import './index.css';var OIe = Object.defineProperty;
var XU = (e) => {
  throw TypeError(e);
};
var RIe = (e, t, r) => t in e ? OIe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Do = (e, t, r) => RIe(e, typeof t != "symbol" ? t + "" : t, r), JU = (e, t, r) => t.has(e) || XU("Cannot " + r);
var Sl = (e, t, r) => (JU(e, t, "read from private field"), r ? r.call(e) : t.get(e)), I0 = (e, t, r) => t.has(e) ? XU("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), bl = (e, t, r, n) => (JU(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
import { jsx as Jt, jsxs as va, Fragment as wIe } from "react/jsx-runtime";
import G, { createContext as ei, memo as Nr, isValidElement as cS, useContext as En, useMemo as tt, useCallback as mt, Fragment as jo, useLayoutEffect as Np, useEffect as nr, useDebugValue as PIe, useReducer as Jse, useRef as Ut, Component as DIe, useState as cn, createElement as xIe, Children as B1, forwardRef as n0 } from "react";
import NIe, { unstable_batchedUpdates as LIe, createPortal as BIe } from "react-dom";
function kIe(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(n, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var fe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function lh(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var ZU = typeof window < "u" ? window : self, MIe = ZU.crypto || ZU.msCrypto, FIe = function(e) {
  if (!e) return Math.random;
  var t = Math.pow(2, 32), r = new Uint32Array(1);
  return function() {
    return e.getRandomValues(r)[0] / t;
  };
}(MIe);
const Mu = /* @__PURE__ */ Mt(FIe);
function ko(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var HIe = typeof Symbol == "function" && Symbol.observable || "@@observable", QU = HIe, rI = () => Math.random().toString(36).substring(7).split("").join("."), $Ie = {
  INIT: `@@redux/INIT${/* @__PURE__ */ rI()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ rI()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${rI()}`
}, Sf = $Ie;
function Zse(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function UIe(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (zIe(e))
    return "date";
  if (jIe(e))
    return "error";
  const r = VIe(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function VIe(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function jIe(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function zIe(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Bl(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = UIe(e)), t;
}
function Qse(e, t, r) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ko(2) : `Expected the root reducer to be a function. Instead, received: '${Bl(e)}'`);
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? ko(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ko(1) : `Expected the enhancer to be a function. Instead, received: '${Bl(r)}'`);
    return r(Qse)(e, t);
  }
  let n = e, i = t, o = /* @__PURE__ */ new Map(), a = o, u = 0, s = !1;
  function c() {
    a === o && (a = /* @__PURE__ */ new Map(), o.forEach((E, m) => {
      a.set(m, E);
    }));
  }
  function l() {
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? ko(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function f(E) {
    if (typeof E != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ko(4) : `Expected the listener to be a function. Instead, received: '${Bl(E)}'`);
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? ko(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let m = !0;
    c();
    const g = u++;
    return a.set(g, E), function() {
      if (m) {
        if (s)
          throw new Error(process.env.NODE_ENV === "production" ? ko(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, c(), a.delete(g), o = null;
      }
    };
  }
  function d(E) {
    if (!Zse(E))
      throw new Error(process.env.NODE_ENV === "production" ? ko(7) : `Actions must be plain objects. Instead, the actual type was: '${Bl(E)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof E.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ko(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof E.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? ko(17) : `Action "type" property must be a string. Instead, the actual type was: '${Bl(E.type)}'. Value was: '${E.type}' (stringified)`);
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? ko(9) : "Reducers may not dispatch actions.");
    try {
      s = !0, i = n(i, E);
    } finally {
      s = !1;
    }
    return (o = a).forEach((g) => {
      g();
    }), E;
  }
  function p(E) {
    if (typeof E != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ko(10) : `Expected the nextReducer to be a function. Instead, received: '${Bl(E)}`);
    n = E, d({
      type: Sf.REPLACE
    });
  }
  function v() {
    const E = f;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(m) {
        if (typeof m != "object" || m === null)
          throw new Error(process.env.NODE_ENV === "production" ? ko(11) : `Expected the observer to be an object. Instead, received: '${Bl(m)}'`);
        function g() {
          const _ = m;
          _.next && _.next(l());
        }
        return g(), {
          unsubscribe: E(g)
        };
      },
      [QU]() {
        return this;
      }
    };
  }
  return d({
    type: Sf.INIT
  }), {
    dispatch: d,
    subscribe: f,
    getState: l,
    replaceReducer: p,
    [QU]: v
  };
}
function eV(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function qIe(e, t, r, n) {
  const i = Object.keys(t), o = r && r.type === Sf.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Zse(e))
    return `The ${o} has unexpected type of "${Bl(e)}". Expected argument to be an object with the following keys: "${i.join('", "')}"`;
  const a = Object.keys(e).filter((u) => !t.hasOwnProperty(u) && !n[u]);
  if (a.forEach((u) => {
    n[u] = !0;
  }), !(r && r.type === Sf.REPLACE) && a.length > 0)
    return `Unexpected ${a.length > 1 ? "keys" : "key"} "${a.join('", "')}" found in ${o}. Expected to find one of the known reducer keys instead: "${i.join('", "')}". Unexpected keys will be ignored.`;
}
function YIe(e) {
  Object.keys(e).forEach((t) => {
    const r = e[t];
    if (typeof r(void 0, {
      type: Sf.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ko(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: Sf.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ko(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${Sf.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function GIe(e) {
  const t = Object.keys(e), r = {};
  for (let a = 0; a < t.length; a++) {
    const u = t[a];
    process.env.NODE_ENV !== "production" && typeof e[u] > "u" && eV(`No reducer provided for key "${u}"`), typeof e[u] == "function" && (r[u] = e[u]);
  }
  const n = Object.keys(r);
  let i;
  process.env.NODE_ENV !== "production" && (i = {});
  let o;
  try {
    YIe(r);
  } catch (a) {
    o = a;
  }
  return function(u = {}, s) {
    if (o)
      throw o;
    if (process.env.NODE_ENV !== "production") {
      const f = qIe(u, r, s, i);
      f && eV(f);
    }
    let c = !1;
    const l = {};
    for (let f = 0; f < n.length; f++) {
      const d = n[f], p = r[d], v = u[d], h = p(v, s);
      if (typeof h > "u") {
        const E = s && s.type;
        throw new Error(process.env.NODE_ENV === "production" ? ko(14) : `When called with an action of type ${E ? `"${String(E)}"` : "(unknown type)"}, the slice reducer for key "${d}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      l[d] = h, c = c || h !== v;
    }
    return c = c || n.length !== Object.keys(u).length, c ? l : u;
  };
}
function WIe(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, r) => (...n) => t(r(...n)));
}
function KIe(...e) {
  return (t) => (r, n) => {
    const i = t(r, n);
    let o = () => {
      throw new Error(process.env.NODE_ENV === "production" ? ko(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const a = {
      getState: i.getState,
      dispatch: (s, ...c) => o(s, ...c)
    }, u = e.map((s) => s(a));
    return o = WIe(...u)(i.dispatch), {
      ...i,
      dispatch: o
    };
  };
}
function XIe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function tV(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rV(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tV(Object(r), !0).forEach(function(n) {
      XIe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tV(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Mo(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var nV = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), nI = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Yl = {
  INIT: "@@redux/INIT" + nI(),
  REPLACE: "@@redux/REPLACE" + nI(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + nI();
  }
};
function ece(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function JIe(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (eOe(e)) return "date";
  if (QIe(e)) return "error";
  var r = ZIe(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ZIe(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function QIe(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function eOe(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ml(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = JIe(e)), t;
}
function N8(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Mo(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(1) : "Expected the enhancer to be a function. Instead, received: '" + Ml(r) + "'");
    return r(N8)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Mo(2) : "Expected the root reducer to be a function. Instead, received: '" + Ml(e) + "'");
  var i = e, o = t, a = [], u = a, s = !1;
  function c() {
    u === a && (u = a.slice());
  }
  function l() {
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Mo(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function f(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(4) : "Expected the listener to be a function. Instead, received: '" + Ml(h) + "'");
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Mo(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var E = !0;
    return c(), u.push(h), function() {
      if (E) {
        if (s)
          throw new Error(process.env.NODE_ENV === "production" ? Mo(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        E = !1, c();
        var g = u.indexOf(h);
        u.splice(g, 1), a = null;
      }
    };
  }
  function d(h) {
    if (!ece(h))
      throw new Error(process.env.NODE_ENV === "production" ? Mo(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ml(h) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof h.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Mo(9) : "Reducers may not dispatch actions.");
    try {
      s = !0, o = i(o, h);
    } finally {
      s = !1;
    }
    for (var E = a = u, m = 0; m < E.length; m++) {
      var g = E[m];
      g();
    }
    return h;
  }
  function p(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ml(h));
    i = h, d({
      type: Yl.REPLACE
    });
  }
  function v() {
    var h, E = f;
    return h = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(g) {
        if (typeof g != "object" || g === null)
          throw new Error(process.env.NODE_ENV === "production" ? Mo(11) : "Expected the observer to be an object. Instead, received: '" + Ml(g) + "'");
        function y() {
          g.next && g.next(l());
        }
        y();
        var _ = E(y);
        return {
          unsubscribe: _
        };
      }
    }, h[nV] = function() {
      return this;
    }, h;
  }
  return d({
    type: Yl.INIT
  }), n = {
    dispatch: d,
    subscribe: f,
    getState: l,
    replaceReducer: p
  }, n[nV] = v, n;
}
var tOe = N8;
function iV(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function rOe(e, t, r, n) {
  var i = Object.keys(t), o = r && r.type === Yl.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!ece(e))
    return "The " + o + ' has unexpected type of "' + Ml(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var a = Object.keys(e).filter(function(u) {
    return !t.hasOwnProperty(u) && !n[u];
  });
  if (a.forEach(function(u) {
    n[u] = !0;
  }), !(r && r.type === Yl.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + o + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function nOe(e) {
  Object.keys(e).forEach(function(t) {
    var r = e[t], n = r(void 0, {
      type: Yl.INIT
    });
    if (typeof n > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: Yl.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Mo(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + Yl.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function iOe(e) {
  for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
    var i = t[n];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && iV('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (r[i] = e[i]);
  }
  var o = Object.keys(r), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var u;
  try {
    nOe(r);
  } catch (s) {
    u = s;
  }
  return function(c, l) {
    if (c === void 0 && (c = {}), u)
      throw u;
    if (process.env.NODE_ENV !== "production") {
      var f = rOe(c, r, l, a);
      f && iV(f);
    }
    for (var d = !1, p = {}, v = 0; v < o.length; v++) {
      var h = o[v], E = r[h], m = c[h], g = E(m, l);
      if (typeof g > "u") {
        var y = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? Mo(14) : "When called with an action of type " + (y ? '"' + String(y) + '"' : "(unknown type)") + ', the slice reducer for key "' + h + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      p[h] = g, d = d || g !== m;
    }
    return d = d || o.length !== Object.keys(c).length, d ? p : c;
  };
}
function oV(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function oOe(e, t) {
  if (typeof e == "function")
    return oV(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? Mo(16) : "bindActionCreators expected an object or a function, but instead received: '" + Ml(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var i = e[n];
    typeof i == "function" && (r[n] = oV(i, t));
  }
  return r;
}
function tce() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
function aOe() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var i = n.apply(void 0, arguments), o = function() {
        throw new Error(process.env.NODE_ENV === "production" ? Mo(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, u = t.map(function(s) {
        return s(a);
      });
      return o = tce.apply(void 0, u)(i.dispatch), rV(rV({}, i), {}, {
        dispatch: o
      });
    };
  };
}
const uOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: Yl,
  applyMiddleware: aOe,
  bindActionCreators: oOe,
  combineReducers: iOe,
  compose: tce,
  createStore: N8,
  legacy_createStore: tOe
}, Symbol.toStringTag, { value: "Module" })), sOe = /* @__PURE__ */ lh(uOe);
var aV = sOe.compose, cOe = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? aV : aV.apply(null, arguments);
}, _s = function(t) {
  return "@@redux-saga/" + t;
}, rce = /* @__PURE__ */ _s("CANCEL_PROMISE"), nce = /* @__PURE__ */ _s("CHANNEL_END"), L8 = /* @__PURE__ */ _s("IO"), uV = /* @__PURE__ */ _s("MATCH"), ice = /* @__PURE__ */ _s("MULTICAST"), oce = /* @__PURE__ */ _s("SAGA_ACTION"), q5 = /* @__PURE__ */ _s("SELF_CANCELLATION"), ace = /* @__PURE__ */ _s("TASK"), Tp = /* @__PURE__ */ _s("TASK_CANCEL"), uce = /* @__PURE__ */ _s("TERMINATE"), lOe = /* @__PURE__ */ _s("LOCATION");
function lS() {
  return lS = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lS.apply(this, arguments);
}
function fOe(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var sce = function(t) {
  return t == null;
}, Xi = function(t) {
  return t != null;
}, Bn = function(t) {
  return typeof t == "function";
}, Pb = function(t) {
  return typeof t == "string";
}, Fu = Array.isArray, B8 = function(t) {
  return t && !Fu(t) && typeof t == "object";
}, Db = function(t) {
  return t && Bn(t.then);
}, xb = function(t) {
  return t && Bn(t.next) && Bn(t.throw);
}, sV = function(t) {
  return t && t[ace];
}, dOe = function(t) {
  return t && Bn(t.isEmpty) && Bn(t.take) && Bn(t.put);
}, cV = function e(t) {
  return t && (Pb(t) || lce(t) || Bn(t) || Fu(t) && t.every(e));
}, IT = function(t) {
  return t && Bn(t.take) && Bn(t.close);
}, cce = function(t) {
  return Bn(t) && t.hasOwnProperty("toString");
}, lce = function(t) {
  return !!t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype;
}, pOe = function(t) {
  return IT(t) && t[ice];
}, hOe = function(t) {
  return t && t[L8];
}, iI = 2147483647;
function vOe(e, t) {
  if (t === void 0 && (t = !0), process.env.NODE_ENV !== "production" && e > iI)
    throw new Error("delay only supports a maximum value of " + iI + "ms");
  var r, n = new Promise(function(i) {
    r = setTimeout(i, Math.min(iI, e), t);
  });
  return n[rce] = function() {
    clearTimeout(r);
  }, n;
}
var EOe = function(t) {
  return function() {
    return t;
  };
}, mOe = /* @__PURE__ */ EOe(!0), Ho = function() {
};
process.env.NODE_ENV !== "production" && typeof Proxy < "u" && (Ho = /* @__PURE__ */ new Proxy(Ho, {
  set: function() {
    throw fS("There was an attempt to assign a property to internal `noop` function.");
  }
}));
var fce = function(t) {
  return t;
}, gOe = typeof Symbol == "function", TOe = gOe && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function en(e, t, r) {
  if (!t(e))
    throw new Error(r);
}
var k8 = function(t, r) {
  lS(t, r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(r).forEach(function(n) {
    t[n] = r[n];
  });
}, yOe = function(t, r) {
  var n;
  return (n = []).concat.apply(n, r.map(t));
};
function Nb(e, t) {
  var r = e.indexOf(t);
  r >= 0 && e.splice(r, 1);
}
function _Oe(e) {
  var t = !1;
  return function() {
    t || (t = !0, e());
  };
}
var AOe = function(t) {
  throw t;
}, SOe = function(t) {
  return {
    value: t,
    done: !0
  };
};
function Y5(e, t, r) {
  t === void 0 && (t = AOe), r === void 0 && (r = "iterator");
  var n = {
    meta: {
      name: r
    },
    next: e,
    throw: t,
    return: SOe,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (n[Symbol.iterator] = function() {
    return n;
  }), n;
}
function bOe(e, t) {
  var r = t.sagaStack;
  console.error(e), console.error(r);
}
var fS = function(t) {
  return new Error(`
  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug
  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.
  Error: ` + t + `
`);
}, dce = function(t, r) {
  return (t ? t + "." : "") + "setContext(props): argument " + r + " is not a plain object";
}, COe = `You can't put (a.k.a. dispatch from saga) frozen actions.
We have to define a special non-enumerable property on those actions for scheduling purposes.
Otherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).
If you are using redux and you care about this behaviour (frozen actions),
then you might want to switch to freezing actions in a middleware rather than in action creator.
Example implementation:

const freezeActions = store => next => action => next(Object.freeze(action))
`, pce = function(t) {
  return Array.apply(null, new Array(t));
}, IOe = function(t) {
  return function(r) {
    return process.env.NODE_ENV !== "production" && en(r, function(n) {
      return !Object.isFrozen(n);
    }, COe), t(Object.defineProperty(r, oce, {
      value: !0
    }));
  };
}, hce = function(t) {
  return t === uce;
}, vce = function(t) {
  return t === Tp;
}, Ece = function(t) {
  return hce(t) || vce(t);
};
function mce(e, t) {
  var r = Object.keys(e), n = r.length;
  process.env.NODE_ENV !== "production" && en(n, function(c) {
    return c > 0;
  }, "createAllStyleChildCallbacks: get an empty array or object");
  var i = 0, o, a = Fu(e) ? pce(n) : {}, u = {};
  function s() {
    i === n && (o = !0, t(a));
  }
  return r.forEach(function(c) {
    var l = function(d, p) {
      o || (p || Ece(d) ? (t.cancel(), t(d, p)) : (a[c] = d, i++, s()));
    };
    l.cancel = Ho, u[c] = l;
  }), t.cancel = function() {
    o || (o = !0, r.forEach(function(c) {
      return u[c].cancel();
    }));
  }, u;
}
function M8(e) {
  return {
    name: e.name || "anonymous",
    location: gce(e)
  };
}
function gce(e) {
  return e[lOe];
}
function OOe() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
var ROe = "Channel's Buffer overflow!", wOe = 1, POe = 3, Tce = 4;
function DOe(e, t) {
  e === void 0 && (e = 10);
  var r = new Array(e), n = 0, i = 0, o = 0, a = function(l) {
    r[i] = l, i = (i + 1) % e, n++;
  }, u = function() {
    if (n != 0) {
      var l = r[o];
      return r[o] = null, n--, o = (o + 1) % e, l;
    }
  }, s = function() {
    for (var l = []; n; )
      l.push(u());
    return l;
  };
  return {
    isEmpty: function() {
      return n == 0;
    },
    put: function(l) {
      if (n < e)
        a(l);
      else {
        var f;
        switch (t) {
          case wOe:
            throw new Error(ROe);
          case POe:
            r[i] = l, i = (i + 1) % e, o = i;
            break;
          case Tce:
            f = 2 * e, r = s(), n = r.length, i = r.length, o = 0, r.length = f, e = f, a(l);
            break;
        }
      }
    },
    take: u,
    flush: s
  };
}
var xOe = function(t) {
  return DOe(t, Tce);
}, T4 = "TAKE", yce = "PUT", _ce = "ALL", Ace = "RACE", Sce = "CALL", NOe = "CPS", bce = "FORK", LOe = "JOIN", Cce = "CANCEL", Ice = "SELECT", BOe = "ACTION_CHANNEL", Oce = "CANCELLED", kOe = "FLUSH", MOe = "GET_CONTEXT", FOe = "SET_CONTEXT", lV = `
(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)`, vs = function(t, r) {
  var n;
  return n = {}, n[L8] = !0, n.combinator = !1, n.type = t, n.payload = r, n;
};
function Uo(e, t) {
  if (e === void 0 && (e = "*"), process.env.NODE_ENV !== "production" && arguments.length && en(arguments[0], Xi, "take(patternOrChannel): patternOrChannel is undefined"), cV(e))
    return Xi(t) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), vs(T4, {
      pattern: e
    });
  if (pOe(e) && Xi(t) && cV(t))
    return vs(T4, {
      channel: e,
      pattern: t
    });
  if (IT(e))
    return Xi(t) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), vs(T4, {
      channel: e
    });
  if (process.env.NODE_ENV !== "production")
    throw new Error("take(patternOrChannel): argument " + e + " is not valid channel or a valid pattern");
}
function an(e, t) {
  return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? (en(e, Xi, "put(channel, action): argument channel is undefined"), en(e, IT, "put(channel, action): argument " + e + " is not a valid channel"), en(t, Xi, "put(channel, action): argument action is undefined")) : en(e, Xi, "put(action): argument action is undefined")), sce(t) && (t = e, e = void 0), vs(yce, {
    channel: e,
    action: t
  });
}
function HOe(e) {
  var t = vs(_ce, e);
  return t.combinator = !0, t;
}
function OT(e) {
  var t = vs(Ace, e);
  return t.combinator = !0, t;
}
var Rce = function(t, r) {
  if (en(r, Xi, t + ": argument fn is undefined or null"), !Bn(r)) {
    var n = null, i;
    if (Fu(r))
      n = r[0], i = r[1], en(i, Xi, t + ": argument of type [context, fn] has undefined or null `fn`");
    else if (B8(r))
      n = r.context, i = r.fn, en(i, Xi, t + ": argument of type {context, fn} has undefined or null `fn`");
    else {
      en(r, Bn, t + ": argument fn is not function");
      return;
    }
    if (n && Pb(i)) {
      en(n[i], Bn, t + ': context arguments has no such method - "' + i + '"');
      return;
    }
    en(i, Bn, t + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};
function wce(e, t) {
  var r = null, n;
  return Bn(e) ? n = e : (Fu(e) ? (r = e[0], n = e[1]) : (r = e.context, n = e.fn), r && Pb(n) && Bn(r[n]) && (n = r[n])), {
    context: r,
    fn: n,
    args: t
  };
}
var $Oe = function(t) {
  return t !== UOe;
};
function So(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof r[0] == "number" ? r[0] : "ms";
    en(e, $Oe, "instead of writing `yield call(delay, " + i + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + i + ")`"), Rce("call", e);
  }
  return vs(Sce, wce(e, r));
}
function Rn(e) {
  process.env.NODE_ENV !== "production" && (Rce("fork", e), en(e, function(i) {
    return !hOe(i);
  }, "fork: argument must not be an effect"));
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return vs(bce, wce(e, r));
}
function Lb(e) {
  if (e === void 0 && (e = q5), process.env.NODE_ENV !== "production") {
    if (arguments.length > 1)
      throw new Error("cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.");
    Fu(e) ? e.forEach(function(t) {
      en(t, sV, "cancel([...tasks]): argument " + t + " is not a valid Task object " + lV);
    }) : e !== q5 && Xi(e) && en(e, sV, "cancel(task): argument " + e + " is not a valid Task object " + lV);
  }
  return vs(Cce, e);
}
function Bu(e) {
  e === void 0 && (e = fce);
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return process.env.NODE_ENV !== "production" && arguments.length && (en(arguments[0], Xi, "select(selector, [...]): argument selector is undefined"), en(e, Bn, "select(selector, [...]): argument " + e + " is not a function")), vs(Ice, {
    selector: e,
    args: r
  });
}
function F8() {
  return vs(Oce, {});
}
var UOe = /* @__PURE__ */ So.bind(null, vOe);
function VOe() {
  var e = {};
  return e.promise = new Promise(function(t, r) {
    e.resolve = t, e.reject = r;
  }), e;
}
var Pce = [], Bb = 0;
function jOe(e) {
  try {
    H8(), e();
  } finally {
    Nce();
  }
}
function Dce(e) {
  Pce.push(e), Bb || (H8(), Lce());
}
function xce(e) {
  try {
    return H8(), e();
  } finally {
    Lce();
  }
}
function H8() {
  Bb++;
}
function Nce() {
  Bb--;
}
function Lce() {
  Nce();
  for (var e; !Bb && (e = Pce.shift()) !== void 0; )
    jOe(e);
}
var zOe = function(t) {
  return function(r) {
    return t.some(function(n) {
      return $8(n)(r);
    });
  };
}, qOe = function(t) {
  return function(r) {
    return t(r);
  };
}, fV = function(t) {
  return function(r) {
    return r.type === String(t);
  };
}, YOe = function(t) {
  return function(r) {
    return r.type === t;
  };
}, Bce = function() {
  return mOe;
};
function $8(e) {
  var t = e === "*" ? Bce : Pb(e) ? fV : Fu(e) ? zOe : cce(e) ? fV : Bn(e) ? qOe : lce(e) ? YOe : null;
  if (t === null)
    throw new Error("invalid pattern: " + e);
  return t(e);
}
var v1 = {
  type: nce
}, U8 = function(t) {
  return t && t.type === nce;
}, kce = "Cannot have a closed channel with pending takers", GOe = "invalid buffer passed to channel factory function", Mce = `Saga or channel was provided with an undefined action
Hints:
  - check that your Action Creator returns a non-undefined value
  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners`;
function WOe(e) {
  e === void 0 && (e = xOe());
  var t = !1, r = [];
  process.env.NODE_ENV !== "production" && en(e, dOe, GOe);
  function n() {
    if (t && r.length)
      throw fS(kce);
    if (r.length && !e.isEmpty())
      throw fS("Cannot have pending takers with non empty buffer");
  }
  function i(s) {
    if (process.env.NODE_ENV !== "production" && (n(), en(s, Xi, Mce)), !t) {
      if (r.length === 0)
        return e.put(s);
      var c = r.shift();
      c(s);
    }
  }
  function o(s) {
    process.env.NODE_ENV !== "production" && (n(), en(s, Bn, "channel.take's callback must be a function")), t && e.isEmpty() ? s(v1) : e.isEmpty() ? (r.push(s), s.cancel = function() {
      Nb(r, s);
    }) : s(e.take());
  }
  function a(s) {
    if (process.env.NODE_ENV !== "production" && (n(), en(s, Bn, "channel.flush' callback must be a function")), t && e.isEmpty()) {
      s(v1);
      return;
    }
    s(e.flush());
  }
  function u() {
    if (process.env.NODE_ENV !== "production" && n(), !t) {
      t = !0;
      var s = r;
      r = [];
      for (var c = 0, l = s.length; c < l; c++) {
        var f = s[c];
        f(v1);
      }
    }
  }
  return {
    take: o,
    put: i,
    flush: a,
    close: u
  };
}
function KOe() {
  var e, t = !1, r = [], n = r;
  function i() {
    if (t && n.length)
      throw fS(kce);
  }
  var o = function() {
    n === r && (n = r.slice());
  }, a = function() {
    process.env.NODE_ENV !== "production" && i(), t = !0;
    var s = r = n;
    n = [], s.forEach(function(c) {
      c(v1);
    });
  };
  return e = {}, e[ice] = !0, e.put = function(s) {
    if (process.env.NODE_ENV !== "production" && (i(), en(s, Xi, Mce)), !t) {
      if (U8(s)) {
        a();
        return;
      }
      for (var c = r = n, l = 0, f = c.length; l < f; l++) {
        var d = c[l];
        d[uV](s) && (d.cancel(), d(s));
      }
    }
  }, e.take = function(s, c) {
    if (c === void 0 && (c = Bce), process.env.NODE_ENV !== "production" && i(), t) {
      s(v1);
      return;
    }
    s[uV] = c, o(), n.push(s), s.cancel = _Oe(function() {
      o(), Nb(n, s);
    });
  }, e.close = a, e;
}
function Fce() {
  var e = KOe(), t = e.put;
  return e.put = function(r) {
    if (r[oce]) {
      t(r);
      return;
    }
    Dce(function() {
      t(r);
    });
  }, e;
}
var sf = 0, Hc = 1, y4 = 2, Hce = 3;
function V8(e, t) {
  var r = e[rce];
  Bn(r) && (t.cancel = r), e.then(t, function(n) {
    t(n, !0);
  });
}
var RT = 0, $ce = function() {
  return ++RT;
}, xo;
function XOe(e, t) {
  return e.isSagaIterator ? {
    name: e.meta.name
  } : M8(t);
}
function JOe(e) {
  var t = e.context, r = e.fn, n = e.args;
  try {
    var i = r.apply(t, n);
    if (xb(i))
      return i;
    var o = !1, a = function(s) {
      return o ? {
        value: s,
        done: !0
      } : (o = !0, {
        value: i,
        done: !Db(i)
      });
    };
    return Y5(a);
  } catch (u) {
    return Y5(function() {
      throw u;
    });
  }
}
function ZOe(e, t, r) {
  var n = t.channel, i = t.action, o = t.resolve;
  Dce(function() {
    var a;
    try {
      a = (n ? n.put : e.dispatch)(i);
    } catch (u) {
      r(u, !0);
      return;
    }
    o && Db(a) ? V8(a, r) : r(a);
  });
}
function QOe(e, t, r) {
  var n = t.channel, i = n === void 0 ? e.channel : n, o = t.pattern, a = t.maybe, u = function(c) {
    if (c instanceof Error) {
      r(c, !0);
      return;
    }
    if (U8(c) && !a) {
      r(uce);
      return;
    }
    r(c);
  };
  try {
    i.take(u, Xi(o) ? $8(o) : null);
  } catch (s) {
    r(s, !0);
    return;
  }
  r.cancel = u.cancel;
}
function eRe(e, t, r, n) {
  var i = t.context, o = t.fn, a = t.args, u = n.task;
  try {
    var s = o.apply(i, a);
    if (Db(s)) {
      V8(s, r);
      return;
    }
    if (xb(s)) {
      kb(
        e,
        s,
        u.context,
        RT,
        M8(o),
        /* isRoot */
        !1,
        r
      );
      return;
    }
    r(s);
  } catch (c) {
    r(c, !0);
  }
}
function tRe(e, t, r) {
  var n = t.context, i = t.fn, o = t.args;
  try {
    var a = function(s, c) {
      sce(s) ? r(c) : r(s, !0);
    };
    i.apply(n, o.concat(a)), a.cancel && (r.cancel = a.cancel);
  } catch (u) {
    r(u, !0);
  }
}
function rRe(e, t, r, n) {
  var i = t.context, o = t.fn, a = t.args, u = t.detached, s = n.task, c = JOe({
    context: i,
    fn: o,
    args: a
  }), l = XOe(c, o);
  xce(function() {
    var f = kb(e, c, s.context, RT, l, u, void 0);
    u ? r(f) : f.isRunning() ? (s.queue.addTask(f), r(f)) : f.isAborted() ? s.queue.abort(f.error()) : r(f);
  });
}
function nRe(e, t, r, n) {
  var i = n.task, o = function(s, c) {
    if (s.isRunning()) {
      var l = {
        task: i,
        cb: c
      };
      c.cancel = function() {
        s.isRunning() && Nb(s.joiners, l);
      }, s.joiners.push(l);
    } else
      s.isAborted() ? c(s.error(), !0) : c(s.result());
  };
  if (Fu(t)) {
    if (t.length === 0) {
      r([]);
      return;
    }
    var a = mce(t, r);
    t.forEach(function(u, s) {
      o(u, a[s]);
    });
  } else
    o(t, r);
}
function oI(e) {
  e.isRunning() && e.cancel();
}
function iRe(e, t, r, n) {
  var i = n.task;
  t === q5 ? oI(i) : Fu(t) ? t.forEach(oI) : oI(t), r();
}
function oRe(e, t, r, n) {
  var i = n.digestEffect, o = RT, a = Object.keys(t);
  if (a.length === 0) {
    r(Fu(t) ? [] : {});
    return;
  }
  var u = mce(t, r);
  a.forEach(function(s) {
    i(t[s], o, u[s], s);
  });
}
function aRe(e, t, r, n) {
  var i = n.digestEffect, o = RT, a = Object.keys(t), u = Fu(t) ? pce(a.length) : {}, s = {}, c = !1;
  a.forEach(function(l) {
    var f = function(p, v) {
      c || (v || Ece(p) ? (r.cancel(), r(p, v)) : (r.cancel(), c = !0, u[l] = p, r(u)));
    };
    f.cancel = Ho, s[l] = f;
  }), r.cancel = function() {
    c || (c = !0, a.forEach(function(l) {
      return s[l].cancel();
    }));
  }, a.forEach(function(l) {
    c || i(t[l], o, s[l], l);
  });
}
function uRe(e, t, r) {
  var n = t.selector, i = t.args;
  try {
    var o = n.apply(void 0, [e.getState()].concat(i));
    r(o);
  } catch (a) {
    r(a, !0);
  }
}
function sRe(e, t, r) {
  var n = t.pattern, i = t.buffer, o = WOe(i), a = $8(n), u = function c(l) {
    U8(l) || e.channel.take(c, a), o.put(l);
  }, s = o.close;
  o.close = function() {
    u.cancel(), s();
  }, e.channel.take(u, a), r(o);
}
function cRe(e, t, r, n) {
  var i = n.task;
  r(i.isCancelled());
}
function lRe(e, t, r) {
  t.flush(r);
}
function fRe(e, t, r, n) {
  var i = n.task;
  r(i.context[t]);
}
function dRe(e, t, r, n) {
  var i = n.task;
  k8(i.context, t), r();
}
var pRe = (xo = {}, xo[T4] = QOe, xo[yce] = ZOe, xo[_ce] = oRe, xo[Ace] = aRe, xo[Sce] = eRe, xo[NOe] = tRe, xo[bce] = rRe, xo[LOe] = nRe, xo[Cce] = iRe, xo[Ice] = uRe, xo[BOe] = sRe, xo[Oce] = cRe, xo[kOe] = lRe, xo[MOe] = fRe, xo[FOe] = dRe, xo);
function hRe(e, t, r) {
  var n = [], i, o = !1;
  s(e);
  var a = function() {
    return n;
  };
  function u(l) {
    t(), c(), r(l, !0);
  }
  function s(l) {
    n.push(l), l.cont = function(f, d) {
      o || (Nb(n, l), l.cont = Ho, d ? u(f) : (l === e && (i = f), n.length || (o = !0, r(i))));
    };
  }
  function c() {
    o || (o = !0, n.forEach(function(l) {
      l.cont = Ho, l.cancel();
    }), n = []);
  }
  return {
    addTask: s,
    cancelAll: c,
    abort: u,
    getTasks: a
  };
}
function Uce(e, t) {
  return e + "?" + t;
}
function vRe(e) {
  var t = gce(e);
  if (t) {
    var r = t.code, n = t.fileName, i = t.lineNumber, o = r + "  " + Uce(n, i);
    return o;
  }
  return "";
}
function dV(e) {
  var t = e.name, r = e.location;
  return r ? t + "  " + Uce(r.fileName, r.lineNumber) : t;
}
function ERe(e) {
  var t = yOe(function(r) {
    return r.cancelledTasks;
  }, e);
  return t.length ? ["Tasks cancelled due to error:"].concat(t).join(`
`) : "";
}
var j8 = null, E1 = [], mRe = function(t) {
  t.crashedEffect = j8, E1.push(t);
}, Vce = function() {
  j8 = null, E1.length = 0;
}, gRe = function(t) {
  j8 = t;
}, TRe = function() {
  var t = E1[0], r = E1.slice(1), n = t.crashedEffect ? vRe(t.crashedEffect) : null, i = "The above error occurred in task " + dV(t.meta) + (n ? ` 
 when executing effect ` + n : "");
  return [i].concat(r.map(function(o) {
    return "    created by " + dV(o.meta);
  }), [ERe(E1)]).join(`
`);
};
function yRe(e, t, r, n, i, o, a) {
  var u;
  a === void 0 && (a = Ho);
  var s = sf, c, l, f = null, d = [], p = Object.create(r), v = hRe(t, function() {
    d.push.apply(d, v.getTasks().map(function(S) {
      return S.meta.name;
    }));
  }, E);
  function h() {
    s === sf && (s = Hc, v.cancelAll(), E(Tp, !1));
  }
  function E(_, S) {
    if (!S)
      _ === Tp ? s = Hc : s !== Hc && (s = Hce), c = _, f && f.resolve(_);
    else {
      if (s = y4, mRe({
        meta: i,
        cancelledTasks: d
      }), y.isRoot) {
        var A = TRe();
        Vce(), e.onError(_, {
          sagaStack: A
        });
      }
      l = _, f && f.reject(_);
    }
    y.cont(_, S), y.joiners.forEach(function(O) {
      O.cb(_, S);
    }), y.joiners = null;
  }
  function m(_) {
    process.env.NODE_ENV !== "production" && en(_, B8, dce("task", _)), k8(p, _);
  }
  function g() {
    return f || (f = VOe(), s === y4 ? f.reject(l) : s !== sf && f.resolve(c)), f.promise;
  }
  var y = (u = {}, u[ace] = !0, u.id = n, u.meta = i, u.isRoot = o, u.context = p, u.joiners = [], u.queue = v, u.cancel = h, u.cont = a, u.end = E, u.setContext = m, u.toPromise = g, u.isRunning = function() {
    return s === sf;
  }, u.isCancelled = function() {
    return s === Hc || s === sf && t.status === Hc;
  }, u.isAborted = function() {
    return s === y4;
  }, u.result = function() {
    return c;
  }, u.error = function() {
    return l;
  }, u);
  return y;
}
function kb(e, t, r, n, i, o, a) {
  if (process.env.NODE_ENV !== "production" && t[TOe])
    throw new Error("redux-saga doesn't support async generators, please use only regular ones");
  var u = e.finalizeRunEffect(p);
  d.cancel = Ho;
  var s = {
    meta: i,
    cancel: f,
    status: sf
  }, c = yRe(e, s, r, n, i, o, a), l = {
    task: c,
    digestEffect: v
  };
  function f() {
    s.status === sf && (s.status = Hc, d(Tp));
  }
  return a && (a.cancel = c.cancel), d(), c;
  function d(h, E) {
    try {
      var m;
      E ? (m = t.throw(h), Vce()) : vce(h) ? (s.status = Hc, d.cancel(), m = Bn(t.return) ? t.return(Tp) : {
        done: !0,
        value: Tp
      }) : hce(h) ? m = Bn(t.return) ? t.return() : {
        done: !0
      } : m = t.next(h), m.done ? (s.status !== Hc && (s.status = Hce), s.cont(m.value)) : v(m.value, n, d);
    } catch (g) {
      if (s.status === Hc)
        throw g;
      s.status = y4, s.cont(g, !0);
    }
  }
  function p(h, E, m) {
    if (Db(h))
      V8(h, m);
    else if (xb(h))
      kb(
        e,
        h,
        c.context,
        E,
        i,
        /* isRoot */
        !1,
        m
      );
    else if (h && h[L8]) {
      var g = pRe[h.type];
      g(e, h.payload, m, l);
    } else
      m(h);
  }
  function v(h, E, m, g) {
    g === void 0 && (g = "");
    var y = $ce();
    e.sagaMonitor && e.sagaMonitor.effectTriggered({
      effectId: y,
      parentEffectId: E,
      label: g,
      effect: h
    });
    var _;
    function S(A, O) {
      _ || (_ = !0, m.cancel = Ho, e.sagaMonitor && (O ? e.sagaMonitor.effectRejected(y, A) : e.sagaMonitor.effectResolved(y, A)), O && gRe(h), m(A, O));
    }
    S.cancel = Ho, m.cancel = function() {
      _ || (_ = !0, S.cancel(), S.cancel = Ho, e.sagaMonitor && e.sagaMonitor.effectCancelled(y));
    }, u(h, y, S);
  }
}
var _Re = "runSaga(options, saga, ...args)", pV = _Re + ": saga argument must be a Generator function!";
function ARe(e, t) {
  var r = e.channel, n = r === void 0 ? Fce() : r, i = e.dispatch, o = e.getState, a = e.context, u = a === void 0 ? {} : a, s = e.sagaMonitor, c = e.effectMiddlewares, l = e.onError, f = l === void 0 ? bOe : l;
  process.env.NODE_ENV !== "production" && en(t, Bn, pV);
  for (var d = arguments.length, p = new Array(d > 2 ? d - 2 : 0), v = 2; v < d; v++)
    p[v - 2] = arguments[v];
  var h = t.apply(void 0, p);
  process.env.NODE_ENV !== "production" && en(h, xb, pV);
  var E = $ce();
  if (s && (s.rootSagaStarted = s.rootSagaStarted || Ho, s.effectTriggered = s.effectTriggered || Ho, s.effectResolved = s.effectResolved || Ho, s.effectRejected = s.effectRejected || Ho, s.effectCancelled = s.effectCancelled || Ho, s.actionDispatched = s.actionDispatched || Ho, s.rootSagaStarted({
    effectId: E,
    saga: t,
    args: p
  })), process.env.NODE_ENV !== "production") {
    if (Xi(i) && en(i, Bn, "dispatch must be a function"), Xi(o) && en(o, Bn, "getState must be a function"), Xi(c)) {
      var m = "effectMiddlewares must be an array of functions";
      en(c, Fu, m), c.forEach(function(S) {
        return en(S, Bn, m);
      });
    }
    en(f, Bn, "onError passed to the redux-saga is not a function!");
  }
  var g;
  if (c) {
    var y = OOe.apply(void 0, c);
    g = function(A) {
      return function(O, P, U) {
        var z = function(H) {
          return A(H, P, U);
        };
        return y(z)(O);
      };
    };
  } else
    g = fce;
  var _ = {
    channel: n,
    dispatch: IOe(i),
    getState: o,
    sagaMonitor: s,
    onError: f,
    finalizeRunEffect: g
  };
  return xce(function() {
    var S = kb(
      _,
      h,
      u,
      E,
      M8(t),
      /* isRoot */
      !0,
      void 0
    );
    return s && s.effectResolved(E, S), S;
  });
}
function SRe(e) {
  var t = e === void 0 ? {} : e, r = t.context, n = r === void 0 ? {} : r, i = t.channel, o = i === void 0 ? Fce() : i, a = t.sagaMonitor, u = fOe(t, ["context", "channel", "sagaMonitor"]), s;
  process.env.NODE_ENV !== "production" && en(o, IT, "options.channel passed to the Saga middleware is not a channel");
  function c(l) {
    var f = l.getState, d = l.dispatch;
    return s = ARe.bind(null, lS({}, u, {
      context: n,
      channel: o,
      dispatch: d,
      getState: f,
      sagaMonitor: a
    })), function(p) {
      return function(v) {
        a && a.actionDispatched && a.actionDispatched(v);
        var h = p(v);
        return o.put(v), h;
      };
    };
  }
  return c.run = function() {
    if (process.env.NODE_ENV !== "production" && !s)
      throw new Error("Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware");
    return s.apply(void 0, arguments);
  }, c.setContext = function(l) {
    process.env.NODE_ENV !== "production" && en(l, B8, dce("sagaMiddleware", l)), k8(n, l);
  }, c;
}
var jce = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(fe, function() {
    function r(O) {
      return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(P) {
        return typeof P;
      } : function(P) {
        return P && typeof Symbol == "function" && P.constructor === Symbol && P !== Symbol.prototype ? "symbol" : typeof P;
      })(O);
    }
    function n(O, P, U, z, k, H, B) {
      try {
        var x = O[H](B), D = x.value;
      } catch (w) {
        return void U(w);
      }
      x.done ? P(D) : Promise.resolve(D).then(z, k);
    }
    function i(O) {
      return function() {
        var P = this, U = arguments;
        return new Promise(function(z, k) {
          var H = O.apply(P, U);
          function B(D) {
            n(H, z, k, B, x, "next", D);
          }
          function x(D) {
            n(H, z, k, B, x, "throw", D);
          }
          B(void 0);
        });
      };
    }
    function o(O, P, U) {
      return P in O ? Object.defineProperty(O, P, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : O[P] = U, O;
    }
    function a(O, P) {
      var U, z = Object.keys(O);
      return Object.getOwnPropertySymbols && (U = Object.getOwnPropertySymbols(O), P && (U = U.filter(function(k) {
        return Object.getOwnPropertyDescriptor(O, k).enumerable;
      })), z.push.apply(z, U)), z;
    }
    function u(O) {
      for (var P = 1; P < arguments.length; P++) {
        var U = arguments[P] != null ? arguments[P] : {};
        P % 2 ? a(Object(U), !0).forEach(function(z) {
          o(O, z, U[z]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(O, Object.getOwnPropertyDescriptors(U)) : a(Object(U)).forEach(function(z) {
          Object.defineProperty(O, z, Object.getOwnPropertyDescriptor(U, z));
        });
      }
      return O;
    }
    function s(O) {
      return function(P) {
        if (Array.isArray(P)) return P;
      }(O) || l(O) || f(O) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function c(O) {
      return function(P) {
        if (Array.isArray(P)) return d(P);
      }(O) || l(O) || f(O) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function l(O) {
      if (typeof Symbol < "u" && Symbol.iterator in Object(O)) return Array.from(O);
    }
    function f(O, P) {
      if (O) {
        if (typeof O == "string") return d(O, P);
        var U = Object.prototype.toString.call(O).slice(8, -1);
        return U === "Object" && O.constructor && (U = O.constructor.name), U === "Map" || U === "Set" ? Array.from(O) : U === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(U) ? d(O, P) : void 0;
      }
    }
    function d(O, P) {
      (P == null || P > O.length) && (P = O.length);
      for (var U = 0, z = new Array(P); U < P; U++) z[U] = O[U];
      return z;
    }
    function p(O) {
      if (typeof Symbol > "u" || O[Symbol.iterator] == null) {
        if (Array.isArray(O) || (O = f(O))) {
          var P = 0, U = function() {
          };
          return { s: U, n: function() {
            return P >= O.length ? { done: !0 } : { done: !1, value: O[P++] };
          }, e: function(x) {
            throw x;
          }, f: U };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var z, k, H = !0, B = !1;
      return { s: function() {
        z = O[Symbol.iterator]();
      }, n: function() {
        var x = z.next();
        return H = x.done, x;
      }, e: function(x) {
        B = !0, k = x;
      }, f: function() {
        try {
          H || z.return == null || z.return();
        } finally {
          if (B) throw k;
        }
      } };
    }
    var v = Object.is || function(O, P) {
      return O === P ? O !== 0 || 1 / O == 1 / P : O != O && P != P;
    };
    function h(O, P, U) {
      m(P);
      var z, k = p(function B(x, D) {
        if (D.length) {
          var w = s(D), $ = w[0], X = w.slice(1);
          if (typeof $ == "function") {
            var V = [];
            if (Array.isArray(x)) for (var F = 0, le = x.length; F < le; F++) $.call(x, x[F], F) && V.push.apply(V, c(B(x, [F].concat(c(X)))));
            else for (var ae in x || {}) $.call(x, x[ae], ae) && V.push.apply(V, c(B(x, [ae].concat(c(X)))));
            return V;
          }
          var ne = B(x !== void 0 && x[$], X);
          return ne ? ne.map(function(ve) {
            return [$].concat(c(ve));
          }) : [[$]];
        }
      }(O, P));
      try {
        for (k.s(); !(z = k.n()).done; ) {
          var H = z.value;
          O = A(O, H, U ? U(S(O, H)) : void 0);
        }
      } catch (B) {
        k.e(B);
      } finally {
        k.f();
      }
      return O;
    }
    function E() {
      return (E = i(regeneratorRuntime.mark(function O(P, U, z) {
        var k, H, B, x;
        return regeneratorRuntime.wrap(function(D) {
          for (; ; ) switch (D.prev = D.next) {
            case 0:
              return m(U), D.next = 3, y(P, U);
            case 3:
              k = D.sent, H = p(k), D.prev = 5, H.s();
            case 7:
              if ((B = H.n()).done) {
                D.next = 23;
                break;
              }
              if (x = B.value, D.t0 = A, D.t1 = P, D.t2 = x, z) return D.next = 15, z(S(P, x));
              D.next = 18;
              break;
            case 15:
              D.t3 = D.sent, D.next = 19;
              break;
            case 18:
              D.t3 = void 0;
            case 19:
              D.t4 = D.t3, P = (0, D.t0)(D.t1, D.t2, D.t4);
            case 21:
              D.next = 7;
              break;
            case 23:
              D.next = 28;
              break;
            case 25:
              D.prev = 25, D.t5 = D.catch(5), H.e(D.t5);
            case 28:
              return D.prev = 28, H.f(), D.finish(28);
            case 31:
              return D.abrupt("return", P);
            case 32:
            case "end":
              return D.stop();
          }
        }, O, null, [[5, 25, 28, 31]]);
      }))).apply(this, arguments);
    }
    function m(O) {
      if (!Array.isArray(O)) throw new Error("path must be an array");
    }
    h.updateInAsync = function(O, P, U) {
      return E.apply(this, arguments);
    };
    var g = ["__proto__", "constructor", "prototype"];
    function y() {
      return _.apply(this, arguments);
    }
    function _() {
      return (_ = i(regeneratorRuntime.mark(function O(P, U) {
        var z, k, H, B, x, D, w, $;
        return regeneratorRuntime.wrap(function(X) {
          for (; ; ) switch (X.prev = X.next) {
            case 0:
              if (U.length) {
                X.next = 2;
                break;
              }
              return X.abrupt("return");
            case 2:
              if (z = s(U), k = z[0], H = z.slice(1), typeof k != "function") {
                X.next = 43;
                break;
              }
              if (B = [], !Array.isArray(P)) {
                X.next = 25;
                break;
              }
              x = 0, D = P.length;
            case 7:
              if (x < D) return X.next = 10, k.call(P, P[x], x);
              X.next = 23;
              break;
            case 10:
              if (X.t0 = X.sent, X.t0) return X.t1 = B.push, X.t2 = B, X.t3 = c, X.next = 17, y(P, [x].concat(c(H)));
              X.next = 20;
              break;
            case 17:
              X.t4 = X.sent, X.t5 = (0, X.t3)(X.t4), X.t1.apply.call(X.t1, X.t2, X.t5);
            case 20:
              x++, X.next = 7;
              break;
            case 23:
              X.next = 42;
              break;
            case 25:
              X.t6 = regeneratorRuntime.keys(P || {});
            case 26:
              if ((X.t7 = X.t6()).done) {
                X.next = 42;
                break;
              }
              return w = X.t7.value, X.next = 30, k.call(P, P[w], w);
            case 30:
              if (X.t8 = X.sent, X.t8) return X.t9 = B.push, X.t10 = B, X.t11 = c, X.next = 37, y(P, [w].concat(c(H)));
              X.next = 40;
              break;
            case 37:
              X.t12 = X.sent, X.t13 = (0, X.t11)(X.t12), X.t9.apply.call(X.t9, X.t10, X.t13);
            case 40:
              X.next = 26;
              break;
            case 42:
              return X.abrupt("return", B);
            case 43:
              return X.next = 45, y(P !== void 0 && P[k], H);
            case 45:
              return $ = X.sent, X.abrupt("return", $ ? $.map(function(V) {
                return [k].concat(c(V));
              }) : [[k]]);
            case 47:
            case "end":
              return X.stop();
          }
        }, O);
      }))).apply(this, arguments);
    }
    function S(O, P) {
      return P.reduce(function(U, z) {
        return U && U[z];
      }, O);
    }
    function A(O, P, U) {
      if (!P.length) return U;
      var z, k = s(P), H = k[0], B = k.slice(1), x = O !== void 0 && O[H], D = O;
      if (z = H, g.includes(z)) return O;
      if (typeof H != "string" || r(D) === "object" && !Array.isArray(D) ? typeof H != "number" || Array.isArray(D) || (D = []) : D = {}, typeof H == "number") {
        var w = A(x, B, U);
        return w === void 0 ? O === void 0 ? O : (H in D && (D = c(D)).splice(H, 1), D) : v(w, x) ? O : ((D = c(D))[H] = w, D);
      }
      var $ = A(x, B, U);
      return $ === void 0 ? O === void 0 ? O : (H in D && delete (D = u({}, D))[H], D) : v($, x) ? O : u(u({}, D), {}, o({}, H, $));
    }
    return h;
  });
})(jce);
var bRe = jce.exports;
const Xr = /* @__PURE__ */ Mt(bRe);
var hV = function(t) {
  return {
    done: !0,
    value: t
  };
}, aI = {};
function zce(e) {
  return IT(e) ? "channel" : cce(e) ? String(e) : Bn(e) ? e.name : String(e);
}
function qce(e, t, r) {
  var n, i, o, a = t;
  function u(s, c) {
    if (a === aI)
      return hV(s);
    if (c && !i)
      throw a = aI, c;
    n && n(s);
    var l = c ? e[i](c) : e[a]();
    return a = l.nextState, o = l.effect, n = l.stateUpdater, i = l.errorState, a === aI ? hV(s) : o;
  }
  return Y5(u, function(s) {
    return u(null, s);
  }, r);
}
function CRe(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  var o = {
    done: !1,
    value: Uo(e)
  }, a = function(l) {
    return {
      done: !1,
      value: Rn.apply(void 0, [t].concat(n, [l]))
    };
  }, u, s = function(l) {
    return u = l;
  };
  return qce({
    q1: function() {
      return {
        nextState: "q2",
        effect: o,
        stateUpdater: s
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: a(u)
      };
    }
  }, "q1", "takeEvery(" + zce(e) + ", " + t.name + ")");
}
function IRe(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  var o = {
    done: !1,
    value: Uo(e)
  }, a = function(p) {
    return {
      done: !1,
      value: Rn.apply(void 0, [t].concat(n, [p]))
    };
  }, u = function(p) {
    return {
      done: !1,
      value: Lb(p)
    };
  }, s, c, l = function(p) {
    return s = p;
  }, f = function(p) {
    return c = p;
  };
  return qce({
    q1: function() {
      return {
        nextState: "q2",
        effect: o,
        stateUpdater: f
      };
    },
    q2: function() {
      return s ? {
        nextState: "q3",
        effect: u(s)
      } : {
        nextState: "q1",
        effect: a(c),
        stateUpdater: l
      };
    },
    q3: function() {
      return {
        nextState: "q1",
        effect: a(c),
        stateUpdater: l
      };
    }
  }, "q1", "takeLatest(" + zce(e) + ", " + t.name + ")");
}
var Yce = function(t, r, n) {
  en(r, Xi, t.name + " requires a pattern or channel"), en(n, Xi, t.name + " requires a saga parameter");
};
function oa(e, t) {
  process.env.NODE_ENV !== "production" && Yce(oa, e, t);
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  return Rn.apply(void 0, [CRe, e, t].concat(n));
}
function z8(e, t) {
  process.env.NODE_ENV !== "production" && Yce(z8, e, t);
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  return Rn.apply(void 0, [IRe, e, t].concat(n));
}
var Sv = function(e) {
  return e && e.Math === Math && e;
}, Mn = (
  // eslint-disable-next-line es/no-global-this -- safe
  Sv(typeof globalThis == "object" && globalThis) || Sv(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Sv(typeof self == "object" && self) || Sv(typeof fe == "object" && fe) || Sv(typeof fe == "object" && fe) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), mn = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, ORe = mn, wT = !ORe(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), RRe = wT, Gce = Function.prototype, vV = Gce.apply, EV = Gce.call, qf = typeof Reflect == "object" && Reflect.apply || (RRe ? EV.bind(vV) : function() {
  return EV.apply(vV, arguments);
}), Wce = wT, Kce = Function.prototype, G5 = Kce.call, wRe = Wce && Kce.bind.bind(G5, G5), bn = Wce ? wRe : function(e) {
  return function() {
    return G5.apply(e, arguments);
  };
}, Xce = bn, PRe = Xce({}.toString), DRe = Xce("".slice), i0 = function(e) {
  return DRe(PRe(e), 8, -1);
}, xRe = i0, NRe = bn, q8 = function(e) {
  if (xRe(e) === "Function") return NRe(e);
}, uI = typeof document == "object" && document.all, Fi = typeof uI > "u" && uI !== void 0 ? function(e) {
  return typeof e == "function" || e === uI;
} : function(e) {
  return typeof e == "function";
}, fh = {}, LRe = mn, Hi = !LRe(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), BRe = wT, w_ = Function.prototype.call, po = BRe ? w_.bind(w_) : function() {
  return w_.apply(w_, arguments);
}, PT = {}, Jce = {}.propertyIsEnumerable, Zce = Object.getOwnPropertyDescriptor, kRe = Zce && !Jce.call({ 1: 2 }, 1);
PT.f = kRe ? function(t) {
  var r = Zce(this, t);
  return !!r && r.enumerable;
} : Jce;
var Yf = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, MRe = bn, FRe = mn, HRe = i0, sI = Object, $Re = MRe("".split), Mb = FRe(function() {
  return !sI("z").propertyIsEnumerable(0);
}) ? function(e) {
  return HRe(e) === "String" ? $Re(e, "") : sI(e);
} : sI, Gf = function(e) {
  return e == null;
}, URe = Gf, VRe = TypeError, dh = function(e) {
  if (URe(e)) throw new VRe("Can't call method on " + e);
  return e;
}, jRe = Mb, zRe = dh, Hu = function(e) {
  return jRe(zRe(e));
}, qRe = Fi, $i = function(e) {
  return typeof e == "object" ? e !== null : qRe(e);
}, Pn = {}, cI = Pn, lI = Mn, YRe = Fi, mV = function(e) {
  return YRe(e) ? e : void 0;
}, zo = function(e, t) {
  return arguments.length < 2 ? mV(cI[e]) || mV(lI[e]) : cI[e] && cI[e][t] || lI[e] && lI[e][t];
}, GRe = bn, Qi = GRe({}.isPrototypeOf), WRe = Mn, gV = WRe.navigator, TV = gV && gV.userAgent, ph = TV ? String(TV) : "", Qce = Mn, fI = ph, yV = Qce.process, _V = Qce.Deno, AV = yV && yV.versions || _V && _V.version, SV = AV && AV.v8, us, dS;
SV && (us = SV.split("."), dS = us[0] > 0 && us[0] < 4 ? 1 : +(us[0] + us[1]));
!dS && fI && (us = fI.match(/Edge\/(\d+)/), (!us || us[1] >= 74) && (us = fI.match(/Chrome\/(\d+)/), us && (dS = +us[1])));
var DT = dS, bV = DT, KRe = mn, XRe = Mn, JRe = XRe.String, hh = !!Object.getOwnPropertySymbols && !KRe(function() {
  var e = Symbol("symbol detection");
  return !JRe(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && bV && bV < 41;
}), ZRe = hh, ele = ZRe && !Symbol.sham && typeof Symbol.iterator == "symbol", QRe = zo, ewe = Fi, twe = Qi, rwe = ele, nwe = Object, xT = rwe ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = QRe("Symbol");
  return ewe(t) && twe(t.prototype, nwe(e));
}, iwe = String, Wf = function(e) {
  try {
    return iwe(e);
  } catch {
    return "Object";
  }
}, owe = Fi, awe = Wf, uwe = TypeError, _a = function(e) {
  if (owe(e)) return e;
  throw new uwe(awe(e) + " is not a function");
}, swe = _a, cwe = Gf, Y8 = function(e, t) {
  var r = e[t];
  return cwe(r) ? void 0 : swe(r);
}, dI = po, pI = Fi, hI = $i, lwe = TypeError, fwe = function(e, t) {
  var r, n;
  if (t === "string" && pI(r = e.toString) && !hI(n = dI(r, e)) || pI(r = e.valueOf) && !hI(n = dI(r, e)) || t !== "string" && pI(r = e.toString) && !hI(n = dI(r, e))) return n;
  throw new lwe("Can't convert object to primitive value");
}, tle = { exports: {} }, rle = !0, CV = Mn, dwe = Object.defineProperty, pwe = function(e, t) {
  try {
    dwe(CV, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    CV[e] = t;
  }
  return t;
}, hwe = Mn, vwe = pwe, IV = "__core-js_shared__", OV = tle.exports = hwe[IV] || vwe(IV, {});
(OV.versions || (OV.versions = [])).push({
  version: "3.39.0",
  mode: "pure",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var G8 = tle.exports, RV = G8, vh = function(e, t) {
  return RV[e] || (RV[e] = t || {});
}, Ewe = dh, mwe = Object, cu = function(e) {
  return mwe(Ewe(e));
}, gwe = bn, Twe = cu, ywe = gwe({}.hasOwnProperty), Co = Object.hasOwn || function(t, r) {
  return ywe(Twe(t), r);
}, _we = bn, Awe = 0, Swe = Math.random(), bwe = _we(1 .toString), Fb = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + bwe(++Awe + Swe, 36);
}, Cwe = Mn, Iwe = vh, wV = Co, Owe = Fb, Rwe = hh, wwe = ele, cp = Cwe.Symbol, vI = Iwe("wks"), Pwe = wwe ? cp.for || cp : cp && cp.withoutSetter || Owe, Oi = function(e) {
  return wV(vI, e) || (vI[e] = Rwe && wV(cp, e) ? cp[e] : Pwe("Symbol." + e)), vI[e];
}, Dwe = po, PV = $i, DV = xT, xwe = Y8, Nwe = fwe, Lwe = Oi, Bwe = TypeError, kwe = Lwe("toPrimitive"), Mwe = function(e, t) {
  if (!PV(e) || DV(e)) return e;
  var r = xwe(e, kwe), n;
  if (r) {
    if (t === void 0 && (t = "default"), n = Dwe(r, e, t), !PV(n) || DV(n)) return n;
    throw new Bwe("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), Nwe(e, t);
}, Fwe = Mwe, Hwe = xT, W8 = function(e) {
  var t = Fwe(e, "string");
  return Hwe(t) ? t : t + "";
}, $we = Mn, xV = $i, W5 = $we.document, Uwe = xV(W5) && xV(W5.createElement), K8 = function(e) {
  return Uwe ? W5.createElement(e) : {};
}, Vwe = Hi, jwe = mn, zwe = K8, nle = !Vwe && !jwe(function() {
  return Object.defineProperty(zwe("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), qwe = Hi, Ywe = po, Gwe = PT, Wwe = Yf, Kwe = Hu, Xwe = W8, Jwe = Co, Zwe = nle, NV = Object.getOwnPropertyDescriptor;
fh.f = qwe ? NV : function(t, r) {
  if (t = Kwe(t), r = Xwe(r), Zwe) try {
    return NV(t, r);
  } catch {
  }
  if (Jwe(t, r)) return Wwe(!Ywe(Gwe.f, t, r), t[r]);
};
var Qwe = mn, ePe = Fi, tPe = /#|\.prototype\./, NT = function(e, t) {
  var r = nPe[rPe(e)];
  return r === oPe ? !0 : r === iPe ? !1 : ePe(t) ? Qwe(t) : !!t;
}, rPe = NT.normalize = function(e) {
  return String(e).replace(tPe, ".").toLowerCase();
}, nPe = NT.data = {}, iPe = NT.NATIVE = "N", oPe = NT.POLYFILL = "P", ile = NT, LV = q8, aPe = _a, uPe = wT, sPe = LV(LV.bind), Kf = function(e, t) {
  return aPe(e), t === void 0 ? e : uPe ? sPe(e, t) : function() {
    return e.apply(t, arguments);
  };
}, Ha = {}, cPe = Hi, lPe = mn, ole = cPe && lPe(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), fPe = $i, dPe = String, pPe = TypeError, $a = function(e) {
  if (fPe(e)) return e;
  throw new pPe(dPe(e) + " is not an object");
}, hPe = Hi, vPe = nle, EPe = ole, P_ = $a, BV = W8, mPe = TypeError, EI = Object.defineProperty, gPe = Object.getOwnPropertyDescriptor, mI = "enumerable", gI = "configurable", TI = "writable";
Ha.f = hPe ? EPe ? function(t, r, n) {
  if (P_(t), r = BV(r), P_(n), typeof t == "function" && r === "prototype" && "value" in n && TI in n && !n[TI]) {
    var i = gPe(t, r);
    i && i[TI] && (t[r] = n.value, n = {
      configurable: gI in n ? n[gI] : i[gI],
      enumerable: mI in n ? n[mI] : i[mI],
      writable: !1
    });
  }
  return EI(t, r, n);
} : EI : function(t, r, n) {
  if (P_(t), r = BV(r), P_(n), vPe) try {
    return EI(t, r, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw new mPe("Accessors not supported");
  return "value" in n && (t[r] = n.value), t;
};
var TPe = Hi, yPe = Ha, _Pe = Yf, o0 = TPe ? function(e, t, r) {
  return yPe.f(e, t, _Pe(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, bv = Mn, APe = qf, SPe = q8, bPe = Fi, CPe = fh.f, IPe = ile, Nd = Pn, OPe = Kf, Ld = o0, kV = Co, RPe = function(e) {
  var t = function(r, n, i) {
    if (this instanceof t) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(r);
        case 2:
          return new e(r, n);
      }
      return new e(r, n, i);
    }
    return APe(e, this, arguments);
  };
  return t.prototype = e.prototype, t;
}, Zt = function(e, t) {
  var r = e.target, n = e.global, i = e.stat, o = e.proto, a = n ? bv : i ? bv[r] : bv[r] && bv[r].prototype, u = n ? Nd : Nd[r] || Ld(Nd, r, {})[r], s = u.prototype, c, l, f, d, p, v, h, E, m;
  for (d in t)
    c = IPe(n ? d : r + (i ? "." : "#") + d, e.forced), l = !c && a && kV(a, d), v = u[d], l && (e.dontCallGetSet ? (m = CPe(a, d), h = m && m.value) : h = a[d]), p = l && h ? h : t[d], !(!c && !o && typeof v == typeof p) && (e.bind && l ? E = OPe(p, bv) : e.wrap && l ? E = RPe(p) : o && bPe(p) ? E = SPe(p) : E = p, (e.sham || p && p.sham || v && v.sham) && Ld(E, "sham", !0), Ld(u, d, E), o && (f = r + "Prototype", kV(Nd, f) || Ld(Nd, f, {}), Ld(Nd[f], d, p), e.real && s && (c || !s[d]) && Ld(s, d, p)));
}, wPe = vh, PPe = Fb, MV = wPe("keys"), Hb = function(e) {
  return MV[e] || (MV[e] = PPe(e));
}, DPe = mn, ale = !DPe(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), xPe = Co, NPe = Fi, LPe = cu, BPe = Hb, kPe = ale, FV = BPe("IE_PROTO"), K5 = Object, MPe = K5.prototype, LT = kPe ? K5.getPrototypeOf : function(e) {
  var t = LPe(e);
  if (xPe(t, FV)) return t[FV];
  var r = t.constructor;
  return NPe(r) && t instanceof r ? r.prototype : t instanceof K5 ? MPe : null;
}, FPe = bn, HPe = _a, $Pe = function(e, t, r) {
  try {
    return FPe(HPe(Object.getOwnPropertyDescriptor(e, t)[r]));
  } catch {
  }
}, UPe = $i, VPe = function(e) {
  return UPe(e) || e === null;
}, jPe = VPe, zPe = String, qPe = TypeError, YPe = function(e) {
  if (jPe(e)) return e;
  throw new qPe("Can't set " + zPe(e) + " as a prototype");
}, GPe = $Pe, WPe = $i, KPe = dh, XPe = YPe, ule = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, t = {}, r;
  try {
    r = GPe(Object.prototype, "__proto__", "set"), r(t, []), e = t instanceof Array;
  } catch {
  }
  return function(i, o) {
    return KPe(i), XPe(o), WPe(i) && (e ? r(i, o) : i.__proto__ = o), i;
  };
}() : void 0), BT = {}, JPe = Math.ceil, ZPe = Math.floor, QPe = Math.trunc || function(t) {
  var r = +t;
  return (r > 0 ? ZPe : JPe)(r);
}, e6e = QPe, Eh = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : e6e(t);
}, t6e = Eh, r6e = Math.max, n6e = Math.min, $b = function(e, t) {
  var r = t6e(e);
  return r < 0 ? r6e(r + t, 0) : n6e(r, t);
}, i6e = Eh, o6e = Math.min, a6e = function(e) {
  var t = i6e(e);
  return t > 0 ? o6e(t, 9007199254740991) : 0;
}, u6e = a6e, As = function(e) {
  return u6e(e.length);
}, s6e = Hu, c6e = $b, l6e = As, HV = function(e) {
  return function(t, r, n) {
    var i = s6e(t), o = l6e(i);
    if (o === 0) return !e && -1;
    var a = c6e(n, o), u;
    if (e && r !== r) {
      for (; o > a; )
        if (u = i[a++], u !== u) return !0;
    } else for (; o > a; a++)
      if ((e || a in i) && i[a] === r) return e || a || 0;
    return !e && -1;
  };
}, sle = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: HV(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: HV(!1)
}, kT = {}, f6e = bn, yI = Co, d6e = Hu, p6e = sle.indexOf, h6e = kT, $V = f6e([].push), cle = function(e, t) {
  var r = d6e(e), n = 0, i = [], o;
  for (o in r) !yI(h6e, o) && yI(r, o) && $V(i, o);
  for (; t.length > n; ) yI(r, o = t[n++]) && (~p6e(i, o) || $V(i, o));
  return i;
}, X8 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], v6e = cle, E6e = X8, m6e = E6e.concat("length", "prototype");
BT.f = Object.getOwnPropertyNames || function(t) {
  return v6e(t, m6e);
};
var MT = {};
MT.f = Object.getOwnPropertySymbols;
var g6e = zo, T6e = bn, y6e = BT, _6e = MT, A6e = $a, S6e = T6e([].concat), lle = g6e("Reflect", "ownKeys") || function(t) {
  var r = y6e.f(A6e(t)), n = _6e.f;
  return n ? S6e(r, n(t)) : r;
}, UV = Co, b6e = lle, C6e = fh, I6e = Ha, O6e = function(e, t, r) {
  for (var n = b6e(t), i = I6e.f, o = C6e.f, a = 0; a < n.length; a++) {
    var u = n[a];
    !UV(e, u) && !(r && UV(r, u)) && i(e, u, o(t, u));
  }
}, Ub = {}, R6e = cle, w6e = X8, FT = Object.keys || function(t) {
  return R6e(t, w6e);
}, P6e = Hi, D6e = ole, x6e = Ha, N6e = $a, L6e = Hu, B6e = FT;
Ub.f = P6e && !D6e ? Object.defineProperties : function(t, r) {
  N6e(t);
  for (var n = L6e(r), i = B6e(r), o = i.length, a = 0, u; o > a; ) x6e.f(t, u = i[a++], n[u]);
  return t;
};
var k6e = zo, fle = k6e("document", "documentElement"), M6e = $a, F6e = Ub, VV = X8, H6e = kT, $6e = fle, U6e = K8, V6e = Hb, jV = ">", zV = "<", X5 = "prototype", J5 = "script", dle = V6e("IE_PROTO"), _I = function() {
}, ple = function(e) {
  return zV + J5 + jV + e + zV + "/" + J5 + jV;
}, qV = function(e) {
  e.write(ple("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, j6e = function() {
  var e = U6e("iframe"), t = "java" + J5 + ":", r;
  return e.style.display = "none", $6e.appendChild(e), e.src = String(t), r = e.contentWindow.document, r.open(), r.write(ple("document.F=Object")), r.close(), r.F;
}, D_, _4 = function() {
  try {
    D_ = new ActiveXObject("htmlfile");
  } catch {
  }
  _4 = typeof document < "u" ? document.domain && D_ ? qV(D_) : j6e() : qV(D_);
  for (var e = VV.length; e--; ) delete _4[X5][VV[e]];
  return _4();
};
H6e[dle] = !0;
var Xf = Object.create || function(t, r) {
  var n;
  return t !== null ? (_I[X5] = M6e(t), n = new _I(), _I[X5] = null, n[dle] = t) : n = _4(), r === void 0 ? n : F6e.f(n, r);
}, z6e = $i, q6e = o0, Y6e = function(e, t) {
  z6e(t) && "cause" in t && q6e(e, "cause", t.cause);
}, G6e = bn, hle = Error, W6e = G6e("".replace), K6e = function(e) {
  return String(new hle(e).stack);
}("zxcasd"), vle = /\n\s*at [^:]*:[^\n]*/, X6e = vle.test(K6e), J6e = function(e, t) {
  if (X6e && typeof e == "string" && !hle.prepareStackTrace)
    for (; t--; ) e = W6e(e, vle, "");
  return e;
}, Z6e = mn, Q6e = Yf, eDe = !Z6e(function() {
  var e = new Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", Q6e(1, 7)), e.stack !== 7) : !0;
}), tDe = o0, rDe = J6e, nDe = eDe, YV = Error.captureStackTrace, iDe = function(e, t, r, n) {
  nDe && (YV ? YV(e, t) : tDe(e, "stack", rDe(r, n)));
}, mh = {}, oDe = Oi, aDe = mh, uDe = oDe("iterator"), sDe = Array.prototype, Ele = function(e) {
  return e !== void 0 && (aDe.Array === e || sDe[uDe] === e);
}, cDe = Oi, lDe = cDe("toStringTag"), mle = {};
mle[lDe] = "z";
var J8 = String(mle) === "[object z]", fDe = J8, dDe = Fi, A4 = i0, pDe = Oi, hDe = pDe("toStringTag"), vDe = Object, EDe = A4(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", mDe = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, HT = fDe ? A4 : function(e) {
  var t, r, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = mDe(t = vDe(e), hDe)) == "string" ? r : EDe ? A4(t) : (n = A4(t)) === "Object" && dDe(t.callee) ? "Arguments" : n;
}, gDe = HT, GV = Y8, TDe = Gf, yDe = mh, _De = Oi, ADe = _De("iterator"), Vb = function(e) {
  if (!TDe(e)) return GV(e, ADe) || GV(e, "@@iterator") || yDe[gDe(e)];
}, SDe = po, bDe = _a, CDe = $a, IDe = Wf, ODe = Vb, RDe = TypeError, gle = function(e, t) {
  var r = arguments.length < 2 ? ODe(e) : t;
  if (bDe(r)) return CDe(SDe(r, e));
  throw new RDe(IDe(e) + " is not iterable");
}, wDe = po, WV = $a, PDe = Y8, jb = function(e, t, r) {
  var n, i;
  WV(e);
  try {
    if (n = PDe(e, "return"), !n) {
      if (t === "throw") throw r;
      return r;
    }
    n = wDe(n, e);
  } catch (o) {
    i = !0, n = o;
  }
  if (t === "throw") throw r;
  if (i) throw n;
  return WV(n), r;
}, DDe = Kf, xDe = po, NDe = $a, LDe = Wf, BDe = Ele, kDe = As, KV = Qi, MDe = gle, FDe = Vb, XV = jb, HDe = TypeError, S4 = function(e, t) {
  this.stopped = e, this.result = t;
}, JV = S4.prototype, ic = function(e, t, r) {
  var n = r && r.that, i = !!(r && r.AS_ENTRIES), o = !!(r && r.IS_RECORD), a = !!(r && r.IS_ITERATOR), u = !!(r && r.INTERRUPTED), s = DDe(t, n), c, l, f, d, p, v, h, E = function(g) {
    return c && XV(c, "normal", g), new S4(!0, g);
  }, m = function(g) {
    return i ? (NDe(g), u ? s(g[0], g[1], E) : s(g[0], g[1])) : u ? s(g, E) : s(g);
  };
  if (o)
    c = e.iterator;
  else if (a)
    c = e;
  else {
    if (l = FDe(e), !l) throw new HDe(LDe(e) + " is not iterable");
    if (BDe(l)) {
      for (f = 0, d = kDe(e); d > f; f++)
        if (p = m(e[f]), p && KV(JV, p)) return p;
      return new S4(!1);
    }
    c = MDe(e, l);
  }
  for (v = o ? e.next : c.next; !(h = xDe(v, c)).done; ) {
    try {
      p = m(h.value);
    } catch (g) {
      XV(c, "throw", g);
    }
    if (typeof p == "object" && p && KV(JV, p)) return p;
  }
  return new S4(!1);
}, $De = HT, UDe = String, a0 = function(e) {
  if ($De(e) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return UDe(e);
}, VDe = a0, jDe = function(e, t) {
  return e === void 0 ? arguments.length < 2 ? "" : t : VDe(e);
}, zDe = Zt, qDe = Qi, YDe = LT, pS = ule, GDe = O6e, Tle = Xf, AI = o0, SI = Yf, WDe = Y6e, KDe = iDe, XDe = ic, JDe = jDe, ZDe = Oi, QDe = ZDe("toStringTag"), hS = Error, exe = [].push, Lp = function(t, r) {
  var n = qDe(bI, this), i;
  pS ? i = pS(new hS(), n ? YDe(this) : bI) : (i = n ? this : Tle(bI), AI(i, QDe, "Error")), r !== void 0 && AI(i, "message", JDe(r)), KDe(i, Lp, i.stack, 1), arguments.length > 2 && WDe(i, arguments[2]);
  var o = [];
  return XDe(t, exe, { that: o }), AI(i, "errors", o), i;
};
pS ? pS(Lp, hS) : GDe(Lp, hS, { name: !0 });
var bI = Lp.prototype = Tle(hS.prototype, {
  constructor: SI(1, Lp),
  message: SI(1, ""),
  name: SI(1, "AggregateError")
});
zDe({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: Lp
});
var txe = Mn, rxe = Fi, ZV = txe.WeakMap, yle = rxe(ZV) && /native code/.test(String(ZV)), nxe = yle, _le = Mn, ixe = $i, oxe = o0, CI = Co, II = G8, axe = Hb, uxe = kT, QV = "Object already initialized", Z5 = _le.TypeError, sxe = _le.WeakMap, vS, k1, ES, cxe = function(e) {
  return ES(e) ? k1(e) : vS(e, {});
}, lxe = function(e) {
  return function(t) {
    var r;
    if (!ixe(t) || (r = k1(t)).type !== e)
      throw new Z5("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (nxe || II.state) {
  var Ls = II.state || (II.state = new sxe());
  Ls.get = Ls.get, Ls.has = Ls.has, Ls.set = Ls.set, vS = function(e, t) {
    if (Ls.has(e)) throw new Z5(QV);
    return t.facade = e, Ls.set(e, t), t;
  }, k1 = function(e) {
    return Ls.get(e) || {};
  }, ES = function(e) {
    return Ls.has(e);
  };
} else {
  var Bd = axe("state");
  uxe[Bd] = !0, vS = function(e, t) {
    if (CI(e, Bd)) throw new Z5(QV);
    return t.facade = e, oxe(e, Bd, t), t;
  }, k1 = function(e) {
    return CI(e, Bd) ? e[Bd] : {};
  }, ES = function(e) {
    return CI(e, Bd);
  };
}
var u0 = {
  set: vS,
  get: k1,
  has: ES,
  enforce: cxe,
  getterFor: lxe
}, Q5 = Hi, fxe = Co, Ale = Function.prototype, dxe = Q5 && Object.getOwnPropertyDescriptor, Z8 = fxe(Ale, "name"), pxe = Z8 && (function() {
}).name === "something", hxe = Z8 && (!Q5 || Q5 && dxe(Ale, "name").configurable), vxe = {
  EXISTS: Z8,
  PROPER: pxe,
  CONFIGURABLE: hxe
}, Exe = o0, gh = function(e, t, r, n) {
  return n && n.enumerable ? e[t] = r : Exe(e, t, r), e;
}, mxe = mn, gxe = Fi, Txe = $i, yxe = Xf, ej = LT, _xe = gh, Axe = Oi, eL = Axe("iterator"), Sle = !1, Uc, OI, RI;
[].keys && (RI = [].keys(), "next" in RI ? (OI = ej(ej(RI)), OI !== Object.prototype && (Uc = OI)) : Sle = !0);
var Sxe = !Txe(Uc) || mxe(function() {
  var e = {};
  return Uc[eL].call(e) !== e;
});
Sxe ? Uc = {} : Uc = yxe(Uc);
gxe(Uc[eL]) || _xe(Uc, eL, function() {
  return this;
});
var ble = {
  IteratorPrototype: Uc,
  BUGGY_SAFARI_ITERATORS: Sle
}, bxe = J8, Cxe = HT, Ixe = bxe ? {}.toString : function() {
  return "[object " + Cxe(this) + "]";
}, Oxe = J8, Rxe = Ha.f, wxe = o0, Pxe = Co, Dxe = Ixe, xxe = Oi, tj = xxe("toStringTag"), s0 = function(e, t, r, n) {
  var i = r ? e : e && e.prototype;
  i && (Pxe(i, tj) || Rxe(i, tj, { configurable: !0, value: t }), n && !Oxe && wxe(i, "toString", Dxe));
}, Nxe = ble.IteratorPrototype, Lxe = Xf, Bxe = Yf, kxe = s0, Mxe = mh, Fxe = function() {
  return this;
}, Hxe = function(e, t, r, n) {
  var i = t + " Iterator";
  return e.prototype = Lxe(Nxe, { next: Bxe(+!n, r) }), kxe(e, i, !1, !0), Mxe[i] = Fxe, e;
}, $xe = Zt, Uxe = po, Cle = vxe, Vxe = Hxe, jxe = LT, zxe = s0, rj = gh, qxe = Oi, nj = mh, Ile = ble, Yxe = Cle.PROPER;
Cle.CONFIGURABLE;
Ile.IteratorPrototype;
var x_ = Ile.BUGGY_SAFARI_ITERATORS, wI = qxe("iterator"), ij = "keys", N_ = "values", oj = "entries", Gxe = function() {
  return this;
}, Q8 = function(e, t, r, n, i, o, a) {
  Vxe(r, t, n);
  var u = function(m) {
    if (m === i && d) return d;
    if (!x_ && m && m in l) return l[m];
    switch (m) {
      case ij:
        return function() {
          return new r(this, m);
        };
      case N_:
        return function() {
          return new r(this, m);
        };
      case oj:
        return function() {
          return new r(this, m);
        };
    }
    return function() {
      return new r(this);
    };
  }, s = t + " Iterator", c = !1, l = e.prototype, f = l[wI] || l["@@iterator"] || i && l[i], d = !x_ && f || u(i), p = t === "Array" && l.entries || f, v, h, E;
  if (p && (v = jxe(p.call(new e())), v !== Object.prototype && v.next && (zxe(v, s, !0, !0), nj[s] = Gxe)), Yxe && i === N_ && f && f.name !== N_ && (c = !0, d = function() {
    return Uxe(f, this);
  }), i)
    if (h = {
      values: u(N_),
      keys: o ? d : u(ij),
      entries: u(oj)
    }, a) for (E in h)
      (x_ || c || !(E in l)) && rj(l, E, h[E]);
    else $xe({ target: t, proto: !0, forced: x_ || c }, h);
  return a && l[wI] !== d && rj(l, wI, d, { name: i }), nj[t] = d, h;
}, ek = function(e, t) {
  return { value: e, done: t };
}, Wxe = Hu, aj = mh, Ole = u0;
Ha.f;
var Kxe = Q8, L_ = ek, Rle = "Array Iterator", Xxe = Ole.set, Jxe = Ole.getterFor(Rle);
Kxe(Array, "Array", function(e, t) {
  Xxe(this, {
    type: Rle,
    target: Wxe(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = Jxe(this), t = e.target, r = e.index++;
  if (!t || r >= t.length)
    return e.target = null, L_(void 0, !0);
  switch (e.kind) {
    case "keys":
      return L_(r, !1);
    case "values":
      return L_(t[r], !1);
  }
  return L_([r, t[r]], !1);
}, "values");
aj.Arguments = aj.Array;
var Cv = Mn, Zxe = ph, Qxe = i0, B_ = function(e) {
  return Zxe.slice(0, e.length) === e;
}, tk = function() {
  return B_("Bun/") ? "BUN" : B_("Cloudflare-Workers") ? "CLOUDFLARE" : B_("Deno/") ? "DENO" : B_("Node.js/") ? "NODE" : Cv.Bun && typeof Bun.version == "string" ? "BUN" : Cv.Deno && typeof Deno.version == "object" ? "DENO" : Qxe(Cv.process) === "process" ? "NODE" : Cv.window && Cv.document ? "BROWSER" : "REST";
}(), eNe = tk, zb = eNe === "NODE", tNe = Ha, rk = function(e, t, r) {
  return tNe.f(e, t, r);
}, rNe = zo, nNe = rk, iNe = Oi, oNe = Hi, uj = iNe("species"), wle = function(e) {
  var t = rNe(e);
  oNe && t && !t[uj] && nNe(t, uj, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, aNe = Qi, uNe = TypeError, qb = function(e, t) {
  if (aNe(t, e)) return e;
  throw new uNe("Incorrect invocation");
}, sNe = bn, cNe = Fi, tL = G8, lNe = sNe(Function.toString);
cNe(tL.inspectSource) || (tL.inspectSource = function(e) {
  return lNe(e);
});
var Ple = tL.inspectSource, fNe = bn, dNe = mn, Dle = Fi, pNe = HT, hNe = zo, vNe = Ple, xle = function() {
}, Nle = hNe("Reflect", "construct"), nk = /^\s*(?:class|function)\b/, ENe = fNe(nk.exec), mNe = !nk.test(xle), Iv = function(t) {
  if (!Dle(t)) return !1;
  try {
    return Nle(xle, [], t), !0;
  } catch {
    return !1;
  }
}, Lle = function(t) {
  if (!Dle(t)) return !1;
  switch (pNe(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return mNe || !!ENe(nk, vNe(t));
  } catch {
    return !0;
  }
};
Lle.sham = !0;
var Yb = !Nle || dNe(function() {
  var e;
  return Iv(Iv.call) || !Iv(Object) || !Iv(function() {
    e = !0;
  }) || e;
}) ? Lle : Iv, gNe = Yb, TNe = Wf, yNe = TypeError, Ble = function(e) {
  if (gNe(e)) return e;
  throw new yNe(TNe(e) + " is not a constructor");
}, sj = $a, _Ne = Ble, ANe = Gf, SNe = Oi, bNe = SNe("species"), kle = function(e, t) {
  var r = sj(e).constructor, n;
  return r === void 0 || ANe(n = sj(r)[bNe]) ? t : _Ne(n);
}, CNe = bn, Jf = CNe([].slice), INe = TypeError, Mle = function(e, t) {
  if (e < t) throw new INe("Not enough arguments");
  return e;
}, ONe = ph, Fle = /(?:ipad|iphone|ipod).*applewebkit/i.test(ONe), iu = Mn, RNe = qf, wNe = Kf, cj = Fi, PNe = Co, Hle = mn, lj = fle, DNe = Jf, fj = K8, xNe = Mle, NNe = Fle, LNe = zb, rL = iu.setImmediate, nL = iu.clearImmediate, BNe = iu.process, PI = iu.Dispatch, kNe = iu.Function, dj = iu.MessageChannel, MNe = iu.String, DI = 0, m1 = {}, pj = "onreadystatechange", M1, O0, xI, NI;
Hle(function() {
  M1 = iu.location;
});
var ik = function(e) {
  if (PNe(m1, e)) {
    var t = m1[e];
    delete m1[e], t();
  }
}, LI = function(e) {
  return function() {
    ik(e);
  };
}, hj = function(e) {
  ik(e.data);
}, vj = function(e) {
  iu.postMessage(MNe(e), M1.protocol + "//" + M1.host);
};
(!rL || !nL) && (rL = function(t) {
  xNe(arguments.length, 1);
  var r = cj(t) ? t : kNe(t), n = DNe(arguments, 1);
  return m1[++DI] = function() {
    RNe(r, void 0, n);
  }, O0(DI), DI;
}, nL = function(t) {
  delete m1[t];
}, LNe ? O0 = function(e) {
  BNe.nextTick(LI(e));
} : PI && PI.now ? O0 = function(e) {
  PI.now(LI(e));
} : dj && !NNe ? (xI = new dj(), NI = xI.port2, xI.port1.onmessage = hj, O0 = wNe(NI.postMessage, NI)) : iu.addEventListener && cj(iu.postMessage) && !iu.importScripts && M1 && M1.protocol !== "file:" && !Hle(vj) ? (O0 = vj, iu.addEventListener("message", hj, !1)) : pj in fj("script") ? O0 = function(e) {
  lj.appendChild(fj("script"))[pj] = function() {
    lj.removeChild(this), ik(e);
  };
} : O0 = function(e) {
  setTimeout(LI(e), 0);
});
var $le = {
  set: rL,
  clear: nL
}, Ej = Mn, FNe = Hi, HNe = Object.getOwnPropertyDescriptor, $Ne = function(e) {
  if (!FNe) return Ej[e];
  var t = HNe(Ej, e);
  return t && t.value;
}, Ule = function() {
  this.head = null, this.tail = null;
};
Ule.prototype = {
  add: function(e) {
    var t = { item: e, next: null }, r = this.tail;
    r ? r.next = t : this.head = t, this.tail = t;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var t = this.head = e.next;
      return t === null && (this.tail = null), e.item;
    }
  }
};
var Vle = Ule, UNe = ph, VNe = /ipad|iphone|ipod/i.test(UNe) && typeof Pebble < "u", jNe = ph, zNe = /web0s(?!.*chrome)/i.test(jNe), Bp = Mn, qNe = $Ne, mj = Kf, BI = $le.set, YNe = Vle, GNe = Fle, WNe = VNe, KNe = zNe, kI = zb, gj = Bp.MutationObserver || Bp.WebKitMutationObserver, Tj = Bp.document, yj = Bp.process, k_ = Bp.Promise, iL = qNe("queueMicrotask"), kd, MI, FI, M_, _j;
if (!iL) {
  var F_ = new YNe(), H_ = function() {
    var e, t;
    for (kI && (e = yj.domain) && e.exit(); t = F_.get(); ) try {
      t();
    } catch (r) {
      throw F_.head && kd(), r;
    }
    e && e.enter();
  };
  !GNe && !kI && !KNe && gj && Tj ? (MI = !0, FI = Tj.createTextNode(""), new gj(H_).observe(FI, { characterData: !0 }), kd = function() {
    FI.data = MI = !MI;
  }) : !WNe && k_ && k_.resolve ? (M_ = k_.resolve(void 0), M_.constructor = k_, _j = mj(M_.then, M_), kd = function() {
    _j(H_);
  }) : kI ? kd = function() {
    yj.nextTick(H_);
  } : (BI = mj(BI, Bp), kd = function() {
    BI(H_);
  }), iL = function(e) {
    F_.head || kd(), F_.add(e);
  };
}
var XNe = iL, JNe = function(e, t) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, t);
  } catch {
  }
}, Th = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (t) {
    return { error: !0, value: t };
  }
}, ZNe = Mn, yh = ZNe.Promise, QNe = Mn, g1 = yh, e5e = Fi, t5e = ile, r5e = Ple, n5e = Oi, Aj = tk, HI = DT, Sj = g1 && g1.prototype, i5e = n5e("species"), oL = !1, jle = e5e(QNe.PromiseRejectionEvent), o5e = t5e("Promise", function() {
  var e = r5e(g1), t = e !== String(g1);
  if (!t && HI === 66 || !(Sj.catch && Sj.finally)) return !0;
  if (!HI || HI < 51 || !/native code/.test(e)) {
    var r = new g1(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, i = r.constructor = {};
    if (i[i5e] = n, oL = r.then(function() {
    }) instanceof n, !oL) return !0;
  }
  return !t && (Aj === "BROWSER" || Aj === "DENO") && !jle;
}), $T = {
  CONSTRUCTOR: o5e,
  REJECTION_EVENT: jle,
  SUBCLASSING: oL
}, oc = {}, bj = _a, a5e = TypeError, u5e = function(e) {
  var t, r;
  this.promise = new e(function(n, i) {
    if (t !== void 0 || r !== void 0) throw new a5e("Bad Promise constructor");
    t = n, r = i;
  }), this.resolve = bj(t), this.reject = bj(r);
};
oc.f = function(e) {
  return new u5e(e);
};
var s5e = Zt, mS = zb, Jl = Mn, UT = po, c5e = gh, l5e = s0, f5e = wle, d5e = _a, aL = Fi, p5e = $i, h5e = qb, v5e = kle, zle = $le.set, ok = XNe, E5e = JNe, m5e = Th, g5e = Vle, qle = u0, uL = yh, ak = $T, Yle = oc, Gb = "Promise", Gle = ak.CONSTRUCTOR, T5e = ak.REJECTION_EVENT;
ak.SUBCLASSING;
var $I = qle.getterFor(Gb), y5e = qle.set, _5e = uL && uL.prototype, lp = uL, UI = _5e, Wle = Jl.TypeError, sL = Jl.document, uk = Jl.process, cL = Yle.f, A5e = cL, S5e = !!(sL && sL.createEvent && Jl.dispatchEvent), Kle = "unhandledrejection", b5e = "rejectionhandled", Cj = 0, Xle = 1, C5e = 2, sk = 1, Jle = 2, $_, Ij, I5e, Zle = function(e) {
  var t;
  return p5e(e) && aL(t = e.then) ? t : !1;
}, Qle = function(e, t) {
  var r = t.value, n = t.state === Xle, i = n ? e.ok : e.fail, o = e.resolve, a = e.reject, u = e.domain, s, c, l;
  try {
    i ? (n || (t.rejection === Jle && R5e(t), t.rejection = sk), i === !0 ? s = r : (u && u.enter(), s = i(r), u && (u.exit(), l = !0)), s === e.promise ? a(new Wle("Promise-chain cycle")) : (c = Zle(s)) ? UT(c, s, o, a) : o(s)) : a(r);
  } catch (f) {
    u && !l && u.exit(), a(f);
  }
}, e0e = function(e, t) {
  e.notified || (e.notified = !0, ok(function() {
    for (var r = e.reactions, n; n = r.get(); )
      Qle(n, e);
    e.notified = !1, t && !e.rejection && O5e(e);
  }));
}, t0e = function(e, t, r) {
  var n, i;
  S5e ? (n = sL.createEvent("Event"), n.promise = t, n.reason = r, n.initEvent(e, !1, !0), Jl.dispatchEvent(n)) : n = { promise: t, reason: r }, !T5e && (i = Jl["on" + e]) ? i(n) : e === Kle && E5e("Unhandled promise rejection", r);
}, O5e = function(e) {
  UT(zle, Jl, function() {
    var t = e.facade, r = e.value, n = Oj(e), i;
    if (n && (i = m5e(function() {
      mS ? uk.emit("unhandledRejection", r, t) : t0e(Kle, t, r);
    }), e.rejection = mS || Oj(e) ? Jle : sk, i.error))
      throw i.value;
  });
}, Oj = function(e) {
  return e.rejection !== sk && !e.parent;
}, R5e = function(e) {
  UT(zle, Jl, function() {
    var t = e.facade;
    mS ? uk.emit("rejectionHandled", t) : t0e(b5e, t, e.value);
  });
}, fp = function(e, t, r) {
  return function(n) {
    e(t, n, r);
  };
}, yp = function(e, t, r) {
  e.done || (e.done = !0, r && (e = r), e.value = t, e.state = C5e, e0e(e, !0));
}, lL = function(e, t, r) {
  if (!e.done) {
    e.done = !0, r && (e = r);
    try {
      if (e.facade === t) throw new Wle("Promise can't be resolved itself");
      var n = Zle(t);
      n ? ok(function() {
        var i = { done: !1 };
        try {
          UT(
            n,
            t,
            fp(lL, i, e),
            fp(yp, i, e)
          );
        } catch (o) {
          yp(i, o, e);
        }
      }) : (e.value = t, e.state = Xle, e0e(e, !1));
    } catch (i) {
      yp({ done: !1 }, i, e);
    }
  }
};
Gle && (lp = function(t) {
  h5e(this, UI), d5e(t), UT($_, this);
  var r = $I(this);
  try {
    t(fp(lL, r), fp(yp, r));
  } catch (n) {
    yp(r, n);
  }
}, UI = lp.prototype, $_ = function(t) {
  y5e(this, {
    type: Gb,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new g5e(),
    rejection: !1,
    state: Cj,
    value: null
  });
}, $_.prototype = c5e(UI, "then", function(t, r) {
  var n = $I(this), i = cL(v5e(this, lp));
  return n.parent = !0, i.ok = aL(t) ? t : !0, i.fail = aL(r) && r, i.domain = mS ? uk.domain : void 0, n.state === Cj ? n.reactions.add(i) : ok(function() {
    Qle(i, n);
  }), i.promise;
}), Ij = function() {
  var e = new $_(), t = $I(e);
  this.promise = e, this.resolve = fp(lL, t), this.reject = fp(yp, t);
}, Yle.f = cL = function(e) {
  return e === lp || e === I5e ? new Ij(e) : A5e(e);
});
s5e({ global: !0, constructor: !0, wrap: !0, forced: Gle }, {
  Promise: lp
});
l5e(lp, Gb, !1, !0);
f5e(Gb);
var w5e = Oi, r0e = w5e("iterator"), n0e = !1;
try {
  var P5e = 0, Rj = {
    next: function() {
      return { done: !!P5e++ };
    },
    return: function() {
      n0e = !0;
    }
  };
  Rj[r0e] = function() {
    return this;
  }, Array.from(Rj, function() {
    throw 2;
  });
} catch {
}
var i0e = function(e, t) {
  try {
    if (!t && !n0e) return !1;
  } catch {
    return !1;
  }
  var r = !1;
  try {
    var n = {};
    n[r0e] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, e(n);
  } catch {
  }
  return r;
}, D5e = yh, x5e = i0e, N5e = $T.CONSTRUCTOR, Wb = N5e || !x5e(function(e) {
  D5e.all(e).then(void 0, function() {
  });
}), L5e = Zt, B5e = po, k5e = _a, M5e = oc, F5e = Th, H5e = ic, $5e = Wb;
L5e({ target: "Promise", stat: !0, forced: $5e }, {
  all: function(t) {
    var r = this, n = M5e.f(r), i = n.resolve, o = n.reject, a = F5e(function() {
      var u = k5e(r.resolve), s = [], c = 0, l = 1;
      H5e(t, function(f) {
        var d = c++, p = !1;
        l++, B5e(u, r, f).then(function(v) {
          p || (p = !0, s[d] = v, --l || i(s));
        }, o);
      }), --l || i(s);
    });
    return a.error && o(a.value), n.promise;
  }
});
var U5e = Zt, V5e = $T.CONSTRUCTOR, wj = yh;
wj && wj.prototype;
U5e({ target: "Promise", proto: !0, forced: V5e, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var j5e = Zt, z5e = po, q5e = _a, Y5e = oc, G5e = Th, W5e = ic, K5e = Wb;
j5e({ target: "Promise", stat: !0, forced: K5e }, {
  race: function(t) {
    var r = this, n = Y5e.f(r), i = n.reject, o = G5e(function() {
      var a = q5e(r.resolve);
      W5e(t, function(u) {
        z5e(a, r, u).then(n.resolve, i);
      });
    });
    return o.error && i(o.value), n.promise;
  }
});
var X5e = Zt, J5e = oc, Z5e = $T.CONSTRUCTOR;
X5e({ target: "Promise", stat: !0, forced: Z5e }, {
  reject: function(t) {
    var r = J5e.f(this), n = r.reject;
    return n(t), r.promise;
  }
});
var Q5e = $a, eLe = $i, tLe = oc, o0e = function(e, t) {
  if (Q5e(e), eLe(t) && t.constructor === e) return t;
  var r = tLe.f(e), n = r.resolve;
  return n(t), r.promise;
}, rLe = Zt, nLe = zo, iLe = rle, oLe = yh, aLe = $T.CONSTRUCTOR, uLe = o0e, sLe = nLe("Promise"), cLe = !aLe;
rLe({ target: "Promise", stat: !0, forced: iLe }, {
  resolve: function(t) {
    return uLe(cLe && this === sLe ? oLe : this, t);
  }
});
var lLe = Zt, fLe = po, dLe = _a, pLe = oc, hLe = Th, vLe = ic, ELe = Wb;
lLe({ target: "Promise", stat: !0, forced: ELe }, {
  allSettled: function(t) {
    var r = this, n = pLe.f(r), i = n.resolve, o = n.reject, a = hLe(function() {
      var u = dLe(r.resolve), s = [], c = 0, l = 1;
      vLe(t, function(f) {
        var d = c++, p = !1;
        l++, fLe(u, r, f).then(function(v) {
          p || (p = !0, s[d] = { status: "fulfilled", value: v }, --l || i(s));
        }, function(v) {
          p || (p = !0, s[d] = { status: "rejected", reason: v }, --l || i(s));
        });
      }), --l || i(s);
    });
    return a.error && o(a.value), n.promise;
  }
});
var mLe = Zt, gLe = po, TLe = _a, yLe = zo, _Le = oc, ALe = Th, SLe = ic, bLe = Wb, Pj = "No one promise resolved";
mLe({ target: "Promise", stat: !0, forced: bLe }, {
  any: function(t) {
    var r = this, n = yLe("AggregateError"), i = _Le.f(r), o = i.resolve, a = i.reject, u = ALe(function() {
      var s = TLe(r.resolve), c = [], l = 0, f = 1, d = !1;
      SLe(t, function(p) {
        var v = l++, h = !1;
        f++, gLe(s, r, p).then(function(E) {
          h || d || (d = !0, o(E));
        }, function(E) {
          h || d || (h = !0, c[v] = E, --f || a(new n(c, Pj)));
        });
      }), --f || a(new n(c, Pj));
    });
    return u.error && a(u.value), i.promise;
  }
});
var CLe = Zt, ILe = Mn, OLe = qf, RLe = Jf, wLe = oc, PLe = _a, a0e = Th, VI = ILe.Promise, Dj = !1, DLe = !VI || !VI.try || a0e(function() {
  VI.try(function(e) {
    Dj = e === 8;
  }, 8);
}).error || !Dj;
CLe({ target: "Promise", stat: !0, forced: DLe }, {
  try: function(e) {
    var t = arguments.length > 1 ? RLe(arguments, 1) : [], r = wLe.f(this), n = a0e(function() {
      return OLe(PLe(e), void 0, t);
    });
    return (n.error ? r.reject : r.resolve)(n.value), r.promise;
  }
});
var xLe = Zt, NLe = oc;
xLe({ target: "Promise", stat: !0 }, {
  withResolvers: function() {
    var t = NLe.f(this);
    return {
      promise: t.promise,
      resolve: t.resolve,
      reject: t.reject
    };
  }
});
var LLe = Zt, fL = yh, BLe = mn, kLe = zo, MLe = Fi, FLe = kle, xj = o0e, HLe = fL && fL.prototype, $Le = !!fL && BLe(function() {
  HLe.finally.call({ then: function() {
  } }, function() {
  });
});
LLe({ target: "Promise", proto: !0, real: !0, forced: $Le }, {
  finally: function(e) {
    var t = FLe(this, kLe("Promise")), r = MLe(e);
    return this.then(
      r ? function(n) {
        return xj(t, e()).then(function() {
          return n;
        });
      } : e,
      r ? function(n) {
        return xj(t, e()).then(function() {
          throw n;
        });
      } : e
    );
  }
});
var ck = bn, ULe = Eh, VLe = a0, jLe = dh, zLe = ck("".charAt), Nj = ck("".charCodeAt), qLe = ck("".slice), Lj = function(e) {
  return function(t, r) {
    var n = VLe(jLe(t)), i = ULe(r), o = n.length, a, u;
    return i < 0 || i >= o ? e ? "" : void 0 : (a = Nj(n, i), a < 55296 || a > 56319 || i + 1 === o || (u = Nj(n, i + 1)) < 56320 || u > 57343 ? e ? zLe(n, i) : a : e ? qLe(n, i, i + 2) : (a - 55296 << 10) + (u - 56320) + 65536);
  };
}, YLe = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Lj(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Lj(!0)
}, GLe = YLe.charAt, WLe = a0, u0e = u0, KLe = Q8, Bj = ek, s0e = "String Iterator", XLe = u0e.set, JLe = u0e.getterFor(s0e);
KLe(String, "String", function(e) {
  XLe(this, {
    type: s0e,
    string: WLe(e),
    index: 0
  });
}, function() {
  var t = JLe(this), r = t.string, n = t.index, i;
  return n >= r.length ? Bj(void 0, !0) : (i = GLe(r, n), t.index += i.length, Bj(i, !1));
});
var ZLe = Pn, QLe = ZLe.Promise, eBe = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, tBe = eBe, rBe = Mn, nBe = s0, kj = mh;
for (var jI in tBe)
  nBe(rBe[jI], jI), kj[jI] = kj.Array;
var iBe = QLe, lk = iBe, oBe = lk;
const aBe = /* @__PURE__ */ Mt(oBe);
function uBe() {
  var e = {};
  return e.promise = new aBe(function(t, r) {
    e.resolve = t, e.reject = r;
  }), e;
}
var F1 = uBe;
const sBe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F1
}, Symbol.toStringTag, { value: "Module" }));
class Jg extends Error {
}
Jg.prototype.name = "InvalidTokenError";
function cBe(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, r) => {
    let n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function lBe(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return cBe(t);
  } catch {
    return atob(t);
  }
}
function fBe(e, t) {
  if (typeof e != "string")
    throw new Jg("Invalid token specified: must be a string");
  t || (t = {});
  const r = t.header === !0 ? 0 : 1, n = e.split(".")[r];
  if (typeof n != "string")
    throw new Jg(`Invalid token specified: missing part #${r + 1}`);
  let i;
  try {
    i = lBe(n);
  } catch (o) {
    throw new Jg(`Invalid token specified: invalid base64 for part #${r + 1} (${o.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (o) {
    throw new Jg(`Invalid token specified: invalid json for part #${r + 1} (${o.message})`);
  }
}
const c0e = { "application/prs.cww": ["cww"], "application/prs.xsf+xml": ["xsf"], "application/vnd.1000minds.decision-model+xml": ["1km"], "application/vnd.3gpp.pic-bw-large": ["plb"], "application/vnd.3gpp.pic-bw-small": ["psb"], "application/vnd.3gpp.pic-bw-var": ["pvb"], "application/vnd.3gpp2.tcap": ["tcap"], "application/vnd.3m.post-it-notes": ["pwn"], "application/vnd.accpac.simply.aso": ["aso"], "application/vnd.accpac.simply.imp": ["imp"], "application/vnd.acucobol": ["acu"], "application/vnd.acucorp": ["atc", "acutc"], "application/vnd.adobe.air-application-installer-package+zip": ["air"], "application/vnd.adobe.formscentral.fcdt": ["fcdt"], "application/vnd.adobe.fxp": ["fxp", "fxpl"], "application/vnd.adobe.xdp+xml": ["xdp"], "application/vnd.adobe.xfdf": ["*xfdf"], "application/vnd.age": ["age"], "application/vnd.ahead.space": ["ahead"], "application/vnd.airzip.filesecure.azf": ["azf"], "application/vnd.airzip.filesecure.azs": ["azs"], "application/vnd.amazon.ebook": ["azw"], "application/vnd.americandynamics.acc": ["acc"], "application/vnd.amiga.ami": ["ami"], "application/vnd.android.package-archive": ["apk"], "application/vnd.anser-web-certificate-issue-initiation": ["cii"], "application/vnd.anser-web-funds-transfer-initiation": ["fti"], "application/vnd.antix.game-component": ["atx"], "application/vnd.apple.installer+xml": ["mpkg"], "application/vnd.apple.keynote": ["key"], "application/vnd.apple.mpegurl": ["m3u8"], "application/vnd.apple.numbers": ["numbers"], "application/vnd.apple.pages": ["pages"], "application/vnd.apple.pkpass": ["pkpass"], "application/vnd.aristanetworks.swi": ["swi"], "application/vnd.astraea-software.iota": ["iota"], "application/vnd.audiograph": ["aep"], "application/vnd.balsamiq.bmml+xml": ["bmml"], "application/vnd.blueice.multipass": ["mpm"], "application/vnd.bmi": ["bmi"], "application/vnd.businessobjects": ["rep"], "application/vnd.chemdraw+xml": ["cdxml"], "application/vnd.chipnuts.karaoke-mmd": ["mmd"], "application/vnd.cinderella": ["cdy"], "application/vnd.citationstyles.style+xml": ["csl"], "application/vnd.claymore": ["cla"], "application/vnd.cloanto.rp9": ["rp9"], "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"], "application/vnd.cluetrust.cartomobile-config": ["c11amc"], "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"], "application/vnd.commonspace": ["csp"], "application/vnd.contact.cmsg": ["cdbcmsg"], "application/vnd.cosmocaller": ["cmc"], "application/vnd.crick.clicker": ["clkx"], "application/vnd.crick.clicker.keyboard": ["clkk"], "application/vnd.crick.clicker.palette": ["clkp"], "application/vnd.crick.clicker.template": ["clkt"], "application/vnd.crick.clicker.wordbank": ["clkw"], "application/vnd.criticaltools.wbs+xml": ["wbs"], "application/vnd.ctc-posml": ["pml"], "application/vnd.cups-ppd": ["ppd"], "application/vnd.curl.car": ["car"], "application/vnd.curl.pcurl": ["pcurl"], "application/vnd.dart": ["dart"], "application/vnd.data-vision.rdz": ["rdz"], "application/vnd.dbf": ["dbf"], "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"], "application/vnd.dece.ttml+xml": ["uvt", "uvvt"], "application/vnd.dece.unspecified": ["uvx", "uvvx"], "application/vnd.dece.zip": ["uvz", "uvvz"], "application/vnd.denovo.fcselayout-link": ["fe_launch"], "application/vnd.dna": ["dna"], "application/vnd.dolby.mlp": ["mlp"], "application/vnd.dpgraph": ["dpg"], "application/vnd.dreamfactory": ["dfac"], "application/vnd.ds-keypoint": ["kpxx"], "application/vnd.dvb.ait": ["ait"], "application/vnd.dvb.service": ["svc"], "application/vnd.dynageo": ["geo"], "application/vnd.ecowin.chart": ["mag"], "application/vnd.enliven": ["nml"], "application/vnd.epson.esf": ["esf"], "application/vnd.epson.msf": ["msf"], "application/vnd.epson.quickanime": ["qam"], "application/vnd.epson.salt": ["slt"], "application/vnd.epson.ssf": ["ssf"], "application/vnd.eszigno3+xml": ["es3", "et3"], "application/vnd.ezpix-album": ["ez2"], "application/vnd.ezpix-package": ["ez3"], "application/vnd.fdf": ["*fdf"], "application/vnd.fdsn.mseed": ["mseed"], "application/vnd.fdsn.seed": ["seed", "dataless"], "application/vnd.flographit": ["gph"], "application/vnd.fluxtime.clip": ["ftc"], "application/vnd.framemaker": ["fm", "frame", "maker", "book"], "application/vnd.frogans.fnc": ["fnc"], "application/vnd.frogans.ltf": ["ltf"], "application/vnd.fsc.weblaunch": ["fsc"], "application/vnd.fujitsu.oasys": ["oas"], "application/vnd.fujitsu.oasys2": ["oa2"], "application/vnd.fujitsu.oasys3": ["oa3"], "application/vnd.fujitsu.oasysgp": ["fg5"], "application/vnd.fujitsu.oasysprs": ["bh2"], "application/vnd.fujixerox.ddd": ["ddd"], "application/vnd.fujixerox.docuworks": ["xdw"], "application/vnd.fujixerox.docuworks.binder": ["xbd"], "application/vnd.fuzzysheet": ["fzs"], "application/vnd.genomatix.tuxedo": ["txd"], "application/vnd.geogebra.file": ["ggb"], "application/vnd.geogebra.tool": ["ggt"], "application/vnd.geometry-explorer": ["gex", "gre"], "application/vnd.geonext": ["gxt"], "application/vnd.geoplan": ["g2w"], "application/vnd.geospace": ["g3w"], "application/vnd.gmx": ["gmx"], "application/vnd.google-apps.document": ["gdoc"], "application/vnd.google-apps.presentation": ["gslides"], "application/vnd.google-apps.spreadsheet": ["gsheet"], "application/vnd.google-earth.kml+xml": ["kml"], "application/vnd.google-earth.kmz": ["kmz"], "application/vnd.grafeq": ["gqf", "gqs"], "application/vnd.groove-account": ["gac"], "application/vnd.groove-help": ["ghf"], "application/vnd.groove-identity-message": ["gim"], "application/vnd.groove-injector": ["grv"], "application/vnd.groove-tool-message": ["gtm"], "application/vnd.groove-tool-template": ["tpl"], "application/vnd.groove-vcard": ["vcg"], "application/vnd.hal+xml": ["hal"], "application/vnd.handheld-entertainment+xml": ["zmm"], "application/vnd.hbci": ["hbci"], "application/vnd.hhe.lesson-player": ["les"], "application/vnd.hp-hpgl": ["hpgl"], "application/vnd.hp-hpid": ["hpid"], "application/vnd.hp-hps": ["hps"], "application/vnd.hp-jlyt": ["jlt"], "application/vnd.hp-pcl": ["pcl"], "application/vnd.hp-pclxl": ["pclxl"], "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"], "application/vnd.ibm.minipay": ["mpy"], "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"], "application/vnd.ibm.rights-management": ["irm"], "application/vnd.ibm.secure-container": ["sc"], "application/vnd.iccprofile": ["icc", "icm"], "application/vnd.igloader": ["igl"], "application/vnd.immervision-ivp": ["ivp"], "application/vnd.immervision-ivu": ["ivu"], "application/vnd.insors.igm": ["igm"], "application/vnd.intercon.formnet": ["xpw", "xpx"], "application/vnd.intergeo": ["i2g"], "application/vnd.intu.qbo": ["qbo"], "application/vnd.intu.qfx": ["qfx"], "application/vnd.ipunplugged.rcprofile": ["rcprofile"], "application/vnd.irepository.package+xml": ["irp"], "application/vnd.is-xpr": ["xpr"], "application/vnd.isac.fcs": ["fcs"], "application/vnd.jam": ["jam"], "application/vnd.jcp.javame.midlet-rms": ["rms"], "application/vnd.jisp": ["jisp"], "application/vnd.joost.joda-archive": ["joda"], "application/vnd.kahootz": ["ktz", "ktr"], "application/vnd.kde.karbon": ["karbon"], "application/vnd.kde.kchart": ["chrt"], "application/vnd.kde.kformula": ["kfo"], "application/vnd.kde.kivio": ["flw"], "application/vnd.kde.kontour": ["kon"], "application/vnd.kde.kpresenter": ["kpr", "kpt"], "application/vnd.kde.kspread": ["ksp"], "application/vnd.kde.kword": ["kwd", "kwt"], "application/vnd.kenameaapp": ["htke"], "application/vnd.kidspiration": ["kia"], "application/vnd.kinar": ["kne", "knp"], "application/vnd.koan": ["skp", "skd", "skt", "skm"], "application/vnd.kodak-descriptor": ["sse"], "application/vnd.las.las+xml": ["lasxml"], "application/vnd.llamagraphics.life-balance.desktop": ["lbd"], "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"], "application/vnd.lotus-1-2-3": ["123"], "application/vnd.lotus-approach": ["apr"], "application/vnd.lotus-freelance": ["pre"], "application/vnd.lotus-notes": ["nsf"], "application/vnd.lotus-organizer": ["org"], "application/vnd.lotus-screencam": ["scm"], "application/vnd.lotus-wordpro": ["lwp"], "application/vnd.macports.portpkg": ["portpkg"], "application/vnd.mapbox-vector-tile": ["mvt"], "application/vnd.mcd": ["mcd"], "application/vnd.medcalcdata": ["mc1"], "application/vnd.mediastation.cdkey": ["cdkey"], "application/vnd.mfer": ["mwf"], "application/vnd.mfmp": ["mfm"], "application/vnd.micrografx.flo": ["flo"], "application/vnd.micrografx.igx": ["igx"], "application/vnd.mif": ["mif"], "application/vnd.mobius.daf": ["daf"], "application/vnd.mobius.dis": ["dis"], "application/vnd.mobius.mbk": ["mbk"], "application/vnd.mobius.mqy": ["mqy"], "application/vnd.mobius.msl": ["msl"], "application/vnd.mobius.plc": ["plc"], "application/vnd.mobius.txf": ["txf"], "application/vnd.mophun.application": ["mpn"], "application/vnd.mophun.certificate": ["mpc"], "application/vnd.mozilla.xul+xml": ["xul"], "application/vnd.ms-artgalry": ["cil"], "application/vnd.ms-cab-compressed": ["cab"], "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"], "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"], "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"], "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"], "application/vnd.ms-excel.template.macroenabled.12": ["xltm"], "application/vnd.ms-fontobject": ["eot"], "application/vnd.ms-htmlhelp": ["chm"], "application/vnd.ms-ims": ["ims"], "application/vnd.ms-lrm": ["lrm"], "application/vnd.ms-officetheme": ["thmx"], "application/vnd.ms-outlook": ["msg"], "application/vnd.ms-pki.seccat": ["cat"], "application/vnd.ms-pki.stl": ["*stl"], "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"], "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"], "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"], "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"], "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"], "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"], "application/vnd.ms-project": ["*mpp", "mpt"], "application/vnd.ms-word.document.macroenabled.12": ["docm"], "application/vnd.ms-word.template.macroenabled.12": ["dotm"], "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"], "application/vnd.ms-wpl": ["wpl"], "application/vnd.ms-xpsdocument": ["xps"], "application/vnd.mseq": ["mseq"], "application/vnd.musician": ["mus"], "application/vnd.muvee.style": ["msty"], "application/vnd.mynfc": ["taglet"], "application/vnd.neurolanguage.nlu": ["nlu"], "application/vnd.nitf": ["ntf", "nitf"], "application/vnd.noblenet-directory": ["nnd"], "application/vnd.noblenet-sealer": ["nns"], "application/vnd.noblenet-web": ["nnw"], "application/vnd.nokia.n-gage.ac+xml": ["*ac"], "application/vnd.nokia.n-gage.data": ["ngdat"], "application/vnd.nokia.n-gage.symbian.install": ["n-gage"], "application/vnd.nokia.radio-preset": ["rpst"], "application/vnd.nokia.radio-presets": ["rpss"], "application/vnd.novadigm.edm": ["edm"], "application/vnd.novadigm.edx": ["edx"], "application/vnd.novadigm.ext": ["ext"], "application/vnd.oasis.opendocument.chart": ["odc"], "application/vnd.oasis.opendocument.chart-template": ["otc"], "application/vnd.oasis.opendocument.database": ["odb"], "application/vnd.oasis.opendocument.formula": ["odf"], "application/vnd.oasis.opendocument.formula-template": ["odft"], "application/vnd.oasis.opendocument.graphics": ["odg"], "application/vnd.oasis.opendocument.graphics-template": ["otg"], "application/vnd.oasis.opendocument.image": ["odi"], "application/vnd.oasis.opendocument.image-template": ["oti"], "application/vnd.oasis.opendocument.presentation": ["odp"], "application/vnd.oasis.opendocument.presentation-template": ["otp"], "application/vnd.oasis.opendocument.spreadsheet": ["ods"], "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"], "application/vnd.oasis.opendocument.text": ["odt"], "application/vnd.oasis.opendocument.text-master": ["odm"], "application/vnd.oasis.opendocument.text-template": ["ott"], "application/vnd.oasis.opendocument.text-web": ["oth"], "application/vnd.olpc-sugar": ["xo"], "application/vnd.oma.dd2+xml": ["dd2"], "application/vnd.openblox.game+xml": ["obgx"], "application/vnd.openofficeorg.extension": ["oxt"], "application/vnd.openstreetmap.data+xml": ["osm"], "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"], "application/vnd.openxmlformats-officedocument.presentationml.slide": ["sldx"], "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ["ppsx"], "application/vnd.openxmlformats-officedocument.presentationml.template": ["potx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ["xltx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ["dotx"], "application/vnd.osgeo.mapguide.package": ["mgp"], "application/vnd.osgi.dp": ["dp"], "application/vnd.osgi.subsystem": ["esa"], "application/vnd.palm": ["pdb", "pqa", "oprc"], "application/vnd.pawaafile": ["paw"], "application/vnd.pg.format": ["str"], "application/vnd.pg.osasli": ["ei6"], "application/vnd.picsel": ["efif"], "application/vnd.pmi.widget": ["wg"], "application/vnd.pocketlearn": ["plf"], "application/vnd.powerbuilder6": ["pbd"], "application/vnd.previewsystems.box": ["box"], "application/vnd.proteus.magazine": ["mgz"], "application/vnd.publishare-delta-tree": ["qps"], "application/vnd.pvi.ptid1": ["ptid"], "application/vnd.pwg-xhtml-print+xml": ["xhtm"], "application/vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"], "application/vnd.rar": ["rar"], "application/vnd.realvnc.bed": ["bed"], "application/vnd.recordare.musicxml": ["mxl"], "application/vnd.recordare.musicxml+xml": ["musicxml"], "application/vnd.rig.cryptonote": ["cryptonote"], "application/vnd.rim.cod": ["cod"], "application/vnd.rn-realmedia": ["rm"], "application/vnd.rn-realmedia-vbr": ["rmvb"], "application/vnd.route66.link66+xml": ["link66"], "application/vnd.sailingtracker.track": ["st"], "application/vnd.seemail": ["see"], "application/vnd.sema": ["sema"], "application/vnd.semd": ["semd"], "application/vnd.semf": ["semf"], "application/vnd.shana.informed.formdata": ["ifm"], "application/vnd.shana.informed.formtemplate": ["itp"], "application/vnd.shana.informed.interchange": ["iif"], "application/vnd.shana.informed.package": ["ipk"], "application/vnd.simtech-mindmapper": ["twd", "twds"], "application/vnd.smaf": ["mmf"], "application/vnd.smart.teacher": ["teacher"], "application/vnd.software602.filler.form+xml": ["fo"], "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"], "application/vnd.spotfire.dxp": ["dxp"], "application/vnd.spotfire.sfs": ["sfs"], "application/vnd.stardivision.calc": ["sdc"], "application/vnd.stardivision.draw": ["sda"], "application/vnd.stardivision.impress": ["sdd"], "application/vnd.stardivision.math": ["smf"], "application/vnd.stardivision.writer": ["sdw", "vor"], "application/vnd.stardivision.writer-global": ["sgl"], "application/vnd.stepmania.package": ["smzip"], "application/vnd.stepmania.stepchart": ["sm"], "application/vnd.sun.wadl+xml": ["wadl"], "application/vnd.sun.xml.calc": ["sxc"], "application/vnd.sun.xml.calc.template": ["stc"], "application/vnd.sun.xml.draw": ["sxd"], "application/vnd.sun.xml.draw.template": ["std"], "application/vnd.sun.xml.impress": ["sxi"], "application/vnd.sun.xml.impress.template": ["sti"], "application/vnd.sun.xml.math": ["sxm"], "application/vnd.sun.xml.writer": ["sxw"], "application/vnd.sun.xml.writer.global": ["sxg"], "application/vnd.sun.xml.writer.template": ["stw"], "application/vnd.sus-calendar": ["sus", "susp"], "application/vnd.svd": ["svd"], "application/vnd.symbian.install": ["sis", "sisx"], "application/vnd.syncml+xml": ["xsm"], "application/vnd.syncml.dm+wbxml": ["bdm"], "application/vnd.syncml.dm+xml": ["xdm"], "application/vnd.syncml.dmddf+xml": ["ddf"], "application/vnd.tao.intent-module-archive": ["tao"], "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"], "application/vnd.tmobile-livetv": ["tmo"], "application/vnd.trid.tpt": ["tpt"], "application/vnd.triscape.mxs": ["mxs"], "application/vnd.trueapp": ["tra"], "application/vnd.ufdl": ["ufd", "ufdl"], "application/vnd.uiq.theme": ["utz"], "application/vnd.umajin": ["umj"], "application/vnd.unity": ["unityweb"], "application/vnd.uoml+xml": ["uoml", "uo"], "application/vnd.vcx": ["vcx"], "application/vnd.visio": ["vsd", "vst", "vss", "vsw"], "application/vnd.visionary": ["vis"], "application/vnd.vsf": ["vsf"], "application/vnd.wap.wbxml": ["wbxml"], "application/vnd.wap.wmlc": ["wmlc"], "application/vnd.wap.wmlscriptc": ["wmlsc"], "application/vnd.webturbo": ["wtb"], "application/vnd.wolfram.player": ["nbp"], "application/vnd.wordperfect": ["wpd"], "application/vnd.wqd": ["wqd"], "application/vnd.wt.stf": ["stf"], "application/vnd.xara": ["xar"], "application/vnd.xfdl": ["xfdl"], "application/vnd.yamaha.hv-dic": ["hvd"], "application/vnd.yamaha.hv-script": ["hvs"], "application/vnd.yamaha.hv-voice": ["hvp"], "application/vnd.yamaha.openscoreformat": ["osf"], "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"], "application/vnd.yamaha.smaf-audio": ["saf"], "application/vnd.yamaha.smaf-phrase": ["spf"], "application/vnd.yellowriver-custom-menu": ["cmp"], "application/vnd.zul": ["zir", "zirz"], "application/vnd.zzazz.deck+xml": ["zaz"], "application/x-7z-compressed": ["7z"], "application/x-abiword": ["abw"], "application/x-ace-compressed": ["ace"], "application/x-apple-diskimage": ["*dmg"], "application/x-arj": ["arj"], "application/x-authorware-bin": ["aab", "x32", "u32", "vox"], "application/x-authorware-map": ["aam"], "application/x-authorware-seg": ["aas"], "application/x-bcpio": ["bcpio"], "application/x-bdoc": ["*bdoc"], "application/x-bittorrent": ["torrent"], "application/x-blorb": ["blb", "blorb"], "application/x-bzip": ["bz"], "application/x-bzip2": ["bz2", "boz"], "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"], "application/x-cdlink": ["vcd"], "application/x-cfs-compressed": ["cfs"], "application/x-chat": ["chat"], "application/x-chess-pgn": ["pgn"], "application/x-chrome-extension": ["crx"], "application/x-cocoa": ["cco"], "application/x-conference": ["nsc"], "application/x-cpio": ["cpio"], "application/x-csh": ["csh"], "application/x-debian-package": ["*deb", "udeb"], "application/x-dgc-compressed": ["dgc"], "application/x-director": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"], "application/x-doom": ["wad"], "application/x-dtbncx+xml": ["ncx"], "application/x-dtbook+xml": ["dtb"], "application/x-dtbresource+xml": ["res"], "application/x-dvi": ["dvi"], "application/x-envoy": ["evy"], "application/x-eva": ["eva"], "application/x-font-bdf": ["bdf"], "application/x-font-ghostscript": ["gsf"], "application/x-font-linux-psf": ["psf"], "application/x-font-pcf": ["pcf"], "application/x-font-snf": ["snf"], "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"], "application/x-freearc": ["arc"], "application/x-futuresplash": ["spl"], "application/x-gca-compressed": ["gca"], "application/x-glulx": ["ulx"], "application/x-gnumeric": ["gnumeric"], "application/x-gramps-xml": ["gramps"], "application/x-gtar": ["gtar"], "application/x-hdf": ["hdf"], "application/x-httpd-php": ["php"], "application/x-install-instructions": ["install"], "application/x-iso9660-image": ["*iso"], "application/x-iwork-keynote-sffkey": ["*key"], "application/x-iwork-numbers-sffnumbers": ["*numbers"], "application/x-iwork-pages-sffpages": ["*pages"], "application/x-java-archive-diff": ["jardiff"], "application/x-java-jnlp-file": ["jnlp"], "application/x-keepass2": ["kdbx"], "application/x-latex": ["latex"], "application/x-lua-bytecode": ["luac"], "application/x-lzh-compressed": ["lzh", "lha"], "application/x-makeself": ["run"], "application/x-mie": ["mie"], "application/x-mobipocket-ebook": ["*prc", "mobi"], "application/x-ms-application": ["application"], "application/x-ms-shortcut": ["lnk"], "application/x-ms-wmd": ["wmd"], "application/x-ms-wmz": ["wmz"], "application/x-ms-xbap": ["xbap"], "application/x-msaccess": ["mdb"], "application/x-msbinder": ["obd"], "application/x-mscardfile": ["crd"], "application/x-msclip": ["clp"], "application/x-msdos-program": ["*exe"], "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"], "application/x-msmediaview": ["mvb", "m13", "m14"], "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"], "application/x-msmoney": ["mny"], "application/x-mspublisher": ["pub"], "application/x-msschedule": ["scd"], "application/x-msterminal": ["trm"], "application/x-mswrite": ["wri"], "application/x-netcdf": ["nc", "cdf"], "application/x-ns-proxy-autoconfig": ["pac"], "application/x-nzb": ["nzb"], "application/x-perl": ["pl", "pm"], "application/x-pilot": ["*prc", "*pdb"], "application/x-pkcs12": ["p12", "pfx"], "application/x-pkcs7-certificates": ["p7b", "spc"], "application/x-pkcs7-certreqresp": ["p7r"], "application/x-rar-compressed": ["*rar"], "application/x-redhat-package-manager": ["rpm"], "application/x-research-info-systems": ["ris"], "application/x-sea": ["sea"], "application/x-sh": ["sh"], "application/x-shar": ["shar"], "application/x-shockwave-flash": ["swf"], "application/x-silverlight-app": ["xap"], "application/x-sql": ["*sql"], "application/x-stuffit": ["sit"], "application/x-stuffitx": ["sitx"], "application/x-subrip": ["srt"], "application/x-sv4cpio": ["sv4cpio"], "application/x-sv4crc": ["sv4crc"], "application/x-t3vm-image": ["t3"], "application/x-tads": ["gam"], "application/x-tar": ["tar"], "application/x-tcl": ["tcl", "tk"], "application/x-tex": ["tex"], "application/x-tex-tfm": ["tfm"], "application/x-texinfo": ["texinfo", "texi"], "application/x-tgif": ["*obj"], "application/x-ustar": ["ustar"], "application/x-virtualbox-hdd": ["hdd"], "application/x-virtualbox-ova": ["ova"], "application/x-virtualbox-ovf": ["ovf"], "application/x-virtualbox-vbox": ["vbox"], "application/x-virtualbox-vbox-extpack": ["vbox-extpack"], "application/x-virtualbox-vdi": ["vdi"], "application/x-virtualbox-vhd": ["vhd"], "application/x-virtualbox-vmdk": ["vmdk"], "application/x-wais-source": ["src"], "application/x-web-app-manifest+json": ["webapp"], "application/x-x509-ca-cert": ["der", "crt", "pem"], "application/x-xfig": ["fig"], "application/x-xliff+xml": ["*xlf"], "application/x-xpinstall": ["xpi"], "application/x-xz": ["xz"], "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"], "audio/vnd.dece.audio": ["uva", "uvva"], "audio/vnd.digital-winds": ["eol"], "audio/vnd.dra": ["dra"], "audio/vnd.dts": ["dts"], "audio/vnd.dts.hd": ["dtshd"], "audio/vnd.lucent.voice": ["lvp"], "audio/vnd.ms-playready.media.pya": ["pya"], "audio/vnd.nuera.ecelp4800": ["ecelp4800"], "audio/vnd.nuera.ecelp7470": ["ecelp7470"], "audio/vnd.nuera.ecelp9600": ["ecelp9600"], "audio/vnd.rip": ["rip"], "audio/x-aac": ["*aac"], "audio/x-aiff": ["aif", "aiff", "aifc"], "audio/x-caf": ["caf"], "audio/x-flac": ["flac"], "audio/x-m4a": ["*m4a"], "audio/x-matroska": ["mka"], "audio/x-mpegurl": ["m3u"], "audio/x-ms-wax": ["wax"], "audio/x-ms-wma": ["wma"], "audio/x-pn-realaudio": ["ram", "ra"], "audio/x-pn-realaudio-plugin": ["rmp"], "audio/x-realaudio": ["*ra"], "audio/x-wav": ["*wav"], "chemical/x-cdx": ["cdx"], "chemical/x-cif": ["cif"], "chemical/x-cmdf": ["cmdf"], "chemical/x-cml": ["cml"], "chemical/x-csml": ["csml"], "chemical/x-xyz": ["xyz"], "image/prs.btif": ["btif", "btf"], "image/prs.pti": ["pti"], "image/vnd.adobe.photoshop": ["psd"], "image/vnd.airzip.accelerator.azv": ["azv"], "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"], "image/vnd.djvu": ["djvu", "djv"], "image/vnd.dvb.subtitle": ["*sub"], "image/vnd.dwg": ["dwg"], "image/vnd.dxf": ["dxf"], "image/vnd.fastbidsheet": ["fbs"], "image/vnd.fpx": ["fpx"], "image/vnd.fst": ["fst"], "image/vnd.fujixerox.edmics-mmr": ["mmr"], "image/vnd.fujixerox.edmics-rlc": ["rlc"], "image/vnd.microsoft.icon": ["ico"], "image/vnd.ms-dds": ["dds"], "image/vnd.ms-modi": ["mdi"], "image/vnd.ms-photo": ["wdp"], "image/vnd.net-fpx": ["npx"], "image/vnd.pco.b16": ["b16"], "image/vnd.tencent.tap": ["tap"], "image/vnd.valve.source.texture": ["vtf"], "image/vnd.wap.wbmp": ["wbmp"], "image/vnd.xiff": ["xif"], "image/vnd.zbrush.pcx": ["pcx"], "image/x-3ds": ["3ds"], "image/x-cmu-raster": ["ras"], "image/x-cmx": ["cmx"], "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"], "image/x-icon": ["*ico"], "image/x-jng": ["jng"], "image/x-mrsid-image": ["sid"], "image/x-ms-bmp": ["*bmp"], "image/x-pcx": ["*pcx"], "image/x-pict": ["pic", "pct"], "image/x-portable-anymap": ["pnm"], "image/x-portable-bitmap": ["pbm"], "image/x-portable-graymap": ["pgm"], "image/x-portable-pixmap": ["ppm"], "image/x-rgb": ["rgb"], "image/x-tga": ["tga"], "image/x-xbitmap": ["xbm"], "image/x-xpixmap": ["xpm"], "image/x-xwindowdump": ["xwd"], "message/vnd.wfa.wsc": ["wsc"], "model/vnd.cld": ["cld"], "model/vnd.collada+xml": ["dae"], "model/vnd.dwf": ["dwf"], "model/vnd.gdl": ["gdl"], "model/vnd.gtw": ["gtw"], "model/vnd.mts": ["mts"], "model/vnd.opengex": ["ogex"], "model/vnd.parasolid.transmit.binary": ["x_b"], "model/vnd.parasolid.transmit.text": ["x_t"], "model/vnd.pytha.pyox": ["pyo", "pyox"], "model/vnd.sap.vds": ["vds"], "model/vnd.usda": ["usda"], "model/vnd.usdz+zip": ["usdz"], "model/vnd.valve.source.compiled-map": ["bsp"], "model/vnd.vtu": ["vtu"], "text/prs.lines.tag": ["dsc"], "text/vnd.curl": ["curl"], "text/vnd.curl.dcurl": ["dcurl"], "text/vnd.curl.mcurl": ["mcurl"], "text/vnd.curl.scurl": ["scurl"], "text/vnd.dvb.subtitle": ["sub"], "text/vnd.familysearch.gedcom": ["ged"], "text/vnd.fly": ["fly"], "text/vnd.fmi.flexstor": ["flx"], "text/vnd.graphviz": ["gv"], "text/vnd.in3d.3dml": ["3dml"], "text/vnd.in3d.spot": ["spot"], "text/vnd.sun.j2me.app-descriptor": ["jad"], "text/vnd.wap.wml": ["wml"], "text/vnd.wap.wmlscript": ["wmls"], "text/x-asm": ["s", "asm"], "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"], "text/x-component": ["htc"], "text/x-fortran": ["f", "for", "f77", "f90"], "text/x-handlebars-template": ["hbs"], "text/x-java-source": ["java"], "text/x-lua": ["lua"], "text/x-markdown": ["mkd"], "text/x-nfo": ["nfo"], "text/x-opml": ["opml"], "text/x-org": ["*org"], "text/x-pascal": ["p", "pas"], "text/x-processing": ["pde"], "text/x-sass": ["sass"], "text/x-scss": ["scss"], "text/x-setext": ["etx"], "text/x-sfv": ["sfv"], "text/x-suse-ymp": ["ymp"], "text/x-uuencode": ["uu"], "text/x-vcalendar": ["vcs"], "text/x-vcard": ["vcf"], "video/vnd.dece.hd": ["uvh", "uvvh"], "video/vnd.dece.mobile": ["uvm", "uvvm"], "video/vnd.dece.pd": ["uvp", "uvvp"], "video/vnd.dece.sd": ["uvs", "uvvs"], "video/vnd.dece.video": ["uvv", "uvvv"], "video/vnd.dvb.file": ["dvb"], "video/vnd.fvt": ["fvt"], "video/vnd.mpegurl": ["mxu", "m4u"], "video/vnd.ms-playready.media.pyv": ["pyv"], "video/vnd.uvvu.mp4": ["uvu", "uvvu"], "video/vnd.vivo": ["viv"], "video/x-f4v": ["f4v"], "video/x-fli": ["fli"], "video/x-flv": ["flv"], "video/x-m4v": ["m4v"], "video/x-matroska": ["mkv", "mk3d", "mks"], "video/x-mng": ["mng"], "video/x-ms-asf": ["asf", "asx"], "video/x-ms-vob": ["vob"], "video/x-ms-wm": ["wm"], "video/x-ms-wmv": ["wmv"], "video/x-ms-wmx": ["wmx"], "video/x-ms-wvx": ["wvx"], "video/x-msvideo": ["avi"], "video/x-sgi-movie": ["movie"], "video/x-smv": ["smv"], "x-conference/x-cooltalk": ["ice"] };
Object.freeze(c0e);
const l0e = { "application/andrew-inset": ["ez"], "application/appinstaller": ["appinstaller"], "application/applixware": ["aw"], "application/appx": ["appx"], "application/appxbundle": ["appxbundle"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/automationml-aml+xml": ["aml"], "application/automationml-amlx+zip": ["amlx"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cpl+xml": ["cpl"], "application/cu-seeme": ["cu"], "application/cwl": ["cwl"], "application/dash+xml": ["mpd"], "application/dash-patch+xml": ["mpp"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdf": ["fdf"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["*js"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/media-policy-dataset+xml": ["mpf"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["*mp4", "*mpg4", "mp4s", "m4p"], "application/msix": ["msix"], "application/msixbundle": ["msixbundle"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-keys": ["asc"], "application/pgp-signature": ["sig", "*asc"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/sql": ["sql"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/watcherinfo+xml": ["wif"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xfdf": ["xfdf"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/aac": ["adts", "aac"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avci": ["avci"], "image/avcs": ["avcs"], "image/avif": ["avif"], "image/bmp": ["bmp", "dib"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/dpx": ["dpx"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm", "jpgm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/jt": ["jt"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/prc": ["prc"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/u3d": ["u3d"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/javascript": ["js", "mjs"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["md", "markdown"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/wgsl": ["wgsl"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "*jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] };
Object.freeze(l0e);
var _u = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, np, Zg, ef;
class dBe {
  constructor(...t) {
    np.set(this, /* @__PURE__ */ new Map()), Zg.set(this, /* @__PURE__ */ new Map()), ef.set(this, /* @__PURE__ */ new Map());
    for (const r of t)
      this.define(r);
  }
  define(t, r = !1) {
    for (let [n, i] of Object.entries(t)) {
      n = n.toLowerCase(), i = i.map((u) => u.toLowerCase()), _u(this, ef, "f").has(n) || _u(this, ef, "f").set(n, /* @__PURE__ */ new Set());
      const o = _u(this, ef, "f").get(n);
      let a = !0;
      for (let u of i) {
        const s = u.startsWith("*");
        if (u = s ? u.slice(1) : u, o == null || o.add(u), a && _u(this, Zg, "f").set(n, u), a = !1, s)
          continue;
        const c = _u(this, np, "f").get(u);
        if (c && c != n && !r)
          throw new Error(`"${n} -> ${u}" conflicts with "${c} -> ${u}". Pass \`force=true\` to override this definition.`);
        _u(this, np, "f").set(u, n);
      }
    }
    return this;
  }
  getType(t) {
    if (typeof t != "string")
      return null;
    const r = t.replace(/^.*[/\\]/, "").toLowerCase(), n = r.replace(/^.*\./, "").toLowerCase(), i = r.length < t.length;
    return !(n.length < r.length - 1) && i ? null : _u(this, np, "f").get(n) ?? null;
  }
  getExtension(t) {
    var r;
    return typeof t != "string" ? null : (t = (r = t == null ? void 0 : t.split) == null ? void 0 : r.call(t, ";")[0], (t && _u(this, Zg, "f").get(t.trim().toLowerCase())) ?? null);
  }
  getAllExtensions(t) {
    return typeof t != "string" ? null : _u(this, ef, "f").get(t.toLowerCase()) ?? null;
  }
  _freeze() {
    this.define = () => {
      throw new Error("define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances");
    }, Object.freeze(this);
    for (const t of _u(this, ef, "f").values())
      Object.freeze(t);
    return this;
  }
  _getTestState() {
    return {
      types: _u(this, np, "f"),
      extensions: _u(this, Zg, "f")
    };
  }
}
np = /* @__PURE__ */ new WeakMap(), Zg = /* @__PURE__ */ new WeakMap(), ef = /* @__PURE__ */ new WeakMap();
const Mj = new dBe(l0e, c0e)._freeze();
var pBe = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message);
    Do(this, "issues");
    this.name = "ValiError", this.issues = t;
  }
};
function f0e(e, t, r, n, i) {
  return {
    issues: [{ context: e, reference: t, input: r, label: n, received: i }]
  };
}
function d0e(e) {
  return { output: e };
}
function kp(e, t) {
  return Array.isArray(e) ? [void 0, e] : [e, t];
}
var Au;
function p0e(e) {
  return {
    lang: (e == null ? void 0 : e.lang) ?? (Au == null ? void 0 : Au.lang),
    message: e == null ? void 0 : e.message,
    abortEarly: (e == null ? void 0 : e.abortEarly) ?? (Au == null ? void 0 : Au.abortEarly),
    abortPipeEarly: (e == null ? void 0 : e.abortPipeEarly) ?? (Au == null ? void 0 : Au.abortPipeEarly),
    skipPipe: (e == null ? void 0 : e.skipPipe) ?? (Au == null ? void 0 : Au.skipPipe)
  };
}
var zI;
function hBe(e) {
  return zI == null ? void 0 : zI.get(e);
}
var qI;
function vBe(e) {
  return qI == null ? void 0 : qI.get(e);
}
var YI;
function EBe(e, t) {
  var r;
  return (r = YI == null ? void 0 : YI.get(e)) == null ? void 0 : r.get(t);
}
function h0e(e, t, r, n, i) {
  const o = t.message ?? EBe(r, i.lang) ?? (e ? vBe(i.lang) : null) ?? (n == null ? void 0 : n.message) ?? hBe(i.lang) ?? i.message;
  return typeof o == "function" ? o(i) : o;
}
function VT(e, t, r) {
  return { typed: e, output: t, issues: r };
}
function gS(e) {
  let t = typeof e;
  return t === "object" && (t = e ? Object.getPrototypeOf(e).constructor.name : "null"), t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t;
}
function mBe(e, t, r) {
  const n = r.received ?? gS(r.input), i = {
    reason: e.type,
    context: r.context.type,
    expected: r.context.expects,
    received: n,
    message: `Invalid ${r.label}: ${r.context.expects ? `Expected ${r.context.expects} but r` : "R"}eceived ${n}`,
    input: r.input,
    requirement: r.context.requirement,
    path: r.path,
    lang: t == null ? void 0 : t.lang,
    abortEarly: t == null ? void 0 : t.abortEarly,
    abortPipeEarly: t == null ? void 0 : t.abortPipeEarly,
    skipPipe: t == null ? void 0 : t.skipPipe
  };
  return i.message = h0e(
    !1,
    r.context,
    r.reference,
    t,
    i
  ), i;
}
function Zl(e, t, r, n) {
  if (e.pipe && !(r != null && r.skipPipe))
    for (const i of e.pipe) {
      const o = i._parse(t);
      if (o.issues) {
        for (const a of o.issues) {
          const u = mBe(e, r, a);
          n ? n.push(u) : n = [u];
        }
        if (r != null && r.abortEarly || r != null && r.abortPipeEarly)
          break;
      } else
        t = o.output;
    }
  return VT(!0, t, n);
}
function gBe(e, t, r) {
  if (!e || typeof e == "object" && !Array.isArray(e)) {
    const [o, a] = kp(t, r);
    return [e, o, a];
  }
  const [n, i] = kp(
    e,
    t
  );
  return [void 0, n, i];
}
function Mp(e, t, r, n, i) {
  const o = gS(r), a = (i == null ? void 0 : i.expected) ?? e.expects, u = {
    reason: (i == null ? void 0 : i.reason) ?? "type",
    context: e.type,
    expected: a,
    received: o,
    message: `Invalid type: Expected ${a} but received ${o}`,
    input: r,
    path: i == null ? void 0 : i.path,
    issues: i == null ? void 0 : i.issues,
    lang: n == null ? void 0 : n.lang,
    abortEarly: n == null ? void 0 : n.abortEarly,
    abortPipeEarly: n == null ? void 0 : n.abortPipeEarly,
    skipPipe: n == null ? void 0 : n.skipPipe
  };
  return u.message = h0e(!0, e, t, n, u), { typed: !1, output: r, issues: [u] };
}
function TBe(e, t) {
  return typeof e.fallback == "function" ? e.fallback(t) : e.fallback;
}
function v0e(e, t) {
  return {
    ...e,
    fallback: t,
    _parse(r, n) {
      const i = e._parse(r, n);
      return i.issues ? VT(
        !0,
        TBe(this, { input: r, issues: i.issues })
      ) : i;
    }
  };
}
function yBe(e) {
  return typeof e.default == "function" ? e.default() : e.default;
}
function _Be(e) {
  return {
    type: "any",
    expects: "any",
    async: !1,
    pipe: e,
    _parse(t, r) {
      return Zl(this, t, r);
    }
  };
}
function Kb(e, t, r) {
  const [n, i] = kp(t, r);
  return {
    type: "array",
    expects: "Array",
    async: !1,
    item: e,
    message: n,
    pipe: i,
    _parse(o, a) {
      if (Array.isArray(o)) {
        let u = !0, s;
        const c = [];
        for (let l = 0; l < o.length; l++) {
          const f = o[l], d = this.item._parse(f, a);
          if (d.issues) {
            const p = {
              type: "array",
              origin: "value",
              input: o,
              key: l,
              value: f
            };
            for (const v of d.issues)
              v.path ? v.path.unshift(p) : v.path = [p], s == null || s.push(v);
            if (s || (s = d.issues), a != null && a.abortEarly) {
              u = !1;
              break;
            }
          }
          d.typed || (u = !1), c.push(d.output);
        }
        return u ? Zl(this, c, a, s) : VT(!1, c, s);
      }
      return Mp(this, Kb, o, a);
    }
  };
}
function Ul(e) {
  return {
    type: "lazy",
    expects: "unknown",
    async: !1,
    getter: e,
    _parse(t, r) {
      return this.getter(t)._parse(t, r);
    }
  };
}
function E0e(e, t) {
  const [r, n] = kp(e, t);
  return {
    type: "number",
    expects: "number",
    async: !1,
    message: r,
    pipe: n,
    _parse(i, o) {
      return typeof i == "number" && !isNaN(i) ? Zl(this, i, o) : Mp(this, E0e, i, o);
    }
  };
}
function m0e(e, t, r, n) {
  const [i, o, a] = gBe(t, r, n);
  let u;
  return {
    type: "object",
    expects: "Object",
    async: !1,
    entries: e,
    rest: i,
    message: o,
    pipe: a,
    _parse(s, c) {
      if (s && typeof s == "object") {
        u = u ?? Object.entries(this.entries);
        let l = !0, f;
        const d = {};
        for (const [p, v] of u) {
          const h = s[p], E = v._parse(h, c);
          if (E.issues) {
            const m = {
              type: "object",
              origin: "value",
              input: s,
              key: p,
              value: h
            };
            for (const g of E.issues)
              g.path ? g.path.unshift(m) : g.path = [m], f == null || f.push(g);
            if (f || (f = E.issues), c != null && c.abortEarly) {
              l = !1;
              break;
            }
          }
          E.typed || (l = !1), (E.output !== void 0 || p in s) && (d[p] = E.output);
        }
        if (this.rest && !(c != null && c.abortEarly && f)) {
          for (const p in s)
            if (!(p in this.entries)) {
              const v = s[p], h = this.rest._parse(v, c);
              if (h.issues) {
                const E = {
                  type: "object",
                  origin: "value",
                  input: s,
                  key: p,
                  value: v
                };
                for (const m of h.issues)
                  m.path ? m.path.unshift(E) : m.path = [E], f == null || f.push(m);
                if (f || (f = h.issues), c != null && c.abortEarly) {
                  l = !1;
                  break;
                }
              }
              h.typed || (l = !1), d[p] = h.output;
            }
        }
        return l ? Zl(
          this,
          d,
          c,
          f
        ) : VT(!1, d, f);
      }
      return Mp(this, m0e, s, c);
    }
  };
}
function dL(e, t) {
  return {
    type: "optional",
    expects: `${e.expects} | undefined`,
    async: !1,
    wrapped: e,
    default: t,
    _parse(r, n) {
      if (r === void 0) {
        const i = yBe(this);
        if (i === void 0)
          return VT(!0, r);
        r = i;
      }
      return this.wrapped._parse(r, n);
    }
  };
}
function Ci(e, t) {
  const [r, n] = kp(e, t);
  return {
    type: "string",
    expects: "string",
    async: !1,
    message: r,
    pipe: n,
    _parse(i, o) {
      return typeof i == "string" ? Zl(this, i, o) : Mp(this, Ci, i, o);
    }
  };
}
function Fj(e) {
  let t;
  if (e)
    for (const r of e)
      if (t)
        for (const n of r.issues)
          t.push(n);
      else
        t = r.issues;
  return t;
}
function Fp(e, t, r) {
  const [n, i] = kp(t, r);
  return {
    type: "union",
    expects: [...new Set(e.map((o) => o.expects))].join(" | "),
    async: !1,
    options: e,
    message: n,
    pipe: i,
    _parse(o, a) {
      let u, s, c;
      for (const l of this.options) {
        const f = l._parse(o, a);
        if (f.typed)
          if (f.issues)
            c ? c.push(f) : c = [f];
          else {
            u = f;
            break;
          }
        else
          s ? s.push(f) : s = [f];
      }
      if (u)
        return Zl(this, u.output, a);
      if (c != null && c.length) {
        const l = c[0];
        return Zl(
          this,
          l.output,
          a,
          // Hint: If there is more than one typed result, we use a general
          // union issue with subissues because the issues could contradict
          // each other.
          c.length === 1 ? l.issues : Mp(this, Fp, o, a, {
            reason: "union",
            issues: Fj(c)
          }).issues
        );
      }
      return (s == null ? void 0 : s.length) === 1 ? s[0] : Mp(this, Fp, o, a, {
        issues: Fj(s)
      });
    }
  };
}
function ABe(e) {
  return {
    type: "unknown",
    expects: "unknown",
    async: !1,
    pipe: e,
    _parse(t, r) {
      return Zl(this, t, r);
    }
  };
}
function _h(e, t, r) {
  const n = e._parse(t, p0e(r));
  if (n.issues)
    throw new pBe(n.issues);
  return n.output;
}
function SBe(e, t, r) {
  const n = e._parse(t, p0e(r));
  return {
    typed: n.typed,
    success: !n.issues,
    output: n.output,
    issues: n.issues
  };
}
function g0e(e, t, r) {
  return {
    ...e,
    _parse(n, i) {
      const o = e._parse(n, i);
      return o.issues ? o.typed = !1 : o.output = t(o.output, { issues: o.issues }), o;
    }
  };
}
function T0e(e, t) {
  return {
    type: "custom",
    expects: null,
    async: !1,
    message: t,
    requirement: e,
    _parse(r) {
      return this.requirement(r) ? d0e(r) : f0e(this, T0e, r, "input");
    }
  };
}
function dp(e, t) {
  return {
    type: "value",
    expects: `${e instanceof Date ? e.toJSON() : gS(e)}`,
    async: !1,
    message: t,
    requirement: e,
    _parse(r) {
      return r <= this.requirement && r >= this.requirement ? d0e(r) : f0e(
        this,
        dp,
        r,
        "value",
        r instanceof Date ? r.toJSON() : gS(r)
      );
    }
  };
}
var bBe = Object.defineProperty, y0e = (e, t) => {
  for (var r in t) bBe(e, r, { get: t[r], enumerable: !0 });
}, _0e = "WEB_CHAT/CLEAR_SUGGESTED_ACTIONS";
function CBe() {
  return { type: _0e };
}
var zc = "DIRECT_LINE/CONNECT", A0e = `${zc}_FULFILLED`, IBe = `${zc}_FULFILLING`, S0e = `${zc}_PENDING`, b0e = `${zc}_REJECTED`, C0e = `${zc}_STILL_PENDING`;
function OBe({ directLine: e, userID: t, username: r }) {
  return { type: zc, payload: { directLine: e, userID: t, username: r } };
}
var jT = "DIRECT_LINE/DISCONNECT", I0e = `${jT}_PENDING`, O0e = `${jT}_FULFILLED`;
function RBe() {
  return { type: jT };
}
var R0e = "WEB_CHAT/DISMISS_NOTIFICATION";
function wBe(e) {
  return { payload: { id: e }, type: R0e };
}
var PBe = wBe, w0e = "WEB_CHAT/EMIT_TYPING_INDICATOR";
function P0e() {
  return { type: w0e };
}
var fk = "WEB_CHAT/MARK_ACTIVITY";
function DBe({ id: e }, t, r) {
  return { type: fk, payload: { activityID: e, name: t, value: r } };
}
var dk = DBe, Zf = "DIRECT_LINE/POST_ACTIVITY", D0e = `${Zf}_FULFILLED`, x0e = `${Zf}_IMPEDED`, Qf = `${Zf}_PENDING`, pL = `${Zf}_REJECTED`;
function xBe(e, t = "keyboard") {
  return { type: Zf, meta: { method: t }, payload: { activity: e } };
}
var ed = xBe, N0e = "WEB_CHAT/SEND_EVENT";
function NBe(e, t) {
  return { type: N0e, payload: { name: e, value: t } };
}
var L0e = "WEB_CHAT/SEND_FILES";
function LBe(e) {
  return { type: L0e, payload: { files: e } };
}
var B0e = "WEB_CHAT/SEND_MESSAGE";
function pk(e, t, { attachments: r, channelData: n } = {}) {
  return { type: B0e, payload: { attachments: r, channelData: n, method: t, text: e } };
}
var k0e = "WEB_CHAT/SEND_MESSAGE_BACK";
function M0e(e, t, r) {
  return { type: k0e, payload: { displayText: r, text: t, value: e } };
}
var F0e = "WEB_CHAT/SEND_POST_BACK";
function H0e(e) {
  return { type: F0e, payload: { value: e } };
}
var $0e = "WEB_CHAT/SET_DICTATE_INTERIMS";
function BBe(e) {
  return { type: $0e, payload: { dictateInterims: e } };
}
var hk = "WEB_CHAT/SET_DICTATE_STATE";
function U0e(e) {
  return { type: hk, payload: { dictateState: e } };
}
var V0e = "WEB_CHAT/SET_LANGUAGE";
function kBe(e) {
  return { type: V0e, payload: { language: e } };
}
function vk() {
  return Mu().toString(36).substring(2);
}
var j0e = "WEB_CHAT/SET_NOTIFICATION";
function b4({ alt: e, data: t, id: r, level: n, message: i }) {
  return (!r || typeof r != "string") && (console.warn('botframework-webchat: The "id" argument passed to "setNotification" must be a string; defaulting to a random value.'), r = vk()), (!n || typeof n != "string") && (console.warn('botframework-webchat: The "level" argument passed to "setNotification" must be a string; defaulting to "info".'), n = "info"), { type: j0e, payload: { alt: e, data: t, id: r, level: n, message: i } };
}
var H1 = "WEB_CHAT/SET_SEND_BOX";
function z0e(e) {
  return { type: H1, payload: { text: e } };
}
var q0e = "WEB_CHAT/SET_SEND_BOX_ATTACHMENTS";
function Y0e(e) {
  return { type: q0e, payload: { attachments: e } };
}
var G0e = "WEB_CHAT/SET_SEND_TIMEOUT";
function MBe(e) {
  return { type: G0e, payload: { sendTimeout: e } };
}
var Ek = "WEB_CHAT/SET_SEND_TYPING_INDICATOR";
function FBe(e) {
  return { payload: { sendTypingIndicator: !!e }, type: Ek };
}
var W0e = "WEB_CHAT/START_DICTATE";
function K0e() {
  return { type: W0e };
}
var X0e = "WEB_CHAT/START_SPEAKING";
function J0e() {
  return { type: X0e };
}
var Z0e = "WEB_CHAT/STOP_DICTATE";
function mk() {
  return { type: Z0e };
}
var gk = "WEB_CHAT/STOP_SPEAKING";
function Q0e() {
  return { type: gk };
}
var efe = "WEB_CHAT/SUBMIT_SEND_BOX";
function HBe(e = "keyboard", { channelData: t } = {}) {
  return { type: efe, payload: { channelData: t, method: e } };
}
var tfe = {};
y0e(tfe, { SENDING: () => UBe, SEND_FAILED: () => $Be, SENT: () => VBe });
var $Be = "send failed", UBe = "sending", VBe = "sent", rfe = {};
y0e(rfe, { DICTATING: () => YBe, IDLE: () => jBe, STARTING: () => qBe, STOPPING: () => GBe, WILL_START: () => zBe });
var jBe = 0, zBe = 1, qBe = 2, YBe = 3, GBe = 4, zT = "DIRECT_LINE/RECONNECT", nfe = `${zT}_FULFILLED`, WBe = `${zT}_FULFILLING`, Tk = `${zT}_PENDING`, KBe = `${zT}_REJECTED`, yk = "WEB_CHAT/SAGA_ERROR";
function XBe() {
  return { type: yk };
}
var JBe = "uninitialized";
function ZBe(e = JBe, { type: t, meta: r }) {
  if (e !== "sagaerror") switch (t) {
    case S0e:
    case Tk:
      e !== "uninitialized" && (e = "reconnecting");
      break;
    case A0e:
      e = "connected";
      break;
    case nfe:
      e = "reconnected";
      break;
    case b0e:
      e = "error";
      break;
    case C0e:
      e = "connectingslow";
      break;
    case O0e:
      e = r && r.error ? "error" : "notconnected";
      break;
    case yk:
      e = "sagaerror";
      break;
  }
  return e;
}
var QBe = "DIRECT_LINE/DELETE_ACTIVITY", Ah = "DIRECT_LINE/INCOMING_ACTIVITY";
function e8e(e) {
  return { type: Ah, payload: { activity: e } };
}
var t8e = e8e, GI = "sending", U_ = "send failed", V_ = "sent";
function r8e(e, t) {
  let r, n = "unknown";
  for (let i = 0; i < e.length; i++) {
    let o = e[+i], a = t(o);
    if ((n === "before" || n === "unknown") && a === "after" || n === "before" && (a === "after" || a === "unknown")) return [r, o, i];
    r = o, n = a;
  }
  return n === "before" ? [r, void 0, e.length] : [void 0, void 0, void 0];
}
var n8e = [], i8e = "https://docs.botframework.com/static/devportal/client/images/bot-framework-default-placeholder.png";
function hL(e) {
  var t;
  return (t = e.channelData) == null ? void 0 : t.clientActivityID;
}
function WI(e) {
  return (t) => hL(t) === e;
}
function o8e(e) {
  return e.type === "typing" && "text" in e && typeof e.text == "string";
}
function ife(e, t, { Date: r }) {
  var i;
  e = Xr(e, ["attachments", () => !0, "contentUrl"], (o) => {
    if (o !== i8e && !/^blob:/iu.test(o)) return o;
  }), e = Xr(e, ["channelData"], (o) => ({ ...o })), e = Xr(e, ["channelData", "webChat", "receivedAt"], () => r.now());
  let { channelData: { "webchat:sequence-id": n } } = e;
  if (typeof n != "number") {
    let o, a;
    o8e(e) && typeof e.channelData.streamSequence == "number" && ([a, o] = r8e(t, (s) => s.type === "typing" && s.channelData.streamId === e.channelData.streamId ? s.channelData.streamSequence < e.channelData.streamSequence ? "before" : "after" : "unknown"));
    let u;
    a ? u = a.channelData["webchat:sequence-id"] + 1e-3 : o ? u = o.channelData["webchat:sequence-id"] - 1e-3 : typeof e.timestamp < "u" ? u = +new r(e.timestamp) : u = (((i = t[t.length - 1]) == null ? void 0 : i.channelData["webchat:sequence-id"]) || 0) + 1e-3, e = Xr(e, ["channelData", "webchat:sequence-id"], () => u);
  }
  return e;
}
function Hj(e, t, r) {
  t = ife(t, e, r);
  let { channelData: { clientActivityID: n, "webchat:sequence-id": i } = {} } = t, o = e.filter(({ channelData: { clientActivityID: u } = {}, id: s }) => !(n && u === n) && !(s && s === t.id)), a = o.findIndex(({ channelData: { "webchat:sequence-id": u } = {} }) => (u || 0) > (i || 0));
  return o.splice(~a ? a : o.length, 0, t), o;
}
function a8e(e) {
  return function(t = n8e, r) {
    switch (r.type) {
      case QBe:
        t = Xr(t, [({ id: n }) => n === r.payload.activityID]);
        break;
      case fk:
        {
          let { payload: n } = r;
          t = Xr(t, [({ id: i }) => i === n.activityID, "channelData", n.name], () => n.value);
        }
        break;
      case Qf:
        {
          let { payload: { activity: n } } = r;
          n = Xr(n, ["channelData", "state"], () => GI), n = Xr(n, ["channelData", "webchat:send-status"], () => GI), t = Hj(t, n, e);
        }
        break;
      case x0e:
        t = Xr(t, [WI(r.meta.clientActivityID), "channelData", "state"], () => U_);
        break;
      case pL:
        t = Xr(t, [WI(r.meta.clientActivityID)], (n) => (n = Xr(n, ["channelData", "state"], () => U_), Xr(n, ["channelData", "webchat:send-status"], () => U_)));
        break;
      case D0e:
        {
          let n = Xr(Xr(ife(r.payload.activity, t, e), ["channelData", "state"], () => V_), ["channelData", "webchat:send-status"], () => V_);
          t = Xr(t, [WI(r.meta.clientActivityID)], () => n);
        }
        break;
      case Ah:
        {
          let { payload: { activity: n } } = r;
          if (n.from.role === "user") {
            let { id: i } = n, o = hL(n), a = t.find((u) => o && hL(u) === o || i && u.id === i);
            if (a) {
              let { channelData: { "webchat:send-status": u } } = a;
              (u === GI || u === U_ || u === V_) && (n = Xr(n, ["channelData", "webchat:send-status"], () => u));
            } else n = Xr(n, ["channelData", "webchat:send-status"], () => V_);
          }
          t = Hj(t, n, e);
        }
        break;
    }
    return t;
  };
}
function u8e(e) {
  return () => ({ ponyfill: e });
}
var $j;
function s8e() {
  return $j || ($j = Object.freeze(Array.from(/* @__PURE__ */ new Set([...Object.getOwnPropertyNames(Object.prototype), "prototype"]))));
}
function ia(e) {
  return s8e().includes(e);
}
var c8e = {};
function l8e({ Date: e }) {
  return function(t = c8e, r) {
    let { type: n } = r, i = e.now();
    if (n === R0e) t = Xr(t, [r.payload.id]);
    else if (n === yk) t = Xr(t, ["connectivitystatus", "message"], () => "javascripterror");
    else if (n === j0e) {
      let { alt: o, data: a, id: u, level: s, message: c } = r.payload;
      if (!ia(u)) {
        let l = t[u];
        (!l || o !== l.alt || !Object.is(a, l.data) || s !== l.level || c !== l.message) && (t = Xr(t, [u], () => ({ alt: o, data: a, id: u, level: s, message: c, timestamp: i })));
      }
    }
    return t;
  };
}
var f8e = {};
function d8e({ Date: e }) {
  return function(t = f8e, { payload: r, type: n }) {
    if (n === Ah || n === Qf) {
      let { activity: { from: { id: i, name: o, role: a }, type: u } } = r;
      if (u === "typing") {
        let s = e.now();
        t = Xr(t, [i, "at"], (c) => c || s), t = Xr(t, [i, "last"], () => s), t = Xr(t, [i, "name"], () => o), t = Xr(t, [i, "role"], () => a);
      } else u === "message" && (t = Xr(t, [i]));
    }
    return t;
  };
}
var p8e = [];
function h8e(e = p8e, { payload: t, type: r }) {
  switch (r) {
    case $0e:
      e = t.dictateInterims;
      break;
  }
  return e;
}
var v8e = 0;
function E8e(e = v8e, { payload: t, type: r }) {
  switch (r) {
    case hk:
      e = t.dictateState;
      break;
    case W0e:
      (e === 0 || e === 4 || e === 1) && (e = 2);
      break;
    case Z0e:
      e === 2 || e === 3 ? e = 4 : e === 1 && (e = 0);
      break;
  }
  return e;
}
var m8e = "en-US";
function g8e(e = m8e, { payload: t, type: r }) {
  switch (r) {
    case V0e:
      e = t.language;
      break;
  }
  return e;
}
var ofe = "DIRECT_LINE/CONNECTION_STATUS_UPDATE";
function T8e(e) {
  return { type: ofe, payload: { connectionStatus: e } };
}
var y8e = 0;
function _8e(e = y8e, { payload: t, type: r }) {
  switch (r) {
    case ofe:
      e = t.connectionStatus;
      break;
  }
  return e;
}
var afe = "WEB_CHAT/SET_REFERENCE_GRAMMAR_ID";
function A8e(e) {
  return { type: afe, payload: { referenceGrammarID: e } };
}
var S8e = null;
function b8e(e = S8e, { payload: t, type: r }) {
  switch (r) {
    case afe:
      e = t.referenceGrammarID || null;
      break;
  }
  return e;
}
var C8e = Object.freeze([]);
function I8e(e = C8e, { payload: t, type: r }) {
  switch (r) {
    case q0e:
      e = t.attachments;
      break;
  }
  return e;
}
var O8e = "";
function R8e(e = O8e, { payload: t, type: r }) {
  switch (r) {
    case H1:
      e = t.text;
      break;
  }
  return e;
}
var w8e = 2e4;
function P8e(e = w8e, { payload: t, type: r }) {
  switch (r) {
    case G0e:
      e = t.sendTimeout;
      break;
  }
  return e;
}
var D8e = !1;
function x8e(e = D8e, { payload: t, type: r }) {
  switch (r) {
    case Ek:
      e = t.sendTypingIndicator;
      break;
  }
  return e;
}
function N8e(e = !1, { type: t }) {
  switch (t) {
    case X0e:
      e = !0;
      break;
    case gk:
      e = !1;
      break;
  }
  return e;
}
var L8e = [], ufe = "WEB_CHAT/SET_SUGGESTED_ACTIONS";
function sfe(e = L8e) {
  return { type: ufe, payload: { suggestedActions: e } };
}
var KI = [];
function B8e(e = KI, { payload: t = {}, type: r }) {
  switch (r) {
    case ufe:
      (t.suggestedActions || []).length ? e = [].slice.call(t.suggestedActions) : e = KI;
      break;
    case _0e:
      e = KI;
      break;
  }
  return e;
}
function k8e(e) {
  return GIe({ activities: a8e(e), connectivityStatus: ZBe, dictateInterims: h8e, dictateState: E8e, internal: u8e(e), language: g8e, notifications: l8e(e), readyState: _8e, referenceGrammarID: b8e, sendBoxAttachments: I8e, sendBoxValue: R8e, sendTimeout: P8e, sendTypingIndicator: x8e, shouldSpeakIncomingActivity: N8e, suggestedActions: B8e, typing: d8e(e) });
}
function qo(e, ...t) {
  return So(function* () {
    for (; ; ) {
      let { meta: { userID: r, username: n }, payload: { directLine: i } } = yield Uo([IBe, WBe]), o = yield Rn(e, { directLine: i, userID: r, username: n }, ...t);
      yield Uo([I0e, Tk]), yield Lb(o);
    }
  });
}
function* M8e() {
  yield an(sfe());
}
function* F8e() {
  yield oa(({ payload: e, type: t }) => t === Qf && e.activity.type === "message", M8e);
}
function* H8e() {
  yield qo(F8e);
}
function _k() {
  let e, t = [];
  return { push: (r) => {
    if (e) {
      let { resolve: n } = e;
      e = null, n(r);
    } else t.push(r);
  }, shift: () => t.length ? Promise.resolve(t.shift()) : (e || (e = F1())).promise };
}
var XI = "connectivitystatus";
function $8e(e) {
  let { push: t, shift: r } = _k(), n = e.subscribe({ next: t });
  return { shift: r, unsubscribe() {
    n.unsubscribe();
  } };
}
function* U8e({ payload: { directLine: e } }) {
  let { shift: t, unsubscribe: r } = $8e(e.connectionStatus$);
  try {
    let n;
    for (; ; ) switch (yield So(t)) {
      case 0:
      case 1:
        yield an(b4({ id: XI, level: "info", message: n ? "reconnecting" : "connecting" }));
        break;
      case 2:
        n = 1, yield an(b4({ id: XI, level: "success", message: "connected" }));
        break;
      case 3:
      case 4:
        n = 1, yield an(b4({ id: XI, level: "error", message: "failedtoconnect" }));
        break;
      default:
        break;
    }
  } finally {
    r();
  }
}
function* V8e() {
  yield z8(zc, U8e);
}
function cfe(e, t) {
  return So(function* () {
    let r = _k(), n = e.subscribe({ next: r.push });
    try {
      for (; ; ) {
        let i = yield So(r.shift);
        yield So(t, i);
      }
    } finally {
      n.unsubscribe();
    }
  });
}
function* j8e({ directLine: e }) {
  yield cfe(e.connectionStatus$, function* (t) {
    yield an(T8e(t)), yield an(A8e(e.referenceGrammarId));
  });
}
function* z8e() {
  yield qo(j8e);
}
function C4(...e) {
  return Rn(function* () {
    for (let t of e) yield an(t);
  });
}
var Xb = "DIRECT_LINE/UPDATE_CONNECTION_STATUS";
function q8e(e) {
  return { type: Xb, payload: { connectionStatus: e } };
}
var Ak = 1, Sk = 2, Y8e = 0;
function JI() {
  return `r_${vk().substring(0, 10)}`;
}
function* G8e(e) {
  let t = _k(), r = e.connectionStatus$.subscribe({ next: t.push });
  try {
    for (; ; ) {
      let n = yield So(t.shift);
      yield an(q8e(n));
    }
  } finally {
    r.unsubscribe();
  }
}
function W8e(e, t) {
  let { token: r } = e, n;
  try {
    n = (fBe(r) || {}).user;
  } catch {
  }
  let i = { fromAction: t, fromToken: n };
  return n ? (t && t !== n && console.warn("Web Chat: user ID is both specified in the Direct Line token and passed in, will use the user ID from the token."), i.final = n) : t ? typeof t != "string" ? (console.warn("Web Chat: user ID must be a string."), i.final = JI()) : /^dl_/u.test(t) ? (console.warn('Web Chat: user ID prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.'), i.final = JI()) : i.final = t : i.final = JI(), i;
}
function* K8e(e) {
  let t = e.activity$.subscribe({ next: () => 0 }), r = t.unsubscribe.bind(t);
  try {
    for (; ; ) {
      let { payload: { connectionStatus: n } } = yield Uo(Xb);
      if (n === Sk) return () => {
        r(), e.end();
      };
      if (n !== Y8e && n !== Ak) throw new Error(`Failed to connect, DirectLineJS returned ${n}.`);
    }
  } catch (n) {
    throw r(), n;
  } finally {
    (yield F8()) && r();
  }
}
function* X8e() {
  for (; ; ) {
    let { payload: { connectionStatus: e } } = yield Uo(Xb);
    if (e === Sk) break;
    if (e !== Ak) throw new Error(`Failed to reconnect. DirectLineJS returned ${e}.`);
  }
}
function* J8e({ type: e, meta: t, payload: r }, n) {
  try {
    yield C4({ type: `${e}_PENDING`, meta: t, payload: r });
    let i = yield n();
    return yield C4({ type: `${e}_FULFILLING`, meta: t, payload: r }, { type: `${e}_FULFILLED`, meta: t, payload: r }), i;
  } catch (i) {
    throw yield C4({ type: `${e}_REJECTED`, error: !0, meta: t, payload: i }), i;
  }
}
function* Z8e() {
  throw yield Uo(jT), new Error("disconnected");
}
function Uj(e, t) {
  return J8e(e, function* () {
    let { result: r } = yield OT({ _: Z8e(), result: t() });
    return r;
  });
}
function* Q8e() {
  for (; ; ) {
    let { payload: { directLine: e, userID: t, username: r } } = yield Uo(zc), n = yield Rn(G8e, e), i = W8e(e, t), o = { userID: i.final, username: r };
    e.setUserId && i.fromToken !== o.userID && e.setUserId(o.userID);
    let a;
    try {
      let u = yield Uj({ type: zc, meta: o, payload: { directLine: e } }, () => So(K8e, e));
      try {
        for (; ; ) {
          let { updateConnectionStatusAction: { payload: { connectionStatus: s } = {} } = {} } = yield OT({ _: Uo(jT), updateConnectionStatusAction: Uo(Xb) });
          if (s === Ak) yield Uj({ type: zT, meta: o, payload: { directLine: e } }, () => So(X8e));
          else if (s !== Sk) {
            if (typeof s < "u") throw new Error(`Connection status changed to ${s}`);
            break;
          }
        }
      } finally {
        u();
      }
    } catch (u) {
      a = { error: u };
    } finally {
      yield Lb(n), yield C4({ type: I0e, meta: a, payload: { directLine: e } }, { type: O0e, meta: a, payload: { directLine: e } });
    }
  }
}
function $1(e, t) {
  return new Promise((r) => t.setTimeout(r, Math.max(e, 0)));
}
var eke = 15e3;
function* tke(e) {
  for (; ; ) yield Uo([S0e, Tk]), "slow" in (yield OT({ fulfilled: Uo([A0e, nfe]), rejected: Uo([b0e, KBe]), slow: So($1, eke, e) })) && (yield an({ type: C0e }));
}
function* rke() {
  yield an(ed({ type: "typing" }));
}
function* nke() {
  yield oa(({ type: e }) => e === w0e, rke);
}
function* ike() {
  yield qo(nke);
}
var lfe = ({ activities: e }) => e, bk = (e) => (t) => lfe(t).filter(e), oke = (e) => bk(({ type: t }) => t === e), ffe = lfe;
function dfe(e) {
  var t;
  return (t = e.channelData) == null ? void 0 : t.speak;
}
function* ake() {
  let e = yield Bu(bk(dfe));
  for (let t of e) yield an(dk(t, "speak", !1));
}
function* uke() {
  yield oa(gk, ake);
}
var pfe = "DIRECT_LINE/QUEUE_INCOMING_ACTIVITY";
function ske(e) {
  return { type: pfe, payload: { activity: e } };
}
var cke = (e) => e;
function lke(e, t) {
  return e.from ? e.from.role || (e.from.id === t ? e = Xr(e, ["from", "role"], () => "user") : e.from.id ? e = Xr(e, ["from", "role"], () => "bot") : e = Xr(e, ["from", "role"], () => "channel")) : e = Xr(e, ["from", "role"], () => "channel"), e;
}
function fke(e) {
  return ["attachmentLayout", "attachments", "channelData", "conversation", "entities", "from", "inputHint", "locale", "name", "recipient", "speak", "suggestedActions", "text", "textFormat", "timestamp", "type"].reduce((t, r) => {
    let { [r]: n } = t;
    return Xr(t, [r], typeof n > "u" || n === null ? void 0 : cke);
  }, e);
}
function dke(e) {
  return Xr(e, ["from", "name"], (t) => {
    let { channelId: r, from: n = {} } = e;
    return (r === "directline" || r === "webchat") && n.id === n.name && n.role === "bot" ? "Bot" : t;
  });
}
function* pke({ directLine: e, userID: t }) {
  yield cfe(e.activity$, function* (r) {
    r = fke(r), r = lke(r, t), r = dke(r), yield an(ske(r));
  });
}
function* hke() {
  yield qo(pke);
}
function Cl(e, t = 2) {
  if (typeof e != "number") throw new Error("First argument must be a number");
  let r = e + "";
  for (; r.length < t; ) r = "0" + r;
  return r;
}
function vke(e) {
  if (!(e.getTimezoneOffset && e.getFullYear && e.getMonth && e.getDate && e.getHours && e.getMinutes && e.getSeconds && e.getMilliseconds)) throw new Error("First argument must be a Date-like object.");
  let t = -e.getTimezoneOffset(), r = t < 0 ? "-" : "+", n = ~~Math.abs(t);
  return `${e.getFullYear()}-${Cl(e.getMonth() + 1)}-${Cl(e.getDate())}T${Cl(e.getHours())}:${Cl(e.getMinutes())}:${Cl(e.getSeconds())}.${Cl(e.getMilliseconds(), 3)}${t ? `${r}${Cl(~~(n / 60))}:${Cl(n % 60)}` : "Z"}`;
}
function Vj(e, ...t) {
  if (!e) return e;
  let r = { ...e };
  for (let n of t) (typeof n != "string" || !ia(n)) && delete r[n];
  return r;
}
var Eke = ({ language: e }) => e;
function mke(e) {
  return So(function* () {
    let t;
    try {
      return yield So(() => new Promise((r, n) => {
        t = e.subscribe({ complete: r, error: n, next: r });
      }));
    } finally {
      t && t.unsubscribe();
    }
  });
}
var gke = ({ sendTimeout: e }) => e, Tke = 3e5;
function* yke(e, t, r, n, { meta: { method: i }, payload: { activity: o } }, a) {
  let u = o.type === "message" && o.attachments || [], s = vk(), c = yield Bu(Eke), l = typeof window.Intl > "u" ? void 0 : new Intl.DateTimeFormat().resolvedOptions().timeZone, f = new a.Date(), d = { ...Vj(o, "id"), channelData: { ...Vj(o.channelData, "state", "webchat:send-status"), clientActivityID: s }, channelId: "webchat", from: { id: t, name: r, role: "user" }, locale: c, localTimestamp: vke(f), localTimezone: l, ...o.type === "message" ? { attachments: u && u.map(({ contentType: h, contentUrl: E, name: m, thumbnailUrl: g }) => ({ contentType: h, contentUrl: E, name: m, thumbnailUrl: g })), text: o.text } : o.type === "event" ? { name: o.name, value: o.value } : {} };
  n || (d.entities = [...d.entities || [], { requiresBotState: !0, supportsListening: !0, supportsTts: !0, type: "ClientCapabilities" }]);
  let p = { clientActivityID: s, method: i };
  yield an({ type: Qf, meta: p, payload: { activity: d } });
  let v;
  try {
    let h = So(function* () {
      var g;
      for (; ; ) {
        let { payload: { activity: y } } = yield Uo(Ah);
        if (((g = y.channelData) == null ? void 0 : g.clientActivityID) === s && y.id) return v = !0, y;
      }
    }), E = yield Bu(gke), { send: { echoBack: m } } = yield OT({ send: HOe({ echoBack: h, postActivity: mke(e.postActivity(d)) }), timeout: So(function* () {
      throw yield So($1, E, a), yield an({ type: x0e, meta: p, payload: { activity: d } }), yield So($1, Tke - E, a), v ? new Error("timed out while waiting for postActivity to return any values") : new Error("timed out while waiting for outgoing message to echo back");
    }) });
    yield an({ type: D0e, meta: p, payload: { activity: m } });
  } catch (h) {
    console.error("botframework-webchat: Failed to post activity to chat adapter.", h), yield an({ type: pL, error: !0, meta: p, payload: h });
  } finally {
    (yield F8()) && (yield an({ type: pL, error: !0, meta: p, payload: new Error("cancelled") }));
  }
}
function* _ke(e) {
  yield qo(function* ({ directLine: t, userID: r, username: n }) {
    let i = 0;
    yield oa(Zf, function* (o) {
      yield* yke(t, r, n, i++, o, e);
    });
  });
}
var Ake = (e) => e && e.from.role === "bot", Ske = 5e3;
function* bke(e, t, r) {
  for (; !(yield F8()); ) {
    let n = yield Uo(e), i = yield Bu(t);
    yield Rn(r, n, i);
  }
}
function* Cke(e, t) {
  let r = t;
  for (; !r.find((n) => n.id === e || n.replyToId === e); ) {
    let { payload: { activity: n } } = yield Uo(Ah);
    if (n.id === e) break;
    r = yield Bu(ffe);
  }
}
function* Ike({ userID: e }, t) {
  yield bke(pfe, ffe, function* ({ payload: { activity: r } }, n) {
    let { replyToId: i } = r, o = n.filter(({ from: { role: s } }) => s === "bot");
    i && o.length && "timeout" in (yield OT({ _: Cke(i, n), timeout: So($1, Ske, t) })) && console.warn(`botframework-webchat: Timed out while waiting for activity "${i}" which activity "${r.id}" is replying to.`, { activity: r, replyToId: i }), yield an(t8e(r));
    let a = yield Bu(oke("message")), u = a[a.length - 1];
    if (Ake(u)) {
      let { suggestedActions: { actions: s, to: c } = { actions: void 0, to: void 0 } } = u;
      yield an(sfe(c != null && c.length && !c.includes(e) ? null : s));
    }
  });
}
function* Oke(e) {
  yield qo(Ike, e);
}
function* Rke({ payload: { name: e, value: t } }) {
  yield an(ed({ name: e, type: "event", value: t }));
}
function* wke() {
  yield oa(({ payload: e, type: t }) => t === N0e && e.name, Rke);
}
function* Pke() {
  yield qo(wke);
}
var Dke = Mj.getType.bind(Mj);
function* xke({ payload: { files: e } }) {
  yield an(ed({ attachments: [].map.call(e, ({ name: t, thumbnail: r, url: n }) => ({ contentType: Dke(t) || "application/octet-stream", contentUrl: n, name: t, thumbnailUrl: r })), channelData: { attachmentSizes: [].map.call(e, ({ size: t }) => t) }, type: "message" }));
}
function* Nke() {
  yield oa(({ payload: e, type: t }) => t === L0e && e.files.length, xke);
}
function* Lke() {
  yield qo(Nke);
}
function* Bke({ payload: { displayText: e, text: t, value: r } }) {
  yield an(ed({ channelData: { messageBack: { displayText: e } }, text: t, type: "message", value: r }));
}
function* kke() {
  yield oa(k0e, Bke);
}
function* Mke() {
  yield qo(kke);
}
function* Fke({ payload: { attachments: e = [], channelData: t, method: r, text: n } }) {
  yield an(ed({ attachments: e.map(({ blob: i, thumbnailURL: o }) => ({ contentType: i instanceof File && i.type || "application/octet-stream", contentUrl: URL.createObjectURL(i), name: i instanceof File ? i.name : void 0, thumbnailUrl: o == null ? void 0 : o.toString() })), channelData: { ...t, attachmentSizes: e.map(({ blob: { size: i } }) => i) }, text: n || void 0, textFormat: "plain", type: "message" }, r));
}
function* Hke() {
  yield oa(({ payload: e, type: t }) => {
    var r;
    return t === B0e && (e.text || ((r = e.attachments) == null ? void 0 : r.length));
  }, Fke);
}
function* $ke() {
  yield qo(Hke);
}
function* Uke({ payload: { value: e } }) {
  yield an(ed({ channelData: { postBack: !0 }, text: typeof e == "string" ? e : void 0, type: "message", value: typeof e != "string" ? e : void 0 }));
}
function* Vke() {
  yield oa(F0e, Uke);
}
function* jke() {
  yield qo(Vke);
}
var zke = ({ sendTypingIndicator: e }) => e, qke = 3e3;
function ZI(e) {
  return Uo(({ payload: t, type: r }) => r === Ek && !t.sendTypingIndicator == !e);
}
function* Yke(e, t) {
  let { Date: r } = t;
  for ((yield Bu(zke)) || (yield ZI(!0)); ; ) {
    let n = -1 / 0, i = yield z8(({ payload: o, type: a }) => a === H1 && o.text || a === Zf && o.activity.type !== "typing", function* ({ payload: o, type: a }) {
      if (a === H1) {
        let u = qke - r.now() + n;
        u > 0 && (yield So($1, u, t)), yield an(P0e()), n = r.now();
      } else o.activity.type === "message" && (n = -1 / 0);
    });
    yield ZI(!1), yield Lb(i), yield ZI(!0);
  }
}
function* Gke(e) {
  yield qo(Yke, e);
}
var Wke = ({ shouldSpeakIncomingActivity: e }) => e;
function Kke(e) {
  return e && e.from && e.type === "message";
}
function* Xke({ userID: e }) {
  yield oa(({ payload: t, type: r }) => r === Ah && t.activity.from.id !== e && t.activity.from.role !== "user", function* ({ payload: { activity: t } }) {
    let r = yield Bu(Wke), n = Kke(t) && r;
    n && (t.speak || t.text || ~(t.attachments || []).findIndex(({ content: { speak: i } = {} }) => i)) && (yield an(dk(t, "speak", !0))), n && t.inputHint === "expectingInput" ? yield an(U0e(1)) : t.inputHint === "ignoringInput" && (yield an(mk()));
  });
}
function* Jke() {
  yield qo(Xke);
}
var Zke = ({ dictateState: e }) => e;
function* Qke() {
  let e = yield Bu(bk(dfe));
  (yield Bu(Zke)) === 1 && !e.length && (yield an(K0e()));
}
function* e9e() {
  yield oa(({ type: e }) => e === fk || e === hk, Qke);
}
function* t9e() {
  yield oa(({ meta: e, payload: t, type: r }) => r === Qf && e.method === "speech" && t.activity.type === "message", function* () {
    yield an(J0e());
  });
}
function* r9e() {
  yield qo(t9e);
}
function* n9e() {
  yield oa(({ payload: e, type: t }) => t === Qf && e.activity.type === "message", function* () {
    yield an(mk());
  });
}
function* i9e() {
  yield qo(n9e);
}
function* o9e() {
  yield oa(({ meta: e, payload: t, type: r }) => r === H1 && t.text || r === Qf && e.method !== "speech" && t.activity.type === "message", function* () {
    yield an(Q0e());
  });
}
function* a9e() {
  yield qo(o9e);
}
function u9e({ sendBoxAttachments: e }) {
  return e;
}
var s9e = ({ sendBoxValue: e }) => e;
function* c9e() {
  yield oa(efe, function* ({ payload: { channelData: e, method: t } }) {
    let r = yield Bu(u9e), n = yield Bu(s9e);
    (r.length || n) && (yield an(pk(n.trim(), t, { attachments: r, channelData: e })), yield an(z0e("")), yield an(Y0e(Object.freeze([]))));
  });
}
function* l9e() {
  yield qo(c9e);
}
function f9e({ ponyfill: e }) {
  return function* () {
    yield Rn(H8e), yield Rn(V8e), yield Rn(z8e), yield Rn(Q8e), yield Rn(tke, e), yield Rn(ike), yield Rn(uke), yield Rn(hke), yield Rn(_ke, e), yield Rn(Oke, e), yield Rn(Pke), yield Rn(Lke), yield Rn(Mke), yield Rn($ke), yield Rn(jke), yield Rn(Gke, e), yield Rn(Jke), yield Rn(e9e), yield Rn(r9e), yield Rn(i9e), yield Rn(a9e), yield Rn(l9e);
  };
}
function d9e(e, ...t) {
  let r = SRe({ onError: (...n) => {
    let [i] = n;
    console.error(i);
    let o = e();
    o && o.dispatch(XBe());
  } });
  return { enhancer: KIe(...t, r), sagaMiddleware: r };
}
function Ck(e, t, ...r) {
  let n = typeof globalThis > "u" ? window : globalThis, i = e.ponyfill || {}, o = { cancelAnimationFrame: i.cancelAnimationFrame || (typeof cancelAnimationFrame == "function" ? cancelAnimationFrame.bind(n) : void 0), cancelIdleCallback: i.cancelIdleCallback || (typeof cancelIdleCallback == "function" ? cancelIdleCallback.bind(n) : void 0), clearImmediate: i.clearImmediate || (typeof clearImmediate == "function" ? clearImmediate.bind(n) : void 0), clearInterval: i.clearInterval || (typeof clearInterval == "function" ? clearInterval.bind(n) : void 0), clearTimeout: i.clearTimeout || (typeof clearTimeout == "function" ? clearTimeout.bind(n) : void 0), Date: i.Date || Date, requestAnimationFrame: i.requestAnimationFrame || (typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(n) : void 0), requestIdleCallback: i.requestIdleCallback || (typeof requestIdleCallback == "function" ? requestIdleCallback.bind(n) : void 0), setImmediate: i.setImmediate || (typeof setImmediate == "function" ? setImmediate.bind(n) : void 0), setInterval: i.setInterval || (typeof setInterval == "function" ? setInterval.bind(n) : void 0), setTimeout: i.setTimeout || (typeof setTimeout == "function" ? setTimeout.bind(n) : void 0) }, { enhancer: a, sagaMiddleware: u } = d9e(() => s, ...r), s = Qse(k8e(o), t || {}, e.devTools ? cOe(a) : a);
  return u.run(f9e({ ponyfill: o })), s;
}
function hfe(e, ...t) {
  return Ck({}, e, ...t);
}
var p9e = (e) => v0e(dL(Fp([g0e(Kb(e), (t) => t[0]), e])), void 0), lo = p9e, h9e = (e) => v0e(g0e(Kb(e), (t) => t.filter((r) => typeof r < "u")), (t) => t != null && t.input ? [_h(e, t == null ? void 0 : t.input)] : void 0);
function I4(e) {
  return h9e(lo(e));
}
var v9e = { "@context": dL(Ci([dp("https://schema.org")])), "@id": dL(Ci()), "@type": Ci(), additionalType: lo(Ci()), alternateName: lo(Ci()), description: lo(Ci()), name: lo(Ci()), potentialAction: I4(Ul(() => Ik())), url: lo(Ci()) }, qT = (e) => m0e({ ...v9e, ...e }, ABe()), E9e = (e) => _h(qT(), e), vfe = (e) => qT({ slogan: lo(Ci()), ...e }), Ik = (e) => qT({ actionStatus: lo(Fp([Ci([dp("ActiveActionStatus")]), Ci([dp("CompletedActionStatus")]), Ci([dp("FailedActionStatus")]), Ci([dp("PotentialActionStatus")])])), provider: lo(Ul(() => vfe())), ...e }), jj = (e) => _h(Ik(), e), zj = (e) => qT({ inDefinedTermSet: lo(Ci()), termCode: lo(Ci()), ...e }), U1 = (e) => qT({ abstract: lo(Ci()), author: I4(Ci()), citation: I4(Ul(() => U1())), keywords: I4(Fp([Ul(() => zj()), Ci()])), pattern: lo(Ul(() => zj())), text: lo(Ci()), usageInfo: lo(Ul(() => U1())), ...e }), qj = (e) => _h(U1(), e), m9e = (e) => U1({ appearance: lo(Ul(() => U1())), claimInterpreter: lo(Ul(() => vfe())), position: lo(Fp([E0e(), Ci()])), ...e }), TS = (e) => _h(m9e(), e), g9e = (e) => Ik({ actionOption: lo(Ci()), ...e }), T9e = (e) => _h(g9e(), e);
function Efe(e) {
  let t = (e || []).find((n) => {
    var i;
    if ((i = n.type) != null && i.startsWith("https://schema.org/")) return E9e(n)["@id"] === "";
  }), r = t && qj(t);
  return r && qj(r);
}
function Hp(e, t) {
  try {
    return e();
  } catch {
    return t;
  }
}
function Li(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function y9e(e) {
  let t;
  return () => {
    t || (e(), t = 1);
  };
}
function rl(e) {
  return y9e(() => console.warn(`botframework-webchat: ${e}.`));
}
var YT = { ActivityClientState: tfe, DictateState: rfe }, _9e = "tsup", A9e = "esmodules", S9e = "4.18.0", j_ = { buildTool: _9e, moduleFormat: A9e, version: S9e };
/*! For license information please see botframework-webchat-core.mjs.LEGAL.txt */
var vL = { exports: {} }, z_ = { exports: {} }, In = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yj;
function b9e() {
  if (Yj) return In;
  Yj = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function y(S) {
    if (typeof S == "object" && S !== null) {
      var A = S.$$typeof;
      switch (A) {
        case t:
          switch (S = S.type, S) {
            case s:
            case c:
            case n:
            case o:
            case i:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case u:
                case l:
                case v:
                case p:
                case a:
                  return S;
                default:
                  return A;
              }
          }
        case r:
          return A;
      }
    }
  }
  function _(S) {
    return y(S) === c;
  }
  return In.AsyncMode = s, In.ConcurrentMode = c, In.ContextConsumer = u, In.ContextProvider = a, In.Element = t, In.ForwardRef = l, In.Fragment = n, In.Lazy = v, In.Memo = p, In.Portal = r, In.Profiler = o, In.StrictMode = i, In.Suspense = f, In.isAsyncMode = function(S) {
    return _(S) || y(S) === s;
  }, In.isConcurrentMode = _, In.isContextConsumer = function(S) {
    return y(S) === u;
  }, In.isContextProvider = function(S) {
    return y(S) === a;
  }, In.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, In.isForwardRef = function(S) {
    return y(S) === l;
  }, In.isFragment = function(S) {
    return y(S) === n;
  }, In.isLazy = function(S) {
    return y(S) === v;
  }, In.isMemo = function(S) {
    return y(S) === p;
  }, In.isPortal = function(S) {
    return y(S) === r;
  }, In.isProfiler = function(S) {
    return y(S) === o;
  }, In.isStrictMode = function(S) {
    return y(S) === i;
  }, In.isSuspense = function(S) {
    return y(S) === f;
  }, In.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === o || S === i || S === f || S === d || typeof S == "object" && S !== null && (S.$$typeof === v || S.$$typeof === p || S.$$typeof === a || S.$$typeof === u || S.$$typeof === l || S.$$typeof === E || S.$$typeof === m || S.$$typeof === g || S.$$typeof === h);
  }, In.typeOf = y, In;
}
var On = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gj;
function C9e() {
  return Gj || (Gj = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function y(We) {
      return typeof We == "string" || typeof We == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      We === n || We === c || We === o || We === i || We === f || We === d || typeof We == "object" && We !== null && (We.$$typeof === v || We.$$typeof === p || We.$$typeof === a || We.$$typeof === u || We.$$typeof === l || We.$$typeof === E || We.$$typeof === m || We.$$typeof === g || We.$$typeof === h);
    }
    function _(We) {
      if (typeof We == "object" && We !== null) {
        var Ne = We.$$typeof;
        switch (Ne) {
          case t:
            var je = We.type;
            switch (je) {
              case s:
              case c:
              case n:
              case o:
              case i:
              case f:
                return je;
              default:
                var et = je && je.$$typeof;
                switch (et) {
                  case u:
                  case l:
                  case v:
                  case p:
                  case a:
                    return et;
                  default:
                    return Ne;
                }
            }
          case r:
            return Ne;
        }
      }
    }
    var S = s, A = c, O = u, P = a, U = t, z = l, k = n, H = v, B = p, x = r, D = o, w = i, $ = f, X = !1;
    function V(We) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(We) || _(We) === s;
    }
    function F(We) {
      return _(We) === c;
    }
    function le(We) {
      return _(We) === u;
    }
    function ae(We) {
      return _(We) === a;
    }
    function ne(We) {
      return typeof We == "object" && We !== null && We.$$typeof === t;
    }
    function ve(We) {
      return _(We) === l;
    }
    function Ie(We) {
      return _(We) === n;
    }
    function Oe(We) {
      return _(We) === v;
    }
    function xe(We) {
      return _(We) === p;
    }
    function ze(We) {
      return _(We) === r;
    }
    function qe(We) {
      return _(We) === o;
    }
    function Je(We) {
      return _(We) === i;
    }
    function Be(We) {
      return _(We) === f;
    }
    On.AsyncMode = S, On.ConcurrentMode = A, On.ContextConsumer = O, On.ContextProvider = P, On.Element = U, On.ForwardRef = z, On.Fragment = k, On.Lazy = H, On.Memo = B, On.Portal = x, On.Profiler = D, On.StrictMode = w, On.Suspense = $, On.isAsyncMode = V, On.isConcurrentMode = F, On.isContextConsumer = le, On.isContextProvider = ae, On.isElement = ne, On.isForwardRef = ve, On.isFragment = Ie, On.isLazy = Oe, On.isMemo = xe, On.isPortal = ze, On.isProfiler = qe, On.isStrictMode = Je, On.isSuspense = Be, On.isValidElementType = y, On.typeOf = _;
  }()), On;
}
var Wj;
function td() {
  return Wj || (Wj = 1, process.env.NODE_ENV === "production" ? z_.exports = b9e() : z_.exports = C9e()), z_.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var QI, Kj;
function Ok() {
  if (Kj) return QI;
  Kj = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, u = 0; u < 10; u++)
        a["_" + String.fromCharCode(u)] = u;
      var s = Object.getOwnPropertyNames(a).map(function(l) {
        return a[l];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return QI = i() ? Object.assign : function(o, a) {
    for (var u, s = n(o), c, l = 1; l < arguments.length; l++) {
      u = Object(arguments[l]);
      for (var f in u)
        t.call(u, f) && (s[f] = u[f]);
      if (e) {
        c = e(u);
        for (var d = 0; d < c.length; d++)
          r.call(u, c[d]) && (s[c[d]] = u[c[d]]);
      }
    }
    return s;
  }, QI;
}
var eO, Xj;
function Rk() {
  if (Xj) return eO;
  Xj = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return eO = e, eO;
}
var tO, Jj;
function mfe() {
  return Jj || (Jj = 1, tO = Function.call.bind(Object.prototype.hasOwnProperty)), tO;
}
var rO, Zj;
function I9e() {
  if (Zj) return rO;
  Zj = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Rk(), r = {}, n = mfe();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in o)
        if (n(o, l)) {
          var f;
          try {
            if (typeof o[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[l](a, l, s, u, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, rO = i, rO;
}
var nO, Qj;
function O9e() {
  if (Qj) return nO;
  Qj = 1;
  var e = td(), t = Ok(), r = Rk(), n = mfe(), i = I9e(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return nO = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(F) {
      var le = F && (c && F[c] || F[l]);
      if (typeof le == "function")
        return le;
    }
    var d = "<<anonymous>>", p = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: g(),
      arrayOf: y,
      element: _(),
      elementType: S(),
      instanceOf: A,
      node: z(),
      objectOf: P,
      oneOf: O,
      oneOfType: U,
      shape: H,
      exact: B
    };
    function v(F, le) {
      return F === le ? F !== 0 || 1 / F === 1 / le : F !== F && le !== le;
    }
    function h(F, le) {
      this.message = F, this.data = le && typeof le == "object" ? le : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function E(F) {
      if (process.env.NODE_ENV !== "production")
        var le = {}, ae = 0;
      function ne(Ie, Oe, xe, ze, qe, Je, Be) {
        if (ze = ze || d, Je = Je || xe, Be !== r) {
          if (s) {
            var We = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw We.name = "Invariant Violation", We;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ne = ze + ":" + xe;
            !le[Ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            ae < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Je + "` prop on `" + ze + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), le[Ne] = !0, ae++);
          }
        }
        return Oe[xe] == null ? Ie ? Oe[xe] === null ? new h("The " + qe + " `" + Je + "` is marked as required " + ("in `" + ze + "`, but its value is `null`.")) : new h("The " + qe + " `" + Je + "` is marked as required in " + ("`" + ze + "`, but its value is `undefined`.")) : null : F(Oe, xe, ze, qe, Je);
      }
      var ve = ne.bind(null, !1);
      return ve.isRequired = ne.bind(null, !0), ve;
    }
    function m(F) {
      function le(ae, ne, ve, Ie, Oe, xe) {
        var ze = ae[ne], qe = w(ze);
        if (qe !== F) {
          var Je = $(ze);
          return new h(
            "Invalid " + Ie + " `" + Oe + "` of type " + ("`" + Je + "` supplied to `" + ve + "`, expected ") + ("`" + F + "`."),
            { expectedType: F }
          );
        }
        return null;
      }
      return E(le);
    }
    function g() {
      return E(a);
    }
    function y(F) {
      function le(ae, ne, ve, Ie, Oe) {
        if (typeof F != "function")
          return new h("Property `" + Oe + "` of component `" + ve + "` has invalid PropType notation inside arrayOf.");
        var xe = ae[ne];
        if (!Array.isArray(xe)) {
          var ze = w(xe);
          return new h("Invalid " + Ie + " `" + Oe + "` of type " + ("`" + ze + "` supplied to `" + ve + "`, expected an array."));
        }
        for (var qe = 0; qe < xe.length; qe++) {
          var Je = F(xe, qe, ve, Ie, Oe + "[" + qe + "]", r);
          if (Je instanceof Error)
            return Je;
        }
        return null;
      }
      return E(le);
    }
    function _() {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae];
        if (!u(Oe)) {
          var xe = w(Oe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(F);
    }
    function S() {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae];
        if (!e.isValidElementType(Oe)) {
          var xe = w(Oe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(F);
    }
    function A(F) {
      function le(ae, ne, ve, Ie, Oe) {
        if (!(ae[ne] instanceof F)) {
          var xe = F.name || d, ze = V(ae[ne]);
          return new h("Invalid " + Ie + " `" + Oe + "` of type " + ("`" + ze + "` supplied to `" + ve + "`, expected ") + ("instance of `" + xe + "`."));
        }
        return null;
      }
      return E(le);
    }
    function O(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function le(ae, ne, ve, Ie, Oe) {
        for (var xe = ae[ne], ze = 0; ze < F.length; ze++)
          if (v(xe, F[ze]))
            return null;
        var qe = JSON.stringify(F, function(Be, We) {
          var Ne = $(We);
          return Ne === "symbol" ? String(We) : We;
        });
        return new h("Invalid " + Ie + " `" + Oe + "` of value `" + String(xe) + "` " + ("supplied to `" + ve + "`, expected one of " + qe + "."));
      }
      return E(le);
    }
    function P(F) {
      function le(ae, ne, ve, Ie, Oe) {
        if (typeof F != "function")
          return new h("Property `" + Oe + "` of component `" + ve + "` has invalid PropType notation inside objectOf.");
        var xe = ae[ne], ze = w(xe);
        if (ze !== "object")
          return new h("Invalid " + Ie + " `" + Oe + "` of type " + ("`" + ze + "` supplied to `" + ve + "`, expected an object."));
        for (var qe in xe)
          if (n(xe, qe)) {
            var Je = F(xe, qe, ve, Ie, Oe + "." + qe, r);
            if (Je instanceof Error)
              return Je;
          }
        return null;
      }
      return E(le);
    }
    function U(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var le = 0; le < F.length; le++) {
        var ae = F[le];
        if (typeof ae != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(ae) + " at index " + le + "."
          ), a;
      }
      function ne(ve, Ie, Oe, xe, ze) {
        for (var qe = [], Je = 0; Je < F.length; Je++) {
          var Be = F[Je], We = Be(ve, Ie, Oe, xe, ze, r);
          if (We == null)
            return null;
          We.data && n(We.data, "expectedType") && qe.push(We.data.expectedType);
        }
        var Ne = qe.length > 0 ? ", expected one of type [" + qe.join(", ") + "]" : "";
        return new h("Invalid " + xe + " `" + ze + "` supplied to " + ("`" + Oe + "`" + Ne + "."));
      }
      return E(ne);
    }
    function z() {
      function F(le, ae, ne, ve, Ie) {
        return x(le[ae]) ? null : new h("Invalid " + ve + " `" + Ie + "` supplied to " + ("`" + ne + "`, expected a ReactNode."));
      }
      return E(F);
    }
    function k(F, le, ae, ne, ve) {
      return new h(
        (F || "React class") + ": " + le + " type `" + ae + "." + ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ve + "`."
      );
    }
    function H(F) {
      function le(ae, ne, ve, Ie, Oe) {
        var xe = ae[ne], ze = w(xe);
        if (ze !== "object")
          return new h("Invalid " + Ie + " `" + Oe + "` of type `" + ze + "` " + ("supplied to `" + ve + "`, expected `object`."));
        for (var qe in F) {
          var Je = F[qe];
          if (typeof Je != "function")
            return k(ve, Ie, Oe, qe, $(Je));
          var Be = Je(xe, qe, ve, Ie, Oe + "." + qe, r);
          if (Be)
            return Be;
        }
        return null;
      }
      return E(le);
    }
    function B(F) {
      function le(ae, ne, ve, Ie, Oe) {
        var xe = ae[ne], ze = w(xe);
        if (ze !== "object")
          return new h("Invalid " + Ie + " `" + Oe + "` of type `" + ze + "` " + ("supplied to `" + ve + "`, expected `object`."));
        var qe = t({}, ae[ne], F);
        for (var Je in qe) {
          var Be = F[Je];
          if (n(F, Je) && typeof Be != "function")
            return k(ve, Ie, Oe, Je, $(Be));
          if (!Be)
            return new h(
              "Invalid " + Ie + " `" + Oe + "` key `" + Je + "` supplied to `" + ve + "`.\nBad object: " + JSON.stringify(ae[ne], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
            );
          var We = Be(xe, Je, ve, Ie, Oe + "." + Je, r);
          if (We)
            return We;
        }
        return null;
      }
      return E(le);
    }
    function x(F) {
      switch (typeof F) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !F;
        case "object":
          if (Array.isArray(F))
            return F.every(x);
          if (F === null || u(F))
            return !0;
          var le = f(F);
          if (le) {
            var ae = le.call(F), ne;
            if (le !== F.entries) {
              for (; !(ne = ae.next()).done; )
                if (!x(ne.value))
                  return !1;
            } else
              for (; !(ne = ae.next()).done; ) {
                var ve = ne.value;
                if (ve && !x(ve[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(F, le) {
      return F === "symbol" ? !0 : le ? le["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && le instanceof Symbol : !1;
    }
    function w(F) {
      var le = typeof F;
      return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : D(le, F) ? "symbol" : le;
    }
    function $(F) {
      if (typeof F > "u" || F === null)
        return "" + F;
      var le = w(F);
      if (le === "object") {
        if (F instanceof Date)
          return "date";
        if (F instanceof RegExp)
          return "regexp";
      }
      return le;
    }
    function X(F) {
      var le = $(F);
      switch (le) {
        case "array":
        case "object":
          return "an " + le;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + le;
        default:
          return le;
      }
    }
    function V(F) {
      return !F.constructor || !F.constructor.name ? d : F.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, nO;
}
var iO, ez;
function R9e() {
  if (ez) return iO;
  ez = 1;
  var e = Rk();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, iO = function() {
    function n(a, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, iO;
}
if (process.env.NODE_ENV !== "production") {
  var w9e = td(), P9e = !0;
  vL.exports = O9e()(w9e.isElement, P9e);
} else
  vL.exports = R9e()();
var GT = vL.exports;
const Q = /* @__PURE__ */ Mt(GT);
function D9e(e) {
  var t;
  return ((t = e == null ? void 0 : e.$$typeof) == null ? void 0 : t.toString()) === "Symbol(react.context)";
}
function x9e(e) {
  var t;
  return ((t = e == null ? void 0 : e.$$typeof) == null ? void 0 : t.toString()) === "Symbol(react.provider)";
}
function N9e(e) {
  return (e == null ? void 0 : e.toString()) === "Symbol(react.fragment)";
}
function gfe(e) {
  return typeof e == "function" ? !0 : L9e(e);
}
function L9e(e) {
  var t;
  return ((t = e == null ? void 0 : e.$$typeof) == null ? void 0 : t.toString()) === "Symbol(react.memo)" && gfe(e.type);
}
function B9e(e) {
  return typeof e == "object" && typeof (e == null ? void 0 : e.render) == "function";
}
function k9e(e) {
  return gfe(e) || B9e(e) || N9e(e) || D9e(e) || x9e(e);
}
function M9e(...e) {
  return (t) => e.reduce((r, n) => n(r), t);
}
function F9e(...e) {
  return (...t) => {
    const r = e.map((n) => n(...t));
    return M9e(...r);
  };
}
function H9e(e = {}) {
  const r = ei({
    get enhancer() {
    },
    useBuildComponentCallback(a, u) {
      if (u != null && u.fallbackComponent)
        return u.fallbackComponent;
      throw new Error("This component/hook cannot be used outside of its corresponding <Provider>");
    }
  }), n = ({ children: a, init: u, middleware: s }) => {
    if (!Array.isArray(s) || s.some((v) => typeof v != "function"))
      throw new Error("middleware prop must be an array of functions");
    const c = Object.freeze(
      s ? s.map((v) => (h) => {
        const E = v(h);
        return (m) => (g) => {
          let y;
          const _ = E((S) => {
            if (y)
              throw new Error("next() cannot be called after the function had returned synchronously");
            return !e.passModifiedRequest && S !== g && console.warn(
              'react-chain-of-responsibility: "options.passModifiedRequest" must be set to true to pass a different request object to next().'
            ), m(e.passModifiedRequest ? S : g);
          })(g);
          if (y = !0, cS(_))
            throw new Error("middleware must not return React element directly");
          if (_ !== !1 && _ !== null && typeof _ < "u" && !k9e(_))
            throw new Error(
              "middleware must return false, null, undefined, function component, or class component"
            );
          return _;
        };
      }) : []
    ), { enhancer: l } = En(r), f = tt(
      () => (
        // We are reversing because it is easier to read:
        // - With reverse, [a, b, c] will become a(b(c(fn)))
        // - Without reverse, [a, b, c] will become c(b(a(fn)))
        F9e(
          ...[...c, ...l ? [() => l] : []].reverse()
        )(u)
      ),
      [u, s, l]
    ), d = mt(
      (v, h = {}) => f(() => h.fallbackComponent)(v),
      [f]
    ), p = tt(
      () => ({ enhancer: f, useBuildComponentCallback: d }),
      [f, d]
    );
    return /* @__PURE__ */ G.createElement(r.Provider, { value: p }, a);
  };
  n.displayName = "ChainOfResponsibilityProvider", n.propTypes = {
    children: Q.any,
    init: Q.any,
    middleware: Q.any
  };
  const i = () => En(r).useBuildComponentCallback, o = Nr(
    // False positive: "children" is not a prop.
    // eslint-disable-next-line react/prop-types
    ({ children: a, fallbackComponent: u, request: s, ...c }) => {
      const f = i()(s, { fallbackComponent: u });
      return f ? /* @__PURE__ */ G.createElement(f, { ...c }, a) : null;
    }
  );
  return o.displayName = "Proxy", o.propTypes = {
    fallbackComponent: Q.any,
    request: Q.any
  }, {
    Provider: n,
    Proxy: o,
    types: {
      init: void 0,
      middleware: void 0,
      props: void 0,
      request: void 0
    },
    useBuildComponentCallback: i
  };
}
var $9e = Object.freeze([]);
function Tfe(e) {
  let t = Kb(_Be([T0e((u) => typeof u == "function", "Middleware must be a function.")])), r = (u) => SBe(t, u).success, n = rl(`"${e}" prop is invalid`), i = (u, s) => {
    if (u) {
      if (r(u)) return Object.freeze(u == null ? void 0 : u.map((c) => c(s)).filter((c) => !!c).map((c) => () => c));
      n();
    }
    return $9e;
  }, { Provider: o, Proxy: a } = H9e();
  return o.displayName = `${e}Provider`, a.displayName = `${e}Proxy`, { initMiddleware: i, Provider: o, Proxy: a, types: { init: void 0, middleware: void 0, props: void 0, request: void 0 } };
}
/*! For license information please see chunk-2S76JUVM.mjs.LEGAL.txt */
var U9e = Object.create, wk = Object.defineProperty, V9e = Object.getOwnPropertyDescriptor, j9e = Object.getOwnPropertyNames, z9e = Object.getPrototypeOf, q9e = Object.prototype.hasOwnProperty, Sh = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Y9e = (e, t) => {
  for (var r in t) wk(e, r, { get: t[r], enumerable: !0 });
}, G9e = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function") for (let i of j9e(t)) !q9e.call(e, i) && i !== r && wk(e, i, { get: () => t[i], enumerable: !(n = V9e(t, i)) || n.enumerable });
  return e;
}, bh = (e, t, r) => (r = e != null ? U9e(z9e(e)) : {}, G9e(!e || !e.__esModule ? wk(r, "default", { value: e, enumerable: !0 }) : r, e));
/*! For license information please see chunk-J6D5YEY6.mjs.LEGAL.txt */
var { initMiddleware: W9e, Provider: K9e, Proxy: X9e, types: KPr } = Tfe("ActivityBorderDecoratorMiddleware"), J9e = "activity border", Z9e = [], Q9e = () => ({ children: e, middleware: t = Z9e }) => {
  let r = tt(() => W9e(t, J9e), [t]);
  return G.createElement(K9e, { middleware: r }, e);
}, Pk = Nr(Q9e());
Pk.displayName = "DecoratorComposer";
var yfe = Nr(({ children: e }) => G.createElement(jo, null, e));
yfe.displayName = "ActivityDecoratorFallback";
var eMe = ["bot", "channel", "user", void 0], tMe = ["informative", "completion", void 0];
function rMe({ children: e, activity: t }) {
  let r = tt(() => {
    var n, i, o, a;
    return { from: eMe.includes((n = t == null ? void 0 : t.from) == null ? void 0 : n.role) ? (i = t == null ? void 0 : t.from) == null ? void 0 : i.role : void 0, state: tMe.includes((o = t == null ? void 0 : t.channelData) == null ? void 0 : o.streamType) ? (a = t == null ? void 0 : t.channelData) == null ? void 0 : a.streamType : void 0 };
  }, [t]);
  return G.createElement(X9e, { fallbackComponent: yfe, request: r }, e);
}
var _fe = Nr(rMe);
/*! For license information please see botframework-webchat-api.decorator.mjs.LEGAL.txt */
const nMe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityDecorator: _fe,
  DecoratorComposer: Pk
}, Symbol.toStringTag, { value: "Module" }));
var iMe = Object.defineProperty, oMe = (e, t) => {
  for (var r in t) iMe(e, r, { get: t[r], enumerable: !0 });
};
function Afe(e) {
  return new DOMParser().parseFromString(e, "text/html");
}
function Sfe(e) {
  let t = new XMLSerializer(), r = [];
  for (let n of e.body.children) r.push(t.serializeToString(n));
  return `${r.join(`
`)}
`;
}
/*! For license information please see chunk-X37JABN5.mjs.LEGAL.txt */
var bfe = ei(void 0);
bfe.displayName = "WebChatAPIContext";
var Cfe = bfe;
function Lr() {
  let e = En(Cfe);
  if (!e) throw new Error("This hook can only be used on a component that is a descendant of <Composer>");
  return e;
}
/*! For license information please see chunk-ZAMHKQQC.mjs.LEGAL.txt */
var qc = /* @__PURE__ */ G.createContext(null);
process.env.NODE_ENV !== "production" && (qc.displayName = "ReactRedux");
function aMe(e) {
  e();
}
var Ife = aMe, uMe = function(t) {
  return Ife = t;
}, sMe = function() {
  return Ife;
};
function cMe() {
  var e = sMe(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var i = t; i; )
          i.callback(), i = i.next;
      });
    },
    get: function() {
      for (var i = [], o = t; o; )
        i.push(o), o = o.next;
      return i;
    },
    subscribe: function(i) {
      var o = !0, a = r = {
        callback: i,
        next: null,
        prev: r
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !o || t === null || (o = !1, a.next ? a.next.prev = a.prev : r = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
var tz = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function Ofe(e, t) {
  var r, n = tz;
  function i(f) {
    return s(), n.subscribe(f);
  }
  function o() {
    n.notify();
  }
  function a() {
    l.onStateChange && l.onStateChange();
  }
  function u() {
    return !!r;
  }
  function s() {
    r || (r = t ? t.addNestedSub(a) : e.subscribe(a), n = cMe());
  }
  function c() {
    r && (r(), r = void 0, n.clear(), n = tz);
  }
  var l = {
    addNestedSub: i,
    notifyNestedSubs: o,
    handleChangeWrapper: a,
    isSubscribed: u,
    trySubscribe: s,
    tryUnsubscribe: c,
    getListeners: function() {
      return n;
    }
  };
  return l;
}
var EL = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Np : nr;
function Rfe(e) {
  var t = e.store, r = e.context, n = e.children, i = tt(function() {
    var u = Ofe(t);
    return {
      store: t,
      subscription: u
    };
  }, [t]), o = tt(function() {
    return t.getState();
  }, [t]);
  EL(function() {
    var u = i.subscription;
    return u.onStateChange = u.notifyNestedSubs, u.trySubscribe(), o !== t.getState() && u.notifyNestedSubs(), function() {
      u.tryUnsubscribe(), u.onStateChange = null;
    };
  }, [i, o]);
  var a = r || qc;
  return /* @__PURE__ */ G.createElement(a.Provider, {
    value: i
  }, n);
}
process.env.NODE_ENV !== "production" && (Rfe.propTypes = {
  store: Q.shape({
    subscribe: Q.func.isRequired,
    dispatch: Q.func.isRequired,
    getState: Q.func.isRequired
  }),
  context: Q.object,
  children: Q.any
});
var wfe = td(), lMe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, fMe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Pfe = {};
Pfe[wfe.ForwardRef] = lMe;
Pfe[wfe.Memo] = fMe;
var Hn = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rz;
function dMe() {
  if (rz) return Hn;
  rz = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, a = 60110, u = 60112, s = 60113, c = 60120, l = 60115, f = 60116, d = 60121, p = 60122, v = 60117, h = 60129, E = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var m = Symbol.for;
    e = m("react.element"), t = m("react.portal"), r = m("react.fragment"), n = m("react.strict_mode"), i = m("react.profiler"), o = m("react.provider"), a = m("react.context"), u = m("react.forward_ref"), s = m("react.suspense"), c = m("react.suspense_list"), l = m("react.memo"), f = m("react.lazy"), d = m("react.block"), p = m("react.server.block"), v = m("react.fundamental"), h = m("react.debug_trace_mode"), E = m("react.legacy_hidden");
  }
  function g(B) {
    if (typeof B == "object" && B !== null) {
      var x = B.$$typeof;
      switch (x) {
        case e:
          switch (B = B.type, B) {
            case r:
            case i:
            case n:
            case s:
            case c:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case a:
                case u:
                case f:
                case l:
                case o:
                  return B;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  var y = o, _ = e, S = u, A = r, O = f, P = l, U = t, z = i, k = n, H = s;
  return Hn.ContextConsumer = a, Hn.ContextProvider = y, Hn.Element = _, Hn.ForwardRef = S, Hn.Fragment = A, Hn.Lazy = O, Hn.Memo = P, Hn.Portal = U, Hn.Profiler = z, Hn.StrictMode = k, Hn.Suspense = H, Hn.isAsyncMode = function() {
    return !1;
  }, Hn.isConcurrentMode = function() {
    return !1;
  }, Hn.isContextConsumer = function(B) {
    return g(B) === a;
  }, Hn.isContextProvider = function(B) {
    return g(B) === o;
  }, Hn.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === e;
  }, Hn.isForwardRef = function(B) {
    return g(B) === u;
  }, Hn.isFragment = function(B) {
    return g(B) === r;
  }, Hn.isLazy = function(B) {
    return g(B) === f;
  }, Hn.isMemo = function(B) {
    return g(B) === l;
  }, Hn.isPortal = function(B) {
    return g(B) === t;
  }, Hn.isProfiler = function(B) {
    return g(B) === i;
  }, Hn.isStrictMode = function(B) {
    return g(B) === n;
  }, Hn.isSuspense = function(B) {
    return g(B) === s;
  }, Hn.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === r || B === i || B === h || B === n || B === s || B === c || B === E || typeof B == "object" && B !== null && (B.$$typeof === f || B.$$typeof === l || B.$$typeof === o || B.$$typeof === a || B.$$typeof === u || B.$$typeof === v || B.$$typeof === d || B[0] === p);
  }, Hn.typeOf = g, Hn;
}
var $n = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nz;
function pMe() {
  return nz || (nz = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, a = 60110, u = 60112, s = 60113, c = 60120, l = 60115, f = 60116, d = 60121, p = 60122, v = 60117, h = 60129, E = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var m = Symbol.for;
      e = m("react.element"), t = m("react.portal"), r = m("react.fragment"), n = m("react.strict_mode"), i = m("react.profiler"), o = m("react.provider"), a = m("react.context"), u = m("react.forward_ref"), s = m("react.suspense"), c = m("react.suspense_list"), l = m("react.memo"), f = m("react.lazy"), d = m("react.block"), p = m("react.server.block"), v = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), h = m("react.debug_trace_mode"), m("react.offscreen"), E = m("react.legacy_hidden");
    }
    var g = !1;
    function y(Be) {
      return !!(typeof Be == "string" || typeof Be == "function" || Be === r || Be === i || Be === h || Be === n || Be === s || Be === c || Be === E || g || typeof Be == "object" && Be !== null && (Be.$$typeof === f || Be.$$typeof === l || Be.$$typeof === o || Be.$$typeof === a || Be.$$typeof === u || Be.$$typeof === v || Be.$$typeof === d || Be[0] === p));
    }
    function _(Be) {
      if (typeof Be == "object" && Be !== null) {
        var We = Be.$$typeof;
        switch (We) {
          case e:
            var Ne = Be.type;
            switch (Ne) {
              case r:
              case i:
              case n:
              case s:
              case c:
                return Ne;
              default:
                var je = Ne && Ne.$$typeof;
                switch (je) {
                  case a:
                  case u:
                  case f:
                  case l:
                  case o:
                    return je;
                  default:
                    return We;
                }
            }
          case t:
            return We;
        }
      }
    }
    var S = a, A = o, O = e, P = u, U = r, z = f, k = l, H = t, B = i, x = n, D = s, w = !1, $ = !1;
    function X(Be) {
      return w || (w = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(Be) {
      return $ || ($ = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(Be) {
      return _(Be) === a;
    }
    function le(Be) {
      return _(Be) === o;
    }
    function ae(Be) {
      return typeof Be == "object" && Be !== null && Be.$$typeof === e;
    }
    function ne(Be) {
      return _(Be) === u;
    }
    function ve(Be) {
      return _(Be) === r;
    }
    function Ie(Be) {
      return _(Be) === f;
    }
    function Oe(Be) {
      return _(Be) === l;
    }
    function xe(Be) {
      return _(Be) === t;
    }
    function ze(Be) {
      return _(Be) === i;
    }
    function qe(Be) {
      return _(Be) === n;
    }
    function Je(Be) {
      return _(Be) === s;
    }
    $n.ContextConsumer = S, $n.ContextProvider = A, $n.Element = O, $n.ForwardRef = P, $n.Fragment = U, $n.Lazy = z, $n.Memo = k, $n.Portal = H, $n.Profiler = B, $n.StrictMode = x, $n.Suspense = D, $n.isAsyncMode = X, $n.isConcurrentMode = V, $n.isContextConsumer = F, $n.isContextProvider = le, $n.isElement = ae, $n.isForwardRef = ne, $n.isFragment = ve, $n.isLazy = Ie, $n.isMemo = Oe, $n.isPortal = xe, $n.isProfiler = ze, $n.isStrictMode = qe, $n.isSuspense = Je, $n.isValidElementType = y, $n.typeOf = _;
  }()), $n;
}
process.env.NODE_ENV === "production" ? dMe() : pMe();
function Dfe() {
  var e = En(qc);
  if (process.env.NODE_ENV !== "production" && !e)
    throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
  return e;
}
function xfe(e) {
  e === void 0 && (e = qc);
  var t = e === qc ? Dfe : function() {
    return En(e);
  };
  return function() {
    var n = t(), i = n.store;
    return i;
  };
}
var hMe = /* @__PURE__ */ xfe();
function vMe(e) {
  e === void 0 && (e = qc);
  var t = e === qc ? hMe : xfe(e);
  return function() {
    var n = t();
    return n.dispatch;
  };
}
var EMe = function(t, r) {
  return t === r;
};
function mMe(e, t, r, n) {
  var i = Jse(function(v) {
    return v + 1;
  }, 0), o = i[1], a = tt(function() {
    return Ofe(r, n);
  }, [r, n]), u = Ut(), s = Ut(), c = Ut(), l = Ut(), f = r.getState(), d;
  try {
    if (e !== s.current || f !== c.current || u.current) {
      var p = e(f);
      l.current === void 0 || !t(p, l.current) ? d = p : d = l.current;
    } else
      d = l.current;
  } catch (v) {
    throw u.current && (v.message += `
The error may be correlated with this previous error:
` + u.current.stack + `

`), v;
  }
  return EL(function() {
    s.current = e, c.current = f, l.current = d, u.current = void 0;
  }), EL(function() {
    function v() {
      try {
        var h = r.getState();
        if (h === c.current)
          return;
        var E = s.current(h);
        if (t(E, l.current))
          return;
        l.current = E, c.current = h;
      } catch (m) {
        u.current = m;
      }
      o();
    }
    return a.onStateChange = v, a.trySubscribe(), v(), function() {
      return a.tryUnsubscribe();
    };
  }, [r, a]), d;
}
function gMe(e) {
  e === void 0 && (e = qc);
  var t = e === qc ? Dfe : function() {
    return En(e);
  };
  return function(n, i) {
    if (i === void 0 && (i = EMe), process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    var o = t(), a = o.store, u = o.subscription, s = mMe(n, i, a, u);
    return PIe(s), s;
  };
}
uMe(LIe);
var TMe = Zt, yMe = Hi, _Me = Xf;
TMe({ target: "Object", stat: !0, sham: !yMe }, {
  create: _Me
});
var AMe = Pn, SMe = AMe.Object, bMe = function(t, r) {
  return SMe.create(t, r);
}, CMe = bMe, Nfe = CMe, IMe = Nfe;
const wf = /* @__PURE__ */ Mt(IMe);
function Vo(e) {
  var t = Ut(), r = tt(function() {
    return wf({}, {
      current: {
        get: function() {
          return t.current;
        }
      }
    });
  }, [t]);
  return t.current = e, r;
}
var Ch = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(n) : typeof e == "object" ? t.exports = n() : r.Globalize = n();
  })(e, function() {
    var r = function(y) {
      return typeof y == "string" ? y : typeof y == "number" ? "" + y : JSON.stringify(y);
    }, n = function(y, _) {
      return y = y.replace(/{[0-9a-zA-Z-_. ]+}/g, function(S) {
        return S = S.replace(/^{([^}]*)}$/, "$1"), r(_[S]);
      }), y;
    }, i = function() {
      var y = arguments[0], _ = [].slice.call(arguments, 1);
      return _.forEach(function(S) {
        var A;
        for (A in S) y[A] = S[A];
      }), y;
    }, o = function(y, _, S) {
      var A;
      return _ = y + (_ ? ": " + n(_, S) : ""), A = new Error(_), A.code = y, i(A, S), A;
    }, a = function(y, _, S) {
      if (y.length && y[y.length - 1].type === _) {
        y[y.length - 1].value += S;
        return;
      }
      y.push({ type: _, value: S });
    }, u = function(y, _) {
      var S = 0, A = [];
      return y.replace(/{[0-9a-zA-Z-_. ]+}/g, function(O, P) {
        var U = O.slice(1, -1);
        a(A, "literal", y.slice(S, P)), a(A, "variable", _[U]), A[A.length - 1].name = U, S += P + O.length;
      }), A.filter(function(O) {
        return O.value !== "";
      });
    }, s = function(y) {
      return y.map(function(_) {
        return _.value;
      }).join("");
    }, c = function(y) {
      return JSON.stringify(y, function(_, S) {
        return S && S.runtimeKey ? S.runtimeKey : S;
      });
    }, l = function(y) {
      return [].reduce.call(y, function(_, S) {
        var A = S.charCodeAt(0);
        return _ = (_ << 5) - _ + A, _ | 0;
      }, 0);
    }, f = function(y, _, S, A) {
      var O;
      return A = A || c(S), O = l(y + _ + A), O > 0 ? "a" + O : "b" + Math.abs(O);
    }, d = function(y, _, S, A) {
      if (!S) throw o(y, _, A);
    }, p = function(y, _) {
      d("E_MISSING_PARAMETER", "Missing required parameter `{name}`.", y !== void 0, { name: _ });
    }, v = function(y, _, S, A) {
      d("E_INVALID_PAR_TYPE", "Invalid `{name}` parameter ({value}). {expected} expected.", S, { expected: A, name: _, value: y });
    }, h = function(y, _) {
      v(y, _, y === void 0 || typeof y == "string", "a string");
    }, E = function(y) {
      return y.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }, m = function(y, _, S) {
      var A;
      for (typeof y != "string" && (y = String(y)), A = y.length; A < _; A += 1) y = S ? y + "0" : "0" + y;
      return y;
    };
    function g(y) {
      if (!(this instanceof g)) return new g(y);
      p(y, "locale"), h(y, "locale"), this._locale = y;
    }
    return g.locale = function(y) {
      return h(y, "locale"), arguments.length && (this._locale = y), this._locale;
    }, g._createError = o, g._formatMessage = n, g._formatMessageToParts = u, g._partsJoin = s, g._partsPush = a, g._regexpEscape = E, g._runtimeKey = f, g._stringPad = m, g._validateParameterPresence = p, g._validateParameterTypeString = h, g._validateParameterType = v, g;
  });
}), Jb = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(["../globalize-runtime"], n) : typeof e == "object" ? t.exports = n(Ch()) : n(r.Globalize);
  })(e, function(r) {
    var n = r._createError, i = r._partsJoin, o = r._partsPush;
    r._regexpEscape;
    var a = r._runtimeKey, u = r._stringPad, s = r._validateParameterType, c = r._validateParameterPresence, l = r._validateParameterTypeString, f = function(w) {
      return n("E_UNSUPPORTED", "Unsupported {feature}.", { feature: w });
    }, d = function(w, $) {
      s(w, $, w === void 0 || typeof w == "number", "Number");
    }, p = /^([^0]*)(0+)([^0]*)$/, v = function(w, $, X) {
      var V, F = $, le = "", ae = ",", ne = !!X;
      for (w = String(w).split("."), V = w[0].length; V > F; ) le = w[0].slice(V - F, V) + (le.length ? ae : "") + le, V -= F, ne && (F = X, ne = !1);
      return w[0] = w[0].slice(0, V) + (le.length ? ae : "") + le, w.join(".");
    }, h = function(w, $, X, V, F, le) {
      return V ? le ? w = F(w, le) : w = F(w, { exponent: -V }) : w = F(w), w = String(w), V && /e-/.test(w) && (w = (+w).toFixed(V).replace(/0+$/, "").replace(/\.$/, "")), X && (w = w.split("."), w[1] = u(w[1] || "", X, !0), w = w.join(".")), $ && (w = w.split("."), w[0] = u(w[0], $), w = w.join(".")), w;
    }, E = function(w, $, X) {
      var V;
      return w === 0 ? w : (V = Math.ceil(Math.log(Math.abs(w)) / Math.log(10)), V -= $, X(w, { exponent: V }));
    }, m = function(w, $, X, V) {
      var F, le;
      if ($ > X && (X = $), F = E(w, $, V), le = E(w, X, V), w = +F == +le ? F : le, w = (+w).toString(10), /e/.test(w)) throw f({ feature: "integers out of (1e21, 1e-7)" });
      return $ - w.replace(/^0+|\./g, "").length > 0 && (w = w.split("."), w[1] = u(w[1] || "", $ - w[0].replace(/^0+/, "").length, !0), w = w.join(".")), w;
    }, g = { ".": "decimal", ",": "group", "%": "percentSign", "+": "plusSign", "-": "minusSign", E: "exponential", "‰": "perMille" }, y = function(w) {
      return w[0] + w[w.length - 1] !== "''" ? w : w === "''" ? "'" : w.replace(/''/g, "'").slice(1, -1);
    }, _ = function(w, $, X) {
      var V, F, le, ae, ne, ve, Ie, Oe, xe, ze, qe, Je, Be, We, Ne, je, et, St, Ot;
      if (Ie = $[2], ve = $[3], ae = $[4], Oe = $[5], ne = $[6], Ne = $[7], Je = $[8], je = $[9], We = $[15], le = $[16], xe = $[17], Ot = $[18], ze = $[19], F = $[20], isNaN(w)) return [{ type: "nan", value: xe }];
      if (w < 0 ? (Be = $[12], qe = $[13], St = $[14]) : (Be = $[11], qe = $[0], St = $[10]), et = function(Le) {
        var Me = "integer", Ae = [];
        return Le.replace(/('([^']|'')+'|'')|./g, function(ie, K) {
          if (K) {
            o(Ae, "literal", y(K));
            return;
          }
          if (ie === "¤") {
            o(Ae, "currency", ie);
            return;
          }
          ie = ie.replace(/[.,\-+E%\u2030]/, function(Z) {
            return Z === "." && (Me = "fraction"), o(Ae, g[Z], Ot[Z]), "";
          }), ie = ie.replace(/[0-9]/, function(Z) {
            return ze && (Z = ze[+Z]), o(Ae, Me, Z), "";
          }), ie.replace(/./, function(Z) {
            o(Ae, "literal", Z);
          });
        }), Ae;
      }, qe = et(qe), St = et(St), !isFinite(w)) return qe.concat({ type: "infinity", value: le }, St);
      Be.indexOf("%") !== -1 ? w *= 100 : Be.indexOf("‰") !== -1 && (w *= 1e3);
      var we, De, Ee, te, ue, ye;
      return F && (ue = Math.abs(Math.floor(w)).toString().length - 1, ue = Math.min(ue, F.maxExponent), ue >= 3 && (we = F[ue] && F[ue].other), we === "0" ? we = null : we && (De = we.split("0").length - 1, te = ue - (De - 1), w = w / Math.pow(10, te))), isNaN(Oe * ne) ? w = h(w, Ie, ve, ae, We, Ne) : w = m(w, Oe, ne, We), F && we && (ye = X ? X(+w) : "other", we = F[ue][ye] || we, Ee = we.match(p), V = function(Le) {
        var Me = [];
        return Le.replace(/(\s+)|([^\s0]+)/g, function(Ae, ie, K) {
          if (ie) {
            o(Me, "literal", ie);
            return;
          }
          if (K) {
            o(Me, "compact", K);
            return;
          }
        }), Me;
      }, qe = qe.concat(V(Ee[1])), St = V(Ee[3]).concat(St)), w = w.replace(/^-/, ""), Je && (w = v(w, Je, je)), qe.concat(et(w), St);
    }, S = function(w) {
      return function($) {
        return i(w($));
      };
    }, A = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/g, O = /[\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D\u2212]|\uD803\uDEAD/g, P = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, U = function(w) {
      return w.replace(A, "").replace(O, "-").replace(P, " ");
    }, z = function(w, $) {
      var X, V, F, le, ae, ne, ve, Ie, Oe, xe;
      X = [["nan"], ["prefix", "infinity", "suffix"], ["prefix", "number", "suffix"], ["negativePrefix", "infinity", "negativeSuffix"], ["negativePrefix", "number", "negativeSuffix"]], F = $[0], V = $[1] || {}, Oe = $[2], w = U(w);
      function ze(Je) {
        return function(Be) {
          switch (Be = Be.split("").map(function(We) {
            return F[We] || V[We] || We;
          }).join(""), Je) {
            case "infinity":
              ae = 1 / 0;
              break;
            case "nan":
              ae = NaN;
              break;
            case "number":
              Be = Be.replace(/,/g, ""), ae = +Be;
              break;
            case "prefix":
            case "negativePrefix":
              ne = Be;
              break;
            case "suffix":
              Ie = Be;
              break;
            case "negativeSuffix":
              Ie = Be, le = !0;
              break;
            default:
              throw new Error("Internal error");
          }
          return "";
        };
      }
      function qe(Je, Be) {
        return Be.some(function(We) {
          var Ne = Je;
          return We.every(function(je) {
            return Ne.match(Oe[je]) === null ? !1 : (Ne = Ne.replace(Oe[je], ze(je)), !0);
          }) && !Ne.length;
        });
      }
      return xe = qe(w, X), !xe || isNaN(ae) ? NaN : (ve = "" + ne + Ie, ve.indexOf("%") !== -1 ? ae /= 100 : ve.indexOf("‰") !== -1 && (ae /= 1e3), le && (ae *= -1), ae);
    }, k = function(w) {
      return function($) {
        return c($, "value"), l($, "value"), z($, w);
      };
    }, H = function(w, $) {
      return function(X) {
        return c(X, "value"), d(X, "value"), _(X, w, $);
      };
    }, B = function(w) {
      return isNaN(w) ? NaN : Math[w < 0 ? "ceil" : "floor"](w);
    }, x = function(w) {
      return w = w || "round", w = w === "truncate" ? B : Math[w], function($, X) {
        var V, F;
        if ($ = +$, isNaN($)) return NaN;
        if (typeof X == "object" && X.exponent) {
          if (V = +X.exponent, F = 1, V === 0) return w($);
          if (!(typeof V == "number" && V % 1 === 0)) return NaN;
        } else {
          if (F = +X || 1, F === 1) return w($);
          if (isNaN(F)) return NaN;
          F = F.toExponential().split("e"), V = +F[1], F = +F[0];
        }
        return $ = $.toString().split("e"), $[0] = +$[0] / F, $[1] = $[1] ? +$[1] - V : -V, $ = w(+($[0] + "e" + $[1])), $ = $.toString().split("e"), $[0] = +$[0] * F, $[1] = $[1] ? +$[1] + V : V, +($[0] + "e" + $[1]);
      };
    };
    r._createErrorUnsupportedFeature = f, r._looseMatching = U, r._numberFormat = _, r._numberFormatterFn = S, r._numberParse = z, r._numberParserFn = k, r._numberRound = x, r._numberToPartsFormatterFn = H, r._removeLiteralQuotes = y, r._validateParameterPresence = c, r._validateParameterTypeNumber = d, r._validateParameterTypeString = l;
    function D(w) {
      return r[w].runtimeKey = w, r[w];
    }
    return r.numberFormatter = r.prototype.numberFormatter = function(w) {
      return w = w || {}, D(a("numberFormatter", this._locale, [w]));
    }, r.numberToPartsFormatter = r.prototype.numberToPartsFormatter = function(w) {
      return w = w || {}, D(a("numberToPartsFormatter", this._locale, [w]));
    }, r.numberParser = r.prototype.numberParser = function(w) {
      return w = w || {}, r[a("numberParser", this._locale, [w])];
    }, r.formatNumber = r.prototype.formatNumber = function(w, $) {
      return c(w, "value"), d(w, "value"), this.numberFormatter($)(w);
    }, r.formatNumberToParts = r.prototype.formatNumberToParts = function(w, $) {
      return c(w, "value"), d(w, "value"), this.numberFormatter($)(w);
    }, r.parseNumber = r.prototype.parseNumber = function(w, $) {
      return c(w, "value"), l(w, "value"), this.numberParser($)(w);
    }, r;
  });
}), Dk = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(["../globalize-runtime"], n) : typeof e == "object" ? t.exports = n(Ch()) : n(r.Globalize);
  })(e, function(r) {
    var n = r._runtimeKey, i = r._validateParameterPresence, o = r._validateParameterType, a = function(s, c) {
      o(s, c, s === void 0 || typeof s == "number", "Number");
    }, u = function(s) {
      return function(c) {
        return i(c, "value"), a(c, "value"), s(c);
      };
    };
    return r._pluralGeneratorFn = u, r._validateParameterTypeNumber = a, r.plural = r.prototype.plural = function(s, c) {
      return i(s, "value"), a(s, "value"), this.pluralGenerator(c)(s);
    }, r.pluralGenerator = r.prototype.pluralGenerator = function(s) {
      return s = s || {}, r[n("pluralGenerator", this._locale, [s])];
    }, r;
  });
}), OMe = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(["../globalize-runtime", "./number"], n) : typeof e == "object" ? t.exports = n(Ch(), Jb()) : n(r.Globalize);
  })(e, function(r) {
    var n = r._createErrorUnsupportedFeature, i = r._looseMatching, o = r._partsJoin, a = r._partsPush, u = r._regexpEscape, s = r._removeLiteralQuotes, c = r._runtimeKey, l = r._stringPad, f = r._validateParameterPresence, d = r._validateParameterType, p = r._validateParameterTypeString, v = function(ae, ne) {
      d(ae, ne, ae === void 0 || ae instanceof Date, "Date");
    }, h = function() {
      function ae(Oe, xe, ze) {
        Object.defineProperty(Oe, xe, { value: ze });
      }
      function ne(Oe, xe) {
        for (var ze = 0, qe = Oe.getTime(); ze < xe.length - 1 && qe >= xe[ze]; ) ze++;
        return ze;
      }
      function ve(Oe) {
        var xe = this.getTimezoneOffset(), ze = Oe();
        this.original.setTime(new Date(this.getTime()));
        var qe = this.getTimezoneOffset();
        return qe - xe && this.original.setMinutes(this.original.getMinutes() + qe - xe), ze;
      }
      var Ie = function(Oe, xe) {
        if (ae(this, "original", new Date(Oe.getTime())), ae(this, "local", new Date(Oe.getTime())), ae(this, "timeZoneData", xe), ae(this, "setWrap", ve), !(xe.untils && xe.offsets && xe.isdsts)) throw new Error("Invalid IANA data");
        this.setTime(this.local.getTime() - this.getTimezoneOffset() * 60 * 1e3);
      };
      return Ie.prototype.clone = function() {
        return new Ie(this.original, this.timeZoneData);
      }, ["getFullYear", "getMonth", "getDate", "getDay", "getHours", "getMinutes", "getSeconds", "getMilliseconds"].forEach(function(Oe) {
        var xe = "getUTC" + Oe.substr(3);
        Ie.prototype[Oe] = function() {
          return this.local[xe]();
        };
      }), Ie.prototype.valueOf = Ie.prototype.getTime = function() {
        return this.local.getTime() + this.getTimezoneOffset() * 60 * 1e3;
      }, Ie.prototype.getTimezoneOffset = function() {
        var Oe = ne(this.original, this.timeZoneData.untils);
        return this.timeZoneData.offsets[Oe];
      }, ["setFullYear", "setMonth", "setDate", "setHours", "setMinutes", "setSeconds", "setMilliseconds"].forEach(function(Oe) {
        var xe = "setUTC" + Oe.substr(3);
        Ie.prototype[Oe] = function(ze) {
          var qe = this.local;
          return this.setWrap(function() {
            return qe[xe](ze);
          });
        };
      }), Ie.prototype.setTime = function(Oe) {
        return this.local.setTime(Oe);
      }, Ie.prototype.isDST = function() {
        var Oe = ne(this.original, this.timeZoneData.untils);
        return !!this.timeZoneData.isdsts[Oe];
      }, Ie.prototype.inspect = function() {
        var Oe = ne(this.original, this.timeZoneData.untils), xe = this.timeZoneData.abbrs;
        return this.local.toISOString().replace(/Z$/, "") + " " + (xe && xe[Oe] + " " || this.getTimezoneOffset() * -1 + " ") + (this.isDST() ? "(daylight savings)" : "");
      }, Ie.prototype.toDate = function() {
        return new Date(this.getTime());
      }, ["toISOString", "toJSON", "toUTCString"].forEach(function(Oe) {
        Ie.prototype[Oe] = function() {
          return this.toDate()[Oe]();
        };
      }), Ie;
    }(), E = function(ae, ne) {
      return (ae.getDay() - ne + 7) % 7;
    }, m = function(ae, ne) {
      var ve = 864e5;
      return (ne.getTime() - ae.getTime()) / ve;
    }, g = function(ae, ne) {
      switch (ae = ae instanceof h ? ae.clone() : new Date(ae.getTime()), ne) {
        case "year":
          ae.setMonth(0);
        case "month":
          ae.setDate(1);
        case "day":
          ae.setHours(0);
        case "hour":
          ae.setMinutes(0);
        case "minute":
          ae.setSeconds(0);
        case "second":
          ae.setMilliseconds(0);
      }
      return ae;
    }, y = function(ae) {
      return Math.floor(m(g(ae, "year"), ae));
    }, _ = function(ae, ne) {
      return ne = ne || function(ve, Ie, Oe) {
        return ve[Oe] = Ie, ve;
      }, Object.keys(ae).reduce(function(ve, Ie) {
        return ne(ve, Ie, ae[Ie]);
      }, {});
    }, S = _({ era: "G", year: "yY", quarter: "qQ", month: "ML", week: "wW", day: "dDF", weekday: "ecE", dayperiod: "a", hour: "hHkK", minute: "m", second: "sSA", zone: "zvVOxX" }, function(ae, ne, ve) {
      return ve.split("").forEach(function(Ie) {
        ae[Ie] = ne;
      }), ae;
    }), A = function(ae) {
      return ae - g(ae, "day");
    }, O = /([a-z])\1*|'([^']|'')+'|''|./ig, P = function(ae, ne, ve, Ie) {
      var Oe, xe = ae.getTimezoneOffset();
      return Oe = Math.abs(xe), Ie = Ie || { 1: function(ze) {
        return l(ze, 1);
      }, 2: function(ze) {
        return l(ze, 2);
      } }, ne.split(";")[xe > 0 ? 1 : 0].replace(":", ve).replace(/HH?/, function(ze) {
        return Ie[ze.length](Math.floor(Oe / 60));
      }).replace(/mm/, function() {
        return Ie[2](Math.floor(Oe % 60));
      }).replace(/ss/, function() {
        return Ie[2](Math.floor(Oe % 1 * 60));
      });
    }, U = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], z = function(ae, ne, ve) {
      var Ie = [], Oe = ve.timeSeparator;
      return ve.timeZoneData && (ae = new h(ae, ve.timeZoneData())), ve.pattern.replace(O, function(xe) {
        var ze, qe, Je, Be, We = xe.charAt(0), Ne = xe.length;
        switch (We === "j" && (We = ve.preferredTime), We === "Z" && (Ne < 4 ? (We = "x", Ne = 4) : Ne < 5 ? (We = "O", Ne = 4) : (We = "X", Ne = 5)), We === "z" && (ae.isDST && (Be = ae.isDST() ? ve.daylightTzName : ve.standardTzName), Be || (We = "O", Ne < 4 && (Ne = 1))), We) {
          case "G":
            Be = ve.eras[ae.getFullYear() < 0 ? 0 : 1];
            break;
          case "y":
            Be = ae.getFullYear(), Ne === 2 && (Be = String(Be), Be = +Be.substr(Be.length - 2));
            break;
          case "Y":
            Be = new Date(ae.getTime()), Be.setDate(Be.getDate() + 7 - E(ae, ve.firstDay) - ve.firstDay - ve.minDays), Be = Be.getFullYear(), Ne === 2 && (Be = String(Be), Be = +Be.substr(Be.length - 2));
            break;
          case "Q":
          case "q":
            Be = Math.ceil((ae.getMonth() + 1) / 3), Ne > 2 && (Be = ve.quarters[We][Ne][Be]);
            break;
          case "M":
          case "L":
            Be = ae.getMonth() + 1, Ne > 2 && (Be = ve.months[We][Ne][Be]);
            break;
          case "w":
            Be = E(g(ae, "year"), ve.firstDay), Be = Math.ceil((y(ae) + Be) / 7) - (7 - Be >= ve.minDays ? 0 : 1);
            break;
          case "W":
            Be = E(g(ae, "month"), ve.firstDay), Be = Math.ceil((ae.getDate() + Be) / 7) - (7 - Be >= ve.minDays ? 0 : 1);
            break;
          case "d":
            Be = ae.getDate();
            break;
          case "D":
            Be = y(ae) + 1;
            break;
          case "F":
            Be = Math.floor(ae.getDate() / 7) + 1;
            break;
          case "e":
          case "c":
            if (Ne <= 2) {
              Be = E(ae, ve.firstDay) + 1;
              break;
            }
          case "E":
            Be = U[ae.getDay()], Be = ve.days[We][Ne][Be];
            break;
          case "a":
            Be = ve.dayPeriods[ae.getHours() < 12 ? "am" : "pm"];
            break;
          case "h":
            Be = ae.getHours() % 12 || 12;
            break;
          case "H":
            Be = ae.getHours();
            break;
          case "K":
            Be = ae.getHours() % 12;
            break;
          case "k":
            Be = ae.getHours() || 24;
            break;
          case "m":
            Be = ae.getMinutes();
            break;
          case "s":
            Be = ae.getSeconds();
            break;
          case "S":
            Be = Math.round(ae.getMilliseconds() * Math.pow(10, Ne - 3));
            break;
          case "A":
            Be = Math.round(A(ae) * Math.pow(10, Ne - 3));
            break;
          case "z":
            break;
          case "v":
            if (ve.genericTzName) {
              Be = ve.genericTzName;
              break;
            }
          case "V":
            if (ve.timeZoneName) {
              Be = ve.timeZoneName;
              break;
            }
            xe === "v" && (Ne = 1);
          case "O":
            ae.getTimezoneOffset() === 0 ? Be = ve.gmtZeroFormat : (Ne < 4 ? (ze = ae.getTimezoneOffset(), ze = ve.hourFormat[ze % 60 - ze % 1 === 0 ? 0 : 1]) : ze = ve.hourFormat, Be = P(ae, ze, Oe, ne), Be = ve.gmtFormat.replace(/\{0\}/, Be));
            break;
          case "X":
            if (ae.getTimezoneOffset() === 0) {
              Be = "Z";
              break;
            }
          case "x":
            ze = ae.getTimezoneOffset(), Ne === 1 && ze % 60 - ze % 1 !== 0 && (Ne += 1), (Ne === 4 || Ne === 5) && ze % 1 === 0 && (Ne -= 2), Be = ["+HH;-HH", "+HHmm;-HHmm", "+HH:mm;-HH:mm", "+HHmmss;-HHmmss", "+HH:mm:ss;-HH:mm:ss"][Ne - 1], Be = P(ae, Be, ":");
            break;
          case ":":
            Be = Oe;
            break;
          case "'":
            Be = s(xe);
            break;
          default:
            Be = xe;
        }
        typeof Be == "number" && (Be = ne[Ne](Be)), qe = S[We], Je = qe || "literal", a(Ie, Je, Be);
      }), Ie;
    }, k = function(ae) {
      return function(ne) {
        return o(ae(ne));
      };
    }, H = function(ae) {
      return new Date(ae, 1, 29).getMonth() === 1;
    }, B = function(ae) {
      return new Date(ae.getFullYear(), ae.getMonth() + 1, 0).getDate();
    }, x = function(ae, ne) {
      var ve = new Date(ae.getFullYear(), ae.getMonth() + 1, 0).getDate();
      ae.setDate(ne < 1 ? 1 : ne < ve ? ne : ve);
    }, D = function(ae, ne) {
      var ve = ae.getDate();
      ae.setDate(1), ae.setMonth(ne), x(ae, ve);
    }, w = function(ae, ne, ve) {
      return ae < ne || ae > ve;
    }, $ = function(ae, ne, ve) {
      var Ie, Oe, xe, ze, qe, Je, Be, We, Ne, je = 0, et = 1, St = 2, Ot = 3, we = 4, De = 5, Ee = 6, te = /* @__PURE__ */ new Date(), ue = [], ye = ["year", "month", "day", "hour", "minute", "second", "milliseconds"];
      if (ve.timeZoneData && (te = new h(te, ve.timeZoneData())), !ne.length || (Ne = ne.every(function(Le) {
        var Me, Ae, ie, K;
        if (Le.type === "literal") return !0;
        switch (Ae = Le.type.charAt(0), K = Le.type.length, Ae === "j" && (Ae = ve.preferredTimeData), Ae) {
          case "G":
            ue.push(je), qe = +Le.value;
            break;
          case "y":
            if (ie = Le.value, K === 2) {
              if (w(ie, 0, 99)) return !1;
              Me = Math.floor(te.getFullYear() / 100) * 100, ie += Me, ie > te.getFullYear() + 20 && (ie -= 100);
            }
            te.setFullYear(ie), ue.push(je);
            break;
          case "Y":
            throw n({ feature: "year pattern `" + Ae + "`" });
          case "Q":
          case "q":
            break;
          case "M":
          case "L":
            if (K <= 2 ? ie = Le.value : ie = +Le.value, w(ie, 1, 12)) return !1;
            ze = ie, ue.push(et);
            break;
          case "w":
          case "W":
            break;
          case "d":
            Oe = Le.value, ue.push(St);
            break;
          case "D":
            xe = Le.value, ue.push(St);
            break;
          case "F":
            break;
          case "e":
          case "c":
          case "E":
            break;
          case "a":
            Ie = Le.value;
            break;
          case "h":
            if (ie = Le.value, w(ie, 1, 12)) return !1;
            Je = Be = !0, te.setHours(ie === 12 ? 0 : ie), ue.push(Ot);
            break;
          case "K":
            if (ie = Le.value, w(ie, 0, 11)) return !1;
            Je = Be = !0, te.setHours(ie), ue.push(Ot);
            break;
          case "k":
            if (ie = Le.value, w(ie, 1, 24)) return !1;
            Je = !0, te.setHours(ie === 24 ? 0 : ie), ue.push(Ot);
            break;
          case "H":
            if (ie = Le.value, w(ie, 0, 23)) return !1;
            Je = !0, te.setHours(ie), ue.push(Ot);
            break;
          case "m":
            if (ie = Le.value, w(ie, 0, 59)) return !1;
            te.setMinutes(ie), ue.push(we);
            break;
          case "s":
            if (ie = Le.value, w(ie, 0, 59)) return !1;
            te.setSeconds(ie), ue.push(De);
            break;
          case "A":
            te.setHours(0), te.setMinutes(0), te.setSeconds(0);
          case "S":
            ie = Math.round(Le.value * Math.pow(10, 3 - K)), te.setMilliseconds(ie), ue.push(Ee);
            break;
          case "z":
          case "Z":
          case "O":
          case "v":
          case "V":
          case "X":
          case "x":
            typeof Le.value == "number" && (We = Le.value);
            break;
        }
        return !0;
      }), !Ne) || Je && !(!Ie ^ Be)) return null;
      if (qe === 0 && te.setFullYear(te.getFullYear() * -1 + 1), ze !== void 0 && D(te, ze - 1), Oe !== void 0) {
        if (w(Oe, 1, B(te))) return null;
        te.setDate(Oe);
      } else if (xe !== void 0) {
        if (w(xe, 1, H(te.getFullYear()) ? 366 : 365)) return null;
        te.setMonth(0), te.setDate(xe);
      }
      return Be && Ie === "pm" && te.setHours(te.getHours() + 12), We !== void 0 && te.setMinutes(te.getMinutes() + We - te.getTimezoneOffset()), ue = Math.max.apply(null, ue), te = g(te, ye[ue]), te instanceof h && (te = te.toDate()), te;
    }, X = function(ae, ne, ve) {
      var Ie, Oe, xe = [], ze = ["abbreviated", "wide", "narrow"];
      return Ie = ve.digitsRe, ae = i(ae), Oe = ve.pattern.match(O).every(function(qe) {
        var Je, Be, We, Ne, je, et = {};
        function St(ue, ye) {
          var Le, Me, Ae = ae.match(ue);
          return ye = ye || function(ie) {
            return +ie;
          }, Ae ? (Me = Ae[1], Ae.length < 6 ? (Le = Me ? 1 : 3, et.value = ye(Ae[Le]) * 60) : Ae.length < 10 ? (Le = Me ? [1, 3] : [5, 7], et.value = ye(Ae[Le[0]]) * 60 + ye(Ae[Le[1]])) : (Le = Me ? [1, 3, 5] : [7, 9, 11], et.value = ye(Ae[Le[0]]) * 60 + ye(Ae[Le[1]]) + ye(Ae[Le[2]]) / 60), Me && (et.value *= -1), !0) : !1;
        }
        function Ot() {
          if (We === 1) return Ne = !0, je = Ie;
        }
        function we() {
          if (We === 1) return Ne = !0, je = new RegExp("^(" + Ie.source + "){1,2}");
        }
        function De() {
          if (We === 1 || We === 2) return Ne = !0, je = new RegExp("^(" + Ie.source + "){1,2}");
        }
        function Ee() {
          if (We === 2) return Ne = !0, je = new RegExp("^(" + Ie.source + "){2}");
        }
        function te(ue) {
          var ye = ve[ue.join("/")];
          return ye && ye.some(function(Le) {
            var Me = Le[1];
            if (Me.test(ae)) return et.value = Le[0], je = Le[1], !0;
          }), null;
        }
        switch (et.type = qe, Be = qe.charAt(0), We = qe.length, Be === "Z" && (We < 4 ? (Be = "x", We = 4) : We < 5 ? (Be = "O", We = 4) : (Be = "X", We = 5)), Be === "z" && ve.standardOrDaylightTzName && (et.value = null, je = ve.standardOrDaylightTzName), Be === "v" && (ve.genericTzName ? (et.value = null, je = ve.genericTzName) : (Be = "V", We = 4)), Be === "V" && ve.timeZoneName && (et.value = We === 2 ? ve.timeZoneName : null, je = ve.timeZoneNameRe), Be) {
          case "G":
            te(["gregorian/eras", We <= 3 ? "eraAbbr" : We === 4 ? "eraNames" : "eraNarrow"]);
            break;
          case "y":
          case "Y":
            Ne = !0, We === 1 ? je = new RegExp("^(" + Ie.source + ")+") : We === 2 ? je = new RegExp("^(" + Ie.source + "){1,2}") : je = new RegExp("^(" + Ie.source + "){" + We + ",}");
            break;
          case "Q":
          case "q":
            Ot() || Ee() || te(["gregorian/quarters", Be === "Q" ? "format" : "stand-alone", ze[We - 3]]);
            break;
          case "M":
          case "L":
            De() || te(["gregorian/months", Be === "M" ? "format" : "stand-alone", ze[We - 3]]);
            break;
          case "D":
            We <= 3 && (Ne = !0, je = new RegExp("^(" + Ie.source + "){" + We + ",3}"));
            break;
          case "W":
          case "F":
            Ot();
            break;
          case "e":
          case "c":
            if (We <= 2) {
              Ot() || Ee();
              break;
            }
          case "E":
            We === 6 ? te(["gregorian/days", [Be === "c" ? "stand-alone" : "format"], "short"]) || te(["gregorian/days", [Be === "c" ? "stand-alone" : "format"], "abbreviated"]) : te(["gregorian/days", [Be === "c" ? "stand-alone" : "format"], ze[We < 3 ? 0 : We - 3]]);
            break;
          case "a":
            te(["gregorian/dayPeriods/format/wide"]);
            break;
          case "w":
            we() || Ee();
            break;
          case "d":
          case "h":
          case "H":
          case "K":
          case "k":
          case "j":
          case "m":
          case "s":
            De();
            break;
          case "S":
            Ne = !0, je = new RegExp("^(" + Ie.source + "){" + We + "}");
            break;
          case "A":
            Ne = !0, je = new RegExp("^(" + Ie.source + "){" + (We + 5) + "}");
            break;
          case "v":
          case "V":
          case "z":
            if (je && je.test(ae) || Be === "V" && We === 2) break;
          case "O":
            if (ae === ve["timeZoneNames/gmtZeroFormat"]) et.value = 0, je = ve["timeZoneNames/gmtZeroFormatRe"];
            else if (Je = ve["timeZoneNames/hourFormat"].some(function(ue) {
              if (St(ue, ne)) return je = ue, !0;
            }), !Je) return null;
            break;
          case "X":
            if (ae === "Z") {
              et.value = 0, je = /^Z/;
              break;
            }
          case "x":
            if (Je = ve.x.some(function(ue) {
              if (St(ue)) return je = ue, !0;
            }), !Je) return null;
            break;
          case "'":
            et.type = "literal", je = new RegExp("^" + u(s(qe)));
            break;
          default:
            et.type = "literal", je = new RegExp("^" + u(qe));
        }
        return !je || (ae = ae.replace(je, function(ue) {
          return et.lexeme = ue, Ne && (et.value = ne(ue)), "";
        }), !et.lexeme) || Ne && isNaN(et.value) ? !1 : (xe.push(et), !0);
      }), ae !== "" && (Oe = !1), Oe ? xe : [];
    }, V = function(ae, ne, ve) {
      return function(Ie) {
        var Oe;
        return f(Ie, "value"), p(Ie, "value"), Oe = X(Ie, ae, ve), $(Ie, Oe, ne) || null;
      };
    }, F = function(ae, ne) {
      return function(ve) {
        return f(ve, "value"), v(ve, "value"), z(ve, ae, ne);
      };
    };
    r._dateFormat = z, r._dateFormatterFn = k, r._dateParser = $, r._dateParserFn = V, r._dateTokenizer = X, r._dateToPartsFormatterFn = F, r._validateParameterTypeDate = v;
    function le(ae) {
      return ae.skeleton !== void 0 || ae.date !== void 0 || ae.time !== void 0 || ae.datetime !== void 0 || ae.raw !== void 0;
    }
    return r.dateFormatter = r.prototype.dateFormatter = function(ae) {
      return ae = ae || {}, le(ae) || (ae.skeleton = "yMd"), r[c("dateFormatter", this._locale, [ae])];
    }, r.dateToPartsFormatter = r.prototype.dateToPartsFormatter = function(ae) {
      return ae = ae || {}, le(ae) || (ae.skeleton = "yMd"), r[c("dateToPartsFormatter", this._locale, [ae])];
    }, r.dateParser = r.prototype.dateParser = function(ae) {
      return ae = ae || {}, le(ae) || (ae.skeleton = "yMd"), r[c("dateParser", this._locale, [ae])];
    }, r.formatDate = r.prototype.formatDate = function(ae, ne) {
      return f(ae, "value"), v(ae, "value"), this.dateFormatter(ne)(ae);
    }, r.formatDateToParts = r.prototype.formatDateToParts = function(ae, ne) {
      return f(ae, "value"), v(ae, "value"), this.dateToPartsFormatter(ne)(ae);
    }, r.parseDate = r.prototype.parseDate = function(ae, ne) {
      return f(ae, "value"), p(ae, "value"), this.dateParser(ne)(ae);
    }, r;
  });
}), RMe = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(["../globalize-runtime", "./number", "./plural"], n) : typeof e == "object" ? t.exports = n(Ch(), Jb(), Dk()) : n(r.Globalize);
  })(e, function(r) {
    var n = r._formatMessage, i = r._runtimeKey, o = r._validateParameterPresence, a = r._validateParameterTypeNumber, u = function(c, l, f, d) {
      var p, v = d["relative-type-" + c];
      return v || (p = c <= 0 ? d["relativeTime-type-past"] : d["relativeTime-type-future"], c = Math.abs(c), v = p["relativeTimePattern-count-" + f(c)], n(v, [l(c)]));
    }, s = function(c, l, f) {
      return function(d) {
        return o(d, "value"), a(d, "value"), u(d, c, l, f);
      };
    };
    return r._relativeTimeFormatterFn = s, r.formatRelativeTime = r.prototype.formatRelativeTime = function(c, l, f) {
      return o(c, "value"), a(c, "value"), this.relativeTimeFormatter(l, f)(c);
    }, r.relativeTimeFormatter = r.prototype.relativeTimeFormatter = function(c, l) {
      return l = l || {}, r[i("relativeTimeFormatter", this._locale, [c, l])];
    }, r;
  });
}), wMe = Sh((e, t) => {
  (function(r, n) {
    typeof define == "function" && define.amd ? define(["../globalize-runtime", "./number", "./plural"], n) : typeof e == "object" ? t.exports = n(Ch(), Jb(), Dk()) : n(r.Globalize);
  })(e, function(r) {
    var n = r._formatMessage, i = r._runtimeKey, o = r._validateParameterPresence, a = r._validateParameterTypeNumber, u = function(c, l, f, d) {
      var p = d.compoundUnitPattern, v, h, E, m, g, y, _, S;
      return d = d.unitProperties, E = l(c), _ = f(c), d instanceof Array ? (h = d[0], g = d[1], S = g.hasOwnProperty("one") ? "one" : "other", v = n(h[_], [E]), m = n(g[S], [""]).trim(), n(p, [v, m])) : (y = d[_], n(y, [E]));
    }, s = function(c, l, f) {
      return function(d) {
        return o(d, "value"), a(d, "value"), u(d, c, l, f);
      };
    };
    return r._unitFormatterFn = s, r.formatUnit = r.prototype.formatUnit = function(c, l, f) {
      return this.unitFormatter(l, f)(c);
    }, r.unitFormatter = r.prototype.unitFormatter = function(c, l) {
      return l = l || {}, r[i("unitFormatter", this._locale, [c, l])];
    }, r;
  });
});
function iz(e) {
  return e.map((t) => `'${t}'`).join(", ");
}
var PMe = "#0063B1", oz = "#767676", Ov = 10, DMe = { accent: PMe, backgroundColor: "White", subtle: oz, paddingRegular: Ov, paddingWide: Ov * 2, fontSizeSmall: "80%", monospaceFont: iz(["Consolas", "Courier New", "monospace"]), primaryFont: iz(["Calibri", "Helvetica Neue", "Arial", "sans-serif"]), rootHeight: "100%", rootWidth: "100%", rootZIndex: 0, transitionDuration: "0s", avatarBorderRadius: "50%", avatarSize: 40, botAvatarBackgroundColor: void 0, botAvatarImage: void 0, botAvatarInitials: void 0, userAvatarBackgroundColor: void 0, userAvatarImage: void 0, userAvatarInitials: void 0, showAvatarInGroup: "status", bubbleBackground: "White", bubbleBorderColor: "#E6E6E6", bubbleBorderRadius: 2, bubbleBorderStyle: "solid", bubbleBorderWidth: 1, bubbleFromUserBackground: "White", bubbleFromUserBorderColor: "#E6E6E6", bubbleFromUserBorderRadius: 2, bubbleFromUserBorderStyle: "solid", bubbleFromUserBorderWidth: 1, bubbleFromUserNubOffset: 0, bubbleFromUserNubSize: void 0, bubbleFromUserTextColor: "Black", bubbleImageHeight: 240, bubbleMaxWidth: 480, bubbleMinHeight: 40, bubbleMinWidth: 250, bubbleNubOffset: 0, bubbleNubSize: void 0, bubbleTextColor: "Black", messageActivityWordBreak: "break-word", connectivityIconPadding: Ov * 1.2, connectivityMarginLeftRight: Ov * 1.4, connectivityMarginTopBottom: Ov * 0.8, connectivityTextSize: "75%", failedConnectivity: "#C50F1F", slowConnectivity: "#EAA300", notificationText: "#5E5E5E", slowConnectionAfter: 15e3, emojiSet: !0, internalLiveRegionFadeAfter: 1e3, markdownExternalLinkIconImage: "url(data:image/svg+xml;base64,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)", markdownRespectCRLF: !0, markdownRenderHTML: !0, hideScrollToEndButton: void 0, autoScrollSnapOnActivity: !1, autoScrollSnapOnActivityOffset: 0, autoScrollSnapOnPage: !1, autoScrollSnapOnPageOffset: 0, hideSendBox: !1, hideUploadButton: !1, hideTelephoneKeypadButton: !0, microphoneButtonColorOnDictate: "#F33", sendBoxBackground: "White", uploadAccept: void 0, uploadMultiple: !0, sendAttachmentOn: "send", sendBoxButtonColor: void 0, sendBoxButtonShadeColor: void 0, sendBoxButtonColorOnActive: void 0, sendBoxButtonShadeColorOnActive: "#EDEBE9", sendBoxButtonColorOnDisabled: "#A19F9D", sendBoxButtonShadeColorOnDisabled: "#F3F2F1", sendBoxButtonColorOnFocus: void 0, sendBoxButtonShadeColorOnFocus: void 0, sendBoxButtonColorOnHover: void 0, sendBoxButtonShadeColorOnHover: "#F3F2F1", sendBoxButtonShadeBorderRadius: 2, sendBoxButtonShadeInset: 2, sendBoxButtonKeyboardFocusIndicatorBorderColor: "#605E5C", sendBoxButtonKeyboardFocusIndicatorBorderRadius: 0, sendBoxButtonKeyboardFocusIndicatorBorderStyle: "solid", sendBoxButtonKeyboardFocusIndicatorBorderWidth: 1, sendBoxButtonKeyboardFocusIndicatorInset: 4, sendBoxDisabledTextColor: void 0, sendBoxHeight: 40, sendBoxMaxHeight: 200, sendBoxTextColor: "Black", sendBoxBorderBottom: void 0, sendBoxBorderLeft: void 0, sendBoxBorderRight: void 0, sendBoxBorderTop: "solid 1px #E6E6E6", sendBoxPlaceholderColor: void 0, sendBoxTextWrap: !1, sendBoxButtonAlignment: "stretch", showSpokenText: !1, spinnerAnimationBackgroundImage: void 0, spinnerAnimationHeight: 16, spinnerAnimationWidth: 16, spinnerAnimationPadding: 12, suggestedActionBorderRadius: 0, suggestedActionHeight: 40, suggestedActionImageHeight: 20, suggestedActionLayout: "carousel", suggestedActionBackgroundColor: "White", suggestedActionBorderColor: void 0, suggestedActionBorderStyle: "solid", suggestedActionBorderWidth: 2, suggestedActionTextColor: void 0, suggestedActionBackgroundColorOnActive: "#EDEBE9", suggestedActionBorderColorOnActive: void 0, suggestedActionBorderStyleOnActive: void 0, suggestedActionBorderWidthOnActive: void 0, suggestedActionTextColorOnActive: void 0, suggestedActionBackgroundColorOnDisabled: void 0, suggestedActionBorderColorOnDisabled: "#E6E6E6", suggestedActionBorderStyleOnDisabled: void 0, suggestedActionBorderWidthOnDisabled: void 0, suggestedActionTextColorOnDisabled: void 0, suggestedActionBackgroundColorOnFocus: void 0, suggestedActionBorderColorOnFocus: void 0, suggestedActionBorderStyleOnFocus: void 0, suggestedActionBorderWidthOnFocus: void 0, suggestedActionTextColorOnFocus: void 0, suggestedActionBackgroundColorOnHover: "#F3F2F1", suggestedActionBorderColorOnHover: void 0, suggestedActionBorderStyleOnHover: void 0, suggestedActionBorderWidthOnHover: void 0, suggestedActionTextColorOnHover: void 0, suggestedActionKeyboardFocusIndicatorBorderColor: "#605E5C", suggestedActionKeyboardFocusIndicatorBorderRadius: 0, suggestedActionKeyboardFocusIndicatorBorderStyle: "dashed", suggestedActionKeyboardFocusIndicatorBorderWidth: 1, suggestedActionKeyboardFocusIndicatorInset: 2, suggestedActionActiveBackground: void 0, suggestedActionBackground: void 0, suggestedActionDisabledBackground: void 0, suggestedActionDisabledBorderColor: void 0, suggestedActionDisabledBorderStyle: void 0, suggestedActionDisabledBorderWidth: void 0, suggestedActionDisabledTextColor: void 0, suggestedActionFocusBackground: void 0, suggestedActionHoverBackground: void 0, suggestedActionsCarouselFlipperCursor: void 0, suggestedActionsCarouselFlipperBoxWidth: 40, suggestedActionsCarouselFlipperSize: 20, suggestedActionsFlowMaxHeight: void 0, suggestedActionsStackedHeight: void 0, suggestedActionsStackedOverflow: void 0, suggestedActionsStackedLayoutButtonMaxHeight: void 0, suggestedActionsStackedLayoutButtonTextWrap: !1, suggestedActionsVisualKeyboardIndicatorColor: "Black", suggestedActionsVisualKeyboardIndicatorStyle: "solid", suggestedActionsVisualKeyboardIndicatorWidth: 2, groupTimestamp: !0, sendTimeout: 2e4, sendTimeoutForAttachments: 12e4, timestampColor: void 0, timestampFormat: "relative", scrollToEndButtonBehavior: "unread", scrollToEndButtonFontSize: "85%", newMessagesButtonFontSize: void 0, transcriptOverlayButtonBackground: "rgba(0, 0, 0, .6)", transcriptOverlayButtonBackgroundOnDisabled: "rgba(0, 0, 0, .6)", transcriptOverlayButtonBackgroundOnFocus: "rgba(0, 0, 0, .8)", transcriptOverlayButtonBackgroundOnHover: "rgba(0, 0, 0, .8)", transcriptOverlayButtonColor: "White", transcriptOverlayButtonColorOnDisabled: "White", transcriptOverlayButtonColorOnFocus: void 0, transcriptOverlayButtonColorOnHover: void 0, notificationDebounceTimeout: 400, hideToaster: !1, toasterHeight: 32, toasterMaxHeight: 32 * 5, toasterSingularMaxHeight: 50, toastFontSize: "87.5%", toastIconWidth: 36, toastSeparatorColor: "#E8EAEC", toastTextPadding: 6, toastErrorBackgroundColor: "#FDE7E9", toastErrorColor: "#A80000", toastInfoBackgroundColor: "#CEF1FF", toastInfoColor: "#105E7D", toastSuccessBackgroundColor: "#DFF6DD", toastSuccessColor: "#107C10", toastWarnBackgroundColor: "#FFF4CE", toastWarnColor: "#3B3A39", transcriptTerminatorBackgroundColor: "#595959", transcriptTerminatorBorderRadius: 5, transcriptTerminatorColor: "White", transcriptTerminatorFontSize: 12, transcriptActivityVisualKeyboardIndicatorColor: oz, transcriptActivityVisualKeyboardIndicatorStyle: "dashed", transcriptActivityVisualKeyboardIndicatorWidth: 1, transcriptVisualKeyboardIndicatorColor: "Black", transcriptVisualKeyboardIndicatorStyle: "solid", transcriptVisualKeyboardIndicatorWidth: 2, typingAnimationBackgroundImage: void 0, typingAnimationDuration: 5e3, typingAnimationHeight: 20, typingAnimationWidth: 64, enableUploadThumbnail: !0, uploadThumbnailContentType: "image/jpeg", uploadThumbnailHeight: 360, uploadThumbnailQuality: 0.6, uploadThumbnailWidth: 720, videoHeight: 270, maxMessageLength: 2e3 }, xMe = DMe, Lfe = ei(void 0);
function NMe() {
  let e = En(Lfe);
  if (!e) throw new Error("botframework-webchat: This hook can only be used under <PonyfillContext>.");
  return e;
}
function Bfe() {
  return NMe().ponyfillState;
}
var ac = Bfe, LMe = { "_.comment": "The content of this file is contributed by the community.", ACTIVITY_BOT_SAID: "البوت $1 قال, $2 أرسل: $3", ACTIVITY_ERROR_BOX_TITLE: "رسالة خطأ", ACTIVITY_STATUS_SEND_FAILED_RETRY: "[إعادة المحاولة][RETRY]. فشل في الإرسال.", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "أرسال", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "أرسل: $1", ACTIVITY_STATUS_SEND_STATUS_ALT: "ارسل الحالة: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "حالا", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "حالا", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "حالا", ACTIVITY_STATUS_TIMESTAMP_TODAY: "حالا", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "حالا", ACTIVITY_USER_SAID: "المستخدم $1 قال, $2 أرسل: $3", CAROUSEL_ATTACHMENTS_BOT_ALT: "البوت ارسل:", CAROUSEL_ATTACHMENTS_USER_ALT: "المستخدم أرسل: ", CAROUSEL_FLIPPER_LEFT_ALT: "يسار", CAROUSEL_FLIPPER_RIGHT_ALT: "يمين", CONNECTIVITY_STATUS_ALT_CONNECTED: "متصل", CONNECTIVITY_STATUS_ALT_CONNECTING: "يتم التوصيل…", CONNECTIVITY_STATUS_ALT_FATAL: "غير قادر على الاتصال.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "حدث انقطاع في الشبكة. إعادة التوصيل…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "خطأ في التقديم. يرجى التحقق من وحدة التحكم أو الاتصال بمطور البوت.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "يستغرق وقتا أطول من المعتاد للاتصال.", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "تحميل الملف '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "تحميل ملف تحميل الملف $1 بحجم $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 بحجم $2", RECEIPT_CARD_TAX: "ضريبة", RECEIPT_CARD_TOTAL: "المجموع", RECEIPT_CARD_VAT: "ضريبة القيمة المضافة", SPEECH_INPUT_LISTENING: "يستمع…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "الميكروفون مغلق", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "الميكروفون قيد التشغيل", SPEECH_INPUT_STARTING: "يبدأ…", TEXT_INPUT_PLACEHOLDER: "اكتب رسالتك", TEXT_INPUT_SEND_BUTTON_ALT: "أرسل", TEXT_INPUT_SPEAK_BUTTON_ALT: "تكلم", TEXT_INPUT_UPLOAD_BUTTON_ALT: "رفع الملف", TRANSCRIPT_NEW_MESSAGES: "رسائل جديدة", TYPING_INDICATOR_ALT: "عرض مؤشر الكتابة" }, BMe = { "_.comment": "The content of this file is contributed by the community.", ACTIVITY_BOT_SAID: "رد الآلي $1 قال, $2 أرسل ب: $3", ACTIVITY_ERROR_BOX_TITLE: "رسالة المشكلة", ACTIVITY_STATUS_SEND_FAILED_RETRY: "فشل في الارسال. [إعادة المحوالة][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "جاري الإرسال", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "أرسل ب: $1", ACTIVITY_STATUS_SEND_STATUS_ALT: "حالة الإرسال: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "الآن", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "الآن", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "الآن", ACTIVITY_STATUS_TIMESTAMP_TODAY: "الآن", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "الآن", ACTIVITY_USER_SAID: "المستخدم $1 قال, $2 أرسل ب: $3", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "غير قادر على تفصيل بطاقة التكيف", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "غير قادر على عرض بطاقة التكيف", CAROUSEL_ATTACHMENTS_BOT_ALT: "الرد الآلي أرسل: ", CAROUSEL_ATTACHMENTS_USER_ALT: "المستخدم أرسل: ", CAROUSEL_FLIPPER_LEFT_ALT: "يسار", CAROUSEL_FLIPPER_RIGHT_ALT: "يمين", CONNECTIVITY_STATUS_ALT_CONNECTED: "تم الإتصال", CONNECTIVITY_STATUS_ALT_CONNECTING: "يتم الاتصال…", CONNECTIVITY_STATUS_ALT_FATAL: "غير قادر عالإتصال.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "حدث انقطاع في الشبكة. إعادة الاتصال…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "خطأ تقديم. يرجى التحقق من وحدة التحكم أو الاتصال مطور الروبوت.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "الإتصال يستغرق اكثر من المعتاد.", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "تحميل الملف '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "تحميل الملف $1 بحجم $2", FILE_CONTENT_WITH_SIZE_ALT: "بحجم $1", RECEIPT_CARD_TAX: "ضريبة", RECEIPT_CARD_TOTAL: "المجموع", RECEIPT_CARD_VAT: "VAT", SPEECH_INPUT_LISTENING: "جاري الإستماع…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "المايكروفون مغلق", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "المايكروفون يعمل", SPEECH_INPUT_STARTING: "جاري البدء…", TEXT_INPUT_ALT: "صندوق الإرسال", TEXT_INPUT_PLACEHOLDER: "اكتب رسالتك", TEXT_INPUT_SEND_BUTTON_ALT: "إرسال", TEXT_INPUT_SPEAK_BUTTON_ALT: "تكلم", TEXT_INPUT_UPLOAD_BUTTON_ALT: "رفع الملف", TRANSCRIPT_NEW_MESSAGES: "رسائل جديدة", TYPING_INDICATOR_ALT: "يتم عرض مؤشر الكتابة" }, kMe = { _comment: "[CI-LOCKED] محتوى هذا الملف مؤمن. نرحب بالمساهمات، ولكن التحقق من صحة التغيير قد يتأخر.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "قابل الروبوت $1:", ACTIVITY_YOU_SAID_ALT: "لقد قلت:", ACTIVITY_BOT_ATTACHED_ALT: "قام الروبوت بإرفاق:", ACTIVITY_ERROR_BOX_TITLE: "رسالة الخطأ", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "انقر للتفاعل.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "الرسالة تفاعلية.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "ارتباط واحد أو أكثر في الرسالة.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "فشل الإرسال.", ACTIVITY_YOU_ATTACHED_ALT: "لقد قمت بإرفاق:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "‏‏مرفق واحد.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 مرفق (مرفقات).", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 مرفق (مرفقات).", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 مرفق (مرفقات).", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 مرفق (مرفقات).", ACTIVITY_STATUS_SEND_FAILED_RETRY: "فشل الإرسال. [إعادة المحاولة][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "جارٍ الإرسال", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "تم إرسالها عند الساعة $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "الآن", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "قبل ساعة", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "قبل دقيقة", ACTIVITY_STATUS_TIMESTAMP_TODAY: "اليوم", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "الأمس", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "خطأ في تحليل البطاقة الموائمة", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "خطأ في عرض البطاقة الموائمة", ATTACHMENT_AUDIO: "مقطع صوتي.", ATTACHMENT_CARD: "بطاقة: $1 $2 $3", ATTACHMENT_FILE: "ملف: $1", ATTACHMENT_IMAGE: "صورة", ATTACHMENT_TEXT: "نص: $1", ATTACHMENT_VIDEO: "مقطع فيديو", CAROUSEL_FLIPPER_NEXT_ALT: "التالي", CAROUSEL_FLIPPER_PREVIOUS_ALT: "السابق", CITATION_MODEL_DIALOG_ALT: "الاقتباس", CONNECTIVITY_STATUS_ALT_CONNECTED: "متصل", CONNECTIVITY_STATUS_ALT_CONNECTING: "جارٍ الاتصال…", CONNECTIVITY_STATUS_ALT_FATAL: "يتعذر الاتصال.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "حدث انقطاع في الشبكة. جارٍ إعادة الاتصال…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "خطأ في العرض. الرجاء فحص وحدة التحكم أو الاتصال بمطور الروبوت.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "يستغرق وقتًا أطول من المعتاد للاتصال.", CONNECTIVITY_STATUS_ALT: "حالة الاتصال: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "تنزيل ملف '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "تنزيل الملف '$1' بحجم $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' بحجم $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "مفتاح Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "الوصول إلى العناصر في الرسالة", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "محفوظات الدردشة", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "مفتاح Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "الخروج من الرسالة", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `مفتاح Tab
مفتاح Shift + tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "التنقل بين العناصر في رسالة", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `مفتاح السهم لأعلى
مفتاح السهم لأسفل`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "التنقل بين الرسائل", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "مفتاح Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "القيام بالإجراء", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `مفتاح Tab
مفتاح Shift + tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "التنقل بين العناصر في نافذة الدردشة", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "نافذة الدردشة", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "إغلاق", KEYBOARD_HELP_HEADER: "عناصر تحكم لوحة المفاتيح", MARKDOWN_EXTERNAL_LINK_ALT: "فتح في نافذة جديدة؛ خارجية.", RECEIPT_CARD_TAX: "الضريبة", RECEIPT_CARD_TOTAL: "الإجمالي‬", RECEIPT_CARD_VAT: "ضريبة القيمة المضافة", REFERENCE_LIST_HEADER_ONE: "$1 مرجع", REFERENCE_LIST_HEADER_FEW: "$1 مراجع", REFERENCE_LIST_HEADER_MANY: "$1 مراجع", REFERENCE_LIST_HEADER_OTHER: "$1 مراجع", REFERENCE_LIST_HEADER_TWO: "مراجع $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "لا يمكن إرسال رسالة فارغة.", SPEECH_INPUT_LISTENING: "جارٍ الاستماع…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "الميكروفون متوقف عن التشغيل", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "الميكروفون قيد التشغيل", SPEECH_INPUT_STARTING: "البدء…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "التالي", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "السابق", SUGGESTED_ACTIONS_LABEL_ALT: "الإجراءات المقترحة", TEXT_INPUT_ALT: "مربع إدخال الرسالة", TEXT_INPUT_PLACEHOLDER: "اكتب رسالتك", TEXT_INPUT_SEND_BUTTON_ALT: "‏‏إرسال", TEXT_INPUT_SPEAK_BUTTON_ALT: "تحدّث", TEXT_INPUT_UPLOAD_BUTTON_ALT: "تحميل الملف", TOAST_ACCORDION_FEW: "$1 إعلامات: انقر هنا للاطلاع على التفاصيل", TOAST_ACCORDION_MANY: "$1 إعلامات: انقر هنا للاطلاع على التفاصيل", TOAST_ACCORDION_OTHER: "$1 إعلامات: انقر هنا للاطلاع على التفاصيل", TOAST_ACCORDION_TWO: "$1 إعلامات: انقر هنا للاطلاع على التفاصيل", TOAST_ALT_ERROR: "‏‏الخطأ", TOAST_ALT_INFO: "المعلومات", TOAST_ALT_SUCCESS: "نجاح", TOAST_ALT_WARN: "تحذير", TOAST_DISMISS_BUTTON: "رفض", TOAST_TITLE_ALT: "الإعلام", TRANSCRIPT_ARIA_LABEL_ALT: "محفوظات الدردشة، اضغط على مفاتيح الأسهم للتنقل.", TRANSCRIPT_ARIA_ROLE_ALT: "محفوظات الدردشة", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "الرسالة تفاعلية. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "هناك ارتباط أو أكثر في الرسالة. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "تتضمن الرسالة إجراءات مقترحة. اضغط على shift tab من مرتين إلى 3 مرات لتحديدها.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "تتضمن الرسالة إجراءات مقترحة. اضغط على $1 لتحديدها.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "فشل إرسال الرسالة.", TRANSCRIPT_MORE_MESSAGES: "المزيد من الرسائل", TRANSCRIPT_NEW_MESSAGES: "رسائل جديدة", TRANSCRIPT_TERMINATOR_TEXT: "نهاية محفوظات الدردشة", TYPING_INDICATOR_ALT: "إظهار مؤشر الكتابة", TYPING_INDICATOR_SINGLE_TEXT: "$1 يكتب الآن.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 وغيره يكتبون الآن.", VOTE_DISLIKE_ALT: "لم يعجبني", VOTE_LIKE_ALT: "أعجبني" }, MMe = { _comment: "[CI-LOCKED] Съдържанието на този файл е заключено. Приносът е добре дошъл, но валидирането на промените може да се забави.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Бот $1 каза:", ACTIVITY_YOU_SAID_ALT: "Вие казахте:", ACTIVITY_BOT_ATTACHED_ALT: "Прикачен бот:", ACTIVITY_ERROR_BOX_TITLE: "Съобщение за грешка", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Щракнете за взаимодействие.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Съобщението е интерактивно.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Една или повече връзки в съобщението.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Изпращането е неуспешно.", ACTIVITY_YOU_ATTACHED_ALT: "Вие прикачихте:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 прикачен файл.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 прикачени файлове.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 прикачени файлове.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 прикачени файлове.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 прикачени файлове.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Изпращането е неуспешно. [Повторен опит][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Изпращане", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Изпратено в $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Преди малко", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Преди час", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Преди минута", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Днес", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Вчера", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Грешка при анализиране на адаптивна карта", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Грешка при рендиране на адаптивна карта", ATTACHMENT_AUDIO: "Аудиоклип.", ATTACHMENT_CARD: "Карта: $1 $2 $3", ATTACHMENT_FILE: "Файл: $1", ATTACHMENT_IMAGE: "Изображение", ATTACHMENT_TEXT: "Текст: $1", ATTACHMENT_VIDEO: "Видеоклип", CAROUSEL_FLIPPER_NEXT_ALT: "Следващо", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Предишно", CITATION_MODEL_DIALOG_ALT: "Цитат", CONNECTIVITY_STATUS_ALT_CONNECTED: "Установена връзка", CONNECTIVITY_STATUS_ALT_CONNECTING: "Свързване...", CONNECTIVITY_STATUS_ALT_FATAL: "Свързването не е възможно.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Възникна прекъсване на мрежата. Повторно свързване...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Грешка при рендиране. Моля, проверете конзолата или се свържете с разработчика на бота.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Свързването отнема повече време от обикновено.", CONNECTIVITY_STATUS_ALT: "Състояние на възможността за връзка: $1", FILE_CONTENT_ALT: "„$1”", FILE_CONTENT_DOWNLOADABLE_ALT: "Изтегляне на файл „$1”", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Изтегляне на файл „$1” с размер $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1” с размер $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Клавиш Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Достъп до елементи в съобщението", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Хронология на чата", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Клавиш Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Съобщение за излизане", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Клавиш Tab
Shift + клавиш Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Придвижване между елементи в съобщение", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Клавиш за стрелка нагоре
Клавиш за стрелка надолу`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Придвижване между съобщения", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Клавиш Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Извършване на действие", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Клавиш Tab
Shift + клавиш Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Придвижване между елементите в прозореца за чат", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Прозорец за чат", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Затваряне", KEYBOARD_HELP_HEADER: "Контроли на клавиатурата", MARKDOWN_EXTERNAL_LINK_ALT: "Отваря се в нов прозорец; външен.", RECEIPT_CARD_TAX: "Данък", RECEIPT_CARD_TOTAL: "Обща сума", RECEIPT_CARD_VAT: "ДДС", REFERENCE_LIST_HEADER_ONE: "$1 препратка", REFERENCE_LIST_HEADER_FEW: "$1 препратки", REFERENCE_LIST_HEADER_MANY: "$1 препратки", REFERENCE_LIST_HEADER_OTHER: "$1 препратки", REFERENCE_LIST_HEADER_TWO: "$1 препратки", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Не може да се изпрати празно съобщение.", SPEECH_INPUT_LISTENING: "Слушане...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Микрофонът е изключен", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Микрофонът е включен", SPEECH_INPUT_STARTING: "Начало...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Следващо", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Предишно", SUGGESTED_ACTIONS_LABEL_ALT: "Предложени действия", TEXT_INPUT_ALT: "Поле за въвеждане на съобщение", TEXT_INPUT_PLACEHOLDER: "Въведете съобщението си", TEXT_INPUT_SEND_BUTTON_ALT: "Изпрати", TEXT_INPUT_SPEAK_BUTTON_ALT: "Говорете", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Качване на файл", TOAST_ACCORDION_FEW: "$1 Известия: Щракнете тук, за да видите подробности", TOAST_ACCORDION_MANY: "$1 Известия: Щракнете тук, за да видите подробности", TOAST_ACCORDION_OTHER: "$1 Известия: Щракнете тук, за да видите подробности", TOAST_ACCORDION_TWO: "$1 Известия: Щракнете тук, за да видите подробности", TOAST_ALT_ERROR: "Грешка", TOAST_ALT_INFO: "Информация", TOAST_ALT_SUCCESS: "Успех", TOAST_ALT_WARN: "Предупреждение", TOAST_DISMISS_BUTTON: "Отхвърляне", TOAST_TITLE_ALT: "Известяване", TRANSCRIPT_ARIA_LABEL_ALT: "Хронология на чата, натиснете клавишите със стрелки, за да навигирате.", TRANSCRIPT_ARIA_ROLE_ALT: "хронология на чата", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Съобщението е интерактивно. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Има една или повече връзки в съобщението. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "В съобщението са предложени действия. Натиснете Shift Tab 2 до 3 пъти, за да ги изберете.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "В съобщението са предложени действия. Натиснете $1, за да ги изберете.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Неуспешно изпращане на съобщението.", TRANSCRIPT_MORE_MESSAGES: "Още съобщения", TRANSCRIPT_NEW_MESSAGES: "Нови съобщения", TRANSCRIPT_TERMINATOR_TEXT: "Край на хронологията на чата", TYPING_INDICATOR_ALT: "Показване на индикатор за въвеждане", TYPING_INDICATOR_SINGLE_TEXT: "$1 пише.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 и други пишат.", VOTE_DISLIKE_ALT: "Не харесвам", VOTE_LIKE_ALT: "Харесвам" }, FMe = { _comment: "[CI-LOCKED] El contingut d'aquest fitxer està bloquejat. Les aportacions són benvingudes, però la validació dels canvis es pot retardar.", ACCESS_KEY_ALT: "Alt Maj $1", ACCESS_KEY_FOR_MAC_ALT: "Control Opció $1", ACTIVITY_BOT_SAID_ALT: "El bot $1 ha dit:", ACTIVITY_YOU_SAID_ALT: "Heu dit:", ACTIVITY_BOT_ATTACHED_ALT: "Bot adjuntat:", ACTIVITY_ERROR_BOX_TITLE: "Missatge d'error", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Feu clic per interactuar.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "El missatge és interactiu.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Un o més enllaços del missatge.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "L'enviament ha fallat.", ACTIVITY_YOU_ATTACHED_ALT: "Heu adjuntat:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 fitxer adjunt.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 fitxers adjunts.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 fitxers adjunts.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 fitxers adjunts.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 fitxers adjunts.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "L'enviament ha fallat. [Torna-ho a provar][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "S'està enviant", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "S'ha enviat a les $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Ara mateix", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Fa una hora", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Fa un minut", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Avui", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ahir", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Error d'anàlisi de la targeta adaptativa", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Error de representació de la targeta adaptativa", ATTACHMENT_AUDIO: "Un clip d’àudio.", ATTACHMENT_CARD: "Una targeta: $1 $2 $3", ATTACHMENT_FILE: "Un fitxer: $1", ATTACHMENT_IMAGE: "Una imatge", ATTACHMENT_TEXT: "Un text: $1", ATTACHMENT_VIDEO: "Un clip de vídeo", CAROUSEL_FLIPPER_NEXT_ALT: "Següent", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Anterior", CITATION_MODEL_DIALOG_ALT: "Cita", CONNECTIVITY_STATUS_ALT_CONNECTED: "Connectat", CONNECTIVITY_STATUS_ALT_CONNECTING: "S'està connectant…", CONNECTIVITY_STATUS_ALT_FATAL: "No es pot connectar.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "S'ha produït una interrupció de la xarxa. S'està reconnectant…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Error de representació. Consulteu la consola o poseu-vos en contacte amb el desenvolupador del bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "S'està trigant més de l'habitual per establir una connexió.", CONNECTIVITY_STATUS_ALT: "Estat de la connectivitat: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Baixa el fitxer "$1"', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Baixa el fitxer "$1" amb una mida de $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" amb una mida de $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Introduïu una clau", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Accediu als elements del missatge", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historial de xat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tecla Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Missatge de sortida", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tecla de tabulació
Tecla Maj + tabulació`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Permet desplaçar-se entre els elements d'un missatge", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tecla fletxa amunt
Tecla fletxa avall`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Permet desplaçar-se entre els missatges", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Introduïu una clau", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Executa l'acció", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tecla de tabulació
Tecla Maj + tabulació`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Permet desplaçar-se entre els elements de la finestra de xat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Finestra del xat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Tanca", KEYBOARD_HELP_HEADER: "Controls de teclat", MARKDOWN_EXTERNAL_LINK_ALT: "S’obre en una finestra nova; externa.", RECEIPT_CARD_TAX: "Impost", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "IVA", REFERENCE_LIST_HEADER_ONE: "$1 referència", REFERENCE_LIST_HEADER_FEW: "$1 referències", REFERENCE_LIST_HEADER_MANY: "$1 referències", REFERENCE_LIST_HEADER_OTHER: "$1 referències", REFERENCE_LIST_HEADER_TWO: "$1 referències", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "No es pot enviar un missatge buit.", SPEECH_INPUT_LISTENING: "Escoltant…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Micròfon desactivat", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Micròfon activat", SPEECH_INPUT_STARTING: "Iniciant…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Següent", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Anterior", SUGGESTED_ACTIONS_LABEL_ALT: "Accions suggerides", TEXT_INPUT_ALT: "Quadre d'entrada del missatge", TEXT_INPUT_PLACEHOLDER: "Escriviu el missatge", TEXT_INPUT_SEND_BUTTON_ALT: "Envia", TEXT_INPUT_SPEAK_BUTTON_ALT: "Parlar", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Carrega el fitxer", TOAST_ACCORDION_FEW: "$1 notificacions: feu clic aquí per veure detalls", TOAST_ACCORDION_MANY: "$1 notificacions: feu clic aquí per veure detalls", TOAST_ACCORDION_OTHER: "$1 notificacions: feu clic aquí per veure detalls", TOAST_ACCORDION_TWO: "$1 notificacions: feu clic aquí per veure detalls", TOAST_ALT_ERROR: "Error", TOAST_ALT_INFO: "Informació", TOAST_ALT_SUCCESS: "Correcta", TOAST_ALT_WARN: "Advertiment", TOAST_DISMISS_BUTTON: "Descarta", TOAST_TITLE_ALT: "Notificació", TRANSCRIPT_ARIA_LABEL_ALT: "Historial de xat, premeu les tecles amunt/avall per desplaçar-vos.", TRANSCRIPT_ARIA_ROLE_ALT: "historial de xat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "El missatge és interactiu. Premeu la tecla de tabulació entre 2 i 3 vegades per canviar a l'historial de xat. A continuació, feu clic al missatge per interactuar.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Un o més enllaços al missatge. Premeu la tecla de tabulació entre 2 i 3 vegades per canviar a l'historial de xat. A continuació, feu clic al missatge per interactuar.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "El missatge ha suggerit accions. Premeu la tecla de tabulació entre 2 i 3 vegades per seleccionar-les.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "El missatge ha suggerit accions. Premeu $1 per seleccionar-les.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "No s'ha pogut enviar el missatge.", TRANSCRIPT_MORE_MESSAGES: "Més missatges", TRANSCRIPT_NEW_MESSAGES: "Missatges nous", TRANSCRIPT_TERMINATOR_TEXT: "Fi de l'historial de xat", TYPING_INDICATOR_ALT: "S'està mostrant l'indicador d'escriptura", TYPING_INDICATOR_SINGLE_TEXT: "$1 està escrivint.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 i altres persones estan escrivint.", VOTE_DISLIKE_ALT: "No m'agrada", VOTE_LIKE_ALT: "M'agrada" }, HMe = { _comment: "[CI-LOCKED] Obsah tohoto souboru je uzamčen. Příspěvky jsou vítány, ale ověření změny může být zpožděno.", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "Control + Option + $1", ACTIVITY_BOT_SAID_ALT: "Robot $1 řekl:", ACTIVITY_YOU_SAID_ALT: "Řekli jste:", ACTIVITY_BOT_ATTACHED_ALT: "Robot byl připojen:", ACTIVITY_ERROR_BOX_TITLE: "Chybová zpráva", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknutím provedete interakci.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Zpráva je interaktivní.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Zpráva obsahuje nejméně jeden odkaz.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Odeslání se nezdařilo.", ACTIVITY_YOU_ATTACHED_ALT: "Připojili jste:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 příloha", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 přílohy", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 příloh", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 příloh", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 přílohy", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Odeslání se nezdařilo. [Opakovat][RETRY]", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Odesílání", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Odesláno v $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Právě teď", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Před 1 hodinou", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Před 1 minutou", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Dnes", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Včera", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Chyba analyzování adaptivní karty", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Chyba vykreslování adaptivní karty", ATTACHMENT_AUDIO: "Zvukový klip", ATTACHMENT_CARD: "Karta: $1 $2 $3", ATTACHMENT_FILE: "Soubor: $1", ATTACHMENT_IMAGE: "Obrázek", ATTACHMENT_TEXT: "Text: $1", ATTACHMENT_VIDEO: "Videoklip", CAROUSEL_FLIPPER_NEXT_ALT: "Další", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Předchozí", CITATION_MODEL_DIALOG_ALT: "Citace", CONNECTIVITY_STATUS_ALT_CONNECTED: "Připojeno", CONNECTIVITY_STATUS_ALT_CONNECTING: "Připojování…", CONNECTIVITY_STATUS_ALT_FATAL: "Nelze navázat připojení.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Došlo k přerušení sítě. Znovu se připojuje…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Chyba vykreslování. Zkontrolujte konzolu nebo kontaktujte vývojáře botů.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Připojení trvá déle než obvykle.", CONNECTIVITY_STATUS_ALT: "Stav připojení: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Stáhnout soubor $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Stáhnout soubor $1 o velikosti $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 o velikosti $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Přístup k položkám ve zprávě", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historie chatu", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Opustit zprávu", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulátor
Shift + tabulátor`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Pohyb mezi položkami ve zprávě", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Šipka nahoru
Šipka dolů`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Pohyb mezi zprávami", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Provedení akce", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulátor
Shift + tabulátor`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Pohyb mezi položkami v okně chatu", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Okno chatu", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zavřít", KEYBOARD_HELP_HEADER: "Ovládání pomocí klávesnice", MARKDOWN_EXTERNAL_LINK_ALT: "Otevře se v novém okně; externí.", RECEIPT_CARD_TAX: "Daň", RECEIPT_CARD_TOTAL: "Celkem", RECEIPT_CARD_VAT: "DPH", REFERENCE_LIST_HEADER_ONE: "$1 odkaz", REFERENCE_LIST_HEADER_FEW: "$1 odkazy", REFERENCE_LIST_HEADER_MANY: "$1 odkazů", REFERENCE_LIST_HEADER_OTHER: "$1 odkazů", REFERENCE_LIST_HEADER_TWO: "$1 odkazy", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Prázdnou zprávu nelze odeslat.", SPEECH_INPUT_LISTENING: "Naslouchání…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon vypnout", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon zapnout", SPEECH_INPUT_STARTING: "Spouštění…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Další", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Předchozí", SUGGESTED_ACTIONS_LABEL_ALT: "Navrhované akce", TEXT_INPUT_ALT: "Pole pro zadání zprávy", TEXT_INPUT_PLACEHOLDER: "Zadejte svou zprávu", TEXT_INPUT_SEND_BUTTON_ALT: "Odeslat", TEXT_INPUT_SPEAK_BUTTON_ALT: "Mluvit", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Nahrát soubor", TOAST_ACCORDION_FEW: "$1 oznámení: kliknutím sem zobrazíte podrobnosti.", TOAST_ACCORDION_MANY: "$1 oznámení: kliknutím sem zobrazíte podrobnosti.", TOAST_ACCORDION_OTHER: "$1 oznámení: kliknutím sem zobrazíte podrobnosti.", TOAST_ACCORDION_TWO: "$1 oznámení: kliknutím sem zobrazíte podrobnosti.", TOAST_ALT_ERROR: "Chyba", TOAST_ALT_INFO: "Informace", TOAST_ALT_SUCCESS: "Úspěch", TOAST_ALT_WARN: "Upozornění", TOAST_DISMISS_BUTTON: "Zavřít", TOAST_TITLE_ALT: "Oznámení", TRANSCRIPT_ARIA_LABEL_ALT: "Historie chatu, k navigaci použijte šipkové klávesy.", TRANSCRIPT_ARIA_ROLE_ALT: "historie chatu", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Zpráva je interaktivní. Dvojím až trojím stisknutím kláves Shift + tabulátor přejdete do historie chatu. Interakci zahájíte kliknutím na zprávu.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Zpráva obsahuje nejméně jeden odkaz. Dvojím až trojím stisknutím kláves Shift + tabulátor přejdete do historie chatu. Interakci zahájíte kliknutím na zprávu.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Zpráva obsahuje navrhované akce. Pokud je chcete vybrat, stiskněte 2 až 3krát klávesy Shift + tabulátor.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Zpráva obsahuje navrhované akce. Pokud je chcete vybrat, stiskněte klávesu $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Zprávu se nepodařilo odeslat.", TRANSCRIPT_MORE_MESSAGES: "Další zprávy", TRANSCRIPT_NEW_MESSAGES: "Nové zprávy", TRANSCRIPT_TERMINATOR_TEXT: "Konec historie chatu", TYPING_INDICATOR_ALT: "Zobrazuje se indikátor psaní", TYPING_INDICATOR_SINGLE_TEXT: "$1 píše.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 a další píšou.", VOTE_DISLIKE_ALT: "To se mi nelíbí", VOTE_LIKE_ALT: "To se mi líbí" }, $Me = { _comment: "[CI-LOCKED] Indholdet af denne fil er låst. Bidrag er velkomne, men valideringen af ændringer bliver muligvis forsinket.", ACCESS_KEY_ALT: "Alt Skift $1", ACCESS_KEY_FOR_MAC_ALT: "Control option $1", ACTIVITY_BOT_SAID_ALT: "Robotten $1 sagde:", ACTIVITY_YOU_SAID_ALT: "Du sagde:", ACTIVITY_BOT_ATTACHED_ALT: "Vedhæftet af robot:", ACTIVITY_ERROR_BOX_TITLE: "Fejlmeddelelse", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klik for at interagere.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Meddelelsen er interaktiv.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Ét eller flere links i meddelelsen.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Afsendelse mislykkedes.", ACTIVITY_YOU_ATTACHED_ALT: "Du vedhæftede:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 vedhæftet fil.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 vedhæftede filer.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 vedhæftede filer.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 vedhæftede filer.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 vedhæftede filer.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Afsendelse mislykkedes. [Prøv igen][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Sender", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Sendt kl. $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Lige nu", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "For en time siden", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "For et minut siden", ACTIVITY_STATUS_TIMESTAMP_TODAY: "I dag", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "I går", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Fortolkningsfejl i AdaptiveCard", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Renderingsfejl i AdaptiveCard", ATTACHMENT_AUDIO: "Et lydklip.", ATTACHMENT_CARD: "Et kort: $1 $2 $3", ATTACHMENT_FILE: "En fil: $1", ATTACHMENT_IMAGE: "Et billede", ATTACHMENT_TEXT: "En tekst: $1", ATTACHMENT_VIDEO: "Et videoklip", CAROUSEL_FLIPPER_NEXT_ALT: "Næste", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Forrige", CITATION_MODEL_DIALOG_ALT: "Citat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Forbundet", CONNECTIVITY_STATUS_ALT_CONNECTING: "Opretter forbindelse ...", CONNECTIVITY_STATUS_ALT_FATAL: "Det var ikke muligt at oprette forbindelse.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Der opstod en netværksafbrydelse. Opretter forbindelse igen ...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Gengivelsesfejl. Kontrollér konsollen, eller kontakt robotudvikleren.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Det tager længere tid end normalt at oprette forbindelse.", CONNECTIVITY_STATUS_ALT: "Forbindelsesstatus: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Download filen '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Hent filen '$1', som fylder $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1', som fylder $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter-tast", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Adgangselementer i meddelelse", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chathistorik", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape-tast", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Afslut meddelelse", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatortast
Skift + tabulatortast`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Flyt mellem elementer i en meddelelse", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Pil op-tast
Pil ned-tast`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Flyt mellem meddelelser", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter-tast", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Udfør handling", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatortast
Skift + tabulatortast`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Flyt mellem elementer i chatvinduet", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chatvindue", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Luk", KEYBOARD_HELP_HEADER: "Tastaturets kontrolelementer", MARKDOWN_EXTERNAL_LINK_ALT: "Åbner i et nyt vindue, eksternt.", RECEIPT_CARD_TAX: "Moms", RECEIPT_CARD_TOTAL: "I alt", RECEIPT_CARD_VAT: "Moms", REFERENCE_LIST_HEADER_ONE: "$1 reference", REFERENCE_LIST_HEADER_FEW: "$1 referencer", REFERENCE_LIST_HEADER_MANY: "$1 referencer", REFERENCE_LIST_HEADER_OTHER: "$1 referencer", REFERENCE_LIST_HEADER_TWO: "$1 referencer", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Der kan ikke sendes en tom meddelelse.", SPEECH_INPUT_LISTENING: "Lytter ...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon Fra", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon Til", SPEECH_INPUT_STARTING: "Starter ...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Næste", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Forrige", SUGGESTED_ACTIONS_LABEL_ALT: "Foreslåede handlinger", TEXT_INPUT_ALT: "Meddelelsesinputfelt", TEXT_INPUT_PLACEHOLDER: "Skriv din meddelelse", TEXT_INPUT_SEND_BUTTON_ALT: "Send", TEXT_INPUT_SPEAK_BUTTON_ALT: "Tal", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Overfør fil", TOAST_ACCORDION_FEW: "$1 Meddelelser: Klik her for at få vist detaljer", TOAST_ACCORDION_MANY: "$1 Meddelelser: Klik her for at få vist detaljer", TOAST_ACCORDION_OTHER: "$1 Meddelelser: Klik her for at få vist detaljer", TOAST_ACCORDION_TWO: "$1 Meddelelser: Klik her for at få vist detaljer", TOAST_ALT_ERROR: "Fejl", TOAST_ALT_INFO: "Oplysninger", TOAST_ALT_SUCCESS: "Fuldført", TOAST_ALT_WARN: "Advarsel!", TOAST_DISMISS_BUTTON: "Afvis", TOAST_TITLE_ALT: "Meddelelse", TRANSCRIPT_ARIA_LABEL_ALT: "Chat-historik. Tryk på piletasterne for at navigere.", TRANSCRIPT_ARIA_ROLE_ALT: "chathistorik", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Meddelelsen er interaktiv. Tryk på Skift og tabulatortast 2 til 3 gange for at skifte til chathistorikken. Klik derefter på meddelelsen for at interagere.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Ét eller flere links i meddelelsen. Tryk på Skift og tabulatortast 2 til 3 gange for at skifte til chathistorikken. Klik derefter på meddelelsen for at interagere.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Meddelelsen har foreslåede handlinger. Tryk på skift tab 2 til 3 gange for at vælge dem.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Meddelelsen har foreslåede handlinger. Tryk på $1 for at vælge dem.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Meddelelsen blev ikke sendt.", TRANSCRIPT_MORE_MESSAGES: "Flere meddelelser", TRANSCRIPT_NEW_MESSAGES: "Nye meddelelser", TRANSCRIPT_TERMINATOR_TEXT: "Slut på chathistorik", TYPING_INDICATOR_ALT: "Viser indtastningsindikator", TYPING_INDICATOR_SINGLE_TEXT: "$1 skriver.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 og andre skriver.", VOTE_DISLIKE_ALT: "Synes ikke om", VOTE_LIKE_ALT: "Synes om" }, UMe = { _comment: "[CI-LOCKED] Der Inhalt dieser Datei ist gesperrt. Beiträge sind willkommen, die Änderungsüberprüfung kann jedoch verzögert werden.", ACCESS_KEY_ALT: "ALT UMSCHALT $1", ACCESS_KEY_FOR_MAC_ALT: "CONTROL OPTION $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 sagte:", ACTIVITY_YOU_SAID_ALT: "Sie sagten:", ACTIVITY_BOT_ATTACHED_ALT: "Bot angefügt:", ACTIVITY_ERROR_BOX_TITLE: "Fehlermeldung", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Zum Interagieren klicken.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Die Nachricht ist interaktiv.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Die Nachricht enthält mindestens einen Link.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Fehler beim Senden.", ACTIVITY_YOU_ATTACHED_ALT: "Sie haben angefügt:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 Anhang.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 Anhänge.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 Anhänge.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 Anhänge.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 Anhänge.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Fehler beim Senden. [Wiederholen][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Wird gesendet ...", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Gesendet um $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Jetzt", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Vor einer Stunde", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Vor einer Minute", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Heute", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Gestern", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Fehler beim Analysieren der adaptiven Karte", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Fehler beim Rendern der adaptiven Karte", ATTACHMENT_AUDIO: "Ein Audioclip.", ATTACHMENT_CARD: "Eine Karte: $1 $2 $3", ATTACHMENT_FILE: "Eine Datei: $1", ATTACHMENT_IMAGE: "Ein Bild", ATTACHMENT_TEXT: "Ein Text: $1", ATTACHMENT_VIDEO: "Ein Videoclip", CAROUSEL_FLIPPER_NEXT_ALT: "Weiter", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Zurück", CITATION_MODEL_DIALOG_ALT: "Zitat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Verbunden", CONNECTIVITY_STATUS_ALT_CONNECTING: "Verbindung wird hergestellt ...", CONNECTIVITY_STATUS_ALT_FATAL: "Verbindung konnte nicht aufgebaut werden.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Netzwerkunterbrechung ist aufgetreten. Verbindung wird wiederhergestellt ...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Fehler beim Rendern. Überprüfen Sie die Konsole, oder wenden Sie sich an den Botentwickler.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Der Verbindungsvorgang dauert länger als erwartet.", CONNECTIVITY_STATUS_ALT: "Verbindungsstatus: $1", FILE_CONTENT_ALT: "„$1“", FILE_CONTENT_DOWNLOADABLE_ALT: "Datei „$1“ herunterladen", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Datei „$1“ mit einer Größe von $2 herunterladen", FILE_CONTENT_WITH_SIZE_ALT: "„$1“ mit einer Größe von $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Eingabetaste", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Auf Elemente in einer Nachricht zugreifen", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chatverlauf", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "ESC-Taste", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Meldung schließen", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `TAB-Taste
UMSCHALT + TAB-Taste`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Zwischen Elementen in einer Nachricht wechseln", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Pfeiltaste nach oben
Pfeiltaste nach unten`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Zwischen Nachrichten wechseln", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Eingabetaste", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Aktion durchführen", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `TAB-Taste
UMSCHALT + TAB-Taste`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Zwischen Elementen im Chatfenster wechseln", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chatfenster", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Schließen", KEYBOARD_HELP_HEADER: "Tastatursteuerung", MARKDOWN_EXTERNAL_LINK_ALT: "Wird in einem neuen Fenster geöffnet, extern.", RECEIPT_CARD_TAX: "Steuer", RECEIPT_CARD_TOTAL: "Gesamt", RECEIPT_CARD_VAT: "Umsatzsteuer", REFERENCE_LIST_HEADER_ONE: "$1 Verweis", REFERENCE_LIST_HEADER_FEW: "$1 Verweise", REFERENCE_LIST_HEADER_MANY: "$1 Verweise", REFERENCE_LIST_HEADER_OTHER: "$1 Verweise", REFERENCE_LIST_HEADER_TWO: "$1 Verweise", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Eine leere Nachricht kann nicht gesendet werden.", SPEECH_INPUT_LISTENING: "Zuhören ...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon aus", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon an", SPEECH_INPUT_STARTING: "Wird gestartet ...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Weiter", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Zurück", SUGGESTED_ACTIONS_LABEL_ALT: "Empfohlene Aktionen", TEXT_INPUT_ALT: "Eingabefeld für Nachricht", TEXT_INPUT_PLACEHOLDER: "Nachricht eingeben", TEXT_INPUT_SEND_BUTTON_ALT: "Senden", TEXT_INPUT_SPEAK_BUTTON_ALT: "Sprechen", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Datei hochladen", TOAST_ACCORDION_FEW: "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.", TOAST_ACCORDION_MANY: "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.", TOAST_ACCORDION_OTHER: "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.", TOAST_ACCORDION_TWO: "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.", TOAST_ALT_ERROR: "Fehler", TOAST_ALT_INFO: "Informationen", TOAST_ALT_SUCCESS: "Erfolg", TOAST_ALT_WARN: "Warnung", TOAST_DISMISS_BUTTON: "Schließen", TOAST_TITLE_ALT: "Benachrichtigung", TRANSCRIPT_ARIA_LABEL_ALT: "Zum Navigieren im Chatverlauf die Pfeiltasten verwenden.", TRANSCRIPT_ARIA_ROLE_ALT: "Chatverlauf", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Die Nachricht ist interaktiv. Drücken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Die Nachricht enthält mindestens einen Link. Drücken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "In der Nachricht sind Aktionen vorgeschlagen worden. Drücken Sie die UMSCHALT + TAB-Taste 2 bis 3 Mal, um sie auszuwählen.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "In der Nachricht sind Aktionen vorgeschlagen worden. Drücken Sie $1, um sie auszuwählen.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Fehler beim Senden der Nachricht.", TRANSCRIPT_MORE_MESSAGES: "Weitere Meldungen", TRANSCRIPT_NEW_MESSAGES: "Neue Nachrichten", TRANSCRIPT_TERMINATOR_TEXT: "Ende des Chatverlaufs", TYPING_INDICATOR_ALT: "Anzeigen des Eingabeindikators", TYPING_INDICATOR_SINGLE_TEXT: "$1 gibt gerade ein.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 und weitere geben gerade ein.", VOTE_DISLIKE_ALT: "Mit „Gefällt mir nicht“ markieren", VOTE_LIKE_ALT: "Mit „Gefällt mir“ markieren" }, VMe = { _comment: "[CI-LOCKED] Το περιεχόμενο αυτού του αρχείου είναι κλειδωμένο. Οι συνεισφορές είναι ευπρόσδεκτες, αλλά η επικύρωση αλλαγών μπορεί να καθυστερήσει.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Το bot $1 είπε:", ACTIVITY_YOU_SAID_ALT: "Είπατε:", ACTIVITY_BOT_ATTACHED_ALT: "Συνημμένο bot:", ACTIVITY_ERROR_BOX_TITLE: "Μήνυμα σφάλματος", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Κάντε κλικ για διαδραστική χρήση.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Το μήνυμα έχει αλληλεπίδραση.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Μία ή περισσότερες συνδέσεις στο μήνυμα.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Η αποστολή απέτυχε.", ACTIVITY_YOU_ATTACHED_ALT: "Επισυνάψατε:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 συνημμένο.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 συνημμένα.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 συνημμένα.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 συνημμένα.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 συνημμένα.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Η αποστολή απέτυχε. [Επανάληψη][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Αποστολή", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Στάλθηκε στις $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Μόλις τώρα", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Πριν από μία ώρα", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Πριν από ένα λεπτό", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Σήμερα", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Εχθές", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Σφάλμα ανάλυσης προσαρμοστικής κάρτας", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Σφάλμα απόδοσης προσαρμοστικής κάρτας", ATTACHMENT_AUDIO: "Ένα απόσπασμα ήχου.", ATTACHMENT_CARD: "Μια κάρτα: $1 $2 $3", ATTACHMENT_FILE: "Ένα αρχείο: $1", ATTACHMENT_IMAGE: "Μια εικόνα", ATTACHMENT_TEXT: "Ένα κείμενο: $1", ATTACHMENT_VIDEO: "Ένα απόσπασμα βίντεο", CAROUSEL_FLIPPER_NEXT_ALT: "Επόμενο", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Προηγούμενο", CITATION_MODEL_DIALOG_ALT: "Παραπομπή", CONNECTIVITY_STATUS_ALT_CONNECTED: "Συνδέθηκε", CONNECTIVITY_STATUS_ALT_CONNECTING: "Σύνδεση…", CONNECTIVITY_STATUS_ALT_FATAL: "Αδυναμία σύνδεσης.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Παρουσιάστηκε διακοπή δικτύου. Επανασύνδεση...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Σφάλμα απόδοσης. Ελέγξτε την κονσόλα ή επικοινωνήστε με τον προγραμματιστή bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Η σύνδεση διαρκεί περισσότερο χρόνο από το συνηθισμένο.", CONNECTIVITY_STATUS_ALT: "Κατάσταση συνδεσιμότητας: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Λήψη αρχείου "$1"', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Λήψη αρχείου "$1" μεγέθους $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" μεγέθους $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Πλήκτρο Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Πρόσβαση σε στοιχεία στο μήνυμα", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Ιστορικό συνομιλίας", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Πλήκτρο Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Μήνυμα εξόδου", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Πλήκτρο Tab
Shift + πλήκτρο Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Μετακινηθείτε μεταξύ στοιχείων σε ένα μήνυμα", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Πλήκτρο βέλους προς τα επάνω
Πλήκτρο βέλους προς τα κάτω`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Μετακίνηση μεταξύ μηνυμάτων", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Πλήκτρο Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Εκτέλεση ενέργειας", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Πλήκτρο Tab
Shift + πλήκτρο Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Μετακίνηση μεταξύ στοιχείων στο παράθυρο συνομιλίας", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Παράθυρο συνομιλίας", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Κλείσιμο", KEYBOARD_HELP_HEADER: "Στοιχεία ελέγχου πληκτρολόγιου", MARKDOWN_EXTERNAL_LINK_ALT: "Ανοίγει νέο παράθυρο – εξωτερικό.", RECEIPT_CARD_TAX: "Φόρος", RECEIPT_CARD_TOTAL: "Σύνολο", RECEIPT_CARD_VAT: "ΦΠΑ", REFERENCE_LIST_HEADER_ONE: "Αναφορά $1", REFERENCE_LIST_HEADER_FEW: "Αναφορές $1", REFERENCE_LIST_HEADER_MANY: "Αναφορές $1", REFERENCE_LIST_HEADER_OTHER: "Αναφορές $1", REFERENCE_LIST_HEADER_TWO: "Αναφορές $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Δεν είναι η αποστολή κενού μηνύματος.", SPEECH_INPUT_LISTENING: "Ακρόαση...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Μικρόφωνο ανενεργό", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Μικρόφωνο ενεργό", SPEECH_INPUT_STARTING: "Έναρξη…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Επόμενο", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Προηγούμενο", SUGGESTED_ACTIONS_LABEL_ALT: "Προτεινόμενες ενέργειες", TEXT_INPUT_ALT: "Πλαίσιο εισαγωγής μηνύματος", TEXT_INPUT_PLACEHOLDER: "Πληκτρολογήστε το μήνυμά σας", TEXT_INPUT_SEND_BUTTON_ALT: "Αποστολή", TEXT_INPUT_SPEAK_BUTTON_ALT: "Ομιλία", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Αποστολή αρχείου", TOAST_ACCORDION_FEW: "$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες", TOAST_ACCORDION_MANY: "$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες", TOAST_ACCORDION_OTHER: "$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες", TOAST_ACCORDION_TWO: "$1 Ειδοποιήσεις: Κάντε κλικ εδώ για να δείτε λεπτομέρειες", TOAST_ALT_ERROR: "Σφάλμα", TOAST_ALT_INFO: "Πληροφορίες", TOAST_ALT_SUCCESS: "Επιτυχία", TOAST_ALT_WARN: "Προειδοποίηση", TOAST_DISMISS_BUTTON: "Ματαίωση", TOAST_TITLE_ALT: "Ειδοποίηση", TRANSCRIPT_ARIA_LABEL_ALT: "Ιστορικό συνομιλίας, πιέστε τα πλήκτρα βέλους για περιήγηση.", TRANSCRIPT_ARIA_ROLE_ALT: "ιστορικό συνομιλίας", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Το μήνυμα είναι αλληλεπιδραστικό. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να μεταβείτε στο ιστορικό συνομιλίας. Στη συνέχεια, κάντε κλικ στο μήνυμα για αλληλεπίδραση.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Μία ή περισσότερες συνδέσεις στο μήνυμα. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να μεταβείτε στο ιστορικό συνομιλίας. Στη συνέχεια, κάντε κλικ στο μήνυμα για αλληλεπίδραση.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Το μήνυμα έχει προτεινόμενες ενέργειες. Πιέστε τον συνδυασμό πλήκτρων Shift και Tab 2 έως 3 φορές για να τις επιλέξετε.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Το μήνυμα έχει προτεινόμενες ενέργειες. Πιέστε $1 για να τις επιλέξετε.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Δεν ήταν δυνατή η αποστολή του μηνύματος.", TRANSCRIPT_MORE_MESSAGES: "Περισσότερα μηνύματα", TRANSCRIPT_NEW_MESSAGES: "Νέα μηνύματα", TRANSCRIPT_TERMINATOR_TEXT: "Λήξη ιστορικού συνομιλίας", TYPING_INDICATOR_ALT: "Εμφάνιση δείκτη πληκτρολόγησης", TYPING_INDICATOR_SINGLE_TEXT: "Ο/Η $1 πληκτρολογεί.", TYPING_INDICATOR_MULTIPLE_TEXT: "Ο/Η $1 και άλλοι πληκτρολογούν.", VOTE_DISLIKE_ALT: "Δεν μου αρέσει", VOTE_LIKE_ALT: "Μου αρέσει" }, jMe = { _comment: "[CI-LOCKED] The content of this file is locked. Contributions are welcome, but change validation may be delayed.", ACCESS_KEY_ALT: "Alt Shift $1", "_ACCESS_KEY_ALT.comment": "These are keyboard modifier keys for screen reader.", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", "_ACCESS_KEY_FOR_MAC_ALT.comment": "These are keyboard modifier keys for screen reader on a Mac.", ACTIVITY_BOT_SAID_ALT: "Bot $1 said:", "_ACTIVITY_BOT_SAID_ALT.comment": 'This is for screen reader only. $1 is the initials for the bot (e.g. "JD").', ACTIVITY_YOU_SAID_ALT: "You said:", "_ACTIVITY_YOU_SAID_ALT.comment": "This is for screen reader only.", ACTIVITY_BOT_ATTACHED_ALT: "Bot attached:", "_ACTIVITY_BOT_ATTACHED_ALT.comment": "This is for screen reader and is narrated before each attachments sent by the bot.", ACTIVITY_ERROR_BOX_TITLE: "Error message", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Click to interact.", "_ACTIVITY_INTERACTIVE_FOOTNOTE_ALT.comment": "This is for screen reader. When the user is navigating to this message which is either contains interactive elements, contains links, or failed to send (with a retry button), it will give this hint.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Message is interactive.", "_ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT.comment": "This is for screen reader. When the user is navigating to this message which contains interactive elements (excluding links), it will give this hint.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "One or more links in the message.", "_ACTIVITY_INTERACTIVE_REASON_LINK_ALT.comment": "This is for screen reader. When the user is navigating to this message which contains links, it will give this hint.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Send failed.", "_ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT.comment": "This is for screen reader. When the user is navigating to this message which was failed to send, it will give this hint.", ACTIVITY_YOU_ATTACHED_ALT: "You attached:", "_ACTIVITY_YOU_ATTACHED_ALT.comment": "This is for screen reader and is narrated before each attachments sent by the user.", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 attachment.", "_ACTIVITY_NUM_ATTACHMENTS_ONE_ALT.comment": 'This is for screen reader and only narrated when the message arrive. The narration when the message arrive, could be "Bot WC said: Hello, World! 1 attachment. Sent at 2020-01-02 12:34 PM.". This is for plural rule of "one".', ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 attachments.", "_ACTIVITY_NUM_ATTACHMENTS_FEW_ALT.comment": '$1 is the number of attachments. This is for plural rule of "few".', ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 attachments.", "_ACTIVITY_NUM_ATTACHMENTS_MANY_ALT.comment": '$1 is the number of attachments. This is for plural rule of "many".', ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 attachments.", "_ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT.comment": '$1 is the number of attachments. This is for plural rule of "other".', ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 attachments.", "_ACTIVITY_NUM_ATTACHMENTS_TWO_ALT.comment": '$1 is the number of attachments. This is for plural rule of "two".', ACTIVITY_STATUS_SEND_FAILED_RETRY: "Send failed. [Retry][RETRY].", "_ACTIVITY_STATUS_SEND_FAILED_RETRY.comment": 'This is Markdown. Do not localize "[RETRY]" (the one in uppercase).', ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Sending", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Sent at $1", "_ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT.comment": "$1 is the time when the message is successfully sent, in absolute format, e.g. 12:34 PM.", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Just now", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "An hour ago", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "A minute ago", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Today", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Yesterday", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Adaptive Card parse error", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Adaptive Card render error", ATTACHMENT_AUDIO: "An audio clip.", ATTACHMENT_CARD: "A card: $1 $2 $3", "_ATTACHMENT_CARD.comment": "$1 is the title of the card. $2 is the subtitle. $3 is the text content.", ATTACHMENT_FILE: "A file: $1", "_ATTACHMENT_FILE.comment": "$1 is the filename.", ATTACHMENT_IMAGE: "An image", ATTACHMENT_TEXT: "A text: $1", "_ATTACHMENT_TEXT.comment": "$1 is the content.", ATTACHMENT_VIDEO: "A video clip", CAROUSEL_FLIPPER_NEXT_ALT: "Next", "_CAROUSEL_FLIPPER_NEXT_ALT.comment": "This is for screen reader for the label of the right flipper button for carousels for left-to-right language or left flipper button for right-to-left (RTL) languages. To support RTL, the language used in this text should be less directional.", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Previous", "_CAROUSEL_FLIPPER_PREVIOUS_ALT.comment": "This is for screen reader for the label of the left flipper button for carousels for left-to-right language or right flipper button for right-to-left (RTL) languages. To support RTL, the language used in this text should be less directional.", CITATION_MODEL_DIALOG_ALT: "Citation", "_CITATION_MODEL_DIALOG_ALT.comment": "This is for screen reader. This is the title of a modal dialog showing citation. When end-user clicks on a citation marker in the bot response, this citation modal dialog will open and show citation related to the marker.", CONNECTIVITY_STATUS_ALT_CONNECTED: "Connected", CONNECTIVITY_STATUS_ALT_CONNECTING: "Connecting…", CONNECTIVITY_STATUS_ALT_FATAL: "Unable to connect.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Network interruption occurred. Reconnecting…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Render error. Please check the console or contact the bot developer.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Taking longer than usual to connect.", CONNECTIVITY_STATUS_ALT: "Connectivity Status: $1", "_CONNECTIVITY_STATUS_ALT.comment": 'This is for screen reader. $1 will be one of "CONNECTIVITY_STATUS_ALT_"*.', FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Download file '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Download file '$1' of size $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' of size $2", "_FILE_CONTENT_ALT.comment": "$1 is the name of the file, e.g. document.docx. $2 is the file size, e.g. 12 MB", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter key", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Access items in message", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chat history", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape key", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Exit message", "_KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER.comment": "While focus is on the message, when the user press ESCAPE key, it should exit the message focus mode and focus back on the text box in the send box.", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab key
Shift + tab key`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Move between items in a message", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Arrow up key
Arrow down key`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Move between messages", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter key", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Do action", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab key
Shift + tab key`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Move between items in the chat window", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chat window", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Close", KEYBOARD_HELP_HEADER: "Keyboard controls", MARKDOWN_EXTERNAL_LINK_ALT: "Opens in a new window; external.", "_MARKDOWN_EXTERNAL_LINK_ALT.comment": "This is for the screen reader and is added to the label of the hyperlink. When clicked, the hyperlink will open in a new tab or window.", RECEIPT_CARD_TAX: "Tax", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "$1 reference", "_REFERENCE_LIST_HEADER_ONE.comment": 'Header of the expand/collapse of reference list. This is for plural rule of "one".', REFERENCE_LIST_HEADER_FEW: "$1 references", "_REFERENCE_LIST_HEADER_FEW.comment": 'Header of the expand/collapse of reference list. This is for plural rule of "few".', REFERENCE_LIST_HEADER_MANY: "$1 references", "_REFERENCE_LIST_HEADER_MANY.comment": 'Header of the expand/collapse of reference list. This is for plural rule of "many".', REFERENCE_LIST_HEADER_OTHER: "$1 references", "_REFERENCE_LIST_HEADER_OTHER.comment": 'Header of the expand/collapse of reference list. This is for plural rule of "other".', REFERENCE_LIST_HEADER_TWO: "$1 references", "_REFERENCE_LIST_HEADER_TWO.comment": 'Header of the expand/collapse of reference list. This is for plural rule of "two".', SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Cannot send empty message.", "_SEND_BOX_IS_EMPTY_TOOLTIP_ALT.comment": "This is for screen reader on the send button. When the send text box is empty, the send button is disabled and this text on the send button explain why the button is disabled.", SPEECH_INPUT_LISTENING: "Listening…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microphone off", "_SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT.comment": "This is for screen reader and is the label of the microphone button, when clicked, will close microphone.", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microphone on", "_SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT.comment": "This is for screen reader and is the label of the microphone button, when clicked, will open microphone.", SPEECH_INPUT_STARTING: "Starting…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Next", "_SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT.comment": "This is for screen reader for the label of the right flipper button for suggested actions. Probably can re-use the value from CAROUSEL_FLIPPER_NEXT_ALT.", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Previous", "_SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT.comment": "This is for screen reader for the label of the left flipper button for suggested actions. Probably can re-use the value from CAROUSEL_FLIPPER_PREVIOUS_ALT.", SUGGESTED_ACTIONS_LABEL_ALT: "Suggested actions", "_SUGGESTED_ACTIONS_LABEL_ALT.comment": 'This is for screen reader. Browser will read as "Suggested actions toolbar", where "toolbar" is a role name appended by browser.', TEXT_INPUT_ALT: "Message input box", "_TEXT_INPUT_ALT.comment": "This is for screen reader for the label of the message input box.", TEXT_INPUT_PLACEHOLDER: "Type your message", TEXT_INPUT_SEND_BUTTON_ALT: "Send", TEXT_INPUT_SPEAK_BUTTON_ALT: "Speak", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Upload file", TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT: "Telephone keypad", TEXT_INPUT_DROP_ZONE: "Drop files", TEXT_INPUT_LENGTH_EXCEEDED_ALT: "Message length exceeded", TELEPHONE_KEYPAD_INPUT_MESSAGE: "Only supports single-digit input", TEXT_INPUT_ATTACHMENTS_FEW: "$1 attachments", "_TEXT_INPUT_ATTACHMENTS_FEW.comment": '$1 is the number of attachments. This is for plural rule of "few".', TEXT_INPUT_ATTACHMENTS_MANY: "$1 attachments", "_TEXT_INPUT_ATTACHMENTS_MANY.comment": '$1 is the number of attachments. This is for plural rule of "many".', TEXT_INPUT_ATTACHMENTS_ONE: "1 attachment", "_TEXT_INPUT_ATTACHMENTS_ONE.comment": '$1 is the number of attachments. This is for plural rule of "one".', TEXT_INPUT_ATTACHMENTS_OTHER: "$1 attachments", "_TEXT_INPUT_ATTACHMENTS_OTHER.comment": '$1 is the number of attachments. This is for plural rule of "other".', TEXT_INPUT_ATTACHMENTS_TWO: "$1 attachments", "_TEXT_INPUT_ATTACHMENTS_TWO.comment": '$1 is the number of attachments. This is for plural rule of "two".', TOAST_ACCORDION_FEW: "$1 Notifications: Click here to see details", "_TOAST_ACCORDION_FEW.comment": '$1 is the number of notifications. This is for plural rule of "few".', TOAST_ACCORDION_MANY: "$1 Notifications: Click here to see details", "_TOAST_ACCORDION_MANY.comment": '$1 is the number of notifications. This is for plural rule of "many".', TOAST_ACCORDION_OTHER: "$1 Notifications: Click here to see details", "_TOAST_ACCORDION_OTHER.comment": '$1 is the number of notifications. This is for plural rule of "other".', TOAST_ACCORDION_TWO: "$1 Notifications: Click here to see details", "_TOAST_ACCORDION_TWO.comment": '$1 is the number of notifications. This is for plural rule of "two".', TOAST_ALT_ERROR: "Error", "_TOAST_ALT_ERROR.comment": "This is for screen reader.", TOAST_ALT_INFO: "Information", "_TOAST_ALT_INFO.comment": "This is for screen reader.", TOAST_ALT_SUCCESS: "Success", "_TOAST_ALT_SUCCESS.comment": "This is for screen reader.", TOAST_ALT_WARN: "Warning", "_TOAST_ALT_WARN.comment": "This is for screen reader.", TOAST_DISMISS_BUTTON: "Dismiss", TOAST_TITLE_ALT: "Notification", "_TOAST_TITLE_ALT.comment": "This is for screen reader. The label for individiual notification.", TRANSCRIPT_ARIA_LABEL_ALT: "Chat history, press arrow keys to navigate.", "_TRANSCRIPT_ARIA_LABEL_ALT.comment": "This is for screen reader for the label that will be narrated when the chat history is focused.", TRANSCRIPT_ARIA_ROLE_ALT: "chat history", "_TRANSCRIPT_ARIA_ROLE_ALT.comment": "This is for screen reader for the aria-roledescription of the chat history container.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Message is interactive. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact.", "_TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT.comment": "This is for screen reader. When one or more activities arrived with interactive elements (no links) attached, the chat history (live region) will give this hint.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "One or more links in the message. Press shift tab key 2 to 3 times to switch to the chat history. Then click on the message to interact.", "_TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT.comment": "This is for screen reader. When one or more activities arrived with links attached, the chat history (live region) will give this hint.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Message has suggested actions. Press shift tab 2 to 3 times to select them.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Message has suggested actions. Press $1 to select them.", "_TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT.comment": '$1 will be "ACCESS_KEY_ALT".', TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Failed to send message.", TRANSCRIPT_MORE_MESSAGES: "More messages", TRANSCRIPT_NEW_MESSAGES: "New messages", TRANSCRIPT_TERMINATOR_TEXT: "End of chat history", TYPING_INDICATOR_ALT: "Showing typing indicator", "_TYPING_INDICATOR_SINGLE_TEXT.comment": "This shows when a single user is typing.", TYPING_INDICATOR_SINGLE_TEXT: "$1 is typing.", "_TYPING_INDICATOR_MULTIPLE_TEXT.comment": "This shows when two or more users are typing simultaneously.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 and others are typing.", VOTE_DISLIKE_ALT: "Dislike", "_VOTE_DISLIKE_ALT.comment": "This is for screen reader. The label of a button with a thumb up icon and is placed next to the timestamp. The button is for giving feedback that the end-user don't think the response is useful.", VOTE_LIKE_ALT: "Like", "_VOTE_LIKE_ALT.comment": "This is for screen reader. The label of a button with a thumb up icon and is placed next to the timestamp. The button is for giving feedback that the end-user think the response is useful." }, zMe = { _comment: "[CI-LOCKED] El contenido de este archivo está bloqueado. Todas las aportaciones son bienvenidas, pero la validación de cambios se puede retrasar.", ACCESS_KEY_ALT: "Alt Mayús $1", ACCESS_KEY_FOR_MAC_ALT: "Control Opción $1", ACTIVITY_BOT_SAID_ALT: "El bot $1 dijo:", ACTIVITY_YOU_SAID_ALT: "Usted dijo:", ACTIVITY_BOT_ATTACHED_ALT: "Bot adjunto:", ACTIVITY_ERROR_BOX_TITLE: "Mensaje de error", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Haga clic para interactuar.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "El mensaje es interactivo.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Uno o varios vínculos en el mensaje.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Errores de envío.", ACTIVITY_YOU_ATTACHED_ALT: "Usted adjuntó:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 archivo adjunto.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 datos adjuntos.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 datos adjuntos.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 datos adjuntos.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 datos adjuntos.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "No se pudo enviar. [Reintentar][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Enviando", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Enviado a las $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Ahora mismo", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Hace una hora", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Hace un minuto", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hoy", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ayer", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Error de análisis de tarjeta adaptable", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Error de representación de tarjeta adaptable", ATTACHMENT_AUDIO: "Clip de audio.", ATTACHMENT_CARD: "Tarjeta: $1 $2 $3", ATTACHMENT_FILE: "Archivo: $1", ATTACHMENT_IMAGE: "Imagen", ATTACHMENT_TEXT: "Texto: $1", ATTACHMENT_VIDEO: "Clip de vídeo", CAROUSEL_FLIPPER_NEXT_ALT: "Siguiente", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Anterior", CITATION_MODEL_DIALOG_ALT: "Cita", CONNECTIVITY_STATUS_ALT_CONNECTED: "Conectado", CONNECTIVITY_STATUS_ALT_CONNECTING: "Conectando…", CONNECTIVITY_STATUS_ALT_FATAL: "No se puede conectar.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Interrupción de la red. Conectando de nuevo…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Error de representación. Compruebe la consola o póngase en contacto con el desarrollador del bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Se está tardando más de lo habitual en conectarse.", CONNECTIVITY_STATUS_ALT: "Estado de conexión: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Descargar archivo '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Descargar el archivo '$1' de tamaño $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' de tamaño $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tecla Entrar", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Acceder a elementos del mensaje", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historial de chats", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tecla Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Salir del mensaje", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tecla Tab
Teclas Mayús + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Moverse entre elementos de un mensaje", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tecla Flecha arriba
Tecla Flecha abajo`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Moverse entre mensajes", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tecla Entrar", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Ejecutar acción", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tecla Tab
Teclas Mayús + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Moverse entre elementos de la ventana de chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Ventana de chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Cerrar", KEYBOARD_HELP_HEADER: "Controles de teclado", MARKDOWN_EXTERNAL_LINK_ALT: "Se abre en una ventana nueva; externo.", RECEIPT_CARD_TAX: "Impuesto", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "IVA", REFERENCE_LIST_HEADER_ONE: "$1 referencia", REFERENCE_LIST_HEADER_FEW: "$1 referencias", REFERENCE_LIST_HEADER_MANY: "$1 referencias", REFERENCE_LIST_HEADER_OTHER: "$1 referencias", REFERENCE_LIST_HEADER_TWO: "$1 referencias", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "No se puede enviar un mensaje vacío.", SPEECH_INPUT_LISTENING: "Escuchando…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Micrófono desactivado", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Micrófono activado", SPEECH_INPUT_STARTING: "Iniciando…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Siguiente", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Anterior", SUGGESTED_ACTIONS_LABEL_ALT: "Acciones sugeridas", TEXT_INPUT_ALT: "Cuadro de entrada de mensajes", TEXT_INPUT_PLACEHOLDER: "Escriba su mensaje", TEXT_INPUT_SEND_BUTTON_ALT: "Enviar", TEXT_INPUT_SPEAK_BUTTON_ALT: "Hablar", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Cargar archivo", TOAST_ACCORDION_FEW: "$1 notificaciones: Haga clic aquí para ver más detalles", TOAST_ACCORDION_MANY: "$1 notificaciones: Haga clic aquí para ver más detalles", TOAST_ACCORDION_OTHER: "$1 notificaciones: Haga clic aquí para ver más detalles", TOAST_ACCORDION_TWO: "$1 notificaciones: Haga clic aquí para ver más detalles", TOAST_ALT_ERROR: "Error", TOAST_ALT_INFO: "Información", TOAST_ALT_SUCCESS: "Correcta", TOAST_ALT_WARN: "Advertencia", TOAST_DISMISS_BUTTON: "Descartar", TOAST_TITLE_ALT: "Notificación", TRANSCRIPT_ARIA_LABEL_ALT: "Historial de chats, presione las teclas de dirección para navegar.", TRANSCRIPT_ARIA_ROLE_ALT: "historial de chats", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "El mensaje es interactivo. Presione Mayús + Tab de 2 a 3 veces para cambiar al historial de chats. Después, haga clic en el mensaje para interactuar.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "El mensaje contiene uno o varios vínculos. Presione Mayús +Tab de 2 a 3 veces para cambiar al historial de chats. Después, haga clic en el mensaje para interactuar.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "El mensaje ha sugerido acciones. Presione Mayús + Tab de 2 a 3 veces para seleccionarlas.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "El mensaje ha sugerido acciones. Presione $1 para seleccionarlas.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "No se pudo enviar el mensaje.", TRANSCRIPT_MORE_MESSAGES: "Más mensajes", TRANSCRIPT_NEW_MESSAGES: "Mensajes nuevos", TRANSCRIPT_TERMINATOR_TEXT: "Final del historial de chats", TYPING_INDICATOR_ALT: "Mostrando indicador de escritura", TYPING_INDICATOR_SINGLE_TEXT: "$1 está escribiendo.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 y otros usuarios están escribiendo.", VOTE_DISLIKE_ALT: "No me gusta", VOTE_LIKE_ALT: "Me gusta" }, qMe = { _comment: "[CI-LOCKED] Selle faili sisu on lukus. Panused on teretulnud, kuid muudatuste valideerimine võib aega võtta.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Robot $1 ütles:", ACTIVITY_YOU_SAID_ALT: "Te ütlesite:", ACTIVITY_BOT_ATTACHED_ALT: "Manustatud robot:", ACTIVITY_ERROR_BOX_TITLE: "Tõrketeade", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klõpsake kasutamiseks.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Sõnum on interaktiivne.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Sõnumis on vähemalt üks link.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Saatmine nurjus.", ACTIVITY_YOU_ATTACHED_ALT: "Manustasite:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 manus.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 manust.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 manust.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 manust.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 manust.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Saatmine nurjus. [Proovi uuesti][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Saatmine", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Saadetud kell $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Just praegu", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Tund tagasi", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Minut tagasi", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Täna", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Eile", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Kohandatava kaardi sõelumise tõrge", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Kohandatava kaardi renderdamise tõrge", ATTACHMENT_AUDIO: "Heliklipp.", ATTACHMENT_CARD: "Kaart: $1 $2 $3", ATTACHMENT_FILE: "Fail: $1", ATTACHMENT_IMAGE: "Pilt", ATTACHMENT_TEXT: "Tekst: $1", ATTACHMENT_VIDEO: "Videoklipp", CAROUSEL_FLIPPER_NEXT_ALT: "Järgmine", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Eelmine", CITATION_MODEL_DIALOG_ALT: "Tsitaat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Ühendatud", CONNECTIVITY_STATUS_ALT_CONNECTING: "Ühenduse loomine…", CONNECTIVITY_STATUS_ALT_FATAL: "Ühendamine nurjus.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Ilmnes võrgukatkestus. Uuesti ühendamine…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Renderdamise tõrge. Kontrollige konsooli või pöörduge roboti arendaja poole.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Ühenduse loomiseks läheb tavapärasest kauem aega.", CONNECTIVITY_STATUS_ALT: "Ühenduse olek: $1", FILE_CONTENT_ALT: "„$1“", FILE_CONTENT_DOWNLOADABLE_ALT: "Laadi alla fail „$1“", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Laadi alla fail „$1” mahuga $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1” mahuga $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Sisestusklahv", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Juurdepääs sõnumi üksustele", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Vestluse ajalugu", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Paoklahv", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Välju sõnumist", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabeldusklahv
Tõstuklahv + tabeldusklahv`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Sõnumis ühest üksusest teise liikumine", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Ülesnooleklahv
Allanooleklahv`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Ühest sõnumist teise liikumine", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Sisestusklahv", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Tee toiming", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabeldusklahv
Tõstuklahv + tabeldusklahv`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Vestlusaknas ühest üksusest teise liikumine", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Vestlusaken", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Sule", KEYBOARD_HELP_HEADER: "Klaviatuuri juhtelemendid", MARKDOWN_EXTERNAL_LINK_ALT: "Avab uues aknas; väline.", RECEIPT_CARD_TAX: "Maks", RECEIPT_CARD_TOTAL: "Kokku", RECEIPT_CARD_VAT: "KM", REFERENCE_LIST_HEADER_ONE: "$1 viide", REFERENCE_LIST_HEADER_FEW: "$1 viidet", REFERENCE_LIST_HEADER_MANY: "$1 viidet", REFERENCE_LIST_HEADER_OTHER: "$1 viidet", REFERENCE_LIST_HEADER_TWO: "$1 viidet", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Tühja sõnumit ei saa saata.", SPEECH_INPUT_LISTENING: "Kuulamine…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon väljas", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon sees", SPEECH_INPUT_STARTING: "Algus…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Järgmine", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Eelmine", SUGGESTED_ACTIONS_LABEL_ALT: "Soovitatavad tegevused", TEXT_INPUT_ALT: "Sõnumi sisestuse väli", TEXT_INPUT_PLACEHOLDER: "Tippige oma sõnum", TEXT_INPUT_SEND_BUTTON_ALT: "Saada", TEXT_INPUT_SPEAK_BUTTON_ALT: "Räägi", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Laadi fail üles", TOAST_ACCORDION_FEW: "$1 teatist: üksikasjade kuvamiseks klõpsake siin", TOAST_ACCORDION_MANY: "$1 teatist: üksikasjade kuvamiseks klõpsake siin", TOAST_ACCORDION_OTHER: "$1 teatist: üksikasjade kuvamiseks klõpsake siin", TOAST_ACCORDION_TWO: "$1 teatist: üksikasjade kuvamiseks klõpsake siin", TOAST_ALT_ERROR: "Tõrge", TOAST_ALT_INFO: "Teave", TOAST_ALT_SUCCESS: "Tehtud", TOAST_ALT_WARN: "Hoiatus", TOAST_DISMISS_BUTTON: "Sule", TOAST_TITLE_ALT: "Teatis", TRANSCRIPT_ARIA_LABEL_ALT: "Vestluse ajalugu, navigeerimiseks vajutage nooleklahvi.", TRANSCRIPT_ARIA_ROLE_ALT: "vestluse ajalugu", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Sõnum on interaktiivne. Vestluse ajaloo avamiseks vajutage 2–3 korda tõstu- ja tabeldusklahvi. Seejärel klõpsake suhtlemiseks sõnumit.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Sõnumis on vähemalt üks link. Vestluse ajaloo avamiseks vajutage 2–3 korda tõstu- ja tabeldusklahvi. Seejärel klõpsake suhtlemiseks sõnumit.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Sõnumil on soovitatavad tegevused. Nende valimiseks vajutage 2–3 korda klahvi Shift.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Sõnumil on soovitatavad tegevused. Nende valimiseks vajutage $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Sõnumi saatmine nurjus.", TRANSCRIPT_MORE_MESSAGES: "Rohkem sõnumeid", TRANSCRIPT_NEW_MESSAGES: "Uued sõnumid", TRANSCRIPT_TERMINATOR_TEXT: "Vestluse ajaloo lõpp", TYPING_INDICATOR_ALT: "Tippimise näidiku kuvamine", TYPING_INDICATOR_SINGLE_TEXT: "$1 kirjutab.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 ja teised kirjutavad.", VOTE_DISLIKE_ALT: "Ei meeldi", VOTE_LIKE_ALT: "Meeldib" }, YMe = { _comment: "[CI-LOCKED] Fitxategi honen edukia blokeatuta dago. Ekarpenak onartzen dira, baina baliteke aldaketen balidazioa atzeratzea.", ACCESS_KEY_ALT: "Alt + Maius + $1", ACCESS_KEY_FOR_MAC_ALT: "Ktrl + Aukera + $1", ACTIVITY_BOT_SAID_ALT: "$1 bot-ak hau esan du:", ACTIVITY_YOU_SAID_ALT: "Hau esan duzu:", ACTIVITY_BOT_ATTACHED_ALT: "Bot-ak hau erantsi du:", ACTIVITY_ERROR_BOX_TITLE: "Errore-mezua", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Sakatu hau interakzioa hasteko.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Mezua interaktiboa da.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Esteka bat edo gehiago dago mezuan.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Ezin izan da bidali.", ACTIVITY_YOU_ATTACHED_ALT: "Hau erantsi duzu:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 eranskin.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 eranskin.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 eranskin.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 eranskin.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 eranskin.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Ezin izan da bidali. [Saiatu berriro][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Bidaltzen", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Bidaltze-ordua: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Oraintxe bertan", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Duela ordubete", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Duela minutu bat", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Gaur", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Atzo", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Txartel moldagarriaren analisi-errorea", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Txartel moldagarriaren errendatze-errorea", ATTACHMENT_AUDIO: "Audio zati bat.", ATTACHMENT_CARD: "Txartel bat: $1 $2 $3", ATTACHMENT_FILE: "Fitxategi bat: $1", ATTACHMENT_IMAGE: "Irudi bat", ATTACHMENT_TEXT: "Testu bat: $1", ATTACHMENT_VIDEO: "Bideo zati bat", CAROUSEL_FLIPPER_NEXT_ALT: "Hurrengoa", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Aurrekoa", CITATION_MODEL_DIALOG_ALT: "Aipua", CONNECTIVITY_STATUS_ALT_CONNECTED: "Konektatu da", CONNECTIVITY_STATUS_ALT_CONNECTING: "Konektatzen…", CONNECTIVITY_STATUS_ALT_FATAL: "Ezin da konektatu.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Sareko konexioa eten egin da. Berriro konektatzen…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Errendatze-errorea. Egiaztatu kontsola edo jarri harremanetan botaren garatzailearekin.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Ohi baino denbora gehiago behar izaten ari gara konektatzeko.", CONNECTIVITY_STATUS_ALT: "Konexioaren egoera: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Deskargatu "$1" fitxategia', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Deskargatu "$1" fitxategia (tamaina: $2)', FILE_CONTENT_WITH_SIZE_ALT: '"$1" (tamaina: $2)', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: '"Sartu" tekla', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Atzitu mezuko elementuak", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Berriketa-historia", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Ihes tekla", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Irten mezutik", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulazio-tekla
Maius + tabulazio-tekla`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Mugitu mezu bateko elementuen artean", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Gora gezia
Behera gezia`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Mugitu mezuen artean", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: '"Sartu" tekla', KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Egin ekintza", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulazio-tekla
Maius + tabulazio-tekla`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Mugitu berriketa-leihoko elementuen artean", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Berriketaren leihoa", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Itxi", KEYBOARD_HELP_HEADER: "Teklatuaren kontrolak", MARKDOWN_EXTERNAL_LINK_ALT: "Beste leiho batean irekitzen da; kanpokoa.", RECEIPT_CARD_TAX: "Zerga", RECEIPT_CARD_TOTAL: "Guztira", RECEIPT_CARD_VAT: "BEZ", REFERENCE_LIST_HEADER_ONE: "$1 erreferentzia", REFERENCE_LIST_HEADER_FEW: "$1 erreferentzia", REFERENCE_LIST_HEADER_MANY: "$1 erreferentzia", REFERENCE_LIST_HEADER_OTHER: "$1 erreferentzia", REFERENCE_LIST_HEADER_TWO: "$1 erreferentzia", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Ezin da mezu hutsik bidali.", SPEECH_INPUT_LISTENING: "Entzuten…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofonoa desaktibatuta dago", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofonoa aktibatuta dago", SPEECH_INPUT_STARTING: "Hasten…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Hurrengoa", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Aurrekoa", SUGGESTED_ACTIONS_LABEL_ALT: "Iradokitako ekintzak", TEXT_INPUT_ALT: "Mezua idazteko koadroa", TEXT_INPUT_PLACEHOLDER: "Idatzi mezua", TEXT_INPUT_SEND_BUTTON_ALT: "Bidali", TEXT_INPUT_SPEAK_BUTTON_ALT: "Hitz egin", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Kargatu fitxategia", TOAST_ACCORDION_FEW: "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko", TOAST_ACCORDION_MANY: "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko", TOAST_ACCORDION_OTHER: "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko", TOAST_ACCORDION_TWO: "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko", TOAST_ALT_ERROR: "Errorea", TOAST_ALT_INFO: "Informazioa", TOAST_ALT_SUCCESS: "Gauzatu da", TOAST_ALT_WARN: "Abisua", TOAST_DISMISS_BUTTON: "Baztertu", TOAST_TITLE_ALT: "Jakinarazpena", TRANSCRIPT_ARIA_LABEL_ALT: "Berriketa-historia. Nabigatzeko, erabili Gora eta Behera geziak.", TRANSCRIPT_ARIA_ROLE_ALT: "berriketa-historia", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Mezua interaktiboa da. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz berriketa-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Esteka bat edo gehiago daude mezuan. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz berriketa-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu Maius fitxa 2 edo 3 aldiz.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Ezin izan da bidali mezua.", TRANSCRIPT_MORE_MESSAGES: "Mezu gehiago", TRANSCRIPT_NEW_MESSAGES: "Mezu berriak", TRANSCRIPT_TERMINATOR_TEXT: "Berriketa-historiaren amaiera", TYPING_INDICATOR_ALT: "Idazketa-adierazlea ikusgai dago", TYPING_INDICATOR_SINGLE_TEXT: "$1 idazten ari da.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 eta beste batzuk idazten ari dira.", VOTE_DISLIKE_ALT: "Ez dut atsegin", VOTE_LIKE_ALT: "Atsegin dut" }, GMe = { _comment: "[CI-LOCKED] Tämän tiedoston sisältö on lukittu. Osallistuminen on tervetullutta, mutta muutosten tarkistamisessa saattaa olla viivettä.", ACCESS_KEY_ALT: "Alt + Vaihto + $1", ACCESS_KEY_FOR_MAC_ALT: "Control + Option + $1", ACTIVITY_BOT_SAID_ALT: "Botti $1 sanoi:", ACTIVITY_YOU_SAID_ALT: "Sanoit:", ACTIVITY_BOT_ATTACHED_ALT: "Botti lisäsi liitteen:", ACTIVITY_ERROR_BOX_TITLE: "Virhesanoma", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Siirry vuorovaikutukseen napsauttamalla.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Viesti on vuorovaikutteinen.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Viestissä on vähintään yksi linkki.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Lähetys epäonnistui.", ACTIVITY_YOU_ATTACHED_ALT: "Lisäsit liitteen:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 liite.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 liitettä.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 liitettä.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 liitettä.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 liitettä.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Lähetys epäonnistui. [Yritä uudelleen][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Lähetetään", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Lähetetty $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Juuri nyt", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Tunti sitten", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Minuutti sitten", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Tänään", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Eilen", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Mukautuvan kortin jäsennysvirhe", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Mukautuvan kortin muodostusvirhe", ATTACHMENT_AUDIO: "Äänileike.", ATTACHMENT_CARD: "Kortti: $1 $2 $3", ATTACHMENT_FILE: "Tiedosto: $1", ATTACHMENT_IMAGE: "Kuva", ATTACHMENT_TEXT: "Teksti: $1", ATTACHMENT_VIDEO: "Videoleike", CAROUSEL_FLIPPER_NEXT_ALT: "Seuraava", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Edellinen", CITATION_MODEL_DIALOG_ALT: "Lainaus", CONNECTIVITY_STATUS_ALT_CONNECTED: "Yhdistetty", CONNECTIVITY_STATUS_ALT_CONNECTING: "Muodostetaan yhteyttä…", CONNECTIVITY_STATUS_ALT_FATAL: "Yhdistäminen ei onnistu.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Verkkoyhteys keskeytyi. Yhdistetään uudelleen…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Muodostusvirhe. Tarkista konsoli tai ota yhteyttä botin kehittäjään.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Yhteyden muodostaminen kestää tavallista kauemmin.", CONNECTIVITY_STATUS_ALT: "Yhteyden tila: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Lataa tiedosto $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Lataa tiedosto $1 (koko $2)", FILE_CONTENT_WITH_SIZE_ALT: "$1 (koko $2)", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter-näppäin", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Viestin kohteiden käyttö", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Keskusteluhistoria", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Esc-näppäin", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Poistu viestistä", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Sarkainnäppäin
Vaihto + sarkainnäppäin`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Siirry viestin kohteiden välillä", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Ylänuolinäppäin
Alanuolinäppäin`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Siirry viestien välillä", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter-näppäin", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Suorita toiminto", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Sarkainnäppäin
Vaihto + sarkainnäppäin`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Siirry keskusteluikkunan kohteiden välillä", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Keskusteluikkuna", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Sulje", KEYBOARD_HELP_HEADER: "Näppäimistökomennot", MARKDOWN_EXTERNAL_LINK_ALT: "Avautuu uudessa ikkunassa; ulkoinen.", RECEIPT_CARD_TAX: "Vero", RECEIPT_CARD_TOTAL: "Yhteensä", RECEIPT_CARD_VAT: "ALV", REFERENCE_LIST_HEADER_ONE: "$1 viite", REFERENCE_LIST_HEADER_FEW: "$1 viitettä", REFERENCE_LIST_HEADER_MANY: "$1 viitettä", REFERENCE_LIST_HEADER_OTHER: "$1 viitettä", REFERENCE_LIST_HEADER_TWO: "$1 viitettä", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Tyhjää viestiä ei voi lähettää.", SPEECH_INPUT_LISTENING: "Kuunnellaan…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofoni pois päältä", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofoni päällä", SPEECH_INPUT_STARTING: "Aloitetaan…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Seuraava", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Edellinen", SUGGESTED_ACTIONS_LABEL_ALT: "Ehdotetut toiminnot", TEXT_INPUT_ALT: "Viestin syöttöruutu", TEXT_INPUT_PLACEHOLDER: "Kirjoita viestisi", TEXT_INPUT_SEND_BUTTON_ALT: "Lähetä", TEXT_INPUT_SPEAK_BUTTON_ALT: "Puhu", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Lataa tiedosto palvelimeen", TOAST_ACCORDION_FEW: "$1 ilmoitusta: Katso lisätietoja napsauttamalla tästä", TOAST_ACCORDION_MANY: "$1 ilmoitusta: Katso lisätietoja napsauttamalla tästä", TOAST_ACCORDION_OTHER: "$1 ilmoitusta: Katso lisätietoja napsauttamalla tästä", TOAST_ACCORDION_TWO: "$1 ilmoitusta: Katso lisätietoja napsauttamalla tästä", TOAST_ALT_ERROR: "Virhe", TOAST_ALT_INFO: "Tiedot", TOAST_ALT_SUCCESS: "Onnistui", TOAST_ALT_WARN: "Varoitus", TOAST_DISMISS_BUTTON: "Hylkää", TOAST_TITLE_ALT: "Ilmoitus", TRANSCRIPT_ARIA_LABEL_ALT: "Keskusteluhistoria, siirry nuolinäppäimillä.", TRANSCRIPT_ARIA_ROLE_ALT: "keskusteluhistoria", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Viesti on vuorovaikutteinen. Siirry keskusteluhistoriaan painamalla vaihto- ja sarkainnäppäimiä 2–3 kertaa. Aloita sitten vuorovaikutus napsauttamalla viestiä.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Viestissä on vähintään yksi linkki. Siirry keskusteluhistoriaan painamalla vaihto- ja sarkainnäppäimiä 2–3 kertaa. Aloita sitten vuorovaikutus napsauttamalla viestiä.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Viestissä on ehdotettuja toimintoja. Valitse ne painamalla vaihto + sarkain 2–3 kertaa.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Viestissä on ehdotettuja toimintoja. Valitse ne painamalla $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Viestin lähettäminen epäonnistui.", TRANSCRIPT_MORE_MESSAGES: "Lisää viestejä", TRANSCRIPT_NEW_MESSAGES: "Uudet viestit", TRANSCRIPT_TERMINATOR_TEXT: "Keskusteluhistorian loppu", TYPING_INDICATOR_ALT: "Näytetään kirjoittamisen ilmaisin", TYPING_INDICATOR_SINGLE_TEXT: "$1 kirjoittaa.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 ja muut kirjoittavat.", VOTE_DISLIKE_ALT: "Älä tykkää", VOTE_LIKE_ALT: "Tykkää" }, WMe = { _comment: "[CI-LOCKED] Le contenu de ce fichier est verrouillé. Les contributions sont les bienvenues, mais la validation des modifications peut être retardée.", ACCESS_KEY_ALT: "Alt + Maj + $1", ACCESS_KEY_FOR_MAC_ALT: "Contrôle + Option + $1", ACTIVITY_BOT_SAID_ALT: "Le bot $1 a dit :", ACTIVITY_YOU_SAID_ALT: "Vous avez dit :", ACTIVITY_BOT_ATTACHED_ALT: "Bot joint :", ACTIVITY_ERROR_BOX_TITLE: "Message d'erreur", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Cliquez pour interagir.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Le message est interactif.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Un ou plusieurs liens dans le message.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Échec de l’envoi.", ACTIVITY_YOU_ATTACHED_ALT: "Vous avez joint :", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 pièce jointe.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 pièces jointes.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 pièces jointes.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 pièces jointes.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 pièces jointes.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Échec de l'envoi. [Réessayez][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Envoi en cours", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Envoyé à $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "À l'instant", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Il y a une heure", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Il y a une minute", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Aujourd'hui", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Hier", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Erreur d'analyse de la carte adaptative", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Erreur d'affichage de la carte adaptative", ATTACHMENT_AUDIO: "Un clip audio.", ATTACHMENT_CARD: "Une carte : $1 $2 $3", ATTACHMENT_FILE: "Un fichier : $1", ATTACHMENT_IMAGE: "Une image", ATTACHMENT_TEXT: "Un texte : $1", ATTACHMENT_VIDEO: "Un clip vidéo", CAROUSEL_FLIPPER_NEXT_ALT: "Suivant", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Précédent", CITATION_MODEL_DIALOG_ALT: "Citation", CONNECTIVITY_STATUS_ALT_CONNECTED: "Connecté", CONNECTIVITY_STATUS_ALT_CONNECTING: "Connexion en cours...", CONNECTIVITY_STATUS_ALT_FATAL: "Impossible de se connecter.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Une interruption du réseau s'est produite. Reconnexion en cours...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Erreur de rendu. Vérifiez la console ou contactez le développeur du bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "La connexion prend plus de temps que d'habitude.", CONNECTIVITY_STATUS_ALT: "Statut de la connectivité : $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Télécharger le fichier '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Télécharger le fichier '$1' de taille $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' de taille $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Touche Entrée", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Accéder aux éléments du message", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historique des conversations instantanées", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Touche Échap", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Message de sortie", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Touche Tab
Touche Maj + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Se déplacer entre les éléments d’un message", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Touche Flèche haut
Touche Flèche bas`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Se déplacer entre les messages", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Touche Entrée", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Effectuer une action", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Touche Tab
Touche Maj + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Se déplacer entre les éléments de la fenêtre de conversation instantanée", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Fenêtre de conversation instantanée", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Fermer", KEYBOARD_HELP_HEADER: "Contrôles du clavier", MARKDOWN_EXTERNAL_LINK_ALT: "S’ouvre dans une nouvelle fenêtre ; externe.", RECEIPT_CARD_TAX: "Taxe", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "TVA", REFERENCE_LIST_HEADER_ONE: "$1 référence", REFERENCE_LIST_HEADER_FEW: "$1 références", REFERENCE_LIST_HEADER_MANY: "$1 références", REFERENCE_LIST_HEADER_OTHER: "$1 références", REFERENCE_LIST_HEADER_TWO: "$1 références", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Impossible d’envoyer un message vide.", SPEECH_INPUT_LISTENING: "Écoute en cours...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microphone désactivé", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microphone activé", SPEECH_INPUT_STARTING: "Démarrage en cours...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Suivant", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Précédent", SUGGESTED_ACTIONS_LABEL_ALT: "Actions suggérées", TEXT_INPUT_ALT: "Zone de saisie du message", TEXT_INPUT_PLACEHOLDER: "Tapez votre message", TEXT_INPUT_SEND_BUTTON_ALT: "Envoyer", TEXT_INPUT_SPEAK_BUTTON_ALT: "Parler", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Charger le fichier", TOAST_ACCORDION_FEW: "$1 Notifications : cliquez ici pour afficher les détails", TOAST_ACCORDION_MANY: "$1 Notifications : cliquez ici pour afficher les détails", TOAST_ACCORDION_OTHER: "$1 Notifications : cliquez ici pour afficher les détails", TOAST_ACCORDION_TWO: "$1 Notifications : cliquez ici pour afficher les détails", TOAST_ALT_ERROR: "Erreur", TOAST_ALT_INFO: "Informations", TOAST_ALT_SUCCESS: "Réussite", TOAST_ALT_WARN: "Avertissement", TOAST_DISMISS_BUTTON: "Ignorer", TOAST_TITLE_ALT: "Notification", TRANSCRIPT_ARIA_LABEL_ALT: "Historique des conversations instantanées, appuyez sur les touches de direction pour naviguer.", TRANSCRIPT_ARIA_ROLE_ALT: "historique des conversations instantanées", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Le message est interactif. Appuyez sur la touche Maj + Tab 2 à 3 fois pour passer à l’historique des conversations instantanées. Ensuite, cliquez sur le message pour interagir.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Un ou plusieurs liens dans le message. Appuyez sur la touche Maj + Tab 2 à 3 fois pour passer à l’historique des conversations instantanées. Ensuite, cliquez sur le message pour interagir.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Le message a des actions suggérées. Appuyez sur Maj + Tab 2 à 3 fois pour les sélectionner.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Le message a des actions suggérées. Appuyez sur $1 pour les sélectionner.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Impossible d’envoyer le message.", TRANSCRIPT_MORE_MESSAGES: "Plus de messages", TRANSCRIPT_NEW_MESSAGES: "Nouveaux messages", TRANSCRIPT_TERMINATOR_TEXT: "Fin de l’historique des conversations instantanées", TYPING_INDICATOR_ALT: "Affichage de l'indicateur de saisie", TYPING_INDICATOR_SINGLE_TEXT: "$1 effectue une saisie.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 et d’autres effectuent une saisie.", VOTE_DISLIKE_ALT: "Je n’aime pas", VOTE_LIKE_ALT: "J’aime" }, KMe = { _comment: "[CI-LOCKED] O contido deste ficheiro está bloqueado. As contribucións son benvidas, pero a validación da modificación pode demorarse.", ACCESS_KEY_ALT: "ALT MAIÚS $1", ACCESS_KEY_FOR_MAC_ALT: "Control Opción $1", ACTIVITY_BOT_SAID_ALT: "O bot $1 dixo:", ACTIVITY_YOU_SAID_ALT: "Dixo:", ACTIVITY_BOT_ATTACHED_ALT: "Anexado ao bot:", ACTIVITY_ERROR_BOX_TITLE: "Mensaxe de erro", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Prema para interactuar.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "A mensaxe é interactiva.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Unha ou varias ligazóns na mensaxe.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Erro ao enviar.", ACTIVITY_YOU_ATTACHED_ALT: "Anexou:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "Un anexo.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 anexos.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Erro no envío. [Tentar de novo][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Enviando", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Enviada ás $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Agora mesmo", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Hai unha hora", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Hai un minuto", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hoxe", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Onte", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Erro de análise do cartón adaptable", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Erro de procesamento do cartón adaptable", ATTACHMENT_AUDIO: "Un clip de audio.", ATTACHMENT_CARD: "Un cartón: $1 $2 $3", ATTACHMENT_FILE: "Un ficheiro: $1", ATTACHMENT_IMAGE: "Unha imaxe", ATTACHMENT_TEXT: "Un texto: $1", ATTACHMENT_VIDEO: "Un clip de vídeo", CAROUSEL_FLIPPER_NEXT_ALT: "Seguinte", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Anterior", CITATION_MODEL_DIALOG_ALT: "Cita", CONNECTIVITY_STATUS_ALT_CONNECTED: "Conectado", CONNECTIVITY_STATUS_ALT_CONNECTING: "Conectando…", CONNECTIVITY_STATUS_ALT_FATAL: "Non é posible conectarse.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Produciuse unha interrupción da rede. Conectando de novo…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Erro de procesamento. Comprobe a consola ou póñase en contacto co programador do bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "A conexión está a tardar máis do normal.", CONNECTIVITY_STATUS_ALT: "Estado da conectividade: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Descargar o ficheiro "$1"', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Descargar o ficheiro "$1" cun tamaño de $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" cun tamaño de $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tecla INTRO", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Acceder aos elementos da mensaxe", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historial de chat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tecla Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Saír da mensaxe", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tecla TAB
Teclas MAIÚS + TAB`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Moverse entre os elementos dunha mensaxe", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tecla Frecha cara a arriba
Tecla Frecha cara a abaixo`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Moverse entre as mensaxes", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tecla INTRO", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Realizar acción", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tecla TAB
Teclas MAIÚS + TAB`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Moverse entre os elementos da ventá de chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Ventá de chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Pechar", KEYBOARD_HELP_HEADER: "Controis de teclado", MARKDOWN_EXTERNAL_LINK_ALT: "Ábrese nunha ventá nova; externa.", RECEIPT_CARD_TAX: "Imposto", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "IVE", REFERENCE_LIST_HEADER_ONE: "Referencia de $1", REFERENCE_LIST_HEADER_FEW: "Referencias de $1", REFERENCE_LIST_HEADER_MANY: "Referencias de $1", REFERENCE_LIST_HEADER_OTHER: "Referencias de $1", REFERENCE_LIST_HEADER_TWO: "Referencias de $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Non se pode enviar unha mensaxe baleira.", SPEECH_INPUT_LISTENING: "Escoitando…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Apagar Micrófono", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Acender micrófono", SPEECH_INPUT_STARTING: "Iniciando…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Seguinte", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Anterior", SUGGESTED_ACTIONS_LABEL_ALT: "Accións suxeridas", TEXT_INPUT_ALT: "Caixa de entrada de mensaxes", TEXT_INPUT_PLACEHOLDER: "Escriba a mensaxe", TEXT_INPUT_SEND_BUTTON_ALT: "Enviar", TEXT_INPUT_SPEAK_BUTTON_ALT: "Falar", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Cargar ficheiro", TOAST_ACCORDION_FEW: "$1 notificacións: prema aquí para ver os detalles", TOAST_ACCORDION_MANY: "$1 notificacións: prema aquí para ver os detalles", TOAST_ACCORDION_OTHER: "$1 notificacións: prema aquí para ver os detalles", TOAST_ACCORDION_TWO: "$1 notificacións: prema aquí para ver os detalles", TOAST_ALT_ERROR: "Erro", TOAST_ALT_INFO: "Información", TOAST_ALT_SUCCESS: "Correcto", TOAST_ALT_WARN: "Aviso", TOAST_DISMISS_BUTTON: "Rexeitar", TOAST_TITLE_ALT: "Notificación", TRANSCRIPT_ARIA_LABEL_ALT: "Historial de chat, prema as teclas de frecha para navegar.", TRANSCRIPT_ARIA_ROLE_ALT: "historial de chat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "A mensaxe é interactiva. Prema as teclas MAIÚS e TAB dúas ou tres veces para cambiar ao historial de chat. A continuación, prema na mensaxe para interactuar.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Unha ou varias ligazóns da mensaxe. Prema as teclas MAIÚS e TAB dúas ou tres veces para cambiar ao historial de chat. A continuación, prema na mensaxe para interactuar.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "A mensaxe ten accións suxeridas. Prema MAIÚS e TAB dúas ou tres veces para seleccionalas.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "A mensaxe ten accións suxeridas. Prema $1 para seleccionalas.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Non foi posible enviar a mensaxe.", TRANSCRIPT_MORE_MESSAGES: "Máis mensaxes", TRANSCRIPT_NEW_MESSAGES: "Mensaxes novas", TRANSCRIPT_TERMINATOR_TEXT: "Fin do historial de chat", TYPING_INDICATOR_ALT: "Mostrando o indicador de escritura", TYPING_INDICATOR_SINGLE_TEXT: "$1 está a escribir.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 e outras persoas están a escribir.", VOTE_DISLIKE_ALT: "Non me gusta", VOTE_LIKE_ALT: "Gústame" }, XMe = { _comment: "[CI-LOCKED] תוכן קובץ זה נעול. תרומות יתקבלו בברכה, אך אימות השינויים עשוי להתעכב.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "תוכנית ה- Bot‏ $1 אמרה:", ACTIVITY_YOU_SAID_ALT: "אמרת:", ACTIVITY_BOT_ATTACHED_ALT: "תוכנית Bot צירפה:", ACTIVITY_ERROR_BOX_TITLE: "הודעת שגיאה", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "לחץ כדי לקיים אינטראקציה.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "ההודעה היא אינטראקטיבית.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "יש קישור אחד או יותר בהודעה.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "השליחה נכשלה.", ACTIVITY_YOU_ATTACHED_ALT: "צירפת:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "קובץ מצורף אחד.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 קבצים מצורפים.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 קבצים מצורפים.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 קבצים מצורפים.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 קבצים מצורפים.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "השליחה נכשלה. [נסה שנית][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "שולח", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "נשלח בשעה $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "ממש עכשיו", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "לפני שעה", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "לפני דקה", ACTIVITY_STATUS_TIMESTAMP_TODAY: "היום", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "אתמול", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "שגיאה בניתוח מבנה טקסט של כרטיס מסתגל", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "שגיאה בעיבוד כרטיס מסתגל", ATTACHMENT_AUDIO: "קליפ שמע.", ATTACHMENT_CARD: "כרטיס: $1 $2 $3", ATTACHMENT_FILE: "קובץ: $1", ATTACHMENT_IMAGE: "תמונה", ATTACHMENT_TEXT: "טקסט: $1", ATTACHMENT_VIDEO: "קליפ וידאו", CAROUSEL_FLIPPER_NEXT_ALT: "הבא", CAROUSEL_FLIPPER_PREVIOUS_ALT: "הקודם", CITATION_MODEL_DIALOG_ALT: "ציטוט", CONNECTIVITY_STATUS_ALT_CONNECTED: "מחובר", CONNECTIVITY_STATUS_ALT_CONNECTING: "מתחבר...", CONNECTIVITY_STATUS_ALT_FATAL: "לא ניתן להתחבר.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "אירעה הפרעה ברשת. מתחבר מחדש...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "שגיאת עיבוד. בדוק את המסוף או פנה אל מפתח הבוט.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "ההתחברות נמשכת זמן רב מהרגיל.", CONNECTIVITY_STATUS_ALT: "מצב קישוריות: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "הורד את הקובץ '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "הורד את הקובץ '$1' בגודל $2", FILE_CONTENT_WITH_SIZE_ALT: "‏'$1' בגודל $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "מקש Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "גישה לפריטים בהודעה", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "היסטוריית צ'אט", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "מקש Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "יציאה מההודעה", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `מקש Tab
מקש Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "מעבר בין פריטים בהודעה", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `מקש חץ למעלה
מקש חץ למטה`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "מעבר בין הודעות", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "מקש Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "ביצוע פעולה", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `מקש Tab
מקש Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "מעבר בין פריטים בחלון הצ'אט", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "חלון צ'אט", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "סגור", KEYBOARD_HELP_HEADER: "פקדי לוח מקשים", MARKDOWN_EXTERNAL_LINK_ALT: "נפתח בחלון חדש; חיצוני.", RECEIPT_CARD_TAX: "מס", RECEIPT_CARD_TOTAL: "סך הכל", RECEIPT_CARD_VAT: 'מע"מ', REFERENCE_LIST_HEADER_ONE: "הפניית $1", REFERENCE_LIST_HEADER_FEW: "הפניות $1", REFERENCE_LIST_HEADER_MANY: "הפניות $1", REFERENCE_LIST_HEADER_OTHER: "הפניות $1", REFERENCE_LIST_HEADER_TWO: "הפניות $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "לא ניתן לשלוח הודעה ריקה.", SPEECH_INPUT_LISTENING: "מאזין…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "כבה מיקרופון", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "הפעל מיקרופון", SPEECH_INPUT_STARTING: "מתחיל...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "הבא", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "הקודם", SUGGESTED_ACTIONS_LABEL_ALT: "פעולות מוצעות", TEXT_INPUT_ALT: "תיבה להזנת הודעה", TEXT_INPUT_PLACEHOLDER: "הקלד את ההודעה שלך", TEXT_INPUT_SEND_BUTTON_ALT: "שלח", TEXT_INPUT_SPEAK_BUTTON_ALT: "דבר", TEXT_INPUT_UPLOAD_BUTTON_ALT: "העלה קובץ", TOAST_ACCORDION_FEW: "$1 הודעות: לחץ כאן להצגת פרטים", TOAST_ACCORDION_MANY: "$1 הודעות: לחץ כאן להצגת פרטים", TOAST_ACCORDION_OTHER: "$1 הודעות: לחץ כאן להצגת פרטים", TOAST_ACCORDION_TWO: "$1 הודעות: לחץ כאן להצגת פרטים", TOAST_ALT_ERROR: "‏‏שגיאה", TOAST_ALT_INFO: "מידע", TOAST_ALT_SUCCESS: "הצלחה", TOAST_ALT_WARN: "אזהרה", TOAST_DISMISS_BUTTON: "בטל", TOAST_TITLE_ALT: "הודעה", TRANSCRIPT_ARIA_LABEL_ALT: "היסטוריית צ'אט, הקש על מקשי החצים כדי לנווט.", TRANSCRIPT_ARIA_ROLE_ALT: "היסטוריית צ'אט", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "ההודעה היא אינטראקטיבית. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "יש קישור אחד או יותר בהודעה. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "ההודעה כוללת פעולות מוצעות. הקש Shift Tab פעמיים או שלוש פעמים כדי לבחור אותן.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "ההודעה כוללת פעולות מוצעות. הקש $1 כדי לבחור אותן.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "שליחת ההודעה נכשלה.", TRANSCRIPT_MORE_MESSAGES: "הודעות נוספות", TRANSCRIPT_NEW_MESSAGES: "הודעות חדשות", TRANSCRIPT_TERMINATOR_TEXT: "סוף היסטוריית הצ'אט", TYPING_INDICATOR_ALT: "מחוון שמציג הקלדה", TYPING_INDICATOR_SINGLE_TEXT: "$1 מקליד/ה.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 ואחרים מקלידים/ות.", VOTE_DISLIKE_ALT: "לא אהבתי", VOTE_LIKE_ALT: "אהבתי" }, JMe = { _comment: "[CI-LOCKED] इस फ़ाइल की सामग्री लॉक है. योगदानकर्ताओं का स्वागत है, लेकिन परिवर्तन सत्यापन में देरी हो सकती है.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "नियंत्रण विकल्प $1", ACTIVITY_BOT_SAID_ALT: "बॉट $1 ने कहा:", ACTIVITY_YOU_SAID_ALT: "आपने कहा:", ACTIVITY_BOT_ATTACHED_ALT: "बॉट संलग्न किया गया:", ACTIVITY_ERROR_BOX_TITLE: "त्रुटि संदेश", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "सहभागिता करने के लिए क्लिक करें.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "संदेश इंटरैक्टिव है.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "संदेश में एक या अधिक लिंक हैं.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "भेजना विफल रहा.", ACTIVITY_YOU_ATTACHED_ALT: "आपने यह संलग्न किया है:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 अनुलग्नक.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 अनुलग्नक.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 अनुलग्नक.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 अनुलग्नक.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 अनुलग्नक.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "भेजना विफल. [पुन: प्रयास करें][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "भेजी जा रही है", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "$1 पर भेजी गई", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "अभी-अभी", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "एक घंटा पहले", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 मिनट पहले", ACTIVITY_STATUS_TIMESTAMP_TODAY: "आज", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "बीता हुआ कल", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "एडेप्टिव कार्ड पार्स त्रुटि", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "एडेप्टिव कार्ड रेंडर त्रुटि", ATTACHMENT_AUDIO: "एक ऑडियो क्लिप.", ATTACHMENT_CARD: "एक कार्ड: $1 $2 $3", ATTACHMENT_FILE: "एक फ़ाइल: $1", ATTACHMENT_IMAGE: "एक छवि", ATTACHMENT_TEXT: "एक पाठ: $1", ATTACHMENT_VIDEO: "एक वीडियो क्लिप", CAROUSEL_FLIPPER_NEXT_ALT: "अगला", CAROUSEL_FLIPPER_PREVIOUS_ALT: "पिछला", CITATION_MODEL_DIALOG_ALT: "उद्धरण", CONNECTIVITY_STATUS_ALT_CONNECTED: "कनेक्ट किया गया", CONNECTIVITY_STATUS_ALT_CONNECTING: "कनेक्ट किया जा रहा है...", CONNECTIVITY_STATUS_ALT_FATAL: "कनेक्ट करने में असमर्थ.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "नेटवर्क व्यवधान उत्पन्न हुआ. पुन: कनेक्ट करें...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "रेंडर त्रुटि. कृपया कंसोल की जाँच करें या बॉट डेवलपर से संपर्क करें.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "कनेक्ट होने में सामान्य से अधिक समय ले रहा है.", CONNECTIVITY_STATUS_ALT: "कनेक्टिविटी स्थिति: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "'$1' फ़ाइल डाउनलोड करें", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "$2 के आकार की '$1' फ़ाइल डाउनलोड करें", FILE_CONTENT_WITH_SIZE_ALT: "$2 के आकार की '$1'", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter कुंजी", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "संदेश में आइटम एक्सेस करें", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "चैट इतिहास", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape कुंजी", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "संदेश बंद करें", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab कुंजी
Shift + Tab कुंजी`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "संदेश में आइटम के बीच जाएं", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `ऊपर तीर कुंजी
नीचे तीर कुंजी`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "संदेशों के बीच जाएं", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter कुंजी", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "क्रिया करें", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab कुंजी
Shift + Tab कुंजी`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "चैट विंडो में आइटम के बीच जाएं", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "चैट विंडो", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "बंद करें", KEYBOARD_HELP_HEADER: "कीबोर्ड नियंत्रण", MARKDOWN_EXTERNAL_LINK_ALT: "एक नई विंडो में खोलता है; बाहरी.", RECEIPT_CARD_TAX: "कर", RECEIPT_CARD_TOTAL: "योग", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "$1 संदर्भ", REFERENCE_LIST_HEADER_FEW: "$1 संदर्भ", REFERENCE_LIST_HEADER_MANY: "$1 संदर्भ", REFERENCE_LIST_HEADER_OTHER: "$1 संदर्भ", REFERENCE_LIST_HEADER_TWO: "$1 संदर्भ", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "रिक्त संदेश भेज नहीं सकते.", SPEECH_INPUT_LISTENING: "सुन रहा है...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "माइक्रोफ़ोन बंद करें", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "माइक्रोफ़ोन चालू करें", SPEECH_INPUT_STARTING: "आरंभ हो रहा है…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "अगला", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "पिछला", SUGGESTED_ACTIONS_LABEL_ALT: "सुझाई गई क्रियाएँ", TEXT_INPUT_ALT: "संदेश इनपुट बॉक्स", TEXT_INPUT_PLACEHOLDER: "अपना संदेश लिखें", TEXT_INPUT_SEND_BUTTON_ALT: "भेजें", TEXT_INPUT_SPEAK_BUTTON_ALT: "बोलें", TEXT_INPUT_UPLOAD_BUTTON_ALT: "फ़ाइल अपलोड करें", TOAST_ACCORDION_FEW: "$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें", TOAST_ACCORDION_MANY: "$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें", TOAST_ACCORDION_OTHER: "$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें", TOAST_ACCORDION_TWO: "$1 सूचनाएँ: विवरण देखने के लिए यहाँ क्लिक करें", TOAST_ALT_ERROR: "त्रुटि", TOAST_ALT_INFO: "जानकारी", TOAST_ALT_SUCCESS: "सफल", TOAST_ALT_WARN: "चेतावनी", TOAST_DISMISS_BUTTON: "खारिज करें", TOAST_TITLE_ALT: "सूचना", TRANSCRIPT_ARIA_LABEL_ALT: "चैट इतिहास, नेविगेट करने के लिए एरो कुंजियां दबाएं.", TRANSCRIPT_ARIA_ROLE_ALT: "चैट इतिहास", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "संदेश इंटरैक्टिव है. चैट इतिहास में जाने के लिए Shift Tab कुंजी को 2 से 3 बार दबाएं. फिर सहभागिता करने के लिए संदेश पर क्लिक करें.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "संदेश में एक या अधिक लिंक हैं. चैट इतिहास में जाने के लिए Shift Tab कुंजी को 2 से 3 बार दबाएं. फिर संदेश पर क्लिक करके सहभागिता करें.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "संदेश में सुझाई गई क्रियाएँ हैं. उन्हें चुनने के लिए shift टैब को 2 से 3 बार दबाएँ.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "संदेश में सुझाई गई क्रियाएँ हैं. उन्हें चुनने के लिए $1 दबाएँ.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "संदेश भेजा नहीं जा सका.", TRANSCRIPT_MORE_MESSAGES: "अधिक संदेश", TRANSCRIPT_NEW_MESSAGES: "नए संदेश", TRANSCRIPT_TERMINATOR_TEXT: "चैट इतिहास का अंत", TYPING_INDICATOR_ALT: "टाइप करने वाला संकेतक दिखा रहा है", TYPING_INDICATOR_SINGLE_TEXT: "$1 टाइप कर रहा है.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 और अन्य लिख रहे हैं.", VOTE_DISLIKE_ALT: "नापसंद करें", VOTE_LIKE_ALT: "पसंद करें" }, ZMe = { _comment: "[CI-LOCKED] Sadržaj ove datoteke blokiran je. Doprinosi su dobrodošli, ali provjera valjanosti promjena može biti odgođena.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 rekao je:", ACTIVITY_YOU_SAID_ALT: "Vi ste rekli:", ACTIVITY_BOT_ATTACHED_ALT: "Priloženi bot:", ACTIVITY_ERROR_BOX_TITLE: "Poruka o pogrešci", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknite za interakciju.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Poruka je interaktivna.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "U poruci se nalazi jedna ili više veza.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Slanje nije uspjelo.", ACTIVITY_YOU_ATTACHED_ALT: "Priložili ste:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 privitak.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 privitka.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 privitaka.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 privitaka.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 privitka.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Slanije nije uspjelo. [Pokušaj ponovno][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Slanje", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Poslano u $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Upravo sada", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Prije 1 h", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Prije 1 minute", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Danas", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Jučer", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Pogreška pri raščlambi prilagodljive kartice", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Pogreška pri renderiranju prilagodljive kartice", ATTACHMENT_AUDIO: "Audioisječak.", ATTACHMENT_CARD: "Kartica: $1 $2 $3", ATTACHMENT_FILE: "Datoteka: $1", ATTACHMENT_IMAGE: "Slika", ATTACHMENT_TEXT: "Tekst: $1", ATTACHMENT_VIDEO: "Videoisječak", CAROUSEL_FLIPPER_NEXT_ALT: "Sljedeće", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Prethodno", CITATION_MODEL_DIALOG_ALT: "Citat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Povezano", CONNECTIVITY_STATUS_ALT_CONNECTING: "Povezivanje u tijeku...", CONNECTIVITY_STATUS_ALT_FATAL: "Povezivanje nije moguće.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Došlo je do prekida mreže. U tijeku je ponovno povezivanje...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Pogreška pri renderiranju. Provjerite konzolu ili se obratite razvojnom inženjeru bota.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Povezivanje traje dulje nego obično.", CONNECTIVITY_STATUS_ALT: "Status veze: $1", FILE_CONTENT_ALT: "„$1”", FILE_CONTENT_DOWNLOADABLE_ALT: "Preuzimanje datoteke „$1”", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Preuzimanje datoteke „$1” veličine $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1” veličine $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tipka Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Pristup stavkama u poruci", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Povijest čavrljanja", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tipka Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Izađi iz poruke", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tipka Tab
Tipka Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Pomicanje među stavkama u poruci", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tipka sa strelicom prema gore
Tipka sa strelicom prema dolje`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Pomicanje među porukama", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tipka Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Izvršavanje radnje", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tipka Tab
Tipka Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Pomicanje među stavkama u prozoru za čavrljanje", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Prozor čavrljanja", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zatvori", KEYBOARD_HELP_HEADER: "Kontrole na tipkovnici", MARKDOWN_EXTERNAL_LINK_ALT: "Otvara se u novom prozoru, vanjskom.", RECEIPT_CARD_TAX: "Porez", RECEIPT_CARD_TOTAL: "Ukupno", RECEIPT_CARD_VAT: "PDV", REFERENCE_LIST_HEADER_ONE: "$1 referenca", REFERENCE_LIST_HEADER_FEW: "$1 reference", REFERENCE_LIST_HEADER_MANY: "$1 reference", REFERENCE_LIST_HEADER_OTHER: "$1 reference", REFERENCE_LIST_HEADER_TWO: "$1 reference", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Prazna poruka se ne može poslati.", SPEECH_INPUT_LISTENING: "Slušanje...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon je isključen", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon je uključen", SPEECH_INPUT_STARTING: "Započinje...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Sljedeće", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Prethodno", SUGGESTED_ACTIONS_LABEL_ALT: "Predložene akcije", TEXT_INPUT_ALT: "Okvir za unos poruke", TEXT_INPUT_PLACEHOLDER: "Unesite poruku", TEXT_INPUT_SEND_BUTTON_ALT: "Pošalji", TEXT_INPUT_SPEAK_BUTTON_ALT: "Govor", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Prijenos datoteke", TOAST_ACCORDION_FEW: "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti", TOAST_ACCORDION_MANY: "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti", TOAST_ACCORDION_OTHER: "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti", TOAST_ACCORDION_TWO: "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti", TOAST_ALT_ERROR: "Pogreška", TOAST_ALT_INFO: "Informacije", TOAST_ALT_SUCCESS: "Uspjeh", TOAST_ALT_WARN: "Upozorenje", TOAST_DISMISS_BUTTON: "Odbaci", TOAST_TITLE_ALT: "Obavijest", TRANSCRIPT_ARIA_LABEL_ALT: "Povijest čavrljanja, pritisnite tipke sa strelicama za navigaciju.", TRANSCRIPT_ARIA_ROLE_ALT: "povijest čavrljanja", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Poruka je interaktivna. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "U poruci se nalazi jedna ili više veza. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Poruka sadrži predložene akcije. Pritisnite shift i tabulator 2 do 3 puta da biste ih odabrali.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Poruka sadrži predložene akcije. Pritisnite $1 da biste ih odabrali.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Slanje poruke nije uspjelo.", TRANSCRIPT_MORE_MESSAGES: "Više poruka", TRANSCRIPT_NEW_MESSAGES: "Nove poruke", TRANSCRIPT_TERMINATOR_TEXT: "Kraj povijesti čavrljanja", TYPING_INDICATOR_ALT: "Prikaz pokazatelja tipkanja", TYPING_INDICATOR_SINGLE_TEXT: "$1 tipka.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 i drugi tipkaju.", VOTE_DISLIKE_ALT: "Ne sviđa mi se", VOTE_LIKE_ALT: "Sviđa mi se" }, QMe = { _comment: "[CI-LOCKED] A fájl tartalma zárolva van. Szívesen fogadjuk a hozzájárulásokat, de a módosítások érvényesítése elhúzódhat.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "A(z) $1 robot azt mondta:", ACTIVITY_YOU_SAID_ALT: "Ön azt mondta:", ACTIVITY_BOT_ATTACHED_ALT: "Robot által csatolva:", ACTIVITY_ERROR_BOX_TITLE: "Hibaüzenet", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kattintson az interakcióhoz.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Az üzenet interaktív.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Egy vagy több hivatkozás van az üzenetben.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Sikertelen küldés.", ACTIVITY_YOU_ATTACHED_ALT: "Ön által csatolva:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 melléklet.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 melléklet.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 melléklet.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 melléklet.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 melléklet.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "A küldés sikertelen. [Újra][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Küldés", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Elküldve: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Éppen most", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Egy órája", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Egy perce", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Ma", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Tegnap", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Elemzési hiba az adaptív kártyánál", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Renderelési hiba az adaptív kártyánál", ATTACHMENT_AUDIO: "Egy hangklip.", ATTACHMENT_CARD: "Egy kártya: $1 $2 $3", ATTACHMENT_FILE: "Egy fájl: $1", ATTACHMENT_IMAGE: "Egy kép", ATTACHMENT_TEXT: "Egy szöveg: $1", ATTACHMENT_VIDEO: "Egy videoklip", CAROUSEL_FLIPPER_NEXT_ALT: "Következő", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Előző", CITATION_MODEL_DIALOG_ALT: "Idézet", CONNECTIVITY_STATUS_ALT_CONNECTED: "Csatlakoztatva", CONNECTIVITY_STATUS_ALT_CONNECTING: "Csatlakozás...", CONNECTIVITY_STATUS_ALT_FATAL: "Nem lehet csatlakozni.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "A hálózati kapcsolat megszakadt. Újracsatlakozás...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Renderelési hiba. Ellenőrizze a konzolt, vagy forduljon a robot fejlesztőjéhez.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "A szokásosnál tovább tart a csatlakozás.", CONNECTIVITY_STATUS_ALT: "Kapcsolat állapota: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "$1 fájl letöltése", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "A(z) $1 fájl letöltése. Méret: $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 mérete: $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter billentyű", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Az üzenet elemeinek elérése", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Csevegés előzményei", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape billentyű", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Kilépés az üzenetből", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulátor billentyű
Shift + tabulátor billentyű`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Az üzenetben lévő elemek közötti navigáció", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Felfelé mutató nyíl
Lefelé mutató nyíl`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Navigáció az üzenetek között", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter billentyű", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Művelet végrehajtása", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulátor billentyű
Shift + tabulátor billentyű`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "A csevegőablakban lévő elemek közötti navigáció", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Csevegőablak", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Bezárás", KEYBOARD_HELP_HEADER: "Billentyűzetvezérlők", MARKDOWN_EXTERNAL_LINK_ALT: "Megnyitja egy új ablakban; külső hivatkozás.", RECEIPT_CARD_TAX: "Adó", RECEIPT_CARD_TOTAL: "Összesen", RECEIPT_CARD_VAT: "ÁFA", REFERENCE_LIST_HEADER_ONE: "$1 hivatkozás", REFERENCE_LIST_HEADER_FEW: "$1 hivatkozás", REFERENCE_LIST_HEADER_MANY: "$1 hivatkozás", REFERENCE_LIST_HEADER_OTHER: "$1 hivatkozás", REFERENCE_LIST_HEADER_TWO: "$1 hivatkozás", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Nem lehet üres üzenetet küldeni.", SPEECH_INPUT_LISTENING: "Hallgatás...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon kikapcsolva", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon bekapcsolva", SPEECH_INPUT_STARTING: "Kezdés...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Következő", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Előző", SUGGESTED_ACTIONS_LABEL_ALT: "Javasolt műveletek", TEXT_INPUT_ALT: "Üzenet beviteli mezője", TEXT_INPUT_PLACEHOLDER: "Írja be az üzenetét", TEXT_INPUT_SEND_BUTTON_ALT: "Küldés", TEXT_INPUT_SPEAK_BUTTON_ALT: "Beszéd", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Fájl feltöltése", TOAST_ACCORDION_FEW: "$1 értesítés: Kattintson ide a részletek megtekintéséhez", TOAST_ACCORDION_MANY: "$1 értesítés: Kattintson ide a részletek megtekintéséhez", TOAST_ACCORDION_OTHER: "$1 értesítés: Kattintson ide a részletek megtekintéséhez", TOAST_ACCORDION_TWO: "$1 értesítés: Kattintson ide a részletek megtekintéséhez", TOAST_ALT_ERROR: "Hiba", TOAST_ALT_INFO: "Információk", TOAST_ALT_SUCCESS: "Sikeres", TOAST_ALT_WARN: "Figyelmeztetés", TOAST_DISMISS_BUTTON: "Elvetés", TOAST_TITLE_ALT: "Értesítés", TRANSCRIPT_ARIA_LABEL_ALT: "Csevegési előzmények; a navigáláshoz használja a nyílbillentyűket.", TRANSCRIPT_ARIA_ROLE_ALT: "csevegés előzményei", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Az üzenet interaktív. A csevegési előzményekre váltáshoz nyomja le 2-3 alkalommal a shift és tabulátor billentyűket. Ezután kattintson az üzenetre az interakcióhoz.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Egy vagy több hivatkozás van az üzenetben. A csevegési előzményekre váltáshoz nyomja le 2-3 alkalommal a shift és tabulátor billentyűket. Ezután kattintson az üzenetre az interakcióhoz.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Az üzenet javasolt intézkedéseket tartalmaz. Nyomja meg 2-3 alkalommal a Shift+Tab billentyűket a kiválasztásukhoz.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Az üzenet javasolt intézkedéseket tartalmaz. Nyomja meg a $1 billentyűt a kiválasztásukhoz.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Nem sikerült elküldeni az üzenetet.", TRANSCRIPT_MORE_MESSAGES: "További üzenetek", TRANSCRIPT_NEW_MESSAGES: "Új üzenetek", TRANSCRIPT_TERMINATOR_TEXT: "A csevegési előzmények vége", TYPING_INDICATOR_ALT: "Gépelésjelző megjelenítése", TYPING_INDICATOR_SINGLE_TEXT: "1 $ és ír.", TYPING_INDICATOR_MULTIPLE_TEXT: "1 $ és mások még írnak.", VOTE_DISLIKE_ALT: "Nem tetszik", VOTE_LIKE_ALT: "Tetszik" }, eFe = { _comment: "[CI-LOCKED] Konten file ini terkunci. Kontribusi diterima, namun validasi perubahan mungkin tertunda.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 berkata:", ACTIVITY_YOU_SAID_ALT: "Anda berkata:", ACTIVITY_BOT_ATTACHED_ALT: "Bot melampirkan:", ACTIVITY_ERROR_BOX_TITLE: "Pesan kesalahan", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klik untuk berinteraksi.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Pesan ini interaktif.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Ada satu atau beberapa tautan dalam pesan ini.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Gagal terkirim.", ACTIVITY_YOU_ATTACHED_ALT: "Anda melampirkan:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 lampiran.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Gagal mengirim. [Coba lagi][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Mengirim", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Dikirim pada $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Baru saja", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Satu jam yang lalu", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Satu menit yang lalu", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hari Ini", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Kemarin", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Kesalahan penguraian Kartu Adaptif", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Kesalahan render Kartu Adaptif", ATTACHMENT_AUDIO: "Klip audio.", ATTACHMENT_CARD: "Kartu: $1 $2 $3", ATTACHMENT_FILE: "File: $1", ATTACHMENT_IMAGE: "Gambar", ATTACHMENT_TEXT: "Teks: $1", ATTACHMENT_VIDEO: "Klip video", CAROUSEL_FLIPPER_NEXT_ALT: "Berikutnya", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Sebelumnya", CITATION_MODEL_DIALOG_ALT: "Kutipan", CONNECTIVITY_STATUS_ALT_CONNECTED: "Tersambung", CONNECTIVITY_STATUS_ALT_CONNECTING: "Menyambungkan…", CONNECTIVITY_STATUS_ALT_FATAL: "Tidak dapat menyambungkan.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Terjadi gangguan jaringan. Menyambungkan kembali…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Kesalahan render. Periksa konsol atau hubungi pengembang bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Memakan waktu lebih lama dari biasanya untuk menyambungkan.", CONNECTIVITY_STATUS_ALT: "Status Konektivitas: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Unduh file '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Unduh file '$1' dengan ukuran $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' dengan ukuran $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tombol Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Akses item dalam pesan", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Riwayat obrolan", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tombol Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Pesan keluar", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tombol Tab
Tombol Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Pindahkan di antara item dalam pesan", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tombol panah atas
Tombol panah bawah`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Pindahkan antarpesan", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tombol Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Lakukan tindakan", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tombol Tab
Tombol Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Pindahkan di antara item dalam jendela obrolan", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Jendela obrolan", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Tutup", KEYBOARD_HELP_HEADER: "Kontrol keyboard", MARKDOWN_EXTERNAL_LINK_ALT: "Membuka di jendela baru; eksternal.", RECEIPT_CARD_TAX: "Pajak", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "PPN", REFERENCE_LIST_HEADER_ONE: "$1 referensi", REFERENCE_LIST_HEADER_FEW: "$1 referensi", REFERENCE_LIST_HEADER_MANY: "$1 referensi", REFERENCE_LIST_HEADER_OTHER: "$1 referensi", REFERENCE_LIST_HEADER_TWO: "$1 referensi", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Tidak dapat mengirim pesan kosong.", SPEECH_INPUT_LISTENING: "Mendengarkan…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon tidak aktif", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon aktif", SPEECH_INPUT_STARTING: "Memulai…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Berikutnya", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Sebelumnya", SUGGESTED_ACTIONS_LABEL_ALT: "Tindakan yang disarankan", TEXT_INPUT_ALT: "Kotak input pesan", TEXT_INPUT_PLACEHOLDER: "Ketik pesan Anda", TEXT_INPUT_SEND_BUTTON_ALT: "Kirim", TEXT_INPUT_SPEAK_BUTTON_ALT: "Ucapkan", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Unggah file", TOAST_ACCORDION_FEW: "$1 Pemberitahuan: Klik di sini untuk melihat detail", TOAST_ACCORDION_MANY: "$1 Pemberitahuan: Klik di sini untuk melihat detail", TOAST_ACCORDION_OTHER: "$1 Pemberitahuan: Klik di sini untuk melihat detail", TOAST_ACCORDION_TWO: "$1 Pemberitahuan: Klik di sini untuk melihat detail", TOAST_ALT_ERROR: "Kesalahan", TOAST_ALT_INFO: "Informasi", TOAST_ALT_SUCCESS: "Berhasil", TOAST_ALT_WARN: "Peringatan", TOAST_DISMISS_BUTTON: "Tutup", TOAST_TITLE_ALT: "Pemberitahuan", TRANSCRIPT_ARIA_LABEL_ALT: "Riwayat obrolan, tekan tombol panah untuk menavigasi.", TRANSCRIPT_ARIA_ROLE_ALT: "riwayat obrolan", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Pesan interaktif. Tekan tombol tab shift 2 hingga 3 kali untuk beralih ke riwayat obrolan. Setelah itu, klik pesan untuk berinteraksi.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Satu atau beberapa klik dalam pesan. Tekan tombol tab shift 2 hingga 3 kali untuk beralih ke riwayat obrolan. Setelah itu, klik pesan untuk berinteraksi.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Pesan memiliki tindakan yang disarankan. Tekan tab shift sebanyak 2 hingga 3 kali untuk memilihnya.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Pesan memiliki tindakan yang disarankan. Tekan $1 untuk memilihnya.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Pesan gagal terkirim.", TRANSCRIPT_MORE_MESSAGES: "Pesan lainnya", TRANSCRIPT_NEW_MESSAGES: "Pesan baru", TRANSCRIPT_TERMINATOR_TEXT: "Akhir riwayat obrolan", TYPING_INDICATOR_ALT: "Menampilkan indikator pengetikan", TYPING_INDICATOR_SINGLE_TEXT: "$1 sedang mengetik.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 dan lainnya sedang mengetik.", VOTE_DISLIKE_ALT: "Tidak suka", VOTE_LIKE_ALT: "Suka" }, tFe = { _comment: "[CI-LOCKED] Il contenuto del file è bloccato. I contributi sono ben accetti, ma la convalida delle modifiche potrebbe essere posticipata.", ACCESS_KEY_ALT: "ALT MAIUSC $1", ACCESS_KEY_FOR_MAC_ALT: "Controllo Opzione $1", ACTIVITY_BOT_SAID_ALT: "Il bot $1 ha detto:", ACTIVITY_YOU_SAID_ALT: "Hai detto:", ACTIVITY_BOT_ATTACHED_ALT: "Il bot ha allegato:", ACTIVITY_ERROR_BOX_TITLE: "Messaggio di errore", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Fare clic per interagire.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Messaggio inattivo.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Uno o più collegamenti nel messaggio.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Invio non riuscito.", ACTIVITY_YOU_ATTACHED_ALT: "Hai allegato:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 allegato.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 allegati.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 allegati.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 allegati.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 allegati.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Invio non riuscito. [tentativo][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Invio in corso", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Inviato alle $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Adesso", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Un'ora fa", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Un minuto fa", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Oggi", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ieri", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Errore di analisi scheda adattiva", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Errore di rendering scheda adattiva", ATTACHMENT_AUDIO: "Clip audio.", ATTACHMENT_CARD: "Scheda: $1 $2 $3", ATTACHMENT_FILE: "File: $1", ATTACHMENT_IMAGE: "Immagine", ATTACHMENT_TEXT: "Testo: $1", ATTACHMENT_VIDEO: "Clip video", CAROUSEL_FLIPPER_NEXT_ALT: "Avanti", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Indietro", CITATION_MODEL_DIALOG_ALT: "Citazione", CONNECTIVITY_STATUS_ALT_CONNECTED: "Connesso", CONNECTIVITY_STATUS_ALT_CONNECTING: "Connessione in corso…", CONNECTIVITY_STATUS_ALT_FATAL: "Impossibile connettersi.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Interruzione di rete. Riconnessione in corso…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Errore di rendering. Controlla la console o contatta lo sviluppatore del bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "La connessione sta richiedendo più tempo del solito.", CONNECTIVITY_STATUS_ALT: "Stato connettività: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Scarica file "$1"', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Scarica il file "$1" con dimensioni pari a $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" con dimensioni pari a $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tasto INVIO", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Accedi agli elementi nel messaggio", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Cronologia chat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tasto ESC", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Messaggio di uscita", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tasto TAB
Tasto MAIUSC + TAB`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Spostati tra gli elementi di un messaggio", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tasto freccia SU
Tasto freccia GIÙ`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Spostati tra i messaggi", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tasto INVIO", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Esegui azione", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tasto TAB
Tasto MAIUSC + TAB`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Spostati tra elementi nella finestra di chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Finestra di chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Chiudi", KEYBOARD_HELP_HEADER: "Comandi della tastiera", MARKDOWN_EXTERNAL_LINK_ALT: "Apre in una nuova finestra; esterna.", RECEIPT_CARD_TAX: "Imposte", RECEIPT_CARD_TOTAL: "Totali", RECEIPT_CARD_VAT: "IVA", REFERENCE_LIST_HEADER_ONE: "Riferimento $1", REFERENCE_LIST_HEADER_FEW: "Riferimenti $1", REFERENCE_LIST_HEADER_MANY: "Riferimenti $1", REFERENCE_LIST_HEADER_OTHER: "Riferimenti $1", REFERENCE_LIST_HEADER_TWO: "Riferimenti $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Impossibile inviare un messaggio vuoto.", SPEECH_INPUT_LISTENING: "In ascolto…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microfono disattivato", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microfono attivo", SPEECH_INPUT_STARTING: "Avvio in corso…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Avanti", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Indietro", SUGGESTED_ACTIONS_LABEL_ALT: "Azioni suggerite", TEXT_INPUT_ALT: "Casella di input messaggio", TEXT_INPUT_PLACEHOLDER: "Digita il tuo messaggio", TEXT_INPUT_SEND_BUTTON_ALT: "Invia", TEXT_INPUT_SPEAK_BUTTON_ALT: "Parla", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Carica file", TOAST_ACCORDION_FEW: "$1 notifiche: fai clic qui per visualizzare i dettagli", TOAST_ACCORDION_MANY: "$1 notifiche: fai clic qui per visualizzare i dettagli", TOAST_ACCORDION_OTHER: "$1 notifiche: fai clic qui per visualizzare i dettagli", TOAST_ACCORDION_TWO: "$1 notifiche: fai clic qui per visualizzare i dettagli", TOAST_ALT_ERROR: "Errore", TOAST_ALT_INFO: "Informazioni", TOAST_ALT_SUCCESS: "Riuscito", TOAST_ALT_WARN: "Avviso", TOAST_DISMISS_BUTTON: "Ignora", TOAST_TITLE_ALT: "Notifica", TRANSCRIPT_ARIA_LABEL_ALT: "Cronologia chat, premi i tasti freccia per spostarti.", TRANSCRIPT_ARIA_ROLE_ALT: "cronologia chat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Il messaggio è interattivo. Premi MAIUSC +TAB da 2 a 3 volte per passare alla cronologia della chat. Fai clic sul messaggio per interagire.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Uno o più collegamenti nel messaggio. Premi MAIUSC +TAB da 2 a 3 volte per passare alla cronologia della chat. Fai clic sul messaggio per interagire.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Azioni suggerite per il messaggio. Premi TAB MAIUSC da 2 a 3 volte per selezionarle.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Azioni suggerite per il messaggio. Premi $1 per selezionarle.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Impossibile inviare il messaggio.", TRANSCRIPT_MORE_MESSAGES: "Altri messaggi", TRANSCRIPT_NEW_MESSAGES: "Nuovi messaggi", TRANSCRIPT_TERMINATOR_TEXT: "Fine della cronologia chat", TYPING_INDICATOR_ALT: "Visualizzazione dell'indicatore di digitazione in corso", TYPING_INDICATOR_SINGLE_TEXT: "$1 sta digitando.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 e altri stanno digitando.", VOTE_DISLIKE_ALT: "Non mi piace", VOTE_LIKE_ALT: "Mi piace" }, rFe = { _comment: "[CI-LOCKED] このファイルのコンテンツはロックされています。投稿は歓迎しますが、変更の検証は遅れる可能性があります。", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "control + option + $1", ACTIVITY_BOT_SAID_ALT: "ボット $1 の発言:", ACTIVITY_YOU_SAID_ALT: "あなたの発言:", ACTIVITY_BOT_ATTACHED_ALT: "ボットの添付:", ACTIVITY_ERROR_BOX_TITLE: "エラー メッセージ", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "クリックして対話します。", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "メッセージはインタラクティブです。", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "メッセージ内に 1 つ以上のリンクがあります。", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "送信に失敗しました。", ACTIVITY_YOU_ATTACHED_ALT: "あなたの添付:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 個の添付ファイル。", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 添付ファイル。", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 添付ファイル。", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 添付ファイル。", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 添付ファイル。", ACTIVITY_STATUS_SEND_FAILED_RETRY: "送信に失敗しました。[再試行][RETRY]。", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "送信中", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "送信時刻: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "たった今", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1 時間前", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 分前", ACTIVITY_STATUS_TIMESTAMP_TODAY: "今日", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "昨日", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "アダプティブ カードの解析エラー", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "アダプティブ カードの表示エラー", ATTACHMENT_AUDIO: "オーディオクリップです。", ATTACHMENT_CARD: "カード: $1 $2 $3", ATTACHMENT_FILE: "ファイル: $1", ATTACHMENT_IMAGE: "画像", ATTACHMENT_TEXT: "テキスト: $1", ATTACHMENT_VIDEO: "ビデオ クリップ", CAROUSEL_FLIPPER_NEXT_ALT: "次へ", CAROUSEL_FLIPPER_PREVIOUS_ALT: "前へ", CITATION_MODEL_DIALOG_ALT: "引用", CONNECTIVITY_STATUS_ALT_CONNECTED: "接続済み", CONNECTIVITY_STATUS_ALT_CONNECTING: "接続中…", CONNECTIVITY_STATUS_ALT_FATAL: "接続できません。", CONNECTIVITY_STATUS_ALT_RECONNECTING: "ネットワークの中断が発生しました。再接続しています...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "表示エラー。コンソールを確認するかボット開発者にお問合せください。", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "通常より接続に時間がかかっています。", CONNECTIVITY_STATUS_ALT: "接続状態: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "ファイル '$1' のダウンロード", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "ファイル '$1' (サイズ: $2) をダウンロードする", FILE_CONTENT_WITH_SIZE_ALT: "'$1' (サイズ: $2)", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter キー", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "メッセージ内のアイテムにアクセスする", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "チャット履歴", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Esc キー", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "終了メッセージ", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab キー
Shift + Tab キー`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "メッセージ内のアイテム間を移動する", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `上方向キー
下方向キー`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "メッセージ間を移動する", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter キー", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "アクション実行", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab キー
Shift + Tab キー`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "チャット ウィンドウ内のアイテム間を移動する", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "チャット ウィンドウ", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "閉じる", KEYBOARD_HELP_HEADER: "キーボード コントロール", MARKDOWN_EXTERNAL_LINK_ALT: "新しいウィンドウ (外部) でレコードを開きます。", RECEIPT_CARD_TAX: "税額", RECEIPT_CARD_TOTAL: "合計", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "$1 件の参照", REFERENCE_LIST_HEADER_FEW: "$1 件の参照", REFERENCE_LIST_HEADER_MANY: "$1 件の参照", REFERENCE_LIST_HEADER_OTHER: "$1 件の参照", REFERENCE_LIST_HEADER_TWO: "$1 件の参照", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "空のメッセージは送信できません。", SPEECH_INPUT_LISTENING: "聞いています…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "マイクが無効", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "マイクが有効", SPEECH_INPUT_STARTING: "開始しています…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "次へ", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "前へ", SUGGESTED_ACTIONS_LABEL_ALT: "推奨されるアクション", TEXT_INPUT_ALT: "メッセージ入力ボックス", TEXT_INPUT_PLACEHOLDER: "メッセージを入力してください", TEXT_INPUT_SEND_BUTTON_ALT: "送信", TEXT_INPUT_SPEAK_BUTTON_ALT: "話す", TEXT_INPUT_UPLOAD_BUTTON_ALT: "ファイルのアップロード", TOAST_ACCORDION_FEW: "$1 件の通知: ここをクリックして詳細を確認する", TOAST_ACCORDION_MANY: "$1 件の通知: ここをクリックして詳細を確認する", TOAST_ACCORDION_OTHER: "$1 件の通知: ここをクリックして詳細を確認する", TOAST_ACCORDION_TWO: "$1 件の通知: ここをクリックして詳細を確認する", TOAST_ALT_ERROR: "エラー", TOAST_ALT_INFO: "情報", TOAST_ALT_SUCCESS: "成功", TOAST_ALT_WARN: "警告", TOAST_DISMISS_BUTTON: "解除", TOAST_TITLE_ALT: "通知", TRANSCRIPT_ARIA_LABEL_ALT: "チャット履歴。方向キーを押して移動します。", TRANSCRIPT_ARIA_ROLE_ALT: "チャット履歴", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "メッセージは対話型です。Shift + Tab キーを 2 ～ 3 回押してチャット履歴に切り替えます。その後、メッセージをクリックして対話します。", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "メッセージ内に 1 つ以上のリンクがあります。Shift + Tab キーを 2 ～ 3 回押してチャット履歴に切り替えます。その後、メッセージをクリックして対話します。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "メッセージに推奨されるアクションがあります。Shift + Tab を 2 ～ 3 回押して選択します。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "メッセージに推奨されるアクションがあります。$1 を押して選択します。", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "メッセージを送信できませんでした。", TRANSCRIPT_MORE_MESSAGES: "その他のメッセージ", TRANSCRIPT_NEW_MESSAGES: "新しいメッセージ", TRANSCRIPT_TERMINATOR_TEXT: "チャット履歴の終了", TYPING_INDICATOR_ALT: "入力インジケーターを表示しています", TYPING_INDICATOR_SINGLE_TEXT: "$1 が入力しています。", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 と他のユーザーが入力しています。", VOTE_DISLIKE_ALT: "低評価", VOTE_LIKE_ALT: "高評価" }, nFe = { _comment: "[CI-LOCKED] Бұл файлдың мазмұны құлыпталған. Жарналар қабылданады, бірақ өзгертулерді тексеру кейінге қалдырылуы мүмкін.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "$1 боттың айтуы бойынша:", ACTIVITY_YOU_SAID_ALT: "Сіздің айтуы бойынша:", ACTIVITY_BOT_ATTACHED_ALT: "Бекітілген бот:", ACTIVITY_ERROR_BOX_TITLE: "Қате туралы хабар", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Өзара әрекеттесу үшін басыңыз.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Хабар интерактивті.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Хабардағы бір немесе бірнеше сілтеме.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Жіберілмеді.", ACTIVITY_YOU_ATTACHED_ALT: "Сіз бекіттіңіз:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 тіркеме.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 тіркемелері.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 тіркемелері.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 тіркемелері.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 тіркемелері.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Жіберу сәтсіз аяқталды. (Қайталау][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Жіберілуде", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Сағат $1 жіберілген", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Дәл қазір", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1 сағат бұрын", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 минут бұрын", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Бүгін", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Кеше", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Бейімделгіш картаны талдау қатесі", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Бейімделгіш картаны көрсету қатесі", ATTACHMENT_AUDIO: "Дыбысклип.", ATTACHMENT_CARD: "Карта: $1 $2 $3", ATTACHMENT_FILE: "Файл: $1", ATTACHMENT_IMAGE: "Кескін", ATTACHMENT_TEXT: "Мәтін: $1", ATTACHMENT_VIDEO: "Бейнеклип", CAROUSEL_FLIPPER_NEXT_ALT: "Келесі", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Алдыңғы", CITATION_MODEL_DIALOG_ALT: "Дәйексөз", CONNECTIVITY_STATUS_ALT_CONNECTED: "Қосылған", CONNECTIVITY_STATUS_ALT_CONNECTING: "Қосылуда...", CONNECTIVITY_STATUS_ALT_FATAL: "Қосу мүмкін емес.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Желі жұмысында іркіліс болды. Қайта қосылуда…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Көрсету қатесі. Консольді тексеріңіз немесе бот әзірлеушісімен хабарласыңыз.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Қосылу әдеттегіден ұзақ уақыт алуда.", CONNECTIVITY_STATUS_ALT: "Қосылым күйі: $1", FILE_CONTENT_ALT: "«$1»", FILE_CONTENT_DOWNLOADABLE_ALT: "$1 файлын жүктеп алу", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "$2 өлшемді $1 файлын жүктеу", FILE_CONTENT_WITH_SIZE_ALT: "$2 өлшемді $1", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter пернесі", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Хабарламадағы элементтерге қол жеткізу", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Сөйлесу журналы", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape пернесі", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Хабардан шығу", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab пернесі
Shift + tab пернесі`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Хабарламадағы элементтер арасында жылжу", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Жоғары көрсеткі пернесі
Төмен көрсеткі пернесі`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Хабарламалар арасында жылжу", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter пернесі", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Әрекет жасау", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab пернесі
Shift + tab пернесі`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Сөйлесу терезесіндегі элементтер арасында жылжу", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Сөйлесу терезесі", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Жабу", KEYBOARD_HELP_HEADER: "Пернетақтаның басқару элементтері", MARKDOWN_EXTERNAL_LINK_ALT: "Жаңа терезеде ашады; сыртқы.", RECEIPT_CARD_TAX: "Салық", RECEIPT_CARD_TOTAL: "Барлығы", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "$1 сілтеме", REFERENCE_LIST_HEADER_FEW: "$1 сілтеме", REFERENCE_LIST_HEADER_MANY: "$1 сілтеме", REFERENCE_LIST_HEADER_OTHER: "$1 сілтеме", REFERENCE_LIST_HEADER_TWO: "$1 сілтеме", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Бос хабар жіберу мүмкін емес.", SPEECH_INPUT_LISTENING: "Тыңдалуда...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Микрофон өшірулі", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Микрофон", SPEECH_INPUT_STARTING: "Басталуда...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Келесі", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Алдыңғы", SUGGESTED_ACTIONS_LABEL_ALT: "Ұсынылған әрекеттер", TEXT_INPUT_ALT: "Хабарды енгізу өрісі", TEXT_INPUT_PLACEHOLDER: "Хабарды теріңіз", TEXT_INPUT_SEND_BUTTON_ALT: "Жіберу", TEXT_INPUT_SPEAK_BUTTON_ALT: "Сөйлеу", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Файлды кері жүктеу", TOAST_ACCORDION_FEW: "$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз", TOAST_ACCORDION_MANY: "$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз", TOAST_ACCORDION_OTHER: "$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз", TOAST_ACCORDION_TWO: "$1 Хабарландырулар: мәліметтерді көру үшін осы жерді басыңыз", TOAST_ALT_ERROR: "Қате", TOAST_ALT_INFO: "Ақпарат", TOAST_ALT_SUCCESS: "Сәтті орындалды", TOAST_ALT_WARN: "Ескерту", TOAST_DISMISS_BUTTON: "Жою", TOAST_TITLE_ALT: "Хабарландыру", TRANSCRIPT_ARIA_LABEL_ALT: "Сөйлесу журналы, шарлау үшін көрсеткі пернелерін басыңыз.", TRANSCRIPT_ARIA_ROLE_ALT: "сөйлесу журналы", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Хабарлама интерактивті. Сөйлесу журналына ауысу үшін shift tab пернесін 2-3 рет басыңыз. Одан кейін өзара әрекеттесу үшін хабарламаны басыңыз.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Хабарламадағы бір немесе бірнеше сілтеме. Сөйлесу журналына ауысу үшін shift tab пернесін 2-3 рет басыңыз. Одан кейін өзара әрекеттесу үшін хабарламаны басыңыз.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Хабарда ұсынылған әрекеттер бар. Оларды таңдау үшін Shift және Tab пернелерін 2-3 рет басыңыз.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Хабарда ұсынылған әрекеттер бар. Оларды таңдау үшін $1 пернесін басыңыз.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Хабар жіберілмеді.", TRANSCRIPT_MORE_MESSAGES: "Қосымша хабарлар", TRANSCRIPT_NEW_MESSAGES: "Жаңа хабарлар", TRANSCRIPT_TERMINATOR_TEXT: "Сөйлесу журналының соңы", TYPING_INDICATOR_ALT: "Мәтін теру индикаторын көрсету", TYPING_INDICATOR_SINGLE_TEXT: "$1 теруде.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 және басқалар теруде.", VOTE_DISLIKE_ALT: "Ұнамайды", VOTE_LIKE_ALT: "Ұнайды" }, iFe = { _comment: "[CI-LOCKED] 이 파일의 내용이 잠겼습니다. 기여를 환영하지만 변경 유효성 검사가 지연될 수 있습니다.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "봇 $1의 말:", ACTIVITY_YOU_SAID_ALT: "나의 말:", ACTIVITY_BOT_ATTACHED_ALT: "봇이 첨부함:", ACTIVITY_ERROR_BOX_TITLE: "오류 메시지", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "상호 작용하려면 클릭하세요.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "대화형 메시지입니다.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "메시지에 링크가 하나 이상 있습니다.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "전송 실패.", ACTIVITY_YOU_ATTACHED_ALT: "내가 첨부함:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "첨부 파일 1개.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "첨부 파일 $1개.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "첨부 파일 $1개.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "첨부 파일 $1개.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "첨부 파일 $1개.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "보내기 실패. [다시 시도][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "보내는 중", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "$1에 보냄", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "방금", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1시간 전", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1분 전", ACTIVITY_STATUS_TIMESTAMP_TODAY: "오늘", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "어제", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "적응형 카드 구문 분석 오류", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "적응형 카드 렌더링 오류", ATTACHMENT_AUDIO: "오디오 클립입니다.", ATTACHMENT_CARD: "카드: $1 $2 $3", ATTACHMENT_FILE: "파일: $1", ATTACHMENT_IMAGE: "이미지", ATTACHMENT_TEXT: "텍스트: $1", ATTACHMENT_VIDEO: "비디오 클립", CAROUSEL_FLIPPER_NEXT_ALT: "다음", CAROUSEL_FLIPPER_PREVIOUS_ALT: "이전", CITATION_MODEL_DIALOG_ALT: "인용", CONNECTIVITY_STATUS_ALT_CONNECTED: "연결됨", CONNECTIVITY_STATUS_ALT_CONNECTING: "연결 중…", CONNECTIVITY_STATUS_ALT_FATAL: "연결할 수 없습니다.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "네트워크 중단이 발생했습니다. 다시 연결하는 중입니다...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "렌더링 오류입니다. 콘솔을 확인하거나 봇 개발자에게 문의하십시오.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "연결하는 데 평소보다 오래 걸립니다.", CONNECTIVITY_STATUS_ALT: "연결 상태: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "'$1' 파일 다운로드", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "$2 크기의 다운로드 파일 '$1'", FILE_CONTENT_WITH_SIZE_ALT: "$2 크기의 '$1'", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter 키", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "메시지 내 항목 액세스", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "채팅 기록", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "ESC 키", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "메시지 나가기", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab 키
Shift + Tab 키`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "메시지 내 항목 사이 이동", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `위쪽 화살표 키
아래쪽 화살표 키`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "메시지 사이 이동", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter 키", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "작업 수행", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab 키
Shift + Tab 키`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "채팅 창에서 항목 사이 이동", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "채팅 창", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "닫기", KEYBOARD_HELP_HEADER: "키보드 컨트롤", MARKDOWN_EXTERNAL_LINK_ALT: "새 창으로 엽니다. 외부.", RECEIPT_CARD_TAX: "세금", RECEIPT_CARD_TOTAL: "합계", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "참조 $1개", REFERENCE_LIST_HEADER_FEW: "$1 참조", REFERENCE_LIST_HEADER_MANY: "$1 참조", REFERENCE_LIST_HEADER_OTHER: "$1 참조", REFERENCE_LIST_HEADER_TWO: "참조 $1개", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "빈 메시지는 보낼 수 없습니다.", SPEECH_INPUT_LISTENING: "듣는 중...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "마이크 끄기", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "마이크 켜기", SPEECH_INPUT_STARTING: "시작하는 중…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "다음", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "이전", SUGGESTED_ACTIONS_LABEL_ALT: "제안된 작업", TEXT_INPUT_ALT: "메시지 입력 상자", TEXT_INPUT_PLACEHOLDER: "메시지 입력", TEXT_INPUT_SEND_BUTTON_ALT: "보내기", TEXT_INPUT_SPEAK_BUTTON_ALT: "말하기", TEXT_INPUT_UPLOAD_BUTTON_ALT: "파일 업로드", TOAST_ACCORDION_FEW: "$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.", TOAST_ACCORDION_MANY: "$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.", TOAST_ACCORDION_OTHER: "$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.", TOAST_ACCORDION_TWO: "$1개 알림: 자세한 내용을 보려면 여기를 클릭하십시오.", TOAST_ALT_ERROR: "오류", TOAST_ALT_INFO: "정보", TOAST_ALT_SUCCESS: "성공", TOAST_ALT_WARN: "경고", TOAST_DISMISS_BUTTON: "해제", TOAST_TITLE_ALT: "알림", TRANSCRIPT_ARIA_LABEL_ALT: "채팅 기록, 아래쪽 화살표 키를 사용하여 탐색합니다.", TRANSCRIPT_ARIA_ROLE_ALT: "채팅 기록", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "메시지가 대화형입니다. 채팅 기록으로 전환하기 위해 Shift Tab 키를 2~3회 누르세요. 그런 다음 상호 작용할 메시지를 클릭하세요.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "메시지에 링크가 하나 이상 있습니다. 채팅 기록으로 전환하기 위해 Shift Tab 키를 2~3회 누르세요. 그런 다음 상호 작용할 메시지를 클릭하세요.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "메시지가 작업을 제안했습니다. 선택하려면 Shift 탭을 2~3번 누르세요.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "메시지가 작업을 제안했습니다. 선택하려면 $1을 누르세요.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "메시지를 보내지 못했습니다.", TRANSCRIPT_MORE_MESSAGES: "추가 메시지", TRANSCRIPT_NEW_MESSAGES: "새 메시지", TRANSCRIPT_TERMINATOR_TEXT: "채팅 기록의 끝 부분", TYPING_INDICATOR_ALT: "입력 표시기 표시", TYPING_INDICATOR_SINGLE_TEXT: "$1님이 입력 중입니다.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1님과 다른 사용자가 입력 중입니다.", VOTE_DISLIKE_ALT: "불만족", VOTE_LIKE_ALT: "만족" }, oFe = { _comment: "[CI-LOCKED] Šio failo turinys užrakintas. Galite prisidėti, tačiau gali užtrukti, kol keitimai bus patikrinti.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Robotas $1 pasakė:", ACTIVITY_YOU_SAID_ALT: "Pasakėte:", ACTIVITY_BOT_ATTACHED_ALT: "Robotas pridėjo:", ACTIVITY_ERROR_BOX_TITLE: "Klaidos pranešimas", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Spustelėkite norėdami sąveikauti.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Pranešimas yra interaktyvus.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Pranešime yra vienas ar keli saitai.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Išsiųsti nepavyko.", ACTIVITY_YOU_ATTACHED_ALT: "Pridėjote:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 priedą.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 priedus.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 priedų.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 priedus.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 priedus.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Nepavyko išsiųsti. [Bandyti dar kartą][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Siunčiama", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Išsiųsta $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Ką tik", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Prieš valandą", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Prieš minutę", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Šiandien", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Vakar", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Adaptyviosios kortelės analizės klaida", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Adaptyviosios kortelės atvaizdavimo klaida", ATTACHMENT_AUDIO: "Garso įrašas.", ATTACHMENT_CARD: "Kortelė: $1 $2 $3", ATTACHMENT_FILE: "Failas: $1", ATTACHMENT_IMAGE: "Vaizdas", ATTACHMENT_TEXT: "Teksto žinutė: $1", ATTACHMENT_VIDEO: "Vaizdo įrašas", CAROUSEL_FLIPPER_NEXT_ALT: "Pirmyn", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Atgal", CITATION_MODEL_DIALOG_ALT: "Citata", CONNECTIVITY_STATUS_ALT_CONNECTED: "Prijungta", CONNECTIVITY_STATUS_ALT_CONNECTING: "Jungiamasi…", CONNECTIVITY_STATUS_ALT_FATAL: "Nepavyko prijungti.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Nutrūko tinklo ryšys. Jungiamasi iš naujo...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Atvaizdavimo klaida. Patikrinkite konsolę arba kreipkitės į roboto kūrėją.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Prisijungimas trunka ilgiau nei įprasta.", CONNECTIVITY_STATUS_ALT: "Ryšio būsena: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Atsisiųsti failą $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Atsisiųsti failą $1, kurio dydis $2", FILE_CONTENT_WITH_SIZE_ALT: "$1, kurio dydis $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Klavišas „Enter“", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Pasiekti pranešimo elementus", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Pokalbio retrospektyva", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Klavišas „Escape“", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Išeiti iš pranešimo", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabuliavimo klavišas
„Shift“ ir tabuliavimo klavišas`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Judėti tarp pranešimo elementų", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Rodyklės aukštyn klavišas
Rodyklės žemyn klavišas`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Judėti tarp pranešimų", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Klavišas „Enter“", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Atlikti veiksmą", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabuliavimo klavišas
„Shift“ ir tabuliavimo klavišas`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Judėti tarp pokalbio lango elementų", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Pokalbio langas", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Uždaryti", KEYBOARD_HELP_HEADER: "Klaviatūros valdikliai", MARKDOWN_EXTERNAL_LINK_ALT: "Atidaroma naujame lange; išorinis.", RECEIPT_CARD_TAX: "Mokestis", RECEIPT_CARD_TOTAL: "Iš viso", RECEIPT_CARD_VAT: "PVM", REFERENCE_LIST_HEADER_ONE: "$1 nuoroda", REFERENCE_LIST_HEADER_FEW: "$1 nuorodos", REFERENCE_LIST_HEADER_MANY: "$1 nuorodos", REFERENCE_LIST_HEADER_OTHER: "$1 nuorodų", REFERENCE_LIST_HEADER_TWO: "$1 nuorodos", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Negali siųsti tuščio pranešimo.", SPEECH_INPUT_LISTENING: "Klausomasi…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofonas išjungtas", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofonas įjungtas", SPEECH_INPUT_STARTING: "Pradedama…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Pirmyn", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Atgal", SUGGESTED_ACTIONS_LABEL_ALT: "Siūlomi veiksmai", TEXT_INPUT_ALT: "Pranešimo įvedimo laukas", TEXT_INPUT_PLACEHOLDER: "Įveskite savo pranešimą", TEXT_INPUT_SEND_BUTTON_ALT: "Siųsti", TEXT_INPUT_SPEAK_BUTTON_ALT: "Kalbėti", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Nusiųsti failą", TOAST_ACCORDION_FEW: "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją", TOAST_ACCORDION_MANY: "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją", TOAST_ACCORDION_OTHER: "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją", TOAST_ACCORDION_TWO: "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją", TOAST_ALT_ERROR: "Klaida", TOAST_ALT_INFO: "Informacija", TOAST_ALT_SUCCESS: "Sėkmingai", TOAST_ALT_WARN: "Įspėjimas", TOAST_DISMISS_BUTTON: "Išjungti", TOAST_TITLE_ALT: "Pranešimas", TRANSCRIPT_ARIA_LABEL_ALT: "Pokalbio retrospektyva, naršykite naudodami rodyklių klavišus.", TRANSCRIPT_ARIA_ROLE_ALT: "pokalbio retrospektyva", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Pranešimas yra interaktyvus. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Pranešime yra vienas ar keli saitai. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, 2–3 kartus paspauskite klavišą „Shift“.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, paspauskite klavišą $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Nepavyko išsiųsti pranešimo.", TRANSCRIPT_MORE_MESSAGES: "Daugiau pranešimų", TRANSCRIPT_NEW_MESSAGES: "Nauji pranešimai", TRANSCRIPT_TERMINATOR_TEXT: "Pokalbio retrospektyvos pabaiga", TYPING_INDICATOR_ALT: "Rodomas teksto įvedimo indikatorius", TYPING_INDICATOR_SINGLE_TEXT: "$1 rašo.", TYPING_INDICATOR_MULTIPLE_TEXT: "Rašo $1 ir kiti.", VOTE_DISLIKE_ALT: "Nepatinka", VOTE_LIKE_ALT: "Patinka" }, aFe = { _comment: "[CI-LOCKED] Šī faila saturs ir bloķēts. Ieguldījumi tiek gaidīti, taču izmaiņu validācija var tikt aizkavēta.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Robots $1 teica:", ACTIVITY_YOU_SAID_ALT: "Jūs teicāt:", ACTIVITY_BOT_ATTACHED_ALT: "Robots pievienots:", ACTIVITY_ERROR_BOX_TITLE: "Kļūdas ziņojums", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Noklikšķiniet, lai mijiedarbotos.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Ziņojums ir interaktīvs.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Ziņojumā ir viena vai vairākas saites.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Nosūtīšana neizdevās.", ACTIVITY_YOU_ATTACHED_ALT: "Jūs pievienojāt:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 pielikums.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 pielikumi.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 pielikumi.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 pielikumi.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 pielikumi.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Neizdevās nosūtīt. [Mēģināt vēlreiz][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Notiek sūtīšana", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Nosūtīts plkst. $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Tikko", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Pirms stundas", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Pirms minūtes", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Šodien", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Vakardien", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Adaptīvās kartītes parsēšanas kļūda", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Adaptīvās kartītes atveides kļūda", ATTACHMENT_AUDIO: "Audioklips.", ATTACHMENT_CARD: "Kartīte: $1 $2 $3", ATTACHMENT_FILE: "Fails: $1", ATTACHMENT_IMAGE: "Attēls", ATTACHMENT_TEXT: "Teksts: $1", ATTACHMENT_VIDEO: "Videoklips", CAROUSEL_FLIPPER_NEXT_ALT: "Tālāk", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Atpakaļ", CITATION_MODEL_DIALOG_ALT: "Citāts", CONNECTIVITY_STATUS_ALT_CONNECTED: "Izveidots savienojums", CONNECTIVITY_STATUS_ALT_CONNECTING: "Notiek savienojuma izveide…", CONNECTIVITY_STATUS_ALT_FATAL: "Nevar izveidot savienojumu.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Radās tīkla darbības pārtraukums. Notiek atkārtota savienojuma izveide…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Atveides kļūda. Lūdzu, pārbaudiet konsoli vai sazinieties ar robota izstrādātāju.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Savienojuma izveide notiek ilgāk nekā parasti.", CONNECTIVITY_STATUS_ALT: "Savienojuma statuss. $1", FILE_CONTENT_ALT: "“$1”", FILE_CONTENT_DOWNLOADABLE_ALT: "Lejupielādēt failu “$1”", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Lejupielādēt failu “$1”, kura lielums ir $2", FILE_CONTENT_WITH_SIZE_ALT: "“$1”, kura lielums ir $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Taustiņš Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Piekļūstiet ziņojuma elementiem", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Tērzēšanas vēsture", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Taustiņš Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Iziet no ziņojuma", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulēšanas taustiņš
Shift + tabulēšanas taustiņš`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Pārvietojieties starp ziņojuma elementiem", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Augšupvērstā bultiņa
Lejupvērstā bultiņa`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Pārvietojieties starp ziņojumiem", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Taustiņš Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Veiciet darbību", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulēšanas taustiņš
Shift + tabulēšanas taustiņš`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Pārvietojieties starp elementiem tērzēšanas logā", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Tērzēšanas logs", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Aizvērt", KEYBOARD_HELP_HEADER: "Tastatūras vadīklas", MARKDOWN_EXTERNAL_LINK_ALT: "Tiek atvērts jaunā logā (ārējā).", RECEIPT_CARD_TAX: "Nodoklis", RECEIPT_CARD_TOTAL: "Kopā", RECEIPT_CARD_VAT: "PVN", REFERENCE_LIST_HEADER_ONE: "$1 atsauce", REFERENCE_LIST_HEADER_FEW: "$1 atsauces", REFERENCE_LIST_HEADER_MANY: "$1 atsauces", REFERENCE_LIST_HEADER_OTHER: "$1 atsauces", REFERENCE_LIST_HEADER_TWO: "$1 atsauces", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Nevar nosūtīt tukšu ziņojumu.", SPEECH_INPUT_LISTENING: "Notiek klausīšanās…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Izslēgt mikrofonu", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Ieslēgt mikrofonu", SPEECH_INPUT_STARTING: "Sākas ievade…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Tālāk", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Atpakaļ", SUGGESTED_ACTIONS_LABEL_ALT: "Ieteicamās darbības", TEXT_INPUT_ALT: "Ziņojuma ievades lodziņš", TEXT_INPUT_PLACEHOLDER: "Ierakstiet ziņojumu", TEXT_INPUT_SEND_BUTTON_ALT: "Nosūtīt", TEXT_INPUT_SPEAK_BUTTON_ALT: "Runāt", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Augšupielādēt failu", TOAST_ACCORDION_FEW: "$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju", TOAST_ACCORDION_MANY: "$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju", TOAST_ACCORDION_OTHER: "$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju", TOAST_ACCORDION_TWO: "$1 paziņojumi. Noklikšķiniet šeit, lai skatītu detalizētu informāciju", TOAST_ALT_ERROR: "Kļūda", TOAST_ALT_INFO: "Informācija", TOAST_ALT_SUCCESS: "Veiksmīgi", TOAST_ALT_WARN: "Brīdinājums", TOAST_DISMISS_BUTTON: "Nerādīt", TOAST_TITLE_ALT: "Paziņojums", TRANSCRIPT_ARIA_LABEL_ALT: "Tērzēšanas vēsture, izmantojiet bulttaustiņus, lai naviģētu.", TRANSCRIPT_ARIA_ROLE_ALT: "tērzēšanas vēsture", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Ziņojums ir interaktīvs. Nospiediet taustiņu Shift un tabulēšanas taustiņu 2–3 reizes, lai pārslēgtu uz tērzēšanas vēsturi. Pēc tam noklikšķiniet uz ziņojuma, lai veiktu mijiedarbību.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Ziņojumā ir viena vai vairākas saites. Nospiediet taustiņu Shift un tabulēšanas taustiņu 2–3 reizes, lai pārslēgtu uz tērzēšanas vēsturi. Pēc tam noklikšķiniet uz ziņojuma, lai veiktu mijiedarbību.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Ziņojumam ir ieteicamās darbības. Lai tās atlasītu, 2–3 reizes nospiediet taustiņu kombināciju Shift Tab.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Ziņojumam ir ieteicamās darbības. Lai tās atlasītu, nospiediet $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Neizdevās nosūtīt ziņojumu.", TRANSCRIPT_MORE_MESSAGES: "Vairāk ziņojumu", TRANSCRIPT_NEW_MESSAGES: "Jauni ziņojumi", TRANSCRIPT_TERMINATOR_TEXT: "Tērzēšanas vēstures beigas", TYPING_INDICATOR_ALT: "Rāda rakstīšanas indikatoru", TYPING_INDICATOR_SINGLE_TEXT: "$1 raksta.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 un citi raksta.", VOTE_DISLIKE_ALT: "Nepatīk", VOTE_LIKE_ALT: "Patīk" }, uFe = { _comment: "[CI-LOCKED] Kandungan fail ini telah dikunci. Sumbangan dialu-alukan, tetapi pengesahan perubahan mungkin ditunda.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 berkata:", ACTIVITY_YOU_SAID_ALT: "Anda berkata:", ACTIVITY_BOT_ATTACHED_ALT: "Bot lampirkan:", ACTIVITY_ERROR_BOX_TITLE: "Mesej ralat", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klik untuk berinteraksi.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Mesej adalah interaktif.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Satu atau beberapa pautan dalam mesej.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Penghantaran telah gagal.", ACTIVITY_YOU_ATTACHED_ALT: "Anda lampirkan:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 lampiran.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 lampiran.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Gagal dihantar. [Cuba Semula][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Menghantar", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Dihantar pada $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Sebentar tadi", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Sejam yang lalu", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Seminit yang lalu", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hari Ini", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Semalam", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Ralat penguraian Kad Mudah Suai", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Ralat pemaparan Kad Mudah Suai", ATTACHMENT_AUDIO: "Klip audio.", ATTACHMENT_CARD: "Kad: $1 $2 $3", ATTACHMENT_FILE: "Fail: $1", ATTACHMENT_IMAGE: "Imej", ATTACHMENT_TEXT: "Teks: $1", ATTACHMENT_VIDEO: "Klip video", CAROUSEL_FLIPPER_NEXT_ALT: "Seterusnya", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Sebelumnya", CITATION_MODEL_DIALOG_ALT: "Petikan", CONNECTIVITY_STATUS_ALT_CONNECTED: "Disambungkan", CONNECTIVITY_STATUS_ALT_CONNECTING: "Bersambung…", CONNECTIVITY_STATUS_ALT_FATAL: "Tidak dapat bersambung.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Gangguan rangkaian telah berlaku. Bersambung semula…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Ralat telah berlaku. Sila semak konsol atau hubungi pembangun bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Masa yang lebih lama daripada biasa diambil untuk bersambung.", CONNECTIVITY_STATUS_ALT: "Status Sambungan: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Muat turun fail '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Muat turun fail '$1' dengan saiz $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' dengan saiz $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Kekunci enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Akses item dalam mesej", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Sejarah sembang", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Kekunci escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Mesej keluar", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Kekunci tab
Kekunci shift + tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Gerakkan antara item dalam mesej", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Kekunci anak panah atas
Kekunci anak panah bawah`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Gerakkan antara mesej", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Kekunci enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Lakukan tindakan", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Kekunci tab
Kekunci shift + tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Gerakkan antara item dalam tetingkap sembang", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Tetingkap sembang", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Tutup", KEYBOARD_HELP_HEADER: "Kawalan papan kekunci", MARKDOWN_EXTERNAL_LINK_ALT: "Buka dalam tetingkap yang baharu; luaran.", RECEIPT_CARD_TAX: "Cukai", RECEIPT_CARD_TOTAL: "Jumlah", RECEIPT_CARD_VAT: "VAT", REFERENCE_LIST_HEADER_ONE: "$1 rujukan", REFERENCE_LIST_HEADER_FEW: "$1 rujukan", REFERENCE_LIST_HEADER_MANY: "$1 rujukan", REFERENCE_LIST_HEADER_OTHER: "$1 rujukan", REFERENCE_LIST_HEADER_TWO: "$1 rujukan", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Tidak boleh menghantar mesej kosong.", SPEECH_INPUT_LISTENING: "Mendengar…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon dimatikan", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon dihidupkan", SPEECH_INPUT_STARTING: "Bermula…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Seterusnya", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Sebelumnya", SUGGESTED_ACTIONS_LABEL_ALT: "Tindakan dicadangkan", TEXT_INPUT_ALT: "Kotak input mesej", TEXT_INPUT_PLACEHOLDER: "Taip mesej anda", TEXT_INPUT_SEND_BUTTON_ALT: "Hantar", TEXT_INPUT_SPEAK_BUTTON_ALT: "Cakap", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Muat naik fail", TOAST_ACCORDION_FEW: "$1 Pemberitahuan: Klik di sini untuk melihat butiran", TOAST_ACCORDION_MANY: "$1 Pemberitahuan: Klik di sini untuk melihat butiran", TOAST_ACCORDION_OTHER: "$1 Pemberitahuan: Klik di sini untuk melihat butiran", TOAST_ACCORDION_TWO: "$1 Pemberitahuan: Klik di sini untuk melihat butiran", TOAST_ALT_ERROR: "Ralat", TOAST_ALT_INFO: "Maklumat", TOAST_ALT_SUCCESS: "Berjaya", TOAST_ALT_WARN: "Amaran", TOAST_DISMISS_BUTTON: "Tolak", TOAST_TITLE_ALT: "Pemberitahuan", TRANSCRIPT_ARIA_LABEL_ALT: "Sejarah sembang, tekan kekunci anak panah untuk menavigasi.", TRANSCRIPT_ARIA_ROLE_ALT: "sejarah sembang", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Mesej adalah interaktif. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Satu atau lebih pautan dalam mesej. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Mesej mempunyai tindakan dicadangkan. Tekan shift tab 2 hingga 3 kali untuk memilih tindakan.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Mesej mempunyai tindakan dicadangkan. Tekan $1 untuk memilih tindakan.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Mesej gagal dihantar.", TRANSCRIPT_MORE_MESSAGES: "Lebih banyak mesej", TRANSCRIPT_NEW_MESSAGES: "Mesej baharu", TRANSCRIPT_TERMINATOR_TEXT: "Tamat sejarah sembang", TYPING_INDICATOR_ALT: "Menunjukkan penunjuk menaip", TYPING_INDICATOR_SINGLE_TEXT: "$1 sedang menaip.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 dan lain-lain sedang menaip.", VOTE_DISLIKE_ALT: "Tidak suka", VOTE_LIKE_ALT: "Suka" }, sFe = { _comment: "[CI-LOCKED] Innholdet i denne filen er låst. Bidrag er velkomne, men validering av endring kan bli forsinket.", ACCESS_KEY_ALT: "Alt Skift $1", ACCESS_KEY_FOR_MAC_ALT: "Kontroll Tilvalg $1", ACTIVITY_BOT_SAID_ALT: "Roboten $1 sa:", ACTIVITY_YOU_SAID_ALT: "Du sa:", ACTIVITY_BOT_ATTACHED_ALT: "Roboten la ved:", ACTIVITY_ERROR_BOX_TITLE: "Feilmelding", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klikk for å samhandle.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Meldingen er interaktiv.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "En eller flere koblinger i meldingen.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Sending mislyktes.", ACTIVITY_YOU_ATTACHED_ALT: "Du la ved:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 vedlegg.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 vedlegg.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 vedlegg.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 vedlegg.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 vedlegg.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Sending mislyktes. [Prøv på nytt][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Sender", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Sendt klokken $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Akkurat nå", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "For en time siden", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "For et minutt siden", ACTIVITY_STATUS_TIMESTAMP_TODAY: "I dag", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "I går", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Feil ved analyse av AdaptiveCard", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Feil ved gjengivelse av AdaptiveCard", ATTACHMENT_AUDIO: "Et lydklipp.", ATTACHMENT_CARD: "Et kort: $1 $2 $3", ATTACHMENT_FILE: "En fil: $1", ATTACHMENT_IMAGE: "Et bilde", ATTACHMENT_TEXT: "En tekst: $1", ATTACHMENT_VIDEO: "Et videoklipp", CAROUSEL_FLIPPER_NEXT_ALT: "Neste", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Forrige", CITATION_MODEL_DIALOG_ALT: "Referanse", CONNECTIVITY_STATUS_ALT_CONNECTED: "Tilkoblet", CONNECTIVITY_STATUS_ALT_CONNECTING: "Kobler til ...", CONNECTIVITY_STATUS_ALT_FATAL: "Kan ikke koble til.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Det oppstod et nettverksbrudd. Kobler til på nytt ...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Gjengivelsesfeil. Kontroller konsollen eller kontakt robotutvikleren.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Tar lengre tid enn vanlig å koble til.", CONNECTIVITY_STATUS_ALT: "Tilkoblingsstatus: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Last ned filen $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Last ned filen $1 med størrelsen $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 med størrelsen $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter-tast", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Få tilgang til elementer i meldingen", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chattelogg", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "ESC-tast", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Lukk melding", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatortast
Skift + tabulatortast`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Flytt mellom elementer i en melding", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Pil opp-tast
Pil ned-tast`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Flytt mellom meldinger", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter-tast", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Utfør handling", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatortast
Skift + tabulatortast`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Flytt mellom elementer i chatvinduet", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chatvindu", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Lukk", KEYBOARD_HELP_HEADER: "Tastaturkontroller", MARKDOWN_EXTERNAL_LINK_ALT: "Åpnes i et nytt vindu, eksternt.", RECEIPT_CARD_TAX: "Avgift", RECEIPT_CARD_TOTAL: "Totalt", RECEIPT_CARD_VAT: "Merverdiavgift", REFERENCE_LIST_HEADER_ONE: "$1 referanse", REFERENCE_LIST_HEADER_FEW: "$1 referanser", REFERENCE_LIST_HEADER_MANY: "$1 referanser", REFERENCE_LIST_HEADER_OTHER: "$1 referanser", REFERENCE_LIST_HEADER_TWO: "$1 referanser", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Kan ikke sende tom melding.", SPEECH_INPUT_LISTENING: "Lytter ...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon av", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon på", SPEECH_INPUT_STARTING: "Starter ...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Neste", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Forrige", SUGGESTED_ACTIONS_LABEL_ALT: "Foreslåtte handlinger", TEXT_INPUT_ALT: "Meldingsinndataboks", TEXT_INPUT_PLACEHOLDER: "Skriv inn meldingen", TEXT_INPUT_SEND_BUTTON_ALT: "Send", TEXT_INPUT_SPEAK_BUTTON_ALT: "Tal", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Last opp fil", TOAST_ACCORDION_FEW: "$1 varslinger: Klikk her for å se detaljer", TOAST_ACCORDION_MANY: "$1 varslinger: Klikk her for å se detaljer", TOAST_ACCORDION_OTHER: "$1 varslinger: Klikk her for å se detaljer", TOAST_ACCORDION_TWO: "$1 varslinger: Klikk her for å se detaljer", TOAST_ALT_ERROR: "Feil", TOAST_ALT_INFO: "Informasjon", TOAST_ALT_SUCCESS: "Vellykket", TOAST_ALT_WARN: "Advarsel!", TOAST_DISMISS_BUTTON: "Forkast", TOAST_TITLE_ALT: "Varsling", TRANSCRIPT_ARIA_LABEL_ALT: "Chattelogg, trykk på piltastene for å navigere.", TRANSCRIPT_ARIA_ROLE_ALT: "chattelogg", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Meldingen er interaktiv. Trykk på skift tabulatortasten to til tre ganger for å bytte til chatteloggen. Deretter klikker du på meldingen for å samhandle.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "En eller flere koblinger i meldingen. Trykk på skift tabulatortasten to til tre ganger for å bytte til chatteloggen. Deretter klikker du på meldingen for å samhandle.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Meldingen har foreslåtte handlinger. Trykk på skift tab to til tre ganger for å velge dem.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Meldingen har foreslåtte handlinger. Trykk på $1 for å velge dem.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Kan ikke sende meldingen.", TRANSCRIPT_MORE_MESSAGES: "Flere meldinger", TRANSCRIPT_NEW_MESSAGES: "Nye meldinger", TRANSCRIPT_TERMINATOR_TEXT: "Slutten på chatteloggen", TYPING_INDICATOR_ALT: "Viser skriveindikatoren", TYPING_INDICATOR_SINGLE_TEXT: "$1 skriver.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 og andre skriver.", VOTE_DISLIKE_ALT: "Mislik", VOTE_LIKE_ALT: "Lik" }, cFe = { _comment: "[CI-LOCKED] De inhoud van dit bestand is vergrendeld. Bijdragen zijn welkom, maar wijzigingen in de validatie zijn mogelijk vertraagd.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 zei:", ACTIVITY_YOU_SAID_ALT: "U zei:", ACTIVITY_BOT_ATTACHED_ALT: "Bot heeft bijgevoegd:", ACTIVITY_ERROR_BOX_TITLE: "Foutbericht", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klik om te communiceren.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Bericht is interactief.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Een of meer koppelingen in het bericht.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Verzenden mislukt.", ACTIVITY_YOU_ATTACHED_ALT: "U hebt bijgevoegd:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 bijlage.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 bijlagen.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 bijlagen.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 bijlagen.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 bijlagen.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Verzenden mislukt. [Opnieuw][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Wordt verzonden", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Verzonden om $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Zojuist", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Een uur geleden", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Een minuut geleden", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Vandaag", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Gisteren", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Parseerfout adaptieve kaart", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Weergavefout adaptieve kaart", ATTACHMENT_AUDIO: "Een audioclip.", ATTACHMENT_CARD: "Een kaart: $1 $2 $3", ATTACHMENT_FILE: "Een bestand: $1", ATTACHMENT_IMAGE: "Een afbeelding", ATTACHMENT_TEXT: "Een tekst: $1", ATTACHMENT_VIDEO: "Een videoclip", CAROUSEL_FLIPPER_NEXT_ALT: "Volgende", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Vorige", CITATION_MODEL_DIALOG_ALT: "Citaat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Verbonden", CONNECTIVITY_STATUS_ALT_CONNECTING: "Verbinding maken...", CONNECTIVITY_STATUS_ALT_FATAL: "Kan geen verbinding maken.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Er is een netwerkonderbreking opgetreden. Verbinding wordt hersteld...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Fout bij genereren. Controleer de console of neem contact op met de bot-ontwikkelaar.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Het duurt langer dan gewoonlijk om verbinding te maken.", CONNECTIVITY_STATUS_ALT: "Verbindingsstatus: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Bestand '$1' downloaden", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Downloadbestand '$1' van grootte $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' van grootte $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter-toets", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Toegang tot items in bericht", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chatgeschiedenis", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape-toets", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Afsluitbericht", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabtoets
Shift + tabtoets`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Heen en weer gaan tussen items in een bericht", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Pijl-omhoog
Pijl-omlaag`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Heen en weer gaan tussen berichten", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter-toets", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Actie uitvoeren", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabtoets
Shift + tabtoets`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Heen en weer gaan tussen items in het chatvenster", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chatvenster", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Sluiten", KEYBOARD_HELP_HEADER: "Toetsenbordbesturingselementen", MARKDOWN_EXTERNAL_LINK_ALT: "Wordt geopend in een nieuw venster; extern.", RECEIPT_CARD_TAX: "Belastingen", RECEIPT_CARD_TOTAL: "Totaal", RECEIPT_CARD_VAT: "Btw", REFERENCE_LIST_HEADER_ONE: "$1 verwijzing", REFERENCE_LIST_HEADER_FEW: "$1 verwijzingen", REFERENCE_LIST_HEADER_MANY: "$1 verwijzingen", REFERENCE_LIST_HEADER_OTHER: "$1 verwijzingen", REFERENCE_LIST_HEADER_TWO: "$1 verwijzingen", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Kan geen leeg bericht verzenden.", SPEECH_INPUT_LISTENING: "Luisteren...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microfoon uit", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microfoon aan", SPEECH_INPUT_STARTING: "Starten...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Volgende", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Vorige", SUGGESTED_ACTIONS_LABEL_ALT: "Voorgestelde acties", TEXT_INPUT_ALT: "Vak voor berichtinvoer", TEXT_INPUT_PLACEHOLDER: "Typ uw bericht", TEXT_INPUT_SEND_BUTTON_ALT: "Verzenden", TEXT_INPUT_SPEAK_BUTTON_ALT: "Spreken", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Bestand uploaden", TOAST_ACCORDION_FEW: "$1 meldingen: klik hier voor details", TOAST_ACCORDION_MANY: "$1 meldingen: klik hier voor details", TOAST_ACCORDION_OTHER: "$1 meldingen: klik hier voor details", TOAST_ACCORDION_TWO: "$1 meldingen: klik hier voor details", TOAST_ALT_ERROR: "Fout", TOAST_ALT_INFO: "Informatie", TOAST_ALT_SUCCESS: "Gelukt", TOAST_ALT_WARN: "Waarschuwing", TOAST_DISMISS_BUTTON: "Negeren", TOAST_TITLE_ALT: "Melding", TRANSCRIPT_ARIA_LABEL_ALT: "Chatgeschiedenis, druk op de pijltoetsen om te navigeren.", TRANSCRIPT_ARIA_ROLE_ALT: "chatgeschiedenis", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Bericht is interactief. Druk 2 tot 3 keer op Shift en tabtoets om over te schakelen naar de chatgeschiedenis. Klik vervolgens op het bericht voor interactie.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Een of meer koppelingen in het bericht. Druk 2 tot 3 keer op Shift en tabtoets om over te schakelen naar de chatgeschiedenis. Klik vervolgens op het bericht voor interactie.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Bericht heeft voorgestelde acties. Druk 2 tot 3 keer op Shift en tabtoets om deze te selecteren.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Bericht heeft voorgestelde acties. Druk op $1 om deze te selecteren.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Het bericht is niet verzonden.", TRANSCRIPT_MORE_MESSAGES: "Meer berichten", TRANSCRIPT_NEW_MESSAGES: "Nieuwe berichten", TRANSCRIPT_TERMINATOR_TEXT: "Einde chatgeschiedenis", TYPING_INDICATOR_ALT: "Indicator voor typen weergeven", TYPING_INDICATOR_SINGLE_TEXT: "$1 is bezig met typen.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 en anderen zijn bezig met typen.", VOTE_DISLIKE_ALT: "Niet leuk", VOTE_LIKE_ALT: "Leuk" }, lFe = { _comment: "[CI-LOCKED] Zawartość tego pliku jest zablokowana. Wkład twórczy jest mile widziany, ale weryfikacja zmian może być opóźniona.", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "Control + Option + $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 powiedział:", ACTIVITY_YOU_SAID_ALT: "Ty mówisz:", ACTIVITY_BOT_ATTACHED_ALT: "Bot dołączył:", ACTIVITY_ERROR_BOX_TITLE: "Komunikat o błędzie", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknij, aby wejść w interakcję.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Wiadomość jest interakcyjna.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Wiadomość zawiera co najmniej jeden link.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Wysyłanie nie powiodło się.", ACTIVITY_YOU_ATTACHED_ALT: "Ty dołączasz:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 załącznik.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 załączniki.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 załączników.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 załącznika.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 załączniki.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Wysyłanie nie powiodło się. [Ponów próbę][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Wysyłanie", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Wysłano o $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Teraz", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Godzinę temu", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Minutę temu", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Dzisiaj", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Wczoraj", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Błąd analizowania karty adaptacyjnej", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Błąd renderowania karty adaptacyjnej", ATTACHMENT_AUDIO: "Klip audio.", ATTACHMENT_CARD: "Karta: $1 $2 $3", ATTACHMENT_FILE: "Plik: $1", ATTACHMENT_IMAGE: "Obraz", ATTACHMENT_TEXT: "Tekst: $1", ATTACHMENT_VIDEO: "Klip wideo", CAROUSEL_FLIPPER_NEXT_ALT: "Dalej", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Wstecz", CITATION_MODEL_DIALOG_ALT: "Cytat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Połączono", CONNECTIVITY_STATUS_ALT_CONNECTING: "Trwa nawiązywanie połączenia...", CONNECTIVITY_STATUS_ALT_FATAL: "Nie można nawiązać połączenia.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Wystąpiła przerwa w działaniu sieci. Trwa ponowne nawiązywanie połączenia...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Błąd renderowania. Sprawdź konsolę lub skontaktuj się z deweloperem bota.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Nawiązywanie połączenia trwa dłużej niż zazwyczaj.", CONNECTIVITY_STATUS_ALT: "Stan łączności: $1", FILE_CONTENT_ALT: "„$1”", FILE_CONTENT_DOWNLOADABLE_ALT: "Pobierz plik „$1”", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Pobierz plik „$1” o rozmiarze $2", FILE_CONTENT_WITH_SIZE_ALT: "Plik „$1” o rozmiarze $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Klawisz Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Uzyskaj dostęp do elementów w wiadomości", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Historia czatu", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Klawisz Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Zamknij komunikat", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Klawisz Tab
Klawisze Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Przechodź między elementami w wiadomości", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Klawisz Strzałka w górę
Klawisz Strzałka w dół`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Przechodź między wiadomościami", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Klawisz Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Wykonaj akcję", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Klawisz Tab
Klawisze Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Przechodź między elementami w oknie czatu", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Okno czatu", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zamknij", KEYBOARD_HELP_HEADER: "Sterowanie za pomocą klawiatury", MARKDOWN_EXTERNAL_LINK_ALT: "Powoduje otwarcie w nowym oknie; link zewnętrzny.", RECEIPT_CARD_TAX: "Podatek", RECEIPT_CARD_TOTAL: "Suma", RECEIPT_CARD_VAT: "Podatek VAT", REFERENCE_LIST_HEADER_ONE: "$1 odwołanie", REFERENCE_LIST_HEADER_FEW: "$1 odwołania", REFERENCE_LIST_HEADER_MANY: "$1 odwołań", REFERENCE_LIST_HEADER_OTHER: "$1 odwołania", REFERENCE_LIST_HEADER_TWO: "$1 odwołania", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Nie można wysłać pustej wiadomości.", SPEECH_INPUT_LISTENING: "Trwa słuchanie...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon wyłączony", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon włączony", SPEECH_INPUT_STARTING: "Trwa rozpoczynanie...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Dalej", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Wstecz", SUGGESTED_ACTIONS_LABEL_ALT: "Sugerowane akcje", TEXT_INPUT_ALT: "Pole wprowadzania wiadomości", TEXT_INPUT_PLACEHOLDER: "Wpisz wiadomość", TEXT_INPUT_SEND_BUTTON_ALT: "Wyślij", TEXT_INPUT_SPEAK_BUTTON_ALT: "Mów", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Przekaż plik", TOAST_ACCORDION_FEW: "$1 powiadomienia: kliknij tutaj, aby wyświetlić szczegóły", TOAST_ACCORDION_MANY: "$1 powiadomienia: kliknij tutaj, aby wyświetlić szczegóły", TOAST_ACCORDION_OTHER: "$1 powiadomienia: kliknij tutaj, aby wyświetlić szczegóły", TOAST_ACCORDION_TWO: "$1 powiadomienia: kliknij tutaj, aby wyświetlić szczegóły", TOAST_ALT_ERROR: "Błąd", TOAST_ALT_INFO: "Informacje", TOAST_ALT_SUCCESS: "Sukces", TOAST_ALT_WARN: "Ostrzeżenie", TOAST_DISMISS_BUTTON: "Odrzuć", TOAST_TITLE_ALT: "Powiadomienie", TRANSCRIPT_ARIA_LABEL_ALT: "Historia czatu, naciskaj klawisze strzałek, aby nawigować.", TRANSCRIPT_ARIA_ROLE_ALT: "historia czatu", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Wiadomość jest interakcyjna. Naciśnij 2-3 razy klawisze Shift+Tab, aby przełączyć się do historii czatu. Następnie kliknij w wiadomości, aby wejść w interakcję.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Wiadomość zawiera co najmniej jeden link. Naciśnij 2-3 razy klawisze Shift+Tab, aby przełączyć się do historii czatu. Następnie kliknij w wiadomości, aby wejść w interakcję.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Wiadomość zawiera sugerowane akcje. Naciśnij klawisze Shift + Tab 2 lub 3 razy, aby je wybrać.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Wiadomość zawiera sugerowane akcje. Naciśnij klawisz $1, aby je wybrać.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Nie można wysłać wiadomości.", TRANSCRIPT_MORE_MESSAGES: "Więcej wiadomości", TRANSCRIPT_NEW_MESSAGES: "Nowe wiadomości", TRANSCRIPT_TERMINATOR_TEXT: "Koniec historii czatu", TYPING_INDICATOR_ALT: "Wyświetlanie wskaźnika wpisywania", TYPING_INDICATOR_SINGLE_TEXT: "$1 pisze.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 i inni piszą.", VOTE_DISLIKE_ALT: "Nie podoba mi się", VOTE_LIKE_ALT: "Podoba mi się" }, fFe = { _comment: "[CI-LOCKED] O conteúdo deste arquivo está bloqueado. Contribuições são bem-vindas, mas pode haver atrasos na validação das alterações.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "O bot $1 disse:", ACTIVITY_YOU_SAID_ALT: "Você disse:", ACTIVITY_BOT_ATTACHED_ALT: "Bot anexado:", ACTIVITY_ERROR_BOX_TITLE: "Mensagem de erro", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Clique para interagir.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "A mensagem é interativa.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Um ou mais links na mensagem.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Falha no envio.", ACTIVITY_YOU_ATTACHED_ALT: "Você anexou:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 anexo.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 anexos.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Falha no envio. [Repetir][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Enviando", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Enviado às $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Agora", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Há uma hora", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Há um minuto", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hoje", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ontem", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Erro de análise do Cartão Adaptável", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Erro de renderização do Cartão Adaptável", ATTACHMENT_AUDIO: "Um clipe de áudio.", ATTACHMENT_CARD: "Um cartão: $1 $2 $3", ATTACHMENT_FILE: "Um arquivo: $1", ATTACHMENT_IMAGE: "Uma imagem", ATTACHMENT_TEXT: "Um texto: $1", ATTACHMENT_VIDEO: "Um videoclipe", CAROUSEL_FLIPPER_NEXT_ALT: "Avançar", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Voltar", CITATION_MODEL_DIALOG_ALT: "Citação", CONNECTIVITY_STATUS_ALT_CONNECTED: "Conectado", CONNECTIVITY_STATUS_ALT_CONNECTING: "Conectando…", CONNECTIVITY_STATUS_ALT_FATAL: "Não é possível conectar.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Ocorreu uma interrupção da rede. Reconectando…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Erro de renderização. Verifique o console ou contate o desenvolvedor de bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "A conexão está demorando mais do que o habitual.", CONNECTIVITY_STATUS_ALT: "Status da Conectividade: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Baixar o arquivo '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Baixar o arquivo '$1' de tamanho $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' de tamanho $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tecla Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Acessar itens na mensagem", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Histórico de chat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tecla Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Sair da mensagem", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tecla Tab
Tecla Shift + tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Mover entre itens em uma mensagem", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tecla de seta para cima
Tecla de seta para baixo`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Mover entre mensagens", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tecla Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Realizar ação", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tecla Tab
Tecla Shift + tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Mover entre itens na janela de chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Janela de chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Fechar", KEYBOARD_HELP_HEADER: "Controles do teclado", MARKDOWN_EXTERNAL_LINK_ALT: "Abre em uma nova janela externa.", RECEIPT_CARD_TAX: "Imposto", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "IVA", REFERENCE_LIST_HEADER_ONE: "$1 referência", REFERENCE_LIST_HEADER_FEW: "$1 referências", REFERENCE_LIST_HEADER_MANY: "$1 referências", REFERENCE_LIST_HEADER_OTHER: "$1 referências", REFERENCE_LIST_HEADER_TWO: "$1 referências", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Não é possível enviar uma mensagem vazia.", SPEECH_INPUT_LISTENING: "Escutando…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microfone desligado", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microfone ligado", SPEECH_INPUT_STARTING: "Iniciando…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Avançar", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Voltar", SUGGESTED_ACTIONS_LABEL_ALT: "Ações sugeridas", TEXT_INPUT_ALT: "Caixa de entrada de mensagens", TEXT_INPUT_PLACEHOLDER: "Digite sua mensagem", TEXT_INPUT_SEND_BUTTON_ALT: "Enviar", TEXT_INPUT_SPEAK_BUTTON_ALT: "Falar", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Carregar arquivo", TOAST_ACCORDION_FEW: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_MANY: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_OTHER: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_TWO: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ALT_ERROR: "Erro", TOAST_ALT_INFO: "Informação", TOAST_ALT_SUCCESS: "Sucesso", TOAST_ALT_WARN: "Aviso", TOAST_DISMISS_BUTTON: "Ignorar", TOAST_TITLE_ALT: "Notificação", TRANSCRIPT_ARIA_LABEL_ALT: "Histórico de chat, use as teclas de seta para navegar.", TRANSCRIPT_ARIA_ROLE_ALT: "histórico de chat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "A mensagem é interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o histórico do chat. Depois, clique na mensagem para interagir.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Um ou mais links na mensagem. A mensagem é interativa. Pressione a tecla Shift Tab de 2 para 3 vezes para alternar para o histórico do chat. Depois, clique na mensagem para interagir.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "A mensagem tem ações sugeridas. Pressione shift tab de 2 a 3 vezes para selecioná-las.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "A mensagem tem ações sugeridas. Pressione $1 para selecioná-las.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Falha ao enviar a mensagem.", TRANSCRIPT_MORE_MESSAGES: "Mais mensagens", TRANSCRIPT_NEW_MESSAGES: "Novas mensagens", TRANSCRIPT_TERMINATOR_TEXT: "Término do histórico de chat", TYPING_INDICATOR_ALT: "Mostrando o indicador de digitação", TYPING_INDICATOR_SINGLE_TEXT: "$1 está digitando.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 e outros estão digitando.", VOTE_DISLIKE_ALT: "Não gostei", VOTE_LIKE_ALT: "Gostei" }, dFe = { _comment: "[CI-LOCKED] O conteúdo deste ficheiro está bloqueado. São aceites contribuições, mas a validação das alterações pode registar atrasos.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Controlo Opção $1", ACTIVITY_BOT_SAID_ALT: "O bot $1 disse:", ACTIVITY_YOU_SAID_ALT: "Disse:", ACTIVITY_BOT_ATTACHED_ALT: "Bot anexado:", ACTIVITY_ERROR_BOX_TITLE: "Mensagem de erro", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Clique para interagir.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "A mensagem é interativa.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "A mensagem contém uma ou mais ligações.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Falha ao enviar.", ACTIVITY_YOU_ATTACHED_ALT: "Anexou:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 anexo.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 anexos.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 anexos.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Falha ao enviar. [Repetir][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "A enviar", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Enviado às $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Agora mesmo", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Há uma hora", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Há um minuto", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hoje", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ontem", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Erro de análise de Cartão Adaptável", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Erro de composição de Cartão Adaptável", ATTACHMENT_AUDIO: "Um clip de áudio.", ATTACHMENT_CARD: "Um cartão: $1 $2 $3", ATTACHMENT_FILE: "Um ficheiro: $1", ATTACHMENT_IMAGE: "Uma imagem", ATTACHMENT_TEXT: "Um texto: $1", ATTACHMENT_VIDEO: "Um clip de vídeo", CAROUSEL_FLIPPER_NEXT_ALT: "Seguinte", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Anterior", CITATION_MODEL_DIALOG_ALT: "Citação", CONNECTIVITY_STATUS_ALT_CONNECTED: "Ligado", CONNECTIVITY_STATUS_ALT_CONNECTING: "A ligar…", CONNECTIVITY_STATUS_ALT_FATAL: "Não é possível ligar.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Ocorreu uma interrupção de rede. A restabelecer ligação…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Erro de composição. Verifique a consola ou contacte o programador do bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "O estabelecimento da ligação está a demorar mais tempo do que o esperado.", CONNECTIVITY_STATUS_ALT: "Estado de Conectividade: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: 'Transferir o ficheiro "$1"', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Transferir o ficheiro "$1" com um tamanho de $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" com um tamanho de $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tecla Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Aceder a itens na mensagem", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Histórico de chat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tecla Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Sair da mensagem", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tecla de tabulação
Shift + tecla de tabulação`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Mover-se entre itens numa mensagem", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tecla de seta para cima
Tecla de seta para baixo`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Mover-se entre mensagens", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tecla Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Efetuar ação", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tecla de tabulação
Shift + tecla de tabulação`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Mover-se entre itens na janela de chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Janela de chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Fechar", KEYBOARD_HELP_HEADER: "Controlos do teclado", MARKDOWN_EXTERNAL_LINK_ALT: "Abre numa nova janela externa.", RECEIPT_CARD_TAX: "Imposto", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "IVA", REFERENCE_LIST_HEADER_ONE: "$1 referência", REFERENCE_LIST_HEADER_FEW: "$1 referências", REFERENCE_LIST_HEADER_MANY: "$1 referências", REFERENCE_LIST_HEADER_OTHER: "$1 referências", REFERENCE_LIST_HEADER_TWO: "$1 referências", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Não é possível enviar uma mensagem vazia.", SPEECH_INPUT_LISTENING: "A escutar…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microfone desativado", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microfone ativado", SPEECH_INPUT_STARTING: "A iniciar…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Seguinte", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Anterior", SUGGESTED_ACTIONS_LABEL_ALT: "Ações sugeridas", TEXT_INPUT_ALT: "Caixa de entrada de mensagens", TEXT_INPUT_PLACEHOLDER: "Escreva a sua mensagem", TEXT_INPUT_SEND_BUTTON_ALT: "Enviar", TEXT_INPUT_SPEAK_BUTTON_ALT: "Falar", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Carregar ficheiro", TOAST_ACCORDION_FEW: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_MANY: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_OTHER: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ACCORDION_TWO: "$1 Notificações: clique aqui para ver os detalhes", TOAST_ALT_ERROR: "Erro", TOAST_ALT_INFO: "Informações", TOAST_ALT_SUCCESS: "Êxito", TOAST_ALT_WARN: "Aviso", TOAST_DISMISS_BUTTON: "Dispensar", TOAST_TITLE_ALT: "Notificação", TRANSCRIPT_ARIA_LABEL_ALT: "Histórico de chat, prima as teclas de seta para navegar.", TRANSCRIPT_ARIA_ROLE_ALT: "histórico de chat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "A mensagem é interativa. Prima Shift + tecla de tabulação 2 a 3 vezes para mudar para o histórico de chat. Em seguida, clique na mensagem para interagir.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "A mensagem contém uma ou mais ligações. Prima Shift + tecla de tabulação 2 a 3 vezes para mudar para o histórico de chat. Em seguida, clique na mensagem para interagir.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "A mensagem tem ações sugeridas. Prima Shift Tabulação 2 a 3 vezes para as selecionar.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "A mensagem tem ações sugeridas. Prima $1 para as selecionar.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Falha ao enviar a mensagem.", TRANSCRIPT_MORE_MESSAGES: "Mais mensagens", TRANSCRIPT_NEW_MESSAGES: "Novas mensagens", TRANSCRIPT_TERMINATOR_TEXT: "Fim do histórico de chat", TYPING_INDICATOR_ALT: "A mostrar o indicador de escrita", TYPING_INDICATOR_SINGLE_TEXT: "$1 está a escrever.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 e outros utilizadores estão a escrever.", VOTE_DISLIKE_ALT: "Não Gostar", VOTE_LIKE_ALT: "Gostar" }, pFe = { _comment: "[CI-LOCKED] Conținutul acestui fișier este blocat. Contribuțiile sunt binevenite, dar validarea schimbării poate fi întârziată.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Robotul $1 a spus:", ACTIVITY_YOU_SAID_ALT: "Ați spus:", ACTIVITY_BOT_ATTACHED_ALT: "Robot atașat:", ACTIVITY_ERROR_BOX_TITLE: "Mesaj de eroare", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Faceți clic pentru a interacționa.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Mesajul este interactiv.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "În mesaj există unul sau mai multe linkuri.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Trimitere nereușită.", ACTIVITY_YOU_ATTACHED_ALT: "Ați atașat:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 atașare.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 atașări.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 atașări.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 de atașări.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 atașări.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Trimiterea nu a reușit. [Reîncercați][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Se trimite", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Trimis la $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Chiar acum", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Acum o oră", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Acum un minut", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Azi", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Ieri", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Eroare de analiză a cardului adaptiv", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Eroare de redare a cardului adaptiv", ATTACHMENT_AUDIO: "Un clip audio.", ATTACHMENT_CARD: "Un card: $1 $2 $3", ATTACHMENT_FILE: "Un fișier: $1", ATTACHMENT_IMAGE: "O imagine", ATTACHMENT_TEXT: "Un text: $1", ATTACHMENT_VIDEO: "Un videoclip", CAROUSEL_FLIPPER_NEXT_ALT: "Înainte", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Înapoi", CITATION_MODEL_DIALOG_ALT: "Mențiune", CONNECTIVITY_STATUS_ALT_CONNECTED: "Conectat", CONNECTIVITY_STATUS_ALT_CONNECTING: "Se conectează…", CONNECTIVITY_STATUS_ALT_FATAL: "Imposibil de conectat.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "A avut loc o întrerupere în rețea. Se reconectează…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Eroare de randare. Verificați consola sau contactați dezvoltatorul robotului.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Conectarea durează mai mult decât de obicei.", CONNECTIVITY_STATUS_ALT: "Stare de conectivitate: $1", FILE_CONTENT_ALT: "„$1”", FILE_CONTENT_DOWNLOADABLE_ALT: "Descărcați fișierul „$1”", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Descărcați fișierul „$1” de dimensiune $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1” de dimensiune $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tasta Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Accesați elementele din mesaj", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Istoric chat", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tasta Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Ieșiți din mesaj", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tasta Tab
Tastele Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Deplasați-vă între elementele dintr-un mesaj", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tasta Săgeată în sus
Tasta Săgeată în jos`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Deplasați-vă între mesaje", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tasta Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Efectuați acțiunea", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tasta Tab
Tastele Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Deplasați-vă între elementele din fereastra de chat", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Fereastră de chat", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Închideți", KEYBOARD_HELP_HEADER: "Comenzi de la tastatură", MARKDOWN_EXTERNAL_LINK_ALT: "Se deschide într-o fereastră nouă; extern.", RECEIPT_CARD_TAX: "Impozit", RECEIPT_CARD_TOTAL: "Total", RECEIPT_CARD_VAT: "TVA", REFERENCE_LIST_HEADER_ONE: "$1 referință", REFERENCE_LIST_HEADER_FEW: "$1 referințe", REFERENCE_LIST_HEADER_MANY: "$1 referințe", REFERENCE_LIST_HEADER_OTHER: "$1 referințe", REFERENCE_LIST_HEADER_TWO: "$1 referințe", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Nu se poate trimite un mesaj gol.", SPEECH_INPUT_LISTENING: "Se ascultă…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Microfon dezactivat", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Microfon activat", SPEECH_INPUT_STARTING: "Începe…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Înainte", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Înapoi", SUGGESTED_ACTIONS_LABEL_ALT: "Acțiuni sugerate", TEXT_INPUT_ALT: "Caseta de introducere a mesajelor", TEXT_INPUT_PLACEHOLDER: "Tastați mesajul", TEXT_INPUT_SEND_BUTTON_ALT: "Trimitere", TEXT_INPUT_SPEAK_BUTTON_ALT: "Vorbire", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Încărcare fișier", TOAST_ACCORDION_FEW: "$1 notificări: Faceți clic aici pentru a vedea detaliile", TOAST_ACCORDION_MANY: "$1 notificări: Faceți clic aici pentru a vedea detaliile", TOAST_ACCORDION_OTHER: "$1 notificări: Faceți clic aici pentru a vedea detaliile", TOAST_ACCORDION_TWO: "$1 notificări: Faceți clic aici pentru a vedea detaliile", TOAST_ALT_ERROR: "Eroare", TOAST_ALT_INFO: "Informații", TOAST_ALT_SUCCESS: "Succes", TOAST_ALT_WARN: "Avertisment", TOAST_DISMISS_BUTTON: "Îndepărtare", TOAST_TITLE_ALT: "Notificare", TRANSCRIPT_ARIA_LABEL_ALT: "Istoric chat, apăsați tastele săgeți pentru a naviga.", TRANSCRIPT_ARIA_ROLE_ALT: "istoric chat", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Mesajul este interactiv. Apăsați tastele Shift și Tab de 2 până la 3 ori, pentru a comuta la istoricul chatului. Apoi faceți clic pe mesaj pentru a interacționa.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "În mesaj există unul sau mai multe linkuri. Apăsați tastele Shift și Tab de 2 până la 3 ori, pentru a comuta la istoricul chatului. Apoi faceți clic pe mesaj pentru a interacționa.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Mesajul are acțiuni sugerate. Apăsați tastele Shift și Tab de 2 până la 3 ori pentru a le selecta.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Mesajul are acțiuni sugerate. Apăsați $1 pentru a le selecta.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Trimiterea mesajului nu a reușit.", TRANSCRIPT_MORE_MESSAGES: "Mai multe mesaje", TRANSCRIPT_NEW_MESSAGES: "Mesaje noi", TRANSCRIPT_TERMINATOR_TEXT: "Sfârșit istoric chat", TYPING_INDICATOR_ALT: "Se afișează indicatorul de tastare", TYPING_INDICATOR_SINGLE_TEXT: "$1 tastează.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 și alții tastează.", VOTE_DISLIKE_ALT: "Nu apreciez", VOTE_LIKE_ALT: "Apreciez" }, hFe = { _comment: "[CI-LOCKED] Содержимое этого файла заблокировано. Вы можете вносить изменения, но их проверка может быть задержана.", ACCESS_KEY_ALT: "ALT SHIFT $1", ACCESS_KEY_FOR_MAC_ALT: "CONTROL OPTION $1", ACTIVITY_BOT_SAID_ALT: "Бот $1 сказал:", ACTIVITY_YOU_SAID_ALT: "Вы сказали:", ACTIVITY_BOT_ATTACHED_ALT: "Прикреплено ботом:", ACTIVITY_ERROR_BOX_TITLE: "Сообщение об ошибке", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Щелкните, чтобы взаимодействовать с сообщением.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Сообщение является интерактивным.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "В сообщении есть одна или несколько ссылок.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Сбой отправки.", ACTIVITY_YOU_ATTACHED_ALT: "Прикреплено вами:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 вложение.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 вложений.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 вложений.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 вложения.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 вложения.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Сбой отправки. [Повторить][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Отправка", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Отправлено в $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Только что", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Час назад", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Минуту назад", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Сегодня", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Вчера", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Ошибка анализа адаптивной карточки", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Ошибка преобразования для просмотра адаптивной карточки", ATTACHMENT_AUDIO: "Аудиоклип.", ATTACHMENT_CARD: "Карточка: $1 $2 $3", ATTACHMENT_FILE: "Файл: $1", ATTACHMENT_IMAGE: "Изображение", ATTACHMENT_TEXT: "Текст: $1", ATTACHMENT_VIDEO: "Видеоклип", CAROUSEL_FLIPPER_NEXT_ALT: "Далее", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Назад", CITATION_MODEL_DIALOG_ALT: "Цитата", CONNECTIVITY_STATUS_ALT_CONNECTED: "Подключено", CONNECTIVITY_STATUS_ALT_CONNECTING: "Подключение…", CONNECTIVITY_STATUS_ALT_FATAL: "Не удается подключиться.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Произошло прерывание соединения с сетью. Выполняется восстановление связи…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Ошибка преобразования для просмотра. Проверьте консоль или обратитесь к разработчику бота.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Для подключения требуется больше времени, чем обычно.", CONNECTIVITY_STATUS_ALT: "Состояние подключения: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Загрузить файл '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Загрузить файл '$1' размера $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' размера $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Клавиша ВВОД", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Доступ к элементами в сообщении", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "История чата", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Клавиша ESC", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Сообщение при выходе", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Клавиша TAB
Клавиши SHIFT + TAB`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Перемещаться между элементами в сообщении", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Стрелка вверх
Стрелка вниз`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Перемещаться между сообщениями", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Клавиша ВВОД", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Выполнить действие", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Клавиша TAB
Клавиши SHIFT + TAB`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Перемещаться между элементами в окне чата", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Окно чата", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Закрыть", KEYBOARD_HELP_HEADER: "Элементы управления клавиатурой", MARKDOWN_EXTERNAL_LINK_ALT: "Открывает в новом окне; внешняя.", RECEIPT_CARD_TAX: "Налог", RECEIPT_CARD_TOTAL: "Итого", RECEIPT_CARD_VAT: "НДС", REFERENCE_LIST_HEADER_ONE: "$1 ссылка", REFERENCE_LIST_HEADER_FEW: "$1 ссылок", REFERENCE_LIST_HEADER_MANY: "$1 ссылок", REFERENCE_LIST_HEADER_OTHER: "$1 ссылки", REFERENCE_LIST_HEADER_TWO: "$1 ссылки", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Невозможно отправить пустое сообщение.", SPEECH_INPUT_LISTENING: "Слушаю…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Микрофон выкл.", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Микрофон вкл.", SPEECH_INPUT_STARTING: "Начало…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Далее", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Назад", SUGGESTED_ACTIONS_LABEL_ALT: "Предлагаемые действия", TEXT_INPUT_ALT: "Поле ввода сообщения", TEXT_INPUT_PLACEHOLDER: "Введите сообщение", TEXT_INPUT_SEND_BUTTON_ALT: "Отправить", TEXT_INPUT_SPEAK_BUTTON_ALT: "Говорить", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Отправить файл", TOAST_ACCORDION_FEW: "Уведомлений: $1. Щелкните здесь для просмотра сведений", TOAST_ACCORDION_MANY: "Уведомлений: $1. Щелкните здесь для просмотра сведений", TOAST_ACCORDION_OTHER: "Уведомлений: $1. Щелкните здесь для просмотра сведений", TOAST_ACCORDION_TWO: "Уведомлений: $1. Щелкните здесь для просмотра сведений", TOAST_ALT_ERROR: "Ошибка", TOAST_ALT_INFO: "Сведения", TOAST_ALT_SUCCESS: "Успешно завершено", TOAST_ALT_WARN: "Предупреждение", TOAST_DISMISS_BUTTON: "Закрыть", TOAST_TITLE_ALT: "Уведомление", TRANSCRIPT_ARIA_LABEL_ALT: "История чата, используйте клавиши со стрелками для перемещения.", TRANSCRIPT_ARIA_ROLE_ALT: "история чата", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Сообщение интерактивно. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "В сообщении есть одна или несколько ссылок. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Для сообщения есть предлагаемые действия. Нажмите SHIFT TAB 2 или 3 раза, чтобы выбрать нужное.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Для сообщения есть предлагаемые действия. Нажмите $1, чтобы выбрать нужное.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Не удалось отправить сообщение.", TRANSCRIPT_MORE_MESSAGES: "Другие сообщения", TRANSCRIPT_NEW_MESSAGES: "Новые сообщения", TRANSCRIPT_TERMINATOR_TEXT: "Конец истории чата", TYPING_INDICATOR_ALT: "Отображение индикатора ввода", TYPING_INDICATOR_SINGLE_TEXT: "$1 вводит текст.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 и другие вводят текст.", VOTE_DISLIKE_ALT: "Не нравится", VOTE_LIKE_ALT: "Нравится" }, vFe = { _comment: "[CI-LOCKED] Obsah tohto súboru je zamknutý. Príspevky sú vítané, ale overenie zmien sa môže oneskoriť.", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "Control + Option + $1", ACTIVITY_BOT_SAID_ALT: "Robot $1 povedal:", ACTIVITY_YOU_SAID_ALT: "Povedali ste:", ACTIVITY_BOT_ATTACHED_ALT: "Robot priložil:", ACTIVITY_ERROR_BOX_TITLE: "Chybové hlásenie", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknutím môžete vykonať interakciu.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Správa je interaktívna.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Najmenej jedno prepojenie v správe.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Odoslanie zlyhalo.", ACTIVITY_YOU_ATTACHED_ALT: "Priložili ste:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 príloha.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 prílohy.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 prílohy.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 príloh.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 prílohy.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Odoslanie zlyhalo. [Skúsiť znova][RETRY]", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Odosiela sa", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Odoslané o $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Práve teraz", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Pred hodinou", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Pred minútou", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Dnes", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Včera", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Chyba analýzy adaptívnej karty", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Chyba vykreslenia adaptívnej karty", ATTACHMENT_AUDIO: "Zvukový klip.", ATTACHMENT_CARD: "Karta: $1 $2 $3", ATTACHMENT_FILE: "Súbor: $1", ATTACHMENT_IMAGE: "Obrázok", ATTACHMENT_TEXT: "Text: $1", ATTACHMENT_VIDEO: "Videoklip", CAROUSEL_FLIPPER_NEXT_ALT: "Nasledujúce", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Predchádzajúce", CITATION_MODEL_DIALOG_ALT: "Citácia", CONNECTIVITY_STATUS_ALT_CONNECTED: "Pripojené", CONNECTIVITY_STATUS_ALT_CONNECTING: "Pripája sa...", CONNECTIVITY_STATUS_ALT_FATAL: "Pripojenie sa nepodarilo.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Vyskytlo sa prerušenie siete. Prebieha opätovné pripájanie...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Chyba vykreslenia. Skontrolujte konzolu alebo sa obráťte na vývojára bota.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Pripojenie trvá dlhšie ako zvyčajne.", CONNECTIVITY_STATUS_ALT: "Stav pripojenia: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Stiahnuť súbor $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Stiahnuť súbor $1 s veľkosťou $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 s veľkosťou $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Kláves Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Získajte prístup k položkám v správe", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "História konverzácie", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Kláves Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Ukončiť zobrazenie správy", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Kláves Tab
Klávesy Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Prechádzajte medzi položkami v správe", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Kláves so šípkou nahor
Kláves so šípkou nadol`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Prechádzajte medzi správami", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Kláves Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Vykonajte akciu", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Kláves Tab
Klávesy Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Prechádzajte medzi položkami v okne konverzácie", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Okno konverzácie", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zavrieť", KEYBOARD_HELP_HEADER: "Ovládacie prvky klávesnice", MARKDOWN_EXTERNAL_LINK_ALT: "Otvorí sa v novom okne, externé.", RECEIPT_CARD_TAX: "Daň", RECEIPT_CARD_TOTAL: "Celkový počet", RECEIPT_CARD_VAT: "DPH", REFERENCE_LIST_HEADER_ONE: "$1 odkaz", REFERENCE_LIST_HEADER_FEW: "Počet odkazov: $1", REFERENCE_LIST_HEADER_MANY: "Počet odkazov: $1", REFERENCE_LIST_HEADER_OTHER: "Počet odkazov: $1", REFERENCE_LIST_HEADER_TWO: "Počet odkazov: $1", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Prázdnu správu nemožno odoslať.", SPEECH_INPUT_LISTENING: "Počúvanie...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Vypnúť mikrofón", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Zapnúť mikrofón", SPEECH_INPUT_STARTING: "Spúšťa sa...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Nasledujúce", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Predchádzajúce", SUGGESTED_ACTIONS_LABEL_ALT: "Navrhované akcie", TEXT_INPUT_ALT: "Vstupné pole pre správu", TEXT_INPUT_PLACEHOLDER: "Zadajte svoju správu", TEXT_INPUT_SEND_BUTTON_ALT: "Odoslať", TEXT_INPUT_SPEAK_BUTTON_ALT: "Čítať", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Nahrať súbor", TOAST_ACCORDION_FEW: "Počet oznámení: $1 – kliknutím sem sa zobrazia podrobnosti", TOAST_ACCORDION_MANY: "Počet oznámení: $1 – kliknutím sem sa zobrazia podrobnosti", TOAST_ACCORDION_OTHER: "Počet oznámení: $1 – kliknutím sem sa zobrazia podrobnosti", TOAST_ACCORDION_TWO: "Počet oznámení: $1 – kliknutím sem sa zobrazia podrobnosti", TOAST_ALT_ERROR: "Chyba", TOAST_ALT_INFO: "Informácie", TOAST_ALT_SUCCESS: "Úspešné", TOAST_ALT_WARN: "Upozornenie", TOAST_DISMISS_BUTTON: "Zrušiť", TOAST_TITLE_ALT: "Oznámenie", TRANSCRIPT_ARIA_LABEL_ALT: "História konverzácie – na navigáciu stlačte klávesy so šípkami.", TRANSCRIPT_ARIA_ROLE_ALT: "história konverzácie", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Správa je interaktívna. Stlačením klávesov Shift a Tab 2- až 3-krát prepnete do histórie konverzácie. Potom môžete interagovať kliknutím na správu.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Najmenej jedno prepojenie v správe. Stlačením klávesov Shift a Tab 2- až 3-krát prepnete do histórie konverzácie. Potom môžete interagovať kliknutím na správu.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Správa obsahuje navrhované akcie. Vyberte ich stlačením klávesov Shift + Tab 2 až 3-krát.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Správa obsahuje navrhované akcie. Vyberte ich stlačením klávesu $1.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Nepodarilo sa odoslať správu.", TRANSCRIPT_MORE_MESSAGES: "Ďalšie správy", TRANSCRIPT_NEW_MESSAGES: "Nové správy", TRANSCRIPT_TERMINATOR_TEXT: "Koniec histórie konverzácie", TYPING_INDICATOR_ALT: "Zobrazuje sa indikátor písania", TYPING_INDICATOR_SINGLE_TEXT: "$1 píše.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 a ďalší píšu.", VOTE_DISLIKE_ALT: "Nepáči sa mi to", VOTE_LIKE_ALT: "Páči sa mi to" }, EFe = { _comment: "[CI-LOCKED] Vsebina te datoteke je zaklenjena. Prispevki so dobrodošli, vendar je preverjanje sprememb lahko zakasnjeno.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 je rekel:", ACTIVITY_YOU_SAID_ALT: "Rekli ste:", ACTIVITY_BOT_ATTACHED_ALT: "Bot je priložil:", ACTIVITY_ERROR_BOX_TITLE: "Sporočilo o napaki", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknite za interakcijo.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Sporočilo je interaktivno.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "V sporočilu je ena ali več povezav.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Pošiljanje ni uspelo.", ACTIVITY_YOU_ATTACHED_ALT: "Priložili ste:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 priloga.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 priloge.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 prilog.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 prilog.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 prilogi.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Pošiljanje ni uspelo. [Vnovični poskus][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Pošiljanje", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Poslano: $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Zdaj", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Pred uro", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Pred minuto", ACTIVITY_STATUS_TIMESTAMP_TODAY: "danes", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "včeraj", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Napaka pri razčlenjevanju prilagodljive kartice", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Napaka pri upodabljanju prilagodljive kartice", ATTACHMENT_AUDIO: "Zvočni posnetek.", ATTACHMENT_CARD: "Kartica: $1 $2 $3", ATTACHMENT_FILE: "Datoteka: $1", ATTACHMENT_IMAGE: "Slika", ATTACHMENT_TEXT: "Besedilo: $1", ATTACHMENT_VIDEO: "Videoposnetek", CAROUSEL_FLIPPER_NEXT_ALT: "Naprej", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Nazaj", CITATION_MODEL_DIALOG_ALT: "Citat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Povezava je vzpostavljena.", CONNECTIVITY_STATUS_ALT_CONNECTING: "Povezovanje …", CONNECTIVITY_STATUS_ALT_FATAL: "Povezave ni mogoče vzpostaviti.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Prišlo je do omrežne prekinitve. Vnovično povezovanje …", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Napaka pri upodabljanju. Preverite konzolo ali se obrnite na razvijalca bota.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Povezovanje traja dlje kot običajno.", CONNECTIVITY_STATUS_ALT: "Stanje povezave: $1", FILE_CONTENT_ALT: "»$1«", FILE_CONTENT_DOWNLOADABLE_ALT: "Prenesi datoteko »$1«", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Prenos datoteke »$1« velikosti $2", FILE_CONTENT_WITH_SIZE_ALT: "»$1« velikosti $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Tipka Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Dostop do elementov v sporočilu", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Zgodovina klepeta", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Tipka Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Izhod iz sporočila", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatorka
Shift + tabulatorka`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Premikanje med elementi v sporočilu", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Tipka s puščico gor
Tipka s puščico dol`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Premikanje med sporočili", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Tipka Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Izvedba dejanja", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabulatorka
Shift + tabulatorka`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Pomikanje med elementi v oknu za klepet", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Okno za klepet", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zapri", KEYBOARD_HELP_HEADER: "Kontrolniki na tipkovnici", MARKDOWN_EXTERNAL_LINK_ALT: "Odpre se v novem oknu; zunanje.", RECEIPT_CARD_TAX: "Davek", RECEIPT_CARD_TOTAL: "Skupaj", RECEIPT_CARD_VAT: "DDV", REFERENCE_LIST_HEADER_ONE: "$1 sklic", REFERENCE_LIST_HEADER_FEW: "$1 sklici", REFERENCE_LIST_HEADER_MANY: "$1 sklicev", REFERENCE_LIST_HEADER_OTHER: "$1 sklicev", REFERENCE_LIST_HEADER_TWO: "$1 sklica", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Praznega sporočila ni mogoče poslati.", SPEECH_INPUT_LISTENING: "Poslušanje …", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon je izklopljen", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon je vklopljen", SPEECH_INPUT_STARTING: "Začetek …", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Naprej", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Nazaj", SUGGESTED_ACTIONS_LABEL_ALT: "Predlagana dejanja", TEXT_INPUT_ALT: "Polje za vnos sporočila", TEXT_INPUT_PLACEHOLDER: "Vnesite sporočilo", TEXT_INPUT_SEND_BUTTON_ALT: "Pošlji", TEXT_INPUT_SPEAK_BUTTON_ALT: "Govor", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Naloži datoteko", TOAST_ACCORDION_FEW: "Obvestila: $1 – za podrobnosti kliknite tukaj", TOAST_ACCORDION_MANY: "Obvestila: $1 – za podrobnosti kliknite tukaj", TOAST_ACCORDION_OTHER: "Obvestila: $1 – za podrobnosti kliknite tukaj", TOAST_ACCORDION_TWO: "Obvestila: $1 – za podrobnosti kliknite tukaj", TOAST_ALT_ERROR: "Napaka", TOAST_ALT_INFO: "Informacije", TOAST_ALT_SUCCESS: "Uspelo je", TOAST_ALT_WARN: "Opozorilo", TOAST_DISMISS_BUTTON: "Opusti", TOAST_TITLE_ALT: "Obvestilo", TRANSCRIPT_ARIA_LABEL_ALT: "Zgodovina klepeta – za pomikanje pritisnite tipke s puščico.", TRANSCRIPT_ARIA_ROLE_ALT: "zgodovina klepeta", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Sporočilo je interaktivno. Dvakrat ali trikrat pritisnite tipko shift in tabulatorko, da preklopite na zgodovino klepeta. Nato kliknite sporočilo za interakcijo z njim.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "V sporočilu je ena ali več povezav. Dvakrat ali trikrat pritisnite tipko shift in tabulatorko, da preklopite na zgodovino klepeta. Nato kliknite sporočilo za interakcijo z njim.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Sporočilo ima predlagana dejanja. 2- do 3-krat pritisnite dvigalko in tabulatorko, da jih izberete.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Sporočilo ima predlagana dejanja. Pritisnite $1, da jih izberete.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Sporočila ni bilo mogoče poslati.", TRANSCRIPT_MORE_MESSAGES: "Več sporočil", TRANSCRIPT_NEW_MESSAGES: "Nova sporočila", TRANSCRIPT_TERMINATOR_TEXT: "Konec zgodovine klepeta", TYPING_INDICATOR_ALT: "Prikaz indikatorja tipkanja", TYPING_INDICATOR_SINGLE_TEXT: "$1 tipka.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 in drugi tipkajo.", VOTE_DISLIKE_ALT: "Ni mi všeč", VOTE_LIKE_ALT: "Všeč mi je" }, mFe = { _comment: "[CI-LOCKED] Садржај ове датотеке је закључан. Доприноси су добродошли, али потврда промене може бити одложена.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Робот $1 је рекао:", ACTIVITY_YOU_SAID_ALT: "Ви сте рекли:", ACTIVITY_BOT_ATTACHED_ALT: "Робот је приложио:", ACTIVITY_ERROR_BOX_TITLE: "Порука о грешци", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Кликните за интеракцију.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Поруке су неактивне.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Порука садржи везе.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Слање није успело.", ACTIVITY_YOU_ATTACHED_ALT: "Приложили сте:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 прилог.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 прилога.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 прилога.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 прилога.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 прилога.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Слање није успело. [Поново покушај] [RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Слање", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Послато у $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Малопре", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Пре сат времена", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Пре једног минута", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Данас", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Јуче", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Грешка у рашчлањивању прилагодљиве картице", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Грешка у приказивању прилагодљиве картице", ATTACHMENT_AUDIO: "Аудио клип.", ATTACHMENT_CARD: "Картица: $1 $2 $3", ATTACHMENT_FILE: "Датотека: $1", ATTACHMENT_IMAGE: "Слика", ATTACHMENT_TEXT: "Текст: $1", ATTACHMENT_VIDEO: "Видео клип", CAROUSEL_FLIPPER_NEXT_ALT: "Даље", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Претходно", CITATION_MODEL_DIALOG_ALT: "Цитат", CONNECTIVITY_STATUS_ALT_CONNECTED: "Повезано", CONNECTIVITY_STATUS_ALT_CONNECTING: "Повезивање…", CONNECTIVITY_STATUS_ALT_FATAL: "Повезивање није могуће.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Дошло је до прекида мреже. Поновно повезивање…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Грешка у приказивању. Проверите конзолу или се обратите програмеру робота.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Повезивање траје дуже него иначе.", CONNECTIVITY_STATUS_ALT: "Статус повезивања: $1", FILE_CONTENT_ALT: "„$1“", FILE_CONTENT_DOWNLOADABLE_ALT: "Преузимање датотеке „$1“", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Преузмите датотеку „$1“ величине $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1“ величине $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Тастер Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Приступ ставкама у поруци", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Историја ћаскања", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Тастер Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Порука на излазу", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Тастер Tab
Shift + тастер Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Прелазак са једне ставке на другу у поруци", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Тастер са стрелицом нагоре
Тастер са стрелицом надоле`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Прелазак са једне поруке на другу", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Тастер Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Обављање радње", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Тастер Tab
Shift + тастер Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Прелазак са једне ставке на другу у прозору за ћаскање", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Прозор за ћаскање", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Затвори", KEYBOARD_HELP_HEADER: "Тастерске контроле", MARKDOWN_EXTERNAL_LINK_ALT: "Отвара се у новом прозору; спољно.", RECEIPT_CARD_TAX: "Порез", RECEIPT_CARD_TOTAL: "Укупно", RECEIPT_CARD_VAT: "ПДВ", REFERENCE_LIST_HEADER_ONE: "$1 референца", REFERENCE_LIST_HEADER_FEW: "$1 референци", REFERENCE_LIST_HEADER_MANY: "$1 референци", REFERENCE_LIST_HEADER_OTHER: "$1 референци", REFERENCE_LIST_HEADER_TWO: "$1 референце", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Није могуће послати празну поруку.", SPEECH_INPUT_LISTENING: "Слушамо...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Микрофон је искључен", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Микрофон је укључен", SPEECH_INPUT_STARTING: "Почиње…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Даље", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Претходно", SUGGESTED_ACTIONS_LABEL_ALT: "Предложене радње", TEXT_INPUT_ALT: "Поље за унос поруке", TEXT_INPUT_PLACEHOLDER: "Откуцајте поруку", TEXT_INPUT_SEND_BUTTON_ALT: "Пошаљи", TEXT_INPUT_SPEAK_BUTTON_ALT: "Изговорите", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Отпреми датотеку", TOAST_ACCORDION_FEW: "$1 обавештења: Кликните овде да бисте видели детаље", TOAST_ACCORDION_MANY: "$1 обавештења: Кликните овде да бисте видели детаље", TOAST_ACCORDION_OTHER: "$1 обавештења: Кликните овде да бисте видели детаље", TOAST_ACCORDION_TWO: "$1 обавештења: Кликните овде да бисте видели детаље", TOAST_ALT_ERROR: "Грешка", TOAST_ALT_INFO: "Информације", TOAST_ALT_SUCCESS: "Успешно", TOAST_ALT_WARN: "Упозорење", TOAST_DISMISS_BUTTON: "Одбаци", TOAST_TITLE_ALT: "Обавештење", TRANSCRIPT_ARIA_LABEL_ALT: "Историја ћаскања, користите тастере са стрелицом да бисте се кретали.", TRANSCRIPT_ARIA_ROLE_ALT: "историја ћаскања", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Порука је интерактивна. Притисните тастере Shift и Тab 2 до 3 пута да бисте се пребацили на историју ћаскања. Затим кликните на поруку да бисте остварили интеракцију.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Порука садржи везе. Притисните тастере Shift и Тab 2 до 3 пута да бисте се пребацили на историју ћаскања. Затим кликните на поруку да бисте остварили интеракцију.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Порука има предложене радње. Притисните тастере shift tab 2 до 3 пута како бисте их изабрали.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Порука има предложене радње. Притисните $1 како бисте их изабрали.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Слање поруке није успело.", TRANSCRIPT_MORE_MESSAGES: "Још порука", TRANSCRIPT_NEW_MESSAGES: "Нове поруке", TRANSCRIPT_TERMINATOR_TEXT: "Крај историје ћаскања", TYPING_INDICATOR_ALT: "Приказује се индикатор куцања", TYPING_INDICATOR_SINGLE_TEXT: "$1 куца.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 и други куцају.", VOTE_DISLIKE_ALT: "Не свиђа ми се", VOTE_LIKE_ALT: "Свиђа ми се" }, gFe = { _comment: "[CI-LOCKED] Sadržaj ove datoteke je zaključan. Doprinosi su dobrodošli, ali potvrda promene može biti odložena.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Robot $1 je rekao:", ACTIVITY_YOU_SAID_ALT: "Vi ste rekli:", ACTIVITY_BOT_ATTACHED_ALT: "Robot je priložio:", ACTIVITY_ERROR_BOX_TITLE: "Poruka o grešci", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Kliknite za interakciju.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Poruka je interaktivna.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Poruka sadrži jednu vez ili više njih.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Slanje nije uspelo.", ACTIVITY_YOU_ATTACHED_ALT: "Priložili ste:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 prilog.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 priloga.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 priloga.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 priloga.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 priloga.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Slanje nije uspelo. [Ponovo pokušaj] [RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Slanje", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Poslato u $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Malopre", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Pre sat vremena", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Pre jednog minuta", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Danas", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Juče", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Greška u raščlanjivanju prilagodljive kartice", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Greška u prikazivanju prilagodljive kartice", ATTACHMENT_AUDIO: "Audio klip.", ATTACHMENT_CARD: "Kartica: $1 $2 $3", ATTACHMENT_FILE: "Datoteka: $1", ATTACHMENT_IMAGE: "Slika", ATTACHMENT_TEXT: "Tekst: $1", ATTACHMENT_VIDEO: "Video klip", CAROUSEL_FLIPPER_NEXT_ALT: "Dalje", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Prethodno", CITATION_MODEL_DIALOG_ALT: "Citat", CONNECTIVITY_STATUS_ALT_CONNECTED: "Povezano", CONNECTIVITY_STATUS_ALT_CONNECTING: "Povezivanje…", CONNECTIVITY_STATUS_ALT_FATAL: "Povezivanje nije moguće.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Došlo je do prekida mreže. Ponovno povezivanje…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Greška u prikazivanju. Proverite konzolu ili se obratite programeru robota.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Povezivanje traje duže nego inače.", CONNECTIVITY_STATUS_ALT: "Status povezivanja: $1", FILE_CONTENT_ALT: "„$1“", FILE_CONTENT_DOWNLOADABLE_ALT: "Preuzimanje datoteke „$1“", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Preuzmite datoteku „$1“ veličine $2", FILE_CONTENT_WITH_SIZE_ALT: "„$1“ veličine $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Taster Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Pristup stavkama u poruci", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Istorija ćaskanja", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Taster Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Zatvori poruku", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Taster Tab
Shift + taster Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Prelazak sa jedne stavke na drugu u poruci", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Taster sa strelicom nagore
Taster sa strelicom nadole`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Prelazak sa jedne poruke na drugu", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Taster Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Obavljanje radnje", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Taster Tab
Shift + taster Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Prelazak sa jedne stavke na drugu u prozoru za ćaskanje", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Prozor za ćaskanje", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Zatvori", KEYBOARD_HELP_HEADER: "Tasterske kontrole", MARKDOWN_EXTERNAL_LINK_ALT: "Otvara se u novom prozoru; spoljno.", RECEIPT_CARD_TAX: "Porez", RECEIPT_CARD_TOTAL: "Ukupno", RECEIPT_CARD_VAT: "PDV", REFERENCE_LIST_HEADER_ONE: "$1 referenca", REFERENCE_LIST_HEADER_FEW: "$1 referenci", REFERENCE_LIST_HEADER_MANY: "$1 referenci", REFERENCE_LIST_HEADER_OTHER: "$1 referenci", REFERENCE_LIST_HEADER_TWO: "$1 reference", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Nije moguće poslati praznu poruku.", SPEECH_INPUT_LISTENING: "Slušamo…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon je isključen", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon je uključen", SPEECH_INPUT_STARTING: "Počinje…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Dalje", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Prethodno", SUGGESTED_ACTIONS_LABEL_ALT: "Predložene radnje", TEXT_INPUT_ALT: "Polje za unos poruke", TEXT_INPUT_PLACEHOLDER: "Otkucajte poruku", TEXT_INPUT_SEND_BUTTON_ALT: "Pošalji", TEXT_INPUT_SPEAK_BUTTON_ALT: "Izgovorite", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Otpremi datoteku", TOAST_ACCORDION_FEW: "$1 obaveštenja: Kliknite ovde da biste videli detalje", TOAST_ACCORDION_MANY: "$1 obaveštenja: Kliknite ovde da biste videli detalje", TOAST_ACCORDION_OTHER: "$1 obaveštenja: Kliknite ovde da biste videli detalje", TOAST_ACCORDION_TWO: "$1 obaveštenja: Kliknite ovde da biste videli detalje", TOAST_ALT_ERROR: "Greška", TOAST_ALT_INFO: "Informacije", TOAST_ALT_SUCCESS: "Uspešno", TOAST_ALT_WARN: "Upozorenje", TOAST_DISMISS_BUTTON: "Odbaci", TOAST_TITLE_ALT: "Obaveštenje", TRANSCRIPT_ARIA_LABEL_ALT: "Istorija ćaskanja, koristite tastere sa strelicom da biste se kretali.", TRANSCRIPT_ARIA_ROLE_ALT: "istorija ćaskanja", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Poruka je interaktivna. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Poruka sadrži veze. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Poruka ima predložene radnje. Pritisnite tastere shift tab 2 do 3 puta kako biste ih izabrali.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Poruka ima predložene radnje. Pritisnite $1 kako biste ih izabrali.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Slanje poruke nije uspelo.", TRANSCRIPT_MORE_MESSAGES: "Još poruka", TRANSCRIPT_NEW_MESSAGES: "Nove poruke", TRANSCRIPT_TERMINATOR_TEXT: "Kraj istorije ćaskanja", TYPING_INDICATOR_ALT: "Prikazuje se indikator kucanja", TYPING_INDICATOR_SINGLE_TEXT: "$1 kuca.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 i drugi kucaju.", VOTE_DISLIKE_ALT: "Ne sviđa mi se", VOTE_LIKE_ALT: "Sviđa mi se" }, TFe = { _comment: "[CI-LOCKED] Innehållet i den här filen är låst. Bidrag välkomnas men verifieringen av ändrar kan fördröjas.", ACCESS_KEY_ALT: "Alt Skift $1", ACCESS_KEY_FOR_MAC_ALT: "Ctrl Alt $1", ACTIVITY_BOT_SAID_ALT: "Roboten $1 sade:", ACTIVITY_YOU_SAID_ALT: "Du sade:", ACTIVITY_BOT_ATTACHED_ALT: "Robot bifogad:", ACTIVITY_ERROR_BOX_TITLE: "Felmeddelande", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Klicka för att interagera.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Meddelandet är interaktivt.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Det finns en eller flera länkar i meddelandet.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Det gick inte att skicka.", ACTIVITY_YOU_ATTACHED_ALT: "Du bifogade:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "En bilaga.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1-bilagor.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1-bilagor.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1-bilagor.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1-bilagor.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Det gick inte att skicka. [Försök igen med][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Skickar", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Skickades klockan $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Just nu", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "En timme sedan", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "En minut sedan", ACTIVITY_STATUS_TIMESTAMP_TODAY: "I dag", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "I går", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Fel vid parsning av adaptivt kort", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Fel vid återgivning av adaptivt kort", ATTACHMENT_AUDIO: "Ett ljudklipp.", ATTACHMENT_CARD: "Ett kort: $1 $2 $3", ATTACHMENT_FILE: "En fil: $1", ATTACHMENT_IMAGE: "En bild", ATTACHMENT_TEXT: "En text: $1", ATTACHMENT_VIDEO: "Ett videoklipp", CAROUSEL_FLIPPER_NEXT_ALT: "Nästa", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Föregående", CITATION_MODEL_DIALOG_ALT: "Hänvisning", CONNECTIVITY_STATUS_ALT_CONNECTED: "Ansluten", CONNECTIVITY_STATUS_ALT_CONNECTING: "Ansluter ...", CONNECTIVITY_STATUS_ALT_FATAL: "Det gick inte att ansluta.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Ett nätverksavbrott inträffade. Ansluter igen ...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Återge fel. Kontrollera konsolen eller kontakta robotutvecklaren.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Det tar längre tid än vanligt att ansluta.", CONNECTIVITY_STATUS_ALT: "Anslutningsstatus: $1", FILE_CONTENT_ALT: "$1", FILE_CONTENT_DOWNLOADABLE_ALT: "Hämta filen $1", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Ladda ned filen $1 med storleken $2", FILE_CONTENT_WITH_SIZE_ALT: "$1 med storleken $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Returtangent", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Få åtkomst till objekt i meddelandet", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Chatthistorik", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Esc-tangent", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Lämna meddelandet", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tabbtangent
Skift + tabbtangent`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Flytta mellan objekt i ett meddelande", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Uppåtpil
Nedåtpil`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Flytta mellan meddelanden", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Returtangent", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Utför åtgärd", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tabbtangent
Skift + tabbtangent`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Flytta mellan objekt i chattfönstret", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Chattfönster", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Stäng", KEYBOARD_HELP_HEADER: "Tangentbordskontroller", MARKDOWN_EXTERNAL_LINK_ALT: "Öppnas i ett nytt fönster; externt.", RECEIPT_CARD_TAX: "Skatt", RECEIPT_CARD_TOTAL: "Summa", RECEIPT_CARD_VAT: "Moms", REFERENCE_LIST_HEADER_ONE: "$1 referens", REFERENCE_LIST_HEADER_FEW: "$1 referenser", REFERENCE_LIST_HEADER_MANY: "$1 referenser", REFERENCE_LIST_HEADER_OTHER: "$1 referenser", REFERENCE_LIST_HEADER_TWO: "$1 referenser", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Det går inte att skicka ett tomt meddelande.", SPEECH_INPUT_LISTENING: "Lyssnar ...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon av", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon på", SPEECH_INPUT_STARTING: "Startar ...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Nästa", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Föregående", SUGGESTED_ACTIONS_LABEL_ALT: "Föreslagna åtgärder", TEXT_INPUT_ALT: "Inmatningsruta för meddelande", TEXT_INPUT_PLACEHOLDER: "Skriv ditt meddelande", TEXT_INPUT_SEND_BUTTON_ALT: "Skicka", TEXT_INPUT_SPEAK_BUTTON_ALT: "Läs upp", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Ladda upp fil", TOAST_ACCORDION_FEW: "$1 aviseringar: Klicka här för att visa mer information.", TOAST_ACCORDION_MANY: "$1 aviseringar: Klicka här för att visa mer information.", TOAST_ACCORDION_OTHER: "$1 aviseringar: Klicka här för att visa mer information.", TOAST_ACCORDION_TWO: "$1 aviseringar: Klicka här för att visa mer information.", TOAST_ALT_ERROR: "Fel", TOAST_ALT_INFO: "Information", TOAST_ALT_SUCCESS: "Lyckades", TOAST_ALT_WARN: "Varning", TOAST_DISMISS_BUTTON: "Stäng", TOAST_TITLE_ALT: "Avisering", TRANSCRIPT_ARIA_LABEL_ALT: "Chatthistorik, tryck på piltangenterna för att navigera.", TRANSCRIPT_ARIA_ROLE_ALT: "chatthistorik", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Meddelandet är interaktivt. Tryck på Skift+Tabbtangenten 2 till 3 gånger för att växla till chatthistoriken. Klicka sedan på meddelandet för att interagera.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Det finns en eller flera länkar i meddelandet. Tryck på Skift+Tabbtangenten 2 till 3 gånger för att växla till chatthistoriken. Klicka sedan på meddelandet för att interagera.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Meddelandet har föreslagit åtgärder. Tryck på Skift Tabb 2 till 3 gånger för att välja dem.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Meddelandet har föreslagit åtgärder. Tryck på $1 för att välja dem.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Det gick inte att skicka meddelandet.", TRANSCRIPT_MORE_MESSAGES: "Fler meddelanden", TRANSCRIPT_NEW_MESSAGES: "Nya meddelanden", TRANSCRIPT_TERMINATOR_TEXT: "Slut på chatthistorik", TYPING_INDICATOR_ALT: "Visar skrivindikatorn", TYPING_INDICATOR_SINGLE_TEXT: "$1 skriver.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 och andra skriver.", VOTE_DISLIKE_ALT: "Ogilla", VOTE_LIKE_ALT: "Gilla" }, yFe = { _comment: "[CI-LOCKED] เนื้อหาของไฟล์นี้ถูกล็อก ยินดีรับการสนับสนุน แต่การตรวจสอบความถูกต้องของการเปลี่ยนแปลงอาจล่าช้า", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "บอท $1 กล่าวว่า:", ACTIVITY_YOU_SAID_ALT: "คุณพูดว่า:", ACTIVITY_BOT_ATTACHED_ALT: "บอทแนบ:", ACTIVITY_ERROR_BOX_TITLE: "ข้อความแสดงข้อผิดพลาด", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "คลิกเพื่อโต้ตอบ", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "ข้อความเป็นแบบโต้ตอบ", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "การส่งไม่สำเร็จ", ACTIVITY_YOU_ATTACHED_ALT: "คุณแนบ:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "สิ่งที่แนบ 1 รายการ", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "สิ่งที่แนบ $1 รายการ", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "สิ่งที่แนบ $1 รายการ", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "สิ่งที่แนบ $1 รายการ", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "สิ่งที่แนบ $1 รายการ", ACTIVITY_STATUS_SEND_FAILED_RETRY: "ส่งไม่สำเร็จ [ลองใหม่][RETRY]", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "กำลังส่ง", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "ส่งเมื่อ $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "ตอนนี้", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "ชั่วโมงที่แล้ว", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "นาทีที่แล้ว", ACTIVITY_STATUS_TIMESTAMP_TODAY: "วันนี้", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "เมื่อวานนี้", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "ข้อผิดพลาดในการแยกวิเคราะห์ Adaptive Card", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "ข้อผิดพลาดในการแสดงผล Adaptive Card", ATTACHMENT_AUDIO: "คลิปเสียง", ATTACHMENT_CARD: "การ์ด: $1 $2 $3", ATTACHMENT_FILE: "ไฟล์: $1", ATTACHMENT_IMAGE: "รูปภาพ", ATTACHMENT_TEXT: "ข้อความ: $1", ATTACHMENT_VIDEO: "คลิปวิดีโอ", CAROUSEL_FLIPPER_NEXT_ALT: "ถัดไป", CAROUSEL_FLIPPER_PREVIOUS_ALT: "ก่อนหน้า", CITATION_MODEL_DIALOG_ALT: "การอ้างอิงถึงแหล่งที่มา", CONNECTIVITY_STATUS_ALT_CONNECTED: "เชื่อมต่อแล้ว", CONNECTIVITY_STATUS_ALT_CONNECTING: "กำลังเชื่อมต่อ...", CONNECTIVITY_STATUS_ALT_FATAL: "ไม่สามารถเชื่อมต่อได้", CONNECTIVITY_STATUS_ALT_RECONNECTING: "เครือข่ายขัดข้อง กำลังเชื่อมต่อใหม่...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "แสดงข้อผิดพลาด โปรดตรวจสอบคอนโซลหรือติดต่อนักพัฒนาบอท", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "ใช้เวลาเชื่อมต่อนานกว่าปกติ", CONNECTIVITY_STATUS_ALT: "สถานะของการเชื่อมต่อ: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "ดาวน์โหลดไฟล์ '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "ดาวน์โหลดไฟล์ '$1' ขนาด $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' ขนาด $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "แป้น Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "เข้าถึงรายการในข้อความ", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "ประวัติการแชท", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "แป้น Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "ออกจากข้อความ", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `แป้น Tab
แป้น Shift + Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "เลื่อนไปมาระหว่างรายการในข้อความ", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `แป้นลูกศรขึ้น
แป้นลูกศรลง`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "เลื่อนไปมาระหว่างข้อความ", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "แป้น Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "ทำการดำเนินการ", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `แป้น Tab
แป้น Shift + Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "เลื่อนไปมาระหว่างรายการในหน้าต่างแชท", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "หน้าต่างแชท", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "ปิด", KEYBOARD_HELP_HEADER: "ตัวควบคุมบนแป้นพิมพ์", MARKDOWN_EXTERNAL_LINK_ALT: "เปิดในหน้าต่างใหม่; ภายนอก", RECEIPT_CARD_TAX: "ภาษี", RECEIPT_CARD_TOTAL: "ยอดรวม", RECEIPT_CARD_VAT: "ภาษีมูลค่าเพิ่ม", REFERENCE_LIST_HEADER_ONE: "การอ้างอิง $1 รายการ", REFERENCE_LIST_HEADER_FEW: "การอ้างอิง $1 รายการ", REFERENCE_LIST_HEADER_MANY: "การอ้างอิง$1รายการ", REFERENCE_LIST_HEADER_OTHER: "การอ้างอิง$1", REFERENCE_LIST_HEADER_TWO: "การอ้างอิง $1 รายการ", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "ไม่สามารถส่งข้อความที่ว่างเปล่า", SPEECH_INPUT_LISTENING: "กำลังฟัง...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "ปิดไมโครโฟน", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "เปิดไมโครโฟน", SPEECH_INPUT_STARTING: "กำลังเริ่ม...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "ถัดไป", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "ก่อนหน้า", SUGGESTED_ACTIONS_LABEL_ALT: "การดำเนินการที่แนะนำ", TEXT_INPUT_ALT: "กล่องป้อนข้อความ", TEXT_INPUT_PLACEHOLDER: "พิมพ์ข้อความของคุณ", TEXT_INPUT_SEND_BUTTON_ALT: "ส่ง", TEXT_INPUT_SPEAK_BUTTON_ALT: "พูด", TEXT_INPUT_UPLOAD_BUTTON_ALT: "อัปโหลดไฟล์", TOAST_ACCORDION_FEW: "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด", TOAST_ACCORDION_MANY: "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด", TOAST_ACCORDION_OTHER: "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด", TOAST_ACCORDION_TWO: "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด", TOAST_ALT_ERROR: "ผิดพลาด", TOAST_ALT_INFO: "ข้อมูล", TOAST_ALT_SUCCESS: "สำเร็จ", TOAST_ALT_WARN: "คำเตือน", TOAST_DISMISS_BUTTON: "ปิดการเตือน", TOAST_TITLE_ALT: "การแจ้งเตือน", TRANSCRIPT_ARIA_LABEL_ALT: "ประวัติการแชท กดแป้นลูกศรเพื่อนำทาง", TRANSCRIPT_ARIA_ROLE_ALT: "ประวัติการแชท", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "ข้อความเป็นแบบโต้ตอบ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "ข้อความมีการดำเนินการที่แนะนำ กด Shift Tab 2 ถึง 3 ครั้งเพื่อเลือก", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "ข้อความมีการดำเนินการที่แนะนำ กด $1 เพื่อเลือก", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "ไม่สามารถส่งข้อความได้", TRANSCRIPT_MORE_MESSAGES: "ข้อความเพิ่มเติม", TRANSCRIPT_NEW_MESSAGES: "ข้อความใหม่", TRANSCRIPT_TERMINATOR_TEXT: "สิ้นสุดประวัติการแชท", TYPING_INDICATOR_ALT: "แสดงตัวแสดงการพิมพ์", TYPING_INDICATOR_SINGLE_TEXT: "$1 กำลังพิมพ์", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 และคนอื่นๆ กำลังพิมพ์", VOTE_DISLIKE_ALT: "ไม่ถูกใจ", VOTE_LIKE_ALT: "ถูกใจ" }, _Fe = { _comment: "[CI-LOCKED] Bu dosyanın içeriği kilitli. Katılımcılar dosyayı kullanabilir ancak değişikliğin doğrulanması gecikebilir.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "$1 botu şöyle diyor:", ACTIVITY_YOU_SAID_ALT: "Şöyle dediniz:", ACTIVITY_BOT_ATTACHED_ALT: "Bot eklendi:", ACTIVITY_ERROR_BOX_TITLE: "Hata iletisi", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Etkileşim kurmak için tıklayın.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "İleti etkileşimli.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "İletide bir veya daha fazla bağlantı var.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Gönderilemedi.", ACTIVITY_YOU_ATTACHED_ALT: "Şunu eklediniz:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 ek.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 ek.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 ek.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 ekler.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 ek.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Gönderme başarısız. [Yeniden Dene][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Gönderiliyor", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "$1 itibarıyla gönderildi", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Hemen şimdi", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Bir saat önce", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Bir dakika önce", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Bugün", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Dün", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Uyarlamalı Kart ayrıştırma hatası", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Uyarlamalı Kart işleme hatası", ATTACHMENT_AUDIO: "Ses klibi.", ATTACHMENT_CARD: "Kart: $1 $2 $3", ATTACHMENT_FILE: "Dosya: $1", ATTACHMENT_IMAGE: "Görüntü", ATTACHMENT_TEXT: "Metin: $1", ATTACHMENT_VIDEO: "Video klibi", CAROUSEL_FLIPPER_NEXT_ALT: "Sonraki", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Önceki", CITATION_MODEL_DIALOG_ALT: "Alıntı", CONNECTIVITY_STATUS_ALT_CONNECTED: "Bağlı", CONNECTIVITY_STATUS_ALT_CONNECTING: "Bağlantı kuruluyor...", CONNECTIVITY_STATUS_ALT_FATAL: "Bağlantı kurulamadı.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Ağ kesintisi oluştu. Yeniden bağlanıyor...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "İşleme hatası. Lütfen konsolu denetleyin veya bot geliştiricisine başvurun.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Bağlantı kurmak normalden uzun sürüyor.", CONNECTIVITY_STATUS_ALT: "Bağlantı Durumu: $1", FILE_CONTENT_ALT: '"$1"', FILE_CONTENT_DOWNLOADABLE_ALT: '"$1" dosyasını indir', FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: '$2 boyutlu "$1" dosyasını indir', FILE_CONTENT_WITH_SIZE_ALT: '$2 boyutlu "$1" dosyası', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter tuşu", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Mesajdaki öğelere erişin", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Sohbet geçmişi", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape tuşu", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "İletiden çık", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Sekme tuşu
Shift + sekme tuşu`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Mesajdaki öğeler arasında gezinin", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Yukarı ok tuşu
Aşağı ok tuşu`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Mesajlar arasında gezinin", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter tuşu", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Eylem gerçekleştirin", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Sekme tuşu
Shift + sekme tuşu`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Sohbet penceresindeki öğeler arasında gezinin", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Sohbet penceresi", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Kapat", KEYBOARD_HELP_HEADER: "Klavye denetimleri", MARKDOWN_EXTERNAL_LINK_ALT: "Yeni bir pencerede açılır; harici.", RECEIPT_CARD_TAX: "Vergi", RECEIPT_CARD_TOTAL: "Toplam", RECEIPT_CARD_VAT: "KDV", REFERENCE_LIST_HEADER_ONE: "$1 başvuru", REFERENCE_LIST_HEADER_FEW: "$1 başvuru", REFERENCE_LIST_HEADER_MANY: "$1 başvuru", REFERENCE_LIST_HEADER_OTHER: "$1 başvuru", REFERENCE_LIST_HEADER_TWO: "$1 başvuru", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Boş ileti gönderilemez.", SPEECH_INPUT_LISTENING: "Dinliyor…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Mikrofon kapalı", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Mikrofon açık", SPEECH_INPUT_STARTING: "Başlatılıyor...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Sonraki", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Önceki", SUGGESTED_ACTIONS_LABEL_ALT: "Önerilen eylemler", TEXT_INPUT_ALT: "İleti gelen kutusu", TEXT_INPUT_PLACEHOLDER: "İletinizi yazın", TEXT_INPUT_SEND_BUTTON_ALT: "Gönder", TEXT_INPUT_SPEAK_BUTTON_ALT: "Konuş", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Dosya yükle", TOAST_ACCORDION_FEW: "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın", TOAST_ACCORDION_MANY: "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın", TOAST_ACCORDION_OTHER: "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın", TOAST_ACCORDION_TWO: "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın", TOAST_ALT_ERROR: "Hata", TOAST_ALT_INFO: "Bilgiler", TOAST_ALT_SUCCESS: "Başarılı", TOAST_ALT_WARN: "Uyarı", TOAST_DISMISS_BUTTON: "Kapat", TOAST_TITLE_ALT: "Bildirim", TRANSCRIPT_ARIA_LABEL_ALT: "Sohbet geçmişi, gezinmek için ok tuşlarını kullanın.", TRANSCRIPT_ARIA_ROLE_ALT: "sohbet geçmişi", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Mesaj etkileşimlidir. Sohbet geçmişine geçmek için shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak için mesaja tıklayın.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Mesajda bir veya daha fazla bağlantı var. Sohbet geçmişine geçmek için shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak için mesaja tıklayın.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "İletide önerilen eylemler var. Seçmek için Shift + sekme tuşlarına 2-3 kez basın.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "İletide önerilen eylemler var. Seçmek için $1 tuşuna basın.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "İleti gönderilemedi.", TRANSCRIPT_MORE_MESSAGES: "Diğer iletiler", TRANSCRIPT_NEW_MESSAGES: "Yeni iletiler", TRANSCRIPT_TERMINATOR_TEXT: "Sohbet geçmişinin sonu", TYPING_INDICATOR_ALT: "Yazma göstergesi gösteriliyor", TYPING_INDICATOR_SINGLE_TEXT: "$1 yazıyor.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 ve diğer kişiler yazıyor.", VOTE_DISLIKE_ALT: "Beğenme", VOTE_LIKE_ALT: "Beğen" }, AFe = { _comment: "[CI-LOCKED] Вміст цього файлу заблоковано. Внески вітаються, але перевірка змін може зайняти певний час.", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "Control + Option + $1", ACTIVITY_BOT_SAID_ALT: "Бот $1 каже:", ACTIVITY_YOU_SAID_ALT: "Ви кажете:", ACTIVITY_BOT_ATTACHED_ALT: "Бот вкладає:", ACTIVITY_ERROR_BOX_TITLE: "Повідомлення про помилку", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Клацніть, щоб взаємодіяти.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Повідомлення інтерактивне.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Повідомлення містить одне або кілька посилань.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Помилка надсилання.", ACTIVITY_YOU_ATTACHED_ALT: "Ви вкладаєте:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 вкладення.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 вкладення.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 вкладення.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 вкладення.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 вкладення.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Не вдалося надіслати. [Повторити][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Надсилання", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Надіслано о $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Щойно", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Годину тому", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Хвилину тому", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Сьогодні", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Учора", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Помилка аналізу адаптивної картки", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Помилка відображення адаптивної картки", ATTACHMENT_AUDIO: "Аудіокліп.", ATTACHMENT_CARD: "Картка: $1 $2 $3", ATTACHMENT_FILE: "Файл: $1", ATTACHMENT_IMAGE: "Зображення", ATTACHMENT_TEXT: "Текст: $1", ATTACHMENT_VIDEO: "Відеокліп", CAROUSEL_FLIPPER_NEXT_ALT: "Далі", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Назад", CITATION_MODEL_DIALOG_ALT: "Цитування", CONNECTIVITY_STATUS_ALT_CONNECTED: "Підключено", CONNECTIVITY_STATUS_ALT_CONNECTING: "Підключення…", CONNECTIVITY_STATUS_ALT_FATAL: "Не вдалося підключити.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Підключення до мережі перервано. Відновлення підключення...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Помилка відображення. Перевірте консоль або зверніться до розробника бота.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Підключення триває більше часу, ніж зазвичай.", CONNECTIVITY_STATUS_ALT: "Стан підключення: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Завантажити файл '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: 'Завантажити файл "$1" завбільшки $2', FILE_CONTENT_WITH_SIZE_ALT: '"$1" завбільшки $2', KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Перейти до елементів у повідомленні", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Історія чату", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Esc", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Повідомлення про вихід", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab
Shift+Tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Перейти між елементами повідомлення", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Стрілка вгору
Стрілка вниз`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Перейти між повідомленнями", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Виконати дію", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab
Shift+Tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Перейти між елементами у вікні чату", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Вікно чату", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Закрити", KEYBOARD_HELP_HEADER: "Елементи керування клавіатурою", MARKDOWN_EXTERNAL_LINK_ALT: "Відкривається в новому вікні; зовнішнє.", RECEIPT_CARD_TAX: "Податок", RECEIPT_CARD_TOTAL: "Усього", RECEIPT_CARD_VAT: "ПДВ", REFERENCE_LIST_HEADER_ONE: "$1 посилання", REFERENCE_LIST_HEADER_FEW: "$1 посилань", REFERENCE_LIST_HEADER_MANY: "$1 посилань", REFERENCE_LIST_HEADER_OTHER: "$1 посилання", REFERENCE_LIST_HEADER_TWO: "$1 посилання", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Не можна надсилати пусті повідомлення.", SPEECH_INPUT_LISTENING: "Слухання…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Мікрофон вимкнуто", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Мікрофон увімкнуто", SPEECH_INPUT_STARTING: "Початок…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Далі", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Назад", SUGGESTED_ACTIONS_LABEL_ALT: "Рекомендовані дії", TEXT_INPUT_ALT: "Вікно вводу повідомлень", TEXT_INPUT_PLACEHOLDER: "Введіть повідомлення", TEXT_INPUT_SEND_BUTTON_ALT: "Надіслати", TEXT_INPUT_SPEAK_BUTTON_ALT: "Говорити", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Передати файл", TOAST_ACCORDION_FEW: "Сповіщень: $1. Натисніть нижче, щоб побачити відомості", TOAST_ACCORDION_MANY: "Сповіщень: $1. Натисніть нижче, щоб побачити відомості", TOAST_ACCORDION_OTHER: "Сповіщень: $1. Натисніть нижче, щоб побачити відомості", TOAST_ACCORDION_TWO: "Сповіщень: $1. Натисніть нижче, щоб побачити відомості", TOAST_ALT_ERROR: "Помилка", TOAST_ALT_INFO: "Відомості", TOAST_ALT_SUCCESS: "Виконано", TOAST_ALT_WARN: "Попередження!", TOAST_DISMISS_BUTTON: "Закрити", TOAST_TITLE_ALT: "Сповіщення", TRANSCRIPT_ARIA_LABEL_ALT: "Історія чату: натискайте клавіші зі стрілками, щоб переходити між елементами.", TRANSCRIPT_ARIA_ROLE_ALT: "історія чату", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Це інтерактивне повідомлення. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Повідомлення містить одне або кілька посилань. Натисніть клавіші Shift+Tab 2–3 рази, щоб перейди до історії чату. Потім клацніть повідомлення, щоб взаємодіяти.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Повідомлення містить рекомендовані дії. Натисніть клавіші Shift + Tab 2–3 рази, щоб вибрати їх.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Повідомлення містить рекомендовані дії. Натисніть клавішу $1, щоб вибрати їх.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Не вдалося надіслати повідомлення.", TRANSCRIPT_MORE_MESSAGES: "Інші повідомлення", TRANSCRIPT_NEW_MESSAGES: "Нові повідомлення", TRANSCRIPT_TERMINATOR_TEXT: "Кінець історії чату", TYPING_INDICATOR_ALT: "Показує індикатор набору", TYPING_INDICATOR_SINGLE_TEXT: "$1 вводить повідомлення.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 та інші вводять повідомлення.", VOTE_DISLIKE_ALT: "Не подобається", VOTE_LIKE_ALT: "Подобається" }, SFe = { _comment: "[CI-LOCKED] Nội dung của tệp này đã bị khóa. Hoan nghênh ý kiến đóng góp, nhưng việc xác nhận thay đổi có thể bị trì hoãn.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "Bot $1 đã nói:", ACTIVITY_YOU_SAID_ALT: "Bạn đã nói:", ACTIVITY_BOT_ATTACHED_ALT: "Bot đã đính kèm:", ACTIVITY_ERROR_BOX_TITLE: "Thông báo lỗi", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "Nhấp để tương tác.", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "Thông báo có tính tương tác.", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "Có một hoặc nhiều đường liên kết trong tin nhắn.", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "Không gửi được.", ACTIVITY_YOU_ATTACHED_ALT: "Bạn đã đính kèm:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 tệp đính kèm.", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 tệp đính kèm.", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 tệp đính kèm.", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 tệp đính kèm.", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 tệp đính kèm.", ACTIVITY_STATUS_SEND_FAILED_RETRY: "Đã không gửi được. [Thử lại][RETRY].", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "Đang gửi", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "Đã gửi vào lúc $1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "Vừa xong", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "Một giờ trước", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "Một phút trước", ACTIVITY_STATUS_TIMESTAMP_TODAY: "Hôm nay", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "Hôm qua", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Lỗi phân tích Thẻ thích nghi", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Lỗi kết xuất Thẻ thích nghi", ATTACHMENT_AUDIO: "Đoạn âm thanh.", ATTACHMENT_CARD: "Thẻ: $1 $2 $3", ATTACHMENT_FILE: "Tệp: $1", ATTACHMENT_IMAGE: "Hình ảnh", ATTACHMENT_TEXT: "Văn bản: $1", ATTACHMENT_VIDEO: "Đoạn video", CAROUSEL_FLIPPER_NEXT_ALT: "Tiếp theo", CAROUSEL_FLIPPER_PREVIOUS_ALT: "Trước", CITATION_MODEL_DIALOG_ALT: "Trích dẫn", CONNECTIVITY_STATUS_ALT_CONNECTED: "Đã kết nối", CONNECTIVITY_STATUS_ALT_CONNECTING: "Đang kết nối...", CONNECTIVITY_STATUS_ALT_FATAL: "Không thể kết nối.", CONNECTIVITY_STATUS_ALT_RECONNECTING: "Đã bị gián đoạn mạng. Đang kết nối lại...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Lỗi kết xuất. Vui lòng kiểm tra bảng điều khiển hoặc liên hệ với nhà phát triển bot.", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "Việc kết nối đang mất nhiều thời gian hơn bình thường.", CONNECTIVITY_STATUS_ALT: "Trạng thái Kết nối: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "Tải tệp '$1' xuống", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "Tải tệp '$1' kích thước $2 xuống", FILE_CONTENT_WITH_SIZE_ALT: "'$1' kích thước $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Phím Enter", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "Truy nhập các mục trong tin nhắn", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "Lịch sử trò chuyện", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Phím Escape", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "Thoát khỏi thông báo", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Phím tab
Shift + phím tab`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "Di chuyển giữa các mục trong một tin nhắn", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `Phím mũi tên lên
Phím mũi tên xuống`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "Di chuyển giữa các tin nhắn", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Phím Enter", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "Thực hiện hành động", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Phím tab
Shift + phím tab`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "Di chuyển giữa các mục trong cửa sổ trò chuyện", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "Cửa sổ trò chuyện", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "Đóng", KEYBOARD_HELP_HEADER: "Bàn phím điều khiển", MARKDOWN_EXTERNAL_LINK_ALT: "Mở trong cửa sổ mới; bên ngoài.", RECEIPT_CARD_TAX: "Thuế", RECEIPT_CARD_TOTAL: "Tổng số", RECEIPT_CARD_VAT: "Thuế GTGT", REFERENCE_LIST_HEADER_ONE: "$1 tham chiếu", REFERENCE_LIST_HEADER_FEW: "$1 tham chiếu", REFERENCE_LIST_HEADER_MANY: "$1 tham chiếu", REFERENCE_LIST_HEADER_OTHER: "$1 tham chiếu", REFERENCE_LIST_HEADER_TWO: "$1 tham chiếu", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "Không thể gửi tin nhắn.", SPEECH_INPUT_LISTENING: "Đang nghe…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "Tắt micrô", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "Bật micrô", SPEECH_INPUT_STARTING: "Đang bắt đầu...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "Tiếp theo", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "Trước", SUGGESTED_ACTIONS_LABEL_ALT: "Hành động được đề xuất", TEXT_INPUT_ALT: "Hộp nhập tin nhắn", TEXT_INPUT_PLACEHOLDER: "Nhập tin nhắn của bạn", TEXT_INPUT_SEND_BUTTON_ALT: "Gửi", TEXT_INPUT_SPEAK_BUTTON_ALT: "Nói", TEXT_INPUT_UPLOAD_BUTTON_ALT: "Tải lên tệp", TOAST_ACCORDION_FEW: "$1 Thông báo: Bấm vào đây để xem chi tiết", TOAST_ACCORDION_MANY: "$1 Thông báo: Bấm vào đây để xem chi tiết", TOAST_ACCORDION_OTHER: "$1 Thông báo: Bấm vào đây để xem chi tiết", TOAST_ACCORDION_TWO: "$1 Thông báo: Bấm vào đây để xem chi tiết", TOAST_ALT_ERROR: "Lỗi", TOAST_ALT_INFO: "Thông tin", TOAST_ALT_SUCCESS: "Thành công", TOAST_ALT_WARN: "Cảnh báo", TOAST_DISMISS_BUTTON: "Bỏ qua", TOAST_TITLE_ALT: "Thông báo", TRANSCRIPT_ARIA_LABEL_ALT: "Lịch sử trò chuyện, nhấn các phím mũi tên để điều hướng.", TRANSCRIPT_ARIA_ROLE_ALT: "lịch sử trò chuyện", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "Tin nhắn có tính tương tác. Bấm phím shift tab 2 đến 3 lần để chuyển sang lịch sử trò chuyện. Sau đó bấm vào tin nhắn để tương tác.", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "Một hoặc nhiều liên kết trong tin nhắn. Bấm phím shift tab 2 đến 3 lần để chuyển sang lịch sử trò chuyện. Sau đó bấm vào tin nhắn để tương tác.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "Thông báo có các hành động được đề xuất. Nhấn tổ hợp phím shift tab 2 đến 3 lần để chọn các hành động đó.", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "Thông báo có các hành động được đề xuất. Nhấn $1 để chọn các hành động đó.", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "Không thể gửi tin nhắn.", TRANSCRIPT_MORE_MESSAGES: "Các tin nhắn khác", TRANSCRIPT_NEW_MESSAGES: "Tin nhắn mới", TRANSCRIPT_TERMINATOR_TEXT: "Kết thúc lịch sử trò chuyện", TYPING_INDICATOR_ALT: "Hiển thị chỉ báo đang nhập", TYPING_INDICATOR_SINGLE_TEXT: "$1 đang nhập.", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 và những người khác đang nhập.", VOTE_DISLIKE_ALT: "Không thích", VOTE_LIKE_ALT: "Thích" }, bFe = { "_.comment": "The content of this file is contributed by the community.", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_MAC_ALT: "Ctrl Option $1", ACTIVITY_BOT_ATTACHED_ALT: "Bot 嘅附件：", ACTIVITY_BOT_SAID_ALT: "Bot $1 話：", ACTIVITY_ERROR_BOX_TITLE: "錯嘅信息", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "襟呢度前往信息入面嘅項目。", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "信息可以互動。", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "信息入面有網頁連結。", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "傳送唔倒。", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 件附件。", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 件附件。", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "一件附件。", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 件附件。", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "兩件附件。", ACTIVITY_STATUS_SEND_FAILED_RETRY: "傳送唔倒。[再嚟一次][RETRY]。", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "而家傳送緊", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "送出嘅時間：$1", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "啱啱", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "一個鐘前", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "一分鐘前", ACTIVITY_STATUS_TIMESTAMP_TODAY: "今日", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "尋日", ACTIVITY_YOU_ATTACHED_ALT: "你嘅附件：", ACTIVITY_YOU_SAID_ALT: "你話：", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "Adaptive Card 解析出事", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "Adaptive Card render 出事", ATTACHMENT_AUDIO: "一段錄音", ATTACHMENT_CARD: "一張卡：$1 $2 $3", ATTACHMENT_FILE: "一個檔案：$1", ATTACHMENT_IMAGE: "一幅圖", ATTACHMENT_TEXT: "一段文字：$1", ATTACHMENT_VIDEO: "一段錄像", CAROUSEL_FLIPPER_NEXT_ALT: "後", CAROUSEL_FLIPPER_PREVIOUS_ALT: "前", CITATION_MODEL_DIALOG_ALT: "引文", CONNECTIVITY_STATUS_ALT_CONNECTED: "接駁到", CONNECTIVITY_STATUS_ALT_CONNECTING: "接駁緊…", CONNECTIVITY_STATUS_ALT_FATAL: "接駁唔倒。", CONNECTIVITY_STATUS_ALT_RECONNECTING: "網絡暫時斷咗，試緊再駁返…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "Render 出事，請睇下 console 或者同 bot 開發人員聯絡。", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "接駁嘅時間比平時長。", CONNECTIVITY_STATUS_ALT: "接駁情況：$1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "下載檔案 '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "下載檔案 '$1' 檔案大小 $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' 檔案大小 $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter 掣", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "前往信息入面嘅項目", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "聊天記錄", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape 掣", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "離開信息", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab 掣
Shift 加 tab 掣`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "喺信息入面揀項目", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `向上箭咀
向下箭咀`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "揀信息", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter 掣", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "執行動作", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab 掣
Shift 加 tab 掣`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "喺聊天視窗入面揀項目", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "聊天視窗", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "閂咗佢", KEYBOARD_HELP_HEADER: "鍵盤控制", MARKDOWN_EXTERNAL_LINK_ALT: "喺新嘅視窗開啟外部連結。", RECEIPT_CARD_TAX: "稅", RECEIPT_CARD_TOTAL: "總共", RECEIPT_CARD_VAT: "消費稅", REFERENCE_LIST_HEADER_ONE: "一篇參考", REFERENCE_LIST_HEADER_FEW: "$1 篇參考", REFERENCE_LIST_HEADER_MANY: "$1 篇參考", REFERENCE_LIST_HEADER_OTHER: "$1 篇參考", REFERENCE_LIST_HEADER_TWO: "兩篇參考", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "唔可以傳送空白嘅訊息。", SPEECH_INPUT_LISTENING: "聽緊你講嘢…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "閂咪", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "開咪", SPEECH_INPUT_STARTING: "開始緊…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "後", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "前", SUGGESTED_ACTIONS_LABEL_ALT: "建議㩒嘅掣", TEXT_INPUT_ALT: "訊息輸入盒", TEXT_INPUT_PLACEHOLDER: "輸入你嘅訊息", TEXT_INPUT_SEND_BUTTON_ALT: "傳送", TEXT_INPUT_SPEAK_BUTTON_ALT: "講嘢", TEXT_INPUT_UPLOAD_BUTTON_ALT: "上載檔案", TEXT_INPUT_ATTACHMENTS_FEW: "$1 件附件", TEXT_INPUT_ATTACHMENTS_MANY: "$1 件附件", TEXT_INPUT_ATTACHMENTS_ONE: "一件附件", TEXT_INPUT_ATTACHMENTS_OTHER: "$1 件附件", TEXT_INPUT_ATTACHMENTS_TWO: "兩件附件", TOAST_ACCORDION_FEW: "$1 項通知：襟呢度睇詳情", TOAST_ACCORDION_MANY: "$1 項通知：襟呢度睇詳情", TOAST_ACCORDION_OTHER: "$1 項通知：襟呢度睇詳情", TOAST_ACCORDION_TWO: "兩項通知：襟呢度睇詳情", TOAST_ALT_ERROR: "錯誤：$1", TOAST_ALT_INFO: "資訊：$1", TOAST_ALT_SUCCESS: "成功：$1", TOAST_ALT_WARN: "警告：$1", TOAST_DISMISS_BUTTON: "閂咗佢", TOAST_TITLE_ALT: "通知", TRANSCRIPT_ARIA_LABEL_ALT: "聊天記錄，襟方向箭咀嚟瀏覽。", TRANSCRIPT_ARIA_ROLE_ALT: "聊天記錄", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "信息可以互動，襟 shift tab 兩三下去聊天記錄，再襟個信息前往佢入面嘅項目。", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "信息入面有網頁連結，襟 shift tab 兩三下去聊天記錄，再襟個信息前往佢入面嘅項目。", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "有信息傳送唔倒。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "信息有建議㩒嘅掣，可以襟 shift tab 兩三下揀佢哋。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "信息有建議㩒嘅掣，可以襟 $1 揀佢哋。", TRANSCRIPT_MORE_MESSAGES: "更多訊息", TRANSCRIPT_NEW_MESSAGES: "新訊息", TRANSCRIPT_TERMINATOR_TEXT: "聊天記錄結束", TYPING_INDICATOR_ALT: "對方打緊字", VOTE_DISLIKE_ALT: "唔啱", VOTE_LIKE_ALT: "啱" }, az = { _comment: "[CI-LOCKED] 此文件的内容已锁定。欢迎发布内容，但更改验证可能会延迟。", ACCESS_KEY_ALT: "Alt + Shift + $1", ACCESS_KEY_FOR_MAC_ALT: "控制键 + 选项键 + $1", ACTIVITY_BOT_SAID_ALT: "机器人 $1 说:", ACTIVITY_YOU_SAID_ALT: "您说:", ACTIVITY_BOT_ATTACHED_ALT: "机器人附加了:", ACTIVITY_ERROR_BOX_TITLE: "错误消息", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "单击以进行交互。", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "消息是交互式消息。", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "消息中有一个或多个链接。", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "发送失败。", ACTIVITY_YOU_ATTACHED_ALT: "您附加了:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 个附件。", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 个附件。", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 个附件。", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 个附件。", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 个附件。", ACTIVITY_STATUS_SEND_FAILED_RETRY: "发送失败。[重试][RETRY]。", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "正在发送", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "已于 $1 发送", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "刚刚", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1 小时前", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 分钟前", ACTIVITY_STATUS_TIMESTAMP_TODAY: "今天", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "昨天", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "自适应卡分析错误", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "自适应卡呈现错误", ATTACHMENT_AUDIO: "音频剪辑。", ATTACHMENT_CARD: "卡片: $1 $2 $3", ATTACHMENT_FILE: "文件: $1", ATTACHMENT_IMAGE: "图像", ATTACHMENT_TEXT: "文本: $1", ATTACHMENT_VIDEO: "视频剪辑", CAROUSEL_FLIPPER_NEXT_ALT: "下一个", CAROUSEL_FLIPPER_PREVIOUS_ALT: "上一个", CITATION_MODEL_DIALOG_ALT: "引文", CONNECTIVITY_STATUS_ALT_CONNECTED: "已连接", CONNECTIVITY_STATUS_ALT_CONNECTING: "正在连接...", CONNECTIVITY_STATUS_ALT_FATAL: "无法连接。", CONNECTIVITY_STATUS_ALT_RECONNECTING: "发生网络中断。正在重新连接...", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "呈现错误。请检查控制台或联系机器人开发者。", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "连接所花费的时间长于平时。", CONNECTIVITY_STATUS_ALT: "连接状态: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "下载文件 '$1'", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "下载文件 '$1'，大小为 $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1' 的大小为 $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "Enter 键", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "访问消息中的项目", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "聊天历史记录", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "Escape 键", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "退出消息", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab 键
Shift + Tab 键`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "在消息中的项目之间移动", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `向上键
向下键`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "在消息之间移动", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "Enter 键", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "执行操作", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab 键
Shift + Tab 键`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "在聊天窗口中的项目之间移动", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "聊天窗口", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "关闭", KEYBOARD_HELP_HEADER: "键盘控件", MARKDOWN_EXTERNAL_LINK_ALT: "在新窗口中打开；外部。", RECEIPT_CARD_TAX: "税款", RECEIPT_CARD_TOTAL: "总额", RECEIPT_CARD_VAT: "增值税", REFERENCE_LIST_HEADER_ONE: "$1 条引用", REFERENCE_LIST_HEADER_FEW: "$1 条引用", REFERENCE_LIST_HEADER_MANY: "$1 条引用", REFERENCE_LIST_HEADER_OTHER: "$1 条引用", REFERENCE_LIST_HEADER_TWO: "$1 条引用", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "无法发送空消息。", SPEECH_INPUT_LISTENING: "正在倾听...", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "麦克风关闭", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "麦克风打开", SPEECH_INPUT_STARTING: "正在启动...", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "下一个", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "上一个", SUGGESTED_ACTIONS_LABEL_ALT: "建议的操作", TEXT_INPUT_ALT: "消息输入框", TEXT_INPUT_PLACEHOLDER: "键入消息", TEXT_INPUT_SEND_BUTTON_ALT: "发送", TEXT_INPUT_SPEAK_BUTTON_ALT: "咨询", TEXT_INPUT_UPLOAD_BUTTON_ALT: "上传文件", TOAST_ACCORDION_FEW: "$1 条通知: 单击此处以查看详细信息", TOAST_ACCORDION_MANY: "$1 条通知: 单击此处以查看详细信息", TOAST_ACCORDION_OTHER: "$1 条通知: 单击此处以查看详细信息", TOAST_ACCORDION_TWO: "$1 条通知: 单击此处以查看详细信息", TOAST_ALT_ERROR: "出错", TOAST_ALT_INFO: "信息", TOAST_ALT_SUCCESS: "成功", TOAST_ALT_WARN: "警告", TOAST_DISMISS_BUTTON: "取消", TOAST_TITLE_ALT: "通知", TRANSCRIPT_ARIA_LABEL_ALT: "聊天历史记录，按箭头键导航。", TRANSCRIPT_ARIA_ROLE_ALT: "聊天历史记录", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "消息是交互式消息。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "消息中有一个或多个链接。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "消息提供了建议的操作。请按 Shift + Tab 键 2 到 3 次进行选择。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "消息提供了建议的操作。请按 $1 进行选择。", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "无法发送消息。", TRANSCRIPT_MORE_MESSAGES: "更多消息", TRANSCRIPT_NEW_MESSAGES: "新消息", TRANSCRIPT_TERMINATOR_TEXT: "聊天历史记录结束", TYPING_INDICATOR_ALT: "显示键入指示器", TYPING_INDICATOR_SINGLE_TEXT: "$1 正在键入。", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 和其他人正在键入。", VOTE_DISLIKE_ALT: "不喜欢", VOTE_LIKE_ALT: "喜欢" }, CFe = { _comment: "[CI-LOCKED] 此檔案的內容已鎖定。歡迎提供意見，但變更驗證可能會有所延遲。", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "機器人 $1 說:", ACTIVITY_YOU_SAID_ALT: "您說:", ACTIVITY_BOT_ATTACHED_ALT: "機器人附加了:", ACTIVITY_ERROR_BOX_TITLE: "錯誤訊息", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "按一下以進行互動。", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "訊息為互動式訊息。", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "訊息中有一或多個連結。", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "傳送失敗。", ACTIVITY_YOU_ATTACHED_ALT: "您附加了:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 個附件。", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 個附件。", ACTIVITY_STATUS_SEND_FAILED_RETRY: "傳送失敗。[重試][RETRY]。", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "正在傳送", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "於 $1 傳送", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "剛剛", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1 小時前", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 分鐘前", ACTIVITY_STATUS_TIMESTAMP_TODAY: "今天", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "昨天", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "調適型卡片剖析錯誤", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "調適型卡片轉譯錯誤", ATTACHMENT_AUDIO: "音訊剪輯。", ATTACHMENT_CARD: "卡片: $1 $2 $3", ATTACHMENT_FILE: "檔案: $1", ATTACHMENT_IMAGE: "影像", ATTACHMENT_TEXT: "文字: $1", ATTACHMENT_VIDEO: "視訊剪輯", CAROUSEL_FLIPPER_NEXT_ALT: "下一個", CAROUSEL_FLIPPER_PREVIOUS_ALT: "上一個", CITATION_MODEL_DIALOG_ALT: "引用", CONNECTIVITY_STATUS_ALT_CONNECTED: "已連線", CONNECTIVITY_STATUS_ALT_CONNECTING: "正在連線…", CONNECTIVITY_STATUS_ALT_FATAL: "無法連線。", CONNECTIVITY_STATUS_ALT_RECONNECTING: "發生網路中斷。正在重新連線…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "轉譯錯誤。請檢查主控台或連絡機器人開發人員。", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "連線所需的時間比平時更長。", CONNECTIVITY_STATUS_ALT: "連線狀態: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "下載 '$1' 檔案", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "下載 '$1' 檔案，大小為 $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1'，大小為 $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "ENTER 鍵", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "存取訊息中的項目", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "聊天記錄", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "ESC 鍵", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "結束訊息", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab 鍵
Shift + Tab 鍵`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "在訊息中的項目之間移動", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `向上鍵
向下鍵`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "在訊息之間移動", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "ENTER 鍵", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "執行動作", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab 鍵
Shift + Tab 鍵`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "在聊天視窗中的項目之間移動", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "聊天視窗", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "關閉", KEYBOARD_HELP_HEADER: "鍵盤控制項", MARKDOWN_EXTERNAL_LINK_ALT: "在新視窗中開啟; 外部。", RECEIPT_CARD_TAX: "稅金", RECEIPT_CARD_TOTAL: "總計", RECEIPT_CARD_VAT: "加值稅", REFERENCE_LIST_HEADER_ONE: "$1 個參考", REFERENCE_LIST_HEADER_FEW: "$1 個參考", REFERENCE_LIST_HEADER_MANY: "$1 個參考", REFERENCE_LIST_HEADER_OTHER: "$1 個參考", REFERENCE_LIST_HEADER_TWO: "$1 個參考", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "無法傳送空白訊息。", SPEECH_INPUT_LISTENING: "正在聆聽…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "關閉麥克風", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "開啟麥克風", SPEECH_INPUT_STARTING: "正在啟動…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "下一個", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "上一個", SUGGESTED_ACTIONS_LABEL_ALT: "建議的動作", TEXT_INPUT_ALT: "訊息輸入方塊", TEXT_INPUT_PLACEHOLDER: "輸入您的訊息", TEXT_INPUT_SEND_BUTTON_ALT: "傳送", TEXT_INPUT_SPEAK_BUTTON_ALT: "說話", TEXT_INPUT_UPLOAD_BUTTON_ALT: "上傳檔案", TOAST_ACCORDION_FEW: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_MANY: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_OTHER: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_TWO: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ALT_ERROR: "錯誤", TOAST_ALT_INFO: "資訊", TOAST_ALT_SUCCESS: "成功", TOAST_ALT_WARN: "警告", TOAST_DISMISS_BUTTON: "關閉", TOAST_TITLE_ALT: "通知", TRANSCRIPT_ARIA_LABEL_ALT: "聊天記錄，按方向鍵進行瀏覽。", TRANSCRIPT_ARIA_ROLE_ALT: "聊天記錄", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "訊息為互動式。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "訊息中的一或多個連結。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "訊息有建議的動作。請按下 Shift Tab 2 至 3 次選取它們。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "訊息有建議的動作。請按下 $1 選取它們。", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "無法傳送訊息。", TRANSCRIPT_MORE_MESSAGES: "更多訊息", TRANSCRIPT_NEW_MESSAGES: "新訊息", TRANSCRIPT_TERMINATOR_TEXT: "聊天記錄結尾", TYPING_INDICATOR_ALT: "顯示輸入指示器", TYPING_INDICATOR_SINGLE_TEXT: "$1 正在鍵入。", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 和其他人正在鍵入。", VOTE_DISLIKE_ALT: "不喜歡", VOTE_LIKE_ALT: "喜歡" }, uz = { _comment: "[CI-LOCKED] 此檔案的內容已鎖定。歡迎提供意見，但變更驗證可能會有所延遲。", ACCESS_KEY_ALT: "Alt Shift $1", ACCESS_KEY_FOR_MAC_ALT: "Control Option $1", ACTIVITY_BOT_SAID_ALT: "機器人 $1 說:", ACTIVITY_YOU_SAID_ALT: "您說:", ACTIVITY_BOT_ATTACHED_ALT: "機器人附加了:", ACTIVITY_ERROR_BOX_TITLE: "錯誤訊息", ACTIVITY_INTERACTIVE_FOOTNOTE_ALT: "按一下以進行互動。", ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: "訊息為互動式訊息。", ACTIVITY_INTERACTIVE_REASON_LINK_ALT: "訊息中有一或多個連結。", ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT: "傳送失敗。", ACTIVITY_YOU_ATTACHED_ALT: "您附加了:", ACTIVITY_NUM_ATTACHMENTS_ONE_ALT: "1 個附件。", ACTIVITY_NUM_ATTACHMENTS_FEW_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_MANY_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT: "$1 個附件。", ACTIVITY_NUM_ATTACHMENTS_TWO_ALT: "$1 個附件。", ACTIVITY_STATUS_SEND_FAILED_RETRY: "傳送失敗。[重試][RETRY]。", ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING: "正在傳送", ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: "於 $1 傳送", ACTIVITY_STATUS_TIMESTAMP_JUST_NOW: "剛剛", ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO: "1 小時前", ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO: "1 分鐘前", ACTIVITY_STATUS_TIMESTAMP_TODAY: "今天", ACTIVITY_STATUS_TIMESTAMP_YESTERDAY: "昨天", ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE: "調適型卡片剖析錯誤", ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER: "調適型卡片轉譯錯誤", ATTACHMENT_AUDIO: "音訊剪輯。", ATTACHMENT_CARD: "卡片: $1 $2 $3", ATTACHMENT_FILE: "檔案: $1", ATTACHMENT_IMAGE: "影像", ATTACHMENT_TEXT: "文字: $1", ATTACHMENT_VIDEO: "視訊剪輯", CAROUSEL_FLIPPER_NEXT_ALT: "下一個", CAROUSEL_FLIPPER_PREVIOUS_ALT: "上一個", CITATION_MODEL_DIALOG_ALT: "引用", CONNECTIVITY_STATUS_ALT_CONNECTED: "已連線", CONNECTIVITY_STATUS_ALT_CONNECTING: "正在連線…", CONNECTIVITY_STATUS_ALT_FATAL: "無法連線。", CONNECTIVITY_STATUS_ALT_RECONNECTING: "發生網路中斷。正在重新連線…", CONNECTIVITY_STATUS_ALT_RENDER_ERROR: "轉譯錯誤。請檢查主控台或連絡機器人開發人員。", CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION: "連線所需的時間比平時更長。", CONNECTIVITY_STATUS_ALT: "連線狀態: $1", FILE_CONTENT_ALT: "'$1'", FILE_CONTENT_DOWNLOADABLE_ALT: "下載 '$1' 檔案", FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT: "下載 '$1' 檔案，大小為 $2", FILE_CONTENT_WITH_SIZE_ALT: "'$1'，大小為 $2", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY: "ENTER 鍵", KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER: "存取訊息中的項目", KEYBOARD_HELP_CHAT_HISTORY_HEADER: "聊天記錄", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY: "ESC 鍵", KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER: "結束訊息", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY: `Tab 鍵
Shift + Tab 鍵`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER: "在訊息中的項目之間移動", KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY: `向上鍵
向下鍵`, KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER: "在訊息之間移動", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY: "ENTER 鍵", KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER: "執行動作", KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY: `Tab 鍵
Shift + Tab 鍵`, KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER: "在聊天視窗中的項目之間移動", KEYBOARD_HELP_CHAT_WINDOW_HEADER: "聊天視窗", KEYBOARD_HELP_CLOSE_BUTTON_ALT: "關閉", KEYBOARD_HELP_HEADER: "鍵盤控制項", MARKDOWN_EXTERNAL_LINK_ALT: "在新視窗中開啟; 外部。", RECEIPT_CARD_TAX: "稅金", RECEIPT_CARD_TOTAL: "總計", RECEIPT_CARD_VAT: "加值稅", REFERENCE_LIST_HEADER_ONE: "$1 個參考", REFERENCE_LIST_HEADER_FEW: "$1 個參考", REFERENCE_LIST_HEADER_MANY: "$1 個參考", REFERENCE_LIST_HEADER_OTHER: "$1 個參考", REFERENCE_LIST_HEADER_TWO: "$1 個參考", SEND_BOX_IS_EMPTY_TOOLTIP_ALT: "無法傳送空白訊息。", SPEECH_INPUT_LISTENING: "正在聆聽…", SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT: "關閉麥克風", SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT: "開啟麥克風", SPEECH_INPUT_STARTING: "正在啟動…", SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT: "下一個", SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT: "上一個", SUGGESTED_ACTIONS_LABEL_ALT: "建議的動作", TEXT_INPUT_ALT: "訊息輸入方塊", TEXT_INPUT_PLACEHOLDER: "輸入您的訊息", TEXT_INPUT_SEND_BUTTON_ALT: "傳送", TEXT_INPUT_SPEAK_BUTTON_ALT: "說話", TEXT_INPUT_UPLOAD_BUTTON_ALT: "上傳檔案", TOAST_ACCORDION_FEW: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_MANY: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_OTHER: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ACCORDION_TWO: "$1 則通知: 按一下這裡來查看詳細資料", TOAST_ALT_ERROR: "錯誤", TOAST_ALT_INFO: "資訊", TOAST_ALT_SUCCESS: "成功", TOAST_ALT_WARN: "警告", TOAST_DISMISS_BUTTON: "關閉", TOAST_TITLE_ALT: "通知", TRANSCRIPT_ARIA_LABEL_ALT: "聊天記錄，按方向鍵進行瀏覽。", TRANSCRIPT_ARIA_ROLE_ALT: "聊天記錄", TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: "訊息為互動式。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。", TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: "訊息中的一或多個連結。請按 Shift Tab 鍵 2 到 3 次切換至聊天記錄，然後按一下訊息進行互動。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT: "訊息有建議的動作。請按下 Shift Tab 2 至 3 次選取它們。", TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT: "訊息有建議的動作。請按下 $1 選取它們。", TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT: "無法傳送訊息。", TRANSCRIPT_MORE_MESSAGES: "更多訊息", TRANSCRIPT_NEW_MESSAGES: "新訊息", TRANSCRIPT_TERMINATOR_TEXT: "聊天記錄結尾", TYPING_INDICATOR_ALT: "顯示輸入指示器", TYPING_INDICATOR_SINGLE_TEXT: "$1 正在鍵入。", TYPING_INDICATOR_MULTIPLE_TEXT: "$1 和其他人正在鍵入。", VOTE_DISLIKE_ALT: "不喜歡", VOTE_LIKE_ALT: "喜歡" }, IFe = { "ar-EG": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ar-EG", SPEECH_LANGUAGE: "ar-EG" }, "ar-SA": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ar-SA", SPEECH_LANGUAGE: "ar-SA" }, "bg-BG": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "bg", SPEECH_LANGUAGE: "bg-BG" }, "ca-ES": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ca", SPEECH_LANGUAGE: "ca-ES" }, "cs-CZ": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "cs", SPEECH_LANGUAGE: "cs-CZ" }, "da-DK": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "da", SPEECH_LANGUAGE: "da-DK" }, "de-DE": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: "neural", GLOBALIZE_LANGUAGE: "de", SPEECH_LANGUAGE: "de-DE" }, "el-GR": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "el", SPEECH_LANGUAGE: "el-GR" }, "en-US": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: "neural", GLOBALIZE_LANGUAGE: "en", SPEECH_LANGUAGE: "en-US" }, "es-ES": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "es", SPEECH_LANGUAGE: "es-ES" }, "et-EE": { GLOBALIZE_LANGUAGE: "et" }, "eu-ES": { GLOBALIZE_LANGUAGE: "eu" }, "fi-FI": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "fi", SPEECH_LANGUAGE: "fi-FI" }, "fr-FR": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "fr", SPEECH_LANGUAGE: "fr-FR" }, "gl-ES": { GLOBALIZE_LANGUAGE: "gl" }, "he-IL": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "he", SPEECH_LANGUAGE: "he-IL" }, "hi-IN": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "hi", SPEECH_LANGUAGE: "hi-IN" }, "hr-HR": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "hr", SPEECH_LANGUAGE: "hr-HR" }, "hu-HU": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "hu", SPEECH_LANGUAGE: "hu-HU" }, "id-ID": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "id", SPEECH_LANGUAGE: "id-ID" }, "it-IT": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: "neural", GLOBALIZE_LANGUAGE: "it", SPEECH_LANGUAGE: "it-IT" }, "ja-JP": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ja", SPEECH_LANGUAGE: "ja-JP" }, "kk-KZ": { GLOBALIZE_LANGUAGE: "kk" }, "ko-KR": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ko", SPEECH_LANGUAGE: "ko-KR" }, "lt-LT": { GLOBALIZE_LANGUAGE: "lt" }, "lv-LV": { GLOBALIZE_LANGUAGE: "lv" }, "ms-MY": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ms", SPEECH_LANGUAGE: "ms-MY" }, "nb-NO": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "nb", SPEECH_LANGUAGE: "nb-NO" }, "nl-NL": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "nl", SPEECH_LANGUAGE: "nl-NL" }, "pl-PL": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "pl", SPEECH_LANGUAGE: "pl-PL" }, "pt-BR": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "pt", SPEECH_LANGUAGE: "pt-BR" }, "pt-PT": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "pt-PT", SPEECH_LANGUAGE: "pt-PT" }, "ro-RO": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ro", SPEECH_LANGUAGE: "ro-RO" }, "ru-RU": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "ru", SPEECH_LANGUAGE: "ru-RU" }, "sk-SK": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "sk", SPEECH_LANGUAGE: "sk-SK" }, "sl-SI": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "sl", SPEECH_LANGUAGE: "sl-SI" }, "sr-Cyrl": { GLOBALIZE_LANGUAGE: "sr-Cyrl" }, "sr-Latn": { GLOBALIZE_LANGUAGE: "sr-Latn" }, "sv-SE": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "sv", SPEECH_LANGUAGE: "sv-SE" }, "th-TH": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "th", SPEECH_LANGUAGE: "th-TH" }, "tr-TR": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "tr", SPEECH_LANGUAGE: "tr-TR" }, "uk-UA": { GLOBALIZE_LANGUAGE: "uk" }, "vi-VN": { COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "vi", SPEECH_LANGUAGE: "vi-VN" }, yue: { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "yue", SPEECH_LANGUAGE: "zh-HK" }, "zh-Hans": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: "neural", GLOBALIZE_LANGUAGE: "zh-Hans", SPEECH_LANGUAGE: "zh-CN" }, "zh-Hans-SG": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: "neural", GLOBALIZE_LANGUAGE: "zh-Hans-SG", SPEECH_LANGUAGE: "zh-CN" }, "zh-Hant": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "zh-Hant", SPEECH_LANGUAGE: "zh-TW" }, "zh-Hant-HK": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "zh-Hant-HK", SPEECH_LANGUAGE: "zh-HK" }, "zh-Hant-MO": { COGNITIVE_SERVICES_SPEECH_TO_TEXT: !0, COGNITIVE_SERVICES_TEXT_TO_SPEECH: !0, GLOBALIZE_LANGUAGE: "zh-Hant-MO", SPEECH_LANGUAGE: "zh-HK" } };
function OFe(...e) {
  let t = {}, r = e.reduce((n, i) => [...n, ...Object.keys(i)], []);
  for (let n of new Set(r)) ia(n) || (t[n] = e.reduce((i, o) => ({ ...i, ...o[n] }), {}));
  return t;
}
var sz;
function RFe() {
  return sz || (sz = OFe({ "ar-EG": LMe, "ar-JO": BMe, "ar-SA": kMe, "bg-BG": MMe, "ca-ES": FMe, "cs-CZ": HMe, "da-DK": $Me, "de-DE": UMe, "el-GR": VMe, "en-US": jMe, "es-ES": zMe, "et-EE": qMe, "eu-ES": YMe, "fi-FI": GMe, "fr-FR": WMe, "gl-ES": KMe, "he-IL": XMe, "hi-IN": JMe, "hr-HR": ZMe, "hu-HU": QMe, "id-ID": eFe, "it-IT": tFe, "ja-JP": rFe, "kk-KZ": nFe, "ko-KR": iFe, "lt-LT": oFe, "lv-LV": aFe, "ms-MY": uFe, "nb-NO": sFe, "nl-NL": cFe, "pl-PL": lFe, "pt-BR": fFe, "pt-PT": dFe, "ro-RO": pFe, "ru-RU": hFe, "sk-SK": vFe, "sl-SI": EFe, "sr-Cyrl": mFe, "sr-Latn": gFe, "sv-SE": TFe, "th-TH": yFe, "tr-TR": _Fe, "uk-UA": AFe, "vi-VN": SFe, yue: bFe, "zh-Hans": az, "zh-Hant": uz, "zh-Hans-SG": az, "zh-Hant-HK": CFe, "zh-Hant-MO": uz }, IFe));
}
var kfe = RFe, wFe = rl('"styleOptions.hideScrollToEndButton" has been deprecated. To hide scroll to end button, set "scrollToEndBehavior" to false. This deprecation migration will be removed on or after 2023-06-02.'), PFe = rl('"styleOptions.newMessagesButtonFontSize" has been renamed to "styleOptions.scrollToEndButtonFontSize". This deprecation migration will be removed on or after 2023-06-02.'), DFe = rl('"styleOptions.suggestedActionBackground" has been deprecated. Please use "styleOptions.suggestedActionBackgroundColor" instead. This deprecation migration will be removed on or after 2021-09-16.'), q_ = rl('"styleOptions.suggestedActionXXXBackground" has been deprecated. Please use "styleOptions.suggestedActionBackgroundColorOnXXX" instead. This deprecation migration will be removed on or after 2021-09-16.'), Y_ = rl('"styleOptions.suggestedActionDisabledXXX" has been renamed to "styleOptions.suggestedActionXXXOnDisabled". This deprecation migration will be removed on or after 2021-09-16.');
function Zb({ hideScrollToEndButton: e, newMessagesButtonFontSize: t, ...r } = {}) {
  let n = { ...xMe, ...r }, { bubbleFromUserNubOffset: i, bubbleNubOffset: o, emojiSet: a } = n, u, s, c;
  i === "top" ? u = 0 : typeof i != "number" ? u = -0 : u = i, o === "top" ? s = 0 : typeof o != "number" ? s = -0 : s = o, a === !0 ? c = { ":)": "😊", ":-)": "😊", "(:": "😊", "(-:": "😊", ":-|": "😐", ":|": "😐", ":-(": "☹️", ":(": "☹️", ":-D": "😀", ":D": "😀", ":-p": "😛", ":p": "😛", ":-P": "😛", ":P": "😛", ":-o": "😲", ":o": "😲", ":O": "😲", ":-O": "😲", ":-0": "😲", ":0": "😲", ";-)": "😉", ";)": "😉", "<3": "❤️", "</3": "💔", "<\\3": "💔" } : Object.prototype.toString.call(a) !== "[object Object]" ? (console.warn("botframework-webchat: emojiSet must be a boolean or an object with emoticon: emojiValues"), c = !1) : c = a, e && (wFe(), n.scrollToEndButtonBehavior = r.scrollToEndButtonBehavior || !1);
  let l = n.scrollToEndButtonBehavior;
  return l !== "any" && l !== !1 && (l === "unread" || console.warn('Web Chat: "scrollToEndButtonBehavior" must be either "unread", "any", or false, will set to "unread".'), l = "unread"), t && (PFe(), n.scrollToEndButtonFontSize = r.scrollToEndButtonFontSize || t), r.suggestedActionBackground && DFe(), r.suggestedActionActiveBackground && (q_(), n.suggestedActionBackgroundColorOnActive = r.suggestedActionBackgroundColorOnActive || r.suggestedActionActiveBackground), r.suggestedActionFocusBackground && (q_(), n.suggestedActionBackgroundColorOnFocus = r.suggestedActionBackgroundColorOnFocus || r.suggestedActionFocusBackground), r.suggestedActionHoverBackground && (q_(), n.suggestedActionBackgroundColorOnHover = r.suggestedActionBackgroundColorOnHover || r.suggestedActionHoverBackground), r.suggestedActionDisabledBackground && (q_(), n.suggestedActionBackgroundColorOnDisabled = r.suggestedActionBackgroundColorOnDisabled || r.suggestedActionDisabledBackground), r.suggestedActionDisabledBorderColor && (Y_(), n.suggestedActionBorderColorOnDisabled = r.suggestedActionBorderColorOnDisabled || r.suggestedActionDisabledBorderColor), r.suggestedActionDisabledBorderStyle && (Y_(), n.suggestedActionBorderStyleOnDisabled = r.suggestedActionBorderStyleOnDisabled || r.suggestedActionDisabledBorderStyle), r.suggestedActionDisabledBorderWidth && (Y_(), n.suggestedActionBorderWidthOnDisabled = r.suggestedActionBorderWidthOnDisabled || r.suggestedActionDisabledBorderWidth), r.suggestedActionDisabledTextColor && (Y_(), n.suggestedActionTextColorOnDisabled = r.suggestedActionTextColorOnDisabled || r.suggestedActionDisabledTextColor), { ...n, bubbleFromUserNubOffset: u, bubbleNubOffset: s, emojiSet: c, scrollToEndButtonBehavior: l };
}
function xFe(e) {
  return e.slowConnectionAfter < 0 && (console.warn('Web Chat: "slowConnectionAfter" cannot be negative, will set to 0.'), e = Xr(e, ["slowConnectionAfter"], () => 0)), e;
}
function xk(e, t) {
  let r = Ut(t);
  return nr(() => {
    r.current = e;
  }), r.current;
}
function oO(e) {
  let t = Ut(), r = tt(() => Object.create({}, { current: { get: () => t.current } }), []);
  return t.current = e, r;
}
var Qb = ei(), NFe = vMe(Qb), Ss = gMe(Qb);
Qb.displayName = "WebChatReduxContext";
var LFe = Qb;
function Ih() {
  return [Ss(({ activities: e }) => e)];
}
function BFe(e, t) {
  let r = [...e].reverse().findIndex(t);
  if (~r) {
    let { length: n } = e || [];
    return n - r - 1;
  }
  return r;
}
var Mfe = ei(void 0);
function Oh(e = !0) {
  let t = En(Mfe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityKeyerComposer>.");
  return t;
}
function Ffe() {
  return Oh().activityKeysState;
}
var kFe = ei(void 0), Hfe = kFe;
function cz(e, t, r) {
  if (t.includes(e)) return e;
  if (!r || !e) return;
  let n = r.indexOf(e);
  if (~n) {
    let i = r.slice(0, n).reverse();
    for (let o of i) if (t.includes(o)) return o;
  }
}
var MFe = ({ children: e }) => {
  let [t] = Ih(), [r] = Ffe(), [n, i] = cn(), [o, a] = cn(), u = oO(r), s = xk(r), c = tt(() => BFe(t, (_) => {
    var S;
    return ((S = _.from) == null ? void 0 : S.role) === "user";
  }), [t]), l = tt(() => (o && !~s.includes(o) && console.warn(`botframework-webchat internal assertion: "rawLastReadActivityKey" of value ${o} should be in the "prevAllActivityKeys" array.`), cz(o, r, s)), [r, s, o]), f = oO(l), d = tt(() => {
    n && !~s.includes(n) && console.warn(`botframework-webchat internal assertion: "rawLastAcknowledgedActivityKey" of value ${n} should be in the "prevAllActivityKeys" array.`);
    let _ = cz(n, r, s);
    return r[Math.max(r.indexOf(_), c)] || r[r.length - 1];
  }, [r, c, s, n]), p = tt(() => {
    let _ = /* @__PURE__ */ new Map(), S = r.indexOf(d), A = r.indexOf(l);
    return r.forEach((O, P) => {
      _.set(O, { acknowledged: P <= S, read: P <= A });
    }), Object.freeze(_);
  }, [r, d, l]), v = oO(p), h = mt((_) => {
    var S;
    return (S = v.current.get(_)) == null ? void 0 : S.acknowledged;
  }, [v]), E = tt(() => {
    let _ = r.indexOf(l);
    return Object.freeze([Object.freeze(r.slice(0, _ + 1)), Object.freeze(r.slice(_ + 1))]);
  }, [r, l]), m = mt(() => {
    let { current: _ } = u;
    i(_[_.length - 1]);
  }, [u, i]), g = mt((_) => {
    let { current: S } = u, A = S.indexOf(_);
    if (!~A) return console.warn(`botframework-webchat: Cannot mark activity with key ${_} as read because it is not in the transcript.`);
    A > S.indexOf(f.current) && a(_);
  }, [u, f, a]);
  E[0].length + E[1].length !== r.length && console.warn("botframework-webchat internal: Sum of count of read and unread activity keys MUST equals to total number of activity keys.");
  let y = tt(() => ({ activityKeysByReadState: E, getHasAcknowledgedByActivityKey: h, lastAcknowledgedActivityKeyState: Object.freeze([d]), lastReadActivityKeyState: Object.freeze([l]), markActivityKeyAsRead: g, markAllAsAcknowledged: m }), [E, h, d, l, g, m]);
  return G.createElement(Hfe.Provider, { value: y }, e);
}, FFe = MFe;
function $fe(e, t, r) {
  let n = r;
  for (let i of e) n = t(n, i);
  return n;
}
function HFe(e) {
  return e.id;
}
function $Fe(e) {
  var t;
  return (t = e.channelData) == null ? void 0 : t.clientActivityID;
}
function UFe(e) {
  return e == null ? void 0 : e[e.length - 1];
}
function VFe(e, t) {
  for (let r of e) if (t(r)) return !0;
  return !1;
}
function jFe() {
  return Mu().toString(36).substring(2, 7);
}
function zFe(e) {
  let { type: t } = e;
  if ((t === "message" || t === "typing") && "text" in e && typeof e.text == "string" && "streamId" in e.channelData && e.channelData.streamId) return e.channelData.streamId;
}
var qFe = ({ children: e }) => {
  if (Oh(!1)) throw new Error("botframework-webchat internal: <ActivityKeyerComposer> should not be nested.");
  let [t] = Ih(), r = Ut(Object.freeze(/* @__PURE__ */ new Map())), n = Ut(Object.freeze(/* @__PURE__ */ new Map())), i = Ut(Object.freeze(/* @__PURE__ */ new Map())), o = Ut(Object.freeze(/* @__PURE__ */ new Map())), a = tt(() => {
    let { current: p } = r, { current: v } = n, { current: h } = i, E = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Map();
    return t.forEach((S) => {
      let A = HFe(S), O = $Fe(S), P = zFe(S), U = O && h.get(O) || P && p.get(P) || A && p.get(A) || v.get(S) || jFe();
      A && E.set(A, U), O && y.set(O, U), g.set(S, U), m.add(U);
      let z = _.has(U) ? [..._.get(U)] : [];
      z.push(S), _.set(U, Object.freeze(z));
    }), r.current = Object.freeze(E), n.current = Object.freeze(g), i.current = Object.freeze(y), o.current = Object.freeze(_), Object.freeze([Object.freeze([...m.values()])]);
  }, [t, r, n, i, o]), u = mt((p) => p && o.current.get(p), [o]), s = mt((p) => UFe(u(p)), [u]), c = mt((p) => p && n.current.get(p), [n]), l = mt((p) => p && r.current.get(p), [r]), f = tt(() => ({ activityKeysState: a, getActivityByKey: s, getActivitiesByKey: u, getKeyByActivity: c, getKeyByActivityId: l }), [a, u, s, c, l]), { length: d } = t;
  return r.current.size > d && console.warn('botframework-webchat internal assertion: "activityIdToKeyMap.size" should be equal or less than "activities.length".'), n.current.size !== d && console.warn('botframework-webchat internal assertion: "activityToKeyMap.size" should be same as "activities.length".'), i.current.size > d && console.warn('botframework-webchat internal assertion: "clientActivityIdToKeyMap.size" should be equal or less than "activities.length".'), VFe(o.current.values(), ({ length: p }) => !p) && console.warn('botframework-webchat internal assertion: all values in "keyToActivitiesMap" should have at least one item.'), $fe(o.current.values(), (p, { length: v }) => p + v, 0) !== d && console.warn('botframework-webchat internal assertion: "keyToActivitiesMap.size" should be same as "activities.length".'), a[0].length !== o.current.size && console.warn('botframework-webchat internal assertion: "activityKeys.length" should be same as "keyToActivitiesMap.size".'), G.createElement(Mfe.Provider, { value: f }, e);
}, YFe = qFe, GFe = ei(new Proxy({}, { get() {
  throw new Error("botframework-webchat internal: This hook can only used under <ActivityListenerComposer>.");
} })), Ufe = GFe, WFe = Nr(({ children: e }) => {
  let [t] = Ih(), r = xk(t, []), n = tt(() => {
    let o = [];
    for (let a of t) r.includes(a) || o.push(a);
    return Object.freeze([Object.freeze(o)]);
  }, [t, r]), i = tt(() => ({ upsertedActivitiesState: n }), [n]);
  return G.createElement(Ufe.Provider, { value: i }, e);
}), KFe = WFe, Vt = {};
Y9e(Vt, { useActiveTyping: () => t7e, useActivities: () => Ih, useActivityKeys: () => r7e, useActivityKeysByRead: () => i7e, useAvatarForBot: () => o7e, useAvatarForUser: () => a7e, useByteFormatter: () => s7e, useConnectivityStatus: () => c7e, useCreateActivityRenderer: () => f7e, useCreateActivityStatusRenderer: () => m7e, useCreateAttachmentForScreenReaderRenderer: () => g7e, useCreateAvatarRenderer: () => T7e, useCreateScrollToEndButtonRenderer: () => y7e, useDateFormatter: () => Gfe, useDebouncedNotifications: () => O7e, useDictateInterims: () => R7e, useDictateState: () => w7e, useDirection: () => N7e, useDisabled: () => L7e, useDismissNotification: () => B7e, useEmitTypingIndicator: () => k7e, useGetActivitiesByKey: () => F7e, useGetActivityByKey: () => Xfe, useGetHasAcknowledgedByActivityKey: () => U7e, useGetKeyByActivity: () => qfe, useGetKeyByActivityId: () => j7e, useGetSendTimeoutForActivity: () => kk, useGrammars: () => z7e, useGroupActivities: () => q7e, useGroupTimestamp: () => Y7e, useLanguage: () => Bk, useLastAcknowledgedActivityKey: () => W7e, useLastReadActivityKey: () => X7e, useLocalizer: () => Jfe, useMarkActivityAsSpoken: () => eHe, useMarkActivityKeyAsRead: () => rHe, useMarkAllAsAcknowledged: () => Zfe, useNotifications: () => Wfe, usePerformCardAction: () => iHe, usePonyfill: () => ac, usePostActivity: () => oHe, useReferenceGrammarID: () => aHe, useRelativeTimeFormatter: () => uHe, useRenderAttachment: () => jfe, useRenderToast: () => sHe, useRenderTypingIndicator: () => cHe, useSendBoxAttachments: () => Qfe, useSendBoxValue: () => lHe, useSendEvent: () => fHe, useSendFiles: () => hHe, useSendMessage: () => vHe, useSendMessageBack: () => EHe, useSendPostBack: () => mHe, useSendStatusByActivityKey: () => Lk, useSendTimeoutForActivity: () => gHe, useSendTypingIndicator: () => THe, useSetNotification: () => yHe, useShouldSpeakIncomingActivity: () => _He, useStartDictate: () => AHe, useStopDictate: () => SHe, useStyleOptions: () => nl, useSubmitSendBox: () => bHe, useSuggestedActions: () => CHe, useTimeoutForSend: () => IHe, useTrackDimension: () => ede, useTrackEvent: () => wh, useTrackException: () => Fk, useTrackTiming: () => RHe, useUserID: () => wHe, useUsername: () => PHe, useVoiceSelector: () => DHe });
var XFe = ei(new Proxy({}, { get() {
  throw new Error("botframework-webchat internal: This hook can only be used under <ActivityTypingProvider>.");
} })), Vfe = XFe;
function JFe() {
  return En(Vfe);
}
function ZFe() {
  return JFe().allTypingState;
}
function QFe() {
  let [, e] = cn();
  return mt(() => e({}), [e]);
}
var Nk = QFe;
function nl() {
  return [Lr().styleOptions];
}
function e7e(e) {
  let [{ clearTimeout: t, Date: r, setTimeout: n }] = ac(), [{ typingAnimationDuration: i }] = nl(), [o] = ZFe(), a = Nk(), u = r.now(), s = Object.freeze([Object.freeze(Object.fromEntries($fe(o.entries(), (f, [d, { firstReceivedAt: p, lastActivityDuration: v, lastReceivedAt: h, name: E, role: m, type: g }]) => {
    let y = h + (e ?? v ?? i);
    return y > u && f.set(d, { at: p, expireAt: y, name: E, role: m, type: g }), f;
  }, /* @__PURE__ */ new Map()).entries()))]), c = Math.min(...Object.values(s[0]).map(({ expireAt: f }) => f)), l = c && c - u;
  return nr(() => {
    if (l && isFinite(l)) {
      let f = n(a, Math.max(0, l));
      return () => t(f);
    }
  }, [t, a, n, l]), s;
}
var t7e = e7e, r7e = Ffe;
function Rh(e = !0) {
  let t = En(Hfe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityAcknowledgementContext>.");
  return t;
}
function n7e() {
  return Rh().activityKeysByReadState;
}
var i7e = n7e;
function o7e() {
  let [{ botAvatarImage: e, botAvatarInitials: t }] = nl();
  return [{ image: e, initials: t }];
}
function a7e() {
  let [{ userAvatarImage: e, userAvatarInitials: t }] = nl();
  return [{ image: e, initials: t }];
}
function eC() {
  return Lr().localizedGlobalizeState;
}
var lz = 1024, fz = 1048576, dz = 1073741824, u7e = { form: "long" }, aO = { form: "short" };
function s7e() {
  let [e] = eC();
  return tt(() => {
    let t = e.unitFormatter.bind(e);
    return (r) => r < lz ? t("byte", u7e)(r) : r < fz ? t("kilobyte", aO)(~~(r / lz)) : r < dz ? t("megabyte", aO)(~~(r / fz)) : t("gigabyte", aO)(~~(r / dz));
  }, [e]);
}
function c7e() {
  return [Ss(({ connectivityStatus: e }) => e)];
}
function jfe() {
  let { attachmentRenderer: e } = Lr();
  return e;
}
function l7e(e) {
  let { activityRenderer: t } = Lr(), r = jfe(), n = r;
  return tt(() => (...i) => {
    let o = t(...i);
    return o ? (a) => {
      if (cS(o)) return o;
      let u = o((...s) => n(...s), a);
      return u || console.warn("botframework-webchat: To hide an activity, the activity renderer should return false. It should not return a function that will return false when called."), u;
    } : !1;
  }, [t, n]);
}
function f7e() {
  return l7e();
}
function zfe() {
  return Oh().getKeyByActivity;
}
var qfe = zfe, d7e = ei(void 0), Yfe = d7e;
function p7e(e = !0) {
  let t = En(Yfe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <ActivitySendStatusComposer>.");
  return t;
}
function h7e() {
  return p7e().sendStatusByActivityKeyState;
}
var Lk = h7e, v7e = Nr(({ activity: e, hideTimestamp: t, nextVisibleActivity: r, sendStatus: n }) => {
  let { activityStatusRenderer: i } = Lr();
  return i({ activity: e, hideTimestamp: t, nextVisibleActivity: r, sameTimestampGroup: t, sendState: n === "send failed" || n === "sent" ? n : "sending" });
}), E7e = Nr(({ activity: e, hideTimestamp: t, nextVisibleActivity: r }) => {
  let [n] = Lk(), i = qfe()(e), o = typeof i == "string" && n.get(i) || "sent";
  return G.createElement(v7e, { activity: e, hideTimestamp: t, nextVisibleActivity: r, sendStatus: o });
});
function m7e() {
  return tt(() => ({ activity: e, nextVisibleActivity: t }) => ({ hideTimestamp: r } = {}) => G.createElement(E7e, { activity: e, hideTimestamp: r, nextVisibleActivity: t }), []);
}
function g7e() {
  return Lr().attachmentForScreenReaderRenderer;
}
function T7e() {
  let [e] = nl(), { avatarRenderer: t } = Lr();
  return tt(() => ({ activity: r }) => {
    let { from: { role: n } = {} } = r, i = t({ activity: r, fromUser: n === "user", styleOptions: e });
    return i !== !1 && typeof i != "function" ? (console.warn("botframework-webchat: avatarMiddleware should return a function to render the avatar, or return false if avatar should be hidden. Please refer to HOOKS.md for details."), () => i) : i;
  }, [t, e]);
}
function y7e() {
  return Lr().scrollToEndButtonRenderer;
}
function Gfe() {
  let [{ Date: e }] = ac(), [t] = eC();
  return tt(() => (r) => t.dateFormatter({ skeleton: "MMMMdhm" })(new e(r)), [e, t]);
}
function G_(e) {
  return typeof e > "u";
}
var _7e = (e) => e;
function A7e(e, t = _7e) {
  return e.reduce((r, n) => {
    let i = G_(r) ? r : t(r), o = G_(n) ? n : t(n);
    return G_(i) ? n : G_(o) || i < o ? r : n;
  }, void 0);
}
var S7e = A7e;
function b7e(e, t) {
  let [{ clearTimeout: r, Date: n, setTimeout: i }] = Bfe();
  nr(() => {
    if (typeof e == "number") {
      let o = Math.max(0, e - n.now());
      if (o) {
        let a = i(t, o);
        return () => r(a);
      }
      t();
    }
  }, [e, r, n, t, i]);
}
function Wfe() {
  return [Ss(({ notifications: e }) => e)];
}
function C7e(e) {
  return S7e(Object.values(e).filter(({ outOfDate: t }) => t).map(({ updateNotBefore: t }) => t));
}
function I7e() {
  let [{ Date: e }] = ac(), [{ notificationDebounceTimeout: t }] = nl(), [r] = Wfe(), n = Ut({}), i = Nk(), o = e.now();
  for (let a of Object.keys(n.current).filter((u) => !(u in r))) n.current = Xr(n.current, [a], (u) => {
    if (o < u.updateNotBefore) return { ...u, outOfDate: !0 };
  });
  for (let [, { alt: a, data: u, id: s, level: c, message: l, timestamp: f }] of Object.entries(r)) n.current = Xr(n.current, [s], (d) => d && a === d.alt && Object.is(u, d.data) && c === d.level && l === d.message && f === d.timestamp ? d : d && o < d.updateNotBefore ? { ...d, outOfDate: !0 } : { ...d, alt: a, data: u, id: s, level: c, message: l, outOfDate: !1, timestamp: f, updateNotBefore: o + t });
  return b7e(C7e(n.current), i), [n.current];
}
var O7e = I7e;
function R7e() {
  return [Ss(({ dictateInterims: e }) => e) || [], Lr().setDictateInterims];
}
function w7e() {
  return [Ss(({ dictateState: e }) => e)];
}
function P7e() {
  return ["ar-EG", "ar-JO", "ar-SA", "he-IL"];
}
function D7e() {
  return [Lr().dir];
}
function Kfe() {
  let { localizedStrings: e } = Lr();
  return e;
}
function Bk(e) {
  let { language: t } = Lr(), r = Kfe();
  return e === "speech" ? [r.SPEECH_LANGUAGE || t] : [t];
}
function x7e(e, t) {
  return e !== "auto" ? e : P7e().includes(t) ? "rtl" : "ltr";
}
function N7e() {
  let [e] = D7e(), [t] = Bk();
  return [tt(() => x7e(e, t), [e, t])];
}
function L7e() {
  return [Lr().disabled];
}
function B7e() {
  return Lr().dismissNotification;
}
function k7e() {
  return Lr().emitTypingIndicator;
}
function M7e() {
  return Oh().getActivitiesByKey;
}
var F7e = M7e;
function H7e() {
  return Oh().getActivityByKey;
}
var Xfe = H7e;
function $7e() {
  return Rh().getHasAcknowledgedByActivityKey;
}
var U7e = $7e;
function V7e() {
  return Oh().getKeyByActivityId;
}
var j7e = V7e;
function kk() {
  let [{ sendTimeout: e, sendTimeoutForAttachments: t }] = nl();
  return tt(() => ({ activity: r }) => {
    var n;
    return typeof e == "function" ? e(r) : r.type === "message" && ((n = r.attachments) != null && n.length) ? t : e;
  }, [e, t]);
}
function z7e() {
  return [Lr().grammars];
}
function q7e() {
  return Lr().groupActivities;
}
function Y7e() {
  let [{ groupTimestamp: e }] = nl();
  return [e];
}
function G7e() {
  return Rh().lastAcknowledgedActivityKeyState;
}
var W7e = G7e;
function K7e() {
  return Rh().lastReadActivityKeyState;
}
var X7e = K7e, { toString: J7e } = {};
function yS(e) {
  return J7e.call(e) === "[object Object]";
}
var Z7e = kfe()["en-US"];
function Jfe({ plural: e } = {}) {
  let [t] = eC(), r = Kfe();
  return mt((n, ...i) => {
    let o = n;
    if (e) {
      let a = n;
      if (yS(a)) {
        if (typeof a.other != "string") throw new Error('useLocalizer: Plural string must have "id.other" of string.');
        if (typeof i[0] != "number") throw new Error("useLocalizer: Plural string must have first argument as a number.");
      } else throw new Error('useLocalizer: Plural string must pass "id" as a map instead of string.');
      for (let s of ["zero", "one", "two", "few", "many"]) {
        let c = typeof n[s];
        if (c !== "string" && c !== "undefined") throw new Error(`useLocalizer: Plural string must have "id.${s}" of string or undefined.`);
      }
      let u = Object.keys(n).filter((s) => !["zero", "one", "two", "few", "many", "other"].includes(s));
      if (u.length) throw new Error(`useLocalizer: Plural string "id" must be either "zero", "one", "two", "few", "many", "other". But not ${u.map((s) => `"${s}"`).join(", ")}.`);
      o = a[t.plural(i[0])] || a.other;
    } else if (typeof n != "string") throw new Error('useLocalizer: "id" must be a string.');
    return Object.entries(i).reduce((a, [u, s]) => a.replace(`$${+u + 1}`, s), ia(o) ? "" : r[o] || Z7e[o] || "");
  }, [t, r, e]);
}
function Q7e() {
  return Lr().markActivity;
}
function eHe() {
  let e = Q7e();
  return mt((t) => e(t, "speak", !1), [e]);
}
function tHe() {
  return Rh().markActivityKeyAsRead;
}
var rHe = tHe;
function nHe() {
  return Rh().markAllAsAcknowledged;
}
var Zfe = nHe;
function iHe() {
  return Lr().onCardAction;
}
function oHe() {
  return Lr().postActivity;
}
function aHe() {
  return [Ss(({ referenceGrammarID: e }) => e)];
}
function uHe() {
  let [{ Date: e }] = ac(), [t] = eC(), r = Gfe(), n = Jfe();
  return tt(() => {
    let i = t.relativeTimeFormatter.bind(t);
    return (o) => {
      let a = new e(o), u = a.getTime();
      if (isNaN(u)) return o;
      let s = e.now() - u, c = Math.floor(s / 6e4), l = Math.floor(s / 36e5);
      return c < 1 ? n("ACTIVITY_STATUS_TIMESTAMP_JUST_NOW") : c === 1 ? n("ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO") : l < 1 ? i("minute")(-c) : l === 1 ? n("ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO") : l < 5 ? i("hour")(-l) : s <= 24 * 36e5 ? n("ACTIVITY_STATUS_TIMESTAMP_TODAY") : s <= 48 * 36e5 ? n("ACTIVITY_STATUS_TIMESTAMP_YESTERDAY") : r(a);
    };
  }, [e, r, t, n]);
}
function sHe() {
  return Lr().toastRenderer;
}
function cHe() {
  return Lr().typingIndicatorRenderer;
}
function Qfe() {
  let e = Ss(({ sendBoxAttachments: r }) => r), { setSendBoxAttachments: t } = Lr();
  return tt(() => Object.freeze([e, t]), [e, t]);
}
function lHe() {
  return [Ss(({ sendBoxValue: e }) => e), Lr().setSendBox];
}
function fHe() {
  return Lr().sendEvent;
}
function V1(e, t) {
  let r;
  return typeof CustomEvent == "function" ? r = new CustomEvent(e) : (r = document.createEvent("Event"), r.initEvent(e, !0, !0)), Object.entries(t).forEach(([n, i]) => {
    ia(n) || (r[n] = i);
  }), r;
}
function Mk() {
  let { telemetryDimensionsRef: e } = Lr();
  return mt(() => ({ ...e.current }), [e]);
}
function pz(e) {
  return typeof e == "number" && isFinite(e) && e >= 0 || typeof e == "string";
}
function wh() {
  let { onTelemetry: e } = Lr(), t = Mk(), r = mt((n, i, o) => {
    if (!i || typeof i != "string") return console.warn('botframework-webchat: "name" passed to "useTrackEvent" hook must be a string.');
    if (typeof o < "u") {
      if (yS(o)) {
        if (!Object.values(o).every((a) => pz(a))) return console.warn('botframework-webchat: Every value in "data" map passed to "useTrackEvent" hook must be a non-negative finite number or string.');
      } else if (!pz(o)) return console.warn('botframework-webchat: "data" passed to "useTrackEvent" hook must be a non-negative finite number or string.');
    }
    e && e(V1("event", { data: o, dimensions: t(), level: n, name: i }));
  }, [e, t]);
  return tt(() => {
    let n = r.bind(null, "info");
    return n.debug = r.bind(null, "debug"), n.error = r.bind(null, "error"), n.info = n, n.warn = r.bind(null, "warn"), n;
  }, [r]);
}
var dHe = rl("This hook will be removed on or after 2026-04-03. Please use `useSendMessage` instead.");
function pHe() {
  let { sendFiles: e } = Lr(), t = wh();
  return mt((r) => {
    r && r.length && (dHe(), e(r), t("sendFiles", { numFiles: r.length, sumSizeInKB: Math.round(r.reduce((n, { size: i }) => n + i, 0) / 1024) }));
  }, [e, t]);
}
var hHe = pHe;
function vHe() {
  let { sendMessage: e } = Lr(), t = wh();
  return mt((r, n, { attachments: i, channelData: o } = {}) => {
    t("sendMessage", { numAttachments: (i == null ? void 0 : i.length) || 0, sumSizeInKB: Math.round((i == null ? void 0 : i.reduce((a, { blob: { size: u } }) => a + u, 0)) / 1024) }), e(r, n, { attachments: i, channelData: o });
  }, [e, t]);
}
function EHe() {
  return Lr().sendMessageBack;
}
function mHe() {
  return Lr().sendPostBack;
}
var hz = !0;
function gHe(e) {
  return hz && (console.warn('botframework-webchat: "useSendTimeoutForActivity" is deprecated and will be removed on or after 2022-07-28. Please use "useGetSendTimeoutForActivity()" instead.'), hz = !1), kk()({ activity: e });
}
function THe() {
  return [Ss(({ sendTypingIndicator: e }) => e)];
}
function yHe() {
  return Lr().setNotification;
}
function _He() {
  let { startSpeakingActivity: e, stopSpeakingActivity: t } = Lr();
  return [Ss(({ shouldSpeakIncomingActivity: r }) => r), mt((r) => {
    r ? e() : t();
  }, [e, t])];
}
function AHe() {
  return Lr().startDictate;
}
function SHe() {
  return Lr().stopDictate;
}
function bHe() {
  let [e] = Qfe(), { submitSendBox: t } = Lr(), r = wh(), n = Vo(e);
  return mt((i, { channelData: o } = {}) => {
    let { current: a } = n;
    return r("submitSendBox", { ...i ? { method: i } : {}, numFiles: a.length, sumSizeInKB: Math.round(a.reduce((u, { blob: { size: s } }) => u + s, 0) / 1024) }), t(i, o && { channelData: o });
  }, [n, t, r]);
}
function CHe() {
  let e = Ss(({ suggestedActions: r }) => r), { clearSuggestedActions: t } = Lr();
  return [e, mt((r) => {
    if (r && r.length) throw new Error("SuggestedActions cannot be set to values other than empty.");
    t();
  }, [t])];
}
function IHe() {
  let [{ sendTimeout: e }] = nl();
  return [e];
}
function ede() {
  let { trackDimension: e } = Lr();
  return e;
}
function Fk() {
  let { onTelemetry: e } = Lr(), t = Mk();
  return mt((r, n = !0) => {
    if (!(r instanceof Error)) return console.warn('botframework-webchat: "error" passed to "useTrackException" must be specified and of type Error.');
    e && e(V1("exception", { dimensions: { ...t() }, error: r, fatal: !!n }));
  }, [e, t]);
}
function OHe(e = 5) {
  return Mu().toString(36).substr(2, e);
}
function RHe() {
  let [{ Date: e }] = ac(), { onTelemetry: t } = Lr(), r = Mk(), n = Fk();
  return mt(async (i, o) => {
    if (!i || typeof i != "string") {
      console.warn('botframework-webchat: "name" passed to "useTrackTiming" hook must be specified and of type string.');
      return;
    } else if (typeof o != "function" && typeof o.then != "function") {
      console.warn('botframework-webchat: "functionOrPromise" passed to "useTrackTiming" hook must be specified, of type function or Promise.');
      return;
    }
    let a = OHe();
    t && t(V1("timingstart", { dimensions: r(), name: i, timingId: a }));
    let u = e.now();
    try {
      return await (typeof o == "function" ? o() : o);
    } catch (s) {
      throw n(s, !1), s;
    } finally {
      let s = e.now() - u;
      t && t(V1("timingend", { dimensions: r(), duration: s, name: i, timingId: a }));
    }
  }, [e, t, r, n]);
}
function wHe() {
  return [Lr().userID];
}
function PHe() {
  return [Lr().username];
}
function DHe(e) {
  let t = Lr();
  return mt((r) => t.selectVoice(r, e), [e, t]);
}
function xHe(e) {
  return Object.freeze(e);
}
var NHe = xHe;
function LHe(e, t) {
  if (!e && t || e && !t) return !1;
  let r = new Set(e == null ? void 0 : e.keys()), n = new Set(t == null ? void 0 : t.keys());
  if (r.size !== n.size) return !1;
  for (let i of n) r.add(i);
  if (r.size !== n.size) return !1;
  for (let i of r) if (!Object.is(e.get(i), t.get(i))) return !1;
  return !0;
}
var BHe = -1 / 0, vz = 1 / 0, kHe = ({ children: e }) => {
  let [t] = Ih(), [{ clearTimeout: r, Date: n, setTimeout: i }] = ac(), o = Nk(), a = zfe(), u = kk(), s = Ut(Object.freeze(/* @__PURE__ */ new Map())), c = tt(() => Object.freeze(t.reduce((E, m) => {
    if (m.from.role === "user") {
      let g = a(m);
      if (g) {
        let { channelData: { state: y, "webchat:send-status": _ } } = m, S = _ || (y === "sent" ? "sent" : "sending");
        if (S === "sent") E.set(g, vz);
        else if (S === "send failed") E.set(g, BHe);
        else {
          let A = +new n(m.localTimestamp) + u({ activity: m });
          A && E.set(g, A);
        }
      }
    }
    return E;
  }, /* @__PURE__ */ new Map())), [t, n, a, u]), l = /* @__PURE__ */ new Map(), f = n.now();
  for (let [E, m] of c) l.set(E, m === vz ? "sent" : f >= m ? "send failed" : "sending");
  LHe(s.current, l) || (s.current = Object.freeze(l));
  let { current: d } = s, p = tt(() => NHe([d]), [d]), v = tt(() => ({ sendStatusByActivityKeyState: p }), [p]), h = Array.from(c.values()).reduce((E, m) => m > f && m < E ? m : E, 1 / 0);
  return nr(() => {
    if (h) {
      let E = i(o, h - n.now());
      return () => r(E);
    }
  }, [r, n, o, h, i]), G.createElement(Yfe.Provider, { value: v }, e);
}, MHe = kHe, FHe = () => {
  var i;
  let [e] = Lk(), t = xk(e), r = Xfe(), n = wh();
  if (t) for (let o of e.keys()) {
    let a = e.get(o), u = t.get(o);
    if (a && a !== u) {
      let s = r(o), c = s == null ? void 0 : s.channelData.clientActivityID, l = s == null ? void 0 : s.type, f = { hasAttachment: (s == null ? void 0 : s.type) === "message" && ((i = s.attachments) == null ? void 0 : i.length) > 0 ? "true" : "false", key: o, status: a, ...c ? { clientActivityID: c } : {}, ...l ? { type: l } : {} };
      u && (f.prevStatus = u), n("send-status:change", f);
    }
  }
  return null;
}, HHe = FHe;
function $He(e) {
  switch (e) {
    case "Infinity":
      return 1 / 0;
    case "-Infinity":
      return -1 / 0;
    default:
      return typeof e == "number" ? e : void 0;
  }
}
function UHe() {
  return En(Ufe);
}
function VHe() {
  return UHe().upsertedActivitiesState;
}
function jHe(e, t) {
  let r = Ut(void 0), n = tt(() => e(r.current), t);
  return nr(() => {
    r.current = n;
  }), n;
}
var zHe = Object.freeze([Object.freeze(/* @__PURE__ */ new Map())]);
function qHe(e) {
  return e.type === "typing" && "text" in e && typeof e.text == "string" && e.channelData.streamType !== "informative";
}
var tde = ({ children: e }) => {
  let [{ Date: t }] = ac(), [r] = Ih(), [n] = VHe(), i = Vo(r), o = jHe((u = zHe) => {
    var d, p, v;
    let { current: s } = i, c = new Map(u[0]), l = !1, f = n.reduce((h, E) => Math.min(h, s.indexOf(E)), 1 / 0);
    for (let h of s.slice(f)) {
      let { from: E, from: { id: m, role: g }, type: y } = h;
      if (y === "typing" && (g === "bot" || g === "user")) {
        let _ = c.get(m), S = ((d = h.channelData.webChat) == null ? void 0 : d.receivedAt) || t.now();
        c.set(m, { firstReceivedAt: (_ == null ? void 0 : _.firstReceivedAt) || S, lastActivityDuration: $He((v = (p = h.channelData.webChat) == null ? void 0 : p.styleOptions) == null ? void 0 : v.typingAnimationDuration), lastReceivedAt: S, name: E.name, role: g, type: qHe(h) ? "livestream" : "busy" }), l = !0;
      } else y === "message" && (c.delete(m), l = !0);
    }
    return l ? Object.freeze([c]) : u;
  }, [i, n]), a = tt(() => ({ allTypingState: o }), [o]);
  return G.createElement(Vfe.Provider, { value: a }, e);
};
tde.displayName = "ActivityTypingComposer";
var YHe = Nr(tde), Hk = ({ children: e, ponyfill: t }) => {
  if (Ut(t).current !== t) throw new Error('botframework-webchat: "ponyfill" props cannot be changed after initial render.');
  let r = tt(() => {
    let i = typeof globalThis > "u" ? window : globalThis;
    return { cancelAnimationFrame: (t == null ? void 0 : t.cancelAnimationFrame) || (typeof cancelAnimationFrame == "function" ? cancelAnimationFrame.bind(i) : void 0), cancelIdleCallback: (t == null ? void 0 : t.cancelIdleCallback) || (typeof cancelIdleCallback == "function" ? cancelIdleCallback.bind(i) : void 0), clearImmediate: (t == null ? void 0 : t.clearImmediate) || (typeof clearImmediate == "function" ? clearImmediate.bind(i) : void 0), clearInterval: (t == null ? void 0 : t.clearInterval) || (typeof clearInterval == "function" ? clearInterval.bind(i) : void 0), clearTimeout: (t == null ? void 0 : t.clearTimeout) || (typeof clearTimeout == "function" ? clearTimeout.bind(i) : void 0), Date: (t == null ? void 0 : t.Date) || Date, requestAnimationFrame: (t == null ? void 0 : t.requestAnimationFrame) || (typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(i) : void 0), requestIdleCallback: (t == null ? void 0 : t.requestIdleCallback) || (typeof requestIdleCallback == "function" ? requestIdleCallback.bind(i) : void 0), setImmediate: (t == null ? void 0 : t.setImmediate) || (typeof setImmediate == "function" ? setImmediate.bind(i) : void 0), setInterval: (t == null ? void 0 : t.setInterval) || (typeof setInterval == "function" ? setInterval.bind(i) : void 0), setTimeout: (t == null ? void 0 : t.setTimeout) || (typeof setTimeout == "function" ? setTimeout.bind(i) : void 0) };
  }, [t]), n = tt(() => ({ ponyfillState: Object.freeze([r]) }), [r]);
  return G.createElement(Lfe.Provider, { value: n }, e);
};
Hk.defaultProps = { ponyfill: void 0 };
Hk.propTypes = { ponyfill: Q.any };
var GHe = Hk;
function WHe(e, t) {
  return Object.entries(e).reduce((r, [n, i]) => (ia(n) || (r[n] = t(i, n)), r), {});
}
function KHe(e) {
  return e = e.toLowerCase(), e === "ar-eg" ? "ar-EG" : e === "ar-jo" ? "ar-JO" : e.startsWith("ar") ? "ar-SA" : e.startsWith("bg") ? "bg-BG" : e.startsWith("ca") ? "ca-ES" : e.startsWith("cs") ? "cs-CZ" : e.startsWith("da") ? "da-DK" : e.startsWith("de") ? "de-DE" : e.startsWith("el") ? "el-GR" : e.startsWith("es") ? "es-ES" : e.startsWith("et") ? "et-EE" : e.startsWith("eu") ? "eu-ES" : e.startsWith("fi") ? "fi-FI" : e.startsWith("fr") ? "fr-FR" : e.startsWith("gl") ? "gl-ES" : e.startsWith("he") ? "he-IL" : e.startsWith("hi") ? "hi-IN" : e.startsWith("hr") ? "hr-HR" : e.startsWith("hu") ? "hu-HU" : e.startsWith("id") ? "id-ID" : e.startsWith("it") ? "it-IT" : e.startsWith("ja") ? "ja-JP" : e.startsWith("kk") ? "kk-KZ" : e.startsWith("ko") ? "ko-KR" : e.startsWith("lt") ? "lt-LT" : e.startsWith("lv") ? "lv-LV" : e.startsWith("ms") ? "ms-MY" : e.startsWith("nb") || e.startsWith("nn") || e.startsWith("no") ? "nb-NO" : e.startsWith("nl") ? "nl-NL" : e.startsWith("pl") ? "pl-PL" : e === "pt-br" ? "pt-BR" : e.startsWith("pt") ? "pt-PT" : e.startsWith("ro") ? "ro-RO" : e.startsWith("ru") ? "ru-RU" : e.startsWith("sk") ? "sk-SK" : e.startsWith("sl") ? "sl-SI" : e.startsWith("sr-cyrl") ? "sr-Cyrl" : e.startsWith("sr-latn") ? "sr-Latn" : e.startsWith("sv") ? "sv-SE" : e.startsWith("th") ? "th-TH" : e.startsWith("tr") ? "tr-TR" : e.startsWith("uk") ? "uk-UA" : e.startsWith("vi") ? "vi-VN" : e.startsWith("yue") || e === "zh-yue" ? (e === "zh-yue" && console.warn('botframework-webchat: The locale "zh-YUE" is being renamed to "yue" and deprecated. It will be removed on or after 2022-02-12.'), "yue") : e === "zh-hant" || e === "zh-tw" ? "zh-Hant" : e === "zh-hant-hk" || e === "zh-hk" ? "zh-Hant-HK" : e === "zh-hant-mo" || e === "zh-mo" ? "zh-Hant-MO" : e === "zh-hans-sg" || e === "zh-sg" ? "zh-Hans-SG" : e.startsWith("zh") ? "zh-Hans" : "en-US";
}
var rde = Tfe, { initMiddleware: Ez, Provider: XHe, Proxy: JHe, types: XPr } = rde("sendBoxMiddleware"), { initMiddleware: mz, Provider: ZHe, Proxy: QHe, types: JPr } = rde("sendBoxToolbarMiddleware");
function e$e() {
  let [e] = Bk(), t = ede(), r = wh();
  nr(() => {
    t("prop:locale", e);
  }, [e, t]), nr(() => {
    r("init");
  }, [r]);
}
var t$e = e$e, r$e = () => (t$e(), null), n$e = r$e;
function i$e({ language: e }, t, r) {
  return [r.locale, e, window.navigator.language, "en-US"].reduce((n, i) => n || t.find(({ lang: o, name: a }) => o === i && /neural/iu.test(a)) || t.find(({ lang: o }) => o === i), null) || t[0];
}
function o$e() {
  let { internalErrorBoxClass: e } = Lr();
  return [e];
}
var $k = ({ error: e, type: t }) => {
  let [r] = o$e(), n = Fk();
  return nr(() => {
    n(e, !1);
  }, [e, n]), nr(() => {
    console.group(`botframework-webchat: ${t}`), console.error(e), console.groupEnd();
  }, [e, t]), !!r && xIe(r, { error: e, type: t });
};
$k.defaultProps = { type: void 0 };
$k.propTypes = { error: Q.any.isRequired, type: Q.string };
var T1 = $k;
function tC(...e) {
  return (t) => {
    let r = e.reduce((n, i) => i ? [...n, i(t)] : n, []);
    return (n) => {
      let i = r.slice(), o = (a) => (...u) => {
        let s = i[+a];
        return (s ? s(o(a + 1)) : n)(...u);
      };
      return o(0);
    };
  };
}
var a$e = ({ children: e }) => typeof e == "function" ? e() : e, Uk = class extends DIe {
  constructor() {
    super(), this.state = { hasError: !1 };
  }
  componentDidCatch(e) {
    let { onError: t } = this.props;
    this.setState({ hasError: !0 }), t(e);
  }
  render() {
    let { children: e } = this.props, { hasError: t } = this.state;
    return !t && G.createElement(a$e, null, e);
  }
};
Uk.defaultProps = { children: void 0, onError: void 0 };
Uk.propTypes = { children: Q.any, onError: Q.func };
var nde = Uk, Vk = ({ children: e, type: t }) => {
  let [r, n] = cn(), i = mt((o) => n(o), []);
  return r ? G.createElement(T1, { error: r, type: t }) : G.createElement(nde, { onError: i }, e);
};
Vk.defaultProps = { children: void 0, type: void 0 };
Vk.propTypes = { children: Q.any, type: Q.string };
var mL = Vk;
function ide(e, ...t) {
  return (...r) => tC(...t)(...r)(() => {
    throw new Error(`reached terminator of ${e}`);
  });
}
function u$e(e, ...t) {
  return (...r) => {
    let n = tC(...t)(...r)(() => {
      throw new Error(`reached terminator of ${e}`);
    });
    return (...i) => G.createElement(mL, { type: `render of ${e}` }, () => {
      try {
        return n(...i);
      } catch (o) {
        return G.createElement(T1, { error: o, type: `render of ${e}` });
      }
    });
  };
}
function R0(e, { strict: t = !1 } = {}, ...r) {
  return (...n) => {
    let i = tC(...r)(...n)(() => G.createElement(T1, { error: new Error(`reached terminator of ${e}`), type: e }));
    return (...o) => {
      try {
        let a = i(...o);
        if (a) {
          if (cS(a)) return t ? (console.error(`botframework-webchat: ${e} should only return either false or a render function.`), !1) : G.createElement(mL, { type: `render of ${e}` }, a);
        } else return !1;
        return (...u) => G.createElement(mL, { type: `render of ${e}` }, () => {
          try {
            let s = a(...u);
            return t && !cS(s) && console.error(`botframework-webchat: ${e} should return React element only.`), s;
          } catch (s) {
            return G.createElement(T1, { error: s, type: `render of ${e}` });
          }
        });
      } catch (a) {
        return G.createElement(T1, { error: a, type: `render of ${e}` });
      }
    };
  };
}
function s$e() {
  return ({ dispatch: e }) => (t) => (...r) => {
    let [{ cardAction: n, cardAction: { value: i } }] = r;
    switch (n.type) {
      case "imBack":
        if (typeof i == "string") e(pk(i, "imBack"));
        else throw new Error('cannot send "imBack" with a non-string value');
        break;
      case "messageBack":
        e(M0e(i, n.text, n.displayText));
        break;
      case "postBack":
        e(H0e(i));
        break;
      default:
        return t(...r);
    }
  };
}
function gz(e, t) {
  let r, n = [], i;
  return e.forEach((o) => {
    i && t(i, o) ? r.push(o) : (r = [o], n.push(r)), i = o;
  }), n;
}
function Tz(e) {
  if (e.from.role === "user") {
    let { channelData: { state: t, "webchat:send-status": r } } = e;
    return r || (t === "sent" ? "sent" : "sending");
  }
}
function c$e(e, t, r, { Date: n }) {
  if (r === !1) return !0;
  if (e && t) {
    if (Tz(e) !== Tz(t)) return !1;
    r = typeof r == "number" ? r : 1 / 0;
    let i = new n(e.timestamp).getTime(), o = new n(t.timestamp).getTime();
    return Math.abs(i - o) <= r;
  }
  return !1;
}
function l$e({ groupTimestamp: e, ponyfill: t }) {
  return () => () => ({ activities: r }) => ({ sender: gz(r, (n, i) => n.from.role === i.from.role), status: gz(r, (n, i) => c$e(n, i, e, t)) });
}
function f$e(e, { setTimeout: t }) {
  return new Promise((r, n) => {
    let i = e.subscribe((o) => {
      r(o), t(() => i.unsubscribe(), 0);
    }, (o) => {
      n(o), t(() => i.unsubscribe(), 0);
    });
  });
}
var b = bh(Ch());
bh(Jb());
bh(Dk());
bh(OMe());
bh(RMe());
bh(wMe());
var yt = b.default._numberRound, _t = b.default._numberToPartsFormatterFn, At = b.default._numberFormatterFn, Tr = b.default._pluralGeneratorFn, yr = b.default._dateToPartsFormatterFn, _r = b.default._dateFormatterFn, Ft = b.default._relativeTimeFormatterFn, ft = b.default._unitFormatterFn;
b.default.a1941952454 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.a71314638 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.b1800711952 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.a311225754 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.a1058394490 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.b1405444964 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "ليس رقم", { ".": "٫", ",": "٬", "%": "٪؜", "+": "؜+", "-": "؜-", E: "اس", "‰": "؉" }, "٠١٢٣٤٥٦٧٨٩"]);
b.default.b162621629 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b745972495 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1541980371 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a83314634 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1711882934 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1565068396 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b426806024 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b345754148 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1581691774 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1590866443 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2072550185 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1593697547 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b431368057 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b487177171 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1597391631 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1832240673 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a965216723 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a1632485429 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a821123423 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b314646955 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1634332471 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1706669702 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1366822502 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1638950076 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2082738969 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a140729307 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a1639873597 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a1577180344 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a1648281116 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a1640797118 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a561501061 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "epäluku", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a226994415 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "epäluku", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a1658344017 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "epäluku", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a306440732 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a910058808 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1666655706 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a552376995 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b55851631 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1689743731 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1303871883 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "‎+", "-": "‎-", E: "E", "‰": "‰" }]);
b.default.a1765653417 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "‎+", "-": "‎-", E: "E", "‰": "‰" }]);
b.default.a1711908235 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "‎+", "-": "‎-", E: "E", "‰": "‰" }]);
b.default.b718362617 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b794073939 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1715602319 = _t(["", , 1, 0, 3, , , , 3, 2, "", "#,##,##0.###", "-#,##,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b973422946 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b111009546 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1723914008 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1804868475 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a116678585 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1726684571 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b977984979 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b252432569 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1739613865 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b476988387 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1901407401 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1754390201 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2046242705 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b990654877 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1765472453 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1501791736 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "сан емес", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a689427148 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "сан емес", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1803336814 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "сан емес", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a770941060 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1870300208 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1807030898 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b249300256 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a861957364 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a1840277654 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.b1260417506 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NS", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b417906314 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NS", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1842124696 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NS", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1763810178 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1156128622 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1867983284 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1019043276 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.b1525239776 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.a1880912578 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "E", "‰": "‰" }]);
b.default.b1779662230 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a665376426 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1890147788 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1235441388 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b355691928 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1947406090 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1485939684 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1180179344 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1954794258 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b296705673 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b607610563 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a669821983 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1561098165 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1149072151 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2007434955 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b299482619 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "не число", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b693695889 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "не число", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2012976081 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "не число", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1968688144 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a900121028 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a2032370022 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "e", "‰": "‰" }]);
b.default.a1463129519 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "e", "‰": "‰" }]);
b.default.b1887294459 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "e", "‰": "‰" }]);
b.default.a2033293543 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "−", E: "e", "‰": "‰" }]);
b.default.a1435181062 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1541270670 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a985776304 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2101971175 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a736927693 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b274946385 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a702510565 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a303321743 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a2042528753 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "−", E: "×10^", "‰": "‰" }]);
b.default.a697948532 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a161898720 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2058228610 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b62670422 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1942452374 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2067463820 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a688824466 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "Е", "‰": "‰" }]);
b.default.b120947326 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "Е", "‰": "‰" }]);
b.default.a2089628324 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": " ", "%": "%", "+": "+", "-": "-", E: "Е", "‰": "‰" }]);
b.default.b1087473771 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a648382175 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a2116410433 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ",", ",": ".", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1418994715 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1039493913 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b96411397 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b711487865 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b580956627 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b847000305 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1759276636 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1297329840 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a876307794 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "NaN", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1217046490 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a926595182 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b846076784 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1831402154 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b938561218 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1987075744 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b610844905 = _t(["", , 1, 0, 0, , , , , , "", "0", "-0", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1755992163 = _t(["", , 2, 0, 0, , , , , , "", "00", "-00", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.b1840235905 = _t(["", , 1, 0, 3, , , , 3, , "", "#,##0.###", "-#,##0.###", "-", "", yt(), "∞", "非數值", { ".": ".", ",": ",", "%": "%", "+": "+", "-": "-", E: "E", "‰": "‰" }]);
b.default.a1038316025 = At((0, b.default)("ar-EG").numberToPartsFormatter({ raw: "0" }));
b.default.a2123356411 = At((0, b.default)("ar-EG").numberToPartsFormatter({ raw: "00" }));
b.default.b1798381219 = At((0, b.default)("ar-EG").numberToPartsFormatter({}));
b.default.b592410675 = At((0, b.default)("ar-SA").numberToPartsFormatter({ raw: "0" }));
b.default.b1184531033 = At((0, b.default)("ar-SA").numberToPartsFormatter({ raw: "00" }));
b.default.b1403114231 = At((0, b.default)("ar-SA").numberToPartsFormatter({}));
b.default.a395141616 = At((0, b.default)("bg").numberToPartsFormatter({ raw: "0" }));
b.default.b635181084 = At((0, b.default)("bg").numberToPartsFormatter({ raw: "00" }));
b.default.b560738426 = At((0, b.default)("bg").numberToPartsFormatter({}));
b.default.a641077879 = At((0, b.default)("ca").numberToPartsFormatter({ raw: "0" }));
b.default.b1601091523 = At((0, b.default)("ca").numberToPartsFormatter({ raw: "00" }));
b.default.b537650401 = At((0, b.default)("ca").numberToPartsFormatter({}));
b.default.a130957221 = At((0, b.default)("cs").numberToPartsFormatter({ raw: "0" }));
b.default.b234962737 = At((0, b.default)("cs").numberToPartsFormatter({ raw: "00" }));
b.default.b521027023 = At((0, b.default)("cs").numberToPartsFormatter({}));
b.default.b2146337608 = At((0, b.default)("da").numberToPartsFormatter({ raw: "0" }));
b.default.b2111625700 = At((0, b.default)("da").numberToPartsFormatter({ raw: "00" }));
b.default.b509021250 = At((0, b.default)("da").numberToPartsFormatter({}));
b.default.a126395188 = At((0, b.default)("de").numberToPartsFormatter({ raw: "0" }));
b.default.b376385760 = At((0, b.default)("de").numberToPartsFormatter({ raw: "00" }));
b.default.b505327166 = At((0, b.default)("de").numberToPartsFormatter({}));
b.default.b1904963378 = At((0, b.default)("el").numberToPartsFormatter({ raw: "0" }));
b.default.a1076008134 = At((0, b.default)("el").numberToPartsFormatter({ raw: "00" }));
b.default.b470233368 = At((0, b.default)("el").numberToPartsFormatter({}));
b.default.a1378886668 = At((0, b.default)("en").numberToPartsFormatter({ raw: "0" }));
b.default.b203855544 = At((0, b.default)("en").numberToPartsFormatter({ raw: "00" }));
b.default.b468386326 = At((0, b.default)("en").numberToPartsFormatter({}));
b.default.b1148906457 = At((0, b.default)("es").numberToPartsFormatter({ raw: "0" }));
b.default.b1256031091 = At((0, b.default)("es").numberToPartsFormatter({ raw: "00" }));
b.default.b463768721 = At((0, b.default)("es").numberToPartsFormatter({}));
b.default.b1654465082 = At((0, b.default)("et").numberToPartsFormatter({ raw: "0" }));
b.default.a251520718 = At((0, b.default)("et").numberToPartsFormatter({ raw: "00" }));
b.default.b462845200 = At((0, b.default)("et").numberToPartsFormatter({}));
b.default.a2134943589 = At((0, b.default)("eu").numberToPartsFormatter({ raw: "0" }));
b.default.a1759072527 = At((0, b.default)("eu").numberToPartsFormatter({ raw: "00" }));
b.default.b461921679 = At((0, b.default)("eu").numberToPartsFormatter({}));
b.default.a1119264306 = At((0, b.default)("fi").numberToPartsFormatter({ raw: "0" }));
b.default.a337785826 = At((0, b.default)("fi").numberToPartsFormatter({ raw: "00" }));
b.default.b444374780 = At((0, b.default)("fi").numberToPartsFormatter({}));
b.default.a864203977 = At((0, b.default)("fr").numberToPartsFormatter({ raw: "0" }));
b.default.a1020850219 = At((0, b.default)("fr").numberToPartsFormatter({ raw: "00" }));
b.default.b436063091 = At((0, b.default)("fr").numberToPartsFormatter({}));
b.default.a1110140240 = At((0, b.default)("gl").numberToPartsFormatter({ raw: "0" }));
b.default.a54939780 = At((0, b.default)("gl").numberToPartsFormatter({ raw: "00" }));
b.default.b412975066 = At((0, b.default)("gl").numberToPartsFormatter({}));
b.default.a1861635128 = At((0, b.default)("he").numberToPartsFormatter({ raw: "0" }));
b.default.a1876444828 = At((0, b.default)("he").numberToPartsFormatter({ raw: "00" }));
b.default.b390810562 = At((0, b.default)("he").numberToPartsFormatter({}));
b.default.b160599372 = At((0, b.default)("hi").numberToPartsFormatter({ raw: "0" }));
b.default.b683282528 = At((0, b.default)("hi").numberToPartsFormatter({ raw: "00" }));
b.default.b387116478 = At((0, b.default)("hi").numberToPartsFormatter({}));
b.default.b415659701 = At((0, b.default)("hr").numberToPartsFormatter({ raw: "0" }));
b.default.b218135 = At((0, b.default)("hr").numberToPartsFormatter({ raw: "00" }));
b.default.b378804789 = At((0, b.default)("hr").numberToPartsFormatter({}));
b.default.b1932335576 = At((0, b.default)("hu").numberToPartsFormatter({ raw: "0" }));
b.default.a227469996 = At((0, b.default)("hu").numberToPartsFormatter({ raw: "00" }));
b.default.b376034226 = At((0, b.default)("hu").numberToPartsFormatter({}));
b.default.b420221734 = At((0, b.default)("id").numberToPartsFormatter({ raw: "0" }));
b.default.b141641158 = At((0, b.default)("id").numberToPartsFormatter({ raw: "00" }));
b.default.b363104932 = At((0, b.default)("id").numberToPartsFormatter({}));
b.default.a80774858 = At((0, b.default)("it").numberToPartsFormatter({ raw: "0" }));
b.default.b1790615990 = At((0, b.default)("it").numberToPartsFormatter({ raw: "00" }));
b.default.b348328596 = At((0, b.default)("it").numberToPartsFormatter({}));
b.default.b1690961346 = At((0, b.default)("ja").numberToPartsFormatter({ raw: "0" }));
b.default.b879863466 = At((0, b.default)("ja").numberToPartsFormatter({ raw: "00" }));
b.default.b337246344 = At((0, b.default)("ja").numberToPartsFormatter({}));
b.default.b944028491 = At((0, b.default)("kk").numberToPartsFormatter({ raw: "0" }));
b.default.a800218559 = At((0, b.default)("kk").numberToPartsFormatter({ raw: "00" }));
b.default.b299381983 = At((0, b.default)("kk").numberToPartsFormatter({}));
b.default.a1328704305 = At((0, b.default)("ko").numberToPartsFormatter({ raw: "0" }));
b.default.b1759508797 = At((0, b.default)("ko").numberToPartsFormatter({ raw: "00" }));
b.default.b295687899 = At((0, b.default)("ko").numberToPartsFormatter({}));
b.default.a308462989 = At((0, b.default)("lt").numberToPartsFormatter({ raw: "0" }));
b.default.a972748775 = At((0, b.default)("lt").numberToPartsFormatter({ raw: "00" }));
b.default.b262441143 = At((0, b.default)("lt").numberToPartsFormatter({}));
b.default.b702654261 = At((0, b.default)("lv").numberToPartsFormatter({ raw: "0" }));
b.default.b307114903 = At((0, b.default)("lv").numberToPartsFormatter({ raw: "00" }));
b.default.b260594101 = At((0, b.default)("lv").numberToPartsFormatter({}));
b.default.b1973393873 = At((0, b.default)("ms").numberToPartsFormatter({ raw: "0" }));
b.default.b1045337211 = At((0, b.default)("ms").numberToPartsFormatter({ raw: "00" }));
b.default.b234735513 = At((0, b.default)("ms").numberToPartsFormatter({}));
b.default.b461280031 = At((0, b.default)("nb").numberToPartsFormatter({ raw: "0" }));
b.default.b1414448365 = At((0, b.default)("nb").numberToPartsFormatter({ raw: "00" }));
b.default.b221806219 = At((0, b.default)("nb").numberToPartsFormatter({}));
b.default.b1221898985 = At((0, b.default)("nl").numberToPartsFormatter({ raw: "0" }));
b.default.a776167837 = At((0, b.default)("nl").numberToPartsFormatter({ raw: "00" }));
b.default.b212571009 = At((0, b.default)("nl").numberToPartsFormatter({}));
b.default.a1793204633 = At((0, b.default)("pl").numberToPartsFormatter({ raw: "0" }));
b.default.b244900517 = At((0, b.default)("pl").numberToPartsFormatter({ raw: "00" }));
b.default.b155312707 = At((0, b.default)("pl").numberToPartsFormatter({}));
b.default.a2043702929 = At((0, b.default)("pt").numberToPartsFormatter({ raw: "0" }));
b.default.b1069387933 = At((0, b.default)("pt").numberToPartsFormatter({ raw: "00" }));
b.default.b147924539 = At((0, b.default)("pt").numberToPartsFormatter({}));
b.default.b1200342102 = At((0, b.default)("pt-PT").numberToPartsFormatter({ raw: "0" }));
b.default.a1444431210 = At((0, b.default)("pt-PT").numberToPartsFormatter({ raw: "00" }));
b.default.a672152716 = At((0, b.default)("pt-PT").numberToPartsFormatter({}));
b.default.b1003334920 = At((0, b.default)("ro").numberToPartsFormatter({ raw: "0" }));
b.default.b1038280740 = At((0, b.default)("ro").numberToPartsFormatter({ raw: "00" }));
b.default.b95283842 = At((0, b.default)("ro").numberToPartsFormatter({}));
b.default.a258280626 = At((0, b.default)("ru").numberToPartsFormatter({ raw: "0" }));
b.default.b582904478 = At((0, b.default)("ru").numberToPartsFormatter({ raw: "00" }));
b.default.b89742716 = At((0, b.default)("ru").numberToPartsFormatter({}));
b.default.b1768515907 = At((0, b.default)("sk").numberToPartsFormatter({ raw: "0" }));
b.default.a1010912439 = At((0, b.default)("sk").numberToPartsFormatter({ raw: "00" }));
b.default.b70348775 = At((0, b.default)("sk").numberToPartsFormatter({}));
b.default.a2020892764 = At((0, b.default)("sl").numberToPartsFormatter({ raw: "0" }));
b.default.b1776503048 = At((0, b.default)("sl").numberToPartsFormatter({ raw: "00" }));
b.default.b69425254 = At((0, b.default)("sl").numberToPartsFormatter({}));
b.default.a623966585 = At((0, b.default)("sr-Cyrl").numberToPartsFormatter({ raw: "0" }));
b.default.b2131541637 = At((0, b.default)("sr-Cyrl").numberToPartsFormatter({ raw: "00" }));
b.default.b1069356579 = At((0, b.default)("sr-Cyrl").numberToPartsFormatter({}));
b.default.a1290756698 = At((0, b.default)("sr-Latn").numberToPartsFormatter({ raw: "0" }));
b.default.a1359082682 = At((0, b.default)("sr-Latn").numberToPartsFormatter({ raw: "00" }));
b.default.a1964888028 = At((0, b.default)("sr-Latn").numberToPartsFormatter({}));
b.default.a1260273810 = At((0, b.default)("sv").numberToPartsFormatter({ raw: "0" }));
b.default.a414113154 = At((0, b.default)("sv").numberToPartsFormatter({ raw: "00" }));
b.default.b60190044 = At((0, b.default)("sv").numberToPartsFormatter({}));
b.default.a1255711777 = At((0, b.default)("th").numberToPartsFormatter({ raw: "0" }));
b.default.a272690131 = At((0, b.default)("th").numberToPartsFormatter({ raw: "00" }));
b.default.b44490187 = At((0, b.default)("th").numberToPartsFormatter({}));
b.default.a495092823 = At((0, b.default)("tr").numberToPartsFormatter({ raw: "0" }));
b.default.b1831660963 = At((0, b.default)("tr").numberToPartsFormatter({ raw: "00" }));
b.default.b35254977 = At((0, b.default)("tr").numberToPartsFormatter({}));
b.default.a1246587711 = At((0, b.default)("uk").numberToPartsFormatter({ raw: "0" }));
b.default.b10155915 = At((0, b.default)("uk").numberToPartsFormatter({ raw: "00" }));
b.default.b13090473 = At((0, b.default)("uk").numberToPartsFormatter({}));
b.default.b529710526 = At((0, b.default)("vi").numberToPartsFormatter({ raw: "0" }));
b.default.a759173586 = At((0, b.default)("vi").numberToPartsFormatter({ raw: "00" }));
b.default.a13691636 = At((0, b.default)("vi").numberToPartsFormatter({}));
b.default.a1529786126 = At((0, b.default)("yue").numberToPartsFormatter({ raw: "0" }));
b.default.a179060358 = At((0, b.default)("yue").numberToPartsFormatter({ raw: "00" }));
b.default.b856184664 = At((0, b.default)("yue").numberToPartsFormatter({}));
b.default.b1522702342 = At((0, b.default)("zh-Hans").numberToPartsFormatter({ raw: "0" }));
b.default.a41198362 = At((0, b.default)("zh-Hans").numberToPartsFormatter({ raw: "00" }));
b.default.a1392834108 = At((0, b.default)("zh-Hans").numberToPartsFormatter({}));
b.default.b868786351 = At((0, b.default)("zh-Hans-SG").numberToPartsFormatter({ raw: "0" }));
b.default.b1162242397 = At((0, b.default)("zh-Hans-SG").numberToPartsFormatter({ raw: "00" }));
b.default.a1171394821 = At((0, b.default)("zh-Hans-SG").numberToPartsFormatter({}));
b.default.b2028260967 = At((0, b.default)("zh-Hant").numberToPartsFormatter({ raw: "0" }));
b.default.a1548750171 = At((0, b.default)("zh-Hant").numberToPartsFormatter({ raw: "00" }));
b.default.a1393757629 = At((0, b.default)("zh-Hant").numberToPartsFormatter({}));
b.default.b940911869 = At((0, b.default)("zh-Hant-HK").numberToPartsFormatter({ raw: "0" }));
b.default.a896833841 = At((0, b.default)("zh-Hant-HK").numberToPartsFormatter({ raw: "00" }));
b.default.b1691988717 = At((0, b.default)("zh-Hant-HK").numberToPartsFormatter({}));
b.default.a279645380 = At((0, b.default)("zh-Hant-MO").numberToPartsFormatter({ raw: "0" }));
b.default.a79402896 = At((0, b.default)("zh-Hant-MO").numberToPartsFormatter({ raw: "00" }));
b.default.b1545148878 = At((0, b.default)("zh-Hant-MO").numberToPartsFormatter({}));
b.default.b469273361 = Tr(function(e) {
  var t = String(e).split("."), r = Number(t[0]) == e, n = r && t[0].slice(-2);
  return e == 0 ? "zero" : e == 1 ? "one" : e == 2 ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
});
b.default.b74006373 = Tr(function(e) {
  var t = String(e).split("."), r = Number(t[0]) == e, n = r && t[0].slice(-2);
  return e == 0 ? "zero" : e == 1 ? "one" : e == 2 ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
});
b.default.a1569994036 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1593082061 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1609705439 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1];
  return e == 1 && n ? "one" : r >= 2 && r <= 4 && n ? "few" : n ? "other" : "many";
});
b.default.a1621711212 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = Number(t[0]) == e;
  return e == 1 || !n && (r == 0 || r == 1) ? "one" : "other";
});
b.default.a1625405296 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1660499094 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1662346136 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1666963741 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1667887262 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1668810783 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1686357682 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1694669371 = Tr(function(e) {
  return e >= 0 && e < 2 ? "one" : "other";
});
b.default.a1717757396 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1739921900 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1], i = Number(t[0]) == e, o = i && t[0].slice(-1);
  return e == 1 && n ? "one" : r == 2 && n ? "two" : n && (e < 0 || e > 10) && i && o == 0 ? "many" : "other";
});
b.default.a1743615984 = Tr(function(e) {
  return e >= 0 && e <= 1 ? "one" : "other";
});
b.default.a1751927673 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = t[1] || "", i = !t[1], o = r.slice(-1), a = r.slice(-2), u = n.slice(-1), s = n.slice(-2);
  return i && o == 1 && a != 11 || u == 1 && s != 11 ? "one" : i && o >= 2 && o <= 4 && (a < 12 || a > 14) || u >= 2 && u <= 4 && (s < 12 || s > 14) ? "few" : "other";
});
b.default.a1754698236 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1767627530 = Tr(function(e) {
  return "other";
});
b.default.a1782403866 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1793486118 = Tr(function(e) {
  return "other";
});
b.default.a1831350479 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1835044563 = Tr(function(e) {
  return "other";
});
b.default.a1868291319 = Tr(function(e) {
  var t = String(e).split("."), r = t[1] || "", n = Number(t[0]) == e, i = n && t[0].slice(-1), o = n && t[0].slice(-2);
  return i == 1 && (o < 11 || o > 19) ? "one" : i >= 2 && i <= 9 && (o < 11 || o > 19) ? "few" : r != 0 ? "many" : "other";
});
b.default.a1870138361 = Tr(function(e) {
  var t = String(e).split("."), r = t[1] || "", n = r.length, i = Number(t[0]) == e, o = i && t[0].slice(-1), a = i && t[0].slice(-2), u = r.slice(-2), s = r.slice(-1);
  return i && o == 0 || a >= 11 && a <= 19 || n == 2 && u >= 11 && u <= 19 ? "zero" : o == 1 && a != 11 || n == 2 && s == 1 && u != 11 || n != 2 && s == 1 ? "one" : "other";
});
b.default.a1895996949 = Tr(function(e) {
  return "other";
});
b.default.a1908926243 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a1918161453 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a1975419755 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1], i = r.slice(-1), o = r.slice(-2);
  return e == 1 && n ? "one" : n && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : n && r != 1 && (i == 0 || i == 1) || n && i >= 5 && i <= 9 || n && o >= 12 && o <= 14 ? "many" : "other";
});
b.default.a1982807923 = Tr(function(e) {
  var t = String(e).split("."), r = t[0];
  return r == 0 || r == 1 ? "one" : "other";
});
b.default.a2001260574 = Tr(function(e) {
  var t = String(e).split("."), r = t[0];
  return r == 0 || r == 1 ? "one" : "other";
});
b.default.a2035448620 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1], n = Number(t[0]) == e, i = n && t[0].slice(-2);
  return e == 1 && r ? "one" : !r || e == 0 || i >= 2 && i <= 19 ? "few" : "other";
});
b.default.a2040989746 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1], i = r.slice(-1), o = r.slice(-2);
  return n && i == 1 && o != 11 ? "one" : n && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : n && i == 0 || n && i >= 5 && i <= 9 || n && o >= 11 && o <= 14 ? "many" : "other";
});
b.default.a2060383687 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1];
  return e == 1 && n ? "one" : r >= 2 && r <= 4 && n ? "few" : n ? "other" : "many";
});
b.default.a2061307208 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1], i = r.slice(-2);
  return n && i == 1 ? "one" : n && i == 2 ? "two" : n && (i == 3 || i == 4) || !n ? "few" : "other";
});
b.default.a598008047 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = t[1] || "", i = !t[1], o = r.slice(-1), a = r.slice(-2), u = n.slice(-1), s = n.slice(-2);
  return i && o == 1 && a != 11 || u == 1 && s != 11 ? "one" : i && o >= 2 && o <= 4 && (a < 12 || a > 14) || u >= 2 && u <= 4 && (s < 12 || s > 14) ? "few" : "other";
});
b.default.b662714642 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = t[1] || "", i = !t[1], o = r.slice(-1), a = r.slice(-2), u = n.slice(-1), s = n.slice(-2);
  return i && o == 1 && a != 11 || u == 1 && s != 11 ? "one" : i && o >= 2 && o <= 4 && (a < 12 || a > 14) || u >= 2 && u <= 4 && (s < 12 || s > 14) ? "few" : "other";
});
b.default.a2070542418 = Tr(function(e) {
  var t = String(e).split("."), r = !t[1];
  return e == 1 && r ? "one" : "other";
});
b.default.a2086242275 = Tr(function(e) {
  return "other";
});
b.default.a2095477485 = Tr(function(e) {
  return e == 1 ? "one" : "other";
});
b.default.a2117641989 = Tr(function(e) {
  var t = String(e).split("."), r = t[0], n = !t[1], i = r.slice(-1), o = r.slice(-2);
  return n && i == 1 && o != 11 ? "one" : n && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : n && i == 0 || n && i >= 5 && i <= 9 || n && o >= 11 && o <= 14 ? "many" : "other";
});
b.default.a2144424098 = Tr(function(e) {
  return "other";
});
b.default.a772012218 = Tr(function(e) {
  return "other";
});
b.default.b1234768562 = Tr(function(e) {
  return "other";
});
b.default.b1960777549 = Tr(function(e) {
  return "other";
});
b.default.b1233845041 = Tr(function(e) {
  return "other";
});
b.default.b529193791 = Tr(function(e) {
  return "other";
});
b.default.b382353952 = Tr(function(e) {
  return "other";
});
b.default.a1178402495 = yr({ 1: (0, b.default)("ar-EG").numberFormatter({ raw: "0" }), 2: (0, b.default)("ar-EG").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "يناير", 2: "فبراير", 3: "مارس", 4: "أبريل", 5: "مايو", 6: "يونيو", 7: "يوليو", 8: "أغسطس", 9: "سبتمبر", 10: "أكتوبر", 11: "نوفمبر", 12: "ديسمبر" } } }, dayPeriods: { am: "ص", pm: "م" } });
b.default.a1191033963 = yr({ 1: (0, b.default)("ar-SA").numberFormatter({ raw: "0" }), 2: (0, b.default)("ar-SA").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "يناير", 2: "فبراير", 3: "مارس", 4: "أبريل", 5: "مايو", 6: "يونيو", 7: "يوليو", 8: "أغسطس", 9: "سبتمبر", 10: "أكتوبر", 11: "نوفمبر", 12: "ديسمبر" } } }, dayPeriods: { am: "ص", pm: "م" } });
b.default.b474539636 = yr({ 1: (0, b.default)("bg").numberFormatter({ raw: "0" }), 2: (0, b.default)("bg").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "януари", 2: "февруари", 3: "март", 4: "април", 5: "май", 6: "юни", 7: "юли", 8: "август", 9: "септември", 10: "октомври", 11: "ноември", 12: "декември" } } }, dayPeriods: { am: "пр.об.", pm: "сл.об." } });
b.default.b865165659 = yr({ 1: (0, b.default)("ca").numberFormatter({ raw: "0" }), 2: (0, b.default)("ca").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM 'a' 'les' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "de gener", 2: "de febrer", 3: "de març", 4: "d’abril", 5: "de maig", 6: "de juny", 7: "de juliol", 8: "d’agost", 9: "de setembre", 10: "d’octubre", 11: "de novembre", 12: "de desembre" } } }, dayPeriods: { am: "a. m.", pm: "p. m." } });
b.default.a399771831 = yr({ 1: (0, b.default)("cs").numberFormatter({ raw: "0" }), 2: (0, b.default)("cs").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "ledna", 2: "února", 3: "března", 4: "dubna", 5: "května", 6: "června", 7: "července", 8: "srpna", 9: "září", 10: "října", 11: "listopadu", 12: "prosince" } } }, dayPeriods: { am: "dop.", pm: "odp." } });
b.default.b834145852 = yr({ 1: (0, b.default)("da").numberFormatter({ raw: "0" }), 2: (0, b.default)("da").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM 'kl'. h.mm a", timeSeparator: ".", months: { M: { 4: { 1: "januar", 2: "februar", 3: "marts", 4: "april", 5: "maj", 6: "juni", 7: "juli", 8: "august", 9: "september", 10: "oktober", 11: "november", 12: "december" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b553048632 = yr({ 1: (0, b.default)("de").numberFormatter({ raw: "0" }), 2: (0, b.default)("de").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM 'um' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "Januar", 2: "Februar", 3: "März", 4: "April", 5: "Mai", 6: "Juni", 7: "Juli", 8: "August", 9: "September", 10: "Oktober", 11: "November", 12: "Dezember" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a2117374958 = yr({ 1: (0, b.default)("el").numberFormatter({ raw: "0" }), 2: (0, b.default)("el").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM - h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "Ιανουαρίου", 2: "Φεβρουαρίου", 3: "Μαρτίου", 4: "Απριλίου", 5: "Μαΐου", 6: "Ιουνίου", 7: "Ιουλίου", 8: "Αυγούστου", 9: "Σεπτεμβρίου", 10: "Οκτωβρίου", 11: "Νοεμβρίου", 12: "Δεκεμβρίου" } } }, dayPeriods: { am: "π.μ.", pm: "μ.μ." } });
b.default.b2037043728 = yr({ 1: (0, b.default)("en").numberFormatter({ raw: "0" }), 2: (0, b.default)("en").numberFormatter({ raw: "00" }) }, { pattern: "MMMM d 'at' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "January", 2: "February", 3: "March", 4: "April", 5: "May", 6: "June", 7: "July", 8: "August", 9: "September", 10: "October", 11: "November", 12: "December" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a461811445 = yr({ 1: (0, b.default)("es").numberFormatter({ raw: "0" }), 2: (0, b.default)("es").numberFormatter({ raw: "00" }) }, { pattern: "d 'de' MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "enero", 2: "febrero", 3: "marzo", 4: "abril", 5: "mayo", 6: "junio", 7: "julio", 8: "agosto", 9: "septiembre", 10: "octubre", 11: "noviembre", 12: "diciembre" } } }, dayPeriods: { am: "a. m.", pm: "p. m." } });
b.default.b1615397898 = yr({ 1: (0, b.default)("et").numberFormatter({ raw: "0" }), 2: (0, b.default)("et").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "jaanuar", 2: "veebruar", 3: "märts", 4: "aprill", 5: "mai", 6: "juuni", 7: "juuli", 8: "august", 9: "september", 10: "oktoober", 11: "november", 12: "detsember" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a602360055 = yr({ 1: (0, b.default)("eu").numberFormatter({ raw: "0" }), 2: (0, b.default)("eu").numberFormatter({ raw: "00" }) }, { pattern: "MMMM d h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "urtarrila", 2: "otsaila", 3: "martxoa", 4: "apirila", 5: "maiatza", 6: "ekaina", 7: "uztaila", 8: "abuztua", 9: "iraila", 10: "urria", 11: "azaroa", 12: "abendua" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b209911798 = yr({ 1: (0, b.default)("fi").numberFormatter({ raw: "0" }), 2: (0, b.default)("fi").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM 'klo' h.mm a", timeSeparator: ".", months: { M: { 4: { 1: "tammikuuta", 2: "helmikuuta", 3: "maaliskuuta", 4: "huhtikuuta", 5: "toukokuuta", 6: "kesäkuuta", 7: "heinäkuuta", 8: "elokuuta", 9: "syyskuuta", 10: "lokakuuta", 11: "marraskuuta", 12: "joulukuuta" } } }, dayPeriods: { am: "ap.", pm: "ip." } });
b.default.b1724926701 = yr({ 1: (0, b.default)("fr").numberFormatter({ raw: "0" }), 2: (0, b.default)("fr").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM 'à' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "janvier", 2: "février", 3: "mars", 4: "avril", 5: "mai", 6: "juin", 7: "juillet", 8: "août", 9: "septembre", 10: "octobre", 11: "novembre", 12: "décembre" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b2115552724 = yr({ 1: (0, b.default)("gl").numberFormatter({ raw: "0" }), 2: (0, b.default)("gl").numberFormatter({ raw: "00" }) }, { pattern: "h:mm a 'do' d 'de' MMMM", timeSeparator: ":", dayPeriods: { am: "a.m.", pm: "p.m." }, months: { M: { 4: { 1: "xaneiro", 2: "febreiro", 3: "marzo", 4: "abril", 5: "maio", 6: "xuño", 7: "xullo", 8: "agosto", 9: "setembro", 10: "outubro", 11: "novembro", 12: "decembro" } } } });
b.default.b428969404 = yr({ 1: (0, b.default)("he").numberFormatter({ raw: "0" }), 2: (0, b.default)("he").numberFormatter({ raw: "00" }) }, { pattern: "d בMMMM בשעה h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "ינואר", 2: "פברואר", 3: "מרץ", 4: "אפריל", 5: "מאי", 6: "יוני", 7: "יולי", 8: "אוגוסט", 9: "ספטמבר", 10: "אוקטובר", 11: "נובמבר", 12: "דצמבר" } } }, dayPeriods: { am: "לפנה״צ", pm: "אחה״צ" } });
b.default.b147872184 = yr({ 1: (0, b.default)("hi").numberFormatter({ raw: "0" }), 2: (0, b.default)("hi").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM को h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "जनवरी", 2: "फ़रवरी", 3: "मार्च", 4: "अप्रैल", 5: "मई", 6: "जून", 7: "जुलाई", 8: "अगस्त", 9: "सितंबर", 10: "अक्तूबर", 11: "नवंबर", 12: "दिसंबर" } } }, dayPeriods: { am: "am", pm: "pm" } });
b.default.b1662887087 = yr({ 1: (0, b.default)("hr").numberFormatter({ raw: "0" }), 2: (0, b.default)("hr").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM 'u' hh:mm a", timeSeparator: ":", months: { M: { 4: { 1: "siječnja", 2: "veljače", 3: "ožujka", 4: "travnja", 5: "svibnja", 6: "lipnja", 7: "srpnja", 8: "kolovoza", 9: "rujna", 10: "listopada", 11: "studenoga", 12: "prosinca" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a695419476 = yr({ 1: (0, b.default)("hu").numberFormatter({ raw: "0" }), 2: (0, b.default)("hu").numberFormatter({ raw: "00" }) }, { pattern: "MMMM d. a h:mm", timeSeparator: ":", months: { M: { 4: { 1: "január", 2: "február", 3: "március", 4: "április", 5: "május", 6: "június", 7: "július", 8: "augusztus", 9: "szeptember", 10: "október", 11: "november", 12: "december" } } }, dayPeriods: { am: "de.", pm: "du." } });
b.default.a1679259746 = yr({ 1: (0, b.default)("id").numberFormatter({ raw: "0" }), 2: (0, b.default)("id").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h.mm a", timeSeparator: ".", months: { M: { 4: { 1: "Januari", 2: "Februari", 3: "Maret", 4: "April", 5: "Mei", 6: "Juni", 7: "Juli", 8: "Agustus", 9: "September", 10: "Oktober", 11: "November", 12: "Desember" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b1491318670 = yr({ 1: (0, b.default)("it").numberFormatter({ raw: "0" }), 2: (0, b.default)("it").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "gennaio", 2: "febbraio", 3: "marzo", 4: "aprile", 5: "maggio", 6: "giugno", 7: "luglio", 8: "agosto", 9: "settembre", 10: "ottobre", 11: "novembre", 12: "dicembre" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b648027010 = yr({ 1: (0, b.default)("ja").numberFormatter({ raw: "0" }), 2: (0, b.default)("ja").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 aK:mm", timeSeparator: ":", dayPeriods: { am: "午前", pm: "午後" } });
b.default.a85735847 = yr({ 1: (0, b.default)("kk").numberFormatter({ raw: "0" }), 2: (0, b.default)("kk").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "қаңтар", 2: "ақпан", 3: "наурыз", 4: "сәуір", 5: "мамыр", 6: "маусым", 7: "шілде", 8: "тамыз", 9: "қыркүйек", 10: "қазан", 11: "қараша", 12: "желтоқсан" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a366833067 = yr({ 1: (0, b.default)("ko").numberFormatter({ raw: "0" }), 2: (0, b.default)("ko").numberFormatter({ raw: "00" }) }, { pattern: "MMMM d일 a h:mm", timeSeparator: ":", months: { M: { 4: { 1: "1월", 2: "2월", 3: "3월", 4: "4월", 5: "5월", 6: "6월", 7: "7월", 8: "8월", 9: "9월", 10: "10월", 11: "11월", 12: "12월" } } }, dayPeriods: { am: "오전", pm: "오후" } });
b.default.b1398259249 = yr({ 1: (0, b.default)("lt").numberFormatter({ raw: "0" }), 2: (0, b.default)("lt").numberFormatter({ raw: "00" }) }, { pattern: "MMMM d 'd'. hh:mm a", timeSeparator: ":", months: { M: { 4: { 1: "sausio", 2: "vasario", 3: "kovo", 4: "balandžio", 5: "gegužės", 6: "birželio", 7: "liepos", 8: "rugpjūčio", 9: "rugsėjo", 10: "spalio", 11: "lapkričio", 12: "gruodžio" } } }, dayPeriods: { am: "priešpiet", pm: "popiet" } });
b.default.b1257710639 = yr({ 1: (0, b.default)("lv").numberFormatter({ raw: "0" }), 2: (0, b.default)("lv").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "janvāris", 2: "februāris", 3: "marts", 4: "aprīlis", 5: "maijs", 6: "jūnijs", 7: "jūlijs", 8: "augusts", 9: "septembris", 10: "oktobris", 11: "novembris", 12: "decembris" } } }, dayPeriods: { am: "priekšpusdienā", pm: "pēcpusdienā" } });
b.default.a709969901 = yr({ 1: (0, b.default)("ms").numberFormatter({ raw: "0" }), 2: (0, b.default)("ms").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "Januari", 2: "Februari", 3: "Mac", 4: "April", 5: "Mei", 6: "Jun", 7: "Julai", 8: "Ogos", 9: "September", 10: "Oktober", 11: "November", 12: "Disember" } } }, dayPeriods: { am: "PG", pm: "PTG" } });
b.default.a1693810171 = yr({ 1: (0, b.default)("nb").numberFormatter({ raw: "0" }), 2: (0, b.default)("nb").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM 'kl'. h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januar", 2: "februar", 3: "mars", 4: "april", 5: "mai", 6: "juni", 7: "juli", 8: "august", 9: "september", 10: "oktober", 11: "november", 12: "desember" } } }, dayPeriods: { am: "a.m.", pm: "p.m." } });
b.default.b1898414075 = yr({ 1: (0, b.default)("nl").numberFormatter({ raw: "0" }), 2: (0, b.default)("nl").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM 'om' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januari", 2: "februari", 3: "maart", 4: "april", 5: "mei", 6: "juni", 7: "juli", 8: "augustus", 9: "september", 10: "oktober", 11: "november", 12: "december" } } }, dayPeriods: { am: "a.m.", pm: "p.m." } });
b.default.b1836374461 = yr({ 1: (0, b.default)("pl").numberFormatter({ raw: "0" }), 2: (0, b.default)("pl").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "stycznia", 2: "lutego", 3: "marca", 4: "kwietnia", 5: "maja", 6: "czerwca", 7: "lipca", 8: "sierpnia", 9: "września", 10: "października", 11: "listopada", 12: "grudnia" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b1274180021 = yr({ 1: (0, b.default)("pt").numberFormatter({ raw: "0" }), 2: (0, b.default)("pt").numberFormatter({ raw: "00" }) }, { pattern: "d 'de' MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "janeiro", 2: "fevereiro", 3: "março", 4: "abril", 5: "maio", 6: "junho", 7: "julho", 8: "agosto", 9: "setembro", 10: "outubro", 11: "novembro", 12: "dezembro" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a1582820462 = yr({ 1: (0, b.default)("pt-PT").numberFormatter({ raw: "0" }), 2: (0, b.default)("pt-PT").numberFormatter({ raw: "00" }) }, { pattern: "d 'de' MMMM 'às' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "janeiro", 2: "fevereiro", 3: "março", 4: "abril", 5: "maio", 6: "junho", 7: "julho", 8: "agosto", 9: "setembro", 10: "outubro", 11: "novembro", 12: "dezembro" } } }, dayPeriods: { am: "da manhã", pm: "da tarde" } });
b.default.a583971716 = yr({ 1: (0, b.default)("ro").numberFormatter({ raw: "0" }), 2: (0, b.default)("ro").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "ianuarie", 2: "februarie", 3: "martie", 4: "aprilie", 5: "mai", 6: "iunie", 7: "iulie", 8: "august", 9: "septembrie", 10: "octombrie", 11: "noiembrie", 12: "decembrie" } } }, dayPeriods: { am: "a.m.", pm: "p.m." } });
b.default.a1005617546 = yr({ 1: (0, b.default)("ru").numberFormatter({ raw: "0" }), 2: (0, b.default)("ru").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "января", 2: "февраля", 3: "марта", 4: "апреля", 5: "мая", 6: "июня", 7: "июля", 8: "августа", 9: "сентября", 10: "октября", 11: "ноября", 12: "декабря" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.a333894303 = yr({ 1: (0, b.default)("sk").numberFormatter({ raw: "0" }), 2: (0, b.default)("sk").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM, h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januára", 2: "februára", 3: "marca", 4: "apríla", 5: "mája", 6: "júna", 7: "júla", 8: "augusta", 9: "septembra", 10: "októbra", 11: "novembra", 12: "decembra" } } }, dayPeriods: { am: "AM", pm: "PM" } });
b.default.b1743315040 = yr({ 1: (0, b.default)("sl").numberFormatter({ raw: "0" }), 2: (0, b.default)("sl").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januar", 2: "februar", 3: "marec", 4: "april", 5: "maj", 6: "junij", 7: "julij", 8: "avgust", 9: "september", 10: "oktober", 11: "november", 12: "december" } } }, dayPeriods: { am: "dop.", pm: "pop." } });
b.default.a374999999 = yr({ 1: (0, b.default)("sr-Cyrl").numberFormatter({ raw: "0" }), 2: (0, b.default)("sr-Cyrl").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "јануар", 2: "фебруар", 3: "март", 4: "април", 5: "мај", 6: "јун", 7: "јул", 8: "август", 9: "септембар", 10: "октобар", 11: "новембар", 12: "децембар" } } }, dayPeriods: { am: "пре подне", pm: "по подне" } });
b.default.a976026686 = yr({ 1: (0, b.default)("sr-Latn").numberFormatter({ raw: "0" }), 2: (0, b.default)("sr-Latn").numberFormatter({ raw: "00" }) }, { pattern: "d. MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januar", 2: "februar", 3: "mart", 4: "april", 5: "maj", 6: "jun", 7: "jul", 8: "avgust", 9: "septembar", 10: "oktobar", 11: "novembar", 12: "decembar" } } }, dayPeriods: { am: "pre podne", pm: "po podne" } });
b.default.b1040571990 = yr({ 1: (0, b.default)("sv").numberFormatter({ raw: "0" }), 2: (0, b.default)("sv").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "januari", 2: "februari", 3: "mars", 4: "april", 5: "maj", 6: "juni", 7: "juli", 8: "augusti", 9: "september", 10: "oktober", 11: "november", 12: "december" } } }, dayPeriods: { am: "fm", pm: "em" } });
b.default.b1993392453 = yr({ 1: (0, b.default)("th").numberFormatter({ raw: "0" }), 2: (0, b.default)("th").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "มกราคม", 2: "กุมภาพันธ์", 3: "มีนาคม", 4: "เมษายน", 5: "พฤษภาคม", 6: "มิถุนายน", 7: "กรกฎาคม", 8: "สิงหาคม", 9: "กันยายน", 10: "ตุลาคม", 11: "พฤศจิกายน", 12: "ธันวาคม" } } }, dayPeriods: { am: "ก่อนเที่ยง", pm: "หลังเที่ยง" } });
b.default.b1290649403 = yr({ 1: (0, b.default)("tr").numberFormatter({ raw: "0" }), 2: (0, b.default)("tr").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM a h:mm", timeSeparator: ":", months: { M: { 4: { 1: "Ocak", 2: "Şubat", 3: "Mart", 4: "Nisan", 5: "Mayıs", 6: "Haziran", 7: "Temmuz", 8: "Ağustos", 9: "Eylül", 10: "Ekim", 11: "Kasım", 12: "Aralık" } } }, dayPeriods: { am: "ÖÖ", pm: "ÖS" } });
b.default.a395933917 = yr({ 1: (0, b.default)("uk").numberFormatter({ raw: "0" }), 2: (0, b.default)("uk").numberFormatter({ raw: "00" }) }, { pattern: "d MMMM 'о' h:mm a", timeSeparator: ":", months: { M: { 4: { 1: "січня", 2: "лютого", 3: "березня", 4: "квітня", 5: "травня", 6: "червня", 7: "липня", 8: "серпня", 9: "вересня", 10: "жовтня", 11: "листопада", 12: "грудня" } } }, dayPeriods: { am: "дп", pm: "пп" } });
b.default.a286405114 = yr({ 1: (0, b.default)("vi").numberFormatter({ raw: "0" }), 2: (0, b.default)("vi").numberFormatter({ raw: "00" }) }, { pattern: "h:mm a d MMMM", timeSeparator: ":", dayPeriods: { am: "SA", pm: "CH" }, months: { M: { 4: { 1: "tháng 1", 2: "tháng 2", 3: "tháng 3", 4: "tháng 4", 5: "tháng 5", 6: "tháng 6", 7: "tháng 7", 8: "tháng 8", 9: "tháng 9", 10: "tháng 10", 11: "tháng 11", 12: "tháng 12" } } } });
b.default.b222114294 = yr({ 1: (0, b.default)("yue").numberFormatter({ raw: "0" }), 2: (0, b.default)("yue").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.b1939787106 = yr({ 1: (0, b.default)("zh-Hans").numberFormatter({ raw: "0" }), 2: (0, b.default)("zh-Hans").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.b621833333 = yr({ 1: (0, b.default)("zh-Hans-SG").numberFormatter({ raw: "0" }), 2: (0, b.default)("zh-Hans-SG").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.a277970847 = yr({ 1: (0, b.default)("zh-Hant").numberFormatter({ raw: "0" }), 2: (0, b.default)("zh-Hant").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.b936690535 = yr({ 1: (0, b.default)("zh-Hant-HK").numberFormatter({ raw: "0" }), 2: (0, b.default)("zh-Hant-HK").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.b500494280 = yr({ 1: (0, b.default)("zh-Hant-MO").numberFormatter({ raw: "0" }), 2: (0, b.default)("zh-Hant-MO").numberFormatter({ raw: "00" }) }, { pattern: "M月d日 ah:mm", timeSeparator: ":", dayPeriods: { am: "上午", pm: "下午" } });
b.default.a50097046 = _r((0, b.default)("ar-EG").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a62728514 = _r((0, b.default)("ar-SA").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b46681067 = _r((0, b.default)("bg").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b437307090 = _r((0, b.default)("ca").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a827630400 = _r((0, b.default)("cs").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b406287283 = _r((0, b.default)("da").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b125190063 = _r((0, b.default)("de").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1749733769 = _r((0, b.default)("el").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1609185159 = _r((0, b.default)("en").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a889670014 = _r((0, b.default)("es").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1187539329 = _r((0, b.default)("et").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a1030218624 = _r((0, b.default)("eu").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a217946771 = _r((0, b.default)("fi").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1297068132 = _r((0, b.default)("fr").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1687694155 = _r((0, b.default)("gl").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1110835 = _r((0, b.default)("he").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a279986385 = _r((0, b.default)("hi").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1235028518 = _r((0, b.default)("hr").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a1123278045 = _r((0, b.default)("hu").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a2107118315 = _r((0, b.default)("id").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1063460101 = _r((0, b.default)("it").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b220168441 = _r((0, b.default)("ja").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a513594416 = _r((0, b.default)("kk").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a794691636 = _r((0, b.default)("ko").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b970400680 = _r((0, b.default)("lt").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b829852070 = _r((0, b.default)("lv").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a1137828470 = _r((0, b.default)("ms").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a2121668740 = _r((0, b.default)("nb").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1470555506 = _r((0, b.default)("nl").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1408515892 = _r((0, b.default)("pl").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b846321452 = _r((0, b.default)("pt").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a454515013 = _r((0, b.default)("pt-PT").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a1011830285 = _r((0, b.default)("ro").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a1433476115 = _r((0, b.default)("ru").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a761752872 = _r((0, b.default)("sk").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1315456471 = _r((0, b.default)("sl").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1594777898 = _r((0, b.default)("sr-Cyrl").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b993751211 = _r((0, b.default)("sr-Latn").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b612713421 = _r((0, b.default)("sv").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1565533884 = _r((0, b.default)("th").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b862790834 = _r((0, b.default)("tr").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a823792486 = _r((0, b.default)("uk").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a714263683 = _r((0, b.default)("vi").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a156599457 = _r((0, b.default)("yue").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.a385402293 = _r((0, b.default)("zh-Hans").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b136997612 = _r((0, b.default)("zh-Hans-SG").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1691807050 = _r((0, b.default)("zh-Hant").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b451854814 = _r((0, b.default)("zh-Hant-HK").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b15658559 = _r((0, b.default)("zh-Hant-MO").dateToPartsFormatter({ skeleton: "MMMMdhm" }));
b.default.b1129493863 = Ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "خلال {0} ساعة", "relativeTimePattern-count-one": "خلال ساعة واحدة", "relativeTimePattern-count-two": "خلال ساعتين", "relativeTimePattern-count-few": "خلال {0} ساعات", "relativeTimePattern-count-many": "خلال {0} ساعة", "relativeTimePattern-count-other": "خلال {0} ساعة" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "قبل {0} ساعة", "relativeTimePattern-count-one": "قبل ساعة واحدة", "relativeTimePattern-count-two": "قبل ساعتين", "relativeTimePattern-count-few": "قبل {0} ساعات", "relativeTimePattern-count-many": "قبل {0} ساعة", "relativeTimePattern-count-other": "قبل {0} ساعة" }, "relative-type-0": "الساعة الحالية" });
b.default.b318696087 = Ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "خلال {0} دقيقة", "relativeTimePattern-count-one": "خلال دقيقة واحدة", "relativeTimePattern-count-two": "خلال دقيقتين", "relativeTimePattern-count-few": "خلال {0} دقائق", "relativeTimePattern-count-many": "خلال {0} دقيقة", "relativeTimePattern-count-other": "خلال {0} دقيقة" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "قبل {0} دقيقة", "relativeTimePattern-count-one": "قبل دقيقة واحدة", "relativeTimePattern-count-two": "قبل دقيقتين", "relativeTimePattern-count-few": "قبل {0} دقائق", "relativeTimePattern-count-many": "قبل {0} دقيقة", "relativeTimePattern-count-other": "قبل {0} دقيقة" }, "relative-type-0": "هذه الدقيقة" });
b.default.b1716664979 = Ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "خلال {0} ساعة", "relativeTimePattern-count-one": "خلال ساعة واحدة", "relativeTimePattern-count-two": "خلال ساعتين", "relativeTimePattern-count-few": "خلال {0} ساعات", "relativeTimePattern-count-many": "خلال {0} ساعة", "relativeTimePattern-count-other": "خلال {0} ساعة" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "قبل {0} ساعة", "relativeTimePattern-count-one": "قبل ساعة واحدة", "relativeTimePattern-count-two": "قبل ساعتين", "relativeTimePattern-count-few": "قبل {0} ساعات", "relativeTimePattern-count-many": "قبل {0} ساعة", "relativeTimePattern-count-other": "قبل {0} ساعة" }, "relative-type-0": "الساعة الحالية" });
b.default.b1949422787 = Ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "خلال {0} دقيقة", "relativeTimePattern-count-one": "خلال دقيقة واحدة", "relativeTimePattern-count-two": "خلال دقيقتين", "relativeTimePattern-count-few": "خلال {0} دقائق", "relativeTimePattern-count-many": "خلال {0} دقيقة", "relativeTimePattern-count-other": "خلال {0} دقيقة" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "قبل {0} دقيقة", "relativeTimePattern-count-one": "قبل دقيقة واحدة", "relativeTimePattern-count-two": "قبل دقيقتين", "relativeTimePattern-count-few": "قبل {0} دقائق", "relativeTimePattern-count-many": "قبل {0} دقيقة", "relativeTimePattern-count-other": "قبل {0} دقيقة" }, "relative-type-0": "هذه الدقيقة" });
b.default.b1132152016 = Ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "след {0} час", "relativeTimePattern-count-other": "след {0} часа" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "преди {0} час", "relativeTimePattern-count-other": "преди {0} часа" }, "relative-type-0": "в този час" });
b.default.a1421786176 = Ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "след {0} минута", "relativeTimePattern-count-other": "след {0} минути" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "преди {0} минута", "relativeTimePattern-count-other": "преди {0} минути" }, "relative-type-0": "в тази минута" });
b.default.a2094915959 = Ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "d’aquí a {0} hora", "relativeTimePattern-count-other": "d’aquí a {0} hores" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "fa {0} hora", "relativeTimePattern-count-other": "fa {0} hores" }, "relative-type-0": "aquesta hora" });
b.default.a1667722439 = Ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "d’aquí a {0} minut", "relativeTimePattern-count-other": "d’aquí a {0} minuts" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "fa {0} minut", "relativeTimePattern-count-other": "fa {0} minuts" }, "relative-type-0": "aquest minut" });
b.default.a123437605 = Ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} hodinu", "relativeTimePattern-count-few": "za {0} hodiny", "relativeTimePattern-count-many": "za {0} hodiny", "relativeTimePattern-count-other": "za {0} hodin" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "před {0} hodinou", "relativeTimePattern-count-few": "před {0} hodinami", "relativeTimePattern-count-many": "před {0} hodiny", "relativeTimePattern-count-other": "před {0} hodinami" }, "relative-type-0": "tuto hodinu" });
b.default.a1157601781 = Ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} minutu", "relativeTimePattern-count-few": "za {0} minuty", "relativeTimePattern-count-many": "za {0} minuty", "relativeTimePattern-count-other": "za {0} minut" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "před {0} minutou", "relativeTimePattern-count-few": "před {0} minutami", "relativeTimePattern-count-many": "před {0} minuty", "relativeTimePattern-count-other": "před {0} minutami" }, "relative-type-0": "tuto minutu" });
b.default.a1801512952 = Ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} time", "relativeTimePattern-count-other": "om {0} timer" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "for {0} time siden", "relativeTimePattern-count-other": "for {0} timer siden" }, "relative-type-0": "i den kommende time" });
b.default.b1119693048 = Ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} minut", "relativeTimePattern-count-other": "om {0} minutter" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "for {0} minut siden", "relativeTimePattern-count-other": "for {0} minutter siden" }, "relative-type-0": "i det kommende minut" });
b.default.b1977123468 = Ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "in {0} Stunde", "relativeTimePattern-count-other": "in {0} Stunden" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "vor {0} Stunde", "relativeTimePattern-count-other": "vor {0} Stunden" }, "relative-type-0": "in dieser Stunde" });
b.default.a1153039748 = Ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "in {0} Minute", "relativeTimePattern-count-other": "in {0} Minuten" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "vor {0} Minute", "relativeTimePattern-count-other": "vor {0} Minuten" }, "relative-type-0": "in dieser Minute" });
b.default.b1366947442 = Ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "σε {0} ώρα", "relativeTimePattern-count-other": "σε {0} ώρες" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "πριν από {0} ώρα", "relativeTimePattern-count-other": "πριν από {0} ώρες" }, "relative-type-0": "τρέχουσα ώρα" });
b.default.b878318818 = Ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "σε {0} λεπτό", "relativeTimePattern-count-other": "σε {0} λεπτά" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "πριν από {0} λεπτό", "relativeTimePattern-count-other": "πριν από {0} λεπτά" }, "relative-type-0": "τρέχον λεπτό" });
b.default.b1108782004 = Ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "in {0} hour", "relativeTimePattern-count-other": "in {0} hours" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} hour ago", "relativeTimePattern-count-other": "{0} hours ago" }, "relative-type-0": "this hour" });
b.default.b1889436068 = Ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "in {0} minute", "relativeTimePattern-count-other": "in {0} minutes" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minute ago", "relativeTimePattern-count-other": "{0} minutes ago" }, "relative-type-0": "this minute" });
b.default.b463368409 = Ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dentro de {0} hora", "relativeTimePattern-count-other": "dentro de {0} horas" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "hace {0} hora", "relativeTimePattern-count-other": "hace {0} horas" }, "relative-type-0": "esta hora" });
b.default.b122261897 = Ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dentro de {0} minuto", "relativeTimePattern-count-other": "dentro de {0} minutos" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "hace {0} minuto", "relativeTimePattern-count-other": "hace {0} minutos" }, "relative-type-0": "este minuto" });
b.default.b334285690 = Ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} tunni pärast", "relativeTimePattern-count-other": "{0} tunni pärast" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} tunni eest", "relativeTimePattern-count-other": "{0} tunni eest" }, "relative-type-0": "praegusel tunnil" });
b.default.b627820522 = Ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} minuti pärast", "relativeTimePattern-count-other": "{0} minuti pärast" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minuti eest", "relativeTimePattern-count-other": "{0} minuti eest" }, "relative-type-0": "praegusel minutil" });
b.default.b205202971 = Ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} ordu barru", "relativeTimePattern-count-other": "{0} ordu barru" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "Duela {0} ordu", "relativeTimePattern-count-other": "Duela {0} ordu" }, "relative-type-0": "ordu honetan" });
b.default.b1133379147 = Ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} minutu barru", "relativeTimePattern-count-other": "{0} minutu barru" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "Duela {0} minutu", "relativeTimePattern-count-other": "Duela {0} minutu" }, "relative-type-0": "minutu honetan" });
b.default.b2047598606 = Ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} tunnin päästä", "relativeTimePattern-count-other": "{0} tunnin päästä" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} tunti sitten", "relativeTimePattern-count-other": "{0} tuntia sitten" }, "relative-type-0": "tämän tunnin aikana" });
b.default.a2145908866 = Ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} minuutin päästä", "relativeTimePattern-count-other": "{0} minuutin päästä" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minuutti sitten", "relativeTimePattern-count-other": "{0} minuuttia sitten" }, "relative-type-0": "tämän minuutin aikana" });
b.default.b885854135 = Ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dans {0} heure", "relativeTimePattern-count-other": "dans {0} heures" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "il y a {0} heure", "relativeTimePattern-count-other": "il y a {0} heures" }, "relative-type-0": "cette heure-ci" });
b.default.a1890848537 = Ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dans {0} minute", "relativeTimePattern-count-other": "dans {0} minutes" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "il y a {0} minute", "relativeTimePattern-count-other": "il y a {0} minutes" }, "relative-type-0": "cette minute-ci" });
b.default.b1953753456 = Ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "en {0} hora", "relativeTimePattern-count-other": "en {0} horas" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "hai {0} hora", "relativeTimePattern-count-other": "hai {0} horas" }, "relative-type-0": "esta hora" });
b.default.a2136784800 = Ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "en {0} minuto", "relativeTimePattern-count-other": "en {0} minutos" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "hai {0} minuto", "relativeTimePattern-count-other": "hai {0} minutos" }, "relative-type-0": "este minuto" });
b.default.a1144231800 = Ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "בעוד שעה", "relativeTimePattern-count-two": "בעוד שעתיים", "relativeTimePattern-count-many": "בעוד {0} שעות", "relativeTimePattern-count-other": "בעוד {0} שעות" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "לפני שעה", "relativeTimePattern-count-two": "לפני שעתיים", "relativeTimePattern-count-many": "לפני {0} שעות", "relativeTimePattern-count-other": "לפני {0} שעות" }, "relative-type-0": "בשעה זו" });
b.default.b1406687608 = Ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "בעוד דקה", "relativeTimePattern-count-two": "בעוד שתי דקות", "relativeTimePattern-count-many": "בעוד {0} דקות", "relativeTimePattern-count-other": "בעוד {0} דקות" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "לפני דקה", "relativeTimePattern-count-two": "לפני שתי דקות", "relativeTimePattern-count-many": "לפני {0} דקות", "relativeTimePattern-count-other": "לפני {0} דקות" }, "relative-type-0": "בדקה זו" });
b.default.a1660562676 = Ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} घंटे में", "relativeTimePattern-count-other": "{0} घंटे में" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} घंटे पहले", "relativeTimePattern-count-other": "{0} घंटे पहले" }, "relative-type-0": "यह घंटा" });
b.default.a866045188 = Ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} मिनट में", "relativeTimePattern-count-other": "{0} मिनट में" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} मिनट पहले", "relativeTimePattern-count-other": "{0} मिनट पहले" }, "relative-type-0": "यह मिनट" });
b.default.b1472660149 = Ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} sat", "relativeTimePattern-count-few": "za {0} sata", "relativeTimePattern-count-other": "za {0} sati" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "prije {0} sat", "relativeTimePattern-count-few": "prije {0} sata", "relativeTimePattern-count-other": "prije {0} sati" }, "relative-type-0": "ovaj sat" });
b.default.a610984859 = Ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} minutu", "relativeTimePattern-count-few": "za {0} minute", "relativeTimePattern-count-other": "za {0} minuta" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "prije {0} minutu", "relativeTimePattern-count-few": "prije {0} minute", "relativeTimePattern-count-other": "prije {0} minuta" }, "relative-type-0": "ova minuta" });
b.default.b1085411992 = Ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} óra múlva", "relativeTimePattern-count-other": "{0} óra múlva" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} órával ezelőtt", "relativeTimePattern-count-other": "{0} órával ezelőtt" }, "relative-type-0": "ebben az órában" });
b.default.b905691016 = Ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} perc múlva", "relativeTimePattern-count-other": "{0} perc múlva" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} perccel ezelőtt", "relativeTimePattern-count-other": "{0} perccel ezelőtt" }, "relative-type-0": "ebben a percben" });
b.default.a721746074 = Ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "dalam {0} jam" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} jam yang lalu" }, "relative-type-0": "jam ini" });
b.default.a606422826 = Ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "dalam {0} menit" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} menit yang lalu" }, "relative-type-0": "menit ini" });
b.default.b1507897718 = Ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "tra {0} ora", "relativeTimePattern-count-other": "tra {0} ore" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} ora fa", "relativeTimePattern-count-other": "{0} ore fa" }, "relative-type-0": "quest’ora" });
b.default.a1107419418 = Ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "tra {0} minuto", "relativeTimePattern-count-other": "tra {0} minuti" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minuto fa", "relativeTimePattern-count-other": "{0} minuti fa" }, "relative-type-0": "questo minuto" });
b.default.a41094910 = Ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 時間後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 時間前" }, "relative-type-0": "1 時間以内" });
b.default.b664316786 = Ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 分後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 分前" }, "relative-type-0": "1 分以内" });
b.default.a1038519093 = Ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} сағаттан кейін", "relativeTimePattern-count-other": "{0} сағаттан кейін" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} сағат бұрын", "relativeTimePattern-count-other": "{0} сағат бұрын" }, "relative-type-0": "осы сағат" });
b.default.a82616069 = Ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} минуттан кейін", "relativeTimePattern-count-other": "{0} минуттан кейін" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} минут бұрын", "relativeTimePattern-count-other": "{0} минут бұрын" }, "relative-type-0": "осы минут" });
b.default.a1554849969 = Ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}시간 후" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}시간 전" }, "relative-type-0": "현재 시간" });
b.default.b1939618431 = Ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}분 후" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}분 전" }, "relative-type-0": "현재 분" });
b.default.a1906860557 = Ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "po {0} valandos", "relativeTimePattern-count-few": "po {0} valandų", "relativeTimePattern-count-many": "po {0} valandos", "relativeTimePattern-count-other": "po {0} valandų" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "prieš {0} valandą", "relativeTimePattern-count-few": "prieš {0} valandas", "relativeTimePattern-count-many": "prieš {0} valandos", "relativeTimePattern-count-other": "prieš {0} valandų" }, "relative-type-0": "šią valandą" });
b.default.a1335107549 = Ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "po {0} minutės", "relativeTimePattern-count-few": "po {0} minučių", "relativeTimePattern-count-many": "po {0} minutės", "relativeTimePattern-count-other": "po {0} minučių" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "prieš {0} minutę", "relativeTimePattern-count-few": "prieš {0} minutes", "relativeTimePattern-count-many": "prieš {0} minutės", "relativeTimePattern-count-other": "prieš {0} minučių" }, "relative-type-0": "šią minutę" });
b.default.b2129941301 = Ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "pēc {0} stundām", "relativeTimePattern-count-one": "pēc {0} stundas", "relativeTimePattern-count-other": "pēc {0} stundām" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "pirms {0} stundām", "relativeTimePattern-count-one": "pirms {0} stundas", "relativeTimePattern-count-other": "pirms {0} stundām" }, "relative-type-0": "šajā stundā" });
b.default.a323990299 = Ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-zero": "pēc {0} minūtēm", "relativeTimePattern-count-one": "pēc {0} minūtes", "relativeTimePattern-count-other": "pēc {0} minūtēm" }, "relativeTime-type-past": { "relativeTimePattern-count-zero": "pirms {0} minūtēm", "relativeTimePattern-count-one": "pirms {0} minūtes", "relativeTimePattern-count-other": "pirms {0} minūtēm" }, "relative-type-0": "šajā minūtē" });
b.default.a1484374831 = Ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "dalam {0} jam" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} jam lalu" }, "relative-type-0": "jam ini" });
b.default.b946749313 = Ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "dalam {0} minit" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} minit lalu" }, "relative-type-0": "pada minit ini" });
b.default.b1003434399 = Ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} time", "relativeTimePattern-count-other": "om {0} timer" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "for {0} time siden", "relativeTimePattern-count-other": "for {0} timer siden" }, "relative-type-0": "denne timen" });
b.default.a565364529 = Ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} minutt", "relativeTimePattern-count-other": "om {0} minutter" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "for {0} minutt siden", "relativeTimePattern-count-other": "for {0} minutter siden" }, "relative-type-0": "dette minuttet" });
b.default.a287392791 = Ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "over {0} uur", "relativeTimePattern-count-other": "over {0} uur" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} uur geleden", "relativeTimePattern-count-other": "{0} uur geleden" }, "relative-type-0": "binnen een uur" });
b.default.b195254425 = Ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "over {0} minuut", "relativeTimePattern-count-other": "over {0} minuten" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minuut geleden", "relativeTimePattern-count-other": "{0} minuten geleden" }, "relative-type-0": "binnen een minuut" });
b.default.b299413223 = Ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} godzinę", "relativeTimePattern-count-few": "za {0} godziny", "relativeTimePattern-count-many": "za {0} godzin", "relativeTimePattern-count-other": "za {0} godziny" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} godzinę temu", "relativeTimePattern-count-few": "{0} godziny temu", "relativeTimePattern-count-many": "{0} godzin temu", "relativeTimePattern-count-other": "{0} godziny temu" }, "relative-type-0": "ta godzina" });
b.default.b1475118103 = Ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} minutę", "relativeTimePattern-count-few": "za {0} minuty", "relativeTimePattern-count-many": "za {0} minut", "relativeTimePattern-count-other": "za {0} minuty" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} minutę temu", "relativeTimePattern-count-few": "{0} minuty temu", "relativeTimePattern-count-many": "{0} minut temu", "relativeTimePattern-count-other": "{0} minuty temu" }, "relative-type-0": "ta minuta" });
b.default.a733248529 = Ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "em {0} hora", "relativeTimePattern-count-other": "em {0} horas" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "há {0} hora", "relativeTimePattern-count-other": "há {0} horas" }, "relative-type-0": "esta hora" });
b.default.b1224619807 = Ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "em {0} minuto", "relativeTimePattern-count-other": "em {0} minutos" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "há {0} minuto", "relativeTimePattern-count-other": "há {0} minutos" }, "relative-type-0": "este minuto" });
b.default.a1268173962 = Ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dentro de {0} hora", "relativeTimePattern-count-other": "dentro de {0} horas" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "há {0} hora", "relativeTimePattern-count-other": "há {0} horas" }, "relative-type-0": "esta hora" });
b.default.a1737613082 = Ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "dentro de {0} minuto", "relativeTimePattern-count-other": "dentro de {0} minutos" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "há {0} minuto", "relativeTimePattern-count-other": "há {0} minutos" }, "relative-type-0": "este minuto" });
b.default.b498971080 = Ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "peste {0} oră", "relativeTimePattern-count-few": "peste {0} ore", "relativeTimePattern-count-other": "peste {0} de ore" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "acum {0} oră", "relativeTimePattern-count-few": "acum {0} ore", "relativeTimePattern-count-other": "acum {0} de ore" }, "relative-type-0": "ora aceasta" });
b.default.a23309640 = Ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "peste {0} minut", "relativeTimePattern-count-few": "peste {0} minute", "relativeTimePattern-count-other": "peste {0} de minute" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "acum {0} minut", "relativeTimePattern-count-few": "acum {0} minute", "relativeTimePattern-count-other": "acum {0} de minute" }, "relative-type-0": "minutul acesta" });
b.default.a275525234 = Ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "через {0} час", "relativeTimePattern-count-few": "через {0} часа", "relativeTimePattern-count-many": "через {0} часов", "relativeTimePattern-count-other": "через {0} часа" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} час назад", "relativeTimePattern-count-few": "{0} часа назад", "relativeTimePattern-count-many": "{0} часов назад", "relativeTimePattern-count-other": "{0} часа назад" }, "relative-type-0": "в этот час" });
b.default.a1284925186 = Ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "через {0} минуту", "relativeTimePattern-count-few": "через {0} минуты", "relativeTimePattern-count-many": "через {0} минут", "relativeTimePattern-count-other": "через {0} минуты" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} минуту назад", "relativeTimePattern-count-few": "{0} минуты назад", "relativeTimePattern-count-many": "{0} минут назад", "relativeTimePattern-count-other": "{0} минуты назад" }, "relative-type-0": "в эту минуту" });
b.default.b1308704963 = Ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "o {0} hodinu", "relativeTimePattern-count-few": "o {0} hodiny", "relativeTimePattern-count-many": "o {0} hodiny", "relativeTimePattern-count-other": "o {0} hodín" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pred {0} hodinou", "relativeTimePattern-count-few": "pred {0} hodinami", "relativeTimePattern-count-many": "pred {0} hodinou", "relativeTimePattern-count-other": "pred {0} hodinami" }, "relative-type-0": "v tejto hodine" });
b.default.b741871347 = Ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "o {0} minútu", "relativeTimePattern-count-few": "o {0} minúty", "relativeTimePattern-count-many": "o {0} minúty", "relativeTimePattern-count-other": "o {0} minút" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pred {0} minútou", "relativeTimePattern-count-few": "pred {0} minútami", "relativeTimePattern-count-many": "pred {0} minúty", "relativeTimePattern-count-other": "pred {0} minútami" }, "relative-type-0": "v tejto minúte" });
b.default.b1179622244 = Ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "čez {0} uro", "relativeTimePattern-count-two": "čez {0} uri", "relativeTimePattern-count-few": "čez {0} ure", "relativeTimePattern-count-other": "čez {0} ur" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pred {0} uro", "relativeTimePattern-count-two": "pred {0} urama", "relativeTimePattern-count-few": "pred {0} urami", "relativeTimePattern-count-other": "pred {0} urami" }, "relative-type-0": "v tej uri" });
b.default.b1247429972 = Ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "čez {0} minuto", "relativeTimePattern-count-two": "čez {0} minuti", "relativeTimePattern-count-few": "čez {0} minute", "relativeTimePattern-count-other": "čez {0} minut" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pred {0} minuto", "relativeTimePattern-count-two": "pred {0} minutama", "relativeTimePattern-count-few": "pred {0} minutami", "relativeTimePattern-count-other": "pred {0} minutami" }, "relative-type-0": "to minuto" });
b.default.b105017831 = Ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "за {0} сат", "relativeTimePattern-count-few": "за {0} сата", "relativeTimePattern-count-other": "за {0} сати" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "пре {0} сата", "relativeTimePattern-count-few": "пре {0} сата", "relativeTimePattern-count-other": "пре {0} сати" }, "relative-type-0": "овог сата" });
b.default.a655259881 = Ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "за {0} минут", "relativeTimePattern-count-few": "за {0} минута", "relativeTimePattern-count-other": "за {0} минута" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "пре {0} минута", "relativeTimePattern-count-few": "пре {0} минута", "relativeTimePattern-count-other": "пре {0} минута" }, "relative-type-0": "овог минута" });
b.default.b502088902 = Ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} sat", "relativeTimePattern-count-few": "za {0} sata", "relativeTimePattern-count-other": "za {0} sati" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pre {0} sata", "relativeTimePattern-count-few": "pre {0} sata", "relativeTimePattern-count-other": "pre {0} sati" }, "relative-type-0": "ovog sata" });
b.default.a1322049994 = Ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "za {0} minut", "relativeTimePattern-count-few": "za {0} minuta", "relativeTimePattern-count-other": "za {0} minuta" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "pre {0} minuta", "relativeTimePattern-count-few": "pre {0} minuta", "relativeTimePattern-count-other": "pre {0} minuta" }, "relative-type-0": "ovog minuta" });
b.default.a111204946 = Ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} timme", "relativeTimePattern-count-other": "om {0} timmar" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "för {0} timme sedan", "relativeTimePattern-count-other": "för {0} timmar sedan" }, "relative-type-0": "denna timme" });
b.default.b2008048926 = Ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "om {0} minut", "relativeTimePattern-count-other": "om {0} minuter" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "för {0} minut sedan", "relativeTimePattern-count-other": "för {0} minuter sedan" }, "relative-type-0": "denna minut" });
b.default.b1989356127 = Ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "ในอีก {0} ชั่วโมง" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} ชั่วโมงที่ผ่านมา" }, "relative-type-0": "ชั่วโมงนี้" });
b.default.b2012610959 = Ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "ในอีก {0} นาที" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} นาทีที่ผ่านมา" }, "relative-type-0": "นาทีนี้" });
b.default.b698528937 = Ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} saat sonra", "relativeTimePattern-count-other": "{0} saat sonra" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} saat önce", "relativeTimePattern-count-other": "{0} saat önce" }, "relative-type-0": "bu saat" });
b.default.a1521737383 = Ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "{0} dakika sonra", "relativeTimePattern-count-other": "{0} dakika sonra" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} dakika önce", "relativeTimePattern-count-other": "{0} dakika önce" }, "relative-type-0": "bu dakika" });
b.default.b1895510977 = Ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "через {0} годину", "relativeTimePattern-count-few": "через {0} години", "relativeTimePattern-count-many": "через {0} годин", "relativeTimePattern-count-other": "через {0} години" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} годину тому", "relativeTimePattern-count-few": "{0} години тому", "relativeTimePattern-count-many": "{0} годин тому", "relativeTimePattern-count-other": "{0} години тому" }, "relative-type-0": "цієї години" });
b.default.b2021735025 = Ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-one": "через {0} хвилину", "relativeTimePattern-count-few": "через {0} хвилини", "relativeTimePattern-count-many": "через {0} хвилин", "relativeTimePattern-count-other": "через {0} хвилини" }, "relativeTime-type-past": { "relativeTimePattern-count-one": "{0} хвилину тому", "relativeTimePattern-count-few": "{0} хвилини тому", "relativeTimePattern-count-many": "{0} хвилин тому", "relativeTimePattern-count-other": "{0} хвилини тому" }, "relative-type-0": "цієї хвилини" });
b.default.a1847887874 = Ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "sau {0} giờ nữa" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} giờ trước" }, "relative-type-0": "giờ này" });
b.default.a496934034 = Ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "sau {0} phút nữa" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} phút trước" }, "relative-type-0": "phút này" });
b.default.a2068901102 = Ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 小時後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 小時前" }, "relative-type-0": "呢個小時" });
b.default.b1857718658 = Ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 分鐘後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 分鐘前" }, "relative-type-0": "呢分鐘" });
b.default.a1130735834 = Ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}小时后" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}小时前" }, "relative-type-0": "这一时间 / 此时" });
b.default.b1491409046 = Ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}分钟后" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}分钟前" }, "relative-type-0": "此刻" });
b.default.b970642223 = Ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}小时后" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}小时前" }, "relative-type-0": "这一时间 / 此时" });
b.default.a2013874593 = Ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0}分钟后" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0}分钟前" }, "relative-type-0": "此刻" });
b.default.a1259818553 = Ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 小時後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 小時前" }, "relative-type-0": "這一小時" });
b.default.b1996967671 = Ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 分鐘後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 分鐘前" }, "relative-type-0": "這一分鐘" });
b.default.b14293757 = Ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 小時後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 小時前" }, "relative-type-0": "這個小時" });
b.default.a1941749075 = Ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 分鐘後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 分鐘前" }, "relative-type-0": "這分鐘" });
b.default.b964977916 = Ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 小時後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 小時前" }, "relative-type-0": "這個小時" });
b.default.b1132660972 = Ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { "relativeTime-type-future": { "relativeTimePattern-count-other": "{0} 分鐘後" }, "relativeTime-type-past": { "relativeTimePattern-count-other": "{0} 分鐘前" }, "relative-type-0": "這分鐘" });
b.default.a1260780216 = ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { compoundUnitPattern: "{0} لكل {1}", unitProperties: { displayName: "بايت", zero: "{0} بايت", one: "{0} بايت", two: "{0} بايت", few: "{0} بايت", many: "{0} بايت", other: "{0} بايت" } });
b.default.b852797741 = ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "كيلوبايت", zero: "{0} كيلوبايت", one: "{0} كيلوبايت", two: "{0} كيلوبايت", few: "{0} كيلوبايت", many: "{0} كيلوبايت", other: "{0} كيلوبايت" } });
b.default.b614409566 = ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "ميغابايت", zero: "{0} ميغابايت", one: "{0} ميغابايت", two: "{0} ميغابايت", few: "{0} ميغابايت", many: "{0} ميغابايت", other: "{0} ميغابايت" } });
b.default.b1965047144 = ft((0, b.default)("ar-EG").numberFormatter({}), (0, b.default)("ar-EG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "غيغابايت", zero: "{0} غيغابايت", one: "{0} غيغابايت", two: "{0} غيغابايت", few: "{0} غيغابايت", many: "{0} غيغابايت", other: "{0} غيغابايت" } });
b.default.a1273411684 = ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { compoundUnitPattern: "{0} لكل {1}", unitProperties: { displayName: "بايت", zero: "{0} بايت", one: "{0} بايت", two: "{0} بايت", few: "{0} بايت", many: "{0} بايت", other: "{0} بايت" } });
b.default.b304462681 = ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "كيلوبايت", zero: "{0} كيلوبايت", one: "{0} كيلوبايت", two: "{0} كيلوبايت", few: "{0} كيلوبايت", many: "{0} كيلوبايت", other: "{0} كيلوبايت" } });
b.default.b66074506 = ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "ميغابايت", zero: "{0} ميغابايت", one: "{0} ميغابايت", two: "{0} ميغابايت", few: "{0} ميغابايت", many: "{0} ميغابايت", other: "{0} ميغابايت" } });
b.default.b1416712084 = ft((0, b.default)("ar-SA").numberFormatter({}), (0, b.default)("ar-SA").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "غيغابايت", zero: "{0} غيغابايت", one: "{0} غيغابايت", two: "{0} غيغابايت", few: "{0} غيغابايت", many: "{0} غيغابايت", other: "{0} غيغابايت" } });
b.default.b595460021 = ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { compoundUnitPattern: "{0} на {1}", unitProperties: { displayName: "байтове", one: "{0} байт", other: "{0} байта" } });
b.default.a946001184 = ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.a1184389359 = ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.b166248219 = ft((0, b.default)("bg").numberFormatter({}), (0, b.default)("bg").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b986086044 = ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.a1228904359 = ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.a1467292534 = ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a116654956 = ft((0, b.default)("ca").numberFormatter({}), (0, b.default)("ca").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.a278851446 = ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "bajty", one: "{0} bajt", few: "{0} bajty", many: "{0} bajtu", other: "{0} bajtů" } });
b.default.a1432594645 = ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", many: "{0} kB", other: "{0} kB" } });
b.default.a1670982820 = ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", many: "{0} MB", other: "{0} MB" } });
b.default.a320345242 = ft((0, b.default)("cs").numberFormatter({}), (0, b.default)("cs").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", many: "{0} GB", other: "{0} GB" } });
b.default.b955066237 = ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { compoundUnitPattern: "{0} pr. {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.a1579704296 = ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.a1818092471 = ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a467454893 = ft((0, b.default)("da").numberFormatter({}), (0, b.default)("da").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b673969017 = ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { compoundUnitPattern: "{0} pro {1}", unitProperties: { displayName: "Bytes", one: "{0} Byte", other: "{0} Bytes" } });
b.default.a1624968804 = ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kbyte", one: "{0} kB", other: "{0} kB" } });
b.default.a1863356979 = ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Mbyte", one: "{0} MB", other: "{0} MB" } });
b.default.a512719401 = ft((0, b.default)("de").numberFormatter({}), (0, b.default)("de").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Gigabyte", one: "{0} GB", other: "{0} GB" } });
b.default.a1996454573 = ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { compoundUnitPattern: "{0} ανά {1}", unitProperties: { displayName: "byte", one: "{0} byte", other: "{0} byte" } });
b.default.a2054981630 = ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b2001597491 = ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a942732227 = ft((0, b.default)("el").numberFormatter({}), (0, b.default)("el").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.a2137003183 = ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.a2077613884 = ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kByte", one: "{0} kB", other: "{0} kB" } });
b.default.b1978965237 = ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MByte", one: "{0} MB", other: "{0} MB" } });
b.default.a965364481 = ft((0, b.default)("en").numberFormatter({}), (0, b.default)("en").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GByte", one: "{0} GB", other: "{0} GB" } });
b.default.a340891060 = ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { compoundUnitPattern: "{0} por {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.a2134194519 = ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b1922384602 = ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1021945116 = ft((0, b.default)("es").numberFormatter({}), (0, b.default)("es").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b1736318283 = ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { compoundUnitPattern: "{0} {1} kohta", unitProperties: { displayName: "baidid", one: "{0} bait", other: "{0} baiti" } });
b.default.a2145510646 = ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b1911068475 = ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1033261243 = ft((0, b.default)("et").numberFormatter({}), (0, b.default)("et").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.a481439670 = ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "byte-ak", one: "{0} byte", other: "{0} byte" } });
b.default.b2138140523 = ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b1899752348 = ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1044577370 = ft((0, b.default)("eu").numberFormatter({}), (0, b.default)("eu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b330832183 = ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "tavut", one: "{0} tavu", other: "{0} tavua" } });
b.default.b1923134110 = ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kt", one: "{0} kt", other: "{0} kt" } });
b.default.b1684745935 = ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Mt", one: "{0} Mt", other: "{0} Mt" } });
b.default.a1259583783 = ft((0, b.default)("fi").numberFormatter({}), (0, b.default)("fi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Gt", one: "{0} Gt", other: "{0} Gt" } });
b.default.b1845847086 = ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { compoundUnitPattern: "{0} par {1}", unitProperties: { displayName: "octets", one: "{0} octet", other: "{0} octets" } });
b.default.b1821288967 = ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "ko", one: "{0} ko", other: "{0} ko" } });
b.default.b1582900792 = ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Mo", one: "{0} Mo", other: "{0} Mo" } });
b.default.a1361428926 = ft((0, b.default)("fr").numberFormatter({}), (0, b.default)("fr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Go", one: "{0} Go", other: "{0} Go" } });
b.default.a2058494187 = ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { compoundUnitPattern: "{0} por {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.b1538385792 = ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b1299997617 = ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1644332101 = ft((0, b.default)("gl").numberFormatter({}), (0, b.default)("gl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b549889789 = ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { compoundUnitPattern: "{0} ל{1}", unitProperties: { displayName: "בייט", one: "{0} בייט", two: "{0} בייט", many: "{0} בייט", other: "{0} בייט" } });
b.default.b1266798744 = ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", two: "{0} kB", many: "{0} kB", other: "{0} kB" } });
b.default.b1028410569 = ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", two: "{0} MB", many: "{0} MB", other: "{0} MB" } });
b.default.a1915919149 = ft((0, b.default)("he").numberFormatter({}), (0, b.default)("he").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", two: "{0} GB", many: "{0} GB", other: "{0} GB" } });
b.default.b268792569 = ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { compoundUnitPattern: "{0} प्रति {1}", unitProperties: { displayName: "बाइट", one: "{0} बाइट", other: "{0} बाइट" } });
b.default.b1221534236 = ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b983146061 = ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1961183657 = ft((0, b.default)("hi").numberFormatter({}), (0, b.default)("hi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b1783807472 = ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "bajtovi", one: "{0} bajt", few: "{0} bajta", other: "{0} bajtova" } });
b.default.b1119689093 = ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", other: "{0} kB" } });
b.default.b881300918 = ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", other: "{0} MB" } });
b.default.a2063028800 = ft((0, b.default)("hr").numberFormatter({}), (0, b.default)("hr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", other: "{0} GB" } });
b.default.a574499091 = ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "bájt", one: "{0} bájt", other: "{0} bájt" } });
b.default.b1085740712 = ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b847352537 = ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a2096977181 = ft((0, b.default)("hu").numberFormatter({}), (0, b.default)("hu").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.a1558339361 = ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "byte", other: "{0} byte" } });
b.default.b927314934 = ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kByte", other: "{0} kB" } });
b.default.b688926759 = ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MByte", other: "{0} MB" } });
b.default.b2039564337 = ft((0, b.default)("id").numberFormatter({}), (0, b.default)("id").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GByte", other: "{0} GB" } });
b.default.b1612239055 = ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { compoundUnitPattern: "{0} al {1}", unitProperties: { displayName: "byte", one: "{0} byte", other: "{0} byte" } });
b.default.b746256902 = ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b507868727 = ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.b1858506305 = ft((0, b.default)("it").numberFormatter({}), (0, b.default)("it").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b768947395 = ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { compoundUnitPattern: "{0}毎{1}", unitProperties: { displayName: "バイト", other: "{0} バイト" } });
b.default.b610463378 = ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "KB", other: "{0} KB" } });
b.default.b372075203 = ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.b1722712781 = ft((0, b.default)("ja").numberFormatter({}), (0, b.default)("ja").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.b35184538 = ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "байт", one: "{0} байт", other: "{0} байт" } });
b.default.b146502171 = ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "кбайт", one: "{0} кБ", other: "{0} кБ" } });
b.default.a91886004 = ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Мбайт", one: "{0} MБ", other: "{0} MБ" } });
b.default.b1258751574 = ft((0, b.default)("kk").numberFormatter({}), (0, b.default)("kk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Гбайт", one: "{0} ГБ", other: "{0} ГБ" } });
b.default.a245912682 = ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { compoundUnitPattern: "{1}당 {0}", unitProperties: { displayName: "바이트", other: "{0}바이트" } });
b.default.b101237663 = ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0}kB" } });
b.default.a137150512 = ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0}MB" } });
b.default.b1213487066 = ft((0, b.default)("ko").numberFormatter({}), (0, b.default)("ko").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0}GB" } });
b.default.b1519179634 = ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "baitai", one: "{0} baitas", few: "{0} baitai", many: "{0} baito", other: "{0} baitų" } });
b.default.a306142909 = ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", many: "{0} kB", other: "{0} kB" } });
b.default.a544531084 = ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", many: "{0} MB", other: "{0} MB" } });
b.default.b806106494 = ft((0, b.default)("lt").numberFormatter({}), (0, b.default)("lt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", many: "{0} GB", other: "{0} GB" } });
b.default.b1378631024 = ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "baiti", zero: "{0} baitu", one: "{0} baits", other: "{0} baiti" } });
b.default.a328775163 = ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", zero: "{0} kB", one: "{0} kB", other: "{0} kB" } });
b.default.a567163338 = ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", zero: "{0} MB", one: "{0} MB", other: "{0} MB" } });
b.default.b783474240 = ft((0, b.default)("lv").numberFormatter({}), (0, b.default)("lv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", zero: "{0} GB", one: "{0} GB", other: "{0} GB" } });
b.default.a589049516 = ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "bait", other: "{0} bait" } });
b.default.a645626719 = ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kBait", other: "{0} kB" } });
b.default.a884014894 = ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MBait", other: "{0} MB" } });
b.default.b466622684 = ft((0, b.default)("ms").numberFormatter({}), (0, b.default)("ms").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GBait", other: "{0} GB" } });
b.default.a1572889786 = ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "byte", one: "{0} byte", other: "{0} byte" } });
b.default.a804052497 = ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.a1042440672 = ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.b308196906 = ft((0, b.default)("nb").numberFormatter({}), (0, b.default)("nb").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b2019334460 = ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "byte", one: "{0} byte", other: "{0} byte" } });
b.default.a917213767 = ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.a1155601942 = ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.b195035636 = ft((0, b.default)("nl").numberFormatter({}), (0, b.default)("nl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b1957294846 = ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { compoundUnitPattern: "{0} na {1}", unitProperties: { displayName: "bajty", one: "{0} bajt", few: "{0} bajty", many: "{0} bajtów", other: "{0} bajta" } });
b.default.a1618813641 = ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB", one: "{0} kB", few: "{0} kB", many: "{0} kB" } });
b.default.a1857201816 = ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB", one: "{0} MB", few: "{0} MB", many: "{0} MB" } });
b.default.a506564238 = ft((0, b.default)("pl").numberFormatter({}), (0, b.default)("pl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB", one: "{0} GB", few: "{0} GB", many: "{0} GB" } });
b.default.b1395100406 = ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { compoundUnitPattern: "{0} por {1}", unitProperties: { displayName: "bytes", one: "{0} bytes", other: "{0} bytes" } });
b.default.a1709342657 = ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kByte", other: "{0} kB", one: "{0} kB" } });
b.default.a1947730832 = ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MByte", other: "{0} MB", one: "{0} MB" } });
b.default.a597093254 = ft((0, b.default)("pt").numberFormatter({}), (0, b.default)("pt").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GByte", other: "{0} GB", one: "{0} GB" } });
b.default.a1665198183 = ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { compoundUnitPattern: "{0} por {1}", unitProperties: { displayName: "bytes", one: "{0} byte", other: "{0} bytes" } });
b.default.a1283235460 = ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kByte", one: "{0} kB", other: "{0} kB" } });
b.default.a1521623635 = ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MByte", one: "{0} MB", other: "{0} MB" } });
b.default.a170986057 = ft((0, b.default)("pt-PT").numberFormatter({}), (0, b.default)("pt-PT").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GByte", one: "{0} GB", other: "{0} GB" } });
b.default.a463051331 = ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { compoundUnitPattern: "{0} pe {1}", unitProperties: { displayName: "byți", one: "{0} byte", few: "{0} byți", other: "{0} de byți" } });
b.default.b1940605400 = ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", other: "{0} kB" } });
b.default.b1702217225 = ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", other: "{0} MB" } });
b.default.a1242112493 = ft((0, b.default)("ro").numberFormatter({}), (0, b.default)("ro").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", other: "{0} GB" } });
b.default.a884697161 = ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "байты", one: "{0} байт", few: "{0} байта", many: "{0} байт", other: "{0} байта" } });
b.default.b1872708638 = ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "кБ", one: "{0} кБ", few: "{0} кБ", many: "{0} кБ", other: "{0} кБ" } });
b.default.b1634320463 = ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "МБ", one: "{0} МБ", few: "{0} МБ", many: "{0} МБ", other: "{0} МБ" } });
b.default.a1310009255 = ft((0, b.default)("ru").numberFormatter({}), (0, b.default)("ru").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "ГБ", one: "{0} ГБ", few: "{0} ГБ", many: "{0} ГБ", other: "{0} ГБ" } });
b.default.a212973918 = ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "bajty", one: "{0} bajt", few: "{0} bajty", many: "{0} bajtu", other: "{0} bajtov" } });
b.default.b1635069971 = ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", many: "{0} kB", other: "{0} kB" } });
b.default.b1396681796 = ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", many: "{0} MB", other: "{0} MB" } });
b.default.a1547647922 = ft((0, b.default)("sk").numberFormatter({}), (0, b.default)("sk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", many: "{0} GB", other: "{0} GB" } });
b.default.b1864235425 = ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { compoundUnitPattern: "{0} na {1}", unitProperties: { displayName: "bajt", one: "{0} bajt", two: "{0} bajta", few: "{0} bajti", other: "{0} bajtov" } });
b.default.b1623753844 = ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", two: "{0} kB", few: "{0} kB", other: "{0} kB" } });
b.default.b1385365669 = ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", two: "{0} MB", few: "{0} MB", other: "{0} MB" } });
b.default.a1558964049 = ft((0, b.default)("sl").numberFormatter({}), (0, b.default)("sl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", two: "{0} GB", few: "{0} GB", other: "{0} GB" } });
b.default.b1064685448 = ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "бајтови", one: "{0} бајт", few: "{0} бајта", other: "{0} бајтова" } });
b.default.b826099437 = ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", other: "{0} kB" } });
b.default.b587711262 = ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", other: "{0} MB" } });
b.default.b1938348840 = ft((0, b.default)("sr-Cyrl").numberFormatter({}), (0, b.default)("sr-Cyrl").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", other: "{0} GB" } });
b.default.b463658761 = ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "bajtovi", one: "{0} bajt", few: "{0} bajta", other: "{0} bajtova" } });
b.default.b1577238540 = ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", few: "{0} kB", other: "{0} kB" } });
b.default.b1338850365 = ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", few: "{0} MB", other: "{0} MB" } });
b.default.a1605479353 = ft((0, b.default)("sr-Latn").numberFormatter({}), (0, b.default)("sr-Latn").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", few: "{0} GB", other: "{0} GB" } });
b.default.b1161492375 = ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { compoundUnitPattern: "{0} per {1}", unitProperties: { displayName: "byte", one: "{0} byte", other: "{0} byte" } });
b.default.b1510592574 = ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b1272204399 = ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1672125319 = ft((0, b.default)("sv").numberFormatter({}), (0, b.default)("sv").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.b2114312838 = ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { compoundUnitPattern: "{0}ต่อ{1}", unitProperties: { displayName: "ไบต์", other: "{0} ไบต์" } });
b.default.b1318218415 = ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.b1079830240 = ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.a1864499478 = ft((0, b.default)("th").numberFormatter({}), (0, b.default)("th").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.b1411569788 = ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "bayt", one: "{0} bayt", other: "{0} bayt" } });
b.default.b1205057145 = ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", one: "{0} kB", other: "{0} kB" } });
b.default.b966668970 = ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", one: "{0} MB", other: "{0} MB" } });
b.default.a1977660748 = ft((0, b.default)("tr").numberFormatter({}), (0, b.default)("tr").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", one: "{0} GB", other: "{0} GB" } });
b.default.a275013532 = ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { compoundUnitPattern: "{0} на {1}", unitProperties: { displayName: "байти", one: "{0} байт", few: "{0} байти", many: "{0} байтів", other: "{0} байта" } });
b.default.b933470097 = ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "кбайт", one: "{0} кБ", few: "{0} кБ", many: "{0} кБ", other: "{0} кБ" } });
b.default.b695081922 = ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Мбайт", one: "{0} МБ", few: "{0} МБ", many: "{0} МБ", other: "{0} МБ" } });
b.default.b2045719500 = ft((0, b.default)("uk").numberFormatter({}), (0, b.default)("uk").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "Гбайт", one: "{0} ГБ", few: "{0} ГБ", many: "{0} ГБ", other: "{0} ГБ" } });
b.default.a165484729 = ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "byte", other: "{0} byte" } });
b.default.b605302414 = ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.b366914239 = ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.b1717551817 = ft((0, b.default)("vi").numberFormatter({}), (0, b.default)("vi").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.b1657704125 = ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { compoundUnitPattern: "每 {1} {0}", unitProperties: { displayName: "byte", other: "{0} byte" } });
b.default.a1393245992 = ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.a1631634167 = ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.a280996589 = ft((0, b.default)("yue").numberFormatter({}), (0, b.default)("yue").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.a915494743 = ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { compoundUnitPattern: "每{1}{0}", unitProperties: { displayName: "字节", other: "{0}字节" } });
b.default.a1506542996 = ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "千字节", other: "{0}千字节" } });
b.default.a1744931171 = ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "兆字节", other: "{0}兆字节" } });
b.default.a394293593 = ft((0, b.default)("zh-Hans").numberFormatter({}), (0, b.default)("zh-Hans").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "吉字节", other: "{0}吉字节" } });
b.default.b1803561142 = ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "字节", other: "{0}字节" } });
b.default.b692157055 = ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "千字节", other: "{0}千字节" } });
b.default.b453768880 = ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "兆字节", other: "{0}兆字节" } });
b.default.b1804406458 = ft((0, b.default)("zh-Hans-SG").numberFormatter({}), (0, b.default)("zh-Hans-SG").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "吉字节", other: "{0}吉字节" } });
b.default.b1161714600 = ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { compoundUnitPattern: "每{1} {0}", unitProperties: { displayName: "byte", other: "{0} byte" } });
b.default.a1517859123 = ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.a1756247298 = ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.a405609720 = ft((0, b.default)("zh-Hant").numberFormatter({}), (0, b.default)("zh-Hant").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.b2118418344 = ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { compoundUnitPattern: "{0}每{1}", unitProperties: { displayName: "位元組", other: "{0} 位元組" } });
b.default.a1900565811 = ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.a2138953986 = ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.a788316408 = ft((0, b.default)("zh-Hant-HK").numberFormatter({}), (0, b.default)("zh-Hant-HK").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
b.default.b1682222089 = ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { compoundUnitPattern: "{0}每{1}", unitProperties: { displayName: "位元組", other: "{0} 位元組" } });
b.default.b595137292 = ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "kB", other: "{0} kB" } });
b.default.b356749117 = ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "MB", other: "{0} MB" } });
b.default.b1707386695 = ft((0, b.default)("zh-Hant-MO").numberFormatter({}), (0, b.default)("zh-Hant-MO").pluralGenerator({}), { compoundUnitPattern: "{0}/{1}", unitProperties: { displayName: "GB", other: "{0} GB" } });
var yz = b.default, d$e = { clearSuggestedActions: CBe, dismissNotification: PBe, emitTypingIndicator: P0e, markActivity: dk, postActivity: ed, sendEvent: NBe, sendFiles: LBe, sendMessage: pk, sendMessageBack: M0e, sendPostBack: H0e, setDictateInterims: BBe, setDictateState: U0e, setNotification: b4, setSendBox: z0e, setSendBoxAttachments: Y0e, setSendTimeout: MBe, startDictate: K0e, startSpeakingActivity: J0e, stopDictate: mk, stopSpeakingActivity: Q0e, submitSendBox: HBe }, _z = Object.freeze([]);
function p$e({ cardActionMiddleware: e, directLine: t, dispatch: r, markAllAsAcknowledged: n, ponyfill: i }) {
  let o = ide("card action", ...e, s$e())({ dispatch: r });
  return { onCardAction: (a, { target: u } = {}) => (n(), o({ cardAction: a, getSignInUrl: a.type === "signin" ? () => {
    let { value: s } = a;
    return t.getSessionId ? f$e(t.getSessionId(), i).then((c) => `${s}${encodeURIComponent(`&code_challenge=${c}`)}`) : (console.warn("botframework-webchat: OAuth is not supported on this Direct Line adapter."), s);
  } : null, target: u })) };
}
function h$e({ groupActivitiesMiddleware: e, groupTimestamp: t, ponyfill: r }) {
  return { groupActivities: ide("group activities", ...e, l$e({ groupTimestamp: t, ponyfill: r }))({}) };
}
function v$e(e, t, r) {
  if (r) {
    if (typeof r == "function") {
      let n = r(e, t);
      if (!yS(n)) throw new Error("botframework-webchat: overrideLocalizedStrings function must return an object.");
      return n;
    }
  } else return e;
  if (!yS(r)) throw new Error("botframework-webchat: overrideLocalizedStrings must be either a function, an object, or falsy.");
  return { ...e, ...r };
}
var jk = ({ activityMiddleware: e, activityStatusMiddleware: t, attachmentForScreenReaderMiddleware: r, attachmentMiddleware: n, avatarMiddleware: i, cardActionMiddleware: o, children: a, dir: u, directLine: s, disabled: c, downscaleImageToDataURL: l, grammars: f, groupActivitiesMiddleware: d, internalErrorBoxClass: p, locale: v, onTelemetry: h, overrideLocalizedStrings: E, renderMarkdown: m, scrollToEndButtonMiddleware: g, selectVoice: y, sendBoxMiddleware: _, sendBoxToolbarMiddleware: S, sendTypingIndicator: A, styleOptions: O, toastMiddleware: P, typingIndicatorMiddleware: U, userID: z, username: k }) => {
  let [H] = ac(), B = NFe(), x = Ut({}), D = tt(() => u === "ltr" || u === "rtl" ? u : "auto", [u]), w = tt(() => f || [], [f]), $ = tt(() => Zb(xFe(O)), [O]);
  nr(() => {
    B(kBe(v));
  }, [B, v]), nr(() => {
    B(FBe(!!A));
  }, [B, A]), nr(() => (B(OBe({ directLine: s, userID: z, username: k })), () => {
    B(RBe());
  }), [B, s, z, k]);
  let X = Zfe(), V = tt(() => p$e({ cardActionMiddleware: Object.freeze([...Li(o)]), directLine: s, dispatch: B, markAllAsAcknowledged: X, ponyfill: H }), [o, s, B, X, H]), F = tt(() => y || i$e.bind(null, { language: v }), [v, y]), le = tt(() => h$e({ groupActivitiesMiddleware: Object.freeze([...Li(d)]), groupTimestamp: $.groupTimestamp, ponyfill: H }), [d, $.groupTimestamp, H]), ae = tt(() => WHe(d$e, (et) => (...St) => B(et(...St))), [B]), ne = tt(() => v$e(kfe()[KHe(v)], v, E), [v, E]), ve = tt(() => {
    let { GLOBALIZE: et, GLOBALIZE_LANGUAGE: St } = ne || {};
    return et || St && yz(St) || yz("en");
  }, [ne]), Ie = mt((et, St) => {
    if (!et || typeof et != "string") return console.warn("botframework-webchat: Telemetry dimension name must be a string.");
    let Ot = typeof St;
    if (Ot !== "string" && Ot !== "undefined") return console.warn("botframework-webchat: Telemetry dimension data must be a string or undefined.");
    x.current = Xr(x.current, [et], Ot === "undefined" ? St : () => St);
  }, [x]), Oe = tt(() => R0("activity", { strict: !1 }, ...Li(e), () => () => ({ activity: et }) => {
    throw et ? new Error(`No renderer for activity of type "${et.type}"`) : new Error("No activity to render");
  })({}), [e]), xe = tt(() => R0("activity status", { strict: !1 }, ...Li(t), () => () => () => !1)({}), [t]), ze = tt(() => R0("attachment for screen reader", { strict: !0 }, ...Li(r), () => () => ({ attachment: et }) => et ? (console.warn(`No renderer for attachment for screen reader of type "${et.contentType}"`), !1) : () => {
    throw new Error("No attachment to render");
  })({}), [r]), qe = tt(() => u$e("attachment", ...Li(n), () => () => ({ attachment: et }) => {
    throw et ? new Error(`No renderer for attachment of type "${et.contentType}"`) : new Error("No attachment to render");
  })({}), [n]), Je = tt(() => R0("avatar", { strict: !1 }, ...Li(i), () => () => () => !1)({}), [i]), Be = tt(() => R0("toast", { strict: !1 }, ...Li(P), () => () => ({ notification: et }) => {
    throw et ? new Error(`No renderer for notification of type "${et.contentType}"`) : new Error("No notification to render");
  })({}), [P]), We = tt(() => R0("typing indicator", { strict: !1 }, ...Li(U), () => () => () => !1)({}), [U]), Ne = tt(() => R0("scroll to end button", { strict: !0 }, ...Li(g), () => () => () => !1)(), [g]), je = tt(() => ({ ...V, ...le, ...ae, activityRenderer: Oe, activityStatusRenderer: xe, attachmentForScreenReaderRenderer: ze, attachmentRenderer: qe, avatarRenderer: Je, dir: D, directLine: s, disabled: c, downscaleImageToDataURL: l, grammars: w, internalErrorBoxClass: p, language: v, localizedGlobalizeState: [ve], localizedStrings: ne, onTelemetry: h, renderMarkdown: m, scrollToEndButtonRenderer: Ne, selectVoice: F, sendTypingIndicator: A, styleOptions: $, telemetryDimensionsRef: x, toastRenderer: Be, trackDimension: Ie, typingIndicatorRenderer: We, userID: z, username: k }), [V, s, c, l, le, ae, p, v, ve, h, Oe, xe, ze, qe, Je, D, w, ne, F, $, Be, We, m, Ne, A, x, Ie, z, k]);
  return G.createElement(Cfe.Provider, { value: je }, G.createElement(KFe, null, G.createElement(MHe, null, G.createElement(YHe, null, G.createElement(XHe, { middleware: _ || _z }, G.createElement(ZHe, { middleware: S || _z }, typeof a == "function" ? a(je) : a, G.createElement(HHe, null)))))), h && G.createElement(n$e, null));
};
jk.defaultProps = { activityMiddleware: void 0, activityStatusMiddleware: void 0, attachmentForScreenReaderMiddleware: void 0, attachmentMiddleware: void 0, avatarMiddleware: void 0, cardActionMiddleware: void 0, children: void 0, dir: "auto", disabled: !1, downscaleImageToDataURL: void 0, grammars: [], groupActivitiesMiddleware: void 0, internalErrorBoxClass: void 0, locale: window.navigator.language || "en-US", onTelemetry: void 0, overrideLocalizedStrings: void 0, renderMarkdown: void 0, scrollToEndButtonMiddleware: void 0, selectVoice: void 0, sendTypingIndicator: !1, styleOptions: {}, toastMiddleware: void 0, typingIndicatorMiddleware: void 0, userID: "", username: "" };
jk.propTypes = { activityMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), activityStatusMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), attachmentForScreenReaderMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), attachmentMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), avatarMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), cardActionMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), children: Q.any, dir: Q.oneOf(["auto", "ltr", "rtl"]), directLine: Q.shape({ activity$: Q.shape({ subscribe: Q.func.isRequired }).isRequired, connectionStatus$: Q.shape({ subscribe: Q.func.isRequired }).isRequired, end: Q.func, getSessionId: Q.func, postActivity: Q.func.isRequired, referenceGrammarID: Q.string, token: Q.string }).isRequired, disabled: Q.bool, downscaleImageToDataURL: Q.func, grammars: Q.arrayOf(Q.string), groupActivitiesMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), internalErrorBoxClass: Q.func, locale: Q.string, onTelemetry: Q.func, overrideLocalizedStrings: Q.oneOfType([Q.any, Q.func]), renderMarkdown: Q.func, scrollToEndButtonMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), selectVoice: Q.func, sendTypingIndicator: Q.bool, styleOptions: Q.any, toastMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), typingIndicatorMiddleware: Q.oneOfType([Q.arrayOf(Q.func), Q.func]), userID: Q.string, username: Q.string };
var WT = ({ onTelemetry: e, store: t, ...r }) => {
  let [n] = ac(), i = tt(() => {
    var f;
    let o = t || Ck({ ponyfill: n }), a = ((f = o.getState().internal) == null ? void 0 : f.ponyfill) || {}, u = /* @__PURE__ */ new Set([...Object.keys(a), ...Object.keys(n)]);
    u.delete("prototype"), Object.getOwnPropertyNames(Object.prototype).forEach((d) => {
      u.delete(d);
    });
    let s = (d) => typeof d == "function" && ("" + d).endsWith("() { [native code] }"), c = (d, p) => s(d) && s(p) || d === p, l = Array.from(u).filter((d) => !c(a[d], n[d]));
    return l.length && console.warn(`botframework-webchat: Ponyfill used in store should match the ponyfill passed in props: ${l.join(", ")}`), o;
  }, [n, t]);
  return G.createElement(Rfe, { context: LFe, store: i }, G.createElement(YFe, null, G.createElement(FFe, null, G.createElement(jk, { onTelemetry: e, ...r }))));
};
WT.defaultProps = { onTelemetry: void 0, store: void 0 };
WT.propTypes = { onTelemetry: Q.func, store: Q.any };
var zk = ({ internalRenderErrorBox: e, onTelemetry: t, ponyfill: r, ...n }) => {
  let [i, o] = cn(), a = mt((u) => {
    console.error("botframework-webchat: Uncaught exception", { error: u }), t && t(V1("exception", { error: u, fatal: !0 })), o(u);
  }, [t, o]);
  return i ? !!e && e({ error: i, type: "uncaught exception" }) : G.createElement(nde, { onError: a }, G.createElement(GHe, { ponyfill: r }, G.createElement(WT, { onTelemetry: t, ...n })));
};
zk.defaultProps = { ...WT.defaultProps, internalRenderErrorBox: void 0, onTelemetry: void 0, ponyfill: void 0 };
zk.propTypes = { ...WT.propTypes, internalRenderErrorBox: Q.any, onTelemetry: Q.func, ponyfill: Q.any };
var qk = zk, E$e = "tsup", m$e = "esmodules", g$e = "4.18.0", uO = { buildTool: E$e, moduleFormat: m$e, version: g$e };
/*! For license information please see botframework-webchat-api.mjs.LEGAL.txt */
var ode = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var u = arguments[a];
        u && (o = i(o, n(u)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var u in o)
        t.call(o, u) && o[u] && (a = i(a, u));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(ode);
var T$e = ode.exports;
const Gt = /* @__PURE__ */ Mt(T$e);
function y$e(e, t) {
  try {
    var r = global, n = r.document;
    if (typeof n < "u" && n.createElement && n.head && n.head.appendChild) {
      var i = n.querySelector('html meta[name="'.concat(encodeURI(e), '"]')) || n.createElement("meta");
      i.setAttribute("name", e), i.setAttribute("content", t), n.head.appendChild(i);
    }
  } catch {
  }
}
function _$e() {
  y$e("react-scroll-to-bottom:version", "4.2.0");
}
var A$e = i0, rd = Array.isArray || function(t) {
  return A$e(t) === "Array";
}, S$e = Zt, b$e = rd;
S$e({ target: "Array", stat: !0 }, {
  isArray: b$e
});
var C$e = Pn, I$e = C$e.Array.isArray, O$e = I$e, ade = O$e, R$e = ade, w$e = R$e, P$e = w$e, D$e = P$e, ude = D$e;
const Yk = /* @__PURE__ */ Mt(ude);
function x$e(e) {
  if (Yk(e)) return e;
}
var N$e = TypeError, L$e = 9007199254740991, Gk = function(e) {
  if (e > L$e) throw N$e("Maximum allowed index exceeded");
  return e;
}, B$e = Hi, k$e = Ha, M$e = Yf, Ph = function(e, t, r) {
  B$e ? k$e.f(e, t, M$e(0, r)) : e[t] = r;
}, Az = rd, F$e = Yb, H$e = $i, $$e = Oi, U$e = $$e("species"), Sz = Array, V$e = function(e) {
  var t;
  return Az(e) && (t = e.constructor, F$e(t) && (t === Sz || Az(t.prototype)) ? t = void 0 : H$e(t) && (t = t[U$e], t === null && (t = void 0))), t === void 0 ? Sz : t;
}, j$e = V$e, Wk = function(e, t) {
  return new (j$e(e))(t === 0 ? 0 : t);
}, z$e = mn, q$e = Oi, Y$e = DT, G$e = q$e("species"), KT = function(e) {
  return Y$e >= 51 || !z$e(function() {
    var t = [], r = t.constructor = {};
    return r[G$e] = function() {
      return { foo: 1 };
    }, t[e](Boolean).foo !== 1;
  });
}, W$e = Zt, K$e = mn, X$e = rd, J$e = $i, Z$e = cu, Q$e = As, bz = Gk, Cz = Ph, eUe = Wk, tUe = KT, rUe = Oi, nUe = DT, sde = rUe("isConcatSpreadable"), iUe = nUe >= 51 || !K$e(function() {
  var e = [];
  return e[sde] = !1, e.concat()[0] !== e;
}), oUe = function(e) {
  if (!J$e(e)) return !1;
  var t = e[sde];
  return t !== void 0 ? !!t : X$e(e);
}, aUe = !iUe || !tUe("concat");
W$e({ target: "Array", proto: !0, arity: 1, forced: aUe }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(t) {
    var r = Z$e(this), n = eUe(r, 0), i = 0, o, a, u, s, c;
    for (o = -1, u = arguments.length; o < u; o++)
      if (c = o === -1 ? r : arguments[o], oUe(c))
        for (s = Q$e(c), bz(i + s), a = 0; a < s; a++, i++) a in c && Cz(n, i, c[a]);
      else
        bz(i + 1), Cz(n, i++, c);
    return n.length = i, n;
  }
});
var rC = {}, uUe = i0, sUe = Hu, cde = BT.f, cUe = Jf, lde = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], lUe = function(e) {
  try {
    return cde(e);
  } catch {
    return cUe(lde);
  }
};
rC.f = function(t) {
  return lde && uUe(t) === "Window" ? lUe(t) : cde(sUe(t));
};
var Dh = {}, fUe = Oi;
Dh.f = fUe;
var Iz = Pn, dUe = Co, pUe = Dh, hUe = Ha.f, gi = function(e) {
  var t = Iz.Symbol || (Iz.Symbol = {});
  dUe(t, e) || hUe(t, e, {
    value: pUe.f(e)
  });
}, vUe = po, EUe = zo, mUe = Oi, gUe = gh, fde = function() {
  var e = EUe("Symbol"), t = e && e.prototype, r = t && t.valueOf, n = mUe("toPrimitive");
  t && !t[n] && gUe(t, n, function(i) {
    return vUe(r, this);
  }, { arity: 1 });
}, TUe = Kf, yUe = bn, _Ue = Mb, AUe = cu, SUe = As, bUe = Wk, Oz = yUe([].push), Il = function(e) {
  var t = e === 1, r = e === 2, n = e === 3, i = e === 4, o = e === 6, a = e === 7, u = e === 5 || o;
  return function(s, c, l, f) {
    for (var d = AUe(s), p = _Ue(d), v = SUe(p), h = TUe(c, l), E = 0, m = f || bUe, g = t ? m(s, v) : r || a ? m(s, 0) : void 0, y, _; v > E; E++) if ((u || E in p) && (y = p[E], _ = h(y, E, d), e))
      if (t) g[E] = _;
      else if (_) switch (e) {
        case 3:
          return !0;
        case 5:
          return y;
        case 6:
          return E;
        case 2:
          Oz(g, y);
      }
      else switch (e) {
        case 4:
          return !1;
        case 7:
          Oz(g, y);
      }
    return o ? -1 : n || i ? i : g;
  };
}, c0 = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Il(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Il(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Il(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Il(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Il(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Il(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Il(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Il(7)
}, nC = Zt, XT = Mn, Kk = po, CUe = bn, $p = Hi, Up = hh, IUe = mn, Ao = Co, OUe = Qi, gL = $a, iC = Hu, Xk = W8, RUe = a0, TL = Yf, Vp = Xf, dde = FT, wUe = BT, pde = rC, PUe = MT, hde = fh, vde = Ha, DUe = Ub, Ede = PT, Rz = gh, xUe = rk, Jk = vh, NUe = Hb, mde = kT, wz = Fb, LUe = Oi, BUe = Dh, kUe = gi, MUe = fde, FUe = s0, gde = u0, oC = c0.forEach, Da = NUe("hidden"), aC = "Symbol", j1 = "prototype", HUe = gde.set, Pz = gde.getterFor(aC), fs = Object[j1], bf = XT.Symbol, Qg = bf && bf[j1], $Ue = XT.RangeError, UUe = XT.TypeError, sO = XT.QObject, Tde = hde.f, Cf = vde.f, yde = pde.f, VUe = Ede.f, _de = CUe([].push), Yc = Jk("symbols"), JT = Jk("op-symbols"), jUe = Jk("wks"), yL = !sO || !sO[j1] || !sO[j1].findChild, Ade = function(e, t, r) {
  var n = Tde(fs, t);
  n && delete fs[t], Cf(e, t, r), n && e !== fs && Cf(fs, t, n);
}, _L = $p && IUe(function() {
  return Vp(Cf({}, "a", {
    get: function() {
      return Cf(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? Ade : Cf, cO = function(e, t) {
  var r = Yc[e] = Vp(Qg);
  return HUe(r, {
    type: aC,
    tag: e,
    description: t
  }), $p || (r.description = t), r;
}, uC = function(t, r, n) {
  t === fs && uC(JT, r, n), gL(t);
  var i = Xk(r);
  return gL(n), Ao(Yc, i) ? (n.enumerable ? (Ao(t, Da) && t[Da][i] && (t[Da][i] = !1), n = Vp(n, { enumerable: TL(0, !1) })) : (Ao(t, Da) || Cf(t, Da, TL(1, Vp(null))), t[Da][i] = !0), _L(t, i, n)) : Cf(t, i, n);
}, Zk = function(t, r) {
  gL(t);
  var n = iC(r), i = dde(n).concat(Ide(n));
  return oC(i, function(o) {
    (!$p || Kk(Sde, n, o)) && uC(t, o, n[o]);
  }), t;
}, zUe = function(t, r) {
  return r === void 0 ? Vp(t) : Zk(Vp(t), r);
}, Sde = function(t) {
  var r = Xk(t), n = Kk(VUe, this, r);
  return this === fs && Ao(Yc, r) && !Ao(JT, r) ? !1 : n || !Ao(this, r) || !Ao(Yc, r) || Ao(this, Da) && this[Da][r] ? n : !0;
}, bde = function(t, r) {
  var n = iC(t), i = Xk(r);
  if (!(n === fs && Ao(Yc, i) && !Ao(JT, i))) {
    var o = Tde(n, i);
    return o && Ao(Yc, i) && !(Ao(n, Da) && n[Da][i]) && (o.enumerable = !0), o;
  }
}, Cde = function(t) {
  var r = yde(iC(t)), n = [];
  return oC(r, function(i) {
    !Ao(Yc, i) && !Ao(mde, i) && _de(n, i);
  }), n;
}, Ide = function(e) {
  var t = e === fs, r = yde(t ? JT : iC(e)), n = [];
  return oC(r, function(i) {
    Ao(Yc, i) && (!t || Ao(fs, i)) && _de(n, Yc[i]);
  }), n;
};
Up || (bf = function() {
  if (OUe(Qg, this)) throw new UUe("Symbol is not a constructor");
  var t = !arguments.length || arguments[0] === void 0 ? void 0 : RUe(arguments[0]), r = wz(t), n = function(i) {
    var o = this === void 0 ? XT : this;
    o === fs && Kk(n, JT, i), Ao(o, Da) && Ao(o[Da], r) && (o[Da][r] = !1);
    var a = TL(1, i);
    try {
      _L(o, r, a);
    } catch (u) {
      if (!(u instanceof $Ue)) throw u;
      Ade(o, r, a);
    }
  };
  return $p && yL && _L(fs, r, { configurable: !0, set: n }), cO(r, t);
}, Qg = bf[j1], Rz(Qg, "toString", function() {
  return Pz(this).tag;
}), Rz(bf, "withoutSetter", function(e) {
  return cO(wz(e), e);
}), Ede.f = Sde, vde.f = uC, DUe.f = Zk, hde.f = bde, wUe.f = pde.f = Cde, PUe.f = Ide, BUe.f = function(e) {
  return cO(LUe(e), e);
}, $p && xUe(Qg, "description", {
  configurable: !0,
  get: function() {
    return Pz(this).description;
  }
}));
nC({ global: !0, constructor: !0, wrap: !0, forced: !Up, sham: !Up }, {
  Symbol: bf
});
oC(dde(jUe), function(e) {
  kUe(e);
});
nC({ target: aC, stat: !0, forced: !Up }, {
  useSetter: function() {
    yL = !0;
  },
  useSimple: function() {
    yL = !1;
  }
});
nC({ target: "Object", stat: !0, forced: !Up, sham: !$p }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: zUe,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: uC,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Zk,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: bde
});
nC({ target: "Object", stat: !0, forced: !Up }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: Cde
});
MUe();
FUe(bf, aC);
mde[Da] = !0;
var qUe = hh, Ode = qUe && !!Symbol.for && !!Symbol.keyFor, YUe = Zt, GUe = zo, WUe = Co, KUe = a0, Rde = vh, XUe = Ode, lO = Rde("string-to-symbol-registry"), JUe = Rde("symbol-to-string-registry");
YUe({ target: "Symbol", stat: !0, forced: !XUe }, {
  for: function(e) {
    var t = KUe(e);
    if (WUe(lO, t)) return lO[t];
    var r = GUe("Symbol")(t);
    return lO[t] = r, JUe[r] = t, r;
  }
});
var ZUe = Zt, QUe = Co, eVe = xT, tVe = Wf, rVe = vh, nVe = Ode, Dz = rVe("symbol-to-string-registry");
ZUe({ target: "Symbol", stat: !0, forced: !nVe }, {
  keyFor: function(t) {
    if (!eVe(t)) throw new TypeError(tVe(t) + " is not a symbol");
    if (QUe(Dz, t)) return Dz[t];
  }
});
var iVe = bn, xz = rd, oVe = Fi, Nz = i0, aVe = a0, Lz = iVe([].push), uVe = function(e) {
  if (oVe(e)) return e;
  if (xz(e)) {
    for (var t = e.length, r = [], n = 0; n < t; n++) {
      var i = e[n];
      typeof i == "string" ? Lz(r, i) : (typeof i == "number" || Nz(i) === "Number" || Nz(i) === "String") && Lz(r, aVe(i));
    }
    var o = r.length, a = !0;
    return function(u, s) {
      if (a)
        return a = !1, s;
      if (xz(this)) return s;
      for (var c = 0; c < o; c++) if (r[c] === u) return s;
    };
  }
}, sVe = Zt, wde = zo, Pde = qf, cVe = po, ZT = bn, Dde = mn, Bz = Fi, kz = xT, xde = Jf, lVe = uVe, fVe = hh, dVe = String, Gl = wde("JSON", "stringify"), W_ = ZT(/./.exec), Mz = ZT("".charAt), pVe = ZT("".charCodeAt), hVe = ZT("".replace), vVe = ZT(1 .toString), EVe = /[\uD800-\uDFFF]/g, Fz = /^[\uD800-\uDBFF]$/, Hz = /^[\uDC00-\uDFFF]$/, $z = !fVe || Dde(function() {
  var e = wde("Symbol")("stringify detection");
  return Gl([e]) !== "[null]" || Gl({ a: e }) !== "{}" || Gl(Object(e)) !== "{}";
}), Uz = Dde(function() {
  return Gl("\uDF06\uD834") !== '"\\udf06\\ud834"' || Gl("\uDEAD") !== '"\\udead"';
}), mVe = function(e, t) {
  var r = xde(arguments), n = lVe(t);
  if (!(!Bz(n) && (e === void 0 || kz(e))))
    return r[1] = function(i, o) {
      if (Bz(n) && (o = cVe(n, this, dVe(i), o)), !kz(o)) return o;
    }, Pde(Gl, null, r);
}, gVe = function(e, t, r) {
  var n = Mz(r, t - 1), i = Mz(r, t + 1);
  return W_(Fz, e) && !W_(Hz, i) || W_(Hz, e) && !W_(Fz, n) ? "\\u" + vVe(pVe(e, 0), 16) : e;
};
Gl && sVe({ target: "JSON", stat: !0, arity: 3, forced: $z || Uz }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(t, r, n) {
    var i = xde(arguments), o = Pde($z ? mVe : Gl, null, i);
    return Uz && typeof o == "string" ? hVe(o, EVe, gVe) : o;
  }
});
var TVe = Zt, yVe = hh, _Ve = mn, Nde = MT, AVe = cu, SVe = !yVe || _Ve(function() {
  Nde.f(1);
});
TVe({ target: "Object", stat: !0, forced: SVe }, {
  getOwnPropertySymbols: function(t) {
    var r = Nde.f;
    return r ? r(AVe(t)) : [];
  }
});
var bVe = gi;
bVe("asyncIterator");
var CVe = gi;
CVe("hasInstance");
var IVe = gi;
IVe("isConcatSpreadable");
var OVe = gi;
OVe("iterator");
var RVe = gi;
RVe("match");
var wVe = gi;
wVe("matchAll");
var PVe = gi;
PVe("replace");
var DVe = gi;
DVe("search");
var xVe = gi;
xVe("species");
var NVe = gi;
NVe("split");
var LVe = gi, BVe = fde;
LVe("toPrimitive");
BVe();
var kVe = zo, MVe = gi, FVe = s0;
MVe("toStringTag");
FVe(kVe("Symbol"), "Symbol");
var HVe = gi;
HVe("unscopables");
var $Ve = Mn, UVe = s0;
UVe($Ve.JSON, "JSON", !0);
var VVe = Pn, jVe = VVe.Symbol, zVe = jVe, Lde = zVe, qVe = Oi, YVe = Ha.f, Vz = qVe("metadata"), jz = Function.prototype;
jz[Vz] === void 0 && YVe(jz, Vz, {
  value: null
});
var GVe = gi;
GVe("asyncDispose");
var WVe = gi;
WVe("dispose");
var KVe = gi;
KVe("metadata");
var XVe = Lde, JVe = XVe, ZVe = zo, QVe = bn, Qk = ZVe("Symbol"), eje = Qk.keyFor, tje = QVe(Qk.prototype.valueOf), Bde = Qk.isRegisteredSymbol || function(t) {
  try {
    return eje(tje(t)) !== void 0;
  } catch {
    return !1;
  }
}, rje = Zt, nje = Bde;
rje({ target: "Symbol", stat: !0 }, {
  isRegisteredSymbol: nje
});
var ije = vh, kde = zo, oje = bn, aje = xT, uje = Oi, _S = kde("Symbol"), zz = _S.isWellKnownSymbol, Mde = kde("Object", "getOwnPropertyNames"), sje = oje(_S.prototype.valueOf), qz = ije("wks");
for (var fO = 0, Yz = Mde(_S), cje = Yz.length; fO < cje; fO++)
  try {
    var Gz = Yz[fO];
    aje(_S[Gz]) && uje(Gz);
  } catch {
  }
var Fde = function(t) {
  if (zz && zz(t)) return !0;
  try {
    for (var r = sje(t), n = 0, i = Mde(qz), o = i.length; n < o; n++)
      if (qz[i[n]] == r) return !0;
  } catch {
  }
  return !1;
}, lje = Zt, fje = Fde;
lje({ target: "Symbol", stat: !0, forced: !0 }, {
  isWellKnownSymbol: fje
});
var dje = gi;
dje("customMatcher");
var pje = gi;
pje("observable");
var hje = Zt, vje = Bde;
hje({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, {
  isRegistered: vje
});
var Eje = Zt, mje = Fde;
Eje({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, {
  isWellKnown: mje
});
var gje = gi;
gje("matcher");
var Tje = gi;
Tje("metadataKey");
var yje = gi;
yje("patternMatch");
var _je = gi;
_je("replaceAll");
var Aje = JVe, Sje = Aje, Hde = Sje;
const hf = /* @__PURE__ */ Mt(Hde);
var bje = Vb, Cje = bje, Ije = Cje, Oje = Ije, Rje = Oje, wje = Rje, Pje = wje, Dje = Pje, $de = Dje;
const e9 = /* @__PURE__ */ Mt($de);
var xje = Hi, Nje = rd, Lje = TypeError, Bje = Object.getOwnPropertyDescriptor, kje = xje && !function() {
  if (this !== void 0) return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (e) {
    return e instanceof TypeError;
  }
}(), Ude = kje ? function(e, t) {
  if (Nje(e) && !Bje(e, "length").writable)
    throw new Lje("Cannot set read only .length");
  return e.length = t;
} : function(e, t) {
  return e.length = t;
}, Mje = Zt, Fje = cu, Hje = As, $je = Ude, Uje = Gk, Vje = mn, jje = Vje(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), zje = function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (e) {
    return e instanceof TypeError;
  }
}, qje = jje || !zje();
Mje({ target: "Array", proto: !0, arity: 1, forced: qje }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(t) {
    var r = Fje(this), n = Hje(r), i = arguments.length;
    Uje(n + i);
    for (var o = 0; o < i; o++)
      r[n] = arguments[o], n++;
    return $je(r, n), n;
  }
});
var Yje = Mn, Gje = Pn, Aa = function(e, t) {
  var r = Gje[e + "Prototype"], n = r && r[t];
  if (n) return n;
  var i = Yje[e], o = i && i.prototype;
  return o && o[t];
}, Wje = Aa, Kje = Wje("Array", "push"), Xje = Qi, Jje = Kje, dO = Array.prototype, Zje = function(e) {
  var t = e.push;
  return e === dO || Xje(dO, e) && t === dO.push ? Jje : t;
}, Qje = Zje, eze = Qje, tze = eze, rze = tze, nze = rze, ize = nze, oze = ize;
const aze = /* @__PURE__ */ Mt(oze);
function uze(e, t) {
  var r = e == null ? null : typeof hf < "u" && e9(e) || e["@@iterator"];
  if (r != null) {
    var n, i, o, a, u = [], s = !0, c = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = o.call(r)).done) && (aze(u).call(u, n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (a = r.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
var sze = Zt, Wz = rd, cze = Yb, lze = $i, Kz = $b, fze = As, dze = Hu, pze = Ph, hze = Oi, vze = KT, Eze = Jf, mze = vze("slice"), gze = hze("species"), pO = Array, Tze = Math.max;
sze({ target: "Array", proto: !0, forced: !mze }, {
  slice: function(t, r) {
    var n = dze(this), i = fze(n), o = Kz(t, i), a = Kz(r === void 0 ? i : r, i), u, s, c;
    if (Wz(n) && (u = n.constructor, cze(u) && (u === pO || Wz(u.prototype)) ? u = void 0 : lze(u) && (u = u[gze], u === null && (u = void 0)), u === pO || u === void 0))
      return Eze(n, o, a);
    for (s = new (u === void 0 ? pO : u)(Tze(a - o, 0)), c = 0; o < a; o++, c++) o in n && pze(s, c, n[o]);
    return s.length = c, s;
  }
});
var yze = Aa, _ze = yze("Array", "slice"), Aze = Qi, Sze = _ze, hO = Array.prototype, bze = function(e) {
  var t = e.slice;
  return e === hO || Aze(hO, e) && t === hO.slice ? Sze : t;
}, Cze = bze, t9 = Cze, Ize = t9, Oze = Ize, Rze = Oze, wze = Rze, Vde = wze;
const Pze = /* @__PURE__ */ Mt(Vde);
var Dze = $a, xze = jb, Nze = function(e, t, r, n) {
  try {
    return n ? t(Dze(r)[0], r[1]) : t(r);
  } catch (i) {
    xze(e, "throw", i);
  }
}, Lze = Kf, Bze = po, kze = cu, Mze = Nze, Fze = Ele, Hze = Yb, $ze = As, Xz = Ph, Uze = gle, Vze = Vb, Jz = Array, jze = function(t) {
  var r = kze(t), n = Hze(this), i = arguments.length, o = i > 1 ? arguments[1] : void 0, a = o !== void 0;
  a && (o = Lze(o, i > 2 ? arguments[2] : void 0));
  var u = Vze(r), s = 0, c, l, f, d, p, v;
  if (u && !(this === Jz && Fze(u)))
    for (l = n ? new this() : [], d = Uze(r, u), p = d.next; !(f = Bze(p, d)).done; s++)
      v = a ? Mze(d, o, [f.value, s], !0) : f.value, Xz(l, s, v);
  else
    for (c = $ze(r), l = n ? new this(c) : Jz(c); c > s; s++)
      v = a ? o(r[s], s) : r[s], Xz(l, s, v);
  return l.length = s, l;
}, zze = Zt, qze = jze, Yze = i0e, Gze = !Yze(function(e) {
  Array.from(e);
});
zze({ target: "Array", stat: !0, forced: Gze }, {
  from: qze
});
var Wze = Pn, Kze = Wze.Array.from, Xze = Kze, Jze = Xze, Zze = Jze, Qze = Zze, eqe = Qze, tqe = eqe, jde = tqe;
const zde = /* @__PURE__ */ Mt(jde);
function AL(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function r9(e, t) {
  if (e) {
    var r;
    if (typeof e == "string") return AL(e, t);
    var n = Pze(r = {}.toString.call(e)).call(r, 8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? zde(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? AL(e, t) : void 0;
  }
}
function rqe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function as(e, t) {
  return x$e(e) || uze(e, t) || r9(e, t) || rqe();
}
var qde = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            n.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var u = r.apply(null, o);
              u && n.push(u);
            }
          } else if (a === "object")
            if (o.toString === Object.prototype.toString)
              for (var s in o)
                t.call(o, s) && o[s] && n.push(s);
            else
              n.push(o.toString());
        }
      }
      return n.join(" ");
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(qde);
var nqe = qde.exports;
const iqe = /* @__PURE__ */ Mt(nqe);
var SL = { exports: {} }, vO, Zz;
function n9() {
  if (Zz) return vO;
  Zz = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return vO = e, vO;
}
var EO, Qz;
function oqe() {
  if (Qz) return EO;
  Qz = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = n9(), r = {}, n = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in o)
        if (n(o, l)) {
          var f;
          try {
            if (typeof o[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[l](a, l, s, u, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, EO = i, EO;
}
var mO, eq;
function aqe() {
  if (eq) return mO;
  eq = 1;
  var e = td(), t = Ok(), r = n9(), n = oqe(), i = Function.call.bind(Object.prototype.hasOwnProperty), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return mO = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(V) {
      var F = V && (c && V[c] || V[l]);
      if (typeof F == "function")
        return F;
    }
    var d = "<<anonymous>>", p = {
      array: m("array"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: g(),
      arrayOf: y,
      element: _(),
      elementType: S(),
      instanceOf: A,
      node: z(),
      objectOf: P,
      oneOf: O,
      oneOfType: U,
      shape: k,
      exact: H
    };
    function v(V, F) {
      return V === F ? V !== 0 || 1 / V === 1 / F : V !== V && F !== F;
    }
    function h(V) {
      this.message = V, this.stack = "";
    }
    h.prototype = Error.prototype;
    function E(V) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, le = 0;
      function ae(ve, Ie, Oe, xe, ze, qe, Je) {
        if (xe = xe || d, qe = qe || Oe, Je !== r) {
          if (s) {
            var Be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Be.name = "Invariant Violation", Be;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var We = xe + ":" + Oe;
            !F[We] && // Avoid spamming the console because they are often not actionable except for lib authors
            le < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + qe + "` prop on `" + xe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[We] = !0, le++);
          }
        }
        return Ie[Oe] == null ? ve ? Ie[Oe] === null ? new h("The " + ze + " `" + qe + "` is marked as required " + ("in `" + xe + "`, but its value is `null`.")) : new h("The " + ze + " `" + qe + "` is marked as required in " + ("`" + xe + "`, but its value is `undefined`.")) : null : V(Ie, Oe, xe, ze, qe);
      }
      var ne = ae.bind(null, !1);
      return ne.isRequired = ae.bind(null, !0), ne;
    }
    function m(V) {
      function F(le, ae, ne, ve, Ie, Oe) {
        var xe = le[ae], ze = D(xe);
        if (ze !== V) {
          var qe = w(xe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + qe + "` supplied to `" + ne + "`, expected ") + ("`" + V + "`."));
        }
        return null;
      }
      return E(F);
    }
    function g() {
      return E(a);
    }
    function y(V) {
      function F(le, ae, ne, ve, Ie) {
        if (typeof V != "function")
          return new h("Property `" + Ie + "` of component `" + ne + "` has invalid PropType notation inside arrayOf.");
        var Oe = le[ae];
        if (!Array.isArray(Oe)) {
          var xe = D(Oe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected an array."));
        }
        for (var ze = 0; ze < Oe.length; ze++) {
          var qe = V(Oe, ze, ne, ve, Ie + "[" + ze + "]", r);
          if (qe instanceof Error)
            return qe;
        }
        return null;
      }
      return E(F);
    }
    function _() {
      function V(F, le, ae, ne, ve) {
        var Ie = F[le];
        if (!u(Ie)) {
          var Oe = D(Ie);
          return new h("Invalid " + ne + " `" + ve + "` of type " + ("`" + Oe + "` supplied to `" + ae + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(V);
    }
    function S() {
      function V(F, le, ae, ne, ve) {
        var Ie = F[le];
        if (!e.isValidElementType(Ie)) {
          var Oe = D(Ie);
          return new h("Invalid " + ne + " `" + ve + "` of type " + ("`" + Oe + "` supplied to `" + ae + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(V);
    }
    function A(V) {
      function F(le, ae, ne, ve, Ie) {
        if (!(le[ae] instanceof V)) {
          var Oe = V.name || d, xe = X(le[ae]);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected ") + ("instance of `" + Oe + "`."));
        }
        return null;
      }
      return E(F);
    }
    function O(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(le, ae, ne, ve, Ie) {
        for (var Oe = le[ae], xe = 0; xe < V.length; xe++)
          if (v(Oe, V[xe]))
            return null;
        var ze = JSON.stringify(V, function(Je, Be) {
          var We = w(Be);
          return We === "symbol" ? String(Be) : Be;
        });
        return new h("Invalid " + ve + " `" + Ie + "` of value `" + String(Oe) + "` " + ("supplied to `" + ne + "`, expected one of " + ze + "."));
      }
      return E(F);
    }
    function P(V) {
      function F(le, ae, ne, ve, Ie) {
        if (typeof V != "function")
          return new h("Property `" + Ie + "` of component `" + ne + "` has invalid PropType notation inside objectOf.");
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected an object."));
        for (var ze in Oe)
          if (i(Oe, ze)) {
            var qe = V(Oe, ze, ne, ve, Ie + "." + ze, r);
            if (qe instanceof Error)
              return qe;
          }
        return null;
      }
      return E(F);
    }
    function U(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < V.length; F++) {
        var le = V[F];
        if (typeof le != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(le) + " at index " + F + "."
          ), a;
      }
      function ae(ne, ve, Ie, Oe, xe) {
        for (var ze = 0; ze < V.length; ze++) {
          var qe = V[ze];
          if (qe(ne, ve, Ie, Oe, xe, r) == null)
            return null;
        }
        return new h("Invalid " + Oe + " `" + xe + "` supplied to " + ("`" + Ie + "`."));
      }
      return E(ae);
    }
    function z() {
      function V(F, le, ae, ne, ve) {
        return B(F[le]) ? null : new h("Invalid " + ne + " `" + ve + "` supplied to " + ("`" + ae + "`, expected a ReactNode."));
      }
      return E(V);
    }
    function k(V) {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type `" + xe + "` " + ("supplied to `" + ne + "`, expected `object`."));
        for (var ze in V) {
          var qe = V[ze];
          if (qe) {
            var Je = qe(Oe, ze, ne, ve, Ie + "." + ze, r);
            if (Je)
              return Je;
          }
        }
        return null;
      }
      return E(F);
    }
    function H(V) {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type `" + xe + "` " + ("supplied to `" + ne + "`, expected `object`."));
        var ze = t({}, le[ae], V);
        for (var qe in ze) {
          var Je = V[qe];
          if (!Je)
            return new h(
              "Invalid " + ve + " `" + Ie + "` key `" + qe + "` supplied to `" + ne + "`.\nBad object: " + JSON.stringify(le[ae], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var Be = Je(Oe, qe, ne, ve, Ie + "." + qe, r);
          if (Be)
            return Be;
        }
        return null;
      }
      return E(F);
    }
    function B(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(B);
          if (V === null || u(V))
            return !0;
          var F = f(V);
          if (F) {
            var le = F.call(V), ae;
            if (F !== V.entries) {
              for (; !(ae = le.next()).done; )
                if (!B(ae.value))
                  return !1;
            } else
              for (; !(ae = le.next()).done; ) {
                var ne = ae.value;
                if (ne && !B(ne[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function x(V, F) {
      return V === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function D(V) {
      var F = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : x(F, V) ? "symbol" : F;
    }
    function w(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var F = D(V);
      if (F === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function $(V) {
      var F = w(V);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function X(V) {
      return !V.constructor || !V.constructor.name ? d : V.constructor.name;
    }
    return p.checkPropTypes = n, p.resetWarningCache = n.resetWarningCache, p.PropTypes = p, p;
  }, mO;
}
var gO, tq;
function uqe() {
  if (tq) return gO;
  tq = 1;
  var e = n9();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, gO = function() {
    function n(a, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, gO;
}
if (process.env.NODE_ENV !== "production") {
  var sqe = td(), cqe = !0;
  SL.exports = aqe()(sqe.isElement, cqe);
} else
  SL.exports = uqe()();
var lqe = SL.exports;
const vn = /* @__PURE__ */ Mt(lqe);
var i9 = /* @__PURE__ */ G.createContext({
  scrollTo: function() {
    return 0;
  },
  scrollToBottom: function() {
    return 0;
  },
  scrollToEnd: function() {
    return 0;
  },
  scrollToStart: function() {
    return 0;
  },
  scrollToTop: function() {
    return 0;
  }
});
i9.displayName = "ScrollToBottomFunctionContext";
function Yde() {
  return En(i9);
}
function Gde() {
  var e = Yde(), t = e.scrollToEnd;
  return t;
}
var o9 = /* @__PURE__ */ G.createContext({
  atBottom: !0,
  atEnd: !0,
  atStart: !1,
  atTop: !0,
  mode: "bottom"
});
o9.displayName = "ScrollToBottomState1Context";
var a9 = /* @__PURE__ */ G.createContext({
  animating: !1,
  animatingToEnd: !1,
  sticky: !0
});
a9.displayName = "ScrollToBottomState2Context";
var u9 = /* @__PURE__ */ G.createContext({
  animating: !1,
  animatingToEnd: !1,
  atBottom: !0,
  atEnd: !0,
  atStart: !1,
  atTop: !0,
  mode: "bottom",
  sticky: !0
});
u9.displayName = "ScrollToBottomStateContext";
var rq = [u9, o9, a9];
function s9(e) {
  return En(rq[e] || rq[0]);
}
function fqe() {
  var e = s9(2), t = e.sticky;
  return [t];
}
var sC = /* @__PURE__ */ G.createContext({
  offsetHeight: 0,
  scrollHeight: 0,
  setTarget: function() {
    return 0;
  },
  styleToClassName: function() {
    return "";
  }
});
sC.displayName = "ScrollToBottomInternalContext";
function Wde() {
  return En(sC);
}
function dqe() {
  var e = Wde(), t = e.styleToClassName;
  return t;
}
vn.any, vn.string;
var Kde = { exports: {} }, pqe = Zt, hqe = Hi, nq = Ha.f;
pqe({ target: "Object", stat: !0, forced: Object.defineProperty !== nq, sham: !hqe }, {
  defineProperty: nq
});
var vqe = Pn, Xde = vqe.Object, Eqe = Kde.exports = function(t, r, n) {
  return Xde.defineProperty(t, r, n);
};
Xde.defineProperty.sham && (Eqe.sham = !0);
var mqe = Kde.exports, gqe = mqe, Jde = gqe, Tqe = Jde, yqe = Tqe, _qe = yqe, Aqe = _qe, Zde = Aqe;
const cC = /* @__PURE__ */ Mt(Zde);
var Sqe = Dh, bqe = Sqe.f("iterator"), Cqe = bqe, Iqe = Cqe, Oqe = Iqe, Rqe = Oqe, wqe = Rqe, Pqe = wqe, Qde = Pqe;
const Dqe = /* @__PURE__ */ Mt(Qde);
function Ta(e) {
  "@babel/helpers - typeof";
  return Ta = typeof hf == "function" && typeof Dqe == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof hf == "function" && t.constructor === hf && t !== hf.prototype ? "symbol" : typeof t;
  }, Ta(e);
}
var xqe = Dh, Nqe = xqe.f("toPrimitive"), Lqe = Nqe, Bqe = Lqe, kqe = Bqe, Mqe = kqe, Fqe = Mqe, Hqe = Fqe, epe = Hqe;
const $qe = /* @__PURE__ */ Mt(epe);
function Uqe(e, t) {
  if (Ta(e) != "object" || !e) return e;
  var r = e[$qe];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ta(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tpe(e) {
  var t = Uqe(e, "string");
  return Ta(t) == "symbol" ? t : t + "";
}
function Vqe(e, t, r) {
  return (t = tpe(t)) in e ? cC(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function jqe(e) {
  if (Yk(e)) return AL(e);
}
function zqe(e) {
  if (typeof hf < "u" && e9(e) != null || e["@@iterator"] != null) return zde(e);
}
function qqe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nn(e) {
  return jqe(e) || zqe(e) || r9(e) || qqe();
}
var K_ = function(e) {
  return e && e.Math == Math && e;
}, lu = (
  // eslint-disable-next-line es/no-global-this -- safe
  K_(typeof globalThis == "object" && globalThis) || K_(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  K_(typeof self == "object" && self) || K_(typeof fe == "object" && fe) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), c9 = {}, bs = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, Yqe = bs, nd = !Yqe(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), rpe = {}, npe = {}.propertyIsEnumerable, ipe = Object.getOwnPropertyDescriptor, Gqe = ipe && !npe.call({ 1: 2 }, 1);
rpe.f = Gqe ? function(t) {
  var r = ipe(this, t);
  return !!r && r.enumerable;
} : npe;
var ope = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, Wqe = {}.toString, l9 = function(e) {
  return Wqe.call(e).slice(8, -1);
}, Kqe = bs, Xqe = l9, Jqe = "".split, Zqe = Kqe(function() {
  return !Object("z").propertyIsEnumerable(0);
}) ? function(e) {
  return Xqe(e) == "String" ? Jqe.call(e, "") : Object(e);
} : Object, lC = function(e) {
  if (e == null) throw TypeError("Can't call method on " + e);
  return e;
}, Qqe = Zqe, eYe = lC, f9 = function(e) {
  return Qqe(eYe(e));
}, $u = function(e) {
  return typeof e == "function";
}, tYe = $u, QT = function(e) {
  return typeof e == "object" ? e !== null : tYe(e);
}, TO = lu, rYe = $u, nYe = function(e) {
  return rYe(e) ? e : void 0;
}, fC = function(e, t) {
  return arguments.length < 2 ? nYe(TO[e]) : TO[e] && TO[e][t];
}, iYe = fC, oYe = iYe("navigator", "userAgent") || "", ape = lu, yO = oYe, iq = ape.process, oq = ape.Deno, aq = iq && iq.versions || oq && oq.version, uq = aq && aq.v8, Bs, AS;
uq ? (Bs = uq.split("."), AS = Bs[0] < 4 ? 1 : Bs[0] + Bs[1]) : yO && (Bs = yO.match(/Edge\/(\d+)/), (!Bs || Bs[1] >= 74) && (Bs = yO.match(/Chrome\/(\d+)/), Bs && (AS = Bs[1])));
var aYe = AS && +AS, sq = aYe, uYe = bs, upe = !!Object.getOwnPropertySymbols && !uYe(function() {
  var e = Symbol();
  return !String(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && sq && sq < 41;
}), sYe = upe, spe = sYe && !Symbol.sham && typeof Symbol.iterator == "symbol", cYe = $u, lYe = fC, fYe = spe, cpe = fYe ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = lYe("Symbol");
  return cYe(t) && Object(e) instanceof t;
}, dYe = function(e) {
  try {
    return String(e);
  } catch {
    return "Object";
  }
}, pYe = $u, hYe = dYe, vYe = function(e) {
  if (pYe(e)) return e;
  throw TypeError(hYe(e) + " is not a function");
}, EYe = vYe, lpe = function(e, t) {
  var r = e[t];
  return r == null ? void 0 : EYe(r);
}, _O = $u, AO = QT, mYe = function(e, t) {
  var r, n;
  if (t === "string" && _O(r = e.toString) && !AO(n = r.call(e)) || _O(r = e.valueOf) && !AO(n = r.call(e)) || t !== "string" && _O(r = e.toString) && !AO(n = r.call(e))) return n;
  throw TypeError("Can't convert object to primitive value");
}, fpe = { exports: {} }, cq = lu, d9 = function(e, t) {
  try {
    Object.defineProperty(cq, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    cq[e] = t;
  }
  return t;
}, gYe = lu, TYe = d9, lq = "__core-js_shared__", yYe = gYe[lq] || TYe(lq, {}), p9 = yYe, fq = p9;
(fpe.exports = function(e, t) {
  return fq[e] || (fq[e] = t !== void 0 ? t : {});
})("versions", []).push({
  version: "3.18.3",
  mode: "global",
  copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
});
var h9 = fpe.exports, _Ye = lC, dpe = function(e) {
  return Object(_Ye(e));
}, AYe = dpe, SYe = {}.hasOwnProperty, id = Object.hasOwn || function(t, r) {
  return SYe.call(AYe(t), r);
}, bYe = 0, CYe = Math.random(), ppe = function(e) {
  return "Symbol(" + String(e === void 0 ? "" : e) + ")_" + (++bYe + CYe).toString(36);
}, IYe = lu, OYe = h9, dq = id, RYe = ppe, pq = upe, wYe = spe, Rv = OYe("wks"), y1 = IYe.Symbol, PYe = wYe ? y1 : y1 && y1.withoutSetter || RYe, ey = function(e) {
  return (!dq(Rv, e) || !(pq || typeof Rv[e] == "string")) && (pq && dq(y1, e) ? Rv[e] = y1[e] : Rv[e] = PYe("Symbol." + e)), Rv[e];
}, hq = QT, vq = cpe, DYe = lpe, xYe = mYe, NYe = ey, LYe = NYe("toPrimitive"), BYe = function(e, t) {
  if (!hq(e) || vq(e)) return e;
  var r = DYe(e, LYe), n;
  if (r) {
    if (t === void 0 && (t = "default"), n = r.call(e, t), !hq(n) || vq(n)) return n;
    throw TypeError("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), xYe(e, t);
}, kYe = BYe, MYe = cpe, hpe = function(e) {
  var t = kYe(e, "string");
  return MYe(t) ? t : String(t);
}, FYe = lu, Eq = QT, bL = FYe.document, HYe = Eq(bL) && Eq(bL.createElement), vpe = function(e) {
  return HYe ? bL.createElement(e) : {};
}, $Ye = nd, UYe = bs, VYe = vpe, Epe = !$Ye && !UYe(function() {
  return Object.defineProperty(VYe("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), jYe = nd, zYe = rpe, qYe = ope, YYe = f9, GYe = hpe, WYe = id, KYe = Epe, mq = Object.getOwnPropertyDescriptor;
c9.f = jYe ? mq : function(t, r) {
  if (t = YYe(t), r = GYe(r), KYe) try {
    return mq(t, r);
  } catch {
  }
  if (WYe(t, r)) return qYe(!zYe.f.call(t, r), t[r]);
};
var ty = {}, XYe = QT, l0 = function(e) {
  if (XYe(e)) return e;
  throw TypeError(String(e) + " is not an object");
}, JYe = nd, ZYe = Epe, gq = l0, QYe = hpe, Tq = Object.defineProperty;
ty.f = JYe ? Tq : function(t, r, n) {
  if (gq(t), r = QYe(r), gq(n), ZYe) try {
    return Tq(t, r, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
  return "value" in n && (t[r] = n.value), t;
};
var eGe = nd, tGe = ty, rGe = ope, dC = eGe ? function(e, t, r) {
  return tGe.f(e, t, rGe(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, mpe = { exports: {} }, nGe = $u, CL = p9, iGe = Function.toString;
nGe(CL.inspectSource) || (CL.inspectSource = function(e) {
  return iGe.call(e);
});
var gpe = CL.inspectSource, oGe = lu, aGe = $u, uGe = gpe, yq = oGe.WeakMap, sGe = aGe(yq) && /native code/.test(uGe(yq)), cGe = h9, lGe = ppe, _q = cGe("keys"), Tpe = function(e) {
  return _q[e] || (_q[e] = lGe(e));
}, v9 = {}, fGe = sGe, dGe = lu, pGe = QT, hGe = dC, SO = id, bO = p9, vGe = Tpe, EGe = v9, Aq = "Object already initialized", mGe = dGe.WeakMap, SS, z1, bS, gGe = function(e) {
  return bS(e) ? z1(e) : SS(e, {});
}, TGe = function(e) {
  return function(t) {
    var r;
    if (!pGe(t) || (r = z1(t)).type !== e)
      throw TypeError("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (fGe || bO.state) {
  var w0 = bO.state || (bO.state = new mGe()), yGe = w0.get, Sq = w0.has, _Ge = w0.set;
  SS = function(e, t) {
    if (Sq.call(w0, e)) throw new TypeError(Aq);
    return t.facade = e, _Ge.call(w0, e, t), t;
  }, z1 = function(e) {
    return yGe.call(w0, e) || {};
  }, bS = function(e) {
    return Sq.call(w0, e);
  };
} else {
  var Md = vGe("state");
  EGe[Md] = !0, SS = function(e, t) {
    if (SO(e, Md)) throw new TypeError(Aq);
    return t.facade = e, hGe(e, Md, t), t;
  }, z1 = function(e) {
    return SO(e, Md) ? e[Md] : {};
  }, bS = function(e) {
    return SO(e, Md);
  };
}
var ype = {
  set: SS,
  get: z1,
  has: bS,
  enforce: gGe,
  getterFor: TGe
}, IL = nd, AGe = id, _pe = Function.prototype, SGe = IL && Object.getOwnPropertyDescriptor, E9 = AGe(_pe, "name"), bGe = E9 && (function() {
}).name === "something", CGe = E9 && (!IL || IL && SGe(_pe, "name").configurable), m9 = {
  EXISTS: E9,
  PROPER: bGe,
  CONFIGURABLE: CGe
}, IGe = lu, bq = $u, OGe = id, Cq = dC, RGe = d9, wGe = gpe, Ape = ype, PGe = m9.CONFIGURABLE, DGe = Ape.get, xGe = Ape.enforce, NGe = String(String).split("String");
(mpe.exports = function(e, t, r, n) {
  var i = n ? !!n.unsafe : !1, o = n ? !!n.enumerable : !1, a = n ? !!n.noTargetGet : !1, u = n && n.name !== void 0 ? n.name : t, s;
  if (bq(r) && (String(u).slice(0, 7) === "Symbol(" && (u = "[" + String(u).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!OGe(r, "name") || PGe && r.name !== u) && Cq(r, "name", u), s = xGe(r), s.source || (s.source = NGe.join(typeof u == "string" ? u : ""))), e === IGe) {
    o ? e[t] = r : RGe(t, r);
    return;
  } else i ? !a && e[t] && (o = !0) : delete e[t];
  o ? e[t] = r : Cq(e, t, r);
})(Function.prototype, "toString", function() {
  return bq(this) && DGe(this).source || wGe(this);
});
var ry = mpe.exports, Spe = {}, LGe = Math.ceil, BGe = Math.floor, pC = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : (t > 0 ? BGe : LGe)(t);
}, kGe = pC, MGe = Math.max, FGe = Math.min, HGe = function(e, t) {
  var r = kGe(e);
  return r < 0 ? MGe(r + t, 0) : FGe(r, t);
}, $Ge = pC, UGe = Math.min, bpe = function(e) {
  return e > 0 ? UGe($Ge(e), 9007199254740991) : 0;
}, VGe = bpe, jGe = function(e) {
  return VGe(e.length);
}, zGe = f9, qGe = HGe, YGe = jGe, Iq = function(e) {
  return function(t, r, n) {
    var i = zGe(t), o = YGe(i), a = qGe(n, o), u;
    if (e && r != r) {
      for (; o > a; )
        if (u = i[a++], u != u) return !0;
    } else for (; o > a; a++)
      if ((e || a in i) && i[a] === r) return e || a || 0;
    return !e && -1;
  };
}, GGe = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Iq(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Iq(!1)
}, CO = id, WGe = f9, KGe = GGe.indexOf, XGe = v9, Cpe = function(e, t) {
  var r = WGe(e), n = 0, i = [], o;
  for (o in r) !CO(XGe, o) && CO(r, o) && i.push(o);
  for (; t.length > n; ) CO(r, o = t[n++]) && (~KGe(i, o) || i.push(o));
  return i;
}, g9 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], JGe = Cpe, ZGe = g9, QGe = ZGe.concat("length", "prototype");
Spe.f = Object.getOwnPropertyNames || function(t) {
  return JGe(t, QGe);
};
var Ipe = {};
Ipe.f = Object.getOwnPropertySymbols;
var eWe = fC, tWe = Spe, rWe = Ipe, nWe = l0, iWe = eWe("Reflect", "ownKeys") || function(t) {
  var r = tWe.f(nWe(t)), n = rWe.f;
  return n ? r.concat(n(t)) : r;
}, oWe = id, aWe = iWe, uWe = c9, sWe = ty, cWe = function(e, t) {
  for (var r = aWe(t), n = sWe.f, i = uWe.f, o = 0; o < r.length; o++) {
    var a = r[o];
    oWe(e, a) || n(e, a, i(t, a));
  }
}, lWe = bs, fWe = $u, dWe = /#|\.prototype\./, ny = function(e, t) {
  var r = hWe[pWe(e)];
  return r == EWe ? !0 : r == vWe ? !1 : fWe(t) ? lWe(t) : !!t;
}, pWe = ny.normalize = function(e) {
  return String(e).replace(dWe, ".").toLowerCase();
}, hWe = ny.data = {}, vWe = ny.NATIVE = "N", EWe = ny.POLYFILL = "P", mWe = ny, IO = lu, gWe = c9.f, TWe = dC, yWe = ry, _We = d9, AWe = cWe, SWe = mWe, bWe = function(e, t) {
  var r = e.target, n = e.global, i = e.stat, o, a, u, s, c, l;
  if (n ? a = IO : i ? a = IO[r] || _We(r, {}) : a = (IO[r] || {}).prototype, a) for (u in t) {
    if (c = t[u], e.noTargetGet ? (l = gWe(a, u), s = l && l.value) : s = a[u], o = SWe(n ? u : r + (i ? "." : "#") + u, e.forced), !o && s !== void 0) {
      if (typeof c == typeof s) continue;
      AWe(c, s);
    }
    (e.sham || s && s.sham) && TWe(c, "sham", !0), yWe(a, u, c, e);
  }
}, CWe = ey, IWe = CWe("toStringTag"), Ope = {};
Ope[IWe] = "z";
var T9 = String(Ope) === "[object z]", OWe = T9, RWe = $u, O4 = l9, wWe = ey, PWe = wWe("toStringTag"), DWe = O4(/* @__PURE__ */ function() {
  return arguments;
}()) == "Arguments", xWe = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, Rpe = OWe ? O4 : function(e) {
  var t, r, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = xWe(t = Object(e), PWe)) == "string" ? r : DWe ? O4(t) : (n = O4(t)) == "Object" && RWe(t.callee) ? "Arguments" : n;
}, NWe = Rpe, hC = function(e) {
  if (NWe(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return String(e);
}, LWe = l0, wpe = function() {
  var e = LWe(this), t = "";
  return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
}, y9 = {}, Ppe = bs, BWe = lu, Dpe = BWe.RegExp;
y9.UNSUPPORTED_Y = Ppe(function() {
  var e = Dpe("a", "y");
  return e.lastIndex = 2, e.exec("abcd") != null;
});
y9.BROKEN_CARET = Ppe(function() {
  var e = Dpe("^r", "gy");
  return e.lastIndex = 2, e.exec("str") != null;
});
var kWe = Cpe, MWe = g9, FWe = Object.keys || function(t) {
  return kWe(t, MWe);
}, HWe = nd, $We = ty, UWe = l0, VWe = FWe, jWe = HWe ? Object.defineProperties : function(t, r) {
  UWe(t);
  for (var n = VWe(r), i = n.length, o = 0, a; i > o; ) $We.f(t, a = n[o++], r[a]);
  return t;
}, zWe = fC, qWe = zWe("document", "documentElement"), YWe = l0, GWe = jWe, Oq = g9, WWe = v9, KWe = qWe, XWe = vpe, JWe = Tpe, Rq = ">", wq = "<", OL = "prototype", RL = "script", xpe = JWe("IE_PROTO"), OO = function() {
}, Npe = function(e) {
  return wq + RL + Rq + e + wq + "/" + RL + Rq;
}, Pq = function(e) {
  e.write(Npe("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, ZWe = function() {
  var e = XWe("iframe"), t = "java" + RL + ":", r;
  return e.style.display = "none", KWe.appendChild(e), e.src = String(t), r = e.contentWindow.document, r.open(), r.write(Npe("document.F=Object")), r.close(), r.F;
}, X_, R4 = function() {
  try {
    X_ = new ActiveXObject("htmlfile");
  } catch {
  }
  R4 = typeof document < "u" ? document.domain && X_ ? Pq(X_) : ZWe() : Pq(X_);
  for (var e = Oq.length; e--; ) delete R4[OL][Oq[e]];
  return R4();
};
WWe[xpe] = !0;
var QWe = Object.create || function(t, r) {
  var n;
  return t !== null ? (OO[OL] = YWe(t), n = new OO(), OO[OL] = null, n[xpe] = t) : n = R4(), r === void 0 ? n : GWe(n, r);
}, eKe = bs, tKe = lu, rKe = tKe.RegExp, nKe = eKe(function() {
  var e = rKe(".", "s");
  return !(e.dotAll && e.exec(`
`) && e.flags === "s");
}), iKe = bs, oKe = lu, aKe = oKe.RegExp, uKe = iKe(function() {
  var e = aKe("(?<a>b)", "g");
  return e.exec("b").groups.a !== "b" || "b".replace(e, "$<a>c") !== "bc";
}), sKe = hC, cKe = wpe, Dq = y9, lKe = h9, fKe = QWe, dKe = ype.get, pKe = nKe, hKe = uKe, CS = RegExp.prototype.exec, vKe = lKe("native-string-replace", String.prototype.replace), wL = CS, PL = function() {
  var e = /a/, t = /b*/g;
  return CS.call(e, "a"), CS.call(t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
}(), Lpe = Dq.UNSUPPORTED_Y || Dq.BROKEN_CARET, DL = /()??/.exec("")[1] !== void 0, EKe = PL || DL || Lpe || pKe || hKe;
EKe && (wL = function(t) {
  var r = this, n = dKe(r), i = sKe(t), o = n.raw, a, u, s, c, l, f, d;
  if (o)
    return o.lastIndex = r.lastIndex, a = wL.call(o, i), r.lastIndex = o.lastIndex, a;
  var p = n.groups, v = Lpe && r.sticky, h = cKe.call(r), E = r.source, m = 0, g = i;
  if (v && (h = h.replace("y", ""), h.indexOf("g") === -1 && (h += "g"), g = i.slice(r.lastIndex), r.lastIndex > 0 && (!r.multiline || r.multiline && i.charAt(r.lastIndex - 1) !== `
`) && (E = "(?: " + E + ")", g = " " + g, m++), u = new RegExp("^(?:" + E + ")", h)), DL && (u = new RegExp("^" + E + "$(?!\\s)", h)), PL && (s = r.lastIndex), c = CS.call(v ? u : r, g), v ? c ? (c.input = c.input.slice(m), c[0] = c[0].slice(m), c.index = r.lastIndex, r.lastIndex += c[0].length) : r.lastIndex = 0 : PL && c && (r.lastIndex = r.global ? c.index + c[0].length : s), DL && c && c.length > 1 && vKe.call(c[0], u, function() {
    for (l = 1; l < arguments.length - 2; l++)
      arguments[l] === void 0 && (c[l] = void 0);
  }), c && p)
    for (c.groups = f = fKe(null), l = 0; l < p.length; l++)
      d = p[l], f[d[0]] = c[d[1]];
  return c;
});
var _9 = wL, mKe = bWe, xq = _9;
mKe({ target: "RegExp", proto: !0, forced: /./.exec !== xq }, {
  exec: xq
});
var Nq = ry, gKe = _9, Lq = bs, Bpe = ey, TKe = dC, yKe = Bpe("species"), RO = RegExp.prototype, _Ke = function(e, t, r, n) {
  var i = Bpe(e), o = !Lq(function() {
    var c = {};
    return c[i] = function() {
      return 7;
    }, ""[e](c) != 7;
  }), a = o && !Lq(function() {
    var c = !1, l = /a/;
    return e === "split" && (l = {}, l.constructor = {}, l.constructor[yKe] = function() {
      return l;
    }, l.flags = "", l[i] = /./[i]), l.exec = function() {
      return c = !0, null;
    }, l[i](""), !c;
  });
  if (!o || !a || r) {
    var u = /./[i], s = t(i, ""[e], function(c, l, f, d, p) {
      var v = l.exec;
      return v === gKe || v === RO.exec ? o && !p ? { done: !0, value: u.call(l, f, d) } : { done: !0, value: c.call(f, l, d) } : { done: !1 };
    });
    Nq(String.prototype, e, s[0]), Nq(RO, i, s[1]);
  }
  n && TKe(RO[i], "sham", !0);
}, AKe = pC, SKe = hC, bKe = lC, Bq = function(e) {
  return function(t, r) {
    var n = SKe(bKe(t)), i = AKe(r), o = n.length, a, u;
    return i < 0 || i >= o ? e ? "" : void 0 : (a = n.charCodeAt(i), a < 55296 || a > 56319 || i + 1 === o || (u = n.charCodeAt(i + 1)) < 56320 || u > 57343 ? e ? n.charAt(i) : a : e ? n.slice(i, i + 2) : (a - 55296 << 10) + (u - 56320) + 65536);
  };
}, CKe = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Bq(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Bq(!0)
}, IKe = CKe.charAt, OKe = function(e, t, r) {
  return t + (r ? IKe(e, t).length : 1);
}, RKe = dpe, wKe = Math.floor, PKe = "".replace, DKe = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, xKe = /\$([$&'`]|\d{1,2})/g, NKe = function(e, t, r, n, i, o) {
  var a = r + e.length, u = n.length, s = xKe;
  return i !== void 0 && (i = RKe(i), s = DKe), PKe.call(o, s, function(c, l) {
    var f;
    switch (l.charAt(0)) {
      case "$":
        return "$";
      case "&":
        return e;
      case "`":
        return t.slice(0, r);
      case "'":
        return t.slice(a);
      case "<":
        f = i[l.slice(1, -1)];
        break;
      default:
        var d = +l;
        if (d === 0) return c;
        if (d > u) {
          var p = wKe(d / 10);
          return p === 0 ? c : p <= u ? n[p - 1] === void 0 ? l.charAt(1) : n[p - 1] + l.charAt(1) : c;
        }
        f = n[d - 1];
    }
    return f === void 0 ? "" : f;
  });
}, LKe = l0, BKe = $u, kKe = l9, MKe = _9, FKe = function(e, t) {
  var r = e.exec;
  if (BKe(r)) {
    var n = r.call(e, t);
    return n !== null && LKe(n), n;
  }
  if (kKe(e) === "RegExp") return MKe.call(e, t);
  throw TypeError("RegExp#exec called on incompatible receiver");
}, HKe = _Ke, $Ke = bs, UKe = l0, VKe = $u, jKe = pC, zKe = bpe, Fd = hC, qKe = lC, YKe = OKe, GKe = lpe, WKe = NKe, KKe = FKe, XKe = ey, xL = XKe("replace"), JKe = Math.max, ZKe = Math.min, QKe = function(e) {
  return e === void 0 ? e : String(e);
}, eXe = function() {
  return "a".replace(/./, "$0") === "$0";
}(), kq = function() {
  return /./[xL] ? /./[xL]("a", "$0") === "" : !1;
}(), tXe = !$Ke(function() {
  var e = /./;
  return e.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(e, "$<a>") !== "7";
});
HKe("replace", function(e, t, r) {
  var n = kq ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(o, a) {
      var u = qKe(this), s = o == null ? void 0 : GKe(o, xL);
      return s ? s.call(o, u, a) : t.call(Fd(u), o, a);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, o) {
      var a = UKe(this), u = Fd(i);
      if (typeof o == "string" && o.indexOf(n) === -1 && o.indexOf("$<") === -1) {
        var s = r(t, a, u, o);
        if (s.done) return s.value;
      }
      var c = VKe(o);
      c || (o = Fd(o));
      var l = a.global;
      if (l) {
        var f = a.unicode;
        a.lastIndex = 0;
      }
      for (var d = []; ; ) {
        var p = KKe(a, u);
        if (p === null || (d.push(p), !l)) break;
        var v = Fd(p[0]);
        v === "" && (a.lastIndex = YKe(u, zKe(a.lastIndex), f));
      }
      for (var h = "", E = 0, m = 0; m < d.length; m++) {
        p = d[m];
        for (var g = Fd(p[0]), y = JKe(ZKe(jKe(p.index), u.length), 0), _ = [], S = 1; S < p.length; S++) _.push(QKe(p[S]));
        var A = p.groups;
        if (c) {
          var O = [g].concat(_, y, u);
          A !== void 0 && O.push(A);
          var P = Fd(o.apply(void 0, O));
        } else
          P = WKe(g, u, y, _, A, o);
        y >= E && (h += u.slice(E, y) + P, E = y + g.length);
      }
      return h + u.slice(E);
    }
  ];
}, !tXe || !eXe || kq);
var kpe = Mn, rXe = qf, nXe = Fi, iXe = tk, oXe = ph, aXe = Jf, uXe = Mle, sXe = kpe.Function, cXe = /MSIE .\./.test(oXe) || iXe === "BUN" && function() {
  var e = kpe.Bun.version.split(".");
  return e.length < 3 || e[0] === "0" && (e[1] < 3 || e[1] === "3" && e[2] === "0");
}(), Mpe = function(e, t) {
  var r = t ? 2 : 1;
  return cXe ? function(n, i) {
    var o = uXe(arguments.length, 1) > r, a = nXe(n) ? n : sXe(n), u = o ? aXe(arguments, r) : [], s = o ? function() {
      rXe(a, this, u);
    } : a;
    return t ? e(s, i) : e(s);
  } : e;
}, lXe = Zt, Fpe = Mn, fXe = Mpe, Mq = fXe(Fpe.setInterval, !0);
lXe({ global: !0, bind: !0, forced: Fpe.setInterval !== Mq }, {
  setInterval: Mq
});
var dXe = Zt, Hpe = Mn, pXe = Mpe, Fq = pXe(Hpe.setTimeout, !0);
dXe({ global: !0, bind: !0, forced: Hpe.setTimeout !== Fq }, {
  setTimeout: Fq
});
var hXe = Pn, vXe = hXe.setInterval, EXe = vXe;
const mXe = /* @__PURE__ */ Mt(EXe);
var gXe = mn, xh = function(e, t) {
  var r = [][e];
  return !!r && gXe(function() {
    r.call(null, t || function() {
      return 1;
    }, 1);
  });
}, TXe = Zt, yXe = q8, _Xe = sle.indexOf, AXe = xh, NL = yXe([].indexOf), $pe = !!NL && 1 / NL([1], 1, -0) < 0, SXe = $pe || !AXe("indexOf");
TXe({ target: "Array", proto: !0, forced: SXe }, {
  indexOf: function(t) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return $pe ? NL(this, t, r) || 0 : _Xe(this, t, r);
  }
});
var bXe = Aa, CXe = bXe("Array", "indexOf"), IXe = Qi, OXe = CXe, wO = Array.prototype, RXe = function(e) {
  var t = e.indexOf;
  return e === wO || IXe(wO, e) && t === wO.indexOf ? OXe : t;
}, wXe = RXe, Upe = wXe, PXe = Upe;
const _p = /* @__PURE__ */ Mt(PXe);
var Hq = Wf, DXe = TypeError, xXe = function(e, t) {
  if (!delete e[t]) throw new DXe("Cannot delete property " + Hq(t) + " of " + Hq(e));
}, NXe = Zt, LXe = cu, BXe = $b, kXe = Eh, MXe = As, FXe = Ude, HXe = Gk, $Xe = Wk, UXe = Ph, PO = xXe, VXe = KT, jXe = VXe("splice"), zXe = Math.max, qXe = Math.min;
NXe({ target: "Array", proto: !0, forced: !jXe }, {
  splice: function(t, r) {
    var n = LXe(this), i = MXe(n), o = BXe(t, i), a = arguments.length, u, s, c, l, f, d;
    for (a === 0 ? u = s = 0 : a === 1 ? (u = 0, s = i - o) : (u = a - 2, s = qXe(zXe(kXe(r), 0), i - o)), HXe(i + u - s), c = $Xe(n, s), l = 0; l < s; l++)
      f = o + l, f in n && UXe(c, l, n[f]);
    if (c.length = s, u < s) {
      for (l = o; l < i - s; l++)
        f = l + s, d = l + u, f in n ? n[d] = n[f] : PO(n, d);
      for (l = i; l > i - s + u; l--) PO(n, l - 1);
    } else if (u > s)
      for (l = i - s; l > o; l--)
        f = l + s - 1, d = l + u - 1, f in n ? n[d] = n[f] : PO(n, d);
    for (l = 0; l < u; l++)
      n[l + o] = arguments[l + 2];
    return FXe(n, i - s + u), c;
  }
});
var YXe = Aa, GXe = YXe("Array", "splice"), WXe = Qi, KXe = GXe, DO = Array.prototype, XXe = function(e) {
  var t = e.splice;
  return e === DO || WXe(DO, e) && t === DO.splice ? KXe : t;
}, JXe = XXe, Vpe = JXe, ZXe = Vpe;
const e1 = /* @__PURE__ */ Mt(ZXe);
var QXe = Aa, eJe = QXe("Array", "concat"), tJe = Qi, rJe = eJe, xO = Array.prototype, nJe = function(e) {
  var t = e.concat;
  return e === xO || tJe(xO, e) && t === xO.concat ? rJe : t;
}, iJe = nJe, oJe = iJe, aJe = oJe;
const si = /* @__PURE__ */ Mt(aJe);
var uJe = Zt, sJe = bn, jpe = Date, cJe = sJe(jpe.prototype.getTime);
uJe({ target: "Date", stat: !0 }, {
  now: function() {
    return cJe(new jpe());
  }
});
var lJe = Pn, fJe = lJe.Date.now, dJe = fJe, zpe = dJe, pJe = zpe;
const Vc = /* @__PURE__ */ Mt(pJe);
var hJe = c0.forEach, vJe = xh, EJe = vJe("forEach"), mJe = EJe ? [].forEach : function(t) {
  return hJe(this, t, arguments.length > 1 ? arguments[1] : void 0);
}, gJe = Zt, $q = mJe;
gJe({ target: "Array", proto: !0, forced: [].forEach !== $q }, {
  forEach: $q
});
var TJe = Aa, yJe = TJe("Array", "forEach"), _Je = yJe, AJe = _Je, SJe = HT, bJe = Co, CJe = Qi, IJe = AJe, NO = Array.prototype, OJe = {
  DOMTokenList: !0,
  NodeList: !0
}, A9 = function(e) {
  var t = e.forEach;
  return e === NO || CJe(NO, e) && t === NO.forEach || bJe(OJe, SJe(e)) ? IJe : t;
}, RJe = A9;
const Pf = /* @__PURE__ */ Mt(RJe);
var wJe = Zt, PJe = cu, qpe = FT, DJe = mn, xJe = DJe(function() {
  qpe(1);
});
wJe({ target: "Object", stat: !0, forced: xJe }, {
  keys: function(t) {
    return qpe(PJe(t));
  }
});
var NJe = Pn, LJe = NJe.Object.keys, BJe = LJe, Ype = BJe, kJe = Ype;
const IS = /* @__PURE__ */ Mt(kJe);
var MJe = Pn, FJe = MJe.Object.getOwnPropertySymbols, HJe = FJe, Gpe = HJe, $Je = Gpe;
const Uq = /* @__PURE__ */ Mt($Je);
var UJe = Zt, VJe = c0.filter, jJe = KT, zJe = jJe("filter");
UJe({ target: "Array", proto: !0, forced: !zJe }, {
  filter: function(t) {
    return VJe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var qJe = Aa, YJe = qJe("Array", "filter"), GJe = Qi, WJe = YJe, LO = Array.prototype, KJe = function(e) {
  var t = e.filter;
  return e === LO || GJe(LO, e) && t === LO.filter ? WJe : t;
}, XJe = KJe, Wpe = XJe, JJe = Wpe;
const Kpe = /* @__PURE__ */ Mt(JJe);
var Xpe = { exports: {} }, ZJe = Zt, QJe = mn, eZe = Hu, Jpe = fh.f, Zpe = Hi, tZe = !Zpe || QJe(function() {
  Jpe(1);
});
ZJe({ target: "Object", stat: !0, forced: tZe, sham: !Zpe }, {
  getOwnPropertyDescriptor: function(t, r) {
    return Jpe(eZe(t), r);
  }
});
var rZe = Pn, Qpe = rZe.Object, nZe = Xpe.exports = function(t, r) {
  return Qpe.getOwnPropertyDescriptor(t, r);
};
Qpe.getOwnPropertyDescriptor.sham && (nZe.sham = !0);
var iZe = Xpe.exports, oZe = iZe, ehe = oZe, aZe = ehe;
const iy = /* @__PURE__ */ Mt(aZe);
var uZe = Zt, sZe = Hi, cZe = lle, lZe = Hu, fZe = fh, dZe = Ph;
uZe({ target: "Object", stat: !0, sham: !sZe }, {
  getOwnPropertyDescriptors: function(t) {
    for (var r = lZe(t), n = fZe.f, i = cZe(r), o = {}, a = 0, u, s; i.length > a; )
      s = n(r, u = i[a++]), s !== void 0 && dZe(o, u, s);
    return o;
  }
});
var pZe = Pn, hZe = pZe.Object.getOwnPropertyDescriptors, vZe = hZe, the = vZe, EZe = the;
const Vq = /* @__PURE__ */ Mt(EZe);
var rhe = { exports: {} }, mZe = Zt, gZe = Hi, jq = Ub.f;
mZe({ target: "Object", stat: !0, forced: Object.defineProperties !== jq, sham: !gZe }, {
  defineProperties: jq
});
var TZe = Pn, nhe = TZe.Object, yZe = rhe.exports = function(t, r) {
  return nhe.defineProperties(t, r);
};
nhe.defineProperties.sham && (yZe.sham = !0);
var _Ze = rhe.exports, AZe = _Ze, ihe = AZe, SZe = ihe;
const S9 = /* @__PURE__ */ Mt(SZe);
var bZe = Jde;
const wu = /* @__PURE__ */ Mt(bZe);
var CZe = !1;
function IZe(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function OZe(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var RZe = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(i) {
      var o;
      n.tags.length === 0 ? n.insertionPoint ? o = n.insertionPoint.nextSibling : n.prepend ? o = n.container.firstChild : o = n.before : o = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, o), n.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? !CZe : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(OZe(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = IZe(i);
      try {
        o.insertRule(n, o.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var i;
      return (i = n.parentNode) == null ? void 0 : i.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Xo = "-ms-", OS = "-moz-", _n = "-webkit-", ohe = "comm", b9 = "rule", C9 = "decl", wZe = "@import", ahe = "@keyframes", PZe = "@layer", DZe = Math.abs, vC = String.fromCharCode, xZe = Object.assign;
function NZe(e, t) {
  return Fo(e, 0) ^ 45 ? (((t << 2 ^ Fo(e, 0)) << 2 ^ Fo(e, 1)) << 2 ^ Fo(e, 2)) << 2 ^ Fo(e, 3) : 0;
}
function uhe(e) {
  return e.trim();
}
function LZe(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function An(e, t, r) {
  return e.replace(t, r);
}
function LL(e, t) {
  return e.indexOf(t);
}
function Fo(e, t) {
  return e.charCodeAt(t) | 0;
}
function q1(e, t, r) {
  return e.slice(t, r);
}
function js(e) {
  return e.length;
}
function I9(e) {
  return e.length;
}
function J_(e, t) {
  return t.push(e), e;
}
function BZe(e, t) {
  return e.map(t).join("");
}
var EC = 1, jp = 1, she = 0, Ma = 0, Gi = 0, Nh = "";
function mC(e, t, r, n, i, o, a) {
  return { value: e, root: t, parent: r, type: n, props: i, children: o, line: EC, column: jp, length: a, return: "" };
}
function wv(e, t) {
  return xZe(mC("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function kZe() {
  return Gi;
}
function MZe() {
  return Gi = Ma > 0 ? Fo(Nh, --Ma) : 0, jp--, Gi === 10 && (jp = 1, EC--), Gi;
}
function ou() {
  return Gi = Ma < she ? Fo(Nh, Ma++) : 0, jp++, Gi === 10 && (jp = 1, EC++), Gi;
}
function Xs() {
  return Fo(Nh, Ma);
}
function w4() {
  return Ma;
}
function oy(e, t) {
  return q1(Nh, e, t);
}
function Y1(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function che(e) {
  return EC = jp = 1, she = js(Nh = e), Ma = 0, [];
}
function lhe(e) {
  return Nh = "", e;
}
function P4(e) {
  return uhe(oy(Ma - 1, BL(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function FZe(e) {
  for (; (Gi = Xs()) && Gi < 33; )
    ou();
  return Y1(e) > 2 || Y1(Gi) > 3 ? "" : " ";
}
function HZe(e, t) {
  for (; --t && ou() && !(Gi < 48 || Gi > 102 || Gi > 57 && Gi < 65 || Gi > 70 && Gi < 97); )
    ;
  return oy(e, w4() + (t < 6 && Xs() == 32 && ou() == 32));
}
function BL(e) {
  for (; ou(); )
    switch (Gi) {
      case e:
        return Ma;
      case 34:
      case 39:
        e !== 34 && e !== 39 && BL(Gi);
        break;
      case 40:
        e === 41 && BL(e);
        break;
      case 92:
        ou();
        break;
    }
  return Ma;
}
function $Ze(e, t) {
  for (; ou() && e + Gi !== 57; )
    if (e + Gi === 84 && Xs() === 47)
      break;
  return "/*" + oy(t, Ma - 1) + "*" + vC(e === 47 ? e : ou());
}
function UZe(e) {
  for (; !Y1(Xs()); )
    ou();
  return oy(e, Ma);
}
function VZe(e) {
  return lhe(D4("", null, null, null, [""], e = che(e), 0, [0], e));
}
function D4(e, t, r, n, i, o, a, u, s) {
  for (var c = 0, l = 0, f = a, d = 0, p = 0, v = 0, h = 1, E = 1, m = 1, g = 0, y = "", _ = i, S = o, A = n, O = y; E; )
    switch (v = g, g = ou()) {
      case 40:
        if (v != 108 && Fo(O, f - 1) == 58) {
          LL(O += An(P4(g), "&", "&\f"), "&\f") != -1 && (m = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += P4(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += FZe(v);
        break;
      case 92:
        O += HZe(w4() - 1, 7);
        continue;
      case 47:
        switch (Xs()) {
          case 42:
          case 47:
            J_(jZe($Ze(ou(), w4()), t, r), s);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * h:
        u[c++] = js(O) * m;
      case 125 * h:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            E = 0;
          case 59 + l:
            m == -1 && (O = An(O, /\f/g, "")), p > 0 && js(O) - f && J_(p > 32 ? qq(O + ";", n, r, f - 1) : qq(An(O, " ", "") + ";", n, r, f - 2), s);
            break;
          case 59:
            O += ";";
          default:
            if (J_(A = zq(O, t, r, c, l, i, u, y, _ = [], S = [], f), o), g === 123)
              if (l === 0)
                D4(O, t, A, A, _, o, f, u, S);
              else
                switch (d === 99 && Fo(O, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    D4(e, A, A, n && J_(zq(e, A, A, 0, 0, i, u, y, i, _ = [], f), S), i, S, f, u, n ? _ : S);
                    break;
                  default:
                    D4(O, A, A, A, [""], S, 0, u, S);
                }
        }
        c = l = p = 0, h = m = 1, y = O = "", f = a;
        break;
      case 58:
        f = 1 + js(O), p = v;
      default:
        if (h < 1) {
          if (g == 123)
            --h;
          else if (g == 125 && h++ == 0 && MZe() == 125)
            continue;
        }
        switch (O += vC(g), g * h) {
          case 38:
            m = l > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            u[c++] = (js(O) - 1) * m, m = 1;
            break;
          case 64:
            Xs() === 45 && (O += P4(ou())), d = Xs(), l = f = js(y = O += UZe(w4())), g++;
            break;
          case 45:
            v === 45 && js(O) == 2 && (h = 0);
        }
    }
  return o;
}
function zq(e, t, r, n, i, o, a, u, s, c, l) {
  for (var f = i - 1, d = i === 0 ? o : [""], p = I9(d), v = 0, h = 0, E = 0; v < n; ++v)
    for (var m = 0, g = q1(e, f + 1, f = DZe(h = a[v])), y = e; m < p; ++m)
      (y = uhe(h > 0 ? d[m] + " " + g : An(g, /&\f/g, d[m]))) && (s[E++] = y);
  return mC(e, t, r, i === 0 ? b9 : u, s, c, l);
}
function jZe(e, t, r) {
  return mC(e, t, r, ohe, vC(kZe()), q1(e, 2, -2), 0);
}
function qq(e, t, r, n) {
  return mC(e, t, r, C9, q1(e, 0, n), q1(e, n + 1, -1), n);
}
function Ap(e, t) {
  for (var r = "", n = I9(e), i = 0; i < n; i++)
    r += t(e[i], i, e, t) || "";
  return r;
}
function zZe(e, t, r, n) {
  switch (e.type) {
    case PZe:
      if (e.children.length) break;
    case wZe:
    case C9:
      return e.return = e.return || e.value;
    case ohe:
      return "";
    case ahe:
      return e.return = e.value + "{" + Ap(e.children, n) + "}";
    case b9:
      e.value = e.props.join(",");
  }
  return js(r = Ap(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function qZe(e) {
  var t = I9(e);
  return function(r, n, i, o) {
    for (var a = "", u = 0; u < t; u++)
      a += e[u](r, n, i, o) || "";
    return a;
  };
}
function YZe(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function GZe(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var WZe = function(t, r, n) {
  for (var i = 0, o = 0; i = o, o = Xs(), i === 38 && o === 12 && (r[n] = 1), !Y1(o); )
    ou();
  return oy(t, Ma);
}, KZe = function(t, r) {
  var n = -1, i = 44;
  do
    switch (Y1(i)) {
      case 0:
        i === 38 && Xs() === 12 && (r[n] = 1), t[n] += WZe(Ma - 1, r, n);
        break;
      case 2:
        t[n] += P4(i);
        break;
      case 4:
        if (i === 44) {
          t[++n] = Xs() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += vC(i);
    }
  while (i = ou());
  return t;
}, XZe = function(t, r) {
  return lhe(KZe(che(t), r));
}, Yq = /* @__PURE__ */ new WeakMap(), JZe = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, i = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Yq.get(n)) && !i) {
      Yq.set(t, !0);
      for (var o = [], a = XZe(r, o), u = n.props, s = 0, c = 0; s < a.length; s++)
        for (var l = 0; l < u.length; l++, c++)
          t.props[c] = o[s] ? a[s].replace(/&\f/g, u[l]) : u[l] + " " + a[s];
    }
  }
}, ZZe = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function fhe(e, t) {
  switch (NZe(e, t)) {
    case 5103:
      return _n + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return _n + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return _n + e + OS + e + Xo + e + e;
    case 6828:
    case 4268:
      return _n + e + Xo + e + e;
    case 6165:
      return _n + e + Xo + "flex-" + e + e;
    case 5187:
      return _n + e + An(e, /(\w+).+(:[^]+)/, _n + "box-$1$2" + Xo + "flex-$1$2") + e;
    case 5443:
      return _n + e + Xo + "flex-item-" + An(e, /flex-|-self/, "") + e;
    case 4675:
      return _n + e + Xo + "flex-line-pack" + An(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return _n + e + Xo + An(e, "shrink", "negative") + e;
    case 5292:
      return _n + e + Xo + An(e, "basis", "preferred-size") + e;
    case 6060:
      return _n + "box-" + An(e, "-grow", "") + _n + e + Xo + An(e, "grow", "positive") + e;
    case 4554:
      return _n + An(e, /([^-])(transform)/g, "$1" + _n + "$2") + e;
    case 6187:
      return An(An(An(e, /(zoom-|grab)/, _n + "$1"), /(image-set)/, _n + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return An(e, /(image-set\([^]*)/, _n + "$1$`$1");
    case 4968:
      return An(An(e, /(.+:)(flex-)?(.*)/, _n + "box-pack:$3" + Xo + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + _n + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return An(e, /(.+)-inline(.+)/, _n + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (js(e) - 1 - t > 6) switch (Fo(e, t + 1)) {
        case 109:
          if (Fo(e, t + 4) !== 45) break;
        case 102:
          return An(e, /(.+:)(.+)-([^]+)/, "$1" + _n + "$2-$3$1" + OS + (Fo(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~LL(e, "stretch") ? fhe(An(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Fo(e, t + 1) !== 115) break;
    case 6444:
      switch (Fo(e, js(e) - 3 - (~LL(e, "!important") && 10))) {
        case 107:
          return An(e, ":", ":" + _n) + e;
        case 101:
          return An(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + _n + (Fo(e, 14) === 45 ? "inline-" : "") + "box$3$1" + _n + "$2$3$1" + Xo + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Fo(e, t + 11)) {
        case 114:
          return _n + e + Xo + An(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return _n + e + Xo + An(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return _n + e + Xo + An(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return _n + e + Xo + e + e;
  }
  return e;
}
var QZe = function(t, r, n, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case C9:
      t.return = fhe(t.value, t.length);
      break;
    case ahe:
      return Ap([wv(t, {
        value: An(t.value, "@", "@" + _n)
      })], i);
    case b9:
      if (t.length) return BZe(t.props, function(o) {
        switch (LZe(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Ap([wv(t, {
              props: [An(o, /:(read-\w+)/, ":" + OS + "$1")]
            })], i);
          case "::placeholder":
            return Ap([wv(t, {
              props: [An(o, /:(plac\w+)/, ":" + _n + "input-$1")]
            }), wv(t, {
              props: [An(o, /:(plac\w+)/, ":" + OS + "$1")]
            }), wv(t, {
              props: [An(o, /:(plac\w+)/, Xo + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, eQe = [QZe], O9 = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(h) {
      var E = h.getAttribute("data-emotion");
      E.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || eQe, o = {}, a, u = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(h) {
      for (var E = h.getAttribute("data-emotion").split(" "), m = 1; m < E.length; m++)
        o[E[m]] = !0;
      u.push(h);
    }
  );
  var s, c = [JZe, ZZe];
  {
    var l, f = [zZe, YZe(function(h) {
      l.insert(h);
    })], d = qZe(c.concat(i, f)), p = function(E) {
      return Ap(VZe(E), d);
    };
    s = function(E, m, g, y) {
      l = g, p(E ? E + "{" + m.styles + "}" : m.styles), y && (v.inserted[m.name] = !0);
    };
  }
  var v = {
    key: r,
    sheet: new RZe({
      key: r,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: s
  };
  return v.sheet.hydrate(u), v;
};
function tQe(e) {
  for (var t = 0, r, n = 0, i = e.length; i >= 4; ++n, i -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var rQe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, nQe = !1, iQe = /[A-Z]|^ms/g, oQe = /_EMO_([^_]+?)_([^]*?)_EMO_/g, dhe = function(t) {
  return t.charCodeAt(1) === 45;
}, Gq = function(t) {
  return t != null && typeof t != "boolean";
}, BO = /* @__PURE__ */ GZe(function(e) {
  return dhe(e) ? e : e.replace(iQe, "-$&").toLowerCase();
}), Wq = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(oQe, function(n, i, o) {
          return Vl = {
            name: i,
            styles: o,
            next: Vl
          }, i;
        });
  }
  return rQe[t] !== 1 && !dhe(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, aQe = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function RS(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var i = r;
      if (i.anim === 1)
        return Vl = {
          name: i.name,
          styles: i.styles,
          next: Vl
        }, i.name;
      var o = r;
      if (o.styles !== void 0) {
        var a = o.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Vl = {
              name: a.name,
              styles: a.styles,
              next: Vl
            }, a = a.next;
        var u = o.styles + ";";
        return u;
      }
      return uQe(e, t, r);
    }
  }
  var s = r;
  if (t == null)
    return s;
  var c = t[s];
  return c !== void 0 ? c : s;
}
function uQe(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var i = 0; i < r.length; i++)
      n += RS(e, t, r[i]) + ";";
  else
    for (var o in r) {
      var a = r[o];
      if (typeof a != "object") {
        var u = a;
        t != null && t[u] !== void 0 ? n += o + "{" + t[u] + "}" : Gq(u) && (n += BO(o) + ":" + Wq(o, u) + ";");
      } else {
        if (o === "NO_COMPONENT_SELECTOR" && nQe)
          throw new Error(aQe);
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var s = 0; s < a.length; s++)
            Gq(a[s]) && (n += BO(o) + ":" + Wq(o, a[s]) + ";");
        else {
          var c = RS(e, t, a);
          switch (o) {
            case "animation":
            case "animationName": {
              n += BO(o) + ":" + c + ";";
              break;
            }
            default:
              n += o + "{" + c + "}";
          }
        }
      }
    }
  return n;
}
var Kq = /label:\s*([^\s;{]+)\s*(;|$)/g, Vl;
function jc(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, i = "";
  Vl = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    n = !1, i += RS(r, t, o);
  else {
    var a = o;
    i += a[0];
  }
  for (var u = 1; u < e.length; u++)
    if (i += RS(r, t, e[u]), n) {
      var s = o;
      i += s[u];
    }
  Kq.lastIndex = 0;
  for (var c = "", l; (l = Kq.exec(i)) !== null; )
    c += "-" + l[1];
  var f = tQe(i) + c;
  return {
    name: f,
    styles: i,
    next: Vl
  };
}
function Lh(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (n += i + " ");
  }), n;
}
var sQe = function(t, r, n) {
  var i = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  t.registered[i] === void 0 && (t.registered[i] = r.styles);
}, R9 = function(t, r, n) {
  sQe(t, r);
  var i = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var o = r;
    do
      t.insert(r === o ? "." + i : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function Xq(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function Jq(e, t, r) {
  var n = [], i = Lh(e, n, r);
  return n.length < 2 ? r : i + t(n);
}
var cQe = function(t) {
  var r = O9(t);
  r.sheet.speedy = function(u) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = u;
  }, r.compat = !0;
  var n = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered, void 0);
    return R9(r, f), r.key + "-" + f.name;
  }, i = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered), d = "animation-" + f.name;
    return Xq(r, {
      name: f.name,
      styles: "@keyframes " + d + "{" + f.styles + "}"
    }), d;
  }, o = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered);
    Xq(r, f);
  }, a = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    return Jq(r.registered, n, lQe(c));
  };
  return {
    css: n,
    cx: a,
    injectGlobal: o,
    keyframes: i,
    hydrate: function(s) {
      s.forEach(function(c) {
        r.inserted[c] = !0;
      });
    },
    flush: function() {
      r.registered = {}, r.inserted = {}, r.sheet.flush();
    },
    // $FlowFixMe
    sheet: r.sheet,
    cache: r,
    getRegisteredStyles: Lh.bind(null, r.registered),
    merge: Jq.bind(null, r.registered, n)
  };
}, lQe = function e(t) {
  for (var r = "", n = 0; n < t.length; n++) {
    var i = t[n];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            o = "";
            for (var a in i)
              i[a] && a && (o && (o += " "), o += a);
          }
          break;
        }
        default:
          o = i;
      }
      o && (r && (r += " "), r += o);
    }
  }
  return r;
}, fQe = ry, w9 = Date.prototype, Zq = "Invalid Date", phe = "toString", dQe = w9[phe], pQe = w9.getTime;
String(/* @__PURE__ */ new Date(NaN)) != Zq && fQe(w9, phe, function() {
  var t = pQe.call(this);
  return t === t ? dQe.call(this) : Zq;
});
var hQe = T9, vQe = Rpe, EQe = hQe ? {}.toString : function() {
  return "[object " + vQe(this) + "]";
}, mQe = T9, gQe = ry, TQe = EQe;
mQe || gQe(Object.prototype, "toString", TQe, { unsafe: !0 });
var yQe = m9.PROPER, _Qe = ry, AQe = l0, Qq = hC, SQe = bs, bQe = wpe, P9 = "toString", hhe = RegExp.prototype, vhe = hhe[P9], CQe = SQe(function() {
  return vhe.call({ source: "a", flags: "b" }) != "/a/b";
}), IQe = yQe && vhe.name != P9;
(CQe || IQe) && _Qe(RegExp.prototype, P9, function() {
  var t = AQe(this), r = Qq(t.source), n = t.flags, i = Qq(n === void 0 && t instanceof RegExp && !("flags" in hhe) ? bQe.call(t) : n);
  return "/" + r + "/" + i;
}, { unsafe: !0 });
function OQe() {
  return Mu().toString(26).substr(2, 5).replace(/[0-9]/g, function(e) {
    return String.fromCharCode(e.charCodeAt(0) + 65);
  });
}
var RQe = ade;
const zp = /* @__PURE__ */ Mt(RQe);
function Nn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "white", r = "background-color: ".concat(e, "; border-radius: 4px; padding: 2px 4px;");
  return t && (r += " color: ".concat(t, ";")), [r, ""];
}
function eY(e, t) {
  for (var r, n, i = arguments.length, o = new Array(i > 2 ? i - 2 : 0), a = 2; a < i; a++)
    o[a - 2] = arguments[a];
  return si(r = [si(n = "%c".concat(e, "%c ")).call(n, t)]).call(r, nn(Nn("green", "white")), o);
}
function wQe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.force, n = r === void 0 ? !1 : r;
  return n ? function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    if (o.length) {
      var u = o, s = as(u, 1), c = s[0];
      typeof c == "function" && (o = c());
      var l = zp(o[0]) ? o : [o], f = l.length === 1;
      Pf(l).call(l, function(d, p) {
        if (f) {
          var v, h;
          (v = console).log.apply(v, nn(eY.apply(void 0, si(h = [e]).call(h, nn(d)))));
        } else if (p) {
          var E;
          (E = console).log.apply(E, nn(zp(d) ? d : [d]));
        } else {
          var m, g;
          (m = console).groupCollapsed.apply(m, nn(eY.apply(void 0, si(g = [e]).call(g, nn(d)))));
        }
      }), f || console.groupEnd();
    }
  } : function() {
    return 0;
  };
}
var PQe = nd, DQe = m9.EXISTS, xQe = ty.f, Ehe = Function.prototype, NQe = Ehe.toString, LQe = /^\s*function ([^ (]*)/, BQe = "name";
PQe && !DQe && xQe(Ehe, BQe, {
  configurable: !0,
  get: function() {
    try {
      return NQe.call(this).match(LQe)[1];
    } catch {
      return "";
    }
  }
});
var kQe = Pn, mhe = kQe.setTimeout, MQe = mhe;
const FQe = /* @__PURE__ */ Mt(MQe);
function HQe(e, t) {
  if (!t)
    return e;
  var r = 0, n = null;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var u = Vc();
    u - r > t ? (e.apply(void 0, o), r = u) : (clearTimeout(n), n = FQe(function() {
      e.apply(void 0, o), r = Vc();
    }, Math.max(0, t - u + r)));
  };
}
var ghe = function(t) {
  var r = t.debounce, n = t.name, i = t.onEvent, o = t.target, a = Ut();
  a.current = i;
  var u = tt(function() {
    return HQe(function(c) {
      var l = a.current;
      l && l(c);
    }, r);
  }, [r, a]), s = mt(function(c) {
    c.timeStampLow = Vc(), u(c);
  }, [u]);
  return Np(function() {
    return o.addEventListener(n, s, {
      passive: !0
    }), s({
      target: o,
      type: n
    }), function() {
      return o.removeEventListener(n, s);
    };
  }, [n, s, o]), !1;
};
ghe.defaultProps = {
  debounce: 200
};
var $Qe = Math.sign || function(t) {
  var r = +t;
  return r === 0 || r !== r ? r : r < 0 ? -1 : 1;
}, UQe = Zt, VQe = $Qe;
UQe({ target: "Math", stat: !0 }, {
  sign: VQe
});
var jQe = Pn, zQe = jQe.Math.sign, qQe = zQe, The = qQe, YQe = The;
const GQe = /* @__PURE__ */ Mt(YQe);
function WQe(e, t) {
  var r = GQe(t - e), n = Math.sqrt(Math.abs(t - e)), i = e + n * r;
  return r > 0 ? Math.min(t, i) : Math.max(t, i);
}
function KQe(e, t, r, n) {
  for (var i = e, o = 0; o < n; o++)
    i = r(i, t);
  return i;
}
var yhe = function(t) {
  var r = t.name, n = t.onEnd, i = t.target, o = t.value, a = Ut(), u = mt(function(c, l, f, d) {
    var p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Vc();
    (f === "100%" || typeof f == "number") && (cancelAnimationFrame(a.current), a.current = requestAnimationFrame(function() {
      if (i) {
        var v = f === "100%" ? i.scrollHeight - i.offsetHeight : f, h = KQe(l, v, WQe, (Vc() - p) / 5);
        Math.abs(v - h) < 1.5 && (h = v), i[c] = h, v === h ? n && n(!0) : u(c, l, f, d + 1, p);
      }
    }));
  }, [a, n, i]), s = mt(function() {
    cancelAnimationFrame(a.current), n && n(!1);
  }, [n]);
  return Np(function() {
    return u(r, i[r], o, 1), i ? (i.addEventListener("pointerdown", s, {
      passive: !0
    }), i.addEventListener("wheel", s, {
      passive: !0
    }), function() {
      i.removeEventListener("pointerdown", s), i.removeEventListener("wheel", s), cancelAnimationFrame(a.current);
    }) : function() {
      return cancelAnimationFrame(a.current);
    };
  }, [u, a, s, r, i, o]), !1;
};
yhe.propTypes = {
  name: vn.string.isRequired,
  onEnd: vn.func,
  target: vn.any.isRequired,
  value: vn.oneOfType([vn.number, vn.oneOf(["100%"])]).isRequired
};
function kO(e) {
  var t = cn(e), r = as(t, 2), n = r[0], i = r[1], o = Ut(), a = mt(function(u) {
    typeof u == "function" ? a(function(s) {
      return u = u(s), o.current = u, u;
    }) : (o.current = u, a(u));
  }, [o]);
  return o.current = n, [n, i, o];
}
function tY(e, t) {
  var r = IS(e);
  if (Uq) {
    var n = Uq(e);
    t && (n = Kpe(n).call(n, function(i) {
      return iy(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    if (t % 2) {
      var n;
      Pf(n = tY(Object(r), !0)).call(n, function(o) {
        Vqe(e, o, r[o]);
      });
    } else if (Vq)
      S9(e, Vq(r));
    else {
      var i;
      Pf(i = tY(Object(r))).call(i, function(o) {
        wu(e, o, iy(r, o));
      });
    }
  }
  return e;
}
var XQe = function() {
  return 1 / 0;
}, nY = 17, JQe = "bottom", is = "top", iY = 1, ZQe = 34, oY = {};
function QQe(e, t) {
  return e(), mXe(e, t);
}
function aY(e) {
  var t = e.mode, r = e.target, n = r.offsetHeight, i = r.scrollHeight, o = r.scrollTop, a = i - o - n < iY, u = o < iY, s = t === is ? u : a, c = t !== is ? u : a;
  return {
    atBottom: a,
    atEnd: s,
    atStart: c,
    atTop: u
  };
}
function Pv(e, t) {
  return e === (t === is ? 0 : "100%");
}
var D9 = function(t) {
  var r = t.checkInterval, n = t.children, i = t.debounce, o = t.debug, a = t.initialScrollBehavior, u = t.mode, s = t.nonce, c = t.scroller, l = tt(function() {
    return wQe("<ScrollToBottom>", {
      force: o
    });
  }, [o]);
  u = u === is ? is : JQe;
  var f = Ut(0), d = Ut(a), p = kO(u === is ? 0 : "100%"), v = as(p, 3), h = v[0], E = v[1], m = v[2], g = kO(null), y = as(g, 3), _ = y[0], S = y[1], A = y[2], O = Ut(0), P = Ut(0), U = Ut(0), z = cn(!0), k = as(z, 2), H = k[0], B = k[1], x = cn(!0), D = as(x, 2), w = D[0], $ = D[1], X = cn(!0), V = as(X, 2), F = V[0], le = V[1], ae = cn(!1), ne = as(ae, 2), ve = ne[0], Ie = ne[1], Oe = kO(!0), xe = as(Oe, 3), ze = xe[0], qe = xe[1], Je = xe[2], Be = Ut([]), We = mt(function(ie) {
    var K = A.current;
    return Be.current.push(ie), K && ie({
      scrollTop: K.scrollTop
    }), function() {
      var Z = Be.current, Ce = _p(Z).call(Z, ie);
      ~Ce && e1(Z).call(Z, Ce, 1);
    };
  }, [Be, A]), Ne = mt(function() {
    var ie = m.current;
    l(function() {
      var K;
      return si(K = ["%cSpineTo%c: %conEnd%c is fired."]).call(K, nn(Nn("magenta")), nn(Nn("orange")), [{
        animateTo: ie
      }]);
    }), f.current = Vc(), Pv(ie, u) || qe(!1), E(null);
  }, [m, l, f, u, E, qe]), je = mt(function(ie) {
    var K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Z = K.behavior, Ce = A.current;
    if (typeof ie != "number" && ie !== "100%")
      return console.warn('react-scroll-to-bottom: Arguments passed to scrollTo() must be either number or "100%".');
    l(function() {
      var be;
      return [si(be = ["%cscrollTo%c: Will scroll to %c".concat(typeof ie == "number" ? ie + "px" : ie.replace(/%/g, "%%"), "%c")]).call(be, nn(Nn("lime", "")), nn(Nn("purple"))), {
        behavior: Z,
        nextAnimateTo: ie,
        target: Ce
      }];
    }), Z === "auto" ? (Ne(), Ce && (Ce.scrollTop = ie === "100%" ? Ce.scrollHeight - Ce.offsetHeight : ie)) : (Z !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollTo". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), E(ie)), Pv(ie, u) && (l(function() {
      var be;
      return [si(be = ["%cscrollTo%c: Scrolling to end, will set sticky to %ctrue%c."]).call(be, nn(Nn("lime", "")), nn(Nn("purple"))), [{
        mode: u,
        nextAnimateTo: ie
      }]];
    }), qe(!0));
  }, [l, Ne, u, E, qe, A]), et = mt(function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, K = ie.behavior;
    l(function() {
      var Z;
      return si(Z = ["%cscrollToBottom%c: Called"]).call(Z, nn(Nn("yellow", "")));
    }), K !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToBottom". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), je("100%", {
      behavior: K || "smooth"
    });
  }, [l, je]), St = mt(function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, K = ie.behavior;
    l(function() {
      var Z;
      return si(Z = ["%cscrollToTop%c: Called"]).call(Z, nn(Nn("yellow", "")));
    }), K !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToTop". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), je(0, {
      behavior: K || "smooth"
    });
  }, [l, je]), Ot = mt(function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, K = ie.behavior;
    l(function() {
      var Ce;
      return si(Ce = ["%cscrollToEnd%c: Called"]).call(Ce, nn(Nn("yellow", "")));
    }), K !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToEnd". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
    var Z = {
      behavior: K || "smooth"
    };
    u === is ? St(Z) : et(Z);
  }, [l, u, et, St]), we = mt(function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, K = ie.behavior;
    l(function() {
      var Ce;
      return si(Ce = ["%cscrollToStart%c: Called"]).call(Ce, nn(Nn("yellow", "")));
    }), K !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToStart". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
    var Z = {
      behavior: K || "smooth"
    };
    u === is ? et(Z) : St(Z);
  }, [l, u, et, St]), De = mt(function() {
    var ie = A.current;
    if (ie) {
      if (d.current === "auto") {
        l(function() {
          var Xt;
          return si(Xt = ["%ctarget changed%c: Initial scroll"]).call(Xt, nn(Nn("blue")));
        }), ie.scrollTop = u === is ? 0 : ie.scrollHeight - ie.offsetHeight, d.current = !1;
        return;
      }
      var K = O.current, Z = ie.offsetHeight, Ce = ie.scrollHeight, be = ie.scrollTop, Ge = u === is ? 0 : Math.max(0, Ce - Z - be), st = Math.max(0, K - be), wt = c({
        maxValue: Ge,
        minValue: st,
        offsetHeight: Z,
        scrollHeight: Ce,
        scrollTop: be
      }), Bt = Math.max(0, Math.min(Ge, wt)), jt;
      u === is || Bt !== Ge ? jt = be + Bt : jt = "100%", l(function() {
        var Xt, Qt, Zr;
        return [si(Xt = [si(Qt = si(Zr = "%cscrollToSticky%c: Will animate from %c".concat(K, "px%c to %c")).call(Zr, typeof jt == "number" ? jt + "px" : jt.replace(/%/g, "%%"), "%c (%c")).call(Qt, (jt === "100%" ? Ge : jt) + K, "px%c)")]).call(Xt, nn(Nn("orange")), nn(Nn("purple")), nn(Nn("purple")), nn(Nn("purple"))), {
          animateFrom: K,
          maxValue: Ge,
          minValue: st,
          nextAnimateTo: jt,
          nextValue: Bt,
          offsetHeight: Z,
          rawNextValue: wt,
          scrollHeight: Ce,
          scrollTop: be
        }];
      }), je(jt, {
        behavior: "smooth"
      });
    }
  }, [O, l, u, c, je, A]), Ee = mt(function(ie) {
    var K, Z = ie.timeStampLow, Ce = m.current, be = A.current, Ge = Ce !== null;
    if (!(Z <= f.current || !be)) {
      var st = aY({
        mode: u,
        target: be
      }), wt = st.atBottom, Bt = st.atEnd, jt = st.atStart, Xt = st.atTop;
      B(wt), $(Bt), Ie(jt), le(Xt);
      var Qt = be.offsetHeight, Zr = be.scrollHeight, Jn = P.current, Ur = U.current, fn = Qt !== Jn, gn = Zr !== Ur;
      if (fn && (P.current = Qt), gn && (U.current = Zr), !fn && !gn) {
        var cr = Ge && Pv(Ce, u) || Bt;
        Je.current !== cr && (l(function() {
          var ai, vo, to, Ui;
          return [si(ai = ["%conScroll%c: %csetSticky%c(%c".concat(cr, "%c)")]).call(ai, nn(Nn("red")), nn(Nn("red")), nn(Nn("purple"))), si(vo = [si(to = si(Ui = "(animating = %c".concat(Ge, "%c && isEnd = %c")).call(Ui, Pv(Ce, u), "%c) || atEnd = %c")).call(to, Bt, "%c")]).call(vo, nn(Nn("purple")), nn(Nn("purple")), nn(Nn("purple")), [{
            animating: Ge,
            animateTo: Ce,
            atEnd: Bt,
            mode: u,
            offsetHeight: be.offsetHeight,
            scrollHeight: be.scrollHeight,
            sticky: Je.current,
            nextSticky: cr
          }])];
        }), qe(cr));
      } else Je.current && (l(function() {
        var ai;
        return [si(ai = ["%conScroll%c: Size changed while sticky, calling %cscrollToSticky()%c"]).call(ai, nn(Nn("red")), nn(Nn("orange")), [{
          offsetHeightChanged: fn,
          scrollHeightChanged: gn
        }]), {
          nextOffsetHeight: Qt,
          prevOffsetHeight: Jn,
          nextScrollHeight: Zr,
          prevScrollHeight: Ur
        }];
      }), De());
      var Ri = be.scrollTop;
      Pf(K = Be.current).call(K, function(ai) {
        return ai({
          scrollTop: Ri
        });
      });
    }
  }, [m, l, f, u, P, U, Be, De, B, $, Ie, le, qe, Je, A]);
  nr(function() {
    if (_) {
      var ie = !1, K = QQe(function() {
        var Z = A.current, Ce = m.current !== null;
        Je.current ? aY({
          mode: u,
          target: Z
        }).atEnd ? ie = !1 : ie ? Vc() - ie > ZQe && (Ce || (O.current = Z.scrollTop, l(function() {
          var be;
          return si(be = ["%cInterval check%c: Should sticky but not at end, calling %cscrollToSticky()%c to scroll"]).call(be, nn(Nn("navy")), nn(Nn("orange")));
        }), De()), ie = !1) : ie = Vc() : Z.scrollHeight <= Z.offsetHeight && !Je.current && (l(function() {
          var be;
          return [si(be = ["%cInterval check%c: Container is emptied, setting sticky back to %ctrue%c"]).call(be, nn(Nn("navy")), nn(Nn("purple"))), [{
            offsetHeight: Z.offsetHeight,
            scrollHeight: Z.scrollHeight,
            sticky: Je.current
          }]];
        }), qe(!0));
      }, Math.max(nY, r) || nY);
      return function() {
        return clearInterval(K);
      };
    }
  }, [m, r, l, u, De, qe, Je, _, A]);
  var te = tt(function() {
    var ie = oY[s] || (oY[s] = cQe({
      key: "react-scroll-to-bottom--css-" + OQe(),
      nonce: s
    }));
    return function(K) {
      return ie.css(K) + "";
    };
  }, [s]), ue = tt(function() {
    return {
      observeScrollPosition: We,
      setTarget: S,
      styleToClassName: te
    };
  }, [We, S, te]), ye = tt(function() {
    return {
      atBottom: H,
      atEnd: w,
      atStart: ve,
      atTop: F,
      mode: u
    };
  }, [H, w, ve, F, u]), Le = tt(function() {
    var ie = h !== null;
    return {
      animating: ie,
      animatingToEnd: ie && Pv(h, u),
      sticky: ze
    };
  }, [h, u, ze]), Me = tt(function() {
    return rY(rY({}, ye), Le);
  }, [ye, Le]), Ae = tt(function() {
    return {
      scrollTo: je,
      scrollToBottom: et,
      scrollToEnd: Ot,
      scrollToStart: we,
      scrollToTop: St
    };
  }, [je, et, Ot, we, St]);
  return nr(function() {
    if (_) {
      var ie = function() {
        U.current = _.scrollHeight;
      };
      return _.addEventListener("focus", ie, {
        capture: !0,
        passive: !0
      }), function() {
        return _.removeEventListener("focus", ie);
      };
    }
  }, [_]), l(function() {
    var ie;
    return [si(ie = ["%cRender%c: Render"]).call(ie, nn(Nn("cyan", ""))), {
      animateTo: h,
      animating: h !== null,
      sticky: ze,
      target: _
    }];
  }), /* @__PURE__ */ G.createElement(sC.Provider, {
    value: ue
  }, /* @__PURE__ */ G.createElement(i9.Provider, {
    value: Ae
  }, /* @__PURE__ */ G.createElement(u9.Provider, {
    value: Me
  }, /* @__PURE__ */ G.createElement(o9.Provider, {
    value: ye
  }, /* @__PURE__ */ G.createElement(a9.Provider, {
    value: Le
  }, n, _ && /* @__PURE__ */ G.createElement(ghe, {
    debounce: i,
    name: "scroll",
    onEvent: Ee,
    target: _
  }), _ && h !== null && /* @__PURE__ */ G.createElement(yhe, {
    name: "scrollTop",
    onEnd: Ne,
    target: _,
    value: h
  }))))));
};
D9.defaultProps = {
  checkInterval: 100,
  children: void 0,
  debounce: 17,
  debug: void 0,
  initialScrollBehavior: "smooth",
  mode: void 0,
  nonce: void 0,
  scroller: XQe
};
D9.propTypes = {
  checkInterval: vn.number,
  children: vn.any,
  debounce: vn.number,
  debug: vn.bool,
  initialScrollBehavior: vn.oneOf(["auto", "smooth"]),
  mode: vn.oneOf(["bottom", "top"]),
  nonce: vn.string,
  scroller: vn.func
};
var eet = {
  height: "100%",
  overflowY: "auto",
  width: "100%"
}, x9 = function(t) {
  var r = t.children, n = t.className, i = En(sC), o = i.setTarget, a = dqe()(eet);
  return /* @__PURE__ */ G.createElement("div", {
    className: iqe(a, (n || "") + ""),
    ref: o
  }, r);
};
x9.defaultProps = {
  children: void 0,
  className: void 0
};
x9.propTypes = {
  children: vn.any,
  className: vn.string
};
vn.any, vn.string, vn.string, vn.string;
vn.number, vn.any, vn.string, vn.number, vn.bool, vn.string, vn.oneOf(["auto", "smooth"]), vn.oneOf(["bottom", "top"]), vn.string, vn.func, vn.string;
function tet() {
  var e = s9(2), t = e.animatingToEnd;
  return [t];
}
function ret() {
  var e = s9(1), t = e.atEnd;
  return [t];
}
function net(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  e && typeof e != "function" ? console.error('react-scroll-to-bottom: First argument passed to "useObserveScrollPosition" must be a function.') : zp(r) || console.error('react-scroll-to-bottom: Second argument passed to "useObserveScrollPosition" must be an array if specified.');
  var n = Wde(), i = n.observeScrollPosition;
  nr(function() {
    return e && i(e);
  }, si(t = []).call(t, nn(r), [!e, i]));
}
function iet() {
  var e = Yde(), t = e.scrollTo;
  return t;
}
_$e();
var _he = { exports: {} }, oet = mn, aet = oet(function() {
  if (typeof ArrayBuffer == "function") {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
  }
}), uet = mn, set = $i, cet = i0, uY = aet, x4 = Object.isExtensible, fet = uet(function() {
  x4(1);
}), det = fet || uY ? function(t) {
  return !set(t) || uY && cet(t) === "ArrayBuffer" ? !1 : x4 ? x4(t) : !0;
} : x4, pet = mn, Ahe = !pet(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), het = Zt, vet = bn, Eet = kT, met = $i, N9 = Co, get = Ha.f, sY = BT, Tet = rC, L9 = det, yet = Fb, _et = Ahe, She = !1, Gc = yet("meta"), Aet = 0, B9 = function(e) {
  get(e, Gc, { value: {
    objectID: "O" + Aet++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, bet = function(e, t) {
  if (!met(e)) return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!N9(e, Gc)) {
    if (!L9(e)) return "F";
    if (!t) return "E";
    B9(e);
  }
  return e[Gc].objectID;
}, Cet = function(e, t) {
  if (!N9(e, Gc)) {
    if (!L9(e)) return !0;
    if (!t) return !1;
    B9(e);
  }
  return e[Gc].weakData;
}, Iet = function(e) {
  return _et && She && L9(e) && !N9(e, Gc) && B9(e), e;
}, Oet = function() {
  Ret.enable = function() {
  }, She = !0;
  var e = sY.f, t = vet([].splice), r = {};
  r[Gc] = 1, e(r).length && (sY.f = function(n) {
    for (var i = e(n), o = 0, a = i.length; o < a; o++)
      if (i[o] === Gc) {
        t(i, o, 1);
        break;
      }
    return i;
  }, het({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: Tet.f
  }));
}, Ret = _he.exports = {
  enable: Oet,
  fastKey: bet,
  getWeakData: Cet,
  onFreeze: Iet
};
Eet[Gc] = !0;
var gC = _he.exports, wet = Zt, Pet = Mn, Det = gC, xet = mn, Net = o0, Let = ic, Bet = qb, ket = Fi, Met = $i, Fet = Gf, Het = s0, $et = Ha.f, Uet = c0.forEach, Vet = Hi, bhe = u0, jet = bhe.set, zet = bhe.getterFor, k9 = function(e, t, r) {
  var n = e.indexOf("Map") !== -1, i = e.indexOf("Weak") !== -1, o = n ? "set" : "add", a = Pet[e], u = a && a.prototype, s = {}, c;
  if (!Vet || !ket(a) || !(i || u.forEach && !xet(function() {
    new a().entries().next();
  })))
    c = r.getConstructor(t, e, n, o), Det.enable();
  else {
    c = t(function(d, p) {
      jet(Bet(d, l), {
        type: e,
        collection: new a()
      }), Fet(p) || Let(p, d[o], { that: d, AS_ENTRIES: n });
    });
    var l = c.prototype, f = zet(e);
    Uet(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(d) {
      var p = d === "add" || d === "set";
      d in u && !(i && d === "clear") && Net(l, d, function(v, h) {
        var E = f(this).collection;
        if (!p && i && !Met(v)) return d === "get" ? void 0 : !1;
        var m = E[d](v === 0 ? 0 : v, h);
        return p ? this : m;
      });
    }), i || $et(l, "size", {
      configurable: !0,
      get: function() {
        return f(this).collection.size;
      }
    });
  }
  return Het(c, e, !1, !0), s[e] = c, wet({ global: !0, forced: !0 }, s), i || r.setStrong(c, e, n), c;
}, qet = gh, M9 = function(e, t, r) {
  for (var n in t)
    r && r.unsafe && e[n] ? e[n] = t[n] : qet(e, n, t[n], r);
  return e;
}, cY = Xf, Yet = rk, lY = M9, Get = Kf, Wet = qb, Ket = Gf, Xet = ic, Jet = Q8, Z_ = ek, Zet = wle, Dv = Hi, fY = gC.fastKey, Che = u0, dY = Che.set, MO = Che.getterFor, Ihe = {
  getConstructor: function(e, t, r, n) {
    var i = e(function(c, l) {
      Wet(c, o), dY(c, {
        type: t,
        index: cY(null),
        first: null,
        last: null,
        size: 0
      }), Dv || (c.size = 0), Ket(l) || Xet(l, c[n], { that: c, AS_ENTRIES: r });
    }), o = i.prototype, a = MO(t), u = function(c, l, f) {
      var d = a(c), p = s(c, l), v, h;
      return p ? p.value = f : (d.last = p = {
        index: h = fY(l, !0),
        key: l,
        value: f,
        previous: v = d.last,
        next: null,
        removed: !1
      }, d.first || (d.first = p), v && (v.next = p), Dv ? d.size++ : c.size++, h !== "F" && (d.index[h] = p)), c;
    }, s = function(c, l) {
      var f = a(c), d = fY(l), p;
      if (d !== "F") return f.index[d];
      for (p = f.first; p; p = p.next)
        if (p.key === l) return p;
    };
    return lY(o, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var l = this, f = a(l), d = f.first; d; )
          d.removed = !0, d.previous && (d.previous = d.previous.next = null), d = d.next;
        f.first = f.last = null, f.index = cY(null), Dv ? f.size = 0 : l.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var l = this, f = a(l), d = s(l, c);
        if (d) {
          var p = d.next, v = d.previous;
          delete f.index[d.index], d.removed = !0, v && (v.next = p), p && (p.previous = v), f.first === d && (f.first = p), f.last === d && (f.last = v), Dv ? f.size-- : l.size--;
        }
        return !!d;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(l) {
        for (var f = a(this), d = Get(l, arguments.length > 1 ? arguments[1] : void 0), p; p = p ? p.next : f.first; )
          for (d(p.value, p.key, this); p && p.removed; ) p = p.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(l) {
        return !!s(this, l);
      }
    }), lY(o, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(l) {
        var f = s(this, l);
        return f && f.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(l, f) {
        return u(this, l === 0 ? 0 : l, f);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(l) {
        return u(this, l = l === 0 ? 0 : l, l);
      }
    }), Dv && Yet(o, "size", {
      configurable: !0,
      get: function() {
        return a(this).size;
      }
    }), i;
  },
  setStrong: function(e, t, r) {
    var n = t + " Iterator", i = MO(t), o = MO(n);
    Jet(e, t, function(a, u) {
      dY(this, {
        type: n,
        target: a,
        state: i(a),
        kind: u,
        last: null
      });
    }, function() {
      for (var a = o(this), u = a.kind, s = a.last; s && s.removed; ) s = s.previous;
      return !a.target || !(a.last = s = s ? s.next : a.state.first) ? (a.target = null, Z_(void 0, !0)) : Z_(u === "keys" ? s.key : u === "values" ? s.value : [s.key, s.value], !1);
    }, r ? "entries" : "values", !r, !0), Zet(t);
  }
}, Qet = k9, ett = Ihe;
Qet("Set", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, ett);
var ttt = Wf, rtt = TypeError, od = function(e) {
  if (typeof e == "object" && "size" in e && "has" in e && "add" in e && "delete" in e && "keys" in e) return e;
  throw new rtt(ttt(e) + " is not a set");
}, Ohe = function(e, t) {
  return t === 1 ? function(r, n) {
    return r[e](n);
  } : function(r, n, i) {
    return r[e](n, i);
  };
}, ntt = zo, FO = Ohe, Rhe = ntt("Set"), itt = Rhe.prototype, ad = {
  Set: Rhe,
  add: FO("add", 1),
  has: FO("has", 1),
  remove: FO("delete", 1),
  proto: itt
}, ott = po, ud = function(e, t, r) {
  for (var n = r ? e : e.iterator, i = e.next, o, a; !(o = ott(i, n)).done; )
    if (a = t(o.value), a !== void 0) return a;
}, att = ud, ay = function(e, t, r) {
  return r ? att(e.keys(), t, !0) : e.forEach(t);
}, whe = ad, utt = ay, stt = whe.Set, ctt = whe.add, F9 = function(e) {
  var t = new stt();
  return utt(e, function(r) {
    ctt(t, r);
  }), t;
}, uy = function(e) {
  return e.size;
}, ltt = function(e) {
  return {
    iterator: e,
    next: e.next,
    done: !1
  };
}, pY = _a, Phe = $a, hY = po, ftt = Eh, dtt = ltt, vY = "Invalid size", ptt = RangeError, htt = TypeError, vtt = Math.max, Dhe = function(e, t) {
  this.set = e, this.size = vtt(t, 0), this.has = pY(e.has), this.keys = pY(e.keys);
};
Dhe.prototype = {
  getIterator: function() {
    return dtt(Phe(hY(this.keys, this.set)));
  },
  includes: function(e) {
    return hY(this.has, this.set, e);
  }
};
var sd = function(e) {
  Phe(e);
  var t = +e.size;
  if (t !== t) throw new htt(vY);
  var r = ftt(t);
  if (r < 0) throw new ptt(vY);
  return new Dhe(e, r);
}, Ett = od, xhe = ad, mtt = F9, gtt = uy, Ttt = sd, ytt = ay, _tt = ud, Att = xhe.has, EY = xhe.remove, Stt = function(t) {
  var r = Ett(this), n = Ttt(t), i = mtt(r);
  return gtt(r) <= n.size ? ytt(r, function(o) {
    n.includes(o) && EY(i, o);
  }) : _tt(n.getIterator(), function(o) {
    Att(r, o) && EY(i, o);
  }), i;
}, cd = function() {
  return !1;
}, btt = Zt, Ctt = Stt, Itt = cd;
btt({ target: "Set", proto: !0, real: !0, forced: !Itt() }, {
  difference: Ctt
});
var Ott = od, H9 = ad, Rtt = uy, wtt = sd, Ptt = ay, Dtt = ud, xtt = H9.Set, mY = H9.add, Ntt = H9.has, Ltt = function(t) {
  var r = Ott(this), n = wtt(t), i = new xtt();
  return Rtt(r) > n.size ? Dtt(n.getIterator(), function(o) {
    Ntt(r, o) && mY(i, o);
  }) : Ptt(r, function(o) {
    n.includes(o) && mY(i, o);
  }), i;
}, Btt = Zt, ktt = Ltt, Mtt = cd, Ftt = !Mtt();
Btt({ target: "Set", proto: !0, real: !0, forced: Ftt }, {
  intersection: ktt
});
var Htt = od, $tt = ad.has, Utt = uy, Vtt = sd, jtt = ay, ztt = ud, qtt = jb, Ytt = function(t) {
  var r = Htt(this), n = Vtt(t);
  if (Utt(r) <= n.size) return jtt(r, function(o) {
    if (n.includes(o)) return !1;
  }, !0) !== !1;
  var i = n.getIterator();
  return ztt(i, function(o) {
    if ($tt(r, o)) return qtt(i, "normal", !1);
  }) !== !1;
}, Gtt = Zt, Wtt = Ytt, Ktt = cd;
Gtt({ target: "Set", proto: !0, real: !0, forced: !Ktt() }, {
  isDisjointFrom: Wtt
});
var Xtt = od, Jtt = uy, Ztt = ay, Qtt = sd, ert = function(t) {
  var r = Xtt(this), n = Qtt(t);
  return Jtt(r) > n.size ? !1 : Ztt(r, function(i) {
    if (!n.includes(i)) return !1;
  }, !0) !== !1;
}, trt = Zt, rrt = ert, nrt = cd;
trt({ target: "Set", proto: !0, real: !0, forced: !nrt() }, {
  isSubsetOf: rrt
});
var irt = od, ort = ad.has, art = uy, urt = sd, srt = ud, crt = jb, lrt = function(t) {
  var r = irt(this), n = urt(t);
  if (art(r) < n.size) return !1;
  var i = n.getIterator();
  return srt(i, function(o) {
    if (!ort(r, o)) return crt(i, "normal", !1);
  }) !== !1;
}, frt = Zt, drt = lrt, prt = cd;
frt({ target: "Set", proto: !0, real: !0, forced: !prt() }, {
  isSupersetOf: drt
});
var hrt = od, $9 = ad, vrt = F9, Ert = sd, mrt = ud, grt = $9.add, Trt = $9.has, yrt = $9.remove, _rt = function(t) {
  var r = hrt(this), n = Ert(t).getIterator(), i = vrt(r);
  return mrt(n, function(o) {
    Trt(r, o) ? yrt(i, o) : grt(i, o);
  }), i;
}, Art = Zt, Srt = _rt, brt = cd;
Art({ target: "Set", proto: !0, real: !0, forced: !brt() }, {
  symmetricDifference: Srt
});
var Crt = od, Irt = ad.add, Ort = F9, Rrt = sd, wrt = ud, Prt = function(t) {
  var r = Crt(this), n = Rrt(t).getIterator(), i = Ort(r);
  return wrt(n, function(o) {
    Irt(i, o);
  }), i;
}, Drt = Zt, xrt = Prt, Nrt = cd;
Drt({ target: "Set", proto: !0, real: !0, forced: !Nrt() }, {
  union: xrt
});
var Lrt = Pn, Brt = Lrt.Set, krt = Brt, Mrt = krt, Frt = Mrt;
const Hrt = /* @__PURE__ */ Mt(Frt);
function $rt(e) {
  var t = Ut(), r = tt(function() {
    return wf({}, {
      current: {
        get: function() {
          return t.current;
        }
      }
    });
  }, [t]);
  return t.current = e, r;
}
function Nhe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = !1, r = e.allowPropagateDuringRender, n = new Hrt(), i = function(s) {
    return void n.add(s);
  }, o = function(s) {
    return void n.delete(s);
  }, a = function() {
    return t = !0, Np(function() {
      t = !1;
    }), function(s) {
      if (t && !r)
        return console.warn("use-propagate: The propagate callback function should not be called while rendering, ignoring the call.");
      Pf(n).call(n, function(c) {
        return c(s);
      });
    };
  };
  return {
    useListen: function(s) {
      var c = $rt(s), l = mt(function(f) {
        return c.current(f);
      }, [c]);
      tt(function() {
        return i(l);
      }, [l]), nr(function() {
        return function() {
          return o(l);
        };
      }, [l]);
    },
    usePropagate: a
  };
}
function gY(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function TY(e, t, r) {
  var n = [], i = Lh(e, n, r);
  return n.length < 2 ? r : i + t(n);
}
var Lhe = function(t) {
  var r = O9(t);
  r.sheet.speedy = function(u) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = u;
  }, r.compat = !0;
  var n = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered, void 0);
    return R9(r, f), r.key + "-" + f.name;
  }, i = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered), d = "animation-" + f.name;
    return gY(r, {
      name: f.name,
      styles: "@keyframes " + d + "{" + f.styles + "}"
    }), d;
  }, o = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered);
    gY(r, f);
  }, a = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    return TY(r.registered, n, Urt(c));
  };
  return {
    css: n,
    cx: a,
    injectGlobal: o,
    keyframes: i,
    hydrate: function(s) {
      s.forEach(function(c) {
        r.inserted[c] = !0;
      });
    },
    flush: function() {
      r.registered = {}, r.inserted = {}, r.sheet.flush();
    },
    // $FlowFixMe
    sheet: r.sheet,
    cache: r,
    getRegisteredStyles: Lh.bind(null, r.registered),
    merge: TY.bind(null, r.registered, n)
  };
}, Urt = function e(t) {
  for (var r = "", n = 0; n < t.length; n++) {
    var i = t[n];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            o = "";
            for (var a in i)
              i[a] && a && (o && (o += " "), o += a);
          }
          break;
        }
        default:
          o = i;
      }
      o && (r && (r += " "), r += o);
    }
  }
  return r;
}, uc = Lhe({
  key: "css"
});
uc.flush;
uc.hydrate;
var Vrt = uc.cx;
uc.merge;
uc.getRegisteredStyles;
uc.injectGlobal;
uc.keyframes;
uc.css;
uc.sheet;
uc.cache;
function yY(e) {
  return typeof e == "object" && e != null && e.nodeType === 1;
}
function _Y(e, t) {
  return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function HO(e, t) {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    var r = getComputedStyle(e, null);
    return _Y(r.overflowY, t) || _Y(r.overflowX, t) || function(n) {
      var i = function(o) {
        if (!o.ownerDocument || !o.ownerDocument.defaultView) return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(n);
      return !!i && (i.clientHeight < n.scrollHeight || i.clientWidth < n.scrollWidth);
    }(e);
  }
  return !1;
}
function Q_(e, t, r, n, i, o, a, u) {
  return o < e && a > t || o > e && a < t ? 0 : o <= e && u <= r || a >= t && u >= r ? o - e - n : a > t && u < r || o < e && u > r ? a - t + i : 0;
}
var jrt = function(e, t) {
  var r = window, n = t.scrollMode, i = t.block, o = t.inline, a = t.boundary, u = t.skipOverflowHiddenElements, s = typeof a == "function" ? a : function(je) {
    return je !== a;
  };
  if (!yY(e)) throw new TypeError("Invalid target");
  for (var c, l, f = document.scrollingElement || document.documentElement, d = [], p = e; yY(p) && s(p); ) {
    if ((p = (l = (c = p).parentElement) == null ? c.getRootNode().host || null : l) === f) {
      d.push(p);
      break;
    }
    p != null && p === document.body && HO(p) && !HO(document.documentElement) || p != null && HO(p, u) && d.push(p);
  }
  for (var v = r.visualViewport ? r.visualViewport.width : innerWidth, h = r.visualViewport ? r.visualViewport.height : innerHeight, E = window.scrollX || pageXOffset, m = window.scrollY || pageYOffset, g = e.getBoundingClientRect(), y = g.height, _ = g.width, S = g.top, A = g.right, O = g.bottom, P = g.left, U = i === "start" || i === "nearest" ? S : i === "end" ? O : S + y / 2, z = o === "center" ? P + _ / 2 : o === "end" ? A : P, k = [], H = 0; H < d.length; H++) {
    var B = d[H], x = B.getBoundingClientRect(), D = x.height, w = x.width, $ = x.top, X = x.right, V = x.bottom, F = x.left;
    if (n === "if-needed" && S >= 0 && P >= 0 && O <= h && A <= v && S >= $ && O <= V && P >= F && A <= X) return k;
    var le = getComputedStyle(B), ae = parseInt(le.borderLeftWidth, 10), ne = parseInt(le.borderTopWidth, 10), ve = parseInt(le.borderRightWidth, 10), Ie = parseInt(le.borderBottomWidth, 10), Oe = 0, xe = 0, ze = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - ae - ve : 0, qe = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - ne - Ie : 0, Je = "offsetWidth" in B ? B.offsetWidth === 0 ? 0 : w / B.offsetWidth : 0, Be = "offsetHeight" in B ? B.offsetHeight === 0 ? 0 : D / B.offsetHeight : 0;
    if (f === B) Oe = i === "start" ? U : i === "end" ? U - h : i === "nearest" ? Q_(m, m + h, h, ne, Ie, m + U, m + U + y, y) : U - h / 2, xe = o === "start" ? z : o === "center" ? z - v / 2 : o === "end" ? z - v : Q_(E, E + v, v, ae, ve, E + z, E + z + _, _), Oe = Math.max(0, Oe + m), xe = Math.max(0, xe + E);
    else {
      Oe = i === "start" ? U - $ - ne : i === "end" ? U - V + Ie + qe : i === "nearest" ? Q_($, V, D, ne, Ie + qe, U, U + y, y) : U - ($ + D / 2) + qe / 2, xe = o === "start" ? z - F - ae : o === "center" ? z - (F + w / 2) + ze / 2 : o === "end" ? z - X + ve + ze : Q_(F, X, w, ae, ve + ze, z, z + _, _);
      var We = B.scrollLeft, Ne = B.scrollTop;
      U += Ne - (Oe = Math.max(0, Math.min(Ne + Oe / Be, B.scrollHeight - D / Be + qe))), z += We - (xe = Math.max(0, Math.min(We + xe / Je, B.scrollWidth - w / Je + ze)));
    }
    k.push({ el: B, top: Oe, left: xe });
  }
  return k;
}, TC = {}, Bhe = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
})(Bhe);
var fu = Bhe.exports, $O = {}, UO = { exports: {} }, AY;
function yC() {
  return AY || (AY = 1, function(e) {
    function t(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? (e.exports = t = function(i) {
        return typeof i;
      }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), t(r);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(UO)), UO.exports;
}
var VO = { exports: {} }, SY;
function U9() {
  return SY || (SY = 1, function(e) {
    function t(r, n, i) {
      return n in r ? Object.defineProperty(r, n, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[n] = i, r;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(VO)), VO.exports;
}
var jO = { exports: {} }, zO = { exports: {} }, bY;
function zrt() {
  return bY || (bY = 1, function(e) {
    function t(r, n) {
      if (r == null) return {};
      var i = {}, o = Object.keys(r), a, u;
      for (u = 0; u < o.length; u++)
        a = o[u], !(n.indexOf(a) >= 0) && (i[a] = r[a]);
      return i;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(zO)), zO.exports;
}
var CY;
function V9() {
  return CY || (CY = 1, function(e) {
    var t = zrt();
    function r(n, i) {
      if (n == null) return {};
      var o = t(n, i), a, u;
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(n);
        for (u = 0; u < s.length; u++)
          a = s[u], !(i.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(n, a) && (o[a] = n[a]);
      }
      return o;
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(jO)), jO.exports;
}
var qO = { exports: {} }, IY;
function qrt() {
  return IY || (IY = 1, function(e) {
    function t(r) {
      throw new TypeError('"' + r + '" is read-only');
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(qO)), qO.exports;
}
var YO = {}, GO = { exports: {} }, WO = { exports: {} }, OY;
function Yrt() {
  return OY || (OY = 1, function(e) {
    function t(r) {
      if (Array.isArray(r)) return r;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(WO)), WO.exports;
}
var KO = { exports: {} }, RY;
function Grt() {
  return RY || (RY = 1, function(e) {
    function t(r, n) {
      var i = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
      if (i != null) {
        var o = [], a = !0, u = !1, s, c;
        try {
          for (i = i.call(r); !(a = (s = i.next()).done) && (o.push(s.value), !(n && o.length === n)); a = !0)
            ;
        } catch (l) {
          u = !0, c = l;
        } finally {
          try {
            !a && i.return != null && i.return();
          } finally {
            if (u) throw c;
          }
        }
        return o;
      }
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(KO)), KO.exports;
}
var XO = { exports: {} }, JO = { exports: {} }, wY;
function khe() {
  return wY || (wY = 1, function(e) {
    function t(r, n) {
      (n == null || n > r.length) && (n = r.length);
      for (var i = 0, o = new Array(n); i < n; i++)
        o[i] = r[i];
      return o;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(JO)), JO.exports;
}
var PY;
function Mhe() {
  return PY || (PY = 1, function(e) {
    var t = khe();
    function r(n, i) {
      if (n) {
        if (typeof n == "string") return t(n, i);
        var o = Object.prototype.toString.call(n).slice(8, -1);
        if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set") return Array.from(n);
        if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return t(n, i);
      }
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(XO)), XO.exports;
}
var ZO = { exports: {} }, DY;
function Wrt() {
  return DY || (DY = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ZO)), ZO.exports;
}
var xY;
function j9() {
  return xY || (xY = 1, function(e) {
    var t = Yrt(), r = Grt(), n = Mhe(), i = Wrt();
    function o(a, u) {
      return t(a) || r(a, u) || n(a, u) || i();
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(GO)), GO.exports;
}
var QO = {}, NY;
function _C() {
  return NY || (NY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = t(G), n = /* @__PURE__ */ r.default.createContext(), i = n;
    e.default = i;
  }(QO)), QO;
}
var eR = {}, tR = { exports: {} }, LY;
function Fhe() {
  return LY || (LY = 1, function(e) {
    var t = function(r) {
      var n = Object.prototype, i = n.hasOwnProperty, o = Object.defineProperty || function(V, F, le) {
        V[F] = le.value;
      }, a, u = typeof Symbol == "function" ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
      function f(V, F, le) {
        return Object.defineProperty(V, F, {
          value: le,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), V[F];
      }
      try {
        f({}, "");
      } catch {
        f = function(F, le, ae) {
          return F[le] = ae;
        };
      }
      function d(V, F, le, ae) {
        var ne = F && F.prototype instanceof y ? F : y, ve = Object.create(ne.prototype), Ie = new w(ae || []);
        return o(ve, "_invoke", { value: H(V, le, Ie) }), ve;
      }
      r.wrap = d;
      function p(V, F, le) {
        try {
          return { type: "normal", arg: V.call(F, le) };
        } catch (ae) {
          return { type: "throw", arg: ae };
        }
      }
      var v = "suspendedStart", h = "suspendedYield", E = "executing", m = "completed", g = {};
      function y() {
      }
      function _() {
      }
      function S() {
      }
      var A = {};
      f(A, s, function() {
        return this;
      });
      var O = Object.getPrototypeOf, P = O && O(O($([])));
      P && P !== n && i.call(P, s) && (A = P);
      var U = S.prototype = y.prototype = Object.create(A);
      _.prototype = S, o(U, "constructor", { value: S, configurable: !0 }), o(
        S,
        "constructor",
        { value: _, configurable: !0 }
      ), _.displayName = f(
        S,
        l,
        "GeneratorFunction"
      );
      function z(V) {
        ["next", "throw", "return"].forEach(function(F) {
          f(V, F, function(le) {
            return this._invoke(F, le);
          });
        });
      }
      r.isGeneratorFunction = function(V) {
        var F = typeof V == "function" && V.constructor;
        return F ? F === _ || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (F.displayName || F.name) === "GeneratorFunction" : !1;
      }, r.mark = function(V) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(V, S) : (V.__proto__ = S, f(V, l, "GeneratorFunction")), V.prototype = Object.create(U), V;
      }, r.awrap = function(V) {
        return { __await: V };
      };
      function k(V, F) {
        function le(ve, Ie, Oe, xe) {
          var ze = p(V[ve], V, Ie);
          if (ze.type === "throw")
            xe(ze.arg);
          else {
            var qe = ze.arg, Je = qe.value;
            return Je && typeof Je == "object" && i.call(Je, "__await") ? F.resolve(Je.__await).then(function(Be) {
              le("next", Be, Oe, xe);
            }, function(Be) {
              le("throw", Be, Oe, xe);
            }) : F.resolve(Je).then(function(Be) {
              qe.value = Be, Oe(qe);
            }, function(Be) {
              return le("throw", Be, Oe, xe);
            });
          }
        }
        var ae;
        function ne(ve, Ie) {
          function Oe() {
            return new F(function(xe, ze) {
              le(ve, Ie, xe, ze);
            });
          }
          return ae = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          ae ? ae.then(
            Oe,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            Oe
          ) : Oe();
        }
        o(this, "_invoke", { value: ne });
      }
      z(k.prototype), f(k.prototype, c, function() {
        return this;
      }), r.AsyncIterator = k, r.async = function(V, F, le, ae, ne) {
        ne === void 0 && (ne = Promise);
        var ve = new k(
          d(V, F, le, ae),
          ne
        );
        return r.isGeneratorFunction(F) ? ve : ve.next().then(function(Ie) {
          return Ie.done ? Ie.value : ve.next();
        });
      };
      function H(V, F, le) {
        var ae = v;
        return function(ve, Ie) {
          if (ae === E)
            throw new Error("Generator is already running");
          if (ae === m) {
            if (ve === "throw")
              throw Ie;
            return X();
          }
          for (le.method = ve, le.arg = Ie; ; ) {
            var Oe = le.delegate;
            if (Oe) {
              var xe = B(Oe, le);
              if (xe) {
                if (xe === g) continue;
                return xe;
              }
            }
            if (le.method === "next")
              le.sent = le._sent = le.arg;
            else if (le.method === "throw") {
              if (ae === v)
                throw ae = m, le.arg;
              le.dispatchException(le.arg);
            } else le.method === "return" && le.abrupt("return", le.arg);
            ae = E;
            var ze = p(V, F, le);
            if (ze.type === "normal") {
              if (ae = le.done ? m : h, ze.arg === g)
                continue;
              return {
                value: ze.arg,
                done: le.done
              };
            } else ze.type === "throw" && (ae = m, le.method = "throw", le.arg = ze.arg);
          }
        };
      }
      function B(V, F) {
        var le = F.method, ae = V.iterator[le];
        if (ae === a)
          return F.delegate = null, le === "throw" && V.iterator.return && (F.method = "return", F.arg = a, B(V, F), F.method === "throw") || le !== "return" && (F.method = "throw", F.arg = new TypeError(
            "The iterator does not provide a '" + le + "' method"
          )), g;
        var ne = p(ae, V.iterator, F.arg);
        if (ne.type === "throw")
          return F.method = "throw", F.arg = ne.arg, F.delegate = null, g;
        var ve = ne.arg;
        if (!ve)
          return F.method = "throw", F.arg = new TypeError("iterator result is not an object"), F.delegate = null, g;
        if (ve.done)
          F[V.resultName] = ve.value, F.next = V.nextLoc, F.method !== "return" && (F.method = "next", F.arg = a);
        else
          return ve;
        return F.delegate = null, g;
      }
      z(U), f(U, l, "Generator"), f(U, s, function() {
        return this;
      }), f(U, "toString", function() {
        return "[object Generator]";
      });
      function x(V) {
        var F = { tryLoc: V[0] };
        1 in V && (F.catchLoc = V[1]), 2 in V && (F.finallyLoc = V[2], F.afterLoc = V[3]), this.tryEntries.push(F);
      }
      function D(V) {
        var F = V.completion || {};
        F.type = "normal", delete F.arg, V.completion = F;
      }
      function w(V) {
        this.tryEntries = [{ tryLoc: "root" }], V.forEach(x, this), this.reset(!0);
      }
      r.keys = function(V) {
        var F = Object(V), le = [];
        for (var ae in F)
          le.push(ae);
        return le.reverse(), function ne() {
          for (; le.length; ) {
            var ve = le.pop();
            if (ve in F)
              return ne.value = ve, ne.done = !1, ne;
          }
          return ne.done = !0, ne;
        };
      };
      function $(V) {
        if (V) {
          var F = V[s];
          if (F)
            return F.call(V);
          if (typeof V.next == "function")
            return V;
          if (!isNaN(V.length)) {
            var le = -1, ae = function ne() {
              for (; ++le < V.length; )
                if (i.call(V, le))
                  return ne.value = V[le], ne.done = !1, ne;
              return ne.value = a, ne.done = !0, ne;
            };
            return ae.next = ae;
          }
        }
        return { next: X };
      }
      r.values = $;
      function X() {
        return { value: a, done: !0 };
      }
      return w.prototype = {
        constructor: w,
        reset: function(V) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(D), !V)
            for (var F in this)
              F.charAt(0) === "t" && i.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = a);
        },
        stop: function() {
          this.done = !0;
          var V = this.tryEntries[0], F = V.completion;
          if (F.type === "throw")
            throw F.arg;
          return this.rval;
        },
        dispatchException: function(V) {
          if (this.done)
            throw V;
          var F = this;
          function le(xe, ze) {
            return ve.type = "throw", ve.arg = V, F.next = xe, ze && (F.method = "next", F.arg = a), !!ze;
          }
          for (var ae = this.tryEntries.length - 1; ae >= 0; --ae) {
            var ne = this.tryEntries[ae], ve = ne.completion;
            if (ne.tryLoc === "root")
              return le("end");
            if (ne.tryLoc <= this.prev) {
              var Ie = i.call(ne, "catchLoc"), Oe = i.call(ne, "finallyLoc");
              if (Ie && Oe) {
                if (this.prev < ne.catchLoc)
                  return le(ne.catchLoc, !0);
                if (this.prev < ne.finallyLoc)
                  return le(ne.finallyLoc);
              } else if (Ie) {
                if (this.prev < ne.catchLoc)
                  return le(ne.catchLoc, !0);
              } else if (Oe) {
                if (this.prev < ne.finallyLoc)
                  return le(ne.finallyLoc);
              } else
                throw new Error("try statement without catch or finally");
            }
          }
        },
        abrupt: function(V, F) {
          for (var le = this.tryEntries.length - 1; le >= 0; --le) {
            var ae = this.tryEntries[le];
            if (ae.tryLoc <= this.prev && i.call(ae, "finallyLoc") && this.prev < ae.finallyLoc) {
              var ne = ae;
              break;
            }
          }
          ne && (V === "break" || V === "continue") && ne.tryLoc <= F && F <= ne.finallyLoc && (ne = null);
          var ve = ne ? ne.completion : {};
          return ve.type = V, ve.arg = F, ne ? (this.method = "next", this.next = ne.finallyLoc, g) : this.complete(ve);
        },
        complete: function(V, F) {
          if (V.type === "throw")
            throw V.arg;
          return V.type === "break" || V.type === "continue" ? this.next = V.arg : V.type === "return" ? (this.rval = this.arg = V.arg, this.method = "return", this.next = "end") : V.type === "normal" && F && (this.next = F), g;
        },
        finish: function(V) {
          for (var F = this.tryEntries.length - 1; F >= 0; --F) {
            var le = this.tryEntries[F];
            if (le.finallyLoc === V)
              return this.complete(le.completion, le.afterLoc), D(le), g;
          }
        },
        catch: function(V) {
          for (var F = this.tryEntries.length - 1; F >= 0; --F) {
            var le = this.tryEntries[F];
            if (le.tryLoc === V) {
              var ae = le.completion;
              if (ae.type === "throw") {
                var ne = ae.arg;
                D(le);
              }
              return ne;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(V, F, le) {
          return this.delegate = {
            iterator: $(V),
            resultName: F,
            nextLoc: le
          }, this.method === "next" && (this.arg = a), g;
        }
      }, r;
    }(
      // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      e.exports
    );
    try {
      regeneratorRuntime = t;
    } catch {
      typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  }(tR)), tR.exports;
}
var rR, BY;
function Hhe() {
  return BY || (BY = 1, rR = Fhe()), rR;
}
var nR = { exports: {} }, iR = { exports: {} }, kY;
function Krt() {
  return kY || (kY = 1, function(e) {
    var t = khe();
    function r(n) {
      if (Array.isArray(n)) return t(n);
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(iR)), iR.exports;
}
var oR = { exports: {} }, MY;
function Xrt() {
  return MY || (MY = 1, function(e) {
    function t(r) {
      if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(oR)), oR.exports;
}
var aR = { exports: {} }, FY;
function Jrt() {
  return FY || (FY = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(aR)), aR.exports;
}
var HY;
function Zrt() {
  return HY || (HY = 1, function(e) {
    var t = Krt(), r = Xrt(), n = Mhe(), i = Jrt();
    function o(a) {
      return t(a) || r(a) || n(a) || i();
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(nR)), nR.exports;
}
var uR = { exports: {} }, $Y;
function $he() {
  return $Y || ($Y = 1, function(e) {
    function t(n, i, o, a, u, s, c) {
      try {
        var l = n[s](c), f = l.value;
      } catch (d) {
        o(d);
        return;
      }
      l.done ? i(f) : Promise.resolve(f).then(a, u);
    }
    function r(n) {
      return function() {
        var i = this, o = arguments;
        return new Promise(function(a, u) {
          var s = n.apply(i, o);
          function c(f) {
            t(s, a, u, c, l, "next", f);
          }
          function l(f) {
            t(s, a, u, c, l, "throw", f);
          }
          c(void 0);
        });
      };
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(uR)), uR.exports;
}
var sR = {}, cR = { exports: {} }, UY;
function Qrt() {
  return UY || (UY = 1, function(e) {
    function t(r, n) {
      if (!(r instanceof n))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(cR)), cR.exports;
}
var lR = { exports: {} }, VY;
function ent() {
  return VY || (VY = 1, function(e) {
    function t(n, i) {
      for (var o = 0; o < i.length; o++) {
        var a = i[o];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
      }
    }
    function r(n, i, o) {
      return i && t(n.prototype, i), o && t(n, o), n;
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(lR)), lR.exports;
}
var fR = {}, jY;
function z9() {
  return jY || (jY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var r = t(j9());
    function n(i, o) {
      if (i === "error") {
        if (typeof ErrorEvent == "function")
          return new ErrorEvent(i, o);
      } else if (typeof CustomEvent == "function")
        return new CustomEvent(i, o);
      var a = document.createEvent("Event");
      return a.initEvent(i, !0, !0), Object.entries(o || {}).forEach(function(u) {
        var s = (0, r.default)(u, 2), c = s[0], l = s[1];
        a[c] = l;
      }), a;
    }
  }(fR)), fR;
}
var dR = {}, zY;
function tnt() {
  return zY || (zY = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t() {
      var r, n, i = new Promise(function(o, a) {
        r = a, n = o;
      });
      if (!r || !n)
        throw new Error("Promise is not a ES-compliant and do not run exector immediately");
      return {
        promise: i,
        reject: r,
        resolve: n
      };
    }
  }(dR)), dR;
}
var pR = {}, qY;
function Uhe() {
  return qY || (qY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var r = t(z9());
    function n(i) {
      return (0, r.default)("error", {
        error: i
      });
    }
  }(pR)), pR;
}
var YY;
function rnt() {
  return YY || (YY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = t(Hhe()), n = t(Qrt()), i = t(ent()), o = t($he()), a = t(z9()), u = t(tnt()), s = t(Uhe());
    function c(d, p, v) {
      return l.apply(this, arguments);
    }
    function l() {
      return l = (0, o.default)(/* @__PURE__ */ r.default.mark(function d(p, v, h) {
        var E, m, g, y, _, S, A, O;
        return r.default.wrap(function(U) {
          for (; ; )
            switch (U.prev = U.next) {
              case 0:
                return E = p.speechSynthesis, m = (0, u.default)(), g = (0, u.default)(), y = (0, u.default)(), v.addEventListener("end", y.resolve), v.addEventListener("error", g.resolve), v.addEventListener("start", m.resolve), E.speak(v), U.next = 10, Promise.race([g.promise, m.promise]);
              case 10:
                if (_ = U.sent, _.type !== "error") {
                  U.next = 13;
                  break;
                }
                throw _.error;
              case 13:
                return A = Promise.race([g.promise, y.promise]), h && h(/* @__PURE__ */ (0, o.default)(/* @__PURE__ */ r.default.mark(function z() {
                  return r.default.wrap(function(H) {
                    for (; ; )
                      switch (H.prev = H.next) {
                        case 0:
                          if (S) {
                            H.next = 4;
                            break;
                          }
                          return E.cancel(), H.next = 4, A;
                        case 4:
                        case "end":
                          return H.stop();
                      }
                  }, z);
                }))), U.next = 17, A;
              case 17:
                if (O = U.sent, S = !0, O.type !== "error") {
                  U.next = 21;
                  break;
                }
                throw O.error;
              case 21:
              case "end":
                return U.stop();
            }
        }, d);
      })), l.apply(this, arguments);
    }
    var f = /* @__PURE__ */ function() {
      function d(p, v, h) {
        var E = h.onEnd, m = h.onError, g = h.onStart;
        (0, n.default)(this, d), this._cancelled = !1, this._deferred = (0, u.default)(), this._onEnd = E, this._onError = m, this._onStart = g, this._ponyfill = p, this._speaking = !1, this._utterance = v, this.promise = this._deferred.promise;
      }
      return (0, i.default)(d, [{
        key: "cancel",
        value: function() {
          var p = (0, o.default)(/* @__PURE__ */ r.default.mark(function h() {
            return r.default.wrap(function(m) {
              for (; ; )
                switch (m.prev = m.next) {
                  case 0:
                    if (this._cancelled = !0, m.t0 = this._cancel, !m.t0) {
                      m.next = 5;
                      break;
                    }
                    return m.next = 5, this._cancel();
                  case 5:
                  case "end":
                    return m.stop();
                }
            }, h, this);
          }));
          function v() {
            return p.apply(this, arguments);
          }
          return v;
        }()
      }, {
        key: "speak",
        value: function() {
          var v = this;
          return this._speaking && console.warn("ASSERTION: QueuedUtterance is already speaking or has spoken."), this._speaking = !0, (0, o.default)(/* @__PURE__ */ r.default.mark(function h() {
            return r.default.wrap(function(m) {
              for (; ; )
                switch (m.prev = m.next) {
                  case 0:
                    if (!v._cancelled) {
                      m.next = 2;
                      break;
                    }
                    throw new Error("cancelled");
                  case 2:
                    return m.next = 4, c(v._ponyfill, v._utterance, function(g) {
                      if (v._cancelled)
                        throw g(), new Error("cancelled");
                      v._cancel = g, v._onStart && v._onStart((0, a.default)("start"));
                    });
                  case 4:
                    if (!v._cancelled) {
                      m.next = 6;
                      break;
                    }
                    throw new Error("cancelled");
                  case 6:
                  case "end":
                    return m.stop();
                }
            }, h);
          }))().then(function() {
            v._onEnd && v._onEnd((0, a.default)("end")), v._deferred.resolve();
          }, function(h) {
            v._onError && v._onError((0, s.default)(h)), v._deferred.reject(h);
          }), this.promise;
        }
      }]), d;
    }();
    e.default = f;
  }(sR)), sR;
}
var GY;
function nnt() {
  return GY || (GY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = a;
    var r = t(Hhe()), n = t(Zrt()), i = t($he()), o = t(rnt());
    function a() {
      var u = [], s, c = /* @__PURE__ */ function() {
        var l = (0, i.default)(/* @__PURE__ */ r.default.mark(function f() {
          return r.default.wrap(function(p) {
            for (; ; )
              switch (p.prev = p.next) {
                case 0:
                  if (!s) {
                    p.next = 2;
                    break;
                  }
                  return p.abrupt("return");
                case 2:
                  return s = !0, p.prev = 3, p.delegateYield(/* @__PURE__ */ r.default.mark(function v() {
                    var h;
                    return r.default.wrap(function(m) {
                      for (; ; )
                        switch (m.prev = m.next) {
                          case 0:
                            if (!(h = u[0])) {
                              m.next = 12;
                              break;
                            }
                            return m.prev = 1, m.next = 4, h.speak();
                          case 4:
                            m.next = 9;
                            break;
                          case 6:
                            m.prev = 6, m.t0 = m.catch(1), m.t0.message !== "cancelled" && console.error(m.t0);
                          case 9:
                            u = u.filter(function(g) {
                              return g !== h;
                            }), m.next = 0;
                            break;
                          case 12:
                          case "end":
                            return m.stop();
                        }
                    }, v, null, [[1, 6]]);
                  })(), "t0", 5);
                case 5:
                  return p.prev = 5, s = !1, p.finish(5);
                case 8:
                case "end":
                  return p.stop();
              }
          }, f, null, [[3, , 5, 8]]);
        }));
        return function() {
          return l.apply(this, arguments);
        };
      }();
      return function(l, f) {
        var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p = d.onEnd, v = d.onError, h = d.onStart;
        if (!(f instanceof l.SpeechSynthesisUtterance))
          throw new Error("utterance must be instance of the ponyfill");
        var E = new o.default(l, f, {
          onEnd: p,
          onError: v,
          onStart: h
        });
        return u = [].concat((0, n.default)(u), [E]), c(), {
          // The cancel() function returns a Promise
          cancel: function() {
            return E.cancel();
          },
          promise: E.promise
        };
      };
    }
  }(eR)), eR;
}
var hR = {}, vR = {}, WY;
function Vhe() {
  return WY || (WY = 1, function(e) {
    var t = fu, r = yC();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(j9()), i = t(GT), o = c(G), a = t(AC()), u = t(Y9());
    function s(d) {
      if (typeof WeakMap != "function") return null;
      var p = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (s = function(E) {
        return E ? v : p;
      })(d);
    }
    function c(d, p) {
      if (d && d.__esModule)
        return d;
      if (d === null || r(d) !== "object" && typeof d != "function")
        return { default: d };
      var v = s(p);
      if (v && v.has(d))
        return v.get(d);
      var h = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var m in d)
        if (m !== "default" && Object.prototype.hasOwnProperty.call(d, m)) {
          var g = E ? Object.getOwnPropertyDescriptor(d, m) : null;
          g && (g.get || g.set) ? Object.defineProperty(h, m, g) : h[m] = d[m];
        }
      return h.default = d, v && v.set(d, h), h;
    }
    var l = function d(p) {
      var v = (0, a.default)(p, d), h = v.children, E = v.disabled, m = v.lang, g = v.onBoundary, y = v.onEnd, _ = v.onError, S = v.onStart, A = v.pitch, O = v.ponyfill, P = v.rate, U = v.text, z = v.voice, k = v.volume, H = (0, o.useState)(!1), B = (0, n.default)(H, 2), x = B[0], D = B[1], w = (0, o.useCallback)(function() {
        return D(!0);
      }), $ = {
        lang: m,
        onBoundary: g,
        onEnd: function(V) {
          D(!1), y && y(V);
        },
        onError: _,
        onStart: S,
        pitch: A,
        ponyfill: O,
        rate: P,
        text: U,
        voice: z,
        volume: k
      };
      return /* @__PURE__ */ o.default.createElement(o.default.Fragment, null, /* @__PURE__ */ o.default.createElement("button", {
        disabled: typeof E == "boolean" ? E : x,
        onClick: w
      }, h), x && /* @__PURE__ */ o.default.createElement(u.default, $));
    };
    l.defaultProps = {
      children: void 0,
      disabled: void 0,
      lang: void 0,
      onBoundary: void 0,
      onEnd: void 0,
      onError: void 0,
      onStart: void 0,
      pitch: void 0,
      ponyfill: void 0,
      rate: void 0,
      text: void 0,
      voice: void 0,
      volume: void 0
    }, l.propTypes = {
      children: i.default.any,
      disabled: i.default.bool,
      lang: i.default.string,
      onBoundary: i.default.func,
      onEnd: i.default.func,
      onError: i.default.func,
      onStart: i.default.func,
      pitch: i.default.number,
      ponyfill: i.default.shape({
        speechSynthesis: i.default.any.isRequired,
        SpeechSynthesisUtterance: i.default.any.isRequired
      }),
      rate: i.default.number,
      text: i.default.string,
      voice: i.default.oneOfType([i.default.any, i.default.func]),
      volume: i.default.number
    };
    var f = l;
    e.default = f;
  }(vR)), vR;
}
var KY;
function AC() {
  return KY || (KY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = l;
    var r = t(U9()), n = t(V9()), i = t(Y9()), o = t(Vhe()), a = ["ponyfill", "speak", "speechSynthesis", "speechSynthesisUtterance", "text"];
    function u(f, d) {
      var p = Object.keys(f);
      if (Object.getOwnPropertySymbols) {
        var v = Object.getOwnPropertySymbols(f);
        d && (v = v.filter(function(h) {
          return Object.getOwnPropertyDescriptor(f, h).enumerable;
        })), p.push.apply(p, v);
      }
      return p;
    }
    function s(f) {
      for (var d = 1; d < arguments.length; d++) {
        var p = arguments[d] != null ? arguments[d] : {};
        d % 2 ? u(Object(p), !0).forEach(function(v) {
          (0, r.default)(f, v, p[v]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(p)) : u(Object(p)).forEach(function(v) {
          Object.defineProperty(f, v, Object.getOwnPropertyDescriptor(p, v));
        });
      }
      return f;
    }
    var c = {
      ponyfill: !0,
      saySpeak: !0
    };
    function l(f, d) {
      var p = f.ponyfill, v = f.speak, h = f.speechSynthesis, E = f.speechSynthesisUtterance, m = f.text, g = (0, n.default)(f, a);
      return !p && (h || E) && (c.ponyfill && (console.warn('react-say: "speechSynthesis" and "speechSynthesisUtterance" props has been renamed to "ponyfill". Please update your code. The deprecated props will be removed in version >= 3.0.0.'), c.ponyfill = !1), p = {
        speechSynthesis: h,
        SpeechSynthesisUtterance: E
      }), (d === i.default || d === o.default) && v && !m && (c.saySpeak && (console.warn('react-say: "speak" prop has been renamed to "text". Please update your code. The deprecated props will be removed in version >= 3.0.0.'), c.saySpeak = !1), m = v), s({
        ponyfill: p,
        text: m
      }, g);
    }
  }(hR)), hR;
}
var ER = {}, mR = {}, XY;
function int() {
  return XY || (XY = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    var t = G;
    function r(n, i) {
      var o = (0, t.useRef)({
        first: !0,
        id: Math.random().toString(36).substr(2, 5),
        unsubscribe: n()
      });
      (0, t.useEffect)(function() {
        var a = o.current;
        return a.first ? a.first = !1 : a.unsubscribe = n(), function() {
          a.unsubscribe && a.unsubscribe(), a.unsubscribe = null;
        };
      }, i);
    }
  }(mR)), mR;
}
var JY;
function ont() {
  return JY || (JY = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var r = t(int());
    function n(i, o, a, u) {
      (0, r.default)(function() {
        var s = function(l) {
          return a && a(l);
        };
        return i.addEventListener(o, s, u), function() {
          a = null, i.removeEventListener(o, s, u);
        };
      }, [a, o, u, i]);
    }
  }(ER)), ER;
}
var ZY;
function q9() {
  return ZY || (ZY = 1, function(e) {
    var t = fu, r = yC();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(j9()), i = t(GT), o = f(G), a = t(_C()), u = t(nnt()), s = t(AC()), c = t(ont());
    function l(v) {
      if (typeof WeakMap != "function") return null;
      var h = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
      return (l = function(g) {
        return g ? E : h;
      })(v);
    }
    function f(v, h) {
      if (v && v.__esModule)
        return v;
      if (v === null || r(v) !== "object" && typeof v != "function")
        return { default: v };
      var E = l(h);
      if (E && E.has(v))
        return E.get(v);
      var m = {}, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in v)
        if (y !== "default" && Object.prototype.hasOwnProperty.call(v, y)) {
          var _ = g ? Object.getOwnPropertyDescriptor(v, y) : null;
          _ && (_.get || _.set) ? Object.defineProperty(m, y, _) : m[y] = v[y];
        }
      return m.default = v, E && E.set(v, m), m;
    }
    var d = function v(h) {
      var E = (0, s.default)(h, v), m = E.children, g = E.ponyfill, y = (0, o.useContext)(a.default) || {}, _ = y.ponyfill, S = y.synthesize, A = g || _ || {
        speechSynthesis: window.speechSynthesis || window.webkitSpeechSynthesis,
        SpeechSynthesisUtterance: window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance
      }, O = (0, o.useMemo)(function() {
        return S || (0, u.default)();
      }, [S]), P = A.speechSynthesis, U = (0, o.useState)(P.getVoices()), z = (0, n.default)(U, 2), k = z[0], H = z[1];
      (0, c.default)(P, "voiceschanged", function() {
        return H(P.getVoices());
      });
      var B = (0, o.useMemo)(function() {
        return {
          ponyfill: A,
          synthesize: O,
          voices: k
        };
      }, [A, O, k]);
      return /* @__PURE__ */ o.default.createElement(a.default.Provider, {
        value: B
      }, typeof m == "function" ? /* @__PURE__ */ o.default.createElement(a.default.Consumer, null, function(x) {
        return m(x);
      }) : m);
    };
    d.defaultProps = {
      children: void 0,
      ponyfill: void 0
    }, d.propTypes = {
      children: i.default.any,
      ponyfill: i.default.shape({
        speechSynthesis: i.default.any,
        SpeechSynthesisUtterance: i.default.any
      })
    };
    var p = d;
    e.default = p;
  }(YO)), YO;
}
var gR = {}, QY;
function jhe() {
  return QY || (QY = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t(r, n) {
      var i = r.speechSynthesis, o = r.SpeechSynthesisUtterance, a = n.lang, u = n.onBoundary, s = n.pitch, c = n.rate, l = n.text, f = n.voice, d = n.volume, p = new o(l), v;
      if (typeof f == "function")
        v = f.call(i, i.getVoices());
      else {
        var h = f || {}, E = h.voiceURI;
        v = E && [].find.call([].slice.call(i.getVoices()), function(m) {
          return m.voiceURI === E;
        });
      }
      return p.lang = a || "", (s || s === 0) && (p.pitch = s), (c || c === 0) && (p.rate = c), v && (p.voice = v), (d || d === 0) && (p.volume = d), u && p.addEventListener("boundary", u), p;
    }
  }(gR)), gR;
}
var TR = {}, yR = {}, eG;
function ant() {
  return eG || (eG = 1, function(e) {
    var t = fu;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var r = G, n = t(_C()), i = t(jhe());
    function o() {
      var a = (0, r.useContext)(n.default), u = a.ponyfill, s = a.synthesize;
      return function(c, l) {
        return typeof c == "string" && (c = (0, i.default)(u, {
          text: c
        })), s(u, c, {
          onStart: l && function() {
            return l();
          }
        });
      };
    }
  }(yR)), yR;
}
var tG;
function zhe() {
  return tG || (tG = 1, function(e) {
    var t = fu, r = yC();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(U9()), i = t(V9()), o = t(GT), a = v(G), u = t(q9()), s = t(z9()), c = t(Uhe()), l = t(AC()), f = t(ant()), d = ["ponyfill"];
    function p(_) {
      if (typeof WeakMap != "function") return null;
      var S = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap();
      return (p = function(P) {
        return P ? A : S;
      })(_);
    }
    function v(_, S) {
      if (_ && _.__esModule)
        return _;
      if (_ === null || r(_) !== "object" && typeof _ != "function")
        return { default: _ };
      var A = p(S);
      if (A && A.has(_))
        return A.get(_);
      var O = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var U in _)
        if (U !== "default" && Object.prototype.hasOwnProperty.call(_, U)) {
          var z = P ? Object.getOwnPropertyDescriptor(_, U) : null;
          z && (z.get || z.set) ? Object.defineProperty(O, U, z) : O[U] = _[U];
        }
      return O.default = _, A && A.set(_, O), O;
    }
    function h(_, S) {
      var A = Object.keys(_);
      if (Object.getOwnPropertySymbols) {
        var O = Object.getOwnPropertySymbols(_);
        S && (O = O.filter(function(P) {
          return Object.getOwnPropertyDescriptor(_, P).enumerable;
        })), A.push.apply(A, O);
      }
      return A;
    }
    function E(_) {
      for (var S = 1; S < arguments.length; S++) {
        var A = arguments[S] != null ? arguments[S] : {};
        S % 2 ? h(Object(A), !0).forEach(function(O) {
          (0, n.default)(_, O, A[O]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_, Object.getOwnPropertyDescriptors(A)) : h(Object(A)).forEach(function(O) {
          Object.defineProperty(_, O, Object.getOwnPropertyDescriptor(A, O));
        });
      }
      return _;
    }
    var m = function(S) {
      var A = (0, l.default)(S), O = A.onEnd, P = A.onError, U = A.onStart, z = A.utterance, k = (0, a.useRef)(!1), H = (0, f.default)();
      return (0, a.useEffect)(function() {
        if (k.current)
          return console.warn("react-say: Should not change utterance after synthesis started.");
        var B, x = H(z, function() {
          k.current = !0, !B && U && U((0, s.default)("start"));
        }), D = x.cancel, w = x.promise;
        return w.then(function() {
          return !B && O && O((0, s.default)("end"));
        }, function($) {
          return !B && P && P((0, c.default)($));
        }), function() {
          B = !0, D();
        };
      }, []), !1;
    };
    m.defaultProps = {
      onEnd: void 0,
      onError: void 0,
      onStart: void 0
    }, m.propTypes = {
      onEnd: o.default.func,
      onError: o.default.func,
      onStart: o.default.func
    };
    var g = function(S) {
      var A = S.ponyfill, O = (0, i.default)(S, d);
      return /* @__PURE__ */ a.default.createElement(u.default, {
        ponyfill: A
      }, /* @__PURE__ */ a.default.createElement(m, O));
    };
    g.defaultProps = E(E({}, m.defaultProps), {}, {
      ponyfill: void 0
    }), g.propTypes = E(E({}, m.propTypes), {}, {
      ponyfill: o.default.shape({
        speechSynthesis: o.default.any.isRequired,
        SpeechSynthesisUtterance: o.default.any.isRequired
      })
    });
    var y = g;
    e.default = y;
  }(TR)), TR;
}
var rG;
function Y9() {
  return rG || (rG = 1, function(e) {
    var t = fu, r = yC();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(U9()), i = t(V9()), o = t(qrt()), a = t(GT), u = h(G), s = t(q9()), c = t(_C()), l = t(jhe()), f = t(AC()), d = t(zhe()), p = ["ponyfill"];
    function v(S) {
      if (typeof WeakMap != "function") return null;
      var A = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap();
      return (v = function(U) {
        return U ? O : A;
      })(S);
    }
    function h(S, A) {
      if (S && S.__esModule)
        return S;
      if (S === null || r(S) !== "object" && typeof S != "function")
        return { default: S };
      var O = v(A);
      if (O && O.has(S))
        return O.get(S);
      var P = {}, U = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var z in S)
        if (z !== "default" && Object.prototype.hasOwnProperty.call(S, z)) {
          var k = U ? Object.getOwnPropertyDescriptor(S, z) : null;
          k && (k.get || k.set) ? Object.defineProperty(P, z, k) : P[z] = S[z];
        }
      return P.default = S, O && O.set(S, P), P;
    }
    function E(S, A) {
      var O = Object.keys(S);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(S);
        A && (P = P.filter(function(U) {
          return Object.getOwnPropertyDescriptor(S, U).enumerable;
        })), O.push.apply(O, P);
      }
      return O;
    }
    function m(S) {
      for (var A = 1; A < arguments.length; A++) {
        var O = arguments[A] != null ? arguments[A] : {};
        A % 2 ? E(Object(O), !0).forEach(function(P) {
          (0, n.default)(S, P, O[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(S, Object.getOwnPropertyDescriptors(O)) : E(Object(O)).forEach(function(P) {
          Object.defineProperty(S, P, Object.getOwnPropertyDescriptor(O, P));
        });
      }
      return S;
    }
    var g = function S(A) {
      var O = (0, f.default)(A, S), P = O.lang, U = O.onBoundary, z = O.onEnd, k = O.onError, H = O.onStart, B = O.pitch, x = O.rate, D = O.speak, w = O.text, $ = O.voice, X = O.volume, V = (0, u.useContext)(c.default), F = V.ponyfill;
      D && !w && (console.warn('react-say: "speak" prop is being deprecated and renamed to "text".'), (0, o.default)("text"));
      var le = (0, u.useMemo)(function() {
        return (0, l.default)(F, {
          lang: P,
          onBoundary: U,
          pitch: B,
          rate: x,
          text: w,
          voice: $,
          volume: X
        });
      }, [P, U, B, F, x, w, $, X]);
      return /* @__PURE__ */ u.default.createElement(d.default, {
        onEnd: z,
        onError: k,
        onStart: H,
        ponyfill: F,
        utterance: le
      });
    };
    g.defaultProps = {
      children: void 0,
      lang: void 0,
      onBoundary: void 0,
      onEnd: void 0,
      onError: void 0,
      onStart: void 0,
      pitch: void 0,
      rate: void 0,
      speak: void 0,
      voice: void 0,
      volume: void 0
    }, g.propTypes = {
      children: a.default.any,
      lang: a.default.string,
      onBoundary: a.default.func,
      onEnd: a.default.func,
      onError: a.default.func,
      onStart: a.default.func,
      pitch: a.default.number,
      rate: a.default.number,
      speak: a.default.string,
      text: a.default.string.isRequired,
      voice: a.default.oneOfType([a.default.any, a.default.func]),
      volume: a.default.number
    };
    var y = function(A) {
      var O = A.ponyfill, P = (0, i.default)(A, p);
      return /* @__PURE__ */ u.default.createElement(s.default, {
        ponyfill: O
      }, /* @__PURE__ */ u.default.createElement(g, P));
    };
    y.defaultProps = m(m({}, d.default.defaultProps), {}, {
      ponyfill: void 0
    }), y.propTypes = m(m({}, d.default.propTypes), {}, {
      ponyfill: a.default.shape({
        speechSynthesis: a.default.any.isRequired,
        SpeechSynthesisUtterance: a.default.any.isRequired
      })
    });
    var _ = y;
    e.default = _;
  }($O)), $O;
}
(function(e) {
  var t = fu;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Composer", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "Context", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(e, "SayButton", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(e, "SayUtterance", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), e.default = void 0;
  var r = t(Y9()), n = t(q9()), i = t(_C()), o = t(Vhe()), a = t(zhe()), u = r.default;
  e.default = u;
})(TC);
const _R = /* @__PURE__ */ Mt(TC);
var Cn = {};
const unt = "Á", snt = "á", cnt = "Ă", lnt = "ă", fnt = "∾", dnt = "∿", pnt = "∾̳", hnt = "Â", vnt = "â", Ent = "´", mnt = "А", gnt = "а", Tnt = "Æ", ynt = "æ", _nt = "⁡", Ant = "𝔄", Snt = "𝔞", bnt = "À", Cnt = "à", Int = "ℵ", Ont = "ℵ", Rnt = "Α", wnt = "α", Pnt = "Ā", Dnt = "ā", xnt = "⨿", Nnt = "&", Lnt = "&", Bnt = "⩕", knt = "⩓", Mnt = "∧", Fnt = "⩜", Hnt = "⩘", $nt = "⩚", Unt = "∠", Vnt = "⦤", jnt = "∠", znt = "⦨", qnt = "⦩", Ynt = "⦪", Gnt = "⦫", Wnt = "⦬", Knt = "⦭", Xnt = "⦮", Jnt = "⦯", Znt = "∡", Qnt = "∟", eit = "⊾", tit = "⦝", rit = "∢", nit = "Å", iit = "⍼", oit = "Ą", ait = "ą", uit = "𝔸", sit = "𝕒", cit = "⩯", lit = "≈", fit = "⩰", dit = "≊", pit = "≋", hit = "'", vit = "⁡", Eit = "≈", mit = "≊", git = "Å", Tit = "å", yit = "𝒜", _it = "𝒶", Ait = "≔", Sit = "*", bit = "≈", Cit = "≍", Iit = "Ã", Oit = "ã", Rit = "Ä", wit = "ä", Pit = "∳", Dit = "⨑", xit = "≌", Nit = "϶", Lit = "‵", Bit = "∽", kit = "⋍", Mit = "∖", Fit = "⫧", Hit = "⊽", $it = "⌅", Uit = "⌆", Vit = "⌅", jit = "⎵", zit = "⎶", qit = "≌", Yit = "Б", Git = "б", Wit = "„", Kit = "∵", Xit = "∵", Jit = "∵", Zit = "⦰", Qit = "϶", eot = "ℬ", tot = "ℬ", rot = "Β", not = "β", iot = "ℶ", oot = "≬", aot = "𝔅", uot = "𝔟", sot = "⋂", cot = "◯", lot = "⋃", fot = "⨀", dot = "⨁", pot = "⨂", hot = "⨆", vot = "★", Eot = "▽", mot = "△", got = "⨄", Tot = "⋁", yot = "⋀", _ot = "⤍", Aot = "⧫", Sot = "▪", bot = "▴", Cot = "▾", Iot = "◂", Oot = "▸", Rot = "␣", wot = "▒", Pot = "░", Dot = "▓", xot = "█", Not = "=⃥", Lot = "≡⃥", Bot = "⫭", kot = "⌐", Mot = "𝔹", Fot = "𝕓", Hot = "⊥", $ot = "⊥", Uot = "⋈", Vot = "⧉", jot = "┐", zot = "╕", qot = "╖", Yot = "╗", Got = "┌", Wot = "╒", Kot = "╓", Xot = "╔", Jot = "─", Zot = "═", Qot = "┬", eat = "╤", tat = "╥", rat = "╦", nat = "┴", iat = "╧", oat = "╨", aat = "╩", uat = "⊟", sat = "⊞", cat = "⊠", lat = "┘", fat = "╛", dat = "╜", pat = "╝", hat = "└", vat = "╘", Eat = "╙", mat = "╚", gat = "│", Tat = "║", yat = "┼", _at = "╪", Aat = "╫", Sat = "╬", bat = "┤", Cat = "╡", Iat = "╢", Oat = "╣", Rat = "├", wat = "╞", Pat = "╟", Dat = "╠", xat = "‵", Nat = "˘", Lat = "˘", Bat = "¦", kat = "𝒷", Mat = "ℬ", Fat = "⁏", Hat = "∽", $at = "⋍", Uat = "⧅", Vat = "\\", jat = "⟈", zat = "•", qat = "•", Yat = "≎", Gat = "⪮", Wat = "≏", Kat = "≎", Xat = "≏", Jat = "Ć", Zat = "ć", Qat = "⩄", eut = "⩉", tut = "⩋", rut = "∩", nut = "⋒", iut = "⩇", out = "⩀", aut = "ⅅ", uut = "∩︀", sut = "⁁", cut = "ˇ", lut = "ℭ", fut = "⩍", dut = "Č", put = "č", hut = "Ç", vut = "ç", Eut = "Ĉ", mut = "ĉ", gut = "∰", Tut = "⩌", yut = "⩐", _ut = "Ċ", Aut = "ċ", Sut = "¸", but = "¸", Cut = "⦲", Iut = "¢", Out = "·", Rut = "·", wut = "𝔠", Put = "ℭ", Dut = "Ч", xut = "ч", Nut = "✓", Lut = "✓", But = "Χ", kut = "χ", Mut = "ˆ", Fut = "≗", Hut = "↺", $ut = "↻", Uut = "⊛", Vut = "⊚", jut = "⊝", zut = "⊙", qut = "®", Yut = "Ⓢ", Gut = "⊖", Wut = "⊕", Kut = "⊗", Xut = "○", Jut = "⧃", Zut = "≗", Qut = "⨐", est = "⫯", tst = "⧂", rst = "∲", nst = "”", ist = "’", ost = "♣", ast = "♣", ust = ":", sst = "∷", cst = "⩴", lst = "≔", fst = "≔", dst = ",", pst = "@", hst = "∁", vst = "∘", Est = "∁", mst = "ℂ", gst = "≅", Tst = "⩭", yst = "≡", _st = "∮", Ast = "∯", Sst = "∮", bst = "𝕔", Cst = "ℂ", Ist = "∐", Ost = "∐", Rst = "©", wst = "©", Pst = "℗", Dst = "∳", xst = "↵", Nst = "✗", Lst = "⨯", Bst = "𝒞", kst = "𝒸", Mst = "⫏", Fst = "⫑", Hst = "⫐", $st = "⫒", Ust = "⋯", Vst = "⤸", jst = "⤵", zst = "⋞", qst = "⋟", Yst = "↶", Gst = "⤽", Wst = "⩈", Kst = "⩆", Xst = "≍", Jst = "∪", Zst = "⋓", Qst = "⩊", ect = "⊍", tct = "⩅", rct = "∪︀", nct = "↷", ict = "⤼", oct = "⋞", act = "⋟", uct = "⋎", sct = "⋏", cct = "¤", lct = "↶", fct = "↷", dct = "⋎", pct = "⋏", hct = "∲", vct = "∱", Ect = "⌭", mct = "†", gct = "‡", Tct = "ℸ", yct = "↓", _ct = "↡", Act = "⇓", Sct = "‐", bct = "⫤", Cct = "⊣", Ict = "⤏", Oct = "˝", Rct = "Ď", wct = "ď", Pct = "Д", Dct = "д", xct = "‡", Nct = "⇊", Lct = "ⅅ", Bct = "ⅆ", kct = "⤑", Mct = "⩷", Fct = "°", Hct = "∇", $ct = "Δ", Uct = "δ", Vct = "⦱", jct = "⥿", zct = "𝔇", qct = "𝔡", Yct = "⥥", Gct = "⇃", Wct = "⇂", Kct = "´", Xct = "˙", Jct = "˝", Zct = "`", Qct = "˜", elt = "⋄", tlt = "⋄", rlt = "⋄", nlt = "♦", ilt = "♦", olt = "¨", alt = "ⅆ", ult = "ϝ", slt = "⋲", clt = "÷", llt = "÷", flt = "⋇", dlt = "⋇", plt = "Ђ", hlt = "ђ", vlt = "⌞", Elt = "⌍", mlt = "$", glt = "𝔻", Tlt = "𝕕", ylt = "¨", _lt = "˙", Alt = "⃜", Slt = "≐", blt = "≑", Clt = "≐", Ilt = "∸", Olt = "∔", Rlt = "⊡", wlt = "⌆", Plt = "∯", Dlt = "¨", xlt = "⇓", Nlt = "⇐", Llt = "⇔", Blt = "⫤", klt = "⟸", Mlt = "⟺", Flt = "⟹", Hlt = "⇒", $lt = "⊨", Ult = "⇑", Vlt = "⇕", jlt = "∥", zlt = "⤓", qlt = "↓", Ylt = "↓", Glt = "⇓", Wlt = "⇵", Klt = "̑", Xlt = "⇊", Jlt = "⇃", Zlt = "⇂", Qlt = "⥐", e0t = "⥞", t0t = "⥖", r0t = "↽", n0t = "⥟", i0t = "⥗", o0t = "⇁", a0t = "↧", u0t = "⊤", s0t = "⤐", c0t = "⌟", l0t = "⌌", f0t = "𝒟", d0t = "𝒹", p0t = "Ѕ", h0t = "ѕ", v0t = "⧶", E0t = "Đ", m0t = "đ", g0t = "⋱", T0t = "▿", y0t = "▾", _0t = "⇵", A0t = "⥯", S0t = "⦦", b0t = "Џ", C0t = "џ", I0t = "⟿", O0t = "É", R0t = "é", w0t = "⩮", P0t = "Ě", D0t = "ě", x0t = "Ê", N0t = "ê", L0t = "≖", B0t = "≕", k0t = "Э", M0t = "э", F0t = "⩷", H0t = "Ė", $0t = "ė", U0t = "≑", V0t = "ⅇ", j0t = "≒", z0t = "𝔈", q0t = "𝔢", Y0t = "⪚", G0t = "È", W0t = "è", K0t = "⪖", X0t = "⪘", J0t = "⪙", Z0t = "∈", Q0t = "⏧", eft = "ℓ", tft = "⪕", rft = "⪗", nft = "Ē", ift = "ē", oft = "∅", aft = "∅", uft = "◻", sft = "∅", cft = "▫", lft = " ", fft = " ", dft = " ", pft = "Ŋ", hft = "ŋ", vft = " ", Eft = "Ę", mft = "ę", gft = "𝔼", Tft = "𝕖", yft = "⋕", _ft = "⧣", Aft = "⩱", Sft = "ε", bft = "Ε", Cft = "ε", Ift = "ϵ", Oft = "≖", Rft = "≕", wft = "≂", Pft = "⪖", Dft = "⪕", xft = "⩵", Nft = "=", Lft = "≂", Bft = "≟", kft = "⇌", Mft = "≡", Fft = "⩸", Hft = "⧥", $ft = "⥱", Uft = "≓", Vft = "ℯ", jft = "ℰ", zft = "≐", qft = "⩳", Yft = "≂", Gft = "Η", Wft = "η", Kft = "Ð", Xft = "ð", Jft = "Ë", Zft = "ë", Qft = "€", edt = "!", tdt = "∃", rdt = "∃", ndt = "ℰ", idt = "ⅇ", odt = "ⅇ", adt = "≒", udt = "Ф", sdt = "ф", cdt = "♀", ldt = "ﬃ", fdt = "ﬀ", ddt = "ﬄ", pdt = "𝔉", hdt = "𝔣", vdt = "ﬁ", Edt = "◼", mdt = "▪", gdt = "fj", Tdt = "♭", ydt = "ﬂ", _dt = "▱", Adt = "ƒ", Sdt = "𝔽", bdt = "𝕗", Cdt = "∀", Idt = "∀", Odt = "⋔", Rdt = "⫙", wdt = "ℱ", Pdt = "⨍", Ddt = "½", xdt = "⅓", Ndt = "¼", Ldt = "⅕", Bdt = "⅙", kdt = "⅛", Mdt = "⅔", Fdt = "⅖", Hdt = "¾", $dt = "⅗", Udt = "⅜", Vdt = "⅘", jdt = "⅚", zdt = "⅝", qdt = "⅞", Ydt = "⁄", Gdt = "⌢", Wdt = "𝒻", Kdt = "ℱ", Xdt = "ǵ", Jdt = "Γ", Zdt = "γ", Qdt = "Ϝ", ept = "ϝ", tpt = "⪆", rpt = "Ğ", npt = "ğ", ipt = "Ģ", opt = "Ĝ", apt = "ĝ", upt = "Г", spt = "г", cpt = "Ġ", lpt = "ġ", fpt = "≥", dpt = "≧", ppt = "⪌", hpt = "⋛", vpt = "≥", Ept = "≧", mpt = "⩾", gpt = "⪩", Tpt = "⩾", ypt = "⪀", _pt = "⪂", Apt = "⪄", Spt = "⋛︀", bpt = "⪔", Cpt = "𝔊", Ipt = "𝔤", Opt = "≫", Rpt = "⋙", wpt = "⋙", Ppt = "ℷ", Dpt = "Ѓ", xpt = "ѓ", Npt = "⪥", Lpt = "≷", Bpt = "⪒", kpt = "⪤", Mpt = "⪊", Fpt = "⪊", Hpt = "⪈", $pt = "≩", Upt = "⪈", Vpt = "≩", jpt = "⋧", zpt = "𝔾", qpt = "𝕘", Ypt = "`", Gpt = "≥", Wpt = "⋛", Kpt = "≧", Xpt = "⪢", Jpt = "≷", Zpt = "⩾", Qpt = "≳", eht = "𝒢", tht = "ℊ", rht = "≳", nht = "⪎", iht = "⪐", oht = "⪧", aht = "⩺", uht = ">", sht = ">", cht = "≫", lht = "⋗", fht = "⦕", dht = "⩼", pht = "⪆", hht = "⥸", vht = "⋗", Eht = "⋛", mht = "⪌", ght = "≷", Tht = "≳", yht = "≩︀", _ht = "≩︀", Aht = "ˇ", Sht = " ", bht = "½", Cht = "ℋ", Iht = "Ъ", Oht = "ъ", Rht = "⥈", wht = "↔", Pht = "⇔", Dht = "↭", xht = "^", Nht = "ℏ", Lht = "Ĥ", Bht = "ĥ", kht = "♥", Mht = "♥", Fht = "…", Hht = "⊹", $ht = "𝔥", Uht = "ℌ", Vht = "ℋ", jht = "⤥", zht = "⤦", qht = "⇿", Yht = "∻", Ght = "↩", Wht = "↪", Kht = "𝕙", Xht = "ℍ", Jht = "―", Zht = "─", Qht = "𝒽", evt = "ℋ", tvt = "ℏ", rvt = "Ħ", nvt = "ħ", ivt = "≎", ovt = "≏", avt = "⁃", uvt = "‐", svt = "Í", cvt = "í", lvt = "⁣", fvt = "Î", dvt = "î", pvt = "И", hvt = "и", vvt = "İ", Evt = "Е", mvt = "е", gvt = "¡", Tvt = "⇔", yvt = "𝔦", _vt = "ℑ", Avt = "Ì", Svt = "ì", bvt = "ⅈ", Cvt = "⨌", Ivt = "∭", Ovt = "⧜", Rvt = "℩", wvt = "Ĳ", Pvt = "ĳ", Dvt = "Ī", xvt = "ī", Nvt = "ℑ", Lvt = "ⅈ", Bvt = "ℐ", kvt = "ℑ", Mvt = "ı", Fvt = "ℑ", Hvt = "⊷", $vt = "Ƶ", Uvt = "⇒", Vvt = "℅", jvt = "∞", zvt = "⧝", qvt = "ı", Yvt = "⊺", Gvt = "∫", Wvt = "∬", Kvt = "ℤ", Xvt = "∫", Jvt = "⊺", Zvt = "⋂", Qvt = "⨗", eEt = "⨼", tEt = "⁣", rEt = "⁢", nEt = "Ё", iEt = "ё", oEt = "Į", aEt = "į", uEt = "𝕀", sEt = "𝕚", cEt = "Ι", lEt = "ι", fEt = "⨼", dEt = "¿", pEt = "𝒾", hEt = "ℐ", vEt = "∈", EEt = "⋵", mEt = "⋹", gEt = "⋴", TEt = "⋳", yEt = "∈", _Et = "⁢", AEt = "Ĩ", SEt = "ĩ", bEt = "І", CEt = "і", IEt = "Ï", OEt = "ï", REt = "Ĵ", wEt = "ĵ", PEt = "Й", DEt = "й", xEt = "𝔍", NEt = "𝔧", LEt = "ȷ", BEt = "𝕁", kEt = "𝕛", MEt = "𝒥", FEt = "𝒿", HEt = "Ј", $Et = "ј", UEt = "Є", VEt = "є", jEt = "Κ", zEt = "κ", qEt = "ϰ", YEt = "Ķ", GEt = "ķ", WEt = "К", KEt = "к", XEt = "𝔎", JEt = "𝔨", ZEt = "ĸ", QEt = "Х", emt = "х", tmt = "Ќ", rmt = "ќ", nmt = "𝕂", imt = "𝕜", omt = "𝒦", amt = "𝓀", umt = "⇚", smt = "Ĺ", cmt = "ĺ", lmt = "⦴", fmt = "ℒ", dmt = "Λ", pmt = "λ", hmt = "⟨", vmt = "⟪", Emt = "⦑", mmt = "⟨", gmt = "⪅", Tmt = "ℒ", ymt = "«", _mt = "⇤", Amt = "⤟", Smt = "←", bmt = "↞", Cmt = "⇐", Imt = "⤝", Omt = "↩", Rmt = "↫", wmt = "⤹", Pmt = "⥳", Dmt = "↢", xmt = "⤙", Nmt = "⤛", Lmt = "⪫", Bmt = "⪭", kmt = "⪭︀", Mmt = "⤌", Fmt = "⤎", Hmt = "❲", $mt = "{", Umt = "[", Vmt = "⦋", jmt = "⦏", zmt = "⦍", qmt = "Ľ", Ymt = "ľ", Gmt = "Ļ", Wmt = "ļ", Kmt = "⌈", Xmt = "{", Jmt = "Л", Zmt = "л", Qmt = "⤶", egt = "“", tgt = "„", rgt = "⥧", ngt = "⥋", igt = "↲", ogt = "≤", agt = "≦", ugt = "⟨", sgt = "⇤", cgt = "←", lgt = "←", fgt = "⇐", dgt = "⇆", pgt = "↢", hgt = "⌈", vgt = "⟦", Egt = "⥡", mgt = "⥙", ggt = "⇃", Tgt = "⌊", ygt = "↽", _gt = "↼", Agt = "⇇", Sgt = "↔", bgt = "↔", Cgt = "⇔", Igt = "⇆", Ogt = "⇋", Rgt = "↭", wgt = "⥎", Pgt = "↤", Dgt = "⊣", xgt = "⥚", Ngt = "⋋", Lgt = "⧏", Bgt = "⊲", kgt = "⊴", Mgt = "⥑", Fgt = "⥠", Hgt = "⥘", $gt = "↿", Ugt = "⥒", Vgt = "↼", jgt = "⪋", zgt = "⋚", qgt = "≤", Ygt = "≦", Ggt = "⩽", Wgt = "⪨", Kgt = "⩽", Xgt = "⩿", Jgt = "⪁", Zgt = "⪃", Qgt = "⋚︀", e1t = "⪓", t1t = "⪅", r1t = "⋖", n1t = "⋚", i1t = "⪋", o1t = "⋚", a1t = "≦", u1t = "≶", s1t = "≶", c1t = "⪡", l1t = "≲", f1t = "⩽", d1t = "≲", p1t = "⥼", h1t = "⌊", v1t = "𝔏", E1t = "𝔩", m1t = "≶", g1t = "⪑", T1t = "⥢", y1t = "↽", _1t = "↼", A1t = "⥪", S1t = "▄", b1t = "Љ", C1t = "љ", I1t = "⇇", O1t = "≪", R1t = "⋘", w1t = "⌞", P1t = "⇚", D1t = "⥫", x1t = "◺", N1t = "Ŀ", L1t = "ŀ", B1t = "⎰", k1t = "⎰", M1t = "⪉", F1t = "⪉", H1t = "⪇", $1t = "≨", U1t = "⪇", V1t = "≨", j1t = "⋦", z1t = "⟬", q1t = "⇽", Y1t = "⟦", G1t = "⟵", W1t = "⟵", K1t = "⟸", X1t = "⟷", J1t = "⟷", Z1t = "⟺", Q1t = "⟼", eTt = "⟶", tTt = "⟶", rTt = "⟹", nTt = "↫", iTt = "↬", oTt = "⦅", aTt = "𝕃", uTt = "𝕝", sTt = "⨭", cTt = "⨴", lTt = "∗", fTt = "_", dTt = "↙", pTt = "↘", hTt = "◊", vTt = "◊", ETt = "⧫", mTt = "(", gTt = "⦓", TTt = "⇆", yTt = "⌟", _Tt = "⇋", ATt = "⥭", STt = "‎", bTt = "⊿", CTt = "‹", ITt = "𝓁", OTt = "ℒ", RTt = "↰", wTt = "↰", PTt = "≲", DTt = "⪍", xTt = "⪏", NTt = "[", LTt = "‘", BTt = "‚", kTt = "Ł", MTt = "ł", FTt = "⪦", HTt = "⩹", $Tt = "<", UTt = "<", VTt = "≪", jTt = "⋖", zTt = "⋋", qTt = "⋉", YTt = "⥶", GTt = "⩻", WTt = "◃", KTt = "⊴", XTt = "◂", JTt = "⦖", ZTt = "⥊", QTt = "⥦", eyt = "≨︀", tyt = "≨︀", ryt = "¯", nyt = "♂", iyt = "✠", oyt = "✠", ayt = "↦", uyt = "↦", syt = "↧", cyt = "↤", lyt = "↥", fyt = "▮", dyt = "⨩", pyt = "М", hyt = "м", vyt = "—", Eyt = "∺", myt = "∡", gyt = " ", Tyt = "ℳ", yyt = "𝔐", _yt = "𝔪", Ayt = "℧", Syt = "µ", byt = "*", Cyt = "⫰", Iyt = "∣", Oyt = "·", Ryt = "⊟", wyt = "−", Pyt = "∸", Dyt = "⨪", xyt = "∓", Nyt = "⫛", Lyt = "…", Byt = "∓", kyt = "⊧", Myt = "𝕄", Fyt = "𝕞", Hyt = "∓", $yt = "𝓂", Uyt = "ℳ", Vyt = "∾", jyt = "Μ", zyt = "μ", qyt = "⊸", Yyt = "⊸", Gyt = "∇", Wyt = "Ń", Kyt = "ń", Xyt = "∠⃒", Jyt = "≉", Zyt = "⩰̸", Qyt = "≋̸", e_t = "ŉ", t_t = "≉", r_t = "♮", n_t = "ℕ", i_t = "♮", o_t = " ", a_t = "≎̸", u_t = "≏̸", s_t = "⩃", c_t = "Ň", l_t = "ň", f_t = "Ņ", d_t = "ņ", p_t = "≇", h_t = "⩭̸", v_t = "⩂", E_t = "Н", m_t = "н", g_t = "–", T_t = "⤤", y_t = "↗", __t = "⇗", A_t = "↗", S_t = "≠", b_t = "≐̸", C_t = "​", I_t = "​", O_t = "​", R_t = "​", w_t = "≢", P_t = "⤨", D_t = "≂̸", x_t = "≫", N_t = "≪", L_t = `
`, B_t = "∄", k_t = "∄", M_t = "𝔑", F_t = "𝔫", H_t = "≧̸", $_t = "≱", U_t = "≱", V_t = "≧̸", j_t = "⩾̸", z_t = "⩾̸", q_t = "⋙̸", Y_t = "≵", G_t = "≫⃒", W_t = "≯", K_t = "≯", X_t = "≫̸", J_t = "↮", Z_t = "⇎", Q_t = "⫲", eAt = "∋", tAt = "⋼", rAt = "⋺", nAt = "∋", iAt = "Њ", oAt = "њ", aAt = "↚", uAt = "⇍", sAt = "‥", cAt = "≦̸", lAt = "≰", fAt = "↚", dAt = "⇍", pAt = "↮", hAt = "⇎", vAt = "≰", EAt = "≦̸", mAt = "⩽̸", gAt = "⩽̸", TAt = "≮", yAt = "⋘̸", _At = "≴", AAt = "≪⃒", SAt = "≮", bAt = "⋪", CAt = "⋬", IAt = "≪̸", OAt = "∤", RAt = "⁠", wAt = " ", PAt = "𝕟", DAt = "ℕ", xAt = "⫬", NAt = "¬", LAt = "≢", BAt = "≭", kAt = "∦", MAt = "∉", FAt = "≠", HAt = "≂̸", $At = "∄", UAt = "≯", VAt = "≱", jAt = "≧̸", zAt = "≫̸", qAt = "≹", YAt = "⩾̸", GAt = "≵", WAt = "≎̸", KAt = "≏̸", XAt = "∉", JAt = "⋵̸", ZAt = "⋹̸", QAt = "∉", e4t = "⋷", t4t = "⋶", r4t = "⧏̸", n4t = "⋪", i4t = "⋬", o4t = "≮", a4t = "≰", u4t = "≸", s4t = "≪̸", c4t = "⩽̸", l4t = "≴", f4t = "⪢̸", d4t = "⪡̸", p4t = "∌", h4t = "∌", v4t = "⋾", E4t = "⋽", m4t = "⊀", g4t = "⪯̸", T4t = "⋠", y4t = "∌", _4t = "⧐̸", A4t = "⋫", S4t = "⋭", b4t = "⊏̸", C4t = "⋢", I4t = "⊐̸", O4t = "⋣", R4t = "⊂⃒", w4t = "⊈", P4t = "⊁", D4t = "⪰̸", x4t = "⋡", N4t = "≿̸", L4t = "⊃⃒", B4t = "⊉", k4t = "≁", M4t = "≄", F4t = "≇", H4t = "≉", $4t = "∤", U4t = "∦", V4t = "∦", j4t = "⫽⃥", z4t = "∂̸", q4t = "⨔", Y4t = "⊀", G4t = "⋠", W4t = "⊀", K4t = "⪯̸", X4t = "⪯̸", J4t = "⤳̸", Z4t = "↛", Q4t = "⇏", eSt = "↝̸", tSt = "↛", rSt = "⇏", nSt = "⋫", iSt = "⋭", oSt = "⊁", aSt = "⋡", uSt = "⪰̸", sSt = "𝒩", cSt = "𝓃", lSt = "∤", fSt = "∦", dSt = "≁", pSt = "≄", hSt = "≄", vSt = "∤", ESt = "∦", mSt = "⋢", gSt = "⋣", TSt = "⊄", ySt = "⫅̸", _St = "⊈", ASt = "⊂⃒", SSt = "⊈", bSt = "⫅̸", CSt = "⊁", ISt = "⪰̸", OSt = "⊅", RSt = "⫆̸", wSt = "⊉", PSt = "⊃⃒", DSt = "⊉", xSt = "⫆̸", NSt = "≹", LSt = "Ñ", BSt = "ñ", kSt = "≸", MSt = "⋪", FSt = "⋬", HSt = "⋫", $St = "⋭", USt = "Ν", VSt = "ν", jSt = "#", zSt = "№", qSt = " ", YSt = "≍⃒", GSt = "⊬", WSt = "⊭", KSt = "⊮", XSt = "⊯", JSt = "≥⃒", ZSt = ">⃒", QSt = "⤄", ebt = "⧞", tbt = "⤂", rbt = "≤⃒", nbt = "<⃒", ibt = "⊴⃒", obt = "⤃", abt = "⊵⃒", ubt = "∼⃒", sbt = "⤣", cbt = "↖", lbt = "⇖", fbt = "↖", dbt = "⤧", pbt = "Ó", hbt = "ó", vbt = "⊛", Ebt = "Ô", mbt = "ô", gbt = "⊚", Tbt = "О", ybt = "о", _bt = "⊝", Abt = "Ő", Sbt = "ő", bbt = "⨸", Cbt = "⊙", Ibt = "⦼", Obt = "Œ", Rbt = "œ", wbt = "⦿", Pbt = "𝔒", Dbt = "𝔬", xbt = "˛", Nbt = "Ò", Lbt = "ò", Bbt = "⧁", kbt = "⦵", Mbt = "Ω", Fbt = "∮", Hbt = "↺", $bt = "⦾", Ubt = "⦻", Vbt = "‾", jbt = "⧀", zbt = "Ō", qbt = "ō", Ybt = "Ω", Gbt = "ω", Wbt = "Ο", Kbt = "ο", Xbt = "⦶", Jbt = "⊖", Zbt = "𝕆", Qbt = "𝕠", eCt = "⦷", tCt = "“", rCt = "‘", nCt = "⦹", iCt = "⊕", oCt = "↻", aCt = "⩔", uCt = "∨", sCt = "⩝", cCt = "ℴ", lCt = "ℴ", fCt = "ª", dCt = "º", pCt = "⊶", hCt = "⩖", vCt = "⩗", ECt = "⩛", mCt = "Ⓢ", gCt = "𝒪", TCt = "ℴ", yCt = "Ø", _Ct = "ø", ACt = "⊘", SCt = "Õ", bCt = "õ", CCt = "⨶", ICt = "⨷", OCt = "⊗", RCt = "Ö", wCt = "ö", PCt = "⌽", DCt = "‾", xCt = "⏞", NCt = "⎴", LCt = "⏜", BCt = "¶", kCt = "∥", MCt = "∥", FCt = "⫳", HCt = "⫽", $Ct = "∂", UCt = "∂", VCt = "П", jCt = "п", zCt = "%", qCt = ".", YCt = "‰", GCt = "⊥", WCt = "‱", KCt = "𝔓", XCt = "𝔭", JCt = "Φ", ZCt = "φ", QCt = "ϕ", e3t = "ℳ", t3t = "☎", r3t = "Π", n3t = "π", i3t = "⋔", o3t = "ϖ", a3t = "ℏ", u3t = "ℎ", s3t = "ℏ", c3t = "⨣", l3t = "⊞", f3t = "⨢", d3t = "+", p3t = "∔", h3t = "⨥", v3t = "⩲", E3t = "±", m3t = "±", g3t = "⨦", T3t = "⨧", y3t = "±", _3t = "ℌ", A3t = "⨕", S3t = "𝕡", b3t = "ℙ", C3t = "£", I3t = "⪷", O3t = "⪻", R3t = "≺", w3t = "≼", P3t = "⪷", D3t = "≺", x3t = "≼", N3t = "≺", L3t = "⪯", B3t = "≼", k3t = "≾", M3t = "⪯", F3t = "⪹", H3t = "⪵", $3t = "⋨", U3t = "⪯", V3t = "⪳", j3t = "≾", z3t = "′", q3t = "″", Y3t = "ℙ", G3t = "⪹", W3t = "⪵", K3t = "⋨", X3t = "∏", J3t = "∏", Z3t = "⌮", Q3t = "⌒", e2t = "⌓", t2t = "∝", r2t = "∝", n2t = "∷", i2t = "∝", o2t = "≾", a2t = "⊰", u2t = "𝒫", s2t = "𝓅", c2t = "Ψ", l2t = "ψ", f2t = " ", d2t = "𝔔", p2t = "𝔮", h2t = "⨌", v2t = "𝕢", E2t = "ℚ", m2t = "⁗", g2t = "𝒬", T2t = "𝓆", y2t = "ℍ", _2t = "⨖", A2t = "?", S2t = "≟", b2t = '"', C2t = '"', I2t = "⇛", O2t = "∽̱", R2t = "Ŕ", w2t = "ŕ", P2t = "√", D2t = "⦳", x2t = "⟩", N2t = "⟫", L2t = "⦒", B2t = "⦥", k2t = "⟩", M2t = "»", F2t = "⥵", H2t = "⇥", $2t = "⤠", U2t = "⤳", V2t = "→", j2t = "↠", z2t = "⇒", q2t = "⤞", Y2t = "↪", G2t = "↬", W2t = "⥅", K2t = "⥴", X2t = "⤖", J2t = "↣", Z2t = "↝", Q2t = "⤚", eIt = "⤜", tIt = "∶", rIt = "ℚ", nIt = "⤍", iIt = "⤏", oIt = "⤐", aIt = "❳", uIt = "}", sIt = "]", cIt = "⦌", lIt = "⦎", fIt = "⦐", dIt = "Ř", pIt = "ř", hIt = "Ŗ", vIt = "ŗ", EIt = "⌉", mIt = "}", gIt = "Р", TIt = "р", yIt = "⤷", _It = "⥩", AIt = "”", SIt = "”", bIt = "↳", CIt = "ℜ", IIt = "ℛ", OIt = "ℜ", RIt = "ℝ", wIt = "ℜ", PIt = "▭", DIt = "®", xIt = "®", NIt = "∋", LIt = "⇋", BIt = "⥯", kIt = "⥽", MIt = "⌋", FIt = "𝔯", HIt = "ℜ", $It = "⥤", UIt = "⇁", VIt = "⇀", jIt = "⥬", zIt = "Ρ", qIt = "ρ", YIt = "ϱ", GIt = "⟩", WIt = "⇥", KIt = "→", XIt = "→", JIt = "⇒", ZIt = "⇄", QIt = "↣", eOt = "⌉", tOt = "⟧", rOt = "⥝", nOt = "⥕", iOt = "⇂", oOt = "⌋", aOt = "⇁", uOt = "⇀", sOt = "⇄", cOt = "⇌", lOt = "⇉", fOt = "↝", dOt = "↦", pOt = "⊢", hOt = "⥛", vOt = "⋌", EOt = "⧐", mOt = "⊳", gOt = "⊵", TOt = "⥏", yOt = "⥜", _Ot = "⥔", AOt = "↾", SOt = "⥓", bOt = "⇀", COt = "˚", IOt = "≓", OOt = "⇄", ROt = "⇌", wOt = "‏", POt = "⎱", DOt = "⎱", xOt = "⫮", NOt = "⟭", LOt = "⇾", BOt = "⟧", kOt = "⦆", MOt = "𝕣", FOt = "ℝ", HOt = "⨮", $Ot = "⨵", UOt = "⥰", VOt = ")", jOt = "⦔", zOt = "⨒", qOt = "⇉", YOt = "⇛", GOt = "›", WOt = "𝓇", KOt = "ℛ", XOt = "↱", JOt = "↱", ZOt = "]", QOt = "’", eRt = "’", tRt = "⋌", rRt = "⋊", nRt = "▹", iRt = "⊵", oRt = "▸", aRt = "⧎", uRt = "⧴", sRt = "⥨", cRt = "℞", lRt = "Ś", fRt = "ś", dRt = "‚", pRt = "⪸", hRt = "Š", vRt = "š", ERt = "⪼", mRt = "≻", gRt = "≽", TRt = "⪰", yRt = "⪴", _Rt = "Ş", ARt = "ş", SRt = "Ŝ", bRt = "ŝ", CRt = "⪺", IRt = "⪶", ORt = "⋩", RRt = "⨓", wRt = "≿", PRt = "С", DRt = "с", xRt = "⊡", NRt = "⋅", LRt = "⩦", BRt = "⤥", kRt = "↘", MRt = "⇘", FRt = "↘", HRt = "§", $Rt = ";", URt = "⤩", VRt = "∖", jRt = "∖", zRt = "✶", qRt = "𝔖", YRt = "𝔰", GRt = "⌢", WRt = "♯", KRt = "Щ", XRt = "щ", JRt = "Ш", ZRt = "ш", QRt = "↓", ewt = "←", twt = "∣", rwt = "∥", nwt = "→", iwt = "↑", owt = "­", awt = "Σ", uwt = "σ", swt = "ς", cwt = "ς", lwt = "∼", fwt = "⩪", dwt = "≃", pwt = "≃", hwt = "⪞", vwt = "⪠", Ewt = "⪝", mwt = "⪟", gwt = "≆", Twt = "⨤", ywt = "⥲", _wt = "←", Awt = "∘", Swt = "∖", bwt = "⨳", Cwt = "⧤", Iwt = "∣", Owt = "⌣", Rwt = "⪪", wwt = "⪬", Pwt = "⪬︀", Dwt = "Ь", xwt = "ь", Nwt = "⌿", Lwt = "⧄", Bwt = "/", kwt = "𝕊", Mwt = "𝕤", Fwt = "♠", Hwt = "♠", $wt = "∥", Uwt = "⊓", Vwt = "⊓︀", jwt = "⊔", zwt = "⊔︀", qwt = "√", Ywt = "⊏", Gwt = "⊑", Wwt = "⊏", Kwt = "⊑", Xwt = "⊐", Jwt = "⊒", Zwt = "⊐", Qwt = "⊒", ePt = "□", tPt = "□", rPt = "⊓", nPt = "⊏", iPt = "⊑", oPt = "⊐", aPt = "⊒", uPt = "⊔", sPt = "▪", cPt = "□", lPt = "▪", fPt = "→", dPt = "𝒮", pPt = "𝓈", hPt = "∖", vPt = "⌣", EPt = "⋆", mPt = "⋆", gPt = "☆", TPt = "★", yPt = "ϵ", _Pt = "ϕ", APt = "¯", SPt = "⊂", bPt = "⋐", CPt = "⪽", IPt = "⫅", OPt = "⊆", RPt = "⫃", wPt = "⫁", PPt = "⫋", DPt = "⊊", xPt = "⪿", NPt = "⥹", LPt = "⊂", BPt = "⋐", kPt = "⊆", MPt = "⫅", FPt = "⊆", HPt = "⊊", $Pt = "⫋", UPt = "⫇", VPt = "⫕", jPt = "⫓", zPt = "⪸", qPt = "≻", YPt = "≽", GPt = "≻", WPt = "⪰", KPt = "≽", XPt = "≿", JPt = "⪰", ZPt = "⪺", QPt = "⪶", e6t = "⋩", t6t = "≿", r6t = "∋", n6t = "∑", i6t = "∑", o6t = "♪", a6t = "¹", u6t = "²", s6t = "³", c6t = "⊃", l6t = "⋑", f6t = "⪾", d6t = "⫘", p6t = "⫆", h6t = "⊇", v6t = "⫄", E6t = "⊃", m6t = "⊇", g6t = "⟉", T6t = "⫗", y6t = "⥻", _6t = "⫂", A6t = "⫌", S6t = "⊋", b6t = "⫀", C6t = "⊃", I6t = "⋑", O6t = "⊇", R6t = "⫆", w6t = "⊋", P6t = "⫌", D6t = "⫈", x6t = "⫔", N6t = "⫖", L6t = "⤦", B6t = "↙", k6t = "⇙", M6t = "↙", F6t = "⤪", H6t = "ß", $6t = "	", U6t = "⌖", V6t = "Τ", j6t = "τ", z6t = "⎴", q6t = "Ť", Y6t = "ť", G6t = "Ţ", W6t = "ţ", K6t = "Т", X6t = "т", J6t = "⃛", Z6t = "⌕", Q6t = "𝔗", eDt = "𝔱", tDt = "∴", rDt = "∴", nDt = "∴", iDt = "Θ", oDt = "θ", aDt = "ϑ", uDt = "ϑ", sDt = "≈", cDt = "∼", lDt = "  ", fDt = " ", dDt = " ", pDt = "≈", hDt = "∼", vDt = "Þ", EDt = "þ", mDt = "˜", gDt = "∼", TDt = "≃", yDt = "≅", _Dt = "≈", ADt = "⨱", SDt = "⊠", bDt = "×", CDt = "⨰", IDt = "∭", ODt = "⤨", RDt = "⌶", wDt = "⫱", PDt = "⊤", DDt = "𝕋", xDt = "𝕥", NDt = "⫚", LDt = "⤩", BDt = "‴", kDt = "™", MDt = "™", FDt = "▵", HDt = "▿", $Dt = "◃", UDt = "⊴", VDt = "≜", jDt = "▹", zDt = "⊵", qDt = "◬", YDt = "≜", GDt = "⨺", WDt = "⃛", KDt = "⨹", XDt = "⧍", JDt = "⨻", ZDt = "⏢", QDt = "𝒯", ext = "𝓉", txt = "Ц", rxt = "ц", nxt = "Ћ", ixt = "ћ", oxt = "Ŧ", axt = "ŧ", uxt = "≬", sxt = "↞", cxt = "↠", lxt = "Ú", fxt = "ú", dxt = "↑", pxt = "↟", hxt = "⇑", vxt = "⥉", Ext = "Ў", mxt = "ў", gxt = "Ŭ", Txt = "ŭ", yxt = "Û", _xt = "û", Axt = "У", Sxt = "у", bxt = "⇅", Cxt = "Ű", Ixt = "ű", Oxt = "⥮", Rxt = "⥾", wxt = "𝔘", Pxt = "𝔲", Dxt = "Ù", xxt = "ù", Nxt = "⥣", Lxt = "↿", Bxt = "↾", kxt = "▀", Mxt = "⌜", Fxt = "⌜", Hxt = "⌏", $xt = "◸", Uxt = "Ū", Vxt = "ū", jxt = "¨", zxt = "_", qxt = "⏟", Yxt = "⎵", Gxt = "⏝", Wxt = "⋃", Kxt = "⊎", Xxt = "Ų", Jxt = "ų", Zxt = "𝕌", Qxt = "𝕦", eNt = "⤒", tNt = "↑", rNt = "↑", nNt = "⇑", iNt = "⇅", oNt = "↕", aNt = "↕", uNt = "⇕", sNt = "⥮", cNt = "↿", lNt = "↾", fNt = "⊎", dNt = "↖", pNt = "↗", hNt = "υ", vNt = "ϒ", ENt = "ϒ", mNt = "Υ", gNt = "υ", TNt = "↥", yNt = "⊥", _Nt = "⇈", ANt = "⌝", SNt = "⌝", bNt = "⌎", CNt = "Ů", INt = "ů", ONt = "◹", RNt = "𝒰", wNt = "𝓊", PNt = "⋰", DNt = "Ũ", xNt = "ũ", NNt = "▵", LNt = "▴", BNt = "⇈", kNt = "Ü", MNt = "ü", FNt = "⦧", HNt = "⦜", $Nt = "ϵ", UNt = "ϰ", VNt = "∅", jNt = "ϕ", zNt = "ϖ", qNt = "∝", YNt = "↕", GNt = "⇕", WNt = "ϱ", KNt = "ς", XNt = "⊊︀", JNt = "⫋︀", ZNt = "⊋︀", QNt = "⫌︀", e5t = "ϑ", t5t = "⊲", r5t = "⊳", n5t = "⫨", i5t = "⫫", o5t = "⫩", a5t = "В", u5t = "в", s5t = "⊢", c5t = "⊨", l5t = "⊩", f5t = "⊫", d5t = "⫦", p5t = "⊻", h5t = "∨", v5t = "⋁", E5t = "≚", m5t = "⋮", g5t = "|", T5t = "‖", y5t = "|", _5t = "‖", A5t = "∣", S5t = "|", b5t = "❘", C5t = "≀", I5t = " ", O5t = "𝔙", R5t = "𝔳", w5t = "⊲", P5t = "⊂⃒", D5t = "⊃⃒", x5t = "𝕍", N5t = "𝕧", L5t = "∝", B5t = "⊳", k5t = "𝒱", M5t = "𝓋", F5t = "⫋︀", H5t = "⊊︀", $5t = "⫌︀", U5t = "⊋︀", V5t = "⊪", j5t = "⦚", z5t = "Ŵ", q5t = "ŵ", Y5t = "⩟", G5t = "∧", W5t = "⋀", K5t = "≙", X5t = "℘", J5t = "𝔚", Z5t = "𝔴", Q5t = "𝕎", eLt = "𝕨", tLt = "℘", rLt = "≀", nLt = "≀", iLt = "𝒲", oLt = "𝓌", aLt = "⋂", uLt = "◯", sLt = "⋃", cLt = "▽", lLt = "𝔛", fLt = "𝔵", dLt = "⟷", pLt = "⟺", hLt = "Ξ", vLt = "ξ", ELt = "⟵", mLt = "⟸", gLt = "⟼", TLt = "⋻", yLt = "⨀", _Lt = "𝕏", ALt = "𝕩", SLt = "⨁", bLt = "⨂", CLt = "⟶", ILt = "⟹", OLt = "𝒳", RLt = "𝓍", wLt = "⨆", PLt = "⨄", DLt = "△", xLt = "⋁", NLt = "⋀", LLt = "Ý", BLt = "ý", kLt = "Я", MLt = "я", FLt = "Ŷ", HLt = "ŷ", $Lt = "Ы", ULt = "ы", VLt = "¥", jLt = "𝔜", zLt = "𝔶", qLt = "Ї", YLt = "ї", GLt = "𝕐", WLt = "𝕪", KLt = "𝒴", XLt = "𝓎", JLt = "Ю", ZLt = "ю", QLt = "ÿ", eBt = "Ÿ", tBt = "Ź", rBt = "ź", nBt = "Ž", iBt = "ž", oBt = "З", aBt = "з", uBt = "Ż", sBt = "ż", cBt = "ℨ", lBt = "​", fBt = "Ζ", dBt = "ζ", pBt = "𝔷", hBt = "ℨ", vBt = "Ж", EBt = "ж", mBt = "⇝", gBt = "𝕫", TBt = "ℤ", yBt = "𝒵", _Bt = "𝓏", ABt = "‍", SBt = "‌", bBt = {
  Aacute: unt,
  aacute: snt,
  Abreve: cnt,
  abreve: lnt,
  ac: fnt,
  acd: dnt,
  acE: pnt,
  Acirc: hnt,
  acirc: vnt,
  acute: Ent,
  Acy: mnt,
  acy: gnt,
  AElig: Tnt,
  aelig: ynt,
  af: _nt,
  Afr: Ant,
  afr: Snt,
  Agrave: bnt,
  agrave: Cnt,
  alefsym: Int,
  aleph: Ont,
  Alpha: Rnt,
  alpha: wnt,
  Amacr: Pnt,
  amacr: Dnt,
  amalg: xnt,
  amp: Nnt,
  AMP: Lnt,
  andand: Bnt,
  And: knt,
  and: Mnt,
  andd: Fnt,
  andslope: Hnt,
  andv: $nt,
  ang: Unt,
  ange: Vnt,
  angle: jnt,
  angmsdaa: znt,
  angmsdab: qnt,
  angmsdac: Ynt,
  angmsdad: Gnt,
  angmsdae: Wnt,
  angmsdaf: Knt,
  angmsdag: Xnt,
  angmsdah: Jnt,
  angmsd: Znt,
  angrt: Qnt,
  angrtvb: eit,
  angrtvbd: tit,
  angsph: rit,
  angst: nit,
  angzarr: iit,
  Aogon: oit,
  aogon: ait,
  Aopf: uit,
  aopf: sit,
  apacir: cit,
  ap: lit,
  apE: fit,
  ape: dit,
  apid: pit,
  apos: hit,
  ApplyFunction: vit,
  approx: Eit,
  approxeq: mit,
  Aring: git,
  aring: Tit,
  Ascr: yit,
  ascr: _it,
  Assign: Ait,
  ast: Sit,
  asymp: bit,
  asympeq: Cit,
  Atilde: Iit,
  atilde: Oit,
  Auml: Rit,
  auml: wit,
  awconint: Pit,
  awint: Dit,
  backcong: xit,
  backepsilon: Nit,
  backprime: Lit,
  backsim: Bit,
  backsimeq: kit,
  Backslash: Mit,
  Barv: Fit,
  barvee: Hit,
  barwed: $it,
  Barwed: Uit,
  barwedge: Vit,
  bbrk: jit,
  bbrktbrk: zit,
  bcong: qit,
  Bcy: Yit,
  bcy: Git,
  bdquo: Wit,
  becaus: Kit,
  because: Xit,
  Because: Jit,
  bemptyv: Zit,
  bepsi: Qit,
  bernou: eot,
  Bernoullis: tot,
  Beta: rot,
  beta: not,
  beth: iot,
  between: oot,
  Bfr: aot,
  bfr: uot,
  bigcap: sot,
  bigcirc: cot,
  bigcup: lot,
  bigodot: fot,
  bigoplus: dot,
  bigotimes: pot,
  bigsqcup: hot,
  bigstar: vot,
  bigtriangledown: Eot,
  bigtriangleup: mot,
  biguplus: got,
  bigvee: Tot,
  bigwedge: yot,
  bkarow: _ot,
  blacklozenge: Aot,
  blacksquare: Sot,
  blacktriangle: bot,
  blacktriangledown: Cot,
  blacktriangleleft: Iot,
  blacktriangleright: Oot,
  blank: Rot,
  blk12: wot,
  blk14: Pot,
  blk34: Dot,
  block: xot,
  bne: Not,
  bnequiv: Lot,
  bNot: Bot,
  bnot: kot,
  Bopf: Mot,
  bopf: Fot,
  bot: Hot,
  bottom: $ot,
  bowtie: Uot,
  boxbox: Vot,
  boxdl: jot,
  boxdL: zot,
  boxDl: qot,
  boxDL: Yot,
  boxdr: Got,
  boxdR: Wot,
  boxDr: Kot,
  boxDR: Xot,
  boxh: Jot,
  boxH: Zot,
  boxhd: Qot,
  boxHd: eat,
  boxhD: tat,
  boxHD: rat,
  boxhu: nat,
  boxHu: iat,
  boxhU: oat,
  boxHU: aat,
  boxminus: uat,
  boxplus: sat,
  boxtimes: cat,
  boxul: lat,
  boxuL: fat,
  boxUl: dat,
  boxUL: pat,
  boxur: hat,
  boxuR: vat,
  boxUr: Eat,
  boxUR: mat,
  boxv: gat,
  boxV: Tat,
  boxvh: yat,
  boxvH: _at,
  boxVh: Aat,
  boxVH: Sat,
  boxvl: bat,
  boxvL: Cat,
  boxVl: Iat,
  boxVL: Oat,
  boxvr: Rat,
  boxvR: wat,
  boxVr: Pat,
  boxVR: Dat,
  bprime: xat,
  breve: Nat,
  Breve: Lat,
  brvbar: Bat,
  bscr: kat,
  Bscr: Mat,
  bsemi: Fat,
  bsim: Hat,
  bsime: $at,
  bsolb: Uat,
  bsol: Vat,
  bsolhsub: jat,
  bull: zat,
  bullet: qat,
  bump: Yat,
  bumpE: Gat,
  bumpe: Wat,
  Bumpeq: Kat,
  bumpeq: Xat,
  Cacute: Jat,
  cacute: Zat,
  capand: Qat,
  capbrcup: eut,
  capcap: tut,
  cap: rut,
  Cap: nut,
  capcup: iut,
  capdot: out,
  CapitalDifferentialD: aut,
  caps: uut,
  caret: sut,
  caron: cut,
  Cayleys: lut,
  ccaps: fut,
  Ccaron: dut,
  ccaron: put,
  Ccedil: hut,
  ccedil: vut,
  Ccirc: Eut,
  ccirc: mut,
  Cconint: gut,
  ccups: Tut,
  ccupssm: yut,
  Cdot: _ut,
  cdot: Aut,
  cedil: Sut,
  Cedilla: but,
  cemptyv: Cut,
  cent: Iut,
  centerdot: Out,
  CenterDot: Rut,
  cfr: wut,
  Cfr: Put,
  CHcy: Dut,
  chcy: xut,
  check: Nut,
  checkmark: Lut,
  Chi: But,
  chi: kut,
  circ: Mut,
  circeq: Fut,
  circlearrowleft: Hut,
  circlearrowright: $ut,
  circledast: Uut,
  circledcirc: Vut,
  circleddash: jut,
  CircleDot: zut,
  circledR: qut,
  circledS: Yut,
  CircleMinus: Gut,
  CirclePlus: Wut,
  CircleTimes: Kut,
  cir: Xut,
  cirE: Jut,
  cire: Zut,
  cirfnint: Qut,
  cirmid: est,
  cirscir: tst,
  ClockwiseContourIntegral: rst,
  CloseCurlyDoubleQuote: nst,
  CloseCurlyQuote: ist,
  clubs: ost,
  clubsuit: ast,
  colon: ust,
  Colon: sst,
  Colone: cst,
  colone: lst,
  coloneq: fst,
  comma: dst,
  commat: pst,
  comp: hst,
  compfn: vst,
  complement: Est,
  complexes: mst,
  cong: gst,
  congdot: Tst,
  Congruent: yst,
  conint: _st,
  Conint: Ast,
  ContourIntegral: Sst,
  copf: bst,
  Copf: Cst,
  coprod: Ist,
  Coproduct: Ost,
  copy: Rst,
  COPY: wst,
  copysr: Pst,
  CounterClockwiseContourIntegral: Dst,
  crarr: xst,
  cross: Nst,
  Cross: Lst,
  Cscr: Bst,
  cscr: kst,
  csub: Mst,
  csube: Fst,
  csup: Hst,
  csupe: $st,
  ctdot: Ust,
  cudarrl: Vst,
  cudarrr: jst,
  cuepr: zst,
  cuesc: qst,
  cularr: Yst,
  cularrp: Gst,
  cupbrcap: Wst,
  cupcap: Kst,
  CupCap: Xst,
  cup: Jst,
  Cup: Zst,
  cupcup: Qst,
  cupdot: ect,
  cupor: tct,
  cups: rct,
  curarr: nct,
  curarrm: ict,
  curlyeqprec: oct,
  curlyeqsucc: act,
  curlyvee: uct,
  curlywedge: sct,
  curren: cct,
  curvearrowleft: lct,
  curvearrowright: fct,
  cuvee: dct,
  cuwed: pct,
  cwconint: hct,
  cwint: vct,
  cylcty: Ect,
  dagger: mct,
  Dagger: gct,
  daleth: Tct,
  darr: yct,
  Darr: _ct,
  dArr: Act,
  dash: Sct,
  Dashv: bct,
  dashv: Cct,
  dbkarow: Ict,
  dblac: Oct,
  Dcaron: Rct,
  dcaron: wct,
  Dcy: Pct,
  dcy: Dct,
  ddagger: xct,
  ddarr: Nct,
  DD: Lct,
  dd: Bct,
  DDotrahd: kct,
  ddotseq: Mct,
  deg: Fct,
  Del: Hct,
  Delta: $ct,
  delta: Uct,
  demptyv: Vct,
  dfisht: jct,
  Dfr: zct,
  dfr: qct,
  dHar: Yct,
  dharl: Gct,
  dharr: Wct,
  DiacriticalAcute: Kct,
  DiacriticalDot: Xct,
  DiacriticalDoubleAcute: Jct,
  DiacriticalGrave: Zct,
  DiacriticalTilde: Qct,
  diam: elt,
  diamond: tlt,
  Diamond: rlt,
  diamondsuit: nlt,
  diams: ilt,
  die: olt,
  DifferentialD: alt,
  digamma: ult,
  disin: slt,
  div: clt,
  divide: llt,
  divideontimes: flt,
  divonx: dlt,
  DJcy: plt,
  djcy: hlt,
  dlcorn: vlt,
  dlcrop: Elt,
  dollar: mlt,
  Dopf: glt,
  dopf: Tlt,
  Dot: ylt,
  dot: _lt,
  DotDot: Alt,
  doteq: Slt,
  doteqdot: blt,
  DotEqual: Clt,
  dotminus: Ilt,
  dotplus: Olt,
  dotsquare: Rlt,
  doublebarwedge: wlt,
  DoubleContourIntegral: Plt,
  DoubleDot: Dlt,
  DoubleDownArrow: xlt,
  DoubleLeftArrow: Nlt,
  DoubleLeftRightArrow: Llt,
  DoubleLeftTee: Blt,
  DoubleLongLeftArrow: klt,
  DoubleLongLeftRightArrow: Mlt,
  DoubleLongRightArrow: Flt,
  DoubleRightArrow: Hlt,
  DoubleRightTee: $lt,
  DoubleUpArrow: Ult,
  DoubleUpDownArrow: Vlt,
  DoubleVerticalBar: jlt,
  DownArrowBar: zlt,
  downarrow: qlt,
  DownArrow: Ylt,
  Downarrow: Glt,
  DownArrowUpArrow: Wlt,
  DownBreve: Klt,
  downdownarrows: Xlt,
  downharpoonleft: Jlt,
  downharpoonright: Zlt,
  DownLeftRightVector: Qlt,
  DownLeftTeeVector: e0t,
  DownLeftVectorBar: t0t,
  DownLeftVector: r0t,
  DownRightTeeVector: n0t,
  DownRightVectorBar: i0t,
  DownRightVector: o0t,
  DownTeeArrow: a0t,
  DownTee: u0t,
  drbkarow: s0t,
  drcorn: c0t,
  drcrop: l0t,
  Dscr: f0t,
  dscr: d0t,
  DScy: p0t,
  dscy: h0t,
  dsol: v0t,
  Dstrok: E0t,
  dstrok: m0t,
  dtdot: g0t,
  dtri: T0t,
  dtrif: y0t,
  duarr: _0t,
  duhar: A0t,
  dwangle: S0t,
  DZcy: b0t,
  dzcy: C0t,
  dzigrarr: I0t,
  Eacute: O0t,
  eacute: R0t,
  easter: w0t,
  Ecaron: P0t,
  ecaron: D0t,
  Ecirc: x0t,
  ecirc: N0t,
  ecir: L0t,
  ecolon: B0t,
  Ecy: k0t,
  ecy: M0t,
  eDDot: F0t,
  Edot: H0t,
  edot: $0t,
  eDot: U0t,
  ee: V0t,
  efDot: j0t,
  Efr: z0t,
  efr: q0t,
  eg: Y0t,
  Egrave: G0t,
  egrave: W0t,
  egs: K0t,
  egsdot: X0t,
  el: J0t,
  Element: Z0t,
  elinters: Q0t,
  ell: eft,
  els: tft,
  elsdot: rft,
  Emacr: nft,
  emacr: ift,
  empty: oft,
  emptyset: aft,
  EmptySmallSquare: uft,
  emptyv: sft,
  EmptyVerySmallSquare: cft,
  emsp13: lft,
  emsp14: fft,
  emsp: dft,
  ENG: pft,
  eng: hft,
  ensp: vft,
  Eogon: Eft,
  eogon: mft,
  Eopf: gft,
  eopf: Tft,
  epar: yft,
  eparsl: _ft,
  eplus: Aft,
  epsi: Sft,
  Epsilon: bft,
  epsilon: Cft,
  epsiv: Ift,
  eqcirc: Oft,
  eqcolon: Rft,
  eqsim: wft,
  eqslantgtr: Pft,
  eqslantless: Dft,
  Equal: xft,
  equals: Nft,
  EqualTilde: Lft,
  equest: Bft,
  Equilibrium: kft,
  equiv: Mft,
  equivDD: Fft,
  eqvparsl: Hft,
  erarr: $ft,
  erDot: Uft,
  escr: Vft,
  Escr: jft,
  esdot: zft,
  Esim: qft,
  esim: Yft,
  Eta: Gft,
  eta: Wft,
  ETH: Kft,
  eth: Xft,
  Euml: Jft,
  euml: Zft,
  euro: Qft,
  excl: edt,
  exist: tdt,
  Exists: rdt,
  expectation: ndt,
  exponentiale: idt,
  ExponentialE: odt,
  fallingdotseq: adt,
  Fcy: udt,
  fcy: sdt,
  female: cdt,
  ffilig: ldt,
  fflig: fdt,
  ffllig: ddt,
  Ffr: pdt,
  ffr: hdt,
  filig: vdt,
  FilledSmallSquare: Edt,
  FilledVerySmallSquare: mdt,
  fjlig: gdt,
  flat: Tdt,
  fllig: ydt,
  fltns: _dt,
  fnof: Adt,
  Fopf: Sdt,
  fopf: bdt,
  forall: Cdt,
  ForAll: Idt,
  fork: Odt,
  forkv: Rdt,
  Fouriertrf: wdt,
  fpartint: Pdt,
  frac12: Ddt,
  frac13: xdt,
  frac14: Ndt,
  frac15: Ldt,
  frac16: Bdt,
  frac18: kdt,
  frac23: Mdt,
  frac25: Fdt,
  frac34: Hdt,
  frac35: $dt,
  frac38: Udt,
  frac45: Vdt,
  frac56: jdt,
  frac58: zdt,
  frac78: qdt,
  frasl: Ydt,
  frown: Gdt,
  fscr: Wdt,
  Fscr: Kdt,
  gacute: Xdt,
  Gamma: Jdt,
  gamma: Zdt,
  Gammad: Qdt,
  gammad: ept,
  gap: tpt,
  Gbreve: rpt,
  gbreve: npt,
  Gcedil: ipt,
  Gcirc: opt,
  gcirc: apt,
  Gcy: upt,
  gcy: spt,
  Gdot: cpt,
  gdot: lpt,
  ge: fpt,
  gE: dpt,
  gEl: ppt,
  gel: hpt,
  geq: vpt,
  geqq: Ept,
  geqslant: mpt,
  gescc: gpt,
  ges: Tpt,
  gesdot: ypt,
  gesdoto: _pt,
  gesdotol: Apt,
  gesl: Spt,
  gesles: bpt,
  Gfr: Cpt,
  gfr: Ipt,
  gg: Opt,
  Gg: Rpt,
  ggg: wpt,
  gimel: Ppt,
  GJcy: Dpt,
  gjcy: xpt,
  gla: Npt,
  gl: Lpt,
  glE: Bpt,
  glj: kpt,
  gnap: Mpt,
  gnapprox: Fpt,
  gne: Hpt,
  gnE: $pt,
  gneq: Upt,
  gneqq: Vpt,
  gnsim: jpt,
  Gopf: zpt,
  gopf: qpt,
  grave: Ypt,
  GreaterEqual: Gpt,
  GreaterEqualLess: Wpt,
  GreaterFullEqual: Kpt,
  GreaterGreater: Xpt,
  GreaterLess: Jpt,
  GreaterSlantEqual: Zpt,
  GreaterTilde: Qpt,
  Gscr: eht,
  gscr: tht,
  gsim: rht,
  gsime: nht,
  gsiml: iht,
  gtcc: oht,
  gtcir: aht,
  gt: uht,
  GT: sht,
  Gt: cht,
  gtdot: lht,
  gtlPar: fht,
  gtquest: dht,
  gtrapprox: pht,
  gtrarr: hht,
  gtrdot: vht,
  gtreqless: Eht,
  gtreqqless: mht,
  gtrless: ght,
  gtrsim: Tht,
  gvertneqq: yht,
  gvnE: _ht,
  Hacek: Aht,
  hairsp: Sht,
  half: bht,
  hamilt: Cht,
  HARDcy: Iht,
  hardcy: Oht,
  harrcir: Rht,
  harr: wht,
  hArr: Pht,
  harrw: Dht,
  Hat: xht,
  hbar: Nht,
  Hcirc: Lht,
  hcirc: Bht,
  hearts: kht,
  heartsuit: Mht,
  hellip: Fht,
  hercon: Hht,
  hfr: $ht,
  Hfr: Uht,
  HilbertSpace: Vht,
  hksearow: jht,
  hkswarow: zht,
  hoarr: qht,
  homtht: Yht,
  hookleftarrow: Ght,
  hookrightarrow: Wht,
  hopf: Kht,
  Hopf: Xht,
  horbar: Jht,
  HorizontalLine: Zht,
  hscr: Qht,
  Hscr: evt,
  hslash: tvt,
  Hstrok: rvt,
  hstrok: nvt,
  HumpDownHump: ivt,
  HumpEqual: ovt,
  hybull: avt,
  hyphen: uvt,
  Iacute: svt,
  iacute: cvt,
  ic: lvt,
  Icirc: fvt,
  icirc: dvt,
  Icy: pvt,
  icy: hvt,
  Idot: vvt,
  IEcy: Evt,
  iecy: mvt,
  iexcl: gvt,
  iff: Tvt,
  ifr: yvt,
  Ifr: _vt,
  Igrave: Avt,
  igrave: Svt,
  ii: bvt,
  iiiint: Cvt,
  iiint: Ivt,
  iinfin: Ovt,
  iiota: Rvt,
  IJlig: wvt,
  ijlig: Pvt,
  Imacr: Dvt,
  imacr: xvt,
  image: Nvt,
  ImaginaryI: Lvt,
  imagline: Bvt,
  imagpart: kvt,
  imath: Mvt,
  Im: Fvt,
  imof: Hvt,
  imped: $vt,
  Implies: Uvt,
  incare: Vvt,
  in: "∈",
  infin: jvt,
  infintie: zvt,
  inodot: qvt,
  intcal: Yvt,
  int: Gvt,
  Int: Wvt,
  integers: Kvt,
  Integral: Xvt,
  intercal: Jvt,
  Intersection: Zvt,
  intlarhk: Qvt,
  intprod: eEt,
  InvisibleComma: tEt,
  InvisibleTimes: rEt,
  IOcy: nEt,
  iocy: iEt,
  Iogon: oEt,
  iogon: aEt,
  Iopf: uEt,
  iopf: sEt,
  Iota: cEt,
  iota: lEt,
  iprod: fEt,
  iquest: dEt,
  iscr: pEt,
  Iscr: hEt,
  isin: vEt,
  isindot: EEt,
  isinE: mEt,
  isins: gEt,
  isinsv: TEt,
  isinv: yEt,
  it: _Et,
  Itilde: AEt,
  itilde: SEt,
  Iukcy: bEt,
  iukcy: CEt,
  Iuml: IEt,
  iuml: OEt,
  Jcirc: REt,
  jcirc: wEt,
  Jcy: PEt,
  jcy: DEt,
  Jfr: xEt,
  jfr: NEt,
  jmath: LEt,
  Jopf: BEt,
  jopf: kEt,
  Jscr: MEt,
  jscr: FEt,
  Jsercy: HEt,
  jsercy: $Et,
  Jukcy: UEt,
  jukcy: VEt,
  Kappa: jEt,
  kappa: zEt,
  kappav: qEt,
  Kcedil: YEt,
  kcedil: GEt,
  Kcy: WEt,
  kcy: KEt,
  Kfr: XEt,
  kfr: JEt,
  kgreen: ZEt,
  KHcy: QEt,
  khcy: emt,
  KJcy: tmt,
  kjcy: rmt,
  Kopf: nmt,
  kopf: imt,
  Kscr: omt,
  kscr: amt,
  lAarr: umt,
  Lacute: smt,
  lacute: cmt,
  laemptyv: lmt,
  lagran: fmt,
  Lambda: dmt,
  lambda: pmt,
  lang: hmt,
  Lang: vmt,
  langd: Emt,
  langle: mmt,
  lap: gmt,
  Laplacetrf: Tmt,
  laquo: ymt,
  larrb: _mt,
  larrbfs: Amt,
  larr: Smt,
  Larr: bmt,
  lArr: Cmt,
  larrfs: Imt,
  larrhk: Omt,
  larrlp: Rmt,
  larrpl: wmt,
  larrsim: Pmt,
  larrtl: Dmt,
  latail: xmt,
  lAtail: Nmt,
  lat: Lmt,
  late: Bmt,
  lates: kmt,
  lbarr: Mmt,
  lBarr: Fmt,
  lbbrk: Hmt,
  lbrace: $mt,
  lbrack: Umt,
  lbrke: Vmt,
  lbrksld: jmt,
  lbrkslu: zmt,
  Lcaron: qmt,
  lcaron: Ymt,
  Lcedil: Gmt,
  lcedil: Wmt,
  lceil: Kmt,
  lcub: Xmt,
  Lcy: Jmt,
  lcy: Zmt,
  ldca: Qmt,
  ldquo: egt,
  ldquor: tgt,
  ldrdhar: rgt,
  ldrushar: ngt,
  ldsh: igt,
  le: ogt,
  lE: agt,
  LeftAngleBracket: ugt,
  LeftArrowBar: sgt,
  leftarrow: cgt,
  LeftArrow: lgt,
  Leftarrow: fgt,
  LeftArrowRightArrow: dgt,
  leftarrowtail: pgt,
  LeftCeiling: hgt,
  LeftDoubleBracket: vgt,
  LeftDownTeeVector: Egt,
  LeftDownVectorBar: mgt,
  LeftDownVector: ggt,
  LeftFloor: Tgt,
  leftharpoondown: ygt,
  leftharpoonup: _gt,
  leftleftarrows: Agt,
  leftrightarrow: Sgt,
  LeftRightArrow: bgt,
  Leftrightarrow: Cgt,
  leftrightarrows: Igt,
  leftrightharpoons: Ogt,
  leftrightsquigarrow: Rgt,
  LeftRightVector: wgt,
  LeftTeeArrow: Pgt,
  LeftTee: Dgt,
  LeftTeeVector: xgt,
  leftthreetimes: Ngt,
  LeftTriangleBar: Lgt,
  LeftTriangle: Bgt,
  LeftTriangleEqual: kgt,
  LeftUpDownVector: Mgt,
  LeftUpTeeVector: Fgt,
  LeftUpVectorBar: Hgt,
  LeftUpVector: $gt,
  LeftVectorBar: Ugt,
  LeftVector: Vgt,
  lEg: jgt,
  leg: zgt,
  leq: qgt,
  leqq: Ygt,
  leqslant: Ggt,
  lescc: Wgt,
  les: Kgt,
  lesdot: Xgt,
  lesdoto: Jgt,
  lesdotor: Zgt,
  lesg: Qgt,
  lesges: e1t,
  lessapprox: t1t,
  lessdot: r1t,
  lesseqgtr: n1t,
  lesseqqgtr: i1t,
  LessEqualGreater: o1t,
  LessFullEqual: a1t,
  LessGreater: u1t,
  lessgtr: s1t,
  LessLess: c1t,
  lesssim: l1t,
  LessSlantEqual: f1t,
  LessTilde: d1t,
  lfisht: p1t,
  lfloor: h1t,
  Lfr: v1t,
  lfr: E1t,
  lg: m1t,
  lgE: g1t,
  lHar: T1t,
  lhard: y1t,
  lharu: _1t,
  lharul: A1t,
  lhblk: S1t,
  LJcy: b1t,
  ljcy: C1t,
  llarr: I1t,
  ll: O1t,
  Ll: R1t,
  llcorner: w1t,
  Lleftarrow: P1t,
  llhard: D1t,
  lltri: x1t,
  Lmidot: N1t,
  lmidot: L1t,
  lmoustache: B1t,
  lmoust: k1t,
  lnap: M1t,
  lnapprox: F1t,
  lne: H1t,
  lnE: $1t,
  lneq: U1t,
  lneqq: V1t,
  lnsim: j1t,
  loang: z1t,
  loarr: q1t,
  lobrk: Y1t,
  longleftarrow: G1t,
  LongLeftArrow: W1t,
  Longleftarrow: K1t,
  longleftrightarrow: X1t,
  LongLeftRightArrow: J1t,
  Longleftrightarrow: Z1t,
  longmapsto: Q1t,
  longrightarrow: eTt,
  LongRightArrow: tTt,
  Longrightarrow: rTt,
  looparrowleft: nTt,
  looparrowright: iTt,
  lopar: oTt,
  Lopf: aTt,
  lopf: uTt,
  loplus: sTt,
  lotimes: cTt,
  lowast: lTt,
  lowbar: fTt,
  LowerLeftArrow: dTt,
  LowerRightArrow: pTt,
  loz: hTt,
  lozenge: vTt,
  lozf: ETt,
  lpar: mTt,
  lparlt: gTt,
  lrarr: TTt,
  lrcorner: yTt,
  lrhar: _Tt,
  lrhard: ATt,
  lrm: STt,
  lrtri: bTt,
  lsaquo: CTt,
  lscr: ITt,
  Lscr: OTt,
  lsh: RTt,
  Lsh: wTt,
  lsim: PTt,
  lsime: DTt,
  lsimg: xTt,
  lsqb: NTt,
  lsquo: LTt,
  lsquor: BTt,
  Lstrok: kTt,
  lstrok: MTt,
  ltcc: FTt,
  ltcir: HTt,
  lt: $Tt,
  LT: UTt,
  Lt: VTt,
  ltdot: jTt,
  lthree: zTt,
  ltimes: qTt,
  ltlarr: YTt,
  ltquest: GTt,
  ltri: WTt,
  ltrie: KTt,
  ltrif: XTt,
  ltrPar: JTt,
  lurdshar: ZTt,
  luruhar: QTt,
  lvertneqq: eyt,
  lvnE: tyt,
  macr: ryt,
  male: nyt,
  malt: iyt,
  maltese: oyt,
  Map: "⤅",
  map: ayt,
  mapsto: uyt,
  mapstodown: syt,
  mapstoleft: cyt,
  mapstoup: lyt,
  marker: fyt,
  mcomma: dyt,
  Mcy: pyt,
  mcy: hyt,
  mdash: vyt,
  mDDot: Eyt,
  measuredangle: myt,
  MediumSpace: gyt,
  Mellintrf: Tyt,
  Mfr: yyt,
  mfr: _yt,
  mho: Ayt,
  micro: Syt,
  midast: byt,
  midcir: Cyt,
  mid: Iyt,
  middot: Oyt,
  minusb: Ryt,
  minus: wyt,
  minusd: Pyt,
  minusdu: Dyt,
  MinusPlus: xyt,
  mlcp: Nyt,
  mldr: Lyt,
  mnplus: Byt,
  models: kyt,
  Mopf: Myt,
  mopf: Fyt,
  mp: Hyt,
  mscr: $yt,
  Mscr: Uyt,
  mstpos: Vyt,
  Mu: jyt,
  mu: zyt,
  multimap: qyt,
  mumap: Yyt,
  nabla: Gyt,
  Nacute: Wyt,
  nacute: Kyt,
  nang: Xyt,
  nap: Jyt,
  napE: Zyt,
  napid: Qyt,
  napos: e_t,
  napprox: t_t,
  natural: r_t,
  naturals: n_t,
  natur: i_t,
  nbsp: o_t,
  nbump: a_t,
  nbumpe: u_t,
  ncap: s_t,
  Ncaron: c_t,
  ncaron: l_t,
  Ncedil: f_t,
  ncedil: d_t,
  ncong: p_t,
  ncongdot: h_t,
  ncup: v_t,
  Ncy: E_t,
  ncy: m_t,
  ndash: g_t,
  nearhk: T_t,
  nearr: y_t,
  neArr: __t,
  nearrow: A_t,
  ne: S_t,
  nedot: b_t,
  NegativeMediumSpace: C_t,
  NegativeThickSpace: I_t,
  NegativeThinSpace: O_t,
  NegativeVeryThinSpace: R_t,
  nequiv: w_t,
  nesear: P_t,
  nesim: D_t,
  NestedGreaterGreater: x_t,
  NestedLessLess: N_t,
  NewLine: L_t,
  nexist: B_t,
  nexists: k_t,
  Nfr: M_t,
  nfr: F_t,
  ngE: H_t,
  nge: $_t,
  ngeq: U_t,
  ngeqq: V_t,
  ngeqslant: j_t,
  nges: z_t,
  nGg: q_t,
  ngsim: Y_t,
  nGt: G_t,
  ngt: W_t,
  ngtr: K_t,
  nGtv: X_t,
  nharr: J_t,
  nhArr: Z_t,
  nhpar: Q_t,
  ni: eAt,
  nis: tAt,
  nisd: rAt,
  niv: nAt,
  NJcy: iAt,
  njcy: oAt,
  nlarr: aAt,
  nlArr: uAt,
  nldr: sAt,
  nlE: cAt,
  nle: lAt,
  nleftarrow: fAt,
  nLeftarrow: dAt,
  nleftrightarrow: pAt,
  nLeftrightarrow: hAt,
  nleq: vAt,
  nleqq: EAt,
  nleqslant: mAt,
  nles: gAt,
  nless: TAt,
  nLl: yAt,
  nlsim: _At,
  nLt: AAt,
  nlt: SAt,
  nltri: bAt,
  nltrie: CAt,
  nLtv: IAt,
  nmid: OAt,
  NoBreak: RAt,
  NonBreakingSpace: wAt,
  nopf: PAt,
  Nopf: DAt,
  Not: xAt,
  not: NAt,
  NotCongruent: LAt,
  NotCupCap: BAt,
  NotDoubleVerticalBar: kAt,
  NotElement: MAt,
  NotEqual: FAt,
  NotEqualTilde: HAt,
  NotExists: $At,
  NotGreater: UAt,
  NotGreaterEqual: VAt,
  NotGreaterFullEqual: jAt,
  NotGreaterGreater: zAt,
  NotGreaterLess: qAt,
  NotGreaterSlantEqual: YAt,
  NotGreaterTilde: GAt,
  NotHumpDownHump: WAt,
  NotHumpEqual: KAt,
  notin: XAt,
  notindot: JAt,
  notinE: ZAt,
  notinva: QAt,
  notinvb: e4t,
  notinvc: t4t,
  NotLeftTriangleBar: r4t,
  NotLeftTriangle: n4t,
  NotLeftTriangleEqual: i4t,
  NotLess: o4t,
  NotLessEqual: a4t,
  NotLessGreater: u4t,
  NotLessLess: s4t,
  NotLessSlantEqual: c4t,
  NotLessTilde: l4t,
  NotNestedGreaterGreater: f4t,
  NotNestedLessLess: d4t,
  notni: p4t,
  notniva: h4t,
  notnivb: v4t,
  notnivc: E4t,
  NotPrecedes: m4t,
  NotPrecedesEqual: g4t,
  NotPrecedesSlantEqual: T4t,
  NotReverseElement: y4t,
  NotRightTriangleBar: _4t,
  NotRightTriangle: A4t,
  NotRightTriangleEqual: S4t,
  NotSquareSubset: b4t,
  NotSquareSubsetEqual: C4t,
  NotSquareSuperset: I4t,
  NotSquareSupersetEqual: O4t,
  NotSubset: R4t,
  NotSubsetEqual: w4t,
  NotSucceeds: P4t,
  NotSucceedsEqual: D4t,
  NotSucceedsSlantEqual: x4t,
  NotSucceedsTilde: N4t,
  NotSuperset: L4t,
  NotSupersetEqual: B4t,
  NotTilde: k4t,
  NotTildeEqual: M4t,
  NotTildeFullEqual: F4t,
  NotTildeTilde: H4t,
  NotVerticalBar: $4t,
  nparallel: U4t,
  npar: V4t,
  nparsl: j4t,
  npart: z4t,
  npolint: q4t,
  npr: Y4t,
  nprcue: G4t,
  nprec: W4t,
  npreceq: K4t,
  npre: X4t,
  nrarrc: J4t,
  nrarr: Z4t,
  nrArr: Q4t,
  nrarrw: eSt,
  nrightarrow: tSt,
  nRightarrow: rSt,
  nrtri: nSt,
  nrtrie: iSt,
  nsc: oSt,
  nsccue: aSt,
  nsce: uSt,
  Nscr: sSt,
  nscr: cSt,
  nshortmid: lSt,
  nshortparallel: fSt,
  nsim: dSt,
  nsime: pSt,
  nsimeq: hSt,
  nsmid: vSt,
  nspar: ESt,
  nsqsube: mSt,
  nsqsupe: gSt,
  nsub: TSt,
  nsubE: ySt,
  nsube: _St,
  nsubset: ASt,
  nsubseteq: SSt,
  nsubseteqq: bSt,
  nsucc: CSt,
  nsucceq: ISt,
  nsup: OSt,
  nsupE: RSt,
  nsupe: wSt,
  nsupset: PSt,
  nsupseteq: DSt,
  nsupseteqq: xSt,
  ntgl: NSt,
  Ntilde: LSt,
  ntilde: BSt,
  ntlg: kSt,
  ntriangleleft: MSt,
  ntrianglelefteq: FSt,
  ntriangleright: HSt,
  ntrianglerighteq: $St,
  Nu: USt,
  nu: VSt,
  num: jSt,
  numero: zSt,
  numsp: qSt,
  nvap: YSt,
  nvdash: GSt,
  nvDash: WSt,
  nVdash: KSt,
  nVDash: XSt,
  nvge: JSt,
  nvgt: ZSt,
  nvHarr: QSt,
  nvinfin: ebt,
  nvlArr: tbt,
  nvle: rbt,
  nvlt: nbt,
  nvltrie: ibt,
  nvrArr: obt,
  nvrtrie: abt,
  nvsim: ubt,
  nwarhk: sbt,
  nwarr: cbt,
  nwArr: lbt,
  nwarrow: fbt,
  nwnear: dbt,
  Oacute: pbt,
  oacute: hbt,
  oast: vbt,
  Ocirc: Ebt,
  ocirc: mbt,
  ocir: gbt,
  Ocy: Tbt,
  ocy: ybt,
  odash: _bt,
  Odblac: Abt,
  odblac: Sbt,
  odiv: bbt,
  odot: Cbt,
  odsold: Ibt,
  OElig: Obt,
  oelig: Rbt,
  ofcir: wbt,
  Ofr: Pbt,
  ofr: Dbt,
  ogon: xbt,
  Ograve: Nbt,
  ograve: Lbt,
  ogt: Bbt,
  ohbar: kbt,
  ohm: Mbt,
  oint: Fbt,
  olarr: Hbt,
  olcir: $bt,
  olcross: Ubt,
  oline: Vbt,
  olt: jbt,
  Omacr: zbt,
  omacr: qbt,
  Omega: Ybt,
  omega: Gbt,
  Omicron: Wbt,
  omicron: Kbt,
  omid: Xbt,
  ominus: Jbt,
  Oopf: Zbt,
  oopf: Qbt,
  opar: eCt,
  OpenCurlyDoubleQuote: tCt,
  OpenCurlyQuote: rCt,
  operp: nCt,
  oplus: iCt,
  orarr: oCt,
  Or: aCt,
  or: uCt,
  ord: sCt,
  order: cCt,
  orderof: lCt,
  ordf: fCt,
  ordm: dCt,
  origof: pCt,
  oror: hCt,
  orslope: vCt,
  orv: ECt,
  oS: mCt,
  Oscr: gCt,
  oscr: TCt,
  Oslash: yCt,
  oslash: _Ct,
  osol: ACt,
  Otilde: SCt,
  otilde: bCt,
  otimesas: CCt,
  Otimes: ICt,
  otimes: OCt,
  Ouml: RCt,
  ouml: wCt,
  ovbar: PCt,
  OverBar: DCt,
  OverBrace: xCt,
  OverBracket: NCt,
  OverParenthesis: LCt,
  para: BCt,
  parallel: kCt,
  par: MCt,
  parsim: FCt,
  parsl: HCt,
  part: $Ct,
  PartialD: UCt,
  Pcy: VCt,
  pcy: jCt,
  percnt: zCt,
  period: qCt,
  permil: YCt,
  perp: GCt,
  pertenk: WCt,
  Pfr: KCt,
  pfr: XCt,
  Phi: JCt,
  phi: ZCt,
  phiv: QCt,
  phmmat: e3t,
  phone: t3t,
  Pi: r3t,
  pi: n3t,
  pitchfork: i3t,
  piv: o3t,
  planck: a3t,
  planckh: u3t,
  plankv: s3t,
  plusacir: c3t,
  plusb: l3t,
  pluscir: f3t,
  plus: d3t,
  plusdo: p3t,
  plusdu: h3t,
  pluse: v3t,
  PlusMinus: E3t,
  plusmn: m3t,
  plussim: g3t,
  plustwo: T3t,
  pm: y3t,
  Poincareplane: _3t,
  pointint: A3t,
  popf: S3t,
  Popf: b3t,
  pound: C3t,
  prap: I3t,
  Pr: O3t,
  pr: R3t,
  prcue: w3t,
  precapprox: P3t,
  prec: D3t,
  preccurlyeq: x3t,
  Precedes: N3t,
  PrecedesEqual: L3t,
  PrecedesSlantEqual: B3t,
  PrecedesTilde: k3t,
  preceq: M3t,
  precnapprox: F3t,
  precneqq: H3t,
  precnsim: $3t,
  pre: U3t,
  prE: V3t,
  precsim: j3t,
  prime: z3t,
  Prime: q3t,
  primes: Y3t,
  prnap: G3t,
  prnE: W3t,
  prnsim: K3t,
  prod: X3t,
  Product: J3t,
  profalar: Z3t,
  profline: Q3t,
  profsurf: e2t,
  prop: t2t,
  Proportional: r2t,
  Proportion: n2t,
  propto: i2t,
  prsim: o2t,
  prurel: a2t,
  Pscr: u2t,
  pscr: s2t,
  Psi: c2t,
  psi: l2t,
  puncsp: f2t,
  Qfr: d2t,
  qfr: p2t,
  qint: h2t,
  qopf: v2t,
  Qopf: E2t,
  qprime: m2t,
  Qscr: g2t,
  qscr: T2t,
  quaternions: y2t,
  quatint: _2t,
  quest: A2t,
  questeq: S2t,
  quot: b2t,
  QUOT: C2t,
  rAarr: I2t,
  race: O2t,
  Racute: R2t,
  racute: w2t,
  radic: P2t,
  raemptyv: D2t,
  rang: x2t,
  Rang: N2t,
  rangd: L2t,
  range: B2t,
  rangle: k2t,
  raquo: M2t,
  rarrap: F2t,
  rarrb: H2t,
  rarrbfs: $2t,
  rarrc: U2t,
  rarr: V2t,
  Rarr: j2t,
  rArr: z2t,
  rarrfs: q2t,
  rarrhk: Y2t,
  rarrlp: G2t,
  rarrpl: W2t,
  rarrsim: K2t,
  Rarrtl: X2t,
  rarrtl: J2t,
  rarrw: Z2t,
  ratail: Q2t,
  rAtail: eIt,
  ratio: tIt,
  rationals: rIt,
  rbarr: nIt,
  rBarr: iIt,
  RBarr: oIt,
  rbbrk: aIt,
  rbrace: uIt,
  rbrack: sIt,
  rbrke: cIt,
  rbrksld: lIt,
  rbrkslu: fIt,
  Rcaron: dIt,
  rcaron: pIt,
  Rcedil: hIt,
  rcedil: vIt,
  rceil: EIt,
  rcub: mIt,
  Rcy: gIt,
  rcy: TIt,
  rdca: yIt,
  rdldhar: _It,
  rdquo: AIt,
  rdquor: SIt,
  rdsh: bIt,
  real: CIt,
  realine: IIt,
  realpart: OIt,
  reals: RIt,
  Re: wIt,
  rect: PIt,
  reg: DIt,
  REG: xIt,
  ReverseElement: NIt,
  ReverseEquilibrium: LIt,
  ReverseUpEquilibrium: BIt,
  rfisht: kIt,
  rfloor: MIt,
  rfr: FIt,
  Rfr: HIt,
  rHar: $It,
  rhard: UIt,
  rharu: VIt,
  rharul: jIt,
  Rho: zIt,
  rho: qIt,
  rhov: YIt,
  RightAngleBracket: GIt,
  RightArrowBar: WIt,
  rightarrow: KIt,
  RightArrow: XIt,
  Rightarrow: JIt,
  RightArrowLeftArrow: ZIt,
  rightarrowtail: QIt,
  RightCeiling: eOt,
  RightDoubleBracket: tOt,
  RightDownTeeVector: rOt,
  RightDownVectorBar: nOt,
  RightDownVector: iOt,
  RightFloor: oOt,
  rightharpoondown: aOt,
  rightharpoonup: uOt,
  rightleftarrows: sOt,
  rightleftharpoons: cOt,
  rightrightarrows: lOt,
  rightsquigarrow: fOt,
  RightTeeArrow: dOt,
  RightTee: pOt,
  RightTeeVector: hOt,
  rightthreetimes: vOt,
  RightTriangleBar: EOt,
  RightTriangle: mOt,
  RightTriangleEqual: gOt,
  RightUpDownVector: TOt,
  RightUpTeeVector: yOt,
  RightUpVectorBar: _Ot,
  RightUpVector: AOt,
  RightVectorBar: SOt,
  RightVector: bOt,
  ring: COt,
  risingdotseq: IOt,
  rlarr: OOt,
  rlhar: ROt,
  rlm: wOt,
  rmoustache: POt,
  rmoust: DOt,
  rnmid: xOt,
  roang: NOt,
  roarr: LOt,
  robrk: BOt,
  ropar: kOt,
  ropf: MOt,
  Ropf: FOt,
  roplus: HOt,
  rotimes: $Ot,
  RoundImplies: UOt,
  rpar: VOt,
  rpargt: jOt,
  rppolint: zOt,
  rrarr: qOt,
  Rrightarrow: YOt,
  rsaquo: GOt,
  rscr: WOt,
  Rscr: KOt,
  rsh: XOt,
  Rsh: JOt,
  rsqb: ZOt,
  rsquo: QOt,
  rsquor: eRt,
  rthree: tRt,
  rtimes: rRt,
  rtri: nRt,
  rtrie: iRt,
  rtrif: oRt,
  rtriltri: aRt,
  RuleDelayed: uRt,
  ruluhar: sRt,
  rx: cRt,
  Sacute: lRt,
  sacute: fRt,
  sbquo: dRt,
  scap: pRt,
  Scaron: hRt,
  scaron: vRt,
  Sc: ERt,
  sc: mRt,
  sccue: gRt,
  sce: TRt,
  scE: yRt,
  Scedil: _Rt,
  scedil: ARt,
  Scirc: SRt,
  scirc: bRt,
  scnap: CRt,
  scnE: IRt,
  scnsim: ORt,
  scpolint: RRt,
  scsim: wRt,
  Scy: PRt,
  scy: DRt,
  sdotb: xRt,
  sdot: NRt,
  sdote: LRt,
  searhk: BRt,
  searr: kRt,
  seArr: MRt,
  searrow: FRt,
  sect: HRt,
  semi: $Rt,
  seswar: URt,
  setminus: VRt,
  setmn: jRt,
  sext: zRt,
  Sfr: qRt,
  sfr: YRt,
  sfrown: GRt,
  sharp: WRt,
  SHCHcy: KRt,
  shchcy: XRt,
  SHcy: JRt,
  shcy: ZRt,
  ShortDownArrow: QRt,
  ShortLeftArrow: ewt,
  shortmid: twt,
  shortparallel: rwt,
  ShortRightArrow: nwt,
  ShortUpArrow: iwt,
  shy: owt,
  Sigma: awt,
  sigma: uwt,
  sigmaf: swt,
  sigmav: cwt,
  sim: lwt,
  simdot: fwt,
  sime: dwt,
  simeq: pwt,
  simg: hwt,
  simgE: vwt,
  siml: Ewt,
  simlE: mwt,
  simne: gwt,
  simplus: Twt,
  simrarr: ywt,
  slarr: _wt,
  SmallCircle: Awt,
  smallsetminus: Swt,
  smashp: bwt,
  smeparsl: Cwt,
  smid: Iwt,
  smile: Owt,
  smt: Rwt,
  smte: wwt,
  smtes: Pwt,
  SOFTcy: Dwt,
  softcy: xwt,
  solbar: Nwt,
  solb: Lwt,
  sol: Bwt,
  Sopf: kwt,
  sopf: Mwt,
  spades: Fwt,
  spadesuit: Hwt,
  spar: $wt,
  sqcap: Uwt,
  sqcaps: Vwt,
  sqcup: jwt,
  sqcups: zwt,
  Sqrt: qwt,
  sqsub: Ywt,
  sqsube: Gwt,
  sqsubset: Wwt,
  sqsubseteq: Kwt,
  sqsup: Xwt,
  sqsupe: Jwt,
  sqsupset: Zwt,
  sqsupseteq: Qwt,
  square: ePt,
  Square: tPt,
  SquareIntersection: rPt,
  SquareSubset: nPt,
  SquareSubsetEqual: iPt,
  SquareSuperset: oPt,
  SquareSupersetEqual: aPt,
  SquareUnion: uPt,
  squarf: sPt,
  squ: cPt,
  squf: lPt,
  srarr: fPt,
  Sscr: dPt,
  sscr: pPt,
  ssetmn: hPt,
  ssmile: vPt,
  sstarf: EPt,
  Star: mPt,
  star: gPt,
  starf: TPt,
  straightepsilon: yPt,
  straightphi: _Pt,
  strns: APt,
  sub: SPt,
  Sub: bPt,
  subdot: CPt,
  subE: IPt,
  sube: OPt,
  subedot: RPt,
  submult: wPt,
  subnE: PPt,
  subne: DPt,
  subplus: xPt,
  subrarr: NPt,
  subset: LPt,
  Subset: BPt,
  subseteq: kPt,
  subseteqq: MPt,
  SubsetEqual: FPt,
  subsetneq: HPt,
  subsetneqq: $Pt,
  subsim: UPt,
  subsub: VPt,
  subsup: jPt,
  succapprox: zPt,
  succ: qPt,
  succcurlyeq: YPt,
  Succeeds: GPt,
  SucceedsEqual: WPt,
  SucceedsSlantEqual: KPt,
  SucceedsTilde: XPt,
  succeq: JPt,
  succnapprox: ZPt,
  succneqq: QPt,
  succnsim: e6t,
  succsim: t6t,
  SuchThat: r6t,
  sum: n6t,
  Sum: i6t,
  sung: o6t,
  sup1: a6t,
  sup2: u6t,
  sup3: s6t,
  sup: c6t,
  Sup: l6t,
  supdot: f6t,
  supdsub: d6t,
  supE: p6t,
  supe: h6t,
  supedot: v6t,
  Superset: E6t,
  SupersetEqual: m6t,
  suphsol: g6t,
  suphsub: T6t,
  suplarr: y6t,
  supmult: _6t,
  supnE: A6t,
  supne: S6t,
  supplus: b6t,
  supset: C6t,
  Supset: I6t,
  supseteq: O6t,
  supseteqq: R6t,
  supsetneq: w6t,
  supsetneqq: P6t,
  supsim: D6t,
  supsub: x6t,
  supsup: N6t,
  swarhk: L6t,
  swarr: B6t,
  swArr: k6t,
  swarrow: M6t,
  swnwar: F6t,
  szlig: H6t,
  Tab: $6t,
  target: U6t,
  Tau: V6t,
  tau: j6t,
  tbrk: z6t,
  Tcaron: q6t,
  tcaron: Y6t,
  Tcedil: G6t,
  tcedil: W6t,
  Tcy: K6t,
  tcy: X6t,
  tdot: J6t,
  telrec: Z6t,
  Tfr: Q6t,
  tfr: eDt,
  there4: tDt,
  therefore: rDt,
  Therefore: nDt,
  Theta: iDt,
  theta: oDt,
  thetasym: aDt,
  thetav: uDt,
  thickapprox: sDt,
  thicksim: cDt,
  ThickSpace: lDt,
  ThinSpace: fDt,
  thinsp: dDt,
  thkap: pDt,
  thksim: hDt,
  THORN: vDt,
  thorn: EDt,
  tilde: mDt,
  Tilde: gDt,
  TildeEqual: TDt,
  TildeFullEqual: yDt,
  TildeTilde: _Dt,
  timesbar: ADt,
  timesb: SDt,
  times: bDt,
  timesd: CDt,
  tint: IDt,
  toea: ODt,
  topbot: RDt,
  topcir: wDt,
  top: PDt,
  Topf: DDt,
  topf: xDt,
  topfork: NDt,
  tosa: LDt,
  tprime: BDt,
  trade: kDt,
  TRADE: MDt,
  triangle: FDt,
  triangledown: HDt,
  triangleleft: $Dt,
  trianglelefteq: UDt,
  triangleq: VDt,
  triangleright: jDt,
  trianglerighteq: zDt,
  tridot: qDt,
  trie: YDt,
  triminus: GDt,
  TripleDot: WDt,
  triplus: KDt,
  trisb: XDt,
  tritime: JDt,
  trpezium: ZDt,
  Tscr: QDt,
  tscr: ext,
  TScy: txt,
  tscy: rxt,
  TSHcy: nxt,
  tshcy: ixt,
  Tstrok: oxt,
  tstrok: axt,
  twixt: uxt,
  twoheadleftarrow: sxt,
  twoheadrightarrow: cxt,
  Uacute: lxt,
  uacute: fxt,
  uarr: dxt,
  Uarr: pxt,
  uArr: hxt,
  Uarrocir: vxt,
  Ubrcy: Ext,
  ubrcy: mxt,
  Ubreve: gxt,
  ubreve: Txt,
  Ucirc: yxt,
  ucirc: _xt,
  Ucy: Axt,
  ucy: Sxt,
  udarr: bxt,
  Udblac: Cxt,
  udblac: Ixt,
  udhar: Oxt,
  ufisht: Rxt,
  Ufr: wxt,
  ufr: Pxt,
  Ugrave: Dxt,
  ugrave: xxt,
  uHar: Nxt,
  uharl: Lxt,
  uharr: Bxt,
  uhblk: kxt,
  ulcorn: Mxt,
  ulcorner: Fxt,
  ulcrop: Hxt,
  ultri: $xt,
  Umacr: Uxt,
  umacr: Vxt,
  uml: jxt,
  UnderBar: zxt,
  UnderBrace: qxt,
  UnderBracket: Yxt,
  UnderParenthesis: Gxt,
  Union: Wxt,
  UnionPlus: Kxt,
  Uogon: Xxt,
  uogon: Jxt,
  Uopf: Zxt,
  uopf: Qxt,
  UpArrowBar: eNt,
  uparrow: tNt,
  UpArrow: rNt,
  Uparrow: nNt,
  UpArrowDownArrow: iNt,
  updownarrow: oNt,
  UpDownArrow: aNt,
  Updownarrow: uNt,
  UpEquilibrium: sNt,
  upharpoonleft: cNt,
  upharpoonright: lNt,
  uplus: fNt,
  UpperLeftArrow: dNt,
  UpperRightArrow: pNt,
  upsi: hNt,
  Upsi: vNt,
  upsih: ENt,
  Upsilon: mNt,
  upsilon: gNt,
  UpTeeArrow: TNt,
  UpTee: yNt,
  upuparrows: _Nt,
  urcorn: ANt,
  urcorner: SNt,
  urcrop: bNt,
  Uring: CNt,
  uring: INt,
  urtri: ONt,
  Uscr: RNt,
  uscr: wNt,
  utdot: PNt,
  Utilde: DNt,
  utilde: xNt,
  utri: NNt,
  utrif: LNt,
  uuarr: BNt,
  Uuml: kNt,
  uuml: MNt,
  uwangle: FNt,
  vangrt: HNt,
  varepsilon: $Nt,
  varkappa: UNt,
  varnothing: VNt,
  varphi: jNt,
  varpi: zNt,
  varpropto: qNt,
  varr: YNt,
  vArr: GNt,
  varrho: WNt,
  varsigma: KNt,
  varsubsetneq: XNt,
  varsubsetneqq: JNt,
  varsupsetneq: ZNt,
  varsupsetneqq: QNt,
  vartheta: e5t,
  vartriangleleft: t5t,
  vartriangleright: r5t,
  vBar: n5t,
  Vbar: i5t,
  vBarv: o5t,
  Vcy: a5t,
  vcy: u5t,
  vdash: s5t,
  vDash: c5t,
  Vdash: l5t,
  VDash: f5t,
  Vdashl: d5t,
  veebar: p5t,
  vee: h5t,
  Vee: v5t,
  veeeq: E5t,
  vellip: m5t,
  verbar: g5t,
  Verbar: T5t,
  vert: y5t,
  Vert: _5t,
  VerticalBar: A5t,
  VerticalLine: S5t,
  VerticalSeparator: b5t,
  VerticalTilde: C5t,
  VeryThinSpace: I5t,
  Vfr: O5t,
  vfr: R5t,
  vltri: w5t,
  vnsub: P5t,
  vnsup: D5t,
  Vopf: x5t,
  vopf: N5t,
  vprop: L5t,
  vrtri: B5t,
  Vscr: k5t,
  vscr: M5t,
  vsubnE: F5t,
  vsubne: H5t,
  vsupnE: $5t,
  vsupne: U5t,
  Vvdash: V5t,
  vzigzag: j5t,
  Wcirc: z5t,
  wcirc: q5t,
  wedbar: Y5t,
  wedge: G5t,
  Wedge: W5t,
  wedgeq: K5t,
  weierp: X5t,
  Wfr: J5t,
  wfr: Z5t,
  Wopf: Q5t,
  wopf: eLt,
  wp: tLt,
  wr: rLt,
  wreath: nLt,
  Wscr: iLt,
  wscr: oLt,
  xcap: aLt,
  xcirc: uLt,
  xcup: sLt,
  xdtri: cLt,
  Xfr: lLt,
  xfr: fLt,
  xharr: dLt,
  xhArr: pLt,
  Xi: hLt,
  xi: vLt,
  xlarr: ELt,
  xlArr: mLt,
  xmap: gLt,
  xnis: TLt,
  xodot: yLt,
  Xopf: _Lt,
  xopf: ALt,
  xoplus: SLt,
  xotime: bLt,
  xrarr: CLt,
  xrArr: ILt,
  Xscr: OLt,
  xscr: RLt,
  xsqcup: wLt,
  xuplus: PLt,
  xutri: DLt,
  xvee: xLt,
  xwedge: NLt,
  Yacute: LLt,
  yacute: BLt,
  YAcy: kLt,
  yacy: MLt,
  Ycirc: FLt,
  ycirc: HLt,
  Ycy: $Lt,
  ycy: ULt,
  yen: VLt,
  Yfr: jLt,
  yfr: zLt,
  YIcy: qLt,
  yicy: YLt,
  Yopf: GLt,
  yopf: WLt,
  Yscr: KLt,
  yscr: XLt,
  YUcy: JLt,
  yucy: ZLt,
  yuml: QLt,
  Yuml: eBt,
  Zacute: tBt,
  zacute: rBt,
  Zcaron: nBt,
  zcaron: iBt,
  Zcy: oBt,
  zcy: aBt,
  Zdot: uBt,
  zdot: sBt,
  zeetrf: cBt,
  ZeroWidthSpace: lBt,
  Zeta: fBt,
  zeta: dBt,
  zfr: pBt,
  Zfr: hBt,
  ZHcy: vBt,
  zhcy: EBt,
  zigrarr: mBt,
  zopf: gBt,
  Zopf: TBt,
  Zscr: yBt,
  zscr: _Bt,
  zwj: ABt,
  zwnj: SBt
};
var qhe = bBt, G9 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, Bh = {}, nG = {};
function CBt(e) {
  var t, r, n = nG[e];
  if (n)
    return n;
  for (n = nG[e] = [], t = 0; t < 128; t++)
    r = String.fromCharCode(t), /^[0-9a-z]$/i.test(r) ? n.push(r) : n.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  for (t = 0; t < e.length; t++)
    n[e.charCodeAt(t)] = e[t];
  return n;
}
function SC(e, t, r) {
  var n, i, o, a, u, s = "";
  for (typeof t != "string" && (r = t, t = SC.defaultChars), typeof r > "u" && (r = !0), u = CBt(t), n = 0, i = e.length; n < i; n++) {
    if (o = e.charCodeAt(n), r && o === 37 && n + 2 < i && /^[0-9a-f]{2}$/i.test(e.slice(n + 1, n + 3))) {
      s += e.slice(n, n + 3), n += 2;
      continue;
    }
    if (o < 128) {
      s += u[o];
      continue;
    }
    if (o >= 55296 && o <= 57343) {
      if (o >= 55296 && o <= 56319 && n + 1 < i && (a = e.charCodeAt(n + 1), a >= 56320 && a <= 57343)) {
        s += encodeURIComponent(e[n] + e[n + 1]), n++;
        continue;
      }
      s += "%EF%BF%BD";
      continue;
    }
    s += encodeURIComponent(e[n]);
  }
  return s;
}
SC.defaultChars = ";/?:@&=+$,-_.!~*'()#";
SC.componentChars = "-_.!~*'()";
var IBt = SC, iG = {};
function OBt(e) {
  var t, r, n = iG[e];
  if (n)
    return n;
  for (n = iG[e] = [], t = 0; t < 128; t++)
    r = String.fromCharCode(t), n.push(r);
  for (t = 0; t < e.length; t++)
    r = e.charCodeAt(t), n[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  return n;
}
function bC(e, t) {
  var r;
  return typeof t != "string" && (t = bC.defaultChars), r = OBt(t), e.replace(/(%[a-f0-9]{2})+/gi, function(n) {
    var i, o, a, u, s, c, l, f = "";
    for (i = 0, o = n.length; i < o; i += 3) {
      if (a = parseInt(n.slice(i + 1, i + 3), 16), a < 128) {
        f += r[a];
        continue;
      }
      if ((a & 224) === 192 && i + 3 < o && (u = parseInt(n.slice(i + 4, i + 6), 16), (u & 192) === 128)) {
        l = a << 6 & 1984 | u & 63, l < 128 ? f += "��" : f += String.fromCharCode(l), i += 3;
        continue;
      }
      if ((a & 240) === 224 && i + 6 < o && (u = parseInt(n.slice(i + 4, i + 6), 16), s = parseInt(n.slice(i + 7, i + 9), 16), (u & 192) === 128 && (s & 192) === 128)) {
        l = a << 12 & 61440 | u << 6 & 4032 | s & 63, l < 2048 || l >= 55296 && l <= 57343 ? f += "���" : f += String.fromCharCode(l), i += 6;
        continue;
      }
      if ((a & 248) === 240 && i + 9 < o && (u = parseInt(n.slice(i + 4, i + 6), 16), s = parseInt(n.slice(i + 7, i + 9), 16), c = parseInt(n.slice(i + 10, i + 12), 16), (u & 192) === 128 && (s & 192) === 128 && (c & 192) === 128)) {
        l = a << 18 & 1835008 | u << 12 & 258048 | s << 6 & 4032 | c & 63, l < 65536 || l > 1114111 ? f += "����" : (l -= 65536, f += String.fromCharCode(55296 + (l >> 10), 56320 + (l & 1023))), i += 9;
        continue;
      }
      f += "�";
    }
    return f;
  });
}
bC.defaultChars = ";/?:@&=+$,#";
bC.componentChars = "";
var RBt = bC, wBt = function(t) {
  var r = "";
  return r += t.protocol || "", r += t.slashes ? "//" : "", r += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? r += "[" + t.hostname + "]" : r += t.hostname || "", r += t.port ? ":" + t.port : "", r += t.pathname || "", r += t.search || "", r += t.hash || "", r;
};
function wS() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
var PBt = /^([a-z0-9.+-]+:)/i, DBt = /:[0-9]*$/, xBt = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, NBt = ["<", ">", '"', "`", " ", "\r", `
`, "	"], LBt = ["{", "}", "|", "\\", "^", "`"].concat(NBt), BBt = ["'"].concat(LBt), oG = ["%", "/", "?", ";", "#"].concat(BBt), aG = ["/", "?", "#"], kBt = 255, uG = /^[+a-z0-9A-Z_-]{0,63}$/, MBt = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, sG = {
  javascript: !0,
  "javascript:": !0
}, cG = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function FBt(e, t) {
  if (e && e instanceof wS)
    return e;
  var r = new wS();
  return r.parse(e, t), r;
}
wS.prototype.parse = function(e, t) {
  var r, n, i, o, a, u = e;
  if (u = u.trim(), !t && e.split("#").length === 1) {
    var s = xBt.exec(u);
    if (s)
      return this.pathname = s[1], s[2] && (this.search = s[2]), this;
  }
  var c = PBt.exec(u);
  if (c && (c = c[0], i = c.toLowerCase(), this.protocol = c, u = u.substr(c.length)), (t || c || u.match(/^\/\/[^@\/]+@[^@\/]+/)) && (a = u.substr(0, 2) === "//", a && !(c && sG[c]) && (u = u.substr(2), this.slashes = !0)), !sG[c] && (a || c && !cG[c])) {
    var l = -1;
    for (r = 0; r < aG.length; r++)
      o = u.indexOf(aG[r]), o !== -1 && (l === -1 || o < l) && (l = o);
    var f, d;
    for (l === -1 ? d = u.lastIndexOf("@") : d = u.lastIndexOf("@", l), d !== -1 && (f = u.slice(0, d), u = u.slice(d + 1), this.auth = f), l = -1, r = 0; r < oG.length; r++)
      o = u.indexOf(oG[r]), o !== -1 && (l === -1 || o < l) && (l = o);
    l === -1 && (l = u.length), u[l - 1] === ":" && l--;
    var p = u.slice(0, l);
    u = u.slice(l), this.parseHost(p), this.hostname = this.hostname || "";
    var v = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!v) {
      var h = this.hostname.split(/\./);
      for (r = 0, n = h.length; r < n; r++) {
        var E = h[r];
        if (E && !E.match(uG)) {
          for (var m = "", g = 0, y = E.length; g < y; g++)
            E.charCodeAt(g) > 127 ? m += "x" : m += E[g];
          if (!m.match(uG)) {
            var _ = h.slice(0, r), S = h.slice(r + 1), A = E.match(MBt);
            A && (_.push(A[1]), S.unshift(A[2])), S.length && (u = S.join(".") + u), this.hostname = _.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > kBt && (this.hostname = ""), v && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  var O = u.indexOf("#");
  O !== -1 && (this.hash = u.substr(O), u = u.slice(0, O));
  var P = u.indexOf("?");
  return P !== -1 && (this.search = u.substr(P), u = u.slice(0, P)), u && (this.pathname = u), cG[i] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
wS.prototype.parseHost = function(e) {
  var t = DBt.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
var HBt = FBt;
Bh.encode = IBt;
Bh.decode = RBt;
Bh.format = wBt;
Bh.parse = HBt;
var P0 = {}, AR, lG;
function Yhe() {
  return lG || (lG = 1, AR = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), AR;
}
var SR, fG;
function Ghe() {
  return fG || (fG = 1, SR = /[\0-\x1F\x7F-\x9F]/), SR;
}
var bR, dG;
function $Bt() {
  return dG || (dG = 1, bR = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), bR;
}
var CR, pG;
function Whe() {
  return pG || (pG = 1, CR = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), CR;
}
var hG;
function UBt() {
  return hG || (hG = 1, P0.Any = Yhe(), P0.Cc = Ghe(), P0.Cf = $Bt(), P0.P = G9, P0.Z = Whe()), P0;
}
(function(e) {
  function t(x) {
    return Object.prototype.toString.call(x);
  }
  function r(x) {
    return t(x) === "[object String]";
  }
  var n = Object.prototype.hasOwnProperty;
  function i(x, D) {
    return n.call(x, D);
  }
  function o(x) {
    var D = Array.prototype.slice.call(arguments, 1);
    return D.forEach(function(w) {
      if (w) {
        if (typeof w != "object")
          throw new TypeError(w + "must be object");
        Object.keys(w).forEach(function($) {
          x[$] = w[$];
        });
      }
    }), x;
  }
  function a(x, D, w) {
    return [].concat(x.slice(0, D), w, x.slice(D + 1));
  }
  function u(x) {
    return !(x >= 55296 && x <= 57343 || x >= 64976 && x <= 65007 || (x & 65535) === 65535 || (x & 65535) === 65534 || x >= 0 && x <= 8 || x === 11 || x >= 14 && x <= 31 || x >= 127 && x <= 159 || x > 1114111);
  }
  function s(x) {
    if (x > 65535) {
      x -= 65536;
      var D = 55296 + (x >> 10), w = 56320 + (x & 1023);
      return String.fromCharCode(D, w);
    }
    return String.fromCharCode(x);
  }
  var c = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, l = /&([a-z#][a-z0-9]{1,31});/gi, f = new RegExp(c.source + "|" + l.source, "gi"), d = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i, p = qhe;
  function v(x, D) {
    var w;
    return i(p, D) ? p[D] : D.charCodeAt(0) === 35 && d.test(D) && (w = D[1].toLowerCase() === "x" ? parseInt(D.slice(2), 16) : parseInt(D.slice(1), 10), u(w)) ? s(w) : x;
  }
  function h(x) {
    return x.indexOf("\\") < 0 ? x : x.replace(c, "$1");
  }
  function E(x) {
    return x.indexOf("\\") < 0 && x.indexOf("&") < 0 ? x : x.replace(f, function(D, w, $) {
      return w || v(D, $);
    });
  }
  var m = /[&<>"]/, g = /[&<>"]/g, y = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
  };
  function _(x) {
    return y[x];
  }
  function S(x) {
    return m.test(x) ? x.replace(g, _) : x;
  }
  var A = /[.?*+^$[\]\\(){}|-]/g;
  function O(x) {
    return x.replace(A, "\\$&");
  }
  function P(x) {
    switch (x) {
      case 9:
      case 32:
        return !0;
    }
    return !1;
  }
  function U(x) {
    if (x >= 8192 && x <= 8202)
      return !0;
    switch (x) {
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 32:
      case 160:
      case 5760:
      case 8239:
      case 8287:
      case 12288:
        return !0;
    }
    return !1;
  }
  var z = G9;
  function k(x) {
    return z.test(x);
  }
  function H(x) {
    switch (x) {
      case 33:
      case 34:
      case 35:
      case 36:
      case 37:
      case 38:
      case 39:
      case 40:
      case 41:
      case 42:
      case 43:
      case 44:
      case 45:
      case 46:
      case 47:
      case 58:
      case 59:
      case 60:
      case 61:
      case 62:
      case 63:
      case 64:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 123:
      case 124:
      case 125:
      case 126:
        return !0;
      default:
        return !1;
    }
  }
  function B(x) {
    return x = x.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (x = x.replace(/ẞ/g, "ß")), x.toLowerCase().toUpperCase();
  }
  e.lib = {}, e.lib.mdurl = Bh, e.lib.ucmicro = UBt(), e.assign = o, e.isString = r, e.has = i, e.unescapeMd = h, e.unescapeAll = E, e.isValidEntityCode = u, e.fromCodePoint = s, e.escapeHtml = S, e.arrayReplaceAt = a, e.isSpace = P, e.isWhiteSpace = U, e.isMdAsciiPunct = H, e.isPunctChar = k, e.escapeRE = O, e.normalizeReference = B;
})(Cn);
var CC = {}, VBt = function(t, r, n) {
  var i, o, a, u, s = -1, c = t.posMax, l = t.pos;
  for (t.pos = r + 1, i = 1; t.pos < c; ) {
    if (a = t.src.charCodeAt(t.pos), a === 93 && (i--, i === 0)) {
      o = !0;
      break;
    }
    if (u = t.pos, t.md.inline.skipToken(t), a === 91) {
      if (u === t.pos - 1)
        i++;
      else if (n)
        return t.pos = l, -1;
    }
  }
  return o && (s = t.pos), t.pos = l, s;
}, vG = Cn.unescapeAll, jBt = function(t, r, n) {
  var i, o, a = r, u = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (t.charCodeAt(a) === 60) {
    for (a++; a < n; ) {
      if (i = t.charCodeAt(a), i === 10 || i === 60)
        return u;
      if (i === 62)
        return u.pos = a + 1, u.str = vG(t.slice(r + 1, a)), u.ok = !0, u;
      if (i === 92 && a + 1 < n) {
        a += 2;
        continue;
      }
      a++;
    }
    return u;
  }
  for (o = 0; a < n && (i = t.charCodeAt(a), !(i === 32 || i < 32 || i === 127)); ) {
    if (i === 92 && a + 1 < n) {
      if (t.charCodeAt(a + 1) === 32)
        break;
      a += 2;
      continue;
    }
    if (i === 40 && (o++, o > 32))
      return u;
    if (i === 41) {
      if (o === 0)
        break;
      o--;
    }
    a++;
  }
  return r === a || o !== 0 || (u.str = vG(t.slice(r, a)), u.pos = a, u.ok = !0), u;
}, zBt = Cn.unescapeAll, qBt = function(t, r, n) {
  var i, o, a = 0, u = r, s = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (u >= n || (o = t.charCodeAt(u), o !== 34 && o !== 39 && o !== 40))
    return s;
  for (u++, o === 40 && (o = 41); u < n; ) {
    if (i = t.charCodeAt(u), i === o)
      return s.pos = u + 1, s.lines = a, s.str = zBt(t.slice(r + 1, u)), s.ok = !0, s;
    if (i === 40 && o === 41)
      return s;
    i === 10 ? a++ : i === 92 && u + 1 < n && (u++, t.charCodeAt(u) === 10 && a++), u++;
  }
  return s;
};
CC.parseLinkLabel = VBt;
CC.parseLinkDestination = jBt;
CC.parseLinkTitle = qBt;
var YBt = Cn.assign, GBt = Cn.unescapeAll, Df = Cn.escapeHtml, sc = {};
sc.code_inline = function(e, t, r, n, i) {
  var o = e[t];
  return "<code" + i.renderAttrs(o) + ">" + Df(o.content) + "</code>";
};
sc.code_block = function(e, t, r, n, i) {
  var o = e[t];
  return "<pre" + i.renderAttrs(o) + "><code>" + Df(e[t].content) + `</code></pre>
`;
};
sc.fence = function(e, t, r, n, i) {
  var o = e[t], a = o.info ? GBt(o.info).trim() : "", u = "", s = "", c, l, f, d, p;
  return a && (f = a.split(/(\s+)/g), u = f[0], s = f.slice(2).join("")), r.highlight ? c = r.highlight(o.content, u, s) || Df(o.content) : c = Df(o.content), c.indexOf("<pre") === 0 ? c + `
` : a ? (l = o.attrIndex("class"), d = o.attrs ? o.attrs.slice() : [], l < 0 ? d.push(["class", r.langPrefix + u]) : (d[l] = d[l].slice(), d[l][1] += " " + r.langPrefix + u), p = {
    attrs: d
  }, "<pre><code" + i.renderAttrs(p) + ">" + c + `</code></pre>
`) : "<pre><code" + i.renderAttrs(o) + ">" + c + `</code></pre>
`;
};
sc.image = function(e, t, r, n, i) {
  var o = e[t];
  return o.attrs[o.attrIndex("alt")][1] = i.renderInlineAsText(o.children, r, n), i.renderToken(e, t, r);
};
sc.hardbreak = function(e, t, r) {
  return r.xhtmlOut ? `<br />
` : `<br>
`;
};
sc.softbreak = function(e, t, r) {
  return r.breaks ? r.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
sc.text = function(e, t) {
  return Df(e[t].content);
};
sc.html_block = function(e, t) {
  return e[t].content;
};
sc.html_inline = function(e, t) {
  return e[t].content;
};
function kh() {
  this.rules = YBt({}, sc);
}
kh.prototype.renderAttrs = function(t) {
  var r, n, i;
  if (!t.attrs)
    return "";
  for (i = "", r = 0, n = t.attrs.length; r < n; r++)
    i += " " + Df(t.attrs[r][0]) + '="' + Df(t.attrs[r][1]) + '"';
  return i;
};
kh.prototype.renderToken = function(t, r, n) {
  var i, o = "", a = !1, u = t[r];
  return u.hidden ? "" : (u.block && u.nesting !== -1 && r && t[r - 1].hidden && (o += `
`), o += (u.nesting === -1 ? "</" : "<") + u.tag, o += this.renderAttrs(u), u.nesting === 0 && n.xhtmlOut && (o += " /"), u.block && (a = !0, u.nesting === 1 && r + 1 < t.length && (i = t[r + 1], (i.type === "inline" || i.hidden || i.nesting === -1 && i.tag === u.tag) && (a = !1))), o += a ? `>
` : ">", o);
};
kh.prototype.renderInline = function(e, t, r) {
  for (var n, i = "", o = this.rules, a = 0, u = e.length; a < u; a++)
    n = e[a].type, typeof o[n] < "u" ? i += o[n](e, a, t, r, this) : i += this.renderToken(e, a, t);
  return i;
};
kh.prototype.renderInlineAsText = function(e, t, r) {
  for (var n = "", i = 0, o = e.length; i < o; i++)
    e[i].type === "text" ? n += e[i].content : e[i].type === "image" ? n += this.renderInlineAsText(e[i].children, t, r) : e[i].type === "softbreak" && (n += `
`);
  return n;
};
kh.prototype.render = function(e, t, r) {
  var n, i, o, a = "", u = this.rules;
  for (n = 0, i = e.length; n < i; n++)
    o = e[n].type, o === "inline" ? a += this.renderInline(e[n].children, t, r) : typeof u[o] < "u" ? a += u[o](e, n, t, r, this) : a += this.renderToken(e, n, t, r);
  return a;
};
var WBt = kh;
function Cs() {
  this.__rules__ = [], this.__cache__ = null;
}
Cs.prototype.__find__ = function(e) {
  for (var t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
Cs.prototype.__compile__ = function() {
  var e = this, t = [""];
  e.__rules__.forEach(function(r) {
    r.enabled && r.alt.forEach(function(n) {
      t.indexOf(n) < 0 && t.push(n);
    });
  }), e.__cache__ = {}, t.forEach(function(r) {
    e.__cache__[r] = [], e.__rules__.forEach(function(n) {
      n.enabled && (r && n.alt.indexOf(r) < 0 || e.__cache__[r].push(n.fn));
    });
  });
};
Cs.prototype.at = function(e, t, r) {
  var n = this.__find__(e), i = r || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[n].fn = t, this.__rules__[n].alt = i.alt || [], this.__cache__ = null;
};
Cs.prototype.before = function(e, t, r, n) {
  var i = this.__find__(e), o = n || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i, 0, {
    name: t,
    enabled: !0,
    fn: r,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Cs.prototype.after = function(e, t, r, n) {
  var i = this.__find__(e), o = n || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i + 1, 0, {
    name: t,
    enabled: !0,
    fn: r,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Cs.prototype.push = function(e, t, r) {
  var n = r || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: n.alt || []
  }), this.__cache__ = null;
};
Cs.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var r = [];
  return e.forEach(function(n) {
    var i = this.__find__(n);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + n);
    }
    this.__rules__[i].enabled = !0, r.push(n);
  }, this), this.__cache__ = null, r;
};
Cs.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(r) {
    r.enabled = !1;
  }), this.enable(e, t);
};
Cs.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var r = [];
  return e.forEach(function(n) {
    var i = this.__find__(n);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + n);
    }
    this.__rules__[i].enabled = !1, r.push(n);
  }, this), this.__cache__ = null, r;
};
Cs.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
var W9 = Cs, KBt = /\r\n?|\n/g, XBt = /\0/g, JBt = function(t) {
  var r;
  r = t.src.replace(KBt, `
`), r = r.replace(XBt, "�"), t.src = r;
}, ZBt = function(t) {
  var r;
  t.inlineMode ? (r = new t.Token("inline", "", 0), r.content = t.src, r.map = [0, 1], r.children = [], t.tokens.push(r)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}, QBt = function(t) {
  var r = t.tokens, n, i, o;
  for (i = 0, o = r.length; i < o; i++)
    n = r[i], n.type === "inline" && t.md.inline.parse(n.content, t.md, t.env, n.children);
}, e8t = Cn.arrayReplaceAt;
function t8t(e) {
  return /^<a[>\s]/i.test(e);
}
function r8t(e) {
  return /^<\/a\s*>/i.test(e);
}
var n8t = function(t) {
  var r, n, i, o, a, u, s, c, l, f, d, p, v, h, E, m, g = t.tokens, y;
  if (t.md.options.linkify) {
    for (n = 0, i = g.length; n < i; n++)
      if (!(g[n].type !== "inline" || !t.md.linkify.pretest(g[n].content)))
        for (o = g[n].children, v = 0, r = o.length - 1; r >= 0; r--) {
          if (u = o[r], u.type === "link_close") {
            for (r--; o[r].level !== u.level && o[r].type !== "link_open"; )
              r--;
            continue;
          }
          if (u.type === "html_inline" && (t8t(u.content) && v > 0 && v--, r8t(u.content) && v++), !(v > 0) && u.type === "text" && t.md.linkify.test(u.content)) {
            for (l = u.content, y = t.md.linkify.match(l), s = [], p = u.level, d = 0, y.length > 0 && y[0].index === 0 && r > 0 && o[r - 1].type === "text_special" && (y = y.slice(1)), c = 0; c < y.length; c++)
              h = y[c].url, E = t.md.normalizeLink(h), t.md.validateLink(E) && (m = y[c].text, y[c].schema ? y[c].schema === "mailto:" && !/^mailto:/i.test(m) ? m = t.md.normalizeLinkText("mailto:" + m).replace(/^mailto:/, "") : m = t.md.normalizeLinkText(m) : m = t.md.normalizeLinkText("http://" + m).replace(/^http:\/\//, ""), f = y[c].index, f > d && (a = new t.Token("text", "", 0), a.content = l.slice(d, f), a.level = p, s.push(a)), a = new t.Token("link_open", "a", 1), a.attrs = [["href", E]], a.level = p++, a.markup = "linkify", a.info = "auto", s.push(a), a = new t.Token("text", "", 0), a.content = m, a.level = p, s.push(a), a = new t.Token("link_close", "a", -1), a.level = --p, a.markup = "linkify", a.info = "auto", s.push(a), d = y[c].lastIndex);
            d < l.length && (a = new t.Token("text", "", 0), a.content = l.slice(d), a.level = p, s.push(a)), g[n].children = o = e8t(o, r, s);
          }
        }
  }
}, Khe = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, i8t = /\((c|tm|r)\)/i, o8t = /\((c|tm|r)\)/ig, a8t = {
  c: "©",
  r: "®",
  tm: "™"
};
function u8t(e, t) {
  return a8t[t.toLowerCase()];
}
function s8t(e) {
  var t, r, n = 0;
  for (t = e.length - 1; t >= 0; t--)
    r = e[t], r.type === "text" && !n && (r.content = r.content.replace(o8t, u8t)), r.type === "link_open" && r.info === "auto" && n--, r.type === "link_close" && r.info === "auto" && n++;
}
function c8t(e) {
  var t, r, n = 0;
  for (t = e.length - 1; t >= 0; t--)
    r = e[t], r.type === "text" && !n && Khe.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && n--, r.type === "link_close" && r.info === "auto" && n++;
}
var l8t = function(t) {
  var r;
  if (t.md.options.typographer)
    for (r = t.tokens.length - 1; r >= 0; r--)
      t.tokens[r].type === "inline" && (i8t.test(t.tokens[r].content) && s8t(t.tokens[r].children), Khe.test(t.tokens[r].content) && c8t(t.tokens[r].children));
}, EG = Cn.isWhiteSpace, mG = Cn.isPunctChar, gG = Cn.isMdAsciiPunct, f8t = /['"]/, TG = /['"]/g, yG = "’";
function eA(e, t, r) {
  return e.slice(0, t) + r + e.slice(t + 1);
}
function d8t(e, t) {
  var r, n, i, o, a, u, s, c, l, f, d, p, v, h, E, m, g, y, _, S, A;
  for (_ = [], r = 0; r < e.length; r++) {
    for (n = e[r], s = e[r].level, g = _.length - 1; g >= 0 && !(_[g].level <= s); g--)
      ;
    if (_.length = g + 1, n.type === "text") {
      i = n.content, a = 0, u = i.length;
      e:
        for (; a < u && (TG.lastIndex = a, o = TG.exec(i), !!o); ) {
          if (E = m = !0, a = o.index + 1, y = o[0] === "'", l = 32, o.index - 1 >= 0)
            l = i.charCodeAt(o.index - 1);
          else
            for (g = r - 1; g >= 0 && !(e[g].type === "softbreak" || e[g].type === "hardbreak"); g--)
              if (e[g].content) {
                l = e[g].content.charCodeAt(e[g].content.length - 1);
                break;
              }
          if (f = 32, a < u)
            f = i.charCodeAt(a);
          else
            for (g = r + 1; g < e.length && !(e[g].type === "softbreak" || e[g].type === "hardbreak"); g++)
              if (e[g].content) {
                f = e[g].content.charCodeAt(0);
                break;
              }
          if (d = gG(l) || mG(String.fromCharCode(l)), p = gG(f) || mG(String.fromCharCode(f)), v = EG(l), h = EG(f), h ? E = !1 : p && (v || d || (E = !1)), v ? m = !1 : d && (h || p || (m = !1)), f === 34 && o[0] === '"' && l >= 48 && l <= 57 && (m = E = !1), E && m && (E = d, m = p), !E && !m) {
            y && (n.content = eA(n.content, o.index, yG));
            continue;
          }
          if (m) {
            for (g = _.length - 1; g >= 0 && (c = _[g], !(_[g].level < s)); g--)
              if (c.single === y && _[g].level === s) {
                c = _[g], y ? (S = t.md.options.quotes[2], A = t.md.options.quotes[3]) : (S = t.md.options.quotes[0], A = t.md.options.quotes[1]), n.content = eA(n.content, o.index, A), e[c.token].content = eA(
                  e[c.token].content,
                  c.pos,
                  S
                ), a += A.length - 1, c.token === r && (a += S.length - 1), i = n.content, u = i.length, _.length = g;
                continue e;
              }
          }
          E ? _.push({
            token: r,
            pos: o.index,
            single: y,
            level: s
          }) : m && y && (n.content = eA(n.content, o.index, yG));
        }
    }
  }
}
var p8t = function(t) {
  var r;
  if (t.md.options.typographer)
    for (r = t.tokens.length - 1; r >= 0; r--)
      t.tokens[r].type !== "inline" || !f8t.test(t.tokens[r].content) || d8t(t.tokens[r].children, t);
}, h8t = function(t) {
  var r, n, i, o, a, u, s = t.tokens;
  for (r = 0, n = s.length; r < n; r++)
    if (s[r].type === "inline") {
      for (i = s[r].children, a = i.length, o = 0; o < a; o++)
        i[o].type === "text_special" && (i[o].type = "text");
      for (o = u = 0; o < a; o++)
        i[o].type === "text" && o + 1 < a && i[o + 1].type === "text" ? i[o + 1].content = i[o].content + i[o + 1].content : (o !== u && (i[u] = i[o]), u++);
      o !== u && (i.length = u);
    }
};
function Mh(e, t, r) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
Mh.prototype.attrIndex = function(t) {
  var r, n, i;
  if (!this.attrs)
    return -1;
  for (r = this.attrs, n = 0, i = r.length; n < i; n++)
    if (r[n][0] === t)
      return n;
  return -1;
};
Mh.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
Mh.prototype.attrSet = function(t, r) {
  var n = this.attrIndex(t), i = [t, r];
  n < 0 ? this.attrPush(i) : this.attrs[n] = i;
};
Mh.prototype.attrGet = function(t) {
  var r = this.attrIndex(t), n = null;
  return r >= 0 && (n = this.attrs[r][1]), n;
};
Mh.prototype.attrJoin = function(t, r) {
  var n = this.attrIndex(t);
  n < 0 ? this.attrPush([t, r]) : this.attrs[n][1] = this.attrs[n][1] + " " + r;
};
var K9 = Mh, v8t = K9;
function Xhe(e, t, r) {
  this.src = e, this.env = r, this.tokens = [], this.inlineMode = !1, this.md = t;
}
Xhe.prototype.Token = v8t;
var E8t = Xhe, m8t = W9, IR = [
  ["normalize", JBt],
  ["block", ZBt],
  ["inline", QBt],
  ["linkify", n8t],
  ["replacements", l8t],
  ["smartquotes", p8t],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", h8t]
];
function X9() {
  this.ruler = new m8t();
  for (var e = 0; e < IR.length; e++)
    this.ruler.push(IR[e][0], IR[e][1]);
}
X9.prototype.process = function(e) {
  var t, r, n;
  for (n = this.ruler.getRules(""), t = 0, r = n.length; t < r; t++)
    n[t](e);
};
X9.prototype.State = E8t;
var g8t = X9, OR = Cn.isSpace;
function RR(e, t) {
  var r = e.bMarks[t] + e.tShift[t], n = e.eMarks[t];
  return e.src.slice(r, n);
}
function _G(e) {
  var t = [], r = 0, n = e.length, i, o = !1, a = 0, u = "";
  for (i = e.charCodeAt(r); r < n; )
    i === 124 && (o ? (u += e.substring(a, r - 1), a = r) : (t.push(u + e.substring(a, r)), u = "", a = r + 1)), o = i === 92, r++, i = e.charCodeAt(r);
  return t.push(u + e.substring(a)), t;
}
var T8t = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d, p, v, h, E, m, g, y, _, S, A;
  if (r + 2 > n || (l = r + 1, t.sCount[l] < t.blkIndent) || t.sCount[l] - t.blkIndent >= 4 || (u = t.bMarks[l] + t.tShift[l], u >= t.eMarks[l]) || (S = t.src.charCodeAt(u++), S !== 124 && S !== 45 && S !== 58) || u >= t.eMarks[l] || (A = t.src.charCodeAt(u++), A !== 124 && A !== 45 && A !== 58 && !OR(A)) || S === 45 && OR(A))
    return !1;
  for (; u < t.eMarks[l]; ) {
    if (o = t.src.charCodeAt(u), o !== 124 && o !== 45 && o !== 58 && !OR(o))
      return !1;
    u++;
  }
  for (a = RR(t, r + 1), f = a.split("|"), v = [], s = 0; s < f.length; s++) {
    if (h = f[s].trim(), !h) {
      if (s === 0 || s === f.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(h))
      return !1;
    h.charCodeAt(h.length - 1) === 58 ? v.push(h.charCodeAt(0) === 58 ? "center" : "right") : h.charCodeAt(0) === 58 ? v.push("left") : v.push("");
  }
  if (a = RR(t, r).trim(), a.indexOf("|") === -1 || t.sCount[r] - t.blkIndent >= 4 || (f = _G(a), f.length && f[0] === "" && f.shift(), f.length && f[f.length - 1] === "" && f.pop(), d = f.length, d === 0 || d !== v.length))
    return !1;
  if (i)
    return !0;
  for (g = t.parentType, t.parentType = "table", _ = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), p.map = E = [r, 0], p = t.push("thead_open", "thead", 1), p.map = [r, r + 1], p = t.push("tr_open", "tr", 1), p.map = [r, r + 1], s = 0; s < f.length; s++)
    p = t.push("th_open", "th", 1), v[s] && (p.attrs = [["style", "text-align:" + v[s]]]), p = t.push("inline", "", 0), p.content = f[s].trim(), p.children = [], p = t.push("th_close", "th", -1);
  for (p = t.push("tr_close", "tr", -1), p = t.push("thead_close", "thead", -1), l = r + 2; l < n && !(t.sCount[l] < t.blkIndent); l++) {
    for (y = !1, s = 0, c = _.length; s < c; s++)
      if (_[s](t, l, n, !0)) {
        y = !0;
        break;
      }
    if (y || (a = RR(t, l).trim(), !a) || t.sCount[l] - t.blkIndent >= 4)
      break;
    for (f = _G(a), f.length && f[0] === "" && f.shift(), f.length && f[f.length - 1] === "" && f.pop(), l === r + 2 && (p = t.push("tbody_open", "tbody", 1), p.map = m = [r + 2, 0]), p = t.push("tr_open", "tr", 1), p.map = [l, l + 1], s = 0; s < d; s++)
      p = t.push("td_open", "td", 1), v[s] && (p.attrs = [["style", "text-align:" + v[s]]]), p = t.push("inline", "", 0), p.content = f[s] ? f[s].trim() : "", p.children = [], p = t.push("td_close", "td", -1);
    p = t.push("tr_close", "tr", -1);
  }
  return m && (p = t.push("tbody_close", "tbody", -1), m[1] = l), p = t.push("table_close", "table", -1), E[1] = l, t.parentType = g, t.line = l, !0;
}, y8t = function(t, r, n) {
  var i, o, a;
  if (t.sCount[r] - t.blkIndent < 4)
    return !1;
  for (o = i = r + 1; i < n; ) {
    if (t.isEmpty(i)) {
      i++;
      continue;
    }
    if (t.sCount[i] - t.blkIndent >= 4) {
      i++, o = i;
      continue;
    }
    break;
  }
  return t.line = o, a = t.push("code_block", "code", 0), a.content = t.getLines(r, o, 4 + t.blkIndent, !1) + `
`, a.map = [r, t.line], !0;
}, _8t = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d = !1, p = t.bMarks[r] + t.tShift[r], v = t.eMarks[r];
  if (t.sCount[r] - t.blkIndent >= 4 || p + 3 > v || (o = t.src.charCodeAt(p), o !== 126 && o !== 96) || (c = p, p = t.skipChars(p, o), a = p - c, a < 3) || (f = t.src.slice(c, p), u = t.src.slice(p, v), o === 96 && u.indexOf(String.fromCharCode(o)) >= 0))
    return !1;
  if (i)
    return !0;
  for (s = r; s++, !(s >= n || (p = c = t.bMarks[s] + t.tShift[s], v = t.eMarks[s], p < v && t.sCount[s] < t.blkIndent)); )
    if (t.src.charCodeAt(p) === o && !(t.sCount[s] - t.blkIndent >= 4) && (p = t.skipChars(p, o), !(p - c < a) && (p = t.skipSpaces(p), !(p < v)))) {
      d = !0;
      break;
    }
  return a = t.sCount[r], t.line = s + (d ? 1 : 0), l = t.push("fence", "code", 0), l.info = u, l.content = t.getLines(r + 1, s, a, !0), l.markup = f, l.map = [r, t.line], !0;
}, A8t = Cn.isSpace, S8t = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d, p, v, h, E, m, g, y, _, S, A, O, P, U = t.lineMax, z = t.bMarks[r] + t.tShift[r], k = t.eMarks[r];
  if (t.sCount[r] - t.blkIndent >= 4 || t.src.charCodeAt(z) !== 62)
    return !1;
  if (i)
    return !0;
  for (v = [], h = [], g = [], y = [], A = t.md.block.ruler.getRules("blockquote"), m = t.parentType, t.parentType = "blockquote", d = r; d < n && (P = t.sCount[d] < t.blkIndent, z = t.bMarks[d] + t.tShift[d], k = t.eMarks[d], !(z >= k)); d++) {
    if (t.src.charCodeAt(z++) === 62 && !P) {
      for (s = t.sCount[d] + 1, t.src.charCodeAt(z) === 32 ? (z++, s++, o = !1, _ = !0) : t.src.charCodeAt(z) === 9 ? (_ = !0, (t.bsCount[d] + s) % 4 === 3 ? (z++, s++, o = !1) : o = !0) : _ = !1, p = s, v.push(t.bMarks[d]), t.bMarks[d] = z; z < k && (a = t.src.charCodeAt(z), A8t(a)); ) {
        a === 9 ? p += 4 - (p + t.bsCount[d] + (o ? 1 : 0)) % 4 : p++;
        z++;
      }
      l = z >= k, h.push(t.bsCount[d]), t.bsCount[d] = t.sCount[d] + 1 + (_ ? 1 : 0), g.push(t.sCount[d]), t.sCount[d] = p - s, y.push(t.tShift[d]), t.tShift[d] = z - t.bMarks[d];
      continue;
    }
    if (l)
      break;
    for (S = !1, u = 0, c = A.length; u < c; u++)
      if (A[u](t, d, n, !0)) {
        S = !0;
        break;
      }
    if (S) {
      t.lineMax = d, t.blkIndent !== 0 && (v.push(t.bMarks[d]), h.push(t.bsCount[d]), y.push(t.tShift[d]), g.push(t.sCount[d]), t.sCount[d] -= t.blkIndent);
      break;
    }
    v.push(t.bMarks[d]), h.push(t.bsCount[d]), y.push(t.tShift[d]), g.push(t.sCount[d]), t.sCount[d] = -1;
  }
  for (E = t.blkIndent, t.blkIndent = 0, O = t.push("blockquote_open", "blockquote", 1), O.markup = ">", O.map = f = [r, 0], t.md.block.tokenize(t, r, d), O = t.push("blockquote_close", "blockquote", -1), O.markup = ">", t.lineMax = U, t.parentType = m, f[1] = t.line, u = 0; u < y.length; u++)
    t.bMarks[u + r] = v[u], t.tShift[u + r] = y[u], t.sCount[u + r] = g[u], t.bsCount[u + r] = h[u];
  return t.blkIndent = E, !0;
}, b8t = Cn.isSpace, C8t = function(t, r, n, i) {
  var o, a, u, s, c = t.bMarks[r] + t.tShift[r], l = t.eMarks[r];
  if (t.sCount[r] - t.blkIndent >= 4 || (o = t.src.charCodeAt(c++), o !== 42 && o !== 45 && o !== 95))
    return !1;
  for (a = 1; c < l; ) {
    if (u = t.src.charCodeAt(c++), u !== o && !b8t(u))
      return !1;
    u === o && a++;
  }
  return a < 3 ? !1 : (i || (t.line = r + 1, s = t.push("hr", "hr", 0), s.map = [r, t.line], s.markup = Array(a + 1).join(String.fromCharCode(o))), !0);
}, Jhe = Cn.isSpace;
function AG(e, t) {
  var r, n, i, o;
  return n = e.bMarks[t] + e.tShift[t], i = e.eMarks[t], r = e.src.charCodeAt(n++), r !== 42 && r !== 45 && r !== 43 || n < i && (o = e.src.charCodeAt(n), !Jhe(o)) ? -1 : n;
}
function SG(e, t) {
  var r, n = e.bMarks[t] + e.tShift[t], i = n, o = e.eMarks[t];
  if (i + 1 >= o || (r = e.src.charCodeAt(i++), r < 48 || r > 57))
    return -1;
  for (; ; ) {
    if (i >= o)
      return -1;
    if (r = e.src.charCodeAt(i++), r >= 48 && r <= 57) {
      if (i - n >= 10)
        return -1;
      continue;
    }
    if (r === 41 || r === 46)
      break;
    return -1;
  }
  return i < o && (r = e.src.charCodeAt(i), !Jhe(r)) ? -1 : i;
}
function I8t(e, t) {
  var r, n, i = e.level + 2;
  for (r = t + 2, n = e.tokens.length - 2; r < n; r++)
    e.tokens[r].level === i && e.tokens[r].type === "paragraph_open" && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
}
var O8t = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d, p, v, h, E, m, g, y, _, S, A, O, P, U, z, k, H, B, x, D, w = r, $ = !1, X = !0;
  if (t.sCount[w] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[w] - t.listIndent >= 4 && t.sCount[w] < t.blkIndent)
    return !1;
  if (i && t.parentType === "paragraph" && t.sCount[w] >= t.blkIndent && ($ = !0), (z = SG(t, w)) >= 0) {
    if (f = !0, H = t.bMarks[w] + t.tShift[w], m = Number(t.src.slice(H, z - 1)), $ && m !== 1) return !1;
  } else if ((z = AG(t, w)) >= 0)
    f = !1;
  else
    return !1;
  if ($ && t.skipSpaces(z) >= t.eMarks[w])
    return !1;
  if (i)
    return !0;
  for (E = t.src.charCodeAt(z - 1), h = t.tokens.length, f ? (D = t.push("ordered_list_open", "ol", 1), m !== 1 && (D.attrs = [["start", m]])) : D = t.push("bullet_list_open", "ul", 1), D.map = v = [w, 0], D.markup = String.fromCharCode(E), k = !1, x = t.md.block.ruler.getRules("list"), S = t.parentType, t.parentType = "list"; w < n; ) {
    for (U = z, g = t.eMarks[w], l = y = t.sCount[w] + z - (t.bMarks[w] + t.tShift[w]); U < g; ) {
      if (o = t.src.charCodeAt(U), o === 9)
        y += 4 - (y + t.bsCount[w]) % 4;
      else if (o === 32)
        y++;
      else
        break;
      U++;
    }
    if (a = U, a >= g ? c = 1 : c = y - l, c > 4 && (c = 1), s = l + c, D = t.push("list_item_open", "li", 1), D.markup = String.fromCharCode(E), D.map = d = [w, 0], f && (D.info = t.src.slice(H, z - 1)), P = t.tight, O = t.tShift[w], A = t.sCount[w], _ = t.listIndent, t.listIndent = t.blkIndent, t.blkIndent = s, t.tight = !0, t.tShift[w] = a - t.bMarks[w], t.sCount[w] = y, a >= g && t.isEmpty(w + 1) ? t.line = Math.min(t.line + 2, n) : t.md.block.tokenize(t, w, n, !0), (!t.tight || k) && (X = !1), k = t.line - w > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = _, t.tShift[w] = O, t.sCount[w] = A, t.tight = P, D = t.push("list_item_close", "li", -1), D.markup = String.fromCharCode(E), w = t.line, d[1] = w, w >= n || t.sCount[w] < t.blkIndent || t.sCount[w] - t.blkIndent >= 4)
      break;
    for (B = !1, u = 0, p = x.length; u < p; u++)
      if (x[u](t, w, n, !0)) {
        B = !0;
        break;
      }
    if (B)
      break;
    if (f) {
      if (z = SG(t, w), z < 0)
        break;
      H = t.bMarks[w] + t.tShift[w];
    } else if (z = AG(t, w), z < 0)
      break;
    if (E !== t.src.charCodeAt(z - 1))
      break;
  }
  return f ? D = t.push("ordered_list_close", "ol", -1) : D = t.push("bullet_list_close", "ul", -1), D.markup = String.fromCharCode(E), v[1] = w, t.line = w, t.parentType = S, X && I8t(t, h), !0;
}, R8t = Cn.normalizeReference, tA = Cn.isSpace, w8t = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d, p, v, h, E, m, g, y, _, S = 0, A = t.bMarks[r] + t.tShift[r], O = t.eMarks[r], P = r + 1;
  if (t.sCount[r] - t.blkIndent >= 4 || t.src.charCodeAt(A) !== 91)
    return !1;
  for (; ++A < O; )
    if (t.src.charCodeAt(A) === 93 && t.src.charCodeAt(A - 1) !== 92) {
      if (A + 1 === O || t.src.charCodeAt(A + 1) !== 58)
        return !1;
      break;
    }
  for (s = t.lineMax, y = t.md.block.ruler.getRules("reference"), v = t.parentType, t.parentType = "reference"; P < s && !t.isEmpty(P); P++)
    if (!(t.sCount[P] - t.blkIndent > 3) && !(t.sCount[P] < 0)) {
      for (g = !1, l = 0, f = y.length; l < f; l++)
        if (y[l](t, P, s, !0)) {
          g = !0;
          break;
        }
      if (g)
        break;
    }
  for (m = t.getLines(r, P, t.blkIndent, !1).trim(), O = m.length, A = 1; A < O; A++) {
    if (o = m.charCodeAt(A), o === 91)
      return !1;
    if (o === 93) {
      p = A;
      break;
    } else o === 10 ? S++ : o === 92 && (A++, A < O && m.charCodeAt(A) === 10 && S++);
  }
  if (p < 0 || m.charCodeAt(p + 1) !== 58)
    return !1;
  for (A = p + 2; A < O; A++)
    if (o = m.charCodeAt(A), o === 10)
      S++;
    else if (!tA(o)) break;
  if (h = t.md.helpers.parseLinkDestination(m, A, O), !h.ok || (c = t.md.normalizeLink(h.str), !t.md.validateLink(c)))
    return !1;
  for (A = h.pos, S += h.lines, a = A, u = S, E = A; A < O; A++)
    if (o = m.charCodeAt(A), o === 10)
      S++;
    else if (!tA(o)) break;
  for (h = t.md.helpers.parseLinkTitle(m, A, O), A < O && E !== A && h.ok ? (_ = h.str, A = h.pos, S += h.lines) : (_ = "", A = a, S = u); A < O && (o = m.charCodeAt(A), !!tA(o)); )
    A++;
  if (A < O && m.charCodeAt(A) !== 10 && _)
    for (_ = "", A = a, S = u; A < O && (o = m.charCodeAt(A), !!tA(o)); )
      A++;
  return A < O && m.charCodeAt(A) !== 10 || (d = R8t(m.slice(1, p)), !d) ? !1 : (i || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[d] > "u" && (t.env.references[d] = { title: _, href: c }), t.parentType = v, t.line = r + S + 1), !0);
}, P8t = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], IC = {}, D8t = "[a-zA-Z_:][a-zA-Z0-9:._-]*", x8t = "[^\"'=<>`\\x00-\\x20]+", N8t = "'[^']*'", L8t = '"[^"]*"', B8t = "(?:" + x8t + "|" + N8t + "|" + L8t + ")", k8t = "(?:\\s+" + D8t + "(?:\\s*=\\s*" + B8t + ")?)", Zhe = "<[A-Za-z][A-Za-z0-9\\-]*" + k8t + "*\\s*\\/?>", Qhe = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", M8t = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", F8t = "<[?][\\s\\S]*?[?]>", H8t = "<![A-Z]+\\s+[^>]*>", $8t = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", U8t = new RegExp("^(?:" + Zhe + "|" + Qhe + "|" + M8t + "|" + F8t + "|" + H8t + "|" + $8t + ")"), V8t = new RegExp("^(?:" + Zhe + "|" + Qhe + ")");
IC.HTML_TAG_RE = U8t;
IC.HTML_OPEN_CLOSE_TAG_RE = V8t;
var j8t = P8t, z8t = IC.HTML_OPEN_CLOSE_TAG_RE, Hd = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + j8t.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(z8t.source + "\\s*$"), /^$/, !1]
], q8t = function(t, r, n, i) {
  var o, a, u, s, c = t.bMarks[r] + t.tShift[r], l = t.eMarks[r];
  if (t.sCount[r] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(c) !== 60)
    return !1;
  for (s = t.src.slice(c, l), o = 0; o < Hd.length && !Hd[o][0].test(s); o++)
    ;
  if (o === Hd.length)
    return !1;
  if (i)
    return Hd[o][2];
  if (a = r + 1, !Hd[o][1].test(s)) {
    for (; a < n && !(t.sCount[a] < t.blkIndent); a++)
      if (c = t.bMarks[a] + t.tShift[a], l = t.eMarks[a], s = t.src.slice(c, l), Hd[o][1].test(s)) {
        s.length !== 0 && a++;
        break;
      }
  }
  return t.line = a, u = t.push("html_block", "", 0), u.map = [r, a], u.content = t.getLines(r, a, t.blkIndent, !0), !0;
}, bG = Cn.isSpace, Y8t = function(t, r, n, i) {
  var o, a, u, s, c = t.bMarks[r] + t.tShift[r], l = t.eMarks[r];
  if (t.sCount[r] - t.blkIndent >= 4 || (o = t.src.charCodeAt(c), o !== 35 || c >= l))
    return !1;
  for (a = 1, o = t.src.charCodeAt(++c); o === 35 && c < l && a <= 6; )
    a++, o = t.src.charCodeAt(++c);
  return a > 6 || c < l && !bG(o) ? !1 : (i || (l = t.skipSpacesBack(l, c), u = t.skipCharsBack(l, 35, c), u > c && bG(t.src.charCodeAt(u - 1)) && (l = u), t.line = r + 1, s = t.push("heading_open", "h" + String(a), 1), s.markup = "########".slice(0, a), s.map = [r, t.line], s = t.push("inline", "", 0), s.content = t.src.slice(c, l).trim(), s.map = [r, t.line], s.children = [], s = t.push("heading_close", "h" + String(a), -1), s.markup = "########".slice(0, a)), !0);
}, G8t = function(t, r, n) {
  var i, o, a, u, s, c, l, f, d, p = r + 1, v, h = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[r] - t.blkIndent >= 4)
    return !1;
  for (v = t.parentType, t.parentType = "paragraph"; p < n && !t.isEmpty(p); p++)
    if (!(t.sCount[p] - t.blkIndent > 3)) {
      if (t.sCount[p] >= t.blkIndent && (c = t.bMarks[p] + t.tShift[p], l = t.eMarks[p], c < l && (d = t.src.charCodeAt(c), (d === 45 || d === 61) && (c = t.skipChars(c, d), c = t.skipSpaces(c), c >= l)))) {
        f = d === 61 ? 1 : 2;
        break;
      }
      if (!(t.sCount[p] < 0)) {
        for (o = !1, a = 0, u = h.length; a < u; a++)
          if (h[a](t, p, n, !0)) {
            o = !0;
            break;
          }
        if (o)
          break;
      }
    }
  return f ? (i = t.getLines(r, p, t.blkIndent, !1).trim(), t.line = p + 1, s = t.push("heading_open", "h" + String(f), 1), s.markup = String.fromCharCode(d), s.map = [r, t.line], s = t.push("inline", "", 0), s.content = i, s.map = [r, t.line - 1], s.children = [], s = t.push("heading_close", "h" + String(f), -1), s.markup = String.fromCharCode(d), t.parentType = v, !0) : !1;
}, W8t = function(t, r, n) {
  var i, o, a, u, s, c, l = r + 1, f = t.md.block.ruler.getRules("paragraph");
  for (c = t.parentType, t.parentType = "paragraph"; l < n && !t.isEmpty(l); l++)
    if (!(t.sCount[l] - t.blkIndent > 3) && !(t.sCount[l] < 0)) {
      for (o = !1, a = 0, u = f.length; a < u; a++)
        if (f[a](t, l, n, !0)) {
          o = !0;
          break;
        }
      if (o)
        break;
    }
  return i = t.getLines(r, l, t.blkIndent, !1).trim(), t.line = l, s = t.push("paragraph_open", "p", 1), s.map = [r, t.line], s = t.push("inline", "", 0), s.content = i, s.map = [r, t.line], s.children = [], s = t.push("paragraph_close", "p", -1), t.parentType = c, !0;
}, eve = K9, OC = Cn.isSpace;
function cc(e, t, r, n) {
  var i, o, a, u, s, c, l, f;
  for (this.src = e, this.md = t, this.env = r, this.tokens = n, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", o = this.src, f = !1, a = u = c = l = 0, s = o.length; u < s; u++) {
    if (i = o.charCodeAt(u), !f)
      if (OC(i)) {
        c++, i === 9 ? l += 4 - l % 4 : l++;
        continue;
      } else
        f = !0;
    (i === 10 || u === s - 1) && (i !== 10 && u++, this.bMarks.push(a), this.eMarks.push(u), this.tShift.push(c), this.sCount.push(l), this.bsCount.push(0), f = !1, c = 0, l = 0, a = u + 1);
  }
  this.bMarks.push(o.length), this.eMarks.push(o.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
cc.prototype.push = function(e, t, r) {
  var n = new eve(e, t, r);
  return n.block = !0, r < 0 && this.level--, n.level = this.level, r > 0 && this.level++, this.tokens.push(n), n;
};
cc.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
cc.prototype.skipEmptyLines = function(t) {
  for (var r = this.lineMax; t < r && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
cc.prototype.skipSpaces = function(t) {
  for (var r, n = this.src.length; t < n && (r = this.src.charCodeAt(t), !!OC(r)); t++)
    ;
  return t;
};
cc.prototype.skipSpacesBack = function(t, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (!OC(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
cc.prototype.skipChars = function(t, r) {
  for (var n = this.src.length; t < n && this.src.charCodeAt(t) === r; t++)
    ;
  return t;
};
cc.prototype.skipCharsBack = function(t, r, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (r !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
cc.prototype.getLines = function(t, r, n, i) {
  var o, a, u, s, c, l, f, d = t;
  if (t >= r)
    return "";
  for (l = new Array(r - t), o = 0; d < r; d++, o++) {
    for (a = 0, f = s = this.bMarks[d], d + 1 < r || i ? c = this.eMarks[d] + 1 : c = this.eMarks[d]; s < c && a < n; ) {
      if (u = this.src.charCodeAt(s), OC(u))
        u === 9 ? a += 4 - (a + this.bsCount[d]) % 4 : a++;
      else if (s - f < this.tShift[d])
        a++;
      else
        break;
      s++;
    }
    a > n ? l[o] = new Array(a - n + 1).join(" ") + this.src.slice(s, c) : l[o] = this.src.slice(s, c);
  }
  return l.join("");
};
cc.prototype.Token = eve;
var K8t = cc, X8t = W9, rA = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", T8t, ["paragraph", "reference"]],
  ["code", y8t],
  ["fence", _8t, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", S8t, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", C8t, ["paragraph", "reference", "blockquote", "list"]],
  ["list", O8t, ["paragraph", "reference", "blockquote"]],
  ["reference", w8t],
  ["html_block", q8t, ["paragraph", "reference", "blockquote"]],
  ["heading", Y8t, ["paragraph", "reference", "blockquote"]],
  ["lheading", G8t],
  ["paragraph", W8t]
];
function RC() {
  this.ruler = new X8t();
  for (var e = 0; e < rA.length; e++)
    this.ruler.push(rA[e][0], rA[e][1], { alt: (rA[e][2] || []).slice() });
}
RC.prototype.tokenize = function(e, t, r) {
  for (var n, i, o, a = this.ruler.getRules(""), u = a.length, s = t, c = !1, l = e.md.options.maxNesting; s < r && (e.line = s = e.skipEmptyLines(s), !(s >= r || e.sCount[s] < e.blkIndent)); ) {
    if (e.level >= l) {
      e.line = r;
      break;
    }
    for (o = e.line, i = 0; i < u; i++)
      if (n = a[i](e, s, r, !1), n) {
        if (o >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!n) throw new Error("none of the block rules matched");
    e.tight = !c, e.isEmpty(e.line - 1) && (c = !0), s = e.line, s < r && e.isEmpty(s) && (c = !0, s++, e.line = s);
  }
};
RC.prototype.parse = function(e, t, r, n) {
  var i;
  e && (i = new this.State(e, t, r, n), this.tokenize(i, i.line, i.lineMax));
};
RC.prototype.State = K8t;
var J8t = RC;
function Z8t(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
var Q8t = function(t, r) {
  for (var n = t.pos; n < t.posMax && !Z8t(t.src.charCodeAt(n)); )
    n++;
  return n === t.pos ? !1 : (r || (t.pending += t.src.slice(t.pos, n)), t.pos = n, !0);
}, ekt = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, tkt = function(t, r) {
  var n, i, o, a, u, s, c, l;
  return !t.md.options.linkify || t.linkLevel > 0 || (n = t.pos, i = t.posMax, n + 3 > i) || t.src.charCodeAt(n) !== 58 || t.src.charCodeAt(n + 1) !== 47 || t.src.charCodeAt(n + 2) !== 47 || (o = t.pending.match(ekt), !o) || (a = o[1], u = t.md.linkify.matchAtStart(t.src.slice(n - a.length)), !u) || (s = u.url, s.length <= a.length) || (s = s.replace(/\*+$/, ""), c = t.md.normalizeLink(s), !t.md.validateLink(c)) ? !1 : (r || (t.pending = t.pending.slice(0, -a.length), l = t.push("link_open", "a", 1), l.attrs = [["href", c]], l.markup = "linkify", l.info = "auto", l = t.push("text", "", 0), l.content = t.md.normalizeLinkText(s), l = t.push("link_close", "a", -1), l.markup = "linkify", l.info = "auto"), t.pos += s.length - a.length, !0);
}, rkt = Cn.isSpace, nkt = function(t, r) {
  var n, i, o, a = t.pos;
  if (t.src.charCodeAt(a) !== 10)
    return !1;
  if (n = t.pending.length - 1, i = t.posMax, !r)
    if (n >= 0 && t.pending.charCodeAt(n) === 32)
      if (n >= 1 && t.pending.charCodeAt(n - 1) === 32) {
        for (o = n - 1; o >= 1 && t.pending.charCodeAt(o - 1) === 32; ) o--;
        t.pending = t.pending.slice(0, o), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (a++; a < i && rkt(t.src.charCodeAt(a)); )
    a++;
  return t.pos = a, !0;
}, ikt = Cn.isSpace, J9 = [];
for (var CG = 0; CG < 256; CG++)
  J9.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  J9[e.charCodeAt(0)] = 1;
});
var okt = function(t, r) {
  var n, i, o, a, u, s = t.pos, c = t.posMax;
  if (t.src.charCodeAt(s) !== 92 || (s++, s >= c)) return !1;
  if (n = t.src.charCodeAt(s), n === 10) {
    for (r || t.push("hardbreak", "br", 0), s++; s < c && (n = t.src.charCodeAt(s), !!ikt(n)); )
      s++;
    return t.pos = s, !0;
  }
  return a = t.src[s], n >= 55296 && n <= 56319 && s + 1 < c && (i = t.src.charCodeAt(s + 1), i >= 56320 && i <= 57343 && (a += t.src[s + 1], s++)), o = "\\" + a, r || (u = t.push("text_special", "", 0), n < 256 && J9[n] !== 0 ? u.content = a : u.content = o, u.markup = o, u.info = "escape"), t.pos = s + 1, !0;
}, akt = function(t, r) {
  var n, i, o, a, u, s, c, l, f = t.pos, d = t.src.charCodeAt(f);
  if (d !== 96)
    return !1;
  for (n = f, f++, i = t.posMax; f < i && t.src.charCodeAt(f) === 96; )
    f++;
  if (o = t.src.slice(n, f), c = o.length, t.backticksScanned && (t.backticks[c] || 0) <= n)
    return r || (t.pending += o), t.pos += c, !0;
  for (s = f; (u = t.src.indexOf("`", s)) !== -1; ) {
    for (s = u + 1; s < i && t.src.charCodeAt(s) === 96; )
      s++;
    if (l = s - u, l === c)
      return r || (a = t.push("code_inline", "code", 0), a.markup = o, a.content = t.src.slice(f, u).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), t.pos = s, !0;
    t.backticks[l] = u;
  }
  return t.backticksScanned = !0, r || (t.pending += o), t.pos += c, !0;
}, wC = {};
wC.tokenize = function(t, r) {
  var n, i, o, a, u, s = t.pos, c = t.src.charCodeAt(s);
  if (r || c !== 126 || (i = t.scanDelims(t.pos, !0), a = i.length, u = String.fromCharCode(c), a < 2))
    return !1;
  for (a % 2 && (o = t.push("text", "", 0), o.content = u, a--), n = 0; n < a; n += 2)
    o = t.push("text", "", 0), o.content = u + u, t.delimiters.push({
      marker: c,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: i.can_open,
      close: i.can_close
    });
  return t.pos += i.length, !0;
};
function IG(e, t) {
  var r, n, i, o, a, u = [], s = t.length;
  for (r = 0; r < s; r++)
    i = t[r], i.marker === 126 && i.end !== -1 && (o = t[i.end], a = e.tokens[i.token], a.type = "s_open", a.tag = "s", a.nesting = 1, a.markup = "~~", a.content = "", a = e.tokens[o.token], a.type = "s_close", a.tag = "s", a.nesting = -1, a.markup = "~~", a.content = "", e.tokens[o.token - 1].type === "text" && e.tokens[o.token - 1].content === "~" && u.push(o.token - 1));
  for (; u.length; ) {
    for (r = u.pop(), n = r + 1; n < e.tokens.length && e.tokens[n].type === "s_close"; )
      n++;
    n--, r !== n && (a = e.tokens[n], e.tokens[n] = e.tokens[r], e.tokens[r] = a);
  }
}
wC.postProcess = function(t) {
  var r, n = t.tokens_meta, i = t.tokens_meta.length;
  for (IG(t, t.delimiters), r = 0; r < i; r++)
    n[r] && n[r].delimiters && IG(t, n[r].delimiters);
};
var PC = {};
PC.tokenize = function(t, r) {
  var n, i, o, a = t.pos, u = t.src.charCodeAt(a);
  if (r || u !== 95 && u !== 42)
    return !1;
  for (i = t.scanDelims(t.pos, u === 42), n = 0; n < i.length; n++)
    o = t.push("text", "", 0), o.content = String.fromCharCode(u), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: u,
      // Total length of these series of delimiters.
      //
      length: i.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: i.can_open,
      close: i.can_close
    });
  return t.pos += i.length, !0;
};
function OG(e, t) {
  var r, n, i, o, a, u, s = t.length;
  for (r = s - 1; r >= 0; r--)
    n = t[r], !(n.marker !== 95 && n.marker !== 42) && n.end !== -1 && (i = t[n.end], u = r > 0 && t[r - 1].end === n.end + 1 && // check that first two markers match and adjacent
    t[r - 1].marker === n.marker && t[r - 1].token === n.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[n.end + 1].token === i.token + 1, a = String.fromCharCode(n.marker), o = e.tokens[n.token], o.type = u ? "strong_open" : "em_open", o.tag = u ? "strong" : "em", o.nesting = 1, o.markup = u ? a + a : a, o.content = "", o = e.tokens[i.token], o.type = u ? "strong_close" : "em_close", o.tag = u ? "strong" : "em", o.nesting = -1, o.markup = u ? a + a : a, o.content = "", u && (e.tokens[t[r - 1].token].content = "", e.tokens[t[n.end + 1].token].content = "", r--));
}
PC.postProcess = function(t) {
  var r, n = t.tokens_meta, i = t.tokens_meta.length;
  for (OG(t, t.delimiters), r = 0; r < i; r++)
    n[r] && n[r].delimiters && OG(t, n[r].delimiters);
};
var ukt = Cn.normalizeReference, wR = Cn.isSpace, skt = function(t, r) {
  var n, i, o, a, u, s, c, l, f, d = "", p = "", v = t.pos, h = t.posMax, E = t.pos, m = !0;
  if (t.src.charCodeAt(t.pos) !== 91 || (u = t.pos + 1, a = t.md.helpers.parseLinkLabel(t, t.pos, !0), a < 0))
    return !1;
  if (s = a + 1, s < h && t.src.charCodeAt(s) === 40) {
    for (m = !1, s++; s < h && (i = t.src.charCodeAt(s), !(!wR(i) && i !== 10)); s++)
      ;
    if (s >= h)
      return !1;
    if (E = s, c = t.md.helpers.parseLinkDestination(t.src, s, t.posMax), c.ok) {
      for (d = t.md.normalizeLink(c.str), t.md.validateLink(d) ? s = c.pos : d = "", E = s; s < h && (i = t.src.charCodeAt(s), !(!wR(i) && i !== 10)); s++)
        ;
      if (c = t.md.helpers.parseLinkTitle(t.src, s, t.posMax), s < h && E !== s && c.ok)
        for (p = c.str, s = c.pos; s < h && (i = t.src.charCodeAt(s), !(!wR(i) && i !== 10)); s++)
          ;
    }
    (s >= h || t.src.charCodeAt(s) !== 41) && (m = !0), s++;
  }
  if (m) {
    if (typeof t.env.references > "u")
      return !1;
    if (s < h && t.src.charCodeAt(s) === 91 ? (E = s + 1, s = t.md.helpers.parseLinkLabel(t, s), s >= 0 ? o = t.src.slice(E, s++) : s = a + 1) : s = a + 1, o || (o = t.src.slice(u, a)), l = t.env.references[ukt(o)], !l)
      return t.pos = v, !1;
    d = l.href, p = l.title;
  }
  return r || (t.pos = u, t.posMax = a, f = t.push("link_open", "a", 1), f.attrs = n = [["href", d]], p && n.push(["title", p]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, f = t.push("link_close", "a", -1)), t.pos = s, t.posMax = h, !0;
}, ckt = Cn.normalizeReference, PR = Cn.isSpace, lkt = function(t, r) {
  var n, i, o, a, u, s, c, l, f, d, p, v, h, E = "", m = t.pos, g = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91 || (s = t.pos + 2, u = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1), u < 0))
    return !1;
  if (c = u + 1, c < g && t.src.charCodeAt(c) === 40) {
    for (c++; c < g && (i = t.src.charCodeAt(c), !(!PR(i) && i !== 10)); c++)
      ;
    if (c >= g)
      return !1;
    for (h = c, f = t.md.helpers.parseLinkDestination(t.src, c, t.posMax), f.ok && (E = t.md.normalizeLink(f.str), t.md.validateLink(E) ? c = f.pos : E = ""), h = c; c < g && (i = t.src.charCodeAt(c), !(!PR(i) && i !== 10)); c++)
      ;
    if (f = t.md.helpers.parseLinkTitle(t.src, c, t.posMax), c < g && h !== c && f.ok)
      for (d = f.str, c = f.pos; c < g && (i = t.src.charCodeAt(c), !(!PR(i) && i !== 10)); c++)
        ;
    else
      d = "";
    if (c >= g || t.src.charCodeAt(c) !== 41)
      return t.pos = m, !1;
    c++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (c < g && t.src.charCodeAt(c) === 91 ? (h = c + 1, c = t.md.helpers.parseLinkLabel(t, c), c >= 0 ? a = t.src.slice(h, c++) : c = u + 1) : c = u + 1, a || (a = t.src.slice(s, u)), l = t.env.references[ckt(a)], !l)
      return t.pos = m, !1;
    E = l.href, d = l.title;
  }
  return r || (o = t.src.slice(s, u), t.md.inline.parse(
    o,
    t.md,
    t.env,
    v = []
  ), p = t.push("image", "img", 0), p.attrs = n = [["src", E], ["alt", ""]], p.children = v, p.content = o, d && n.push(["title", d])), t.pos = c, t.posMax = g, !0;
}, fkt = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, dkt = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/, pkt = function(t, r) {
  var n, i, o, a, u, s, c = t.pos;
  if (t.src.charCodeAt(c) !== 60)
    return !1;
  for (u = t.pos, s = t.posMax; ; ) {
    if (++c >= s || (a = t.src.charCodeAt(c), a === 60)) return !1;
    if (a === 62) break;
  }
  return n = t.src.slice(u + 1, c), dkt.test(n) ? (i = t.md.normalizeLink(n), t.md.validateLink(i) ? (r || (o = t.push("link_open", "a", 1), o.attrs = [["href", i]], o.markup = "autolink", o.info = "auto", o = t.push("text", "", 0), o.content = t.md.normalizeLinkText(n), o = t.push("link_close", "a", -1), o.markup = "autolink", o.info = "auto"), t.pos += n.length + 2, !0) : !1) : fkt.test(n) ? (i = t.md.normalizeLink("mailto:" + n), t.md.validateLink(i) ? (r || (o = t.push("link_open", "a", 1), o.attrs = [["href", i]], o.markup = "autolink", o.info = "auto", o = t.push("text", "", 0), o.content = t.md.normalizeLinkText(n), o = t.push("link_close", "a", -1), o.markup = "autolink", o.info = "auto"), t.pos += n.length + 2, !0) : !1) : !1;
}, hkt = IC.HTML_TAG_RE;
function vkt(e) {
  return /^<a[>\s]/i.test(e);
}
function Ekt(e) {
  return /^<\/a\s*>/i.test(e);
}
function mkt(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
var gkt = function(t, r) {
  var n, i, o, a, u = t.pos;
  return !t.md.options.html || (o = t.posMax, t.src.charCodeAt(u) !== 60 || u + 2 >= o) || (n = t.src.charCodeAt(u + 1), n !== 33 && n !== 63 && n !== 47 && !mkt(n)) || (i = t.src.slice(u).match(hkt), !i) ? !1 : (r || (a = t.push("html_inline", "", 0), a.content = i[0], vkt(a.content) && t.linkLevel++, Ekt(a.content) && t.linkLevel--), t.pos += i[0].length, !0);
}, RG = qhe, Tkt = Cn.has, ykt = Cn.isValidEntityCode, wG = Cn.fromCodePoint, _kt = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, Akt = /^&([a-z][a-z0-9]{1,31});/i, Skt = function(t, r) {
  var n, i, o, a, u = t.pos, s = t.posMax;
  if (t.src.charCodeAt(u) !== 38 || u + 1 >= s) return !1;
  if (n = t.src.charCodeAt(u + 1), n === 35) {
    if (o = t.src.slice(u).match(_kt), o)
      return r || (i = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), a = t.push("text_special", "", 0), a.content = ykt(i) ? wG(i) : wG(65533), a.markup = o[0], a.info = "entity"), t.pos += o[0].length, !0;
  } else if (o = t.src.slice(u).match(Akt), o && Tkt(RG, o[1]))
    return r || (a = t.push("text_special", "", 0), a.content = RG[o[1]], a.markup = o[0], a.info = "entity"), t.pos += o[0].length, !0;
  return !1;
};
function PG(e) {
  var t, r, n, i, o, a, u, s, c = {}, l = e.length;
  if (l) {
    var f = 0, d = -2, p = [];
    for (t = 0; t < l; t++)
      if (n = e[t], p.push(0), (e[f].marker !== n.marker || d !== n.token - 1) && (f = t), d = n.token, n.length = n.length || 0, !!n.close) {
        for (c.hasOwnProperty(n.marker) || (c[n.marker] = [-1, -1, -1, -1, -1, -1]), o = c[n.marker][(n.open ? 3 : 0) + n.length % 3], r = f - p[f] - 1, a = r; r > o; r -= p[r] + 1)
          if (i = e[r], i.marker === n.marker && i.open && i.end < 0 && (u = !1, (i.close || n.open) && (i.length + n.length) % 3 === 0 && (i.length % 3 !== 0 || n.length % 3 !== 0) && (u = !0), !u)) {
            s = r > 0 && !e[r - 1].open ? p[r - 1] + 1 : 0, p[t] = t - r + s, p[r] = s, n.open = !1, i.end = t, i.close = !1, a = -1, d = -2;
            break;
          }
        a !== -1 && (c[n.marker][(n.open ? 3 : 0) + (n.length || 0) % 3] = a);
      }
  }
}
var bkt = function(t) {
  var r, n = t.tokens_meta, i = t.tokens_meta.length;
  for (PG(t.delimiters), r = 0; r < i; r++)
    n[r] && n[r].delimiters && PG(n[r].delimiters);
}, Ckt = function(t) {
  var r, n, i = 0, o = t.tokens, a = t.tokens.length;
  for (r = n = 0; r < a; r++)
    o[r].nesting < 0 && i--, o[r].level = i, o[r].nesting > 0 && i++, o[r].type === "text" && r + 1 < a && o[r + 1].type === "text" ? o[r + 1].content = o[r].content + o[r + 1].content : (r !== n && (o[n] = o[r]), n++);
  r !== n && (o.length = n);
}, Z9 = K9, DG = Cn.isWhiteSpace, xG = Cn.isPunctChar, NG = Cn.isMdAsciiPunct;
function sy(e, t, r, n) {
  this.src = e, this.env = r, this.md = t, this.tokens = n, this.tokens_meta = Array(n.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
sy.prototype.pushPending = function() {
  var e = new Z9("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
sy.prototype.push = function(e, t, r) {
  this.pending && this.pushPending();
  var n = new Z9(e, t, r), i = null;
  return r < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), n.level = this.level, r > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], i = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(n), this.tokens_meta.push(i), n;
};
sy.prototype.scanDelims = function(e, t) {
  var r = e, n, i, o, a, u, s, c, l, f, d = !0, p = !0, v = this.posMax, h = this.src.charCodeAt(e);
  for (n = e > 0 ? this.src.charCodeAt(e - 1) : 32; r < v && this.src.charCodeAt(r) === h; )
    r++;
  return o = r - e, i = r < v ? this.src.charCodeAt(r) : 32, c = NG(n) || xG(String.fromCharCode(n)), f = NG(i) || xG(String.fromCharCode(i)), s = DG(n), l = DG(i), l ? d = !1 : f && (s || c || (d = !1)), s ? p = !1 : c && (l || f || (p = !1)), t ? (a = d, u = p) : (a = d && (!p || c), u = p && (!d || f)), {
    can_open: a,
    can_close: u,
    length: o
  };
};
sy.prototype.Token = Z9;
var Ikt = sy, LG = W9, DR = [
  ["text", Q8t],
  ["linkify", tkt],
  ["newline", nkt],
  ["escape", okt],
  ["backticks", akt],
  ["strikethrough", wC.tokenize],
  ["emphasis", PC.tokenize],
  ["link", skt],
  ["image", lkt],
  ["autolink", pkt],
  ["html_inline", gkt],
  ["entity", Skt]
], xR = [
  ["balance_pairs", bkt],
  ["strikethrough", wC.postProcess],
  ["emphasis", PC.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", Ckt]
];
function cy() {
  var e;
  for (this.ruler = new LG(), e = 0; e < DR.length; e++)
    this.ruler.push(DR[e][0], DR[e][1]);
  for (this.ruler2 = new LG(), e = 0; e < xR.length; e++)
    this.ruler2.push(xR[e][0], xR[e][1]);
}
cy.prototype.skipToken = function(e) {
  var t, r, n = e.pos, i = this.ruler.getRules(""), o = i.length, a = e.md.options.maxNesting, u = e.cache;
  if (typeof u[n] < "u") {
    e.pos = u[n];
    return;
  }
  if (e.level < a) {
    for (r = 0; r < o; r++)
      if (e.level++, t = i[r](e, !0), e.level--, t) {
        if (n >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  t || e.pos++, u[n] = e.pos;
};
cy.prototype.tokenize = function(e) {
  for (var t, r, n, i = this.ruler.getRules(""), o = i.length, a = e.posMax, u = e.md.options.maxNesting; e.pos < a; ) {
    if (n = e.pos, e.level < u) {
      for (r = 0; r < o; r++)
        if (t = i[r](e, !1), t) {
          if (n >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (t) {
      if (e.pos >= a)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
cy.prototype.parse = function(e, t, r, n) {
  var i, o, a, u = new this.State(e, t, r, n);
  for (this.tokenize(u), o = this.ruler2.getRules(""), a = o.length, i = 0; i < a; i++)
    o[i](u);
};
cy.prototype.State = Ikt;
var Okt = cy, NR, BG;
function Rkt() {
  return BG || (BG = 1, NR = function(e) {
    var t = {};
    e = e || {}, t.src_Any = Yhe().source, t.src_Cc = Ghe().source, t.src_Z = Whe().source, t.src_P = G9.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
    var r = "[><｜]";
    return t.src_pseudo_letter = "(?:(?!" + r + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + r + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + r + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + r + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
  }), NR;
}
function kL(e) {
  var t = Array.prototype.slice.call(arguments, 1);
  return t.forEach(function(r) {
    r && Object.keys(r).forEach(function(n) {
      e[n] = r[n];
    });
  }), e;
}
function DC(e) {
  return Object.prototype.toString.call(e);
}
function wkt(e) {
  return DC(e) === "[object String]";
}
function Pkt(e) {
  return DC(e) === "[object Object]";
}
function Dkt(e) {
  return DC(e) === "[object RegExp]";
}
function kG(e) {
  return DC(e) === "[object Function]";
}
function xkt(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
var tve = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function Nkt(e) {
  return Object.keys(e || {}).reduce(function(t, r) {
    return t || tve.hasOwnProperty(r);
  }, !1);
}
var Lkt = {
  "http:": {
    validate: function(e, t, r) {
      var n = e.slice(t);
      return r.re.http || (r.re.http = new RegExp(
        "^\\/\\/" + r.re.src_auth + r.re.src_host_port_strict + r.re.src_path,
        "i"
      )), r.re.http.test(n) ? n.match(r.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, r) {
      var n = e.slice(t);
      return r.re.no_http || (r.re.no_http = new RegExp(
        "^" + r.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + r.re.src_domain + ")\\.)+" + r.re.src_domain_root + ")" + r.re.src_port + r.re.src_host_terminator + r.re.src_path,
        "i"
      )), r.re.no_http.test(n) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : n.match(r.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, r) {
      var n = e.slice(t);
      return r.re.mailto || (r.re.mailto = new RegExp(
        "^" + r.re.src_email_name + "@" + r.re.src_host_strict,
        "i"
      )), r.re.mailto.test(n) ? n.match(r.re.mailto)[0].length : 0;
    }
  }
}, Bkt = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", kkt = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function Mkt(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function Fkt(e) {
  return function(t, r) {
    var n = t.slice(r);
    return e.test(n) ? n.match(e)[0].length : 0;
  };
}
function MG() {
  return function(e, t) {
    t.normalize(e);
  };
}
function PS(e) {
  var t = e.re = Rkt()(e.__opts__), r = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || r.push(Bkt), r.push(t.src_xn), t.src_tlds = r.join("|");
  function n(u) {
    return u.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(n(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(n(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(n(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(n(t.tpl_host_fuzzy_test), "i");
  var i = [];
  e.__compiled__ = {};
  function o(u, s) {
    throw new Error('(LinkifyIt) Invalid schema "' + u + '": ' + s);
  }
  Object.keys(e.__schemas__).forEach(function(u) {
    var s = e.__schemas__[u];
    if (s !== null) {
      var c = { validate: null, link: null };
      if (e.__compiled__[u] = c, Pkt(s)) {
        Dkt(s.validate) ? c.validate = Fkt(s.validate) : kG(s.validate) ? c.validate = s.validate : o(u, s), kG(s.normalize) ? c.normalize = s.normalize : s.normalize ? o(u, s) : c.normalize = MG();
        return;
      }
      if (wkt(s)) {
        i.push(u);
        return;
      }
      o(u, s);
    }
  }), i.forEach(function(u) {
    e.__compiled__[e.__schemas__[u]] && (e.__compiled__[u].validate = e.__compiled__[e.__schemas__[u]].validate, e.__compiled__[u].normalize = e.__compiled__[e.__schemas__[u]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: MG() };
  var a = Object.keys(e.__compiled__).filter(function(u) {
    return u.length > 0 && e.__compiled__[u];
  }).map(xkt).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), Mkt(e);
}
function Hkt(e, t) {
  var r = e.__index__, n = e.__last_index__, i = e.__text_cache__.slice(r, n);
  this.schema = e.__schema__.toLowerCase(), this.index = r + t, this.lastIndex = n + t, this.raw = i, this.text = i, this.url = i;
}
function ML(e, t) {
  var r = new Hkt(e, t);
  return e.__compiled__[r.schema].normalize(r, e), r;
}
function uu(e, t) {
  if (!(this instanceof uu))
    return new uu(e, t);
  t || Nkt(e) && (t = e, e = {}), this.__opts__ = kL({}, tve, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = kL({}, Lkt, e), this.__compiled__ = {}, this.__tlds__ = kkt, this.__tlds_replaced__ = !1, this.re = {}, PS(this);
}
uu.prototype.add = function(t, r) {
  return this.__schemas__[t] = r, PS(this), this;
};
uu.prototype.set = function(t) {
  return this.__opts__ = kL(this.__opts__, t), this;
};
uu.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  var r, n, i, o, a, u, s, c, l;
  if (this.re.schema_test.test(t)) {
    for (s = this.re.schema_search, s.lastIndex = 0; (r = s.exec(t)) !== null; )
      if (o = this.testSchemaAt(t, r[2], s.lastIndex), o) {
        this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = t.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (n = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (a = n.index + n[1].length, (this.__index__ < 0 || a < this.__index__) && (this.__schema__ = "", this.__index__ = a, this.__last_index__ = n.index + n[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (l = t.indexOf("@"), l >= 0 && (i = t.match(this.re.email_fuzzy)) !== null && (a = i.index + i[1].length, u = i.index + i[0].length, (this.__index__ < 0 || a < this.__index__ || a === this.__index__ && u > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = a, this.__last_index__ = u))), this.__index__ >= 0;
};
uu.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
uu.prototype.testSchemaAt = function(t, r, n) {
  return this.__compiled__[r.toLowerCase()] ? this.__compiled__[r.toLowerCase()].validate(t, n, this) : 0;
};
uu.prototype.match = function(t) {
  var r = 0, n = [];
  this.__index__ >= 0 && this.__text_cache__ === t && (n.push(ML(this, r)), r = this.__last_index__);
  for (var i = r ? t.slice(r) : t; this.test(i); )
    n.push(ML(this, r)), i = i.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
uu.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  var r = this.re.schema_at_start.exec(t);
  if (!r) return null;
  var n = this.testSchemaAt(t, r[2], r[0].length);
  return n ? (this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + n, ML(this, 0)) : null;
};
uu.prototype.tlds = function(t, r) {
  return t = Array.isArray(t) ? t : [t], r ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(n, i, o) {
    return n !== o[i - 1];
  }).reverse(), PS(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, PS(this), this);
};
uu.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
uu.prototype.onCompile = function() {
};
var $kt = uu;
const Sp = 2147483647, Ys = 36, Q9 = 1, G1 = 26, Ukt = 38, Vkt = 700, rve = 72, nve = 128, ive = "-", jkt = /^xn--/, zkt = /[^\0-\x7F]/, qkt = /[\x2E\u3002\uFF0E\uFF61]/g, Ykt = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, LR = Ys - Q9, Gs = Math.floor, BR = String.fromCharCode;
function Fl(e) {
  throw new RangeError(Ykt[e]);
}
function Gkt(e, t) {
  const r = [];
  let n = e.length;
  for (; n--; )
    r[n] = t(e[n]);
  return r;
}
function ove(e, t) {
  const r = e.split("@");
  let n = "";
  r.length > 1 && (n = r[0] + "@", e = r[1]), e = e.replace(qkt, ".");
  const i = e.split("."), o = Gkt(i, t).join(".");
  return n + o;
}
function eM(e) {
  const t = [];
  let r = 0;
  const n = e.length;
  for (; r < n; ) {
    const i = e.charCodeAt(r++);
    if (i >= 55296 && i <= 56319 && r < n) {
      const o = e.charCodeAt(r++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), r--);
    } else
      t.push(i);
  }
  return t;
}
const ave = (e) => String.fromCodePoint(...e), Wkt = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : Ys;
}, FG = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, uve = function(e, t, r) {
  let n = 0;
  for (e = r ? Gs(e / Vkt) : e >> 1, e += Gs(e / t); e > LR * G1 >> 1; n += Ys)
    e = Gs(e / LR);
  return Gs(n + (LR + 1) * e / (e + Ukt));
}, tM = function(e) {
  const t = [], r = e.length;
  let n = 0, i = nve, o = rve, a = e.lastIndexOf(ive);
  a < 0 && (a = 0);
  for (let u = 0; u < a; ++u)
    e.charCodeAt(u) >= 128 && Fl("not-basic"), t.push(e.charCodeAt(u));
  for (let u = a > 0 ? a + 1 : 0; u < r; ) {
    const s = n;
    for (let l = 1, f = Ys; ; f += Ys) {
      u >= r && Fl("invalid-input");
      const d = Wkt(e.charCodeAt(u++));
      d >= Ys && Fl("invalid-input"), d > Gs((Sp - n) / l) && Fl("overflow"), n += d * l;
      const p = f <= o ? Q9 : f >= o + G1 ? G1 : f - o;
      if (d < p)
        break;
      const v = Ys - p;
      l > Gs(Sp / v) && Fl("overflow"), l *= v;
    }
    const c = t.length + 1;
    o = uve(n - s, c, s == 0), Gs(n / c) > Sp - i && Fl("overflow"), i += Gs(n / c), n %= c, t.splice(n++, 0, i);
  }
  return String.fromCodePoint(...t);
}, rM = function(e) {
  const t = [];
  e = eM(e);
  const r = e.length;
  let n = nve, i = 0, o = rve;
  for (const s of e)
    s < 128 && t.push(BR(s));
  const a = t.length;
  let u = a;
  for (a && t.push(ive); u < r; ) {
    let s = Sp;
    for (const l of e)
      l >= n && l < s && (s = l);
    const c = u + 1;
    s - n > Gs((Sp - i) / c) && Fl("overflow"), i += (s - n) * c, n = s;
    for (const l of e)
      if (l < n && ++i > Sp && Fl("overflow"), l === n) {
        let f = i;
        for (let d = Ys; ; d += Ys) {
          const p = d <= o ? Q9 : d >= o + G1 ? G1 : d - o;
          if (f < p)
            break;
          const v = f - p, h = Ys - p;
          t.push(
            BR(FG(p + v % h, 0))
          ), f = Gs(v / h);
        }
        t.push(BR(FG(f, 0))), o = uve(i, c, u === a), i = 0, ++u;
      }
    ++i, ++n;
  }
  return t.join("");
}, sve = function(e) {
  return ove(e, function(t) {
    return jkt.test(t) ? tM(t.slice(4).toLowerCase()) : t;
  });
}, cve = function(e) {
  return ove(e, function(t) {
    return zkt.test(t) ? "xn--" + rM(t) : t;
  });
}, Kkt = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: eM,
    encode: ave
  },
  decode: tM,
  encode: rM,
  toASCII: cve,
  toUnicode: sve
}, Xkt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: tM,
  default: Kkt,
  encode: rM,
  toASCII: cve,
  toUnicode: sve,
  ucs2decode: eM,
  ucs2encode: ave
}, Symbol.toStringTag, { value: "Module" })), Jkt = /* @__PURE__ */ lh(Xkt);
var Zkt = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 100
    // Internal protection, recursion limit
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, Qkt = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, e9t = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, _1 = Cn, t9t = CC, r9t = WBt, n9t = g8t, i9t = J8t, o9t = Okt, a9t = $kt, vf = Bh, lve = Jkt, u9t = {
  default: Zkt,
  zero: Qkt,
  commonmark: e9t
}, s9t = /^(vbscript|javascript|file|data):/, c9t = /^data:image\/(gif|png|jpeg|webp);/;
function l9t(e) {
  var t = e.trim().toLowerCase();
  return s9t.test(t) ? !!c9t.test(t) : !0;
}
var fve = ["http:", "https:", "mailto:"];
function f9t(e) {
  var t = vf.parse(e, !0);
  if (t.hostname && (!t.protocol || fve.indexOf(t.protocol) >= 0))
    try {
      t.hostname = lve.toASCII(t.hostname);
    } catch {
    }
  return vf.encode(vf.format(t));
}
function d9t(e) {
  var t = vf.parse(e, !0);
  if (t.hostname && (!t.protocol || fve.indexOf(t.protocol) >= 0))
    try {
      t.hostname = lve.toUnicode(t.hostname);
    } catch {
    }
  return vf.decode(vf.format(t), vf.decode.defaultChars + "%");
}
function ku(e, t) {
  if (!(this instanceof ku))
    return new ku(e, t);
  t || _1.isString(e) || (t = e || {}, e = "default"), this.inline = new o9t(), this.block = new i9t(), this.core = new n9t(), this.renderer = new r9t(), this.linkify = new a9t(), this.validateLink = l9t, this.normalizeLink = f9t, this.normalizeLinkText = d9t, this.utils = _1, this.helpers = _1.assign({}, t9t), this.options = {}, this.configure(e), t && this.set(t);
}
ku.prototype.set = function(e) {
  return _1.assign(this.options, e), this;
};
ku.prototype.configure = function(e) {
  var t = this, r;
  if (_1.isString(e) && (r = e, e = u9t[r], !e))
    throw new Error('Wrong `markdown-it` preset "' + r + '", check name');
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
  }), this;
};
ku.prototype.enable = function(e, t) {
  var r = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    r = r.concat(this[i].ruler.enable(e, !0));
  }, this), r = r.concat(this.inline.ruler2.enable(e, !0));
  var n = e.filter(function(i) {
    return r.indexOf(i) < 0;
  });
  if (n.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + n);
  return this;
};
ku.prototype.disable = function(e, t) {
  var r = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    r = r.concat(this[i].ruler.disable(e, !0));
  }, this), r = r.concat(this.inline.ruler2.disable(e, !0));
  var n = e.filter(function(i) {
    return r.indexOf(i) < 0;
  });
  if (n.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + n);
  return this;
};
ku.prototype.use = function(e) {
  var t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
ku.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  var r = new this.core.State(e, this, t);
  return this.core.process(r), r.tokens;
};
ku.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
ku.prototype.parseInline = function(e, t) {
  var r = new this.core.State(e, this, t);
  return r.inlineMode = !0, this.core.process(r), r.tokens;
};
ku.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var p9t = ku, h9t = p9t;
const xC = /* @__PURE__ */ Mt(h9t);
var NC = {};
NC.byteLength = m9t;
var nM = NC.toByteArray = T9t;
NC.fromByteArray = A9t;
var zs = [], Ou = [], v9t = typeof Uint8Array < "u" ? Uint8Array : Array, kR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var $d = 0, E9t = kR.length; $d < E9t; ++$d)
  zs[$d] = kR[$d], Ou[kR.charCodeAt($d)] = $d;
Ou[45] = 62;
Ou[95] = 63;
function dve(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var n = r === t ? 0 : 4 - r % 4;
  return [r, n];
}
function m9t(e) {
  var t = dve(e), r = t[0], n = t[1];
  return (r + n) * 3 / 4 - n;
}
function g9t(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function T9t(e) {
  var t, r = dve(e), n = r[0], i = r[1], o = new v9t(g9t(e, n, i)), a = 0, u = i > 0 ? n - 4 : n, s;
  for (s = 0; s < u; s += 4)
    t = Ou[e.charCodeAt(s)] << 18 | Ou[e.charCodeAt(s + 1)] << 12 | Ou[e.charCodeAt(s + 2)] << 6 | Ou[e.charCodeAt(s + 3)], o[a++] = t >> 16 & 255, o[a++] = t >> 8 & 255, o[a++] = t & 255;
  return i === 2 && (t = Ou[e.charCodeAt(s)] << 2 | Ou[e.charCodeAt(s + 1)] >> 4, o[a++] = t & 255), i === 1 && (t = Ou[e.charCodeAt(s)] << 10 | Ou[e.charCodeAt(s + 1)] << 4 | Ou[e.charCodeAt(s + 2)] >> 2, o[a++] = t >> 8 & 255, o[a++] = t & 255), o;
}
function y9t(e) {
  return zs[e >> 18 & 63] + zs[e >> 12 & 63] + zs[e >> 6 & 63] + zs[e & 63];
}
function _9t(e, t, r) {
  for (var n, i = [], o = t; o < r; o += 3)
    n = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (e[o + 2] & 255), i.push(y9t(n));
  return i.join("");
}
function A9t(e) {
  for (var t, r = e.length, n = r % 3, i = [], o = 16383, a = 0, u = r - n; a < u; a += o)
    i.push(_9t(e, a, a + o > u ? u : a + o));
  return n === 1 ? (t = e[r - 1], i.push(
    zs[t >> 2] + zs[t << 4 & 63] + "=="
  )) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], i.push(
    zs[t >> 10] + zs[t >> 4 & 63] + zs[t << 2 & 63] + "="
  )), i.join("");
}
const S9t = {};
function b9t(e, t) {
  const r = S9t, n = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, i = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return pve(e, n, i);
}
function pve(e, t, r) {
  if (C9t(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return HG(e.children, t, r);
  }
  return Array.isArray(e) ? HG(e, t, r) : "";
}
function HG(e, t, r) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; )
    n[i] = pve(e[i], t, r);
  return n.join("");
}
function C9t(e) {
  return !!(e && typeof e == "object");
}
const $G = document.createElement("i");
function iM(e) {
  const t = "&" + e + ";";
  $G.innerHTML = t;
  const r = $G.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === t ? !1 : r;
}
function Wc(e, t, r, n) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, r = r > 0 ? r : 0, n.length < 1e4)
    a = Array.from(n), a.unshift(t, r), e.splice(...a);
  else
    for (r && e.splice(t, r); o < n.length; )
      a = n.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function Pu(e, t) {
  return e.length > 0 ? (Wc(e, e.length, 0, t), e) : t;
}
const UG = {}.hasOwnProperty;
function I9t(e) {
  const t = {};
  let r = -1;
  for (; ++r < e.length; )
    O9t(t, e[r]);
  return t;
}
function O9t(e, t) {
  let r;
  for (r in t) {
    const i = (UG.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = t[r];
    let a;
    if (o)
      for (a in o) {
        UG.call(i, a) || (i[a] = []);
        const u = o[a];
        R9t(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(u) ? u : u ? [u] : []
        );
      }
  }
}
function R9t(e, t) {
  let r = -1;
  const n = [];
  for (; ++r < t.length; )
    (t[r].add === "after" ? e : n).push(t[r]);
  Wc(e, 0, 0, n);
}
function hve(e, t) {
  const r = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function bp(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const qs = f0(/[A-Za-z]/), ds = f0(/[\dA-Za-z]/), w9t = f0(/[#-'*+\--9=?A-Z^-~]/);
function FL(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const HL = f0(/\d/), P9t = f0(/[\dA-Fa-f]/), D9t = f0(/[!-/:-@[-`{-~]/);
function Cr(e) {
  return e !== null && e < -2;
}
function Ba(e) {
  return e !== null && (e < 0 || e === 32);
}
function Sn(e) {
  return e === -2 || e === -1 || e === 32;
}
const x9t = f0(new RegExp("\\p{P}|\\p{S}", "u")), N9t = f0(/\s/);
function f0(e) {
  return t;
  function t(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Qn(e, t, r, n) {
  const i = n ? n - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(s) {
    return Sn(s) ? (e.enter(r), u(s)) : t(s);
  }
  function u(s) {
    return Sn(s) && o++ < i ? (e.consume(s), u) : (e.exit(r), t(s));
  }
}
const L9t = {
  tokenize: B9t
};
function B9t(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    n,
    i
  );
  let r;
  return t;
  function n(u) {
    if (u === null) {
      e.consume(u);
      return;
    }
    return e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), Qn(e, t, "linePrefix");
  }
  function i(u) {
    return e.enter("paragraph"), o(u);
  }
  function o(u) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = s), r = s, a(u);
  }
  function a(u) {
    if (u === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(u);
      return;
    }
    return Cr(u) ? (e.consume(u), e.exit("chunkText"), o) : (e.consume(u), a);
  }
}
const k9t = {
  tokenize: M9t
}, VG = {
  tokenize: F9t
};
function M9t(e) {
  const t = this, r = [];
  let n = 0, i, o, a;
  return u;
  function u(y) {
    if (n < r.length) {
      const _ = r[n];
      return t.containerState = _[1], e.attempt(
        _[0].continuation,
        s,
        c
      )(y);
    }
    return c(y);
  }
  function s(y) {
    if (n++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && g();
      const _ = t.events.length;
      let S = _, A;
      for (; S--; )
        if (t.events[S][0] === "exit" && t.events[S][1].type === "chunkFlow") {
          A = t.events[S][1].end;
          break;
        }
      m(n);
      let O = _;
      for (; O < t.events.length; )
        t.events[O][1].end = Object.assign({}, A), O++;
      return Wc(
        t.events,
        S + 1,
        0,
        t.events.slice(_)
      ), t.events.length = O, c(y);
    }
    return u(y);
  }
  function c(y) {
    if (n === r.length) {
      if (!i)
        return d(y);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return v(y);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      VG,
      l,
      f
    )(y);
  }
  function l(y) {
    return i && g(), m(n), d(y);
  }
  function f(y) {
    return t.parser.lazy[t.now().line] = n !== r.length, a = t.now().offset, v(y);
  }
  function d(y) {
    return t.containerState = {}, e.attempt(
      VG,
      p,
      v
    )(y);
  }
  function p(y) {
    return n++, r.push([t.currentConstruct, t.containerState]), d(y);
  }
  function v(y) {
    if (y === null) {
      i && g(), m(0), e.consume(y);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), h(y);
  }
  function h(y) {
    if (y === null) {
      E(e.exit("chunkFlow"), !0), m(0), e.consume(y);
      return;
    }
    return Cr(y) ? (e.consume(y), E(e.exit("chunkFlow")), n = 0, t.interrupt = void 0, u) : (e.consume(y), h);
  }
  function E(y, _) {
    const S = t.sliceStream(y);
    if (_ && S.push(null), y.previous = o, o && (o.next = y), o = y, i.defineSkip(y.start), i.write(S), t.parser.lazy[y.start.line]) {
      let A = i.events.length;
      for (; A--; )
        if (
          // The token starts before the line ending…
          i.events[A][1].start.offset < a && // …and either is not ended yet…
          (!i.events[A][1].end || // …or ends after it.
          i.events[A][1].end.offset > a)
        )
          return;
      const O = t.events.length;
      let P = O, U, z;
      for (; P--; )
        if (t.events[P][0] === "exit" && t.events[P][1].type === "chunkFlow") {
          if (U) {
            z = t.events[P][1].end;
            break;
          }
          U = !0;
        }
      for (m(n), A = O; A < t.events.length; )
        t.events[A][1].end = Object.assign({}, z), A++;
      Wc(
        t.events,
        P + 1,
        0,
        t.events.slice(O)
      ), t.events.length = A;
    }
  }
  function m(y) {
    let _ = r.length;
    for (; _-- > y; ) {
      const S = r[_];
      t.containerState = S[1], S[0].exit.call(t, e);
    }
    r.length = y;
  }
  function g() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function F9t(e, t, r) {
  return Qn(
    e,
    e.attempt(this.parser.constructs.document, t, r),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function jG(e) {
  if (e === null || Ba(e) || N9t(e))
    return 1;
  if (x9t(e))
    return 2;
}
function oM(e, t, r) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !n.includes(o) && (t = o(t, r), n.push(o));
  }
  return t;
}
const $L = {
  name: "attention",
  tokenize: $9t,
  resolveAll: H9t
};
function H9t(e, t) {
  let r = -1, n, i, o, a, u, s, c, l;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (n = r; n--; )
        if (e[n][0] === "exit" && e[n][1].type === "attentionSequence" && e[n][1]._open && // If the markers are the same:
        t.sliceSerialize(e[n][1]).charCodeAt(0) === t.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[n][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[n][1].end.offset - e[n][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          s = e[n][1].end.offset - e[n][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = Object.assign({}, e[n][1].end), d = Object.assign({}, e[r][1].start);
          zG(f, -s), zG(d, s), a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: Object.assign({}, e[n][1].end)
          }, u = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[r][1].start),
            end: d
          }, o = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[n][1].end),
            end: Object.assign({}, e[r][1].start)
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, u.end)
          }, e[n][1].end = Object.assign({}, a.start), e[r][1].start = Object.assign({}, u.end), c = [], e[n][1].end.offset - e[n][1].start.offset && (c = Pu(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])), c = Pu(c, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["enter", o, t]]), c = Pu(c, oM(t.parser.constructs.insideSpan.null, e.slice(n + 1, r), t)), c = Pu(c, [["exit", o, t], ["enter", u, t], ["exit", u, t], ["exit", i, t]]), e[r][1].end.offset - e[r][1].start.offset ? (l = 2, c = Pu(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])) : l = 0, Wc(e, n - 1, r - n + 3, c), r = n + c.length - l - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function $9t(e, t) {
  const r = this.parser.constructs.attentionMarkers.null, n = this.previous, i = jG(n);
  let o;
  return a;
  function a(s) {
    return o = s, e.enter("attentionSequence"), u(s);
  }
  function u(s) {
    if (s === o)
      return e.consume(s), u;
    const c = e.exit("attentionSequence"), l = jG(s), f = !l || l === 2 && i || r.includes(s), d = !i || i === 2 && l || r.includes(n);
    return c._open = !!(o === 42 ? f : f && (i || !d)), c._close = !!(o === 42 ? d : d && (l || !f)), t(s);
  }
}
function zG(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const U9t = {
  name: "autolink",
  tokenize: V9t
};
function V9t(e, t, r) {
  let n = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(p) {
    return qs(p) ? (e.consume(p), a) : p === 64 ? r(p) : c(p);
  }
  function a(p) {
    return p === 43 || p === 45 || p === 46 || ds(p) ? (n = 1, u(p)) : c(p);
  }
  function u(p) {
    return p === 58 ? (e.consume(p), n = 0, s) : (p === 43 || p === 45 || p === 46 || ds(p)) && n++ < 32 ? (e.consume(p), u) : (n = 0, c(p));
  }
  function s(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || FL(p) ? r(p) : (e.consume(p), s);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), l) : w9t(p) ? (e.consume(p), c) : r(p);
  }
  function l(p) {
    return ds(p) ? f(p) : r(p);
  }
  function f(p) {
    return p === 46 ? (e.consume(p), n = 0, l) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : d(p);
  }
  function d(p) {
    if ((p === 45 || ds(p)) && n++ < 63) {
      const v = p === 45 ? d : f;
      return e.consume(p), v;
    }
    return r(p);
  }
}
const LC = {
  tokenize: j9t,
  partial: !0
};
function j9t(e, t, r) {
  return n;
  function n(o) {
    return Sn(o) ? Qn(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Cr(o) ? t(o) : r(o);
  }
}
const vve = {
  name: "blockQuote",
  tokenize: z9t,
  continuation: {
    tokenize: q9t
  },
  exit: Y9t
};
function z9t(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    if (a === 62) {
      const u = n.containerState;
      return u.open || (e.enter("blockQuote", {
        _container: !0
      }), u.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return r(a);
  }
  function o(a) {
    return Sn(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function q9t(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return Sn(a) ? Qn(e, o, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a) : o(a);
  }
  function o(a) {
    return e.attempt(vve, t, r)(a);
  }
}
function Y9t(e) {
  e.exit("blockQuote");
}
const Eve = {
  name: "characterEscape",
  tokenize: G9t
};
function G9t(e, t, r) {
  return n;
  function n(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return D9t(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : r(o);
  }
}
const mve = {
  name: "characterReference",
  tokenize: W9t
};
function W9t(e, t, r) {
  const n = this;
  let i = 0, o, a;
  return u;
  function u(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), s;
  }
  function s(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), o = 31, a = ds, l(f));
  }
  function c(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = P9t, l) : (e.enter("characterReferenceValue"), o = 7, a = HL, l(f));
  }
  function l(f) {
    if (f === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return a === ds && !iM(n.sliceSerialize(d)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(f) && i++ < o ? (e.consume(f), l) : r(f);
  }
}
const qG = {
  tokenize: X9t,
  partial: !0
}, YG = {
  name: "codeFenced",
  tokenize: K9t,
  concrete: !0
};
function K9t(e, t, r) {
  const n = this, i = {
    tokenize: S,
    partial: !0
  };
  let o = 0, a = 0, u;
  return s;
  function s(A) {
    return c(A);
  }
  function c(A) {
    const O = n.events[n.events.length - 1];
    return o = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, u = A, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), l(A);
  }
  function l(A) {
    return A === u ? (a++, e.consume(A), l) : a < 3 ? r(A) : (e.exit("codeFencedFenceSequence"), Sn(A) ? Qn(e, f, "whitespace")(A) : f(A));
  }
  function f(A) {
    return A === null || Cr(A) ? (e.exit("codeFencedFence"), n.interrupt ? t(A) : e.check(qG, h, _)(A)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(A));
  }
  function d(A) {
    return A === null || Cr(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(A)) : Sn(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Qn(e, p, "whitespace")(A)) : A === 96 && A === u ? r(A) : (e.consume(A), d);
  }
  function p(A) {
    return A === null || Cr(A) ? f(A) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), v(A));
  }
  function v(A) {
    return A === null || Cr(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(A)) : A === 96 && A === u ? r(A) : (e.consume(A), v);
  }
  function h(A) {
    return e.attempt(i, _, E)(A);
  }
  function E(A) {
    return e.enter("lineEnding"), e.consume(A), e.exit("lineEnding"), m;
  }
  function m(A) {
    return o > 0 && Sn(A) ? Qn(e, g, "linePrefix", o + 1)(A) : g(A);
  }
  function g(A) {
    return A === null || Cr(A) ? e.check(qG, h, _)(A) : (e.enter("codeFlowValue"), y(A));
  }
  function y(A) {
    return A === null || Cr(A) ? (e.exit("codeFlowValue"), g(A)) : (e.consume(A), y);
  }
  function _(A) {
    return e.exit("codeFenced"), t(A);
  }
  function S(A, O, P) {
    let U = 0;
    return z;
    function z(D) {
      return A.enter("lineEnding"), A.consume(D), A.exit("lineEnding"), k;
    }
    function k(D) {
      return A.enter("codeFencedFence"), Sn(D) ? Qn(A, H, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : H(D);
    }
    function H(D) {
      return D === u ? (A.enter("codeFencedFenceSequence"), B(D)) : P(D);
    }
    function B(D) {
      return D === u ? (U++, A.consume(D), B) : U >= a ? (A.exit("codeFencedFenceSequence"), Sn(D) ? Qn(A, x, "whitespace")(D) : x(D)) : P(D);
    }
    function x(D) {
      return D === null || Cr(D) ? (A.exit("codeFencedFence"), O(D)) : P(D);
    }
  }
}
function X9t(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return a === null ? r(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return n.parser.lazy[n.now().line] ? r(a) : t(a);
  }
}
const MR = {
  name: "codeIndented",
  tokenize: Z9t
}, J9t = {
  tokenize: Q9t,
  partial: !0
};
function Z9t(e, t, r) {
  const n = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), Qn(e, o, "linePrefix", 5)(c);
  }
  function o(c) {
    const l = n.events[n.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? a(c) : r(c);
  }
  function a(c) {
    return c === null ? s(c) : Cr(c) ? e.attempt(J9t, a, s)(c) : (e.enter("codeFlowValue"), u(c));
  }
  function u(c) {
    return c === null || Cr(c) ? (e.exit("codeFlowValue"), a(c)) : (e.consume(c), u);
  }
  function s(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function Q9t(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return n.parser.lazy[n.now().line] ? r(a) : Cr(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : Qn(e, o, "linePrefix", 5)(a);
  }
  function o(a) {
    const u = n.events[n.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? t(a) : Cr(a) ? i(a) : r(a);
  }
}
const eMt = {
  name: "codeText",
  tokenize: nMt,
  resolve: tMt,
  previous: rMt
};
function tMt(e) {
  let t = e.length - 4, r = 3, n, i;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (n = r; ++n < t; )
      if (e[n][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", r += 2, t -= 2;
        break;
      }
  }
  for (n = r - 1, t++; ++n <= t; )
    i === void 0 ? n !== t && e[n][1].type !== "lineEnding" && (i = n) : (n === t || e[n][1].type === "lineEnding") && (e[i][1].type = "codeTextData", n !== i + 2 && (e[i][1].end = e[n - 1][1].end, e.splice(i + 2, n - i - 2), t -= n - i - 2, n = i + 2), i = void 0);
  return e;
}
function rMt(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function nMt(e, t, r) {
  let n = 0, i, o;
  return a;
  function a(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), u(f);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), n++, u) : (e.exit("codeTextSequence"), s(f));
  }
  function s(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), s) : f === 96 ? (o = e.enter("codeTextSequence"), i = 0, l(f)) : Cr(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), s) : (e.enter("codeTextData"), c(f));
  }
  function c(f) {
    return f === null || f === 32 || f === 96 || Cr(f) ? (e.exit("codeTextData"), s(f)) : (e.consume(f), c);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : i === n ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (o.type = "codeTextData", c(f));
  }
}
class iMt {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, r) {
    const n = r ?? Number.POSITIVE_INFINITY;
    return n < this.left.length ? this.left.slice(t, n) : t > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, r, n) {
    const i = r || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return n && xv(this.left, n), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), xv(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), xv(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const r = this.left.splice(t, Number.POSITIVE_INFINITY);
        xv(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        xv(this.left, r.reverse());
      }
  }
}
function xv(e, t) {
  let r = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; r < t.length; )
      e.push(...t.slice(r, r + 1e4)), r += 1e4;
}
function gve(e) {
  const t = {};
  let r = -1, n, i, o, a, u, s, c;
  const l = new iMt(e);
  for (; ++r < l.length; ) {
    for (; r in t; )
      r = t[r];
    if (n = l.get(r), r && n[1].type === "chunkFlow" && l.get(r - 1)[1].type === "listItemPrefix" && (s = n[1]._tokenizer.events, o = 0, o < s.length && s[o][1].type === "lineEndingBlank" && (o += 2), o < s.length && s[o][1].type === "content"))
      for (; ++o < s.length && s[o][1].type !== "content"; )
        s[o][1].type === "chunkText" && (s[o][1]._isInFirstContentOfListItem = !0, o++);
    if (n[0] === "enter")
      n[1].contentType && (Object.assign(t, oMt(l, r)), r = t[r], c = !0);
    else if (n[1]._container) {
      for (o = r, i = void 0; o-- && (a = l.get(o), a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (l.get(i)[1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (n[1].end = Object.assign({}, l.get(i)[1].start), u = l.slice(i, r), u.unshift(n), l.splice(i, r - i + 1, u));
    }
  }
  return Wc(e, 0, Number.POSITIVE_INFINITY, l.slice(0)), !c;
}
function oMt(e, t) {
  const r = e.get(t)[1], n = e.get(t)[2];
  let i = t - 1;
  const o = [], a = r._tokenizer || n.parser[r.contentType](r.start), u = a.events, s = [], c = {};
  let l, f, d = -1, p = r, v = 0, h = 0;
  const E = [h];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    o.push(i), p._tokenizer || (l = n.sliceStream(p), p.next || l.push(null), f && a.defineSkip(p.start), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(l), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = r; ++d < u.length; )
    // Find a void token that includes a break.
    u[d][0] === "exit" && u[d - 1][0] === "enter" && u[d][1].type === u[d - 1][1].type && u[d][1].start.line !== u[d][1].end.line && (h = d + 1, E.push(h), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (a.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : E.pop(), d = E.length; d--; ) {
    const m = u.slice(E[d], E[d + 1]), g = o.pop();
    s.push([g, g + m.length - 1]), e.splice(g, 2, m);
  }
  for (s.reverse(), d = -1; ++d < s.length; )
    c[v + s[d][0]] = v + s[d][1], v += s[d][1] - s[d][0] - 1;
  return c;
}
const aMt = {
  tokenize: cMt,
  resolve: sMt
}, uMt = {
  tokenize: lMt,
  partial: !0
};
function sMt(e) {
  return gve(e), e;
}
function cMt(e, t) {
  let r;
  return n;
  function n(u) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), i(u);
  }
  function i(u) {
    return u === null ? o(u) : Cr(u) ? e.check(uMt, a, o)(u) : (e.consume(u), i);
  }
  function o(u) {
    return e.exit("chunkContent"), e.exit("content"), t(u);
  }
  function a(u) {
    return e.consume(u), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, i;
  }
}
function lMt(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Qn(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Cr(a))
      return r(a);
    const u = n.events[n.events.length - 1];
    return !n.parser.constructs.disable.null.includes("codeIndented") && u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? t(a) : e.interrupt(n.parser.constructs.flow, r, t)(a);
  }
}
function Tve(e, t, r, n, i, o, a, u, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let l = 0;
  return f;
  function f(m) {
    return m === 60 ? (e.enter(n), e.enter(i), e.enter(o), e.consume(m), e.exit(o), d) : m === null || m === 32 || m === 41 || FL(m) ? r(m) : (e.enter(n), e.enter(a), e.enter(u), e.enter("chunkString", {
      contentType: "string"
    }), h(m));
  }
  function d(m) {
    return m === 62 ? (e.enter(o), e.consume(m), e.exit(o), e.exit(i), e.exit(n), t) : (e.enter(u), e.enter("chunkString", {
      contentType: "string"
    }), p(m));
  }
  function p(m) {
    return m === 62 ? (e.exit("chunkString"), e.exit(u), d(m)) : m === null || m === 60 || Cr(m) ? r(m) : (e.consume(m), m === 92 ? v : p);
  }
  function v(m) {
    return m === 60 || m === 62 || m === 92 ? (e.consume(m), p) : p(m);
  }
  function h(m) {
    return !l && (m === null || m === 41 || Ba(m)) ? (e.exit("chunkString"), e.exit(u), e.exit(a), e.exit(n), t(m)) : l < c && m === 40 ? (e.consume(m), l++, h) : m === 41 ? (e.consume(m), l--, h) : m === null || m === 32 || m === 40 || FL(m) ? r(m) : (e.consume(m), m === 92 ? E : h);
  }
  function E(m) {
    return m === 40 || m === 41 || m === 92 ? (e.consume(m), h) : h(m);
  }
}
function yve(e, t, r, n, i, o) {
  const a = this;
  let u = 0, s;
  return c;
  function c(p) {
    return e.enter(n), e.enter(i), e.consume(p), e.exit(i), e.enter(o), l;
  }
  function l(p) {
    return u > 999 || p === null || p === 91 || p === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !u && "_hiddenFootnoteSupport" in a.parser.constructs ? r(p) : p === 93 ? (e.exit(o), e.enter(i), e.consume(p), e.exit(i), e.exit(n), t) : Cr(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), l) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || Cr(p) || u++ > 999 ? (e.exit("chunkString"), l(p)) : (e.consume(p), s || (s = !Sn(p)), p === 92 ? d : f);
  }
  function d(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), u++, f) : f(p);
  }
}
function _ve(e, t, r, n, i, o) {
  let a;
  return u;
  function u(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(n), e.enter(i), e.consume(d), e.exit(i), a = d === 40 ? 41 : d, s) : r(d);
  }
  function s(d) {
    return d === a ? (e.enter(i), e.consume(d), e.exit(i), e.exit(n), t) : (e.enter(o), c(d));
  }
  function c(d) {
    return d === a ? (e.exit(o), s(a)) : d === null ? r(d) : Cr(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), Qn(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), l(d));
  }
  function l(d) {
    return d === a || d === null || Cr(d) ? (e.exit("chunkString"), c(d)) : (e.consume(d), d === 92 ? f : l);
  }
  function f(d) {
    return d === a || d === 92 ? (e.consume(d), l) : l(d);
  }
}
function A1(e, t) {
  let r;
  return n;
  function n(i) {
    return Cr(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), r = !0, n) : Sn(i) ? Qn(
      e,
      n,
      r ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const fMt = {
  name: "definition",
  tokenize: pMt
}, dMt = {
  tokenize: hMt,
  partial: !0
};
function pMt(e, t, r) {
  const n = this;
  let i;
  return o;
  function o(p) {
    return e.enter("definition"), a(p);
  }
  function a(p) {
    return yve.call(
      n,
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function u(p) {
    return i = bp(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), s) : r(p);
  }
  function s(p) {
    return Ba(p) ? A1(e, c)(p) : c(p);
  }
  function c(p) {
    return Tve(
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function l(p) {
    return e.attempt(dMt, f, f)(p);
  }
  function f(p) {
    return Sn(p) ? Qn(e, d, "whitespace")(p) : d(p);
  }
  function d(p) {
    return p === null || Cr(p) ? (e.exit("definition"), n.parser.defined.push(i), t(p)) : r(p);
  }
}
function hMt(e, t, r) {
  return n;
  function n(u) {
    return Ba(u) ? A1(e, i)(u) : r(u);
  }
  function i(u) {
    return _ve(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(u);
  }
  function o(u) {
    return Sn(u) ? Qn(e, a, "whitespace")(u) : a(u);
  }
  function a(u) {
    return u === null || Cr(u) ? t(u) : r(u);
  }
}
const vMt = {
  name: "hardBreakEscape",
  tokenize: EMt
};
function EMt(e, t, r) {
  return n;
  function n(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Cr(o) ? (e.exit("hardBreakEscape"), t(o)) : r(o);
  }
}
const mMt = {
  name: "headingAtx",
  tokenize: TMt,
  resolve: gMt
};
function gMt(e, t) {
  let r = e.length - 2, n = 3, i, o;
  return e[n][1].type === "whitespace" && (n += 2), r - 2 > n && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (n === r - 1 || r - 4 > n && e[r - 2][1].type === "whitespace") && (r -= n + 1 === r ? 2 : 4), r > n && (i = {
    type: "atxHeadingText",
    start: e[n][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[n][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Wc(e, n, r - n + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function TMt(e, t, r) {
  let n = 0;
  return i;
  function i(l) {
    return e.enter("atxHeading"), o(l);
  }
  function o(l) {
    return e.enter("atxHeadingSequence"), a(l);
  }
  function a(l) {
    return l === 35 && n++ < 6 ? (e.consume(l), a) : l === null || Ba(l) ? (e.exit("atxHeadingSequence"), u(l)) : r(l);
  }
  function u(l) {
    return l === 35 ? (e.enter("atxHeadingSequence"), s(l)) : l === null || Cr(l) ? (e.exit("atxHeading"), t(l)) : Sn(l) ? Qn(e, u, "whitespace")(l) : (e.enter("atxHeadingText"), c(l));
  }
  function s(l) {
    return l === 35 ? (e.consume(l), s) : (e.exit("atxHeadingSequence"), u(l));
  }
  function c(l) {
    return l === null || l === 35 || Ba(l) ? (e.exit("atxHeadingText"), u(l)) : (e.consume(l), c);
  }
}
const yMt = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], GG = ["pre", "script", "style", "textarea"], _Mt = {
  name: "htmlFlow",
  tokenize: CMt,
  resolveTo: bMt,
  concrete: !0
}, AMt = {
  tokenize: OMt,
  partial: !0
}, SMt = {
  tokenize: IMt,
  partial: !0
};
function bMt(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function CMt(e, t, r) {
  const n = this;
  let i, o, a, u, s;
  return c;
  function c(ne) {
    return l(ne);
  }
  function l(ne) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(ne), f;
  }
  function f(ne) {
    return ne === 33 ? (e.consume(ne), d) : ne === 47 ? (e.consume(ne), o = !0, h) : ne === 63 ? (e.consume(ne), i = 3, n.interrupt ? t : F) : qs(ne) ? (e.consume(ne), a = String.fromCharCode(ne), E) : r(ne);
  }
  function d(ne) {
    return ne === 45 ? (e.consume(ne), i = 2, p) : ne === 91 ? (e.consume(ne), i = 5, u = 0, v) : qs(ne) ? (e.consume(ne), i = 4, n.interrupt ? t : F) : r(ne);
  }
  function p(ne) {
    return ne === 45 ? (e.consume(ne), n.interrupt ? t : F) : r(ne);
  }
  function v(ne) {
    const ve = "CDATA[";
    return ne === ve.charCodeAt(u++) ? (e.consume(ne), u === ve.length ? n.interrupt ? t : H : v) : r(ne);
  }
  function h(ne) {
    return qs(ne) ? (e.consume(ne), a = String.fromCharCode(ne), E) : r(ne);
  }
  function E(ne) {
    if (ne === null || ne === 47 || ne === 62 || Ba(ne)) {
      const ve = ne === 47, Ie = a.toLowerCase();
      return !ve && !o && GG.includes(Ie) ? (i = 1, n.interrupt ? t(ne) : H(ne)) : yMt.includes(a.toLowerCase()) ? (i = 6, ve ? (e.consume(ne), m) : n.interrupt ? t(ne) : H(ne)) : (i = 7, n.interrupt && !n.parser.lazy[n.now().line] ? r(ne) : o ? g(ne) : y(ne));
    }
    return ne === 45 || ds(ne) ? (e.consume(ne), a += String.fromCharCode(ne), E) : r(ne);
  }
  function m(ne) {
    return ne === 62 ? (e.consume(ne), n.interrupt ? t : H) : r(ne);
  }
  function g(ne) {
    return Sn(ne) ? (e.consume(ne), g) : z(ne);
  }
  function y(ne) {
    return ne === 47 ? (e.consume(ne), z) : ne === 58 || ne === 95 || qs(ne) ? (e.consume(ne), _) : Sn(ne) ? (e.consume(ne), y) : z(ne);
  }
  function _(ne) {
    return ne === 45 || ne === 46 || ne === 58 || ne === 95 || ds(ne) ? (e.consume(ne), _) : S(ne);
  }
  function S(ne) {
    return ne === 61 ? (e.consume(ne), A) : Sn(ne) ? (e.consume(ne), S) : y(ne);
  }
  function A(ne) {
    return ne === null || ne === 60 || ne === 61 || ne === 62 || ne === 96 ? r(ne) : ne === 34 || ne === 39 ? (e.consume(ne), s = ne, O) : Sn(ne) ? (e.consume(ne), A) : P(ne);
  }
  function O(ne) {
    return ne === s ? (e.consume(ne), s = null, U) : ne === null || Cr(ne) ? r(ne) : (e.consume(ne), O);
  }
  function P(ne) {
    return ne === null || ne === 34 || ne === 39 || ne === 47 || ne === 60 || ne === 61 || ne === 62 || ne === 96 || Ba(ne) ? S(ne) : (e.consume(ne), P);
  }
  function U(ne) {
    return ne === 47 || ne === 62 || Sn(ne) ? y(ne) : r(ne);
  }
  function z(ne) {
    return ne === 62 ? (e.consume(ne), k) : r(ne);
  }
  function k(ne) {
    return ne === null || Cr(ne) ? H(ne) : Sn(ne) ? (e.consume(ne), k) : r(ne);
  }
  function H(ne) {
    return ne === 45 && i === 2 ? (e.consume(ne), w) : ne === 60 && i === 1 ? (e.consume(ne), $) : ne === 62 && i === 4 ? (e.consume(ne), le) : ne === 63 && i === 3 ? (e.consume(ne), F) : ne === 93 && i === 5 ? (e.consume(ne), V) : Cr(ne) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(AMt, ae, B)(ne)) : ne === null || Cr(ne) ? (e.exit("htmlFlowData"), B(ne)) : (e.consume(ne), H);
  }
  function B(ne) {
    return e.check(SMt, x, ae)(ne);
  }
  function x(ne) {
    return e.enter("lineEnding"), e.consume(ne), e.exit("lineEnding"), D;
  }
  function D(ne) {
    return ne === null || Cr(ne) ? B(ne) : (e.enter("htmlFlowData"), H(ne));
  }
  function w(ne) {
    return ne === 45 ? (e.consume(ne), F) : H(ne);
  }
  function $(ne) {
    return ne === 47 ? (e.consume(ne), a = "", X) : H(ne);
  }
  function X(ne) {
    if (ne === 62) {
      const ve = a.toLowerCase();
      return GG.includes(ve) ? (e.consume(ne), le) : H(ne);
    }
    return qs(ne) && a.length < 8 ? (e.consume(ne), a += String.fromCharCode(ne), X) : H(ne);
  }
  function V(ne) {
    return ne === 93 ? (e.consume(ne), F) : H(ne);
  }
  function F(ne) {
    return ne === 62 ? (e.consume(ne), le) : ne === 45 && i === 2 ? (e.consume(ne), F) : H(ne);
  }
  function le(ne) {
    return ne === null || Cr(ne) ? (e.exit("htmlFlowData"), ae(ne)) : (e.consume(ne), le);
  }
  function ae(ne) {
    return e.exit("htmlFlow"), t(ne);
  }
}
function IMt(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return Cr(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : r(a);
  }
  function o(a) {
    return n.parser.lazy[n.now().line] ? r(a) : t(a);
  }
}
function OMt(e, t, r) {
  return n;
  function n(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(LC, t, r);
  }
}
const RMt = {
  name: "htmlText",
  tokenize: wMt
};
function wMt(e, t, r) {
  const n = this;
  let i, o, a;
  return u;
  function u(F) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(F), s;
  }
  function s(F) {
    return F === 33 ? (e.consume(F), c) : F === 47 ? (e.consume(F), S) : F === 63 ? (e.consume(F), y) : qs(F) ? (e.consume(F), P) : r(F);
  }
  function c(F) {
    return F === 45 ? (e.consume(F), l) : F === 91 ? (e.consume(F), o = 0, v) : qs(F) ? (e.consume(F), g) : r(F);
  }
  function l(F) {
    return F === 45 ? (e.consume(F), p) : r(F);
  }
  function f(F) {
    return F === null ? r(F) : F === 45 ? (e.consume(F), d) : Cr(F) ? (a = f, $(F)) : (e.consume(F), f);
  }
  function d(F) {
    return F === 45 ? (e.consume(F), p) : f(F);
  }
  function p(F) {
    return F === 62 ? w(F) : F === 45 ? d(F) : f(F);
  }
  function v(F) {
    const le = "CDATA[";
    return F === le.charCodeAt(o++) ? (e.consume(F), o === le.length ? h : v) : r(F);
  }
  function h(F) {
    return F === null ? r(F) : F === 93 ? (e.consume(F), E) : Cr(F) ? (a = h, $(F)) : (e.consume(F), h);
  }
  function E(F) {
    return F === 93 ? (e.consume(F), m) : h(F);
  }
  function m(F) {
    return F === 62 ? w(F) : F === 93 ? (e.consume(F), m) : h(F);
  }
  function g(F) {
    return F === null || F === 62 ? w(F) : Cr(F) ? (a = g, $(F)) : (e.consume(F), g);
  }
  function y(F) {
    return F === null ? r(F) : F === 63 ? (e.consume(F), _) : Cr(F) ? (a = y, $(F)) : (e.consume(F), y);
  }
  function _(F) {
    return F === 62 ? w(F) : y(F);
  }
  function S(F) {
    return qs(F) ? (e.consume(F), A) : r(F);
  }
  function A(F) {
    return F === 45 || ds(F) ? (e.consume(F), A) : O(F);
  }
  function O(F) {
    return Cr(F) ? (a = O, $(F)) : Sn(F) ? (e.consume(F), O) : w(F);
  }
  function P(F) {
    return F === 45 || ds(F) ? (e.consume(F), P) : F === 47 || F === 62 || Ba(F) ? U(F) : r(F);
  }
  function U(F) {
    return F === 47 ? (e.consume(F), w) : F === 58 || F === 95 || qs(F) ? (e.consume(F), z) : Cr(F) ? (a = U, $(F)) : Sn(F) ? (e.consume(F), U) : w(F);
  }
  function z(F) {
    return F === 45 || F === 46 || F === 58 || F === 95 || ds(F) ? (e.consume(F), z) : k(F);
  }
  function k(F) {
    return F === 61 ? (e.consume(F), H) : Cr(F) ? (a = k, $(F)) : Sn(F) ? (e.consume(F), k) : U(F);
  }
  function H(F) {
    return F === null || F === 60 || F === 61 || F === 62 || F === 96 ? r(F) : F === 34 || F === 39 ? (e.consume(F), i = F, B) : Cr(F) ? (a = H, $(F)) : Sn(F) ? (e.consume(F), H) : (e.consume(F), x);
  }
  function B(F) {
    return F === i ? (e.consume(F), i = void 0, D) : F === null ? r(F) : Cr(F) ? (a = B, $(F)) : (e.consume(F), B);
  }
  function x(F) {
    return F === null || F === 34 || F === 39 || F === 60 || F === 61 || F === 96 ? r(F) : F === 47 || F === 62 || Ba(F) ? U(F) : (e.consume(F), x);
  }
  function D(F) {
    return F === 47 || F === 62 || Ba(F) ? U(F) : r(F);
  }
  function w(F) {
    return F === 62 ? (e.consume(F), e.exit("htmlTextData"), e.exit("htmlText"), t) : r(F);
  }
  function $(F) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), X;
  }
  function X(F) {
    return Sn(F) ? Qn(e, V, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(F) : V(F);
  }
  function V(F) {
    return e.enter("htmlTextData"), a(F);
  }
}
const aM = {
  name: "labelEnd",
  tokenize: BMt,
  resolveTo: LMt,
  resolveAll: NMt
}, PMt = {
  tokenize: kMt
}, DMt = {
  tokenize: MMt
}, xMt = {
  tokenize: FMt
};
function NMt(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const r = e[t][1];
    (r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") && (e.splice(t + 1, r.type === "labelImage" ? 4 : 2), r.type = "data", t++);
  }
  return e;
}
function LMt(e, t) {
  let r = e.length, n = 0, i, o, a, u;
  for (; r--; )
    if (i = e[r][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[r][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[r][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = r, i.type !== "labelLink")) {
        n = 2;
        break;
      }
    } else i.type === "labelEnd" && (a = r);
  const s = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[a][1].end)
  }, l = {
    type: "labelText",
    start: Object.assign({}, e[o + n + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return u = [["enter", s, t], ["enter", c, t]], u = Pu(u, e.slice(o + 1, o + n + 3)), u = Pu(u, [["enter", l, t]]), u = Pu(u, oM(t.parser.constructs.insideSpan.null, e.slice(o + n + 4, a - 3), t)), u = Pu(u, [["exit", l, t], e[a - 2], e[a - 1], ["exit", c, t]]), u = Pu(u, e.slice(a + 1)), u = Pu(u, [["exit", s, t]]), Wc(e, o, e.length, u), e;
}
function BMt(e, t, r) {
  const n = this;
  let i = n.events.length, o, a;
  for (; i--; )
    if ((n.events[i][1].type === "labelImage" || n.events[i][1].type === "labelLink") && !n.events[i][1]._balanced) {
      o = n.events[i][1];
      break;
    }
  return u;
  function u(d) {
    return o ? o._inactive ? f(d) : (a = n.parser.defined.includes(bp(n.sliceSerialize({
      start: o.end,
      end: n.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), s) : r(d);
  }
  function s(d) {
    return d === 40 ? e.attempt(PMt, l, a ? l : f)(d) : d === 91 ? e.attempt(DMt, l, a ? c : f)(d) : a ? l(d) : f(d);
  }
  function c(d) {
    return e.attempt(xMt, l, f)(d);
  }
  function l(d) {
    return t(d);
  }
  function f(d) {
    return o._balanced = !0, r(d);
  }
}
function kMt(e, t, r) {
  return n;
  function n(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return Ba(f) ? A1(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? l(f) : Tve(e, a, u, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function a(f) {
    return Ba(f) ? A1(e, s)(f) : l(f);
  }
  function u(f) {
    return r(f);
  }
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? _ve(e, c, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : l(f);
  }
  function c(f) {
    return Ba(f) ? A1(e, l)(f) : l(f);
  }
  function l(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : r(f);
  }
}
function MMt(e, t, r) {
  const n = this;
  return i;
  function i(u) {
    return yve.call(n, e, o, a, "reference", "referenceMarker", "referenceString")(u);
  }
  function o(u) {
    return n.parser.defined.includes(bp(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? t(u) : r(u);
  }
  function a(u) {
    return r(u);
  }
}
function FMt(e, t, r) {
  return n;
  function n(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : r(o);
  }
}
const HMt = {
  name: "labelStartImage",
  tokenize: $Mt,
  resolveAll: aM.resolveAll
};
function $Mt(e, t, r) {
  const n = this;
  return i;
  function i(u) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(u), e.exit("labelImageMarker"), o;
  }
  function o(u) {
    return u === 91 ? (e.enter("labelMarker"), e.consume(u), e.exit("labelMarker"), e.exit("labelImage"), a) : r(u);
  }
  function a(u) {
    return u === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(u) : t(u);
  }
}
const UMt = {
  name: "labelStartLink",
  tokenize: VMt,
  resolveAll: aM.resolveAll
};
function VMt(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(a) : t(a);
  }
}
const FR = {
  name: "lineEnding",
  tokenize: jMt
};
function jMt(e, t) {
  return r;
  function r(n) {
    return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), Qn(e, t, "linePrefix");
  }
}
const N4 = {
  name: "thematicBreak",
  tokenize: zMt
};
function zMt(e, t, r) {
  let n = 0, i;
  return o;
  function o(c) {
    return e.enter("thematicBreak"), a(c);
  }
  function a(c) {
    return i = c, u(c);
  }
  function u(c) {
    return c === i ? (e.enter("thematicBreakSequence"), s(c)) : n >= 3 && (c === null || Cr(c)) ? (e.exit("thematicBreak"), t(c)) : r(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), n++, s) : (e.exit("thematicBreakSequence"), Sn(c) ? Qn(e, u, "whitespace")(c) : u(c));
  }
}
const Ra = {
  name: "list",
  tokenize: GMt,
  continuation: {
    tokenize: WMt
  },
  exit: XMt
}, qMt = {
  tokenize: JMt,
  partial: !0
}, YMt = {
  tokenize: KMt,
  partial: !0
};
function GMt(e, t, r) {
  const n = this, i = n.events[n.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return u;
  function u(p) {
    const v = n.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (v === "listUnordered" ? !n.containerState.marker || p === n.containerState.marker : HL(p)) {
      if (n.containerState.type || (n.containerState.type = v, e.enter(v, {
        _container: !0
      })), v === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(N4, r, c)(p) : c(p);
      if (!n.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(p);
    }
    return r(p);
  }
  function s(p) {
    return HL(p) && ++a < 10 ? (e.consume(p), s) : (!n.interrupt || a < 2) && (n.containerState.marker ? p === n.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : r(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || p, e.check(
      LC,
      // Can’t be empty when interrupting.
      n.interrupt ? r : l,
      e.attempt(qMt, d, f)
    );
  }
  function l(p) {
    return n.containerState.initialBlankLine = !0, o++, d(p);
  }
  function f(p) {
    return Sn(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), d) : r(p);
  }
  function d(p) {
    return n.containerState.size = o + n.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function WMt(e, t, r) {
  const n = this;
  return n.containerState._closeFlow = void 0, e.check(LC, i, o);
  function i(u) {
    return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, Qn(e, t, "listItemIndent", n.containerState.size + 1)(u);
  }
  function o(u) {
    return n.containerState.furtherBlankLines || !Sn(u) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, a(u)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, e.attempt(YMt, t, a)(u));
  }
  function a(u) {
    return n.containerState._closeFlow = !0, n.interrupt = void 0, Qn(e, e.attempt(Ra, t, r), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u);
  }
}
function KMt(e, t, r) {
  const n = this;
  return Qn(e, i, "listItemIndent", n.containerState.size + 1);
  function i(o) {
    const a = n.events[n.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === n.containerState.size ? t(o) : r(o);
  }
}
function XMt(e) {
  e.exit(this.containerState.type);
}
function JMt(e, t, r) {
  const n = this;
  return Qn(e, i, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const a = n.events[n.events.length - 1];
    return !Sn(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : r(o);
  }
}
const WG = {
  name: "setextUnderline",
  tokenize: QMt,
  resolveTo: ZMt
};
function ZMt(e, t) {
  let r = e.length, n, i, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        n = r;
        break;
      }
      e[r][1].type === "paragraph" && (i = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[n][1], t]), e[n][1].end = Object.assign({}, e[o][1].end)) : e[n][1] = a, e.push(["exit", a, t]), e;
}
function QMt(e, t, r) {
  const n = this;
  let i;
  return o;
  function o(c) {
    let l = n.events.length, f;
    for (; l--; )
      if (n.events[l][1].type !== "lineEnding" && n.events[l][1].type !== "linePrefix" && n.events[l][1].type !== "content") {
        f = n.events[l][1].type === "paragraph";
        break;
      }
    return !n.parser.lazy[n.now().line] && (n.interrupt || f) ? (e.enter("setextHeadingLine"), i = c, a(c)) : r(c);
  }
  function a(c) {
    return e.enter("setextHeadingLineSequence"), u(c);
  }
  function u(c) {
    return c === i ? (e.consume(c), u) : (e.exit("setextHeadingLineSequence"), Sn(c) ? Qn(e, s, "lineSuffix")(c) : s(c));
  }
  function s(c) {
    return c === null || Cr(c) ? (e.exit("setextHeadingLine"), t(c)) : r(c);
  }
}
const eFt = {
  tokenize: tFt
};
function tFt(e) {
  const t = this, r = e.attempt(
    // Try to parse a blank line.
    LC,
    n,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      Qn(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(aMt, i)
        ),
        "linePrefix"
      )
    )
  );
  return r;
  function n(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, r;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, r;
  }
}
const rFt = {
  resolveAll: Sve()
}, nFt = Ave("string"), iFt = Ave("text");
function Ave(e) {
  return {
    tokenize: t,
    resolveAll: Sve(
      e === "text" ? oFt : void 0
    )
  };
  function t(r) {
    const n = this, i = this.parser.constructs[e], o = r.attempt(i, a, u);
    return a;
    function a(l) {
      return c(l) ? o(l) : u(l);
    }
    function u(l) {
      if (l === null) {
        r.consume(l);
        return;
      }
      return r.enter("data"), r.consume(l), s;
    }
    function s(l) {
      return c(l) ? (r.exit("data"), o(l)) : (r.consume(l), s);
    }
    function c(l) {
      if (l === null)
        return !0;
      const f = i[l];
      let d = -1;
      if (f)
        for (; ++d < f.length; ) {
          const p = f[d];
          if (!p.previous || p.previous.call(n, n.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Sve(e) {
  return t;
  function t(r, n) {
    let i = -1, o;
    for (; ++i <= r.length; )
      o === void 0 ? r[i] && r[i][1].type === "data" && (o = i, i++) : (!r[i] || r[i][1].type !== "data") && (i !== o + 2 && (r[o][1].end = r[i - 1][1].end, r.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(r, n) : r;
  }
}
function oFt(e, t) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const n = e[r - 1][1], i = t.sliceStream(n);
      let o = i.length, a = -1, u = 0, s;
      for (; o--; ) {
        const c = i[o];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === 32; )
            u++, a--;
          if (a) break;
          a = -1;
        } else if (c === -2)
          s = !0, u++;
        else if (c !== -1) {
          o++;
          break;
        }
      }
      if (u) {
        const c = {
          type: r === e.length || s || u < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: n.end.line,
            column: n.end.column - u,
            offset: n.end.offset - u,
            _index: n.start._index + o,
            _bufferIndex: o ? a : n.start._bufferIndex + a
          },
          end: Object.assign({}, n.end)
        };
        n.end = Object.assign({}, c.start), n.start.offset === n.end.offset ? Object.assign(n, c) : (e.splice(
          r,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), r += 2);
      }
      r++;
    }
  return e;
}
function aFt(e, t, r) {
  let n = Object.assign(
    r ? Object.assign({}, r) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], u = [];
  const s = {
    consume: g,
    enter: y,
    exit: _,
    attempt: O(S),
    check: O(A),
    interrupt: O(A, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: p,
    sliceSerialize: d,
    now: v,
    defineSkip: h,
    write: f
  };
  let l = t.tokenize.call(c, s);
  return t.resolveAll && o.push(t), c;
  function f(k) {
    return a = Pu(a, k), E(), a[a.length - 1] !== null ? [] : (P(t, 0), c.events = oM(o, c.events, c), c.events);
  }
  function d(k, H) {
    return sFt(p(k), H);
  }
  function p(k) {
    return uFt(a, k);
  }
  function v() {
    const { line: k, column: H, offset: B, _index: x, _bufferIndex: D } = n;
    return {
      line: k,
      column: H,
      offset: B,
      _index: x,
      _bufferIndex: D
    };
  }
  function h(k) {
    i[k.line] = k.column, z();
  }
  function E() {
    let k;
    for (; n._index < a.length; ) {
      const H = a[n._index];
      if (typeof H == "string")
        for (k = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === k && n._bufferIndex < H.length; )
          m(H.charCodeAt(n._bufferIndex));
      else
        m(H);
    }
  }
  function m(k) {
    l = l(k);
  }
  function g(k) {
    Cr(k) ? (n.line++, n.column = 1, n.offset += k === -3 ? 2 : 1, z()) : k !== -1 && (n.column++, n.offset++), n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === a[n._index].length && (n._bufferIndex = -1, n._index++)), c.previous = k;
  }
  function y(k, H) {
    const B = H || {};
    return B.type = k, B.start = v(), c.events.push(["enter", B, c]), u.push(B), B;
  }
  function _(k) {
    const H = u.pop();
    return H.end = v(), c.events.push(["exit", H, c]), H;
  }
  function S(k, H) {
    P(k, H.from);
  }
  function A(k, H) {
    H.restore();
  }
  function O(k, H) {
    return B;
    function B(x, D, w) {
      let $, X, V, F;
      return Array.isArray(x) ? ae(x) : "tokenize" in x ? (
        // @ts-expect-error Looks like a construct.
        ae([x])
      ) : le(x);
      function le(Oe) {
        return xe;
        function xe(ze) {
          const qe = ze !== null && Oe[ze], Je = ze !== null && Oe.null, Be = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(qe) ? qe : qe ? [qe] : [],
            ...Array.isArray(Je) ? Je : Je ? [Je] : []
          ];
          return ae(Be)(ze);
        }
      }
      function ae(Oe) {
        return $ = Oe, X = 0, Oe.length === 0 ? w : ne(Oe[X]);
      }
      function ne(Oe) {
        return xe;
        function xe(ze) {
          return F = U(), V = Oe, Oe.partial || (c.currentConstruct = Oe), Oe.name && c.parser.constructs.disable.null.includes(Oe.name) ? Ie() : Oe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(c), H) : c,
            s,
            ve,
            Ie
          )(ze);
        }
      }
      function ve(Oe) {
        return k(V, F), D;
      }
      function Ie(Oe) {
        return F.restore(), ++X < $.length ? ne($[X]) : w;
      }
    }
  }
  function P(k, H) {
    k.resolveAll && !o.includes(k) && o.push(k), k.resolve && Wc(
      c.events,
      H,
      c.events.length - H,
      k.resolve(c.events.slice(H), c)
    ), k.resolveTo && (c.events = k.resolveTo(c.events, c));
  }
  function U() {
    const k = v(), H = c.previous, B = c.currentConstruct, x = c.events.length, D = Array.from(u);
    return {
      restore: w,
      from: x
    };
    function w() {
      n = k, c.previous = H, c.currentConstruct = B, c.events.length = x, u = D, z();
    }
  }
  function z() {
    n.line in i && n.column < 2 && (n.column = i[n.line], n.offset += i[n.line] - 1);
  }
}
function uFt(e, t) {
  const r = t.start._index, n = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (r === i)
    a = [e[r].slice(n, o)];
  else {
    if (a = e.slice(r, i), n > -1) {
      const u = a[0];
      typeof u == "string" ? a[0] = u.slice(n) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function sFt(e, t) {
  let r = -1;
  const n = [];
  let i;
  for (; ++r < e.length; ) {
    const o = e[r];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i) continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, n.push(a);
  }
  return n.join("");
}
const cFt = {
  42: Ra,
  43: Ra,
  45: Ra,
  48: Ra,
  49: Ra,
  50: Ra,
  51: Ra,
  52: Ra,
  53: Ra,
  54: Ra,
  55: Ra,
  56: Ra,
  57: Ra,
  62: vve
}, lFt = {
  91: fMt
}, fFt = {
  [-2]: MR,
  [-1]: MR,
  32: MR
}, dFt = {
  35: mMt,
  42: N4,
  45: [WG, N4],
  60: _Mt,
  61: WG,
  95: N4,
  96: YG,
  126: YG
}, pFt = {
  38: mve,
  92: Eve
}, hFt = {
  [-5]: FR,
  [-4]: FR,
  [-3]: FR,
  33: HMt,
  38: mve,
  42: $L,
  60: [U9t, RMt],
  91: UMt,
  92: [vMt, Eve],
  93: aM,
  95: $L,
  96: eMt
}, vFt = {
  null: [$L, rFt]
}, EFt = {
  null: [42, 95]
}, mFt = {
  null: []
}, gFt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: EFt,
  contentInitial: lFt,
  disable: mFt,
  document: cFt,
  flow: dFt,
  flowInitial: fFt,
  insideSpan: vFt,
  string: pFt,
  text: hFt
}, Symbol.toStringTag, { value: "Module" }));
function TFt(e) {
  const r = (
    /** @type {FullNormalizedExtension} */
    I9t([gFt, ...(e || {}).extensions || []])
  ), n = {
    defined: [],
    lazy: {},
    constructs: r,
    content: i(L9t),
    document: i(k9t),
    flow: i(eFt),
    string: i(nFt),
    text: i(iFt)
  };
  return n;
  function i(o) {
    return a;
    function a(u) {
      return aFt(n, o, u);
    }
  }
}
function yFt(e) {
  for (; !gve(e); )
    ;
  return e;
}
const KG = /[\0\t\n\r]/g;
function _Ft() {
  let e = 1, t = "", r = !0, n;
  return i;
  function i(o, a, u) {
    const s = [];
    let c, l, f, d, p;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(a || void 0).decode(o)), f = 0, t = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (KG.lastIndex = f, c = KG.exec(o), d = c && c.index !== void 0 ? c.index : o.length, p = o.charCodeAt(d), !c) {
        t = o.slice(f);
        break;
      }
      if (p === 10 && f === d && n)
        s.push(-3), n = void 0;
      else
        switch (n && (s.push(-5), n = void 0), f < d && (s.push(o.slice(f, d)), e += d - f), p) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (l = Math.ceil(e / 4) * 4, s.push(-2); e++ < l; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            n = !0, e = 1;
        }
      f = d + 1;
    }
    return u && (n && s.push(-5), t && s.push(t), s.push(null)), s;
  }
}
const AFt = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function SFt(e) {
  return e.replace(AFt, bFt);
}
function bFt(e, t, r) {
  if (t)
    return t;
  if (r.charCodeAt(0) === 35) {
    const i = r.charCodeAt(1), o = i === 120 || i === 88;
    return hve(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return iM(r) || e;
}
function L4(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? XG(e.position) : "start" in e || "end" in e ? XG(e) : "line" in e || "column" in e ? UL(e) : "";
}
function UL(e) {
  return JG(e && e.line) + ":" + JG(e && e.column);
}
function XG(e) {
  return UL(e && e.start) + "-" + UL(e && e.end);
}
function JG(e) {
  return e && typeof e == "number" ? e : 1;
}
const bve = {}.hasOwnProperty;
function Cve(e, t, r) {
  return typeof t != "string" && (r = t, t = void 0), CFt(r)(
    yFt(
      TFt(r).document().write(_Ft()(e, t, !0))
    )
  );
}
function CFt(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(we),
      autolinkProtocol: U,
      autolinkEmail: U,
      atxHeading: o(je),
      blockQuote: o(qe),
      characterEscape: U,
      characterReference: U,
      codeFenced: o(Je),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: o(Je, a),
      codeText: o(Be, a),
      codeTextData: U,
      data: U,
      codeFlowValue: U,
      definition: o(We),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: o(Ne),
      hardBreakEscape: o(et),
      hardBreakTrailing: o(et),
      htmlFlow: o(St, a),
      htmlFlowData: U,
      htmlText: o(St, a),
      htmlTextData: U,
      image: o(Ot),
      label: a,
      link: o(we),
      listItem: o(Ee),
      listItemValue: d,
      listOrdered: o(De, f),
      listUnordered: o(De),
      paragraph: o(te),
      reference: ne,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: o(je),
      strong: o(ue),
      thematicBreak: o(Le)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: S,
      autolink: s(),
      autolinkEmail: ze,
      autolinkProtocol: xe,
      blockQuote: s(),
      characterEscapeValue: z,
      characterReferenceMarkerHexadecimal: Ie,
      characterReferenceMarkerNumeric: Ie,
      characterReferenceValue: Oe,
      codeFenced: s(E),
      codeFencedFence: h,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: v,
      codeFlowValue: z,
      codeIndented: s(m),
      codeText: s(D),
      codeTextData: z,
      data: z,
      definition: s(),
      definitionDestinationString: _,
      definitionLabelString: g,
      definitionTitleString: y,
      emphasis: s(),
      hardBreakEscape: s(H),
      hardBreakTrailing: s(H),
      htmlFlow: s(B),
      htmlFlowData: z,
      htmlText: s(x),
      htmlTextData: z,
      image: s($),
      label: V,
      labelText: X,
      lineEnding: k,
      link: s(w),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: ve,
      resourceDestinationString: F,
      resourceTitleString: le,
      resource: ae,
      setextHeading: s(P),
      setextHeadingLineSequence: O,
      setextHeadingText: A,
      strong: s(),
      thematicBreak: s()
    }
  };
  Ive(t, (e || {}).mdastExtensions || []);
  const r = {};
  return n;
  function n(Me) {
    let Ae = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [Ae],
      tokenStack: [],
      config: t,
      enter: u,
      exit: c,
      buffer: a,
      resume: l,
      data: r
    }, K = [];
    let Z = -1;
    for (; ++Z < Me.length; )
      if (Me[Z][1].type === "listOrdered" || Me[Z][1].type === "listUnordered")
        if (Me[Z][0] === "enter")
          K.push(Z);
        else {
          const Ce = K.pop();
          Z = i(Me, Ce, Z);
        }
    for (Z = -1; ++Z < Me.length; ) {
      const Ce = t[Me[Z][0]];
      bve.call(Ce, Me[Z][1].type) && Ce[Me[Z][1].type].call(
        Object.assign(
          {
            sliceSerialize: Me[Z][2].sliceSerialize
          },
          ie
        ),
        Me[Z][1]
      );
    }
    if (ie.tokenStack.length > 0) {
      const Ce = ie.tokenStack[ie.tokenStack.length - 1];
      (Ce[1] || ZG).call(ie, void 0, Ce[0]);
    }
    for (Ae.position = {
      start: Ol(
        Me.length > 0 ? Me[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Ol(
        Me.length > 0 ? Me[Me.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Z = -1; ++Z < t.transforms.length; )
      Ae = t.transforms[Z](Ae) || Ae;
    return Ae;
  }
  function i(Me, Ae, ie) {
    let K = Ae - 1, Z = -1, Ce = !1, be, Ge, st, wt;
    for (; ++K <= ie; ) {
      const Bt = Me[K];
      switch (Bt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Bt[0] === "enter" ? Z++ : Z--, wt = void 0;
          break;
        }
        case "lineEndingBlank": {
          Bt[0] === "enter" && (be && !wt && !Z && !st && (st = K), wt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          wt = void 0;
      }
      if (!Z && Bt[0] === "enter" && Bt[1].type === "listItemPrefix" || Z === -1 && Bt[0] === "exit" && (Bt[1].type === "listUnordered" || Bt[1].type === "listOrdered")) {
        if (be) {
          let jt = K;
          for (Ge = void 0; jt--; ) {
            const Xt = Me[jt];
            if (Xt[1].type === "lineEnding" || Xt[1].type === "lineEndingBlank") {
              if (Xt[0] === "exit") continue;
              Ge && (Me[Ge][1].type = "lineEndingBlank", Ce = !0), Xt[1].type = "lineEnding", Ge = jt;
            } else if (!(Xt[1].type === "linePrefix" || Xt[1].type === "blockQuotePrefix" || Xt[1].type === "blockQuotePrefixWhitespace" || Xt[1].type === "blockQuoteMarker" || Xt[1].type === "listItemIndent")) break;
          }
          st && (!Ge || st < Ge) && (be._spread = !0), be.end = Object.assign(
            {},
            Ge ? Me[Ge][1].start : Bt[1].end
          ), Me.splice(Ge || K, 0, ["exit", be, Bt[2]]), K++, ie++;
        }
        if (Bt[1].type === "listItemPrefix") {
          const jt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Bt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          be = jt, Me.splice(K, 0, ["enter", jt, Bt[2]]), K++, ie++, st = void 0, wt = !0;
        }
      }
    }
    return Me[Ae][1]._spread = Ce, ie;
  }
  function o(Me, Ae) {
    return ie;
    function ie(K) {
      u.call(this, Me(K), K), Ae && Ae.call(this, K);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(Me, Ae, ie) {
    this.stack[this.stack.length - 1].children.push(Me), this.stack.push(Me), this.tokenStack.push([Ae, ie]), Me.position = {
      start: Ol(Ae.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(Me) {
    return Ae;
    function Ae(ie) {
      Me && Me.call(this, ie), c.call(this, ie);
    }
  }
  function c(Me, Ae) {
    const ie = this.stack.pop(), K = this.tokenStack.pop();
    if (K)
      K[0].type !== Me.type && (Ae ? Ae.call(this, Me, K[0]) : (K[1] || ZG).call(this, Me, K[0]));
    else throw new Error(
      "Cannot close `" + Me.type + "` (" + L4({
        start: Me.start,
        end: Me.end
      }) + "): it’s not open"
    );
    ie.position.end = Ol(Me.end);
  }
  function l() {
    return b9t(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(Me) {
    if (this.data.expectingFirstListItemValue) {
      const Ae = this.stack[this.stack.length - 2];
      Ae.start = Number.parseInt(this.sliceSerialize(Me), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.lang = Me;
  }
  function v() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.meta = Me;
  }
  function h() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function E() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.value = Me.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function m() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.value = Me.replace(/(\r?\n|\r)$/g, "");
  }
  function g(Me) {
    const Ae = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = Ae, ie.identifier = bp(
      this.sliceSerialize(Me)
    ).toLowerCase();
  }
  function y() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.title = Me;
  }
  function _() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.url = Me;
  }
  function S(Me) {
    const Ae = this.stack[this.stack.length - 1];
    if (!Ae.depth) {
      const ie = this.sliceSerialize(Me).length;
      Ae.depth = ie;
    }
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(Me) {
    const Ae = this.stack[this.stack.length - 1];
    Ae.depth = this.sliceSerialize(Me).codePointAt(0) === 61 ? 1 : 2;
  }
  function P() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function U(Me) {
    const ie = this.stack[this.stack.length - 1].children;
    let K = ie[ie.length - 1];
    (!K || K.type !== "text") && (K = ye(), K.position = {
      start: Ol(Me.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(K)), this.stack.push(K);
  }
  function z(Me) {
    const Ae = this.stack.pop();
    Ae.value += this.sliceSerialize(Me), Ae.position.end = Ol(Me.end);
  }
  function k(Me) {
    const Ae = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = Ae.children[Ae.children.length - 1];
      ie.position.end = Ol(Me.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(Ae.type) && (U.call(this, Me), z.call(this, Me));
  }
  function H() {
    this.data.atHardBreak = !0;
  }
  function B() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.value = Me;
  }
  function x() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.value = Me;
  }
  function D() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.value = Me;
  }
  function w() {
    const Me = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ae = this.data.referenceType || "shortcut";
      Me.type += "Reference", Me.referenceType = Ae, delete Me.url, delete Me.title;
    } else
      delete Me.identifier, delete Me.label;
    this.data.referenceType = void 0;
  }
  function $() {
    const Me = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ae = this.data.referenceType || "shortcut";
      Me.type += "Reference", Me.referenceType = Ae, delete Me.url, delete Me.title;
    } else
      delete Me.identifier, delete Me.label;
    this.data.referenceType = void 0;
  }
  function X(Me) {
    const Ae = this.sliceSerialize(Me), ie = this.stack[this.stack.length - 2];
    ie.label = SFt(Ae), ie.identifier = bp(Ae).toLowerCase();
  }
  function V() {
    const Me = this.stack[this.stack.length - 1], Ae = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const K = Me.children;
      ie.children = K;
    } else
      ie.alt = Ae;
  }
  function F() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.url = Me;
  }
  function le() {
    const Me = this.resume(), Ae = this.stack[this.stack.length - 1];
    Ae.title = Me;
  }
  function ae() {
    this.data.inReference = void 0;
  }
  function ne() {
    this.data.referenceType = "collapsed";
  }
  function ve(Me) {
    const Ae = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = Ae, ie.identifier = bp(
      this.sliceSerialize(Me)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function Ie(Me) {
    this.data.characterReferenceType = Me.type;
  }
  function Oe(Me) {
    const Ae = this.sliceSerialize(Me), ie = this.data.characterReferenceType;
    let K;
    ie ? (K = hve(
      Ae,
      ie === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : K = iM(Ae);
    const Z = this.stack.pop();
    Z.value += K, Z.position.end = Ol(Me.end);
  }
  function xe(Me) {
    z.call(this, Me);
    const Ae = this.stack[this.stack.length - 1];
    Ae.url = this.sliceSerialize(Me);
  }
  function ze(Me) {
    z.call(this, Me);
    const Ae = this.stack[this.stack.length - 1];
    Ae.url = "mailto:" + this.sliceSerialize(Me);
  }
  function qe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Je() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Be() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ne() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function je() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function et() {
    return {
      type: "break"
    };
  }
  function St() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ot() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function we() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function De(Me) {
    return {
      type: "list",
      ordered: Me.type === "listOrdered",
      start: null,
      spread: Me._spread,
      children: []
    };
  }
  function Ee(Me) {
    return {
      type: "listItem",
      spread: Me._spread,
      checked: null,
      children: []
    };
  }
  function te() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ue() {
    return {
      type: "strong",
      children: []
    };
  }
  function ye() {
    return {
      type: "text",
      value: ""
    };
  }
  function Le() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ol(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Ive(e, t) {
  let r = -1;
  for (; ++r < t.length; ) {
    const n = t[r];
    Array.isArray(n) ? Ive(e, n) : IFt(e, n);
  }
}
function IFt(e, t) {
  let r;
  for (r in t)
    if (bve.call(t, r))
      switch (r) {
        case "canContainEols": {
          const n = t[r];
          n && e[r].push(...n);
          break;
        }
        case "transforms": {
          const n = t[r];
          n && e[r].push(...n);
          break;
        }
        case "enter":
        case "exit": {
          const n = t[r];
          n && Object.assign(e[r], n);
          break;
        }
      }
}
function ZG(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + L4({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + L4({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + L4({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
var OFt = function e(t) {
  Object.freeze(t);
  var r = typeof t == "function", n = Object.prototype.hasOwnProperty;
  return Object.getOwnPropertyNames(t).forEach(function(i) {
    n.call(t, i) && (!r || i !== "caller" && i !== "callee" && i !== "arguments") && t[i] !== null && (typeof t[i] == "object" || typeof t[i] == "function") && !Object.isFrozen(t[i]) && e(t[i]);
  }), t;
};
const RFt = /* @__PURE__ */ Mt(OFt);
function wFt() {
  return Lr().setDictateState;
}
/*! For license information please see botframework-webchat-api.internal.mjs.LEGAL.txt */
var PFt = Zt, DFt = c0.map, xFt = KT, NFt = xFt("map");
PFt({ target: "Array", proto: !0, forced: !NFt }, {
  map: function(t) {
    return DFt(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var LFt = Aa, BFt = LFt("Array", "map"), kFt = Qi, MFt = BFt, HR = Array.prototype, FFt = function(e) {
  var t = e.map;
  return e === HR || kFt(HR, e) && t === HR.map ? MFt : t;
}, HFt = FFt, Ove = HFt, $Ft = Ove;
const UFt = /* @__PURE__ */ Mt($Ft);
var Rve = Hi, VFt = mn, wve = bn, jFt = LT, zFt = FT, qFt = Hu, YFt = PT.f, Pve = wve(YFt), GFt = wve([].push), WFt = Rve && VFt(function() {
  var e = /* @__PURE__ */ Object.create(null);
  return e[2] = 2, !Pve(e, 2);
}), QG = function(e) {
  return function(t) {
    for (var r = qFt(t), n = zFt(r), i = WFt && jFt(r) === null, o = n.length, a = 0, u = [], s; o > a; )
      s = n[a++], (!Rve || (i ? s in r : Pve(r, s))) && GFt(u, e ? [s, r[s]] : r[s]);
    return u;
  };
}, KFt = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: QG(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: QG(!1)
}, XFt = Zt, JFt = KFt.entries;
XFt({ target: "Object", stat: !0 }, {
  entries: function(t) {
    return JFt(t);
  }
});
var ZFt = Pn, QFt = ZFt.Object.entries, e7t = QFt, Dve = e7t, t7t = Dve;
const r7t = /* @__PURE__ */ Mt(t7t);
var VL = { exports: {} }, $R, eW;
function uM() {
  if (eW) return $R;
  eW = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $R = e, $R;
}
var UR, tW;
function n7t() {
  if (tW) return UR;
  tW = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = uM(), r = {}, n = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in o)
        if (n(o, l)) {
          var f;
          try {
            if (typeof o[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[l](a, l, s, u, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, UR = i, UR;
}
var VR, rW;
function i7t() {
  if (rW) return VR;
  rW = 1;
  var e = td(), t = Ok(), r = uM(), n = n7t(), i = Function.call.bind(Object.prototype.hasOwnProperty), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return VR = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(V) {
      var F = V && (c && V[c] || V[l]);
      if (typeof F == "function")
        return F;
    }
    var d = "<<anonymous>>", p = {
      array: m("array"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: g(),
      arrayOf: y,
      element: _(),
      elementType: S(),
      instanceOf: A,
      node: z(),
      objectOf: P,
      oneOf: O,
      oneOfType: U,
      shape: k,
      exact: H
    };
    function v(V, F) {
      return V === F ? V !== 0 || 1 / V === 1 / F : V !== V && F !== F;
    }
    function h(V) {
      this.message = V, this.stack = "";
    }
    h.prototype = Error.prototype;
    function E(V) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, le = 0;
      function ae(ve, Ie, Oe, xe, ze, qe, Je) {
        if (xe = xe || d, qe = qe || Oe, Je !== r) {
          if (s) {
            var Be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Be.name = "Invariant Violation", Be;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var We = xe + ":" + Oe;
            !F[We] && // Avoid spamming the console because they are often not actionable except for lib authors
            le < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + qe + "` prop on `" + xe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[We] = !0, le++);
          }
        }
        return Ie[Oe] == null ? ve ? Ie[Oe] === null ? new h("The " + ze + " `" + qe + "` is marked as required " + ("in `" + xe + "`, but its value is `null`.")) : new h("The " + ze + " `" + qe + "` is marked as required in " + ("`" + xe + "`, but its value is `undefined`.")) : null : V(Ie, Oe, xe, ze, qe);
      }
      var ne = ae.bind(null, !1);
      return ne.isRequired = ae.bind(null, !0), ne;
    }
    function m(V) {
      function F(le, ae, ne, ve, Ie, Oe) {
        var xe = le[ae], ze = D(xe);
        if (ze !== V) {
          var qe = w(xe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + qe + "` supplied to `" + ne + "`, expected ") + ("`" + V + "`."));
        }
        return null;
      }
      return E(F);
    }
    function g() {
      return E(a);
    }
    function y(V) {
      function F(le, ae, ne, ve, Ie) {
        if (typeof V != "function")
          return new h("Property `" + Ie + "` of component `" + ne + "` has invalid PropType notation inside arrayOf.");
        var Oe = le[ae];
        if (!Array.isArray(Oe)) {
          var xe = D(Oe);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected an array."));
        }
        for (var ze = 0; ze < Oe.length; ze++) {
          var qe = V(Oe, ze, ne, ve, Ie + "[" + ze + "]", r);
          if (qe instanceof Error)
            return qe;
        }
        return null;
      }
      return E(F);
    }
    function _() {
      function V(F, le, ae, ne, ve) {
        var Ie = F[le];
        if (!u(Ie)) {
          var Oe = D(Ie);
          return new h("Invalid " + ne + " `" + ve + "` of type " + ("`" + Oe + "` supplied to `" + ae + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(V);
    }
    function S() {
      function V(F, le, ae, ne, ve) {
        var Ie = F[le];
        if (!e.isValidElementType(Ie)) {
          var Oe = D(Ie);
          return new h("Invalid " + ne + " `" + ve + "` of type " + ("`" + Oe + "` supplied to `" + ae + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(V);
    }
    function A(V) {
      function F(le, ae, ne, ve, Ie) {
        if (!(le[ae] instanceof V)) {
          var Oe = V.name || d, xe = X(le[ae]);
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected ") + ("instance of `" + Oe + "`."));
        }
        return null;
      }
      return E(F);
    }
    function O(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(le, ae, ne, ve, Ie) {
        for (var Oe = le[ae], xe = 0; xe < V.length; xe++)
          if (v(Oe, V[xe]))
            return null;
        var ze = JSON.stringify(V, function(Je, Be) {
          var We = w(Be);
          return We === "symbol" ? String(Be) : Be;
        });
        return new h("Invalid " + ve + " `" + Ie + "` of value `" + String(Oe) + "` " + ("supplied to `" + ne + "`, expected one of " + ze + "."));
      }
      return E(F);
    }
    function P(V) {
      function F(le, ae, ne, ve, Ie) {
        if (typeof V != "function")
          return new h("Property `" + Ie + "` of component `" + ne + "` has invalid PropType notation inside objectOf.");
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type " + ("`" + xe + "` supplied to `" + ne + "`, expected an object."));
        for (var ze in Oe)
          if (i(Oe, ze)) {
            var qe = V(Oe, ze, ne, ve, Ie + "." + ze, r);
            if (qe instanceof Error)
              return qe;
          }
        return null;
      }
      return E(F);
    }
    function U(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < V.length; F++) {
        var le = V[F];
        if (typeof le != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(le) + " at index " + F + "."
          ), a;
      }
      function ae(ne, ve, Ie, Oe, xe) {
        for (var ze = 0; ze < V.length; ze++) {
          var qe = V[ze];
          if (qe(ne, ve, Ie, Oe, xe, r) == null)
            return null;
        }
        return new h("Invalid " + Oe + " `" + xe + "` supplied to " + ("`" + Ie + "`."));
      }
      return E(ae);
    }
    function z() {
      function V(F, le, ae, ne, ve) {
        return B(F[le]) ? null : new h("Invalid " + ne + " `" + ve + "` supplied to " + ("`" + ae + "`, expected a ReactNode."));
      }
      return E(V);
    }
    function k(V) {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type `" + xe + "` " + ("supplied to `" + ne + "`, expected `object`."));
        for (var ze in V) {
          var qe = V[ze];
          if (qe) {
            var Je = qe(Oe, ze, ne, ve, Ie + "." + ze, r);
            if (Je)
              return Je;
          }
        }
        return null;
      }
      return E(F);
    }
    function H(V) {
      function F(le, ae, ne, ve, Ie) {
        var Oe = le[ae], xe = D(Oe);
        if (xe !== "object")
          return new h("Invalid " + ve + " `" + Ie + "` of type `" + xe + "` " + ("supplied to `" + ne + "`, expected `object`."));
        var ze = t({}, le[ae], V);
        for (var qe in ze) {
          var Je = V[qe];
          if (!Je)
            return new h(
              "Invalid " + ve + " `" + Ie + "` key `" + qe + "` supplied to `" + ne + "`.\nBad object: " + JSON.stringify(le[ae], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var Be = Je(Oe, qe, ne, ve, Ie + "." + qe, r);
          if (Be)
            return Be;
        }
        return null;
      }
      return E(F);
    }
    function B(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(B);
          if (V === null || u(V))
            return !0;
          var F = f(V);
          if (F) {
            var le = F.call(V), ae;
            if (F !== V.entries) {
              for (; !(ae = le.next()).done; )
                if (!B(ae.value))
                  return !1;
            } else
              for (; !(ae = le.next()).done; ) {
                var ne = ae.value;
                if (ne && !B(ne[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function x(V, F) {
      return V === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function D(V) {
      var F = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : x(F, V) ? "symbol" : F;
    }
    function w(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var F = D(V);
      if (F === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function $(V) {
      var F = w(V);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function X(V) {
      return !V.constructor || !V.constructor.name ? d : V.constructor.name;
    }
    return p.checkPropTypes = n, p.resetWarningCache = n.resetWarningCache, p.PropTypes = p, p;
  }, VR;
}
var jR, nW;
function o7t() {
  if (nW) return jR;
  nW = 1;
  var e = uM();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, jR = function() {
    function n(a, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, jR;
}
if (process.env.NODE_ENV !== "production") {
  var a7t = td(), u7t = !0;
  VL.exports = i7t()(a7t.isElement, u7t);
} else
  VL.exports = o7t()();
var s7t = VL.exports;
const xr = /* @__PURE__ */ Mt(s7t);
var iW = /* @__PURE__ */ ei({
  abortable: !1,
  readyState: 0,
  supported: !0
});
function c7t(e) {
  var t = Ut();
  return nr(function() {
    t.current = e;
  }), t.current;
}
function Oc(e) {
  var t = Ut();
  return t.current = e, t;
}
function oW(e) {
  if (typeof window < "u")
    return typeof window[e] < "u" ? window[e] : window["webkit".concat(e)];
}
function Ud() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function() {
    var n = arguments, i = this;
    Pf(t).call(t, function(o) {
      return o.apply(i, n);
    });
  };
}
function nA(e) {
  return !!(e && typeof e.abort == "function");
}
var sM = function(t) {
  var r = t.children, n = t.extra, i = t.grammar, o = t.lang, a = t.onDictate, u = t.onError, s = t.onProgress, c = t.onRawEvent, l = t.speechGrammarList, f = t.speechRecognition, d = t.started, p = cn(0), v = as(p, 2), h = v[0], E = v[1], m = Ut(!1), g = Oc(n), y = Oc(i), _ = Oc(o), S = Ut(!1), A = Oc(a), O = Oc(u), P = Oc(s), U = Oc(c), z = c7t(f), k = Ut(), H = Oc(l), B = Oc(f);
  z !== f && (S.current = !1);
  var x = mt(function(ve) {
    var Ie = ve.target;
    return Ie === k.current && E(3);
  }, [k, E]), D = mt(function(ve) {
    var Ie = ve.target;
    Ie === k.current && (E(2), m.current = !0, P.current && P.current({
      abortable: nA(Ie),
      type: "progress"
    }));
  }, [m, P, k, E]), w = mt(function(ve) {
    var Ie = ve.target;
    Ie === k.current && (k.current = void 0, E(0), m.current && (A.current && A.current({
      type: "dictate"
    }), m.current = !1));
  }, [m, A, k, E]), $ = mt(function(ve) {
    ve.target === k.current && (m.current = !1, k.current = void 0, ve.error === "not-allowed" && (S.current = !0), E(0), O.current && O.current(ve));
  }, [m, O, S, k, E]), X = mt(function(ve) {
    ve.target === k.current && U.current && U.current(ve);
  }, [U, k]), V = mt(function(ve) {
    var Ie = ve.results, Oe = ve.target;
    if (Oe === k.current && Ie.length) {
      var xe = UFt([]).call(Ie, function(qe) {
        var Je = qe[0];
        return {
          confidence: Je.confidence,
          transcript: Je.transcript
        };
      }), ze = Ie[0];
      ze.isFinal ? (k.current = void 0, E(0), A.current && A.current({
        result: xe[0],
        type: "dictate"
      })) : P.current && P.current({
        abortable: nA(Oe),
        results: xe,
        type: "progress"
      });
    }
  }, [A, P, k, E]), F = mt(function(ve) {
    var Ie = ve.target;
    return Ie === k.current && E(1);
  }, [k, E]);
  nr(function() {
    if (d) {
      var ve;
      if (!B.current || S.current)
        throw new Error("Speech recognition is not supported");
      var Ie = H.current && y.current && new H.current(), Oe = k.current = new B.current();
      Ie && (Ie.addFromString(y.current, 1), Oe.grammars = Ie), Oe.lang = _.current, Oe.interimResults = !0, Oe.onaudioend = Ud(x, X), Oe.onaudiostart = Ud(D, X), Oe.onend = Ud(w, X), Oe.onerror = Ud($, X), Oe.onnomatch = X, Oe.onresult = Ud(V, X), Oe.onsoundend = X, Oe.onsoundstart = X, Oe.onspeechend = X, Oe.onspeechstart = X, Oe.onstart = Ud(F, X);
      var xe = g.current;
      xe && Pf(ve = r7t(xe)).call(ve, function(ze) {
        var qe = as(ze, 2), Je = qe[0], Be = qe[1];
        Je !== "constructor" && Je !== "prototype" && Je !== "__proto__" && (Oe[Je] = Be);
      }), Oe.start();
    }
    return function() {
      var ze = k.current;
      if (ze)
        if (nA(ze))
          ze.abort();
        else
          throw new Error("Failed to stop recognition while the current one is ongoing and is not abortable.");
    };
  }, [g, y, x, D, w, $, X, V, F, _, S, k, H, B, d]);
  var le = nA(k.current) && h === 2, ae = !!f && !S.current, ne = tt(function() {
    return {
      abortable: le,
      readyState: h,
      supported: ae
    };
  }, [le, h, ae]);
  return /* @__PURE__ */ G.createElement(iW.Provider, {
    value: ne
  }, /* @__PURE__ */ G.createElement(iW.Consumer, null, function(ve) {
    return typeof r == "function" ? r(ve) : r;
  }));
};
sM.defaultProps = {
  children: void 0,
  extra: void 0,
  grammar: void 0,
  lang: void 0,
  onDictate: void 0,
  onError: void 0,
  onProgress: void 0,
  onRawEvent: void 0,
  speechGrammarList: navigator.mediaDevices && navigator.mediaDevices.getUserMedia && oW("SpeechGrammarList"),
  speechRecognition: navigator.mediaDevices && navigator.mediaDevices.getUserMedia && oW("SpeechRecognition"),
  started: void 0
};
sM.propTypes = {
  children: xr.any,
  extra: xr.any,
  grammar: xr.string,
  lang: xr.string,
  onDictate: xr.func,
  onError: xr.func,
  onProgress: xr.func,
  onRawEvent: xr.func,
  speechGrammarList: xr.any,
  speechRecognition: xr.any,
  started: xr.any
};
xr.any, xr.string, xr.bool, xr.func.isRequired;
xr.any, xr.string, xr.bool, xr.any, xr.string, xr.string, xr.func, xr.func, xr.func, xr.func, xr.func, xr.any, xr.any;
xr.any, xr.string, xr.bool, xr.func.isRequired, xr.bool.isRequired;
xr.any, xr.string, xr.bool, xr.any, xr.string, xr.string, xr.func, xr.func, xr.func, xr.func, xr.any, xr.any;
var l7t = ude;
const f7t = /* @__PURE__ */ Mt(l7t);
function d7t(e) {
  if (f7t(e)) return e;
}
var p7t = Hde;
const Ef = /* @__PURE__ */ Mt(p7t);
var h7t = $de;
const v7t = /* @__PURE__ */ Mt(h7t);
function E7t(e, t) {
  var r = e == null ? null : typeof Ef < "u" && v7t(e) || e["@@iterator"];
  if (r != null) {
    var n, i, o, a, u = [], s = !0, c = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (a = r.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
var m7t = Vde;
const xve = /* @__PURE__ */ Mt(m7t);
var g7t = jde;
const T7t = /* @__PURE__ */ Mt(g7t);
function aW(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function y7t(e, t) {
  var r;
  if (e) {
    if (typeof e == "string") return aW(e, t);
    var n = xve(r = Object.prototype.toString.call(e)).call(r, 8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return T7t(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aW(e, t);
  }
}
function _7t() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function co(e, t) {
  return d7t(e) || E7t(e, t) || y7t(e, t) || _7t();
}
var Nve = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            n.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var u = r.apply(null, o);
              u && n.push(u);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              n.push(o.toString());
              continue;
            }
            for (var s in o)
              t.call(o, s) && o[s] && n.push(s);
          }
        }
      }
      return n.join(" ");
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Nve);
var A7t = Nve.exports;
const DS = /* @__PURE__ */ Mt(A7t);
var S7t = Ove;
const BC = /* @__PURE__ */ Mt(S7t);
var b7t = cu, uW = $b, C7t = As, I7t = function(t) {
  for (var r = b7t(this), n = C7t(r), i = arguments.length, o = uW(i > 1 ? arguments[1] : void 0, n), a = i > 2 ? arguments[2] : void 0, u = a === void 0 ? n : uW(a, n); u > o; ) r[o++] = t;
  return r;
}, O7t = Zt, R7t = I7t;
O7t({ target: "Array", proto: !0 }, {
  fill: R7t
});
var w7t = Aa, P7t = w7t("Array", "fill"), D7t = Qi, x7t = P7t, zR = Array.prototype, N7t = function(e) {
  var t = e.fill;
  return e === zR || D7t(zR, e) && t === zR.fill ? x7t : t;
}, L7t = N7t, B7t = L7t, k7t = B7t;
const M7t = /* @__PURE__ */ Mt(k7t), Lve = /* @__PURE__ */ ei();
function kC() {
  return En(Lve);
}
function F7t() {
  var e = kC(), t = e.index;
  return [t];
}
const Bve = /* @__PURE__ */ ei();
function cM() {
  var e = En(Bve);
  if (!e)
    throw new Error("react-film: Hooks can only be used inside the component.");
  return e;
}
function kve() {
  var e = cM(), t = e.scrollTo;
  return t;
}
var lM = function(t) {
  var r = t["aria-label"], n = t.itemIndex, i = F7t(), o = co(i, 1), a = o[0], u = kve(), s = a === n, c = mt(function() {
    return u(function() {
      return n;
    });
  }, [n, u]), l = mt(function(f) {
    var d = f.keyCode;
    (d === 13 || d === 32) && (f.preventDefault(), f.stopPropagation(), c());
  }, [c]);
  return /* @__PURE__ */ G.createElement("li", {
    className: "react-film__dot"
  }, /* @__PURE__ */ G.createElement("input", {
    "aria-label": r,
    "aria-pressed": s,
    checked: s,
    className: "react-film__dot__input",
    onChange: c,
    onKeyPress: l,
    role: "button",
    type: "checkbox"
  }), /* @__PURE__ */ G.createElement("div", {
    className: "react-film__dot__handle"
  }));
};
lM.defaultProps = {
  "aria-label": void 0
};
lM.propTypes = {
  "aria-label": Q.string,
  itemIndex: Q.number.isRequired
};
const Mve = /* @__PURE__ */ ei();
function ly() {
  var e = En(Mve);
  if (!e)
    throw new Error("react-film: Hooks can only be used inside the component.");
  return e;
}
function Fve() {
  var e = ly(), t = e.numItems;
  return [t];
}
var H7t = function() {
  var t, r, n = Fve(), i = co(n, 1), o = i[0];
  return /* @__PURE__ */ G.createElement("ul", {
    className: "react-film__dots"
  }, BC(t = M7t(r = new Array(o)).call(r)).call(t, function(a, u) {
    return (
      /* eslint-disable-next-line react/no-array-index-key */
      /* @__PURE__ */ G.createElement(lM, {
        "aria-label": u + 1 + "",
        itemIndex: u,
        key: u
      })
    );
  }));
};
const Hve = /* @__PURE__ */ ei();
function $ve() {
  var e = En(Hve);
  if (!e)
    throw new Error("react-film: Hooks can only be used inside the component.");
  return e;
}
function Uve() {
  var e = $ve(), t = e.itemContainerCallbackRefWithSubscribe;
  return mt(function(r) {
    return t(r);
  }, [t]);
}
function Vve() {
  var e = $ve(), t = e.scrollableCallbackRefWithSubscribe;
  return mt(function(r) {
    return t(r);
  }, [t]);
}
var fy = function(t) {
  var r = t.children, n = Uve(), i = Vve();
  return /* @__PURE__ */ G.createElement("div", {
    className: "react-film__filmstrip",
    ref: i
  }, /* @__PURE__ */ G.createElement("ul", {
    className: "react-film__filmstrip__list",
    ref: n
  }, BC(B1).call(B1, r, function(o) {
    return /* @__PURE__ */ G.createElement("li", {
      className: "react-film__filmstrip__item"
    }, o);
  })));
};
fy.defaultProps = {
  children: void 0
};
fy.propTypes = {
  children: Q.any
};
function fM() {
  var e = ly(), t = e.dir;
  return [t];
}
function jve() {
  var e = kC(), t = e.scrollBarPercentage;
  return [t];
}
function $7t() {
  var e = cM(), t = e.scrollOneLeft;
  return t;
}
function U7t() {
  var e = cM(), t = e.scrollOneRight;
  return t;
}
var qp = function(t) {
  var r = t["aria-label"], n = t.blurFocusOnClick, i = t.children, o = t.mode, a = fM(), u = co(a, 1), s = u[0], c = jve(), l = co(c, 1), f = l[0], d = Ut(), p = o === "left", v = $7t(), h = U7t(), E = mt(function() {
    p ? v() : h(), n && d.current && d.current.blur();
  }, [n, d, p, v, h]), m = mt(function(y) {
    var _ = y.key;
    (_ === "Enter" || _ === " ") && (y.preventDefault(), p ? v() : h());
  }, [p, v, h]), g;
  return s === "rtl" ? p ? g = f === "100%" || f === "-100%" : g = f === "0%" : p ? g = f === "0%" : g = f === "100%", /* @__PURE__ */ G.createElement("button", {
    "aria-label": r || (p ? "left" : "right"),
    className: DS("react-film__flipper", "react-film__main__overlay", {
      "react-film__flipper--left": p,
      "react-film__flipper--right": !p
    }),
    onClick: E,
    onKeyDown: m,
    ref: d,
    type: "button"
  }, /* @__PURE__ */ G.createElement("div", {
    className: DS("react-film__flipper__slider", "react-film__main__slider", {
      "react-film__main__slider--hide": g,
      "react-film__main__slider--left": p,
      "react-film__main__slider--right": !p
    })
  }, /* @__PURE__ */ G.createElement("div", {
    className: "react-film__flipper__body"
  }, i)));
};
qp.defaultProps = {
  "aria-label": void 0,
  blurFocusOnClick: !1,
  children: void 0,
  mode: "left"
};
qp.propTypes = {
  "aria-label": Q.string,
  blurFocusOnClick: Q.bool,
  children: Q.any,
  mode: Q.oneOf(["left", "right"])
};
var V7t = Ype, j7t = V7t, z7t = j7t, q7t = z7t, Y7t = q7t, G7t = Y7t;
const W7t = /* @__PURE__ */ Mt(G7t);
var K7t = Gpe, X7t = K7t, J7t = X7t, Z7t = J7t, Q7t = Z7t, eHt = Q7t;
const sW = /* @__PURE__ */ Mt(eHt);
var tHt = Wpe, rHt = tHt, nHt = rHt, iHt = nHt, oHt = iHt, aHt = oHt;
const uHt = /* @__PURE__ */ Mt(aHt);
var sHt = ehe, cHt = sHt, lHt = cHt, fHt = lHt, dHt = fHt, pHt = dHt;
const zve = /* @__PURE__ */ Mt(pHt);
var hHt = A9, vHt = hHt, EHt = vHt, mHt = EHt, gHt = mHt, THt = gHt;
const S1 = /* @__PURE__ */ Mt(THt);
var yHt = the, _Ht = yHt, AHt = _Ht, SHt = AHt, bHt = SHt, CHt = bHt;
const cW = /* @__PURE__ */ Mt(CHt);
var IHt = ihe, OHt = IHt, RHt = OHt, wHt = RHt, PHt = wHt, DHt = PHt;
const xHt = /* @__PURE__ */ Mt(DHt);
var NHt = Zde;
const xS = /* @__PURE__ */ Mt(NHt);
var LHt = Qde;
const BHt = /* @__PURE__ */ Mt(LHt);
function Yp(e) {
  "@babel/helpers - typeof";
  return Yp = typeof Ef == "function" && typeof BHt == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Ef == "function" && t.constructor === Ef && t !== Ef.prototype ? "symbol" : typeof t;
  }, Yp(e);
}
var kHt = epe;
const MHt = /* @__PURE__ */ Mt(kHt);
function FHt(e, t) {
  if (Yp(e) !== "object" || e === null) return e;
  var r = e[MHt];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Yp(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function HHt(e) {
  var t = FHt(e, "string");
  return Yp(t) === "symbol" ? t : String(t);
}
function jL(e, t, r) {
  return t = HHt(t), t in e ? xS(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function lW(e, t) {
  var r = W7t(e);
  if (sW) {
    var n = sW(e);
    t && (n = uHt(n).call(n, function(i) {
      return zve(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r, n, i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S1(r = lW(Object(i), !0)).call(r, function(o) {
      jL(e, o, i[o]);
    }) : cW ? xHt(e, cW(i)) : S1(n = lW(Object(i))).call(n, function(o) {
      xS(e, o, zve(i, o));
    });
  }
  return e;
}
var qve = `	
\v\f\r                　\u2028\u2029\uFEFF`, $Ht = bn, UHt = dh, VHt = a0, zL = qve, fW = $Ht("".replace), jHt = RegExp("^[" + zL + "]+"), zHt = RegExp("(^|[^" + zL + "])[" + zL + "]+$"), qR = function(e) {
  return function(t) {
    var r = VHt(UHt(t));
    return e & 1 && (r = fW(r, jHt, "")), e & 2 && (r = fW(r, zHt, "$1")), r;
  };
}, qHt = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: qR(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: qR(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: qR(3)
}, Yve = Mn, YHt = mn, GHt = bn, WHt = a0, KHt = qHt.trim, XHt = qve, JHt = GHt("".charAt), NS = Yve.parseFloat, dW = Yve.Symbol, pW = dW && dW.iterator, ZHt = 1 / NS(XHt + "-0") !== -1 / 0 || pW && !YHt(function() {
  NS(Object(pW));
}), QHt = ZHt ? function(t) {
  var r = KHt(WHt(t)), n = NS(r);
  return n === 0 && JHt(r, 0) === "-" ? -0 : n;
} : NS, e$t = Zt, hW = QHt;
e$t({ global: !0, forced: parseFloat !== hW }, {
  parseFloat: hW
});
var t$t = Pn, r$t = t$t.parseFloat, n$t = r$t, i$t = n$t, o$t = i$t;
const Vd = /* @__PURE__ */ Mt(o$t);
var a$t = navigator, Gve = a$t.userAgent, dM = /Edge\//.test(Gve), pM = /Trident\/7(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])0/.test(Gve);
function hM() {
  var e = kC(), t = e.scrollBarWidth;
  return [t];
}
var u$t = function() {
  var t = fM(), r = co(t, 1), n = r[0], i = jve(), o = co(i, 1), a = o[0], u = hM(), s = co(u, 1), c = s[0];
  return /* @__PURE__ */ G.createElement("div", {
    className: "react-film__scroll-bar react-film__main__slider react-film__main__slider--bottom"
  }, /* @__PURE__ */ G.createElement("div", {
    className: "react-film__scroll-bar__handle",
    style: hi(hi({}, n === "rtl" ? dM || pM ? {
      marginRight: "".concat((1 - Vd(c) / 100) * Vd(a), "%")
    } : {
      marginRight: "".concat((Vd(c) / 100 - 1) * Vd(a), "%")
    } : {
      marginLeft: "".concat((1 - Vd(c) / 100) * Vd(a), "%")
    }), {}, {
      width: c
    })
  }));
};
function s$t() {
  var e = ly(), t = e.height;
  return [t];
}
function vM() {
  var e = kC(), t = e.scrolling;
  return [t];
}
function Wve() {
  var e = ly(), t = e.styleOptions;
  return [t];
}
function Kve() {
  var e = ly(), t = e.styleSetClassNames;
  return [t];
}
var dy = function(t) {
  var r = t.children, n = t.className, i = fM(), o = co(i, 1), a = o[0], u = s$t(), s = co(u, 1), c = s[0], l = Fve(), f = co(l, 1), d = f[0], p = hM(), v = co(p, 1), h = v[0], E = vM(), m = co(E, 1), g = m[0], y = Kve(), _ = co(y, 1), S = _[0].root, A = Wve(), O = co(A, 1), P = O[0], U = P.flipperBlurFocusOnClick, z = P.leftFlipperAriaLabel, k = P.leftFlipperText, H = P.rightFlipperAriaLabel, B = P.rightFlipperText, x = P.showDots, D = P.showFlipper, w = P.showScrollBar, $ = tt(function() {
    return {
      height: c
    };
  }, [c]);
  return /* @__PURE__ */ G.createElement("div", {
    className: DS(S, (n || "") + ""),
    dir: a
  }, /* @__PURE__ */ G.createElement("div", {
    className: DS("react-film__main", {
      "react-film__main--scrolling": g
    }),
    style: $
  }, !!d && h !== "100%" && !!D && /* @__PURE__ */ G.createElement(qp, {
    "aria-label": z,
    blurFocusOnClick: U,
    mode: "left"
  }, k), /* @__PURE__ */ G.createElement(fy, null, r), !!d && h !== "100%" && !!D && /* @__PURE__ */ G.createElement(qp, {
    "aria-label": H,
    blurFocusOnClick: U,
    mode: "right"
  }, B), !!d && h !== "100%" && !!w && /* @__PURE__ */ G.createElement(u$t, null)), !!d && h !== "100%" && !!x && /* @__PURE__ */ G.createElement(H7t, null));
};
dy.defaultProps = {
  children: void 0,
  className: void 0
};
dy.propTypes = {
  children: Q.any,
  className: Q.string
};
var c$t = Zt, l$t = ic, f$t = Ph;
c$t({ target: "Object", stat: !0 }, {
  fromEntries: function(t) {
    var r = {};
    return l$t(t, function(n, i) {
      f$t(r, n, i);
    }, { AS_ENTRIES: !0 }), r;
  }
});
var d$t = Pn, p$t = d$t.Object.fromEntries, h$t = p$t, v$t = h$t, E$t = v$t;
const m$t = /* @__PURE__ */ Mt(E$t);
var g$t = Dve;
const T$t = /* @__PURE__ */ Mt(g$t);
var y$t = mhe;
const MC = /* @__PURE__ */ Mt(y$t);
function vW(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function EW(e, t, r) {
  var n = [], i = Lh(e, n, r);
  return n.length < 2 ? r : i + t(n);
}
var _$t = function(t) {
  var r = O9(t);
  r.sheet.speedy = function(u) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = u;
  }, r.compat = !0;
  var n = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered, void 0);
    return R9(r, f), r.key + "-" + f.name;
  }, i = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered), d = "animation-" + f.name;
    return vW(r, {
      name: f.name,
      styles: "@keyframes " + d + "{" + f.styles + "}"
    }), d;
  }, o = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var f = jc(c, r.registered);
    vW(r, f);
  }, a = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    return EW(r.registered, n, A$t(c));
  };
  return {
    css: n,
    cx: a,
    injectGlobal: o,
    keyframes: i,
    hydrate: function(s) {
      s.forEach(function(c) {
        r.inserted[c] = !0;
      });
    },
    flush: function() {
      r.registered = {}, r.inserted = {}, r.sheet.flush();
    },
    // $FlowFixMe
    sheet: r.sheet,
    cache: r,
    getRegisteredStyles: Lh.bind(null, r.registered),
    merge: EW.bind(null, r.registered, n)
  };
}, A$t = function e(t) {
  for (var r = "", n = 0; n < t.length; n++) {
    var i = t[n];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            o = "";
            for (var a in i)
              i[a] && a && (o && (o += " "), o += a);
          }
          break;
        }
        default:
          o = i;
      }
      o && (r && (r += " "), r += o);
    }
  }
  return r;
};
function S$t(e, t) {
  nr(function() {
    if (e) {
      var r = MC(e, t);
      return function() {
        return clearTimeout(r);
      };
    }
  }, [t, e]);
}
function b$t() {
  var e = Wve(), t = co(e, 1), r = t[0].autoCenter, n = vM(), i = co(n, 1), o = i[0], a = kve(), u = mt(function() {
    return a(function(s) {
      var c = s.index;
      return c;
    });
  }, [a]);
  S$t(!r || o ? void 0 : u, 0);
}
var C$t = function() {
  return b$t(), !1;
};
function I$t(e, t, r, n) {
  var i = e === "rtl";
  if (r && t) {
    var o = r.children, a = o[Math.max(0, Math.min(o.length - 1, n))];
    if (a) {
      if (t.offsetWidth === t.scrollWidth)
        return 0;
      var u = a.offsetLeft + (a.offsetWidth - t.offsetWidth) / 2;
      return i ? (u = Math.min(u, 0), u = Math.max(u, t.offsetWidth - t.scrollWidth)) : (u = Math.max(u, 0), u = Math.min(u, t.scrollWidth - t.offsetWidth)), i && (dM || pM) && (u = -u), u;
    }
  }
}
var O$t = 20, R$t = 6, w$t = 60, P$t = 40, D$t = 8, x$t = 4;
function Xve() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.autoCenter, r = e.autoHide, n = e.autoHideFlipperOnEdge, i = e.cursor, o = e.dir, a = e.dotBoxSize, u = e.dotSize, s = e.flipperBlurFocusOnClick, c = e.flipperBoxWidth, l = e.flipperSize, f = e.leftFlipperAriaLabel, d = e.leftFlipperText, p = e.rightFlipperAriaLabel, v = e.rightFlipperText, h = e.scrollBarHeight, E = e.scrollBarMargin, m = e.showDots, g = e.showFlipper, y = e.showScrollBar, _ = o === "rtl";
  return {
    autoCenter: t !== !1,
    autoHide: r !== !1,
    autoHideFlipperOnEdge: n !== !1,
    cursor: typeof i > "u" ? "pointer" : i,
    dotBoxSize: typeof a == "number" ? a : O$t,
    dotSize: typeof u == "number" ? u : R$t,
    flipperBlurFocusOnClick: s === !0,
    flipperBoxWidth: typeof c == "number" ? c : w$t,
    flipperSize: typeof l == "number" ? l : P$t,
    leftFlipperAriaLabel: f || "left",
    leftFlipperText: d || (_ ? ">" : "<"),
    rightFlipperAriaLabel: p || "right",
    rightFlipperText: v || (_ ? "<" : ">"),
    scrollBarHeight: typeof h == "number" ? h : D$t,
    scrollBarMargin: typeof E == "number" ? E : x$t,
    showDots: m !== !1,
    showFlipper: g !== !1,
    showScrollBar: y !== !1
  };
}
var N$t = function(t) {
  var r = t.dotBoxSize;
  return {
    "& .react-film__dots": {
      alignItems: "center",
      bottom: 0,
      display: "flex",
      height: r,
      justifyContent: "center",
      listStyleType: "none",
      margin: 0,
      padding: 0,
      width: "100%"
    }
  };
}, L$t = function(t) {
  var r = t.cursor, n = t.dotBoxSize, i = t.dotSize;
  return {
    "& .react-film__dot": {
      alignItems: "center",
      display: "flex",
      height: n,
      justifyContent: "center",
      position: "relative",
      width: n,
      "& .react-film__dot__input": hi(hi({}, r ? {
        cursor: r
      } : {}), {}, {
        height: "100%",
        left: 0,
        margin: 0,
        opacity: 0,
        position: "absolute",
        top: 0,
        touchAction: "none",
        userSelect: "none",
        width: "100%"
      }),
      "& .react-film__dot__handle": {
        background: "rgba(0, 0, 0, .2)",
        borderRadius: i / 2,
        height: i,
        width: i
      },
      "&:hover .react-film__dot__handle, & .react-film__dot__input:focus + .react-film__dot__handle": {
        background: "rgba(0, 0, 0, .4)"
      },
      "& .react-film__dot__input:active + .react-film__dot__handle": {
        background: "rgba(0, 0, 0, .8)"
      },
      "& .react-film__dot__input:checked:not(:active) + .react-film__dot__handle": {
        background: "rgba(0, 0, 0, .6)"
      }
    }
  };
}, B$t = function(t) {
  var r, n = t.cursor, i = t.flipperBoxWidth, o = t.flipperSize;
  return {
    "& .react-film__flipper": hi(hi({}, n ? {
      cursor: n
    } : {}), {}, {
      background: "Transparent",
      border: 0,
      height: "100%",
      outline: 0,
      overflow: "hidden",
      position: "absolute",
      top: 0,
      touchAction: "none",
      userSelect: "none",
      width: i,
      zIndex: 1,
      "&.react-film__flipper--left": {
        left: 0,
        "& .react-film__flipper__slider": {
          left: 0
        }
      },
      "&.react-film__flipper--right": {
        right: 0,
        "& .react-film__flipper__slider": {
          right: 0
        }
      },
      "& .react-film__flipper__slider": {
        alignItems: "center",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        width: "100%"
      },
      "& .react-film__flipper__body": {
        backgroundColor: "rgba(0, 0, 0, .6)",
        borderRadius: "50%",
        color: "rgba(255, 255, 255, .6)",
        fontFamily: BC(r = ["Consolas", "monospace"]).call(r, function(a) {
          return "'".concat(a, "'");
        }).join(", "),
        fontSize: 16,
        height: o,
        lineHeight: "".concat(o, "px"),
        overflow: "hidden",
        position: "relative",
        transitionDuration: "100ms",
        transitionProperty: "background-color",
        width: o
      },
      "&:hover, &:focus": {
        "& .react-film__flipper__body": {
          backgroundColor: "rgba(0, 0, 0, .8)",
          color: "rgba(255, 255, 255, .8)",
          transitionDuration: 0
        }
      },
      "&:active .react-film__flipper__body": {
        backgroundColor: "Black",
        color: "White",
        transitionDuration: 0
      }
    })
  };
}, k$t = function() {
  return {
    "& .react-film__filmstrip": {
      MsOverflowStyle: "none",
      overflowX: "scroll",
      overflowY: "hidden",
      overscrollBehaviorX: "contain",
      position: "relative",
      touchAction: "manipulation",
      zIndex: 0,
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "& .react-film__filmstrip__list": {
        display: "flex",
        listStyleType: "none",
        margin: 0,
        padding: 0
      }
    }
  };
}, M$t = function(t) {
  var r = t.autoHide, n = t.scrollBarHeight, i = t.scrollBarMargin;
  return {
    "& .react-film__scroll-bar": {
      bottom: r ? -30 : 0,
      boxSizing: "border-box",
      padding: i,
      position: "absolute",
      transitionDelay: "1s",
      transitionDuration: "300ms",
      transitionProperty: "bottom",
      width: "100%",
      "& .react-film__scroll-bar__handle": {
        backdropFilter: "blur(4px)",
        background: "rgba(255, 255, 255, .4)",
        borderRadius: n / 2,
        height: n
      }
    }
  };
}, F$t = function(t) {
  var r = t.autoHide, n = t.autoHideFlipperOnEdge, i = t.flipperBoxWidth, o = t.flipperSize;
  return {
    "& .react-film__main": hi({
      overflow: "hidden",
      position: "relative"
    }, r ? {
      "&:hover, &.react-film__main--scrolling": {
        "& .react-film__main__slider": {
          transitionDelay: "0s",
          "&.react-film__main__slider--bottom": {
            bottom: 0
          },
          "&.react-film__main__slider--left": jL({}, n ? "&:not(.react-film__main__slider--hide)" : "&", {
            left: 0
          }),
          "&.react-film__main__slider--right": jL({}, n ? "&:not(.react-film__main__slider--hide)" : "&", {
            right: 0
          })
        }
      },
      "& .react-film__main__overlay:focus .react-film__main__slider:not(.react-film__main__slider--hide)": {
        transitionDelay: "0s",
        "&.react-film__main__slider--left": {
          left: 0
        },
        "&.react-film__main__slider--right": {
          right: 0
        }
      },
      "& .react-film__main__slider": {
        transitionDelay: "1s",
        transitionDuration: "300ms",
        "&.react-film__main__slider--left": {
          left: (i + o) / -2,
          transitionProperty: "left"
        },
        "&.react-film__main__slider--right": {
          right: (i + o) / -2,
          transitionProperty: "right"
        }
      }
    } : {})
  };
};
function EM(e) {
  return e = Xve(e), {
    root: hi(hi(hi(hi(hi(hi({}, N$t(e)), L$t(e)), k$t()), B$t(e)), F$t(e)), M$t(e))
  };
}
function H$t() {
  return Mu().toString(26).substr(2, 5).replace(/[0-9]/g, function(e) {
    return String.fromCharCode(e.charCodeAt(0) + 65);
  });
}
var $$t = t9;
const U$t = /* @__PURE__ */ Mt($$t);
var V$t = _a, j$t = cu, z$t = Mb, q$t = As, mW = TypeError, gW = "Reduce of empty array with no initial value", TW = function(e) {
  return function(t, r, n, i) {
    var o = j$t(t), a = z$t(o), u = q$t(o);
    if (V$t(r), u === 0 && n < 2) throw new mW(gW);
    var s = e ? u - 1 : 0, c = e ? -1 : 1;
    if (n < 2) for (; ; ) {
      if (s in a) {
        i = a[s], s += c;
        break;
      }
      if (s += c, e ? s < 0 : u <= s)
        throw new mW(gW);
    }
    for (; e ? s >= 0 : u > s; s += c) s in a && (i = r(i, a[s], s, o));
    return i;
  };
}, Y$t = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: TW(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: TW(!0)
}, G$t = Zt, W$t = Y$t.left, K$t = xh, yW = DT, X$t = zb, J$t = !X$t && yW > 79 && yW < 83, Z$t = J$t || !K$t("reduce");
G$t({ target: "Array", proto: !0, forced: Z$t }, {
  reduce: function(t) {
    var r = arguments.length;
    return W$t(this, t, r, r > 1 ? arguments[1] : void 0);
  }
});
var Q$t = Aa, eUt = Q$t("Array", "reduce"), tUt = Qi, rUt = eUt, YR = Array.prototype, nUt = function(e) {
  var t = e.reduce;
  return e === YR || tUt(YR, e) && t === YR.reduce ? rUt : t;
}, iUt = nUt, oUt = iUt, aUt = oUt;
const uUt = /* @__PURE__ */ Mt(aUt);
function sUt(e, t) {
  return uUt(e).call(e, function(r, n, i) {
    var o = t.call(e, n, i);
    return o > r.score ? {
      index: i,
      score: o
    } : r;
  }, {
    index: -1,
    score: -1 / 0
  }).index;
}
function _W(e, t, r, n) {
  var i = e === "rtl";
  if (r && t) {
    var o = n || t.scrollLeft, a = i && (dM || pM) ? -o : o, u = r.children, s = a + t.offsetWidth / 2, c = sUt(U$t([]).call(u), function(v) {
      var h = v.offsetLeft + v.offsetWidth / 2;
      return 1 / Math.abs(s - h);
    });
    if (~c) {
      var l = u[c], f = l.offsetLeft + l.offsetWidth / 2, d = c + (s - f) / l.offsetWidth * (i ? -1 : 1);
      (d % 1 > 0.99 || d % 1 < 0.01) && (d = Math.round(d));
      var p;
      return Math.abs(a) < 1 ? p = 0 : (i ? a <= t.offsetWidth - t.scrollWidth : a >= t.scrollWidth - t.offsetWidth) ? p = u.length - 1 : p = Math.round(d), {
        index: p,
        indexFraction: d
      };
    }
  }
}
const cUt = /* @__PURE__ */ ei();
var lUt = The;
const fUt = /* @__PURE__ */ Mt(lUt);
var dUt = zpe;
const LS = /* @__PURE__ */ Mt(dUt);
function pUt(e, t, r, n) {
  for (var i = e, o = 0; o < n; o++)
    i = r(i, t);
  return i;
}
function hUt(e, t) {
  var r = fUt(t - e), n = Math.sqrt(Math.abs(t - e)), i = e + n * r;
  return r > 0 ? Math.min(t, i) : Math.max(t, i);
}
function vUt(e, t, r) {
  nr(function() {
    if (e) {
      var n = LS(), i, o = function a(u) {
        i = requestAnimationFrame(function() {
          var s = pUt(u, t, hUt, (LS() - n) / 5);
          Math.abs(t - s) < 0.5 && (s = t), e.scrollLeft = s, t === s ? r && r(!0) : a(u);
        });
      };
      return o(e.scrollLeft), function() {
        return cancelAnimationFrame(i);
      };
    }
  }, [e, t, r]);
}
var EUt = A9;
const mUt = /* @__PURE__ */ Mt(EUt);
var gUt = Upe;
const TUt = /* @__PURE__ */ Mt(gUt);
var yUt = Vpe;
const _Ut = /* @__PURE__ */ Mt(yUt);
var AW = 10;
function SW() {
  return tt(function() {
    var e = [], t = function r(n) {
      r.current = n, mUt(e).call(e, function(i) {
        i.cleanup && i.cleanup(), i.cleanup = i.callback(n);
      });
    };
    return t.subscribe = function(r) {
      var n = {
        callback: r
      };
      return e.push(n), e.length >= AW && console.warn("useSubscribe: Reaching maximum limit of subscribers (".concat(AW, "), please make sure your code did clean up properly.")), n.cleanup = r(t.current), function() {
        n.cleanup && n.cleanup();
        var i = TUt(e).call(e, n);
        ~i && _Ut(e).call(e, i, 1);
      };
    }, t;
  }, []);
}
var AUt = Nfe, SUt = AUt, bUt = SUt, CUt = bUt, Jve = CUt;
const IUt = /* @__PURE__ */ Mt(Jve);
var OUt = Jve;
const GR = /* @__PURE__ */ Mt(OUt);
var RUt = Zt, wUt = mn, PUt = cu, Zve = LT, DUt = ale, xUt = wUt(function() {
  Zve(1);
});
RUt({ target: "Object", stat: !0, forced: xUt, sham: !DUt }, {
  getPrototypeOf: function(t) {
    return Zve(PUt(t));
  }
});
var NUt = Pn, LUt = NUt.Object.getPrototypeOf, BUt = LUt, Qve = BUt, kUt = Qve, MUt = kUt, FUt = MUt, HUt = FUt, eEe = HUt;
const bW = /* @__PURE__ */ Mt(eEe);
var $Ut = eEe;
const UUt = /* @__PURE__ */ Mt($Ut);
var VUt = Zt, jUt = ule;
VUt({ target: "Object", stat: !0 }, {
  setPrototypeOf: jUt
});
var zUt = Pn, qUt = zUt.Object.setPrototypeOf, YUt = qUt, tEe = YUt, GUt = tEe, WUt = GUt, KUt = WUt, XUt = KUt, rEe = XUt;
const qL = /* @__PURE__ */ Mt(rEe);
var JUt = rEe;
const CW = /* @__PURE__ */ Mt(JUt);
var ZUt = lk, QUt = ZUt, eVt = QUt, tVt = eVt, rVt = tVt, nVt = rVt;
const mM = /* @__PURE__ */ Mt(nVt);
var iVt = Zt, oVt = bn, aVt = rd, uVt = oVt([].reverse), IW = [1, 2];
iVt({ target: "Array", proto: !0, forced: String(IW) === String(IW.reverse()) }, {
  reverse: function() {
    return aVt(this) && (this.length = this.length), uVt(this);
  }
});
var sVt = Aa, cVt = sVt("Array", "reverse"), lVt = Qi, fVt = cVt, WR = Array.prototype, dVt = function(e) {
  var t = e.reverse;
  return e === WR || lVt(WR, e) && t === WR.reverse ? fVt : t;
}, pVt = dVt, hVt = pVt, vVt = hVt, EVt = vVt, mVt = EVt, gVt = mVt, TVt = gVt, yVt = TVt;
const _Vt = /* @__PURE__ */ Mt(yVt);
function YL() {
  YL = function() {
    return e;
  };
  var e = {}, t = Object.prototype, r = t.hasOwnProperty, n = xS || function(H, B, x) {
    H[B] = x.value;
  }, i = typeof Ef == "function" ? Ef : {}, o = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function s(H, B, x) {
    return xS(H, B, {
      value: x,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), H[B];
  }
  try {
    s({}, "");
  } catch {
    s = function(x, D, w) {
      return x[D] = w;
    };
  }
  function c(H, B, x, D) {
    var w = B && B.prototype instanceof d ? B : d, $ = GR(w.prototype), X = new U(D || []);
    return n($, "_invoke", {
      value: S(H, x, X)
    }), $;
  }
  function l(H, B, x) {
    try {
      return {
        type: "normal",
        arg: H.call(B, x)
      };
    } catch (D) {
      return {
        type: "throw",
        arg: D
      };
    }
  }
  e.wrap = c;
  var f = {};
  function d() {
  }
  function p() {
  }
  function v() {
  }
  var h = {};
  s(h, o, function() {
    return this;
  });
  var E = UUt, m = E && E(E(z([])));
  m && m !== t && r.call(m, o) && (h = m);
  var g = v.prototype = d.prototype = GR(h);
  function y(H) {
    var B;
    S1(B = ["next", "throw", "return"]).call(B, function(x) {
      s(H, x, function(D) {
        return this._invoke(x, D);
      });
    });
  }
  function _(H, B) {
    function x(w, $, X, V) {
      var F = l(H[w], H, $);
      if (F.type !== "throw") {
        var le = F.arg, ae = le.value;
        return ae && Yp(ae) == "object" && r.call(ae, "__await") ? B.resolve(ae.__await).then(function(ne) {
          x("next", ne, X, V);
        }, function(ne) {
          x("throw", ne, X, V);
        }) : B.resolve(ae).then(function(ne) {
          le.value = ne, X(le);
        }, function(ne) {
          return x("throw", ne, X, V);
        });
      }
      V(F.arg);
    }
    var D;
    n(this, "_invoke", {
      value: function($, X) {
        function V() {
          return new B(function(F, le) {
            x($, X, F, le);
          });
        }
        return D = D ? D.then(V, V) : V();
      }
    });
  }
  function S(H, B, x) {
    var D = "suspendedStart";
    return function(w, $) {
      if (D === "executing") throw new Error("Generator is already running");
      if (D === "completed") {
        if (w === "throw") throw $;
        return k();
      }
      for (x.method = w, x.arg = $; ; ) {
        var X = x.delegate;
        if (X) {
          var V = A(X, x);
          if (V) {
            if (V === f) continue;
            return V;
          }
        }
        if (x.method === "next") x.sent = x._sent = x.arg;
        else if (x.method === "throw") {
          if (D === "suspendedStart") throw D = "completed", x.arg;
          x.dispatchException(x.arg);
        } else x.method === "return" && x.abrupt("return", x.arg);
        D = "executing";
        var F = l(H, B, x);
        if (F.type === "normal") {
          if (D = x.done ? "completed" : "suspendedYield", F.arg === f) continue;
          return {
            value: F.arg,
            done: x.done
          };
        }
        F.type === "throw" && (D = "completed", x.method = "throw", x.arg = F.arg);
      }
    };
  }
  function A(H, B) {
    var x = B.method, D = H.iterator[x];
    if (D === void 0) return B.delegate = null, x === "throw" && H.iterator.return && (B.method = "return", B.arg = void 0, A(H, B), B.method === "throw") || x !== "return" && (B.method = "throw", B.arg = new TypeError("The iterator does not provide a '" + x + "' method")), f;
    var w = l(D, H.iterator, B.arg);
    if (w.type === "throw") return B.method = "throw", B.arg = w.arg, B.delegate = null, f;
    var $ = w.arg;
    return $ ? $.done ? (B[H.resultName] = $.value, B.next = H.nextLoc, B.method !== "return" && (B.method = "next", B.arg = void 0), B.delegate = null, f) : $ : (B.method = "throw", B.arg = new TypeError("iterator result is not an object"), B.delegate = null, f);
  }
  function O(H) {
    var B = {
      tryLoc: H[0]
    };
    1 in H && (B.catchLoc = H[1]), 2 in H && (B.finallyLoc = H[2], B.afterLoc = H[3]), this.tryEntries.push(B);
  }
  function P(H) {
    var B = H.completion || {};
    B.type = "normal", delete B.arg, H.completion = B;
  }
  function U(H) {
    this.tryEntries = [{
      tryLoc: "root"
    }], S1(H).call(H, O, this), this.reset(!0);
  }
  function z(H) {
    if (H) {
      var B = H[o];
      if (B) return B.call(H);
      if (typeof H.next == "function") return H;
      if (!isNaN(H.length)) {
        var x = -1, D = function w() {
          for (; ++x < H.length; ) if (r.call(H, x)) return w.value = H[x], w.done = !1, w;
          return w.value = void 0, w.done = !0, w;
        };
        return D.next = D;
      }
    }
    return {
      next: k
    };
  }
  function k() {
    return {
      value: void 0,
      done: !0
    };
  }
  return p.prototype = v, n(g, "constructor", {
    value: v,
    configurable: !0
  }), n(v, "constructor", {
    value: p,
    configurable: !0
  }), p.displayName = s(v, u, "GeneratorFunction"), e.isGeneratorFunction = function(H) {
    var B = typeof H == "function" && H.constructor;
    return !!B && (B === p || (B.displayName || B.name) === "GeneratorFunction");
  }, e.mark = function(H) {
    return CW ? CW(H, v) : (H.__proto__ = v, s(H, u, "GeneratorFunction")), H.prototype = GR(g), H;
  }, e.awrap = function(H) {
    return {
      __await: H
    };
  }, y(_.prototype), s(_.prototype, a, function() {
    return this;
  }), e.AsyncIterator = _, e.async = function(H, B, x, D, w) {
    w === void 0 && (w = mM);
    var $ = new _(c(H, B, x, D), w);
    return e.isGeneratorFunction(B) ? $ : $.next().then(function(X) {
      return X.done ? X.value : $.next();
    });
  }, y(g), s(g, u, "Generator"), s(g, o, function() {
    return this;
  }), s(g, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(H) {
    var B = Object(H), x = [];
    for (var D in B) x.push(D);
    return _Vt(x).call(x), function w() {
      for (; x.length; ) {
        var $ = x.pop();
        if ($ in B) return w.value = $, w.done = !1, w;
      }
      return w.done = !0, w;
    };
  }, e.values = z, U.prototype = {
    constructor: U,
    reset: function(B) {
      var x;
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, S1(x = this.tryEntries).call(x, P), !B) for (var D in this) D.charAt(0) === "t" && r.call(this, D) && !isNaN(+xve(D).call(D, 1)) && (this[D] = void 0);
    },
    stop: function() {
      this.done = !0;
      var B = this.tryEntries[0].completion;
      if (B.type === "throw") throw B.arg;
      return this.rval;
    },
    dispatchException: function(B) {
      if (this.done) throw B;
      var x = this;
      function D(le, ae) {
        return X.type = "throw", X.arg = B, x.next = le, ae && (x.method = "next", x.arg = void 0), !!ae;
      }
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var $ = this.tryEntries[w], X = $.completion;
        if ($.tryLoc === "root") return D("end");
        if ($.tryLoc <= this.prev) {
          var V = r.call($, "catchLoc"), F = r.call($, "finallyLoc");
          if (V && F) {
            if (this.prev < $.catchLoc) return D($.catchLoc, !0);
            if (this.prev < $.finallyLoc) return D($.finallyLoc);
          } else if (V) {
            if (this.prev < $.catchLoc) return D($.catchLoc, !0);
          } else {
            if (!F) throw new Error("try statement without catch or finally");
            if (this.prev < $.finallyLoc) return D($.finallyLoc);
          }
        }
      }
    },
    abrupt: function(B, x) {
      for (var D = this.tryEntries.length - 1; D >= 0; --D) {
        var w = this.tryEntries[D];
        if (w.tryLoc <= this.prev && r.call(w, "finallyLoc") && this.prev < w.finallyLoc) {
          var $ = w;
          break;
        }
      }
      $ && (B === "break" || B === "continue") && $.tryLoc <= x && x <= $.finallyLoc && ($ = null);
      var X = $ ? $.completion : {};
      return X.type = B, X.arg = x, $ ? (this.method = "next", this.next = $.finallyLoc, f) : this.complete(X);
    },
    complete: function(B, x) {
      if (B.type === "throw") throw B.arg;
      return B.type === "break" || B.type === "continue" ? this.next = B.arg : B.type === "return" ? (this.rval = this.arg = B.arg, this.method = "return", this.next = "end") : B.type === "normal" && x && (this.next = x), f;
    },
    finish: function(B) {
      for (var x = this.tryEntries.length - 1; x >= 0; --x) {
        var D = this.tryEntries[x];
        if (D.finallyLoc === B) return this.complete(D.completion, D.afterLoc), P(D), f;
      }
    },
    catch: function(B) {
      for (var x = this.tryEntries.length - 1; x >= 0; --x) {
        var D = this.tryEntries[x];
        if (D.tryLoc === B) {
          var w = D.completion;
          if (w.type === "throw") {
            var $ = w.arg;
            P(D);
          }
          return $;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(B, x, D) {
      return this.delegate = {
        iterator: z(B),
        resultName: x,
        nextLoc: D
      }, this.method === "next" && (this.arg = void 0), f;
    }
  }, e;
}
function OW(e, t, r, n, i, o, a) {
  try {
    var u = e[o](a), s = u.value;
  } catch (c) {
    r(c);
    return;
  }
  u.done ? t(s) : mM.resolve(s).then(n, i);
}
function AVt(e) {
  return function() {
    var t = this, r = arguments;
    return new mM(function(n, i) {
      var o = e.apply(t, r);
      function a(s) {
        OW(o, n, i, a, u, "next", s);
      }
      function u(s) {
        OW(o, n, i, a, u, "throw", s);
      }
      a(void 0);
    });
  };
}
var SVt = lk;
const bVt = /* @__PURE__ */ Mt(SVt);
var RW = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function CVt(e, t) {
  return !!(e === t || RW(e) && RW(t));
}
function IVt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!CVt(e[r], t[r]))
      return !1;
  return !0;
}
function nEe(e, t) {
  t === void 0 && (t = IVt);
  var r = null;
  function n() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    if (r && r.lastThis === this && t(i, r.lastArgs))
      return r.lastResult;
    var a = e.apply(this, i);
    return r = {
      lastResult: a,
      lastArgs: i,
      lastThis: this
    }, a;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
function OVt(e, t) {
  if (t > 0)
    return MC(e, t);
  e();
}
function RVt(e, t) {
  var r = 0, n;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    n || (n = OVt(function() {
      n = null, r = LS(), e.apply(void 0, o);
    }, t + r - LS()));
  };
}
function wVt() {
  return new bVt(function(e) {
    return MC(function() {
      return e();
    });
  });
}
function PVt(e, t) {
  nr(function() {
    return e.subscribe(function(r) {
      if (r) {
        var n = nEe(function(u, s, c) {
          return t && t({
            initial: u,
            fraction: s,
            width: c
          });
        }), i = function(s) {
          var c = r.offsetWidth, l = r.scrollLeft, f = r.scrollWidth;
          n(s, "".concat(f === c ? 0 : l / (f - c) * 100, "%"), "".concat(c / f * 100, "%"));
        }, o = function() {
          return i(!1);
        }, a = RVt(function() {
          i(!1);
        });
        return r.addEventListener("pointerover", a, {
          passive: !0
        }), r.addEventListener("scroll", o, {
          passive: !0
        }), AVt(/* @__PURE__ */ YL().mark(function u() {
          return YL().wrap(function(c) {
            for (; ; ) switch (c.prev = c.next) {
              case 0:
                if (r.scrollWidth !== r.offsetWidth) {
                  c.next = 3;
                  break;
                }
                return c.next = 3, wVt();
              case 3:
                i(!0);
              case 4:
              case "end":
                return c.stop();
            }
          }, u);
        }))(), function() {
          r.removeEventListener("pointerover", a), r.removeEventListener("scroll", o);
        };
      }
    });
  }, [e, t]);
}
var wW = {}, FC = function(t) {
  var r = t.children, n = t.dir, i = t.height, o = t.nonce, a = t.numItems, u = t.styleOptions, s = t.styleSet;
  n = n === "ltr" || n === "rtl" ? n : void 0;
  var c = tt(function() {
    return Xve(u);
  }, [u]), l = tt(function() {
    return s || EM(c);
  }, [c, s]), f = tt(function() {
    var $, X = wW[o] || (wW[o] = _$t({
      key: "react-film--css-".concat(H$t()),
      nonce: o
    }));
    return m$t(BC($ = T$t(l)).call($, function(V) {
      var F = co(V, 2), le = F[0], ae = F[1];
      return [le, X.css(ae) + ""];
    }));
  }, [o, l]), d = cn(), p = co(d, 2);
  p[0];
  var v = p[1], h = SW(), E = SW(), m = Ut(null), g = Ut();
  nr(function() {
    return function() {
      return clearTimeout(g.current);
    };
  }, [g]);
  var y = mt(function($) {
    var X = _W(n, E.current, h.current, m.current);
    if (X) {
      var V = X.index, F = X.indexFraction, le = $({
        index: V,
        indexFraction: F
      });
      typeof le == "number" && (m.current = I$t(n, E.current, h.current, le), v({}));
    }
  }, [n, v, h, E, m]), _ = mt(function() {
    y(function($) {
      var X = $.indexFraction;
      return n === "rtl" ? Math.floor(X) + 1 : Math.ceil(X) - 1;
    });
  }, [n, y]), S = mt(function() {
    y(function($) {
      var X = $.indexFraction;
      return n === "rtl" ? Math.ceil(X) - 1 : Math.floor(X) + 1;
    });
  }, [n, y]), A = tt(function() {
    return {
      scrollTo: y,
      scrollOneLeft: _,
      scrollOneRight: S
    };
  }, [y, _, S]), O = tt(function() {
    return {
      itemContainerCallbackRefWithSubscribe: h,
      scrollableCallbackRefWithSubscribe: E
    };
  }, [h, E]), P = tt(function() {
    return {
      dir: n,
      height: i,
      nonce: o,
      numItems: a,
      styleOptions: c,
      styleSetClassNames: f
    };
  }, [n, i, o, a, c, f]), U = cn({
    index: 0,
    indexFraction: 0,
    scrollBarPercentage: "0%",
    scrollBarWidth: "0%",
    scrolling: !1
  }), z = co(U, 2), k = z[0], H = z[1], B = mt(function($) {
    H($), clearTimeout(g.current), $.scrolling && (g.current = MC(
      function() {
        return H(hi(hi({}, $), {}, {
          scrolling: !1
        }));
      },
      // eslint-disable-next-line no-magic-numbers
      500
    ));
  }, [g, H]), x = mt(function($) {
    var X = $.fraction, V = $.initial, F = $.width, le = _W(n, E.current, h.current, m.current);
    if (le) {
      var ae = le.index, ne = le.indexFraction;
      B({
        index: ae,
        indexFraction: ne,
        scrolling: !V,
        scrollBarPercentage: X,
        scrollBarWidth: F
      });
    }
  }, [n, h, E, m, B]), D = mt(function() {
    m.current = null, v({});
  }, [v, m]), w = tt(function() {
    return hi(hi(hi(hi({}, A), O), P), k);
  }, [A, O, P, k]);
  return vUt(typeof m.current == "number" && E.current, m.current, D), nr(function() {
    return E.subscribe(function($) {
      if ($)
        return $.addEventListener("pointerdown", D, {
          passive: !0
        }), function() {
          return $.removeEventListener("pointerdown", D);
        };
    });
  }, [D, E]), PVt(E, x), /* @__PURE__ */ G.createElement(Mve.Provider, {
    value: P
  }, /* @__PURE__ */ G.createElement(Hve.Provider, {
    value: O
  }, /* @__PURE__ */ G.createElement(Bve.Provider, {
    value: A
  }, /* @__PURE__ */ G.createElement(Lve.Provider, {
    value: k
  }, /* @__PURE__ */ G.createElement(cUt.Provider, {
    value: w
  }, r, c.autoCenter && /* @__PURE__ */ G.createElement(C$t, null))))));
};
FC.defaultProps = {
  children: void 0,
  dir: void 0,
  height: void 0,
  nonce: void 0,
  styleOptions: void 0,
  styleSet: void 0
};
FC.propTypes = {
  children: Q.oneOfType([Q.arrayOf(Q.element), Q.element]),
  dir: Q.oneOf(["ltr", "rtl"]),
  height: Q.number,
  nonce: Q.string,
  numItems: Q.number.isRequired,
  styleOptions: Q.any,
  styleSet: Q.any
};
fy.defaultProps;
fy.propTypes;
var gM = function(t) {
  var r = t.autoCenter, n = t.autoHide, i = t.autoHideFlipperOnEdge, o = t.children, a = t.className, u = t.dir, s = t.flipperBlurFocusOnClick, c = t.height, l = t.leftFlipperAriaLabel, f = t.leftFlipperText, d = t.nonce, p = t.rightFlipperAriaLabel, v = t.rightFlipperText, h = t.showDots, E = t.showFlipper, m = t.showScrollBar, g = t.styleSet, y = tt(function() {
    return {
      autoCenter: r,
      autoHide: n,
      autoHideFlipperOnEdge: i,
      dir: u,
      leftFlipperAriaLabel: l,
      leftFlipperText: f,
      flipperBlurFocusOnClick: s,
      rightFlipperAriaLabel: p,
      rightFlipperText: v,
      showDots: h,
      showFlipper: E,
      showScrollBar: m
    };
  }, [r, n, i, u, l, f, s, p, v, h, E, m]);
  return /* @__PURE__ */ G.createElement(FC, {
    dir: u,
    height: c,
    nonce: d,
    numItems: o ? B1.count(o) : 0,
    styleOptions: y,
    styleSet: g
  }, /* @__PURE__ */ G.createElement(dy, {
    className: a
  }, o));
};
gM.defaultProps = hi(hi({}, dy.defaultProps), {}, {
  autoCenter: void 0,
  autoHide: void 0,
  autoHideFlipperOnEdge: void 0,
  children: void 0,
  className: void 0,
  dir: void 0,
  flipperBlurFocusOnClick: void 0,
  leftFlipperAriaLabel: void 0,
  leftFlipperText: void 0,
  nonce: void 0,
  rightFlipperAriaLabel: void 0,
  rightFlipperText: void 0,
  showDots: void 0,
  showFlipper: void 0,
  showScrollBar: void 0,
  styleSet: void 0
});
gM.propTypes = hi(hi({}, dy.propTypes), {}, {
  autoCenter: Q.bool,
  autoHide: Q.bool,
  autoHideFlipperOnEdge: Q.bool,
  children: Q.any,
  className: Q.string,
  dir: Q.oneOf(["auto", "ltr", "rtl"]),
  flipperBlurFocusOnClick: Q.bool,
  height: Q.number,
  leftFlipperAriaLabel: Q.string,
  leftFlipperText: Q.string,
  nonce: Q.string,
  rightFlipperAriaLabel: Q.string,
  rightFlipperText: Q.string,
  showDots: Q.bool,
  showFlipper: Q.bool,
  showScrollBar: Q.bool,
  styleSet: Q.any
});
if (typeof document < "u" && document.head) {
  var KR = document.createElement("meta");
  KR.setAttribute("name", "react-film"), KR.setAttribute("content", "version=".concat("3.1.1-main.df870ea")), document.head.appendChild(KR);
}
function DVt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = e.filter(Boolean);
  if (r.length <= 1) {
    var n = r[0];
    return n || null;
  }
  return function(o) {
    r.forEach(function(a) {
      typeof a == "function" ? a(o) : a && (a.current = o);
    });
  };
}
var xVt = ei(void 0), iEe = xVt;
function ho() {
  let e = En(iEe);
  if (!e) throw new Error("This hook can only be used on a component that is a descendant of <Composer>");
  return e;
}
function Tn() {
  return ho().styleToEmotionObject;
}
var NVt = { color: "transparent", height: 1, overflow: "hidden", position: "absolute", top: 0, whiteSpace: "nowrap", width: 1 }, HC = n0(({ "aria-hidden": e, id: t, text: r }, n) => {
  let i = Tn()(NVt) + "";
  return e && !t && console.warn('botframework-webchat assertion: when "aria-hidden" is set, the screen reader text should be read by "aria-labelledby". Thus, "id" must be set.'), G.createElement("div", { "aria-hidden": e, className: i, id: t, ref: n }, r);
});
HC.defaultProps = { "aria-hidden": void 0, id: void 0 };
HC.propTypes = { "aria-hidden": Q.bool, id: Q.string, text: Q.string.isRequired };
HC.displayName = "ScreenReaderText";
var ya = Nr(HC), { useLocalizer: LVt } = Vt, BVt = () => {
  let e = LVt();
  return G.createElement(ya, { text: e("CONNECTIVITY_STATUS_ALT", e("CONNECTIVITY_STATUS_ALT_CONNECTED")) });
}, kVt = BVt;
function pr() {
  return Object.freeze([ho().styleSet]);
}
var { useDirection: MVt } = Vt, FVt = () => {
  let [{ spinnerAnimation: e }] = pr(), [t] = MVt();
  return G.createElement("div", { className: Gt(e + "", t === "rtl" && "webchat__spinner--rtl") });
}, HVt = FVt;
function $Vt() {
  let [, e] = cn();
  return mt(() => e({}), [e]);
}
var UVt = $Vt, { usePonyfill: VVt } = Vt;
function oEe(e, t) {
  let [{ clearTimeout: r, Date: n, setTimeout: i }] = VVt();
  nr(() => {
    if (typeof e == "number") {
      let o = Math.max(0, e - n.now());
      if (o) {
        let a = i(t, o);
        return () => r(a);
      }
      t();
    }
  }, [e, r, n, t, i]);
}
var { useDirection: jVt } = Vt, PW = 16, TM = ({ className: e, size: t }) => {
  let [r] = jVt();
  return G.createElement("svg", { alt: "", className: Gt(e + "", r === "rtl" && "webchat_warning--rtl"), height: PW * t, viewBox: "0 0 13.1 13.1", width: PW * t }, G.createElement("path", { d: "M13.1,13.1H0L6.6,0L13.1,13.1z M7,10.5H6.1v0.9H7V10.5z M7,9.7V5.2H6.1v4.4L7,9.7z", fillRule: "evenodd" }));
};
TM.defaultProps = { className: "", size: 1 };
TM.propTypes = { className: Q.string, size: Q.number };
var zVt = TM, { useDirection: qVt, useLocalizer: YVt, usePonyfill: GVt, useStyleOptions: WVt } = Vt, yM = ({ reconnect: e }) => {
  let [{ Date: t }] = GVt(), [{ slowConnectionAfter: r }] = WVt(), [{ connectivityNotification: n, warningNotification: i }] = pr(), [o] = qVt(), [a] = cn(() => t.now()), u = UVt(), s = YVt(), c = s("CONNECTIVITY_STATUS_ALT_CONNECTING"), l = s("CONNECTIVITY_STATUS_ALT_RECONNECTING"), f = s("CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION");
  return oEe(a + r, u), t.now() >= a + r ? G.createElement(G.Fragment, null, G.createElement(ya, { text: s("CONNECTIVITY_STATUS_ALT", f) }), G.createElement("div", { "aria-hidden": !0, className: Gt("webchat__connectivityStatus", i + ""), dir: o }, G.createElement(zVt, null), f)) : G.createElement(G.Fragment, null, G.createElement(ya, { text: s("CONNECTIVITY_STATUS_ALT", e ? l : c) }), G.createElement("div", { "aria-hidden": !0, className: Gt("webchat__connectivityStatus", n + ""), dir: o }, G.createElement(HVt, null), e ? l : c));
};
yM.defaultProps = { reconnect: !1 };
yM.propTypes = { reconnect: Q.bool };
var DW = yM, { useDirection: KVt } = Vt, xW = 16, _M = ({ className: e, size: t }) => {
  let [r] = KVt();
  return G.createElement("svg", { alt: "", className: Gt(e + "", r === "rtl" && "webchat__error--rtl"), height: xW * t, viewBox: "0 0 13.1 13.1", width: xW * t }, G.createElement("path", { d: "M6.5,13C2.9,13,0,10.1,0,6.5S2.9,0,6.5,0S13,2.9,13,6.5S10.1,13,6.5,13z M6.1,3.5v4.3h0.9V3.5H6.1z M6.1,8.7v0.9h0.9V8.7H6.1z", fillRule: "evenodd" }));
};
_M.defaultProps = { className: "", size: 1 };
_M.propTypes = { className: Q.string, size: Q.number };
var aEe = _M, { useDirection: XVt, useLocalizer: JVt } = Vt, ZVt = () => {
  let [{ errorNotification: e }] = pr(), [t] = XVt(), r = JVt(), n = r("CONNECTIVITY_STATUS_ALT_FATAL");
  return G.createElement(G.Fragment, null, G.createElement(ya, { text: r("CONNECTIVITY_STATUS_ALT", n) }), G.createElement("div", { "aria-hidden": !0, className: Gt("webchat__connectivityStatus", e + ""), dir: t }, G.createElement(aEe, null), n));
}, QVt = ZVt, { useDirection: ejt, useLocalizer: tjt } = Vt, rjt = () => {
  let [{ errorNotification: e }] = pr(), [t] = ejt(), r = tjt(), n = r("CONNECTIVITY_STATUS_ALT_RENDER_ERROR");
  return G.createElement(G.Fragment, null, G.createElement(ya, { text: r("CONNECTIVITY_STATUS_ALT", n) }), G.createElement("div", { "aria-hidden": !0, className: Gt("webchat__connectivityStatus", e + ""), dir: t }, G.createElement(aEe, null), n));
}, njt = rjt, { useDebouncedNotifications: ijt } = Vt, ojt = () => {
  let [{ connectivitystatus: e }] = ijt();
  if (!e) return !1;
  switch (e.message) {
    case "connecting":
      return G.createElement(DW, null);
    case "javascripterror":
      return G.createElement(njt, null);
    case "failedtoconnect":
      return G.createElement(QVt, null);
    case "reconnecting":
      return G.createElement(DW, { reconnect: !0 });
    case "connected":
    default:
      return G.createElement(kVt, null);
  }
}, uEe = ojt, AM = ({ className: e }) => G.createElement("svg", { className: (e || "") + "", focusable: !1, height: "9", role: "presentation", viewBox: "0 0 16 9", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M15.2734 8.97656L8 1.71094L0.726563 8.97656L0.0234375 8.27344L8 0.289062L15.9766 8.27344L15.2734 8.97656Z" }));
AM.defaultProps = { className: void 0 };
AM.propTypes = { className: Q.string };
var ajt = AM, SM = ({ className: e }) => G.createElement("svg", { className: (e || "") + "", focusable: !1, height: "10", role: "presentation", viewBox: "0 0 16 10", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M15.1484 0.648437L15.8516 1.35156L8 9.20312L0.148438 1.35156L0.851563 0.648438L8 7.79687L15.1484 0.648437Z" }));
SM.defaultProps = { className: void 0 };
SM.propTypes = { className: Q.string };
var ujt = SM, bM = ({ "aria-label": e, className: t }) => G.createElement("svg", { "aria-label": e, className: (t || "") + "", fill: "none", height: "20", viewBox: "0 0 20 20", width: "20", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M14.5605 5.81055L15.4395 6.68945L8.125 14.0039L4.56055 10.4395L5.43945 9.56055L8.125 12.2461L14.5605 5.81055ZM10 0C10.918 0 11.8034 0.120443 12.6562 0.361328C13.5091 0.595703 14.3066 0.93099 15.0488 1.36719C15.791 1.79688 16.4648 2.31771 17.0703 2.92969C17.6823 3.53516 18.2031 4.20898 18.6328 4.95117C19.069 5.69336 19.4043 6.49089 19.6387 7.34375C19.8796 8.19661 20 9.08203 20 10C20 10.918 19.8796 11.8034 19.6387 12.6562C19.4043 13.5091 19.069 14.3066 18.6328 15.0488C18.2031 15.791 17.6823 16.4681 17.0703 17.0801C16.4648 17.6855 15.791 18.2064 15.0488 18.6426C14.3066 19.0723 13.5091 19.4076 12.6562 19.6484C11.8034 19.8828 10.918 20 10 20C9.08203 20 8.19661 19.8828 7.34375 19.6484C6.49089 19.4076 5.69336 19.0723 4.95117 18.6426C4.20898 18.2064 3.5319 17.6855 2.91992 17.0801C2.31445 16.4681 1.79362 15.791 1.35742 15.0488C0.927734 14.3066 0.592448 13.5124 0.351562 12.666C0.117188 11.8132 0 10.9245 0 10C0 9.08203 0.117188 8.19661 0.351562 7.34375C0.592448 6.49089 0.927734 5.69336 1.35742 4.95117C1.79362 4.20898 2.31445 3.53516 2.91992 2.92969C3.5319 2.31771 4.20898 1.79688 4.95117 1.36719C5.69336 0.93099 6.48763 0.595703 7.33398 0.361328C8.18685 0.120443 9.07552 0 10 0ZM10 18.75C10.8008 18.75 11.5723 18.6458 12.3145 18.4375C13.0632 18.2292 13.7598 17.9362 14.4043 17.5586C15.0553 17.1745 15.6478 16.7155 16.1816 16.1816C16.7155 15.6478 17.1712 15.0586 17.5488 14.4141C17.9329 13.763 18.2292 13.0664 18.4375 12.3242C18.6458 11.582 18.75 10.8073 18.75 10C18.75 9.19922 18.6458 8.42773 18.4375 7.68555C18.2292 6.93685 17.9329 6.24023 17.5488 5.5957C17.1712 4.94466 16.7155 4.35221 16.1816 3.81836C15.6478 3.28451 15.0553 2.82878 14.4043 2.45117C13.7598 2.06706 13.0632 1.77083 12.3145 1.5625C11.5723 1.35417 10.8008 1.25 10 1.25C9.19922 1.25 8.42448 1.35417 7.67578 1.5625C6.93359 1.77083 6.23698 2.06706 5.58594 2.45117C4.94141 2.82878 4.35221 3.28451 3.81836 3.81836C3.28451 4.35221 2.82552 4.94466 2.44141 5.5957C2.0638 6.24023 1.77083 6.93685 1.5625 7.68555C1.35417 8.42773 1.25 9.19922 1.25 10C1.25 10.8008 1.35417 11.5755 1.5625 12.3242C1.77083 13.0664 2.0638 13.763 2.44141 14.4141C2.82552 15.0586 3.28451 15.6478 3.81836 16.1816C4.35221 16.7155 4.94141 17.1745 5.58594 17.5586C6.23698 17.9362 6.93359 18.2292 7.67578 18.4375C8.41797 18.6458 9.19271 18.75 10 18.75Z", fill: "#107C10" }));
bM.defaultProps = { "aria-label": void 0, className: void 0 };
bM.propTypes = { "aria-label": Q.string, className: Q.string };
var sjt = bM, CM = ({ "aria-label": e, className: t }) => G.createElement("svg", { "aria-label": e, className: (t || "") + "", height: "19", viewBox: "0 0 19 19", width: "19", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M9.375 0C10.2409 0 11.071 0.110677 11.8652 0.332031C12.666 0.553385 13.4147 0.869141 14.1113 1.2793C14.8079 1.68294 15.4395 2.17122 16.0059 2.74414C16.5788 3.31055 17.0671 3.94206 17.4707 4.63867C17.8809 5.33529 18.1966 6.08398 18.418 6.88477C18.6393 7.67904 18.75 8.50911 18.75 9.375C18.75 10.2409 18.6393 11.0742 18.418 11.875C18.1966 12.6693 17.8809 13.4147 17.4707 14.1113C17.0671 14.8079 16.5788 15.4427 16.0059 16.0156C15.4395 16.582 14.8079 17.0703 14.1113 17.4805C13.4147 17.8841 12.666 18.1966 11.8652 18.418C11.071 18.6393 10.2409 18.75 9.375 18.75C8.50911 18.75 7.67578 18.6393 6.875 18.418C6.08073 18.1966 5.33529 17.8841 4.63867 17.4805C3.94206 17.0703 3.30729 16.582 2.73438 16.0156C2.16797 15.4427 1.67969 14.8079 1.26953 14.1113C0.865885 13.4147 0.553385 12.6693 0.332031 11.875C0.110677 11.0742 0 10.2409 0 9.375C0 8.50911 0.110677 7.67904 0.332031 6.88477C0.553385 6.08398 0.865885 5.33529 1.26953 4.63867C1.67969 3.94206 2.16797 3.31055 2.73438 2.74414C3.30729 2.17122 3.94206 1.68294 4.63867 1.2793C5.33529 0.869141 6.08073 0.553385 6.875 0.332031C7.67578 0.110677 8.50911 0 9.375 0ZM9.375 17.5C10.1172 17.5 10.8333 17.4023 11.5234 17.207C12.2201 17.0117 12.8678 16.7383 13.4668 16.3867C14.0723 16.0352 14.6224 15.612 15.1172 15.1172C15.612 14.6224 16.0352 14.0755 16.3867 13.4766C16.7383 12.8711 17.0117 12.2233 17.207 11.5332C17.4023 10.8431 17.5 10.1237 17.5 9.375C17.5 8.63281 17.4023 7.91667 17.207 7.22656C17.0117 6.52995 16.7383 5.88216 16.3867 5.2832C16.0352 4.67773 15.612 4.1276 15.1172 3.63281C14.6224 3.13802 14.0723 2.71484 13.4668 2.36328C12.8678 2.01172 12.2201 1.73828 11.5234 1.54297C10.8333 1.34766 10.1172 1.25 9.375 1.25C8.6263 1.25 7.9069 1.34766 7.2168 1.54297C6.52669 1.73828 5.87891 2.01172 5.27344 2.36328C4.67448 2.71484 4.1276 3.13802 3.63281 3.63281C3.13802 4.1276 2.71484 4.67773 2.36328 5.2832C2.01172 5.88216 1.73828 6.52995 1.54297 7.22656C1.34766 7.91667 1.25 8.63281 1.25 9.375C1.25 10.1172 1.34766 10.8366 1.54297 11.5332C1.73828 12.2233 2.01172 12.8711 2.36328 13.4766C2.71484 14.0755 3.13802 14.6224 3.63281 15.1172C4.1276 15.612 4.67448 16.0352 5.27344 16.3867C5.87891 16.7383 6.52669 17.0117 7.2168 17.207C7.9069 17.4023 8.6263 17.5 9.375 17.5ZM8.75 5H10V11.25H8.75V5ZM8.75 12.5H10V13.75H8.75V12.5Z" }));
CM.defaultProps = { "aria-label": void 0, className: void 0 };
CM.propTypes = { "aria-label": Q.string, className: Q.string };
var cjt = CM, { useLocalizer: ljt } = Vt, IM = ({ className: e, level: t }) => {
  let r = ljt(), n = { error: r("TOAST_ALT_ERROR"), info: r("TOAST_ALT_INFO"), success: r("TOAST_ALT_SUCCESS"), warn: r("TOAST_ALT_WARN") }, i = !ia(t) && n[t] || "";
  return G.createElement(G.Fragment, null, t === "success" ? G.createElement(sjt, { "aria-label": i, className: e }) : G.createElement(cjt, { "aria-label": i, className: e }));
};
IM.defaultProps = { className: void 0 };
IM.propTypes = { className: Q.string, level: Q.oneOf(["error", "info", "success", "warn"]).isRequired };
var sEe = IM;
function OM(e = 5) {
  return Mu().toString(36).substr(2, e);
}
var { useDebouncedNotifications: fjt, useLocalizer: djt, useRenderToast: pjt } = Vt, hjt = { display: "flex", flexDirection: "column", "& .webchat__toaster__header": { display: "flex", flexShrink: 0 }, "& .webchat__toaster__expandText": { flex: 1 }, "& .webchat__toaster__list": { display: "block", listStyleType: "none" } }, cEe = { error: 1, warn: 2, info: 3, success: 4 }, vjt = Object.keys(cEe);
function NW(e) {
  return vjt.includes(e) ? cEe[e] : 5;
}
function Ejt(e, t) {
  return NW(e) - NW(t);
}
function mjt(e) {
  return Object.values(e).sort(({ timestamp: t }, { timestamp: r }) => r - t);
}
var gjt = (e) => e, Tjt = { two: "TOAST_ACCORDION_TWO", few: "TOAST_ACCORDION_FEW", many: "TOAST_ACCORDION_MANY", other: "TOAST_ACCORDION_OTHER" }, yjt = () => {
  let e = tt(OM, []), [{ toaster: t }] = pr(), [r] = fjt(), [n, i] = cn(!1), o = djt({ plural: !0 }), a = pjt(), u = Tn()(hjt) + "", s = mt(() => i(!n), [n, i]), c = tt(() => mjt(r), [r]), l = tt(() => c.map((h) => {
    let E = a({ notification: h });
    return E && { children: E, notification: h };
  }).filter(gjt), [a, c]), f = l.length > 1, [d] = l.map(({ notification: { level: h } }) => h).sort(Ejt), p = tt(() => !f || n ? `webchat__toaster__list__${e}` : void 0, [f, n, e]), v = tt(() => f ? `webchat__toaster__header__${e}` : void 0, [f, e]);
  return nr(() => {
    !f && i(!1);
  }, [f]), G.createElement("div", { "aria-labelledby": v, "aria-live": "polite", "aria-relevant": "all", className: Gt("webchat__toaster", { "webchat__toaster--expandable": f, "webchat__toaster--expanded": n, "webchat__toaster--error": d === "error", "webchat__toaster--info": d === "info", "webchat__toaster--success": d === "success", "webchat__toaster--warn": d === "warn" }, u, t + ""), role: "log" }, f && G.createElement("button", { "aria-controls": p, "aria-expanded": n, className: "webchat__toaster__header", id: v, onClick: s, type: "button" }, G.createElement("div", { "aria-hidden": !0, className: "webchat__toaster__expandLevelIconBox" }, G.createElement(sEe, { className: "webchat__toaster__expandLevelIcon", level: d })), G.createElement("div", { className: "webchat__toaster__expandText" }, o(Tjt, l.length)), G.createElement("div", { "aria-hidden": !0, className: "webchat__toaster__expandIcon" }, G.createElement("div", { className: "webchat__toaster__expandIconFocus" }, n ? G.createElement(ajt, null) : G.createElement(ujt, null)))), (!f || n) && G.createElement("div", { "aria-labelledby": v, className: "webchat__toaster__list", id: p }, l.map(({ children: h, notification: { id: E } }) => G.createElement("div", { "aria-atomic": !0, className: "webchat__toaster__listItem", key: E }, h))));
}, lEe = yjt, { userAgent: fEe } = navigator, dEe = /Linux; Android/u.test(fEe), pEe = /Trident\/7.0/u.test(fEe), { useActiveTyping: GL, useRenderTypingIndicator: _jt } = Vt;
function hEe() {
  let [e] = GL();
  return tt(() => Object.freeze([!!Object.values(e).some(({ role: t, type: r }) => t !== "user" && r !== "livestream")]), [e]);
}
var Ajt = () => {
  let [e] = GL(), [t] = hEe(), [r] = GL(1 / 0), n = _jt();
  return G.createElement(jo, null, n({ activeTyping: e, typing: r, visible: t }));
}, Sjt = Ajt, RM = ({ className: e, onFocus: t, redirectRef: r }) => {
  let n = mt(() => {
    var i;
    (i = r == null ? void 0 : r.current) == null || i.focus(), t && t();
  }, [t, r]);
  return G.createElement("div", { className: e, onFocus: n, tabIndex: 0 });
};
RM.defaultProps = { className: void 0, onFocus: void 0, redirectRef: void 0 };
RM.propTypes = { className: Q.string, onFocus: Q.func, redirectRef: Q.shape({ current: Q.instanceOf(HTMLElement) }) };
var BS = RM, vEe = { Add: "+", Decimal: ".", Divide: "/", Multiply: "*", Subtract: "-" }, bjt = Object.keys(vEe);
function Cjt(e) {
  return e.length === 1 ? e : bjt.includes(e) ? vEe[e] : void 0;
}
function Gp(e) {
  return 1 / e >= 0;
}
function $C(e) {
  let t = tt(() => Mu().toString(36).substr(2, 5), []);
  return e = e ? `${e}--` : "", `${e}${t}`;
}
function LW(e) {
  let t = [];
  return Object.freeze([{ ...e, waitUntil(r) {
    t.push(r);
  } }, async () => {
    for (let r = 0; await Promise.all(t).then(() => {
    }), r !== t.length; r = t.length) ;
  }]);
}
var { useListen: EEe, usePropagate: Ijt } = Nhe();
function d0() {
  let e = Ijt(), { focusTranscriptCallbacksRef: t } = ho();
  return mt(async (r) => {
    if (r === "sendBox" || r === "sendBoxWithoutKeyboard") {
      let [n, i] = LW({ noKeyboard: r === "sendBoxWithoutKeyboard" });
      e(n), await i();
    } else {
      let [, n] = LW({});
      t.current.forEach((i) => i()), await n();
    }
  }, [e, t]);
}
var { useLocalizer: Ojt } = Vt, tf = ({ header: e, text: t }) => G.createElement("dl", { className: "webchat__keyboard-help__notes" }, G.createElement("dt", { className: "webchat__keyboard-help__notes-header" }, e), t.split(`
`).map((r, n) => G.createElement("dd", { className: "webchat__keyboard-help__notes-text", key: n }, r)));
tf.propTypes = { header: Q.string.isRequired, text: Q.string.isRequired };
var Rjt = () => {
  let [{ keyboardHelp: e }] = pr(), [t, r] = cn(!1), n = d0(), i = $C("webchat__keyboard-help__header"), o = Ojt(), a = o("KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_BODY"), u = o("KEYBOARD_HELP_CHAT_HISTORY_ACCESS_ITEMS_IN_MESSAGE_HEADER"), s = o("KEYBOARD_HELP_CHAT_HISTORY_HEADER"), c = o("KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_BODY"), l = o("KEYBOARD_HELP_CHAT_HISTORY_LEAVE_MESSAGE_HEADER"), f = o("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_BODY"), d = o("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_ITEMS_HEADER"), p = o("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_BODY"), v = o("KEYBOARD_HELP_CHAT_HISTORY_MOVE_BETWEEN_MESSAGES_HEADER"), h = o("KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_BODY"), E = o("KEYBOARD_HELP_CHAT_WINDOW_BODY_DO_ACTION_HEADER"), m = o("KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_BODY"), g = o("KEYBOARD_HELP_CHAT_WINDOW_BODY_MOVE_BETWEEN_ITEMS_HEADER"), y = o("KEYBOARD_HELP_CHAT_WINDOW_HEADER"), _ = o("KEYBOARD_HELP_CLOSE_BUTTON_ALT"), S = o("KEYBOARD_HELP_HEADER"), A = mt((z) => document.activeElement !== z.target && r(!1), [r]), O = mt(() => n("main"), [n]), P = mt(() => r(!0), [r]), U = mt((z) => {
    let { key: k } = z;
    (k === "Enter" || k === "Escape" || k === " ") && (z.preventDefault(), z.stopPropagation(), n("main"));
  }, [n]);
  return G.createElement("div", { "aria-labelledby": i, className: Gt("webchat__keyboard-help", e + "", { "webchat__keyboard-help--shown": t }), onBlur: A, role: "dialog" }, G.createElement("div", { className: "webchat__keyboard-help__border" }, G.createElement("div", { className: "webchat__keyboard-help__box" }, G.createElement("div", { className: "webchat__keyboard-help__scrollable" }, G.createElement("button", { "aria-label": _, className: "webchat__keyboard-help__close-button", onClick: O, onFocus: P, onKeyDown: U, type: "button" }, G.createElement("div", { className: "webchat__keyboard-help__close-button-border" }, G.createElement("svg", { className: "webchat__keyboard-help__close-button-image", focusable: !1, role: "presentation", viewBox: "0 0 2048 2048", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M2048 136l-888 888 888 888-136 136-888-888-888 888L0 1912l888-888L0 136 136 0l888 888L1912 0l136 136z" })))), G.createElement("h2", { className: "webchat__keyboard-help__header", id: i }, S), G.createElement("article", { className: "webchat__keyboard-help__section" }, G.createElement("header", null, G.createElement("h3", { className: "webchat__keyboard-help__sub-header" }, y)), G.createElement("div", { className: "webchat__keyboard-help__two-panes" }, G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--light", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "#C8C6C4", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "#323130", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "#C8C6C4", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "#C8C6C4", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "#323130", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "#323130", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#323130", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#323130", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z", fill: "#323130", fillRule: "evenodd" })), G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--dark", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "#484644", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "#F3F2F1", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "#484644", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "#484644", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "#F3F2F1", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "#F3F2F1", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#F3F2F1", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#F3F2F1", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z", fill: "#F3F2F1", fillRule: "evenodd" })), G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--high-contrast", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "white", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "white", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "white", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "white", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 5.64645C116.524 5.45118 116.84 5.45118 117.036 5.64645L120.218 8.82843C120.413 9.02369 120.413 9.34027 120.218 9.53553C120.022 9.7308 119.706 9.7308 119.51 9.53553L117.182 7.20711V192.793L119.51 190.464C119.706 190.269 120.022 190.269 120.218 190.464C120.413 190.66 120.413 190.976 120.218 191.172L117.036 194.354C116.84 194.549 116.524 194.549 116.328 194.354L113.146 191.172C112.951 190.976 112.951 190.66 113.146 190.464C113.342 190.269 113.658 190.269 113.854 190.464L116.182 192.793V7.20711L113.854 9.53553C113.658 9.7308 113.342 9.7308 113.146 9.53553C112.951 9.34027 112.951 9.02369 113.146 8.82843L116.328 5.64645Z", fill: "white", fillRule: "evenodd" })), G.createElement("div", { className: "webchat__keyboard-help__notes-pane" }, G.createElement(tf, { header: g, text: m }), G.createElement(tf, { header: E, text: h })))), G.createElement("article", { className: "webchat__keyboard-help__section" }, G.createElement("header", null, G.createElement("h3", { className: "webchat__keyboard-help__header" }, s)), G.createElement("div", { className: "webchat__keyboard-help__two-panes" }, G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--light", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "#C8C6C4", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "#323130", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "#323130", strokeDasharray: "2 2", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "#323130", strokeDasharray: "2 2", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "#C8C6C4", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "#C8C6C4", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#C8C6C4", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#C8C6C4", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z", fill: "#323130", fillRule: "evenodd" })), G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--dark", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "#484644", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "#F3F2F1", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "#F3F2F1", strokeDasharray: "2 2", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "#F3F2F1", strokeDasharray: "2 2", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "#484644", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "#484644", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#484644", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "#484644", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z", fill: "#F3F2F1", fillRule: "evenodd" })), G.createElement("svg", { className: "webchat__keyboard-help__image webchat__keyboard-help__image--high-contrast", fill: "none", focusable: !1, height: "200", role: "presentation", viewBox: "0 0 121 200", width: "121", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("rect", { height: "199", stroke: "white", width: "109", x: "0.5", y: "0.5" }), G.createElement("rect", { height: "156", stroke: "white", width: "102", x: "3.5", y: "4.5" }), G.createElement("rect", { height: "42", stroke: "white", strokeDasharray: "2 2", width: "93", x: "7.5", y: "8.5" }), G.createElement("rect", { height: "99", stroke: "white", strokeDasharray: "2 2", width: "93", x: "7.5", y: "55.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "102", x: "3.5", y: "182.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "3.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "38.5", y: "165.5" }), G.createElement("rect", { height: "13", stroke: "white", width: "32", x: "73.5", y: "165.5" }), G.createElement("path", { clipRule: "evenodd", d: "M116.328 7.64645C116.524 7.45118 116.84 7.45118 117.036 7.64645L120.218 10.8284C120.413 11.0237 120.413 11.3403 120.218 11.5355C120.022 11.7308 119.706 11.7308 119.51 11.5355L117.182 9.20711V156.793L119.51 154.464C119.706 154.269 120.022 154.269 120.218 154.464C120.413 154.66 120.413 154.976 120.218 155.172L117.036 158.354C116.84 158.549 116.524 158.549 116.328 158.354L113.146 155.172C112.951 154.976 112.951 154.66 113.146 154.464C113.342 154.269 113.658 154.269 113.854 154.464L116.182 156.793V9.20711L113.854 11.5355C113.658 11.7308 113.342 11.7308 113.146 11.5355C112.951 11.3403 112.951 11.0237 113.146 10.8284L116.328 7.64645Z", fill: "white", fillRule: "evenodd" })), G.createElement("div", { className: "webchat__keyboard-help__notes-pane" }, G.createElement(tf, { header: v, text: p }), G.createElement(tf, { header: u, text: a }), G.createElement(tf, { header: d, text: f }), G.createElement(tf, { header: l, text: c }))))))));
}, wjt = Rjt;
function mEe(e) {
  var n, i, o, a;
  if (e.type !== "message") return !0;
  let { channelData: t } = e, r = t == null ? void 0 : t["webchat:fallback-text"];
  return typeof r == "string" ? !r : !((n = t == null ? void 0 : t.messageBack) != null && n.displayText || e.text || (i = e.attachments) != null && i.length || (a = (o = e.suggestedActions) == null ? void 0 : o.actions) != null && a.length);
}
function wM(e) {
  switch (e) {
    case "plain":
      return "text/plain";
    case "xml":
      return "text/xml";
    default:
      return "text/markdown";
  }
}
function Pjt(e, t) {
  let r = [].slice.call(e.childNodes), n = [];
  for (; r.length; ) {
    let i = r.shift(), { childNodes: o } = i;
    n.push(...t(i) || []), r.unshift(...[].slice.call(o));
  }
  return n;
}
var Djt = ["A", "ABBR", "ACRONYM", "AUDIO", "B", "BDI", "BDO", "BIG", "BR", "BUTTON", "CANVAS", "CITE", "CODE", "DATA", "DATALIST", "DEL", "DFN", "EM", "EMBED", "I", "IFRAME", "IMG", "INPUT", "INS", "KBD", "LABEL", "MAP", "MARK", "METER", "NOSCRIPT", "OBJECT", "OUTPUT", "PICTURE", "PROGRESS", "Q", "RUBY", "S", "SAMP", "SCRIPT", "SELECT", "SLOT", "SMALL", "SPAN", "STRONG", "SUB", "SUP", "SVG", "TEMPLATE", "TEXTAREA", "TIME", "U", "TT", "VAR", "VIDEO", "WBR"];
function xjt(e) {
  return Pjt(e, (t) => {
    let { nodeType: r, tagName: n, textContent: i } = t;
    if (r === Node.TEXT_NODE) return [i];
    if (n === "IMG") return [t.getAttribute("alt")];
    if (!Djt.includes(n)) return [`
`];
  });
}
function gEe(e, t) {
  var i, o, a;
  if (e.type !== "message") return !1;
  let r = (i = e == null ? void 0 : e.channelData) == null ? void 0 : i["webchat:fallback-text"];
  if (typeof r == "string") return r || !1;
  let n = ((a = (o = e == null ? void 0 : e.channelData) == null ? void 0 : o.messageBack) == null ? void 0 : a.displayText) || e.text;
  return n ? t && wM(e.textFormat) === "text/markdown" ? xjt(new DOMParser().parseFromString(t(n), "text/html")).join("").replace(/\n{2,}/gu, `
`).trim() : n : "";
}
var { useCreateAttachmentForScreenReaderRenderer: Njt, useLocalizer: Ljt } = Vt, Bjt = { few: "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT", many: "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT", one: "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT", other: "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT", two: "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT" }, kjt = ({ activity: e }) => {
  let { attachments: t = [] } = e, r = Njt(), n = Ljt({ plural: !0 }), i = t.map((u) => r({ activity: e, attachment: u })).filter(Boolean), o = t.length - i.length, a = !!o && n(Bjt, o);
  return G.createElement(jo, null, i.map((u, s) => G.createElement("div", { key: s }, typeof u == "function" && u())), a && G.createElement("p", null, a));
}, Mjt = kjt;
function TEe(e) {
  let { title: t } = e, { type: r, value: n } = e;
  return r === "messageBack" ? t || e.displayText : t || (typeof n == "string" ? n : JSON.stringify(n));
}
var yEe = ({ suggestedActions: e }) => {
  var t;
  return ((t = e.actions) == null ? void 0 : t.length) && G.createElement("p", { className: "webchat__live-region-activity__suggested-actions" }, e.actions.map((r, n) => G.createElement("button", { className: "webchat__live-region-activity__suggested-action", key: n, tabIndex: -1, type: "button" }, TEe(r))));
};
yEe.propTypes = { suggestedActions: Q.shape({ actions: Q.array }).isRequired };
var Fjt = yEe, { useLocalizer: Hjt, useStyleOptions: $jt } = Vt;
function Fh(e = "message activity") {
  let { renderMarkdown: t } = ho(), [r] = $jt(), [{ renderMarkdown: n }] = pr(), i = Hjt()("MARKDOWN_EXTERNAL_LINK_ALT"), o = tt(() => Vrt("webchat__render-markdown", { "webchat__render-markdown--adaptive-cards": e === "adaptive cards", "webchat__render-markdown--citation": e === "citation modal", "webchat__render-markdown--message-activity": e !== "accessible name" && e !== "adaptive cards" && e !== "citation modal" }, n + ""), [e, n]);
  return tt(() => t && ((a) => {
    let u = t(a, r, { containerClassName: o, externalLinkAlt: i }), s = Afe(u), c = s.createElement("div");
    return o && c.classList.add(...o.split(" ").filter(Boolean)), c.append(...s.body.children), s.body.append(c), Sfe(s);
  }), [o, i, t, r]);
}
var { useAvatarForBot: Ujt, useLocalizer: Vjt } = Vt, jjt = { "&.webchat__live-region-activity": { color: "transparent", height: 1, opacity: 0, overflow: "hidden", position: "absolute", top: 0, whiteSpace: "nowrap", width: 1 } }, _Ee = ({ activity: e }) => {
  let [{ initials: t }] = Ujt(), { from: { role: r }, type: n } = e, i = n === "message" ? e.channelData["webchat:fallback-text"] : void 0, o = Vjt(), a = Fh(), u = Tn()(jjt) + "", s = tt(() => gEe(e, a), [e, a]), c = (r === "user" ? o("ACTIVITY_YOU_SAID_ALT") : o("ACTIVITY_BOT_SAID_ALT", t || "")).replace(/\s{2,}/gu, " "), l = i && typeof i == "string";
  return G.createElement("article", { "aria-atomic": !0, className: Gt("webchat__live-region-activity", u) }, G.createElement("div", null, c), l ? G.createElement("div", null, i) : G.createElement(jo, null, G.createElement("div", null, s), n === "message" && G.createElement(jo, null, !!e.suggestedActions && G.createElement(Fjt, { suggestedActions: e.suggestedActions }), G.createElement(Mjt, { activity: e }))));
};
_Ee.propTypes = { activity: Q.any.isRequired };
var zjt = _Ee, PM = "sending", py = "send failed", qjt = "sent";
function DM(e) {
  let t = Ut();
  return nr(() => {
    t.current = e;
  }), t.current;
}
var Yjt = ei(void 0), AEe = Yjt;
function xM(e = !0) {
  let t = En(AEe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <LiveRegionComposer>.");
  return t;
}
function SEe() {
  return xM().queueStaticElement;
}
var { useGetActivityByKey: Gjt, useLocalizer: Wjt, useSendStatusByActivityKey: Kjt } = Vt, Xjt = () => {
  let [e] = Kjt(), t = Gjt(), r = Wjt(), n = SEe(), i = tt(() => Array.from(e).reduce((s, [c, l]) => l === py && !mEe(t(c)) ? s.add(c) : s, /* @__PURE__ */ new Set()), [t, e]), o = r("TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT"), a = DM(i), u = tt(() => {
    if (i === a) return !1;
    for (let s of i.keys()) if (!a.has(s)) return !0;
    return !1;
  }, [i, a]);
  return nr(() => {
    u && n(o);
  }, [u, o, n]), null;
}, Jjt = Xjt;
function Zjt() {
  let { markAllAsRendered: e } = xM();
  nr(e);
}
function Qjt() {
  return xM().staticElementEntriesState;
}
var NM = ({ "aria-label": e, "aria-live": t, "aria-roledescription": r, className: n, role: i, textElementClassName: o }) => {
  let [a] = Qjt();
  return Zjt(), G.createElement("div", { "aria-label": e, "aria-live": t, "aria-roledescription": r, className: n, role: i }, a.map(({ element: u, key: s }) => typeof u == "string" ? G.createElement("div", { "aria-atomic": !0, className: o, key: s }, u) : G.createElement(jo, { key: s }, u)));
};
NM.defaultProps = { "aria-label": void 0, "aria-roledescription": void 0, className: void 0, role: void 0, textElementClassName: void 0 };
NM.propTypes = { "aria-label": Q.string, "aria-live": Q.oneOf(["assertive", "polite"]).isRequired, "aria-roledescription": Q.string, className: Q.string, role: Q.string, textElementClassName: Q.string };
var ezt = NM;
function Lu(e) {
  let t = Ut(), r = tt(() => Object.create({}, { current: { get: () => t.current } }), []);
  return t.current = e, r;
}
var { usePonyfill: tzt } = Vt, bEe = "polite", CEe = 1e3, LM = ({ "aria-label": e, "aria-live": t = bEe, "aria-roledescription": r, children: n, className: i, fadeAfter: o = CEe, role: a, textElementClassName: u }) => {
  let [{ clearTimeout: s, setTimeout: c }] = tzt(), [l, f] = cn([]), d = Lu(o), p = Ut(), v = Ut(1), h = Lu(l), E = mt(() => {
    h.current.length && (p.current && s(p.current), p.current = c(() => {
      h.current.length && f([]);
    }, d.current));
  }, [s, d, p, f, c, h]);
  nr(() => () => p.current && s(p.current), [s, p]);
  let m = mt((_) => {
    let S = v.current;
    v.current = v.current + 1, f((A) => [...A, { element: _, key: S }]);
  }, [v, f]), g = tt(() => Object.freeze([Object.freeze(l)]), [l]), y = tt(() => ({ markAllAsRendered: E, queueStaticElement: m, staticElementEntriesState: g }), [E, m, g]);
  return G.createElement(AEe.Provider, { value: y }, G.createElement(ezt, { "aria-label": e, "aria-live": t, "aria-roledescription": r, className: i, role: a, textElementClassName: u }), n);
};
LM.defaultProps = { "aria-label": void 0, "aria-live": bEe, "aria-roledescription": void 0, children: void 0, className: void 0, fadeAfter: CEe, role: void 0, textElementClassName: void 0 };
LM.propTypes = { "aria-label": Q.string, "aria-live": Q.oneOf(["assertive", "polite"]), "aria-roledescription": Q.string, children: Q.any, className: Q.string, fadeAfter: Q.number, role: Q.string, textElementClassName: Q.string };
var rzt = LM;
function UC(e) {
  let t = (e == null ? void 0 : e.querySelectorAll("a[href], area[href], audio[controls], button:not(:disabled), iframe, input:not(:disabled), keygen, select:not(:disabled), summary, textarea:not(:disabled), video[controls], [contenteditable], [tabindex]")) || [];
  return [].filter.call(t, (r) => {
    let n = r.attributes.getNamedItem("tabindex");
    if (n && n.specified) {
      let i = parseInt(n.value, 10);
      return i >= 0 || isNaN(i) && r.nodeName.toLowerCase() === "input";
    }
    return !0;
  });
}
var nzt = /^(android|linux armv7l)/giu, izt = /^(mac|ipad|iphone|ipod)/giu, ozt = /^linux/giu, azt = /^win/giu;
function IEe() {
  let { navigator: { platform: e } } = window;
  return tt(() => {
    let t = nzt.test(e), r = izt.test(e), n = azt.test(e), i = !t && ozt.test(e);
    return [{ android: t, apple: r, linux: i, windows: n }];
  }, [e]);
}
var { useLocalizer: uzt } = Vt;
function OEe(e) {
  let [{ apple: t }] = IEe(), r = uzt();
  return mt((n) => {
    if (!n || typeof n != "string" || !n.length) throw new Error('useLocalizeAccessKey: "accessKey" must be a non-empty string');
    return e === "accessible name" ? r(t ? "ACCESS_KEY_FOR_MAC_ALT" : "ACCESS_KEY_ALT", n[0]) : (t ? "Control+AltGraph+" : "Alt+Shift+") + n[0];
  }, [t, r, e]);
}
function REe() {
  let { suggestedActionsAccessKey: e } = ho();
  return [e];
}
var { useActiveTyping: szt } = Vt;
function czt(e, t) {
  return e.length === t.length && e.every((r, n) => t[+n] === r);
}
function lzt() {
  let [e] = szt(), t = Ut(Object.freeze([Object.freeze([])])), r = Object.values(e).filter(({ role: a }) => a !== "user").sort(({ at: a }, { at: u }) => a - u), n = Object.freeze([Object.freeze(r.map(({ name: a }) => a))]), { current: i } = t, o = czt(n[0], i[0]) ? i : n;
  return nr(() => {
    t.current = o;
  }, [t, o]), o;
}
var { useActivities: fzt, useGetKeyByActivity: dzt, useLocalizer: wEe, useStyleOptions: pzt } = Vt, hzt = { "&.webchat__live-region-transcript": { "& .webchat__live-region-transcript__note, & .webchat__live-region-transcript__note, & .webchat__live-region-transcript__text-element": { color: "transparent", height: 1, overflow: "hidden", position: "absolute", top: 0, whiteSpace: "nowrap", width: 1 } } }, vzt = ({ activityElementMapRef: e }) => {
  let [t] = REe(), [r] = fzt(), [n] = lzt(), i = dzt(), o = wEe(), a = OEe("accessible name"), u = SEe(), s = o("TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT"), c = o("TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT"), l = !!n.length && o(n.length > 1 ? "TYPING_INDICATOR_MULTIPLE_TEXT" : "TYPING_INDICATOR_SINGLE_TEXT", n[0]), f = t ? o("TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT", a(t)) : o("TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT"), d = tt(() => Object.freeze(r.reduce((v, h) => h.type === "message" ? v.set(i(h), h) : v, /* @__PURE__ */ new Map())), [r, i]), p = Ut();
  return nr(() => {
    let { current: v } = p, h = [];
    for (let [y, _] of Array.from(d.entries()).reverse()) {
      if (v != null && v.has(y)) break;
      h.unshift({ activity: _, key: y }), mEe(_) || u(G.createElement(zjt, { activity: _ }));
    }
    let E = h.some(({ key: y }) => {
      var _;
      return (_ = e.current.get(y)) == null ? void 0 : _.querySelector("a");
    }), m = h.some(({ key: y }) => {
      var _;
      return !!UC((_ = e.current.get(y)) == null ? void 0 : _.querySelector(".webchat__basic-transcript__activity-body")).length;
    }), g = h.some(({ activity: y }) => {
      var _, S;
      return y.type === "message" && ((S = (_ = y.suggestedActions) == null ? void 0 : _.actions) == null ? void 0 : S.length);
    });
    (E || m) && u(G.createElement("div", { className: "webchat__live-region-transcript__note", role: "note" }, E ? c : s)), g && u(G.createElement("div", { className: "webchat__live-region-transcript__note", role: "note" }, f)), p.current = d;
  }, [e, s, c, f, p, u, d]), nr(() => {
    l && u(l);
  }, [u, l]), G.createElement(Jjt, null);
}, PEe = ({ activityElementMapRef: e }) => {
  let [{ internalLiveRegionFadeAfter: t }] = pzt(), r = wEe(), n = Tn()(hzt) + "", i = r("TRANSCRIPT_ARIA_ROLE_ALT");
  return G.createElement(rzt, { "aria-roledescription": i, className: Gt("webchat__live-region-transcript", n), fadeAfter: t, role: "log", textElementClassName: "webchat__live-region-transcript__text-element" }, G.createElement(vzt, { activityElementMapRef: e }));
};
PEe.propTypes = { activityElementMapRef: Q.shape({ current: Q.instanceOf(Map) }).isRequired };
var Ezt = PEe;
function mzt(e) {
  if ("scrollBehavior" in document.documentElement.style) return e.scrollIntoView({ block: "nearest" });
  let [t] = jrt(e, { block: "nearest" });
  t.el.scrollTop = t.top;
}
var gzt = ei(void 0), DEe = gzt, xEe = ei(void 0);
function NEe(e = !0) {
  let t = En(xEe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <ActivityTreeComposer>.");
  return t;
}
function BM(e = {}) {
  let t = NEe();
  return (e == null ? void 0 : e.flat) === !0 ? t.flattenedActivityTreeWithRendererState : t.activityTreeWithRendererState;
}
function Tzt(e) {
  let [t, r] = cn(), n = Ut(e), i = mt((o) => {
    let { current: a } = n;
    o = o instanceof Function ? o(a) : o, a !== o && (n.current = o, r({}));
  }, [r, n]);
  return Object.freeze([n.current, i, n]);
}
var { useGetKeyByActivity: yzt } = Vt;
function BW(e) {
  return e[e.length - 1];
}
function _zt(e = 1 / 0) {
  return Mu().toString(36).substring(2, 2 + e);
}
var LEe = ({ children: e, containerRef: t }) => {
  var y;
  let [r] = BM({ flat: !0 }), [n, i, o] = Tzt(), a = yzt(), u = tt(() => _zt(3), []), s = mt((_) => _ && `webchat__transcript-focus-${u}__activity-${_}`, [u]), c = tt(() => Object.freeze(r.map(({ activity: _ }) => a(_))), [r, a]), l = Lu(c), f = DM(c);
  c !== f && !((y = t.current) != null && y.contains(document.activeElement)) && (o.current = void 0);
  let { current: d } = o, p = tt(() => c.includes(d) ? d : BW(c), [c, d]), v = Lu(p), h = tt(() => s(p), [s, p]), E = mt((_, S = !0) => {
    var A;
    if (_ === !1 ? i(void 0) : _ === !0 ? i((O) => O || v.current) : _ && i(_), S) {
      (A = t.current) == null || A.focus();
      let O = s(_ === !1 ? BW(l.current) : _ && _ !== !0 ? _ : o.current), P = O && document.getElementById(O);
      P && !P.contains(document.activeElement) && mzt(P);
    }
  }, [s, t, v, l, o, i]), m = mt((_) => {
    let { current: S } = l;
    if (isNaN(_) || !S.length) return E(!1, !0);
    let { current: A } = v, O = S.indexOf(A), P = ~O ? Math.max(0, Math.min(S.length - 1, O + _)) : S.length - 1;
    E(S[+P], !0);
  }, [v, l, E]), g = tt(() => ({ activeDescendantIdState: Object.freeze([h]), getDescendantIdByActivityKey: s, focusByActivityKey: E, focusedActivityKeyState: Object.freeze([p]), focusedExplicitlyState: Object.freeze([!!d]), focusRelativeActivity: m }), [h, s, E, p, m, d]);
  return G.createElement(DEe.Provider, { value: g }, e);
};
LEe.propTypes = { containerRef: Q.shape({ current: Q.instanceOf(HTMLElement) }).isRequired };
var Azt = LEe;
function Hh(e = !0) {
  let t = En(DEe);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <TranscriptFocusComposer>.");
  return t;
}
function BEe() {
  return Hh().activeDescendantIdState;
}
function Szt() {
  return ho().dispatchScrollPosition;
}
function bzt() {
  return ho().dispatchTranscriptFocusByActivityKey;
}
function kM() {
  return Hh().focusByActivityKey;
}
function Czt() {
  return Hh().focusedActivityKeyState;
}
function Izt() {
  return Hh().focusedExplicitlyState;
}
function Ozt() {
  return Hh().focusRelativeActivity;
}
function Rzt(e, t) {
  let r = document.createElement("style");
  t && r.setAttribute("nonce", t), document.head.appendChild(r);
  try {
    return r.sheet.insertRule("html" + e + "{}", 0), !0;
  } catch {
    return !1;
  } finally {
    document.head.removeChild(r);
  }
}
function MM() {
  let { nonce: e } = ho();
  return [e];
}
var { usePonyfill: wzt } = Vt, Pzt = ["date", "datetime-local", "datetime", "email", "month", "number", "password", "search", "tel", "text", "time", "url", "week"];
function Dzt(e) {
  let { isContentEditable: t, readOnly: r, tagName: n, type: i } = e;
  return n === "INPUT" && Pzt.includes(i) && !r || n === "TEXTAREA" && !r || t;
}
function xzt(e, t, r) {
  let n;
  return { pause: () => {
    n && (t.forEach((i) => e.removeEventListener(i, r)), n = void 0);
  }, resume: () => {
    n || (t.forEach((i) => e.addEventListener(i, r)), n = !0);
  } };
}
function Nzt(e, t) {
  let [{ Date: r }] = wzt(), n = Ut(0), i = Ut(!0), o = Ut(!1), a = tt(() => xzt(document, ["mousemove", "mousedown", "mouseup", "pointermove", "pointerdown", "pointerup", "touchmove", "touchstart", "touchend"], (p) => {
    var v;
    ((v = p.target.nodeName) == null ? void 0 : v.toLowerCase()) !== "html" && (i.current = !1, a.pause());
  }), [i]), u = mt((p) => {
    o.current !== p && (o.current = p, p && (t == null || t.current()));
  }, [o, t]), s = mt((p) => {
    p.altKey || p.ctrlKey || p.metaKey || (p.target === e.current && u(!0), i.current = !0);
  }, [i, u, e]), c = mt(() => {
    i.current = !1;
  }, [i]), l = mt(({ target: p }) => {
    p === e.current && (i.current || Dzt(p)) && u(!0);
  }, [i, u, e]), f = mt((p) => {
    p.target === e.current && o.current && (n.current = r.now(), u(!1));
  }, [n, r, o, u, e]), d = mt(() => {
    document.visibilityState === "hidden" && (r.now() - n.current < 100 && (i.current = !0), a.resume());
  }, [n, r, a, i]);
  nr(() => (document.addEventListener("keydown", s, !0), document.addEventListener("mousedown", c, !0), document.addEventListener("pointerdown", c, !0), document.addEventListener("touchstart", c, !0), document.addEventListener("visibilitychange", d, !0), () => {
    document.removeEventListener("keydown", s), document.removeEventListener("mousedown", c), document.removeEventListener("pointerdown", c), document.removeEventListener("touchstart", c), document.removeEventListener("visibilitychange", d);
  }), [s, c, d]), nr(() => {
    let { current: p } = e;
    return p.addEventListener("blur", f, !0), p.addEventListener("focus", l, !0), () => {
      p.removeEventListener("blur", f), p.removeEventListener("focus", l);
    };
  }, [f, l, e]), nr(() => (a.resume(), () => a.pause()), [a]);
}
function Lzt(e, t) {
  let r = mt(() => {
    let { current: n } = e;
    (n.matches || n.msMatchesSelector).call(n, ":focus-visible") && (t == null || t.current());
  }, [t, e]);
  nr(() => {
    let { current: n } = e;
    return n.addEventListener("focus", r), () => n.removeEventListener("focus", r);
  }, [r, e, e.current]);
}
function kEe(e, t) {
  let [r] = MM(), n = Lu(t), i = Ut(r);
  tt(() => Rzt(":focus-visible", i.current), [i]) ? Lzt(e, n) : Nzt(e, n);
}
function VC(e, ...t) {
  t.forEach((r) => {
    let n;
    for (; ~(n = e.indexOf(r)); ) e.splice(n, 1);
  });
}
function Bzt(e) {
  let { focusTranscriptCallbacksRef: t } = ho();
  nr(() => {
    if (e) {
      let { current: r } = t;
      return r.push(e), () => VC(r, e);
    }
  }, [e, t]);
}
function kzt(e) {
  let { scrollToCallbacksRef: t } = ho();
  nr(() => {
    if (e) {
      let { current: r } = t;
      return r.push(e), () => VC(r, e);
    }
  }, [e, t]);
}
function Mzt(e) {
  let { scrollToEndCallbacksRef: t } = ho();
  nr(() => {
    let { current: r } = t;
    return r.push(e), () => VC(r, e);
  }, [e, t]);
}
var jC = ({ children: e, onFocus: t, onLeave: r }) => {
  let n = Ut(), i = Vo(r), o = mt(() => UC(n.current).filter((c) => c.getAttribute("aria-disabled") !== "true"), [n]), a = mt((c) => {
    var l;
    c.key === "Escape" && (c.preventDefault(), c.stopPropagation(), (l = i.current) == null || l.call(i));
  }, [i]), u = mt(() => {
    var f;
    let c = o(), l = c[c.length - 1];
    l ? l.focus() : (f = i.current) == null || f.call(i);
  }, [o, i]), s = mt(() => {
    var l;
    let [c] = o();
    c ? c.focus() : (l = i.current) == null || l.call(i);
  }, [o, i]);
  return G.createElement(jo, null, G.createElement(BS, { onFocus: u }), G.createElement("div", { onFocus: t, onKeyDown: a, ref: n }, e), G.createElement(BS, { onFocus: s }));
};
jC.defaultProps = { children: void 0, onFocus: void 0 };
jC.propTypes = { children: Q.any, onFocus: Q.func, onLeave: Q.func.isRequired };
jC.displayName = "FocusTrap";
var Fzt = Nr(jC), Hzt = { color: "Red", margin: 0 }, FM = ({ speak: e }) => {
  let t = Tn()(Hzt) + "";
  return !!e && G.createElement("pre", { className: t }, e);
};
FM.defaultProps = { speak: "" };
FM.propTypes = { speak: Q.string };
var $zt = FM, Uzt = "default" in _R ? _R.default : _R, { useMarkActivityAsSpoken: Vzt, useStyleOptions: jzt, useVoiceSelector: zzt } = Vt, HM = ({ activity: e }) => {
  var u;
  let [{ showSpokenText: t }] = jzt(), r = Vzt(), n = zzt(e), i = mt(() => {
    r(e);
  }, [e, r]), o = tt(() => {
    if (e.type !== "message") return !1;
    let { attachments: s = [], speak: c, text: l } = e;
    return [c || l, ...s.filter(({ contentType: f }) => f === "application/vnd.microsoft.card.adaptive").map((f) => {
      var d;
      return (d = f == null ? void 0 : f.content) == null ? void 0 : d.speak;
    })].filter((f) => f).join(`\r
`);
  }, [e]), a = e.type === "message" && ((u = e.channelData) == null ? void 0 : u.speechSynthesisUtterance);
  return !!e && G.createElement(G.Fragment, null, a ? G.createElement(TC.SayUtterance, { onEnd: i, onError: i, utterance: a }) : G.createElement(Uzt, { onEnd: i, onError: i, text: o, voice: n }), !!t && G.createElement($zt, { speak: o }));
};
HM.propTypes = { activity: Q.shape({ attachments: Q.arrayOf(Q.shape({ speak: Q.string, subtitle: Q.string, text: Q.string, title: Q.string })), channelData: Q.shape({ speechSynthesisUtterance: Q.any }), speak: Q.string, text: Q.string, type: Q.string.isRequired }).isRequired };
HM.displayName = "SpeakActivity";
var MEe = Nr(HM), { useAvatarForBot: qzt, useGetKeyByActivity: Yzt, useLocalizer: kW, useSendStatusByActivityKey: Gzt } = Vt, Wzt = { few: "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT", many: "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT", one: "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT", other: "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT", two: "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT" };
function Kzt(e, t) {
  var O, P;
  let [{ initials: r }] = qzt(), [n, i] = cn(!1), [o] = Gzt(), a = ((O = e.from) == null ? void 0 : O.role) === "user", u = Yzt(), s = kW(), c = kW({ plural: !0 }), l = e.type === "message" && ((P = e.attachments) == null ? void 0 : P.length) || 0, f = Fh(), d = s("ACTIVITY_INTERACTIVE_FOOTNOTE_ALT"), p = s("ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT"), v = s("ACTIVITY_INTERACTIVE_REASON_LINK_ALT"), h = s("ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT"), E = tt(() => u(e), [e, u]), m = tt(() => (a ? s("ACTIVITY_YOU_SAID_ALT") : s("ACTIVITY_BOT_SAID_ALT", r || "")).replace(/\s{2,}/gu, " "), [r, a, s]), g = Lu(n), y = tt(() => gEe(e, f), [e, f]), _ = tt(() => l ? c(Wzt, l) : "", [c, l]), S = tt(() => o.get(E) === py, [E, o]), A = tt(() => [m, y, _, S ? h : "", n === 0 ? v : n === 1 ? p : "", n || S ? d : ""].filter(Boolean).join(" "), [d, p, v, h, m, n, S, y, _]);
  return nr(() => {
    var k;
    let U = !!((k = t.current) != null && k.querySelector("a")), z = !!UC(t.current).length;
    g.current !== z && i(U ? 0 : z ? 1 : !1);
  }, [t, g, i]), [A];
}
function Xzt() {
  return Hh().getDescendantIdByActivityKey;
}
var { useActivityKeysByRead: Jzt, useGetHasAcknowledgedByActivityKey: Zzt, useGetKeyByActivity: Qzt } = Vt, zC = n0(({ activity: e, children: t }, r) => {
  var A;
  let [n] = BEe(), [i] = Jzt(), o = Ut(), a = kM(), u = Qzt(), s = (A = e.channelData) == null ? void 0 : A.speak, [c] = Kzt(e, o), l = u(e), f = Zzt()(l), d = Vo(l), p = Xzt()(l), v = `webchat__basic-transcript__active-descendant-label--${l}`, h = p === n, E = i.includes(l), m = mt((O) => a(d.current, O), [d, a]), g = mt(() => m(!1), [m]), y = mt(() => m(), [m]), _ = mt(() => m(!1), [m]), S = tt(() => G.createElement("div", { className: "webchat__basic-transcript__activity-body", ref: o }, t), [o, t]);
  return G.createElement("article", { className: Gt("webchat__basic-transcript__activity", { "webchat__basic-transcript__activity--acknowledged": f, "webchat__basic-transcript__activity--read": E }), onMouseDownCapture: _, ref: r }, !dEe && G.createElement("div", { "aria-labelledby": v, className: "webchat__basic-transcript__activity-active-descendant", id: p, role: "article" }, G.createElement(ya, { "aria-hidden": !0, id: v, text: c })), G.createElement(Fzt, { onFocus: g, onLeave: y }, S), s && G.createElement(MEe, { activity: e }), G.createElement("div", { className: Gt("webchat__basic-transcript__activity-indicator", { "webchat__basic-transcript__activity-indicator--focus": h }) }));
});
zC.defaultProps = { children: void 0 };
zC.displayName = "ActivityRow";
zC.propTypes = { activity: Q.shape({ channelData: Q.shape({ speak: Q.bool, "webchat:fallback-text": Q.string }) }).isRequired, children: Q.any };
var eqt = Nr(zC), { useCreateActivityStatusRenderer: tqt } = Vt;
function rqt({ activityElementMapRef: e, activityKey: t, activity: r, hideTimestamp: n, renderActivity: i, renderAvatar: o, showCallout: a }) {
  let u = tqt(), s = mt((f) => {
    f ? e.current.set(t, f) : e.current.delete(t);
  }, [e, t]), c = tt(() => u({ activity: r, nextVisibleActivity: void 0 }), [r, u]), l = tt(() => i({ hideTimestamp: n, renderActivityStatus: c, renderAvatar: o, showCallout: a }), [n, i, c, o, a]);
  return G.createElement(eqt, { activity: r, ref: s }, l);
}
var nqt = Nr(rqt);
function FEe(e, t) {
  if (typeof e != "function") throw new Error("The first argument must be a function.");
  if (!Array.isArray(t)) throw new Error("The second argument must be an array.");
  let r = Vo(e), n = Ut(), i = Ut(), o = tt(() => (n.current = [], i.current = [], (...a) => {
    let u = r.current, s = n.current, c = i.current, l = s.find(({ args: d }) => a.length === d.length && a.every((p, v) => Object.is(p, d[v])));
    if (l) return l.args = a, c.push(l), l.result;
    let f = { args: a, result: u(...a) };
    return c.push(f), s.push(f), f.result;
  }), [r, n, i, ...t]);
  return nr(() => {
    n.current = i.current, i.current = [];
  }), o;
}
var { useListen: iqt, usePropagate: HEe } = Nhe(), { useActivityKeys: oqt, useActivityKeysByRead: aqt, useCreateAvatarRenderer: uqt, useCreateScrollToEndButtonRenderer: sqt, useDirection: cqt, useGetActivityByKey: lqt, useGetKeyByActivity: $Ee, useGetKeyByActivityId: fqt, useLastAcknowledgedActivityKey: dqt, useLocalizer: UEe, useMarkActivityKeyAsRead: VEe, useMarkAllAsAcknowledged: pqt, useStyleOptions: $M } = Vt, hqt = { "&.webchat__basic-transcript": { display: "flex", flexDirection: "column", overflow: "hidden", position: "relative", "& .webchat__basic-transcript__filler": { flex: 1 }, "& .webchat__basic-transcript__scrollable": { display: "flex", flexDirection: "column", overflowX: "hidden", WebkitOverflowScrolling: "touch" }, "& .webchat__basic-transcript__transcript": { listStyleType: "none" } } }, qC = n0(({ activityElementMapRef: e, className: t }, r) => {
  let [{ basicTranscript: n }] = pr(), [{ bubbleFromUserNubOffset: i, bubbleNubOffset: o, groupTimestamp: a, showAvatarInGroup: u }] = $M(), [s] = BEe(), [c] = BM(), [l] = cqt(), [f] = Czt(), [d] = Izt(), p = uqt(), v = d0(), h = kM(), E = Ozt(), m = lqt(), g = $Ee(), y = fqt(), _ = UEe(), S = Tn()(hqt) + "", A = Ut(), O = $C("webchat__basic-transcript__terminator-label"), P = Ut(), U = Lu(f), z = a === !1, k = _("TRANSCRIPT_TERMINATOR_TEXT"), H = _("TRANSCRIPT_ARIA_LABEL_ALT"), B = mt((qe) => {
    typeof r == "function" ? r(qe) : r.current = qe, A.current = qe;
  }, [r, A]), x = FEe((qe) => p({ activity: qe }), [p]), D = tt(() => {
    let qe = [], Je = Gp(o), Be = Gp(i);
    return c.forEach((We) => {
      let [[{ activity: Ne }]] = We, je = x(Ne);
      We.forEach((et, St) => {
        let Ot = !St, we = St === We.length - 1;
        et.forEach(({ activity: De, renderActivity: Ee }, te) => {
          var ie;
          let ue = !te, ye = g(De), Le = te === et.length - 1, Me = ((ie = De.from) == null ? void 0 : ie.role) === "user" ? Be : Je, Ae;
          u === "sender" ? Me ? Ae = Ot && ue : Ae = we && Le : u === "status" ? Me ? Ae = ue : Ae = Le : Ae = !0, qe.push(G.createElement(nqt, { activity: De, activityElementMapRef: e, activityKey: ye, hideTimestamp: z || te !== et.length - 1, key: ye, renderActivity: Ee, renderAvatar: je, showCallout: Ae }));
        });
      });
    }), qe;
  }, [e, c, i, o, x, g, z, u]), w = iet(), $ = Gde(), X = mt((qe, { behavior: Je = "auto" } = {}) => {
    var Ne;
    if (!qe) throw new Error('botframework-webchat: First argument passed to "useScrollTo" must be a ScrollPosition object.');
    let { activityID: Be, scrollTop: We } = qe;
    if (typeof We < "u") w(We, { behavior: Je });
    else if (typeof Be < "u") {
      let je = (Ne = e.current.get(y(Be))) == null ? void 0 : Ne.querySelector(".webchat__basic-transcript__activity-active-descendant"), et = A.current.querySelector(".webchat__basic-transcript__scrollable");
      if (et && je) {
        let St = je.getClientRects()[0], Ot = et.getClientRects()[0];
        if (St && Ot) {
          let { height: we, y: De } = St, { height: Ee } = Ot, te = De + et.scrollTop, ue = Math.min(te, te - Ee + we);
          w(ue, { behavior: Je });
        }
      }
    }
  }, [e, y, A, w]), V = mt(() => $({ behavior: "smooth" }), [$]), F = mt(({ direction: qe, displacement: Je }) => {
    let { current: Be } = A;
    if (!Be) return;
    let We = Be.querySelector(".webchat__basic-transcript__scrollable"), Ne;
    typeof Je == "number" ? Ne = We.scrollTop + (qe === "down" ? 1 : -1) * Je : Ne = We.scrollTop + (qe === "down" ? 1 : -1) * We.offsetHeight, X({ scrollTop: Math.max(0, Math.min(We.scrollHeight - We.offsetHeight, Ne)) }, { behavior: "smooth" });
  }, [A, X]);
  kzt(X), Mzt(V), iqt(F);
  let le = VEe(), ae = Szt(), ne = mt(({ scrollTop: qe }) => {
    var St;
    let { current: Je } = A;
    if (!Je) return;
    let Be = Je.querySelector(".webchat__basic-transcript__scrollable"), We = Be.getClientRects()[0];
    if (!We) return;
    let { bottom: Ne } = We, je = Array.from(e.current.entries()), et = (St = Be.scrollTop ? je.reverse().find(([, Ot]) => {
      let we = Ot.getClientRects()[0];
      return we && we.bottom < Ne + 1;
    }) : je[0]) == null ? void 0 : St[0];
    if (et && le(et), ae) {
      let Ot = m(et);
      ae({ ...Ot ? { activityID: Ot.id } : {}, scrollTop: qe });
    }
  }, [e, ae, m, le, A]);
  net(ne);
  let ve = mt((qe) => {
    var je, et;
    let { target: Je } = qe, Be = Je === P.current, We = Je === qe.currentTarget;
    if (!Be && !We) return;
    let Ne = !0;
    switch (qe.key) {
      case "ArrowDown":
        E(Be ? 0 : 1);
        break;
      case "ArrowUp":
        E(Be ? 0 : -1);
        break;
      case "End":
        E(1 / 0);
        break;
      case "Enter":
        if (!Be) {
          let St = (je = e.current.get(U.current)) == null ? void 0 : je.querySelector(".webchat__basic-transcript__activity-body");
          (et = UC(St)[0]) == null || et.focus();
        }
        break;
      case "Escape":
        v("sendBoxWithoutKeyboard");
        break;
      case "Home":
        E(-1 / 0);
        break;
      default:
        Ne = !1;
        break;
    }
    Ne && (qe.preventDefault(), qe.stopPropagation());
  }, [e, v, U, E, P]), Ie = mt((qe) => {
    let { altKey: Je, ctrlKey: Be, key: We, metaKey: Ne, target: je } = qe;
    Je || Be && We !== "v" || Ne || !Cjt(We) && We !== "Backspace" || (je === qe.currentTarget || je === P.current) && (qe.stopPropagation(), v("sendBox"));
  }, [v]);
  Bzt(mt(() => h(void 0), [h]));
  let Oe = bzt();
  tt(() => Oe(d ? f : void 0), [Oe, f, d]);
  let xe = mt(({ currentTarget: qe, target: Je }) => Je === qe && h(!0, !1), [h]), ze = mt(() => h(void 0), [h]);
  return kEe(A, mt(() => h(void 0), [h])), G.createElement("div", { "aria-activedescendant": dEe ? void 0 : s, "aria-label": H, className: Gt("webchat__basic-transcript", n + "", S, (t || "") + ""), dir: l, onFocus: xe, onKeyDown: ve, onKeyDownCapture: Ie, ref: B, role: "group", tabIndex: 0 }, G.createElement(Ezt, { activityElementMapRef: e }), G.createElement(jEe, { onFocusFiller: ze, terminatorRef: P }, D), !!D.length && G.createElement(jo, null, G.createElement(BS, { redirectRef: A }), G.createElement("div", { "aria-labelledby": O, className: "webchat__basic-transcript__terminator", ref: P, role: "note", tabIndex: 0 }, G.createElement("div", { className: "webchat__basic-transcript__terminator-body" }, G.createElement("div", { className: "webchat__basic-transcript__terminator-text", id: O }, k)))), G.createElement("div", { className: "webchat__basic-transcript__focus-indicator" }));
});
qC.defaultProps = { className: "" };
qC.displayName = "InternalTranscript";
qC.propTypes = { activityElementMapRef: Q.shape({ current: Q.instanceOf(Map) }).isRequired, className: Q.string };
var jEe = ({ children: e, onFocusFiller: t, terminatorRef: r }) => {
  let [{ activities: n }] = pr(), [i] = tet(), [o] = ret(), [, a] = aqt(), [u] = fqe(), [s] = $M(), c = kM(), l = UEe(), f = VEe(), d = pqt(), p = Gde(), v = DM(u), h = l("TRANSCRIPT_ARIA_ROLE_ALT"), E = v !== u && u;
  tt(() => E && d(), [d, E]);
  let [m] = BM({ flat: !0 }), g = $Ee(), y = tt(() => m.map(({ activity: k }) => g(k)), [m, g]), _ = Lu(y), S = tt(() => u && a.length ? (f(a[a.length - 1]), []) : a, [f, u, a]), A = Lu(S), O = tt(() => S.some((k) => y.includes(k)), [y, S]), P = mt(() => {
    var B;
    p({ behavior: "smooth" });
    let { current: k } = _, H = A.current.find((x) => k.includes(x));
    H ? c(H) : (B = r.current) == null || B.focus();
  }, [c, A, _, p, r]), U = sqt()({ atEnd: i || o || u, styleOptions: s, unread: O }), z = !!G.Children.count(e);
  return G.createElement(G.Fragment, null, U && U({ onClick: P }), z && G.createElement(BS, { redirectRef: r }), G.createElement(x9, { className: "webchat__basic-transcript__scrollable" }, G.createElement("div", { "aria-hidden": !0, className: "webchat__basic-transcript__filler", onFocus: t }), z && G.createElement("section", { "aria-roledescription": h, className: Gt(n + "", "webchat__basic-transcript__transcript"), role: "feed" }, e), G.createElement(Sjt, null)));
};
jEe.propTypes = { children: Q.any.isRequired, onFocusFiller: Q.func.isRequired, terminatorRef: Q.any.isRequired };
var vqt = (e) => {
  let [t] = oqt(), [r] = dqt(), [n] = $M(), i = Lu(t), o = Lu(r), a = Lu(n);
  return mt(({ offsetHeight: u, scrollTop: s }) => {
    let { current: { autoScrollSnapOnActivity: c, autoScrollSnapOnActivityOffset: l, autoScrollSnapOnPage: f, autoScrollSnapOnPageOffset: d } } = a, p = typeof c == "number" ? Math.max(0, c) : c ? 1 : 0, v = typeof f == "number" ? Math.max(0, Math.min(1, f)) : f ? 1 : 0, h = typeof l == "number" ? l : 0, E = typeof d == "number" ? d : 0;
    if (p || v) {
      let { current: m } = e, { current: g } = i, { current: y } = o, _ = [], S = g.indexOf(y);
      if (~S) {
        let A = Array.from(m.keys()), O = -1;
        for (let P of g.slice(0, S + 1).reverse()) {
          let U = A.indexOf(P);
          if (~U) {
            U !== A.length - 1 && (O = U + 1);
            break;
          }
        }
        if (~O) {
          let P = Array.from(m.values());
          if (p) {
            let U = P[O + p - 1];
            if (U) {
              let z = U == null ? void 0 : U.querySelector(".webchat__basic-transcript__activity-active-descendant"), k = U.offsetTop + z.offsetTop;
              _.push(k + z.offsetHeight - u - s + h);
            }
          }
          if (v) {
            let U = P[+O], z = U.querySelector(".webchat__basic-transcript__activity-active-descendant"), k = U.offsetTop + z.offsetTop;
            _.push(k - s - u * (1 - v) + E);
          }
        }
      }
      return Math.min(..._);
    }
    return 1 / 0;
  }, [e, i, o, a]);
}, UM = ({ className: e }) => {
  let t = Ut(/* @__PURE__ */ new Map()), r = Ut(), n = vqt(t);
  return G.createElement(Azt, { containerRef: r }, G.createElement(D9, { scroller: n }, G.createElement(wjt, null), G.createElement(qC, { activityElementMapRef: t, className: e, ref: r })));
};
UM.defaultProps = { className: "" };
UM.propTypes = { className: Q.string };
var zEe = Nr(UM), { navigator: { userAgent: qEe } } = window, Eqt = ["a", "body", "button", "frame", "iframe", "img", "input", "isindex", "object", "select", "textarea"], mqt = /Firefox\//iu.test(qEe), gqt = /Trident\//iu.test(qEe);
function YEe(e) {
  let { tabIndex: t } = e;
  if (gqt) {
    let r = e.attributes.getNamedItem("tabindex");
    if (!r || !r.specified) return ~Eqt.indexOf(e.nodeName.toLowerCase()) ? 0 : null;
  } else if (!~t) {
    let r = e.getAttribute("tabindex");
    if (r === null || r === "" && !mqt) return null;
  }
  return t;
}
var Tqt = () => !0, GEe = "a[href], audio, button, details, details summary, embed, iframe, input, object, rect, select, svg[focusable], textarea, video, [tabindex]";
function yqt(e, t = Tqt) {
  if (!e) return;
  let r = [].filter.call(e.querySelectorAll(GEe), t);
  return [].find.call(r, (n) => {
    let i = YEe(n);
    return typeof i == "number" && i >= 0;
  });
}
function _qt(e) {
  if (e) return (e.matches || e.msMatchesSelector).call(e, GEe) ? e : yqt(e);
}
var Aqt = ei(), WEe = Aqt, VM = ({ children: e, ...t }) => {
  let [{ apple: r }] = IEe(), n = Ut({ focii: [] }), i = mt((o) => {
    let { altKey: a, ctrlKey: u, key: s, shiftKey: c } = o;
    if (a && (r ? u : c)) {
      let l = n.current.focii.filter((p) => p.keys.includes(s)), f = l.findIndex(({ ref: { current: p } }) => p === document.activeElement || p.contains(document.activeElement)), d = l[(f + 1) % l.length];
      if (d) {
        o.preventDefault(), o.stopPropagation();
        let p = _qt(d.ref.current);
        p && p.focus();
      }
    }
  }, [r]);
  return G.createElement(WEe.Provider, { value: n.current }, G.createElement("div", { onKeyUp: i, ...t }, e));
};
VM.defaultProps = { children: void 0 };
VM.propTypes = { children: Q.any };
var KEe = VM, { useStyleOptions: Sqt } = Vt, bqt = { display: "flex", flexDirection: "column" }, Cqt = { flexShrink: 0 }, Iqt = { flexShrink: 0 }, Oqt = { flexShrink: 0 }, Rqt = { flex: 1 }, XEe = ["complementary", "contentinfo", "form", "main", "region"], jM = ({ className: e, role: t }) => {
  let [{ root: r }] = pr(), [n] = Sqt(), i = Tn(), o = i(Cqt) + "", a = i(bqt) + "", u = i(Iqt) + "", s = i(Oqt) + "", c = i(Rqt) + "";
  return XEe.includes(t) || (t = "complementary"), G.createElement(KEe, { className: Gt(a, r + "", (e || "") + ""), role: t }, !n.hideToaster && G.createElement(lEe, { className: s }), G.createElement(zEe, { className: c }), G.createElement(uEe, { className: o }), G.createElement(JHe, { className: u, request: void 0 }));
};
jM.defaultProps = { className: "", role: "complementary" };
jM.propTypes = { className: Q.string, role: Q.oneOf(XEe) };
var JEe = jM, zM = ({ alt: e, autoPlay: t, loop: r, src: n }) => {
  let [{ audioContent: i }] = pr();
  return G.createElement("audio", { "aria-label": e, autoPlay: t, className: i, controls: !0, loop: r, src: n });
};
zM.defaultProps = { alt: "", autoPlay: !1, loop: !1, poster: "" };
zM.propTypes = { alt: Q.string, autoPlay: Q.bool, loop: Q.bool, poster: Q.string, src: Q.string.isRequired };
var ZEe = zM, QEe = ({ attachment: e }) => {
  let [{ audioAttachment: t }] = pr();
  return G.createElement("div", { className: t }, G.createElement(ZEe, { alt: e.name, src: e.contentUrl }));
};
QEe.propTypes = { attachment: Q.shape({ contentUrl: Q.string.isRequired, name: Q.string }).isRequired };
var wqt = QEe, MW = 22, qM = ({ className: e, size: t }) => G.createElement("svg", { className: e, focusable: !1, height: MW * t, role: "presentation", viewBox: "0 0 31.8 46", width: MW * t }, G.createElement("path", { d: "M26.8,23.8l-10.9,11L5,23.8l1.6-1.6l8.2,8.3V5H17v25.5l8.2-8.3L26.8,23.8z M5.8,41v-2.2H26V41H5.8z" }));
qM.defaultProps = { className: "", size: 1 };
qM.propTypes = { className: Q.string, size: Q.number };
var Pqt = qM, { useByteFormatter: eme, useDirection: Dqt, useLocalizer: xqt } = Vt, Nqt = { display: "flex", "& .webchat__fileContent__buttonLink": { display: "flex", flex: 1 }, "& .webchat__fileContent__badge": { display: "flex", flex: 1, flexDirection: "column" } }, Lqt = ["blob:", "data:", "http:", "https:"];
function Bqt(e) {
  try {
    return Lqt.includes(new URL(e).protocol);
  } catch {
    return !1;
  }
}
var kS = ({ downloadIcon: e, fileName: t, size: r }) => {
  let [n] = Dqt(), i = eme(), o = typeof r == "number" && i(r);
  return G.createElement(G.Fragment, null, G.createElement("div", { "aria-hidden": !0, className: "webchat__fileContent__badge" }, G.createElement("div", { className: "webchat__fileContent__fileName" }, t), !!o && G.createElement("div", { className: "webchat__fileContent__size" }, o)), e && G.createElement(Pqt, { className: Gt("webchat__fileContent__downloadIcon", n === "rtl" && "webchat__fileContent__downloadIcon--rtl"), size: 1.5 }));
};
kS.defaultProps = { downloadIcon: !1, size: void 0 };
kS.propTypes = { downloadIcon: Q.bool, fileName: Q.string.isRequired, size: Q.number };
var YM = ({ className: e, href: t, fileName: r, size: n }) => {
  let [{ fileContent: i }] = pr(), o = xqt(), a = eme(), u = Tn()(Nqt) + "", s = typeof n == "number" && a(n);
  t = t && Bqt(t) ? t : void 0;
  let c = o(t ? s ? "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT" : "FILE_CONTENT_DOWNLOADABLE_ALT" : s ? "FILE_CONTENT_WITH_SIZE_ALT" : "FILE_CONTENT_ALT", r, s);
  return G.createElement("div", { className: Gt("webchat__fileContent", u, i + "", (e || "") + "") }, t ? G.createElement("a", { "aria-label": c, className: "webchat__fileContent__buttonLink", download: r, href: t, rel: "noopener noreferrer", target: "_blank" }, G.createElement(kS, { downloadIcon: !0, fileName: r, size: n })) : G.createElement(kS, { downloadIcon: !1, fileName: r, size: n }));
};
YM.defaultProps = { className: "", href: void 0, size: void 0 };
YM.propTypes = { className: Q.string, fileName: Q.string.isRequired, href: Q.string, size: Q.number };
var tme = YM, rme = ({ activity: { attachments: e = [], channelData: { attachmentSizes: t = [] } = {} } = {}, attachment: r }) => {
  let n = e.indexOf(r), i = t[+n];
  return G.createElement(tme, { fileName: r.name, href: r.contentUrl, size: i });
};
rme.propTypes = { activity: Q.shape({ attachment: Q.array, channelData: Q.shape({ attachmentSizes: Q.arrayOf(Q.number) }) }).isRequired, attachment: Q.shape({ contentUrl: Q.string, name: Q.string.isRequired }).isRequired };
var FW = rme, kqt = { overflow: "hidden", position: "relative", "& > img": { height: "auto", left: "50%", position: "absolute", top: "50%", transform: "translate(-50%, -50%)", width: "100%" } }, GM = ({ alt: e, className: t, height: r, src: n, width: i }) => {
  let o = Tn()(kqt) + "", a = tt(() => ({ height: r, width: i }), [r, i]);
  return G.createElement("div", { className: Gt(o, (t || "") + ""), style: a }, G.createElement("img", { alt: e, src: n }));
};
GM.defaultProps = { alt: "", className: "" };
GM.propTypes = { alt: Q.string, className: Q.string, height: Q.oneOfType([Q.number, Q.string]).isRequired, src: Q.string.isRequired, width: Q.oneOfType([Q.number, Q.string]).isRequired };
var nme = GM, { useStyleOptions: Mqt } = Vt, WM = ({ alt: e, src: t }) => {
  let [{ bubbleImageHeight: r }] = Mqt();
  return G.createElement(nme, { alt: e, height: r, src: t, width: "100%" });
};
WM.defaultProps = { alt: "" };
WM.propTypes = { alt: Q.string, src: Q.string.isRequired };
var ime = WM, Fqt = /^data:([^,]*?)(;(base64)){0,1},([A-Za-z0-9+/=]+)/u, Hqt = "text/plain;charset=US-ASCII";
function $qt(e) {
  let t = Fqt.exec(e);
  if (!t) return;
  let [, r, , n, i] = t;
  if (n === "base64") return { base64: i, contentType: r || Hqt, encoding: n };
}
function Uqt(e) {
  let t = $qt(e);
  if (t) return new Blob([nM(t.base64)], { type: t.contentType });
}
var ome = ({ attachment: e }) => {
  let t = e.thumbnailUrl || e.contentUrl, r = Uqt(t);
  return r && (t = URL.createObjectURL(r)), G.createElement(ime, { alt: e.name, src: t });
};
ome.propTypes = { attachment: Q.oneOfType([Q.shape({ contentUrl: Q.string.isRequired, name: Q.string, thumbnailUrl: Q.string }), Q.shape({ contentUrl: Q.string, name: Q.string, thumbnailUrl: Q.string.isRequired })]).isRequired };
var Vqt = ome, ame = Nr(({ value: e }) => G.createElement("div", { className: "webchat__link-definitions__badge" }, e));
ame.displayName = "Badge";
var jqt = ame, zqt = ({ className: e }) => G.createElement("svg", { className: Gt("webchat__text-content__open-in-new-window-icon", e), viewBox: "3 3 18 18", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M7.2501 4.50017H10.7495C11.1637 4.50017 11.4995 4.83596 11.4995 5.25017C11.4995 5.62986 11.2173 5.94366 10.8513 5.99332L10.7495 6.00017H7.24974C6.07079 5.99961 5.10349 6.90656 5.00786 8.06112L5.00028 8.22003L5.00312 16.7507C5.00343 17.9415 5.92885 18.9161 7.09966 18.9949L7.25371 19.0001L15.7518 18.9884C16.9415 18.9868 17.9145 18.062 17.9935 16.8923L17.9987 16.7384V13.2321C17.9987 12.8179 18.3345 12.4821 18.7487 12.4821C19.1284 12.4821 19.4422 12.7643 19.4918 13.1303L19.4987 13.2321V16.7384C19.4987 18.7407 17.9293 20.3769 15.9528 20.4829L15.7538 20.4884L7.25827 20.5001L7.05495 20.4949C5.14239 20.3954 3.60895 18.8627 3.50837 16.9502L3.50312 16.7511L3.50089 8.2527L3.50529 8.0502C3.60539 6.13749 5.13867 4.60449 7.05096 4.50527L7.2501 4.50017H10.7495H7.2501ZM13.7481 3.00146L20.3018 3.00197L20.4014 3.01575L20.5022 3.04393L20.559 3.06803C20.6122 3.09122 20.6634 3.12163 20.7111 3.15885L20.7804 3.22156L20.8641 3.32014L20.9183 3.41025L20.957 3.50057L20.9762 3.56476L20.9898 3.62862L20.9992 3.72282L20.9997 10.2554C20.9997 10.6696 20.6639 11.0054 20.2497 11.0054C19.87 11.0054 19.5562 10.7232 19.5065 10.3571L19.4997 10.2554L19.4989 5.56147L12.2797 12.7847C12.0134 13.051 11.5968 13.0753 11.3031 12.8575L11.219 12.7849C10.9527 12.5187 10.9284 12.1021 11.1462 11.8084L11.2188 11.7243L18.4369 4.50146H13.7481C13.3684 4.50146 13.0546 4.21931 13.005 3.85324L12.9981 3.75146C12.9981 3.37177 13.2803 3.05797 13.6464 3.00831L13.7481 3.00146Z", fill: "currentcolor" })), qqt = zqt, ume = Nr(({ badgeName: e, badgeTitle: t, identifier: r, isExternal: n, text: i }) => G.createElement("div", { className: "webchat__link-definitions__list-item-body" }, r ? G.createElement(jqt, { value: r }) : null, G.createElement("div", { className: "webchat__link-definitions__list-item-body-main" }, G.createElement("div", { className: "webchat__link-definitions__list-item-main-text" }, G.createElement("div", { className: "webchat__link-definitions__list-item-text", title: i }, i), n ? G.createElement(qqt, { className: "webchat__link-definitions__open-in-new-window-icon" }) : null), e && G.createElement("div", { className: "webchat__link-definitions__list-item-badge", title: t }, e))));
ume.displayName = "ItemBody";
var HW = ume;
function Yqt(e) {
  try {
    let { host: t, port: r, protocol: n } = new URL(e);
    if (n === "http:" || n === "https:") return r ? t : t.replace(/^www\./iu, "");
  } catch {
  }
  return e;
}
var sme = Nr(({ badgeName: e, badgeTitle: t, identifier: r, onClick: n, text: i, url: o }) => {
  let a = Vo(n), u = mt((s) => {
    let { current: c } = a;
    if (c) {
      let l = new CustomEvent("click");
      c(l), l.defaultPrevented && s.preventDefault();
    }
  }, [a]);
  return o ? G.createElement("a", { className: "webchat__link-definitions__list-item-box webchat__link-definitions__list-item-box--as-link", href: o, onClick: u, rel: "noopener noreferrer", target: "_blank" }, G.createElement(HW, { badgeName: e, badgeTitle: t, identifier: r, isExternal: !0, text: i || Yqt(o) })) : G.createElement("button", { className: "webchat__link-definitions__list-item-box webchat__link-definitions__list-item-box--as-button", onClick: u, type: "button" }, G.createElement(HW, { badgeName: e, badgeTitle: t, identifier: r, text: i }));
});
sme.displayName = "LinkDefinitionItem";
var Gqt = sme, cme = Nr(() => G.createElement("svg", { className: "webchat__link-definitions__header-chevron", fill: "none", height: "10", viewBox: "1 3 10 7", width: "14", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M2.14645 4.64645C2.34171 4.45118 2.65829 4.45118 2.85355 4.64645L6 7.79289L9.14645 4.64645C9.34171 4.45118 9.65829 4.45118 9.85355 4.64645C10.0488 4.84171 10.0488 5.15829 9.85355 5.35355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.14645 5.35355C1.95118 5.15829 1.95118 4.84171 2.14645 4.64645Z", fill: "currentcolor" })));
cme.displayName = "Chevron";
var Wqt = cme, { useLocalizer: Kqt } = Vt, { count: Xqt, map: Jqt } = B1, Zqt = { one: "REFERENCE_LIST_HEADER_ONE", few: "REFERENCE_LIST_HEADER_FEW", many: "REFERENCE_LIST_HEADER_MANY", other: "REFERENCE_LIST_HEADER_OTHER", two: "REFERENCE_LIST_HEADER_TWO" }, lme = ({ accessoryComponentType: e, accessoryProps: t, children: r }) => {
  let [{ linkDefinitions: n }] = pr(), i = Kqt({ plural: !0 })(Zqt, Xqt(r));
  return G.createElement("details", { className: Gt(n, "webchat__link-definitions"), open: !0 }, G.createElement("summary", { className: "webchat__link-definitions__header" }, G.createElement("div", { className: "webchat__link-definitions__header-text" }, i), G.createElement(Wqt, null), G.createElement("div", { className: "webchat__link-definitions__header-filler" }), e && G.createElement("div", { className: "webchat__link-definitions__header-accessory" }, G.createElement(e, t))), G.createElement("div", { className: "webchat__link-definitions__list", role: "list" }, Jqt(r, (o) => G.createElement("div", { className: "webchat__link-definitions__list-item", role: "listitem" }, o))));
};
lme.displayName = "LinkDefinitions";
var Qqt = lme, eYt = ["__proto__", "constructor", "prototype"];
function $W(e) {
  return Object.getOwnPropertyNames(e).filter((t) => !eYt.includes(t));
}
function WL(e) {
  if (e) {
    let t = e["@id"];
    return typeof t == "string" && t.startsWith("_:");
  }
  return !1;
}
function UW(e) {
  return WL(e) && Object.getOwnPropertyNames(e).every((t) => t.startsWith("@"));
}
function VW() {
  let e = /* @__PURE__ */ new Set();
  return (t) => e.has(t) ? !1 : (e.add(t), !0);
}
function tYt(e) {
  let t = /* @__PURE__ */ new Map(), r = [e], n = VW();
  for (; r.length; ) {
    let a = r.shift();
    if (!a) continue;
    let u = $W(a);
    for (let s of u) {
      let c = a[s];
      WL(c) && !UW(c) && t.set(c["@id"], c), n(c) && r.push(c);
    }
  }
  let i = [e], o = VW();
  for (; i.length; ) {
    let a = i.shift();
    if (!a) continue;
    let u = $W(a);
    for (let s of u) {
      let c = a[s];
      if (WL(c) && UW(c)) {
        let l = t.get(c["@id"]);
        l && (a[s] = l);
      } else o(c) && i.push(c);
    }
  }
}
function fme(e) {
  let t = structuredClone(e);
  return tYt(t), RFt(t);
}
var rYt = { close: { get() {
  throw new Error("close cannot be used outside of <ModalDialogComposer>.");
} }, showModal: { get() {
  throw new Error("showModal cannot be used outside of <ModalDialogComposer>.");
} } }, dme = ei(Object.create({}, rYt));
dme.displayName = "ModalDialogComposer";
var pme = dme;
function nYt() {
  return En(pme);
}
function iYt() {
  return nYt().showModal;
}
var hme = Nr(({ headerText: e, markdown: t }) => {
  let [{ renderMarkdown: r }] = pr(), n = Fh("citation modal");
  return G.createElement(jo, null, e && G.createElement("h2", { className: "webchat__citation-modal-dialog__header" }, e), n ? G.createElement("div", { className: Gt("webchat__citation-modal-dialog__body", "webchat__render-markdown", r + ""), dangerouslySetInnerHTML: { __html: n(t) } }) : G.createElement("div", { className: Gt("webchat__render-markdown", r + "") }, t));
});
hme.displayName = "CitationModalContent";
var oYt = hme, aYt = ({ className: e, fillColor: t, hasLock: r }) => G.createElement("svg", { className: Gt(e), height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, r ? G.createElement(jo, null, t && G.createElement("path", { d: "M8.35464 2.14678C8.15946 1.95123 7.84268 1.95105 7.64728 2.14638C6.40416 3.38902 5.02923 4 3.5 4C3.22386 4 3 4.22386 3 4.5V7.50126C3 10.4242 4.35378 12.4971 7 13.6523V10C7 9.06808 7.63739 8.28503 8.5 8.06301V8C8.5 6.34315 9.84315 5 11.5 5C12.0464 5 12.5587 5.14609 13 5.40135V4.5C13 4.22386 12.7761 4 12.5 4C10.9689 4 9.5947 3.38913 8.35464 2.14678ZM9.5 9V8C9.5 6.89543 10.3954 6 11.5 6C12.6046 6 13.5 6.89543 13.5 8V9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H9C8.44771 15 8 14.5523 8 14V10C8 9.44772 8.44772 9 9 9H9.5ZM10.5 8V9H12.5V8C12.5 7.44772 12.0523 7 11.5 7C10.9477 7 10.5 7.44772 10.5 8ZM12.25 12C12.25 11.5858 11.9142 11.25 11.5 11.25C11.0858 11.25 10.75 11.5858 10.75 12C10.75 12.4142 11.0858 12.75 11.5 12.75C11.9142 12.75 12.25 12.4142 12.25 12Z", fill: t }), G.createElement("path", { d: "M7.64728 2.14638C7.84268 1.95105 8.15946 1.95123 8.35464 2.14678C9.5947 3.38913 10.9689 4 12.5 4C12.7761 4 13 4.22386 13 4.5V5.40135C12.6963 5.22567 12.359 5.1017 12 5.04148V4.98121C10.5195 4.86895 9.18521 4.25528 8.00042 3.18917C6.81393 4.25491 5.47941 4.86879 4 4.98118V7.50126C4 8.9349 4.36269 10.0655 5.02127 10.9453C5.49089 11.5727 6.14168 12.1134 7 12.5478V13.6523C4.35378 12.4971 3 10.4242 3 7.50126V4.5C3 4.22386 3.22386 4 3.5 4C5.02923 4 6.40416 3.38902 7.64728 2.14638ZM9.5 8V9H9C8.44772 9 8 9.44772 8 10V14C8 14.5523 8.44771 15 9 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H13.5V8C13.5 6.89543 12.6046 6 11.5 6C10.3954 6 9.5 6.89543 9.5 8ZM10.5 9V8C10.5 7.44772 10.9477 7 11.5 7C12.0523 7 12.5 7.44772 12.5 8V9H10.5ZM11.5 11.25C11.9142 11.25 12.25 11.5858 12.25 12C12.25 12.4142 11.9142 12.75 11.5 12.75C11.0858 12.75 10.75 12.4142 10.75 12C10.75 11.5858 11.0858 11.25 11.5 11.25Z", fill: "currentcolor" })) : G.createElement(jo, null, t && G.createElement("path", { d: "M7.64728 2.14638C7.84268 1.95105 8.15946 1.95123 8.35464 2.14678C9.5947 3.38913 10.9689 4 12.5 4C12.7761 4 13 4.22386 13 4.5V7.50126C13 10.7196 11.3587 12.9075 8.15811 13.9743C8.05548 14.0086 7.94452 14.0086 7.84189 13.9743C4.64126 12.9075 3 10.7196 3 7.50126V4.5C3 4.22386 3.22386 4 3.5 4C5.02923 4 6.40416 3.38902 7.64728 2.14638Z", fill: t }), G.createElement("path", { d: "M7.64728 2.14638C7.84268 1.95105 8.15946 1.95123 8.35464 2.14678C9.5947 3.38913 10.9689 4 12.5 4C12.7761 4 13 4.22386 13 4.5V7.50126C13 10.7196 11.3587 12.9075 8.15811 13.9743C8.05548 14.0086 7.94452 14.0086 7.84189 13.9743C4.64126 12.9075 3 10.7196 3 7.50126V4.5C3 4.22386 3.22386 4 3.5 4C5.02923 4 6.40416 3.38902 7.64728 2.14638ZM8.00042 3.18917C6.81393 4.25491 5.47941 4.86879 4 4.98118V7.50126C4 8.9349 4.36269 10.0655 5.02127 10.9453C5.65858 11.7967 6.62953 12.4885 8 12.9715C9.37047 12.4885 10.3414 11.7967 10.9787 10.9453C11.6373 10.0655 12 8.9349 12 7.50126V4.98121C10.5195 4.86895 9.18521 4.25528 8.00042 3.18917Z", fill: "currentcolor" }))), uYt = aYt, vme = Nr(({ className: e, color: t, isEncrypted: r, name: n, title: i }) => G.createElement("div", { className: Gt("webchat__link-definitions__message-sensitivity-label", { "webchat__link-definitions__message-sensitivity-label--is-encrypted": r }, e), title: tt(() => [n, i].filter(Boolean).join(`

`), [n, i]) }, G.createElement(uYt, { className: "webchat__link-definitions__message-sensitivity-label-icon", fillColor: t, hasLock: r }), G.createElement("span", { className: "webchat__link-definitions__message-sensitivity-label-text" }, n)));
vme.displayName = "MessageSensitivityLabel";
var sYt = vme;
function cYt(e) {
  return e.matches("button");
}
var { useLocalizer: lYt } = Vt;
function fYt(e) {
  var t;
  return ((t = Hp(() => new URL(e))) == null ? void 0 : t.protocol) === "cite:";
}
var Eme = Nr(({ activity: e, markdown: t }) => {
  let [{ citationModalDialog: r, renderMarkdown: n, textContent: i }] = pr(), o = lYt(), a = tt(() => fme(e.entities || []), [e.entities]), u = Fh("message activity"), s = iYt(), c = tt(() => Efe(a), [a]), l = o("CITATION_MODEL_DIALOG_ALT");
  if (!u) throw new Error("botframework-webchat: assert failed for renderMarkdownAsHTML");
  let f = tt(() => ({ __html: t ? u(t) : "" }), [u, t]), d = tt(() => Cve(t).children.filter((S) => S.type === "definition"), [t]), p = mt((S, A, O) => {
    s(() => G.createElement(oYt, { headerText: S, markdown: A }), { "aria-label": O || S || l, className: Gt("webchat__citation-modal-dialog", r) });
  }, [r, l, s]), v = tt(() => Object.freeze(d.map((S) => {
    var P;
    let A = (P = c == null ? void 0 : c.citation) == null ? void 0 : P.map(TS).find(({ position: U }) => "" + U === S.identifier);
    if (A) return { claim: A, key: S.url, handleClick: A != null && A.appearance && !A.appearance.url ? () => p(A.appearance.name ?? S.title, A.appearance.text, A.alternateName) : void 0, markdownDefinition: S, url: A != null && A.appearance ? A.appearance.url : S.url };
    let O = a.filter(({ type: U }) => U === "https://schema.org/Claim").map(TS).find(({ "@id": U }) => U === S.url);
    return O ? { claim: O, key: S.url, handleClick: fYt(O["@id"]) ? () => p(O.name ?? S.title, O.text, O.alternateName) : void 0, markdownDefinition: S } : { key: S.url, markdownDefinition: S, url: S.url };
  })), [a, d, c, p]), h = Vo(v), E = mt((S) => {
    let A = S.target, O = cYt(A) ? A : A.closest("button");
    if (!O || !A.contains(O)) return;
    let P = h.current.find(({ key: U }) => U === O.value);
    P != null && P.handleClick && (S.preventDefault(), S.stopPropagation(), P.handleClick());
  }, [h]), m = tt(() => {
    var A;
    let S = c == null ? void 0 : c.usageInfo;
    if (S) {
      let { pattern: O } = S, P = !!((A = S.keywords) != null && A.find((U) => U === "encrypted-content"));
      return { color: O && O.inDefinedTermSet === "https://www.w3.org/TR/css-color-4/" && O.name === "color" && O.termCode, isEncrypted: P, name: S.name, title: S.description };
    }
  }, [c]), g = (S) => {
    var A, O, P;
    return ((A = S.claim) == null ? void 0 : A.name) ?? ((P = (O = S.claim) == null ? void 0 : O.appearance) == null ? void 0 : P.name) ?? S.markdownDefinition.title;
  }, y = (S) => {
    var A, O, P;
    return (P = (O = (A = S.claim) == null ? void 0 : A.appearance) == null ? void 0 : O.usageInfo) == null ? void 0 : P.name;
  }, _ = (S) => {
    var A, O, P;
    return (P = (O = (A = S.claim) == null ? void 0 : A.appearance) == null ? void 0 : O.usageInfo) == null ? void 0 : P.description;
  };
  return G.createElement("div", { className: Gt("webchat__text-content", "webchat__text-content--is-markdown", i + "") }, G.createElement("div", { className: Gt("webchat__text-content__markdown", n + ""), dangerouslySetInnerHTML: f, onClick: E }), !!v.length && G.createElement(Qqt, { accessoryComponentType: m && sYt, accessoryProps: m }, v.map((S) => G.createElement(Gqt, { badgeName: y(S), badgeTitle: `${y(S) ?? ""}

${_(S) ?? ""}`.trim(), identifier: S.markdownDefinition.label, key: S.key, onClick: S.handleClick, text: g(S), url: S.url }))));
});
Eme.displayName = "MarkdownTextContent";
var dYt = Eme, mme = Nr(({ text: e }) => {
  let [{ textContent: t }] = pr();
  return G.createElement(jo, null, (e || "").split(`
`).map((r) => G.createElement("p", { className: Gt("webchat__text-content", "webchat__text-content--is-plain", t + ""), key: r }, r.trim())));
});
mme.displayName = "PlainTextContent";
var pYt = mme, KM = Nr(({ activity: e, contentType: t = "text/plain", text: r }) => {
  let n = !!Fh("message activity");
  return r ? t === "text/markdown" && n ? G.createElement(dYt, { activity: e, markdown: r }) : G.createElement(pYt, { text: r }) : null;
});
KM.defaultProps = { contentType: "text/plain" };
KM.displayName = "TextContent";
var gme = KM, Tme = Nr(({ activity: e, attachment: { content: t, contentType: r } }) => G.createElement(gme, { activity: e, contentType: r, text: t }));
Tme.displayName = "TextAttachment";
var hYt = Tme, XM = ({ alt: e, autoPlay: t, loop: r, poster: n, src: i }) => {
  let [{ videoContent: o }] = pr();
  return G.createElement("video", { "aria-label": e, autoPlay: t, className: o, controls: !0, loop: r, poster: n, src: i });
};
XM.defaultProps = { alt: "", autoPlay: !1, loop: !1, poster: "" };
XM.propTypes = { alt: Q.string, autoPlay: Q.bool, loop: Q.bool, poster: Q.string, src: Q.string.isRequired };
var yme = XM, { useLocalizer: vYt } = Vt, JM = ({ alt: e, autoPlay: t, embedID: r, loop: n }) => {
  let [{ vimeoContent: i }] = pr(), o = vYt(), a = new URLSearchParams({ autoplay: t ? "1" : "0", badge: "0", byline: "0", loop: n ? "1" : "0", portrait: "0", title: "0" }).toString(), u = o("ATTACHMENT_VIDEO");
  return G.createElement("iframe", { allowFullScreen: !0, "aria-label": e, className: i, sandbox: "allow-same-origin allow-scripts", src: `https://player.vimeo.com/video/${encodeURI(r)}?${a}`, title: u });
};
JM.defaultProps = { alt: "", autoPlay: !1, loop: !1 };
JM.propTypes = { alt: Q.string, autoPlay: Q.bool, embedID: Q.string.isRequired, loop: Q.bool };
var _me = JM, { useLocalizer: EYt } = Vt, ZM = ({ alt: e, autoPlay: t, embedID: r, loop: n }) => {
  let [{ youTubeContent: i }] = pr(), o = EYt(), a = new URLSearchParams({ autoplay: t ? "1" : "0", loop: n ? "1" : "0", modestbranding: "1" }).toString(), u = o("ATTACHMENT_VIDEO");
  return G.createElement("iframe", { allowFullScreen: !0, "aria-label": e, className: i, sandbox: "allow-same-origin allow-scripts", src: `https://youtube.com/embed/${r}?${a}`, title: u });
};
ZM.defaultProps = { alt: "", autoPlay: !1, loop: !1 };
ZM.propTypes = { alt: Q.string, autoPlay: Q.bool, embedID: Q.string.isRequired, loop: Q.bool };
var KL = ZM, mYt = "youtube.com", gYt = "www.youtube.com", TYt = "youtu.be", yYt = "www.youtu.be", _Yt = "vimeo.com", AYt = "www.vimeo.com";
function SYt(e) {
  let t;
  typeof URL == "function" ? t = new URL(e) : (t = document.createElement("a"), t.setAttribute("href", e));
  let { hostname: r, pathname: n, search: i } = t;
  return { hostname: r, pathname: n, search: i };
}
var QM = ({ alt: e, autoPlay: t, loop: r, poster: n, src: i }) => {
  let { hostname: o, pathname: a, search: u } = SYt(i), s = a.split("/").pop(), c = new URLSearchParams(u);
  switch (o) {
    case _Yt:
    case AYt:
      return G.createElement(_me, { alt: e, autoPlay: t, embedID: s, loop: r });
    case mYt:
    case gYt:
      return G.createElement(KL, { alt: e, autoPlay: t, embedID: c.get("v"), loop: r });
    case TYt:
    case yYt:
      return G.createElement(KL, { alt: e, autoPlay: t, embedID: s, loop: r });
    default:
      return G.createElement(yme, { alt: e, autoPlay: t, loop: r, poster: n, src: i });
  }
};
QM.defaultProps = { alt: "", autoPlay: !1, loop: !1, poster: "" };
QM.propTypes = { alt: Q.string, autoPlay: Q.bool, loop: Q.bool, poster: Q.string, src: Q.string.isRequired };
var Ame = QM, bYt = { display: "flex", flexDirection: "column" }, Sme = ({ attachment: e }) => {
  let [{ videoAttachment: t }] = pr(), r = Tn()(bYt) + "";
  return G.createElement("div", { className: Gt(r, t + "") }, G.createElement(Ame, { alt: e.name, src: e.contentUrl }));
};
Sme.propTypes = { attachment: Q.shape({ contentUrl: Q.string.isRequired, name: Q.string }).isRequired };
var CYt = Sme;
function IYt(e) {
  return e.contentType.startsWith("text/");
}
function OYt() {
  return [() => (e) => (...t) => {
    let [{ activity: r, activity: { from: { role: n = void 0 } = {} } = {}, attachment: i, attachment: { contentType: o = void 0, contentUrl: a = void 0, thumbnailUrl: u = void 0 } = {} }] = t, s = IYt(i);
    return (s ? !i.content : n === "user" && !u) ? G.createElement(FW, { activity: r, attachment: i }) : /^audio\//u.test(o) ? G.createElement(wqt, { attachment: i }) : /^image\//u.test(o) ? G.createElement(Vqt, { attachment: i }) : /^video\//u.test(o) ? G.createElement(CYt, { attachment: i }) : a || o === "application/octet-stream" ? G.createElement(FW, { activity: r, attachment: i }) : s ? G.createElement(hYt, { activity: r, attachment: i }) : e(...t);
  }];
}
function $h() {
  return [ho().webSpeechPonyfill];
}
function RYt() {
  let [{ resumeAudioContext: e }] = $h();
  return () => e && e();
}
function bme() {
  let { dictateAbortable: e, setDictateAbortable: t } = ho();
  return [e, t];
}
var { useActivities: wYt, useDictateInterims: PYt, useDictateState: DYt, useDisabled: xYt, useEmitTypingIndicator: NYt, useLanguage: LYt, useSendBoxValue: BYt, useSendTypingIndicator: kYt, useShouldSpeakIncomingActivity: MYt, useStopDictate: FYt, useSubmitSendBox: HYt } = Vt, { DictateState: { DICTATING: Nv, IDLE: XR, STARTING: iA } } = YT, eF = ({ onError: e }) => {
  let [, t] = bme(), [, r] = PYt(), [, n] = BYt(), [, i] = MYt(), [{ SpeechGrammarList: o, SpeechRecognition: a } = {}] = $h(), [u] = wYt(), [s] = DYt(), [c] = xYt(), [l] = kYt(), [f] = LYt("speech"), d = NYt(), p = RYt(), v = wFt(), h = FYt(), E = HYt(), m = tt(() => u.filter(({ channelData: { speak: S } = {} }) => S).length, [u]), g = mt(({ result: { confidence: S, transcript: A } = {} }) => {
    (s === Nv || s === iA) && (r([]), v(XR), h(), A && (n(A), E("speech", { channelData: { speech: { alternatives: [{ confidence: S, transcript: A }] } } }), i(!0)));
  }, [s, r, v, h, n, E, i]), y = mt(({ abortable: S, results: A = [] }) => {
    if (s === Nv || s === iA) {
      let O = A.map(({ transcript: P }) => P);
      t(S), r(O), v(Nv), l && d();
    }
  }, [s, d, l, t, r, v]), _ = mt((S) => {
    s !== XR && v(XR), (s === Nv || s === iA) && h(), e && e(S);
  }, [s, e, v, h]);
  return nr(() => (window.addEventListener("pointerdown", p), () => window.removeEventListener("pointerdown", p)), [p]), G.createElement(sM, { lang: f, onDictate: g, onError: _, onProgress: y, speechGrammarList: o, speechRecognition: a, started: !c && (s === iA || s === Nv) && !m });
};
eF.defaultProps = { onError: void 0 };
eF.propTypes = { onError: Q.func };
var $Yt = eF, { useLocalizer: UYt } = Vt, tF = ({ error: e, type: t }) => {
  let [{ errorBox: r }] = pr(), n = UYt();
  return G.createElement(G.Fragment, null, G.createElement(ya, { text: n("ACTIVITY_ERROR_BOX_TITLE") }), G.createElement("div", { className: r }, G.createElement("div", null, t), G.createElement("details", null, G.createElement("summary", null, e.message), G.createElement("pre", null, e.stack))));
};
tF.defaultProps = { type: "" };
tF.propTypes = { error: Q.instanceOf(Error).isRequired, type: Q.string };
var VYt = tF;
function Cme(e) {
  let t = /* @__PURE__ */ new Map();
  return { get(r) {
    return t.get(r);
  }, set(r, n) {
    let i = t.get(r);
    i && e.removeEventListener(r, i), n ? (e.addEventListener(r, n), t.set(r, n)) : t.delete(r);
  } };
}
var jW = class extends Event {
  constructor(e, t) {
    super(e), this._utterance = t;
  }
  get charIndex() {
    return 0;
  }
  get elapsedTime() {
    return 0;
  }
  get name() {
  }
  get utterance() {
    return this._utterance;
  }
}, jYt = class extends EventTarget {
  constructor(t) {
    super(), this._lang = "en-US", this._pitch = 1, this._rate = 1, this._text = t, this._voice = null, this._volume = 1, this._shim = Cme(this);
  }
  get lang() {
    return this._lang;
  }
  set lang(t) {
    this._lang = t;
  }
  get pitch() {
    return this._pitch;
  }
  set pitch(t) {
    this._pitch = t;
  }
  get rate() {
    return this._rate;
  }
  set rate(t) {
    this._rate = t;
  }
  get text() {
    return this._text;
  }
  set text(t) {
    this._text = t;
  }
  get voice() {
    return this._voice;
  }
  set voice(t) {
    this._voice = t;
  }
  get volume() {
    return this._volume;
  }
  set volume(t) {
    this._volume = t;
  }
  get onboundary() {
    return this._shim.get("boundary");
  }
  set onboundary(t) {
    this._shim.set("boundary", t);
  }
  get onend() {
    return this._shim.get("end");
  }
  set onend(t) {
    this._shim.set("end", t);
  }
  get onerror() {
    return this._shim.get("error");
  }
  set onerror(t) {
    this._shim.set("error", t);
  }
  get onmark() {
    return this._shim.get("mark");
  }
  set onmark(t) {
    this._shim.set("mark", t);
  }
  get onpause() {
    return this._shim.get("pause");
  }
  set onpause(t) {
    this._shim.set("pause", t);
  }
  get onresume() {
    return this._shim.get("resume");
  }
  set onresume(t) {
    this._shim.set("resume", t);
  }
  get onstart() {
    return this._shim.get("start");
  }
  set onstart(t) {
    this._shim.set("start", t);
  }
}, zYt = class {
  get default() {
    return !0;
  }
  get lang() {
    return "en-US";
  }
  get localService() {
    return !0;
  }
  get name() {
    return "English (US)";
  }
  get voiceURI() {
    return "English (US)";
  }
}, qYt = class extends EventTarget {
  constructor() {
    super(), this._shim = Cme(this);
  }
  get paused() {
    return !1;
  }
  get pending() {
    return !1;
  }
  get speaking() {
    return !1;
  }
  cancel() {
  }
  getVoices() {
    return [new zYt()];
  }
  pause() {
    throw new Error("pause is not implemented.");
  }
  resume() {
    throw new Error("resume is not implemented.");
  }
  speak(t) {
    t.dispatchEvent(new jW("start", t)), t.dispatchEvent(new jW("end", t));
  }
  get onvoiceschanged() {
    return this._shim.get("voiceschanged");
  }
  set onvoiceschanged(t) {
    this._shim.set("voiceschanged", t);
  }
}, Ime = new qYt();
function YYt() {
  function e(r) {
    return new Promise(function(n, i) {
      let o = new FileReader();
      o.onerror = function(a) {
        i(a.error || new Error(a.message));
      }, o.onloadend = function() {
        n(o.result);
      }, o.readAsDataURL(r);
    });
  }
  function t(r, n, i, o) {
    if (r < i && n < o) return { height: n, width: r };
    let a = r / n;
    return a > i / o ? { height: i / a, width: i } : { height: o, width: o * a };
  }
  onmessage = function(r) {
    let n = r.data, i = n.arrayBuffer, o = n.maxHeight, a = n.maxWidth, u = n.type, s = n.quality, c = r.ports[0];
    return Promise.resolve().then(function() {
      return createImageBitmap(new Blob([i]), { resizeQuality: "high" });
    }).then(function(l) {
      let f = t(l.width, l.height, a, o), d = f.height, p = f.width, v = new OffscreenCanvas(p, d);
      return v.getContext("2d").drawImage(l, 0, 0, p, d), (v.convertToBlob || v.toBlob).bind(v)({ type: u, quality: s });
    }).then(function(l) {
      return e(l);
    }).then(function(l) {
      return c.postMessage({ result: l });
    }).catch(function(l) {
      console.error(l), c.postMessage({ error: { message: l.message, stack: l.stack } });
    });
  }, postMessage("ready");
}
function Ome(e) {
  let t = new Blob([`(${e})()`], { type: "text/javascript" }), r = window.URL.createObjectURL(t);
  return new Promise((n, i) => {
    let o = new Worker(r);
    o.onerror = ({ error: a, message: u }) => i(a || new Error(u)), o.onmessage = ({ data: a }) => a === "ready" && n(o);
  }).finally(() => {
    window.URL.revokeObjectURL(r);
  });
}
var Lv;
async function GYt() {
  let e;
  return Lv ? e = await Lv : (Lv = Ome(YYt), e = await Lv, e.addEventListener("error", () => {
    Lv = null, e.terminate();
  })), e;
}
var WYt = () => {
  let e = typeof window.OffscreenCanvas < "u" && (typeof window.OffscreenCanvas.prototype.convertToBlob < "u" || typeof window.OffscreenCanvas.prototype.toBlob < "u"), t;
  if (e) try {
    new OffscreenCanvas(1, 1).getContext("2d"), t = !0;
  } catch {
    t = !1;
  }
  return typeof window.createImageBitmap < "u" && e && t;
}, zW;
function KYt() {
  return zW || (zW = (async () => {
    if (typeof window.MessageChannel > "u" || typeof window.Worker > "u") return !1;
    let e;
    try {
      e = await Ome('function(){postMessage("ready")}');
    } catch {
      return !1;
    }
    return e.terminate(), !0;
  })());
}
var qW;
function Rme() {
  return qW || (qW = (async () => {
    try {
      return (await Promise.all([WYt(), KYt()])).every((e) => e);
    } catch {
      return !1;
    }
  })());
}
function XYt(e, t, r, n, i) {
  return new Promise((o, a) => {
    let { port1: u, port2: s } = new MessageChannel();
    u.onmessage = ({ data: c }) => {
      if ("error" in c) {
        let { message: l, stack: f } = c.error, d = new Error(l);
        d.stack = f, a(d);
      } else o(new URL(c.result));
      u.close(), s.close();
    }, Promise.all([e.arrayBuffer(), GYt()]).then(([c, l]) => l.postMessage({ arrayBuffer: c, maxHeight: r, maxWidth: t, quality: i, type: n }, [c, s]));
  });
}
var { useTrackDimension: JYt } = Vt, ZYt = () => {
  let [e] = $h(), t = JYt(), r = !!e.SpeechRecognition, n = e.speechSynthesis && e.speechSynthesis !== Ime;
  return nr(() => {
    t("capability:downscaleImage:workerType", Rme() ? "web worker" : "main"), t("capability:renderer", "html"), t("prop:speechRecognition", !!r + ""), t("prop:speechSynthesis", !!n + "");
  }, [t, r, n]), !1;
}, QYt = ZYt, { useDirection: eGt, useStyleOptions: tGt } = Vt, rGt = { "&.webchat__bubble": { display: "flex", position: "relative", "& .webchat__bubble__nub-pad": { flexShrink: 0 }, "& .webchat__bubble__content": { flexGrow: 1, overflow: "hidden" } } };
function nGt(e, t, r, n = !1) {
  if (typeof e != "number") return !1;
  let i = e / 2, o = t / 2, a = r === "bot" ? "" : `translate(${i} 0) scale(-1 1) translate(${-i} 0)`, u = n ? `translate(0 ${i}) scale(1 -1) translate(0 ${-i})` : "", s = [e, o].join(" "), c = [t, o].join(" "), l = [e + t, e + o].join(" ");
  return G.createElement("svg", { className: "webchat__bubble__nub", version: "1.1", viewBox: `0 0 ${e} ${e}`, xmlns: "http://www.w3.org/2000/svg" }, G.createElement("g", { transform: `${a} ${u}` }, G.createElement("path", { className: "webchat__bubble__nub-outline", d: `M${s} L${c} L${l}` })));
}
var YC = ({ "aria-hidden": e, children: t, className: r, fromUser: n, nub: i }) => {
  let [{ bubble: o }] = pr(), [a] = eGt(), [{ bubbleBorderWidth: u, bubbleFromUserBorderWidth: s, bubbleFromUserNubSize: c, bubbleNubSize: l, bubbleNubOffset: f, bubbleFromUserNubOffset: d }] = tGt(), p = Tn()(rGt) + "", { borderWidth: v, nubOffset: h, nubSize: E, side: m } = n ? { borderWidth: s, nubOffset: d, nubSize: c, side: "user" } : { borderWidth: u, nubOffset: f, nubSize: l, side: "bot" };
  return G.createElement("div", { "aria-hidden": e, className: Gt("webchat__bubble", { "webchat__bubble--from-user": n, "webchat__bubble--hide-nub": i !== !0 && i !== !1, "webchat__bubble--nub-on-top": Gp(h), "webchat__bubble--rtl": a === "rtl", "webchat__bubble--show-nub": i === !0 }, p, o + "", (r || "") + "") }, G.createElement("div", { className: "webchat__bubble__nub-pad" }), G.createElement("div", { className: "webchat__bubble__content" }, t), i === !0 && nGt(E, v, m, !Gp(h)));
};
YC.defaultProps = { "aria-hidden": void 0, children: void 0, className: "", fromUser: !1, nub: !1 };
YC.propTypes = { "aria-hidden": Q.bool, children: Q.any, className: Q.string, fromUser: Q.bool, nub: Q.oneOf([!0, !1, "hidden"]) };
YC.displayName = "Bubble";
var W1 = Nr(YC), { useDirection: iGt, useLocalizer: oGt } = Vt, rF = ({ activity: e, attachment: t, className: r, fromUser: n, hasAvatar: i, hideNub: o, index: a, renderAttachment: u, showAvatar: s, showNub: c }) => {
  let [l] = iGt(), f = oGt(), [{ carouselFilmStripAttachment: d }] = pr(), p = f(n ? "ACTIVITY_YOU_ATTACHED_ALT" : "ACTIVITY_BOT_ATTACHED_ALT");
  return G.createElement("li", { "aria-roledescription": "attachment", className: Gt("webchat__carousel-filmstrip-attachment", { "webchat__carousel-filmstrip-attachment--hide-avatar": i && !s, "webchat__carousel-filmstrip-attachment--hide-nub": o, "webchat__carousel-filmstrip-attachment--rtl": l === "rtl", "webchat__carousel-filmstrip-attachment--show-avatar": s, "webchat__carousel-filmstrip-attachment--show-nub": c }, "react-film__filmstrip__item", d + "", (r || "") + ""), role: "listitem", tabIndex: 0 }, G.createElement(ya, { text: p }), G.createElement(W1, { fromUser: n, key: a, nub: !1 }, u({ activity: e, attachment: t }), G.createElement("div", { className: "webchat__carousel-filmstrip-attachment--focus" })));
};
rF.defaultProps = { className: "" };
rF.propTypes = { activity: Q.shape({ attachments: Q.array, from: Q.shape({ role: Q.string.isRequired }).isRequired, text: Q.string, textFormat: Q.string, timestamp: Q.string }).isRequired, attachment: Q.shape({ content: Q.any }).isRequired, className: Q.string, fromUser: Q.any.isRequired, hasAvatar: Q.any.isRequired, hideNub: Q.bool.isRequired, index: Q.number.isRequired, renderAttachment: Q.func.isRequired, showAvatar: Q.bool.isRequired, showNub: Q.bool.isRequired };
var aGt = rF, { useAvatarForBot: uGt, useAvatarForUser: sGt, useDirection: cGt, useLocalizer: lGt, useStyleOptions: fGt } = Vt, dGt = { "&.webchat__carousel-filmstrip": { display: "flex", flexDirection: "column", MsOverflowStyle: "none", overflowX: "scroll", overflowY: "hidden", position: "relative", touchAction: "manipulation", WebkitOverflowScrolling: "touch", "&::-webkit-scrollbar": { display: "none" }, "& .webchat__carousel-filmstrip__alignment-pad": { flexShrink: 0 }, "& .webchat__carousel-filmstrip-attachment": { flex: 1 }, "& .webchat__carousel-filmstrip__attachments": { display: "flex", listStyleType: "none", margin: 0, padding: 0 }, "& .webchat__carousel-filmstrip__avatar": { flexShrink: 0 }, "& .webchat__carousel-filmstrip__avatar-gutter": { display: "flex", flexDirection: "column", flexShrink: 0 }, "& .webchat__carousel-filmstrip__complimentary": { display: "flex" }, "& .webchat__carousel-filmstrip__complimentary-content": { display: "flex", flexGrow: 1, flexDirection: "column" }, "& .webchat__carousel-filmstrip__content": { display: "flex", flexGrow: 1, flexDirection: "column" }, "& .webchat__carousel-filmstrip__filler": { flexGrow: 1e4, flexShrink: 1 }, "& .webchat__carousel-filmstrip__main": { display: "flex" }, "& .webchat__carousel-filmstrip__message": { display: "flex" }, "& .webchat__carousel-filmstrip__nub-pad": { flexShrink: 0 }, "& .webchat__carousel-filmstrip__status": { display: "flex" } } }, nF = ({ activity: e, className: t, hideTimestamp: r, renderActivityStatus: n, renderAttachment: i, renderAvatar: o, showCallout: a }) => {
  let [{ bubbleNubOffset: u, bubbleNubSize: s, bubbleFromUserNubOffset: c, bubbleFromUserNubSize: l }] = fGt(), [{ carouselFilmStrip: f }] = pr(), [{ initials: d }] = uGt(), [{ initials: p }] = sGt(), [v] = cGt(), h = lGt(), E = Tn()(dGt) + "", m = typeof n == "function", g = Uve(), y = Vve(), { attachments: _ = [], channelData: { messageBack: { displayText: S } = {} } = {}, from: { role: A } = {}, text: O, textFormat: P } = e, U = S || O, z = A === "user", k = (z ? h("ACTIVITY_YOU_SAID_ALT") : h("ACTIVITY_BOT_SAID_ALT", d || "")).replace(/\s{2,}/gu, " "), H = z ? p : d, B = z ? c : u, x = z ? l : s, D = z ? d : p, w = z ? s : l, $ = H || typeof H == "string", X = D || typeof D == "string", V = typeof x == "number", F = typeof w == "number", le = Gp(B), ae = !X && F, ne = a && $ && !!o, ve = a && V && (le || !_.length), Ie = V && !ve;
  return G.createElement("div", { className: Gt("webchat__carousel-filmstrip", { "webchat__carousel-filmstrip--extra-trailing": ae, "webchat__carousel-filmstrip--hide-avatar": $ && !ne, "webchat__carousel-filmstrip--hide-nub": Ie, "webchat__carousel-filmstrip--no-message": !U, "webchat__carousel-filmstrip--rtl": v === "rtl", "webchat__carousel-filmstrip--show-avatar": ne, "webchat__carousel-filmstrip--show-nub": ve, "webchat__carousel-filmstrip--top-callout": le }, "react-film__filmstrip", E, f + "", (t || "") + ""), ref: y }, G.createElement("div", { className: "webchat__carousel-filmstrip__main" }, G.createElement("div", { className: "webchat__carousel-filmstrip__avatar-gutter" }, ne && o({ activity: e })), G.createElement("div", { className: "webchat__carousel-filmstrip__content" }, !!U && G.createElement("div", { "aria-roledescription": "message", className: "webchat__carousel-filmstrip__message", role: "group" }, G.createElement(ya, { text: k }), G.createElement(W1, { className: "webchat__carousel-filmstrip__bubble", fromUser: z, nub: ve || ($ || V) && "hidden" }, i({ activity: e, attachment: { content: U, contentType: wM(P) } })), G.createElement("div", { className: "webchat__carousel-filmstrip__filler" })), G.createElement("div", { className: "webchat__carousel-filmstrip__complimentary" }, G.createElement("div", { className: "webchat__carousel-filmstrip__nub-pad" }), G.createElement("div", { className: "webchat__carousel-filmstrip__complimentary-content c" }, G.createElement("ul", { className: "webchat__carousel-filmstrip__attachments react-film__filmstrip__list", ref: g }, _.map((Oe, xe) => G.createElement(aGt, { activity: e, attachment: Oe, fromUser: z, hasAvatar: $, hideNub: Ie, index: xe, key: xe, renderAttachment: i, showAvatar: ne, showNub: ve })))))), G.createElement("div", { className: "webchat__carousel-filmstrip__alignment-pad" })), m && G.createElement("div", { className: "webchat__carousel-filmstrip__status" }, G.createElement("div", { className: "webchat__carousel-filmstrip__avatar-gutter" }), G.createElement("div", { className: "webchat__carousel-filmstrip__nub-pad" }), n({ hideTimestamp: r })));
};
nF.defaultProps = { className: "", hideTimestamp: !1, renderActivityStatus: !1, renderAvatar: !1, showCallout: !1 };
nF.propTypes = { activity: Q.shape({ attachments: Q.array, channelData: Q.shape({ messageBack: Q.shape({ displayText: Q.string }) }), from: Q.shape({ role: Q.string.isRequired }).isRequired, text: Q.string, textFormat: Q.string, timestamp: Q.string }).isRequired, className: Q.string, hideTimestamp: Q.bool, renderActivityStatus: Q.oneOfType([Q.oneOf([!1]), Q.func]), renderAttachment: Q.func.isRequired, renderAvatar: Q.oneOfType([Q.oneOf([!1]), Q.func]), showCallout: Q.bool };
var pGt = nF, { useDirection: wme, useLocalizer: hGt } = Vt, vGt = { "&.webchat__carousel-layout": { overflow: "hidden", position: "relative" } }, hy = ({ activity: e, hideTimestamp: t, renderActivityStatus: r, renderAttachment: n, renderAvatar: i, showCallout: o }) => {
  let [{ carouselFlipper: a }] = pr(), [{ root: u }] = Kve(), [s] = wme(), [c] = hM(), [l] = vM(), f = s === "rtl" ? ">" : "<", d = hGt(), p = s === "rtl" ? "<" : ">", v = Tn()(vGt) + "", h = d("CAROUSEL_FLIPPER_NEXT_ALT"), E = d("CAROUSEL_FLIPPER_PREVIOUS_ALT"), m = s === "rtl" ? h : E, g = s === "rtl" ? E : h;
  return G.createElement("div", { className: Gt("webchat__carousel-layout", v, a + "", u) }, G.createElement("div", { className: Gt("react-film__main", { "react-film__main--scrolling": l }) }, G.createElement(pGt, { activity: e, hideTimestamp: t, renderActivityStatus: r, renderAttachment: n, renderAvatar: i, showCallout: o }), c !== "100%" && G.createElement(G.Fragment, null, G.createElement(qp, { "aria-label": m, blurFocusOnClick: !0, mode: "left" }, f), G.createElement(qp, { "aria-label": g, blurFocusOnClick: !0, mode: "right" }, p))));
};
hy.defaultProps = { hideTimestamp: !1, renderActivityStatus: !1, renderAvatar: !1, showCallout: !0 };
hy.propTypes = { activity: Q.shape({ attachments: Q.array }).isRequired, hideTimestamp: Q.bool, renderActivityStatus: Q.oneOfType([Q.oneOf([!1]), Q.func]), renderAttachment: Q.func.isRequired, renderAvatar: Q.oneOfType([Q.oneOf([!1]), Q.func]), showCallout: Q.bool };
var iF = (e) => {
  let { activity: { attachments: t = [] } = {} } = e, [r] = wme(), [n] = MM(), i = tt(() => EM({ cursor: null }), []);
  return G.createElement(FC, { dir: r, nonce: n, numItems: t.length, styleSet: i }, G.createElement(hy, { ...e }));
};
iF.defaultProps = { ...hy.defaultProps };
iF.propTypes = { ...hy.propTypes };
var EGt = Nr(iF), { useAvatarForBot: mGt, useAvatarForUser: gGt, useLocalizer: TGt, useStyleOptions: yGt } = Vt, _Gt = { "&.webchat__stacked-layout": { position: "relative", "& .webchat__stacked-layout__attachment-row, & .webchat__stacked-layout__main, & .webchat__stacked-layout__message-row, & .webchat__stacked-layout__status": { display: "flex" }, "& .webchat__stacked-layout__alignment-pad": { flexShrink: 0 }, "& .webchat__stacked-layout__attachment": { width: "100%" }, "& .webchat__stacked-layout__avatar-gutter": { display: "flex", flexDirection: "column", flexShrink: 0 }, "&.webchat__stacked-layout--from-user": { "& .webchat__stacked-layout__attachment-row, & .webchat__stacked-layout__main, & .webchat__stacked-layout__message-row, & .webchat__stacked-layout__status": { flexDirection: "row-reverse" } }, "& .webchat__stacked-layout__content": { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }, "& .webchat__stacked-layout__nub-pad": { flexShrink: 0 } } }, oF = ({ activity: e, hideTimestamp: t, renderActivityStatus: r, renderAttachment: n, renderAvatar: i, showCallout: o }) => {
  var le, ae;
  let [a] = yGt(), [{ initials: u }] = mGt(), [{ initials: s }] = gGt(), [{ stackedLayout: c }] = pr(), l = $C("webchat__stacked-layout__id"), f = TGt(), d = Tn()(_Gt) + "", { bubbleNubOffset: p, bubbleNubSize: v, bubbleFromUserNubOffset: h, bubbleFromUserNubSize: E } = a, m = e.type === "message", g = m && e.attachments || [], y = e.from.role === "user", _ = m && ((ae = (le = e.channelData) == null ? void 0 : le.messageBack) == null ? void 0 : ae.displayText) || "", S = m ? _ || e.text : "", A = f(y ? "ACTIVITY_YOU_ATTACHED_ALT" : "ACTIVITY_BOT_ATTACHED_ALT"), O = (y ? f("ACTIVITY_YOU_SAID_ALT") : f("ACTIVITY_BOT_SAID_ALT", u || "")).replace(/\s{2,}/gu, " "), P = y ? s : u, U = y ? h : p, z = y ? E : v, k = y ? u : s, H = y ? v : E, B = P || typeof P == "string", x = k || typeof k == "string", D = typeof z == "number", w = typeof H == "number", $ = Gp(U), X = !x && w, V = o && B && !!i, F = o && D && ($ || !(g != null && g.length));
  return G.createElement("div", { "aria-labelledby": S ? l : void 0, className: Gt("webchat__stacked-layout", d, c + "", { "webchat__stacked-layout--extra-trailing": X, "webchat__stacked-layout--from-user": y, "webchat__stacked-layout--hide-avatar": B && !V, "webchat__stacked-layout--hide-nub": D && !F, "webchat__stacked-layout--no-message": !S, "webchat__stacked-layout--show-avatar": V, "webchat__stacked-layout--show-nub": F, "webchat__stacked-layout--top-callout": $ }) }, G.createElement("div", { className: "webchat__stacked-layout__main" }, G.createElement("div", { className: "webchat__stacked-layout__avatar-gutter" }, V && i()), G.createElement("div", { className: "webchat__stacked-layout__content" }, !!S && G.createElement("div", { "aria-roledescription": "message", className: "webchat__stacked-layout__message-row", id: l, role: "group" }, G.createElement(ya, { text: O }), G.createElement(W1, { className: "webchat__stacked-layout__message", fromUser: y, nub: F || (B || D ? "hidden" : !1) }, G.createElement(_fe, { activity: e }, n({ activity: e, attachment: m ? { content: S, contentType: wM(e.textFormat) } : void 0 })))), g.map((ne, ve) => G.createElement("div", { "aria-roledescription": "attachment", className: Gt("webchat__stacked-layout__attachment-row", { "webchat__stacked-layout__attachment-row--first": !ve }), key: ve, role: "group" }, G.createElement(ya, { text: A }), G.createElement(W1, { className: "webchat__stacked-layout__attachment", fromUser: y, key: ve, nub: B || D ? "hidden" : !1 }, n({ activity: e, attachment: ne }))))), G.createElement("div", { className: "webchat__stacked-layout__alignment-pad" })), typeof r == "function" && G.createElement("div", { className: "webchat__stacked-layout__status" }, G.createElement("div", { className: "webchat__stacked-layout__avatar-gutter" }), G.createElement("div", { className: "webchat__stacked-layout__nub-pad" }), r({ hideTimestamp: t }), G.createElement("div", { className: "webchat__stacked-layout__alignment-pad" })));
};
oF.defaultProps = { hideTimestamp: !1, renderActivityStatus: () => !1, renderAvatar: void 0, showCallout: !0 };
oF.propTypes = { activity: Q.shape({ attachments: Q.array, channelData: Q.shape({ messageBack: Q.shape({ displayText: Q.string }) }), from: Q.shape({ role: Q.string.isRequired }).isRequired, text: Q.string, textFormat: Q.oneOf(["markdown", "plain", "xml"]), timestamp: Q.string, type: Q.string.isRequired }).isRequired, hideTimestamp: Q.bool, renderActivityStatus: Q.oneOfType([Q.oneOf([!1]), Q.func]), renderAttachment: Q.func.isRequired, renderAvatar: Q.oneOfType([Q.oneOf([!1]), Q.func]), showCallout: Q.bool };
var YW = Nr(oF);
function AGt() {
  return [() => (e) => (...t) => {
    var i;
    let [{ activity: r }] = t, { type: n } = r;
    if (n === "typing") return "text" in r && typeof r.text == "string" && r.channelData.streamType !== "informative" ? function(o, a) {
      return typeof a > "u" && console.warn("botframework-webchat: One or more arguments were missing after passing through the activity middleware. Please check your custom activity middleware to make sure it passes all arguments."), G.createElement(YW, { activity: { ...r, type: "message" }, renderAttachment: o, ...a });
    } : !1;
    if (n === "conversationUpdate" || n === "event" || n === "invoke") return !1;
    if (n === "message") {
      let { attachments: o, channelData: a, text: u } = r;
      if (a != null && a.postBack || a != null && a.messageBack && !a.messageBack.displayText || !(u || o != null && o.length)) return !1;
    }
    return n === "message" || n === "typing" ? n === "message" && (((i = r.attachments) == null ? void 0 : i.length) || 0) > 1 && r.attachmentLayout === "carousel" ? function(o, a) {
      return typeof a > "u" && console.warn("botframework-webchat: One or more arguments were missing after passing through the activity middleware. Please check your custom activity middleware to make sure it passes all arguments."), G.createElement(EGt, { activity: r, renderAttachment: o, ...a });
    } : function(o, a) {
      return typeof a > "u" && console.warn("botframework-webchat: One or more arguments were missing after passing through the activity middleware. Please check your custom activity middleware to make sure it passes all arguments."), G.createElement(YW, { activity: r, renderAttachment: o, ...a });
    } : e(...t);
  }];
}
function SGt(e, t) {
  let r;
  return typeof CustomEvent == "function" ? r = new CustomEvent(e) : (r = document.createEvent("Event"), r.initEvent(e, !0, !0)), Object.entries(t).forEach(([n, i]) => {
    ia(n) || (r[n] = i);
  }), r;
}
function bGt() {
  return ho().internalMarkdownItState;
}
var CGt = bGt;
function aF(e, t) {
  return e.map((r) => {
    if (r) {
      let n = t(r);
      return n.children && (n.children = aF(n.children, t)), n;
    }
    return r;
  });
}
var { useStyleOptions: IGt } = Vt;
function OGt(e) {
  return aF(e, (t) => {
    switch (t = { ...t }, t.type) {
      case "link_open":
        t.tag = "button", t.attrs = [...Xr(t.attrs, [([r, n]) => r === "href" && n.startsWith("#")], ([, r]) => ["data-markdown-href", r.substr(1)]), ["type", "button"]];
        break;
      case "link_close":
        t.tag = "button";
        break;
    }
    return t;
  });
}
var uF = ({ children: e, onReference: t, references: r }) => {
  typeof e != "string" && (console.warn('botframework-webchat: "children" prop passed to <InlineMarkdown> must be of type string.'), e = "");
  let [n] = CGt(), [{ accent: i }] = IGt(), o = Tn(), a = tt(() => o({ "& button[data-markdown-href]": { appearance: "none", backgroundColor: "transparent", border: 0, color: i, cursor: "pointer", fontFamily: "inherit", fontSize: "inherit", padding: 0 }, "@media screen and (forced-colors: active)": { "& button[data-markdown-href]": { color: "LinkText", textDecoration: "underline" } } }) + "", [i, o]);
  r = r.map((f) => f.toUpperCase());
  let { hrefToRef: u, refToHref: s } = r.reduce(({ hrefToRef: f, refToHref: d }, p) => {
    let v = OM();
    return { hrefToRef: { ...f, [v]: p }, refToHref: { ...d, [p]: v } };
  }, { hrefToRef: {}, refToHref: {} }), c = tt(() => {
    let f = n.parseInline(e, { references: r.reduce((p, v) => ia(v) ? p : { ...p, [v]: { href: `#${s[v]}` } }, {}) }), d = OGt(f);
    return { __html: n.renderer.render(d) };
  }, [e, s, n, r]), l = mt((f) => {
    f.stopPropagation();
    let d = f.target.getAttribute("data-markdown-href");
    d && t && t(SGt("reference", ia(d) ? {} : { data: u[d] }));
  }, [u, t]);
  return G.createElement("span", { className: a, dangerouslySetInnerHTML: c, onClick: l });
};
uF.defaultProps = { children: "", onReference: void 0, references: [] };
uF.propTypes = { children: Q.string, onReference: Q.func, references: Q.arrayOf(Q.string) };
var RGt = uF, { useLocalizer: wGt } = Vt, PGt = ["RETRY"], Pme = ({ onRetryClick: e }) => {
  let t = mt(({ data: n }) => n === "RETRY" && e(), [e]), r = wGt()("ACTIVITY_STATUS_SEND_FAILED_RETRY");
  return G.createElement(RGt, { onReference: t, references: PGt }, r);
};
Pme.propTypes = { onRetryClick: Q.func.isRequired };
var DGt = Pme, { useLocalizer: xGt, usePostActivity: NGt } = Vt, Dme = ({ activity: e, sendStatus: t }) => {
  let [{ sendStatus: r }] = pr(), n = d0(), i = xGt(), o = NGt(), a = mt(() => {
    o(e), n("sendBoxWithoutKeyboard");
  }, [e, n, o]), u = i("ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING");
  return G.createElement(G.Fragment, null, G.createElement("span", { className: Gt("webchat__activity-status", "webchat__activity-status--sending", r) }, t === PM ? u : t === py ? G.createElement(DGt, { onRetryClick: a }) : !1));
};
Dme.propTypes = { activity: Q.any.isRequired, sendStatus: Q.oneOf([PM, py, qjt]).isRequired };
var xme = Dme;
function LGt() {
  return () => (e) => ({ activity: t, sendState: r, ...n }) => {
    switch (r) {
      case PM:
      case py:
        return G.createElement(xme, { activity: t, sendStatus: r });
      default:
        return e({ activity: t, sendState: r, ...n });
    }
  };
}
var { useDateFormatter: BGt, useLocalizer: kGt } = Vt, sF = ({ hide: e, value: t }) => {
  let r = kGt(), n = BGt()(t);
  return G.createElement(jo, null, G.createElement(ya, { text: r("ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT", n) }), !e && G.createElement("span", { "aria-hidden": !0 }, n));
};
sF.defaultProps = { hide: !1 };
sF.propTypes = { hide: Q.bool, value: Q.string.isRequired };
var Nme = sF, Lme = Nr(({ className: e }) => G.createElement("svg", { className: e, fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M13.0939 4.61984C12.716 2.60391 10.6934 1.34358 8.71713 1.89254L3.76706 3.26756C3.03196 3.47175 2.47706 4.07638 2.33656 4.82627L2.11258 6.02165C1.94781 6.90105 2.5733 7.6693 3.26989 7.95815C3.5248 8.06386 3.81627 8.21111 4.1232 8.41574C5.80215 9.53503 6.60359 11.0523 7.13855 12.3413C7.23478 12.5731 7.32706 12.8106 7.41614 13.0399C7.56235 13.4162 7.69994 13.7703 7.83227 14.041C7.94336 14.2683 8.07685 14.4964 8.2515 14.6716C8.43773 14.8585 8.68676 14.9995 9.00016 14.9995C9.35735 14.9995 9.66579 14.8763 9.91159 14.6602C10.1473 14.453 10.3051 14.179 10.4137 13.8989C10.6282 13.3453 10.6952 12.648 10.7032 12.0058C10.7114 11.3524 10.6585 10.705 10.6045 10.2249C10.5955 10.1452 10.5865 10.0698 10.5776 9.99952H11.0903C12.6557 9.99952 13.836 8.57733 13.5475 7.03879L13.0939 4.61984Z", fill: "currentcolor" })));
Lme.displayName = "ThumbDislike16Filled";
var MGt = Lme, Bme = Nr(({ className: e }) => G.createElement("svg", { className: e, fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M10.5776 9.99952C10.5944 10.133 10.6119 10.2848 10.6283 10.45C10.7019 11.1893 10.7593 12.2428 10.6146 13.1274C10.5427 13.5666 10.4137 14.0141 10.1727 14.3636C9.91609 14.7357 9.52604 14.9995 9.00016 14.9995C8.48357 14.9995 8.16907 14.6298 7.97616 14.3084C7.78384 13.9879 7.61527 13.553 7.44271 13.1078L7.42958 13.0739C6.88287 11.6637 6.13522 9.75708 4.1232 8.41574C3.81627 8.21111 3.5248 8.06386 3.26989 7.95815C2.5733 7.6693 1.94781 6.90105 2.11258 6.02165L2.33656 4.82627C2.47706 4.07638 3.03196 3.47175 3.76706 3.26756L8.71713 1.89254C10.6934 1.34358 12.716 2.60391 13.0939 4.61984L13.5475 7.03879C13.836 8.57733 12.6557 9.99952 11.0903 9.99952H10.5776ZM12.1111 4.80413C11.8411 3.36418 10.3964 2.46395 8.98478 2.85605L4.03471 4.23107C3.66715 4.33317 3.38971 4.63549 3.31945 5.01043L3.09548 6.20582C3.04235 6.48935 3.2566 6.87007 3.65293 7.03442C3.96222 7.16268 4.31198 7.33974 4.67791 7.58369C6.9648 9.10828 7.80648 11.2795 8.35387 12.6916L8.36197 12.7124C8.55151 13.2014 8.69067 13.5556 8.83359 13.7938C8.90275 13.909 8.95439 13.9644 8.98519 13.9886C8.99329 13.995 8.99862 13.9981 9.00124 13.9995C9.14311 13.9992 9.24643 13.9453 9.3495 13.7959C9.46849 13.6233 9.56579 13.3445 9.62769 12.966C9.75044 12.2154 9.70484 11.2689 9.63323 10.549C9.60484 10.2636 9.57314 10.0209 9.54862 9.85016C9.53637 9.76485 9.52595 9.69769 9.51867 9.65235L9.51029 9.60123L9.50819 9.58884L9.50772 9.58609C9.48227 9.44064 9.52236 9.29093 9.61735 9.17788C9.66884 9.11659 9.73358 9.06935 9.8056 9.03892C9.86646 9.01321 9.93252 8.99952 10.0002 8.99952H11.0903C12.0295 8.99952 12.7377 8.1462 12.5646 7.22308L12.1111 4.80413Z", fill: "currentcolor" })));
Bme.displayName = "ThumbDislike16Regular";
var FGt = Bme, kme = Nr(({ className: e }) => G.createElement("svg", { className: e, fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M9.5806 1.0516C8.83006 0.843 8.24411 1.40248 8.03494 1.92332C7.79411 2.52303 7.58243 2.94395 7.32941 3.44707C7.17287 3.75833 7.00052 4.10106 6.79565 4.53704C6.32141 5.54625 5.84755 6.19347 5.5035 6.58154C5.33128 6.77579 5.19093 6.90585 5.09835 6.98435C5.05204 7.02362 5.01761 7.05005 4.99704 7.0652L4.9809 7.07684L3.109 8.18119C2.27244 8.67473 1.91142 9.69797 2.25304 10.6072L2.77304 11.9912C2.98944 12.5671 3.45891 13.0114 4.04591 13.1958L9.40179 14.8781C10.7365 15.2974 12.1555 14.5397 12.5497 13.1973L13.9139 8.55127C14.29 7.2705 13.3298 5.9878 11.9949 5.9878H10.6099C10.6759 5.76117 10.7434 5.50906 10.8047 5.24751C10.9361 4.68641 11.0478 4.04484 11.0375 3.51008C11.028 3.01293 10.9778 2.49126 10.7735 2.04807C10.5544 1.57258 10.1709 1.21566 9.5806 1.0516ZM4.9768 7.07969L4.97492 7.08097L4.9768 7.07969Z", fill: "currentcolor" })));
kme.displayName = "ThumbLike16Filled";
var HGt = kme, Mme = Nr(({ className: e }) => G.createElement("svg", { className: e, fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M8.03494 1.92332C8.24411 1.40248 8.83006 0.843 9.5806 1.0516C10.1709 1.21566 10.5544 1.57258 10.7735 2.04807C10.9778 2.49126 11.028 3.01293 11.0375 3.51008C11.0478 4.04484 10.9361 4.68641 10.8047 5.24751C10.7434 5.50906 10.6759 5.76117 10.6099 5.9878H11.9949C13.3298 5.9878 14.29 7.2705 13.9139 8.55127L12.5497 13.1973C12.1555 14.5397 10.7365 15.2974 9.40179 14.8781L4.04591 13.1958C3.45891 13.0114 2.98944 12.5671 2.77304 11.9912L2.25304 10.6072C1.91142 9.69797 2.27244 8.67473 3.109 8.18119L4.98089 7.07684C4.98462 7.07423 4.99002 7.07037 4.99704 7.0652C5.01761 7.05005 5.05204 7.02362 5.09835 6.98435C5.19093 6.90585 5.33128 6.77579 5.5035 6.58154C5.84755 6.19347 6.32141 5.54625 6.79565 4.53704C7.00052 4.10106 7.17287 3.75833 7.32941 3.44707C7.58243 2.94395 7.79411 2.52303 8.03494 1.92332ZM5.51946 7.91969C5.51378 7.92334 5.50805 7.9269 5.50224 7.93032L3.61713 9.04247C3.19885 9.28924 3.01834 9.80086 3.18915 10.2555L3.70914 11.6394C3.81735 11.9274 4.05208 12.1496 4.34558 12.2418L9.70146 13.9241C10.5023 14.1756 11.3537 13.721 11.5902 12.9156L12.9544 8.26953C13.1424 7.62915 12.6623 6.9878 11.9949 6.9878H9.92587C9.76349 6.9878 9.61122 6.90894 9.51751 6.77632C9.42381 6.64369 9.40035 6.47382 9.4546 6.32077C9.55458 6.03869 9.70672 5.54998 9.83103 5.01941C9.95711 4.48125 10.0456 3.93709 10.0377 3.52931C10.0287 3.061 9.97907 2.71335 9.86536 2.46667C9.76654 2.25227 9.61384 2.09874 9.31282 2.01508C9.26971 2.0031 9.21948 2.0066 9.15353 2.04989C9.08149 2.09718 9.00781 2.18417 8.96291 2.29598C8.70922 2.92772 8.46651 3.41157 8.19787 3.94711C8.04311 4.25564 7.87974 4.58133 7.7007 4.96233C7.18681 6.05594 6.66067 6.78372 6.25176 7.24494C6.04749 7.47534 5.87312 7.6385 5.74509 7.74707C5.68109 7.80133 5.62875 7.84188 5.59013 7.87034C5.57082 7.88456 5.55495 7.89575 5.54277 7.90411L5.5273 7.91456L5.52171 7.91823L5.51946 7.91969ZM4.97612 7.08018L4.97492 7.08097L4.97612 7.08018Z", fill: "currentcolor" })));
Mme.displayName = "ThumbLike16Regular";
var $Gt = Mme, Fme = Nr(({ className: e, direction: t, filled: r = !1 }) => t === "down" ? r ? G.createElement(MGt, { className: e }) : G.createElement(FGt, { className: e }) : r ? G.createElement(HGt, { className: e }) : G.createElement($Gt, { className: e }));
Fme.displayName = "ThumbButtonImage";
var GW = Fme, { useLocalizer: UGt } = Vt, Hme = Nr(({ direction: e, onClick: t, pressed: r }) => {
  let [{ thumbButton: n }] = pr(), i = UGt()(e === "down" ? "VOTE_DISLIKE_ALT" : "VOTE_LIKE_ALT");
  return G.createElement("button", { "aria-label": i, "aria-pressed": r, className: Gt("webchat__thumb-button", { "webchat__thumb-button--is-pressed": r }, n + ""), onClick: t, title: i, type: "button" }, G.createElement(GW, { className: Gt("webchat__thumb-button__image", { "webchat__thumb-button__image--is-down": e === "down" }), direction: e }), G.createElement(GW, { className: Gt("webchat__thumb-button__image", "webchat__thumb-button__image--is-filled", { "webchat__thumb-button__image--is-down": e === "down" }), direction: e, filled: !0 }));
});
Hme.displayName = "ThumbButton";
var VGt = Hme, $me = Nr(({ action: e, onClick: t, pressed: r }) => {
  let n = Vo(t), i = Vo(e), o = tt(() => {
    var u;
    return e["@type"] === "DislikeAction" || e["@type"] === "VoteAction" && ((u = Hp(() => T9e(e))) == null ? void 0 : u.actionOption) === "downvote" ? "down" : "up";
  }, [e]), a = mt(() => {
    var u;
    return (u = n.current) == null ? void 0 : u.call(n, i.current);
  }, [n, i]);
  return G.createElement(VGt, { direction: o, onClick: a, pressed: r });
});
$me.displayName = "FeedbackVoteButton";
var jGt = $me, { usePonyfill: zGt, usePostActivity: qGt } = Vt, YGt = 500, Ume = Nr(({ actions: e }) => {
  let [{ clearTimeout: t, setTimeout: r }] = zGt(), [n, i] = cn(), o = qGt(), a = Vo(o);
  return nr(() => {
    if (!n) return;
    let u = r(() => a.current({ entities: [n], name: "webchat:activity-status/feedback", type: "event" }), YGt);
    return () => t(u);
  }, [t, a, n, r]), G.createElement(jo, null, Array.from(e).map((u, s) => G.createElement(jGt, { action: u, key: u["@id"] || s, onClick: i, pressed: n === u })));
});
Ume.displayName = "ActivityStatusFeedback";
var GGt = Ume, Vme = Nr(({ project: e }) => {
  let { name: t, slogan: r, url: n } = e, i = r || t;
  return n ? G.createElement("a", { className: "webchat__activity-status__originator webchat__activity-status__originator--has-link", href: n, rel: "noopener noreferrer", target: "_blank" }, i) : G.createElement("span", { className: "webchat__activity-status__originator" }, i);
});
Vme.displayName = "Originator";
var WGt = Vme, jme = Nr(({ children: e, className: t }) => G.createElement("span", { className: Gt("webchat__activity-status--slotted", t) }, B1.map(e, (r, n) => n ? G.createElement(jo, null, G.createElement("span", { className: "webchat__activity-status__slot-pipe", role: "presentation" }, "|"), r) : r)));
jme.displayName = "SlottedActivityStatus";
var zme = jme, { usePonyfill: KGt } = Vt;
function WW(e, t, { Date: r }) {
  let n = new r(e).getTime(), i = r.now();
  return n > i ? n : i + t - (i - n) % t;
}
function XGt(e, t, r) {
  let [n] = KGt(), [i, o] = cn(WW(e, t, n)), a = mt(() => {
    o(WW(e, t, n) + Mu());
  }, [r, e, t, n]);
  return oEe(i, a), [i, o];
}
var { useDateFormatter: JGt, useLocalizer: ZGt, useRelativeTimeFormatter: QGt } = Vt, eWt = 6e4, qme = ({ value: e }) => {
  let t = JGt(), r = QGt(), n = ZGt();
  return XGt(e, eWt), G.createElement(jo, null, G.createElement(ya, { text: n("ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT", t(e)) }), G.createElement("span", { "aria-hidden": !0 }, r(e)));
};
qme.propTypes = { value: Q.string.isRequired };
var tWt = qme, { useStyleOptions: rWt } = Vt, Yme = ({ timestamp: e }) => {
  let [{ timestampFormat: t }] = rWt();
  return t === "relative" ? G.createElement(tWt, { value: e }) : G.createElement(Nme, { value: e });
};
Yme.propTypes = { timestamp: Q.string.isRequired };
var cF = Yme, KW = rl('Root-level things are being deprecated, please relate all things to `entities[@id=""]` instead. This feature will be removed in 2025-03-06.'), Gme = Nr(({ activity: e }) => {
  let [{ sendStatus: t }] = pr(), { timestamp: r } = e, n = tt(() => fme(e.entities || []), [e.entities]), i = tt(() => Efe(n), [n]), o = tt(() => {
    var u;
    try {
      if (i) return (u = TS(((i == null ? void 0 : i.citation) || [])[0])) == null ? void 0 : u.claimInterpreter;
      let [s] = n.filter(({ type: l }) => l === "https://schema.org/Claim").map(TS);
      if (s) return KW(), s == null ? void 0 : s.claimInterpreter;
      let c = jj(n.find(({ type: l }) => l === "https://schema.org/ReplyAction"));
      if (c) return KW(), c == null ? void 0 : c.provider;
    } catch {
    }
  }, [n, i]), a = tt(() => {
    try {
      let u = ((i == null ? void 0 : i.potentialAction) || []).filter(({ "@type": c }) => c === "LikeAction" || c === "DislikeAction");
      if (u.length) return Object.freeze(new Set(u));
      let s = n.filter(({ type: c }) => c === "https://schema.org/VoteAction").map(jj);
      if (s.length) return Object.freeze(new Set(s));
    } catch {
    }
  }, [n, i]);
  return G.createElement(zme, { className: Gt("webchat__activity-status", t + "") }, tt(() => [r && G.createElement(cF, { key: "timestamp", timestamp: r }), o && G.createElement(WGt, { key: "originator", project: o }), (a == null ? void 0 : a.size) && G.createElement(GGt, { actions: a, key: "feedback" })].filter(Boolean), [o, r, a]));
});
Gme.displayName = "OthersActivityStatus";
var nWt = Gme, Wme = Nr(({ activity: e }) => {
  let [{ sendStatus: t }] = pr(), { timestamp: r } = e;
  return r ? G.createElement(zme, { className: Gt("webchat__activity-status", "webchat__activity-status--self", t + "") }, G.createElement(cF, { timestamp: r })) : null;
});
Wme.displayName = "SelftActivityStatus";
var iWt = Wme;
function oWt() {
  return () => () => (...e) => {
    let [{ activity: t, hideTimestamp: r }] = e;
    return typeof t.timestamp > "u" ? G.createElement(jo, null) : r ? G.createElement(Nme, { hide: !0, value: t.timestamp }) : t.from.role === "bot" ? G.createElement(nWt, { activity: t }) : G.createElement(iWt, { activity: t });
  };
}
function aWt() {
  return [LGt(), oWt()];
}
var { useLocalizer: uWt } = Vt, sWt = () => {
  let e = uWt()("ATTACHMENT_AUDIO");
  return G.createElement("article", null, e);
}, cWt = sWt, { useLocalizer: lWt } = Vt, Kme = ({ attachment: { name: e = "" } = {} }) => {
  let t = lWt()("ATTACHMENT_FILE", e);
  return G.createElement("article", null, t);
};
Kme.propTypes = { attachment: Q.shape({ name: Q.string.isRequired }).isRequired };
var XW = Kme, { useLocalizer: fWt } = Vt, dWt = () => {
  let e = fWt()("ATTACHMENT_IMAGE");
  return G.createElement("article", null, e);
}, pWt = dWt, { useLocalizer: hWt } = Vt, Xme = ({ attachment: { content: e = "" } = {} }) => {
  let t = hWt()("ATTACHMENT_TEXT", e);
  return G.createElement("article", null, t);
};
Xme.propTypes = { attachment: Q.shape({ content: Q.string.isRequired }).isRequired };
var vWt = Xme, { useLocalizer: EWt } = Vt, mWt = () => {
  let e = EWt()("ATTACHMENT_VIDEO");
  return G.createElement("article", null, e);
}, gWt = mWt;
function TWt() {
  return [() => (e) => (...t) => {
    let [{ activity: { from: { role: r = void 0 } = {} } = {}, attachment: n, attachment: { contentType: i = void 0, contentUrl: o = void 0, thumbnailUrl: a = void 0 } = {} }] = t, u = /^text\//u.test(i);
    return (u ? !n.content : r === "user" && !a) ? () => G.createElement(XW, { attachment: n }) : /^audio\//u.test(i) ? () => G.createElement(cWt, null) : /^image\//u.test(i) ? () => G.createElement(pWt, null) : /^video\//u.test(i) ? () => G.createElement(gWt, null) : o || i === "application/octet-stream" ? () => G.createElement(XW, { attachment: n }) : u ? () => G.createElement(vWt, { attachment: n }) : e(...t);
  }];
}
var { useAvatarForBot: yWt, useAvatarForUser: _Wt } = Vt, AWt = { "& .webchat__imageAvatar__image": { width: "100%" } }, lF = ({ fromUser: e }) => {
  let [{ image: t }] = yWt(), [{ image: r }] = _Wt(), [{ imageAvatar: n }] = pr(), i = Tn()(AWt) + "";
  return !!(e ? r : t) && G.createElement("div", { className: Gt("webchat__imageAvatar", i, n + "") }, G.createElement(nme, { alt: "", className: "webchat__imageAvatar__image", height: "100%", src: e ? r : t, width: "100%" }));
};
lF.defaultProps = { fromUser: !1 };
lF.propTypes = { fromUser: Q.bool };
var SWt = lF, { useAvatarForBot: bWt, useAvatarForUser: CWt } = Vt, IWt = { alignItems: "center", display: "flex", "& .webchat__initialsAvatar__initials": { justifyContent: "center" } }, fF = ({ fromUser: e }) => {
  let [{ initials: t }] = bWt(), [{ initials: r }] = CWt(), [{ initialsAvatar: n }] = pr(), i = Tn()(IWt) + "";
  return G.createElement("div", { className: Gt("webchat__initialsAvatar", { "webchat__initialsAvatar--fromUser": e }, i, n + "") }, G.createElement("div", { className: "webchat__initialsAvatar__initials" }, e ? r : t));
};
fF.defaultProps = { fromUser: !1 };
fF.propTypes = { fromUser: Q.bool };
var OWt = fF, RWt = { overflow: "hidden", position: "relative", "> *": { left: 0, position: "absolute", top: 0 } }, GC = ({ "aria-hidden": e, className: t, fromUser: r }) => {
  let [{ avatar: n }] = pr(), i = Tn()(RWt) + "";
  return G.createElement("div", { "aria-hidden": e, className: Gt("webchat__defaultAvatar", { "webchat__defaultAvatar--fromUser": r }, i, n + "", (t || "") + "") }, G.createElement(OWt, { fromUser: r }), G.createElement(SWt, { fromUser: r }));
};
GC.defaultProps = { "aria-hidden": !0, className: "" };
GC.propTypes = { "aria-hidden": Q.bool, className: Q.string, fromUser: Q.bool.isRequired };
function wWt() {
  return [() => () => ({ fromUser: e, styleOptions: t }) => {
    let { botAvatarImage: r, botAvatarInitials: n, userAvatarImage: i, userAvatarInitials: o } = t;
    return (e ? i || o : r || n) ? () => G.createElement(GC, { fromUser: e }) : !1;
  }];
}
function JW(e) {
  e = e.replace(/[\x00-\x20]+/gu, ""), e = e.replace(/<!--.*?-->/gu, "");
  let t = e.match(/^([a-zA-Z]+):/u);
  if (t) return t[1].toLowerCase();
}
var PWt = ["data", "http", "https", "ftp", "mailto", "sip", "tel"];
function DWt() {
  return [() => (e) => (...t) => {
    let [{ cardAction: { type: r, value: n }, getSignInUrl: i }] = t;
    switch (r) {
      case "call":
      case "downloadFile":
      case "openUrl":
      case "playAudio":
      case "playVideo":
      case "showImage":
        if (PWt.includes(JW(n))) if (pEe) {
          let o = window.open();
          o.opener = null, o.location = n;
        } else window.open(n, "_blank", "noopener noreferrer");
        else console.warn("botframework-webchat: Cannot open URL with disallowed schemes.", n);
        break;
      case "signin": {
        (async function() {
          let o = window.open(), a = await i();
          ["http", "https"].includes(JW(a)) ? o.location.href = a : (console.warn("botframework-webchat: Cannot open URL with disallowed schemes.", a), o.close());
        })();
        break;
      }
      default:
        return e(...t);
    }
  }];
}
var { useDirection: xWt, useLocalizer: NWt, useStyleOptions: LWt } = Vt, WC = ({ onClick: e }) => {
  let [{ scrollToEndButton: t }] = pr(), [{ scrollToEndButtonBehavior: r }] = LWt(), [n] = xWt(), i = NWt()(r === "any" ? "TRANSCRIPT_MORE_MESSAGES" : "TRANSCRIPT_NEW_MESSAGES");
  return G.createElement("button", { "aria-label": i, className: Gt("webchat__scroll-to-end-button", t + "", n === "rtl" ? "webchat__scroll-to-end-button--rtl" : ""), onClick: e, tabIndex: 0, type: "button" }, i);
};
WC.defaultProps = { onClick: void 0 };
WC.displayName = "ScrollToEndButton";
WC.propTypes = { onClick: Q.func };
var ZW = WC;
function BWt() {
  return [() => () => ({ atEnd: e, styleOptions: { scrollToEndButtonBehavior: t }, unread: r }) => t ? t === "any" ? !e && ZW : !e && r && ZW : !1];
}
var dF = ({ className: e }) => G.createElement("svg", { className: (e || "") + "", focusable: !1, height: "14", role: "presentation", viewBox: "0 0 14 14", width: "14", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M7.71094 7L13.1016 12.3984L12.3984 13.1016L7 7.71094L1.60156 13.1016L0.898438 12.3984L6.28906 7L0.898438 1.60156L1.60156 0.898438L7 6.28906L12.3984 0.898438L13.1016 1.60156L7.71094 7Z" }));
dF.defaultProps = { className: void 0 };
dF.propTypes = { className: Q.string };
var kWt = dF;
function MWt() {
  let { internalRenderMarkdownInline: e } = ho();
  return e;
}
var FWt = MWt, { useDismissNotification: HWt, useLocalizer: $Wt } = Vt, UWt = { display: "flex", "& .webchat__toast__text": { flex: 1 } }, Jme = ({ notification: { alt: e, id: t, level: r, message: n = "" } }) => {
  let [{ toast: i }] = pr(), o = tt(() => `webchat__toast__${OM()}`, []), a = $Wt(), u = HWt(), s = FWt(), c = Tn()(UWt) + "", l = mt(() => u(t), [u, t]), f = tt(() => ({ __html: s(n) }), [n, s]);
  return G.createElement("div", { "aria-describedby": o, "aria-label": a("TOAST_TITLE_ALT"), className: Gt("webchat__toast", { "webchat__toast--error": r === "error", "webchat__toast--info": r === "info", "webchat__toast--success": r === "success", "webchat__toast--warn": r === "warn" }, c, i + ""), role: "dialog" }, G.createElement("div", { className: "webchat__toast__iconBox" }, G.createElement(sEe, { className: "webchat__toast__icon", level: r })), !!e && G.createElement(ya, { text: e }), G.createElement("div", { "aria-hidden": !!e, className: "webchat__toast__text", dangerouslySetInnerHTML: f, id: o }), G.createElement("button", { "aria-label": a("TOAST_DISMISS_BUTTON"), className: "webchat__toast__dismissButton", onClick: l, type: "button" }, G.createElement("div", { "aria-hidden": !0, className: "webchat__toast__dismissButtonFocus" }, G.createElement(kWt, null))));
};
Jme.propTypes = { notification: Q.shape({ alt: Q.string, id: Q.string.isRequired, level: Q.string.isRequired, message: Q.string.isRequired }).isRequired };
var VWt = Jme;
function jWt() {
  return () => () => ({ notification: e }) => G.createElement(VWt, { notification: e });
}
var zWt = jWt;
function qWt() {
  return [() => (e) => (...t) => {
    let [{ notification: { id: r } }] = t;
    return r !== "connectivitystatus" && e(...t);
  }, zWt()];
}
var YWt = qWt, { useDirection: GWt, useLocalizer: WWt } = Vt, KWt = { "&.webchat__typing-indicator.webchat__typing-indicator--rtl": { transform: "scale(-1, 1)" } }, XWt = () => {
  let [{ typingAnimation: e }] = pr(), [t] = GWt(), r = WWt(), n = Tn()(KWt) + "";
  return G.createElement(G.Fragment, null, G.createElement(ya, { text: r("TYPING_INDICATOR_ALT") }), G.createElement("div", { "aria-hidden": !0, className: Gt("webchat__typing-indicator", { "webchat__typing-indicator--rtl": t === "rtl" }, n, e + "") }));
}, JWt = XWt, { useDirection: ZWt, useLocalizer: QWt } = Vt, eKt = () => {
  let [{ typingIndicator: e }] = pr(), [t] = ZWt(), r = QWt();
  return G.createElement("div", { className: Gt(e + "", t === "rtl" && "webchat__typing-indicator--rtl") }, G.createElement(JWt, { "aria-label": r("TYPING_INDICATOR_ALT") }));
};
function tKt() {
  return [() => () => ({ visible: e }) => e && G.createElement(eKt, null)];
}
function rKt(e, t) {
  let r = Ut(), n = tt(() => e(r.current), t);
  return nr(() => {
    r.current = n;
  }), n;
}
function nKt(e, t) {
  let r = FEe((n, i) => t({ activity: n, nextVisibleActivity: i }), [t]);
  return tt(() => {
    let n = [], i;
    for (let o = e.length - 1; o >= 0; o--) {
      let a = e[+o], u = r(a, i);
      u && (n.splice(0, 0, { activity: a, renderActivity: u }), i = a);
    }
    return Object.freeze(n);
  }, [e, r]);
}
function iKt(e, ...t) {
  return t.reduce((r, n) => r.reduce((i, o) => (n.includes(o) && i.push(o), i), []), [...e]);
}
var { useGroupActivities: oKt } = Vt;
function QW(e, t) {
  return e.every((r) => t.some((n) => n.includes(r)));
}
function aKt(e) {
  let t = oKt(), r = tt(() => new Map(e.map((o) => [o.activity, o])), [e]), { entriesBySender: n, entriesByStatus: i } = tt(() => {
    let o = [...r.keys()], a = t({ activities: o }), u = (a == null ? void 0 : a.sender) || [], s = (a == null ? void 0 : a.status) || [], [c, l] = [u, s].map((f) => f.map((d) => d.map((p) => r.get(p))));
    return QW(o, u) || console.warn('botframework-webchat: Not every activities are grouped in the "sender" property. Please fix "groupActivitiesMiddleware" and group every activities.'), QW(o, s) || console.warn('botframework-webchat: Not every activities are grouped in the "status" property. Please fix "groupActivitiesMiddleware" and group every activities.'), { entriesBySender: c, entriesByStatus: l };
  }, [r, t]);
  return tt(() => {
    let o = [...e], a = [];
    for (; o.length; ) {
      let u, s = n.find((l) => l.includes(o[0])), c = [];
      s == null || s.forEach((l) => {
        let f = i.find((p) => p.includes(l)), d = iKt(o, s, f);
        d.length && (c.push(Object.freeze(d)), VC(o, ...d), u = !0);
      }), u || c.push(Object.freeze([o.shift()])), a.push(Object.freeze(c));
    }
    return e.every((u) => a.some((s) => s.some((c) => c.includes(u)))) || console.warn("botframework-webchat internal: Not all visible activities are grouped in the activityTree.", { entries: e, activityTree: a }), Object.freeze(a);
  }, [n, i, e]);
}
var uKt = aKt, { useActivities: sKt, useCreateActivityRenderer: cKt, useGetActivitiesByKey: lKt, useGetKeyByActivity: fKt } = Vt, dKt = ({ children: e }) => {
  if (NEe(!1)) throw new Error("botframework-webchat internal: <ActivityTreeComposer> should not be nested.");
  let [t] = sKt(), r = lKt(), n = fKt(), i = tt(() => {
    let l = [];
    for (let f of t) {
      let d = r(n(f));
      d[0] === f && l.push(d[d.length - 1]);
    }
    return Object.freeze(l);
  }, [r, n, t]), o = cKt(), a = nKt(i, o), u = uKt(a), s = rKt((l) => {
    let f = Object.freeze(u.reduce((d, p) => p.reduce((v, h) => h.reduce((E, m) => (E.push(m), E), v), d), []));
    return f.length === (l == null ? void 0 : l.length) && f.every((d, p) => d === l[+p]) ? l : f;
  }, [u]), c = tt(() => ({ activityTreeWithRendererState: Object.freeze([u]), flattenedActivityTreeWithRendererState: Object.freeze([s]) }), [u, s]);
  return G.createElement(xEe.Provider, { value: c }, e);
}, pKt = dKt;
function pF() {
  let { scrollToEndCallbacksRef: e } = ho();
  return mt(() => e.current.forEach((t) => t({ behavior: "smooth" })), [e]);
}
var hKt = ei(void 0), Zme = hKt, { useConnectivityStatus: vKt, useLocalizer: EKt, usePonyfill: mKt, useSendBoxAttachments: gKt, useSendBoxValue: TKt, useSubmitSendBox: yKt } = Vt, _Kt = { "&.webchat__submit-error-message": { color: "transparent", height: 1, overflow: "hidden", position: "absolute", top: 0, whiteSpace: "nowrap", width: 1 } }, AKt = 500, SKt = 50, bKt = ({ children: e }) => {
  let [{ clearTimeout: t, setTimeout: r }] = mKt(), [n] = gKt(), [i] = vKt(), [o, a] = cn(!1), [u] = TKt(), s = yKt(), c = d0(), l = EKt(), f = pF(), d = Tn(), p = $C("webchat__send-box__error-message-id"), v = Ut(void 0), h = tt(() => Object.freeze((/* @__PURE__ */ new Map()).set("empty", l("SEND_BOX_IS_EMPTY_TOOLTIP_ALT")).set("offline", l("CONNECTIVITY_STATUS_ALT_FATAL"))), [l]), E = Vo(c), m = Vo(f), g = Ut(a), y = d(_Kt) + "", _ = tt(() => Object.freeze([o ? p : void 0]), [o, p]);
  g.current = a;
  let S = Vo(i !== "connected" && i !== "reconnected" ? "offline" : !u && !n.length ? "empty" : void 0), A = mt(({ setFocus: P } = {}) => {
    var z, k, H;
    (P === "main" || P === "sendBox" || P === "sendBoxWithoutKeyboard") && ((z = E.current) == null || z.call(E, P === "main" || P === "sendBox" ? P : "sendBoxWithoutKeyboard"));
    let { current: U } = S;
    U ? (v.current && v.current.forEach(t), (k = g.current) == null || k.call(g, !1), v.current = Object.freeze([r(() => {
      var B;
      return (B = g.current) == null ? void 0 : B.call(g, U);
    }, SKt), r(() => {
      var B;
      return (B = g.current) == null ? void 0 : B.call(g, !1);
    }, AKt)])) : ((H = m.current) == null || H.call(m), s());
  }, [s, t, E, m, g, r, S, v]);
  nr(() => () => {
    g.current = void 0;
  }, [g]);
  let O = tt(() => ({ submit: A, submitErrorMessageIdState: _ }), [A, _]);
  return G.createElement(Zme.Provider, { value: O }, e, G.createElement("span", { className: Gt("webchat__submit-error-message", y), id: p, role: "alert" }, o ? h.get(o) : ""));
}, CKt = bKt, { useLocalizer: IKt } = Vt, Qme = Nr(({ "aria-label": e, "aria-labelledby": t, children: r, className: n, onDismiss: i }) => {
  let [{ modalDialog: o }] = pr(), a = Ut(null), u = IKt()("KEYBOARD_HELP_CLOSE_BUTTON_ALT"), s = mt(() => {
    var c;
    return (c = a.current) == null ? void 0 : c.close();
  }, [a]);
  return nr(() => {
    var c;
    return (c = a.current) == null ? void 0 : c.showModal();
  }, [a]), G.createElement("dialog", { "aria-label": t ? void 0 : e, "aria-labelledby": t, className: Gt("webchat__modal-dialog", n, o + ""), onClose: i, open: !1, ref: a, role: "dialog" }, G.createElement("div", { className: "webchat__modal-dialog__box" }, G.createElement("div", { className: "webchat__modal-dialog__close-button-layout" }, G.createElement("button", { "aria-label": u, className: "webchat__modal-dialog__close-button", onClick: s, type: "button" }, G.createElement("div", { className: "webchat__modal-dialog__close-button-border" }, G.createElement("svg", { className: "webchat__modal-dialog__close-button-image", focusable: !1, role: "presentation", viewBox: "0 0 2048 2048", xmlns: "http://www.w3.org/2000/svg" }, G.createElement("path", { d: "M2048 136l-888 888 888 888-136 136-888-888-888 888L0 1912l888-888L0 136 136 0l888 888L1912 0l136 136z" }))))), G.createElement("div", { className: "webchat__modal-dialog__body" }, r)));
});
Qme.displayName = "ModalDialog";
var OKt = Qme, ege = Nr(({ children: e }) => {
  var a, u, s;
  let [t, r] = cn(), n = mt(() => r(void 0), [r]), i = mt((c, l) => r(Object.freeze([c, l])), [r]), o = tt(() => Object.freeze({ close: n, showModal: i }), [n, i]);
  return G.createElement(pme.Provider, { value: o }, e, t && G.createElement(OKt, { "aria-label": (a = t[1]) == null ? void 0 : a["aria-label"], "aria-labelledby": (u = t[1]) == null ? void 0 : u["aria-labelledby"], className: (s = t[1]) == null ? void 0 : s.className, onDismiss: n }, t[0]()));
});
ege.displayName = "ModalDialogComposer";
var RKt = ege, Su = Object.freeze([]), wKt = Object.freeze({}), XL = ei({ activityMiddleware: Su, activityStatusMiddleware: Su, attachmentForScreenReaderMiddleware: Su, attachmentMiddleware: Su, avatarMiddleware: Su, cardActionMiddleware: Su, groupActivitiesMiddleware: Su, scrollToEndButtonMiddleware: Su, sendBoxMiddleware: Su, sendBoxToolbarMiddleware: Su, styleOptions: wKt, toastMiddleware: Su, typingIndicatorMiddleware: Su });
function PKt() {
  return En(XL);
}
function tge() {
  let e = En(Zme);
  if (!e) throw new Error("botframework-webchat internal: This hook can only be used under <SendBoxComposer>.");
  return e;
}
function DKt() {
  return tge().submitErrorMessageIdState;
}
var { DictateState: { DICTATING: xKt, STARTING: eK, STOPPING: NKt } } = YT, { useDictateInterims: LKt, useDictateState: BKt, useLocalizer: kKt } = Vt, MKt = { alignItems: "center", display: "flex" }, hF = ({ className: e }) => {
  let [t] = LKt(), [r] = BKt(), [{ dictationInterims: n }] = pr(), i = kKt(), o = Tn()(MKt) + "";
  return r === eK || r === NKt ? G.createElement("p", { className: Gt(n + "", o, (e || "") + "", "status") }, r === eK && i("SPEECH_INPUT_STARTING")) : r === xKt && (t.length ? G.createElement("p", { className: Gt(n + "", o, (e || "") + "", "dictating") }, t.map((a, u) => G.createElement("span", { key: u }, a, " "))) : G.createElement("p", { className: Gt(n + "", o, (e || "") + "", "status") }, i("SPEECH_INPUT_LISTENING")));
};
hF.defaultProps = { className: "" };
hF.propTypes = { className: Q.string };
var rge = hF;
function nge() {
  let [e] = bme();
  return [e];
}
var FKt = ({ className: e }) => G.createElement("svg", { className: e, focusable: !1, height: 28, role: "presentation", viewBox: "0 0 34.75 46", width: 28 }, G.createElement("path", { className: "a", d: "M29.75,23v6.36a7,7,0,0,1-.56,2.78,7.16,7.16,0,0,1-3.8,3.8,7,7,0,0,1-2.78.56H18.5v2.25H23V41H11.75v-2.25h4.5V36.5h-4.11a7,7,0,0,1-2.78-.56,7.16,7.16,0,0,1-3.8-3.8,7,7,0,0,1-.56-2.78V23h2.25v6.36a4.72,4.72,0,0,0,.39,1.9,4.78,4.78,0,0,0,2.6,2.6,4.72,4.72,0,0,0,1.9.39h10.47a4.72,4.72,0,0,0,1.9-.39,4.78,4.78,0,0,0,2.6-2.6,4.72,4.72,0,0,0,.39-1.9V23Zm-18,5.62a1.13,1.13,0,0,0,1.13,1.13h9a1.13,1.13,0,0,0,1.12-1.13V8.38a1.13,1.13,0,0,0-1.12-1.13h-9a1.13,1.13,0,0,0-1.13,1.13Zm1.13,3.38a3.41,3.41,0,0,1-1.32-.26,3.31,3.31,0,0,1-1.8-1.8,3.41,3.41,0,0,1-.26-1.32V8.38a3.41,3.41,0,0,1,.26-1.32,3.31,3.31,0,0,1,1.8-1.8,3.41,3.41,0,0,1,1.32-.26h9a3.4,3.4,0,0,1,1.31.26,3.31,3.31,0,0,1,1.8,1.8,3.41,3.41,0,0,1,.26,1.32v20.24a3.41,3.41,0,0,1-.26,1.32,3.31,3.31,0,0,1-1.8,1.8,3.4,3.4,0,0,1-1.31.26Z" })), HKt = FKt, $Kt = (e) => e.preventDefault(), KC = n0(({ "aria-hidden": e, children: t, disabled: r, onClick: n, tabIndex: i, ...o }, a) => {
  let u = Ut();
  return G.createElement("button", { "aria-disabled": r || void 0, "aria-hidden": e, onClick: r ? $Kt : n, ref: a || u, tabIndex: r ? -1 : i, ...o, type: "button" }, t);
});
KC.defaultProps = { "aria-hidden": void 0, children: void 0, disabled: void 0, onClick: void 0, tabIndex: void 0 };
KC.displayName = "AccessibleButton";
KC.propTypes = { "aria-hidden": Q.bool, children: Q.any, disabled: Q.bool, onClick: Q.func, tabIndex: Q.number, type: Q.oneOf(["button"]).isRequired };
var ige = KC;
function oge(e) {
  let [t, r] = cn(!1), n = mt(() => r(!1), [r]), i = mt(() => r(!0), [r]);
  return kEe(e, i), nr(() => {
    let { current: o } = e;
    return o.addEventListener("blur", n), () => o.removeEventListener("blur", n);
  }, [n, e]), [t];
}
var { useStyleOptions: UKt } = Vt, vF = ({ alt: e, children: t, className: r, disabled: n, onClick: i }) => {
  let [{ sendBoxButton: o }] = pr(), [{ sendBoxButtonAlignment: a }] = UKt(), u = Ut(), [s] = oge(u);
  return G.createElement(ige, { className: Gt(o + "", "webchat__icon-button", { "webchat__icon-button--focus-visible": s, "webchat__icon-button--stretch": a !== "bottom" && a !== "top" }, r + ""), disabled: n, onClick: n ? void 0 : i, ref: u, title: e, type: "button" }, G.createElement("div", { className: "webchat__icon-button__shade" }), t, G.createElement("div", { className: "webchat__icon-button__keyboard-focus-indicator" }));
};
vF.defaultProps = { alt: "", children: void 0, className: "", disabled: !1, onClick: void 0 };
vF.propTypes = { alt: Q.string, children: Q.any, className: Q.string, disabled: Q.bool, onClick: Q.func };
var EF = vF, { DictateState: Cp } = YT, { useDictateInterims: VKt, useDictateState: mF, useDisabled: jKt, useLocalizer: zKt, useSendBoxValue: qKt, useShouldSpeakIncomingActivity: YKt, useStartDictate: GKt, useStopDictate: WKt } = Vt, KKt = { display: "flex", "& > .sr-only": { color: "transparent", height: 1, left: -1e4, overflow: "hidden", position: "absolute", top: 0, whiteSpace: "nowrap", width: 1 } };
function age() {
  let [, e] = qKt(), [, t] = YKt(), [r] = VKt(), [n] = mF(), [i] = $h(), o = GKt(), a = WKt(), { speechSynthesis: u, SpeechSynthesisUtterance: s } = i || {}, [c] = cn(() => nEe((l, f) => {
    if (l && f) {
      let d = new f("");
      [d.voice] = l.getVoices(), l.speak(d);
    }
  }));
  return mt(() => {
    n === Cp.WILL_START ? t(!1) : n === Cp.DICTATING ? (a(), e(r.join(" "))) : (t(!1), o()), c(u, s);
  }, [r, n, c, e, t, u, s, o, a]);
}
function uge() {
  let [e] = nge(), [t] = mF(), [r] = jKt();
  return [r || t === Cp.STARTING || t === Cp.STOPPING || t === Cp.DICTATING && !e];
}
var gF = ({ className: e }) => {
  let [{ microphoneButton: t }] = pr(), [r] = mF(), [n] = uge(), i = age(), o = zKt(), a = Tn()(KKt) + "", u = r === Cp.DICTATING;
  return G.createElement("div", { "aria-controls": "webchatSendBoxMicrophoneButton", className: Gt("webchat__microphone-button", { "webchat__microphone-button--dictating": u }, t + "", a, (e || "") + "") }, G.createElement(EF, { alt: o("TEXT_INPUT_SPEAK_BUTTON_ALT"), className: "webchat__microphone-button__button", disabled: n, onClick: i }, G.createElement(HKt, { className: "webchat__microphone-button__icon" })), G.createElement("div", { "aria-live": "polite", className: "sr-only", id: "webchatSendBoxMicrophoneButton", role: "status" }, o(u ? "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT" : "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT")));
};
gF.defaultProps = { className: "" };
gF.propTypes = { className: Q.string };
var sge = gF, { useDirection: XKt } = Vt, JKt = { "&.webchat__send-icon": { "&.webchat__send-icon--rtl": { transform: "scale(-1, 1)" } } }, ZKt = () => {
  let [e] = XKt(), t = Tn()(JKt) + "";
  return G.createElement("svg", { className: Gt("webchat__send-icon", { "webchat__send-icon--rtl": e === "rtl" }, t), height: 28, viewBox: "0 0 45.7 33.8", width: 28 }, G.createElement("path", { clipRule: "evenodd", d: "M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z" }));
}, QKt = ZKt;
function TF() {
  return tge().submit;
}
var { useDisabled: eXt, useLocalizer: tXt } = Vt, yF = ({ className: e }) => {
  let [t] = eXt(), r = tXt(), n = TF(), i = mt(() => n({ setFocus: "sendBoxWithoutKeyboard" }), [n]);
  return G.createElement(EF, { alt: r("TEXT_INPUT_SEND_BUTTON_ALT"), className: Gt("webchat__send-button", e), disabled: t, onClick: i }, G.createElement(QKt, null));
};
yF.defaultProps = { className: void 0 };
yF.propTypes = { className: Q.string };
var cge = yF;
function rXt(e) {
  let [t, r] = cn(!1), n = mt(() => r(!1), [r]), i = mt(({ target: o }) => {
    var u;
    let a = o;
    r(e.current === a || !!((u = e.current) != null && u.contains(a)));
  }, [r, e]);
  return nr(() => (document.addEventListener("blur", n), document.addEventListener("focus", i), () => {
    document.removeEventListener("blur", n), document.removeEventListener("focus", i);
  }), [n, i]), Object.freeze([t]);
}
var nXt = ei({ itemEffector: () => {
  throw new Error("botframework-webchat internal: Not implemented.");
} }), lge = nXt, _F = ({ children: e, onEscapeKey: t, orientation: r }) => {
  let n = Ut(0), i = Ut([]), o = mt(() => {
    let { current: f } = n;
    i.current.forEach(({ current: d }, p) => {
      d == null || d.setAttribute("tabindex", f === p ? "0" : "-1");
    });
  }, [n]), a = mt((f) => {
    var p, v, h;
    let d;
    typeof f == "number" ? d = f : d = f(n.current), d && !((p = i.current[+d]) != null && p.current) && (d = 0), n.current !== d && (n.current = d, o(), (h = (v = i.current[+d]) == null ? void 0 : v.current) == null || h.focus());
  }, [n, i, o]), u = mt((f) => {
    let { target: d } = f, p = i.current.findIndex(({ current: v }) => v === d);
    ~p && a(p);
  }, [i, a]), s = mt((f) => {
    let { key: d } = f, p = r === "vertical";
    switch (d) {
      case "ArrowDown":
      case "ArrowRight":
      case "Down":
      case "Right":
        if (p && d === "ArrowRight" || !p && d === "ArrowDown") return;
        a((v) => {
          let h = i.current.map((m, g) => g), E = h.indexOf(v) + 1;
          return E >= h.length ? h[0] : h[+E];
        });
        break;
      case "ArrowLeft":
      case "ArrowUp":
      case "Left":
      case "Up":
        if (p && d === "ArrowLeft" || !p && d === "ArrowUp") return;
        a((v) => {
          let h = i.current.map((m, g) => g), E = h.indexOf(v) - 1;
          return E < 0 ? h[h.length - 1] : h[+E];
        });
        break;
      case "Home":
        a(0);
        break;
      case "End":
        a(1 / 0);
        break;
      case "Escape":
        if (!t) return;
        t();
        break;
      default:
        return;
    }
    f.preventDefault(), f.stopPropagation();
  }, [a, t, r]), c = mt((f, d) => {
    let { current: p } = f;
    return i.current[+d] = f, p.addEventListener("focus", u), p.addEventListener("keydown", s), p.setAttribute("tabindex", n.current === d ? "0" : "-1"), () => {
      p.removeEventListener("focus", u), p.removeEventListener("keydown", s), delete i.current[+d];
    };
  }, [n, u, s]), l = tt(() => ({ itemEffector: c }), [c]);
  return nr(() => {
    a((f) => f);
  }), G.createElement(lge.Provider, { value: l }, e);
};
_F.defaultProps = { onEscapeKey: void 0, orientation: "horizontal" };
_F.propTypes = { onEscapeKey: Q.func, orientation: Q.oneOf(["horizontal", "vertical"]) };
var JR = _F;
function iXt(e = !0) {
  let t = En(lge);
  if (e && !t) throw new Error("botframework-webchat internal: This hook can only be used under <RovingTabIndexComposer>.");
  return t;
}
function oXt(e) {
  let t = Ut(), { itemEffector: r } = iXt();
  return nr(() => r(t, e)), t;
}
function aXt() {
  return En(WEe);
}
function uXt(e, t) {
  let r = e.indexOf(t);
  ~r && e.splice(r, 1);
}
function sXt(e, t) {
  if (e && typeof e != "string") throw new Error('useFocusAccessKeyEffect: If defined, "key" must be of type "string".');
  if (!t || !("current" in t)) throw new Error('useFocusAccessKeyEffect: "ref" must be defined and has "current" property.');
  let r = aXt();
  nr(() => {
    if (e) {
      let n = { keys: e.split(/\s+/gu), ref: t };
      return r.focii.push(n), () => uXt(r.focii, n);
    }
  }, [r, e, t]);
}
var { useDirection: cXt, useDisabled: lXt, usePerformCardAction: fXt, useStyleOptions: dXt, useSuggestedActions: pXt } = Vt, hXt = { "&.webchat__suggested-action": { display: "flex", overflow: "hidden" } }, AF = ({ buttonText: e, className: t, displayText: r, image: n, imageAlt: i, itemIndex: o, text: a, textClassName: u, type: s, value: c }) => {
  let [l, f] = pXt(), [{ suggestedActionsStackedLayoutButtonTextWrap: d }] = dXt(), [{ suggestedAction: p }] = pr(), [v] = REe(), [h] = cXt(), [E] = lXt(), m = d0(), g = oXt(o), y = OEe("aria-keyshortcuts"), _ = fXt(), S = Tn()(hXt) + "", A = pF(), [O] = oge(g), P = mt(({ target: U }) => {
    (async function() {
      await m("sendBoxWithoutKeyboard"), _({ displayText: r, text: a, type: s, value: c }, { target: U }), s === "openUrl" && f([]), A();
    })();
  }, [r, m, _, A, f, a, s, c]);
  return sXt(v, g), G.createElement(ige, { ...v ? { "aria-keyshortcuts": y(v) } : {}, className: Gt("webchat__suggested-action", { "webchat__suggested-action--focus-visible": O, "webchat__suggested-action--rtl": h === "rtl", "webchat__suggested-action--wrapping": d }, S, p + "", (t || "") + ""), disabled: E, onClick: P, ref: g, type: "button" }, n && G.createElement("img", { alt: i, className: Gt("webchat__suggested-action__image", h === "rtl" && "webchat__suggested-action__image--rtl"), src: n }), G.createElement("span", { className: Gt("webchat__suggested-action__text", (u || "") + "") }, e), G.createElement("div", { className: "webchat__suggested-action__keyboard-focus-indicator" }));
};
AF.defaultProps = { className: "", displayText: "", image: "", imageAlt: void 0, text: "", textClassName: "", type: void 0, value: void 0 };
AF.propTypes = { buttonText: Q.string.isRequired, className: Q.string, displayText: Q.string, image: Q.string, imageAlt: Q.string, itemIndex: Q.number.isRequired, text: Q.string, textClassName: Q.string, type: Q.string, value: Q.any };
var vXt = AF, { useDirection: EXt, useLocalizer: fge, useStyleOptions: dge, useSuggestedActions: mXt } = Vt, SF = { "&.webchat__suggested-actions": { "&.webchat__suggested-actions--flow-layout .webchat__suggested-actions__flow-box": { display: "flex", flexWrap: "wrap" }, "&.webchat__suggested-actions--stack-layout .webchat__suggested-actions__stack": { display: "flex", flexDirection: "column" } } }, bF = ({ children: e, className: t, label: r }) => {
  let [{ suggestedActionsCarouselFlipperBoxWidth: n, suggestedActionsCarouselFlipperCursor: i, suggestedActionsCarouselFlipperSize: o }] = dge(), [{ suggestedActions: a }] = pr(), [u] = EXt(), [s] = MM(), c = fge(), l = Ut(), f = Tn()(SF) + "", d = tt(() => EM({ autoHide: !1, cursor: i, flipperBoxWidth: n, flipperSize: o }), [n, i, o]), p = c("SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT"), v = c("SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT"), [h] = rXt(l), E = u === "rtl" ? p : v, m = u === "rtl" ? v : p;
  return G.createElement("div", { "aria-label": r, "aria-orientation": "horizontal", className: Gt("webchat__suggested-actions", "webchat__suggested-actions--carousel-layout", { "webchat__suggested-actions--focus-within": h, "webchat__suggested-actions--rtl": u === "rtl" }, f, a + "", (t || "") + ""), ref: l, role: "toolbar" }, !!e && !!G.Children.count(e) && G.createElement(gM, { autoCenter: !1, className: "webchat__suggested-actions__carousel", dir: u, flipperBlurFocusOnClick: !0, leftFlipperAriaLabel: E, nonce: s, rightFlipperAriaLabel: m, showDots: !1, showScrollBar: !1, styleSet: d }, e), G.createElement("div", { className: "webchat__suggested-actions__focus-indicator" }));
};
bF.defaultProps = { children: void 0, className: void 0 };
bF.propTypes = { children: Q.any, className: Q.string, label: Q.string.isRequired };
var CF = ({ children: e, className: t, label: r }) => {
  let [{ suggestedActions: n }] = pr(), i = Tn()(SF) + "";
  return G.createElement("div", { "aria-label": r, "aria-live": "polite", "aria-orientation": "horizontal", className: Gt("webchat__suggested-actions", "webchat__suggested-actions--flow-layout", i, n + "", (t || "") + ""), role: "toolbar" }, !!e && !!G.Children.count(e) && G.createElement("div", { className: "webchat__suggested-actions__flow-box" }, G.Children.map(e, (o) => G.createElement("div", { className: "webchat__suggested-actions__flow-item-box" }, o))), G.createElement("div", { className: "webchat__suggested-actions__focus-indicator" }));
};
CF.defaultProps = { children: void 0, className: void 0 };
CF.propTypes = { children: Q.any, className: Q.string, label: Q.string.isRequired };
var IF = ({ children: e, className: t, label: r }) => {
  let [{ suggestedActions: n }] = pr(), i = Tn()(SF) + "";
  return G.createElement("div", { "aria-label": r, "aria-live": "polite", "aria-orientation": "vertical", className: Gt("webchat__suggested-actions", "webchat__suggested-actions--stacked-layout", i, n + "", (t || "") + ""), role: "toolbar" }, !!e && !!G.Children.count(e) && G.createElement("div", { className: "webchat__suggested-actions__stack" }, e), G.createElement("div", { className: "webchat__suggested-actions__focus-indicator" }));
};
IF.defaultProps = { children: void 0, className: void 0 };
IF.propTypes = { children: Q.any, className: Q.string, label: Q.string.isRequired };
var gXt = ({ className: e }) => {
  let [t] = mXt(), [{ suggestedActionLayout: r, suggestedActionsStackedLayoutButtonTextWrap: n }] = dge(), i = fge(), o = d0(), a = mt(() => {
    o("sendBox");
  }, [o]), u = i("SUGGESTED_ACTIONS_LABEL_ALT"), s = t.map((c, l) => {
    let { displayText: f, image: d, imageAltText: p, text: v, type: h, value: E } = c;
    return G.createElement("div", { className: "webchat__suggested-actions__item-box", key: l }, G.createElement(vXt, { buttonText: TEe(c), className: "webchat__suggested-actions__button", displayText: f, image: d, imageAlt: d && (p || v), itemIndex: l, text: v, textClassName: r === "stacked" && n ? "webchat__suggested-actions__button-text-stacked-text-wrap" : "webchat__suggested-actions__button-text", type: h, value: E }));
  });
  return s.length ? r === "flow" ? G.createElement(JR, { onEscapeKey: a }, G.createElement(CF, { className: e, label: u }, s)) : r === "stacked" ? G.createElement(JR, { onEscapeKey: a, orientation: "vertical" }, G.createElement(IF, { className: e, label: u }, s)) : G.createElement(JR, { onEscapeKey: a }, G.createElement(bF, { className: e, label: u }, s)) : null;
}, pge = gXt;
function hge(e, t) {
  nr(() => {
    let { current: r } = e;
    r && (r.enterKeyHint = t);
  }, [t, e]);
}
var XC = n0(({ "aria-errormessage": e, className: t, disabled: r, enterKeyHint: n, onChange: i, onFocus: o, onKeyDown: a, onKeyDownCapture: u, onKeyPress: s, onSelect: c, placeholder: l, readOnly: f, tabIndex: d, value: p, ...v }, h) => {
  let E = Ut(), m = h || E;
  return hge(m, n), G.createElement("input", { "aria-disabled": r || void 0, "aria-errormessage": e, className: t, onChange: r ? void 0 : i, onFocus: r ? void 0 : o, onKeyDown: r ? void 0 : a, onKeyDownCapture: r ? void 0 : u, onKeyPress: r ? void 0 : s, onSelect: r ? void 0 : c, placeholder: l, readOnly: f || r, ref: m, tabIndex: r ? -1 : d, value: p, ...v, type: "text" });
});
XC.defaultProps = { "aria-errormessage": void 0, className: void 0, disabled: void 0, enterKeyHint: void 0, inputMode: void 0, onChange: void 0, onFocus: void 0, onKeyDown: void 0, onKeyDownCapture: void 0, onKeyPress: void 0, onSelect: void 0, placeholder: void 0, readOnly: void 0, tabIndex: void 0, value: void 0 };
XC.displayName = "AccessibleInputText";
XC.propTypes = { "aria-errormessage": Q.string, className: Q.string, disabled: Q.bool, enterKeyHint: Q.string, inputMode: Q.oneOf(["text", "none", "tel", "url", "email", "numeric", "decimal", "search"]), onChange: Q.func, onFocus: Q.func, onKeyDown: Q.func, onKeyDownCapture: Q.func, onKeyPress: Q.func, onSelect: Q.func, placeholder: Q.string, readOnly: Q.bool, tabIndex: Q.number, type: Q.oneOf(["text"]).isRequired, value: Q.string };
var TXt = XC;
function yXt(e) {
  let { altKey: t, target: r, target: { tagName: n } } = e, i = r.getAttribute("autocomplete"), o = i && i !== "off";
  if (n === "INPUT") {
    let { list: a, type: u, value: s } = r;
    if (u === "button" || u === "checkbox" || u === "file" || u === "image" || u === "radio" || u === "reset" || u === "submit" || (u === "email" || u === "password" || u === "search" || u === "tel" || u === "text" || u === "url") && (o || a || t || !s))
      return !0;
  } else {
    if (n === "SELECT") return !1;
    if (n === "TEXTAREA") {
      if (!o && (t || !r.value)) return !0;
    } else if (r.getAttribute("contenteditable") === "true") {
      if (t || !r.innerHTML) return !0;
    } else return !0;
  }
}
function vge() {
  let e = HEe();
  return mt((t) => e({ direction: "down", ...t }), [e]);
}
function Ege() {
  let e = HEe();
  return mt((t) => e({ direction: "up", ...t }), [e]);
}
var _T, AT, ST, bT, Use, _Xt = (Use = class {
  constructor(t, r, n, i) {
    I0(this, _T);
    I0(this, AT);
    I0(this, ST);
    I0(this, bT);
    bl(this, _T, i), bl(this, AT, n), bl(this, ST, r), bl(this, bT, t);
  }
  get group() {
    return Sl(this, _T);
  }
  get selectionStart() {
    return Sl(this, ST);
  }
  get selectionEnd() {
    return Sl(this, AT);
  }
  get value() {
    return Sl(this, bT);
  }
}, _T = new WeakMap(), AT = new WeakMap(), ST = new WeakMap(), bT = new WeakMap(), Use);
function AXt(e) {
  let t = Ut([]), r = mt((i) => {
    let { current: o } = e;
    if (!o) return;
    let { current: a } = t, [u] = a, { selectionEnd: s, selectionStart: c, value: l } = o;
    (!i || i !== (u == null ? void 0 : u.group)) && (l === (u == null ? void 0 : u.value) && a.shift(), a.unshift(new _Xt(l, c, s, i)));
  }, [e, t]), n = mt(() => {
    let { current: i } = e;
    if (!i) return;
    let { current: o } = t, a;
    for (; o.length && ([a] = o, (a == null ? void 0 : a.value) === i.value); ) o.shift();
    a ? (i.value = a.value, i.selectionStart = a.selectionStart, i.selectionEnd = a.selectionEnd) : i.value = "";
  }, [e, t]);
  return Object.freeze({ push: r, undo: n });
}
function SXt({ componentProps: e, componentType: t, emojiMap: r = /* @__PURE__ */ new Map(), innerRef: n, onChange: i }) {
  let { value: o } = e, a = Ut(null), u = Vo(i), { push: s, undo: c } = AXt(a), l = Vo(o), f = mt(({ currentTarget: v }) => {
    var g;
    let { selectionEnd: h, selectionStart: E, value: m } = v;
    if (typeof h == "number" && typeof E == "number" && E === h && m && m.length === (l.current || "").length + 1) for (let [y, _] of r.entries()) {
      let { length: S } = y;
      if (m.slice(h - S, h) === y) {
        s();
        let A = `${m.slice(0, h - S)}${_}${m.slice(h)}`, O = h + _.length - S;
        v.value = A, v.selectionStart = E, v.selectionEnd = O;
        break;
      }
    }
    m || s(), (g = u.current) == null || g.call(u, v.value);
  }, [s, r, u, l]), d = mt(() => s(), [s]), p = mt((v) => {
    var y;
    let { ctrlKey: h, key: E, metaKey: m } = v, g = E.toUpperCase();
    (h || m) && g === "Z" ? (v.preventDefault(), c(), (y = u.current) == null || y.call(u, v.currentTarget.value)) : E === "Backspace" ? s("backspace") : E === "Delete" ? s("delete") : E === "ArrowLeft" || E === "ArrowRight" || E === "ArrowUp" || E === "ArrowDown" || E === "Home" || E === "End" || E === "PageUp" || E === "PageDown" || (h || m) && g === "A" || (h || m) && (g === "V" || g === "X") ? s() : s("change");
  }, [s, u, c]);
  return tt(() => (!a.current || a.current.value !== o) && s(), [s, a, o]), G.createElement(t, { ...e, onChange: f, onFocus: d, onKeyDown: p, ref: DVt(a, n) });
}
function JC(e) {
  let t = n0(({ emojiMap: r, onChange: n, ...i }, o) => G.createElement(SXt, { componentProps: i, componentType: e, emojiMap: r, innerRef: o, onChange: n }));
  return t.displayName = `WithEmoji<${e.displayName}>`, t;
}
var ZC = n0(({ className: e, disabled: t, inputMode: r, onChange: n, onFocus: i, onKeyDown: o, onKeyDownCapture: a, onKeyPress: u, onSelect: s, placeholder: c, readOnly: l, rows: f, tabIndex: d, ...p }, v) => {
  let h = Ut();
  return G.createElement("textarea", { "aria-disabled": t || void 0, className: e, inputMode: r, onChange: t ? void 0 : n, onFocus: t ? void 0 : i, onKeyDown: t ? void 0 : o, onKeyDownCapture: t ? void 0 : a, onKeyPress: t ? void 0 : u, onSelect: t ? void 0 : s, placeholder: c, readOnly: l || t, ref: v || h, rows: f, tabIndex: t ? -1 : d, ...p });
});
ZC.defaultProps = { className: void 0, disabled: void 0, inputMode: void 0, onChange: void 0, onFocus: void 0, onKeyDown: void 0, onKeyDownCapture: void 0, onKeyPress: void 0, onSelect: void 0, placeholder: void 0, readOnly: void 0, rows: void 0, tabIndex: void 0, value: void 0 };
ZC.displayName = "AccessibleTextArea";
ZC.propTypes = { className: Q.string, disabled: Q.bool, inputMode: Q.oneOf(["text", "none", "tel", "url", "email", "numeric", "decimal", "search"]), onChange: Q.func, onFocus: Q.func, onKeyDown: Q.func, onKeyDownCapture: Q.func, onKeyPress: Q.func, onSelect: Q.func, placeholder: Q.string, readOnly: Q.bool, rows: Q.number, tabIndex: Q.number, value: Q.string };
var bXt = ZC, OF = n0(({ "aria-errormessage": e, "aria-label": t, className: r, "data-id": n, disabled: i, enterKeyHint: o, inputMode: a, onChange: u, onFocus: s, onKeyDown: c, onKeyDownCapture: l, onKeyPress: f, onSelect: d, placeholder: p, readOnly: v, rows: h, textAreaClassName: E, value: m }, g) => {
  let [{ autoResizeTextArea: y }] = pr();
  return hge(g, o), G.createElement("div", { className: Gt("webchat__auto-resize-textarea", y + "", r) }, G.createElement("div", { "aria-hidden": !0, className: "webchat__auto-resize-textarea__doppelganger" }, m, " "), G.createElement(bXt, { "aria-errormessage": e, "aria-label": t, className: Gt("webchat__auto-resize-textarea__textarea", E), "data-id": n, disabled: i, inputMode: a, onChange: u, onFocus: s, onKeyDown: c, onKeyDownCapture: l, onKeyPress: f, onSelect: d, placeholder: p, readOnly: v, ref: g, rows: h, value: m }));
});
OF.defaultProps = { "aria-errormessage": void 0, "aria-label": void 0, "data-id": void 0, className: void 0, disabled: void 0, enterKeyHint: void 0, inputMode: void 0, onChange: void 0, onFocus: void 0, onKeyDown: void 0, onKeyDownCapture: void 0, onKeyPress: void 0, onSelect: void 0, placeholder: void 0, readOnly: void 0, rows: void 0, textAreaClassName: void 0, value: "" };
OF.propTypes = { "aria-errormessage": Q.string, "aria-label": Q.string, className: Q.string, "data-id": Q.string, disabled: Q.bool, enterKeyHint: Q.string, inputMode: Q.oneOf(["text", "none", "tel", "url", "email", "numeric", "decimal", "search"]), onChange: Q.func, onFocus: Q.func, onKeyDown: Q.func, onKeyDownCapture: Q.func, onKeyPress: Q.func, onSelect: Q.func, placeholder: Q.string, readOnly: Q.bool, rows: Q.number, textAreaClassName: Q.string, value: Q.string };
var CXt = OF, { useDisabled: IXt, useLocalizer: OXt, usePonyfill: RXt, useSendBoxValue: mge, useStopDictate: wXt, useStyleOptions: PXt } = Vt, DXt = { "&.webchat__send-box-text-box": { display: "flex", "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__text-area": { flex: 1 } } };
function gge() {
  let e = TF();
  return mt((t) => e({ setFocus: t || void 0 }), [e]);
}
function xXt() {
  let [e, t] = mge(), r = wXt(), n = mt((i) => {
    if (typeof i != "string") throw new Error("botframework-webchat: First argument passed to useTextBoxValue() must be a string.");
    t(i), r();
  }, [t, r]);
  return [e, n];
}
var NXt = (e) => e.preventDefault(), LXt = JC(TXt), BXt = JC(CXt), kXt = ({ className: e = "" }) => {
  let [t, r] = mge(), [{ sendBoxTextBox: n }] = pr(), [{ emojiSet: i, sendBoxTextWrap: o }] = PXt(), [{ setTimeout: a }] = RXt(), [u] = IXt(), s = Ut(), c = OXt(), l = Tn()(DXt) + "", f = vge(), d = Ege(), p = gge(), v = c("TEXT_INPUT_ALT"), h = c("TEXT_INPUT_PLACEHOLDER"), E = mt((S) => {
    let { key: A, shiftKey: O } = S;
    A === "Enter" && !O && (S.preventDefault(), p("sendBox"));
  }, [p]), m = mt((S) => {
    S.preventDefault(), p();
  }, [p]), g = mt((S) => {
    let { ctrlKey: A, metaKey: O, shiftKey: P } = S;
    if (!(A || O || P) && yXt(S)) {
      let U = !0;
      switch (S.key) {
        case "End":
          f({ displacement: 1 / 0 });
          break;
        case "Home":
          d({ displacement: 1 / 0 });
          break;
        case "PageDown":
          f();
          break;
        case "PageUp":
          d();
          break;
        default:
          U = !1;
          break;
      }
      U && (S.preventDefault(), S.stopPropagation());
    }
  }, [f, d]), y = mt((S) => {
    let { noKeyboard: A } = S, { current: O } = s;
    if (O) if (A && !pEe) {
      let P = O.getAttribute("readonly");
      O.setAttribute("readonly", "readonly"), S.waitUntil(async function() {
        await new Promise((U) => a(U, 0)), O && (O.focus(), P ? O.setAttribute("readonly", P) : O.removeAttribute("readonly"));
      }());
    } else O.focus();
  }, [s, a]);
  EEe(y);
  let _ = tt(() => new Map(Object.entries(i)), [i]);
  return G.createElement("form", { "aria-disabled": u, className: Gt("webchat__send-box-text-box", l, n + "", (e || "") + ""), onSubmit: u ? NXt : m }, o ? G.createElement(BXt, { "aria-label": v, className: "webchat__send-box-text-box__text-area", "data-id": "webchat-sendbox-input", disabled: u, emojiMap: _, enterKeyHint: "send", inputMode: "text", onChange: r, onKeyDownCapture: u ? void 0 : g, onKeyPress: u ? void 0 : E, placeholder: h, readOnly: u, ref: s, rows: 1, textAreaClassName: "webchat__send-box-text-box__html-text-area", value: t }) : G.createElement(LXt, { "aria-label": v, className: "webchat__send-box-text-box__input", "data-id": "webchat-sendbox-input", disabled: u, emojiMap: _, enterKeyHint: "send", inputMode: "text", onChange: r, onKeyDownCapture: u ? void 0 : g, onKeyPress: u ? void 0 : E, placeholder: h, readOnly: u, ref: s, type: "text", value: t }), u && G.createElement("div", { className: "webchat__send-box-text-box__glass" }));
}, Tge = kXt, { DictateState: { DICTATING: MXt, STARTING: FXt } } = YT, { useActivities: HXt, useDirection: $Xt, useDictateState: UXt, useStyleOptions: VXt } = Vt, jXt = { "&.webchat__send-box": { "& .webchat__send-box__button": { flexShrink: 0 }, "& .webchat__send-box__dictation-interims": { flex: 1e4 }, "& .webchat__send-box__main": { display: "flex" }, "& .webchat__send-box__microphone-button": { flex: 1 }, "& .webchat__send-box__text-box": { flex: 1e4 } } };
function zXt(e) {
  var t;
  return e.type === "message" && ((t = e.channelData) == null ? void 0 : t.speak);
}
function yge() {
  let [e] = HXt(), [t] = UXt();
  return [(t === FXt || t === MXt) && !e.filter(zXt).length];
}
var qXt = ({ className: e }) => {
  let [{ sendBoxButtonAlignment: t }] = VXt(), [{ sendBox: r }] = pr(), [{ SpeechRecognition: n = void 0 } = {}] = $h(), [i] = $Xt(), [o] = DKt(), [a] = yge(), u = Tn()(jXt) + "", s = !!n, c = Gt("webchat__send-box__button", { "webchat__send-box__button--align-bottom": t === "bottom", "webchat__send-box__button--align-stretch": t !== "bottom" && t !== "top", "webchat__send-box__button--align-top": t === "top" });
  return G.createElement("div", { "aria-errormessage": o, "aria-invalid": !!o, className: Gt("webchat__send-box", r + "", u + "", (e || "") + ""), dir: i, role: "form" }, G.createElement(pge, null), G.createElement("div", { className: "webchat__send-box__main" }, G.createElement(QHe, { className: c, request: void 0 }), a ? G.createElement(rge, { className: "webchat__send-box__dictation-interims" }) : G.createElement(Tge, { className: "webchat__send-box__text-box" }), s ? G.createElement(sge, { className: Gt(c, "webchat__send-box__microphone-button") }) : G.createElement(cge, { className: c })));
}, _ge = qXt, { useStyleOptions: YXt } = Vt, GXt = ({ className: e }) => {
  let [{ hideSendBox: t }] = YXt();
  return t ? null : G.createElement(_ge, { className: e });
}, WXt = () => Object.freeze([() => () => () => GXt]), KXt = WXt;
function XXt(e, t, r, n) {
  if (e < r && t < n) return { height: t, width: e };
  let i = e / t;
  return i > r / n ? { height: r / i, width: r } : { height: n, width: n * i };
}
function JXt(e, t) {
  let r = document.createElement("canvas");
  return r.height = t, r.width = e, r;
}
function ZXt(e) {
  let t = URL.createObjectURL(e);
  return new Promise((r, n) => {
    let i = document.createElement("img");
    i.addEventListener("error", ({ error: o }) => n(o)), i.addEventListener("load", () => r(i)), i.setAttribute("src", t);
  }).finally(() => {
    URL.revokeObjectURL(t);
  });
}
async function QXt(e, t, r, n, i) {
  let o = await ZXt(e), { height: a, width: u } = XXt(o.width, o.height, t, r), s = JXt(u, a), c = s.getContext("2d");
  if (!c) throw new Error("botframework-webchat: Failed to get 2D context.");
  return c.drawImage(o, 0, 0, u, a), new URL(s.toDataURL(n, i));
}
async function Age(e, t, r, n, i) {
  return await Rme() ? XYt(e, t, r, n, i) : QXt(e, t, r, n, i);
}
var { useStyleOptions: eJt, useTrackTiming: tJt } = Vt;
async function rJt(e, t, r, n, i) {
  try {
    return await Age(e, t, r, n, i);
  } catch (o) {
    console.warn(`Web Chat: Failed to downscale image due to ${o}.`);
  }
}
function QC() {
  let [e] = eJt(), t = tJt(), r = Vo(e);
  return mt((n, i) => {
    let { current: { enableUploadThumbnail: o, uploadThumbnailContentType: a, uploadThumbnailHeight: u, uploadThumbnailQuality: s, uploadThumbnailWidth: c } } = r;
    return o && (i || (n instanceof File ? n.type : "")).startsWith("image/") ? t("sendFiles:makeThumbnail", rJt(n, c, u, a, s)) : Promise.resolve(void 0);
  }, [r, t]);
}
var nJt = { "&.webchat__attachment-icon": { display: "grid", gridTemplateArea: "body", position: "relative", "& .webchat__attachment-icon__icon": { gridArea: "body" }, "&:not(.webchat__attachment-icon--checked) .webchat__attachment-icon__checkmark-icon": { display: "none" }, "& .webchat__attachment-icon__checkmark-icon": { border: "2px solid white", borderRadius: "50%", position: "absolute", left: "45%", top: "50%" } } }, iJt = ({ checked: e }) => {
  let t = Tn()(nJt) + "";
  return G.createElement("div", { className: Gt("webchat__attachment-icon", { "webchat__attachment-icon--checked": e }, t) }, G.createElement("svg", { className: "webchat__attachment-icon__icon", focusable: !1, height: 28, role: "presentation", viewBox: "0 0 25.75 46", width: 28 }, G.createElement("path", { clipRule: "evenodd", d: "M20.75 11.75v21.37a7.69 7.69 0 0 1-.62 3.07 7.95 7.95 0 0 1-4.19 4.19 7.89 7.89 0 0 1-6.13 0 7.95 7.95 0 0 1-4.19-4.19 7.69 7.69 0 0 1-.62-3.07v-22.5a5.27 5.27 0 0 1 .45-2.17 5.69 5.69 0 0 1 3-3 5.48 5.48 0 0 1 4.35 0 5.69 5.69 0 0 1 3 3 5.27 5.27 0 0 1 .45 2.17v22.5a3.41 3.41 0 0 1-.26 1.32 3.31 3.31 0 0 1-1.8 1.8 3.46 3.46 0 0 1-2.63 0 3.31 3.31 0 0 1-1.8-1.8 3.41 3.41 0 0 1-.26-1.32V14h2.25v19.12a1.13 1.13 0 1 0 2.25 0v-22.5a3.4 3.4 0 0 0-.26-1.31 3.31 3.31 0 0 0-1.8-1.8 3.46 3.46 0 0 0-2.63 0 3.31 3.31 0 0 0-1.8 1.8 3.4 3.4 0 0 0-.26 1.31v22.5a5.32 5.32 0 0 0 .45 2.18 5.69 5.69 0 0 0 3 3 5.48 5.48 0 0 0 4.35 0 5.69 5.69 0 0 0 3-3 5.32 5.32 0 0 0 .45-2.18v-21.37z" })), G.createElement("svg", { className: "webchat__attachment-icon__icon webchat__attachment-icon__checkmark-icon", focusable: !1, height: 10, role: "presentation", viewBox: "0 0 10 10", width: 10 }, G.createElement("path", { d: "M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM7.10356 4.10355L4.85357 6.35356C4.65831 6.54883 4.34173 6.54883 4.14646 6.35357L3.14645 5.35357C2.95119 5.1583 2.95118 4.84172 3.14644 4.64646C3.34171 4.45119 3.65829 4.45119 3.85355 4.64645L4.50001 5.29291L6.39644 3.39645C6.59171 3.20119 6.90829 3.20118 7.10355 3.39644C7.29881 3.59171 7.29882 3.90829 7.10356 4.10355Z" })));
}, oJt = iJt, { useDisabled: aJt, useSendBoxAttachments: uJt, useLocalizer: sJt, useStyleOptions: cJt } = Vt, lJt = { "&.webchat__upload-button": { display: "flex", overflow: "hidden", position: "relative", "& .webchat__upload-button--file-input": { height: 0, width: 0, opacity: 0, position: "absolute", left: 0, top: 0 } } }, fJt = (e) => e.preventDefault(), RF = ({ className: e }) => {
  let [{ sendAttachmentOn: t, uploadAccept: r, uploadMultiple: n }] = cJt(), [{ uploadButton: i }] = pr(), [o] = aJt(), [a, u] = uJt(), s = d0(), c = Ut(null), l = sJt(), f = QC(), d = Tn()(lJt) + "", p = TF(), v = Vo(t), h = l("TEXT_INPUT_UPLOAD_BUTTON_ALT"), E = mt(() => {
    var g;
    return (g = c.current) == null ? void 0 : g.click();
  }, [c]), m = mt(({ currentTarget: g }) => {
    s("sendBox"), async function() {
      u(Object.freeze(await Promise.all([...g.files].map((y) => f(y).then((_) => ({ blob: y, thumbnailURL: _ })))))), v.current === "attach" && p();
    }();
  }, [s, f, v, u, p]);
  return G.createElement("div", { className: Gt(d, "webchat__upload-button", i + "", e) }, G.createElement("input", { accept: r, "aria-disabled": o, "aria-hidden": "true", className: "webchat__upload-button--file-input", multiple: n, onChange: o ? void 0 : m, onClick: o ? fJt : void 0, readOnly: o, ref: c, role: "button", tabIndex: -1, type: "file" }), G.createElement(EF, { alt: h, "aria-label": h, disabled: o, onClick: E }, G.createElement(oJt, { checked: !!a.length })));
};
RF.defaultProps = { className: void 0 };
RF.propTypes = { className: Q.string };
var Sge = RF, { useStyleOptions: dJt } = Vt;
function pJt({ className: e }) {
  let [{ hideUploadButton: t }] = dJt();
  return !t && G.createElement(Sge, { className: e });
}
var bge = Nr(pJt), hJt = () => Object.freeze([() => () => () => bge]), vJt = hJt;
function EJt() {
  return { margin: 0, padding: 0 };
}
function mJt({ avatarSize: e }) {
  return { display: "flex", minHeight: e };
}
function gJt() {
  return { width: "100%" };
}
function TJt({ primaryFont: e }) {
  return { "&.webchat__auto-resize-textarea": { fontFamily: e, overflow: "hidden", position: "relative", "& .webchat__auto-resize-textarea__doppelganger": { color: "transparent", height: "100%", overflowY: "auto", userSelect: "none", width: "inherit", whiteSpace: "pre-wrap", wordBreak: "break-word" }, "& .webchat__auto-resize-textarea__textarea": { appearance: "none", backgroundColor: "transparent", border: 0, color: "inherit", fontFamily: "inherit", fontSize: "inherit", height: "100%", left: 0, margin: 0, outline: 0, overflowY: "auto", padding: 0, position: "absolute", resize: "none", top: 0, width: "100%", wordBreak: "break-word" } } };
}
function yJt({ avatarBorderRadius: e, avatarSize: t }) {
  return { "&.webchat__defaultAvatar": { borderRadius: e, height: t, width: t } };
}
function _Jt({ paddingRegular: e, primaryFont: t, transcriptActivityVisualKeyboardIndicatorColor: r, transcriptActivityVisualKeyboardIndicatorStyle: n, transcriptActivityVisualKeyboardIndicatorWidth: i, transcriptTerminatorBackgroundColor: o, transcriptTerminatorBorderRadius: a, transcriptTerminatorColor: u, transcriptTerminatorFontSize: s, transcriptVisualKeyboardIndicatorColor: c, transcriptVisualKeyboardIndicatorStyle: l, transcriptVisualKeyboardIndicatorWidth: f }) {
  return { "&.webchat__basic-transcript": { "&:focus": { outline: 0, "& .webchat__basic-transcript__activity-indicator.webchat__basic-transcript__activity-indicator--focus": { borderColor: r, borderStyle: n, borderWidth: i, boxSizing: "border-box", height: `calc(100% - ${e / 2}px)`, left: 0, marginBottom: 0, marginLeft: e / 2, marginRight: e / 2, marginTop: 0, pointerEvents: "none", position: "absolute", top: 0, width: `calc(100% - ${e}px)` } }, "&:focus-visible .webchat__basic-transcript__focus-indicator, .webchat__basic-transcript__terminator:focus-visible + .webchat__basic-transcript__focus-indicator": { height: "100%", borderColor: c, borderStyle: l, borderWidth: f, boxSizing: "border-box", pointerEvents: "none", position: "absolute", top: 0, width: "100%" }, "& .webchat__basic-transcript__activity": { paddingTop: e / 2, position: "relative", "&:first-child": { marginTop: e / 2 }, "&:not(:first-child)": { marginTop: -e / 2 } }, "& .webchat__basic-transcript__activity-active-descendant": { height: "100%", left: 0, marginTop: -e / 2, paddingBottom: e / 2, pointerEvents: "none", position: "absolute", top: 0, width: "100%" }, "& .webchat__basic-transcript__activity-body:not(:empty)": { paddingBottom: e }, "& .webchat__basic-transcript__terminator": { bottom: 0, height: 0, outline: 0, position: "relative", width: "100%" }, "& .webchat__basic-transcript__terminator-body": { bottom: 0, display: "flex", justifyContent: "center", position: "absolute", width: "100%" }, "& .webchat__basic-transcript__terminator:not(:focus) .webchat__basic-transcript__terminator-body": { display: "none" }, "& .webchat__basic-transcript__terminator-text": { backgroundColor: o, borderRadius: a, color: u, fontFamily: t, fontSize: s, margin: e / 2, padding: e / 2 } } };
}
function e3(e, t) {
  let r = {};
  for (let [i, o] of Object.entries(t)) if (typeof o == "number" || typeof o == "string") {
    let a = i.replace(/(^left|^right|Left|Right)/u, (u) => u === "Left" ? "Right" : u === "left" ? "right" : u === "Right" ? "Left" : "left");
    ia(a) || (r[a] = o);
  } else ia(i) || (r[i] = e3("", o));
  let n = /^&\s*/gu.exec(e) || "";
  return e ? { [`${n}:not(${e.substr(n.length)})`]: t, [e]: r } : r;
}
function AJt({ bubbleBackground: e, bubbleBorderColor: t, bubbleBorderRadius: r, bubbleBorderStyle: n, bubbleBorderWidth: i, bubbleFromUserBackground: o, bubbleFromUserBorderColor: a, bubbleFromUserBorderRadius: u, bubbleFromUserBorderStyle: s, bubbleFromUserBorderWidth: c, bubbleFromUserNubOffset: l, bubbleFromUserNubSize: f, bubbleFromUserTextColor: d, bubbleMinHeight: p, bubbleNubOffset: v, bubbleNubSize: h, bubbleTextColor: E, messageActivityWordBreak: m, paddingRegular: g, transitionDuration: y }) {
  let _ = typeof v == "number" ? Math.min(r, Math.abs(v)) : r, S = typeof l == "number" ? Math.min(u, Math.abs(l)) : u;
  return { "&.webchat__bubble": { "& .webchat__bubble__content": { marginLeft: 0, marginRight: 0, transitionDuration: y, transitionProperty: "margin-left, margin-right", wordBreak: m }, "& .webchat__bubble__nub": { overflow: "hidden", position: "absolute" }, "& .webchat__bubble__nub-pad": { transitionDuration: y, transitionProperty: "width", width: 0 }, "&.webchat__bubble--hide-nub, &.webchat__bubble--show-nub": { "& .webchat__bubble__nub-pad": { width: g } }, "&.webchat__bubble--rtl .webchat__bubble__nub": { transform: "scale(-1, 1)" }, "&:not(.webchat__bubble--from-user)": { "& .webchat__bubble__content": { background: e, borderColor: t, borderRadius: r, borderStyle: n, borderWidth: i, color: E, minHeight: p - i * 2 }, ...typeof h == "number" ? { "& .webchat__bubble__nub": { height: h, width: h } } : {}, "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__nub": { bottom: -v }, "&.webchat__bubble--nub-on-top .webchat__bubble__nub": { top: v }, "& .webchat__bubble__nub-outline": { fill: e, stroke: t, strokeWidth: i } }, "&.webchat__bubble--from-user": { flexDirection: "row-reverse", "& .webchat__bubble__content": { background: o, borderColor: a, borderRadius: u, borderStyle: s, borderWidth: c, color: d, minHeight: p - c * 2 }, ...typeof f == "number" ? { "& .webchat__bubble__nub": { height: f, width: f } } : {}, "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__nub": { bottom: -l }, "&.webchat__bubble--nub-on-top .webchat__bubble__nub": { top: l }, "& .webchat__bubble__nub-outline": { fill: o, stroke: a, strokeWidth: c } }, ...e3("&.webchat__bubble--rtl", { "&:not(.webchat__bubble--from-user)": { "&.webchat__bubble--show-nub": { "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__content": { borderBottomLeftRadius: _ }, "&.webchat__bubble--nub-on-top .webchat__bubble__content": { borderTopLeftRadius: _ } }, ...typeof h == "number" ? { "& .webchat__bubble__nub": { left: i - h + g } } : {} }, "&.webchat__bubble--from-user": { "&.webchat__bubble--show-nub": { "&:not(.webchat__bubble--nub-on-top) .webchat__bubble__content": { borderBottomRightRadius: S }, "&.webchat__bubble--nub-on-top .webchat__bubble__content": { borderTopRightRadius: S } }, ...typeof f == "number" ? { "& .webchat__bubble__nub": { right: c - f + g } } : {} } }) } };
}
function SJt({ avatarSize: e, bubbleMaxWidth: t, paddingRegular: r, transitionDuration: n }) {
  return { "&.webchat__carousel-filmstrip": { "@supports (-moz-appearance: none)": { marginBottom: -17 }, "& .webchat__carousel-filmstrip__message": { maxWidth: t, transitionDuration: n, transitionProperty: "max-width" }, "&.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub, &.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": { "& .webchat__carousel-filmstrip__message": { maxWidth: t + r } }, "& .webchat__carousel-filmstrip__alignment-pad": { transitionDuration: n, transitionProperty: "width", width: r }, "&.webchat__carousel-filmstrip--extra-trailing .webchat__carousel-filmstrip__alignment-pad": { width: r * 2 }, "&:not(.webchat__carousel-filmstrip--no-message) .webchat__carousel-filmstrip__attachments": { marginTop: r }, "& .webchat__carousel-filmstrip__avatar-gutter": { alignItems: "flex-end", transitionDuration: n, transitionProperty: "width" }, "& .webchat__carousel-filmstrip__nub-pad": { transitionDuration: n, transitionProperty: "width", width: 0 }, "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": { "& .webchat__carousel-filmstrip__avatar-gutter": { width: e } }, "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar, &.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub": { "& .webchat__carousel-filmstrip__nub-pad": { width: r } }, "&:not(.webchat__carousel-filmstrip--top-callout) .webchat__carousel-filmstrip__avatar-gutter": { justifyContent: "flex-end" }, ...e3("&.webchat__carousel-filmstrip--rtl", { "& .webchat__carousel-filmstrip__avatar-gutter": { marginLeft: r }, "& .webchat__carousel-filmstrip__attachments": { marginLeft: -r }, "&.webchat__carousel-filmstrip--hide-avatar, &.webchat__carousel-filmstrip--show-avatar": { "& .webchat__carousel-filmstrip__attachments": { marginLeft: -(e + r * 2) } }, "&.webchat__carousel-filmstrip--hide-nub, &.webchat__carousel-filmstrip--show-nub": { "&:not(.webchat__carousel-filmstrip--hide-avatar.webchat__carousel-filmstrip--show-avatar)": { "& .webchat__carousel-filmstrip__attachments": { marginLeft: -r * 2 } } } }) } };
}
function bJt({ avatarSize: e, bubbleMaxWidth: t, bubbleMinWidth: r, paddingRegular: n, transcriptVisualKeyboardIndicatorColor: i, transcriptVisualKeyboardIndicatorStyle: o, transcriptVisualKeyboardIndicatorWidth: a, transitionDuration: u }) {
  return { "&.webchat__carousel-filmstrip-attachment": { minWidth: r, maxWidth: t, transitionDuration: u, transitionProperty: "max-width, min-width", "&:focus": { outline: 0 }, "&:focus .webchat__carousel-filmstrip-attachment--focus": { borderColor: i, borderStyle: o, borderWidth: a, boxSizing: "border-box", height: `calc(100% - ${a}px)`, left: 0, pointerEvents: "none", position: "absolute", top: 0, width: `calc(100% - ${a}px)` } }, ...e3("&.webchat__carousel-filmstrip-attachment--rtl", { paddingLeft: n, "&.webchat__carousel-filmstrip-attachment--hide-avatar, &.webchat__carousel-filmstrip-attachment--show-avatar": { "&:first-child": { paddingLeft: e + n * 2 } }, "&.webchat__carousel-filmstrip-attachment--hide-nub, &.webchat__carousel-filmstrip-attachment--show-nub": { "&:not(.webchat__carousel-filmstrip-attachment--hide-avatar.webchat__carousel-filmstrip-attachment--show-avatar):first-child": { paddingLeft: n * 2 } } }) };
}
function CJt({ transcriptOverlayButtonBackground: e, transcriptOverlayButtonBackgroundOnDisabled: t, transcriptOverlayButtonBackgroundOnFocus: r, transcriptOverlayButtonBackgroundOnHover: n, transcriptOverlayButtonColor: i, transcriptOverlayButtonColorOnDisabled: o, transcriptOverlayButtonColorOnFocus: a, transcriptOverlayButtonColorOnHover: u }) {
  return { "&.webchat__carousel-layout": { "& .react-film__flipper": { "& .react-film__flipper__body": { backgroundColor: e, color: i, outline: 0 }, '&:disabled, &[aria-disabled="true"]': { "& .react-film__flipper__body": { backgroundColor: t, color: o } }, "&:focus .react-film__flipper__body": { backgroundColor: r, color: a || i }, "&:hover .react-film__flipper__body": { backgroundColor: n, color: u || i } } } };
}
function IJt() {
  return { "&.webchat__citation-modal-dialog": { "& .webchat__citation-modal-dialog__body": { lineHeight: "20px" } } };
}
function OJt({ connectivityMarginLeftRight: e, connectivityMarginTopBottom: t, connectivityTextSize: r, notificationText: n, primaryFont: i }) {
  return { alignItems: "center", color: n, display: "flex", fontFamily: i, fontSize: r, marginBottom: t, marginLeft: e, marginRight: e, marginTop: t };
}
var RJt = Object.freeze({ ColorAccent: "--webchat__color--accent", ColorSubtle: "--webchat__color--subtle", ColorTimestamp: "--webchat__color--timestamp", FontPrimary: "--webchat__font--primary", FontSizeSmall: "--webchat__font-size--small", IconURLExternalLink: "--webchat__icon-url--external-link", MaxWidthBubble: "--webchat__max-width--bubble", MinHeightBubble: "--webchat__min-height--bubble", PaddingRegular: "--webchat__padding--regular" }), $s = RJt;
function wJt({ accent: e, bubbleMaxWidth: t, bubbleMinHeight: r, fontSizeSmall: n, markdownExternalLinkIconImage: i, paddingRegular: o, primaryFont: a, subtle: u, timestampColor: s }) {
  return { "&.webchat__css-custom-properties": { display: "contents", [$s.ColorAccent]: e, [$s.ColorSubtle]: u, [$s.ColorTimestamp]: s || u, [$s.FontPrimary]: a, [$s.FontSizeSmall]: n, [$s.IconURLExternalLink]: i, [$s.MaxWidthBubble]: t + "px", [$s.MinHeightBubble]: r + "px", [$s.PaddingRegular]: o + "px" } };
}
function PJt({ paddingRegular: e, primaryFont: t }) {
  return { fontFamily: t, margin: 0, paddingBottom: 0, paddingLeft: e, paddingRight: e, paddingTop: 0, "&.dictating > span:not(:first-child), &.status": { opacity: 0.5 } };
}
function DJt({ monospaceFont: e, primaryFont: t }) {
  return { display: "flex", flexDirection: "column", fontFamily: t, margin: 0, minHeight: 20, maxHeight: 200, overflowY: "auto", WebkitOverflowScrolling: "touch", "& > :first-child": { backgroundColor: "#EF0000", color: "White", padding: "5px 10px" }, "& > :last-child": { borderColor: "#EF0000", borderStyle: "dashed", borderBottomWidth: 2, borderLeftWidth: 2, borderRightWidth: 2, borderTopWidth: 0, margin: 0, overflowY: "auto", padding: 10, "& > pre": { fontFamily: e, fontSize: "60%", margin: 0 } } };
}
function xJt({ connectivityIconPadding: e, connectivityMarginLeftRight: t, connectivityMarginTopBottom: r, connectivityTextSize: n, failedConnectivity: i, primaryFont: o }) {
  return { alignItems: "center", color: i, display: "flex", fontFamily: o, fontSize: n, fontWeight: "bold", marginBottom: r, marginLeft: t, marginRight: t, marginTop: r, "& > svg": { fill: i, "&:not(.webchat__error--rtl)": { paddingRight: e }, "&.webchat__error--rtl": { paddingLeft: e } } };
}
function NJt({ accent: e, bubbleTextColor: t, paddingRegular: r, primaryFont: n }) {
  return { color: t, display: "flex", fontFamily: n, padding: r, "& .webchat__fileContent__badge": { justifyContent: "center" }, "& .webchat__fileContent__buttonLink": { alignItems: "center", color: t, textDecoration: "none", "&:focus": { backgroundColor: "rgba(0, 0, 0, .1)" } }, "& .webchat__fileContent__downloadIcon": { fill: e, padding: r, "&:not(.webchat__fileContent__downloadIcon--rtl)": { marginLeft: r }, "&.webchat__fileContent__downloadIcon--rtl": { marginRight: r } }, "& .webchat__fileContent__fileName": { color: e } };
}
function LJt({ avatarSize: e }) {
  return { height: e, overflow: "hidden", width: e };
}
function BJt({ accent: e, avatarSize: t, botAvatarBackgroundColor: r, primaryFont: n, userAvatarBackgroundColor: i }) {
  return { "&.webchat__initialsAvatar": { alignItems: "center", color: "White", fontFamily: n, height: t, justifyContent: "center", overflow: "hidden", width: t, "&.webchat__initialsAvatar--fromUser": { backgroundColor: i || e }, "&:not(.webchat__initialsAvatar--fromUser)": { backgroundColor: r || e } } };
}
var oA = "@media (forced-colors: none) and (prefers-color-scheme: dark)", kJt = "@media (forced-colors: none) and (prefers-color-scheme: light)", aA = "@media (forced-colors: active)";
function MJt({ paddingRegular: e, primaryFont: t }) {
  return { "&.webchat__keyboard-help": { fontFamily: t, fontSize: 14, height: "100%", outline: 0, overflow: "hidden", "&:not(.webchat__keyboard-help--shown)": { height: 0, margin: 0, overflow: "hidden", pointerEvents: "none", width: 0 }, "& .webchat__keyboard-help__border": { boxSizing: "border-box", height: "100%", padding: e }, "& .webchat__keyboard-help__box": { borderRadius: 2, boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)", height: "100%", overflow: "hidden", [aA]: { backgroundColor: "Canvas", boxShadow: "none", outlineColor: "ButtonBorder", outlineStyle: "solid", outlineWidth: 4 }, [oA]: { backgroundColor: "Black", boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.28), 0px 0px 2px rgba(0, 0, 0, 0.24)" } }, "& .webchat__keyboard-help__scrollable": { boxSizing: "border-box", height: "100%", overflowY: "auto", padding: e * 2, position: "relative" }, "& .webchat__keyboard-help__close-button": { appearance: "none", backgroundColor: "transparent", border: 0, outline: 0, padding: e, pointerEvents: "none", position: "absolute", right: 0, top: 0 }, "& .webchat__keyboard-help__close-button-border": { alignItems: "center", borderRadius: 4, borderStyle: "solid", borderWidth: 2, color: "#999", display: "flex", height: 30, justifyContent: "center", pointerEvents: "initial", width: 30, [kJt]: { borderColor: "black", "&:active": { backgroundColor: "#EDEBE9" }, "&:not(:active):hover": { backgroundColor: "#F3F2F1" } }, [oA]: { borderColor: "white", "&:active": { backgroundColor: "#292827" }, "&:not(:active):hover": { backgroundColor: "#252423" } }, [aA]: { backgroundColor: "ButtonFace", borderColor: "ButtonBorder" } }, "& .webchat__keyboard-help__close-button-image": { fill: "#323130", height: 10, width: 10, [aA]: { fill: "ButtonText" }, [oA]: { fill: "#F3F2F1" } }, "& .webchat__keyboard-help__header, & .webchat__keyboard-help__sub-header": { marginBottom: e / 2, marginTop: 0 }, "& .webchat__keyboard-help__section:not(:last-child)": { marginBottom: e }, "& .webchat__keyboard-help__two-panes": { alignItems: "flex-start", display: "flex" }, "& .webchat__keyboard-help__image": { paddingRight: e }, "& .webchat__keyboard-help__image--dark, & .webchat__keyboard-help__image--high-contrast": { display: "none" }, [aA]: { "& .webchat__keyboard-help__image--dark, & .webchat__keyboard-help__image--light": { display: "none" }, "& .webchat__keyboard-help__image--high-contrast": { display: "unset", mixBlendMode: "difference" } }, [oA]: { color: "#F3F2F1", "& .webchat__keyboard-help__image--light": { display: "none" }, "& .webchat__keyboard-help__image--dark": { display: "unset" } }, "& .webchat__keyboard-help__notes": { marginBottom: e, marginTop: 0 }, "& .webchat__keyboard-help__notes-header": { fontWeight: "bold", margin: 0 }, "& .webchat__keyboard-help__notes-pane": { flexShrink: 1e4 }, "& .webchat__keyboard-help__notes-text": { margin: 0 } } };
}
var K1 = "@media (forced-colors: active)", Ip = "@media (forced-colors: none)", FJt = new Proxy({}, { get(e, t) {
  return `var(${$s[t]})`;
} }), ni = FJt, ZR = "@media (forced-colors: none) and not (forced-colors: none)", QR = "@media (forced-colors: none)";
function HJt() {
  return { "&.webchat__link-definitions": { ".webchat__link-definitions__header": { alignItems: "center", display: "flex", fontFamily: ni.FontPrimary, fontSize: ni.FontSizeSmall, gap: 4, listStyle: "none", [QR]: { color: "#616161" }, [ZR]: { color: "#616161" } }, ".webchat__link-definitions__header-text": { flexShrink: 0 }, ".webchat__link-definitions__header::-webkit-details-marker": { display: "none" }, ".webchat__link-definitions__header-chevron": { flexShrink: 0 }, "&:not([open]) .webchat__link-definitions__header-chevron": { transform: "rotate(-180deg)" }, ".webchat__link-definitions__header-filler": { flexGrow: 1 }, ".webchat__link-definitions__header-accessory": { overflow: "hidden" }, ".webchat__link-definitions__message-sensitivity-label": { display: "flex", gap: 4 }, ".webchat__link-definitions__message-sensitivity-label-icon": { color: "CanvasText", flexShrink: 0 }, ".webchat__link-definitions__message-sensitivity-label-text": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, ".webchat__link-definitions__list": { display: "flex", flexDirection: "column", gap: 4, margin: "4px 0 0", padding: 0 }, ".webchat__link-definitions__list-item": { display: "flex", flexDirection: "column" }, ".webchat__link-definitions__badge": { alignItems: "center", alignSelf: "flex-start", borderRadius: "4px", borderStyle: "solid", borderWidth: 1, display: "flex", flexShrink: 0, fontSize: "75%", justifyContent: "center", margin: 4, minWidth: "1em", overflow: "hidden", padding: 2, whiteSpace: "nowrap", [QR]: { backgroundColor: "white", borderColor: "#e0e0e0", color: "black" }, [ZR]: { backgroundColor: "black", borderColor: "#e0e0e0", color: "white" }, [K1]: { borderColor: "buttonborder" } }, ".webchat__link-definitions__list-item-box": { alignItems: "center", borderRadius: 4, borderStyle: "solid", borderWidth: 1, [QR]: { backgroundColor: "white", borderColor: "#d1d1d1" }, [ZR]: { backgroundColor: "black", borderColor: "#d1d1d1" }, [K1]: { backgroundColor: "canvas", borderColor: "buttonborder" } }, ".webchat__link-definitions__list-item-box--as-link": { display: "block", outlineOffset: 0, textDecoration: "none" }, ".webchat__link-definitions__list-item-box--as-button": { appearance: "none", background: "transparent", cursor: "pointer", fontFamily: "inherit", fontSize: "inherit", overflow: "hidden", padding: 0, textAlign: "initial" }, ".webchat__link-definitions__list-item-body": { alignItems: "center", display: "flex", fontFamily: "Calibri, 'Helvetica Neue', Arial, 'sans-serif'", gap: 4, padding: 4 }, ".webchat__link-definitions__list-item-body-main": { display: "flex", flexDirection: "column", gap: 2, overflow: "hidden" }, ".webchat__link-definitions__list-item-main-text": { alignItems: "baseline", display: "flex", gap: 4 }, ".webchat__link-definitions__list-item-badge, .webchat__link-definitions__list-item-text": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, ".webchat__link-definitions__list-item-text": { textDecoration: "underline", [Ip]: { color: ni.ColorAccent } }, ".webchat__link-definitions__list-item-badge": { fontSize: ni.FontSizeSmall, [Ip]: { color: ni.ColorSubtle } }, ".webchat__link-definitions__open-in-new-window-icon": { flexShrink: 0, paddingRight: 4, [Ip]: { color: ni.ColorAccent } } } };
}
function $Jt({ microphoneButtonColorOnDictate: e }) {
  return { "&.webchat__microphone-button": { "&.webchat__microphone-button--dictating .webchat__microphone-button__button": { "&, &:focus, &:hover": { "& .webchat__microphone-button__icon": { fill: e } } } } };
}
var ew = "@media (forced-colors: none) and not (forced-colors: none)", tw = "@media (forced-colors: none)";
function UJt() {
  return { "&.webchat__modal-dialog": { fontFamily: ni.FontPrimary, maxHeight: "calc(100% - 32px)", maxWidth: "calc(100% - 32px)", width: "100%", [Ip]: { backgroundColor: "transparent", border: 0 }, "& .webchat__modal-dialog__box": { borderRadius: 2, overflow: "hidden", margin: "auto", "@media screen and (max-width: 639px)": { maxWidth: "unset" }, "@media screen and (min-width: 640px)": { maxWidth: "60%", minWidth: "calc(640px - 32px)", width: "60%" }, [tw]: { backgroundColor: "White", boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)" }, [ew]: { backgroundColor: "Black", boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.28), 0px 0px 2px rgba(0, 0, 0, 0.24)", color: "White" }, [K1]: { outlineColor: "ButtonBorder", outlineStyle: "solid", outlineWidth: 4 } }, "& .webchat__modal-dialog__close-button-layout": { float: "right", padding: ni.PaddingRegular }, "& .webchat__modal-dialog__close-button": { height: 30, width: 30, [Ip]: { appearance: "none", backgroundColor: "transparent", borderColor: "transparent", borderRadius: 4, borderStyle: "solid", borderWidth: 2, color: "#999", outline: 0 } }, "& .webchat__modal-dialog__close-button:focus": { [tw]: { borderColor: "black", "&:active": { backgroundColor: "#EDEBE9" }, "&:not(:active):hover": { backgroundColor: "#F3F2F1" } }, [ew]: { borderColor: "white", "&:active": { backgroundColor: "#292827" }, "&:not(:active):hover": { backgroundColor: "#252423" } } }, "& .webchat__modal-dialog__close-button-image": { height: 10, width: 10, [tw]: { fill: "#323130" }, [ew]: { fill: "#F3F2F1" }, [K1]: { fill: "currentcolor" } }, "& .webchat__modal-dialog__body": { margin: `calc(${ni.PaddingRegular} * 2)` } } };
}
function VJt() {
  return { "&.webchat__render-markdown": { display: "contents", "&.webchat__render-markdown--adaptive-cards > *:first-child": { marginTop: 0, width: "100%", overflow: "hidden", textOverflow: "ellipsis" }, "&.webchat__render-markdown--adaptive-cards > *:last-child": { marginBottom: 0 }, "&.webchat__render-markdown--message-activity > *:first-child": { marginTop: 0 }, "&.webchat__render-markdown--message-activity > *:last-child": { marginBottom: 0 }, "& .webchat__render-markdown__external-link-icon": { backgroundImage: ni.IconURLExternalLink, height: ".75em", marginLeft: ".25em" }, "& .webchat__render-markdown__citation": { background: "transparent", border: 0, cursor: "pointer", fontFamily: "unset", fontSize: "unset", padding: 0, textDecoration: "underline", whiteSpace: "nowrap", [K1]: { color: "LinkText" }, [Ip]: { color: ni.ColorAccent } }, "& .webchat__render-markdown__pure-identifier": { whiteSpace: "nowrap" }, "& .webchat__render-markdown__pure-identifier::after": { content: "']'" }, "& .webchat__render-markdown__pure-identifier::before": { content: "'['" } } };
}
function jJt({ backgroundColor: e, rootHeight: t, rootWidth: r, rootZIndex: n }) {
  return { backgroundColor: e, height: t, width: r, zIndex: n };
}
function zJt({ paddingRegular: e, primaryFont: t, scrollToEndButtonFontSize: r, transcriptOverlayButtonBackground: n, transcriptOverlayButtonBackgroundOnFocus: i, transcriptOverlayButtonBackgroundOnHover: o, transcriptOverlayButtonColor: a, transcriptOverlayButtonColorOnFocus: u, transcriptOverlayButtonColorOnHover: s }) {
  return { "&.webchat__scroll-to-end-button": { "@media screen and (forced-colors: active)": { borderWidth: "initial", outline: "initial" }, appearance: "none", backgroundColor: n, borderRadius: e, borderWidth: 0, bottom: 5, color: a, fontFamily: t, fontSize: r, outline: 0, padding: e, position: "absolute", zIndex: 1, "&:hover": { backgroundColor: o, color: s || a }, "&:focus": { backgroundColor: i, color: u || a }, "&:not(.webchat__scroll-to-end-button--rtl)": { right: 20 }, "&.webchat__scroll-to-end-button--rtl": { left: 20 } } };
}
function qJt({ sendBoxButtonColor: e, sendBoxButtonColorOnActive: t, sendBoxButtonColorOnDisabled: r, sendBoxButtonColorOnFocus: n, sendBoxButtonColorOnHover: i, sendBoxButtonKeyboardFocusIndicatorBorderColor: o, sendBoxButtonKeyboardFocusIndicatorBorderRadius: a, sendBoxButtonKeyboardFocusIndicatorBorderStyle: u, sendBoxButtonKeyboardFocusIndicatorBorderWidth: s, sendBoxButtonKeyboardFocusIndicatorInset: c, sendBoxButtonShadeBorderRadius: l, sendBoxButtonShadeColor: f, sendBoxButtonShadeColorOnActive: d, sendBoxButtonShadeColorOnDisabled: p, sendBoxButtonShadeColorOnFocus: v, sendBoxButtonShadeColorOnHover: h, sendBoxButtonShadeInset: E, sendBoxHeight: m, subtle: g }) {
  return { "&.webchat__icon-button": { alignItems: "center", appearance: "none", backgroundColor: "Transparent", border: 0, display: "flex", fill: e || g, justifyContent: "center", outline: 0, padding: 0, position: "relative", width: m, "&:not(.webchat__icon-button--stretch)": { height: m }, '&:disabled, &[aria-disabled="true"]': { fill: r, "& .webchat__icon-button__shade": { backgroundColor: p } }, '&:not(:disabled):not([aria-disabled="true"])': { "&:active": { fill: t, "& .webchat__icon-button__shade": { backgroundColor: d } }, "&:not(:active)": { "&:hover": { fill: i, "& .webchat__icon-button__shade": { backgroundColor: h } }, "&:not(:hover)": { "&:focus": { fill: n, "& .webchat__icon-button__shade": { backgroundColor: v } } } } }, "&:not(:focus-visible) .webchat__icon-button__keyboard-focus-indicator": { display: "none" }, "&:not(.webchat__icon-button--focus-visible) .webchat__icon-button__keyboard-focus-indicator": { display: "none" }, "& > *": { position: "relative" }, "& .webchat__icon-button__shade": { backgroundColor: f, borderRadius: l, bottom: E, left: E, position: "absolute", right: E, top: E }, "& .webchat__icon-button__keyboard-focus-indicator": { borderColor: o, borderRadius: a, borderStyle: u, borderWidth: s, bottom: c, left: c, position: "absolute", right: c, top: c } } };
}
function YJt({ sendBoxBackground: e, sendBoxBorderBottom: t, sendBoxBorderLeft: r, sendBoxBorderRight: n, sendBoxBorderTop: i, sendBoxHeight: o }) {
  return { "&.webchat__send-box": { "& .webchat__send-box__button--align-bottom": { alignSelf: "flex-end" }, "& .webchat__send-box__button--align-stretch": { alignSelf: "stretch" }, "& .webchat__send-box__button--align-top": { alignSelf: "flex-start" }, "& .webchat__send-box__main": { alignItems: "stretch", backgroundColor: e, borderBottom: t, borderLeft: r, borderRight: n, borderTop: i, minHeight: o } } };
}
function GJt({ paddingRegular: e, primaryFont: t, sendBoxDisabledTextColor: r, sendBoxMaxHeight: n, sendBoxPlaceholderColor: i, sendBoxTextColor: o, subtle: a }) {
  return { "&.webchat__send-box-text-box": { alignItems: "center", fontFamily: t, padding: e, position: "relative", "& .webchat__send-box-text-box__input": { border: 0, fontFamily: "inherit", fontSize: "inherit", height: "100%", outline: 0, padding: 0 }, "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__html-text-area": { backgroundColor: "transparent", '&:not(:disabled):not([aria-disabled="true"])': { color: o }, '&:disabled, &[aria-disabled="true"]': { color: r || a }, "&::placeholder": { color: i || a } }, "& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__text-area": { maxHeight: n }, "& .webchat__send-box-text-box__glass": { height: "100%", left: 0, position: "absolute", top: 0, userSelect: 0, width: "100%" } } };
}
function WJt() {
  return { "&.webchat__activity-status": { color: ni.ColorTimestamp, fontFamily: ni.FontPrimary, fontSize: ni.FontSizeSmall, marginTop: `calc(${ni.PaddingRegular} / 2)` }, "&.webchat__activity-status--slotted": { display: "inline-flex", gap: 4 }, "& .webchat__activity-status__originator": { alignItems: "center", "&.webchat__activity-status__originator--has-link": { color: ni.ColorAccent } } };
}
function KJt({ bubbleMaxWidth: e, bubbleMinWidth: t, paddingRegular: r }) {
  return { "& > .bubble-box": { maxWidth: e, minWidth: t }, "& > .filler": { minWidth: r } };
}
function XJt() {
  return { "&.webchat__slotted-activity-status": { alignItems: "center", display: "inline-flex", gap: 4, marginTop: `calc(${ni.PaddingRegular} / 2)`, "& .webchat__slotted-activity-status__pipe": { fontSize: ni.FontSizeSmall } } };
}
var JJt = "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", ZJt = "image/gif", rw;
function QJt({ spinnerAnimationBackgroundImage: e, spinnerAnimationHeight: t, spinnerAnimationWidth: r, spinnerAnimationPadding: n }) {
  return rw || (rw = URL.createObjectURL(new Blob([nM(JJt)], { type: ZJt }))), { backgroundImage: e || `url('${rw}')`, backgroundRepeat: "no-repeat", backgroundSize: "contain", height: t, width: r, ":not(.webchat__spinner--rtl)": { marginRight: n }, ".webchat__spinner--rtl": { marginLeft: n } };
}
function eZt({ avatarSize: e, bubbleMaxWidth: t, bubbleMinWidth: r, paddingRegular: n, transitionDuration: i }) {
  return { "&.webchat__stacked-layout": { marginLeft: n, marginRight: n, "& .webchat__stacked-layout__alignment-pad": { transitionDuration: i, transitionProperty: "width", width: 0 }, "&.webchat__stacked-layout--extra-trailing .webchat__stacked-layout__alignment-pad": { width: n }, "& .webchat__stacked-layout__avatar-gutter": { transitionDuration: i, transitionProperty: "width", width: 0 }, "& .webchat__stacked-layout__attachment": { maxWidth: t, minWidth: r, transitionDuration: i, transitionProperty: "max-width, min-width" }, "& .webchat__stacked-layout__attachment-row": { marginTop: n, width: "100%" }, "&.webchat__stacked-layout--no-message .webchat__stacked-layout__attachment-row.webchat__stacked-layout__attachment-row--first": { marginTop: 0 }, "& .webchat__stacked-layout__message": { maxWidth: t, overflow: "hidden", transitionDuration: i, transitionProperty: "max-width" }, "& .webchat__stacked-layout__nub-pad": { transitionDuration: i, transitionProperty: "width", width: 0 }, "&.webchat__stacked-layout--hide-avatar, &.webchat__stacked-layout--show-avatar": { "& .webchat__stacked-layout__avatar-gutter": { width: e } }, "&.webchat__stacked-layout--hide-avatar, &.webchat__stacked-layout--show-avatar, &.webchat__stacked-layout--hide-nub, &.webchat__stacked-layout--show-nub": { "& .webchat__stacked-layout__attachment, & .webchat__stacked-layout__message": { maxWidth: t + n }, "& .webchat__stacked-layout__nub-pad": { width: n } }, "&:not(.webchat__stacked-layout--top-callout)": { "& .webchat__stacked-layout__avatar-gutter, & .webchat__stacked-layout__content": { justifyContent: "flex-end" } } } };
}
function tZt({ paddingRegular: e, suggestedActionsCarouselFlipperSize: t, suggestedActionsFlowMaxHeight: r, suggestedActionsStackedHeight: n, suggestedActionsStackedOverflow: i, suggestedActionsVisualKeyboardIndicatorColor: o, suggestedActionsVisualKeyboardIndicatorStyle: a, suggestedActionsVisualKeyboardIndicatorWidth: u, transcriptOverlayButtonBackground: s, transcriptOverlayButtonBackgroundOnDisabled: c, transcriptOverlayButtonBackgroundOnFocus: l, transcriptOverlayButtonBackgroundOnHover: f, transcriptOverlayButtonColor: d, transcriptOverlayButtonColorOnDisabled: p, transcriptOverlayButtonColorOnFocus: v, transcriptOverlayButtonColorOnHover: h }) {
  return { "&.webchat__suggested-actions": { position: "relative", "&.webchat__suggested-actions--carousel-layout": { "& .webchat__suggested-actions__carousel": { paddingBottom: e / 2, paddingTop: e / 2, "& .webchat__suggested-actions__item-box": { paddingBottom: e / 2, paddingLeft: e / 2, paddingRight: e / 2, paddingTop: e / 2 }, "& .react-film__filmstrip": { scrollbarWidth: "none" }, "& .react-film__flipper": { '&:disabled, &[aria-disabled="true"]': { "& .react-film__flipper__body": { backgroundColor: c, color: p } }, "&:focus .react-film__flipper__body": { backgroundColor: l, color: v || d }, "&:hover .react-film__flipper__body": { backgroundColor: f, color: h || d }, "& .react-film__flipper__body": { background: s, color: d, outline: 0 } } }, "&:not(.webchat__suggested-actions--rtl)": { "& .react-film__filmstrip__item:first-child": { paddingLeft: e / 2 }, "& .react-film__filmstrip__item:last-child": { paddingRight: e / 2 }, "& .react-film__flipper + .react-film__filmstrip": { "& .react-film__filmstrip__item:first-child": { paddingLeft: t + e * 1.5 }, "& .react-film__filmstrip__item:last-child": { paddingRight: t + e * 1.5 } } }, "&.webchat__suggested-actions--rtl": { "& .react-film__filmstrip__item:first-child": { paddingRight: e / 2 }, "& .react-film__filmstrip__item:last-child": { paddingLeft: e / 2 }, "& .react-film__flipper + .react-film__filmstrip": { "& .react-film__filmstrip__item:first-child": { paddingRight: t + e * 1.5 }, "& .react-film__filmstrip__item:last-child": { paddingLeft: t + e * 1.5 } } } }, "&.webchat__suggested-actions--flow-layout": { "& .webchat__suggested-actions__flow-box": { maxHeight: r, overflowY: "auto", paddingBottom: e / 2, paddingLeft: e / 2, paddingRight: e / 2, paddingTop: e / 2 }, "& .webchat__suggested-actions__flow-item-box": { maxWidth: "100%", overflow: "hidden" }, "& .webchat__suggested-actions__item-box": { paddingBottom: e / 2, paddingLeft: e / 2, paddingRight: e / 2, paddingTop: e / 2 } }, "&.webchat__suggested-actions--stacked-layout": { "& .webchat__suggested-actions__stack": { maxHeight: n || "auto", overflowY: i || "auto", paddingBottom: e / 2, paddingLeft: e / 2, paddingRight: e / 2, paddingTop: e / 2 }, "& .webchat__suggested-actions__item-box": { paddingBottom: e / 2, paddingLeft: e / 2, paddingRight: e / 2, paddingTop: e / 2 } }, "&.webchat__suggested-actions--flow-layout, &.webchat__suggested-actions--stacked-layout": { "& .webchat__suggested-actions__button-text": { overflow: "hidden", textOverflow: "ellipsis" }, "& .webchat__suggested-actions__button-text-stacked-text-wrap": { alignItems: "center", display: "flex", whiteSpace: "normal" } }, "& .webchat__suggested-actions__item-box": { display: "flex", maxWidth: "100%" }, "&.webchat__suggested-actions--focus-within, &:focus-within": { "& .webchat__suggested-actions__focus-indicator": { borderColor: o, borderStyle: a, borderWidth: u, boxSizing: "border-box", height: "100%", pointerEvents: "none", position: "absolute", top: 0, width: "100%" } } } };
}
function rZt({ accent: e, paddingRegular: t, paddingWide: r, primaryFont: n, suggestedActionBorderRadius: i, suggestedActionBackgroundColor: o, suggestedActionBorderColor: a, suggestedActionBorderStyle: u, suggestedActionBorderWidth: s, suggestedActionTextColor: c, suggestedActionBackgroundColorOnActive: l, suggestedActionBorderColorOnActive: f, suggestedActionBorderStyleOnActive: d, suggestedActionBorderWidthOnActive: p, suggestedActionTextColorOnActive: v, suggestedActionBackgroundColorOnDisabled: h, suggestedActionBorderColorOnDisabled: E, suggestedActionBorderStyleOnDisabled: m, suggestedActionBorderWidthOnDisabled: g, suggestedActionTextColorOnDisabled: y, suggestedActionBackgroundColorOnFocus: _, suggestedActionBorderColorOnFocus: S, suggestedActionBorderStyleOnFocus: A, suggestedActionBorderWidthOnFocus: O, suggestedActionTextColorOnFocus: P, suggestedActionBackgroundColorOnHover: U, suggestedActionBorderColorOnHover: z, suggestedActionBorderStyleOnHover: k, suggestedActionBorderWidthOnHover: H, suggestedActionTextColorOnHover: B, suggestedActionKeyboardFocusIndicatorBorderColor: x, suggestedActionKeyboardFocusIndicatorBorderRadius: D, suggestedActionKeyboardFocusIndicatorBorderStyle: w, suggestedActionKeyboardFocusIndicatorBorderWidth: $, suggestedActionKeyboardFocusIndicatorInset: X, suggestedActionHeight: V, suggestedActionImageHeight: F, suggestedActionsStackedLayoutButtonMaxHeight: le, subtle: ae, suggestedActionActiveBackground: ne, suggestedActionBackground: ve, suggestedActionDisabledBackground: Ie, suggestedActionFocusBackground: Oe, suggestedActionHoverBackground: xe }) {
  return { "&.webchat__suggested-action": { alignItems: "center", background: ve, backgroundColor: o, borderColor: a || e, borderRadius: i, borderStyle: u, borderWidth: s, color: c || e, fontFamily: n, fontSize: "inherit", height: V, justifyContent: "center", maxWidth: "100%", outline: 0, paddingLeft: r, paddingRight: r, position: "relative", whiteSpace: "nowrap", width: "100%", '&:disabled, &[aria-disabled="true"]': { background: Ie, backgroundColor: h, borderColor: E, borderStyle: m, borderWidth: g, color: y || ae }, '&:not(:disabled):not([aria-disabled="true"])': { "&:active": { background: ne, backgroundColor: l, borderColor: f, borderStyle: d, borderWidth: p, color: v }, "&:not(:active)": { "&:hover": { background: xe, backgroundColor: U, borderColor: z, borderStyle: k, borderWidth: H, color: B }, "&:not(:hover)": { "&:focus": { background: Oe, backgroundColor: _, borderColor: S, borderStyle: A, borderWidth: O, color: P } } } }, "&:not(:focus-visible) .webchat__suggested-action__keyboard-focus-indicator": { display: "none" }, "&:not(.webchat__suggested-action--focus-visible) .webchat__suggested-action__keyboard-focus-indicator": { display: "none" }, "&:not(.webchat__suggested-action--rtl) .webchat__suggested-action__image + .webchat__suggested-action__text": { paddingLeft: t }, "&.webchat__suggested-action--rtl .webchat__suggested-action__image + .webchat__suggested-action__text": { paddingRight: t }, "&.webchat__suggested-action--wrapping": { height: "auto", maxHeight: le || "100%", minHeight: typeof le == "number" && typeof V == "number" ? Math.min(le, V) : V }, "& .webchat__suggested-action__image": { height: F }, "& .webchat__suggested-action__keyboard-focus-indicator": { borderColor: x, borderRadius: D, borderStyle: w, borderWidth: $, bottom: X, left: X, position: "absolute", right: X, top: X } } };
}
function nZt() {
  return { "&.webchat__text-content": { fontFamily: ni.FontPrimary, margin: 0, minHeight: `calc(${ni.MinHeightBubble} - ${ni.PaddingRegular} * 2)`, padding: ni.PaddingRegular, "&.webchat__text-content--is-markdown": { display: "flex", flexDirection: "column", gap: ni.PaddingRegular }, "& .webchat__text-content__markdown img:not(.webchat__render-markdown__external-link-icon)": { maxWidth: ni.MaxWidthBubble, width: "100%" }, "& .webchat__text-content__markdown pre": { overflow: "hidden" }, "& .webchat__text-content__open-in-new-window-icon": { height: ".75em" } } };
}
function iZt() {
  return { "&.webchat__thumb-button": { appearance: "none", background: "Transparent", border: 0, borderRadius: 2, height: 16, overflow: "hidden", padding: 0, width: 16, "&:active": { background: "#EDEBE9" }, "&:focus": { outline: "solid 1px #605E5C" }, "& .webchat__thumb-button__image": { color: ni.ColorAccent, width: 14 }, "&:hover .webchat__thumb-button__image:not(.webchat__thumb-button__image--is-filled)": { display: "none" }, "&.webchat__thumb-button--is-pressed .webchat__thumb-button__image:not(.webchat__thumb-button__image--is-filled)": { display: "none" }, "&.webchat__thumb-button:not(:hover):not(.webchat__thumb-button--is-pressed) .webchat__thumb-button__image--is-filled": { display: "none" } } };
}
function oZt({ primaryFont: e, toasterHeight: t, toasterMaxHeight: r, toastErrorBackgroundColor: n, toastErrorColor: i, toasterSingularMaxHeight: o, toastFontSize: a, toastIconWidth: u, toastInfoBackgroundColor: s, toastInfoColor: c, toastSeparatorColor: l, toastSuccessBackgroundColor: f, toastSuccessColor: d, toastWarnBackgroundColor: p, toastWarnColor: v }) {
  return { overflowY: "hidden", "&:not(.webchat__toaster--expandable)": { maxHeight: o }, "&.webchat__toaster--expandable:not(.webchat__toaster--expanded) > ul": { height: 0 }, "&.webchat__toaster--expandable.webchat__toaster--expanded": { maxHeight: r }, "& .webchat__toaster__header": { alignItems: "center", alignSelf: "stretch", appearance: "none", backgroundColor: "Transparent", border: 0, display: "flex", fontFamily: e, fontSize: a, minHeight: t, outline: 0, padding: 0, textAlign: "left", "&:focus .webchat__toaster__expandIconFocus": { borderColor: "rgba(26, 10, 0, .7)" }, "&:hover .webchat__toaster__expandIconFocus": { backgroundColor: "rgba(0, 0, 0, .12)" } }, "& .webchat__toaster__expandIconFocus": { alignItems: "center", borderColor: "Transparent", borderStyle: "solid", borderWidth: 1, borderRadius: 3, display: "flex", height: 22, justifyContent: "center", width: 22 }, "&.webchat__toaster--error": { "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": { backgroundColor: n }, "& .webchat__toaster__header": { color: i, fill: i } }, "&.webchat__toaster--info": { "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": { backgroundColor: s }, "& .webchat__toaster__header": { color: c, fill: c } }, "&.webchat__toaster--success": { "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": { backgroundColor: f }, "& .webchat__toaster__header": { color: d, fill: d } }, "&.webchat__toaster--warn": { "&:not(.webchat__toaster--expandable), & .webchat__toaster__header": { backgroundColor: p }, "& .webchat__toaster__header": { color: v, fill: v } }, "& .webchat__toaster__expandLevelIconBox": { height: t, width: u }, "& .webchat__toaster__expandIcon": { height: t, width: t }, "& .webchat__toaster__expandText": { padding: "6px 0" }, "& .webchat__toaster__expandLevelIconBox, & .webchat__toaster__expandIcon": { alignItems: "center", display: "flex", justifyContent: "center" }, "& .webchat__toaster__list": { margin: 0, overflowY: "auto", padding: 0 }, "& .webchat__toaster__listItem:first-child:last-child": { overflow: "hidden" }, "& .webchat__toaster__listItem:not(:first-child), & .webchat__toaster__listItem:not(:last-child)": { borderBottomColor: l, borderBottomStyle: "solid", borderBottomWidth: 1, minHeight: 32 } };
}
function aZt({ primaryFont: e, toasterHeight: t, toastErrorColor: r, toastFontSize: n, toastIconWidth: i, toastInfoColor: o, toastSuccessColor: a, toastTextPadding: u, toastWarnColor: s }) {
  return { fontFamily: e, fontSize: n, minHeight: t, "&.webchat__toast--error": { color: r, fill: r }, "&.webchat__toast--info": { color: o, fill: o }, "&.webchat__toast--success": { color: a, fill: a }, "&.webchat__toast--warn": { color: s, fill: s }, "& .webchat__toast__iconBox": { alignItems: "center", display: "flex", flexShrink: 0, height: t, justifyContent: "center", width: i }, "& .webchat__toast__dismissButton": { alignItems: "center", appearance: "none", backgroundColor: "Transparent", border: 0, display: "flex", height: t, justifyContent: "center", outline: 0, padding: 0, width: t, "&:focus .webchat__toast__dismissButtonFocus": { borderColor: "rgba(26, 10, 0, .7)" }, "&:hover .webchat__toast__dismissButtonFocus": { backgroundColor: "rgba(0, 0, 0, .12)" } }, "& .webchat__toast__dismissButtonFocus": { alignItems: "center", borderColor: "Transparent", borderStyle: "solid", borderWidth: 1, borderRadius: 3, display: "flex", height: 22, justifyContent: "center", width: 22 }, "& .webchat__toast__text": { alignSelf: "center", paddingBottom: u, paddingTop: u } };
}
var uZt = "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", sZt = "image/gif", nw;
function cZt({ typingAnimationBackgroundImage: e, typingAnimationHeight: t, typingAnimationWidth: r }) {
  return nw || (nw = URL.createObjectURL(new Blob([nM(uZt)], { type: sZt }))), { backgroundImage: e || `url('${nw}')`, backgroundRepeat: "no-repeat", height: t, width: r };
}
function lZt({ paddingRegular: e }) {
  return { paddingBottom: e, "&:not(.webchat__typing-indicator--rtl)": { paddingLeft: e }, "&.webchat__typing-indicator--rtl": { paddingRight: e } };
}
function fZt({ sendBoxButtonColor: e, sendBoxButtonColorOnFocus: t, sendBoxButtonColorOnHover: r, sendBoxHeight: n, subtle: i }) {
  return { width: n, "& > .icon > svg": { fill: e || i }, "& > input:hover + .icon > svg": { fill: r }, "& > input:focus + .icon > svg": { fill: t } };
}
function dZt() {
  return {};
}
function pZt({ videoHeight: e }) {
  return { height: e, width: "100%" };
}
function hZt({ videoHeight: e }) {
  return { border: 0, height: e, width: "100%" };
}
function vZt({ connectivityIconPadding: e, connectivityMarginLeftRight: t, connectivityMarginTopBottom: r, connectivityTextSize: n, primaryFont: i, slowConnectivity: o, notificationText: a }) {
  return { alignItems: "center", color: a, display: "flex", fontFamily: i, fontSize: n, marginBottom: r, marginLeft: t, marginRight: t, marginTop: r, "& > svg": { fill: o, "&:not(webchat__warning--rtl)": { paddingRight: e }, "&.webchat__warning--rtl": { paddingLeft: e } } };
}
function EZt({ videoHeight: e }) {
  return { border: 0, height: e, width: "100%" };
}
function wF(e) {
  let t = Zb(e);
  return Object.freeze({ activities: EJt(), audioAttachment: mJt(t), audioContent: gJt(), autoResizeTextArea: TJt(t), avatar: yJt(t), basicTranscript: _Jt(t), bubble: AJt(t), carouselFilmStrip: SJt(t), carouselFilmStripAttachment: bJt(t), carouselFlipper: CJt(t), connectivityNotification: OJt(t), dictationInterims: PJt(t), errorBox: DJt(t), errorNotification: xJt(t), fileContent: NJt(t), imageAvatar: LJt(t), initialsAvatar: BJt(t), keyboardHelp: MJt(t), microphoneButton: $Jt(t), options: { ...t }, root: jJt(t), scrollToEndButton: zJt(t), sendBox: YJt(t), sendBoxButton: qJt(t), sendBoxTextBox: GJt(t), singleAttachmentActivity: KJt(t), spinnerAnimation: QJt(t), stackedLayout: eZt(t), suggestedAction: rZt(t), suggestedActions: tZt(t), toast: aZt(t), toaster: oZt(t), typingAnimation: cZt(t), typingIndicator: lZt(t), uploadButton: fZt(t), videoAttachment: dZt(), videoContent: pZt(t), vimeoContent: hZt(t), warningNotification: vZt(t), youTubeContent: EZt(t), citationModalDialog: IJt(), cssCustomProperties: wJt(t), linkDefinitions: HJt(), modalDialog: UJt(), renderMarkdown: VJt(), sendStatus: WJt(), slottedActivityStatus: XJt(), textContent: nZt(), thumbButton: iZt() });
}
function mZt(e, t) {
  return Xr(e, ["attrs"], (r) => {
    let n = Object.fromEntries(r), i = t(n);
    return Object.entries(i);
  });
}
function gZt(e) {
  return aF(e, (t) => {
    switch (t.type) {
      case "link_open":
        t = mZt(t, (r) => /^\w/u.test(r.href) ? { ...r, rel: "noopener noreferrer", target: "_blank" } : r);
        break;
    }
    return t;
  });
}
function TZt() {
  return Mu().toString(26).substr(2, 5).replace(/\d/gu, (e) => String.fromCharCode(e.charCodeAt(0) + 65));
}
function yZt(e, t) {
  return Object.entries(e).reduce((r, [n, i]) => (ia(n) || (r[n] = t(i, n)), r), {});
}
var { useGetActivityByKey: _Zt, useReferenceGrammarID: AZt, useStyleOptions: SZt } = Vt, tK = {};
function bZt(e, t) {
  return yZt(t, (r, n) => n === "options" ? r : e(r));
}
var Cge = Nr(({ children: e }) => {
  let [{ cssCustomProperties: t }] = pr(), r = mt((n) => {
    console.error(n);
  }, []);
  return G.createElement("div", { className: Gt("webchat__css-custom-properties", t) }, G.createElement(Pk, null, G.createElement(RKt, null, G.createElement(CKt, null, e, G.createElement($Yt, { onError: r })))));
});
Cge.displayName = "ComposerCoreUI";
var vy = ({ children: e, extraStyleSet: t, nonce: r, renderMarkdown: n, styleSet: i, suggestedActionsAccessKey: o, webSpeechPonyfillFactory: a }) => {
  let [u, s] = cn(), [c] = AZt(), [l] = SZt(), f = Ut([]), d = tt(() => new xC(), []), p = Ut([]), v = Ut([]), h = tt(() => (B) => {
    let x = d.parseInline(B), D = gZt(x);
    return d.renderer.render(D);
  }, [d]), E = tt(() => {
    let B = tK[`id-${r}`] || (tK[`id-${r}`] = Lhe({ key: `webchat--css-${TZt()}`, nonce: r }));
    return (x) => B.css(x);
  }, [r]), m = tt(() => bZt(E, { ...i || wF(l), ...t }), [t, l, i, E]), g = tt(() => {
    let B = a && a({ referenceGrammarID: c }), { speechSynthesis: x, SpeechSynthesisUtterance: D } = B || {};
    return { ...B, speechSynthesis: x || Ime, SpeechSynthesisUtterance: D || jYt };
  }, [c, a]), y = Ut([]), _ = mt((B) => y.current.forEach((x) => x(B)), [y]), S = mt((B) => (y.current = [...y.current, B], () => {
    y.current = y.current.filter((x) => x !== B);
  }), [y]), A = Ut([]), [O, P] = cn(0), U = _Zt(), z = tt(() => {
    let B = Symbol();
    return (x) => {
      if (x !== B) {
        B = x;
        let D = { activity: U(x) };
        A.current.forEach((w) => w(D));
      }
    };
  }, [U, A]), k = mt((B) => (A.current = [...A.current, B], P(A.current.length), () => {
    A.current = A.current.filter((x) => x !== B), P(A.current.length);
  }), [A, P]), H = tt(() => ({ dictateAbortable: u, dispatchScrollPosition: _, dispatchTranscriptFocusByActivityKey: z, focusTranscriptCallbacksRef: f, internalMarkdownItState: [d], internalRenderMarkdownInline: h, nonce: r, numTranscriptFocusObservers: O, observeScrollPosition: S, observeTranscriptFocus: k, renderMarkdown: n, scrollToCallbacksRef: p, scrollToEndCallbacksRef: v, setDictateAbortable: s, styleSet: m, styleToEmotionObject: E, suggestedActionsAccessKey: o, webSpeechPonyfill: g }), [u, _, z, f, d, h, r, O, S, k, m, n, p, v, s, E, o, g]);
  return G.createElement(TC.Composer, { ponyfill: g }, G.createElement(iEe.Provider, { value: H }, G.createElement(Cge, null, e)));
};
vy.defaultProps = { extraStyleSet: void 0, nonce: void 0, renderMarkdown: void 0, styleSet: void 0, suggestedActionsAccessKey: "A a Å å", webSpeechPonyfillFactory: void 0 };
vy.propTypes = { extraStyleSet: Q.any, nonce: Q.string, renderMarkdown: Q.func, styleSet: Q.any, suggestedActionsAccessKey: Q.oneOfType([Q.oneOf([!1]), Q.string]), webSpeechPonyfillFactory: Q.func };
var PF = ({ activityMiddleware: e, activityStatusMiddleware: t, attachmentForScreenReaderMiddleware: r, attachmentMiddleware: n, avatarMiddleware: i, cardActionMiddleware: o, children: a, extraStyleSet: u, renderMarkdown: s, scrollToEndButtonMiddleware: c, sendBoxMiddleware: l, sendBoxToolbarMiddleware: f, styleOptions: d, styleSet: p, suggestedActionsAccessKey: v, toastMiddleware: h, typingIndicatorMiddleware: E, webSpeechPonyfillFactory: m, ...g }) => {
  let { nonce: y, onTelemetry: _ } = g, S = PKt(), A = tt(() => [...Li(e), ...S.activityMiddleware, ...AGt()], [e, S.activityMiddleware]), O = tt(() => [...Li(t), ...S.activityStatusMiddleware, ...aWt()], [t, S.activityStatusMiddleware]), P = tt(() => [...Li(r), ...S.attachmentForScreenReaderMiddleware, ...TWt()], [r, S.attachmentForScreenReaderMiddleware]), U = tt(() => [...Li(n), ...S.attachmentMiddleware, ...OYt()], [n, S.attachmentMiddleware]), z = tt(() => [...Li(i), ...S.avatarMiddleware, ...wWt()], [i, S.avatarMiddleware]), k = tt(() => [...Li(o), ...S.cardActionMiddleware, ...DWt()], [o, S.cardActionMiddleware]), H = tt(() => [...Li(h), ...S.toastMiddleware, ...YWt()], [h, S.toastMiddleware]), B = tt(() => [...Li(E), ...S.typingIndicatorMiddleware, ...tKt()], [E, S.typingIndicatorMiddleware]), x = tt(() => BWt(), []), D = tt(() => [...Li(c), ...S.scrollToEndButtonMiddleware, ...x], [x, c, S.scrollToEndButtonMiddleware]), w = tt(() => ({ ...S.styleOptions, ...d }), [d, S.styleOptions]), $ = tt(() => Object.freeze([...Ez(l), ...Ez(S.sendBoxMiddleware), ...KXt()]), [l, S.sendBoxMiddleware]), X = tt(() => Object.freeze([...mz(f), ...mz(S.sendBoxToolbarMiddleware), ...vJt()]), [f, S.sendBoxToolbarMiddleware]);
  return G.createElement(qk, { activityMiddleware: A, activityStatusMiddleware: O, attachmentForScreenReaderMiddleware: P, attachmentMiddleware: U, avatarMiddleware: z, cardActionMiddleware: k, downscaleImageToDataURL: Age, internalErrorBoxClass: void 0, nonce: y, scrollToEndButtonMiddleware: D, sendBoxMiddleware: $, sendBoxToolbarMiddleware: X, styleOptions: w, toastMiddleware: H, typingIndicatorMiddleware: B, ...g }, G.createElement(pKt, null, G.createElement(vy, { extraStyleSet: u, nonce: y, renderMarkdown: s, styleSet: p, suggestedActionsAccessKey: v, webSpeechPonyfillFactory: m }, a, _ && G.createElement(QYt, null))));
};
PF.defaultProps = { ...qk.defaultProps, ...vy.defaultProps, children: void 0 };
PF.propTypes = { ...qk.propTypes, ...vy.propTypes, children: Q.any };
var t3 = PF, CZt = ["complementary", "contentinfo", "form", "main", "region"], DF = ({ className: e, role: t, ...r }) => G.createElement(t3, { ...r }, G.createElement(JEe, { className: e, role: t }));
DF.defaultProps = { className: void 0, role: void 0, ...t3.defaultProps };
var { children: t6r, ...IZt } = t3.propTypes;
DF.propTypes = { className: Q.string, role: Q.oneOf(CZt), ...IZt };
var OZt = DF, xF = ({ "aria-hidden": e, className: t, fromUser: r }) => (console.warn("botframework-webchat: <Avatar> component is deprecated and will be removed on or after 2022-02-25. Please use `useRenderAvatar` hook instead."), G.createElement(GC, { "aria-hidden": e, className: t, fromUser: r }));
xF.defaultProps = { "aria-hidden": !1, className: "", fromUser: !1 };
xF.propTypes = { "aria-hidden": Q.bool, className: Q.string, fromUser: Q.bool };
var RZt = xF;
function wZt(e, t, r, n) {
  function i(o) {
    let { env: a = {} } = o;
    for (let u = o.tokens.length - 1; u >= 0; u--) {
      if (o.tokens[u].type !== "inline") continue;
      let s = o.tokens[u].children;
      for (let c = s.length - 1; c >= 0; c--) s[c].type === r && n(s, c, a);
    }
  }
  e.core.ruler.push(t, i);
}
var PZt = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", DZt = new xC(), rK = { content: "​", type: "text" };
function ks(e, t, r) {
  let n = e.findIndex((i) => i[0] === t);
  r === !1 ? ~n && e.splice(n, 1) : typeof r == "string" ? ~n ? e[+n][1] = r : e.push([t, r]) : typeof r == "function" && (~n ? e[+n][1] = r(e[+n][1]) : e.push([t, r()]));
}
var xZt = (e) => e.use(wZt, "url_new_win", "link_open", (t, r, n) => {
  let { decorateLink: i, linkOptions: o } = n, a = t.indexOf(t.slice(r + 1).find(({ type: s }) => s === "link_close")), u = t.splice(r, ~a ? a - r + 1 : 2);
  try {
    let [s] = u, c = u[u.length - 1], [, l] = s.attrs.find(([A]) => A === "href"), f = u.slice(1, u.length - 1).filter(({ type: A }) => A === "text").map(({ content: A }) => A).join(" "), d = i == null ? void 0 : i(l, f, o);
    if (!d) return;
    let { ariaLabel: p, asButton: v, className: h, iconAlt: E, iconClassName: m, rel: g, target: y, title: _, wrapZeroWidthSpace: S } = d;
    if (ks(s.attrs, "aria-label", p), ks(s.attrs, "class", h), ks(s.attrs, "title", _), m) {
      let A = DZt.parseInline(`![](${PZt})`)[0].children;
      ks(A[0].attrs, "class", m), ks(A[0].attrs, "title", E), u.splice(-1, 0, ...A);
    }
    v ? (ks(s.attrs, "href", !1), s.tag = "button", ks(s.attrs, "type", "button"), ks(s.attrs, "value", l), c.tag = "button") : (ks(s.attrs, "rel", g), ks(s.attrs, "target", y)), S && (u.splice(0, 0, rK), u.splice(1 / 0, 0, rK));
  } finally {
    t.splice(r, 0, ...u);
  }
}), NZt = xZt, LZt = ["data", "http", "https", "ftp", "mailto", "sip", "tel"], BZt = [], kZt = "", MZt = (e, t, r) => {
  let n = { rel: "noopener noreferrer", target: "_blank", wrapZeroWidthSpace: !0, ...r }, i = [t], o = /* @__PURE__ */ new Set(), a = BZt.find(({ url: c }) => c === e), u = Hp(() => new URL(e).protocol);
  a && (i.push(a.title || Hp(() => new URL(a.url).host) || a.url), a.label === t && o.add("webchat__render-markdown__pure-identifier")), LZt.map((c) => `${c}:`).includes(u) ? (u === "http:" || u === "https:") && (n.iconClassName = [n.iconClassName, "webchat__render-markdown__external-link-icon"].filter((c) => c).join(" "), i.push(kZt)) : (n.asButton ?? (n.asButton = !0), o.add("webchat__render-markdown__citation")), i.length > 1 && (n.ariaLabel ?? (n.ariaLabel = (c) => c || i.join(" "))), typeof (r == null ? void 0 : r.className) == "string" && o.add(r.className);
  let s = Array.from(o).join(" ");
  return r != null && r.className && (r == null ? void 0 : r.className) instanceof Function ? n.className = r.className(s) : n.className = s, n.title ?? (n.title = !1), n;
}, { useLocalizer: FZt } = Vt, nK = new xC().use(NZt);
function HZt(e) {
  return typeof e.stringIds != "string";
}
var $Zt = (e) => {
  let { className: t, linkClassName: r, onDecorateLink: n = MZt, stringIds: i, values: o } = e, a = FZt(HZt(e) && { plural: !0 }), u = tt(() => ({ linkOptions: { className: r }, decorateLink: n }), [r, n]), s = tt(() => ({ __html: nK.renderer.render(nK.parseInline(a(i, ...o ?? []), u), u) }), [u, a, i, o]);
  return G.createElement("span", { className: t, dangerouslySetInnerHTML: s });
}, UZt = Nr($Zt), Zu = Object.freeze([]), VZt = ({ children: e, activityMiddleware: t, activityStatusMiddleware: r, attachmentForScreenReaderMiddleware: n, attachmentMiddleware: i, avatarMiddleware: o, cardActionMiddleware: a, groupActivitiesMiddleware: u, scrollToEndButtonMiddleware: s, sendBoxMiddleware: c, sendBoxToolbarMiddleware: l, styleOptions: f, toastMiddleware: d, typingIndicatorMiddleware: p }) => {
  let v = En(XL), h = tt(() => Object.freeze([...t || [], ...v.activityMiddleware]), [t, v.activityMiddleware]), E = tt(() => Object.freeze([...r || Zu, ...v.activityStatusMiddleware]), [r, v.activityStatusMiddleware]), m = tt(() => Object.freeze([...n || Zu, ...v.attachmentForScreenReaderMiddleware]), [n, v.attachmentForScreenReaderMiddleware]), g = tt(() => Object.freeze([...i || Zu, ...v.attachmentMiddleware]), [i, v.attachmentMiddleware]), y = tt(() => Object.freeze([...o || Zu, ...v.avatarMiddleware]), [o, v.avatarMiddleware]), _ = tt(() => Object.freeze([...a || Zu, ...v.cardActionMiddleware]), [a, v.cardActionMiddleware]), S = tt(() => Object.freeze([...u || Zu, ...v.groupActivitiesMiddleware]), [u, v.groupActivitiesMiddleware]), A = tt(() => Object.freeze([...s || Zu, ...v.scrollToEndButtonMiddleware]), [s, v.scrollToEndButtonMiddleware]), O = tt(() => Object.freeze([...c || Zu, ...v.sendBoxMiddleware]), [c, v.sendBoxMiddleware]), P = tt(() => Object.freeze([...l || Zu, ...v.sendBoxToolbarMiddleware]), [l, v.sendBoxToolbarMiddleware]), U = tt(() => Object.freeze({ ...f, ...v.styleOptions }), [f, v.styleOptions]), z = tt(() => Object.freeze([...d || Zu, ...v.toastMiddleware]), [d, v.toastMiddleware]), k = tt(() => Object.freeze([...p || Zu, ...v.typingIndicatorMiddleware]), [p, v.typingIndicatorMiddleware]), H = tt(() => ({ activityMiddleware: h, activityStatusMiddleware: E, attachmentForScreenReaderMiddleware: m, attachmentMiddleware: g, avatarMiddleware: y, cardActionMiddleware: _, groupActivitiesMiddleware: S, scrollToEndButtonMiddleware: A, sendBoxMiddleware: O, sendBoxToolbarMiddleware: P, styleOptions: U, toastMiddleware: z, typingIndicatorMiddleware: k }), [h, E, m, g, y, _, S, A, O, P, U, z, k]);
  return G.createElement(XL.Provider, { value: H }, e);
}, jZt = Nr(VZt), Ige = {};
oMe(Ige, { useDictateAbortable: () => nge, useFocus: () => d0, useMakeThumbnail: () => QC, useMicrophoneButtonClick: () => age, useMicrophoneButtonDisabled: () => uge, useObserveScrollPosition: () => zZt, useObserveTranscriptFocus: () => qZt, useRegisterFocusSendBox: () => EEe, useRenderMarkdownAsHTML: () => Fh, useScrollDown: () => vge, useScrollTo: () => YZt, useScrollToEnd: () => pF, useScrollUp: () => Ege, useSendBoxSpeechInterimsVisible: () => yge, useSendFiles: () => WZt, useSendMessage: () => XZt, useStyleSet: () => pr, useTextBoxSubmit: () => gge, useTextBoxValue: () => xXt, useTypingIndicatorVisible: () => hEe, useWebSpeechPonyfill: () => $h });
function zZt(e, t) {
  typeof e != "function" ? (e = void 0, console.warn('botframework-webchat: First argument passed to "useObserveScrollPosition" must be a function.')) : typeof t < "u" && !Array.isArray(t) && console.warn('botframework-webchat: Second argument passed to "useObserveScrollPosition" must be an array if specified.');
  let { observeScrollPosition: r } = ho();
  nr(() => e && r(e), [...t || [], e, r]);
}
function qZt(e, t) {
  typeof e != "function" ? (e = void 0, console.warn('botframework-webchat: First argument passed to "useObserveTranscriptFocus" must be a function.')) : typeof t < "u" && !Array.isArray(t) && console.warn('botframework-webchat: Second argument passed to "useObserveTranscriptFocus" must be an array if specified.');
  let { observeTranscriptFocus: r } = ho();
  nr(() => e && r(e), [...t || [], e, r]);
}
function YZt() {
  let { scrollToCallbacksRef: e } = ho();
  return mt((...t) => e.current.forEach((r) => r(...t)), [e]);
}
var { useSendFiles: GZt } = Vt;
function WZt() {
  let e = QC(), t = GZt();
  return mt((r) => {
    (async function() {
      r && r.length && t(await Promise.all(r.map((n) => e(n, /\.(gif|jpe?g|png)$/iu.test(n.name) ? "image/*" : "application/octet-stream").then((i) => ({ name: n.name, size: n.size, thumbnail: i == null ? void 0 : i.toString(), url: URL.createObjectURL(n) })))));
    })();
  }, [e, t]);
}
var { useSendMessage: KZt } = Vt;
function XZt() {
  let e = QC(), t = KZt();
  return mt(async (r, n, { channelData: i, attachments: o } = {}) => {
    t(r, n, { attachments: o ? await Promise.all([...o].map(async ({ blob: a, thumbnailURL: u }) => (!u && a instanceof File && (u = await e(a)), { blob: a, thumbnailURL: u }))) : [], channelData: i });
  }, [e, t]);
}
var du = { ...Vt, ...Ige }, JZt = "tsup", ZZt = "esmodules", QZt = "4.18.0", uA = { buildTool: JZt, moduleFormat: ZZt, version: QZt }, Ey = { BasicWebChat: JEe, Composer: t3, ThemeProvider: jZt, AccessKeySinkSurface: KEe, BasicConnectivityStatus: uEe, BasicSendBox: _ge, BasicSendBoxToolbar: bge, BasicToaster: lEe, BasicTranscript: zEe, AudioContent: ZEe, FileContent: tme, HTMLVideoContent: yme, ImageContent: ime, TextContent: gme, VideoContent: Ame, VimeoContent: _me, YouTubeContent: KL, Avatar: RZt, Bubble: W1, ErrorBox: VYt, SendStatus: xme, SpeakActivity: MEe, Timestamp: cF, DictationInterims: rge, MicrophoneButton: sge, SendButton: cge, SendTextBox: Tge, SuggestedActions: pge, UploadButton: Sge, LocalizedString: UZt }, NF = OZt;
/*! For license information please see botframework-webchat-component.mjs.LEGAL.txt */
var iw = {}, Oge = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
})(Oge);
var my = Oge.exports, Rge = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? (e.exports = t = function(i) {
      return typeof i;
    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(i) {
      return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
    }, e.exports.default = e.exports, e.exports.__esModule = !0), t(r);
  }
  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
})(Rge);
var LF = Rge.exports, ow = { exports: {} }, aw = { exports: {} }, iK;
function eQt() {
  return iK || (iK = 1, function(e) {
    function t(r, n) {
      if (r == null) return {};
      var i = {}, o = Object.keys(r), a, u;
      for (u = 0; u < o.length; u++)
        a = o[u], !(n.indexOf(a) >= 0) && (i[a] = r[a]);
      return i;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(aw)), aw.exports;
}
var oK;
function wge() {
  return oK || (oK = 1, function(e) {
    var t = eQt();
    function r(n, i) {
      if (n == null) return {};
      var o = t(n, i), a, u;
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(n);
        for (u = 0; u < s.length; u++)
          a = s[u], !(i.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(n, a) && (o[a] = n[a]);
      }
      return o;
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ow)), ow.exports;
}
var uw = { exports: {} }, aK;
function BF() {
  return aK || (aK = 1, function(e) {
    function t(r, n) {
      if (!(r instanceof n))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(uw)), uw.exports;
}
var sw = { exports: {} }, uK;
function kF() {
  return uK || (uK = 1, function(e) {
    function t(n, i) {
      for (var o = 0; o < i.length; o++) {
        var a = i[o];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
      }
    }
    function r(n, i, o) {
      return i && t(n.prototype, i), o && t(n, o), n;
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(sw)), sw.exports;
}
var cw = { exports: {} }, sK;
function Pge() {
  return sK || (sK = 1, function(e) {
    function t(r, n, i) {
      return n in r ? Object.defineProperty(r, n, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[n] = i, r;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(cw)), cw.exports;
}
var cK = {}, lw, lK;
function Io() {
  if (lK) return lw;
  lK = 1;
  var e = function(t) {
    return t && t.Math == Math && t;
  };
  return lw = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof fe == "object" && fe) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")(), lw;
}
var fw = {}, dw, fK;
function il() {
  return fK || (fK = 1, dw = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), dw;
}
var pw, dK;
function Uh() {
  if (dK) return pw;
  dK = 1;
  var e = il();
  return pw = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] != 7;
  }), pw;
}
var hw = {}, pK;
function tQt() {
  if (pK) return hw;
  pK = 1;
  var e = {}.propertyIsEnumerable, t = Object.getOwnPropertyDescriptor, r = t && !e.call({ 1: 2 }, 1);
  return hw.f = r ? function(i) {
    var o = t(this, i);
    return !!o && o.enumerable;
  } : e, hw;
}
var vw, hK;
function r3() {
  return hK || (hK = 1, vw = function(e, t) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: t
    };
  }), vw;
}
var Ew, vK;
function MF() {
  if (vK) return Ew;
  vK = 1;
  var e = {}.toString;
  return Ew = function(t) {
    return e.call(t).slice(8, -1);
  }, Ew;
}
var mw, EK;
function rQt() {
  if (EK) return mw;
  EK = 1;
  var e = il(), t = MF(), r = "".split;
  return mw = e(function() {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function(n) {
    return t(n) == "String" ? r.call(n, "") : Object(n);
  } : Object, mw;
}
var gw, mK;
function FF() {
  return mK || (mK = 1, gw = function(e) {
    if (e == null) throw TypeError("Can't call method on " + e);
    return e;
  }), gw;
}
var Tw, gK;
function n3() {
  if (gK) return Tw;
  gK = 1;
  var e = rQt(), t = FF();
  return Tw = function(r) {
    return e(t(r));
  }, Tw;
}
var yw, TK;
function ld() {
  return TK || (TK = 1, yw = function(e) {
    return typeof e == "object" ? e !== null : typeof e == "function";
  }), yw;
}
var _w, yK;
function Dge() {
  if (yK) return _w;
  yK = 1;
  var e = ld();
  return _w = function(t, r) {
    if (!e(t)) return t;
    var n, i;
    if (r && typeof (n = t.toString) == "function" && !e(i = n.call(t)) || typeof (n = t.valueOf) == "function" && !e(i = n.call(t)) || !r && typeof (n = t.toString) == "function" && !e(i = n.call(t))) return i;
    throw TypeError("Can't convert object to primitive value");
  }, _w;
}
var Aw, _K;
function xge() {
  if (_K) return Aw;
  _K = 1;
  var e = FF();
  return Aw = function(t) {
    return Object(e(t));
  }, Aw;
}
var Sw, AK;
function ol() {
  if (AK) return Sw;
  AK = 1;
  var e = xge(), t = {}.hasOwnProperty;
  return Sw = Object.hasOwn || function(n, i) {
    return t.call(e(n), i);
  }, Sw;
}
var bw, SK;
function HF() {
  if (SK) return bw;
  SK = 1;
  var e = Io(), t = ld(), r = e.document, n = t(r) && t(r.createElement);
  return bw = function(i) {
    return n ? r.createElement(i) : {};
  }, bw;
}
var Cw, bK;
function Nge() {
  if (bK) return Cw;
  bK = 1;
  var e = Uh(), t = il(), r = HF();
  return Cw = !e && !t(function() {
    return Object.defineProperty(r("div"), "a", {
      get: function() {
        return 7;
      }
    }).a != 7;
  }), Cw;
}
var CK;
function $F() {
  if (CK) return fw;
  CK = 1;
  var e = Uh(), t = tQt(), r = r3(), n = n3(), i = Dge(), o = ol(), a = Nge(), u = Object.getOwnPropertyDescriptor;
  return fw.f = e ? u : function(c, l) {
    if (c = n(c), l = i(l, !0), a) try {
      return u(c, l);
    } catch {
    }
    if (o(c, l)) return r(!t.f.call(c, l), c[l]);
  }, fw;
}
var Iw = {}, Ow, IK;
function al() {
  if (IK) return Ow;
  IK = 1;
  var e = ld();
  return Ow = function(t) {
    if (!e(t))
      throw TypeError(String(t) + " is not an object");
    return t;
  }, Ow;
}
var OK;
function Vh() {
  if (OK) return Iw;
  OK = 1;
  var e = Uh(), t = Nge(), r = al(), n = Dge(), i = Object.defineProperty;
  return Iw.f = e ? i : function(a, u, s) {
    if (r(a), u = n(u, !0), r(s), t) try {
      return i(a, u, s);
    } catch {
    }
    if ("get" in s || "set" in s) throw TypeError("Accessors not supported");
    return "value" in s && (a[u] = s.value), a;
  }, Iw;
}
var Rw, RK;
function p0() {
  if (RK) return Rw;
  RK = 1;
  var e = Uh(), t = Vh(), r = r3();
  return Rw = e ? function(n, i, o) {
    return t.f(n, i, r(1, o));
  } : function(n, i, o) {
    return n[i] = o, n;
  }, Rw;
}
var ww = { exports: {} }, Pw, wK;
function UF() {
  if (wK) return Pw;
  wK = 1;
  var e = Io(), t = p0();
  return Pw = function(r, n) {
    try {
      t(e, r, n);
    } catch {
      e[r] = n;
    }
    return n;
  }, Pw;
}
var Dw, PK;
function VF() {
  if (PK) return Dw;
  PK = 1;
  var e = Io(), t = UF(), r = "__core-js_shared__", n = e[r] || t(r, {});
  return Dw = n, Dw;
}
var xw, DK;
function jF() {
  if (DK) return xw;
  DK = 1;
  var e = VF(), t = Function.toString;
  return typeof e.inspectSource != "function" && (e.inspectSource = function(r) {
    return t.call(r);
  }), xw = e.inspectSource, xw;
}
var Nw, xK;
function nQt() {
  if (xK) return Nw;
  xK = 1;
  var e = Io(), t = jF(), r = e.WeakMap;
  return Nw = typeof r == "function" && /native code/.test(t(r)), Nw;
}
var Lw = { exports: {} }, Bw, NK;
function gy() {
  return NK || (NK = 1, Bw = !1), Bw;
}
var LK;
function Lge() {
  if (LK) return Lw.exports;
  LK = 1;
  var e = gy(), t = VF();
  return (Lw.exports = function(r, n) {
    return t[r] || (t[r] = n !== void 0 ? n : {});
  })("versions", []).push({
    version: "3.15.2",
    mode: e ? "pure" : "global",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  }), Lw.exports;
}
var kw, BK;
function Bge() {
  if (BK) return kw;
  BK = 1;
  var e = 0, t = Math.random();
  return kw = function(r) {
    return "Symbol(" + String(r === void 0 ? "" : r) + ")_" + (++e + t).toString(36);
  }, kw;
}
var Mw, kK;
function zF() {
  if (kK) return Mw;
  kK = 1;
  var e = Lge(), t = Bge(), r = e("keys");
  return Mw = function(n) {
    return r[n] || (r[n] = t(n));
  }, Mw;
}
var Fw, MK;
function qF() {
  return MK || (MK = 1, Fw = {}), Fw;
}
var Hw, FK;
function i3() {
  if (FK) return Hw;
  FK = 1;
  var e = nQt(), t = Io(), r = ld(), n = p0(), i = ol(), o = VF(), a = zF(), u = qF(), s = "Object already initialized", c = t.WeakMap, l, f, d, p = function(_) {
    return d(_) ? f(_) : l(_, {});
  }, v = function(_) {
    return function(S) {
      var A;
      if (!r(S) || (A = f(S)).type !== _)
        throw TypeError("Incompatible receiver, " + _ + " required");
      return A;
    };
  };
  if (e || o.state) {
    var h = o.state || (o.state = new c()), E = h.get, m = h.has, g = h.set;
    l = function(_, S) {
      if (m.call(h, _)) throw new TypeError(s);
      return S.facade = _, g.call(h, _, S), S;
    }, f = function(_) {
      return E.call(h, _) || {};
    }, d = function(_) {
      return m.call(h, _);
    };
  } else {
    var y = a("state");
    u[y] = !0, l = function(_, S) {
      if (i(_, y)) throw new TypeError(s);
      return S.facade = _, n(_, y, S), S;
    }, f = function(_) {
      return i(_, y) ? _[y] : {};
    }, d = function(_) {
      return i(_, y);
    };
  }
  return Hw = {
    set: l,
    get: f,
    has: d,
    enforce: p,
    getterFor: v
  }, Hw;
}
var HK;
function jh() {
  if (HK) return ww.exports;
  HK = 1;
  var e = Io(), t = p0(), r = ol(), n = UF(), i = jF(), o = i3(), a = o.get, u = o.enforce, s = String(String).split("String");
  return (ww.exports = function(c, l, f, d) {
    var p = d ? !!d.unsafe : !1, v = d ? !!d.enumerable : !1, h = d ? !!d.noTargetGet : !1, E;
    if (typeof f == "function" && (typeof l == "string" && !r(f, "name") && t(f, "name", l), E = u(f), E.source || (E.source = s.join(typeof l == "string" ? l : ""))), c === e) {
      v ? c[l] = f : n(l, f);
      return;
    } else p ? !h && c[l] && (v = !0) : delete c[l];
    v ? c[l] = f : t(c, l, f);
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && a(this).source || i(this);
  }), ww.exports;
}
var $w, $K;
function kge() {
  if ($K) return $w;
  $K = 1;
  var e = Io();
  return $w = e, $w;
}
var Uw, UK;
function fd() {
  if (UK) return Uw;
  UK = 1;
  var e = kge(), t = Io(), r = function(n) {
    return typeof n == "function" ? n : void 0;
  };
  return Uw = function(n, i) {
    return arguments.length < 2 ? r(e[n]) || r(t[n]) : e[n] && e[n][i] || t[n] && t[n][i];
  }, Uw;
}
var Vw = {}, jw, VK;
function YF() {
  if (VK) return jw;
  VK = 1;
  var e = Math.ceil, t = Math.floor;
  return jw = function(r) {
    return isNaN(r = +r) ? 0 : (r > 0 ? t : e)(r);
  }, jw;
}
var zw, jK;
function Mge() {
  if (jK) return zw;
  jK = 1;
  var e = YF(), t = Math.min;
  return zw = function(r) {
    return r > 0 ? t(e(r), 9007199254740991) : 0;
  }, zw;
}
var qw, zK;
function iQt() {
  if (zK) return qw;
  zK = 1;
  var e = YF(), t = Math.max, r = Math.min;
  return qw = function(n, i) {
    var o = e(n);
    return o < 0 ? t(o + i, 0) : r(o, i);
  }, qw;
}
var Yw, qK;
function oQt() {
  if (qK) return Yw;
  qK = 1;
  var e = n3(), t = Mge(), r = iQt(), n = function(i) {
    return function(o, a, u) {
      var s = e(o), c = t(s.length), l = r(u, c), f;
      if (i && a != a) {
        for (; c > l; )
          if (f = s[l++], f != f) return !0;
      } else for (; c > l; l++)
        if ((i || l in s) && s[l] === a) return i || l || 0;
      return !i && -1;
    };
  };
  return Yw = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: n(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: n(!1)
  }, Yw;
}
var Gw, YK;
function Fge() {
  if (YK) return Gw;
  YK = 1;
  var e = ol(), t = n3(), r = oQt().indexOf, n = qF();
  return Gw = function(i, o) {
    var a = t(i), u = 0, s = [], c;
    for (c in a) !e(n, c) && e(a, c) && s.push(c);
    for (; o.length > u; ) e(a, c = o[u++]) && (~r(s, c) || s.push(c));
    return s;
  }, Gw;
}
var Ww, GK;
function GF() {
  return GK || (GK = 1, Ww = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), Ww;
}
var WK;
function aQt() {
  if (WK) return Vw;
  WK = 1;
  var e = Fge(), t = GF(), r = t.concat("length", "prototype");
  return Vw.f = Object.getOwnPropertyNames || function(i) {
    return e(i, r);
  }, Vw;
}
var Kw = {}, KK;
function uQt() {
  return KK || (KK = 1, Kw.f = Object.getOwnPropertySymbols), Kw;
}
var Xw, XK;
function sQt() {
  if (XK) return Xw;
  XK = 1;
  var e = fd(), t = aQt(), r = uQt(), n = al();
  return Xw = e("Reflect", "ownKeys") || function(o) {
    var a = t.f(n(o)), u = r.f;
    return u ? a.concat(u(o)) : a;
  }, Xw;
}
var Jw, JK;
function cQt() {
  if (JK) return Jw;
  JK = 1;
  var e = ol(), t = sQt(), r = $F(), n = Vh();
  return Jw = function(i, o) {
    for (var a = t(o), u = n.f, s = r.f, c = 0; c < a.length; c++) {
      var l = a[c];
      e(i, l) || u(i, l, s(o, l));
    }
  }, Jw;
}
var Zw, ZK;
function Hge() {
  if (ZK) return Zw;
  ZK = 1;
  var e = il(), t = /#|\.prototype\./, r = function(u, s) {
    var c = i[n(u)];
    return c == a ? !0 : c == o ? !1 : typeof s == "function" ? e(s) : !!s;
  }, n = r.normalize = function(u) {
    return String(u).replace(t, ".").toLowerCase();
  }, i = r.data = {}, o = r.NATIVE = "N", a = r.POLYFILL = "P";
  return Zw = r, Zw;
}
var Qw, QK;
function dd() {
  if (QK) return Qw;
  QK = 1;
  var e = Io(), t = $F().f, r = p0(), n = jh(), i = UF(), o = cQt(), a = Hge();
  return Qw = function(u, s) {
    var c = u.target, l = u.global, f = u.stat, d, p, v, h, E, m;
    if (l ? p = e : f ? p = e[c] || i(c, {}) : p = (e[c] || {}).prototype, p) for (v in s) {
      if (E = s[v], u.noTargetGet ? (m = t(p, v), h = m && m.value) : h = p[v], d = a(l ? v : c + (f ? "." : "#") + v, u.forced), !d && h !== void 0) {
        if (typeof E == typeof h) continue;
        o(E, h);
      }
      (u.sham || h && h.sham) && r(E, "sham", !0), n(p, v, E, u);
    }
  }, Qw;
}
var eP, eX;
function lQt() {
  if (eX) return eP;
  eX = 1;
  var e = il();
  return eP = !e(function() {
    function t() {
    }
    return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
  }), eP;
}
var tP, tX;
function WF() {
  if (tX) return tP;
  tX = 1;
  var e = ol(), t = xge(), r = zF(), n = lQt(), i = r("IE_PROTO"), o = Object.prototype;
  return tP = n ? Object.getPrototypeOf : function(a) {
    return a = t(a), e(a, i) ? a[i] : typeof a.constructor == "function" && a instanceof a.constructor ? a.constructor.prototype : a instanceof Object ? o : null;
  }, tP;
}
var rP, rX;
function fQt() {
  if (rX) return rP;
  rX = 1;
  var e = ld();
  return rP = function(t) {
    if (!e(t) && t !== null)
      throw TypeError("Can't set " + String(t) + " as a prototype");
    return t;
  }, rP;
}
var nP, nX;
function KF() {
  if (nX) return nP;
  nX = 1;
  var e = al(), t = fQt();
  return nP = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var r = !1, n = {}, i;
    try {
      i = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, i.call(n, []), r = n instanceof Array;
    } catch {
    }
    return function(a, u) {
      return e(a), t(u), r ? i.call(a, u) : a.__proto__ = u, a;
    };
  }() : void 0), nP;
}
var iP, iX;
function dQt() {
  if (iX) return iP;
  iX = 1;
  var e = Fge(), t = GF();
  return iP = Object.keys || function(n) {
    return e(n, t);
  }, iP;
}
var oP, oX;
function pQt() {
  if (oX) return oP;
  oX = 1;
  var e = Uh(), t = Vh(), r = al(), n = dQt();
  return oP = e ? Object.defineProperties : function(o, a) {
    r(o);
    for (var u = n(a), s = u.length, c = 0, l; s > c; ) t.f(o, l = u[c++], a[l]);
    return o;
  }, oP;
}
var aP, aX;
function $ge() {
  if (aX) return aP;
  aX = 1;
  var e = fd();
  return aP = e("document", "documentElement"), aP;
}
var uP, uX;
function XF() {
  if (uX) return uP;
  uX = 1;
  var e = al(), t = pQt(), r = GF(), n = qF(), i = $ge(), o = HF(), a = zF(), u = ">", s = "<", c = "prototype", l = "script", f = a("IE_PROTO"), d = function() {
  }, p = function(g) {
    return s + l + u + g + s + "/" + l + u;
  }, v = function(g) {
    g.write(p("")), g.close();
    var y = g.parentWindow.Object;
    return g = null, y;
  }, h = function() {
    var g = o("iframe"), y = "java" + l + ":", _;
    return g.style.display = "none", i.appendChild(g), g.src = String(y), _ = g.contentWindow.document, _.open(), _.write(p("document.F=Object")), _.close(), _.F;
  }, E, m = function() {
    try {
      E = document.domain && new ActiveXObject("htmlfile");
    } catch {
    }
    m = E ? v(E) : h();
    for (var g = r.length; g--; ) delete m[c][r[g]];
    return m();
  };
  return n[f] = !0, uP = Object.create || function(y, _) {
    var S;
    return y !== null ? (d[c] = e(y), S = new d(), d[c] = null, S[f] = y) : S = m(), _ === void 0 ? S : t(S, _);
  }, uP;
}
var sP, sX;
function JF() {
  if (sX) return sP;
  sX = 1;
  var e = fd();
  return sP = e("navigator", "userAgent") || "", sP;
}
var cP, cX;
function Uge() {
  if (cX) return cP;
  cX = 1;
  var e = Io(), t = JF(), r = e.process, n = r && r.versions, i = n && n.v8, o, a;
  return i ? (o = i.split("."), a = o[0] < 4 ? 1 : o[0] + o[1]) : t && (o = t.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = t.match(/Chrome\/(\d+)/), o && (a = o[1]))), cP = a && +a, cP;
}
var lP, lX;
function Vge() {
  if (lX) return lP;
  lX = 1;
  var e = Uge(), t = il();
  return lP = !!Object.getOwnPropertySymbols && !t(function() {
    var r = Symbol();
    return !String(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), lP;
}
var fP, fX;
function hQt() {
  if (fX) return fP;
  fX = 1;
  var e = Vge();
  return fP = e && !Symbol.sham && typeof Symbol.iterator == "symbol", fP;
}
var dP, dX;
function pu() {
  if (dX) return dP;
  dX = 1;
  var e = Io(), t = Lge(), r = ol(), n = Bge(), i = Vge(), o = hQt(), a = t("wks"), u = e.Symbol, s = o ? u : u && u.withoutSetter || n;
  return dP = function(c) {
    return (!r(a, c) || !(i || typeof a[c] == "string")) && (i && r(u, c) ? a[c] = u[c] : a[c] = s("Symbol." + c)), a[c];
  }, dP;
}
var pP, pX;
function Ty() {
  return pX || (pX = 1, pP = {}), pP;
}
var hP, hX;
function vQt() {
  if (hX) return hP;
  hX = 1;
  var e = pu(), t = Ty(), r = e("iterator"), n = Array.prototype;
  return hP = function(i) {
    return i !== void 0 && (t.Array === i || n[r] === i);
  }, hP;
}
var vP, vX;
function zh() {
  return vX || (vX = 1, vP = function(e) {
    if (typeof e != "function")
      throw TypeError(String(e) + " is not a function");
    return e;
  }), vP;
}
var EP, EX;
function jge() {
  if (EX) return EP;
  EX = 1;
  var e = zh();
  return EP = function(t, r, n) {
    if (e(t), r === void 0) return t;
    switch (n) {
      case 0:
        return function() {
          return t.call(r);
        };
      case 1:
        return function(i) {
          return t.call(r, i);
        };
      case 2:
        return function(i, o) {
          return t.call(r, i, o);
        };
      case 3:
        return function(i, o, a) {
          return t.call(r, i, o, a);
        };
    }
    return function() {
      return t.apply(r, arguments);
    };
  }, EP;
}
var mP, mX;
function ZF() {
  if (mX) return mP;
  mX = 1;
  var e = pu(), t = e("toStringTag"), r = {};
  return r[t] = "z", mP = String(r) === "[object z]", mP;
}
var gP, gX;
function zge() {
  if (gX) return gP;
  gX = 1;
  var e = ZF(), t = MF(), r = pu(), n = r("toStringTag"), i = t(/* @__PURE__ */ function() {
    return arguments;
  }()) == "Arguments", o = function(a, u) {
    try {
      return a[u];
    } catch {
    }
  };
  return gP = e ? t : function(a) {
    var u, s, c;
    return a === void 0 ? "Undefined" : a === null ? "Null" : typeof (s = o(u = Object(a), n)) == "string" ? s : i ? t(u) : (c = t(u)) == "Object" && typeof u.callee == "function" ? "Arguments" : c;
  }, gP;
}
var TP, TX;
function EQt() {
  if (TX) return TP;
  TX = 1;
  var e = zge(), t = Ty(), r = pu(), n = r("iterator");
  return TP = function(i) {
    if (i != null) return i[n] || i["@@iterator"] || t[e(i)];
  }, TP;
}
var yP, yX;
function mQt() {
  if (yX) return yP;
  yX = 1;
  var e = al();
  return yP = function(t) {
    var r = t.return;
    if (r !== void 0)
      return e(r.call(t)).value;
  }, yP;
}
var _P, _X;
function o3() {
  if (_X) return _P;
  _X = 1;
  var e = al(), t = vQt(), r = Mge(), n = jge(), i = EQt(), o = mQt(), a = function(u, s) {
    this.stopped = u, this.result = s;
  };
  return _P = function(u, s, c) {
    var l = c && c.that, f = !!(c && c.AS_ENTRIES), d = !!(c && c.IS_ITERATOR), p = !!(c && c.INTERRUPTED), v = n(s, l, 1 + f + p), h, E, m, g, y, _, S, A = function(P) {
      return h && o(h), new a(!0, P);
    }, O = function(P) {
      return f ? (e(P), p ? v(P[0], P[1], A) : v(P[0], P[1])) : p ? v(P, A) : v(P);
    };
    if (d)
      h = u;
    else {
      if (E = i(u), typeof E != "function") throw TypeError("Target is not iterable");
      if (t(E)) {
        for (m = 0, g = r(u.length); g > m; m++)
          if (y = O(u[m]), y && y instanceof a) return y;
        return new a(!1);
      }
      h = E.call(u);
    }
    for (_ = h.next; !(S = _.call(h)).done; ) {
      try {
        y = O(S.value);
      } catch (P) {
        throw o(h), P;
      }
      if (typeof y == "object" && y && y instanceof a) return y;
    }
    return new a(!1);
  }, _P;
}
var AX;
function qge() {
  if (AX) return cK;
  AX = 1;
  var e = dd(), t = WF(), r = KF(), n = XF(), i = p0(), o = r3(), a = o3(), u = function(c, l) {
    var f = this;
    if (!(f instanceof u)) return new u(c, l);
    r && (f = r(new Error(void 0), t(f))), l !== void 0 && i(f, "message", String(l));
    var d = [];
    return a(c, d.push, { that: d }), i(f, "errors", d), f;
  };
  return u.prototype = n(Error.prototype, {
    constructor: o(5, u),
    message: o(5, ""),
    name: o(5, "AggregateError")
  }), e({ global: !0 }, {
    AggregateError: u
  }), cK;
}
var SX = {}, AP, bX;
function gQt() {
  if (bX) return AP;
  bX = 1;
  var e = ZF(), t = zge();
  return AP = e ? {}.toString : function() {
    return "[object " + t(this) + "]";
  }, AP;
}
var CX;
function TQt() {
  if (CX) return SX;
  CX = 1;
  var e = ZF(), t = jh(), r = gQt();
  return e || t(Object.prototype, "toString", r, { unsafe: !0 }), SX;
}
var IX = {}, SP, OX;
function Yge() {
  if (OX) return SP;
  OX = 1;
  var e = Io();
  return SP = e.Promise, SP;
}
var bP, RX;
function yQt() {
  if (RX) return bP;
  RX = 1;
  var e = jh();
  return bP = function(t, r, n) {
    for (var i in r) e(t, i, r[i], n);
    return t;
  }, bP;
}
var CP, wX;
function QF() {
  if (wX) return CP;
  wX = 1;
  var e = Vh().f, t = ol(), r = pu(), n = r("toStringTag");
  return CP = function(i, o, a) {
    i && !t(i = a ? i : i.prototype, n) && e(i, n, { configurable: !0, value: o });
  }, CP;
}
var IP, PX;
function _Qt() {
  if (PX) return IP;
  PX = 1;
  var e = fd(), t = Vh(), r = pu(), n = Uh(), i = r("species");
  return IP = function(o) {
    var a = e(o), u = t.f;
    n && a && !a[i] && u(a, i, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, IP;
}
var OP, DX;
function AQt() {
  return DX || (DX = 1, OP = function(e, t, r) {
    if (!(e instanceof t))
      throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
    return e;
  }), OP;
}
var RP, xX;
function SQt() {
  if (xX) return RP;
  xX = 1;
  var e = pu(), t = e("iterator"), r = !1;
  try {
    var n = 0, i = {
      next: function() {
        return { done: !!n++ };
      },
      return: function() {
        r = !0;
      }
    };
    i[t] = function() {
      return this;
    }, Array.from(i, function() {
      throw 2;
    });
  } catch {
  }
  return RP = function(o, a) {
    if (!a && !r) return !1;
    var u = !1;
    try {
      var s = {};
      s[t] = function() {
        return {
          next: function() {
            return { done: u = !0 };
          }
        };
      }, o(s);
    } catch {
    }
    return u;
  }, RP;
}
var wP, NX;
function Gge() {
  if (NX) return wP;
  NX = 1;
  var e = al(), t = zh(), r = pu(), n = r("species");
  return wP = function(i, o) {
    var a = e(i).constructor, u;
    return a === void 0 || (u = e(a)[n]) == null ? o : t(u);
  }, wP;
}
var PP, LX;
function Wge() {
  if (LX) return PP;
  LX = 1;
  var e = JF();
  return PP = /(?:iphone|ipod|ipad).*applewebkit/i.test(e), PP;
}
var DP, BX;
function e7() {
  if (BX) return DP;
  BX = 1;
  var e = MF(), t = Io();
  return DP = e(t.process) == "process", DP;
}
var xP, kX;
function Kge() {
  if (kX) return xP;
  kX = 1;
  var e = Io(), t = il(), r = jge(), n = $ge(), i = HF(), o = Wge(), a = e7(), u = e.location, s = e.setImmediate, c = e.clearImmediate, l = e.process, f = e.MessageChannel, d = e.Dispatch, p = 0, v = {}, h = "onreadystatechange", E, m, g, y = function(O) {
    if (v.hasOwnProperty(O)) {
      var P = v[O];
      delete v[O], P();
    }
  }, _ = function(O) {
    return function() {
      y(O);
    };
  }, S = function(O) {
    y(O.data);
  }, A = function(O) {
    e.postMessage(O + "", u.protocol + "//" + u.host);
  };
  return (!s || !c) && (s = function(P) {
    for (var U = [], z = 1; arguments.length > z; ) U.push(arguments[z++]);
    return v[++p] = function() {
      (typeof P == "function" ? P : Function(P)).apply(void 0, U);
    }, E(p), p;
  }, c = function(P) {
    delete v[P];
  }, a ? E = function(O) {
    l.nextTick(_(O));
  } : d && d.now ? E = function(O) {
    d.now(_(O));
  } : f && !o ? (m = new f(), g = m.port2, m.port1.onmessage = S, E = r(g.postMessage, g, 1)) : e.addEventListener && typeof postMessage == "function" && !e.importScripts && u && u.protocol !== "file:" && !t(A) ? (E = A, e.addEventListener("message", S, !1)) : h in i("script") ? E = function(O) {
    n.appendChild(i("script"))[h] = function() {
      n.removeChild(this), y(O);
    };
  } : E = function(O) {
    setTimeout(_(O), 0);
  }), xP = {
    set: s,
    clear: c
  }, xP;
}
var NP, MX;
function bQt() {
  if (MX) return NP;
  MX = 1;
  var e = JF();
  return NP = /web0s(?!.*chrome)/i.test(e), NP;
}
var LP, FX;
function CQt() {
  if (FX) return LP;
  FX = 1;
  var e = Io(), t = $F().f, r = Kge().set, n = Wge(), i = bQt(), o = e7(), a = e.MutationObserver || e.WebKitMutationObserver, u = e.document, s = e.process, c = e.Promise, l = t(e, "queueMicrotask"), f = l && l.value, d, p, v, h, E, m, g, y;
  return f || (d = function() {
    var _, S;
    for (o && (_ = s.domain) && _.exit(); p; ) {
      S = p.fn, p = p.next;
      try {
        S();
      } catch (A) {
        throw p ? h() : v = void 0, A;
      }
    }
    v = void 0, _ && _.enter();
  }, !n && !o && !i && a && u ? (E = !0, m = u.createTextNode(""), new a(d).observe(m, { characterData: !0 }), h = function() {
    m.data = E = !E;
  }) : c && c.resolve ? (g = c.resolve(void 0), g.constructor = c, y = g.then, h = function() {
    y.call(g, d);
  }) : o ? h = function() {
    s.nextTick(d);
  } : h = function() {
    r.call(e, d);
  }), LP = f || function(_) {
    var S = { fn: _, next: void 0 };
    v && (v.next = S), p || (p = S, h()), v = S;
  }, LP;
}
var BP = {}, HX;
function yy() {
  if (HX) return BP;
  HX = 1;
  var e = zh(), t = function(r) {
    var n, i;
    this.promise = new r(function(o, a) {
      if (n !== void 0 || i !== void 0) throw TypeError("Bad Promise constructor");
      n = o, i = a;
    }), this.resolve = e(n), this.reject = e(i);
  };
  return BP.f = function(r) {
    return new t(r);
  }, BP;
}
var kP, $X;
function Xge() {
  if ($X) return kP;
  $X = 1;
  var e = al(), t = ld(), r = yy();
  return kP = function(n, i) {
    if (e(n), t(i) && i.constructor === n) return i;
    var o = r.f(n), a = o.resolve;
    return a(i), o.promise;
  }, kP;
}
var MP, UX;
function IQt() {
  if (UX) return MP;
  UX = 1;
  var e = Io();
  return MP = function(t, r) {
    var n = e.console;
    n && n.error && (arguments.length === 1 ? n.error(t) : n.error(t, r));
  }, MP;
}
var FP, VX;
function a3() {
  return VX || (VX = 1, FP = function(e) {
    try {
      return { error: !1, value: e() };
    } catch (t) {
      return { error: !0, value: t };
    }
  }), FP;
}
var HP, jX;
function OQt() {
  return jX || (jX = 1, HP = typeof window == "object"), HP;
}
var zX;
function RQt() {
  if (zX) return IX;
  zX = 1;
  var e = dd(), t = gy(), r = Io(), n = fd(), i = Yge(), o = jh(), a = yQt(), u = KF(), s = QF(), c = _Qt(), l = ld(), f = zh(), d = AQt(), p = jF(), v = o3(), h = SQt(), E = Gge(), m = Kge().set, g = CQt(), y = Xge(), _ = IQt(), S = yy(), A = a3(), O = i3(), P = Hge(), U = pu(), z = OQt(), k = e7(), H = Uge(), B = U("species"), x = "Promise", D = O.get, w = O.set, $ = O.getterFor(x), X = i && i.prototype, V = i, F = X, le = r.TypeError, ae = r.document, ne = r.process, ve = S.f, Ie = ve, Oe = !!(ae && ae.createEvent && r.dispatchEvent), xe = typeof PromiseRejectionEvent == "function", ze = "unhandledrejection", qe = "rejectionhandled", Je = 0, Be = 1, We = 2, Ne = 1, je = 2, et = !1, St, Ot, we, De, Ee = P(x, function() {
    var be = p(V), Ge = be !== String(V);
    if (!Ge && H === 66 || t && !F.finally) return !0;
    if (H >= 51 && /native code/.test(be)) return !1;
    var st = new V(function(jt) {
      jt(1);
    }), wt = function(jt) {
      jt(function() {
      }, function() {
      });
    }, Bt = st.constructor = {};
    return Bt[B] = wt, et = st.then(function() {
    }) instanceof wt, et ? !Ge && z && !xe : !0;
  }), te = Ee || !h(function(be) {
    V.all(be).catch(function() {
    });
  }), ue = function(be) {
    var Ge;
    return l(be) && typeof (Ge = be.then) == "function" ? Ge : !1;
  }, ye = function(be, Ge) {
    if (!be.notified) {
      be.notified = !0;
      var st = be.reactions;
      g(function() {
        for (var wt = be.value, Bt = be.state == Be, jt = 0; st.length > jt; ) {
          var Xt = st[jt++], Qt = Bt ? Xt.ok : Xt.fail, Zr = Xt.resolve, Jn = Xt.reject, Ur = Xt.domain, fn, gn, cr;
          try {
            Qt ? (Bt || (be.rejection === je && ie(be), be.rejection = Ne), Qt === !0 ? fn = wt : (Ur && Ur.enter(), fn = Qt(wt), Ur && (Ur.exit(), cr = !0)), fn === Xt.promise ? Jn(le("Promise-chain cycle")) : (gn = ue(fn)) ? gn.call(fn, Zr, Jn) : Zr(fn)) : Jn(wt);
          } catch (Ri) {
            Ur && !cr && Ur.exit(), Jn(Ri);
          }
        }
        be.reactions = [], be.notified = !1, Ge && !be.rejection && Me(be);
      });
    }
  }, Le = function(be, Ge, st) {
    var wt, Bt;
    Oe ? (wt = ae.createEvent("Event"), wt.promise = Ge, wt.reason = st, wt.initEvent(be, !1, !0), r.dispatchEvent(wt)) : wt = { promise: Ge, reason: st }, !xe && (Bt = r["on" + be]) ? Bt(wt) : be === ze && _("Unhandled promise rejection", st);
  }, Me = function(be) {
    m.call(r, function() {
      var Ge = be.facade, st = be.value, wt = Ae(be), Bt;
      if (wt && (Bt = A(function() {
        k ? ne.emit("unhandledRejection", st, Ge) : Le(ze, Ge, st);
      }), be.rejection = k || Ae(be) ? je : Ne, Bt.error))
        throw Bt.value;
    });
  }, Ae = function(be) {
    return be.rejection !== Ne && !be.parent;
  }, ie = function(be) {
    m.call(r, function() {
      var Ge = be.facade;
      k ? ne.emit("rejectionHandled", Ge) : Le(qe, Ge, be.value);
    });
  }, K = function(be, Ge, st) {
    return function(wt) {
      be(Ge, wt, st);
    };
  }, Z = function(be, Ge, st) {
    be.done || (be.done = !0, st && (be = st), be.value = Ge, be.state = We, ye(be, !0));
  }, Ce = function(be, Ge, st) {
    if (!be.done) {
      be.done = !0, st && (be = st);
      try {
        if (be.facade === Ge) throw le("Promise can't be resolved itself");
        var wt = ue(Ge);
        wt ? g(function() {
          var Bt = { done: !1 };
          try {
            wt.call(
              Ge,
              K(Ce, Bt, be),
              K(Z, Bt, be)
            );
          } catch (jt) {
            Z(Bt, jt, be);
          }
        }) : (be.value = Ge, be.state = Be, ye(be, !1));
      } catch (Bt) {
        Z({ done: !1 }, Bt, be);
      }
    }
  };
  if (Ee && (V = function(Ge) {
    d(this, V, x), f(Ge), St.call(this);
    var st = D(this);
    try {
      Ge(K(Ce, st), K(Z, st));
    } catch (wt) {
      Z(st, wt);
    }
  }, F = V.prototype, St = function(Ge) {
    w(this, {
      type: x,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: [],
      rejection: !1,
      state: Je,
      value: void 0
    });
  }, St.prototype = a(F, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function(Ge, st) {
      var wt = $(this), Bt = ve(E(this, V));
      return Bt.ok = typeof Ge == "function" ? Ge : !0, Bt.fail = typeof st == "function" && st, Bt.domain = k ? ne.domain : void 0, wt.parent = !0, wt.reactions.push(Bt), wt.state != Je && ye(wt, !1), Bt.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    catch: function(be) {
      return this.then(void 0, be);
    }
  }), Ot = function() {
    var be = new St(), Ge = D(be);
    this.promise = be, this.resolve = K(Ce, Ge), this.reject = K(Z, Ge);
  }, S.f = ve = function(be) {
    return be === V || be === we ? new Ot(be) : Ie(be);
  }, !t && typeof i == "function" && X !== Object.prototype)) {
    De = X.then, et || (o(X, "then", function(Ge, st) {
      var wt = this;
      return new V(function(Bt, jt) {
        De.call(wt, Bt, jt);
      }).then(Ge, st);
    }, { unsafe: !0 }), o(X, "catch", F.catch, { unsafe: !0 }));
    try {
      delete X.constructor;
    } catch {
    }
    u && u(X, F);
  }
  return e({ global: !0, wrap: !0, forced: Ee }, {
    Promise: V
  }), s(V, x, !1, !0), c(x), we = n(x), e({ target: x, stat: !0, forced: Ee }, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function(Ge) {
      var st = ve(this);
      return st.reject.call(void 0, Ge), st.promise;
    }
  }), e({ target: x, stat: !0, forced: t || Ee }, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function(Ge) {
      return y(t && this === we ? V : this, Ge);
    }
  }), e({ target: x, stat: !0, forced: te }, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function(Ge) {
      var st = this, wt = ve(st), Bt = wt.resolve, jt = wt.reject, Xt = A(function() {
        var Qt = f(st.resolve), Zr = [], Jn = 0, Ur = 1;
        v(Ge, function(fn) {
          var gn = Jn++, cr = !1;
          Zr.push(void 0), Ur++, Qt.call(st, fn).then(function(Ri) {
            cr || (cr = !0, Zr[gn] = Ri, --Ur || Bt(Zr));
          }, jt);
        }), --Ur || Bt(Zr);
      });
      return Xt.error && jt(Xt.value), wt.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function(Ge) {
      var st = this, wt = ve(st), Bt = wt.reject, jt = A(function() {
        var Xt = f(st.resolve);
        v(Ge, function(Qt) {
          Xt.call(st, Qt).then(wt.resolve, Bt);
        });
      });
      return jt.error && Bt(jt.value), wt.promise;
    }
  }), IX;
}
var qX = {}, YX;
function Jge() {
  if (YX) return qX;
  YX = 1;
  var e = dd(), t = zh(), r = yy(), n = a3(), i = o3();
  return e({ target: "Promise", stat: !0 }, {
    allSettled: function(a) {
      var u = this, s = r.f(u), c = s.resolve, l = s.reject, f = n(function() {
        var d = t(u.resolve), p = [], v = 0, h = 1;
        i(a, function(E) {
          var m = v++, g = !1;
          p.push(void 0), h++, d.call(u, E).then(function(y) {
            g || (g = !0, p[m] = { status: "fulfilled", value: y }, --h || c(p));
          }, function(y) {
            g || (g = !0, p[m] = { status: "rejected", reason: y }, --h || c(p));
          });
        }), --h || c(p);
      });
      return f.error && l(f.value), s.promise;
    }
  }), qX;
}
var GX = {}, WX;
function Zge() {
  if (WX) return GX;
  WX = 1;
  var e = dd(), t = zh(), r = fd(), n = yy(), i = a3(), o = o3(), a = "No one promise resolved";
  return e({ target: "Promise", stat: !0 }, {
    any: function(s) {
      var c = this, l = n.f(c), f = l.resolve, d = l.reject, p = i(function() {
        var v = t(c.resolve), h = [], E = 0, m = 1, g = !1;
        o(s, function(y) {
          var _ = E++, S = !1;
          h.push(void 0), m++, v.call(c, y).then(function(A) {
            S || g || (g = !0, f(A));
          }, function(A) {
            S || g || (S = !0, h[_] = A, --m || d(new (r("AggregateError"))(h, a)));
          });
        }), --m || d(new (r("AggregateError"))(h, a));
      });
      return p.error && d(p.value), l.promise;
    }
  }), GX;
}
var KX = {}, XX;
function wQt() {
  if (XX) return KX;
  XX = 1;
  var e = dd(), t = gy(), r = Yge(), n = il(), i = fd(), o = Gge(), a = Xge(), u = jh(), s = !!r && n(function() {
    r.prototype.finally.call({ then: function() {
    } }, function() {
    });
  });
  if (e({ target: "Promise", proto: !0, real: !0, forced: s }, {
    finally: function(l) {
      var f = o(this, i("Promise")), d = typeof l == "function";
      return this.then(
        d ? function(p) {
          return a(f, l()).then(function() {
            return p;
          });
        } : l,
        d ? function(p) {
          return a(f, l()).then(function() {
            throw p;
          });
        } : l
      );
    }
  }), !t && typeof r == "function") {
    var c = i("Promise").prototype.finally;
    r.prototype.finally !== c && u(r.prototype, "finally", c, { unsafe: !0 });
  }
  return KX;
}
var JX = {}, $P, ZX;
function PQt() {
  if (ZX) return $P;
  ZX = 1;
  var e = YF(), t = FF(), r = function(n) {
    return function(i, o) {
      var a = String(t(i)), u = e(o), s = a.length, c, l;
      return u < 0 || u >= s ? n ? "" : void 0 : (c = a.charCodeAt(u), c < 55296 || c > 56319 || u + 1 === s || (l = a.charCodeAt(u + 1)) < 56320 || l > 57343 ? n ? a.charAt(u) : c : n ? a.slice(u, u + 2) : (c - 55296 << 10) + (l - 56320) + 65536);
    };
  };
  return $P = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: r(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: r(!0)
  }, $P;
}
var UP, QX;
function Qge() {
  if (QX) return UP;
  QX = 1;
  var e = il(), t = WF(), r = p0(), n = ol(), i = pu(), o = gy(), a = i("iterator"), u = !1, s = function() {
    return this;
  }, c, l, f;
  [].keys && (f = [].keys(), "next" in f ? (l = t(t(f)), l !== Object.prototype && (c = l)) : u = !0);
  var d = c == null || e(function() {
    var p = {};
    return c[a].call(p) !== p;
  });
  return d && (c = {}), (!o || d) && !n(c, a) && r(c, a, s), UP = {
    IteratorPrototype: c,
    BUGGY_SAFARI_ITERATORS: u
  }, UP;
}
var VP, eJ;
function DQt() {
  if (eJ) return VP;
  eJ = 1;
  var e = Qge().IteratorPrototype, t = XF(), r = r3(), n = QF(), i = Ty(), o = function() {
    return this;
  };
  return VP = function(a, u, s) {
    var c = u + " Iterator";
    return a.prototype = t(e, { next: r(1, s) }), n(a, c, !1, !0), i[c] = o, a;
  }, VP;
}
var jP, tJ;
function e1e() {
  if (tJ) return jP;
  tJ = 1;
  var e = dd(), t = DQt(), r = WF(), n = KF(), i = QF(), o = p0(), a = jh(), u = pu(), s = gy(), c = Ty(), l = Qge(), f = l.IteratorPrototype, d = l.BUGGY_SAFARI_ITERATORS, p = u("iterator"), v = "keys", h = "values", E = "entries", m = function() {
    return this;
  };
  return jP = function(g, y, _, S, A, O, P) {
    t(_, y, S);
    var U = function(V) {
      if (V === A && x) return x;
      if (!d && V in H) return H[V];
      switch (V) {
        case v:
          return function() {
            return new _(this, V);
          };
        case h:
          return function() {
            return new _(this, V);
          };
        case E:
          return function() {
            return new _(this, V);
          };
      }
      return function() {
        return new _(this);
      };
    }, z = y + " Iterator", k = !1, H = g.prototype, B = H[p] || H["@@iterator"] || A && H[A], x = !d && B || U(A), D = y == "Array" && H.entries || B, w, $, X;
    if (D && (w = r(D.call(new g())), f !== Object.prototype && w.next && (!s && r(w) !== f && (n ? n(w, f) : typeof w[p] != "function" && o(w, p, m)), i(w, z, !0, !0), s && (c[z] = m))), A == h && B && B.name !== h && (k = !0, x = function() {
      return B.call(this);
    }), (!s || P) && H[p] !== x && o(H, p, x), c[y] = x, A)
      if ($ = {
        values: U(h),
        keys: O ? x : U(v),
        entries: U(E)
      }, P) for (X in $)
        (d || k || !(X in H)) && a(H, X, $[X]);
      else e({ target: y, proto: !0, forced: d || k }, $);
    return $;
  }, jP;
}
var rJ;
function xQt() {
  if (rJ) return JX;
  rJ = 1;
  var e = PQt().charAt, t = i3(), r = e1e(), n = "String Iterator", i = t.set, o = t.getterFor(n);
  return r(String, "String", function(a) {
    i(this, {
      type: n,
      string: String(a),
      index: 0
    });
  }, function() {
    var u = o(this), s = u.string, c = u.index, l;
    return c >= s.length ? { value: void 0, done: !0 } : (l = e(s, c), u.index += l.length, { value: l, done: !1 });
  }), JX;
}
var nJ = {}, zP, iJ;
function NQt() {
  return iJ || (iJ = 1, zP = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), zP;
}
var qP, oJ;
function LQt() {
  if (oJ) return qP;
  oJ = 1;
  var e = pu(), t = XF(), r = Vh(), n = e("unscopables"), i = Array.prototype;
  return i[n] == null && r.f(i, n, {
    configurable: !0,
    value: t(null)
  }), qP = function(o) {
    i[n][o] = !0;
  }, qP;
}
var YP, aJ;
function BQt() {
  if (aJ) return YP;
  aJ = 1;
  var e = n3(), t = LQt(), r = Ty(), n = i3(), i = e1e(), o = "Array Iterator", a = n.set, u = n.getterFor(o);
  return YP = i(Array, "Array", function(s, c) {
    a(this, {
      type: o,
      target: e(s),
      // target
      index: 0,
      // next index
      kind: c
      // kind
    });
  }, function() {
    var s = u(this), c = s.target, l = s.kind, f = s.index++;
    return !c || f >= c.length ? (s.target = void 0, { value: void 0, done: !0 }) : l == "keys" ? { value: f, done: !1 } : l == "values" ? { value: c[f], done: !1 } : { value: [f, c[f]], done: !1 };
  }, "values"), r.Arguments = r.Array, t("keys"), t("values"), t("entries"), YP;
}
var uJ;
function kQt() {
  if (uJ) return nJ;
  uJ = 1;
  var e = Io(), t = NQt(), r = BQt(), n = p0(), i = pu(), o = i("iterator"), a = i("toStringTag"), u = r.values;
  for (var s in t) {
    var c = e[s], l = c && c.prototype;
    if (l) {
      if (l[o] !== u) try {
        n(l, o, u);
      } catch {
        l[o] = u;
      }
      if (l[a] || n(l, a, s), t[s]) {
        for (var f in r)
          if (l[f] !== r[f]) try {
            n(l, f, r[f]);
          } catch {
            l[f] = r[f];
          }
      }
    }
  }
  return nJ;
}
var GP, sJ;
function MQt() {
  if (sJ) return GP;
  sJ = 1, qge(), TQt(), RQt(), Jge(), Zge(), wQt(), xQt(), kQt();
  var e = kge();
  return GP = e.Promise, GP;
}
var cJ = {}, lJ;
function FQt() {
  return lJ || (lJ = 1, qge()), cJ;
}
var fJ = {}, dJ;
function HQt() {
  return dJ || (dJ = 1, Jge()), fJ;
}
var pJ = {}, hJ;
function $Qt() {
  if (hJ) return pJ;
  hJ = 1;
  var e = dd(), t = yy(), r = a3();
  return e({ target: "Promise", stat: !0 }, {
    try: function(n) {
      var i = t.f(this), o = r(n);
      return (o.error ? i.reject : i.resolve)(o.value), i.promise;
    }
  }), pJ;
}
var vJ = {}, EJ;
function UQt() {
  return EJ || (EJ = 1, Zge()), vJ;
}
var WP, mJ;
function VQt() {
  if (mJ) return WP;
  mJ = 1;
  var e = MQt();
  return FQt(), HQt(), $Qt(), UQt(), WP = e, WP;
}
var gJ = {}, TJ;
function jQt() {
  return TJ || (TJ = 1, function(e) {
    var t = function() {
      try {
        if (e.URLSearchParams && new e.URLSearchParams("foo=bar").get("foo") === "bar")
          return e.URLSearchParams;
      } catch {
      }
      return null;
    }(), r = t && new t({ a: 1 }).toString() === "a=1", n = t && new t("s=%2B").get("s") === "+", i = "__URLSearchParams__", o = t ? function() {
      var _ = new t();
      return _.append("s", " &"), _.toString() === "s=+%26";
    }() : !0, a = s.prototype, u = !!(e.Symbol && e.Symbol.iterator);
    if (t && r && n && o)
      return;
    function s(_) {
      _ = _ || "", (_ instanceof URLSearchParams || _ instanceof s) && (_ = _.toString()), this[i] = E(_);
    }
    a.append = function(_, S) {
      m(this[i], _, S);
    }, a.delete = function(_) {
      delete this[i][_];
    }, a.get = function(_) {
      var S = this[i];
      return this.has(_) ? S[_][0] : null;
    }, a.getAll = function(_) {
      var S = this[i];
      return this.has(_) ? S[_].slice(0) : [];
    }, a.has = function(_) {
      return y(this[i], _);
    }, a.set = function(S, A) {
      this[i][S] = ["" + A];
    }, a.toString = function() {
      var _ = this[i], S = [], A, O, P, U;
      for (O in _)
        for (P = p(O), A = 0, U = _[O]; A < U.length; A++)
          S.push(P + "=" + p(U[A]));
      return S.join("&");
    };
    var c = !n, l = !c && t && !r && e.Proxy, f;
    l ? (f = new Proxy(t, {
      construct: function(_, S) {
        return new _(new s(S[0]).toString());
      }
    }), f.toString = Function.prototype.toString.bind(s)) : f = s, Object.defineProperty(e, "URLSearchParams", {
      value: f
    });
    var d = e.URLSearchParams.prototype;
    d.polyfill = !0, d.forEach = d.forEach || function(_, S) {
      var A = E(this.toString());
      Object.getOwnPropertyNames(A).forEach(function(O) {
        A[O].forEach(function(P) {
          _.call(S, P, O, this);
        }, this);
      }, this);
    }, d.sort = d.sort || function() {
      var _ = E(this.toString()), S = [], A, O, P;
      for (A in _)
        S.push(A);
      for (S.sort(), O = 0; O < S.length; O++)
        this.delete(S[O]);
      for (O = 0; O < S.length; O++) {
        var U = S[O], z = _[U];
        for (P = 0; P < z.length; P++)
          this.append(U, z[P]);
      }
    }, d.keys = d.keys || function() {
      var _ = [];
      return this.forEach(function(S, A) {
        _.push(A);
      }), h(_);
    }, d.values = d.values || function() {
      var _ = [];
      return this.forEach(function(S) {
        _.push(S);
      }), h(_);
    }, d.entries = d.entries || function() {
      var _ = [];
      return this.forEach(function(S, A) {
        _.push([A, S]);
      }), h(_);
    }, u && (d[e.Symbol.iterator] = d[e.Symbol.iterator] || d.entries);
    function p(_) {
      var S = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
      };
      return encodeURIComponent(_).replace(/[!'\(\)~]|%20|%00/g, function(A) {
        return S[A];
      });
    }
    function v(_) {
      return _.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(S) {
        return decodeURIComponent(S);
      });
    }
    function h(_) {
      var S = {
        next: function() {
          var A = _.shift();
          return { done: A === void 0, value: A };
        }
      };
      return u && (S[e.Symbol.iterator] = function() {
        return S;
      }), S;
    }
    function E(_) {
      var S = {};
      if (typeof _ == "object")
        if (g(_))
          for (var A = 0; A < _.length; A++) {
            var O = _[A];
            if (g(O) && O.length === 2)
              m(S, O[0], O[1]);
            else
              throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
          }
        else
          for (var P in _)
            _.hasOwnProperty(P) && m(S, P, _[P]);
      else {
        _.indexOf("?") === 0 && (_ = _.slice(1));
        for (var U = _.split("&"), z = 0; z < U.length; z++) {
          var k = U[z], H = k.indexOf("=");
          -1 < H ? m(S, v(k.slice(0, H)), v(k.slice(H + 1))) : k && m(S, v(k), "");
        }
      }
      return S;
    }
    function m(_, S, A) {
      var O = typeof A == "string" ? A : A != null && typeof A.toString == "function" ? A.toString() : JSON.stringify(A);
      y(_, S) ? _[S].push(O) : _[S] = [O];
    }
    function g(_) {
      return !!_ && Object.prototype.toString.call(_) === "[object Array]";
    }
    function y(_, S) {
      return Object.prototype.hasOwnProperty.call(_, S);
    }
  }(typeof fe < "u" ? fe : typeof window < "u" ? window : fe)), gJ;
}
var KP = {}, Bv = {}, XP = {}, JP = {}, yJ;
function ul() {
  if (yJ) return JP;
  yJ = 1;
  var e = typeof window < "u" && window, t = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, r = typeof fe < "u" && fe, n = e || r || t;
  return JP.root = n, function() {
    if (!n)
      throw new Error("RxJS could not find any global context (window, self, global)");
  }(), JP;
}
var ZP = {}, QP = {}, e6 = {}, _J;
function t1e() {
  if (_J) return e6;
  _J = 1;
  function e(t) {
    return typeof t == "function";
  }
  return e6.isFunction = e, e6;
}
var t6 = {}, r6 = {}, AJ;
function u3() {
  return AJ || (AJ = 1, r6.isArray = Array.isArray || function(e) {
    return e && typeof e.length == "number";
  }), r6;
}
var n6 = {}, SJ;
function r1e() {
  if (SJ) return n6;
  SJ = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return n6.isObject = e, n6;
}
var i6 = {}, o6 = {}, bJ;
function s3() {
  return bJ || (bJ = 1, o6.errorObject = { e: {} }), o6;
}
var CJ;
function t7() {
  if (CJ) return i6;
  CJ = 1;
  var e = s3(), t;
  function r() {
    try {
      return t.apply(this, arguments);
    } catch (i) {
      return e.errorObject.e = i, e.errorObject;
    }
  }
  function n(i) {
    return t = i, r;
  }
  return i6.tryCatch = n, i6;
}
var a6 = {}, IJ;
function zQt() {
  if (IJ) return a6;
  IJ = 1;
  var e = fe && fe.__extends || function(r, n) {
    for (var i in n) n.hasOwnProperty(i) && (r[i] = n[i]);
    function o() {
      this.constructor = r;
    }
    r.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  }, t = function(r) {
    e(n, r);
    function n(i) {
      r.call(this), this.errors = i;
      var o = Error.call(this, i ? i.length + ` errors occurred during unsubscription:
  ` + i.map(function(a, u) {
        return u + 1 + ") " + a.toString();
      }).join(`
  `) : "");
      this.name = o.name = "UnsubscriptionError", this.stack = o.stack, this.message = o.message;
    }
    return n;
  }(Error);
  return a6.UnsubscriptionError = t, a6;
}
var OJ;
function _y() {
  if (OJ) return t6;
  OJ = 1;
  var e = u3(), t = r1e(), r = t1e(), n = t7(), i = s3(), o = zQt(), a = function() {
    function s(c) {
      this.closed = !1, this._parent = null, this._parents = null, this._subscriptions = null, c && (this._unsubscribe = c);
    }
    return s.prototype.unsubscribe = function() {
      var c = !1, l;
      if (!this.closed) {
        var f = this, d = f._parent, p = f._parents, v = f._unsubscribe, h = f._subscriptions;
        this.closed = !0, this._parent = null, this._parents = null, this._subscriptions = null;
        for (var E = -1, m = p ? p.length : 0; d; )
          d.remove(this), d = ++E < m && p[E] || null;
        if (r.isFunction(v)) {
          var g = n.tryCatch(v).call(this);
          g === i.errorObject && (c = !0, l = l || (i.errorObject.e instanceof o.UnsubscriptionError ? u(i.errorObject.e.errors) : [i.errorObject.e]));
        }
        if (e.isArray(h))
          for (E = -1, m = h.length; ++E < m; ) {
            var y = h[E];
            if (t.isObject(y)) {
              var g = n.tryCatch(y.unsubscribe).call(y);
              if (g === i.errorObject) {
                c = !0, l = l || [];
                var _ = i.errorObject.e;
                _ instanceof o.UnsubscriptionError ? l = l.concat(u(_.errors)) : l.push(_);
              }
            }
          }
        if (c)
          throw new o.UnsubscriptionError(l);
      }
    }, s.prototype.add = function(c) {
      if (!c || c === s.EMPTY)
        return s.EMPTY;
      if (c === this)
        return this;
      var l = c;
      switch (typeof c) {
        case "function":
          l = new s(c);
        case "object":
          if (l.closed || typeof l.unsubscribe != "function")
            return l;
          if (this.closed)
            return l.unsubscribe(), l;
          if (typeof l._addParent != "function") {
            var f = l;
            l = new s(), l._subscriptions = [f];
          }
          break;
        default:
          throw new Error("unrecognized teardown " + c + " added to Subscription.");
      }
      var d = this._subscriptions || (this._subscriptions = []);
      return d.push(l), l._addParent(this), l;
    }, s.prototype.remove = function(c) {
      var l = this._subscriptions;
      if (l) {
        var f = l.indexOf(c);
        f !== -1 && l.splice(f, 1);
      }
    }, s.prototype._addParent = function(c) {
      var l = this, f = l._parent, d = l._parents;
      !f || f === c ? this._parent = c : d ? d.indexOf(c) === -1 && d.push(c) : this._parents = [c];
    }, s.EMPTY = function(c) {
      return c.closed = !0, c;
    }(new s()), s;
  }();
  t6.Subscription = a;
  function u(s) {
    return s.reduce(function(c, l) {
      return c.concat(l instanceof o.UnsubscriptionError ? l.errors : l);
    }, []);
  }
  return t6;
}
var u6 = {}, RJ;
function n1e() {
  return RJ || (RJ = 1, u6.empty = {
    closed: !0,
    next: function(e) {
    },
    error: function(e) {
      throw e;
    },
    complete: function() {
    }
  }), u6;
}
var s6 = {}, wJ;
function r7() {
  return wJ || (wJ = 1, function(e) {
    var t = ul(), r = t.root.Symbol;
    e.rxSubscriber = typeof r == "function" && typeof r.for == "function" ? r.for("rxSubscriber") : "@@rxSubscriber", e.$$rxSubscriber = e.rxSubscriber;
  }(s6)), s6;
}
var PJ;
function Ua() {
  if (PJ) return QP;
  PJ = 1;
  var e = fe && fe.__extends || function(s, c) {
    for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
    function f() {
      this.constructor = s;
    }
    s.prototype = c === null ? Object.create(c) : (f.prototype = c.prototype, new f());
  }, t = t1e(), r = _y(), n = n1e(), i = r7(), o = function(s) {
    e(c, s);
    function c(l, f, d) {
      switch (s.call(this), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length) {
        case 0:
          this.destination = n.empty;
          break;
        case 1:
          if (!l) {
            this.destination = n.empty;
            break;
          }
          if (typeof l == "object") {
            if (u(l)) {
              var p = l[i.rxSubscriber]();
              this.syncErrorThrowable = p.syncErrorThrowable, this.destination = p, p.add(this);
            } else
              this.syncErrorThrowable = !0, this.destination = new a(this, l);
            break;
          }
        default:
          this.syncErrorThrowable = !0, this.destination = new a(this, l, f, d);
          break;
      }
    }
    return c.prototype[i.rxSubscriber] = function() {
      return this;
    }, c.create = function(l, f, d) {
      var p = new c(l, f, d);
      return p.syncErrorThrowable = !1, p;
    }, c.prototype.next = function(l) {
      this.isStopped || this._next(l);
    }, c.prototype.error = function(l) {
      this.isStopped || (this.isStopped = !0, this._error(l));
    }, c.prototype.complete = function() {
      this.isStopped || (this.isStopped = !0, this._complete());
    }, c.prototype.unsubscribe = function() {
      this.closed || (this.isStopped = !0, s.prototype.unsubscribe.call(this));
    }, c.prototype._next = function(l) {
      this.destination.next(l);
    }, c.prototype._error = function(l) {
      this.destination.error(l), this.unsubscribe();
    }, c.prototype._complete = function() {
      this.destination.complete(), this.unsubscribe();
    }, c.prototype._unsubscribeAndRecycle = function() {
      var l = this, f = l._parent, d = l._parents;
      return this._parent = null, this._parents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parent = f, this._parents = d, this;
    }, c;
  }(r.Subscription);
  QP.Subscriber = o;
  var a = function(s) {
    e(c, s);
    function c(l, f, d, p) {
      s.call(this), this._parentSubscriber = l;
      var v, h = this;
      t.isFunction(f) ? v = f : f && (v = f.next, d = f.error, p = f.complete, f !== n.empty && (h = Object.create(f), t.isFunction(h.unsubscribe) && this.add(h.unsubscribe.bind(h)), h.unsubscribe = this.unsubscribe.bind(this))), this._context = h, this._next = v, this._error = d, this._complete = p;
    }
    return c.prototype.next = function(l) {
      if (!this.isStopped && this._next) {
        var f = this._parentSubscriber;
        f.syncErrorThrowable ? this.__tryOrSetError(f, this._next, l) && this.unsubscribe() : this.__tryOrUnsub(this._next, l);
      }
    }, c.prototype.error = function(l) {
      if (!this.isStopped) {
        var f = this._parentSubscriber;
        if (this._error)
          f.syncErrorThrowable ? (this.__tryOrSetError(f, this._error, l), this.unsubscribe()) : (this.__tryOrUnsub(this._error, l), this.unsubscribe());
        else if (f.syncErrorThrowable)
          f.syncErrorValue = l, f.syncErrorThrown = !0, this.unsubscribe();
        else
          throw this.unsubscribe(), l;
      }
    }, c.prototype.complete = function() {
      var l = this;
      if (!this.isStopped) {
        var f = this._parentSubscriber;
        if (this._complete) {
          var d = function() {
            return l._complete.call(l._context);
          };
          f.syncErrorThrowable ? (this.__tryOrSetError(f, d), this.unsubscribe()) : (this.__tryOrUnsub(d), this.unsubscribe());
        } else
          this.unsubscribe();
      }
    }, c.prototype.__tryOrUnsub = function(l, f) {
      try {
        l.call(this._context, f);
      } catch (d) {
        throw this.unsubscribe(), d;
      }
    }, c.prototype.__tryOrSetError = function(l, f, d) {
      try {
        f.call(this._context, d);
      } catch (p) {
        return l.syncErrorValue = p, l.syncErrorThrown = !0, !0;
      }
      return !1;
    }, c.prototype._unsubscribe = function() {
      var l = this._parentSubscriber;
      this._context = null, this._parentSubscriber = null, l.unsubscribe();
    }, c;
  }(o);
  function u(s) {
    return s instanceof o || "syncErrorThrowable" in s && s[i.rxSubscriber];
  }
  return QP;
}
var DJ;
function qQt() {
  if (DJ) return ZP;
  DJ = 1;
  var e = Ua(), t = r7(), r = n1e();
  function n(i, o, a) {
    if (i) {
      if (i instanceof e.Subscriber)
        return i;
      if (i[t.rxSubscriber])
        return i[t.rxSubscriber]();
    }
    return !i && !o && !a ? new e.Subscriber(r.empty) : new e.Subscriber(i, o, a);
  }
  return ZP.toSubscriber = n, ZP;
}
var c6 = {}, xJ;
function n7() {
  return xJ || (xJ = 1, function(e) {
    var t = ul();
    function r(n) {
      var i, o = n.Symbol;
      return typeof o == "function" ? o.observable ? i = o.observable : (i = o("observable"), o.observable = i) : i = "@@observable", i;
    }
    e.getSymbolObservable = r, e.observable = r(t.root), e.$$observable = e.observable;
  }(c6)), c6;
}
var sA = {}, l6 = {}, NJ;
function YQt() {
  if (NJ) return l6;
  NJ = 1;
  function e() {
  }
  return l6.noop = e, l6;
}
var LJ;
function GQt() {
  if (LJ) return sA;
  LJ = 1;
  var e = YQt();
  function t() {
    for (var n = [], i = 0; i < arguments.length; i++)
      n[i - 0] = arguments[i];
    return r(n);
  }
  sA.pipe = t;
  function r(n) {
    return n ? n.length === 1 ? n[0] : function(o) {
      return n.reduce(function(a, u) {
        return u(a);
      }, o);
    } : e.noop;
  }
  return sA.pipeFromArray = r, sA;
}
var BJ;
function ln() {
  if (BJ) return XP;
  BJ = 1;
  var e = ul(), t = qQt(), r = n7(), n = GQt(), i = function() {
    function o(a) {
      this._isScalar = !1, a && (this._subscribe = a);
    }
    return o.prototype.lift = function(a) {
      var u = new o();
      return u.source = this, u.operator = a, u;
    }, o.prototype.subscribe = function(a, u, s) {
      var c = this.operator, l = t.toSubscriber(a, u, s);
      if (c ? c.call(l, this.source) : l.add(this.source || !l.syncErrorThrowable ? this._subscribe(l) : this._trySubscribe(l)), l.syncErrorThrowable && (l.syncErrorThrowable = !1, l.syncErrorThrown))
        throw l.syncErrorValue;
      return l;
    }, o.prototype._trySubscribe = function(a) {
      try {
        return this._subscribe(a);
      } catch (u) {
        a.syncErrorThrown = !0, a.syncErrorValue = u, a.error(u);
      }
    }, o.prototype.forEach = function(a, u) {
      var s = this;
      if (u || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? u = e.root.Rx.config.Promise : e.root.Promise && (u = e.root.Promise)), !u)
        throw new Error("no Promise impl found");
      return new u(function(c, l) {
        var f;
        f = s.subscribe(function(d) {
          if (f)
            try {
              a(d);
            } catch (p) {
              l(p), f.unsubscribe();
            }
          else
            a(d);
        }, l, c);
      });
    }, o.prototype._subscribe = function(a) {
      return this.source.subscribe(a);
    }, o.prototype[r.observable] = function() {
      return this;
    }, o.prototype.pipe = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u - 0] = arguments[u];
      return a.length === 0 ? this : n.pipeFromArray(a)(this);
    }, o.prototype.toPromise = function(a) {
      var u = this;
      if (a || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? a = e.root.Rx.config.Promise : e.root.Promise && (a = e.root.Promise)), !a)
        throw new Error("no Promise impl found");
      return new a(function(s, c) {
        var l;
        u.subscribe(function(f) {
          return l = f;
        }, function(f) {
          return c(f);
        }, function() {
          return s(l);
        });
      });
    }, o.create = function(a) {
      return new o(a);
    }, o;
  }();
  return XP.Observable = i, XP;
}
var f6 = {}, kJ;
function i1e() {
  if (kJ) return f6;
  kJ = 1;
  var e = fe && fe.__extends || function(r, n) {
    for (var i in n) n.hasOwnProperty(i) && (r[i] = n[i]);
    function o() {
      this.constructor = r;
    }
    r.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  }, t = function(r) {
    e(n, r);
    function n() {
      var i = r.call(this, "object unsubscribed");
      this.name = i.name = "ObjectUnsubscribedError", this.stack = i.stack, this.message = i.message;
    }
    return n;
  }(Error);
  return f6.ObjectUnsubscribedError = t, f6;
}
var d6 = {}, MJ;
function WQt() {
  if (MJ) return d6;
  MJ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = _y(), r = function(n) {
    e(i, n);
    function i(o, a) {
      n.call(this), this.subject = o, this.subscriber = a, this.closed = !1;
    }
    return i.prototype.unsubscribe = function() {
      if (!this.closed) {
        this.closed = !0;
        var o = this.subject, a = o.observers;
        if (this.subject = null, !(!a || a.length === 0 || o.isStopped || o.closed)) {
          var u = a.indexOf(this.subscriber);
          u !== -1 && a.splice(u, 1);
        }
      }
    }, i;
  }(t.Subscription);
  return d6.SubjectSubscription = r, d6;
}
var FJ;
function c3() {
  if (FJ) return Bv;
  FJ = 1;
  var e = fe && fe.__extends || function(l, f) {
    for (var d in f) f.hasOwnProperty(d) && (l[d] = f[d]);
    function p() {
      this.constructor = l;
    }
    l.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
  }, t = ln(), r = Ua(), n = _y(), i = i1e(), o = WQt(), a = r7(), u = function(l) {
    e(f, l);
    function f(d) {
      l.call(this, d), this.destination = d;
    }
    return f;
  }(r.Subscriber);
  Bv.SubjectSubscriber = u;
  var s = function(l) {
    e(f, l);
    function f() {
      l.call(this), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
    }
    return f.prototype[a.rxSubscriber] = function() {
      return new u(this);
    }, f.prototype.lift = function(d) {
      var p = new c(this, this);
      return p.operator = d, p;
    }, f.prototype.next = function(d) {
      if (this.closed)
        throw new i.ObjectUnsubscribedError();
      if (!this.isStopped)
        for (var p = this.observers, v = p.length, h = p.slice(), E = 0; E < v; E++)
          h[E].next(d);
    }, f.prototype.error = function(d) {
      if (this.closed)
        throw new i.ObjectUnsubscribedError();
      this.hasError = !0, this.thrownError = d, this.isStopped = !0;
      for (var p = this.observers, v = p.length, h = p.slice(), E = 0; E < v; E++)
        h[E].error(d);
      this.observers.length = 0;
    }, f.prototype.complete = function() {
      if (this.closed)
        throw new i.ObjectUnsubscribedError();
      this.isStopped = !0;
      for (var d = this.observers, p = d.length, v = d.slice(), h = 0; h < p; h++)
        v[h].complete();
      this.observers.length = 0;
    }, f.prototype.unsubscribe = function() {
      this.isStopped = !0, this.closed = !0, this.observers = null;
    }, f.prototype._trySubscribe = function(d) {
      if (this.closed)
        throw new i.ObjectUnsubscribedError();
      return l.prototype._trySubscribe.call(this, d);
    }, f.prototype._subscribe = function(d) {
      if (this.closed)
        throw new i.ObjectUnsubscribedError();
      return this.hasError ? (d.error(this.thrownError), n.Subscription.EMPTY) : this.isStopped ? (d.complete(), n.Subscription.EMPTY) : (this.observers.push(d), new o.SubjectSubscription(this, d));
    }, f.prototype.asObservable = function() {
      var d = new t.Observable();
      return d.source = this, d;
    }, f.create = function(d, p) {
      return new c(d, p);
    }, f;
  }(t.Observable);
  Bv.Subject = s;
  var c = function(l) {
    e(f, l);
    function f(d, p) {
      l.call(this), this.destination = d, this.source = p;
    }
    return f.prototype.next = function(d) {
      var p = this.destination;
      p && p.next && p.next(d);
    }, f.prototype.error = function(d) {
      var p = this.destination;
      p && p.error && this.destination.error(d);
    }, f.prototype.complete = function() {
      var d = this.destination;
      d && d.complete && this.destination.complete();
    }, f.prototype._subscribe = function(d) {
      var p = this.source;
      return p ? this.source.subscribe(d) : n.Subscription.EMPTY;
    }, f;
  }(s);
  return Bv.AnonymousSubject = c, Bv;
}
var HJ;
function o1e() {
  if (HJ) return KP;
  HJ = 1;
  var e = fe && fe.__extends || function(i, o) {
    for (var a in o) o.hasOwnProperty(a) && (i[a] = o[a]);
    function u() {
      this.constructor = i;
    }
    i.prototype = o === null ? Object.create(o) : (u.prototype = o.prototype, new u());
  }, t = c3(), r = i1e(), n = function(i) {
    e(o, i);
    function o(a) {
      i.call(this), this._value = a;
    }
    return Object.defineProperty(o.prototype, "value", {
      get: function() {
        return this.getValue();
      },
      enumerable: !0,
      configurable: !0
    }), o.prototype._subscribe = function(a) {
      var u = i.prototype._subscribe.call(this, a);
      return u && !u.closed && a.next(this._value), u;
    }, o.prototype.getValue = function() {
      if (this.hasError)
        throw this.thrownError;
      if (this.closed)
        throw new r.ObjectUnsubscribedError();
      return this._value;
    }, o.prototype.next = function(a) {
      i.prototype.next.call(this, this._value = a);
    }, o;
  }(t.Subject);
  return KP.BehaviorSubject = n, KP;
}
var p6 = {}, h6 = {}, v6 = {}, $J;
function KQt() {
  if ($J) return v6;
  $J = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = _y(), r = function(n) {
    e(i, n);
    function i(o, a) {
      n.call(this);
    }
    return i.prototype.schedule = function(o, a) {
      return this;
    }, i;
  }(t.Subscription);
  return v6.Action = r, v6;
}
var UJ;
function XQt() {
  if (UJ) return h6;
  UJ = 1;
  var e = fe && fe.__extends || function(i, o) {
    for (var a in o) o.hasOwnProperty(a) && (i[a] = o[a]);
    function u() {
      this.constructor = i;
    }
    i.prototype = o === null ? Object.create(o) : (u.prototype = o.prototype, new u());
  }, t = ul(), r = KQt(), n = function(i) {
    e(o, i);
    function o(a, u) {
      i.call(this, a, u), this.scheduler = a, this.pending = !1, this.work = u;
    }
    return o.prototype.schedule = function(a, u) {
      if (u === void 0 && (u = 0), this.closed)
        return this;
      this.state = a, this.pending = !0;
      var s = this.id, c = this.scheduler;
      return s != null && (this.id = this.recycleAsyncId(c, s, u)), this.delay = u, this.id = this.id || this.requestAsyncId(c, this.id, u), this;
    }, o.prototype.requestAsyncId = function(a, u, s) {
      return s === void 0 && (s = 0), t.root.setInterval(a.flush.bind(a, this), s);
    }, o.prototype.recycleAsyncId = function(a, u, s) {
      return s === void 0 && (s = 0), s !== null && this.delay === s && this.pending === !1 ? u : t.root.clearInterval(u) && void 0 || void 0;
    }, o.prototype.execute = function(a, u) {
      if (this.closed)
        return new Error("executing a cancelled action");
      this.pending = !1;
      var s = this._execute(a, u);
      if (s)
        return s;
      this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
    }, o.prototype._execute = function(a, u) {
      var s = !1, c = void 0;
      try {
        this.work(a);
      } catch (l) {
        s = !0, c = !!l && l || new Error(l);
      }
      if (s)
        return this.unsubscribe(), c;
    }, o.prototype._unsubscribe = function() {
      var a = this.id, u = this.scheduler, s = u.actions, c = s.indexOf(this);
      this.work = null, this.state = null, this.pending = !1, this.scheduler = null, c !== -1 && s.splice(c, 1), a != null && (this.id = this.recycleAsyncId(u, a, null)), this.delay = null;
    }, o;
  }(r.Action);
  return h6.AsyncAction = n, h6;
}
var E6 = {}, m6 = {}, VJ;
function JQt() {
  if (VJ) return m6;
  VJ = 1;
  var e = function() {
    function t(r, n) {
      n === void 0 && (n = t.now), this.SchedulerAction = r, this.now = n;
    }
    return t.prototype.schedule = function(r, n, i) {
      return n === void 0 && (n = 0), new this.SchedulerAction(this, r).schedule(i, n);
    }, t.now = Date.now ? Date.now : function() {
      return +/* @__PURE__ */ new Date();
    }, t;
  }();
  return m6.Scheduler = e, m6;
}
var jJ;
function ZQt() {
  if (jJ) return E6;
  jJ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = JQt(), r = function(n) {
    e(i, n);
    function i() {
      n.apply(this, arguments), this.actions = [], this.active = !1, this.scheduled = void 0;
    }
    return i.prototype.flush = function(o) {
      var a = this.actions;
      if (this.active) {
        a.push(o);
        return;
      }
      var u;
      this.active = !0;
      do
        if (u = o.execute(o.state, o.delay))
          break;
      while (o = a.shift());
      if (this.active = !1, u) {
        for (; o = a.shift(); )
          o.unsubscribe();
        throw u;
      }
    }, i;
  }(t.Scheduler);
  return E6.AsyncScheduler = r, E6;
}
var zJ;
function l3() {
  if (zJ) return p6;
  zJ = 1;
  var e = XQt(), t = ZQt();
  return p6.async = new t.AsyncScheduler(e.AsyncAction), p6;
}
function JL(e) {
  this.message = e;
}
JL.prototype = new Error(), JL.prototype.name = "InvalidCharacterError";
var qJ = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new JL("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, o = 0, a = ""; n = t.charAt(o++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? a += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return a;
};
function QQt(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(qJ(r).replace(/(.)/g, function(n, i) {
        var o = i.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      }));
    }(t);
  } catch {
    return qJ(t);
  }
}
function X1(e) {
  this.message = e;
}
function a1e(e, t) {
  if (typeof e != "string") throw new X1("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(QQt(e.split(".")[r]));
  } catch (n) {
    throw new X1("Invalid token specified: " + n.message);
  }
}
X1.prototype = new Error(), X1.prototype.name = "InvalidTokenError";
const eer = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InvalidTokenError: X1,
  default: a1e
}, Symbol.toStringTag, { value: "Module" })), ter = /* @__PURE__ */ lh(eer);
var YJ = {}, g6 = {}, T6 = {}, y6 = {}, GJ;
function f3() {
  if (GJ) return y6;
  GJ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = Ua(), r = function(n) {
    e(i, n);
    function i() {
      n.apply(this, arguments);
    }
    return i.prototype.notifyNext = function(o, a, u, s, c) {
      this.destination.next(a);
    }, i.prototype.notifyError = function(o, a) {
      this.destination.error(o);
    }, i.prototype.notifyComplete = function(o) {
      this.destination.complete();
    }, i;
  }(t.Subscriber);
  return y6.OuterSubscriber = r, y6;
}
var _6 = {}, A6 = {}, WJ;
function u1e() {
  return WJ || (WJ = 1, A6.isArrayLike = function(e) {
    return e && typeof e.length == "number";
  }), A6;
}
var S6 = {}, KJ;
function s1e() {
  if (KJ) return S6;
  KJ = 1;
  function e(t) {
    return t && typeof t.subscribe != "function" && typeof t.then == "function";
  }
  return S6.isPromise = e, S6;
}
var b6 = {}, XJ;
function i7() {
  return XJ || (XJ = 1, function(e) {
    var t = ul();
    function r(n) {
      var i = n.Symbol;
      if (typeof i == "function")
        return i.iterator || (i.iterator = i("iterator polyfill")), i.iterator;
      var o = n.Set;
      if (o && typeof new o()["@@iterator"] == "function")
        return "@@iterator";
      var a = n.Map;
      if (a)
        for (var u = Object.getOwnPropertyNames(a.prototype), s = 0; s < u.length; ++s) {
          var c = u[s];
          if (c !== "entries" && c !== "size" && a.prototype[c] === a.prototype.entries)
            return c;
        }
      return "@@iterator";
    }
    e.symbolIteratorPonyfill = r, e.iterator = r(t.root), e.$$iterator = e.iterator;
  }(b6)), b6;
}
var C6 = {}, JJ;
function rer() {
  if (JJ) return C6;
  JJ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = Ua(), r = function(n) {
    e(i, n);
    function i(o, a, u) {
      n.call(this), this.parent = o, this.outerValue = a, this.outerIndex = u, this.index = 0;
    }
    return i.prototype._next = function(o) {
      this.parent.notifyNext(this.outerValue, o, this.outerIndex, this.index++, this);
    }, i.prototype._error = function(o) {
      this.parent.notifyError(o, this), this.unsubscribe();
    }, i.prototype._complete = function() {
      this.parent.notifyComplete(this), this.unsubscribe();
    }, i;
  }(t.Subscriber);
  return C6.InnerSubscriber = r, C6;
}
var ZJ;
function d3() {
  if (ZJ) return _6;
  ZJ = 1;
  var e = ul(), t = u1e(), r = s1e(), n = r1e(), i = ln(), o = i7(), a = rer(), u = n7();
  function s(c, l, f, d) {
    var p = new a.InnerSubscriber(c, f, d);
    if (p.closed)
      return null;
    if (l instanceof i.Observable)
      return l._isScalar ? (p.next(l.value), p.complete(), null) : (p.syncErrorThrowable = !0, l.subscribe(p));
    if (t.isArrayLike(l)) {
      for (var v = 0, h = l.length; v < h && !p.closed; v++)
        p.next(l[v]);
      p.closed || p.complete();
    } else {
      if (r.isPromise(l))
        return l.then(function(S) {
          p.closed || (p.next(S), p.complete());
        }, function(S) {
          return p.error(S);
        }).then(null, function(S) {
          e.root.setTimeout(function() {
            throw S;
          });
        }), p;
      if (l && typeof l[o.iterator] == "function") {
        var E = l[o.iterator]();
        do {
          var m = E.next();
          if (m.done) {
            p.complete();
            break;
          }
          if (p.next(m.value), p.closed)
            break;
        } while (!0);
      } else if (l && typeof l[u.observable] == "function") {
        var g = l[u.observable]();
        if (typeof g.subscribe != "function")
          p.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
        else
          return g.subscribe(new a.InnerSubscriber(c, f, d));
      } else {
        var y = n.isObject(l) ? "an invalid object" : "'" + l + "'", _ = "You provided " + y + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
        p.error(new TypeError(_));
      }
    }
    return null;
  }
  return _6.subscribeToResult = s, _6;
}
var QJ;
function ner() {
  if (QJ) return T6;
  QJ = 1;
  var e = fe && fe.__extends || function(a, u) {
    for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = f3(), r = d3();
  function n(a) {
    return function(s) {
      var c = new i(a), l = s.lift(c);
      return c.caught = l;
    };
  }
  T6.catchError = n;
  var i = function() {
    function a(u) {
      this.selector = u;
    }
    return a.prototype.call = function(u, s) {
      return s.subscribe(new o(u, this.selector, this.caught));
    }, a;
  }(), o = function(a) {
    e(u, a);
    function u(s, c, l) {
      a.call(this, s), this.selector = c, this.caught = l;
    }
    return u.prototype.error = function(s) {
      if (!this.isStopped) {
        var c = void 0;
        try {
          c = this.selector(s, this.caught);
        } catch (l) {
          a.prototype.error.call(this, l);
          return;
        }
        this._unsubscribeAndRecycle(), this.add(r.subscribeToResult(this, c));
      }
    }, u;
  }(t.OuterSubscriber);
  return T6;
}
var eZ;
function ier() {
  if (eZ) return g6;
  eZ = 1;
  var e = ner();
  function t(r) {
    return e.catchError(r)(this);
  }
  return g6._catch = t, g6;
}
var tZ;
function oer() {
  if (tZ) return YJ;
  tZ = 1;
  var e = ln(), t = ier();
  return e.Observable.prototype.catch = t._catch, e.Observable.prototype._catch = t._catch, YJ;
}
var rZ = {}, I6 = {}, kv = {}, O6 = {}, R6 = {}, nZ;
function c1e() {
  if (nZ) return R6;
  nZ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = ln(), r = function(n) {
    e(i, n);
    function i(o, a) {
      n.call(this), this.value = o, this.scheduler = a, this._isScalar = !0, a && (this._isScalar = !1);
    }
    return i.create = function(o, a) {
      return new i(o, a);
    }, i.dispatch = function(o) {
      var a = o.done, u = o.value, s = o.subscriber;
      if (a) {
        s.complete();
        return;
      }
      s.next(u), !s.closed && (o.done = !0, this.schedule(o));
    }, i.prototype._subscribe = function(o) {
      var a = this.value, u = this.scheduler;
      if (u)
        return u.schedule(i.dispatch, 0, {
          done: !1,
          value: a,
          subscriber: o
        });
      o.next(a), o.closed || o.complete();
    }, i;
  }(t.Observable);
  return R6.ScalarObservable = r, R6;
}
var w6 = {}, iZ;
function p3() {
  if (iZ) return w6;
  iZ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = ln(), r = function(n) {
    e(i, n);
    function i(o) {
      n.call(this), this.scheduler = o;
    }
    return i.create = function(o) {
      return new i(o);
    }, i.dispatch = function(o) {
      var a = o.subscriber;
      a.complete();
    }, i.prototype._subscribe = function(o) {
      var a = this.scheduler;
      if (a)
        return a.schedule(i.dispatch, 0, { subscriber: o });
      o.complete();
    }, i;
  }(t.Observable);
  return w6.EmptyObservable = r, w6;
}
var P6 = {}, oZ;
function aer() {
  if (oZ) return P6;
  oZ = 1;
  function e(t) {
    return t && typeof t.schedule == "function";
  }
  return P6.isScheduler = e, P6;
}
var aZ;
function o7() {
  if (aZ) return O6;
  aZ = 1;
  var e = fe && fe.__extends || function(a, u) {
    for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = ln(), r = c1e(), n = p3(), i = aer(), o = function(a) {
    e(u, a);
    function u(s, c) {
      a.call(this), this.array = s, this.scheduler = c, !c && s.length === 1 && (this._isScalar = !0, this.value = s[0]);
    }
    return u.create = function(s, c) {
      return new u(s, c);
    }, u.of = function() {
      for (var s = [], c = 0; c < arguments.length; c++)
        s[c - 0] = arguments[c];
      var l = s[s.length - 1];
      i.isScheduler(l) ? s.pop() : l = null;
      var f = s.length;
      return f > 1 ? new u(s, l) : f === 1 ? new r.ScalarObservable(s[0], l) : new n.EmptyObservable(l);
    }, u.dispatch = function(s) {
      var c = s.array, l = s.index, f = s.count, d = s.subscriber;
      if (l >= f) {
        d.complete();
        return;
      }
      d.next(c[l]), !d.closed && (s.index = l + 1, this.schedule(s));
    }, u.prototype._subscribe = function(s) {
      var c = 0, l = this.array, f = l.length, d = this.scheduler;
      if (d)
        return d.schedule(u.dispatch, 0, {
          array: l,
          index: c,
          count: f,
          subscriber: s
        });
      for (var p = 0; p < f && !s.closed; p++)
        s.next(l[p]);
      s.complete();
    }, u;
  }(t.Observable);
  return O6.ArrayObservable = o, O6;
}
var uZ;
function uer() {
  if (uZ) return kv;
  uZ = 1;
  var e = fe && fe.__extends || function(c, l) {
    for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
    function d() {
      this.constructor = c;
    }
    c.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
  }, t = o7(), r = u3(), n = f3(), i = d3(), o = {};
  function a() {
    for (var c = [], l = 0; l < arguments.length; l++)
      c[l - 0] = arguments[l];
    var f = null;
    return typeof c[c.length - 1] == "function" && (f = c.pop()), c.length === 1 && r.isArray(c[0]) && (c = c[0].slice()), function(d) {
      return d.lift.call(new t.ArrayObservable([d].concat(c)), new u(f));
    };
  }
  kv.combineLatest = a;
  var u = function() {
    function c(l) {
      this.project = l;
    }
    return c.prototype.call = function(l, f) {
      return f.subscribe(new s(l, this.project));
    }, c;
  }();
  kv.CombineLatestOperator = u;
  var s = function(c) {
    e(l, c);
    function l(f, d) {
      c.call(this, f), this.project = d, this.active = 0, this.values = [], this.observables = [];
    }
    return l.prototype._next = function(f) {
      this.values.push(o), this.observables.push(f);
    }, l.prototype._complete = function() {
      var f = this.observables, d = f.length;
      if (d === 0)
        this.destination.complete();
      else {
        this.active = d, this.toRespond = d;
        for (var p = 0; p < d; p++) {
          var v = f[p];
          this.add(i.subscribeToResult(this, v, v, p));
        }
      }
    }, l.prototype.notifyComplete = function(f) {
      (this.active -= 1) === 0 && this.destination.complete();
    }, l.prototype.notifyNext = function(f, d, p, v, h) {
      var E = this.values, m = E[p], g = this.toRespond ? m === o ? --this.toRespond : this.toRespond : 0;
      E[p] = d, g === 0 && (this.project ? this._tryProject(E) : this.destination.next(E.slice()));
    }, l.prototype._tryProject = function(f) {
      var d;
      try {
        d = this.project.apply(this, f);
      } catch (p) {
        this.destination.error(p);
        return;
      }
      this.destination.next(d);
    }, l;
  }(n.OuterSubscriber);
  return kv.CombineLatestSubscriber = s, kv;
}
var sZ;
function ser() {
  if (sZ) return I6;
  sZ = 1;
  var e = uer();
  function t() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n - 0] = arguments[n];
    return e.combineLatest.apply(void 0, r)(this);
  }
  return I6.combineLatest = t, I6;
}
var cZ;
function cer() {
  if (cZ) return rZ;
  cZ = 1;
  var e = ln(), t = ser();
  return e.Observable.prototype.combineLatest = t.combineLatest, rZ;
}
var lZ = {}, D6 = {}, x6 = {}, fZ;
function ler() {
  if (fZ) return x6;
  fZ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = Ua();
  function r(o) {
    return function(a) {
      return a.lift(new n(o, a));
    };
  }
  x6.count = r;
  var n = function() {
    function o(a, u) {
      this.predicate = a, this.source = u;
    }
    return o.prototype.call = function(a, u) {
      return u.subscribe(new i(a, this.predicate, this.source));
    }, o;
  }(), i = function(o) {
    e(a, o);
    function a(u, s, c) {
      o.call(this, u), this.predicate = s, this.source = c, this.count = 0, this.index = 0;
    }
    return a.prototype._next = function(u) {
      this.predicate ? this._tryPredicate(u) : this.count++;
    }, a.prototype._tryPredicate = function(u) {
      var s;
      try {
        s = this.predicate(u, this.index++, this.source);
      } catch (c) {
        this.destination.error(c);
        return;
      }
      s && this.count++;
    }, a.prototype._complete = function() {
      this.destination.next(this.count), this.destination.complete();
    }, a;
  }(t.Subscriber);
  return x6;
}
var dZ;
function fer() {
  if (dZ) return D6;
  dZ = 1;
  var e = ler();
  function t(r) {
    return e.count(r)(this);
  }
  return D6.count = t, D6;
}
var pZ;
function der() {
  if (pZ) return lZ;
  pZ = 1;
  var e = ln(), t = fer();
  return e.Observable.prototype.count = t.count, lZ;
}
var hZ = {}, N6 = {}, L6 = {}, B6 = {}, vZ;
function per() {
  if (vZ) return B6;
  vZ = 1;
  function e(t) {
    return t instanceof Date && !isNaN(+t);
  }
  return B6.isDate = e, B6;
}
var k6 = {}, EZ;
function l1e() {
  if (EZ) return k6;
  EZ = 1;
  var e = ln(), t = function() {
    function r(n, i, o) {
      this.kind = n, this.value = i, this.error = o, this.hasValue = n === "N";
    }
    return r.prototype.observe = function(n) {
      switch (this.kind) {
        case "N":
          return n.next && n.next(this.value);
        case "E":
          return n.error && n.error(this.error);
        case "C":
          return n.complete && n.complete();
      }
    }, r.prototype.do = function(n, i, o) {
      var a = this.kind;
      switch (a) {
        case "N":
          return n && n(this.value);
        case "E":
          return i && i(this.error);
        case "C":
          return o && o();
      }
    }, r.prototype.accept = function(n, i, o) {
      return n && typeof n.next == "function" ? this.observe(n) : this.do(n, i, o);
    }, r.prototype.toObservable = function() {
      var n = this.kind;
      switch (n) {
        case "N":
          return e.Observable.of(this.value);
        case "E":
          return e.Observable.throw(this.error);
        case "C":
          return e.Observable.empty();
      }
      throw new Error("unexpected notification kind value");
    }, r.createNext = function(n) {
      return typeof n < "u" ? new r("N", n) : r.undefinedValueNotification;
    }, r.createError = function(n) {
      return new r("E", void 0, n);
    }, r.createComplete = function() {
      return r.completeNotification;
    }, r.completeNotification = new r("C"), r.undefinedValueNotification = new r("N", void 0), r;
  }();
  return k6.Notification = t, k6;
}
var mZ;
function her() {
  if (mZ) return L6;
  mZ = 1;
  var e = fe && fe.__extends || function(c, l) {
    for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
    function d() {
      this.constructor = c;
    }
    c.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
  }, t = l3(), r = per(), n = Ua(), i = l1e();
  function o(c, l) {
    l === void 0 && (l = t.async);
    var f = r.isDate(c), d = f ? +c - l.now() : Math.abs(c);
    return function(p) {
      return p.lift(new a(d, l));
    };
  }
  L6.delay = o;
  var a = function() {
    function c(l, f) {
      this.delay = l, this.scheduler = f;
    }
    return c.prototype.call = function(l, f) {
      return f.subscribe(new u(l, this.delay, this.scheduler));
    }, c;
  }(), u = function(c) {
    e(l, c);
    function l(f, d, p) {
      c.call(this, f), this.delay = d, this.scheduler = p, this.queue = [], this.active = !1, this.errored = !1;
    }
    return l.dispatch = function(f) {
      for (var d = f.source, p = d.queue, v = f.scheduler, h = f.destination; p.length > 0 && p[0].time - v.now() <= 0; )
        p.shift().notification.observe(h);
      if (p.length > 0) {
        var E = Math.max(0, p[0].time - v.now());
        this.schedule(f, E);
      } else
        this.unsubscribe(), d.active = !1;
    }, l.prototype._schedule = function(f) {
      this.active = !0, this.add(f.schedule(l.dispatch, this.delay, {
        source: this,
        destination: this.destination,
        scheduler: f
      }));
    }, l.prototype.scheduleNotification = function(f) {
      if (this.errored !== !0) {
        var d = this.scheduler, p = new s(d.now() + this.delay, f);
        this.queue.push(p), this.active === !1 && this._schedule(d);
      }
    }, l.prototype._next = function(f) {
      this.scheduleNotification(i.Notification.createNext(f));
    }, l.prototype._error = function(f) {
      this.errored = !0, this.queue = [], this.destination.error(f);
    }, l.prototype._complete = function() {
      this.scheduleNotification(i.Notification.createComplete());
    }, l;
  }(n.Subscriber), s = /* @__PURE__ */ function() {
    function c(l, f) {
      this.time = l, this.notification = f;
    }
    return c;
  }();
  return L6;
}
var gZ;
function ver() {
  if (gZ) return N6;
  gZ = 1;
  var e = l3(), t = her();
  function r(n, i) {
    return i === void 0 && (i = e.async), t.delay(n, i)(this);
  }
  return N6.delay = r, N6;
}
var TZ;
function Eer() {
  if (TZ) return hZ;
  TZ = 1;
  var e = ln(), t = ver();
  return e.Observable.prototype.delay = t.delay, hZ;
}
var yZ = {}, M6 = {}, F6 = {}, _Z;
function mer() {
  if (_Z) return F6;
  _Z = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = Ua();
  function r(o, a, u) {
    return function(c) {
      return c.lift(new n(o, a, u));
    };
  }
  F6.tap = r;
  var n = function() {
    function o(a, u, s) {
      this.nextOrObserver = a, this.error = u, this.complete = s;
    }
    return o.prototype.call = function(a, u) {
      return u.subscribe(new i(a, this.nextOrObserver, this.error, this.complete));
    }, o;
  }(), i = function(o) {
    e(a, o);
    function a(u, s, c, l) {
      o.call(this, u);
      var f = new t.Subscriber(s, c, l);
      f.syncErrorThrowable = !0, this.add(f), this.safeSubscriber = f;
    }
    return a.prototype._next = function(u) {
      var s = this.safeSubscriber;
      s.next(u), s.syncErrorThrown ? this.destination.error(s.syncErrorValue) : this.destination.next(u);
    }, a.prototype._error = function(u) {
      var s = this.safeSubscriber;
      s.error(u), s.syncErrorThrown ? this.destination.error(s.syncErrorValue) : this.destination.error(u);
    }, a.prototype._complete = function() {
      var u = this.safeSubscriber;
      u.complete(), u.syncErrorThrown ? this.destination.error(u.syncErrorValue) : this.destination.complete();
    }, a;
  }(t.Subscriber);
  return F6;
}
var AZ;
function ger() {
  if (AZ) return M6;
  AZ = 1;
  var e = mer();
  function t(r, n, i) {
    return e.tap(r, n, i)(this);
  }
  return M6._do = t, M6;
}
var SZ;
function Ter() {
  if (SZ) return yZ;
  SZ = 1;
  var e = ln(), t = ger();
  return e.Observable.prototype.do = t._do, e.Observable.prototype._do = t._do, yZ;
}
var bZ = {}, H6 = {}, $6 = {}, CZ;
function yer() {
  if (CZ) return $6;
  CZ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = Ua();
  function r(o, a) {
    return function(s) {
      return s.lift(new n(o, a));
    };
  }
  $6.filter = r;
  var n = function() {
    function o(a, u) {
      this.predicate = a, this.thisArg = u;
    }
    return o.prototype.call = function(a, u) {
      return u.subscribe(new i(a, this.predicate, this.thisArg));
    }, o;
  }(), i = function(o) {
    e(a, o);
    function a(u, s, c) {
      o.call(this, u), this.predicate = s, this.thisArg = c, this.count = 0;
    }
    return a.prototype._next = function(u) {
      var s;
      try {
        s = this.predicate.call(this.thisArg, u, this.count++);
      } catch (c) {
        this.destination.error(c);
        return;
      }
      s && this.destination.next(u);
    }, a;
  }(t.Subscriber);
  return $6;
}
var IZ;
function _er() {
  if (IZ) return H6;
  IZ = 1;
  var e = yer();
  function t(r, n) {
    return e.filter(r, n)(this);
  }
  return H6.filter = t, H6;
}
var OZ;
function Aer() {
  if (OZ) return bZ;
  OZ = 1;
  var e = ln(), t = _er();
  return e.Observable.prototype.filter = t.filter, bZ;
}
var RZ = {}, U6 = {}, cA = {}, wZ;
function f1e() {
  if (wZ) return cA;
  wZ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = Ua();
  function r(o, a) {
    return function(s) {
      if (typeof o != "function")
        throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
      return s.lift(new n(o, a));
    };
  }
  cA.map = r;
  var n = function() {
    function o(a, u) {
      this.project = a, this.thisArg = u;
    }
    return o.prototype.call = function(a, u) {
      return u.subscribe(new i(a, this.project, this.thisArg));
    }, o;
  }();
  cA.MapOperator = n;
  var i = function(o) {
    e(a, o);
    function a(u, s, c) {
      o.call(this, u), this.project = s, this.count = 0, this.thisArg = c || this;
    }
    return a.prototype._next = function(u) {
      var s;
      try {
        s = this.project.call(this.thisArg, u, this.count++);
      } catch (c) {
        this.destination.error(c);
        return;
      }
      this.destination.next(s);
    }, a;
  }(t.Subscriber);
  return cA;
}
var PZ;
function Ser() {
  if (PZ) return U6;
  PZ = 1;
  var e = f1e();
  function t(r, n) {
    return e.map(r, n)(this);
  }
  return U6.map = t, U6;
}
var DZ;
function ber() {
  if (DZ) return RZ;
  DZ = 1;
  var e = ln(), t = Ser();
  return e.Observable.prototype.map = t.map, RZ;
}
var xZ = {}, V6 = {}, Mv = {}, NZ;
function d1e() {
  if (NZ) return Mv;
  NZ = 1;
  var e = fe && fe.__extends || function(a, u) {
    for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = d3(), r = f3();
  function n(a, u, s) {
    return s === void 0 && (s = Number.POSITIVE_INFINITY), function(l) {
      return typeof u == "number" && (s = u, u = null), l.lift(new i(a, u, s));
    };
  }
  Mv.mergeMap = n;
  var i = function() {
    function a(u, s, c) {
      c === void 0 && (c = Number.POSITIVE_INFINITY), this.project = u, this.resultSelector = s, this.concurrent = c;
    }
    return a.prototype.call = function(u, s) {
      return s.subscribe(new o(u, this.project, this.resultSelector, this.concurrent));
    }, a;
  }();
  Mv.MergeMapOperator = i;
  var o = function(a) {
    e(u, a);
    function u(s, c, l, f) {
      f === void 0 && (f = Number.POSITIVE_INFINITY), a.call(this, s), this.project = c, this.resultSelector = l, this.concurrent = f, this.hasCompleted = !1, this.buffer = [], this.active = 0, this.index = 0;
    }
    return u.prototype._next = function(s) {
      this.active < this.concurrent ? this._tryNext(s) : this.buffer.push(s);
    }, u.prototype._tryNext = function(s) {
      var c, l = this.index++;
      try {
        c = this.project(s, l);
      } catch (f) {
        this.destination.error(f);
        return;
      }
      this.active++, this._innerSub(c, s, l);
    }, u.prototype._innerSub = function(s, c, l) {
      this.add(t.subscribeToResult(this, s, c, l));
    }, u.prototype._complete = function() {
      this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete();
    }, u.prototype.notifyNext = function(s, c, l, f, d) {
      this.resultSelector ? this._notifyResultSelector(s, c, l, f) : this.destination.next(c);
    }, u.prototype._notifyResultSelector = function(s, c, l, f) {
      var d;
      try {
        d = this.resultSelector(s, c, l, f);
      } catch (p) {
        this.destination.error(p);
        return;
      }
      this.destination.next(d);
    }, u.prototype.notifyComplete = function(s) {
      var c = this.buffer;
      this.remove(s), this.active--, c.length > 0 ? this._next(c.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
    }, u;
  }(r.OuterSubscriber);
  return Mv.MergeMapSubscriber = o, Mv;
}
var LZ;
function Cer() {
  if (LZ) return V6;
  LZ = 1;
  var e = d1e();
  function t(r, n, i) {
    return i === void 0 && (i = Number.POSITIVE_INFINITY), e.mergeMap(r, n, i)(this);
  }
  return V6.mergeMap = t, V6;
}
var BZ;
function Ier() {
  if (BZ) return xZ;
  BZ = 1;
  var e = ln(), t = Cer();
  return e.Observable.prototype.mergeMap = t.mergeMap, e.Observable.prototype.flatMap = t.mergeMap, xZ;
}
var kZ = {}, j6 = {}, z6 = {}, MZ;
function Oer() {
  if (MZ) return z6;
  MZ = 1;
  var e = d1e();
  function t(r, n) {
    return e.mergeMap(r, n, 1);
  }
  return z6.concatMap = t, z6;
}
var FZ;
function Rer() {
  if (FZ) return j6;
  FZ = 1;
  var e = Oer();
  function t(r, n) {
    return e.concatMap(r, n)(this);
  }
  return j6.concatMap = t, j6;
}
var HZ;
function wer() {
  if (HZ) return kZ;
  HZ = 1;
  var e = ln(), t = Rer();
  return e.Observable.prototype.concatMap = t.concatMap, kZ;
}
var $Z = {}, q6 = {}, Y6 = {}, UZ;
function Per() {
  if (UZ) return Y6;
  UZ = 1;
  var e = fe && fe.__extends || function(c, l) {
    for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
    function d() {
      this.constructor = c;
    }
    c.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
  }, t = c3(), r = t7(), n = s3(), i = f3(), o = d3();
  function a(c) {
    return function(l) {
      return l.lift(new u(c, l));
    };
  }
  Y6.retryWhen = a;
  var u = function() {
    function c(l, f) {
      this.notifier = l, this.source = f;
    }
    return c.prototype.call = function(l, f) {
      return f.subscribe(new s(l, this.notifier, this.source));
    }, c;
  }(), s = function(c) {
    e(l, c);
    function l(f, d, p) {
      c.call(this, f), this.notifier = d, this.source = p;
    }
    return l.prototype.error = function(f) {
      if (!this.isStopped) {
        var d = this.errors, p = this.retries, v = this.retriesSubscription;
        if (p)
          this.errors = null, this.retriesSubscription = null;
        else {
          if (d = new t.Subject(), p = r.tryCatch(this.notifier)(d), p === n.errorObject)
            return c.prototype.error.call(this, n.errorObject.e);
          v = o.subscribeToResult(this, p);
        }
        this._unsubscribeAndRecycle(), this.errors = d, this.retries = p, this.retriesSubscription = v, d.next(f);
      }
    }, l.prototype._unsubscribe = function() {
      var f = this, d = f.errors, p = f.retriesSubscription;
      d && (d.unsubscribe(), this.errors = null), p && (p.unsubscribe(), this.retriesSubscription = null), this.retries = null;
    }, l.prototype.notifyNext = function(f, d, p, v, h) {
      var E = this, m = E.errors, g = E.retries, y = E.retriesSubscription;
      this.errors = null, this.retries = null, this.retriesSubscription = null, this._unsubscribeAndRecycle(), this.errors = m, this.retries = g, this.retriesSubscription = y, this.source.subscribe(this);
    }, l;
  }(i.OuterSubscriber);
  return Y6;
}
var VZ;
function Der() {
  if (VZ) return q6;
  VZ = 1;
  var e = Per();
  function t(r) {
    return e.retryWhen(r)(this);
  }
  return q6.retryWhen = t, q6;
}
var jZ;
function xer() {
  if (jZ) return $Z;
  jZ = 1;
  var e = ln(), t = Der();
  return e.Observable.prototype.retryWhen = t.retryWhen, $Z;
}
var zZ = {}, G6 = {}, W6 = {}, lA = {}, fA = {}, K6 = {}, qZ;
function p1e() {
  if (qZ) return K6;
  qZ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = Ua();
  function r() {
    return function(a) {
      return a.lift(new n(a));
    };
  }
  K6.refCount = r;
  var n = function() {
    function o(a) {
      this.connectable = a;
    }
    return o.prototype.call = function(a, u) {
      var s = this.connectable;
      s._refCount++;
      var c = new i(a, s), l = u.subscribe(c);
      return c.closed || (c.connection = s.connect()), l;
    }, o;
  }(), i = function(o) {
    e(a, o);
    function a(u, s) {
      o.call(this, u), this.connectable = s;
    }
    return a.prototype._unsubscribe = function() {
      var u = this.connectable;
      if (!u) {
        this.connection = null;
        return;
      }
      this.connectable = null;
      var s = u._refCount;
      if (s <= 0) {
        this.connection = null;
        return;
      }
      if (u._refCount = s - 1, s > 1) {
        this.connection = null;
        return;
      }
      var c = this.connection, l = u._connection;
      this.connection = null, l && (!c || l === c) && l.unsubscribe();
    }, a;
  }(t.Subscriber);
  return K6;
}
var YZ;
function Ner() {
  if (YZ) return fA;
  YZ = 1;
  var e = fe && fe.__extends || function(c, l) {
    for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
    function d() {
      this.constructor = c;
    }
    c.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
  }, t = c3(), r = ln(), n = Ua(), i = _y(), o = p1e(), a = function(c) {
    e(l, c);
    function l(f, d) {
      c.call(this), this.source = f, this.subjectFactory = d, this._refCount = 0, this._isComplete = !1;
    }
    return l.prototype._subscribe = function(f) {
      return this.getSubject().subscribe(f);
    }, l.prototype.getSubject = function() {
      var f = this._subject;
      return (!f || f.isStopped) && (this._subject = this.subjectFactory()), this._subject;
    }, l.prototype.connect = function() {
      var f = this._connection;
      return f || (this._isComplete = !1, f = this._connection = new i.Subscription(), f.add(this.source.subscribe(new s(this.getSubject(), this))), f.closed ? (this._connection = null, f = i.Subscription.EMPTY) : this._connection = f), f;
    }, l.prototype.refCount = function() {
      return o.refCount()(this);
    }, l;
  }(r.Observable);
  fA.ConnectableObservable = a;
  var u = a.prototype;
  fA.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: !0 },
    _subject: { value: null, writable: !0 },
    _connection: { value: null, writable: !0 },
    _subscribe: { value: u._subscribe },
    _isComplete: { value: u._isComplete, writable: !0 },
    getSubject: { value: u.getSubject },
    connect: { value: u.connect },
    refCount: { value: u.refCount }
  };
  var s = function(c) {
    e(l, c);
    function l(f, d) {
      c.call(this, f), this.connectable = d;
    }
    return l.prototype._error = function(f) {
      this._unsubscribe(), c.prototype._error.call(this, f);
    }, l.prototype._complete = function() {
      this.connectable._isComplete = !0, this._unsubscribe(), c.prototype._complete.call(this);
    }, l.prototype._unsubscribe = function() {
      var f = this.connectable;
      if (f) {
        this.connectable = null;
        var d = f._connection;
        f._refCount = 0, f._subject = null, f._connection = null, d && d.unsubscribe();
      }
    }, l;
  }(t.SubjectSubscriber);
  return function(c) {
    e(l, c);
    function l(f, d) {
      c.call(this, f), this.connectable = d;
    }
    return l.prototype._unsubscribe = function() {
      var f = this.connectable;
      if (!f) {
        this.connection = null;
        return;
      }
      this.connectable = null;
      var d = f._refCount;
      if (d <= 0) {
        this.connection = null;
        return;
      }
      if (f._refCount = d - 1, d > 1) {
        this.connection = null;
        return;
      }
      var p = this.connection, v = f._connection;
      this.connection = null, v && (!p || v === p) && v.unsubscribe();
    }, l;
  }(n.Subscriber), fA;
}
var GZ;
function Ler() {
  if (GZ) return lA;
  GZ = 1;
  var e = Ner();
  function t(n, i) {
    return function(a) {
      var u;
      if (typeof n == "function" ? u = n : u = function() {
        return n;
      }, typeof i == "function")
        return a.lift(new r(u, i));
      var s = Object.create(a, e.connectableObservableDescriptor);
      return s.source = a, s.subjectFactory = u, s;
    };
  }
  lA.multicast = t;
  var r = function() {
    function n(i, o) {
      this.subjectFactory = i, this.selector = o;
    }
    return n.prototype.call = function(i, o) {
      var a = this.selector, u = this.subjectFactory(), s = a(u).subscribe(i);
      return s.add(o.subscribe(u)), s;
    }, n;
  }();
  return lA.MulticastOperator = r, lA;
}
var WZ;
function Ber() {
  if (WZ) return W6;
  WZ = 1;
  var e = Ler(), t = p1e(), r = c3();
  function n() {
    return new r.Subject();
  }
  function i() {
    return function(o) {
      return t.refCount()(e.multicast(n)(o));
    };
  }
  return W6.share = i, W6;
}
var KZ;
function ker() {
  if (KZ) return G6;
  KZ = 1;
  var e = Ber();
  function t() {
    return e.share()(this);
  }
  return G6.share = t, G6;
}
var XZ;
function Mer() {
  if (XZ) return zZ;
  XZ = 1;
  var e = ln(), t = ker();
  return e.Observable.prototype.share = t.share, zZ;
}
var JZ = {}, X6 = {}, J6 = {}, Z6 = {}, ZZ;
function Fer() {
  if (ZZ) return Z6;
  ZZ = 1;
  var e = fe && fe.__extends || function(r, n) {
    for (var i in n) n.hasOwnProperty(i) && (r[i] = n[i]);
    function o() {
      this.constructor = r;
    }
    r.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  }, t = function(r) {
    e(n, r);
    function n() {
      var i = r.call(this, "argument out of range");
      this.name = i.name = "ArgumentOutOfRangeError", this.stack = i.stack, this.message = i.message;
    }
    return n;
  }(Error);
  return Z6.ArgumentOutOfRangeError = t, Z6;
}
var QZ;
function Her() {
  if (QZ) return J6;
  QZ = 1;
  var e = fe && fe.__extends || function(u, s) {
    for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
    function l() {
      this.constructor = u;
    }
    u.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
  }, t = Ua(), r = Fer(), n = p3();
  function i(u) {
    return function(s) {
      return u === 0 ? new n.EmptyObservable() : s.lift(new o(u));
    };
  }
  J6.take = i;
  var o = function() {
    function u(s) {
      if (this.total = s, this.total < 0)
        throw new r.ArgumentOutOfRangeError();
    }
    return u.prototype.call = function(s, c) {
      return c.subscribe(new a(s, this.total));
    }, u;
  }(), a = function(u) {
    e(s, u);
    function s(c, l) {
      u.call(this, c), this.total = l, this.count = 0;
    }
    return s.prototype._next = function(c) {
      var l = this.total, f = ++this.count;
      f <= l && (this.destination.next(c), f === l && (this.destination.complete(), this.unsubscribe()));
    }, s;
  }(t.Subscriber);
  return J6;
}
var eQ;
function $er() {
  if (eQ) return X6;
  eQ = 1;
  var e = Her();
  function t(r) {
    return e.take(r)(this);
  }
  return X6.take = t, X6;
}
var tQ;
function Uer() {
  if (tQ) return JZ;
  tQ = 1;
  var e = ln(), t = $er();
  return e.Observable.prototype.take = t.take, JZ;
}
var rQ = {}, Q6 = {}, Wa = {}, nQ;
function Ver() {
  if (nQ) return Wa;
  nQ = 1;
  var e = fe && fe.__extends || function(A, O) {
    for (var P in O) O.hasOwnProperty(P) && (A[P] = O[P]);
    function U() {
      this.constructor = A;
    }
    A.prototype = O === null ? Object.create(O) : (U.prototype = O.prototype, new U());
  }, t = ul(), r = t7(), n = s3(), i = ln(), o = Ua(), a = f1e();
  function u() {
    if (t.root.XMLHttpRequest)
      return new t.root.XMLHttpRequest();
    if (t.root.XDomainRequest)
      return new t.root.XDomainRequest();
    throw new Error("CORS is not supported by your browser");
  }
  function s() {
    if (t.root.XMLHttpRequest)
      return new t.root.XMLHttpRequest();
    var A = void 0;
    try {
      for (var O = ["Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.4.0"], P = 0; P < 3; P++)
        try {
          if (A = O[P], new t.root.ActiveXObject(A))
            break;
        } catch {
        }
      return new t.root.ActiveXObject(A);
    } catch {
      throw new Error("XMLHttpRequest is not supported by your browser");
    }
  }
  function c(A, O) {
    return O === void 0 && (O = null), new E({ method: "GET", url: A, headers: O });
  }
  Wa.ajaxGet = c;
  function l(A, O, P) {
    return new E({ method: "POST", url: A, body: O, headers: P });
  }
  Wa.ajaxPost = l;
  function f(A, O) {
    return new E({ method: "DELETE", url: A, headers: O });
  }
  Wa.ajaxDelete = f;
  function d(A, O, P) {
    return new E({ method: "PUT", url: A, body: O, headers: P });
  }
  Wa.ajaxPut = d;
  function p(A, O, P) {
    return new E({ method: "PATCH", url: A, body: O, headers: P });
  }
  Wa.ajaxPatch = p;
  var v = a.map(function(A, O) {
    return A.response;
  });
  function h(A, O) {
    return v(new E({
      method: "GET",
      url: A,
      responseType: "json",
      headers: O
    }));
  }
  Wa.ajaxGetJSON = h;
  var E = function(A) {
    e(O, A);
    function O(P) {
      A.call(this);
      var U = {
        async: !0,
        createXHR: function() {
          return this.crossDomain ? u.call(this) : s();
        },
        crossDomain: !1,
        withCredentials: !1,
        headers: {},
        method: "GET",
        responseType: "json",
        timeout: 0
      };
      if (typeof P == "string")
        U.url = P;
      else
        for (var z in P)
          P.hasOwnProperty(z) && (U[z] = P[z]);
      this.request = U;
    }
    return O.prototype._subscribe = function(P) {
      return new m(P, this.request);
    }, O.create = function() {
      var P = function(U) {
        return new O(U);
      };
      return P.get = c, P.post = l, P.delete = f, P.put = d, P.patch = p, P.getJSON = h, P;
    }(), O;
  }(i.Observable);
  Wa.AjaxObservable = E;
  var m = function(A) {
    e(O, A);
    function O(P, U) {
      A.call(this, P), this.request = U, this.done = !1;
      var z = U.headers = U.headers || {};
      !U.crossDomain && !z["X-Requested-With"] && (z["X-Requested-With"] = "XMLHttpRequest"), !("Content-Type" in z) && !(t.root.FormData && U.body instanceof t.root.FormData) && typeof U.body < "u" && (z["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"), U.body = this.serializeBody(U.body, U.headers["Content-Type"]), this.send();
    }
    return O.prototype.next = function(P) {
      this.done = !0;
      var U = this, z = U.xhr, k = U.request, H = U.destination, B = new g(P, z, k);
      H.next(B);
    }, O.prototype.send = function() {
      var P = this, U = P.request, z = P.request, k = z.user, H = z.method, B = z.url, x = z.async, D = z.password, w = z.headers, $ = z.body, X = U.createXHR, V = r.tryCatch(X).call(U);
      if (V === n.errorObject)
        this.error(n.errorObject.e);
      else {
        this.xhr = V, this.setupEvents(V, U);
        var F = void 0;
        if (k ? F = r.tryCatch(V.open).call(V, H, B, x, k, D) : F = r.tryCatch(V.open).call(V, H, B, x), F === n.errorObject)
          return this.error(n.errorObject.e), null;
        if (x && (V.timeout = U.timeout, V.responseType = U.responseType), "withCredentials" in V && (V.withCredentials = !!U.withCredentials), this.setHeaders(V, w), F = $ ? r.tryCatch(V.send).call(V, $) : r.tryCatch(V.send).call(V), F === n.errorObject)
          return this.error(n.errorObject.e), null;
      }
      return V;
    }, O.prototype.serializeBody = function(P, U) {
      if (!P || typeof P == "string")
        return P;
      if (t.root.FormData && P instanceof t.root.FormData)
        return P;
      if (U) {
        var z = U.indexOf(";");
        z !== -1 && (U = U.substring(0, z));
      }
      switch (U) {
        case "application/x-www-form-urlencoded":
          return Object.keys(P).map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(P[k]);
          }).join("&");
        case "application/json":
          return JSON.stringify(P);
        default:
          return P;
      }
    }, O.prototype.setHeaders = function(P, U) {
      for (var z in U)
        U.hasOwnProperty(z) && P.setRequestHeader(z, U[z]);
    }, O.prototype.setupEvents = function(P, U) {
      var z = U.progressSubscriber;
      function k(D) {
        var w = k, $ = w.subscriber, X = w.progressSubscriber, V = w.request;
        X && X.error(D), $.error(new S(this, V));
      }
      if (P.ontimeout = k, k.request = U, k.subscriber = this, k.progressSubscriber = z, P.upload && "withCredentials" in P) {
        if (z) {
          var H;
          H = function(D) {
            var w = H.progressSubscriber;
            w.next(D);
          }, t.root.XDomainRequest ? P.onprogress = H : P.upload.onprogress = H, H.progressSubscriber = z;
        }
        var B;
        B = function(D) {
          var w = B, $ = w.progressSubscriber, X = w.subscriber, V = w.request;
          $ && $.error(D), X.error(new y("ajax error", this, V));
        }, P.onerror = B, B.request = U, B.subscriber = this, B.progressSubscriber = z;
      }
      function x(D) {
        var w = x, $ = w.subscriber, X = w.progressSubscriber, V = w.request;
        if (this.readyState === 4) {
          var F = this.status === 1223 ? 204 : this.status, le = this.responseType === "text" ? this.response || this.responseText : this.response;
          F === 0 && (F = le ? 200 : 0), 200 <= F && F < 300 ? (X && X.complete(), $.next(D), $.complete()) : (X && X.error(D), $.error(new y("ajax error " + F, this, V)));
        }
      }
      P.onreadystatechange = x, x.subscriber = this, x.progressSubscriber = z, x.request = U;
    }, O.prototype.unsubscribe = function() {
      var P = this, U = P.done, z = P.xhr;
      !U && z && z.readyState !== 4 && typeof z.abort == "function" && z.abort(), A.prototype.unsubscribe.call(this);
    }, O;
  }(o.Subscriber);
  Wa.AjaxSubscriber = m;
  var g = /* @__PURE__ */ function() {
    function A(O, P, U) {
      this.originalEvent = O, this.xhr = P, this.request = U, this.status = P.status, this.responseType = P.responseType || U.responseType, this.response = _(this.responseType, P);
    }
    return A;
  }();
  Wa.AjaxResponse = g;
  var y = function(A) {
    e(O, A);
    function O(P, U, z) {
      A.call(this, P), this.message = P, this.xhr = U, this.request = z, this.status = U.status, this.responseType = U.responseType || z.responseType, this.response = _(this.responseType, U);
    }
    return O;
  }(Error);
  Wa.AjaxError = y;
  function _(A, O) {
    switch (A) {
      case "json":
        return "response" in O ? O.responseType ? O.response : JSON.parse(O.response || O.responseText || "null") : JSON.parse(O.responseText || "null");
      case "xml":
        return O.responseXML;
      case "text":
      default:
        return "response" in O ? O.response : O.responseText;
    }
  }
  var S = function(A) {
    e(O, A);
    function O(P, U) {
      A.call(this, "ajax timeout", P, U);
    }
    return O;
  }(y);
  return Wa.AjaxTimeoutError = S, Wa;
}
var iQ;
function jer() {
  if (iQ) return Q6;
  iQ = 1;
  var e = Ver();
  return Q6.ajax = e.AjaxObservable.create, Q6;
}
var oQ;
function zer() {
  if (oQ) return rQ;
  oQ = 1;
  var e = ln(), t = jer();
  return e.Observable.ajax = t.ajax, rQ;
}
var aQ = {}, eD = {}, uQ;
function qer() {
  if (uQ) return eD;
  uQ = 1;
  var e = p3();
  return eD.empty = e.EmptyObservable.create, eD;
}
var sQ;
function Yer() {
  if (sQ) return aQ;
  sQ = 1;
  var e = ln(), t = qer();
  return e.Observable.empty = t.empty, aQ;
}
var cQ = {}, tD = {}, rD = {}, nD = {}, lQ;
function Ger() {
  if (lQ) return nD;
  lQ = 1;
  var e = fe && fe.__extends || function(a, u) {
    for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = ul(), r = ln(), n = function(a) {
    e(u, a);
    function u(s, c) {
      a.call(this), this.promise = s, this.scheduler = c;
    }
    return u.create = function(s, c) {
      return new u(s, c);
    }, u.prototype._subscribe = function(s) {
      var c = this, l = this.promise, f = this.scheduler;
      if (f == null)
        this._isScalar ? s.closed || (s.next(this.value), s.complete()) : l.then(function(d) {
          c.value = d, c._isScalar = !0, s.closed || (s.next(d), s.complete());
        }, function(d) {
          s.closed || s.error(d);
        }).then(null, function(d) {
          t.root.setTimeout(function() {
            throw d;
          });
        });
      else if (this._isScalar) {
        if (!s.closed)
          return f.schedule(i, 0, { value: this.value, subscriber: s });
      } else
        l.then(function(d) {
          c.value = d, c._isScalar = !0, s.closed || s.add(f.schedule(i, 0, { value: d, subscriber: s }));
        }, function(d) {
          s.closed || s.add(f.schedule(o, 0, { err: d, subscriber: s }));
        }).then(null, function(d) {
          t.root.setTimeout(function() {
            throw d;
          });
        });
    }, u;
  }(r.Observable);
  nD.PromiseObservable = n;
  function i(a) {
    var u = a.value, s = a.subscriber;
    s.closed || (s.next(u), s.complete());
  }
  function o(a) {
    var u = a.err, s = a.subscriber;
    s.closed || s.error(u);
  }
  return nD;
}
var iD = {}, fQ;
function Wer() {
  if (fQ) return iD;
  fQ = 1;
  var e = fe && fe.__extends || function(d, p) {
    for (var v in p) p.hasOwnProperty(v) && (d[v] = p[v]);
    function h() {
      this.constructor = d;
    }
    d.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
  }, t = ul(), r = ln(), n = i7(), i = function(d) {
    e(p, d);
    function p(v, h) {
      if (d.call(this), this.scheduler = h, v == null)
        throw new Error("iterator cannot be null.");
      this.iterator = u(v);
    }
    return p.create = function(v, h) {
      return new p(v, h);
    }, p.dispatch = function(v) {
      var h = v.index, E = v.hasError, m = v.iterator, g = v.subscriber;
      if (E) {
        g.error(v.error);
        return;
      }
      var y = m.next();
      if (y.done) {
        g.complete();
        return;
      }
      if (g.next(y.value), v.index = h + 1, g.closed) {
        typeof m.return == "function" && m.return();
        return;
      }
      this.schedule(v);
    }, p.prototype._subscribe = function(v) {
      var h = 0, E = this, m = E.iterator, g = E.scheduler;
      if (g)
        return g.schedule(p.dispatch, 0, {
          index: h,
          iterator: m,
          subscriber: v
        });
      do {
        var y = m.next();
        if (y.done) {
          v.complete();
          break;
        } else
          v.next(y.value);
        if (v.closed) {
          typeof m.return == "function" && m.return();
          break;
        }
      } while (!0);
    }, p;
  }(r.Observable);
  iD.IteratorObservable = i;
  var o = function() {
    function d(p, v, h) {
      v === void 0 && (v = 0), h === void 0 && (h = p.length), this.str = p, this.idx = v, this.len = h;
    }
    return d.prototype[n.iterator] = function() {
      return this;
    }, d.prototype.next = function() {
      return this.idx < this.len ? {
        done: !1,
        value: this.str.charAt(this.idx++)
      } : {
        done: !0,
        value: void 0
      };
    }, d;
  }(), a = function() {
    function d(p, v, h) {
      v === void 0 && (v = 0), h === void 0 && (h = c(p)), this.arr = p, this.idx = v, this.len = h;
    }
    return d.prototype[n.iterator] = function() {
      return this;
    }, d.prototype.next = function() {
      return this.idx < this.len ? {
        done: !1,
        value: this.arr[this.idx++]
      } : {
        done: !0,
        value: void 0
      };
    }, d;
  }();
  function u(d) {
    var p = d[n.iterator];
    if (!p && typeof d == "string")
      return new o(d);
    if (!p && d.length !== void 0)
      return new a(d);
    if (!p)
      throw new TypeError("object is not iterable");
    return d[n.iterator]();
  }
  var s = Math.pow(2, 53) - 1;
  function c(d) {
    var p = +d.length;
    return isNaN(p) ? 0 : p === 0 || !l(p) ? p : (p = f(p) * Math.floor(Math.abs(p)), p <= 0 ? 0 : p > s ? s : p);
  }
  function l(d) {
    return typeof d == "number" && t.root.isFinite(d);
  }
  function f(d) {
    var p = +d;
    return p === 0 || isNaN(p) ? p : p < 0 ? -1 : 1;
  }
  return iD;
}
var oD = {}, dQ;
function Ker() {
  if (dQ) return oD;
  dQ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = ln(), r = c1e(), n = p3(), i = function(o) {
    e(a, o);
    function a(u, s) {
      o.call(this), this.arrayLike = u, this.scheduler = s, !s && u.length === 1 && (this._isScalar = !0, this.value = u[0]);
    }
    return a.create = function(u, s) {
      var c = u.length;
      return c === 0 ? new n.EmptyObservable() : c === 1 ? new r.ScalarObservable(u[0], s) : new a(u, s);
    }, a.dispatch = function(u) {
      var s = u.arrayLike, c = u.index, l = u.length, f = u.subscriber;
      if (!f.closed) {
        if (c >= l) {
          f.complete();
          return;
        }
        f.next(s[c]), u.index = c + 1, this.schedule(u);
      }
    }, a.prototype._subscribe = function(u) {
      var s = 0, c = this, l = c.arrayLike, f = c.scheduler, d = l.length;
      if (f)
        return f.schedule(a.dispatch, 0, {
          arrayLike: l,
          index: s,
          length: d,
          subscriber: u
        });
      for (var p = 0; p < d && !u.closed; p++)
        u.next(l[p]);
      u.complete();
    }, a;
  }(t.Observable);
  return oD.ArrayLikeObservable = i, oD;
}
var jd = {}, pQ;
function Xer() {
  if (pQ) return jd;
  pQ = 1;
  var e = fe && fe.__extends || function(u, s) {
    for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
    function l() {
      this.constructor = u;
    }
    u.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
  }, t = Ua(), r = l1e();
  function n(u, s) {
    return s === void 0 && (s = 0), function(l) {
      return l.lift(new i(u, s));
    };
  }
  jd.observeOn = n;
  var i = function() {
    function u(s, c) {
      c === void 0 && (c = 0), this.scheduler = s, this.delay = c;
    }
    return u.prototype.call = function(s, c) {
      return c.subscribe(new o(s, this.scheduler, this.delay));
    }, u;
  }();
  jd.ObserveOnOperator = i;
  var o = function(u) {
    e(s, u);
    function s(c, l, f) {
      f === void 0 && (f = 0), u.call(this, c), this.scheduler = l, this.delay = f;
    }
    return s.dispatch = function(c) {
      var l = c.notification, f = c.destination;
      l.observe(f), this.unsubscribe();
    }, s.prototype.scheduleMessage = function(c) {
      this.add(this.scheduler.schedule(s.dispatch, this.delay, new a(c, this.destination)));
    }, s.prototype._next = function(c) {
      this.scheduleMessage(r.Notification.createNext(c));
    }, s.prototype._error = function(c) {
      this.scheduleMessage(r.Notification.createError(c));
    }, s.prototype._complete = function() {
      this.scheduleMessage(r.Notification.createComplete());
    }, s;
  }(t.Subscriber);
  jd.ObserveOnSubscriber = o;
  var a = /* @__PURE__ */ function() {
    function u(s, c) {
      this.notification = s, this.destination = c;
    }
    return u;
  }();
  return jd.ObserveOnMessage = a, jd;
}
var hQ;
function Jer() {
  if (hQ) return rD;
  hQ = 1;
  var e = fe && fe.__extends || function(p, v) {
    for (var h in v) v.hasOwnProperty(h) && (p[h] = v[h]);
    function E() {
      this.constructor = p;
    }
    p.prototype = v === null ? Object.create(v) : (E.prototype = v.prototype, new E());
  }, t = u3(), r = u1e(), n = s1e(), i = Ger(), o = Wer(), a = o7(), u = Ker(), s = i7(), c = ln(), l = Xer(), f = n7(), d = function(p) {
    e(v, p);
    function v(h, E) {
      p.call(this, null), this.ish = h, this.scheduler = E;
    }
    return v.create = function(h, E) {
      if (h != null) {
        if (typeof h[f.observable] == "function")
          return h instanceof c.Observable && !E ? h : new v(h, E);
        if (t.isArray(h))
          return new a.ArrayObservable(h, E);
        if (n.isPromise(h))
          return new i.PromiseObservable(h, E);
        if (typeof h[s.iterator] == "function" || typeof h == "string")
          return new o.IteratorObservable(h, E);
        if (r.isArrayLike(h))
          return new u.ArrayLikeObservable(h, E);
      }
      throw new TypeError((h !== null && typeof h || h) + " is not observable");
    }, v.prototype._subscribe = function(h) {
      var E = this.ish, m = this.scheduler;
      return m == null ? E[f.observable]().subscribe(h) : E[f.observable]().subscribe(new l.ObserveOnSubscriber(h, m, 0));
    }, v;
  }(c.Observable);
  return rD.FromObservable = d, rD;
}
var vQ;
function Zer() {
  if (vQ) return tD;
  vQ = 1;
  var e = Jer();
  return tD.from = e.FromObservable.create, tD;
}
var EQ;
function Qer() {
  if (EQ) return cQ;
  EQ = 1;
  var e = ln(), t = Zer();
  return e.Observable.from = t.from, cQ;
}
var mQ = {}, aD = {}, uD = {}, sD = {}, gQ;
function etr() {
  if (gQ) return sD;
  gQ = 1;
  var e = u3();
  function t(r) {
    return !e.isArray(r) && r - parseFloat(r) + 1 >= 0;
  }
  return sD.isNumeric = t, sD;
}
var TQ;
function ttr() {
  if (TQ) return uD;
  TQ = 1;
  var e = fe && fe.__extends || function(o, a) {
    for (var u in a) a.hasOwnProperty(u) && (o[u] = a[u]);
    function s() {
      this.constructor = o;
    }
    o.prototype = a === null ? Object.create(a) : (s.prototype = a.prototype, new s());
  }, t = etr(), r = ln(), n = l3(), i = function(o) {
    e(a, o);
    function a(u, s) {
      u === void 0 && (u = 0), s === void 0 && (s = n.async), o.call(this), this.period = u, this.scheduler = s, (!t.isNumeric(u) || u < 0) && (this.period = 0), (!s || typeof s.schedule != "function") && (this.scheduler = n.async);
    }
    return a.create = function(u, s) {
      return u === void 0 && (u = 0), s === void 0 && (s = n.async), new a(u, s);
    }, a.dispatch = function(u) {
      var s = u.index, c = u.subscriber, l = u.period;
      c.next(s), !c.closed && (u.index += 1, this.schedule(u, l));
    }, a.prototype._subscribe = function(u) {
      var s = 0, c = this.period, l = this.scheduler;
      u.add(l.schedule(a.dispatch, c, {
        index: s,
        subscriber: u,
        period: c
      }));
    }, a;
  }(r.Observable);
  return uD.IntervalObservable = i, uD;
}
var yQ;
function rtr() {
  if (yQ) return aD;
  yQ = 1;
  var e = ttr();
  return aD.interval = e.IntervalObservable.create, aD;
}
var _Q;
function ntr() {
  if (_Q) return mQ;
  _Q = 1;
  var e = ln(), t = rtr();
  return e.Observable.interval = t.interval, mQ;
}
var AQ = {}, cD = {}, SQ;
function itr() {
  if (SQ) return cD;
  SQ = 1;
  var e = o7();
  return cD.of = e.ArrayObservable.of, cD;
}
var bQ;
function otr() {
  if (bQ) return AQ;
  bQ = 1;
  var e = ln(), t = itr();
  return e.Observable.of = t.of, AQ;
}
var CQ = {}, lD = {}, fD = {}, IQ;
function atr() {
  if (IQ) return fD;
  IQ = 1;
  var e = fe && fe.__extends || function(n, i) {
    for (var o in i) i.hasOwnProperty(o) && (n[o] = i[o]);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  }, t = ln(), r = function(n) {
    e(i, n);
    function i(o, a) {
      n.call(this), this.error = o, this.scheduler = a;
    }
    return i.create = function(o, a) {
      return new i(o, a);
    }, i.dispatch = function(o) {
      var a = o.error, u = o.subscriber;
      u.error(a);
    }, i.prototype._subscribe = function(o) {
      var a = this.error, u = this.scheduler;
      if (o.syncErrorThrowable = !0, u)
        return u.schedule(i.dispatch, 0, {
          error: a,
          subscriber: o
        });
      o.error(a);
    }, i;
  }(t.Observable);
  return fD.ErrorObservable = r, fD;
}
var OQ;
function utr() {
  if (OQ) return lD;
  OQ = 1;
  var e = atr();
  return lD._throw = e.ErrorObservable.create, lD;
}
var RQ;
function str() {
  if (RQ) return CQ;
  RQ = 1;
  var e = ln(), t = utr();
  return e.Observable.throw = t._throw, CQ;
}
var dD = {}, pD = {}, hD = { exports: {} }, vD = { exports: {} }, wQ;
function ctr() {
  return wQ || (wQ = 1, function(e) {
    function t(r) {
      if (Array.isArray(r)) return r;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(vD)), vD.exports;
}
var ED = { exports: {} }, PQ;
function h1e() {
  return PQ || (PQ = 1, function(e) {
    function t(r) {
      if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ED)), ED.exports;
}
var mD = { exports: {} }, gD = { exports: {} }, DQ;
function v1e() {
  return DQ || (DQ = 1, function(e) {
    function t(r, n) {
      (n == null || n > r.length) && (n = r.length);
      for (var i = 0, o = new Array(n); i < n; i++)
        o[i] = r[i];
      return o;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(gD)), gD.exports;
}
var xQ;
function E1e() {
  return xQ || (xQ = 1, function(e) {
    var t = v1e();
    function r(n, i) {
      if (n) {
        if (typeof n == "string") return t(n, i);
        var o = Object.prototype.toString.call(n).slice(8, -1);
        if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set") return Array.from(n);
        if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return t(n, i);
      }
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(mD)), mD.exports;
}
var TD = { exports: {} }, NQ;
function ltr() {
  return NQ || (NQ = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(TD)), TD.exports;
}
var LQ;
function ftr() {
  return LQ || (LQ = 1, function(e) {
    var t = ctr(), r = h1e(), n = E1e(), i = ltr();
    function o(a) {
      return t(a) || r(a) || n(a) || i();
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(hD)), hD.exports;
}
var BQ;
function dtr() {
  return BQ || (BQ = 1, function(e) {
    var t = my;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var r = t(ftr());
    function n(i) {
      if (i)
        if (~i.indexOf(".")) {
          var o = i.split(".").reverse(), a = (0, r.default)(o), u = a[0], s = a.slice(1);
          return {
            extname: "." + u,
            name: s.reverse().join(".")
          };
        } else
          return {
            extname: "",
            name: i
          };
      else return {
        extname: "",
        name: ""
      };
    }
  }(pD)), pD;
}
var kQ;
function ptr() {
  return kQ || (kQ = 1, function(e) {
    var t = my;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var r = t(dtr());
    function n(i) {
      var o = [];
      return i.forEach(function(a) {
        for (var u = (0, r.default)(a), s = u.extname, c = u.name, l = 0, f = a; o.includes(f); )
          f = [c, "(".concat(++l, ")")].filter(function(d) {
            return d;
          }).join(" ") + s;
        o.push(f);
      }), o;
    }
  }(dD)), dD;
}
var Fv = {}, yD, MQ;
function htr() {
  return MQ || (MQ = 1, yD = Fhe()), yD;
}
var _D = { exports: {} }, AD = { exports: {} }, FQ;
function vtr() {
  return FQ || (FQ = 1, function(e) {
    function t(r, n) {
      return n.get ? n.get.call(r) : n.value;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(AD)), AD.exports;
}
var SD = { exports: {} }, HQ;
function m1e() {
  return HQ || (HQ = 1, function(e) {
    function t(r, n, i) {
      if (!n.has(r))
        throw new TypeError("attempted to " + i + " private field on non-instance");
      return n.get(r);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(SD)), SD.exports;
}
var $Q;
function g1e() {
  return $Q || ($Q = 1, function(e) {
    var t = vtr(), r = m1e();
    function n(i, o) {
      var a = r(i, o, "get");
      return t(i, a);
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(_D)), _D.exports;
}
var bD = { exports: {} }, CD = { exports: {} }, UQ;
function Etr() {
  return UQ || (UQ = 1, function(e) {
    function t(r, n, i) {
      if (n.set)
        n.set.call(r, i);
      else {
        if (!n.writable)
          throw new TypeError("attempted to set read only private field");
        n.value = i;
      }
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(CD)), CD.exports;
}
var VQ;
function T1e() {
  return VQ || (VQ = 1, function(e) {
    var t = Etr(), r = m1e();
    function n(i, o, a) {
      var u = r(i, o, "set");
      return t(i, u, a), a;
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(bD)), bD.exports;
}
var ID = { exports: {} }, OD = { exports: {} }, jQ;
function mtr() {
  return jQ || (jQ = 1, function(e) {
    var t = v1e();
    function r(n) {
      if (Array.isArray(n)) return t(n);
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(OD)), OD.exports;
}
var RD = { exports: {} }, zQ;
function gtr() {
  return zQ || (zQ = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(RD)), RD.exports;
}
var qQ;
function Ttr() {
  return qQ || (qQ = 1, function(e) {
    var t = mtr(), r = h1e(), n = E1e(), i = gtr();
    function o(a) {
      return t(a) || r(a) || n(a) || i();
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ID)), ID.exports;
}
var wD = { exports: {} }, YQ;
function ytr() {
  return YQ || (YQ = 1, function(e) {
    function t(n, i, o, a, u, s, c) {
      try {
        var l = n[s](c), f = l.value;
      } catch (d) {
        o(d);
        return;
      }
      l.done ? i(f) : Promise.resolve(f).then(a, u);
    }
    function r(n) {
      return function() {
        var i = this, o = arguments;
        return new Promise(function(a, u) {
          var s = n.apply(i, o);
          function c(f) {
            t(s, a, u, c, l, "next", f);
          }
          function l(f) {
            t(s, a, u, c, l, "throw", f);
          }
          c(void 0);
        });
      };
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(wD)), wD.exports;
}
var PD = {}, dA = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var GQ;
function _tr() {
  return GQ || (GQ = 1, dA.read = function(e, t, r, n, i) {
    var o, a, u = i * 8 - n - 1, s = (1 << u) - 1, c = s >> 1, l = -7, f = r ? i - 1 : 0, d = r ? -1 : 1, p = e[t + f];
    for (f += d, o = p & (1 << -l) - 1, p >>= -l, l += u; l > 0; o = o * 256 + e[t + f], f += d, l -= 8)
      ;
    for (a = o & (1 << -l) - 1, o >>= -l, l += n; l > 0; a = a * 256 + e[t + f], f += d, l -= 8)
      ;
    if (o === 0)
      o = 1 - c;
    else {
      if (o === s)
        return a ? NaN : (p ? -1 : 1) * (1 / 0);
      a = a + Math.pow(2, n), o = o - c;
    }
    return (p ? -1 : 1) * a * Math.pow(2, o - n);
  }, dA.write = function(e, t, r, n, i, o) {
    var a, u, s, c = o * 8 - i - 1, l = (1 << c) - 1, f = l >> 1, d = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : o - 1, v = n ? 1 : -1, h = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), a + f >= 1 ? t += d / s : t += d * Math.pow(2, 1 - f), t * s >= 2 && (a++, s /= 2), a + f >= l ? (u = 0, a = l) : a + f >= 1 ? (u = (t * s - 1) * Math.pow(2, i), a = a + f) : (u = t * Math.pow(2, f - 1) * Math.pow(2, i), a = 0)); i >= 8; e[r + p] = u & 255, p += v, u /= 256, i -= 8)
      ;
    for (a = a << i | u, c += i; c > 0; e[r + p] = a & 255, p += v, a /= 256, c -= 8)
      ;
    e[r + p - v] |= h * 128;
  }), dA;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var WQ;
function Atr() {
  return WQ || (WQ = 1, function(e) {
    const t = NC, r = _tr(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = u, e.SlowBuffer = g, e.INSPECT_MAX_BYTES = 50;
    const i = 2147483647;
    e.kMaxLength = i, u.TYPED_ARRAY_SUPPORT = o(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        const ie = new Uint8Array(1), K = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(K, Uint8Array.prototype), Object.setPrototypeOf(ie, K), ie.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(u.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (u.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(u.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (u.isBuffer(this))
          return this.byteOffset;
      }
    });
    function a(ie) {
      if (ie > i)
        throw new RangeError('The value "' + ie + '" is invalid for option "size"');
      const K = new Uint8Array(ie);
      return Object.setPrototypeOf(K, u.prototype), K;
    }
    function u(ie, K, Z) {
      if (typeof ie == "number") {
        if (typeof K == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return f(ie);
      }
      return s(ie, K, Z);
    }
    u.poolSize = 8192;
    function s(ie, K, Z) {
      if (typeof ie == "string")
        return d(ie, K);
      if (ArrayBuffer.isView(ie))
        return v(ie);
      if (ie == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ie
        );
      if (ue(ie, ArrayBuffer) || ie && ue(ie.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ue(ie, SharedArrayBuffer) || ie && ue(ie.buffer, SharedArrayBuffer)))
        return h(ie, K, Z);
      if (typeof ie == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const Ce = ie.valueOf && ie.valueOf();
      if (Ce != null && Ce !== ie)
        return u.from(Ce, K, Z);
      const be = E(ie);
      if (be) return be;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ie[Symbol.toPrimitive] == "function")
        return u.from(ie[Symbol.toPrimitive]("string"), K, Z);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ie
      );
    }
    u.from = function(ie, K, Z) {
      return s(ie, K, Z);
    }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
    function c(ie) {
      if (typeof ie != "number")
        throw new TypeError('"size" argument must be of type number');
      if (ie < 0)
        throw new RangeError('The value "' + ie + '" is invalid for option "size"');
    }
    function l(ie, K, Z) {
      return c(ie), ie <= 0 ? a(ie) : K !== void 0 ? typeof Z == "string" ? a(ie).fill(K, Z) : a(ie).fill(K) : a(ie);
    }
    u.alloc = function(ie, K, Z) {
      return l(ie, K, Z);
    };
    function f(ie) {
      return c(ie), a(ie < 0 ? 0 : m(ie) | 0);
    }
    u.allocUnsafe = function(ie) {
      return f(ie);
    }, u.allocUnsafeSlow = function(ie) {
      return f(ie);
    };
    function d(ie, K) {
      if ((typeof K != "string" || K === "") && (K = "utf8"), !u.isEncoding(K))
        throw new TypeError("Unknown encoding: " + K);
      const Z = y(ie, K) | 0;
      let Ce = a(Z);
      const be = Ce.write(ie, K);
      return be !== Z && (Ce = Ce.slice(0, be)), Ce;
    }
    function p(ie) {
      const K = ie.length < 0 ? 0 : m(ie.length) | 0, Z = a(K);
      for (let Ce = 0; Ce < K; Ce += 1)
        Z[Ce] = ie[Ce] & 255;
      return Z;
    }
    function v(ie) {
      if (ue(ie, Uint8Array)) {
        const K = new Uint8Array(ie);
        return h(K.buffer, K.byteOffset, K.byteLength);
      }
      return p(ie);
    }
    function h(ie, K, Z) {
      if (K < 0 || ie.byteLength < K)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (ie.byteLength < K + (Z || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let Ce;
      return K === void 0 && Z === void 0 ? Ce = new Uint8Array(ie) : Z === void 0 ? Ce = new Uint8Array(ie, K) : Ce = new Uint8Array(ie, K, Z), Object.setPrototypeOf(Ce, u.prototype), Ce;
    }
    function E(ie) {
      if (u.isBuffer(ie)) {
        const K = m(ie.length) | 0, Z = a(K);
        return Z.length === 0 || ie.copy(Z, 0, 0, K), Z;
      }
      if (ie.length !== void 0)
        return typeof ie.length != "number" || ye(ie.length) ? a(0) : p(ie);
      if (ie.type === "Buffer" && Array.isArray(ie.data))
        return p(ie.data);
    }
    function m(ie) {
      if (ie >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return ie | 0;
    }
    function g(ie) {
      return +ie != ie && (ie = 0), u.alloc(+ie);
    }
    u.isBuffer = function(K) {
      return K != null && K._isBuffer === !0 && K !== u.prototype;
    }, u.compare = function(K, Z) {
      if (ue(K, Uint8Array) && (K = u.from(K, K.offset, K.byteLength)), ue(Z, Uint8Array) && (Z = u.from(Z, Z.offset, Z.byteLength)), !u.isBuffer(K) || !u.isBuffer(Z))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (K === Z) return 0;
      let Ce = K.length, be = Z.length;
      for (let Ge = 0, st = Math.min(Ce, be); Ge < st; ++Ge)
        if (K[Ge] !== Z[Ge]) {
          Ce = K[Ge], be = Z[Ge];
          break;
        }
      return Ce < be ? -1 : be < Ce ? 1 : 0;
    }, u.isEncoding = function(K) {
      switch (String(K).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, u.concat = function(K, Z) {
      if (!Array.isArray(K))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (K.length === 0)
        return u.alloc(0);
      let Ce;
      if (Z === void 0)
        for (Z = 0, Ce = 0; Ce < K.length; ++Ce)
          Z += K[Ce].length;
      const be = u.allocUnsafe(Z);
      let Ge = 0;
      for (Ce = 0; Ce < K.length; ++Ce) {
        let st = K[Ce];
        if (ue(st, Uint8Array))
          Ge + st.length > be.length ? (u.isBuffer(st) || (st = u.from(st)), st.copy(be, Ge)) : Uint8Array.prototype.set.call(
            be,
            st,
            Ge
          );
        else if (u.isBuffer(st))
          st.copy(be, Ge);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        Ge += st.length;
      }
      return be;
    };
    function y(ie, K) {
      if (u.isBuffer(ie))
        return ie.length;
      if (ArrayBuffer.isView(ie) || ue(ie, ArrayBuffer))
        return ie.byteLength;
      if (typeof ie != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ie
        );
      const Z = ie.length, Ce = arguments.length > 2 && arguments[2] === !0;
      if (!Ce && Z === 0) return 0;
      let be = !1;
      for (; ; )
        switch (K) {
          case "ascii":
          case "latin1":
          case "binary":
            return Z;
          case "utf8":
          case "utf-8":
            return Ot(ie).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Z * 2;
          case "hex":
            return Z >>> 1;
          case "base64":
            return Ee(ie).length;
          default:
            if (be)
              return Ce ? -1 : Ot(ie).length;
            K = ("" + K).toLowerCase(), be = !0;
        }
    }
    u.byteLength = y;
    function _(ie, K, Z) {
      let Ce = !1;
      if ((K === void 0 || K < 0) && (K = 0), K > this.length || ((Z === void 0 || Z > this.length) && (Z = this.length), Z <= 0) || (Z >>>= 0, K >>>= 0, Z <= K))
        return "";
      for (ie || (ie = "utf8"); ; )
        switch (ie) {
          case "hex":
            return V(this, K, Z);
          case "utf8":
          case "utf-8":
            return x(this, K, Z);
          case "ascii":
            return $(this, K, Z);
          case "latin1":
          case "binary":
            return X(this, K, Z);
          case "base64":
            return B(this, K, Z);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return F(this, K, Z);
          default:
            if (Ce) throw new TypeError("Unknown encoding: " + ie);
            ie = (ie + "").toLowerCase(), Ce = !0;
        }
    }
    u.prototype._isBuffer = !0;
    function S(ie, K, Z) {
      const Ce = ie[K];
      ie[K] = ie[Z], ie[Z] = Ce;
    }
    u.prototype.swap16 = function() {
      const K = this.length;
      if (K % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let Z = 0; Z < K; Z += 2)
        S(this, Z, Z + 1);
      return this;
    }, u.prototype.swap32 = function() {
      const K = this.length;
      if (K % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let Z = 0; Z < K; Z += 4)
        S(this, Z, Z + 3), S(this, Z + 1, Z + 2);
      return this;
    }, u.prototype.swap64 = function() {
      const K = this.length;
      if (K % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let Z = 0; Z < K; Z += 8)
        S(this, Z, Z + 7), S(this, Z + 1, Z + 6), S(this, Z + 2, Z + 5), S(this, Z + 3, Z + 4);
      return this;
    }, u.prototype.toString = function() {
      const K = this.length;
      return K === 0 ? "" : arguments.length === 0 ? x(this, 0, K) : _.apply(this, arguments);
    }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(K) {
      if (!u.isBuffer(K)) throw new TypeError("Argument must be a Buffer");
      return this === K ? !0 : u.compare(this, K) === 0;
    }, u.prototype.inspect = function() {
      let K = "";
      const Z = e.INSPECT_MAX_BYTES;
      return K = this.toString("hex", 0, Z).replace(/(.{2})/g, "$1 ").trim(), this.length > Z && (K += " ... "), "<Buffer " + K + ">";
    }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(K, Z, Ce, be, Ge) {
      if (ue(K, Uint8Array) && (K = u.from(K, K.offset, K.byteLength)), !u.isBuffer(K))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof K
        );
      if (Z === void 0 && (Z = 0), Ce === void 0 && (Ce = K ? K.length : 0), be === void 0 && (be = 0), Ge === void 0 && (Ge = this.length), Z < 0 || Ce > K.length || be < 0 || Ge > this.length)
        throw new RangeError("out of range index");
      if (be >= Ge && Z >= Ce)
        return 0;
      if (be >= Ge)
        return -1;
      if (Z >= Ce)
        return 1;
      if (Z >>>= 0, Ce >>>= 0, be >>>= 0, Ge >>>= 0, this === K) return 0;
      let st = Ge - be, wt = Ce - Z;
      const Bt = Math.min(st, wt), jt = this.slice(be, Ge), Xt = K.slice(Z, Ce);
      for (let Qt = 0; Qt < Bt; ++Qt)
        if (jt[Qt] !== Xt[Qt]) {
          st = jt[Qt], wt = Xt[Qt];
          break;
        }
      return st < wt ? -1 : wt < st ? 1 : 0;
    };
    function A(ie, K, Z, Ce, be) {
      if (ie.length === 0) return -1;
      if (typeof Z == "string" ? (Ce = Z, Z = 0) : Z > 2147483647 ? Z = 2147483647 : Z < -2147483648 && (Z = -2147483648), Z = +Z, ye(Z) && (Z = be ? 0 : ie.length - 1), Z < 0 && (Z = ie.length + Z), Z >= ie.length) {
        if (be) return -1;
        Z = ie.length - 1;
      } else if (Z < 0)
        if (be) Z = 0;
        else return -1;
      if (typeof K == "string" && (K = u.from(K, Ce)), u.isBuffer(K))
        return K.length === 0 ? -1 : O(ie, K, Z, Ce, be);
      if (typeof K == "number")
        return K = K & 255, typeof Uint8Array.prototype.indexOf == "function" ? be ? Uint8Array.prototype.indexOf.call(ie, K, Z) : Uint8Array.prototype.lastIndexOf.call(ie, K, Z) : O(ie, [K], Z, Ce, be);
      throw new TypeError("val must be string, number or Buffer");
    }
    function O(ie, K, Z, Ce, be) {
      let Ge = 1, st = ie.length, wt = K.length;
      if (Ce !== void 0 && (Ce = String(Ce).toLowerCase(), Ce === "ucs2" || Ce === "ucs-2" || Ce === "utf16le" || Ce === "utf-16le")) {
        if (ie.length < 2 || K.length < 2)
          return -1;
        Ge = 2, st /= 2, wt /= 2, Z /= 2;
      }
      function Bt(Xt, Qt) {
        return Ge === 1 ? Xt[Qt] : Xt.readUInt16BE(Qt * Ge);
      }
      let jt;
      if (be) {
        let Xt = -1;
        for (jt = Z; jt < st; jt++)
          if (Bt(ie, jt) === Bt(K, Xt === -1 ? 0 : jt - Xt)) {
            if (Xt === -1 && (Xt = jt), jt - Xt + 1 === wt) return Xt * Ge;
          } else
            Xt !== -1 && (jt -= jt - Xt), Xt = -1;
      } else
        for (Z + wt > st && (Z = st - wt), jt = Z; jt >= 0; jt--) {
          let Xt = !0;
          for (let Qt = 0; Qt < wt; Qt++)
            if (Bt(ie, jt + Qt) !== Bt(K, Qt)) {
              Xt = !1;
              break;
            }
          if (Xt) return jt;
        }
      return -1;
    }
    u.prototype.includes = function(K, Z, Ce) {
      return this.indexOf(K, Z, Ce) !== -1;
    }, u.prototype.indexOf = function(K, Z, Ce) {
      return A(this, K, Z, Ce, !0);
    }, u.prototype.lastIndexOf = function(K, Z, Ce) {
      return A(this, K, Z, Ce, !1);
    };
    function P(ie, K, Z, Ce) {
      Z = Number(Z) || 0;
      const be = ie.length - Z;
      Ce ? (Ce = Number(Ce), Ce > be && (Ce = be)) : Ce = be;
      const Ge = K.length;
      Ce > Ge / 2 && (Ce = Ge / 2);
      let st;
      for (st = 0; st < Ce; ++st) {
        const wt = parseInt(K.substr(st * 2, 2), 16);
        if (ye(wt)) return st;
        ie[Z + st] = wt;
      }
      return st;
    }
    function U(ie, K, Z, Ce) {
      return te(Ot(K, ie.length - Z), ie, Z, Ce);
    }
    function z(ie, K, Z, Ce) {
      return te(we(K), ie, Z, Ce);
    }
    function k(ie, K, Z, Ce) {
      return te(Ee(K), ie, Z, Ce);
    }
    function H(ie, K, Z, Ce) {
      return te(De(K, ie.length - Z), ie, Z, Ce);
    }
    u.prototype.write = function(K, Z, Ce, be) {
      if (Z === void 0)
        be = "utf8", Ce = this.length, Z = 0;
      else if (Ce === void 0 && typeof Z == "string")
        be = Z, Ce = this.length, Z = 0;
      else if (isFinite(Z))
        Z = Z >>> 0, isFinite(Ce) ? (Ce = Ce >>> 0, be === void 0 && (be = "utf8")) : (be = Ce, Ce = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const Ge = this.length - Z;
      if ((Ce === void 0 || Ce > Ge) && (Ce = Ge), K.length > 0 && (Ce < 0 || Z < 0) || Z > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      be || (be = "utf8");
      let st = !1;
      for (; ; )
        switch (be) {
          case "hex":
            return P(this, K, Z, Ce);
          case "utf8":
          case "utf-8":
            return U(this, K, Z, Ce);
          case "ascii":
          case "latin1":
          case "binary":
            return z(this, K, Z, Ce);
          case "base64":
            return k(this, K, Z, Ce);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return H(this, K, Z, Ce);
          default:
            if (st) throw new TypeError("Unknown encoding: " + be);
            be = ("" + be).toLowerCase(), st = !0;
        }
    }, u.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function B(ie, K, Z) {
      return K === 0 && Z === ie.length ? t.fromByteArray(ie) : t.fromByteArray(ie.slice(K, Z));
    }
    function x(ie, K, Z) {
      Z = Math.min(ie.length, Z);
      const Ce = [];
      let be = K;
      for (; be < Z; ) {
        const Ge = ie[be];
        let st = null, wt = Ge > 239 ? 4 : Ge > 223 ? 3 : Ge > 191 ? 2 : 1;
        if (be + wt <= Z) {
          let Bt, jt, Xt, Qt;
          switch (wt) {
            case 1:
              Ge < 128 && (st = Ge);
              break;
            case 2:
              Bt = ie[be + 1], (Bt & 192) === 128 && (Qt = (Ge & 31) << 6 | Bt & 63, Qt > 127 && (st = Qt));
              break;
            case 3:
              Bt = ie[be + 1], jt = ie[be + 2], (Bt & 192) === 128 && (jt & 192) === 128 && (Qt = (Ge & 15) << 12 | (Bt & 63) << 6 | jt & 63, Qt > 2047 && (Qt < 55296 || Qt > 57343) && (st = Qt));
              break;
            case 4:
              Bt = ie[be + 1], jt = ie[be + 2], Xt = ie[be + 3], (Bt & 192) === 128 && (jt & 192) === 128 && (Xt & 192) === 128 && (Qt = (Ge & 15) << 18 | (Bt & 63) << 12 | (jt & 63) << 6 | Xt & 63, Qt > 65535 && Qt < 1114112 && (st = Qt));
          }
        }
        st === null ? (st = 65533, wt = 1) : st > 65535 && (st -= 65536, Ce.push(st >>> 10 & 1023 | 55296), st = 56320 | st & 1023), Ce.push(st), be += wt;
      }
      return w(Ce);
    }
    const D = 4096;
    function w(ie) {
      const K = ie.length;
      if (K <= D)
        return String.fromCharCode.apply(String, ie);
      let Z = "", Ce = 0;
      for (; Ce < K; )
        Z += String.fromCharCode.apply(
          String,
          ie.slice(Ce, Ce += D)
        );
      return Z;
    }
    function $(ie, K, Z) {
      let Ce = "";
      Z = Math.min(ie.length, Z);
      for (let be = K; be < Z; ++be)
        Ce += String.fromCharCode(ie[be] & 127);
      return Ce;
    }
    function X(ie, K, Z) {
      let Ce = "";
      Z = Math.min(ie.length, Z);
      for (let be = K; be < Z; ++be)
        Ce += String.fromCharCode(ie[be]);
      return Ce;
    }
    function V(ie, K, Z) {
      const Ce = ie.length;
      (!K || K < 0) && (K = 0), (!Z || Z < 0 || Z > Ce) && (Z = Ce);
      let be = "";
      for (let Ge = K; Ge < Z; ++Ge)
        be += Le[ie[Ge]];
      return be;
    }
    function F(ie, K, Z) {
      const Ce = ie.slice(K, Z);
      let be = "";
      for (let Ge = 0; Ge < Ce.length - 1; Ge += 2)
        be += String.fromCharCode(Ce[Ge] + Ce[Ge + 1] * 256);
      return be;
    }
    u.prototype.slice = function(K, Z) {
      const Ce = this.length;
      K = ~~K, Z = Z === void 0 ? Ce : ~~Z, K < 0 ? (K += Ce, K < 0 && (K = 0)) : K > Ce && (K = Ce), Z < 0 ? (Z += Ce, Z < 0 && (Z = 0)) : Z > Ce && (Z = Ce), Z < K && (Z = K);
      const be = this.subarray(K, Z);
      return Object.setPrototypeOf(be, u.prototype), be;
    };
    function le(ie, K, Z) {
      if (ie % 1 !== 0 || ie < 0) throw new RangeError("offset is not uint");
      if (ie + K > Z) throw new RangeError("Trying to access beyond buffer length");
    }
    u.prototype.readUintLE = u.prototype.readUIntLE = function(K, Z, Ce) {
      K = K >>> 0, Z = Z >>> 0, Ce || le(K, Z, this.length);
      let be = this[K], Ge = 1, st = 0;
      for (; ++st < Z && (Ge *= 256); )
        be += this[K + st] * Ge;
      return be;
    }, u.prototype.readUintBE = u.prototype.readUIntBE = function(K, Z, Ce) {
      K = K >>> 0, Z = Z >>> 0, Ce || le(K, Z, this.length);
      let be = this[K + --Z], Ge = 1;
      for (; Z > 0 && (Ge *= 256); )
        be += this[K + --Z] * Ge;
      return be;
    }, u.prototype.readUint8 = u.prototype.readUInt8 = function(K, Z) {
      return K = K >>> 0, Z || le(K, 1, this.length), this[K];
    }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 2, this.length), this[K] | this[K + 1] << 8;
    }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 2, this.length), this[K] << 8 | this[K + 1];
    }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), (this[K] | this[K + 1] << 8 | this[K + 2] << 16) + this[K + 3] * 16777216;
    }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), this[K] * 16777216 + (this[K + 1] << 16 | this[K + 2] << 8 | this[K + 3]);
    }, u.prototype.readBigUInt64LE = Me(function(K) {
      K = K >>> 0, Ne(K, "offset");
      const Z = this[K], Ce = this[K + 7];
      (Z === void 0 || Ce === void 0) && je(K, this.length - 8);
      const be = Z + this[++K] * 2 ** 8 + this[++K] * 2 ** 16 + this[++K] * 2 ** 24, Ge = this[++K] + this[++K] * 2 ** 8 + this[++K] * 2 ** 16 + Ce * 2 ** 24;
      return BigInt(be) + (BigInt(Ge) << BigInt(32));
    }), u.prototype.readBigUInt64BE = Me(function(K) {
      K = K >>> 0, Ne(K, "offset");
      const Z = this[K], Ce = this[K + 7];
      (Z === void 0 || Ce === void 0) && je(K, this.length - 8);
      const be = Z * 2 ** 24 + this[++K] * 2 ** 16 + this[++K] * 2 ** 8 + this[++K], Ge = this[++K] * 2 ** 24 + this[++K] * 2 ** 16 + this[++K] * 2 ** 8 + Ce;
      return (BigInt(be) << BigInt(32)) + BigInt(Ge);
    }), u.prototype.readIntLE = function(K, Z, Ce) {
      K = K >>> 0, Z = Z >>> 0, Ce || le(K, Z, this.length);
      let be = this[K], Ge = 1, st = 0;
      for (; ++st < Z && (Ge *= 256); )
        be += this[K + st] * Ge;
      return Ge *= 128, be >= Ge && (be -= Math.pow(2, 8 * Z)), be;
    }, u.prototype.readIntBE = function(K, Z, Ce) {
      K = K >>> 0, Z = Z >>> 0, Ce || le(K, Z, this.length);
      let be = Z, Ge = 1, st = this[K + --be];
      for (; be > 0 && (Ge *= 256); )
        st += this[K + --be] * Ge;
      return Ge *= 128, st >= Ge && (st -= Math.pow(2, 8 * Z)), st;
    }, u.prototype.readInt8 = function(K, Z) {
      return K = K >>> 0, Z || le(K, 1, this.length), this[K] & 128 ? (255 - this[K] + 1) * -1 : this[K];
    }, u.prototype.readInt16LE = function(K, Z) {
      K = K >>> 0, Z || le(K, 2, this.length);
      const Ce = this[K] | this[K + 1] << 8;
      return Ce & 32768 ? Ce | 4294901760 : Ce;
    }, u.prototype.readInt16BE = function(K, Z) {
      K = K >>> 0, Z || le(K, 2, this.length);
      const Ce = this[K + 1] | this[K] << 8;
      return Ce & 32768 ? Ce | 4294901760 : Ce;
    }, u.prototype.readInt32LE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), this[K] | this[K + 1] << 8 | this[K + 2] << 16 | this[K + 3] << 24;
    }, u.prototype.readInt32BE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), this[K] << 24 | this[K + 1] << 16 | this[K + 2] << 8 | this[K + 3];
    }, u.prototype.readBigInt64LE = Me(function(K) {
      K = K >>> 0, Ne(K, "offset");
      const Z = this[K], Ce = this[K + 7];
      (Z === void 0 || Ce === void 0) && je(K, this.length - 8);
      const be = this[K + 4] + this[K + 5] * 2 ** 8 + this[K + 6] * 2 ** 16 + (Ce << 24);
      return (BigInt(be) << BigInt(32)) + BigInt(Z + this[++K] * 2 ** 8 + this[++K] * 2 ** 16 + this[++K] * 2 ** 24);
    }), u.prototype.readBigInt64BE = Me(function(K) {
      K = K >>> 0, Ne(K, "offset");
      const Z = this[K], Ce = this[K + 7];
      (Z === void 0 || Ce === void 0) && je(K, this.length - 8);
      const be = (Z << 24) + // Overflow
      this[++K] * 2 ** 16 + this[++K] * 2 ** 8 + this[++K];
      return (BigInt(be) << BigInt(32)) + BigInt(this[++K] * 2 ** 24 + this[++K] * 2 ** 16 + this[++K] * 2 ** 8 + Ce);
    }), u.prototype.readFloatLE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), r.read(this, K, !0, 23, 4);
    }, u.prototype.readFloatBE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 4, this.length), r.read(this, K, !1, 23, 4);
    }, u.prototype.readDoubleLE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 8, this.length), r.read(this, K, !0, 52, 8);
    }, u.prototype.readDoubleBE = function(K, Z) {
      return K = K >>> 0, Z || le(K, 8, this.length), r.read(this, K, !1, 52, 8);
    };
    function ae(ie, K, Z, Ce, be, Ge) {
      if (!u.isBuffer(ie)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (K > be || K < Ge) throw new RangeError('"value" argument is out of bounds');
      if (Z + Ce > ie.length) throw new RangeError("Index out of range");
    }
    u.prototype.writeUintLE = u.prototype.writeUIntLE = function(K, Z, Ce, be) {
      if (K = +K, Z = Z >>> 0, Ce = Ce >>> 0, !be) {
        const wt = Math.pow(2, 8 * Ce) - 1;
        ae(this, K, Z, Ce, wt, 0);
      }
      let Ge = 1, st = 0;
      for (this[Z] = K & 255; ++st < Ce && (Ge *= 256); )
        this[Z + st] = K / Ge & 255;
      return Z + Ce;
    }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(K, Z, Ce, be) {
      if (K = +K, Z = Z >>> 0, Ce = Ce >>> 0, !be) {
        const wt = Math.pow(2, 8 * Ce) - 1;
        ae(this, K, Z, Ce, wt, 0);
      }
      let Ge = Ce - 1, st = 1;
      for (this[Z + Ge] = K & 255; --Ge >= 0 && (st *= 256); )
        this[Z + Ge] = K / st & 255;
      return Z + Ce;
    }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 1, 255, 0), this[Z] = K & 255, Z + 1;
    }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 2, 65535, 0), this[Z] = K & 255, this[Z + 1] = K >>> 8, Z + 2;
    }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 2, 65535, 0), this[Z] = K >>> 8, this[Z + 1] = K & 255, Z + 2;
    }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 4, 4294967295, 0), this[Z + 3] = K >>> 24, this[Z + 2] = K >>> 16, this[Z + 1] = K >>> 8, this[Z] = K & 255, Z + 4;
    }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 4, 4294967295, 0), this[Z] = K >>> 24, this[Z + 1] = K >>> 16, this[Z + 2] = K >>> 8, this[Z + 3] = K & 255, Z + 4;
    };
    function ne(ie, K, Z, Ce, be) {
      We(K, Ce, be, ie, Z, 7);
      let Ge = Number(K & BigInt(4294967295));
      ie[Z++] = Ge, Ge = Ge >> 8, ie[Z++] = Ge, Ge = Ge >> 8, ie[Z++] = Ge, Ge = Ge >> 8, ie[Z++] = Ge;
      let st = Number(K >> BigInt(32) & BigInt(4294967295));
      return ie[Z++] = st, st = st >> 8, ie[Z++] = st, st = st >> 8, ie[Z++] = st, st = st >> 8, ie[Z++] = st, Z;
    }
    function ve(ie, K, Z, Ce, be) {
      We(K, Ce, be, ie, Z, 7);
      let Ge = Number(K & BigInt(4294967295));
      ie[Z + 7] = Ge, Ge = Ge >> 8, ie[Z + 6] = Ge, Ge = Ge >> 8, ie[Z + 5] = Ge, Ge = Ge >> 8, ie[Z + 4] = Ge;
      let st = Number(K >> BigInt(32) & BigInt(4294967295));
      return ie[Z + 3] = st, st = st >> 8, ie[Z + 2] = st, st = st >> 8, ie[Z + 1] = st, st = st >> 8, ie[Z] = st, Z + 8;
    }
    u.prototype.writeBigUInt64LE = Me(function(K, Z = 0) {
      return ne(this, K, Z, BigInt(0), BigInt("0xffffffffffffffff"));
    }), u.prototype.writeBigUInt64BE = Me(function(K, Z = 0) {
      return ve(this, K, Z, BigInt(0), BigInt("0xffffffffffffffff"));
    }), u.prototype.writeIntLE = function(K, Z, Ce, be) {
      if (K = +K, Z = Z >>> 0, !be) {
        const Bt = Math.pow(2, 8 * Ce - 1);
        ae(this, K, Z, Ce, Bt - 1, -Bt);
      }
      let Ge = 0, st = 1, wt = 0;
      for (this[Z] = K & 255; ++Ge < Ce && (st *= 256); )
        K < 0 && wt === 0 && this[Z + Ge - 1] !== 0 && (wt = 1), this[Z + Ge] = (K / st >> 0) - wt & 255;
      return Z + Ce;
    }, u.prototype.writeIntBE = function(K, Z, Ce, be) {
      if (K = +K, Z = Z >>> 0, !be) {
        const Bt = Math.pow(2, 8 * Ce - 1);
        ae(this, K, Z, Ce, Bt - 1, -Bt);
      }
      let Ge = Ce - 1, st = 1, wt = 0;
      for (this[Z + Ge] = K & 255; --Ge >= 0 && (st *= 256); )
        K < 0 && wt === 0 && this[Z + Ge + 1] !== 0 && (wt = 1), this[Z + Ge] = (K / st >> 0) - wt & 255;
      return Z + Ce;
    }, u.prototype.writeInt8 = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 1, 127, -128), K < 0 && (K = 255 + K + 1), this[Z] = K & 255, Z + 1;
    }, u.prototype.writeInt16LE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 2, 32767, -32768), this[Z] = K & 255, this[Z + 1] = K >>> 8, Z + 2;
    }, u.prototype.writeInt16BE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 2, 32767, -32768), this[Z] = K >>> 8, this[Z + 1] = K & 255, Z + 2;
    }, u.prototype.writeInt32LE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 4, 2147483647, -2147483648), this[Z] = K & 255, this[Z + 1] = K >>> 8, this[Z + 2] = K >>> 16, this[Z + 3] = K >>> 24, Z + 4;
    }, u.prototype.writeInt32BE = function(K, Z, Ce) {
      return K = +K, Z = Z >>> 0, Ce || ae(this, K, Z, 4, 2147483647, -2147483648), K < 0 && (K = 4294967295 + K + 1), this[Z] = K >>> 24, this[Z + 1] = K >>> 16, this[Z + 2] = K >>> 8, this[Z + 3] = K & 255, Z + 4;
    }, u.prototype.writeBigInt64LE = Me(function(K, Z = 0) {
      return ne(this, K, Z, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), u.prototype.writeBigInt64BE = Me(function(K, Z = 0) {
      return ve(this, K, Z, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function Ie(ie, K, Z, Ce, be, Ge) {
      if (Z + Ce > ie.length) throw new RangeError("Index out of range");
      if (Z < 0) throw new RangeError("Index out of range");
    }
    function Oe(ie, K, Z, Ce, be) {
      return K = +K, Z = Z >>> 0, be || Ie(ie, K, Z, 4), r.write(ie, K, Z, Ce, 23, 4), Z + 4;
    }
    u.prototype.writeFloatLE = function(K, Z, Ce) {
      return Oe(this, K, Z, !0, Ce);
    }, u.prototype.writeFloatBE = function(K, Z, Ce) {
      return Oe(this, K, Z, !1, Ce);
    };
    function xe(ie, K, Z, Ce, be) {
      return K = +K, Z = Z >>> 0, be || Ie(ie, K, Z, 8), r.write(ie, K, Z, Ce, 52, 8), Z + 8;
    }
    u.prototype.writeDoubleLE = function(K, Z, Ce) {
      return xe(this, K, Z, !0, Ce);
    }, u.prototype.writeDoubleBE = function(K, Z, Ce) {
      return xe(this, K, Z, !1, Ce);
    }, u.prototype.copy = function(K, Z, Ce, be) {
      if (!u.isBuffer(K)) throw new TypeError("argument should be a Buffer");
      if (Ce || (Ce = 0), !be && be !== 0 && (be = this.length), Z >= K.length && (Z = K.length), Z || (Z = 0), be > 0 && be < Ce && (be = Ce), be === Ce || K.length === 0 || this.length === 0) return 0;
      if (Z < 0)
        throw new RangeError("targetStart out of bounds");
      if (Ce < 0 || Ce >= this.length) throw new RangeError("Index out of range");
      if (be < 0) throw new RangeError("sourceEnd out of bounds");
      be > this.length && (be = this.length), K.length - Z < be - Ce && (be = K.length - Z + Ce);
      const Ge = be - Ce;
      return this === K && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Z, Ce, be) : Uint8Array.prototype.set.call(
        K,
        this.subarray(Ce, be),
        Z
      ), Ge;
    }, u.prototype.fill = function(K, Z, Ce, be) {
      if (typeof K == "string") {
        if (typeof Z == "string" ? (be = Z, Z = 0, Ce = this.length) : typeof Ce == "string" && (be = Ce, Ce = this.length), be !== void 0 && typeof be != "string")
          throw new TypeError("encoding must be a string");
        if (typeof be == "string" && !u.isEncoding(be))
          throw new TypeError("Unknown encoding: " + be);
        if (K.length === 1) {
          const st = K.charCodeAt(0);
          (be === "utf8" && st < 128 || be === "latin1") && (K = st);
        }
      } else typeof K == "number" ? K = K & 255 : typeof K == "boolean" && (K = Number(K));
      if (Z < 0 || this.length < Z || this.length < Ce)
        throw new RangeError("Out of range index");
      if (Ce <= Z)
        return this;
      Z = Z >>> 0, Ce = Ce === void 0 ? this.length : Ce >>> 0, K || (K = 0);
      let Ge;
      if (typeof K == "number")
        for (Ge = Z; Ge < Ce; ++Ge)
          this[Ge] = K;
      else {
        const st = u.isBuffer(K) ? K : u.from(K, be), wt = st.length;
        if (wt === 0)
          throw new TypeError('The value "' + K + '" is invalid for argument "value"');
        for (Ge = 0; Ge < Ce - Z; ++Ge)
          this[Ge + Z] = st[Ge % wt];
      }
      return this;
    };
    const ze = {};
    function qe(ie, K, Z) {
      ze[ie] = class extends Z {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: K.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${ie}]`, this.stack, delete this.name;
        }
        get code() {
          return ie;
        }
        set code(be) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: be,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${ie}]: ${this.message}`;
        }
      };
    }
    qe(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(ie) {
        return ie ? `${ie} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), qe(
      "ERR_INVALID_ARG_TYPE",
      function(ie, K) {
        return `The "${ie}" argument must be of type number. Received type ${typeof K}`;
      },
      TypeError
    ), qe(
      "ERR_OUT_OF_RANGE",
      function(ie, K, Z) {
        let Ce = `The value of "${ie}" is out of range.`, be = Z;
        return Number.isInteger(Z) && Math.abs(Z) > 2 ** 32 ? be = Je(String(Z)) : typeof Z == "bigint" && (be = String(Z), (Z > BigInt(2) ** BigInt(32) || Z < -(BigInt(2) ** BigInt(32))) && (be = Je(be)), be += "n"), Ce += ` It must be ${K}. Received ${be}`, Ce;
      },
      RangeError
    );
    function Je(ie) {
      let K = "", Z = ie.length;
      const Ce = ie[0] === "-" ? 1 : 0;
      for (; Z >= Ce + 4; Z -= 3)
        K = `_${ie.slice(Z - 3, Z)}${K}`;
      return `${ie.slice(0, Z)}${K}`;
    }
    function Be(ie, K, Z) {
      Ne(K, "offset"), (ie[K] === void 0 || ie[K + Z] === void 0) && je(K, ie.length - (Z + 1));
    }
    function We(ie, K, Z, Ce, be, Ge) {
      if (ie > Z || ie < K) {
        const st = typeof K == "bigint" ? "n" : "";
        let wt;
        throw K === 0 || K === BigInt(0) ? wt = `>= 0${st} and < 2${st} ** ${(Ge + 1) * 8}${st}` : wt = `>= -(2${st} ** ${(Ge + 1) * 8 - 1}${st}) and < 2 ** ${(Ge + 1) * 8 - 1}${st}`, new ze.ERR_OUT_OF_RANGE("value", wt, ie);
      }
      Be(Ce, be, Ge);
    }
    function Ne(ie, K) {
      if (typeof ie != "number")
        throw new ze.ERR_INVALID_ARG_TYPE(K, "number", ie);
    }
    function je(ie, K, Z) {
      throw Math.floor(ie) !== ie ? (Ne(ie, Z), new ze.ERR_OUT_OF_RANGE("offset", "an integer", ie)) : K < 0 ? new ze.ERR_BUFFER_OUT_OF_BOUNDS() : new ze.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${K}`,
        ie
      );
    }
    const et = /[^+/0-9A-Za-z-_]/g;
    function St(ie) {
      if (ie = ie.split("=")[0], ie = ie.trim().replace(et, ""), ie.length < 2) return "";
      for (; ie.length % 4 !== 0; )
        ie = ie + "=";
      return ie;
    }
    function Ot(ie, K) {
      K = K || 1 / 0;
      let Z;
      const Ce = ie.length;
      let be = null;
      const Ge = [];
      for (let st = 0; st < Ce; ++st) {
        if (Z = ie.charCodeAt(st), Z > 55295 && Z < 57344) {
          if (!be) {
            if (Z > 56319) {
              (K -= 3) > -1 && Ge.push(239, 191, 189);
              continue;
            } else if (st + 1 === Ce) {
              (K -= 3) > -1 && Ge.push(239, 191, 189);
              continue;
            }
            be = Z;
            continue;
          }
          if (Z < 56320) {
            (K -= 3) > -1 && Ge.push(239, 191, 189), be = Z;
            continue;
          }
          Z = (be - 55296 << 10 | Z - 56320) + 65536;
        } else be && (K -= 3) > -1 && Ge.push(239, 191, 189);
        if (be = null, Z < 128) {
          if ((K -= 1) < 0) break;
          Ge.push(Z);
        } else if (Z < 2048) {
          if ((K -= 2) < 0) break;
          Ge.push(
            Z >> 6 | 192,
            Z & 63 | 128
          );
        } else if (Z < 65536) {
          if ((K -= 3) < 0) break;
          Ge.push(
            Z >> 12 | 224,
            Z >> 6 & 63 | 128,
            Z & 63 | 128
          );
        } else if (Z < 1114112) {
          if ((K -= 4) < 0) break;
          Ge.push(
            Z >> 18 | 240,
            Z >> 12 & 63 | 128,
            Z >> 6 & 63 | 128,
            Z & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return Ge;
    }
    function we(ie) {
      const K = [];
      for (let Z = 0; Z < ie.length; ++Z)
        K.push(ie.charCodeAt(Z) & 255);
      return K;
    }
    function De(ie, K) {
      let Z, Ce, be;
      const Ge = [];
      for (let st = 0; st < ie.length && !((K -= 2) < 0); ++st)
        Z = ie.charCodeAt(st), Ce = Z >> 8, be = Z % 256, Ge.push(be), Ge.push(Ce);
      return Ge;
    }
    function Ee(ie) {
      return t.toByteArray(St(ie));
    }
    function te(ie, K, Z, Ce) {
      let be;
      for (be = 0; be < Ce && !(be + Z >= K.length || be >= ie.length); ++be)
        K[be + Z] = ie[be];
      return be;
    }
    function ue(ie, K) {
      return ie instanceof K || ie != null && ie.constructor != null && ie.constructor.name != null && ie.constructor.name === K.name;
    }
    function ye(ie) {
      return ie !== ie;
    }
    const Le = function() {
      const ie = "0123456789abcdef", K = new Array(256);
      for (let Z = 0; Z < 16; ++Z) {
        const Ce = Z * 16;
        for (let be = 0; be < 16; ++be)
          K[Ce + be] = ie[Z] + ie[be];
      }
      return K;
    }();
    function Me(ie) {
      return typeof BigInt > "u" ? Ae : ie;
    }
    function Ae() {
      throw new Error("BigInt not supported");
    }
  }(PD)), PD;
}
function pA(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var DD = { exports: {} }, KQ;
function y1e() {
  return KQ || (KQ = 1, function(e, t) {
    (function(r) {
      e.exports = r();
    })(function() {
      return (/* @__PURE__ */ function() {
        function r(n, i, o) {
          function a(c, l) {
            if (!i[c]) {
              if (!n[c]) {
                var f = typeof pA == "function" && pA;
                if (!l && f) return f(c, !0);
                if (u) return u(c, !0);
                var d = new Error("Cannot find module '" + c + "'");
                throw d.code = "MODULE_NOT_FOUND", d;
              }
              var p = i[c] = { exports: {} };
              n[c][0].call(p.exports, function(v) {
                var h = n[c][1][v];
                return a(h || v);
              }, p, p.exports, r, n, i, o);
            }
            return i[c].exports;
          }
          for (var u = typeof pA == "function" && pA, s = 0; s < o.length; s++) a(o[s]);
          return a;
        }
        return r;
      }())({ 1: [function(r, n, i) {
        var o = this && this.__awaiter || function(f, d, p, v) {
          function h(E) {
            return E instanceof p ? E : new p(function(m) {
              m(E);
            });
          }
          return new (p || (p = Promise))(function(E, m) {
            function g(S) {
              try {
                _(v.next(S));
              } catch (A) {
                m(A);
              }
            }
            function y(S) {
              try {
                _(v.throw(S));
              } catch (A) {
                m(A);
              }
            }
            function _(S) {
              S.done ? E(S.value) : h(S.value).then(g, y);
            }
            _((v = v.apply(f, d || [])).next());
          });
        }, a = this && this.__generator || function(f, d) {
          var p = { label: 0, sent: function() {
            if (E[0] & 1) throw E[1];
            return E[1];
          }, trys: [], ops: [] }, v, h, E, m;
          return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function g(_) {
            return function(S) {
              return y([_, S]);
            };
          }
          function y(_) {
            if (v) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, _[0] && (p = 0)), p; ) try {
              if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
              switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
                case 0:
                case 1:
                  E = _;
                  break;
                case 4:
                  return p.label++, { value: _[1], done: !1 };
                case 5:
                  p.label++, h = _[1], _ = [0];
                  continue;
                case 7:
                  _ = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
                    p.label = _[1];
                    break;
                  }
                  if (_[0] === 6 && p.label < E[1]) {
                    p.label = E[1], E = _;
                    break;
                  }
                  if (E && p.label < E[2]) {
                    p.label = E[2], p.ops.push(_);
                    break;
                  }
                  E[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              _ = d.call(f, p);
            } catch (S) {
              _ = [6, S], h = 0;
            } finally {
              v = E = 0;
            }
            if (_[0] & 5) throw _[1];
            return { value: _[0] ? _[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadAssembler = void 0;
        var u = r("../subscribableStream"), s = r("../payloads"), c = r("../contentStream"), l = (
          /** @class */
          function() {
            function f(d, p) {
              if (this.streamManager = d, this._byteOrderMark = 65279, this._utf = "utf8", p.header ? (this.id = p.header.id, this.payloadType = p.header.payloadType, this.contentLength = p.header.payloadLength, this.end = p.header.end) : this.id = p.id, !this.id)
                throw Error("An ID must be supplied when creating an assembler.");
              this._onCompleted = p.onCompleted;
            }
            return f.prototype.getPayloadStream = function() {
              return this.stream || (this.stream = this.createPayloadStream()), this.stream;
            }, f.prototype.onReceive = function(d, p, v) {
              this.end = d.end, d.payloadType === s.PayloadTypes.response || d.payloadType === s.PayloadTypes.request ? this.process(p).then().catch() : d.end && p.end();
            }, f.prototype.close = function() {
              this.streamManager.closeStream(this.id);
            }, f.prototype.createPayloadStream = function() {
              return new u.SubscribableStream();
            }, f.prototype.payloadFromJson = function(d) {
              return JSON.parse(d.charCodeAt(0) === this._byteOrderMark ? d.slice(1) : d);
            }, f.prototype.stripBOM = function(d) {
              return d.charCodeAt(0) === this._byteOrderMark ? d.slice(1) : d;
            }, f.prototype.process = function(d) {
              return o(this, void 0, void 0, function() {
                var p, v;
                return a(this, function(h) {
                  switch (h.label) {
                    case 0:
                      return p = d.read(d.length), p ? (v = p.toString(this._utf), this.payloadType !== s.PayloadTypes.request ? [3, 2] : [4, this.processRequest(v)]) : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return h.sent(), [3, 4];
                    case 2:
                      return this.payloadType !== s.PayloadTypes.response ? [3, 4] : [4, this.processResponse(v)];
                    case 3:
                      h.sent(), h.label = 4;
                    case 4:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.processResponse = function(d) {
              return o(this, void 0, void 0, function() {
                var p, v;
                return a(this, function(h) {
                  switch (h.label) {
                    case 0:
                      return p = this.payloadFromJson(this.stripBOM(d)), v = { streams: [], statusCode: p.statusCode }, [4, this.processStreams(p, v)];
                    case 1:
                      return h.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.processRequest = function(d) {
              return o(this, void 0, void 0, function() {
                var p, v;
                return a(this, function(h) {
                  switch (h.label) {
                    case 0:
                      return p = this.payloadFromJson(d), v = { streams: [], path: p.path, verb: p.verb }, [4, this.processStreams(p, v)];
                    case 1:
                      return h.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.processStreams = function(d, p) {
              var v;
              return o(this, void 0, void 0, function() {
                var h = this;
                return a(this, function(E) {
                  switch (E.label) {
                    case 0:
                      return (v = d.streams) === null || v === void 0 || v.forEach(function(m) {
                        var g, y = (g = m.type) !== null && g !== void 0 ? g : m.contentType, _ = h.streamManager.getPayloadAssembler(m.id);
                        _.payloadType = y, _.contentLength = m.length, p.streams.push(new c.ContentStream(m.id, _));
                      }), [4, this._onCompleted(this.id, p)];
                    case 1:
                      return E.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f;
          }()
        );
        i.PayloadAssembler = l;
      }, { "../contentStream": 2, "../payloads": 16, "../subscribableStream": 27 }], 2: [function(r, n, i) {
        var o = this && this.__awaiter || function(s, c, l, f) {
          function d(p) {
            return p instanceof l ? p : new l(function(v) {
              v(p);
            });
          }
          return new (l || (l = Promise))(function(p, v) {
            function h(g) {
              try {
                m(f.next(g));
              } catch (y) {
                v(y);
              }
            }
            function E(g) {
              try {
                m(f.throw(g));
              } catch (y) {
                v(y);
              }
            }
            function m(g) {
              g.done ? p(g.value) : d(g.value).then(h, E);
            }
            m((f = f.apply(s, c || [])).next());
          });
        }, a = this && this.__generator || function(s, c) {
          var l = { label: 0, sent: function() {
            if (p[0] & 1) throw p[1];
            return p[1];
          }, trys: [], ops: [] }, f, d, p, v;
          return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function h(m) {
            return function(g) {
              return E([m, g]);
            };
          }
          function E(m) {
            if (f) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, m[0] && (l = 0)), l; ) try {
              if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
              switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
                case 0:
                case 1:
                  p = m;
                  break;
                case 4:
                  return l.label++, { value: m[1], done: !1 };
                case 5:
                  l.label++, d = m[1], m = [0];
                  continue;
                case 7:
                  m = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
                    l = 0;
                    continue;
                  }
                  if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
                    l.label = m[1];
                    break;
                  }
                  if (m[0] === 6 && l.label < p[1]) {
                    l.label = p[1], p = m;
                    break;
                  }
                  if (p && l.label < p[2]) {
                    l.label = p[2], l.ops.push(m);
                    break;
                  }
                  p[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              m = c.call(s, l);
            } catch (g) {
              m = [6, g], d = 0;
            } finally {
              f = p = 0;
            }
            if (m[0] & 5) throw m[1];
            return { value: m[0] ? m[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.ContentStream = void 0;
        var u = (
          /** @class */
          function() {
            function s(c, l) {
              if (!l)
                throw Error("Null Argument Exception");
              this.id = c, this.assembler = l;
            }
            return Object.defineProperty(s.prototype, "contentType", {
              /**
               * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
               */
              get: function() {
                return this.assembler.payloadType;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(s.prototype, "length", {
              /**
               * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               */
              get: function() {
                return this.assembler.contentLength;
              },
              enumerable: !1,
              configurable: !0
            }), s.prototype.getStream = function() {
              return this.stream || (this.stream = this.assembler.getPayloadStream()), this.stream;
            }, s.prototype.cancel = function() {
              this.assembler.close();
            }, s.prototype.readAsString = function() {
              return o(this, void 0, void 0, function() {
                var c;
                return a(this, function(l) {
                  switch (l.label) {
                    case 0:
                      return [4, this.readAll()];
                    case 1:
                      return c = l.sent().bufferArray, [2, (c || []).map(function(f) {
                        return f.toString("utf8");
                      }).join("")];
                  }
                });
              });
            }, s.prototype.readAsJson = function() {
              return o(this, void 0, void 0, function() {
                var c;
                return a(this, function(l) {
                  switch (l.label) {
                    case 0:
                      return [4, this.readAsString()];
                    case 1:
                      return c = l.sent(), [2, JSON.parse(c)];
                  }
                });
              });
            }, s.prototype.readAll = function() {
              return o(this, void 0, void 0, function() {
                var c, l, f, d, p, v = this;
                return a(this, function(h) {
                  switch (h.label) {
                    case 0:
                      for (c = [], l = 0, f = this.getStream(); l < f.length; )
                        d = f.read(f.length), c.push(d), l += d.length;
                      return l < this.length ? (p = new Promise(function(E) {
                        var m = function(g) {
                          return function(y) {
                            c.push(y), l += y.length, l === g.length && E(!0);
                          };
                        };
                        f.subscribe(m(v));
                      }), [4, p]) : [3, 2];
                    case 1:
                      h.sent(), h.label = 2;
                    case 2:
                      return [2, { bufferArray: c, size: l }];
                  }
                });
              });
            }, s;
          }()
        );
        i.ContentStream = u;
      }, {}], 3: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.CancelDisassembler = void 0;
        var o = (
          /** @class */
          function() {
            function a(u, s, c) {
              this.sender = u, this.id = s, this.payloadType = c;
            }
            return a.prototype.disassemble = function() {
              var u = {
                payloadType: this.payloadType,
                payloadLength: 0,
                id: this.id,
                end: !0
              };
              this.sender.sendPayload(u);
            }, a;
          }()
        );
        i.CancelDisassembler = o;
      }, {}], 4: [function(r, n, i) {
        var o = this && this.__extends || /* @__PURE__ */ function() {
          var f = function(d, p) {
            return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, h) {
              v.__proto__ = h;
            } || function(v, h) {
              for (var E in h) Object.prototype.hasOwnProperty.call(h, E) && (v[E] = h[E]);
            }, f(d, p);
          };
          return function(d, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Class extends value " + String(p) + " is not a constructor or null");
            f(d, p);
            function v() {
              this.constructor = d;
            }
            d.prototype = p === null ? Object.create(p) : (v.prototype = p.prototype, new v());
          };
        }(), a = this && this.__awaiter || function(f, d, p, v) {
          function h(E) {
            return E instanceof p ? E : new p(function(m) {
              m(E);
            });
          }
          return new (p || (p = Promise))(function(E, m) {
            function g(S) {
              try {
                _(v.next(S));
              } catch (A) {
                m(A);
              }
            }
            function y(S) {
              try {
                _(v.throw(S));
              } catch (A) {
                m(A);
              }
            }
            function _(S) {
              S.done ? E(S.value) : h(S.value).then(g, y);
            }
            _((v = v.apply(f, d || [])).next());
          });
        }, u = this && this.__generator || function(f, d) {
          var p = { label: 0, sent: function() {
            if (E[0] & 1) throw E[1];
            return E[1];
          }, trys: [], ops: [] }, v, h, E, m;
          return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function g(_) {
            return function(S) {
              return y([_, S]);
            };
          }
          function y(_) {
            if (v) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, _[0] && (p = 0)), p; ) try {
              if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
              switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
                case 0:
                case 1:
                  E = _;
                  break;
                case 4:
                  return p.label++, { value: _[1], done: !1 };
                case 5:
                  p.label++, h = _[1], _ = [0];
                  continue;
                case 7:
                  _ = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
                    p.label = _[1];
                    break;
                  }
                  if (_[0] === 6 && p.label < E[1]) {
                    p.label = E[1], E = _;
                    break;
                  }
                  if (E && p.label < E[2]) {
                    p.label = E[2], p.ops.push(_);
                    break;
                  }
                  E[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              _ = d.call(f, p);
            } catch (S) {
              _ = [6, S], h = 0;
            } finally {
              v = E = 0;
            }
            if (_[0] & 5) throw _[1];
            return { value: _[0] ? _[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.HttpContentStreamDisassembler = void 0;
        var s = r("./payloadDisassembler"), c = r("../payloads"), l = (
          /** @class */
          function(f) {
            o(d, f);
            function d(p, v) {
              var h = f.call(this, p, v.id) || this;
              return h.payloadType = c.PayloadTypes.stream, h.contentStream = v, h;
            }
            return d.prototype.getStream = function() {
              return a(this, void 0, void 0, function() {
                var p;
                return u(this, function(v) {
                  return p = this.contentStream.content.getStream(), [2, { stream: p, streamLength: p.length }];
                });
              });
            }, d;
          }(s.PayloadDisassembler)
        );
        i.HttpContentStreamDisassembler = l;
      }, { "../payloads": 16, "./payloadDisassembler": 5 }], 5: [function(r, n, i) {
        var o = this && this.__awaiter || function(c, l, f, d) {
          function p(v) {
            return v instanceof f ? v : new f(function(h) {
              h(v);
            });
          }
          return new (f || (f = Promise))(function(v, h) {
            function E(y) {
              try {
                g(d.next(y));
              } catch (_) {
                h(_);
              }
            }
            function m(y) {
              try {
                g(d.throw(y));
              } catch (_) {
                h(_);
              }
            }
            function g(y) {
              y.done ? v(y.value) : p(y.value).then(E, m);
            }
            g((d = d.apply(c, l || [])).next());
          });
        }, a = this && this.__generator || function(c, l) {
          var f = { label: 0, sent: function() {
            if (v[0] & 1) throw v[1];
            return v[1];
          }, trys: [], ops: [] }, d, p, v, h;
          return h = { next: E(0), throw: E(1), return: E(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
            return this;
          }), h;
          function E(g) {
            return function(y) {
              return m([g, y]);
            };
          }
          function m(g) {
            if (d) throw new TypeError("Generator is already executing.");
            for (; h && (h = 0, g[0] && (f = 0)), f; ) try {
              if (d = 1, p && (v = g[0] & 2 ? p.return : g[0] ? p.throw || ((v = p.return) && v.call(p), 0) : p.next) && !(v = v.call(p, g[1])).done) return v;
              switch (p = 0, v && (g = [g[0] & 2, v.value]), g[0]) {
                case 0:
                case 1:
                  v = g;
                  break;
                case 4:
                  return f.label++, { value: g[1], done: !1 };
                case 5:
                  f.label++, p = g[1], g = [0];
                  continue;
                case 7:
                  g = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (v = f.trys, !(v = v.length > 0 && v[v.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (g[0] === 3 && (!v || g[1] > v[0] && g[1] < v[3])) {
                    f.label = g[1];
                    break;
                  }
                  if (g[0] === 6 && f.label < v[1]) {
                    f.label = v[1], v = g;
                    break;
                  }
                  if (v && f.label < v[2]) {
                    f.label = v[2], f.ops.push(g);
                    break;
                  }
                  v[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              g = l.call(c, f);
            } catch (y) {
              g = [6, y], p = 0;
            } finally {
              d = v = 0;
            }
            if (g[0] & 5) throw g[1];
            return { value: g[0] ? g[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadDisassembler = void 0;
        var u = r("../subscribableStream"), s = (
          /** @class */
          function() {
            function c(l, f) {
              this.sender = l, this.id = f;
            }
            return c.serialize = function(l) {
              var f = new u.SubscribableStream();
              return f.write(JSON.stringify(l)), f.end(), { stream: f, streamLength: f.length };
            }, c.prototype.disassemble = function() {
              return o(this, void 0, void 0, function() {
                var l, f, d;
                return a(this, function(p) {
                  switch (p.label) {
                    case 0:
                      return [4, this.getStream()];
                    case 1:
                      return l = p.sent(), f = l.stream, d = l.streamLength, this.stream = f, this.streamLength = d, [2, this.send()];
                  }
                });
              });
            }, c.prototype.send = function() {
              return o(this, void 0, void 0, function() {
                var l;
                return a(this, function(f) {
                  return l = {
                    payloadType: this.payloadType,
                    payloadLength: this.streamLength,
                    id: this.id,
                    end: !0
                  }, this.sender.sendPayload(l, this.stream), [
                    2
                    /*return*/
                  ];
                });
              });
            }, c;
          }()
        );
        i.PayloadDisassembler = s;
      }, { "../subscribableStream": 27 }], 6: [function(r, n, i) {
        var o = this && this.__extends || /* @__PURE__ */ function() {
          var f = function(d, p) {
            return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, h) {
              v.__proto__ = h;
            } || function(v, h) {
              for (var E in h) Object.prototype.hasOwnProperty.call(h, E) && (v[E] = h[E]);
            }, f(d, p);
          };
          return function(d, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Class extends value " + String(p) + " is not a constructor or null");
            f(d, p);
            function v() {
              this.constructor = d;
            }
            d.prototype = p === null ? Object.create(p) : (v.prototype = p.prototype, new v());
          };
        }(), a = this && this.__awaiter || function(f, d, p, v) {
          function h(E) {
            return E instanceof p ? E : new p(function(m) {
              m(E);
            });
          }
          return new (p || (p = Promise))(function(E, m) {
            function g(S) {
              try {
                _(v.next(S));
              } catch (A) {
                m(A);
              }
            }
            function y(S) {
              try {
                _(v.throw(S));
              } catch (A) {
                m(A);
              }
            }
            function _(S) {
              S.done ? E(S.value) : h(S.value).then(g, y);
            }
            _((v = v.apply(f, d || [])).next());
          });
        }, u = this && this.__generator || function(f, d) {
          var p = { label: 0, sent: function() {
            if (E[0] & 1) throw E[1];
            return E[1];
          }, trys: [], ops: [] }, v, h, E, m;
          return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function g(_) {
            return function(S) {
              return y([_, S]);
            };
          }
          function y(_) {
            if (v) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, _[0] && (p = 0)), p; ) try {
              if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
              switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
                case 0:
                case 1:
                  E = _;
                  break;
                case 4:
                  return p.label++, { value: _[1], done: !1 };
                case 5:
                  p.label++, h = _[1], _ = [0];
                  continue;
                case 7:
                  _ = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
                    p.label = _[1];
                    break;
                  }
                  if (_[0] === 6 && p.label < E[1]) {
                    p.label = E[1], E = _;
                    break;
                  }
                  if (E && p.label < E[2]) {
                    p.label = E[2], p.ops.push(_);
                    break;
                  }
                  E[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              _ = d.call(f, p);
            } catch (S) {
              _ = [6, S], h = 0;
            } finally {
              v = E = 0;
            }
            if (_[0] & 5) throw _[1];
            return { value: _[0] ? _[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.RequestDisassembler = void 0;
        var s = r("../payloads/payloadTypes"), c = r("./payloadDisassembler"), l = (
          /** @class */
          function(f) {
            o(d, f);
            function d(p, v, h) {
              var E = f.call(this, p, v) || this;
              return E.request = h, E.payloadType = s.PayloadTypes.request, E;
            }
            return d.prototype.getStream = function() {
              var p, v, h, E;
              return a(this, void 0, void 0, function() {
                var m;
                return u(this, function(g) {
                  return m = { verb: (p = this.request) === null || p === void 0 ? void 0 : p.verb, path: (v = this.request) === null || v === void 0 ? void 0 : v.path, streams: [] }, (E = (h = this.request) === null || h === void 0 ? void 0 : h.streams) === null || E === void 0 || E.forEach(function(y) {
                    m.streams.push(y.description);
                  }), [2, c.PayloadDisassembler.serialize(m)];
                });
              });
            }, d;
          }(c.PayloadDisassembler)
        );
        i.RequestDisassembler = l;
      }, { "../payloads/payloadTypes": 19, "./payloadDisassembler": 5 }], 7: [function(r, n, i) {
        var o = this && this.__extends || /* @__PURE__ */ function() {
          var f = function(d, p) {
            return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, h) {
              v.__proto__ = h;
            } || function(v, h) {
              for (var E in h) Object.prototype.hasOwnProperty.call(h, E) && (v[E] = h[E]);
            }, f(d, p);
          };
          return function(d, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Class extends value " + String(p) + " is not a constructor or null");
            f(d, p);
            function v() {
              this.constructor = d;
            }
            d.prototype = p === null ? Object.create(p) : (v.prototype = p.prototype, new v());
          };
        }(), a = this && this.__awaiter || function(f, d, p, v) {
          function h(E) {
            return E instanceof p ? E : new p(function(m) {
              m(E);
            });
          }
          return new (p || (p = Promise))(function(E, m) {
            function g(S) {
              try {
                _(v.next(S));
              } catch (A) {
                m(A);
              }
            }
            function y(S) {
              try {
                _(v.throw(S));
              } catch (A) {
                m(A);
              }
            }
            function _(S) {
              S.done ? E(S.value) : h(S.value).then(g, y);
            }
            _((v = v.apply(f, d || [])).next());
          });
        }, u = this && this.__generator || function(f, d) {
          var p = { label: 0, sent: function() {
            if (E[0] & 1) throw E[1];
            return E[1];
          }, trys: [], ops: [] }, v, h, E, m;
          return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function g(_) {
            return function(S) {
              return y([_, S]);
            };
          }
          function y(_) {
            if (v) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, _[0] && (p = 0)), p; ) try {
              if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
              switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
                case 0:
                case 1:
                  E = _;
                  break;
                case 4:
                  return p.label++, { value: _[1], done: !1 };
                case 5:
                  p.label++, h = _[1], _ = [0];
                  continue;
                case 7:
                  _ = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
                    p.label = _[1];
                    break;
                  }
                  if (_[0] === 6 && p.label < E[1]) {
                    p.label = E[1], E = _;
                    break;
                  }
                  if (E && p.label < E[2]) {
                    p.label = E[2], p.ops.push(_);
                    break;
                  }
                  E[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              _ = d.call(f, p);
            } catch (S) {
              _ = [6, S], h = 0;
            } finally {
              v = E = 0;
            }
            if (_[0] & 5) throw _[1];
            return { value: _[0] ? _[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.ResponseDisassembler = void 0;
        var s = r("../payloads/payloadTypes"), c = r("./payloadDisassembler"), l = (
          /** @class */
          function(f) {
            o(d, f);
            function d(p, v, h) {
              var E = f.call(this, p, v) || this;
              return E.payloadType = s.PayloadTypes.response, E.response = h, E;
            }
            return d.prototype.getStream = function() {
              var p;
              return a(this, void 0, void 0, function() {
                var v;
                return u(this, function(h) {
                  return v = { statusCode: this.response.statusCode, streams: [] }, (p = this.response.streams) === null || p === void 0 || p.forEach(function(E) {
                    var m = E.description;
                    v.streams.push({
                      id: m.id,
                      contentType: m.type,
                      length: m.length
                    });
                  }), [2, c.PayloadDisassembler.serialize(v)];
                });
              });
            }, d;
          }(c.PayloadDisassembler)
        );
        i.ResponseDisassembler = l;
      }, { "../payloads/payloadTypes": 19, "./payloadDisassembler": 5 }], 8: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.HttpContent = i.HttpContentStream = void 0;
        var o = r("./utilities/protocol-base"), a = (
          /** @class */
          /* @__PURE__ */ function() {
            function s(c) {
              var l, f, d, p, v, h;
              this.content = c, this.id = (0, o.generateGuid)(), this.description = {
                id: this.id,
                type: (d = (f = (l = this.content) === null || l === void 0 ? void 0 : l.headers) === null || f === void 0 ? void 0 : f.type) !== null && d !== void 0 ? d : "unknown",
                length: (h = (v = (p = this.content) === null || p === void 0 ? void 0 : p.headers) === null || v === void 0 ? void 0 : v.contentLength) !== null && h !== void 0 ? h : 0
              };
            }
            return s;
          }()
        );
        i.HttpContentStream = a;
        var u = (
          /** @class */
          function() {
            function s(c, l) {
              this.headers = c, this.stream = l;
            }
            return s.prototype.getStream = function() {
              return this.stream;
            }, s;
          }()
        );
        i.HttpContent = u;
      }, { "./utilities/protocol-base": 28 }], 9: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.WebSocketClient = i.BrowserWebSocket = i.SubscribableStream = i.StreamingResponse = i.StreamingRequest = i.RequestHandler = i.HttpContent = i.ContentStream = void 0;
        var o = r("./contentStream");
        Object.defineProperty(i, "ContentStream", { enumerable: !0, get: function() {
          return o.ContentStream;
        } });
        var a = r("./httpContentStream");
        Object.defineProperty(i, "HttpContent", { enumerable: !0, get: function() {
          return a.HttpContent;
        } });
        var u = r("./requestHandler");
        Object.defineProperty(i, "RequestHandler", { enumerable: !0, get: function() {
          return u.RequestHandler;
        } });
        var s = r("./streamingRequest");
        Object.defineProperty(i, "StreamingRequest", { enumerable: !0, get: function() {
          return s.StreamingRequest;
        } });
        var c = r("./streamingResponse");
        Object.defineProperty(i, "StreamingResponse", { enumerable: !0, get: function() {
          return c.StreamingResponse;
        } });
        var l = r("./subscribableStream");
        Object.defineProperty(i, "SubscribableStream", { enumerable: !0, get: function() {
          return l.SubscribableStream;
        } });
        var f = r("./webSocket/index-browser");
        Object.defineProperty(i, "BrowserWebSocket", { enumerable: !0, get: function() {
          return f.BrowserWebSocket;
        } }), Object.defineProperty(i, "WebSocketClient", { enumerable: !0, get: function() {
          return f.WebSocketClient;
        } });
      }, { "./contentStream": 2, "./httpContentStream": 8, "./requestHandler": 24, "./streamingRequest": 25, "./streamingResponse": 26, "./subscribableStream": 27, "./webSocket/index-browser": 31 }], 10: [function(r, n, i) {
        var o = this && this.__createBinding || (Object.create ? function(u, s, c, l) {
          l === void 0 && (l = c);
          var f = Object.getOwnPropertyDescriptor(s, c);
          (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
            return s[c];
          } }), Object.defineProperty(u, l, f);
        } : function(u, s, c, l) {
          l === void 0 && (l = c), u[l] = s[c];
        }), a = this && this.__exportStar || function(u, s) {
          for (var c in u) c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && o(s, u, c);
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), a(r("./payloadReceiver"), i), a(r("./payloadSender"), i), a(r("./transportDisconnectedEvent"), i), a(r("./transportDisconnectedEventHandler"), i);
      }, { "./payloadReceiver": 11, "./payloadSender": 12, "./transportDisconnectedEvent": 13, "./transportDisconnectedEventHandler": 14 }], 11: [function(r, n, i) {
        var o = this && this.__awaiter || function(d, p, v, h) {
          function E(m) {
            return m instanceof v ? m : new v(function(g) {
              g(m);
            });
          }
          return new (v || (v = Promise))(function(m, g) {
            function y(A) {
              try {
                S(h.next(A));
              } catch (O) {
                g(O);
              }
            }
            function _(A) {
              try {
                S(h.throw(A));
              } catch (O) {
                g(O);
              }
            }
            function S(A) {
              A.done ? m(A.value) : E(A.value).then(y, _);
            }
            S((h = h.apply(d, p || [])).next());
          });
        }, a = this && this.__generator || function(d, p) {
          var v = { label: 0, sent: function() {
            if (m[0] & 1) throw m[1];
            return m[1];
          }, trys: [], ops: [] }, h, E, m, g;
          return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function y(S) {
            return function(A) {
              return _([S, A]);
            };
          }
          function _(S) {
            if (h) throw new TypeError("Generator is already executing.");
            for (; g && (g = 0, S[0] && (v = 0)), v; ) try {
              if (h = 1, E && (m = S[0] & 2 ? E.return : S[0] ? E.throw || ((m = E.return) && m.call(E), 0) : E.next) && !(m = m.call(E, S[1])).done) return m;
              switch (E = 0, m && (S = [S[0] & 2, m.value]), S[0]) {
                case 0:
                case 1:
                  m = S;
                  break;
                case 4:
                  return v.label++, { value: S[1], done: !1 };
                case 5:
                  v.label++, E = S[1], S = [0];
                  continue;
                case 7:
                  S = v.ops.pop(), v.trys.pop();
                  continue;
                default:
                  if (m = v.trys, !(m = m.length > 0 && m[m.length - 1]) && (S[0] === 6 || S[0] === 2)) {
                    v = 0;
                    continue;
                  }
                  if (S[0] === 3 && (!m || S[1] > m[0] && S[1] < m[3])) {
                    v.label = S[1];
                    break;
                  }
                  if (S[0] === 6 && v.label < m[1]) {
                    v.label = m[1], m = S;
                    break;
                  }
                  if (m && v.label < m[2]) {
                    v.label = m[2], v.ops.push(S);
                    break;
                  }
                  m[2] && v.ops.pop(), v.trys.pop();
                  continue;
              }
              S = p.call(d, v);
            } catch (A) {
              S = [6, A], E = 0;
            } finally {
              h = m = 0;
            }
            if (S[0] & 5) throw S[1];
            return { value: S[0] ? S[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadReceiver = void 0;
        var u = r("../payloads/payloadTypes"), s = r("../payloads/headerSerializer"), c = r("../payloads/payloadConstants"), l = r("./transportDisconnectedEvent"), f = (
          /** @class */
          function() {
            function d() {
            }
            return Object.defineProperty(d.prototype, "isConnected", {
              /**
               * Get current connected state
               *
               * @returns true if connected to a transport sender.
               */
              get: function() {
                return this._receiver != null;
              },
              enumerable: !1,
              configurable: !0
            }), d.prototype.connect = function(p) {
              return this._receiver = p, this.receivePackets();
            }, d.prototype.subscribe = function(p, v) {
              this._getStream = p, this._receiveAction = v;
            }, d.prototype.disconnect = function(p) {
              var v, h;
              if (p === void 0 && (p = l.TransportDisconnectedEvent.Empty), !!this.isConnected)
                try {
                  this._receiver.close(), (v = this.disconnected) === null || v === void 0 || v.call(this, this, p);
                } catch (E) {
                  (h = this.disconnected) === null || h === void 0 || h.call(this, this, new l.TransportDisconnectedEvent(E.message));
                } finally {
                  this._receiver = null;
                }
            }, d.prototype.receivePackets = function() {
              return o(this, void 0, void 0, function() {
                var p, v, h, E, m, g, y, _, S;
                return a(this, function(A) {
                  switch (A.label) {
                    case 0:
                      if (!this.isConnected) return [3, 11];
                      A.label = 1;
                    case 1:
                      A.trys.push([1, 9, , 10]), p = 0, A.label = 2;
                    case 2:
                      return p < c.PayloadConstants.MaxHeaderLength ? (v = this, [4, this._receiver.receive(c.PayloadConstants.MaxHeaderLength - p)]) : [3, 4];
                    case 3:
                      return v._receiveHeaderBuffer = A.sent(), this._receiveHeaderBuffer && (p += this._receiveHeaderBuffer.length), [3, 2];
                    case 4:
                      if (h = s.HeaderSerializer.deserialize(this._receiveHeaderBuffer), E = h.payloadType === u.PayloadTypes.stream, !(h.payloadLength > 0)) return [3, 8];
                      m = 0, g = this._getStream(h), A.label = 5;
                    case 5:
                      return m < h.payloadLength && m < c.PayloadConstants.MaxPayloadLength ? (y = Math.min(h.payloadLength - m, c.PayloadConstants.MaxPayloadLength), _ = this, [4, this._receiver.receive(y)]) : [3, 7];
                    case 6:
                      return _._receivePayloadBuffer = A.sent(), m += this._receivePayloadBuffer.byteLength, g.write(this._receivePayloadBuffer), E && this._receiveAction(h, g, m), [3, 5];
                    case 7:
                      E || this._receiveAction(h, g, m), A.label = 8;
                    case 8:
                      return [3, 10];
                    case 9:
                      return S = A.sent(), this.disconnect(new l.TransportDisconnectedEvent(S.message)), [3, 10];
                    case 10:
                      return [3, 0];
                    case 11:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d;
          }()
        );
        i.PayloadReceiver = f;
      }, { "../payloads/headerSerializer": 15, "../payloads/payloadConstants": 18, "../payloads/payloadTypes": 19, "./transportDisconnectedEvent": 13 }], 12: [function(r, n, i) {
        (function(o) {
          (function() {
            Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadSender = void 0;
            var a = r("../payloads/headerSerializer"), u = r("../payloads/payloadConstants"), s = r("./transportDisconnectedEvent"), c = (
              /** @class */
              function() {
                function l() {
                }
                return Object.defineProperty(l.prototype, "isConnected", {
                  /**
                   * Get current connected state
                   *
                   * @returns true if connected to a transport sender.
                   */
                  get: function() {
                    return this._sender != null;
                  },
                  enumerable: !1,
                  configurable: !0
                }), l.prototype.connect = function(f) {
                  this._sender = f;
                }, l.prototype.sendPayload = function(f, d, p) {
                  var v = { header: f, payload: d, sentCallback: p };
                  this.writePacket(v);
                }, l.prototype.disconnect = function(f) {
                  var d, p;
                  if (f === void 0 && (f = s.TransportDisconnectedEvent.Empty), !!this.isConnected)
                    try {
                      this._sender.close(), (d = this.disconnected) === null || d === void 0 || d.call(this, this, f);
                    } catch (v) {
                      (p = this.disconnected) === null || p === void 0 || p.call(this, this, new s.TransportDisconnectedEvent(v.message));
                    } finally {
                      this._sender = null;
                    }
                }, l.prototype.writePacket = function(f) {
                  try {
                    if (f.header.payloadLength > 0 && f.payload) {
                      for (var d = f.header.payloadLength; d > 0; ) {
                        var p = d <= u.PayloadConstants.MaxPayloadLength ? d : u.PayloadConstants.MaxPayloadLength, v = f.payload.read(p), h = f.header;
                        h.payloadLength = p, h.end = d <= u.PayloadConstants.MaxPayloadLength;
                        var E = o.alloc(u.PayloadConstants.MaxHeaderLength);
                        a.HeaderSerializer.serialize(h, E), this._sender.send(E), this._sender.send(v), d -= v.length;
                      }
                      f.sentCallback && f.sentCallback();
                    }
                  } catch (m) {
                    this.disconnect(new s.TransportDisconnectedEvent(m.message));
                  }
                }, l;
              }()
            );
            i.PayloadSender = c;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { "../payloads/headerSerializer": 15, "../payloads/payloadConstants": 18, "./transportDisconnectedEvent": 13, buffer: 35 }], 13: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.TransportDisconnectedEvent = void 0;
        var o = (
          /** @class */
          function() {
            function a(u) {
              this.reason = u;
            }
            return a.Empty = new a(), a;
          }()
        );
        i.TransportDisconnectedEvent = o;
      }, {}], 14: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 });
      }, {}], 15: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.HeaderSerializer = void 0;
        var o = r("./payloadConstants"), a = (
          /** @class */
          function() {
            function u() {
            }
            return u.serialize = function(s, c) {
              c.write(s.payloadType, this.TypeOffset, 1, this.Encoding), c.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding), c.write(this.headerLengthPadder(s.payloadLength, this.LengthLength, "0"), this.LengthOffset, this.LengthLength, this.Encoding), c.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding), c.write(s.id, this.IdOffset), c.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding), c.write(s.end ? this.End : this.NotEnd, this.EndOffset), c.write(this.Terminator, this.TerminatorOffset);
            }, u.deserialize = function(s) {
              var c = s.toString(this.Encoding), l = c.split(this.Delimiter);
              if (l.length !== 4)
                throw Error("Cannot parse header, header is malformed. Header: ".concat(c));
              var f = l[0], d = l[1], p = l[2], v = l[3], h = v === `1
`, E = Number(d), m = { end: h, payloadLength: E, payloadType: f, id: p };
              if (!(m.payloadLength <= o.PayloadConstants.MaxPayloadLength && m.payloadLength >= o.PayloadConstants.MinLength))
                throw Error("Header length of ".concat(m.payloadLength, " is missing or malformed"));
              if (m.payloadType.length !== this.TypeDelimiterOffset)
                throw Error("Header type '".concat(m.payloadType.length, "' is missing or malformed."));
              if (!m.id || !m.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || m.id.length !== this.IdLength)
                throw Error("Header ID '".concat(m.id, "' is missing or malformed."));
              if (!(v === `0
` || v === `1
`))
                throw Error("Header End is missing or not a valid value. Header end: '".concat(v, "'"));
              return m;
            }, u.headerLengthPadder = function(s, c, l) {
              var f = Array(c + 1).join(l), d = s.toString();
              return (f + d).slice(d.length);
            }, u.Delimiter = ".", u.Terminator = `
`, u.End = "1", u.NotEnd = "0", u.TypeOffset = 0, u.TypeDelimiterOffset = 1, u.LengthOffset = 2, u.LengthLength = 6, u.LengthDelimeterOffset = 8, u.IdOffset = 9, u.IdLength = 36, u.IdDelimeterOffset = 45, u.EndOffset = 46, u.TerminatorOffset = 47, u.Encoding = "utf8", u;
          }()
        );
        i.HeaderSerializer = a;
      }, { "./payloadConstants": 18 }], 16: [function(r, n, i) {
        var o = this && this.__createBinding || (Object.create ? function(u, s, c, l) {
          l === void 0 && (l = c);
          var f = Object.getOwnPropertyDescriptor(s, c);
          (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
            return s[c];
          } }), Object.defineProperty(u, l, f);
        } : function(u, s, c, l) {
          l === void 0 && (l = c), u[l] = s[c];
        }), a = this && this.__exportStar || function(u, s) {
          for (var c in u) c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && o(s, u, c);
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), a(r("./headerSerializer"), i), a(r("./streamManager"), i), a(r("./payloadAssemblerManager"), i), a(r("./payloadTypes"), i), a(r("./requestManager"), i), a(r("./sendOperations"), i), a(r("./streamManager"), i);
      }, { "./headerSerializer": 15, "./payloadAssemblerManager": 17, "./payloadTypes": 19, "./requestManager": 20, "./sendOperations": 21, "./streamManager": 22 }], 17: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadAssemblerManager = void 0;
        var o = r("../assemblers/payloadAssembler"), a = r("./payloadTypes"), u = (
          /** @class */
          function() {
            function s(c, l, f) {
              this.streamManager = c, this.onReceiveResponse = l, this.onReceiveRequest = f, this.activeAssemblers = {};
            }
            return s.prototype.getPayloadStream = function(c) {
              if (c.payloadType === a.PayloadTypes.stream)
                return this.streamManager.getPayloadStream(c);
              if (!this.activeAssemblers[c.id]) {
                var l = this.createPayloadAssembler(c);
                if (l)
                  return this.activeAssemblers[c.id] = l, l.getPayloadStream();
              }
            }, s.prototype.onReceive = function(c, l, f) {
              if (c.payloadType === a.PayloadTypes.stream)
                this.streamManager.onReceive(c, l, f);
              else {
                if (this.activeAssemblers && this.activeAssemblers[c.id]) {
                  var d = this.activeAssemblers[c.id];
                  d.onReceive(c, l, f);
                }
                c.end && delete this.activeAssemblers[c.id];
              }
            }, s.prototype.createPayloadAssembler = function(c) {
              if (c.payloadType === a.PayloadTypes.request)
                return new o.PayloadAssembler(this.streamManager, {
                  header: c,
                  onCompleted: this.onReceiveRequest
                });
              if (c.payloadType === a.PayloadTypes.response)
                return new o.PayloadAssembler(this.streamManager, {
                  header: c,
                  onCompleted: this.onReceiveResponse
                });
            }, s;
          }()
        );
        i.PayloadAssemblerManager = u;
      }, { "../assemblers/payloadAssembler": 1, "./payloadTypes": 19 }], 18: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadConstants = void 0, function(o) {
          o[o.MaxPayloadLength = 4096] = "MaxPayloadLength", o[o.MaxHeaderLength = 48] = "MaxHeaderLength", o[o.MaxLength = 999999] = "MaxLength", o[o.MinLength = 0] = "MinLength";
        }(i.PayloadConstants || (i.PayloadConstants = {}));
      }, {}], 19: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.PayloadTypes = void 0, function(o) {
          o.request = "A", o.response = "B", o.stream = "S", o.cancelAll = "X", o.cancelStream = "C";
        }(i.PayloadTypes || (i.PayloadTypes = {}));
      }, {}], 20: [function(r, n, i) {
        var o = this && this.__awaiter || function(c, l, f, d) {
          function p(v) {
            return v instanceof f ? v : new f(function(h) {
              h(v);
            });
          }
          return new (f || (f = Promise))(function(v, h) {
            function E(y) {
              try {
                g(d.next(y));
              } catch (_) {
                h(_);
              }
            }
            function m(y) {
              try {
                g(d.throw(y));
              } catch (_) {
                h(_);
              }
            }
            function g(y) {
              y.done ? v(y.value) : p(y.value).then(E, m);
            }
            g((d = d.apply(c, l || [])).next());
          });
        }, a = this && this.__generator || function(c, l) {
          var f = { label: 0, sent: function() {
            if (v[0] & 1) throw v[1];
            return v[1];
          }, trys: [], ops: [] }, d, p, v, h;
          return h = { next: E(0), throw: E(1), return: E(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
            return this;
          }), h;
          function E(g) {
            return function(y) {
              return m([g, y]);
            };
          }
          function m(g) {
            if (d) throw new TypeError("Generator is already executing.");
            for (; h && (h = 0, g[0] && (f = 0)), f; ) try {
              if (d = 1, p && (v = g[0] & 2 ? p.return : g[0] ? p.throw || ((v = p.return) && v.call(p), 0) : p.next) && !(v = v.call(p, g[1])).done) return v;
              switch (p = 0, v && (g = [g[0] & 2, v.value]), g[0]) {
                case 0:
                case 1:
                  v = g;
                  break;
                case 4:
                  return f.label++, { value: g[1], done: !1 };
                case 5:
                  f.label++, p = g[1], g = [0];
                  continue;
                case 7:
                  g = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (v = f.trys, !(v = v.length > 0 && v[v.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (g[0] === 3 && (!v || g[1] > v[0] && g[1] < v[3])) {
                    f.label = g[1];
                    break;
                  }
                  if (g[0] === 6 && f.label < v[1]) {
                    f.label = v[1], v = g;
                    break;
                  }
                  if (v && f.label < v[2]) {
                    f.label = v[2], f.ops.push(g);
                    break;
                  }
                  v[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              g = l.call(c, f);
            } catch (y) {
              g = [6, y], p = 0;
            } finally {
              d = v = 0;
            }
            if (g[0] & 5) throw g[1];
            return { value: g[0] ? g[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.RequestManager = void 0;
        var u = (
          /** @class */
          /* @__PURE__ */ function() {
            function c() {
            }
            return c;
          }()
        ), s = (
          /** @class */
          function() {
            function c() {
              this._pendingRequests = {};
            }
            return c.prototype.pendingRequestCount = function() {
              return Object.keys(this._pendingRequests).length;
            }, c.prototype.signalResponse = function(l, f) {
              return o(this, void 0, void 0, function() {
                var d;
                return a(this, function(p) {
                  return d = this._pendingRequests[l], d ? (d.resolve(f), delete this._pendingRequests[l], [2, !0]) : [2, !1];
                });
              });
            }, c.prototype.getResponse = function(l) {
              var f = this._pendingRequests[l];
              if (f)
                return Promise.reject("requestId '".concat(l, "' already exists in RequestManager"));
              f = new u(), f.requestId = l;
              var d = new Promise(function(p, v) {
                f.resolve = p, f.reject = v;
              });
              return this._pendingRequests[l] = f, d;
            }, c.prototype.rejectAllResponses = function(l) {
              var f = this;
              Object.entries(this._pendingRequests).forEach(function(d) {
                var p = d[0], v = d[1].reject;
                v(l), delete f._pendingRequests[p];
              });
            }, c;
          }()
        );
        i.RequestManager = s;
      }, {}], 21: [function(r, n, i) {
        var o = this && this.__awaiter || function(p, v, h, E) {
          function m(g) {
            return g instanceof h ? g : new h(function(y) {
              y(g);
            });
          }
          return new (h || (h = Promise))(function(g, y) {
            function _(O) {
              try {
                A(E.next(O));
              } catch (P) {
                y(P);
              }
            }
            function S(O) {
              try {
                A(E.throw(O));
              } catch (P) {
                y(P);
              }
            }
            function A(O) {
              O.done ? g(O.value) : m(O.value).then(_, S);
            }
            A((E = E.apply(p, v || [])).next());
          });
        }, a = this && this.__generator || function(p, v) {
          var h = { label: 0, sent: function() {
            if (g[0] & 1) throw g[1];
            return g[1];
          }, trys: [], ops: [] }, E, m, g, y;
          return y = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
            return this;
          }), y;
          function _(A) {
            return function(O) {
              return S([A, O]);
            };
          }
          function S(A) {
            if (E) throw new TypeError("Generator is already executing.");
            for (; y && (y = 0, A[0] && (h = 0)), h; ) try {
              if (E = 1, m && (g = A[0] & 2 ? m.return : A[0] ? m.throw || ((g = m.return) && g.call(m), 0) : m.next) && !(g = g.call(m, A[1])).done) return g;
              switch (m = 0, g && (A = [A[0] & 2, g.value]), A[0]) {
                case 0:
                case 1:
                  g = A;
                  break;
                case 4:
                  return h.label++, { value: A[1], done: !1 };
                case 5:
                  h.label++, m = A[1], A = [0];
                  continue;
                case 7:
                  A = h.ops.pop(), h.trys.pop();
                  continue;
                default:
                  if (g = h.trys, !(g = g.length > 0 && g[g.length - 1]) && (A[0] === 6 || A[0] === 2)) {
                    h = 0;
                    continue;
                  }
                  if (A[0] === 3 && (!g || A[1] > g[0] && A[1] < g[3])) {
                    h.label = A[1];
                    break;
                  }
                  if (A[0] === 6 && h.label < g[1]) {
                    h.label = g[1], g = A;
                    break;
                  }
                  if (g && h.label < g[2]) {
                    h.label = g[2], h.ops.push(A);
                    break;
                  }
                  g[2] && h.ops.pop(), h.trys.pop();
                  continue;
              }
              A = v.call(p, h);
            } catch (O) {
              A = [6, O], m = 0;
            } finally {
              E = g = 0;
            }
            if (A[0] & 5) throw A[1];
            return { value: A[0] ? A[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.SendOperations = void 0;
        var u = r("../disassemblers/cancelDisassembler"), s = r("../disassemblers/httpContentStreamDisassembler"), c = r("../disassemblers/requestDisassembler"), l = r("../disassemblers/responseDisassembler"), f = r("./payloadTypes"), d = (
          /** @class */
          function() {
            function p(v) {
              this.payloadSender = v;
            }
            return p.prototype.sendRequest = function(v, h) {
              return o(this, void 0, void 0, function() {
                var E, m = this;
                return a(this, function(g) {
                  switch (g.label) {
                    case 0:
                      return E = new c.RequestDisassembler(this.payloadSender, v, h), [4, E.disassemble()];
                    case 1:
                      return g.sent(), h.streams && h.streams.forEach(function(y) {
                        return o(m, void 0, void 0, function() {
                          return a(this, function(_) {
                            switch (_.label) {
                              case 0:
                                return [4, new s.HttpContentStreamDisassembler(this.payloadSender, y).disassemble()];
                              case 1:
                                return _.sent(), [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      }), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, p.prototype.sendResponse = function(v, h) {
              return o(this, void 0, void 0, function() {
                var E, m = this;
                return a(this, function(g) {
                  switch (g.label) {
                    case 0:
                      return E = new l.ResponseDisassembler(this.payloadSender, v, h), [4, E.disassemble()];
                    case 1:
                      return g.sent(), h.streams && h.streams.forEach(function(y) {
                        return o(m, void 0, void 0, function() {
                          return a(this, function(_) {
                            switch (_.label) {
                              case 0:
                                return [4, new s.HttpContentStreamDisassembler(this.payloadSender, y).disassemble()];
                              case 1:
                                return _.sent(), [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      }), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, p.prototype.sendCancelStream = function(v) {
              return o(this, void 0, void 0, function() {
                var h;
                return a(this, function(E) {
                  return h = new u.CancelDisassembler(this.payloadSender, v, f.PayloadTypes.cancelStream), h.disassemble(), [
                    2
                    /*return*/
                  ];
                });
              });
            }, p;
          }()
        );
        i.SendOperations = d;
      }, { "../disassemblers/cancelDisassembler": 3, "../disassemblers/httpContentStreamDisassembler": 4, "../disassemblers/requestDisassembler": 6, "../disassemblers/responseDisassembler": 7, "./payloadTypes": 19 }], 22: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.StreamManager = void 0;
        var o = r("../assemblers/payloadAssembler"), a = (
          /** @class */
          function() {
            function u(s) {
              this.onCancelStream = s, this.activeAssemblers = [];
            }
            return u.prototype.getPayloadAssembler = function(s) {
              if (this.activeAssemblers[s])
                return this.activeAssemblers[s];
              var c = new o.PayloadAssembler(this, { id: s });
              return this.activeAssemblers[s] = c, c;
            }, u.prototype.getPayloadStream = function(s) {
              var c = this.getPayloadAssembler(s.id);
              return c.getPayloadStream();
            }, u.prototype.onReceive = function(s, c, l) {
              this.activeAssemblers[s.id] && this.activeAssemblers[s.id].onReceive(s, c, l);
            }, u.prototype.closeStream = function(s) {
              if (this.activeAssemblers[s]) {
                var c = this.activeAssemblers[s];
                this.activeAssemblers.splice(this.activeAssemblers.indexOf(s), 1);
                var l = c.getPayloadStream();
                (c.contentLength && l.length < c.contentLength || !c.end) && this.onCancelStream(c);
              } else
                return;
            }, u;
          }()
        );
        i.StreamManager = a;
      }, { "../assemblers/payloadAssembler": 1 }], 23: [function(r, n, i) {
        var o = this && this.__awaiter || function(d, p, v, h) {
          function E(m) {
            return m instanceof v ? m : new v(function(g) {
              g(m);
            });
          }
          return new (v || (v = Promise))(function(m, g) {
            function y(A) {
              try {
                S(h.next(A));
              } catch (O) {
                g(O);
              }
            }
            function _(A) {
              try {
                S(h.throw(A));
              } catch (O) {
                g(O);
              }
            }
            function S(A) {
              A.done ? m(A.value) : E(A.value).then(y, _);
            }
            S((h = h.apply(d, p || [])).next());
          });
        }, a = this && this.__generator || function(d, p) {
          var v = { label: 0, sent: function() {
            if (m[0] & 1) throw m[1];
            return m[1];
          }, trys: [], ops: [] }, h, E, m, g;
          return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function y(S) {
            return function(A) {
              return _([S, A]);
            };
          }
          function _(S) {
            if (h) throw new TypeError("Generator is already executing.");
            for (; g && (g = 0, S[0] && (v = 0)), v; ) try {
              if (h = 1, E && (m = S[0] & 2 ? E.return : S[0] ? E.throw || ((m = E.return) && m.call(E), 0) : E.next) && !(m = m.call(E, S[1])).done) return m;
              switch (E = 0, m && (S = [S[0] & 2, m.value]), S[0]) {
                case 0:
                case 1:
                  m = S;
                  break;
                case 4:
                  return v.label++, { value: S[1], done: !1 };
                case 5:
                  v.label++, E = S[1], S = [0];
                  continue;
                case 7:
                  S = v.ops.pop(), v.trys.pop();
                  continue;
                default:
                  if (m = v.trys, !(m = m.length > 0 && m[m.length - 1]) && (S[0] === 6 || S[0] === 2)) {
                    v = 0;
                    continue;
                  }
                  if (S[0] === 3 && (!m || S[1] > m[0] && S[1] < m[3])) {
                    v.label = S[1];
                    break;
                  }
                  if (S[0] === 6 && v.label < m[1]) {
                    v.label = m[1], m = S;
                    break;
                  }
                  if (m && v.label < m[2]) {
                    v.label = m[2], v.ops.push(S);
                    break;
                  }
                  m[2] && v.ops.pop(), v.trys.pop();
                  continue;
              }
              S = p.call(d, v);
            } catch (A) {
              S = [6, A], E = 0;
            } finally {
              h = m = 0;
            }
            if (S[0] & 5) throw S[1];
            return { value: S[0] ? S[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.ProtocolAdapter = void 0;
        var u = r("./payloads/payloadAssemblerManager"), s = r("./payloads/sendOperations"), c = r("./payloads/streamManager"), l = r("./utilities/protocol-base"), f = (
          /** @class */
          function() {
            function d(p, v, h, E) {
              var m = this;
              this.requestHandler = p, this.requestManager = v, this.payloadSender = h, this.payloadReceiver = E, this.sendOperations = new s.SendOperations(this.payloadSender), this.streamManager = new c.StreamManager(this.onCancelStream), this.assemblerManager = new u.PayloadAssemblerManager(this.streamManager, function(g, y) {
                return m.onReceiveResponse(g, y);
              }, function(g, y) {
                return m.onReceiveRequest(g, y);
              }), this.payloadReceiver.subscribe(function(g) {
                return m.assemblerManager.getPayloadStream(g);
              }, function(g, y, _) {
                return m.assemblerManager.onReceive(g, y, _);
              });
            }
            return d.prototype.sendRequest = function(p) {
              return o(this, void 0, void 0, function() {
                var v, h;
                return a(this, function(E) {
                  switch (E.label) {
                    case 0:
                      return v = (0, l.generateGuid)(), h = this.requestManager.getResponse(v), [4, this.sendOperations.sendRequest(v, p)];
                    case 1:
                      return E.sent(), [2, h];
                  }
                });
              });
            }, d.prototype.onReceiveRequest = function(p, v) {
              return o(this, void 0, void 0, function() {
                var h;
                return a(this, function(E) {
                  switch (E.label) {
                    case 0:
                      return this.requestHandler ? [4, this.requestHandler.processRequest(v)] : [3, 3];
                    case 1:
                      return h = E.sent(), h ? [4, this.sendOperations.sendResponse(p, h)] : [3, 3];
                    case 2:
                      E.sent(), E.label = 3;
                    case 3:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d.prototype.onReceiveResponse = function(p, v) {
              return o(this, void 0, void 0, function() {
                return a(this, function(h) {
                  switch (h.label) {
                    case 0:
                      return [4, this.requestManager.signalResponse(p, v)];
                    case 1:
                      return h.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d.prototype.onCancelStream = function(p) {
              this.sendOperations.sendCancelStream(p.id).catch();
            }, d;
          }()
        );
        i.ProtocolAdapter = f;
      }, { "./payloads/payloadAssemblerManager": 17, "./payloads/sendOperations": 21, "./payloads/streamManager": 22, "./utilities/protocol-base": 28 }], 24: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.RequestHandler = void 0;
        var o = (
          /** @class */
          /* @__PURE__ */ function() {
            function a() {
            }
            return a;
          }()
        );
        i.RequestHandler = o;
      }, {}], 25: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.StreamingRequest = void 0;
        var o = r("./httpContentStream"), a = r("./subscribableStream"), u = (
          /** @class */
          function() {
            function s() {
              this.streams = [];
            }
            return s.create = function(c, l, f) {
              var d = new s();
              return d.verb = c, d.path = l, f && d.setBody(f), d;
            }, s.prototype.addStream = function(c) {
              if (!c)
                throw new Error("Argument Undefined Exception: content undefined.");
              this.streams.push(new o.HttpContentStream(c));
            }, s.prototype.setBody = function(c) {
              if (typeof c == "string") {
                var l = new a.SubscribableStream();
                l.write(c, "utf8"), this.addStream(new o.HttpContent({
                  type: "application/json; charset=utf-8",
                  contentLength: l.length
                }, l));
              } else typeof c == "object" && this.addStream(c);
            }, s;
          }()
        );
        i.StreamingRequest = u;
      }, { "./httpContentStream": 8, "./subscribableStream": 27 }], 26: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.StreamingResponse = void 0;
        var o = r("./httpContentStream"), a = r("./subscribableStream"), u = (
          /** @class */
          function() {
            function s() {
              this.streams = [];
            }
            return s.create = function(c, l) {
              var f = new s();
              return f.statusCode = c, l && f.addStream(l), f;
            }, s.prototype.addStream = function(c) {
              this.streams.push(new o.HttpContentStream(c));
            }, s.prototype.setBody = function(c) {
              var l = new a.SubscribableStream();
              l.write(JSON.stringify(c), "utf8"), this.addStream(new o.HttpContent({
                type: "application/json; charset=utf-8",
                contentLength: l.length
              }, l));
            }, s;
          }()
        );
        i.StreamingResponse = u;
      }, { "./httpContentStream": 8, "./subscribableStream": 27 }], 27: [function(r, n, i) {
        (function(o) {
          (function() {
            var a = this && this.__extends || /* @__PURE__ */ function() {
              var c = function(l, f) {
                return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, p) {
                  d.__proto__ = p;
                } || function(d, p) {
                  for (var v in p) Object.prototype.hasOwnProperty.call(p, v) && (d[v] = p[v]);
                }, c(l, f);
              };
              return function(l, f) {
                if (typeof f != "function" && f !== null)
                  throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
                c(l, f);
                function d() {
                  this.constructor = l;
                }
                l.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
              };
            }();
            Object.defineProperty(i, "__esModule", { value: !0 }), i.SubscribableStream = void 0;
            var u = r("stream"), s = (
              /** @class */
              function(c) {
                a(l, c);
                function l(f) {
                  var d = c.call(this, f) || this;
                  return d.length = 0, d.bufferList = [], d;
                }
                return l.prototype._write = function(f, d, p) {
                  var v = o.from(f);
                  this.bufferList.push(v), this.length += f.length, this._onData && this._onData(v), p();
                }, l.prototype._read = function(f) {
                  if (this.bufferList.length === 0)
                    this.push(null);
                  else
                    for (var d = 0; d < f && this.bufferList.length > 0; ) {
                      var p = this.bufferList[0];
                      this.push(p), this.bufferList.splice(0, 1), d += p.length;
                    }
                }, l.prototype.subscribe = function(f) {
                  this._onData = f;
                }, l;
              }(u.Duplex)
            );
            i.SubscribableStream = s;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { buffer: 35, stream: 41 }], 28: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.generateGuid = void 0;
        var o = r("uuid");
        function a() {
          return (0, o.v4)();
        }
        i.generateGuid = a;
      }, { uuid: 58 }], 29: [function(r, n, i) {
        var o = this && this.__awaiter || function(s, c, l, f) {
          function d(p) {
            return p instanceof l ? p : new l(function(v) {
              v(p);
            });
          }
          return new (l || (l = Promise))(function(p, v) {
            function h(g) {
              try {
                m(f.next(g));
              } catch (y) {
                v(y);
              }
            }
            function E(g) {
              try {
                m(f.throw(g));
              } catch (y) {
                v(y);
              }
            }
            function m(g) {
              g.done ? p(g.value) : d(g.value).then(h, E);
            }
            m((f = f.apply(s, c || [])).next());
          });
        }, a = this && this.__generator || function(s, c) {
          var l = { label: 0, sent: function() {
            if (p[0] & 1) throw p[1];
            return p[1];
          }, trys: [], ops: [] }, f, d, p, v;
          return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function h(m) {
            return function(g) {
              return E([m, g]);
            };
          }
          function E(m) {
            if (f) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, m[0] && (l = 0)), l; ) try {
              if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
              switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
                case 0:
                case 1:
                  p = m;
                  break;
                case 4:
                  return l.label++, { value: m[1], done: !1 };
                case 5:
                  l.label++, d = m[1], m = [0];
                  continue;
                case 7:
                  m = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
                    l = 0;
                    continue;
                  }
                  if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
                    l.label = m[1];
                    break;
                  }
                  if (m[0] === 6 && l.label < p[1]) {
                    l.label = p[1], p = m;
                    break;
                  }
                  if (p && l.label < p[2]) {
                    l.label = p[2], l.ops.push(m);
                    break;
                  }
                  p[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              m = c.call(s, l);
            } catch (g) {
              m = [6, g], d = 0;
            } finally {
              f = p = 0;
            }
            if (m[0] & 5) throw m[1];
            return { value: m[0] ? m[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.BrowserWebSocket = void 0;
        var u = (
          /** @class */
          function() {
            function s(c) {
              c && (this.webSocket = c);
            }
            return s.prototype.connect = function(c) {
              return o(this, void 0, void 0, function() {
                var l, f;
                return a(this, function(d) {
                  return this.webSocket || (this.webSocket = new WebSocket(c)), this.webSocket.onerror = function(p) {
                    f(p);
                  }, this.webSocket.onopen = function(p) {
                    l(p);
                  }, [2, new Promise(function(p, v) {
                    l = p, f = v;
                  })];
                });
              });
            }, Object.defineProperty(s.prototype, "isConnected", {
              /**
               * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
               *
               * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
               */
              get: function() {
                return this.webSocket.readyState === 1;
              },
              enumerable: !1,
              configurable: !0
            }), s.prototype.write = function(c) {
              this.webSocket.send(c);
            }, s.prototype.close = function() {
              this.webSocket.close();
            }, s.prototype.setOnMessageHandler = function(c) {
              var l = "buffer", f = [];
              this.webSocket.onmessage = function(d) {
                var p = new FileReader(), v = { buffer: null };
                f.push(v), p.onload = function(h) {
                  var E = h.target;
                  if (v[l] = E.result, f[0] === v)
                    for (; 0 < f.length && f[0][l]; )
                      c(f[0][l]), f.splice(0, 1);
                }, p.readAsArrayBuffer(d.data);
              };
            }, s.prototype.setOnErrorHandler = function(c) {
              this.webSocket.onerror = function(l) {
                l && c(l);
              };
            }, s.prototype.setOnCloseHandler = function(c) {
              this.webSocket.onclose = c;
            }, s;
          }()
        );
        i.BrowserWebSocket = u;
      }, {}], 30: [function(r, n, i) {
        var o = this && this.__awaiter || function(p, v, h, E) {
          function m(g) {
            return g instanceof h ? g : new h(function(y) {
              y(g);
            });
          }
          return new (h || (h = Promise))(function(g, y) {
            function _(O) {
              try {
                A(E.next(O));
              } catch (P) {
                y(P);
              }
            }
            function S(O) {
              try {
                A(E.throw(O));
              } catch (P) {
                y(P);
              }
            }
            function A(O) {
              O.done ? g(O.value) : m(O.value).then(_, S);
            }
            A((E = E.apply(p, v || [])).next());
          });
        }, a = this && this.__generator || function(p, v) {
          var h = { label: 0, sent: function() {
            if (g[0] & 1) throw g[1];
            return g[1];
          }, trys: [], ops: [] }, E, m, g, y;
          return y = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
            return this;
          }), y;
          function _(A) {
            return function(O) {
              return S([A, O]);
            };
          }
          function S(A) {
            if (E) throw new TypeError("Generator is already executing.");
            for (; y && (y = 0, A[0] && (h = 0)), h; ) try {
              if (E = 1, m && (g = A[0] & 2 ? m.return : A[0] ? m.throw || ((g = m.return) && g.call(m), 0) : m.next) && !(g = g.call(m, A[1])).done) return g;
              switch (m = 0, g && (A = [A[0] & 2, g.value]), A[0]) {
                case 0:
                case 1:
                  g = A;
                  break;
                case 4:
                  return h.label++, { value: A[1], done: !1 };
                case 5:
                  h.label++, m = A[1], A = [0];
                  continue;
                case 7:
                  A = h.ops.pop(), h.trys.pop();
                  continue;
                default:
                  if (g = h.trys, !(g = g.length > 0 && g[g.length - 1]) && (A[0] === 6 || A[0] === 2)) {
                    h = 0;
                    continue;
                  }
                  if (A[0] === 3 && (!g || A[1] > g[0] && A[1] < g[3])) {
                    h.label = A[1];
                    break;
                  }
                  if (A[0] === 6 && h.label < g[1]) {
                    h.label = g[1], g = A;
                    break;
                  }
                  if (g && h.label < g[2]) {
                    h.label = g[2], h.ops.push(A);
                    break;
                  }
                  g[2] && h.ops.pop(), h.trys.pop();
                  continue;
              }
              A = v.call(p, h);
            } catch (O) {
              A = [6, O], m = 0;
            } finally {
              E = g = 0;
            }
            if (A[0] & 5) throw A[1];
            return { value: A[0] ? A[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(i, "__esModule", { value: !0 }), i.WebSocketClient = void 0;
        var u = r("./browserWebSocket"), s = r("../payloadTransport"), c = r("../protocolAdapter"), l = r("../payloads"), f = r("./webSocketTransport"), d = (
          /** @class */
          function() {
            function p(v) {
              var h = v.url, E = v.requestHandler, m = v.disconnectionHandler, g = m === void 0 ? null : m;
              this._url = h, this._requestHandler = E, this._disconnectionHandler = g, this._requestManager = new l.RequestManager(), this._sender = new s.PayloadSender(), this._sender.disconnected = this.onConnectionDisconnected.bind(this), this._receiver = new s.PayloadReceiver(), this._receiver.disconnected = this.onConnectionDisconnected.bind(this), this._protocolAdapter = new c.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
            }
            return p.prototype.connect = function() {
              return o(this, void 0, void 0, function() {
                var v, h;
                return a(this, function(E) {
                  switch (E.label) {
                    case 0:
                      return v = new u.BrowserWebSocket(), [4, v.connect(this._url)];
                    case 1:
                      return E.sent(), h = new f.WebSocketTransport(v), this._sender.connect(h), this._receiver.connect(h), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, p.prototype.disconnect = function() {
              this._sender.disconnect(new s.TransportDisconnectedEvent("Disconnect was called.")), this._receiver.disconnect(new s.TransportDisconnectedEvent("Disconnect was called."));
            }, p.prototype.send = function(v) {
              return o(this, void 0, void 0, function() {
                return a(this, function(h) {
                  return [2, this._protocolAdapter.sendRequest(v)];
                });
              });
            }, p.prototype.onConnectionDisconnected = function(v, h) {
              if (this._requestManager.rejectAllResponses(new Error("Disconnect was called.")), this._disconnectionHandler != null) {
                this._disconnectionHandler("Disconnected");
                return;
              }
              throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(v), "'. Args:' ").concat(JSON.stringify(h)));
            }, p;
          }()
        );
        i.WebSocketClient = d;
      }, { "../payloadTransport": 10, "../payloads": 16, "../protocolAdapter": 23, "./browserWebSocket": 29, "./webSocketTransport": 32 }], 31: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.WebSocketTransport = i.WebSocketClient = i.BrowserWebSocket = void 0;
        var o = r("./browserWebSocket");
        Object.defineProperty(i, "BrowserWebSocket", { enumerable: !0, get: function() {
          return o.BrowserWebSocket;
        } });
        var a = r("./browserWebSocketClient");
        Object.defineProperty(i, "WebSocketClient", { enumerable: !0, get: function() {
          return a.WebSocketClient;
        } });
        var u = r("./webSocketTransport");
        Object.defineProperty(i, "WebSocketTransport", { enumerable: !0, get: function() {
          return u.WebSocketTransport;
        } });
      }, { "./browserWebSocket": 29, "./browserWebSocketClient": 30, "./webSocketTransport": 32 }], 32: [function(r, n, i) {
        (function(o) {
          (function() {
            var a = this && this.__awaiter || function(c, l, f, d) {
              function p(v) {
                return v instanceof f ? v : new f(function(h) {
                  h(v);
                });
              }
              return new (f || (f = Promise))(function(v, h) {
                function E(y) {
                  try {
                    g(d.next(y));
                  } catch (_) {
                    h(_);
                  }
                }
                function m(y) {
                  try {
                    g(d.throw(y));
                  } catch (_) {
                    h(_);
                  }
                }
                function g(y) {
                  y.done ? v(y.value) : p(y.value).then(E, m);
                }
                g((d = d.apply(c, l || [])).next());
              });
            }, u = this && this.__generator || function(c, l) {
              var f = { label: 0, sent: function() {
                if (v[0] & 1) throw v[1];
                return v[1];
              }, trys: [], ops: [] }, d, p, v, h;
              return h = { next: E(0), throw: E(1), return: E(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
                return this;
              }), h;
              function E(g) {
                return function(y) {
                  return m([g, y]);
                };
              }
              function m(g) {
                if (d) throw new TypeError("Generator is already executing.");
                for (; h && (h = 0, g[0] && (f = 0)), f; ) try {
                  if (d = 1, p && (v = g[0] & 2 ? p.return : g[0] ? p.throw || ((v = p.return) && v.call(p), 0) : p.next) && !(v = v.call(p, g[1])).done) return v;
                  switch (p = 0, v && (g = [g[0] & 2, v.value]), g[0]) {
                    case 0:
                    case 1:
                      v = g;
                      break;
                    case 4:
                      return f.label++, { value: g[1], done: !1 };
                    case 5:
                      f.label++, p = g[1], g = [0];
                      continue;
                    case 7:
                      g = f.ops.pop(), f.trys.pop();
                      continue;
                    default:
                      if (v = f.trys, !(v = v.length > 0 && v[v.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                        f = 0;
                        continue;
                      }
                      if (g[0] === 3 && (!v || g[1] > v[0] && g[1] < v[3])) {
                        f.label = g[1];
                        break;
                      }
                      if (g[0] === 6 && f.label < v[1]) {
                        f.label = v[1], v = g;
                        break;
                      }
                      if (v && f.label < v[2]) {
                        f.label = v[2], f.ops.push(g);
                        break;
                      }
                      v[2] && f.ops.pop(), f.trys.pop();
                      continue;
                  }
                  g = l.call(c, f);
                } catch (y) {
                  g = [6, y], p = 0;
                } finally {
                  d = v = 0;
                }
                if (g[0] & 5) throw g[1];
                return { value: g[0] ? g[1] : void 0, done: !0 };
              }
            };
            Object.defineProperty(i, "__esModule", { value: !0 }), i.WebSocketTransport = void 0;
            var s = (
              /** @class */
              function() {
                function c(l) {
                  var f = this;
                  this.ws = l, this._queue = [], this._activeOffset = 0, this._activeReceiveCount = 0, this.ws.setOnMessageHandler(function(d) {
                    f.onReceive(d);
                  }), this.ws.setOnErrorHandler(function(d) {
                    f.onError(d);
                  }), this.ws.setOnCloseHandler(function() {
                    f.onClose();
                  });
                }
                return c.prototype.send = function(l) {
                  var f;
                  return !((f = this.ws) === null || f === void 0) && f.isConnected ? (this.ws.write(l), l.length) : 0;
                }, Object.defineProperty(c.prototype, "isConnected", {
                  /**
                   * Returns true if the transport is connected to a socket.
                   *
                   * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
                   */
                  get: function() {
                    var l;
                    return !!(!((l = this.ws) === null || l === void 0) && l.isConnected);
                  },
                  enumerable: !1,
                  configurable: !0
                }), c.prototype.close = function() {
                  var l;
                  !((l = this.ws) === null || l === void 0) && l.isConnected && this.ws.close();
                }, c.prototype.receive = function(l) {
                  return a(this, void 0, void 0, function() {
                    var f, d = this;
                    return u(this, function(p) {
                      if (this._activeReceiveResolve)
                        throw new Error("Cannot call receive more than once before it has returned.");
                      return this._activeReceiveCount = l, f = new Promise(function(v, h) {
                        d._activeReceiveResolve = v, d._activeReceiveReject = h;
                      }), this.trySignalData(), [2, f];
                    });
                  });
                }, c.prototype.onReceive = function(l) {
                  this._queue && l && l.byteLength > 0 && (this._queue.push(o.from(l)), this.trySignalData());
                }, c.prototype.onClose = function() {
                  this._activeReceiveReject && this._activeReceiveReject(new Error("Socket was closed.")), this._active = null, this._activeOffset = 0, this._activeReceiveResolve = null, this._activeReceiveReject = null, this._activeReceiveCount = 0, this.ws = null;
                }, c.prototype.onError = function(l) {
                  this._activeReceiveReject && this._activeReceiveReject(l), this.onClose();
                }, c.prototype.trySignalData = function() {
                  if (this._activeReceiveResolve && (!this._active && this._queue.length > 0 && (this._active = this._queue.shift(), this._activeOffset = 0), this._active)) {
                    if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                      var l = this._active;
                      this._active = null, this._activeReceiveResolve(l);
                    } else {
                      var f = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset), l = o.alloc(f);
                      this._active.copy(l, 0, this._activeOffset, this._activeOffset + f), this._activeOffset += f, this._activeOffset >= this._active.length && (this._active = null, this._activeOffset = 0), this._activeReceiveResolve(l);
                    }
                    this._activeReceiveCount = 0, this._activeReceiveReject = null, this._activeReceiveResolve = null;
                  }
                }, c;
              }()
            );
            i.WebSocketTransport = s;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { buffer: 35 }], 33: [function(r, n, i) {
        i.byteLength = d, i.toByteArray = v, i.fromByteArray = m;
        for (var o = [], a = [], u = typeof Uint8Array < "u" ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, l = s.length; c < l; ++c)
          o[c] = s[c], a[s.charCodeAt(c)] = c;
        a[45] = 62, a[95] = 63;
        function f(g) {
          var y = g.length;
          if (y % 4 > 0)
            throw new Error("Invalid string. Length must be a multiple of 4");
          var _ = g.indexOf("=");
          _ === -1 && (_ = y);
          var S = _ === y ? 0 : 4 - _ % 4;
          return [_, S];
        }
        function d(g) {
          var y = f(g), _ = y[0], S = y[1];
          return (_ + S) * 3 / 4 - S;
        }
        function p(g, y, _) {
          return (y + _) * 3 / 4 - _;
        }
        function v(g) {
          var y, _ = f(g), S = _[0], A = _[1], O = new u(p(g, S, A)), P = 0, U = A > 0 ? S - 4 : S, z;
          for (z = 0; z < U; z += 4)
            y = a[g.charCodeAt(z)] << 18 | a[g.charCodeAt(z + 1)] << 12 | a[g.charCodeAt(z + 2)] << 6 | a[g.charCodeAt(z + 3)], O[P++] = y >> 16 & 255, O[P++] = y >> 8 & 255, O[P++] = y & 255;
          return A === 2 && (y = a[g.charCodeAt(z)] << 2 | a[g.charCodeAt(z + 1)] >> 4, O[P++] = y & 255), A === 1 && (y = a[g.charCodeAt(z)] << 10 | a[g.charCodeAt(z + 1)] << 4 | a[g.charCodeAt(z + 2)] >> 2, O[P++] = y >> 8 & 255, O[P++] = y & 255), O;
        }
        function h(g) {
          return o[g >> 18 & 63] + o[g >> 12 & 63] + o[g >> 6 & 63] + o[g & 63];
        }
        function E(g, y, _) {
          for (var S, A = [], O = y; O < _; O += 3)
            S = (g[O] << 16 & 16711680) + (g[O + 1] << 8 & 65280) + (g[O + 2] & 255), A.push(h(S));
          return A.join("");
        }
        function m(g) {
          for (var y, _ = g.length, S = _ % 3, A = [], O = 16383, P = 0, U = _ - S; P < U; P += O)
            A.push(E(
              g,
              P,
              P + O > U ? U : P + O
            ));
          return S === 1 ? (y = g[_ - 1], A.push(
            o[y >> 2] + o[y << 4 & 63] + "=="
          )) : S === 2 && (y = (g[_ - 2] << 8) + g[_ - 1], A.push(
            o[y >> 10] + o[y >> 4 & 63] + o[y << 2 & 63] + "="
          )), A.join("");
        }
      }, {}], 34: [function(r, n, i) {
      }, {}], 35: [function(r, n, i) {
        (function(o) {
          (function() {
            var a = r("base64-js"), u = r("ieee754");
            i.Buffer = f, i.SlowBuffer = S, i.INSPECT_MAX_BYTES = 50;
            var s = 2147483647;
            i.kMaxLength = s, f.TYPED_ARRAY_SUPPORT = c(), !f.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
              "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
            );
            function c() {
              try {
                var Ee = new Uint8Array(1);
                return Ee.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                  return 42;
                } }, Ee.foo() === 42;
              } catch {
                return !1;
              }
            }
            Object.defineProperty(f.prototype, "parent", {
              enumerable: !0,
              get: function() {
                if (f.isBuffer(this))
                  return this.buffer;
              }
            }), Object.defineProperty(f.prototype, "offset", {
              enumerable: !0,
              get: function() {
                if (f.isBuffer(this))
                  return this.byteOffset;
              }
            });
            function l(Ee) {
              if (Ee > s)
                throw new RangeError('The value "' + Ee + '" is invalid for option "size"');
              var te = new Uint8Array(Ee);
              return te.__proto__ = f.prototype, te;
            }
            function f(Ee, te, ue) {
              if (typeof Ee == "number") {
                if (typeof te == "string")
                  throw new TypeError(
                    'The "string" argument must be of type string. Received type number'
                  );
                return h(Ee);
              }
              return d(Ee, te, ue);
            }
            typeof Symbol < "u" && Symbol.species != null && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
              value: null,
              configurable: !0,
              enumerable: !1,
              writable: !1
            }), f.poolSize = 8192;
            function d(Ee, te, ue) {
              if (typeof Ee == "string")
                return E(Ee, te);
              if (ArrayBuffer.isView(Ee))
                return m(Ee);
              if (Ee == null)
                throw TypeError(
                  "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ee
                );
              if (we(Ee, ArrayBuffer) || Ee && we(Ee.buffer, ArrayBuffer))
                return g(Ee, te, ue);
              if (typeof Ee == "number")
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type number'
                );
              var ye = Ee.valueOf && Ee.valueOf();
              if (ye != null && ye !== Ee)
                return f.from(ye, te, ue);
              var Le = y(Ee);
              if (Le) return Le;
              if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Ee[Symbol.toPrimitive] == "function")
                return f.from(
                  Ee[Symbol.toPrimitive]("string"),
                  te,
                  ue
                );
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ee
              );
            }
            f.from = function(Ee, te, ue) {
              return d(Ee, te, ue);
            }, f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array;
            function p(Ee) {
              if (typeof Ee != "number")
                throw new TypeError('"size" argument must be of type number');
              if (Ee < 0)
                throw new RangeError('The value "' + Ee + '" is invalid for option "size"');
            }
            function v(Ee, te, ue) {
              return p(Ee), Ee <= 0 ? l(Ee) : te !== void 0 ? typeof ue == "string" ? l(Ee).fill(te, ue) : l(Ee).fill(te) : l(Ee);
            }
            f.alloc = function(Ee, te, ue) {
              return v(Ee, te, ue);
            };
            function h(Ee) {
              return p(Ee), l(Ee < 0 ? 0 : _(Ee) | 0);
            }
            f.allocUnsafe = function(Ee) {
              return h(Ee);
            }, f.allocUnsafeSlow = function(Ee) {
              return h(Ee);
            };
            function E(Ee, te) {
              if ((typeof te != "string" || te === "") && (te = "utf8"), !f.isEncoding(te))
                throw new TypeError("Unknown encoding: " + te);
              var ue = A(Ee, te) | 0, ye = l(ue), Le = ye.write(Ee, te);
              return Le !== ue && (ye = ye.slice(0, Le)), ye;
            }
            function m(Ee) {
              for (var te = Ee.length < 0 ? 0 : _(Ee.length) | 0, ue = l(te), ye = 0; ye < te; ye += 1)
                ue[ye] = Ee[ye] & 255;
              return ue;
            }
            function g(Ee, te, ue) {
              if (te < 0 || Ee.byteLength < te)
                throw new RangeError('"offset" is outside of buffer bounds');
              if (Ee.byteLength < te + (ue || 0))
                throw new RangeError('"length" is outside of buffer bounds');
              var ye;
              return te === void 0 && ue === void 0 ? ye = new Uint8Array(Ee) : ue === void 0 ? ye = new Uint8Array(Ee, te) : ye = new Uint8Array(Ee, te, ue), ye.__proto__ = f.prototype, ye;
            }
            function y(Ee) {
              if (f.isBuffer(Ee)) {
                var te = _(Ee.length) | 0, ue = l(te);
                return ue.length === 0 || Ee.copy(ue, 0, 0, te), ue;
              }
              if (Ee.length !== void 0)
                return typeof Ee.length != "number" || De(Ee.length) ? l(0) : m(Ee);
              if (Ee.type === "Buffer" && Array.isArray(Ee.data))
                return m(Ee.data);
            }
            function _(Ee) {
              if (Ee >= s)
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
              return Ee | 0;
            }
            function S(Ee) {
              return +Ee != Ee && (Ee = 0), f.alloc(+Ee);
            }
            f.isBuffer = function(te) {
              return te != null && te._isBuffer === !0 && te !== f.prototype;
            }, f.compare = function(te, ue) {
              if (we(te, Uint8Array) && (te = f.from(te, te.offset, te.byteLength)), we(ue, Uint8Array) && (ue = f.from(ue, ue.offset, ue.byteLength)), !f.isBuffer(te) || !f.isBuffer(ue))
                throw new TypeError(
                  'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                );
              if (te === ue) return 0;
              for (var ye = te.length, Le = ue.length, Me = 0, Ae = Math.min(ye, Le); Me < Ae; ++Me)
                if (te[Me] !== ue[Me]) {
                  ye = te[Me], Le = ue[Me];
                  break;
                }
              return ye < Le ? -1 : Le < ye ? 1 : 0;
            }, f.isEncoding = function(te) {
              switch (String(te).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;
                default:
                  return !1;
              }
            }, f.concat = function(te, ue) {
              if (!Array.isArray(te))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (te.length === 0)
                return f.alloc(0);
              var ye;
              if (ue === void 0)
                for (ue = 0, ye = 0; ye < te.length; ++ye)
                  ue += te[ye].length;
              var Le = f.allocUnsafe(ue), Me = 0;
              for (ye = 0; ye < te.length; ++ye) {
                var Ae = te[ye];
                if (we(Ae, Uint8Array) && (Ae = f.from(Ae)), !f.isBuffer(Ae))
                  throw new TypeError('"list" argument must be an Array of Buffers');
                Ae.copy(Le, Me), Me += Ae.length;
              }
              return Le;
            };
            function A(Ee, te) {
              if (f.isBuffer(Ee))
                return Ee.length;
              if (ArrayBuffer.isView(Ee) || we(Ee, ArrayBuffer))
                return Ee.byteLength;
              if (typeof Ee != "string")
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Ee
                );
              var ue = Ee.length, ye = arguments.length > 2 && arguments[2] === !0;
              if (!ye && ue === 0) return 0;
              for (var Le = !1; ; )
                switch (te) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return ue;
                  case "utf8":
                  case "utf-8":
                    return Ne(Ee).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return ue * 2;
                  case "hex":
                    return ue >>> 1;
                  case "base64":
                    return St(Ee).length;
                  default:
                    if (Le)
                      return ye ? -1 : Ne(Ee).length;
                    te = ("" + te).toLowerCase(), Le = !0;
                }
            }
            f.byteLength = A;
            function O(Ee, te, ue) {
              var ye = !1;
              if ((te === void 0 || te < 0) && (te = 0), te > this.length || ((ue === void 0 || ue > this.length) && (ue = this.length), ue <= 0) || (ue >>>= 0, te >>>= 0, ue <= te))
                return "";
              for (Ee || (Ee = "utf8"); ; )
                switch (Ee) {
                  case "hex":
                    return ne(this, te, ue);
                  case "utf8":
                  case "utf-8":
                    return X(this, te, ue);
                  case "ascii":
                    return le(this, te, ue);
                  case "latin1":
                  case "binary":
                    return ae(this, te, ue);
                  case "base64":
                    return $(this, te, ue);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return ve(this, te, ue);
                  default:
                    if (ye) throw new TypeError("Unknown encoding: " + Ee);
                    Ee = (Ee + "").toLowerCase(), ye = !0;
                }
            }
            f.prototype._isBuffer = !0;
            function P(Ee, te, ue) {
              var ye = Ee[te];
              Ee[te] = Ee[ue], Ee[ue] = ye;
            }
            f.prototype.swap16 = function() {
              var te = this.length;
              if (te % 2 !== 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (var ue = 0; ue < te; ue += 2)
                P(this, ue, ue + 1);
              return this;
            }, f.prototype.swap32 = function() {
              var te = this.length;
              if (te % 4 !== 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (var ue = 0; ue < te; ue += 4)
                P(this, ue, ue + 3), P(this, ue + 1, ue + 2);
              return this;
            }, f.prototype.swap64 = function() {
              var te = this.length;
              if (te % 8 !== 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (var ue = 0; ue < te; ue += 8)
                P(this, ue, ue + 7), P(this, ue + 1, ue + 6), P(this, ue + 2, ue + 5), P(this, ue + 3, ue + 4);
              return this;
            }, f.prototype.toString = function() {
              var te = this.length;
              return te === 0 ? "" : arguments.length === 0 ? X(this, 0, te) : O.apply(this, arguments);
            }, f.prototype.toLocaleString = f.prototype.toString, f.prototype.equals = function(te) {
              if (!f.isBuffer(te)) throw new TypeError("Argument must be a Buffer");
              return this === te ? !0 : f.compare(this, te) === 0;
            }, f.prototype.inspect = function() {
              var te = "", ue = i.INSPECT_MAX_BYTES;
              return te = this.toString("hex", 0, ue).replace(/(.{2})/g, "$1 ").trim(), this.length > ue && (te += " ... "), "<Buffer " + te + ">";
            }, f.prototype.compare = function(te, ue, ye, Le, Me) {
              if (we(te, Uint8Array) && (te = f.from(te, te.offset, te.byteLength)), !f.isBuffer(te))
                throw new TypeError(
                  'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof te
                );
              if (ue === void 0 && (ue = 0), ye === void 0 && (ye = te ? te.length : 0), Le === void 0 && (Le = 0), Me === void 0 && (Me = this.length), ue < 0 || ye > te.length || Le < 0 || Me > this.length)
                throw new RangeError("out of range index");
              if (Le >= Me && ue >= ye)
                return 0;
              if (Le >= Me)
                return -1;
              if (ue >= ye)
                return 1;
              if (ue >>>= 0, ye >>>= 0, Le >>>= 0, Me >>>= 0, this === te) return 0;
              for (var Ae = Me - Le, ie = ye - ue, K = Math.min(Ae, ie), Z = this.slice(Le, Me), Ce = te.slice(ue, ye), be = 0; be < K; ++be)
                if (Z[be] !== Ce[be]) {
                  Ae = Z[be], ie = Ce[be];
                  break;
                }
              return Ae < ie ? -1 : ie < Ae ? 1 : 0;
            };
            function U(Ee, te, ue, ye, Le) {
              if (Ee.length === 0) return -1;
              if (typeof ue == "string" ? (ye = ue, ue = 0) : ue > 2147483647 ? ue = 2147483647 : ue < -2147483648 && (ue = -2147483648), ue = +ue, De(ue) && (ue = Le ? 0 : Ee.length - 1), ue < 0 && (ue = Ee.length + ue), ue >= Ee.length) {
                if (Le) return -1;
                ue = Ee.length - 1;
              } else if (ue < 0)
                if (Le) ue = 0;
                else return -1;
              if (typeof te == "string" && (te = f.from(te, ye)), f.isBuffer(te))
                return te.length === 0 ? -1 : z(Ee, te, ue, ye, Le);
              if (typeof te == "number")
                return te = te & 255, typeof Uint8Array.prototype.indexOf == "function" ? Le ? Uint8Array.prototype.indexOf.call(Ee, te, ue) : Uint8Array.prototype.lastIndexOf.call(Ee, te, ue) : z(Ee, [te], ue, ye, Le);
              throw new TypeError("val must be string, number or Buffer");
            }
            function z(Ee, te, ue, ye, Le) {
              var Me = 1, Ae = Ee.length, ie = te.length;
              if (ye !== void 0 && (ye = String(ye).toLowerCase(), ye === "ucs2" || ye === "ucs-2" || ye === "utf16le" || ye === "utf-16le")) {
                if (Ee.length < 2 || te.length < 2)
                  return -1;
                Me = 2, Ae /= 2, ie /= 2, ue /= 2;
              }
              function K(st, wt) {
                return Me === 1 ? st[wt] : st.readUInt16BE(wt * Me);
              }
              var Z;
              if (Le) {
                var Ce = -1;
                for (Z = ue; Z < Ae; Z++)
                  if (K(Ee, Z) === K(te, Ce === -1 ? 0 : Z - Ce)) {
                    if (Ce === -1 && (Ce = Z), Z - Ce + 1 === ie) return Ce * Me;
                  } else
                    Ce !== -1 && (Z -= Z - Ce), Ce = -1;
              } else
                for (ue + ie > Ae && (ue = Ae - ie), Z = ue; Z >= 0; Z--) {
                  for (var be = !0, Ge = 0; Ge < ie; Ge++)
                    if (K(Ee, Z + Ge) !== K(te, Ge)) {
                      be = !1;
                      break;
                    }
                  if (be) return Z;
                }
              return -1;
            }
            f.prototype.includes = function(te, ue, ye) {
              return this.indexOf(te, ue, ye) !== -1;
            }, f.prototype.indexOf = function(te, ue, ye) {
              return U(this, te, ue, ye, !0);
            }, f.prototype.lastIndexOf = function(te, ue, ye) {
              return U(this, te, ue, ye, !1);
            };
            function k(Ee, te, ue, ye) {
              ue = Number(ue) || 0;
              var Le = Ee.length - ue;
              ye ? (ye = Number(ye), ye > Le && (ye = Le)) : ye = Le;
              var Me = te.length;
              ye > Me / 2 && (ye = Me / 2);
              for (var Ae = 0; Ae < ye; ++Ae) {
                var ie = parseInt(te.substr(Ae * 2, 2), 16);
                if (De(ie)) return Ae;
                Ee[ue + Ae] = ie;
              }
              return Ae;
            }
            function H(Ee, te, ue, ye) {
              return Ot(Ne(te, Ee.length - ue), Ee, ue, ye);
            }
            function B(Ee, te, ue, ye) {
              return Ot(je(te), Ee, ue, ye);
            }
            function x(Ee, te, ue, ye) {
              return B(Ee, te, ue, ye);
            }
            function D(Ee, te, ue, ye) {
              return Ot(St(te), Ee, ue, ye);
            }
            function w(Ee, te, ue, ye) {
              return Ot(et(te, Ee.length - ue), Ee, ue, ye);
            }
            f.prototype.write = function(te, ue, ye, Le) {
              if (ue === void 0)
                Le = "utf8", ye = this.length, ue = 0;
              else if (ye === void 0 && typeof ue == "string")
                Le = ue, ye = this.length, ue = 0;
              else if (isFinite(ue))
                ue = ue >>> 0, isFinite(ye) ? (ye = ye >>> 0, Le === void 0 && (Le = "utf8")) : (Le = ye, ye = void 0);
              else
                throw new Error(
                  "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                );
              var Me = this.length - ue;
              if ((ye === void 0 || ye > Me) && (ye = Me), te.length > 0 && (ye < 0 || ue < 0) || ue > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              Le || (Le = "utf8");
              for (var Ae = !1; ; )
                switch (Le) {
                  case "hex":
                    return k(this, te, ue, ye);
                  case "utf8":
                  case "utf-8":
                    return H(this, te, ue, ye);
                  case "ascii":
                    return B(this, te, ue, ye);
                  case "latin1":
                  case "binary":
                    return x(this, te, ue, ye);
                  case "base64":
                    return D(this, te, ue, ye);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return w(this, te, ue, ye);
                  default:
                    if (Ae) throw new TypeError("Unknown encoding: " + Le);
                    Le = ("" + Le).toLowerCase(), Ae = !0;
                }
            }, f.prototype.toJSON = function() {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            function $(Ee, te, ue) {
              return te === 0 && ue === Ee.length ? a.fromByteArray(Ee) : a.fromByteArray(Ee.slice(te, ue));
            }
            function X(Ee, te, ue) {
              ue = Math.min(Ee.length, ue);
              for (var ye = [], Le = te; Le < ue; ) {
                var Me = Ee[Le], Ae = null, ie = Me > 239 ? 4 : Me > 223 ? 3 : Me > 191 ? 2 : 1;
                if (Le + ie <= ue) {
                  var K, Z, Ce, be;
                  switch (ie) {
                    case 1:
                      Me < 128 && (Ae = Me);
                      break;
                    case 2:
                      K = Ee[Le + 1], (K & 192) === 128 && (be = (Me & 31) << 6 | K & 63, be > 127 && (Ae = be));
                      break;
                    case 3:
                      K = Ee[Le + 1], Z = Ee[Le + 2], (K & 192) === 128 && (Z & 192) === 128 && (be = (Me & 15) << 12 | (K & 63) << 6 | Z & 63, be > 2047 && (be < 55296 || be > 57343) && (Ae = be));
                      break;
                    case 4:
                      K = Ee[Le + 1], Z = Ee[Le + 2], Ce = Ee[Le + 3], (K & 192) === 128 && (Z & 192) === 128 && (Ce & 192) === 128 && (be = (Me & 15) << 18 | (K & 63) << 12 | (Z & 63) << 6 | Ce & 63, be > 65535 && be < 1114112 && (Ae = be));
                  }
                }
                Ae === null ? (Ae = 65533, ie = 1) : Ae > 65535 && (Ae -= 65536, ye.push(Ae >>> 10 & 1023 | 55296), Ae = 56320 | Ae & 1023), ye.push(Ae), Le += ie;
              }
              return F(ye);
            }
            var V = 4096;
            function F(Ee) {
              var te = Ee.length;
              if (te <= V)
                return String.fromCharCode.apply(String, Ee);
              for (var ue = "", ye = 0; ye < te; )
                ue += String.fromCharCode.apply(
                  String,
                  Ee.slice(ye, ye += V)
                );
              return ue;
            }
            function le(Ee, te, ue) {
              var ye = "";
              ue = Math.min(Ee.length, ue);
              for (var Le = te; Le < ue; ++Le)
                ye += String.fromCharCode(Ee[Le] & 127);
              return ye;
            }
            function ae(Ee, te, ue) {
              var ye = "";
              ue = Math.min(Ee.length, ue);
              for (var Le = te; Le < ue; ++Le)
                ye += String.fromCharCode(Ee[Le]);
              return ye;
            }
            function ne(Ee, te, ue) {
              var ye = Ee.length;
              (!te || te < 0) && (te = 0), (!ue || ue < 0 || ue > ye) && (ue = ye);
              for (var Le = "", Me = te; Me < ue; ++Me)
                Le += We(Ee[Me]);
              return Le;
            }
            function ve(Ee, te, ue) {
              for (var ye = Ee.slice(te, ue), Le = "", Me = 0; Me < ye.length; Me += 2)
                Le += String.fromCharCode(ye[Me] + ye[Me + 1] * 256);
              return Le;
            }
            f.prototype.slice = function(te, ue) {
              var ye = this.length;
              te = ~~te, ue = ue === void 0 ? ye : ~~ue, te < 0 ? (te += ye, te < 0 && (te = 0)) : te > ye && (te = ye), ue < 0 ? (ue += ye, ue < 0 && (ue = 0)) : ue > ye && (ue = ye), ue < te && (ue = te);
              var Le = this.subarray(te, ue);
              return Le.__proto__ = f.prototype, Le;
            };
            function Ie(Ee, te, ue) {
              if (Ee % 1 !== 0 || Ee < 0) throw new RangeError("offset is not uint");
              if (Ee + te > ue) throw new RangeError("Trying to access beyond buffer length");
            }
            f.prototype.readUIntLE = function(te, ue, ye) {
              te = te >>> 0, ue = ue >>> 0, ye || Ie(te, ue, this.length);
              for (var Le = this[te], Me = 1, Ae = 0; ++Ae < ue && (Me *= 256); )
                Le += this[te + Ae] * Me;
              return Le;
            }, f.prototype.readUIntBE = function(te, ue, ye) {
              te = te >>> 0, ue = ue >>> 0, ye || Ie(te, ue, this.length);
              for (var Le = this[te + --ue], Me = 1; ue > 0 && (Me *= 256); )
                Le += this[te + --ue] * Me;
              return Le;
            }, f.prototype.readUInt8 = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 1, this.length), this[te];
            }, f.prototype.readUInt16LE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 2, this.length), this[te] | this[te + 1] << 8;
            }, f.prototype.readUInt16BE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 2, this.length), this[te] << 8 | this[te + 1];
            }, f.prototype.readUInt32LE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), (this[te] | this[te + 1] << 8 | this[te + 2] << 16) + this[te + 3] * 16777216;
            }, f.prototype.readUInt32BE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), this[te] * 16777216 + (this[te + 1] << 16 | this[te + 2] << 8 | this[te + 3]);
            }, f.prototype.readIntLE = function(te, ue, ye) {
              te = te >>> 0, ue = ue >>> 0, ye || Ie(te, ue, this.length);
              for (var Le = this[te], Me = 1, Ae = 0; ++Ae < ue && (Me *= 256); )
                Le += this[te + Ae] * Me;
              return Me *= 128, Le >= Me && (Le -= Math.pow(2, 8 * ue)), Le;
            }, f.prototype.readIntBE = function(te, ue, ye) {
              te = te >>> 0, ue = ue >>> 0, ye || Ie(te, ue, this.length);
              for (var Le = ue, Me = 1, Ae = this[te + --Le]; Le > 0 && (Me *= 256); )
                Ae += this[te + --Le] * Me;
              return Me *= 128, Ae >= Me && (Ae -= Math.pow(2, 8 * ue)), Ae;
            }, f.prototype.readInt8 = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 1, this.length), this[te] & 128 ? (255 - this[te] + 1) * -1 : this[te];
            }, f.prototype.readInt16LE = function(te, ue) {
              te = te >>> 0, ue || Ie(te, 2, this.length);
              var ye = this[te] | this[te + 1] << 8;
              return ye & 32768 ? ye | 4294901760 : ye;
            }, f.prototype.readInt16BE = function(te, ue) {
              te = te >>> 0, ue || Ie(te, 2, this.length);
              var ye = this[te + 1] | this[te] << 8;
              return ye & 32768 ? ye | 4294901760 : ye;
            }, f.prototype.readInt32LE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), this[te] | this[te + 1] << 8 | this[te + 2] << 16 | this[te + 3] << 24;
            }, f.prototype.readInt32BE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), this[te] << 24 | this[te + 1] << 16 | this[te + 2] << 8 | this[te + 3];
            }, f.prototype.readFloatLE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), u.read(this, te, !0, 23, 4);
            }, f.prototype.readFloatBE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 4, this.length), u.read(this, te, !1, 23, 4);
            }, f.prototype.readDoubleLE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 8, this.length), u.read(this, te, !0, 52, 8);
            }, f.prototype.readDoubleBE = function(te, ue) {
              return te = te >>> 0, ue || Ie(te, 8, this.length), u.read(this, te, !1, 52, 8);
            };
            function Oe(Ee, te, ue, ye, Le, Me) {
              if (!f.isBuffer(Ee)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (te > Le || te < Me) throw new RangeError('"value" argument is out of bounds');
              if (ue + ye > Ee.length) throw new RangeError("Index out of range");
            }
            f.prototype.writeUIntLE = function(te, ue, ye, Le) {
              if (te = +te, ue = ue >>> 0, ye = ye >>> 0, !Le) {
                var Me = Math.pow(2, 8 * ye) - 1;
                Oe(this, te, ue, ye, Me, 0);
              }
              var Ae = 1, ie = 0;
              for (this[ue] = te & 255; ++ie < ye && (Ae *= 256); )
                this[ue + ie] = te / Ae & 255;
              return ue + ye;
            }, f.prototype.writeUIntBE = function(te, ue, ye, Le) {
              if (te = +te, ue = ue >>> 0, ye = ye >>> 0, !Le) {
                var Me = Math.pow(2, 8 * ye) - 1;
                Oe(this, te, ue, ye, Me, 0);
              }
              var Ae = ye - 1, ie = 1;
              for (this[ue + Ae] = te & 255; --Ae >= 0 && (ie *= 256); )
                this[ue + Ae] = te / ie & 255;
              return ue + ye;
            }, f.prototype.writeUInt8 = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 1, 255, 0), this[ue] = te & 255, ue + 1;
            }, f.prototype.writeUInt16LE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 2, 65535, 0), this[ue] = te & 255, this[ue + 1] = te >>> 8, ue + 2;
            }, f.prototype.writeUInt16BE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 2, 65535, 0), this[ue] = te >>> 8, this[ue + 1] = te & 255, ue + 2;
            }, f.prototype.writeUInt32LE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 4, 4294967295, 0), this[ue + 3] = te >>> 24, this[ue + 2] = te >>> 16, this[ue + 1] = te >>> 8, this[ue] = te & 255, ue + 4;
            }, f.prototype.writeUInt32BE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 4, 4294967295, 0), this[ue] = te >>> 24, this[ue + 1] = te >>> 16, this[ue + 2] = te >>> 8, this[ue + 3] = te & 255, ue + 4;
            }, f.prototype.writeIntLE = function(te, ue, ye, Le) {
              if (te = +te, ue = ue >>> 0, !Le) {
                var Me = Math.pow(2, 8 * ye - 1);
                Oe(this, te, ue, ye, Me - 1, -Me);
              }
              var Ae = 0, ie = 1, K = 0;
              for (this[ue] = te & 255; ++Ae < ye && (ie *= 256); )
                te < 0 && K === 0 && this[ue + Ae - 1] !== 0 && (K = 1), this[ue + Ae] = (te / ie >> 0) - K & 255;
              return ue + ye;
            }, f.prototype.writeIntBE = function(te, ue, ye, Le) {
              if (te = +te, ue = ue >>> 0, !Le) {
                var Me = Math.pow(2, 8 * ye - 1);
                Oe(this, te, ue, ye, Me - 1, -Me);
              }
              var Ae = ye - 1, ie = 1, K = 0;
              for (this[ue + Ae] = te & 255; --Ae >= 0 && (ie *= 256); )
                te < 0 && K === 0 && this[ue + Ae + 1] !== 0 && (K = 1), this[ue + Ae] = (te / ie >> 0) - K & 255;
              return ue + ye;
            }, f.prototype.writeInt8 = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 1, 127, -128), te < 0 && (te = 255 + te + 1), this[ue] = te & 255, ue + 1;
            }, f.prototype.writeInt16LE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 2, 32767, -32768), this[ue] = te & 255, this[ue + 1] = te >>> 8, ue + 2;
            }, f.prototype.writeInt16BE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 2, 32767, -32768), this[ue] = te >>> 8, this[ue + 1] = te & 255, ue + 2;
            }, f.prototype.writeInt32LE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 4, 2147483647, -2147483648), this[ue] = te & 255, this[ue + 1] = te >>> 8, this[ue + 2] = te >>> 16, this[ue + 3] = te >>> 24, ue + 4;
            }, f.prototype.writeInt32BE = function(te, ue, ye) {
              return te = +te, ue = ue >>> 0, ye || Oe(this, te, ue, 4, 2147483647, -2147483648), te < 0 && (te = 4294967295 + te + 1), this[ue] = te >>> 24, this[ue + 1] = te >>> 16, this[ue + 2] = te >>> 8, this[ue + 3] = te & 255, ue + 4;
            };
            function xe(Ee, te, ue, ye, Le, Me) {
              if (ue + ye > Ee.length) throw new RangeError("Index out of range");
              if (ue < 0) throw new RangeError("Index out of range");
            }
            function ze(Ee, te, ue, ye, Le) {
              return te = +te, ue = ue >>> 0, Le || xe(Ee, te, ue, 4), u.write(Ee, te, ue, ye, 23, 4), ue + 4;
            }
            f.prototype.writeFloatLE = function(te, ue, ye) {
              return ze(this, te, ue, !0, ye);
            }, f.prototype.writeFloatBE = function(te, ue, ye) {
              return ze(this, te, ue, !1, ye);
            };
            function qe(Ee, te, ue, ye, Le) {
              return te = +te, ue = ue >>> 0, Le || xe(Ee, te, ue, 8), u.write(Ee, te, ue, ye, 52, 8), ue + 8;
            }
            f.prototype.writeDoubleLE = function(te, ue, ye) {
              return qe(this, te, ue, !0, ye);
            }, f.prototype.writeDoubleBE = function(te, ue, ye) {
              return qe(this, te, ue, !1, ye);
            }, f.prototype.copy = function(te, ue, ye, Le) {
              if (!f.isBuffer(te)) throw new TypeError("argument should be a Buffer");
              if (ye || (ye = 0), !Le && Le !== 0 && (Le = this.length), ue >= te.length && (ue = te.length), ue || (ue = 0), Le > 0 && Le < ye && (Le = ye), Le === ye || te.length === 0 || this.length === 0) return 0;
              if (ue < 0)
                throw new RangeError("targetStart out of bounds");
              if (ye < 0 || ye >= this.length) throw new RangeError("Index out of range");
              if (Le < 0) throw new RangeError("sourceEnd out of bounds");
              Le > this.length && (Le = this.length), te.length - ue < Le - ye && (Le = te.length - ue + ye);
              var Me = Le - ye;
              if (this === te && typeof Uint8Array.prototype.copyWithin == "function")
                this.copyWithin(ue, ye, Le);
              else if (this === te && ye < ue && ue < Le)
                for (var Ae = Me - 1; Ae >= 0; --Ae)
                  te[Ae + ue] = this[Ae + ye];
              else
                Uint8Array.prototype.set.call(
                  te,
                  this.subarray(ye, Le),
                  ue
                );
              return Me;
            }, f.prototype.fill = function(te, ue, ye, Le) {
              if (typeof te == "string") {
                if (typeof ue == "string" ? (Le = ue, ue = 0, ye = this.length) : typeof ye == "string" && (Le = ye, ye = this.length), Le !== void 0 && typeof Le != "string")
                  throw new TypeError("encoding must be a string");
                if (typeof Le == "string" && !f.isEncoding(Le))
                  throw new TypeError("Unknown encoding: " + Le);
                if (te.length === 1) {
                  var Me = te.charCodeAt(0);
                  (Le === "utf8" && Me < 128 || Le === "latin1") && (te = Me);
                }
              } else typeof te == "number" && (te = te & 255);
              if (ue < 0 || this.length < ue || this.length < ye)
                throw new RangeError("Out of range index");
              if (ye <= ue)
                return this;
              ue = ue >>> 0, ye = ye === void 0 ? this.length : ye >>> 0, te || (te = 0);
              var Ae;
              if (typeof te == "number")
                for (Ae = ue; Ae < ye; ++Ae)
                  this[Ae] = te;
              else {
                var ie = f.isBuffer(te) ? te : f.from(te, Le), K = ie.length;
                if (K === 0)
                  throw new TypeError('The value "' + te + '" is invalid for argument "value"');
                for (Ae = 0; Ae < ye - ue; ++Ae)
                  this[Ae + ue] = ie[Ae % K];
              }
              return this;
            };
            var Je = /[^+/0-9A-Za-z-_]/g;
            function Be(Ee) {
              if (Ee = Ee.split("=")[0], Ee = Ee.trim().replace(Je, ""), Ee.length < 2) return "";
              for (; Ee.length % 4 !== 0; )
                Ee = Ee + "=";
              return Ee;
            }
            function We(Ee) {
              return Ee < 16 ? "0" + Ee.toString(16) : Ee.toString(16);
            }
            function Ne(Ee, te) {
              te = te || 1 / 0;
              for (var ue, ye = Ee.length, Le = null, Me = [], Ae = 0; Ae < ye; ++Ae) {
                if (ue = Ee.charCodeAt(Ae), ue > 55295 && ue < 57344) {
                  if (!Le) {
                    if (ue > 56319) {
                      (te -= 3) > -1 && Me.push(239, 191, 189);
                      continue;
                    } else if (Ae + 1 === ye) {
                      (te -= 3) > -1 && Me.push(239, 191, 189);
                      continue;
                    }
                    Le = ue;
                    continue;
                  }
                  if (ue < 56320) {
                    (te -= 3) > -1 && Me.push(239, 191, 189), Le = ue;
                    continue;
                  }
                  ue = (Le - 55296 << 10 | ue - 56320) + 65536;
                } else Le && (te -= 3) > -1 && Me.push(239, 191, 189);
                if (Le = null, ue < 128) {
                  if ((te -= 1) < 0) break;
                  Me.push(ue);
                } else if (ue < 2048) {
                  if ((te -= 2) < 0) break;
                  Me.push(
                    ue >> 6 | 192,
                    ue & 63 | 128
                  );
                } else if (ue < 65536) {
                  if ((te -= 3) < 0) break;
                  Me.push(
                    ue >> 12 | 224,
                    ue >> 6 & 63 | 128,
                    ue & 63 | 128
                  );
                } else if (ue < 1114112) {
                  if ((te -= 4) < 0) break;
                  Me.push(
                    ue >> 18 | 240,
                    ue >> 12 & 63 | 128,
                    ue >> 6 & 63 | 128,
                    ue & 63 | 128
                  );
                } else
                  throw new Error("Invalid code point");
              }
              return Me;
            }
            function je(Ee) {
              for (var te = [], ue = 0; ue < Ee.length; ++ue)
                te.push(Ee.charCodeAt(ue) & 255);
              return te;
            }
            function et(Ee, te) {
              for (var ue, ye, Le, Me = [], Ae = 0; Ae < Ee.length && !((te -= 2) < 0); ++Ae)
                ue = Ee.charCodeAt(Ae), ye = ue >> 8, Le = ue % 256, Me.push(Le), Me.push(ye);
              return Me;
            }
            function St(Ee) {
              return a.toByteArray(Be(Ee));
            }
            function Ot(Ee, te, ue, ye) {
              for (var Le = 0; Le < ye && !(Le + ue >= te.length || Le >= Ee.length); ++Le)
                te[Le + ue] = Ee[Le];
              return Le;
            }
            function we(Ee, te) {
              return Ee instanceof te || Ee != null && Ee.constructor != null && Ee.constructor.name != null && Ee.constructor.name === te.name;
            }
            function De(Ee) {
              return Ee !== Ee;
            }
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { "base64-js": 33, buffer: 35, ieee754: 37 }], 36: [function(r, n, i) {
        var o = typeof Reflect == "object" ? Reflect : null, a = o && typeof o.apply == "function" ? o.apply : function(P, U, z) {
          return Function.prototype.apply.call(P, U, z);
        }, u;
        o && typeof o.ownKeys == "function" ? u = o.ownKeys : Object.getOwnPropertySymbols ? u = function(P) {
          return Object.getOwnPropertyNames(P).concat(Object.getOwnPropertySymbols(P));
        } : u = function(P) {
          return Object.getOwnPropertyNames(P);
        };
        function s(O) {
          console && console.warn && console.warn(O);
        }
        var c = Number.isNaN || function(P) {
          return P !== P;
        };
        function l() {
          l.init.call(this);
        }
        n.exports = l, n.exports.once = A, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
        var f = 10;
        function d(O) {
          if (typeof O != "function")
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof O);
        }
        Object.defineProperty(l, "defaultMaxListeners", {
          enumerable: !0,
          get: function() {
            return f;
          },
          set: function(O) {
            if (typeof O != "number" || O < 0 || c(O))
              throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + O + ".");
            f = O;
          }
        }), l.init = function() {
          (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, l.prototype.setMaxListeners = function(P) {
          if (typeof P != "number" || P < 0 || c(P))
            throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + P + ".");
          return this._maxListeners = P, this;
        };
        function p(O) {
          return O._maxListeners === void 0 ? l.defaultMaxListeners : O._maxListeners;
        }
        l.prototype.getMaxListeners = function() {
          return p(this);
        }, l.prototype.emit = function(P) {
          for (var U = [], z = 1; z < arguments.length; z++) U.push(arguments[z]);
          var k = P === "error", H = this._events;
          if (H !== void 0)
            k = k && H.error === void 0;
          else if (!k)
            return !1;
          if (k) {
            var B;
            if (U.length > 0 && (B = U[0]), B instanceof Error)
              throw B;
            var x = new Error("Unhandled error." + (B ? " (" + B.message + ")" : ""));
            throw x.context = B, x;
          }
          var D = H[P];
          if (D === void 0)
            return !1;
          if (typeof D == "function")
            a(D, this, U);
          else
            for (var w = D.length, $ = y(D, w), z = 0; z < w; ++z)
              a($[z], this, U);
          return !0;
        };
        function v(O, P, U, z) {
          var k, H, B;
          if (d(U), H = O._events, H === void 0 ? (H = O._events = /* @__PURE__ */ Object.create(null), O._eventsCount = 0) : (H.newListener !== void 0 && (O.emit(
            "newListener",
            P,
            U.listener ? U.listener : U
          ), H = O._events), B = H[P]), B === void 0)
            B = H[P] = U, ++O._eventsCount;
          else if (typeof B == "function" ? B = H[P] = z ? [U, B] : [B, U] : z ? B.unshift(U) : B.push(U), k = p(O), k > 0 && B.length > k && !B.warned) {
            B.warned = !0;
            var x = new Error("Possible EventEmitter memory leak detected. " + B.length + " " + String(P) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            x.name = "MaxListenersExceededWarning", x.emitter = O, x.type = P, x.count = B.length, s(x);
          }
          return O;
        }
        l.prototype.addListener = function(P, U) {
          return v(this, P, U, !1);
        }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function(P, U) {
          return v(this, P, U, !0);
        };
        function h() {
          if (!this.fired)
            return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function E(O, P, U) {
          var z = { fired: !1, wrapFn: void 0, target: O, type: P, listener: U }, k = h.bind(z);
          return k.listener = U, z.wrapFn = k, k;
        }
        l.prototype.once = function(P, U) {
          return d(U), this.on(P, E(this, P, U)), this;
        }, l.prototype.prependOnceListener = function(P, U) {
          return d(U), this.prependListener(P, E(this, P, U)), this;
        }, l.prototype.removeListener = function(P, U) {
          var z, k, H, B, x;
          if (d(U), k = this._events, k === void 0)
            return this;
          if (z = k[P], z === void 0)
            return this;
          if (z === U || z.listener === U)
            --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete k[P], k.removeListener && this.emit("removeListener", P, z.listener || U));
          else if (typeof z != "function") {
            for (H = -1, B = z.length - 1; B >= 0; B--)
              if (z[B] === U || z[B].listener === U) {
                x = z[B].listener, H = B;
                break;
              }
            if (H < 0)
              return this;
            H === 0 ? z.shift() : _(z, H), z.length === 1 && (k[P] = z[0]), k.removeListener !== void 0 && this.emit("removeListener", P, x || U);
          }
          return this;
        }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function(P) {
          var U, z, k;
          if (z = this._events, z === void 0)
            return this;
          if (z.removeListener === void 0)
            return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[P] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[P]), this;
          if (arguments.length === 0) {
            var H = Object.keys(z), B;
            for (k = 0; k < H.length; ++k)
              B = H[k], B !== "removeListener" && this.removeAllListeners(B);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (U = z[P], typeof U == "function")
            this.removeListener(P, U);
          else if (U !== void 0)
            for (k = U.length - 1; k >= 0; k--)
              this.removeListener(P, U[k]);
          return this;
        };
        function m(O, P, U) {
          var z = O._events;
          if (z === void 0)
            return [];
          var k = z[P];
          return k === void 0 ? [] : typeof k == "function" ? U ? [k.listener || k] : [k] : U ? S(k) : y(k, k.length);
        }
        l.prototype.listeners = function(P) {
          return m(this, P, !0);
        }, l.prototype.rawListeners = function(P) {
          return m(this, P, !1);
        }, l.listenerCount = function(O, P) {
          return typeof O.listenerCount == "function" ? O.listenerCount(P) : g.call(O, P);
        }, l.prototype.listenerCount = g;
        function g(O) {
          var P = this._events;
          if (P !== void 0) {
            var U = P[O];
            if (typeof U == "function")
              return 1;
            if (U !== void 0)
              return U.length;
          }
          return 0;
        }
        l.prototype.eventNames = function() {
          return this._eventsCount > 0 ? u(this._events) : [];
        };
        function y(O, P) {
          for (var U = new Array(P), z = 0; z < P; ++z)
            U[z] = O[z];
          return U;
        }
        function _(O, P) {
          for (; P + 1 < O.length; P++)
            O[P] = O[P + 1];
          O.pop();
        }
        function S(O) {
          for (var P = new Array(O.length), U = 0; U < P.length; ++U)
            P[U] = O[U].listener || O[U];
          return P;
        }
        function A(O, P) {
          return new Promise(function(U, z) {
            function k() {
              H !== void 0 && O.removeListener("error", H), U([].slice.call(arguments));
            }
            var H;
            P !== "error" && (H = function(x) {
              O.removeListener(P, k), z(x);
            }, O.once("error", H)), O.once(P, k);
          });
        }
      }, {}], 37: [function(r, n, i) {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        i.read = function(o, a, u, s, c) {
          var l, f, d = c * 8 - s - 1, p = (1 << d) - 1, v = p >> 1, h = -7, E = u ? c - 1 : 0, m = u ? -1 : 1, g = o[a + E];
          for (E += m, l = g & (1 << -h) - 1, g >>= -h, h += d; h > 0; l = l * 256 + o[a + E], E += m, h -= 8)
            ;
          for (f = l & (1 << -h) - 1, l >>= -h, h += s; h > 0; f = f * 256 + o[a + E], E += m, h -= 8)
            ;
          if (l === 0)
            l = 1 - v;
          else {
            if (l === p)
              return f ? NaN : (g ? -1 : 1) * (1 / 0);
            f = f + Math.pow(2, s), l = l - v;
          }
          return (g ? -1 : 1) * f * Math.pow(2, l - s);
        }, i.write = function(o, a, u, s, c, l) {
          var f, d, p, v = l * 8 - c - 1, h = (1 << v) - 1, E = h >> 1, m = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = s ? 0 : l - 1, y = s ? 1 : -1, _ = a < 0 || a === 0 && 1 / a < 0 ? 1 : 0;
          for (a = Math.abs(a), isNaN(a) || a === 1 / 0 ? (d = isNaN(a) ? 1 : 0, f = h) : (f = Math.floor(Math.log(a) / Math.LN2), a * (p = Math.pow(2, -f)) < 1 && (f--, p *= 2), f + E >= 1 ? a += m / p : a += m * Math.pow(2, 1 - E), a * p >= 2 && (f++, p /= 2), f + E >= h ? (d = 0, f = h) : f + E >= 1 ? (d = (a * p - 1) * Math.pow(2, c), f = f + E) : (d = a * Math.pow(2, E - 1) * Math.pow(2, c), f = 0)); c >= 8; o[u + g] = d & 255, g += y, d /= 256, c -= 8)
            ;
          for (f = f << c | d, v += c; v > 0; o[u + g] = f & 255, g += y, f /= 256, v -= 8)
            ;
          o[u + g - y] |= _ * 128;
        };
      }, {}], 38: [function(r, n, i) {
        typeof Object.create == "function" ? n.exports = function(a, u) {
          u && (a.super_ = u, a.prototype = Object.create(u.prototype, {
            constructor: {
              value: a,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : n.exports = function(a, u) {
          if (u) {
            a.super_ = u;
            var s = function() {
            };
            s.prototype = u.prototype, a.prototype = new s(), a.prototype.constructor = a;
          }
        };
      }, {}], 39: [function(r, n, i) {
        var o = n.exports = {}, a, u;
        function s() {
          throw new Error("setTimeout has not been defined");
        }
        function c() {
          throw new Error("clearTimeout has not been defined");
        }
        (function() {
          try {
            typeof setTimeout == "function" ? a = setTimeout : a = s;
          } catch {
            a = s;
          }
          try {
            typeof clearTimeout == "function" ? u = clearTimeout : u = c;
          } catch {
            u = c;
          }
        })();
        function l(_) {
          if (a === setTimeout)
            return setTimeout(_, 0);
          if ((a === s || !a) && setTimeout)
            return a = setTimeout, setTimeout(_, 0);
          try {
            return a(_, 0);
          } catch {
            try {
              return a.call(null, _, 0);
            } catch {
              return a.call(this, _, 0);
            }
          }
        }
        function f(_) {
          if (u === clearTimeout)
            return clearTimeout(_);
          if ((u === c || !u) && clearTimeout)
            return u = clearTimeout, clearTimeout(_);
          try {
            return u(_);
          } catch {
            try {
              return u.call(null, _);
            } catch {
              return u.call(this, _);
            }
          }
        }
        var d = [], p = !1, v, h = -1;
        function E() {
          !p || !v || (p = !1, v.length ? d = v.concat(d) : h = -1, d.length && m());
        }
        function m() {
          if (!p) {
            var _ = l(E);
            p = !0;
            for (var S = d.length; S; ) {
              for (v = d, d = []; ++h < S; )
                v && v[h].run();
              h = -1, S = d.length;
            }
            v = null, p = !1, f(_);
          }
        }
        o.nextTick = function(_) {
          var S = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var A = 1; A < arguments.length; A++)
              S[A - 1] = arguments[A];
          d.push(new g(_, S)), d.length === 1 && !p && l(m);
        };
        function g(_, S) {
          this.fun = _, this.array = S;
        }
        g.prototype.run = function() {
          this.fun.apply(null, this.array);
        }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {};
        function y() {
        }
        o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function(_) {
          return [];
        }, o.binding = function(_) {
          throw new Error("process.binding is not supported");
        }, o.cwd = function() {
          return "/";
        }, o.chdir = function(_) {
          throw new Error("process.chdir is not supported");
        }, o.umask = function() {
          return 0;
        };
      }, {}], 40: [function(r, n, i) {
        /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
        var o = r("buffer"), a = o.Buffer;
        function u(c, l) {
          for (var f in c)
            l[f] = c[f];
        }
        a.from && a.alloc && a.allocUnsafe && a.allocUnsafeSlow ? n.exports = o : (u(o, i), i.Buffer = s);
        function s(c, l, f) {
          return a(c, l, f);
        }
        s.prototype = Object.create(a.prototype), u(a, s), s.from = function(c, l, f) {
          if (typeof c == "number")
            throw new TypeError("Argument must not be a number");
          return a(c, l, f);
        }, s.alloc = function(c, l, f) {
          if (typeof c != "number")
            throw new TypeError("Argument must be a number");
          var d = a(c);
          return l !== void 0 ? typeof f == "string" ? d.fill(l, f) : d.fill(l) : d.fill(0), d;
        }, s.allocUnsafe = function(c) {
          if (typeof c != "number")
            throw new TypeError("Argument must be a number");
          return a(c);
        }, s.allocUnsafeSlow = function(c) {
          if (typeof c != "number")
            throw new TypeError("Argument must be a number");
          return o.SlowBuffer(c);
        };
      }, { buffer: 35 }], 41: [function(r, n, i) {
        n.exports = u;
        var o = r("events").EventEmitter, a = r("inherits");
        a(u, o), u.Readable = r("readable-stream/lib/_stream_readable.js"), u.Writable = r("readable-stream/lib/_stream_writable.js"), u.Duplex = r("readable-stream/lib/_stream_duplex.js"), u.Transform = r("readable-stream/lib/_stream_transform.js"), u.PassThrough = r("readable-stream/lib/_stream_passthrough.js"), u.finished = r("readable-stream/lib/internal/streams/end-of-stream.js"), u.pipeline = r("readable-stream/lib/internal/streams/pipeline.js"), u.Stream = u;
        function u() {
          o.call(this);
        }
        u.prototype.pipe = function(s, c) {
          var l = this;
          function f(g) {
            s.writable && s.write(g) === !1 && l.pause && l.pause();
          }
          l.on("data", f);
          function d() {
            l.readable && l.resume && l.resume();
          }
          s.on("drain", d), !s._isStdio && (!c || c.end !== !1) && (l.on("end", v), l.on("close", h));
          var p = !1;
          function v() {
            p || (p = !0, s.end());
          }
          function h() {
            p || (p = !0, typeof s.destroy == "function" && s.destroy());
          }
          function E(g) {
            if (m(), o.listenerCount(this, "error") === 0)
              throw g;
          }
          l.on("error", E), s.on("error", E);
          function m() {
            l.removeListener("data", f), s.removeListener("drain", d), l.removeListener("end", v), l.removeListener("close", h), l.removeListener("error", E), s.removeListener("error", E), l.removeListener("end", m), l.removeListener("close", m), s.removeListener("close", m);
          }
          return l.on("end", m), l.on("close", m), s.on("close", m), s.emit("pipe", l), s;
        };
      }, { events: 36, inherits: 38, "readable-stream/lib/_stream_duplex.js": 43, "readable-stream/lib/_stream_passthrough.js": 44, "readable-stream/lib/_stream_readable.js": 45, "readable-stream/lib/_stream_transform.js": 46, "readable-stream/lib/_stream_writable.js": 47, "readable-stream/lib/internal/streams/end-of-stream.js": 51, "readable-stream/lib/internal/streams/pipeline.js": 53 }], 42: [function(r, n, i) {
        function o(d, p) {
          d.prototype = Object.create(p.prototype), d.prototype.constructor = d, d.__proto__ = p;
        }
        var a = {};
        function u(d, p, v) {
          v || (v = Error);
          function h(m, g, y) {
            return typeof p == "string" ? p : p(m, g, y);
          }
          var E = /* @__PURE__ */ function(m) {
            o(g, m);
            function g(y, _, S) {
              return m.call(this, h(y, _, S)) || this;
            }
            return g;
          }(v);
          E.prototype.name = v.name, E.prototype.code = d, a[d] = E;
        }
        function s(d, p) {
          if (Array.isArray(d)) {
            var v = d.length;
            return d = d.map(function(h) {
              return String(h);
            }), v > 2 ? "one of ".concat(p, " ").concat(d.slice(0, v - 1).join(", "), ", or ") + d[v - 1] : v === 2 ? "one of ".concat(p, " ").concat(d[0], " or ").concat(d[1]) : "of ".concat(p, " ").concat(d[0]);
          } else
            return "of ".concat(p, " ").concat(String(d));
        }
        function c(d, p, v) {
          return d.substr(0, p.length) === p;
        }
        function l(d, p, v) {
          return (v === void 0 || v > d.length) && (v = d.length), d.substring(v - p.length, v) === p;
        }
        function f(d, p, v) {
          return typeof v != "number" && (v = 0), v + p.length > d.length ? !1 : d.indexOf(p, v) !== -1;
        }
        u("ERR_INVALID_OPT_VALUE", function(d, p) {
          return 'The value "' + p + '" is invalid for option "' + d + '"';
        }, TypeError), u("ERR_INVALID_ARG_TYPE", function(d, p, v) {
          var h;
          typeof p == "string" && c(p, "not ") ? (h = "must not be", p = p.replace(/^not /, "")) : h = "must be";
          var E;
          if (l(d, " argument"))
            E = "The ".concat(d, " ").concat(h, " ").concat(s(p, "type"));
          else {
            var m = f(d, ".") ? "property" : "argument";
            E = 'The "'.concat(d, '" ').concat(m, " ").concat(h, " ").concat(s(p, "type"));
          }
          return E += ". Received type ".concat(typeof v), E;
        }, TypeError), u("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), u("ERR_METHOD_NOT_IMPLEMENTED", function(d) {
          return "The " + d + " method is not implemented";
        }), u("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), u("ERR_STREAM_DESTROYED", function(d) {
          return "Cannot call " + d + " after a stream was destroyed";
        }), u("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), u("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), u("ERR_STREAM_WRITE_AFTER_END", "write after end"), u("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), u("ERR_UNKNOWN_ENCODING", function(d) {
          return "Unknown encoding: " + d;
        }, TypeError), u("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), n.exports.codes = a;
      }, {}], 43: [function(r, n, i) {
        (function(o) {
          (function() {
            var a = Object.keys || function(h) {
              var E = [];
              for (var m in h)
                E.push(m);
              return E;
            };
            n.exports = d;
            var u = r("./_stream_readable"), s = r("./_stream_writable");
            r("inherits")(d, u);
            for (var c = a(s.prototype), l = 0; l < c.length; l++) {
              var f = c[l];
              d.prototype[f] || (d.prototype[f] = s.prototype[f]);
            }
            function d(h) {
              if (!(this instanceof d)) return new d(h);
              u.call(this, h), s.call(this, h), this.allowHalfOpen = !0, h && (h.readable === !1 && (this.readable = !1), h.writable === !1 && (this.writable = !1), h.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", p)));
            }
            Object.defineProperty(d.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            }), Object.defineProperty(d.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            }), Object.defineProperty(d.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function p() {
              this._writableState.ended || o.nextTick(v, this);
            }
            function v(h) {
              h.end();
            }
            Object.defineProperty(d.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
              },
              set: function(E) {
                this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = E, this._writableState.destroyed = E);
              }
            });
          }).call(this);
        }).call(this, r("_process"));
      }, { "./_stream_readable": 45, "./_stream_writable": 47, _process: 39, inherits: 38 }], 44: [function(r, n, i) {
        n.exports = a;
        var o = r("./_stream_transform");
        r("inherits")(a, o);
        function a(u) {
          if (!(this instanceof a)) return new a(u);
          o.call(this, u);
        }
        a.prototype._transform = function(u, s, c) {
          c(null, u);
        };
      }, { "./_stream_transform": 46, inherits: 38 }], 45: [function(r, n, i) {
        (function(o, a) {
          (function() {
            n.exports = w;
            var u;
            w.ReadableState = D, r("events").EventEmitter;
            var s = function(De, Ee) {
              return De.listeners(Ee).length;
            }, c = r("./internal/streams/stream"), l = r("buffer").Buffer, f = a.Uint8Array || function() {
            };
            function d(we) {
              return l.from(we);
            }
            function p(we) {
              return l.isBuffer(we) || we instanceof f;
            }
            var v = r("util"), h;
            v && v.debuglog ? h = v.debuglog("stream") : h = function() {
            };
            var E = r("./internal/streams/buffer_list"), m = r("./internal/streams/destroy"), g = r("./internal/streams/state"), y = g.getHighWaterMark, _ = r("../errors").codes, S = _.ERR_INVALID_ARG_TYPE, A = _.ERR_STREAM_PUSH_AFTER_EOF, O = _.ERR_METHOD_NOT_IMPLEMENTED, P = _.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, U, z, k;
            r("inherits")(w, c);
            var H = m.errorOrDestroy, B = ["error", "close", "destroy", "pause", "resume"];
            function x(we, De, Ee) {
              if (typeof we.prependListener == "function") return we.prependListener(De, Ee);
              !we._events || !we._events[De] ? we.on(De, Ee) : Array.isArray(we._events[De]) ? we._events[De].unshift(Ee) : we._events[De] = [Ee, we._events[De]];
            }
            function D(we, De, Ee) {
              u = u || r("./_stream_duplex"), we = we || {}, typeof Ee != "boolean" && (Ee = De instanceof u), this.objectMode = !!we.objectMode, Ee && (this.objectMode = this.objectMode || !!we.readableObjectMode), this.highWaterMark = y(this, we, "readableHighWaterMark", Ee), this.buffer = new E(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = we.emitClose !== !1, this.autoDestroy = !!we.autoDestroy, this.destroyed = !1, this.defaultEncoding = we.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, we.encoding && (U || (U = r("string_decoder/").StringDecoder), this.decoder = new U(we.encoding), this.encoding = we.encoding);
            }
            function w(we) {
              if (u = u || r("./_stream_duplex"), !(this instanceof w)) return new w(we);
              var De = this instanceof u;
              this._readableState = new D(we, this, De), this.readable = !0, we && (typeof we.read == "function" && (this._read = we.read), typeof we.destroy == "function" && (this._destroy = we.destroy)), c.call(this);
            }
            Object.defineProperty(w.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 ? !1 : this._readableState.destroyed;
              },
              set: function(De) {
                this._readableState && (this._readableState.destroyed = De);
              }
            }), w.prototype.destroy = m.destroy, w.prototype._undestroy = m.undestroy, w.prototype._destroy = function(we, De) {
              De(we);
            }, w.prototype.push = function(we, De) {
              var Ee = this._readableState, te;
              return Ee.objectMode ? te = !0 : typeof we == "string" && (De = De || Ee.defaultEncoding, De !== Ee.encoding && (we = l.from(we, De), De = ""), te = !0), $(this, we, De, !1, te);
            }, w.prototype.unshift = function(we) {
              return $(this, we, null, !0, !1);
            };
            function $(we, De, Ee, te, ue) {
              h("readableAddChunk", De);
              var ye = we._readableState;
              if (De === null)
                ye.reading = !1, ne(we, ye);
              else {
                var Le;
                if (ue || (Le = V(ye, De)), Le)
                  H(we, Le);
                else if (ye.objectMode || De && De.length > 0)
                  if (typeof De != "string" && !ye.objectMode && Object.getPrototypeOf(De) !== l.prototype && (De = d(De)), te)
                    ye.endEmitted ? H(we, new P()) : X(we, ye, De, !0);
                  else if (ye.ended)
                    H(we, new A());
                  else {
                    if (ye.destroyed)
                      return !1;
                    ye.reading = !1, ye.decoder && !Ee ? (De = ye.decoder.write(De), ye.objectMode || De.length !== 0 ? X(we, ye, De, !1) : Oe(we, ye)) : X(we, ye, De, !1);
                  }
                else te || (ye.reading = !1, Oe(we, ye));
              }
              return !ye.ended && (ye.length < ye.highWaterMark || ye.length === 0);
            }
            function X(we, De, Ee, te) {
              De.flowing && De.length === 0 && !De.sync ? (De.awaitDrain = 0, we.emit("data", Ee)) : (De.length += De.objectMode ? 1 : Ee.length, te ? De.buffer.unshift(Ee) : De.buffer.push(Ee), De.needReadable && ve(we)), Oe(we, De);
            }
            function V(we, De) {
              var Ee;
              return !p(De) && typeof De != "string" && De !== void 0 && !we.objectMode && (Ee = new S("chunk", ["string", "Buffer", "Uint8Array"], De)), Ee;
            }
            w.prototype.isPaused = function() {
              return this._readableState.flowing === !1;
            }, w.prototype.setEncoding = function(we) {
              U || (U = r("string_decoder/").StringDecoder);
              var De = new U(we);
              this._readableState.decoder = De, this._readableState.encoding = this._readableState.decoder.encoding;
              for (var Ee = this._readableState.buffer.head, te = ""; Ee !== null; )
                te += De.write(Ee.data), Ee = Ee.next;
              return this._readableState.buffer.clear(), te !== "" && this._readableState.buffer.push(te), this._readableState.length = te.length, this;
            };
            var F = 1073741824;
            function le(we) {
              return we >= F ? we = F : (we--, we |= we >>> 1, we |= we >>> 2, we |= we >>> 4, we |= we >>> 8, we |= we >>> 16, we++), we;
            }
            function ae(we, De) {
              return we <= 0 || De.length === 0 && De.ended ? 0 : De.objectMode ? 1 : we !== we ? De.flowing && De.length ? De.buffer.head.data.length : De.length : (we > De.highWaterMark && (De.highWaterMark = le(we)), we <= De.length ? we : De.ended ? De.length : (De.needReadable = !0, 0));
            }
            w.prototype.read = function(we) {
              h("read", we), we = parseInt(we, 10);
              var De = this._readableState, Ee = we;
              if (we !== 0 && (De.emittedReadable = !1), we === 0 && De.needReadable && ((De.highWaterMark !== 0 ? De.length >= De.highWaterMark : De.length > 0) || De.ended))
                return h("read: emitReadable", De.length, De.ended), De.length === 0 && De.ended ? et(this) : ve(this), null;
              if (we = ae(we, De), we === 0 && De.ended)
                return De.length === 0 && et(this), null;
              var te = De.needReadable;
              h("need readable", te), (De.length === 0 || De.length - we < De.highWaterMark) && (te = !0, h("length less than watermark", te)), De.ended || De.reading ? (te = !1, h("reading or ended", te)) : te && (h("do read"), De.reading = !0, De.sync = !0, De.length === 0 && (De.needReadable = !0), this._read(De.highWaterMark), De.sync = !1, De.reading || (we = ae(Ee, De)));
              var ue;
              return we > 0 ? ue = je(we, De) : ue = null, ue === null ? (De.needReadable = De.length <= De.highWaterMark, we = 0) : (De.length -= we, De.awaitDrain = 0), De.length === 0 && (De.ended || (De.needReadable = !0), Ee !== we && De.ended && et(this)), ue !== null && this.emit("data", ue), ue;
            };
            function ne(we, De) {
              if (h("onEofChunk"), !De.ended) {
                if (De.decoder) {
                  var Ee = De.decoder.end();
                  Ee && Ee.length && (De.buffer.push(Ee), De.length += De.objectMode ? 1 : Ee.length);
                }
                De.ended = !0, De.sync ? ve(we) : (De.needReadable = !1, De.emittedReadable || (De.emittedReadable = !0, Ie(we)));
              }
            }
            function ve(we) {
              var De = we._readableState;
              h("emitReadable", De.needReadable, De.emittedReadable), De.needReadable = !1, De.emittedReadable || (h("emitReadable", De.flowing), De.emittedReadable = !0, o.nextTick(Ie, we));
            }
            function Ie(we) {
              var De = we._readableState;
              h("emitReadable_", De.destroyed, De.length, De.ended), !De.destroyed && (De.length || De.ended) && (we.emit("readable"), De.emittedReadable = !1), De.needReadable = !De.flowing && !De.ended && De.length <= De.highWaterMark, Ne(we);
            }
            function Oe(we, De) {
              De.readingMore || (De.readingMore = !0, o.nextTick(xe, we, De));
            }
            function xe(we, De) {
              for (; !De.reading && !De.ended && (De.length < De.highWaterMark || De.flowing && De.length === 0); ) {
                var Ee = De.length;
                if (h("maybeReadMore read 0"), we.read(0), Ee === De.length)
                  break;
              }
              De.readingMore = !1;
            }
            w.prototype._read = function(we) {
              H(this, new O("_read()"));
            }, w.prototype.pipe = function(we, De) {
              var Ee = this, te = this._readableState;
              switch (te.pipesCount) {
                case 0:
                  te.pipes = we;
                  break;
                case 1:
                  te.pipes = [te.pipes, we];
                  break;
                default:
                  te.pipes.push(we);
                  break;
              }
              te.pipesCount += 1, h("pipe count=%d opts=%j", te.pipesCount, De);
              var ue = (!De || De.end !== !1) && we !== o.stdout && we !== o.stderr, ye = ue ? Me : st;
              te.endEmitted ? o.nextTick(ye) : Ee.once("end", ye), we.on("unpipe", Le);
              function Le(wt, Bt) {
                h("onunpipe"), wt === Ee && Bt && Bt.hasUnpiped === !1 && (Bt.hasUnpiped = !0, K());
              }
              function Me() {
                h("onend"), we.end();
              }
              var Ae = ze(Ee);
              we.on("drain", Ae);
              var ie = !1;
              function K() {
                h("cleanup"), we.removeListener("close", be), we.removeListener("finish", Ge), we.removeListener("drain", Ae), we.removeListener("error", Ce), we.removeListener("unpipe", Le), Ee.removeListener("end", Me), Ee.removeListener("end", st), Ee.removeListener("data", Z), ie = !0, te.awaitDrain && (!we._writableState || we._writableState.needDrain) && Ae();
              }
              Ee.on("data", Z);
              function Z(wt) {
                h("ondata");
                var Bt = we.write(wt);
                h("dest.write", Bt), Bt === !1 && ((te.pipesCount === 1 && te.pipes === we || te.pipesCount > 1 && Ot(te.pipes, we) !== -1) && !ie && (h("false write response, pause", te.awaitDrain), te.awaitDrain++), Ee.pause());
              }
              function Ce(wt) {
                h("onerror", wt), st(), we.removeListener("error", Ce), s(we, "error") === 0 && H(we, wt);
              }
              x(we, "error", Ce);
              function be() {
                we.removeListener("finish", Ge), st();
              }
              we.once("close", be);
              function Ge() {
                h("onfinish"), we.removeListener("close", be), st();
              }
              we.once("finish", Ge);
              function st() {
                h("unpipe"), Ee.unpipe(we);
              }
              return we.emit("pipe", Ee), te.flowing || (h("pipe resume"), Ee.resume()), we;
            };
            function ze(we) {
              return function() {
                var Ee = we._readableState;
                h("pipeOnDrain", Ee.awaitDrain), Ee.awaitDrain && Ee.awaitDrain--, Ee.awaitDrain === 0 && s(we, "data") && (Ee.flowing = !0, Ne(we));
              };
            }
            w.prototype.unpipe = function(we) {
              var De = this._readableState, Ee = {
                hasUnpiped: !1
              };
              if (De.pipesCount === 0) return this;
              if (De.pipesCount === 1)
                return we && we !== De.pipes ? this : (we || (we = De.pipes), De.pipes = null, De.pipesCount = 0, De.flowing = !1, we && we.emit("unpipe", this, Ee), this);
              if (!we) {
                var te = De.pipes, ue = De.pipesCount;
                De.pipes = null, De.pipesCount = 0, De.flowing = !1;
                for (var ye = 0; ye < ue; ye++)
                  te[ye].emit("unpipe", this, {
                    hasUnpiped: !1
                  });
                return this;
              }
              var Le = Ot(De.pipes, we);
              return Le === -1 ? this : (De.pipes.splice(Le, 1), De.pipesCount -= 1, De.pipesCount === 1 && (De.pipes = De.pipes[0]), we.emit("unpipe", this, Ee), this);
            }, w.prototype.on = function(we, De) {
              var Ee = c.prototype.on.call(this, we, De), te = this._readableState;
              return we === "data" ? (te.readableListening = this.listenerCount("readable") > 0, te.flowing !== !1 && this.resume()) : we === "readable" && !te.endEmitted && !te.readableListening && (te.readableListening = te.needReadable = !0, te.flowing = !1, te.emittedReadable = !1, h("on readable", te.length, te.reading), te.length ? ve(this) : te.reading || o.nextTick(Je, this)), Ee;
            }, w.prototype.addListener = w.prototype.on, w.prototype.removeListener = function(we, De) {
              var Ee = c.prototype.removeListener.call(this, we, De);
              return we === "readable" && o.nextTick(qe, this), Ee;
            }, w.prototype.removeAllListeners = function(we) {
              var De = c.prototype.removeAllListeners.apply(this, arguments);
              return (we === "readable" || we === void 0) && o.nextTick(qe, this), De;
            };
            function qe(we) {
              var De = we._readableState;
              De.readableListening = we.listenerCount("readable") > 0, De.resumeScheduled && !De.paused ? De.flowing = !0 : we.listenerCount("data") > 0 && we.resume();
            }
            function Je(we) {
              h("readable nexttick read 0"), we.read(0);
            }
            w.prototype.resume = function() {
              var we = this._readableState;
              return we.flowing || (h("resume"), we.flowing = !we.readableListening, Be(this, we)), we.paused = !1, this;
            };
            function Be(we, De) {
              De.resumeScheduled || (De.resumeScheduled = !0, o.nextTick(We, we, De));
            }
            function We(we, De) {
              h("resume", De.reading), De.reading || we.read(0), De.resumeScheduled = !1, we.emit("resume"), Ne(we), De.flowing && !De.reading && we.read(0);
            }
            w.prototype.pause = function() {
              return h("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function Ne(we) {
              var De = we._readableState;
              for (h("flow", De.flowing); De.flowing && we.read() !== null; )
                ;
            }
            w.prototype.wrap = function(we) {
              var De = this, Ee = this._readableState, te = !1;
              we.on("end", function() {
                if (h("wrapped end"), Ee.decoder && !Ee.ended) {
                  var Le = Ee.decoder.end();
                  Le && Le.length && De.push(Le);
                }
                De.push(null);
              }), we.on("data", function(Le) {
                if (h("wrapped data"), Ee.decoder && (Le = Ee.decoder.write(Le)), !(Ee.objectMode && Le == null) && !(!Ee.objectMode && (!Le || !Le.length))) {
                  var Me = De.push(Le);
                  Me || (te = !0, we.pause());
                }
              });
              for (var ue in we)
                this[ue] === void 0 && typeof we[ue] == "function" && (this[ue] = /* @__PURE__ */ function(Me) {
                  return function() {
                    return we[Me].apply(we, arguments);
                  };
                }(ue));
              for (var ye = 0; ye < B.length; ye++)
                we.on(B[ye], this.emit.bind(this, B[ye]));
              return this._read = function(Le) {
                h("wrapped _read", Le), te && (te = !1, we.resume());
              }, this;
            }, typeof Symbol == "function" && (w.prototype[Symbol.asyncIterator] = function() {
              return z === void 0 && (z = r("./internal/streams/async_iterator")), z(this);
            }), Object.defineProperty(w.prototype, "readableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.highWaterMark;
              }
            }), Object.defineProperty(w.prototype, "readableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState && this._readableState.buffer;
              }
            }), Object.defineProperty(w.prototype, "readableFlowing", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.flowing;
              },
              set: function(De) {
                this._readableState && (this._readableState.flowing = De);
              }
            }), w._fromList = je, Object.defineProperty(w.prototype, "readableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.length;
              }
            });
            function je(we, De) {
              if (De.length === 0) return null;
              var Ee;
              return De.objectMode ? Ee = De.buffer.shift() : !we || we >= De.length ? (De.decoder ? Ee = De.buffer.join("") : De.buffer.length === 1 ? Ee = De.buffer.first() : Ee = De.buffer.concat(De.length), De.buffer.clear()) : Ee = De.buffer.consume(we, De.decoder), Ee;
            }
            function et(we) {
              var De = we._readableState;
              h("endReadable", De.endEmitted), De.endEmitted || (De.ended = !0, o.nextTick(St, De, we));
            }
            function St(we, De) {
              if (h("endReadableNT", we.endEmitted, we.length), !we.endEmitted && we.length === 0 && (we.endEmitted = !0, De.readable = !1, De.emit("end"), we.autoDestroy)) {
                var Ee = De._writableState;
                (!Ee || Ee.autoDestroy && Ee.finished) && De.destroy();
              }
            }
            typeof Symbol == "function" && (w.from = function(we, De) {
              return k === void 0 && (k = r("./internal/streams/from")), k(w, we, De);
            });
            function Ot(we, De) {
              for (var Ee = 0, te = we.length; Ee < te; Ee++)
                if (we[Ee] === De) return Ee;
              return -1;
            }
          }).call(this);
        }).call(this, r("_process"), typeof fe < "u" ? fe : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { "../errors": 42, "./_stream_duplex": 43, "./internal/streams/async_iterator": 48, "./internal/streams/buffer_list": 49, "./internal/streams/destroy": 50, "./internal/streams/from": 52, "./internal/streams/state": 54, "./internal/streams/stream": 55, _process: 39, buffer: 35, events: 36, inherits: 38, "string_decoder/": 56, util: 34 }], 46: [function(r, n, i) {
        n.exports = d;
        var o = r("../errors").codes, a = o.ERR_METHOD_NOT_IMPLEMENTED, u = o.ERR_MULTIPLE_CALLBACK, s = o.ERR_TRANSFORM_ALREADY_TRANSFORMING, c = o.ERR_TRANSFORM_WITH_LENGTH_0, l = r("./_stream_duplex");
        r("inherits")(d, l);
        function f(h, E) {
          var m = this._transformState;
          m.transforming = !1;
          var g = m.writecb;
          if (g === null)
            return this.emit("error", new u());
          m.writechunk = null, m.writecb = null, E != null && this.push(E), g(h);
          var y = this._readableState;
          y.reading = !1, (y.needReadable || y.length < y.highWaterMark) && this._read(y.highWaterMark);
        }
        function d(h) {
          if (!(this instanceof d)) return new d(h);
          l.call(this, h), this._transformState = {
            afterTransform: f.bind(this),
            needTransform: !1,
            transforming: !1,
            writecb: null,
            writechunk: null,
            writeencoding: null
          }, this._readableState.needReadable = !0, this._readableState.sync = !1, h && (typeof h.transform == "function" && (this._transform = h.transform), typeof h.flush == "function" && (this._flush = h.flush)), this.on("prefinish", p);
        }
        function p() {
          var h = this;
          typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(E, m) {
            v(h, E, m);
          }) : v(this, null, null);
        }
        d.prototype.push = function(h, E) {
          return this._transformState.needTransform = !1, l.prototype.push.call(this, h, E);
        }, d.prototype._transform = function(h, E, m) {
          m(new a("_transform()"));
        }, d.prototype._write = function(h, E, m) {
          var g = this._transformState;
          if (g.writecb = m, g.writechunk = h, g.writeencoding = E, !g.transforming) {
            var y = this._readableState;
            (g.needTransform || y.needReadable || y.length < y.highWaterMark) && this._read(y.highWaterMark);
          }
        }, d.prototype._read = function(h) {
          var E = this._transformState;
          E.writechunk !== null && !E.transforming ? (E.transforming = !0, this._transform(E.writechunk, E.writeencoding, E.afterTransform)) : E.needTransform = !0;
        }, d.prototype._destroy = function(h, E) {
          l.prototype._destroy.call(this, h, function(m) {
            E(m);
          });
        };
        function v(h, E, m) {
          if (E) return h.emit("error", E);
          if (m != null && h.push(m), h._writableState.length) throw new c();
          if (h._transformState.transforming) throw new s();
          return h.push(null);
        }
      }, { "../errors": 42, "./_stream_duplex": 43, inherits: 38 }], 47: [function(r, n, i) {
        (function(o, a) {
          (function() {
            n.exports = D;
            function u(Ne) {
              var je = this;
              this.next = null, this.entry = null, this.finish = function() {
                We(je, Ne);
              };
            }
            var s;
            D.WritableState = B;
            var c = {
              deprecate: r("util-deprecate")
            }, l = r("./internal/streams/stream"), f = r("buffer").Buffer, d = a.Uint8Array || function() {
            };
            function p(Ne) {
              return f.from(Ne);
            }
            function v(Ne) {
              return f.isBuffer(Ne) || Ne instanceof d;
            }
            var h = r("./internal/streams/destroy"), E = r("./internal/streams/state"), m = E.getHighWaterMark, g = r("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, _ = g.ERR_METHOD_NOT_IMPLEMENTED, S = g.ERR_MULTIPLE_CALLBACK, A = g.ERR_STREAM_CANNOT_PIPE, O = g.ERR_STREAM_DESTROYED, P = g.ERR_STREAM_NULL_VALUES, U = g.ERR_STREAM_WRITE_AFTER_END, z = g.ERR_UNKNOWN_ENCODING, k = h.errorOrDestroy;
            r("inherits")(D, l);
            function H() {
            }
            function B(Ne, je, et) {
              s = s || r("./_stream_duplex"), Ne = Ne || {}, typeof et != "boolean" && (et = je instanceof s), this.objectMode = !!Ne.objectMode, et && (this.objectMode = this.objectMode || !!Ne.writableObjectMode), this.highWaterMark = m(this, Ne, "writableHighWaterMark", et), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var St = Ne.decodeStrings === !1;
              this.decodeStrings = !St, this.defaultEncoding = Ne.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Ot) {
                ne(je, Ot);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Ne.emitClose !== !1, this.autoDestroy = !!Ne.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new u(this);
            }
            B.prototype.getBuffer = function() {
              for (var je = this.bufferedRequest, et = []; je; )
                et.push(je), je = je.next;
              return et;
            }, function() {
              try {
                Object.defineProperty(B.prototype, "buffer", {
                  get: c.deprecate(function() {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch {
              }
            }();
            var x;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (x = Function.prototype[Symbol.hasInstance], Object.defineProperty(D, Symbol.hasInstance, {
              value: function(je) {
                return x.call(this, je) ? !0 : this !== D ? !1 : je && je._writableState instanceof B;
              }
            })) : x = function(je) {
              return je instanceof this;
            };
            function D(Ne) {
              s = s || r("./_stream_duplex");
              var je = this instanceof s;
              if (!je && !x.call(D, this)) return new D(Ne);
              this._writableState = new B(Ne, this, je), this.writable = !0, Ne && (typeof Ne.write == "function" && (this._write = Ne.write), typeof Ne.writev == "function" && (this._writev = Ne.writev), typeof Ne.destroy == "function" && (this._destroy = Ne.destroy), typeof Ne.final == "function" && (this._final = Ne.final)), l.call(this);
            }
            D.prototype.pipe = function() {
              k(this, new A());
            };
            function w(Ne, je) {
              var et = new U();
              k(Ne, et), o.nextTick(je, et);
            }
            function $(Ne, je, et, St) {
              var Ot;
              return et === null ? Ot = new P() : typeof et != "string" && !je.objectMode && (Ot = new y("chunk", ["string", "Buffer"], et)), Ot ? (k(Ne, Ot), o.nextTick(St, Ot), !1) : !0;
            }
            D.prototype.write = function(Ne, je, et) {
              var St = this._writableState, Ot = !1, we = !St.objectMode && v(Ne);
              return we && !f.isBuffer(Ne) && (Ne = p(Ne)), typeof je == "function" && (et = je, je = null), we ? je = "buffer" : je || (je = St.defaultEncoding), typeof et != "function" && (et = H), St.ending ? w(this, et) : (we || $(this, St, Ne, et)) && (St.pendingcb++, Ot = V(this, St, we, Ne, je, et)), Ot;
            }, D.prototype.cork = function() {
              this._writableState.corked++;
            }, D.prototype.uncork = function() {
              var Ne = this._writableState;
              Ne.corked && (Ne.corked--, !Ne.writing && !Ne.corked && !Ne.bufferProcessing && Ne.bufferedRequest && Oe(this, Ne));
            }, D.prototype.setDefaultEncoding = function(je) {
              if (typeof je == "string" && (je = je.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((je + "").toLowerCase()) > -1)) throw new z(je);
              return this._writableState.defaultEncoding = je, this;
            }, Object.defineProperty(D.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            });
            function X(Ne, je, et) {
              return !Ne.objectMode && Ne.decodeStrings !== !1 && typeof je == "string" && (je = f.from(je, et)), je;
            }
            Object.defineProperty(D.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            });
            function V(Ne, je, et, St, Ot, we) {
              if (!et) {
                var De = X(je, St, Ot);
                St !== De && (et = !0, Ot = "buffer", St = De);
              }
              var Ee = je.objectMode ? 1 : St.length;
              je.length += Ee;
              var te = je.length < je.highWaterMark;
              if (te || (je.needDrain = !0), je.writing || je.corked) {
                var ue = je.lastBufferedRequest;
                je.lastBufferedRequest = {
                  chunk: St,
                  encoding: Ot,
                  isBuf: et,
                  callback: we,
                  next: null
                }, ue ? ue.next = je.lastBufferedRequest : je.bufferedRequest = je.lastBufferedRequest, je.bufferedRequestCount += 1;
              } else
                F(Ne, je, !1, Ee, St, Ot, we);
              return te;
            }
            function F(Ne, je, et, St, Ot, we, De) {
              je.writelen = St, je.writecb = De, je.writing = !0, je.sync = !0, je.destroyed ? je.onwrite(new O("write")) : et ? Ne._writev(Ot, je.onwrite) : Ne._write(Ot, we, je.onwrite), je.sync = !1;
            }
            function le(Ne, je, et, St, Ot) {
              --je.pendingcb, et ? (o.nextTick(Ot, St), o.nextTick(Je, Ne, je), Ne._writableState.errorEmitted = !0, k(Ne, St)) : (Ot(St), Ne._writableState.errorEmitted = !0, k(Ne, St), Je(Ne, je));
            }
            function ae(Ne) {
              Ne.writing = !1, Ne.writecb = null, Ne.length -= Ne.writelen, Ne.writelen = 0;
            }
            function ne(Ne, je) {
              var et = Ne._writableState, St = et.sync, Ot = et.writecb;
              if (typeof Ot != "function") throw new S();
              if (ae(et), je) le(Ne, et, St, je, Ot);
              else {
                var we = xe(et) || Ne.destroyed;
                !we && !et.corked && !et.bufferProcessing && et.bufferedRequest && Oe(Ne, et), St ? o.nextTick(ve, Ne, et, we, Ot) : ve(Ne, et, we, Ot);
              }
            }
            function ve(Ne, je, et, St) {
              et || Ie(Ne, je), je.pendingcb--, St(), Je(Ne, je);
            }
            function Ie(Ne, je) {
              je.length === 0 && je.needDrain && (je.needDrain = !1, Ne.emit("drain"));
            }
            function Oe(Ne, je) {
              je.bufferProcessing = !0;
              var et = je.bufferedRequest;
              if (Ne._writev && et && et.next) {
                var St = je.bufferedRequestCount, Ot = new Array(St), we = je.corkedRequestsFree;
                we.entry = et;
                for (var De = 0, Ee = !0; et; )
                  Ot[De] = et, et.isBuf || (Ee = !1), et = et.next, De += 1;
                Ot.allBuffers = Ee, F(Ne, je, !0, je.length, Ot, "", we.finish), je.pendingcb++, je.lastBufferedRequest = null, we.next ? (je.corkedRequestsFree = we.next, we.next = null) : je.corkedRequestsFree = new u(je), je.bufferedRequestCount = 0;
              } else {
                for (; et; ) {
                  var te = et.chunk, ue = et.encoding, ye = et.callback, Le = je.objectMode ? 1 : te.length;
                  if (F(Ne, je, !1, Le, te, ue, ye), et = et.next, je.bufferedRequestCount--, je.writing)
                    break;
                }
                et === null && (je.lastBufferedRequest = null);
              }
              je.bufferedRequest = et, je.bufferProcessing = !1;
            }
            D.prototype._write = function(Ne, je, et) {
              et(new _("_write()"));
            }, D.prototype._writev = null, D.prototype.end = function(Ne, je, et) {
              var St = this._writableState;
              return typeof Ne == "function" ? (et = Ne, Ne = null, je = null) : typeof je == "function" && (et = je, je = null), Ne != null && this.write(Ne, je), St.corked && (St.corked = 1, this.uncork()), St.ending || Be(this, St, et), this;
            }, Object.defineProperty(D.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function xe(Ne) {
              return Ne.ending && Ne.length === 0 && Ne.bufferedRequest === null && !Ne.finished && !Ne.writing;
            }
            function ze(Ne, je) {
              Ne._final(function(et) {
                je.pendingcb--, et && k(Ne, et), je.prefinished = !0, Ne.emit("prefinish"), Je(Ne, je);
              });
            }
            function qe(Ne, je) {
              !je.prefinished && !je.finalCalled && (typeof Ne._final == "function" && !je.destroyed ? (je.pendingcb++, je.finalCalled = !0, o.nextTick(ze, Ne, je)) : (je.prefinished = !0, Ne.emit("prefinish")));
            }
            function Je(Ne, je) {
              var et = xe(je);
              if (et && (qe(Ne, je), je.pendingcb === 0 && (je.finished = !0, Ne.emit("finish"), je.autoDestroy))) {
                var St = Ne._readableState;
                (!St || St.autoDestroy && St.endEmitted) && Ne.destroy();
              }
              return et;
            }
            function Be(Ne, je, et) {
              je.ending = !0, Je(Ne, je), et && (je.finished ? o.nextTick(et) : Ne.once("finish", et)), je.ended = !0, Ne.writable = !1;
            }
            function We(Ne, je, et) {
              var St = Ne.entry;
              for (Ne.entry = null; St; ) {
                var Ot = St.callback;
                je.pendingcb--, Ot(et), St = St.next;
              }
              je.corkedRequestsFree.next = Ne;
            }
            Object.defineProperty(D.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState === void 0 ? !1 : this._writableState.destroyed;
              },
              set: function(je) {
                this._writableState && (this._writableState.destroyed = je);
              }
            }), D.prototype.destroy = h.destroy, D.prototype._undestroy = h.undestroy, D.prototype._destroy = function(Ne, je) {
              je(Ne);
            };
          }).call(this);
        }).call(this, r("_process"), typeof fe < "u" ? fe : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { "../errors": 42, "./_stream_duplex": 43, "./internal/streams/destroy": 50, "./internal/streams/state": 54, "./internal/streams/stream": 55, _process: 39, buffer: 35, inherits: 38, "util-deprecate": 57 }], 48: [function(r, n, i) {
        (function(o) {
          (function() {
            var a;
            function u(O, P, U) {
              return P in O ? Object.defineProperty(O, P, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : O[P] = U, O;
            }
            var s = r("./end-of-stream"), c = Symbol("lastResolve"), l = Symbol("lastReject"), f = Symbol("error"), d = Symbol("ended"), p = Symbol("lastPromise"), v = Symbol("handlePromise"), h = Symbol("stream");
            function E(O, P) {
              return {
                value: O,
                done: P
              };
            }
            function m(O) {
              var P = O[c];
              if (P !== null) {
                var U = O[h].read();
                U !== null && (O[p] = null, O[c] = null, O[l] = null, P(E(U, !1)));
              }
            }
            function g(O) {
              o.nextTick(m, O);
            }
            function y(O, P) {
              return function(U, z) {
                O.then(function() {
                  if (P[d]) {
                    U(E(void 0, !0));
                    return;
                  }
                  P[v](U, z);
                }, z);
              };
            }
            var _ = Object.getPrototypeOf(function() {
            }), S = Object.setPrototypeOf((a = {
              get stream() {
                return this[h];
              },
              next: function() {
                var P = this, U = this[f];
                if (U !== null)
                  return Promise.reject(U);
                if (this[d])
                  return Promise.resolve(E(void 0, !0));
                if (this[h].destroyed)
                  return new Promise(function(B, x) {
                    o.nextTick(function() {
                      P[f] ? x(P[f]) : B(E(void 0, !0));
                    });
                  });
                var z = this[p], k;
                if (z)
                  k = new Promise(y(z, this));
                else {
                  var H = this[h].read();
                  if (H !== null)
                    return Promise.resolve(E(H, !1));
                  k = new Promise(this[v]);
                }
                return this[p] = k, k;
              }
            }, u(a, Symbol.asyncIterator, function() {
              return this;
            }), u(a, "return", function() {
              var P = this;
              return new Promise(function(U, z) {
                P[h].destroy(null, function(k) {
                  if (k) {
                    z(k);
                    return;
                  }
                  U(E(void 0, !0));
                });
              });
            }), a), _), A = function(P) {
              var U, z = Object.create(S, (U = {}, u(U, h, {
                value: P,
                writable: !0
              }), u(U, c, {
                value: null,
                writable: !0
              }), u(U, l, {
                value: null,
                writable: !0
              }), u(U, f, {
                value: null,
                writable: !0
              }), u(U, d, {
                value: P._readableState.endEmitted,
                writable: !0
              }), u(U, v, {
                value: function(H, B) {
                  var x = z[h].read();
                  x ? (z[p] = null, z[c] = null, z[l] = null, H(E(x, !1))) : (z[c] = H, z[l] = B);
                },
                writable: !0
              }), U));
              return z[p] = null, s(P, function(k) {
                if (k && k.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                  var H = z[l];
                  H !== null && (z[p] = null, z[c] = null, z[l] = null, H(k)), z[f] = k;
                  return;
                }
                var B = z[c];
                B !== null && (z[p] = null, z[c] = null, z[l] = null, B(E(void 0, !0))), z[d] = !0;
              }), P.on("readable", g.bind(null, z)), z;
            };
            n.exports = A;
          }).call(this);
        }).call(this, r("_process"));
      }, { "./end-of-stream": 51, _process: 39 }], 49: [function(r, n, i) {
        function o(m, g) {
          var y = Object.keys(m);
          if (Object.getOwnPropertySymbols) {
            var _ = Object.getOwnPropertySymbols(m);
            g && (_ = _.filter(function(S) {
              return Object.getOwnPropertyDescriptor(m, S).enumerable;
            })), y.push.apply(y, _);
          }
          return y;
        }
        function a(m) {
          for (var g = 1; g < arguments.length; g++) {
            var y = arguments[g] != null ? arguments[g] : {};
            g % 2 ? o(Object(y), !0).forEach(function(_) {
              u(m, _, y[_]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(m, Object.getOwnPropertyDescriptors(y)) : o(Object(y)).forEach(function(_) {
              Object.defineProperty(m, _, Object.getOwnPropertyDescriptor(y, _));
            });
          }
          return m;
        }
        function u(m, g, y) {
          return g in m ? Object.defineProperty(m, g, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : m[g] = y, m;
        }
        function s(m, g) {
          if (!(m instanceof g))
            throw new TypeError("Cannot call a class as a function");
        }
        function c(m, g) {
          for (var y = 0; y < g.length; y++) {
            var _ = g[y];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(m, _.key, _);
          }
        }
        function l(m, g, y) {
          return g && c(m.prototype, g), m;
        }
        var f = r("buffer"), d = f.Buffer, p = r("util"), v = p.inspect, h = v && v.custom || "inspect";
        function E(m, g, y) {
          d.prototype.copy.call(m, g, y);
        }
        n.exports = /* @__PURE__ */ function() {
          function m() {
            s(this, m), this.head = null, this.tail = null, this.length = 0;
          }
          return l(m, [{
            key: "push",
            value: function(y) {
              var _ = {
                data: y,
                next: null
              };
              this.length > 0 ? this.tail.next = _ : this.head = _, this.tail = _, ++this.length;
            }
          }, {
            key: "unshift",
            value: function(y) {
              var _ = {
                data: y,
                next: this.head
              };
              this.length === 0 && (this.tail = _), this.head = _, ++this.length;
            }
          }, {
            key: "shift",
            value: function() {
              if (this.length !== 0) {
                var y = this.head.data;
                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, y;
              }
            }
          }, {
            key: "clear",
            value: function() {
              this.head = this.tail = null, this.length = 0;
            }
          }, {
            key: "join",
            value: function(y) {
              if (this.length === 0) return "";
              for (var _ = this.head, S = "" + _.data; _ = _.next; )
                S += y + _.data;
              return S;
            }
          }, {
            key: "concat",
            value: function(y) {
              if (this.length === 0) return d.alloc(0);
              for (var _ = d.allocUnsafe(y >>> 0), S = this.head, A = 0; S; )
                E(S.data, _, A), A += S.data.length, S = S.next;
              return _;
            }
            // Consumes a specified amount of bytes or characters from the buffered data.
          }, {
            key: "consume",
            value: function(y, _) {
              var S;
              return y < this.head.data.length ? (S = this.head.data.slice(0, y), this.head.data = this.head.data.slice(y)) : y === this.head.data.length ? S = this.shift() : S = _ ? this._getString(y) : this._getBuffer(y), S;
            }
          }, {
            key: "first",
            value: function() {
              return this.head.data;
            }
            // Consumes a specified amount of characters from the buffered data.
          }, {
            key: "_getString",
            value: function(y) {
              var _ = this.head, S = 1, A = _.data;
              for (y -= A.length; _ = _.next; ) {
                var O = _.data, P = y > O.length ? O.length : y;
                if (P === O.length ? A += O : A += O.slice(0, y), y -= P, y === 0) {
                  P === O.length ? (++S, _.next ? this.head = _.next : this.head = this.tail = null) : (this.head = _, _.data = O.slice(P));
                  break;
                }
                ++S;
              }
              return this.length -= S, A;
            }
            // Consumes a specified amount of bytes from the buffered data.
          }, {
            key: "_getBuffer",
            value: function(y) {
              var _ = d.allocUnsafe(y), S = this.head, A = 1;
              for (S.data.copy(_), y -= S.data.length; S = S.next; ) {
                var O = S.data, P = y > O.length ? O.length : y;
                if (O.copy(_, _.length - y, 0, P), y -= P, y === 0) {
                  P === O.length ? (++A, S.next ? this.head = S.next : this.head = this.tail = null) : (this.head = S, S.data = O.slice(P));
                  break;
                }
                ++A;
              }
              return this.length -= A, _;
            }
            // Make sure the linked list only shows the minimal necessary information.
          }, {
            key: h,
            value: function(y, _) {
              return v(this, a({}, _, {
                // Only inspect one level.
                depth: 0,
                // It should not recurse.
                customInspect: !1
              }));
            }
          }]), m;
        }();
      }, { buffer: 35, util: 34 }], 50: [function(r, n, i) {
        (function(o) {
          (function() {
            function a(d, p) {
              var v = this, h = this._readableState && this._readableState.destroyed, E = this._writableState && this._writableState.destroyed;
              return h || E ? (p ? p(d) : d && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, o.nextTick(l, this, d)) : o.nextTick(l, this, d)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(m) {
                !p && m ? v._writableState ? v._writableState.errorEmitted ? o.nextTick(s, v) : (v._writableState.errorEmitted = !0, o.nextTick(u, v, m)) : o.nextTick(u, v, m) : p ? (o.nextTick(s, v), p(m)) : o.nextTick(s, v);
              }), this);
            }
            function u(d, p) {
              l(d, p), s(d);
            }
            function s(d) {
              d._writableState && !d._writableState.emitClose || d._readableState && !d._readableState.emitClose || d.emit("close");
            }
            function c() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function l(d, p) {
              d.emit("error", p);
            }
            function f(d, p) {
              var v = d._readableState, h = d._writableState;
              v && v.autoDestroy || h && h.autoDestroy ? d.destroy(p) : d.emit("error", p);
            }
            n.exports = {
              destroy: a,
              undestroy: c,
              errorOrDestroy: f
            };
          }).call(this);
        }).call(this, r("_process"));
      }, { _process: 39 }], 51: [function(r, n, i) {
        var o = r("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
        function a(l) {
          var f = !1;
          return function() {
            if (!f) {
              f = !0;
              for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++)
                p[v] = arguments[v];
              l.apply(this, p);
            }
          };
        }
        function u() {
        }
        function s(l) {
          return l.setHeader && typeof l.abort == "function";
        }
        function c(l, f, d) {
          if (typeof f == "function") return c(l, null, f);
          f || (f = {}), d = a(d || u);
          var p = f.readable || f.readable !== !1 && l.readable, v = f.writable || f.writable !== !1 && l.writable, h = function() {
            l.writable || m();
          }, E = l._writableState && l._writableState.finished, m = function() {
            v = !1, E = !0, p || d.call(l);
          }, g = l._readableState && l._readableState.endEmitted, y = function() {
            p = !1, g = !0, v || d.call(l);
          }, _ = function(P) {
            d.call(l, P);
          }, S = function() {
            var P;
            if (p && !g)
              return (!l._readableState || !l._readableState.ended) && (P = new o()), d.call(l, P);
            if (v && !E)
              return (!l._writableState || !l._writableState.ended) && (P = new o()), d.call(l, P);
          }, A = function() {
            l.req.on("finish", m);
          };
          return s(l) ? (l.on("complete", m), l.on("abort", S), l.req ? A() : l.on("request", A)) : v && !l._writableState && (l.on("end", h), l.on("close", h)), l.on("end", y), l.on("finish", m), f.error !== !1 && l.on("error", _), l.on("close", S), function() {
            l.removeListener("complete", m), l.removeListener("abort", S), l.removeListener("request", A), l.req && l.req.removeListener("finish", m), l.removeListener("end", h), l.removeListener("close", h), l.removeListener("finish", m), l.removeListener("end", y), l.removeListener("error", _), l.removeListener("close", S);
          };
        }
        n.exports = c;
      }, { "../../../errors": 42 }], 52: [function(r, n, i) {
        n.exports = function() {
          throw new Error("Readable.from is not available in the browser");
        };
      }, {}], 53: [function(r, n, i) {
        var o;
        function a(m) {
          var g = !1;
          return function() {
            g || (g = !0, m.apply(void 0, arguments));
          };
        }
        var u = r("../../../errors").codes, s = u.ERR_MISSING_ARGS, c = u.ERR_STREAM_DESTROYED;
        function l(m) {
          if (m) throw m;
        }
        function f(m) {
          return m.setHeader && typeof m.abort == "function";
        }
        function d(m, g, y, _) {
          _ = a(_);
          var S = !1;
          m.on("close", function() {
            S = !0;
          }), o === void 0 && (o = r("./end-of-stream")), o(m, {
            readable: g,
            writable: y
          }, function(O) {
            if (O) return _(O);
            S = !0, _();
          });
          var A = !1;
          return function(O) {
            if (!S && !A) {
              if (A = !0, f(m)) return m.abort();
              if (typeof m.destroy == "function") return m.destroy();
              _(O || new c("pipe"));
            }
          };
        }
        function p(m) {
          m();
        }
        function v(m, g) {
          return m.pipe(g);
        }
        function h(m) {
          return !m.length || typeof m[m.length - 1] != "function" ? l : m.pop();
        }
        function E() {
          for (var m = arguments.length, g = new Array(m), y = 0; y < m; y++)
            g[y] = arguments[y];
          var _ = h(g);
          if (Array.isArray(g[0]) && (g = g[0]), g.length < 2)
            throw new s("streams");
          var S, A = g.map(function(O, P) {
            var U = P < g.length - 1, z = P > 0;
            return d(O, U, z, function(k) {
              S || (S = k), k && A.forEach(p), !U && (A.forEach(p), _(S));
            });
          });
          return g.reduce(v);
        }
        n.exports = E;
      }, { "../../../errors": 42, "./end-of-stream": 51 }], 54: [function(r, n, i) {
        var o = r("../../../errors").codes.ERR_INVALID_OPT_VALUE;
        function a(s, c, l) {
          return s.highWaterMark != null ? s.highWaterMark : c ? s[l] : null;
        }
        function u(s, c, l, f) {
          var d = a(c, f, l);
          if (d != null) {
            if (!(isFinite(d) && Math.floor(d) === d) || d < 0) {
              var p = f ? l : "highWaterMark";
              throw new o(p, d);
            }
            return Math.floor(d);
          }
          return s.objectMode ? 16 : 16 * 1024;
        }
        n.exports = {
          getHighWaterMark: u
        };
      }, { "../../../errors": 42 }], 55: [function(r, n, i) {
        n.exports = r("events").EventEmitter;
      }, { events: 36 }], 56: [function(r, n, i) {
        var o = r("safe-buffer").Buffer, a = o.isEncoding || function(A) {
          switch (A = "" + A, A && A.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return !0;
            default:
              return !1;
          }
        };
        function u(A) {
          if (!A) return "utf8";
          for (var O; ; )
            switch (A) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return A;
              default:
                if (O) return;
                A = ("" + A).toLowerCase(), O = !0;
            }
        }
        function s(A) {
          var O = u(A);
          if (typeof O != "string" && (o.isEncoding === a || !a(A))) throw new Error("Unknown encoding: " + A);
          return O || A;
        }
        i.StringDecoder = c;
        function c(A) {
          this.encoding = s(A);
          var O;
          switch (this.encoding) {
            case "utf16le":
              this.text = E, this.end = m, O = 4;
              break;
            case "utf8":
              this.fillLast = p, O = 4;
              break;
            case "base64":
              this.text = g, this.end = y, O = 3;
              break;
            default:
              this.write = _, this.end = S;
              return;
          }
          this.lastNeed = 0, this.lastTotal = 0, this.lastChar = o.allocUnsafe(O);
        }
        c.prototype.write = function(A) {
          if (A.length === 0) return "";
          var O, P;
          if (this.lastNeed) {
            if (O = this.fillLast(A), O === void 0) return "";
            P = this.lastNeed, this.lastNeed = 0;
          } else
            P = 0;
          return P < A.length ? O ? O + this.text(A, P) : this.text(A, P) : O || "";
        }, c.prototype.end = h, c.prototype.text = v, c.prototype.fillLast = function(A) {
          if (this.lastNeed <= A.length)
            return A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, A.length), this.lastNeed -= A.length;
        };
        function l(A) {
          return A <= 127 ? 0 : A >> 5 === 6 ? 2 : A >> 4 === 14 ? 3 : A >> 3 === 30 ? 4 : A >> 6 === 2 ? -1 : -2;
        }
        function f(A, O, P) {
          var U = O.length - 1;
          if (U < P) return 0;
          var z = l(O[U]);
          return z >= 0 ? (z > 0 && (A.lastNeed = z - 1), z) : --U < P || z === -2 ? 0 : (z = l(O[U]), z >= 0 ? (z > 0 && (A.lastNeed = z - 2), z) : --U < P || z === -2 ? 0 : (z = l(O[U]), z >= 0 ? (z > 0 && (z === 2 ? z = 0 : A.lastNeed = z - 3), z) : 0));
        }
        function d(A, O, P) {
          if ((O[0] & 192) !== 128)
            return A.lastNeed = 0, "�";
          if (A.lastNeed > 1 && O.length > 1) {
            if ((O[1] & 192) !== 128)
              return A.lastNeed = 1, "�";
            if (A.lastNeed > 2 && O.length > 2 && (O[2] & 192) !== 128)
              return A.lastNeed = 2, "�";
          }
        }
        function p(A) {
          var O = this.lastTotal - this.lastNeed, P = d(this, A);
          if (P !== void 0) return P;
          if (this.lastNeed <= A.length)
            return A.copy(this.lastChar, O, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          A.copy(this.lastChar, O, 0, A.length), this.lastNeed -= A.length;
        }
        function v(A, O) {
          var P = f(this, A, O);
          if (!this.lastNeed) return A.toString("utf8", O);
          this.lastTotal = P;
          var U = A.length - (P - this.lastNeed);
          return A.copy(this.lastChar, 0, U), A.toString("utf8", O, U);
        }
        function h(A) {
          var O = A && A.length ? this.write(A) : "";
          return this.lastNeed ? O + "�" : O;
        }
        function E(A, O) {
          if ((A.length - O) % 2 === 0) {
            var P = A.toString("utf16le", O);
            if (P) {
              var U = P.charCodeAt(P.length - 1);
              if (U >= 55296 && U <= 56319)
                return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1], P.slice(0, -1);
            }
            return P;
          }
          return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = A[A.length - 1], A.toString("utf16le", O, A.length - 1);
        }
        function m(A) {
          var O = A && A.length ? this.write(A) : "";
          if (this.lastNeed) {
            var P = this.lastTotal - this.lastNeed;
            return O + this.lastChar.toString("utf16le", 0, P);
          }
          return O;
        }
        function g(A, O) {
          var P = (A.length - O) % 3;
          return P === 0 ? A.toString("base64", O) : (this.lastNeed = 3 - P, this.lastTotal = 3, P === 1 ? this.lastChar[0] = A[A.length - 1] : (this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1]), A.toString("base64", O, A.length - P));
        }
        function y(A) {
          var O = A && A.length ? this.write(A) : "";
          return this.lastNeed ? O + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : O;
        }
        function _(A) {
          return A.toString(this.encoding);
        }
        function S(A) {
          return A && A.length ? this.write(A) : "";
        }
      }, { "safe-buffer": 40 }], 57: [function(r, n, i) {
        (function(o) {
          (function() {
            n.exports = a;
            function a(s, c) {
              if (u("noDeprecation"))
                return s;
              var l = !1;
              function f() {
                if (!l) {
                  if (u("throwDeprecation"))
                    throw new Error(c);
                  u("traceDeprecation") ? console.trace(c) : console.warn(c), l = !0;
                }
                return s.apply(this, arguments);
              }
              return f;
            }
            function u(s) {
              try {
                if (!o.localStorage) return !1;
              } catch {
                return !1;
              }
              var c = o.localStorage[s];
              return c == null ? !1 : String(c).toLowerCase() === "true";
            }
          }).call(this);
        }).call(this, typeof fe < "u" ? fe : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}], 58: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), Object.defineProperty(i, "v1", {
          enumerable: !0,
          get: function() {
            return o.default;
          }
        }), Object.defineProperty(i, "v3", {
          enumerable: !0,
          get: function() {
            return a.default;
          }
        }), Object.defineProperty(i, "v4", {
          enumerable: !0,
          get: function() {
            return u.default;
          }
        }), Object.defineProperty(i, "v5", {
          enumerable: !0,
          get: function() {
            return s.default;
          }
        }), Object.defineProperty(i, "NIL", {
          enumerable: !0,
          get: function() {
            return c.default;
          }
        }), Object.defineProperty(i, "version", {
          enumerable: !0,
          get: function() {
            return l.default;
          }
        }), Object.defineProperty(i, "validate", {
          enumerable: !0,
          get: function() {
            return f.default;
          }
        }), Object.defineProperty(i, "stringify", {
          enumerable: !0,
          get: function() {
            return d.default;
          }
        }), Object.defineProperty(i, "parse", {
          enumerable: !0,
          get: function() {
            return p.default;
          }
        });
        var o = v(r("./v1.js")), a = v(r("./v3.js")), u = v(r("./v4.js")), s = v(r("./v5.js")), c = v(r("./nil.js")), l = v(r("./version.js")), f = v(r("./validate.js")), d = v(r("./stringify.js")), p = v(r("./parse.js"));
        function v(h) {
          return h && h.__esModule ? h : { default: h };
        }
      }, { "./nil.js": 60, "./parse.js": 61, "./stringify.js": 65, "./v1.js": 66, "./v3.js": 67, "./v4.js": 69, "./v5.js": 70, "./validate.js": 71, "./version.js": 72 }], 59: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        function o(g) {
          if (typeof g == "string") {
            const y = unescape(encodeURIComponent(g));
            g = new Uint8Array(y.length);
            for (let _ = 0; _ < y.length; ++_)
              g[_] = y.charCodeAt(_);
          }
          return a(s(c(g), g.length * 8));
        }
        function a(g) {
          const y = [], _ = g.length * 32, S = "0123456789abcdef";
          for (let A = 0; A < _; A += 8) {
            const O = g[A >> 5] >>> A % 32 & 255, P = parseInt(S.charAt(O >>> 4 & 15) + S.charAt(O & 15), 16);
            y.push(P);
          }
          return y;
        }
        function u(g) {
          return (g + 64 >>> 9 << 4) + 14 + 1;
        }
        function s(g, y) {
          g[y >> 5] |= 128 << y % 32, g[u(y) - 1] = y;
          let _ = 1732584193, S = -271733879, A = -1732584194, O = 271733878;
          for (let P = 0; P < g.length; P += 16) {
            const U = _, z = S, k = A, H = O;
            _ = p(_, S, A, O, g[P], 7, -680876936), O = p(O, _, S, A, g[P + 1], 12, -389564586), A = p(A, O, _, S, g[P + 2], 17, 606105819), S = p(S, A, O, _, g[P + 3], 22, -1044525330), _ = p(_, S, A, O, g[P + 4], 7, -176418897), O = p(O, _, S, A, g[P + 5], 12, 1200080426), A = p(A, O, _, S, g[P + 6], 17, -1473231341), S = p(S, A, O, _, g[P + 7], 22, -45705983), _ = p(_, S, A, O, g[P + 8], 7, 1770035416), O = p(O, _, S, A, g[P + 9], 12, -1958414417), A = p(A, O, _, S, g[P + 10], 17, -42063), S = p(S, A, O, _, g[P + 11], 22, -1990404162), _ = p(_, S, A, O, g[P + 12], 7, 1804603682), O = p(O, _, S, A, g[P + 13], 12, -40341101), A = p(A, O, _, S, g[P + 14], 17, -1502002290), S = p(S, A, O, _, g[P + 15], 22, 1236535329), _ = v(_, S, A, O, g[P + 1], 5, -165796510), O = v(O, _, S, A, g[P + 6], 9, -1069501632), A = v(A, O, _, S, g[P + 11], 14, 643717713), S = v(S, A, O, _, g[P], 20, -373897302), _ = v(_, S, A, O, g[P + 5], 5, -701558691), O = v(O, _, S, A, g[P + 10], 9, 38016083), A = v(A, O, _, S, g[P + 15], 14, -660478335), S = v(S, A, O, _, g[P + 4], 20, -405537848), _ = v(_, S, A, O, g[P + 9], 5, 568446438), O = v(O, _, S, A, g[P + 14], 9, -1019803690), A = v(A, O, _, S, g[P + 3], 14, -187363961), S = v(S, A, O, _, g[P + 8], 20, 1163531501), _ = v(_, S, A, O, g[P + 13], 5, -1444681467), O = v(O, _, S, A, g[P + 2], 9, -51403784), A = v(A, O, _, S, g[P + 7], 14, 1735328473), S = v(S, A, O, _, g[P + 12], 20, -1926607734), _ = h(_, S, A, O, g[P + 5], 4, -378558), O = h(O, _, S, A, g[P + 8], 11, -2022574463), A = h(A, O, _, S, g[P + 11], 16, 1839030562), S = h(S, A, O, _, g[P + 14], 23, -35309556), _ = h(_, S, A, O, g[P + 1], 4, -1530992060), O = h(O, _, S, A, g[P + 4], 11, 1272893353), A = h(A, O, _, S, g[P + 7], 16, -155497632), S = h(S, A, O, _, g[P + 10], 23, -1094730640), _ = h(_, S, A, O, g[P + 13], 4, 681279174), O = h(O, _, S, A, g[P], 11, -358537222), A = h(A, O, _, S, g[P + 3], 16, -722521979), S = h(S, A, O, _, g[P + 6], 23, 76029189), _ = h(_, S, A, O, g[P + 9], 4, -640364487), O = h(O, _, S, A, g[P + 12], 11, -421815835), A = h(A, O, _, S, g[P + 15], 16, 530742520), S = h(S, A, O, _, g[P + 2], 23, -995338651), _ = E(_, S, A, O, g[P], 6, -198630844), O = E(O, _, S, A, g[P + 7], 10, 1126891415), A = E(A, O, _, S, g[P + 14], 15, -1416354905), S = E(S, A, O, _, g[P + 5], 21, -57434055), _ = E(_, S, A, O, g[P + 12], 6, 1700485571), O = E(O, _, S, A, g[P + 3], 10, -1894986606), A = E(A, O, _, S, g[P + 10], 15, -1051523), S = E(S, A, O, _, g[P + 1], 21, -2054922799), _ = E(_, S, A, O, g[P + 8], 6, 1873313359), O = E(O, _, S, A, g[P + 15], 10, -30611744), A = E(A, O, _, S, g[P + 6], 15, -1560198380), S = E(S, A, O, _, g[P + 13], 21, 1309151649), _ = E(_, S, A, O, g[P + 4], 6, -145523070), O = E(O, _, S, A, g[P + 11], 10, -1120210379), A = E(A, O, _, S, g[P + 2], 15, 718787259), S = E(S, A, O, _, g[P + 9], 21, -343485551), _ = l(_, U), S = l(S, z), A = l(A, k), O = l(O, H);
          }
          return [_, S, A, O];
        }
        function c(g) {
          if (g.length === 0)
            return [];
          const y = g.length * 8, _ = new Uint32Array(u(y));
          for (let S = 0; S < y; S += 8)
            _[S >> 5] |= (g[S / 8] & 255) << S % 32;
          return _;
        }
        function l(g, y) {
          const _ = (g & 65535) + (y & 65535);
          return (g >> 16) + (y >> 16) + (_ >> 16) << 16 | _ & 65535;
        }
        function f(g, y) {
          return g << y | g >>> 32 - y;
        }
        function d(g, y, _, S, A, O) {
          return l(f(l(l(y, g), l(S, O)), A), _);
        }
        function p(g, y, _, S, A, O, P) {
          return d(y & _ | ~y & S, g, y, A, O, P);
        }
        function v(g, y, _, S, A, O, P) {
          return d(y & S | _ & ~S, g, y, A, O, P);
        }
        function h(g, y, _, S, A, O, P) {
          return d(y ^ _ ^ S, g, y, A, O, P);
        }
        function E(g, y, _, S, A, O, P) {
          return d(_ ^ (y | ~S), g, y, A, O, P);
        }
        var m = o;
        i.default = m;
      }, {}], 60: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = "00000000-0000-0000-0000-000000000000";
        i.default = o;
      }, {}], 61: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = a(r("./validate.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        function u(c) {
          if (!(0, o.default)(c))
            throw TypeError("Invalid UUID");
          let l;
          const f = new Uint8Array(16);
          return f[0] = (l = parseInt(c.slice(0, 8), 16)) >>> 24, f[1] = l >>> 16 & 255, f[2] = l >>> 8 & 255, f[3] = l & 255, f[4] = (l = parseInt(c.slice(9, 13), 16)) >>> 8, f[5] = l & 255, f[6] = (l = parseInt(c.slice(14, 18), 16)) >>> 8, f[7] = l & 255, f[8] = (l = parseInt(c.slice(19, 23), 16)) >>> 8, f[9] = l & 255, f[10] = (l = parseInt(c.slice(24, 36), 16)) / 1099511627776 & 255, f[11] = l / 4294967296 & 255, f[12] = l >>> 24 & 255, f[13] = l >>> 16 & 255, f[14] = l >>> 8 & 255, f[15] = l & 255, f;
        }
        var s = u;
        i.default = s;
      }, { "./validate.js": 71 }], 62: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
        i.default = o;
      }, {}], 63: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = u;
        let o;
        const a = new Uint8Array(16);
        function u() {
          if (!o && (o = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !o))
            throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
          return o(a);
        }
      }, {}], 64: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        function o(c, l, f, d) {
          switch (c) {
            case 0:
              return l & f ^ ~l & d;
            case 1:
              return l ^ f ^ d;
            case 2:
              return l & f ^ l & d ^ f & d;
            case 3:
              return l ^ f ^ d;
          }
        }
        function a(c, l) {
          return c << l | c >>> 32 - l;
        }
        function u(c) {
          const l = [1518500249, 1859775393, 2400959708, 3395469782], f = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
          if (typeof c == "string") {
            const h = unescape(encodeURIComponent(c));
            c = [];
            for (let E = 0; E < h.length; ++E)
              c.push(h.charCodeAt(E));
          } else Array.isArray(c) || (c = Array.prototype.slice.call(c));
          c.push(128);
          const d = c.length / 4 + 2, p = Math.ceil(d / 16), v = new Array(p);
          for (let h = 0; h < p; ++h) {
            const E = new Uint32Array(16);
            for (let m = 0; m < 16; ++m)
              E[m] = c[h * 64 + m * 4] << 24 | c[h * 64 + m * 4 + 1] << 16 | c[h * 64 + m * 4 + 2] << 8 | c[h * 64 + m * 4 + 3];
            v[h] = E;
          }
          v[p - 1][14] = (c.length - 1) * 8 / Math.pow(2, 32), v[p - 1][14] = Math.floor(v[p - 1][14]), v[p - 1][15] = (c.length - 1) * 8 & 4294967295;
          for (let h = 0; h < p; ++h) {
            const E = new Uint32Array(80);
            for (let A = 0; A < 16; ++A)
              E[A] = v[h][A];
            for (let A = 16; A < 80; ++A)
              E[A] = a(E[A - 3] ^ E[A - 8] ^ E[A - 14] ^ E[A - 16], 1);
            let m = f[0], g = f[1], y = f[2], _ = f[3], S = f[4];
            for (let A = 0; A < 80; ++A) {
              const O = Math.floor(A / 20), P = a(m, 5) + o(O, g, y, _) + S + l[O] + E[A] >>> 0;
              S = _, _ = y, y = a(g, 30) >>> 0, g = m, m = P;
            }
            f[0] = f[0] + m >>> 0, f[1] = f[1] + g >>> 0, f[2] = f[2] + y >>> 0, f[3] = f[3] + _ >>> 0, f[4] = f[4] + S >>> 0;
          }
          return [f[0] >> 24 & 255, f[0] >> 16 & 255, f[0] >> 8 & 255, f[0] & 255, f[1] >> 24 & 255, f[1] >> 16 & 255, f[1] >> 8 & 255, f[1] & 255, f[2] >> 24 & 255, f[2] >> 16 & 255, f[2] >> 8 & 255, f[2] & 255, f[3] >> 24 & 255, f[3] >> 16 & 255, f[3] >> 8 & 255, f[3] & 255, f[4] >> 24 & 255, f[4] >> 16 & 255, f[4] >> 8 & 255, f[4] & 255];
        }
        var s = u;
        i.default = s;
      }, {}], 65: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = a(r("./validate.js"));
        function a(l) {
          return l && l.__esModule ? l : { default: l };
        }
        const u = [];
        for (let l = 0; l < 256; ++l)
          u.push((l + 256).toString(16).substr(1));
        function s(l, f = 0) {
          const d = (u[l[f + 0]] + u[l[f + 1]] + u[l[f + 2]] + u[l[f + 3]] + "-" + u[l[f + 4]] + u[l[f + 5]] + "-" + u[l[f + 6]] + u[l[f + 7]] + "-" + u[l[f + 8]] + u[l[f + 9]] + "-" + u[l[f + 10]] + u[l[f + 11]] + u[l[f + 12]] + u[l[f + 13]] + u[l[f + 14]] + u[l[f + 15]]).toLowerCase();
          if (!(0, o.default)(d))
            throw TypeError("Stringified UUID is invalid");
          return d;
        }
        var c = s;
        i.default = c;
      }, { "./validate.js": 71 }], 66: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = u(r("./rng.js")), a = u(r("./stringify.js"));
        function u(v) {
          return v && v.__esModule ? v : { default: v };
        }
        let s, c, l = 0, f = 0;
        function d(v, h, E) {
          let m = h && E || 0;
          const g = h || new Array(16);
          v = v || {};
          let y = v.node || s, _ = v.clockseq !== void 0 ? v.clockseq : c;
          if (y == null || _ == null) {
            const z = v.random || (v.rng || o.default)();
            y == null && (y = s = [z[0] | 1, z[1], z[2], z[3], z[4], z[5]]), _ == null && (_ = c = (z[6] << 8 | z[7]) & 16383);
          }
          let S = v.msecs !== void 0 ? v.msecs : Date.now(), A = v.nsecs !== void 0 ? v.nsecs : f + 1;
          const O = S - l + (A - f) / 1e4;
          if (O < 0 && v.clockseq === void 0 && (_ = _ + 1 & 16383), (O < 0 || S > l) && v.nsecs === void 0 && (A = 0), A >= 1e4)
            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          l = S, f = A, c = _, S += 122192928e5;
          const P = ((S & 268435455) * 1e4 + A) % 4294967296;
          g[m++] = P >>> 24 & 255, g[m++] = P >>> 16 & 255, g[m++] = P >>> 8 & 255, g[m++] = P & 255;
          const U = S / 4294967296 * 1e4 & 268435455;
          g[m++] = U >>> 8 & 255, g[m++] = U & 255, g[m++] = U >>> 24 & 15 | 16, g[m++] = U >>> 16 & 255, g[m++] = _ >>> 8 | 128, g[m++] = _ & 255;
          for (let z = 0; z < 6; ++z)
            g[m + z] = y[z];
          return h || (0, a.default)(g);
        }
        var p = d;
        i.default = p;
      }, { "./rng.js": 63, "./stringify.js": 65 }], 67: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = u(r("./v35.js")), a = u(r("./md5.js"));
        function u(l) {
          return l && l.__esModule ? l : { default: l };
        }
        var c = (0, o.default)("v3", 48, a.default);
        i.default = c;
      }, { "./md5.js": 59, "./v35.js": 68 }], 68: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = f, i.URL = i.DNS = void 0;
        var o = u(r("./stringify.js")), a = u(r("./parse.js"));
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        function s(d) {
          d = unescape(encodeURIComponent(d));
          const p = [];
          for (let v = 0; v < d.length; ++v)
            p.push(d.charCodeAt(v));
          return p;
        }
        const c = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
        i.DNS = c;
        const l = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
        i.URL = l;
        function f(d, p, v) {
          function h(E, m, g, y) {
            if (typeof E == "string" && (E = s(E)), typeof m == "string" && (m = (0, a.default)(m)), m.length !== 16)
              throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
            let _ = new Uint8Array(16 + E.length);
            if (_.set(m), _.set(E, m.length), _ = v(_), _[6] = _[6] & 15 | p, _[8] = _[8] & 63 | 128, g) {
              y = y || 0;
              for (let S = 0; S < 16; ++S)
                g[y + S] = _[S];
              return g;
            }
            return (0, o.default)(_);
          }
          try {
            h.name = d;
          } catch {
          }
          return h.DNS = c, h.URL = l, h;
        }
      }, { "./parse.js": 61, "./stringify.js": 65 }], 69: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = u(r("./rng.js")), a = u(r("./stringify.js"));
        function u(l) {
          return l && l.__esModule ? l : { default: l };
        }
        function s(l, f, d) {
          l = l || {};
          const p = l.random || (l.rng || o.default)();
          if (p[6] = p[6] & 15 | 64, p[8] = p[8] & 63 | 128, f) {
            d = d || 0;
            for (let v = 0; v < 16; ++v)
              f[d + v] = p[v];
            return f;
          }
          return (0, a.default)(p);
        }
        var c = s;
        i.default = c;
      }, { "./rng.js": 63, "./stringify.js": 65 }], 70: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = u(r("./v35.js")), a = u(r("./sha1.js"));
        function u(l) {
          return l && l.__esModule ? l : { default: l };
        }
        var c = (0, o.default)("v5", 80, a.default);
        i.default = c;
      }, { "./sha1.js": 64, "./v35.js": 68 }], 71: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = a(r("./regex.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        function u(c) {
          return typeof c == "string" && o.default.test(c);
        }
        var s = u;
        i.default = s;
      }, { "./regex.js": 62 }], 72: [function(r, n, i) {
        Object.defineProperty(i, "__esModule", {
          value: !0
        }), i.default = void 0;
        var o = a(r("./validate.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        function u(c) {
          if (!(0, o.default)(c))
            throw TypeError("Invalid UUID");
          return parseInt(c.substr(14, 1), 16);
        }
        var s = u;
        i.default = s;
      }, { "./validate.js": 71 }] }, {}, [9])(9);
    });
  }(DD)), DD.exports;
}
var xD = {}, XQ;
function Str() {
  return XQ || (XQ = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    function t() {
      var n = {};
      return n.promise = new Promise(function(i, o) {
        n.reject = o, n.resolve = i;
      }), n;
    }
    var r = t;
    e.default = r;
  }(xD)), xD;
}
var hA = { exports: {} }, JQ;
function btr() {
  return JQ || (JQ = 1, function(e, t) {
    var r = typeof self < "u" ? self : fe, n = function() {
      function o() {
        this.fetch = !1, this.DOMException = r.DOMException;
      }
      return o.prototype = r, new o();
    }();
    (function(o) {
      (function(a) {
        var u = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob: "FileReader" in o && "Blob" in o && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o
        };
        function s(x) {
          return x && DataView.prototype.isPrototypeOf(x);
        }
        if (u.arrayBuffer)
          var c = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], l = ArrayBuffer.isView || function(x) {
            return x && c.indexOf(Object.prototype.toString.call(x)) > -1;
          };
        function f(x) {
          if (typeof x != "string" && (x = String(x)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(x))
            throw new TypeError("Invalid character in header field name");
          return x.toLowerCase();
        }
        function d(x) {
          return typeof x != "string" && (x = String(x)), x;
        }
        function p(x) {
          var D = {
            next: function() {
              var w = x.shift();
              return { done: w === void 0, value: w };
            }
          };
          return u.iterable && (D[Symbol.iterator] = function() {
            return D;
          }), D;
        }
        function v(x) {
          this.map = {}, x instanceof v ? x.forEach(function(D, w) {
            this.append(w, D);
          }, this) : Array.isArray(x) ? x.forEach(function(D) {
            this.append(D[0], D[1]);
          }, this) : x && Object.getOwnPropertyNames(x).forEach(function(D) {
            this.append(D, x[D]);
          }, this);
        }
        v.prototype.append = function(x, D) {
          x = f(x), D = d(D);
          var w = this.map[x];
          this.map[x] = w ? w + ", " + D : D;
        }, v.prototype.delete = function(x) {
          delete this.map[f(x)];
        }, v.prototype.get = function(x) {
          return x = f(x), this.has(x) ? this.map[x] : null;
        }, v.prototype.has = function(x) {
          return this.map.hasOwnProperty(f(x));
        }, v.prototype.set = function(x, D) {
          this.map[f(x)] = d(D);
        }, v.prototype.forEach = function(x, D) {
          for (var w in this.map)
            this.map.hasOwnProperty(w) && x.call(D, this.map[w], w, this);
        }, v.prototype.keys = function() {
          var x = [];
          return this.forEach(function(D, w) {
            x.push(w);
          }), p(x);
        }, v.prototype.values = function() {
          var x = [];
          return this.forEach(function(D) {
            x.push(D);
          }), p(x);
        }, v.prototype.entries = function() {
          var x = [];
          return this.forEach(function(D, w) {
            x.push([w, D]);
          }), p(x);
        }, u.iterable && (v.prototype[Symbol.iterator] = v.prototype.entries);
        function h(x) {
          if (x.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          x.bodyUsed = !0;
        }
        function E(x) {
          return new Promise(function(D, w) {
            x.onload = function() {
              D(x.result);
            }, x.onerror = function() {
              w(x.error);
            };
          });
        }
        function m(x) {
          var D = new FileReader(), w = E(D);
          return D.readAsArrayBuffer(x), w;
        }
        function g(x) {
          var D = new FileReader(), w = E(D);
          return D.readAsText(x), w;
        }
        function y(x) {
          for (var D = new Uint8Array(x), w = new Array(D.length), $ = 0; $ < D.length; $++)
            w[$] = String.fromCharCode(D[$]);
          return w.join("");
        }
        function _(x) {
          if (x.slice)
            return x.slice(0);
          var D = new Uint8Array(x.byteLength);
          return D.set(new Uint8Array(x)), D.buffer;
        }
        function S() {
          return this.bodyUsed = !1, this._initBody = function(x) {
            this._bodyInit = x, x ? typeof x == "string" ? this._bodyText = x : u.blob && Blob.prototype.isPrototypeOf(x) ? this._bodyBlob = x : u.formData && FormData.prototype.isPrototypeOf(x) ? this._bodyFormData = x : u.searchParams && URLSearchParams.prototype.isPrototypeOf(x) ? this._bodyText = x.toString() : u.arrayBuffer && u.blob && s(x) ? (this._bodyArrayBuffer = _(x.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(x) || l(x)) ? this._bodyArrayBuffer = _(x) : this._bodyText = x = Object.prototype.toString.call(x) : this._bodyText = "", this.headers.get("content-type") || (typeof x == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(x) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, u.blob && (this.blob = function() {
            var x = h(this);
            if (x)
              return x;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
          }), this.text = function() {
            var x = h(this);
            if (x)
              return x;
            if (this._bodyBlob)
              return g(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(y(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, u.formData && (this.formData = function() {
            return this.text().then(U);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var A = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function O(x) {
          var D = x.toUpperCase();
          return A.indexOf(D) > -1 ? D : x;
        }
        function P(x, D) {
          D = D || {};
          var w = D.body;
          if (x instanceof P) {
            if (x.bodyUsed)
              throw new TypeError("Already read");
            this.url = x.url, this.credentials = x.credentials, D.headers || (this.headers = new v(x.headers)), this.method = x.method, this.mode = x.mode, this.signal = x.signal, !w && x._bodyInit != null && (w = x._bodyInit, x.bodyUsed = !0);
          } else
            this.url = String(x);
          if (this.credentials = D.credentials || this.credentials || "same-origin", (D.headers || !this.headers) && (this.headers = new v(D.headers)), this.method = O(D.method || this.method || "GET"), this.mode = D.mode || this.mode || null, this.signal = D.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && w)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(w);
        }
        P.prototype.clone = function() {
          return new P(this, { body: this._bodyInit });
        };
        function U(x) {
          var D = new FormData();
          return x.trim().split("&").forEach(function(w) {
            if (w) {
              var $ = w.split("="), X = $.shift().replace(/\+/g, " "), V = $.join("=").replace(/\+/g, " ");
              D.append(decodeURIComponent(X), decodeURIComponent(V));
            }
          }), D;
        }
        function z(x) {
          var D = new v(), w = x.replace(/\r?\n[\t ]+/g, " ");
          return w.split(/\r?\n/).forEach(function($) {
            var X = $.split(":"), V = X.shift().trim();
            if (V) {
              var F = X.join(":").trim();
              D.append(V, F);
            }
          }), D;
        }
        S.call(P.prototype);
        function k(x, D) {
          D || (D = {}), this.type = "default", this.status = D.status === void 0 ? 200 : D.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in D ? D.statusText : "OK", this.headers = new v(D.headers), this.url = D.url || "", this._initBody(x);
        }
        S.call(k.prototype), k.prototype.clone = function() {
          return new k(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new v(this.headers),
            url: this.url
          });
        }, k.error = function() {
          var x = new k(null, { status: 0, statusText: "" });
          return x.type = "error", x;
        };
        var H = [301, 302, 303, 307, 308];
        k.redirect = function(x, D) {
          if (H.indexOf(D) === -1)
            throw new RangeError("Invalid status code");
          return new k(null, { status: D, headers: { location: x } });
        }, a.DOMException = o.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(D, w) {
            this.message = D, this.name = w;
            var $ = Error(D);
            this.stack = $.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function B(x, D) {
          return new Promise(function(w, $) {
            var X = new P(x, D);
            if (X.signal && X.signal.aborted)
              return $(new a.DOMException("Aborted", "AbortError"));
            var V = new XMLHttpRequest();
            function F() {
              V.abort();
            }
            V.onload = function() {
              var le = {
                status: V.status,
                statusText: V.statusText,
                headers: z(V.getAllResponseHeaders() || "")
              };
              le.url = "responseURL" in V ? V.responseURL : le.headers.get("X-Request-URL");
              var ae = "response" in V ? V.response : V.responseText;
              w(new k(ae, le));
            }, V.onerror = function() {
              $(new TypeError("Network request failed"));
            }, V.ontimeout = function() {
              $(new TypeError("Network request failed"));
            }, V.onabort = function() {
              $(new a.DOMException("Aborted", "AbortError"));
            }, V.open(X.method, X.url, !0), X.credentials === "include" ? V.withCredentials = !0 : X.credentials === "omit" && (V.withCredentials = !1), "responseType" in V && u.blob && (V.responseType = "blob"), X.headers.forEach(function(le, ae) {
              V.setRequestHeader(ae, le);
            }), X.signal && (X.signal.addEventListener("abort", F), V.onreadystatechange = function() {
              V.readyState === 4 && X.signal.removeEventListener("abort", F);
            }), V.send(typeof X._bodyInit > "u" ? null : X._bodyInit);
          });
        }
        return B.polyfill = !0, o.fetch || (o.fetch = B, o.Headers = v, o.Request = P, o.Response = k), a.Headers = v, a.Request = P, a.Response = k, a.fetch = B, Object.defineProperty(a, "__esModule", { value: !0 }), a;
      })({});
    })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
    var i = n;
    t = i.fetch, t.default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
  }(hA, hA.exports)), hA.exports;
}
var ND = {}, LD = { exports: {} }, ZQ;
function _1e() {
  return ZQ || (ZQ = 1, function(e) {
    function t(r) {
      if (r === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(LD)), LD.exports;
}
var BD = { exports: {} }, kD = { exports: {} }, MD = { exports: {} }, QQ;
function A1e() {
  return QQ || (QQ = 1, function(e) {
    function t(r) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, t(r);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(MD)), MD.exports;
}
var eee;
function Ctr() {
  return eee || (eee = 1, function(e) {
    var t = A1e();
    function r(n, i) {
      for (; !Object.prototype.hasOwnProperty.call(n, i) && (n = t(n), n !== null); )
        ;
      return n;
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(kD)), kD.exports;
}
var tee;
function Itr() {
  return tee || (tee = 1, function(e) {
    var t = Ctr();
    function r(n, i, o) {
      return typeof Reflect < "u" && Reflect.get ? (e.exports = r = Reflect.get, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = r = function(u, s, c) {
        var l = t(u, s);
        if (l) {
          var f = Object.getOwnPropertyDescriptor(l, s);
          return f.get ? f.get.call(c) : f.value;
        }
      }, e.exports.default = e.exports, e.exports.__esModule = !0), r(n, i, o || n);
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(BD)), BD.exports;
}
var FD = { exports: {} }, HD = { exports: {} }, ree;
function Otr() {
  return ree || (ree = 1, function(e) {
    function t(r, n) {
      return e.exports = t = Object.setPrototypeOf || function(o, a) {
        return o.__proto__ = a, o;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, t(r, n);
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(HD)), HD.exports;
}
var nee;
function Rtr() {
  return nee || (nee = 1, function(e) {
    var t = Otr();
    function r(n, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), i && t(n, i);
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(FD)), FD.exports;
}
var $D = { exports: {} }, iee;
function wtr() {
  return iee || (iee = 1, function(e) {
    var t = LF.default, r = _1e();
    function n(i, o) {
      return o && (t(o) === "object" || typeof o == "function") ? o : r(i);
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }($D)), $D.exports;
}
var oee;
function Ptr() {
  return oee || (oee = 1, function(e) {
    var t = my;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = t(BF()), n = t(kF()), i = t(_1e()), o = t(Itr()), a = t(Rtr()), u = t(wtr()), s = t(A1e()), c = t(g1e()), l = t(T1e()), f = y1e();
    function d(y) {
      var _ = p();
      return function() {
        var A = (0, s.default)(y), O;
        if (_) {
          var P = (0, s.default)(this).constructor;
          O = Reflect.construct(A, arguments, P);
        } else
          O = A.apply(this, arguments);
        return (0, u.default)(this, O);
      };
    }
    function p() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var v = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ function(y) {
      (0, a.default)(S, y);
      var _ = d(S);
      function S(A) {
        var O, P = A.disconnectionHandler, U = A.networkInformation, z = A.requestHandler, k = A.url;
        return (0, r.default)(this, S), O = _.call(this, {
          disconnectionHandler: P,
          requestHandler: z,
          url: k
        }), v.set((0, i.default)(O), {
          writable: !0,
          value: !1
        }), h.set((0, i.default)(O), {
          writable: !0,
          value: function() {
            return (0, c.default)((0, i.default)(O), E) === (0, c.default)((0, i.default)(O), m).type || O.disconnect();
          }
        }), E.set((0, i.default)(O), {
          writable: !0,
          value: void 0
        }), m.set((0, i.default)(O), {
          writable: !0,
          value: void 0
        }), (0, l.default)((0, i.default)(O), m, U), O;
      }
      return (0, n.default)(S, [{
        key: "connect",
        value: (
          // TODO: Better, the `NetworkInformation` instance should be passed to `BrowserWebSocketClient` -> `BrowserWebSocket`.
          //       `BrowserWebSocket` is where it creates `WebSocket` object.
          //       The `NetworkInformation` instance should accompany `WebSocket` and forcibly close it on abort.
          //       Maybe `botframework-streaming` should accept ponyfills.
          function() {
            if ((0, c.default)(this, v))
              return console.warn("botframework-directlinejs: connect() can only be called once."), Promise.resolve();
            if ((0, l.default)(this, v, !0), (0, c.default)(this, m)) {
              var O = (0, c.default)(this, m), P = O.type;
              if ((0, l.default)(this, E, P), P === "none")
                return console.warn("botframework-directlinejs: Failed to connect while offline."), Promise.reject(new Error("botframework-directlinejs: Failed to connect while offline."));
              (0, c.default)(this, m).addEventListener("change", (0, c.default)(this, h));
            }
            return (0, o.default)((0, s.default)(S.prototype), "connect", this).call(this);
          }
        )
      }, {
        key: "disconnect",
        value: function() {
          var O;
          (O = (0, c.default)(this, m)) === null || O === void 0 || O.removeEventListener("change", (0, c.default)(this, h)), (0, o.default)((0, s.default)(S.prototype), "disconnect", this).call(this);
        }
      }]), S;
    }(f.WebSocketClient);
    e.default = g;
  }(ND)), ND;
}
var aee;
function Dtr() {
  if (aee) return Fv;
  aee = 1;
  var e = my, t = LF;
  Object.defineProperty(Fv, "__esModule", {
    value: !0
  }), Fv.DirectLineStreaming = void 0;
  var r = e(wge()), n = e(htr()), i = e(g1e()), o = e(T1e()), a = e(Ttr()), u = e(ytr()), s = e(BF()), c = e(kF()), l = e(Pge()), f = o1e(), d = Atr(), p = ln(), v = S(y1e()), h = e(Str()), E = e(btr()), m = S1e(), g = e(Ptr()), y = ["attachments"];
  function _(B) {
    if (typeof WeakMap != "function") return null;
    var x = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
    return (_ = function($) {
      return $ ? D : x;
    })(B);
  }
  function S(B, x) {
    if (B && B.__esModule)
      return B;
    if (B === null || t(B) !== "object" && typeof B != "function")
      return { default: B };
    var D = _(x);
    if (D && D.has(B))
      return D.get(B);
    var w = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var X in B)
      if (X !== "default" && Object.prototype.hasOwnProperty.call(B, X)) {
        var V = $ ? Object.getOwnPropertyDescriptor(B, X) : null;
        V && (V.get || V.set) ? Object.defineProperty(w, X, V) : w[X] = B[X];
      }
    return w.default = B, D && D.set(B, w), w;
  }
  var A = "DirectLine/3.0", O = 3, P = 30 * 60 * 1e3, U = P / 2, z = /* @__PURE__ */ function() {
    function B(x, D, w) {
      (0, s.default)(this, B), (0, l.default)(this, "activityQueue", []), this.subscriber = x, this.connectionStatus$ = D, this.shouldQueue = w;
    }
    return (0, c.default)(B, [{
      key: "setSubscriber",
      value: function(D) {
        this.subscriber = D;
      }
    }, {
      key: "processRequest",
      value: function() {
        var x = (0, u.default)(/* @__PURE__ */ n.default.mark(function w($, X) {
          var V, F, le, ae, ne, ve, Ie, Oe, xe;
          return n.default.wrap(function(qe) {
            for (; ; )
              switch (qe.prev = qe.next) {
                case 0:
                  return V = (0, a.default)($.streams), F = V.shift(), qe.next = 4, F.readAsString();
                case 4:
                  if (le = qe.sent, ae = JSON.parse(le), ae.activities.length === 1) {
                    qe.next = 9;
                    break;
                  }
                  return this.subscriber.error(new Error("there should be exactly one activity")), qe.abrupt("return", v.StreamingResponse.create(500));
                case 9:
                  if (ne = ae.activities[0], !(V.length > 0)) {
                    qe.next = 21;
                    break;
                  }
                  ve = (0, a.default)(ne.attachments);
                case 12:
                  if (!(Ie = V.shift())) {
                    qe.next = 20;
                    break;
                  }
                  return qe.next = 15, Ie.readAsString();
                case 15:
                  Oe = qe.sent, xe = "data:text/plain;base64," + Oe, ve.push({
                    contentType: Ie.contentType,
                    contentUrl: xe
                  }), qe.next = 12;
                  break;
                case 20:
                  ne.attachments = ve;
                case 21:
                  return this.shouldQueue() ? this.activityQueue.push(ne) : this.subscriber.next(ne), qe.abrupt("return", v.StreamingResponse.create(200));
                case 23:
                case "end":
                  return qe.stop();
              }
          }, w, this);
        }));
        function D(w, $) {
          return x.apply(this, arguments);
        }
        return D;
      }()
    }, {
      key: "flush",
      value: function() {
        var D = this;
        this.connectionStatus$.subscribe(function() {
        }), this.activityQueue.forEach(function(w) {
          return D.subscriber.next(w);
        }), this.activityQueue = [];
      }
    }, {
      key: "end",
      value: function() {
        this.subscriber.complete();
      }
    }]), B;
  }(), k = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ function() {
    function B(x) {
      var D = this;
      (0, s.default)(this, B), (0, l.default)(this, "connectionStatus$", new f.BehaviorSubject(m.ConnectionStatus.Uninitialized)), (0, l.default)(this, "_botAgent", ""), k.set(this, {
        writable: !0,
        value: void 0
      });
      var w = x == null ? void 0 : x.networkInformation;
      typeof w > "u" || typeof w.addEventListener == "function" && typeof w.removeEventListener == "function" && typeof w.type == "string" ? (0, o.default)(this, k, w) : console.warn('botframework-directlinejs: "networkInformation" option specified must be a `NetworkInformation`-like instance extending `EventTarget` interface with a `type` property returning a string.'), this.token = x.token, this.refreshToken().catch(function() {
        D.connectionStatus$.next(m.ConnectionStatus.ExpiredToken);
      }), this.domain = x.domain, x.conversationId && (this.conversationId = x.conversationId), this._botAgent = this.getBotAgent(x.botAgent), this.queueActivities = !0, this.activity$ = p.Observable.create(/* @__PURE__ */ function() {
        var $ = (0, u.default)(/* @__PURE__ */ n.default.mark(function X(V) {
          return n.default.wrap(function(le) {
            for (; ; )
              switch (le.prev = le.next) {
                case 0:
                  D.activitySubscriber = V, D.theStreamHandler = new z(V, D.connectionStatus$, function() {
                    return D.queueActivities;
                  }), D.connectDeferred.resolve();
                case 3:
                case "end":
                  return le.stop();
              }
          }, X);
        }));
        return function(X) {
          return $.apply(this, arguments);
        };
      }()).share(), this.connectWithRetryAsync();
    }
    return (0, c.default)(B, [{
      key: "reconnect",
      value: function(D) {
        var w = D.conversationId, $ = D.token;
        if (this.connectionStatus$.getValue() === m.ConnectionStatus.Ended)
          throw new Error("Connection has ended.");
        this.conversationId = w, this.token = $, this.connectDeferred.resolve();
      }
    }, {
      key: "end",
      value: function() {
        this.activitySubscriber.complete(), this.connectionStatus$.next(m.ConnectionStatus.Ended), this.connectionStatus$.complete(), this.streamConnection.disconnect();
      }
    }, {
      key: "commonHeaders",
      value: function() {
        return {
          Authorization: "Bearer ".concat(this.token),
          "x-ms-bot-agent": this._botAgent
        };
      }
    }, {
      key: "getBotAgent",
      value: function() {
        var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", w = "directlineStreaming";
        return D && (w += "; ".concat(D)), "".concat(A, " (").concat(w, ")");
      }
    }, {
      key: "refreshToken",
      value: function() {
        var x = (0, u.default)(/* @__PURE__ */ n.default.mark(function w() {
          var $, X, V, F;
          return n.default.wrap(function(ae) {
            for (; ; )
              switch (ae.prev = ae.next) {
                case 0:
                  return ae.next = 4, this.waitUntilOnline();
                case 4:
                  $ = 0;
                case 5:
                  if (!($ < O)) {
                    ae.next = 30;
                    break;
                  }
                  return $++, ae.next = 9, new Promise(function(ne) {
                    return setTimeout(ne, U);
                  });
                case 9:
                  return ae.prev = 9, ae.next = 12, (0, E.default)("".concat(this.domain, "/tokens/refresh"), {
                    method: "POST",
                    headers: this.commonHeaders()
                  });
                case 12:
                  if (X = ae.sent, !X.ok) {
                    ae.next = 22;
                    break;
                  }
                  return $ = 0, ae.next = 17, X.json();
                case 17:
                  V = ae.sent, F = V.token, this.token = F, ae.next = 23;
                  break;
                case 22:
                  X.status === 403 || X.status === 403 ? (console.error("Fatal error while refreshing the token: ".concat(X.status, " ").concat(X.statusText)), this.streamConnection.disconnect()) : console.warn("Refresh attempt #".concat($, " failed: ").concat(X.status, " ").concat(X.statusText));
                case 23:
                  ae.next = 28;
                  break;
                case 25:
                  ae.prev = 25, ae.t0 = ae.catch(9), console.warn("Refresh attempt #".concat($, " threw an exception: ").concat(ae.t0));
                case 28:
                  ae.next = 5;
                  break;
                case 30:
                  console.error("Retries exhausted"), this.streamConnection.disconnect();
                case 32:
                case "end":
                  return ae.stop();
              }
          }, w, this, [[9, 25]]);
        }));
        function D() {
          return x.apply(this, arguments);
        }
        return D;
      }()
    }, {
      key: "postActivity",
      value: function(D) {
        var w = this;
        if (this.connectionStatus$.value === m.ConnectionStatus.Ended || this.connectionStatus$.value === m.ConnectionStatus.FailedToConnect)
          return p.Observable.throw(new Error("Connection is closed"));
        if (D.type === "message" && D.attachments && D.attachments.length > 0)
          return this.postMessageWithAttachments(D);
        var $ = p.Observable.create(/* @__PURE__ */ function() {
          var X = (0, u.default)(/* @__PURE__ */ n.default.mark(function V(F) {
            var le, ae, ne, ve, Ie, Oe;
            return n.default.wrap(function(ze) {
              for (; ; )
                switch (ze.prev = ze.next) {
                  case 0:
                    return le = v.StreamingRequest.create("POST", "/v3/directline/conversations/" + w.conversationId + "/activities"), le.setBody(JSON.stringify(D)), ze.prev = 2, ze.next = 5, w.streamConnection.send(le);
                  case 5:
                    if (ae = ze.sent, ae.statusCode === 200) {
                      ze.next = 8;
                      break;
                    }
                    throw new Error("PostActivity returned " + ae.statusCode);
                  case 8:
                    if (ne = ae.streams.length, ne === 1) {
                      ze.next = 11;
                      break;
                    }
                    throw new Error("Expected one stream but got " + ne);
                  case 11:
                    return ze.next = 13, ae.streams[0].readAsString();
                  case 13:
                    return ve = ze.sent, Ie = JSON.parse(ve), Oe = Ie.Id, F.next(Oe), ze.abrupt("return", F.complete());
                  case 19:
                    return ze.prev = 19, ze.t0 = ze.catch(2), console.warn(ze.t0), w.streamConnection.disconnect(), ze.abrupt("return", F.error(ze.t0));
                  case 24:
                  case "end":
                    return ze.stop();
                }
            }, V, null, [[2, 19]]);
          }));
          return function(V) {
            return X.apply(this, arguments);
          };
        }());
        return $;
      }
    }, {
      key: "postMessageWithAttachments",
      value: function(D) {
        var w = this, $ = D.attachments, X = (0, r.default)(D, y);
        return p.Observable.create(function(V) {
          var F = [];
          (0, u.default)(/* @__PURE__ */ n.default.mark(function le() {
            var ae, ne, ve, Ie, Oe, xe, ze;
            return n.default.wrap(function(Je) {
              for (; ; )
                switch (Je.prev = Je.next) {
                  case 0:
                    return Je.prev = 0, Je.next = 3, Promise.all($.map(/* @__PURE__ */ function() {
                      var Be = (0, u.default)(/* @__PURE__ */ n.default.mark(function We(Ne) {
                        var je, et;
                        return n.default.wrap(function(Ot) {
                          for (; ; )
                            switch (Ot.prev = Ot.next) {
                              case 0:
                                return je = Ne, Ot.next = 3, (0, E.default)(je.contentUrl);
                              case 3:
                                if (et = Ot.sent, !et.ok) {
                                  Ot.next = 12;
                                  break;
                                }
                                return Ot.next = 7, et.arrayBuffer();
                              case 7:
                                return Ot.t0 = Ot.sent, Ot.t1 = je, Ot.abrupt("return", {
                                  arrayBuffer: Ot.t0,
                                  media: Ot.t1
                                });
                              case 12:
                                throw new Error("...");
                              case 13:
                              case "end":
                                return Ot.stop();
                            }
                        }, We);
                      }));
                      return function(We) {
                        return Be.apply(this, arguments);
                      };
                    }()));
                  case 3:
                    return ae = Je.sent, ae.forEach(function(Be) {
                      var We = Be.arrayBuffer, Ne = Be.media, je = d.Buffer.from(We), et = new v.SubscribableStream();
                      et.write(je);
                      var St = new v.HttpContent({
                        type: Ne.contentType,
                        contentLength: je.length
                      }, et);
                      F.push(St);
                    }), ne = "/v3/directline/conversations/".concat(w.conversationId, "/users/").concat(X.from.id, "/upload"), ve = v.StreamingRequest.create("PUT", ne), Ie = new v.SubscribableStream(), Ie.write(JSON.stringify(X), "utf-8"), ve.addStream(new v.HttpContent({
                      type: "application/vnd.microsoft.activity",
                      contentLength: Ie.length
                    }, Ie)), F.forEach(function(Be) {
                      return ve.addStream(Be);
                    }), Je.next = 13, w.streamConnection.send(ve);
                  case 13:
                    if (Oe = Je.sent, !(Oe.streams && Oe.streams.length !== 1)) {
                      Je.next = 18;
                      break;
                    }
                    V.error(new Error("Invalid stream count ".concat(Oe.streams.length))), Je.next = 24;
                    break;
                  case 18:
                    return Je.next = 20, Oe.streams[0].readAsJson();
                  case 20:
                    xe = Je.sent, ze = xe.Id, V.next(ze), V.complete();
                  case 24:
                    Je.next = 29;
                    break;
                  case 26:
                    Je.prev = 26, Je.t0 = Je.catch(0), V.error(Je.t0);
                  case 29:
                  case "end":
                    return Je.stop();
                }
            }, le, null, [[0, 26]]);
          }))();
        });
      }
    }, {
      key: "waitUntilOnline",
      value: function() {
        var x = (0, u.default)(/* @__PURE__ */ n.default.mark(function w() {
          var $ = this;
          return n.default.wrap(function(V) {
            for (; ; )
              switch (V.prev = V.next) {
                case 0:
                  return V.abrupt("return", new Promise(function(F, le) {
                    $.connectionStatus$.subscribe(function(ae) {
                      if (ae === m.ConnectionStatus.Online)
                        return F();
                    }, function(ae) {
                      return le(ae);
                    });
                  }));
                case 1:
                case "end":
                  return V.stop();
              }
          }, w);
        }));
        function D() {
          return x.apply(this, arguments);
        }
        return D;
      }()
    }, {
      key: "connectAsync",
      value: function() {
        var x = (0, u.default)(/* @__PURE__ */ n.default.mark(function w() {
          var $ = this, X, V, F, le, ae;
          return n.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  if (X = new RegExp("^http(s?)"), X.test(this.domain)) {
                    ve.next = 3;
                    break;
                  }
                  throw "Domain must begin with http or https";
                case 3:
                  return V = {
                    token: this.token
                  }, this.conversationId && (V.conversationId = this.conversationId), F = new AbortController(), le = new URLSearchParams(V).toString(), ae = "".concat(this.domain.replace(X, "ws$1"), "/conversations/connect?").concat(le), ve.abrupt("return", new Promise(/* @__PURE__ */ function() {
                    var Ie = (0, u.default)(/* @__PURE__ */ n.default.mark(function Oe(xe, ze) {
                      var qe, Je, Be, We;
                      return n.default.wrap(function(je) {
                        for (; ; )
                          switch (je.prev = je.next) {
                            case 0:
                              return je.prev = 0, $.streamConnection = new g.default({
                                disconnectionHandler: xe,
                                networkInformation: (0, i.default)($, k),
                                requestHandler: {
                                  processRequest: function(St) {
                                    if (F.signal.aborted)
                                      throw new Error("Cannot process streaming request, `streamingConnection` should be disconnected.");
                                    return $.theStreamHandler.processRequest(St);
                                  }
                                },
                                url: ae
                              }), $.queueActivities = !0, je.next = 5, $.streamConnection.connect();
                            case 5:
                              return qe = v.StreamingRequest.create("POST", "/v3/directline/conversations"), je.next = 8, $.streamConnection.send(qe);
                            case 8:
                              if (Je = je.sent, Je.statusCode === 200) {
                                je.next = 11;
                                break;
                              }
                              throw new Error("Connection response code " + Je.statusCode);
                            case 11:
                              if (Je.streams.length === 1) {
                                je.next = 13;
                                break;
                              }
                              throw new Error("Expected 1 stream but got " + Je.streams.length);
                            case 13:
                              return je.next = 15, Je.streams[0].readAsString();
                            case 15:
                              return Be = je.sent, We = JSON.parse(Be), $.conversationId = We.conversationId, $.connectionStatus$.next(m.ConnectionStatus.Online), je.next = 21, $.waitUntilOnline();
                            case 21:
                              $.theStreamHandler.flush(), $.queueActivities = !1, je.next = 28;
                              break;
                            case 25:
                              je.prev = 25, je.t0 = je.catch(0), ze(je.t0);
                            case 28:
                            case "end":
                              return je.stop();
                          }
                      }, Oe, null, [[0, 25]]);
                    }));
                    return function(Oe, xe) {
                      return Ie.apply(this, arguments);
                    };
                  }()).finally(function() {
                    return F.abort();
                  }));
                case 9:
                case "end":
                  return ve.stop();
              }
          }, w, this);
        }));
        function D() {
          return x.apply(this, arguments);
        }
        return D;
      }()
    }, {
      key: "connectWithRetryAsync",
      value: function() {
        var x = (0, u.default)(/* @__PURE__ */ n.default.mark(function w() {
          var $ = this, X, V;
          return n.default.wrap(function(le) {
            for (; ; )
              switch (le.prev = le.next) {
                case 0:
                  return le.next = 2, (this.connectDeferred = (0, h.default)()).promise;
                case 2:
                  X = O, this.connectionStatus$.next(m.ConnectionStatus.Connecting);
                case 4:
                  if (!(X > 0)) {
                    le.next = 27;
                    break;
                  }
                  return X--, V = Date.now(), le.prev = 7, le.next = 10, this.connectAsync();
                case 10:
                  le.next = 15;
                  break;
                case 12:
                  le.prev = 12, le.t0 = le.catch(7), console.error(le.t0);
                case 15:
                  if (this.connectionStatus$.getValue() !== m.ConnectionStatus.Ended) {
                    le.next = 17;
                    break;
                  }
                  return le.abrupt("return");
                case 17:
                  if (this.connectionStatus$.getValue() !== m.ConnectionStatus.Connecting && this.connectionStatus$.next(m.ConnectionStatus.Connecting), !(6e4 < Date.now() - V)) {
                    le.next = 22;
                    break;
                  }
                  X = O, le.next = 25;
                  break;
                case 22:
                  if (!(X > 0)) {
                    le.next = 25;
                    break;
                  }
                  return le.next = 25, new Promise(function(ae) {
                    return setTimeout(ae, $.getRetryDelay());
                  });
                case 25:
                  le.next = 4;
                  break;
                case 27:
                  this.connectionStatus$.next(m.ConnectionStatus.FailedToConnect);
                case 28:
                  le.next = 0;
                  break;
                case 30:
                case "end":
                  return le.stop();
              }
          }, w, this, [[7, 12]]);
        }));
        function D() {
          return x.apply(this, arguments);
        }
        return D;
      }()
      // Returns the delay duration in milliseconds
    }, {
      key: "getRetryDelay",
      value: function() {
        return Math.floor(3e3 + Math.random() * 12e3);
      }
    }]), B;
  }();
  return Fv.DirectLineStreaming = H, Fv;
}
var uee;
function S1e() {
  return uee || (uee = 1, function(e) {
    var t = my, r = LF;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "DirectLineStreaming", {
      enumerable: !0,
      get: function() {
        return d.DirectLineStreaming;
      }
    }), e.DirectLine = e.ConnectionStatus = void 0;
    var n = t(wge()), i = t(BF()), o = t(kF()), a = t(Pge());
    VQt(), jQt();
    var u = o1e(), s = ln(), c = l3(), l = h(ter);
    oer(), cer(), der(), Eer(), Ter(), Aer(), ber(), Ier(), wer(), xer(), Mer(), Uer(), zer(), Yer(), Qer(), ntr(), otr(), str();
    var f = t(ptr()), d = Dtr(), p = ["contentUrl"];
    function v(x) {
      if (typeof WeakMap != "function") return null;
      var D = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap();
      return (v = function(X) {
        return X ? w : D;
      })(x);
    }
    function h(x, D) {
      if (x && x.__esModule)
        return x;
      if (x === null || r(x) !== "object" && typeof x != "function")
        return { default: x };
      var w = v(D);
      if (w && w.has(x))
        return w.get(x);
      var $ = {}, X = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var V in x)
        if (V !== "default" && Object.prototype.hasOwnProperty.call(x, V)) {
          var F = X ? Object.getOwnPropertyDescriptor(x, V) : null;
          F && (F.get || F.set) ? Object.defineProperty($, V, F) : $[V] = x[V];
        }
      return $.default = x, w && w.set(x, $), $;
    }
    function E(x, D) {
      var w = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(x);
        D && ($ = $.filter(function(X) {
          return Object.getOwnPropertyDescriptor(x, X).enumerable;
        })), w.push.apply(w, $);
      }
      return w;
    }
    function m(x) {
      for (var D = 1; D < arguments.length; D++) {
        var w = arguments[D] != null ? arguments[D] : {};
        D % 2 ? E(Object(w), !0).forEach(function($) {
          (0, a.default)(x, $, w[$]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(w)) : E(Object(w)).forEach(function($) {
          Object.defineProperty(x, $, Object.getOwnPropertyDescriptor(w, $));
        });
      }
      return x;
    }
    var g = "DirectLine/3.0", y;
    e.ConnectionStatus = y, function(x) {
      x[x.Uninitialized = 0] = "Uninitialized", x[x.Connecting = 1] = "Connecting", x[x.Online = 2] = "Online", x[x.ExpiredToken = 3] = "ExpiredToken", x[x.FailedToConnect = 4] = "FailedToConnect", x[x.Ended = 5] = "Ended";
    }(y || (e.ConnectionStatus = y = {}));
    var _ = function(D, w) {
      var $ = function() {
        throw new Error("not implemented");
      }, X = function(le) {
        return le.catch(function(ae) {
          if (ae.status === 429) {
            var ne = ae.xhr.getResponseHeader("Retry-After"), ve = Number(ne);
            if (!isNaN(ve))
              return s.Observable.timer(ve, w).flatMap(function(Ie) {
                return s.Observable.throw(ae, w);
              });
          }
          return s.Observable.throw(ae, w);
        });
      }, V = function(le) {
        return X(D(le));
      };
      return Object.assign(V, {
        get: function(le, ae) {
          return $();
        },
        post: function(le, ae, ne) {
          return $();
        },
        put: function(le, ae, ne) {
          return $();
        },
        patch: function(le, ae, ne) {
          return $();
        },
        delete: function(le, ae) {
          return $();
        },
        getJSON: function(le, ae) {
          return $();
        }
      });
    }, S = function(D) {
      var w = D.scheduler || c.async;
      return {
        scheduler: w,
        ajax: _(D.ajax || s.Observable.ajax, w),
        WebSocket: D.WebSocket || WebSocket,
        random: D.random || Math.random
      };
    }, A = 30 * 60 * 1e3, O = A / 2, P = 200, U = new Error("expired token"), z = new Error("conversation ended"), k = new Error("failed to connect"), H = {
      log: function(D) {
        for (var w, $ = arguments.length, X = new Array($ > 1 ? $ - 1 : 0), V = 1; V < $; V++)
          X[V - 1] = arguments[V];
        typeof window < "u" && window.botchatDebug && D && (w = console).log.apply(w, [D].concat(X));
      }
    }, B = /* @__PURE__ */ function() {
      function x(D) {
        (0, i.default)(this, x), (0, a.default)(this, "connectionStatus$", new u.BehaviorSubject(y.Uninitialized)), (0, a.default)(this, "domain", "https://directline.botframework.com/v3/directline"), (0, a.default)(this, "watermark", ""), (0, a.default)(this, "_botAgent", ""), (0, a.default)(this, "timeout", 20 * 1e3), (0, a.default)(this, "pollingInterval", 1e3), this.secret = D.secret, this.token = D.secret || D.token, this.webSocket = (D.webSocket === void 0 ? !0 : D.webSocket) && typeof WebSocket < "u" && WebSocket !== void 0, D.conversationStartProperties && D.conversationStartProperties.locale && (Object.prototype.toString.call(D.conversationStartProperties.locale) === "[object String]" ? this.localeOnStartConversation = D.conversationStartProperties.locale : console.warn("DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag")), D.domain && (this.domain = D.domain), D.conversationId && (this.conversationId = D.conversationId), D.watermark && (this.watermark = D.watermark), D.streamUrl && (D.token && D.conversationId ? this.streamUrl = D.streamUrl : console.warn("DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid")), D.timeout !== void 0 && (this.timeout = D.timeout), this.retries = (A - O) / this.timeout, this._botAgent = this.getBotAgent(D.botAgent), this.services = S(D);
        var w = ~~D.pollingInterval;
        w < P ? typeof D.pollingInterval < "u" && console.warn("DirectLineJS: provided pollingInterval (".concat(D.pollingInterval, ") is under lower bound (200ms), using default of 1000ms")) : this.pollingInterval = w, this.expiredTokenExhaustion = this.setConnectionStatusFallback(y.ExpiredToken, y.FailedToConnect, 5), this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
      }
      return (0, o.default)(x, [{
        key: "checkConnection",
        value: function() {
          var w = this, $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, X = this.connectionStatus$.flatMap(function(V) {
            return V === y.Uninitialized ? (w.connectionStatus$.next(y.Connecting), w.token && w.streamUrl ? (w.connectionStatus$.next(y.Online), s.Observable.of(V, w.services.scheduler)) : w.startConversation().do(function(F) {
              w.conversationId = F.conversationId, w.token = w.secret || F.token, w.streamUrl = F.streamUrl, w.referenceGrammarId = F.referenceGrammarId, w.secret || w.refreshTokenLoop(), w.connectionStatus$.next(y.Online);
            }, function(F) {
              w.connectionStatus$.next(y.FailedToConnect);
            }).map(function(F) {
              return V;
            })) : s.Observable.of(V, w.services.scheduler);
          }).filter(function(V) {
            return V != y.Uninitialized && V != y.Connecting;
          }).flatMap(function(V) {
            switch (V) {
              case y.Ended:
                return s.Observable.throw(z, w.services.scheduler);
              case y.FailedToConnect:
                return s.Observable.throw(k, w.services.scheduler);
              case y.ExpiredToken:
                return s.Observable.of(V, w.services.scheduler);
              default:
                return s.Observable.of(V, w.services.scheduler);
            }
          });
          return $ ? X.take(1) : X;
        }
      }, {
        key: "setConnectionStatusFallback",
        value: function(w, $) {
          var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
          X--;
          var V = 0, F = null;
          return function(le) {
            return le === w && F === le && V >= X ? (V = 0, $) : (V++, F = le, le);
          };
        }
      }, {
        key: "expiredToken",
        value: function() {
          var w = this.connectionStatus$.getValue();
          w != y.Ended && w != y.FailedToConnect && this.connectionStatus$.next(y.ExpiredToken);
          var $ = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
          this.connectionStatus$.next($);
        }
      }, {
        key: "startConversation",
        value: function() {
          var w = this, $ = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations"), X = this.conversationId ? "GET" : "POST", V = this.conversationId ? void 0 : {
            user: {
              id: this.userIdOnStartConversation
            },
            locale: this.localeOnStartConversation
          };
          return this.services.ajax({
            method: X,
            url: $,
            body: V,
            timeout: this.timeout,
            headers: m({
              Accept: "application/json",
              "Content-Type": "application/json"
            }, this.commonHeaders())
          }).map(function(F) {
            return F.response;
          }).retryWhen(function(F) {
            return (
              // for now we deem 4xx and 5xx errors as unrecoverable
              // for everything else (timeouts), retry for a while
              F.mergeMap(function(le) {
                return le.status >= 400 && le.status < 600 ? s.Observable.throw(le, w.services.scheduler) : s.Observable.of(le, w.services.scheduler);
              }).delay(w.timeout, w.services.scheduler).take(w.retries)
            );
          });
        }
      }, {
        key: "refreshTokenLoop",
        value: function() {
          var w = this;
          this.tokenRefreshSubscription = s.Observable.interval(O, this.services.scheduler).flatMap(function($) {
            return w.refreshToken();
          }).subscribe(function($) {
            H.log("refreshing token", $, "at", /* @__PURE__ */ new Date()), w.token = $;
          });
        }
      }, {
        key: "refreshToken",
        value: function() {
          var w = this;
          return this.checkConnection(!0).flatMap(function($) {
            return w.services.ajax({
              method: "POST",
              url: "".concat(w.domain, "/tokens/refresh"),
              timeout: w.timeout,
              headers: m({}, w.commonHeaders())
            }).map(function(X) {
              return X.response.token;
            }).retryWhen(function(X) {
              return X.mergeMap(function(V) {
                return V.status === 403 ? (w.expiredToken(), s.Observable.throw(V, w.services.scheduler)) : V.status === 404 ? s.Observable.throw(V, w.services.scheduler) : s.Observable.of(V, w.services.scheduler);
              }).delay(w.timeout, w.services.scheduler).take(w.retries);
            });
          });
        }
      }, {
        key: "reconnect",
        value: function(w) {
          this.token = w.token, this.streamUrl = w.streamUrl, this.connectionStatus$.getValue() === y.ExpiredToken && this.connectionStatus$.next(y.Online);
        }
      }, {
        key: "end",
        value: function() {
          this.tokenRefreshSubscription && this.tokenRefreshSubscription.unsubscribe();
          try {
            this.connectionStatus$.next(y.Ended);
          } catch (w) {
            if (w === z) return;
            throw w;
          }
        }
      }, {
        key: "getSessionId",
        value: function() {
          var w = this;
          return H.log("getSessionId"), this.checkConnection(!0).flatMap(function($) {
            return w.services.ajax({
              method: "GET",
              url: "".concat(w.domain, "/session/getsessionid"),
              withCredentials: !0,
              timeout: w.timeout,
              headers: m({
                "Content-Type": "application/json"
              }, w.commonHeaders())
            }).map(function(X) {
              return X && X.response && X.response.sessionId ? (H.log("getSessionId response: " + X.response.sessionId), X.response.sessionId) : "";
            }).catch(function(X) {
              return H.log("getSessionId error: " + X.status), s.Observable.of("", w.services.scheduler);
            });
          }).catch(function($) {
            return w.catchExpiredToken($);
          });
        }
      }, {
        key: "postActivity",
        value: function(w) {
          var $ = this;
          return this.userIdOnStartConversation && w.from && w.from.id !== this.userIdOnStartConversation && (console.warn("DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id"), w.from.id = this.userIdOnStartConversation), w.type === "message" && w.attachments && w.attachments.length > 0 ? this.postMessageWithAttachments(w) : (H.log("postActivity", w), this.checkConnection(!0).flatMap(function(X) {
            return $.services.ajax({
              method: "POST",
              url: "".concat($.domain, "/conversations/").concat($.conversationId, "/activities"),
              body: w,
              timeout: $.timeout,
              headers: m({
                "Content-Type": "application/json"
              }, $.commonHeaders())
            }).map(function(V) {
              return V.response.id;
            }).catch(function(V) {
              return $.catchPostError(V);
            });
          }).catch(function(X) {
            return $.catchExpiredToken(X);
          }));
        }
      }, {
        key: "postMessageWithAttachments",
        value: function(w) {
          var $ = this, X = w.attachments, V = (0, f.default)(X.map(function(ae) {
            return ae.name || "blob";
          })), F = X.map(function(ae, ne) {
            return m(m({}, ae), {}, {
              name: V[ne]
            });
          }), le;
          return this.checkConnection(!0).flatMap(function(ae) {
            return le = new FormData(), le.append("activity", new Blob([JSON.stringify(m(m({}, w), {}, {
              // Removing contentUrl from attachment, we will send it via multipart
              attachments: F.map(function(ne) {
                ne.contentUrl;
                var ve = (0, n.default)(ne, p);
                return m({}, ve);
              })
            }))], {
              type: "application/vnd.microsoft.activity"
            })), s.Observable.from(F, $.services.scheduler).flatMap(function(ne) {
              return $.services.ajax({
                method: "GET",
                url: ne.contentUrl,
                responseType: "arraybuffer"
              }).do(function(ve) {
                return le.append("file", new Blob([ve.response], {
                  type: ne.contentType
                }), ne.name);
              });
            }).count();
          }).flatMap(function(ae) {
            return $.services.ajax({
              method: "POST",
              url: "".concat($.domain, "/conversations/").concat($.conversationId, "/upload?userId=").concat(w.from.id),
              body: le,
              timeout: $.timeout,
              headers: m({}, $.commonHeaders())
            }).map(function(ne) {
              return ne.response.id;
            }).catch(function(ne) {
              return $.catchPostError(ne);
            });
          }).catch(function(ae) {
            return $.catchPostError(ae);
          });
        }
      }, {
        key: "catchPostError",
        value: function(w) {
          if (w.status === 403)
            this.expiredToken();
          else if (w.status >= 400 && w.status < 500)
            return s.Observable.throw(w, this.services.scheduler);
          return s.Observable.of("retry", this.services.scheduler);
        }
      }, {
        key: "catchExpiredToken",
        value: function(w) {
          return w === U ? s.Observable.of("retry", this.services.scheduler) : s.Observable.throw(w, this.services.scheduler);
        }
      }, {
        key: "pollingGetActivity$",
        value: function() {
          var w = this, $ = s.Observable.create(function(X) {
            var V = new u.BehaviorSubject({});
            V.subscribe(function() {
              if (w.connectionStatus$.getValue() === y.Online) {
                var F = Date.now();
                w.services.ajax({
                  headers: m({
                    Accept: "application/json"
                  }, w.commonHeaders()),
                  method: "GET",
                  url: "".concat(w.domain, "/conversations/").concat(w.conversationId, "/activities?watermark=").concat(w.watermark),
                  timeout: w.timeout
                }).subscribe(function(le) {
                  X.next(le), setTimeout(function() {
                    return V.next(null);
                  }, Math.max(0, w.pollingInterval - Date.now() + F));
                }, function(le) {
                  switch (le.status) {
                    case 403:
                      w.connectionStatus$.next(y.ExpiredToken), setTimeout(function() {
                        return V.next(null);
                      }, w.pollingInterval);
                      break;
                    case 404:
                      w.connectionStatus$.next(y.Ended);
                      break;
                    default:
                      X.error(le);
                      break;
                  }
                });
              }
            });
          });
          return this.checkConnection().flatMap(function(X) {
            return $.catch(function() {
              return s.Observable.empty();
            }).map(function(V) {
              return V.response;
            }).flatMap(function(V) {
              return w.observableFromActivityGroup(V);
            });
          });
        }
      }, {
        key: "observableFromActivityGroup",
        value: function(w) {
          return w.watermark && (this.watermark = w.watermark), s.Observable.from(w.activities, this.services.scheduler);
        }
      }, {
        key: "webSocketActivity$",
        value: function() {
          var w = this;
          return this.checkConnection().flatMap(function($) {
            return w.observableWebSocket().retryWhen(function(X) {
              return X.delay(w.getRetryDelay(), w.services.scheduler).mergeMap(function(V) {
                return w.reconnectToConversation();
              });
            });
          }).flatMap(function($) {
            return w.observableFromActivityGroup($);
          });
        }
        // Returns the delay duration in milliseconds
      }, {
        key: "getRetryDelay",
        value: function() {
          return Math.floor(3e3 + this.services.random() * 12e3);
        }
        // Originally we used Observable.webSocket, but it's fairly opinionated and I ended up writing
        // a lot of code to work around their implementation details. Since WebChat is meant to be a reference
        // implementation, I decided roll the below, where the logic is more purposeful. - @billba
      }, {
        key: "observableWebSocket",
        value: function() {
          var w = this;
          return s.Observable.create(function($) {
            H.log("creating WebSocket", w.streamUrl);
            var X = new w.services.WebSocket(w.streamUrl), V, F;
            return X.onopen = function(le) {
              H.log("WebSocket open", le), V = s.Observable.interval(w.timeout, w.services.scheduler).subscribe(function(ae) {
                try {
                  X.send("");
                } catch (ne) {
                  H.log("Ping error", ne);
                }
              });
            }, X.onclose = function(le) {
              H.log("WebSocket close", le), V && V.unsubscribe(), F || $.error(le), F = !0;
            }, X.onerror = function(le) {
              H.log("WebSocket error", le), V && V.unsubscribe(), F || $.error(le), F = !0;
            }, X.onmessage = function(le) {
              return le.data && $.next(JSON.parse(le.data));
            }, function() {
              (X.readyState === 0 || X.readyState === 1) && X.close();
            };
          });
        }
      }, {
        key: "reconnectToConversation",
        value: function() {
          var w = this;
          return this.checkConnection(!0).flatMap(function($) {
            return w.services.ajax({
              method: "GET",
              url: "".concat(w.domain, "/conversations/").concat(w.conversationId, "?watermark=").concat(w.watermark),
              timeout: w.timeout,
              headers: m({
                Accept: "application/json"
              }, w.commonHeaders())
            }).do(function(X) {
              w.secret || (w.token = X.response.token), w.streamUrl = X.response.streamUrl;
            }).map(function(X) {
              return null;
            }).retryWhen(function(X) {
              return X.mergeMap(function(V) {
                if (V.status === 403)
                  w.expiredToken();
                else if (V.status === 404)
                  return s.Observable.throw(z, w.services.scheduler);
                return s.Observable.of(V, w.services.scheduler);
              }).delay(w.timeout, w.services.scheduler).take(w.retries);
            });
          });
        }
      }, {
        key: "commonHeaders",
        value: function() {
          return {
            Authorization: "Bearer ".concat(this.token),
            "x-ms-bot-agent": this._botAgent
          };
        }
      }, {
        key: "getBotAgent",
        value: function() {
          var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", $ = "directlinejs";
          return w && ($ += "; ".concat(w)), "".concat(g, " (").concat($, " ").concat("0.15.5", ")");
        }
      }, {
        key: "setUserId",
        value: function(w) {
          if (this.connectionStatus$.getValue() === y.Online)
            throw new Error("DirectLineJS: It is connected, we cannot set user id.");
          var $ = this.parseToken(this.token);
          if ($)
            return console.warn("DirectLineJS: user id is already set in token, will ignore this user id.");
          if (/^dl_/.test(w))
            return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
          this.userIdOnStartConversation = w;
        }
      }, {
        key: "parseToken",
        value: function(w) {
          try {
            var $ = (0, l.default)(w), X = $.user;
            return X;
          } catch (V) {
            if (V instanceof l.InvalidTokenError)
              return;
          }
        }
      }]), x;
    }();
    e.DirectLine = B;
  }(iw)), iw;
}
var b1e = S1e(), xtr = Object.create, h3 = Object.defineProperty, Ntr = Object.getOwnPropertyDescriptor, Ltr = Object.getOwnPropertyNames, Btr = Object.getPrototypeOf, ktr = Object.prototype.hasOwnProperty, Qe = (e, t) => () => (e && (t = e(e = 0)), t), ot = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), a7 = (e, t) => {
  for (var r in t) h3(e, r, { get: t[r], enumerable: !0 });
}, C1e = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function") for (let i of Ltr(t)) !ktr.call(e, i) && i !== r && h3(e, i, { get: () => t[i], enumerable: !(n = Ntr(t, i)) || n.enumerable });
  return e;
}, Qa = (e, t, r) => (r = e != null ? xtr(Btr(e)) : {}, C1e(t || !e || !e.__esModule ? h3(r, "default", { value: e, enumerable: !0 }) : r, e)), u7 = (e) => C1e(h3({}, "__esModule", { value: !0 }), e), Mtr = "4.18.0";
function Rl(e, t) {
  try {
    let { document: r } = globalThis;
    if (typeof r < "u" && r.createElement && r.head && r.head.appendChild) {
      let n = r.querySelector(`html meta[name="${encodeURI(e)}"]`) || r.createElement("meta");
      n.setAttribute("name", e), n.setAttribute("content", t), r.head.appendChild(n);
    }
  } catch {
  }
}
function I1e(e) {
  Rl("botframework-webchat:api", `version=${uO.version}; build-tool=${uO.buildTool}; module-format=${uO.moduleFormat}`), Rl("botframework-webchat:bundle", `version=${Mtr}; variant=${e}; build-tool=tsup; module-format=esmodules`), Rl("botframework-webchat:component", `version=${uA.version}; build-tool=${uA.buildTool}; module-format=${uA.moduleFormat}`), Rl("botframework-webchat:core", `version=${j_.version}; build-tool=${j_.buildTool}; module-format=${j_.moduleFormat}`), Rl("botframework-webchat:bundle:variant", e), Rl("botframework-webchat:bundle:version", "4.18.0"), Rl("botframework-webchat:core:version", j_.version), Rl("botframework-webchat:ui:version", uA.version);
}
function Ftr() {
  return !window.SpeechRecognition && !window.webkitSpeechRecognition && console.warn("Web Chat: This browser does not support Web Speech API Speech Recognition."), window.speechSynthesis || console.warn("Web Chat: This browser does not support Web Speech API Speech Synthesis."), () => ({ SpeechGrammarList: window.SpeechGrammarList || window.webkitSpeechGrammarList, SpeechRecognition: window.SpeechRecognition || window.webkitSpeechRecognition, speechSynthesis: window.speechSynthesis, SpeechSynthesisUtterance: window.SpeechSynthesisUtterance });
}
function O1e({ botAgent: e, conversationId: t, conversationStartProperties: r, domain: n, fetch: i, pollingInterval: o, secret: a, streamUrl: u, token: s, watermark: c, webSocket: l }) {
  return new b1e.DirectLine({ botAgent: e, conversationId: t, conversationStartProperties: r, domain: n, fetch: i, pollingInterval: o, secret: a, streamUrl: u, token: s, watermark: c, webSocket: l, createFormData: (f) => {
    let d = new FormData();
    return f.forEach(({ contentType: p, data: v, filename: h, name: E }) => {
      d.append(E, new Blob(v, { type: p }), h);
    }), d;
  } });
}
function R1e({ botAgent: e, conversationId: t, domain: r, token: n }) {
  return Promise.resolve(new b1e.DirectLineStreaming({ botAgent: e, conversationId: t, domain: r, token: n }));
}
function w1e(e, t, r) {
  NIe.render(G.createElement(e, { ...t }), r);
}
var Htr = w1e.bind(null, NF), $tr = "tsup", Utr = "esmodules", Ay = "4.18.0", Vtr = { buildTool: $tr, moduleFormat: Utr, variant: "minimal", version: Ay }, jtr = (e) => (e.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent in the createDirectLine function. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details."), O1e({ ...e, botAgent: `WebChat/${Ay} (Minimal)` })), ztr = (e) => (e.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent in the createDirectLine function. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details."), R1e({ ...e, botAgent: `WebChat/${Ay} (Minimal)` }));
window.WebChat = { ...window.WebChat, concatMiddleware: tC, Constants: YT, createBrowserWebSpeechPonyfillFactory: Ftr, createDirectLine: jtr, createDirectLineAppServiceExtension: ztr, createStore: hfe, createStoreWithOptions: Ck, createStyleSet: wF, decorator: nMe, hooks: du, ReactWebChat: NF, renderWebChat: Htr, withEmoji: JC };
I1e("minimal");
/*! For license information please see chunk-6NGHWPUW.mjs.LEGAL.txt */
var vA, qtr = new Uint8Array(16);
function Ytr() {
  if (!vA && (vA = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !vA))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return vA(qtr);
}
const Gtr = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Wtr(e) {
  return typeof e == "string" && Gtr.test(e);
}
var Lo = [];
for (var UD = 0; UD < 256; ++UD)
  Lo.push((UD + 256).toString(16).substr(1));
function Ktr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Lo[e[t + 0]] + Lo[e[t + 1]] + Lo[e[t + 2]] + Lo[e[t + 3]] + "-" + Lo[e[t + 4]] + Lo[e[t + 5]] + "-" + Lo[e[t + 6]] + Lo[e[t + 7]] + "-" + Lo[e[t + 8]] + Lo[e[t + 9]] + "-" + Lo[e[t + 10]] + Lo[e[t + 11]] + Lo[e[t + 12]] + Lo[e[t + 13]] + Lo[e[t + 14]] + Lo[e[t + 15]]).toLowerCase();
  if (!Wtr(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function P1e(e, t, r) {
  e = e || {};
  var n = e.random || (e.rng || Ytr)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Ktr(n);
}
var yo = {}, lc = {};
Object.defineProperty(lc, "__esModule", { value: !0 });
lc.Strings = void 0;
var Xtr = (
  /** @class */
  function() {
    function e() {
    }
    return e.errors = {
      unknownElementType: function(t) {
        return 'Unknown element type "'.concat(t, '". Fallback will be used if present.');
      },
      unknownActionType: function(t) {
        return 'Unknown action type "'.concat(t, '". Fallback will be used if present.');
      },
      elementTypeNotAllowed: function(t) {
        return 'Element type "'.concat(t, '" is not allowed in this context.');
      },
      actionTypeNotAllowed: function(t) {
        return 'Action type "'.concat(t, '" is not allowed in this context.');
      },
      invalidPropertyValue: function(t, r) {
        return 'Invalid value "'.concat(t, '" for property "').concat(r, '".');
      },
      showCardMustHaveCard: function() {
        return '"An Action.ShowCard must have its "card" property set to a valid AdaptiveCard object.';
      },
      invalidColumnWidth: function(t) {
        return 'Invalid column width "'.concat(t, '" - defaulting to "auto".');
      },
      invalidCardVersion: function(t) {
        return 'Invalid card version. Defaulting to "'.concat(t, '".');
      },
      invalidVersionString: function(t) {
        return 'Invalid version string "'.concat(t, '".');
      },
      propertyValueNotSupported: function(t, r, n, i) {
        return 'Value "'.concat(t, '" for property "').concat(r, '" is supported in version ').concat(n, ", but you are using version ").concat(i, ".");
      },
      propertyNotSupported: function(t, r, n) {
        return 'Property "'.concat(t, '" is supported in version ').concat(r, ", but you are using version ").concat(n, ".");
      },
      indexOutOfRange: function(t) {
        return "Index out of range (".concat(t, ").");
      },
      elementCannotBeUsedAsInline: function() {
        return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
      },
      inlineAlreadyParented: function() {
        return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
      },
      interactivityNotAllowed: function() {
        return "Interactivity is not allowed.";
      },
      inputsMustHaveUniqueId: function() {
        return "All inputs must have a unique Id.";
      },
      choiceSetMustHaveAtLeastOneChoice: function() {
        return "An Input.ChoiceSet must have at least one choice defined.";
      },
      choiceSetChoicesMustHaveTitleAndValue: function() {
        return "All choices in an Input.ChoiceSet must have their title and value properties set.";
      },
      propertyMustBeSet: function(t) {
        return 'Property "'.concat(t, '" must be set.');
      },
      actionHttpHeadersMustHaveNameAndValue: function() {
        return "All headers of an Action.Http must have their name and value properties set.";
      },
      tooManyActions: function(t) {
        return "Maximum number of actions exceeded (".concat(t, ").");
      },
      tooLittleTimeDelay: function(t) {
        return "Autoplay Delay is too short (".concat(t, ").");
      },
      tooManyCarouselPages: function(t) {
        return "Maximum number of Carousel pages exceeded (".concat(t, ").");
      },
      invalidInitialPageIndex: function(t) {
        return "InitialPage for carousel is invalid (".concat(t, ").");
      },
      columnAlreadyBelongsToAnotherSet: function() {
        return "This column already belongs to another ColumnSet.";
      },
      invalidCardType: function() {
        return `Invalid or missing card type. Make sure the card's type property is set to "AdaptiveCard".`;
      },
      unsupportedCardVersion: function(t, r) {
        return "The specified card version (".concat(t, ") is not supported or still in preview. The latest released card version is ").concat(r, ".");
      },
      duplicateId: function(t) {
        return 'Duplicate Id "'.concat(t, '".');
      },
      markdownProcessingNotEnabled: function() {
        return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
      },
      processMarkdownEventRemoved: function() {
        return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
      },
      elementAlreadyParented: function() {
        return "The element already belongs to another container.";
      },
      actionAlreadyParented: function() {
        return "The action already belongs to another element.";
      },
      elementTypeNotStandalone: function(t) {
        return "Elements of type ".concat(t, " cannot be used as standalone elements.");
      },
      invalidInputLabelWidth: function() {
        return "Invalid input label width. Defaulting to label width from host config.";
      }
    }, e.magicCodeInputCard = {
      tryAgain: function() {
        return "That didn't work... let's try again.";
      },
      pleaseLogin: function() {
        return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
      },
      enterMagicCode: function() {
        return "Enter magic code";
      },
      pleaseEnterMagicCodeYouReceived: function() {
        return "Please enter the magic code you received.";
      },
      submit: function() {
        return "Submit";
      },
      cancel: function() {
        return "Cancel";
      },
      somethingWentWrong: function() {
        return "Something went wrong. This action can't be handled.";
      },
      authenticationFailed: function() {
        return "Authentication failed.";
      }
    }, e.runtime = {
      automaticRefreshPaused: function() {
        return "Automatic refresh paused.";
      },
      clckToRestartAutomaticRefresh: function() {
        return "Click to restart.";
      },
      refreshThisCard: function() {
        return "Refresh this card";
      }
    }, e.hints = {
      dontUseWeightedAndStrecthedColumnsInSameSet: function() {
        return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
      }
    }, e.defaults = {
      inlineActionTitle: function() {
        return "Inline Action";
      },
      overflowButtonText: function() {
        return "...";
      },
      overflowButtonTooltip: function() {
        return "More options";
      },
      emptyElementText: function(t) {
        return "Empty ".concat(t);
      },
      mediaPlayerAriaLabel: function() {
        return "Media content";
      },
      mediaPlayerPlayMedia: function() {
        return "Play media";
      },
      youTubeVideoPlayer: function() {
        return "YouTube video player";
      },
      vimeoVideoPlayer: function() {
        return "Vimeo video player";
      },
      dailymotionVideoPlayer: function() {
        return "Dailymotion video player";
      },
      carouselNavigationPreviousTooltip: function() {
        return "Previous carousel page";
      },
      carouselNavigationNextTooltip: function() {
        return "Next carousel page";
      }
    }, e;
  }()
);
lc.Strings = Xtr;
var Uu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ActionRole = e.CarouselInteractionEvent = e.LogLevel = e.RefreshMode = e.TypeErrorType = e.ContainerFitStatus = e.ValidationEvent = e.ValidationPhase = e.InputLabelPosition = e.InputTextStyle = e.ActionIconPlacement = e.FillMode = e.Orientation = e.ShowCardActionMode = e.ImageStyle = e.ActionAlignment = e.VerticalAlignment = e.HorizontalAlignment = e.TextColor = e.Spacing = e.FontType = e.TextWeight = e.InputStyle = e.TextSize = e.SizeUnit = e.ImageSetPresentationStyle = e.ImageSize = e.Size = e.ActionMode = e.ActionStyle = e.ContainerStyle = void 0;
  var t = (
    /** @class */
    function() {
      function i() {
      }
      return i.Default = "default", i.Emphasis = "emphasis", i.Accent = "accent", i.Good = "good", i.Attention = "attention", i.Warning = "warning", i;
    }()
  );
  e.ContainerStyle = t;
  var r = (
    /** @class */
    function() {
      function i() {
      }
      return i.Default = "default", i.Positive = "positive", i.Destructive = "destructive", i;
    }()
  );
  e.ActionStyle = r;
  var n = (
    /** @class */
    function() {
      function i() {
      }
      return i.Primary = "primary", i.Secondary = "secondary", i;
    }()
  );
  e.ActionMode = n, function(i) {
    i[i.Auto = 0] = "Auto", i[i.Stretch = 1] = "Stretch", i[i.Small = 2] = "Small", i[i.Medium = 3] = "Medium", i[i.Large = 4] = "Large";
  }(e.Size || (e.Size = {})), function(i) {
    i[i.Small = 0] = "Small", i[i.Medium = 1] = "Medium", i[i.Large = 2] = "Large";
  }(e.ImageSize || (e.ImageSize = {})), function(i) {
    i[i.Default = 0] = "Default", i[i.Stacked = 1] = "Stacked";
  }(e.ImageSetPresentationStyle || (e.ImageSetPresentationStyle = {})), function(i) {
    i[i.Weight = 0] = "Weight", i[i.Pixel = 1] = "Pixel";
  }(e.SizeUnit || (e.SizeUnit = {})), function(i) {
    i[i.Small = 0] = "Small", i[i.Default = 1] = "Default", i[i.Medium = 2] = "Medium", i[i.Large = 3] = "Large", i[i.ExtraLarge = 4] = "ExtraLarge";
  }(e.TextSize || (e.TextSize = {})), function(i) {
    i[i.RevealOnHover = 0] = "RevealOnHover", i[i.Default = 1] = "Default";
  }(e.InputStyle || (e.InputStyle = {})), function(i) {
    i[i.Lighter = 0] = "Lighter", i[i.Default = 1] = "Default", i[i.Bolder = 2] = "Bolder";
  }(e.TextWeight || (e.TextWeight = {})), function(i) {
    i[i.Default = 0] = "Default", i[i.Monospace = 1] = "Monospace";
  }(e.FontType || (e.FontType = {})), function(i) {
    i[i.None = 0] = "None", i[i.Small = 1] = "Small", i[i.Default = 2] = "Default", i[i.Medium = 3] = "Medium", i[i.Large = 4] = "Large", i[i.ExtraLarge = 5] = "ExtraLarge", i[i.Padding = 6] = "Padding";
  }(e.Spacing || (e.Spacing = {})), function(i) {
    i[i.Default = 0] = "Default", i[i.Dark = 1] = "Dark", i[i.Light = 2] = "Light", i[i.Accent = 3] = "Accent", i[i.Good = 4] = "Good", i[i.Warning = 5] = "Warning", i[i.Attention = 6] = "Attention";
  }(e.TextColor || (e.TextColor = {})), function(i) {
    i[i.Left = 0] = "Left", i[i.Center = 1] = "Center", i[i.Right = 2] = "Right";
  }(e.HorizontalAlignment || (e.HorizontalAlignment = {})), function(i) {
    i[i.Top = 0] = "Top", i[i.Center = 1] = "Center", i[i.Bottom = 2] = "Bottom";
  }(e.VerticalAlignment || (e.VerticalAlignment = {})), function(i) {
    i[i.Left = 0] = "Left", i[i.Center = 1] = "Center", i[i.Right = 2] = "Right", i[i.Stretch = 3] = "Stretch";
  }(e.ActionAlignment || (e.ActionAlignment = {})), function(i) {
    i[i.Default = 0] = "Default", i[i.Person = 1] = "Person";
  }(e.ImageStyle || (e.ImageStyle = {})), function(i) {
    i[i.Inline = 0] = "Inline", i[i.Popup = 1] = "Popup";
  }(e.ShowCardActionMode || (e.ShowCardActionMode = {})), function(i) {
    i[i.Horizontal = 0] = "Horizontal", i[i.Vertical = 1] = "Vertical";
  }(e.Orientation || (e.Orientation = {})), function(i) {
    i[i.Cover = 0] = "Cover", i[i.RepeatHorizontally = 1] = "RepeatHorizontally", i[i.RepeatVertically = 2] = "RepeatVertically", i[i.Repeat = 3] = "Repeat";
  }(e.FillMode || (e.FillMode = {})), function(i) {
    i[i.LeftOfTitle = 0] = "LeftOfTitle", i[i.AboveTitle = 1] = "AboveTitle";
  }(e.ActionIconPlacement || (e.ActionIconPlacement = {})), function(i) {
    i[i.Text = 0] = "Text", i[i.Tel = 1] = "Tel", i[i.Url = 2] = "Url", i[i.Email = 3] = "Email", i[i.Password = 4] = "Password";
  }(e.InputTextStyle || (e.InputTextStyle = {})), function(i) {
    i[i.Inline = 0] = "Inline", i[i.Above = 1] = "Above";
  }(e.InputLabelPosition || (e.InputLabelPosition = {})), function(i) {
    i[i.Parse = 0] = "Parse", i[i.ToJSON = 1] = "ToJSON", i[i.Validation = 2] = "Validation";
  }(e.ValidationPhase || (e.ValidationPhase = {})), function(i) {
    i[i.Hint = 0] = "Hint", i[i.ActionTypeNotAllowed = 1] = "ActionTypeNotAllowed", i[i.CollectionCantBeEmpty = 2] = "CollectionCantBeEmpty", i[i.Deprecated = 3] = "Deprecated", i[i.ElementTypeNotAllowed = 4] = "ElementTypeNotAllowed", i[i.InteractivityNotAllowed = 5] = "InteractivityNotAllowed", i[i.InvalidPropertyValue = 6] = "InvalidPropertyValue", i[i.MissingCardType = 7] = "MissingCardType", i[i.PropertyCantBeNull = 8] = "PropertyCantBeNull", i[i.TooManyActions = 9] = "TooManyActions", i[i.UnknownActionType = 10] = "UnknownActionType", i[i.UnknownElementType = 11] = "UnknownElementType", i[i.UnsupportedCardVersion = 12] = "UnsupportedCardVersion", i[i.DuplicateId = 13] = "DuplicateId", i[i.UnsupportedProperty = 14] = "UnsupportedProperty", i[i.RequiredInputsShouldHaveLabel = 15] = "RequiredInputsShouldHaveLabel", i[i.RequiredInputsShouldHaveErrorMessage = 16] = "RequiredInputsShouldHaveErrorMessage", i[i.Other = 17] = "Other";
  }(e.ValidationEvent || (e.ValidationEvent = {})), function(i) {
    i[i.FullyInContainer = 0] = "FullyInContainer", i[i.Overflowing = 1] = "Overflowing", i[i.FullyOutOfContainer = 2] = "FullyOutOfContainer";
  }(e.ContainerFitStatus || (e.ContainerFitStatus = {})), function(i) {
    i[i.UnknownType = 0] = "UnknownType", i[i.ForbiddenType = 1] = "ForbiddenType";
  }(e.TypeErrorType || (e.TypeErrorType = {})), function(i) {
    i[i.Disabled = 0] = "Disabled", i[i.Manual = 1] = "Manual", i[i.Automatic = 2] = "Automatic";
  }(e.RefreshMode || (e.RefreshMode = {})), function(i) {
    i[i.Info = 0] = "Info", i[i.Warning = 1] = "Warning", i[i.Error = 2] = "Error";
  }(e.LogLevel || (e.LogLevel = {})), function(i) {
    i[i.NavigationNext = 0] = "NavigationNext", i[i.NavigationPrevious = 1] = "NavigationPrevious", i[i.Pagination = 2] = "Pagination", i[i.Autoplay = 3] = "Autoplay";
  }(e.CarouselInteractionEvent || (e.CarouselInteractionEvent = {})), function(i) {
    i[i.Button = 0] = "Button", i[i.Link = 1] = "Link", i[i.Tab = 2] = "Tab", i[i.Menu = 3] = "Menu", i[i.MenuItem = 4] = "MenuItem";
  }(e.ActionRole || (e.ActionRole = {}));
})(Uu);
var fc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.UUID = e.SizeAndUnit = e.PaddingDefinition = e.SpacingDefinition = e.StringWithSubstitutions = e.ContentTypes = e.GlobalSettings = void 0;
  var t = Uu, r = (
    /** @class */
    function() {
      function s() {
      }
      return s.useAdvancedTextBlockTruncation = !0, s.useAdvancedCardBottomTruncation = !1, s.useMarkdownInRadioButtonAndCheckbox = !0, s.allowMarkForTextHighlighting = !1, s.alwaysBleedSeparators = !1, s.enableFullJsonRoundTrip = !1, s.displayInputValidationErrors = !0, s.allowPreProcessingPropertyValues = !1, s.setTabIndexAtCardRoot = !0, s.enableFallback = !0, s.useWebkitLineClamp = !0, s.allowMoreThanMaxActionsInOverflowMenu = !1, s.removePaddingFromContainersWithBackgroundImage = !1, s.resetInputsDirtyStateAfterActionExecution = !0, s.applets = {
        logEnabled: !0,
        logLevel: t.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3e3,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
          mode: t.RefreshMode.Manual,
          timeBetweenAutomaticRefreshes: 3e3,
          maximumConsecutiveAutomaticRefreshes: 3,
          allowManualRefreshesAfterAutomaticRefreshes: !0
        }
      }, s;
    }()
  );
  e.GlobalSettings = r, e.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
  };
  var n = (
    /** @class */
    function() {
      function s() {
        this._isProcessed = !1;
      }
      return s.prototype.getReferencedInputs = function(c, l) {
        if (!l)
          throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original)
          for (var f = 0, d = c; f < d.length; f++) {
            var p = d[f], v = new RegExp("\\{{2}(" + p.id + ").value\\}{2}", "gi").exec(this._original);
            v != null && p.id && (l[p.id] = p);
          }
      }, s.prototype.substituteInputValues = function(c, l) {
        if (this._processed = this._original, this._original)
          for (var f = /\{{2}([a-z0-9_$@]+).value\}{2}/gi, d = void 0; (d = f.exec(this._original)) !== null && this._processed; )
            for (var p = 0, v = Object.keys(c); p < v.length; p++) {
              var h = v[p];
              if (h.toLowerCase() === d[1].toLowerCase()) {
                var E = c[h], m = "";
                E.value && (m = E.value), l === e.ContentTypes.applicationJson ? (m = JSON.stringify(m), m = m.slice(1, -1)) : l === e.ContentTypes.applicationXWwwFormUrlencoded && (m = encodeURIComponent(m)), this._processed = this._processed.replace(d[0], m);
                break;
              }
            }
        this._isProcessed = !0;
      }, s.prototype.getOriginal = function() {
        return this._original;
      }, s.prototype.get = function() {
        return this._isProcessed ? this._processed : this._original;
      }, s.prototype.set = function(c) {
        this._original = c, this._isProcessed = !1;
      }, s;
    }()
  );
  e.StringWithSubstitutions = n;
  var i = (
    /** @class */
    /* @__PURE__ */ function() {
      function s(c, l, f, d) {
        c === void 0 && (c = 0), l === void 0 && (l = 0), f === void 0 && (f = 0), d === void 0 && (d = 0), this.left = 0, this.top = 0, this.right = 0, this.bottom = 0, this.top = c, this.right = l, this.bottom = f, this.left = d;
      }
      return s;
    }()
  );
  e.SpacingDefinition = i;
  var o = (
    /** @class */
    /* @__PURE__ */ function() {
      function s(c, l, f, d) {
        c === void 0 && (c = t.Spacing.None), l === void 0 && (l = t.Spacing.None), f === void 0 && (f = t.Spacing.None), d === void 0 && (d = t.Spacing.None), this.top = t.Spacing.None, this.right = t.Spacing.None, this.bottom = t.Spacing.None, this.left = t.Spacing.None, this.top = c, this.right = l, this.bottom = f, this.left = d;
      }
      return s;
    }()
  );
  e.PaddingDefinition = o;
  var a = (
    /** @class */
    function() {
      function s(c, l) {
        this.physicalSize = c, this.unit = l;
      }
      return s.parse = function(c, l) {
        l === void 0 && (l = !1);
        var f = new s(0, t.SizeUnit.Weight);
        if (typeof c == "number")
          return f.physicalSize = c, f;
        if (typeof c == "string") {
          var d = /^([0-9]+)(px|\*)?$/g, p = d.exec(c), v = l ? 3 : 2;
          if (p && p.length >= v)
            return f.physicalSize = parseInt(p[1]), p.length === 3 && p[2] === "px" && (f.unit = t.SizeUnit.Pixel), f;
        }
        throw new Error("Invalid size: " + c);
      }, s;
    }()
  );
  e.SizeAndUnit = a;
  /**
   * Fast UUID generator, RFC4122 version 4 compliant.
   * @author Jeff Ward (jcward.com).
   * @license MIT license
   * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
   **/
  var u = (
    /** @class */
    function() {
      function s() {
      }
      return s.generate = function() {
        var c = Math.random() * 4294967295 | 0, l = Math.random() * 4294967295 | 0, f = Math.random() * 4294967295 | 0, d = Math.random() * 4294967295 | 0;
        return s.lut[c & 255] + s.lut[c >> 8 & 255] + s.lut[c >> 16 & 255] + s.lut[c >> 24 & 255] + "-" + s.lut[l & 255] + s.lut[l >> 8 & 255] + "-" + s.lut[l >> 16 & 15 | 64] + s.lut[l >> 24 & 255] + "-" + s.lut[f & 63 | 128] + s.lut[f >> 8 & 255] + "-" + s.lut[f >> 16 & 255] + s.lut[f >> 24 & 255] + s.lut[d & 255] + s.lut[d >> 8 & 255] + s.lut[d >> 16 & 255] + s.lut[d >> 24 & 255];
      }, s.initialize = function() {
        for (var c = 0; c < 256; c++)
          s.lut[c] = (c < 16 ? "0" : "") + c.toString(16);
      }, s.lut = [], s;
    }()
  );
  e.UUID = u, u.initialize();
})(fc);
var Pr = {}, VD;
Object.defineProperty(Pr, "__esModule", { value: !0 });
Pr.debounce = Pr.addCancelSelectActionEventHandler = Pr.clearElementChildren = Pr.getScrollY = Pr.getScrollX = Pr.getFitStatus = Pr.truncate = Pr.truncateText = Pr.stringToCssColor = Pr.parseEnum = Pr.getEnumValueByName = Pr.parseBool = Pr.parseNumber = Pr.parseString = Pr.appendChild = Pr.generateUniqueId = Pr.isMobileOS = Pr.isInternetExplorer = void 0;
var jD = Uu, Jtr = fc;
function Ztr() {
  return window.document.documentMode !== void 0;
}
Pr.isInternetExplorer = Ztr;
function Qtr() {
  var e = window.navigator.userAgent;
  return !!e.match(/Android/i) || !!e.match(/iPad/i) || !!e.match(/iPhone/i);
}
Pr.isMobileOS = Qtr;
function err() {
  return "__ac-" + Jtr.UUID.generate();
}
Pr.generateUniqueId = err;
function trr(e, t) {
  t && e.appendChild(t);
}
Pr.appendChild = trr;
function rrr(e, t) {
  return typeof e == "string" ? e : t;
}
Pr.parseString = rrr;
function nrr(e, t) {
  return typeof e == "number" ? e : t;
}
Pr.parseNumber = nrr;
function irr(e, t) {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string")
    switch (e.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      default:
        return t;
    }
  return t;
}
Pr.parseBool = irr;
function D1e(e, t) {
  for (var r in e) {
    var n = parseInt(r, 10);
    if (n >= 0) {
      var i = e[r];
      if (i && typeof i == "string" && i.toLowerCase() === t.toLowerCase())
        return n;
    }
  }
}
Pr.getEnumValueByName = D1e;
function orr(e, t, r) {
  if (!t)
    return r;
  var n = D1e(e, t);
  return n !== void 0 ? n : r;
}
Pr.parseEnum = orr;
function arr(e) {
  if (e) {
    var t = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi, r = t.exec(e);
    if (r && r[4]) {
      var n = parseInt(r[1], 16) / 255, i = parseInt(r[2], 16), o = parseInt(r[3], 16), a = parseInt(r[4], 16);
      return "rgba(" + i + "," + o + "," + a + "," + n + ")";
    }
  }
  return e;
}
Pr.stringToCssColor = arr;
function x1e(e, t, r, n, i) {
  var o = function() {
    return t - e.scrollHeight >= -1;
  };
  if (!o()) {
    for (var a = crr(r), u = 0, s = a.length, c = 0; u < s; ) {
      var l = Math.floor((u + s) / 2);
      n(r, a[l]), o() ? (c = a[l], u = l + 1) : s = l;
    }
    if (n(r, c), i && t - e.scrollHeight >= i - 1) {
      for (var f = MS(r, c); f < r.length && (n(r, f), o()); )
        c = f, f = MS(r, f);
      n(r, c);
    }
  }
}
function urr(e, t, r) {
  x1e(e, t, e.innerText, function(n, i) {
    e.innerText = n.substring(0, i) + "...";
  }, r);
}
Pr.truncateText = urr;
var zD = typeof window > "u" || (VD = window.trustedTypes) === null || VD === void 0 ? void 0 : VD.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
  createHTML: function(e) {
    return e;
  }
});
function srr(e, t, r) {
  x1e(e, t, e.innerHTML, function(n, i) {
    var o, a = n.substring(0, i) + "...", u = (o = zD == null ? void 0 : zD.createHTML(a)) !== null && o !== void 0 ? o : a;
    e.innerHTML = u;
  }, r);
}
Pr.truncate = srr;
function crr(e) {
  for (var t = [], r = MS(e, -1); r < e.length; )
    e[r] === " " && t.push(r), r = MS(e, r);
  return t;
}
function MS(e, t) {
  for (t += 1; t < e.length && e[t] === "<"; )
    for (; t < e.length && e[t++] !== ">"; )
      ;
  return t;
}
function lrr(e, t) {
  var r = e.offsetTop, n = r + e.clientHeight;
  return n <= t ? jD.ContainerFitStatus.FullyInContainer : r < t ? jD.ContainerFitStatus.Overflowing : jD.ContainerFitStatus.FullyOutOfContainer;
}
Pr.getFitStatus = lrr;
function frr() {
  return window.pageXOffset;
}
Pr.getScrollX = frr;
function drr() {
  return window.pageYOffset;
}
Pr.getScrollY = drr;
function prr(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
Pr.clearElementChildren = prr;
function hrr(e) {
  e.onclick = function(t) {
    t.preventDefault(), t.cancelBubble = !0;
  };
}
Pr.addCancelSelectActionEventHandler = hrr;
function vrr(e, t) {
  var r;
  function n() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    r && clearTimeout(r), r = setTimeout(function() {
      e.apply(void 0, i);
    }, t);
  }
  return n;
}
Pr.debounce = vrr;
var Dr = {}, Is = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Dr, "__esModule", { value: !0 });
Dr.SerializableObject = Dr.property = Dr.SerializableObjectSchema = Dr.CustomProperty = Dr.SerializableObjectCollectionProperty = Dr.SerializableObjectProperty = Dr.EnumProperty = Dr.ValueSetProperty = Dr.StringArrayProperty = Dr.PixelSizeProperty = Dr.NumProperty = Dr.BoolProperty = Dr.StringProperty = Dr.PropertyDefinition = Dr.BaseSerializationContext = Dr.isVersionLessOrEqual = Dr.Versions = Dr.Version = void 0;
var mf = fc, v3 = Pr, Ea = Uu, Js = lc, os = (
  /** @class */
  function() {
    function e(t, r, n) {
      t === void 0 && (t = 1), r === void 0 && (r = 1), this._isValid = !0, this._major = t, this._minor = r, this._label = n;
    }
    return e.parse = function(t, r) {
      if (t) {
        var n = new e();
        n._versionString = t;
        var i = /(\d+).(\d+)/gi, o = i.exec(t);
        return o != null && o.length === 3 ? (n._major = parseInt(o[1]), n._minor = parseInt(o[2])) : n._isValid = !1, n._isValid || r.logParseEvent(void 0, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidVersionString(n._versionString)), n;
      }
    }, e.prototype.toString = function() {
      return this._isValid ? this._major + "." + this._minor : this._versionString;
    }, e.prototype.toJSON = function() {
      return this.toString();
    }, e.prototype.compareTo = function(t) {
      if (!this.isValid || !t.isValid)
        throw new Error("Cannot compare invalid version.");
      return this.major > t.major ? 1 : this.major < t.major ? -1 : this.minor > t.minor ? 1 : this.minor < t.minor ? -1 : 0;
    }, Object.defineProperty(e.prototype, "label", {
      get: function() {
        return this._label ? this._label : this.toString();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "major", {
      get: function() {
        return this._major;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "minor", {
      get: function() {
        return this._minor;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isValid", {
      get: function() {
        return this._isValid;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
Dr.Version = os;
var s7 = (
  /** @class */
  function() {
    function e() {
    }
    return e.getAllDeclaredVersions = function() {
      var t = e, r = [];
      for (var n in t)
        if (n.match(/^v[0-9_]*$/))
          try {
            var i = t[n];
            i instanceof os && r.push(i);
          } catch {
          }
      return r.sort(function(o, a) {
        return o.compareTo(a);
      });
    }, e.v1_0 = new os(1, 0), e.v1_1 = new os(1, 1), e.v1_2 = new os(1, 2), e.v1_3 = new os(1, 3), e.v1_4 = new os(1, 4), e.v1_5 = new os(1, 5), e.v1_6 = new os(1, 6), e.latest = e.v1_6, e;
  }()
);
Dr.Versions = s7;
function Err(e, t) {
  return e instanceof os && t instanceof os ? t.compareTo(e) >= 0 : !0;
}
Dr.isVersionLessOrEqual = Err;
var c7 = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = s7.latest), this._validationEvents = [], this.targetVersion = t;
    }
    return e.prototype.isTemplateString = function(t) {
      return typeof t == "string" ? t.startsWith("${") : !1;
    }, e.prototype.tryDeleteValue = function(t, r) {
      mf.GlobalSettings.enableFullJsonRoundTrip || delete t[r];
    }, e.prototype.tryDeleteDefaultValue = function(t, r) {
      (!mf.GlobalSettings.enableFullJsonRoundTrip || !this.isTemplateString(t[r])) && delete t[r];
    }, e.prototype.serializeValue = function(t, r, n, i, o) {
      i === void 0 && (i = void 0), o === void 0 && (o = !1), n == null ? (!mf.GlobalSettings.enableFullJsonRoundTrip || o) && delete t[r] : n === i ? (!mf.GlobalSettings.enableFullJsonRoundTrip || o || !this.isTemplateString(t[r])) && delete t[r] : t[r] = n;
    }, e.prototype.serializeString = function(t, r, n, i) {
      n == null ? this.tryDeleteValue(t, r) : n === i ? this.tryDeleteDefaultValue(t, r) : t[r] = n;
    }, e.prototype.serializeBool = function(t, r, n, i) {
      n == null ? this.tryDeleteValue(t, r) : n === i ? this.tryDeleteDefaultValue(t, r) : t[r] = n;
    }, e.prototype.serializeNumber = function(t, r, n, i) {
      n == null || isNaN(n) ? this.tryDeleteValue(t, r) : n === i ? this.tryDeleteDefaultValue(t, r) : t[r] = n;
    }, e.prototype.serializeEnum = function(t, r, n, i, o) {
      o === void 0 && (o = void 0), i == null ? this.tryDeleteValue(r, n) : i === o ? this.tryDeleteDefaultValue(r, n) : r[n] = t[i];
    }, e.prototype.serializeArray = function(t, r, n) {
      var i = [];
      if (n)
        for (var o = 0, a = n; o < a.length; o++) {
          var u = a[o], s = void 0;
          u instanceof L1e ? s = u.toJSON(this) : u.toJSON ? s = u.toJSON() : s = u, s !== void 0 && i.push(s);
        }
      i.length === 0 ? t.hasOwnProperty(r) && Array.isArray(t[r]) && delete t[r] : this.serializeValue(t, r, i);
    }, e.prototype.clearEvents = function() {
      this._validationEvents = [];
    }, e.prototype.logEvent = function(t, r, n, i) {
      this._validationEvents.push({
        source: t,
        phase: r,
        event: n,
        message: i
      });
    }, e.prototype.logParseEvent = function(t, r, n) {
      this.logEvent(t, Ea.ValidationPhase.Parse, r, n);
    }, e.prototype.getEventAt = function(t) {
      return this._validationEvents[t];
    }, Object.defineProperty(e.prototype, "eventCount", {
      get: function() {
        return this._validationEvents.length;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
Dr.BaseSerializationContext = c7;
var see = (
  /** @class */
  function(e) {
    Is(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(c7)
), Vu = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this.targetVersion = t, this.name = r, this.defaultValue = n, this.onGetInitialValue = i, this.isSerializationEnabled = !0, this.sequentialNumber = e._sequentialNumber, e._sequentialNumber++;
    }
    return e.prototype.getInternalName = function() {
      return this.name;
    }, e.prototype.parse = function(t, r, n) {
      return r[this.name];
    }, e.prototype.toJSON = function(t, r, n, i) {
      i.serializeValue(r, this.name, n, this.defaultValue);
    }, e._sequentialNumber = 0, e;
  }()
);
Dr.PropertyDefinition = Vu;
var mrr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o, a, u) {
      i === void 0 && (i = !0);
      var s = e.call(this, r, n, a, u) || this;
      return s.targetVersion = r, s.name = n, s.treatEmptyAsUndefined = i, s.regEx = o, s.defaultValue = a, s.onGetInitialValue = u, s;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = v3.parseString(n[this.name], this.defaultValue), a = o === void 0 || o === "" && this.treatEmptyAsUndefined;
      if (!a && this.regEx !== void 0) {
        var u = this.regEx.exec(o);
        if (!u) {
          i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidPropertyValue(o, this.name));
          return;
        }
      }
      return o;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeString(n, this.name, i === "" && this.treatEmptyAsUndefined ? void 0 : i, this.defaultValue);
    }, t;
  }(Vu)
);
Dr.StringProperty = mrr;
var grr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n, i, o) || this;
      return a.targetVersion = r, a.name = n, a.defaultValue = i, a.onGetInitialValue = o, a;
    }
    return t.prototype.parse = function(r, n, i) {
      return v3.parseBool(n[this.name], this.defaultValue);
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeBool(n, this.name, i, this.defaultValue);
    }, t;
  }(Vu)
);
Dr.BoolProperty = grr;
var Trr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n, i, o) || this;
      return a.targetVersion = r, a.name = n, a.defaultValue = i, a.onGetInitialValue = o, a;
    }
    return t.prototype.parse = function(r, n, i) {
      return v3.parseNumber(n[this.name], this.defaultValue);
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeNumber(n, this.name, i, this.defaultValue);
    }, t;
  }(Vu)
);
Dr.NumProperty = Trr;
var yrr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = void 0, a = n[this.name];
      if (typeof a == "string") {
        var u = !1;
        try {
          var s = mf.SizeAndUnit.parse(a, !0);
          s.unit === Ea.SizeUnit.Pixel && (o = s.physicalSize, u = !0);
        } catch {
        }
        u || i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidPropertyValue(n[this.name], this.name));
      }
      return o;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeValue(n, this.name, typeof i == "number" && !isNaN(i) ? i + "px" : void 0);
    }, t;
  }(Vu)
);
Dr.PixelSizeProperty = yrr;
var _rr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n, i, o) || this;
      return a.targetVersion = r, a.name = n, a.defaultValue = i, a.onGetInitialValue = o, a;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = n[this.name];
      if (o === void 0 || !Array.isArray(o))
        return this.defaultValue;
      for (var a = [], u = 0, s = o; u < s.length; u++) {
        var c = s[u];
        typeof c == "string" ? a.push(c) : i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, 'Invalid array value "'.concat(JSON.stringify(c), '" of type "').concat(typeof c, '" ignored for "').concat(this.name, '".'));
      }
      return a;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeArray(n, this.name, i);
    }, t;
  }(Vu)
);
Dr.StringArrayProperty = _rr;
var Arr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r, n, o, a) || this;
      return u.targetVersion = r, u.name = n, u.values = i, u.defaultValue = o, u.onGetInitialValue = a, u;
    }
    return t.prototype.isValidValue = function(r, n) {
      for (var i = 0, o = this.values; i < o.length; i++) {
        var a = o[i];
        if (r.toLowerCase() === a.value.toLowerCase()) {
          var u = a.targetVersion ? a.targetVersion : this.targetVersion;
          return u.compareTo(n.targetVersion) <= 0;
        }
      }
      return !1;
    }, t.prototype.parse = function(r, n, i) {
      var o = n[this.name];
      if (o === void 0)
        return this.defaultValue;
      if (typeof o == "string")
        for (var a = 0, u = this.values; a < u.length; a++) {
          var s = u[a];
          if (o.toLowerCase() === s.value.toLowerCase()) {
            var c = s.targetVersion ? s.targetVersion : this.targetVersion;
            return c.compareTo(i.targetVersion) <= 0 ? s.value : (i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.propertyValueNotSupported(o, this.name, c.toString(), i.targetVersion.toString())), this.defaultValue);
          }
        }
      return i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidPropertyValue(o, this.name)), this.defaultValue;
    }, t.prototype.toJSON = function(r, n, i, o) {
      var a = !1;
      if (i !== void 0) {
        a = !0;
        for (var u = 0, s = this.values; u < s.length; u++) {
          var c = s[u];
          if (c.value === i) {
            var l = c.targetVersion ? c.targetVersion : this.targetVersion;
            if (l.compareTo(o.targetVersion) <= 0) {
              a = !1;
              break;
            } else
              o.logEvent(r, Ea.ValidationPhase.ToJSON, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.propertyValueNotSupported(i, this.name, l.toString(), o.targetVersion.toString()));
          }
        }
      }
      a || o.serializeValue(n, this.name, i, this.defaultValue, !0);
    }, t;
  }(Vu)
);
Dr.ValueSetProperty = Arr;
var Srr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o, a, u) {
      var s = e.call(this, r, n, o, u) || this;
      if (s.targetVersion = r, s.name = n, s.enumType = i, s.defaultValue = o, s.onGetInitialValue = u, s._values = [], a)
        s._values = a;
      else
        for (var c in i) {
          var l = parseInt(c, 10);
          l >= 0 && s._values.push({ value: l });
        }
      return s;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = n[this.name];
      if (typeof o != "string")
        return this.defaultValue;
      var a = v3.getEnumValueByName(this.enumType, o);
      if (a !== void 0)
        for (var u = 0, s = this.values; u < s.length; u++) {
          var c = s[u];
          if (c.value === a) {
            var l = c.targetVersion ? c.targetVersion : this.targetVersion;
            return l.compareTo(i.targetVersion) <= 0 ? a : (i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.propertyValueNotSupported(o, this.name, l.toString(), i.targetVersion.toString())), this.defaultValue);
          }
        }
      return i.logParseEvent(r, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidPropertyValue(o, this.name)), this.defaultValue;
    }, t.prototype.toJSON = function(r, n, i, o) {
      var a = !1;
      if (i !== void 0) {
        a = !0;
        for (var u = 0, s = this.values; u < s.length; u++) {
          var c = s[u];
          if (c.value === i) {
            var l = c.targetVersion ? c.targetVersion : this.targetVersion;
            if (l.compareTo(o.targetVersion) <= 0) {
              a = !1;
              break;
            } else
              o.logEvent(r, Ea.ValidationPhase.ToJSON, Ea.ValidationEvent.InvalidPropertyValue, Js.Strings.errors.invalidPropertyValue(i, this.name));
          }
        }
      }
      a || o.serializeEnum(this.enumType, n, this.name, i, this.defaultValue);
    }, Object.defineProperty(t.prototype, "values", {
      get: function() {
        return this._values;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Vu)
);
Dr.EnumProperty = Srr;
var brr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o, a) {
      o === void 0 && (o = !1);
      var u = e.call(this, r, n, a, function(s) {
        return u.nullable ? void 0 : new u.objectType();
      }) || this;
      return u.targetVersion = r, u.name = n, u.objectType = i, u.nullable = o, u;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = n[this.name];
      if (o === void 0)
        return this.onGetInitialValue ? this.onGetInitialValue(r) : this.defaultValue;
      var a = new this.objectType();
      return a.parse(o, i), a;
    }, t.prototype.toJSON = function(r, n, i, o) {
      var a = void 0;
      i !== void 0 && !i.hasAllDefaultValues() && (a = i.toJSON(o)), typeof a == "object" && Object.keys(a).length === 0 && (a = void 0), o.serializeValue(n, this.name, a, this.defaultValue, !0);
    }, t;
  }(Vu)
);
Dr.SerializableObjectProperty = brr;
var Crr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n, void 0, function(u) {
        return [];
      }) || this;
      return a.targetVersion = r, a.name = n, a.objectType = i, a.onItemAdded = o, a;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = [], a = n[this.name];
      if (Array.isArray(a))
        for (var u = 0, s = a; u < s.length; u++) {
          var c = s[u], l = new this.objectType();
          l.parse(c, i), o.push(l), this.onItemAdded && this.onItemAdded(r, l);
        }
      return o.length > 0 ? o : this.onGetInitialValue ? this.onGetInitialValue(r) : void 0;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeArray(n, this.name, i);
    }, t;
  }(Vu)
);
Dr.SerializableObjectCollectionProperty = Crr;
var Irr = (
  /** @class */
  function(e) {
    Is(t, e);
    function t(r, n, i, o, a, u) {
      var s = e.call(this, r, n, a, u) || this;
      if (s.targetVersion = r, s.name = n, s.onParse = i, s.onToJSON = o, s.defaultValue = a, s.onGetInitialValue = u, !s.onParse)
        throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
      if (!s.onToJSON)
        throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
      return s;
    }
    return t.prototype.parse = function(r, n, i) {
      return this.onParse(r, this, n, i);
    }, t.prototype.toJSON = function(r, n, i, o) {
      this.onToJSON(r, this, n, i, o);
    }, t;
  }(Vu)
);
Dr.CustomProperty = Irr;
var N1e = (
  /** @class */
  function() {
    function e() {
      this._properties = [];
    }
    return e.prototype.indexOf = function(t) {
      for (var r = 0; r < this._properties.length; r++)
        if (this._properties[r] === t)
          return r;
      return -1;
    }, e.prototype.add = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      for (var n = 0, i = t; n < i.length; n++) {
        var o = i[n];
        this.indexOf(o) === -1 && this._properties.push(o);
      }
    }, e.prototype.remove = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      for (var n = 0, i = t; n < i.length; n++)
        for (var o = i[n]; ; ) {
          var a = this.indexOf(o);
          if (a >= 0)
            this._properties.splice(a, 1);
          else
            break;
        }
    }, e.prototype.getItemAt = function(t) {
      return this._properties[t];
    }, e.prototype.getCount = function() {
      return this._properties.length;
    }, e;
  }()
);
Dr.SerializableObjectSchema = N1e;
function Orr(e) {
  return function(t, r) {
    var n = Object.getOwnPropertyDescriptor(t, r) || {};
    !n.get && !n.set && (n.get = function() {
      return this.getValue(e);
    }, n.set = function(i) {
      this.setValue(e, i);
    }, Object.defineProperty(t, r, n));
  };
}
Dr.property = Orr;
var L1e = (
  /** @class */
  function() {
    function e() {
      this._propertyBag = {}, this._rawProperties = {}, this.maxVersion = e.defaultMaxVersion;
      for (var t = this.getSchema(), r = 0; r < t.getCount(); r++) {
        var n = t.getItemAt(r);
        n.onGetInitialValue && this.setValue(n, n.onGetInitialValue(this));
      }
    }
    return e.prototype.getDefaultSerializationContext = function() {
      return new see();
    }, e.prototype.populateSchema = function(t) {
      var r = this.constructor, n = [];
      for (var i in r)
        try {
          var o = r[i];
          o instanceof Vu && n.push(o);
        } catch {
        }
      if (n.length > 0) {
        var a = n.sort(function(u, s) {
          return u.sequentialNumber > s.sequentialNumber ? 1 : u.sequentialNumber < s.sequentialNumber ? -1 : 0;
        });
        t.add.apply(t, a);
      }
      e.onRegisterCustomProperties && e.onRegisterCustomProperties(this, t);
    }, e.prototype.getValue = function(t) {
      return this._propertyBag.hasOwnProperty(t.getInternalName()) ? this._propertyBag[t.getInternalName()] : t.defaultValue;
    }, e.prototype.setValue = function(t, r) {
      r == null ? delete this._propertyBag[t.getInternalName()] : this._propertyBag[t.getInternalName()] = r;
    }, e.prototype.internalParse = function(t, r) {
      if (this._propertyBag = {}, this._rawProperties = mf.GlobalSettings.enableFullJsonRoundTrip ? t || {} : {}, t)
        for (var n = this.getSchema(), i = 0; i < n.getCount(); i++) {
          var o = n.getItemAt(i);
          if (o.isSerializationEnabled) {
            var a = o.onGetInitialValue ? o.onGetInitialValue(this) : void 0;
            t.hasOwnProperty(o.name) && (o.targetVersion.compareTo(r.targetVersion) <= 0 ? a = o.parse(this, t, r) : r.logParseEvent(this, Ea.ValidationEvent.UnsupportedProperty, Js.Strings.errors.propertyNotSupported(o.name, o.targetVersion.toString(), r.targetVersion.toString()))), this.setValue(o, a);
          }
        }
      else
        this.resetDefaultValues();
    }, e.prototype.internalToJSON = function(t, r) {
      for (var n = this.getSchema(), i = [], o = 0; o < n.getCount(); o++) {
        var a = n.getItemAt(o);
        a.isSerializationEnabled && a.targetVersion.compareTo(r.targetVersion) <= 0 && i.indexOf(a.name) === -1 && (a.toJSON(this, t, this.getValue(a), r), i.push(a.name));
      }
    }, e.prototype.shouldSerialize = function(t) {
      return !0;
    }, e.prototype.parse = function(t, r) {
      this.internalParse(t, r || new see());
    }, e.prototype.toJSON = function(t) {
      var r;
      if (t && t instanceof c7 ? r = t : (r = this.getDefaultSerializationContext(), r.toJSONOriginalParam = t), this.shouldSerialize(r)) {
        var n = void 0;
        return mf.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties == "object" ? n = this._rawProperties : n = {}, this.internalToJSON(n, r), n;
      } else
        return;
    }, e.prototype.hasDefaultValue = function(t) {
      return this.getValue(t) === t.defaultValue;
    }, e.prototype.hasAllDefaultValues = function() {
      for (var t = this.getSchema(), r = 0; r < t.getCount(); r++) {
        var n = t.getItemAt(r);
        if (!this.hasDefaultValue(n))
          return !1;
      }
      return !0;
    }, e.prototype.resetDefaultValues = function() {
      for (var t = this.getSchema(), r = 0; r < t.getCount(); r++) {
        var n = t.getItemAt(r);
        this.setValue(n, n.defaultValue);
      }
    }, e.prototype.setCustomProperty = function(t, r) {
      var n = typeof r == "string" && !r || r === void 0 || r === null;
      n ? delete this._rawProperties[t] : this._rawProperties[t] = r;
    }, e.prototype.getCustomProperty = function(t) {
      return this._rawProperties[t];
    }, e.prototype.getSchema = function() {
      var t = e._schemaCache[this.getSchemaKey()];
      return t || (t = new N1e(), this.populateSchema(t), e._schemaCache[this.getSchemaKey()] = t), t;
    }, e.defaultMaxVersion = s7.latest, e._schemaCache = {}, e;
  }()
);
Dr.SerializableObject = L1e;
var qh = {}, Rrr = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(qh, "__esModule", { value: !0 });
qh.HostCapabilities = void 0;
var cee = Dr, wrr = (
  /** @class */
  function(e) {
    Rrr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._capabilities = {}, r;
    }
    return t.prototype.getSchemaKey = function() {
      return "HostCapabilities";
    }, t.prototype.internalParse = function(r, n) {
      if (e.prototype.internalParse.call(this, r, n), r)
        for (var i in r) {
          var o = r[i];
          if (typeof o == "string")
            if (o === "*")
              this.addCapability(i, "*");
            else {
              var a = cee.Version.parse(o, n);
              a != null && a.isValid && this.addCapability(i, a);
            }
        }
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n);
      for (var i in this._capabilities)
        r[i] = this._capabilities[i];
    }, t.prototype.addCapability = function(r, n) {
      this._capabilities[r] = n;
    }, t.prototype.removeCapability = function(r) {
      delete this._capabilities[r];
    }, t.prototype.clear = function() {
      this._capabilities = {};
    }, t.prototype.hasCapability = function(r, n) {
      return this._capabilities.hasOwnProperty(r) ? n === "*" || this._capabilities[r] === "*" ? !0 : n.compareTo(this._capabilities[r]) <= 0 : !1;
    }, t.prototype.areAllMet = function(r) {
      for (var n in this._capabilities)
        if (!r.hasCapability(n, this._capabilities[n]))
          return !1;
      return !0;
    }, t;
  }(cee.SerializableObject)
);
qh.HostCapabilities = wrr;
var ar = {}, Yh = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(ar, "__esModule", { value: !0 });
ar.defaultHostConfig = ar.HostConfig = ar.CarouselConfig = ar.FontTypeSet = ar.FontTypeDefinition = ar.ContainerStyleSet = ar.ContainerStyleDefinition = ar.ColorSetDefinition = ar.ActionsConfig = ar.ShowCardActionConfig = ar.FactSetConfig = ar.FactTitleDefinition = ar.FactTextDefinition = ar.InputConfig = ar.InputLabelConfig = ar.RequiredInputLabelTextDefinition = ar.TextBlockConfig = ar.TextStyleSet = ar.TextStyleDefinition = ar.BaseTextDefinition = ar.TableConfig = ar.MediaConfig = ar.ImageSetConfig = ar.AdaptiveCardConfig = ar.TextColorDefinition = ar.ColorDefinition = void 0;
var Ht = Uu, E3 = Pr, B1e = fc, Prr = qh;
function Nu(e, t, r) {
  if (typeof t == "string") {
    var n = E3.parseEnum(e, t, r);
    return n !== void 0 ? n : r;
  } else return typeof t == "number" ? t : r;
}
var ZL = (
  /** @class */
  function() {
    function e(t, r) {
      this.default = "#000000", this.subtle = "#666666", t && (this.default = t), r && (this.subtle = r);
    }
    return e.prototype.parse = function(t) {
      t && (this.default = t.default || this.default, this.subtle = t.subtle || this.subtle);
    }, e;
  }()
);
ar.ColorDefinition = ZL;
var kl = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.highlightColors = new ZL("#22000000", "#11000000"), r;
    }
    return t.prototype.parse = function(r) {
      e.prototype.parse.call(this, r), r && this.highlightColors.parse(r.highlightColors);
    }, t;
  }(ZL)
);
ar.TextColorDefinition = kl;
var QL = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.allowCustomStyle = !1, t && (this.allowCustomStyle = t.allowCustomStyle || this.allowCustomStyle);
    }
    return e;
  }()
);
ar.AdaptiveCardConfig = QL;
var eB = (
  /** @class */
  function() {
    function e(t) {
      this.imageSize = Ht.Size.Medium, this.maxImageHeight = 100, t && (this.imageSize = t.imageSize != null ? t.imageSize : this.imageSize, this.maxImageHeight = E3.parseNumber(t.maxImageHeight, 100));
    }
    return e.prototype.toJSON = function() {
      return {
        imageSize: Ht.Size[this.imageSize],
        maxImageHeight: this.maxImageHeight
      };
    }, e;
  }()
);
ar.ImageSetConfig = eB;
var k1e = (
  /** @class */
  function() {
    function e(t) {
      this.allowInlinePlayback = !0, t && (this.defaultPoster = t.defaultPoster, this.allowInlinePlayback = t.allowInlinePlayback || this.allowInlinePlayback);
    }
    return e.prototype.toJSON = function() {
      return {
        defaultPoster: this.defaultPoster,
        allowInlinePlayback: this.allowInlinePlayback
      };
    }, e;
  }()
);
ar.MediaConfig = k1e;
var M1e = (
  /** @class */
  function() {
    function e(t) {
      this.cellSpacing = 8, t && (this.cellSpacing = t.cellSpacing && typeof t.cellSpacing == "number" ? t.cellSpacing : this.cellSpacing);
    }
    return e.prototype.toJSON = function() {
      return {
        cellSpacing: this.cellSpacing
      };
    }, e;
  }()
);
ar.TableConfig = M1e;
var Ql = (
  /** @class */
  function() {
    function e(t) {
      this.size = Ht.TextSize.Default, this.color = Ht.TextColor.Default, this.isSubtle = !1, this.weight = Ht.TextWeight.Default, this.parse(t);
    }
    return e.prototype.parse = function(t) {
      t && (this.size = Nu(Ht.TextSize, t.size, this.size), this.color = Nu(Ht.TextColor, t.color, this.color), this.isSubtle = t.isSubtle !== void 0 && typeof t.isSubtle == "boolean" ? t.isSubtle : this.isSubtle, this.weight = Nu(Ht.TextWeight, t.weight, this.getDefaultWeight()));
    }, e.prototype.getDefaultWeight = function() {
      return Ht.TextWeight.Default;
    }, e.prototype.toJSON = function() {
      return {
        size: Ht.TextSize[this.size],
        color: Ht.TextColor[this.color],
        isSubtle: this.isSubtle,
        weight: Ht.TextWeight[this.weight]
      };
    }, e;
  }()
);
ar.BaseTextDefinition = Ql;
var B4 = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.fontType = Ht.FontType.Default, r;
    }
    return t.prototype.parse = function(r) {
      e.prototype.parse.call(this, r), r && (this.fontType = Nu(Ht.FontType, r.fontType, this.fontType));
    }, t;
  }(Ql)
);
ar.TextStyleDefinition = B4;
var tB = (
  /** @class */
  function() {
    function e(t) {
      this.default = new B4(), this.heading = new B4({
        size: "Large",
        weight: "Bolder"
      }), this.columnHeader = new B4({
        weight: "Bolder"
      }), t && (this.heading.parse(t.heading), this.columnHeader.parse(t.columnHeader));
    }
    return e.prototype.getStyleByName = function(t) {
      switch (t.toLowerCase()) {
        case "heading":
          return this.heading;
        case "columnHeader":
          return this.columnHeader;
        default:
          return this.default;
      }
    }, e;
  }()
);
ar.TextStyleSet = tB;
var rB = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      t && (this.headingLevel = E3.parseNumber(t.headingLevel));
    }
    return e;
  }()
);
ar.TextBlockConfig = rB;
var nB = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.suffix = " *", r.suffixColor = Ht.TextColor.Attention, r;
    }
    return t.prototype.parse = function(r) {
      e.prototype.parse.call(this, r), r && (this.suffix = r.suffix || this.suffix, this.suffixColor = Nu(Ht.TextColor, r.suffixColor, this.suffixColor));
    }, t.prototype.toJSON = function() {
      var r = e.prototype.toJSON.call(this);
      return r.suffix = this.suffix, r.suffixColor = Ht.TextColor[this.suffixColor], r;
    }, t;
  }(Ql)
);
ar.RequiredInputLabelTextDefinition = nB;
var iB = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.inputSpacing = Ht.Spacing.Small, this.width = 30, this.requiredInputs = new nB(), this.optionalInputs = new Ql(), t && (this.inputSpacing = Nu(Ht.Spacing, t.inputSpacing, this.inputSpacing), this.requiredInputs = new nB(t.requiredInputs), this.optionalInputs = new Ql(t.optionalInputs), this.width = t.width != null ? t.width : this.width);
    }
    return e;
  }()
);
ar.InputLabelConfig = iB;
var oB = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.label = new iB(), this.errorMessage = new Ql({
        color: Ht.TextColor.Attention
      }), this.debounceTimeInMilliSeconds = 0, this.allowDynamicallyFilteredChoiceSet = !0, this.allowRevealOnHoverStyle = !1, t && (this.label = new iB(t.label), this.errorMessage = new Ql(t.errorMessage), this.allowRevealOnHoverStyle = t.allowRevealOnHoverStyle || this.allowRevealOnHoverStyle, this.allowDynamicallyFilteredChoiceSet = t.allowDynamicallyFilteredChoiceSet || this.allowDynamicallyFilteredChoiceSet, this.debounceTimeInMilliSeconds = t.debounceTimeInMilliSeconds || this.debounceTimeInMilliSeconds);
    }
    return e;
  }()
);
ar.InputConfig = oB;
var FS = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.wrap = !0, r;
    }
    return t.prototype.parse = function(r) {
      e.prototype.parse.call(this, r), r && (this.wrap = r.wrap != null ? r.wrap : this.wrap);
    }, t.prototype.toJSON = function() {
      var r = e.prototype.toJSON.call(this);
      return r.wrap = this.wrap, r;
    }, t;
  }(Ql)
);
ar.FactTextDefinition = FS;
var aB = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.maxWidth = 150, n.weight = Ht.TextWeight.Bolder, r && (n.maxWidth = r.maxWidth != null ? r.maxWidth : n.maxWidth, n.weight = Nu(Ht.TextWeight, r.weight, Ht.TextWeight.Bolder)), n;
    }
    return t.prototype.getDefaultWeight = function() {
      return Ht.TextWeight.Bolder;
    }, t;
  }(FS)
);
ar.FactTitleDefinition = aB;
var uB = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.title = new aB(), this.value = new FS(), this.spacing = 10, t && (this.title = new aB(t.title), this.value = new FS(t.value), this.spacing = t.spacing && t.spacing != null ? t.spacing && t.spacing : this.spacing);
    }
    return e;
  }()
);
ar.FactSetConfig = uB;
var sB = (
  /** @class */
  function() {
    function e(t) {
      this.actionMode = Ht.ShowCardActionMode.Inline, this.inlineTopMargin = 16, this.style = Ht.ContainerStyle.Emphasis, t && (this.actionMode = Nu(Ht.ShowCardActionMode, t.actionMode, Ht.ShowCardActionMode.Inline), this.inlineTopMargin = t.inlineTopMargin != null ? t.inlineTopMargin : this.inlineTopMargin, this.style = t.style && typeof t.style == "string" ? t.style : Ht.ContainerStyle.Emphasis);
    }
    return e.prototype.toJSON = function() {
      return {
        actionMode: Ht.ShowCardActionMode[this.actionMode],
        inlineTopMargin: this.inlineTopMargin,
        style: this.style
      };
    }, e;
  }()
);
ar.ShowCardActionConfig = sB;
var cB = (
  /** @class */
  function() {
    function e(t) {
      if (this.maxActions = 5, this.spacing = Ht.Spacing.Default, this.buttonSpacing = 20, this.showCard = new sB(), this.preExpandSingleShowCardAction = !1, this.actionsOrientation = Ht.Orientation.Horizontal, this.actionAlignment = Ht.ActionAlignment.Left, this.iconPlacement = Ht.ActionIconPlacement.LeftOfTitle, this.allowTitleToWrap = !1, this.iconSize = 16, t) {
        this.maxActions = t.maxActions != null ? t.maxActions : this.maxActions, this.spacing = Nu(Ht.Spacing, t.spacing && t.spacing, Ht.Spacing.Default), this.buttonSpacing = t.buttonSpacing != null ? t.buttonSpacing : this.buttonSpacing, this.showCard = new sB(t.showCard), this.preExpandSingleShowCardAction = E3.parseBool(t.preExpandSingleShowCardAction, !1), this.actionsOrientation = Nu(Ht.Orientation, t.actionsOrientation, Ht.Orientation.Horizontal), this.actionAlignment = Nu(Ht.ActionAlignment, t.actionAlignment, Ht.ActionAlignment.Left), this.iconPlacement = Nu(Ht.ActionIconPlacement, t.iconPlacement, Ht.ActionIconPlacement.LeftOfTitle), this.allowTitleToWrap = t.allowTitleToWrap != null ? t.allowTitleToWrap : this.allowTitleToWrap;
        try {
          var r = B1e.SizeAndUnit.parse(t.iconSize);
          r.unit === Ht.SizeUnit.Pixel && (this.iconSize = r.physicalSize);
        } catch {
        }
      }
    }
    return e.prototype.toJSON = function() {
      return {
        maxActions: this.maxActions,
        spacing: Ht.Spacing[this.spacing],
        buttonSpacing: this.buttonSpacing,
        showCard: this.showCard,
        preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
        actionsOrientation: Ht.Orientation[this.actionsOrientation],
        actionAlignment: Ht.ActionAlignment[this.actionAlignment]
      };
    }, e;
  }()
);
ar.ActionsConfig = cB;
var F1e = (
  /** @class */
  function() {
    function e(t) {
      this.default = new kl(), this.dark = new kl(), this.light = new kl(), this.accent = new kl(), this.good = new kl(), this.warning = new kl(), this.attention = new kl(), this.parse(t);
    }
    return e.prototype.parseSingleColor = function(t, r) {
      t && this[r].parse(t[r]);
    }, e.prototype.parse = function(t) {
      t && (this.parseSingleColor(t, "default"), this.parseSingleColor(t, "dark"), this.parseSingleColor(t, "light"), this.parseSingleColor(t, "accent"), this.parseSingleColor(t, "good"), this.parseSingleColor(t, "warning"), this.parseSingleColor(t, "attention"));
    }, e;
  }()
);
ar.ColorSetDefinition = F1e;
var l7 = (
  /** @class */
  function() {
    function e(t) {
      this.foregroundColors = new F1e({
        default: { default: "#333333", subtle: "#EE333333" },
        dark: { default: "#000000", subtle: "#66000000" },
        light: { default: "#FFFFFF", subtle: "#33000000" },
        accent: { default: "#2E89FC", subtle: "#882E89FC" },
        good: { default: "#028A02", subtle: "#DD027502" },
        warning: { default: "#E69500", subtle: "#DDE69500" },
        attention: { default: "#CC3300", subtle: "#DDCC3300" }
      }), this.parse(t);
    }
    return e.prototype.parse = function(t) {
      t && (this.backgroundColor = t.backgroundColor, this.foregroundColors.parse(t.foregroundColors), this.highlightBackgroundColor = t.highlightBackgroundColor, this.highlightForegroundColor = t.highlightForegroundColor, this.borderColor = t.borderColor);
    }, Object.defineProperty(e.prototype, "isBuiltIn", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
ar.ContainerStyleDefinition = l7;
var zd = (
  /** @class */
  function(e) {
    Yh(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(t.prototype, "isBuiltIn", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(l7)
), lB = (
  /** @class */
  function() {
    function e(t) {
      if (this._allStyles = {}, this._allStyles[Ht.ContainerStyle.Default] = new zd(), this._allStyles[Ht.ContainerStyle.Emphasis] = new zd(), this._allStyles[Ht.ContainerStyle.Accent] = new zd(), this._allStyles[Ht.ContainerStyle.Good] = new zd(), this._allStyles[Ht.ContainerStyle.Attention] = new zd(), this._allStyles[Ht.ContainerStyle.Warning] = new zd(), t) {
        this._allStyles[Ht.ContainerStyle.Default].parse(t[Ht.ContainerStyle.Default]), this._allStyles[Ht.ContainerStyle.Emphasis].parse(t[Ht.ContainerStyle.Emphasis]), this._allStyles[Ht.ContainerStyle.Accent].parse(t[Ht.ContainerStyle.Accent]), this._allStyles[Ht.ContainerStyle.Good].parse(t[Ht.ContainerStyle.Good]), this._allStyles[Ht.ContainerStyle.Attention].parse(t[Ht.ContainerStyle.Attention]), this._allStyles[Ht.ContainerStyle.Warning].parse(t[Ht.ContainerStyle.Warning]);
        var r = t.customStyles;
        if (r && Array.isArray(r))
          for (var n = 0, i = r; n < i.length; n++) {
            var o = i[n];
            if (o) {
              var a = o.name;
              a && typeof a == "string" && (this._allStyles.hasOwnProperty(a) ? this._allStyles[a].parse(o.style) : this._allStyles[a] = new l7(o.style));
            }
          }
      }
    }
    return e.prototype.toJSON = function() {
      var t = this, r = [];
      Object.keys(this._allStyles).forEach(function(i) {
        t._allStyles[i].isBuiltIn || r.push({
          name: i,
          style: t._allStyles[i]
        });
      });
      var n = {
        default: this.default,
        emphasis: this.emphasis
      };
      return r.length > 0 && (n.customStyles = r), n;
    }, e.prototype.getStyleByName = function(t, r) {
      return t && this._allStyles.hasOwnProperty(t) ? this._allStyles[t] : r || this._allStyles[Ht.ContainerStyle.Default];
    }, Object.defineProperty(e.prototype, "default", {
      get: function() {
        return this._allStyles[Ht.ContainerStyle.Default];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "emphasis", {
      get: function() {
        return this._allStyles[Ht.ContainerStyle.Emphasis];
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
ar.ContainerStyleSet = lB;
var J1 = (
  /** @class */
  function() {
    function e(t) {
      this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif", this.fontSizes = {
        small: 12,
        default: 14,
        medium: 17,
        large: 21,
        extraLarge: 26
      }, this.fontWeights = {
        lighter: 200,
        default: 400,
        bolder: 600
      }, t && (this.fontFamily = t);
    }
    return e.prototype.parse = function(t) {
      this.fontFamily = t.fontFamily || this.fontFamily, this.fontSizes = {
        small: t.fontSizes && t.fontSizes.small || this.fontSizes.small,
        default: t.fontSizes && t.fontSizes.default || this.fontSizes.default,
        medium: t.fontSizes && t.fontSizes.medium || this.fontSizes.medium,
        large: t.fontSizes && t.fontSizes.large || this.fontSizes.large,
        extraLarge: t.fontSizes && t.fontSizes.extraLarge || this.fontSizes.extraLarge
      }, this.fontWeights = {
        lighter: t.fontWeights && t.fontWeights.lighter || this.fontWeights.lighter,
        default: t.fontWeights && t.fontWeights.default || this.fontWeights.default,
        bolder: t.fontWeights && t.fontWeights.bolder || this.fontWeights.bolder
      };
    }, e.monospace = new e("'Courier New', Courier, monospace"), e;
  }()
);
ar.FontTypeDefinition = J1;
var H1e = (
  /** @class */
  function() {
    function e(t) {
      this.default = new J1(), this.monospace = new J1("'Courier New', Courier, monospace"), t && (this.default.parse(t.default), this.monospace.parse(t.monospace));
    }
    return e.prototype.getStyleDefinition = function(t) {
      switch (t) {
        case Ht.FontType.Monospace:
          return this.monospace;
        case Ht.FontType.Default:
        default:
          return this.default;
      }
    }, e;
  }()
);
ar.FontTypeSet = H1e;
var fB = (
  /** @class */
  function() {
    function e(t) {
      this.maxCarouselPages = 10, this.minAutoplayDelay = 5e3, t && (this.maxCarouselPages = t.maxCarouselPages != null ? t.maxCarouselPages : this.maxCarouselPages, this.minAutoplayDelay = t.minAutoplayDelay != null ? t.minAutoplayDelay : this.minAutoplayDelay);
    }
    return e.prototype.toJSON = function() {
      return {
        maxCarouselPages: this.maxCarouselPages,
        minAutoplayDelay: this.minAutoplayDelay
      };
    }, e;
  }()
);
ar.CarouselConfig = fB;
var $1e = (
  /** @class */
  function() {
    function e(t) {
      this.hostCapabilities = new Prr.HostCapabilities(), this.choiceSetInputValueSeparator = ",", this.supportsInteractivity = !0, this.spacing = {
        small: 3,
        default: 8,
        medium: 20,
        large: 30,
        extraLarge: 40,
        padding: 15
      }, this.separator = {
        lineThickness: 1,
        lineColor: "#EEEEEE"
      }, this.imageSizes = {
        small: 40,
        medium: 80,
        large: 160
      }, this.containerStyles = new lB(), this.inputs = new oB(), this.actions = new cB(), this.adaptiveCard = new QL(), this.imageSet = new eB(), this.media = new k1e(), this.factSet = new uB(), this.table = new M1e(), this.textStyles = new tB(), this.textBlock = new rB(), this.carousel = new fB(), this.alwaysAllowBleed = !1, t && ((typeof t == "string" || t instanceof String) && (t = JSON.parse(t)), this.choiceSetInputValueSeparator = t && typeof t.choiceSetInputValueSeparator == "string" ? t.choiceSetInputValueSeparator : this.choiceSetInputValueSeparator, this.supportsInteractivity = t && typeof t.supportsInteractivity == "boolean" ? t.supportsInteractivity : this.supportsInteractivity, this._legacyFontType = new J1(), this._legacyFontType.parse(t), t.fontTypes && (this.fontTypes = new H1e(t.fontTypes)), t.lineHeights && (this.lineHeights = {
        small: t.lineHeights.small,
        default: t.lineHeights.default,
        medium: t.lineHeights.medium,
        large: t.lineHeights.large,
        extraLarge: t.lineHeights.extraLarge
      }), this.imageSizes = {
        small: t.imageSizes && t.imageSizes.small || this.imageSizes.small,
        medium: t.imageSizes && t.imageSizes.medium || this.imageSizes.medium,
        large: t.imageSizes && t.imageSizes.large || this.imageSizes.large
      }, this.containerStyles = new lB(t.containerStyles), this.spacing = {
        small: t.spacing && t.spacing.small || this.spacing.small,
        default: t.spacing && t.spacing.default || this.spacing.default,
        medium: t.spacing && t.spacing.medium || this.spacing.medium,
        large: t.spacing && t.spacing.large || this.spacing.large,
        extraLarge: t.spacing && t.spacing.extraLarge || this.spacing.extraLarge,
        padding: t.spacing && t.spacing.padding || this.spacing.padding
      }, this.separator = {
        lineThickness: t.separator && t.separator.lineThickness || this.separator.lineThickness,
        lineColor: t.separator && t.separator.lineColor || this.separator.lineColor
      }, this.inputs = new oB(t.inputs || this.inputs), this.actions = new cB(t.actions || this.actions), this.adaptiveCard = new QL(t.adaptiveCard || this.adaptiveCard), this.imageSet = new eB(t.imageSet), this.factSet = new uB(t.factSet), this.textStyles = new tB(t.textStyles), this.textBlock = new rB(t.textBlock), this.carousel = new fB(t.carousel));
    }
    return e.prototype.getFontTypeDefinition = function(t) {
      return this.fontTypes ? this.fontTypes.getStyleDefinition(t) : t === Ht.FontType.Monospace ? J1.monospace : this._legacyFontType;
    }, e.prototype.getEffectiveSpacing = function(t) {
      switch (t) {
        case Ht.Spacing.Small:
          return this.spacing.small;
        case Ht.Spacing.Default:
          return this.spacing.default;
        case Ht.Spacing.Medium:
          return this.spacing.medium;
        case Ht.Spacing.Large:
          return this.spacing.large;
        case Ht.Spacing.ExtraLarge:
          return this.spacing.extraLarge;
        case Ht.Spacing.Padding:
          return this.spacing.padding;
        default:
          return 0;
      }
    }, e.prototype.paddingDefinitionToSpacingDefinition = function(t) {
      return new B1e.SpacingDefinition(this.getEffectiveSpacing(t.top), this.getEffectiveSpacing(t.right), this.getEffectiveSpacing(t.bottom), this.getEffectiveSpacing(t.left));
    }, e.prototype.makeCssClassNames = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      for (var n = [], i = 0, o = t; i < o.length; i++) {
        var a = o[i];
        n.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + a);
      }
      return n;
    }, e.prototype.makeCssClassName = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      var n = this.makeCssClassNames.apply(this, t).join(" ");
      return n || "";
    }, Object.defineProperty(e.prototype, "fontFamily", {
      get: function() {
        return this._legacyFontType.fontFamily;
      },
      set: function(t) {
        this._legacyFontType.fontFamily = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "fontSizes", {
      get: function() {
        return this._legacyFontType.fontSizes;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "fontWeights", {
      get: function() {
        return this._legacyFontType.fontWeights;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
ar.HostConfig = $1e;
ar.defaultHostConfig = new $1e({
  supportsInteractivity: !0,
  spacing: {
    small: 10,
    default: 20,
    medium: 30,
    large: 40,
    extraLarge: 50,
    padding: 20
  },
  separator: {
    lineThickness: 1,
    lineColor: "#EEEEEE"
  },
  fontTypes: {
    default: {
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      fontSizes: {
        small: 12,
        default: 14,
        medium: 17,
        large: 21,
        extraLarge: 26
      },
      fontWeights: {
        lighter: 200,
        default: 400,
        bolder: 600
      }
    },
    monospace: {
      fontFamily: "'Courier New', Courier, monospace",
      fontSizes: {
        small: 12,
        default: 14,
        medium: 17,
        large: 21,
        extraLarge: 26
      },
      fontWeights: {
        lighter: 200,
        default: 400,
        bolder: 600
      }
    }
  },
  imageSizes: {
    small: 40,
    medium: 80,
    large: 160
  },
  containerStyles: {
    default: {
      backgroundColor: "#FFFFFF",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    emphasis: {
      backgroundColor: "#08000000",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    accent: {
      backgroundColor: "#C7DEF9",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    good: {
      backgroundColor: "#CCFFCC",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    attention: {
      backgroundColor: "#FFC5B2",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    warning: {
      backgroundColor: "#FFE2B2",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    }
  },
  inputs: {
    label: {
      requiredInputs: {
        weight: Ht.TextWeight.Bolder,
        suffix: " *",
        suffixColor: Ht.TextColor.Attention
      },
      optionalInputs: {
        weight: Ht.TextWeight.Bolder
      }
    },
    errorMessage: {
      color: Ht.TextColor.Attention,
      weight: Ht.TextWeight.Bolder
    },
    debounceTimeInMilliSeconds: 250
  },
  actions: {
    maxActions: 5,
    spacing: Ht.Spacing.Default,
    buttonSpacing: 10,
    showCard: {
      actionMode: Ht.ShowCardActionMode.Inline,
      inlineTopMargin: 16
    },
    actionsOrientation: Ht.Orientation.Horizontal,
    actionAlignment: Ht.ActionAlignment.Left
  },
  adaptiveCard: {
    allowCustomStyle: !1
  },
  imageSet: {
    imageSize: Ht.Size.Medium,
    maxImageHeight: 100
  },
  factSet: {
    title: {
      color: Ht.TextColor.Default,
      size: Ht.TextSize.Default,
      isSubtle: !1,
      weight: Ht.TextWeight.Bolder,
      wrap: !0,
      maxWidth: 150
    },
    value: {
      color: Ht.TextColor.Default,
      size: Ht.TextSize.Default,
      isSubtle: !1,
      weight: Ht.TextWeight.Default,
      wrap: !0
    },
    spacing: 10
  },
  carousel: {
    maxCarouselPages: 10,
    minAutoplayDuration: 5e3
  },
  textBlock: {
    headingLevel: 2
  }
});
var Kc = {};
Object.defineProperty(Kc, "__esModule", { value: !0 });
Kc.GlobalRegistry = Kc.CardObjectRegistry = void 0;
var Drr = Dr, t1 = (
  /** @class */
  function() {
    function e() {
      this._items = {};
    }
    return e.prototype.findByName = function(t) {
      return this._items.hasOwnProperty(t) ? this._items[t] : void 0;
    }, e.prototype.clear = function() {
      this._items = {};
    }, e.prototype.copyTo = function(t) {
      for (var r = Object.keys(this._items), n = 0, i = r; n < i.length; n++) {
        var o = i[n], a = this._items[o];
        t.register(a.typeName, a.objectType, a.schemaVersion);
      }
    }, e.prototype.register = function(t, r, n) {
      n === void 0 && (n = Drr.Versions.v1_0);
      var i = this.findByName(t);
      i !== void 0 ? i.objectType = r : i = {
        typeName: t,
        objectType: r,
        schemaVersion: n
      }, this._items[t] = i;
    }, e.prototype.unregister = function(t) {
      delete this._items[t];
    }, e.prototype.createInstance = function(t, r) {
      var n = this.findByName(t);
      return n && n.schemaVersion.compareTo(r) <= 0 ? new n.objectType() : void 0;
    }, e.prototype.getItemCount = function() {
      return Object.keys(this._items).length;
    }, e.prototype.getItemAt = function(t) {
      var r = this;
      return Object.keys(this._items).map(function(n) {
        return r._items[n];
      })[t];
    }, e;
  }()
);
Kc.CardObjectRegistry = t1;
var xrr = (
  /** @class */
  function() {
    function e() {
    }
    return e.populateWithDefaultElements = function(t) {
      t.clear(), e.defaultElements.copyTo(t);
    }, e.populateWithDefaultActions = function(t) {
      t.clear(), e.defaultActions.copyTo(t);
    }, Object.defineProperty(e, "elements", {
      get: function() {
        return e._elements || (e._elements = new t1(), e.populateWithDefaultElements(e._elements)), e._elements;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e, "actions", {
      get: function() {
        return e._actions || (e._actions = new t1(), e.populateWithDefaultActions(e._actions)), e._actions;
      },
      enumerable: !1,
      configurable: !0
    }), e.reset = function() {
      e._elements = void 0, e._actions = void 0;
    }, e.defaultElements = new t1(), e.defaultActions = new t1(), e;
  }()
);
Kc.GlobalRegistry = xrr;
var xf = {}, Nrr = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), lee = fe && fe.__decorate || function(e, t, r, n) {
  var i = arguments.length, o = i < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, r, n);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, r, o) : a(t, r)) || o);
  return i > 3 && o && Object.defineProperty(t, r, o), o;
};
Object.defineProperty(xf, "__esModule", { value: !0 });
xf.CardObject = xf.ValidationResults = void 0;
var U1e = Uu, Lrr = lc, Brr = fc, fee = qh, Rc = Dr, V1e = (
  /** @class */
  function() {
    function e() {
      this.allIds = {}, this.validationEvents = [];
    }
    return e.prototype.addFailure = function(t, r, n) {
      this.validationEvents.push({
        phase: U1e.ValidationPhase.Validation,
        source: t,
        event: r,
        message: n
      });
    }, e;
  }()
);
xf.ValidationResults = V1e;
var krr = (
  /** @class */
  function(e) {
    Nrr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._shouldFallback = !1, r;
    }
    return t.prototype.getSchemaKey = function() {
      return this.getJsonTypeName();
    }, Object.defineProperty(t.prototype, "requires", {
      get: function() {
        return this.getValue(t.requiresProperty);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.contains = function(r) {
      return this._renderedElement ? this._renderedElement.contains(r) : !1;
    }, t.prototype.preProcessPropertyValue = function(r, n) {
      var i = n === void 0 ? this.getValue(r) : n;
      if (Brr.GlobalSettings.allowPreProcessingPropertyValues) {
        for (var o = this; o && !o.onPreProcessPropertyValue; )
          o = o.parent;
        if (o && o.onPreProcessPropertyValue)
          return o.onPreProcessPropertyValue(this, r, i);
      }
      return i;
    }, t.prototype.setParent = function(r) {
      this._parent = r;
    }, t.prototype.setShouldFallback = function(r) {
      this._shouldFallback = r;
    }, t.prototype.shouldFallback = function() {
      return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    }, t.prototype.getRootObject = function() {
      for (var r = this; r.parent; )
        r = r.parent;
      return r;
    }, t.prototype.internalValidateProperties = function(r) {
      this.id && (r.allIds.hasOwnProperty(this.id) ? (r.allIds[this.id] === 1 && r.addFailure(this, U1e.ValidationEvent.DuplicateId, Lrr.Strings.errors.duplicateId(this.id)), r.allIds[this.id] += 1) : r.allIds[this.id] = 1);
    }, t.prototype.validateProperties = function() {
      var r = new V1e();
      return this.internalValidateProperties(r), r;
    }, t.prototype.findDOMNodeOwner = function(r) {
      return this.contains(r) ? this : void 0;
    }, t.prototype.releaseDOMResources = function() {
    }, Object.defineProperty(t.prototype, "parent", {
      get: function() {
        return this._parent;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "renderedElement", {
      get: function() {
        return this._renderedElement;
      },
      enumerable: !1,
      configurable: !0
    }), t.typeNameProperty = new Rc.StringProperty(Rc.Versions.v1_0, "type", void 0, void 0, void 0, function(r) {
      return r.getJsonTypeName();
    }), t.idProperty = new Rc.StringProperty(Rc.Versions.v1_0, "id"), t.requiresProperty = new Rc.SerializableObjectProperty(Rc.Versions.v1_2, "requires", fee.HostCapabilities, !1, new fee.HostCapabilities()), lee([
      (0, Rc.property)(t.idProperty)
    ], t.prototype, "id", void 0), lee([
      (0, Rc.property)(t.requiresProperty)
    ], t.prototype, "requires", null), t;
  }(Rc.SerializableObject)
);
xf.CardObject = krr;
var Ct = {}, m3 = {}, j1e = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(m3, "__esModule", { value: !0 });
m3.formatText = void 0;
var z1e = (
  /** @class */
  function() {
    function e(t) {
      this._regularExpression = t;
    }
    return e.prototype.format = function(t, r) {
      var n;
      if (r) {
        for (var i = r; (n = this._regularExpression.exec(r)) != null; )
          i = i.replace(n[0], this.internalFormat(t, n));
        return i;
      } else
        return r;
    }, e;
  }()
), Mrr = (
  /** @class */
  function(e) {
    j1e(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.internalFormat = function(r, n) {
      var i = new Date(Date.parse(n[1])), o = n[2] !== void 0 ? n[2].toLowerCase() : "compact";
      return o !== "compact" ? i.toLocaleDateString(r, {
        day: "numeric",
        weekday: o,
        month: o,
        year: "numeric"
      }) : i.toLocaleDateString();
    }, t;
  }(z1e)
), Frr = (
  /** @class */
  function(e) {
    j1e(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.internalFormat = function(r, n) {
      var i = new Date(Date.parse(n[1]));
      return i.toLocaleTimeString(r, { hour: "numeric", minute: "2-digit" });
    }, t;
  }(z1e)
);
function Hrr(e, t) {
  for (var r = [
    new Mrr(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
    new Frr(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
  ], n = t, i = 0, o = r; i < o.length; i++) {
    var a = o[i];
    n = a.format(e, n);
  }
  return n;
}
m3.formatText = Hrr;
var q1e = {}, g3 = {}, Gh = {};
Object.defineProperty(Gh, "__esModule", { value: !0 });
Gh.Constants = void 0;
var $rr = (
  /** @class */
  function() {
    function e() {
    }
    return e.keys = {
      tab: "Tab",
      enter: "Enter",
      escape: "Escape",
      space: " ",
      up: "ArrowUp",
      down: "ArrowDown",
      delete: "Delete"
    }, e;
  }()
);
Gh.Constants = $rr;
Object.defineProperty(g3, "__esModule", { value: !0 });
g3.MenuItem = void 0;
var Urr = ar, Vrr = Gh, jrr = (
  /** @class */
  function() {
    function e(t, r) {
      this._isEnabled = !0, this.key = t, this._value = r;
    }
    return e.prototype.click = function() {
      this.isEnabled && this.onClick && this.onClick(this);
    }, e.prototype.updateCssClasses = function() {
      if (this._element) {
        var t = this._hostConfig ? this._hostConfig : Urr.defaultHostConfig;
        this._element.className = t.makeCssClassName("ac-ctrl"), this._element.classList.add(t.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled")), this.isEnabled || this._element.classList.add(t.makeCssClassName("ac-disabled"));
      }
    }, e.prototype.toString = function() {
      return this.value;
    }, e.prototype.render = function(t) {
      var r = this;
      return this._hostConfig = t, this._element || (this._element = document.createElement("span"), this._element.innerText = this.value, this._element.setAttribute("role", "menuitem"), this.isEnabled || this._element.setAttribute("aria-disabled", "true"), this._element.setAttribute("aria-current", "false"), this._element.onmouseup = function(n) {
        r.click();
      }, this._element.onkeydown = function(n) {
        n.key === Vrr.Constants.keys.enter && (n.stopPropagation(), n.preventDefault(), r.click());
      }, this.updateCssClasses()), this._element;
    }, Object.defineProperty(e.prototype, "value", {
      get: function() {
        return this._value;
      },
      set: function(t) {
        this._value = t, this._element && (this._element.innerText = t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isEnabled", {
      get: function() {
        return this._isEnabled;
      },
      set: function(t) {
        this._isEnabled !== t && (this._isEnabled = t, this.updateCssClasses());
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
g3.MenuItem = jrr;
var T3 = {}, y3 = {};
Object.defineProperty(y3, "__esModule", { value: !0 });
y3.Collection = void 0;
var zrr = (
  /** @class */
  function() {
    function e() {
      this._items = [];
    }
    return e.prototype.get = function(t) {
      return this._items[t];
    }, e.prototype.add = function(t) {
      this._items.push(t), this.onItemAdded && this.onItemAdded(t);
    }, e.prototype.remove = function(t) {
      var r = this._items.indexOf(t);
      r >= 0 && (this._items = this._items.splice(r, 1), this.onItemRemoved && this.onItemRemoved(t));
    }, e.prototype.indexOf = function(t) {
      return this._items.indexOf(t);
    }, Object.defineProperty(e.prototype, "length", {
      get: function() {
        return this._items.length;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
y3.Collection = zrr;
var _3 = {};
Object.defineProperty(_3, "__esModule", { value: !0 });
_3.PopupControl = void 0;
var qrr = Gh, Ms = Pr, Yrr = ar, Grr = (
  /** @class */
  function() {
    function e() {
      this._isOpen = !1;
    }
    return e.prototype.keyDown = function(t) {
      switch (t.key) {
        case qrr.Constants.keys.escape:
          this.closePopup(!0);
          break;
      }
    }, e.prototype.render = function(t) {
      var r = this, n = document.createElement("div");
      return n.tabIndex = 0, n.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container"), n.setAttribute("role", "dialog"), n.setAttribute("aria-modal", "true"), n.onkeydown = function(i) {
        return r.keyDown(i), !i.cancelBubble;
      }, n.appendChild(this.renderContent()), n;
    }, e.prototype.focus = function() {
      this._popupElement && this._popupElement.firstElementChild.focus();
    }, e.prototype.popup = function(t) {
      var r, n, i, o, a, u = this;
      if (!this._isOpen) {
        this._overlayElement = document.createElement("div"), this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay"), this._overlayElement.tabIndex = 0, this._overlayElement.style.width = document.documentElement.scrollWidth + "px", this._overlayElement.style.height = document.documentElement.scrollHeight + "px", this._overlayElement.onfocus = function(y) {
          u.closePopup(!0);
        }, document.body.appendChild(this._overlayElement);
        var s = t.getBoundingClientRect();
        this._popupElement = this.render(s), (r = this._popupElement.classList).remove.apply(r, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft")), window.addEventListener("resize", function(y) {
          u.closePopup(!0);
        });
        var c = t.getAttribute("aria-label");
        c && this._popupElement.setAttribute("aria-label", c), this._overlayElement.appendChild(this._popupElement);
        var l = this._popupElement.getBoundingClientRect(), f = window.innerHeight - s.bottom, d = s.top, p = window.innerWidth - s.right, v = s.left, h = s.left + Ms.getScrollX(), E;
        if (d < l.height && f < l.height) {
          var m = Math.min(l.height, window.innerHeight);
          if (this._popupElement.style.maxHeight = m + "px", m < l.height ? E = Ms.getScrollY() : E = Ms.getScrollY() + s.top + (s.height - m) / 2, v < l.width && p < l.width) {
            var g = Math.min(l.width, window.innerWidth);
            this._popupElement.style.maxWidth = g + "px", g < l.width ? h = Ms.getScrollX() : h = Ms.getScrollX() + s.left + (s.width - g) / 2;
          } else
            p >= l.width ? (h = Ms.getScrollX() + s.right, (n = this._popupElement.classList).add.apply(n, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"))) : (h = Ms.getScrollX() + s.left - l.width, (i = this._popupElement.classList).add.apply(i, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft")));
        } else
          f >= l.height ? (E = Ms.getScrollY() + s.bottom, (o = this._popupElement.classList).add.apply(o, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"))) : (E = Ms.getScrollY() + s.top - l.height, (a = this._popupElement.classList).add.apply(a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"))), p < l.width && (h = Ms.getScrollX() + s.right - l.width);
        this._popupElement.style.left = h + "px", this._popupElement.style.top = E + "px", this._popupElement.focus(), this._isOpen = !0;
      }
    }, e.prototype.closePopup = function(t) {
      this._isOpen && (document.body.removeChild(this._overlayElement), this._isOpen = !1, this.onClose && this.onClose(this, t));
    }, Object.defineProperty(e.prototype, "hostConfig", {
      get: function() {
        return this._hostConfig ? this._hostConfig : Yrr.defaultHostConfig;
      },
      set: function(t) {
        this._hostConfig = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isOpen", {
      get: function() {
        return this._isOpen;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
_3.PopupControl = Grr;
var Wrr = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(T3, "__esModule", { value: !0 });
T3.PopupMenu = void 0;
var qD = Gh, Krr = y3, Xrr = _3, Jrr = (
  /** @class */
  function(e) {
    Wrr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._items = new Krr.Collection(), r._renderedItems = [], r._selectedIndex = -1, r;
    }
    return t.prototype.renderContent = function() {
      var r = document.createElement("div");
      r.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup"), r.setAttribute("role", "listbox");
      for (var n = 0; n < this._items.length; n++) {
        var i = this._items.get(n).render(this.hostConfig);
        i.tabIndex = 0, r.appendChild(i), n == 0 && i.setAttribute("aria-expanded", "true"), n === this.selectedIndex && i.focus(), this._renderedItems.push(i);
      }
      return r;
    }, t.prototype.keyDown = function(r) {
      e.prototype.keyDown.call(this, r);
      var n = this._selectedIndex;
      switch (r.key) {
        case qD.Constants.keys.tab:
          this.closePopup(!0);
          break;
        case qD.Constants.keys.up:
          n <= 0 ? n = this._renderedItems.length - 1 : (n--, n < 0 && (n = this._renderedItems.length - 1)), this.selectedIndex = n, this.removeAriaExpanded(n), r.cancelBubble = !0;
          break;
        case qD.Constants.keys.down:
          n < 0 ? n = 0 : (n++, n >= this._renderedItems.length && (n = 0), this.removeAriaExpanded(n)), this.selectedIndex = n, r.cancelBubble = !0;
          break;
      }
    }, Object.defineProperty(t.prototype, "items", {
      get: function() {
        return this._items;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "selectedIndex", {
      get: function() {
        return this._selectedIndex;
      },
      set: function(r) {
        r >= 0 && r < this._renderedItems.length && (this._renderedItems[r].focus(), this._selectedIndex = r);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.removeAriaExpanded = function(r) {
      this._renderedItems[r].getAttribute("aria-expanded") === "true" && this._renderedItems[r].removeAttribute("aria-expanded");
    }, t;
  }(Xrr.PopupControl)
);
T3.PopupMenu = Jrr;
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(n, i, o, a) {
    a === void 0 && (a = o);
    var u = Object.getOwnPropertyDescriptor(i, o);
    (!u || ("get" in u ? !i.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, a, u);
  } : function(n, i, o, a) {
    a === void 0 && (a = o), n[a] = i[o];
  }), r = fe && fe.__exportStar || function(n, i) {
    for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(g3, e), r(T3, e);
})(q1e);
var tr = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bt = fe && fe.__decorate || function(e, t, r, n) {
  var i = arguments.length, o = i < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, r, n);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, r, o) : a(t, r)) || o);
  return i > 3 && o && Object.defineProperty(t, r, o), o;
}, Sy = fe && fe.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, by = fe && fe.__generator || function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(c) {
    return function(l) {
      return s([c, l]);
    };
  }
  function s(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, dee = fe && fe.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(Ct, "__esModule", { value: !0 });
Ct.BackgroundImage = Ct.ContainerBase = Ct.StylableCardElementContainer = Ct.ContainerStyleProperty = Ct.ActionSet = Ct.ShowCardAction = Ct.HttpAction = Ct.HttpHeader = Ct.ToggleVisibilityAction = Ct.OpenUrlAction = Ct.DataQuery = Ct.ExecuteAction = Ct.UniversalAction = Ct.SubmitAction = Ct.SubmitActionBase = Ct.Action = Ct.TimeInput = Ct.TimeProperty = Ct.DateInput = Ct.NumberInput = Ct.FilteredChoiceSet = Ct.ChoiceSetInput = Ct.ChoiceSetInputDataQuery = Ct.Choice = Ct.ToggleInput = Ct.TextInput = Ct.Input = Ct.Media = Ct.YouTubePlayer = Ct.DailymotionPlayer = Ct.VimeoPlayer = Ct.IFrameMediaMediaPlayer = Ct.CustomMediaPlayer = Ct.HTML5MediaPlayer = Ct.MediaPlayer = Ct.MediaSource = Ct.CaptionSource = Ct.ContentSource = Ct.ImageSet = Ct.CardElementContainer = Ct.Image = Ct.FactSet = Ct.Fact = Ct.RichTextBlock = Ct.TextRun = Ct.TextBlock = Ct.BaseTextBlock = Ct.ActionProperty = Ct.CardElement = Ct.renderSeparation = void 0;
Ct.SerializationContext = Ct.AdaptiveCard = Ct.Authentication = Ct.TokenExchangeResource = Ct.AuthCardButton = Ct.RefreshDefinition = Ct.RefreshActionProperty = Ct.ContainerWithActions = Ct.ColumnSet = Ct.Column = Ct.Container = void 0;
var Ke = Uu, Ir = fc, lr = Pr, A3 = ar, Y1e = m3, G1e = xf, pe = Dr, mi = Kc, fr = lc, pee = q1e;
function HS(e) {
  var t, r, n = typeof window > "u" ? "" : (r = (t = window.trustedTypes) === null || t === void 0 ? void 0 : t.emptyHTML) !== null && r !== void 0 ? r : "";
  e.innerHTML = n;
}
function f7(e, t, r) {
  if (t.spacing > 0 || t.lineThickness && t.lineThickness > 0) {
    var n = document.createElement("div");
    n.className = e.makeCssClassName("ac-" + (r === Ke.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator"), n.setAttribute("aria-hidden", "true");
    var i = t.lineColor ? lr.stringToCssColor(t.lineColor) : "";
    return r === Ke.Orientation.Horizontal ? t.lineThickness ? (n.style.paddingTop = t.spacing / 2 + "px", n.style.marginBottom = t.spacing / 2 + "px", n.style.borderBottom = t.lineThickness + "px solid " + i) : n.style.height = t.spacing + "px" : t.lineThickness ? (n.style.paddingLeft = t.spacing / 2 + "px", n.style.marginRight = t.spacing / 2 + "px", n.style.borderRight = t.lineThickness + "px solid " + i) : n.style.width = t.spacing + "px", n.style.overflow = "hidden", n.style.flex = "0 0 auto", n;
  } else
    return;
}
Ct.renderSeparation = f7;
var na = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._truncatedDueToOverflow = !1, r;
    }
    return Object.defineProperty(t.prototype, "lang", {
      get: function() {
        var r = this.getValue(t.langProperty);
        return r || (this.parent ? this.parent.lang : void 0);
      },
      set: function(r) {
        this.setValue(t.langProperty, r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isVisible", {
      get: function() {
        return this.getValue(t.isVisibleProperty);
      },
      set: function(r) {
        Ir.GlobalSettings.useAdvancedCardBottomTruncation && !r && this.undoOverflowTruncation(), this.isVisible !== r && (this.setValue(t.isVisibleProperty, r), this.updateRenderedElementVisibility(), this._renderedElement && YD(this)), this._renderedElement && this._renderedElement.setAttribute("aria-expanded", r.toString());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.internalRenderSeparator = function() {
      var r = f7(this.hostConfig, {
        spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
        lineThickness: this.separator ? this.hostConfig.separator.lineThickness : void 0,
        lineColor: this.separator ? this.hostConfig.separator.lineColor : void 0
      }, this.separatorOrientation);
      if (Ir.GlobalSettings.alwaysBleedSeparators && r && this.separatorOrientation === Ke.Orientation.Horizontal) {
        var n = this.getParentContainer();
        if (n && n.getEffectivePadding()) {
          var i = this.hostConfig.paddingDefinitionToSpacingDefinition(n.getEffectivePadding());
          r.style.marginLeft = "-" + i.left + "px", r.style.marginRight = "-" + i.right + "px";
        }
      }
      return r;
    }, t.prototype.updateRenderedElementVisibility = function() {
      var r = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
      this._renderedElement && (r ? this._renderedElement.style.display = r : this._renderedElement.style.removeProperty("display")), this._separatorElement && (this.parent && this.parent.isFirstElement(this) ? this._separatorElement.style.display = "none" : r ? this._separatorElement.style.display = r : this._separatorElement.style.removeProperty("display"));
    }, t.prototype.hideElementDueToOverflow = function() {
      this._renderedElement && this.isVisible && (this._renderedElement.style.visibility = "hidden", this.isVisible = !1, YD(this, !1));
    }, t.prototype.showElementHiddenDueToOverflow = function() {
      this._renderedElement && !this.isVisible && (this._renderedElement.style.removeProperty("visibility"), this.isVisible = !0, YD(this, !1));
    }, t.prototype.handleOverflow = function(r) {
      if (this.isVisible || this.isHiddenDueToOverflow()) {
        var n = this.truncateOverflow(r);
        this._truncatedDueToOverflow = n || this._truncatedDueToOverflow, n ? n && !this.isVisible && this.showElementHiddenDueToOverflow() : this.hideElementDueToOverflow();
      }
    }, t.prototype.resetOverflow = function() {
      var r = !1;
      return this._truncatedDueToOverflow && (this.undoOverflowTruncation(), this._truncatedDueToOverflow = !1, r = !0), this.isHiddenDueToOverflow() && this.showElementHiddenDueToOverflow(), r;
    }, t.prototype.getDefaultSerializationContext = function() {
      return new Kp();
    }, t.prototype.createPlaceholderElement = function() {
      var r = this.getEffectiveStyleDefinition(), n = lr.stringToCssColor(r.foregroundColors.default.subtle), i = document.createElement("div");
      return i.style.border = "1px dashed " + n, i.style.padding = "4px", i.style.minHeight = "32px", i.style.fontSize = "10px", n && (i.style.color = n), i.innerText = fr.Strings.defaults.emptyElementText(this.getJsonTypeName()), i;
    }, t.prototype.adjustRenderedElementSize = function(r) {
      this.height === "auto" ? r.style.flex = "0 0 auto" : r.style.flex = "1 1 auto";
    }, t.prototype.updateInputsVisualState = function(r) {
      var n = this.getAllInputs(), i = r ? Ru.MouseEnterOnCard : Ru.MouseLeaveOnCard;
      n.forEach(function(o) {
        return o.updateVisualState(i);
      });
    }, t.prototype.isDisplayed = function() {
      return this._renderedElement !== void 0 && this.isVisible && this._renderedElement.offsetHeight > 0;
    }, t.prototype.overrideInternalRender = function() {
      return this.internalRender();
    }, t.prototype.applyPadding = function() {
      if (this.separatorElement && this.separatorOrientation === Ke.Orientation.Horizontal)
        if (Ir.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
          var r = new Ir.PaddingDefinition();
          this.getImmediateSurroundingPadding(r);
          var n = this.hostConfig.paddingDefinitionToSpacingDefinition(r);
          this.separatorElement.style.marginLeft = "-" + n.left + "px", this.separatorElement.style.marginRight = "-" + n.right + "px";
        } else
          this.separatorElement.style.marginRight = "0", this.separatorElement.style.marginLeft = "0";
    }, t.prototype.truncateOverflow = function(r) {
      return !1;
    }, t.prototype.undoOverflowTruncation = function() {
    }, t.prototype.getDefaultPadding = function() {
      return new Ir.PaddingDefinition();
    }, t.prototype.getHasBackground = function(r) {
      return !1;
    }, t.prototype.getHasBorder = function() {
      return !1;
    }, t.prototype.getPadding = function() {
      return this._padding;
    }, t.prototype.setPadding = function(r) {
      this._padding = r;
    }, t.prototype.shouldSerialize = function(r) {
      return r.elementRegistry.findByName(this.getJsonTypeName()) !== void 0;
    }, Object.defineProperty(t.prototype, "useDefaultSizing", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "separatorOrientation", {
      get: function() {
        return Ke.Orientation.Horizontal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "defaultStyle", {
      get: function() {
        return Ke.ContainerStyle.Default;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.parse = function(r, n) {
      e.prototype.parse.call(this, r, n || new Kp());
    }, t.prototype.asString = function() {
      return "";
    }, t.prototype.isBleeding = function() {
      return !1;
    }, t.prototype.getEffectiveStyle = function() {
      return this.parent ? this.parent.getEffectiveStyle() : this.defaultStyle;
    }, t.prototype.getEffectiveStyleDefinition = function() {
      return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    }, t.prototype.getEffectiveTextStyleDefinition = function() {
      return this.parent ? this.parent.getEffectiveTextStyleDefinition() : this.hostConfig.textStyles.default;
    }, t.prototype.getForbiddenActionTypes = function() {
      return [];
    }, t.prototype.getImmediateSurroundingPadding = function(r, n, i, o, a) {
      if (n === void 0 && (n = !0), i === void 0 && (i = !0), o === void 0 && (o = !0), a === void 0 && (a = !0), this.parent) {
        var u = n && this.parent.isTopElement(this), s = i && this.parent.isRightMostElement(this), c = o && this.parent.isBottomElement(this), l = a && this.parent.isLeftMostElement(this), f = this.parent.getEffectivePadding();
        f && (u && f.top !== Ke.Spacing.None && (r.top = f.top, u = !1), s && f.right !== Ke.Spacing.None && (r.right = f.right, s = !1), c && f.bottom !== Ke.Spacing.None && (r.bottom = f.bottom, c = !1), l && f.left !== Ke.Spacing.None && (r.left = f.left, l = !1)), (u || s || c || l) && this.parent.getImmediateSurroundingPadding(r, u, s, c, l);
      }
    }, t.prototype.getActionCount = function() {
      return 0;
    }, t.prototype.getActionAt = function(r) {
      throw new Error(fr.Strings.errors.indexOutOfRange(r));
    }, t.prototype.indexOfAction = function(r) {
      for (var n = 0; n < this.getActionCount(); n++)
        if (this.getActionAt(n) === r)
          return n;
      return -1;
    }, t.prototype.remove = function() {
      return this.parent && this.parent instanceof S3 ? this.parent.removeItem(this) : !1;
    }, t.prototype.render = function() {
      return this._renderedElement = this.overrideInternalRender(), this._separatorElement = this.internalRenderSeparator(), this._renderedElement ? (this.id && (this._renderedElement.id = this.id), this.customCssSelector && this._renderedElement.classList.add(this.customCssSelector), this._renderedElement.style.boxSizing = "border-box", this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : void 0, this.adjustRenderedElementSize(this._renderedElement), this.updateLayout(!1)) : this.isDesignMode() && (this._renderedElement = this.createPlaceholderElement()), this._renderedElement;
    }, t.prototype.updateLayout = function(r) {
      this.updateRenderedElementVisibility(), this.applyPadding();
    }, t.prototype.updateActionsEnabledState = function() {
      for (var r = this.getRootElement().getAllActions(), n = 0, i = r; n < i.length; n++) {
        var o = i[n];
        o.updateEnabledState();
      }
    }, t.prototype.indexOf = function(r) {
      return -1;
    }, t.prototype.isDesignMode = function() {
      var r = this.getRootElement();
      return r instanceof ga && r.designMode;
    }, t.prototype.isFirstElement = function(r) {
      return !0;
    }, t.prototype.isLastElement = function(r) {
      return !0;
    }, t.prototype.isAtTheVeryLeft = function() {
      return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : !0;
    }, t.prototype.isAtTheVeryRight = function() {
      return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : !0;
    }, t.prototype.isAtTheVeryTop = function() {
      return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : !0;
    }, t.prototype.isAtTheVeryBottom = function() {
      return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : !0;
    }, t.prototype.isBleedingAtTop = function() {
      return !1;
    }, t.prototype.isBleedingAtBottom = function() {
      return !1;
    }, t.prototype.isLeftMostElement = function(r) {
      return !0;
    }, t.prototype.isRightMostElement = function(r) {
      return !0;
    }, t.prototype.isTopElement = function(r) {
      return this.isFirstElement(r);
    }, t.prototype.isBottomElement = function(r) {
      return this.isLastElement(r);
    }, t.prototype.isHiddenDueToOverflow = function() {
      return this._renderedElement !== void 0 && this._renderedElement.style.visibility === "hidden";
    }, t.prototype.getRootElement = function() {
      return this.getRootObject();
    }, t.prototype.getParentContainer = function() {
      for (var r = this.parent; r; ) {
        if (r instanceof hd)
          return r;
        r = r.parent;
      }
    }, t.prototype.getAllInputs = function(r) {
      return [];
    }, t.prototype.getAllActions = function() {
      for (var r = [], n = 0; n < this.getActionCount(); n++) {
        var i = this.getActionAt(n);
        i && r.push(i);
      }
      return r;
    }, t.prototype.getResourceInformation = function() {
      return [];
    }, t.prototype.getElementById = function(r) {
      return this.id === r ? this : void 0;
    }, t.prototype.getActionById = function(r) {
    }, t.prototype.getElementByIdFromAction = function(r) {
      for (var n = void 0, i = 0; i < this.getActionCount(); i++) {
        var o = this.getActionAt(i);
        if (o instanceof Lf && (n = o.card.getElementById(r), n))
          break;
      }
      return n;
    }, t.prototype.getEffectivePadding = function() {
      var r = this.getPadding();
      return r || this.getDefaultPadding();
    }, t.prototype.getEffectiveHorizontalAlignment = function() {
      return this.horizontalAlignment !== void 0 ? this.horizontalAlignment : this.parent ? this.parent.getEffectiveHorizontalAlignment() : Ke.HorizontalAlignment.Left;
    }, Object.defineProperty(t.prototype, "hostConfig", {
      get: function() {
        return this._hostConfig ? this._hostConfig : this.parent ? this.parent.hostConfig : A3.defaultHostConfig;
      },
      set: function(r) {
        this._hostConfig = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "index", {
      get: function() {
        return this.parent ? this.parent.indexOf(this) : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isInteractive", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isInline", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hasVisibleSeparator", {
      get: function() {
        return this.parent && this.separatorElement ? !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode()) : !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "separatorElement", {
      get: function() {
        return this._separatorElement;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "parent", {
      get: function() {
        return this._parent;
      },
      enumerable: !1,
      configurable: !0
    }), t.langProperty = new pe.StringProperty(pe.Versions.v1_1, "lang", !0, /^[a-z]{2,3}$/gi), t.isVisibleProperty = new pe.BoolProperty(pe.Versions.v1_2, "isVisible", !0), t.separatorProperty = new pe.BoolProperty(pe.Versions.v1_0, "separator", !1), t.heightProperty = new pe.ValueSetProperty(pe.Versions.v1_1, "height", [{ value: "auto" }, { value: "stretch" }], "auto"), t.horizontalAlignmentProperty = new pe.EnumProperty(pe.Versions.v1_0, "horizontalAlignment", Ke.HorizontalAlignment), t.spacingProperty = new pe.EnumProperty(pe.Versions.v1_0, "spacing", Ke.Spacing, Ke.Spacing.Default), bt([
      (0, pe.property)(t.horizontalAlignmentProperty)
    ], t.prototype, "horizontalAlignment", void 0), bt([
      (0, pe.property)(t.spacingProperty)
    ], t.prototype, "spacing", void 0), bt([
      (0, pe.property)(t.separatorProperty)
    ], t.prototype, "separator", void 0), bt([
      (0, pe.property)(t.heightProperty)
    ], t.prototype, "height", void 0), bt([
      (0, pe.property)(t.langProperty)
    ], t.prototype, "lang", null), bt([
      (0, pe.property)(t.isVisibleProperty)
    ], t.prototype, "isVisible", null), t;
  }(G1e.CardObject)
);
Ct.CardElement = na;
var Cy = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n, i) {
      i === void 0 && (i = []);
      var o = e.call(this, r, n, void 0) || this;
      return o.targetVersion = r, o.name = n, o.forbiddenActionTypes = i, o;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = r;
      return i.parseAction(o, n[this.name], this.forbiddenActionTypes, o.isDesignMode());
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeValue(n, this.name, i ? i.toJSON(o) : void 0, void 0, !0);
    }, t;
  }(pe.PropertyDefinition)
);
Ct.ActionProperty = Cy;
var Op = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.ariaHidden = !1, r && (n.text = r), n;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.remove(t.selectActionProperty);
    }, Object.defineProperty(t.prototype, "text", {
      get: function() {
        return this.getValue(t.textProperty);
      },
      set: function(r) {
        this.setText(r);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getFontSize = function(r) {
      switch (this.effectiveSize) {
        case Ke.TextSize.Small:
          return r.fontSizes.small;
        case Ke.TextSize.Medium:
          return r.fontSizes.medium;
        case Ke.TextSize.Large:
          return r.fontSizes.large;
        case Ke.TextSize.ExtraLarge:
          return r.fontSizes.extraLarge;
        default:
          return r.fontSizes.default;
      }
    }, t.prototype.getColorDefinition = function(r, n) {
      switch (n) {
        case Ke.TextColor.Accent:
          return r.accent;
        case Ke.TextColor.Dark:
          return r.dark;
        case Ke.TextColor.Light:
          return r.light;
        case Ke.TextColor.Good:
          return r.good;
        case Ke.TextColor.Warning:
          return r.warning;
        case Ke.TextColor.Attention:
          return r.attention;
        default:
          return r.default;
      }
    }, t.prototype.setText = function(r) {
      this.setValue(t.textProperty, r);
    }, t.prototype.init = function(r) {
      this.size = r.size, this.weight = r.weight, this.color = r.color, this.isSubtle = r.isSubtle;
    }, t.prototype.asString = function() {
      return this.text;
    }, t.prototype.applyStylesTo = function(r) {
      var n = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
      n.fontFamily && (r.style.fontFamily = n.fontFamily);
      var i;
      switch (this.effectiveSize) {
        case Ke.TextSize.Small:
          i = n.fontSizes.small;
          break;
        case Ke.TextSize.Medium:
          i = n.fontSizes.medium;
          break;
        case Ke.TextSize.Large:
          i = n.fontSizes.large;
          break;
        case Ke.TextSize.ExtraLarge:
          i = n.fontSizes.extraLarge;
          break;
        default:
          i = n.fontSizes.default;
          break;
      }
      r.style.fontSize = i + "px";
      var o = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor), a = lr.stringToCssColor(this.effectiveIsSubtle ? o.subtle : o.default);
      a && (r.style.color = a);
      var u;
      switch (this.effectiveWeight) {
        case Ke.TextWeight.Lighter:
          u = n.fontWeights.lighter;
          break;
        case Ke.TextWeight.Bolder:
          u = n.fontWeights.bolder;
          break;
        default:
          u = n.fontWeights.default;
          break;
      }
      r.style.fontWeight = u.toString(), this.ariaHidden && r.setAttribute("aria-hidden", "true");
    }, t.prototype.getAllActions = function() {
      var r = e.prototype.getAllActions.call(this);
      return this.selectAction && r.push(this.selectAction), r;
    }, Object.defineProperty(t.prototype, "effectiveColor", {
      get: function() {
        return this.color !== void 0 ? this.color : this.getEffectiveTextStyleDefinition().color;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "effectiveFontType", {
      get: function() {
        return this.fontType !== void 0 ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "effectiveIsSubtle", {
      get: function() {
        return this.isSubtle !== void 0 ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "effectiveSize", {
      get: function() {
        return this.size !== void 0 ? this.size : this.getEffectiveTextStyleDefinition().size;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "effectiveWeight", {
      get: function() {
        return this.weight !== void 0 ? this.weight : this.getEffectiveTextStyleDefinition().weight;
      },
      enumerable: !1,
      configurable: !0
    }), t.textProperty = new pe.StringProperty(pe.Versions.v1_0, "text", !0), t.sizeProperty = new pe.EnumProperty(pe.Versions.v1_0, "size", Ke.TextSize), t.weightProperty = new pe.EnumProperty(pe.Versions.v1_0, "weight", Ke.TextWeight), t.colorProperty = new pe.EnumProperty(pe.Versions.v1_0, "color", Ke.TextColor), t.isSubtleProperty = new pe.BoolProperty(pe.Versions.v1_0, "isSubtle"), t.fontTypeProperty = new pe.EnumProperty(pe.Versions.v1_2, "fontType", Ke.FontType), t.selectActionProperty = new Cy(pe.Versions.v1_1, "selectAction", [
      "Action.ShowCard"
    ]), bt([
      (0, pe.property)(t.sizeProperty)
    ], t.prototype, "size", void 0), bt([
      (0, pe.property)(t.weightProperty)
    ], t.prototype, "weight", void 0), bt([
      (0, pe.property)(t.colorProperty)
    ], t.prototype, "color", void 0), bt([
      (0, pe.property)(t.fontTypeProperty)
    ], t.prototype, "fontType", void 0), bt([
      (0, pe.property)(t.isSubtleProperty)
    ], t.prototype, "isSubtle", void 0), bt([
      (0, pe.property)(t.textProperty)
    ], t.prototype, "text", null), bt([
      (0, pe.property)(t.selectActionProperty)
    ], t.prototype, "selectAction", void 0), t;
  }(na)
);
Ct.BaseTextBlock = Op;
var Nf = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.wrap = !1, i._treatAsPlainText = !0, i.useMarkdown = !0, i;
    }
    t.prototype.restoreOriginalContent = function() {
      var i, o;
      if (this.renderedElement !== void 0) {
        this.maxLines && this.maxLines > 0 && (this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px");
        var a = (o = (i = t._ttRoundtripPolicy) === null || i === void 0 ? void 0 : i.createHTML(this._originalInnerHtml)) !== null && o !== void 0 ? o : this._originalInnerHtml;
        this.renderedElement.innerHTML = a;
      }
    }, t.prototype.truncateIfSupported = function(i) {
      if (this.renderedElement !== void 0) {
        var o = this.renderedElement.children, a = !o.length, u = a || o.length === 1 && o[0].tagName.toLowerCase() === "p" && !o[0].children.length;
        if (u) {
          var s = a ? this.renderedElement : o[0];
          return lr.truncateText(s, i, this._computedLineHeight), !0;
        }
      }
      return !1;
    }, t.prototype.setText = function(i) {
      e.prototype.setText.call(this, i), this._processedText = void 0;
    }, t.prototype.internalRender = function() {
      var i = this, o, a;
      if (this._processedText = void 0, this.text) {
        var u = this.preProcessPropertyValue(Op.textProperty), s = this.hostConfig, c = void 0;
        if (this.forElementId) {
          var l = document.createElement("label");
          l.htmlFor = this.forElementId, c = l;
        } else
          c = document.createElement("div");
        if (c.classList.add(s.makeCssClassName("ac-textBlock")), c.style.overflow = "hidden", this.applyStylesTo(c), this.style === "heading") {
          c.setAttribute("role", "heading");
          var f = this.hostConfig.textBlock.headingLevel;
          f !== void 0 && f > 0 && c.setAttribute("aria-level", f.toString());
        }
        if (this.selectAction && s.supportsInteractivity && (c.onclick = function(O) {
          i.selectAction && i.selectAction.isEffectivelyEnabled() && (O.preventDefault(), O.cancelBubble = !0, i.selectAction.execute());
        }, this.selectAction.setupElementForAccessibility(c), this.selectAction.isEffectivelyEnabled() && c.classList.add(s.makeCssClassName("ac-selectable"))), !this._processedText) {
          this._treatAsPlainText = !0;
          var d = Y1e.formatText(this.lang, u);
          if (this.useMarkdown && d) {
            Ir.GlobalSettings.allowMarkForTextHighlighting && (d = d.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/"));
            var p = ga.applyMarkdown(d);
            if (p.didProcess && p.outputHtml) {
              if (this._processedText = p.outputHtml, this._treatAsPlainText = !1, Ir.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                var v = "", h = this.getEffectiveStyleDefinition();
                h.highlightBackgroundColor && (v += "background-color: " + h.highlightBackgroundColor + ";"), h.highlightForegroundColor && (v += "color: " + h.highlightForegroundColor + ";"), v && (v = 'style="' + v + '"'), this._processedText = this._processedText.replace(/===/g, "<mark " + v + ">").replace(/\/==\//g, "</mark>");
              }
            } else
              this._processedText = d, this._treatAsPlainText = !0;
          } else
            this._processedText = d, this._treatAsPlainText = !0;
        }
        if (this._processedText || (this._processedText = ""), this._treatAsPlainText)
          c.innerText = this._processedText;
        else {
          var E = (a = (o = t._ttMarkdownPolicy) === null || o === void 0 ? void 0 : o.createHTML(this._processedText)) !== null && a !== void 0 ? a : this._processedText;
          c.innerHTML = E;
        }
        if (c.firstElementChild instanceof HTMLElement) {
          var m = c.firstElementChild;
          m.style.marginTop = "0px", m.style.width = "100%", this.wrap || (m.style.overflow = "hidden", m.style.textOverflow = "ellipsis");
        }
        c.lastElementChild instanceof HTMLElement && (c.lastElementChild.style.marginBottom = "0px");
        for (var g = c.getElementsByTagName("a"), y = function(O) {
          O.classList.add(s.makeCssClassName("ac-anchor")), O.target = "_blank", O.onclick = function(P) {
            mee(i, O, P) && (P.preventDefault(), P.cancelBubble = !0);
          }, O.oncontextmenu = function(P) {
            return mee(i, O, P) ? (P.preventDefault(), P.cancelBubble = !0, !1) : !0;
          };
        }, _ = 0, S = Array.from(g); _ < S.length; _++) {
          var A = S[_];
          y(A);
        }
        return this.wrap ? (c.style.wordWrap = "break-word", this.maxLines && this.maxLines > 0 && (c.style.overflow = "hidden", lr.isInternetExplorer() || !Ir.GlobalSettings.useWebkitLineClamp ? c.style.maxHeight = this._computedLineHeight * this.maxLines + "px" : (c.style.removeProperty("line-height"), c.style.display = "-webkit-box", c.style.webkitBoxOrient = "vertical", c.style.webkitLineClamp = this.maxLines.toString()))) : (c.style.whiteSpace = "nowrap", c.style.textOverflow = "ellipsis"), (Ir.GlobalSettings.useAdvancedTextBlockTruncation || Ir.GlobalSettings.useAdvancedCardBottomTruncation) && (this._originalInnerHtml = c.innerHTML), c;
      } else
        return;
    }, t.prototype.truncateOverflow = function(i) {
      return i >= this._computedLineHeight ? this.truncateIfSupported(i) : !1;
    }, t.prototype.undoOverflowTruncation = function() {
      if (this.restoreOriginalContent(), Ir.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
        var i = this._computedLineHeight * this.maxLines;
        this.truncateIfSupported(i);
      }
    }, t.prototype.applyStylesTo = function(i) {
      switch (e.prototype.applyStylesTo.call(this, i), this.getEffectiveHorizontalAlignment()) {
        case Ke.HorizontalAlignment.Center:
          i.style.textAlign = "center";
          break;
        case Ke.HorizontalAlignment.Right:
          i.style.textAlign = "end";
          break;
        default:
          i.style.textAlign = "start";
          break;
      }
      var o = this.hostConfig.lineHeights;
      if (o)
        switch (this.effectiveSize) {
          case Ke.TextSize.Small:
            this._computedLineHeight = o.small;
            break;
          case Ke.TextSize.Medium:
            this._computedLineHeight = o.medium;
            break;
          case Ke.TextSize.Large:
            this._computedLineHeight = o.large;
            break;
          case Ke.TextSize.ExtraLarge:
            this._computedLineHeight = o.extraLarge;
            break;
          default:
            this._computedLineHeight = o.default;
            break;
        }
      else
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
      i.style.lineHeight = this._computedLineHeight + "px";
    }, t.prototype.getJsonTypeName = function() {
      return "TextBlock";
    }, t.prototype.getEffectiveTextStyleDefinition = function() {
      return this.style ? this.hostConfig.textStyles.getStyleByName(this.style) : e.prototype.getEffectiveTextStyleDefinition.call(this);
    }, t.prototype.updateLayout = function(i) {
      i === void 0 && (i = !1), e.prototype.updateLayout.call(this, i), Ir.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed() && (this.restoreOriginalContent(), this.truncateIfSupported(this._computedLineHeight * this.maxLines));
    };
    var r, n;
    return t.wrapProperty = new pe.BoolProperty(pe.Versions.v1_0, "wrap", !1), t.maxLinesProperty = new pe.NumProperty(pe.Versions.v1_0, "maxLines"), t.styleProperty = new pe.ValueSetProperty(pe.Versions.v1_5, "style", [
      { value: "default" },
      { value: "columnHeader" },
      { value: "heading" }
    ]), t._ttMarkdownPolicy = typeof window > "u" || (r = window.trustedTypes) === null || r === void 0 ? void 0 : r.createPolicy("adaptivecards#markdownPassthroughPolicy", { createHTML: function(i) {
      return i;
    } }), t._ttRoundtripPolicy = typeof window > "u" || (n = window.trustedTypes) === null || n === void 0 ? void 0 : n.createPolicy("adaptivecards#restoreContentsPolicy", { createHTML: function(i) {
      return i;
    } }), bt([
      (0, pe.property)(t.wrapProperty)
    ], t.prototype, "wrap", void 0), bt([
      (0, pe.property)(t.maxLinesProperty)
    ], t.prototype, "maxLines", void 0), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", void 0), t;
  }(Op)
);
Ct.TextBlock = Nf;
var Wp = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.italic = !1, r.strikethrough = !1, r.highlight = !1, r.underline = !1, r;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.add(Op.selectActionProperty);
    }, t.prototype.internalRender = function() {
      var r = this;
      if (this.text) {
        var n = this.preProcessPropertyValue(Op.textProperty), i = this.hostConfig, o = Y1e.formatText(this.lang, n);
        o || (o = "");
        var a = document.createElement("span");
        if (a.classList.add(i.makeCssClassName("ac-textRun")), this.applyStylesTo(a), this.selectAction && i.supportsInteractivity) {
          var u = document.createElement("a");
          u.classList.add(i.makeCssClassName("ac-anchor"));
          var s = this.selectAction.getHref();
          u.href = s || "", u.target = "_blank", u.onclick = function(c) {
            r.selectAction && r.selectAction.isEffectivelyEnabled() && (c.preventDefault(), c.cancelBubble = !0, r.selectAction.execute());
          }, this.selectAction.setupElementForAccessibility(u), u.innerText = o, a.appendChild(u);
        } else
          a.innerText = o;
        return a;
      } else
        return;
    }, t.prototype.applyStylesTo = function(r) {
      if (e.prototype.applyStylesTo.call(this, r), this.italic && (r.style.fontStyle = "italic"), this.strikethrough && (r.style.textDecoration = "line-through"), this.highlight) {
        var n = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor), i = lr.stringToCssColor(this.effectiveIsSubtle ? n.highlightColors.subtle : n.highlightColors.default);
        i && (r.style.backgroundColor = i);
      }
      this.underline && (r.style.textDecoration = "underline");
    }, t.prototype.getJsonTypeName = function() {
      return "TextRun";
    }, Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isInline", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.italicProperty = new pe.BoolProperty(pe.Versions.v1_2, "italic", !1), t.strikethroughProperty = new pe.BoolProperty(pe.Versions.v1_2, "strikethrough", !1), t.highlightProperty = new pe.BoolProperty(pe.Versions.v1_2, "highlight", !1), t.underlineProperty = new pe.BoolProperty(pe.Versions.v1_3, "underline", !1), bt([
      (0, pe.property)(t.italicProperty)
    ], t.prototype, "italic", void 0), bt([
      (0, pe.property)(t.strikethroughProperty)
    ], t.prototype, "strikethrough", void 0), bt([
      (0, pe.property)(t.highlightProperty)
    ], t.prototype, "highlight", void 0), bt([
      (0, pe.property)(t.underlineProperty)
    ], t.prototype, "underline", void 0), t;
  }(Op)
);
Ct.TextRun = Wp;
var d7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._inlines = [], r;
    }
    return t.prototype.internalAddInline = function(r, n) {
      if (n === void 0 && (n = !1), !r.isInline)
        throw new Error(fr.Strings.errors.elementCannotBeUsedAsInline());
      var i = r.parent === void 0 || n;
      if (!i && r.parent !== this)
        throw new Error(fr.Strings.errors.inlineAlreadyParented());
      r.setParent(this), this._inlines.push(r);
    }, t.prototype.internalParse = function(r, n) {
      if (e.prototype.internalParse.call(this, r, n), this._inlines = [], Array.isArray(r.inlines))
        for (var i = 0, o = r.inlines; i < o.length; i++) {
          var a = o[i], u = void 0;
          if (typeof a == "string") {
            var s = new Wp();
            s.text = a, u = s;
          } else
            u = n.parseElement(this, a, [], !1);
          u && this.internalAddInline(u, !0);
        }
    }, t.prototype.internalToJSON = function(r, n) {
      if (e.prototype.internalToJSON.call(this, r, n), this._inlines.length > 0) {
        for (var i = [], o = 0, a = this._inlines; o < a.length; o++) {
          var u = a[o];
          i.push(u.toJSON(n));
        }
        n.serializeValue(r, "inlines", i);
      }
    }, t.prototype.internalRender = function() {
      if (this._inlines.length > 0) {
        var r = void 0;
        if (this.forElementId) {
          var n = document.createElement("label");
          n.htmlFor = this.forElementId, r = n;
        } else
          r = document.createElement("div");
        switch (r.className = this.hostConfig.makeCssClassName("ac-richTextBlock"), this.getEffectiveHorizontalAlignment()) {
          case Ke.HorizontalAlignment.Center:
            r.style.textAlign = "center";
            break;
          case Ke.HorizontalAlignment.Right:
            r.style.textAlign = "end";
            break;
          default:
            r.style.textAlign = "start";
            break;
        }
        for (var i = 0, o = 0, a = this._inlines; o < a.length; o++) {
          var u = a[o], s = u.render();
          s && (r.appendChild(s), i++);
        }
        if (i > 0)
          return r;
      }
    }, t.prototype.asString = function() {
      for (var r = "", n = 0, i = this._inlines; n < i.length; n++) {
        var o = i[n];
        r += o.asString();
      }
      return r;
    }, t.prototype.getJsonTypeName = function() {
      return "RichTextBlock";
    }, t.prototype.getInlineCount = function() {
      return this._inlines.length;
    }, t.prototype.getInlineAt = function(r) {
      if (r >= 0 && r < this._inlines.length)
        return this._inlines[r];
      throw new Error(fr.Strings.errors.indexOutOfRange(r));
    }, t.prototype.addInline = function(r) {
      typeof r == "string" ? this.internalAddInline(new Wp(r)) : this.internalAddInline(r);
    }, t.prototype.removeInline = function(r) {
      var n = this._inlines.indexOf(r);
      return n >= 0 ? (this._inlines[n].setParent(void 0), this._inlines.splice(n, 1), !0) : !1;
    }, t;
  }(na)
);
Ct.RichTextBlock = d7;
var W1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this) || this;
      return i.name = r, i.value = n, i;
    }
    return t.prototype.getSchemaKey = function() {
      return "Fact";
    }, t.titleProperty = new pe.StringProperty(pe.Versions.v1_0, "title"), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), bt([
      (0, pe.property)(t.titleProperty)
    ], t.prototype, "name", void 0), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "value", void 0), t;
  }(pe.SerializableObject)
);
Ct.Fact = W1e;
var K1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(t.prototype, "useDefaultSizing", {
      //#endregion
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.internalRender = function() {
      var r = void 0, n = this.hostConfig;
      if (this.facts.length > 0) {
        r = document.createElement("table"), r.style.borderWidth = "0px", r.style.borderSpacing = "0px", r.style.borderStyle = "none", r.style.borderCollapse = "collapse", r.style.display = "block", r.style.overflow = "hidden", r.classList.add(n.makeCssClassName("ac-factset")), r.setAttribute("role", "presentation");
        for (var i = 0; i < this.facts.length; i++) {
          var o = document.createElement("tr");
          i > 0 && (o.style.marginTop = n.factSet.spacing + "px");
          var a = document.createElement("td");
          a.style.padding = "0", a.classList.add(n.makeCssClassName("ac-fact-title")), n.factSet.title.maxWidth && (a.style.maxWidth = n.factSet.title.maxWidth + "px"), a.style.verticalAlign = "top";
          var u = new Nf();
          u.setParent(this), u.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name, u.size = n.factSet.title.size, u.color = n.factSet.title.color, u.isSubtle = n.factSet.title.isSubtle, u.weight = n.factSet.title.weight, u.wrap = n.factSet.title.wrap, u.spacing = Ke.Spacing.None, lr.appendChild(a, u.render()), lr.appendChild(o, a), a = document.createElement("td"), a.style.width = "10px", lr.appendChild(o, a), a = document.createElement("td"), a.style.padding = "0", a.style.verticalAlign = "top", a.classList.add(n.makeCssClassName("ac-fact-value")), u = new Nf(), u.setParent(this), u.text = this.facts[i].value, u.size = n.factSet.value.size, u.color = n.factSet.value.color, u.isSubtle = n.factSet.value.isSubtle, u.weight = n.factSet.value.weight, u.wrap = n.factSet.value.wrap, u.spacing = Ke.Spacing.None, lr.appendChild(a, u.render()), lr.appendChild(o, a), lr.appendChild(r, o);
        }
      }
      return r;
    }, t.prototype.getJsonTypeName = function() {
      return "FactSet";
    }, t.factsProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_0, "facts", W1e), bt([
      (0, pe.property)(t.factsProperty)
    ], t.prototype, "facts", void 0), t;
  }(na)
);
Ct.FactSet = K1e;
var hee = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n) || this;
      return a.targetVersion = r, a.name = n, a.internalName = i, a.fallbackProperty = o, a;
    }
    return t.prototype.getInternalName = function() {
      return this.internalName;
    }, t.prototype.parse = function(r, n, i) {
      var o = void 0, a = n[this.name];
      if (a === void 0)
        return this.defaultValue;
      var u = !1;
      if (typeof a == "string") {
        try {
          var s = Ir.SizeAndUnit.parse(a, !0);
          s.unit === Ke.SizeUnit.Pixel && (o = s.physicalSize, u = !0);
        } catch {
        }
        !u && this.fallbackProperty && (u = this.fallbackProperty.isValidValue(a, i));
      }
      return u || i.logParseEvent(r, Ke.ValidationEvent.InvalidPropertyValue, fr.Strings.errors.invalidPropertyValue(a, this.name)), o;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeValue(n, this.name, typeof i == "number" && !isNaN(i) ? i + "px" : void 0);
    }, t;
  }(pe.PropertyDefinition)
), b1 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.size = Ke.Size.Auto, r.style = Ke.ImageStyle.Default, r;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.remove(na.heightProperty);
    }, t.prototype.applySize = function(r) {
      if (this.pixelWidth || this.pixelHeight)
        this.pixelWidth && (r.style.width = this.pixelWidth + "px"), this.pixelHeight && (r.style.height = this.pixelHeight + "px");
      else if (this.maxHeight) {
        switch (this.size) {
          case Ke.Size.Small:
            r.style.height = this.hostConfig.imageSizes.small + "px";
            break;
          case Ke.Size.Large:
            r.style.height = this.hostConfig.imageSizes.large + "px";
            break;
          default:
            r.style.height = this.hostConfig.imageSizes.medium + "px";
            break;
        }
        r.style.maxHeight = this.maxHeight + "px";
      } else {
        switch (this.size) {
          case Ke.Size.Stretch:
            r.style.width = "100%";
            break;
          case Ke.Size.Auto:
            r.style.maxWidth = "100%";
            break;
          case Ke.Size.Small:
            r.style.width = this.hostConfig.imageSizes.small + "px";
            break;
          case Ke.Size.Large:
            r.style.width = this.hostConfig.imageSizes.large + "px";
            break;
          case Ke.Size.Medium:
            r.style.width = this.hostConfig.imageSizes.medium + "px";
            break;
        }
        r.style.maxHeight = "100%";
      }
    }, Object.defineProperty(t.prototype, "useDefaultSizing", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.internalRender = function() {
      var r = this, n = void 0;
      if (this.url) {
        n = document.createElement("div"), n.style.display = "flex", n.style.alignItems = "flex-start";
        var i = this.hostConfig;
        switch (this.getEffectiveHorizontalAlignment()) {
          case Ke.HorizontalAlignment.Center:
            n.style.justifyContent = "center";
            break;
          case Ke.HorizontalAlignment.Right:
            n.style.justifyContent = "flex-end";
            break;
          default:
            n.style.justifyContent = "flex-start";
            break;
        }
        var o = document.createElement("img");
        this.renderedImageElement = o, o.onload = function(s) {
          Eee(r);
        }, o.onerror = function(s) {
          if (r.renderedElement) {
            var c = r.getRootElement();
            if (HS(r.renderedElement), c && c.designMode) {
              var l = document.createElement("div");
              l.style.display = "flex", l.style.alignItems = "center", l.style.justifyContent = "center", l.style.backgroundColor = "#EEEEEE", l.style.color = "black", l.innerText = ":-(", l.style.padding = "10px", r.applySize(l), r.renderedElement.appendChild(l);
            }
          }
          Eee(r);
        }, o.style.minWidth = "0", o.classList.add(i.makeCssClassName("ac-image")), this.selectAction && i.supportsInteractivity && (o.onkeypress = function(s) {
          r.selectAction && r.selectAction.isEffectivelyEnabled() && (s.code === "Enter" || s.code === "Space") && (s.preventDefault(), s.cancelBubble = !0, r.selectAction.execute());
        }, o.onclick = function(s) {
          r.selectAction && r.selectAction.isEffectivelyEnabled() && (s.preventDefault(), s.cancelBubble = !0, r.selectAction.execute());
        }, this.selectAction.setupElementForAccessibility(o), this.selectAction.isEffectivelyEnabled() && o.classList.add(i.makeCssClassName("ac-selectable"))), this.applySize(o), this.style === Ke.ImageStyle.Person && (o.style.borderRadius = "50%", o.style.backgroundPosition = "50% 50%", o.style.backgroundRepeat = "no-repeat");
        var a = lr.stringToCssColor(this.backgroundColor);
        a && (o.style.backgroundColor = a), this.setImageSource(o);
        var u = this.preProcessPropertyValue(t.altTextProperty);
        u && (o.alt = u), n.appendChild(o);
      }
      return n;
    }, t.prototype.getJsonTypeName = function() {
      return "Image";
    }, t.prototype.getAllActions = function() {
      var r = e.prototype.getAllActions.call(this);
      return this.selectAction && r.push(this.selectAction), r;
    }, t.prototype.getActionById = function(r) {
      var n = e.prototype.getActionById.call(this, r);
      return !n && this.selectAction && (n = this.selectAction.getActionById(r)), n;
    }, t.prototype.getResourceInformation = function() {
      return this.url ? [{ url: this.url, mimeType: "image" }] : [];
    }, t.prototype.setImageSource = function(r) {
      var n = new Zrr(this.forceLoad, this.url);
      n.configureImage(this), r.src = this.preProcessPropertyValue(t.urlProperty), n.resetImage(this);
    }, t.urlProperty = new pe.StringProperty(pe.Versions.v1_0, "url"), t.altTextProperty = new pe.StringProperty(pe.Versions.v1_0, "altText"), t.backgroundColorProperty = new pe.StringProperty(pe.Versions.v1_1, "backgroundColor"), t.styleProperty = new pe.EnumProperty(pe.Versions.v1_0, "style", Ke.ImageStyle, Ke.ImageStyle.Default), t.sizeProperty = new pe.EnumProperty(pe.Versions.v1_0, "size", Ke.Size, Ke.Size.Auto), t.pixelWidthProperty = new hee(pe.Versions.v1_1, "width", "pixelWidth"), t.pixelHeightProperty = new hee(pe.Versions.v1_1, "height", "pixelHeight", na.heightProperty), t.selectActionProperty = new Cy(pe.Versions.v1_1, "selectAction", [
      "Action.ShowCard"
    ]), t.shouldForceLoadProperty = new pe.BoolProperty(pe.Versions.v1_6, "forceLoad", !1), bt([
      (0, pe.property)(t.urlProperty)
    ], t.prototype, "url", void 0), bt([
      (0, pe.property)(t.altTextProperty)
    ], t.prototype, "altText", void 0), bt([
      (0, pe.property)(t.backgroundColorProperty)
    ], t.prototype, "backgroundColor", void 0), bt([
      (0, pe.property)(t.sizeProperty)
    ], t.prototype, "size", void 0), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", void 0), bt([
      (0, pe.property)(t.pixelWidthProperty)
    ], t.prototype, "pixelWidth", void 0), bt([
      (0, pe.property)(t.pixelHeightProperty)
    ], t.prototype, "pixelHeight", void 0), bt([
      (0, pe.property)(t.selectActionProperty)
    ], t.prototype, "selectAction", void 0), bt([
      (0, pe.property)(t.shouldForceLoadProperty)
    ], t.prototype, "forceLoad", void 0), t;
  }(na)
);
Ct.Image = b1;
var Zrr = (
  /** @class */
  function() {
    function e(t, r) {
      this.doForceLoad = t, this.url = r, r && r.length && t && (this.uniqueHash = "?" + Date.now(), this.urlWithForceLoadOption = r + this.uniqueHash);
    }
    return e.prototype.configureImage = function(t) {
      this.urlWithForceLoadOption && this.urlWithForceLoadOption.length && (t.url = this.urlWithForceLoadOption);
    }, e.prototype.resetImage = function(t) {
      t.url = this.url;
    }, e;
  }()
), S3 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.allowVerticalOverflow = !1, r;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), this.isSelectable || r.remove(t.selectActionProperty);
    }, t.prototype.isElementAllowed = function(r) {
      return this.hostConfig.supportsInteractivity || !r.isInteractive;
    }, t.prototype.applyPadding = function() {
      if (e.prototype.applyPadding.call(this), !!this.renderedElement) {
        var r = new Ir.SpacingDefinition();
        this.getEffectivePadding() && (r = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding())), this.renderedElement.style.paddingTop = r.top + "px", this.renderedElement.style.paddingRight = r.right + "px", this.renderedElement.style.paddingBottom = r.bottom + "px", this.renderedElement.style.paddingLeft = r.left + "px", this.renderedElement.style.marginRight = "0", this.renderedElement.style.marginLeft = "0";
      }
    }, Object.defineProperty(t.prototype, "isSelectable", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.forbiddenChildElements = function() {
      return [];
    }, t.prototype.releaseDOMResources = function() {
      e.prototype.releaseDOMResources.call(this);
      for (var r = 0; r < this.getItemCount(); r++)
        this.getItemAt(r).releaseDOMResources();
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r);
      for (var n = 0; n < this.getItemCount(); n++) {
        var i = this.getItemAt(n);
        !this.hostConfig.supportsInteractivity && i.isInteractive && r.addFailure(this, Ke.ValidationEvent.InteractivityNotAllowed, fr.Strings.errors.interactivityNotAllowed()), this.isElementAllowed(i) || r.addFailure(this, Ke.ValidationEvent.InteractivityNotAllowed, fr.Strings.errors.elementTypeNotAllowed(i.getJsonTypeName())), i.internalValidateProperties(r);
      }
      this._selectAction && this._selectAction.internalValidateProperties(r);
    }, t.prototype.render = function() {
      var r = this, n = e.prototype.render.call(this);
      if (n) {
        var i = this.hostConfig;
        this.allowVerticalOverflow && (n.style.overflowX = "hidden", n.style.overflowY = "auto"), n && this.isSelectable && this._selectAction && i.supportsInteractivity && (n.onclick = function(o) {
          r._selectAction && r._selectAction.isEffectivelyEnabled() && (o.preventDefault(), o.cancelBubble = !0, r._selectAction.execute());
        }, n.onkeypress = function(o) {
          r._selectAction && r._selectAction.isEffectivelyEnabled() && (o.code === "Enter" || o.code === "Space") && (o.preventDefault(), o.cancelBubble = !0, r._selectAction.execute());
        }, this._selectAction.setupElementForAccessibility(n), this._selectAction.isEffectivelyEnabled() && n.classList.add(i.makeCssClassName("ac-selectable")));
      }
      return n;
    }, t.prototype.updateLayout = function(r) {
      if (r === void 0 && (r = !0), e.prototype.updateLayout.call(this, r), r)
        for (var n = 0; n < this.getItemCount(); n++)
          this.getItemAt(n).updateLayout();
    }, t.prototype.getAllInputs = function(r) {
      r === void 0 && (r = !0);
      for (var n = [], i = 0; i < this.getItemCount(); i++)
        n.push.apply(n, this.getItemAt(i).getAllInputs(r));
      return n;
    }, t.prototype.getAllActions = function() {
      for (var r = e.prototype.getAllActions.call(this), n = 0; n < this.getItemCount(); n++)
        r.push.apply(r, this.getItemAt(n).getAllActions());
      return this._selectAction && r.push(this._selectAction), r;
    }, t.prototype.getResourceInformation = function() {
      for (var r = [], n = 0; n < this.getItemCount(); n++)
        r.push.apply(r, this.getItemAt(n).getResourceInformation());
      return r;
    }, t.prototype.getElementById = function(r) {
      var n = e.prototype.getElementById.call(this, r);
      if (!n)
        for (var i = 0; i < this.getItemCount() && (n = this.getItemAt(i).getElementById(r), !n); i++)
          ;
      return n;
    }, t.prototype.findDOMNodeOwner = function(r) {
      for (var n, i = void 0, o = 0; o < this.getItemCount(); o++)
        if (i = this.getItemAt(o).findDOMNodeOwner(r), i)
          return i;
      for (var o = 0; o < this.getActionCount(); o++)
        if (i = (n = this.getActionAt(o)) === null || n === void 0 ? void 0 : n.findDOMNodeOwner(r), i)
          return i;
      return e.prototype.findDOMNodeOwner.call(this, r);
    }, t.selectActionProperty = new Cy(pe.Versions.v1_1, "selectAction", [
      "Action.ShowCard"
    ]), bt([
      (0, pe.property)(t.selectActionProperty)
    ], t.prototype, "_selectAction", void 0), t;
  }(na)
);
Ct.CardElementContainer = S3;
var X1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._images = [], r.imageSize = Ke.ImageSize.Medium, r.presentationStyle = Ke.ImageSetPresentationStyle.Default, r.pixelOffset = 0, r;
    }
    return t.prototype.internalRender = function() {
      var r = void 0;
      if (this._images.length > 0) {
        r = document.createElement("div"), r.style.display = "flex", r.style.flexWrap = "wrap";
        for (var n = 0, i = this._images; n < i.length; n++) {
          var o = i[n];
          switch (this.imageSize) {
            case Ke.ImageSize.Small:
              o.size = Ke.Size.Small;
              break;
            case Ke.ImageSize.Large:
              o.size = Ke.Size.Large;
              break;
            default:
              o.size = Ke.Size.Medium;
              break;
          }
          o.maxHeight = this.hostConfig.imageSet.maxImageHeight;
          var a = o.render();
          a && (a.style.display = "inline-flex", a.style.margin = "0px", this.presentationStyle == Ke.ImageSetPresentationStyle.Default && (a.style.marginRight = "10px"), lr.appendChild(r, a));
        }
        this.presentationStyle == Ke.ImageSetPresentationStyle.Stacked && this.applyStackedPresentationStyle();
      }
      return r;
    }, t.prototype.applyStackedPresentationStyle = function() {
      if (this._images[0].renderedImageElement) {
        var r = vee.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height), n = this.getEffectiveBackgroundColor();
        if (r) {
          var i = new vee(this.pixelOffset, r, n);
          i.configureImagesArrayAsStackedLayout(this._images);
        }
      }
    }, t.prototype.getEffectiveBackgroundColor = function() {
      var r = this.getParentContainer(), n = r == null ? void 0 : r.getEffectiveStyle(), i = this.hostConfig.containerStyles.getStyleByName(n, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
      return lr.stringToCssColor(i.backgroundColor);
    }, t.prototype.getItemCount = function() {
      return this._images.length;
    }, t.prototype.getItemAt = function(r) {
      return this._images[r];
    }, t.prototype.getFirstVisibleRenderedItem = function() {
      return this._images && this._images.length > 0 ? this._images[0] : void 0;
    }, t.prototype.getLastVisibleRenderedItem = function() {
      return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : void 0;
    }, t.prototype.removeItem = function(r) {
      if (r instanceof b1) {
        var n = this._images.indexOf(r);
        if (n >= 0)
          return this._images.splice(n, 1), r.setParent(void 0), this.updateLayout(), !0;
      }
      return !1;
    }, t.prototype.getJsonTypeName = function() {
      return "ImageSet";
    }, t.prototype.addImage = function(r) {
      if (!r.parent)
        this._images.push(r), r.setParent(this);
      else
        throw new Error("This image already belongs to another ImageSet");
    }, t.prototype.indexOf = function(r) {
      return r instanceof b1 ? this._images.indexOf(r) : -1;
    }, t.imagesProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_0, "images", b1, function(r, n) {
      n.setParent(r);
    }), t.imageSizeProperty = new pe.EnumProperty(pe.Versions.v1_0, "imageSize", Ke.ImageSize, Ke.ImageSize.Medium), t.imagePresentationStyle = new pe.EnumProperty(pe.Versions.v1_6, "style", Ke.ImageSetPresentationStyle, Ke.ImageSetPresentationStyle.Default), t.pixelOffset = new pe.NumProperty(pe.Versions.v1_6, "offset", 0, void 0), bt([
      (0, pe.property)(t.imagesProperty)
    ], t.prototype, "_images", void 0), bt([
      (0, pe.property)(t.imageSizeProperty)
    ], t.prototype, "imageSize", void 0), bt([
      (0, pe.property)(t.imagePresentationStyle)
    ], t.prototype, "presentationStyle", void 0), bt([
      (0, pe.property)(t.pixelOffset)
    ], t.prototype, "pixelOffset", void 0), t;
  }(S3)
);
Ct.ImageSet = X1e;
var vee = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.sign45 = 0.7071, this.maxImageCounts = 2, this.offset = 0, this.normalizationConstant = 0, this.border = 5, this.dimension = 0, this.dimension = r, this.normalizationConstant = (r * this.sign45 - 0.5 * r) * 2, this.offset = this.sign45 * (Math.max(t, -r) - this.normalizationConstant), this.style = n || "";
    }
    return e.prototype.moveImageRight = function(t) {
      t.style.marginLeft = this.offset + "px";
    }, e.prototype.moveImageUp = function(t) {
      t.style.marginBottom = this.offset + this.dimension + "px";
    }, e.prototype.moveImageDown = function(t) {
      t.style.marginTop = this.offset + this.dimension + "px";
    }, e.prototype.makeImageRound = function(t) {
      t.style.borderRadius = "50%", t.style.backgroundPosition = "50% 50%", t.style.backgroundRepeat = "no-repeat";
    }, e.prototype.applyBorder = function(t) {
      t.style.height = this.dimension + this.border * 2 + "px", t.style.border = this.border + "px solid " + this.style;
    }, e.prototype.configureImageForBottomLeft = function(t) {
      this.moveImageDown(t), this.makeImageRound(t), this.applyBorder(t), t.style.zIndex = "2";
    }, e.prototype.configureImageForTopRight = function(t) {
      this.moveImageUp(t), this.moveImageRight(t), this.makeImageRound(t), t.style.zIndex = "1";
    }, e.prototype.configureImagesArrayAsStackedLayout = function(t) {
      t.length == 1 ? t[0].renderedImageElement && this.makeImageRound(t[0].renderedImageElement) : t.length <= this.maxImageCounts && t[0].renderedImageElement && t[1].renderedImageElement && (this.configureImageForBottomLeft(t[0].renderedImageElement), this.configureImageForTopRight(t[1].renderedImageElement));
    }, e.parseNumericPixelDimension = function(t) {
      if ((t == null ? void 0 : t.substring(t.length - 2)) == "px")
        return parseInt(t.substring(0, t.length - 2));
    }, e;
  }()
), p7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this) || this;
      return i.url = r, i.mimeType = n, i;
    }
    return t.prototype.isValid = function() {
      return !!(this.mimeType && this.url);
    }, t.mimeTypeProperty = new pe.StringProperty(pe.Versions.v1_1, "mimeType"), t.urlProperty = new pe.StringProperty(pe.Versions.v1_1, "url"), bt([
      (0, pe.property)(t.mimeTypeProperty)
    ], t.prototype, "mimeType", void 0), bt([
      (0, pe.property)(t.urlProperty)
    ], t.prototype, "url", void 0), t;
  }(pe.SerializableObject)
);
Ct.ContentSource = p7;
var J1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n) || this;
      return o.label = i, o;
    }
    return t.prototype.getSchemaKey = function() {
      return "CaptionSource";
    }, t.prototype.render = function() {
      var r = void 0;
      return this.isValid() && (r = document.createElement("track"), r.src = this.url, r.kind = "captions", r.label = this.label), r;
    }, t.labelProperty = new pe.StringProperty(pe.Versions.v1_6, "label"), bt([
      (0, pe.property)(t.labelProperty)
    ], t.prototype, "label", void 0), t;
  }(p7)
);
Ct.CaptionSource = J1e;
var Z1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "MediaSource";
    }, t.prototype.render = function() {
      var r = void 0;
      return this.isValid() && (r = document.createElement("source"), r.src = this.url, r.type = this.mimeType), r;
    }, t;
  }(p7)
);
Ct.MediaSource = Z1e;
var h7 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.play = function() {
    }, Object.defineProperty(e.prototype, "posterUrl", {
      get: function() {
        return this._posterUrl;
      },
      set: function(t) {
        this._posterUrl = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "selectedMediaType", {
      get: function() {
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
Ct.MediaPlayer = h7;
var Q1e = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.owner = r, n._selectedSources = [], n._captionSources = [], n.processSources(), n;
    }
    return t.prototype.processSources = function() {
      var r;
      this._selectedSources = [], this._captionSources = [], this._selectedMediaType = void 0;
      for (var n = 0, i = this.owner.sources; n < i.length; n++) {
        var o = i[n], a = o.mimeType ? o.mimeType.split("/") : [];
        if (a.length === 2) {
          if (!this._selectedMediaType) {
            var u = t.supportedMediaTypes.indexOf(a[0]);
            u >= 0 && (this._selectedMediaType = t.supportedMediaTypes[u]);
          }
          a[0] === this._selectedMediaType && this._selectedSources.push(o);
        }
      }
      (r = this._captionSources).push.apply(r, this.owner.captionSources);
    }, t.prototype.canPlay = function() {
      return this._selectedSources.length > 0;
    }, t.prototype.fetchVideoDetails = function() {
      return Sy(this, void 0, void 0, function() {
        return by(this, function(r) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.render = function() {
      this._selectedMediaType === "video" ? this._mediaElement = document.createElement("video") : this._mediaElement = document.createElement("audio"), this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : fr.Strings.defaults.mediaPlayerAriaLabel()), this._mediaElement.setAttribute("webkit-playsinline", ""), this._mediaElement.setAttribute("playsinline", ""), this._mediaElement.setAttribute("crossorigin", ""), this._mediaElement.autoplay = !0, this._mediaElement.controls = !0, lr.isMobileOS() && (this._mediaElement.muted = !0), this._mediaElement.preload = "none", this._mediaElement.style.width = "100%";
      for (var r = 0, n = this.owner.sources; r < n.length; r++) {
        var i = n[r], o = i.render();
        lr.appendChild(this._mediaElement, o);
      }
      for (var a = 0, u = this.owner.captionSources; a < u.length; a++) {
        var s = u[a];
        if (s.mimeType == "vtt") {
          var c = s.render();
          lr.appendChild(this._mediaElement, c);
        }
      }
      return this._mediaElement;
    }, t.prototype.play = function() {
      this._mediaElement && this._mediaElement.play();
    }, Object.defineProperty(t.prototype, "selectedMediaType", {
      get: function() {
        return this._selectedMediaType;
      },
      enumerable: !1,
      configurable: !0
    }), t.supportedMediaTypes = ["audio", "video"], t;
  }(h7)
);
Ct.HTML5MediaPlayer = Q1e;
var eTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r) {
      return e.call(this) || this;
    }
    return t;
  }(h7)
);
Ct.CustomMediaPlayer = eTe;
var b3 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i.iFrameTitle = n, r.length >= 2 && (i._videoId = r[1]), i;
    }
    return t.prototype.canPlay = function() {
      return this._videoId !== void 0;
    }, t.prototype.render = function() {
      var r = document.createElement("div");
      r.style.position = "relative", r.style.width = "100%", r.style.height = "0", r.style.paddingBottom = "56.25%";
      var n = document.createElement("iframe");
      return n.style.position = "absolute", n.style.top = "0", n.style.left = "0", n.style.width = "100%", n.style.height = "100%", n.src = this.getEmbedVideoUrl(), n.frameBorder = "0", this.iFrameTitle && (n.title = this.iFrameTitle), n.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", n.allowFullscreen = !0, r.appendChild(n), r;
    }, Object.defineProperty(t.prototype, "videoId", {
      get: function() {
        return this._videoId;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(eTe)
);
Ct.IFrameMediaMediaPlayer = b3;
var tTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.fetchVideoDetails = function() {
      return Sy(this, void 0, void 0, function() {
        var r, n, i;
        return by(this, function(o) {
          switch (o.label) {
            case 0:
              return r = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl()), [4, fetch(r)];
            case 1:
              return n = o.sent(), n.ok ? [4, n.json()] : [3, 3];
            case 2:
              i = o.sent(), this.posterUrl = i.thumbnail_url, o.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getEmbedVideoUrl = function() {
      return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    }, t;
  }(b3)
);
Ct.VimeoPlayer = tTe;
var rTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.fetchVideoDetails = function() {
      return Sy(this, void 0, void 0, function() {
        var r, n, i;
        return by(this, function(o) {
          switch (o.label) {
            case 0:
              return r = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url"), [4, fetch(r)];
            case 1:
              return n = o.sent(), n.ok ? [4, n.json()] : [3, 3];
            case 2:
              i = o.sent(), this.posterUrl = i.thumbnail_720_url, o.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getEmbedVideoUrl = function() {
      return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    }, t;
  }(b3)
);
Ct.DailymotionPlayer = rTe;
var nTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.iFrameTitle = n, r.length >= 3 && r[2] !== void 0 && (i._startTimeIndex = parseInt(r[2])), i;
    }
    return t.prototype.fetchVideoDetails = function() {
      return Sy(this, void 0, void 0, function() {
        return by(this, function(r) {
          return this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : void 0, [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.getEmbedVideoUrl = function() {
      var r = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
      return this._startTimeIndex !== void 0 && (r += "&start=".concat(this._startTimeIndex)), r;
    }, t;
  }(b3)
);
Ct.YouTubePlayer = nTe;
var iTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.sources = [], r.captionSources = [], r;
    }
    return t.prototype.createMediaPlayer = function() {
      for (var r = 0, n = t.customMediaPlayers; r < n.length; r++)
        for (var i = n[r], o = 0, a = this.sources; o < a.length; o++) {
          var u = a[o];
          if (u.url)
            for (var s = 0, c = i.urlPatterns; s < c.length; s++) {
              var l = c[s], f = l.exec(u.url);
              if (f !== null)
                return i.createMediaPlayer(f);
            }
        }
      return new Q1e(this);
    }, t.prototype.handlePlayButtonInvoke = function(r) {
      if (this.hostConfig.media.allowInlinePlayback) {
        if (r.preventDefault(), r.cancelBubble = !0, this.renderedElement) {
          var n = this._mediaPlayer.render();
          HS(this.renderedElement), this.renderedElement.appendChild(n), this._mediaPlayer.play(), n.focus();
        }
      } else
        t.onPlay && (r.preventDefault(), r.cancelBubble = !0, t.onPlay(this));
    }, t.prototype.displayPoster = function() {
      return Sy(this, void 0, void 0, function() {
        var r, n, i, o, a, u, s, c, l = this;
        return by(this, function(f) {
          return this.renderedElement && (r = 12, n = 15, i = document.createElement("div"), i.className = this.hostConfig.makeCssClassName("ac-media-poster"), i.setAttribute("role", "contentinfo"), i.setAttribute("aria-label", this.altText ? this.altText : fr.Strings.defaults.mediaPlayerAriaLabel()), i.style.position = "relative", i.style.display = "flex", o = this.poster ? this.poster : this._mediaPlayer.posterUrl, o || (o = this.hostConfig.media.defaultPoster), o ? (a = document.createElement("img"), a.style.width = "100%", a.style.height = "100%", a.setAttribute("role", "presentation"), a.onerror = function(d) {
            a.parentNode && a.parentNode.removeChild(a), i.classList.add("empty"), i.style.minHeight = "150px";
          }, a.src = o, i.appendChild(a)) : (i.classList.add("empty"), i.style.minHeight = "150px"), this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay() && (u = document.createElement("div"), u.tabIndex = 0, u.setAttribute("role", "button"), u.setAttribute("aria-label", fr.Strings.defaults.mediaPlayerPlayMedia()), u.className = this.hostConfig.makeCssClassName("ac-media-playButton"), u.style.display = "flex", u.style.alignItems = "center", u.style.justifyContent = "center", u.onclick = function(d) {
            l.handlePlayButtonInvoke(d);
          }, u.onkeypress = function(d) {
            (d.code === "Enter" || d.code === "Space") && l.handlePlayButtonInvoke(d);
          }, s = document.createElement("div"), s.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow"), s.style.width = r + "px", s.style.height = n + "px", s.style.borderTopWidth = n / 2 + "px", s.style.borderBottomWidth = n / 2 + "px", s.style.borderLeftWidth = r + "px", s.style.borderRightWidth = "0", s.style.borderStyle = "solid", s.style.borderTopColor = "transparent", s.style.borderRightColor = "transparent", s.style.borderBottomColor = "transparent", s.style.transform = "translate(" + r / 10 + "px,0px)", u.appendChild(s), c = document.createElement("div"), c.style.position = "absolute", c.style.left = "0", c.style.top = "0", c.style.width = "100%", c.style.height = "100%", c.style.display = "flex", c.style.justifyContent = "center", c.style.alignItems = "center", c.appendChild(u), i.appendChild(c)), HS(this.renderedElement), this.renderedElement.appendChild(i)), [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.internalRender = function() {
      var r = document.createElement("div");
      return r.className = this.hostConfig.makeCssClassName("ac-media"), r;
    }, t.prototype.render = function() {
      var r = this, n = e.prototype.render.call(this);
      return n && (this._mediaPlayer = this.createMediaPlayer(), this._mediaPlayer.fetchVideoDetails().then(function() {
        return r.displayPoster();
      })), n;
    }, t.prototype.releaseDOMResources = function() {
      e.prototype.releaseDOMResources.call(this), this.displayPoster();
    }, t.prototype.getJsonTypeName = function() {
      return "Media";
    }, t.prototype.getResourceInformation = function() {
      var r = [];
      if (this._mediaPlayer) {
        var n = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
        n && r.push({ url: n, mimeType: "image" });
      }
      for (var i = 0, o = this.sources; i < o.length; i++) {
        var a = o[i];
        a.isValid() && r.push({
          /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */
          url: a.url,
          mimeType: a.mimeType
          /* eslint-enable @typescript-eslint/no-unnecessary-type-assertion */
        });
      }
      for (var u = 0, s = this.captionSources; u < s.length; u++) {
        var c = s[u];
        c.isValid() && r.push({
          /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */
          url: c.url,
          mimeType: c.mimeType
          /* eslint-enable @typescript-eslint/no-unnecessary-type-assertion */
        });
      }
      return r;
    }, Object.defineProperty(t.prototype, "selectedMediaType", {
      get: function() {
        return this._mediaPlayer.selectedMediaType;
      },
      enumerable: !1,
      configurable: !0
    }), t.customMediaPlayers = [
      {
        urlPatterns: [
          /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
          /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
        ],
        createMediaPlayer: function(r) {
          return new nTe(r, fr.Strings.defaults.youTubeVideoPlayer());
        }
      },
      {
        urlPatterns: [/^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi],
        createMediaPlayer: function(r) {
          return new tTe(r, fr.Strings.defaults.vimeoVideoPlayer());
        }
      },
      {
        urlPatterns: [/^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi],
        createMediaPlayer: function(r) {
          return new rTe(r, fr.Strings.defaults.dailymotionVideoPlayer());
        }
      }
    ], t.sourcesProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_1, "sources", Z1e), t.captionSourcesProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_6, "captionSources", J1e), t.posterProperty = new pe.StringProperty(pe.Versions.v1_1, "poster"), t.altTextProperty = new pe.StringProperty(pe.Versions.v1_1, "altText"), bt([
      (0, pe.property)(t.sourcesProperty)
    ], t.prototype, "sources", void 0), bt([
      (0, pe.property)(t.captionSourcesProperty)
    ], t.prototype, "captionSources", void 0), bt([
      (0, pe.property)(t.posterProperty)
    ], t.prototype, "poster", void 0), bt([
      (0, pe.property)(t.altTextProperty)
    ], t.prototype, "altText", void 0), t;
  }(na)
);
Ct.Media = iTe;
var Ru;
(function(e) {
  e[e.InitialRender = 0] = "InitialRender", e[e.MouseEnterOnCard = 1] = "MouseEnterOnCard", e[e.MouseLeaveOnCard = 2] = "MouseLeaveOnCard", e[e.FocusLeave = 3] = "FocusLeave";
})(Ru || (Ru = {}));
var pd = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.inputStyle = Ke.InputStyle.Default, r;
    }
    return t.prototype.getAllLabelIds = function() {
      var r = [];
      return this.labelledBy && r.push(this.labelledBy), this._renderedLabelElement && r.push(this._renderedLabelElement.id), this._renderedErrorMessageElement && r.push(this._renderedErrorMessageElement.id), r;
    }, t.prototype.updateInputControlAriaLabelledBy = function() {
      if (this._renderedInputControlElement) {
        var r = this.getAllLabelIds();
        r.length > 0 ? this._renderedInputControlElement.setAttribute("aria-labelledby", r.join(" ")) : this._renderedInputControlElement.removeAttribute("aria-labelledby");
      }
    }, Object.defineProperty(t.prototype, "isNullable", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "renderedInputControlElement", {
      get: function() {
        return this._renderedInputControlElement;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "inputControlContainerElement", {
      get: function() {
        return this._inputControlContainerElement;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.overrideInternalRender = function() {
      var r = this, n = this.hostConfig;
      this._outerContainerElement = document.createElement("div"), this._outerContainerElement.style.display = "flex", this.labelPosition === Ke.InputLabelPosition.Inline ? this._outerContainerElement.style.flexDirection = "row" : this._outerContainerElement.style.flexDirection = "column";
      var i = lr.generateUniqueId();
      if (this.label) {
        var o = new d7();
        o.setParent(this), o.forElementId = i;
        var a = new Wp(this.label);
        if (o.addInline(a), this.isRequired) {
          a.init(n.inputs.label.requiredInputs);
          var u = new Wp(n.inputs.label.requiredInputs.suffix);
          u.color = n.inputs.label.requiredInputs.suffixColor, u.ariaHidden = !0, o.addInline(u);
        } else
          a.init(n.inputs.label.optionalInputs);
        this._renderedLabelElement = o.render(), this._renderedLabelElement && (this._renderedLabelElement.id = lr.generateUniqueId(), this.labelPosition === Ke.InputLabelPosition.Inline ? this._renderedLabelElement.style.alignSelf = "center" : this._renderedLabelElement.style.marginBottom = n.getEffectiveSpacing(n.inputs.label.inputSpacing) + "px", this._outerContainerElement.appendChild(this._renderedLabelElement));
      }
      if (this._inputControlContainerElement = document.createElement("div"), this._inputControlContainerElement.className = n.makeCssClassName("ac-input-container"), this._inputControlContainerElement.style.display = "flex", this.height === "stretch" && (this._inputControlContainerElement.style.alignItems = "stretch", this._inputControlContainerElement.style.flex = "1 1 auto"), this._renderedInputControlElement = this.internalRender(), this._renderedInputControlElement) {
        if (this._renderedInputControlElement.id = i, this._renderedInputControlElement.style.minWidth = "0px", this.isNullable && this.isRequired && (this._renderedInputControlElement.setAttribute("aria-required", "true"), this._renderedInputControlElement.classList.add(n.makeCssClassName("ac-input-required"))), this._inputControlContainerElement.appendChild(this._renderedInputControlElement), this._outerContainerElement.appendChild(this._inputControlContainerElement), this._renderedLabelElement && this.labelPosition === Ke.InputLabelPosition.Inline)
          if (this.labelWidth) {
            if (this.labelWidth.unit == Ke.SizeUnit.Weight) {
              var c = this.labelWidth.physicalSize;
              this._renderedLabelElement.style.width = c.toString() + "%", this._inputControlContainerElement.style.width = (100 - c).toString() + "%";
            } else if (this.labelWidth.unit == Ke.SizeUnit.Pixel) {
              var l = this.labelWidth.physicalSize;
              this._renderedLabelElement.style.width = l.toString() + "px";
            }
          } else {
            var s = n.inputs.label.width;
            this._renderedLabelElement.style.width = s.toString() + "%", this._inputControlContainerElement.style.width = 100 - s + "%";
          }
        return this.updateVisualState(Ru.InitialRender), this._renderedInputControlElement && (this._renderedInputControlElement.onblur = function(f) {
          r.updateVisualState(Ru.FocusLeave);
        }), this.updateInputControlAriaLabelledBy(), this._outerContainerElement;
      }
      this.resetDirtyState();
    }, t.prototype.valueChanged = function() {
      this.getRootElement().updateActionsEnabledState(), this.isValid() && this.resetValidationFailureCue(), this.onValueChanged && this.onValueChanged(this), nnr(this);
    }, t.prototype.resetValidationFailureCue = function() {
      this.renderedInputControlElement && (this instanceof Z1 && this.isDynamicTypeahead() ? this.removeValidationFailureCue() : this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed")), this.updateInputControlAriaLabelledBy(), this._renderedErrorMessageElement && (this._outerContainerElement.removeChild(this._renderedErrorMessageElement), this._renderedErrorMessageElement = void 0));
    }, t.prototype.showValidationErrorMessage = function() {
      if (this.renderedElement && this.errorMessage && Ir.GlobalSettings.displayInputValidationErrors) {
        var r = new Nf();
        r.setParent(this), r.text = this.errorMessage, r.wrap = !0, r.init(this.hostConfig.inputs.errorMessage), this._renderedErrorMessageElement = r.render(), this._renderedErrorMessageElement && (this._renderedErrorMessageElement.id = lr.generateUniqueId(), this._outerContainerElement.appendChild(this._renderedErrorMessageElement), this.updateInputControlAriaLabelledBy());
      }
    }, Object.defineProperty(t.prototype, "allowRevealOnHoverStyle", {
      get: function() {
        return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.shouldHideInputAdornersForRevealOnHover = function(r, n) {
      var i = r === document.activeElement, o = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"), a = r.classList.contains(o), u = n === Ru.InitialRender || n === Ru.FocusLeave && !a || n === Ru.MouseLeaveOnCard && !i;
      return u;
    }, t.prototype.updateVisualState = function(r) {
      !this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== Ke.InputStyle.RevealOnHover || (r === Ru.InitialRender ? this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender")) : r === Ru.MouseEnterOnCard ? this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover")) : r === Ru.MouseLeaveOnCard && this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover")));
    }, t.prototype.focus = function() {
      this._renderedInputControlElement && this._renderedInputControlElement.focus();
    }, t.prototype.isValid = function() {
      return !0;
    }, t.prototype.isDirty = function() {
      return this.value !== this._oldValue;
    }, t.prototype.resetDirtyState = function() {
      this._oldValue = this.value;
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.id || r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.inputsMustHaveUniqueId()), this.isRequired && (this.label || r.addFailure(this, Ke.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label"), this.errorMessage || r.addFailure(this, Ke.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message"));
    }, t.prototype.validateValue = function() {
      this.resetValidationFailureCue();
      var r = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
      return !r && this.renderedInputControlElement && (this instanceof Z1 && this.isDynamicTypeahead() ? this.showValidationFailureCue() : this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed")), this.showValidationErrorMessage()), r;
    }, t.prototype.getAllInputs = function(r) {
      return [this];
    }, t.prototype.render = function() {
      var r = e.prototype.render.call(this);
      return this.resetDirtyState(), r;
    }, Object.defineProperty(t.prototype, "isInteractive", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.labelProperty = new pe.StringProperty(pe.Versions.v1_3, "label", !0), t.isRequiredProperty = new pe.BoolProperty(pe.Versions.v1_3, "isRequired", !1), t.errorMessageProperty = new pe.StringProperty(pe.Versions.v1_3, "errorMessage", !0), t.inputStyleProperty = new pe.EnumProperty(pe.Versions.v1_6, "inputStyle", Ke.InputStyle, Ke.InputStyle.Default, [
      { value: Ke.InputStyle.RevealOnHover },
      { value: Ke.InputStyle.Default }
    ]), t.labelWidthProperty = new pe.CustomProperty(pe.Versions.v1_6, "labelWidth", function(r, n, i, o) {
      var a = n.defaultValue, u = i[n.name], s = !1;
      if (typeof u == "number" && !isNaN(u))
        a = new Ir.SizeAndUnit(u, Ke.SizeUnit.Weight), (a.physicalSize < 0 || a.physicalSize > 100) && (s = !0);
      else if (typeof u == "string")
        try {
          a = Ir.SizeAndUnit.parse(u);
        } catch {
          s = !0;
        }
      else
        s = !0;
      return s && (o.logParseEvent(r, Ke.ValidationEvent.InvalidPropertyValue, fr.Strings.errors.invalidInputLabelWidth()), a = void 0), a;
    }, function(r, n, i, o, a) {
      o instanceof Ir.SizeAndUnit && (o.unit === Ke.SizeUnit.Pixel ? a.serializeValue(i, "labelWidth", o.physicalSize + "px") : a.serializeNumber(i, "labelWidth", o.physicalSize));
    }, void 0), t.labelPositionProperty = new pe.EnumProperty(pe.Versions.v1_6, "labelPosition", Ke.InputLabelPosition, Ke.InputLabelPosition.Above, [
      { value: Ke.InputLabelPosition.Inline },
      { value: Ke.InputLabelPosition.Above }
    ]), bt([
      (0, pe.property)(t.labelProperty)
    ], t.prototype, "label", void 0), bt([
      (0, pe.property)(t.isRequiredProperty)
    ], t.prototype, "isRequired", void 0), bt([
      (0, pe.property)(t.errorMessageProperty)
    ], t.prototype, "errorMessage", void 0), bt([
      (0, pe.property)(t.inputStyleProperty)
    ], t.prototype, "inputStyle", void 0), bt([
      (0, pe.property)(t.labelWidthProperty)
    ], t.prototype, "labelWidth", void 0), bt([
      (0, pe.property)(t.labelPositionProperty)
    ], t.prototype, "labelPosition", void 0), t;
  }(na)
);
Ct.Input = pd;
var oTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.isMultiline = !1, r.style = Ke.InputTextStyle.Text, r;
    }
    return t.prototype.setupInput = function(r) {
      var n = this;
      r.style.flex = "1 1 auto", r.tabIndex = this.isDesignMode() ? -1 : 0, this.placeholder && (r.placeholder = this.placeholder, r.setAttribute("aria-label", this.placeholder)), this.defaultValue && (r.value = this.defaultValue), this.maxLength && this.maxLength > 0 && (r.maxLength = this.maxLength), r.oninput = function() {
        n.valueChanged();
      }, r.onkeypress = function(i) {
        i.ctrlKey && i.code === "Enter" && n.inlineAction && n.inlineAction.isEffectivelyEnabled() && n.inlineAction.execute();
      };
    }, t.prototype.internalRender = function() {
      var r;
      return this.isMultiline && this.style !== Ke.InputTextStyle.Password ? (r = document.createElement("textarea"), r.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline"), this.height === "stretch" && (r.style.height = "initial")) : (r = document.createElement("input"), r.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput"), r.type = Ke.InputTextStyle[this.style].toLowerCase()), this.setupInput(r), r;
    }, t.prototype.overrideInternalRender = function() {
      var r = this, n = e.prototype.overrideInternalRender.call(this);
      if (this.inlineAction) {
        var i = document.createElement("button");
        if (i.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled"), i.onclick = function(a) {
          r.inlineAction && r.inlineAction.isEffectivelyEnabled() && (a.preventDefault(), a.cancelBubble = !0, r.inlineAction.execute());
        }, this.inlineAction.iconUrl) {
          i.classList.add("iconOnly");
          var o = document.createElement("img");
          o.style.height = "100%", o.setAttribute("role", "presentation"), o.style.display = "none", o.onload = function() {
            o.style.removeProperty("display");
          }, o.onerror = function() {
            i.removeChild(o), i.classList.remove("iconOnly"), i.classList.add("textOnly"), i.textContent = r.inlineAction && r.inlineAction.title ? r.inlineAction.title : fr.Strings.defaults.inlineActionTitle();
          }, o.src = this.inlineAction.iconUrl, i.appendChild(o), i.title = this.inlineAction.title ? this.inlineAction.title : fr.Strings.defaults.inlineActionTitle();
        } else
          i.classList.add("textOnly"), i.textContent = this.inlineAction.title ? this.inlineAction.title : fr.Strings.defaults.inlineActionTitle();
        this.inlineAction.setupElementForAccessibility(i, !0), i.style.marginLeft = "8px", this.inputControlContainerElement.appendChild(i);
      }
      return n;
    }, t.prototype.updateVisualState = function(r) {
      this.allowRevealOnHoverStyle && (this.inlineAction || this.isMultiline || e.prototype.updateVisualState.call(this, r));
    }, t.prototype.getJsonTypeName = function() {
      return "Input.Text";
    }, t.prototype.getAllActions = function() {
      var r = e.prototype.getAllActions.call(this);
      return this.inlineAction && r.push(this.inlineAction), r;
    }, t.prototype.getActionById = function(r) {
      var n = e.prototype.getActionById.call(this, r);
      return !n && this.inlineAction && (n = this.inlineAction.getActionById(r)), n;
    }, t.prototype.isSet = function() {
      return !!this.value;
    }, t.prototype.isValid = function() {
      return this.value && this.regex ? new RegExp(this.regex, "g").test(this.value) : !0;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        if (this.renderedInputControlElement)
          return this.isMultiline ? this.renderedInputControlElement.value : this.renderedInputControlElement.value;
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), t.maxLengthProperty = new pe.NumProperty(pe.Versions.v1_0, "maxLength"), t.isMultilineProperty = new pe.BoolProperty(pe.Versions.v1_0, "isMultiline", !1), t.placeholderProperty = new pe.StringProperty(pe.Versions.v1_0, "placeholder"), t.styleProperty = new pe.EnumProperty(pe.Versions.v1_0, "style", Ke.InputTextStyle, Ke.InputTextStyle.Text, [
      { value: Ke.InputTextStyle.Text },
      { value: Ke.InputTextStyle.Tel },
      { value: Ke.InputTextStyle.Url },
      { value: Ke.InputTextStyle.Email },
      { value: Ke.InputTextStyle.Password, targetVersion: pe.Versions.v1_5 }
    ]), t.inlineActionProperty = new Cy(pe.Versions.v1_0, "inlineAction", [
      "Action.ShowCard"
    ]), t.regexProperty = new pe.StringProperty(pe.Versions.v1_3, "regex", !0), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.maxLengthProperty)
    ], t.prototype, "maxLength", void 0), bt([
      (0, pe.property)(t.isMultilineProperty)
    ], t.prototype, "isMultiline", void 0), bt([
      (0, pe.property)(t.placeholderProperty)
    ], t.prototype, "placeholder", void 0), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", void 0), bt([
      (0, pe.property)(t.inlineActionProperty)
    ], t.prototype, "inlineAction", void 0), bt([
      (0, pe.property)(t.regexProperty)
    ], t.prototype, "regex", void 0), t;
  }(pd)
);
Ct.TextInput = oTe;
var aTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.valueOn = "true", r.valueOff = "false", r.wrap = !1, r;
    }
    return t.prototype.updateInputControlAriaLabelledBy = function() {
      if (this._checkboxInputElement) {
        var r = this.getAllLabelIds().join(" ");
        this._checkboxInputLabelElement && this._checkboxInputLabelElement.id && (r += " " + this._checkboxInputLabelElement.id), r ? this._checkboxInputElement.setAttribute("aria-labelledby", r) : this._checkboxInputElement.removeAttribute("aria-labelledby");
      }
    }, t.prototype.internalRender = function() {
      var r = this, n = document.createElement("div");
      if (n.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput"), n.style.width = "100%", n.style.display = "flex", n.style.alignItems = "center", this._checkboxInputElement = document.createElement("input"), this._checkboxInputElement.id = lr.generateUniqueId(), this._checkboxInputElement.type = "checkbox", this._checkboxInputElement.style.display = "inline-block", this._checkboxInputElement.style.verticalAlign = "middle", this._checkboxInputElement.style.margin = "0", this._checkboxInputElement.style.flex = "0 0 auto", this.title && this._checkboxInputElement.setAttribute("aria-label", this.title), this.isRequired && this._checkboxInputElement.setAttribute("aria-required", "true"), this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0, this.defaultValue === this.valueOn && (this._checkboxInputElement.checked = !0), this._oldCheckboxValue = this._checkboxInputElement.checked, this._checkboxInputElement.onchange = function() {
        r.valueChanged();
      }, lr.appendChild(n, this._checkboxInputElement), this.title || this.isDesignMode()) {
        var i = new Nf();
        if (i.setParent(this), i.forElementId = this._checkboxInputElement.id, i.hostConfig = this.hostConfig, i.text = this.title ? this.title : this.getJsonTypeName(), i.useMarkdown = Ir.GlobalSettings.useMarkdownInRadioButtonAndCheckbox, i.wrap = this.wrap, this._checkboxInputLabelElement = i.render(), this._checkboxInputLabelElement) {
          this._checkboxInputLabelElement.id = lr.generateUniqueId(), this._checkboxInputLabelElement.style.display = "inline-block", this._checkboxInputLabelElement.style.flex = "1 1 auto", this._checkboxInputLabelElement.style.marginLeft = "6px", this._checkboxInputLabelElement.style.verticalAlign = "middle";
          var o = document.createElement("div");
          o.style.width = "6px", lr.appendChild(n, o), lr.appendChild(n, this._checkboxInputLabelElement);
        }
      }
      return n;
    }, Object.defineProperty(t.prototype, "isNullable", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateVisualState = function(r) {
    }, t.prototype.getJsonTypeName = function() {
      return "Input.Toggle";
    }, t.prototype.focus = function() {
      this._checkboxInputElement && this._checkboxInputElement.focus();
    }, t.prototype.isSet = function() {
      return this.isRequired ? this.value === this.valueOn : !!this.value;
    }, t.prototype.isDirty = function() {
      return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : !1;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        if (this._checkboxInputElement)
          return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), t.titleProperty = new pe.StringProperty(pe.Versions.v1_0, "title"), t.valueOnProperty = new pe.StringProperty(pe.Versions.v1_0, "valueOn", !0, void 0, "true", function(r) {
      return "true";
    }), t.valueOffProperty = new pe.StringProperty(pe.Versions.v1_0, "valueOff", !0, void 0, "false", function(r) {
      return "false";
    }), t.wrapProperty = new pe.BoolProperty(pe.Versions.v1_2, "wrap", !1), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.titleProperty)
    ], t.prototype, "title", void 0), bt([
      (0, pe.property)(t.valueOnProperty)
    ], t.prototype, "valueOn", void 0), bt([
      (0, pe.property)(t.valueOffProperty)
    ], t.prototype, "valueOff", void 0), bt([
      (0, pe.property)(t.wrapProperty)
    ], t.prototype, "wrap", void 0), t;
  }(pd)
);
Ct.ToggleInput = aTe;
var uTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this) || this;
      return i.title = r, i.value = n, i;
    }
    return t.prototype.getSchemaKey = function() {
      return "Choice";
    }, t.titleProperty = new pe.StringProperty(pe.Versions.v1_0, "title"), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), bt([
      (0, pe.property)(t.titleProperty)
    ], t.prototype, "title", void 0), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "value", void 0), t;
  }(pe.SerializableObject)
);
Ct.Choice = uTe;
var sTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "choices.data";
    }, t.typeProperty = new pe.StringProperty(pe.Versions.v1_6, "type", !0, new RegExp("^Data.Query$")), t.datasetProperty = new pe.StringProperty(pe.Versions.v1_6, "dataset"), t.countProperty = new pe.NumProperty(pe.Versions.v1_6, "count"), t.skipProperty = new pe.NumProperty(pe.Versions.v1_6, "skip"), bt([
      (0, pe.property)(t.typeProperty)
    ], t.prototype, "type", void 0), bt([
      (0, pe.property)(t.datasetProperty)
    ], t.prototype, "dataset", void 0), bt([
      (0, pe.property)(t.countProperty)
    ], t.prototype, "count", void 0), bt([
      (0, pe.property)(t.skipProperty)
    ], t.prototype, "skip", void 0), t;
  }(pe.SerializableObject)
);
Ct.ChoiceSetInputDataQuery = sTe;
var Z1 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.isMultiSelect = !1, r.wrap = !1, r.choices = [], r;
    }
    return Object.defineProperty(t.prototype, "isCompact", {
      get: function() {
        return !this.style || this.style === "compact";
      },
      set: function(r) {
        this.style = r ? void 0 : "expanded";
      },
      enumerable: !1,
      configurable: !0
    }), t.getUniqueCategoryName = function() {
      var r = "__ac-category" + t._uniqueCategoryCounter;
      return t._uniqueCategoryCounter++, r;
    }, t.prototype.isDynamicTypeahead = function() {
      return this.hostConfig.inputs.allowDynamicallyFilteredChoiceSet && !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
    }, t.prototype.getFilterForDynamicSearch = function() {
      var r;
      return (r = this._textInput) === null || r === void 0 ? void 0 : r.value;
    }, t.prototype.getDropdownElement = function() {
      var r;
      return (r = this._filteredChoiceSet) === null || r === void 0 ? void 0 : r.dropdown;
    }, t.prototype.renderChoices = function(r, n) {
      var i;
      (i = this._filteredChoiceSet) === null || i === void 0 || i.processResponse(r, n);
    }, t.prototype.showLoadingIndicator = function() {
      var r;
      (r = this._filteredChoiceSet) === null || r === void 0 || r.showLoadingIndicator();
    }, t.prototype.removeLoadingIndicator = function() {
      var r;
      (r = this._filteredChoiceSet) === null || r === void 0 || r.removeLoadingIndicator();
    }, t.prototype.showErrorIndicator = function(r, n) {
      var i;
      (i = this._filteredChoiceSet) === null || i === void 0 || i.showErrorIndicator(r, n);
    }, t.prototype.showValidationFailureCue = function() {
      var r;
      (r = this._textInput) === null || r === void 0 || r.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    }, t.prototype.removeValidationFailureCue = function() {
      var r;
      (r = this._textInput) === null || r === void 0 || r.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    }, t.prototype.createPlaceholderOptionWhenValueDoesNotExist = function() {
      if (!this.value) {
        var r = document.createElement("option");
        return r.selected = !0, r.disabled = !0, r.hidden = !0, r.value = "", this.placeholder && (r.text = this.placeholder), r;
      }
    }, t.prototype.internalApplyAriaCurrent = function() {
      if (this._selectElement) {
        var r = this._selectElement.options;
        if (r)
          for (var n = 0, i = Array.from(r); n < i.length; n++) {
            var o = i[n];
            o.selected ? o.setAttribute("aria-current", "true") : o.removeAttribute("aria-current");
          }
      }
    }, t.prototype.renderCompoundInput = function(r, n, i) {
      var o = this, a = document.createElement("div");
      a.className = this.hostConfig.makeCssClassName("ac-input", r), a.style.width = "100%", a.tabIndex = this.isDesignMode() ? -1 : 0, this._toggleInputs = [], this._labels = [];
      for (var u = 0, s = this.choices; u < s.length; u++) {
        var c = s[u], l = document.createElement("input");
        l.id = lr.generateUniqueId(), l.type = n, l.style.margin = "0", l.style.display = "inline-block", l.style.verticalAlign = "middle", l.style.flex = "0 0 auto", l.name = this.id ? this.id : this._uniqueCategoryName, this.isRequired && l.setAttribute("aria-required", "true"), l.tabIndex = this.isDesignMode() ? -1 : 0, c.value && (l.value = c.value), c.title && l.setAttribute("aria-label", c.title), i && c.value && i.indexOf(c.value) >= 0 && (l.checked = !0), l.onchange = function() {
          o.valueChanged();
        }, this._toggleInputs.push(l);
        var f = document.createElement("div");
        f.style.display = "flex", f.style.alignItems = "center", lr.appendChild(f, l);
        var d = new Nf();
        d.setParent(this), d.forElementId = l.id, d.hostConfig = this.hostConfig, d.text = c.title ? c.title : "Choice " + this._toggleInputs.length, d.useMarkdown = Ir.GlobalSettings.useMarkdownInRadioButtonAndCheckbox, d.wrap = this.wrap;
        var p = d.render();
        if (this._labels.push(p), p) {
          p.id = lr.generateUniqueId(), p.style.display = "inline-block", p.style.flex = "1 1 auto", p.style.marginLeft = "6px", p.style.verticalAlign = "middle";
          var v = document.createElement("div");
          v.style.width = "6px", lr.appendChild(f, v), lr.appendChild(f, p);
        }
        lr.appendChild(a, f);
      }
      return a;
    }, t.prototype.updateInputControlAriaLabelledBy = function() {
      if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels)
        for (var r = this.getAllLabelIds(), n = 0; n < this._toggleInputs.length; n++) {
          var i = r.join(" "), o = this._labels[n];
          o && o.id && (i += " " + o.id), i ? this._toggleInputs[n].setAttribute("aria-labelledby", i) : this._toggleInputs[n].removeAttribute("aria-labelledby");
        }
      else
        e.prototype.updateInputControlAriaLabelledBy.call(this);
    }, t.prototype.internalRender = function() {
      var r = this;
      if (this._uniqueCategoryName = t.getUniqueCategoryName(), this.isDynamicTypeahead()) {
        var n = new cTe(t._uniqueCategoryCounter, this.choices, this.hostConfig);
        if (n.render(), n.textInput) {
          this._textInput = n.textInput, this.defaultValue && (this._textInput.value = this.defaultValue), this.placeholder && !this._textInput.value && (this._textInput.placeholder = this.placeholder, this._textInput.setAttribute("aria-label", this.placeholder)), this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
          var i = lr.debounce(function() {
            n.processChoices(), r.valueChanged(), r._textInput && (r.value ? (r._textInput.removeAttribute("placeholder"), r._textInput.removeAttribute("aria-label")) : r.placeholder && (r._textInput.placeholder = r.placeholder, r._textInput.setAttribute("aria-label", r.placeholder)));
          }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
          this._textInput.onclick = i, this._textInput.oninput = i;
        }
        return n.parent = this, this._filteredChoiceSet = n, n.renderedElement;
      } else {
        if (this.isMultiSelect)
          return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : void 0);
        if (this.style === "expanded")
          return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [this.defaultValue] : void 0);
        if (this.style === "filtered") {
          var o = document.createElement("div");
          o.style.width = "100%", this._textInput = document.createElement("input"), this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered"), this._textInput.type = "text", this._textInput.style.width = "100%", this._textInput.oninput = function() {
            r.valueChanged(), r._textInput && (r.value ? (r._textInput.removeAttribute("placeholder"), r._textInput.removeAttribute("aria-label")) : r.placeholder && (r._textInput.placeholder = r.placeholder, r._textInput.setAttribute("aria-label", r.placeholder)));
          }, this.defaultValue && (this._textInput.value = this.defaultValue), this.placeholder && !this._textInput.value && (this._textInput.placeholder = this.placeholder, this._textInput.setAttribute("aria-label", this.placeholder)), this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
          var a = document.createElement("datalist");
          a.id = lr.generateUniqueId();
          for (var u = 0, s = this.choices; u < s.length; u++) {
            var c = s[u], l = document.createElement("option");
            c.title && (l.value = c.title, l.setAttribute("aria-label", c.title)), l.tabIndex = this.isDesignMode() ? -1 : 0, a.appendChild(l);
          }
          return this._textInput.setAttribute("list", a.id), o.append(this._textInput, a), o;
        } else {
          this._selectElement = document.createElement("select"), this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact"), this._selectElement.style.width = "100%", this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
          var f = this.createPlaceholderOptionWhenValueDoesNotExist();
          lr.appendChild(this._selectElement, f);
          for (var d = 0, p = this.choices; d < p.length; d++) {
            var c = p[d], l = document.createElement("option");
            l.value = c.value, c.title && (l.text = c.title, l.setAttribute("aria-label", c.title)), l.tabIndex = this.isDesignMode() ? -1 : 0, c.value === this.defaultValue && (l.selected = !0), lr.appendChild(this._selectElement, l);
          }
          return this._selectElement.onchange = function() {
            r.internalApplyAriaCurrent(), r.valueChanged();
          }, this.internalApplyAriaCurrent(), this._selectElement;
        }
      }
    }, t.prototype.updateVisualState = function(r) {
      if (this.allowRevealOnHoverStyle && !this.isMultiSelect && this.isCompact && (e.prototype.updateVisualState.call(this, r), this._selectElement && this.inputStyle === Ke.InputStyle.RevealOnHover)) {
        var n = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, r);
        n ? (this._selectElement.style.appearance = "none", this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"))) : (this._selectElement.style.appearance = "auto", this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus")));
      }
    }, t.prototype.getJsonTypeName = function() {
      return "Input.ChoiceSet";
    }, t.prototype.focus = function() {
      this._toggleInputs && (this.isMultiSelect || this.style === "expanded") ? this._toggleInputs.length > 0 && this._toggleInputs[0].focus() : this._textInput ? this._textInput.focus() : e.prototype.focus.call(this);
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.choices.length === 0 && r.addFailure(this, Ke.ValidationEvent.CollectionCantBeEmpty, fr.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
      for (var n = 0, i = this.choices; n < i.length; n++) {
        var o = i[n];
        (!o.title || !o.value) && r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
      }
    }, t.prototype.isSet = function() {
      return !!this.value;
    }, t.prototype.isValid = function() {
      if (this._textInput) {
        if (this.value === "" || this.value === this.placeholder)
          return !0;
        for (var r = 0, n = this.choices; r < n.length; r++) {
          var i = n[r];
          if (this.value === i.value)
            return !0;
        }
        if (this.dynamicChoices)
          for (var o = 0, a = this.dynamicChoices; o < a.length; o++) {
            var i = a[o];
            if (this.value === i)
              return !0;
          }
        return !1;
      }
      return e.prototype.isValid.call(this);
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        if (this.isMultiSelect) {
          if (!this._toggleInputs || this._toggleInputs.length === 0)
            return;
          for (var s = "", c = 0, l = this._toggleInputs; c < l.length; c++) {
            var u = l[c];
            u.checked && (s !== "" && (s += this.hostConfig.choiceSetInputValueSeparator), s += u.value);
          }
          return s || void 0;
        } else {
          if (this._selectElement)
            return this._selectElement.selectedIndex > 0 ? this._selectElement.value : void 0;
          if (this._textInput) {
            for (var r = 0, n = this.choices; r < n.length; r++) {
              var i = n[r];
              if (i.title && this._textInput.value === i.title)
                return i.value;
            }
            return this._textInput.value;
          } else if (this._toggleInputs && this._toggleInputs.length > 0)
            for (var o = 0, a = this._toggleInputs; o < a.length; o++) {
              var u = a[o];
              if (u.checked)
                return u.value;
            }
          return;
        }
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "dynamicChoices", {
      get: function() {
        var r;
        return (r = this._filteredChoiceSet) === null || r === void 0 ? void 0 : r.dynamicChoices;
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), t.choicesProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_0, "choices", uTe), t.choicesDataProperty = new pe.SerializableObjectProperty(pe.Versions.v1_6, "choices.data", sTe), t.styleProperty = new pe.ValueSetProperty(pe.Versions.v1_0, "style", [
      { value: "compact" },
      { value: "expanded" },
      { value: "filtered", targetVersion: pe.Versions.v1_5 }
    ], "compact"), t.isMultiSelectProperty = new pe.BoolProperty(pe.Versions.v1_0, "isMultiSelect", !1), t.placeholderProperty = new pe.StringProperty(pe.Versions.v1_0, "placeholder"), t.wrapProperty = new pe.BoolProperty(pe.Versions.v1_2, "wrap", !1), t._uniqueCategoryCounter = 0, bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", void 0), bt([
      (0, pe.property)(t.isMultiSelectProperty)
    ], t.prototype, "isMultiSelect", void 0), bt([
      (0, pe.property)(t.placeholderProperty)
    ], t.prototype, "placeholder", void 0), bt([
      (0, pe.property)(t.wrapProperty)
    ], t.prototype, "wrap", void 0), bt([
      (0, pe.property)(t.choicesProperty)
    ], t.prototype, "choices", void 0), bt([
      (0, pe.property)(t.choicesDataProperty)
    ], t.prototype, "choicesData", void 0), t;
  }(pd)
);
Ct.ChoiceSetInput = Z1;
var cTe = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._choiceSetId = t, this._choices = r, this._dynamicChoices = [], this._visibleChoiceCount = 0, this._highlightedChoiceId = -1, this._hostConfig = n;
    }
    return e.prototype.render = function() {
      var t = this, r = document.createElement("div");
      r.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-container"), this._textInput = document.createElement("input"), this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-textbox"), this._textInput.type = "text", this._textInput.onkeydown = function(n) {
        if (n.key === "ArrowDown")
          n.preventDefault(), t.highlightChoice(t._highlightedChoiceId + 1);
        else if (n.key === "ArrowUp")
          n.preventDefault(), t.highlightChoice(t._highlightedChoiceId - 1);
        else if (n.key === "Enter") {
          var i = document.getElementById("ac-choiceSetInput-".concat(t._choiceSetId, "-choice-").concat(t._highlightedChoiceId));
          i == null || i.click();
        }
      }, this._dropdown = document.createElement("div"), this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-dropdown"), r.append(this._textInput, this._dropdown), this._renderedElement = r;
    }, e.prototype.createChoice = function(t, r, n) {
      var i = this, o = document.createElement("span");
      return o.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice"), o.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(n), o.innerHTML = t.replace(r, "<b>".concat(r, "</b>")), o.tabIndex = -1, o.onclick = function() {
        o.classList.remove(i.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted")), i._highlightedChoiceId = -1, i._textInput && (i._textInput.value = o.innerText, i._textInput.focus()), i._dropdown && i._dropdown.classList.remove(i.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
      }, o.onmousemove = function() {
        i._highlightedChoiceId !== n && i.highlightChoice(n, !1);
      }, o;
    }, e.prototype.highlightChoice = function(t, r) {
      if (r === void 0 && (r = !0), this._visibleChoiceCount > 0) {
        var n = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(this._highlightedChoiceId)), i = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(t));
        i ? (n == null || n.classList.remove(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted")), i.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted")), r && i.scrollIntoView(), this._highlightedChoiceId = t) : n && this._highlightedChoiceId !== 0 ? this.highlightChoice(0) : this.highlightChoice(this._visibleChoiceCount - 1);
      }
    }, e.prototype.filterChoices = function() {
      for (var t, r, n = ((t = this._textInput) === null || t === void 0 ? void 0 : t.value.toLowerCase().trim()) || "", i = dee(dee([], this._choices, !0), this._dynamicChoices, !0), o = 0, a = i; o < a.length; o++) {
        var u = a[o];
        if (u.title) {
          var s = u.title.toLowerCase().indexOf(n);
          if (s !== -1) {
            var c = u.title.substring(s, s + n.length), l = this.createChoice(u.title, c, this._visibleChoiceCount++);
            (r = this._dropdown) === null || r === void 0 || r.appendChild(l);
          }
        }
      }
    }, e.prototype.getStatusIndicator = function(t) {
      if (t) {
        if (!this._errorIndicator) {
          var r = document.createElement("div");
          r.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator"), this._errorIndicator = r;
        }
        return this._errorIndicator.innerText = t, this._errorIndicator;
      } else {
        if (!this._loadingIndicator) {
          var n = document.createElement("div");
          n.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator"), this._loadingIndicator = n;
        }
        return this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...", this._loadingIndicator;
      }
    }, e.prototype.resetDropdown = function() {
      this._dropdown && (lr.clearElementChildren(this._dropdown), this._visibleChoiceCount = 0, this._highlightedChoiceId = -1);
    }, e.prototype.showDropdown = function() {
      var t;
      !((t = this._dropdown) === null || t === void 0) && t.hasChildNodes() && this._dropdown.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
    }, e.prototype.processChoices = function() {
      this.resetDropdown(), this.filterChoices(), this.showDropdown();
    }, e.prototype.processResponse = function(t, r) {
      var n;
      t === ((n = this._textInput) === null || n === void 0 ? void 0 : n.value) && (this.resetDropdown(), this._dynamicChoices = r, this.filterChoices(), this._visibleChoiceCount === 0 && this.showErrorIndicator(t, "No results found"));
    }, e.prototype.showLoadingIndicator = function() {
      var t, r = this.getStatusIndicator();
      (t = this._dropdown) === null || t === void 0 || t.appendChild(r), this.showDropdown();
    }, e.prototype.removeLoadingIndicator = function() {
      var t, r;
      this._loadingIndicator && (!((t = this._dropdown) === null || t === void 0) && t.contains(this._loadingIndicator)) && ((r = this._dropdown) === null || r === void 0 || r.removeChild(this._loadingIndicator));
    }, e.prototype.showErrorIndicator = function(t, r) {
      var n, i;
      if (t === ((n = this._textInput) === null || n === void 0 ? void 0 : n.value)) {
        this.processChoices();
        var o = this.getStatusIndicator(r);
        (i = this._dropdown) === null || i === void 0 || i.appendChild(o), o.scrollIntoView();
      }
    }, Object.defineProperty(e.prototype, "dynamicChoices", {
      get: function() {
        var t;
        return (t = this._dynamicChoices) === null || t === void 0 ? void 0 : t.map(function(r) {
          return r.title;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "hostConfig", {
      get: function() {
        return this._hostConfig ? this._hostConfig : this.parent ? this.parent.hostConfig : A3.defaultHostConfig;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "parent", {
      get: function() {
        return this._parent;
      },
      set: function(t) {
        this._parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "renderedElement", {
      get: function() {
        return this._renderedElement;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "textInput", {
      get: function() {
        return this._textInput;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "dropdown", {
      get: function() {
        return this._dropdown;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
Ct.FilteredChoiceSet = cTe;
var lTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.internalRender = function() {
      var r = this;
      return this._numberInputElement = document.createElement("input"), this._numberInputElement.setAttribute("type", "number"), this.min !== void 0 && this._numberInputElement.setAttribute("min", this.min.toString()), this.max !== void 0 && this._numberInputElement.setAttribute("max", this.max.toString()), this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput"), this._numberInputElement.style.width = "100%", this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0, this.defaultValue !== void 0 && (this._numberInputElement.valueAsNumber = this.defaultValue), this.placeholder && (this._numberInputElement.placeholder = this.placeholder, this._numberInputElement.setAttribute("aria-label", this.placeholder)), this._numberInputElement.oninput = function() {
        r.valueChanged();
      }, this._numberInputElement;
    }, t.prototype.getJsonTypeName = function() {
      return "Input.Number";
    }, t.prototype.isSet = function() {
      return this.value !== void 0 && !isNaN(this.value);
    }, t.prototype.isValid = function() {
      if (this.value === void 0)
        return !this.isRequired;
      var r = !0;
      return this.min !== void 0 && (r = r && this.value >= this.min), this.max !== void 0 && (r = r && this.value <= this.max), r;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this._numberInputElement ? this._numberInputElement.valueAsNumber : void 0;
      },
      set: function(r) {
        r && this._numberInputElement && (this._numberInputElement.value = r.toString());
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new pe.NumProperty(pe.Versions.v1_0, "value"), t.placeholderProperty = new pe.StringProperty(pe.Versions.v1_0, "placeholder"), t.minProperty = new pe.NumProperty(pe.Versions.v1_0, "min"), t.maxProperty = new pe.NumProperty(pe.Versions.v1_0, "max"), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.minProperty)
    ], t.prototype, "min", void 0), bt([
      (0, pe.property)(t.maxProperty)
    ], t.prototype, "max", void 0), bt([
      (0, pe.property)(t.placeholderProperty)
    ], t.prototype, "placeholder", void 0), t;
  }(pd)
);
Ct.NumberInput = lTe;
var fTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.internalRender = function() {
      var r = this;
      return this._dateInputElement = document.createElement("input"), this._dateInputElement.setAttribute("type", "date"), this.min && this._dateInputElement.setAttribute("min", this.min), this.max && this._dateInputElement.setAttribute("max", this.max), this.placeholder && (this._dateInputElement.placeholder = this.placeholder, this._dateInputElement.setAttribute("aria-label", this.placeholder)), this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0, this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput"), this._dateInputElement.style.width = "100%", this._dateInputElement.oninput = function() {
        r.valueChanged();
      }, this.defaultValue && (this._dateInputElement.value = this.defaultValue), this._dateInputElement;
    }, t.prototype.updateVisualState = function(r) {
      if (this.allowRevealOnHoverStyle && (e.prototype.updateVisualState.call(this, r), this._dateInputElement && this.inputStyle === Ke.InputStyle.RevealOnHover)) {
        var n = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, r);
        n ? this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus")) : this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus")), TTe(
          this._dateInputElement,
          n
          /*hide*/
        );
      }
    }, t.prototype.getJsonTypeName = function() {
      return "Input.Date";
    }, t.prototype.isSet = function() {
      return !!this.value;
    }, t.prototype.isValid = function() {
      if (!this.value)
        return !this.isRequired;
      var r = new Date(this.value), n = !0;
      if (this.min) {
        var i = new Date(this.min);
        n = n && r >= i;
      }
      if (this.max) {
        var o = new Date(this.max);
        n = n && r <= o;
      }
      return n;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this._dateInputElement ? this._dateInputElement.value : void 0;
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new pe.StringProperty(pe.Versions.v1_0, "value"), t.placeholderProperty = new pe.StringProperty(pe.Versions.v1_0, "placeholder"), t.minProperty = new pe.StringProperty(pe.Versions.v1_0, "min"), t.maxProperty = new pe.StringProperty(pe.Versions.v1_0, "max"), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.minProperty)
    ], t.prototype, "min", void 0), bt([
      (0, pe.property)(t.maxProperty)
    ], t.prototype, "max", void 0), bt([
      (0, pe.property)(t.placeholderProperty)
    ], t.prototype, "placeholder", void 0), t;
  }(pd)
);
Ct.DateInput = fTe;
var k4 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this, r, n, function(o, a, u, s) {
        var c = u[a.name];
        if (typeof c == "string" && c && /^[0-9]{2}:[0-9]{2}$/.test(c))
          return c;
      }, function(o, a, u, s, c) {
        c.serializeValue(u, a.name, s);
      }) || this;
      return i.targetVersion = r, i.name = n, i;
    }
    return t;
  }(pe.CustomProperty)
);
Ct.TimeProperty = k4;
var dTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.convertTimeStringToDate = function(r) {
      return /* @__PURE__ */ new Date("1973-09-04T" + r + ":00Z");
    }, t.prototype.internalRender = function() {
      var r = this;
      return this._timeInputElement = document.createElement("input"), this._timeInputElement.setAttribute("type", "time"), this.min && this._timeInputElement.setAttribute("min", this.min), this.max && this._timeInputElement.setAttribute("max", this.max), this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput"), this._timeInputElement.style.width = "100%", this._timeInputElement.oninput = function() {
        r.valueChanged();
      }, this.placeholder && (this._timeInputElement.placeholder = this.placeholder, this._timeInputElement.setAttribute("aria-label", this.placeholder)), this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0, this.defaultValue && (this._timeInputElement.value = this.defaultValue), this._timeInputElement;
    }, t.prototype.updateVisualState = function(r) {
      if (this.allowRevealOnHoverStyle && (e.prototype.updateVisualState.call(this, r), this._timeInputElement && this.inputStyle === Ke.InputStyle.RevealOnHover)) {
        var n = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, r);
        n ? this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus")) : this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus")), TTe(
          this._timeInputElement,
          n
          /*hide*/
        );
      }
    }, t.prototype.getJsonTypeName = function() {
      return "Input.Time";
    }, t.prototype.isSet = function() {
      return !!this.value;
    }, t.prototype.isValid = function() {
      if (!this.value)
        return !this.isRequired;
      var r = t.convertTimeStringToDate(this.value), n = !0;
      if (this.min) {
        var i = t.convertTimeStringToDate(this.min);
        n = n && r >= i;
      }
      if (this.max) {
        var o = t.convertTimeStringToDate(this.max);
        n = n && r <= o;
      }
      return n;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this._timeInputElement ? this._timeInputElement.value : void 0;
      },
      enumerable: !1,
      configurable: !0
    }), t.valueProperty = new k4(pe.Versions.v1_0, "value"), t.placeholderProperty = new pe.StringProperty(pe.Versions.v1_0, "placeholder"), t.minProperty = new k4(pe.Versions.v1_0, "min"), t.maxProperty = new k4(pe.Versions.v1_0, "max"), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "defaultValue", void 0), bt([
      (0, pe.property)(t.minProperty)
    ], t.prototype, "min", void 0), bt([
      (0, pe.property)(t.maxProperty)
    ], t.prototype, "max", void 0), bt([
      (0, pe.property)(t.placeholderProperty)
    ], t.prototype, "placeholder", void 0), t;
  }(pd)
);
Ct.TimeInput = dTe;
var Xc = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.style = Ke.ActionStyle.Default, r.mode = Ke.ActionMode.Primary, r._state = 0, r._isFocusable = !0, r;
    }
    return t.prototype.renderButtonContent = function() {
      if (this.renderedElement) {
        var r = this.hostConfig, n = document.createElement("div");
        if (n.style.overflow = "hidden", n.style.textOverflow = "ellipsis", r.actions.iconPlacement === Ke.ActionIconPlacement.AboveTitle || r.actions.allowTitleToWrap || (n.style.whiteSpace = "nowrap"), this.title && (n.innerText = this.title), !this.iconUrl)
          this.renderedElement.classList.add("noIcon"), this.renderedElement.appendChild(n);
        else {
          var i = document.createElement("img");
          i.src = this.iconUrl, i.style.width = r.actions.iconSize + "px", i.style.height = r.actions.iconSize + "px", i.style.flex = "0 0 auto", r.actions.iconPlacement === Ke.ActionIconPlacement.AboveTitle ? (this.renderedElement.classList.add("iconAbove"), this.renderedElement.style.flexDirection = "column", this.title && (i.style.marginBottom = "6px")) : (this.renderedElement.classList.add("iconLeft"), i.style.maxHeight = "100%", this.title && (i.style.marginRight = "6px")), this.renderedElement.appendChild(i), this.renderedElement.appendChild(n);
        }
      }
    }, t.prototype.getParentContainer = function() {
      return this.parent instanceof hd ? this.parent : this.parent ? this.parent.getParentContainer() : void 0;
    }, t.prototype.isDesignMode = function() {
      var r = this.getRootObject();
      return r instanceof na && r.isDesignMode();
    }, t.prototype.updateCssClasses = function() {
      var r, n;
      if (this.parent && this.renderedElement) {
        var i = this.parent.hostConfig;
        this.renderedElement.className = i.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
        var o = this.getParentContainer();
        if (o) {
          var a = o.getEffectiveStyle();
          a && this.renderedElement.classList.add("style-" + a);
        }
        switch (this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1, this._state) {
          case 0:
            break;
          case 1:
            this.renderedElement.classList.add(i.makeCssClassName("expanded"));
            break;
          case 2:
            this.renderedElement.classList.add(i.makeCssClassName("subdued"));
            break;
        }
        this.style && this.isEffectivelyEnabled() && (this.style === Ke.ActionStyle.Positive ? (r = this.renderedElement.classList).add.apply(r, i.makeCssClassNames("primary", "style-positive")) : (n = this.renderedElement.classList).add.apply(n, i.makeCssClassNames("style-" + this.style.toLowerCase())));
      }
    }, t.prototype.getDefaultSerializationContext = function() {
      return new Kp();
    }, t.prototype.internalGetReferencedInputs = function() {
      return {};
    }, t.prototype.internalPrepareForExecution = function(r) {
    }, t.prototype.internalValidateInputs = function(r) {
      var n = [];
      if (r)
        for (var i = 0, o = Object.keys(r); i < o.length; i++) {
          var a = o[i], u = r[a];
          u.validateValue() || n.push(u);
        }
      return n;
    }, t.prototype.shouldSerialize = function(r) {
      return r.actionRegistry.findByName(this.getJsonTypeName()) !== void 0;
    }, t.prototype.raiseExecuteActionEvent = function() {
      this.onExecute && this.onExecute(this), rnr(this);
    }, t.prototype.internalAfterExecute = function() {
      var r = this.getRootObject();
      r instanceof na && r.updateActionsEnabledState();
    }, t.prototype.getHref = function() {
      return "";
    }, t.prototype.getAriaRole = function() {
      var r = this.getAriaRoleFromEnum();
      return r ?? "button";
    }, t.prototype.getAriaRoleFromEnum = function() {
      switch (this.role) {
        case Ke.ActionRole.Button:
          return "button";
        case Ke.ActionRole.Link:
          return "link";
        case Ke.ActionRole.Menu:
          return "menu";
        case Ke.ActionRole.MenuItem:
          return "menuitem";
        case Ke.ActionRole.Tab:
          return "tab";
        default:
          return;
      }
    }, t.prototype.setupElementForAccessibility = function(r, n) {
      n === void 0 && (n = !1), r.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1, r.setAttribute("role", this.getAriaRole()), r instanceof HTMLButtonElement && (r.disabled = !this.isEffectivelyEnabled()), this.isEffectivelyEnabled() ? (r.removeAttribute("aria-disabled"), r.classList.add(this.hostConfig.makeCssClassName("ac-selectable"))) : r.setAttribute("aria-disabled", "true"), this.title ? (r.setAttribute("aria-label", this.title), r.title = this.title) : (r.removeAttribute("aria-label"), r.removeAttribute("title")), this.tooltip && (n && !this.title && r.setAttribute("aria-label", this.tooltip), r.title = this.tooltip);
    }, t.prototype.parse = function(r, n) {
      return e.prototype.parse.call(this, r, n || new Kp());
    }, t.prototype.render = function() {
      var r = this, n = document.createElement("button");
      n.type = "button", n.style.display = "flex", n.style.alignItems = "center", n.style.justifyContent = "center", n.onclick = function(i) {
        r.isEffectivelyEnabled() && (i.preventDefault(), i.cancelBubble = !0, r.execute());
      }, this._renderedElement = n, this.renderButtonContent(), this.updateCssClasses(), this.setupElementForAccessibility(n);
    }, t.prototype.execute = function() {
      this._actionCollection && this._actionCollection.actionExecuted(this), this.raiseExecuteActionEvent(), this.internalAfterExecute();
    }, t.prototype.prepareForExecution = function() {
      var r = this.getReferencedInputs(), n = this.internalValidateInputs(r);
      return n.length > 0 ? (n[0].focus(), !1) : (this.internalPrepareForExecution(r), !0);
    }, t.prototype.remove = function() {
      return this._actionCollection ? this._actionCollection.removeAction(this) : !1;
    }, t.prototype.getAllInputs = function(r) {
      return [];
    }, t.prototype.getAllActions = function() {
      return [this];
    }, t.prototype.getResourceInformation = function() {
      return this.iconUrl ? [{ url: this.iconUrl, mimeType: "image" }] : [];
    }, t.prototype.getActionById = function(r) {
      return this.id === r ? this : void 0;
    }, t.prototype.getReferencedInputs = function() {
      return this.internalGetReferencedInputs();
    }, t.prototype.validateInputs = function() {
      return this.internalValidateInputs(this.getReferencedInputs());
    }, t.prototype.updateEnabledState = function() {
    }, t.prototype.isEffectivelyEnabled = function() {
      return this.isEnabled;
    }, Object.defineProperty(t.prototype, "isPrimary", {
      get: function() {
        return this.style === Ke.ActionStyle.Positive;
      },
      set: function(r) {
        r ? this.style = Ke.ActionStyle.Positive : this.style === Ke.ActionStyle.Positive && (this.style = Ke.ActionStyle.Default);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hostConfig", {
      get: function() {
        return this.parent ? this.parent.hostConfig : A3.defaultHostConfig;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "parent", {
      get: function() {
        return this._parent;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "state", {
      get: function() {
        return this._state;
      },
      set: function(r) {
        this._state !== r && (this._state = r, this.updateCssClasses());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isFocusable", {
      get: function() {
        return this._isFocusable;
      },
      set: function(r) {
        this._isFocusable !== r && (this._isFocusable = r, this.updateCssClasses());
      },
      enumerable: !1,
      configurable: !0
    }), t.titleProperty = new pe.StringProperty(pe.Versions.v1_0, "title"), t.iconUrlProperty = new pe.StringProperty(pe.Versions.v1_1, "iconUrl"), t.styleProperty = new pe.ValueSetProperty(pe.Versions.v1_2, "style", [
      { value: Ke.ActionStyle.Default },
      { value: Ke.ActionStyle.Positive },
      { value: Ke.ActionStyle.Destructive }
    ], Ke.ActionStyle.Default), t.modeProperty = new pe.ValueSetProperty(pe.Versions.v1_5, "mode", [{ value: Ke.ActionMode.Primary }, { value: Ke.ActionMode.Secondary }], Ke.ActionMode.Primary), t.tooltipProperty = new pe.StringProperty(pe.Versions.v1_5, "tooltip"), t.isEnabledProperty = new pe.BoolProperty(pe.Versions.v1_5, "isEnabled", !0), t.roleProperty = new pe.EnumProperty(pe.Versions.v1_6, "role", Ke.ActionRole), bt([
      (0, pe.property)(t.titleProperty)
    ], t.prototype, "title", void 0), bt([
      (0, pe.property)(t.iconUrlProperty)
    ], t.prototype, "iconUrl", void 0), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", void 0), bt([
      (0, pe.property)(t.modeProperty)
    ], t.prototype, "mode", void 0), bt([
      (0, pe.property)(t.tooltipProperty)
    ], t.prototype, "tooltip", void 0), bt([
      (0, pe.property)(t.isEnabledProperty)
    ], t.prototype, "isEnabled", void 0), bt([
      (0, pe.property)(t.roleProperty)
    ], t.prototype, "role", void 0), t;
  }(G1e.CardObject)
);
Ct.Action = Xc;
var v7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.disabledUnlessAssociatedInputsChange = !1, r._isPrepared = !1, r._areReferencedInputsDirty = !1, r;
    }
    return t.prototype.internalGetReferencedInputs = function() {
      var r = {};
      if (this.associatedInputs !== "none") {
        for (var n = this.parent, i = []; n; )
          i.push.apply(i, n.getAllInputs(!1)), n = n.parent;
        for (var o = 0, a = i; o < a.length; o++) {
          var u = a[o];
          u.id && (r[u.id] = u);
        }
      }
      return r;
    }, t.prototype.internalPrepareForExecution = function(r) {
      if (this._originalData ? this._processedData = JSON.parse(JSON.stringify(this._originalData)) : this._processedData = {}, this._processedData && r)
        for (var n = 0, i = Object.keys(r); n < i.length; n++) {
          var o = i[n], a = r[o];
          a.id && a.isSet() && (this._processedData[a.id] = typeof a.value == "string" ? a.value : a.value.toString());
        }
      this._isPrepared = !0;
    }, t.prototype.internalAfterExecute = function() {
      Ir.GlobalSettings.resetInputsDirtyStateAfterActionExecution && this.resetReferencedInputsDirtyState();
    }, t.prototype.resetReferencedInputsDirtyState = function() {
      var r = this.getReferencedInputs();
      if (this._areReferencedInputsDirty = !1, r)
        for (var n = 0, i = Object.keys(r); n < i.length; n++) {
          var o = i[n], a = r[o];
          a.resetDirtyState();
        }
    }, t.prototype.updateEnabledState = function() {
      this._areReferencedInputsDirty = !1;
      var r = this.getReferencedInputs();
      if (r)
        for (var n = 0, i = Object.keys(r); n < i.length; n++) {
          var o = i[n], a = r[o];
          if (a.isDirty()) {
            this._areReferencedInputsDirty = !0;
            break;
          }
        }
      this.updateCssClasses(), this._renderedElement && this.setupElementForAccessibility(this._renderedElement);
    }, t.prototype.isEffectivelyEnabled = function() {
      var r = e.prototype.isEffectivelyEnabled.call(this);
      return this.disabledUnlessAssociatedInputsChange ? r && this._areReferencedInputsDirty : r;
    }, Object.defineProperty(t.prototype, "data", {
      get: function() {
        return this._isPrepared ? this._processedData : this._originalData;
      },
      set: function(r) {
        this._originalData = r, this._isPrepared = !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.dataProperty = new pe.PropertyDefinition(pe.Versions.v1_0, "data"), t.associatedInputsProperty = new pe.CustomProperty(pe.Versions.v1_3, "associatedInputs", function(r, n, i, o) {
      var a = i[n.name];
      if (a !== void 0 && typeof a == "string")
        return a.toLowerCase() === "none" ? "none" : "auto";
    }, function(r, n, i, o, a) {
      a.serializeValue(i, n.name, o);
    }), t.disabledUnlessAssociatedInputsChangeProperty = new pe.BoolProperty(pe.Versions.v1_6, "disabledUnlessAssociatedInputsChange", !1), bt([
      (0, pe.property)(t.dataProperty)
    ], t.prototype, "_originalData", void 0), bt([
      (0, pe.property)(t.associatedInputsProperty)
    ], t.prototype, "associatedInputs", void 0), bt([
      (0, pe.property)(t.disabledUnlessAssociatedInputsChangeProperty)
    ], t.prototype, "disabledUnlessAssociatedInputsChange", void 0), t;
  }(Xc)
);
Ct.SubmitActionBase = v7;
var dB = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.JsonTypeName = "Action.Submit", t;
  }(v7)
);
Ct.SubmitAction = dB;
var E7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(v7)
);
Ct.UniversalAction = E7;
var $S = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.JsonTypeName = "Action.Execute", t.verbProperty = new pe.StringProperty(pe.Versions.v1_4, "verb"), bt([
      (0, pe.property)(t.verbProperty)
    ], t.prototype, "verb", void 0), t;
  }(E7)
);
Ct.ExecuteAction = $S;
var Qrr = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.JsonTypeName = "Data.Query", t.datasetProperty = new pe.StringProperty(pe.Versions.v1_6, "dataset"), t.filterProperty = new pe.StringProperty(pe.Versions.v1_6, "filter"), t.countProperty = new pe.NumProperty(pe.Versions.v1_6, "count"), t.skipProperty = new pe.NumProperty(pe.Versions.v1_6, "skip"), bt([
      (0, pe.property)(t.datasetProperty)
    ], t.prototype, "dataset", void 0), bt([
      (0, pe.property)(t.filterProperty)
    ], t.prototype, "filter", void 0), bt([
      (0, pe.property)(t.countProperty)
    ], t.prototype, "count", void 0), bt([
      (0, pe.property)(t.skipProperty)
    ], t.prototype, "skip", void 0), t;
  }(E7)
);
Ct.DataQuery = Qrr;
var pB = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.prototype.getAriaRole = function() {
      var r = this.getAriaRoleFromEnum();
      return r ?? "link";
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.url || r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.propertyMustBeSet("url"));
    }, t.prototype.getHref = function() {
      return this.url;
    }, t.urlProperty = new pe.StringProperty(pe.Versions.v1_0, "url"), t.JsonTypeName = "Action.OpenUrl", bt([
      (0, pe.property)(t.urlProperty)
    ], t.prototype, "url", void 0), t;
  }(Xc)
);
Ct.OpenUrlAction = pB;
var hB = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.targetElements = {}, r;
    }
    return t.prototype.updateAriaControlsAttribute = function() {
      if (this.targetElements) {
        var r = Object.keys(this.targetElements);
        this._renderedElement && (r.length > 0 ? this._renderedElement.setAttribute("aria-controls", r.join(" ")) : this._renderedElement.removeAttribute("aria-controls"));
      }
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.targetElements || r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.propertyMustBeSet("targetElements"));
    }, t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.prototype.render = function() {
      e.prototype.render.call(this), this.updateAriaControlsAttribute();
    }, t.prototype.execute = function() {
      if (e.prototype.execute.call(this), this.parent)
        for (var r = 0, n = Object.keys(this.targetElements); r < n.length; r++) {
          var i = n[r], o = this.parent.getRootElement().getElementById(i);
          o && (typeof this.targetElements[i] == "boolean" ? o.isVisible = this.targetElements[i] : o.isVisible = !o.isVisible);
        }
    }, t.prototype.addTargetElement = function(r, n) {
      n === void 0 && (n = void 0), this.targetElements[r] = n, this.updateAriaControlsAttribute();
    }, t.prototype.removeTargetElement = function(r) {
      delete this.targetElements[r], this.updateAriaControlsAttribute();
    }, t.targetElementsProperty = new pe.CustomProperty(pe.Versions.v1_2, "targetElements", function(r, n, i, o) {
      var a = {};
      if (Array.isArray(i[n.name]))
        for (var u = 0, s = i[n.name]; u < s.length; u++) {
          var c = s[u];
          if (typeof c == "string")
            a[c] = void 0;
          else if (typeof c == "object") {
            var l = c.elementId;
            typeof l == "string" && (a[l] = lr.parseBool(c.isVisible));
          }
        }
      return a;
    }, function(r, n, i, o, a) {
      for (var u = [], s = 0, c = Object.keys(o); s < c.length; s++) {
        var l = c[s];
        typeof o[l] == "boolean" ? u.push({
          elementId: l,
          isVisible: o[l]
        }) : u.push(l);
      }
      a.serializeArray(i, n.name, u);
    }, {}, function(r) {
      return {};
    }), t.JsonTypeName = "Action.ToggleVisibility", bt([
      (0, pe.property)(t.targetElementsProperty)
    ], t.prototype, "targetElements", void 0), t;
  }(Xc)
);
Ct.ToggleVisibilityAction = hB;
var vB = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this, r, n, void 0, function() {
        return new Ir.StringWithSubstitutions();
      }) || this;
      return i.targetVersion = r, i.name = n, i;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = new Ir.StringWithSubstitutions();
      return o.set(lr.parseString(n[this.name])), o;
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeValue(n, this.name, i.getOriginal());
    }, t;
  }(pe.PropertyDefinition)
), pTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      r === void 0 && (r = ""), n === void 0 && (n = "");
      var i = e.call(this) || this;
      return i.name = r, i.value = n, i;
    }
    return t.prototype.getSchemaKey = function() {
      return "HttpHeader";
    }, t.prototype.getReferencedInputs = function(r, n) {
      this._value.getReferencedInputs(r, n);
    }, t.prototype.prepareForExecution = function(r) {
      this._value.substituteInputValues(r, Ir.ContentTypes.applicationXWwwFormUrlencoded);
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this._value.get();
      },
      set: function(r) {
        this._value.set(r);
      },
      enumerable: !1,
      configurable: !0
    }), t.nameProperty = new pe.StringProperty(pe.Versions.v1_0, "name"), t.valueProperty = new vB(pe.Versions.v1_0, "value"), bt([
      (0, pe.property)(t.nameProperty)
    ], t.prototype, "name", void 0), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "_value", void 0), t;
  }(pe.SerializableObject)
);
Ct.HttpHeader = pTe;
var enr = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._ignoreInputValidation = !1, r;
    }
    return t.prototype.internalGetReferencedInputs = function() {
      var r = this.parent ? this.parent.getRootElement().getAllInputs() : [], n = {};
      this._url.getReferencedInputs(r, n);
      for (var i = 0, o = this.headers; i < o.length; i++) {
        var a = o[i];
        a.getReferencedInputs(r, n);
      }
      return this._body.getReferencedInputs(r, n), n;
    }, t.prototype.internalPrepareForExecution = function(r) {
      if (r) {
        this._url.substituteInputValues(r, Ir.ContentTypes.applicationXWwwFormUrlencoded);
        for (var n = Ir.ContentTypes.applicationJson, i = 0, o = this.headers; i < o.length; i++) {
          var a = o[i];
          a.prepareForExecution(r), a.name && a.name.toLowerCase() === "content-type" && (n = a.value);
        }
        this._body.substituteInputValues(r, n);
      }
    }, t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.prototype.internalValidateProperties = function(r) {
      if (e.prototype.internalValidateProperties.call(this, r), this.url || r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.propertyMustBeSet("url")), this.headers.length > 0)
        for (var n = 0, i = this.headers; n < i.length; n++) {
          var o = i[n];
          o.name || r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    }, Object.defineProperty(t.prototype, "ignoreInputValidation", {
      get: function() {
        return this._ignoreInputValidation;
      },
      set: function(r) {
        this._ignoreInputValidation = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "url", {
      get: function() {
        return this._url.get();
      },
      set: function(r) {
        this._url.set(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "body", {
      get: function() {
        return this._body.get();
      },
      set: function(r) {
        this._body.set(r);
      },
      enumerable: !1,
      configurable: !0
    }), t.urlProperty = new vB(pe.Versions.v1_0, "url"), t.bodyProperty = new vB(pe.Versions.v1_0, "body"), t.methodProperty = new pe.StringProperty(pe.Versions.v1_0, "method"), t.headersProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_0, "headers", pTe), t.ignoreInputValidationProperty = new pe.BoolProperty(pe.Versions.v1_3, "ignoreInputValidation", !1), t.JsonTypeName = "Action.Http", bt([
      (0, pe.property)(t.urlProperty)
    ], t.prototype, "_url", void 0), bt([
      (0, pe.property)(t.bodyProperty)
    ], t.prototype, "_body", void 0), bt([
      (0, pe.property)(t.methodProperty)
    ], t.prototype, "method", void 0), bt([
      (0, pe.property)(t.headersProperty)
    ], t.prototype, "headers", void 0), bt([
      (0, pe.property)(t.ignoreInputValidationProperty)
    ], t.prototype, "_ignoreInputValidation", void 0), t;
  }(Xc)
);
Ct.HttpAction = enr;
var Lf = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.card = new anr(), r;
    }
    return t.prototype.updateCssClasses = function() {
      if (e.prototype.updateCssClasses.call(this), this.renderedElement) {
        var r = this.parent ? this.parent.hostConfig : A3.defaultHostConfig;
        this.renderedElement.classList.add(r.makeCssClassName("expandable")), this.renderedElement.setAttribute("aria-expanded", (this.state === 1).toString());
      }
    }, t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n);
      var i = r.card;
      i ? this.card.parse(i, n) : n.logParseEvent(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.showCardMustHaveCard());
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), this.card && n.serializeValue(r, "card", this.card.toJSON(n));
    }, t.prototype.raiseExecuteActionEvent = function() {
      this.hostConfig.actions.showCard.actionMode === Ke.ShowCardActionMode.Popup && e.prototype.raiseExecuteActionEvent.call(this);
    }, t.prototype.releaseDOMResources = function() {
      e.prototype.releaseDOMResources.call(this), this.card.releaseDOMResources();
    }, t.prototype.getJsonTypeName = function() {
      return t.JsonTypeName;
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.card.internalValidateProperties(r);
    }, t.prototype.setParent = function(r) {
      e.prototype.setParent.call(this, r), this.card.setParent(r);
    }, t.prototype.getAllInputs = function(r) {
      return r === void 0 && (r = !0), this.card.getAllInputs(r);
    }, t.prototype.getAllActions = function() {
      var r = e.prototype.getAllActions.call(this);
      return r.push.apply(r, this.card.getAllActions()), r;
    }, t.prototype.getResourceInformation = function() {
      var r = e.prototype.getResourceInformation.call(this);
      return r.push.apply(r, this.card.getResourceInformation()), r;
    }, t.prototype.getActionById = function(r) {
      var n = e.prototype.getActionById.call(this, r);
      return n || (n = this.card.getActionById(r)), n;
    }, t.JsonTypeName = "Action.ShowCard", t;
  }(Xc)
);
Ct.ShowCardAction = Lf;
var tnr = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n._actions = r, n.title = fr.Strings.defaults.overflowButtonText(), n.tooltip = fr.Strings.defaults.overflowButtonTooltip(), n;
    }
    return t.prototype.getActions = function() {
      return this._actions;
    }, t.prototype.getAllActions = function() {
      var r = e.prototype.getAllActions.call(this);
      return r.push.apply(r, this._actions), r;
    }, t.prototype.getJsonTypeName = function() {
      return Lf.JsonTypeName;
    }, t.prototype.execute = function() {
      var r = this, n, i = !inr(this, this.renderedElement);
      if (i && this.renderedElement) {
        var o = new pee.PopupMenu();
        o.hostConfig = this.hostConfig;
        for (var a = function(c) {
          var l = new pee.MenuItem(c.toString(), (n = u._actions[c].title) !== null && n !== void 0 ? n : "");
          l.isEnabled = u._actions[c].isEnabled, l.onClick = function() {
            var f = r._actions[c];
            o.closePopup(!1), f.isEnabled && f.execute();
          }, o.items.add(l);
        }, u = this, s = 0; s < this._actions.length; s++)
          a(s);
        o.onClose = function() {
          var c, l;
          (c = r.renderedElement) === null || c === void 0 || c.focus(), (l = r.renderedElement) === null || l === void 0 || l.setAttribute("aria-expanded", "false");
        }, this.renderedElement.setAttribute("aria-expanded", "true"), o.popup(this.renderedElement), o.selectedIndex = 0;
      }
    }, t.prototype.setupElementForAccessibility = function(r, n) {
      n === void 0 && (n = !1), e.prototype.setupElementForAccessibility.call(this, r, n), r.setAttribute("aria-label", fr.Strings.defaults.overflowButtonTooltip()), r.setAttribute("aria-expanded", "false");
    }, t.JsonTypeName = "Action.Overflow", t;
  }(Xc)
), hTe = (
  /** @class */
  function() {
    function e(t) {
      this._items = [], this._renderedActions = [], this._owner = t;
    }
    return e.prototype.isActionAllowed = function(t) {
      var r = this._owner.getForbiddenActionTypes();
      if (r)
        for (var n = 0, i = r; n < i.length; n++) {
          var o = i[n];
          if (t.constructor === o)
            return !1;
        }
      return !0;
    }, e.prototype.refreshContainer = function() {
      if (HS(this._actionCardContainer), !this._actionCard) {
        this._actionCardContainer.style.marginTop = "0px";
        return;
      }
      this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
      var t = this._owner.getEffectivePadding();
      this._owner.getImmediateSurroundingPadding(t);
      var r = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(t);
      this._actionCard && (this._actionCard.style.paddingLeft = r.left + "px", this._actionCard.style.paddingRight = r.right + "px", this._actionCard.style.marginLeft = "-" + r.left + "px", this._actionCard.style.marginRight = "-" + r.right + "px", r.bottom !== 0 && !this._owner.isDesignMode() && (this._actionCard.style.paddingBottom = r.bottom + "px", this._actionCard.style.marginBottom = "-" + r.bottom + "px"), lr.appendChild(this._actionCardContainer, this._actionCard));
    }, e.prototype.layoutChanged = function() {
      this._owner.getRootElement().updateLayout();
    }, e.prototype.showActionCard = function(t, r, n) {
      r === void 0 && (r = !1), n === void 0 && (n = !0), t.card.suppressStyle = r;
      var i = t.card.renderedElement && !this._owner.isDesignMode() ? t.card.renderedElement : t.card.render();
      this._actionCard = i, this._expandedAction = t, this.refreshContainer(), n && (this.layoutChanged(), gee(t, !0));
    }, e.prototype.collapseExpandedAction = function() {
      for (var t = 0, r = this._renderedActions; t < r.length; t++) {
        var n = r[t];
        n.state = 0;
      }
      var i = this._expandedAction;
      this._expandedAction = void 0, this._actionCard = void 0, this.refreshContainer(), i && (this.layoutChanged(), gee(i, !1));
    }, e.prototype.expandShowCardAction = function(t, r) {
      for (var n = this, i = !1, o = 0, a = this._renderedActions; o < a.length; o++) {
        var u = a[o];
        this._owner.hostConfig.actions.actionsOrientation == Ke.Orientation.Horizontal && i && (u.isFocusable = !1), u !== t ? u.state = 2 : (u.state = 1, i = !0, u.renderedElement && (u.renderedElement.onblur = function(s) {
          for (var c = 0, l = n._renderedActions; c < l.length; c++) {
            var f = l[c];
            f.isFocusable = !0;
          }
        }));
      }
      this.showActionCard(t, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), r);
    }, e.prototype.releaseDOMResources = function() {
      for (var t = 0, r = this._renderedActions; t < r.length; t++) {
        var n = r[t];
        n.releaseDOMResources();
      }
    }, e.prototype.actionExecuted = function(t) {
      t instanceof Lf ? t === this._expandedAction ? this.collapseExpandedAction() : this._owner.hostConfig.actions.showCard.actionMode === Ke.ShowCardActionMode.Inline && this.expandShowCardAction(t, !0) : this.collapseExpandedAction();
    }, e.prototype.parse = function(t, r) {
      if (this.clear(), Array.isArray(t))
        for (var n = 0, i = t; n < i.length; n++) {
          var o = i[n], a = [];
          this._owner instanceof T7 && (a = this._owner.getForbiddenActionNames());
          var u = r.parseAction(this._owner, o, a, !this._owner.isDesignMode());
          u && this.addAction(u);
        }
    }, e.prototype.toJSON = function(t, r, n) {
      n.serializeArray(t, r, this._items);
    }, e.prototype.getActionAt = function(t) {
      return this._items[t];
    }, e.prototype.getActionCount = function() {
      return this._items.length;
    }, e.prototype.getActionById = function(t) {
      for (var r = void 0, n = 0, i = this._items; n < i.length; n++) {
        var o = i[n];
        if (r = o.getActionById(t), r)
          break;
      }
      return r;
    }, e.prototype.validateProperties = function(t) {
      this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions && t.addFailure(this._owner, Ke.ValidationEvent.TooManyActions, fr.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions)), this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity && t.addFailure(this._owner, Ke.ValidationEvent.InteractivityNotAllowed, fr.Strings.errors.interactivityNotAllowed());
      for (var r = 0, n = this._items; r < n.length; r++) {
        var i = n[r];
        this.isActionAllowed(i) || t.addFailure(this._owner, Ke.ValidationEvent.ActionTypeNotAllowed, fr.Strings.errors.actionTypeNotAllowed(i.getJsonTypeName())), i.internalValidateProperties(t);
      }
    }, e.prototype.render = function(t) {
      var r = this._owner.hostConfig;
      if (r.supportsInteractivity) {
        var n = document.createElement("div"), i = r.actions.maxActions ? Math.min(r.actions.maxActions, this._items.length) : this._items.length;
        if (this._actionCardContainer = document.createElement("div"), this._renderedActions = [], r.actions.preExpandSingleShowCardAction && i === 1 && this._items[0] instanceof Lf && this.isActionAllowed(this._items[0]))
          this.showActionCard(this._items[0], !0), this._renderedActions.push(this._items[0]);
        else {
          var o = document.createElement("div");
          if (o.className = r.makeCssClassName("ac-actionSet"), o.style.display = "flex", t === Ke.Orientation.Horizontal)
            if (o.style.flexDirection = "row", this._owner.horizontalAlignment && r.actions.actionAlignment !== Ke.ActionAlignment.Stretch)
              switch (this._owner.horizontalAlignment) {
                case Ke.HorizontalAlignment.Center:
                  o.style.justifyContent = "center";
                  break;
                case Ke.HorizontalAlignment.Right:
                  o.style.justifyContent = "flex-end";
                  break;
                default:
                  o.style.justifyContent = "flex-start";
                  break;
              }
            else
              switch (r.actions.actionAlignment) {
                case Ke.ActionAlignment.Center:
                  o.style.justifyContent = "center";
                  break;
                case Ke.ActionAlignment.Right:
                  o.style.justifyContent = "flex-end";
                  break;
                default:
                  o.style.justifyContent = "flex-start";
                  break;
              }
          else if (o.style.flexDirection = "column", this._owner.horizontalAlignment && r.actions.actionAlignment !== Ke.ActionAlignment.Stretch)
            switch (this._owner.horizontalAlignment) {
              case Ke.HorizontalAlignment.Center:
                o.style.alignItems = "center";
                break;
              case Ke.HorizontalAlignment.Right:
                o.style.alignItems = "flex-end";
                break;
              default:
                o.style.alignItems = "flex-start";
                break;
            }
          else
            switch (r.actions.actionAlignment) {
              case Ke.ActionAlignment.Center:
                o.style.alignItems = "center";
                break;
              case Ke.ActionAlignment.Right:
                o.style.alignItems = "flex-end";
                break;
              case Ke.ActionAlignment.Stretch:
                o.style.alignItems = "stretch";
                break;
              default:
                o.style.alignItems = "flex-start";
                break;
            }
          var a = this._items.filter(this.isActionAllowed.bind(this)), u = [], s = [];
          if (this._owner.isDesignMode())
            u = a;
          else {
            a.forEach(function(y) {
              return y.mode === Ke.ActionMode.Secondary ? s.push(y) : u.push(y);
            });
            var c = u.splice(r.actions.maxActions);
            Ir.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu && s.push.apply(s, c);
            var l = !0;
            if (s.length > 0) {
              this._overflowAction || (this._overflowAction = new tnr(s), this._overflowAction.setParent(this._owner), this._overflowAction._actionCollection = this);
              var f = this._owner instanceof ga && !this._owner.parent;
              l = !onr(this._overflowAction, f);
            }
            this._overflowAction && l && u.push(this._overflowAction);
          }
          for (var d = 0; d < u.length; d++) {
            var p = u[d];
            if (p.render(), p.renderedElement && (r.actions.actionsOrientation === Ke.Orientation.Horizontal && r.actions.actionAlignment === Ke.ActionAlignment.Stretch ? p.renderedElement.style.flex = "0 1 100%" : p.renderedElement.style.flex = "0 1 auto", o.appendChild(p.renderedElement), this._renderedActions.push(p), d < u.length - 1 && r.actions.buttonSpacing > 0)) {
              var v = document.createElement("div");
              t === Ke.Orientation.Horizontal ? (v.style.flex = "0 0 auto", v.style.width = r.actions.buttonSpacing + "px") : v.style.height = r.actions.buttonSpacing + "px", lr.appendChild(o, v);
            }
          }
          var h = document.createElement("div");
          h.style.overflow = "hidden", h.appendChild(o), lr.appendChild(n, h);
        }
        lr.appendChild(n, this._actionCardContainer);
        for (var E = 0, m = this._renderedActions; E < m.length; E++) {
          var g = m[E];
          if (g.state === 1) {
            this.expandShowCardAction(g, !1);
            break;
          }
        }
        return this._renderedActions.length > 0 ? n : void 0;
      }
    }, e.prototype.addAction = function(t) {
      if (!t)
        throw new Error("The action parameter cannot be null.");
      if ((!t.parent || t.parent === this._owner) && this._items.indexOf(t) < 0)
        this._items.push(t), t.parent || t.setParent(this._owner), t._actionCollection = this;
      else
        throw new Error(fr.Strings.errors.actionAlreadyParented());
    }, e.prototype.removeAction = function(t) {
      this.expandedAction && this._expandedAction === t && this.collapseExpandedAction();
      var r = this._items.indexOf(t);
      if (r >= 0) {
        this._items.splice(r, 1), t.setParent(void 0), t._actionCollection = void 0;
        for (var n = 0; n < this._renderedActions.length; n++)
          if (this._renderedActions[n] === t) {
            this._renderedActions.splice(n, 1);
            break;
          }
        return !0;
      }
      return !1;
    }, e.prototype.clear = function() {
      this._items = [], this._renderedActions = [], this._expandedAction = void 0;
    }, e.prototype.getAllInputs = function(t) {
      t === void 0 && (t = !0);
      var r = [];
      if (t)
        for (var n = 0, i = this._items; n < i.length; n++) {
          var o = i[n];
          r.push.apply(r, o.getAllInputs());
        }
      return r;
    }, e.prototype.getResourceInformation = function() {
      for (var t = [], r = 0, n = this._items; r < n.length; r++) {
        var i = n[r];
        t.push.apply(t, i.getResourceInformation());
      }
      return t;
    }, Object.defineProperty(e.prototype, "renderedActionCount", {
      get: function() {
        return this._renderedActions.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "expandedAction", {
      get: function() {
        return this._expandedAction;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), vTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e.call(this) || this;
      return r._actionCollection = new hTe(r), r;
    }
    return t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this._actionCollection.parse(r.actions, n);
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), this._actionCollection.toJSON(r, "actions", n);
    }, t.prototype.internalRender = function() {
      return this._actionCollection.render(this.orientation !== void 0 ? this.orientation : this.hostConfig.actions.actionsOrientation);
    }, t.prototype.releaseDOMResources = function() {
      e.prototype.releaseDOMResources.call(this), this._actionCollection.releaseDOMResources();
    }, t.prototype.isBleedingAtBottom = function() {
      return this._actionCollection.renderedActionCount === 0 ? e.prototype.isBleedingAtBottom.call(this) : this._actionCollection.getActionCount() === 1 ? this._actionCollection.expandedAction !== void 0 && !this.hostConfig.actions.preExpandSingleShowCardAction : this._actionCollection.expandedAction !== void 0;
    }, t.prototype.getJsonTypeName = function() {
      return "ActionSet";
    }, t.prototype.getActionCount = function() {
      return this._actionCollection.getActionCount();
    }, t.prototype.getActionAt = function(r) {
      return r >= 0 && r < this.getActionCount() ? this._actionCollection.getActionAt(r) : e.prototype.getActionAt.call(this, r);
    }, t.prototype.getActionById = function(r) {
      var n = this._actionCollection.getActionById(r);
      return n || e.prototype.getActionById.call(this, r);
    }, t.prototype.getAllActions = function() {
      for (var r = e.prototype.getAllActions.call(this), n = 0; n < this.getActionCount(); n++) {
        var i = this.getActionAt(n);
        i && r.push(i);
      }
      return r;
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this._actionCollection.validateProperties(r);
    }, t.prototype.addAction = function(r) {
      this._actionCollection.addAction(r);
    }, t.prototype.getAllInputs = function(r) {
      return r === void 0 && (r = !0), r ? this._actionCollection.getAllInputs() : [];
    }, t.prototype.getResourceInformation = function() {
      return this._actionCollection.getResourceInformation();
    }, t.prototype.findDOMNodeOwner = function(r) {
      for (var n = void 0, i = 0; i < this.getActionCount(); i++) {
        var o = this.getActionAt(i);
        if (o && (n = o.findDOMNodeOwner(r), n))
          return n;
      }
      return e.prototype.findDOMNodeOwner.call(this, r);
    }, t.prototype.getElementById = function(r) {
      var n = e.prototype.getElementById.call(this, r);
      return n || (n = this.getElementByIdFromAction(r)), n;
    }, Object.defineProperty(t.prototype, "isInteractive", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.orientationProperty = new pe.EnumProperty(pe.Versions.v1_1, "orientation", Ke.Orientation), bt([
      (0, pe.property)(t.orientationProperty)
    ], t.prototype, "orientation", void 0), t;
  }(na)
);
Ct.ActionSet = vTe;
var ETe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, r, n, [
        { value: Ke.ContainerStyle.Default },
        { value: Ke.ContainerStyle.Emphasis },
        { targetVersion: pe.Versions.v1_2, value: Ke.ContainerStyle.Accent },
        { targetVersion: pe.Versions.v1_2, value: Ke.ContainerStyle.Good },
        { targetVersion: pe.Versions.v1_2, value: Ke.ContainerStyle.Attention },
        { targetVersion: pe.Versions.v1_2, value: Ke.ContainerStyle.Warning }
      ], i, o) || this;
      return a.targetVersion = r, a.name = n, a.defaultValue = i, a.onGetInitialValue = o, a;
    }
    return t;
  }(pe.ValueSetProperty)
);
Ct.ContainerStyleProperty = ETe;
var mTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(t.prototype, "style", {
      get: function() {
        if (this.allowCustomStyle) {
          var r = this.getValue(t.styleProperty);
          if (r && this.hostConfig.containerStyles.getStyleByName(r))
            return r;
        }
      },
      set: function(r) {
        this.setValue(t.styleProperty, r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "allowCustomStyle", {
      //#endregion
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hasExplicitStyle", {
      get: function() {
        return this.getValue(t.styleProperty) !== void 0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.applyBorder = function() {
    }, t.prototype.applyBackground = function() {
      if (this.renderedElement) {
        var r = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        if (r.backgroundColor) {
          var n = lr.stringToCssColor(r.backgroundColor);
          n && (this.renderedElement.style.backgroundColor = n);
        }
      }
    }, t.prototype.applyPadding = function() {
      if (e.prototype.applyPadding.call(this), !!this.renderedElement) {
        var r = new Ir.SpacingDefinition();
        if (this.getEffectivePadding() && (r = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding())), this.renderedElement.style.paddingTop = r.top + "px", this.renderedElement.style.paddingRight = r.right + "px", this.renderedElement.style.paddingBottom = r.bottom + "px", this.renderedElement.style.paddingLeft = r.left + "px", this.isBleeding()) {
          var n = new Ir.PaddingDefinition();
          this.getImmediateSurroundingPadding(n);
          var i = this.hostConfig.paddingDefinitionToSpacingDefinition(n);
          this.renderedElement.style.marginRight = "-" + i.right + "px", this.renderedElement.style.marginLeft = "-" + i.left + "px", this.isDesignMode() || (this.renderedElement.style.marginTop = "-" + i.top + "px", this.renderedElement.style.marginBottom = "-" + i.bottom + "px"), this.separatorElement && this.separatorOrientation === Ke.Orientation.Horizontal && (this.separatorElement.style.marginLeft = "-" + i.left + "px", this.separatorElement.style.marginRight = "-" + i.right + "px");
        } else
          this.renderedElement.style.marginRight = "0", this.renderedElement.style.marginLeft = "0", this.renderedElement.style.marginTop = "0", this.renderedElement.style.marginBottom = "0", this.separatorElement && this.separatorOrientation === Ke.Orientation.Horizontal && (this.separatorElement.style.marginRight = "0", this.separatorElement.style.marginLeft = "0");
      }
    }, t.prototype.getHasBackground = function(r) {
      r === void 0 && (r = !1);
      for (var n = this.parent; n; ) {
        var i = !1;
        if (r ? i = !1 : i = n instanceof hd ? n.backgroundImage.isValid() : !1, n instanceof t && this.hasExplicitStyle && (n.getEffectiveStyle() !== this.getEffectiveStyle() || i))
          return !0;
        n = n.parent;
      }
      return !1;
    }, t.prototype.getDefaultPadding = function() {
      return this.getHasBackground() || this.getHasBorder() ? new Ir.PaddingDefinition(Ke.Spacing.Padding, Ke.Spacing.Padding, Ke.Spacing.Padding, Ke.Spacing.Padding) : e.prototype.getDefaultPadding.call(this);
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r);
      var n = this.getValue(t.styleProperty);
      if (n !== void 0) {
        var i = this.hostConfig.containerStyles.getStyleByName(n);
        i || r.addFailure(this, Ke.ValidationEvent.InvalidPropertyValue, fr.Strings.errors.invalidPropertyValue(n, "style"));
      }
    }, t.prototype.render = function() {
      var r = e.prototype.render.call(this);
      return r && this.getHasBackground() && this.applyBackground(), this.applyBorder(), r;
    }, t.prototype.getEffectiveStyle = function() {
      var r = this.style;
      return r || e.prototype.getEffectiveStyle.call(this);
    }, t.styleProperty = new ETe(pe.Versions.v1_0, "style"), bt([
      (0, pe.property)(t.styleProperty)
    ], t.prototype, "style", null), t;
  }(S3)
);
Ct.StylableCardElementContainer = mTe;
var m7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._bleed = !1, r;
    }
    return t.prototype.adjustRenderedElementSize = function(r) {
      e.prototype.adjustRenderedElementSize.call(this, r), this.minPixelHeight && (r.style.minHeight = this.minPixelHeight + "px");
    }, t.prototype.getHasExpandedAction = function() {
      return !1;
    }, t.prototype.getBleed = function() {
      return this._bleed;
    }, t.prototype.setBleed = function(r) {
      this._bleed = r;
    }, Object.defineProperty(t.prototype, "renderedActionCount", {
      get: function() {
        return 0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.isBleeding = function() {
      return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    }, t.bleedProperty = new pe.BoolProperty(pe.Versions.v1_2, "bleed", !1), t.minHeightProperty = new pe.PixelSizeProperty(pe.Versions.v1_2, "minHeight"), bt([
      (0, pe.property)(t.bleedProperty)
    ], t.prototype, "_bleed", void 0), bt([
      (0, pe.property)(t.minHeightProperty)
    ], t.prototype, "minPixelHeight", void 0), t;
  }(mTe)
);
Ct.ContainerBase = m7;
var gTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "BackgroundImage";
    }, t.prototype.internalParse = function(r, n) {
      if (typeof r == "string")
        this.resetDefaultValues(), this.url = r;
      else
        return e.prototype.internalParse.call(this, r, n);
    }, t.prototype.apply = function(r) {
      if (this.url && r.renderedElement) {
        switch (r.renderedElement.style.backgroundImage = "url('" + r.preProcessPropertyValue(t.urlProperty, this.url) + "')", this.fillMode) {
          case Ke.FillMode.Repeat:
            r.renderedElement.style.backgroundRepeat = "repeat";
            break;
          case Ke.FillMode.RepeatHorizontally:
            r.renderedElement.style.backgroundRepeat = "repeat-x";
            break;
          case Ke.FillMode.RepeatVertically:
            r.renderedElement.style.backgroundRepeat = "repeat-y";
            break;
          case Ke.FillMode.Cover:
          default:
            r.renderedElement.style.backgroundRepeat = "no-repeat", r.renderedElement.style.backgroundSize = "cover";
            break;
        }
        switch (this.horizontalAlignment) {
          case Ke.HorizontalAlignment.Left:
            break;
          case Ke.HorizontalAlignment.Center:
            r.renderedElement.style.backgroundPositionX = "center";
            break;
          case Ke.HorizontalAlignment.Right:
            r.renderedElement.style.backgroundPositionX = "right";
            break;
        }
        switch (this.verticalAlignment) {
          case Ke.VerticalAlignment.Top:
            break;
          case Ke.VerticalAlignment.Center:
            r.renderedElement.style.backgroundPositionY = "center";
            break;
          case Ke.VerticalAlignment.Bottom:
            r.renderedElement.style.backgroundPositionY = "bottom";
            break;
        }
      }
    }, t.prototype.isValid = function() {
      return !!this.url;
    }, t.urlProperty = new pe.StringProperty(pe.Versions.v1_0, "url"), t.fillModeProperty = new pe.EnumProperty(pe.Versions.v1_2, "fillMode", Ke.FillMode, Ke.FillMode.Cover), t.horizontalAlignmentProperty = new pe.EnumProperty(pe.Versions.v1_2, "horizontalAlignment", Ke.HorizontalAlignment, Ke.HorizontalAlignment.Left), t.verticalAlignmentProperty = new pe.EnumProperty(pe.Versions.v1_2, "verticalAlignment", Ke.VerticalAlignment, Ke.VerticalAlignment.Top), bt([
      (0, pe.property)(t.urlProperty)
    ], t.prototype, "url", void 0), bt([
      (0, pe.property)(t.fillModeProperty)
    ], t.prototype, "fillMode", void 0), bt([
      (0, pe.property)(t.horizontalAlignmentProperty)
    ], t.prototype, "horizontalAlignment", void 0), bt([
      (0, pe.property)(t.verticalAlignmentProperty)
    ], t.prototype, "verticalAlignment", void 0), t;
  }(pe.SerializableObject)
);
Ct.BackgroundImage = gTe;
var hd = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._items = [], r._renderedItems = [], r;
    }
    return Object.defineProperty(t.prototype, "backgroundImage", {
      get: function() {
        return this.getValue(t.backgroundImageProperty);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.insertItemAt = function(r, n, i) {
      if (!r.parent || i)
        if (r.isStandalone)
          n < 0 || n >= this._items.length ? this._items.push(r) : this._items.splice(n, 0, r), r.setParent(this);
        else
          throw new Error(fr.Strings.errors.elementTypeNotStandalone(r.getJsonTypeName()));
      else
        throw new Error(fr.Strings.errors.elementAlreadyParented());
    }, t.prototype.getItemsCollectionPropertyName = function() {
      return "items";
    }, t.prototype.applyBackground = function() {
      this.backgroundImage.isValid() && this.renderedElement && this.backgroundImage.apply(this), e.prototype.applyBackground.call(this);
    }, t.prototype.applyRTL = function(r) {
      this.rtl !== void 0 && (r.dir = this.rtl ? "rtl" : "ltr");
    }, t.prototype.internalRender = function() {
      this._renderedItems = [];
      var r = this.hostConfig, n = document.createElement("div");
      switch (this.applyRTL(n), n.classList.add(r.makeCssClassName("ac-container")), n.style.display = "flex", n.style.flexDirection = "column", Ir.GlobalSettings.useAdvancedCardBottomTruncation && (n.style.minHeight = "-webkit-min-content"), this.getEffectiveVerticalContentAlignment()) {
        case Ke.VerticalAlignment.Center:
          n.style.justifyContent = "center";
          break;
        case Ke.VerticalAlignment.Bottom:
          n.style.justifyContent = "flex-end";
          break;
        default:
          n.style.justifyContent = "flex-start";
          break;
      }
      if (this._items.length > 0)
        for (var i = 0, o = this._items; i < o.length; i++) {
          var a = o[i], u = this.isElementAllowed(a) ? a.render() : void 0;
          u && (this._renderedItems.length > 0 && a.separatorElement && (a.separatorElement.style.flex = "0 0 auto", lr.appendChild(n, a.separatorElement)), lr.appendChild(n, u), this._renderedItems.push(a));
        }
      else if (this.isDesignMode()) {
        var s = this.createPlaceholderElement();
        s.style.width = "100%", s.style.height = "100%", n.appendChild(s);
      }
      return n;
    }, t.prototype.truncateOverflow = function(r) {
      if (this.renderedElement) {
        for (var n = this.renderedElement.offsetTop + r + 1, i = function(s) {
          var c = s.renderedElement;
          if (c)
            switch (lr.getFitStatus(c, n)) {
              case Ke.ContainerFitStatus.FullyInContainer:
                var l = s.resetOverflow();
                l && i(s);
                break;
              case Ke.ContainerFitStatus.Overflowing:
                var f = n - c.offsetTop;
                s.handleOverflow(f);
                break;
              case Ke.ContainerFitStatus.FullyOutOfContainer:
                s.handleOverflow(0);
                break;
            }
        }, o = 0, a = this._items; o < a.length; o++) {
          var u = a[o];
          i(u);
        }
        return !0;
      }
      return !1;
    }, t.prototype.undoOverflowTruncation = function() {
      for (var r = 0, n = this._items; r < n.length; r++) {
        var i = n[r];
        i.resetOverflow();
      }
    }, t.prototype.getHasBackground = function(r) {
      r === void 0 && (r = !1);
      var n = r ? !1 : this.backgroundImage.isValid();
      return n || e.prototype.getHasBackground.call(this, r);
    }, t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this.clear(), this.setShouldFallback(!1);
      var i = r[this.getItemsCollectionPropertyName()];
      if (Array.isArray(i))
        for (var o = 0, a = i; o < a.length; o++) {
          var u = a[o], s = n.parseElement(this, u, this.forbiddenChildElements(), !this.isDesignMode());
          s && this.insertItemAt(s, -1, !0);
        }
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n);
      var i = this.getItemsCollectionPropertyName();
      n.serializeArray(r, i, this._items);
    }, Object.defineProperty(t.prototype, "isSelectable", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getEffectivePadding = function() {
      return Ir.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(!0) ? new Ir.PaddingDefinition() : e.prototype.getEffectivePadding.call(this);
    }, t.prototype.getEffectiveVerticalContentAlignment = function() {
      if (this.verticalContentAlignment !== void 0)
        return this.verticalContentAlignment;
      var r = this.getParentContainer();
      return r ? r.getEffectiveVerticalContentAlignment() : Ke.VerticalAlignment.Top;
    }, t.prototype.getItemCount = function() {
      return this._items.length;
    }, t.prototype.getItemAt = function(r) {
      return this._items[r];
    }, t.prototype.getFirstVisibleRenderedItem = function() {
      if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0)
        for (var r = 0, n = this._renderedItems; r < n.length; r++) {
          var i = n[r];
          if (i.isVisible)
            return i;
        }
    }, t.prototype.getLastVisibleRenderedItem = function() {
      if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) {
        for (var r = this._renderedItems.length - 1; r >= 0; r--)
          if (this._renderedItems[r].isVisible)
            return this._renderedItems[r];
      }
    }, t.prototype.getJsonTypeName = function() {
      return "Container";
    }, t.prototype.isFirstElement = function(r) {
      for (var n = this.isDesignMode(), i = 0, o = this._items; i < o.length; i++) {
        var a = o[i];
        if (a.isVisible || n)
          return a === r;
      }
      return !1;
    }, t.prototype.isLastElement = function(r) {
      for (var n = this.isDesignMode(), i = this._items.length - 1; i >= 0; i--)
        if (this._items[i].isVisible || n)
          return this._items[i] === r;
      return !1;
    }, t.prototype.isRtl = function() {
      if (this.rtl !== void 0)
        return this.rtl;
      var r = this.getParentContainer();
      return r ? r.isRtl() : !1;
    }, t.prototype.isBleedingAtTop = function() {
      var r = this.getFirstVisibleRenderedItem();
      return this.isBleeding() || (r ? r.isBleedingAtTop() : !1);
    }, t.prototype.isBleedingAtBottom = function() {
      var r = this.getLastVisibleRenderedItem();
      return this.isBleeding() || (r ? r.isBleedingAtBottom() && r.getEffectiveStyle() === this.getEffectiveStyle() : !1);
    }, t.prototype.indexOf = function(r) {
      return this._items.indexOf(r);
    }, t.prototype.addItem = function(r) {
      this.insertItemAt(r, -1, !1);
    }, t.prototype.insertItemBefore = function(r, n) {
      this.insertItemAt(r, this._items.indexOf(n), !1);
    }, t.prototype.insertItemAfter = function(r, n) {
      this.insertItemAt(r, this._items.indexOf(n) + 1, !1);
    }, t.prototype.removeItem = function(r) {
      var n = this._items.indexOf(r);
      return n >= 0 ? (this._items.splice(n, 1), r.setParent(void 0), this.updateLayout(), !0) : !1;
    }, t.prototype.clear = function() {
      this._items = [], this._renderedItems = [];
    }, t.prototype.getResourceInformation = function() {
      var r = e.prototype.getResourceInformation.call(this);
      return this.backgroundImage.isValid() && r.push({
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
        url: this.backgroundImage.url,
        mimeType: "image"
      }), r;
    }, t.prototype.getActionById = function(r) {
      var n = e.prototype.getActionById.call(this, r);
      if (!n && (this.selectAction && (n = this.selectAction.getActionById(r)), !n))
        for (var i = 0, o = this._items; i < o.length; i++) {
          var a = o[i];
          if (n = a.getActionById(r), n)
            break;
        }
      return n;
    }, Object.defineProperty(t.prototype, "padding", {
      get: function() {
        return this.getPadding();
      },
      set: function(r) {
        this.setPadding(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "selectAction", {
      get: function() {
        return this._selectAction;
      },
      set: function(r) {
        this._selectAction = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "bleed", {
      get: function() {
        return this.getBleed();
      },
      set: function(r) {
        this.setBleed(r);
      },
      enumerable: !1,
      configurable: !0
    }), t.backgroundImageProperty = new pe.SerializableObjectProperty(pe.Versions.v1_0, "backgroundImage", gTe), t.verticalContentAlignmentProperty = new pe.EnumProperty(pe.Versions.v1_1, "verticalContentAlignment", Ke.VerticalAlignment), t.rtlProperty = new pe.BoolProperty(pe.Versions.v1_0, "rtl"), bt([
      (0, pe.property)(t.backgroundImageProperty)
    ], t.prototype, "backgroundImage", null), bt([
      (0, pe.property)(t.verticalContentAlignmentProperty)
    ], t.prototype, "verticalContentAlignment", void 0), bt([
      (0, pe.property)(t.rtlProperty)
    ], t.prototype, "rtl", void 0), t;
  }(m7)
);
Ct.Container = hd;
var M4 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r) {
      r === void 0 && (r = "stretch");
      var n = e.call(this) || this;
      return n.width = "stretch", n._computedWeight = 0, n.width = r, n;
    }
    return t.prototype.adjustRenderedElementSize = function(r) {
      var n = 20;
      this.isDesignMode() ? (r.style.minWidth = "20px", r.style.minHeight = (this.minPixelHeight ? Math.max(this.minPixelHeight, n) : n) + "px") : (r.style.minWidth = "0", this.minPixelHeight && (r.style.minHeight = this.minPixelHeight + "px")), this.width === "auto" ? r.style.flex = "0 1 auto" : this.width === "stretch" ? r.style.flex = "1 1 50px" : this.width instanceof Ir.SizeAndUnit && (this.width.unit === Ke.SizeUnit.Pixel ? (r.style.flex = "0 0 auto", r.style.width = this.width.physicalSize + "px") : r.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%");
    }, t.prototype.shouldSerialize = function(r) {
      return !0;
    }, Object.defineProperty(t.prototype, "separatorOrientation", {
      get: function() {
        return Ke.Orientation.Vertical;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getJsonTypeName = function() {
      return "Column";
    }, Object.defineProperty(t.prototype, "hasVisibleSeparator", {
      get: function() {
        return this.parent && this.parent instanceof g7 ? this.separatorElement !== void 0 && !this.parent.isLeftMostElement(this) : !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.widthProperty = new pe.CustomProperty(pe.Versions.v1_0, "width", function(r, n, i, o) {
      var a = n.defaultValue, u = i[n.name], s = !1;
      if (typeof u == "number" && !isNaN(u))
        a = new Ir.SizeAndUnit(u, Ke.SizeUnit.Weight);
      else if (u === "auto" || u === "stretch")
        a = u;
      else if (typeof u == "string")
        try {
          a = Ir.SizeAndUnit.parse(u), a.unit === Ke.SizeUnit.Pixel && n.targetVersion.compareTo(o.targetVersion) > 0 && (s = !0);
        } catch {
          s = !0;
        }
      else
        s = !0;
      return s && (o.logParseEvent(r, Ke.ValidationEvent.InvalidPropertyValue, fr.Strings.errors.invalidColumnWidth(u)), a = "auto"), a;
    }, function(r, n, i, o, a) {
      o instanceof Ir.SizeAndUnit ? o.unit === Ke.SizeUnit.Pixel ? a.serializeValue(i, "width", o.physicalSize + "px") : a.serializeNumber(i, "width", o.physicalSize) : a.serializeValue(i, "width", o);
    }, "stretch"), bt([
      (0, pe.property)(t.widthProperty)
    ], t.prototype, "width", void 0), t;
  }(hd)
);
Ct.Column = M4;
var g7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._columns = [], r;
    }
    return t.prototype.createColumnInstance = function(r, n) {
      return n.parseCardObject(this, r, [], !this.isDesignMode(), function(i) {
        return !i || i === "Column" ? new M4() : void 0;
      }, function(i, o) {
        n.logParseEvent(void 0, Ke.ValidationEvent.ElementTypeNotAllowed, fr.Strings.errors.elementTypeNotAllowed(i));
      });
    }, t.prototype.internalRender = function() {
      if (this._renderedColumns = [], this._columns.length > 0) {
        var r = this.hostConfig, n = document.createElement("div");
        switch (n.className = r.makeCssClassName("ac-columnSet"), n.style.display = "flex", Ir.GlobalSettings.useAdvancedCardBottomTruncation && (n.style.minHeight = "-webkit-min-content"), this.getEffectiveHorizontalAlignment()) {
          case Ke.HorizontalAlignment.Center:
            n.style.justifyContent = "center";
            break;
          case Ke.HorizontalAlignment.Right:
            n.style.justifyContent = "flex-end";
            break;
          default:
            n.style.justifyContent = "flex-start";
            break;
        }
        for (var i = 0, o = 0, a = this._columns; o < a.length; o++) {
          var u = a[o];
          u.width instanceof Ir.SizeAndUnit && u.width.unit === Ke.SizeUnit.Weight && (i += u.width.physicalSize);
        }
        for (var s = 0, c = this._columns; s < c.length; s++) {
          var u = c[s];
          if (u.width instanceof Ir.SizeAndUnit && u.width.unit === Ke.SizeUnit.Weight && i > 0) {
            var l = 100 / i * u.width.physicalSize;
            u._computedWeight = l;
          }
          var f = u.render();
          f && (this._renderedColumns.length > 0 && u.separatorElement && (u.separatorElement.style.flex = "0 0 auto", lr.appendChild(n, u.separatorElement)), lr.appendChild(n, f), this._renderedColumns.push(u));
        }
        return this._renderedColumns.length > 0 ? n : void 0;
      } else
        return;
    }, t.prototype.truncateOverflow = function(r) {
      for (var n = 0, i = this._columns; n < i.length; n++) {
        var o = i[n];
        o.handleOverflow(r);
      }
      return !0;
    }, t.prototype.undoOverflowTruncation = function() {
      for (var r = 0, n = this._columns; r < n.length; r++) {
        var i = n[r];
        i.resetOverflow();
      }
    }, Object.defineProperty(t.prototype, "isSelectable", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this._columns = [], this._renderedColumns = [];
      var i = r.columns;
      if (Array.isArray(i))
        for (var o = 0, a = i; o < a.length; o++) {
          var u = a[o], s = this.createColumnInstance(u, n);
          s && this._columns.push(s);
        }
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), n.serializeArray(r, "columns", this._columns);
    }, t.prototype.isFirstElement = function(r) {
      for (var n = 0, i = this._columns; n < i.length; n++) {
        var o = i[n];
        if (o.isVisible)
          return o === r;
      }
      return !1;
    }, t.prototype.isBleedingAtTop = function() {
      if (this.isBleeding())
        return !0;
      if (this._renderedColumns && this._renderedColumns.length > 0)
        for (var r = 0, n = this._columns; r < n.length; r++) {
          var i = n[r];
          if (i.isBleedingAtTop())
            return !0;
        }
      return !1;
    }, t.prototype.isBleedingAtBottom = function() {
      if (this.isBleeding())
        return !0;
      if (this._renderedColumns && this._renderedColumns.length > 0)
        for (var r = 0, n = this._columns; r < n.length; r++) {
          var i = n[r];
          if (i.isBleedingAtBottom())
            return !0;
        }
      return !1;
    }, t.prototype.getItemCount = function() {
      return this._columns.length;
    }, t.prototype.getFirstVisibleRenderedItem = function() {
      if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0)
        return this._renderedColumns[0];
    }, t.prototype.getLastVisibleRenderedItem = function() {
      if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0)
        return this._renderedColumns[this._renderedColumns.length - 1];
    }, t.prototype.getColumnAt = function(r) {
      return this._columns[r];
    }, t.prototype.getItemAt = function(r) {
      return this.getColumnAt(r);
    }, t.prototype.getJsonTypeName = function() {
      return "ColumnSet";
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r);
      for (var n = 0, i = 0, o = 0, a = this._columns; o < a.length; o++) {
        var u = a[o];
        typeof u.width == "number" ? n++ : u.width === "stretch" && i++;
      }
      n > 0 && i > 0 && r.addFailure(this, Ke.ValidationEvent.Hint, fr.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    }, t.prototype.addColumn = function(r) {
      if (!r.parent)
        this._columns.push(r), r.setParent(this);
      else
        throw new Error(fr.Strings.errors.columnAlreadyBelongsToAnotherSet());
    }, t.prototype.removeItem = function(r) {
      if (r instanceof M4) {
        var n = this._columns.indexOf(r);
        if (n >= 0)
          return this._columns.splice(n, 1), r.setParent(void 0), this.updateLayout(), !0;
      }
      return !1;
    }, t.prototype.indexOf = function(r) {
      return r instanceof M4 ? this._columns.indexOf(r) : -1;
    }, t.prototype.isLeftMostElement = function(r) {
      return this._columns.indexOf(r) === 0;
    }, t.prototype.isRightMostElement = function(r) {
      return this._columns.indexOf(r) === this._columns.length - 1;
    }, t.prototype.isTopElement = function(r) {
      return this._columns.indexOf(r) >= 0;
    }, t.prototype.isBottomElement = function(r) {
      return this._columns.indexOf(r) >= 0;
    }, t.prototype.getActionById = function(r) {
      for (var n = void 0, i = 0, o = this._columns; i < o.length; i++) {
        var a = o[i];
        if (n = a.getActionById(r), n)
          break;
      }
      return n;
    }, Object.defineProperty(t.prototype, "bleed", {
      get: function() {
        return this.getBleed();
      },
      set: function(r) {
        this.setBleed(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "padding", {
      get: function() {
        return this.getPadding();
      },
      set: function(r) {
        this.setPadding(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "selectAction", {
      get: function() {
        return this._selectAction;
      },
      set: function(r) {
        this._selectAction = r;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m7)
);
Ct.ColumnSet = g7;
function Eee(e) {
  var t = e.getRootElement(), r = t && t.onImageLoaded ? t.onImageLoaded : ga.onImageLoaded;
  r && r(e);
}
function mee(e, t, r) {
  var n = e.getRootElement(), i = n && n.onAnchorClicked ? n.onAnchorClicked : ga.onAnchorClicked;
  return i !== void 0 ? i(e, t, r) : !1;
}
function rnr(e) {
  var t = e.parent ? e.parent.getRootElement() : void 0, r = t && t.onExecuteAction ? t.onExecuteAction : ga.onExecuteAction;
  e.prepareForExecution() && r && r(e);
}
function gee(e, t) {
  var r = e.parent ? e.parent.getRootElement() : void 0, n = r && r.onInlineCardExpanded ? r.onInlineCardExpanded : ga.onInlineCardExpanded;
  n && n(e, t);
}
function nnr(e) {
  var t = e.getRootElement(), r = t && t.onInputValueChanged ? t.onInputValueChanged : ga.onInputValueChanged;
  r && r(e);
}
function YD(e, t) {
  t === void 0 && (t = !0);
  var r = e.getRootElement();
  t && r.updateLayout();
  var n = r, i = n && n.onElementVisibilityChanged ? n.onElementVisibilityChanged : ga.onElementVisibilityChanged;
  i !== void 0 && i(e);
}
function TTe(e, t) {
  t ? (e.readOnly = !0, e.required = !0) : (e.readOnly = !1, e.required = !1);
}
function inr(e, t) {
  var r = e.parent ? e.parent.getRootElement() : void 0, n = r && r.onDisplayOverflowActionMenu ? r.onDisplayOverflowActionMenu : ga.onDisplayOverflowActionMenu;
  return n !== void 0 ? n(e.getActions(), t) : !1;
}
function onr(e, t) {
  var r = e.parent ? e.parent.getRootElement() : void 0, n = r && r.onRenderOverflowActions ? r.onRenderOverflowActions : ga.onRenderOverflowActions;
  return n !== void 0 ? n(e.getActions(), t) : !1;
}
var T7 = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e.call(this) || this;
      return r._actionCollection = new hTe(r), r;
    }
    return t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this.parseActions(r, n);
    }, t.prototype.parseActions = function(r, n) {
      this._actionCollection.parse(r.actions, n);
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), this._actionCollection.toJSON(r, "actions", n);
    }, t.prototype.internalRender = function() {
      var r = e.prototype.internalRender.call(this);
      if (r) {
        var n = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
        return n && (lr.appendChild(r, f7(this.hostConfig, {
          spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
        }, Ke.Orientation.Horizontal)), lr.appendChild(r, n)), this.renderIfEmpty || r.children.length > 0 ? r : void 0;
      } else
        return;
    }, t.prototype.getHasExpandedAction = function() {
      return this.renderedActionCount === 0 ? !1 : this.renderedActionCount === 1 ? this._actionCollection.expandedAction !== void 0 && !this.hostConfig.actions.preExpandSingleShowCardAction : this._actionCollection.expandedAction !== void 0;
    }, Object.defineProperty(t.prototype, "renderedActionCount", {
      get: function() {
        return this._actionCollection.renderedActionCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "renderIfEmpty", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.releaseDOMResources = function() {
      e.prototype.releaseDOMResources.call(this), this._actionCollection.releaseDOMResources();
    }, t.prototype.getActionCount = function() {
      return this._actionCollection.getActionCount();
    }, t.prototype.getActionAt = function(r) {
      return r >= 0 && r < this.getActionCount() ? this._actionCollection.getActionAt(r) : e.prototype.getActionAt.call(this, r);
    }, t.prototype.getActionById = function(r) {
      var n = this._actionCollection.getActionById(r);
      return n || e.prototype.getActionById.call(this, r);
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this._actionCollection && this._actionCollection.validateProperties(r);
    }, t.prototype.isLastElement = function(r) {
      return e.prototype.isLastElement.call(this, r) && this._actionCollection.getActionCount() === 0;
    }, t.prototype.addAction = function(r) {
      this._actionCollection.addAction(r);
    }, t.prototype.clear = function() {
      e.prototype.clear.call(this), this._actionCollection.clear();
    }, t.prototype.getAllInputs = function(r) {
      r === void 0 && (r = !0);
      var n = e.prototype.getAllInputs.call(this, r);
      return r && n.push.apply(n, this._actionCollection.getAllInputs(r)), n;
    }, t.prototype.getResourceInformation = function() {
      var r = e.prototype.getResourceInformation.call(this);
      return r.push.apply(r, this._actionCollection.getResourceInformation()), r;
    }, t.prototype.isBleedingAtBottom = function() {
      return this._actionCollection.renderedActionCount === 0 ? e.prototype.isBleedingAtBottom.call(this) : this._actionCollection.getActionCount() === 1 ? this._actionCollection.expandedAction !== void 0 && !this.hostConfig.actions.preExpandSingleShowCardAction : this._actionCollection.expandedAction !== void 0;
    }, t.prototype.getForbiddenActionNames = function() {
      return [];
    }, t.prototype.getElementById = function(r) {
      var n = e.prototype.getElementById.call(this, r);
      return n || (n = this.getElementByIdFromAction(r)), n;
    }, Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(hd)
);
Ct.ContainerWithActions = T7;
var yTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t(r, n) {
      var i = e.call(this, r, n, void 0) || this;
      return i.targetVersion = r, i.name = n, i;
    }
    return t.prototype.parse = function(r, n, i) {
      var o = i.parseAction(r.parent, n[this.name], [], !1);
      if (o !== void 0) {
        if (o instanceof $S)
          return o;
        i.logParseEvent(r, Ke.ValidationEvent.ActionTypeNotAllowed, fr.Strings.errors.actionTypeNotAllowed(o.getJsonTypeName()));
      }
      i.logParseEvent(r, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.propertyMustBeSet("action"));
    }, t.prototype.toJSON = function(r, n, i, o) {
      o.serializeValue(n, this.name, i ? i.toJSON(o) : void 0, void 0, !0);
    }, t;
  }(pe.PropertyDefinition)
);
Ct.RefreshActionProperty = yTe;
var _Te = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(t.prototype, "action", {
      get: function() {
        return this.getValue(t.actionProperty);
      },
      set: function(r) {
        this.setValue(t.actionProperty, r), r && r.setParent(this.parent);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getSchemaKey = function() {
      return "RefreshDefinition";
    }, t.actionProperty = new yTe(pe.Versions.v1_4, "action"), t.userIdsProperty = new pe.StringArrayProperty(pe.Versions.v1_4, "userIds"), bt([
      (0, pe.property)(t.actionProperty)
    ], t.prototype, "action", null), bt([
      (0, pe.property)(t.userIdsProperty)
    ], t.prototype, "userIds", void 0), t;
  }(pe.SerializableObject)
);
Ct.RefreshDefinition = _Te;
var ATe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "AuthCardButton";
    }, t.typeProperty = new pe.StringProperty(pe.Versions.v1_4, "type"), t.titleProperty = new pe.StringProperty(pe.Versions.v1_4, "title"), t.imageProperty = new pe.StringProperty(pe.Versions.v1_4, "image"), t.valueProperty = new pe.StringProperty(pe.Versions.v1_4, "value"), bt([
      (0, pe.property)(t.typeProperty)
    ], t.prototype, "type", void 0), bt([
      (0, pe.property)(t.titleProperty)
    ], t.prototype, "title", void 0), bt([
      (0, pe.property)(t.imageProperty)
    ], t.prototype, "image", void 0), bt([
      (0, pe.property)(t.valueProperty)
    ], t.prototype, "value", void 0), t;
  }(pe.SerializableObject)
);
Ct.AuthCardButton = ATe;
var STe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "TokenExchangeResource";
    }, t.idProperty = new pe.StringProperty(pe.Versions.v1_4, "id"), t.uriProperty = new pe.StringProperty(pe.Versions.v1_4, "uri"), t.providerIdProperty = new pe.StringProperty(pe.Versions.v1_4, "providerId"), bt([
      (0, pe.property)(t.idProperty)
    ], t.prototype, "id", void 0), bt([
      (0, pe.property)(t.uriProperty)
    ], t.prototype, "uri", void 0), bt([
      (0, pe.property)(t.providerIdProperty)
    ], t.prototype, "providerId", void 0), t;
  }(pe.SerializableObject)
);
Ct.TokenExchangeResource = STe;
var bTe = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSchemaKey = function() {
      return "Authentication";
    }, t.textProperty = new pe.StringProperty(pe.Versions.v1_4, "text"), t.connectionNameProperty = new pe.StringProperty(pe.Versions.v1_4, "connectionName"), t.buttonsProperty = new pe.SerializableObjectCollectionProperty(pe.Versions.v1_4, "buttons", ATe), t.tokenExchangeResourceProperty = new pe.SerializableObjectProperty(pe.Versions.v1_4, "tokenExchangeResource", STe, !0), bt([
      (0, pe.property)(t.textProperty)
    ], t.prototype, "text", void 0), bt([
      (0, pe.property)(t.connectionNameProperty)
    ], t.prototype, "connectionName", void 0), bt([
      (0, pe.property)(t.buttonsProperty)
    ], t.prototype, "buttons", void 0), bt([
      (0, pe.property)(t.tokenExchangeResourceProperty)
    ], t.prototype, "tokenExchangeResource", void 0), t;
  }(pe.SerializableObject)
);
Ct.Authentication = bTe;
var ga = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.designMode = !1, r;
    }
    return Object.defineProperty(t.prototype, "refresh", {
      get: function() {
        return this.getValue(t.refreshProperty);
      },
      set: function(r) {
        this.setValue(t.refreshProperty, r), r && (r.parent = this);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "processMarkdown", {
      get: function() {
        throw new Error(fr.Strings.errors.processMarkdownEventRemoved());
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      set: function(r) {
        throw new Error(fr.Strings.errors.processMarkdownEventRemoved());
      },
      enumerable: !1,
      configurable: !0
    }), t.applyMarkdown = function(r) {
      var n = {
        didProcess: !1
      };
      if (t.onProcessMarkdown)
        t.onProcessMarkdown(r, n);
      else if (window.markdownit) {
        var i = window.markdownit;
        n.outputHtml = i().render(r), n.didProcess = !0;
      } else t._haveWarnedAboutNoMarkdownProcessing || (console.warn(fr.Strings.errors.markdownProcessingNotEnabled), t._haveWarnedAboutNoMarkdownProcessing = !0);
      return n;
    }, t.prototype.isVersionSupported = function() {
      if (this.bypassVersionCheck)
        return !0;
      var r = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
      return !r;
    }, t.prototype.getDefaultSerializationContext = function() {
      return new Kp(this.version);
    }, t.prototype.getItemsCollectionPropertyName = function() {
      return "body";
    }, t.prototype.internalParse = function(r, n) {
      this._fallbackCard = void 0;
      var i = n.parseElement(void 0, r.fallback, this.forbiddenChildElements(), !this.isDesignMode());
      i && (this._fallbackCard = new t(), this._fallbackCard.addItem(i)), e.prototype.internalParse.call(this, r, n);
    }, t.prototype.internalToJSON = function(r, n) {
      this.setValue(t.versionProperty, n.targetVersion), e.prototype.internalToJSON.call(this, r, n);
    }, t.prototype.internalRender = function() {
      var r = e.prototype.internalRender.call(this);
      return Ir.GlobalSettings.useAdvancedCardBottomTruncation && r && r.style.removeProperty("minHeight"), r;
    }, t.prototype.getHasBackground = function(r) {
      return !0;
    }, t.prototype.getDefaultPadding = function() {
      return new Ir.PaddingDefinition(Ke.Spacing.Padding, Ke.Spacing.Padding, Ke.Spacing.Padding, Ke.Spacing.Padding);
    }, t.prototype.shouldSerialize = function(r) {
      return !0;
    }, Object.defineProperty(t.prototype, "renderIfEmpty", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "bypassVersionCheck", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "allowCustomStyle", {
      get: function() {
        return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hasBackground", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getJsonTypeName = function() {
      return "AdaptiveCard";
    }, t.prototype.internalValidateProperties = function(r) {
      e.prototype.internalValidateProperties.call(this, r), this.getValue(na.typeNameProperty) !== "AdaptiveCard" && r.addFailure(this, Ke.ValidationEvent.MissingCardType, fr.Strings.errors.invalidCardType()), !this.bypassVersionCheck && !this.version ? r.addFailure(this, Ke.ValidationEvent.PropertyCantBeNull, fr.Strings.errors.propertyMustBeSet("version")) : this.isVersionSupported() || r.addFailure(this, Ke.ValidationEvent.UnsupportedCardVersion, fr.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    }, t.prototype.render = function(r) {
      var n = this, i;
      this.shouldFallback() && this._fallbackCard ? (this._fallbackCard.hostConfig = this.hostConfig, i = this._fallbackCard.render()) : (i = e.prototype.render.call(this), i && (i.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard")), Ir.GlobalSettings.setTabIndexAtCardRoot && (i.tabIndex = 0), this.speak && i.setAttribute("aria-label", this.speak), i.onmouseenter = function(a) {
        n.updateInputsVisualState(
          !0
          /* hover */
        );
      }, i.onmouseleave = function(a) {
        n.updateInputsVisualState(
          !1
          /* hover */
        );
      }, this.getRootElement().updateActionsEnabledState())), r && (lr.appendChild(r, i), this.updateLayout());
      var o = this.getAllInputs();
      return document.onclick = function(a) {
        o.forEach(function(u) {
          var s, c;
          u instanceof Z1 && !(!((s = u.renderedElement) === null || s === void 0) && s.contains(a.target)) && ((c = u.getDropdownElement()) === null || c === void 0 || c.classList.remove(n.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open")));
        });
      }, i;
    }, t.prototype.updateLayout = function(r) {
      if (r === void 0 && (r = !0), e.prototype.updateLayout.call(this, r), Ir.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
        var n = this.hostConfig.getEffectiveSpacing(Ke.Spacing.Default);
        this.handleOverflow(this.renderedElement.offsetHeight - n);
      }
    }, t.prototype.shouldFallback = function() {
      return e.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    }, Object.defineProperty(t.prototype, "hasVisibleSeparator", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json", t.$schemaProperty = new pe.CustomProperty(pe.Versions.v1_0, "$schema", function(r, n, i, o) {
      return t.schemaUrl;
    }, function(r, n, i, o, a) {
      a.serializeValue(i, n.name, t.schemaUrl);
    }), t.versionProperty = new pe.CustomProperty(pe.Versions.v1_0, "version", function(r, n, i, o) {
      var a = pe.Version.parse(i[n.name], o);
      return a === void 0 && (a = pe.Versions.latest, o.logParseEvent(r, Ke.ValidationEvent.InvalidPropertyValue, fr.Strings.errors.invalidCardVersion(a.toString()))), a;
    }, function(r, n, i, o, a) {
      o !== void 0 && a.serializeValue(i, n.name, o.toString());
    }, pe.Versions.v1_0), t.fallbackTextProperty = new pe.StringProperty(pe.Versions.v1_0, "fallbackText"), t.speakProperty = new pe.StringProperty(pe.Versions.v1_0, "speak"), t.refreshProperty = new pe.SerializableObjectProperty(pe.Versions.v1_4, "refresh", _Te, !0), t.authenticationProperty = new pe.SerializableObjectProperty(pe.Versions.v1_4, "authentication", bTe, !0), t._haveWarnedAboutNoMarkdownProcessing = !1, bt([
      (0, pe.property)(t.versionProperty)
    ], t.prototype, "version", void 0), bt([
      (0, pe.property)(t.fallbackTextProperty)
    ], t.prototype, "fallbackText", void 0), bt([
      (0, pe.property)(t.speakProperty)
    ], t.prototype, "speak", void 0), bt([
      (0, pe.property)(t.refreshProperty)
    ], t.prototype, "refresh", null), bt([
      (0, pe.property)(t.authenticationProperty)
    ], t.prototype, "authentication", void 0), t;
  }(T7)
);
Ct.AdaptiveCard = ga;
var anr = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.suppressStyle = !1, r;
    }
    return t.prototype.getSchemaKey = function() {
      return "InlineAdaptiveCard";
    }, t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.remove(ga.$schemaProperty, ga.versionProperty);
    }, t.prototype.getDefaultPadding = function() {
      return new Ir.PaddingDefinition(this.suppressStyle ? Ke.Spacing.None : Ke.Spacing.Padding, Ke.Spacing.Padding, this.suppressStyle ? Ke.Spacing.None : Ke.Spacing.Padding, Ke.Spacing.Padding);
    }, Object.defineProperty(t.prototype, "bypassVersionCheck", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "defaultStyle", {
      get: function() {
        return this.suppressStyle ? Ke.ContainerStyle.Default : this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : Ke.ContainerStyle.Emphasis;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function(r) {
      var n = e.prototype.render.call(this, r);
      return n && (n.setAttribute("aria-live", "polite"), n.removeAttribute("tabindex")), n;
    }, t;
  }(ga)
), Kp = (
  /** @class */
  function(e) {
    tr(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._forbiddenTypes = /* @__PURE__ */ new Set(), r;
    }
    return t.prototype.internalParseCardObject = function(r, n, i, o, a, u) {
      var s = this, c = void 0;
      if (n && typeof n == "object") {
        var l = /* @__PURE__ */ new Set();
        this._forbiddenTypes.forEach(function(v) {
          l.add(v);
        }), i.forEach(function(v) {
          s._forbiddenTypes.add(v);
        });
        var f = lr.parseString(n.type);
        if (f && this._forbiddenTypes.has(f))
          u(f, Ke.TypeErrorType.ForbiddenType);
        else {
          var d = !1;
          if (c = a(f), c ? (c.setParent(r), c.parse(n, this), d = Ir.GlobalSettings.enableFallback && o && c.shouldFallback()) : (d = Ir.GlobalSettings.enableFallback && o, u(f, Ke.TypeErrorType.UnknownType)), d) {
            var p = n.fallback;
            !p && r && r.setShouldFallback(!0), typeof p == "string" && p.toLowerCase() === "drop" ? c = void 0 : typeof p == "object" && (c = this.internalParseCardObject(r, p, i, !0, a, u));
          }
        }
        this._forbiddenTypes = l;
      }
      return c;
    }, t.prototype.cardObjectParsed = function(r, n) {
      r instanceof Xc && this.onParseAction ? this.onParseAction(r, n, this) : r instanceof na && this.onParseElement && this.onParseElement(r, n, this);
    }, t.prototype.shouldSerialize = function(r) {
      return r instanceof Xc ? this.actionRegistry.findByName(r.getJsonTypeName()) !== void 0 : r instanceof na ? this.elementRegistry.findByName(r.getJsonTypeName()) !== void 0 : !0;
    }, t.prototype.parseCardObject = function(r, n, i, o, a, u) {
      var s = new Set(i), c = this.internalParseCardObject(r, n, s, o, a, u);
      return c !== void 0 && this.cardObjectParsed(c, n), c;
    }, t.prototype.parseElement = function(r, n, i, o) {
      var a = this;
      return this.parseCardObject(r, n, i, o, function(u) {
        return a.elementRegistry.createInstance(u, a.targetVersion);
      }, function(u, s) {
        s === Ke.TypeErrorType.UnknownType ? a.logParseEvent(void 0, Ke.ValidationEvent.UnknownElementType, fr.Strings.errors.unknownElementType(u)) : a.logParseEvent(void 0, Ke.ValidationEvent.ElementTypeNotAllowed, fr.Strings.errors.elementTypeNotAllowed(u));
      });
    }, t.prototype.parseAction = function(r, n, i, o) {
      var a = this;
      return this.parseCardObject(r, n, i, o, function(u) {
        return a.actionRegistry.createInstance(u, a.targetVersion);
      }, function(u, s) {
        s === Ke.TypeErrorType.UnknownType ? a.logParseEvent(void 0, Ke.ValidationEvent.UnknownActionType, fr.Strings.errors.unknownActionType(u)) : a.logParseEvent(void 0, Ke.ValidationEvent.ActionTypeNotAllowed, fr.Strings.errors.actionTypeNotAllowed(u));
      });
    }, Object.defineProperty(t.prototype, "elementRegistry", {
      get: function() {
        var r;
        return (r = this._elementRegistry) !== null && r !== void 0 ? r : mi.GlobalRegistry.elements;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setElementRegistry = function(r) {
      this._elementRegistry = r;
    }, Object.defineProperty(t.prototype, "actionRegistry", {
      get: function() {
        var r;
        return (r = this._actionRegistry) !== null && r !== void 0 ? r : mi.GlobalRegistry.actions;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setActionRegistry = function(r) {
      this._actionRegistry = r;
    }, t;
  }(pe.BaseSerializationContext)
);
Ct.SerializationContext = Kp;
mi.GlobalRegistry.defaultElements.register("Container", hd);
mi.GlobalRegistry.defaultElements.register("TextBlock", Nf);
mi.GlobalRegistry.defaultElements.register("RichTextBlock", d7, pe.Versions.v1_2);
mi.GlobalRegistry.defaultElements.register("TextRun", Wp, pe.Versions.v1_2);
mi.GlobalRegistry.defaultElements.register("Image", b1);
mi.GlobalRegistry.defaultElements.register("ImageSet", X1e);
mi.GlobalRegistry.defaultElements.register("Media", iTe, pe.Versions.v1_1);
mi.GlobalRegistry.defaultElements.register("FactSet", K1e);
mi.GlobalRegistry.defaultElements.register("ColumnSet", g7);
mi.GlobalRegistry.defaultElements.register("ActionSet", vTe, pe.Versions.v1_2);
mi.GlobalRegistry.defaultElements.register("Input.Text", oTe);
mi.GlobalRegistry.defaultElements.register("Input.Date", fTe);
mi.GlobalRegistry.defaultElements.register("Input.Time", dTe);
mi.GlobalRegistry.defaultElements.register("Input.Number", lTe);
mi.GlobalRegistry.defaultElements.register("Input.ChoiceSet", Z1);
mi.GlobalRegistry.defaultElements.register("Input.Toggle", aTe);
mi.GlobalRegistry.defaultActions.register(pB.JsonTypeName, pB);
mi.GlobalRegistry.defaultActions.register(dB.JsonTypeName, dB);
mi.GlobalRegistry.defaultActions.register(Lf.JsonTypeName, Lf);
mi.GlobalRegistry.defaultActions.register(hB.JsonTypeName, hB, pe.Versions.v1_2);
mi.GlobalRegistry.defaultActions.register($S.JsonTypeName, $S, pe.Versions.v1_4);
var Wl = {};
function Tee(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function y7(e = {}, t = {}) {
  Object.keys(t).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : Tee(t[r]) && Tee(e[r]) && Object.keys(t[r]).length > 0 && y7(e[r], t[r]);
  });
}
const CTe = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Zi() {
  const e = typeof document < "u" ? document : {};
  return y7(e, CTe), e;
}
const unr = {
  document: CTe,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function Xn() {
  const e = typeof window < "u" ? window : {};
  return y7(e, unr), e;
}
function snr(e) {
  const t = e.__proto__;
  Object.defineProperty(e, "__proto__", {
    get() {
      return t;
    },
    set(r) {
      t.__proto__ = r;
    }
  });
}
class jl extends Array {
  constructor(t) {
    typeof t == "number" ? super(t) : (super(...t || []), snr(this));
  }
}
function Iy(e = []) {
  const t = [];
  return e.forEach((r) => {
    Array.isArray(r) ? t.push(...Iy(r)) : t.push(r);
  }), t;
}
function ITe(e, t) {
  return Array.prototype.filter.call(e, t);
}
function cnr(e) {
  const t = [];
  for (let r = 0; r < e.length; r += 1)
    t.indexOf(e[r]) === -1 && t.push(e[r]);
  return t;
}
function lnr(e, t) {
  if (typeof e != "string")
    return [e];
  const r = [], n = t.querySelectorAll(e);
  for (let i = 0; i < n.length; i += 1)
    r.push(n[i]);
  return r;
}
function xt(e, t) {
  const r = Xn(), n = Zi();
  let i = [];
  if (!t && e instanceof jl)
    return e;
  if (!e)
    return new jl(i);
  if (typeof e == "string") {
    const o = e.trim();
    if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
      let a = "div";
      o.indexOf("<li") === 0 && (a = "ul"), o.indexOf("<tr") === 0 && (a = "tbody"), (o.indexOf("<td") === 0 || o.indexOf("<th") === 0) && (a = "tr"), o.indexOf("<tbody") === 0 && (a = "table"), o.indexOf("<option") === 0 && (a = "select");
      const u = n.createElement(a);
      u.innerHTML = o;
      for (let s = 0; s < u.childNodes.length; s += 1)
        i.push(u.childNodes[s]);
    } else
      i = lnr(e.trim(), t || n);
  } else if (e.nodeType || e === r || e === n)
    i.push(e);
  else if (Array.isArray(e)) {
    if (e instanceof jl) return e;
    i = e;
  }
  return new jl(cnr(i));
}
xt.fn = jl.prototype;
function fnr(...e) {
  const t = Iy(e.map((r) => r.split(" ")));
  return this.forEach((r) => {
    r.classList.add(...t);
  }), this;
}
function dnr(...e) {
  const t = Iy(e.map((r) => r.split(" ")));
  return this.forEach((r) => {
    r.classList.remove(...t);
  }), this;
}
function pnr(...e) {
  const t = Iy(e.map((r) => r.split(" ")));
  this.forEach((r) => {
    t.forEach((n) => {
      r.classList.toggle(n);
    });
  });
}
function hnr(...e) {
  const t = Iy(e.map((r) => r.split(" ")));
  return ITe(this, (r) => t.filter((n) => r.classList.contains(n)).length > 0).length > 0;
}
function vnr(e, t) {
  if (arguments.length === 1 && typeof e == "string")
    return this[0] ? this[0].getAttribute(e) : void 0;
  for (let r = 0; r < this.length; r += 1)
    if (arguments.length === 2)
      this[r].setAttribute(e, t);
    else
      for (const n in e)
        this[r][n] = e[n], this[r].setAttribute(n, e[n]);
  return this;
}
function Enr(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].removeAttribute(e);
  return this;
}
function mnr(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transform = e;
  return this;
}
function gnr(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transitionDuration = typeof e != "string" ? `${e}ms` : e;
  return this;
}
function Tnr(...e) {
  let [t, r, n, i] = e;
  typeof e[1] == "function" && ([t, n, i] = e, r = void 0), i || (i = !1);
  function o(c) {
    const l = c.target;
    if (!l) return;
    const f = c.target.dom7EventData || [];
    if (f.indexOf(c) < 0 && f.unshift(c), xt(l).is(r)) n.apply(l, f);
    else {
      const d = xt(l).parents();
      for (let p = 0; p < d.length; p += 1)
        xt(d[p]).is(r) && n.apply(d[p], f);
    }
  }
  function a(c) {
    const l = c && c.target ? c.target.dom7EventData || [] : [];
    l.indexOf(c) < 0 && l.unshift(c), n.apply(this, l);
  }
  const u = t.split(" ");
  let s;
  for (let c = 0; c < this.length; c += 1) {
    const l = this[c];
    if (r)
      for (s = 0; s < u.length; s += 1) {
        const f = u[s];
        l.dom7LiveListeners || (l.dom7LiveListeners = {}), l.dom7LiveListeners[f] || (l.dom7LiveListeners[f] = []), l.dom7LiveListeners[f].push({
          listener: n,
          proxyListener: o
        }), l.addEventListener(f, o, i);
      }
    else
      for (s = 0; s < u.length; s += 1) {
        const f = u[s];
        l.dom7Listeners || (l.dom7Listeners = {}), l.dom7Listeners[f] || (l.dom7Listeners[f] = []), l.dom7Listeners[f].push({
          listener: n,
          proxyListener: a
        }), l.addEventListener(f, a, i);
      }
  }
  return this;
}
function ynr(...e) {
  let [t, r, n, i] = e;
  typeof e[1] == "function" && ([t, n, i] = e, r = void 0), i || (i = !1);
  const o = t.split(" ");
  for (let a = 0; a < o.length; a += 1) {
    const u = o[a];
    for (let s = 0; s < this.length; s += 1) {
      const c = this[s];
      let l;
      if (!r && c.dom7Listeners ? l = c.dom7Listeners[u] : r && c.dom7LiveListeners && (l = c.dom7LiveListeners[u]), l && l.length)
        for (let f = l.length - 1; f >= 0; f -= 1) {
          const d = l[f];
          n && d.listener === n || n && d.listener && d.listener.dom7proxy && d.listener.dom7proxy === n ? (c.removeEventListener(u, d.proxyListener, i), l.splice(f, 1)) : n || (c.removeEventListener(u, d.proxyListener, i), l.splice(f, 1));
        }
    }
  }
  return this;
}
function _nr(...e) {
  const t = Xn(), r = e[0].split(" "), n = e[1];
  for (let i = 0; i < r.length; i += 1) {
    const o = r[i];
    for (let a = 0; a < this.length; a += 1) {
      const u = this[a];
      if (t.CustomEvent) {
        const s = new t.CustomEvent(o, {
          detail: n,
          bubbles: !0,
          cancelable: !0
        });
        u.dom7EventData = e.filter((c, l) => l > 0), u.dispatchEvent(s), u.dom7EventData = [], delete u.dom7EventData;
      }
    }
  }
  return this;
}
function Anr(e) {
  const t = this;
  function r(n) {
    n.target === this && (e.call(this, n), t.off("transitionend", r));
  }
  return e && t.on("transitionend", r), this;
}
function Snr(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function bnr(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function Cnr() {
  if (this.length > 0) {
    const e = Xn(), t = Zi(), r = this[0], n = r.getBoundingClientRect(), i = t.body, o = r.clientTop || i.clientTop || 0, a = r.clientLeft || i.clientLeft || 0, u = r === e ? e.scrollY : r.scrollTop, s = r === e ? e.scrollX : r.scrollLeft;
    return {
      top: n.top + u - o,
      left: n.left + s - a
    };
  }
  return null;
}
function Inr() {
  const e = Xn();
  return this[0] ? e.getComputedStyle(this[0], null) : {};
}
function Onr(e, t) {
  const r = Xn();
  let n;
  if (arguments.length === 1)
    if (typeof e == "string") {
      if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(e);
    } else {
      for (n = 0; n < this.length; n += 1)
        for (const i in e)
          this[n].style[i] = e[i];
      return this;
    }
  if (arguments.length === 2 && typeof e == "string") {
    for (n = 0; n < this.length; n += 1)
      this[n].style[e] = t;
    return this;
  }
  return this;
}
function Rnr(e) {
  return e ? (this.forEach((t, r) => {
    e.apply(t, [t, r]);
  }), this) : this;
}
function wnr(e) {
  const t = ITe(this, e);
  return xt(t);
}
function Pnr(e) {
  if (typeof e > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].innerHTML = e;
  return this;
}
function Dnr(e) {
  if (typeof e > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].textContent = e;
  return this;
}
function xnr(e) {
  const t = Xn(), r = Zi(), n = this[0];
  let i, o;
  if (!n || typeof e > "u") return !1;
  if (typeof e == "string") {
    if (n.matches) return n.matches(e);
    if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
    if (n.msMatchesSelector) return n.msMatchesSelector(e);
    for (i = xt(e), o = 0; o < i.length; o += 1)
      if (i[o] === n) return !0;
    return !1;
  }
  if (e === r)
    return n === r;
  if (e === t)
    return n === t;
  if (e.nodeType || e instanceof jl) {
    for (i = e.nodeType ? [e] : e, o = 0; o < i.length; o += 1)
      if (i[o] === n) return !0;
    return !1;
  }
  return !1;
}
function Nnr() {
  let e = this[0], t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function Lnr(e) {
  if (typeof e > "u") return this;
  const t = this.length;
  if (e > t - 1)
    return xt([]);
  if (e < 0) {
    const r = t + e;
    return r < 0 ? xt([]) : xt([this[r]]);
  }
  return xt([this[e]]);
}
function Bnr(...e) {
  let t;
  const r = Zi();
  for (let n = 0; n < e.length; n += 1) {
    t = e[n];
    for (let i = 0; i < this.length; i += 1)
      if (typeof t == "string") {
        const o = r.createElement("div");
        for (o.innerHTML = t; o.firstChild; )
          this[i].appendChild(o.firstChild);
      } else if (t instanceof jl)
        for (let o = 0; o < t.length; o += 1)
          this[i].appendChild(t[o]);
      else
        this[i].appendChild(t);
  }
  return this;
}
function knr(e) {
  const t = Zi();
  let r, n;
  for (r = 0; r < this.length; r += 1)
    if (typeof e == "string") {
      const i = t.createElement("div");
      for (i.innerHTML = e, n = i.childNodes.length - 1; n >= 0; n -= 1)
        this[r].insertBefore(i.childNodes[n], this[r].childNodes[0]);
    } else if (e instanceof jl)
      for (n = 0; n < e.length; n += 1)
        this[r].insertBefore(e[n], this[r].childNodes[0]);
    else
      this[r].insertBefore(e, this[r].childNodes[0]);
  return this;
}
function Mnr(e) {
  return this.length > 0 ? e ? this[0].nextElementSibling && xt(this[0].nextElementSibling).is(e) ? xt([this[0].nextElementSibling]) : xt([]) : this[0].nextElementSibling ? xt([this[0].nextElementSibling]) : xt([]) : xt([]);
}
function Fnr(e) {
  const t = [];
  let r = this[0];
  if (!r) return xt([]);
  for (; r.nextElementSibling; ) {
    const n = r.nextElementSibling;
    e ? xt(n).is(e) && t.push(n) : t.push(n), r = n;
  }
  return xt(t);
}
function Hnr(e) {
  if (this.length > 0) {
    const t = this[0];
    return e ? t.previousElementSibling && xt(t.previousElementSibling).is(e) ? xt([t.previousElementSibling]) : xt([]) : t.previousElementSibling ? xt([t.previousElementSibling]) : xt([]);
  }
  return xt([]);
}
function $nr(e) {
  const t = [];
  let r = this[0];
  if (!r) return xt([]);
  for (; r.previousElementSibling; ) {
    const n = r.previousElementSibling;
    e ? xt(n).is(e) && t.push(n) : t.push(n), r = n;
  }
  return xt(t);
}
function Unr(e) {
  const t = [];
  for (let r = 0; r < this.length; r += 1)
    this[r].parentNode !== null && (e ? xt(this[r].parentNode).is(e) && t.push(this[r].parentNode) : t.push(this[r].parentNode));
  return xt(t);
}
function Vnr(e) {
  const t = [];
  for (let r = 0; r < this.length; r += 1) {
    let n = this[r].parentNode;
    for (; n; )
      e ? xt(n).is(e) && t.push(n) : t.push(n), n = n.parentNode;
  }
  return xt(t);
}
function jnr(e) {
  let t = this;
  return typeof e > "u" ? xt([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
}
function znr(e) {
  const t = [];
  for (let r = 0; r < this.length; r += 1) {
    const n = this[r].querySelectorAll(e);
    for (let i = 0; i < n.length; i += 1)
      t.push(n[i]);
  }
  return xt(t);
}
function qnr(e) {
  const t = [];
  for (let r = 0; r < this.length; r += 1) {
    const n = this[r].children;
    for (let i = 0; i < n.length; i += 1)
      (!e || xt(n[i]).is(e)) && t.push(n[i]);
  }
  return xt(t);
}
function Ynr() {
  for (let e = 0; e < this.length; e += 1)
    this[e].parentNode && this[e].parentNode.removeChild(this[e]);
  return this;
}
const yee = {
  addClass: fnr,
  removeClass: dnr,
  hasClass: hnr,
  toggleClass: pnr,
  attr: vnr,
  removeAttr: Enr,
  transform: mnr,
  transition: gnr,
  on: Tnr,
  off: ynr,
  trigger: _nr,
  transitionEnd: Anr,
  outerWidth: Snr,
  outerHeight: bnr,
  styles: Inr,
  offset: Cnr,
  css: Onr,
  each: Rnr,
  html: Pnr,
  text: Dnr,
  is: xnr,
  index: Nnr,
  eq: Lnr,
  append: Bnr,
  prepend: knr,
  next: Mnr,
  nextAll: Fnr,
  prev: Hnr,
  prevAll: $nr,
  parent: Unr,
  parents: Vnr,
  closest: jnr,
  find: znr,
  children: qnr,
  filter: wnr,
  remove: Ynr
};
Object.keys(yee).forEach((e) => {
  Object.defineProperty(xt.fn, e, {
    value: yee[e],
    writable: !0
  });
});
function Gnr(e) {
  const t = e;
  Object.keys(t).forEach((r) => {
    try {
      t[r] = null;
    } catch {
    }
    try {
      delete t[r];
    } catch {
    }
  });
}
function e0(e, t = 0) {
  return setTimeout(e, t);
}
function tu() {
  return Date.now();
}
function Wnr(e) {
  const t = Xn();
  let r;
  return t.getComputedStyle && (r = t.getComputedStyle(e, null)), !r && e.currentStyle && (r = e.currentStyle), r || (r = e.style), r;
}
function EB(e, t = "x") {
  const r = Xn();
  let n, i, o;
  const a = Wnr(e);
  return r.WebKitCSSMatrix ? (i = a.transform || a.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((u) => u.replace(",", ".")).join(", ")), o = new r.WebKitCSSMatrix(i === "none" ? "" : i)) : (o = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), t === "x" && (r.WebKitCSSMatrix ? i = o.m41 : n.length === 16 ? i = parseFloat(n[12]) : i = parseFloat(n[4])), t === "y" && (r.WebKitCSSMatrix ? i = o.m42 : n.length === 16 ? i = parseFloat(n[13]) : i = parseFloat(n[5])), i || 0;
}
function r1(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Knr(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function eu(...e) {
  const t = Object(e[0]), r = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < e.length; n += 1) {
    const i = e[n];
    if (i != null && !Knr(i)) {
      const o = Object.keys(Object(i)).filter((a) => r.indexOf(a) < 0);
      for (let a = 0, u = o.length; a < u; a += 1) {
        const s = o[a], c = Object.getOwnPropertyDescriptor(i, s);
        c !== void 0 && c.enumerable && (r1(t[s]) && r1(i[s]) ? i[s].__swiper__ ? t[s] = i[s] : eu(t[s], i[s]) : !r1(t[s]) && r1(i[s]) ? (t[s] = {}, i[s].__swiper__ ? t[s] = i[s] : eu(t[s], i[s])) : t[s] = i[s]);
      }
    }
  }
  return t;
}
function n1(e, t, r) {
  e.style.setProperty(t, r);
}
function OTe({
  swiper: e,
  targetPosition: t,
  side: r
}) {
  const n = Xn(), i = -e.translate;
  let o = null, a;
  const u = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
  const s = t > i ? "next" : "prev", c = (f, d) => s === "next" && f >= d || s === "prev" && f <= d, l = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = a);
    const f = Math.max(Math.min((a - o) / u, 1), 0), d = 0.5 - Math.cos(f * Math.PI) / 2;
    let p = i + d * (t - i);
    if (c(p, t) && (p = t), e.wrapperEl.scrollTo({
      [r]: p
    }), c(p, t)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [r]: p
        });
      }), n.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = n.requestAnimationFrame(l);
  };
  l();
}
let GD;
function Xnr() {
  const e = Xn(), t = Zi();
  return {
    smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
    passiveListener: function() {
      let n = !1;
      try {
        const i = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            n = !0;
          }
        });
        e.addEventListener("testPassiveListener", null, i);
      } catch {
      }
      return n;
    }(),
    gestures: function() {
      return "ongesturestart" in e;
    }()
  };
}
function RTe() {
  return GD || (GD = Xnr()), GD;
}
let WD;
function Jnr({
  userAgent: e
} = {}) {
  const t = RTe(), r = Xn(), n = r.navigator.platform, i = e || r.navigator.userAgent, o = {
    ios: !1,
    android: !1
  }, a = r.screen.width, u = r.screen.height, s = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let c = i.match(/(iPad).*OS\s([\d_]+)/);
  const l = i.match(/(iPod)(.*OS\s([\d_]+))?/), f = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), d = n === "Win32";
  let p = n === "MacIntel";
  const v = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !c && p && t.touch && v.indexOf(`${a}x${u}`) >= 0 && (c = i.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), p = !1), s && !d && (o.os = "android", o.android = !0), (c || f || l) && (o.os = "ios", o.ios = !0), o;
}
function Znr(e = {}) {
  return WD || (WD = Jnr(e)), WD;
}
let KD;
function Qnr() {
  const e = Xn();
  function t() {
    const r = e.navigator.userAgent.toLowerCase();
    return r.indexOf("safari") >= 0 && r.indexOf("chrome") < 0 && r.indexOf("android") < 0;
  }
  return {
    isSafari: t(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function eir() {
  return KD || (KD = Qnr()), KD;
}
function tir({
  swiper: e,
  on: t,
  emit: r
}) {
  const n = Xn();
  let i = null, o = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (r("beforeResize"), r("resize"));
  }, u = () => {
    !e || e.destroyed || !e.initialized || (i = new ResizeObserver((l) => {
      o = n.requestAnimationFrame(() => {
        const {
          width: f,
          height: d
        } = e;
        let p = f, v = d;
        l.forEach(({
          contentBoxSize: h,
          contentRect: E,
          target: m
        }) => {
          m && m !== e.el || (p = E ? E.width : (h[0] || h).inlineSize, v = E ? E.height : (h[0] || h).blockSize);
        }), (p !== f || v !== d) && a();
      });
    }), i.observe(e.el));
  }, s = () => {
    o && n.cancelAnimationFrame(o), i && i.unobserve && e.el && (i.unobserve(e.el), i = null);
  }, c = () => {
    !e || e.destroyed || !e.initialized || r("orientationchange");
  };
  t("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      u();
      return;
    }
    n.addEventListener("resize", a), n.addEventListener("orientationchange", c);
  }), t("destroy", () => {
    s(), n.removeEventListener("resize", a), n.removeEventListener("orientationchange", c);
  });
}
function rir({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = [], o = Xn(), a = (c, l = {}) => {
    const f = o.MutationObserver || o.WebkitMutationObserver, d = new f((p) => {
      if (p.length === 1) {
        n("observerUpdate", p[0]);
        return;
      }
      const v = function() {
        n("observerUpdate", p[0]);
      };
      o.requestAnimationFrame ? o.requestAnimationFrame(v) : o.setTimeout(v, 0);
    });
    d.observe(c, {
      attributes: typeof l.attributes > "u" ? !0 : l.attributes,
      childList: typeof l.childList > "u" ? !0 : l.childList,
      characterData: typeof l.characterData > "u" ? !0 : l.characterData
    }), i.push(d);
  }, u = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const c = e.$el.parents();
        for (let l = 0; l < c.length; l += 1)
          a(c[l]);
      }
      a(e.$el[0], {
        childList: e.params.observeSlideChildren
      }), a(e.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, s = () => {
    i.forEach((c) => {
      c.disconnect();
    }), i.splice(0, i.length);
  };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", u), r("destroy", s);
}
const nir = {
  on(e, t, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    const i = r ? "unshift" : "push";
    return e.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][i](t);
    }), n;
  },
  once(e, t, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    function i(...o) {
      n.off(e, i), i.__emitterProxy && delete i.__emitterProxy, t.apply(n, o);
    }
    return i.__emitterProxy = t, n.on(e, i, r);
  },
  onAny(e, t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function") return r;
    const n = t ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[n](e), r;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const r = t.eventsAnyListeners.indexOf(e);
    return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
  },
  off(e, t) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || e.split(" ").forEach((n) => {
      typeof t > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((i, o) => {
        (i === t || i.__emitterProxy && i.__emitterProxy === t) && r.eventsListeners[n].splice(o, 1);
      });
    }), r;
  },
  emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let r, n, i;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (r = e[0], n = e.slice(1, e.length), i = t) : (r = e[0].events, n = e[0].data, i = e[0].context || t), n.unshift(i), (Array.isArray(r) ? r : r.split(" ")).forEach((a) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((u) => {
        u.apply(i, [a, ...n]);
      }), t.eventsListeners && t.eventsListeners[a] && t.eventsListeners[a].forEach((u) => {
        u.apply(i, n);
      });
    }), t;
  }
};
function iir() {
  const e = this;
  let t, r;
  const n = e.$el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = n[0].clientWidth, typeof e.params.height < "u" && e.params.height !== null ? r = e.params.height : r = n[0].clientHeight, !(t === 0 && e.isHorizontal() || r === 0 && e.isVertical()) && (t = t - parseInt(n.css("padding-left") || 0, 10) - parseInt(n.css("padding-right") || 0, 10), r = r - parseInt(n.css("padding-top") || 0, 10) - parseInt(n.css("padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(r) && (r = 0), Object.assign(e, {
    width: t,
    height: r,
    size: e.isHorizontal() ? t : r
  }));
}
function oir() {
  const e = this;
  function t(z) {
    return e.isHorizontal() ? z : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[z];
  }
  function r(z, k) {
    return parseFloat(z.getPropertyValue(t(k)) || 0);
  }
  const n = e.params, {
    $wrapperEl: i,
    size: o,
    rtlTranslate: a,
    wrongRTL: u
  } = e, s = e.virtual && n.virtual.enabled, c = s ? e.virtual.slides.length : e.slides.length, l = i.children(`.${e.params.slideClass}`), f = s ? e.virtual.slides.length : l.length;
  let d = [];
  const p = [], v = [];
  let h = n.slidesOffsetBefore;
  typeof h == "function" && (h = n.slidesOffsetBefore.call(e));
  let E = n.slidesOffsetAfter;
  typeof E == "function" && (E = n.slidesOffsetAfter.call(e));
  const m = e.snapGrid.length, g = e.slidesGrid.length;
  let y = n.spaceBetween, _ = -h, S = 0, A = 0;
  if (typeof o > "u")
    return;
  typeof y == "string" && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * o), e.virtualSize = -y, a ? l.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : l.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), n.centeredSlides && n.cssMode && (n1(e.wrapperEl, "--swiper-centered-offset-before", ""), n1(e.wrapperEl, "--swiper-centered-offset-after", ""));
  const O = n.grid && n.grid.rows > 1 && e.grid;
  O && e.grid.initSlides(f);
  let P;
  const U = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((z) => typeof n.breakpoints[z].slidesPerView < "u").length > 0;
  for (let z = 0; z < f; z += 1) {
    P = 0;
    const k = l.eq(z);
    if (O && e.grid.updateSlide(z, k, f, t), k.css("display") !== "none") {
      if (n.slidesPerView === "auto") {
        U && (l[z].style[t("width")] = "");
        const H = getComputedStyle(k[0]), B = k[0].style.transform, x = k[0].style.webkitTransform;
        if (B && (k[0].style.transform = "none"), x && (k[0].style.webkitTransform = "none"), n.roundLengths)
          P = e.isHorizontal() ? k.outerWidth(!0) : k.outerHeight(!0);
        else {
          const D = r(H, "width"), w = r(H, "padding-left"), $ = r(H, "padding-right"), X = r(H, "margin-left"), V = r(H, "margin-right"), F = H.getPropertyValue("box-sizing");
          if (F && F === "border-box")
            P = D + X + V;
          else {
            const {
              clientWidth: le,
              offsetWidth: ae
            } = k[0];
            P = D + w + $ + X + V + (ae - le);
          }
        }
        B && (k[0].style.transform = B), x && (k[0].style.webkitTransform = x), n.roundLengths && (P = Math.floor(P));
      } else
        P = (o - (n.slidesPerView - 1) * y) / n.slidesPerView, n.roundLengths && (P = Math.floor(P)), l[z] && (l[z].style[t("width")] = `${P}px`);
      l[z] && (l[z].swiperSlideSize = P), v.push(P), n.centeredSlides ? (_ = _ + P / 2 + S / 2 + y, S === 0 && z !== 0 && (_ = _ - o / 2 - y), z === 0 && (_ = _ - o / 2 - y), Math.abs(_) < 1 / 1e3 && (_ = 0), n.roundLengths && (_ = Math.floor(_)), A % n.slidesPerGroup === 0 && d.push(_), p.push(_)) : (n.roundLengths && (_ = Math.floor(_)), (A - Math.min(e.params.slidesPerGroupSkip, A)) % e.params.slidesPerGroup === 0 && d.push(_), p.push(_), _ = _ + P + y), e.virtualSize += P + y, S = P, A += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, o) + E, a && u && (n.effect === "slide" || n.effect === "coverflow") && i.css({
    width: `${e.virtualSize + n.spaceBetween}px`
  }), n.setWrapperSize && i.css({
    [t("width")]: `${e.virtualSize + n.spaceBetween}px`
  }), O && e.grid.updateWrapperSize(P, d, t), !n.centeredSlides) {
    const z = [];
    for (let k = 0; k < d.length; k += 1) {
      let H = d[k];
      n.roundLengths && (H = Math.floor(H)), d[k] <= e.virtualSize - o && z.push(H);
    }
    d = z, Math.floor(e.virtualSize - o) - Math.floor(d[d.length - 1]) > 1 && d.push(e.virtualSize - o);
  }
  if (d.length === 0 && (d = [0]), n.spaceBetween !== 0) {
    const z = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
    l.filter((k, H) => n.cssMode ? H !== l.length - 1 : !0).css({
      [z]: `${y}px`
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let z = 0;
    v.forEach((H) => {
      z += H + (n.spaceBetween ? n.spaceBetween : 0);
    }), z -= n.spaceBetween;
    const k = z - o;
    d = d.map((H) => H < 0 ? -h : H > k ? k + E : H);
  }
  if (n.centerInsufficientSlides) {
    let z = 0;
    if (v.forEach((k) => {
      z += k + (n.spaceBetween ? n.spaceBetween : 0);
    }), z -= n.spaceBetween, z < o) {
      const k = (o - z) / 2;
      d.forEach((H, B) => {
        d[B] = H - k;
      }), p.forEach((H, B) => {
        p[B] = H + k;
      });
    }
  }
  if (Object.assign(e, {
    slides: l,
    snapGrid: d,
    slidesGrid: p,
    slidesSizesGrid: v
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    n1(e.wrapperEl, "--swiper-centered-offset-before", `${-d[0]}px`), n1(e.wrapperEl, "--swiper-centered-offset-after", `${e.size / 2 - v[v.length - 1] / 2}px`);
    const z = -e.snapGrid[0], k = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((H) => H + z), e.slidesGrid = e.slidesGrid.map((H) => H + k);
  }
  if (f !== c && e.emit("slidesLengthChange"), d.length !== m && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== g && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), !s && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const z = `${n.containerModifierClass}backface-hidden`, k = e.$el.hasClass(z);
    f <= n.maxBackfaceHiddenSlides ? k || e.$el.addClass(z) : k && e.$el.removeClass(z);
  }
}
function air(e) {
  const t = this, r = [], n = t.virtual && t.params.virtual.enabled;
  let i = 0, o;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const a = (u) => n ? t.slides.filter((s) => parseInt(s.getAttribute("data-swiper-slide-index"), 10) === u)[0] : t.slides.eq(u)[0];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || xt([])).each((u) => {
        r.push(u);
      });
    else
      for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
        const u = t.activeIndex + o;
        if (u > t.slides.length && !n) break;
        r.push(a(u));
      }
  else
    r.push(a(t.activeIndex));
  for (o = 0; o < r.length; o += 1)
    if (typeof r[o] < "u") {
      const u = r[o].offsetHeight;
      i = u > i ? u : i;
    }
  (i || i === 0) && t.$wrapperEl.css("height", `${i}px`);
}
function uir() {
  const e = this, t = e.slides;
  for (let r = 0; r < t.length; r += 1)
    t[r].swiperSlideOffset = e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop;
}
function sir(e = this && this.translate || 0) {
  const t = this, r = t.params, {
    slides: n,
    rtlTranslate: i,
    snapGrid: o
  } = t;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let a = -e;
  i && (a = e), n.removeClass(r.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  for (let u = 0; u < n.length; u += 1) {
    const s = n[u];
    let c = s.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (c -= n[0].swiperSlideOffset);
    const l = (a + (r.centeredSlides ? t.minTranslate() : 0) - c) / (s.swiperSlideSize + r.spaceBetween), f = (a - o[0] + (r.centeredSlides ? t.minTranslate() : 0) - c) / (s.swiperSlideSize + r.spaceBetween), d = -(a - c), p = d + t.slidesSizesGrid[u];
    (d >= 0 && d < t.size - 1 || p > 1 && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(s), t.visibleSlidesIndexes.push(u), n.eq(u).addClass(r.slideVisibleClass)), s.progress = i ? -l : l, s.originalProgress = i ? -f : f;
  }
  t.visibleSlides = xt(t.visibleSlides);
}
function cir(e) {
  const t = this;
  if (typeof e > "u") {
    const c = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * c || 0;
  }
  const r = t.params, n = t.maxTranslate() - t.minTranslate();
  let {
    progress: i,
    isBeginning: o,
    isEnd: a
  } = t;
  const u = o, s = a;
  n === 0 ? (i = 0, o = !0, a = !0) : (i = (e - t.minTranslate()) / n, o = i <= 0, a = i >= 1), Object.assign(t, {
    progress: i,
    isBeginning: o,
    isEnd: a
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), o && !u && t.emit("reachBeginning toEdge"), a && !s && t.emit("reachEnd toEdge"), (u && !o || s && !a) && t.emit("fromEdge"), t.emit("progress", i);
}
function lir() {
  const e = this, {
    slides: t,
    params: r,
    $wrapperEl: n,
    activeIndex: i,
    realIndex: o
  } = e, a = e.virtual && r.virtual.enabled;
  t.removeClass(`${r.slideActiveClass} ${r.slideNextClass} ${r.slidePrevClass} ${r.slideDuplicateActiveClass} ${r.slideDuplicateNextClass} ${r.slideDuplicatePrevClass}`);
  let u;
  a ? u = e.$wrapperEl.find(`.${r.slideClass}[data-swiper-slide-index="${i}"]`) : u = t.eq(i), u.addClass(r.slideActiveClass), r.loop && (u.hasClass(r.slideDuplicateClass) ? n.children(`.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${o}"]`).addClass(r.slideDuplicateActiveClass) : n.children(`.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${o}"]`).addClass(r.slideDuplicateActiveClass));
  let s = u.nextAll(`.${r.slideClass}`).eq(0).addClass(r.slideNextClass);
  r.loop && s.length === 0 && (s = t.eq(0), s.addClass(r.slideNextClass));
  let c = u.prevAll(`.${r.slideClass}`).eq(0).addClass(r.slidePrevClass);
  r.loop && c.length === 0 && (c = t.eq(-1), c.addClass(r.slidePrevClass)), r.loop && (s.hasClass(r.slideDuplicateClass) ? n.children(`.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${s.attr("data-swiper-slide-index")}"]`).addClass(r.slideDuplicateNextClass) : n.children(`.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${s.attr("data-swiper-slide-index")}"]`).addClass(r.slideDuplicateNextClass), c.hasClass(r.slideDuplicateClass) ? n.children(`.${r.slideClass}:not(.${r.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(r.slideDuplicatePrevClass) : n.children(`.${r.slideClass}.${r.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(r.slideDuplicatePrevClass)), e.emitSlidesClasses();
}
function fir(e) {
  const t = this, r = t.rtlTranslate ? t.translate : -t.translate, {
    slidesGrid: n,
    snapGrid: i,
    params: o,
    activeIndex: a,
    realIndex: u,
    snapIndex: s
  } = t;
  let c = e, l;
  if (typeof c > "u") {
    for (let d = 0; d < n.length; d += 1)
      typeof n[d + 1] < "u" ? r >= n[d] && r < n[d + 1] - (n[d + 1] - n[d]) / 2 ? c = d : r >= n[d] && r < n[d + 1] && (c = d + 1) : r >= n[d] && (c = d);
    o.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0);
  }
  if (i.indexOf(r) >= 0)
    l = i.indexOf(r);
  else {
    const d = Math.min(o.slidesPerGroupSkip, c);
    l = d + Math.floor((c - d) / o.slidesPerGroup);
  }
  if (l >= i.length && (l = i.length - 1), c === a) {
    l !== s && (t.snapIndex = l, t.emit("snapIndexChange"));
    return;
  }
  const f = parseInt(t.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
  Object.assign(t, {
    snapIndex: l,
    realIndex: f,
    previousIndex: a,
    activeIndex: c
  }), t.emit("activeIndexChange"), t.emit("snapIndexChange"), u !== f && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
}
function dir(e) {
  const t = this, r = t.params, n = xt(e).closest(`.${r.slideClass}`)[0];
  let i = !1, o;
  if (n) {
    for (let a = 0; a < t.slides.length; a += 1)
      if (t.slides[a] === n) {
        i = !0, o = a;
        break;
      }
  }
  if (n && i)
    t.clickedSlide = n, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(xt(n).attr("data-swiper-slide-index"), 10) : t.clickedIndex = o;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
const pir = {
  updateSize: iir,
  updateSlides: oir,
  updateAutoHeight: air,
  updateSlidesOffset: uir,
  updateSlidesProgress: sir,
  updateProgress: cir,
  updateSlidesClasses: lir,
  updateActiveIndex: fir,
  updateClickedSlide: dir
};
function hir(e = this.isHorizontal() ? "x" : "y") {
  const t = this, {
    params: r,
    rtlTranslate: n,
    translate: i,
    $wrapperEl: o
  } = t;
  if (r.virtualTranslate)
    return n ? -i : i;
  if (r.cssMode)
    return i;
  let a = EB(o[0], e);
  return n && (a = -a), a || 0;
}
function vir(e, t) {
  const r = this, {
    rtlTranslate: n,
    params: i,
    $wrapperEl: o,
    wrapperEl: a,
    progress: u
  } = r;
  let s = 0, c = 0;
  const l = 0;
  r.isHorizontal() ? s = n ? -e : e : c = e, i.roundLengths && (s = Math.floor(s), c = Math.floor(c)), i.cssMode ? a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -s : -c : i.virtualTranslate || o.transform(`translate3d(${s}px, ${c}px, ${l}px)`), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? s : c;
  let f;
  const d = r.maxTranslate() - r.minTranslate();
  d === 0 ? f = 0 : f = (e - r.minTranslate()) / d, f !== u && r.updateProgress(e), r.emit("setTranslate", r.translate, t);
}
function Eir() {
  return -this.snapGrid[0];
}
function mir() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function gir(e = 0, t = this.params.speed, r = !0, n = !0, i) {
  const o = this, {
    params: a,
    wrapperEl: u
  } = o;
  if (o.animating && a.preventInteractionOnTransition)
    return !1;
  const s = o.minTranslate(), c = o.maxTranslate();
  let l;
  if (n && e > s ? l = s : n && e < c ? l = c : l = e, o.updateProgress(l), a.cssMode) {
    const f = o.isHorizontal();
    if (t === 0)
      u[f ? "scrollLeft" : "scrollTop"] = -l;
    else {
      if (!o.support.smoothScroll)
        return OTe({
          swiper: o,
          targetPosition: -l,
          side: f ? "left" : "top"
        }), !0;
      u.scrollTo({
        [f ? "left" : "top"]: -l,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (o.setTransition(0), o.setTranslate(l), r && (o.emit("beforeTransitionStart", t, i), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(l), r && (o.emit("beforeTransitionStart", t, i), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(d) {
    !o || o.destroyed || d.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, r && o.emit("transitionEnd"));
  }), o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))), !0;
}
const Tir = {
  getTranslate: hir,
  setTranslate: vir,
  minTranslate: Eir,
  maxTranslate: mir,
  translateTo: gir
};
function yir(e, t) {
  const r = this;
  r.params.cssMode || r.$wrapperEl.transition(e), r.emit("setTransition", e, t);
}
function wTe({
  swiper: e,
  runCallbacks: t,
  direction: r,
  step: n
}) {
  const {
    activeIndex: i,
    previousIndex: o
  } = e;
  let a = r;
  if (a || (i > o ? a = "next" : i < o ? a = "prev" : a = "reset"), e.emit(`transition${n}`), t && i !== o) {
    if (a === "reset") {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    e.emit(`slideChangeTransition${n}`), a === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
  }
}
function _ir(e = !0, t) {
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), wTe({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function Air(e = !0, t) {
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), wTe({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
const Sir = {
  setTransition: yir,
  transitionStart: _ir,
  transitionEnd: Air
};
function bir(e = 0, t = this.params.speed, r = !0, n, i) {
  if (typeof e != "number" && typeof e != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
  if (typeof e == "string") {
    const y = parseInt(e, 10);
    if (!isFinite(y))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = y;
  }
  const o = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: u,
    snapGrid: s,
    slidesGrid: c,
    previousIndex: l,
    activeIndex: f,
    rtlTranslate: d,
    wrapperEl: p,
    enabled: v
  } = o;
  if (o.animating && u.preventInteractionOnTransition || !v && !n && !i)
    return !1;
  const h = Math.min(o.params.slidesPerGroupSkip, a);
  let E = h + Math.floor((a - h) / o.params.slidesPerGroup);
  E >= s.length && (E = s.length - 1);
  const m = -s[E];
  if (u.normalizeSlideIndex)
    for (let y = 0; y < c.length; y += 1) {
      const _ = -Math.floor(m * 100), S = Math.floor(c[y] * 100), A = Math.floor(c[y + 1] * 100);
      typeof c[y + 1] < "u" ? _ >= S && _ < A - (A - S) / 2 ? a = y : _ >= S && _ < A && (a = y + 1) : _ >= S && (a = y);
    }
  if (o.initialized && a !== f && (!o.allowSlideNext && m < o.translate && m < o.minTranslate() || !o.allowSlidePrev && m > o.translate && m > o.maxTranslate() && (f || 0) !== a))
    return !1;
  a !== (l || 0) && r && o.emit("beforeSlideChangeStart"), o.updateProgress(m);
  let g;
  if (a > f ? g = "next" : a < f ? g = "prev" : g = "reset", d && -m === o.translate || !d && m === o.translate)
    return o.updateActiveIndex(a), u.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), u.effect !== "slide" && o.setTranslate(m), g !== "reset" && (o.transitionStart(r, g), o.transitionEnd(r, g)), !1;
  if (u.cssMode) {
    const y = o.isHorizontal(), _ = d ? m : -m;
    if (t === 0) {
      const S = o.virtual && o.params.virtual.enabled;
      S && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), p[y ? "scrollLeft" : "scrollTop"] = _, S && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._swiperImmediateVirtual = !1;
      });
    } else {
      if (!o.support.smoothScroll)
        return OTe({
          swiper: o,
          targetPosition: _,
          side: y ? "left" : "top"
        }), !0;
      p.scrollTo({
        [y ? "left" : "top"]: _,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return o.setTransition(t), o.setTranslate(m), o.updateActiveIndex(a), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, n), o.transitionStart(r, g), t === 0 ? o.transitionEnd(r, g) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(_) {
    !o || o.destroyed || _.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(r, g));
  }), o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd)), !0;
}
function Cir(e = 0, t = this.params.speed, r = !0, n) {
  if (typeof e == "string") {
    const a = parseInt(e, 10);
    if (!isFinite(a))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = a;
  }
  const i = this;
  let o = e;
  return i.params.loop && (o += i.loopedSlides), i.slideTo(o, t, r, n);
}
function Iir(e = this.params.speed, t = !0, r) {
  const n = this, {
    animating: i,
    enabled: o,
    params: a
  } = n;
  if (!o) return n;
  let u = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (u = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const s = n.activeIndex < a.slidesPerGroupSkip ? 1 : u;
  if (a.loop) {
    if (i && a.loopPreventsSlide) return !1;
    n.loopFix(), n._clientLeft = n.$wrapperEl[0].clientLeft;
  }
  return a.rewind && n.isEnd ? n.slideTo(0, e, t, r) : n.slideTo(n.activeIndex + s, e, t, r);
}
function Oir(e = this.params.speed, t = !0, r) {
  const n = this, {
    params: i,
    animating: o,
    snapGrid: a,
    slidesGrid: u,
    rtlTranslate: s,
    enabled: c
  } = n;
  if (!c) return n;
  if (i.loop) {
    if (o && i.loopPreventsSlide) return !1;
    n.loopFix(), n._clientLeft = n.$wrapperEl[0].clientLeft;
  }
  const l = s ? n.translate : -n.translate;
  function f(E) {
    return E < 0 ? -Math.floor(Math.abs(E)) : Math.floor(E);
  }
  const d = f(l), p = a.map((E) => f(E));
  let v = a[p.indexOf(d) - 1];
  if (typeof v > "u" && i.cssMode) {
    let E;
    a.forEach((m, g) => {
      d >= m && (E = g);
    }), typeof E < "u" && (v = a[E > 0 ? E - 1 : E]);
  }
  let h = 0;
  if (typeof v < "u" && (h = u.indexOf(v), h < 0 && (h = n.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (h = h - n.slidesPerViewDynamic("previous", !0) + 1, h = Math.max(h, 0))), i.rewind && n.isBeginning) {
    const E = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(E, e, t, r);
  }
  return n.slideTo(h, e, t, r);
}
function Rir(e = this.params.speed, t = !0, r) {
  const n = this;
  return n.slideTo(n.activeIndex, e, t, r);
}
function wir(e = this.params.speed, t = !0, r, n = 0.5) {
  const i = this;
  let o = i.activeIndex;
  const a = Math.min(i.params.slidesPerGroupSkip, o), u = a + Math.floor((o - a) / i.params.slidesPerGroup), s = i.rtlTranslate ? i.translate : -i.translate;
  if (s >= i.snapGrid[u]) {
    const c = i.snapGrid[u], l = i.snapGrid[u + 1];
    s - c > (l - c) * n && (o += i.params.slidesPerGroup);
  } else {
    const c = i.snapGrid[u - 1], l = i.snapGrid[u];
    s - c <= (l - c) * n && (o -= i.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, i.slidesGrid.length - 1), i.slideTo(o, e, t, r);
}
function Pir() {
  const e = this, {
    params: t,
    $wrapperEl: r
  } = e, n = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let i = e.clickedIndex, o;
  if (t.loop) {
    if (e.animating) return;
    o = parseInt(xt(e.clickedSlide).attr("data-swiper-slide-index"), 10), t.centeredSlides ? i < e.loopedSlides - n / 2 || i > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(), i = r.children(`.${t.slideClass}[data-swiper-slide-index="${o}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), e0(() => {
      e.slideTo(i);
    })) : e.slideTo(i) : i > e.slides.length - n ? (e.loopFix(), i = r.children(`.${t.slideClass}[data-swiper-slide-index="${o}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), e0(() => {
      e.slideTo(i);
    })) : e.slideTo(i);
  } else
    e.slideTo(i);
}
const Dir = {
  slideTo: bir,
  slideToLoop: Cir,
  slideNext: Iir,
  slidePrev: Oir,
  slideReset: Rir,
  slideToClosest: wir,
  slideToClickedSlide: Pir
};
function xir() {
  const e = this, t = Zi(), {
    params: r,
    $wrapperEl: n
  } = e, i = n.children().length > 0 ? xt(n.children()[0].parentNode) : n;
  i.children(`.${r.slideClass}.${r.slideDuplicateClass}`).remove();
  let o = i.children(`.${r.slideClass}`);
  if (r.loopFillGroupWithBlank) {
    const s = r.slidesPerGroup - o.length % r.slidesPerGroup;
    if (s !== r.slidesPerGroup) {
      for (let c = 0; c < s; c += 1) {
        const l = xt(t.createElement("div")).addClass(`${r.slideClass} ${r.slideBlankClass}`);
        i.append(l);
      }
      o = i.children(`.${r.slideClass}`);
    }
  }
  r.slidesPerView === "auto" && !r.loopedSlides && (r.loopedSlides = o.length), e.loopedSlides = Math.ceil(parseFloat(r.loopedSlides || r.slidesPerView, 10)), e.loopedSlides += r.loopAdditionalSlides, e.loopedSlides > o.length && e.params.loopedSlidesLimit && (e.loopedSlides = o.length);
  const a = [], u = [];
  o.each((s, c) => {
    xt(s).attr("data-swiper-slide-index", c);
  });
  for (let s = 0; s < e.loopedSlides; s += 1) {
    const c = s - Math.floor(s / o.length) * o.length;
    u.push(o.eq(c)[0]), a.unshift(o.eq(o.length - c - 1)[0]);
  }
  for (let s = 0; s < u.length; s += 1)
    i.append(xt(u[s].cloneNode(!0)).addClass(r.slideDuplicateClass));
  for (let s = a.length - 1; s >= 0; s -= 1)
    i.prepend(xt(a[s].cloneNode(!0)).addClass(r.slideDuplicateClass));
}
function Nir() {
  const e = this;
  e.emit("beforeLoopFix");
  const {
    activeIndex: t,
    slides: r,
    loopedSlides: n,
    allowSlidePrev: i,
    allowSlideNext: o,
    snapGrid: a,
    rtlTranslate: u
  } = e;
  let s;
  e.allowSlidePrev = !0, e.allowSlideNext = !0;
  const l = -a[t] - e.getTranslate();
  t < n ? (s = r.length - n * 3 + t, s += n, e.slideTo(s, 0, !1, !0) && l !== 0 && e.setTranslate((u ? -e.translate : e.translate) - l)) : t >= r.length - n && (s = -r.length + t + n, s += n, e.slideTo(s, 0, !1, !0) && l !== 0 && e.setTranslate((u ? -e.translate : e.translate) - l)), e.allowSlidePrev = i, e.allowSlideNext = o, e.emit("loopFix");
}
function Lir() {
  const e = this, {
    $wrapperEl: t,
    params: r,
    slides: n
  } = e;
  t.children(`.${r.slideClass}.${r.slideDuplicateClass},.${r.slideClass}.${r.slideBlankClass}`).remove(), n.removeAttr("data-swiper-slide-index");
}
const Bir = {
  loopCreate: xir,
  loopFix: Nir,
  loopDestroy: Lir
};
function kir(e) {
  const t = this;
  if (t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const r = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  r.style.cursor = "move", r.style.cursor = e ? "grabbing" : "grab";
}
function Mir() {
  const e = this;
  e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const Fir = {
  setGrabCursor: kir,
  unsetGrabCursor: Mir
};
function Hir(e, t = this) {
  function r(n) {
    if (!n || n === Zi() || n === Xn()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const i = n.closest(e);
    return !i && !n.getRootNode ? null : i || r(n.getRootNode().host);
  }
  return r(t);
}
function $ir(e) {
  const t = this, r = Zi(), n = Xn(), i = t.touchEventsData, {
    params: o,
    touches: a,
    enabled: u
  } = t;
  if (!u || t.animating && o.preventInteractionOnTransition)
    return;
  !t.animating && o.cssMode && o.loop && t.loopFix();
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  let c = xt(s.target);
  if (o.touchEventsTarget === "wrapper" && !c.closest(t.wrapperEl).length || (i.isTouchEvent = s.type === "touchstart", !i.isTouchEvent && "which" in s && s.which === 3) || !i.isTouchEvent && "button" in s && s.button > 0 || i.isTouched && i.isMoved) return;
  const l = !!o.noSwipingClass && o.noSwipingClass !== "", f = e.composedPath ? e.composedPath() : e.path;
  l && s.target && s.target.shadowRoot && f && (c = xt(f[0]));
  const d = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, p = !!(s.target && s.target.shadowRoot);
  if (o.noSwiping && (p ? Hir(d, c[0]) : c.closest(d)[0])) {
    t.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !c.closest(o.swipeHandler)[0])
    return;
  a.currentX = s.type === "touchstart" ? s.targetTouches[0].pageX : s.pageX, a.currentY = s.type === "touchstart" ? s.targetTouches[0].pageY : s.pageY;
  const v = a.currentX, h = a.currentY, E = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection, m = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
  if (E && (v <= m || v >= n.innerWidth - m))
    if (E === "prevent")
      e.preventDefault();
    else
      return;
  if (Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = v, a.startY = h, i.touchStartTime = tu(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (i.allowThresholdMove = !1), s.type !== "touchstart") {
    let g = !0;
    c.is(i.focusableElements) && (g = !1, c[0].nodeName === "SELECT" && (i.isTouched = !1)), r.activeElement && xt(r.activeElement).is(i.focusableElements) && r.activeElement !== c[0] && r.activeElement.blur();
    const y = g && t.allowTouchMove && o.touchStartPreventDefault;
    (o.touchStartForcePreventDefault || y) && !c[0].isContentEditable && s.preventDefault();
  }
  t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
}
function Uir(e) {
  const t = Zi(), r = this, n = r.touchEventsData, {
    params: i,
    touches: o,
    rtlTranslate: a,
    enabled: u
  } = r;
  if (!u) return;
  let s = e;
  if (s.originalEvent && (s = s.originalEvent), !n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", s);
    return;
  }
  if (n.isTouchEvent && s.type !== "touchmove") return;
  const c = s.type === "touchmove" && s.targetTouches && (s.targetTouches[0] || s.changedTouches[0]), l = s.type === "touchmove" ? c.pageX : s.pageX, f = s.type === "touchmove" ? c.pageY : s.pageY;
  if (s.preventedByNestedSwiper) {
    o.startX = l, o.startY = f;
    return;
  }
  if (!r.allowTouchMove) {
    xt(s.target).is(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(o, {
      startX: l,
      startY: f,
      currentX: l,
      currentY: f
    }), n.touchStartTime = tu());
    return;
  }
  if (n.isTouchEvent && i.touchReleaseOnEdges && !i.loop) {
    if (r.isVertical()) {
      if (f < o.startY && r.translate <= r.maxTranslate() || f > o.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else if (l < o.startX && r.translate <= r.maxTranslate() || l > o.startX && r.translate >= r.minTranslate())
      return;
  }
  if (n.isTouchEvent && t.activeElement && s.target === t.activeElement && xt(s.target).is(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  if (n.allowTouchCallbacks && r.emit("touchMove", s), s.targetTouches && s.targetTouches.length > 1) return;
  o.currentX = l, o.currentY = f;
  const d = o.currentX - o.startX, p = o.currentY - o.startY;
  if (r.params.threshold && Math.sqrt(d ** 2 + p ** 2) < r.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let m;
    r.isHorizontal() && o.currentY === o.startY || r.isVertical() && o.currentX === o.startX ? n.isScrolling = !1 : d * d + p * p >= 25 && (m = Math.atan2(Math.abs(p), Math.abs(d)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? m > i.touchAngle : 90 - m > i.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", s), typeof n.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = !0), n.isScrolling) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !i.cssMode && s.cancelable && s.preventDefault(), i.touchMoveStopPropagation && !i.nested && s.stopPropagation(), n.isMoved || (i.loop && !i.cssMode && r.loopFix(), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating && r.$wrapperEl.trigger("webkitTransitionEnd transitionend"), n.allowMomentumBounce = !1, i.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", s)), r.emit("sliderMove", s), n.isMoved = !0;
  let v = r.isHorizontal() ? d : p;
  o.diff = v, v *= i.touchRatio, a && (v = -v), r.swipeDirection = v > 0 ? "prev" : "next", n.currentTranslate = v + n.startTranslate;
  let h = !0, E = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (E = 0), v > 0 && n.currentTranslate > r.minTranslate() ? (h = !1, i.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + v) ** E)) : v < 0 && n.currentTranslate < r.maxTranslate() && (h = !1, i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - v) ** E)), h && (s.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), i.threshold > 0)
    if (Math.abs(v) > i.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = r.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && r.freeMode || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), r.params.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function Vir(e) {
  const t = this, r = t.touchEventsData, {
    params: n,
    touches: i,
    rtlTranslate: o,
    slidesGrid: a,
    enabled: u
  } = t;
  if (!u) return;
  let s = e;
  if (s.originalEvent && (s = s.originalEvent), r.allowTouchCallbacks && t.emit("touchEnd", s), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && n.grabCursor && t.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  n.grabCursor && r.isMoved && r.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const c = tu(), l = c - r.touchStartTime;
  if (t.allowClick) {
    const g = s.path || s.composedPath && s.composedPath();
    t.updateClickedSlide(g && g[0] || s.target), t.emit("tap click", s), l < 300 && c - r.lastClickTime < 300 && t.emit("doubleTap doubleClick", s);
  }
  if (r.lastClickTime = tu(), e0(() => {
    t.destroyed || (t.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !t.swipeDirection || i.diff === 0 || r.currentTranslate === r.startTranslate) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let f;
  if (n.followFinger ? f = o ? t.translate : -t.translate : f = -r.currentTranslate, n.cssMode)
    return;
  if (t.params.freeMode && n.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: f
    });
    return;
  }
  let d = 0, p = t.slidesSizesGrid[0];
  for (let g = 0; g < a.length; g += g < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup) {
    const y = g < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
    typeof a[g + y] < "u" ? f >= a[g] && f < a[g + y] && (d = g, p = a[g + y] - a[g]) : f >= a[g] && (d = g, p = a[a.length - 1] - a[a.length - 2]);
  }
  let v = null, h = null;
  n.rewind && (t.isBeginning ? h = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (v = 0));
  const E = (f - a[d]) / p, m = d < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
  if (l > n.longSwipesMs) {
    if (!n.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (E >= n.longSwipesRatio ? t.slideTo(n.rewind && t.isEnd ? v : d + m) : t.slideTo(d)), t.swipeDirection === "prev" && (E > 1 - n.longSwipesRatio ? t.slideTo(d + m) : h !== null && E < 0 && Math.abs(E) > n.longSwipesRatio ? t.slideTo(h) : t.slideTo(d));
  } else {
    if (!n.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (s.target === t.navigation.nextEl || s.target === t.navigation.prevEl) ? s.target === t.navigation.nextEl ? t.slideTo(d + m) : t.slideTo(d) : (t.swipeDirection === "next" && t.slideTo(v !== null ? v : d + m), t.swipeDirection === "prev" && t.slideTo(h !== null ? h : d));
  }
}
function _ee() {
  const e = this, {
    params: t,
    el: r
  } = e;
  if (r && r.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: i,
    snapGrid: o
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = i, e.allowSlideNext = n, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
}
function jir(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function zir() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: r,
    enabled: n
  } = e;
  if (!n) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let i;
  const o = e.maxTranslate() - e.minTranslate();
  o === 0 ? i = 0 : i = (e.translate - e.minTranslate()) / o, i !== e.progress && e.updateProgress(r ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let Aee = !1;
function qir() {
}
const PTe = (e, t) => {
  const r = Zi(), {
    params: n,
    touchEvents: i,
    el: o,
    wrapperEl: a,
    device: u,
    support: s
  } = e, c = !!n.nested, l = t === "on" ? "addEventListener" : "removeEventListener", f = t;
  if (!s.touch)
    o[l](i.start, e.onTouchStart, !1), r[l](i.move, e.onTouchMove, c), r[l](i.end, e.onTouchEnd, !1);
  else {
    const d = i.start === "touchstart" && s.passiveListener && n.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    o[l](i.start, e.onTouchStart, d), o[l](i.move, e.onTouchMove, s.passiveListener ? {
      passive: !1,
      capture: c
    } : c), o[l](i.end, e.onTouchEnd, d), i.cancel && o[l](i.cancel, e.onTouchEnd, d);
  }
  (n.preventClicks || n.preventClicksPropagation) && o[l]("click", e.onClick, !0), n.cssMode && a[l]("scroll", e.onScroll), n.updateOnWindowResize ? e[f](u.ios || u.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", _ee, !0) : e[f]("observerUpdate", _ee, !0);
};
function Yir() {
  const e = this, t = Zi(), {
    params: r,
    support: n
  } = e;
  e.onTouchStart = $ir.bind(e), e.onTouchMove = Uir.bind(e), e.onTouchEnd = Vir.bind(e), r.cssMode && (e.onScroll = zir.bind(e)), e.onClick = jir.bind(e), n.touch && !Aee && (t.addEventListener("touchstart", qir), Aee = !0), PTe(e, "on");
}
function Gir() {
  PTe(this, "off");
}
const Wir = {
  attachEvents: Yir,
  detachEvents: Gir
}, See = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function Kir() {
  const e = this, {
    activeIndex: t,
    initialized: r,
    loopedSlides: n = 0,
    params: i,
    $el: o
  } = e, a = i.breakpoints;
  if (!a || a && Object.keys(a).length === 0) return;
  const u = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
  if (!u || e.currentBreakpoint === u) return;
  const c = (u in a ? a[u] : void 0) || e.originalParams, l = See(e, i), f = See(e, c), d = i.enabled;
  l && !f ? (o.removeClass(`${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`), e.emitContainerClasses()) : !l && f && (o.addClass(`${i.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && i.grid.fill === "column") && o.addClass(`${i.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((E) => {
    const m = i[E] && i[E].enabled, g = c[E] && c[E].enabled;
    m && !g && e[E].disable(), !m && g && e[E].enable();
  });
  const p = c.direction && c.direction !== i.direction, v = i.loop && (c.slidesPerView !== i.slidesPerView || p);
  p && r && e.changeDirection(), eu(e.params, c);
  const h = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), d && !h ? e.disable() : !d && h && e.enable(), e.currentBreakpoint = u, e.emit("_beforeBreakpoint", c), v && r && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - n + e.loopedSlides, 0, !1)), e.emit("breakpoint", c);
}
function Xir(e, t = "window", r) {
  if (!e || t === "container" && !r) return;
  let n = !1;
  const i = Xn(), o = t === "window" ? i.innerHeight : r.clientHeight, a = Object.keys(e).map((u) => {
    if (typeof u == "string" && u.indexOf("@") === 0) {
      const s = parseFloat(u.substr(1));
      return {
        value: o * s,
        point: u
      };
    }
    return {
      value: u,
      point: u
    };
  });
  a.sort((u, s) => parseInt(u.value, 10) - parseInt(s.value, 10));
  for (let u = 0; u < a.length; u += 1) {
    const {
      point: s,
      value: c
    } = a[u];
    t === "window" ? i.matchMedia(`(min-width: ${c}px)`).matches && (n = s) : c <= r.clientWidth && (n = s);
  }
  return n || "max";
}
const Jir = {
  setBreakpoint: Kir,
  getBreakpoint: Xir
};
function Zir(e, t) {
  const r = [];
  return e.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((i) => {
      n[i] && r.push(t + i);
    }) : typeof n == "string" && r.push(t + n);
  }), r;
}
function Qir() {
  const e = this, {
    classNames: t,
    params: r,
    rtl: n,
    $el: i,
    device: o,
    support: a
  } = e, u = Zir(["initialized", r.direction, {
    "pointer-events": !a.touch
  }, {
    "free-mode": e.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  t.push(...u), i.addClass([...t].join(" ")), e.emitContainerClasses();
}
function eor() {
  const e = this, {
    $el: t,
    classNames: r
  } = e;
  t.removeClass(r.join(" ")), e.emitContainerClasses();
}
const tor = {
  addClasses: Qir,
  removeClasses: eor
};
function ror(e, t, r, n, i, o) {
  const a = Xn();
  let u;
  function s() {
    o && o();
  }
  !xt(e).parent("picture")[0] && (!e.complete || !i) && t ? (u = new a.Image(), u.onload = s, u.onerror = s, n && (u.sizes = n), r && (u.srcset = r), t && (u.src = t)) : s();
}
function nor() {
  const e = this;
  e.imagesToLoad = e.$el.find("img");
  function t() {
    typeof e > "u" || e === null || !e || e.destroyed || (e.imagesLoaded !== void 0 && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
  }
  for (let r = 0; r < e.imagesToLoad.length; r += 1) {
    const n = e.imagesToLoad[r];
    e.loadImage(n, n.currentSrc || n.getAttribute("src"), n.srcset || n.getAttribute("srcset"), n.sizes || n.getAttribute("sizes"), !0, t);
  }
}
const ior = {
  loadImage: ror,
  preloadImages: nor
};
function oor() {
  const e = this, {
    isLocked: t,
    params: r
  } = e, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const i = e.slides.length - 1, o = e.slidesGrid[i] + e.slidesSizesGrid[i] + n * 2;
    e.isLocked = e.size > o;
  } else
    e.isLocked = e.snapGrid.length === 1;
  r.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), r.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const aor = {
  checkOverflow: oor
}, bee = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function uor(e, t) {
  return function(n = {}) {
    const i = Object.keys(n)[0], o = n[i];
    if (typeof o != "object" || o === null) {
      eu(t, n);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && e[i] === !0 && (e[i] = {
      auto: !0
    }), !(i in e && "enabled" in o)) {
      eu(t, n);
      return;
    }
    e[i] === !0 && (e[i] = {
      enabled: !0
    }), typeof e[i] == "object" && !("enabled" in e[i]) && (e[i].enabled = !0), e[i] || (e[i] = {
      enabled: !1
    }), eu(t, n);
  };
}
const XD = {
  eventsEmitter: nir,
  update: pir,
  translate: Tir,
  transition: Sir,
  slide: Dir,
  loop: Bir,
  grabCursor: Fir,
  events: Wir,
  breakpoints: Jir,
  checkOverflow: aor,
  classes: tor,
  images: ior
}, JD = {};
class Za {
  constructor(...t) {
    let r, n;
    if (t.length === 1 && t[0].constructor && Object.prototype.toString.call(t[0]).slice(8, -1) === "Object" ? n = t[0] : [r, n] = t, n || (n = {}), n = eu({}, n), r && !n.el && (n.el = r), n.el && xt(n.el).length > 1) {
      const u = [];
      return xt(n.el).each((s) => {
        const c = eu({}, n, {
          el: s
        });
        u.push(new Za(c));
      }), u;
    }
    const i = this;
    i.__swiper__ = !0, i.support = RTe(), i.device = Znr({
      userAgent: n.userAgent
    }), i.browser = eir(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], n.modules && Array.isArray(n.modules) && i.modules.push(...n.modules);
    const o = {};
    i.modules.forEach((u) => {
      u({
        swiper: i,
        extendParams: uor(n, o),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const a = eu({}, bee, o);
    return i.params = eu({}, a, JD, n), i.originalParams = eu({}, i.params), i.passedParams = eu({}, n), i.params && i.params.on && Object.keys(i.params.on).forEach((u) => {
      i.on(u, i.params.on[u]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), i.$ = xt, Object.assign(i, {
      enabled: i.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: xt(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return i.params.direction === "horizontal";
      },
      isVertical() {
        return i.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      // Touch Events
      touchEvents: function() {
        const s = ["touchstart", "touchmove", "touchend", "touchcancel"], c = ["pointerdown", "pointermove", "pointerup"];
        return i.touchEventsTouch = {
          start: s[0],
          move: s[1],
          end: s[2],
          cancel: s[3]
        }, i.touchEventsDesktop = {
          start: c[0],
          move: c[1],
          end: c[2]
        }, i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: i.params.focusableElements,
        // Last click time
        lastClickTime: tu(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, r) {
    const n = this;
    t = Math.min(Math.max(t, 0), 1);
    const i = n.minTranslate(), a = (n.maxTranslate() - i) * t + i;
    n.translateTo(a, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const r = t.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(t) {
    const r = this;
    return r.destroyed ? "" : t.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const r = [];
    t.slides.each((n) => {
      const i = t.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: i
      }), t.emit("_slideClass", n, i);
    }), t.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(t = "current", r = !1) {
    const n = this, {
      params: i,
      slides: o,
      slidesGrid: a,
      slidesSizesGrid: u,
      size: s,
      activeIndex: c
    } = n;
    let l = 1;
    if (i.centeredSlides) {
      let f = o[c].swiperSlideSize, d;
      for (let p = c + 1; p < o.length; p += 1)
        o[p] && !d && (f += o[p].swiperSlideSize, l += 1, f > s && (d = !0));
      for (let p = c - 1; p >= 0; p -= 1)
        o[p] && !d && (f += o[p].swiperSlideSize, l += 1, f > s && (d = !0));
    } else if (t === "current")
      for (let f = c + 1; f < o.length; f += 1)
        (r ? a[f] + u[f] - a[c] < s : a[f] - a[c] < s) && (l += 1);
    else
      for (let f = c - 1; f >= 0; f -= 1)
        a[c] - a[f] < s && (l += 1);
    return l;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: r,
      params: n
    } = t;
    n.breakpoints && t.setBreakpoint(), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function i() {
      const a = t.rtlTranslate ? t.translate * -1 : t.translate, u = Math.min(Math.max(a, t.maxTranslate()), t.minTranslate());
      t.setTranslate(u), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let o;
    t.params.freeMode && t.params.freeMode.enabled ? (i(), t.params.autoHeight && t.updateAutoHeight()) : ((t.params.slidesPerView === "auto" || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? o = t.slideTo(t.slides.length - 1, 0, !1, !0) : o = t.slideTo(t.activeIndex, 0, !1, !0), o || i()), n.watchOverflow && r !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, r = !0) {
    const n = this, i = n.params.direction;
    return t || (t = i === "horizontal" ? "vertical" : "horizontal"), t === i || t !== "horizontal" && t !== "vertical" || (n.$el.removeClass(`${n.params.containerModifierClass}${i}`).addClass(`${n.params.containerModifierClass}${t}`), n.emitContainerClasses(), n.params.direction = t, n.slides.each((o) => {
      t === "vertical" ? o.style.width = "" : o.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(t) {
    const r = this;
    r.rtl && t === "rtl" || !r.rtl && t === "ltr" || (r.rtl = t === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.$el.addClass(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.$el.removeClass(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(t) {
    const r = this;
    if (r.mounted) return !0;
    const n = xt(t || r.params.el);
    if (t = n[0], !t)
      return !1;
    t.swiper = r;
    const i = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = (() => {
      if (t && t.shadowRoot && t.shadowRoot.querySelector) {
        const u = xt(t.shadowRoot.querySelector(i()));
        return u.children = (s) => n.children(s), u;
      }
      return n.children ? n.children(i()) : xt(n).children(i());
    })();
    if (a.length === 0 && r.params.createElements) {
      const s = Zi().createElement("div");
      a = xt(s), s.className = r.params.wrapperClass, n.append(s), n.children(`.${r.params.slideClass}`).each((c) => {
        a.append(c);
      });
    }
    return Object.assign(r, {
      $el: n,
      el: t,
      $wrapperEl: a,
      wrapperEl: a[0],
      mounted: !0,
      // RTL
      rtl: t.dir.toLowerCase() === "rtl" || n.css("direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || n.css("direction") === "rtl"),
      wrongRTL: a.css("display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const r = this;
    return r.initialized || r.mount(t) === !1 || (r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.params.loop && r.loopCreate(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.preloadImages && r.preloadImages(), r.params.loop ? r.slideTo(r.params.initialSlide + r.loopedSlides, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.attachEvents(), r.initialized = !0, r.emit("init"), r.emit("afterInit")), r;
  }
  destroy(t = !0, r = !0) {
    const n = this, {
      params: i,
      $el: o,
      $wrapperEl: a,
      slides: u
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), i.loop && n.loopDestroy(), r && (n.removeClasses(), o.removeAttr("style"), a.removeAttr("style"), u && u.length && u.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((s) => {
      n.off(s);
    }), t !== !1 && (n.$el[0].swiper = null, Gnr(n)), n.destroyed = !0), null;
  }
  static extendDefaults(t) {
    eu(JD, t);
  }
  static get extendedDefaults() {
    return JD;
  }
  static get defaults() {
    return bee;
  }
  static installModule(t) {
    Za.prototype.__modules__ || (Za.prototype.__modules__ = []);
    const r = Za.prototype.__modules__;
    typeof t == "function" && r.indexOf(t) < 0 && r.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((r) => Za.installModule(r)), Za) : (Za.installModule(t), Za);
  }
}
Object.keys(XD).forEach((e) => {
  Object.keys(XD[e]).forEach((t) => {
    Za.prototype[t] = XD[e][t];
  });
});
Za.use([tir, rir]);
function sor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  t({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let i;
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  function o(f, d) {
    const p = e.params.virtual;
    if (p.cache && e.virtual.cache[d])
      return e.virtual.cache[d];
    const v = p.renderSlide ? xt(p.renderSlide.call(e, f, d)) : xt(`<div class="${e.params.slideClass}" data-swiper-slide-index="${d}">${f}</div>`);
    return v.attr("data-swiper-slide-index") || v.attr("data-swiper-slide-index", d), p.cache && (e.virtual.cache[d] = v), v;
  }
  function a(f) {
    const {
      slidesPerView: d,
      slidesPerGroup: p,
      centeredSlides: v
    } = e.params, {
      addSlidesBefore: h,
      addSlidesAfter: E
    } = e.params.virtual, {
      from: m,
      to: g,
      slides: y,
      slidesGrid: _,
      offset: S
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const A = e.activeIndex || 0;
    let O;
    e.rtlTranslate ? O = "right" : O = e.isHorizontal() ? "left" : "top";
    let P, U;
    v ? (P = Math.floor(d / 2) + p + E, U = Math.floor(d / 2) + p + h) : (P = d + (p - 1) + E, U = p + h);
    const z = Math.max((A || 0) - U, 0), k = Math.min((A || 0) + P, y.length - 1), H = (e.slidesGrid[z] || 0) - (e.slidesGrid[0] || 0);
    Object.assign(e.virtual, {
      from: z,
      to: k,
      offset: H,
      slidesGrid: e.slidesGrid
    });
    function B() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), n("virtualUpdate");
    }
    if (m === z && g === k && !f) {
      e.slidesGrid !== _ && H !== S && e.slides.css(O, `${H}px`), e.updateProgress(), n("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: H,
        from: z,
        to: k,
        slides: function() {
          const $ = [];
          for (let X = z; X <= k; X += 1)
            $.push(y[X]);
          return $;
        }()
      }), e.params.virtual.renderExternalUpdate ? B() : n("virtualUpdate");
      return;
    }
    const x = [], D = [];
    if (f)
      e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
    else
      for (let w = m; w <= g; w += 1)
        (w < z || w > k) && e.$wrapperEl.find(`.${e.params.slideClass}[data-swiper-slide-index="${w}"]`).remove();
    for (let w = 0; w < y.length; w += 1)
      w >= z && w <= k && (typeof g > "u" || f ? D.push(w) : (w > g && D.push(w), w < m && x.push(w)));
    D.forEach((w) => {
      e.$wrapperEl.append(o(y[w], w));
    }), x.sort((w, $) => $ - w).forEach((w) => {
      e.$wrapperEl.prepend(o(y[w], w));
    }), e.$wrapperEl.children(".swiper-slide").css(O, `${H}px`), B();
  }
  function u(f) {
    if (typeof f == "object" && "length" in f)
      for (let d = 0; d < f.length; d += 1)
        f[d] && e.virtual.slides.push(f[d]);
    else
      e.virtual.slides.push(f);
    a(!0);
  }
  function s(f) {
    const d = e.activeIndex;
    let p = d + 1, v = 1;
    if (Array.isArray(f)) {
      for (let h = 0; h < f.length; h += 1)
        f[h] && e.virtual.slides.unshift(f[h]);
      p = d + f.length, v = f.length;
    } else
      e.virtual.slides.unshift(f);
    if (e.params.virtual.cache) {
      const h = e.virtual.cache, E = {};
      Object.keys(h).forEach((m) => {
        const g = h[m], y = g.attr("data-swiper-slide-index");
        y && g.attr("data-swiper-slide-index", parseInt(y, 10) + v), E[parseInt(m, 10) + v] = g;
      }), e.virtual.cache = E;
    }
    a(!0), e.slideTo(p, 0);
  }
  function c(f) {
    if (typeof f > "u" || f === null) return;
    let d = e.activeIndex;
    if (Array.isArray(f))
      for (let p = f.length - 1; p >= 0; p -= 1)
        e.virtual.slides.splice(f[p], 1), e.params.virtual.cache && delete e.virtual.cache[f[p]], f[p] < d && (d -= 1), d = Math.max(d, 0);
    else
      e.virtual.slides.splice(f, 1), e.params.virtual.cache && delete e.virtual.cache[f], f < d && (d -= 1), d = Math.max(d, 0);
    a(!0), e.slideTo(d, 0);
  }
  function l() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), a(!0), e.slideTo(0, 0);
  }
  r("beforeInit", () => {
    e.params.virtual.enabled && (e.virtual.slides = e.params.virtual.slides, e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, e.params.initialSlide || a());
  }), r("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(i), i = setTimeout(() => {
      a();
    }, 100)) : a());
  }), r("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && n1(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: u,
    prependSlide: s,
    removeSlide: c,
    removeAllSlides: l,
    update: a
  });
}
function cor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = Zi(), o = Xn();
  e.keyboard = {
    enabled: !1
  }, t({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function a(c) {
    if (!e.enabled) return;
    const {
      rtlTranslate: l
    } = e;
    let f = c;
    f.originalEvent && (f = f.originalEvent);
    const d = f.keyCode || f.charCode, p = e.params.keyboard.pageUpDown, v = p && d === 33, h = p && d === 34, E = d === 37, m = d === 39, g = d === 38, y = d === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && m || e.isVertical() && y || h) || !e.allowSlidePrev && (e.isHorizontal() && E || e.isVertical() && g || v))
      return !1;
    if (!(f.shiftKey || f.altKey || f.ctrlKey || f.metaKey) && !(i.activeElement && i.activeElement.nodeName && (i.activeElement.nodeName.toLowerCase() === "input" || i.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (v || h || E || m || g || y)) {
        let _ = !1;
        if (e.$el.parents(`.${e.params.slideClass}`).length > 0 && e.$el.parents(`.${e.params.slideActiveClass}`).length === 0)
          return;
        const S = e.$el, A = S[0].clientWidth, O = S[0].clientHeight, P = o.innerWidth, U = o.innerHeight, z = e.$el.offset();
        l && (z.left -= e.$el[0].scrollLeft);
        const k = [[z.left, z.top], [z.left + A, z.top], [z.left, z.top + O], [z.left + A, z.top + O]];
        for (let H = 0; H < k.length; H += 1) {
          const B = k[H];
          if (B[0] >= 0 && B[0] <= P && B[1] >= 0 && B[1] <= U) {
            if (B[0] === 0 && B[1] === 0) continue;
            _ = !0;
          }
        }
        if (!_) return;
      }
      e.isHorizontal() ? ((v || h || E || m) && (f.preventDefault ? f.preventDefault() : f.returnValue = !1), ((h || m) && !l || (v || E) && l) && e.slideNext(), ((v || E) && !l || (h || m) && l) && e.slidePrev()) : ((v || h || g || y) && (f.preventDefault ? f.preventDefault() : f.returnValue = !1), (h || y) && e.slideNext(), (v || g) && e.slidePrev()), n("keyPress", d);
    }
  }
  function u() {
    e.keyboard.enabled || (xt(i).on("keydown", a), e.keyboard.enabled = !0);
  }
  function s() {
    e.keyboard.enabled && (xt(i).off("keydown", a), e.keyboard.enabled = !1);
  }
  r("init", () => {
    e.params.keyboard.enabled && u();
  }), r("destroy", () => {
    e.keyboard.enabled && s();
  }), Object.assign(e.keyboard, {
    enable: u,
    disable: s
  });
}
function lor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = Xn();
  t({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let o, a = tu(), u;
  const s = [];
  function c(g) {
    let A = 0, O = 0, P = 0, U = 0;
    return "detail" in g && (O = g.detail), "wheelDelta" in g && (O = -g.wheelDelta / 120), "wheelDeltaY" in g && (O = -g.wheelDeltaY / 120), "wheelDeltaX" in g && (A = -g.wheelDeltaX / 120), "axis" in g && g.axis === g.HORIZONTAL_AXIS && (A = O, O = 0), P = A * 10, U = O * 10, "deltaY" in g && (U = g.deltaY), "deltaX" in g && (P = g.deltaX), g.shiftKey && !P && (P = U, U = 0), (P || U) && g.deltaMode && (g.deltaMode === 1 ? (P *= 40, U *= 40) : (P *= 800, U *= 800)), P && !A && (A = P < 1 ? -1 : 1), U && !O && (O = U < 1 ? -1 : 1), {
      spinX: A,
      spinY: O,
      pixelX: P,
      pixelY: U
    };
  }
  function l() {
    e.enabled && (e.mouseEntered = !0);
  }
  function f() {
    e.enabled && (e.mouseEntered = !1);
  }
  function d(g) {
    return e.params.mousewheel.thresholdDelta && g.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && tu() - a < e.params.mousewheel.thresholdTime ? !1 : g.delta >= 6 && tu() - a < 60 ? !0 : (g.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", g.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", g.raw)), a = new i.Date().getTime(), !1);
  }
  function p(g) {
    const y = e.params.mousewheel;
    if (g.direction < 0) {
      if (e.isEnd && !e.params.loop && y.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && y.releaseOnEdges)
      return !0;
    return !1;
  }
  function v(g) {
    let y = g, _ = !0;
    if (!e.enabled) return;
    const S = e.params.mousewheel;
    e.params.cssMode && y.preventDefault();
    let A = e.$el;
    if (e.params.mousewheel.eventsTarget !== "container" && (A = xt(e.params.mousewheel.eventsTarget)), !e.mouseEntered && !A[0].contains(y.target) && !S.releaseOnEdges) return !0;
    y.originalEvent && (y = y.originalEvent);
    let O = 0;
    const P = e.rtlTranslate ? -1 : 1, U = c(y);
    if (S.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(U.pixelX) > Math.abs(U.pixelY)) O = -U.pixelX * P;
        else return !0;
      else if (Math.abs(U.pixelY) > Math.abs(U.pixelX)) O = -U.pixelY;
      else return !0;
    else
      O = Math.abs(U.pixelX) > Math.abs(U.pixelY) ? -U.pixelX * P : -U.pixelY;
    if (O === 0) return !0;
    S.invert && (O = -O);
    let z = e.getTranslate() + O * S.sensitivity;
    if (z >= e.minTranslate() && (z = e.minTranslate()), z <= e.maxTranslate() && (z = e.maxTranslate()), _ = e.params.loop ? !0 : !(z === e.minTranslate() || z === e.maxTranslate()), _ && e.params.nested && y.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const k = {
        time: tu(),
        delta: Math.abs(O),
        direction: Math.sign(O),
        raw: g
      };
      s.length >= 2 && s.shift();
      const H = s.length ? s[s.length - 1] : void 0;
      if (s.push(k), H ? (k.direction !== H.direction || k.delta > H.delta || k.time > H.time + 150) && d(k) : d(k), p(k))
        return !0;
    } else {
      const k = {
        time: tu(),
        delta: Math.abs(O),
        direction: Math.sign(O)
      }, H = u && k.time < u.time + 500 && k.delta <= u.delta && k.direction === u.direction;
      if (!H) {
        u = void 0, e.params.loop && e.loopFix();
        let B = e.getTranslate() + O * S.sensitivity;
        const x = e.isBeginning, D = e.isEnd;
        if (B >= e.minTranslate() && (B = e.minTranslate()), B <= e.maxTranslate() && (B = e.maxTranslate()), e.setTransition(0), e.setTranslate(B), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!x && e.isBeginning || !D && e.isEnd) && e.updateSlidesClasses(), e.params.freeMode.sticky) {
          clearTimeout(o), o = void 0, s.length >= 15 && s.shift();
          const w = s.length ? s[s.length - 1] : void 0, $ = s[0];
          if (s.push(k), w && (k.delta > w.delta || k.direction !== w.direction))
            s.splice(0);
          else if (s.length >= 15 && k.time - $.time < 500 && $.delta - k.delta >= 1 && k.delta <= 6) {
            const X = O > 0 ? 0.8 : 0.2;
            u = k, s.splice(0), o = e0(() => {
              e.slideToClosest(e.params.speed, !0, void 0, X);
            }, 0);
          }
          o || (o = e0(() => {
            u = k, s.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
          }, 500));
        }
        if (H || n("scroll", y), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), B === e.minTranslate() || B === e.maxTranslate()) return !0;
      }
    }
    return y.preventDefault ? y.preventDefault() : y.returnValue = !1, !1;
  }
  function h(g) {
    let y = e.$el;
    e.params.mousewheel.eventsTarget !== "container" && (y = xt(e.params.mousewheel.eventsTarget)), y[g]("mouseenter", l), y[g]("mouseleave", f), y[g]("wheel", v);
  }
  function E() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", v), !0) : e.mousewheel.enabled ? !1 : (h("on"), e.mousewheel.enabled = !0, !0);
  }
  function m() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, v), !0) : e.mousewheel.enabled ? (h("off"), e.mousewheel.enabled = !1, !0) : !1;
  }
  r("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && m(), e.params.mousewheel.enabled && E();
  }), r("destroy", () => {
    e.params.cssMode && E(), e.mousewheel.enabled && m();
  }), Object.assign(e.mousewheel, {
    enable: E,
    disable: m
  });
}
function _7(e, t, r, n) {
  const i = Zi();
  return e.params.createElements && Object.keys(n).forEach((o) => {
    if (!r[o] && r.auto === !0) {
      let a = e.$el.children(`.${n[o]}`)[0];
      a || (a = i.createElement("div"), a.className = n[o], e.$el.append(a)), r[o] = a, t[o] = a;
    }
  }), r;
}
function dor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };
  function i(p) {
    let v;
    return p && (v = xt(p), e.params.uniqueNavElements && typeof p == "string" && v.length > 1 && e.$el.find(p).length === 1 && (v = e.$el.find(p))), v;
  }
  function o(p, v) {
    const h = e.params.navigation;
    p && p.length > 0 && (p[v ? "addClass" : "removeClass"](h.disabledClass), p[0] && p[0].tagName === "BUTTON" && (p[0].disabled = v), e.params.watchOverflow && e.enabled && p[e.isLocked ? "addClass" : "removeClass"](h.lockClass));
  }
  function a() {
    if (e.params.loop) return;
    const {
      $nextEl: p,
      $prevEl: v
    } = e.navigation;
    o(v, e.isBeginning && !e.params.rewind), o(p, e.isEnd && !e.params.rewind);
  }
  function u(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
  }
  function s(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
  }
  function c() {
    const p = e.params.navigation;
    if (e.params.navigation = _7(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    const v = i(p.nextEl), h = i(p.prevEl);
    v && v.length > 0 && v.on("click", s), h && h.length > 0 && h.on("click", u), Object.assign(e.navigation, {
      $nextEl: v,
      nextEl: v && v[0],
      $prevEl: h,
      prevEl: h && h[0]
    }), e.enabled || (v && v.addClass(p.lockClass), h && h.addClass(p.lockClass));
  }
  function l() {
    const {
      $nextEl: p,
      $prevEl: v
    } = e.navigation;
    p && p.length && (p.off("click", s), p.removeClass(e.params.navigation.disabledClass)), v && v.length && (v.off("click", u), v.removeClass(e.params.navigation.disabledClass));
  }
  r("init", () => {
    e.params.navigation.enabled === !1 ? d() : (c(), a());
  }), r("toEdge fromEdge lock unlock", () => {
    a();
  }), r("destroy", () => {
    l();
  }), r("enable disable", () => {
    const {
      $nextEl: p,
      $prevEl: v
    } = e.navigation;
    p && p[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass), v && v[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass);
  }), r("click", (p, v) => {
    const {
      $nextEl: h,
      $prevEl: E
    } = e.navigation, m = v.target;
    if (e.params.navigation.hideOnClick && !xt(m).is(E) && !xt(m).is(h)) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === m || e.pagination.el.contains(m))) return;
      let g;
      h ? g = h.hasClass(e.params.navigation.hiddenClass) : E && (g = E.hasClass(e.params.navigation.hiddenClass)), n(g === !0 ? "navigationShow" : "navigationHide"), h && h.toggleClass(e.params.navigation.hiddenClass), E && E.toggleClass(e.params.navigation.hiddenClass);
    }
  });
  const f = () => {
    e.$el.removeClass(e.params.navigation.navigationDisabledClass), c(), a();
  }, d = () => {
    e.$el.addClass(e.params.navigation.navigationDisabledClass), l();
  };
  Object.assign(e.navigation, {
    enable: f,
    disable: d,
    update: a,
    init: c,
    destroy: l
  });
}
function Fc(e = "") {
  return `.${e.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function por({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = "swiper-pagination";
  t({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (h) => h,
      formatFractionTotal: (h) => h,
      bulletClass: `${i}-bullet`,
      bulletActiveClass: `${i}-bullet-active`,
      modifierClass: `${i}-`,
      currentClass: `${i}-current`,
      totalClass: `${i}-total`,
      hiddenClass: `${i}-hidden`,
      progressbarFillClass: `${i}-progressbar-fill`,
      progressbarOppositeClass: `${i}-progressbar-opposite`,
      clickableClass: `${i}-clickable`,
      lockClass: `${i}-lock`,
      horizontalClass: `${i}-horizontal`,
      verticalClass: `${i}-vertical`,
      paginationDisabledClass: `${i}-disabled`
    }
  }), e.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let o, a = 0;
  function u() {
    return !e.params.pagination.el || !e.pagination.el || !e.pagination.$el || e.pagination.$el.length === 0;
  }
  function s(h, E) {
    const {
      bulletActiveClass: m
    } = e.params.pagination;
    h[E]().addClass(`${m}-${E}`)[E]().addClass(`${m}-${E}-${E}`);
  }
  function c() {
    const h = e.rtl, E = e.params.pagination;
    if (u()) return;
    const m = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, g = e.pagination.$el;
    let y;
    const _ = e.params.loop ? Math.ceil((m - e.loopedSlides * 2) / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (y = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup), y > m - 1 - e.loopedSlides * 2 && (y -= m - e.loopedSlides * 2), y > _ - 1 && (y -= _), y < 0 && e.params.paginationType !== "bullets" && (y = _ + y)) : typeof e.snapIndex < "u" ? y = e.snapIndex : y = e.activeIndex || 0, E.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const S = e.pagination.bullets;
      let A, O, P;
      if (E.dynamicBullets && (o = S.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), g.css(e.isHorizontal() ? "width" : "height", `${o * (E.dynamicMainBullets + 4)}px`), E.dynamicMainBullets > 1 && e.previousIndex !== void 0 && (a += y - (e.previousIndex - e.loopedSlides || 0), a > E.dynamicMainBullets - 1 ? a = E.dynamicMainBullets - 1 : a < 0 && (a = 0)), A = Math.max(y - a, 0), O = A + (Math.min(S.length, E.dynamicMainBullets) - 1), P = (O + A) / 2), S.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((U) => `${E.bulletActiveClass}${U}`).join(" ")), g.length > 1)
        S.each((U) => {
          const z = xt(U), k = z.index();
          k === y && z.addClass(E.bulletActiveClass), E.dynamicBullets && (k >= A && k <= O && z.addClass(`${E.bulletActiveClass}-main`), k === A && s(z, "prev"), k === O && s(z, "next"));
        });
      else {
        const U = S.eq(y), z = U.index();
        if (U.addClass(E.bulletActiveClass), E.dynamicBullets) {
          const k = S.eq(A), H = S.eq(O);
          for (let B = A; B <= O; B += 1)
            S.eq(B).addClass(`${E.bulletActiveClass}-main`);
          if (e.params.loop)
            if (z >= S.length) {
              for (let B = E.dynamicMainBullets; B >= 0; B -= 1)
                S.eq(S.length - B).addClass(`${E.bulletActiveClass}-main`);
              S.eq(S.length - E.dynamicMainBullets - 1).addClass(`${E.bulletActiveClass}-prev`);
            } else
              s(k, "prev"), s(H, "next");
          else
            s(k, "prev"), s(H, "next");
        }
      }
      if (E.dynamicBullets) {
        const U = Math.min(S.length, E.dynamicMainBullets + 4), z = (o * U - o) / 2 - P * o, k = h ? "right" : "left";
        S.css(e.isHorizontal() ? k : "top", `${z}px`);
      }
    }
    if (E.type === "fraction" && (g.find(Fc(E.currentClass)).text(E.formatFractionCurrent(y + 1)), g.find(Fc(E.totalClass)).text(E.formatFractionTotal(_))), E.type === "progressbar") {
      let S;
      E.progressbarOpposite ? S = e.isHorizontal() ? "vertical" : "horizontal" : S = e.isHorizontal() ? "horizontal" : "vertical";
      const A = (y + 1) / _;
      let O = 1, P = 1;
      S === "horizontal" ? O = A : P = A, g.find(Fc(E.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${O}) scaleY(${P})`).transition(e.params.speed);
    }
    E.type === "custom" && E.renderCustom ? (g.html(E.renderCustom(e, y + 1, _)), n("paginationRender", g[0])) : n("paginationUpdate", g[0]), e.params.watchOverflow && e.enabled && g[e.isLocked ? "addClass" : "removeClass"](E.lockClass);
  }
  function l() {
    const h = e.params.pagination;
    if (u()) return;
    const E = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, m = e.pagination.$el;
    let g = "";
    if (h.type === "bullets") {
      let y = e.params.loop ? Math.ceil((E - e.loopedSlides * 2) / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && !e.params.loop && y > E && (y = E);
      for (let _ = 0; _ < y; _ += 1)
        h.renderBullet ? g += h.renderBullet.call(e, _, h.bulletClass) : g += `<${h.bulletElement} class="${h.bulletClass}"></${h.bulletElement}>`;
      m.html(g), e.pagination.bullets = m.find(Fc(h.bulletClass));
    }
    h.type === "fraction" && (h.renderFraction ? g = h.renderFraction.call(e, h.currentClass, h.totalClass) : g = `<span class="${h.currentClass}"></span> / <span class="${h.totalClass}"></span>`, m.html(g)), h.type === "progressbar" && (h.renderProgressbar ? g = h.renderProgressbar.call(e, h.progressbarFillClass) : g = `<span class="${h.progressbarFillClass}"></span>`, m.html(g)), h.type !== "custom" && n("paginationRender", e.pagination.$el[0]);
  }
  function f() {
    e.params.pagination = _7(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const h = e.params.pagination;
    if (!h.el) return;
    let E = xt(h.el);
    E.length !== 0 && (e.params.uniqueNavElements && typeof h.el == "string" && E.length > 1 && (E = e.$el.find(h.el), E.length > 1 && (E = E.filter((m) => xt(m).parents(".swiper")[0] === e.el))), h.type === "bullets" && h.clickable && E.addClass(h.clickableClass), E.addClass(h.modifierClass + h.type), E.addClass(e.isHorizontal() ? h.horizontalClass : h.verticalClass), h.type === "bullets" && h.dynamicBullets && (E.addClass(`${h.modifierClass}${h.type}-dynamic`), a = 0, h.dynamicMainBullets < 1 && (h.dynamicMainBullets = 1)), h.type === "progressbar" && h.progressbarOpposite && E.addClass(h.progressbarOppositeClass), h.clickable && E.on("click", Fc(h.bulletClass), function(g) {
      g.preventDefault();
      let y = xt(this).index() * e.params.slidesPerGroup;
      e.params.loop && (y += e.loopedSlides), e.slideTo(y);
    }), Object.assign(e.pagination, {
      $el: E,
      el: E[0]
    }), e.enabled || E.addClass(h.lockClass));
  }
  function d() {
    const h = e.params.pagination;
    if (u()) return;
    const E = e.pagination.$el;
    E.removeClass(h.hiddenClass), E.removeClass(h.modifierClass + h.type), E.removeClass(e.isHorizontal() ? h.horizontalClass : h.verticalClass), e.pagination.bullets && e.pagination.bullets.removeClass && e.pagination.bullets.removeClass(h.bulletActiveClass), h.clickable && E.off("click", Fc(h.bulletClass));
  }
  r("init", () => {
    e.params.pagination.enabled === !1 ? v() : (f(), l(), c());
  }), r("activeIndexChange", () => {
    (e.params.loop || typeof e.snapIndex > "u") && c();
  }), r("snapIndexChange", () => {
    e.params.loop || c();
  }), r("slidesLengthChange", () => {
    e.params.loop && (l(), c());
  }), r("snapGridLengthChange", () => {
    e.params.loop || (l(), c());
  }), r("destroy", () => {
    d();
  }), r("enable disable", () => {
    const {
      $el: h
    } = e.pagination;
    h && h[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass);
  }), r("lock unlock", () => {
    c();
  }), r("click", (h, E) => {
    const m = E.target, {
      $el: g
    } = e.pagination;
    if (e.params.pagination.el && e.params.pagination.hideOnClick && g && g.length > 0 && !xt(m).hasClass(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && m === e.navigation.nextEl || e.navigation.prevEl && m === e.navigation.prevEl)) return;
      const y = g.hasClass(e.params.pagination.hiddenClass);
      n(y === !0 ? "paginationShow" : "paginationHide"), g.toggleClass(e.params.pagination.hiddenClass);
    }
  });
  const p = () => {
    e.$el.removeClass(e.params.pagination.paginationDisabledClass), e.pagination.$el && e.pagination.$el.removeClass(e.params.pagination.paginationDisabledClass), f(), l(), c();
  }, v = () => {
    e.$el.addClass(e.params.pagination.paginationDisabledClass), e.pagination.$el && e.pagination.$el.addClass(e.params.pagination.paginationDisabledClass), d();
  };
  Object.assign(e.pagination, {
    enable: p,
    disable: v,
    render: l,
    update: c,
    init: f,
    destroy: d
  });
}
function hor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = Zi();
  let o = !1, a = null, u = null, s, c, l, f;
  t({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };
  function d() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: k,
      rtlTranslate: H,
      progress: B
    } = e, {
      $dragEl: x,
      $el: D
    } = k, w = e.params.scrollbar;
    let $ = c, X = (l - c) * B;
    H ? (X = -X, X > 0 ? ($ = c - X, X = 0) : -X + c > l && ($ = l + X)) : X < 0 ? ($ = c + X, X = 0) : X + c > l && ($ = l - X), e.isHorizontal() ? (x.transform(`translate3d(${X}px, 0, 0)`), x[0].style.width = `${$}px`) : (x.transform(`translate3d(0px, ${X}px, 0)`), x[0].style.height = `${$}px`), w.hide && (clearTimeout(a), D[0].style.opacity = 1, a = setTimeout(() => {
      D[0].style.opacity = 0, D.transition(400);
    }, 1e3));
  }
  function p(k) {
    !e.params.scrollbar.el || !e.scrollbar.el || e.scrollbar.$dragEl.transition(k);
  }
  function v() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: k
    } = e, {
      $dragEl: H,
      $el: B
    } = k;
    H[0].style.width = "", H[0].style.height = "", l = e.isHorizontal() ? B[0].offsetWidth : B[0].offsetHeight, f = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? c = l * f : c = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? H[0].style.width = `${c}px` : H[0].style.height = `${c}px`, f >= 1 ? B[0].style.display = "none" : B[0].style.display = "", e.params.scrollbar.hide && (B[0].style.opacity = 0), e.params.watchOverflow && e.enabled && k.$el[e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
  }
  function h(k) {
    return e.isHorizontal() ? k.type === "touchstart" || k.type === "touchmove" ? k.targetTouches[0].clientX : k.clientX : k.type === "touchstart" || k.type === "touchmove" ? k.targetTouches[0].clientY : k.clientY;
  }
  function E(k) {
    const {
      scrollbar: H,
      rtlTranslate: B
    } = e, {
      $el: x
    } = H;
    let D;
    D = (h(k) - x.offset()[e.isHorizontal() ? "left" : "top"] - (s !== null ? s : c / 2)) / (l - c), D = Math.max(Math.min(D, 1), 0), B && (D = 1 - D);
    const w = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * D;
    e.updateProgress(w), e.setTranslate(w), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function m(k) {
    const H = e.params.scrollbar, {
      scrollbar: B,
      $wrapperEl: x
    } = e, {
      $el: D,
      $dragEl: w
    } = B;
    o = !0, s = k.target === w[0] || k.target === w ? h(k) - k.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, k.preventDefault(), k.stopPropagation(), x.transition(100), w.transition(100), E(k), clearTimeout(u), D.transition(0), H.hide && D.css("opacity", 1), e.params.cssMode && e.$wrapperEl.css("scroll-snap-type", "none"), n("scrollbarDragStart", k);
  }
  function g(k) {
    const {
      scrollbar: H,
      $wrapperEl: B
    } = e, {
      $el: x,
      $dragEl: D
    } = H;
    o && (k.preventDefault ? k.preventDefault() : k.returnValue = !1, E(k), B.transition(0), x.transition(0), D.transition(0), n("scrollbarDragMove", k));
  }
  function y(k) {
    const H = e.params.scrollbar, {
      scrollbar: B,
      $wrapperEl: x
    } = e, {
      $el: D
    } = B;
    o && (o = !1, e.params.cssMode && (e.$wrapperEl.css("scroll-snap-type", ""), x.transition("")), H.hide && (clearTimeout(u), u = e0(() => {
      D.css("opacity", 0), D.transition(400);
    }, 1e3)), n("scrollbarDragEnd", k), H.snapOnRelease && e.slideToClosest());
  }
  function _(k) {
    const {
      scrollbar: H,
      touchEventsTouch: B,
      touchEventsDesktop: x,
      params: D,
      support: w
    } = e, $ = H.$el;
    if (!$) return;
    const X = $[0], V = w.passiveListener && D.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, F = w.passiveListener && D.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!X) return;
    const le = k === "on" ? "addEventListener" : "removeEventListener";
    w.touch ? (X[le](B.start, m, V), X[le](B.move, g, V), X[le](B.end, y, F)) : (X[le](x.start, m, V), i[le](x.move, g, V), i[le](x.end, y, F));
  }
  function S() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("on");
  }
  function A() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("off");
  }
  function O() {
    const {
      scrollbar: k,
      $el: H
    } = e;
    e.params.scrollbar = _7(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const B = e.params.scrollbar;
    if (!B.el) return;
    let x = xt(B.el);
    e.params.uniqueNavElements && typeof B.el == "string" && x.length > 1 && H.find(B.el).length === 1 && (x = H.find(B.el)), x.addClass(e.isHorizontal() ? B.horizontalClass : B.verticalClass);
    let D = x.find(`.${e.params.scrollbar.dragClass}`);
    D.length === 0 && (D = xt(`<div class="${e.params.scrollbar.dragClass}"></div>`), x.append(D)), Object.assign(k, {
      $el: x,
      el: x[0],
      $dragEl: D,
      dragEl: D[0]
    }), B.draggable && S(), x && x[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
  }
  function P() {
    const k = e.params.scrollbar, H = e.scrollbar.$el;
    H && H.removeClass(e.isHorizontal() ? k.horizontalClass : k.verticalClass), A();
  }
  r("init", () => {
    e.params.scrollbar.enabled === !1 ? z() : (O(), v(), d());
  }), r("update resize observerUpdate lock unlock", () => {
    v();
  }), r("setTranslate", () => {
    d();
  }), r("setTransition", (k, H) => {
    p(H);
  }), r("enable disable", () => {
    const {
      $el: k
    } = e.scrollbar;
    k && k[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
  }), r("destroy", () => {
    P();
  });
  const U = () => {
    e.$el.removeClass(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.$el && e.scrollbar.$el.removeClass(e.params.scrollbar.scrollbarDisabledClass), O(), v(), d();
  }, z = () => {
    e.$el.addClass(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.$el && e.scrollbar.$el.addClass(e.params.scrollbar.scrollbarDisabledClass), P();
  };
  Object.assign(e.scrollbar, {
    enable: U,
    disable: z,
    updateSize: v,
    setTranslate: d,
    init: O,
    destroy: P
  });
}
function vor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    parallax: {
      enabled: !1
    }
  });
  const n = (a, u) => {
    const {
      rtl: s
    } = e, c = xt(a), l = s ? -1 : 1, f = c.attr("data-swiper-parallax") || "0";
    let d = c.attr("data-swiper-parallax-x"), p = c.attr("data-swiper-parallax-y");
    const v = c.attr("data-swiper-parallax-scale"), h = c.attr("data-swiper-parallax-opacity");
    if (d || p ? (d = d || "0", p = p || "0") : e.isHorizontal() ? (d = f, p = "0") : (p = f, d = "0"), d.indexOf("%") >= 0 ? d = `${parseInt(d, 10) * u * l}%` : d = `${d * u * l}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * u}%` : p = `${p * u}px`, typeof h < "u" && h !== null) {
      const E = h - (h - 1) * (1 - Math.abs(u));
      c[0].style.opacity = E;
    }
    if (typeof v > "u" || v === null)
      c.transform(`translate3d(${d}, ${p}, 0px)`);
    else {
      const E = v - (v - 1) * (1 - Math.abs(u));
      c.transform(`translate3d(${d}, ${p}, 0px) scale(${E})`);
    }
  }, i = () => {
    const {
      $el: a,
      slides: u,
      progress: s,
      snapGrid: c
    } = e;
    a.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((l) => {
      n(l, s);
    }), u.each((l, f) => {
      let d = l.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (d += Math.ceil(f / 2) - s * (c.length - 1)), d = Math.min(Math.max(d, -1), 1), xt(l).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((p) => {
        n(p, d);
      });
    });
  }, o = (a = e.params.speed) => {
    const {
      $el: u
    } = e;
    u.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((s) => {
      const c = xt(s);
      let l = parseInt(c.attr("data-swiper-parallax-duration"), 10) || a;
      a === 0 && (l = 0), c.transition(l);
    });
  };
  r("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), r("init", () => {
    e.params.parallax.enabled && i();
  }), r("setTranslate", () => {
    e.params.parallax.enabled && i();
  }), r("setTransition", (a, u) => {
    e.params.parallax.enabled && o(u);
  });
}
function Eor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  const i = Xn();
  t({
    zoom: {
      enabled: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let o = 1, a = !1, u, s, c;
  const l = {
    $slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    $imageEl: void 0,
    $imageWrapEl: void 0,
    maxRatio: 3
  }, f = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, d = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let p = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return p;
    },
    set(w) {
      if (p !== w) {
        const $ = l.$imageEl ? l.$imageEl[0] : void 0, X = l.$slideEl ? l.$slideEl[0] : void 0;
        n("zoomChange", w, $, X);
      }
      p = w;
    }
  });
  function v(w) {
    if (w.targetTouches.length < 2) return 1;
    const $ = w.targetTouches[0].pageX, X = w.targetTouches[0].pageY, V = w.targetTouches[1].pageX, F = w.targetTouches[1].pageY;
    return Math.sqrt((V - $) ** 2 + (F - X) ** 2);
  }
  function h(w) {
    const $ = e.support, X = e.params.zoom;
    if (s = !1, c = !1, !$.gestures) {
      if (w.type !== "touchstart" || w.type === "touchstart" && w.targetTouches.length < 2)
        return;
      s = !0, l.scaleStart = v(w);
    }
    if ((!l.$slideEl || !l.$slideEl.length) && (l.$slideEl = xt(w.target).closest(`.${e.params.slideClass}`), l.$slideEl.length === 0 && (l.$slideEl = e.slides.eq(e.activeIndex)), l.$imageEl = l.$slideEl.find(`.${X.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), l.$imageWrapEl = l.$imageEl.parent(`.${X.containerClass}`), l.maxRatio = l.$imageWrapEl.attr("data-swiper-zoom") || X.maxRatio, l.$imageWrapEl.length === 0)) {
      l.$imageEl = void 0;
      return;
    }
    l.$imageEl && l.$imageEl.transition(0), a = !0;
  }
  function E(w) {
    const $ = e.support, X = e.params.zoom, V = e.zoom;
    if (!$.gestures) {
      if (w.type !== "touchmove" || w.type === "touchmove" && w.targetTouches.length < 2)
        return;
      c = !0, l.scaleMove = v(w);
    }
    if (!l.$imageEl || l.$imageEl.length === 0) {
      w.type === "gesturechange" && h(w);
      return;
    }
    $.gestures ? V.scale = w.scale * o : V.scale = l.scaleMove / l.scaleStart * o, V.scale > l.maxRatio && (V.scale = l.maxRatio - 1 + (V.scale - l.maxRatio + 1) ** 0.5), V.scale < X.minRatio && (V.scale = X.minRatio + 1 - (X.minRatio - V.scale + 1) ** 0.5), l.$imageEl.transform(`translate3d(0,0,0) scale(${V.scale})`);
  }
  function m(w) {
    const $ = e.device, X = e.support, V = e.params.zoom, F = e.zoom;
    if (!X.gestures) {
      if (!s || !c || w.type !== "touchend" || w.type === "touchend" && w.changedTouches.length < 2 && !$.android)
        return;
      s = !1, c = !1;
    }
    !l.$imageEl || l.$imageEl.length === 0 || (F.scale = Math.max(Math.min(F.scale, l.maxRatio), V.minRatio), l.$imageEl.transition(e.params.speed).transform(`translate3d(0,0,0) scale(${F.scale})`), o = F.scale, a = !1, F.scale === 1 && (l.$slideEl = void 0));
  }
  function g(w) {
    const $ = e.device;
    !l.$imageEl || l.$imageEl.length === 0 || f.isTouched || ($.android && w.cancelable && w.preventDefault(), f.isTouched = !0, f.touchesStart.x = w.type === "touchstart" ? w.targetTouches[0].pageX : w.pageX, f.touchesStart.y = w.type === "touchstart" ? w.targetTouches[0].pageY : w.pageY);
  }
  function y(w) {
    const $ = e.zoom;
    if (!l.$imageEl || l.$imageEl.length === 0 || (e.allowClick = !1, !f.isTouched || !l.$slideEl)) return;
    f.isMoved || (f.width = l.$imageEl[0].offsetWidth, f.height = l.$imageEl[0].offsetHeight, f.startX = EB(l.$imageWrapEl[0], "x") || 0, f.startY = EB(l.$imageWrapEl[0], "y") || 0, l.slideWidth = l.$slideEl[0].offsetWidth, l.slideHeight = l.$slideEl[0].offsetHeight, l.$imageWrapEl.transition(0));
    const X = f.width * $.scale, V = f.height * $.scale;
    if (!(X < l.slideWidth && V < l.slideHeight)) {
      if (f.minX = Math.min(l.slideWidth / 2 - X / 2, 0), f.maxX = -f.minX, f.minY = Math.min(l.slideHeight / 2 - V / 2, 0), f.maxY = -f.minY, f.touchesCurrent.x = w.type === "touchmove" ? w.targetTouches[0].pageX : w.pageX, f.touchesCurrent.y = w.type === "touchmove" ? w.targetTouches[0].pageY : w.pageY, !f.isMoved && !a) {
        if (e.isHorizontal() && (Math.floor(f.minX) === Math.floor(f.startX) && f.touchesCurrent.x < f.touchesStart.x || Math.floor(f.maxX) === Math.floor(f.startX) && f.touchesCurrent.x > f.touchesStart.x)) {
          f.isTouched = !1;
          return;
        }
        if (!e.isHorizontal() && (Math.floor(f.minY) === Math.floor(f.startY) && f.touchesCurrent.y < f.touchesStart.y || Math.floor(f.maxY) === Math.floor(f.startY) && f.touchesCurrent.y > f.touchesStart.y)) {
          f.isTouched = !1;
          return;
        }
      }
      w.cancelable && w.preventDefault(), w.stopPropagation(), f.isMoved = !0, f.currentX = f.touchesCurrent.x - f.touchesStart.x + f.startX, f.currentY = f.touchesCurrent.y - f.touchesStart.y + f.startY, f.currentX < f.minX && (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8), f.currentX > f.maxX && (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8), f.currentY < f.minY && (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8), f.currentY > f.maxY && (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8), d.prevPositionX || (d.prevPositionX = f.touchesCurrent.x), d.prevPositionY || (d.prevPositionY = f.touchesCurrent.y), d.prevTime || (d.prevTime = Date.now()), d.x = (f.touchesCurrent.x - d.prevPositionX) / (Date.now() - d.prevTime) / 2, d.y = (f.touchesCurrent.y - d.prevPositionY) / (Date.now() - d.prevTime) / 2, Math.abs(f.touchesCurrent.x - d.prevPositionX) < 2 && (d.x = 0), Math.abs(f.touchesCurrent.y - d.prevPositionY) < 2 && (d.y = 0), d.prevPositionX = f.touchesCurrent.x, d.prevPositionY = f.touchesCurrent.y, d.prevTime = Date.now(), l.$imageWrapEl.transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`);
    }
  }
  function _() {
    const w = e.zoom;
    if (!l.$imageEl || l.$imageEl.length === 0) return;
    if (!f.isTouched || !f.isMoved) {
      f.isTouched = !1, f.isMoved = !1;
      return;
    }
    f.isTouched = !1, f.isMoved = !1;
    let $ = 300, X = 300;
    const V = d.x * $, F = f.currentX + V, le = d.y * X, ae = f.currentY + le;
    d.x !== 0 && ($ = Math.abs((F - f.currentX) / d.x)), d.y !== 0 && (X = Math.abs((ae - f.currentY) / d.y));
    const ne = Math.max($, X);
    f.currentX = F, f.currentY = ae;
    const ve = f.width * w.scale, Ie = f.height * w.scale;
    f.minX = Math.min(l.slideWidth / 2 - ve / 2, 0), f.maxX = -f.minX, f.minY = Math.min(l.slideHeight / 2 - Ie / 2, 0), f.maxY = -f.minY, f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX), f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY), l.$imageWrapEl.transition(ne).transform(`translate3d(${f.currentX}px, ${f.currentY}px,0)`);
  }
  function S() {
    const w = e.zoom;
    l.$slideEl && e.previousIndex !== e.activeIndex && (l.$imageEl && l.$imageEl.transform("translate3d(0,0,0) scale(1)"), l.$imageWrapEl && l.$imageWrapEl.transform("translate3d(0,0,0)"), w.scale = 1, o = 1, l.$slideEl = void 0, l.$imageEl = void 0, l.$imageWrapEl = void 0);
  }
  function A(w) {
    const $ = e.zoom, X = e.params.zoom;
    if (l.$slideEl || (w && w.target && (l.$slideEl = xt(w.target).closest(`.${e.params.slideClass}`)), l.$slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? l.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`) : l.$slideEl = e.slides.eq(e.activeIndex)), l.$imageEl = l.$slideEl.find(`.${X.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), l.$imageWrapEl = l.$imageEl.parent(`.${X.containerClass}`)), !l.$imageEl || l.$imageEl.length === 0 || !l.$imageWrapEl || l.$imageWrapEl.length === 0) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), l.$slideEl.addClass(`${X.zoomedSlideClass}`);
    let V, F, le, ae, ne, ve, Ie, Oe, xe, ze, qe, Je, Be, We, Ne, je, et, St;
    typeof f.touchesStart.x > "u" && w ? (V = w.type === "touchend" ? w.changedTouches[0].pageX : w.pageX, F = w.type === "touchend" ? w.changedTouches[0].pageY : w.pageY) : (V = f.touchesStart.x, F = f.touchesStart.y), $.scale = l.$imageWrapEl.attr("data-swiper-zoom") || X.maxRatio, o = l.$imageWrapEl.attr("data-swiper-zoom") || X.maxRatio, w ? (et = l.$slideEl[0].offsetWidth, St = l.$slideEl[0].offsetHeight, le = l.$slideEl.offset().left + i.scrollX, ae = l.$slideEl.offset().top + i.scrollY, ne = le + et / 2 - V, ve = ae + St / 2 - F, xe = l.$imageEl[0].offsetWidth, ze = l.$imageEl[0].offsetHeight, qe = xe * $.scale, Je = ze * $.scale, Be = Math.min(et / 2 - qe / 2, 0), We = Math.min(St / 2 - Je / 2, 0), Ne = -Be, je = -We, Ie = ne * $.scale, Oe = ve * $.scale, Ie < Be && (Ie = Be), Ie > Ne && (Ie = Ne), Oe < We && (Oe = We), Oe > je && (Oe = je)) : (Ie = 0, Oe = 0), l.$imageWrapEl.transition(300).transform(`translate3d(${Ie}px, ${Oe}px,0)`), l.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${$.scale})`);
  }
  function O() {
    const w = e.zoom, $ = e.params.zoom;
    l.$slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? l.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`) : l.$slideEl = e.slides.eq(e.activeIndex), l.$imageEl = l.$slideEl.find(`.${$.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), l.$imageWrapEl = l.$imageEl.parent(`.${$.containerClass}`)), !(!l.$imageEl || l.$imageEl.length === 0 || !l.$imageWrapEl || l.$imageWrapEl.length === 0) && (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), w.scale = 1, o = 1, l.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), l.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), l.$slideEl.removeClass(`${$.zoomedSlideClass}`), l.$slideEl = void 0);
  }
  function P(w) {
    const $ = e.zoom;
    $.scale && $.scale !== 1 ? O() : A(w);
  }
  function U() {
    const w = e.support, $ = e.touchEvents.start === "touchstart" && w.passiveListener && e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, X = w.passiveListener ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: $,
      activeListenerWithCapture: X
    };
  }
  function z() {
    return `.${e.params.slideClass}`;
  }
  function k(w) {
    const {
      passiveListener: $
    } = U(), X = z();
    e.$wrapperEl[w]("gesturestart", X, h, $), e.$wrapperEl[w]("gesturechange", X, E, $), e.$wrapperEl[w]("gestureend", X, m, $);
  }
  function H() {
    u || (u = !0, k("on"));
  }
  function B() {
    u && (u = !1, k("off"));
  }
  function x() {
    const w = e.zoom;
    if (w.enabled) return;
    w.enabled = !0;
    const $ = e.support, {
      passiveListener: X,
      activeListenerWithCapture: V
    } = U(), F = z();
    $.gestures ? (e.$wrapperEl.on(e.touchEvents.start, H, X), e.$wrapperEl.on(e.touchEvents.end, B, X)) : e.touchEvents.start === "touchstart" && (e.$wrapperEl.on(e.touchEvents.start, F, h, X), e.$wrapperEl.on(e.touchEvents.move, F, E, V), e.$wrapperEl.on(e.touchEvents.end, F, m, X), e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, F, m, X)), e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, y, V);
  }
  function D() {
    const w = e.zoom;
    if (!w.enabled) return;
    const $ = e.support;
    w.enabled = !1;
    const {
      passiveListener: X,
      activeListenerWithCapture: V
    } = U(), F = z();
    $.gestures ? (e.$wrapperEl.off(e.touchEvents.start, H, X), e.$wrapperEl.off(e.touchEvents.end, B, X)) : e.touchEvents.start === "touchstart" && (e.$wrapperEl.off(e.touchEvents.start, F, h, X), e.$wrapperEl.off(e.touchEvents.move, F, E, V), e.$wrapperEl.off(e.touchEvents.end, F, m, X), e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, F, m, X)), e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, y, V);
  }
  r("init", () => {
    e.params.zoom.enabled && x();
  }), r("destroy", () => {
    D();
  }), r("touchStart", (w, $) => {
    e.zoom.enabled && g($);
  }), r("touchEnd", (w, $) => {
    e.zoom.enabled && _();
  }), r("doubleTap", (w, $) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && P($);
  }), r("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && S();
  }), r("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && S();
  }), Object.assign(e.zoom, {
    enable: x,
    disable: D,
    in: A,
    out: O,
    toggle: P
  });
}
function mor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  t({
    lazy: {
      checkInView: !1,
      enabled: !1,
      loadPrevNext: !1,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: !1,
      scrollingElement: "",
      elementClass: "swiper-lazy",
      loadingClass: "swiper-lazy-loading",
      loadedClass: "swiper-lazy-loaded",
      preloaderClass: "swiper-lazy-preloader"
    }
  }), e.lazy = {};
  let i = !1, o = !1;
  function a(c, l = !0) {
    const f = e.params.lazy;
    if (typeof c > "u" || e.slides.length === 0) return;
    const p = e.virtual && e.params.virtual.enabled ? e.$wrapperEl.children(`.${e.params.slideClass}[data-swiper-slide-index="${c}"]`) : e.slides.eq(c), v = p.find(`.${f.elementClass}:not(.${f.loadedClass}):not(.${f.loadingClass})`);
    p.hasClass(f.elementClass) && !p.hasClass(f.loadedClass) && !p.hasClass(f.loadingClass) && v.push(p[0]), v.length !== 0 && v.each((h) => {
      const E = xt(h);
      E.addClass(f.loadingClass);
      const m = E.attr("data-background"), g = E.attr("data-src"), y = E.attr("data-srcset"), _ = E.attr("data-sizes"), S = E.parent("picture");
      e.loadImage(E[0], g || m, y, _, !1, () => {
        if (!(typeof e > "u" || e === null || !e || e && !e.params || e.destroyed)) {
          if (m ? (E.css("background-image", `url("${m}")`), E.removeAttr("data-background")) : (y && (E.attr("srcset", y), E.removeAttr("data-srcset")), _ && (E.attr("sizes", _), E.removeAttr("data-sizes")), S.length && S.children("source").each((A) => {
            const O = xt(A);
            O.attr("data-srcset") && (O.attr("srcset", O.attr("data-srcset")), O.removeAttr("data-srcset"));
          }), g && (E.attr("src", g), E.removeAttr("data-src"))), E.addClass(f.loadedClass).removeClass(f.loadingClass), p.find(`.${f.preloaderClass}`).remove(), e.params.loop && l) {
            const A = p.attr("data-swiper-slide-index");
            if (p.hasClass(e.params.slideDuplicateClass)) {
              const O = e.$wrapperEl.children(`[data-swiper-slide-index="${A}"]:not(.${e.params.slideDuplicateClass})`);
              a(O.index(), !1);
            } else {
              const O = e.$wrapperEl.children(`.${e.params.slideDuplicateClass}[data-swiper-slide-index="${A}"]`);
              a(O.index(), !1);
            }
          }
          n("lazyImageReady", p[0], E[0]), e.params.autoHeight && e.updateAutoHeight();
        }
      }), n("lazyImageLoad", p[0], E[0]);
    });
  }
  function u() {
    const {
      $wrapperEl: c,
      params: l,
      slides: f,
      activeIndex: d
    } = e, p = e.virtual && l.virtual.enabled, v = l.lazy;
    let h = l.slidesPerView;
    h === "auto" && (h = 0);
    function E(g) {
      if (p) {
        if (c.children(`.${l.slideClass}[data-swiper-slide-index="${g}"]`).length)
          return !0;
      } else if (f[g]) return !0;
      return !1;
    }
    function m(g) {
      return p ? xt(g).attr("data-swiper-slide-index") : xt(g).index();
    }
    if (o || (o = !0), e.params.watchSlidesProgress)
      c.children(`.${l.slideVisibleClass}`).each((g) => {
        const y = p ? xt(g).attr("data-swiper-slide-index") : xt(g).index();
        a(y);
      });
    else if (h > 1)
      for (let g = d; g < d + h; g += 1)
        E(g) && a(g);
    else
      a(d);
    if (v.loadPrevNext)
      if (h > 1 || v.loadPrevNextAmount && v.loadPrevNextAmount > 1) {
        const g = v.loadPrevNextAmount, y = Math.ceil(h), _ = Math.min(d + y + Math.max(g, y), f.length), S = Math.max(d - Math.max(y, g), 0);
        for (let A = d + y; A < _; A += 1)
          E(A) && a(A);
        for (let A = S; A < d; A += 1)
          E(A) && a(A);
      } else {
        const g = c.children(`.${l.slideNextClass}`);
        g.length > 0 && a(m(g));
        const y = c.children(`.${l.slidePrevClass}`);
        y.length > 0 && a(m(y));
      }
  }
  function s() {
    const c = Xn();
    if (!e || e.destroyed) return;
    const l = e.params.lazy.scrollingElement ? xt(e.params.lazy.scrollingElement) : xt(c), f = l[0] === c, d = f ? c.innerWidth : l[0].offsetWidth, p = f ? c.innerHeight : l[0].offsetHeight, v = e.$el.offset(), {
      rtlTranslate: h
    } = e;
    let E = !1;
    h && (v.left -= e.$el[0].scrollLeft);
    const m = [[v.left, v.top], [v.left + e.width, v.top], [v.left, v.top + e.height], [v.left + e.width, v.top + e.height]];
    for (let y = 0; y < m.length; y += 1) {
      const _ = m[y];
      if (_[0] >= 0 && _[0] <= d && _[1] >= 0 && _[1] <= p) {
        if (_[0] === 0 && _[1] === 0) continue;
        E = !0;
      }
    }
    const g = e.touchEvents.start === "touchstart" && e.support.passiveListener && e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    E ? (u(), l.off("scroll", s, g)) : i || (i = !0, l.on("scroll", s, g));
  }
  r("beforeInit", () => {
    e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
  }), r("init", () => {
    e.params.lazy.enabled && (e.params.lazy.checkInView ? s() : u());
  }), r("scroll", () => {
    e.params.freeMode && e.params.freeMode.enabled && !e.params.freeMode.sticky && u();
  }), r("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
    e.params.lazy.enabled && (e.params.lazy.checkInView ? s() : u());
  }), r("transitionStart", () => {
    e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !o) && (e.params.lazy.checkInView ? s() : u());
  }), r("transitionEnd", () => {
    e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && (e.params.lazy.checkInView ? s() : u());
  }), r("slideChange", () => {
    const {
      lazy: c,
      cssMode: l,
      watchSlidesProgress: f,
      touchReleaseOnEdges: d,
      resistanceRatio: p
    } = e.params;
    c.enabled && (l || f && (d || p === 0)) && u();
  }), r("destroy", () => {
    e.$el && e.$el.find(`.${e.params.lazy.loadingClass}`).removeClass(e.params.lazy.loadingClass);
  }), Object.assign(e.lazy, {
    load: u,
    loadInSlide: a
  });
}
function gor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function n(s, c) {
    const l = /* @__PURE__ */ function() {
      let v, h, E;
      return (m, g) => {
        for (h = -1, v = m.length; v - h > 1; )
          E = v + h >> 1, m[E] <= g ? h = E : v = E;
        return v;
      };
    }();
    this.x = s, this.y = c, this.lastIndex = s.length - 1;
    let f, d;
    return this.interpolate = function(v) {
      return v ? (d = l(this.x, v), f = d - 1, (v - this.x[f]) * (this.y[d] - this.y[f]) / (this.x[d] - this.x[f]) + this.y[f]) : 0;
    }, this;
  }
  function i(s) {
    e.controller.spline || (e.controller.spline = e.params.loop ? new n(e.slidesGrid, s.slidesGrid) : new n(e.snapGrid, s.snapGrid));
  }
  function o(s, c) {
    const l = e.controller.control;
    let f, d;
    const p = e.constructor;
    function v(h) {
      const E = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (i(h), d = -e.controller.spline.interpolate(-E)), (!d || e.params.controller.by === "container") && (f = (h.maxTranslate() - h.minTranslate()) / (e.maxTranslate() - e.minTranslate()), d = (E - e.minTranslate()) * f + h.minTranslate()), e.params.controller.inverse && (d = h.maxTranslate() - d), h.updateProgress(d), h.setTranslate(d, e), h.updateActiveIndex(), h.updateSlidesClasses();
    }
    if (Array.isArray(l))
      for (let h = 0; h < l.length; h += 1)
        l[h] !== c && l[h] instanceof p && v(l[h]);
    else l instanceof p && c !== l && v(l);
  }
  function a(s, c) {
    const l = e.constructor, f = e.controller.control;
    let d;
    function p(v) {
      v.setTransition(s, e), s !== 0 && (v.transitionStart(), v.params.autoHeight && e0(() => {
        v.updateAutoHeight();
      }), v.$wrapperEl.transitionEnd(() => {
        f && (v.params.loop && e.params.controller.by === "slide" && v.loopFix(), v.transitionEnd());
      }));
    }
    if (Array.isArray(f))
      for (d = 0; d < f.length; d += 1)
        f[d] !== c && f[d] instanceof l && p(f[d]);
    else f instanceof l && c !== f && p(f);
  }
  function u() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  r("beforeInit", () => {
    e.controller.control = e.params.controller.control;
  }), r("update", () => {
    u();
  }), r("resize", () => {
    u();
  }), r("observerUpdate", () => {
    u();
  }), r("setTranslate", (s, c, l) => {
    e.controller.control && e.controller.setTranslate(c, l);
  }), r("setTransition", (s, c, l) => {
    e.controller.control && e.controller.setTransition(c, l);
  }), Object.assign(e.controller, {
    setTranslate: o,
    setTransition: a
  });
}
function Tor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  }), e.a11y = {
    clicked: !1
  };
  let n = null;
  function i(H) {
    const B = n;
    B.length !== 0 && (B.html(""), B.html(H));
  }
  function o(H = 16) {
    const B = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(H).replace(/x/g, B);
  }
  function a(H) {
    H.attr("tabIndex", "0");
  }
  function u(H) {
    H.attr("tabIndex", "-1");
  }
  function s(H, B) {
    H.attr("role", B);
  }
  function c(H, B) {
    H.attr("aria-roledescription", B);
  }
  function l(H, B) {
    H.attr("aria-controls", B);
  }
  function f(H, B) {
    H.attr("aria-label", B);
  }
  function d(H, B) {
    H.attr("id", B);
  }
  function p(H, B) {
    H.attr("aria-live", B);
  }
  function v(H) {
    H.attr("aria-disabled", !0);
  }
  function h(H) {
    H.attr("aria-disabled", !1);
  }
  function E(H) {
    if (H.keyCode !== 13 && H.keyCode !== 32) return;
    const B = e.params.a11y, x = xt(H.target);
    e.navigation && e.navigation.$nextEl && x.is(e.navigation.$nextEl) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? i(B.lastSlideMessage) : i(B.nextSlideMessage)), e.navigation && e.navigation.$prevEl && x.is(e.navigation.$prevEl) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? i(B.firstSlideMessage) : i(B.prevSlideMessage)), e.pagination && x.is(Fc(e.params.pagination.bulletClass)) && x[0].click();
  }
  function m() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      $nextEl: H,
      $prevEl: B
    } = e.navigation;
    B && B.length > 0 && (e.isBeginning ? (v(B), u(B)) : (h(B), a(B))), H && H.length > 0 && (e.isEnd ? (v(H), u(H)) : (h(H), a(H)));
  }
  function g() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function y() {
    return g() && e.params.pagination.clickable;
  }
  function _() {
    const H = e.params.a11y;
    g() && e.pagination.bullets.each((B) => {
      const x = xt(B);
      e.params.pagination.clickable && (a(x), e.params.pagination.renderBullet || (s(x, "button"), f(x, H.paginationBulletMessage.replace(/\{\{index\}\}/, x.index() + 1)))), x.is(`.${e.params.pagination.bulletActiveClass}`) ? x.attr("aria-current", "true") : x.removeAttr("aria-current");
    });
  }
  const S = (H, B, x) => {
    a(H), H[0].tagName !== "BUTTON" && (s(H, "button"), H.on("keydown", E)), f(H, x), l(H, B);
  }, A = () => {
    e.a11y.clicked = !0;
  }, O = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, P = (H) => {
    if (e.a11y.clicked) return;
    const B = H.target.closest(`.${e.params.slideClass}`);
    if (!B || !e.slides.includes(B)) return;
    const x = e.slides.indexOf(B) === e.activeIndex, D = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(B);
    x || D || H.sourceCapabilities && H.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, e.slideTo(e.slides.indexOf(B), 0));
  }, U = () => {
    const H = e.params.a11y;
    H.itemRoleDescriptionMessage && c(xt(e.slides), H.itemRoleDescriptionMessage), H.slideRole && s(xt(e.slides), H.slideRole);
    const B = e.params.loop ? e.slides.filter((x) => !x.classList.contains(e.params.slideDuplicateClass)).length : e.slides.length;
    H.slideLabelMessage && e.slides.each((x, D) => {
      const w = xt(x), $ = e.params.loop ? parseInt(w.attr("data-swiper-slide-index"), 10) : D, X = H.slideLabelMessage.replace(/\{\{index\}\}/, $ + 1).replace(/\{\{slidesLength\}\}/, B);
      f(w, X);
    });
  }, z = () => {
    const H = e.params.a11y;
    e.$el.append(n);
    const B = e.$el;
    H.containerRoleDescriptionMessage && c(B, H.containerRoleDescriptionMessage), H.containerMessage && f(B, H.containerMessage);
    const x = e.$wrapperEl, D = H.id || x.attr("id") || `swiper-wrapper-${o(16)}`, w = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    d(x, D), p(x, w), U();
    let $, X;
    e.navigation && e.navigation.$nextEl && ($ = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (X = e.navigation.$prevEl), $ && $.length && S($, D, H.nextSlideMessage), X && X.length && S(X, D, H.prevSlideMessage), y() && e.pagination.$el.on("keydown", Fc(e.params.pagination.bulletClass), E), e.$el.on("focus", P, !0), e.$el.on("pointerdown", A, !0), e.$el.on("pointerup", O, !0);
  };
  function k() {
    n && n.length > 0 && n.remove();
    let H, B;
    e.navigation && e.navigation.$nextEl && (H = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (B = e.navigation.$prevEl), H && H.off("keydown", E), B && B.off("keydown", E), y() && e.pagination.$el.off("keydown", Fc(e.params.pagination.bulletClass), E), e.$el.off("focus", P, !0), e.$el.off("pointerdown", A, !0), e.$el.off("pointerup", O, !0);
  }
  r("beforeInit", () => {
    n = xt(`<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  }), r("afterInit", () => {
    e.params.a11y.enabled && z();
  }), r("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && U();
  }), r("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && m();
  }), r("paginationUpdate", () => {
    e.params.a11y.enabled && _();
  }), r("destroy", () => {
    e.params.a11y.enabled && k();
  });
}
function yor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let n = !1, i = {};
  const o = (d) => d.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), a = (d) => {
    const p = Xn();
    let v;
    d ? v = new URL(d) : v = p.location;
    const h = v.pathname.slice(1).split("/").filter((y) => y !== ""), E = h.length, m = h[E - 2], g = h[E - 1];
    return {
      key: m,
      value: g
    };
  }, u = (d, p) => {
    const v = Xn();
    if (!n || !e.params.history.enabled) return;
    let h;
    e.params.url ? h = new URL(e.params.url) : h = v.location;
    const E = e.slides.eq(p);
    let m = o(E.attr("data-history"));
    if (e.params.history.root.length > 0) {
      let y = e.params.history.root;
      y[y.length - 1] === "/" && (y = y.slice(0, y.length - 1)), m = `${y}/${d}/${m}`;
    } else h.pathname.includes(d) || (m = `${d}/${m}`);
    e.params.history.keepQuery && (m += h.search);
    const g = v.history.state;
    g && g.value === m || (e.params.history.replaceState ? v.history.replaceState({
      value: m
    }, null, m) : v.history.pushState({
      value: m
    }, null, m));
  }, s = (d, p, v) => {
    if (p)
      for (let h = 0, E = e.slides.length; h < E; h += 1) {
        const m = e.slides.eq(h);
        if (o(m.attr("data-history")) === p && !m.hasClass(e.params.slideDuplicateClass)) {
          const y = m.index();
          e.slideTo(y, d, v);
        }
      }
    else
      e.slideTo(0, d, v);
  }, c = () => {
    i = a(e.params.url), s(e.params.speed, i.value, !1);
  }, l = () => {
    const d = Xn();
    if (e.params.history) {
      if (!d.history || !d.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      n = !0, i = a(e.params.url), !(!i.key && !i.value) && (s(0, i.value, e.params.runCallbacksOnInit), e.params.history.replaceState || d.addEventListener("popstate", c));
    }
  }, f = () => {
    const d = Xn();
    e.params.history.replaceState || d.removeEventListener("popstate", c);
  };
  r("init", () => {
    e.params.history.enabled && l();
  }), r("destroy", () => {
    e.params.history.enabled && f();
  }), r("transitionEnd _freeModeNoMomentumRelease", () => {
    n && u(e.params.history.key, e.activeIndex);
  }), r("slideChange", () => {
    n && e.params.cssMode && u(e.params.history.key, e.activeIndex);
  });
}
function _or({
  swiper: e,
  extendParams: t,
  emit: r,
  on: n
}) {
  let i = !1;
  const o = Zi(), a = Xn();
  t({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1
    }
  });
  const u = () => {
    r("hashChange");
    const f = o.location.hash.replace("#", ""), d = e.slides.eq(e.activeIndex).attr("data-hash");
    if (f !== d) {
      const p = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${f}"]`).index();
      if (typeof p > "u") return;
      e.slideTo(p);
    }
  }, s = () => {
    if (!(!i || !e.params.hashNavigation.enabled))
      if (e.params.hashNavigation.replaceState && a.history && a.history.replaceState)
        a.history.replaceState(null, null, `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || ""), r("hashSet");
      else {
        const f = e.slides.eq(e.activeIndex), d = f.attr("data-hash") || f.attr("data-history");
        o.location.hash = d || "", r("hashSet");
      }
  }, c = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    i = !0;
    const f = o.location.hash.replace("#", "");
    if (f)
      for (let p = 0, v = e.slides.length; p < v; p += 1) {
        const h = e.slides.eq(p);
        if ((h.attr("data-hash") || h.attr("data-history")) === f && !h.hasClass(e.params.slideDuplicateClass)) {
          const m = h.index();
          e.slideTo(m, 0, e.params.runCallbacksOnInit, !0);
        }
      }
    e.params.hashNavigation.watchState && xt(a).on("hashchange", u);
  }, l = () => {
    e.params.hashNavigation.watchState && xt(a).off("hashchange", u);
  };
  n("init", () => {
    e.params.hashNavigation.enabled && c();
  }), n("destroy", () => {
    e.params.hashNavigation.enabled && l();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    i && s();
  }), n("slideChange", () => {
    i && e.params.cssMode && s();
  });
}
function Aor({
  swiper: e,
  extendParams: t,
  on: r,
  emit: n
}) {
  let i;
  e.autoplay = {
    running: !1,
    paused: !1
  }, t({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  function o() {
    if (!e.size) {
      e.autoplay.running = !1, e.autoplay.paused = !1;
      return;
    }
    const h = e.slides.eq(e.activeIndex);
    let E = e.params.autoplay.delay;
    h.attr("data-swiper-autoplay") && (E = h.attr("data-swiper-autoplay") || e.params.autoplay.delay), clearTimeout(i), i = e0(() => {
      let m;
      e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), m = e.slidePrev(e.params.speed, !0, !0), n("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? u() : (m = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), n("autoplay")) : (m = e.slidePrev(e.params.speed, !0, !0), n("autoplay")) : e.params.loop ? (e.loopFix(), m = e.slideNext(e.params.speed, !0, !0), n("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? u() : (m = e.slideTo(0, e.params.speed, !0, !0), n("autoplay")) : (m = e.slideNext(e.params.speed, !0, !0), n("autoplay")), (e.params.cssMode && e.autoplay.running || m === !1) && o();
    }, E);
  }
  function a() {
    return typeof i < "u" || e.autoplay.running ? !1 : (e.autoplay.running = !0, n("autoplayStart"), o(), !0);
  }
  function u() {
    return !e.autoplay.running || typeof i > "u" ? !1 : (i && (clearTimeout(i), i = void 0), e.autoplay.running = !1, n("autoplayStop"), !0);
  }
  function s(h) {
    e.autoplay.running && (e.autoplay.paused || (i && clearTimeout(i), e.autoplay.paused = !0, h === 0 || !e.params.autoplay.waitForTransition ? (e.autoplay.paused = !1, o()) : ["transitionend", "webkitTransitionEnd"].forEach((E) => {
      e.$wrapperEl[0].addEventListener(E, l);
    })));
  }
  function c() {
    const h = Zi();
    h.visibilityState === "hidden" && e.autoplay.running && s(), h.visibilityState === "visible" && e.autoplay.paused && (o(), e.autoplay.paused = !1);
  }
  function l(h) {
    !e || e.destroyed || !e.$wrapperEl || h.target === e.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((E) => {
      e.$wrapperEl[0].removeEventListener(E, l);
    }), e.autoplay.paused = !1, e.autoplay.running ? o() : u());
  }
  function f() {
    e.params.autoplay.disableOnInteraction ? u() : (n("autoplayPause"), s()), ["transitionend", "webkitTransitionEnd"].forEach((h) => {
      e.$wrapperEl[0].removeEventListener(h, l);
    });
  }
  function d() {
    e.params.autoplay.disableOnInteraction || (e.autoplay.paused = !1, n("autoplayResume"), o());
  }
  function p() {
    e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", f), e.$el.on("mouseleave", d));
  }
  function v() {
    e.$el.off("mouseenter", f), e.$el.off("mouseleave", d);
  }
  r("init", () => {
    e.params.autoplay.enabled && (a(), Zi().addEventListener("visibilitychange", c), p());
  }), r("beforeTransitionStart", (h, E, m) => {
    e.autoplay.running && (m || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(E) : u());
  }), r("sliderFirstMove", () => {
    e.autoplay.running && (e.params.autoplay.disableOnInteraction ? u() : s());
  }), r("touchEnd", () => {
    e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && o();
  }), r("destroy", () => {
    v(), e.autoplay.running && u(), Zi().removeEventListener("visibilitychange", c);
  }), Object.assign(e.autoplay, {
    pause: s,
    run: o,
    start: a,
    stop: u
  });
}
function Sor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let n = !1, i = !1;
  e.thumbs = {
    swiper: null
  };
  function o() {
    const s = e.thumbs.swiper;
    if (!s || s.destroyed) return;
    const c = s.clickedIndex, l = s.clickedSlide;
    if (l && xt(l).hasClass(e.params.thumbs.slideThumbActiveClass) || typeof c > "u" || c === null) return;
    let f;
    if (s.params.loop ? f = parseInt(xt(s.clickedSlide).attr("data-swiper-slide-index"), 10) : f = c, e.params.loop) {
      let d = e.activeIndex;
      e.slides.eq(d).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, d = e.activeIndex);
      const p = e.slides.eq(d).prevAll(`[data-swiper-slide-index="${f}"]`).eq(0).index(), v = e.slides.eq(d).nextAll(`[data-swiper-slide-index="${f}"]`).eq(0).index();
      typeof p > "u" ? f = v : typeof v > "u" ? f = p : v - d < d - p ? f = v : f = p;
    }
    e.slideTo(f);
  }
  function a() {
    const {
      thumbs: s
    } = e.params;
    if (n) return !1;
    n = !0;
    const c = e.constructor;
    if (s.swiper instanceof c)
      e.thumbs.swiper = s.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      });
    else if (r1(s.swiper)) {
      const l = Object.assign({}, s.swiper);
      Object.assign(l, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new c(l), i = !0;
    }
    return e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", o), !0;
  }
  function u(s) {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const l = c.params.slidesPerView === "auto" ? c.slidesPerViewDynamic() : c.params.slidesPerView;
    let f = 1;
    const d = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (f = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (f = 1), f = Math.floor(f), c.slides.removeClass(d), c.params.loop || c.params.virtual && c.params.virtual.enabled)
      for (let h = 0; h < f; h += 1)
        c.$wrapperEl.children(`[data-swiper-slide-index="${e.realIndex + h}"]`).addClass(d);
    else
      for (let h = 0; h < f; h += 1)
        c.slides.eq(e.realIndex + h).addClass(d);
    const p = e.params.thumbs.autoScrollOffset, v = p && !c.params.loop;
    if (e.realIndex !== c.realIndex || v) {
      let h = c.activeIndex, E, m;
      if (c.params.loop) {
        c.slides.eq(h).hasClass(c.params.slideDuplicateClass) && (c.loopFix(), c._clientLeft = c.$wrapperEl[0].clientLeft, h = c.activeIndex);
        const g = c.slides.eq(h).prevAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index(), y = c.slides.eq(h).nextAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index();
        typeof g > "u" ? E = y : typeof y > "u" ? E = g : y - h === h - g ? E = c.params.slidesPerGroup > 1 ? y : h : y - h < h - g ? E = y : E = g, m = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        E = e.realIndex, m = E > e.previousIndex ? "next" : "prev";
      v && (E += m === "next" ? p : -1 * p), c.visibleSlidesIndexes && c.visibleSlidesIndexes.indexOf(E) < 0 && (c.params.centeredSlides ? E > h ? E = E - Math.floor(l / 2) + 1 : E = E + Math.floor(l / 2) - 1 : E > h && c.params.slidesPerGroup, c.slideTo(E, s ? 0 : void 0));
    }
  }
  r("beforeInit", () => {
    const {
      thumbs: s
    } = e.params;
    !s || !s.swiper || (a(), u(!0));
  }), r("slideChange update resize observerUpdate", () => {
    u();
  }), r("setTransition", (s, c) => {
    const l = e.thumbs.swiper;
    !l || l.destroyed || l.setTransition(c);
  }), r("beforeDestroy", () => {
    const s = e.thumbs.swiper;
    !s || s.destroyed || i && s.destroy();
  }), Object.assign(e.thumbs, {
    init: a,
    update: u
  });
}
function bor({
  swiper: e,
  extendParams: t,
  emit: r,
  once: n
}) {
  t({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function i() {
    const u = e.getTranslate();
    e.setTranslate(u), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function o() {
    const {
      touchEventsData: u,
      touches: s
    } = e;
    u.velocities.length === 0 && u.velocities.push({
      position: s[e.isHorizontal() ? "startX" : "startY"],
      time: u.touchStartTime
    }), u.velocities.push({
      position: s[e.isHorizontal() ? "currentX" : "currentY"],
      time: tu()
    });
  }
  function a({
    currentPos: u
  }) {
    const {
      params: s,
      $wrapperEl: c,
      rtlTranslate: l,
      snapGrid: f,
      touchEventsData: d
    } = e, v = tu() - d.touchStartTime;
    if (u < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (u > -e.maxTranslate()) {
      e.slides.length < f.length ? e.slideTo(f.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (s.freeMode.momentum) {
      if (d.velocities.length > 1) {
        const A = d.velocities.pop(), O = d.velocities.pop(), P = A.position - O.position, U = A.time - O.time;
        e.velocity = P / U, e.velocity /= 2, Math.abs(e.velocity) < s.freeMode.minimumVelocity && (e.velocity = 0), (U > 150 || tu() - A.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= s.freeMode.momentumVelocityRatio, d.velocities.length = 0;
      let h = 1e3 * s.freeMode.momentumRatio;
      const E = e.velocity * h;
      let m = e.translate + E;
      l && (m = -m);
      let g = !1, y;
      const _ = Math.abs(e.velocity) * 20 * s.freeMode.momentumBounceRatio;
      let S;
      if (m < e.maxTranslate())
        s.freeMode.momentumBounce ? (m + e.maxTranslate() < -_ && (m = e.maxTranslate() - _), y = e.maxTranslate(), g = !0, d.allowMomentumBounce = !0) : m = e.maxTranslate(), s.loop && s.centeredSlides && (S = !0);
      else if (m > e.minTranslate())
        s.freeMode.momentumBounce ? (m - e.minTranslate() > _ && (m = e.minTranslate() + _), y = e.minTranslate(), g = !0, d.allowMomentumBounce = !0) : m = e.minTranslate(), s.loop && s.centeredSlides && (S = !0);
      else if (s.freeMode.sticky) {
        let A;
        for (let O = 0; O < f.length; O += 1)
          if (f[O] > -m) {
            A = O;
            break;
          }
        Math.abs(f[A] - m) < Math.abs(f[A - 1] - m) || e.swipeDirection === "next" ? m = f[A] : m = f[A - 1], m = -m;
      }
      if (S && n("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (l ? h = Math.abs((-m - e.translate) / e.velocity) : h = Math.abs((m - e.translate) / e.velocity), s.freeMode.sticky) {
          const A = Math.abs((l ? -m : m) - e.translate), O = e.slidesSizesGrid[e.activeIndex];
          A < O ? h = s.speed : A < 2 * O ? h = s.speed * 1.5 : h = s.speed * 2.5;
        }
      } else if (s.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      s.freeMode.momentumBounce && g ? (e.updateProgress(y), e.setTransition(h), e.setTranslate(m), e.transitionStart(!0, e.swipeDirection), e.animating = !0, c.transitionEnd(() => {
        !e || e.destroyed || !d.allowMomentumBounce || (r("momentumBounce"), e.setTransition(s.speed), setTimeout(() => {
          e.setTranslate(y), c.transitionEnd(() => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (r("_freeModeNoMomentumRelease"), e.updateProgress(m), e.setTransition(h), e.setTranslate(m), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, c.transitionEnd(() => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(m), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (s.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else s.freeMode && r("_freeModeNoMomentumRelease");
    (!s.freeMode.momentum || v >= s.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: i,
      onTouchMove: o,
      onTouchEnd: a
    }
  });
}
function Cor({
  swiper: e,
  extendParams: t
}) {
  t({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let r, n, i;
  const o = (s) => {
    const {
      slidesPerView: c
    } = e.params, {
      rows: l,
      fill: f
    } = e.params.grid;
    n = r / l, i = Math.floor(s / l), Math.floor(s / l) === s / l ? r = s : r = Math.ceil(s / l) * l, c !== "auto" && f === "row" && (r = Math.max(r, c * l));
  }, a = (s, c, l, f) => {
    const {
      slidesPerGroup: d,
      spaceBetween: p
    } = e.params, {
      rows: v,
      fill: h
    } = e.params.grid;
    let E, m, g;
    if (h === "row" && d > 1) {
      const y = Math.floor(s / (d * v)), _ = s - v * d * y, S = y === 0 ? d : Math.min(Math.ceil((l - y * v * d) / v), d);
      g = Math.floor(_ / S), m = _ - g * S + y * d, E = m + g * r / v, c.css({
        "-webkit-order": E,
        order: E
      });
    } else h === "column" ? (m = Math.floor(s / v), g = s - m * v, (m > i || m === i && g === v - 1) && (g += 1, g >= v && (g = 0, m += 1))) : (g = Math.floor(s / n), m = s - g * n);
    c.css(f("margin-top"), g !== 0 ? p && `${p}px` : "");
  }, u = (s, c, l) => {
    const {
      spaceBetween: f,
      centeredSlides: d,
      roundLengths: p
    } = e.params, {
      rows: v
    } = e.params.grid;
    if (e.virtualSize = (s + f) * r, e.virtualSize = Math.ceil(e.virtualSize / v) - f, e.$wrapperEl.css({
      [l("width")]: `${e.virtualSize + f}px`
    }), d) {
      c.splice(0, c.length);
      const h = [];
      for (let E = 0; E < c.length; E += 1) {
        let m = c[E];
        p && (m = Math.floor(m)), c[E] < e.virtualSize + c[0] && h.push(m);
      }
      c.push(...h);
    }
  };
  e.grid = {
    initSlides: o,
    updateSlide: a,
    updateWrapperSize: u
  };
}
function Ior(e) {
  const t = this, {
    $wrapperEl: r,
    params: n
  } = t;
  if (n.loop && t.loopDestroy(), typeof e == "object" && "length" in e)
    for (let i = 0; i < e.length; i += 1)
      e[i] && r.append(e[i]);
  else
    r.append(e);
  n.loop && t.loopCreate(), n.observer || t.update();
}
function Oor(e) {
  const t = this, {
    params: r,
    $wrapperEl: n,
    activeIndex: i
  } = t;
  r.loop && t.loopDestroy();
  let o = i + 1;
  if (typeof e == "object" && "length" in e) {
    for (let a = 0; a < e.length; a += 1)
      e[a] && n.prepend(e[a]);
    o = i + e.length;
  } else
    n.prepend(e);
  r.loop && t.loopCreate(), r.observer || t.update(), t.slideTo(o, 0, !1);
}
function Ror(e, t) {
  const r = this, {
    $wrapperEl: n,
    params: i,
    activeIndex: o
  } = r;
  let a = o;
  i.loop && (a -= r.loopedSlides, r.loopDestroy(), r.slides = n.children(`.${i.slideClass}`));
  const u = r.slides.length;
  if (e <= 0) {
    r.prependSlide(t);
    return;
  }
  if (e >= u) {
    r.appendSlide(t);
    return;
  }
  let s = a > e ? a + 1 : a;
  const c = [];
  for (let l = u - 1; l >= e; l -= 1) {
    const f = r.slides.eq(l);
    f.remove(), c.unshift(f);
  }
  if (typeof t == "object" && "length" in t) {
    for (let l = 0; l < t.length; l += 1)
      t[l] && n.append(t[l]);
    s = a > e ? a + t.length : a;
  } else
    n.append(t);
  for (let l = 0; l < c.length; l += 1)
    n.append(c[l]);
  i.loop && r.loopCreate(), i.observer || r.update(), i.loop ? r.slideTo(s + r.loopedSlides, 0, !1) : r.slideTo(s, 0, !1);
}
function wor(e) {
  const t = this, {
    params: r,
    $wrapperEl: n,
    activeIndex: i
  } = t;
  let o = i;
  r.loop && (o -= t.loopedSlides, t.loopDestroy(), t.slides = n.children(`.${r.slideClass}`));
  let a = o, u;
  if (typeof e == "object" && "length" in e) {
    for (let s = 0; s < e.length; s += 1)
      u = e[s], t.slides[u] && t.slides.eq(u).remove(), u < a && (a -= 1);
    a = Math.max(a, 0);
  } else
    u = e, t.slides[u] && t.slides.eq(u).remove(), u < a && (a -= 1), a = Math.max(a, 0);
  r.loop && t.loopCreate(), r.observer || t.update(), r.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
}
function Por() {
  const e = this, t = [];
  for (let r = 0; r < e.slides.length; r += 1)
    t.push(r);
  e.removeSlide(t);
}
function Dor({
  swiper: e
}) {
  Object.assign(e, {
    appendSlide: Ior.bind(e),
    prependSlide: Oor.bind(e),
    addSlide: Ror.bind(e),
    removeSlide: wor.bind(e),
    removeAllSlides: Por.bind(e)
  });
}
function Wh(e) {
  const {
    effect: t,
    swiper: r,
    on: n,
    setTranslate: i,
    setTransition: o,
    overwriteParams: a,
    perspective: u,
    recreateShadows: s,
    getEffectParams: c
  } = e;
  n("beforeInit", () => {
    if (r.params.effect !== t) return;
    r.classNames.push(`${r.params.containerModifierClass}${t}`), u && u() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const f = a ? a() : {};
    Object.assign(r.params, f), Object.assign(r.originalParams, f);
  }), n("setTranslate", () => {
    r.params.effect === t && i();
  }), n("setTransition", (f, d) => {
    r.params.effect === t && o(d);
  }), n("transitionEnd", () => {
    if (r.params.effect === t && s) {
      if (!c || !c().slideShadows) return;
      r.slides.each((f) => {
        r.$(f).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
      }), s();
    }
  });
  let l;
  n("virtualUpdate", () => {
    r.params.effect === t && (r.slides.length || (l = !0), requestAnimationFrame(() => {
      l && r.slides && r.slides.length && (i(), l = !1);
    }));
  });
}
function Oy(e, t) {
  return e.transformEl ? t.find(e.transformEl).css({
    "backface-visibility": "hidden",
    "-webkit-backface-visibility": "hidden"
  }) : t;
}
function C3({
  swiper: e,
  duration: t,
  transformEl: r,
  allSlides: n
}) {
  const {
    slides: i,
    activeIndex: o,
    $wrapperEl: a
  } = e;
  if (e.params.virtualTranslate && t !== 0) {
    let u = !1, s;
    n ? s = r ? i.find(r) : i : s = r ? i.eq(o).find(r) : i.eq(o), s.transitionEnd(() => {
      if (u || !e || e.destroyed) return;
      u = !0, e.animating = !1;
      const c = ["webkitTransitionEnd", "transitionend"];
      for (let l = 0; l < c.length; l += 1)
        a.trigger(c[l]);
    });
  }
}
function xor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    fadeEffect: {
      crossFade: !1,
      transformEl: null
    }
  }), Wh({
    effect: "fade",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: o
      } = e, a = e.params.fadeEffect;
      for (let u = 0; u < o.length; u += 1) {
        const s = e.slides.eq(u);
        let l = -s[0].swiperSlideOffset;
        e.params.virtualTranslate || (l -= e.translate);
        let f = 0;
        e.isHorizontal() || (f = l, l = 0);
        const d = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(s[0].progress), 0) : 1 + Math.min(Math.max(s[0].progress, -1), 0);
        Oy(a, s).css({
          opacity: d
        }).transform(`translate3d(${l}px, ${f}px, 0px)`);
      }
    },
    setTransition: (o) => {
      const {
        transformEl: a
      } = e.params.fadeEffect;
      (a ? e.slides.find(a) : e.slides).transition(o), C3({
        swiper: e,
        duration: o,
        transformEl: a,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Nor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const n = (u, s, c) => {
    let l = c ? u.find(".swiper-slide-shadow-left") : u.find(".swiper-slide-shadow-top"), f = c ? u.find(".swiper-slide-shadow-right") : u.find(".swiper-slide-shadow-bottom");
    l.length === 0 && (l = xt(`<div class="swiper-slide-shadow-${c ? "left" : "top"}"></div>`), u.append(l)), f.length === 0 && (f = xt(`<div class="swiper-slide-shadow-${c ? "right" : "bottom"}"></div>`), u.append(f)), l.length && (l[0].style.opacity = Math.max(-s, 0)), f.length && (f[0].style.opacity = Math.max(s, 0));
  };
  Wh({
    effect: "cube",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        $el: u,
        $wrapperEl: s,
        slides: c,
        width: l,
        height: f,
        rtlTranslate: d,
        size: p,
        browser: v
      } = e, h = e.params.cubeEffect, E = e.isHorizontal(), m = e.virtual && e.params.virtual.enabled;
      let g = 0, y;
      h.shadow && (E ? (y = s.find(".swiper-cube-shadow"), y.length === 0 && (y = xt('<div class="swiper-cube-shadow"></div>'), s.append(y)), y.css({
        height: `${l}px`
      })) : (y = u.find(".swiper-cube-shadow"), y.length === 0 && (y = xt('<div class="swiper-cube-shadow"></div>'), u.append(y))));
      for (let S = 0; S < c.length; S += 1) {
        const A = c.eq(S);
        let O = S;
        m && (O = parseInt(A.attr("data-swiper-slide-index"), 10));
        let P = O * 90, U = Math.floor(P / 360);
        d && (P = -P, U = Math.floor(-P / 360));
        const z = Math.max(Math.min(A[0].progress, 1), -1);
        let k = 0, H = 0, B = 0;
        O % 4 === 0 ? (k = -U * 4 * p, B = 0) : (O - 1) % 4 === 0 ? (k = 0, B = -U * 4 * p) : (O - 2) % 4 === 0 ? (k = p + U * 4 * p, B = p) : (O - 3) % 4 === 0 && (k = -p, B = 3 * p + p * 4 * U), d && (k = -k), E || (H = k, k = 0);
        const x = `rotateX(${E ? 0 : -P}deg) rotateY(${E ? P : 0}deg) translate3d(${k}px, ${H}px, ${B}px)`;
        z <= 1 && z > -1 && (g = O * 90 + z * 90, d && (g = -O * 90 - z * 90)), A.transform(x), h.slideShadows && n(A, z, E);
      }
      if (s.css({
        "-webkit-transform-origin": `50% 50% -${p / 2}px`,
        "transform-origin": `50% 50% -${p / 2}px`
      }), h.shadow)
        if (E)
          y.transform(`translate3d(0px, ${l / 2 + h.shadowOffset}px, ${-l / 2}px) rotateX(90deg) rotateZ(0deg) scale(${h.shadowScale})`);
        else {
          const S = Math.abs(g) - Math.floor(Math.abs(g) / 90) * 90, A = 1.5 - (Math.sin(S * 2 * Math.PI / 360) / 2 + Math.cos(S * 2 * Math.PI / 360) / 2), O = h.shadowScale, P = h.shadowScale / A, U = h.shadowOffset;
          y.transform(`scale3d(${O}, 1, ${P}) translate3d(0px, ${f / 2 + U}px, ${-f / 2 / P}px) rotateX(-90deg)`);
        }
      const _ = v.isSafari || v.isWebView ? -p / 2 : 0;
      s.transform(`translate3d(0px,0,${_}px) rotateX(${e.isHorizontal() ? 0 : g}deg) rotateY(${e.isHorizontal() ? -g : 0}deg)`), s[0].style.setProperty("--swiper-cube-translate-z", `${_}px`);
    },
    setTransition: (u) => {
      const {
        $el: s,
        slides: c
      } = e;
      c.transition(u).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(u), e.params.cubeEffect.shadow && !e.isHorizontal() && s.find(".swiper-cube-shadow").transition(u);
    },
    recreateShadows: () => {
      const u = e.isHorizontal();
      e.slides.each((s) => {
        const c = Math.max(Math.min(s.progress, 1), -1);
        n(xt(s), c, u);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function Xp(e, t, r) {
  const n = `swiper-slide-shadow${r ? `-${r}` : ""}`, i = e.transformEl ? t.find(e.transformEl) : t;
  let o = i.children(`.${n}`);
  return o.length || (o = xt(`<div class="swiper-slide-shadow${r ? `-${r}` : ""}"></div>`), i.append(o)), o;
}
function Lor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0,
      transformEl: null
    }
  });
  const n = (u, s, c) => {
    let l = e.isHorizontal() ? u.find(".swiper-slide-shadow-left") : u.find(".swiper-slide-shadow-top"), f = e.isHorizontal() ? u.find(".swiper-slide-shadow-right") : u.find(".swiper-slide-shadow-bottom");
    l.length === 0 && (l = Xp(c, u, e.isHorizontal() ? "left" : "top")), f.length === 0 && (f = Xp(c, u, e.isHorizontal() ? "right" : "bottom")), l.length && (l[0].style.opacity = Math.max(-s, 0)), f.length && (f[0].style.opacity = Math.max(s, 0));
  };
  Wh({
    effect: "flip",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: u,
        rtlTranslate: s
      } = e, c = e.params.flipEffect;
      for (let l = 0; l < u.length; l += 1) {
        const f = u.eq(l);
        let d = f[0].progress;
        e.params.flipEffect.limitRotation && (d = Math.max(Math.min(f[0].progress, 1), -1));
        const p = f[0].swiperSlideOffset;
        let h = -180 * d, E = 0, m = e.params.cssMode ? -p - e.translate : -p, g = 0;
        e.isHorizontal() ? s && (h = -h) : (g = m, m = 0, E = -h, h = 0), f[0].style.zIndex = -Math.abs(Math.round(d)) + u.length, c.slideShadows && n(f, d, c);
        const y = `translate3d(${m}px, ${g}px, 0px) rotateX(${E}deg) rotateY(${h}deg)`;
        Oy(c, f).transform(y);
      }
    },
    setTransition: (u) => {
      const {
        transformEl: s
      } = e.params.flipEffect;
      (s ? e.slides.find(s) : e.slides).transition(u).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(u), C3({
        swiper: e,
        duration: u,
        transformEl: s
      });
    },
    recreateShadows: () => {
      const u = e.params.flipEffect;
      e.slides.each((s) => {
        const c = xt(s);
        let l = c[0].progress;
        e.params.flipEffect.limitRotation && (l = Math.max(Math.min(s.progress, 1), -1)), n(c, l, u);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Bor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0,
      transformEl: null
    }
  }), Wh({
    effect: "coverflow",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        width: o,
        height: a,
        slides: u,
        slidesSizesGrid: s
      } = e, c = e.params.coverflowEffect, l = e.isHorizontal(), f = e.translate, d = l ? -f + o / 2 : -f + a / 2, p = l ? c.rotate : -c.rotate, v = c.depth;
      for (let h = 0, E = u.length; h < E; h += 1) {
        const m = u.eq(h), g = s[h], y = m[0].swiperSlideOffset, _ = (d - y - g / 2) / g, S = typeof c.modifier == "function" ? c.modifier(_) : _ * c.modifier;
        let A = l ? p * S : 0, O = l ? 0 : p * S, P = -v * Math.abs(S), U = c.stretch;
        typeof U == "string" && U.indexOf("%") !== -1 && (U = parseFloat(c.stretch) / 100 * g);
        let z = l ? 0 : U * S, k = l ? U * S : 0, H = 1 - (1 - c.scale) * Math.abs(S);
        Math.abs(k) < 1e-3 && (k = 0), Math.abs(z) < 1e-3 && (z = 0), Math.abs(P) < 1e-3 && (P = 0), Math.abs(A) < 1e-3 && (A = 0), Math.abs(O) < 1e-3 && (O = 0), Math.abs(H) < 1e-3 && (H = 0);
        const B = `translate3d(${k}px,${z}px,${P}px)  rotateX(${O}deg) rotateY(${A}deg) scale(${H})`;
        if (Oy(c, m).transform(B), m[0].style.zIndex = -Math.abs(Math.round(S)) + 1, c.slideShadows) {
          let D = l ? m.find(".swiper-slide-shadow-left") : m.find(".swiper-slide-shadow-top"), w = l ? m.find(".swiper-slide-shadow-right") : m.find(".swiper-slide-shadow-bottom");
          D.length === 0 && (D = Xp(c, m, l ? "left" : "top")), w.length === 0 && (w = Xp(c, m, l ? "right" : "bottom")), D.length && (D[0].style.opacity = S > 0 ? S : 0), w.length && (w[0].style.opacity = -S > 0 ? -S : 0);
        }
      }
    },
    setTransition: (o) => {
      const {
        transformEl: a
      } = e.params.coverflowEffect;
      (a ? e.slides.find(a) : e.slides).transition(o).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(o);
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function kor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const n = (a) => typeof a == "string" ? a : `${a}px`;
  Wh({
    effect: "creative",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: a,
        $wrapperEl: u,
        slidesSizesGrid: s
      } = e, c = e.params.creativeEffect, {
        progressMultiplier: l
      } = c, f = e.params.centeredSlides;
      if (f) {
        const d = s[0] / 2 - e.params.slidesOffsetBefore || 0;
        u.transform(`translateX(calc(50% - ${d}px))`);
      }
      for (let d = 0; d < a.length; d += 1) {
        const p = a.eq(d), v = p[0].progress, h = Math.min(Math.max(p[0].progress, -c.limitProgress), c.limitProgress);
        let E = h;
        f || (E = Math.min(Math.max(p[0].originalProgress, -c.limitProgress), c.limitProgress));
        const m = p[0].swiperSlideOffset, g = [e.params.cssMode ? -m - e.translate : -m, 0, 0], y = [0, 0, 0];
        let _ = !1;
        e.isHorizontal() || (g[1] = g[0], g[0] = 0);
        let S = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        h < 0 ? (S = c.next, _ = !0) : h > 0 && (S = c.prev, _ = !0), g.forEach((H, B) => {
          g[B] = `calc(${H}px + (${n(S.translate[B])} * ${Math.abs(h * l)}))`;
        }), y.forEach((H, B) => {
          y[B] = S.rotate[B] * Math.abs(h * l);
        }), p[0].style.zIndex = -Math.abs(Math.round(v)) + a.length;
        const A = g.join(", "), O = `rotateX(${y[0]}deg) rotateY(${y[1]}deg) rotateZ(${y[2]}deg)`, P = E < 0 ? `scale(${1 + (1 - S.scale) * E * l})` : `scale(${1 - (1 - S.scale) * E * l})`, U = E < 0 ? 1 + (1 - S.opacity) * E * l : 1 - (1 - S.opacity) * E * l, z = `translate3d(${A}) ${O} ${P}`;
        if (_ && S.shadow || !_) {
          let H = p.children(".swiper-slide-shadow");
          if (H.length === 0 && S.shadow && (H = Xp(c, p)), H.length) {
            const B = c.shadowPerProgress ? h * (1 / c.limitProgress) : h;
            H[0].style.opacity = Math.min(Math.max(Math.abs(B), 0), 1);
          }
        }
        const k = Oy(c, p);
        k.transform(z).css({
          opacity: U
        }), S.origin && k.css("transform-origin", S.origin);
      }
    },
    setTransition: (a) => {
      const {
        transformEl: u
      } = e.params.creativeEffect;
      (u ? e.slides.find(u) : e.slides).transition(a).find(".swiper-slide-shadow").transition(a), C3({
        swiper: e,
        duration: a,
        transformEl: u,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Mor({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    cardsEffect: {
      slideShadows: !0,
      transformEl: null,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), Wh({
    effect: "cards",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: o,
        activeIndex: a
      } = e, u = e.params.cardsEffect, {
        startTranslate: s,
        isTouched: c
      } = e.touchEventsData, l = e.translate;
      for (let f = 0; f < o.length; f += 1) {
        const d = o.eq(f), p = d[0].progress, v = Math.min(Math.max(p, -4), 4);
        let h = d[0].swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && e.$wrapperEl.transform(`translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (h -= o[0].swiperSlideOffset);
        let E = e.params.cssMode ? -h - e.translate : -h, m = 0;
        const g = -100 * Math.abs(v);
        let y = 1, _ = -u.perSlideRotate * v, S = u.perSlideOffset - Math.abs(v) * 0.75;
        const A = e.virtual && e.params.virtual.enabled ? e.virtual.from + f : f, O = (A === a || A === a - 1) && v > 0 && v < 1 && (c || e.params.cssMode) && l < s, P = (A === a || A === a + 1) && v < 0 && v > -1 && (c || e.params.cssMode) && l > s;
        if (O || P) {
          const H = (1 - Math.abs((Math.abs(v) - 0.5) / 0.5)) ** 0.5;
          _ += -28 * v * H, y += -0.5 * H, S += 96 * H, m = `${-25 * H * Math.abs(v)}%`;
        }
        if (v < 0 ? E = `calc(${E}px + (${S * Math.abs(v)}%))` : v > 0 ? E = `calc(${E}px + (-${S * Math.abs(v)}%))` : E = `${E}px`, !e.isHorizontal()) {
          const H = m;
          m = E, E = H;
        }
        const U = v < 0 ? `${1 + (1 - y) * v}` : `${1 - (1 - y) * v}`, z = `
        translate3d(${E}, ${m}, ${g}px)
        rotateZ(${u.rotate ? _ : 0}deg)
        scale(${U})
      `;
        if (u.slideShadows) {
          let H = d.find(".swiper-slide-shadow");
          H.length === 0 && (H = Xp(u, d)), H.length && (H[0].style.opacity = Math.min(Math.max((Math.abs(v) - 0.5) / 0.5, 0), 1));
        }
        d[0].style.zIndex = -Math.abs(Math.round(p)) + o.length, Oy(u, d).transform(z);
      }
    },
    setTransition: (o) => {
      const {
        transformEl: a
      } = e.params.cardsEffect;
      (a ? e.slides.find(a) : e.slides).transition(o).find(".swiper-slide-shadow").transition(o), C3({
        swiper: e,
        duration: o,
        transformEl: a
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const For = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  A11y: Tor,
  Autoplay: Aor,
  Controller: gor,
  EffectCards: Mor,
  EffectCoverflow: Bor,
  EffectCreative: kor,
  EffectCube: Nor,
  EffectFade: xor,
  EffectFlip: Lor,
  FreeMode: bor,
  Grid: Cor,
  HashNavigation: _or,
  History: yor,
  Keyboard: cor,
  Lazy: mor,
  Manipulation: Dor,
  Mousewheel: lor,
  Navigation: dor,
  Pagination: por,
  Parallax: vor,
  Scrollbar: hor,
  Swiper: Za,
  Thumbs: Sor,
  Virtual: sor,
  Zoom: Eor,
  default: Za
}, Symbol.toStringTag, { value: "Module" })), Hor = /* @__PURE__ */ lh(For);
var DTe = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hv = fe && fe.__decorate || function(e, t, r, n) {
  var i = arguments.length, o = i < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, r, n);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, r, o) : a(t, r)) || o);
  return i > 3 && o && Object.defineProperty(t, r, o), o;
}, xTe = fe && fe.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(Wl, "__esModule", { value: !0 });
Wl.CarouselEvent = Wl.Carousel = Wl.CarouselPage = void 0;
var pa = Ct, No = Uu, Jo = Dr, $or = Kc, Uor = Uu, wc = lc, wl = Hor, i1 = Pr, Vor = fc, mB = (
  /** @class */
  function(e) {
    DTe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.remove(pa.Container.styleProperty), r.remove(pa.Container.bleedProperty), r.remove(pa.Container.isVisibleProperty);
    }, t.prototype.internalRender = function() {
      var r = document.createElement("div");
      r.className = this.hostConfig.makeCssClassName("swiper-slide"), this.rtl = this.isRtl();
      var n = e.prototype.internalRender.call(this);
      return i1.appendChild(r, n), r;
    }, t.prototype.getForbiddenActionTypes = function() {
      return [pa.ShowCardAction, pa.ToggleVisibilityAction];
    }, t.prototype.getForbiddenChildElements = function() {
      return this.forbiddenChildElements();
    }, t.prototype.forbiddenChildElements = function() {
      return xTe([
        pa.ToggleVisibilityAction.JsonTypeName,
        pa.ShowCardAction.JsonTypeName,
        "Media",
        "ActionSet",
        "Input.Text",
        "Input.Date",
        "Input.Time",
        "Input.Number",
        "Input.ChoiceSet",
        "Input.Toggle",
        "Carousel"
      ], e.prototype.forbiddenChildElements.call(this), !0);
    }, t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this.setShouldFallback(!1);
    }, t.prototype.shouldSerialize = function(r) {
      return !0;
    }, t.prototype.getJsonTypeName = function() {
      return "CarouselPage";
    }, Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hasVisibleSeparator", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(pa.Container)
);
Wl.CarouselPage = mB;
var NTe = (
  /** @class */
  function(e) {
    DTe(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.carouselLoop = !0, r.carouselOrientation = No.Orientation.Horizontal, r._pages = [], r._currentIndex = 0, r._previousEventType = No.CarouselInteractionEvent.Pagination, r;
    }
    return t.prototype.populateSchema = function(r) {
      e.prototype.populateSchema.call(this, r), r.remove(pa.Container.styleProperty), r.remove(pa.Container.bleedProperty), r.remove(pa.Container.isVisibleProperty);
    }, Object.defineProperty(t.prototype, "timer", {
      get: function() {
        var r = this.getValue(t.timerProperty);
        return r && r < this.hostConfig.carousel.minAutoplayDelay && (console.warn(wc.Strings.errors.tooLittleTimeDelay), r = this.hostConfig.carousel.minAutoplayDelay), r;
      },
      set: function(r) {
        r && r < this.hostConfig.carousel.minAutoplayDelay ? (console.warn(wc.Strings.errors.tooLittleTimeDelay), this.setValue(t.timerProperty, this.hostConfig.carousel.minAutoplayDelay)) : this.setValue(t.timerProperty, r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "initialPageIndex", {
      get: function() {
        return this.getValue(t.initialPageProperty);
      },
      set: function(r) {
        this.isValidParsedPageIndex(r) ? this.setValue(t.initialPageProperty, r) : (console.warn(wc.Strings.errors.invalidInitialPageIndex(r)), this.setValue(t.initialPageProperty, 0));
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.isValidParsedPageIndex = function(r) {
      return this._pages ? this.isValidPageIndex(r, this._pages.length) : !1;
    }, t.prototype.isValidRenderedPageIndex = function(r) {
      return this._renderedPages ? this.isValidPageIndex(r, this._renderedPages.length) : !1;
    }, t.prototype.isValidPageIndex = function(r, n) {
      return n > 0 && 0 <= r && r < n;
    }, Object.defineProperty(t.prototype, "previousEventType", {
      //#endregion
      get: function() {
        return this._previousEventType;
      },
      set: function(r) {
        this._previousEventType = r;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.forbiddenChildElements = function() {
      return xTe([
        pa.ToggleVisibilityAction.JsonTypeName,
        pa.ShowCardAction.JsonTypeName,
        "Media",
        "ActionSet",
        "Input.Text",
        "Input.Date",
        "Input.Time",
        "Input.Number",
        "Input.ChoiceSet",
        "Input.Toggle"
      ], e.prototype.forbiddenChildElements.call(this), !0);
    }, t.prototype.adjustRenderedElementSize = function(r) {
      e.prototype.adjustRenderedElementSize.call(this, r), this.height == "stretch" && this._containerForAdorners !== void 0 && (this._containerForAdorners.style.height = "100%"), this.carouselHeight && (this._carouselPageContainer.style.height = this.carouselHeight + "px");
    }, t.prototype.getJsonTypeName = function() {
      return "Carousel";
    }, t.prototype.getItemCount = function() {
      return this._pages.length;
    }, t.prototype.getItemAt = function(r) {
      return this._pages[r];
    }, t.prototype.addPage = function(r) {
      this._pages.push(r), r.setParent(this);
    }, t.prototype.removeItem = function(r) {
      if (r instanceof mB) {
        var n = this._pages.indexOf(r);
        if (n >= 0)
          return this._pages.splice(n, 1), r.setParent(void 0), this.updateLayout(), !0;
      }
      return !1;
    }, t.prototype.getFirstVisibleRenderedItem = function() {
      var r;
      if (this.renderedElement && ((r = this._renderedPages) === null || r === void 0 ? void 0 : r.length) > 0)
        return this._renderedPages[0];
    }, t.prototype.getLastVisibleRenderedItem = function() {
      var r;
      if (this.renderedElement && ((r = this._renderedPages) === null || r === void 0 ? void 0 : r.length) > 0)
        return this._renderedPages[this._renderedPages.length - 1];
    }, Object.defineProperty(t.prototype, "currentPageId", {
      get: function() {
        var r, n;
        if (!((n = (r = this._carousel) === null || r === void 0 ? void 0 : r.slides) === null || n === void 0) && n.length) {
          var i = this._carousel.slides[this._carousel.activeIndex];
          return i.id;
        }
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "currentPageIndex", {
      get: function() {
        var r;
        return (r = this._carousel) === null || r === void 0 ? void 0 : r.realIndex;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this._pages = [];
      var i = r.pages;
      if (Array.isArray(i))
        for (var o = 0, a = i; o < a.length; o++) {
          var u = a[o], s = this.createCarouselPageInstance(u, n);
          s && this._pages.push(s);
        }
      this.validateParsing(n);
    }, t.prototype.validateParsing = function(r) {
      this.isValidParsedPageIndex(this.initialPageIndex) || r.logParseEvent(this, No.ValidationEvent.InvalidPropertyValue, wc.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), n.serializeArray(r, "pages", this._pages);
    }, t.prototype.internalRender = function() {
      var r;
      if (this._renderedPages = [], !(this._pages.length <= 0)) {
        this.validateOrientationProperties();
        var n = document.createElement("div");
        n.className = this.hostConfig.makeCssClassName("ac-carousel-card-level-container");
        var i = document.createElement("div");
        i.className = this.hostConfig.makeCssClassName("swiper", "ac-carousel"), this._carouselPageContainer = i;
        var o = document.createElement("div");
        o.className = this.hostConfig.makeCssClassName("ac-carousel-container"), this._containerForAdorners = o, n.appendChild(o);
        var a = document.createElement("div");
        switch (a.className = this.hostConfig.makeCssClassName("swiper-wrapper", "ac-carousel-card-container"), a.style.display = "flex", this.getEffectiveVerticalContentAlignment()) {
          case No.VerticalAlignment.Top:
            a.style.alignItems = "flex-start";
            break;
          case No.VerticalAlignment.Bottom:
            a.style.alignItems = "flex-end";
            break;
          default:
            a.style.alignItems = "center";
            break;
        }
        Vor.GlobalSettings.useAdvancedCardBottomTruncation && (a.style.minHeight = "-webkit-min-content");
        var u = document.createElement("div");
        u.className = this.hostConfig.makeCssClassName("ac-carousel-navigation");
        var s = document.createElement("div");
        s.className = this.hostConfig.makeCssClassName("swiper-button-prev");
        var c = document.createElement("div");
        c.className = this.hostConfig.makeCssClassName("swiper-button-next"), this.carouselOrientation === No.Orientation.Horizontal ? this.updateCssForHorizontalCarousel(s, c) : this.updateCssForVerticalCarousel(u, s, c);
        var l = document.createElement("div");
        l.className = this.hostConfig.makeCssClassName("swiper-pagination", "ac-carousel-pagination"), u.appendChild(s), i1.addCancelSelectActionEventHandler(s), u.appendChild(l), i1.addCancelSelectActionEventHandler(l), u.appendChild(c), i1.addCancelSelectActionEventHandler(c), this.isDesignMode() && (s.style.zIndex = "20", c.style.zIndex = "20", l.style.zIndex = "20");
        var f = Math.min(this._pages.length, this.hostConfig.carousel.maxCarouselPages);
        if (this._pages.length > this.hostConfig.carousel.maxCarouselPages && console.warn(wc.Strings.errors.tooManyCarouselPages), this._pages.length > 0)
          for (var d = 0; d < f; d++) {
            var p = this._pages[d], v = this.isElementAllowed(p) ? p.render() : void 0;
            v == null || v.classList.add("ac-carousel-page"), (r = v == null ? void 0 : v.children[0]) === null || r === void 0 || r.classList.add("ac-carousel-page-container"), v && (i1.appendChild(a, v), this._renderedPages.push(p));
          }
        return i.appendChild(a), i.tabIndex = this.isDesignMode() ? -1 : 0, o.appendChild(i), o.appendChild(u), this.rtl = this.isRtl(), this.applyRTL(l), this.isDesignMode() || (this.isValidRenderedPageIndex(this.initialPageIndex) ? this._currentIndex = this.initialPageIndex : (console.warn(wc.Strings.errors.invalidInitialPageIndex(this.initialPageIndex)), this._currentIndex = 0)), this.initializeCarouselControl(i, c, s, l, this.rtl), this._renderedPages.length > 0 ? n : void 0;
      }
    }, t.prototype.applyRTL = function(r) {
      e.prototype.applyRTL.call(this, this._carouselPageContainer), this.rtl && r.classList.add(this.hostConfig.makeCssClassName("ac-carousel-pagination-rtl"));
    }, t.prototype.validateOrientationProperties = function() {
      this.carouselHeight || (this.carouselOrientation = No.Orientation.Horizontal);
    }, t.prototype.updateCssForHorizontalCarousel = function(r, n) {
      r.classList.add(this.hostConfig.makeCssClassName("ac-carousel-left")), n.classList.add(this.hostConfig.makeCssClassName("ac-carousel-right"));
    }, t.prototype.updateCssForVerticalCarousel = function(r, n, i) {
      this._containerForAdorners.classList.add(this.hostConfig.makeCssClassName("ac-carousel-container-vertical")), r.classList.add(this.hostConfig.makeCssClassName("ac-carousel-navigation-vertical")), n.classList.add(this.hostConfig.makeCssClassName("ac-carousel-up")), i.classList.add(this.hostConfig.makeCssClassName("ac-carousel-down"));
    }, t.prototype.initializeCarouselControl = function(r, n, i, o, a) {
      var u = this, s, c, l, f = a === void 0 || !a ? n : i, d = a === void 0 || !a ? i : n, p = No.Orientation.Horizontal === this.carouselOrientation ? d : i, v = No.Orientation.Horizontal === this.carouselOrientation ? f : n, h = {
        loop: !this.isDesignMode() && this.carouselLoop,
        modules: [wl.Navigation, wl.Pagination, wl.Scrollbar, wl.A11y, wl.History, wl.Keyboard],
        pagination: {
          el: o,
          clickable: !0
        },
        navigation: {
          prevEl: p,
          nextEl: v
        },
        a11y: {
          enabled: !0
        },
        keyboard: {
          enabled: !1,
          onlyInViewport: !0
        },
        direction: this.carouselOrientation === No.Orientation.Horizontal ? "horizontal" : "vertical",
        resizeObserver: !1,
        initialSlide: this._currentIndex
      };
      this.timer && !this.isDesignMode() && ((s = h.modules) === null || s === void 0 || s.push(wl.Autoplay), h.autoplay = { delay: this.timer, pauseOnMouseEnter: !0 });
      var E = new wl.Swiper(r, h);
      r.addEventListener("mouseenter", function(m) {
        var g;
        (g = E.autoplay) === null || g === void 0 || g.stop();
      }), r.addEventListener("mouseleave", function(m) {
        var g;
        (g = E.autoplay) === null || g === void 0 || g.start();
      }), E.on("navigationNext", function(m) {
        u.raiseCarouselEvent(No.CarouselInteractionEvent.NavigationNext);
      }), E.on("navigationPrev", function(m) {
        u.raiseCarouselEvent(No.CarouselInteractionEvent.NavigationPrevious);
      }), E.on("slideChangeTransitionEnd", function(m) {
        u.currentIndex = m.realIndex, u.raiseCarouselEvent(No.CarouselInteractionEvent.Pagination);
      }), E.on("autoplay", function() {
        u.raiseCarouselEvent(No.CarouselInteractionEvent.Autoplay);
      }), E.on("paginationRender", function(m, g) {
        m.pagination.bullets.forEach(function(y, _) {
          y.addEventListener("keypress", function(S) {
            S.key == "Enter" && (S.preventDefault(), m.slideTo(_ + 1));
          });
        });
      }), E.on("destroy", function() {
        u.destroyResizeObserver();
      }), i.title = (c = i.ariaLabel) !== null && c !== void 0 ? c : wc.Strings.defaults.carouselNavigationPreviousTooltip(), n.title = (l = n.ariaLabel) !== null && l !== void 0 ? l : wc.Strings.defaults.carouselNavigationNextTooltip(), this._carousel = E, this.createResizeObserver();
    }, t.prototype.createCarouselPageInstance = function(r, n) {
      return n.parseCardObject(this, r, this.forbiddenChildElements(), !this.isDesignMode(), function(i) {
        return !i || i === "CarouselPage" ? new mB() : void 0;
      }, function(i, o) {
        n.logParseEvent(void 0, Uor.ValidationEvent.ElementTypeNotAllowed, wc.Strings.errors.elementTypeNotAllowed(i));
      });
    }, t.prototype.slideTo = function(r) {
      var n;
      (n = this._carousel) === null || n === void 0 || n.slideTo(r);
    }, Object.defineProperty(t.prototype, "carouselPageContainer", {
      get: function() {
        return this._carouselPageContainer;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "currentIndex", {
      get: function() {
        return this._currentIndex;
      },
      set: function(r) {
        this._currentIndex = r;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.createCarouselEvent = function(r) {
      var n;
      return this.currentPageIndex != null && (n = this.getItemAt(this.currentPageIndex).id), new LTe(r, this.id, n, this.currentPageIndex);
    }, t.prototype.raiseCarouselEvent = function(r) {
      var n = this.parent ? this.parent.getRootElement() : void 0, i = n && n.onCarouselEvent ? n.onCarouselEvent : pa.AdaptiveCard.onCarouselEvent;
      i && r == No.CarouselInteractionEvent.Pagination && i(this.createCarouselEvent(this.previousEventType)), this.previousEventType = r;
    }, t.prototype.createResizeObserver = function() {
      var r = this, n;
      this.checkIfCarouselInValidStateForResizeEvent() && (this._observer = new ResizeObserver(function(i) {
        var o, a, u, s, c = (o = r._carousel) === null || o === void 0 ? void 0 : o.width, l = (a = r._carousel) === null || a === void 0 ? void 0 : a.height, f = c, d = l;
        i.forEach(function(p) {
          var v, h = p.contentBoxSize, E = p.contentRect, m = p.target;
          m && m !== ((v = r._carousel) === null || v === void 0 ? void 0 : v.el) || (f = E ? E.width : (h[0] || h).inlineSize, d = E ? E.height : (h[0] || h).blockSize);
        }), (f !== c || d !== l) && r.checkIfCarouselInValidStateForResizeEvent() && ((u = r._carousel) === null || u === void 0 || u.emit("beforeResize"), (s = r._carousel) === null || s === void 0 || s.emit("resize"));
      }), this._observer.observe((n = this._carousel) === null || n === void 0 ? void 0 : n.el));
    }, t.prototype.destroyResizeObserver = function() {
      var r;
      this._observer && this._observer.unobserve && (!((r = this._carousel) === null || r === void 0) && r.el) && (this._observer.unobserve(this._carousel.el), this._observer = null);
    }, t.prototype.checkIfCarouselInValidStateForResizeEvent = function() {
      return this._carousel && !this._carousel.destroyed;
    }, t.timerProperty = new Jo.NumProperty(Jo.Versions.v1_6, "timer", void 0), t.initialPageProperty = new Jo.NumProperty(Jo.Versions.v1_6, "initialPage", 0), t.loopProperty = new Jo.BoolProperty(Jo.Versions.v1_6, "loop", !0), t.orientationProperty = new Jo.EnumProperty(Jo.Versions.v1_6, "orientation", No.Orientation, No.Orientation.Horizontal), t.carouselHeightProperty = new Jo.PixelSizeProperty(Jo.Versions.v1_6, "heightInPixels"), Hv([
      (0, Jo.property)(t.timerProperty)
    ], t.prototype, "timer", null), Hv([
      (0, Jo.property)(t.initialPageProperty)
    ], t.prototype, "initialPageIndex", null), Hv([
      (0, Jo.property)(t.loopProperty)
    ], t.prototype, "carouselLoop", void 0), Hv([
      (0, Jo.property)(t.orientationProperty)
    ], t.prototype, "carouselOrientation", void 0), Hv([
      (0, Jo.property)(t.carouselHeightProperty)
    ], t.prototype, "carouselHeight", void 0), t;
  }(pa.Container)
);
Wl.Carousel = NTe;
var LTe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r, n, i) {
      this.type = t, this.carouselId = r, this.activeCarouselPageId = n, this.activeCarouselPageIndex = i;
    }
    return e;
  }()
);
Wl.CarouselEvent = LTe;
$or.GlobalRegistry.defaultElements.register("Carousel", NTe, Jo.Versions.v1_6);
var xu = {}, Ry = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ss = fe && fe.__decorate || function(e, t, r, n) {
  var i = arguments.length, o = i < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, r, n);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, r, o) : a(t, r)) || o);
  return i > 3 && o && Object.defineProperty(t, r, o), o;
};
Object.defineProperty(xu, "__esModule", { value: !0 });
xu.Table = xu.TableRow = xu.TableCell = xu.StylableContainer = xu.TableColumnDefinition = void 0;
var I3 = Ct, ri = Uu, jor = Kc, on = Dr, zl = fc, gB = lc, A7 = Pr, BTe = (
  /** @class */
  function(e) {
    Ry(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.width = new zl.SizeAndUnit(1, ri.SizeUnit.Weight), r;
    }
    return t.prototype.getSchemaKey = function() {
      return "ColumnDefinition";
    }, t.horizontalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "horizontalCellContentAlignment", ri.HorizontalAlignment), t.verticalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "verticalCellContentAlignment", ri.VerticalAlignment), t.widthProperty = new on.CustomProperty(on.Versions.v1_5, "width", function(r, n, i, o) {
      var a = n.defaultValue, u = i[n.name], s = !1;
      if (typeof u == "number" && !isNaN(u))
        a = new zl.SizeAndUnit(u, ri.SizeUnit.Weight);
      else if (typeof u == "string")
        try {
          a = zl.SizeAndUnit.parse(u);
        } catch {
          s = !0;
        }
      else
        s = !0;
      return s && o.logParseEvent(r, ri.ValidationEvent.InvalidPropertyValue, gB.Strings.errors.invalidColumnWidth(u)), a;
    }, function(r, n, i, o, a) {
      o.unit === ri.SizeUnit.Pixel ? a.serializeValue(i, "width", o.physicalSize + "px") : a.serializeNumber(i, "width", o.physicalSize);
    }, new zl.SizeAndUnit(1, ri.SizeUnit.Weight)), ss([
      (0, on.property)(t.horizontalCellContentAlignmentProperty)
    ], t.prototype, "horizontalCellContentAlignment", void 0), ss([
      (0, on.property)(t.verticalCellContentAlignmentProperty)
    ], t.prototype, "verticalCellContentAlignment", void 0), ss([
      (0, on.property)(t.widthProperty)
    ], t.prototype, "width", void 0), t;
  }(on.SerializableObject)
);
xu.TableColumnDefinition = BTe;
var S7 = (
  /** @class */
  function(e) {
    Ry(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._items = [], r;
    }
    return t.prototype.parseItem = function(r, n) {
      var i = this;
      return n.parseCardObject(
        this,
        r,
        [],
        // Forbidden types not supported for elements for now
        !this.isDesignMode(),
        function(o) {
          return i.createItemInstance(o);
        },
        function(o, a) {
          n.logParseEvent(void 0, ri.ValidationEvent.ElementTypeNotAllowed, gB.Strings.errors.elementTypeNotAllowed(o));
        }
      );
    }, t.prototype.internalAddItem = function(r) {
      if (!r.parent)
        this._items.push(r), r.setParent(this);
      else
        throw new Error(gB.Strings.errors.elementAlreadyParented());
    }, t.prototype.internalRemoveItem = function(r) {
      var n = this._items.indexOf(r);
      return n >= 0 ? (this._items.splice(n, 1), r.setParent(void 0), this.updateLayout(), !0) : !1;
    }, t.prototype.internalIndexOf = function(r) {
      return this._items.indexOf(r);
    }, t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this._items = [];
      var i = r[this.getCollectionPropertyName()];
      if (Array.isArray(i))
        for (var o = 0, a = i; o < a.length; o++) {
          var u = a[o], s = this.parseItem(u, n);
          s && this._items.push(s);
        }
    }, t.prototype.internalToJSON = function(r, n) {
      e.prototype.internalToJSON.call(this, r, n), n.serializeArray(r, this.getCollectionPropertyName(), this._items);
    }, t.prototype.removeItem = function(r) {
      return this.internalRemoveItem(r);
    }, t.prototype.getItemCount = function() {
      return this._items.length;
    }, t.prototype.getItemAt = function(r) {
      return this._items[r];
    }, t.prototype.getFirstVisibleRenderedItem = function() {
      return this.getItemCount() > 0 ? this.getItemAt(0) : void 0;
    }, t.prototype.getLastVisibleRenderedItem = function() {
      return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : void 0;
    }, t;
  }(I3.StylableCardElementContainer)
);
xu.StylableContainer = S7;
var F4 = (
  /** @class */
  function(e) {
    Ry(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._columnIndex = -1, r._cellType = "data", r;
    }
    return t.prototype.getHasBorder = function() {
      return this.parentRow.parentTable.showGridLines;
    }, t.prototype.applyBorder = function() {
      if (this.renderedElement && this.getHasBorder()) {
        var r = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
        if (r.borderColor) {
          var n = (0, A7.stringToCssColor)(r.borderColor);
          n && (this.renderedElement.style.borderRight = "1px solid " + n, this.renderedElement.style.borderBottom = "1px solid " + n);
        }
      }
    }, t.prototype.getDefaultPadding = function() {
      return this.getHasBackground() || this.getHasBorder() ? new zl.PaddingDefinition(ri.Spacing.Small, ri.Spacing.Small, ri.Spacing.Small, ri.Spacing.Small) : e.prototype.getDefaultPadding.call(this);
    }, t.prototype.internalRender = function() {
      var r = e.prototype.internalRender.call(this);
      return r && (r.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader"), r.style.minWidth = "0", this.cellType === "header" && r.setAttribute("scope", "col")), r;
    }, t.prototype.shouldSerialize = function(r) {
      return !0;
    }, t.prototype.getJsonTypeName = function() {
      return "TableCell";
    }, t.prototype.getEffectiveTextStyleDefinition = function() {
      return this.cellType === "header" ? this.hostConfig.textStyles.columnHeader : e.prototype.getEffectiveTextStyleDefinition.call(this);
    }, t.prototype.getEffectiveHorizontalAlignment = function() {
      if (this.horizontalAlignment !== void 0)
        return this.horizontalAlignment;
      if (this.parentRow.horizontalCellContentAlignment !== void 0)
        return this.parentRow.horizontalCellContentAlignment;
      if (this.columnIndex >= 0) {
        var r = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
        if (r !== void 0)
          return r;
      }
      return this.parentRow.parentTable.horizontalCellContentAlignment !== void 0 ? this.parentRow.parentTable.horizontalCellContentAlignment : e.prototype.getEffectiveHorizontalAlignment.call(this);
    }, t.prototype.getEffectiveVerticalContentAlignment = function() {
      if (this.verticalContentAlignment !== void 0)
        return this.verticalContentAlignment;
      if (this.parentRow.verticalCellContentAlignment !== void 0)
        return this.parentRow.verticalCellContentAlignment;
      if (this.columnIndex >= 0) {
        var r = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
        if (r !== void 0)
          return r;
      }
      return this.parentRow.parentTable.verticalCellContentAlignment !== void 0 ? this.parentRow.parentTable.verticalCellContentAlignment : e.prototype.getEffectiveVerticalContentAlignment.call(this);
    }, Object.defineProperty(t.prototype, "columnIndex", {
      get: function() {
        return this._columnIndex;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "cellType", {
      get: function() {
        return this._cellType;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "parentRow", {
      get: function() {
        return this.parent;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(I3.Container)
);
xu.TableCell = F4;
var TB = (
  /** @class */
  function(e) {
    Ry(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getDefaultPadding = function() {
      return new zl.PaddingDefinition(ri.Spacing.None, ri.Spacing.None, ri.Spacing.None, ri.Spacing.None);
    }, t.prototype.applyBackground = function() {
      if (this.renderedElement) {
        var r = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        if (r.backgroundColor) {
          var n = (0, A7.stringToCssColor)(r.backgroundColor);
          n && (this.renderedElement.style.backgroundColor = n);
        }
      }
    }, t.prototype.getCollectionPropertyName = function() {
      return "cells";
    }, t.prototype.createItemInstance = function(r) {
      return !r || r === "TableCell" ? new F4() : void 0;
    }, t.prototype.internalRender = function() {
      var r = this.getIsFirstRow(), n = this.hostConfig.table.cellSpacing, i = document.createElement("div");
      i.setAttribute("role", "row"), i.style.display = "flex", i.style.flexDirection = "row";
      for (var o = 0; o < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); o++) {
        var a = this.getItemAt(o);
        a._columnIndex = o, a._cellType = this.parentTable.firstRowAsHeaders && r ? "header" : "data";
        var u = a.render();
        if (u) {
          var s = this.parentTable.getColumnAt(o);
          s.computedWidth.unit === ri.SizeUnit.Pixel ? u.style.flex = "0 0 " + s.computedWidth.physicalSize + "px" : u.style.flex = "1 1 " + s.computedWidth.physicalSize + "%", o > 0 && !this.parentTable.showGridLines && n > 0 && (u.style.marginLeft = n + "px"), i.appendChild(u);
        }
      }
      return i.children.length > 0 ? i : void 0;
    }, t.prototype.shouldSerialize = function(r) {
      return !0;
    }, t.prototype.addCell = function(r) {
      this.internalAddItem(r);
    }, t.prototype.removeCellAt = function(r) {
      return r >= 0 && r < this.getItemCount() ? this.removeItem(this.getItemAt(r)) : !1;
    }, t.prototype.indexOf = function(r) {
      return r instanceof F4 ? this.internalIndexOf(r) : -1;
    }, t.prototype.ensureHasEnoughCells = function(r) {
      for (; this.getItemCount() < r; )
        this.addCell(new F4());
    }, t.prototype.getJsonTypeName = function() {
      return "TableRow";
    }, t.prototype.getIsFirstRow = function() {
      return this.parentTable.getItemAt(0) === this;
    }, Object.defineProperty(t.prototype, "parentTable", {
      get: function() {
        return this.parent;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isStandalone", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), t.styleProperty = new I3.ContainerStyleProperty(on.Versions.v1_5, "style"), t.horizontalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "horizontalCellContentAlignment", ri.HorizontalAlignment), t.verticalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "verticalCellContentAlignment", ri.VerticalAlignment), ss([
      (0, on.property)(t.horizontalCellContentAlignmentProperty)
    ], t.prototype, "horizontalCellContentAlignment", void 0), ss([
      (0, on.property)(t.verticalCellContentAlignmentProperty)
    ], t.prototype, "verticalCellContentAlignment", void 0), t;
  }(S7)
);
xu.TableRow = TB;
var kTe = (
  /** @class */
  function(e) {
    Ry(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._columns = [], r.firstRowAsHeaders = !0, r.showGridLines = !0, r;
    }
    return Object.defineProperty(t.prototype, "gridStyle", {
      get: function() {
        var r = this.getValue(t.gridStyleProperty);
        if (r && this.hostConfig.containerStyles.getStyleByName(r))
          return r;
      },
      set: function(r) {
        this.setValue(t.gridStyleProperty, r);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.ensureRowsHaveEnoughCells = function() {
      for (var r = 0; r < this.getItemCount(); r++)
        this.getItemAt(r).ensureHasEnoughCells(this.getColumnCount());
    }, t.prototype.removeCellsFromColumn = function(r) {
      for (var n = 0; n < this.getItemCount(); n++)
        this.getItemAt(n).removeCellAt(r);
    }, t.prototype.getCollectionPropertyName = function() {
      return "rows";
    }, t.prototype.createItemInstance = function(r) {
      return !r || r === "TableRow" ? new TB() : void 0;
    }, t.prototype.internalParse = function(r, n) {
      e.prototype.internalParse.call(this, r, n), this.ensureRowsHaveEnoughCells();
    }, t.prototype.internalRender = function() {
      if (this.getItemCount() > 0) {
        for (var r = 0, n = 0, i = this._columns; n < i.length; n++) {
          var o = i[n];
          o.width.unit === ri.SizeUnit.Weight && (r += o.width.physicalSize);
        }
        for (var a = 0, u = this._columns; a < u.length; a++) {
          var o = u[a];
          o.width.unit === ri.SizeUnit.Pixel ? o.computedWidth = new zl.SizeAndUnit(o.width.physicalSize, ri.SizeUnit.Pixel) : o.computedWidth = new zl.SizeAndUnit(100 / r * o.width.physicalSize, ri.SizeUnit.Weight);
        }
        var s = document.createElement("div");
        if (s.setAttribute("role", "table"), s.style.display = "flex", s.style.flexDirection = "column", this.showGridLines) {
          var c = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
          if (c.borderColor) {
            var l = (0, A7.stringToCssColor)(c.borderColor);
            l && (s.style.borderTop = "1px solid " + l, s.style.borderLeft = "1px solid " + l);
          }
        }
        for (var f = this.hostConfig.table.cellSpacing, d = 0; d < this.getItemCount(); d++) {
          var p = this.getItemAt(d).render();
          if (p) {
            if (d > 0 && !this.showGridLines && f > 0) {
              var v = document.createElement("div");
              v.setAttribute("aria-hidden", "true"), v.style.height = f + "px", s.appendChild(v);
            }
            s.appendChild(p);
          }
        }
        return s;
      }
    }, t.prototype.addColumn = function(r) {
      this._columns.push(r), this.ensureRowsHaveEnoughCells();
    }, t.prototype.removeColumn = function(r) {
      var n = this._columns.indexOf(r);
      n >= 0 && (this.removeCellsFromColumn(n), this._columns.splice(n, 1));
    }, t.prototype.getColumnCount = function() {
      return this._columns.length;
    }, t.prototype.getColumnAt = function(r) {
      return this._columns[r];
    }, t.prototype.addRow = function(r) {
      this.internalAddItem(r), r.ensureHasEnoughCells(this.getColumnCount());
    }, t.prototype.indexOf = function(r) {
      return r instanceof TB ? this.internalIndexOf(r) : -1;
    }, t.prototype.getJsonTypeName = function() {
      return "Table";
    }, t._columnsProperty = new on.SerializableObjectCollectionProperty(on.Versions.v1_5, "columns", BTe), t.firstRowAsHeadersProperty = new on.BoolProperty(on.Versions.v1_5, "firstRowAsHeaders", !0), t.showGridLinesProperty = new on.BoolProperty(on.Versions.v1_5, "showGridLines", !0), t.gridStyleProperty = new I3.ContainerStyleProperty(on.Versions.v1_5, "gridStyle"), t.horizontalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "horizontalCellContentAlignment", ri.HorizontalAlignment), t.verticalCellContentAlignmentProperty = new on.EnumProperty(on.Versions.v1_5, "verticalCellContentAlignment", ri.VerticalAlignment), ss([
      (0, on.property)(t._columnsProperty)
    ], t.prototype, "_columns", void 0), ss([
      (0, on.property)(t.firstRowAsHeadersProperty)
    ], t.prototype, "firstRowAsHeaders", void 0), ss([
      (0, on.property)(t.showGridLinesProperty)
    ], t.prototype, "showGridLines", void 0), ss([
      (0, on.property)(t.gridStyleProperty)
    ], t.prototype, "gridStyle", null), ss([
      (0, on.property)(t.horizontalCellContentAlignmentProperty)
    ], t.prototype, "horizontalCellContentAlignment", void 0), ss([
      (0, on.property)(t.verticalCellContentAlignmentProperty)
    ], t.prototype, "verticalCellContentAlignment", void 0), t;
  }(S7)
);
xu.Table = kTe;
jor.GlobalRegistry.defaultElements.register("Table", kTe, on.Versions.v1_5);
var O3 = {};
Object.defineProperty(O3, "__esModule", { value: !0 });
O3.ChannelAdapter = void 0;
var zor = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
);
O3.ChannelAdapter = zor;
var b7 = {};
(function(e) {
  var t = fe && fe.__extends || /* @__PURE__ */ function() {
    var u = function(s, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, f) {
        l.__proto__ = f;
      } || function(l, f) {
        for (var d in f) Object.prototype.hasOwnProperty.call(f, d) && (l[d] = f[d]);
      }, u(s, c);
    };
    return function(s, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      u(s, c);
      function l() {
        this.constructor = s;
      }
      s.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LoginRequestResponse = e.ErrorResponse = e.SuccessResponse = e.ActivityResponse = e.ActivityRequestError = e.ActivityRequestTrigger = void 0, function(u) {
    u.Automatic = "automatic", u.Manual = "manual";
  }(e.ActivityRequestTrigger || (e.ActivityRequestTrigger = {}));
  var r = (
    /** @class */
    /* @__PURE__ */ function() {
      function u(s, c) {
        this.code = s, this.message = c;
      }
      return u;
    }()
  );
  e.ActivityRequestError = r;
  var n = (
    /** @class */
    /* @__PURE__ */ function() {
      function u(s) {
        this.request = s;
      }
      return u;
    }()
  );
  e.ActivityResponse = n;
  var i = (
    /** @class */
    function(u) {
      t(s, u);
      function s(c, l) {
        var f = u.call(this, c) || this;
        return f.request = c, f.rawContent = l, f;
      }
      return s;
    }(n)
  );
  e.SuccessResponse = i;
  var o = (
    /** @class */
    function(u) {
      t(s, u);
      function s(c, l) {
        var f = u.call(this, c) || this;
        return f.request = c, f.error = l, f;
      }
      return s;
    }(n)
  );
  e.ErrorResponse = o;
  var a = (
    /** @class */
    function(u) {
      t(s, u);
      function s(c, l) {
        var f = u.call(this, c) || this;
        f.request = c, f._auth = l;
        for (var d = 0, p = f._auth.buttons; d < p.length; d++) {
          var v = p[d];
          if (v.type === "signin" && v.value !== void 0)
            try {
              new URL(v.value), f.signinButton = v;
              break;
            } catch {
            }
        }
        return f;
      }
      return Object.defineProperty(s.prototype, "tokenExchangeResource", {
        get: function() {
          return this._auth.tokenExchangeResource;
        },
        enumerable: !1,
        configurable: !0
      }), s;
    }(n)
  );
  e.LoginRequestResponse = a;
})(b7);
var R3 = {}, H4 = fe && fe.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, o1 = fe && fe.__generator || function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(c) {
    return function(l) {
      return s([c, l]);
    };
  }
  function s(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(R3, "__esModule", { value: !0 });
R3.AdaptiveApplet = void 0;
var Wn = Uu, ZD = Pr, oo = fc, Qu = b7, $v = lc, es = Ct, qor = Dr;
function Pi(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  if (oo.GlobalSettings.applets.logEnabled)
    if (oo.GlobalSettings.applets.onLogEvent)
      oo.GlobalSettings.applets.onLogEvent(e, t, r);
    else
      switch (e) {
        case Wn.LogLevel.Warning:
          console.warn(t, r);
          break;
        case Wn.LogLevel.Error:
          console.error(t, r);
          break;
        default:
          console.log(t, r);
          break;
      }
}
var Yor = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.action = t, this.trigger = r, this.consecutiveActions = n, this.attemptNumber = 0;
    }
    return e.prototype.retryAsync = function() {
      return H4(this, void 0, void 0, function() {
        return o1(this, function(t) {
          return this.onSend && this.onSend(this), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), Gor = (
  /** @class */
  function() {
    function e() {
      this._allowAutomaticCardUpdate = !1, this.renderedElement = document.createElement("div"), this.renderedElement.className = "aaf-cardHost", this.renderedElement.style.position = "relative", this.renderedElement.style.display = "flex", this.renderedElement.style.flexDirection = "column", this._cardHostElement = document.createElement("div"), this._refreshButtonHostElement = document.createElement("div"), this._refreshButtonHostElement.className = "aaf-refreshButtonHost", this._refreshButtonHostElement.style.display = "none", this.renderedElement.appendChild(this._cardHostElement), this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    return e.prototype.displayCard = function(t) {
      if (t.renderedElement)
        ZD.clearElementChildren(this._cardHostElement), this._refreshButtonHostElement.style.display = "none", this._cardHostElement.appendChild(t.renderedElement);
      else
        throw new Error("displayCard: undefined card.");
    }, e.prototype.showManualRefreshButton = function(t) {
      var r = this, n = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : !0;
      if (n) {
        this._refreshButtonHostElement.style.display = "none";
        var i = void 0;
        if (this.onRenderManualRefreshButton)
          i = this.onRenderManualRefreshButton(this);
        else {
          var o = $v.Strings.runtime.refreshThisCard();
          if (oo.GlobalSettings.applets.refresh.mode === Wn.RefreshMode.Automatic) {
            var a = $v.Strings.runtime.automaticRefreshPaused();
            a[a.length - 1] !== " " && (a += " "), o = $v.Strings.runtime.clckToRestartAutomaticRefresh();
          }
          var u = {
            type: "AdaptiveCard",
            version: "1.2",
            body: [
              {
                type: "RichTextBlock",
                horizontalAlignment: "right",
                inlines: [
                  {
                    type: "TextRun",
                    text: o,
                    selectAction: {
                      type: "Action.Submit",
                      id: "refreshCard"
                    }
                  }
                ]
              }
            ]
          }, s = new es.AdaptiveCard();
          s.parse(u, new es.SerializationContext(qor.Versions.v1_2)), s.onExecuteAction = function(c) {
            c.id === "refreshCard" && (ZD.clearElementChildren(r._refreshButtonHostElement), r.internalExecuteAction(t, Qu.ActivityRequestTrigger.Automatic, 0));
          }, i = s.render();
        }
        i && (ZD.clearElementChildren(this._refreshButtonHostElement), this._refreshButtonHostElement.appendChild(i), this._refreshButtonHostElement.style.removeProperty("display"));
      }
    }, e.prototype.createActivityRequest = function(t, r, n) {
      var i = this;
      if (this.card) {
        var o = new Yor(t, r, n);
        o.onSend = function(u) {
          u.attemptNumber++, i.internalSendActivityRequestAsync(o);
        };
        var a = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, o, t) : !1;
        return a ? void 0 : o;
      } else
        throw new Error("createActivityRequest: no card has been set.");
    }, e.prototype.createMagicCodeInputCard = function(t) {
      var r = {
        type: "AdaptiveCard",
        version: "1.0",
        body: [
          {
            type: "TextBlock",
            color: "attention",
            text: t === 1 ? void 0 : "That didn't work... let's try again.",
            wrap: !0,
            horizontalAlignment: "center"
          },
          {
            type: "TextBlock",
            text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
            wrap: !0,
            horizontalAlignment: "center"
          },
          {
            type: "Input.Text",
            id: "magicCode",
            placeholder: "Enter magic code"
          },
          {
            type: "ActionSet",
            horizontalAlignment: "center",
            actions: [
              {
                type: "Action.Submit",
                id: e._submitMagicCodeActionId,
                title: "Submit"
              },
              {
                type: "Action.Submit",
                id: e._cancelMagicCodeAuthActionId,
                title: "Cancel"
              }
            ]
          }
        ]
      }, n = new es.AdaptiveCard();
      return n.parse(r), n;
    }, e.prototype.cancelAutomaticRefresh = function() {
      this._allowAutomaticCardUpdate && Pi(Wn.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card."), this._allowAutomaticCardUpdate = !1;
    }, e.prototype.createSerializationContext = function() {
      return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new es.SerializationContext();
    }, e.prototype.internalSetCard = function(t, r) {
      var n = this;
      if (typeof t == "object" && t.type === "AdaptiveCard" && (this._cardPayload = t), this._cardPayload)
        try {
          var i = new es.AdaptiveCard();
          this.hostConfig && (i.hostConfig = this.hostConfig);
          var o = this.createSerializationContext();
          i.parse(this._cardPayload, o);
          var a = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : !0;
          if (a && (this._card = i, this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken && this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource), this._card.onExecuteAction = function(s) {
            n.cancelAutomaticRefresh(), n.internalExecuteAction(s, Qu.ActivityRequestTrigger.Manual, 0);
          }, this._card.onInputValueChanged = function(s) {
            var c, l, f;
            if (n.cancelAutomaticRefresh(), s instanceof es.ChoiceSetInput && s.isDynamicTypeahead()) {
              var d = s.getFilterForDynamicSearch();
              if (d) {
                var p = new es.DataQuery();
                p.filter = d, p.dataset = ((c = s.choicesData) === null || c === void 0 ? void 0 : c.dataset) || "", p.count = (l = s.choicesData) === null || l === void 0 ? void 0 : l.count, p.skip = (f = s.choicesData) === null || f === void 0 ? void 0 : f.skip, n._choiceSet = s, n.internalExecuteAction(
                  p,
                  Qu.ActivityRequestTrigger.Manual,
                  0
                  // consecutiveActions
                );
              }
            }
          }, this._card.render(), this._card.renderedElement && (this.displayCard(this._card), this.onCardChanged && this.onCardChanged(this), this._card.refresh)))
            if (oo.GlobalSettings.applets.refresh.mode === Wn.RefreshMode.Automatic && r < oo.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes)
              if (oo.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0)
                Pi(Wn.LogLevel.Info, "Triggering automatic card refresh number " + (r + 1)), this.internalExecuteAction(this._card.refresh.action, Qu.ActivityRequestTrigger.Automatic, r + 1);
              else {
                Pi(Wn.LogLevel.Info, "Scheduling automatic card refresh number " + (r + 1) + " in " + oo.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                var u = this._card.refresh.action;
                this._allowAutomaticCardUpdate = !0, window.setTimeout(function() {
                  n._allowAutomaticCardUpdate && n.internalExecuteAction(u, Qu.ActivityRequestTrigger.Automatic, r + 1);
                }, oo.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
              }
            else oo.GlobalSettings.applets.refresh.mode !== Wn.RefreshMode.Disabled && (r > 0 ? Pi(Wn.LogLevel.Warning, "Stopping automatic refreshes after " + r + " consecutive refreshes.") : Pi(Wn.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled."), (oo.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || oo.GlobalSettings.applets.refresh.mode === Wn.RefreshMode.Manual) && (Pi(Wn.LogLevel.Info, "Showing manual refresh button."), this.showManualRefreshButton(this._card.refresh.action)));
        } catch (s) {
          Pi(Wn.LogLevel.Error, "setCard: " + s);
        }
    }, e.prototype.internalExecuteAction = function(t, r, n) {
      if (t instanceof es.UniversalAction)
        if (this.channelAdapter) {
          var i = this.createActivityRequest(t, r, n);
          i && i.retryAsync();
        } else
          throw new Error("internalExecuteAction: No channel adapter set.");
      this.onAction && this.onAction(this, t);
    }, e.prototype.createProgressOverlay = function(t) {
      if (!this._progressOverlay)
        if (this.onCreateProgressOverlay)
          this._progressOverlay = this.onCreateProgressOverlay(this, t);
        else {
          this._progressOverlay = document.createElement("div"), this._progressOverlay.className = "aaf-progress-overlay";
          var r = document.createElement("div");
          r.className = "aaf-spinner", r.style.width = "28px", r.style.height = "28px", this._progressOverlay.appendChild(r);
        }
      return this._progressOverlay;
    }, e.prototype.removeProgressOverlay = function(t) {
      this.onRemoveProgressOverlay && this.onRemoveProgressOverlay(this, t), this._progressOverlay !== void 0 && (this.renderedElement.removeChild(this._progressOverlay), this._progressOverlay = void 0);
    }, e.prototype.activityRequestSucceeded = function(t, r) {
      this.onActivityRequestSucceeded && this.onActivityRequestSucceeded(this, t, r);
    }, e.prototype.activityRequestFailed = function(t) {
      return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, t) : oo.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    }, e.prototype.showAuthCodeInputDialog = function(t) {
      var r = this, n = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, t) : !0;
      if (n) {
        var i = this.createMagicCodeInputCard(t.attemptNumber);
        i.render(), i.onExecuteAction = function(o) {
          if (r.card && o instanceof es.SubmitAction)
            switch (o.id) {
              case e._submitMagicCodeActionId:
                var a = void 0;
                o.data && typeof o.data.magicCode == "string" && (a = o.data.magicCode), a ? (r.displayCard(r.card), t.authCode = a, t.retryAsync()) : alert("Please enter the magic code you received.");
                break;
              case e._cancelMagicCodeAuthActionId:
                Pi(Wn.LogLevel.Warning, "Authentication cancelled by user."), r.displayCard(r.card);
                break;
              default:
                Pi(Wn.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + o.id + ")"), alert($v.Strings.magicCodeInputCard.somethingWentWrong());
                break;
            }
        }, this.displayCard(i);
      }
    }, e.prototype.internalSendActivityRequestAsync = function(t) {
      return H4(this, void 0, void 0, function() {
        var r;
        return o1(this, function(n) {
          switch (n.label) {
            case 0:
              if (!this.channelAdapter)
                throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
              return r = t.action, r instanceof es.ExecuteAction ? [4, this.internalSendExecuteRequestAsync(t)] : [3, 2];
            case 1:
              return n.sent(), [3, 5];
            case 2:
              return r instanceof es.DataQuery ? [4, this.internalSendDataQueryRequestAsync(t)] : [3, 4];
            case 3:
              return n.sent(), [3, 5];
            case 4:
              throw new Error("internalSendActivityRequestAsync: Unhandled Action Type");
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.internalSendExecuteRequestAsync = function(t) {
      return H4(this, void 0, void 0, function() {
        var r, n, i, o, a;
        return o1(this, function(u) {
          switch (u.label) {
            case 0:
              if (!this.channelAdapter)
                throw new Error("internalSendExecuteRequestAsync: channelAdapter is not set.");
              r = this.createProgressOverlay(t), r !== void 0 && this.renderedElement.appendChild(r), n = !1, i = function() {
                var s, c, l, f, d, p, v;
                return o1(this, function(h) {
                  switch (h.label) {
                    case 0:
                      s = void 0, t.attemptNumber === 1 ? Pi(Wn.LogLevel.Info, "Sending activity request to channel (attempt " + t.attemptNumber + ")") : Pi(Wn.LogLevel.Info, "Re-sending activity request to channel (attempt " + t.attemptNumber + ")"), h.label = 1;
                    case 1:
                      return h.trys.push([1, 3, , 4]), [4, o.channelAdapter.sendRequestAsync(t)];
                    case 2:
                      return s = h.sent(), [3, 4];
                    case 3:
                      return c = h.sent(), Pi(Wn.LogLevel.Error, "Activity request failed: " + c), o.removeProgressOverlay(t), n = !0, [3, 4];
                    case 4:
                      if (!s) return [3, 10];
                      if (!(s instanceof Qu.SuccessResponse)) return [3, 5];
                      if (o.removeProgressOverlay(t), s.rawContent === void 0)
                        throw new Error("internalSendExecuteRequestAsync: Action.Execute result is undefined");
                      l = s.rawContent;
                      try {
                        l = JSON.parse(s.rawContent);
                      } catch {
                      }
                      if (typeof l == "string")
                        Pi(Wn.LogLevel.Info, "The activity request returned a string after " + t.attemptNumber + " attempt(s)."), o.activityRequestSucceeded(s, l);
                      else if (typeof l == "object" && l.type === "AdaptiveCard")
                        Pi(Wn.LogLevel.Info, "The activity request returned an Adaptive Card after " + t.attemptNumber + " attempt(s)."), o.internalSetCard(l, t.consecutiveActions), o.activityRequestSucceeded(s, o.card);
                      else
                        throw new Error("internalSendExecuteRequestAsync: Action.Execute result is of unsupported type (" + typeof s.rawContent + ")");
                      return n = !0, [3, 10];
                    case 5:
                      return s instanceof Qu.ErrorResponse ? (f = o.activityRequestFailed(s), f >= 0 && t.attemptNumber < oo.GlobalSettings.applets.maximumRetryAttempts ? (Pi(Wn.LogLevel.Warning, "Activity request failed: ".concat(s.error.message, ". Retrying in ").concat(f, "ms")), t.attemptNumber++, [4, new Promise(function(E, m) {
                        window.setTimeout(function() {
                          E();
                        }, f);
                      })]) : [3, 7]) : [3, 9];
                    case 6:
                      return h.sent(), [3, 8];
                    case 7:
                      Pi(Wn.LogLevel.Error, "Activity request failed: ".concat(s.error.message, ". Giving up after ").concat(t.attemptNumber, " attempt(s)")), o.removeProgressOverlay(t), n = !0, h.label = 8;
                    case 8:
                      return [3, 10];
                    case 9:
                      if (s instanceof Qu.LoginRequestResponse) {
                        if (Pi(Wn.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + t.attemptNumber + " attempt(s)."), t.attemptNumber <= oo.GlobalSettings.applets.maximumRetryAttempts) {
                          if (d = !0, s.tokenExchangeResource && o.onSSOTokenNeeded && (d = !o.onSSOTokenNeeded(o, t, s.tokenExchangeResource)), d) {
                            if (o.removeProgressOverlay(t), s.signinButton === void 0)
                              throw new Error("internalSendExecuteRequestAsync: the login request doesn't contain a valid signin URL.");
                            Pi(Wn.LogLevel.Info, "Login required at " + s.signinButton.value), o.onShowSigninPrompt ? o.onShowSigninPrompt(o, t, s.signinButton) : (o.showAuthCodeInputDialog(t), p = window.screenX + (window.outerWidth - oo.GlobalSettings.applets.authPromptWidth) / 2, v = window.screenY + (window.outerHeight - oo.GlobalSettings.applets.authPromptHeight) / 2, window.open(s.signinButton.value, s.signinButton.title ? s.signinButton.title : "Sign in", "width=".concat(oo.GlobalSettings.applets.authPromptWidth, ",height=").concat(oo.GlobalSettings.applets.authPromptHeight, ",left=").concat(p, ",top=").concat(v)));
                          }
                        } else
                          Pi(Wn.LogLevel.Error, "Authentication failed. Giving up after " + t.attemptNumber + " attempt(s)"), alert($v.Strings.magicCodeInputCard.authenticationFailed());
                        return [2, "break"];
                      } else
                        throw new Error("Unhandled response type: " + JSON.stringify(s));
                    case 10:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              }, o = this, u.label = 1;
            case 1:
              return n ? [3, 3] : [5, i()];
            case 2:
              return a = u.sent(), a === "break" ? [3, 3] : [3, 1];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.internalSendDataQueryRequestAsync = function(t) {
      return H4(this, void 0, void 0, function() {
        var r, n, i, o, a;
        return o1(this, function(u) {
          switch (u.label) {
            case 0:
              if (!this.channelAdapter)
                throw new Error("internalSendDataQueryRequestAsync: channel adapter not set");
              if (r = t.action.filter, !this._choiceSet) return [3, 5];
              this._choiceSet.showLoadingIndicator(), n = void 0, u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), [4, this.channelAdapter.sendRequestAsync(t)];
            case 2:
              return n = u.sent(), [3, 4];
            case 3:
              return i = u.sent(), this._choiceSet.showErrorIndicator(r, "Unable to load"), Pi(Wn.LogLevel.Error, "Activity request failed: " + i), [3, 4];
            case 4:
              if (n)
                if (n instanceof Qu.SuccessResponse)
                  if (o = n.rawContent, o) {
                    a = void 0;
                    try {
                      a = JSON.parse(o);
                    } catch {
                      throw this._choiceSet.showErrorIndicator(r, "Unable to load"), new Error("internalSendDataQueryRequestAsync: Cannot parse response object: " + o);
                    }
                    if (typeof a == "object")
                      this._choiceSet.renderChoices(r, a), this.activityRequestSucceeded(n, o);
                    else
                      throw this._choiceSet.showErrorIndicator(r, "Error loading results"), new Error("internalSendDataQueryRequestAsync: Data.Query result is of unsupported type (" + typeof o + ")");
                  } else
                    throw this._choiceSet.showErrorIndicator(r, "Unable to load"), new Error("internalSendDataQueryRequestAsync: Data.Query result is undefined");
                else if (n instanceof Qu.ErrorResponse)
                  this._choiceSet.showErrorIndicator(r, n.error.message || "Error loading results"), Pi(Wn.LogLevel.Error, "Activity request failed: ".concat(n.error.message, ".")), this.activityRequestFailed(n);
                else
                  throw this._choiceSet.showErrorIndicator(r, "Unable to load"), new Error("Unhandled response type: " + JSON.stringify(n));
              else
                this._choiceSet.removeLoadingIndicator();
              u.label = 5;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.refreshCard = function() {
      this._card && this._card.refresh && this.internalExecuteAction(this._card.refresh.action, Qu.ActivityRequestTrigger.Manual, 0);
    }, e.prototype.setCard = function(t) {
      this.internalSetCard(t, 0);
    }, Object.defineProperty(e.prototype, "card", {
      get: function() {
        return this._card;
      },
      enumerable: !1,
      configurable: !0
    }), e._submitMagicCodeActionId = "submitMagicCode", e._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth", e;
  }()
);
R3.AdaptiveApplet = Gor;
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(n, i, o, a) {
    a === void 0 && (a = o);
    var u = Object.getOwnPropertyDescriptor(i, o);
    (!u || ("get" in u ? !i.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, a, u);
  } : function(n, i, o, a) {
    a === void 0 && (a = o), n[a] = i[o];
  }), r = fe && fe.__exportStar || function(n, i) {
    for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(lc, e), r(Uu, e), r(fc, e), r(Pr, e), r(Dr, e), r(qh, e), r(ar, e), r(Kc, e), r(xf, e), r(Ct, e), r(Wl, e), r(xu, e), r(O3, e), r(b7, e), r(R3, e);
})(yo);
const Wor = /* @__PURE__ */ Mt(yo), Kor = /* @__PURE__ */ kIe({
  __proto__: null,
  default: Wor
}, [yo]);
var MTe = {}, Q1 = {}, C7 = {}, I7 = {}, O7 = {};
Object.defineProperty(O7, "__esModule", { value: !0 });
O7.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var R7 = {};
Object.defineProperty(R7, "__esModule", { value: !0 });
R7.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var yB = {};
(function(e) {
  var t;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
  var r = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(o) {
    var a = "";
    return o > 65535 && (o -= 65536, a += String.fromCharCode(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), a += String.fromCharCode(o), a;
  };
  function n(o) {
    var a;
    return o >= 55296 && o <= 57343 || o > 1114111 ? 65533 : (a = r.get(o)) !== null && a !== void 0 ? a : o;
  }
  e.replaceCodePoint = n;
  function i(o) {
    return (0, e.fromCodePoint)(n(o));
  }
  e.default = i;
})(yB);
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(k, H, B, x) {
    x === void 0 && (x = B);
    var D = Object.getOwnPropertyDescriptor(H, B);
    (!D || ("get" in D ? !H.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
      return H[B];
    } }), Object.defineProperty(k, x, D);
  } : function(k, H, B, x) {
    x === void 0 && (x = B), k[x] = H[B];
  }), r = fe && fe.__setModuleDefault || (Object.create ? function(k, H) {
    Object.defineProperty(k, "default", { enumerable: !0, value: H });
  } : function(k, H) {
    k.default = H;
  }), n = fe && fe.__importStar || function(k) {
    if (k && k.__esModule) return k;
    var H = {};
    if (k != null) for (var B in k) B !== "default" && Object.prototype.hasOwnProperty.call(k, B) && t(H, k, B);
    return r(H, k), H;
  }, i = fe && fe.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
  var o = i(O7);
  e.htmlDecodeTree = o.default;
  var a = i(R7);
  e.xmlDecodeTree = a.default;
  var u = n(yB);
  e.decodeCodePoint = u.default;
  var s = yB;
  Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
    return s.replaceCodePoint;
  } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
    return s.fromCodePoint;
  } });
  var c;
  (function(k) {
    k[k.NUM = 35] = "NUM", k[k.SEMI = 59] = "SEMI", k[k.EQUALS = 61] = "EQUALS", k[k.ZERO = 48] = "ZERO", k[k.NINE = 57] = "NINE", k[k.LOWER_A = 97] = "LOWER_A", k[k.LOWER_F = 102] = "LOWER_F", k[k.LOWER_X = 120] = "LOWER_X", k[k.LOWER_Z = 122] = "LOWER_Z", k[k.UPPER_A = 65] = "UPPER_A", k[k.UPPER_F = 70] = "UPPER_F", k[k.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var l = 32, f;
  (function(k) {
    k[k.VALUE_LENGTH = 49152] = "VALUE_LENGTH", k[k.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", k[k.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(f = e.BinTrieFlags || (e.BinTrieFlags = {}));
  function d(k) {
    return k >= c.ZERO && k <= c.NINE;
  }
  function p(k) {
    return k >= c.UPPER_A && k <= c.UPPER_F || k >= c.LOWER_A && k <= c.LOWER_F;
  }
  function v(k) {
    return k >= c.UPPER_A && k <= c.UPPER_Z || k >= c.LOWER_A && k <= c.LOWER_Z || d(k);
  }
  function h(k) {
    return k === c.EQUALS || v(k);
  }
  var E;
  (function(k) {
    k[k.EntityStart = 0] = "EntityStart", k[k.NumericStart = 1] = "NumericStart", k[k.NumericDecimal = 2] = "NumericDecimal", k[k.NumericHex = 3] = "NumericHex", k[k.NamedEntity = 4] = "NamedEntity";
  })(E || (E = {}));
  var m;
  (function(k) {
    k[k.Legacy = 0] = "Legacy", k[k.Strict = 1] = "Strict", k[k.Attribute = 2] = "Attribute";
  })(m = e.DecodingMode || (e.DecodingMode = {}));
  var g = (
    /** @class */
    function() {
      function k(H, B, x) {
        this.decodeTree = H, this.emitCodePoint = B, this.errors = x, this.state = E.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = m.Strict;
      }
      return k.prototype.startEntity = function(H) {
        this.decodeMode = H, this.state = E.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, k.prototype.write = function(H, B) {
        switch (this.state) {
          case E.EntityStart:
            return H.charCodeAt(B) === c.NUM ? (this.state = E.NumericStart, this.consumed += 1, this.stateNumericStart(H, B + 1)) : (this.state = E.NamedEntity, this.stateNamedEntity(H, B));
          case E.NumericStart:
            return this.stateNumericStart(H, B);
          case E.NumericDecimal:
            return this.stateNumericDecimal(H, B);
          case E.NumericHex:
            return this.stateNumericHex(H, B);
          case E.NamedEntity:
            return this.stateNamedEntity(H, B);
        }
      }, k.prototype.stateNumericStart = function(H, B) {
        return B >= H.length ? -1 : (H.charCodeAt(B) | l) === c.LOWER_X ? (this.state = E.NumericHex, this.consumed += 1, this.stateNumericHex(H, B + 1)) : (this.state = E.NumericDecimal, this.stateNumericDecimal(H, B));
      }, k.prototype.addToNumericResult = function(H, B, x, D) {
        if (B !== x) {
          var w = x - B;
          this.result = this.result * Math.pow(D, w) + parseInt(H.substr(B, w), D), this.consumed += w;
        }
      }, k.prototype.stateNumericHex = function(H, B) {
        for (var x = B; B < H.length; ) {
          var D = H.charCodeAt(B);
          if (d(D) || p(D))
            B += 1;
          else
            return this.addToNumericResult(H, x, B, 16), this.emitNumericEntity(D, 3);
        }
        return this.addToNumericResult(H, x, B, 16), -1;
      }, k.prototype.stateNumericDecimal = function(H, B) {
        for (var x = B; B < H.length; ) {
          var D = H.charCodeAt(B);
          if (d(D))
            B += 1;
          else
            return this.addToNumericResult(H, x, B, 10), this.emitNumericEntity(D, 2);
        }
        return this.addToNumericResult(H, x, B, 10), -1;
      }, k.prototype.emitNumericEntity = function(H, B) {
        var x;
        if (this.consumed <= B)
          return (x = this.errors) === null || x === void 0 || x.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (H === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === m.Strict)
          return 0;
        return this.emitCodePoint((0, u.replaceCodePoint)(this.result), this.consumed), this.errors && (H !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, k.prototype.stateNamedEntity = function(H, B) {
        for (var x = this.decodeTree, D = x[this.treeIndex], w = (D & f.VALUE_LENGTH) >> 14; B < H.length; B++, this.excess++) {
          var $ = H.charCodeAt(B);
          if (this.treeIndex = _(x, D, this.treeIndex + Math.max(1, w), $), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === m.Attribute && // We shouldn't have consumed any characters after the entity,
            (w === 0 || // And there should be no invalid characters.
            h($)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (D = x[this.treeIndex], w = (D & f.VALUE_LENGTH) >> 14, w !== 0) {
            if ($ === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, w, this.consumed + this.excess);
            this.decodeMode !== m.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, k.prototype.emitNotTerminatedNamedEntity = function() {
        var H, B = this, x = B.result, D = B.decodeTree, w = (D[x] & f.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(x, w, this.consumed), (H = this.errors) === null || H === void 0 || H.missingSemicolonAfterCharacterReference(), this.consumed;
      }, k.prototype.emitNamedEntityData = function(H, B, x) {
        var D = this.decodeTree;
        return this.emitCodePoint(B === 1 ? D[H] & ~f.VALUE_LENGTH : D[H + 1], x), B === 3 && this.emitCodePoint(D[H + 2], x), x;
      }, k.prototype.end = function() {
        var H;
        switch (this.state) {
          case E.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== m.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case E.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case E.NumericHex:
            return this.emitNumericEntity(0, 3);
          case E.NumericStart:
            return (H = this.errors) === null || H === void 0 || H.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case E.EntityStart:
            return 0;
        }
      }, k;
    }()
  );
  e.EntityDecoder = g;
  function y(k) {
    var H = "", B = new g(k, function(x) {
      return H += (0, u.fromCodePoint)(x);
    });
    return function(D, w) {
      for (var $ = 0, X = 0; (X = D.indexOf("&", X)) >= 0; ) {
        H += D.slice($, X), B.startEntity(w);
        var V = B.write(
          D,
          // Skip the "&"
          X + 1
        );
        if (V < 0) {
          $ = X + B.end();
          break;
        }
        $ = X + V, X = V === 0 ? $ + 1 : $;
      }
      var F = H + D.slice($);
      return H = "", F;
    };
  }
  function _(k, H, B, x) {
    var D = (H & f.BRANCH_LENGTH) >> 7, w = H & f.JUMP_TABLE;
    if (D === 0)
      return w !== 0 && x === w ? B : -1;
    if (w) {
      var $ = x - w;
      return $ < 0 || $ >= D ? -1 : k[B + $] - 1;
    }
    for (var X = B, V = X + D - 1; X <= V; ) {
      var F = X + V >>> 1, le = k[F];
      if (le < x)
        X = F + 1;
      else if (le > x)
        V = F - 1;
      else
        return k[F + D];
    }
    return -1;
  }
  e.determineBranch = _;
  var S = y(o.default), A = y(a.default);
  function O(k, H) {
    return H === void 0 && (H = m.Legacy), S(k, H);
  }
  e.decodeHTML = O;
  function P(k) {
    return S(k, m.Attribute);
  }
  e.decodeHTMLAttribute = P;
  function U(k) {
    return S(k, m.Strict);
  }
  e.decodeHTMLStrict = U;
  function z(k) {
    return A(k, m.Strict);
  }
  e.decodeXML = z;
})(I7);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
  var t = I7, r;
  (function(d) {
    d[d.Tab = 9] = "Tab", d[d.NewLine = 10] = "NewLine", d[d.FormFeed = 12] = "FormFeed", d[d.CarriageReturn = 13] = "CarriageReturn", d[d.Space = 32] = "Space", d[d.ExclamationMark = 33] = "ExclamationMark", d[d.Number = 35] = "Number", d[d.Amp = 38] = "Amp", d[d.SingleQuote = 39] = "SingleQuote", d[d.DoubleQuote = 34] = "DoubleQuote", d[d.Dash = 45] = "Dash", d[d.Slash = 47] = "Slash", d[d.Zero = 48] = "Zero", d[d.Nine = 57] = "Nine", d[d.Semi = 59] = "Semi", d[d.Lt = 60] = "Lt", d[d.Eq = 61] = "Eq", d[d.Gt = 62] = "Gt", d[d.Questionmark = 63] = "Questionmark", d[d.UpperA = 65] = "UpperA", d[d.LowerA = 97] = "LowerA", d[d.UpperF = 70] = "UpperF", d[d.LowerF = 102] = "LowerF", d[d.UpperZ = 90] = "UpperZ", d[d.LowerZ = 122] = "LowerZ", d[d.LowerX = 120] = "LowerX", d[d.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(r || (r = {}));
  var n;
  (function(d) {
    d[d.Text = 1] = "Text", d[d.BeforeTagName = 2] = "BeforeTagName", d[d.InTagName = 3] = "InTagName", d[d.InSelfClosingTag = 4] = "InSelfClosingTag", d[d.BeforeClosingTagName = 5] = "BeforeClosingTagName", d[d.InClosingTagName = 6] = "InClosingTagName", d[d.AfterClosingTagName = 7] = "AfterClosingTagName", d[d.BeforeAttributeName = 8] = "BeforeAttributeName", d[d.InAttributeName = 9] = "InAttributeName", d[d.AfterAttributeName = 10] = "AfterAttributeName", d[d.BeforeAttributeValue = 11] = "BeforeAttributeValue", d[d.InAttributeValueDq = 12] = "InAttributeValueDq", d[d.InAttributeValueSq = 13] = "InAttributeValueSq", d[d.InAttributeValueNq = 14] = "InAttributeValueNq", d[d.BeforeDeclaration = 15] = "BeforeDeclaration", d[d.InDeclaration = 16] = "InDeclaration", d[d.InProcessingInstruction = 17] = "InProcessingInstruction", d[d.BeforeComment = 18] = "BeforeComment", d[d.CDATASequence = 19] = "CDATASequence", d[d.InSpecialComment = 20] = "InSpecialComment", d[d.InCommentLike = 21] = "InCommentLike", d[d.BeforeSpecialS = 22] = "BeforeSpecialS", d[d.SpecialStartSequence = 23] = "SpecialStartSequence", d[d.InSpecialTag = 24] = "InSpecialTag", d[d.BeforeEntity = 25] = "BeforeEntity", d[d.BeforeNumericEntity = 26] = "BeforeNumericEntity", d[d.InNamedEntity = 27] = "InNamedEntity", d[d.InNumericEntity = 28] = "InNumericEntity", d[d.InHexEntity = 29] = "InHexEntity";
  })(n || (n = {}));
  function i(d) {
    return d === r.Space || d === r.NewLine || d === r.Tab || d === r.FormFeed || d === r.CarriageReturn;
  }
  function o(d) {
    return d === r.Slash || d === r.Gt || i(d);
  }
  function a(d) {
    return d >= r.Zero && d <= r.Nine;
  }
  function u(d) {
    return d >= r.LowerA && d <= r.LowerZ || d >= r.UpperA && d <= r.UpperZ;
  }
  function s(d) {
    return d >= r.UpperA && d <= r.UpperF || d >= r.LowerA && d <= r.LowerF;
  }
  var c;
  (function(d) {
    d[d.NoValue = 0] = "NoValue", d[d.Unquoted = 1] = "Unquoted", d[d.Single = 2] = "Single", d[d.Double = 3] = "Double";
  })(c = e.QuoteType || (e.QuoteType = {}));
  var l = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, f = (
    /** @class */
    function() {
      function d(p, v) {
        var h = p.xmlMode, E = h === void 0 ? !1 : h, m = p.decodeEntities, g = m === void 0 ? !0 : m;
        this.cbs = v, this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = E, this.decodeEntities = g, this.entityTrie = E ? t.xmlDecodeTree : t.htmlDecodeTree;
      }
      return d.prototype.reset = function() {
        this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, d.prototype.write = function(p) {
        this.offset += this.buffer.length, this.buffer = p, this.parse();
      }, d.prototype.end = function() {
        this.running && this.finish();
      }, d.prototype.pause = function() {
        this.running = !1;
      }, d.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, d.prototype.getIndex = function() {
        return this.index;
      }, d.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, d.prototype.stateText = function(p) {
        p === r.Lt || !this.decodeEntities && this.fastForwardTo(r.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = n.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && p === r.Amp && (this.state = n.BeforeEntity);
      }, d.prototype.stateSpecialStartSequence = function(p) {
        var v = this.sequenceIndex === this.currentSequence.length, h = v ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          o(p)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (p | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!h)
          this.isSpecial = !1;
        else if (!v) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = n.InTagName, this.stateInTagName(p);
      }, d.prototype.stateInSpecialTag = function(p) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (p === r.Gt || i(p)) {
            var v = this.index - this.currentSequence.length;
            if (this.sectionStart < v) {
              var h = this.index;
              this.index = v, this.cbs.ontext(this.sectionStart, v), this.index = h;
            }
            this.isSpecial = !1, this.sectionStart = v + 2, this.stateInClosingTagName(p);
            return;
          }
          this.sequenceIndex = 0;
        }
        (p | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === l.TitleEnd ? this.decodeEntities && p === r.Amp && (this.state = n.BeforeEntity) : this.fastForwardTo(r.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(p === r.Lt);
      }, d.prototype.stateCDATASequence = function(p) {
        p === l.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === l.Cdata.length && (this.state = n.InCommentLike, this.currentSequence = l.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = n.InDeclaration, this.stateInDeclaration(p));
      }, d.prototype.fastForwardTo = function(p) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === p)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, d.prototype.stateInCommentLike = function(p) {
        p === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = n.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : p !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, d.prototype.isTagStartChar = function(p) {
        return this.xmlMode ? !o(p) : u(p);
      }, d.prototype.startSpecial = function(p, v) {
        this.isSpecial = !0, this.currentSequence = p, this.sequenceIndex = v, this.state = n.SpecialStartSequence;
      }, d.prototype.stateBeforeTagName = function(p) {
        if (p === r.ExclamationMark)
          this.state = n.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (p === r.Questionmark)
          this.state = n.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(p)) {
          var v = p | 32;
          this.sectionStart = this.index, !this.xmlMode && v === l.TitleEnd[2] ? this.startSpecial(l.TitleEnd, 3) : this.state = !this.xmlMode && v === l.ScriptEnd[2] ? n.BeforeSpecialS : n.InTagName;
        } else p === r.Slash ? this.state = n.BeforeClosingTagName : (this.state = n.Text, this.stateText(p));
      }, d.prototype.stateInTagName = function(p) {
        o(p) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(p));
      }, d.prototype.stateBeforeClosingTagName = function(p) {
        i(p) || (p === r.Gt ? this.state = n.Text : (this.state = this.isTagStartChar(p) ? n.InClosingTagName : n.InSpecialComment, this.sectionStart = this.index));
      }, d.prototype.stateInClosingTagName = function(p) {
        (p === r.Gt || i(p)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.AfterClosingTagName, this.stateAfterClosingTagName(p));
      }, d.prototype.stateAfterClosingTagName = function(p) {
        (p === r.Gt || this.fastForwardTo(r.Gt)) && (this.state = n.Text, this.baseState = n.Text, this.sectionStart = this.index + 1);
      }, d.prototype.stateBeforeAttributeName = function(p) {
        p === r.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = n.InSpecialTag, this.sequenceIndex = 0) : this.state = n.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : p === r.Slash ? this.state = n.InSelfClosingTag : i(p) || (this.state = n.InAttributeName, this.sectionStart = this.index);
      }, d.prototype.stateInSelfClosingTag = function(p) {
        p === r.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = n.Text, this.baseState = n.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(p) || (this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(p));
      }, d.prototype.stateInAttributeName = function(p) {
        (p === r.Eq || o(p)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.AfterAttributeName, this.stateAfterAttributeName(p));
      }, d.prototype.stateAfterAttributeName = function(p) {
        p === r.Eq ? this.state = n.BeforeAttributeValue : p === r.Slash || p === r.Gt ? (this.cbs.onattribend(c.NoValue, this.index), this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(p)) : i(p) || (this.cbs.onattribend(c.NoValue, this.index), this.state = n.InAttributeName, this.sectionStart = this.index);
      }, d.prototype.stateBeforeAttributeValue = function(p) {
        p === r.DoubleQuote ? (this.state = n.InAttributeValueDq, this.sectionStart = this.index + 1) : p === r.SingleQuote ? (this.state = n.InAttributeValueSq, this.sectionStart = this.index + 1) : i(p) || (this.sectionStart = this.index, this.state = n.InAttributeValueNq, this.stateInAttributeValueNoQuotes(p));
      }, d.prototype.handleInAttributeValue = function(p, v) {
        p === v || !this.decodeEntities && this.fastForwardTo(v) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(v === r.DoubleQuote ? c.Double : c.Single, this.index), this.state = n.BeforeAttributeName) : this.decodeEntities && p === r.Amp && (this.baseState = this.state, this.state = n.BeforeEntity);
      }, d.prototype.stateInAttributeValueDoubleQuotes = function(p) {
        this.handleInAttributeValue(p, r.DoubleQuote);
      }, d.prototype.stateInAttributeValueSingleQuotes = function(p) {
        this.handleInAttributeValue(p, r.SingleQuote);
      }, d.prototype.stateInAttributeValueNoQuotes = function(p) {
        i(p) || p === r.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(c.Unquoted, this.index), this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(p)) : this.decodeEntities && p === r.Amp && (this.baseState = this.state, this.state = n.BeforeEntity);
      }, d.prototype.stateBeforeDeclaration = function(p) {
        p === r.OpeningSquareBracket ? (this.state = n.CDATASequence, this.sequenceIndex = 0) : this.state = p === r.Dash ? n.BeforeComment : n.InDeclaration;
      }, d.prototype.stateInDeclaration = function(p) {
        (p === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
      }, d.prototype.stateInProcessingInstruction = function(p) {
        (p === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
      }, d.prototype.stateBeforeComment = function(p) {
        p === r.Dash ? (this.state = n.InCommentLike, this.currentSequence = l.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = n.InDeclaration;
      }, d.prototype.stateInSpecialComment = function(p) {
        (p === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = n.Text, this.sectionStart = this.index + 1);
      }, d.prototype.stateBeforeSpecialS = function(p) {
        var v = p | 32;
        v === l.ScriptEnd[3] ? this.startSpecial(l.ScriptEnd, 4) : v === l.StyleEnd[3] ? this.startSpecial(l.StyleEnd, 4) : (this.state = n.InTagName, this.stateInTagName(p));
      }, d.prototype.stateBeforeEntity = function(p) {
        this.entityExcess = 1, this.entityResult = 0, p === r.Number ? this.state = n.BeforeNumericEntity : p === r.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = n.InNamedEntity, this.stateInNamedEntity(p));
      }, d.prototype.stateInNamedEntity = function(p) {
        if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, p), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var v = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
        if (v) {
          var h = (v >> 14) - 1;
          if (!this.allowLegacyEntity() && p !== r.Semi)
            this.trieIndex += h;
          else {
            var E = this.index - this.entityExcess + 1;
            E > this.sectionStart && this.emitPartial(this.sectionStart, E), this.entityResult = this.trieIndex, this.trieIndex += h, this.entityExcess = 0, this.sectionStart = this.index + 1, h === 0 && this.emitNamedEntity();
          }
        }
      }, d.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var p = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (p) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, d.prototype.stateBeforeNumericEntity = function(p) {
        (p | 32) === r.LowerX ? (this.entityExcess++, this.state = n.InHexEntity) : (this.state = n.InNumericEntity, this.stateInNumericEntity(p));
      }, d.prototype.emitNumericEntity = function(p) {
        var v = this.index - this.entityExcess - 1, h = v + 2 + +(this.state === n.InHexEntity);
        h !== this.index && (v > this.sectionStart && this.emitPartial(this.sectionStart, v), this.sectionStart = this.index + Number(p), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, d.prototype.stateInNumericEntity = function(p) {
        p === r.Semi ? this.emitNumericEntity(!0) : a(p) ? (this.entityResult = this.entityResult * 10 + (p - r.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, d.prototype.stateInHexEntity = function(p) {
        p === r.Semi ? this.emitNumericEntity(!0) : a(p) ? (this.entityResult = this.entityResult * 16 + (p - r.Zero), this.entityExcess++) : s(p) ? (this.entityResult = this.entityResult * 16 + ((p | 32) - r.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, d.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === n.Text || this.baseState === n.InSpecialTag);
      }, d.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === n.Text || this.state === n.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === n.InAttributeValueDq || this.state === n.InAttributeValueSq || this.state === n.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, d.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, d.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var p = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case n.Text: {
              this.stateText(p);
              break;
            }
            case n.SpecialStartSequence: {
              this.stateSpecialStartSequence(p);
              break;
            }
            case n.InSpecialTag: {
              this.stateInSpecialTag(p);
              break;
            }
            case n.CDATASequence: {
              this.stateCDATASequence(p);
              break;
            }
            case n.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(p);
              break;
            }
            case n.InAttributeName: {
              this.stateInAttributeName(p);
              break;
            }
            case n.InCommentLike: {
              this.stateInCommentLike(p);
              break;
            }
            case n.InSpecialComment: {
              this.stateInSpecialComment(p);
              break;
            }
            case n.BeforeAttributeName: {
              this.stateBeforeAttributeName(p);
              break;
            }
            case n.InTagName: {
              this.stateInTagName(p);
              break;
            }
            case n.InClosingTagName: {
              this.stateInClosingTagName(p);
              break;
            }
            case n.BeforeTagName: {
              this.stateBeforeTagName(p);
              break;
            }
            case n.AfterAttributeName: {
              this.stateAfterAttributeName(p);
              break;
            }
            case n.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(p);
              break;
            }
            case n.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(p);
              break;
            }
            case n.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(p);
              break;
            }
            case n.AfterClosingTagName: {
              this.stateAfterClosingTagName(p);
              break;
            }
            case n.BeforeSpecialS: {
              this.stateBeforeSpecialS(p);
              break;
            }
            case n.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(p);
              break;
            }
            case n.InSelfClosingTag: {
              this.stateInSelfClosingTag(p);
              break;
            }
            case n.InDeclaration: {
              this.stateInDeclaration(p);
              break;
            }
            case n.BeforeDeclaration: {
              this.stateBeforeDeclaration(p);
              break;
            }
            case n.BeforeComment: {
              this.stateBeforeComment(p);
              break;
            }
            case n.InProcessingInstruction: {
              this.stateInProcessingInstruction(p);
              break;
            }
            case n.InNamedEntity: {
              this.stateInNamedEntity(p);
              break;
            }
            case n.BeforeEntity: {
              this.stateBeforeEntity(p);
              break;
            }
            case n.InHexEntity: {
              this.stateInHexEntity(p);
              break;
            }
            case n.InNumericEntity: {
              this.stateInNumericEntity(p);
              break;
            }
            default:
              this.stateBeforeNumericEntity(p);
          }
          this.index++;
        }
        this.cleanup();
      }, d.prototype.finish = function() {
        this.state === n.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, d.prototype.handleTrailingData = function() {
        var p = this.buffer.length + this.offset;
        this.state === n.InCommentLike ? this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, p, 0) : this.cbs.oncomment(this.sectionStart, p, 0) : this.state === n.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === n.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === n.InTagName || this.state === n.BeforeAttributeName || this.state === n.BeforeAttributeValue || this.state === n.AfterAttributeName || this.state === n.InAttributeName || this.state === n.InAttributeValueSq || this.state === n.InAttributeValueDq || this.state === n.InAttributeValueNq || this.state === n.InClosingTagName || this.cbs.ontext(this.sectionStart, p);
      }, d.prototype.emitPartial = function(p, v) {
        this.baseState !== n.Text && this.baseState !== n.InSpecialTag ? this.cbs.onattribdata(p, v) : this.cbs.ontext(p, v);
      }, d.prototype.emitCodePoint = function(p) {
        this.baseState !== n.Text && this.baseState !== n.InSpecialTag ? this.cbs.onattribentity(p) : this.cbs.ontextentity(p);
      }, d;
    }()
  );
  e.default = f;
})(C7);
var Xor = fe && fe.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Jor = fe && fe.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Zor = fe && fe.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var r in e) r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Xor(t, e, r);
  return Jor(t, e), t;
};
Object.defineProperty(Q1, "__esModule", { value: !0 });
Q1.Parser = void 0;
var EA = Zor(C7), Cee = I7, qd = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Un = /* @__PURE__ */ new Set(["p"]), Iee = /* @__PURE__ */ new Set(["thead", "tbody"]), Oee = /* @__PURE__ */ new Set(["dd", "dt"]), Ree = /* @__PURE__ */ new Set(["rt", "rp"]), Qor = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Un],
  ["h1", Un],
  ["h2", Un],
  ["h3", Un],
  ["h4", Un],
  ["h5", Un],
  ["h6", Un],
  ["select", qd],
  ["input", qd],
  ["output", qd],
  ["button", qd],
  ["datalist", qd],
  ["textarea", qd],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Oee],
  ["dt", Oee],
  ["address", Un],
  ["article", Un],
  ["aside", Un],
  ["blockquote", Un],
  ["details", Un],
  ["div", Un],
  ["dl", Un],
  ["fieldset", Un],
  ["figcaption", Un],
  ["figure", Un],
  ["footer", Un],
  ["form", Un],
  ["header", Un],
  ["hr", Un],
  ["main", Un],
  ["nav", Un],
  ["ol", Un],
  ["pre", Un],
  ["section", Un],
  ["table", Un],
  ["ul", Un],
  ["rt", Ree],
  ["rp", Ree],
  ["tbody", Iee],
  ["tfoot", Iee]
]), ear = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), wee = /* @__PURE__ */ new Set(["math", "svg"]), Pee = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), tar = /\s|\//, rar = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = {});
      var n, i, o, a, u;
      this.options = r, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = t ?? {}, this.lowerCaseTagNames = (n = r.lowerCaseTags) !== null && n !== void 0 ? n : !r.xmlMode, this.lowerCaseAttributeNames = (i = r.lowerCaseAttributeNames) !== null && i !== void 0 ? i : !r.xmlMode, this.tokenizer = new ((o = r.Tokenizer) !== null && o !== void 0 ? o : EA.default)(this.options, this), (u = (a = this.cbs).onparserinit) === null || u === void 0 || u.call(a, this);
    }
    return e.prototype.ontext = function(t, r) {
      var n, i, o = this.getSlice(t, r);
      this.endIndex = r - 1, (i = (n = this.cbs).ontext) === null || i === void 0 || i.call(n, o), this.startIndex = r;
    }, e.prototype.ontextentity = function(t) {
      var r, n, i = this.tokenizer.getSectionStart();
      this.endIndex = i - 1, (n = (r = this.cbs).ontext) === null || n === void 0 || n.call(r, (0, Cee.fromCodePoint)(t)), this.startIndex = i;
    }, e.prototype.isVoidElement = function(t) {
      return !this.options.xmlMode && ear.has(t);
    }, e.prototype.onopentagname = function(t, r) {
      this.endIndex = r;
      var n = this.getSlice(t, r);
      this.lowerCaseTagNames && (n = n.toLowerCase()), this.emitOpenTag(n);
    }, e.prototype.emitOpenTag = function(t) {
      var r, n, i, o;
      this.openTagStart = this.startIndex, this.tagname = t;
      var a = !this.options.xmlMode && Qor.get(t);
      if (a)
        for (; this.stack.length > 0 && a.has(this.stack[this.stack.length - 1]); ) {
          var u = this.stack.pop();
          (n = (r = this.cbs).onclosetag) === null || n === void 0 || n.call(r, u, !0);
        }
      this.isVoidElement(t) || (this.stack.push(t), wee.has(t) ? this.foreignContext.push(!0) : Pee.has(t) && this.foreignContext.push(!1)), (o = (i = this.cbs).onopentagname) === null || o === void 0 || o.call(i, t), this.cbs.onopentag && (this.attribs = {});
    }, e.prototype.endOpenTag = function(t) {
      var r, n;
      this.startIndex = this.openTagStart, this.attribs && ((n = (r = this.cbs).onopentag) === null || n === void 0 || n.call(r, this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, e.prototype.onopentagend = function(t) {
      this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
    }, e.prototype.onclosetag = function(t, r) {
      var n, i, o, a, u, s;
      this.endIndex = r;
      var c = this.getSlice(t, r);
      if (this.lowerCaseTagNames && (c = c.toLowerCase()), (wee.has(c) || Pee.has(c)) && this.foreignContext.pop(), this.isVoidElement(c))
        !this.options.xmlMode && c === "br" && ((i = (n = this.cbs).onopentagname) === null || i === void 0 || i.call(n, "br"), (a = (o = this.cbs).onopentag) === null || a === void 0 || a.call(o, "br", {}, !0), (s = (u = this.cbs).onclosetag) === null || s === void 0 || s.call(u, "br", !1));
      else {
        var l = this.stack.lastIndexOf(c);
        if (l !== -1)
          if (this.cbs.onclosetag)
            for (var f = this.stack.length - l; f--; )
              this.cbs.onclosetag(this.stack.pop(), f !== 0);
          else
            this.stack.length = l;
        else !this.options.xmlMode && c === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = r + 1;
    }, e.prototype.onselfclosingtag = function(t) {
      this.endIndex = t, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
    }, e.prototype.closeCurrentTag = function(t) {
      var r, n, i = this.tagname;
      this.endOpenTag(t), this.stack[this.stack.length - 1] === i && ((n = (r = this.cbs).onclosetag) === null || n === void 0 || n.call(r, i, !t), this.stack.pop());
    }, e.prototype.onattribname = function(t, r) {
      this.startIndex = t;
      var n = this.getSlice(t, r);
      this.attribname = this.lowerCaseAttributeNames ? n.toLowerCase() : n;
    }, e.prototype.onattribdata = function(t, r) {
      this.attribvalue += this.getSlice(t, r);
    }, e.prototype.onattribentity = function(t) {
      this.attribvalue += (0, Cee.fromCodePoint)(t);
    }, e.prototype.onattribend = function(t, r) {
      var n, i;
      this.endIndex = r, (i = (n = this.cbs).onattribute) === null || i === void 0 || i.call(n, this.attribname, this.attribvalue, t === EA.QuoteType.Double ? '"' : t === EA.QuoteType.Single ? "'" : t === EA.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, e.prototype.getInstructionName = function(t) {
      var r = t.search(tar), n = r < 0 ? t : t.substr(0, r);
      return this.lowerCaseTagNames && (n = n.toLowerCase()), n;
    }, e.prototype.ondeclaration = function(t, r) {
      this.endIndex = r;
      var n = this.getSlice(t, r);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(n);
        this.cbs.onprocessinginstruction("!".concat(i), "!".concat(n));
      }
      this.startIndex = r + 1;
    }, e.prototype.onprocessinginstruction = function(t, r) {
      this.endIndex = r;
      var n = this.getSlice(t, r);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(n);
        this.cbs.onprocessinginstruction("?".concat(i), "?".concat(n));
      }
      this.startIndex = r + 1;
    }, e.prototype.oncomment = function(t, r, n) {
      var i, o, a, u;
      this.endIndex = r, (o = (i = this.cbs).oncomment) === null || o === void 0 || o.call(i, this.getSlice(t, r - n)), (u = (a = this.cbs).oncommentend) === null || u === void 0 || u.call(a), this.startIndex = r + 1;
    }, e.prototype.oncdata = function(t, r, n) {
      var i, o, a, u, s, c, l, f, d, p;
      this.endIndex = r;
      var v = this.getSlice(t, r - n);
      this.options.xmlMode || this.options.recognizeCDATA ? ((o = (i = this.cbs).oncdatastart) === null || o === void 0 || o.call(i), (u = (a = this.cbs).ontext) === null || u === void 0 || u.call(a, v), (c = (s = this.cbs).oncdataend) === null || c === void 0 || c.call(s)) : ((f = (l = this.cbs).oncomment) === null || f === void 0 || f.call(l, "[CDATA[".concat(v, "]]")), (p = (d = this.cbs).oncommentend) === null || p === void 0 || p.call(d)), this.startIndex = r + 1;
    }, e.prototype.onend = function() {
      var t, r;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var n = this.stack.length; n > 0; this.cbs.onclosetag(this.stack[--n], !0))
          ;
      }
      (r = (t = this.cbs).onend) === null || r === void 0 || r.call(t);
    }, e.prototype.reset = function() {
      var t, r, n, i;
      (r = (t = this.cbs).onreset) === null || r === void 0 || r.call(t), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (n = this.cbs).onparserinit) === null || i === void 0 || i.call(n, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, e.prototype.parseComplete = function(t) {
      this.reset(), this.end(t);
    }, e.prototype.getSlice = function(t, r) {
      for (; t - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var n = this.buffers[0].slice(t - this.bufferOffset, r - this.bufferOffset); r - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), n += this.buffers[0].slice(0, r - this.bufferOffset);
      return n;
    }, e.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, e.prototype.write = function(t) {
      var r, n;
      if (this.ended) {
        (n = (r = this.cbs).onerror) === null || n === void 0 || n.call(r, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
    }, e.prototype.end = function(t) {
      var r, n;
      if (this.ended) {
        (n = (r = this.cbs).onerror) === null || n === void 0 || n.call(r, new Error(".end() after done!"));
        return;
      }
      t && this.write(t), this.ended = !0, this.tokenizer.end();
    }, e.prototype.pause = function() {
      this.tokenizer.pause();
    }, e.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, e.prototype.parseChunk = function(t) {
      this.write(t);
    }, e.prototype.done = function(t) {
      this.end(t);
    }, e;
  }()
);
Q1.Parser = rar;
var Jc = {}, Kh = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(n) {
    n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function r(n) {
    return n.type === t.Tag || n.type === t.Script || n.type === t.Style;
  }
  e.isTag = r, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(Kh);
var Kr = {}, h0 = fe && fe.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), C1 = fe && fe.__assign || function() {
  return C1 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, C1.apply(this, arguments);
};
Object.defineProperty(Kr, "__esModule", { value: !0 });
Kr.cloneNode = Kr.hasChildren = Kr.isDocument = Kr.isDirective = Kr.isComment = Kr.isText = Kr.isCDATA = Kr.isTag = Kr.Element = Kr.Document = Kr.CDATA = Kr.NodeWithChildren = Kr.ProcessingInstruction = Kr.Comment = Kr.Text = Kr.DataNode = Kr.Node = void 0;
var ka = Kh, w7 = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), P7(this, t);
    }, e;
  }()
);
Kr.Node = w7;
var w3 = (
  /** @class */
  function(e) {
    h0(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.data = r, n;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(r) {
        this.data = r;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(w7)
);
Kr.DataNode = w3;
var FTe = (
  /** @class */
  function(e) {
    h0(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.type = ka.ElementType.Text, r;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(w3)
);
Kr.Text = FTe;
var HTe = (
  /** @class */
  function(e) {
    h0(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.type = ka.ElementType.Comment, r;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(w3)
);
Kr.Comment = HTe;
var $Te = (
  /** @class */
  function(e) {
    h0(t, e);
    function t(r, n) {
      var i = e.call(this, n) || this;
      return i.name = r, i.type = ka.ElementType.Directive, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(w3)
);
Kr.ProcessingInstruction = $Te;
var P3 = (
  /** @class */
  function(e) {
    h0(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.children = r, n;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var r;
        return (r = this.children[0]) !== null && r !== void 0 ? r : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(r) {
        this.children = r;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(w7)
);
Kr.NodeWithChildren = P3;
var UTe = (
  /** @class */
  function(e) {
    h0(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.type = ka.ElementType.CDATA, r;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(P3)
);
Kr.CDATA = UTe;
var VTe = (
  /** @class */
  function(e) {
    h0(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.type = ka.ElementType.Root, r;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(P3)
);
Kr.Document = VTe;
var jTe = (
  /** @class */
  function(e) {
    h0(t, e);
    function t(r, n, i, o) {
      i === void 0 && (i = []), o === void 0 && (o = r === "script" ? ka.ElementType.Script : r === "style" ? ka.ElementType.Style : ka.ElementType.Tag);
      var a = e.call(this, i) || this;
      return a.name = r, a.attribs = n, a.type = o, a;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(r) {
        this.name = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var r = this;
        return Object.keys(this.attribs).map(function(n) {
          var i, o;
          return {
            name: n,
            value: r.attribs[n],
            namespace: (i = r["x-attribsNamespace"]) === null || i === void 0 ? void 0 : i[n],
            prefix: (o = r["x-attribsPrefix"]) === null || o === void 0 ? void 0 : o[n]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(P3)
);
Kr.Element = jTe;
function zTe(e) {
  return (0, ka.isTag)(e);
}
Kr.isTag = zTe;
function qTe(e) {
  return e.type === ka.ElementType.CDATA;
}
Kr.isCDATA = qTe;
function YTe(e) {
  return e.type === ka.ElementType.Text;
}
Kr.isText = YTe;
function GTe(e) {
  return e.type === ka.ElementType.Comment;
}
Kr.isComment = GTe;
function WTe(e) {
  return e.type === ka.ElementType.Directive;
}
Kr.isDirective = WTe;
function KTe(e) {
  return e.type === ka.ElementType.Root;
}
Kr.isDocument = KTe;
function nar(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
Kr.hasChildren = nar;
function P7(e, t) {
  t === void 0 && (t = !1);
  var r;
  if (YTe(e))
    r = new FTe(e.data);
  else if (GTe(e))
    r = new HTe(e.data);
  else if (zTe(e)) {
    var n = t ? QD(e.children) : [], i = new jTe(e.name, C1({}, e.attribs), n);
    n.forEach(function(s) {
      return s.parent = i;
    }), e.namespace != null && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = C1({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = C1({}, e["x-attribsPrefix"])), r = i;
  } else if (qTe(e)) {
    var n = t ? QD(e.children) : [], o = new UTe(n);
    n.forEach(function(c) {
      return c.parent = o;
    }), r = o;
  } else if (KTe(e)) {
    var n = t ? QD(e.children) : [], a = new VTe(n);
    n.forEach(function(c) {
      return c.parent = a;
    }), e["x-mode"] && (a["x-mode"] = e["x-mode"]), r = a;
  } else if (WTe(e)) {
    var u = new $Te(e.name, e.data);
    e["x-name"] != null && (u["x-name"] = e["x-name"], u["x-publicId"] = e["x-publicId"], u["x-systemId"] = e["x-systemId"]), r = u;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
Kr.cloneNode = P7;
function QD(e) {
  for (var t = e.map(function(n) {
    return P7(n, !0);
  }), r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(u, s, c, l) {
    l === void 0 && (l = c);
    var f = Object.getOwnPropertyDescriptor(s, c);
    (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(u, l, f);
  } : function(u, s, c, l) {
    l === void 0 && (l = c), u[l] = s[c];
  }), r = fe && fe.__exportStar || function(u, s) {
    for (var c in u) c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && t(s, u, c);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var n = Kh, i = Kr;
  r(Kr, e);
  var o = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, a = (
    /** @class */
    function() {
      function u(s, c, l) {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (l = c, c = o), typeof s == "object" && (c = s, s = void 0), this.callback = s ?? null, this.options = c ?? o, this.elementCB = l ?? null;
      }
      return u.prototype.onparserinit = function(s) {
        this.parser = s;
      }, u.prototype.onreset = function() {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, u.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, u.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, u.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, u.prototype.onopentag = function(s, c) {
        var l = this.options.xmlMode ? n.ElementType.Tag : void 0, f = new i.Element(s, c, void 0, l);
        this.addNode(f), this.tagStack.push(f);
      }, u.prototype.ontext = function(s) {
        var c = this.lastNode;
        if (c && c.type === n.ElementType.Text)
          c.data += s, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var l = new i.Text(s);
          this.addNode(l), this.lastNode = l;
        }
      }, u.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === n.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var c = new i.Comment(s);
        this.addNode(c), this.lastNode = c;
      }, u.prototype.oncommentend = function() {
        this.lastNode = null;
      }, u.prototype.oncdatastart = function() {
        var s = new i.Text(""), c = new i.CDATA([s]);
        this.addNode(c), s.parent = c, this.lastNode = s;
      }, u.prototype.oncdataend = function() {
        this.lastNode = null;
      }, u.prototype.onprocessinginstruction = function(s, c) {
        var l = new i.ProcessingInstruction(s, c);
        this.addNode(l);
      }, u.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, u.prototype.addNode = function(s) {
        var c = this.tagStack[this.tagStack.length - 1], l = c.children[c.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), c.children.push(s), l && (s.prev = l, l.next = s), s.parent = c, this.lastNode = null;
      }, u;
    }()
  );
  e.DomHandler = a, e.default = a;
})(Jc);
var $4 = {}, ru = {}, wy = {}, XTe = {}, _B = {}, D7 = {};
Object.defineProperty(D7, "__esModule", { value: !0 });
D7.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var x7 = {};
Object.defineProperty(x7, "__esModule", { value: !0 });
x7.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var AB = {};
(function(e) {
  var t;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
  var r = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(o) {
    var a = "";
    return o > 65535 && (o -= 65536, a += String.fromCharCode(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), a += String.fromCharCode(o), a;
  };
  function n(o) {
    var a;
    return o >= 55296 && o <= 57343 || o > 1114111 ? 65533 : (a = r.get(o)) !== null && a !== void 0 ? a : o;
  }
  e.replaceCodePoint = n;
  function i(o) {
    return (0, e.fromCodePoint)(n(o));
  }
  e.default = i;
})(AB);
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(k, H, B, x) {
    x === void 0 && (x = B);
    var D = Object.getOwnPropertyDescriptor(H, B);
    (!D || ("get" in D ? !H.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
      return H[B];
    } }), Object.defineProperty(k, x, D);
  } : function(k, H, B, x) {
    x === void 0 && (x = B), k[x] = H[B];
  }), r = fe && fe.__setModuleDefault || (Object.create ? function(k, H) {
    Object.defineProperty(k, "default", { enumerable: !0, value: H });
  } : function(k, H) {
    k.default = H;
  }), n = fe && fe.__importStar || function(k) {
    if (k && k.__esModule) return k;
    var H = {};
    if (k != null) for (var B in k) B !== "default" && Object.prototype.hasOwnProperty.call(k, B) && t(H, k, B);
    return r(H, k), H;
  }, i = fe && fe.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
  var o = i(D7);
  e.htmlDecodeTree = o.default;
  var a = i(x7);
  e.xmlDecodeTree = a.default;
  var u = n(AB);
  e.decodeCodePoint = u.default;
  var s = AB;
  Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
    return s.replaceCodePoint;
  } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
    return s.fromCodePoint;
  } });
  var c;
  (function(k) {
    k[k.NUM = 35] = "NUM", k[k.SEMI = 59] = "SEMI", k[k.EQUALS = 61] = "EQUALS", k[k.ZERO = 48] = "ZERO", k[k.NINE = 57] = "NINE", k[k.LOWER_A = 97] = "LOWER_A", k[k.LOWER_F = 102] = "LOWER_F", k[k.LOWER_X = 120] = "LOWER_X", k[k.LOWER_Z = 122] = "LOWER_Z", k[k.UPPER_A = 65] = "UPPER_A", k[k.UPPER_F = 70] = "UPPER_F", k[k.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var l = 32, f;
  (function(k) {
    k[k.VALUE_LENGTH = 49152] = "VALUE_LENGTH", k[k.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", k[k.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(f = e.BinTrieFlags || (e.BinTrieFlags = {}));
  function d(k) {
    return k >= c.ZERO && k <= c.NINE;
  }
  function p(k) {
    return k >= c.UPPER_A && k <= c.UPPER_F || k >= c.LOWER_A && k <= c.LOWER_F;
  }
  function v(k) {
    return k >= c.UPPER_A && k <= c.UPPER_Z || k >= c.LOWER_A && k <= c.LOWER_Z || d(k);
  }
  function h(k) {
    return k === c.EQUALS || v(k);
  }
  var E;
  (function(k) {
    k[k.EntityStart = 0] = "EntityStart", k[k.NumericStart = 1] = "NumericStart", k[k.NumericDecimal = 2] = "NumericDecimal", k[k.NumericHex = 3] = "NumericHex", k[k.NamedEntity = 4] = "NamedEntity";
  })(E || (E = {}));
  var m;
  (function(k) {
    k[k.Legacy = 0] = "Legacy", k[k.Strict = 1] = "Strict", k[k.Attribute = 2] = "Attribute";
  })(m = e.DecodingMode || (e.DecodingMode = {}));
  var g = (
    /** @class */
    function() {
      function k(H, B, x) {
        this.decodeTree = H, this.emitCodePoint = B, this.errors = x, this.state = E.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = m.Strict;
      }
      return k.prototype.startEntity = function(H) {
        this.decodeMode = H, this.state = E.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, k.prototype.write = function(H, B) {
        switch (this.state) {
          case E.EntityStart:
            return H.charCodeAt(B) === c.NUM ? (this.state = E.NumericStart, this.consumed += 1, this.stateNumericStart(H, B + 1)) : (this.state = E.NamedEntity, this.stateNamedEntity(H, B));
          case E.NumericStart:
            return this.stateNumericStart(H, B);
          case E.NumericDecimal:
            return this.stateNumericDecimal(H, B);
          case E.NumericHex:
            return this.stateNumericHex(H, B);
          case E.NamedEntity:
            return this.stateNamedEntity(H, B);
        }
      }, k.prototype.stateNumericStart = function(H, B) {
        return B >= H.length ? -1 : (H.charCodeAt(B) | l) === c.LOWER_X ? (this.state = E.NumericHex, this.consumed += 1, this.stateNumericHex(H, B + 1)) : (this.state = E.NumericDecimal, this.stateNumericDecimal(H, B));
      }, k.prototype.addToNumericResult = function(H, B, x, D) {
        if (B !== x) {
          var w = x - B;
          this.result = this.result * Math.pow(D, w) + parseInt(H.substr(B, w), D), this.consumed += w;
        }
      }, k.prototype.stateNumericHex = function(H, B) {
        for (var x = B; B < H.length; ) {
          var D = H.charCodeAt(B);
          if (d(D) || p(D))
            B += 1;
          else
            return this.addToNumericResult(H, x, B, 16), this.emitNumericEntity(D, 3);
        }
        return this.addToNumericResult(H, x, B, 16), -1;
      }, k.prototype.stateNumericDecimal = function(H, B) {
        for (var x = B; B < H.length; ) {
          var D = H.charCodeAt(B);
          if (d(D))
            B += 1;
          else
            return this.addToNumericResult(H, x, B, 10), this.emitNumericEntity(D, 2);
        }
        return this.addToNumericResult(H, x, B, 10), -1;
      }, k.prototype.emitNumericEntity = function(H, B) {
        var x;
        if (this.consumed <= B)
          return (x = this.errors) === null || x === void 0 || x.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (H === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === m.Strict)
          return 0;
        return this.emitCodePoint((0, u.replaceCodePoint)(this.result), this.consumed), this.errors && (H !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, k.prototype.stateNamedEntity = function(H, B) {
        for (var x = this.decodeTree, D = x[this.treeIndex], w = (D & f.VALUE_LENGTH) >> 14; B < H.length; B++, this.excess++) {
          var $ = H.charCodeAt(B);
          if (this.treeIndex = _(x, D, this.treeIndex + Math.max(1, w), $), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === m.Attribute && // We shouldn't have consumed any characters after the entity,
            (w === 0 || // And there should be no invalid characters.
            h($)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (D = x[this.treeIndex], w = (D & f.VALUE_LENGTH) >> 14, w !== 0) {
            if ($ === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, w, this.consumed + this.excess);
            this.decodeMode !== m.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, k.prototype.emitNotTerminatedNamedEntity = function() {
        var H, B = this, x = B.result, D = B.decodeTree, w = (D[x] & f.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(x, w, this.consumed), (H = this.errors) === null || H === void 0 || H.missingSemicolonAfterCharacterReference(), this.consumed;
      }, k.prototype.emitNamedEntityData = function(H, B, x) {
        var D = this.decodeTree;
        return this.emitCodePoint(B === 1 ? D[H] & ~f.VALUE_LENGTH : D[H + 1], x), B === 3 && this.emitCodePoint(D[H + 2], x), x;
      }, k.prototype.end = function() {
        var H;
        switch (this.state) {
          case E.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== m.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case E.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case E.NumericHex:
            return this.emitNumericEntity(0, 3);
          case E.NumericStart:
            return (H = this.errors) === null || H === void 0 || H.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case E.EntityStart:
            return 0;
        }
      }, k;
    }()
  );
  e.EntityDecoder = g;
  function y(k) {
    var H = "", B = new g(k, function(x) {
      return H += (0, u.fromCodePoint)(x);
    });
    return function(D, w) {
      for (var $ = 0, X = 0; (X = D.indexOf("&", X)) >= 0; ) {
        H += D.slice($, X), B.startEntity(w);
        var V = B.write(
          D,
          // Skip the "&"
          X + 1
        );
        if (V < 0) {
          $ = X + B.end();
          break;
        }
        $ = X + V, X = V === 0 ? $ + 1 : $;
      }
      var F = H + D.slice($);
      return H = "", F;
    };
  }
  function _(k, H, B, x) {
    var D = (H & f.BRANCH_LENGTH) >> 7, w = H & f.JUMP_TABLE;
    if (D === 0)
      return w !== 0 && x === w ? B : -1;
    if (w) {
      var $ = x - w;
      return $ < 0 || $ >= D ? -1 : k[B + $] - 1;
    }
    for (var X = B, V = X + D - 1; X <= V; ) {
      var F = X + V >>> 1, le = k[F];
      if (le < x)
        X = F + 1;
      else if (le > x)
        V = F - 1;
      else
        return k[F + D];
    }
    return -1;
  }
  e.determineBranch = _;
  var S = y(o.default), A = y(a.default);
  function O(k, H) {
    return H === void 0 && (H = m.Legacy), S(k, H);
  }
  e.decodeHTML = O;
  function P(k) {
    return S(k, m.Attribute);
  }
  e.decodeHTMLAttribute = P;
  function U(k) {
    return S(k, m.Strict);
  }
  e.decodeHTMLStrict = U;
  function z(k) {
    return A(k, m.Strict);
  }
  e.decodeXML = z;
})(_B);
var Bf = {}, N7 = {};
Object.defineProperty(N7, "__esModule", { value: !0 });
function mA(e) {
  for (var t = 1; t < e.length; t++)
    e[t][0] += e[t - 1][0] + 1;
  return e;
}
N7.default = new Map(/* @__PURE__ */ mA([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ mA([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ mA([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ mA([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var US = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var t = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(i, o) {
    return i.codePointAt(o);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(i, o) {
      return (i.charCodeAt(o) & 64512) === 55296 ? (i.charCodeAt(o) - 55296) * 1024 + i.charCodeAt(o + 1) - 56320 + 65536 : i.charCodeAt(o);
    }
  );
  function r(i) {
    for (var o = "", a = 0, u; (u = e.xmlReplacer.exec(i)) !== null; ) {
      var s = u.index, c = i.charCodeAt(s), l = t.get(c);
      l !== void 0 ? (o += i.substring(a, s) + l, a = s + 1) : (o += "".concat(i.substring(a, s), "&#x").concat((0, e.getCodePoint)(i, s).toString(16), ";"), a = e.xmlReplacer.lastIndex += +((c & 64512) === 55296));
    }
    return o + i.substr(a);
  }
  e.encodeXML = r, e.escape = r;
  function n(i, o) {
    return function(u) {
      for (var s, c = 0, l = ""; s = i.exec(u); )
        c !== s.index && (l += u.substring(c, s.index)), l += o.get(s[0].charCodeAt(0)), c = s.index + 1;
      return l + u.substring(c);
    };
  }
  e.escapeUTF8 = n(/[&<>'"]/g, t), e.escapeAttribute = n(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), e.escapeText = n(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(US);
var iar = fe && fe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Bf, "__esModule", { value: !0 });
Bf.encodeNonAsciiHTML = Bf.encodeHTML = void 0;
var oar = iar(N7), JTe = US, aar = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function uar(e) {
  return ZTe(aar, e);
}
Bf.encodeHTML = uar;
function sar(e) {
  return ZTe(JTe.xmlReplacer, e);
}
Bf.encodeNonAsciiHTML = sar;
function ZTe(e, t) {
  for (var r = "", n = 0, i; (i = e.exec(t)) !== null; ) {
    var o = i.index;
    r += t.substring(n, o);
    var a = t.charCodeAt(o), u = oar.default.get(a);
    if (typeof u == "object") {
      if (o + 1 < t.length) {
        var s = t.charCodeAt(o + 1), c = typeof u.n == "number" ? u.n === s ? u.o : void 0 : u.n.get(s);
        if (c !== void 0) {
          r += c, n = e.lastIndex += 1;
          continue;
        }
      }
      u = u.v;
    }
    if (u !== void 0)
      r += u, n = o + 1;
    else {
      var l = (0, JTe.getCodePoint)(t, o);
      r += "&#x".concat(l.toString(16), ";"), n = e.lastIndex += +(l !== a);
    }
  }
  return r + t.substr(n);
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
  var t = _B, r = Bf, n = US, i;
  (function(d) {
    d[d.XML = 0] = "XML", d[d.HTML = 1] = "HTML";
  })(i = e.EntityLevel || (e.EntityLevel = {}));
  var o;
  (function(d) {
    d[d.UTF8 = 0] = "UTF8", d[d.ASCII = 1] = "ASCII", d[d.Extensive = 2] = "Extensive", d[d.Attribute = 3] = "Attribute", d[d.Text = 4] = "Text";
  })(o = e.EncodingMode || (e.EncodingMode = {}));
  function a(d, p) {
    p === void 0 && (p = i.XML);
    var v = typeof p == "number" ? p : p.level;
    if (v === i.HTML) {
      var h = typeof p == "object" ? p.mode : void 0;
      return (0, t.decodeHTML)(d, h);
    }
    return (0, t.decodeXML)(d);
  }
  e.decode = a;
  function u(d, p) {
    var v;
    p === void 0 && (p = i.XML);
    var h = typeof p == "number" ? { level: p } : p;
    return (v = h.mode) !== null && v !== void 0 || (h.mode = t.DecodingMode.Strict), a(d, h);
  }
  e.decodeStrict = u;
  function s(d, p) {
    p === void 0 && (p = i.XML);
    var v = typeof p == "number" ? { level: p } : p;
    return v.mode === o.UTF8 ? (0, n.escapeUTF8)(d) : v.mode === o.Attribute ? (0, n.escapeAttribute)(d) : v.mode === o.Text ? (0, n.escapeText)(d) : v.level === i.HTML ? v.mode === o.ASCII ? (0, r.encodeNonAsciiHTML)(d) : (0, r.encodeHTML)(d) : (0, n.encodeXML)(d);
  }
  e.encode = s;
  var c = US;
  Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
    return c.encodeXML;
  } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
    return c.escape;
  } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
    return c.escapeUTF8;
  } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
    return c.escapeAttribute;
  } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
    return c.escapeText;
  } });
  var l = Bf;
  Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return l.encodeNonAsciiHTML;
  } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } });
  var f = _B;
  Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
    return f.EntityDecoder;
  } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
    return f.DecodingMode;
  } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
    return f.decodeXML;
  } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return f.decodeHTMLAttribute;
  } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
    return f.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return f.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
    return f.decodeXML;
  } });
})(XTe);
var Jp = {};
Object.defineProperty(Jp, "__esModule", { value: !0 });
Jp.attributeNames = Jp.elementNames = void 0;
Jp.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
Jp.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
var pp = fe && fe.__assign || function() {
  return pp = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, pp.apply(this, arguments);
}, car = fe && fe.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), lar = fe && fe.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), far = fe && fe.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var r in e) r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && car(t, e, r);
  return lar(t, e), t;
};
Object.defineProperty(wy, "__esModule", { value: !0 });
wy.render = void 0;
var Pc = far(Kh), VS = XTe, QTe = Jp, dar = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function par(e) {
  return e.replace(/"/g, "&quot;");
}
function har(e, t) {
  var r;
  if (e) {
    var n = ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) === !1 ? par : t.xmlMode || t.encodeEntities !== "utf8" ? VS.encodeXML : VS.escapeAttribute;
    return Object.keys(e).map(function(i) {
      var o, a, u = (o = e[i]) !== null && o !== void 0 ? o : "";
      return t.xmlMode === "foreign" && (i = (a = QTe.attributeNames.get(i)) !== null && a !== void 0 ? a : i), !t.emptyAttrs && !t.xmlMode && u === "" ? i : "".concat(i, '="').concat(n(u), '"');
    }).join(" ");
  }
}
var Dee = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function D3(e, t) {
  t === void 0 && (t = {});
  for (var r = ("length" in e) ? e : [e], n = "", i = 0; i < r.length; i++)
    n += Ear(r[i], t);
  return n;
}
wy.render = D3;
wy.default = D3;
function Ear(e, t) {
  switch (e.type) {
    case Pc.Root:
      return D3(e.children, t);
    case Pc.Doctype:
    case Pc.Directive:
      return yar(e);
    case Pc.Comment:
      return Sar(e);
    case Pc.CDATA:
      return Aar(e);
    case Pc.Script:
    case Pc.Style:
    case Pc.Tag:
      return Tar(e, t);
    case Pc.Text:
      return _ar(e, t);
  }
}
var mar = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), gar = /* @__PURE__ */ new Set(["svg", "math"]);
function Tar(e, t) {
  var r;
  t.xmlMode === "foreign" && (e.name = (r = QTe.elementNames.get(e.name)) !== null && r !== void 0 ? r : e.name, e.parent && mar.has(e.parent.name) && (t = pp(pp({}, t), { xmlMode: !1 }))), !t.xmlMode && gar.has(e.name) && (t = pp(pp({}, t), { xmlMode: "foreign" }));
  var n = "<".concat(e.name), i = har(e.attribs, t);
  return i && (n += " ".concat(i)), e.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && Dee.has(e.name)
  )) ? (t.xmlMode || (n += " "), n += "/>") : (n += ">", e.children.length > 0 && (n += D3(e.children, t)), (t.xmlMode || !Dee.has(e.name)) && (n += "</".concat(e.name, ">"))), n;
}
function yar(e) {
  return "<".concat(e.data, ">");
}
function _ar(e, t) {
  var r, n = e.data || "";
  return ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && dar.has(e.parent.name)) && (n = t.xmlMode || t.encodeEntities !== "utf8" ? (0, VS.encodeXML)(n) : (0, VS.escapeText)(n)), n;
}
function Aar(e) {
  return "<![CDATA[".concat(e.children[0].data, "]]>");
}
function Sar(e) {
  return "<!--".concat(e.data, "-->");
}
var bar = fe && fe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ru, "__esModule", { value: !0 });
ru.innerText = ru.textContent = ru.getText = ru.getInnerHTML = ru.getOuterHTML = void 0;
var Zs = Jc, Car = bar(wy), Iar = Kh;
function eye(e, t) {
  return (0, Car.default)(e, t);
}
ru.getOuterHTML = eye;
function Oar(e, t) {
  return (0, Zs.hasChildren)(e) ? e.children.map(function(r) {
    return eye(r, t);
  }).join("") : "";
}
ru.getInnerHTML = Oar;
function U4(e) {
  return Array.isArray(e) ? e.map(U4).join("") : (0, Zs.isTag)(e) ? e.name === "br" ? `
` : U4(e.children) : (0, Zs.isCDATA)(e) ? U4(e.children) : (0, Zs.isText)(e) ? e.data : "";
}
ru.getText = U4;
function SB(e) {
  return Array.isArray(e) ? e.map(SB).join("") : (0, Zs.hasChildren)(e) && !(0, Zs.isComment)(e) ? SB(e.children) : (0, Zs.isText)(e) ? e.data : "";
}
ru.textContent = SB;
function bB(e) {
  return Array.isArray(e) ? e.map(bB).join("") : (0, Zs.hasChildren)(e) && (e.type === Iar.ElementType.Tag || (0, Zs.isCDATA)(e)) ? bB(e.children) : (0, Zs.isText)(e) ? e.data : "";
}
ru.innerText = bB;
var _o = {};
Object.defineProperty(_o, "__esModule", { value: !0 });
_o.prevElementSibling = _o.nextElementSibling = _o.getName = _o.hasAttrib = _o.getAttributeValue = _o.getSiblings = _o.getParent = _o.getChildren = void 0;
var L7 = Jc;
function tye(e) {
  return (0, L7.hasChildren)(e) ? e.children : [];
}
_o.getChildren = tye;
function rye(e) {
  return e.parent || null;
}
_o.getParent = rye;
function Rar(e) {
  var t, r, n = rye(e);
  if (n != null)
    return tye(n);
  for (var i = [e], o = e.prev, a = e.next; o != null; )
    i.unshift(o), t = o, o = t.prev;
  for (; a != null; )
    i.push(a), r = a, a = r.next;
  return i;
}
_o.getSiblings = Rar;
function war(e, t) {
  var r;
  return (r = e.attribs) === null || r === void 0 ? void 0 : r[t];
}
_o.getAttributeValue = war;
function Par(e, t) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
}
_o.hasAttrib = Par;
function Dar(e) {
  return e.name;
}
_o.getName = Dar;
function xar(e) {
  for (var t, r = e.next; r !== null && !(0, L7.isTag)(r); )
    t = r, r = t.next;
  return r;
}
_o.nextElementSibling = xar;
function Nar(e) {
  for (var t, r = e.prev; r !== null && !(0, L7.isTag)(r); )
    t = r, r = t.prev;
  return r;
}
_o.prevElementSibling = Nar;
var xa = {};
Object.defineProperty(xa, "__esModule", { value: !0 });
xa.prepend = xa.prependChild = xa.append = xa.appendChild = xa.replaceElement = xa.removeElement = void 0;
function Py(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    var t = e.parent.children, r = t.lastIndexOf(e);
    r >= 0 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
xa.removeElement = Py;
function Lar(e, t) {
  var r = t.prev = e.prev;
  r && (r.next = t);
  var n = t.next = e.next;
  n && (n.prev = t);
  var i = t.parent = e.parent;
  if (i) {
    var o = i.children;
    o[o.lastIndexOf(e)] = t, e.parent = null;
  }
}
xa.replaceElement = Lar;
function Bar(e, t) {
  if (Py(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    var r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
xa.appendChild = Bar;
function kar(e, t) {
  Py(t);
  var r = e.parent, n = e.next;
  if (t.next = n, t.prev = e, e.next = t, t.parent = r, n) {
    if (n.prev = t, r) {
      var i = r.children;
      i.splice(i.lastIndexOf(n), 0, t);
    }
  } else r && r.children.push(t);
}
xa.append = kar;
function Mar(e, t) {
  if (Py(t), t.parent = e, t.prev = null, e.children.unshift(t) !== 1) {
    var r = e.children[1];
    r.prev = t, t.next = r;
  } else
    t.next = null;
}
xa.prependChild = Mar;
function Far(e, t) {
  Py(t);
  var r = e.parent;
  if (r) {
    var n = r.children;
    n.splice(n.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
xa.prepend = Far;
var ha = {};
Object.defineProperty(ha, "__esModule", { value: !0 });
ha.findAll = ha.existsOne = ha.findOne = ha.findOneChild = ha.find = ha.filter = void 0;
var x3 = Jc;
function Har(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), nye(e, Array.isArray(t) ? t : [t], r, n);
}
ha.filter = Har;
function nye(e, t, r, n) {
  for (var i = [], o = [t], a = [0]; ; ) {
    if (a[0] >= o[0].length) {
      if (a.length === 1)
        return i;
      o.shift(), a.shift();
      continue;
    }
    var u = o[0][a[0]++];
    if (e(u) && (i.push(u), --n <= 0))
      return i;
    r && (0, x3.hasChildren)(u) && u.children.length > 0 && (a.unshift(0), o.unshift(u.children));
  }
}
ha.find = nye;
function $ar(e, t) {
  return t.find(e);
}
ha.findOneChild = $ar;
function iye(e, t, r) {
  r === void 0 && (r = !0);
  for (var n = null, i = 0; i < t.length && !n; i++) {
    var o = t[i];
    if ((0, x3.isTag)(o))
      e(o) ? n = o : r && o.children.length > 0 && (n = iye(e, o.children, !0));
    else continue;
  }
  return n;
}
ha.findOne = iye;
function oye(e, t) {
  return t.some(function(r) {
    return (0, x3.isTag)(r) && (e(r) || oye(e, r.children));
  });
}
ha.existsOne = oye;
function Uar(e, t) {
  for (var r = [], n = [t], i = [0]; ; ) {
    if (i[0] >= n[0].length) {
      if (n.length === 1)
        return r;
      n.shift(), i.shift();
      continue;
    }
    var o = n[0][i[0]++];
    (0, x3.isTag)(o) && (e(o) && r.push(o), o.children.length > 0 && (i.unshift(0), n.unshift(o.children)));
  }
}
ha.findAll = Uar;
var nu = {};
Object.defineProperty(nu, "__esModule", { value: !0 });
nu.getElementsByTagType = nu.getElementsByTagName = nu.getElementById = nu.getElements = nu.testElement = void 0;
var cf = Jc, N3 = ha, jS = {
  tag_name: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, cf.isTag)(t) && e(t.name);
    } : e === "*" ? cf.isTag : function(t) {
      return (0, cf.isTag)(t) && t.name === e;
    };
  },
  tag_type: function(e) {
    return typeof e == "function" ? function(t) {
      return e(t.type);
    } : function(t) {
      return t.type === e;
    };
  },
  tag_contains: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, cf.isText)(t) && e(t.data);
    } : function(t) {
      return (0, cf.isText)(t) && t.data === e;
    };
  }
};
function aye(e, t) {
  return typeof t == "function" ? function(r) {
    return (0, cf.isTag)(r) && t(r.attribs[e]);
  } : function(r) {
    return (0, cf.isTag)(r) && r.attribs[e] === t;
  };
}
function Var(e, t) {
  return function(r) {
    return e(r) || t(r);
  };
}
function uye(e) {
  var t = Object.keys(e).map(function(r) {
    var n = e[r];
    return Object.prototype.hasOwnProperty.call(jS, r) ? jS[r](n) : aye(r, n);
  });
  return t.length === 0 ? null : t.reduce(Var);
}
function jar(e, t) {
  var r = uye(e);
  return r ? r(t) : !0;
}
nu.testElement = jar;
function zar(e, t, r, n) {
  n === void 0 && (n = 1 / 0);
  var i = uye(e);
  return i ? (0, N3.filter)(i, t, r, n) : [];
}
nu.getElements = zar;
function qar(e, t, r) {
  return r === void 0 && (r = !0), Array.isArray(t) || (t = [t]), (0, N3.findOne)(aye("id", e), t, r);
}
nu.getElementById = qar;
function Yar(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), (0, N3.filter)(jS.tag_name(e), t, r, n);
}
nu.getElementsByTagName = Yar;
function Gar(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), (0, N3.filter)(jS.tag_type(e), t, r, n);
}
nu.getElementsByTagType = Gar;
var sye = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.uniqueSort = e.compareDocumentPosition = e.DocumentPosition = e.removeSubsets = void 0;
  var t = Jc;
  function r(a) {
    for (var u = a.length; --u >= 0; ) {
      var s = a[u];
      if (u > 0 && a.lastIndexOf(s, u - 1) >= 0) {
        a.splice(u, 1);
        continue;
      }
      for (var c = s.parent; c; c = c.parent)
        if (a.includes(c)) {
          a.splice(u, 1);
          break;
        }
    }
    return a;
  }
  e.removeSubsets = r;
  var n;
  (function(a) {
    a[a.DISCONNECTED = 1] = "DISCONNECTED", a[a.PRECEDING = 2] = "PRECEDING", a[a.FOLLOWING = 4] = "FOLLOWING", a[a.CONTAINS = 8] = "CONTAINS", a[a.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(n = e.DocumentPosition || (e.DocumentPosition = {}));
  function i(a, u) {
    var s = [], c = [];
    if (a === u)
      return 0;
    for (var l = (0, t.hasChildren)(a) ? a : a.parent; l; )
      s.unshift(l), l = l.parent;
    for (l = (0, t.hasChildren)(u) ? u : u.parent; l; )
      c.unshift(l), l = l.parent;
    for (var f = Math.min(s.length, c.length), d = 0; d < f && s[d] === c[d]; )
      d++;
    if (d === 0)
      return n.DISCONNECTED;
    var p = s[d - 1], v = p.children, h = s[d], E = c[d];
    return v.indexOf(h) > v.indexOf(E) ? p === u ? n.FOLLOWING | n.CONTAINED_BY : n.FOLLOWING : p === a ? n.PRECEDING | n.CONTAINS : n.PRECEDING;
  }
  e.compareDocumentPosition = i;
  function o(a) {
    return a = a.filter(function(u, s, c) {
      return !c.includes(u, s + 1);
    }), a.sort(function(u, s) {
      var c = i(u, s);
      return c & n.PRECEDING ? -1 : c & n.FOLLOWING ? 1 : 0;
    }), a;
  }
  e.uniqueSort = o;
})(sye);
var L3 = {};
Object.defineProperty(L3, "__esModule", { value: !0 });
L3.getFeed = void 0;
var War = ru, Dy = nu;
function Kar(e) {
  var t = zS(eur, e);
  return t ? t.name === "feed" ? Xar(t) : Jar(t) : null;
}
L3.getFeed = Kar;
function Xar(e) {
  var t, r = e.children, n = {
    type: "atom",
    items: (0, Dy.getElementsByTagName)("entry", r).map(function(a) {
      var u, s = a.children, c = { media: cye(s) };
      Pa(c, "id", "id", s), Pa(c, "title", "title", s);
      var l = (u = zS("link", s)) === null || u === void 0 ? void 0 : u.attribs.href;
      l && (c.link = l);
      var f = ql("summary", s) || ql("content", s);
      f && (c.description = f);
      var d = ql("updated", s);
      return d && (c.pubDate = new Date(d)), c;
    })
  };
  Pa(n, "id", "id", r), Pa(n, "title", "title", r);
  var i = (t = zS("link", r)) === null || t === void 0 ? void 0 : t.attribs.href;
  i && (n.link = i), Pa(n, "description", "subtitle", r);
  var o = ql("updated", r);
  return o && (n.updated = new Date(o)), Pa(n, "author", "email", r, !0), n;
}
function Jar(e) {
  var t, r, n = (r = (t = zS("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && r !== void 0 ? r : [], i = {
    type: e.name.substr(0, 3),
    id: "",
    items: (0, Dy.getElementsByTagName)("item", e.children).map(function(a) {
      var u = a.children, s = { media: cye(u) };
      Pa(s, "id", "guid", u), Pa(s, "title", "title", u), Pa(s, "link", "link", u), Pa(s, "description", "description", u);
      var c = ql("pubDate", u) || ql("dc:date", u);
      return c && (s.pubDate = new Date(c)), s;
    })
  };
  Pa(i, "title", "title", n), Pa(i, "link", "link", n), Pa(i, "description", "description", n);
  var o = ql("lastBuildDate", n);
  return o && (i.updated = new Date(o)), Pa(i, "author", "managingEditor", n, !0), i;
}
var Zar = ["url", "type", "lang"], Qar = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function cye(e) {
  return (0, Dy.getElementsByTagName)("media:content", e).map(function(t) {
    for (var r = t.attribs, n = {
      medium: r.medium,
      isDefault: !!r.isDefault
    }, i = 0, o = Zar; i < o.length; i++) {
      var a = o[i];
      r[a] && (n[a] = r[a]);
    }
    for (var u = 0, s = Qar; u < s.length; u++) {
      var a = s[u];
      r[a] && (n[a] = parseInt(r[a], 10));
    }
    return r.expression && (n.expression = r.expression), n;
  });
}
function zS(e, t) {
  return (0, Dy.getElementsByTagName)(e, t, !0, 1)[0];
}
function ql(e, t, r) {
  return r === void 0 && (r = !1), (0, War.textContent)((0, Dy.getElementsByTagName)(e, t, r, 1)).trim();
}
function Pa(e, t, r, n, i) {
  i === void 0 && (i = !1);
  var o = ql(r, n, i);
  o && (e[t] = o);
}
function eur(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(i, o, a, u) {
    u === void 0 && (u = a);
    var s = Object.getOwnPropertyDescriptor(o, a);
    (!s || ("get" in s ? !o.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return o[a];
    } }), Object.defineProperty(i, u, s);
  } : function(i, o, a, u) {
    u === void 0 && (u = a), i[u] = o[a];
  }), r = fe && fe.__exportStar || function(i, o) {
    for (var a in i) a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, i, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, r(ru, e), r(_o, e), r(xa, e), r(ha, e), r(nu, e), r(sye, e), r(L3, e);
  var n = Jc;
  Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
    return n.isTag;
  } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
    return n.isCDATA;
  } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
    return n.isText;
  } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
    return n.isComment;
  } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
    return n.isDocument;
  } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
    return n.hasChildren;
  } });
})($4);
(function(e) {
  var t = fe && fe.__createBinding || (Object.create ? function(m, g, y, _) {
    _ === void 0 && (_ = y);
    var S = Object.getOwnPropertyDescriptor(g, y);
    (!S || ("get" in S ? !g.__esModule : S.writable || S.configurable)) && (S = { enumerable: !0, get: function() {
      return g[y];
    } }), Object.defineProperty(m, _, S);
  } : function(m, g, y, _) {
    _ === void 0 && (_ = y), m[_] = g[y];
  }), r = fe && fe.__setModuleDefault || (Object.create ? function(m, g) {
    Object.defineProperty(m, "default", { enumerable: !0, value: g });
  } : function(m, g) {
    m.default = g;
  }), n = fe && fe.__importStar || function(m) {
    if (m && m.__esModule) return m;
    var g = {};
    if (m != null) for (var y in m) y !== "default" && Object.prototype.hasOwnProperty.call(m, y) && t(g, m, y);
    return r(g, m), g;
  }, i = fe && fe.__importDefault || function(m) {
    return m && m.__esModule ? m : { default: m };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
  var o = Q1, a = Q1;
  Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
    return a.Parser;
  } });
  var u = Jc, s = Jc;
  Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } });
  function c(m, g) {
    var y = new u.DomHandler(void 0, g);
    return new o.Parser(y, g).end(m), y.root;
  }
  e.parseDocument = c;
  function l(m, g) {
    return c(m, g).children;
  }
  e.parseDOM = l;
  function f(m, g, y) {
    var _ = new u.DomHandler(m, g, y);
    return new o.Parser(_, g);
  }
  e.createDomStream = f;
  var d = C7;
  Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
    return i(d).default;
  } }), e.ElementType = n(Kh);
  var p = $4, v = $4;
  Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
    return v.getFeed;
  } });
  var h = { xmlMode: !0 };
  function E(m, g) {
    return g === void 0 && (g = h), (0, p.getFeed)(l(m, g));
  }
  e.parseFeed = E, e.DomUtils = n($4);
})(MTe);
var tur = (e) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, B7 = {};
Object.defineProperty(B7, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function xee(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rur(e) {
  var t, r;
  return xee(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (r = t.prototype, !(xee(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1)));
}
B7.isPlainObject = rur;
var nur = function(t) {
  return iur(t) && !our(t);
};
function iur(e) {
  return !!e && typeof e == "object";
}
function our(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || sur(e);
}
var aur = typeof Symbol == "function" && Symbol.for, uur = aur ? Symbol.for("react.element") : 60103;
function sur(e) {
  return e.$$typeof === uur;
}
function cur(e) {
  return Array.isArray(e) ? [] : {};
}
function eT(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Zp(cur(e), e, t) : e;
}
function lur(e, t, r) {
  return e.concat(t).map(function(n) {
    return eT(n, r);
  });
}
function fur(e, t) {
  if (!t.customMerge)
    return Zp;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : Zp;
}
function dur(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Nee(e) {
  return Object.keys(e).concat(dur(e));
}
function lye(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function pur(e, t) {
  return lye(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function hur(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && Nee(e).forEach(function(i) {
    n[i] = eT(e[i], r);
  }), Nee(t).forEach(function(i) {
    pur(e, i) || (lye(e, i) && r.isMergeableObject(t[i]) ? n[i] = fur(i, r)(e[i], t[i], r) : n[i] = eT(t[i], r));
  }), n;
}
function Zp(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || lur, r.isMergeableObject = r.isMergeableObject || nur, r.cloneUnlessOtherwiseSpecified = eT;
  var n = Array.isArray(t), i = Array.isArray(e), o = n === i;
  return o ? n ? r.arrayMerge(e, t, r) : hur(e, t, r) : eT(t, r);
}
Zp.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, i) {
    return Zp(n, i, r);
  }, {});
};
var vur = Zp, Eur = vur, fye = { exports: {} };
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.parseSrcset = r();
  })(fe, function() {
    return function(t) {
      function r(_) {
        return _ === " " || // space
        _ === "	" || // horizontal tab
        _ === `
` || // new line
        _ === "\f" || // form feed
        _ === "\r";
      }
      function n(_) {
        var S, A = _.exec(t.substring(E));
        if (A)
          return S = A[0], E += S.length, S;
      }
      for (var i = t.length, o = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, u = /^[^ \t\n\r\u000c]+/, s = /[,]+$/, c = /^\d+$/, l = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, d, p, v, h, E = 0, m = []; ; ) {
        if (n(a), E >= i)
          return m;
        f = n(u), d = [], f.slice(-1) === "," ? (f = f.replace(s, ""), y()) : g();
      }
      function g() {
        for (n(o), p = "", v = "in descriptor"; ; ) {
          if (h = t.charAt(E), v === "in descriptor")
            if (r(h))
              p && (d.push(p), p = "", v = "after descriptor");
            else if (h === ",") {
              E += 1, p && d.push(p), y();
              return;
            } else if (h === "(")
              p = p + h, v = "in parens";
            else if (h === "") {
              p && d.push(p), y();
              return;
            } else
              p = p + h;
          else if (v === "in parens")
            if (h === ")")
              p = p + h, v = "in descriptor";
            else if (h === "") {
              d.push(p), y();
              return;
            } else
              p = p + h;
          else if (v === "after descriptor" && !r(h))
            if (h === "") {
              y();
              return;
            } else
              v = "in descriptor", E -= 1;
          E += 1;
        }
      }
      function y() {
        var _ = !1, S, A, O, P, U = {}, z, k, H, B, x;
        for (P = 0; P < d.length; P++)
          z = d[P], k = z[z.length - 1], H = z.substring(0, z.length - 1), B = parseInt(H, 10), x = parseFloat(H), c.test(H) && k === "w" ? ((S || A) && (_ = !0), B === 0 ? _ = !0 : S = B) : l.test(H) && k === "x" ? ((S || A || O) && (_ = !0), x < 0 ? _ = !0 : A = x) : c.test(H) && k === "h" ? ((O || A) && (_ = !0), B === 0 ? _ = !0 : O = B) : _ = !0;
        _ ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + z + "'.") : (U.url = f, S && (U.w = S), A && (U.d = A), O && (U.h = O), m.push(U));
      }
    };
  });
})(fye);
var mur = fye.exports, k7 = { exports: {} }, $r = String, dye = function() {
  return { isColorSupported: !1, reset: $r, bold: $r, dim: $r, italic: $r, underline: $r, inverse: $r, hidden: $r, strikethrough: $r, black: $r, red: $r, green: $r, yellow: $r, blue: $r, magenta: $r, cyan: $r, white: $r, gray: $r, bgBlack: $r, bgRed: $r, bgGreen: $r, bgYellow: $r, bgBlue: $r, bgMagenta: $r, bgCyan: $r, bgWhite: $r, blackBright: $r, redBright: $r, greenBright: $r, yellowBright: $r, blueBright: $r, magentaBright: $r, cyanBright: $r, whiteBright: $r, bgBlackBright: $r, bgRedBright: $r, bgGreenBright: $r, bgYellowBright: $r, bgBlueBright: $r, bgMagentaBright: $r, bgCyanBright: $r, bgWhiteBright: $r };
};
k7.exports = dye();
k7.exports.createColors = dye;
var gur = k7.exports;
const I1 = {}, Tur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I1
}, Symbol.toStringTag, { value: "Module" })), ki = /* @__PURE__ */ lh(Tur);
let Lee = gur, Bee = ki, CB = class pye extends Error {
  constructor(t, r, n, i, o, a) {
    super(t), this.name = "CssSyntaxError", this.reason = t, o && (this.file = o), i && (this.source = i), a && (this.plugin = a), typeof r < "u" && typeof n < "u" && (typeof r == "number" ? (this.line = r, this.column = n) : (this.line = r.line, this.column = r.column, this.endLine = n.line, this.endColumn = n.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, pye);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(t) {
    if (!this.source) return "";
    let r = this.source;
    t == null && (t = Lee.isColorSupported);
    let n = (l) => l, i = (l) => l, o = (l) => l;
    if (t) {
      let { bold: l, gray: f, red: d } = Lee.createColors(!0);
      i = (p) => l(d(p)), n = (p) => f(p), Bee && (o = (p) => Bee(p));
    }
    let a = r.split(/\r?\n/), u = Math.max(this.line - 3, 0), s = Math.min(this.line + 2, a.length), c = String(s).length;
    return a.slice(u, s).map((l, f) => {
      let d = u + 1 + f, p = " " + (" " + d).slice(-c) + " | ";
      if (d === this.line) {
        if (l.length > 160) {
          let h = 20, E = Math.max(0, this.column - h), m = Math.max(
            this.column + h,
            this.endColumn + h
          ), g = l.slice(E, m), y = n(p.replace(/\d/g, " ")) + l.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
          return i(">") + n(p) + o(g) + `
 ` + y + i("^");
        }
        let v = n(p.replace(/\d/g, " ")) + l.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + n(p) + o(l) + `
 ` + v + i("^");
      }
      return " " + n(p) + o(l);
    }).join(`
`);
  }
  toString() {
    let t = this.showSourceCode();
    return t && (t = `

` + t + `
`), this.name + ": " + this.message + t;
  }
};
var M7 = CB;
CB.default = CB;
const kee = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function yur(e) {
  return e[0].toUpperCase() + e.slice(1);
}
let IB = class {
  constructor(t) {
    this.builder = t;
  }
  atrule(t, r) {
    let n = "@" + t.name, i = t.params ? this.rawValue(t, "params") : "";
    if (typeof t.raws.afterName < "u" ? n += t.raws.afterName : i && (n += " "), t.nodes)
      this.block(t, n + i);
    else {
      let o = (t.raws.between || "") + (r ? ";" : "");
      this.builder(n + i + o, t);
    }
  }
  beforeAfter(t, r) {
    let n;
    t.type === "decl" ? n = this.raw(t, null, "beforeDecl") : t.type === "comment" ? n = this.raw(t, null, "beforeComment") : r === "before" ? n = this.raw(t, null, "beforeRule") : n = this.raw(t, null, "beforeClose");
    let i = t.parent, o = 0;
    for (; i && i.type !== "root"; )
      o += 1, i = i.parent;
    if (n.includes(`
`)) {
      let a = this.raw(t, null, "indent");
      if (a.length)
        for (let u = 0; u < o; u++) n += a;
    }
    return n;
  }
  block(t, r) {
    let n = this.raw(t, "between", "beforeOpen");
    this.builder(r + n + "{", t, "start");
    let i;
    t.nodes && t.nodes.length ? (this.body(t), i = this.raw(t, "after")) : i = this.raw(t, "after", "emptyBody"), i && this.builder(i), this.builder("}", t, "end");
  }
  body(t) {
    let r = t.nodes.length - 1;
    for (; r > 0 && t.nodes[r].type === "comment"; )
      r -= 1;
    let n = this.raw(t, "semicolon");
    for (let i = 0; i < t.nodes.length; i++) {
      let o = t.nodes[i], a = this.raw(o, "before");
      a && this.builder(a), this.stringify(o, r !== i || n);
    }
  }
  comment(t) {
    let r = this.raw(t, "left", "commentLeft"), n = this.raw(t, "right", "commentRight");
    this.builder("/*" + r + t.text + n + "*/", t);
  }
  decl(t, r) {
    let n = this.raw(t, "between", "colon"), i = t.prop + n + this.rawValue(t, "value");
    t.important && (i += t.raws.important || " !important"), r && (i += ";"), this.builder(i, t);
  }
  document(t) {
    this.body(t);
  }
  raw(t, r, n) {
    let i;
    if (n || (n = r), r && (i = t.raws[r], typeof i < "u"))
      return i;
    let o = t.parent;
    if (n === "before" && (!o || o.type === "root" && o.first === t || o && o.type === "document"))
      return "";
    if (!o) return kee[n];
    let a = t.root();
    if (a.rawCache || (a.rawCache = {}), typeof a.rawCache[n] < "u")
      return a.rawCache[n];
    if (n === "before" || n === "after")
      return this.beforeAfter(t, n);
    {
      let u = "raw" + yur(n);
      this[u] ? i = this[u](a, t) : a.walk((s) => {
        if (i = s.raws[r], typeof i < "u") return !1;
      });
    }
    return typeof i > "u" && (i = kee[n]), a.rawCache[n] = i, i;
  }
  rawBeforeClose(t) {
    let r;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length > 0 && typeof n.raws.after < "u")
        return r = n.raws.after, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), r && (r = r.replace(/\S/g, "")), r;
  }
  rawBeforeComment(t, r) {
    let n;
    return t.walkComments((i) => {
      if (typeof i.raws.before < "u")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n > "u" ? n = this.raw(r, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeDecl(t, r) {
    let n;
    return t.walkDecls((i) => {
      if (typeof i.raws.before < "u")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n > "u" ? n = this.raw(r, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeOpen(t) {
    let r;
    return t.walk((n) => {
      if (n.type !== "decl" && (r = n.raws.between, typeof r < "u"))
        return !1;
    }), r;
  }
  rawBeforeRule(t) {
    let r;
    return t.walk((n) => {
      if (n.nodes && (n.parent !== t || t.first !== n) && typeof n.raws.before < "u")
        return r = n.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), r && (r = r.replace(/\S/g, "")), r;
  }
  rawColon(t) {
    let r;
    return t.walkDecls((n) => {
      if (typeof n.raws.between < "u")
        return r = n.raws.between.replace(/[^\s:]/g, ""), !1;
    }), r;
  }
  rawEmptyBody(t) {
    let r;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length === 0 && (r = n.raws.after, typeof r < "u"))
        return !1;
    }), r;
  }
  rawIndent(t) {
    if (t.raws.indent) return t.raws.indent;
    let r;
    return t.walk((n) => {
      let i = n.parent;
      if (i && i !== t && i.parent && i.parent === t && typeof n.raws.before < "u") {
        let o = n.raws.before.split(`
`);
        return r = o[o.length - 1], r = r.replace(/\S/g, ""), !1;
      }
    }), r;
  }
  rawSemicolon(t) {
    let r;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length && n.last.type === "decl" && (r = n.raws.semicolon, typeof r < "u"))
        return !1;
    }), r;
  }
  rawValue(t, r) {
    let n = t[r], i = t.raws[r];
    return i && i.value === n ? i.raw : n;
  }
  root(t) {
    this.body(t), t.raws.after && this.builder(t.raws.after);
  }
  rule(t) {
    this.block(t, this.rawValue(t, "selector")), t.raws.ownSemicolon && this.builder(t.raws.ownSemicolon, t, "end");
  }
  stringify(t, r) {
    if (!this[t.type])
      throw new Error(
        "Unknown AST node type " + t.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[t.type](t, r);
  }
};
var hye = IB;
IB.default = IB;
let _ur = hye;
function OB(e, t) {
  new _ur(t).stringify(e);
}
var B3 = OB;
OB.default = OB;
var xy = {};
xy.isClean = Symbol("isClean");
xy.my = Symbol("my");
let Aur = M7, Sur = hye, bur = B3, { isClean: Uv, my: Cur } = xy;
function RB(e, t) {
  let r = new e.constructor();
  for (let n in e) {
    if (!Object.prototype.hasOwnProperty.call(e, n) || n === "proxyCache") continue;
    let i = e[n], o = typeof i;
    n === "parent" && o === "object" ? t && (r[n] = t) : n === "source" ? r[n] = i : Array.isArray(i) ? r[n] = i.map((a) => RB(a, r)) : (o === "object" && i !== null && (i = RB(i)), r[n] = i);
  }
  return r;
}
let wB = class {
  constructor(t = {}) {
    this.raws = {}, this[Uv] = !1, this[Cur] = !0;
    for (let r in t)
      if (r === "nodes") {
        this.nodes = [];
        for (let n of t[r])
          typeof n.clone == "function" ? this.append(n.clone()) : this.append(n);
      } else
        this[r] = t[r];
  }
  addToError(t) {
    if (t.postcssNode = this, t.stack && this.source && /\n\s{4}at /.test(t.stack)) {
      let r = this.source;
      t.stack = t.stack.replace(
        /\n\s{4}at /,
        `$&${r.input.from}:${r.start.line}:${r.start.column}$&`
      );
    }
    return t;
  }
  after(t) {
    return this.parent.insertAfter(this, t), this;
  }
  assign(t = {}) {
    for (let r in t)
      this[r] = t[r];
    return this;
  }
  before(t) {
    return this.parent.insertBefore(this, t), this;
  }
  cleanRaws(t) {
    delete this.raws.before, delete this.raws.after, t || delete this.raws.between;
  }
  clone(t = {}) {
    let r = RB(this);
    for (let n in t)
      r[n] = t[n];
    return r;
  }
  cloneAfter(t = {}) {
    let r = this.clone(t);
    return this.parent.insertAfter(this, r), r;
  }
  cloneBefore(t = {}) {
    let r = this.clone(t);
    return this.parent.insertBefore(this, r), r;
  }
  error(t, r = {}) {
    if (this.source) {
      let { end: n, start: i } = this.rangeBy(r);
      return this.source.input.error(
        t,
        { column: i.column, line: i.line },
        { column: n.column, line: n.line },
        r
      );
    }
    return new Aur(t);
  }
  getProxyProcessor() {
    return {
      get(t, r) {
        return r === "proxyOf" ? t : r === "root" ? () => t.root().toProxy() : t[r];
      },
      set(t, r, n) {
        return t[r] === n || (t[r] = n, (r === "prop" || r === "value" || r === "name" || r === "params" || r === "important" || /* c8 ignore next */
        r === "text") && t.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Uv] = !0;
  }
  markDirty() {
    if (this[Uv]) {
      this[Uv] = !1;
      let t = this;
      for (; t = t.parent; )
        t[Uv] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let t = this.parent.index(this);
    return this.parent.nodes[t + 1];
  }
  positionBy(t, r) {
    let n = this.source.start;
    if (t.index)
      n = this.positionInside(t.index, r);
    else if (t.word) {
      r = this.toString();
      let i = r.indexOf(t.word);
      i !== -1 && (n = this.positionInside(i, r));
    }
    return n;
  }
  positionInside(t, r) {
    let n = r || this.toString(), i = this.source.start.column, o = this.source.start.line;
    for (let a = 0; a < t; a++)
      n[a] === `
` ? (i = 1, o += 1) : i += 1;
    return { column: i, line: o };
  }
  prev() {
    if (!this.parent) return;
    let t = this.parent.index(this);
    return this.parent.nodes[t - 1];
  }
  rangeBy(t) {
    let r = {
      column: this.source.start.column,
      line: this.source.start.line
    }, n = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: r.column + 1,
      line: r.line
    };
    if (t.word) {
      let i = this.toString(), o = i.indexOf(t.word);
      o !== -1 && (r = this.positionInside(o, i), n = this.positionInside(
        o + t.word.length,
        i
      ));
    } else
      t.start ? r = {
        column: t.start.column,
        line: t.start.line
      } : t.index && (r = this.positionInside(t.index)), t.end ? n = {
        column: t.end.column,
        line: t.end.line
      } : typeof t.endIndex == "number" ? n = this.positionInside(t.endIndex) : t.index && (n = this.positionInside(t.index + 1));
    return (n.line < r.line || n.line === r.line && n.column <= r.column) && (n = { column: r.column + 1, line: r.line }), { end: n, start: r };
  }
  raw(t, r) {
    return new Sur().raw(this, t, r);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...t) {
    if (this.parent) {
      let r = this, n = !1;
      for (let i of t)
        i === this ? n = !0 : n ? (this.parent.insertAfter(r, i), r = i) : this.parent.insertBefore(r, i);
      n || this.remove();
    }
    return this;
  }
  root() {
    let t = this;
    for (; t.parent && t.parent.type !== "document"; )
      t = t.parent;
    return t;
  }
  toJSON(t, r) {
    let n = {}, i = r == null;
    r = r || /* @__PURE__ */ new Map();
    let o = 0;
    for (let a in this) {
      if (!Object.prototype.hasOwnProperty.call(this, a) || a === "parent" || a === "proxyCache") continue;
      let u = this[a];
      if (Array.isArray(u))
        n[a] = u.map((s) => typeof s == "object" && s.toJSON ? s.toJSON(null, r) : s);
      else if (typeof u == "object" && u.toJSON)
        n[a] = u.toJSON(null, r);
      else if (a === "source") {
        let s = r.get(u.input);
        s == null && (s = o, r.set(u.input, o), o++), n[a] = {
          end: u.end,
          inputId: s,
          start: u.start
        };
      } else
        n[a] = u;
    }
    return i && (n.inputs = [...r.keys()].map((a) => a.toJSON())), n;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(t = bur) {
    t.stringify && (t = t.stringify);
    let r = "";
    return t(this, (n) => {
      r += n;
    }), r;
  }
  warn(t, r, n) {
    let i = { node: this };
    for (let o in n) i[o] = n[o];
    return t.warn(r, i);
  }
  get proxyOf() {
    return this;
  }
};
var k3 = wB;
wB.default = wB;
let Iur = k3, PB = class extends Iur {
  constructor(t) {
    super(t), this.type = "comment";
  }
};
var M3 = PB;
PB.default = PB;
let Our = k3, DB = class extends Our {
  constructor(t) {
    t && typeof t.value < "u" && typeof t.value != "string" && (t = { ...t, value: String(t.value) }), super(t), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
};
var F3 = DB;
DB.default = DB;
let vye = M3, Eye = F3, Rur = k3, { isClean: mye, my: gye } = xy, F7, Tye, yye, H7;
function _ye(e) {
  return e.map((t) => (t.nodes && (t.nodes = _ye(t.nodes)), delete t.source, t));
}
function Aye(e) {
  if (e[mye] = !1, e.proxyOf.nodes)
    for (let t of e.proxyOf.nodes)
      Aye(t);
}
let Zc = class Sye extends Rur {
  append(...t) {
    for (let r of t) {
      let n = this.normalize(r, this.last);
      for (let i of n) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(t) {
    if (super.cleanRaws(t), this.nodes)
      for (let r of this.nodes) r.cleanRaws(t);
  }
  each(t) {
    if (!this.proxyOf.nodes) return;
    let r = this.getIterator(), n, i;
    for (; this.indexes[r] < this.proxyOf.nodes.length && (n = this.indexes[r], i = t(this.proxyOf.nodes[n], n), i !== !1); )
      this.indexes[r] += 1;
    return delete this.indexes[r], i;
  }
  every(t) {
    return this.nodes.every(t);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let t = this.lastEach;
    return this.indexes[t] = 0, t;
  }
  getProxyProcessor() {
    return {
      get(t, r) {
        return r === "proxyOf" ? t : t[r] ? r === "each" || typeof r == "string" && r.startsWith("walk") ? (...n) => t[r](
          ...n.map((i) => typeof i == "function" ? (o, a) => i(o.toProxy(), a) : i)
        ) : r === "every" || r === "some" ? (n) => t[r](
          (i, ...o) => n(i.toProxy(), ...o)
        ) : r === "root" ? () => t.root().toProxy() : r === "nodes" ? t.nodes.map((n) => n.toProxy()) : r === "first" || r === "last" ? t[r].toProxy() : t[r] : t[r];
      },
      set(t, r, n) {
        return t[r] === n || (t[r] = n, (r === "name" || r === "params" || r === "selector") && t.markDirty()), !0;
      }
    };
  }
  index(t) {
    return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
  }
  insertAfter(t, r) {
    let n = this.index(t), i = this.normalize(r, this.proxyOf.nodes[n]).reverse();
    n = this.index(t);
    for (let a of i) this.proxyOf.nodes.splice(n + 1, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], n < o && (this.indexes[a] = o + i.length);
    return this.markDirty(), this;
  }
  insertBefore(t, r) {
    let n = this.index(t), i = n === 0 ? "prepend" : !1, o = this.normalize(
      r,
      this.proxyOf.nodes[n],
      i
    ).reverse();
    n = this.index(t);
    for (let u of o) this.proxyOf.nodes.splice(n, 0, u);
    let a;
    for (let u in this.indexes)
      a = this.indexes[u], n <= a && (this.indexes[u] = a + o.length);
    return this.markDirty(), this;
  }
  normalize(t, r) {
    if (typeof t == "string")
      t = _ye(Tye(t).nodes);
    else if (typeof t > "u")
      t = [];
    else if (Array.isArray(t)) {
      t = t.slice(0);
      for (let i of t)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (t.type === "root" && this.type !== "document") {
      t = t.nodes.slice(0);
      for (let i of t)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (t.type)
      t = [t];
    else if (t.prop) {
      if (typeof t.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof t.value != "string" && (t.value = String(t.value)), t = [new Eye(t)];
    } else if (t.selector || t.selectors)
      t = [new H7(t)];
    else if (t.name)
      t = [new F7(t)];
    else if (t.text)
      t = [new vye(t)];
    else
      throw new Error("Unknown node type in node creation");
    return t.map((i) => (i[gye] || Sye.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[mye] && Aye(i), i.raws || (i.raws = {}), typeof i.raws.before > "u" && r && typeof r.raws.before < "u" && (i.raws.before = r.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...t) {
    t = t.reverse();
    for (let r of t) {
      let n = this.normalize(r, this.first, "prepend").reverse();
      for (let i of n) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + n.length;
    }
    return this.markDirty(), this;
  }
  push(t) {
    return t.parent = this, this.proxyOf.nodes.push(t), this;
  }
  removeAll() {
    for (let t of this.proxyOf.nodes) t.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(t) {
    t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
    let r;
    for (let n in this.indexes)
      r = this.indexes[n], r >= t && (this.indexes[n] = r - 1);
    return this.markDirty(), this;
  }
  replaceValues(t, r, n) {
    return n || (n = r, r = {}), this.walkDecls((i) => {
      r.props && !r.props.includes(i.prop) || r.fast && !i.value.includes(r.fast) || (i.value = i.value.replace(t, n));
    }), this.markDirty(), this;
  }
  some(t) {
    return this.nodes.some(t);
  }
  walk(t) {
    return this.each((r, n) => {
      let i;
      try {
        i = t(r, n);
      } catch (o) {
        throw r.addToError(o);
      }
      return i !== !1 && r.walk && (i = r.walk(t)), i;
    });
  }
  walkAtRules(t, r) {
    return r ? t instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "atrule" && t.test(n.name))
        return r(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "atrule" && n.name === t)
        return r(n, i);
    }) : (r = t, this.walk((n, i) => {
      if (n.type === "atrule")
        return r(n, i);
    }));
  }
  walkComments(t) {
    return this.walk((r, n) => {
      if (r.type === "comment")
        return t(r, n);
    });
  }
  walkDecls(t, r) {
    return r ? t instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "decl" && t.test(n.prop))
        return r(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "decl" && n.prop === t)
        return r(n, i);
    }) : (r = t, this.walk((n, i) => {
      if (n.type === "decl")
        return r(n, i);
    }));
  }
  walkRules(t, r) {
    return r ? t instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "rule" && t.test(n.selector))
        return r(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "rule" && n.selector === t)
        return r(n, i);
    }) : (r = t, this.walk((n, i) => {
      if (n.type === "rule")
        return r(n, i);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
};
Zc.registerParse = (e) => {
  Tye = e;
};
Zc.registerRule = (e) => {
  H7 = e;
};
Zc.registerAtRule = (e) => {
  F7 = e;
};
Zc.registerRoot = (e) => {
  yye = e;
};
var vd = Zc;
Zc.default = Zc;
Zc.rebuild = (e) => {
  e.type === "atrule" ? Object.setPrototypeOf(e, F7.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, H7.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, Eye.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, vye.prototype) : e.type === "root" && Object.setPrototypeOf(e, yye.prototype), e[gye] = !0, e.nodes && e.nodes.forEach((t) => {
    Zc.rebuild(t);
  });
};
let bye = vd, qS = class extends bye {
  constructor(t) {
    super(t), this.type = "atrule";
  }
  append(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...t);
  }
  prepend(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...t);
  }
};
var $7 = qS;
qS.default = qS;
bye.registerAtRule(qS);
let wur = vd, Cye, Iye, tT = class extends wur {
  constructor(t) {
    super({ type: "document", ...t }), this.nodes || (this.nodes = []);
  }
  toResult(t = {}) {
    return new Cye(new Iye(), this, t).stringify();
  }
};
tT.registerLazyResult = (e) => {
  Cye = e;
};
tT.registerProcessor = (e) => {
  Iye = e;
};
var U7 = tT;
tT.default = tT;
let Pur = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Dur = (e, t = 21) => (r = t) => {
  let n = "", i = r;
  for (; i--; )
    n += e[Math.random() * e.length | 0];
  return n;
}, xur = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += Pur[Math.random() * 64 | 0];
  return t;
};
var Nur = { nanoid: xur, customAlphabet: Dur };
let { existsSync: Lur, readFileSync: Bur } = ki, { dirname: ex, join: kur } = ki, { SourceMapConsumer: Mee, SourceMapGenerator: Fee } = ki;
function Mur(e) {
  return Buffer ? Buffer.from(e, "base64").toString() : window.atob(e);
}
let xB = class {
  constructor(t, r) {
    if (r.map === !1) return;
    this.loadAnnotation(t), this.inline = this.startWith(this.annotation, "data:");
    let n = r.map ? r.map.prev : void 0, i = this.loadMap(r.from, n);
    !this.mapFile && r.from && (this.mapFile = r.from), this.mapFile && (this.root = ex(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new Mee(this.text)), this.consumerCache;
  }
  decodeInline(t) {
    let r = /^data:application\/json;charset=utf-?8;base64,/, n = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, o = /^data:application\/json,/, a = t.match(i) || t.match(o);
    if (a)
      return decodeURIComponent(t.substr(a[0].length));
    let u = t.match(r) || t.match(n);
    if (u)
      return Mur(t.substr(u[0].length));
    let s = t.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + s);
  }
  getAnnotationURL(t) {
    return t.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(t) {
    return typeof t != "object" ? !1 : typeof t.mappings == "string" || typeof t._mappings == "string" || Array.isArray(t.sections);
  }
  loadAnnotation(t) {
    let r = t.match(/\/\*\s*# sourceMappingURL=/g);
    if (!r) return;
    let n = t.lastIndexOf(r.pop()), i = t.indexOf("*/", n);
    n > -1 && i > -1 && (this.annotation = this.getAnnotationURL(t.substring(n, i)));
  }
  loadFile(t) {
    if (this.root = ex(t), Lur(t))
      return this.mapFile = t, Bur(t, "utf-8").toString().trim();
  }
  loadMap(t, r) {
    if (r === !1) return !1;
    if (r) {
      if (typeof r == "string")
        return r;
      if (typeof r == "function") {
        let n = r(t);
        if (n) {
          let i = this.loadFile(n);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + n.toString()
            );
          return i;
        }
      } else {
        if (r instanceof Mee)
          return Fee.fromSourceMap(r).toString();
        if (r instanceof Fee)
          return r.toString();
        if (this.isMap(r))
          return JSON.stringify(r);
        throw new Error(
          "Unsupported previous source map format: " + r.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let n = this.annotation;
        return t && (n = kur(ex(t), n)), this.loadFile(n);
      }
    }
  }
  startWith(t, r) {
    return t ? t.substr(0, r.length) === r : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Oye = xB;
xB.default = xB;
let { nanoid: Fur } = Nur, { isAbsolute: NB, resolve: LB } = ki, { SourceMapConsumer: Hur, SourceMapGenerator: $ur } = ki, { fileURLToPath: Hee, pathToFileURL: gA } = ki, $ee = M7, Uur = Oye, tx = ki, rx = Symbol("fromOffsetCache"), Vur = !!(Hur && $ur), Uee = !!(LB && NB), YS = class {
  constructor(t, r = {}) {
    if (t === null || typeof t > "u" || typeof t == "object" && !t.toString)
      throw new Error(`PostCSS received ${t} instead of CSS string`);
    if (this.css = t.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, r.from && (!Uee || /^\w+:\/\//.test(r.from) || NB(r.from) ? this.file = r.from : this.file = LB(r.from)), Uee && Vur) {
      let n = new Uur(this.css, r);
      if (n.text) {
        this.map = n;
        let i = n.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + Fur(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(t, r, n, i = {}) {
    let o, a, u;
    if (r && typeof r == "object") {
      let c = r, l = n;
      if (typeof c.offset == "number") {
        let f = this.fromOffset(c.offset);
        r = f.line, n = f.col;
      } else
        r = c.line, n = c.column;
      if (typeof l.offset == "number") {
        let f = this.fromOffset(l.offset);
        a = f.line, o = f.col;
      } else
        a = l.line, o = l.column;
    } else if (!n) {
      let c = this.fromOffset(r);
      r = c.line, n = c.col;
    }
    let s = this.origin(r, n, a, o);
    return s ? u = new $ee(
      t,
      s.endLine === void 0 ? s.line : { column: s.column, line: s.line },
      s.endLine === void 0 ? s.column : { column: s.endColumn, line: s.endLine },
      s.source,
      s.file,
      i.plugin
    ) : u = new $ee(
      t,
      a === void 0 ? r : { column: n, line: r },
      a === void 0 ? n : { column: o, line: a },
      this.css,
      this.file,
      i.plugin
    ), u.input = { column: n, endColumn: o, endLine: a, line: r, source: this.css }, this.file && (gA && (u.input.url = gA(this.file).toString()), u.input.file = this.file), u;
  }
  fromOffset(t) {
    let r, n;
    if (this[rx])
      n = this[rx];
    else {
      let o = this.css.split(`
`);
      n = new Array(o.length);
      let a = 0;
      for (let u = 0, s = o.length; u < s; u++)
        n[u] = a, a += o[u].length + 1;
      this[rx] = n;
    }
    r = n[n.length - 1];
    let i = 0;
    if (t >= r)
      i = n.length - 1;
    else {
      let o = n.length - 2, a;
      for (; i < o; )
        if (a = i + (o - i >> 1), t < n[a])
          o = a - 1;
        else if (t >= n[a + 1])
          i = a + 1;
        else {
          i = a;
          break;
        }
    }
    return {
      col: t - n[i] + 1,
      line: i + 1
    };
  }
  mapResolve(t) {
    return /^\w+:\/\//.test(t) ? t : LB(this.map.consumer().sourceRoot || this.map.root || ".", t);
  }
  origin(t, r, n, i) {
    if (!this.map) return !1;
    let o = this.map.consumer(), a = o.originalPositionFor({ column: r, line: t });
    if (!a.source) return !1;
    let u;
    typeof n == "number" && (u = o.originalPositionFor({ column: i, line: n }));
    let s;
    NB(a.source) ? s = gA(a.source) : s = new URL(
      a.source,
      this.map.consumer().sourceRoot || gA(this.map.mapFile)
    );
    let c = {
      column: a.column,
      endColumn: u && u.column,
      endLine: u && u.line,
      line: a.line,
      url: s.toString()
    };
    if (s.protocol === "file:")
      if (Hee)
        c.file = Hee(s);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let l = o.sourceContentFor(a.source);
    return l && (c.source = l), c;
  }
  toJSON() {
    let t = {};
    for (let r of ["hasBOM", "css", "file", "id"])
      this[r] != null && (t[r] = this[r]);
    return this.map && (t.map = { ...this.map }, t.map.consumerCache && (t.map.consumerCache = void 0)), t;
  }
  get from() {
    return this.file || this.id;
  }
};
var H3 = YS;
YS.default = YS;
tx && tx.registerInput && tx.registerInput(YS);
let Rye = vd, wye, Pye, Qp = class extends Rye {
  constructor(t) {
    super(t), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(t, r, n) {
    let i = super.normalize(t);
    if (r) {
      if (n === "prepend")
        this.nodes.length > 1 ? r.raws.before = this.nodes[1].raws.before : delete r.raws.before;
      else if (this.first !== r)
        for (let o of i)
          o.raws.before = r.raws.before;
    }
    return i;
  }
  removeChild(t, r) {
    let n = this.index(t);
    return !r && n === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n].raws.before), super.removeChild(t);
  }
  toResult(t = {}) {
    return new wye(new Pye(), this, t).stringify();
  }
};
Qp.registerLazyResult = (e) => {
  wye = e;
};
Qp.registerProcessor = (e) => {
  Pye = e;
};
var Ny = Qp;
Qp.default = Qp;
Rye.registerRoot(Qp);
let rT = {
  comma(e) {
    return rT.split(e, [","], !0);
  },
  space(e) {
    let t = [" ", `
`, "	"];
    return rT.split(e, t);
  },
  split(e, t, r) {
    let n = [], i = "", o = !1, a = 0, u = !1, s = "", c = !1;
    for (let l of e)
      c ? c = !1 : l === "\\" ? c = !0 : u ? l === s && (u = !1) : l === '"' || l === "'" ? (u = !0, s = l) : l === "(" ? a += 1 : l === ")" ? a > 0 && (a -= 1) : a === 0 && t.includes(l) && (o = !0), o ? (i !== "" && n.push(i.trim()), i = "", o = !1) : i += l;
    return (r || i !== "") && n.push(i.trim()), n;
  }
};
var Dye = rT;
rT.default = rT;
let xye = vd, jur = Dye, GS = class extends xye {
  constructor(t) {
    super(t), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return jur.comma(this.selector);
  }
  set selectors(t) {
    let r = this.selector ? this.selector.match(/,\s*/) : null, n = r ? r[0] : "," + this.raw("between", "beforeOpen");
    this.selector = t.join(n);
  }
};
var V7 = GS;
GS.default = GS;
xye.registerRule(GS);
let zur = $7, qur = M3, Yur = F3, Gur = H3, Wur = Oye, Kur = Ny, Xur = V7;
function nT(e, t) {
  if (Array.isArray(e)) return e.map((i) => nT(i));
  let { inputs: r, ...n } = e;
  if (r) {
    t = [];
    for (let i of r) {
      let o = { ...i, __proto__: Gur.prototype };
      o.map && (o.map = {
        ...o.map,
        __proto__: Wur.prototype
      }), t.push(o);
    }
  }
  if (n.nodes && (n.nodes = e.nodes.map((i) => nT(i, t))), n.source) {
    let { inputId: i, ...o } = n.source;
    n.source = o, i != null && (n.source.input = t[i]);
  }
  if (n.type === "root")
    return new Kur(n);
  if (n.type === "decl")
    return new Yur(n);
  if (n.type === "rule")
    return new Xur(n);
  if (n.type === "comment")
    return new qur(n);
  if (n.type === "atrule")
    return new zur(n);
  throw new Error("Unknown node type: " + e.type);
}
var Jur = nT;
nT.default = nT;
let { dirname: V4, relative: Nye, resolve: Lye, sep: Bye } = ki, { SourceMapConsumer: kye, SourceMapGenerator: j4 } = ki, { pathToFileURL: Vee } = ki, Zur = H3, Qur = !!(kye && j4), esr = !!(V4 && Lye && Nye && Bye), tsr = class {
  constructor(t, r, n, i) {
    this.stringify = t, this.mapOpts = n.map || {}, this.root = r, this.opts = n, this.css = i, this.originalCSS = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let t;
    this.isInline() ? t = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? t = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? t = this.mapOpts.annotation(this.opts.to, this.root) : t = this.outputFile() + ".map";
    let r = `
`;
    this.css.includes(`\r
`) && (r = `\r
`), this.css += r + "/*# sourceMappingURL=" + t + " */";
  }
  applyPrevMaps() {
    for (let t of this.previous()) {
      let r = this.toUrl(this.path(t.file)), n = t.root || V4(t.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new kye(t.text), i.sourcesContent && (i.sourcesContent = null)) : i = t.consumer(), this.map.applySourceMap(i, r, this.toUrl(this.path(n)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let t;
        for (let r = this.root.nodes.length - 1; r >= 0; r--)
          t = this.root.nodes[r], t.type === "comment" && t.text.startsWith("# sourceMappingURL=") && this.root.removeChild(r);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), esr && Qur && this.isMap())
      return this.generateMap();
    {
      let t = "";
      return this.stringify(this.root, (r) => {
        t += r;
      }), [t];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let t = this.previous()[0].consumer();
      t.file = this.outputFile(), this.map = j4.fromSourceMap(t, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new j4({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new j4({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let t = 1, r = 1, n = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, o, a;
    this.stringify(this.root, (u, s, c) => {
      if (this.css += u, s && c !== "end" && (i.generated.line = t, i.generated.column = r - 1, s.source && s.source.start ? (i.source = this.sourcePath(s), i.original.line = s.source.start.line, i.original.column = s.source.start.column - 1, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), a = u.match(/\n/g), a ? (t += a.length, o = u.lastIndexOf(`
`), r = u.length - o) : r += u.length, s && c !== "start") {
        let l = s.parent || { raws: {} };
        (!(s.type === "decl" || s.type === "atrule" && !s.nodes) || s !== l.last || l.raws.semicolon) && (s.source && s.source.end ? (i.source = this.sourcePath(s), i.original.line = s.source.end.line, i.original.column = s.source.end.column - 1, i.generated.line = t, i.generated.column = r - 2, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, i.generated.line = t, i.generated.column = r - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((t) => t.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let t = this.mapOpts.annotation;
    return typeof t < "u" && t !== !0 ? !1 : this.previous().length ? this.previous().some((r) => r.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((t) => t.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(t) {
    if (this.mapOpts.absolute || t.charCodeAt(0) === 60 || /^\w+:\/\//.test(t)) return t;
    let r = this.memoizedPaths.get(t);
    if (r) return r;
    let n = this.opts.to ? V4(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (n = V4(Lye(n, this.mapOpts.annotation)));
    let i = Nye(n, t);
    return this.memoizedPaths.set(t, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((t) => {
          if (t.source && t.source.input.map) {
            let r = t.source.input.map;
            this.previousMaps.includes(r) || this.previousMaps.push(r);
          }
        });
      else {
        let t = new Zur(this.originalCSS, this.opts);
        t.map && this.previousMaps.push(t.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let t = {};
    if (this.root)
      this.root.walk((r) => {
        if (r.source) {
          let n = r.source.input.from;
          if (n && !t[n]) {
            t[n] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(n) : this.toUrl(this.path(n));
            this.map.setSourceContent(i, r.source.input.css);
          }
        }
      });
    else if (this.css) {
      let r = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(r, this.css);
    }
  }
  sourcePath(t) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(t.source.input.from) : this.toUrl(this.path(t.source.input.from));
  }
  toBase64(t) {
    return Buffer ? Buffer.from(t).toString("base64") : window.btoa(unescape(encodeURIComponent(t)));
  }
  toFileUrl(t) {
    let r = this.memoizedFileURLs.get(t);
    if (r) return r;
    if (Vee) {
      let n = Vee(t).toString();
      return this.memoizedFileURLs.set(t, n), n;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(t) {
    let r = this.memoizedURLs.get(t);
    if (r) return r;
    Bye === "\\" && (t = t.replace(/\\/g, "/"));
    let n = encodeURI(t).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(t, n), n;
  }
};
var Mye = tsr;
const nx = 39, jee = 34, TA = 92, zee = 47, yA = 10, Vv = 32, _A = 12, AA = 9, SA = 13, rsr = 91, nsr = 93, isr = 40, osr = 41, asr = 123, usr = 125, ssr = 59, csr = 42, lsr = 58, fsr = 64, bA = /[\t\n\f\r "#'()/;[\\\]{}]/g, CA = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, dsr = /.[\r\n"'(/\\]/, qee = /[\da-f]/i;
var psr = function(t, r = {}) {
  let n = t.css.valueOf(), i = r.ignoreErrors, o, a, u, s, c, l, f, d, p, v, h = n.length, E = 0, m = [], g = [];
  function y() {
    return E;
  }
  function _(P) {
    throw t.error("Unclosed " + P, E);
  }
  function S() {
    return g.length === 0 && E >= h;
  }
  function A(P) {
    if (g.length) return g.pop();
    if (E >= h) return;
    let U = P ? P.ignoreUnclosed : !1;
    switch (o = n.charCodeAt(E), o) {
      case yA:
      case Vv:
      case AA:
      case SA:
      case _A: {
        s = E;
        do
          s += 1, o = n.charCodeAt(s);
        while (o === Vv || o === yA || o === AA || o === SA || o === _A);
        l = ["space", n.slice(E, s)], E = s - 1;
        break;
      }
      case rsr:
      case nsr:
      case asr:
      case usr:
      case lsr:
      case ssr:
      case osr: {
        let z = String.fromCharCode(o);
        l = [z, z, E];
        break;
      }
      case isr: {
        if (v = m.length ? m.pop()[1] : "", p = n.charCodeAt(E + 1), v === "url" && p !== nx && p !== jee && p !== Vv && p !== yA && p !== AA && p !== _A && p !== SA) {
          s = E;
          do {
            if (f = !1, s = n.indexOf(")", s + 1), s === -1)
              if (i || U) {
                s = E;
                break;
              } else
                _("bracket");
            for (d = s; n.charCodeAt(d - 1) === TA; )
              d -= 1, f = !f;
          } while (f);
          l = ["brackets", n.slice(E, s + 1), E, s], E = s;
        } else
          s = n.indexOf(")", E + 1), a = n.slice(E, s + 1), s === -1 || dsr.test(a) ? l = ["(", "(", E] : (l = ["brackets", a, E, s], E = s);
        break;
      }
      case nx:
      case jee: {
        c = o === nx ? "'" : '"', s = E;
        do {
          if (f = !1, s = n.indexOf(c, s + 1), s === -1)
            if (i || U) {
              s = E + 1;
              break;
            } else
              _("string");
          for (d = s; n.charCodeAt(d - 1) === TA; )
            d -= 1, f = !f;
        } while (f);
        l = ["string", n.slice(E, s + 1), E, s], E = s;
        break;
      }
      case fsr: {
        bA.lastIndex = E + 1, bA.test(n), bA.lastIndex === 0 ? s = n.length - 1 : s = bA.lastIndex - 2, l = ["at-word", n.slice(E, s + 1), E, s], E = s;
        break;
      }
      case TA: {
        for (s = E, u = !0; n.charCodeAt(s + 1) === TA; )
          s += 1, u = !u;
        if (o = n.charCodeAt(s + 1), u && o !== zee && o !== Vv && o !== yA && o !== AA && o !== SA && o !== _A && (s += 1, qee.test(n.charAt(s)))) {
          for (; qee.test(n.charAt(s + 1)); )
            s += 1;
          n.charCodeAt(s + 1) === Vv && (s += 1);
        }
        l = ["word", n.slice(E, s + 1), E, s], E = s;
        break;
      }
      default: {
        o === zee && n.charCodeAt(E + 1) === csr ? (s = n.indexOf("*/", E + 2) + 1, s === 0 && (i || U ? s = n.length : _("comment")), l = ["comment", n.slice(E, s + 1), E, s], E = s) : (CA.lastIndex = E + 1, CA.test(n), CA.lastIndex === 0 ? s = n.length - 1 : s = CA.lastIndex - 2, l = ["word", n.slice(E, s + 1), E, s], m.push(l), E = s);
        break;
      }
    }
    return E++, l;
  }
  function O(P) {
    g.push(P);
  }
  return {
    back: O,
    endOfFile: S,
    nextToken: A,
    position: y
  };
};
let hsr = $7, vsr = M3, Esr = F3, msr = Ny, Yee = V7, gsr = psr;
const Gee = {
  empty: !0,
  space: !0
};
function Tsr(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let r = e[t], n = r[3] || r[2];
    if (n) return n;
  }
}
let ysr = class {
  constructor(t) {
    this.input = t, this.root = new msr(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: t, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(t) {
    let r = new hsr();
    r.name = t[1].slice(1), r.name === "" && this.unnamedAtrule(r, t), this.init(r, t[2]);
    let n, i, o, a = !1, u = !1, s = [], c = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (t = this.tokenizer.nextToken(), n = t[0], n === "(" || n === "[" ? c.push(n === "(" ? ")" : "]") : n === "{" && c.length > 0 ? c.push("}") : n === c[c.length - 1] && c.pop(), c.length === 0)
        if (n === ";") {
          r.source.end = this.getPosition(t[2]), r.source.end.offset++, this.semicolon = !0;
          break;
        } else if (n === "{") {
          u = !0;
          break;
        } else if (n === "}") {
          if (s.length > 0) {
            for (o = s.length - 1, i = s[o]; i && i[0] === "space"; )
              i = s[--o];
            i && (r.source.end = this.getPosition(i[3] || i[2]), r.source.end.offset++);
          }
          this.end(t);
          break;
        } else
          s.push(t);
      else
        s.push(t);
      if (this.tokenizer.endOfFile()) {
        a = !0;
        break;
      }
    }
    r.raws.between = this.spacesAndCommentsFromEnd(s), s.length ? (r.raws.afterName = this.spacesAndCommentsFromStart(s), this.raw(r, "params", s), a && (t = s[s.length - 1], r.source.end = this.getPosition(t[3] || t[2]), r.source.end.offset++, this.spaces = r.raws.between, r.raws.between = "")) : (r.raws.afterName = "", r.params = ""), u && (r.nodes = [], this.current = r);
  }
  checkMissedSemicolon(t) {
    let r = this.colon(t);
    if (r === !1) return;
    let n = 0, i;
    for (let o = r - 1; o >= 0 && (i = t[o], !(i[0] !== "space" && (n += 1, n === 2))); o--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(t) {
    let r = 0, n, i, o;
    for (let [a, u] of t.entries()) {
      if (i = u, o = i[0], o === "(" && (r += 1), o === ")" && (r -= 1), r === 0 && o === ":")
        if (!n)
          this.doubleColon(i);
        else {
          if (n[0] === "word" && n[1] === "progid")
            continue;
          return a;
        }
      n = i;
    }
    return !1;
  }
  comment(t) {
    let r = new vsr();
    this.init(r, t[2]), r.source.end = this.getPosition(t[3] || t[2]), r.source.end.offset++;
    let n = t[1].slice(2, -2);
    if (/^\s*$/.test(n))
      r.text = "", r.raws.left = n, r.raws.right = "";
    else {
      let i = n.match(/^(\s*)([^]*\S)(\s*)$/);
      r.text = i[2], r.raws.left = i[1], r.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = gsr(this.input);
  }
  decl(t, r) {
    let n = new Esr();
    this.init(n, t[0][2]);
    let i = t[t.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, t.pop()), n.source.end = this.getPosition(
      i[3] || i[2] || Tsr(t)
    ), n.source.end.offset++; t[0][0] !== "word"; )
      t.length === 1 && this.unknownWord(t), n.raws.before += t.shift()[1];
    for (n.source.start = this.getPosition(t[0][2]), n.prop = ""; t.length; ) {
      let c = t[0][0];
      if (c === ":" || c === "space" || c === "comment")
        break;
      n.prop += t.shift()[1];
    }
    n.raws.between = "";
    let o;
    for (; t.length; )
      if (o = t.shift(), o[0] === ":") {
        n.raws.between += o[1];
        break;
      } else
        o[0] === "word" && /\w/.test(o[1]) && this.unknownWord([o]), n.raws.between += o[1];
    (n.prop[0] === "_" || n.prop[0] === "*") && (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
    let a = [], u;
    for (; t.length && (u = t[0][0], !(u !== "space" && u !== "comment")); )
      a.push(t.shift());
    this.precheckMissedSemicolon(t);
    for (let c = t.length - 1; c >= 0; c--) {
      if (o = t[c], o[1].toLowerCase() === "!important") {
        n.important = !0;
        let l = this.stringFrom(t, c);
        l = this.spacesFromEnd(t) + l, l !== " !important" && (n.raws.important = l);
        break;
      } else if (o[1].toLowerCase() === "important") {
        let l = t.slice(0), f = "";
        for (let d = c; d > 0; d--) {
          let p = l[d][0];
          if (f.trim().startsWith("!") && p !== "space")
            break;
          f = l.pop()[1] + f;
        }
        f.trim().startsWith("!") && (n.important = !0, n.raws.important = f, t = l);
      }
      if (o[0] !== "space" && o[0] !== "comment")
        break;
    }
    t.some((c) => c[0] !== "space" && c[0] !== "comment") && (n.raws.between += a.map((c) => c[1]).join(""), a = []), this.raw(n, "value", a.concat(t), r), n.value.includes(":") && !r && this.checkMissedSemicolon(t);
  }
  doubleColon(t) {
    throw this.input.error(
      "Double colon",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
  emptyRule(t) {
    let r = new Yee();
    this.init(r, t[2]), r.selector = "", r.raws.between = "", this.current = r;
  }
  end(t) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(t) {
    if (this.spaces += t[1], this.current.nodes) {
      let r = this.current.nodes[this.current.nodes.length - 1];
      r && r.type === "rule" && !r.raws.ownSemicolon && (r.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(t) {
    let r = this.input.fromOffset(t);
    return {
      column: r.col,
      line: r.line,
      offset: t
    };
  }
  init(t, r) {
    this.current.push(t), t.source = {
      input: this.input,
      start: this.getPosition(r)
    }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
  }
  other(t) {
    let r = !1, n = null, i = !1, o = null, a = [], u = t[1].startsWith("--"), s = [], c = t;
    for (; c; ) {
      if (n = c[0], s.push(c), n === "(" || n === "[")
        o || (o = c), a.push(n === "(" ? ")" : "]");
      else if (u && i && n === "{")
        o || (o = c), a.push("}");
      else if (a.length === 0)
        if (n === ";")
          if (i) {
            this.decl(s, u);
            return;
          } else
            break;
        else if (n === "{") {
          this.rule(s);
          return;
        } else if (n === "}") {
          this.tokenizer.back(s.pop()), r = !0;
          break;
        } else n === ":" && (i = !0);
      else n === a[a.length - 1] && (a.pop(), a.length === 0 && (o = null));
      c = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (r = !0), a.length > 0 && this.unclosedBracket(o), r && i) {
      if (!u)
        for (; s.length && (c = s[s.length - 1][0], !(c !== "space" && c !== "comment")); )
          this.tokenizer.back(s.pop());
      this.decl(s, u);
    } else
      this.unknownWord(s);
  }
  parse() {
    let t;
    for (; !this.tokenizer.endOfFile(); )
      switch (t = this.tokenizer.nextToken(), t[0]) {
        case "space":
          this.spaces += t[1];
          break;
        case ";":
          this.freeSemicolon(t);
          break;
        case "}":
          this.end(t);
          break;
        case "comment":
          this.comment(t);
          break;
        case "at-word":
          this.atrule(t);
          break;
        case "{":
          this.emptyRule(t);
          break;
        default:
          this.other(t);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(t, r, n, i) {
    let o, a, u = n.length, s = "", c = !0, l, f;
    for (let d = 0; d < u; d += 1)
      o = n[d], a = o[0], a === "space" && d === u - 1 && !i ? c = !1 : a === "comment" ? (f = n[d - 1] ? n[d - 1][0] : "empty", l = n[d + 1] ? n[d + 1][0] : "empty", !Gee[f] && !Gee[l] ? s.slice(-1) === "," ? c = !1 : s += o[1] : c = !1) : s += o[1];
    if (!c) {
      let d = n.reduce((p, v) => p + v[1], "");
      t.raws[r] = { raw: d, value: s };
    }
    t[r] = s;
  }
  rule(t) {
    t.pop();
    let r = new Yee();
    this.init(r, t[0][2]), r.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(r, "selector", t), this.current = r;
  }
  spacesAndCommentsFromEnd(t) {
    let r, n = "";
    for (; t.length && (r = t[t.length - 1][0], !(r !== "space" && r !== "comment")); )
      n = t.pop()[1] + n;
    return n;
  }
  // Errors
  spacesAndCommentsFromStart(t) {
    let r, n = "";
    for (; t.length && (r = t[0][0], !(r !== "space" && r !== "comment")); )
      n += t.shift()[1];
    return n;
  }
  spacesFromEnd(t) {
    let r, n = "";
    for (; t.length && (r = t[t.length - 1][0], r === "space"); )
      n = t.pop()[1] + n;
    return n;
  }
  stringFrom(t, r) {
    let n = "";
    for (let i = r; i < t.length; i++)
      n += t[i][1];
    return t.splice(r, t.length - r), n;
  }
  unclosedBlock() {
    let t = this.current.source.start;
    throw this.input.error("Unclosed block", t.line, t.column);
  }
  unclosedBracket(t) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: t[2] },
      { offset: t[2] + 1 }
    );
  }
  unexpectedClose(t) {
    throw this.input.error(
      "Unexpected }",
      { offset: t[2] },
      { offset: t[2] + 1 }
    );
  }
  unknownWord(t) {
    throw this.input.error(
      "Unknown word",
      { offset: t[0][2] },
      { offset: t[0][2] + t[0][1].length }
    );
  }
  unnamedAtrule(t, r) {
    throw this.input.error(
      "At-rule without name",
      { offset: r[2] },
      { offset: r[2] + r[1].length }
    );
  }
};
var _sr = ysr;
let Asr = vd, Ssr = H3, bsr = _sr;
function WS(e, t) {
  let r = new Ssr(e, t), n = new bsr(r);
  try {
    n.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && t && t.from && (/\.scss$/i.test(t.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(t.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(t.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return n.root;
}
var j7 = WS;
WS.default = WS;
Asr.registerParse(WS);
let BB = class {
  constructor(t, r = {}) {
    if (this.type = "warning", this.text = t, r.node && r.node.source) {
      let n = r.node.rangeBy(r);
      this.line = n.start.line, this.column = n.start.column, this.endLine = n.end.line, this.endColumn = n.end.column;
    }
    for (let n in r) this[n] = r[n];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Fye = BB;
BB.default = BB;
let Csr = Fye, kB = class {
  constructor(t, r, n) {
    this.processor = t, this.messages = [], this.root = r, this.opts = n, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(t, r = {}) {
    r.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (r.plugin = this.lastPlugin.postcssPlugin);
    let n = new Csr(t, r);
    return this.messages.push(n), n;
  }
  warnings() {
    return this.messages.filter((t) => t.type === "warning");
  }
  get content() {
    return this.css;
  }
};
var z7 = kB;
kB.default = kB;
let Wee = {};
var Hye = function(t) {
  Wee[t] || (Wee[t] = !0, typeof console < "u" && console.warn && console.warn(t));
};
let Isr = vd, Osr = U7, Rsr = Mye, wsr = j7, Kee = z7, Psr = Ny, Dsr = B3, { isClean: Us, my: xsr } = xy, Nsr = Hye;
const Lsr = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Bsr = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, ksr = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, eh = 0;
function jv(e) {
  return typeof e == "object" && typeof e.then == "function";
}
function $ye(e) {
  let t = !1, r = Lsr[e.type];
  return e.type === "decl" ? t = e.prop.toLowerCase() : e.type === "atrule" && (t = e.name.toLowerCase()), t && e.append ? [
    r,
    r + "-" + t,
    eh,
    r + "Exit",
    r + "Exit-" + t
  ] : t ? [r, r + "-" + t, r + "Exit", r + "Exit-" + t] : e.append ? [r, eh, r + "Exit"] : [r, r + "Exit"];
}
function Xee(e) {
  let t;
  return e.type === "document" ? t = ["Document", eh, "DocumentExit"] : e.type === "root" ? t = ["Root", eh, "RootExit"] : t = $ye(e), {
    eventIndex: 0,
    events: t,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function MB(e) {
  return e[Us] = !1, e.nodes && e.nodes.forEach((t) => MB(t)), e;
}
let FB = {}, th = class Uye {
  constructor(t, r, n) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof r == "object" && r !== null && (r.type === "root" || r.type === "document"))
      i = MB(r);
    else if (r instanceof Uye || r instanceof Kee)
      i = MB(r.root), r.map && (typeof n.map > "u" && (n.map = {}), n.map.inline || (n.map.inline = !1), n.map.prev = r.map);
    else {
      let o = wsr;
      n.syntax && (o = n.syntax.parse), n.parser && (o = n.parser), o.parse && (o = o.parse);
      try {
        i = o(r, n);
      } catch (a) {
        this.processed = !0, this.error = a;
      }
      i && !i[xsr] && Isr.rebuild(i);
    }
    this.result = new Kee(t, i, n), this.helpers = { ...FB, postcss: FB, result: this.result }, this.plugins = this.processor.plugins.map((o) => typeof o == "object" && o.prepare ? { ...o, ...o.prepare(this.result) } : o);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(t, r) {
    let n = this.result.lastPlugin;
    try {
      if (r && r.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = n.postcssPlugin, t.setMessage();
      else if (n.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = n.postcssPlugin, o = n.postcssVersion, a = this.result.processor.version, u = o.split("."), s = a.split(".");
        (u[0] !== s[0] || parseInt(u[1]) > parseInt(s[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + a + ", but " + i + " uses " + o + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return t;
  }
  prepareVisitors() {
    this.listeners = {};
    let t = (r, n, i) => {
      this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push([r, i]);
    };
    for (let r of this.plugins)
      if (typeof r == "object")
        for (let n in r) {
          if (!Bsr[n] && /^[A-Z]/.test(n))
            throw new Error(
              `Unknown event ${n} in ${r.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!ksr[n])
            if (typeof r[n] == "object")
              for (let i in r[n])
                i === "*" ? t(r, n, r[n][i]) : t(
                  r,
                  n + "-" + i.toLowerCase(),
                  r[n][i]
                );
            else typeof r[n] == "function" && t(r, n, r[n]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let t = 0; t < this.plugins.length; t++) {
      let r = this.plugins[t], n = this.runOnRoot(r);
      if (jv(n))
        try {
          await n;
        } catch (i) {
          throw this.handleError(i);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[Us]; ) {
        t[Us] = !0;
        let r = [Xee(t)];
        for (; r.length > 0; ) {
          let n = this.visitTick(r);
          if (jv(n))
            try {
              await n;
            } catch (i) {
              let o = r[r.length - 1].node;
              throw this.handleError(i, o);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [r, n] of this.listeners.OnceExit) {
          this.result.lastPlugin = r;
          try {
            if (t.type === "document") {
              let i = t.nodes.map(
                (o) => n(o, this.helpers)
              );
              await Promise.all(i);
            } else
              await n(t, this.helpers);
          } catch (i) {
            throw this.handleError(i);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(t) {
    this.result.lastPlugin = t;
    try {
      if (typeof t == "object" && t.Once) {
        if (this.result.root.type === "document") {
          let r = this.result.root.nodes.map(
            (n) => t.Once(n, this.helpers)
          );
          return jv(r[0]) ? Promise.all(r) : r;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (r) {
      throw this.handleError(r);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let t = this.result.opts, r = Dsr;
    t.syntax && (r = t.syntax.stringify), t.stringifier && (r = t.stringifier), r.stringify && (r = r.stringify);
    let i = new Rsr(r, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let t of this.plugins) {
      let r = this.runOnRoot(t);
      if (jv(r))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[Us]; )
        t[Us] = !0, this.walkSync(t);
      if (this.listeners.OnceExit)
        if (t.type === "document")
          for (let r of t.nodes)
            this.visitSync(this.listeners.OnceExit, r);
        else
          this.visitSync(this.listeners.OnceExit, t);
    }
    return this.result;
  }
  then(t, r) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Nsr(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, r);
  }
  toString() {
    return this.css;
  }
  visitSync(t, r) {
    for (let [n, i] of t) {
      this.result.lastPlugin = n;
      let o;
      try {
        o = i(r, this.helpers);
      } catch (a) {
        throw this.handleError(a, r.proxyOf);
      }
      if (r.type !== "root" && r.type !== "document" && !r.parent)
        return !0;
      if (jv(o))
        throw this.getAsyncError();
    }
  }
  visitTick(t) {
    let r = t[t.length - 1], { node: n, visitors: i } = r;
    if (n.type !== "root" && n.type !== "document" && !n.parent) {
      t.pop();
      return;
    }
    if (i.length > 0 && r.visitorIndex < i.length) {
      let [a, u] = i[r.visitorIndex];
      r.visitorIndex += 1, r.visitorIndex === i.length && (r.visitors = [], r.visitorIndex = 0), this.result.lastPlugin = a;
      try {
        return u(n.toProxy(), this.helpers);
      } catch (s) {
        throw this.handleError(s, n);
      }
    }
    if (r.iterator !== 0) {
      let a = r.iterator, u;
      for (; u = n.nodes[n.indexes[a]]; )
        if (n.indexes[a] += 1, !u[Us]) {
          u[Us] = !0, t.push(Xee(u));
          return;
        }
      r.iterator = 0, delete n.indexes[a];
    }
    let o = r.events;
    for (; r.eventIndex < o.length; ) {
      let a = o[r.eventIndex];
      if (r.eventIndex += 1, a === eh) {
        n.nodes && n.nodes.length && (n[Us] = !0, r.iterator = n.getIterator());
        return;
      } else if (this.listeners[a]) {
        r.visitors = this.listeners[a];
        return;
      }
    }
    t.pop();
  }
  walkSync(t) {
    t[Us] = !0;
    let r = $ye(t);
    for (let n of r)
      if (n === eh)
        t.nodes && t.each((i) => {
          i[Us] || this.walkSync(i);
        });
      else {
        let i = this.listeners[n];
        if (i && this.visitSync(i, t.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
};
th.registerPostcss = (e) => {
  FB = e;
};
var Vye = th;
th.default = th;
Psr.registerLazyResult(th);
Osr.registerLazyResult(th);
let Msr = Mye, Fsr = j7;
const Hsr = z7;
let $sr = B3, Usr = Hye, HB = class {
  constructor(t, r, n) {
    r = r.toString(), this.stringified = !1, this._processor = t, this._css = r, this._opts = n, this._map = void 0;
    let i, o = $sr;
    this.result = new Hsr(this._processor, i, this._opts), this.result.css = r;
    let a = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return a.root;
      }
    });
    let u = new Msr(o, i, this._opts, r);
    if (u.isMap()) {
      let [s, c] = u.generate();
      s && (this.result.css = s), c && (this.result.map = c);
    } else
      u.clearAnnotation(), this.result.css = u.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(t, r) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Usr(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, r);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let t, r = Fsr;
    try {
      t = r(this._css, this._opts);
    } catch (n) {
      this.error = n;
    }
    if (this.error)
      throw this.error;
    return this._root = t, t;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
};
var Vsr = HB;
HB.default = HB;
let jsr = U7, zsr = Vye, qsr = Vsr, Ysr = Ny, iT = class {
  constructor(t = []) {
    this.version = "8.4.47", this.plugins = this.normalize(t);
  }
  normalize(t) {
    let r = [];
    for (let n of t)
      if (n.postcss === !0 ? n = n() : n.postcss && (n = n.postcss), typeof n == "object" && Array.isArray(n.plugins))
        r = r.concat(n.plugins);
      else if (typeof n == "object" && n.postcssPlugin)
        r.push(n);
      else if (typeof n == "function")
        r.push(n);
      else if (typeof n == "object" && (n.parse || n.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(n + " is not a PostCSS plugin");
    return r;
  }
  process(t, r = {}) {
    return !this.plugins.length && !r.parser && !r.stringifier && !r.syntax ? new qsr(this, t, r) : new zsr(this, t, r);
  }
  use(t) {
    return this.plugins = this.plugins.concat(this.normalize([t])), this;
  }
};
var Gsr = iT;
iT.default = iT;
Ysr.registerProcessor(iT);
jsr.registerProcessor(iT);
let jye = $7, zye = M3, Wsr = vd, Ksr = M7, qye = F3, Yye = U7, Xsr = Jur, Jsr = H3, Zsr = Vye, Qsr = Dye, ecr = k3, tcr = j7, q7 = Gsr, rcr = z7, Gye = Ny, Wye = V7, ncr = B3, icr = Fye;
function kn(...e) {
  return e.length === 1 && Array.isArray(e[0]) && (e = e[0]), new q7(e);
}
kn.plugin = function(t, r) {
  let n = !1;
  function i(...a) {
    console && console.warn && !n && (n = !0, console.warn(
      t + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      t + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let u = r(...a);
    return u.postcssPlugin = t, u.postcssVersion = new q7().version, u;
  }
  let o;
  return Object.defineProperty(i, "postcss", {
    get() {
      return o || (o = i()), o;
    }
  }), i.process = function(a, u, s) {
    return kn([i(s)]).process(a, u);
  }, i;
};
kn.stringify = ncr;
kn.parse = tcr;
kn.fromJSON = Xsr;
kn.list = Qsr;
kn.comment = (e) => new zye(e);
kn.atRule = (e) => new jye(e);
kn.decl = (e) => new qye(e);
kn.rule = (e) => new Wye(e);
kn.root = (e) => new Gye(e);
kn.document = (e) => new Yye(e);
kn.CssSyntaxError = Ksr;
kn.Declaration = qye;
kn.Container = Wsr;
kn.Processor = q7;
kn.Document = Yye;
kn.Comment = zye;
kn.Warning = icr;
kn.AtRule = jye;
kn.Result = rcr;
kn.Input = Jsr;
kn.Rule = Wye;
kn.Root = Gye;
kn.Node = ecr;
Zsr.registerPostcss(kn);
var ocr = kn;
kn.default = kn;
const acr = MTe, Jee = tur, { isPlainObject: ucr } = B7, Zee = Eur, scr = mur, { parse: ccr } = ocr, lcr = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], fcr = ["script", "style"];
function a1(e, t) {
  e && Object.keys(e).forEach(function(r) {
    t(e[r], r);
  });
}
function Mc(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function Qee(e, t) {
  const r = [];
  return a1(e, function(n) {
    t(n) && r.push(n);
  }), r;
}
function dcr(e) {
  for (const t in e)
    if (Mc(e, t))
      return !1;
  return !0;
}
function pcr(e) {
  return e.map(function(t) {
    if (!t.url)
      throw new Error("URL missing");
    return t.url + (t.w ? ` ${t.w}w` : "") + (t.h ? ` ${t.h}h` : "") + (t.d ? ` ${t.d}x` : "");
  }).join(", ");
}
var hcr = oT;
const vcr = /^[^\0\t\n\f\r /<=>]+$/;
function oT(e, t, r) {
  if (e == null)
    return "";
  typeof e == "number" && (e = e.toString());
  let n = "", i = "";
  function o(D, w) {
    const $ = this;
    this.tag = D, this.attribs = w || {}, this.tagPosition = n.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (E.length) {
        const X = E[E.length - 1];
        X.text += $.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      E.length && lcr.includes(this.tag) && E[E.length - 1].mediaChildren.push(this.tag);
    };
  }
  t = Object.assign({}, oT.defaults, t), t.parser = Object.assign({}, Ecr, t.parser);
  const a = function(D) {
    return t.allowedTags === !1 || (t.allowedTags || []).indexOf(D) > -1;
  };
  fcr.forEach(function(D) {
    a(D) && !t.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${D}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const u = t.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let s, c;
  t.allowedAttributes && (s = {}, c = {}, a1(t.allowedAttributes, function(D, w) {
    s[w] = [];
    const $ = [];
    D.forEach(function(X) {
      typeof X == "string" && X.indexOf("*") >= 0 ? $.push(Jee(X).replace(/\\\*/g, ".*")) : s[w].push(X);
    }), $.length && (c[w] = new RegExp("^(" + $.join("|") + ")$"));
  }));
  const l = {}, f = {}, d = {};
  a1(t.allowedClasses, function(D, w) {
    if (s && (Mc(s, w) || (s[w] = []), s[w].push("class")), l[w] = D, Array.isArray(D)) {
      const $ = [];
      l[w] = [], d[w] = [], D.forEach(function(X) {
        typeof X == "string" && X.indexOf("*") >= 0 ? $.push(Jee(X).replace(/\\\*/g, ".*")) : X instanceof RegExp ? d[w].push(X) : l[w].push(X);
      }), $.length && (f[w] = new RegExp("^(" + $.join("|") + ")$"));
    }
  });
  const p = {};
  let v;
  a1(t.transformTags, function(D, w) {
    let $;
    typeof D == "function" ? $ = D : typeof D == "string" && ($ = oT.simpleTransform(D)), w === "*" ? v = $ : p[w] = $;
  });
  let h, E, m, g, y, _, S = !1;
  O();
  const A = new acr.Parser({
    onopentag: function(D, w) {
      if (t.enforceHtmlBoundary && D === "html" && O(), y) {
        _++;
        return;
      }
      const $ = new o(D, w);
      E.push($);
      let X = !1;
      const V = !!$.text;
      let F;
      if (Mc(p, D) && (F = p[D](D, w), $.attribs = w = F.attribs, F.text !== void 0 && ($.innerText = F.text), D !== F.tagName && ($.name = D = F.tagName, g[h] = F.tagName)), v && (F = v(D, w), $.attribs = w = F.attribs, D !== F.tagName && ($.name = D = F.tagName, g[h] = F.tagName)), (!a(D) || t.disallowedTagsMode === "recursiveEscape" && !dcr(m) || t.nestingLimit != null && h >= t.nestingLimit) && (X = !0, m[h] = !0, (t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") && u.indexOf(D) !== -1 && (y = !0, _ = 1), m[h] = !0), h++, X) {
        if (t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard")
          return;
        i = n, n = "";
      }
      n += "<" + D, D === "script" && (t.allowedScriptHostnames || t.allowedScriptDomains) && ($.innerText = ""), (!s || Mc(s, D) || s["*"]) && a1(w, function(le, ae) {
        if (!vcr.test(ae)) {
          delete $.attribs[ae];
          return;
        }
        if (le === "" && !t.allowedEmptyAttributes.includes(ae) && (t.nonBooleanAttributes.includes(ae) || t.nonBooleanAttributes.includes("*"))) {
          delete $.attribs[ae];
          return;
        }
        let ne = !1;
        if (!s || Mc(s, D) && s[D].indexOf(ae) !== -1 || s["*"] && s["*"].indexOf(ae) !== -1 || Mc(c, D) && c[D].test(ae) || c["*"] && c["*"].test(ae))
          ne = !0;
        else if (s && s[D]) {
          for (const ve of s[D])
            if (ucr(ve) && ve.name && ve.name === ae) {
              ne = !0;
              let Ie = "";
              if (ve.multiple === !0) {
                const Oe = le.split(" ");
                for (const xe of Oe)
                  ve.values.indexOf(xe) !== -1 && (Ie === "" ? Ie = xe : Ie += " " + xe);
              } else ve.values.indexOf(le) >= 0 && (Ie = le);
              le = Ie;
            }
        }
        if (ne) {
          if (t.allowedSchemesAppliedToAttributes.indexOf(ae) !== -1 && U(D, le)) {
            delete $.attribs[ae];
            return;
          }
          if (D === "script" && ae === "src") {
            let ve = !0;
            try {
              const Ie = z(le);
              if (t.allowedScriptHostnames || t.allowedScriptDomains) {
                const Oe = (t.allowedScriptHostnames || []).find(function(ze) {
                  return ze === Ie.url.hostname;
                }), xe = (t.allowedScriptDomains || []).find(function(ze) {
                  return Ie.url.hostname === ze || Ie.url.hostname.endsWith(`.${ze}`);
                });
                ve = Oe || xe;
              }
            } catch {
              ve = !1;
            }
            if (!ve) {
              delete $.attribs[ae];
              return;
            }
          }
          if (D === "iframe" && ae === "src") {
            let ve = !0;
            try {
              const Ie = z(le);
              if (Ie.isRelativeUrl)
                ve = Mc(t, "allowIframeRelativeUrls") ? t.allowIframeRelativeUrls : !t.allowedIframeHostnames && !t.allowedIframeDomains;
              else if (t.allowedIframeHostnames || t.allowedIframeDomains) {
                const Oe = (t.allowedIframeHostnames || []).find(function(ze) {
                  return ze === Ie.url.hostname;
                }), xe = (t.allowedIframeDomains || []).find(function(ze) {
                  return Ie.url.hostname === ze || Ie.url.hostname.endsWith(`.${ze}`);
                });
                ve = Oe || xe;
              }
            } catch {
              ve = !1;
            }
            if (!ve) {
              delete $.attribs[ae];
              return;
            }
          }
          if (ae === "srcset")
            try {
              let ve = scr(le);
              if (ve.forEach(function(Ie) {
                U("srcset", Ie.url) && (Ie.evil = !0);
              }), ve = Qee(ve, function(Ie) {
                return !Ie.evil;
              }), ve.length)
                le = pcr(Qee(ve, function(Ie) {
                  return !Ie.evil;
                })), $.attribs[ae] = le;
              else {
                delete $.attribs[ae];
                return;
              }
            } catch {
              delete $.attribs[ae];
              return;
            }
          if (ae === "class") {
            const ve = l[D], Ie = l["*"], Oe = f[D], xe = d[D], ze = f["*"], qe = [
              Oe,
              ze
            ].concat(xe).filter(function(Je) {
              return Je;
            });
            if (ve && Ie ? le = x(le, Zee(ve, Ie), qe) : le = x(le, ve || Ie, qe), !le.length) {
              delete $.attribs[ae];
              return;
            }
          }
          if (ae === "style") {
            if (t.parseStyleAttributes)
              try {
                const ve = ccr(D + " {" + le + "}", { map: !1 }), Ie = k(ve, t.allowedStyles);
                if (le = H(Ie), le.length === 0) {
                  delete $.attribs[ae];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + D + " {" + le + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete $.attribs[ae];
                return;
              }
            else if (t.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          n += " " + ae, le && le.length ? n += '="' + P(le, !0) + '"' : t.allowedEmptyAttributes.includes(ae) && (n += '=""');
        } else
          delete $.attribs[ae];
      }), t.selfClosing.indexOf(D) !== -1 ? n += " />" : (n += ">", $.innerText && !V && !t.textFilter && (n += P($.innerText), S = !0)), X && (n = i + P(n), i = "");
    },
    ontext: function(D) {
      if (y)
        return;
      const w = E[E.length - 1];
      let $;
      if (w && ($ = w.tag, D = w.innerText !== void 0 ? w.innerText : D), t.disallowedTagsMode === "completelyDiscard" && !a($))
        D = "";
      else if ((t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") && ($ === "script" || $ === "style"))
        n += D;
      else {
        const X = P(D, !1);
        t.textFilter && !S ? n += t.textFilter(X, $) : S || (n += X);
      }
      if (E.length) {
        const X = E[E.length - 1];
        X.text += D;
      }
    },
    onclosetag: function(D, w) {
      if (y)
        if (_--, !_)
          y = !1;
        else
          return;
      const $ = E.pop();
      if (!$)
        return;
      if ($.tag !== D) {
        E.push($);
        return;
      }
      y = t.enforceHtmlBoundary ? D === "html" : !1, h--;
      const X = m[h];
      if (X) {
        if (delete m[h], t.disallowedTagsMode === "discard" || t.disallowedTagsMode === "completelyDiscard") {
          $.updateParentNodeText();
          return;
        }
        i = n, n = "";
      }
      if (g[h] && (D = g[h], delete g[h]), t.exclusiveFilter && t.exclusiveFilter($)) {
        n = n.substr(0, $.tagPosition);
        return;
      }
      if ($.updateParentNodeMediaChildren(), $.updateParentNodeText(), // Already output />
      t.selfClosing.indexOf(D) !== -1 || // Escaped tag, closing tag is implied
      w && !a(D) && ["escape", "recursiveEscape"].indexOf(t.disallowedTagsMode) >= 0) {
        X && (n = i, i = "");
        return;
      }
      n += "</" + D + ">", X && (n = i + P(n), i = ""), S = !1;
    }
  }, t.parser);
  return A.write(e), A.end(), n;
  function O() {
    n = "", h = 0, E = [], m = {}, g = {}, y = !1, _ = 0;
  }
  function P(D, w) {
    return typeof D != "string" && (D = D + ""), t.parser.decodeEntities && (D = D.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), w && (D = D.replace(/"/g, "&quot;"))), D = D.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), w && (D = D.replace(/"/g, "&quot;")), D;
  }
  function U(D, w) {
    for (w = w.replace(/[\x00-\x20]+/g, ""); ; ) {
      const V = w.indexOf("<!--");
      if (V === -1)
        break;
      const F = w.indexOf("-->", V + 4);
      if (F === -1)
        break;
      w = w.substring(0, V) + w.substring(F + 3);
    }
    const $ = w.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!$)
      return w.match(/^[/\\]{2}/) ? !t.allowProtocolRelative : !1;
    const X = $[1].toLowerCase();
    return Mc(t.allowedSchemesByTag, D) ? t.allowedSchemesByTag[D].indexOf(X) === -1 : !t.allowedSchemes || t.allowedSchemes.indexOf(X) === -1;
  }
  function z(D) {
    if (D = D.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), D.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let w = "relative://relative-site";
    for (let V = 0; V < 100; V++)
      w += `/${V}`;
    const $ = new URL(D, w);
    return {
      isRelativeUrl: $ && $.hostname === "relative-site" && $.protocol === "relative:",
      url: $
    };
  }
  function k(D, w) {
    if (!w)
      return D;
    const $ = D.nodes[0];
    let X;
    return w[$.selector] && w["*"] ? X = Zee(
      w[$.selector],
      w["*"]
    ) : X = w[$.selector] || w["*"], X && (D.nodes[0].nodes = $.nodes.reduce(B(X), [])), D;
  }
  function H(D) {
    return D.nodes[0].nodes.reduce(function(w, $) {
      return w.push(
        `${$.prop}:${$.value}${$.important ? " !important" : ""}`
      ), w;
    }, []).join(";");
  }
  function B(D) {
    return function(w, $) {
      return Mc(D, $.prop) && D[$.prop].some(function(V) {
        return V.test($.value);
      }) && w.push($), w;
    };
  }
  function x(D, w, $) {
    return w ? (D = D.split(/\s+/), D.filter(function(X) {
      return w.indexOf(X) !== -1 || $.some(function(V) {
        return V.test(X);
      });
    }).join(" ")) : D;
  }
}
const Ecr = {
  decodeEntities: !0
};
oT.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
oT.simpleTransform = function(e, t, r) {
  return r = r === void 0 ? !0 : r, t = t || {}, function(n, i) {
    let o;
    if (r)
      for (o in t)
        i[o] = t[o];
    else
      i = t;
    return {
      tagName: e,
      attribs: i
    };
  };
};
const mcr = /* @__PURE__ */ Mt(hcr);
function Kye(e, t) {
  var r = typeof hf < "u" && e9(e) || e["@@iterator"];
  if (!r) {
    if (Yk(e) || (r = r9(e)) || t) {
      r && (e = r);
      var n = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, a = !0, u = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return a = c.done, c;
    },
    e: function(c) {
      u = !0, o = c;
    },
    f: function() {
      try {
        a || r.return == null || r.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
var gcr = Zt, Tcr = mn, ycr = rC.f, _cr = Tcr(function() {
  return !Object.getOwnPropertyNames(1);
});
gcr({ target: "Object", stat: !0, forced: _cr }, {
  getOwnPropertyNames: ycr
});
var Acr = Pn, Scr = Acr.Object, bcr = function(t) {
  return Scr.getOwnPropertyNames(t);
}, Ccr = bcr, Icr = Ccr, Ocr = Icr;
const Xye = /* @__PURE__ */ Mt(Ocr);
var Rcr = Qve;
const KS = /* @__PURE__ */ Mt(Rcr);
var wcr = t9;
const da = /* @__PURE__ */ Mt(wcr);
var Pcr = Zt, Dcr = c0.some, xcr = xh, Ncr = xcr("some");
Pcr({ target: "Array", proto: !0, forced: !Ncr }, {
  some: function(t) {
    return Dcr(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Lcr = Aa, Bcr = Lcr("Array", "some"), kcr = Qi, Mcr = Bcr, ix = Array.prototype, Fcr = function(e) {
  var t = e.some;
  return e === ix || kcr(ix, e) && t === ix.some ? Mcr : t;
}, Hcr = Fcr, $cr = Hcr, Ucr = $cr;
const Vcr = /* @__PURE__ */ Mt(Ucr);
var jcr = qf, zcr = Hu, qcr = Eh, Ycr = As, Gcr = xh, Wcr = Math.min, $B = [].lastIndexOf, Jye = !!$B && 1 / [1].lastIndexOf(1, -0) < 0, Kcr = Gcr("lastIndexOf"), Xcr = Jye || !Kcr, Jcr = Xcr ? function(t) {
  if (Jye) return jcr($B, this, arguments) || 0;
  var r = zcr(this), n = Ycr(r);
  if (n === 0) return -1;
  var i = n - 1;
  for (arguments.length > 1 && (i = Wcr(i, qcr(arguments[1]))), i < 0 && (i = n + i); i >= 0; i--) if (i in r && r[i] === t) return i || 0;
  return -1;
} : $B, Zcr = Zt, ete = Jcr;
Zcr({ target: "Array", proto: !0, forced: ete !== [].lastIndexOf }, {
  lastIndexOf: ete
});
var Qcr = Aa, elr = Qcr("Array", "lastIndexOf"), tlr = Qi, rlr = elr, ox = Array.prototype, nlr = function(e) {
  var t = e.lastIndexOf;
  return e === ox || tlr(ox, e) && t === ox.lastIndexOf ? rlr : t;
}, ilr = nlr, olr = ilr, alr = olr;
const rf = /* @__PURE__ */ Mt(alr);
var tte = Hi, ulr = bn, slr = po, clr = mn, ax = FT, llr = MT, flr = PT, dlr = cu, plr = Mb, Yd = Object.assign, rte = Object.defineProperty, hlr = ulr([].concat), vlr = !Yd || clr(function() {
  if (tte && Yd({ b: 1 }, Yd(rte({}, "a", {
    enumerable: !0,
    get: function() {
      rte(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, t = {}, r = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return e[r] = 7, n.split("").forEach(function(i) {
    t[i] = i;
  }), Yd({}, e)[r] !== 7 || ax(Yd({}, t)).join("") !== n;
}) ? function(t, r) {
  for (var n = dlr(t), i = arguments.length, o = 1, a = llr.f, u = flr.f; i > o; )
    for (var s = plr(arguments[o++]), c = a ? hlr(ax(s), a(s)) : ax(s), l = c.length, f = 0, d; l > f; )
      d = c[f++], (!tte || slr(u, s, d)) && (n[d] = s[d]);
  return n;
} : Yd, Elr = Zt, nte = vlr;
Elr({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== nte }, {
  assign: nte
});
var mlr = Pn, glr = mlr.Object.assign, Tlr = glr, ylr = Tlr, _lr = ylr;
const ite = /* @__PURE__ */ Mt(_lr);
var Alr = Zt, Slr = c0.every, blr = xh, Clr = blr("every");
Alr({ target: "Array", proto: !0, forced: !Clr }, {
  every: function(t) {
    return Slr(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Ilr = Aa, Olr = Ilr("Array", "every"), Rlr = Qi, wlr = Olr, ux = Array.prototype, Plr = function(e) {
  var t = e.every;
  return e === ux || Rlr(ux, e) && t === ux.every ? wlr : t;
}, Dlr = Plr, xlr = Dlr, Nlr = xlr;
const D0 = /* @__PURE__ */ Mt(Nlr);
var Llr = wf, Zye = wu, Blr = iy, Qye = Xye, klr = KS, Mlr = Object.prototype.hasOwnProperty, Y7 = function(t, r) {
  return function() {
    return r || (0, t[Qye(t)[0]])((r = {
      exports: {}
    }).exports, r), r.exports;
  };
}, Flr = function(t, r, n, i) {
  if (r && Ta(r) === "object" || typeof r == "function") {
    var o = Kye(Qye(r)), a;
    try {
      var u = function() {
        var c = a.value;
        !Mlr.call(t, c) && c !== n && Zye(t, c, {
          get: function() {
            return r[c];
          },
          enumerable: !(i = Blr(r, c)) || i.enumerable
        });
      };
      for (o.s(); !(a = o.n()).done; )
        u();
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
  }
  return t;
}, Hlr = function(t, r, n) {
  return n = t != null ? Llr(klr(t)) : {}, Flr(Zye(n, "default", {
    value: t,
    enumerable: !0
  }), t);
}, $lr = Y7({
  "../markdown-it-attrs/utils.js": function(t) {
    t.getAttrs = function(u, s, c) {
      for (var l = /[^\t\n\f />"'=]/, f = " ", d = "=", p = ".", v = "#", h = [], E = "", m = "", g = !0, y = !1, _ = s + c.leftDelimiter.length; _ < u.length; _++) {
        if (da(u).call(u, _, _ + c.rightDelimiter.length) === c.rightDelimiter) {
          E !== "" && h.push([E, m]);
          break;
        }
        var S = u.charAt(_);
        if (S === d && g) {
          g = !1;
          continue;
        }
        if (S === p && E === "") {
          u.charAt(_ + 1) === p ? (E = "css-module", _ += 1) : E = "class", g = !1;
          continue;
        }
        if (S === v && E === "") {
          E = "id", g = !1;
          continue;
        }
        if (S === '"' && m === "" && !y) {
          y = !0;
          continue;
        }
        if (S === '"' && y) {
          y = !1;
          continue;
        }
        if (S === f && !y) {
          if (E === "")
            continue;
          h.push([E, m]), E = "", m = "", g = !0;
          continue;
        }
        if (!(g && S.search(l) === -1)) {
          if (g) {
            E += S;
            continue;
          }
          m += S;
        }
      }
      if (c.allowedAttributes && c.allowedAttributes.length) {
        var A = c.allowedAttributes;
        return Kpe(h).call(h, function(O) {
          var P = O[0];
          function U(z) {
            return P === z || z instanceof RegExp && z.test(P);
          }
          return Vcr(A).call(A, U);
        });
      }
      return h;
    }, t.addAttrs = function(u, s) {
      for (var c = 0, l = u.length; c < l; ++c) {
        var f = u[c][0];
        f === "class" ? s.attrJoin("class", u[c][1]) : f === "css-module" ? s.attrJoin("css-module", u[c][1]) : s.attrPush(u[c]);
      }
      return s;
    }, t.hasDelimiters = function(u, s) {
      if (!u)
        throw new Error('Parameter `where` not passed. Should be "start", "end" or "only".');
      return function(c) {
        var l, f = s.leftDelimiter.length + 1 + s.rightDelimiter.length;
        if (!c || typeof c != "string" || c.length < f)
          return !1;
        function d(g) {
          var y = g.charAt(s.leftDelimiter.length) === ".", _ = g.charAt(s.leftDelimiter.length) === "#";
          return y || _ ? g.length >= f + 1 : g.length >= f;
        }
        var p, v, h, E, m = f - s.rightDelimiter.length;
        switch (u) {
          case "start":
            h = da(c).call(c, 0, s.leftDelimiter.length), p = h === s.leftDelimiter ? 0 : -1, v = p === -1 ? -1 : _p(c).call(c, s.rightDelimiter, m), E = c.charAt(v + s.rightDelimiter.length), E && _p(l = s.rightDelimiter).call(l, E) !== -1 && (v = -1);
            break;
          case "end":
            p = rf(c).call(c, s.leftDelimiter), v = p === -1 ? -1 : _p(c).call(c, s.rightDelimiter, p + m), v = v === c.length - s.rightDelimiter.length ? v : -1;
            break;
          case "only":
            h = da(c).call(c, 0, s.leftDelimiter.length), p = h === s.leftDelimiter ? 0 : -1, h = da(c).call(c, c.length - s.rightDelimiter.length), v = h === s.rightDelimiter ? c.length - s.rightDelimiter.length : -1;
            break;
          default:
            throw new Error("Unexpected case ".concat(u, ", expected 'start', 'end' or 'only'"));
        }
        return p !== -1 && v !== -1 && d(c.substring(p, v + s.rightDelimiter.length));
      };
    }, t.removeDelimiter = function(u, s) {
      var c = r(s.leftDelimiter), l = r(s.rightDelimiter), f = new RegExp("[ \\n]?" + c + "[^" + c + l + "]+" + l + "$"), d = u.search(f);
      return d !== -1 ? da(u).call(u, 0, d) : u;
    };
    function r(u) {
      return u.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    t.escapeRegExp = r, t.getMatchingOpeningToken = function(u, s) {
      if (u[s].type === "softbreak")
        return !1;
      if (u[s].nesting === 0)
        return u[s];
      for (var c = u[s].level, l = u[s].type.replace("_close", "_open"); s >= 0; --s)
        if (u[s].type === l && u[s].level === c)
          return u[s];
      return !1;
    };
    var n = /[&<>"]/, i = /[&<>"]/g, o = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;"
    };
    function a(u) {
      return o[u];
    }
    t.escapeHtml = function(u) {
      return n.test(u) ? u.replace(i, a) : u;
    };
  }
}), Ulr = Y7({
  "../markdown-it-attrs/patterns.js": function(t, r) {
    var n = $lr();
    r.exports = function(o) {
      var a = new RegExp("^ {0,3}[-*_]{3,} ?" + n.escapeRegExp(o.leftDelimiter) + "[^" + n.escapeRegExp(o.rightDelimiter) + "]");
      return [{
        name: "fenced code blocks",
        tests: [{
          shift: 0,
          block: !0,
          info: n.hasDelimiters("end", o)
        }],
        transform: function(s, c) {
          var l, f = s[c], d = rf(l = f.info).call(l, o.leftDelimiter), p = n.getAttrs(f.info, d, o);
          n.addAttrs(p, f), f.info = n.removeDelimiter(f.info, o);
        }
      }, {
        name: "inline nesting 0",
        tests: [{
          shift: 0,
          type: "inline",
          children: [{
            shift: -1,
            type: function(s) {
              return s === "image" || s === "code_inline";
            }
          }, {
            shift: 0,
            type: "text",
            content: n.hasDelimiters("start", o)
          }]
        }],
        transform: function(s, c, l) {
          var f, d = s[c].children[l], p = _p(f = d.content).call(f, o.rightDelimiter), v = s[c].children[l - 1], h = n.getAttrs(d.content, 0, o);
          if (n.addAttrs(h, v), d.content.length === p + o.rightDelimiter.length) {
            var E;
            e1(E = s[c].children).call(E, l, 1);
          } else {
            var m;
            d.content = da(m = d.content).call(m, p + o.rightDelimiter.length);
          }
        }
      }, {
        name: "tables",
        tests: [{
          shift: 0,
          type: "table_close"
        }, {
          shift: 1,
          type: "paragraph_open"
        }, {
          shift: 2,
          type: "inline",
          content: n.hasDelimiters("only", o)
        }],
        transform: function(s, c) {
          var l = s[c + 2], f = n.getMatchingOpeningToken(s, c), d = n.getAttrs(l.content, 0, o);
          n.addAttrs(d, f), e1(s).call(s, c + 1, 3);
        }
      }, {
        name: "inline attributes",
        tests: [{
          shift: 0,
          type: "inline",
          children: [{
            shift: -1,
            nesting: -1
          }, {
            shift: 0,
            type: "text",
            content: n.hasDelimiters("start", o)
          }]
        }],
        transform: function(s, c, l) {
          var f = s[c].children[l], d = f.content, p = n.getAttrs(d, 0, o), v = n.getMatchingOpeningToken(s[c].children, l - 1);
          n.addAttrs(p, v), f.content = da(d).call(d, _p(d).call(d, o.rightDelimiter) + o.rightDelimiter.length);
        }
      }, {
        name: "list softbreak",
        tests: [{
          shift: -2,
          type: "list_item_open"
        }, {
          shift: 0,
          type: "inline",
          children: [{
            position: -2,
            type: "softbreak"
          }, {
            position: -1,
            type: "text",
            content: n.hasDelimiters("only", o)
          }]
        }],
        transform: function(s, c, l) {
          for (var f, d = s[c].children[l], p = d.content, v = n.getAttrs(p, 0, o), h = c - 2; s[h - 1] && s[h - 1].type !== "ordered_list_open" && s[h - 1].type !== "bullet_list_open"; )
            h--;
          n.addAttrs(v, s[h - 1]), s[c].children = da(f = s[c].children).call(f, 0, -2);
        }
      }, {
        name: "list double softbreak",
        tests: [{
          shift: 0,
          type: function(s) {
            return s === "bullet_list_close" || s === "ordered_list_close";
          }
        }, {
          shift: 1,
          type: "paragraph_open"
        }, {
          shift: 2,
          type: "inline",
          content: n.hasDelimiters("only", o),
          children: function(s) {
            return s.length === 1;
          }
        }, {
          shift: 3,
          type: "paragraph_close"
        }],
        transform: function(s, c) {
          var l = s[c + 2], f = l.content, d = n.getAttrs(f, 0, o), p = n.getMatchingOpeningToken(s, c);
          n.addAttrs(d, p), e1(s).call(s, c + 1, 3);
        }
      }, {
        name: "list item end",
        tests: [{
          shift: -2,
          type: "list_item_open"
        }, {
          shift: 0,
          type: "inline",
          children: [{
            position: -1,
            type: "text",
            content: n.hasDelimiters("end", o)
          }]
        }],
        transform: function(s, c, l) {
          var f = s[c].children[l], d = f.content, p = n.getAttrs(d, rf(d).call(d, o.leftDelimiter), o);
          n.addAttrs(p, s[c - 2]);
          var v = da(d).call(d, 0, rf(d).call(d, o.leftDelimiter));
          f.content = i(v) !== " " ? v : da(v).call(v, 0, -1);
        }
      }, {
        name: `
{.a} softbreak then curly in start`,
        tests: [{
          shift: 0,
          type: "inline",
          children: [{
            position: -2,
            type: "softbreak"
          }, {
            position: -1,
            type: "text",
            content: n.hasDelimiters("only", o)
          }]
        }],
        transform: function(s, c, l) {
          for (var f, d = s[c].children[l], p = n.getAttrs(d.content, 0, o), v = c + 1; s[v + 1] && s[v + 1].nesting === -1; )
            v++;
          var h = n.getMatchingOpeningToken(s, v);
          n.addAttrs(p, h), s[c].children = da(f = s[c].children).call(f, 0, -2);
        }
      }, {
        name: "horizontal rule",
        tests: [{
          shift: 0,
          type: "paragraph_open"
        }, {
          shift: 1,
          type: "inline",
          children: function(s) {
            return s.length === 1;
          },
          content: function(s) {
            return s.match(a) !== null;
          }
        }, {
          shift: 2,
          type: "paragraph_close"
        }],
        transform: function(s, c) {
          var l = s[c];
          l.type = "hr", l.tag = "hr", l.nesting = 0;
          var f = s[c + 1].content, d = rf(f).call(f, o.leftDelimiter), p = n.getAttrs(f, d, o);
          n.addAttrs(p, l), l.markup = f, e1(s).call(s, c + 1, 2);
        }
      }, {
        name: "end of block",
        tests: [{
          shift: 0,
          type: "inline",
          children: [{
            position: -1,
            content: n.hasDelimiters("end", o),
            type: function(s) {
              return s !== "code_inline" && s !== "math_inline";
            }
          }]
        }],
        transform: function(s, c, l) {
          for (var f = s[c].children[l], d = f.content, p = n.getAttrs(d, rf(d).call(d, o.leftDelimiter), o), v = c + 1; s[v + 1] && s[v + 1].nesting === -1; )
            v++;
          var h = n.getMatchingOpeningToken(s, v);
          n.addAttrs(p, h);
          var E = da(d).call(d, 0, rf(d).call(d, o.leftDelimiter));
          f.content = i(E) !== " " ? E : da(E).call(E, 0, -1);
        }
      }];
    };
    function i(o) {
      return da(o).call(o, -1)[0];
    }
  }
}), Vlr = Y7({
  "../markdown-it-attrs/index.js": function(t, r) {
    var n = Ulr(), i = {
      leftDelimiter: "{",
      rightDelimiter: "}",
      allowedAttributes: []
    };
    r.exports = function(f, d) {
      var p = ite({}, i);
      p = ite(p, d);
      var v = n(p);
      function h(E) {
        for (var m = E.tokens, g = function(S) {
          for (var A = function(U) {
            var z, k = v[U], H = null, B = D0(z = k.tests).call(z, function(x) {
              var D = o(m, S, x);
              return D.j !== null && (H = D.j), D.match;
            });
            B && (k.transform(m, S, H), (k.name === "inline attributes" || k.name === "inline nesting 0") && U--), O = U;
          }, O = 0; O < v.length; O++)
            A(O);
        }, y = 0; y < m.length; y++)
          g(y);
      }
      f.core.ruler.before("linkify", "curly_attributes", h);
    };
    function o(l, f, d) {
      var p = {
        match: !1,
        j: null
      }, v = d.shift !== void 0 ? f + d.shift : d.position;
      if (d.shift !== void 0 && v < 0)
        return p;
      var h = s(l, v);
      if (h === void 0)
        return p;
      for (var E = function() {
        var S = y[g];
        if (S === "shift" || S === "position")
          return 0;
        if (h[S] === void 0)
          return {
            v: p
          };
        if (S === "children" && a(d.children)) {
          if (h.children.length === 0)
            return {
              v: p
            };
          var A, O = d.children, P = h.children;
          if (D0(O).call(O, function(x) {
            return x.position !== void 0;
          })) {
            if (A = D0(O).call(O, function(x) {
              return o(P, x.position, x).match;
            }), A) {
              var U = c(O).position;
              p.j = U >= 0 ? U : P.length + U;
            }
          } else
            for (var z = function(D) {
              if (A = D0(O).call(O, function(w) {
                return o(P, D, w).match;
              }), A)
                return p.j = D, 1;
            }, k = 0; k < P.length && !z(k); k++)
              ;
          return A === !1 ? {
            v: p
          } : 0;
        }
        switch (Ta(d[S])) {
          case "boolean":
          case "number":
          case "string":
            if (h[S] !== d[S])
              return {
                v: p
              };
            break;
          case "function":
            if (!d[S](h[S]))
              return {
                v: p
              };
            break;
          case "object":
            if (u(d[S])) {
              var H, B = D0(H = d[S]).call(H, function(x) {
                return x(h[S]);
              });
              if (B === !1)
                return {
                  v: p
                };
              break;
            }
          default:
            throw new Error("Unknown type of pattern test (key: ".concat(S, "). Test should be of type boolean, number, string, function or array of functions."));
        }
      }, m, g = 0, y = IS(d); g < y.length; g++)
        if (m = E(), m !== 0 && m)
          return m.v;
      return p.match = !0, p;
    }
    function a(l) {
      return zp(l) && l.length && D0(l).call(l, function(f) {
        return Ta(f) === "object";
      });
    }
    function u(l) {
      return zp(l) && l.length && D0(l).call(l, function(f) {
        return typeof f == "function";
      });
    }
    function s(l, f) {
      return f >= 0 ? l[f] : l[l.length + f];
    }
    function c(l) {
      return da(l).call(l, -1)[0] || {};
    }
  }
}), jlr = Hlr(Vlr()), zlr = jlr.default, zv = function(e) {
  return e && e.Math === Math && e;
}, ju = (
  // eslint-disable-next-line es/no-global-this -- safe
  zv(typeof globalThis == "object" && globalThis) || zv(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  zv(typeof self == "object" && self) || zv(typeof fe == "object" && fe) || zv(typeof fe == "object" && fe) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), G7 = {}, zu = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, qlr = zu, qu = !qlr(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), Ylr = zu, W7 = !Ylr(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Glr = W7, IA = Function.prototype.call, sl = Glr ? IA.bind(IA) : function() {
  return IA.apply(IA, arguments);
}, K7 = {}, e_e = {}.propertyIsEnumerable, t_e = Object.getOwnPropertyDescriptor, Wlr = t_e && !e_e.call({ 1: 2 }, 1);
K7.f = Wlr ? function(t) {
  var r = t_e(this, t);
  return !!r && r.enumerable;
} : e_e;
var X7 = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, r_e = W7, n_e = Function.prototype, UB = n_e.call, Klr = r_e && n_e.bind.bind(UB, UB), Va = r_e ? Klr : function(e) {
  return function() {
    return UB.apply(e, arguments);
  };
}, i_e = Va, Xlr = i_e({}.toString), Jlr = i_e("".slice), J7 = function(e) {
  return Jlr(Xlr(e), 8, -1);
}, Zlr = Va, Qlr = zu, e0r = J7, sx = Object, t0r = Zlr("".split), r0r = Qlr(function() {
  return !sx("z").propertyIsEnumerable(0);
}) ? function(e) {
  return e0r(e) === "String" ? t0r(e, "") : sx(e);
} : sx, $3 = function(e) {
  return e == null;
}, n0r = $3, i0r = TypeError, U3 = function(e) {
  if (n0r(e)) throw new i0r("Can't call method on " + e);
  return e;
}, o0r = r0r, a0r = U3, Xh = function(e) {
  return o0r(a0r(e));
}, cx = typeof document == "object" && document.all, aa = typeof cx > "u" && cx !== void 0 ? function(e) {
  return typeof e == "function" || e === cx;
} : function(e) {
  return typeof e == "function";
}, u0r = aa, cl = function(e) {
  return typeof e == "object" ? e !== null : u0r(e);
}, lx = ju, s0r = aa, c0r = function(e) {
  return s0r(e) ? e : void 0;
}, Ed = function(e, t) {
  return arguments.length < 2 ? c0r(lx[e]) : lx[e] && lx[e][t];
}, l0r = Va, Z7 = l0r({}.isPrototypeOf), f0r = typeof navigator < "u" && String(navigator.userAgent) || "", o_e = ju, fx = f0r, ote = o_e.process, ate = o_e.Deno, ute = ote && ote.versions || ate && ate.version, ste = ute && ute.v8, cs, XS;
ste && (cs = ste.split("."), XS = cs[0] > 0 && cs[0] < 4 ? 1 : +(cs[0] + cs[1]));
!XS && fx && (cs = fx.match(/Edge\/(\d+)/), (!cs || cs[1] >= 74) && (cs = fx.match(/Chrome\/(\d+)/), cs && (XS = +cs[1])));
var d0r = XS, cte = d0r, p0r = zu, h0r = ju, v0r = h0r.String, a_e = !!Object.getOwnPropertySymbols && !p0r(function() {
  var e = Symbol("symbol detection");
  return !v0r(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && cte && cte < 41;
}), E0r = a_e, u_e = E0r && !Symbol.sham && typeof Symbol.iterator == "symbol", m0r = Ed, g0r = aa, T0r = Z7, y0r = u_e, _0r = Object, s_e = y0r ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = m0r("Symbol");
  return g0r(t) && T0r(t.prototype, _0r(e));
}, A0r = String, Q7 = function(e) {
  try {
    return A0r(e);
  } catch {
    return "Object";
  }
}, S0r = aa, b0r = Q7, C0r = TypeError, Ly = function(e) {
  if (S0r(e)) return e;
  throw new C0r(b0r(e) + " is not a function");
}, I0r = Ly, O0r = $3, By = function(e, t) {
  var r = e[t];
  return O0r(r) ? void 0 : I0r(r);
}, dx = sl, px = aa, hx = cl, R0r = TypeError, w0r = function(e, t) {
  var r, n;
  if (t === "string" && px(r = e.toString) && !hx(n = dx(r, e)) || px(r = e.valueOf) && !hx(n = dx(r, e)) || t !== "string" && px(r = e.toString) && !hx(n = dx(r, e))) return n;
  throw new R0r("Can't convert object to primitive value");
}, c_e = { exports: {} }, lte = ju, P0r = Object.defineProperty, eH = function(e, t) {
  try {
    P0r(lte, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    lte[e] = t;
  }
  return t;
}, D0r = ju, x0r = eH, fte = "__core-js_shared__", dte = c_e.exports = D0r[fte] || x0r(fte, {});
(dte.versions || (dte.versions = [])).push({
  version: "3.37.0",
  mode: "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var tH = c_e.exports, pte = tH, l_e = function(e, t) {
  return pte[e] || (pte[e] = t || {});
}, N0r = U3, L0r = Object, f_e = function(e) {
  return L0r(N0r(e));
}, B0r = Va, k0r = f_e, M0r = B0r({}.hasOwnProperty), dc = Object.hasOwn || function(t, r) {
  return M0r(k0r(t), r);
}, F0r = Va, H0r = 0, $0r = Math.random(), U0r = F0r(1 .toString), d_e = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + U0r(++H0r + $0r, 36);
}, V0r = ju, j0r = l_e, hte = dc, z0r = d_e, q0r = a_e, Y0r = u_e, hp = V0r.Symbol, vx = j0r("wks"), G0r = Y0r ? hp.for || hp : hp && hp.withoutSetter || z0r, ja = function(e) {
  return hte(vx, e) || (vx[e] = q0r && hte(hp, e) ? hp[e] : G0r("Symbol." + e)), vx[e];
}, W0r = sl, vte = cl, Ete = s_e, K0r = By, X0r = w0r, J0r = ja, Z0r = TypeError, Q0r = J0r("toPrimitive"), efr = function(e, t) {
  if (!vte(e) || Ete(e)) return e;
  var r = K0r(e, Q0r), n;
  if (r) {
    if (t === void 0 && (t = "default"), n = W0r(r, e, t), !vte(n) || Ete(n)) return n;
    throw new Z0r("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), X0r(e, t);
}, tfr = efr, rfr = s_e, p_e = function(e) {
  var t = tfr(e, "string");
  return rfr(t) ? t : t + "";
}, nfr = ju, mte = cl, VB = nfr.document, ifr = mte(VB) && mte(VB.createElement), rH = function(e) {
  return ifr ? VB.createElement(e) : {};
}, ofr = qu, afr = zu, ufr = rH, h_e = !ofr && !afr(function() {
  return Object.defineProperty(ufr("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), sfr = qu, cfr = sl, lfr = K7, ffr = X7, dfr = Xh, pfr = p_e, hfr = dc, vfr = h_e, gte = Object.getOwnPropertyDescriptor;
G7.f = sfr ? gte : function(t, r) {
  if (t = dfr(t), r = pfr(r), vfr) try {
    return gte(t, r);
  } catch {
  }
  if (hfr(t, r)) return ffr(!cfr(lfr.f, t, r), t[r]);
};
var pc = {}, Efr = qu, mfr = zu, v_e = Efr && mfr(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), gfr = cl, Tfr = String, yfr = TypeError, ll = function(e) {
  if (gfr(e)) return e;
  throw new yfr(Tfr(e) + " is not an object");
}, _fr = qu, Afr = h_e, Sfr = v_e, OA = ll, Tte = p_e, bfr = TypeError, Ex = Object.defineProperty, Cfr = Object.getOwnPropertyDescriptor, mx = "enumerable", gx = "configurable", Tx = "writable";
pc.f = _fr ? Sfr ? function(t, r, n) {
  if (OA(t), r = Tte(r), OA(n), typeof t == "function" && r === "prototype" && "value" in n && Tx in n && !n[Tx]) {
    var i = Cfr(t, r);
    i && i[Tx] && (t[r] = n.value, n = {
      configurable: gx in n ? n[gx] : i[gx],
      enumerable: mx in n ? n[mx] : i[mx],
      writable: !1
    });
  }
  return Ex(t, r, n);
} : Ex : function(t, r, n) {
  if (OA(t), r = Tte(r), OA(n), Afr) try {
    return Ex(t, r, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw new bfr("Accessors not supported");
  return "value" in n && (t[r] = n.value), t;
};
var Ifr = qu, Ofr = pc, Rfr = X7, V3 = Ifr ? function(e, t, r) {
  return Ofr.f(e, t, Rfr(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, E_e = { exports: {} }, jB = qu, wfr = dc, m_e = Function.prototype, Pfr = jB && Object.getOwnPropertyDescriptor, nH = wfr(m_e, "name"), Dfr = nH && (function() {
}).name === "something", xfr = nH && (!jB || jB && Pfr(m_e, "name").configurable), g_e = {
  EXISTS: nH,
  PROPER: Dfr,
  CONFIGURABLE: xfr
}, Nfr = Va, Lfr = aa, zB = tH, Bfr = Nfr(Function.toString);
Lfr(zB.inspectSource) || (zB.inspectSource = function(e) {
  return Bfr(e);
});
var T_e = zB.inspectSource, kfr = ju, Mfr = aa, yte = kfr.WeakMap, Ffr = Mfr(yte) && /native code/.test(String(yte)), Hfr = l_e, $fr = d_e, _te = Hfr("keys"), iH = function(e) {
  return _te[e] || (_te[e] = $fr(e));
}, oH = {}, Ufr = Ffr, y_e = ju, Vfr = cl, jfr = V3, yx = dc, _x = tH, zfr = iH, qfr = oH, Ate = "Object already initialized", qB = y_e.TypeError, Yfr = y_e.WeakMap, JS, aT, ZS, Gfr = function(e) {
  return ZS(e) ? aT(e) : JS(e, {});
}, Wfr = function(e) {
  return function(t) {
    var r;
    if (!Vfr(t) || (r = aT(t)).type !== e)
      throw new qB("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (Ufr || _x.state) {
  var Fs = _x.state || (_x.state = new Yfr());
  Fs.get = Fs.get, Fs.has = Fs.has, Fs.set = Fs.set, JS = function(e, t) {
    if (Fs.has(e)) throw new qB(Ate);
    return t.facade = e, Fs.set(e, t), t;
  }, aT = function(e) {
    return Fs.get(e) || {};
  }, ZS = function(e) {
    return Fs.has(e);
  };
} else {
  var Gd = zfr("state");
  qfr[Gd] = !0, JS = function(e, t) {
    if (yx(e, Gd)) throw new qB(Ate);
    return t.facade = e, jfr(e, Gd, t), t;
  }, aT = function(e) {
    return yx(e, Gd) ? e[Gd] : {};
  }, ZS = function(e) {
    return yx(e, Gd);
  };
}
var j3 = {
  set: JS,
  get: aT,
  has: ZS,
  enforce: Gfr,
  getterFor: Wfr
}, aH = Va, Kfr = zu, Xfr = aa, RA = dc, YB = qu, Jfr = g_e.CONFIGURABLE, Zfr = T_e, __e = j3, Qfr = __e.enforce, edr = __e.get, Ste = String, z4 = Object.defineProperty, tdr = aH("".slice), rdr = aH("".replace), ndr = aH([].join), idr = YB && !Kfr(function() {
  return z4(function() {
  }, "length", { value: 8 }).length !== 8;
}), odr = String(String).split("String"), adr = E_e.exports = function(e, t, r) {
  tdr(Ste(t), 0, 7) === "Symbol(" && (t = "[" + rdr(Ste(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!RA(e, "name") || Jfr && e.name !== t) && (YB ? z4(e, "name", { value: t, configurable: !0 }) : e.name = t), idr && r && RA(r, "arity") && e.length !== r.arity && z4(e, "length", { value: r.arity });
  try {
    r && RA(r, "constructor") && r.constructor ? YB && z4(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch {
  }
  var n = Qfr(e);
  return RA(n, "source") || (n.source = ndr(odr, typeof t == "string" ? t : "")), e;
};
Function.prototype.toString = adr(function() {
  return Xfr(this) && edr(this).source || Zfr(this);
}, "toString");
var A_e = E_e.exports, udr = aa, sdr = pc, cdr = A_e, ldr = eH, Jh = function(e, t, r, n) {
  n || (n = {});
  var i = n.enumerable, o = n.name !== void 0 ? n.name : t;
  if (udr(r) && cdr(r, o, n), n.global)
    i ? e[t] = r : ldr(t, r);
  else {
    try {
      n.unsafe ? e[t] && (i = !0) : delete e[t];
    } catch {
    }
    i ? e[t] = r : sdr.f(e, t, {
      value: r,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, S_e = {}, fdr = Math.ceil, ddr = Math.floor, pdr = Math.trunc || function(t) {
  var r = +t;
  return (r > 0 ? ddr : fdr)(r);
}, hdr = pdr, uH = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : hdr(t);
}, vdr = uH, Edr = Math.max, mdr = Math.min, gdr = function(e, t) {
  var r = vdr(e);
  return r < 0 ? Edr(r + t, 0) : mdr(r, t);
}, Tdr = uH, ydr = Math.min, _dr = function(e) {
  var t = Tdr(e);
  return t > 0 ? ydr(t, 9007199254740991) : 0;
}, Adr = _dr, b_e = function(e) {
  return Adr(e.length);
}, Sdr = Xh, bdr = gdr, Cdr = b_e, bte = function(e) {
  return function(t, r, n) {
    var i = Sdr(t), o = Cdr(i);
    if (o === 0) return !e && -1;
    var a = bdr(n, o), u;
    if (e && r !== r) {
      for (; o > a; )
        if (u = i[a++], u !== u) return !0;
    } else for (; o > a; a++)
      if ((e || a in i) && i[a] === r) return e || a || 0;
    return !e && -1;
  };
}, Idr = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: bte(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: bte(!1)
}, Odr = Va, Ax = dc, Rdr = Xh, wdr = Idr.indexOf, Pdr = oH, Cte = Odr([].push), C_e = function(e, t) {
  var r = Rdr(e), n = 0, i = [], o;
  for (o in r) !Ax(Pdr, o) && Ax(r, o) && Cte(i, o);
  for (; t.length > n; ) Ax(r, o = t[n++]) && (~wdr(i, o) || Cte(i, o));
  return i;
}, sH = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Ddr = C_e, xdr = sH, Ndr = xdr.concat("length", "prototype");
S_e.f = Object.getOwnPropertyNames || function(t) {
  return Ddr(t, Ndr);
};
var I_e = {};
I_e.f = Object.getOwnPropertySymbols;
var Ldr = Ed, Bdr = Va, kdr = S_e, Mdr = I_e, Fdr = ll, Hdr = Bdr([].concat), $dr = Ldr("Reflect", "ownKeys") || function(t) {
  var r = kdr.f(Fdr(t)), n = Mdr.f;
  return n ? Hdr(r, n(t)) : r;
}, Ite = dc, Udr = $dr, Vdr = G7, jdr = pc, zdr = function(e, t, r) {
  for (var n = Udr(t), i = jdr.f, o = Vdr.f, a = 0; a < n.length; a++) {
    var u = n[a];
    !Ite(e, u) && !(r && Ite(r, u)) && i(e, u, o(t, u));
  }
}, qdr = zu, Ydr = aa, Gdr = /#|\.prototype\./, ky = function(e, t) {
  var r = Kdr[Wdr(e)];
  return r === Jdr ? !0 : r === Xdr ? !1 : Ydr(t) ? qdr(t) : !!t;
}, Wdr = ky.normalize = function(e) {
  return String(e).replace(Gdr, ".").toLowerCase();
}, Kdr = ky.data = {}, Xdr = ky.NATIVE = "N", Jdr = ky.POLYFILL = "P", Zdr = ky, wA = ju, Qdr = G7.f, epr = V3, tpr = Jh, rpr = eH, npr = zdr, ipr = Zdr, My = function(e, t) {
  var r = e.target, n = e.global, i = e.stat, o, a, u, s, c, l;
  if (n ? a = wA : i ? a = wA[r] || rpr(r, {}) : a = wA[r] && wA[r].prototype, a) for (u in t) {
    if (c = t[u], e.dontCallGetSet ? (l = Qdr(a, u), s = l && l.value) : s = a[u], o = ipr(n ? u : r + (i ? "." : "#") + u, e.forced), !o && s !== void 0) {
      if (typeof c == typeof s) continue;
      npr(c, s);
    }
    (e.sham || s && s.sham) && epr(c, "sham", !0), tpr(a, u, c, e);
  }
}, opr = zu, apr = !opr(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), upr = dc, spr = aa, cpr = f_e, lpr = iH, fpr = apr, Ote = lpr("IE_PROTO"), GB = Object, dpr = GB.prototype, cH = fpr ? GB.getPrototypeOf : function(e) {
  var t = cpr(e);
  if (upr(t, Ote)) return t[Ote];
  var r = t.constructor;
  return spr(r) && t instanceof r ? r.prototype : t instanceof GB ? dpr : null;
}, ppr = C_e, hpr = sH, O_e = Object.keys || function(t) {
  return ppr(t, hpr);
}, R_e = qu, vpr = zu, w_e = Va, Epr = cH, mpr = O_e, gpr = Xh, Tpr = K7.f, P_e = w_e(Tpr), ypr = w_e([].push), _pr = R_e && vpr(function() {
  var e = /* @__PURE__ */ Object.create(null);
  return e[2] = 2, !P_e(e, 2);
}), Rte = function(e) {
  return function(t) {
    for (var r = gpr(t), n = mpr(r), i = _pr && Epr(r) === null, o = n.length, a = 0, u = [], s; o > a; )
      s = n[a++], (!R_e || (i ? s in r : P_e(r, s))) && ypr(u, e ? [s, r[s]] : r[s]);
    return u;
  };
}, Apr = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: Rte(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: Rte(!1)
}, Spr = My, bpr = Apr.entries;
Spr({ target: "Object", stat: !0 }, {
  entries: function(t) {
    return bpr(t);
  }
});
var Cpr = ju, lH = Cpr, Ipr = lH;
Ipr.Object.entries;
var WB = { exports: {} }, wte = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (wte) {
  var Pte = new Uint8Array(16);
  WB.exports = function() {
    return wte(Pte), Pte;
  };
} else {
  var Dte = new Array(16);
  WB.exports = function() {
    for (var t = 0, r; t < 16; t++)
      t & 3 || (r = Math.random() * 4294967296), Dte[t] = r >>> ((t & 3) << 3) & 255;
    return Dte;
  };
}
var D_e = WB.exports, x_e = [];
for (var PA = 0; PA < 256; ++PA)
  x_e[PA] = (PA + 256).toString(16).substr(1);
function Opr(e, t) {
  var r = t || 0, n = x_e;
  return [
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]]
  ].join("");
}
var N_e = Opr, Rpr = D_e, wpr = N_e, xte, Sx, bx = 0, Cx = 0;
function Ppr(e, t, r) {
  var n = t && r || 0, i = t || [];
  e = e || {};
  var o = e.node || xte, a = e.clockseq !== void 0 ? e.clockseq : Sx;
  if (o == null || a == null) {
    var u = Rpr();
    o == null && (o = xte = [
      u[0] | 1,
      u[1],
      u[2],
      u[3],
      u[4],
      u[5]
    ]), a == null && (a = Sx = (u[6] << 8 | u[7]) & 16383);
  }
  var s = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), c = e.nsecs !== void 0 ? e.nsecs : Cx + 1, l = s - bx + (c - Cx) / 1e4;
  if (l < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (l < 0 || s > bx) && e.nsecs === void 0 && (c = 0), c >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  bx = s, Cx = c, Sx = a, s += 122192928e5;
  var f = ((s & 268435455) * 1e4 + c) % 4294967296;
  i[n++] = f >>> 24 & 255, i[n++] = f >>> 16 & 255, i[n++] = f >>> 8 & 255, i[n++] = f & 255;
  var d = s / 4294967296 * 1e4 & 268435455;
  i[n++] = d >>> 8 & 255, i[n++] = d & 255, i[n++] = d >>> 24 & 15 | 16, i[n++] = d >>> 16 & 255, i[n++] = a >>> 8 | 128, i[n++] = a & 255;
  for (var p = 0; p < 6; ++p)
    i[n + p] = o[p];
  return t || wpr(i);
}
var Dpr = Ppr, xpr = D_e, Npr = N_e;
function Lpr(e, t, r) {
  var n = t && r || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var i = e.random || (e.rng || xpr)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t)
    for (var o = 0; o < 16; ++o)
      t[n + o] = i[o];
  return t || Npr(i);
}
var Bpr = Lpr, kpr = Dpr, L_e = Bpr, fH = L_e;
fH.v1 = kpr;
fH.v4 = L_e;
var B_e = fH;
const KB = () => B_e.v4(), Ei = () => KB().replace(new RegExp("-", "g"), "").toUpperCase();
var qn;
(function(e) {
  e[e.Debug = 0] = "Debug", e[e.Info = 1] = "Info", e[e.Warning = 2] = "Warning", e[e.Error = 3] = "Error";
})(qn || (qn = {}));
let v0 = class {
  constructor(t, r) {
    this.privName = t, this.privEventId = Ei(), this.privEventTime = (/* @__PURE__ */ new Date()).toISOString(), this.privEventType = r, this.privMetadata = {};
  }
  get name() {
    return this.privName;
  }
  get eventId() {
    return this.privEventId;
  }
  get eventTime() {
    return this.privEventTime;
  }
  get eventType() {
    return this.privEventType;
  }
  get metadata() {
    return this.privMetadata;
  }
};
class Fy extends v0 {
  constructor(t, r, n = qn.Info) {
    super(t, n), this.privAudioSourceId = r;
  }
  get audioSourceId() {
    return this.privAudioSourceId;
  }
}
class z3 extends Fy {
  constructor(t) {
    super("AudioSourceInitializingEvent", t);
  }
}
class uT extends Fy {
  constructor(t) {
    super("AudioSourceReadyEvent", t);
  }
}
class k_e extends Fy {
  constructor(t) {
    super("AudioSourceOffEvent", t);
  }
}
class QS extends Fy {
  constructor(t, r) {
    super("AudioSourceErrorEvent", t, qn.Error), this.privError = r;
  }
  get error() {
    return this.privError;
  }
}
class q3 extends Fy {
  constructor(t, r, n) {
    super(t, r), this.privAudioNodeId = n;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
}
class Hy extends q3 {
  constructor(t, r) {
    super("AudioStreamNodeAttachingEvent", t, r);
  }
}
class $y extends q3 {
  constructor(t, r) {
    super("AudioStreamNodeAttachedEvent", t, r);
  }
}
class Qc extends q3 {
  constructor(t, r) {
    super("AudioStreamNodeDetachedEvent", t, r);
  }
}
class dH extends q3 {
  constructor(t, r, n) {
    super("AudioStreamNodeErrorEvent", t, r), this.privError = n;
  }
  get error() {
    return this.privError;
  }
}
class pH extends v0 {
  constructor(t, r, n = qn.Info) {
    super(t, n), this.privJsonResult = r;
  }
  get jsonString() {
    return this.privJsonResult;
  }
}
class md extends v0 {
  constructor(t, r, n = qn.Info) {
    super(t, n), this.privConnectionId = r;
  }
  get connectionId() {
    return this.privConnectionId;
  }
}
class M_e extends md {
  constructor(t, r, n) {
    super("ConnectionStartEvent", t), this.privUri = r, this.privHeaders = n;
  }
  get uri() {
    return this.privUri;
  }
  get headers() {
    return this.privHeaders;
  }
}
class F_e extends md {
  constructor(t, r) {
    super("ConnectionEstablishedEvent", t);
  }
}
class Mpr extends md {
  constructor(t, r, n) {
    super("ConnectionClosedEvent", t, qn.Debug), this.privReason = n, this.privStatusCode = r;
  }
  get reason() {
    return this.privReason;
  }
  get statusCode() {
    return this.privStatusCode;
  }
}
class Fpr extends md {
  constructor(t, r, n) {
    super("ConnectionErrorEvent", t, qn.Debug), this.privMessage = r, this.privType = n;
  }
  get message() {
    return this.privMessage;
  }
  get type() {
    return this.privType;
  }
}
class Hpr extends md {
  constructor(t, r, n) {
    super("ConnectionEstablishErrorEvent", t, qn.Error), this.privStatusCode = r, this.privReason = n;
  }
  get reason() {
    return this.privReason;
  }
  get statusCode() {
    return this.privStatusCode;
  }
}
class XB extends md {
  constructor(t, r, n) {
    super("ConnectionMessageReceivedEvent", t), this.privNetworkReceivedTime = r, this.privMessage = n;
  }
  get networkReceivedTime() {
    return this.privNetworkReceivedTime;
  }
  get message() {
    return this.privMessage;
  }
}
class $pr extends md {
  constructor(t, r, n) {
    super("ConnectionMessageSentEvent", t), this.privNetworkSentTime = r, this.privMessage = n;
  }
  get networkSentTime() {
    return this.privNetworkSentTime;
  }
  get message() {
    return this.privMessage;
  }
}
class bo extends Error {
  /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */
  constructor(t) {
    super(t), this.name = "ArgumentNull", this.message = t;
  }
}
class Na extends Error {
  /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */
  constructor(t) {
    super(t), this.name = "InvalidOperation", this.message = t;
  }
}
class hH extends Error {
  /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */
  constructor(t, r) {
    super(r), this.name = t + "ObjectDisposed", this.message = r;
  }
}
var Jr;
(function(e) {
  e[e.Text = 0] = "Text", e[e.Binary = 1] = "Binary";
})(Jr || (Jr = {}));
let JB = class {
  constructor(t, r, n, i) {
    if (this.privBody = null, t === Jr.Text && r && typeof r != "string")
      throw new Na("Payload must be a string");
    if (t === Jr.Binary && r && !(r instanceof ArrayBuffer))
      throw new Na("Payload must be ArrayBuffer");
    switch (this.privMessageType = t, this.privBody = r, this.privHeaders = n || {}, this.privId = i || Ei(), this.messageType) {
      case Jr.Binary:
        this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
        break;
      case Jr.Text:
        this.privSize = this.textBody.length;
    }
  }
  get messageType() {
    return this.privMessageType;
  }
  get headers() {
    return this.privHeaders;
  }
  get body() {
    return this.privBody;
  }
  get textBody() {
    if (this.privMessageType === Jr.Binary)
      throw new Na("Not supported for binary message");
    return this.privBody;
  }
  get binaryBody() {
    if (this.privMessageType === Jr.Text)
      throw new Na("Not supported for text message");
    return this.privBody;
  }
  get id() {
    return this.privId;
  }
}, Ix = class {
  constructor(t, r) {
    this.privStatusCode = t, this.privReason = r;
  }
  get statusCode() {
    return this.privStatusCode;
  }
  get reason() {
    return this.privReason;
  }
};
class Upr extends v0 {
  constructor(t, r = qn.Info) {
    super(t, r);
  }
}
class Vpr extends Upr {
  constructor(t) {
    super("SendingAgentContextMessageEvent"), this.privAgentConfig = t;
  }
  get agentConfig() {
    return this.privAgentConfig;
  }
}
let ms = class {
  constructor(t) {
    this.privEventListeners = {}, this.privIsDisposed = !1, this.onEvent = (r) => {
      if (this.isDisposed())
        throw new hH("EventSource");
      if (this.metadata)
        for (const n in this.metadata)
          n && r.metadata && (r.metadata[n] || (r.metadata[n] = this.metadata[n]));
      for (const n in this.privEventListeners)
        n && this.privEventListeners[n] && this.privEventListeners[n](r);
    }, this.attach = (r) => {
      const n = Ei();
      return this.privEventListeners[n] = r, {
        detach: () => (delete this.privEventListeners[n], Promise.resolve())
      };
    }, this.attachListener = (r) => this.attach(r.onEvent), this.isDisposed = () => this.privIsDisposed, this.dispose = () => {
      this.privEventListeners = null, this.privIsDisposed = !0;
    }, this.privMetadata = t;
  }
  get metadata() {
    return this.privMetadata;
  }
}, fo = class H_e {
  static get instance() {
    return H_e.privInstance;
  }
};
fo.privInstance = new ms();
fo.setEventSource = (e) => {
  if (!e)
    throw new bo("eventSource");
  fo.privInstance = e;
};
var uo;
(function(e) {
  e[e.None = 0] = "None", e[e.Connected = 1] = "Connected", e[e.Connecting = 2] = "Connecting", e[e.Disconnected = 3] = "Disconnected";
})(uo || (uo = {}));
let Ox = class nf {
  constructor(t) {
    if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.get = (r) => (this.throwIfDisposed(), this.privList[r]), this.first = () => this.get(0), this.last = () => this.get(this.length() - 1), this.add = (r) => {
      this.throwIfDisposed(), this.insertAt(this.privList.length, r);
    }, this.insertAt = (r, n) => {
      this.throwIfDisposed(), r === 0 ? this.privList.unshift(n) : r === this.privList.length ? this.privList.push(n) : this.privList.splice(r, 0, n), this.triggerSubscriptions(this.privAddSubscriptions);
    }, this.removeFirst = () => (this.throwIfDisposed(), this.removeAt(0)), this.removeLast = () => (this.throwIfDisposed(), this.removeAt(this.length() - 1)), this.removeAt = (r) => (this.throwIfDisposed(), this.remove(r, 1)[0]), this.remove = (r, n) => {
      this.throwIfDisposed();
      const i = this.privList.splice(r, n);
      return this.triggerSubscriptions(this.privRemoveSubscriptions), i;
    }, this.clear = () => {
      this.throwIfDisposed(), this.remove(0, this.length());
    }, this.length = () => (this.throwIfDisposed(), this.privList.length), this.onAdded = (r) => {
      this.throwIfDisposed();
      const n = this.privSubscriptionIdCounter++;
      return this.privAddSubscriptions[n] = r, {
        detach: () => (delete this.privAddSubscriptions[n], Promise.resolve())
      };
    }, this.onRemoved = (r) => {
      this.throwIfDisposed();
      const n = this.privSubscriptionIdCounter++;
      return this.privRemoveSubscriptions[n] = r, {
        detach: () => (delete this.privRemoveSubscriptions[n], Promise.resolve())
      };
    }, this.onDisposed = (r) => {
      this.throwIfDisposed();
      const n = this.privSubscriptionIdCounter++;
      return this.privDisposedSubscriptions[n] = r, {
        detach: () => (delete this.privDisposedSubscriptions[n], Promise.resolve())
      };
    }, this.join = (r) => (this.throwIfDisposed(), this.privList.join(r)), this.toArray = () => {
      const r = Array();
      return this.privList.forEach((n) => {
        r.push(n);
      }), r;
    }, this.any = (r) => (this.throwIfDisposed(), r ? this.where(r).length() > 0 : this.length() > 0), this.all = (r) => (this.throwIfDisposed(), this.where(r).length() === this.length()), this.forEach = (r) => {
      this.throwIfDisposed();
      for (let n = 0; n < this.length(); n++)
        r(this.privList[n], n);
    }, this.select = (r) => {
      this.throwIfDisposed();
      const n = [];
      for (let i = 0; i < this.privList.length; i++)
        n.push(r(this.privList[i], i));
      return new nf(n);
    }, this.where = (r) => {
      this.throwIfDisposed();
      const n = new nf();
      for (let i = 0; i < this.privList.length; i++)
        r(this.privList[i], i) && n.add(this.privList[i]);
      return n;
    }, this.orderBy = (r) => {
      this.throwIfDisposed();
      const i = this.toArray().sort(r);
      return new nf(i);
    }, this.orderByDesc = (r) => (this.throwIfDisposed(), this.orderBy((n, i) => r(i, n))), this.clone = () => (this.throwIfDisposed(), new nf(this.toArray())), this.concat = (r) => (this.throwIfDisposed(), new nf(this.privList.concat(r.toArray()))), this.concatArray = (r) => (this.throwIfDisposed(), new nf(this.privList.concat(r))), this.isDisposed = () => this.privList == null, this.dispose = (r) => {
      this.isDisposed() || (this.privDisposeReason = r, this.privList = null, this.privAddSubscriptions = null, this.privRemoveSubscriptions = null, this.triggerSubscriptions(this.privDisposedSubscriptions));
    }, this.throwIfDisposed = () => {
      if (this.isDisposed())
        throw new hH("List", this.privDisposeReason);
    }, this.triggerSubscriptions = (r) => {
      if (r)
        for (const n in r)
          n && r[n]();
    }, this.privList = [], t)
      for (const r of t)
        this.privList.push(r);
  }
};
var Nte;
(function(e) {
  e[e.None = 0] = "None", e[e.Resolved = 1] = "Resolved", e[e.Rejected = 2] = "Rejected";
})(Nte || (Nte = {}));
class Wi {
  constructor() {
    this.resolve = (t) => (this.privResolve(t), this), this.reject = (t) => (this.privReject(t), this), this.privPromise = new Promise((t, r) => {
      this.privResolve = t, this.privReject = r;
    });
  }
  get promise() {
    return this.privPromise;
  }
}
function ip(e, t, r) {
  e.then((n) => {
    try {
      t && t(n);
    } catch (i) {
      if (r)
        try {
          if (i instanceof Error) {
            const o = i;
            r(o.name + ": " + o.message);
          } else
            r(i);
        } catch {
        }
    }
  }, (n) => {
    if (r)
      try {
        if (n instanceof Error) {
          const i = n;
          r(i.name + ": " + i.message);
        } else
          r(n);
      } catch {
      }
  });
}
var Lte = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, O1;
(function(e) {
  e[e.Dequeue = 0] = "Dequeue", e[e.Peek = 1] = "Peek";
})(O1 || (O1 = {}));
let eb = class {
  constructor(t) {
    this.privPromiseStore = new Ox(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.enqueue = (r) => {
      this.throwIfDispose(), this.enqueueFromPromise(new Promise((n, i) => {
        n(r);
      }));
    }, this.enqueueFromPromise = (r) => {
      this.throwIfDispose(), r.then((n) => {
        this.privList.add(n);
      }, (n) => {
      });
    }, this.dequeue = () => {
      this.throwIfDispose();
      const r = new Wi();
      return this.privSubscribers && (this.privSubscribers.add({ deferral: r, type: O1.Dequeue }), this.drain()), r.promise;
    }, this.peek = () => {
      this.throwIfDispose();
      const r = new Wi();
      return this.privSubscribers && (this.privSubscribers.add({ deferral: r, type: O1.Peek }), this.drain()), r.promise;
    }, this.length = () => (this.throwIfDispose(), this.privList.length()), this.isDisposed = () => this.privSubscribers == null, this.drain = () => {
      if (!this.privIsDrainInProgress && !this.privIsDisposing) {
        this.privIsDrainInProgress = !0;
        const r = this.privSubscribers, n = this.privList;
        if (r && n) {
          for (; n.length() > 0 && r.length() > 0 && !this.privIsDisposing; ) {
            const i = r.removeFirst();
            if (i.type === O1.Peek)
              i.deferral.resolve(n.first());
            else {
              const o = n.removeFirst();
              i.deferral.resolve(o);
            }
          }
          this.privSubscribers === r && (this.privSubscribers = r), this.privList === n && (this.privList = n);
        }
        this.privIsDrainInProgress = !1;
      }
    }, this.throwIfDispose = () => {
      if (this.isDisposed())
        throw this.privDisposeReason ? new Na(this.privDisposeReason) : new hH("Queue");
      if (this.privIsDisposing)
        throw new Na("Queue disposing");
    }, this.privList = t || new Ox(), this.privDetachables = [], this.privSubscribers = new Ox(), this.privDetachables.push(this.privList.onAdded(this.drain));
  }
  drainAndDispose(t, r) {
    return Lte(this, void 0, void 0, function* () {
      if (!this.isDisposed() && !this.privIsDisposing) {
        this.privDisposeReason = r, this.privIsDisposing = !0;
        const n = this.privSubscribers;
        if (n) {
          for (; n.length() > 0; )
            n.removeFirst().deferral.resolve(void 0);
          this.privSubscribers === n && (this.privSubscribers = n);
        }
        for (const i of this.privDetachables)
          yield i.detach();
        if (this.privPromiseStore.length() > 0 && t) {
          const i = [];
          return this.privPromiseStore.toArray().forEach((o) => {
            i.push(o);
          }), Promise.all(i).finally(() => {
            this.privSubscribers = null, this.privList.forEach((o, a) => {
              t(o);
            }), this.privList = null;
          }).then();
        } else
          this.privSubscribers = null, this.privList = null;
      }
    });
  }
  dispose(t) {
    return Lte(this, void 0, void 0, function* () {
      yield this.drainAndDispose(null, t);
    });
  }
}, tb = class {
  constructor(t, r, n) {
    if (this.privPayload = null, !r)
      throw new bo("payload");
    if (t === Jr.Binary && r.__proto__.constructor.name !== "ArrayBuffer")
      throw new Na("Payload must be ArrayBuffer");
    if (t === Jr.Text && typeof r != "string")
      throw new Na("Payload must be a string");
    this.privMessageType = t, this.privPayload = r, this.privId = n || Ei();
  }
  get messageType() {
    return this.privMessageType;
  }
  get payload() {
    return this.privPayload;
  }
  get textContent() {
    if (this.privMessageType === Jr.Binary)
      throw new Na("Not supported for binary message");
    return this.privPayload;
  }
  get binaryContent() {
    if (this.privMessageType === Jr.Text)
      throw new Na("Not supported for text message");
    return this.privPayload;
  }
  get id() {
    return this.privId;
  }
}, jpr = class {
  constructor(t, r) {
    this.encode = (n) => {
      const i = this.downSampleAudioFrame(n, this.privActualSampleRate, this.privDesiredSampleRate);
      if (!i)
        return null;
      const o = i.length * 2, a = new ArrayBuffer(o), u = new DataView(a);
      return this.floatTo16BitPCM(u, 0, i), a;
    }, this.setString = (n, i, o) => {
      for (let a = 0; a < o.length; a++)
        n.setUint8(i + a, o.charCodeAt(a));
    }, this.floatTo16BitPCM = (n, i, o) => {
      for (let a = 0; a < o.length; a++, i += 2) {
        const u = Math.max(-1, Math.min(1, o[a]));
        n.setInt16(i, u < 0 ? u * 32768 : u * 32767, !0);
      }
    }, this.downSampleAudioFrame = (n, i, o) => {
      if (o === i || o > i)
        return n;
      const a = i / o, u = Math.round(n.length / a), s = new Float32Array(u);
      let c = 0, l = 0;
      for (; l < u; ) {
        const f = Math.round((l + 1) * a);
        let d = 0, p = 0;
        for (; c < f && c < n.length; )
          d += n[c++], p++;
        s[l++] = d / p;
      }
      return s;
    }, this.privActualSampleRate = t, this.privDesiredSampleRate = r;
  }
};
var zpr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let $_e = class {
  constructor(t) {
    this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.read = () => {
      if (this.privIsReadEnded)
        throw new Na("Stream read has already finished");
      return this.privReaderQueue.dequeue().then((r) => zpr(this, void 0, void 0, function* () {
        return (r === void 0 || r.isEnd) && (yield this.privReaderQueue.dispose("End of stream reached")), r;
      }));
    }, this.readEnded = () => {
      this.privIsReadEnded || (this.privIsReadEnded = !0, this.privReaderQueue = new eb());
    }, this.throwIfClosed = () => {
      if (this.privIsWriteEnded)
        throw new Na("Stream closed");
    }, this.privId = t || Ei(), this.privReaderQueue = new eb();
  }
  get isClosed() {
    return this.privIsWriteEnded;
  }
  get isReadEnded() {
    return this.privIsReadEnded;
  }
  get id() {
    return this.privId;
  }
  close() {
    this.privIsWriteEnded || (this.writeStreamChunk({
      buffer: null,
      isEnd: !0,
      timeReceived: Date.now()
    }), this.privIsWriteEnded = !0);
  }
  writeStreamChunk(t) {
    if (this.throwIfClosed(), !this.privReaderQueue.isDisposed())
      try {
        this.privReaderQueue.enqueue(t);
      } catch {
      }
  }
}, vH = class extends $_e {
  constructor(t, r) {
    super(r), this.privTargetChunkSize = t, this.privNextBufferReadyBytes = 0;
  }
  writeStreamChunk(t) {
    if (t.isEnd || this.privNextBufferReadyBytes === 0 && t.buffer.byteLength === this.privTargetChunkSize) {
      super.writeStreamChunk(t);
      return;
    }
    let r = 0;
    for (; r < t.buffer.byteLength; ) {
      this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = t.timeReceived);
      const n = Math.min(t.buffer.byteLength - r, this.privTargetChunkSize - this.privNextBufferReadyBytes), i = new Uint8Array(this.privNextBufferToWrite), o = new Uint8Array(t.buffer.slice(r, n + r));
      i.set(o, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += n, r += n, this.privNextBufferReadyBytes === this.privTargetChunkSize && (super.writeStreamChunk({
        buffer: this.privNextBufferToWrite,
        isEnd: !1,
        timeReceived: this.privNextBufferStartTime
      }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
    }
  }
  close() {
    this.privNextBufferReadyBytes !== 0 && !this.isClosed && super.writeStreamChunk({
      buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
      isEnd: !1,
      timeReceived: this.privNextBufferStartTime
    }), super.close();
  }
}, Yi = class {
};
Yi.workerTimers = null;
Yi.clearTimeout = (e) => Yi.timers().clearTimeout(e);
Yi.setTimeout = (e, t) => Yi.timers().setTimeout(e, t);
Yi.load = (e) => {
  const t = /* @__PURE__ */ new Map([[0, () => {
  }]]), r = /* @__PURE__ */ new Map(), n = new Worker(e);
  return n.addEventListener("message", ({ data: a }) => {
    if (Yi.isCallNotification(a)) {
      const { params: { timerId: u } } = a, s = t.get(u);
      if (typeof s == "number") {
        const c = r.get(s);
        if (c === void 0 || c !== u)
          throw new Error("The timer is in an undefined state.");
      } else if (typeof s < "u")
        s(), t.delete(u);
      else
        throw new Error("The timer is in an undefined state.");
    } else if (Yi.isClearResponse(a)) {
      const { id: u } = a, s = r.get(u);
      if (s === void 0)
        throw new Error("The timer is in an undefined state.");
      r.delete(u), t.delete(s);
    } else {
      const { error: { message: u } } = a;
      throw new Error(u);
    }
  }), {
    clearTimeout: (a) => {
      const u = Math.random();
      r.set(u, a), t.set(a, u), n.postMessage({
        id: u,
        method: "clear",
        params: { timerId: a }
      });
    },
    setTimeout: (a, u) => {
      const s = Math.random();
      return t.set(s, a), n.postMessage({
        id: null,
        method: "set",
        params: {
          delay: u,
          now: performance.now(),
          timerId: s
        }
      }), s;
    }
  };
};
Yi.loadWorkerTimers = () => {
  const e = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
  return () => {
    if (Yi.workerTimers !== null)
      return Yi.workerTimers;
    const t = new Blob([e], { type: "application/javascript; charset=utf-8" }), r = URL.createObjectURL(t);
    return Yi.workerTimers = Yi.load(r), Yi.workerTimers.setTimeout(() => URL.revokeObjectURL(r), 0), Yi.workerTimers;
  };
};
Yi.timers = Yi.loadWorkerTimers();
Yi.isCallNotification = (e) => e.method !== void 0 && e.method === "call";
Yi.isClearResponse = (e) => e.error === null && typeof e.id == "number";
class Sa extends v0 {
  constructor(t, r, n) {
    super(t, r), this.privSignature = n;
  }
}
class qpr extends Sa {
  constructor(t) {
    super("OCSPMemoryCacheHitEvent", qn.Debug, t);
  }
}
class Ypr extends Sa {
  constructor(t) {
    super("OCSPCacheMissEvent", qn.Debug, t);
  }
}
class Gpr extends Sa {
  constructor(t) {
    super("OCSPDiskCacheHitEvent", qn.Debug, t);
  }
}
class Wpr extends Sa {
  constructor(t) {
    super("OCSPCacheUpdateNeededEvent", qn.Debug, t);
  }
}
class Kpr extends Sa {
  constructor(t) {
    super("OCSPMemoryCacheStoreEvent", qn.Debug, t);
  }
}
class Xpr extends Sa {
  constructor(t) {
    super("OCSPDiskCacheStoreEvent", qn.Debug, t);
  }
}
class Jpr extends Sa {
  constructor(t) {
    super("OCSPCacheUpdatehCompleteEvent", qn.Debug, t);
  }
}
class Zpr extends Sa {
  constructor() {
    super("OCSPStapleReceivedEvent", qn.Debug, "");
  }
}
class Qpr extends Sa {
  constructor(t, r) {
    super("OCSPCacheEntryExpiredEvent", qn.Debug, t), this.privExpireTime = r;
  }
}
class ehr extends Sa {
  constructor(t, r, n) {
    super("OCSPCacheEntryNeedsRefreshEvent", qn.Debug, t), this.privExpireTime = n, this.privStartTime = r;
  }
}
class thr extends Sa {
  constructor(t, r, n) {
    super("OCSPCacheHitEvent", qn.Debug, t), this.privExpireTime = n, this.privExpireTimeString = new Date(n).toLocaleDateString(), this.privStartTime = r, this.privStartTimeString = new Date(r).toLocaleTimeString();
  }
}
class rhr extends Sa {
  constructor(t, r) {
    super("OCSPVerificationFailedEvent", qn.Debug, t), this.privError = r;
  }
}
class nhr extends Sa {
  constructor(t, r) {
    super("OCSPCacheFetchErrorEvent", qn.Debug, t), this.privError = r;
  }
}
class ihr extends Sa {
  constructor(t) {
    super("OCSPResponseRetrievedEvent", qn.Debug, t);
  }
}
class ohr extends Sa {
  constructor(t, r) {
    super("OCSPCacheUpdateErrorEvent", qn.Debug, t), this.privError = r;
  }
}
class If extends v0 {
  constructor(t) {
    super("BackgroundEvent", qn.Error), this.privError = t;
  }
  get error() {
    return this.privError;
  }
}
let Ii = class {
};
Ii.AuthKey = "Ocp-Apim-Subscription-Key";
Ii.ConnectionId = "X-ConnectionId";
Ii.ContentType = "Content-Type";
Ii.CustomCommandsAppId = "X-CommandsAppId";
Ii.Path = "Path";
Ii.RequestId = "X-RequestId";
Ii.RequestStreamId = "X-StreamId";
Ii.RequestTimestamp = "X-Timestamp";
class ZB {
  constructor(t, r) {
    this.privHeaderName = t, this.privToken = r;
  }
  get headerName() {
    return this.privHeaderName;
  }
  get token() {
    return this.privToken;
  }
}
let ahr = class {
  /**
   * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
   * @constructor
   * @param {string} subscriptionKey - The subscription key
   */
  constructor(t) {
    if (this.fetch = (r) => Promise.resolve(this.privAuthInfo), this.fetchOnExpiry = (r) => Promise.resolve(this.privAuthInfo), !t)
      throw new bo("subscriptionKey");
    this.privAuthInfo = new ZB(Ii.AuthKey, t);
  }
};
const Bte = "Authorization";
let uhr = class {
  constructor(t, r) {
    if (this.fetch = (n) => this.privFetchCallback(n).then((i) => new ZB(Bte, i)), this.fetchOnExpiry = (n) => this.privFetchOnExpiryCallback(n).then((i) => new ZB(Bte, i)), !t)
      throw new bo("fetchCallback");
    if (!r)
      throw new bo("fetchOnExpiryCallback");
    this.privFetchCallback = t, this.privFetchOnExpiryCallback = r;
  }
}, Vn = class u1 {
  static throwIfNullOrUndefined(t, r) {
    if (t == null)
      throw new Error("throwIfNullOrUndefined:" + r);
  }
  static throwIfNull(t, r) {
    if (t === null)
      throw new Error("throwIfNull:" + r);
  }
  static throwIfNullOrWhitespace(t, r) {
    if (u1.throwIfNullOrUndefined(t, r), ("" + t).trim().length < 1)
      throw new Error("throwIfNullOrWhitespace:" + r);
  }
  static throwIfDisposed(t) {
    if (t)
      throw new Error("the object is already disposed");
  }
  static throwIfArrayEmptyOrWhitespace(t, r) {
    if (u1.throwIfNullOrUndefined(t, r), t.length === 0)
      throw new Error("throwIfArrayEmptyOrWhitespace:" + r);
    for (const n of t)
      u1.throwIfNullOrWhitespace(n, r);
  }
  static throwIfFileDoesNotExist(t, r) {
    u1.throwIfNullOrWhitespace(t, r);
  }
  static throwIfNotUndefined(t, r) {
    if (t !== void 0)
      throw new Error("throwIfNotUndefined:" + r);
  }
}, shr = class {
  constructor(t) {
    this.id = () => this.privId, Vn.throwIfNullOrUndefined(void 0, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = (void 0)(t, "w");
  }
  set format(t) {
    Vn.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = t;
    let r = 0;
    this.privAudioFormat.hasHeader && (r = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = (void 0)("", { fd: this.privFd, start: r, autoClose: !1 }));
  }
  write(t) {
    Vn.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(t.slice(0)));
  }
  close() {
    this.privFd !== void 0 && (this.privWriteStream.on("finish", () => {
      this.privAudioFormat.hasHeader && (this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten), (void 0)(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0)), (void 0)(this.privFd), this.privFd = void 0;
    }), this.privWriteStream.end());
  }
};
var Or;
(function(e) {
  e[e.PCM = 1] = "PCM", e[e.MuLaw = 2] = "MuLaw", e[e.Siren = 3] = "Siren", e[e.MP3 = 4] = "MP3", e[e.SILKSkype = 5] = "SILKSkype", e[e.OGG_OPUS = 6] = "OGG_OPUS", e[e.WEBM_OPUS = 7] = "WEBM_OPUS", e[e.ALaw = 8] = "ALaw";
})(Or || (Or = {}));
let Y3 = class {
  /**
   * Creates an audio stream format object representing the default audio stream
   * format (16KHz 16bit mono PCM).
   * @member AudioStreamFormat.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormat} The audio stream format being created.
   */
  static getDefaultInputFormat() {
    return kf.getDefaultInputFormat();
  }
  /**
   * Creates an audio stream format object with the specified pcm waveformat characteristics.
   * @member AudioStreamFormat.getWaveFormatPCM
   * @function
   * @public
   * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
   * @param {number} bitsPerSample - Bits per sample, typically 16.
   * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
   *        uses one channel and stereo data uses two channels.
   * @returns {AudioStreamFormat} The audio stream format being created.
   */
  static getWaveFormatPCM(t, r, n) {
    return new kf(t, r, n);
  }
};
class kf extends Y3 {
  /**
   * Creates an instance with the given values.
   * @constructor
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {number} channels - Number of channels.
   * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
   */
  constructor(t = 16e3, r = 16, n = 1, i = Or.PCM) {
    switch (super(), this.setString = (a, u, s) => {
      for (let c = 0; c < s.length; c++)
        a.setUint8(u + c, s.charCodeAt(c));
    }, i) {
      case Or.PCM:
        this.formatTag = 1;
        break;
      case Or.ALaw:
        this.formatTag = 6;
        break;
      case Or.MuLaw:
        this.formatTag = 7;
        break;
    }
    this.bitsPerSample = r, this.samplesPerSec = t, this.channels = n, this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8), this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8), this.privHeader = new ArrayBuffer(44);
    const o = new DataView(this.privHeader);
    this.setString(o, 0, "RIFF"), o.setUint32(4, 0, !0), this.setString(o, 8, "WAVEfmt "), o.setUint32(16, 16, !0), o.setUint16(20, this.formatTag, !0), o.setUint16(22, this.channels, !0), o.setUint32(24, this.samplesPerSec, !0), o.setUint32(28, this.avgBytesPerSec, !0), o.setUint16(32, this.channels * (this.bitsPerSample / 8), !0), o.setUint16(34, this.bitsPerSample, !0), this.setString(o, 36, "data"), o.setUint32(40, 0, !0);
  }
  /**
   * Retrieves the default input format.
   * @member AudioStreamFormatImpl.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormatImpl} The default input format.
   */
  static getDefaultInputFormat() {
    return new kf();
  }
  /**
   * Creates an audio context appropriate to current browser
   * @member AudioStreamFormatImpl.getAudioContext
   * @function
   * @public
   * @returns {AudioContext} An audio context instance
   */
  static getAudioContext(t) {
    const r = window.AudioContext || window.webkitAudioContext || !1;
    if (r)
      return t !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new r({ sampleRate: t }) : new r();
    throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
  }
  /**
   * Closes the configuration object.
   * @member AudioStreamFormatImpl.prototype.close
   * @function
   * @public
   */
  close() {
  }
  get header() {
    return this.privHeader;
  }
}
var QB = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let EH = class {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  constructor() {
  }
  /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member AudioInputStream.createPushStream
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The audio input stream being created.
   */
  static createPushStream(t) {
    return U_e.create(t);
  }
  /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
   * and close() methods.
   * @member AudioInputStream.createPullStream
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
   *        PullAudioInputStreamCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
   *        the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The audio input stream being created.
   */
  static createPullStream(t, r) {
    return V_e.create(t, r);
  }
};
class U_e extends EH {
  /**
   * Creates a memory backed PushAudioInputStream with the specified audio format.
   * @member PushAudioInputStream.create
   * @function
   * @public
   * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
   *        push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PushAudioInputStream} The push audio input stream being created.
   */
  static create(t) {
    return new chr(t);
  }
}
class chr extends U_e {
  /**
   * Creates and initalizes an instance with the given values.
   * @constructor
   * @param {AudioStreamFormat} format - The audio stream format.
   */
  constructor(t) {
    super(), this.onEvent = (r) => {
      this.privEvents.onEvent(r), fo.instance.onEvent(r);
    }, t === void 0 ? this.privFormat = kf.getDefaultInputFormat() : this.privFormat = t, this.privEvents = new ms(), this.privId = Ei(), this.privStream = new vH(this.privFormat.avgBytesPerSec / 10);
  }
  /**
   * Format information for the audio
   */
  get format() {
    return Promise.resolve(this.privFormat);
  }
  /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PushAudioInputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */
  write(t) {
    this.privStream.writeStreamChunk({
      buffer: t,
      isEnd: !1,
      timeReceived: Date.now()
    });
  }
  /**
   * Closes the stream.
   * @member PushAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */
  close() {
    this.privStream.close();
  }
  id() {
    return this.privId;
  }
  get blob() {
    return this.attach("id").then((t) => {
      const r = [];
      let n = Buffer.from("");
      const i = () => t.read().then((o) => !o || o.isEnd ? typeof XMLHttpRequest < "u" && typeof Blob < "u" ? Promise.resolve(new Blob(r)) : Promise.resolve(Buffer.from(n)) : (typeof Blob < "u" ? r.push(o.buffer) : n = Buffer.concat([n, this.toBuffer(o.buffer)]), i()));
      return i();
    });
  }
  turnOn() {
    this.onEvent(new z3(this.privId)), this.onEvent(new uT(this.privId));
  }
  attach(t) {
    return QB(this, void 0, void 0, function* () {
      this.onEvent(new Hy(this.privId, t)), yield this.turnOn();
      const r = this.privStream;
      return this.onEvent(new $y(this.privId, t)), {
        detach: () => QB(this, void 0, void 0, function* () {
          return r.readEnded(), this.onEvent(new Qc(this.privId, t)), this.turnOff();
        }),
        id: () => t,
        read: () => r.read()
      };
    });
  }
  detach(t) {
    this.onEvent(new Qc(this.privId, t));
  }
  turnOff() {
  }
  get events() {
    return this.privEvents;
  }
  get deviceInfo() {
    return Promise.resolve({
      bitspersample: this.privFormat.bitsPerSample,
      channelcount: this.privFormat.channels,
      connectivity: nh.Unknown,
      manufacturer: "Speech SDK",
      model: "PushStream",
      samplerate: this.privFormat.samplesPerSec,
      type: Mf.Stream
    });
  }
  toBuffer(t) {
    const r = Buffer.alloc(t.byteLength), n = new Uint8Array(t);
    for (let i = 0; i < r.length; ++i)
      r[i] = n[i];
    return r;
  }
}
class V_e extends EH {
  /**
   * Creates and initializes and instance.
   * @constructor
   */
  constructor() {
    super();
  }
  /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @member PullAudioInputStream.create
   * @function
   * @public
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   *        derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   * @returns {PullAudioInputStream} The push audio input stream being created.
   */
  static create(t, r) {
    return new j_e(t, r);
  }
}
class j_e extends V_e {
  /**
   * Creates a PullAudioInputStream that delegates to the specified callback interface for
   * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
   * @constructor
   * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
   *        derived from PullAudioInputStreamCustomCallback
   * @param {AudioStreamFormat} format - The audio data format in which audio will be
   *        returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
   */
  constructor(t, r) {
    super(), this.onEvent = (n) => {
      this.privEvents.onEvent(n), fo.instance.onEvent(n);
    }, r === void 0 ? this.privFormat = Y3.getDefaultInputFormat() : this.privFormat = r, this.privEvents = new ms(), this.privId = Ei(), this.privCallback = t, this.privIsClosed = !1, this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
  }
  /**
   * Format information for the audio
   */
  get format() {
    return Promise.resolve(this.privFormat);
  }
  /**
   * Closes the stream.
   * @member PullAudioInputStreamImpl.prototype.close
   * @function
   * @public
   */
  close() {
    this.privIsClosed = !0, this.privCallback.close();
  }
  id() {
    return this.privId;
  }
  get blob() {
    return Promise.reject("Not implemented");
  }
  turnOn() {
    this.onEvent(new z3(this.privId)), this.onEvent(new uT(this.privId));
  }
  attach(t) {
    return QB(this, void 0, void 0, function* () {
      return this.onEvent(new Hy(this.privId, t)), yield this.turnOn(), this.onEvent(new $y(this.privId, t)), {
        detach: () => (this.privCallback.close(), this.onEvent(new Qc(this.privId, t)), this.turnOff()),
        id: () => t,
        read: () => {
          let r = 0, n;
          for (; r < this.privBufferSize; ) {
            const i = new ArrayBuffer(this.privBufferSize - r), o = this.privCallback.read(i);
            if (n === void 0 ? n = i : new Int8Array(n).set(new Int8Array(i), r), o === 0)
              break;
            r += o;
          }
          return Promise.resolve({
            buffer: n.slice(0, r),
            isEnd: this.privIsClosed || r === 0,
            timeReceived: Date.now()
          });
        }
      };
    });
  }
  detach(t) {
    this.onEvent(new Qc(this.privId, t));
  }
  turnOff() {
  }
  get events() {
    return this.privEvents;
  }
  get deviceInfo() {
    return Promise.resolve({
      bitspersample: this.privFormat.bitsPerSample,
      channelcount: this.privFormat.channels,
      connectivity: nh.Unknown,
      manufacturer: "Speech SDK",
      model: "PullStream",
      samplerate: this.privFormat.samplesPerSec,
      type: Mf.Stream
    });
  }
}
var pn;
(function(e) {
  e[e.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", e[e.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", e[e.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", e[e.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", e[e.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", e[e.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", e[e.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", e[e.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", e[e.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", e[e.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", e[e.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", e[e.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", e[e.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", e[e.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", e[e.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", e[e.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", e[e.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", e[e.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", e[e.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", e[e.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", e[e.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", e[e.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", e[e.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", e[e.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", e[e.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", e[e.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", e[e.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", e[e.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", e[e.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw";
})(pn || (pn = {}));
class zr extends kf {
  /**
   * Creates an instance with the given values.
   * @constructor
   * @param formatTag
   * @param {number} channels - Number of channels.
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} avgBytesPerSec - Average bytes per second.
   * @param {number} blockAlign - Block alignment.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {string} audioFormatString - Audio format string
   * @param {string} requestAudioFormatString - Audio format string sent to service.
   * @param {boolean} hasHeader - If the format has header or not.
   */
  constructor(t, r, n, i, o, a, u, s, c) {
    super(n, a, r, t), this.formatTag = t, this.avgBytesPerSec = i, this.blockAlign = o, this.priAudioFormatString = u, this.priRequestAudioFormatString = s, this.priHasHeader = c;
  }
  static fromSpeechSynthesisOutputFormat(t) {
    return t === void 0 ? zr.getDefaultOutputFormat() : zr.fromSpeechSynthesisOutputFormatString(zr.SpeechSynthesisOutputFormatToString[t]);
  }
  static fromSpeechSynthesisOutputFormatString(t) {
    switch (t) {
      case "raw-8khz-8bit-mono-mulaw":
        return new zr(Or.MuLaw, 1, 8e3, 8e3, 1, 8, t, t, !1);
      case "riff-16khz-16kbps-mono-siren":
        return new zr(Or.Siren, 1, 16e3, 2e3, 40, 0, t, "audio-16khz-16kbps-mono-siren", !0);
      case "audio-16khz-16kbps-mono-siren":
        return new zr(Or.Siren, 1, 16e3, 2e3, 40, 0, t, t, !1);
      case "audio-16khz-32kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 16e3, 4096, 2, 16, t, t, !1);
      case "audio-16khz-128kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 16e3, 16384, 2, 16, t, t, !1);
      case "audio-16khz-64kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 16e3, 8192, 2, 16, t, t, !1);
      case "audio-24khz-48kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 24e3, 6144, 2, 16, t, t, !1);
      case "audio-24khz-96kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 24e3, 12288, 2, 16, t, t, !1);
      case "audio-24khz-160kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 24e3, 20480, 2, 16, t, t, !1);
      case "raw-16khz-16bit-mono-truesilk":
        return new zr(Or.SILKSkype, 1, 16e3, 32e3, 2, 16, t, t, !1);
      case "riff-8khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 8e3, 16e3, 2, 16, t, "raw-8khz-16bit-mono-pcm", !0);
      case "riff-24khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 24e3, 48e3, 2, 16, t, "raw-24khz-16bit-mono-pcm", !0);
      case "riff-8khz-8bit-mono-mulaw":
        return new zr(Or.MuLaw, 1, 8e3, 8e3, 1, 8, t, "raw-8khz-8bit-mono-mulaw", !0);
      case "raw-16khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 16e3, 32e3, 2, 16, t, "raw-16khz-16bit-mono-pcm", !1);
      case "raw-24khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 24e3, 48e3, 2, 16, t, "raw-24khz-16bit-mono-pcm", !1);
      case "raw-8khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 8e3, 16e3, 2, 16, t, "raw-8khz-16bit-mono-pcm", !1);
      case "ogg-16khz-16bit-mono-opus":
        return new zr(Or.OGG_OPUS, 1, 16e3, 8192, 2, 16, t, t, !1);
      case "ogg-24khz-16bit-mono-opus":
        return new zr(Or.OGG_OPUS, 1, 24e3, 8192, 2, 16, t, t, !1);
      case "raw-48khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 48e3, 96e3, 2, 16, t, "raw-48khz-16bit-mono-pcm", !1);
      case "riff-48khz-16bit-mono-pcm":
        return new zr(Or.PCM, 1, 48e3, 96e3, 2, 16, t, "raw-48khz-16bit-mono-pcm", !0);
      case "audio-48khz-96kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 48e3, 12288, 2, 16, t, t, !1);
      case "audio-48khz-192kbitrate-mono-mp3":
        return new zr(Or.MP3, 1, 48e3, 24576, 2, 16, t, t, !1);
      case "ogg-48khz-16bit-mono-opus":
        return new zr(Or.OGG_OPUS, 1, 48e3, 12e3, 2, 16, t, t, !1);
      case "webm-16khz-16bit-mono-opus":
        return new zr(Or.WEBM_OPUS, 1, 16e3, 8e3, 2, 16, t, t, !1);
      case "webm-24khz-16bit-mono-opus":
        return new zr(Or.WEBM_OPUS, 1, 24e3, 8e3, 2, 16, t, t, !1);
      case "raw-24khz-16bit-mono-truesilk":
        return new zr(Or.SILKSkype, 1, 24e3, 48e3, 2, 16, t, t, !1);
      case "raw-8khz-8bit-mono-alaw":
        return new zr(Or.ALaw, 1, 8e3, 8e3, 1, 8, t, t, !1);
      case "riff-8khz-8bit-mono-alaw":
        return new zr(Or.ALaw, 1, 8e3, 8e3, 1, 8, t, "raw-8khz-8bit-mono-alaw", !0);
      case "riff-16khz-16bit-mono-pcm":
      default:
        return new zr(Or.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
    }
  }
  static getDefaultOutputFormat() {
    return zr.fromSpeechSynthesisOutputFormatString(typeof window < "u" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
  }
  /**
   * Specifies if this audio output format has a header
   * @boolean AudioOutputFormatImpl.prototype.hasHeader
   * @function
   * @public
   */
  get hasHeader() {
    return this.priHasHeader;
  }
  /**
   * Specifies the header of this format
   * @ArrayBuffer AudioOutputFormatImpl.prototype.header
   * @function
   * @public
   */
  get header() {
    if (this.hasHeader)
      return this.privHeader;
  }
  /**
   * Updates the header based on the audio length
   * @member AudioOutputFormatImpl.updateHeader
   * @function
   * @public
   * @param {number} audioLength - the audio length
   */
  updateHeader(t) {
    this.priHasHeader && new DataView(this.privHeader).setUint32(40, t, !0);
  }
  /**
   * Specifies the audio format string to be sent to the service
   * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
   * @function
   * @public
   */
  get requestAudioFormatString() {
    return this.priRequestAudioFormatString;
  }
}
zr.SpeechSynthesisOutputFormatToString = {
  [pn.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
  [pn.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
  [pn.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
  [pn.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
  [pn.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
  [pn.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
  [pn.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
  [pn.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
  [pn.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
  [pn.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
  [pn.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
  [pn.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
  [pn.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
  [pn.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
  [pn.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
  [pn.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
  [pn.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
  [pn.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
  [pn.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
  [pn.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
  [pn.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
  [pn.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
  [pn.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
  [pn.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
  [pn.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
  [pn.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
  [pn.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
  [pn.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
  [pn.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw"
};
var lhr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let mH = class {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  constructor() {
  }
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioOutputStream.createPullStream
   * @function
   * @public
   * @returns {PullAudioOutputStream} The audio output stream being created.
   */
  static createPullStream() {
    return gH.create();
  }
};
class gH extends mH {
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member PullAudioOutputStream.create
   * @function
   * @public
   * @returns {PullAudioOutputStream} The push audio output stream being created.
   */
  static create() {
    return new TH();
  }
}
class TH extends gH {
  /**
   * Creates and initializes an instance with the given values.
   * @constructor
   */
  constructor() {
    super(), this.privId = Ei(), this.privStream = new $_e();
  }
  /**
   * Sets the format information to the stream. For internal use only.
   * @param {AudioStreamFormat} format - the format to be set.
   */
  set format(t) {
    t == null && (this.privFormat = zr.getDefaultOutputFormat()), this.privFormat = t;
  }
  /**
   * Format information for the audio
   */
  get format() {
    return this.privFormat;
  }
  /**
   * Checks if the stream is closed
   * @member PullAudioOutputStreamImpl.prototype.isClosed
   * @property
   * @public
   */
  get isClosed() {
    return this.privStream.isClosed;
  }
  /**
   * Gets the id of the stream
   * @member PullAudioOutputStreamImpl.prototype.id
   * @property
   * @public
   */
  id() {
    return this.privId;
  }
  /**
   * Reads audio data from the internal buffer.
   * @member PullAudioOutputStreamImpl.prototype.read
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
   * @returns {Promise<number>} - Audio buffer length has been read.
   */
  read(t) {
    return lhr(this, void 0, void 0, function* () {
      const r = new Int8Array(t);
      let n = 0;
      if (this.privLastChunkView !== void 0) {
        if (this.privLastChunkView.length > t.byteLength)
          return r.set(this.privLastChunkView.slice(0, t.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(t.byteLength), Promise.resolve(t.byteLength);
        r.set(this.privLastChunkView), n = this.privLastChunkView.length, this.privLastChunkView = void 0;
      }
      for (; n < t.byteLength && !this.privStream.isReadEnded; ) {
        const i = yield this.privStream.read();
        if (i !== void 0 && !i.isEnd) {
          let o;
          i.buffer.byteLength > t.byteLength - n ? (o = i.buffer.slice(0, t.byteLength - n), this.privLastChunkView = new Int8Array(i.buffer.slice(t.byteLength - n))) : o = i.buffer, r.set(new Int8Array(o), n), n += o.byteLength;
        } else
          yield this.privStream.readEnded();
      }
      return n;
    });
  }
  /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PullAudioOutputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */
  write(t) {
    Vn.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({
      buffer: t,
      isEnd: !1,
      timeReceived: Date.now()
    });
  }
  /**
   * Closes the stream.
   * @member PullAudioOutputStreamImpl.prototype.close
   * @function
   * @public
   */
  close() {
    this.privStream.close();
  }
}
class z_e extends mH {
  /**
   * Creates and initializes and instance.
   * @constructor
   */
  constructor() {
    super();
  }
  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * write() and close() methods.
   * @member PushAudioOutputStream.create
   * @function
   * @public
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   *        derived from PushAudioOutputStreamCallback
   * @returns {PushAudioOutputStream} The push audio output stream being created.
   */
  static create(t) {
    return new q_e(t);
  }
}
class q_e extends z_e {
  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * read() and close() methods.
   * @constructor
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   *        derived from PushAudioOutputStreamCallback
   */
  constructor(t) {
    super(), this.privId = Ei(), this.privCallback = t;
  }
  // tslint:disable-next-line:no-empty
  set format(t) {
  }
  write(t) {
    this.privCallback.write && this.privCallback.write(t);
  }
  close() {
    this.privCallback.close && this.privCallback.close();
  }
  id() {
    return this.privId;
  }
}
let sT = class Y_e {
  /**
   * Creates an AudioConfig object representing the default microphone on the system.
   * @member AudioConfig.fromDefaultMicrophoneInput
   * @function
   * @public
   * @returns {AudioConfig} The audio input configuration being created.
   */
  static fromDefaultMicrophoneInput() {
    const t = new xx();
    return new Wd(new q4(t));
  }
  /**
   * Creates an AudioConfig object representing a microphone with the specified device ID.
   * @member AudioConfig.fromMicrophoneInput
   * @function
   * @public
   * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
   *        Default microphone is used the value is omitted.
   * @returns {AudioConfig} The audio input configuration being created.
   */
  static fromMicrophoneInput(t) {
    const r = new xx();
    return new Wd(new q4(r, t));
  }
  /**
   * Creates an AudioConfig object representing the specified file.
   * @member AudioConfig.fromWavFileInput
   * @function
   * @public
   * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */
  static fromWavFileInput(t, r = "unnamedBuffer.wav") {
    return new Wd(new Jhr(t, r));
  }
  /**
   * Creates an AudioConfig object representing the specified stream.
   * @member AudioConfig.fromStreamInput
   * @function
   * @public
   * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
   *        stream. Currently, only WAV / PCM is supported.
   * @returns {AudioConfig} The audio input configuration being created.
   */
  static fromStreamInput(t) {
    if (t instanceof fhr)
      return new Wd(new j_e(t));
    if (t instanceof EH)
      return new Wd(t);
    if (typeof MediaStream < "u" && t instanceof MediaStream) {
      const r = new xx();
      return new Wd(new q4(r, null, null, t));
    }
    throw new Error("Not Supported Type");
  }
  /**
   * Creates an AudioConfig object representing the default speaker.
   * @member AudioConfig.fromDefaultSpeakerOutput
   * @function
   * @public
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */
  static fromDefaultSpeakerOutput() {
    return new Kd(new Fte());
  }
  /**
   * Creates an AudioConfig object representing the custom IPlayer object.
   * You can use the IPlayer object to control pause, resume, etc.
   * @member AudioConfig.fromSpeakerOutput
   * @function
   * @public
   * @param {IPlayer} player - the IPlayer object for playback.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.12.0
   */
  static fromSpeakerOutput(t) {
    if (t === void 0)
      return Y_e.fromDefaultSpeakerOutput();
    if (t instanceof Fte)
      return new Kd(t);
    throw new Error("Not Supported Type");
  }
  /**
   * Creates an AudioConfig object representing a specified output audio file
   * @member AudioConfig.fromAudioFileOutput
   * @function
   * @public
   * @param {PathLike} filename - the filename of the output audio file
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */
  static fromAudioFileOutput(t) {
    return new Kd(new shr(t));
  }
  /**
   * Creates an AudioConfig object representing a specified audio output stream
   * @member AudioConfig.fromStreamOutput
   * @function
   * @public
   * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
   *        stream.
   * @returns {AudioConfig} The audio output configuration being created.
   * Added in version 1.11.0
   */
  static fromStreamOutput(t) {
    if (t instanceof dhr)
      return new Kd(new q_e(t));
    if (t instanceof z_e)
      return new Kd(t);
    if (t instanceof gH)
      return new Kd(t);
    throw new Error("Not Supported Type");
  }
};
class Wd extends sT {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioSource} source - An audio source.
   */
  constructor(t) {
    super(), this.privSource = t;
  }
  /**
   * Format information for the audio
   */
  get format() {
    return this.privSource.format;
  }
  /**
   * @member AudioConfigImpl.prototype.close
   * @function
   * @public
   */
  close(t, r) {
    this.privSource.turnOff().then(() => {
      t && t();
    }, (n) => {
      r && r(n);
    });
  }
  /**
   * @member AudioConfigImpl.prototype.id
   * @function
   * @public
   */
  id() {
    return this.privSource.id();
  }
  /**
   * @member AudioConfigImpl.prototype.blob
   * @function
   * @public
   */
  get blob() {
    return this.privSource.blob;
  }
  /**
   * @member AudioConfigImpl.prototype.turnOn
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */
  turnOn() {
    return this.privSource.turnOn();
  }
  /**
   * @member AudioConfigImpl.prototype.attach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   * @returns {Promise<IAudioStreamNode>} A promise.
   */
  attach(t) {
    return this.privSource.attach(t);
  }
  /**
   * @member AudioConfigImpl.prototype.detach
   * @function
   * @public
   * @param {string} audioNodeId - The audio node id.
   */
  detach(t) {
    return this.privSource.detach(t);
  }
  /**
   * @member AudioConfigImpl.prototype.turnOff
   * @function
   * @public
   * @returns {Promise<void>} A promise.
   */
  turnOff() {
    return this.privSource.turnOff();
  }
  /**
   * @member AudioConfigImpl.prototype.events
   * @function
   * @public
   * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
   */
  get events() {
    return this.privSource.events;
  }
  setProperty(t, r) {
    if (Vn.throwIfNull(r, "value"), this.privSource.setProperty !== void 0)
      this.privSource.setProperty(t, r);
    else
      throw new Error("This AudioConfig instance does not support setting properties.");
  }
  getProperty(t, r) {
    if (this.privSource.getProperty !== void 0)
      return this.privSource.getProperty(t, r);
    throw new Error("This AudioConfig instance does not support getting properties.");
  }
  get deviceInfo() {
    return this.privSource.deviceInfo;
  }
}
class Kd extends sT {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioDestination} destination - An audio destination.
   */
  constructor(t) {
    super(), this.privDestination = t;
  }
  set format(t) {
    this.privDestination.format = t;
  }
  write(t) {
    this.privDestination.write(t);
  }
  close() {
    this.privDestination.close();
  }
  id() {
    return this.privDestination.id();
  }
  setProperty(t, r) {
    throw new Error("This AudioConfig instance does not support setting properties.");
  }
  getProperty(t, r) {
    throw new Error("This AudioConfig instance does not support getting properties.");
  }
}
var ea;
(function(e) {
  e[e.Error = 0] = "Error", e[e.EndOfStream = 1] = "EndOfStream";
})(ea || (ea = {}));
let fhr = class {
}, dhr = class {
}, cT = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionId - The session id.
   */
  constructor(t) {
    this.privSessionId = t;
  }
  /**
   * Represents the session identifier.
   * @member SessionEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} Represents the session identifier.
   */
  get sessionId() {
    return this.privSessionId;
  }
}, rh = class extends cT {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  constructor(t, r) {
    super(r), this.privOffset = t;
  }
  /**
   * Represents the message offset
   * @member RecognitionEventArgs.prototype.offset
   * @function
   * @public
   */
  get offset() {
    return this.privOffset;
  }
};
var Of;
(function(e) {
  e[e.Simple = 0] = "Simple", e[e.Detailed = 1] = "Detailed";
})(Of || (Of = {}));
let phr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  constructor(t, r, n, i, o, a, u, s, c, l) {
    this.privResultId = t, this.privReason = r, this.privText = n, this.privDuration = i, this.privOffset = o, this.privLanguage = a, this.privLanguageDetectionConfidence = u, this.privErrorDetails = s, this.privJson = c, this.privProperties = l;
  }
  /**
   * Specifies the result identifier.
   * @member RecognitionResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */
  get resultId() {
    return this.privResultId;
  }
  /**
   * Specifies status of the result.
   * @member RecognitionResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * Presents the recognized text in the result.
   * @member RecognitionResult.prototype.text
   * @function
   * @public
   * @returns {string} Presents the recognized text in the result.
   */
  get text() {
    return this.privText;
  }
  /**
   * Duration of recognized speech in 100 nano second incements.
   * @member RecognitionResult.prototype.duration
   * @function
   * @public
   * @returns {number} Duration of recognized speech in 100 nano second incements.
   */
  get duration() {
    return this.privDuration;
  }
  /**
   * Offset of recognized speech in 100 nano second incements.
   * @member RecognitionResult.prototype.offset
   * @function
   * @public
   * @returns {number} Offset of recognized speech in 100 nano second incements.
   */
  get offset() {
    return this.privOffset;
  }
  /**
   * Primary Language detected.
   * @member RecognitionResult.prototype.language
   * @function
   * @public
   * @returns {string} language detected.
   */
  get language() {
    return this.privLanguage;
  }
  /**
   * Primary Language detection confidence (Unknown, Low, Medium, High).
   * @member RecognitionResult.prototype.languageDetectionConfidence
   * @function
   * @public
   * @returns {string} detection confidence strength.
   */
  get languageDetectionConfidence() {
    return this.privLanguageDetectionConfidence;
  }
  /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member RecognitionResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
  /**
   * A string containing Json serialized recognition result as it was received from the service.
   * @member RecognitionResult.prototype.json
   * @function
   * @private
   * @returns {string} Json serialized representation of the result.
   */
  get json() {
    return this.privJson;
  }
  /**
   *  The set of properties exposed in the result.
   * @member RecognitionResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */
  get properties() {
    return this.privProperties;
  }
}, DA = class extends phr {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} speakerId - speaker id for conversation transcription, if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  constructor(t, r, n, i, o, a, u, s, c, l, f) {
    super(t, r, n, i, o, a, u, c, l, f), this.privSpeakerId = s;
  }
  /**
   * speaker id from conversation transcription/id scenarios
   * @member SpeechRecognitionResult.prototype.speakerId
   * @function
   * @public
   * @returns {string} id of speaker in given result
   */
  get speakerId() {
    return this.privSpeakerId;
  }
}, Rx = class extends rh {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechRecognitionResult} result - The speech recognition result.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  constructor(t, r, n) {
    super(r, n), this.privResult = t;
  }
  /**
   * Specifies the recognition result.
   * @member SpeechRecognitionEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechRecognitionResult} the recognition result.
   */
  get result() {
    return this.privResult;
  }
}, hhr = class extends rh {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  constructor(t, r, n, i, o) {
    super(i, o), this.privReason = t, this.privErrorDetails = r, this.privErrorCode = n;
  }
  /**
   * The reason the recognition was canceled.
   * @member CancellationEventArgsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * The error code in case of an unsuccessful operation.
   * @return An error code that represents the error reason.
   */
  get errorCode() {
    return this.privErrorCode;
  }
  /**
   * In case of an unsuccessful operation, provides details of the occurred error.
   * @member CancellationEventArgsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
}, vhr = class extends hhr {
};
var La;
(function(e) {
  e[e.NoMatch = 0] = "NoMatch", e[e.Canceled = 1] = "Canceled", e[e.RecognizingSpeech = 2] = "RecognizingSpeech", e[e.RecognizedSpeech = 3] = "RecognizedSpeech", e[e.RecognizedKeyword = 4] = "RecognizedKeyword", e[e.RecognizingIntent = 5] = "RecognizingIntent", e[e.RecognizedIntent = 6] = "RecognizedIntent", e[e.TranslatingSpeech = 7] = "TranslatingSpeech", e[e.TranslatedSpeech = 8] = "TranslatedSpeech", e[e.SynthesizingAudio = 9] = "SynthesizingAudio", e[e.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", e[e.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", e[e.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", e[e.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", e[e.RecognizedSpeakers = 14] = "RecognizedSpeakers", e[e.RecognizedSpeaker = 15] = "RecognizedSpeaker", e[e.ResetVoiceProfile = 16] = "ResetVoiceProfile", e[e.DeletedVoiceProfile = 17] = "DeletedVoiceProfile";
})(La || (La = {}));
let Ehr = class {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  constructor() {
  }
  /**
   * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * @member SpeechConfig.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - The subscription key.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} The speech factory
   */
  static fromSubscription(t, r) {
    Vn.throwIfNullOrWhitespace(t, "subscriptionKey"), Vn.throwIfNullOrWhitespace(r, "region");
    const n = new gf();
    return n.setProperty(Lt.SpeechServiceConnection_Region, r), n.setProperty(Lt.SpeechServiceConnection_IntentRegion, r), n.setProperty(Lt.SpeechServiceConnection_Key, t), n;
  }
  /**
   * Creates an instance of the speech config with specified endpoint and subscription key.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
   *              SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
   *              and the effective language is "de-DE". Only the parameters that are not specified in the
   *              endpoint URL can be set by other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   *       fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
   *       use the authorization token.
   * @member SpeechConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */
  static fromEndpoint(t, r) {
    Vn.throwIfNull(t, "endpoint");
    const n = new gf();
    return n.setProperty(Lt.SpeechServiceConnection_Endpoint, t.href), r !== void 0 && n.setProperty(Lt.SpeechServiceConnection_Key, r), n;
  }
  /**
   * Creates an instance of the speech config with specified host and subscription key.
   * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
   * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL),
   * and then set the AuthorizationToken property on the created SpeechConfig instance.
   * Note: Added in version 1.9.0.
   * @member SpeechConfig.fromHost
   * @function
   * @public
   * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
   * @returns {SpeechConfig} A speech factory instance.
   */
  static fromHost(t, r) {
    Vn.throwIfNull(t, "hostName");
    const n = new gf();
    return n.setProperty(Lt.SpeechServiceConnection_Host, t.protocol + "//" + t.hostname + (t.port === "" ? "" : ":" + t.port)), r !== void 0 && n.setProperty(Lt.SpeechServiceConnection_Key, r), n;
  }
  /**
   * Creates an instance of the speech factory with specified initial authorization token and region.
   * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
   *       expires, the caller needs to refresh it by calling this setter with a new valid token.
   * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
   *       to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
   *       the new token value will not apply to recognizers that have already been created. For recognizers
   *       that have been created before, you need to set authorization token of the corresponding recognizer
   *       to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
   * @member SpeechConfig.fromAuthorizationToken
   * @function
   * @public
   * @param {string} authorizationToken - The initial authorization token.
   * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {SpeechConfig} A speech factory instance.
   */
  static fromAuthorizationToken(t, r) {
    Vn.throwIfNull(t, "authorizationToken"), Vn.throwIfNullOrWhitespace(r, "region");
    const n = new gf();
    return n.setProperty(Lt.SpeechServiceConnection_Region, r), n.setProperty(Lt.SpeechServiceConnection_IntentRegion, r), n.authorizationToken = t, n;
  }
  /**
   * Closes the configuration.
   * @member SpeechConfig.prototype.close
   * @function
   * @public
   */
  /* tslint:disable:no-empty */
  close() {
  }
};
class gf extends Ehr {
  constructor() {
    super(), this.privProperties = new rb(), this.speechRecognitionLanguage = "en-US", this.outputFormat = Of.Simple;
  }
  get properties() {
    return this.privProperties;
  }
  get endPoint() {
    return new URL(this.privProperties.getProperty(Lt.SpeechServiceConnection_Endpoint));
  }
  get subscriptionKey() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_Key);
  }
  get region() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_Region);
  }
  get authorizationToken() {
    return this.privProperties.getProperty(Lt.SpeechServiceAuthorization_Token);
  }
  set authorizationToken(t) {
    this.privProperties.setProperty(Lt.SpeechServiceAuthorization_Token, t);
  }
  get speechRecognitionLanguage() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_RecoLanguage);
  }
  set speechRecognitionLanguage(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_RecoLanguage, t);
  }
  get autoDetectSourceLanguages() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_AutoDetectSourceLanguages);
  }
  set autoDetectSourceLanguages(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_AutoDetectSourceLanguages, t);
  }
  get outputFormat() {
    return Of[this.privProperties.getProperty(r8, void 0)];
  }
  set outputFormat(t) {
    this.privProperties.setProperty(r8, Of[t]);
  }
  get endpointId() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_EndpointId);
  }
  set endpointId(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_EndpointId, t);
  }
  setProperty(t, r) {
    Vn.throwIfNull(r, "value"), this.privProperties.setProperty(t, r);
  }
  getProperty(t, r) {
    return this.privProperties.getProperty(t, r);
  }
  setProxy(t, r, n, i) {
    this.setProperty(Lt[Lt.SpeechServiceConnection_ProxyHostName], t), this.setProperty(Lt[Lt.SpeechServiceConnection_ProxyPort], r), this.setProperty(Lt[Lt.SpeechServiceConnection_ProxyUserName], n), this.setProperty(Lt[Lt.SpeechServiceConnection_ProxyPassword], i);
  }
  setServiceProperty(t, r, n) {
    const i = JSON.parse(this.privProperties.getProperty(n8, "{}"));
    i[t] = r, this.privProperties.setProperty(n8, JSON.stringify(i));
  }
  setProfanity(t) {
    this.privProperties.setProperty(Lt.SpeechServiceResponse_ProfanityOption, e8[t]);
  }
  enableAudioLogging() {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_EnableAudioLogging, "true");
  }
  requestWordLevelTimestamps() {
    this.privProperties.setProperty(Lt.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
  }
  enableDictation() {
    this.privProperties.setProperty(Khr, "true");
  }
  clone() {
    const t = new gf();
    return t.privProperties = this.privProperties.clone(), t;
  }
  get speechSynthesisLanguage() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_SynthLanguage);
  }
  set speechSynthesisLanguage(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_SynthLanguage, t);
  }
  get speechSynthesisVoiceName() {
    return this.privProperties.getProperty(Lt.SpeechServiceConnection_SynthVoice);
  }
  set speechSynthesisVoiceName(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_SynthVoice, t);
  }
  get speechSynthesisOutputFormat() {
    return pn[this.privProperties.getProperty(Lt.SpeechServiceConnection_SynthOutputFormat, void 0)];
  }
  set speechSynthesisOutputFormat(t) {
    this.privProperties.setProperty(Lt.SpeechServiceConnection_SynthOutputFormat, pn[t]);
  }
}
let rb = class G_e {
  constructor() {
    this.privKeys = [], this.privValues = [];
  }
  /**
   * Returns the property value in type String. The parameter must have the same type as String.
   * Currently only String, int and bool are allowed.
   * If the name is not available, the specified defaultValue is returned.
   * @member PropertyCollection.prototype.getProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} def - The default value which is returned if the parameter
   *        is not available in the collection.
   * @returns {string} value of the parameter.
   */
  getProperty(t, r) {
    let n;
    typeof t == "string" ? n = t : n = Lt[t];
    for (let i = 0; i < this.privKeys.length; i++)
      if (this.privKeys[i] === n)
        return this.privValues[i];
    return r;
  }
  /**
   * Sets the String value of the parameter specified by name.
   * @member PropertyCollection.prototype.setProperty
   * @function
   * @public
   * @param {string} key - The parameter name.
   * @param {string} value - The value of the parameter.
   */
  setProperty(t, r) {
    let n;
    typeof t == "string" ? n = t : n = Lt[t];
    for (let i = 0; i < this.privKeys.length; i++)
      if (this.privKeys[i] === n) {
        this.privValues[i] = r;
        return;
      }
    this.privKeys.push(n), this.privValues.push(r);
  }
  /**
   * Clones the collection.
   * @member PropertyCollection.prototype.clone
   * @function
   * @public
   * @returns {PropertyCollection} A copy of the collection.
   */
  clone() {
    const t = new G_e();
    for (let r = 0; r < this.privKeys.length; r++)
      t.privKeys.push(this.privKeys[r]), t.privValues.push(this.privValues[r]);
    return t;
  }
  /**
   * Merges this set of properties into another, no overwrites.
   * @member PropertyCollection.prototype.mergeTo
   * @function
   * @public
   * @param {PropertyCollection} The collection to merge into.
   */
  mergeTo(t) {
    this.privKeys.forEach((r) => {
      if (t.getProperty(r, void 0) === void 0) {
        const n = this.getProperty(r);
        t.setProperty(r, n);
      }
    });
  }
};
var Lt;
(function(e) {
  e[e.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", e[e.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", e[e.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", e[e.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", e[e.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", e[e.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", e[e.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", e[e.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", e[e.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", e[e.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", e[e.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", e[e.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", e[e.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", e[e.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", e[e.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", e[e.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", e[e.Speech_SessionId = 16] = "Speech_SessionId", e[e.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", e[e.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", e[e.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", e[e.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", e[e.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", e[e.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", e[e.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", e[e.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", e[e.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", e[e.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", e[e.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", e[e.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", e[e.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", e[e.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", e[e.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", e[e.SpeechServiceConnection_EnableAudioLogging = 32] = "SpeechServiceConnection_EnableAudioLogging", e[e.SpeechServiceResponse_ProfanityOption = 33] = "SpeechServiceResponse_ProfanityOption", e[e.SpeechServiceResponse_PostProcessingOption = 34] = "SpeechServiceResponse_PostProcessingOption", e[e.SpeechServiceResponse_RequestWordLevelTimestamps = 35] = "SpeechServiceResponse_RequestWordLevelTimestamps", e[e.SpeechServiceResponse_StablePartialResultThreshold = 36] = "SpeechServiceResponse_StablePartialResultThreshold", e[e.SpeechServiceResponse_OutputFormatOption = 37] = "SpeechServiceResponse_OutputFormatOption", e[e.SpeechServiceResponse_TranslationRequestStablePartialResult = 38] = "SpeechServiceResponse_TranslationRequestStablePartialResult", e[e.Conversation_ApplicationId = 39] = "Conversation_ApplicationId", e[e.Conversation_DialogType = 40] = "Conversation_DialogType", e[e.Conversation_Initial_Silence_Timeout = 41] = "Conversation_Initial_Silence_Timeout", e[e.Conversation_From_Id = 42] = "Conversation_From_Id", e[e.Conversation_Conversation_Id = 43] = "Conversation_Conversation_Id", e[e.Conversation_Custom_Voice_Deployment_Ids = 44] = "Conversation_Custom_Voice_Deployment_Ids", e[e.Conversation_Speech_Activity_Template = 45] = "Conversation_Speech_Activity_Template", e[e.Conversation_Request_Bot_Status_Messages = 46] = "Conversation_Request_Bot_Status_Messages", e[e.Conversation_Agent_Connection_Id = 47] = "Conversation_Agent_Connection_Id", e[e.SpeechServiceConnection_Host = 48] = "SpeechServiceConnection_Host", e[e.ConversationTranslator_Host = 49] = "ConversationTranslator_Host", e[e.ConversationTranslator_Name = 50] = "ConversationTranslator_Name", e[e.ConversationTranslator_CorrelationId = 51] = "ConversationTranslator_CorrelationId", e[e.ConversationTranslator_Token = 52] = "ConversationTranslator_Token", e[e.PronunciationAssessment_ReferenceText = 53] = "PronunciationAssessment_ReferenceText", e[e.PronunciationAssessment_GradingSystem = 54] = "PronunciationAssessment_GradingSystem", e[e.PronunciationAssessment_Granularity = 55] = "PronunciationAssessment_Granularity", e[e.PronunciationAssessment_EnableMiscue = 56] = "PronunciationAssessment_EnableMiscue", e[e.PronunciationAssessment_Json = 57] = "PronunciationAssessment_Json", e[e.PronunciationAssessment_Params = 58] = "PronunciationAssessment_Params";
})(Lt || (Lt = {}));
var qv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let mhr = class W_e {
  /**
   * Creates and initializes an instance of a Recognizer
   * @constructor
   * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
   */
  constructor(t, r, n) {
    this.audioConfig = t !== void 0 ? t : sT.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = r.clone(), this.privConnectionFactory = n, this.implCommonRecognizerSetup();
  }
  /**
   * Dispose of associated resources.
   * @member Recognizer.prototype.close
   * @function
   * @public
   */
  close(t, r) {
    Vn.throwIfDisposed(this.privDisposed), ip(this.dispose(!0), t, r);
  }
  /**
   * @Internal
   * Internal data member to support fromRecognizer* pattern methods on other classes.
   * Do not use externally, object returned will change without warning or notice.
   */
  get internalData() {
    return this.privReco;
  }
  /**
   * This method performs cleanup of resources.
   * The Boolean parameter disposing indicates whether the method is called
   * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
   * Derived classes should override this method to dispose resource if needed.
   * @member Recognizer.prototype.dispose
   * @function
   * @public
   * @param {boolean} disposing - Flag to request disposal.
   */
  dispose(t) {
    return qv(this, void 0, void 0, function* () {
      this.privDisposed || (this.privDisposed = !0, t && this.privReco && (yield this.privReco.audioSource.turnOff(), yield this.privReco.dispose()));
    });
  }
  /**
   * This method returns the current state of the telemetry setting.
   * @member Recognizer.prototype.telemetryEnabled
   * @function
   * @public
   * @returns true if the telemetry is enabled, false otherwise.
   */
  static get telemetryEnabled() {
    return nb.telemetryDataEnabled;
  }
  /**
   * This method globally enables or disables telemetry.
   * @member Recognizer.prototype.enableTelemetry
   * @function
   * @public
   * @param enabled - Global setting for telemetry collection.
   * If set to true, telemetry information like microphone errors,
   * recognition errors are collected and sent to Microsoft.
   * If set to false, no telemetry is sent to Microsoft.
   */
  /* tslint:disable:member-ordering */
  static enableTelemetry(t) {
    nb.telemetryDataEnabled = t;
  }
  // Does the generic recognizer setup that is common across all recognizer types.
  implCommonRecognizerSetup() {
    let t = typeof window < "u" ? "Browser" : "Node", r = "unknown", n = "unknown";
    typeof navigator < "u" && (t = t + "/" + navigator.platform, r = navigator.userAgent, n = navigator.appVersion);
    const i = this.createRecognizerConfig(new J_e(new Z_e(new Phr(t, r, n))));
    this.privReco = this.createServiceRecognizer(W_e.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, i);
  }
  recognizeOnceAsyncImpl(t) {
    return qv(this, void 0, void 0, function* () {
      Vn.throwIfDisposed(this.privDisposed);
      const r = new Wi();
      yield this.implRecognizerStop(), yield this.privReco.recognize(t, r.resolve, r.reject);
      const n = yield r.promise;
      return yield this.implRecognizerStop(), n;
    });
  }
  startContinuousRecognitionAsyncImpl(t) {
    return qv(this, void 0, void 0, function* () {
      Vn.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop(), yield this.privReco.recognize(t, void 0, void 0);
    });
  }
  stopContinuousRecognitionAsyncImpl() {
    return qv(this, void 0, void 0, function* () {
      Vn.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop();
    });
  }
  implRecognizerStop() {
    return qv(this, void 0, void 0, function* () {
      this.privReco && (yield this.privReco.stopRecognizing());
    });
  }
  static getAuthFromProperties(t) {
    const r = t.getProperty(Lt.SpeechServiceConnection_Key, void 0);
    return r && r !== "" ? new ahr(r) : new uhr((i) => {
      const o = t.getProperty(Lt.SpeechServiceAuthorization_Token, void 0);
      return Promise.resolve(o);
    }, (i) => {
      const o = t.getProperty(Lt.SpeechServiceAuthorization_Token, void 0);
      return Promise.resolve(o);
    });
  }
};
var Mi;
(function(e) {
  e[e.NoError = 0] = "NoError", e[e.AuthenticationFailure = 1] = "AuthenticationFailure", e[e.BadRequestParameters = 2] = "BadRequestParameters", e[e.TooManyRequests = 3] = "TooManyRequests", e[e.ConnectionFailure = 4] = "ConnectionFailure", e[e.ServiceTimeout = 5] = "ServiceTimeout", e[e.ServiceError = 6] = "ServiceError", e[e.RuntimeError = 7] = "RuntimeError";
})(Mi || (Mi = {}));
var xA;
let ps = class {
  /**
   * Creates an instance of DialogService config.
   * @constructor
   */
  constructor() {
  }
  /**
   * Sets the corresponding backend application identifier.
   * @member DialogServiceConfig.prototype.Conversation_ApplicationId
   * @function
   * @public
   * @param {string} value - The application identifier to set.
   */
  // tslint:disable-next-line: no-empty
  set applicationId(t) {
  }
};
ps.DialogTypes = (xA = class {
}, xA.BotFramework = "bot_framework", xA.CustomCommands = "custom_commands", xA);
class Yv extends ps {
  /**
   * Creates an instance of dialogService config.
   */
  constructor() {
    super(), this.privSpeechConfig = new gf();
  }
  /**
   * Provides access to custom properties.
   * @member DialogServiceConfigImpl.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The properties.
   */
  get properties() {
    return this.privSpeechConfig.properties;
  }
  /**
   * Gets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   */
  get speechRecognitionLanguage() {
    return this.privSpeechConfig.speechRecognitionLanguage;
  }
  /**
   * Sets the speech recognition language.
   * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
   * @function
   * @public
   * @param {string} value - The language to set.
   */
  set speechRecognitionLanguage(t) {
    Vn.throwIfNullOrWhitespace(t, "value"), this.privSpeechConfig.speechRecognitionLanguage = t;
  }
  get outputFormat() {
    return this.privSpeechConfig.outputFormat;
  }
  set outputFormat(t) {
    this.privSpeechConfig.outputFormat = t;
  }
  /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.setProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to set.
   * @param {string} value - The value.
   */
  setProperty(t, r) {
    this.privSpeechConfig.setProperty(t, r);
  }
  /**
   * Sets a named property as value
   * @member DialogServiceConfigImpl.prototype.getProperty
   * @function
   * @public
   * @param {PropertyId | string} name - The property to get.
   * @param {string} def - The default value to return in case the property is not known.
   * @returns {string} The current value, or provided default, of the given property.
   */
  getProperty(t, r) {
    return this.privSpeechConfig.getProperty(t);
  }
  /**
   * Sets the proxy configuration.
   * Only relevant in Node.js environments.
   * Added in version 1.4.0.
   * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
   * @param proxyPort The port number of the proxy server.
   * @param proxyUserName The user name of the proxy server.
   * @param proxyPassword The password of the proxy server.
   */
  setProxy(t, r, n, i) {
    this.setProperty(Lt.SpeechServiceConnection_ProxyHostName, t), this.setProperty(Lt.SpeechServiceConnection_ProxyPort, `${r}`), n && this.setProperty(Lt.SpeechServiceConnection_ProxyUserName, n), i && this.setProperty(Lt.SpeechServiceConnection_ProxyPassword, i);
  }
  setServiceProperty(t, r, n) {
    this.privSpeechConfig.setServiceProperty(t, r, n);
  }
  /**
   * Dispose of associated resources.
   * @member DialogServiceConfigImpl.prototype.close
   * @function
   * @public
   */
  close() {
  }
}
let NA = class extends Yv {
  /**
   * Creates an instance of BotFrameworkConfig.
   */
  constructor() {
    super();
  }
  /**
   * Creates a bot framework configuration instance with the provided subscription information.
   * @member BotFrameworkConfig.fromSubscription
   * @function
   * @public
   * @param subscription Subscription key associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   *        resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */
  static fromSubscription(t, r, n) {
    Vn.throwIfNullOrWhitespace(t, "subscription"), Vn.throwIfNullOrWhitespace(r, "region");
    const i = new Yv();
    return i.setProperty(Lt.Conversation_DialogType, ps.DialogTypes.BotFramework), i.setProperty(Lt.SpeechServiceConnection_Key, t), i.setProperty(Lt.SpeechServiceConnection_Region, r), n && i.setProperty(Lt.Conversation_ApplicationId, n), i;
  }
  /**
   * Creates a bot framework configuration instance for the specified authorization token and region.
   * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
   *       caller must refresh it by setting the authorizationToken property on the corresponding
   *       DialogServiceConnector instance created with this config. The contents of configuration objects are copied
   *       when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
   *       original configuration's authorization token. Create a new configuration instance or set the
   *       SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
   *       further DialogServiceConnectors.
   * @member BotFrameworkConfig.fromAuthorizationToken
   * @function
   * @public
   * @param authorizationToken The authorization token associated with the bot
   * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   *        resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */
  static fromAuthorizationToken(t, r, n) {
    Vn.throwIfNullOrWhitespace(t, "authorizationToken"), Vn.throwIfNullOrWhitespace(r, "region");
    const i = new Yv();
    return i.setProperty(Lt.Conversation_DialogType, ps.DialogTypes.BotFramework), i.setProperty(Lt.SpeechServiceAuthorization_Token, t), i.setProperty(Lt.SpeechServiceConnection_Region, r), n && i.setProperty(Lt.Conversation_ApplicationId, n), i;
  }
  /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-default service host. The standard resource path will be
   * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
   * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
   * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
   *       property on the created BotFrameworkConfig instance.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromHost
   * @function
   * @public
   * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
   *        wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
   *        wss://{host}.convai.speech.azure.us.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   *        token must be set.
   * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
   *        resource name.
   * @returns {BotFrameworkConfig} A new bot framework configuration instance.
   */
  static fromHost(t, r, n) {
    Vn.throwIfNullOrUndefined(t, "host");
    const i = t instanceof URL ? t : new URL(`wss://${t}.convai.speech.azure.us`);
    Vn.throwIfNullOrUndefined(i, "resolvedHost");
    const o = new Yv();
    return o.setProperty(Lt.Conversation_DialogType, ps.DialogTypes.BotFramework), o.setProperty(Lt.SpeechServiceConnection_Host, i.toString()), r !== void 0 && o.setProperty(Lt.SpeechServiceConnection_Key, r), o;
  }
  /**
   * Creates an instance of a BotFrameworkConfig.
   * This method is intended only for users who use a non-standard service endpoint or parameters.
   * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
   * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
   *       fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
   *       use the authorization token.
   * Note: Added in version 1.15.0.
   * @member BotFrameworkConfig.fromEndpoint
   * @function
   * @public
   * @param {URL} endpoint - The service endpoint to connect to.
   * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
   *        token must be set.
   * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
   */
  static fromEndpoint(t, r) {
    Vn.throwIfNull(t, "endpoint");
    const n = new Yv();
    return n.setProperty(Lt.Conversation_DialogType, ps.DialogTypes.BotFramework), n.setProperty(Lt.SpeechServiceConnection_Endpoint, t.toString()), r !== void 0 && n.setProperty(Lt.SpeechServiceConnection_Key, r), n;
  }
}, ii = class {
};
ii.BotId = "botid";
ii.CustomSpeechDeploymentId = "cid";
ii.CustomVoiceDeploymentId = "deploymentId";
ii.EnableAudioLogging = "storeAudio";
ii.EnableLanguageId = "lidEnabled";
ii.EnableWordLevelTimestamps = "wordLevelTimestamps";
ii.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
ii.Format = "format";
ii.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
ii.Language = "language";
ii.Profanity = "profanity";
ii.RequestBotStatusMessages = "enableBotMessageStatus";
ii.StableIntermediateThreshold = "stableIntermediateThreshold";
ii.StableTranslation = "stableTranslation";
ii.TestHooks = "testhooks";
let ghr = class {
  setCommonUrlParams(t, r, n) {
    this.setUrlParameter(Lt.SpeechServiceConnection_EnableAudioLogging, ii.EnableAudioLogging, t, r, n), this.setUrlParameter(Lt.SpeechServiceResponse_RequestWordLevelTimestamps, ii.EnableWordLevelTimestamps, t, r, n), this.setUrlParameter(Lt.SpeechServiceResponse_ProfanityOption, ii.Profanity, t, r, n), this.setUrlParameter(Lt.SpeechServiceConnection_InitialSilenceTimeoutMs, ii.InitialSilenceTimeoutMs, t, r, n), this.setUrlParameter(Lt.SpeechServiceConnection_EndSilenceTimeoutMs, ii.EndSilenceTimeoutMs, t, r, n), this.setUrlParameter(Lt.SpeechServiceResponse_StablePartialResultThreshold, ii.StableIntermediateThreshold, t, r, n);
    const i = JSON.parse(t.parameters.getProperty(n8, "{}"));
    Object.keys(i).forEach((o, a, u) => {
      r[o] = i[o];
    });
  }
  setUrlParameter(t, r, n, i, o) {
    const a = n.parameters.getProperty(t, void 0);
    a && (!o || o.search(r) === -1) && (i[r] = a.toLocaleLowerCase());
  }
};
var LA;
class lT extends ghr {
  constructor() {
    super(...arguments), this.create = (t, r, n) => {
      const i = t.parameters.getProperty(Lt.Conversation_ApplicationId, ""), o = t.parameters.getProperty(Lt.Conversation_DialogType), a = t.parameters.getProperty(Lt.SpeechServiceConnection_Region), u = t.parameters.getProperty(Lt.SpeechServiceConnection_RecoLanguage, "en-US"), s = t.parameters.getProperty(Lt.Conversation_Request_Bot_Status_Messages, "true"), c = {};
      c[Ii.ConnectionId] = n, c[ii.Format] = t.parameters.getProperty(r8, Of[Of.Simple]).toLowerCase(), c[ii.Language] = u, c[ii.RequestBotStatusMessages] = s, i && (c[ii.BotId] = i, o === ps.DialogTypes.CustomCommands && (c[Ii.CustomCommandsAppId] = i));
      const l = o === ps.DialogTypes.CustomCommands ? "commands/" : "", f = o === ps.DialogTypes.CustomCommands ? "v1" : o === ps.DialogTypes.BotFramework ? "v3" : "v0", d = {};
      r.token != null && r.token !== "" && (d[r.headerName] = r.token);
      let p = t.parameters.getProperty(Lt.SpeechServiceConnection_Endpoint, "");
      if (!p) {
        const h = a && a.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", E = t.parameters.getProperty(Lt.SpeechServiceConnection_Host, `wss://${a}.${lT.Constants.BaseUrl}${h}`);
        p = `${E.endsWith("/") ? E : E + "/"}${l}${lT.Constants.ApiKey}/${f}`;
      }
      this.setCommonUrlParams(t, c, p);
      const v = t.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new dvr(p, c, d, new Dhr(), hvr.fromRecognizerConfig(t), v, n);
    };
  }
}
lT.Constants = (LA = class {
}, LA.ApiKey = "api", LA.BaseUrl = "convai.speech", LA);
var kte = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let Thr = class extends mhr {
  /**
   * Initializes an instance of the DialogServiceConnector.
   * @constructor
   * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
   * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
   */
  constructor(t, r) {
    const n = t;
    Vn.throwIfNull(t, "dialogConfig"), super(r, n.properties, new lT()), this.isTurnComplete = !0, this.privIsDisposed = !1, this.privProperties = n.properties.clone();
    const i = this.buildAgentConfig();
    this.privReco.agentConfig.set(i);
  }
  /**
   * Starts a connection to the service.
   * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
   *
   * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
   * be notified when the connection is established.
   * @member DialogServiceConnector.prototype.connect
   * @function
   * @public
   */
  connect(t, r) {
    ip(this.privReco.connect(), t, r);
  }
  /**
   * Closes the connection the service.
   * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
   *
   * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
   */
  disconnect(t, r) {
    ip(this.privReco.disconnect(), t, r);
  }
  /**
   * Gets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @returns {string} Authorization token.
   */
  get authorizationToken() {
    return this.properties.getProperty(Lt.SpeechServiceAuthorization_Token);
  }
  /**
   * Sets the authorization token used to communicate with the service.
   * @member DialogServiceConnector.prototype.authorizationToken
   * @function
   * @public
   * @param {string} token - Authorization token.
   */
  set authorizationToken(t) {
    Vn.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(Lt.SpeechServiceAuthorization_Token, t);
  }
  /**
   * The collection of properties and their values defined for this DialogServiceConnector.
   * @member DialogServiceConnector.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
   */
  get properties() {
    return this.privProperties;
  }
  /** Gets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be empty
   */
  get speechActivityTemplate() {
    return this.properties.getProperty(Lt.Conversation_Speech_Activity_Template);
  }
  /** Sets the template for the activity generated by service from speech.
   * Properties from the template will be stamped on the generated activity.
   * It can be null or empty.
   * Note: it has to be a valid Json object.
   */
  set speechActivityTemplate(t) {
    this.properties.setProperty(Lt.Conversation_Speech_Activity_Template, t);
  }
  /**
   * Starts recognition and stops after the first utterance is recognized.
   * @member DialogServiceConnector.prototype.listenOnceAsync
   * @function
   * @public
   * @param cb - Callback that received the result when the reco has completed.
   * @param err - Callback invoked in case of an error.
   */
  listenOnceAsync(t, r) {
    if (this.isTurnComplete) {
      Vn.throwIfDisposed(this.privIsDisposed);
      const i = kte(this, void 0, void 0, function* () {
        yield this.privReco.connect(), yield this.implRecognizerStop(), this.isTurnComplete = !1;
        const o = new Wi();
        yield this.privReco.recognize(Tf.Conversation, o.resolve, o.reject);
        const a = yield o.promise;
        return yield this.implRecognizerStop(), a;
      });
      i.catch(() => {
        this.dispose(!0).catch(() => {
        });
      }), ip(i.finally(() => {
        this.isTurnComplete = !0;
      }), t, r);
    }
  }
  sendActivityAsync(t, r, n) {
    ip(this.privReco.sendMessage(t), r, n);
  }
  /**
   * closes all external resources held by an instance of this class.
   * @member DialogServiceConnector.prototype.close
   * @function
   * @public
   */
  close(t, r) {
    Vn.throwIfDisposed(this.privIsDisposed), ip(this.dispose(!0), t, r);
  }
  dispose(t) {
    const r = Object.create(null, {
      dispose: { get: () => super.dispose }
    });
    return kte(this, void 0, void 0, function* () {
      this.privIsDisposed || t && (this.privIsDisposed = !0, yield this.implRecognizerStop(), yield r.dispose.call(this, t));
    });
  }
  createRecognizerConfig(t) {
    return new Rhr(t, this.privProperties);
  }
  createServiceRecognizer(t, r, n, i) {
    const o = n;
    return new Vhr(t, r, o, i, this);
  }
  buildAgentConfig() {
    return {
      botInfo: {
        commType: this.properties.getProperty("Conversation_Communication_Type", "Default"),
        commandsCulture: void 0,
        connectionId: this.properties.getProperty(Lt.Conversation_Agent_Connection_Id),
        conversationId: this.properties.getProperty(Lt.Conversation_Conversation_Id, void 0),
        fromId: this.properties.getProperty(Lt.Conversation_From_Id, void 0),
        ttsAudioFormat: this.properties.getProperty(Lt.SpeechServiceConnection_SynthOutputFormat, void 0)
      },
      version: 0.2
    };
  }
}, yhr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {any} activity - The activity..
   */
  constructor(t, r) {
    this.privActivity = t, this.privAudioStream = r;
  }
  /**
   * Gets the received activity
   * @member ActivityReceivedEventArgs.prototype.activity
   * @function
   * @public
   * @returns {any} the received activity.
   */
  get activity() {
    return this.privActivity;
  }
  get audioStream() {
    return this.privAudioStream;
  }
};
class yH {
  constructor(t) {
    this.privMessageStatusResponse = JSON.parse(t);
  }
  static fromJSON(t) {
    return new yH(t);
  }
  get interactionId() {
    return this.privMessageStatusResponse.interactionId;
  }
  get conversationId() {
    return this.privMessageStatusResponse.conversationId;
  }
  get statusCode() {
    switch (this.privMessageStatusResponse.statusCode) {
      case "Success":
        return 200;
      case "Failed":
        return 400;
      case "TimedOut":
        return 429;
      default:
        return this.privMessageStatusResponse.statusCode;
    }
  }
}
let _hr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} turnStatus - The JSON-encoded turn status message.
   */
  constructor(t) {
    this.privTurnStatus = yH.fromJSON(t);
  }
  /**
   * Gets the interaction identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.interactionId
   * @function
   * @public
   * @returns {any} the received interaction id.
   */
  get interactionId() {
    return this.privTurnStatus.interactionId;
  }
  /**
   * Gets the conversation identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.conversationId
   * @function
   * @public
   * @returns {any} the received conversation id.
   */
  get conversationId() {
    return this.privTurnStatus.conversationId;
  }
  /**
   * Gets the received turn status code.
   * @member TurnStatusReceivedEventArgs.prototype.statusCode
   * @function
   * @public
   * @returns {number} the received turn status.
   */
  get statusCode() {
    return this.privTurnStatus.statusCode;
  }
};
var e8;
(function(e) {
  e[e.Masked = 0] = "Masked", e[e.Removed = 1] = "Removed", e[e.Raw = 2] = "Raw";
})(e8 || (e8 = {}));
let BA = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {number} audioData - The offset into the stream.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  constructor(t, r, n, i, o) {
    this.privResultId = t, this.privReason = r, this.privAudioData = n, this.privErrorDetails = i, this.privProperties = o;
  }
  /**
   * Specifies the result identifier.
   * @member SpeechSynthesisResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */
  get resultId() {
    return this.privResultId;
  }
  /**
   * Specifies status of the result.
   * @member SpeechSynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * The synthesized audio data
   * @member SpeechSynthesisResult.prototype.audioData
   * @function
   * @public
   * @returns {ArrayBuffer} The synthesized audio data.
   */
  get audioData() {
    return this.privAudioData;
  }
  /**
   * In case of an unsuccessful synthesis, provides details of the occurred error.
   * @member SpeechSynthesisResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
  /**
   *  The set of properties exposed in the result.
   * @member SpeechSynthesisResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */
  get properties() {
    return this.privProperties;
  }
}, kA = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechSynthesisResult} result - The speech synthesis result.
   */
  constructor(t) {
    this.privResult = t;
  }
  /**
   * Specifies the synthesis result.
   * @member SpeechSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechSynthesisResult} the synthesis result.
   */
  get result() {
    return this.privResult;
  }
}, Ahr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} text - The text.
   * @param {number} wordLength - The length of the word.
   * @param {number} textOffset - The text offset.
   */
  constructor(t, r, n, i) {
    this.privAudioOffset = t, this.privText = r, this.privWordLength = n, this.privTextOffset = i;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the text of the word boundary event.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the text.
   */
  get text() {
    return this.privText;
  }
  /**
   * Specifies the word length
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
   * @function
   * @public
   * @returns {number} the word length
   */
  get wordLength() {
    return this.privWordLength;
  }
  /**
   * Specifies the text offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
   * @function
   * @public
   * @returns {number} the text offset.
   */
  get textOffset() {
    return this.privTextOffset;
  }
}, Shr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} text - The bookmark text.
   */
  constructor(t, r) {
    this.privAudioOffset = t, this.privText = r;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the bookmark.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the bookmark text.
   */
  get text() {
    return this.privText;
  }
}, bhr = class {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} visemeId - The viseme ID.
   * @param {string} animation - The animation, could be in svg or other format.
   */
  constructor(t, r, n) {
    this.privAudioOffset = t, this.privVisemeId = r, this.privAnimation = n;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the viseme ID.
   * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
   * @function
   * @public
   * @returns {number} the viseme ID.
   */
  get visemeId() {
    return this.privVisemeId;
  }
  /**
   * Specifies the animation.
   * @member SpeechSynthesisVisemeEventArgs.prototype.animation
   * @function
   * @public
   * @returns {string} the animation, could be in svg or other format.
   */
  get animation() {
    return this.privAnimation;
  }
};
var wx = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
const Chr = 60 * 30, Mte = {
  [Or.PCM]: "audio/wav",
  [Or.MuLaw]: "audio/x-wav",
  [Or.MP3]: "audio/mpeg",
  [Or.OGG_OPUS]: "audio/ogg",
  [Or.WEBM_OPUS]: "audio/webm; codecs=opus",
  [Or.ALaw]: "audio/x-wav"
};
let Fte = class {
  constructor(t) {
    this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = t || Ei(), this.privIsPaused = !1, this.privIsClosed = !1;
  }
  id() {
    return this.privId;
  }
  write(t, r, n) {
    this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(t), this.updateSourceBuffer().then(() => {
      r && r();
    }, (i) => {
      n && n(i);
    })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(t), this.privBytesReceived += t.byteLength);
  }
  close(t, r) {
    if (this.privIsClosed = !0, this.privSourceBuffer !== void 0)
      this.handleSourceBufferUpdateEnd().then(() => {
        t && t();
      }, (n) => {
        r && r(n);
      });
    else if (this.privAudioOutputStream !== void 0)
      if ((this.privFormat.formatTag === Or.PCM || this.privFormat.formatTag === Or.MuLaw || this.privFormat.formatTag === Or.ALaw) && this.privFormat.hasHeader === !1)
        console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
      else {
        let n = new ArrayBuffer(this.privBytesReceived);
        this.privAudioOutputStream.read(n).then((i) => {
          n = AH.addHeader(n, this.privFormat);
          const o = new Blob([n], { type: Mte[this.privFormat.formatTag] });
          this.privAudio.src = window.URL.createObjectURL(o), this.notifyPlayback().then(() => {
            t && t();
          }, (a) => {
            r && r(a);
          });
        }, (i) => {
          r && r(i);
        });
      }
    else
      this.onAudioEnd && this.onAudioEnd(this);
  }
  set format(t) {
    if (typeof AudioContext < "u" || typeof window.webkitAudioContext < "u") {
      this.privFormat = t;
      const r = Mte[this.privFormat.formatTag];
      r === void 0 ? console.warn(`Unknown mimeType for format ${Or[this.privFormat.formatTag]}; playback is not supported.`) : typeof MediaSource < "u" && MediaSource.isTypeSupported(r) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = (n) => {
        this.privMediaSourceOpened = !0, this.privMediaSource.duration = Chr, this.privSourceBuffer = this.privMediaSource.addSourceBuffer(r), this.privSourceBuffer.onupdate = (i) => {
          this.updateSourceBuffer().catch((o) => {
            fo.instance.onEvent(new If(o));
          });
        }, this.privSourceBuffer.onupdateend = (i) => {
          this.handleSourceBufferUpdateEnd().catch((o) => {
            fo.instance.onEvent(new If(o));
          });
        }, this.privSourceBuffer.onupdatestart = (i) => {
          this.privAppendingToBuffer = !1;
        };
      }, this.updateSourceBuffer().catch((n) => {
        fo.instance.onEvent(new If(n));
      })) : (console.warn(`Format ${Or[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`), this.privAudioOutputStream = new TH(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
    }
  }
  get isClosed() {
    return this.privIsClosed;
  }
  get currentTime() {
    return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
  }
  pause() {
    !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
  }
  resume(t, r) {
    this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(() => {
      t && t();
    }, (n) => {
      r && r(n);
    }), this.privIsPaused = !1);
  }
  get internalAudio() {
    return this.privAudio;
  }
  updateSourceBuffer() {
    return wx(this, void 0, void 0, function* () {
      if (this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
        this.privAppendingToBuffer = !0;
        const t = this.privAudioBuffer.shift();
        try {
          this.privSourceBuffer.appendBuffer(t);
        } catch {
          this.privAudioBuffer.unshift(t), console.log("buffer filled, pausing addition of binaries until space is made");
          return;
        }
        yield this.notifyPlayback();
      } else this.canEndStream() && (yield this.handleSourceBufferUpdateEnd());
    });
  }
  handleSourceBufferUpdateEnd() {
    return wx(this, void 0, void 0, function* () {
      this.canEndStream() && this.sourceBufferAvailable() && (this.privMediaSource.endOfStream(), yield this.notifyPlayback());
    });
  }
  notifyPlayback() {
    return wx(this, void 0, void 0, function* () {
      !this.privPlaybackStarted && this.privAudio !== void 0 && (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = () => {
        this.onAudioEnd && this.onAudioEnd(this);
      }, this.privIsPaused || (yield this.privAudio.play()));
    });
  }
  canEndStream() {
    return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
  }
  sourceBufferAvailable() {
    return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
  }
}, G3 = class extends v0 {
  constructor(t, r, n, i = qn.Info) {
    super(t, i), this.privRequestId = r, this.privSessionId = n;
  }
  get requestId() {
    return this.privRequestId;
  }
  get sessionId() {
    return this.privSessionId;
  }
};
class K_e extends G3 {
  constructor(t, r, n, i) {
    super("RecognitionTriggeredEvent", t, r), this.privAudioSourceId = n, this.privAudioNodeId = i;
  }
  get audioSourceId() {
    return this.privAudioSourceId;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
}
class Ihr extends G3 {
  constructor(t, r, n, i) {
    super("ListeningStartedEvent", t, r), this.privAudioSourceId = n, this.privAudioNodeId = i;
  }
  get audioSourceId() {
    return this.privAudioSourceId;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
}
class X_e extends G3 {
  constructor(t, r, n) {
    super("ConnectingToServiceEvent", t, n), this.privAuthFetchEventid = r;
  }
  get authFetchEventid() {
    return this.privAuthFetchEventid;
  }
}
class Ohr extends G3 {
  constructor(t, r, n, i, o) {
    super("RecognitionStartedEvent", t, o), this.privAudioSourceId = r, this.privAudioNodeId = n, this.privAuthFetchEventId = i;
  }
  get audioSourceId() {
    return this.privAudioSourceId;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
  get authFetchEventId() {
    return this.privAuthFetchEventId;
  }
}
var Hte;
(function(e) {
  e[e.Success = 0] = "Success", e[e.AudioSourceError = 1] = "AudioSourceError", e[e.AudioSourceTimeout = 2] = "AudioSourceTimeout", e[e.AuthTokenFetchError = 3] = "AuthTokenFetchError", e[e.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", e[e.UnAuthorized = 5] = "UnAuthorized", e[e.ConnectTimeout = 6] = "ConnectTimeout", e[e.ConnectError = 7] = "ConnectError", e[e.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", e[e.UnknownError = 9] = "UnknownError";
})(Hte || (Hte = {}));
class so extends JB {
  constructor(t, r, n, i, o, a, u, s) {
    if (!r)
      throw new bo("path");
    if (!n)
      throw new bo("requestId");
    const c = {};
    if (c[Ii.Path] = r, c[Ii.RequestId] = n, c[Ii.RequestTimestamp] = (/* @__PURE__ */ new Date()).toISOString(), i && (c[Ii.ContentType] = i), a && (c[Ii.RequestStreamId] = a), u)
      for (const l in u)
        l && (c[l] = u[l]);
    s ? super(t, o, c, s) : super(t, o, c), this.privPath = r, this.privRequestId = n, this.privContentType = i, this.privStreamId = a, this.privAdditionalHeaders = u;
  }
  get path() {
    return this.privPath;
  }
  get requestId() {
    return this.privRequestId;
  }
  get contentType() {
    return this.privContentType;
  }
  get streamId() {
    return this.privStreamId;
  }
  get additionalHeaders() {
    return this.privAdditionalHeaders;
  }
}
so.fromConnectionMessage = (e) => {
  let t = null, r = null, n = null, i = null;
  const o = {};
  if (e.headers)
    for (const a in e.headers)
      a && (a.toLowerCase() === Ii.Path.toLowerCase() ? t = e.headers[a] : a.toLowerCase() === Ii.RequestId.toLowerCase() ? r = e.headers[a] : a.toLowerCase() === Ii.RequestTimestamp.toLowerCase() ? e.headers[a] : a.toLowerCase() === Ii.ContentType.toLowerCase() ? n = e.headers[a] : a.toLowerCase() === Ii.RequestStreamId.toLowerCase() ? i = e.headers[a] : o[a] = e.headers[a]);
  return new so(e.messageType, t, r, n, e.body, i, o, e.id);
};
var io = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let nb = class s1 {
  constructor(t, r, n, i, o) {
    if (this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.recognizeOverride = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendSpeechContext = (a) => {
      const u = this.speechContext.toJSON();
      if (u)
        return a.send(new so(Jr.Text, "speech.context", this.privRequestSession.requestId, "application/json", u));
    }, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSpeechServiceConfig = (a, u, s) => {
      if (s1.telemetryDataEnabled !== !0) {
        const l = {
          context: {
            system: JSON.parse(s).context.system
          }
        };
        s = JSON.stringify(l);
      }
      if (this.privRecognizerConfig.parameters.getProperty("TranscriptionService_SingleChannel", "false").toLowerCase() === "true") {
        const c = JSON.parse(s);
        c.context.DisableReferenceChannel = "True", c.context.MicSpec = "1_0_0", s = JSON.stringify(c);
      }
      if (s)
        return a.send(new so(Jr.Text, "speech.config", u.requestId, "application/json", s));
    }, !t)
      throw new bo("authentication");
    if (!r)
      throw new bo("connectionFactory");
    if (!n)
      throw new bo("audioSource");
    if (!i)
      throw new bo("recognizerConfig");
    this.privMustReportEndOfStream = !1, this.privAuthentication = t, this.privConnectionFactory = r, this.privAudioSource = n, this.privRecognizerConfig = i, this.privIsDisposed = !1, this.privRecognizer = o, this.privRequestSession = new Mhr(this.privAudioSource.id()), this.privConnectionEvents = new ms(), this.privServiceEvents = new ms(), this.privDynamicGrammar = new Hhr(), this.privSpeechContext = new Fhr(this.privDynamicGrammar), this.privAgentConfig = new nAe(), typeof Blob < "u" && typeof Worker < "u" && (this.privSetTimeout = Yi.setTimeout), this.connectionEvents.attach((a) => io(this, void 0, void 0, function* () {
      if (a.name === "ConnectionClosedEvent") {
        const u = a;
        (u.statusCode === 1003 || u.statusCode === 1007 || u.statusCode === 1002 || u.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) && (yield this.cancelRecognitionLocal(ea.Error, u.statusCode === 1007 ? Mi.BadRequestParameters : Mi.ConnectionFailure, u.reason + " websocket error code: " + u.statusCode));
      }
    }));
  }
  get audioSource() {
    return this.privAudioSource;
  }
  get speechContext() {
    return this.privSpeechContext;
  }
  get dynamicGrammar() {
    return this.privDynamicGrammar;
  }
  get agentConfig() {
    return this.privAgentConfig;
  }
  set conversationTranslatorToken(t) {
    this.privRecognizerConfig.parameters.setProperty(Lt.ConversationTranslator_Token, t);
  }
  set authentication(t) {
    this.privAuthentication = this.authentication;
  }
  isDisposed() {
    return this.privIsDisposed;
  }
  dispose(t) {
    return io(this, void 0, void 0, function* () {
      if (this.privIsDisposed = !0, this.privConnectionConfigurationPromise)
        try {
          yield (yield this.privConnectionConfigurationPromise).dispose(t);
        } catch {
          return;
        }
    });
  }
  get connectionEvents() {
    return this.privConnectionEvents;
  }
  get serviceEvents() {
    return this.privServiceEvents;
  }
  get recognitionMode() {
    return this.privRecognizerConfig.recognitionMode;
  }
  recognize(t, r, n) {
    return io(this, void 0, void 0, function* () {
      if (this.recognizeOverride !== void 0)
        return this.recognizeOverride(t, r, n);
      this.privConnectionConfigurationPromise = null, this.privRecognizerConfig.recognitionMode = t, this.privSuccessCallback = r, this.privErrorCallback = n, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
      const i = this.connectImpl();
      let o;
      try {
        const s = yield this.audioSource.attach(this.privRequestSession.audioNodeId), c = yield this.audioSource.format, l = yield this.audioSource.deviceInfo;
        this.privIsLiveAudio = l.type && l.type === Mf.Microphones, o = new vAe(s, c.avgBytesPerSec), yield this.privRequestSession.onAudioSourceAttachCompleted(o, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: l };
      } catch (s) {
        throw yield this.privRequestSession.onStopRecognizing(), s;
      }
      try {
        yield i;
      } catch (s) {
        yield this.cancelRecognitionLocal(ea.Error, Mi.ConnectionFailure, s);
        return;
      }
      const a = new cT(this.privRequestSession.sessionId);
      this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, a), this.receiveMessage(), this.sendAudio(o).catch((s) => io(this, void 0, void 0, function* () {
        yield this.cancelRecognitionLocal(ea.Error, Mi.RuntimeError, s);
      }));
    });
  }
  stopRecognizing() {
    return io(this, void 0, void 0, function* () {
      if (this.privRequestSession.isRecognizing)
        try {
          yield this.audioSource.turnOff(), yield this.sendFinalAudio(), yield this.privRequestSession.onStopRecognizing(), yield this.privRequestSession.turnCompletionPromise;
        } finally {
          yield this.privRequestSession.dispose();
        }
    });
  }
  connect() {
    return io(this, void 0, void 0, function* () {
      return yield this.connectImpl(), Promise.resolve();
    });
  }
  connectAsync(t, r) {
    this.connectImpl().then((n) => {
      try {
        t && t();
      } catch (i) {
        r && r(i);
      }
    }, (n) => {
      try {
        r && r(n);
      } catch {
      }
    });
  }
  disconnect() {
    return io(this, void 0, void 0, function* () {
      yield this.cancelRecognitionLocal(ea.Error, Mi.NoError, "Disconnecting"), this.disconnectOverride !== void 0 && (yield this.disconnectOverride());
      try {
        yield (yield this.privConnectionPromise).dispose();
      } catch {
      }
      this.privConnectionPromise = null;
    });
  }
  sendMessage(t) {
  }
  sendNetworkMessage(t, r) {
    return io(this, void 0, void 0, function* () {
      const n = typeof r == "string" ? Jr.Text : Jr.Binary, i = typeof r == "string" ? "application/json" : "";
      return (yield this.fetchConnection()).send(new so(n, t, this.privRequestSession.requestId, i, r));
    });
  }
  set activityTemplate(t) {
    this.privActivityTemplate = t;
  }
  get activityTemplate() {
    return this.privActivityTemplate;
  }
  sendTelemetryData() {
    return io(this, void 0, void 0, function* () {
      const t = this.privRequestSession.getTelemetry();
      if (s1.telemetryDataEnabled !== !0 || this.privIsDisposed || t === null)
        return;
      if (s1.telemetryData)
        try {
          s1.telemetryData(t);
        } catch {
        }
      yield (yield this.fetchConnection()).send(new so(Jr.Text, "telemetry", this.privRequestSession.requestId, "application/json", t));
    });
  }
  // Cancels recognition.
  cancelRecognitionLocal(t, r, n) {
    return io(this, void 0, void 0, function* () {
      this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, t, r, n));
    });
  }
  receiveMessage() {
    return io(this, void 0, void 0, function* () {
      try {
        if (this.privIsDisposed)
          return;
        let t = yield this.fetchConnection();
        const r = yield t.read();
        if (this.receiveMessageOverride !== void 0)
          return this.receiveMessageOverride();
        if (!r)
          return this.privRequestSession.isRecognizing ? this.receiveMessage() : void 0;
        this.privServiceHasSentMessage = !0;
        const n = so.fromConnectionMessage(r);
        if (n.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase())
          switch (n.path.toLowerCase()) {
            case "turn.start":
              this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse();
              break;
            case "speech.startdetected":
              const i = ib.fromJSON(n.textBody), o = new rh(i.Offset, this.privRequestSession.sessionId);
              this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, o);
              break;
            case "speech.enddetected":
              let a;
              n.textBody.length > 0 ? a = n.textBody : a = "{ Offset: 0 }";
              const u = ib.fromJSON(a);
              this.privRecognizerConfig.isContinuousRecognition && this.privRequestSession.onServiceRecognized(u.Offset + this.privRequestSession.currentTurnAudioOffset);
              const s = new rh(u.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
              this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, s);
              break;
            case "turn.end":
              yield this.sendTelemetryData(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream && (this.privMustReportEndOfStream = !1, yield this.cancelRecognitionLocal(ea.EndOfStream, Mi.NoError, void 0));
              const c = new cT(this.privRequestSession.sessionId);
              if (yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, c);
                return;
              } else
                t = yield this.fetchConnection(), yield this.sendPrePayloadJSON(t);
              break;
            default:
              (yield this.processTypeSpecificMessages(n)) || this.privServiceEvents && this.serviceEvents.onEvent(new pH(n.path.toLowerCase(), n.textBody));
          }
        return this.receiveMessage();
      } catch {
        return null;
      }
    });
  }
  // Encapsulated for derived service recognizers that need to send additional JSON
  sendPrePayloadJSON(t) {
    return io(this, void 0, void 0, function* () {
      if (this.sendPrePayloadJSONOverride !== void 0)
        return this.sendPrePayloadJSONOverride(t);
      yield this.sendSpeechContext(t), yield this.sendWaveHeader(t);
    });
  }
  sendWaveHeader(t) {
    return io(this, void 0, void 0, function* () {
      const r = yield this.audioSource.format;
      return t.send(new so(Jr.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", r.header));
    });
  }
  // Establishes a websocket connection to the end point.
  connectImpl() {
    return this.privConnectionPromise ? this.privConnectionPromise.then((t) => t.state() === uo.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, (t) => (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl())) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(() => {
    }), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
  }
  fetchConnection() {
    return io(this, void 0, void 0, function* () {
      return this.privConnectionConfigurationPromise ? this.privConnectionConfigurationPromise.then((t) => t.state() === uo.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, (t) => (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
    });
  }
  sendAudio(t) {
    return io(this, void 0, void 0, function* () {
      const r = yield this.audioSource.format;
      let n = Date.now();
      const i = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), o = r.avgBytesPerSec / 1e3 * parseInt(i, 10), a = this.privRequestSession.recogNumber, u = () => io(this, void 0, void 0, function* () {
        if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a) {
          const s = yield this.fetchConnection(), c = yield t.read();
          if (this.privRequestSession.isSpeechEnded)
            return;
          let l, f;
          if (!c || c.isEnd ? (l = null, f = 0) : (l = c.buffer, this.privRequestSession.onAudioSent(l.byteLength), o >= this.privRequestSession.bytesSent ? f = 0 : f = Math.max(0, n - Date.now())), f !== 0 && (yield this.delay(f)), l !== null && (n = Date.now() + l.byteLength * 1e3 / (r.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a)
            if (s.send(new so(Jr.Binary, "audio", this.privRequestSession.requestId, null, l)).catch(() => {
              this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(() => {
              });
            }), c != null && c.isEnd)
              this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
            else
              return u();
        }
      });
      return u();
    });
  }
  retryableConnect() {
    return io(this, void 0, void 0, function* () {
      let t = !1;
      this.privAuthFetchEventId = Ei();
      const r = this.privRequestSession.sessionId;
      this.privConnectionId = r !== void 0 ? r : Ei(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
      let n = 0, i = "";
      for (; this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount; ) {
        const a = yield t ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        yield this.privRequestSession.onAuthCompleted(!1);
        const u = this.privConnectionFactory.create(this.privRecognizerConfig, a, this.privConnectionId);
        this.privRequestSession.listenForServiceTelemetry(u.events), u.events.attach((c) => {
          this.connectionEvents.onEvent(c);
        });
        const s = yield u.open();
        if (s.statusCode === 200)
          return yield this.privRequestSession.onConnectionEstablishCompleted(s.statusCode), Promise.resolve(u);
        s.statusCode === 1006 && (t = !0), n = s.statusCode, i = s.reason, this.privRequestSession.onRetryConnection();
      }
      return yield this.privRequestSession.onConnectionEstablishCompleted(n, i), Promise.reject(`Unable to contact server. StatusCode: ${n}, ${this.privRecognizerConfig.parameters.getProperty(Lt.SpeechServiceConnection_Endpoint)} Reason: ${i}`);
    });
  }
  delay(t) {
    return new Promise((r, n) => {
      this.privSetTimeout(r, t);
    });
  }
  writeBufferToConsole(t) {
    let r = "Buffer Size: ";
    if (t === null)
      r += "null";
    else {
      const n = new Uint8Array(t);
      r += t.byteLength + `\r
`;
      for (let i = 0; i < t.byteLength; i++)
        r += n[i].toString(16).padStart(2, "0") + " ";
    }
    console.info(r);
  }
  sendFinalAudio() {
    return io(this, void 0, void 0, function* () {
      yield (yield this.fetchConnection()).send(new so(Jr.Binary, "audio", this.privRequestSession.requestId, null, null));
    });
  }
  // Takes an established websocket connection to the endpoint and sends speech configuration information.
  configureConnection() {
    return io(this, void 0, void 0, function* () {
      const t = yield this.connectImpl();
      return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(t) : (yield this.sendSpeechServiceConfig(t, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendPrePayloadJSON(t), t);
    });
  }
};
nb.telemetryDataEnabled = !0;
var Tf;
(function(e) {
  e[e.Interactive = 0] = "Interactive", e[e.Conversation = 1] = "Conversation", e[e.Dictation = 2] = "Dictation";
})(Tf || (Tf = {}));
var $te;
(function(e) {
  e[e.Simple = 0] = "Simple", e[e.Detailed = 1] = "Detailed";
})($te || ($te = {}));
let Rhr = class {
  constructor(t, r) {
    this.privRecognitionMode = Tf.Interactive, this.privSpeechServiceConfig = t || new J_e(new Z_e(null)), this.privParameters = r, this.privMaxRetryCount = parseInt(r.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
  }
  get parameters() {
    return this.privParameters;
  }
  get recognitionMode() {
    return this.privRecognitionMode;
  }
  set recognitionMode(t) {
    this.privRecognitionMode = t, this.privRecognitionActivityTimeout = t === Tf.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = Tf[t];
  }
  get SpeechServiceConfig() {
    return this.privSpeechServiceConfig;
  }
  get recognitionActivityTimeout() {
    return this.privRecognitionActivityTimeout;
  }
  get isContinuousRecognition() {
    return this.privRecognitionMode !== Tf.Interactive;
  }
  get autoDetectSourceLanguages() {
    return this.parameters.getProperty(Lt.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
  }
  get maxRetryCount() {
    return this.privMaxRetryCount;
  }
};
class J_e {
  constructor(t) {
    this.serialize = () => JSON.stringify(this, (r, n) => {
      if (n && typeof n == "object") {
        const i = {};
        for (const o in n)
          Object.hasOwnProperty.call(n, o) && (i[o && o.charAt(0).toLowerCase() + o.substring(1)] = n[o]);
        return i;
      }
      return n;
    }), this.context = t;
  }
  get Context() {
    return this.context;
  }
  get Recognition() {
    return this.recognition;
  }
  set Recognition(t) {
    this.recognition = t.toLowerCase();
  }
}
class Z_e {
  constructor(t) {
    this.system = new whr(), this.os = t;
  }
}
class whr {
  constructor() {
    const t = "1.17.0";
    this.name = "SpeechSDK", this.version = t, this.build = "JavaScript", this.lang = "JavaScript";
  }
}
let Phr = class {
  constructor(t, r, n) {
    this.platform = t, this.name = r, this.version = n;
  }
};
var nh;
(function(e) {
  e.Bluetooth = "Bluetooth", e.Wired = "Wired", e.WiFi = "WiFi", e.Cellular = "Cellular", e.InBuilt = "InBuilt", e.Unknown = "Unknown";
})(nh || (nh = {}));
var Mf;
(function(e) {
  e.Phone = "Phone", e.Speaker = "Speaker", e.Car = "Car", e.Headset = "Headset", e.Thermostat = "Thermostat", e.Microphones = "Microphones", e.Deskphone = "Deskphone", e.RemoteControl = "RemoteControl", e.Unknown = "Unknown", e.File = "File", e.Stream = "Stream";
})(Mf || (Mf = {}));
const Ute = `\r
`;
let Dhr = class {
  constructor() {
    this.toConnectionMessage = (t) => {
      const r = new Wi();
      try {
        if (t.messageType === Jr.Text) {
          const n = t.textContent;
          let i = {}, o = null;
          if (n) {
            const a = n.split(`\r
\r
`);
            a && a.length > 0 && (i = this.parseHeaders(a[0]), a.length > 1 && (o = a[1]));
          }
          r.resolve(new JB(t.messageType, o, i, t.id));
        } else if (t.messageType === Jr.Binary) {
          const n = t.binaryContent;
          let i = {}, o = null;
          if (!n || n.byteLength < 2)
            throw new Error("Invalid binary message format. Header length missing.");
          const a = new DataView(n), u = a.getInt16(0);
          if (n.byteLength < u + 2)
            throw new Error("Invalid binary message format. Header content missing.");
          let s = "";
          for (let c = 0; c < u; c++)
            s += String.fromCharCode(a.getInt8(c + 2));
          i = this.parseHeaders(s), n.byteLength > u + 2 && (o = n.slice(2 + u)), r.resolve(new JB(t.messageType, o, i, t.id));
        }
      } catch (n) {
        r.reject(`Error formatting the message. Error: ${n}`);
      }
      return r.promise;
    }, this.fromConnectionMessage = (t) => {
      const r = new Wi();
      try {
        if (t.messageType === Jr.Text) {
          const n = `${this.makeHeaders(t)}${Ute}${t.textBody ? t.textBody : ""}`;
          r.resolve(new tb(Jr.Text, n, t.id));
        } else if (t.messageType === Jr.Binary) {
          const n = this.makeHeaders(t), i = t.binaryBody, o = this.stringToArrayBuffer(n), a = new Int8Array(o), u = a.byteLength, s = new Int8Array(2 + u + (i ? i.byteLength : 0));
          if (s[0] = u >> 8 & 255, s[1] = u & 255, s.set(a, 2), i) {
            const l = new Int8Array(i);
            s.set(l, 2 + u);
          }
          const c = s.buffer;
          r.resolve(new tb(Jr.Binary, c, t.id));
        }
      } catch (n) {
        r.reject(`Error formatting the message. ${n}`);
      }
      return r.promise;
    }, this.makeHeaders = (t) => {
      let r = "";
      if (t.headers)
        for (const n in t.headers)
          n && (r += `${n}: ${t.headers[n]}${Ute}`);
      return r;
    }, this.parseHeaders = (t) => {
      const r = {};
      if (t) {
        const n = t.match(/[^\r\n]+/g);
        if (r) {
          for (const i of n)
            if (i) {
              const o = i.indexOf(":"), a = o > 0 ? i.substr(0, o).trim().toLowerCase() : i, u = o > 0 && i.length > o + 1 ? i.substr(o + 1).trim() : "";
              r[a] = u;
            }
        }
      }
      return r;
    }, this.stringToArrayBuffer = (t) => {
      const r = new ArrayBuffer(t.length), n = new DataView(r);
      for (let i = 0; i < t.length; i++)
        n.setUint8(i, t.charCodeAt(i));
      return r;
    };
  }
}, xhr = class {
  static implTranslateRecognitionResult(t) {
    let r = La.Canceled;
    switch (t) {
      case ao.Success:
        r = La.RecognizedSpeech;
        break;
      case ao.NoMatch:
      case ao.InitialSilenceTimeout:
      case ao.BabbleTimeout:
      case ao.EndOfDictation:
        r = La.NoMatch;
        break;
      case ao.Error:
      default:
        r = La.Canceled;
        break;
    }
    return r;
  }
  static implTranslateCancelResult(t) {
    let r = ea.EndOfStream;
    switch (t) {
      case ao.Success:
      case ao.EndOfDictation:
      case ao.NoMatch:
        r = ea.EndOfStream;
        break;
      case ao.InitialSilenceTimeout:
      case ao.BabbleTimeout:
      case ao.Error:
      default:
        r = ea.Error;
        break;
    }
    return r;
  }
  static implTranslateCancelErrorCode(t) {
    let r = Mi.NoError;
    switch (t) {
      case ao.Error:
        r = Mi.ServiceError;
        break;
      case ao.TooManyRequests:
        r = Mi.TooManyRequests;
        break;
      default:
        r = Mi.NoError;
        break;
    }
    return r;
  }
};
var Vte;
(function(e) {
  e[e.Success = 0] = "Success", e[e.SynthesisEnd = 1] = "SynthesisEnd", e[e.Error = 2] = "Error";
})(Vte || (Vte = {}));
var ao;
(function(e) {
  e[e.Success = 0] = "Success", e[e.NoMatch = 1] = "NoMatch", e[e.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", e[e.BabbleTimeout = 3] = "BabbleTimeout", e[e.Error = 4] = "Error", e[e.EndOfDictation = 5] = "EndOfDictation", e[e.TooManyRequests = 6] = "TooManyRequests";
})(ao || (ao = {}));
let ib = class Q_e {
  constructor(t) {
    this.privSpeechStartDetected = JSON.parse(t);
  }
  static fromJSON(t) {
    return new Q_e(t);
  }
  get Offset() {
    return this.privSpeechStartDetected.Offset;
  }
}, Nhr = class eAe {
  constructor(t) {
    this.privSpeechHypothesis = JSON.parse(t);
  }
  static fromJSON(t) {
    return new eAe(t);
  }
  get Text() {
    return this.privSpeechHypothesis.Text;
  }
  get Offset() {
    return this.privSpeechHypothesis.Offset;
  }
  get Duration() {
    return this.privSpeechHypothesis.Duration;
  }
  get Language() {
    return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
  }
  get LanguageDetectionConfidence() {
    return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
  }
  get SpeakerId() {
    return this.privSpeechHypothesis.SpeakerId;
  }
}, Lhr = class tAe {
  constructor(t) {
    this.privSpeechKeyword = JSON.parse(t);
  }
  static fromJSON(t) {
    return new tAe(t);
  }
  get Status() {
    return this.privSpeechKeyword.Status;
  }
  get Text() {
    return this.privSpeechKeyword.Text;
  }
  get Offset() {
    return this.privSpeechKeyword.Offset;
  }
  get Duration() {
    return this.privSpeechKeyword.Duration;
  }
}, Bhr = class rAe {
  constructor(t) {
    this.privSimpleSpeechPhrase = JSON.parse(t), this.privSimpleSpeechPhrase.RecognitionStatus = ao[this.privSimpleSpeechPhrase.RecognitionStatus];
  }
  static fromJSON(t) {
    return new rAe(t);
  }
  get RecognitionStatus() {
    return this.privSimpleSpeechPhrase.RecognitionStatus;
  }
  get DisplayText() {
    return this.privSimpleSpeechPhrase.DisplayText;
  }
  get Offset() {
    return this.privSimpleSpeechPhrase.Offset;
  }
  get Duration() {
    return this.privSimpleSpeechPhrase.Duration;
  }
  get Language() {
    return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
  }
  get LanguageDetectionConfidence() {
    return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
  }
  get SpeakerId() {
    return this.privSimpleSpeechPhrase.SpeakerId;
  }
};
class khr {
  constructor(t, r, n) {
    this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.onEvent = (i) => {
      this.privIsDisposed || (i instanceof K_e && i.requestId === this.privRequestId && (this.privListeningTriggerMetric = {
        End: i.eventTime,
        Name: "ListeningTrigger",
        Start: i.eventTime
      }), i instanceof Hy && i.audioSourceId === this.privAudioSourceId && i.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = i.eventTime), i instanceof $y && i.audioSourceId === this.privAudioSourceId && i.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = i.eventTime), i instanceof QS && i.audioSourceId === this.privAudioSourceId && (this.privMicMetric || (this.privMicMetric = {
        End: i.eventTime,
        Error: i.error,
        Name: "Microphone",
        Start: this.privMicStartTime
      })), i instanceof dH && i.audioSourceId === this.privAudioSourceId && i.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
        End: i.eventTime,
        Error: i.error,
        Name: "Microphone",
        Start: this.privMicStartTime
      })), i instanceof Qc && i.audioSourceId === this.privAudioSourceId && i.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
        End: i.eventTime,
        Name: "Microphone",
        Start: this.privMicStartTime
      })), i instanceof X_e && i.requestId === this.privRequestId && (this.privConnectionId = i.sessionId), i instanceof M_e && i.connectionId === this.privConnectionId && (this.privConnectionStartTime = i.eventTime), i instanceof F_e && i.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
        End: i.eventTime,
        Id: this.privConnectionId,
        Name: "Connection",
        Start: this.privConnectionStartTime
      })), i instanceof Hpr && i.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
        End: i.eventTime,
        Error: this.getConnectionError(i.statusCode),
        Id: this.privConnectionId,
        Name: "Connection",
        Start: this.privConnectionStartTime
      })), i instanceof XB && i.connectionId === this.privConnectionId && i.message && i.message.headers && i.message.headers.path && (this.privReceivedMessages[i.message.headers.path] || (this.privReceivedMessages[i.message.headers.path] = new Array()), this.privReceivedMessages[i.message.headers.path].push(i.networkReceivedTime)));
    }, this.getTelemetry = () => {
      const i = new Array();
      this.privListeningTriggerMetric && i.push(this.privListeningTriggerMetric), this.privMicMetric && i.push(this.privMicMetric), this.privConnectionEstablishMetric && i.push(this.privConnectionEstablishMetric), this.privPhraseLatencies.length > 0 && i.push({
        PhraseLatencyMs: this.privPhraseLatencies
      }), this.privHypothesisLatencies.length > 0 && i.push({
        FirstHypothesisLatencyMs: this.privHypothesisLatencies
      });
      const o = {
        Metrics: i,
        ReceivedMessages: this.privReceivedMessages
      }, a = JSON.stringify(o);
      return this.privReceivedMessages = {}, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privPhraseLatencies = [], this.privHypothesisLatencies = [], a;
    }, this.dispose = () => {
      this.privIsDisposed = !0;
    }, this.getConnectionError = (i) => {
      switch (i) {
        case 400:
        case 1002:
        case 1003:
        case 1005:
        case 1007:
        case 1008:
        case 1009:
          return "BadRequest";
        case 401:
          return "Unauthorized";
        case 403:
          return "Forbidden";
        case 503:
        case 1001:
          return "ServerUnavailable";
        case 500:
        case 1011:
          return "ServerError";
        case 408:
        case 504:
          return "Timeout";
        default:
          return "statuscode:" + i.toString();
      }
    }, this.privRequestId = t, this.privAudioSourceId = r, this.privAudioNodeId = n, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
  }
  phraseReceived(t) {
    t > 0 && this.privPhraseLatencies.push(Date.now() - t);
  }
  hypothesisReceived(t) {
    t > 0 && this.privHypothesisLatencies.push(Date.now() - t);
  }
  // Determines if there are any telemetry events to send to the service.
  get hasTelemetry() {
    return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
  }
}
var Pl = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let Mhr = class {
  constructor(t) {
    this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.onPreConnectionStart = (r, n) => {
      this.privAuthFetchEventId = r, this.privSessionId = n, this.onEvent(new X_e(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }, this.onServiceTurnStartResponse = () => {
      this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
      })), this.privInTurn = !0, this.privTurnDeferral = new Wi();
    }, this.getTelemetry = () => this.privServiceTelemetryListener.hasTelemetry ? this.privServiceTelemetryListener.getTelemetry() : null, this.onEvent = (r) => {
      this.privServiceTelemetryListener && this.privServiceTelemetryListener.onEvent(r), fo.instance.onEvent(r);
    }, this.privAudioSourceId = t, this.privRequestId = Ei(), this.privAudioNodeId = Ei(), this.privTurnDeferral = new Wi(), this.privTurnDeferral.resolve();
  }
  get sessionId() {
    return this.privSessionId;
  }
  get requestId() {
    return this.privRequestId;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
  get turnCompletionPromise() {
    return this.privTurnDeferral.promise;
  }
  get isSpeechEnded() {
    return this.privIsSpeechEnded;
  }
  get isRecognizing() {
    return this.privIsRecognizing;
  }
  get currentTurnAudioOffset() {
    return this.privTurnStartAudioOffset;
  }
  get recogNumber() {
    return this.privRecogNumber;
  }
  get numConnectionAttempts() {
    return this.privConnectionAttempts;
  }
  // The number of bytes sent for the current connection.
  // Counter is reset to 0 each time a connection is established.
  get bytesSent() {
    return this.privBytesSent;
  }
  listenForServiceTelemetry(t) {
    this.privServiceTelemetryListener && this.privDetachables.push(t.attachListener(this.privServiceTelemetryListener));
  }
  startNewRecognition() {
    this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRequestId = Ei(), this.privRecogNumber++, this.privServiceTelemetryListener = new khr(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new K_e(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
  }
  onAudioSourceAttachCompleted(t, r, n) {
    return Pl(this, void 0, void 0, function* () {
      this.privAudioNode = t, this.privIsAudioNodeDetached = !1, r ? yield this.onComplete() : this.onEvent(new Ihr(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    });
  }
  onAuthCompleted(t, r) {
    return Pl(this, void 0, void 0, function* () {
      t && (yield this.onComplete());
    });
  }
  onConnectionEstablishCompleted(t, r) {
    return Pl(this, void 0, void 0, function* () {
      if (t === 200) {
        this.onEvent(new Ohr(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0;
        return;
      } else t === 403 && (yield this.onComplete());
    });
  }
  onServiceTurnEndResponse(t) {
    return Pl(this, void 0, void 0, function* () {
      this.privTurnDeferral.resolve(), !t || this.isSpeechEnded ? (yield this.onComplete(), this.privInTurn = !1) : (this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privRequestId = Ei(), this.privAudioNode.replay());
    });
  }
  onHypothesis(t) {
    this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(t)));
  }
  onPhraseRecognized(t) {
    this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(t)), this.onServiceRecognized(t);
  }
  onServiceRecognized(t) {
    this.privLastRecoOffset = t, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(t), this.privConnectionAttempts = 0;
  }
  onAudioSent(t) {
    this.privBytesSent += t;
  }
  onRetryConnection() {
    this.privConnectionAttempts++;
  }
  dispose(t) {
    return Pl(this, void 0, void 0, function* () {
      if (!this.privIsDisposed) {
        this.privIsDisposed = !0;
        for (const r of this.privDetachables)
          yield r.detach();
        this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1;
      }
    });
  }
  onStopRecognizing() {
    return Pl(this, void 0, void 0, function* () {
      yield this.onComplete();
    });
  }
  // Should be called with the audioNode for this session has indicated that it is out of speech.
  onSpeechEnded() {
    this.privIsSpeechEnded = !0;
  }
  onComplete() {
    return Pl(this, void 0, void 0, function* () {
      this.privIsRecognizing && (this.privIsRecognizing = !1, yield this.detachAudioNode());
    });
  }
  detachAudioNode() {
    return Pl(this, void 0, void 0, function* () {
      this.privIsAudioNodeDetached || (this.privIsAudioNodeDetached = !0, this.privAudioNode && (yield this.privAudioNode.detach()));
    });
  }
}, Fhr = class {
  constructor(t) {
    this.privContext = {}, this.privDynamicGrammar = t;
  }
  /**
   * Adds a section to the speech.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */
  setSection(t, r) {
    this.privContext[t] = r;
  }
  /**
   * @Internal
   * This is only used by pronunciation assessment config.
   * Do not use externally, object returned will change without warning or notice.
   */
  setPronunciationAssessmentParams(t) {
    this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = {
      enrichment: {
        pronunciationAssessment: {}
      }
    }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(t), this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
      detailed: {
        options: []
      },
      format: {}
    }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
  }
  toJSON() {
    const t = this.privDynamicGrammar.generateGrammarObject();
    return this.setSection("dgi", t), JSON.stringify(this.privContext);
  }
}, Hhr = class {
  // Adds one more reference phrases to the dynamic grammar to send.
  // All added phrases are generic phrases.
  addPhrase(t) {
    this.privPhrases || (this.privPhrases = []), t instanceof Array ? this.privPhrases = this.privPhrases.concat(t) : this.privPhrases.push(t);
  }
  // Clears all phrases stored in the current object.
  clearPhrases() {
    this.privPhrases = void 0;
  }
  // Adds one or more reference grammars to the current grammar.
  addReferenceGrammar(t) {
    this.privGrammars || (this.privGrammars = []), t instanceof Array ? this.privGrammars = this.privGrammars.concat(t) : this.privGrammars.push(t);
  }
  // clears all grammars stored on the recognizer.
  clearGrammars() {
    this.privGrammars = void 0;
  }
  // Generates an object that represents the dynamic grammar used by the Speech Service.
  // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
  // of a DynamicGrammarBuilder
  generateGrammarObject() {
    if (this.privGrammars === void 0 && this.privPhrases === void 0)
      return;
    const t = {};
    if (t.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
      const r = [];
      this.privPhrases.forEach((n, i, o) => {
        r.push({
          Text: n
        });
      }), t.Groups = [{ Type: "Generic", Items: r }];
    }
    return t;
  }
};
class _H {
  constructor(t) {
    this.privActivityResponse = JSON.parse(t);
  }
  static fromJSON(t) {
    return new _H(t);
  }
  get conversationId() {
    return this.privActivityResponse.conversationId;
  }
  get messageDataStreamType() {
    return this.privActivityResponse.messageDataStreamType;
  }
  get messagePayload() {
    return this.privActivityResponse.messagePayload;
  }
  get version() {
    return this.privActivityResponse.version;
  }
}
var t8;
(function(e) {
  e[e.None = 0] = "None", e[e.TextToSpeechAudio = 1] = "TextToSpeechAudio";
})(t8 || (t8 = {}));
let $hr = class {
  constructor(t, r) {
    this.privRequestId = r, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = t, this.resetTurnEndTimeout();
  }
  get audioStream() {
    return this.resetTurnEndTimeout(), this.privAudioStream;
  }
  processActivityPayload(t, r) {
    return t.messageDataStreamType === t8.TextToSpeechAudio && (this.privAudioStream = mH.createPullStream(), this.privAudioStream.format = r !== void 0 ? r : zr.getDefaultOutputFormat()), this.privAudioStream;
  }
  endAudioStream() {
    this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
  }
  complete() {
    this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
  }
  resetTurnEndTimeout() {
    this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(() => {
      this.privTurnManager.CompleteTurn(this.privRequestId);
    }, 2e3);
  }
}, Uhr = class {
  constructor() {
    this.privTurnMap = /* @__PURE__ */ new Map();
  }
  StartTurn(t) {
    if (this.privTurnMap.has(t))
      throw new Na("Service error: There is already a turn with id:" + t);
    const r = new $hr(this, t);
    return this.privTurnMap.set(t, r), this.privTurnMap.get(t);
  }
  GetTurn(t) {
    return this.privTurnMap.get(t);
  }
  CompleteTurn(t) {
    if (!this.privTurnMap.has(t))
      throw new Na("Service error: Received turn end for an unknown turn id:" + t);
    const r = this.privTurnMap.get(t);
    return r.complete(), this.privTurnMap.delete(t), r;
  }
};
var ts = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let Vhr = class extends nb {
  constructor(t, r, n, i, o) {
    super(t, r, n, i, o), this.sendAgentConfig = (a) => {
      if (this.agentConfig && !this.agentConfigSent) {
        if (this.privRecognizerConfig.parameters.getProperty(Lt.Conversation_DialogType) === ps.DialogTypes.CustomCommands) {
          const s = this.agentConfig.get();
          s.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty(Lt.SpeechServiceConnection_RecoLanguage, "en-us"), this.agentConfig.set(s);
        }
        this.onEvent(new Vpr(this.agentConfig));
        const u = this.agentConfig.toJsonString();
        return this.agentConfigSent = !0, a.send(new so(Jr.Text, "agent.config", this.privRequestSession.requestId, "application/json", u));
      }
    }, this.sendAgentContext = (a) => {
      const u = KB(), s = this.privDialogServiceConnector.properties.getProperty(Lt.Conversation_Speech_Activity_Template), l = JSON.stringify({
        channelData: "",
        context: {
          interactionId: u
        },
        messagePayload: typeof s === void 0 ? void 0 : s,
        version: 0.5
      });
      return a.send(new so(Jr.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", l));
    }, this.handleResponseMessage = (a) => {
      const u = JSON.parse(a.textBody);
      switch (u.messageType.toLowerCase()) {
        case "message":
          const s = a.requestId.toUpperCase(), c = _H.fromJSON(a.textBody), l = this.privTurnStateManager.GetTurn(s);
          if (c.conversationId) {
            const p = this.agentConfig.get();
            p.botInfo.conversationId = c.conversationId, this.agentConfig.set(p);
          }
          const f = l.processActivityPayload(c, zr.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty(Lt.SpeechServiceConnection_SynthOutputFormat, void 0))), d = new yhr(c.messagePayload, f);
          if (this.privDialogServiceConnector.activityReceived)
            try {
              this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, d);
            } catch {
            }
          break;
        case "messagestatus":
          if (this.privDialogServiceConnector.turnStatusReceived)
            try {
              this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new _hr(a.textBody));
            } catch {
            }
          break;
        default:
          fo.instance.onEvent(new If(`Unexpected response of type ${u.messageType}. Ignoring.`));
          break;
      }
    }, this.privEvents = new ms(), this.privDialogServiceConnector = o, this.receiveMessageOverride = this.receiveDialogMessageOverride, this.privTurnStateManager = new Uhr(), this.recognizeOverride = this.listenOnce, this.postConnectImplOverride = this.dialogConnectImpl, this.configConnectionOverride = this.configConnection, this.disconnectOverride = this.privDisconnect, this.privDialogAudioSource = n, this.agentConfigSent = !1, this.privLastResult = null, this.connectionEvents.attach((a) => ts(this, void 0, void 0, function* () {
      a.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0);
    }));
  }
  sendMessage(t) {
    return ts(this, void 0, void 0, function* () {
      const r = KB(), n = Ei(), i = {
        context: {
          interactionId: r
        },
        messagePayload: JSON.parse(t),
        version: 0.5
      }, o = JSON.stringify(i);
      yield (yield this.fetchConnection()).send(new so(Jr.Text, "agent", n, "application/json", o));
    });
  }
  privDisconnect() {
    return ts(this, void 0, void 0, function* () {
      yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, ea.Error, Mi.NoError, "Disconnecting"), this.terminateMessageLoop = !0, this.agentConfigSent = !1;
    });
  }
  processTypeSpecificMessages(t) {
    return ts(this, void 0, void 0, function* () {
      const r = new rb();
      t.messageType === Jr.Text && r.setProperty(Lt.SpeechServiceResponse_JsonResult, t.textBody);
      let n, i;
      switch (t.path.toLowerCase()) {
        case "speech.phrase":
          const o = Bhr.fromJSON(t.textBody);
          if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + o.Offset + o.Duration), o.RecognitionStatus !== ao.TooManyRequests && o.RecognitionStatus !== ao.Error) {
            const f = this.fireEventForResult(o, r);
            if (this.privLastResult = f.result, this.privDialogServiceConnector.recognized)
              try {
                this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, f);
              } catch {
              }
          }
          i = !0;
          break;
        case "speech.hypothesis":
          const a = Nhr.fromJSON(t.textBody), u = a.Offset + this.privRequestSession.currentTurnAudioOffset;
          n = new DA(this.privRequestSession.requestId, La.RecognizingSpeech, a.Text, a.Duration, u, a.Language, a.LanguageDetectionConfidence, void 0, void 0, t.textBody, r), this.privRequestSession.onHypothesis(u);
          const s = new Rx(n, a.Duration, this.privRequestSession.sessionId);
          if (this.privDialogServiceConnector.recognizing)
            try {
              this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, s);
            } catch {
            }
          i = !0;
          break;
        case "speech.keyword":
          const c = Lhr.fromJSON(t.textBody);
          n = new DA(this.privRequestSession.requestId, c.Status === "Accepted" ? La.RecognizedKeyword : La.NoMatch, c.Text, c.Duration, c.Offset, void 0, void 0, void 0, void 0, t.textBody, r), c.Status !== "Accepted" && (this.privLastResult = n);
          const l = new Rx(n, n.duration, n.resultId);
          if (this.privDialogServiceConnector.recognized)
            try {
              this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, l);
            } catch {
            }
          i = !0;
          break;
        case "audio":
          {
            const f = t.requestId.toUpperCase(), d = this.privTurnStateManager.GetTurn(f);
            try {
              t.binaryBody ? d.audioStream.write(t.binaryBody) : d.endAudioStream();
            } catch {
            }
          }
          i = !0;
          break;
        case "response":
          this.handleResponseMessage(t), i = !0;
          break;
      }
      return i;
    });
  }
  // Cancels recognition.
  cancelRecognition(t, r, n, i, o) {
    return ts(this, void 0, void 0, function* () {
      if (this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing()), this.privDialogServiceConnector.canceled) {
        const a = new rb();
        a.setProperty(aAe, Mi[i]);
        const u = new vhr(n, o, i, void 0, t);
        try {
          this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, u);
        } catch {
        }
        if (this.privSuccessCallback) {
          const s = new DA(
            void 0,
            // ResultId
            La.Canceled,
            void 0,
            // Text
            void 0,
            // Duration
            void 0,
            // Offset
            void 0,
            // Language
            void 0,
            // Language Detection Confidence
            void 0,
            // Speaker Id
            o,
            void 0,
            // Json
            a
          );
          try {
            this.privSuccessCallback(s), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }
    });
  }
  listenOnce(t, r, n) {
    return ts(this, void 0, void 0, function* () {
      this.privRecognizerConfig.recognitionMode = t, this.privSuccessCallback = r, this.privErrorCallback = n, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty(Lt.Speech_SessionId, this.privRequestSession.sessionId);
      const i = this.connectImpl(), o = this.sendPreAudioMessages(), a = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId), u = yield this.privDialogAudioSource.format, s = yield this.privDialogAudioSource.deviceInfo, c = new vAe(a, u.avgBytesPerSec);
      yield this.privRequestSession.onAudioSourceAttachCompleted(c, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: s };
      try {
        yield i, yield o;
      } catch (d) {
        return yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, ea.Error, Mi.ConnectionFailure, d), Promise.resolve();
      }
      const l = new cT(this.privRequestSession.sessionId);
      this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, l), this.sendAudio(c).then(() => {
      }, (d) => ts(this, void 0, void 0, function* () {
        yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, ea.Error, Mi.RuntimeError, d);
      }));
    });
  }
  // Establishes a websocket connection to the end point.
  dialogConnectImpl(t) {
    return this.privConnectionLoop = this.startMessageLoop(), t;
  }
  receiveDialogMessageOverride() {
    const t = new Wi(), r = () => ts(this, void 0, void 0, function* () {
      try {
        const n = this.isDisposed(), i = !this.isDisposed() && this.terminateMessageLoop;
        if (n || i) {
          t.resolve(void 0);
          return;
        }
        const a = yield (yield this.fetchConnection()).read();
        if (!a)
          return r();
        const u = so.fromConnectionMessage(a);
        switch (u.path.toLowerCase()) {
          case "turn.start":
            {
              const v = u.requestId.toUpperCase(), h = this.privRequestSession.requestId.toUpperCase();
              v !== h ? this.privTurnStateManager.StartTurn(v) : this.privRequestSession.onServiceTurnStartResponse();
            }
            break;
          case "speech.startdetected":
            const c = ib.fromJSON(u.textBody), l = new rh(c.Offset, this.privRequestSession.sessionId);
            this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, l);
            break;
          case "speech.enddetected":
            let f;
            u.textBody.length > 0 ? f = u.textBody : f = "{ Offset: 0 }";
            const d = ib.fromJSON(f);
            this.privRequestSession.onServiceRecognized(d.Offset + this.privRequestSession.currentTurnAudioOffset);
            const p = new rh(d.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
            this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, p);
            break;
          case "turn.end":
            {
              const v = u.requestId.toUpperCase(), h = this.privRequestSession.requestId.toUpperCase();
              if (v !== h)
                this.privTurnStateManager.CompleteTurn(v);
              else {
                const E = new cT(this.privRequestSession.sessionId);
                if (yield this.privRequestSession.onServiceTurnEndResponse(!1), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, E), this.privSuccessCallback && this.privLastResult) {
                  try {
                    this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                  } catch (m) {
                    this.privErrorCallback && this.privErrorCallback(m);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
              }
            }
            break;
          default:
            this.processTypeSpecificMessages(u) || this.serviceEvents && this.serviceEvents.onEvent(new pH(u.path.toLowerCase(), u.textBody));
        }
        return r();
      } catch {
        this.terminateMessageLoop = !0, t.resolve();
      }
    });
    return r().catch((n) => {
      fo.instance.onEvent(new If(n));
    }), t.promise;
  }
  startMessageLoop() {
    return ts(this, void 0, void 0, function* () {
      this.terminateMessageLoop = !1;
      try {
        yield this.receiveDialogMessageOverride();
      } catch (t) {
        yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, ea.Error, Mi.RuntimeError, t);
      }
      return Promise.resolve();
    });
  }
  // Takes an established websocket connection to the endpoint and sends speech configuration information.
  configConnection(t) {
    return ts(this, void 0, void 0, function* () {
      return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, Promise.reject("Connection to service terminated.")) : (yield this.sendSpeechServiceConfig(t, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendAgentConfig(t), t);
    });
  }
  sendPreAudioMessages() {
    return ts(this, void 0, void 0, function* () {
      const t = yield this.fetchConnection();
      this.addKeywordContextData(), yield this.sendSpeechContext(t), yield this.sendAgentContext(t), yield this.sendWaveHeader(t);
    });
  }
  fireEventForResult(t, r) {
    const n = xhr.implTranslateRecognitionResult(t.RecognitionStatus), i = t.Offset + this.privRequestSession.currentTurnAudioOffset, o = new DA(this.privRequestSession.requestId, n, t.DisplayText, t.Duration, i, t.Language, t.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(t), r);
    return new Rx(o, i, this.privRequestSession.sessionId);
  }
  onEvent(t) {
    this.privEvents.onEvent(t), fo.instance.onEvent(t);
  }
  addKeywordContextData() {
    const t = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
    if (t === void 0)
      return;
    const r = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), n = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), i = t.split(";"), o = r === void 0 ? [] : r.split(";"), a = n === void 0 ? [] : n.split(";"), u = [];
    for (let s = 0; s < i.length; s++) {
      const c = {};
      c.text = i[s], s < o.length && (c.offset = Number(o[s])), s < a.length && (c.duration = Number(a[s])), u.push(c);
    }
    this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [{
      clientDetectedKeywords: u,
      onReject: { action: "EndOfTurn" },
      type: "startTrigger"
    }]);
  }
}, nAe = class {
  toJsonString() {
    return JSON.stringify(this.iPrivConfig);
  }
  get() {
    return this.iPrivConfig;
  }
  /**
   * Setter for the agent.config object.
   * @param value a JSON serializable object.
   */
  set(t) {
    this.iPrivConfig = t;
  }
};
var R1;
(function(e) {
  e.WordBoundary = "WordBoundary", e.Bookmark = "Bookmark", e.Viseme = "Viseme";
})(R1 || (R1 = {}));
let jhr = class iAe {
  constructor(t) {
    this.privSynthesisAudioMetadata = JSON.parse(t);
  }
  static fromJSON(t) {
    return new iAe(t);
  }
  get Metadata() {
    return this.privSynthesisAudioMetadata.Metadata;
  }
};
var Dc = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let AH = class oAe {
  constructor(t, r, n, i, o) {
    if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSynthesisContext = (a) => {
      const u = this.synthesisContext.toJSON();
      if (u)
        return a.send(new so(Jr.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", u));
    }, this.sendSpeechServiceConfig = (a, u) => {
      if (u)
        return a.send(new so(Jr.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", u));
    }, this.sendSsmlMessage = (a, u, s) => a.send(new so(Jr.Text, "ssml", s, "application/ssml+xml", u)), !t)
      throw new bo("authentication");
    if (!r)
      throw new bo("connectionFactory");
    if (!n)
      throw new bo("synthesizerConfig");
    this.privAuthentication = t, this.privConnectionFactory = r, this.privSynthesizerConfig = n, this.privIsDisposed = !1, this.privSpeechSynthesizer = i, this.privSessionAudioDestination = o, this.privSynthesisTurn = new Ghr(), this.privConnectionEvents = new ms(), this.privServiceEvents = new ms(), this.privSynthesisContext = new Whr(this.privSpeechSynthesizer), this.privAgentConfig = new nAe(), this.connectionEvents.attach((a) => {
      if (a.name === "ConnectionClosedEvent") {
        const u = a;
        u.statusCode !== 1e3 && this.cancelSynthesisLocal(ea.Error, u.statusCode === 1007 ? Mi.BadRequestParameters : Mi.ConnectionFailure, u.reason + " websocket error code: " + u.statusCode);
      }
    });
  }
  get synthesisContext() {
    return this.privSynthesisContext;
  }
  get agentConfig() {
    return this.privAgentConfig;
  }
  get connectionEvents() {
    return this.privConnectionEvents;
  }
  get serviceEvents() {
    return this.privServiceEvents;
  }
  set activityTemplate(t) {
    this.privActivityTemplate = t;
  }
  get activityTemplate() {
    return this.privActivityTemplate;
  }
  set audioOutputFormat(t) {
    this.privAudioOutputFormat = t, this.privSynthesisTurn.audioOutputFormat = t, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = t), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = t);
  }
  static addHeader(t, r) {
    if (!r.hasHeader)
      return t;
    r.updateHeader(t.byteLength);
    const n = new Uint8Array(t.byteLength + r.header.byteLength);
    return n.set(new Uint8Array(r.header), 0), n.set(new Uint8Array(t), r.header.byteLength), n.buffer;
  }
  isDisposed() {
    return this.privIsDisposed;
  }
  dispose(t) {
    return Dc(this, void 0, void 0, function* () {
      this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise && (yield (yield this.privConnectionConfigurationPromise).dispose(t));
    });
  }
  connect() {
    return Dc(this, void 0, void 0, function* () {
      yield this.connectImpl();
    });
  }
  sendNetworkMessage(t, r) {
    return Dc(this, void 0, void 0, function* () {
      const n = typeof r == "string" ? Jr.Text : Jr.Binary, i = typeof r == "string" ? "application/json" : "";
      return (yield this.fetchConnection()).send(new so(n, t, this.privSynthesisTurn.requestId, i, r));
    });
  }
  Speak(t, r, n, i, o, a) {
    return Dc(this, void 0, void 0, function* () {
      let u;
      if (r ? u = t : u = this.privSpeechSynthesizer.buildSsml(t), this.speakOverride !== void 0)
        return this.speakOverride(u, n, i, o);
      this.privSuccessCallback = i, this.privErrorCallback = o, this.privSynthesisTurn.startNewSynthesis(n, t, r, a);
      try {
        yield this.connectImpl();
        const s = yield this.fetchConnection();
        yield this.sendSynthesisContext(s), yield this.sendSsmlMessage(s, u, n);
        const c = new kA(new BA(n, La.SynthesizingAudioStarted));
        this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, c);
        const l = this.receiveMessage();
      } catch (s) {
        return this.cancelSynthesisLocal(ea.Error, Mi.ConnectionFailure, s), Promise.reject(s);
      }
    });
  }
  // Cancels synthesis.
  cancelSynthesis(t, r, n, i) {
    const o = new rb();
    o.setProperty(aAe, Mi[n]);
    const a = new BA(t, La.Canceled, void 0, i, o);
    if (this.privSpeechSynthesizer.SynthesisCanceled) {
      const u = new kA(a);
      try {
        this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, u);
      } catch {
      }
    }
    if (this.privSuccessCallback)
      try {
        this.privSuccessCallback(a);
      } catch {
      }
  }
  // Cancels synthesis.
  cancelSynthesisLocal(t, r, n) {
    this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, t, r, n));
  }
  processTypeSpecificMessages(t, r, n) {
    return !0;
  }
  receiveMessage() {
    return Dc(this, void 0, void 0, function* () {
      try {
        const r = yield (yield this.fetchConnection()).read();
        if (this.receiveMessageOverride !== void 0)
          return this.receiveMessageOverride();
        if (this.privIsDisposed)
          return;
        if (!r)
          return this.privSynthesisTurn.isSynthesizing ? this.receiveMessage() : void 0;
        this.privServiceHasSentMessage = !0;
        const n = so.fromConnectionMessage(r);
        if (n.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase())
          switch (n.path.toLowerCase()) {
            case "turn.start":
              this.privSynthesisTurn.onServiceTurnStartResponse();
              break;
            case "response":
              this.privSynthesisTurn.onServiceResponseMessage(n.textBody);
              break;
            case "audio":
              if (this.privSynthesisTurn.streamId.toLowerCase() === n.streamId.toLowerCase() && n.binaryBody) {
                if (this.privSynthesisTurn.onAudioChunkReceived(n.binaryBody), this.privSpeechSynthesizer.synthesizing)
                  try {
                    const a = oAe.addHeader(n.binaryBody, this.privSynthesisTurn.audioOutputFormat), u = new kA(new BA(this.privSynthesisTurn.requestId, La.SynthesizingAudio, a));
                    this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, u);
                  } catch {
                  }
                this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(n.binaryBody);
              }
              break;
            case "audio.metadata":
              const i = jhr.fromJSON(n.textBody).Metadata;
              for (const a of i)
                switch (a.Type) {
                  case R1.WordBoundary:
                    this.privSynthesisTurn.onWordBoundaryEvent(a.Data.text.Text);
                    const u = new Ahr(a.Data.Offset, a.Data.text.Text, a.Data.text.Length, this.privSynthesisTurn.currentTextOffset);
                    if (this.privSpeechSynthesizer.wordBoundary)
                      try {
                        this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, u);
                      } catch {
                      }
                    break;
                  case R1.Bookmark:
                    const s = new Shr(a.Data.Offset, a.Data.Bookmark);
                    if (this.privSpeechSynthesizer.bookmarkReached)
                      try {
                        this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, s);
                      } catch {
                      }
                    break;
                  case R1.Viseme:
                    if (this.privSynthesisTurn.onVisemeMetadataReceived(a), a.Data.IsLastAnimation) {
                      const c = new bhr(a.Data.Offset, a.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                      if (this.privSpeechSynthesizer.visemeReceived)
                        try {
                          this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, c);
                        } catch {
                        }
                    }
                    break;
                }
              break;
            case "turn.end":
              this.privSynthesisTurn.onServiceTurnEndResponse();
              let o;
              try {
                const a = yield this.privSynthesisTurn.getAllReceivedAudioWithHeader();
                o = new BA(this.privSynthesisTurn.requestId, La.SynthesizingAudioCompleted, a), this.privSuccessCallback && this.privSuccessCallback(o);
              } catch (a) {
                this.privErrorCallback && this.privErrorCallback(a);
              }
              if (this.privSpeechSynthesizer.synthesisCompleted)
                try {
                  this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new kA(o));
                } catch {
                }
              break;
            default:
              this.processTypeSpecificMessages(n) || this.privServiceEvents && this.serviceEvents.onEvent(new pH(n.path.toLowerCase(), n.textBody));
          }
        return this.receiveMessage();
      } catch {
      }
    });
  }
  connectImpl(t = !1) {
    if (this.privConnectionPromise)
      return this.privConnectionPromise.then((n) => n.state() === uo.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, (n) => (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()));
    this.privAuthFetchEventId = Ei(), this.privConnectionId = Ei(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
    const r = t ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
    return this.privConnectionPromise = r.then((n) => Dc(this, void 0, void 0, function* () {
      yield this.privSynthesisTurn.onAuthCompleted(!1);
      const i = this.privConnectionFactory.create(this.privSynthesizerConfig, n, this.privConnectionId);
      i.events.attach((a) => {
        this.connectionEvents.onEvent(a);
      });
      const o = yield i.open();
      return o.statusCode === 200 ? (yield this.privSynthesisTurn.onConnectionEstablishCompleted(o.statusCode), Promise.resolve(i)) : o.statusCode === 403 && !t ? this.connectImpl(!0) : (yield this.privSynthesisTurn.onConnectionEstablishCompleted(o.statusCode, o.reason), Promise.reject(`Unable to contact server. StatusCode: ${o.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty(Lt.SpeechServiceConnection_Endpoint)} Reason: ${o.reason}`));
    }), (n) => Dc(this, void 0, void 0, function* () {
      throw yield this.privSynthesisTurn.onAuthCompleted(!0, n), new Error(n);
    })), this.privConnectionPromise.catch(() => {
    }), this.privConnectionPromise;
  }
  fetchConnection() {
    return Dc(this, void 0, void 0, function* () {
      return this.privConnectionConfigurationPromise ? this.privConnectionConfigurationPromise.then((t) => t.state() === uo.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, (t) => (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
    });
  }
  // Takes an established websocket connection to the endpoint and sends speech configuration information.
  configureConnection() {
    return Dc(this, void 0, void 0, function* () {
      const t = yield this.connectImpl();
      return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(t) : (yield this.sendSpeechServiceConfig(t, this.privSynthesizerConfig.SpeechServiceConfig.serialize()), t);
    });
  }
};
AH.telemetryDataEnabled = !0;
class SH extends v0 {
  constructor(t, r, n = qn.Info) {
    super(t, n), this.privRequestId = r;
  }
  get requestId() {
    return this.privRequestId;
  }
}
class zhr extends SH {
  constructor(t, r, n) {
    super("SynthesisTriggeredEvent", t), this.privSessionAudioDestinationId = r, this.privTurnAudioDestinationId = n;
  }
  get audioSessionDestinationId() {
    return this.privSessionAudioDestinationId;
  }
  get audioTurnDestinationId() {
    return this.privTurnAudioDestinationId;
  }
}
class qhr extends SH {
  constructor(t, r) {
    super("ConnectingToSynthesisServiceEvent", t), this.privAuthFetchEventId = r;
  }
  get authFetchEventId() {
    return this.privAuthFetchEventId;
  }
}
class Yhr extends SH {
  constructor(t, r) {
    super("SynthesisStartedEvent", t), this.privAuthFetchEventId = r;
  }
  get authFetchEventId() {
    return this.privAuthFetchEventId;
  }
}
var Px = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let Ghr = class {
  constructor() {
    this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.onPreConnectionStart = (t, r) => {
      this.privAuthFetchEventId = t, this.onEvent(new qhr(this.privRequestId, this.privAuthFetchEventId));
    }, this.onAuthCompleted = (t, r) => {
      t && this.onComplete();
    }, this.onConnectionEstablishCompleted = (t, r) => {
      if (t === 200) {
        this.onEvent(new Yhr(this.requestId, this.privAuthFetchEventId)), this.privBytesReceived = 0;
        return;
      } else t === 403 && this.onComplete();
    }, this.onServiceResponseMessage = (t) => {
      const r = JSON.parse(t);
      this.streamId = r.audio.streamId;
    }, this.onServiceTurnEndResponse = () => {
      this.privInTurn = !1, this.privTurnDeferral.resolve(), this.onComplete();
    }, this.onServiceTurnStartResponse = () => {
      this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
      })), this.privInTurn = !0, this.privTurnDeferral = new Wi();
    }, this.dispose = (t) => {
      this.privIsDisposed || (this.privIsDisposed = !0);
    }, this.onEvent = (t) => {
      fo.instance.onEvent(t);
    }, this.onComplete = () => {
      this.privIsSynthesizing && (this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !0, this.privAudioOutputStream.close(), this.privInTurn = !1, this.privTurnAudioDestination !== void 0 && (this.privTurnAudioDestination.close(), this.privTurnAudioDestination = void 0));
    }, this.privRequestId = Ei(), this.privTurnDeferral = new Wi(), this.privTurnDeferral.resolve();
  }
  get requestId() {
    return this.privRequestId;
  }
  get streamId() {
    return this.privStreamId;
  }
  set streamId(t) {
    this.privStreamId = t;
  }
  get audioOutputFormat() {
    return this.privAudioOutputFormat;
  }
  set audioOutputFormat(t) {
    this.privAudioOutputFormat = t;
  }
  get turnCompletionPromise() {
    return this.privTurnDeferral.promise;
  }
  get isSynthesisEnded() {
    return this.privIsSynthesisEnded;
  }
  get isSynthesizing() {
    return this.privIsSynthesizing;
  }
  get currentTextOffset() {
    return this.privTextOffset;
  }
  // The number of bytes received for current turn
  get bytesReceived() {
    return this.privBytesReceived;
  }
  getAllReceivedAudio() {
    return Px(this, void 0, void 0, function* () {
      return this.privReceivedAudio ? Promise.resolve(this.privReceivedAudio) : this.privIsSynthesisEnded ? (yield this.readAllAudioFromStream(), Promise.resolve(this.privReceivedAudio)) : null;
    });
  }
  getAllReceivedAudioWithHeader() {
    return Px(this, void 0, void 0, function* () {
      if (this.privReceivedAudioWithHeader)
        return this.privReceivedAudioWithHeader;
      if (!this.privIsSynthesisEnded)
        return null;
      if (this.audioOutputFormat.hasHeader) {
        const t = yield this.getAllReceivedAudio();
        return this.privReceivedAudioWithHeader = AH.addHeader(t, this.audioOutputFormat), this.privReceivedAudioWithHeader;
      } else
        return this.getAllReceivedAudio();
    });
  }
  startNewSynthesis(t, r, n, i) {
    this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = t, this.privRawText = r, this.privIsSSML = n, this.privAudioOutputStream = new TH(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privPartialVisemeAnimation = "", i !== void 0 && (this.privTurnAudioDestination = i, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new zhr(this.requestId, void 0, i === void 0 ? void 0 : i.id()));
  }
  onAudioChunkReceived(t) {
    this.isSynthesizing && (this.privAudioOutputStream.write(t), this.privBytesReceived += t.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(t));
  }
  onWordBoundaryEvent(t) {
    this.updateTextOffset(t);
  }
  onVisemeMetadataReceived(t) {
    t.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += t.Data.AnimationChunk);
  }
  onStopSynthesizing() {
    this.onComplete();
  }
  /**
   * Gets the viseme animation string (merged from animation chunk), and clears the internal
   * partial animation.
   */
  getAndClearVisemeAnimation() {
    const t = this.privPartialVisemeAnimation;
    return this.privPartialVisemeAnimation = "", t;
  }
  updateTextOffset(t) {
    this.privTextOffset >= 0 && (this.privTextOffset = this.privRawText.indexOf(t, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + t.length), this.privIsSSML && this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1) && this.updateTextOffset(t));
  }
  readAllAudioFromStream() {
    return Px(this, void 0, void 0, function* () {
      if (this.privIsSynthesisEnded) {
        this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
        try {
          yield this.privAudioOutputStream.read(this.privReceivedAudio);
        } catch {
          this.privReceivedAudio = new ArrayBuffer(0);
        }
      }
    });
  }
}, Whr = class {
  constructor(t) {
    this.privContext = {}, this.privSpeechSynthesizer = t;
  }
  /**
   * Adds a section to the synthesis.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */
  setSection(t, r) {
    this.privContext[t] = r;
  }
  /**
   * Sets the audio output format for synthesis context generation.
   * @param format {AudioOutputFormatImpl} the output format
   */
  set audioOutputFormat(t) {
    this.privAudioOutputFormat = t;
  }
  toJSON() {
    const t = this.buildSynthesisContext();
    return this.setSection("synthesis", t), JSON.stringify(this.privContext);
  }
  buildSynthesisContext() {
    return {
      audio: {
        metadataOptions: {
          bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
          sentenceBoundaryEnabled: !1,
          visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
          wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary
        },
        outputFormat: this.privAudioOutputFormat.requestAudioFormatString
      },
      language: {
        autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
      }
    };
  }
};
const r8 = "OutputFormat", aAe = "CancellationErrorCode", n8 = "ServiceProperties", Khr = "ForceDictation";
var MA = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
const Xhr = "MICROPHONE-WorkletSourceUrl";
let q4 = class of {
  constructor(t, r, n, i) {
    this.privRecorder = t, this.deviceId = r, this.privStreams = {}, this.turnOn = () => {
      if (this.privInitializeDeferral)
        return this.privInitializeDeferral.promise;
      this.privInitializeDeferral = new Wi();
      try {
        this.createAudioContext();
      } catch (u) {
        if (u instanceof Error) {
          const s = u;
          this.privInitializeDeferral.reject(s.name + ": " + s.message);
        } else
          this.privInitializeDeferral.reject(u);
        return this.privInitializeDeferral.promise;
      }
      const o = window.navigator;
      let a = o.getUserMedia || o.webkitGetUserMedia || o.mozGetUserMedia || o.msGetUserMedia;
      if (o.mediaDevices && (a = (u, s, c) => {
        o.mediaDevices.getUserMedia(u).then(s).catch(c);
      }), a) {
        const u = () => {
          this.onEvent(new z3(this.privId)), this.privMediaStream && this.privMediaStream.active ? (this.onEvent(new uT(this.privId)), this.privInitializeDeferral.resolve()) : a({ audio: this.deviceId ? { deviceId: this.deviceId } : !0, video: !1 }, (s) => {
            this.privMediaStream = s, this.onEvent(new uT(this.privId)), this.privInitializeDeferral.resolve();
          }, (s) => {
            const c = `Error occurred during microphone initialization: ${s}`;
            this.privInitializeDeferral.reject(c), this.onEvent(new QS(this.privId, c));
          });
        };
        this.privContext.state === "suspended" ? this.privContext.resume().then(u).catch((s) => {
          this.privInitializeDeferral.reject(`Failed to initialize audio context: ${s}`);
        }) : u();
      } else {
        const u = "Browser does not support getUserMedia.";
        this.privInitializeDeferral.reject(u), this.onEvent(new QS(u, ""));
      }
      return this.privInitializeDeferral.promise;
    }, this.id = () => this.privId, this.attach = (o) => (this.onEvent(new Hy(this.privId, o)), this.listen(o).then((a) => (this.onEvent(new $y(this.privId, o)), {
      detach: () => MA(this, void 0, void 0, function* () {
        return a.readEnded(), delete this.privStreams[o], this.onEvent(new Qc(this.privId, o)), this.turnOff();
      }),
      id: () => o,
      read: () => a.read()
    }))), this.detach = (o) => {
      o && this.privStreams[o] && (this.privStreams[o].close(), delete this.privStreams[o], this.onEvent(new Qc(this.privId, o)));
    }, this.listen = (o) => MA(this, void 0, void 0, function* () {
      yield this.turnOn();
      const a = new vH(this.privOutputChunkSize, o);
      this.privStreams[o] = a;
      try {
        this.privRecorder.record(this.privContext, this.privMediaStream, a);
      } catch (s) {
        throw this.onEvent(new dH(this.privId, o, s)), s;
      }
      return a;
    }), this.onEvent = (o) => {
      this.privEvents.onEvent(o), fo.instance.onEvent(o);
    }, this.createAudioContext = () => {
      this.privContext || (this.privContext = kf.getAudioContext(of.AUDIOFORMAT.samplesPerSec));
    }, this.privOutputChunkSize = of.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = n || Ei(), this.privEvents = new ms(), this.privMediaStream = i || null;
  }
  get format() {
    return Promise.resolve(of.AUDIOFORMAT);
  }
  get blob() {
    return Promise.reject("Not implemented for Mic input");
  }
  turnOff() {
    return MA(this, void 0, void 0, function* () {
      for (const t in this.privStreams)
        if (t) {
          const r = this.privStreams[t];
          r && r.close();
        }
      this.onEvent(new k_e(this.privId)), this.privInitializeDeferral && (yield this.privInitializeDeferral, this.privInitializeDeferral = null), yield this.destroyAudioContext();
    });
  }
  get events() {
    return this.privEvents;
  }
  get deviceInfo() {
    return this.getMicrophoneLabel().then((t) => ({
      bitspersample: of.AUDIOFORMAT.bitsPerSample,
      channelcount: of.AUDIOFORMAT.channels,
      connectivity: nh.Unknown,
      manufacturer: "Speech SDK",
      model: t,
      samplerate: of.AUDIOFORMAT.samplesPerSec,
      type: Mf.Microphones
    }));
  }
  setProperty(t, r) {
    if (t === Xhr)
      this.privRecorder.setWorkletUrl(r);
    else
      throw new Error("Property '" + t + "' is not supported on Microphone.");
  }
  getMicrophoneLabel() {
    const t = "microphone";
    if (this.privMicrophoneLabel !== void 0)
      return Promise.resolve(this.privMicrophoneLabel);
    if (this.privMediaStream === void 0 || !this.privMediaStream.active)
      return Promise.resolve(t);
    this.privMicrophoneLabel = t;
    const r = this.privMediaStream.getTracks()[0].getSettings().deviceId;
    if (r === void 0)
      return Promise.resolve(this.privMicrophoneLabel);
    const n = new Wi();
    return navigator.mediaDevices.enumerateDevices().then((i) => {
      for (const o of i)
        if (o.deviceId === r) {
          this.privMicrophoneLabel = o.label;
          break;
        }
      n.resolve(this.privMicrophoneLabel);
    }, () => n.resolve(this.privMicrophoneLabel)), n.promise;
  }
  destroyAudioContext() {
    return MA(this, void 0, void 0, function* () {
      if (!this.privContext)
        return;
      this.privRecorder.releaseMediaResources(this.privContext);
      let t = !1;
      "close" in this.privContext && (t = !0), t ? (yield this.privContext.close(), this.privContext = null) : this.privContext !== null && this.privContext.state === "running" && (yield this.privContext.suspend());
    });
  }
};
q4.AUDIOFORMAT = Y3.getDefaultInputFormat();
var Dx = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let Jhr = class {
  constructor(t, r, n) {
    this.privStreams = {}, this.privHeaderEnd = 44, this.turnOn = () => {
      if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
        const i = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
        return this.onEvent(new QS(i, "")), Promise.reject(i);
      }
      this.onEvent(new z3(this.privId)), this.onEvent(new uT(this.privId));
    }, this.id = () => this.privId, this.attach = (i) => Dx(this, void 0, void 0, function* () {
      this.onEvent(new Hy(this.privId, i));
      const o = yield this.upload(i);
      return this.onEvent(new $y(this.privId, i)), Promise.resolve({
        detach: () => Dx(this, void 0, void 0, function* () {
          o.readEnded(), delete this.privStreams[i], this.onEvent(new Qc(this.privId, i)), yield this.turnOff();
        }),
        id: () => i,
        read: () => o.read()
      });
    }), this.detach = (i) => {
      i && this.privStreams[i] && (this.privStreams[i].close(), delete this.privStreams[i], this.onEvent(new Qc(this.privId, i)));
    }, this.turnOff = () => {
      for (const i in this.privStreams)
        if (i) {
          const o = this.privStreams[i];
          o && !o.isClosed && o.close();
        }
      return this.onEvent(new k_e(this.privId)), Promise.resolve();
    }, this.onEvent = (i) => {
      this.privEvents.onEvent(i), fo.instance.onEvent(i);
    }, this.privId = n || Ei(), this.privEvents = new ms(), this.privSource = t, typeof window < "u" && typeof Blob < "u" && this.privSource instanceof Blob ? this.privFilename = t.name : this.privFilename = r || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
  }
  get format() {
    return this.privAudioFormatPromise;
  }
  get blob() {
    return Promise.resolve(this.privSource);
  }
  get events() {
    return this.privEvents;
  }
  get deviceInfo() {
    return this.privAudioFormatPromise.then((t) => Promise.resolve({
      bitspersample: t.bitsPerSample,
      channelcount: t.channels,
      connectivity: nh.Unknown,
      manufacturer: "Speech SDK",
      model: "File",
      samplerate: t.samplesPerSec,
      type: Mf.File
    }));
  }
  readHeader() {
    const r = this.privSource.slice(0, 512), n = new Wi(), i = (o) => {
      const a = new DataView(o), u = (p) => String.fromCharCode(a.getUint8(p), a.getUint8(p + 1), a.getUint8(p + 2), a.getUint8(p + 3));
      if (u(0) !== "RIFF") {
        n.reject("Invalid WAV header in file, RIFF was not found");
        return;
      }
      if (u(8) !== "WAVE" || u(12) !== "fmt ") {
        n.reject("Invalid WAV header in file, WAVEfmt was not found");
        return;
      }
      const s = a.getInt32(16, !0), c = a.getUint16(22, !0), l = a.getUint32(24, !0), f = a.getUint16(34, !0);
      let d = 36 + Math.max(s - 16, 0);
      for (; u(d) !== "data"; d += 2)
        if (d > 504) {
          n.reject("Invalid WAV header in file, data block was not found");
          return;
        }
      this.privHeaderEnd = d + 8, n.resolve(Y3.getWaveFormatPCM(l, f, c));
    };
    if (typeof window < "u" && typeof Blob < "u" && r instanceof Blob) {
      const o = new FileReader();
      o.onload = (a) => {
        const u = a.target.result;
        i(u);
      }, o.readAsArrayBuffer(r);
    } else {
      const o = r;
      i(o.buffer.slice(o.byteOffset, o.byteOffset + o.byteLength));
    }
    return n.promise;
  }
  upload(t) {
    return Dx(this, void 0, void 0, function* () {
      const r = (n) => {
        const i = `Error occurred while processing '${this.privFilename}'. ${n}`;
        throw this.onEvent(new dH(this.privId, t, i)), new Error(i);
      };
      try {
        yield this.turnOn();
        const n = yield this.privAudioFormatPromise, i = new vH(n.avgBytesPerSec / 10, t);
        this.privStreams[t] = i;
        const o = this.privSource.slice(this.privHeaderEnd), a = (u) => {
          i.isClosed || (i.writeStreamChunk({
            buffer: u,
            isEnd: !1,
            timeReceived: Date.now()
          }), i.close());
        };
        if (typeof window < "u" && typeof Blob < "u" && o instanceof Blob) {
          const u = new FileReader();
          u.onerror = (s) => {
            r(s.toString());
          }, u.onload = (s) => {
            const c = s.target.result;
            a(c);
          }, u.readAsArrayBuffer(o);
        } else {
          const u = o;
          a(u.buffer.slice(u.byteOffset, u.byteOffset + u.byteLength));
        }
        return i;
      } catch (n) {
        r(n);
      }
    });
  }
};
class xx {
  constructor() {
    this.record = (t, r, n) => {
      const o = (() => {
        let s = 0;
        try {
          return t.createScriptProcessor(s, 1, 1);
        } catch {
          s = 2048;
          let l = t.sampleRate;
          for (; s < 16384 && l >= 32e3; )
            s <<= 1, l >>= 1;
          return t.createScriptProcessor(s, 1, 1);
        }
      })(), a = new jpr(t.sampleRate, 16e3);
      o.onaudioprocess = (s) => {
        const c = s.inputBuffer.getChannelData(0);
        if (n && !n.isClosed) {
          const l = a.encode(c);
          l && n.writeStreamChunk({
            buffer: l,
            isEnd: !1,
            timeReceived: Date.now()
          });
        }
      };
      const u = t.createMediaStreamSource(r);
      this.privSpeechProcessorScript && t.audioWorklet ? t.audioWorklet.addModule(this.privSpeechProcessorScript).then(() => {
        const s = new AudioWorkletNode(t, "speech-processor");
        s.port.onmessage = (c) => {
          const l = c.data;
          if (n && !n.isClosed) {
            const f = a.encode(l);
            f && n.writeStreamChunk({
              buffer: f,
              isEnd: !1,
              timeReceived: Date.now()
            });
          }
        }, u.connect(s), s.connect(t.destination), this.privMediaResources = {
          scriptProcessorNode: s,
          source: u,
          stream: r
        };
      }).catch(() => {
        u.connect(o), o.connect(t.destination), this.privMediaResources = {
          scriptProcessorNode: o,
          source: u,
          stream: r
        };
      }) : (u.connect(o), o.connect(t.destination), this.privMediaResources = {
        scriptProcessorNode: o,
        source: u,
        stream: r
      });
    }, this.releaseMediaResources = (t) => {
      this.privMediaResources && (this.privMediaResources.scriptProcessorNode && (this.privMediaResources.scriptProcessorNode.disconnect(t.destination), this.privMediaResources.scriptProcessorNode = null), this.privMediaResources.source && (this.privMediaResources.source.disconnect(), this.privMediaResources.stream.getTracks().forEach((r) => r.stop()), this.privMediaResources.source = null));
    };
  }
  setWorkletUrl(t) {
    this.privSpeechProcessorScript = t;
  }
}
var Zhr = function(t, r) {
  if (r = r.split(":")[0], t = +t, !t) return !1;
  switch (r) {
    case "http":
    case "ws":
      return t !== 80;
    case "https":
    case "wss":
      return t !== 443;
    case "ftp":
      return t !== 21;
    case "gopher":
      return t !== 70;
    case "file":
      return !1;
  }
  return t !== 0;
}, bH = {}, Qhr = Object.prototype.hasOwnProperty, evr;
function jte(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return null;
  }
}
function zte(e) {
  try {
    return encodeURIComponent(e);
  } catch {
    return null;
  }
}
function tvr(e) {
  for (var t = /([^=?#&]+)=?([^&]*)/g, r = {}, n; n = t.exec(e); ) {
    var i = jte(n[1]), o = jte(n[2]);
    i === null || o === null || i in r || (r[i] = o);
  }
  return r;
}
function rvr(e, t) {
  t = t || "";
  var r = [], n, i;
  typeof t != "string" && (t = "?");
  for (i in e)
    if (Qhr.call(e, i)) {
      if (n = e[i], !n && (n === null || n === evr || isNaN(n)) && (n = ""), i = zte(i), n = zte(n), i === null || n === null) continue;
      r.push(i + "=" + n);
    }
  return r.length ? t + r.join("&") : "";
}
bH.stringify = rvr;
bH.parse = tvr;
var uAe = Zhr, W3 = bH, nvr = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, sAe = /[\n\r\t]/g, ivr = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, cAe = /:\d+$/, ovr = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, avr = /^[a-zA-Z]:/;
function CH(e) {
  return (e || "").toString().replace(nvr, "");
}
var i8 = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  function(t, r) {
    return Qs(r.protocol) ? t.replace(/\\/g, "/") : t;
  },
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
], qte = { hash: 1, query: 1 };
function lAe(e) {
  var t;
  typeof window < "u" ? t = window : typeof fe < "u" ? t = fe : typeof self < "u" ? t = self : t = {};
  var r = t.location || {};
  e = e || r;
  var n = {}, i = typeof e, o;
  if (e.protocol === "blob:")
    n = new rc(unescape(e.pathname), {});
  else if (i === "string") {
    n = new rc(e, {});
    for (o in qte) delete n[o];
  } else if (i === "object") {
    for (o in e)
      o in qte || (n[o] = e[o]);
    n.slashes === void 0 && (n.slashes = ivr.test(e.href));
  }
  return n;
}
function Qs(e) {
  return e === "file:" || e === "ftp:" || e === "http:" || e === "https:" || e === "ws:" || e === "wss:";
}
function fAe(e, t) {
  e = CH(e), e = e.replace(sAe, ""), t = t || {};
  var r = ovr.exec(e), n = r[1] ? r[1].toLowerCase() : "", i = !!r[2], o = !!r[3], a = 0, u;
  return i ? o ? (u = r[2] + r[3] + r[4], a = r[2].length + r[3].length) : (u = r[2] + r[4], a = r[2].length) : o ? (u = r[3] + r[4], a = r[3].length) : u = r[4], n === "file:" ? a >= 2 && (u = u.slice(2)) : Qs(n) ? u = r[4] : n ? i && (u = u.slice(2)) : a >= 2 && Qs(t.protocol) && (u = r[4]), {
    protocol: n,
    slashes: i || Qs(n),
    slashesCount: a,
    rest: u
  };
}
function uvr(e, t) {
  if (e === "") return t;
  for (var r = (t || "/").split("/").slice(0, -1).concat(e.split("/")), n = r.length, i = r[n - 1], o = !1, a = 0; n--; )
    r[n] === "." ? r.splice(n, 1) : r[n] === ".." ? (r.splice(n, 1), a++) : a && (n === 0 && (o = !0), r.splice(n, 1), a--);
  return o && r.unshift(""), (i === "." || i === "..") && r.push(""), r.join("/");
}
function rc(e, t, r) {
  if (e = CH(e), e = e.replace(sAe, ""), !(this instanceof rc))
    return new rc(e, t, r);
  var n, i, o, a, u, s, c = i8.slice(), l = typeof t, f = this, d = 0;
  for (l !== "object" && l !== "string" && (r = t, t = null), r && typeof r != "function" && (r = W3.parse), t = lAe(t), i = fAe(e || "", t), n = !i.protocol && !i.slashes, f.slashes = i.slashes || n && t.slashes, f.protocol = i.protocol || t.protocol || "", e = i.rest, (i.protocol === "file:" && (i.slashesCount !== 2 || avr.test(e)) || !i.slashes && (i.protocol || i.slashesCount < 2 || !Qs(f.protocol))) && (c[3] = [/(.*)/, "pathname"]); d < c.length; d++) {
    if (a = c[d], typeof a == "function") {
      e = a(e, f);
      continue;
    }
    o = a[0], s = a[1], o !== o ? f[s] = e : typeof o == "string" ? (u = o === "@" ? e.lastIndexOf(o) : e.indexOf(o), ~u && (typeof a[2] == "number" ? (f[s] = e.slice(0, u), e = e.slice(u + a[2])) : (f[s] = e.slice(u), e = e.slice(0, u)))) : (u = o.exec(e)) && (f[s] = u[1], e = e.slice(0, u.index)), f[s] = f[s] || n && a[3] && t[s] || "", a[4] && (f[s] = f[s].toLowerCase());
  }
  r && (f.query = r(f.query)), n && t.slashes && f.pathname.charAt(0) !== "/" && (f.pathname !== "" || t.pathname !== "") && (f.pathname = uvr(f.pathname, t.pathname)), f.pathname.charAt(0) !== "/" && Qs(f.protocol) && (f.pathname = "/" + f.pathname), uAe(f.port, f.protocol) || (f.host = f.hostname, f.port = ""), f.username = f.password = "", f.auth && (u = f.auth.indexOf(":"), ~u ? (f.username = f.auth.slice(0, u), f.username = encodeURIComponent(decodeURIComponent(f.username)), f.password = f.auth.slice(u + 1), f.password = encodeURIComponent(decodeURIComponent(f.password))) : f.username = encodeURIComponent(decodeURIComponent(f.auth)), f.auth = f.password ? f.username + ":" + f.password : f.username), f.origin = f.protocol !== "file:" && Qs(f.protocol) && f.host ? f.protocol + "//" + f.host : "null", f.href = f.toString();
}
function svr(e, t, r) {
  var n = this;
  switch (e) {
    case "query":
      typeof t == "string" && t.length && (t = (r || W3.parse)(t)), n[e] = t;
      break;
    case "port":
      n[e] = t, uAe(t, n.protocol) ? t && (n.host = n.hostname + ":" + t) : (n.host = n.hostname, n[e] = "");
      break;
    case "hostname":
      n[e] = t, n.port && (t += ":" + n.port), n.host = t;
      break;
    case "host":
      n[e] = t, cAe.test(t) ? (t = t.split(":"), n.port = t.pop(), n.hostname = t.join(":")) : (n.hostname = t, n.port = "");
      break;
    case "protocol":
      n.protocol = t.toLowerCase(), n.slashes = !r;
      break;
    case "pathname":
    case "hash":
      if (t) {
        var i = e === "pathname" ? "/" : "#";
        n[e] = t.charAt(0) !== i ? i + t : t;
      } else
        n[e] = t;
      break;
    case "username":
    case "password":
      n[e] = encodeURIComponent(t);
      break;
    case "auth":
      var o = t.indexOf(":");
      ~o ? (n.username = t.slice(0, o), n.username = encodeURIComponent(decodeURIComponent(n.username)), n.password = t.slice(o + 1), n.password = encodeURIComponent(decodeURIComponent(n.password))) : n.username = encodeURIComponent(decodeURIComponent(t));
  }
  for (var a = 0; a < i8.length; a++) {
    var u = i8[a];
    u[4] && (n[u[1]] = n[u[1]].toLowerCase());
  }
  return n.auth = n.password ? n.username + ":" + n.password : n.username, n.origin = n.protocol !== "file:" && Qs(n.protocol) && n.host ? n.protocol + "//" + n.host : "null", n.href = n.toString(), n;
}
function cvr(e) {
  (!e || typeof e != "function") && (e = W3.stringify);
  var t, r = this, n = r.host, i = r.protocol;
  i && i.charAt(i.length - 1) !== ":" && (i += ":");
  var o = i + (r.protocol && r.slashes || Qs(r.protocol) ? "//" : "");
  return r.username ? (o += r.username, r.password && (o += ":" + r.password), o += "@") : r.password ? (o += ":" + r.password, o += "@") : r.protocol !== "file:" && Qs(r.protocol) && !n && r.pathname !== "/" && (o += "@"), (n[n.length - 1] === ":" || cAe.test(r.hostname) && !r.port) && (n += ":"), o += n + r.pathname, t = typeof r.query == "object" ? e(r.query) : r.query, t && (o += t.charAt(0) !== "?" ? "?" + t : t), r.hash && (o += r.hash), o;
}
rc.prototype = { set: svr, toString: cvr };
rc.extractProtocol = fAe;
rc.location = lAe;
rc.trimLeft = CH;
rc.qs = W3;
var dAe = rc;
const lvr = /* @__PURE__ */ Mt(dAe);
var Gv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
class bi {
  constructor(t) {
    t && (this.privProxyInfo = t), bi.privDiskCache || (bi.privDiskCache = new I1("microsoft-cognitiveservices-speech-sdk-cache", { supportBuffer: !0, location: typeof process < "u" && process.env.SPEECH_OCSP_CACHE_ROOT ? process.env.SPEECH_OCSP_CACHE_ROOT : void 0 }));
  }
  // Test hook to force the disk cache to be recreated.
  static forceReinitDiskCache() {
    bi.privDiskCache = void 0, bi.privMemCache = {};
  }
  GetAgent(t) {
    const r = new I1.Agent(this.CreateConnection);
    if (this.privProxyInfo !== void 0 && this.privProxyInfo.HostName !== void 0 && this.privProxyInfo.Port > 0) {
      const n = "privProxyInfo";
      r[n] = this.privProxyInfo;
    }
    return r;
  }
  static GetProxyAgent(t) {
    const r = {
      host: t.HostName,
      port: t.Port
    };
    return t.UserName ? r.headers = {
      "Proxy-Authentication": "Basic " + new Buffer(t.UserName + ":" + (t.Password === void 0) ? "" : t.Password).toString("base64")
    } : r.headers = {}, r.headers.requestOCSP = "true", new I1(r);
  }
  static OCSPCheck(t, r) {
    return Gv(this, void 0, void 0, function* () {
      let n, i, o = !1;
      const a = yield t;
      a.cork();
      const u = a;
      return new Promise((s, c) => {
        a.on("OCSPResponse", (l) => {
          l && (this.onEvent(new Zpr()), i = l);
        }), a.on("error", (l) => {
          o || (o = !0, a.destroy(), c(l));
        }), u.on("secure", () => Gv(this, void 0, void 0, function* () {
          const l = u.getPeerCertificate(!0);
          try {
            const f = yield this.GetIssuer(l);
            n = (void 0).generate(l.raw, f.raw);
            const d = n.id.toString("hex");
            i || (i = yield bi.GetResponseFromCache(d, n, r)), yield this.VerifyOCSPResponse(i, n, r), a.uncork(), o = !0, s(a);
          } catch (f) {
            a.destroy(), o = !0, c(f);
          }
        }));
      });
    });
  }
  static GetIssuer(t) {
    return t.issuerCertificate ? Promise.resolve(t.issuerCertificate) : new Promise((r, n) => {
      new (void 0)({}).fetchIssuer(t, null, (o, a) => {
        if (o) {
          n(o);
          return;
        }
        r(a);
      });
    });
  }
  static GetResponseFromCache(t, r, n) {
    return Gv(this, void 0, void 0, function* () {
      let i = bi.privMemCache[t];
      if (i && this.onEvent(new qpr(t)), !i)
        try {
          const o = yield bi.privDiskCache.get(t);
          o.isCached && (bi.onEvent(new Gpr(t)), bi.StoreMemoryCacheEntry(t, o.value), i = o.value);
        } catch {
          i = null;
        }
      if (!i)
        return i;
      try {
        const a = (void 0).parseResponse(i).value.tbsResponseData;
        a.responses.length < 1;
        const u = a.responses[0].thisUpdate, s = a.responses[0].nextUpdate;
        if (s < Date.now() + this.testTimeOffset - 6e4)
          this.onEvent(new Qpr(t, s)), i = null;
        else {
          const c = Math.min(864e5, (s - u) / 2);
          s - (Date.now() + this.testTimeOffset) < c ? (this.onEvent(new ehr(t, u, s)), this.UpdateCache(r, n).catch((l) => {
            this.onEvent(new ohr(t, l.toString()));
          })) : this.onEvent(new thr(t, u, s));
        }
      } catch (o) {
        this.onEvent(new nhr(t, o)), i = null;
      }
      return i || this.onEvent(new Ypr(t)), i;
    });
  }
  static VerifyOCSPResponse(t, r, n) {
    return Gv(this, void 0, void 0, function* () {
      let i = t;
      return r.certID.toString("hex"), i || (i = yield bi.GetOCSPResponse(r, n)), new Promise((o, a) => {
        (void 0)({ request: r, response: i }, (u, s) => {
          u ? (bi.onEvent(new rhr(r.id.toString("hex"), u)), t ? this.VerifyOCSPResponse(null, r, n).then(() => {
            o();
          }, (c) => {
            a(c);
          }) : a(u)) : (t || bi.StoreCacheEntry(r.id.toString("hex"), i), o());
        });
      });
    });
  }
  static UpdateCache(t, r) {
    return Gv(this, void 0, void 0, function* () {
      const n = t.id.toString("hex");
      this.onEvent(new Wpr(n));
      const i = yield this.GetOCSPResponse(t, r);
      this.StoreCacheEntry(n, i), this.onEvent(new Jpr(t.id.toString("hex")));
    });
  }
  static StoreCacheEntry(t, r) {
    this.StoreMemoryCacheEntry(t, r), this.StoreDiskCacheEntry(t, r);
  }
  static StoreMemoryCacheEntry(t, r) {
    this.privMemCache[t] = r, this.onEvent(new Kpr(t));
  }
  static StoreDiskCacheEntry(t, r) {
    this.privDiskCache.set(t, r).then(() => {
      this.onEvent(new Xpr(t));
    });
  }
  static GetOCSPResponse(t, r) {
    const n = "1.3.6.1.5.5.7.48.1";
    let i = {};
    if (r) {
      const o = bi.GetProxyAgent(r);
      i.agent = o;
    }
    return new Promise((o, a) => {
      (void 0).getAuthorityInfo(t.cert, n, (u, s) => {
        if (u) {
          a(u);
          return;
        }
        const c = lvr(s);
        c.path = c.pathname, i = Object.assign(Object.assign({}, i), c), (void 0).getResponse(i, t.data, (l, f) => {
          if (l) {
            a(l);
            return;
          }
          this.onEvent(new ihr(t.certID.toString("hex"))), o(f);
        });
      });
    });
  }
  CreateConnection(t, r) {
    const n = typeof process < "u" && process.env.NODE_TLS_REJECT_UNAUTHORIZED !== "0" && process.env.SPEECH_CONDUCT_OCSP_CHECK !== "0" && r.secureEndpoint;
    let i;
    if (r = Object.assign(Object.assign({}, r), {
      requestOCSP: !bi.forceDisableOCSPStapling,
      servername: r.host
    }), this.privProxyInfo) {
      const a = bi.GetProxyAgent(this.privProxyInfo);
      i = new Promise((u, s) => {
        a.callback(t, r, (c, l) => {
          c ? s(c) : u(l);
        });
      });
    } else
      r.secureEndpoint, i = Promise.resolve((void 0)(r));
    return n ? bi.OCSPCheck(i, this.privProxyInfo) : i;
  }
}
bi.testTimeOffset = 0;
bi.forceDisableOCSPStapling = !1;
bi.privMemCache = {};
bi.onEvent = (e) => {
  fo.instance.onEvent(e);
};
var Yte = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let pAe = class hAe {
  constructor(t, r, n, i, o, a) {
    if (this.open = () => {
      if (this.privConnectionState === uo.Disconnected)
        return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
      if (this.privConnectionEstablishDeferral)
        return this.privConnectionEstablishDeferral.promise;
      this.privConnectionEstablishDeferral = new Wi(), this.privCertificateValidatedDeferral = new Wi(), this.privConnectionState = uo.Connecting;
      try {
        if (typeof WebSocket < "u" && !hAe.forceNpmWebSocket)
          this.privCertificateValidatedDeferral.resolve(), this.privWebsocketClient = new WebSocket(this.privUri);
        else {
          const u = { headers: this.privHeaders, perMessageDeflate: this.privEnableCompression };
          this.privCertificateValidatedDeferral.resolve();
          const s = new bi(this.proxyInfo);
          u.agent = s.GetAgent(), this.privWebsocketClient = new I1(this.privUri, u);
        }
        this.privWebsocketClient.binaryType = "arraybuffer", this.privReceivingMessageQueue = new eb(), this.privDisconnectDeferral = new Wi(), this.privSendMessageQueue = new eb(), this.processSendQueue().catch((u) => {
          fo.instance.onEvent(new If(u));
        });
      } catch (u) {
        return this.privConnectionEstablishDeferral.resolve(new Ix(500, u)), this.privConnectionEstablishDeferral.promise;
      }
      return this.onEvent(new M_e(this.privConnectionId, this.privUri)), this.privWebsocketClient.onopen = (u) => {
        this.privCertificateValidatedDeferral.promise.then(() => {
          this.privConnectionState = uo.Connected, this.onEvent(new F_e(this.privConnectionId)), this.privConnectionEstablishDeferral.resolve(new Ix(200, ""));
        }, (s) => {
          this.privConnectionEstablishDeferral.reject(s);
        });
      }, this.privWebsocketClient.onerror = (u) => {
        this.onEvent(new Fpr(this.privConnectionId, u.message, u.type)), this.privLastErrorReceived = u.message;
      }, this.privWebsocketClient.onclose = (u) => {
        this.privConnectionState === uo.Connecting ? (this.privConnectionState = uo.Disconnected, this.privConnectionEstablishDeferral.resolve(new Ix(u.code, u.reason + " " + this.privLastErrorReceived))) : (this.privConnectionState = uo.Disconnected, this.privWebsocketClient = null, this.onEvent(new Mpr(this.privConnectionId, u.code, u.reason))), this.onClose(u.code, u.reason).catch((s) => {
          fo.instance.onEvent(new If(s));
        });
      }, this.privWebsocketClient.onmessage = (u) => {
        const s = (/* @__PURE__ */ new Date()).toISOString();
        if (this.privConnectionState === uo.Connected) {
          const c = new Wi();
          if (this.privReceivingMessageQueue.enqueueFromPromise(c.promise), u.data instanceof ArrayBuffer) {
            const l = new tb(Jr.Binary, u.data);
            this.privMessageFormatter.toConnectionMessage(l).then((f) => {
              this.onEvent(new XB(this.privConnectionId, s, f)), c.resolve(f);
            }, (f) => {
              c.reject(`Invalid binary message format. Error: ${f}`);
            });
          } else {
            const l = new tb(Jr.Text, u.data);
            this.privMessageFormatter.toConnectionMessage(l).then((f) => {
              this.onEvent(new XB(this.privConnectionId, s, f)), c.resolve(f);
            }, (f) => {
              c.reject(`Invalid text message format. Error: ${f}`);
            });
          }
        }
      }, this.privConnectionEstablishDeferral.promise;
    }, this.send = (u) => {
      if (this.privConnectionState !== uo.Connected)
        return Promise.reject(`Cannot send on connection that is in ${uo[this.privConnectionState]} state`);
      const s = new Wi(), c = new Wi();
      return this.privSendMessageQueue.enqueueFromPromise(c.promise), this.privMessageFormatter.fromConnectionMessage(u).then((l) => {
        c.resolve({
          Message: u,
          RawWebsocketMessage: l,
          sendStatusDeferral: s
        });
      }, (l) => {
        c.reject(`Error formatting the message. ${l}`);
      }), s.promise;
    }, this.read = () => this.privConnectionState !== uo.Connected ? Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`) : this.privReceivingMessageQueue.dequeue(), this.close = (u) => {
      if (this.privWebsocketClient)
        this.privConnectionState !== uo.Disconnected && this.privWebsocketClient.close(1e3, u || "Normal closure by client");
      else
        return Promise.resolve();
      return this.privDisconnectDeferral.promise;
    }, this.sendRawMessage = (u) => {
      try {
        if (!u)
          return Promise.resolve();
        if (this.onEvent(new $pr(this.privConnectionId, (/* @__PURE__ */ new Date()).toISOString(), u.Message)), this.isWebsocketOpen)
          this.privWebsocketClient.send(u.RawWebsocketMessage.payload);
        else
          return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + u.Message.id + " " + new Error().stack);
        return Promise.resolve();
      } catch (s) {
        return Promise.reject(`websocket send error: ${s}`);
      }
    }, this.onEvent = (u) => {
      this.privConnectionEvents.onEvent(u), fo.instance.onEvent(u);
    }, !t)
      throw new bo("uri");
    if (!n)
      throw new bo("messageFormatter");
    this.proxyInfo = i, this.privConnectionEvents = new ms(), this.privConnectionId = r, this.privMessageFormatter = n, this.privConnectionState = uo.None, this.privUri = t, this.privHeaders = o, this.privEnableCompression = a, this.privHeaders[Ii.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
  }
  get state() {
    return this.privConnectionState;
  }
  get events() {
    return this.privConnectionEvents;
  }
  onClose(t, r) {
    return Yte(this, void 0, void 0, function* () {
      const n = `Connection closed. ${t}: ${r}`;
      this.privConnectionState = uo.Disconnected, this.privDisconnectDeferral.resolve(), yield this.privReceivingMessageQueue.drainAndDispose((i) => {
      }, n), yield this.privSendMessageQueue.drainAndDispose((i) => {
        i.sendStatusDeferral.reject(n);
      }, n);
    });
  }
  processSendQueue() {
    return Yte(this, void 0, void 0, function* () {
      for (; ; ) {
        const r = yield this.privSendMessageQueue.dequeue();
        if (!r)
          return;
        try {
          yield this.sendRawMessage(r), r.sendStatusDeferral.resolve();
        } catch (n) {
          r.sendStatusDeferral.reject(n);
        }
      }
    });
  }
  get isWebsocketOpen() {
    return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
  }
};
pAe.forceNpmWebSocket = !1;
var fvr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
let dvr = class {
  constructor(t, r, n, i, o, a = !1, u) {
    if (this.privIsDisposed = !1, this.isDisposed = () => this.privIsDisposed, this.state = () => this.privConnectionMessageAdapter.state, this.open = () => this.privConnectionMessageAdapter.open(), this.send = (l) => this.privConnectionMessageAdapter.send(l), this.read = () => this.privConnectionMessageAdapter.read(), !t)
      throw new bo("uri");
    if (!i)
      throw new bo("messageFormatter");
    this.privMessageFormatter = i;
    let s = "", c = 0;
    if (r) {
      for (const l in r)
        if (l) {
          s += c === 0 && t.indexOf("?") === -1 ? "?" : "&";
          const f = encodeURIComponent(r[l]);
          s += `${l}=${f}`, c++;
        }
    }
    if (n) {
      for (const l in n)
        if (l) {
          s += c === 0 && t.indexOf("?") === -1 ? "?" : "&";
          const f = encodeURIComponent(n[l]);
          s += `${l}=${f}`, c++;
        }
    }
    this.privUri = t + s, this.privId = u || Ei(), this.privConnectionMessageAdapter = new pAe(this.privUri, this.id, this.privMessageFormatter, o, n, a);
  }
  dispose() {
    return fvr(this, void 0, void 0, function* () {
      this.privIsDisposed = !0, this.privConnectionMessageAdapter && (yield this.privConnectionMessageAdapter.close());
    });
  }
  get id() {
    return this.privId;
  }
  get events() {
    return this.privConnectionMessageAdapter.events;
  }
}, vAe = class {
  constructor(t, r) {
    this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.id = () => this.privAudioNode.id(), this.privAudioNode = t, this.privBytesPerSecond = r;
  }
  // Reads and returns the next chunk of audio buffer.
  // If replay of existing buffers are needed, read() will first seek and replay
  // existing content, and upoin completion it will read new content from the underlying
  // audio node, saving that content into the replayable buffers.
  read() {
    if (this.privReplay && this.privBuffers.length !== 0) {
      const t = this.privReplayOffset - this.privBufferStartOffset;
      let r = Math.round(t * this.privBytesPerSecond * 1e-7);
      r % 2 !== 0 && r++;
      let n = 0;
      for (; n < this.privBuffers.length && r >= this.privBuffers[n].chunk.buffer.byteLength; )
        r -= this.privBuffers[n++].chunk.buffer.byteLength;
      if (n < this.privBuffers.length) {
        const i = this.privBuffers[n].chunk.buffer.slice(r);
        return this.privReplayOffset += i.byteLength / this.privBytesPerSecond * 1e7, n === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({
          buffer: i,
          isEnd: !1,
          timeReceived: this.privBuffers[n].chunk.timeReceived
        });
      }
    }
    return this.privAudioNode.read().then((t) => (t && t.buffer && (this.privBuffers.push(new pvr(t, this.privBufferSerial++, this.privBufferedBytes)), this.privBufferedBytes += t.buffer.byteLength), t));
  }
  detach() {
    return this.privBuffers = void 0, this.privAudioNode.detach();
  }
  replay() {
    this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
  }
  // Shrinks the existing audio buffers to start at the new offset, or at the
  // beginning of the buffer closest to the requested offset.
  // A replay request will start from the last shrink point.
  shrinkBuffers(t) {
    if (this.privBuffers === void 0 || this.privBuffers.length === 0)
      return;
    this.privLastShrinkOffset = t;
    const r = t - this.privBufferStartOffset;
    let n = Math.round(r * this.privBytesPerSecond * 1e-7), i = 0;
    for (; i < this.privBuffers.length && n >= this.privBuffers[i].chunk.buffer.byteLength; )
      n -= this.privBuffers[i++].chunk.buffer.byteLength;
    this.privBufferStartOffset = Math.round(t - n / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(i);
  }
  // Finds the time a buffer of audio was first seen by offset.
  findTimeAtOffset(t) {
    if (t < this.privBufferStartOffset || this.privBuffers === void 0)
      return 0;
    for (const r of this.privBuffers) {
      const n = r.byteOffset / this.privBytesPerSecond * 1e7, i = n + r.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
      if (t >= n && t <= i)
        return r.chunk.timeReceived;
    }
    return 0;
  }
};
class pvr {
  constructor(t, r, n) {
    this.chunk = t, this.serial = r, this.byteOffset = n;
  }
}
let hvr = class EAe {
  constructor(t, r, n, i) {
    this.privProxyHostName = t, this.privProxyPort = r, this.privProxyUserName = n, this.privProxyPassword = i;
  }
  static fromParameters(t) {
    return new EAe(t.getProperty(Lt.SpeechServiceConnection_ProxyHostName), parseInt(t.getProperty(Lt.SpeechServiceConnection_ProxyPort), 10), t.getProperty(Lt.SpeechServiceConnection_ProxyUserName), t.getProperty(Lt.SpeechServiceConnection_ProxyPassword));
  }
  static fromRecognizerConfig(t) {
    return this.fromParameters(t.parameters);
  }
  get HostName() {
    return this.privProxyHostName;
  }
  get Port() {
    return this.privProxyPort;
  }
  get UserName() {
    return this.privProxyUserName;
  }
  get Password() {
    return this.privProxyPassword;
  }
};
var mAe = bn, vvr = _a, Evr = $i, mvr = Co, Gte = Jf, gvr = wT, gAe = Function, Tvr = mAe([].concat), yvr = mAe([].join), Nx = {}, _vr = function(e, t, r) {
  if (!mvr(Nx, t)) {
    for (var n = [], i = 0; i < t; i++) n[i] = "a[" + i + "]";
    Nx[t] = gAe("C,a", "return new C(" + yvr(n, ",") + ")");
  }
  return Nx[t](e, r);
}, TAe = gvr ? gAe.bind : function(t) {
  var r = vvr(this), n = r.prototype, i = Gte(arguments, 1), o = function() {
    var u = Tvr(i, Gte(arguments));
    return this instanceof o ? _vr(r, u.length, u) : r.apply(t, u);
  };
  return Evr(n) && (o.prototype = n), o;
}, Avr = Zt, Svr = zo, Lx = qf, bvr = TAe, Wte = Ble, Cvr = $a, Kte = $i, Ivr = Xf, yAe = mn, IH = Svr("Reflect", "construct"), Ovr = Object.prototype, Rvr = [].push, _Ae = yAe(function() {
  function e() {
  }
  return !(IH(function() {
  }, [], e) instanceof e);
}), AAe = !yAe(function() {
  IH(function() {
  });
}), Xte = _Ae || AAe;
Avr({ target: "Reflect", stat: !0, forced: Xte, sham: Xte }, {
  construct: function(t, r) {
    Wte(t), Cvr(r);
    var n = arguments.length < 3 ? t : Wte(arguments[2]);
    if (AAe && !_Ae) return IH(t, r, n);
    if (t === n) {
      switch (r.length) {
        case 0:
          return new t();
        case 1:
          return new t(r[0]);
        case 2:
          return new t(r[0], r[1]);
        case 3:
          return new t(r[0], r[1], r[2]);
        case 4:
          return new t(r[0], r[1], r[2], r[3]);
      }
      var i = [null];
      return Lx(Rvr, i, r), new (Lx(bvr, t, i))();
    }
    var o = n.prototype, a = Ivr(Kte(o) ? o : Ovr), u = Lx(t, a, r);
    return Kte(u) ? u : a;
  }
});
var wvr = Pn, Pvr = wvr.Reflect.construct, Dvr = Pvr, SAe = Dvr, xvr = SAe;
const Nvr = /* @__PURE__ */ Mt(xvr);
function bAe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Lvr(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), cC(e, tpe(n.key), n);
  }
}
function CAe(e, t, r) {
  return t && Lvr(e.prototype, t), cC(e, "prototype", {
    writable: !1
  }), e;
}
function Bvr(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kvr(e, t) {
  if (t && (Ta(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Bvr(e);
}
var Mvr = SAe, Fvr = Mvr, Hvr = Fvr, $vr = Hvr, Uvr = $vr;
const Vvr = /* @__PURE__ */ Mt(Uvr);
function IAe() {
  try {
    var e = !Boolean.prototype.valueOf.call(Vvr(Boolean, [], function() {
    }));
  } catch {
  }
  return (IAe = function() {
    return !!e;
  })();
}
var jvr = Zt, Jte = TAe;
jvr({ target: "Function", proto: !0, forced: Function.bind !== Jte }, {
  bind: Jte
});
var zvr = Aa, qvr = zvr("Function", "bind"), Yvr = Qi, Gvr = qvr, Bx = Function.prototype, Wvr = function(e) {
  var t = e.bind;
  return e === Bx || Yvr(Bx, e) && t === Bx.bind ? Gvr : t;
}, Kvr = Wvr, Xvr = Kvr, Jvr = Xvr, Zvr = Jvr, Qvr = Zvr, eEr = Qvr, tEr = eEr;
const OAe = /* @__PURE__ */ Mt(tEr);
function ob(e) {
  var t;
  return ob = qL ? OAe(t = bW).call(t) : function(r) {
    return r.__proto__ || bW(r);
  }, ob(e);
}
function o8(e, t) {
  var r;
  return o8 = qL ? OAe(r = qL).call(r) : function(n, i) {
    return n.__proto__ = i, n;
  }, o8(e, t);
}
function rEr(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = IUt(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), cC(e, "prototype", {
    writable: !1
  }), t && o8(e, t);
}
var nEr = bn, Zte = M9, FA = gC.getWeakData, iEr = qb, oEr = $a, aEr = Gf, kx = $i, uEr = ic, RAe = c0, Qte = Co, wAe = u0, sEr = wAe.set, cEr = wAe.getterFor, lEr = RAe.find, fEr = RAe.findIndex, dEr = nEr([].splice), pEr = 0, HA = function(e) {
  return e.frozen || (e.frozen = new PAe());
}, PAe = function() {
  this.entries = [];
}, Mx = function(e, t) {
  return lEr(e.entries, function(r) {
    return r[0] === t;
  });
};
PAe.prototype = {
  get: function(e) {
    var t = Mx(this, e);
    if (t) return t[1];
  },
  has: function(e) {
    return !!Mx(this, e);
  },
  set: function(e, t) {
    var r = Mx(this, e);
    r ? r[1] = t : this.entries.push([e, t]);
  },
  delete: function(e) {
    var t = fEr(this.entries, function(r) {
      return r[0] === e;
    });
    return ~t && dEr(this.entries, t, 1), !!~t;
  }
};
var hEr = {
  getConstructor: function(e, t, r, n) {
    var i = e(function(s, c) {
      iEr(s, o), sEr(s, {
        type: t,
        id: pEr++,
        frozen: null
      }), aEr(c) || uEr(c, s[n], { that: s, AS_ENTRIES: r });
    }), o = i.prototype, a = cEr(t), u = function(s, c, l) {
      var f = a(s), d = FA(oEr(c), !0);
      return d === !0 ? HA(f).set(c, l) : d[f.id] = l, s;
    };
    return Zte(o, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      delete: function(s) {
        var c = a(this);
        if (!kx(s)) return !1;
        var l = FA(s);
        return l === !0 ? HA(c).delete(s) : l && Qte(l, c.id) && delete l[c.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function(c) {
        var l = a(this);
        if (!kx(c)) return !1;
        var f = FA(c);
        return f === !0 ? HA(l).has(c) : f && Qte(f, l.id);
      }
    }), Zte(o, r ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function(c) {
        var l = a(this);
        if (kx(c)) {
          var f = FA(c);
          if (f === !0) return HA(l).get(c);
          if (f) return f[l.id];
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function(c, l) {
        return u(this, c, l);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function(c) {
        return u(this, c, !0);
      }
    }), i;
  }
}, vEr = Ahe, ere = Mn, Y4 = bn, tre = M9, EEr = gC, mEr = k9, DAe = hEr, $A = $i, UA = u0.enforce, gEr = mn, TEr = yle, Uy = Object, yEr = Array.isArray, VA = Uy.isExtensible, xAe = Uy.isFrozen, _Er = Uy.isSealed, NAe = Uy.freeze, AEr = Uy.seal, SEr = !ere.ActiveXObject && "ActiveXObject" in ere, Wv, LAe = function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, BAe = mEr("WeakMap", LAe, DAe), op = BAe.prototype, G4 = Y4(op.set), bEr = function() {
  return vEr && gEr(function() {
    var e = NAe([]);
    return G4(new BAe(), e, 1), !xAe(e);
  });
};
if (TEr) if (SEr) {
  Wv = DAe.getConstructor(LAe, "WeakMap", !0), EEr.enable();
  var rre = Y4(op.delete), jA = Y4(op.has), nre = Y4(op.get);
  tre(op, {
    delete: function(e) {
      if ($A(e) && !VA(e)) {
        var t = UA(this);
        return t.frozen || (t.frozen = new Wv()), rre(this, e) || t.frozen.delete(e);
      }
      return rre(this, e);
    },
    has: function(t) {
      if ($A(t) && !VA(t)) {
        var r = UA(this);
        return r.frozen || (r.frozen = new Wv()), jA(this, t) || r.frozen.has(t);
      }
      return jA(this, t);
    },
    get: function(t) {
      if ($A(t) && !VA(t)) {
        var r = UA(this);
        return r.frozen || (r.frozen = new Wv()), jA(this, t) ? nre(this, t) : r.frozen.get(t);
      }
      return nre(this, t);
    },
    set: function(t, r) {
      if ($A(t) && !VA(t)) {
        var n = UA(this);
        n.frozen || (n.frozen = new Wv()), jA(this, t) ? G4(this, t, r) : n.frozen.set(t, r);
      } else G4(this, t, r);
      return this;
    }
  });
} else bEr() && tre(op, {
  set: function(t, r) {
    var n;
    return yEr(t) && (xAe(t) ? n = NAe : _Er(t) && (n = AEr)), G4(this, t, r), n && n(t), this;
  }
});
var CEr = Pn, IEr = CEr.WeakMap, OEr = IEr, REr = OEr, wEr = REr;
const w1 = /* @__PURE__ */ Mt(wEr);
var PEr = tEe;
const ire = /* @__PURE__ */ Mt(PEr);
var DEr = k9, xEr = Ihe;
DEr("Map", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, xEr);
var NEr = zo, zA = Ohe, ore = NEr("Map"), LEr = {
  Map: ore,
  set: zA("set", 2),
  get: zA("get", 1),
  has: zA("has", 1),
  remove: zA("delete", 1),
  proto: ore.prototype
}, BEr = Zt, kEr = bn, MEr = _a, FEr = dh, HEr = ic, K3 = LEr, $Er = rle, UEr = K3.Map, VEr = K3.has, jEr = K3.get, zEr = K3.set, qEr = kEr([].push);
BEr({ target: "Map", stat: !0, forced: $Er }, {
  groupBy: function(t, r) {
    FEr(t), MEr(r);
    var n = new UEr(), i = 0;
    return HEr(t, function(o) {
      var a = r(o, i++);
      VEr(n, a) ? qEr(jEr(n, a), o) : zEr(n, a, [o]);
    }), n;
  }
});
var YEr = Pn, GEr = YEr.Map, WEr = GEr, KEr = WEr, XEr = KEr;
const JEr = /* @__PURE__ */ Mt(XEr);
var ZEr = Lde;
const kAe = /* @__PURE__ */ Mt(ZEr);
var QEr = Dh, emr = QEr.f("toStringTag"), tmr = emr, rmr = tmr, nmr = rmr;
const ab = /* @__PURE__ */ Mt(nmr);
function imr(e, t, r) {
  return t = ob(t), kvr(e, IAe() ? Nvr(t, [], ob(e).constructor) : t.apply(e, r));
}
var omr = wf, MAe = wu, amr = iy, FAe = Xye, umr = KS, smr = Object.prototype.hasOwnProperty, cmr = function(t, r) {
  return function() {
    return r || (0, t[FAe(t)[0]])((r = {
      exports: {}
    }).exports, r), r.exports;
  };
}, lmr = function(t, r, n, i) {
  if (r && Ta(r) === "object" || typeof r == "function") {
    var o = Kye(FAe(r)), a;
    try {
      var u = function() {
        var c = a.value;
        !smr.call(t, c) && c !== n && MAe(t, c, {
          get: function() {
            return r[c];
          },
          enumerable: !(i = amr(r, c)) || i.enumerable
        });
      };
      for (o.s(); !(a = o.n()).done; )
        u();
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
  }
  return t;
}, fmr = function(t, r, n) {
  return n = t != null ? omr(umr(t)) : {}, lmr(MAe(n, "default", {
    value: t,
    enumerable: !0
  }), t);
}, dmr = cmr({
  "../abort-controller/node_modules/event-target-shim/dist/event-target-shim.js": function(t, r) {
    wu(t, "__esModule", {
      value: !0
    });
    var n = /* @__PURE__ */ new w1(), i = /* @__PURE__ */ new w1();
    function o(k) {
      var H = n.get(k);
      return console.assert(H != null, "'this' is expected an Event object, but got", k), H;
    }
    function a(k) {
      if (k.passiveListener != null) {
        typeof console < "u" && typeof console.error == "function" && console.error("Unable to preventDefault inside passive event listener invocation.", k.passiveListener);
        return;
      }
      k.event.cancelable && (k.canceled = !0, typeof k.event.preventDefault == "function" && k.event.preventDefault());
    }
    function u(k, H) {
      n.set(this, {
        eventTarget: k,
        event: H,
        eventPhase: 2,
        currentTarget: k,
        canceled: !1,
        stopped: !1,
        immediateStopped: !1,
        passiveListener: null,
        timeStamp: H.timeStamp || Vc()
      }), wu(this, "isTrusted", {
        value: !1,
        enumerable: !0
      });
      for (var B = IS(H), x = 0; x < B.length; ++x) {
        var D = B[x];
        D in this || wu(this, D, s(D));
      }
    }
    u.prototype = {
      get type() {
        return o(this).event.type;
      },
      get target() {
        return o(this).eventTarget;
      },
      get currentTarget() {
        return o(this).currentTarget;
      },
      composedPath: function() {
        var H = o(this).currentTarget;
        return H == null ? [] : [H];
      },
      get NONE() {
        return 0;
      },
      get CAPTURING_PHASE() {
        return 1;
      },
      get AT_TARGET() {
        return 2;
      },
      get BUBBLING_PHASE() {
        return 3;
      },
      get eventPhase() {
        return o(this).eventPhase;
      },
      stopPropagation: function() {
        var H = o(this);
        H.stopped = !0, typeof H.event.stopPropagation == "function" && H.event.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var H = o(this);
        H.stopped = !0, H.immediateStopped = !0, typeof H.event.stopImmediatePropagation == "function" && H.event.stopImmediatePropagation();
      },
      get bubbles() {
        return !!o(this).event.bubbles;
      },
      get cancelable() {
        return !!o(this).event.cancelable;
      },
      preventDefault: function() {
        a(o(this));
      },
      get defaultPrevented() {
        return o(this).canceled;
      },
      get composed() {
        return !!o(this).event.composed;
      },
      get timeStamp() {
        return o(this).timeStamp;
      },
      get srcElement() {
        return o(this).eventTarget;
      },
      get cancelBubble() {
        return o(this).stopped;
      },
      set cancelBubble(k) {
        if (k) {
          var H = o(this);
          H.stopped = !0, typeof H.event.cancelBubble == "boolean" && (H.event.cancelBubble = !0);
        }
      },
      get returnValue() {
        return !o(this).canceled;
      },
      set returnValue(k) {
        k || a(o(this));
      },
      initEvent: function() {
      }
    }, wu(u.prototype, "constructor", {
      value: u,
      configurable: !0,
      writable: !0
    }), typeof window < "u" && typeof window.Event < "u" && (ire(u.prototype, window.Event.prototype), i.set(window.Event.prototype, u));
    function s(k) {
      return {
        get: function() {
          return o(this).event[k];
        },
        set: function(B) {
          o(this).event[k] = B;
        },
        configurable: !0,
        enumerable: !0
      };
    }
    function c(k) {
      return {
        value: function() {
          var B = o(this).event;
          return B[k].apply(B, arguments);
        },
        configurable: !0,
        enumerable: !0
      };
    }
    function l(k, H) {
      var B = IS(H);
      if (B.length === 0)
        return k;
      function x(V, F) {
        k.call(this, V, F);
      }
      x.prototype = wf(k.prototype, {
        constructor: {
          value: x,
          configurable: !0,
          writable: !0
        }
      });
      for (var D = 0; D < B.length; ++D) {
        var w = B[D];
        if (!(w in k.prototype)) {
          var $ = iy(H, w), X = typeof $.value == "function";
          wu(x.prototype, w, X ? c(w) : s(w));
        }
      }
      return x;
    }
    function f(k) {
      if (k == null || k === Object.prototype)
        return u;
      var H = i.get(k);
      return H == null && (H = l(f(KS(k)), k), i.set(k, H)), H;
    }
    function d(k, H) {
      var B = f(KS(H));
      return new B(k, H);
    }
    function p(k) {
      return o(k).immediateStopped;
    }
    function v(k, H) {
      o(k).eventPhase = H;
    }
    function h(k, H) {
      o(k).currentTarget = H;
    }
    function E(k, H) {
      o(k).passiveListener = H;
    }
    var m = /* @__PURE__ */ new w1(), g = 1, y = 2, _ = 3;
    function S(k) {
      return k !== null && Ta(k) === "object";
    }
    function A(k) {
      var H = m.get(k);
      if (H == null)
        throw new TypeError("'this' is expected an EventTarget object, but got another value.");
      return H;
    }
    function O(k) {
      return {
        get: function() {
          for (var B = A(this), x = B.get(k); x != null; ) {
            if (x.listenerType === _)
              return x.listener;
            x = x.next;
          }
          return null;
        },
        set: function(B) {
          typeof B != "function" && !S(B) && (B = null);
          for (var x = A(this), D = null, w = x.get(k); w != null; )
            w.listenerType === _ ? D !== null ? D.next = w.next : w.next !== null ? x.set(k, w.next) : x.delete(k) : D = w, w = w.next;
          if (B !== null) {
            var $ = {
              listener: B,
              listenerType: _,
              passive: !1,
              once: !1,
              next: null
            };
            D === null ? x.set(k, $) : D.next = $;
          }
        },
        configurable: !0,
        enumerable: !0
      };
    }
    function P(k, H) {
      wu(k, "on".concat(H), O(H));
    }
    function U(k) {
      function H() {
        z.call(this);
      }
      H.prototype = wf(z.prototype, {
        constructor: {
          value: H,
          configurable: !0,
          writable: !0
        }
      });
      for (var B = 0; B < k.length; ++B)
        P(H.prototype, k[B]);
      return H;
    }
    function z() {
      if (this instanceof z) {
        m.set(this, /* @__PURE__ */ new JEr());
        return;
      }
      if (arguments.length === 1 && zp(arguments[0]))
        return U(arguments[0]);
      if (arguments.length > 0) {
        for (var k = new Array(arguments.length), H = 0; H < arguments.length; ++H)
          k[H] = arguments[H];
        return U(k);
      }
      throw new TypeError("Cannot call a class as a function");
    }
    z.prototype = {
      addEventListener: function(H, B, x) {
        if (B != null) {
          if (typeof B != "function" && !S(B))
            throw new TypeError("'listener' should be a function or an object.");
          var D = A(this), w = S(x), $ = w ? !!x.capture : !!x, X = $ ? g : y, V = {
            listener: B,
            listenerType: X,
            passive: w && !!x.passive,
            once: w && !!x.once,
            next: null
          }, F = D.get(H);
          if (F === void 0) {
            D.set(H, V);
            return;
          }
          for (var le = null; F != null; ) {
            if (F.listener === B && F.listenerType === X)
              return;
            le = F, F = F.next;
          }
          le.next = V;
        }
      },
      removeEventListener: function(H, B, x) {
        if (B != null)
          for (var D = A(this), w = S(x) ? !!x.capture : !!x, $ = w ? g : y, X = null, V = D.get(H); V != null; ) {
            if (V.listener === B && V.listenerType === $) {
              X !== null ? X.next = V.next : V.next !== null ? D.set(H, V.next) : D.delete(H);
              return;
            }
            X = V, V = V.next;
          }
      },
      dispatchEvent: function(H) {
        if (H == null || typeof H.type != "string")
          throw new TypeError('"event.type" should be a string.');
        var B = A(this), x = H.type, D = B.get(x);
        if (D == null)
          return !0;
        for (var w = d(this, H), $ = null; D != null; ) {
          if (D.once ? $ !== null ? $.next = D.next : D.next !== null ? B.set(x, D.next) : B.delete(x) : $ = D, E(w, D.passive ? D.listener : null), typeof D.listener == "function")
            try {
              D.listener.call(this, w);
            } catch (X) {
              typeof console < "u" && typeof console.error == "function" && console.error(X);
            }
          else D.listenerType !== _ && typeof D.listener.handleEvent == "function" && D.listener.handleEvent(w);
          if (p(w))
            break;
          D = D.next;
        }
        return E(w, null), v(w, 0), h(w, null), !w.defaultPrevented;
      }
    }, wu(z.prototype, "constructor", {
      value: z,
      configurable: !0,
      writable: !0
    }), typeof window < "u" && typeof window.EventTarget < "u" && ire(z.prototype, window.EventTarget.prototype), t.defineEventAttribute = P, t.EventTarget = z, t.default = z, r.exports = z, r.exports.EventTarget = r.exports.default = z, r.exports.defineEventAttribute = P;
  }
}), OH = fmr(dmr()), X3 = /* @__PURE__ */ function(e) {
  function t() {
    throw bAe(this, t), imr(this, t), new TypeError("AbortSignal cannot be constructed directly");
  }
  return rEr(t, e), CAe(t, [{
    key: "aborted",
    get: function() {
      var n = ub.get(this);
      if (typeof n != "boolean")
        throw new TypeError("Expected 'this' to be an 'AbortSignal' object, but got ".concat(this === null ? "null" : Ta(this)));
      return n;
    }
  }]);
}(OH.EventTarget);
(0, OH.defineEventAttribute)(X3.prototype, "abort");
function pmr() {
  var e = wf(X3.prototype);
  return OH.EventTarget.call(e), ub.set(e, !1), e;
}
function hmr(e) {
  ub.get(e) === !1 && (ub.set(e, !0), e.dispatchEvent({
    type: "abort"
  }));
}
var ub = /* @__PURE__ */ new w1();
S9(X3.prototype, {
  aborted: {
    enumerable: !0
  }
});
typeof kAe == "function" && Ta(ab) === "symbol" && wu(X3.prototype, ab, {
  configurable: !0,
  value: "AbortSignal"
});
var RH = /* @__PURE__ */ function() {
  function e() {
    bAe(this, e), HAe.set(this, pmr());
  }
  return CAe(e, [{
    key: "signal",
    get: function() {
      return are(this);
    }
  }, {
    key: "abort",
    value: function() {
      hmr(are(this));
    }
  }]);
}(), HAe = /* @__PURE__ */ new w1();
function are(e) {
  var t = HAe.get(e);
  if (t == null)
    throw new TypeError("Expected 'this' to be an 'AbortController' object, but got ".concat(e === null ? "null" : Ta(e)));
  return t;
}
S9(RH.prototype, {
  signal: {
    enumerable: !0
  },
  abort: {
    enumerable: !0
  }
});
typeof kAe == "function" && Ta(ab) === "symbol" && wu(RH.prototype, ab, {
  configurable: !0,
  value: "AbortController"
});
var vmr = RH, Emr = (typeof window > "u" ? {} : window).AbortController, mmr = Emr || vmr, $Ae = {}, UAe = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(UAe);
var J3 = UAe.exports, Vy = {}, VAe = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(VAe);
var Zh = VAe.exports, Fx = { exports: {} }, ure;
function gmr() {
  return ure || (ure = 1, function(e) {
    var t = J3.default;
    function r() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      e.exports = r = function() {
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var n = {}, i = Object.prototype, o = i.hasOwnProperty, a = typeof Symbol == "function" ? Symbol : {}, u = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
      function l(B, x, D) {
        return Object.defineProperty(B, x, {
          value: D,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), B[x];
      }
      try {
        l({}, "");
      } catch {
        l = function(D, w, $) {
          return D[w] = $;
        };
      }
      function f(B, x, D, w) {
        var $ = x && x.prototype instanceof v ? x : v, X = Object.create($.prototype), V = new z(w || []);
        return X._invoke = /* @__PURE__ */ function(F, le, ae) {
          var ne = "suspendedStart";
          return function(ve, Ie) {
            if (ne === "executing") throw new Error("Generator is already running");
            if (ne === "completed") {
              if (ve === "throw") throw Ie;
              return H();
            }
            for (ae.method = ve, ae.arg = Ie; ; ) {
              var Oe = ae.delegate;
              if (Oe) {
                var xe = O(Oe, ae);
                if (xe) {
                  if (xe === p) continue;
                  return xe;
                }
              }
              if (ae.method === "next") ae.sent = ae._sent = ae.arg;
              else if (ae.method === "throw") {
                if (ne === "suspendedStart") throw ne = "completed", ae.arg;
                ae.dispatchException(ae.arg);
              } else ae.method === "return" && ae.abrupt("return", ae.arg);
              ne = "executing";
              var ze = d(F, le, ae);
              if (ze.type === "normal") {
                if (ne = ae.done ? "completed" : "suspendedYield", ze.arg === p) continue;
                return {
                  value: ze.arg,
                  done: ae.done
                };
              }
              ze.type === "throw" && (ne = "completed", ae.method = "throw", ae.arg = ze.arg);
            }
          };
        }(B, D, V), X;
      }
      function d(B, x, D) {
        try {
          return {
            type: "normal",
            arg: B.call(x, D)
          };
        } catch (w) {
          return {
            type: "throw",
            arg: w
          };
        }
      }
      n.wrap = f;
      var p = {};
      function v() {
      }
      function h() {
      }
      function E() {
      }
      var m = {};
      l(m, u, function() {
        return this;
      });
      var g = Object.getPrototypeOf, y = g && g(g(k([])));
      y && y !== i && o.call(y, u) && (m = y);
      var _ = E.prototype = v.prototype = Object.create(m);
      function S(B) {
        ["next", "throw", "return"].forEach(function(x) {
          l(B, x, function(D) {
            return this._invoke(x, D);
          });
        });
      }
      function A(B, x) {
        function D($, X, V, F) {
          var le = d(B[$], B, X);
          if (le.type !== "throw") {
            var ae = le.arg, ne = ae.value;
            return ne && t(ne) == "object" && o.call(ne, "__await") ? x.resolve(ne.__await).then(function(ve) {
              D("next", ve, V, F);
            }, function(ve) {
              D("throw", ve, V, F);
            }) : x.resolve(ne).then(function(ve) {
              ae.value = ve, V(ae);
            }, function(ve) {
              return D("throw", ve, V, F);
            });
          }
          F(le.arg);
        }
        var w;
        this._invoke = function($, X) {
          function V() {
            return new x(function(F, le) {
              D($, X, F, le);
            });
          }
          return w = w ? w.then(V, V) : V();
        };
      }
      function O(B, x) {
        var D = B.iterator[x.method];
        if (D === void 0) {
          if (x.delegate = null, x.method === "throw") {
            if (B.iterator.return && (x.method = "return", x.arg = void 0, O(B, x), x.method === "throw")) return p;
            x.method = "throw", x.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return p;
        }
        var w = d(D, B.iterator, x.arg);
        if (w.type === "throw") return x.method = "throw", x.arg = w.arg, x.delegate = null, p;
        var $ = w.arg;
        return $ ? $.done ? (x[B.resultName] = $.value, x.next = B.nextLoc, x.method !== "return" && (x.method = "next", x.arg = void 0), x.delegate = null, p) : $ : (x.method = "throw", x.arg = new TypeError("iterator result is not an object"), x.delegate = null, p);
      }
      function P(B) {
        var x = {
          tryLoc: B[0]
        };
        1 in B && (x.catchLoc = B[1]), 2 in B && (x.finallyLoc = B[2], x.afterLoc = B[3]), this.tryEntries.push(x);
      }
      function U(B) {
        var x = B.completion || {};
        x.type = "normal", delete x.arg, B.completion = x;
      }
      function z(B) {
        this.tryEntries = [{
          tryLoc: "root"
        }], B.forEach(P, this), this.reset(!0);
      }
      function k(B) {
        if (B) {
          var x = B[u];
          if (x) return x.call(B);
          if (typeof B.next == "function") return B;
          if (!isNaN(B.length)) {
            var D = -1, w = function $() {
              for (; ++D < B.length; )
                if (o.call(B, D)) return $.value = B[D], $.done = !1, $;
              return $.value = void 0, $.done = !0, $;
            };
            return w.next = w;
          }
        }
        return {
          next: H
        };
      }
      function H() {
        return {
          value: void 0,
          done: !0
        };
      }
      return h.prototype = E, l(_, "constructor", E), l(E, "constructor", h), h.displayName = l(E, c, "GeneratorFunction"), n.isGeneratorFunction = function(B) {
        var x = typeof B == "function" && B.constructor;
        return !!x && (x === h || (x.displayName || x.name) === "GeneratorFunction");
      }, n.mark = function(B) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(B, E) : (B.__proto__ = E, l(B, c, "GeneratorFunction")), B.prototype = Object.create(_), B;
      }, n.awrap = function(B) {
        return {
          __await: B
        };
      }, S(A.prototype), l(A.prototype, s, function() {
        return this;
      }), n.AsyncIterator = A, n.async = function(B, x, D, w, $) {
        $ === void 0 && ($ = Promise);
        var X = new A(f(B, x, D, w), $);
        return n.isGeneratorFunction(x) ? X : X.next().then(function(V) {
          return V.done ? V.value : X.next();
        });
      }, S(_), l(_, c, "Generator"), l(_, u, function() {
        return this;
      }), l(_, "toString", function() {
        return "[object Generator]";
      }), n.keys = function(B) {
        var x = [];
        for (var D in B)
          x.push(D);
        return x.reverse(), function w() {
          for (; x.length; ) {
            var $ = x.pop();
            if ($ in B) return w.value = $, w.done = !1, w;
          }
          return w.done = !0, w;
        };
      }, n.values = k, z.prototype = {
        constructor: z,
        reset: function(x) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(U), !x) for (var D in this)
            D.charAt(0) === "t" && o.call(this, D) && !isNaN(+D.slice(1)) && (this[D] = void 0);
        },
        stop: function() {
          this.done = !0;
          var x = this.tryEntries[0].completion;
          if (x.type === "throw") throw x.arg;
          return this.rval;
        },
        dispatchException: function(x) {
          if (this.done) throw x;
          var D = this;
          function w(ae, ne) {
            return V.type = "throw", V.arg = x, D.next = ae, ne && (D.method = "next", D.arg = void 0), !!ne;
          }
          for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
            var X = this.tryEntries[$], V = X.completion;
            if (X.tryLoc === "root") return w("end");
            if (X.tryLoc <= this.prev) {
              var F = o.call(X, "catchLoc"), le = o.call(X, "finallyLoc");
              if (F && le) {
                if (this.prev < X.catchLoc) return w(X.catchLoc, !0);
                if (this.prev < X.finallyLoc) return w(X.finallyLoc);
              } else if (F) {
                if (this.prev < X.catchLoc) return w(X.catchLoc, !0);
              } else {
                if (!le) throw new Error("try statement without catch or finally");
                if (this.prev < X.finallyLoc) return w(X.finallyLoc);
              }
            }
          }
        },
        abrupt: function(x, D) {
          for (var w = this.tryEntries.length - 1; w >= 0; --w) {
            var $ = this.tryEntries[w];
            if ($.tryLoc <= this.prev && o.call($, "finallyLoc") && this.prev < $.finallyLoc) {
              var X = $;
              break;
            }
          }
          X && (x === "break" || x === "continue") && X.tryLoc <= D && D <= X.finallyLoc && (X = null);
          var V = X ? X.completion : {};
          return V.type = x, V.arg = D, X ? (this.method = "next", this.next = X.finallyLoc, p) : this.complete(V);
        },
        complete: function(x, D) {
          if (x.type === "throw") throw x.arg;
          return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && D && (this.next = D), p;
        },
        finish: function(x) {
          for (var D = this.tryEntries.length - 1; D >= 0; --D) {
            var w = this.tryEntries[D];
            if (w.finallyLoc === x) return this.complete(w.completion, w.afterLoc), U(w), p;
          }
        },
        catch: function(x) {
          for (var D = this.tryEntries.length - 1; D >= 0; --D) {
            var w = this.tryEntries[D];
            if (w.tryLoc === x) {
              var $ = w.completion;
              if ($.type === "throw") {
                var X = $.arg;
                U(w);
              }
              return X;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(x, D, w) {
          return this.delegate = {
            iterator: k(x),
            resultName: D,
            nextLoc: w
          }, this.method === "next" && (this.arg = void 0), p;
        }
      }, n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Fx)), Fx.exports;
}
var Hx, sre;
function jAe() {
  if (sre) return Hx;
  sre = 1;
  var e = gmr()();
  Hx = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return Hx;
}
var $x = { exports: {} }, Ux = { exports: {} }, Vx = { exports: {} }, cre;
function zAe() {
  return cre || (cre = 1, function(e) {
    function t(r, n) {
      (n == null || n > r.length) && (n = r.length);
      for (var i = 0, o = new Array(n); i < n; i++)
        o[i] = r[i];
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Vx)), Vx.exports;
}
var lre;
function Tmr() {
  return lre || (lre = 1, function(e) {
    var t = zAe();
    function r(n) {
      if (Array.isArray(n)) return t(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ux)), Ux.exports;
}
var jx = { exports: {} }, fre;
function ymr() {
  return fre || (fre = 1, function(e) {
    function t(r) {
      if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(jx)), jx.exports;
}
var zx = { exports: {} }, dre;
function _mr() {
  return dre || (dre = 1, function(e) {
    var t = zAe();
    function r(n, i) {
      if (n) {
        if (typeof n == "string") return t(n, i);
        var o = Object.prototype.toString.call(n).slice(8, -1);
        if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set") return Array.from(n);
        if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return t(n, i);
      }
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(zx)), zx.exports;
}
var qx = { exports: {} }, pre;
function Amr() {
  return pre || (pre = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(qx)), qx.exports;
}
var hre;
function qAe() {
  return hre || (hre = 1, function(e) {
    var t = Tmr(), r = ymr(), n = _mr(), i = Amr();
    function o(a) {
      return t(a) || r(a) || n(a) || i();
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($x)), $x.exports;
}
var Yx = { exports: {} }, vre;
function jy() {
  return vre || (vre = 1, function(e) {
    function t(r, n, i) {
      return n in r ? Object.defineProperty(r, n, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[n] = i, r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Yx)), Yx.exports;
}
var Gx = { exports: {} }, Ere;
function YAe() {
  return Ere || (Ere = 1, function(e) {
    function t(n, i, o, a, u, s, c) {
      try {
        var l = n[s](c), f = l.value;
      } catch (d) {
        o(d);
        return;
      }
      l.done ? i(f) : Promise.resolve(f).then(a, u);
    }
    function r(n) {
      return function() {
        var i = this, o = arguments;
        return new Promise(function(a, u) {
          var s = n.apply(i, o);
          function c(f) {
            t(s, a, u, c, l, "next", f);
          }
          function l(f) {
            t(s, a, u, c, l, "throw", f);
          }
          c(void 0);
        });
      };
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Gx)), Gx.exports;
}
var Wx = { exports: {} }, mre;
function wH() {
  return mre || (mre = 1, function(e) {
    function t(n, i) {
      for (var o = 0; o < i.length; o++) {
        var a = i[o];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
      }
    }
    function r(n, i, o) {
      return i && t(n.prototype, i), o && t(n, o), Object.defineProperty(n, "prototype", {
        writable: !1
      }), n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Wx)), Wx.exports;
}
var Kx = { exports: {} }, gre;
function PH() {
  return gre || (gre = 1, function(e) {
    function t(r, n) {
      if (!(r instanceof n))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Kx)), Kx.exports;
}
var Xx = { exports: {} }, Jx = { exports: {} }, Tre;
function DH() {
  return Tre || (Tre = 1, function(e) {
    function t(r, n) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, a) {
        return o.__proto__ = a, o;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Jx)), Jx.exports;
}
var yre;
function GAe() {
  return yre || (yre = 1, function(e) {
    var t = DH();
    function r(n, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(n, "prototype", {
        writable: !1
      }), i && t(n, i);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Xx)), Xx.exports;
}
var Zx = { exports: {} }, Qx = { exports: {} }, _re;
function WAe() {
  return _re || (_re = 1, function(e) {
    function t(r) {
      if (r === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Qx)), Qx.exports;
}
var Are;
function KAe() {
  return Are || (Are = 1, function(e) {
    var t = J3.default, r = WAe();
    function n(i, o) {
      if (o && (t(o) === "object" || typeof o == "function"))
        return o;
      if (o !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return r(i);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Zx)), Zx.exports;
}
var eN = { exports: {} }, Sre;
function Z3() {
  return Sre || (Sre = 1, function(e) {
    function t(r) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(eN)), eN.exports;
}
var bu = {}, tN = { exports: {} }, rN = { exports: {} }, bre;
function XAe() {
  return bre || (bre = 1, function(e) {
    var t = Z3();
    function r(n, i) {
      for (; !Object.prototype.hasOwnProperty.call(n, i) && (n = t(n), n !== null); )
        ;
      return n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(rN)), rN.exports;
}
var Cre;
function Smr() {
  return Cre || (Cre = 1, function(e) {
    var t = XAe(), r = jy();
    function n(o, a, u, s) {
      return typeof Reflect < "u" && Reflect.set ? n = Reflect.set : n = function(l, f, d, p) {
        var v = t(l, f), h;
        if (v) {
          if (h = Object.getOwnPropertyDescriptor(v, f), h.set)
            return h.set.call(p, d), !0;
          if (!h.writable)
            return !1;
        }
        if (h = Object.getOwnPropertyDescriptor(p, f), h) {
          if (!h.writable)
            return !1;
          h.value = d, Object.defineProperty(p, f, h);
        } else
          r(p, f, d);
        return !0;
      }, n(o, a, u, s);
    }
    function i(o, a, u, s, c) {
      var l = n(o, a, u, s || o);
      if (!l && c)
        throw new Error("failed to set property");
      return u;
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(tN)), tN.exports;
}
var nN = { exports: {} }, Ire;
function bmr() {
  return Ire || (Ire = 1, function(e) {
    var t = XAe();
    function r() {
      return typeof Reflect < "u" && Reflect.get ? (e.exports = r = Reflect.get.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = r = function(i, o, a) {
        var u = t(i, o);
        if (u) {
          var s = Object.getOwnPropertyDescriptor(u, o);
          return s.get ? s.get.call(arguments.length < 3 ? i : a) : s.value;
        }
      }, e.exports.__esModule = !0, e.exports.default = e.exports), r.apply(this, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(nN)), nN.exports;
}
var iN = { exports: {} }, oN = { exports: {} }, Ore;
function Cmr() {
  return Ore || (Ore = 1, function(e) {
    function t(r) {
      return Function.toString.call(r).indexOf("[native code]") !== -1;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(oN)), oN.exports;
}
var aN = { exports: {} }, uN = { exports: {} }, Rre;
function Imr() {
  return Rre || (Rre = 1, function(e) {
    function t() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(uN)), uN.exports;
}
var wre;
function Omr() {
  return wre || (wre = 1, function(e) {
    var t = DH(), r = Imr();
    function n(i, o, a) {
      return r() ? (e.exports = n = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = n = function(s, c, l) {
        var f = [null];
        f.push.apply(f, c);
        var d = Function.bind.apply(s, f), p = new d();
        return l && t(p, l.prototype), p;
      }, e.exports.__esModule = !0, e.exports.default = e.exports), n.apply(null, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(aN)), aN.exports;
}
var Pre;
function Rmr() {
  return Pre || (Pre = 1, function(e) {
    var t = Z3(), r = DH(), n = Cmr(), i = Omr();
    function o(a) {
      var u = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e.exports = o = function(c) {
        if (c === null || !n(c)) return c;
        if (typeof c != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof u < "u") {
          if (u.has(c)) return u.get(c);
          u.set(c, l);
        }
        function l() {
          return i(c, arguments, t(this).constructor);
        }
        return l.prototype = Object.create(c.prototype, {
          constructor: {
            value: l,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r(l, c);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, o(a);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(iN)), iN.exports;
}
var Dre;
function wmr() {
  if (Dre) return bu;
  Dre = 1, Object.defineProperty(bu, "__esModule", { value: !0 });
  var e = qAe(), t = Smr(), r = bmr(), n = WAe(), i = GAe(), o = KAe(), a = Z3(), u = Rmr(), s = jy(), c = PH(), l = wH(), f = J3;
  function d(ht) {
    return ht && typeof ht == "object" && "default" in ht ? ht : { default: ht };
  }
  var p = /* @__PURE__ */ d(e), v = /* @__PURE__ */ d(t), h = /* @__PURE__ */ d(r), E = /* @__PURE__ */ d(n), m = /* @__PURE__ */ d(i), g = /* @__PURE__ */ d(o), y = /* @__PURE__ */ d(a), _ = /* @__PURE__ */ d(u), S = /* @__PURE__ */ d(s), A = /* @__PURE__ */ d(c), O = /* @__PURE__ */ d(l), P = /* @__PURE__ */ d(f);
  function U(ht) {
    var Pe = z();
    return function() {
      var Ye = y.default(ht), Xe;
      if (Pe) {
        var dt = y.default(this).constructor;
        Xe = Reflect.construct(Ye, arguments, dt);
      } else
        Xe = Ye.apply(this, arguments);
      return g.default(this, Xe);
    };
  }
  function z() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function k(ht, Pe) {
    var Fe = Object.keys(ht);
    if (Object.getOwnPropertySymbols) {
      var Ye = Object.getOwnPropertySymbols(ht);
      Pe && (Ye = Ye.filter(function(Xe) {
        return Object.getOwnPropertyDescriptor(ht, Xe).enumerable;
      })), Fe.push.apply(Fe, Ye);
    }
    return Fe;
  }
  function H(ht) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var Fe = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? k(Object(Fe), !0).forEach(function(Ye) {
        S.default(ht, Ye, Fe[Ye]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ht, Object.getOwnPropertyDescriptors(Fe)) : k(Object(Fe)).forEach(function(Ye) {
        Object.defineProperty(ht, Ye, Object.getOwnPropertyDescriptor(Fe, Ye));
      });
    }
    return ht;
  }
  function B(ht, Pe) {
    if (!ht) {
      for (var Fe = arguments.length, Ye = new Array(Fe > 2 ? Fe - 2 : 0), Xe = 2; Xe < Fe; Xe++)
        Ye[Xe - 2] = arguments[Xe];
      throw new TypeError(x(Pe, Ye));
    }
  }
  function x(ht, Pe) {
    var Fe = 0;
    return ht.replace(/%[os]/g, function() {
      return D(Pe[Fe++]);
    });
  }
  function D(ht) {
    return P.default(ht) !== "object" || ht === null ? String(ht) : Object.prototype.toString.call(ht);
  }
  var w;
  function $(ht) {
    B(typeof ht == "function" || ht === void 0, "The error handler must be a function or undefined, but got %o.", ht), w = ht;
  }
  function X(ht) {
    try {
      var Pe = ht instanceof Error ? ht : new Error(D(ht));
      if (w) {
        w(Pe);
        return;
      }
      if (typeof dispatchEvent == "function" && typeof ErrorEvent == "function")
        dispatchEvent(new ErrorEvent("error", {
          error: Pe,
          message: Pe.message
        }));
      else if (typeof process < "u" && typeof process.emit == "function") {
        process.emit("uncaughtException", Pe);
        return;
      }
      console.error(Pe);
    } catch {
    }
  }
  var V = typeof window < "u" ? window : typeof self < "u" ? self : typeof fe < "u" ? fe : typeof globalThis < "u" ? globalThis : void 0, F;
  function le(ht) {
    B(typeof ht == "function" || ht === void 0, "The warning handler must be a function or undefined, but got %o.", ht), F = ht;
  }
  var ae = /* @__PURE__ */ function() {
    function ht(Pe, Fe) {
      A.default(this, ht), this.code = Pe, this.message = Fe;
    }
    return O.default(ht, [{
      key: "warn",
      value: function() {
        var Fe;
        try {
          for (var Ye, Xe = arguments.length, dt = new Array(Xe), Nt = 0; Nt < Xe; Nt++)
            dt[Nt] = arguments[Nt];
          if (F) {
            F(H(H({}, this), {}, {
              args: dt
            }));
            return;
          }
          var er = ((Fe = new Error().stack) !== null && Fe !== void 0 ? Fe : "").replace(/^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?\n){2}/g, `
`);
          (Ye = console).warn.apply(Ye, [this.message].concat(dt, [er]));
        } catch {
        }
      }
    }]), ht;
  }(), ne = new ae("W01", "Unable to initialize event under dispatching."), ve = new ae("W02", "Assigning any falsy value to 'cancelBubble' property has no effect."), Ie = new ae("W03", "Assigning any truthy value to 'returnValue' property has no effect."), Oe = new ae("W04", "Unable to preventDefault on non-cancelable events."), xe = new ae("W05", "Unable to preventDefault inside passive event listener invocation."), ze = new ae("W06", "An event listener wasn't added because it has been added already: %o, %o"), qe = new ae("W07", "The %o option value was abandoned because the event listener wasn't added as duplicated."), Je = new ae("W08", "The 'callback' argument must be a function or an object that has 'handleEvent' method: %o"), Be = new ae("W09", "Event attribute handler must be a function: %o"), We = /* @__PURE__ */ function() {
    O.default(ht, null, [{
      key: "NONE",
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-none
       */
      get: function() {
        return Ne;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-capturing_phase
       */
    }, {
      key: "CAPTURING_PHASE",
      get: function() {
        return je;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-at_target
       */
    }, {
      key: "AT_TARGET",
      get: function() {
        return et;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-bubbling_phase
       */
    }, {
      key: "BUBBLING_PHASE",
      get: function() {
        return St;
      }
      /**
       * Initialize this event instance.
       * @param type The type of this event.
       * @param eventInitDict Options to initialize.
       * @see https://dom.spec.whatwg.org/#dom-event-event
       */
    }]);
    function ht(Pe, Fe) {
      A.default(this, ht), Object.defineProperty(this, "isTrusted", {
        value: !1,
        enumerable: !0
      });
      var Ye = Fe ?? {};
      Ot.set(this, {
        type: String(Pe),
        bubbles: !!Ye.bubbles,
        cancelable: !!Ye.cancelable,
        composed: !!Ye.composed,
        target: null,
        currentTarget: null,
        stopPropagationFlag: !1,
        stopImmediatePropagationFlag: !1,
        canceledFlag: !1,
        inPassiveListenerFlag: !1,
        dispatchFlag: !1,
        timeStamp: Date.now()
      });
    }
    return O.default(ht, [{
      key: "composedPath",
      /**
       * The event target of the current dispatching.
       * This doesn't support node tree.
       * @see https://dom.spec.whatwg.org/#dom-event-composedpath
       */
      value: function() {
        var Fe = we(this).currentTarget;
        return Fe ? [Fe] : [];
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-none
       */
    }, {
      key: "stopPropagation",
      /**
       * Stop event bubbling.
       * Because this shim doesn't support node tree, this merely changes the `cancelBubble` property value.
       * @see https://dom.spec.whatwg.org/#dom-event-stoppropagation
       */
      value: function() {
        we(this).stopPropagationFlag = !0;
      }
      /**
       * `true` if event bubbling was stopped.
       * @deprecated
       * @see https://dom.spec.whatwg.org/#dom-event-cancelbubble
       */
    }, {
      key: "stopImmediatePropagation",
      /**
       * Stop event bubbling and subsequent event listener callings.
       * @see https://dom.spec.whatwg.org/#dom-event-stopimmediatepropagation
       */
      value: function() {
        var Fe = we(this);
        Fe.stopPropagationFlag = Fe.stopImmediatePropagationFlag = !0;
      }
      /**
       * `true` if this event will bubble.
       * @see https://dom.spec.whatwg.org/#dom-event-bubbles
       */
    }, {
      key: "preventDefault",
      /**
       * Cancel the default behavior.
       * @see https://dom.spec.whatwg.org/#dom-event-preventdefault
       */
      value: function() {
        De(we(this));
      }
      /**
       * `true` if the default behavior was canceled.
       * @see https://dom.spec.whatwg.org/#dom-event-defaultprevented
       */
    }, {
      key: "initEvent",
      /**
       * @deprecated Don't use this method. The constructor did initialization.
       */
      value: function(Fe) {
        var Ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Xe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, dt = we(this);
        if (dt.dispatchFlag) {
          ne.warn();
          return;
        }
        Ot.set(this, H(H({}, dt), {}, {
          type: String(Fe),
          bubbles: !!Ye,
          cancelable: !!Xe,
          target: null,
          currentTarget: null,
          stopPropagationFlag: !1,
          stopImmediatePropagationFlag: !1,
          canceledFlag: !1
        }));
      }
    }, {
      key: "type",
      get: function() {
        return we(this).type;
      }
      /**
       * The event target of the current dispatching.
       * @see https://dom.spec.whatwg.org/#dom-event-target
       */
    }, {
      key: "target",
      get: function() {
        return we(this).target;
      }
      /**
       * The event target of the current dispatching.
       * @deprecated Use the `target` property instead.
       * @see https://dom.spec.whatwg.org/#dom-event-srcelement
       */
    }, {
      key: "srcElement",
      get: function() {
        return we(this).target;
      }
      /**
       * The event target of the current dispatching.
       * @see https://dom.spec.whatwg.org/#dom-event-currenttarget
       */
    }, {
      key: "currentTarget",
      get: function() {
        return we(this).currentTarget;
      }
    }, {
      key: "NONE",
      get: function() {
        return Ne;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-capturing_phase
       */
    }, {
      key: "CAPTURING_PHASE",
      get: function() {
        return je;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-at_target
       */
    }, {
      key: "AT_TARGET",
      get: function() {
        return et;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-bubbling_phase
       */
    }, {
      key: "BUBBLING_PHASE",
      get: function() {
        return St;
      }
      /**
       * The current event phase.
       * @see https://dom.spec.whatwg.org/#dom-event-eventphase
       */
    }, {
      key: "eventPhase",
      get: function() {
        return we(this).dispatchFlag ? 2 : 0;
      }
    }, {
      key: "cancelBubble",
      get: function() {
        return we(this).stopPropagationFlag;
      },
      set: function(Fe) {
        Fe ? we(this).stopPropagationFlag = !0 : ve.warn();
      }
    }, {
      key: "bubbles",
      get: function() {
        return we(this).bubbles;
      }
      /**
       * `true` if this event can be canceled by the `preventDefault()` method.
       * @see https://dom.spec.whatwg.org/#dom-event-cancelable
       */
    }, {
      key: "cancelable",
      get: function() {
        return we(this).cancelable;
      }
      /**
       * `true` if the default behavior will act.
       * @deprecated Use the `defaultPrevented` proeprty instead.
       * @see https://dom.spec.whatwg.org/#dom-event-returnvalue
       */
    }, {
      key: "returnValue",
      get: function() {
        return !we(this).canceledFlag;
      },
      set: function(Fe) {
        Fe ? Ie.warn() : De(we(this));
      }
    }, {
      key: "defaultPrevented",
      get: function() {
        return we(this).canceledFlag;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-composed
       */
    }, {
      key: "composed",
      get: function() {
        return we(this).composed;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-istrusted
       */
      //istanbul ignore next
    }, {
      key: "isTrusted",
      get: function() {
        return !1;
      }
      /**
       * @see https://dom.spec.whatwg.org/#dom-event-timestamp
       */
    }, {
      key: "timeStamp",
      get: function() {
        return we(this).timeStamp;
      }
    }]), ht;
  }(), Ne = 0, je = 1, et = 2, St = 3, Ot = /* @__PURE__ */ new WeakMap();
  function we(ht) {
    var Pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "this", Fe = Ot.get(ht);
    return B(Fe != null, "'%s' must be an object that Event constructor created, but got another one: %o", Pe, ht), Fe;
  }
  function De(ht) {
    if (ht.inPassiveListenerFlag) {
      xe.warn();
      return;
    }
    if (!ht.cancelable) {
      Oe.warn();
      return;
    }
    ht.canceledFlag = !0;
  }
  Object.defineProperty(We, "NONE", {
    enumerable: !0
  }), Object.defineProperty(We, "CAPTURING_PHASE", {
    enumerable: !0
  }), Object.defineProperty(We, "AT_TARGET", {
    enumerable: !0
  }), Object.defineProperty(We, "BUBBLING_PHASE", {
    enumerable: !0
  });
  for (var Ee = Object.getOwnPropertyNames(We.prototype), te = 0; te < Ee.length; ++te)
    Ee[te] !== "constructor" && Object.defineProperty(We.prototype, Ee[te], {
      enumerable: !0
    });
  typeof V < "u" && typeof V.Event < "u" && Object.setPrototypeOf(We.prototype, V.Event.prototype);
  function ue(ht) {
    return V.DOMException ? new V.DOMException(ht, "InvalidStateError") : (ye == null && (ye = /* @__PURE__ */ function(Pe) {
      m.default(Ye, Pe);
      var Fe = U(Ye);
      function Ye(Xe) {
        var dt;
        return A.default(this, Ye), dt = Fe.call(this, Xe), Error.captureStackTrace && Error.captureStackTrace(E.default(dt), Ye), dt;
      }
      return O.default(Ye, [{
        key: "code",
        get: function() {
          return 11;
        }
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "name",
        get: function() {
          return "InvalidStateError";
        }
      }]), Ye;
    }(/* @__PURE__ */ _.default(Error)), Object.defineProperties(ye.prototype, {
      code: {
        enumerable: !0
      },
      name: {
        enumerable: !0
      }
    }), Me(ye), Me(ye.prototype)), new ye(ht));
  }
  var ye, Le = {
    INDEX_SIZE_ERR: 1,
    DOMSTRING_SIZE_ERR: 2,
    HIERARCHY_REQUEST_ERR: 3,
    WRONG_DOCUMENT_ERR: 4,
    INVALID_CHARACTER_ERR: 5,
    NO_DATA_ALLOWED_ERR: 6,
    NO_MODIFICATION_ALLOWED_ERR: 7,
    NOT_FOUND_ERR: 8,
    NOT_SUPPORTED_ERR: 9,
    INUSE_ATTRIBUTE_ERR: 10,
    INVALID_STATE_ERR: 11,
    SYNTAX_ERR: 12,
    INVALID_MODIFICATION_ERR: 13,
    NAMESPACE_ERR: 14,
    INVALID_ACCESS_ERR: 15,
    VALIDATION_ERR: 16,
    TYPE_MISMATCH_ERR: 17,
    SECURITY_ERR: 18,
    NETWORK_ERR: 19,
    ABORT_ERR: 20,
    URL_MISMATCH_ERR: 21,
    QUOTA_EXCEEDED_ERR: 22,
    TIMEOUT_ERR: 23,
    INVALID_NODE_TYPE_ERR: 24,
    DATA_CLONE_ERR: 25
  };
  function Me(ht) {
    for (var Pe = Object.keys(Le), Fe = function(dt) {
      var Nt = Pe[dt], er = Le[Nt];
      Object.defineProperty(ht, Nt, {
        get: function() {
          return er;
        },
        configurable: !0,
        enumerable: !0
      });
    }, Ye = 0; Ye < Pe.length; ++Ye)
      Fe(Ye);
  }
  var Ae = /* @__PURE__ */ function(ht) {
    m.default(Fe, ht);
    var Pe = U(Fe);
    O.default(Fe, null, [{
      key: "wrap",
      /**
       * Wrap a given event object to control states.
       * @param event The event-like object to wrap.
       */
      value: function(Xe) {
        return new (Ce(Xe))(Xe);
      }
    }]);
    function Fe(Ye) {
      var Xe, dt, Nt;
      A.default(this, Fe), Nt = Pe.call(this, Ye.type, {
        bubbles: Ye.bubbles,
        cancelable: Ye.cancelable,
        composed: Ye.composed
      }), Ye.cancelBubble && h.default((Xe = E.default(Nt), y.default(Fe.prototype)), "stopPropagation", Xe).call(Xe), Ye.defaultPrevented && h.default((dt = E.default(Nt), y.default(Fe.prototype)), "preventDefault", dt).call(dt), ie.set(E.default(Nt), {
        original: Ye
      });
      for (var er = Object.keys(Ye), Sr = 0; Sr < er.length; ++Sr) {
        var Fr = er[Sr];
        Fr in E.default(Nt) || Object.defineProperty(E.default(Nt), Fr, Ge(Ye, Fr));
      }
      return Nt;
    }
    return O.default(Fe, [{
      key: "stopPropagation",
      value: function() {
        h.default(y.default(Fe.prototype), "stopPropagation", this).call(this);
        var Xe = K(this), dt = Xe.original;
        "stopPropagation" in dt && dt.stopPropagation();
      }
    }, {
      key: "stopImmediatePropagation",
      value: function() {
        h.default(y.default(Fe.prototype), "stopImmediatePropagation", this).call(this);
        var Xe = K(this), dt = Xe.original;
        "stopImmediatePropagation" in dt && dt.stopImmediatePropagation();
      }
    }, {
      key: "preventDefault",
      value: function() {
        h.default(y.default(Fe.prototype), "preventDefault", this).call(this);
        var Xe = K(this), dt = Xe.original;
        "preventDefault" in dt && dt.preventDefault();
      }
    }, {
      key: "cancelBubble",
      get: function() {
        return h.default(y.default(Fe.prototype), "cancelBubble", this);
      },
      set: function(Xe) {
        v.default(y.default(Fe.prototype), "cancelBubble", Xe, this, !0);
        var dt = K(this), Nt = dt.original;
        "cancelBubble" in Nt && (Nt.cancelBubble = Xe);
      }
    }, {
      key: "returnValue",
      get: function() {
        return h.default(y.default(Fe.prototype), "returnValue", this);
      },
      set: function(Xe) {
        v.default(y.default(Fe.prototype), "returnValue", Xe, this, !0);
        var dt = K(this), Nt = dt.original;
        "returnValue" in Nt && (Nt.returnValue = Xe);
      }
    }, {
      key: "timeStamp",
      get: function() {
        var Xe = K(this), dt = Xe.original;
        return "timeStamp" in dt ? dt.timeStamp : h.default(y.default(Fe.prototype), "timeStamp", this);
      }
    }]), Fe;
  }(We), ie = /* @__PURE__ */ new WeakMap();
  function K(ht) {
    var Pe = ie.get(ht);
    return B(Pe != null, "'this' is expected an Event object, but got", ht), Pe;
  }
  var Z = /* @__PURE__ */ new WeakMap();
  Z.set(Object.prototype, Ae), typeof V < "u" && typeof V.Event < "u" && Z.set(V.Event.prototype, Ae);
  function Ce(ht) {
    var Pe = Object.getPrototypeOf(ht);
    if (Pe == null)
      return Ae;
    var Fe = Z.get(Pe);
    return Fe == null && (Fe = be(Ce(Pe), Pe), Z.set(Pe, Fe)), Fe;
  }
  function be(ht, Pe) {
    for (var Fe = /* @__PURE__ */ function(dt) {
      m.default(er, dt);
      var Nt = U(er);
      function er() {
        return A.default(this, er), Nt.apply(this, arguments);
      }
      return er;
    }(ht), Ye = Object.keys(Pe), Xe = 0; Xe < Ye.length; ++Xe)
      Object.defineProperty(Fe.prototype, Ye[Xe], Ge(Pe, Ye[Xe]));
    return Fe;
  }
  function Ge(ht, Pe) {
    var Fe = Object.getOwnPropertyDescriptor(ht, Pe);
    return {
      get: function() {
        var Xe = K(this).original, dt = Xe[Pe];
        return typeof dt == "function" ? dt.bind(Xe) : dt;
      },
      set: function(Xe) {
        var dt = K(this).original;
        dt[Pe] = Xe;
      },
      configurable: Fe.configurable,
      enumerable: Fe.enumerable
    };
  }
  function st(ht, Pe, Fe, Ye, Xe, dt) {
    return {
      callback: ht,
      flags: (Pe ? 1 : 0) | (Fe ? 2 : 0) | (Ye ? 4 : 0),
      signal: Xe,
      signalListener: dt
    };
  }
  function wt(ht) {
    ht.flags |= 8;
  }
  function Bt(ht) {
    return (ht.flags & 1) === 1;
  }
  function jt(ht) {
    return (ht.flags & 2) === 2;
  }
  function Xt(ht) {
    return (ht.flags & 4) === 4;
  }
  function Qt(ht) {
    return (ht.flags & 8) === 8;
  }
  function Zr(ht, Pe, Fe) {
    var Ye = ht.callback;
    try {
      typeof Ye == "function" ? Ye.call(Pe, Fe) : typeof Ye.handleEvent == "function" && Ye.handleEvent(Fe);
    } catch (Xe) {
      X(Xe);
    }
  }
  function Jn(ht, Pe, Fe) {
    for (var Ye = ht.listeners, Xe = 0; Xe < Ye.length; ++Xe)
      if (Ye[Xe].callback === Pe && Bt(Ye[Xe]) === Fe)
        return Xe;
    return -1;
  }
  function Ur(ht, Pe, Fe, Ye, Xe, dt) {
    var Nt;
    dt && (Nt = fn.bind(null, ht, Pe, Fe), dt.addEventListener("abort", Nt));
    var er = st(Pe, Fe, Ye, Xe, dt, Nt);
    return ht.cow ? (ht.cow = !1, ht.listeners = [].concat(p.default(ht.listeners), [er])) : ht.listeners.push(er), er;
  }
  function fn(ht, Pe, Fe) {
    var Ye = Jn(ht, Pe, Fe);
    return Ye !== -1 ? gn(ht, Ye) : !1;
  }
  function gn(ht, Pe) {
    var Fe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Ye = ht.listeners[Pe];
    return wt(Ye), Ye.signal && Ye.signal.removeEventListener("abort", Ye.signalListener), ht.cow && !Fe ? (ht.cow = !1, ht.listeners = ht.listeners.filter(function(Xe, dt) {
      return dt !== Pe;
    }), !1) : (ht.listeners.splice(Pe, 1), !0);
  }
  function cr() {
    return /* @__PURE__ */ Object.create(null);
  }
  function Ri(ht, Pe) {
    var Fe;
    return (Fe = ht[Pe]) !== null && Fe !== void 0 ? Fe : ht[Pe] = {
      attrCallback: void 0,
      attrListener: void 0,
      cow: !1,
      listeners: []
    };
  }
  var ai = /* @__PURE__ */ function() {
    function ht() {
      A.default(this, ht), vo.set(this, cr());
    }
    return O.default(ht, [{
      key: "addEventListener",
      value: function(Fe, Ye, Xe) {
        var dt = to(this), Nt = Ui(Fe, Ye, Xe), er = Nt.callback, Sr = Nt.capture, Fr = Nt.once, ro = Nt.passive, Eo = Nt.signal, Ti = Nt.type;
        if (!(er == null || Eo != null && Eo.aborted)) {
          var Ya = Ri(dt, Ti), ws = Jn(Ya, er, Sr);
          if (ws !== -1) {
            Wu(Ya.listeners[ws], ro, Fr, Eo);
            return;
          }
          Ur(Ya, er, Sr, ro, Fr, Eo);
        }
      }
      // Implementation
    }, {
      key: "removeEventListener",
      value: function(Fe, Ye, Xe) {
        var dt = to(this), Nt = Gu(Fe, Ye, Xe), er = Nt.callback, Sr = Nt.capture, Fr = Nt.type, ro = dt[Fr];
        er != null && ro && fn(ro, er, Sr);
      }
      // Implementation
    }, {
      key: "dispatchEvent",
      value: function(Fe) {
        var Ye = to(this)[String(Fe.type)];
        if (Ye == null)
          return !0;
        var Xe = Fe instanceof We ? Fe : Ae.wrap(Fe), dt = we(Xe, "event");
        if (dt.dispatchFlag)
          throw ue("This event has been in dispatching.");
        if (dt.dispatchFlag = !0, dt.target = dt.currentTarget = this, !dt.stopPropagationFlag) {
          var Nt = Ye.cow, er = Ye.listeners;
          Ye.cow = !0;
          for (var Sr = 0; Sr < er.length; ++Sr) {
            var Fr = er[Sr];
            if (!Qt(Fr) && (Xt(Fr) && gn(Ye, Sr, !Nt) && (Sr -= 1), dt.inPassiveListenerFlag = jt(Fr), Zr(Fr, this, Xe), dt.inPassiveListenerFlag = !1, dt.stopImmediatePropagationFlag))
              break;
          }
          Nt || (Ye.cow = !1);
        }
        return dt.target = null, dt.currentTarget = null, dt.stopImmediatePropagationFlag = !1, dt.stopPropagationFlag = !1, dt.dispatchFlag = !1, !dt.canceledFlag;
      }
    }]), ht;
  }(), vo = /* @__PURE__ */ new WeakMap();
  function to(ht) {
    var Pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "this", Fe = vo.get(ht);
    return B(Fe != null, "'%s' must be an object that EventTarget constructor created, but got another one: %o", Pe, ht), Fe;
  }
  function Ui(ht, Pe, Fe) {
    var Ye;
    return Rs(Pe), P.default(Fe) === "object" && Fe !== null ? {
      type: String(ht),
      callback: Pe ?? void 0,
      capture: !!Fe.capture,
      passive: !!Fe.passive,
      once: !!Fe.once,
      signal: (Ye = Fe.signal) !== null && Ye !== void 0 ? Ye : void 0
    } : {
      type: String(ht),
      callback: Pe ?? void 0,
      capture: !!Fe,
      passive: !1,
      once: !1,
      signal: void 0
    };
  }
  function Gu(ht, Pe, Fe) {
    return Rs(Pe), P.default(Fe) === "object" && Fe !== null ? {
      type: String(ht),
      callback: Pe ?? void 0,
      capture: !!Fe.capture
    } : {
      type: String(ht),
      callback: Pe ?? void 0,
      capture: !!Fe
    };
  }
  function Rs(ht) {
    if (!(typeof ht == "function" || P.default(ht) === "object" && ht !== null && typeof ht.handleEvent == "function")) {
      if (ht == null || P.default(ht) === "object") {
        Je.warn(ht);
        return;
      }
      throw new TypeError(x(Je.message, [ht]));
    }
  }
  function Wu(ht, Pe, Fe, Ye) {
    ze.warn(Bt(ht) ? "capture" : "bubble", ht.callback), jt(ht) !== Pe && qe.warn("passive"), Xt(ht) !== Fe && qe.warn("once"), ht.signal !== Ye && qe.warn("signal");
  }
  for (var Ku = Object.getOwnPropertyNames(ai.prototype), Ca = 0; Ca < Ku.length; ++Ca)
    Ku[Ca] !== "constructor" && Object.defineProperty(ai.prototype, Ku[Ca], {
      enumerable: !0
    });
  typeof V < "u" && typeof V.EventTarget < "u" && Object.setPrototypeOf(ai.prototype, V.EventTarget.prototype);
  function Dn(ht, Pe) {
    var Fe, Ye, Xe = to(ht, "target");
    return (Ye = (Fe = Xe[Pe]) === null || Fe === void 0 ? void 0 : Fe.attrCallback) !== null && Ye !== void 0 ? Ye : null;
  }
  function Xu(ht, Pe, Fe) {
    Fe != null && typeof Fe != "function" && Be.warn(Fe), typeof Fe == "function" || P.default(Fe) === "object" && Fe !== null ? Ze(ht, Pe, Fe) : kt(ht, Pe);
  }
  function Ze(ht, Pe, Fe) {
    var Ye = Ri(to(ht, "target"), String(Pe));
    Ye.attrCallback = Fe, Ye.attrListener == null && (Ye.attrListener = Ur(Ye, qt(Ye), !1, !1, !1, void 0));
  }
  function kt(ht, Pe) {
    var Fe = to(ht, "target"), Ye = Fe[String(Pe)];
    Ye && Ye.attrListener && (fn(Ye, Ye.attrListener.callback, !1), Ye.attrCallback = Ye.attrListener = void 0);
  }
  function qt(ht) {
    return function(Pe) {
      var Fe = ht.attrCallback;
      typeof Fe == "function" && Fe.call(this, Pe);
    };
  }
  function sr() {
    for (var ht = /* @__PURE__ */ function(Fe) {
      m.default(Xe, Fe);
      var Ye = U(Xe);
      function Xe() {
        return A.default(this, Xe), Ye.apply(this, arguments);
      }
      return Xe;
    }(ai), Pe = 0; Pe < arguments.length; ++Pe)
      Mr(ht.prototype, Pe < 0 || arguments.length <= Pe ? void 0 : arguments[Pe]);
    return ht;
  }
  function Mr(ht, Pe, Fe) {
    Object.defineProperty(ht, "on".concat(Pe), {
      get: function() {
        return Dn(this, Pe);
      },
      set: function(Xe) {
        Xu(this, Pe, Xe);
      },
      configurable: !0,
      enumerable: !0
    });
  }
  return bu.Event = We, bu.EventTarget = ai, bu.default = ai, bu.defineCustomEventTarget = sr, bu.defineEventAttribute = Mr, bu.getEventAttributeValue = Dn, bu.setErrorHandler = $, bu.setEventAttributeValue = Xu, bu.setWarningHandler = le, bu;
}
var qA = {}, YA = {}, xre;
function Pmr() {
  if (xre) return YA;
  xre = 1;
  var e = Zh;
  Object.defineProperty(YA, "__esModule", {
    value: !0
  }), YA.default = i;
  var t = e(jy());
  function r(o, a) {
    var u = Object.keys(o);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(o);
      a && (s = s.filter(function(c) {
        return Object.getOwnPropertyDescriptor(o, c).enumerable;
      })), u.push.apply(u, s);
    }
    return u;
  }
  function n(o) {
    for (var a = 1; a < arguments.length; a++) {
      var u = arguments[a] != null ? arguments[a] : {};
      a % 2 ? r(Object(u), !0).forEach(function(s) {
        (0, t.default)(o, s, u[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : r(Object(u)).forEach(function(s) {
        Object.defineProperty(o, s, Object.getOwnPropertyDescriptor(u, s));
      });
    }
    return o;
  }
  function i(o, a) {
    var u = n(n(n({}, [].reduce.call(o, function(s, c, l) {
      return s[l] = c, s;
    }, {})), a), {}, (0, t.default)({
      length: o.length
    }, Symbol.iterator, function() {
      return [].slice.call(u)[Symbol.iterator]();
    }));
    return u;
  }
  return YA;
}
var Kv = {}, sN = {}, cN = {}, Xv = {}, lN = {}, pi = {}, fN = {}, x0 = {}, Nre;
function gd() {
  if (Nre) return x0;
  Nre = 1, Object.defineProperty(x0, "__esModule", { value: !0 }), x0.createNoDashGuid = x0.createGuid = void 0;
  var e = B_e, t = function() {
    return e.v4();
  };
  x0.createGuid = t;
  var r = function() {
    return t().replace(new RegExp("-", "g"), "").toUpperCase();
  };
  return x0.createNoDashGuid = r, x0;
}
var Lre;
function zy() {
  return Lre || (Lre = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PlatformEvent = e.EventType = void 0;
    var t = gd();
    (function(n) {
      n[n.Debug = 0] = "Debug", n[n.Info = 1] = "Info", n[n.Warning = 2] = "Warning", n[n.Error = 3] = "Error";
    })(e.EventType || (e.EventType = {}));
    var r = (
      /** @class */
      function() {
        function n(i, o) {
          this.privName = i, this.privEventId = t.createNoDashGuid(), this.privEventTime = (/* @__PURE__ */ new Date()).toISOString(), this.privEventType = o, this.privMetadata = {};
        }
        return Object.defineProperty(n.prototype, "name", {
          get: function() {
            return this.privName;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(n.prototype, "eventId", {
          get: function() {
            return this.privEventId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(n.prototype, "eventTime", {
          get: function() {
            return this.privEventTime;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(n.prototype, "eventType", {
          get: function() {
            return this.privEventType;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(n.prototype, "metadata", {
          get: function() {
            return this.privMetadata;
          },
          enumerable: !1,
          configurable: !0
        }), n;
      }()
    );
    e.PlatformEvent = r;
  }(fN)), fN;
}
var Bre;
function Dmr() {
  if (Bre) return pi;
  Bre = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var d = function(p, v) {
      return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, E) {
        h.__proto__ = E;
      } || function(h, E) {
        for (var m in E) E.hasOwnProperty(m) && (h[m] = E[m]);
      }, d(p, v);
    };
    return function(p, v) {
      d(p, v);
      function h() {
        this.constructor = p;
      }
      p.prototype = v === null ? Object.create(v) : (h.prototype = v.prototype, new h());
    };
  }();
  Object.defineProperty(pi, "__esModule", { value: !0 }), pi.AudioStreamNodeErrorEvent = pi.AudioStreamNodeDetachedEvent = pi.AudioStreamNodeAttachedEvent = pi.AudioStreamNodeAttachingEvent = pi.AudioStreamNodeEvent = pi.AudioSourceErrorEvent = pi.AudioSourceOffEvent = pi.AudioSourceReadyEvent = pi.AudioSourceInitializingEvent = pi.AudioSourceEvent = void 0;
  var t = zy(), r = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h, E) {
        E === void 0 && (E = t.EventType.Info);
        var m = d.call(this, v, E) || this;
        return m.privAudioSourceId = h, m;
      }
      return Object.defineProperty(p.prototype, "audioSourceId", {
        get: function() {
          return this.privAudioSourceId;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    }(t.PlatformEvent)
  );
  pi.AudioSourceEvent = r;
  var n = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v) {
        return d.call(this, "AudioSourceInitializingEvent", v) || this;
      }
      return p;
    }(r)
  );
  pi.AudioSourceInitializingEvent = n;
  var i = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v) {
        return d.call(this, "AudioSourceReadyEvent", v) || this;
      }
      return p;
    }(r)
  );
  pi.AudioSourceReadyEvent = i;
  var o = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v) {
        return d.call(this, "AudioSourceOffEvent", v) || this;
      }
      return p;
    }(r)
  );
  pi.AudioSourceOffEvent = o;
  var a = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h) {
        var E = d.call(this, "AudioSourceErrorEvent", v, t.EventType.Error) || this;
        return E.privError = h, E;
      }
      return Object.defineProperty(p.prototype, "error", {
        get: function() {
          return this.privError;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    }(r)
  );
  pi.AudioSourceErrorEvent = a;
  var u = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h, E) {
        var m = d.call(this, v, h) || this;
        return m.privAudioNodeId = E, m;
      }
      return Object.defineProperty(p.prototype, "audioNodeId", {
        get: function() {
          return this.privAudioNodeId;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    }(r)
  );
  pi.AudioStreamNodeEvent = u;
  var s = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h) {
        return d.call(this, "AudioStreamNodeAttachingEvent", v, h) || this;
      }
      return p;
    }(u)
  );
  pi.AudioStreamNodeAttachingEvent = s;
  var c = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h) {
        return d.call(this, "AudioStreamNodeAttachedEvent", v, h) || this;
      }
      return p;
    }(u)
  );
  pi.AudioStreamNodeAttachedEvent = c;
  var l = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h) {
        return d.call(this, "AudioStreamNodeDetachedEvent", v, h) || this;
      }
      return p;
    }(u)
  );
  pi.AudioStreamNodeDetachedEvent = l;
  var f = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h, E) {
        var m = d.call(this, "AudioStreamNodeErrorEvent", v, h) || this;
        return m.privError = E, m;
      }
      return Object.defineProperty(p.prototype, "error", {
        get: function() {
          return this.privError;
        },
        enumerable: !1,
        configurable: !0
      }), p;
    }(u)
  );
  return pi.AudioStreamNodeErrorEvent = f, pi;
}
var Di = {}, kre;
function xmr() {
  if (kre) return Di;
  kre = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var f = function(d, p) {
      return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, h) {
        v.__proto__ = h;
      } || function(v, h) {
        for (var E in h) h.hasOwnProperty(E) && (v[E] = h[E]);
      }, f(d, p);
    };
    return function(d, p) {
      f(d, p);
      function v() {
        this.constructor = d;
      }
      d.prototype = p === null ? Object.create(p) : (v.prototype = p.prototype, new v());
    };
  }();
  Object.defineProperty(Di, "__esModule", { value: !0 }), Di.ConnectionMessageSentEvent = Di.ConnectionMessageReceivedEvent = Di.ConnectionEstablishErrorEvent = Di.ConnectionErrorEvent = Di.ConnectionClosedEvent = Di.ConnectionEstablishedEvent = Di.ConnectionStartEvent = Di.ConnectionEvent = Di.ServiceEvent = void 0;
  var t = zy(), r = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        h === void 0 && (h = t.EventType.Info);
        var E = f.call(this, p, h) || this;
        return E.privJsonResult = v, E;
      }
      return Object.defineProperty(d.prototype, "jsonString", {
        get: function() {
          return this.privJsonResult;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(t.PlatformEvent)
  );
  Di.ServiceEvent = r;
  var n = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        h === void 0 && (h = t.EventType.Info);
        var E = f.call(this, p, h) || this;
        return E.privConnectionId = v, E;
      }
      return Object.defineProperty(d.prototype, "connectionId", {
        get: function() {
          return this.privConnectionId;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(t.PlatformEvent)
  );
  Di.ConnectionEvent = n;
  var i = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionStartEvent", p) || this;
        return E.privUri = v, E.privHeaders = h, E;
      }
      return Object.defineProperty(d.prototype, "uri", {
        get: function() {
          return this.privUri;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "headers", {
        get: function() {
          return this.privHeaders;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  Di.ConnectionStartEvent = i;
  var o = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v) {
        return f.call(this, "ConnectionEstablishedEvent", p) || this;
      }
      return d;
    }(n)
  );
  Di.ConnectionEstablishedEvent = o;
  var a = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionClosedEvent", p, t.EventType.Debug) || this;
        return E.privReason = h, E.privStatusCode = v, E;
      }
      return Object.defineProperty(d.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "statusCode", {
        get: function() {
          return this.privStatusCode;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  Di.ConnectionClosedEvent = a;
  var u = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionErrorEvent", p, t.EventType.Debug) || this;
        return E.privMessage = v, E.privType = h, E;
      }
      return Object.defineProperty(d.prototype, "message", {
        get: function() {
          return this.privMessage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "type", {
        get: function() {
          return this.privType;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  Di.ConnectionErrorEvent = u;
  var s = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionEstablishErrorEvent", p, t.EventType.Error) || this;
        return E.privStatusCode = v, E.privReason = h, E;
      }
      return Object.defineProperty(d.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "statusCode", {
        get: function() {
          return this.privStatusCode;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  Di.ConnectionEstablishErrorEvent = s;
  var c = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionMessageReceivedEvent", p) || this;
        return E.privNetworkReceivedTime = v, E.privMessage = h, E;
      }
      return Object.defineProperty(d.prototype, "networkReceivedTime", {
        get: function() {
          return this.privNetworkReceivedTime;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "message", {
        get: function() {
          return this.privMessage;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  Di.ConnectionMessageReceivedEvent = c;
  var l = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p, v, h) {
        var E = f.call(this, "ConnectionMessageSentEvent", p) || this;
        return E.privNetworkSentTime = v, E.privMessage = h, E;
      }
      return Object.defineProperty(d.prototype, "networkSentTime", {
        get: function() {
          return this.privNetworkSentTime;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "message", {
        get: function() {
          return this.privMessage;
        },
        enumerable: !1,
        configurable: !0
      }), d;
    }(n)
  );
  return Di.ConnectionMessageSentEvent = l, Di;
}
var dN = {}, xc = {}, Mre;
function hc() {
  if (Mre) return xc;
  Mre = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(xc, "__esModule", { value: !0 }), xc.ObjectDisposedError = xc.InvalidOperationError = xc.ArgumentNullError = void 0;
  var t = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a) {
        var u = i.call(this, a) || this;
        return u.name = "ArgumentNull", u.message = a, u;
      }
      return o;
    }(Error)
  );
  xc.ArgumentNullError = t;
  var r = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a) {
        var u = i.call(this, a) || this;
        return u.name = "InvalidOperation", u.message = a, u;
      }
      return o;
    }(Error)
  );
  xc.InvalidOperationError = r;
  var n = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a, u) {
        var s = i.call(this, u) || this;
        return s.name = a + "ObjectDisposed", s.message = u, s;
      }
      return o;
    }(Error)
  );
  return xc.ObjectDisposedError = n, xc;
}
var Fre;
function JAe() {
  return Fre || (Fre = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ConnectionMessage = e.MessageType = void 0;
    var t = hc(), r = gd(), n;
    (function(o) {
      o[o.Text = 0] = "Text", o[o.Binary = 1] = "Binary";
    })(n = e.MessageType || (e.MessageType = {}));
    var i = (
      /** @class */
      function() {
        function o(a, u, s, c) {
          if (this.privBody = null, a === n.Text && u && typeof u != "string")
            throw new t.InvalidOperationError("Payload must be a string");
          if (a === n.Binary && u && !(u instanceof ArrayBuffer))
            throw new t.InvalidOperationError("Payload must be ArrayBuffer");
          switch (this.privMessageType = a, this.privBody = u, this.privHeaders = s || {}, this.privId = c || r.createNoDashGuid(), this.messageType) {
            case n.Binary:
              this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
              break;
            case n.Text:
              this.privSize = this.textBody.length;
          }
        }
        return Object.defineProperty(o.prototype, "messageType", {
          get: function() {
            return this.privMessageType;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(o.prototype, "headers", {
          get: function() {
            return this.privHeaders;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(o.prototype, "body", {
          get: function() {
            return this.privBody;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(o.prototype, "textBody", {
          get: function() {
            if (this.privMessageType === n.Binary)
              throw new t.InvalidOperationError("Not supported for binary message");
            return this.privBody;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(o.prototype, "binaryBody", {
          get: function() {
            if (this.privMessageType === n.Text)
              throw new t.InvalidOperationError("Not supported for text message");
            return this.privBody;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(o.prototype, "id", {
          get: function() {
            return this.privId;
          },
          enumerable: !1,
          configurable: !0
        }), o;
      }()
    );
    e.ConnectionMessage = i;
  }(dN)), dN;
}
var Jv = {}, Hre;
function Nmr() {
  if (Hre) return Jv;
  Hre = 1, Object.defineProperty(Jv, "__esModule", { value: !0 }), Jv.ConnectionOpenResponse = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privStatusCode = r, this.privReason = n;
      }
      return Object.defineProperty(t.prototype, "statusCode", {
        get: function() {
          return this.privStatusCode;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Jv.ConnectionOpenResponse = e, Jv;
}
var N0 = {}, $re;
function ZAe() {
  if ($re) return N0;
  $re = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(N0, "__esModule", { value: !0 }), N0.SendingAgentContextMessageEvent = N0.DialogEvent = void 0;
  var t = zy(), r = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a, u) {
        return u === void 0 && (u = t.EventType.Info), i.call(this, a, u) || this;
      }
      return o;
    }(t.PlatformEvent)
  );
  N0.DialogEvent = r;
  var n = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a) {
        var u = i.call(this, "SendingAgentContextMessageEvent") || this;
        return u.privAgentConfig = a, u;
      }
      return Object.defineProperty(o.prototype, "agentConfig", {
        get: function() {
          return this.privAgentConfig;
        },
        enumerable: !1,
        configurable: !0
      }), o;
    }(r)
  );
  return N0.SendingAgentContextMessageEvent = n, N0;
}
var Zv = {}, Qv = {}, Ure;
function QAe() {
  if (Ure) return Qv;
  Ure = 1, Object.defineProperty(Qv, "__esModule", { value: !0 }), Qv.EventSource = void 0;
  var e = hc(), t = gd(), r = (
    /** @class */
    function() {
      function n(i) {
        var o = this;
        this.privEventListeners = {}, this.privIsDisposed = !1, this.onEvent = function(a) {
          if (o.isDisposed())
            throw new e.ObjectDisposedError("EventSource");
          if (o.metadata)
            for (var u in o.metadata)
              u && a.metadata && (a.metadata[u] || (a.metadata[u] = o.metadata[u]));
          for (var s in o.privEventListeners)
            s && o.privEventListeners[s] && o.privEventListeners[s](a);
        }, this.attach = function(a) {
          var u = t.createNoDashGuid();
          return o.privEventListeners[u] = a, {
            detach: function() {
              return delete o.privEventListeners[u], Promise.resolve();
            }
          };
        }, this.attachListener = function(a) {
          return o.attach(a.onEvent);
        }, this.isDisposed = function() {
          return o.privIsDisposed;
        }, this.dispose = function() {
          o.privEventListeners = null, o.privIsDisposed = !0;
        }, this.privMetadata = i;
      }
      return Object.defineProperty(n.prototype, "metadata", {
        get: function() {
          return this.privMetadata;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return Qv.EventSource = r, Qv;
}
var Vre;
function Lmr() {
  if (Vre) return Zv;
  Vre = 1, Object.defineProperty(Zv, "__esModule", { value: !0 }), Zv.Events = void 0;
  var e = hc(), t = QAe(), r = (
    /** @class */
    function() {
      function n() {
      }
      return Object.defineProperty(n, "instance", {
        get: function() {
          return n.privInstance;
        },
        enumerable: !1,
        configurable: !0
      }), n.privInstance = new t.EventSource(), n.setEventSource = function(i) {
        if (!i)
          throw new e.ArgumentNullError("eventSource");
        n.privInstance = i;
      }, n;
    }()
  );
  return Zv.Events = r, Zv;
}
var pN = {}, jre;
function Bmr() {
  return jre || (jre = 1, Object.defineProperty(pN, "__esModule", { value: !0 })), pN;
}
var hN = {}, zre;
function kmr() {
  return zre || (zre = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ConnectionState = void 0, function(t) {
      t[t.None = 0] = "None", t[t.Connected = 1] = "Connected", t[t.Connecting = 2] = "Connecting", t[t.Disconnected = 3] = "Disconnected";
    }(e.ConnectionState || (e.ConnectionState = {}));
  }(hN)), hN;
}
var vN = {}, qre;
function Mmr() {
  return qre || (qre = 1, Object.defineProperty(vN, "__esModule", { value: !0 })), vN;
}
var EN = {}, Yre;
function Fmr() {
  return Yre || (Yre = 1, Object.defineProperty(EN, "__esModule", { value: !0 })), EN;
}
var mN = {}, Gre;
function Hmr() {
  return Gre || (Gre = 1, Object.defineProperty(mN, "__esModule", { value: !0 })), mN;
}
var gN = {}, Wre;
function $mr() {
  return Wre || (Wre = 1, Object.defineProperty(gN, "__esModule", { value: !0 })), gN;
}
var TN = {}, Kre;
function Umr() {
  return Kre || (Kre = 1, Object.defineProperty(TN, "__esModule", { value: !0 })), TN;
}
var yN = {}, Xre;
function Vmr() {
  return Xre || (Xre = 1, Object.defineProperty(yN, "__esModule", { value: !0 })), yN;
}
var _N = {}, Jre;
function jmr() {
  return Jre || (Jre = 1, Object.defineProperty(_N, "__esModule", { value: !0 })), _N;
}
var eE = {}, Zre;
function e4e() {
  if (Zre) return eE;
  Zre = 1, Object.defineProperty(eE, "__esModule", { value: !0 }), eE.List = void 0;
  var e = hc(), t = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(n) {
        var i = this;
        if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.get = function(s) {
          return i.throwIfDisposed(), i.privList[s];
        }, this.first = function() {
          return i.get(0);
        }, this.last = function() {
          return i.get(i.length() - 1);
        }, this.add = function(s) {
          i.throwIfDisposed(), i.insertAt(i.privList.length, s);
        }, this.insertAt = function(s, c) {
          i.throwIfDisposed(), s === 0 ? i.privList.unshift(c) : s === i.privList.length ? i.privList.push(c) : i.privList.splice(s, 0, c), i.triggerSubscriptions(i.privAddSubscriptions);
        }, this.removeFirst = function() {
          return i.throwIfDisposed(), i.removeAt(0);
        }, this.removeLast = function() {
          return i.throwIfDisposed(), i.removeAt(i.length() - 1);
        }, this.removeAt = function(s) {
          return i.throwIfDisposed(), i.remove(s, 1)[0];
        }, this.remove = function(s, c) {
          i.throwIfDisposed();
          var l = i.privList.splice(s, c);
          return i.triggerSubscriptions(i.privRemoveSubscriptions), l;
        }, this.clear = function() {
          i.throwIfDisposed(), i.remove(0, i.length());
        }, this.length = function() {
          return i.throwIfDisposed(), i.privList.length;
        }, this.onAdded = function(s) {
          i.throwIfDisposed();
          var c = i.privSubscriptionIdCounter++;
          return i.privAddSubscriptions[c] = s, {
            detach: function() {
              return delete i.privAddSubscriptions[c], Promise.resolve();
            }
          };
        }, this.onRemoved = function(s) {
          i.throwIfDisposed();
          var c = i.privSubscriptionIdCounter++;
          return i.privRemoveSubscriptions[c] = s, {
            detach: function() {
              return delete i.privRemoveSubscriptions[c], Promise.resolve();
            }
          };
        }, this.onDisposed = function(s) {
          i.throwIfDisposed();
          var c = i.privSubscriptionIdCounter++;
          return i.privDisposedSubscriptions[c] = s, {
            detach: function() {
              return delete i.privDisposedSubscriptions[c], Promise.resolve();
            }
          };
        }, this.join = function(s) {
          return i.throwIfDisposed(), i.privList.join(s);
        }, this.toArray = function() {
          var s = Array();
          return i.privList.forEach(function(c) {
            s.push(c);
          }), s;
        }, this.any = function(s) {
          return i.throwIfDisposed(), s ? i.where(s).length() > 0 : i.length() > 0;
        }, this.all = function(s) {
          return i.throwIfDisposed(), i.where(s).length() === i.length();
        }, this.forEach = function(s) {
          i.throwIfDisposed();
          for (var c = 0; c < i.length(); c++)
            s(i.privList[c], c);
        }, this.select = function(s) {
          i.throwIfDisposed();
          for (var c = [], l = 0; l < i.privList.length; l++)
            c.push(s(i.privList[l], l));
          return new r(c);
        }, this.where = function(s) {
          i.throwIfDisposed();
          for (var c = new r(), l = 0; l < i.privList.length; l++)
            s(i.privList[l], l) && c.add(i.privList[l]);
          return c;
        }, this.orderBy = function(s) {
          i.throwIfDisposed();
          var c = i.toArray(), l = c.sort(s);
          return new r(l);
        }, this.orderByDesc = function(s) {
          return i.throwIfDisposed(), i.orderBy(function(c, l) {
            return s(l, c);
          });
        }, this.clone = function() {
          return i.throwIfDisposed(), new r(i.toArray());
        }, this.concat = function(s) {
          return i.throwIfDisposed(), new r(i.privList.concat(s.toArray()));
        }, this.concatArray = function(s) {
          return i.throwIfDisposed(), new r(i.privList.concat(s));
        }, this.isDisposed = function() {
          return i.privList == null;
        }, this.dispose = function(s) {
          i.isDisposed() || (i.privDisposeReason = s, i.privList = null, i.privAddSubscriptions = null, i.privRemoveSubscriptions = null, i.triggerSubscriptions(i.privDisposedSubscriptions));
        }, this.throwIfDisposed = function() {
          if (i.isDisposed())
            throw new e.ObjectDisposedError("List", i.privDisposeReason);
        }, this.triggerSubscriptions = function(s) {
          if (s)
            for (var c in s)
              c && s[c]();
        }, this.privList = [], n)
          for (var o = 0, a = n; o < a.length; o++) {
            var u = a[o];
            this.privList.push(u);
          }
      }
      return r;
    }()
  );
  return eE.List = t, eE;
}
var AN = {}, Qre;
function xH() {
  return Qre || (Qre = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.marshalPromiseToCallbacks = e.Sink = e.Deferred = e.PromiseResultEventSource = e.PromiseResult = e.PromiseState = void 0;
    var t;
    (function(u) {
      u[u.None = 0] = "None", u[u.Resolved = 1] = "Resolved", u[u.Rejected = 2] = "Rejected";
    })(t = e.PromiseState || (e.PromiseState = {}));
    var r = (
      /** @class */
      function() {
        function u(s) {
          var c = this;
          this.throwIfError = function() {
            if (c.isError)
              throw c.error;
          }, s.on(function(l) {
            c.privIsCompleted || (c.privIsCompleted = !0, c.privIsError = !1, c.privResult = l);
          }, function(l) {
            c.privIsCompleted || (c.privIsCompleted = !0, c.privIsError = !0, c.privError = l);
          });
        }
        return Object.defineProperty(u.prototype, "isCompleted", {
          get: function() {
            return this.privIsCompleted;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "isError", {
          get: function() {
            return this.privIsError;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "error", {
          get: function() {
            return this.privError;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "result", {
          get: function() {
            return this.privResult;
          },
          enumerable: !1,
          configurable: !0
        }), u;
      }()
    );
    e.PromiseResult = r;
    var n = (
      /** @class */
      /* @__PURE__ */ function() {
        function u() {
          var s = this;
          this.setResult = function(c) {
            s.privOnSetResult(c);
          }, this.setError = function(c) {
            s.privOnSetError(c);
          }, this.on = function(c, l) {
            s.privOnSetResult = c, s.privOnSetError = l;
          };
        }
        return u;
      }()
    );
    e.PromiseResultEventSource = n;
    var i = (
      /** @class */
      function() {
        function u() {
          var s = this;
          this.resolve = function(c) {
            return s.privResolve(c), s;
          }, this.reject = function(c) {
            return s.privReject(c), s;
          }, this.privPromise = new Promise(function(c, l) {
            s.privResolve = c, s.privReject = l;
          });
        }
        return Object.defineProperty(u.prototype, "promise", {
          get: function() {
            return this.privPromise;
          },
          enumerable: !1,
          configurable: !0
        }), u;
      }()
    );
    e.Deferred = i;
    var o = (
      /** @class */
      function() {
        function u() {
          var s = this;
          this.privState = t.None, this.privPromiseResult = null, this.privPromiseResultEvents = null, this.privSuccessHandlers = [], this.privErrorHandlers = [], this.resolve = function(c) {
            if (s.privState !== t.None)
              throw new Error("'Cannot resolve a completed promise'");
            s.privState = t.Resolved, s.privPromiseResultEvents.setResult(c);
            for (var l = 0; l < s.privSuccessHandlers.length; l++)
              s.executeSuccessCallback(c, s.privSuccessHandlers[l], s.privErrorHandlers[l]);
            s.detachHandlers();
          }, this.reject = function(c) {
            if (s.privState !== t.None)
              throw new Error("'Cannot reject a completed promise'");
            s.privState = t.Rejected, s.privPromiseResultEvents.setError(c);
            for (var l = 0, f = s.privErrorHandlers; l < f.length; l++) {
              var d = f[l];
              s.executeErrorCallback(c, d);
            }
            s.detachHandlers();
          }, this.on = function(c, l) {
            c == null && (c = function(f) {
            }), s.privState === t.None ? (s.privSuccessHandlers.push(c), s.privErrorHandlers.push(l)) : (s.privState === t.Resolved ? s.executeSuccessCallback(s.privPromiseResult.result, c, l) : s.privState === t.Rejected && s.executeErrorCallback(s.privPromiseResult.error, l), s.detachHandlers());
          }, this.executeSuccessCallback = function(c, l, f) {
            try {
              l(c);
            } catch (d) {
              s.executeErrorCallback("'Unhandled callback error: " + d + "'", f);
            }
          }, this.executeErrorCallback = function(c, l) {
            if (l)
              try {
                l(c);
              } catch (f) {
                throw new Error("'Unhandled callback error: " + f + ". InnerError: " + c + "'");
              }
            else
              throw new Error("'Unhandled error: " + c + "'");
          }, this.detachHandlers = function() {
            s.privErrorHandlers = [], s.privSuccessHandlers = [];
          }, this.privPromiseResultEvents = new n(), this.privPromiseResult = new r(this.privPromiseResultEvents);
        }
        return Object.defineProperty(u.prototype, "state", {
          get: function() {
            return this.privState;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "result", {
          get: function() {
            return this.privPromiseResult;
          },
          enumerable: !1,
          configurable: !0
        }), u;
      }()
    );
    e.Sink = o;
    function a(u, s, c) {
      u.then(function(l) {
        try {
          s && s(l);
        } catch (d) {
          if (c)
            try {
              if (d instanceof Error) {
                var f = d;
                c(f.name + ": " + f.message);
              } else
                c(d);
            } catch {
            }
        }
      }, function(l) {
        if (c)
          try {
            if (l instanceof Error) {
              var f = l;
              c(f.name + ": " + f.message);
            } else
              c(l);
          } catch {
          }
      });
    }
    e.marshalPromiseToCallbacks = a;
  }(AN)), AN;
}
var tE = {}, ene;
function t4e() {
  if (ene) return tE;
  ene = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(tE, "__esModule", { value: !0 }), tE.Queue = void 0;
  var r = hc(), n = e4e(), i = xH(), o;
  (function(u) {
    u[u.Dequeue = 0] = "Dequeue", u[u.Peek = 1] = "Peek";
  })(o || (o = {}));
  var a = (
    /** @class */
    function() {
      function u(s) {
        var c = this;
        this.privPromiseStore = new n.List(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.enqueue = function(l) {
          c.throwIfDispose(), c.enqueueFromPromise(new Promise(function(f, d) {
            f(l);
          }));
        }, this.enqueueFromPromise = function(l) {
          c.throwIfDispose(), l.then(function(f) {
            c.privList.add(f);
          }, function(f) {
          });
        }, this.dequeue = function() {
          c.throwIfDispose();
          var l = new i.Deferred();
          return c.privSubscribers && (c.privSubscribers.add({ deferral: l, type: o.Dequeue }), c.drain()), l.promise;
        }, this.peek = function() {
          c.throwIfDispose();
          var l = new i.Deferred(), f = c.privSubscribers;
          return f && (c.privSubscribers.add({ deferral: l, type: o.Peek }), c.drain()), l.promise;
        }, this.length = function() {
          return c.throwIfDispose(), c.privList.length();
        }, this.isDisposed = function() {
          return c.privSubscribers == null;
        }, this.drain = function() {
          if (!c.privIsDrainInProgress && !c.privIsDisposing) {
            c.privIsDrainInProgress = !0;
            var l = c.privSubscribers, f = c.privList;
            if (l && f) {
              for (; f.length() > 0 && l.length() > 0 && !c.privIsDisposing; ) {
                var d = l.removeFirst();
                if (d.type === o.Peek)
                  d.deferral.resolve(f.first());
                else {
                  var p = f.removeFirst();
                  d.deferral.resolve(p);
                }
              }
              c.privSubscribers === l && (c.privSubscribers = l), c.privList === f && (c.privList = f);
            }
            c.privIsDrainInProgress = !1;
          }
        }, this.throwIfDispose = function() {
          if (c.isDisposed())
            throw c.privDisposeReason ? new r.InvalidOperationError(c.privDisposeReason) : new r.ObjectDisposedError("Queue");
          if (c.privIsDisposing)
            throw new r.InvalidOperationError("Queue disposing");
        }, this.privList = s || new n.List(), this.privDetachables = [], this.privSubscribers = new n.List(), this.privDetachables.push(this.privList.onAdded(this.drain));
      }
      return u.prototype.drainAndDispose = function(s, c) {
        return e(this, void 0, void 0, function() {
          var l, f, d, p, v, h, E = this;
          return t(this, function(m) {
            switch (m.label) {
              case 0:
                if (!(!this.isDisposed() && !this.privIsDisposing)) return [3, 5];
                if (this.privDisposeReason = c, this.privIsDisposing = !0, l = this.privSubscribers, l) {
                  for (; l.length() > 0; )
                    f = l.removeFirst(), f.deferral.resolve(void 0);
                  this.privSubscribers === l && (this.privSubscribers = l);
                }
                d = 0, p = this.privDetachables, m.label = 1;
              case 1:
                return d < p.length ? (v = p[d], [4, v.detach()]) : [3, 4];
              case 2:
                m.sent(), m.label = 3;
              case 3:
                return d++, [3, 1];
              case 4:
                if (this.privPromiseStore.length() > 0 && s)
                  return h = [], this.privPromiseStore.toArray().forEach(function(g) {
                    h.push(g);
                  }), [2, Promise.all(h).finally(function() {
                    E.privSubscribers = null, E.privList.forEach(function(g, y) {
                      s(g);
                    }), E.privList = null;
                  }).then()];
                this.privSubscribers = null, this.privList = null, m.label = 5;
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.dispose = function(s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, this.drainAndDispose(null, s)];
              case 1:
                return c.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u;
    }()
  );
  return tE.Queue = a, tE;
}
var rE = {}, tne;
function zmr() {
  if (tne) return rE;
  tne = 1, Object.defineProperty(rE, "__esModule", { value: !0 }), rE.RawWebsocketMessage = void 0;
  var e = JAe(), t = hc(), r = gd(), n = (
    /** @class */
    function() {
      function i(o, a, u) {
        if (this.privPayload = null, !a)
          throw new t.ArgumentNullError("payload");
        if (o === e.MessageType.Binary && a.__proto__.constructor.name !== "ArrayBuffer")
          throw new t.InvalidOperationError("Payload must be ArrayBuffer");
        if (o === e.MessageType.Text && typeof a != "string")
          throw new t.InvalidOperationError("Payload must be a string");
        this.privMessageType = o, this.privPayload = a, this.privId = u || r.createNoDashGuid();
      }
      return Object.defineProperty(i.prototype, "messageType", {
        get: function() {
          return this.privMessageType;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "payload", {
        get: function() {
          return this.privPayload;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "textContent", {
        get: function() {
          if (this.privMessageType === e.MessageType.Binary)
            throw new t.InvalidOperationError("Not supported for binary message");
          return this.privPayload;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "binaryContent", {
        get: function() {
          if (this.privMessageType === e.MessageType.Text)
            throw new t.InvalidOperationError("Not supported for text message");
          return this.privPayload;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "id", {
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }()
  );
  return rE.RawWebsocketMessage = n, rE;
}
var nE = {}, rne;
function qmr() {
  if (rne) return nE;
  rne = 1, Object.defineProperty(nE, "__esModule", { value: !0 }), nE.RiffPcmEncoder = void 0;
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t(r, n) {
        var i = this;
        this.encode = function(o) {
          var a = i.downSampleAudioFrame(o, i.privActualSampleRate, i.privDesiredSampleRate);
          if (!a)
            return null;
          var u = a.length * 2, s = new ArrayBuffer(u), c = new DataView(s);
          return i.floatTo16BitPCM(c, 0, a), s;
        }, this.setString = function(o, a, u) {
          for (var s = 0; s < u.length; s++)
            o.setUint8(a + s, u.charCodeAt(s));
        }, this.floatTo16BitPCM = function(o, a, u) {
          for (var s = 0; s < u.length; s++, a += 2) {
            var c = Math.max(-1, Math.min(1, u[s]));
            o.setInt16(a, c < 0 ? c * 32768 : c * 32767, !0);
          }
        }, this.downSampleAudioFrame = function(o, a, u) {
          if (u === a || u > a)
            return o;
          for (var s = a / u, c = Math.round(o.length / s), l = new Float32Array(c), f = 0, d = 0; d < c; ) {
            for (var p = Math.round((d + 1) * s), v = 0, h = 0; f < p && f < o.length; )
              v += o[f++], h++;
            l[d++] = v / h;
          }
          return l;
        }, this.privActualSampleRate = r, this.privDesiredSampleRate = n;
      }
      return t;
    }()
  );
  return nE.RiffPcmEncoder = e, nE;
}
var iE = {}, nne;
function Ymr() {
  if (nne) return iE;
  nne = 1;
  var e = fe && fe.__awaiter || function(a, u, s, c) {
    function l(f) {
      return f instanceof s ? f : new s(function(d) {
        d(f);
      });
    }
    return new (s || (s = Promise))(function(f, d) {
      function p(E) {
        try {
          h(c.next(E));
        } catch (m) {
          d(m);
        }
      }
      function v(E) {
        try {
          h(c.throw(E));
        } catch (m) {
          d(m);
        }
      }
      function h(E) {
        E.done ? f(E.value) : l(E.value).then(p, v);
      }
      h((c = c.apply(a, u || [])).next());
    });
  }, t = fe && fe.__generator || function(a, u) {
    var s = { label: 0, sent: function() {
      if (f[0] & 1) throw f[1];
      return f[1];
    }, trys: [], ops: [] }, c, l, f, d;
    return d = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
      return this;
    }), d;
    function p(h) {
      return function(E) {
        return v([h, E]);
      };
    }
    function v(h) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; s; ) try {
        if (c = 1, l && (f = h[0] & 2 ? l.return : h[0] ? l.throw || ((f = l.return) && f.call(l), 0) : l.next) && !(f = f.call(l, h[1])).done) return f;
        switch (l = 0, f && (h = [h[0] & 2, f.value]), h[0]) {
          case 0:
          case 1:
            f = h;
            break;
          case 4:
            return s.label++, { value: h[1], done: !1 };
          case 5:
            s.label++, l = h[1], h = [0];
            continue;
          case 7:
            h = s.ops.pop(), s.trys.pop();
            continue;
          default:
            if (f = s.trys, !(f = f.length > 0 && f[f.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              s = 0;
              continue;
            }
            if (h[0] === 3 && (!f || h[1] > f[0] && h[1] < f[3])) {
              s.label = h[1];
              break;
            }
            if (h[0] === 6 && s.label < f[1]) {
              s.label = f[1], f = h;
              break;
            }
            if (f && s.label < f[2]) {
              s.label = f[2], s.ops.push(h);
              break;
            }
            f[2] && s.ops.pop(), s.trys.pop();
            continue;
        }
        h = u.call(a, s);
      } catch (E) {
        h = [6, E], l = 0;
      } finally {
        c = f = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(iE, "__esModule", { value: !0 }), iE.Stream = void 0;
  var r = hc(), n = gd(), i = t4e(), o = (
    /** @class */
    function() {
      function a(u) {
        var s = this;
        this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.read = function() {
          if (s.privIsReadEnded)
            throw new r.InvalidOperationError("Stream read has already finished");
          return s.privReaderQueue.dequeue().then(function(c) {
            return e(s, void 0, void 0, function() {
              return t(this, function(l) {
                switch (l.label) {
                  case 0:
                    return c === void 0 || c.isEnd ? [4, this.privReaderQueue.dispose("End of stream reached")] : [3, 2];
                  case 1:
                    l.sent(), l.label = 2;
                  case 2:
                    return [2, c];
                }
              });
            });
          });
        }, this.readEnded = function() {
          s.privIsReadEnded || (s.privIsReadEnded = !0, s.privReaderQueue = new i.Queue());
        }, this.throwIfClosed = function() {
          if (s.privIsWriteEnded)
            throw new r.InvalidOperationError("Stream closed");
        }, this.privId = u || n.createNoDashGuid(), this.privReaderQueue = new i.Queue();
      }
      return Object.defineProperty(a.prototype, "isClosed", {
        get: function() {
          return this.privIsWriteEnded;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "isReadEnded", {
        get: function() {
          return this.privIsReadEnded;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "id", {
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.close = function() {
        this.privIsWriteEnded || (this.writeStreamChunk({
          buffer: null,
          isEnd: !0,
          timeReceived: Date.now()
        }), this.privIsWriteEnded = !0);
      }, a.prototype.writeStreamChunk = function(u) {
        if (this.throwIfClosed(), !this.privReaderQueue.isDisposed())
          try {
            this.privReaderQueue.enqueue(u);
          } catch {
          }
      }, a;
    }()
  );
  return iE.Stream = o, iE;
}
var SN = {}, ine;
function NH() {
  return ine || (ine = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.TranslationStatus = void 0, function(t) {
      t[t.Success = 0] = "Success", t[t.Error = 1] = "Error";
    }(e.TranslationStatus || (e.TranslationStatus = {}));
  }(SN)), SN;
}
var oE = {}, one;
function Gmr() {
  if (one) return oE;
  one = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(oE, "__esModule", { value: !0 }), oE.ChunkedArrayBufferStream = void 0;
  var t = Ar(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a) {
        var u = n.call(this, a) || this;
        return u.privTargetChunkSize = o, u.privNextBufferReadyBytes = 0, u;
      }
      return i.prototype.writeStreamChunk = function(o) {
        if (o.isEnd || this.privNextBufferReadyBytes === 0 && o.buffer.byteLength === this.privTargetChunkSize) {
          n.prototype.writeStreamChunk.call(this, o);
          return;
        }
        for (var a = 0; a < o.buffer.byteLength; ) {
          this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = o.timeReceived);
          var u = Math.min(o.buffer.byteLength - a, this.privTargetChunkSize - this.privNextBufferReadyBytes), s = new Uint8Array(this.privNextBufferToWrite), c = new Uint8Array(o.buffer.slice(a, u + a));
          s.set(c, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += u, a += u, this.privNextBufferReadyBytes === this.privTargetChunkSize && (n.prototype.writeStreamChunk.call(this, {
            buffer: this.privNextBufferToWrite,
            isEnd: !1,
            timeReceived: this.privNextBufferStartTime
          }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
        }
      }, i.prototype.close = function() {
        this.privNextBufferReadyBytes !== 0 && !this.isClosed && n.prototype.writeStreamChunk.call(this, {
          buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
          isEnd: !1,
          timeReceived: this.privNextBufferStartTime
        }), n.prototype.close.call(this);
      }, i;
    }(t.Stream)
  );
  return oE.ChunkedArrayBufferStream = r, oE;
}
var bN = {}, ane;
function Wmr() {
  return ane || (ane = 1, Object.defineProperty(bN, "__esModule", { value: !0 })), bN;
}
var aE = {}, une;
function Kmr() {
  if (une) return aE;
  une = 1, Object.defineProperty(aE, "__esModule", { value: !0 }), aE.Timeout = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.workerTimers = null, t.clearTimeout = function(r) {
        return t.timers().clearTimeout(r);
      }, t.setTimeout = function(r, n) {
        return t.timers().setTimeout(r, n);
      }, t.load = function(r) {
        var n = /* @__PURE__ */ new Map([[0, function() {
        }]]), i = /* @__PURE__ */ new Map(), o = new Worker(r);
        o.addEventListener("message", function(s) {
          var c = s.data;
          if (t.isCallNotification(c)) {
            var l = c.params.timerId, f = n.get(l);
            if (typeof f == "number") {
              var d = i.get(f);
              if (d === void 0 || d !== l)
                throw new Error("The timer is in an undefined state.");
            } else if (typeof f < "u")
              f(), n.delete(l);
            else
              throw new Error("The timer is in an undefined state.");
          } else if (t.isClearResponse(c)) {
            var p = c.id, d = i.get(p);
            if (d === void 0)
              throw new Error("The timer is in an undefined state.");
            i.delete(p), n.delete(d);
          } else {
            var v = c.error.message;
            throw new Error(v);
          }
        });
        var a = function(s) {
          var c = Math.random();
          i.set(c, s), n.set(s, c), o.postMessage({
            id: c,
            method: "clear",
            params: { timerId: s }
          });
        }, u = function(s, c) {
          var l = Math.random();
          return n.set(l, s), o.postMessage({
            id: null,
            method: "set",
            params: {
              delay: c,
              now: performance.now(),
              timerId: l
            }
          }), l;
        };
        return {
          clearTimeout: a,
          setTimeout: u
        };
      }, t.loadWorkerTimers = function() {
        var r = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        return function() {
          if (t.workerTimers !== null)
            return t.workerTimers;
          var n = new Blob([r], { type: "application/javascript; charset=utf-8" }), i = URL.createObjectURL(n);
          return t.workerTimers = t.load(i), t.workerTimers.setTimeout(function() {
            return URL.revokeObjectURL(i);
          }, 0), t.workerTimers;
        };
      }, t.timers = t.loadWorkerTimers(), t.isCallNotification = function(r) {
        return r.method !== void 0 && r.method === "call";
      }, t.isClearResponse = function(r) {
        return r.error === null && typeof r.id == "number";
      }, t;
    }()
  );
  return aE.Timeout = e, aE;
}
var Gr = {}, sne;
function r4e() {
  if (sne) return Gr;
  sne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var y = function(_, S) {
      return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, O) {
        A.__proto__ = O;
      } || function(A, O) {
        for (var P in O) O.hasOwnProperty(P) && (A[P] = O[P]);
      }, y(_, S);
    };
    return function(_, S) {
      y(_, S);
      function A() {
        this.constructor = _;
      }
      _.prototype = S === null ? Object.create(S) : (A.prototype = S.prototype, new A());
    };
  }();
  Object.defineProperty(Gr, "__esModule", { value: !0 }), Gr.OCSPCacheUpdateErrorEvent = Gr.OCSPResponseRetrievedEvent = Gr.OCSPCacheFetchErrorEvent = Gr.OCSPVerificationFailedEvent = Gr.OCSPCacheHitEvent = Gr.OCSPCacheEntryNeedsRefreshEvent = Gr.OCSPCacheEntryExpiredEvent = Gr.OCSPWSUpgradeStartedEvent = Gr.OCSPStapleReceivedEvent = Gr.OCSPCacheUpdatehCompleteEvent = Gr.OCSPDiskCacheStoreEvent = Gr.OCSPMemoryCacheStoreEvent = Gr.OCSPCacheUpdateNeededEvent = Gr.OCSPDiskCacheHitEvent = Gr.OCSPCacheMissEvent = Gr.OCSPMemoryCacheHitEvent = Gr.OCSPEvent = void 0;
  var t = zy(), r = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A, O) {
        var P = y.call(this, S, A) || this;
        return P.privSignature = O, P;
      }
      return _;
    }(t.PlatformEvent)
  );
  Gr.OCSPEvent = r;
  var n = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPMemoryCacheHitEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPMemoryCacheHitEvent = n;
  var i = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPCacheMissEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheMissEvent = i;
  var o = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPDiskCacheHitEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPDiskCacheHitEvent = o;
  var a = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPCacheUpdateNeededEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheUpdateNeededEvent = a;
  var u = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPMemoryCacheStoreEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPMemoryCacheStoreEvent = u;
  var s = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPDiskCacheStoreEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPDiskCacheStoreEvent = s;
  var c = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPCacheUpdatehCompleteEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheUpdatehCompleteEvent = c;
  var l = (
    /** @class */
    function(y) {
      e(_, y);
      function _() {
        return y.call(this, "OCSPStapleReceivedEvent", t.EventType.Debug, "") || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPStapleReceivedEvent = l;
  var f = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPWSUpgradeStartedEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPWSUpgradeStartedEvent = f;
  var d = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A) {
        var O = y.call(this, "OCSPCacheEntryExpiredEvent", t.EventType.Debug, S) || this;
        return O.privExpireTime = A, O;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheEntryExpiredEvent = d;
  var p = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A, O) {
        var P = y.call(this, "OCSPCacheEntryNeedsRefreshEvent", t.EventType.Debug, S) || this;
        return P.privExpireTime = O, P.privStartTime = A, P;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheEntryNeedsRefreshEvent = p;
  var v = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A, O) {
        var P = y.call(this, "OCSPCacheHitEvent", t.EventType.Debug, S) || this;
        return P.privExpireTime = O, P.privExpireTimeString = new Date(O).toLocaleDateString(), P.privStartTime = A, P.privStartTimeString = new Date(A).toLocaleTimeString(), P;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheHitEvent = v;
  var h = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A) {
        var O = y.call(this, "OCSPVerificationFailedEvent", t.EventType.Debug, S) || this;
        return O.privError = A, O;
      }
      return _;
    }(r)
  );
  Gr.OCSPVerificationFailedEvent = h;
  var E = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A) {
        var O = y.call(this, "OCSPCacheFetchErrorEvent", t.EventType.Debug, S) || this;
        return O.privError = A, O;
      }
      return _;
    }(r)
  );
  Gr.OCSPCacheFetchErrorEvent = E;
  var m = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S) {
        return y.call(this, "OCSPResponseRetrievedEvent", t.EventType.Debug, S) || this;
      }
      return _;
    }(r)
  );
  Gr.OCSPResponseRetrievedEvent = m;
  var g = (
    /** @class */
    function(y) {
      e(_, y);
      function _(S, A) {
        var O = y.call(this, "OCSPCacheUpdateErrorEvent", t.EventType.Debug, S) || this;
        return O.privError = A, O;
      }
      return _;
    }(r)
  );
  return Gr.OCSPCacheUpdateErrorEvent = g, Gr;
}
var uE = {}, cne;
function Xmr() {
  if (cne) return uE;
  cne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(uE, "__esModule", { value: !0 }), uE.BackgroundEvent = void 0;
  var t = Ar(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o) {
        var a = n.call(this, "BackgroundEvent", t.EventType.Error) || this;
        return a.privError = o, a;
      }
      return Object.defineProperty(i.prototype, "error", {
        get: function() {
          return this.privError;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.PlatformEvent)
  );
  return uE.BackgroundEvent = r, uE;
}
var lne;
function Ar() {
  return lne || (lne = 1, function(e) {
    var t = fe && fe.__createBinding || (Object.create ? function(i, o, a, u) {
      u === void 0 && (u = a), Object.defineProperty(i, u, { enumerable: !0, get: function() {
        return o[a];
      } });
    } : function(i, o, a, u) {
      u === void 0 && (u = a), i[u] = o[a];
    }), r = fe && fe.__exportStar || function(i, o) {
      for (var a in i) a !== "default" && !o.hasOwnProperty(a) && t(o, i, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(Dmr(), e), r(xmr(), e), r(JAe(), e), r(Nmr(), e), r(ZAe(), e), r(hc(), e), r(Lmr(), e), r(QAe(), e), r(gd(), e), r(Bmr(), e), r(kmr(), e), r(Mmr(), e), r(Fmr(), e), r(Hmr(), e), r($mr(), e), r(Umr(), e), r(Vmr(), e), r(jmr(), e), r(e4e(), e), r(zy(), e), r(xH(), e), r(t4e(), e), r(zmr(), e), r(qmr(), e), r(Ymr(), e);
    var n = NH();
    Object.defineProperty(e, "TranslationStatus", { enumerable: !0, get: function() {
      return n.TranslationStatus;
    } }), r(Gmr(), e), r(Wmr(), e), r(Kmr(), e), r(r4e(), e), r(Xmr(), e);
  }(lN)), lN;
}
var fne;
function Jmr() {
  if (fne) return Xv;
  fne = 1, Object.defineProperty(Xv, "__esModule", { value: !0 }), Xv.ConsoleLoggingListener = void 0;
  var e = Ar(), t = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(n) {
        var i = this;
        n === void 0 && (n = e.EventType.Warning), this.onEvent = function(o) {
          if (o.eventType >= i.privLogLevelFilter) {
            var a = i.toString(o);
            switch (o.eventType) {
              case e.EventType.Debug:
                console.debug(a);
                break;
              case e.EventType.Info:
                console.info(a);
                break;
              case e.EventType.Warning:
                console.warn(a);
                break;
              case e.EventType.Error:
                console.error(a);
                break;
              default:
                console.log(a);
                break;
            }
          }
        }, this.toString = function(o) {
          var a = [
            "" + o.EventTime,
            "" + o.Name
          ];
          for (var u in o)
            if (u && o.hasOwnProperty(u) && u !== "eventTime" && u !== "eventType" && u !== "eventId" && u !== "name" && u !== "constructor") {
              var s = o[u], c = "<NULL>";
              s != null && (typeof s == "number" || typeof s == "string" ? c = s.toString() : c = JSON.stringify(s)), a.push(u + ": " + c);
            }
          return a.join(" | ");
        }, this.privLogLevelFilter = n;
      }
      return r;
    }()
  );
  return Xv.ConsoleLoggingListener = t, Xv;
}
var CN = {}, dne;
function Zmr() {
  return dne || (dne = 1, Object.defineProperty(CN, "__esModule", { value: !0 })), CN;
}
var IN = {}, ON = {}, sE = {}, cE = {}, pne;
function vc() {
  if (pne) return cE;
  pne = 1, Object.defineProperty(cE, "__esModule", { value: !0 }), cE.HeaderNames = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.AuthKey = "Ocp-Apim-Subscription-Key", t.ConnectionId = "X-ConnectionId", t.ContentType = "Content-Type", t.CustomCommandsAppId = "X-CommandsAppId", t.Path = "Path", t.RequestId = "X-RequestId", t.RequestStreamId = "X-StreamId", t.RequestTimestamp = "X-Timestamp", t;
    }()
  );
  return cE.HeaderNames = e, cE;
}
var lE = {}, hne;
function LH() {
  if (hne) return lE;
  hne = 1, Object.defineProperty(lE, "__esModule", { value: !0 }), lE.AuthInfo = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privHeaderName = r, this.privToken = n;
      }
      return Object.defineProperty(t.prototype, "headerName", {
        get: function() {
          return this.privHeaderName;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "token", {
        get: function() {
          return this.privToken;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return lE.AuthInfo = e, lE;
}
var vne;
function Qmr() {
  if (vne) return sE;
  vne = 1, Object.defineProperty(sE, "__esModule", { value: !0 }), sE.CognitiveSubscriptionKeyAuthentication = void 0;
  var e = Ar(), t = vc(), r = LH(), n = (
    /** @class */
    /* @__PURE__ */ function() {
      function i(o) {
        var a = this;
        if (this.fetch = function(u) {
          return Promise.resolve(a.privAuthInfo);
        }, this.fetchOnExpiry = function(u) {
          return Promise.resolve(a.privAuthInfo);
        }, !o)
          throw new e.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new r.AuthInfo(t.HeaderNames.AuthKey, o);
      }
      return i;
    }()
  );
  return sE.CognitiveSubscriptionKeyAuthentication = n, sE;
}
var fE = {}, Ene;
function egr() {
  if (Ene) return fE;
  Ene = 1, Object.defineProperty(fE, "__esModule", { value: !0 }), fE.CognitiveTokenAuthentication = void 0;
  var e = Ar(), t = LH(), r = "Authorization", n = (
    /** @class */
    /* @__PURE__ */ function() {
      function i(o, a) {
        var u = this;
        if (this.fetch = function(s) {
          return u.privFetchCallback(s).then(function(c) {
            return new t.AuthInfo(r, c);
          });
        }, this.fetchOnExpiry = function(s) {
          return u.privFetchOnExpiryCallback(s).then(function(c) {
            return new t.AuthInfo(r, c);
          });
        }, !o)
          throw new e.ArgumentNullError("fetchCallback");
        if (!a)
          throw new e.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = o, this.privFetchOnExpiryCallback = a;
      }
      return i;
    }()
  );
  return fE.CognitiveTokenAuthentication = n, fE;
}
var RN = {}, mne;
function tgr() {
  return mne || (mne = 1, Object.defineProperty(RN, "__esModule", { value: !0 })), RN;
}
var wN = {}, gne;
function rgr() {
  return gne || (gne = 1, Object.defineProperty(wN, "__esModule", { value: !0 })), wN;
}
var dE = {}, PN = {}, Nc = {}, pE = {}, Tne;
function tn() {
  if (Tne) return pE;
  Tne = 1, Object.defineProperty(pE, "__esModule", { value: !0 }), pE.Contracts = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.throwIfNullOrUndefined = function(r, n) {
        if (r == null)
          throw new Error("throwIfNullOrUndefined:" + n);
      }, t.throwIfNull = function(r, n) {
        if (r === null)
          throw new Error("throwIfNull:" + n);
      }, t.throwIfNullOrWhitespace = function(r, n) {
        if (t.throwIfNullOrUndefined(r, n), ("" + r).trim().length < 1)
          throw new Error("throwIfNullOrWhitespace:" + n);
      }, t.throwIfDisposed = function(r) {
        if (r)
          throw new Error("the object is already disposed");
      }, t.throwIfArrayEmptyOrWhitespace = function(r, n) {
        if (t.throwIfNullOrUndefined(r, n), r.length === 0)
          throw new Error("throwIfArrayEmptyOrWhitespace:" + n);
        for (var i = 0, o = r; i < o.length; i++) {
          var a = o[i];
          t.throwIfNullOrWhitespace(a, n);
        }
      }, t.throwIfFileDoesNotExist = function(r, n) {
        t.throwIfNullOrWhitespace(r, n);
      }, t.throwIfNotUndefined = function(r, n) {
        if (r !== void 0)
          throw new Error("throwIfNotUndefined:" + n);
      }, t;
    }()
  );
  return pE.Contracts = e, pE;
}
var hE = {}, yne;
function n4e() {
  if (yne) return hE;
  yne = 1;
  var e = fe && fe.__createBinding || (Object.create ? function(a, u, s, c) {
    c === void 0 && (c = s), Object.defineProperty(a, c, { enumerable: !0, get: function() {
      return u[s];
    } });
  } : function(a, u, s, c) {
    c === void 0 && (c = s), a[c] = u[s];
  }), t = fe && fe.__setModuleDefault || (Object.create ? function(a, u) {
    Object.defineProperty(a, "default", { enumerable: !0, value: u });
  } : function(a, u) {
    a.default = u;
  }), r = fe && fe.__importStar || function(a) {
    if (a && a.__esModule) return a;
    var u = {};
    if (a != null) for (var s in a) s !== "default" && Object.hasOwnProperty.call(a, s) && e(u, a, s);
    return t(u, a), u;
  };
  Object.defineProperty(hE, "__esModule", { value: !0 }), hE.AudioFileWriter = void 0;
  var n = r(ki), i = tn(), o = (
    /** @class */
    function() {
      function a(u) {
        var s = this;
        this.id = function() {
          return s.privId;
        }, i.Contracts.throwIfNullOrUndefined(n.openSync, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = n.openSync(u, "w");
      }
      return Object.defineProperty(a.prototype, "format", {
        set: function(u) {
          i.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = u;
          var s = 0;
          this.privAudioFormat.hasHeader && (s = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = n.createWriteStream("", { fd: this.privFd, start: s, autoClose: !1 }));
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.write = function(u) {
        i.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(u.slice(0)));
      }, a.prototype.close = function() {
        var u = this;
        this.privFd !== void 0 && (this.privWriteStream.on("finish", function() {
          u.privAudioFormat.hasHeader && (u.privAudioFormat.updateHeader(u.privWriteStream.bytesWritten), n.writeSync(u.privFd, new Int8Array(u.privAudioFormat.header), 0, u.privAudioFormat.header.byteLength, 0)), n.closeSync(u.privFd), u.privFd = void 0;
        }), this.privWriteStream.end());
      }, a;
    }()
  );
  return hE.AudioFileWriter = o, hE;
}
var Ka = {}, DN = {}, _ne;
function Td() {
  return _ne || (_ne = 1, function(e) {
    var t = fe && fe.__extends || /* @__PURE__ */ function() {
      var o = function(a, u) {
        return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
          s.__proto__ = c;
        } || function(s, c) {
          for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
        }, o(a, u);
      };
      return function(a, u) {
        o(a, u);
        function s() {
          this.constructor = a;
        }
        a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
      };
    }();
    Object.defineProperty(e, "__esModule", { value: !0 }), e.AudioStreamFormatImpl = e.AudioStreamFormat = e.AudioFormatTag = void 0;
    var r;
    (function(o) {
      o[o.PCM = 1] = "PCM", o[o.MuLaw = 2] = "MuLaw", o[o.Siren = 3] = "Siren", o[o.MP3 = 4] = "MP3", o[o.SILKSkype = 5] = "SILKSkype", o[o.OGG_OPUS = 6] = "OGG_OPUS", o[o.WEBM_OPUS = 7] = "WEBM_OPUS", o[o.ALaw = 8] = "ALaw";
    })(r = e.AudioFormatTag || (e.AudioFormatTag = {}));
    var n = (
      /** @class */
      function() {
        function o() {
        }
        return o.getDefaultInputFormat = function() {
          return i.getDefaultInputFormat();
        }, o.getWaveFormatPCM = function(a, u, s) {
          return new i(a, u, s);
        }, o;
      }()
    );
    e.AudioStreamFormat = n;
    var i = (
      /** @class */
      function(o) {
        t(a, o);
        function a(u, s, c, l) {
          u === void 0 && (u = 16e3), s === void 0 && (s = 16), c === void 0 && (c = 1), l === void 0 && (l = r.PCM);
          var f = o.call(this) || this;
          switch (f.setString = function(p, v, h) {
            for (var E = 0; E < h.length; E++)
              p.setUint8(v + E, h.charCodeAt(E));
          }, l) {
            case r.PCM:
              f.formatTag = 1;
              break;
            case r.ALaw:
              f.formatTag = 6;
              break;
            case r.MuLaw:
              f.formatTag = 7;
              break;
          }
          f.bitsPerSample = s, f.samplesPerSec = u, f.channels = c, f.avgBytesPerSec = f.samplesPerSec * f.channels * (f.bitsPerSample / 8), f.blockAlign = f.channels * Math.max(f.bitsPerSample, 8), f.privHeader = new ArrayBuffer(44);
          var d = new DataView(f.privHeader);
          return f.setString(d, 0, "RIFF"), d.setUint32(4, 0, !0), f.setString(d, 8, "WAVEfmt "), d.setUint32(16, 16, !0), d.setUint16(20, f.formatTag, !0), d.setUint16(22, f.channels, !0), d.setUint32(24, f.samplesPerSec, !0), d.setUint32(28, f.avgBytesPerSec, !0), d.setUint16(32, f.channels * (f.bitsPerSample / 8), !0), d.setUint16(34, f.bitsPerSample, !0), f.setString(d, 36, "data"), d.setUint32(40, 0, !0), f;
        }
        return a.getDefaultInputFormat = function() {
          return new a();
        }, a.getAudioContext = function(u) {
          var s = window.AudioContext || window.webkitAudioContext || !1;
          if (s)
            return u !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new s({ sampleRate: u }) : new s();
          throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
        }, a.prototype.close = function() {
        }, Object.defineProperty(a.prototype, "header", {
          get: function() {
            return this.privHeader;
          },
          enumerable: !1,
          configurable: !0
        }), a;
      }(n)
    );
    e.AudioStreamFormatImpl = i;
  }(DN)), DN;
}
var Ane;
function i4e() {
  if (Ane) return Ka;
  Ane = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var p = function(v, h) {
      return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, m) {
        E.__proto__ = m;
      } || function(E, m) {
        for (var g in m) m.hasOwnProperty(g) && (E[g] = m[g]);
      }, p(v, h);
    };
    return function(v, h) {
      p(v, h);
      function E() {
        this.constructor = v;
      }
      v.prototype = h === null ? Object.create(h) : (E.prototype = h.prototype, new E());
    };
  }(), t = fe && fe.__awaiter || function(p, v, h, E) {
    function m(g) {
      return g instanceof h ? g : new h(function(y) {
        y(g);
      });
    }
    return new (h || (h = Promise))(function(g, y) {
      function _(O) {
        try {
          A(E.next(O));
        } catch (P) {
          y(P);
        }
      }
      function S(O) {
        try {
          A(E.throw(O));
        } catch (P) {
          y(P);
        }
      }
      function A(O) {
        O.done ? g(O.value) : m(O.value).then(_, S);
      }
      A((E = E.apply(p, v || [])).next());
    });
  }, r = fe && fe.__generator || function(p, v) {
    var h = { label: 0, sent: function() {
      if (g[0] & 1) throw g[1];
      return g[1];
    }, trys: [], ops: [] }, E, m, g, y;
    return y = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
      return this;
    }), y;
    function _(A) {
      return function(O) {
        return S([A, O]);
      };
    }
    function S(A) {
      if (E) throw new TypeError("Generator is already executing.");
      for (; h; ) try {
        if (E = 1, m && (g = A[0] & 2 ? m.return : A[0] ? m.throw || ((g = m.return) && g.call(m), 0) : m.next) && !(g = g.call(m, A[1])).done) return g;
        switch (m = 0, g && (A = [A[0] & 2, g.value]), A[0]) {
          case 0:
          case 1:
            g = A;
            break;
          case 4:
            return h.label++, { value: A[1], done: !1 };
          case 5:
            h.label++, m = A[1], A = [0];
            continue;
          case 7:
            A = h.ops.pop(), h.trys.pop();
            continue;
          default:
            if (g = h.trys, !(g = g.length > 0 && g[g.length - 1]) && (A[0] === 6 || A[0] === 2)) {
              h = 0;
              continue;
            }
            if (A[0] === 3 && (!g || A[1] > g[0] && A[1] < g[3])) {
              h.label = A[1];
              break;
            }
            if (A[0] === 6 && h.label < g[1]) {
              h.label = g[1], g = A;
              break;
            }
            if (g && h.label < g[2]) {
              h.label = g[2], h.ops.push(A);
              break;
            }
            g[2] && h.ops.pop(), h.trys.pop();
            continue;
        }
        A = v.call(p, h);
      } catch (O) {
        A = [6, O], m = 0;
      } finally {
        E = g = 0;
      }
      if (A[0] & 5) throw A[1];
      return { value: A[0] ? A[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Ka, "__esModule", { value: !0 }), Ka.PullAudioInputStreamImpl = Ka.PullAudioInputStream = Ka.PushAudioInputStreamImpl = Ka.PushAudioInputStream = Ka.AudioInputStream = void 0;
  var n = gr(), i = Ar(), o = gd(), a = Wt(), u = Td(), s = (
    /** @class */
    function() {
      function p() {
      }
      return p.createPushStream = function(v) {
        return c.create(v);
      }, p.createPullStream = function(v, h) {
        return f.create(v, h);
      }, p;
    }()
  );
  Ka.AudioInputStream = s;
  var c = (
    /** @class */
    function(p) {
      e(v, p);
      function v() {
        return p !== null && p.apply(this, arguments) || this;
      }
      return v.create = function(h) {
        return new l(h);
      }, v;
    }(s)
  );
  Ka.PushAudioInputStream = c;
  var l = (
    /** @class */
    function(p) {
      e(v, p);
      function v(h) {
        var E = p.call(this) || this;
        return E.onEvent = function(m) {
          E.privEvents.onEvent(m), i.Events.instance.onEvent(m);
        }, h === void 0 ? E.privFormat = u.AudioStreamFormatImpl.getDefaultInputFormat() : E.privFormat = h, E.privEvents = new i.EventSource(), E.privId = o.createNoDashGuid(), E.privStream = new i.ChunkedArrayBufferStream(E.privFormat.avgBytesPerSec / 10), E;
      }
      return Object.defineProperty(v.prototype, "format", {
        /**
         * Format information for the audio
         */
        get: function() {
          return Promise.resolve(this.privFormat);
        },
        enumerable: !1,
        configurable: !0
      }), v.prototype.write = function(h) {
        this.privStream.writeStreamChunk({
          buffer: h,
          isEnd: !1,
          timeReceived: Date.now()
        });
      }, v.prototype.close = function() {
        this.privStream.close();
      }, v.prototype.id = function() {
        return this.privId;
      }, Object.defineProperty(v.prototype, "blob", {
        get: function() {
          var h = this;
          return this.attach("id").then(function(E) {
            var m = [], g = Buffer.from(""), y = function() {
              return E.read().then(function(_) {
                return !_ || _.isEnd ? typeof XMLHttpRequest < "u" && typeof Blob < "u" ? Promise.resolve(new Blob(m)) : Promise.resolve(Buffer.from(g)) : (typeof Blob < "u" ? m.push(_.buffer) : g = Buffer.concat([g, h.toBuffer(_.buffer)]), y());
              });
            };
            return y();
          });
        },
        enumerable: !1,
        configurable: !0
      }), v.prototype.turnOn = function() {
        this.onEvent(new i.AudioSourceInitializingEvent(this.privId)), this.onEvent(new i.AudioSourceReadyEvent(this.privId));
      }, v.prototype.attach = function(h) {
        return t(this, void 0, void 0, function() {
          var E, m = this;
          return r(this, function(g) {
            switch (g.label) {
              case 0:
                return this.onEvent(new i.AudioStreamNodeAttachingEvent(this.privId, h)), [4, this.turnOn()];
              case 1:
                return g.sent(), E = this.privStream, this.onEvent(new i.AudioStreamNodeAttachedEvent(this.privId, h)), [2, {
                  detach: function() {
                    return t(m, void 0, void 0, function() {
                      return r(this, function(y) {
                        return E.readEnded(), this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, h)), [2, this.turnOff()];
                      });
                    });
                  },
                  id: function() {
                    return h;
                  },
                  read: function() {
                    return E.read();
                  }
                }];
            }
          });
        });
      }, v.prototype.detach = function(h) {
        this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, h));
      }, v.prototype.turnOff = function() {
      }, Object.defineProperty(v.prototype, "events", {
        get: function() {
          return this.privEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(v.prototype, "deviceInfo", {
        get: function() {
          return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: n.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: n.type.Stream
          });
        },
        enumerable: !1,
        configurable: !0
      }), v.prototype.toBuffer = function(h) {
        for (var E = Buffer.alloc(h.byteLength), m = new Uint8Array(h), g = 0; g < E.length; ++g)
          E[g] = m[g];
        return E;
      }, v;
    }(c)
  );
  Ka.PushAudioInputStreamImpl = l;
  var f = (
    /** @class */
    function(p) {
      e(v, p);
      function v() {
        return p.call(this) || this;
      }
      return v.create = function(h, E) {
        return new d(h, E);
      }, v;
    }(s)
  );
  Ka.PullAudioInputStream = f;
  var d = (
    /** @class */
    function(p) {
      e(v, p);
      function v(h, E) {
        var m = p.call(this) || this;
        return m.onEvent = function(g) {
          m.privEvents.onEvent(g), i.Events.instance.onEvent(g);
        }, E === void 0 ? m.privFormat = a.AudioStreamFormat.getDefaultInputFormat() : m.privFormat = E, m.privEvents = new i.EventSource(), m.privId = o.createNoDashGuid(), m.privCallback = h, m.privIsClosed = !1, m.privBufferSize = m.privFormat.avgBytesPerSec / 10, m;
      }
      return Object.defineProperty(v.prototype, "format", {
        /**
         * Format information for the audio
         */
        get: function() {
          return Promise.resolve(this.privFormat);
        },
        enumerable: !1,
        configurable: !0
      }), v.prototype.close = function() {
        this.privIsClosed = !0, this.privCallback.close();
      }, v.prototype.id = function() {
        return this.privId;
      }, Object.defineProperty(v.prototype, "blob", {
        get: function() {
          return Promise.reject("Not implemented");
        },
        enumerable: !1,
        configurable: !0
      }), v.prototype.turnOn = function() {
        this.onEvent(new i.AudioSourceInitializingEvent(this.privId)), this.onEvent(new i.AudioSourceReadyEvent(this.privId));
      }, v.prototype.attach = function(h) {
        return t(this, void 0, void 0, function() {
          var E = this;
          return r(this, function(m) {
            switch (m.label) {
              case 0:
                return this.onEvent(new i.AudioStreamNodeAttachingEvent(this.privId, h)), [4, this.turnOn()];
              case 1:
                return m.sent(), this.onEvent(new i.AudioStreamNodeAttachedEvent(this.privId, h)), [2, {
                  detach: function() {
                    return E.privCallback.close(), E.onEvent(new i.AudioStreamNodeDetachedEvent(E.privId, h)), E.turnOff();
                  },
                  id: function() {
                    return h;
                  },
                  read: function() {
                    for (var g = 0, y; g < E.privBufferSize; ) {
                      var _ = new ArrayBuffer(E.privBufferSize - g), S = E.privCallback.read(_);
                      if (y === void 0)
                        y = _;
                      else {
                        var A = new Int8Array(y);
                        A.set(new Int8Array(_), g);
                      }
                      if (S === 0)
                        break;
                      g += S;
                    }
                    return Promise.resolve({
                      buffer: y.slice(0, g),
                      isEnd: E.privIsClosed || g === 0,
                      timeReceived: Date.now()
                    });
                  }
                }];
            }
          });
        });
      }, v.prototype.detach = function(h) {
        this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, h));
      }, v.prototype.turnOff = function() {
      }, Object.defineProperty(v.prototype, "events", {
        get: function() {
          return this.privEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(v.prototype, "deviceInfo", {
        get: function() {
          return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: n.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: n.type.Stream
          });
        },
        enumerable: !1,
        configurable: !0
      }), v;
    }(f)
  );
  return Ka.PullAudioInputStreamImpl = d, Ka;
}
var Xa = {}, vE = {}, xN = {}, Sne;
function o4e() {
  return Sne || (Sne = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SpeechSynthesisOutputFormat = void 0, function(t) {
      t[t.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", t[t.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", t[t.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", t[t.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", t[t.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", t[t.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", t[t.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", t[t.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", t[t.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", t[t.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", t[t.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", t[t.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", t[t.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", t[t.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", t[t.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", t[t.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", t[t.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", t[t.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", t[t.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", t[t.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", t[t.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", t[t.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", t[t.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", t[t.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", t[t.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", t[t.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", t[t.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", t[t.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", t[t.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw";
    }(e.SpeechSynthesisOutputFormat || (e.SpeechSynthesisOutputFormat = {}));
  }(xN)), xN;
}
var bne;
function Q3() {
  if (bne) return vE;
  bne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }(), t;
  Object.defineProperty(vE, "__esModule", { value: !0 }), vE.AudioOutputFormatImpl = void 0;
  var r = o4e(), n = Td(), i = (
    /** @class */
    function(o) {
      e(a, o);
      function a(u, s, c, l, f, d, p, v, h) {
        var E = o.call(this, c, d, s, u) || this;
        return E.formatTag = u, E.avgBytesPerSec = l, E.blockAlign = f, E.priAudioFormatString = p, E.priRequestAudioFormatString = v, E.priHasHeader = h, E;
      }
      return a.fromSpeechSynthesisOutputFormat = function(u) {
        return u === void 0 ? a.getDefaultOutputFormat() : a.fromSpeechSynthesisOutputFormatString(a.SpeechSynthesisOutputFormatToString[u]);
      }, a.fromSpeechSynthesisOutputFormatString = function(u) {
        switch (u) {
          case "raw-8khz-8bit-mono-mulaw":
            return new a(n.AudioFormatTag.MuLaw, 1, 8e3, 8e3, 1, 8, u, u, !1);
          case "riff-16khz-16kbps-mono-siren":
            return new a(n.AudioFormatTag.Siren, 1, 16e3, 2e3, 40, 0, u, "audio-16khz-16kbps-mono-siren", !0);
          case "audio-16khz-16kbps-mono-siren":
            return new a(n.AudioFormatTag.Siren, 1, 16e3, 2e3, 40, 0, u, u, !1);
          case "audio-16khz-32kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 16e3, 4096, 2, 16, u, u, !1);
          case "audio-16khz-128kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 16e3, 16384, 2, 16, u, u, !1);
          case "audio-16khz-64kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 16e3, 8192, 2, 16, u, u, !1);
          case "audio-24khz-48kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 24e3, 6144, 2, 16, u, u, !1);
          case "audio-24khz-96kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 24e3, 12288, 2, 16, u, u, !1);
          case "audio-24khz-160kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 24e3, 20480, 2, 16, u, u, !1);
          case "raw-16khz-16bit-mono-truesilk":
            return new a(n.AudioFormatTag.SILKSkype, 1, 16e3, 32e3, 2, 16, u, u, !1);
          case "riff-8khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 8e3, 16e3, 2, 16, u, "raw-8khz-16bit-mono-pcm", !0);
          case "riff-24khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 24e3, 48e3, 2, 16, u, "raw-24khz-16bit-mono-pcm", !0);
          case "riff-8khz-8bit-mono-mulaw":
            return new a(n.AudioFormatTag.MuLaw, 1, 8e3, 8e3, 1, 8, u, "raw-8khz-8bit-mono-mulaw", !0);
          case "raw-16khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 16e3, 32e3, 2, 16, u, "raw-16khz-16bit-mono-pcm", !1);
          case "raw-24khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 24e3, 48e3, 2, 16, u, "raw-24khz-16bit-mono-pcm", !1);
          case "raw-8khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 8e3, 16e3, 2, 16, u, "raw-8khz-16bit-mono-pcm", !1);
          case "ogg-16khz-16bit-mono-opus":
            return new a(n.AudioFormatTag.OGG_OPUS, 1, 16e3, 8192, 2, 16, u, u, !1);
          case "ogg-24khz-16bit-mono-opus":
            return new a(n.AudioFormatTag.OGG_OPUS, 1, 24e3, 8192, 2, 16, u, u, !1);
          case "raw-48khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 48e3, 96e3, 2, 16, u, "raw-48khz-16bit-mono-pcm", !1);
          case "riff-48khz-16bit-mono-pcm":
            return new a(n.AudioFormatTag.PCM, 1, 48e3, 96e3, 2, 16, u, "raw-48khz-16bit-mono-pcm", !0);
          case "audio-48khz-96kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 48e3, 12288, 2, 16, u, u, !1);
          case "audio-48khz-192kbitrate-mono-mp3":
            return new a(n.AudioFormatTag.MP3, 1, 48e3, 24576, 2, 16, u, u, !1);
          case "ogg-48khz-16bit-mono-opus":
            return new a(n.AudioFormatTag.OGG_OPUS, 1, 48e3, 12e3, 2, 16, u, u, !1);
          case "webm-16khz-16bit-mono-opus":
            return new a(n.AudioFormatTag.WEBM_OPUS, 1, 16e3, 8e3, 2, 16, u, u, !1);
          case "webm-24khz-16bit-mono-opus":
            return new a(n.AudioFormatTag.WEBM_OPUS, 1, 24e3, 8e3, 2, 16, u, u, !1);
          case "raw-24khz-16bit-mono-truesilk":
            return new a(n.AudioFormatTag.SILKSkype, 1, 24e3, 48e3, 2, 16, u, u, !1);
          case "raw-8khz-8bit-mono-alaw":
            return new a(n.AudioFormatTag.ALaw, 1, 8e3, 8e3, 1, 8, u, u, !1);
          case "riff-8khz-8bit-mono-alaw":
            return new a(n.AudioFormatTag.ALaw, 1, 8e3, 8e3, 1, 8, u, "raw-8khz-8bit-mono-alaw", !0);
          case "riff-16khz-16bit-mono-pcm":
          default:
            return new a(n.AudioFormatTag.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
        }
      }, a.getDefaultOutputFormat = function() {
        return a.fromSpeechSynthesisOutputFormatString(typeof window < "u" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
      }, Object.defineProperty(a.prototype, "hasHeader", {
        /**
         * Specifies if this audio output format has a header
         * @boolean AudioOutputFormatImpl.prototype.hasHeader
         * @function
         * @public
         */
        get: function() {
          return this.priHasHeader;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "header", {
        /**
         * Specifies the header of this format
         * @ArrayBuffer AudioOutputFormatImpl.prototype.header
         * @function
         * @public
         */
        get: function() {
          if (this.hasHeader)
            return this.privHeader;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.updateHeader = function(u) {
        if (this.priHasHeader) {
          var s = new DataView(this.privHeader);
          s.setUint32(40, u, !0);
        }
      }, Object.defineProperty(a.prototype, "requestAudioFormatString", {
        /**
         * Specifies the audio format string to be sent to the service
         * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
         * @function
         * @public
         */
        get: function() {
          return this.priRequestAudioFormatString;
        },
        enumerable: !1,
        configurable: !0
      }), a.SpeechSynthesisOutputFormatToString = (t = {}, t[r.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw] = "raw-8khz-8bit-mono-mulaw", t[r.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren] = "riff-16khz-16kbps-mono-siren", t[r.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren] = "audio-16khz-16kbps-mono-siren", t[r.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3] = "audio-16khz-32kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3] = "audio-16khz-128kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3] = "audio-16khz-64kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3] = "audio-24khz-48kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3] = "audio-24khz-96kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3] = "audio-24khz-160kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk] = "raw-16khz-16bit-mono-truesilk", t[r.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm] = "riff-16khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm] = "riff-8khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm] = "riff-24khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw] = "riff-8khz-8bit-mono-mulaw", t[r.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm] = "raw-16khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm] = "raw-24khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm] = "raw-8khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus] = "ogg-16khz-16bit-mono-opus", t[r.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus] = "ogg-24khz-16bit-mono-opus", t[r.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm] = "raw-48khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm] = "riff-48khz-16bit-mono-pcm", t[r.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3] = "audio-48khz-96kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3] = "audio-48khz-192kbitrate-mono-mp3", t[r.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus] = "ogg-48khz-16bit-mono-opus", t[r.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus] = "webm-16khz-16bit-mono-opus", t[r.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus] = "webm-24khz-16bit-mono-opus", t[r.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk] = "raw-24khz-16bit-mono-truesilk", t[r.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw] = "raw-8khz-8bit-mono-alaw", t[r.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw] = "riff-8khz-8bit-mono-alaw", t), a;
    }(n.AudioStreamFormatImpl)
  );
  return vE.AudioOutputFormatImpl = i, vE;
}
var Cne;
function Qh() {
  if (Cne) return Xa;
  Cne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var f = function(d, p) {
      return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, h) {
        v.__proto__ = h;
      } || function(v, h) {
        for (var E in h) h.hasOwnProperty(E) && (v[E] = h[E]);
      }, f(d, p);
    };
    return function(d, p) {
      f(d, p);
      function v() {
        this.constructor = d;
      }
      d.prototype = p === null ? Object.create(p) : (v.prototype = p.prototype, new v());
    };
  }(), t = fe && fe.__awaiter || function(f, d, p, v) {
    function h(E) {
      return E instanceof p ? E : new p(function(m) {
        m(E);
      });
    }
    return new (p || (p = Promise))(function(E, m) {
      function g(S) {
        try {
          _(v.next(S));
        } catch (A) {
          m(A);
        }
      }
      function y(S) {
        try {
          _(v.throw(S));
        } catch (A) {
          m(A);
        }
      }
      function _(S) {
        S.done ? E(S.value) : h(S.value).then(g, y);
      }
      _((v = v.apply(f, d || [])).next());
    });
  }, r = fe && fe.__generator || function(f, d) {
    var p = { label: 0, sent: function() {
      if (E[0] & 1) throw E[1];
      return E[1];
    }, trys: [], ops: [] }, v, h, E, m;
    return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
      return this;
    }), m;
    function g(_) {
      return function(S) {
        return y([_, S]);
      };
    }
    function y(_) {
      if (v) throw new TypeError("Generator is already executing.");
      for (; p; ) try {
        if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
        switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
          case 0:
          case 1:
            E = _;
            break;
          case 4:
            return p.label++, { value: _[1], done: !1 };
          case 5:
            p.label++, h = _[1], _ = [0];
            continue;
          case 7:
            _ = p.ops.pop(), p.trys.pop();
            continue;
          default:
            if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
              p = 0;
              continue;
            }
            if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
              p.label = _[1];
              break;
            }
            if (_[0] === 6 && p.label < E[1]) {
              p.label = E[1], E = _;
              break;
            }
            if (E && p.label < E[2]) {
              p.label = E[2], p.ops.push(_);
              break;
            }
            E[2] && p.ops.pop(), p.trys.pop();
            continue;
        }
        _ = d.call(f, p);
      } catch (S) {
        _ = [6, S], h = 0;
      } finally {
        v = E = 0;
      }
      if (_[0] & 5) throw _[1];
      return { value: _[0] ? _[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Xa, "__esModule", { value: !0 }), Xa.PushAudioOutputStreamImpl = Xa.PushAudioOutputStream = Xa.PullAudioOutputStreamImpl = Xa.PullAudioOutputStream = Xa.AudioOutputStream = void 0;
  var n = Ar(), i = tn(), o = Q3(), a = (
    /** @class */
    function() {
      function f() {
      }
      return f.createPullStream = function() {
        return u.create();
      }, f;
    }()
  );
  Xa.AudioOutputStream = a;
  var u = (
    /** @class */
    function(f) {
      e(d, f);
      function d() {
        return f !== null && f.apply(this, arguments) || this;
      }
      return d.create = function() {
        return new s();
      }, d;
    }(a)
  );
  Xa.PullAudioOutputStream = u;
  var s = (
    /** @class */
    function(f) {
      e(d, f);
      function d() {
        var p = f.call(this) || this;
        return p.privId = n.createNoDashGuid(), p.privStream = new n.Stream(), p;
      }
      return Object.defineProperty(d.prototype, "format", {
        /**
         * Format information for the audio
         */
        get: function() {
          return this.privFormat;
        },
        /**
         * Sets the format information to the stream. For internal use only.
         * @param {AudioStreamFormat} format - the format to be set.
         */
        set: function(p) {
          p == null && (this.privFormat = o.AudioOutputFormatImpl.getDefaultOutputFormat()), this.privFormat = p;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(d.prototype, "isClosed", {
        /**
         * Checks if the stream is closed
         * @member PullAudioOutputStreamImpl.prototype.isClosed
         * @property
         * @public
         */
        get: function() {
          return this.privStream.isClosed;
        },
        enumerable: !1,
        configurable: !0
      }), d.prototype.id = function() {
        return this.privId;
      }, d.prototype.read = function(p) {
        return t(this, void 0, void 0, function() {
          var v, h, E, m;
          return r(this, function(g) {
            switch (g.label) {
              case 0:
                if (v = new Int8Array(p), h = 0, this.privLastChunkView !== void 0) {
                  if (this.privLastChunkView.length > p.byteLength)
                    return v.set(this.privLastChunkView.slice(0, p.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(p.byteLength), [2, Promise.resolve(p.byteLength)];
                  v.set(this.privLastChunkView), h = this.privLastChunkView.length, this.privLastChunkView = void 0;
                }
                g.label = 1;
              case 1:
                return h < p.byteLength && !this.privStream.isReadEnded ? [4, this.privStream.read()] : [3, 6];
              case 2:
                return E = g.sent(), E !== void 0 && !E.isEnd ? (m = void 0, E.buffer.byteLength > p.byteLength - h ? (m = E.buffer.slice(0, p.byteLength - h), this.privLastChunkView = new Int8Array(E.buffer.slice(p.byteLength - h))) : m = E.buffer, v.set(new Int8Array(m), h), h += m.byteLength, [3, 5]) : [3, 3];
              case 3:
                return [4, this.privStream.readEnded()];
              case 4:
                g.sent(), g.label = 5;
              case 5:
                return [3, 1];
              case 6:
                return [2, h];
            }
          });
        });
      }, d.prototype.write = function(p) {
        i.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({
          buffer: p,
          isEnd: !1,
          timeReceived: Date.now()
        });
      }, d.prototype.close = function() {
        this.privStream.close();
      }, d;
    }(u)
  );
  Xa.PullAudioOutputStreamImpl = s;
  var c = (
    /** @class */
    function(f) {
      e(d, f);
      function d() {
        return f.call(this) || this;
      }
      return d.create = function(p) {
        return new l(p);
      }, d;
    }(a)
  );
  Xa.PushAudioOutputStream = c;
  var l = (
    /** @class */
    function(f) {
      e(d, f);
      function d(p) {
        var v = f.call(this) || this;
        return v.privId = n.createNoDashGuid(), v.privCallback = p, v;
      }
      return Object.defineProperty(d.prototype, "format", {
        // tslint:disable-next-line:no-empty
        set: function(p) {
        },
        enumerable: !1,
        configurable: !0
      }), d.prototype.write = function(p) {
        this.privCallback.write && this.privCallback.write(p);
      }, d.prototype.close = function() {
        this.privCallback.close && this.privCallback.close();
      }, d.prototype.id = function() {
        return this.privId;
      }, d;
    }(c)
  );
  return Xa.PushAudioOutputStreamImpl = l, Xa;
}
var Ine;
function ngr() {
  if (Ine) return Nc;
  Ine = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var l = function(f, d) {
      return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, v) {
        p.__proto__ = v;
      } || function(p, v) {
        for (var h in v) v.hasOwnProperty(h) && (p[h] = v[h]);
      }, l(f, d);
    };
    return function(f, d) {
      l(f, d);
      function p() {
        this.constructor = f;
      }
      f.prototype = d === null ? Object.create(d) : (p.prototype = d.prototype, new p());
    };
  }();
  Object.defineProperty(Nc, "__esModule", { value: !0 }), Nc.AudioOutputConfigImpl = Nc.AudioConfigImpl = Nc.AudioConfig = void 0;
  var t = Yu(), r = tn(), n = Wt(), i = n4e(), o = i4e(), a = Qh(), u = (
    /** @class */
    function() {
      function l() {
      }
      return l.fromDefaultMicrophoneInput = function() {
        var f = new t.PcmRecorder();
        return new s(new t.MicAudioSource(f));
      }, l.fromMicrophoneInput = function(f) {
        var d = new t.PcmRecorder();
        return new s(new t.MicAudioSource(d, f));
      }, l.fromWavFileInput = function(f, d) {
        return d === void 0 && (d = "unnamedBuffer.wav"), new s(new t.FileAudioSource(f, d));
      }, l.fromStreamInput = function(f) {
        if (f instanceof n.PullAudioInputStreamCallback)
          return new s(new o.PullAudioInputStreamImpl(f));
        if (f instanceof n.AudioInputStream)
          return new s(f);
        if (typeof MediaStream < "u" && f instanceof MediaStream) {
          var d = new t.PcmRecorder();
          return new s(new t.MicAudioSource(d, null, null, f));
        }
        throw new Error("Not Supported Type");
      }, l.fromDefaultSpeakerOutput = function() {
        return new c(new n.SpeakerAudioDestination());
      }, l.fromSpeakerOutput = function(f) {
        if (f === void 0)
          return l.fromDefaultSpeakerOutput();
        if (f instanceof n.SpeakerAudioDestination)
          return new c(f);
        throw new Error("Not Supported Type");
      }, l.fromAudioFileOutput = function(f) {
        return new c(new i.AudioFileWriter(f));
      }, l.fromStreamOutput = function(f) {
        if (f instanceof n.PushAudioOutputStreamCallback)
          return new c(new a.PushAudioOutputStreamImpl(f));
        if (f instanceof n.PushAudioOutputStream)
          return new c(f);
        if (f instanceof n.PullAudioOutputStream)
          return new c(f);
        throw new Error("Not Supported Type");
      }, l;
    }()
  );
  Nc.AudioConfig = u;
  var s = (
    /** @class */
    function(l) {
      e(f, l);
      function f(d) {
        var p = l.call(this) || this;
        return p.privSource = d, p;
      }
      return Object.defineProperty(f.prototype, "format", {
        /**
         * Format information for the audio
         */
        get: function() {
          return this.privSource.format;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.close = function(d, p) {
        this.privSource.turnOff().then(function() {
          d && d();
        }, function(v) {
          p && p(v);
        });
      }, f.prototype.id = function() {
        return this.privSource.id();
      }, Object.defineProperty(f.prototype, "blob", {
        /**
         * @member AudioConfigImpl.prototype.blob
         * @function
         * @public
         */
        get: function() {
          return this.privSource.blob;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.turnOn = function() {
        return this.privSource.turnOn();
      }, f.prototype.attach = function(d) {
        return this.privSource.attach(d);
      }, f.prototype.detach = function(d) {
        return this.privSource.detach(d);
      }, f.prototype.turnOff = function() {
        return this.privSource.turnOff();
      }, Object.defineProperty(f.prototype, "events", {
        /**
         * @member AudioConfigImpl.prototype.events
         * @function
         * @public
         * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
         */
        get: function() {
          return this.privSource.events;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.setProperty = function(d, p) {
        if (r.Contracts.throwIfNull(p, "value"), this.privSource.setProperty !== void 0)
          this.privSource.setProperty(d, p);
        else
          throw new Error("This AudioConfig instance does not support setting properties.");
      }, f.prototype.getProperty = function(d, p) {
        if (this.privSource.getProperty !== void 0)
          return this.privSource.getProperty(d, p);
        throw new Error("This AudioConfig instance does not support getting properties.");
      }, Object.defineProperty(f.prototype, "deviceInfo", {
        get: function() {
          return this.privSource.deviceInfo;
        },
        enumerable: !1,
        configurable: !0
      }), f;
    }(u)
  );
  Nc.AudioConfigImpl = s;
  var c = (
    /** @class */
    function(l) {
      e(f, l);
      function f(d) {
        var p = l.call(this) || this;
        return p.privDestination = d, p;
      }
      return Object.defineProperty(f.prototype, "format", {
        set: function(d) {
          this.privDestination.format = d;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.write = function(d) {
        this.privDestination.write(d);
      }, f.prototype.close = function() {
        this.privDestination.close();
      }, f.prototype.id = function() {
        return this.privDestination.id();
      }, f.prototype.setProperty = function(d, p) {
        throw new Error("This AudioConfig instance does not support setting properties.");
      }, f.prototype.getProperty = function(d, p) {
        throw new Error("This AudioConfig instance does not support getting properties.");
      }, f;
    }(u)
  );
  return Nc.AudioOutputConfigImpl = c, Nc;
}
var NN = {}, One;
function igr() {
  return One || (One = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.CancellationReason = void 0, function(t) {
      t[t.Error = 0] = "Error", t[t.EndOfStream = 1] = "EndOfStream";
    }(e.CancellationReason || (e.CancellationReason = {}));
  }(NN)), NN;
}
var EE = {}, Rne;
function ogr() {
  if (Rne) return EE;
  Rne = 1, Object.defineProperty(EE, "__esModule", { value: !0 }), EE.PullAudioInputStreamCallback = void 0;
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t() {
      }
      return t;
    }()
  );
  return EE.PullAudioInputStreamCallback = e, EE;
}
var mE = {}, wne;
function agr() {
  if (wne) return mE;
  wne = 1, Object.defineProperty(mE, "__esModule", { value: !0 }), mE.PushAudioOutputStreamCallback = void 0;
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t() {
      }
      return t;
    }()
  );
  return mE.PushAudioOutputStreamCallback = e, mE;
}
var gE = {}, Pne;
function ugr() {
  if (Pne) return gE;
  Pne = 1, Object.defineProperty(gE, "__esModule", { value: !0 }), gE.KeywordRecognitionModel = void 0;
  var e = tn(), t = (
    /** @class */
    function() {
      function r() {
        this.privDisposed = !1;
      }
      return r.fromFile = function(n) {
        throw e.Contracts.throwIfFileDoesNotExist(n, "fileName"), new Error("Not yet implemented.");
      }, r.fromStream = function(n) {
        throw e.Contracts.throwIfNull(n, "file"), new Error("Not yet implemented.");
      }, r.prototype.close = function() {
        this.privDisposed || (this.privDisposed = !0);
      }, r;
    }()
  );
  return gE.KeywordRecognitionModel = t, gE;
}
var TE = {}, Dne;
function sgr() {
  if (Dne) return TE;
  Dne = 1, Object.defineProperty(TE, "__esModule", { value: !0 }), TE.SessionEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privSessionId = r;
      }
      return Object.defineProperty(t.prototype, "sessionId", {
        /**
         * Represents the session identifier.
         * @member SessionEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} Represents the session identifier.
         */
        get: function() {
          return this.privSessionId;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return TE.SessionEventArgs = e, TE;
}
var yE = {}, xne;
function cgr() {
  if (xne) return yE;
  xne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(yE, "__esModule", { value: !0 }), yE.RecognitionEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a) {
        var u = n.call(this, a) || this;
        return u.privOffset = o, u;
      }
      return Object.defineProperty(i.prototype, "offset", {
        /**
         * Represents the message offset
         * @member RecognitionEventArgs.prototype.offset
         * @function
         * @public
         */
        get: function() {
          return this.privOffset;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SessionEventArgs)
  );
  return yE.RecognitionEventArgs = r, yE;
}
var LN = {}, Nne;
function lgr() {
  return Nne || (Nne = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.OutputFormat = void 0, function(t) {
      t[t.Simple = 0] = "Simple", t[t.Detailed = 1] = "Detailed";
    }(e.OutputFormat || (e.OutputFormat = {}));
  }(LN)), LN;
}
var _E = {}, Lne;
function fgr() {
  if (Lne) return _E;
  Lne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(_E, "__esModule", { value: !0 }), _E.IntentRecognitionEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u) {
        var s = n.call(this, a, u) || this;
        return s.privResult = o, s;
      }
      return Object.defineProperty(i.prototype, "result", {
        /**
         * Represents the intent recognition result.
         * @member IntentRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {IntentRecognitionResult} Represents the intent recognition result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.RecognitionEventArgs)
  );
  return _E.IntentRecognitionEventArgs = r, _E;
}
var AE = {}, Bne;
function dgr() {
  if (Bne) return AE;
  Bne = 1, Object.defineProperty(AE, "__esModule", { value: !0 }), AE.RecognitionResult = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i, o, a, u, s, c, l, f) {
        this.privResultId = r, this.privReason = n, this.privText = i, this.privDuration = o, this.privOffset = a, this.privLanguage = u, this.privLanguageDetectionConfidence = s, this.privErrorDetails = c, this.privJson = l, this.privProperties = f;
      }
      return Object.defineProperty(t.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member RecognitionResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */
        get: function() {
          return this.privResultId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member RecognitionResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "text", {
        /**
         * Presents the recognized text in the result.
         * @member RecognitionResult.prototype.text
         * @function
         * @public
         * @returns {string} Presents the recognized text in the result.
         */
        get: function() {
          return this.privText;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "duration", {
        /**
         * Duration of recognized speech in 100 nano second incements.
         * @member RecognitionResult.prototype.duration
         * @function
         * @public
         * @returns {number} Duration of recognized speech in 100 nano second incements.
         */
        get: function() {
          return this.privDuration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "offset", {
        /**
         * Offset of recognized speech in 100 nano second incements.
         * @member RecognitionResult.prototype.offset
         * @function
         * @public
         * @returns {number} Offset of recognized speech in 100 nano second incements.
         */
        get: function() {
          return this.privOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "language", {
        /**
         * Primary Language detected.
         * @member RecognitionResult.prototype.language
         * @function
         * @public
         * @returns {string} language detected.
         */
        get: function() {
          return this.privLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "languageDetectionConfidence", {
        /**
         * Primary Language detection confidence (Unknown, Low, Medium, High).
         * @member RecognitionResult.prototype.languageDetectionConfidence
         * @function
         * @public
         * @returns {string} detection confidence strength.
         */
        get: function() {
          return this.privLanguageDetectionConfidence;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member RecognitionResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "json", {
        /**
         * A string containing Json serialized recognition result as it was received from the service.
         * @member RecognitionResult.prototype.json
         * @function
         * @private
         * @returns {string} Json serialized representation of the result.
         */
        get: function() {
          return this.privJson;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "properties", {
        /**
         *  The set of properties exposed in the result.
         * @member RecognitionResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return AE.RecognitionResult = e, AE;
}
var SE = {}, kne;
function pgr() {
  if (kne) return SE;
  kne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(SE, "__esModule", { value: !0 }), SE.SpeechRecognitionResult = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c, l, f, d, p, v, h) {
        var E = n.call(this, o, a, u, s, c, l, f, p, v, h) || this;
        return E.privSpeakerId = d, E;
      }
      return Object.defineProperty(i.prototype, "speakerId", {
        /**
         * speaker id from conversation transcription/id scenarios
         * @member SpeechRecognitionResult.prototype.speakerId
         * @function
         * @public
         * @returns {string} id of speaker in given result
         */
        get: function() {
          return this.privSpeakerId;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.RecognitionResult)
  );
  return SE.SpeechRecognitionResult = r, SE;
}
var bE = {}, Mne;
function hgr() {
  if (Mne) return bE;
  Mne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(bE, "__esModule", { value: !0 }), bE.IntentRecognitionResult = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c, l, f, d, p, v, h) {
        var E = n.call(this, a, u, s, c, l, f, d, void 0, p, v, h) || this;
        return E.privIntentId = o, E;
      }
      return Object.defineProperty(i.prototype, "intentId", {
        /**
         * A String that represents the intent identifier being recognized.
         * @member IntentRecognitionResult.prototype.intentId
         * @function
         * @public
         * @returns {string} A String that represents the intent identifier being recognized.
         */
        get: function() {
          return this.privIntentId;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SpeechRecognitionResult)
  );
  return bE.IntentRecognitionResult = r, bE;
}
var L0 = {}, Fne;
function vgr() {
  if (Fne) return L0;
  Fne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(L0, "__esModule", { value: !0 }), L0.LanguageUnderstandingModelImpl = L0.LanguageUnderstandingModel = void 0;
  var t = tn(), r = (
    /** @class */
    function() {
      function i() {
      }
      return i.fromEndpoint = function(o) {
        t.Contracts.throwIfNull(o, "uri"), t.Contracts.throwIfNullOrWhitespace(o.hostname, "uri");
        var a = new n(), u = o.host.indexOf(".");
        if (u === -1)
          throw new Error("Could not determine region from endpoint");
        a.region = o.host.substr(0, u);
        var s = o.pathname.lastIndexOf("/") + 1;
        if (s === -1)
          throw new Error("Could not determine appId from endpoint");
        if (a.appId = o.pathname.substr(s), a.subscriptionKey = o.searchParams.get("subscription-key"), a.subscriptionKey === void 0)
          throw new Error("Could not determine subscription key from endpoint");
        return a;
      }, i.fromAppId = function(o) {
        t.Contracts.throwIfNullOrWhitespace(o, "appId");
        var a = new n();
        return a.appId = o, a;
      }, i.fromSubscription = function(o, a, u) {
        t.Contracts.throwIfNullOrWhitespace(o, "subscriptionKey"), t.Contracts.throwIfNullOrWhitespace(a, "appId"), t.Contracts.throwIfNullOrWhitespace(u, "region");
        var s = new n();
        return s.appId = a, s.region = u, s.subscriptionKey = o, s;
      }, i;
    }()
  );
  L0.LanguageUnderstandingModel = r;
  var n = (
    /** @class */
    function(i) {
      e(o, i);
      function o() {
        return i !== null && i.apply(this, arguments) || this;
      }
      return o;
    }(r)
  );
  return L0.LanguageUnderstandingModelImpl = n, L0;
}
var B0 = {}, Hne;
function Egr() {
  if (Hne) return B0;
  Hne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(B0, "__esModule", { value: !0 }), B0.ConversationTranscriptionEventArgs = B0.SpeechRecognitionEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a, u, s) {
        var c = i.call(this, u, s) || this;
        return c.privResult = a, c;
      }
      return Object.defineProperty(o.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member SpeechRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechRecognitionResult} the recognition result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), o;
    }(t.RecognitionEventArgs)
  );
  B0.SpeechRecognitionEventArgs = r;
  var n = (
    /** @class */
    function(i) {
      e(o, i);
      function o() {
        return i !== null && i.apply(this, arguments) || this;
      }
      return o;
    }(r)
  );
  return B0.ConversationTranscriptionEventArgs = n, B0;
}
var CE = {}, IE = {}, $ne;
function BH() {
  if ($ne) return IE;
  $ne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(IE, "__esModule", { value: !0 }), IE.CancellationEventArgsBase = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c) {
        var l = n.call(this, s, c) || this;
        return l.privReason = o, l.privErrorDetails = a, l.privErrorCode = u, l;
      }
      return Object.defineProperty(i.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationEventArgsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful operation.
         * @return An error code that represents the error reason.
         */
        get: function() {
          return this.privErrorCode;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful operation, provides details of the occurred error.
         * @member CancellationEventArgsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.RecognitionEventArgs)
  );
  return IE.CancellationEventArgsBase = r, IE;
}
var Une;
function mgr() {
  if (Une) return CE;
  Une = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(CE, "__esModule", { value: !0 }), CE.SpeechRecognitionCanceledEventArgs = void 0;
  var t = BH(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return i;
    }(t.CancellationEventArgsBase)
  );
  return CE.SpeechRecognitionCanceledEventArgs = r, CE;
}
var OE = {}, Vne;
function ggr() {
  if (Vne) return OE;
  Vne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(OE, "__esModule", { value: !0 }), OE.TranslationRecognitionEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u) {
        var s = n.call(this, a, u) || this;
        return s.privResult = o, s;
      }
      return Object.defineProperty(i.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.RecognitionEventArgs)
  );
  return OE.TranslationRecognitionEventArgs = r, OE;
}
var RE = {}, jne;
function Tgr() {
  if (jne) return RE;
  jne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(RE, "__esModule", { value: !0 }), RE.TranslationSynthesisEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a) {
        var u = n.call(this, a) || this;
        return u.privResult = o, u;
      }
      return Object.defineProperty(i.prototype, "result", {
        /**
         * Specifies the translation synthesis result.
         * @member TranslationSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SessionEventArgs)
  );
  return RE.TranslationSynthesisEventArgs = r, RE;
}
var wE = {}, zne;
function a4e() {
  if (zne) return wE;
  zne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(wE, "__esModule", { value: !0 }), wE.TranslationRecognitionResult = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c, l, f, d, p) {
        var v = n.call(this, a, u, s, c, l, void 0, void 0, void 0, f, d, p) || this;
        return v.privTranslations = o, v;
      }
      return Object.defineProperty(i.prototype, "translations", {
        /**
         * Presents the translation results. Each item in the dictionary represents
         * a translation result in one of target languages, where the key is the name
         * of the target language, in BCP-47 format, and the value is the translation
         * text in the specified language.
         * @member TranslationRecognitionResult.prototype.translations
         * @function
         * @public
         * @returns {Translations} the current translation map that holds all translations requested.
         */
        get: function() {
          return this.privTranslations;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SpeechRecognitionResult)
  );
  return wE.TranslationRecognitionResult = r, wE;
}
var PE = {}, qne;
function ygr() {
  if (qne) return PE;
  qne = 1, Object.defineProperty(PE, "__esModule", { value: !0 }), PE.TranslationSynthesisResult = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privReason = r, this.privAudio = n;
      }
      return Object.defineProperty(t.prototype, "audio", {
        /**
         * Translated text in the target language.
         * @member TranslationSynthesisResult.prototype.audio
         * @function
         * @public
         * @returns {ArrayBuffer} Translated audio in the target language.
         */
        get: function() {
          return this.privAudio;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "reason", {
        /**
         * The synthesis status.
         * @member TranslationSynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} The synthesis status.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return PE.TranslationSynthesisResult = e, PE;
}
var BN = {}, Yne;
function _gr() {
  return Yne || (Yne = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ResultReason = void 0, function(t) {
      t[t.NoMatch = 0] = "NoMatch", t[t.Canceled = 1] = "Canceled", t[t.RecognizingSpeech = 2] = "RecognizingSpeech", t[t.RecognizedSpeech = 3] = "RecognizedSpeech", t[t.RecognizedKeyword = 4] = "RecognizedKeyword", t[t.RecognizingIntent = 5] = "RecognizingIntent", t[t.RecognizedIntent = 6] = "RecognizedIntent", t[t.TranslatingSpeech = 7] = "TranslatingSpeech", t[t.TranslatedSpeech = 8] = "TranslatedSpeech", t[t.SynthesizingAudio = 9] = "SynthesizingAudio", t[t.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", t[t.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", t[t.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", t[t.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", t[t.RecognizedSpeakers = 14] = "RecognizedSpeakers", t[t.RecognizedSpeaker = 15] = "RecognizedSpeaker", t[t.ResetVoiceProfile = 16] = "ResetVoiceProfile", t[t.DeletedVoiceProfile = 17] = "DeletedVoiceProfile";
    }(e.ResultReason || (e.ResultReason = {}));
  }(BN)), BN;
}
var k0 = {}, Gne;
function Agr() {
  if (Gne) return k0;
  Gne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var a = function(u, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
        c.__proto__ = l;
      } || function(c, l) {
        for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
      }, a(u, s);
    };
    return function(u, s) {
      a(u, s);
      function c() {
        this.constructor = u;
      }
      u.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
    };
  }();
  Object.defineProperty(k0, "__esModule", { value: !0 }), k0.SpeechConfigImpl = k0.SpeechConfig = void 0;
  var t = gr(), r = tn(), n = Wt(), i = (
    /** @class */
    function() {
      function a() {
      }
      return a.fromSubscription = function(u, s) {
        r.Contracts.throwIfNullOrWhitespace(u, "subscriptionKey"), r.Contracts.throwIfNullOrWhitespace(s, "region");
        var c = new o();
        return c.setProperty(n.PropertyId.SpeechServiceConnection_Region, s), c.setProperty(n.PropertyId.SpeechServiceConnection_IntentRegion, s), c.setProperty(n.PropertyId.SpeechServiceConnection_Key, u), c;
      }, a.fromEndpoint = function(u, s) {
        r.Contracts.throwIfNull(u, "endpoint");
        var c = new o();
        return c.setProperty(n.PropertyId.SpeechServiceConnection_Endpoint, u.href), s !== void 0 && c.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), c;
      }, a.fromHost = function(u, s) {
        r.Contracts.throwIfNull(u, "hostName");
        var c = new o();
        return c.setProperty(n.PropertyId.SpeechServiceConnection_Host, u.protocol + "//" + u.hostname + (u.port === "" ? "" : ":" + u.port)), s !== void 0 && c.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), c;
      }, a.fromAuthorizationToken = function(u, s) {
        r.Contracts.throwIfNull(u, "authorizationToken"), r.Contracts.throwIfNullOrWhitespace(s, "region");
        var c = new o();
        return c.setProperty(n.PropertyId.SpeechServiceConnection_Region, s), c.setProperty(n.PropertyId.SpeechServiceConnection_IntentRegion, s), c.authorizationToken = u, c;
      }, a.prototype.close = function() {
      }, a;
    }()
  );
  k0.SpeechConfig = i;
  var o = (
    /** @class */
    function(a) {
      e(u, a);
      function u() {
        var s = a.call(this) || this;
        return s.privProperties = new n.PropertyCollection(), s.speechRecognitionLanguage = "en-US", s.outputFormat = n.OutputFormat.Simple, s;
      }
      return Object.defineProperty(u.prototype, "properties", {
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "endPoint", {
        get: function() {
          return new URL(this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_Endpoint));
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "subscriptionKey", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_Key);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "region", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "authorizationToken", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechRecognitionLanguage", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_RecoLanguage, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "autoDetectSourceLanguages", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "outputFormat", {
        get: function() {
          return n.OutputFormat[this.privProperties.getProperty(t.OutputFormatPropertyName, void 0)];
        },
        set: function(s) {
          this.privProperties.setProperty(t.OutputFormatPropertyName, n.OutputFormat[s]);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "endpointId", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_EndpointId);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_EndpointId, s);
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.setProperty = function(s, c) {
        r.Contracts.throwIfNull(c, "value"), this.privProperties.setProperty(s, c);
      }, u.prototype.getProperty = function(s, c) {
        return this.privProperties.getProperty(s, c);
      }, u.prototype.setProxy = function(s, c, l, f) {
        this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyHostName], s), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyPort], c), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyUserName], l), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyPassword], f);
      }, u.prototype.setServiceProperty = function(s, c, l) {
        var f = JSON.parse(this.privProperties.getProperty(t.ServicePropertiesPropertyName, "{}"));
        f[s] = c, this.privProperties.setProperty(t.ServicePropertiesPropertyName, JSON.stringify(f));
      }, u.prototype.setProfanity = function(s) {
        this.privProperties.setProperty(n.PropertyId.SpeechServiceResponse_ProfanityOption, n.ProfanityOption[s]);
      }, u.prototype.enableAudioLogging = function() {
        this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
      }, u.prototype.requestWordLevelTimestamps = function() {
        this.privProperties.setProperty(n.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
      }, u.prototype.enableDictation = function() {
        this.privProperties.setProperty(t.ForceDictationPropertyName, "true");
      }, u.prototype.clone = function() {
        var s = new u();
        return s.privProperties = this.privProperties.clone(), s;
      }, Object.defineProperty(u.prototype, "speechSynthesisLanguage", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthLanguage, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechSynthesisVoiceName", {
        get: function() {
          return this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthVoice, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechSynthesisOutputFormat", {
        get: function() {
          return n.SpeechSynthesisOutputFormat[this.privProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)];
        },
        set: function(s) {
          this.privProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthOutputFormat, n.SpeechSynthesisOutputFormat[s]);
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(i)
  );
  return k0.SpeechConfigImpl = o, k0;
}
var M0 = {}, Wne;
function Sgr() {
  if (Wne) return M0;
  Wne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var a = function(u, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
        c.__proto__ = l;
      } || function(c, l) {
        for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
      }, a(u, s);
    };
    return function(u, s) {
      a(u, s);
      function c() {
        this.constructor = u;
      }
      u.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
    };
  }();
  Object.defineProperty(M0, "__esModule", { value: !0 }), M0.SpeechTranslationConfigImpl = M0.SpeechTranslationConfig = void 0;
  var t = gr(), r = tn(), n = Wt(), i = (
    /** @class */
    function(a) {
      e(u, a);
      function u() {
        return a.call(this) || this;
      }
      return u.fromSubscription = function(s, c) {
        r.Contracts.throwIfNullOrWhitespace(s, "subscriptionKey"), r.Contracts.throwIfNullOrWhitespace(c, "region");
        var l = new o();
        return l.properties.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), l.properties.setProperty(n.PropertyId.SpeechServiceConnection_Region, c), l;
      }, u.fromAuthorizationToken = function(s, c) {
        r.Contracts.throwIfNullOrWhitespace(s, "authorizationToken"), r.Contracts.throwIfNullOrWhitespace(c, "region");
        var l = new o();
        return l.properties.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, s), l.properties.setProperty(n.PropertyId.SpeechServiceConnection_Region, c), l;
      }, u.fromHost = function(s, c) {
        r.Contracts.throwIfNull(s, "hostName");
        var l = new o();
        return l.setProperty(n.PropertyId.SpeechServiceConnection_Host, s.protocol + "//" + s.hostname + (s.port === "" ? "" : ":" + s.port)), c !== void 0 && l.setProperty(n.PropertyId.SpeechServiceConnection_Key, c), l;
      }, u.fromEndpoint = function(s, c) {
        r.Contracts.throwIfNull(s, "endpoint"), r.Contracts.throwIfNull(c, "subscriptionKey");
        var l = new o();
        return l.properties.setProperty(n.PropertyId.SpeechServiceConnection_Endpoint, s.href), l.properties.setProperty(n.PropertyId.SpeechServiceConnection_Key, c), l;
      }, u;
    }(n.SpeechConfig)
  );
  M0.SpeechTranslationConfig = i;
  var o = (
    /** @class */
    function(a) {
      e(u, a);
      function u() {
        var s = a.call(this) || this;
        return s.privSpeechProperties = new n.PropertyCollection(), s.outputFormat = n.OutputFormat.Simple, s;
      }
      return Object.defineProperty(u.prototype, "authorizationToken", {
        /**
         * Gets/Sets the authorization token.
         * If this is set, subscription key is ignored.
         * User needs to make sure the provided authorization token is valid and not expired.
         * @member SpeechTranslationConfigImpl.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - The authorization token.
         */
        set: function(s) {
          r.Contracts.throwIfNullOrWhitespace(s, "value"), this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @return {string} The speechRecognitionLanguage.
         */
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_RecoLanguage]);
        },
        /**
         * Sets the speech recognition language.
         * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The authorization token.
         */
        set: function(s) {
          r.Contracts.throwIfNullOrWhitespace(s, "value"), this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_RecoLanguage, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "subscriptionKey", {
        /**
         * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
         * @function
         * @public
         */
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_Key]);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "outputFormat", {
        /**
         * Gets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */
        get: function() {
          return n.OutputFormat[this.privSpeechProperties.getProperty(t.OutputFormatPropertyName, void 0)];
        },
        /**
         * Gets/Sets the output format
         * @member SpeechTranslationConfigImpl.prototype.outputFormat
         * @function
         * @public
         */
        set: function(s) {
          this.privSpeechProperties.setProperty(t.OutputFormatPropertyName, n.OutputFormat[s]);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "endpointId", {
        /**
         * Gets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_EndpointId);
        },
        /**
         * Gets/Sets the endpoint id.
         * @member SpeechTranslationConfigImpl.prototype.endpointId
         * @function
         * @public
         */
        set: function(s) {
          this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_EndpointId, s);
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.addTargetLanguage = function(s) {
        r.Contracts.throwIfNullOrWhitespace(s, "value");
        var c = this.targetLanguages;
        c.push(s), this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_TranslationToLanguages, c.join(","));
      }, Object.defineProperty(u.prototype, "targetLanguages", {
        /**
         * Gets the (text) target language to translate into.
         * @member SpeechTranslationConfigImpl.prototype.targetLanguages
         * @function
         * @public
         * @param {string} value - The language such as de-DE
         */
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",") : [];
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "voiceName", {
        /**
         * Gets the voice name.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         */
        get: function() {
          return this.getProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_TranslationVoice]);
        },
        /**
         * Gets/Sets the voice of the translated language, enable voice synthesis output.
         * @member SpeechTranslationConfigImpl.prototype.voiceName
         * @function
         * @public
         * @param {string} value - The name of the voice.
         */
        set: function(s) {
          r.Contracts.throwIfNullOrWhitespace(s, "value"), this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_TranslationVoice, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "region", {
        /**
         * Provides the region.
         * @member SpeechTranslationConfigImpl.prototype.region
         * @function
         * @public
         * @returns {string} The region.
         */
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_Region);
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.setProxy = function(s, c, l, f) {
        this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyHostName], s), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyPort], c), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyUserName], l), this.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_ProxyPassword], f);
      }, u.prototype.getProperty = function(s, c) {
        return this.privSpeechProperties.getProperty(s, c);
      }, u.prototype.setProperty = function(s, c) {
        this.privSpeechProperties.setProperty(s, c);
      }, Object.defineProperty(u.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member SpeechTranslationConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */
        get: function() {
          return this.privSpeechProperties;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.close = function() {
      }, u.prototype.setServiceProperty = function(s, c, l) {
        var f = JSON.parse(this.privSpeechProperties.getProperty(t.ServicePropertiesPropertyName, "{}"));
        f[s] = c, this.privSpeechProperties.setProperty(t.ServicePropertiesPropertyName, JSON.stringify(f));
      }, u.prototype.setProfanity = function(s) {
        this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceResponse_ProfanityOption, n.ProfanityOption[s]);
      }, u.prototype.enableAudioLogging = function() {
        this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
      }, u.prototype.requestWordLevelTimestamps = function() {
        this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
      }, u.prototype.enableDictation = function() {
        this.privSpeechProperties.setProperty(t.ForceDictationPropertyName, "true");
      }, Object.defineProperty(u.prototype, "speechSynthesisLanguage", {
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthLanguage);
        },
        set: function(s) {
          this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthLanguage, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechSynthesisVoiceName", {
        get: function() {
          return this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthVoice);
        },
        set: function(s) {
          this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthVoice, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechSynthesisOutputFormat", {
        get: function() {
          return n.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty(n.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)];
        },
        set: function(s) {
          this.privSpeechProperties.setProperty(n.PropertyId.SpeechServiceConnection_SynthOutputFormat, n.SpeechSynthesisOutputFormat[s]);
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(i)
  );
  return M0.SpeechTranslationConfigImpl = o, M0;
}
var DE = {}, Kne;
function u4e() {
  if (Kne) return DE;
  Kne = 1, Object.defineProperty(DE, "__esModule", { value: !0 }), DE.PropertyCollection = void 0;
  var e = Wt(), t = (
    /** @class */
    function() {
      function r() {
        this.privKeys = [], this.privValues = [];
      }
      return r.prototype.getProperty = function(n, i) {
        var o;
        typeof n == "string" ? o = n : o = e.PropertyId[n];
        for (var a = 0; a < this.privKeys.length; a++)
          if (this.privKeys[a] === o)
            return this.privValues[a];
        return i;
      }, r.prototype.setProperty = function(n, i) {
        var o;
        typeof n == "string" ? o = n : o = e.PropertyId[n];
        for (var a = 0; a < this.privKeys.length; a++)
          if (this.privKeys[a] === o) {
            this.privValues[a] = i;
            return;
          }
        this.privKeys.push(o), this.privValues.push(i);
      }, r.prototype.clone = function() {
        for (var n = new r(), i = 0; i < this.privKeys.length; i++)
          n.privKeys.push(this.privKeys[i]), n.privValues.push(this.privValues[i]);
        return n;
      }, r.prototype.mergeTo = function(n) {
        var i = this;
        this.privKeys.forEach(function(o) {
          if (n.getProperty(o, void 0) === void 0) {
            var a = i.getProperty(o);
            n.setProperty(o, a);
          }
        });
      }, r;
    }()
  );
  return DE.PropertyCollection = t, DE;
}
var kN = {}, Xne;
function kH() {
  return Xne || (Xne = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PropertyId = void 0, function(t) {
      t[t.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", t[t.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", t[t.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", t[t.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", t[t.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", t[t.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", t[t.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", t[t.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", t[t.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", t[t.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", t[t.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", t[t.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", t[t.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", t[t.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", t[t.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", t[t.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", t[t.Speech_SessionId = 16] = "Speech_SessionId", t[t.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", t[t.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", t[t.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", t[t.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", t[t.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", t[t.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", t[t.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", t[t.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", t[t.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", t[t.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", t[t.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", t[t.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", t[t.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", t[t.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", t[t.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", t[t.SpeechServiceConnection_EnableAudioLogging = 32] = "SpeechServiceConnection_EnableAudioLogging", t[t.SpeechServiceResponse_ProfanityOption = 33] = "SpeechServiceResponse_ProfanityOption", t[t.SpeechServiceResponse_PostProcessingOption = 34] = "SpeechServiceResponse_PostProcessingOption", t[t.SpeechServiceResponse_RequestWordLevelTimestamps = 35] = "SpeechServiceResponse_RequestWordLevelTimestamps", t[t.SpeechServiceResponse_StablePartialResultThreshold = 36] = "SpeechServiceResponse_StablePartialResultThreshold", t[t.SpeechServiceResponse_OutputFormatOption = 37] = "SpeechServiceResponse_OutputFormatOption", t[t.SpeechServiceResponse_TranslationRequestStablePartialResult = 38] = "SpeechServiceResponse_TranslationRequestStablePartialResult", t[t.Conversation_ApplicationId = 39] = "Conversation_ApplicationId", t[t.Conversation_DialogType = 40] = "Conversation_DialogType", t[t.Conversation_Initial_Silence_Timeout = 41] = "Conversation_Initial_Silence_Timeout", t[t.Conversation_From_Id = 42] = "Conversation_From_Id", t[t.Conversation_Conversation_Id = 43] = "Conversation_Conversation_Id", t[t.Conversation_Custom_Voice_Deployment_Ids = 44] = "Conversation_Custom_Voice_Deployment_Ids", t[t.Conversation_Speech_Activity_Template = 45] = "Conversation_Speech_Activity_Template", t[t.Conversation_Request_Bot_Status_Messages = 46] = "Conversation_Request_Bot_Status_Messages", t[t.Conversation_Agent_Connection_Id = 47] = "Conversation_Agent_Connection_Id", t[t.SpeechServiceConnection_Host = 48] = "SpeechServiceConnection_Host", t[t.ConversationTranslator_Host = 49] = "ConversationTranslator_Host", t[t.ConversationTranslator_Name = 50] = "ConversationTranslator_Name", t[t.ConversationTranslator_CorrelationId = 51] = "ConversationTranslator_CorrelationId", t[t.ConversationTranslator_Token = 52] = "ConversationTranslator_Token", t[t.PronunciationAssessment_ReferenceText = 53] = "PronunciationAssessment_ReferenceText", t[t.PronunciationAssessment_GradingSystem = 54] = "PronunciationAssessment_GradingSystem", t[t.PronunciationAssessment_Granularity = 55] = "PronunciationAssessment_Granularity", t[t.PronunciationAssessment_EnableMiscue = 56] = "PronunciationAssessment_EnableMiscue", t[t.PronunciationAssessment_Json = 57] = "PronunciationAssessment_Json", t[t.PronunciationAssessment_Params = 58] = "PronunciationAssessment_Params";
    }(e.PropertyId || (e.PropertyId = {}));
  }(kN)), kN;
}
var xE = {}, Jne;
function bgr() {
  if (Jne) return xE;
  Jne = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(xE, "__esModule", { value: !0 }), xE.Recognizer = void 0;
  var r = gr(), n = Ar(), i = tn(), o = Wt(), a = (
    /** @class */
    function() {
      function u(s, c, l) {
        this.audioConfig = s !== void 0 ? s : o.AudioConfig.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = c.clone(), this.privConnectionFactory = l, this.implCommonRecognizerSetup();
      }
      return u.prototype.close = function(s, c) {
        i.Contracts.throwIfDisposed(this.privDisposed), n.marshalPromiseToCallbacks(this.dispose(!0), s, c);
      }, Object.defineProperty(u.prototype, "internalData", {
        /**
         * @Internal
         * Internal data member to support fromRecognizer* pattern methods on other classes.
         * Do not use externally, object returned will change without warning or notice.
         */
        get: function() {
          return this.privReco;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.dispose = function(s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return this.privDisposed ? [
                  2
                  /*return*/
                ] : (this.privDisposed = !0, s ? this.privReco ? [4, this.privReco.audioSource.turnOff()] : [3, 3] : [3, 3]);
              case 1:
                return c.sent(), [4, this.privReco.dispose()];
              case 2:
                c.sent(), c.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(u, "telemetryEnabled", {
        /**
         * This method returns the current state of the telemetry setting.
         * @member Recognizer.prototype.telemetryEnabled
         * @function
         * @public
         * @returns true if the telemetry is enabled, false otherwise.
         */
        get: function() {
          return r.ServiceRecognizerBase.telemetryDataEnabled;
        },
        enumerable: !1,
        configurable: !0
      }), u.enableTelemetry = function(s) {
        r.ServiceRecognizerBase.telemetryDataEnabled = s;
      }, u.prototype.implCommonRecognizerSetup = function() {
        var s = typeof window < "u" ? "Browser" : "Node", c = "unknown", l = "unknown";
        typeof navigator < "u" && (s = s + "/" + navigator.platform, c = navigator.userAgent, l = navigator.appVersion);
        var f = this.createRecognizerConfig(new r.SpeechServiceConfig(new r.Context(new r.OS(s, c, l))));
        this.privReco = this.createServiceRecognizer(u.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, f);
      }, u.prototype.recognizeOnceAsyncImpl = function(s) {
        return e(this, void 0, void 0, function() {
          var c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return i.Contracts.throwIfDisposed(this.privDisposed), c = new n.Deferred(), [4, this.implRecognizerStop()];
              case 1:
                return f.sent(), [4, this.privReco.recognize(s, c.resolve, c.reject)];
              case 2:
                return f.sent(), [4, c.promise];
              case 3:
                return l = f.sent(), [4, this.implRecognizerStop()];
              case 4:
                return f.sent(), [2, l];
            }
          });
        });
      }, u.prototype.startContinuousRecognitionAsyncImpl = function(s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return i.Contracts.throwIfDisposed(this.privDisposed), [4, this.implRecognizerStop()];
              case 1:
                return c.sent(), [4, this.privReco.recognize(s, void 0, void 0)];
              case 2:
                return c.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.stopContinuousRecognitionAsyncImpl = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return i.Contracts.throwIfDisposed(this.privDisposed), [4, this.implRecognizerStop()];
              case 1:
                return s.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.implRecognizerStop = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return this.privReco ? [4, this.privReco.stopRecognizing()] : [3, 2];
              case 1:
                s.sent(), s.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.getAuthFromProperties = function(s) {
        var c = s.getProperty(o.PropertyId.SpeechServiceConnection_Key, void 0), l = c && c !== "" ? new r.CognitiveSubscriptionKeyAuthentication(c) : new r.CognitiveTokenAuthentication(function(f) {
          var d = s.getProperty(o.PropertyId.SpeechServiceAuthorization_Token, void 0);
          return Promise.resolve(d);
        }, function(f) {
          var d = s.getProperty(o.PropertyId.SpeechServiceAuthorization_Token, void 0);
          return Promise.resolve(d);
        });
        return l;
      }, u;
    }()
  );
  return xE.Recognizer = a, xE;
}
var NE = {}, Zne;
function Cgr() {
  if (Zne) return NE;
  Zne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }(), t = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, r = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(NE, "__esModule", { value: !0 }), NE.SpeechRecognizer = void 0;
  var n = gr(), i = Ar(), o = tn(), a = Wt(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = this, p = l;
        return o.Contracts.throwIfNull(p, "speechConfig"), o.Contracts.throwIfNullOrWhitespace(p.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage), a.PropertyId[a.PropertyId.SpeechServiceConnection_RecoLanguage]), d = s.call(this, f, p.properties, new n.SpeechConnectionFactory()) || this, d.privDisposedRecognizer = !1, d;
      }
      return c.FromConfig = function(l, f, d) {
        var p = l;
        f.properties.mergeTo(p.properties);
        var v = new c(l, d);
        return v;
      }, Object.defineProperty(c.prototype, "endpointId", {
        /**
         * Gets the endpoint id of a customized speech model that is used for speech recognition.
         * @member SpeechRecognizer.prototype.endpointId
         * @function
         * @public
         * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(a.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(l) {
          o.Contracts.throwIfNullOrWhitespace(l, "token"), this.properties.setProperty(a.PropertyId.SpeechServiceAuthorization_Token, l);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member SpeechRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "outputFormat", {
        /**
         * Gets the output format of recognition.
         * @member SpeechRecognizer.prototype.outputFormat
         * @function
         * @public
         * @returns {OutputFormat} The output format of recognition.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(n.OutputFormatPropertyName, a.OutputFormat[a.OutputFormat.Simple]) === a.OutputFormat[a.OutputFormat.Simple] ? a.OutputFormat.Simple : a.OutputFormat.Detailed;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechRecognizer.
         * @member SpeechRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), c.prototype.recognizeOnceAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(n.RecognitionMode.Interactive), l, f);
      }, c.prototype.startContinuousRecognitionAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(n.RecognitionMode.Conversation), l, f);
      }, c.prototype.stopContinuousRecognitionAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), l, f);
      }, c.prototype.startKeywordRecognitionAsync = function(l, f, d) {
        o.Contracts.throwIfNull(l, "model"), d && d("Not yet implemented.");
      }, c.prototype.stopKeywordRecognitionAsync = function(l, f) {
        l && l();
      }, c.prototype.close = function(l, f) {
        o.Contracts.throwIfDisposed(this.privDisposedRecognizer), i.marshalPromiseToCallbacks(this.dispose(!0), l, f);
      }, c.prototype.dispose = function(l) {
        return t(this, void 0, void 0, function() {
          return r(this, function(f) {
            switch (f.label) {
              case 0:
                return this.privDisposedRecognizer ? [
                  2
                  /*return*/
                ] : l ? (this.privDisposedRecognizer = !0, [4, this.implRecognizerStop()]) : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return [4, s.prototype.dispose.call(this, l)];
              case 3:
                return f.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.createRecognizerConfig = function(l) {
        return new n.RecognizerConfig(l, this.properties);
      }, c.prototype.createServiceRecognizer = function(l, f, d, p) {
        var v = d;
        return new n.SpeechServiceRecognizer(l, f, v, p, this);
      }, c;
    }(a.Recognizer)
  );
  return NE.SpeechRecognizer = u, NE;
}
var LE = {}, Qne;
function Igr() {
  if (Qne) return LE;
  Qne = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }(), t = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, r = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(LE, "__esModule", { value: !0 }), LE.IntentRecognizer = void 0;
  var n = gr(), i = Ar(), o = tn(), a = Wt(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = this;
        o.Contracts.throwIfNullOrUndefined(l, "speechConfig");
        var p = l;
        return o.Contracts.throwIfNullOrUndefined(p, "speechConfig"), d = s.call(this, f, p.properties, new n.IntentConnectionFactory()) || this, d.privAddedIntents = [], d.privAddedLmIntents = {}, d.privDisposedIntentRecognizer = !1, d.privProperties = p.properties, o.Contracts.throwIfNullOrWhitespace(d.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage), a.PropertyId[a.PropertyId.SpeechServiceConnection_RecoLanguage]), d;
      }
      return Object.defineProperty(c.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member IntentRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} the spoken language of recognition.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(a.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
         * @member IntentRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */
        set: function(l) {
          this.properties.setProperty(a.PropertyId.SpeechServiceAuthorization_Token, l);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this IntentRecognizer.
         * @member IntentRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their
         *          values defined for this IntentRecognizer.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), c.prototype.recognizeOnceAsync = function(l, f) {
        if (o.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
          var d = this.buildSpeechContext();
          this.privReco.speechContext.setSection("intent", d.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(d.ReferenceGrammars);
          var p = this.privReco;
          p.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        i.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(n.RecognitionMode.Interactive), l, f);
      }, c.prototype.startContinuousRecognitionAsync = function(l, f) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
          var d = this.buildSpeechContext();
          this.privReco.speechContext.setSection("intent", d.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(d.ReferenceGrammars);
          var p = this.privReco;
          p.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        i.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(n.RecognitionMode.Conversation), l, f);
      }, c.prototype.stopContinuousRecognitionAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), l, f);
      }, c.prototype.startKeywordRecognitionAsync = function(l, f, d) {
        o.Contracts.throwIfNull(l, "model"), d && d("Not yet implemented.");
      }, c.prototype.stopKeywordRecognitionAsync = function(l, f) {
        l && l();
      }, c.prototype.addIntent = function(l, f) {
        o.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), o.Contracts.throwIfNullOrWhitespace(f, "intentId"), o.Contracts.throwIfNullOrWhitespace(l, "simplePhrase"), this.privAddedIntents.push([f, l]);
      }, c.prototype.addIntentWithLanguageModel = function(l, f, d) {
        o.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), o.Contracts.throwIfNullOrWhitespace(l, "intentId"), o.Contracts.throwIfNull(f, "model");
        var p = f;
        o.Contracts.throwIfNullOrWhitespace(p.appId, "model.appId"), this.privAddedLmIntents[l] = new n.AddedLmIntent(p, d);
      }, c.prototype.addAllIntents = function(l, f) {
        o.Contracts.throwIfNull(l, "model");
        var d = l;
        o.Contracts.throwIfNullOrWhitespace(d.appId, "model.appId"), this.privUmbrellaIntent = new n.AddedLmIntent(d, f);
      }, c.prototype.close = function(l, f) {
        o.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), i.marshalPromiseToCallbacks(this.dispose(!0), l, f);
      }, c.prototype.createRecognizerConfig = function(l) {
        return new n.RecognizerConfig(l, this.properties);
      }, c.prototype.createServiceRecognizer = function(l, f, d, p) {
        var v = d;
        return new n.IntentServiceRecognizer(l, f, v, p, this);
      }, c.prototype.dispose = function(l) {
        return t(this, void 0, void 0, function() {
          return r(this, function(f) {
            switch (f.label) {
              case 0:
                return this.privDisposedIntentRecognizer ? [
                  2
                  /*return*/
                ] : l ? (this.privDisposedIntentRecognizer = !0, [4, s.prototype.dispose.call(this, l)]) : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.buildSpeechContext = function() {
        var l, f, d, p = [];
        this.privUmbrellaIntent !== void 0 && (l = this.privUmbrellaIntent.modelImpl.appId, f = this.privUmbrellaIntent.modelImpl.region, d = this.privUmbrellaIntent.modelImpl.subscriptionKey);
        for (var v = 0, h = Object.keys(this.privAddedLmIntents); v < h.length; v++) {
          var E = h[v], m = this.privAddedLmIntents[E];
          if (l === void 0)
            l = m.modelImpl.appId;
          else if (l !== m.modelImpl.appId)
            throw new Error("Intents must all be from the same LUIS model");
          if (f === void 0)
            f = m.modelImpl.region;
          else if (f !== m.modelImpl.region)
            throw new Error("Intents must all be from the same LUIS model in a single region");
          if (d === void 0)
            d = m.modelImpl.subscriptionKey;
          else if (d !== m.modelImpl.subscriptionKey)
            throw new Error("Intents must all use the same subscription key");
          var g = "luis/" + l + "-PRODUCTION#" + E;
          p.push(g);
        }
        return {
          Intent: {
            id: l,
            key: d === void 0 ? this.privProperties.getProperty(a.PropertyId[a.PropertyId.SpeechServiceConnection_Key]) : d,
            provider: "LUIS"
          },
          ReferenceGrammars: this.privUmbrellaIntent === void 0 ? p : ["luis/" + l + "-PRODUCTION"]
        };
      }, c;
    }(a.Recognizer)
  );
  return LE.IntentRecognizer = u, LE;
}
var MN = {}, eie;
function Ogr() {
  return eie || (eie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.VoiceProfileType = void 0, function(t) {
      t[t.TextIndependentIdentification = 0] = "TextIndependentIdentification", t[t.TextDependentVerification = 1] = "TextDependentVerification", t[t.TextIndependentVerification = 2] = "TextIndependentVerification";
    }(e.VoiceProfileType || (e.VoiceProfileType = {}));
  }(MN)), MN;
}
var BE = {}, tie;
function Rgr() {
  if (tie) return BE;
  tie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }(), t = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, r = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(BE, "__esModule", { value: !0 }), BE.TranslationRecognizer = void 0;
  var n = gr(), i = Ar(), o = tn(), a = Wt(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = this, p = l;
        return o.Contracts.throwIfNull(p, "speechConfig"), d = s.call(this, f, p.properties, new n.TranslationConnectionFactory()) || this, d.privDisposedTranslationRecognizer = !1, d.privProperties = p.properties.clone(), d.properties.getProperty(a.PropertyId.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && o.Contracts.throwIfNullOrWhitespace(d.properties.getProperty(a.PropertyId.SpeechServiceConnection_TranslationVoice), a.PropertyId[a.PropertyId.SpeechServiceConnection_TranslationVoice]), o.Contracts.throwIfNullOrWhitespace(d.properties.getProperty(a.PropertyId.SpeechServiceConnection_TranslationToLanguages), a.PropertyId[a.PropertyId.SpeechServiceConnection_TranslationToLanguages]), o.Contracts.throwIfNullOrWhitespace(d.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage), a.PropertyId[a.PropertyId.SpeechServiceConnection_RecoLanguage]), d;
      }
      return Object.defineProperty(c.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the language name that was set when the recognizer was created.
         * @member TranslationRecognizer.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} Gets the language name that was set when the recognizer was created.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "targetLanguages", {
        /**
         * Gets target languages for translation that were set when the recognizer was created.
         * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
         * @member TranslationRecognizer.prototype.targetLanguages
         * @function
         * @public
         * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "voiceName", {
        /**
         * Gets the name of output voice.
         * @member TranslationRecognizer.prototype.voiceName
         * @function
         * @public
         * @returns {string} the name of output voice.
         */
        get: function() {
          return o.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(a.PropertyId.SpeechServiceConnection_TranslationVoice, void 0);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(a.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member TranslationRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} value - Authorization token.
         */
        set: function(l) {
          this.properties.setProperty(a.PropertyId.SpeechServiceAuthorization_Token, l);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this TranslationRecognizer.
         * @member TranslationRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), c.prototype.recognizeOnceAsync = function(l, f) {
        o.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), i.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(n.RecognitionMode.Conversation), l, f);
      }, c.prototype.startContinuousRecognitionAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(n.RecognitionMode.Conversation), l, f);
      }, c.prototype.stopContinuousRecognitionAsync = function(l, f) {
        i.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), l, f);
      }, c.prototype.close = function(l, f) {
        o.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), i.marshalPromiseToCallbacks(this.dispose(!0), l, f);
      }, c.prototype.onConnection = function() {
      }, c.prototype.onDisconnection = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(l) {
            return [
              2
              /*return*/
            ];
          });
        });
      }, c.prototype.dispose = function(l) {
        return t(this, void 0, void 0, function() {
          return r(this, function(f) {
            switch (f.label) {
              case 0:
                return this.privDisposedTranslationRecognizer ? [
                  2
                  /*return*/
                ] : (this.privDisposedTranslationRecognizer = !0, l ? [4, this.implRecognizerStop()] : [3, 3]);
              case 1:
                return f.sent(), [4, s.prototype.dispose.call(this, l)];
              case 2:
                f.sent(), f.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.createRecognizerConfig = function(l) {
        return new n.RecognizerConfig(l, this.properties);
      }, c.prototype.createServiceRecognizer = function(l, f, d, p) {
        var v = d;
        return new n.TranslationServiceRecognizer(l, f, v, p, this);
      }, c;
    }(a.Recognizer)
  );
  return BE.TranslationRecognizer = u, BE;
}
var kE = {}, rie;
function wgr() {
  if (rie) return kE;
  rie = 1, Object.defineProperty(kE, "__esModule", { value: !0 }), kE.Translations = void 0;
  var e = Wt(), t = (
    /** @class */
    function() {
      function r() {
        this.privMap = new e.PropertyCollection();
      }
      return r.prototype.get = function(n, i) {
        return this.privMap.getProperty(n, i);
      }, r.prototype.set = function(n, i) {
        this.privMap.setProperty(n, i);
      }, r;
    }()
  );
  return kE.Translations = t, kE;
}
var FN = {}, nie;
function Pgr() {
  return nie || (nie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.NoMatchReason = void 0, function(t) {
      t[t.NotRecognized = 0] = "NotRecognized", t[t.InitialSilenceTimeout = 1] = "InitialSilenceTimeout", t[t.InitialBabbleTimeout = 2] = "InitialBabbleTimeout";
    }(e.NoMatchReason || (e.NoMatchReason = {}));
  }(FN)), FN;
}
var ME = {}, iie;
function Dgr() {
  if (iie) return ME;
  iie = 1, Object.defineProperty(ME, "__esModule", { value: !0 }), ME.NoMatchDetails = void 0;
  var e = gr(), t = Wt(), r = (
    /** @class */
    function() {
      function n(i) {
        this.privReason = i;
      }
      return n.fromResult = function(i) {
        var o = e.SimpleSpeechPhrase.fromJSON(i.json), a = t.NoMatchReason.NotRecognized;
        switch (o.RecognitionStatus) {
          case e.RecognitionStatus.BabbleTimeout:
            a = t.NoMatchReason.InitialBabbleTimeout;
            break;
          case e.RecognitionStatus.InitialSilenceTimeout:
            a = t.NoMatchReason.InitialSilenceTimeout;
            break;
          default:
            a = t.NoMatchReason.NotRecognized;
            break;
        }
        return new n(a);
      }, Object.defineProperty(n.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member NoMatchDetails.prototype.reason
         * @function
         * @public
         * @returns {NoMatchReason} Specifies the reason canceled.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return ME.NoMatchDetails = r, ME;
}
var FE = {}, oie;
function xgr() {
  if (oie) return FE;
  oie = 1, Object.defineProperty(FE, "__esModule", { value: !0 }), FE.TranslationRecognitionCanceledEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i, o, a) {
        this.privCancelReason = n, this.privErrorDetails = i, this.privResult = a, this.privSessionId = r, this.privErrorCode = o;
      }
      return Object.defineProperty(t.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @member TranslationRecognitionCanceledEventArgs.prototype.result
         * @function
         * @public
         * @returns {TranslationRecognitionResult} the recognition result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "sessionId", {
        /**
         * Specifies the session identifier.
         * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
         * @function
         * @public
         * @returns {string} the session identifier.
         */
        get: function() {
          return this.privSessionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member TranslationRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */
        get: function() {
          return this.privCancelReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */
        get: function() {
          return this.privErrorCode;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return FE.TranslationRecognitionCanceledEventArgs = e, FE;
}
var HE = {}, aie;
function Ngr() {
  if (aie) return HE;
  aie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(HE, "__esModule", { value: !0 }), HE.IntentRecognitionCanceledEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c, l) {
        var f = n.call(this, s, c, l) || this;
        return f.privReason = o, f.privErrorDetails = a, f.privErrorCode = u, f;
      }
      return Object.defineProperty(i.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member IntentRecognitionCanceledEventArgs.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "errorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */
        get: function() {
          return this.privErrorCode;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.IntentRecognitionEventArgs)
  );
  return HE.IntentRecognitionCanceledEventArgs = r, HE;
}
var $E = {}, uie;
function s4e() {
  if (uie) return $E;
  uie = 1, Object.defineProperty($E, "__esModule", { value: !0 }), $E.CancellationDetailsBase = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i) {
        this.privReason = r, this.privErrorDetails = n, this.privErrorCode = i;
      }
      return Object.defineProperty(t.prototype, "reason", {
        /**
         * The reason the recognition was canceled.
         * @member CancellationDetailsBase.prototype.reason
         * @function
         * @public
         * @returns {CancellationReason} Specifies the reason canceled.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful recognition, provides details of the occurred error.
         * @member CancellationDetailsBase.prototype.errorDetails
         * @function
         * @public
         * @returns {string} A String that represents the error details.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "ErrorCode", {
        /**
         * The error code in case of an unsuccessful recognition.
         * Added in version 1.1.0.
         * @return An error code that represents the error reason.
         */
        get: function() {
          return this.privErrorCode;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return $E.CancellationDetailsBase = e, $E;
}
var UE = {}, sie;
function Lgr() {
  if (sie) return UE;
  sie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }();
  Object.defineProperty(UE, "__esModule", { value: !0 }), UE.CancellationDetails = void 0;
  var t = gr(), r = s4e(), n = Wt(), i = (
    /** @class */
    function(o) {
      e(a, o);
      function a(u, s, c) {
        return o.call(this, u, s, c) || this;
      }
      return a.fromResult = function(u) {
        var s = n.CancellationReason.Error, c = n.CancellationErrorCode.NoError;
        if (u instanceof n.RecognitionResult && u.json) {
          var l = t.SimpleSpeechPhrase.fromJSON(u.json);
          s = t.EnumTranslation.implTranslateCancelResult(l.RecognitionStatus);
        }
        return u.properties && (c = n.CancellationErrorCode[u.properties.getProperty(t.CancellationErrorCodePropertyName, n.CancellationErrorCode[n.CancellationErrorCode.NoError])]), new a(s, u.errorDetails, c);
      }, a;
    }(r.CancellationDetailsBase)
  );
  return UE.CancellationDetails = i, UE;
}
var HN = {}, cie;
function Bgr() {
  return cie || (cie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.CancellationErrorCode = void 0, function(t) {
      t[t.NoError = 0] = "NoError", t[t.AuthenticationFailure = 1] = "AuthenticationFailure", t[t.BadRequestParameters = 2] = "BadRequestParameters", t[t.TooManyRequests = 3] = "TooManyRequests", t[t.ConnectionFailure = 4] = "ConnectionFailure", t[t.ServiceTimeout = 5] = "ServiceTimeout", t[t.ServiceError = 6] = "ServiceError", t[t.RuntimeError = 7] = "RuntimeError";
    }(e.CancellationErrorCode || (e.CancellationErrorCode = {}));
  }(HN)), HN;
}
var VE = {}, lie;
function kgr() {
  if (lie) return VE;
  lie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(VE, "__esModule", { value: !0 }), VE.ConnectionEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return i;
    }(t.SessionEventArgs)
  );
  return VE.ConnectionEventArgs = r, VE;
}
var jE = {}, fie;
function Mgr() {
  if (fie) return jE;
  fie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(jE, "__esModule", { value: !0 }), jE.ServiceEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u) {
        var s = n.call(this, u) || this;
        return s.privJsonResult = o, s.privEventName = a, s;
      }
      return Object.defineProperty(i.prototype, "jsonString", {
        get: function() {
          return this.privJsonResult;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "eventName", {
        get: function() {
          return this.privEventName;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SessionEventArgs)
  );
  return jE.ServiceEventArgs = r, jE;
}
var zE = {}, F0 = {}, die;
function c4e() {
  if (die) return F0;
  die = 1, Object.defineProperty(F0, "__esModule", { value: !0 }), F0.ConnectionMessageImpl = F0.ConnectionMessage = void 0;
  var e = vc(), t = Ar(), r = u4e(), n = kH(), i = (
    /** @class */
    /* @__PURE__ */ function() {
      function a() {
      }
      return a;
    }()
  );
  F0.ConnectionMessage = i;
  var o = (
    /** @class */
    function() {
      function a(u) {
        var s = this;
        this.privConnectionMessage = u, this.privProperties = new r.PropertyCollection(), this.privConnectionMessage.headers[e.HeaderNames.ConnectionId] && this.privProperties.setProperty(n.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[e.HeaderNames.ConnectionId]), Object.keys(this.privConnectionMessage.headers).forEach(function(c, l, f) {
          s.privProperties.setProperty(c, s.privConnectionMessage.headers[c]);
        });
      }
      return Object.defineProperty(a.prototype, "path", {
        /**
         * The message path.
         */
        get: function() {
          return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find(function(u) {
            return u.toLowerCase() === "path".toLowerCase();
          })];
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "isTextMessage", {
        /**
         * Checks to see if the ConnectionMessage is a text message.
         * See also IsBinaryMessage().
         */
        get: function() {
          return this.privConnectionMessage.messageType === t.MessageType.Text;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "isBinaryMessage", {
        /**
         * Checks to see if the ConnectionMessage is a binary message.
         * See also GetBinaryMessage().
         */
        get: function() {
          return this.privConnectionMessage.messageType === t.MessageType.Binary;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "TextMessage", {
        /**
         * Gets the text message payload. Typically the text message content-type is
         * application/json. To determine other content-types use
         * Properties.GetProperty("Content-Type").
         */
        get: function() {
          return this.privConnectionMessage.textBody;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "binaryMessage", {
        /**
         * Gets the binary message payload.
         */
        get: function() {
          return this.privConnectionMessage.binaryBody;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "properties", {
        /**
         * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
         * Message headers can be accessed via this collection (e.g. "Content-Type").
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.toString = function() {
        return "";
      }, a;
    }()
  );
  return F0.ConnectionMessageImpl = o, F0;
}
var pie;
function Fgr() {
  if (pie) return zE;
  pie = 1, Object.defineProperty(zE, "__esModule", { value: !0 }), zE.Connection = void 0;
  var e = gr(), t = Ar(), r = c4e(), n = tn(), i = Wt(), o = (
    /** @class */
    function() {
      function a() {
      }
      return a.fromRecognizer = function(u) {
        var s = u.internalData, c = new a();
        return c.privInternalData = s, c.setupEvents(), c;
      }, a.fromSynthesizer = function(u) {
        var s = u.internalData, c = new a();
        return c.privInternalData = s, c.setupEvents(), c;
      }, a.prototype.openConnection = function(u, s) {
        t.marshalPromiseToCallbacks(this.privInternalData.connect(), u, s);
      }, a.prototype.closeConnection = function(u, s) {
        if (this.privInternalData instanceof e.SynthesisAdapterBase)
          throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        t.marshalPromiseToCallbacks(this.privInternalData.disconnect(), u, s);
      }, a.prototype.setMessageProperty = function(u, s, c) {
        if (n.Contracts.throwIfNullOrWhitespace(s, "propertyName"), this.privInternalData instanceof e.ServiceRecognizerBase) {
          if (u.toLowerCase() !== "speech.context")
            throw new Error("Only speech.context message property sets are currently supported for recognizer");
          this.privInternalData.speechContext.setSection(s, c);
        } else if (this.privInternalData instanceof e.SynthesisAdapterBase) {
          if (u.toLowerCase() !== "synthesis.context")
            throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
          this.privInternalData.synthesisContext.setSection(s, c);
        }
      }, a.prototype.sendMessageAsync = function(u, s, c, l) {
        t.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(u, s), c, l);
      }, a.prototype.close = function() {
      }, a.prototype.setupEvents = function() {
        var u = this;
        this.privEventListener = this.privInternalData.connectionEvents.attach(function(s) {
          s.name === "ConnectionEstablishedEvent" ? u.connected && u.connected(new i.ConnectionEventArgs(s.connectionId)) : s.name === "ConnectionClosedEvent" ? u.disconnected && u.disconnected(new i.ConnectionEventArgs(s.connectionId)) : s.name === "ConnectionMessageSentEvent" ? u.messageSent && u.messageSent(new i.ConnectionMessageEventArgs(new r.ConnectionMessageImpl(s.message))) : s.name === "ConnectionMessageReceivedEvent" && u.messageReceived && u.messageReceived(new i.ConnectionMessageEventArgs(new r.ConnectionMessageImpl(s.message)));
        }), this.privServiceEventListener = this.privInternalData.serviceEvents.attach(function(s) {
          u.receivedServiceMessage && u.receivedServiceMessage(new i.ServiceEventArgs(s.jsonString, s.name));
        });
      }, a;
    }()
  );
  return zE.Connection = o, zE;
}
var qE = {}, hie;
function Hgr() {
  if (hie) return qE;
  hie = 1, Object.defineProperty(qE, "__esModule", { value: !0 }), qE.PhraseListGrammar = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privGrammerBuilder = r.dynamicGrammar;
      }
      return t.fromRecognizer = function(r) {
        var n = r.internalData;
        return new t(n);
      }, t.prototype.addPhrase = function(r) {
        this.privGrammerBuilder.addPhrase(r);
      }, t.prototype.addPhrases = function(r) {
        this.privGrammerBuilder.addPhrase(r);
      }, t.prototype.clear = function() {
        this.privGrammerBuilder.clearPhrases();
      }, t;
    }()
  );
  return qE.PhraseListGrammar = e, qE;
}
var H0 = {}, vie;
function MH() {
  if (vie) return H0;
  vie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }();
  Object.defineProperty(H0, "__esModule", { value: !0 }), H0.DialogServiceConfigImpl = H0.DialogServiceConfig = void 0;
  var t = tn(), r = Wt(), n = (
    /** @class */
    function() {
      function o() {
      }
      Object.defineProperty(o.prototype, "applicationId", {
        /**
         * Sets the corresponding backend application identifier.
         * @member DialogServiceConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */
        // tslint:disable-next-line: no-empty
        set: function(u) {
        },
        enumerable: !1,
        configurable: !0
      });
      var a;
      return o.DialogTypes = (a = /** @class */
      /* @__PURE__ */ function() {
        function u() {
        }
        return u;
      }(), a.BotFramework = "bot_framework", a.CustomCommands = "custom_commands", a), o;
    }()
  );
  H0.DialogServiceConfig = n;
  var i = (
    /** @class */
    function(o) {
      e(a, o);
      function a() {
        var u = o.call(this) || this;
        return u.privSpeechConfig = new r.SpeechConfigImpl(), u;
      }
      return Object.defineProperty(a.prototype, "properties", {
        /**
         * Provides access to custom properties.
         * @member DialogServiceConfigImpl.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The properties.
         */
        get: function() {
          return this.privSpeechConfig.properties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         */
        get: function() {
          return this.privSpeechConfig.speechRecognitionLanguage;
        },
        /**
         * Sets the speech recognition language.
         * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @param {string} value - The language to set.
         */
        set: function(u) {
          t.Contracts.throwIfNullOrWhitespace(u, "value"), this.privSpeechConfig.speechRecognitionLanguage = u;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "outputFormat", {
        get: function() {
          return this.privSpeechConfig.outputFormat;
        },
        set: function(u) {
          this.privSpeechConfig.outputFormat = u;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.setProperty = function(u, s) {
        this.privSpeechConfig.setProperty(u, s);
      }, a.prototype.getProperty = function(u, s) {
        return this.privSpeechConfig.getProperty(u);
      }, a.prototype.setProxy = function(u, s, c, l) {
        this.setProperty(r.PropertyId.SpeechServiceConnection_ProxyHostName, u), this.setProperty(r.PropertyId.SpeechServiceConnection_ProxyPort, "" + s), c && this.setProperty(r.PropertyId.SpeechServiceConnection_ProxyUserName, c), l && this.setProperty(r.PropertyId.SpeechServiceConnection_ProxyPassword, l);
      }, a.prototype.setServiceProperty = function(u, s, c) {
        this.privSpeechConfig.setServiceProperty(u, s, c);
      }, a.prototype.close = function() {
      }, a;
    }(n)
  );
  return H0.DialogServiceConfigImpl = i, H0;
}
var YE = {}, Eie;
function $gr() {
  if (Eie) return YE;
  Eie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }();
  Object.defineProperty(YE, "__esModule", { value: !0 }), YE.BotFrameworkConfig = void 0;
  var t = tn(), r = MH(), n = Wt(), i = (
    /** @class */
    function(o) {
      e(a, o);
      function a() {
        return o.call(this) || this;
      }
      return a.fromSubscription = function(u, s, c) {
        t.Contracts.throwIfNullOrWhitespace(u, "subscription"), t.Contracts.throwIfNullOrWhitespace(s, "region");
        var l = new r.DialogServiceConfigImpl();
        return l.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.BotFramework), l.setProperty(n.PropertyId.SpeechServiceConnection_Key, u), l.setProperty(n.PropertyId.SpeechServiceConnection_Region, s), c && l.setProperty(n.PropertyId.Conversation_ApplicationId, c), l;
      }, a.fromAuthorizationToken = function(u, s, c) {
        t.Contracts.throwIfNullOrWhitespace(u, "authorizationToken"), t.Contracts.throwIfNullOrWhitespace(s, "region");
        var l = new r.DialogServiceConfigImpl();
        return l.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.BotFramework), l.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, u), l.setProperty(n.PropertyId.SpeechServiceConnection_Region, s), c && l.setProperty(n.PropertyId.Conversation_ApplicationId, c), l;
      }, a.fromHost = function(u, s, c) {
        t.Contracts.throwIfNullOrUndefined(u, "host");
        var l = u instanceof URL ? u : new URL("wss://" + u + ".convai.speech.azure.us");
        t.Contracts.throwIfNullOrUndefined(l, "resolvedHost");
        var f = new r.DialogServiceConfigImpl();
        return f.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.BotFramework), f.setProperty(n.PropertyId.SpeechServiceConnection_Host, l.toString()), s !== void 0 && f.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), f;
      }, a.fromEndpoint = function(u, s) {
        t.Contracts.throwIfNull(u, "endpoint");
        var c = new r.DialogServiceConfigImpl();
        return c.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.BotFramework), c.setProperty(n.PropertyId.SpeechServiceConnection_Endpoint, u.toString()), s !== void 0 && c.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), c;
      }, a;
    }(r.DialogServiceConfigImpl)
  );
  return YE.BotFrameworkConfig = i, YE;
}
var GE = {}, mie;
function Ugr() {
  if (mie) return GE;
  mie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }();
  Object.defineProperty(GE, "__esModule", { value: !0 }), GE.CustomCommandsConfig = void 0;
  var t = tn(), r = MH(), n = Wt(), i = (
    /** @class */
    function(o) {
      e(a, o);
      function a() {
        return o.call(this) || this;
      }
      return a.fromSubscription = function(u, s, c) {
        t.Contracts.throwIfNullOrWhitespace(u, "applicationId"), t.Contracts.throwIfNullOrWhitespace(s, "subscription"), t.Contracts.throwIfNullOrWhitespace(c, "region");
        var l = new r.DialogServiceConfigImpl();
        return l.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.CustomCommands), l.setProperty(n.PropertyId.Conversation_ApplicationId, u), l.setProperty(n.PropertyId.SpeechServiceConnection_Key, s), l.setProperty(n.PropertyId.SpeechServiceConnection_Region, c), l;
      }, a.fromAuthorizationToken = function(u, s, c) {
        t.Contracts.throwIfNullOrWhitespace(u, "applicationId"), t.Contracts.throwIfNullOrWhitespace(s, "authorizationToken"), t.Contracts.throwIfNullOrWhitespace(c, "region");
        var l = new r.DialogServiceConfigImpl();
        return l.setProperty(n.PropertyId.Conversation_DialogType, r.DialogServiceConfig.DialogTypes.CustomCommands), l.setProperty(n.PropertyId.Conversation_ApplicationId, u), l.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, s), l.setProperty(n.PropertyId.SpeechServiceConnection_Region, c), l;
      }, Object.defineProperty(a.prototype, "applicationId", {
        /**
         * Gets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to get.
         */
        get: function() {
          return this.getProperty(n.PropertyId.Conversation_ApplicationId);
        },
        /**
         * Sets the corresponding backend application identifier.
         * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
         * @function
         * @public
         * @param {string} value - The application identifier to set.
         */
        set: function(u) {
          t.Contracts.throwIfNullOrWhitespace(u, "value"), this.setProperty(n.PropertyId.Conversation_ApplicationId, u);
        },
        enumerable: !1,
        configurable: !0
      }), a;
    }(r.DialogServiceConfigImpl)
  );
  return GE.CustomCommandsConfig = i, GE;
}
var WE = {}, KE = {}, XE = {}, JE = {}, gie;
function ev() {
  if (gie) return JE;
  gie = 1, Object.defineProperty(JE, "__esModule", { value: !0 }), JE.QueryParameterNames = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.BotId = "botid", t.CustomSpeechDeploymentId = "cid", t.CustomVoiceDeploymentId = "deploymentId", t.EnableAudioLogging = "storeAudio", t.EnableLanguageId = "lidEnabled", t.EnableWordLevelTimestamps = "wordLevelTimestamps", t.EndSilenceTimeoutMs = "endSilenceTimeoutMs", t.Format = "format", t.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs", t.Language = "language", t.Profanity = "profanity", t.RequestBotStatusMessages = "enableBotMessageStatus", t.StableIntermediateThreshold = "stableIntermediateThreshold", t.StableTranslation = "stableTranslation", t.TestHooks = "testhooks", t;
    }()
  );
  return JE.QueryParameterNames = e, JE;
}
var Tie;
function tv() {
  if (Tie) return XE;
  Tie = 1, Object.defineProperty(XE, "__esModule", { value: !0 }), XE.ConnectionFactoryBase = void 0;
  var e = gr(), t = Wt(), r = ev(), n = (
    /** @class */
    function() {
      function i() {
      }
      return i.prototype.setCommonUrlParams = function(o, a, u) {
        this.setUrlParameter(t.PropertyId.SpeechServiceConnection_EnableAudioLogging, r.QueryParameterNames.EnableAudioLogging, o, a, u), this.setUrlParameter(t.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, r.QueryParameterNames.EnableWordLevelTimestamps, o, a, u), this.setUrlParameter(t.PropertyId.SpeechServiceResponse_ProfanityOption, r.QueryParameterNames.Profanity, o, a, u), this.setUrlParameter(t.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, r.QueryParameterNames.InitialSilenceTimeoutMs, o, a, u), this.setUrlParameter(t.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, r.QueryParameterNames.EndSilenceTimeoutMs, o, a, u), this.setUrlParameter(t.PropertyId.SpeechServiceResponse_StablePartialResultThreshold, r.QueryParameterNames.StableIntermediateThreshold, o, a, u);
        var s = JSON.parse(o.parameters.getProperty(e.ServicePropertiesPropertyName, "{}"));
        Object.keys(s).forEach(function(c, l, f) {
          a[c] = s[c];
        });
      }, i.prototype.setUrlParameter = function(o, a, u, s, c) {
        var l = u.parameters.getProperty(o, void 0);
        l && (!c || c.search(a) === -1) && (s[a] = l.toLocaleLowerCase());
      }, i;
    }()
  );
  return XE.ConnectionFactoryBase = n, XE;
}
var yie;
function Vgr() {
  if (yie) return KE;
  yie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var c = function(l, f) {
      return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, p) {
        d.__proto__ = p;
      } || function(d, p) {
        for (var v in p) p.hasOwnProperty(v) && (d[v] = p[v]);
      }, c(l, f);
    };
    return function(l, f) {
      c(l, f);
      function d() {
        this.constructor = l;
      }
      l.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
    };
  }();
  Object.defineProperty(KE, "__esModule", { value: !0 }), KE.DialogConnectionFactory = void 0;
  var t = Yu(), r = gr(), n = Wt(), i = tv(), o = gr(), a = vc(), u = ev(), s = (
    /** @class */
    function(c) {
      e(l, c);
      function l() {
        var d = c !== null && c.apply(this, arguments) || this;
        return d.create = function(p, v, h) {
          var E = p.parameters.getProperty(n.PropertyId.Conversation_ApplicationId, ""), m = p.parameters.getProperty(n.PropertyId.Conversation_DialogType), g = p.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Region), y = p.parameters.getProperty(n.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US"), _ = p.parameters.getProperty(n.PropertyId.Conversation_Request_Bot_Status_Messages, "true"), S = {};
          S[a.HeaderNames.ConnectionId] = h, S[u.QueryParameterNames.Format] = p.parameters.getProperty(r.OutputFormatPropertyName, n.OutputFormat[n.OutputFormat.Simple]).toLowerCase(), S[u.QueryParameterNames.Language] = y, S[u.QueryParameterNames.RequestBotStatusMessages] = _, E && (S[u.QueryParameterNames.BotId] = E, m === n.DialogServiceConfig.DialogTypes.CustomCommands && (S[a.HeaderNames.CustomCommandsAppId] = E));
          var A = m === n.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "", O = m === n.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : m === n.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0", P = {};
          v.token != null && v.token !== "" && (P[v.headerName] = v.token);
          var U = p.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Endpoint, "");
          if (!U) {
            var z = g && g.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", k = p.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Host, "wss://" + g + "." + l.Constants.BaseUrl + z), H = k.endsWith("/") ? k : k + "/";
            U = "" + H + A + l.Constants.ApiKey + "/" + O;
          }
          d.setCommonUrlParams(p, S, U);
          var B = p.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new t.WebsocketConnection(U, S, P, new o.WebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(p), B, h);
        }, d;
      }
      var f;
      return l.Constants = (f = /** @class */
      /* @__PURE__ */ function() {
        function d() {
        }
        return d;
      }(), f.ApiKey = "api", f.BaseUrl = "convai.speech", f), l;
    }(i.ConnectionFactoryBase)
  );
  return KE.DialogConnectionFactory = s, KE;
}
var _ie;
function jgr() {
  if (_ie) return WE;
  _ie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var l = function(f, d) {
      return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, v) {
        p.__proto__ = v;
      } || function(p, v) {
        for (var h in v) v.hasOwnProperty(h) && (p[h] = v[h]);
      }, l(f, d);
    };
    return function(f, d) {
      l(f, d);
      function p() {
        this.constructor = f;
      }
      f.prototype = d === null ? Object.create(d) : (p.prototype = d.prototype, new p());
    };
  }(), t = fe && fe.__awaiter || function(l, f, d, p) {
    function v(h) {
      return h instanceof d ? h : new d(function(E) {
        E(h);
      });
    }
    return new (d || (d = Promise))(function(h, E) {
      function m(_) {
        try {
          y(p.next(_));
        } catch (S) {
          E(S);
        }
      }
      function g(_) {
        try {
          y(p.throw(_));
        } catch (S) {
          E(S);
        }
      }
      function y(_) {
        _.done ? h(_.value) : v(_.value).then(m, g);
      }
      y((p = p.apply(l, f || [])).next());
    });
  }, r = fe && fe.__generator || function(l, f) {
    var d = { label: 0, sent: function() {
      if (h[0] & 1) throw h[1];
      return h[1];
    }, trys: [], ops: [] }, p, v, h, E;
    return E = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (E[Symbol.iterator] = function() {
      return this;
    }), E;
    function m(y) {
      return function(_) {
        return g([y, _]);
      };
    }
    function g(y) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; d; ) try {
        if (p = 1, v && (h = y[0] & 2 ? v.return : y[0] ? v.throw || ((h = v.return) && h.call(v), 0) : v.next) && !(h = h.call(v, y[1])).done) return h;
        switch (v = 0, h && (y = [y[0] & 2, h.value]), y[0]) {
          case 0:
          case 1:
            h = y;
            break;
          case 4:
            return d.label++, { value: y[1], done: !1 };
          case 5:
            d.label++, v = y[1], y = [0];
            continue;
          case 7:
            y = d.ops.pop(), d.trys.pop();
            continue;
          default:
            if (h = d.trys, !(h = h.length > 0 && h[h.length - 1]) && (y[0] === 6 || y[0] === 2)) {
              d = 0;
              continue;
            }
            if (y[0] === 3 && (!h || y[1] > h[0] && y[1] < h[3])) {
              d.label = y[1];
              break;
            }
            if (y[0] === 6 && d.label < h[1]) {
              d.label = h[1], h = y;
              break;
            }
            if (h && d.label < h[2]) {
              d.label = h[2], d.ops.push(y);
              break;
            }
            h[2] && d.ops.pop(), d.trys.pop();
            continue;
        }
        y = f.call(l, d);
      } catch (_) {
        y = [6, _], v = 0;
      } finally {
        p = h = 0;
      }
      if (y[0] & 5) throw y[1];
      return { value: y[0] ? y[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(WE, "__esModule", { value: !0 }), WE.DialogServiceConnector = void 0;
  var n = Vgr(), i = gr(), o = Ar(), a = tn(), u = Wt(), s = kH(), c = (
    /** @class */
    function(l) {
      e(f, l);
      function f(d, p) {
        var v = this, h = d;
        a.Contracts.throwIfNull(d, "dialogConfig"), v = l.call(this, p, h.properties, new n.DialogConnectionFactory()) || this, v.isTurnComplete = !0, v.privIsDisposed = !1, v.privProperties = h.properties.clone();
        var E = v.buildAgentConfig();
        return v.privReco.agentConfig.set(E), v;
      }
      return f.prototype.connect = function(d, p) {
        o.marshalPromiseToCallbacks(this.privReco.connect(), d, p);
      }, f.prototype.disconnect = function(d, p) {
        o.marshalPromiseToCallbacks(this.privReco.disconnect(), d, p);
      }, Object.defineProperty(f.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(s.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Sets the authorization token used to communicate with the service.
         * @member DialogServiceConnector.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(d) {
          a.Contracts.throwIfNullOrWhitespace(d, "token"), this.properties.setProperty(s.PropertyId.SpeechServiceAuthorization_Token, d);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this DialogServiceConnector.
         * @member DialogServiceConnector.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "speechActivityTemplate", {
        /** Gets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be empty
         */
        get: function() {
          return this.properties.getProperty(s.PropertyId.Conversation_Speech_Activity_Template);
        },
        /** Sets the template for the activity generated by service from speech.
         * Properties from the template will be stamped on the generated activity.
         * It can be null or empty.
         * Note: it has to be a valid Json object.
         */
        set: function(d) {
          this.properties.setProperty(s.PropertyId.Conversation_Speech_Activity_Template, d);
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.listenOnceAsync = function(d, p) {
        var v = this;
        if (this.isTurnComplete) {
          a.Contracts.throwIfDisposed(this.privIsDisposed);
          var h = function() {
            return t(v, void 0, void 0, function() {
              var m, g;
              return r(this, function(y) {
                switch (y.label) {
                  case 0:
                    return [4, this.privReco.connect()];
                  case 1:
                    return y.sent(), [4, this.implRecognizerStop()];
                  case 2:
                    return y.sent(), this.isTurnComplete = !1, m = new o.Deferred(), [4, this.privReco.recognize(i.RecognitionMode.Conversation, m.resolve, m.reject)];
                  case 3:
                    return y.sent(), [4, m.promise];
                  case 4:
                    return g = y.sent(), [4, this.implRecognizerStop()];
                  case 5:
                    return y.sent(), [2, g];
                }
              });
            });
          }, E = h();
          E.catch(function() {
            v.dispose(!0).catch(function() {
            });
          }), o.marshalPromiseToCallbacks(E.finally(function() {
            v.isTurnComplete = !0;
          }), d, p);
        }
      }, f.prototype.sendActivityAsync = function(d, p, v) {
        o.marshalPromiseToCallbacks(this.privReco.sendMessage(d), p, v);
      }, f.prototype.close = function(d, p) {
        a.Contracts.throwIfDisposed(this.privIsDisposed), o.marshalPromiseToCallbacks(this.dispose(!0), d, p);
      }, f.prototype.dispose = function(d) {
        return t(this, void 0, void 0, function() {
          return r(this, function(p) {
            switch (p.label) {
              case 0:
                return this.privIsDisposed ? [
                  2
                  /*return*/
                ] : d ? (this.privIsDisposed = !0, [4, this.implRecognizerStop()]) : [3, 3];
              case 1:
                return p.sent(), [4, l.prototype.dispose.call(this, d)];
              case 2:
                p.sent(), p.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f.prototype.createRecognizerConfig = function(d) {
        return new i.RecognizerConfig(d, this.privProperties);
      }, f.prototype.createServiceRecognizer = function(d, p, v, h) {
        var E = v;
        return new i.DialogServiceAdapter(d, p, E, h, this);
      }, f.prototype.buildAgentConfig = function() {
        var d = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
          botInfo: {
            commType: d,
            commandsCulture: void 0,
            connectionId: this.properties.getProperty(s.PropertyId.Conversation_Agent_Connection_Id),
            conversationId: this.properties.getProperty(s.PropertyId.Conversation_Conversation_Id, void 0),
            fromId: this.properties.getProperty(s.PropertyId.Conversation_From_Id, void 0),
            ttsAudioFormat: this.properties.getProperty(s.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)
          },
          version: 0.2
        };
      }, f;
    }(u.Recognizer)
  );
  return WE.DialogServiceConnector = c, WE;
}
var ZE = {}, Aie;
function zgr() {
  if (Aie) return ZE;
  Aie = 1, Object.defineProperty(ZE, "__esModule", { value: !0 }), ZE.ActivityReceivedEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privActivity = r, this.privAudioStream = n;
      }
      return Object.defineProperty(t.prototype, "activity", {
        /**
         * Gets the received activity
         * @member ActivityReceivedEventArgs.prototype.activity
         * @function
         * @public
         * @returns {any} the received activity.
         */
        get: function() {
          return this.privActivity;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "audioStream", {
        get: function() {
          return this.privAudioStream;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return ZE.ActivityReceivedEventArgs = e, ZE;
}
var QE = {}, em = {}, Sie;
function qgr() {
  if (Sie) return em;
  Sie = 1, Object.defineProperty(em, "__esModule", { value: !0 }), em.TurnStatusResponsePayload = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privMessageStatusResponse = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "interactionId", {
        get: function() {
          return this.privMessageStatusResponse.interactionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "conversationId", {
        get: function() {
          return this.privMessageStatusResponse.conversationId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "statusCode", {
        get: function() {
          switch (this.privMessageStatusResponse.statusCode) {
            case "Success":
              return 200;
            case "Failed":
              return 400;
            case "TimedOut":
              return 429;
            default:
              return this.privMessageStatusResponse.statusCode;
          }
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return em.TurnStatusResponsePayload = e, em;
}
var bie;
function Ygr() {
  if (bie) return QE;
  bie = 1, Object.defineProperty(QE, "__esModule", { value: !0 }), QE.TurnStatusReceivedEventArgs = void 0;
  var e = qgr(), t = (
    /** @class */
    function() {
      function r(n) {
        this.privTurnStatus = e.TurnStatusResponsePayload.fromJSON(n);
      }
      return Object.defineProperty(r.prototype, "interactionId", {
        /**
         * Gets the interaction identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.interactionId
         * @function
         * @public
         * @returns {any} the received interaction id.
         */
        get: function() {
          return this.privTurnStatus.interactionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "conversationId", {
        /**
         * Gets the conversation identifier associated with this turn status event.
         * @member TurnStatusReceivedEventArgs.prototype.conversationId
         * @function
         * @public
         * @returns {any} the received conversation id.
         */
        get: function() {
          return this.privTurnStatus.conversationId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "statusCode", {
        /**
         * Gets the received turn status code.
         * @member TurnStatusReceivedEventArgs.prototype.statusCode
         * @function
         * @public
         * @returns {number} the received turn status.
         */
        get: function() {
          return this.privTurnStatus.statusCode;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return QE.TurnStatusReceivedEventArgs = t, QE;
}
var $N = {}, Cie;
function Ggr() {
  return Cie || (Cie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ServicePropertyChannel = void 0, function(t) {
      t[t.UriQueryParameter = 0] = "UriQueryParameter";
    }(e.ServicePropertyChannel || (e.ServicePropertyChannel = {}));
  }($N)), $N;
}
var UN = {}, Iie;
function Wgr() {
  return Iie || (Iie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ProfanityOption = void 0, function(t) {
      t[t.Masked = 0] = "Masked", t[t.Removed = 1] = "Removed", t[t.Raw = 2] = "Raw";
    }(e.ProfanityOption || (e.ProfanityOption = {}));
  }(UN)), UN;
}
var tm = {}, Oie;
function Kgr() {
  if (Oie) return tm;
  Oie = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(tm, "__esModule", { value: !0 }), tm.BaseAudioPlayer = void 0;
  var r = hc(), n = xH(), i = Wt(), o = Td(), a = (
    /** @class */
    function() {
      function u(s) {
        this.audioContext = null, this.gainNode = null, this.autoUpdateBufferTimer = 0, s === void 0 && (s = i.AudioStreamFormat.getDefaultInputFormat()), this.init(s);
      }
      return u.prototype.playAudioSample = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d, p;
            return t(this, function(v) {
              return this.ensureInitializedContext(), d = this.formatAudioData(s), p = new Float32Array(this.samples.length + d.length), p.set(this.samples, 0), p.set(d, this.samples.length), this.samples = p, [
                2
                /*return*/
              ];
            });
          });
        }(), c, l);
      }, u.prototype.stopAudio = function(s, c) {
        this.audioContext !== null && (this.samples = new Float32Array(), clearInterval(this.autoUpdateBufferTimer), this.audioContext.close().then(function() {
          s && s();
        }, function(l) {
          c && c(l);
        }), this.audioContext = null);
      }, u.prototype.init = function(s) {
        this.audioFormat = s, this.samples = new Float32Array();
      }, u.prototype.ensureInitializedContext = function() {
        var s = this;
        if (this.audioContext === null) {
          this.createAudioContext();
          var c = 200;
          this.autoUpdateBufferTimer = setInterval(function() {
            s.updateAudioBuffer();
          }, c);
        }
      }, u.prototype.createAudioContext = function() {
        this.audioContext = o.AudioStreamFormatImpl.getAudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = 1, this.gainNode.connect(this.audioContext.destination), this.startTime = this.audioContext.currentTime;
      }, u.prototype.formatAudioData = function(s) {
        switch (this.audioFormat.bitsPerSample) {
          case 8:
            return this.formatArrayBuffer(new Int8Array(s), 128);
          case 16:
            return this.formatArrayBuffer(new Int16Array(s), 32768);
          case 32:
            return this.formatArrayBuffer(new Int32Array(s), 2147483648);
          default:
            throw new r.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
      }, u.prototype.formatArrayBuffer = function(s, c) {
        for (var l = new Float32Array(s.length), f = 0; f < s.length; f++)
          l[f] = s[f] / c;
        return l;
      }, u.prototype.updateAudioBuffer = function() {
        if (this.samples.length !== 0) {
          for (var s = this.audioFormat.channels, c = this.audioContext.createBufferSource(), l = this.samples.length / s, f = this.audioContext.createBuffer(s, l, this.audioFormat.samplesPerSec), d = 0; d < s; d++)
            for (var p = d, v = f.getChannelData(d), h = 0; h < this.samples.length; h++, p += s)
              v[h] = this.samples[p];
          this.startTime < this.audioContext.currentTime && (this.startTime = this.audioContext.currentTime), c.buffer = f, c.connect(this.gainNode), c.start(this.startTime), this.startTime += f.duration, this.samples = new Float32Array();
        }
      }, u.prototype.playAudio = function(s) {
        return e(this, void 0, void 0, function() {
          var c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return this.audioContext === null && this.createAudioContext(), c = this.audioContext.createBufferSource(), l = this.audioContext.destination, [4, this.audioContext.decodeAudioData(s, function(d) {
                  c.buffer = d, c.connect(l), c.start(0);
                })];
              case 1:
                return f.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u;
    }()
  );
  return tm.BaseAudioPlayer = a, tm;
}
var rm = {}, Rie;
function Xgr() {
  if (Rie) return rm;
  Rie = 1, Object.defineProperty(rm, "__esModule", { value: !0 }), rm.ConnectionMessageEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privConnectionMessage = r;
      }
      return Object.defineProperty(t.prototype, "message", {
        /**
         * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
         */
        get: function() {
          return this.privConnectionMessage;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.toString = function() {
        return "Message: " + this.privConnectionMessage.toString();
      }, t;
    }()
  );
  return rm.ConnectionMessageEventArgs = e, rm;
}
var nm = {}, wie;
function Jgr() {
  if (wie) return nm;
  wie = 1, Object.defineProperty(nm, "__esModule", { value: !0 }), nm.VoiceProfile = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privId = r, this.privProfileType = n;
      }
      return Object.defineProperty(t.prototype, "profileId", {
        /**
         * profileId of this Voice Profile instance
         * @member VoiceProfile.prototype.profileId
         * @function
         * @public
         * @returns {string} profileId of this Voice Profile instance.
         */
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "profileType", {
        /**
         * profileType of this Voice Profile instance
         * @member VoiceProfile.prototype.profileType
         * @function
         * @public
         * @returns {VoiceProfileType} profile type of this Voice Profile instance.
         */
        get: function() {
          return this.privProfileType;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return nm.VoiceProfile = e, nm;
}
var $0 = {}, Pie;
function Zgr() {
  if (Pie) return $0;
  Pie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var o = function(a, u) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, c) {
        s.__proto__ = c;
      } || function(s, c) {
        for (var l in c) c.hasOwnProperty(l) && (s[l] = c[l]);
      }, o(a, u);
    };
    return function(a, u) {
      o(a, u);
      function s() {
        this.constructor = a;
      }
      a.prototype = u === null ? Object.create(u) : (s.prototype = u.prototype, new s());
    };
  }();
  Object.defineProperty($0, "__esModule", { value: !0 }), $0.VoiceProfileEnrollmentCancellationDetails = $0.VoiceProfileEnrollmentResult = void 0;
  var t = gr(), r = Wt(), n = (
    /** @class */
    function() {
      function o(a, u, s) {
        this.privReason = a, this.privProperties = new r.PropertyCollection(), this.privReason !== r.ResultReason.Canceled ? u && (this.privDetails = JSON.parse(u), this.privDetails.enrollmentStatus.toLowerCase() === "enrolling" && (this.privReason = r.ResultReason.EnrollingVoiceProfile)) : (this.privErrorDetails = s, this.privProperties.setProperty(t.CancellationErrorCodePropertyName, r.CancellationErrorCode[r.CancellationErrorCode.ServiceError]));
      }
      return o.FromIdentificationProfileList = function(a) {
        for (var u = [], s = 0, c = a.profiles; s < c.length; s++) {
          var l = c[s], f = l.enrollmentStatus.toLowerCase() === "enrolling" ? r.ResultReason.EnrollingVoiceProfile : l.enrollmentStatus.toLowerCase() === "enrolled" ? r.ResultReason.EnrolledVoiceProfile : r.ResultReason.Canceled, d = new o(f, null, null);
          d.privDetails = this.getIdentificationDetails(l), u.push(d);
        }
        return u;
      }, o.FromVerificationProfileList = function(a) {
        for (var u = [], s = 0, c = a.profiles; s < c.length; s++) {
          var l = c[s], f = l.enrollmentStatus.toLowerCase() === "enrolling" ? r.ResultReason.EnrollingVoiceProfile : l.enrollmentStatus.toLowerCase() === "enrolled" ? r.ResultReason.EnrolledVoiceProfile : r.ResultReason.Canceled, d = new o(f, null, null);
          d.privDetails = this.getVerificationDetails(l), u.push(d);
        }
        return u;
      }, Object.defineProperty(o.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "enrollmentsCount", {
        get: function() {
          return this.privDetails.enrollmentsCount;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "enrollmentsLength", {
        get: function() {
          return this.privDetails.enrollmentsLength;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "properties", {
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "enrollmentResultDetails", {
        get: function() {
          return this.privDetails;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "errorDetails", {
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), o.getIdentificationDetails = function(a) {
        return {
          audioSpeechLength: a.speechTime ? parseFloat(a.speechTime) : 0,
          enrollmentStatus: a.enrollmentStatus,
          enrollmentsLength: a.enrollmentSpeechTime ? parseFloat(a.enrollmentSpeechTime) : 0,
          profileId: a.profileId || a.identificationProfileId,
          remainingEnrollmentSpeechLength: a.remainingEnrollmentSpeechTime ? parseFloat(a.remainingEnrollmentSpeechTime) : 0
        };
      }, o.getVerificationDetails = function(a) {
        return {
          enrollmentStatus: a.enrollmentStatus,
          enrollmentsCount: a.enrollmentsCount,
          profileId: a.profileId || a.verificationProfileId,
          remainingEnrollmentSpeechLength: a.remainingEnrollmentSpeechLength ? parseFloat(a.remainingEnrollmentSpeechLength) : 0,
          remainingEnrollmentsCount: a.remainingEnrollments || a.remainingEnrollmentsCount
        };
      }, o;
    }()
  );
  $0.VoiceProfileEnrollmentResult = n;
  var i = (
    /** @class */
    function(o) {
      e(a, o);
      function a(u, s, c) {
        return o.call(this, u, s, c) || this;
      }
      return a.fromResult = function(u) {
        var s = r.CancellationReason.Error, c = r.CancellationErrorCode.NoError;
        return u.properties && (c = r.CancellationErrorCode[u.properties.getProperty(t.CancellationErrorCodePropertyName, r.CancellationErrorCode[r.CancellationErrorCode.NoError])]), new a(s, u.errorDetails, c);
      }, a;
    }(r.CancellationDetailsBase)
  );
  return $0.VoiceProfileEnrollmentCancellationDetails = i, $0;
}
var U0 = {}, Die;
function Qgr() {
  if (Die) return U0;
  Die = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var a = function(u, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
        c.__proto__ = l;
      } || function(c, l) {
        for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
      }, a(u, s);
    };
    return function(u, s) {
      a(u, s);
      function c() {
        this.constructor = u;
      }
      u.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
    };
  }();
  Object.defineProperty(U0, "__esModule", { value: !0 }), U0.VoiceProfileCancellationDetails = U0.VoiceProfileResult = void 0;
  var t = gr(), r = tn(), n = Wt(), i = (
    /** @class */
    function() {
      function a(u, s) {
        this.privReason = u, this.privProperties = new n.PropertyCollection(), u === n.ResultReason.Canceled && (r.Contracts.throwIfNullOrUndefined(s, "statusText"), this.privErrorDetails = s, this.privProperties.setProperty(t.CancellationErrorCodePropertyName, n.CancellationErrorCode[n.CancellationErrorCode.ServiceError]));
      }
      return Object.defineProperty(a.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "properties", {
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "errorDetails", {
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), a;
    }()
  );
  U0.VoiceProfileResult = i;
  var o = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c, l) {
        return a.call(this, s, c, l) || this;
      }
      return u.fromResult = function(s) {
        var c = n.CancellationReason.Error, l = n.CancellationErrorCode.NoError;
        return s.properties && (l = n.CancellationErrorCode[s.properties.getProperty(t.CancellationErrorCodePropertyName, n.CancellationErrorCode[n.CancellationErrorCode.NoError])]), new u(c, s.errorDetails, l);
      }, u;
    }(n.CancellationDetailsBase)
  );
  return U0.VoiceProfileCancellationDetails = o, U0;
}
var im = {}, xie;
function e1r() {
  if (xie) return im;
  xie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(im, "__esModule", { value: !0 }), im.VoiceProfileAuthorizationPhraseResult = void 0;
  var t = tn(), r = Wt(), n = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a, u, s) {
        var c = i.call(this, a, u) || this;
        c.privPhrases = [], t.Contracts.throwIfNullOrUndefined(s, "phrases array");
        for (var l = 0, f = s; l < f.length; l++) {
          var d = f[l];
          c.privPhrases.push(d.passPhrase);
        }
        return c;
      }
      return Object.defineProperty(o.prototype, "phrases", {
        get: function() {
          return this.privPhrases;
        },
        enumerable: !1,
        configurable: !0
      }), o;
    }(r.VoiceProfileResult)
  );
  return im.VoiceProfileAuthorizationPhraseResult = n, im;
}
var om = {}, Nie;
function t1r() {
  if (Nie) return om;
  Nie = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(om, "__esModule", { value: !0 }), om.VoiceProfileClient = void 0;
  var r = gr(), n = Ar(), i = tn(), o = Wt(), a = (
    /** @class */
    function() {
      function u(s) {
        var c = s;
        i.Contracts.throwIfNull(c, "speechConfig"), this.privProperties = c.properties.clone(), this.implClientSetup();
      }
      return Object.defineProperty(u.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(o.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member VoiceProfileClient.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(s) {
          i.Contracts.throwIfNullOrWhitespace(s, "token"), this.properties.setProperty(o.PropertyId.SpeechServiceAuthorization_Token, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this VoiceProfileClient.
         * @member VoiceProfileClient.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.createProfileAsync = function(s, c, l, f) {
        var d = this;
        n.marshalPromiseToCallbacks(function() {
          return e(d, void 0, void 0, function() {
            var p, v, h;
            return t(this, function(E) {
              switch (E.label) {
                case 0:
                  return [4, this.privAdapter.createProfile(s, c)];
                case 1:
                  return p = E.sent(), v = p.json(), h = new o.VoiceProfile(v.profileId, s), [2, h];
              }
            });
          });
        }(), l, f);
      }, u.prototype.retrieveEnrollmentResultAsync = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d;
            return t(this, function(p) {
              switch (p.label) {
                case 0:
                  return [4, this.privAdapter.getProfileStatus(s)];
                case 1:
                  return d = p.sent(), [2, new o.VoiceProfileEnrollmentResult(d.ok ? o.ResultReason.EnrolledVoiceProfile : o.ResultReason.Canceled, d.data, d.statusText)];
              }
            });
          });
        }(), c, l);
      }, u.prototype.getAllProfilesAsync = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d;
            return t(this, function(p) {
              switch (p.label) {
                case 0:
                  return [4, this.privAdapter.getProfiles(s)];
                case 1:
                  return d = p.sent(), s === o.VoiceProfileType.TextIndependentIdentification ? [2, o.VoiceProfileEnrollmentResult.FromIdentificationProfileList(d.json())] : [2, o.VoiceProfileEnrollmentResult.FromVerificationProfileList(d.json())];
              }
            });
          });
        }(), c, l);
      }, u.prototype.getAuthorizationPhrasesAsync = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d;
            return t(this, function(p) {
              switch (p.label) {
                case 0:
                  return [4, this.privAdapter.getAuthorizationPhrases(s)];
                case 1:
                  return d = p.sent(), [2, new o.VoiceProfileAuthorizationPhraseResult(d.ok ? o.ResultReason.EnrollingVoiceProfile : o.ResultReason.Canceled, d.statusText, d.json())];
              }
            });
          });
        }(), c, l);
      }, u.prototype.enrollProfileAsync = function(s, c, l, f) {
        var d = this, p = c;
        i.Contracts.throwIfNullOrUndefined(p, "audioConfig"), n.marshalPromiseToCallbacks(function() {
          return e(d, void 0, void 0, function() {
            var v;
            return t(this, function(h) {
              switch (h.label) {
                case 0:
                  return [4, this.privAdapter.createEnrollment(s, p)];
                case 1:
                  return v = h.sent(), [2, new o.VoiceProfileEnrollmentResult(v.ok ? o.ResultReason.EnrolledVoiceProfile : o.ResultReason.Canceled, v.data, v.statusText)];
              }
            });
          });
        }(), l, f);
      }, u.prototype.deleteProfileAsync = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d;
            return t(this, function(p) {
              switch (p.label) {
                case 0:
                  return [4, this.privAdapter.deleteProfile(s)];
                case 1:
                  return d = p.sent(), [2, this.getResult(d, o.ResultReason.DeletedVoiceProfile)];
              }
            });
          });
        }(), c, l);
      }, u.prototype.resetProfileAsync = function(s, c, l) {
        var f = this;
        n.marshalPromiseToCallbacks(function() {
          return e(f, void 0, void 0, function() {
            var d;
            return t(this, function(p) {
              switch (p.label) {
                case 0:
                  return [4, this.privAdapter.resetProfile(s)];
                case 1:
                  return d = p.sent(), [2, this.getResult(d, o.ResultReason.ResetVoiceProfile)];
              }
            });
          });
        }(), c, l);
      }, u.prototype.close = function() {
      }, u.prototype.implClientSetup = function() {
        var s = typeof window < "u" ? "Browser" : "Node", c = "unknown", l = "unknown";
        typeof navigator < "u" && (s = s + "/" + navigator.platform, c = navigator.userAgent, l = navigator.appVersion);
        var f = new r.SpeakerRecognitionConfig(new r.Context(new r.OS(s, c, l)), this.privProperties);
        this.privAdapter = new r.SpeakerIdMessageAdapter(f);
      }, u.prototype.getResult = function(s, c, l) {
        var f = new o.VoiceProfileResult(s.ok ? c : o.ResultReason.Canceled, s.statusText);
        return f;
      }, u;
    }()
  );
  return om.VoiceProfileClient = a, om;
}
var am = {}, Lie;
function r1r() {
  if (Lie) return am;
  Lie = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(am, "__esModule", { value: !0 }), am.SpeakerRecognizer = void 0;
  var r = gr(), n = Ar(), i = tn(), o = Wt(), a = (
    /** @class */
    function() {
      function u(s, c) {
        var l = s;
        i.Contracts.throwIfNull(l, "speechConfig"), this.privAudioConfigImpl = c, i.Contracts.throwIfNull(this.privAudioConfigImpl, "audioConfig"), this.privProperties = l.properties.clone(), this.implSRSetup();
      }
      return Object.defineProperty(u.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(o.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeakerRecognizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(s) {
          i.Contracts.throwIfNullOrWhitespace(s, "token"), this.properties.setProperty(o.PropertyId.SpeechServiceAuthorization_Token, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeakerRecognizer.
         * @member SpeakerRecognizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.recognizeOnceAsync = function(s, c, l) {
        if (s instanceof o.SpeakerIdentificationModel) {
          var f = this.privAdapter.identifySpeaker(s, this.privAudioConfigImpl);
          n.marshalPromiseToCallbacks(this.getResult(f, o.SpeakerRecognitionResultType.Identify, void 0), c, l);
        } else if (s instanceof o.SpeakerVerificationModel) {
          var f = this.privAdapter.verifySpeaker(s, this.privAudioConfigImpl);
          n.marshalPromiseToCallbacks(this.getResult(f, o.SpeakerRecognitionResultType.Verify, s.voiceProfile.profileId), c, l);
        } else
          throw new Error("SpeakerRecognizer.recognizeOnce: Unexpected model type");
      }, u.prototype.close = function() {
      }, u.prototype.implSRSetup = function() {
        var s = typeof window < "u" ? "Browser" : "Node", c = "unknown", l = "unknown";
        typeof navigator < "u" && (s = s + "/" + navigator.platform, c = navigator.userAgent, l = navigator.appVersion);
        var f = new r.SpeakerRecognitionConfig(new r.Context(new r.OS(s, c, l)), this.privProperties);
        this.privAdapter = new r.SpeakerIdMessageAdapter(f);
      }, u.prototype.getResult = function(s, c, l) {
        return e(this, void 0, void 0, function() {
          var f;
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                return [4, s];
              case 1:
                return f = d.sent(), [2, new o.SpeakerRecognitionResult(c, f.data, l, f.ok ? o.ResultReason.RecognizedSpeaker : o.ResultReason.Canceled)];
            }
          });
        });
      }, u;
    }()
  );
  return am.SpeakerRecognizer = a, am;
}
var um = {}, Bie;
function n1r() {
  if (Bie) return um;
  Bie = 1, Object.defineProperty(um, "__esModule", { value: !0 }), um.SpeakerIdentificationModel = void 0;
  var e = tn(), t = Wt(), r = (
    /** @class */
    function() {
      function n(i) {
        var o = this;
        if (this.privVoiceProfiles = [], e.Contracts.throwIfNullOrUndefined(i, "VoiceProfiles"), i.length === 0)
          throw new Error("Empty Voice Profiles array");
        i.forEach(function(a) {
          if (a.profileType !== t.VoiceProfileType.TextIndependentIdentification)
            throw new Error("Identification model can only be created from Identification profile: " + a.profileId);
          o.privVoiceProfiles.push(a);
        });
      }
      return n.fromProfiles = function(i) {
        return new n(i);
      }, Object.defineProperty(n.prototype, "voiceProfileIds", {
        get: function() {
          return this.privVoiceProfiles.map(function(i) {
            return i.profileId;
          }).join(",");
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return um.SpeakerIdentificationModel = r, um;
}
var sm = {}, kie;
function i1r() {
  if (kie) return sm;
  kie = 1, Object.defineProperty(sm, "__esModule", { value: !0 }), sm.SpeakerVerificationModel = void 0;
  var e = tn(), t = Wt(), r = (
    /** @class */
    function() {
      function n(i) {
        if (e.Contracts.throwIfNullOrUndefined(i, "VoiceProfile"), i.profileType === t.VoiceProfileType.TextIndependentIdentification)
          throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = i;
      }
      return n.fromProfile = function(i) {
        return new n(i);
      }, Object.defineProperty(n.prototype, "voiceProfile", {
        get: function() {
          return this.privVoiceProfile;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return sm.SpeakerVerificationModel = r, sm;
}
var cm = {}, Mie;
function o1r() {
  if (Mie) return cm;
  Mie = 1, Object.defineProperty(cm, "__esModule", { value: !0 }), cm.AutoDetectSourceLanguageConfig = void 0;
  var e = gr(), t = tn(), r = Wt(), n = (
    /** @class */
    function() {
      function i() {
        this.privProperties = new r.PropertyCollection();
      }
      return i.fromOpenRange = function() {
        var o = new i();
        return o.properties.setProperty(r.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, e.AutoDetectSourceLanguagesOpenRangeOptionName), o;
      }, i.fromLanguages = function(o) {
        t.Contracts.throwIfArrayEmptyOrWhitespace(o, "languages");
        var a = new i();
        return a.properties.setProperty(r.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, o.join()), a;
      }, i.fromSourceLanguageConfigs = function(o) {
        if (o.length < 1)
          throw new Error("Expected non-empty SourceLanguageConfig array.");
        var a = new i(), u = [];
        return o.forEach(function(s) {
          if (u.push(s.language), s.endpointId !== void 0 && s.endpointId !== "") {
            var c = s.language + r.PropertyId.SpeechServiceConnection_EndpointId.toString();
            a.properties.setProperty(c, s.endpointId);
          }
        }), a.properties.setProperty(r.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, u.join()), a;
      }, Object.defineProperty(i.prototype, "properties", {
        /**
         * @member AutoDetectSourceLanguageConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets an auto detected language config properties
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }()
  );
  return cm.AutoDetectSourceLanguageConfig = n, cm;
}
var lm = {}, Fie;
function a1r() {
  if (Fie) return lm;
  Fie = 1, Object.defineProperty(lm, "__esModule", { value: !0 }), lm.AutoDetectSourceLanguageResult = void 0;
  var e = tn(), t = (
    /** @class */
    function() {
      function r(n, i) {
        e.Contracts.throwIfNullOrUndefined(n, "language"), e.Contracts.throwIfNullOrUndefined(i, "languageDetectionConfidence"), this.privLanguage = n, this.privLanguageDetectionConfidence = i;
      }
      return r.fromResult = function(n) {
        return new r(n.language, n.languageDetectionConfidence);
      }, Object.defineProperty(r.prototype, "language", {
        get: function() {
          return this.privLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "languageDetectionConfidence", {
        get: function() {
          return this.privLanguageDetectionConfidence;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return lm.AutoDetectSourceLanguageResult = t, lm;
}
var fm = {}, Hie;
function u1r() {
  if (Hie) return fm;
  Hie = 1, Object.defineProperty(fm, "__esModule", { value: !0 }), fm.SourceLanguageConfig = void 0;
  var e = tn(), t = (
    /** @class */
    function() {
      function r(n, i) {
        e.Contracts.throwIfNullOrUndefined(n, "language"), this.privLanguage = n, this.privEndpointId = i;
      }
      return r.fromLanguage = function(n, i) {
        return new r(n, i);
      }, Object.defineProperty(r.prototype, "language", {
        get: function() {
          return this.privLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "endpointId", {
        get: function() {
          return this.privEndpointId;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return fm.SourceLanguageConfig = t, fm;
}
var VN = {}, $ie;
function s1r() {
  return $ie || ($ie = 1, function(e) {
    var t = fe && fe.__extends || /* @__PURE__ */ function() {
      var s = function(c, l) {
        return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
          f.__proto__ = d;
        } || function(f, d) {
          for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
        }, s(c, l);
      };
      return function(c, l) {
        s(c, l);
        function f() {
          this.constructor = c;
        }
        c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
      };
    }();
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SpeakerRecognitionCancellationDetails = e.SpeakerRecognitionResult = e.SpeakerRecognitionResultType = void 0;
    var r = gr(), n = tn(), i = Wt(), o;
    (function(s) {
      s[s.Verify = 0] = "Verify", s[s.Identify = 1] = "Identify";
    })(o = e.SpeakerRecognitionResultType || (e.SpeakerRecognitionResultType = {}));
    var a = (
      /** @class */
      function() {
        function s(c, l, f, d) {
          if (d === void 0 && (d = i.ResultReason.RecognizedSpeaker), this.privProperties = new i.PropertyCollection(), this.privReason = d, this.privReason !== i.ResultReason.Canceled)
            if (c === o.Identify) {
              var p = JSON.parse(l);
              n.Contracts.throwIfNullOrUndefined(p, "JSON"), this.privProfileId = p.identifiedProfile.profileId, this.privScore = p.identifiedProfile.score;
            } else {
              var p = JSON.parse(l);
              n.Contracts.throwIfNullOrUndefined(p, "JSON"), this.privScore = p.score, p.recognitionResult.toLowerCase() !== "accept" && (this.privReason = i.ResultReason.NoMatch), f !== void 0 && f !== "" && (this.privProfileId = f);
            }
          else {
            var p = JSON.parse(l);
            n.Contracts.throwIfNullOrUndefined(p, "JSON"), this.privErrorDetails = p.statusText, this.privProperties.setProperty(r.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.ServiceError]);
          }
          this.privProperties.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, l);
        }
        return Object.defineProperty(s.prototype, "properties", {
          get: function() {
            return this.privProperties;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(s.prototype, "reason", {
          get: function() {
            return this.privReason;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(s.prototype, "profileId", {
          get: function() {
            return this.privProfileId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(s.prototype, "errorDetails", {
          get: function() {
            return this.privErrorDetails;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(s.prototype, "score", {
          get: function() {
            return this.privScore;
          },
          enumerable: !1,
          configurable: !0
        }), s;
      }()
    );
    e.SpeakerRecognitionResult = a;
    var u = (
      /** @class */
      function(s) {
        t(c, s);
        function c(l, f, d) {
          return s.call(this, l, f, d) || this;
        }
        return c.fromResult = function(l) {
          var f = i.CancellationReason.Error, d = i.CancellationErrorCode.NoError;
          return l.properties && (d = i.CancellationErrorCode[l.properties.getProperty(r.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.NoError])]), new c(f, l.errorDetails, d);
        }, c;
      }(i.CancellationDetailsBase)
    );
    e.SpeakerRecognitionCancellationDetails = u;
  }(VN)), VN;
}
var jN = {}, V0 = {}, Uie;
function l4e() {
  if (Uie) return V0;
  Uie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var l = function(f, d) {
      return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, v) {
        p.__proto__ = v;
      } || function(p, v) {
        for (var h in v) v.hasOwnProperty(h) && (p[h] = v[h]);
      }, l(f, d);
    };
    return function(f, d) {
      l(f, d);
      function p() {
        this.constructor = f;
      }
      f.prototype = d === null ? Object.create(d) : (p.prototype = d.prototype, new p());
    };
  }(), t = fe && fe.__awaiter || function(l, f, d, p) {
    function v(h) {
      return h instanceof d ? h : new d(function(E) {
        E(h);
      });
    }
    return new (d || (d = Promise))(function(h, E) {
      function m(_) {
        try {
          y(p.next(_));
        } catch (S) {
          E(S);
        }
      }
      function g(_) {
        try {
          y(p.throw(_));
        } catch (S) {
          E(S);
        }
      }
      function y(_) {
        _.done ? h(_.value) : v(_.value).then(m, g);
      }
      y((p = p.apply(l, f || [])).next());
    });
  }, r = fe && fe.__generator || function(l, f) {
    var d = { label: 0, sent: function() {
      if (h[0] & 1) throw h[1];
      return h[1];
    }, trys: [], ops: [] }, p, v, h, E;
    return E = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (E[Symbol.iterator] = function() {
      return this;
    }), E;
    function m(y) {
      return function(_) {
        return g([y, _]);
      };
    }
    function g(y) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; d; ) try {
        if (p = 1, v && (h = y[0] & 2 ? v.return : y[0] ? v.throw || ((h = v.return) && h.call(v), 0) : v.next) && !(h = h.call(v, y[1])).done) return h;
        switch (v = 0, h && (y = [y[0] & 2, h.value]), y[0]) {
          case 0:
          case 1:
            h = y;
            break;
          case 4:
            return d.label++, { value: y[1], done: !1 };
          case 5:
            d.label++, v = y[1], y = [0];
            continue;
          case 7:
            y = d.ops.pop(), d.trys.pop();
            continue;
          default:
            if (h = d.trys, !(h = h.length > 0 && h[h.length - 1]) && (y[0] === 6 || y[0] === 2)) {
              d = 0;
              continue;
            }
            if (y[0] === 3 && (!h || y[1] > h[0] && y[1] < h[3])) {
              d.label = y[1];
              break;
            }
            if (y[0] === 6 && d.label < h[1]) {
              d.label = h[1], h = y;
              break;
            }
            if (h && d.label < h[2]) {
              d.label = h[2], d.ops.push(y);
              break;
            }
            h[2] && d.ops.pop(), d.trys.pop();
            continue;
        }
        y = f.call(l, d);
      } catch (_) {
        y = [6, _], v = 0;
      } finally {
        p = h = 0;
      }
      if (y[0] & 5) throw y[1];
      return { value: y[0] ? y[1] : void 0, done: !0 };
    }
  }, n = fe && fe.__spreadArrays || function() {
    for (var l = 0, f = 0, d = arguments.length; f < d; f++) l += arguments[f].length;
    for (var p = Array(l), v = 0, f = 0; f < d; f++)
      for (var h = arguments[f], E = 0, m = h.length; E < m; E++, v++)
        p[v] = h[E];
    return p;
  };
  Object.defineProperty(V0, "__esModule", { value: !0 }), V0.ConversationImpl = V0.Conversation = void 0;
  var i = gr(), o = Ar(), a = tn(), u = Wt(), s = (
    /** @class */
    function() {
      function l() {
      }
      return l.createConversationAsync = function(f, d, p, v) {
        var h = this;
        if (a.Contracts.throwIfNullOrUndefined(f, i.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config")), a.Contracts.throwIfNullOrUndefined(f.region, i.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), !f.subscriptionKey && !f.getProperty(u.PropertyId[u.PropertyId.SpeechServiceAuthorization_Token]) && a.Contracts.throwIfNullOrUndefined(f.subscriptionKey, i.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key")), typeof d == "string") {
          var E = new c(f, d);
          return o.marshalPromiseToCallbacks(function() {
            return t(h, void 0, void 0, function() {
              return r(this, function(y) {
                return [
                  2
                  /*return*/
                ];
              });
            });
          }(), p, v), E;
        } else {
          var E = new c(f), m = d, g = p;
          return E.createConversationAsync(function() {
            m && m();
          }, function(_) {
            g && g(_);
          }), E;
        }
      }, l;
    }()
  );
  V0.Conversation = s;
  var c = (
    /** @class */
    function(l) {
      e(f, l);
      function f(d, p) {
        var v = l.call(this) || this;
        v.privIsDisposed = !1, v.privIsConnected = !1, v.privErrors = i.ConversationConnectionConfig.restErrors, v.privConversationId = "", v.onConnected = function(y) {
          v.privIsConnected = !0;
          try {
            v.privConversationTranslator.sessionStarted && v.privConversationTranslator.sessionStarted(v.privConversationTranslator, y);
          } catch {
          }
        }, v.onDisconnected = function(y) {
          return t(v, void 0, void 0, function() {
            return r(this, function(_) {
              switch (_.label) {
                case 0:
                  return [4, this.close(!1)];
                case 1:
                  _.sent();
                  try {
                    this.privConversationTranslator.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, y);
                  } catch {
                  }
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v.onCanceled = function(y, _) {
          return t(v, void 0, void 0, function() {
            return r(this, function(S) {
              switch (S.label) {
                case 0:
                  return [4, this.close(!1)];
                case 1:
                  S.sent();
                  try {
                    this.privConversationTranslator.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, _);
                  } catch {
                  }
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v.onParticipantUpdateCommandReceived = function(y, _) {
          var S, A;
          try {
            var O = v.privParticipants.getParticipant(_.id);
            if (O !== void 0) {
              switch (_.key) {
                case i.ConversationTranslatorCommandTypes.changeNickname:
                  O.displayName = _.value;
                  break;
                case i.ConversationTranslatorCommandTypes.setUseTTS:
                  O.useTts = _.value;
                  break;
                case i.ConversationTranslatorCommandTypes.setProfanityFiltering:
                  O.profanity = _.value;
                  break;
                case i.ConversationTranslatorCommandTypes.setMute:
                  O.isMuted = _.value;
                  break;
                case i.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                  O.translateToLanguages = _.value;
                  break;
              }
              v.privParticipants.addOrUpdateParticipant(O), !((S = v.privConversationTranslator) === null || S === void 0) && S.participantsChanged && ((A = v.privConversationTranslator) === null || A === void 0 || A.participantsChanged(v.privConversationTranslator, new u.ConversationParticipantsChangedEventArgs(u.ParticipantChangedReason.Updated, [v.toParticipant(O)], _.sessionId)));
            }
          } catch {
          }
        }, v.onLockRoomCommandReceived = function(y, _) {
        }, v.onMuteAllCommandReceived = function(y, _) {
          var S, A;
          try {
            v.privParticipants.participants.forEach(function(O) {
              return O.isMuted = O.isHost ? !1 : _.isMuted;
            }), !((S = v.privConversationTranslator) === null || S === void 0) && S.participantsChanged && ((A = v.privConversationTranslator) === null || A === void 0 || A.participantsChanged(v.privConversationTranslator, new u.ConversationParticipantsChangedEventArgs(u.ParticipantChangedReason.Updated, v.toParticipants(!1), _.sessionId)));
          } catch {
          }
        }, v.onParticipantJoinCommandReceived = function(y, _) {
          var S, A;
          try {
            var O = v.privParticipants.addOrUpdateParticipant(_.participant);
            O !== void 0 && !((S = v.privConversationTranslator) === null || S === void 0) && S.participantsChanged && ((A = v.privConversationTranslator) === null || A === void 0 || A.participantsChanged(v.privConversationTranslator, new u.ConversationParticipantsChangedEventArgs(u.ParticipantChangedReason.JoinedConversation, [v.toParticipant(O)], _.sessionId)));
          } catch {
          }
        }, v.onParticipantLeaveCommandReceived = function(y, _) {
          var S, A;
          try {
            var O = v.privParticipants.getParticipant(_.participant.id);
            O !== void 0 && (v.privParticipants.deleteParticipant(_.participant.id), !((S = v.privConversationTranslator) === null || S === void 0) && S.participantsChanged && ((A = v.privConversationTranslator) === null || A === void 0 || A.participantsChanged(v.privConversationTranslator, new u.ConversationParticipantsChangedEventArgs(u.ParticipantChangedReason.LeftConversation, [v.toParticipant(O)], _.sessionId))));
          } catch {
          }
        }, v.onTranslationReceived = function(y, _) {
          var S, A, O, P, U, z;
          try {
            switch (_.command) {
              case i.ConversationTranslatorMessageTypes.final:
                !((S = v.privConversationTranslator) === null || S === void 0) && S.transcribed && ((A = v.privConversationTranslator) === null || A === void 0 || A.transcribed(v.privConversationTranslator, new u.ConversationTranslationEventArgs(_.payload, void 0, _.sessionId)));
                break;
              case i.ConversationTranslatorMessageTypes.partial:
                !((O = v.privConversationTranslator) === null || O === void 0) && O.transcribing && ((P = v.privConversationTranslator) === null || P === void 0 || P.transcribing(v.privConversationTranslator, new u.ConversationTranslationEventArgs(_.payload, void 0, _.sessionId)));
                break;
              case i.ConversationTranslatorMessageTypes.instantMessage:
                !((U = v.privConversationTranslator) === null || U === void 0) && U.textMessageReceived && ((z = v.privConversationTranslator) === null || z === void 0 || z.textMessageReceived(v.privConversationTranslator, new u.ConversationTranslationEventArgs(_.payload, void 0, _.sessionId)));
                break;
            }
          } catch {
          }
        }, v.onParticipantsListReceived = function(y, _) {
          var S, A, O;
          try {
            if (_.sessionToken !== void 0 && _.sessionToken !== null && (v.privRoom.token = _.sessionToken), v.privParticipants.participants = n(_.participants), v.privParticipants.me !== void 0 && (v.privIsReady = !0), !((S = v.privConversationTranslator) === null || S === void 0) && S.participantsChanged && ((A = v.privConversationTranslator) === null || A === void 0 || A.participantsChanged(v.privConversationTranslator, new u.ConversationParticipantsChangedEventArgs(u.ParticipantChangedReason.JoinedConversation, v.toParticipants(!0), _.sessionId))), v.me.isHost) {
              var P = (O = v.privConversationTranslator) === null || O === void 0 ? void 0 : O.properties.getProperty(u.PropertyId.ConversationTranslator_Name);
              P !== void 0 && P.length > 0 && P !== v.me.displayName && v.changeNicknameAsync(P);
            }
          } catch {
          }
        }, v.onConversationExpiration = function(y, _) {
          var S, A;
          try {
            !((S = v.privConversationTranslator) === null || S === void 0) && S.conversationExpiration && ((A = v.privConversationTranslator) === null || A === void 0 || A.conversationExpiration(v.privConversationTranslator, _));
          } catch {
          }
        }, v.privProperties = new u.PropertyCollection(), v.privManager = new i.ConversationManager();
        var h = d.getProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (h || d.setProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_RecoLanguage], i.ConversationConnectionConfig.defaultLanguageCode), v.privLanguage = d.getProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_RecoLanguage]), p)
          v.privConversationId = p;
        else {
          d.targetLanguages.length === 0 && d.addTargetLanguage(v.privLanguage);
          var E = d.getProperty(u.PropertyId[u.PropertyId.SpeechServiceResponse_ProfanityOption]);
          E || d.setProfanity(u.ProfanityOption.Masked);
          var m = d.getProperty(u.PropertyId[u.PropertyId.ConversationTranslator_Name]);
          (m == null || m.length <= 1 || m.length > 50) && (m = "Host"), d.setProperty(u.PropertyId[u.PropertyId.ConversationTranslator_Name], m);
        }
        v.privConfig = d;
        var g = d;
        return a.Contracts.throwIfNull(g, "speechConfig"), v.privProperties = g.properties.clone(), v.privIsConnected = !1, v.privParticipants = new i.InternalParticipants(), v.privIsReady = !1, v.privTextMessageMaxLength = 1e3, v;
      }
      return Object.defineProperty(f.prototype, "conversationTranslator", {
        set: function(d) {
          this.privConversationTranslator = d;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "room", {
        // get the internal data about a conversation
        get: function() {
          return this.privRoom;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "connection", {
        // get the wrapper for connecting to the websockets
        get: function() {
          return this.privConversationRecognizer;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "authorizationToken", {
        // get / set the speech auth token
        get: function() {
          return this.privToken;
        },
        set: function(d) {
          a.Contracts.throwIfNullOrWhitespace(d, "authorizationToken"), this.privToken = d;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "config", {
        // get the config
        get: function() {
          return this.privConfig;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "conversationId", {
        // get the conversation Id
        get: function() {
          return this.privRoom ? this.privRoom.roomId : this.privConversationId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "properties", {
        // get the properties
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "speechRecognitionLanguage", {
        // get the speech language
        get: function() {
          return this.privLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "isMutedByHost", {
        get: function() {
          var d, p;
          return !((d = this.privParticipants.me) === null || d === void 0) && d.isHost ? !1 : (p = this.privParticipants.me) === null || p === void 0 ? void 0 : p.isMuted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "isConnected", {
        get: function() {
          return this.privIsConnected && this.privIsReady;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "participants", {
        get: function() {
          return this.toParticipants(!0);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "me", {
        get: function() {
          return this.toParticipant(this.privParticipants.me);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "host", {
        get: function() {
          return this.toParticipant(this.privParticipants.host);
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.createConversationAsync = function(d, p) {
        var v = this;
        try {
          this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), p), this.privManager.createOrJoin(this.privProperties, void 0, function(h) {
            h || v.handleError(new Error(v.privErrors.permissionDeniedConnect), p), v.privRoom = h, v.handleCallback(d, p);
          }, function(h) {
            v.handleError(h, p);
          });
        } catch (h) {
          this.handleError(h, p);
        }
      }, f.prototype.startConversationAsync = function(d, p) {
        var v = this;
        try {
          this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), p), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer = i.ConversationRecognizerFactory.fromConfig(this.privConfig), this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, function() {
            v.handleCallback(d, p);
          }, function(h) {
            v.handleError(h, p);
          });
        } catch (h) {
          this.handleError(h, p);
        }
      }, f.prototype.addParticipantAsync = function(d, p, v) {
        a.Contracts.throwIfNullOrUndefined(d, "Participant"), o.marshalPromiseToCallbacks(this.addParticipantImplAsync(d), p, v);
      }, f.prototype.joinConversationAsync = function(d, p, v, h, E) {
        var m = this;
        try {
          a.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), a.Contracts.throwIfNullOrWhitespace(p, this.privErrors.invalidArgs.replace("{arg}", "nickname")), a.Contracts.throwIfNullOrWhitespace(v, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, d, function(g) {
            a.Contracts.throwIfNullOrUndefined(g, m.privErrors.permissionDeniedConnect), m.privRoom = g, m.privConfig.authorizationToken = g.cognitiveSpeechAuthToken, h && h(g.cognitiveSpeechAuthToken);
          }, function(g) {
            m.handleError(g, E);
          });
        } catch (g) {
          this.handleError(g, E);
        }
      }, f.prototype.deleteConversationAsync = function(d, p) {
        o.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), d, p);
      }, f.prototype.deleteConversationImplAsync = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(d) {
            switch (d.label) {
              case 0:
                return a.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), a.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), [4, this.privManager.leave(this.privProperties, this.privRoom.token)];
              case 1:
                return d.sent(), this.dispose(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f.prototype.endConversationAsync = function(d, p) {
        o.marshalPromiseToCallbacks(this.endConversationImplAsync(), d, p);
      }, f.prototype.endConversationImplAsync = function() {
        return this.close(!0);
      }, f.prototype.lockConversationAsync = function(d, p) {
        var v = this, h;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), p), (h = this.privConversationRecognizer) === null || h === void 0 || h.sendRequest(this.getLockCommand(!0), function() {
            v.handleCallback(d, p);
          }, function(E) {
            v.handleError(E, p);
          });
        } catch (E) {
          this.handleError(E, p);
        }
      }, f.prototype.muteAllParticipantsAsync = function(d, p) {
        var v = this, h;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), p), (h = this.privConversationRecognizer) === null || h === void 0 || h.sendRequest(this.getMuteAllCommand(!0), function() {
            v.handleCallback(d, p);
          }, function(E) {
            v.handleError(E, p);
          });
        } catch (E) {
          this.handleError(E, p);
        }
      }, f.prototype.muteParticipantAsync = function(d, p, v) {
        var h = this, E;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "userId")), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), v), !this.me.isHost && this.me.id !== d && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), v);
          var m = this.privParticipants.getParticipantIndex(d);
          m === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), v), (E = this.privConversationRecognizer) === null || E === void 0 || E.sendRequest(this.getMuteCommand(d, !0), function() {
            h.handleCallback(p, v);
          }, function(g) {
            h.handleError(g, v);
          });
        } catch (g) {
          this.handleError(g, v);
        }
      }, f.prototype.removeParticipantAsync = function(d, p, v) {
        var h = this, E;
        try {
          if (a.Contracts.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && d.hasOwnProperty("id"))
            o.marshalPromiseToCallbacks(this.removeParticipantImplAsync(d), p, v);
          else {
            a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), v);
            var m = "";
            if (typeof d == "string")
              m = d;
            else if (d.hasOwnProperty("id")) {
              var g = d;
              m = g.id;
            } else if (d.hasOwnProperty("userId")) {
              var y = d;
              m = y.userId;
            }
            a.Contracts.throwIfNullOrWhitespace(m, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            var _ = this.participants.findIndex(function(S) {
              return S.id === m;
            });
            _ === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), v), (E = this.privConversationRecognizer) === null || E === void 0 || E.sendRequest(this.getEjectCommand(m), function() {
              h.handleCallback(p, v);
            }, function(S) {
              h.handleError(S, v);
            });
          }
        } catch (S) {
          this.handleError(S, v);
        }
      }, f.prototype.unlockConversationAsync = function(d, p) {
        var v = this, h;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), p), (h = this.privConversationRecognizer) === null || h === void 0 || h.sendRequest(this.getLockCommand(!1), function() {
            v.handleCallback(d, p);
          }, function(E) {
            v.handleError(E, p);
          });
        } catch (E) {
          this.handleError(E, p);
        }
      }, f.prototype.unmuteAllParticipantsAsync = function(d, p) {
        var v = this, h;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), p), (h = this.privConversationRecognizer) === null || h === void 0 || h.sendRequest(this.getMuteAllCommand(!1), function() {
            v.handleCallback(d, p);
          }, function(E) {
            v.handleError(E, p);
          });
        } catch (E) {
          this.handleError(E, p);
        }
      }, f.prototype.unmuteParticipantAsync = function(d, p, v) {
        var h = this, E;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "userId")), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), v), !this.me.isHost && this.me.id !== d && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), v);
          var m = this.privParticipants.getParticipantIndex(d);
          m === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), v), (E = this.privConversationRecognizer) === null || E === void 0 || E.sendRequest(this.getMuteCommand(d, !1), function() {
            h.handleCallback(p, v);
          }, function(g) {
            h.handleError(g, v);
          });
        } catch (g) {
          this.handleError(g, v);
        }
      }, f.prototype.sendTextMessageAsync = function(d, p, v) {
        var h = this, E;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "message")), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), v), d.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), v), (E = this.privConversationRecognizer) === null || E === void 0 || E.sendRequest(this.getMessageCommand(d), function() {
            h.handleCallback(p, v);
          }, function(m) {
            h.handleError(m, v);
          });
        } catch (m) {
          this.handleError(m, v);
        }
      }, f.prototype.changeNicknameAsync = function(d, p, v) {
        var h = this, E;
        try {
          a.Contracts.throwIfDisposed(this.privIsDisposed), a.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), a.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "nickname")), a.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), v), (E = this.privConversationRecognizer) === null || E === void 0 || E.sendRequest(this.getChangeNicknameCommand(d), function() {
            h.handleCallback(p, v);
          }, function(m) {
            h.handleError(m, v);
          });
        } catch (m) {
          this.handleError(m, v);
        }
      }, f.prototype.isDisposed = function() {
        return this.privIsDisposed;
      }, f.prototype.dispose = function(d) {
        var p;
        this.isDisposed || (this.privIsDisposed = !0, (p = this.config) === null || p === void 0 || p.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privConversationRecognizer = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
      }, Object.defineProperty(f.prototype, "transcriberRecognizer", {
        get: function() {
          return this.privTranscriberRecognizer;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.connectTranscriberRecognizer = function(d) {
        return t(this, void 0, void 0, function() {
          return r(this, function(p) {
            switch (p.label) {
              case 0:
                return this.privTranscriberRecognizer ? [4, this.privTranscriberRecognizer.close()] : [3, 2];
              case 1:
                p.sent(), p.label = 2;
              case 2:
                return this.privTranscriberRecognizer = d, this.privTranscriberRecognizer.conversation = this, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(f.prototype, "conversationInfo", {
        get: function() {
          for (var d = this.conversationId, p = this.participants.map(function(_) {
            return {
              id: _.id,
              preferredLanguage: _.preferredLanguage,
              voice: _.voice
            };
          }), v = {}, h = 0, E = i.ConversationConnectionConfig.transcriptionEventKeys; h < E.length; h++) {
            var m = E[h], g = this.properties.getProperty(m, "");
            g !== "" && (v[m] = g);
          }
          var y = { id: d, participants: p, conversationProperties: v };
          return y;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.addParticipantImplAsync = function(d) {
        var p = this.privParticipants.addOrUpdateParticipant(d);
        if (p !== void 0 && this.privTranscriberRecognizer) {
          var v = this.conversationInfo;
          return v.participants = [d], this.privTranscriberRecognizer.pushConversationEvent(v, "join");
        }
      }, f.prototype.removeParticipantImplAsync = function(d) {
        this.privParticipants.deleteParticipant(d.id);
        var p = this.conversationInfo;
        return p.participants = [d], this.privTranscriberRecognizer.pushConversationEvent(p, "leave");
      }, f.prototype.close = function(d) {
        var p, v;
        return t(this, void 0, void 0, function() {
          return r(this, function(h) {
            switch (h.label) {
              case 0:
                return h.trys.push([0, 3, , 4]), this.privIsConnected = !1, [4, this.privConversationRecognizer.close()];
              case 1:
                return h.sent(), [4, (p = this.privTranscriberRecognizer) === null || p === void 0 ? void 0 : p.close()];
              case 2:
                return h.sent(), this.privConversationRecognizer = void 0, (v = this.privConversationTranslator) === null || v === void 0 || v.dispose(), [3, 4];
              case 3:
                return h.sent(), [3, 4];
              case 4:
                return d && this.dispose(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(f.prototype, "canSend", {
        /** Helpers */
        get: function() {
          var d;
          return this.privIsConnected && !(!((d = this.privParticipants.me) === null || d === void 0) && d.isMuted);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "canSendAsHost", {
        get: function() {
          var d;
          return this.privIsConnected && ((d = this.privParticipants.me) === null || d === void 0 ? void 0 : d.isHost);
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.handleCallback = function(d, p) {
        if (d) {
          try {
            d();
          } catch (v) {
            p && p(v);
          }
          d = void 0;
        }
      }, f.prototype.handleError = function(d, p) {
        if (p)
          if (d instanceof Error) {
            var v = d;
            p(v.name + ": " + v.message);
          } else
            p(d);
      }, f.prototype.toParticipants = function(d) {
        var p = this, v = this.privParticipants.participants.map(function(h) {
          return p.toParticipant(h);
        });
        return d ? v : v.filter(function(h) {
          return h.isHost === !1;
        });
      }, f.prototype.toParticipant = function(d) {
        return new u.Participant(d.id, d.avatar, d.displayName, d.isHost, d.isMuted, d.isUsingTts, d.preferredLanguage, d.voice);
      }, f.prototype.getMuteAllCommand = function(d) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
          command: i.ConversationTranslatorCommandTypes.setMuteAll,
          // tslint:disable-next-line: object-literal-shorthand
          participantId: this.privRoom.participantId,
          roomid: this.privRoom.roomId,
          type: i.ConversationTranslatorMessageTypes.participantCommand,
          value: d
        });
      }, f.prototype.getMuteCommand = function(d, p) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(d, "participantId"), JSON.stringify({
          command: i.ConversationTranslatorCommandTypes.setMute,
          // tslint:disable-next-line: object-literal-shorthand
          participantId: d,
          roomid: this.privRoom.roomId,
          type: i.ConversationTranslatorMessageTypes.participantCommand,
          value: p
        });
      }, f.prototype.getLockCommand = function(d) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
          command: i.ConversationTranslatorCommandTypes.setLockState,
          // tslint:disable-next-line: object-literal-shorthand
          participantId: this.privRoom.participantId,
          roomid: this.privRoom.roomId,
          type: i.ConversationTranslatorMessageTypes.participantCommand,
          value: d
        });
      }, f.prototype.getEjectCommand = function(d) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(d, "participantId"), JSON.stringify({
          command: i.ConversationTranslatorCommandTypes.ejectParticipant,
          // tslint:disable-next-line: object-literal-shorthand
          participantId: d,
          roomid: this.privRoom.roomId,
          type: i.ConversationTranslatorMessageTypes.participantCommand
        });
      }, f.prototype.getChangeNicknameCommand = function(d) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(d, "nickname"), a.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
          command: i.ConversationTranslatorCommandTypes.changeNickname,
          nickname: d,
          // tslint:disable-next-line: object-literal-shorthand
          participantId: this.privRoom.participantId,
          roomid: this.privRoom.roomId,
          type: i.ConversationTranslatorMessageTypes.participantCommand,
          value: d
        });
      }, f.prototype.getMessageCommand = function(d) {
        return a.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), a.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), a.Contracts.throwIfNullOrWhitespace(d, "message"), JSON.stringify({
          // tslint:disable-next-line: object-literal-shorthand
          participantId: this.privRoom.participantId,
          roomId: this.privRoom.roomId,
          text: d,
          type: i.ConversationTranslatorMessageTypes.instantMessage
        });
      }, f;
    }(s)
  );
  return V0.ConversationImpl = c, V0;
}
var dm = {}, Vie;
function c1r() {
  if (Vie) return dm;
  Vie = 1, Object.defineProperty(dm, "__esModule", { value: !0 }), dm.ConversationCommon = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privAudioConfig = r;
      }
      return t.prototype.handleCallback = function(r, n) {
        if (r) {
          try {
            r();
          } catch (i) {
            n && n(i);
          }
          r = void 0;
        }
      }, t.prototype.handleError = function(r, n) {
        if (n)
          if (r instanceof Error) {
            var i = r;
            n(i.name + ": " + i.message);
          } else
            n(r);
      }, t;
    }()
  );
  return dm.ConversationCommon = e, dm;
}
var pm = {}, jie;
function l1r() {
  if (jie) return pm;
  jie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(pm, "__esModule", { value: !0 }), pm.ConversationExpirationEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a) {
        var u = n.call(this, a) || this;
        return u.privExpirationTime = o, u;
      }
      return Object.defineProperty(i.prototype, "expirationTime", {
        /** How much longer until the conversation expires (in minutes). */
        get: function() {
          return this.privExpirationTime;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SessionEventArgs)
  );
  return pm.ConversationExpirationEventArgs = r, pm;
}
var hm = {}, zie;
function f1r() {
  if (zie) return hm;
  zie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(hm, "__esModule", { value: !0 }), hm.ConversationParticipantsChangedEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u) {
        var s = n.call(this, u) || this;
        return s.privReason = o, s.privParticipant = a, s;
      }
      return Object.defineProperty(i.prototype, "reason", {
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "participants", {
        get: function() {
          return this.privParticipant;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.SessionEventArgs)
  );
  return hm.ConversationParticipantsChangedEventArgs = r, hm;
}
var vm = {}, qie;
function d1r() {
  if (qie) return vm;
  qie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(vm, "__esModule", { value: !0 }), vm.ConversationTranslationCanceledEventArgs = void 0;
  var t = BH(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return i;
    }(t.CancellationEventArgsBase)
  );
  return vm.ConversationTranslationCanceledEventArgs = r, vm;
}
var Em = {}, Yie;
function p1r() {
  if (Yie) return Em;
  Yie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(Em, "__esModule", { value: !0 }), Em.ConversationTranslationEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u) {
        var s = n.call(this, a, u) || this;
        return s.privResult = o, s;
      }
      return Object.defineProperty(i.prototype, "result", {
        /**
         * Specifies the recognition result.
         * @returns {ConversationTranslationResult} the recognition result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.RecognitionEventArgs)
  );
  return Em.ConversationTranslationEventArgs = r, Em;
}
var mm = {}, Gie;
function h1r() {
  if (Gie) return mm;
  Gie = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(mm, "__esModule", { value: !0 }), mm.ConversationTranslationResult = void 0;
  var t = a4e(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s, c, l, f, d, p, v, h) {
        var E = n.call(this, a, s, c, l, f, d, p, v, h) || this;
        return E.privId = o, E.privOrigLang = u, E;
      }
      return Object.defineProperty(i.prototype, "participantId", {
        /**
         * The unique identifier for the participant this result is for.
         */
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "originalLang", {
        /**
         * The original language this result was in.
         */
        get: function() {
          return this.privOrigLang;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.TranslationRecognitionResult)
  );
  return mm.ConversationTranslationResult = r, mm;
}
var zN = {}, Wie;
function v1r() {
  return Wie || (Wie = 1, function(e) {
    var t = fe && fe.__extends || /* @__PURE__ */ function() {
      var p = function(v, h) {
        return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, m) {
          E.__proto__ = m;
        } || function(E, m) {
          for (var g in m) m.hasOwnProperty(g) && (E[g] = m[g]);
        }, p(v, h);
      };
      return function(v, h) {
        p(v, h);
        function E() {
          this.constructor = v;
        }
        v.prototype = h === null ? Object.create(h) : (E.prototype = h.prototype, new E());
      };
    }(), r = fe && fe.__awaiter || function(p, v, h, E) {
      function m(g) {
        return g instanceof h ? g : new h(function(y) {
          y(g);
        });
      }
      return new (h || (h = Promise))(function(g, y) {
        function _(O) {
          try {
            A(E.next(O));
          } catch (P) {
            y(P);
          }
        }
        function S(O) {
          try {
            A(E.throw(O));
          } catch (P) {
            y(P);
          }
        }
        function A(O) {
          O.done ? g(O.value) : m(O.value).then(_, S);
        }
        A((E = E.apply(p, v || [])).next());
      });
    }, n = fe && fe.__generator || function(p, v) {
      var h = { label: 0, sent: function() {
        if (g[0] & 1) throw g[1];
        return g[1];
      }, trys: [], ops: [] }, E, m, g, y;
      return y = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
        return this;
      }), y;
      function _(A) {
        return function(O) {
          return S([A, O]);
        };
      }
      function S(A) {
        if (E) throw new TypeError("Generator is already executing.");
        for (; h; ) try {
          if (E = 1, m && (g = A[0] & 2 ? m.return : A[0] ? m.throw || ((g = m.return) && g.call(m), 0) : m.next) && !(g = g.call(m, A[1])).done) return g;
          switch (m = 0, g && (A = [A[0] & 2, g.value]), A[0]) {
            case 0:
            case 1:
              g = A;
              break;
            case 4:
              return h.label++, { value: A[1], done: !1 };
            case 5:
              h.label++, m = A[1], A = [0];
              continue;
            case 7:
              A = h.ops.pop(), h.trys.pop();
              continue;
            default:
              if (g = h.trys, !(g = g.length > 0 && g[g.length - 1]) && (A[0] === 6 || A[0] === 2)) {
                h = 0;
                continue;
              }
              if (A[0] === 3 && (!g || A[1] > g[0] && A[1] < g[3])) {
                h.label = A[1];
                break;
              }
              if (A[0] === 6 && h.label < g[1]) {
                h.label = g[1], g = A;
                break;
              }
              if (g && h.label < g[2]) {
                h.label = g[2], h.ops.push(A);
                break;
              }
              g[2] && h.ops.pop(), h.trys.pop();
              continue;
          }
          A = v.call(p, h);
        } catch (O) {
          A = [6, O], m = 0;
        } finally {
          E = g = 0;
        }
        if (A[0] & 5) throw A[1];
        return { value: A[0] ? A[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ConversationTranslator = e.SpeechState = void 0;
    var i = gr(), o = Ar(), a = tn(), u = Wt(), s = l4e(), c = f4e(), l;
    (function(p) {
      p[p.Inactive = 0] = "Inactive", p[p.Connecting = 1] = "Connecting", p[p.Connected = 2] = "Connected";
    })(l = e.SpeechState || (e.SpeechState = {}));
    var f = (
      /** @class */
      function(p) {
        t(v, p);
        function v(h, E, m) {
          var g = p.call(this, h, E) || this;
          return g.privSpeechState = l.Inactive, m && (g.privTranslator = m, g.sessionStarted = function() {
            g.privSpeechState = l.Connected;
          }, g.sessionStopped = function() {
            g.privSpeechState = l.Inactive;
          }, g.recognized = function(y, _) {
            return r(g, void 0, void 0, function() {
              var S;
              return n(this, function(A) {
                switch (A.label) {
                  case 0:
                    return !((S = _.result) === null || S === void 0) && S.errorDetails ? [4, this.cancelSpeech()] : [3, 2];
                  case 1:
                    A.sent(), this.fireCancelEvent(_.result.errorDetails), A.label = 2;
                  case 2:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }, g.canceled = function(y, _) {
            return r(g, void 0, void 0, function() {
              return n(this, function(S) {
                switch (S.label) {
                  case 0:
                    if (this.privSpeechState === l.Inactive) return [3, 4];
                    S.label = 1;
                  case 1:
                    return S.trys.push([1, 3, , 4]), [4, this.cancelSpeech()];
                  case 2:
                    return S.sent(), [3, 4];
                  case 3:
                    return S.sent(), this.privSpeechState = l.Inactive, [3, 4];
                  case 4:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), g;
        }
        return Object.defineProperty(v.prototype, "state", {
          get: function() {
            return this.privSpeechState;
          },
          set: function(h) {
            this.privSpeechState = h;
          },
          enumerable: !1,
          configurable: !0
        }), v.prototype.onConnection = function() {
          this.privSpeechState = l.Connected;
        }, v.prototype.onDisconnection = function() {
          return r(this, void 0, void 0, function() {
            return n(this, function(h) {
              switch (h.label) {
                case 0:
                  return this.privSpeechState = l.Inactive, [4, this.cancelSpeech()];
                case 1:
                  return h.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v.prototype.fireCancelEvent = function(h) {
          var E, m, g;
          try {
            if (this.privTranslator.canceled) {
              var y = new c.ConversationTranslationCanceledEventArgs((E = h == null ? void 0 : h.reason) !== null && E !== void 0 ? E : u.CancellationReason.Error, (m = h == null ? void 0 : h.errorDetails) !== null && m !== void 0 ? m : h, (g = h == null ? void 0 : h.errorCode) !== null && g !== void 0 ? g : u.CancellationErrorCode.RuntimeError, void 0, h == null ? void 0 : h.sessionId);
              this.privTranslator.canceled(this.privTranslator, y);
            }
          } catch {
          }
        }, v.prototype.cancelSpeech = function() {
          var h;
          return r(this, void 0, void 0, function() {
            return n(this, function(E) {
              switch (E.label) {
                case 0:
                  return E.trys.push([0, 2, , 3]), this.stopContinuousRecognitionAsync(), [4, (h = this.privReco) === null || h === void 0 ? void 0 : h.disconnect()];
                case 1:
                  return E.sent(), this.privSpeechState = l.Inactive, [3, 3];
                case 2:
                  return E.sent(), [3, 3];
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v;
      }(u.TranslationRecognizer)
    ), d = (
      /** @class */
      function(p) {
        t(v, p);
        function v(h) {
          var E = p.call(this, h) || this;
          return E.privIsDisposed = !1, E.privIsSpeaking = !1, E.privErrors = i.ConversationConnectionConfig.restErrors, E.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345", E.privPlaceholderRegion = "westus", E.privProperties = new u.PropertyCollection(), E;
        }
        return Object.defineProperty(v.prototype, "properties", {
          get: function() {
            return this.privProperties;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(v.prototype, "speechRecognitionLanguage", {
          get: function() {
            return this.privSpeechRecognitionLanguage;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(v.prototype, "participants", {
          get: function() {
            var h;
            return (h = this.privConversation) === null || h === void 0 ? void 0 : h.participants;
          },
          enumerable: !1,
          configurable: !0
        }), v.prototype.joinConversationAsync = function(h, E, m, g, y) {
          var _ = this;
          try {
            if (typeof h == "string") {
              a.Contracts.throwIfNullOrUndefined(h, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), a.Contracts.throwIfNullOrWhitespace(E, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privConversation && this.handleError(new Error(this.privErrors.permissionDeniedStart), y);
              var S = m;
              (S == null || S === "") && (S = i.ConversationConnectionConfig.defaultLanguageCode), this.privSpeechTranslationConfig = u.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion), this.privSpeechTranslationConfig.setProfanity(u.ProfanityOption.Masked), this.privSpeechTranslationConfig.addTargetLanguage(S), this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_RecoLanguage], S), this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.ConversationTranslator_Name], E);
              var A = this.privProperties.getProperty(u.PropertyId.ConversationTranslator_Host);
              A && this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.ConversationTranslator_Host], A);
              var O = this.privProperties.getProperty(u.PropertyId.SpeechServiceConnection_Host);
              O && this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_Host], O), this.privConversation = new s.ConversationImpl(this.privSpeechTranslationConfig), this.privConversation.conversationTranslator = this, this.privConversation.joinConversationAsync(h, E, S, function(P) {
                P || _.handleError(new Error(_.privErrors.permissionDeniedConnect), y), _.privSpeechTranslationConfig.authorizationToken = P, _.privConversation.startConversationAsync(function() {
                  _.handleCallback(g, y);
                }, function(U) {
                  _.handleError(U, y);
                });
              }, function(P) {
                _.handleError(P, y);
              });
            } else typeof h == "object" ? (a.Contracts.throwIfNullOrUndefined(h, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), a.Contracts.throwIfNullOrWhitespace(E, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privProperties.setProperty(u.PropertyId.ConversationTranslator_Name, E), this.privConversation = h, this.privConversation.conversationTranslator = this, a.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect), a.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privSpeechTranslationConfig = h.config, this.handleCallback(m, g)) : this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), g);
          } catch (P) {
            this.handleError(P, typeof m == "string" ? y : g);
          }
        }, v.prototype.leaveConversationAsync = function(h, E) {
          var m = this;
          o.marshalPromiseToCallbacks(function() {
            return r(m, void 0, void 0, function() {
              return n(this, function(g) {
                switch (g.label) {
                  case 0:
                    return [4, this.cancelSpeech()];
                  case 1:
                    return g.sent(), [4, this.privConversation.endConversationImplAsync()];
                  case 2:
                    return g.sent(), [4, this.privConversation.deleteConversationImplAsync()];
                  case 3:
                    return g.sent(), this.dispose(), [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }(), h, E);
        }, v.prototype.sendTextMessageAsync = function(h, E, m) {
          var g;
          try {
            a.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), a.Contracts.throwIfNullOrWhitespace(h, this.privErrors.invalidArgs.replace("{arg}", h)), (g = this.privConversation) === null || g === void 0 || g.sendTextMessageAsync(h, E, m);
          } catch (y) {
            this.handleError(y, m);
          }
        }, v.prototype.startTranscribingAsync = function(h, E) {
          var m = this;
          o.marshalPromiseToCallbacks(function() {
            return r(m, void 0, void 0, function() {
              var g;
              return n(this, function(y) {
                switch (y.label) {
                  case 0:
                    return y.trys.push([0, 4, , 6]), a.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), a.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privCTRecognizer !== void 0 ? [3, 2] : [4, this.connectTranslatorRecognizer()];
                  case 1:
                    y.sent(), y.label = 2;
                  case 2:
                    return a.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend), this.canSpeak || this.handleError(new Error(this.privErrors.permissionDeniedSend), E), [4, this.startContinuousRecognition()];
                  case 3:
                    return y.sent(), this.privIsSpeaking = !0, [3, 6];
                  case 4:
                    return g = y.sent(), this.privIsSpeaking = !1, [4, this.cancelSpeech()];
                  case 5:
                    throw y.sent(), g;
                  case 6:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }(), h, E);
        }, v.prototype.stopTranscribingAsync = function(h, E) {
          var m = this;
          o.marshalPromiseToCallbacks(function() {
            return r(m, void 0, void 0, function() {
              var g = this;
              return n(this, function(y) {
                switch (y.label) {
                  case 0:
                    return y.trys.push([0, 4, , 6]), this.privIsSpeaking ? [3, 2] : [4, this.cancelSpeech()];
                  case 1:
                    return y.sent(), [
                      2
                      /*return*/
                    ];
                  case 2:
                    return this.privIsSpeaking = !1, [4, new Promise(function(_, S) {
                      var A;
                      (A = g.privCTRecognizer) === null || A === void 0 || A.stopContinuousRecognitionAsync(_, S);
                    })];
                  case 3:
                    return y.sent(), [3, 6];
                  case 4:
                    return y.sent(), [4, this.cancelSpeech()];
                  case 5:
                    return y.sent(), [3, 6];
                  case 6:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }(), h, E);
        }, v.prototype.isDisposed = function() {
          return this.privIsDisposed;
        }, v.prototype.dispose = function(h, E, m) {
          var g = this;
          o.marshalPromiseToCallbacks(function() {
            return r(g, void 0, void 0, function() {
              var y, _;
              return n(this, function(S) {
                switch (S.label) {
                  case 0:
                    return this.isDisposed && !this.privIsSpeaking ? [
                      2
                      /*return*/
                    ] : [4, this.cancelSpeech()];
                  case 1:
                    return S.sent(), this.privIsDisposed = !0, (y = this.privSpeechTranslationConfig) === null || y === void 0 || y.close(), this.privSpeechRecognitionLanguage = void 0, this.privProperties = void 0, this.privAudioConfig = void 0, this.privSpeechTranslationConfig = void 0, (_ = this.privConversation) === null || _ === void 0 || _.dispose(), this.privConversation = void 0, [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }(), E, m);
        }, v.prototype.cancelSpeech = function() {
          var h;
          return r(this, void 0, void 0, function() {
            return n(this, function(E) {
              switch (E.label) {
                case 0:
                  return E.trys.push([0, 2, , 3]), this.privIsSpeaking = !1, [4, (h = this.privCTRecognizer) === null || h === void 0 ? void 0 : h.onDisconnection()];
                case 1:
                  return E.sent(), this.privCTRecognizer = void 0, [3, 3];
                case 2:
                  return E.sent(), [3, 3];
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v.prototype.connectTranslatorRecognizer = function() {
          return r(this, void 0, void 0, function() {
            var h, E, m, g;
            return n(this, function(y) {
              switch (y.label) {
                case 0:
                  return y.trys.push([0, 1, , 3]), this.privAudioConfig === void 0 && (this.privAudioConfig = u.AudioConfig.fromDefaultMicrophoneInput()), this.privSpeechTranslationConfig.getProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey && this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_Key], ""), h = encodeURIComponent(this.privConversation.room.token), E = this.privSpeechTranslationConfig.getProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_Host], i.ConversationConnectionConfig.speechHost), E = E.replace("{region}", this.privConversation.room.cognitiveSpeechRegion), m = "wss://" + E + i.ConversationConnectionConfig.speechPath + "?" + i.ConversationConnectionConfig.configParams.token + "=" + h, this.privSpeechTranslationConfig.setProperty(u.PropertyId[u.PropertyId.SpeechServiceConnection_Endpoint], m), this.privCTRecognizer = new f(this.privSpeechTranslationConfig, this.privAudioConfig, this), [3, 3];
                case 1:
                  return g = y.sent(), [4, this.cancelSpeech()];
                case 2:
                  throw y.sent(), g;
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, v.prototype.startContinuousRecognition = function() {
          var h = this;
          return new Promise(function(E, m) {
            h.privCTRecognizer.startContinuousRecognitionAsync(E, m);
          });
        }, Object.defineProperty(v.prototype, "canSpeak", {
          get: function() {
            return !(!this.privConversation.isConnected || !this.privCTRecognizer || this.privIsSpeaking || this.privCTRecognizer.state === l.Connected || this.privCTRecognizer.state === l.Connecting || this.privConversation.isMutedByHost);
          },
          enumerable: !1,
          configurable: !0
        }), v;
      }(c.ConversationCommon)
    );
    e.ConversationTranslator = d;
  }(zN)), zN;
}
var gm = {}, Kie;
function E1r() {
  if (Kie) return gm;
  Kie = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(gm, "__esModule", { value: !0 }), gm.ConversationTranscriber = void 0;
  var r = gr(), n = Ar(), i = tn(), o = Wt(), a = (
    /** @class */
    function() {
      function u(s) {
        this.privAudioConfig = s, this.privProperties = new o.PropertyCollection(), this.privRecognizer = void 0, this.privDisposedRecognizer = !1;
      }
      return u.prototype.joinConversationAsync = function(s, c, l) {
        var f = s;
        i.Contracts.throwIfNullOrUndefined(f, "Conversation"), this.privRecognizer = new r.TranscriberRecognizer(s.config, this.privAudioConfig), i.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer"), this.privRecognizer.connectCallbacks(this), n.marshalPromiseToCallbacks(f.connectTranscriberRecognizer(this.privRecognizer), c, l);
      }, Object.defineProperty(u.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(o.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member ConversationTranscriber.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(s) {
          i.Contracts.throwIfNullOrWhitespace(s, "token"), this.properties.setProperty(o.PropertyId.SpeechServiceAuthorization_Token, s);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "speechRecognitionLanguage", {
        /**
         * Gets the spoken language of recognition.
         * @member ConversationTranscriber.prototype.speechRecognitionLanguage
         * @function
         * @public
         * @returns {string} The spoken language of recognition.
         */
        get: function() {
          return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(o.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this ConversationTranscriber.
         * @member ConversationTranscriber.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this ConversationTranscriber.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.startTranscribingAsync = function(s, c) {
        this.privRecognizer.startContinuousRecognitionAsync(s, c);
      }, u.prototype.stopTranscribingAsync = function(s, c) {
        this.privRecognizer.stopContinuousRecognitionAsync(s, c);
      }, u.prototype.leaveConversationAsync = function(s, c) {
        var l = this;
        this.privRecognizer.disconnectCallbacks(), n.marshalPromiseToCallbacks(function() {
          return e(l, void 0, void 0, function() {
            return t(this, function(f) {
              return [
                2
                /*return*/
              ];
            });
          });
        }(), s, c);
      }, u.prototype.close = function(s, c) {
        i.Contracts.throwIfDisposed(this.privDisposedRecognizer), n.marshalPromiseToCallbacks(this.dispose(!0), s, c);
      }, u.prototype.dispose = function(s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            return this.privDisposedRecognizer ? [
              2
              /*return*/
            ] : (s && (this.privDisposedRecognizer = !0), [
              2
              /*return*/
            ]);
          });
        });
      }, u;
    }()
  );
  return gm.ConversationTranscriber = a, gm;
}
var j0 = {}, Xie;
function m1r() {
  if (Xie) return j0;
  Xie = 1, Object.defineProperty(j0, "__esModule", { value: !0 }), j0.Participant = j0.User = void 0;
  var e = Wt(), t = (
    /** @class */
    function() {
      function n(i) {
        this.privUserId = i;
      }
      return Object.defineProperty(n.prototype, "userId", {
        get: function() {
          return this.privUserId;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  j0.User = t;
  var r = (
    /** @class */
    function() {
      function n(i, o, a, u, s, c, l, f) {
        this.privId = i, this.privAvatar = o, this.privDisplayName = a, this.privIsHost = u, this.privIsMuted = s, this.privIsUsingTts = c, this.privPreferredLanguage = l, this.privVoice = f, this.privProperties = new e.PropertyCollection();
      }
      return n.From = function(i, o, a) {
        return new n(i, "", i, !1, !1, !1, o, a);
      }, Object.defineProperty(n.prototype, "avatar", {
        get: function() {
          return this.privAvatar;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "displayName", {
        get: function() {
          return this.privDisplayName;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "id", {
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "preferredLanguage", {
        get: function() {
          return this.privPreferredLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "isHost", {
        get: function() {
          return this.privIsHost;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "isMuted", {
        get: function() {
          return this.privIsMuted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "isUsingTts", {
        get: function() {
          return this.privIsUsingTts;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "voice", {
        get: function() {
          return this.privVoice;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "properties", {
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return j0.Participant = r, j0;
}
var qN = {}, Jie;
function g1r() {
  return Jie || (Jie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ParticipantChangedReason = void 0, function(t) {
      t[t.JoinedConversation = 0] = "JoinedConversation", t[t.LeftConversation = 1] = "LeftConversation", t[t.Updated = 2] = "Updated";
    }(e.ParticipantChangedReason || (e.ParticipantChangedReason = {}));
  }(qN)), qN;
}
var Zie;
function f4e() {
  return Zie || (Zie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t = l4e();
    Object.defineProperty(e, "Conversation", { enumerable: !0, get: function() {
      return t.Conversation;
    } }), Object.defineProperty(e, "ConversationImpl", { enumerable: !0, get: function() {
      return t.ConversationImpl;
    } });
    var r = c1r();
    Object.defineProperty(e, "ConversationCommon", { enumerable: !0, get: function() {
      return r.ConversationCommon;
    } });
    var n = l1r();
    Object.defineProperty(e, "ConversationExpirationEventArgs", { enumerable: !0, get: function() {
      return n.ConversationExpirationEventArgs;
    } });
    var i = f1r();
    Object.defineProperty(e, "ConversationParticipantsChangedEventArgs", { enumerable: !0, get: function() {
      return i.ConversationParticipantsChangedEventArgs;
    } });
    var o = d1r();
    Object.defineProperty(e, "ConversationTranslationCanceledEventArgs", { enumerable: !0, get: function() {
      return o.ConversationTranslationCanceledEventArgs;
    } });
    var a = p1r();
    Object.defineProperty(e, "ConversationTranslationEventArgs", { enumerable: !0, get: function() {
      return a.ConversationTranslationEventArgs;
    } });
    var u = h1r();
    Object.defineProperty(e, "ConversationTranslationResult", { enumerable: !0, get: function() {
      return u.ConversationTranslationResult;
    } });
    var s = v1r();
    Object.defineProperty(e, "ConversationTranslator", { enumerable: !0, get: function() {
      return s.ConversationTranslator;
    } });
    var c = E1r();
    Object.defineProperty(e, "ConversationTranscriber", { enumerable: !0, get: function() {
      return c.ConversationTranscriber;
    } });
    var l = m1r();
    Object.defineProperty(e, "Participant", { enumerable: !0, get: function() {
      return l.Participant;
    } }), Object.defineProperty(e, "User", { enumerable: !0, get: function() {
      return l.User;
    } });
    var f = g1r();
    Object.defineProperty(e, "ParticipantChangedReason", { enumerable: !0, get: function() {
      return f.ParticipantChangedReason;
    } });
  }(jN)), jN;
}
var z0 = {}, Qie;
function T1r() {
  if (Qie) return z0;
  Qie = 1;
  var e = fe && fe.__awaiter || function(f, d, p, v) {
    function h(E) {
      return E instanceof p ? E : new p(function(m) {
        m(E);
      });
    }
    return new (p || (p = Promise))(function(E, m) {
      function g(S) {
        try {
          _(v.next(S));
        } catch (A) {
          m(A);
        }
      }
      function y(S) {
        try {
          _(v.throw(S));
        } catch (A) {
          m(A);
        }
      }
      function _(S) {
        S.done ? E(S.value) : h(S.value).then(g, y);
      }
      _((v = v.apply(f, d || [])).next());
    });
  }, t = fe && fe.__generator || function(f, d) {
    var p = { label: 0, sent: function() {
      if (E[0] & 1) throw E[1];
      return E[1];
    }, trys: [], ops: [] }, v, h, E, m;
    return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
      return this;
    }), m;
    function g(_) {
      return function(S) {
        return y([_, S]);
      };
    }
    function y(_) {
      if (v) throw new TypeError("Generator is already executing.");
      for (; p; ) try {
        if (v = 1, h && (E = _[0] & 2 ? h.return : _[0] ? h.throw || ((E = h.return) && E.call(h), 0) : h.next) && !(E = E.call(h, _[1])).done) return E;
        switch (h = 0, E && (_ = [_[0] & 2, E.value]), _[0]) {
          case 0:
          case 1:
            E = _;
            break;
          case 4:
            return p.label++, { value: _[1], done: !1 };
          case 5:
            p.label++, h = _[1], _ = [0];
            continue;
          case 7:
            _ = p.ops.pop(), p.trys.pop();
            continue;
          default:
            if (E = p.trys, !(E = E.length > 0 && E[E.length - 1]) && (_[0] === 6 || _[0] === 2)) {
              p = 0;
              continue;
            }
            if (_[0] === 3 && (!E || _[1] > E[0] && _[1] < E[3])) {
              p.label = _[1];
              break;
            }
            if (_[0] === 6 && p.label < E[1]) {
              p.label = E[1], E = _;
              break;
            }
            if (E && p.label < E[2]) {
              p.label = E[2], p.ops.push(_);
              break;
            }
            E[2] && p.ops.pop(), p.trys.pop();
            continue;
        }
        _ = d.call(f, p);
      } catch (S) {
        _ = [6, S], h = 0;
      } finally {
        v = E = 0;
      }
      if (_[0] & 5) throw _[1];
      return { value: _[0] ? _[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(z0, "__esModule", { value: !0 }), z0.SynthesisRequest = z0.SpeechSynthesizer = void 0;
  var r = gr(), n = Ar(), i = n4e(), o = Q3(), a = Qh(), u = tn(), s = Wt(), c = (
    /** @class */
    function() {
      function f(d, p) {
        var v = d;
        u.Contracts.throwIfNull(v, "speechConfig"), p !== null && (p === void 0 ? this.audioConfig = typeof window > "u" ? void 0 : s.AudioConfig.fromDefaultSpeakerOutput() : this.audioConfig = p), this.privProperties = v.properties.clone(), this.privDisposed = !1, this.privSynthesizing = !1, this.privConnectionFactory = new r.SpeechSynthesisConnectionFactory(), this.synthesisRequestQueue = new n.Queue(), this.implCommonSynthesizeSetup();
      }
      return Object.defineProperty(f.prototype, "authorizationToken", {
        /**
         * Gets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @returns {string} Authorization token.
         */
        get: function() {
          return this.properties.getProperty(s.PropertyId.SpeechServiceAuthorization_Token);
        },
        /**
         * Gets/Sets the authorization token used to communicate with the service.
         * @member SpeechSynthesizer.prototype.authorizationToken
         * @function
         * @public
         * @param {string} token - Authorization token.
         */
        set: function(d) {
          u.Contracts.throwIfNullOrWhitespace(d, "token"), this.properties.setProperty(s.PropertyId.SpeechServiceAuthorization_Token, d);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "properties", {
        /**
         * The collection of properties and their values defined for this SpeechSynthesizer.
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(f.prototype, "autoDetectSourceLanguage", {
        /**
         * Indicates if auto detect source language is enabled
         * @member SpeechSynthesizer.prototype.properties
         * @function
         * @public
         * @returns {boolean} if auto detect source language is enabled
         */
        get: function() {
          return this.properties.getProperty(s.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === r.AutoDetectSourceLanguagesOpenRangeOptionName;
        },
        enumerable: !1,
        configurable: !0
      }), f.FromConfig = function(d, p, v) {
        var h = d;
        return p.properties.mergeTo(h.properties), new f(d, v);
      }, f.prototype.buildSsml = function(d) {
        var p, v = (p = {}, p["ar-EG"] = "Microsoft Server Speech Text to Speech Voice (ar-EG, Hoda)", p["ar-SA"] = "Microsoft Server Speech Text to Speech Voice (ar-SA, Naayf)", p["bg-BG"] = "Microsoft Server Speech Text to Speech Voice (bg-BG, Ivan)", p["ca-ES"] = "Microsoft Server Speech Text to Speech Voice (ca-ES, HerenaRUS)", p["cs-CZ"] = "Microsoft Server Speech Text to Speech Voice (cs-CZ, Jakub)", p["da-DK"] = "Microsoft Server Speech Text to Speech Voice (da-DK, HelleRUS)", p["de-AT"] = "Microsoft Server Speech Text to Speech Voice (de-AT, Michael)", p["de-CH"] = "Microsoft Server Speech Text to Speech Voice (de-CH, Karsten)", p["de-DE"] = "Microsoft Server Speech Text to Speech Voice (de-DE, HeddaRUS)", p["el-GR"] = "Microsoft Server Speech Text to Speech Voice (el-GR, Stefanos)", p["en-AU"] = "Microsoft Server Speech Text to Speech Voice (en-AU, HayleyRUS)", p["en-CA"] = "Microsoft Server Speech Text to Speech Voice (en-CA, HeatherRUS)", p["en-GB"] = "Microsoft Server Speech Text to Speech Voice (en-GB, HazelRUS)", p["en-IE"] = "Microsoft Server Speech Text to Speech Voice (en-IE, Sean)", p["en-IN"] = "Microsoft Server Speech Text to Speech Voice (en-IN, PriyaRUS)", p["en-US"] = "Microsoft Server Speech Text to Speech Voice (en-US, AriaRUS)", p["es-ES"] = "Microsoft Server Speech Text to Speech Voice (es-ES, HelenaRUS)", p["es-MX"] = "Microsoft Server Speech Text to Speech Voice (es-MX, HildaRUS)", p["fi-FI"] = "Microsoft Server Speech Text to Speech Voice (fi-FI, HeidiRUS)", p["fr-CA"] = "Microsoft Server Speech Text to Speech Voice (fr-CA, HarmonieRUS)", p["fr-CH"] = "Microsoft Server Speech Text to Speech Voice (fr-CH, Guillaume)", p["fr-FR"] = "Microsoft Server Speech Text to Speech Voice (fr-FR, HortenseRUS)", p["he-IL"] = "Microsoft Server Speech Text to Speech Voice (he-IL, Asaf)", p["hi-IN"] = "Microsoft Server Speech Text to Speech Voice (hi-IN, Kalpana)", p["hr-HR"] = "Microsoft Server Speech Text to Speech Voice (hr-HR, Matej)", p["hu-HU"] = "Microsoft Server Speech Text to Speech Voice (hu-HU, Szabolcs)", p["id-ID"] = "Microsoft Server Speech Text to Speech Voice (id-ID, Andika)", p["it-IT"] = "Microsoft Server Speech Text to Speech Voice (it-IT, LuciaRUS)", p["ja-JP"] = "Microsoft Server Speech Text to Speech Voice (ja-JP, HarukaRUS)", p["ko-KR"] = "Microsoft Server Speech Text to Speech Voice (ko-KR, HeamiRUS)", p["ms-MY"] = "Microsoft Server Speech Text to Speech Voice (ms-MY, Rizwan)", p["nb-NO"] = "Microsoft Server Speech Text to Speech Voice (nb-NO, HuldaRUS)", p["nl-NL"] = "Microsoft Server Speech Text to Speech Voice (nl-NL, HannaRUS)", p["pl-PL"] = "Microsoft Server Speech Text to Speech Voice (pl-PL, PaulinaRUS)", p["pt-BR"] = "Microsoft Server Speech Text to Speech Voice (pt-BR, HeloisaRUS)", p["pt-PT"] = "Microsoft Server Speech Text to Speech Voice (pt-PT, HeliaRUS)", p["ro-RO"] = "Microsoft Server Speech Text to Speech Voice (ro-RO, Andrei)", p["ru-RU"] = "Microsoft Server Speech Text to Speech Voice (ru-RU, EkaterinaRUS)", p["sk-SK"] = "Microsoft Server Speech Text to Speech Voice (sk-SK, Filip)", p["sl-SI"] = "Microsoft Server Speech Text to Speech Voice (sl-SI, Lado)", p["sv-SE"] = "Microsoft Server Speech Text to Speech Voice (sv-SE, HedvigRUS)", p["ta-IN"] = "Microsoft Server Speech Text to Speech Voice (ta-IN, Valluvar)", p["te-IN"] = "Microsoft Server Speech Text to Speech Voice (te-IN, Chitra)", p["th-TH"] = "Microsoft Server Speech Text to Speech Voice (th-TH, Pattara)", p["tr-TR"] = "Microsoft Server Speech Text to Speech Voice (tr-TR, SedaRUS)", p["vi-VN"] = "Microsoft Server Speech Text to Speech Voice (vi-VN, An)", p["zh-CN"] = "Microsoft Server Speech Text to Speech Voice (zh-CN, HuihuiRUS)", p["zh-HK"] = "Microsoft Server Speech Text to Speech Voice (zh-HK, TracyRUS)", p["zh-TW"] = "Microsoft Server Speech Text to Speech Voice (zh-TW, HanHanRUS)", p), h = this.properties.getProperty(s.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US"), E = this.properties.getProperty(s.PropertyId.SpeechServiceConnection_SynthVoice, ""), m = f.XMLEncode(d);
        return this.autoDetectSourceLanguage ? h = "en-US" : E = E || v[h], E && (m = "<voice name='" + E + "'>" + m + "</voice>"), m = "<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='" + h + "'>" + m + "</speak>", m;
      }, f.prototype.speakTextAsync = function(d, p, v, h) {
        this.speakImpl(d, !1, p, v, h);
      }, f.prototype.speakSsmlAsync = function(d, p, v, h) {
        this.speakImpl(d, !0, p, v, h);
      }, f.prototype.close = function(d, p) {
        u.Contracts.throwIfDisposed(this.privDisposed), n.marshalPromiseToCallbacks(this.dispose(!0), d, p);
      }, Object.defineProperty(f.prototype, "internalData", {
        /**
         * @Internal
         * Do not use externally, object returned will change without warning or notice.
         */
        get: function() {
          return this.privAdapter;
        },
        enumerable: !1,
        configurable: !0
      }), f.prototype.dispose = function(d) {
        return e(this, void 0, void 0, function() {
          return t(this, function(p) {
            switch (p.label) {
              case 0:
                return this.privDisposed ? [
                  2
                  /*return*/
                ] : d ? this.privAdapter ? [4, this.privAdapter.dispose()] : [3, 2] : [3, 2];
              case 1:
                p.sent(), p.label = 2;
              case 2:
                return this.privDisposed = !0, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f.prototype.createSynthesizerConfig = function(d) {
        return new r.SynthesizerConfig(d, this.privProperties);
      }, f.prototype.createSynthesisAdapter = function(d, p, v, h) {
        return new r.SynthesisAdapterBase(d, p, h, this, this.audioConfig);
      }, f.prototype.implCommonSynthesizeSetup = function() {
        var d = this, p = typeof window < "u" ? "Browser" : "Node", v = "unknown", h = "unknown";
        typeof navigator < "u" && (p = p + "/" + navigator.platform, v = navigator.userAgent, h = navigator.appVersion);
        var E = this.createSynthesizerConfig(new r.SpeechServiceConfig(new r.Context(new r.OS(p, v, h)))), m = this.privProperties.getProperty(s.PropertyId.SpeechServiceConnection_Key, void 0), g = m && m !== "" ? new r.CognitiveSubscriptionKeyAuthentication(m) : new r.CognitiveTokenAuthentication(function(y) {
          var _ = d.privProperties.getProperty(s.PropertyId.SpeechServiceAuthorization_Token, void 0);
          return Promise.resolve(_);
        }, function(y) {
          var _ = d.privProperties.getProperty(s.PropertyId.SpeechServiceAuthorization_Token, void 0);
          return Promise.resolve(_);
        });
        this.privAdapter = this.createSynthesisAdapter(g, this.privConnectionFactory, this.audioConfig, E), this.privAdapter.audioOutputFormat = o.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat(s.SpeechSynthesisOutputFormat[this.properties.getProperty(s.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)]);
      }, f.prototype.speakImpl = function(d, p, v, h, E) {
        var m = this;
        try {
          u.Contracts.throwIfDisposed(this.privDisposed);
          var g = n.createNoDashGuid(), y = void 0;
          E instanceof s.PushAudioOutputStreamCallback ? y = new a.PushAudioOutputStreamImpl(E) : E instanceof s.PullAudioOutputStream ? y = E : E !== void 0 ? y = new i.AudioFileWriter(E) : y = void 0, this.synthesisRequestQueue.enqueue(new l(g, d, p, function(S) {
            if (m.privSynthesizing = !1, v)
              try {
                v(S);
              } catch (A) {
                h && h(A);
              }
            v = void 0, m.adapterSpeak().catch(function() {
            });
          }, function(S) {
            h && h(S);
          }, y)), this.adapterSpeak().catch(function() {
          });
        } catch (S) {
          if (h)
            if (S instanceof Error) {
              var _ = S;
              h(_.name + ": " + _.message);
            } else
              h(S);
          this.dispose(!0).catch(function() {
          });
        }
      }, f.prototype.adapterSpeak = function() {
        return e(this, void 0, void 0, function() {
          var d;
          return t(this, function(p) {
            switch (p.label) {
              case 0:
                return !this.privDisposed && !this.privSynthesizing ? (this.privSynthesizing = !0, [4, this.synthesisRequestQueue.dequeue()]) : [3, 2];
              case 1:
                return d = p.sent(), [2, this.privAdapter.Speak(d.text, d.isSSML, d.requestId, d.cb, d.err, d.dataStream)];
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f.XMLEncode = function(d) {
        return d.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
      }, f;
    }()
  );
  z0.SpeechSynthesizer = c;
  var l = (
    /** @class */
    /* @__PURE__ */ function() {
      function f(d, p, v, h, E, m) {
        this.requestId = d, this.text = p, this.isSSML = v, this.cb = h, this.err = E, this.dataStream = m;
      }
      return f;
    }()
  );
  return z0.SynthesisRequest = l, z0;
}
var Tm = {}, eoe;
function y1r() {
  if (eoe) return Tm;
  eoe = 1, Object.defineProperty(Tm, "__esModule", { value: !0 }), Tm.SpeechSynthesisResult = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i, o, a) {
        this.privResultId = r, this.privReason = n, this.privAudioData = i, this.privErrorDetails = o, this.privProperties = a;
      }
      return Object.defineProperty(t.prototype, "resultId", {
        /**
         * Specifies the result identifier.
         * @member SpeechSynthesisResult.prototype.resultId
         * @function
         * @public
         * @returns {string} Specifies the result identifier.
         */
        get: function() {
          return this.privResultId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "reason", {
        /**
         * Specifies status of the result.
         * @member SpeechSynthesisResult.prototype.reason
         * @function
         * @public
         * @returns {ResultReason} Specifies status of the result.
         */
        get: function() {
          return this.privReason;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "audioData", {
        /**
         * The synthesized audio data
         * @member SpeechSynthesisResult.prototype.audioData
         * @function
         * @public
         * @returns {ArrayBuffer} The synthesized audio data.
         */
        get: function() {
          return this.privAudioData;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "errorDetails", {
        /**
         * In case of an unsuccessful synthesis, provides details of the occurred error.
         * @member SpeechSynthesisResult.prototype.errorDetails
         * @function
         * @public
         * @returns {string} a brief description of an error.
         */
        get: function() {
          return this.privErrorDetails;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "properties", {
        /**
         *  The set of properties exposed in the result.
         * @member SpeechSynthesisResult.prototype.properties
         * @function
         * @public
         * @returns {PropertyCollection} The set of properties exposed in the result.
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Tm.SpeechSynthesisResult = e, Tm;
}
var ym = {}, toe;
function _1r() {
  if (toe) return ym;
  toe = 1, Object.defineProperty(ym, "__esModule", { value: !0 }), ym.SpeechSynthesisEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privResult = r;
      }
      return Object.defineProperty(t.prototype, "result", {
        /**
         * Specifies the synthesis result.
         * @member SpeechSynthesisEventArgs.prototype.result
         * @function
         * @public
         * @returns {SpeechSynthesisResult} the synthesis result.
         */
        get: function() {
          return this.privResult;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return ym.SpeechSynthesisEventArgs = e, ym;
}
var _m = {}, roe;
function A1r() {
  if (roe) return _m;
  roe = 1, Object.defineProperty(_m, "__esModule", { value: !0 }), _m.SpeechSynthesisWordBoundaryEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i, o) {
        this.privAudioOffset = r, this.privText = n, this.privWordLength = i, this.privTextOffset = o;
      }
      return Object.defineProperty(t.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */
        get: function() {
          return this.privAudioOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "text", {
        /**
         * Specifies the text of the word boundary event.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the text.
         */
        get: function() {
          return this.privText;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "wordLength", {
        /**
         * Specifies the word length
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
         * @function
         * @public
         * @returns {number} the word length
         */
        get: function() {
          return this.privWordLength;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "textOffset", {
        /**
         * Specifies the text offset.
         * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
         * @function
         * @public
         * @returns {number} the text offset.
         */
        get: function() {
          return this.privTextOffset;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return _m.SpeechSynthesisWordBoundaryEventArgs = e, _m;
}
var Am = {}, noe;
function S1r() {
  if (noe) return Am;
  noe = 1, Object.defineProperty(Am, "__esModule", { value: !0 }), Am.SpeechSynthesisBookmarkEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        this.privAudioOffset = r, this.privText = n;
      }
      return Object.defineProperty(t.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */
        get: function() {
          return this.privAudioOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "text", {
        /**
         * Specifies the bookmark.
         * @member SpeechSynthesisBookmarkEventArgs.prototype.text
         * @function
         * @public
         * @returns {string} the bookmark text.
         */
        get: function() {
          return this.privText;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Am.SpeechSynthesisBookmarkEventArgs = e, Am;
}
var Sm = {}, ioe;
function b1r() {
  if (ioe) return Sm;
  ioe = 1, Object.defineProperty(Sm, "__esModule", { value: !0 }), Sm.SpeechSynthesisVisemeEventArgs = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n, i) {
        this.privAudioOffset = r, this.privVisemeId = n, this.privAnimation = i;
      }
      return Object.defineProperty(t.prototype, "audioOffset", {
        /**
         * Specifies the audio offset.
         * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
         * @function
         * @public
         * @returns {number} the audio offset.
         */
        get: function() {
          return this.privAudioOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "visemeId", {
        /**
         * Specifies the viseme ID.
         * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
         * @function
         * @public
         * @returns {number} the viseme ID.
         */
        get: function() {
          return this.privVisemeId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "animation", {
        /**
         * Specifies the animation.
         * @member SpeechSynthesisVisemeEventArgs.prototype.animation
         * @function
         * @public
         * @returns {string} the animation, could be in svg or other format.
         */
        get: function() {
          return this.privAnimation;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Sm.SpeechSynthesisVisemeEventArgs = e, Sm;
}
var bm = {}, ooe;
function C1r() {
  if (ooe) return bm;
  ooe = 1;
  var e = fe && fe.__awaiter || function(l, f, d, p) {
    function v(h) {
      return h instanceof d ? h : new d(function(E) {
        E(h);
      });
    }
    return new (d || (d = Promise))(function(h, E) {
      function m(_) {
        try {
          y(p.next(_));
        } catch (S) {
          E(S);
        }
      }
      function g(_) {
        try {
          y(p.throw(_));
        } catch (S) {
          E(S);
        }
      }
      function y(_) {
        _.done ? h(_.value) : v(_.value).then(m, g);
      }
      y((p = p.apply(l, f || [])).next());
    });
  }, t = fe && fe.__generator || function(l, f) {
    var d = { label: 0, sent: function() {
      if (h[0] & 1) throw h[1];
      return h[1];
    }, trys: [], ops: [] }, p, v, h, E;
    return E = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (E[Symbol.iterator] = function() {
      return this;
    }), E;
    function m(y) {
      return function(_) {
        return g([y, _]);
      };
    }
    function g(y) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; d; ) try {
        if (p = 1, v && (h = y[0] & 2 ? v.return : y[0] ? v.throw || ((h = v.return) && h.call(v), 0) : v.next) && !(h = h.call(v, y[1])).done) return h;
        switch (v = 0, h && (y = [y[0] & 2, h.value]), y[0]) {
          case 0:
          case 1:
            h = y;
            break;
          case 4:
            return d.label++, { value: y[1], done: !1 };
          case 5:
            d.label++, v = y[1], y = [0];
            continue;
          case 7:
            y = d.ops.pop(), d.trys.pop();
            continue;
          default:
            if (h = d.trys, !(h = h.length > 0 && h[h.length - 1]) && (y[0] === 6 || y[0] === 2)) {
              d = 0;
              continue;
            }
            if (y[0] === 3 && (!h || y[1] > h[0] && y[1] < h[3])) {
              d.label = y[1];
              break;
            }
            if (y[0] === 6 && d.label < h[1]) {
              d.label = h[1], h = y;
              break;
            }
            if (h && d.label < h[2]) {
              d.label = h[2], d.ops.push(y);
              break;
            }
            h[2] && d.ops.pop(), d.trys.pop();
            continue;
        }
        y = f.call(l, d);
      } catch (_) {
        y = [6, _], v = 0;
      } finally {
        p = h = 0;
      }
      if (y[0] & 5) throw y[1];
      return { value: y[0] ? y[1] : void 0, done: !0 };
    }
  }, r;
  Object.defineProperty(bm, "__esModule", { value: !0 }), bm.SpeakerAudioDestination = void 0;
  var n = gr(), i = Ar(), o = Qh(), a = Td(), u = 60 * 30, s = (r = {}, r[a.AudioFormatTag.PCM] = "audio/wav", r[a.AudioFormatTag.MuLaw] = "audio/x-wav", r[a.AudioFormatTag.MP3] = "audio/mpeg", r[a.AudioFormatTag.OGG_OPUS] = "audio/ogg", r[a.AudioFormatTag.WEBM_OPUS] = "audio/webm; codecs=opus", r[a.AudioFormatTag.ALaw] = "audio/x-wav", r), c = (
    /** @class */
    function() {
      function l(f) {
        this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = f || i.createNoDashGuid(), this.privIsPaused = !1, this.privIsClosed = !1;
      }
      return l.prototype.id = function() {
        return this.privId;
      }, l.prototype.write = function(f, d, p) {
        this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(f), this.updateSourceBuffer().then(function() {
          d && d();
        }, function(v) {
          p && p(v);
        })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(f), this.privBytesReceived += f.byteLength);
      }, l.prototype.close = function(f, d) {
        var p = this;
        if (this.privIsClosed = !0, this.privSourceBuffer !== void 0)
          this.handleSourceBufferUpdateEnd().then(function() {
            f && f();
          }, function(h) {
            d && d(h);
          });
        else if (this.privAudioOutputStream !== void 0)
          if ((this.privFormat.formatTag === a.AudioFormatTag.PCM || this.privFormat.formatTag === a.AudioFormatTag.MuLaw || this.privFormat.formatTag === a.AudioFormatTag.ALaw) && this.privFormat.hasHeader === !1)
            console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
          else {
            var v = new ArrayBuffer(this.privBytesReceived);
            this.privAudioOutputStream.read(v).then(function(h) {
              v = n.SynthesisAdapterBase.addHeader(v, p.privFormat);
              var E = new Blob([v], { type: s[p.privFormat.formatTag] });
              p.privAudio.src = window.URL.createObjectURL(E), p.notifyPlayback().then(function() {
                f && f();
              }, function(m) {
                d && d(m);
              });
            }, function(h) {
              d && d(h);
            });
          }
        else
          this.onAudioEnd && this.onAudioEnd(this);
      }, Object.defineProperty(l.prototype, "format", {
        set: function(f) {
          var d = this;
          if (typeof AudioContext < "u" || typeof window.webkitAudioContext < "u") {
            this.privFormat = f;
            var p = s[this.privFormat.formatTag];
            p === void 0 ? console.warn("Unknown mimeType for format " + a.AudioFormatTag[this.privFormat.formatTag] + "; playback is not supported.") : typeof MediaSource < "u" && MediaSource.isTypeSupported(p) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = function(v) {
              d.privMediaSourceOpened = !0, d.privMediaSource.duration = u, d.privSourceBuffer = d.privMediaSource.addSourceBuffer(p), d.privSourceBuffer.onupdate = function(h) {
                d.updateSourceBuffer().catch(function(E) {
                  i.Events.instance.onEvent(new i.BackgroundEvent(E));
                });
              }, d.privSourceBuffer.onupdateend = function(h) {
                d.handleSourceBufferUpdateEnd().catch(function(E) {
                  i.Events.instance.onEvent(new i.BackgroundEvent(E));
                });
              }, d.privSourceBuffer.onupdatestart = function(h) {
                d.privAppendingToBuffer = !1;
              };
            }, this.updateSourceBuffer().catch(function(v) {
              i.Events.instance.onEvent(new i.BackgroundEvent(v));
            })) : (console.warn("Format " + a.AudioFormatTag[this.privFormat.formatTag] + " could not be played by MSE, streaming playback is not enabled."), this.privAudioOutputStream = new o.PullAudioOutputStreamImpl(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
          }
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(l.prototype, "isClosed", {
        get: function() {
          return this.privIsClosed;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(l.prototype, "currentTime", {
        get: function() {
          return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
        },
        enumerable: !1,
        configurable: !0
      }), l.prototype.pause = function() {
        !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
      }, l.prototype.resume = function(f, d) {
        this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(function() {
          f && f();
        }, function(p) {
          d && d(p);
        }), this.privIsPaused = !1);
      }, Object.defineProperty(l.prototype, "internalAudio", {
        get: function() {
          return this.privAudio;
        },
        enumerable: !1,
        configurable: !0
      }), l.prototype.updateSourceBuffer = function() {
        return e(this, void 0, void 0, function() {
          var f;
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                if (!(this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable())) return [3, 2];
                this.privAppendingToBuffer = !0, f = this.privAudioBuffer.shift();
                try {
                  this.privSourceBuffer.appendBuffer(f);
                } catch {
                  return this.privAudioBuffer.unshift(f), console.log("buffer filled, pausing addition of binaries until space is made"), [
                    2
                    /*return*/
                  ];
                }
                return [4, this.notifyPlayback()];
              case 1:
                return d.sent(), [3, 4];
              case 2:
                return this.canEndStream() ? [4, this.handleSourceBufferUpdateEnd()] : [3, 4];
              case 3:
                d.sent(), d.label = 4;
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, l.prototype.handleSourceBufferUpdateEnd = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return this.canEndStream() && this.sourceBufferAvailable() ? (this.privMediaSource.endOfStream(), [4, this.notifyPlayback()]) : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, l.prototype.notifyPlayback = function() {
        return e(this, void 0, void 0, function() {
          var f = this;
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                return !this.privPlaybackStarted && this.privAudio !== void 0 ? (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = function() {
                  f.onAudioEnd && f.onAudioEnd(f);
                }, this.privIsPaused ? [3, 2] : [4, this.privAudio.play()]) : [3, 2];
              case 1:
                d.sent(), d.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, l.prototype.canEndStream = function() {
        return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
      }, l.prototype.sourceBufferAvailable = function() {
        return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
      }, l;
    }()
  );
  return bm.SpeakerAudioDestination = c, bm;
}
var Cm = {}, aoe;
function I1r() {
  if (aoe) return Cm;
  aoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(Cm, "__esModule", { value: !0 }), Cm.ConversationTranscriptionCanceledEventArgs = void 0;
  var t = BH(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return i;
    }(t.CancellationEventArgsBase)
  );
  return Cm.ConversationTranscriptionCanceledEventArgs = r, Cm;
}
var YN = {}, uoe;
function O1r() {
  return uoe || (uoe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PronunciationAssessmentGradingSystem = void 0, function(t) {
      t[t.FivePoint = 1] = "FivePoint", t[t.HundredMark = 2] = "HundredMark";
    }(e.PronunciationAssessmentGradingSystem || (e.PronunciationAssessmentGradingSystem = {}));
  }(YN)), YN;
}
var GN = {}, soe;
function R1r() {
  return soe || (soe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PronunciationAssessmentGranularity = void 0, function(t) {
      t[t.Phoneme = 1] = "Phoneme", t[t.Word = 2] = "Word", t[t.FullText = 3] = "FullText";
    }(e.PronunciationAssessmentGranularity || (e.PronunciationAssessmentGranularity = {}));
  }(GN)), GN;
}
var Im = {}, coe;
function w1r() {
  if (coe) return Im;
  coe = 1, Object.defineProperty(Im, "__esModule", { value: !0 }), Im.PronunciationAssessmentConfig = void 0;
  var e = tn(), t = Wt(), r = (
    /** @class */
    function() {
      function n(i, o, a, u) {
        o === void 0 && (o = t.PronunciationAssessmentGradingSystem.FivePoint), a === void 0 && (a = t.PronunciationAssessmentGranularity.Phoneme), u === void 0 && (u = !1), e.Contracts.throwIfNullOrUndefined(i, "referenceText"), this.privProperties = new t.PropertyCollection(), this.privProperties.setProperty(t.PropertyId.PronunciationAssessment_ReferenceText, i), this.privProperties.setProperty(t.PropertyId.PronunciationAssessment_GradingSystem, t.PronunciationAssessmentGradingSystem[o]), this.privProperties.setProperty(t.PropertyId.PronunciationAssessment_Granularity, t.PronunciationAssessmentGranularity[a]), this.privProperties.setProperty(t.PropertyId.PronunciationAssessment_EnableMiscue, String(u));
      }
      return n.fromJSON = function(i) {
        e.Contracts.throwIfNullOrUndefined(i, "json");
        var o = new n("");
        return o.privProperties = new t.PropertyCollection(), o.properties.setProperty(t.PropertyId.PronunciationAssessment_Json, i), o;
      }, n.prototype.toJSON = function() {
        return this.updateJson(), this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_Params);
      }, n.prototype.applyTo = function(i) {
        this.updateJson();
        var o = i.internalData;
        o.speechContext.setPronunciationAssessmentParams(this.properties.getProperty(t.PropertyId.PronunciationAssessment_Params));
      }, Object.defineProperty(n.prototype, "referenceText", {
        /**
         * Gets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @returns {string} Reference text.
         */
        get: function() {
          return this.properties.getProperty(t.PropertyId.PronunciationAssessment_ReferenceText);
        },
        /**
         * Gets/Sets the reference text.
         * @member PronunciationAssessmentConfig.prototype.referenceText
         * @function
         * @public
         * @param {string} referenceText - Reference text.
         */
        set: function(i) {
          e.Contracts.throwIfNullOrWhitespace(i, "referenceText"), this.properties.setProperty(t.PropertyId.PronunciationAssessment_ReferenceText, i);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "properties", {
        /**
         * @member PronunciationAssessmentConfig.prototype.properties
         * @function
         * @public
         * @return {PropertyCollection} Properties of the config.
         * @summary Gets a pronunciation assessment config properties
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), n.prototype.updateJson = function() {
        var i = this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_Json, "{}"), o = JSON.parse(i), a = this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_ReferenceText);
        a && (o.referenceText = a);
        var u = this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_GradingSystem);
        u && (o.gradingSystem = u);
        var s = this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_Granularity);
        s && (o.granularity = s), o.dimension = "Comprehensive";
        var c = this.privProperties.getProperty(t.PropertyId.PronunciationAssessment_EnableMiscue);
        c === "true" ? o.enableMiscue = !0 : c === "false" && (o.enableMiscue = !1), this.privProperties.setProperty(t.PropertyId.PronunciationAssessment_Params, JSON.stringify(o));
      }, n;
    }()
  );
  return Im.PronunciationAssessmentConfig = r, Im;
}
var Om = {}, loe;
function P1r() {
  if (loe) return Om;
  loe = 1, Object.defineProperty(Om, "__esModule", { value: !0 }), Om.PronunciationAssessmentResult = void 0;
  var e = tn(), t = Wt(), r = (
    /** @class */
    function() {
      function n(i) {
        var o = JSON.parse(i);
        e.Contracts.throwIfNullOrUndefined(o.NBest[0], "NBest"), this.privPronJson = o.NBest[0];
      }
      return n.fromResult = function(i) {
        e.Contracts.throwIfNullOrUndefined(i, "result");
        var o = i.properties.getProperty(t.PropertyId.SpeechServiceResponse_JsonResult);
        return e.Contracts.throwIfNullOrUndefined(o, "json"), new n(o);
      }, Object.defineProperty(n.prototype, "detailResult", {
        /**
         * Gets the detail result of pronunciation assessment.
         * @member PronunciationAssessmentConfig.prototype.detailResult
         * @function
         * @public
         * @returns {any} detail result.
         */
        get: function() {
          return this.privPronJson;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "accuracyScore", {
        /**
         * The score indicating the pronunciation accuracy of the given speech, which indicates
         * how closely the phonemes match a native speaker's pronunciation.
         * @member PronunciationAssessmentResult.prototype.accuracyScore
         * @function
         * @public
         * @returns {number} Accuracy score.
         */
        get: function() {
          return this.detailResult.PronunciationAssessment.AccuracyScore;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "pronunciationScore", {
        /**
         * The overall score indicating the pronunciation quality of the given speech.
         * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
         * @member PronunciationAssessmentResult.prototype.pronunciationScore
         * @function
         * @public
         * @returns {number} Pronunciation score.
         */
        get: function() {
          return this.detailResult.PronunciationAssessment.PronScore;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "completenessScore", {
        /**
         * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
         * @member PronunciationAssessmentResult.prototype.completenessScore
         * @function
         * @public
         * @returns {number} Completeness score.
         */
        get: function() {
          return this.detailResult.PronunciationAssessment.CompletenessScore;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "fluencyScore", {
        /**
         * The score indicating the fluency of the given speech.
         * @member PronunciationAssessmentResult.prototype.fluencyScore
         * @function
         * @public
         * @returns {number} Fluency score.
         */
        get: function() {
          return this.detailResult.PronunciationAssessment.FluencyScore;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return Om.PronunciationAssessmentResult = r, Om;
}
var foe;
function Wt() {
  return foe || (foe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t = ngr();
    Object.defineProperty(e, "AudioConfig", { enumerable: !0, get: function() {
      return t.AudioConfig;
    } });
    var r = Td();
    Object.defineProperty(e, "AudioStreamFormat", { enumerable: !0, get: function() {
      return r.AudioStreamFormat;
    } });
    var n = i4e();
    Object.defineProperty(e, "AudioInputStream", { enumerable: !0, get: function() {
      return n.AudioInputStream;
    } }), Object.defineProperty(e, "PullAudioInputStream", { enumerable: !0, get: function() {
      return n.PullAudioInputStream;
    } }), Object.defineProperty(e, "PushAudioInputStream", { enumerable: !0, get: function() {
      return n.PushAudioInputStream;
    } });
    var i = Qh();
    Object.defineProperty(e, "AudioOutputStream", { enumerable: !0, get: function() {
      return i.AudioOutputStream;
    } }), Object.defineProperty(e, "PullAudioOutputStream", { enumerable: !0, get: function() {
      return i.PullAudioOutputStream;
    } }), Object.defineProperty(e, "PushAudioOutputStream", { enumerable: !0, get: function() {
      return i.PushAudioOutputStream;
    } });
    var o = igr();
    Object.defineProperty(e, "CancellationReason", { enumerable: !0, get: function() {
      return o.CancellationReason;
    } });
    var a = ogr();
    Object.defineProperty(e, "PullAudioInputStreamCallback", { enumerable: !0, get: function() {
      return a.PullAudioInputStreamCallback;
    } });
    var u = agr();
    Object.defineProperty(e, "PushAudioOutputStreamCallback", { enumerable: !0, get: function() {
      return u.PushAudioOutputStreamCallback;
    } });
    var s = ugr();
    Object.defineProperty(e, "KeywordRecognitionModel", { enumerable: !0, get: function() {
      return s.KeywordRecognitionModel;
    } });
    var c = sgr();
    Object.defineProperty(e, "SessionEventArgs", { enumerable: !0, get: function() {
      return c.SessionEventArgs;
    } });
    var l = cgr();
    Object.defineProperty(e, "RecognitionEventArgs", { enumerable: !0, get: function() {
      return l.RecognitionEventArgs;
    } });
    var f = lgr();
    Object.defineProperty(e, "OutputFormat", { enumerable: !0, get: function() {
      return f.OutputFormat;
    } });
    var d = fgr();
    Object.defineProperty(e, "IntentRecognitionEventArgs", { enumerable: !0, get: function() {
      return d.IntentRecognitionEventArgs;
    } });
    var p = dgr();
    Object.defineProperty(e, "RecognitionResult", { enumerable: !0, get: function() {
      return p.RecognitionResult;
    } });
    var v = pgr();
    Object.defineProperty(e, "SpeechRecognitionResult", { enumerable: !0, get: function() {
      return v.SpeechRecognitionResult;
    } });
    var h = hgr();
    Object.defineProperty(e, "IntentRecognitionResult", { enumerable: !0, get: function() {
      return h.IntentRecognitionResult;
    } });
    var E = vgr();
    Object.defineProperty(e, "LanguageUnderstandingModel", { enumerable: !0, get: function() {
      return E.LanguageUnderstandingModel;
    } });
    var m = Egr();
    Object.defineProperty(e, "SpeechRecognitionEventArgs", { enumerable: !0, get: function() {
      return m.SpeechRecognitionEventArgs;
    } }), Object.defineProperty(e, "ConversationTranscriptionEventArgs", { enumerable: !0, get: function() {
      return m.ConversationTranscriptionEventArgs;
    } });
    var g = mgr();
    Object.defineProperty(e, "SpeechRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return g.SpeechRecognitionCanceledEventArgs;
    } });
    var y = ggr();
    Object.defineProperty(e, "TranslationRecognitionEventArgs", { enumerable: !0, get: function() {
      return y.TranslationRecognitionEventArgs;
    } });
    var _ = Tgr();
    Object.defineProperty(e, "TranslationSynthesisEventArgs", { enumerable: !0, get: function() {
      return _.TranslationSynthesisEventArgs;
    } });
    var S = a4e();
    Object.defineProperty(e, "TranslationRecognitionResult", { enumerable: !0, get: function() {
      return S.TranslationRecognitionResult;
    } });
    var A = ygr();
    Object.defineProperty(e, "TranslationSynthesisResult", { enumerable: !0, get: function() {
      return A.TranslationSynthesisResult;
    } });
    var O = _gr();
    Object.defineProperty(e, "ResultReason", { enumerable: !0, get: function() {
      return O.ResultReason;
    } });
    var P = Agr();
    Object.defineProperty(e, "SpeechConfig", { enumerable: !0, get: function() {
      return P.SpeechConfig;
    } }), Object.defineProperty(e, "SpeechConfigImpl", { enumerable: !0, get: function() {
      return P.SpeechConfigImpl;
    } });
    var U = Sgr();
    Object.defineProperty(e, "SpeechTranslationConfig", { enumerable: !0, get: function() {
      return U.SpeechTranslationConfig;
    } }), Object.defineProperty(e, "SpeechTranslationConfigImpl", { enumerable: !0, get: function() {
      return U.SpeechTranslationConfigImpl;
    } });
    var z = u4e();
    Object.defineProperty(e, "PropertyCollection", { enumerable: !0, get: function() {
      return z.PropertyCollection;
    } });
    var k = kH();
    Object.defineProperty(e, "PropertyId", { enumerable: !0, get: function() {
      return k.PropertyId;
    } });
    var H = bgr();
    Object.defineProperty(e, "Recognizer", { enumerable: !0, get: function() {
      return H.Recognizer;
    } });
    var B = Cgr();
    Object.defineProperty(e, "SpeechRecognizer", { enumerable: !0, get: function() {
      return B.SpeechRecognizer;
    } });
    var x = Igr();
    Object.defineProperty(e, "IntentRecognizer", { enumerable: !0, get: function() {
      return x.IntentRecognizer;
    } });
    var D = Ogr();
    Object.defineProperty(e, "VoiceProfileType", { enumerable: !0, get: function() {
      return D.VoiceProfileType;
    } });
    var w = Rgr();
    Object.defineProperty(e, "TranslationRecognizer", { enumerable: !0, get: function() {
      return w.TranslationRecognizer;
    } });
    var $ = wgr();
    Object.defineProperty(e, "Translations", { enumerable: !0, get: function() {
      return $.Translations;
    } });
    var X = Pgr();
    Object.defineProperty(e, "NoMatchReason", { enumerable: !0, get: function() {
      return X.NoMatchReason;
    } });
    var V = Dgr();
    Object.defineProperty(e, "NoMatchDetails", { enumerable: !0, get: function() {
      return V.NoMatchDetails;
    } });
    var F = xgr();
    Object.defineProperty(e, "TranslationRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return F.TranslationRecognitionCanceledEventArgs;
    } });
    var le = Ngr();
    Object.defineProperty(e, "IntentRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return le.IntentRecognitionCanceledEventArgs;
    } });
    var ae = s4e();
    Object.defineProperty(e, "CancellationDetailsBase", { enumerable: !0, get: function() {
      return ae.CancellationDetailsBase;
    } });
    var ne = Lgr();
    Object.defineProperty(e, "CancellationDetails", { enumerable: !0, get: function() {
      return ne.CancellationDetails;
    } });
    var ve = Bgr();
    Object.defineProperty(e, "CancellationErrorCode", { enumerable: !0, get: function() {
      return ve.CancellationErrorCode;
    } });
    var Ie = kgr();
    Object.defineProperty(e, "ConnectionEventArgs", { enumerable: !0, get: function() {
      return Ie.ConnectionEventArgs;
    } });
    var Oe = Mgr();
    Object.defineProperty(e, "ServiceEventArgs", { enumerable: !0, get: function() {
      return Oe.ServiceEventArgs;
    } });
    var xe = Fgr();
    Object.defineProperty(e, "Connection", { enumerable: !0, get: function() {
      return xe.Connection;
    } });
    var ze = Hgr();
    Object.defineProperty(e, "PhraseListGrammar", { enumerable: !0, get: function() {
      return ze.PhraseListGrammar;
    } });
    var qe = MH();
    Object.defineProperty(e, "DialogServiceConfig", { enumerable: !0, get: function() {
      return qe.DialogServiceConfig;
    } });
    var Je = $gr();
    Object.defineProperty(e, "BotFrameworkConfig", { enumerable: !0, get: function() {
      return Je.BotFrameworkConfig;
    } });
    var Be = Ugr();
    Object.defineProperty(e, "CustomCommandsConfig", { enumerable: !0, get: function() {
      return Be.CustomCommandsConfig;
    } });
    var We = jgr();
    Object.defineProperty(e, "DialogServiceConnector", { enumerable: !0, get: function() {
      return We.DialogServiceConnector;
    } });
    var Ne = zgr();
    Object.defineProperty(e, "ActivityReceivedEventArgs", { enumerable: !0, get: function() {
      return Ne.ActivityReceivedEventArgs;
    } });
    var je = Ygr();
    Object.defineProperty(e, "TurnStatusReceivedEventArgs", { enumerable: !0, get: function() {
      return je.TurnStatusReceivedEventArgs;
    } });
    var et = Ggr();
    Object.defineProperty(e, "ServicePropertyChannel", { enumerable: !0, get: function() {
      return et.ServicePropertyChannel;
    } });
    var St = Wgr();
    Object.defineProperty(e, "ProfanityOption", { enumerable: !0, get: function() {
      return St.ProfanityOption;
    } });
    var Ot = Kgr();
    Object.defineProperty(e, "BaseAudioPlayer", { enumerable: !0, get: function() {
      return Ot.BaseAudioPlayer;
    } });
    var we = Xgr();
    Object.defineProperty(e, "ConnectionMessageEventArgs", { enumerable: !0, get: function() {
      return we.ConnectionMessageEventArgs;
    } });
    var De = c4e();
    Object.defineProperty(e, "ConnectionMessage", { enumerable: !0, get: function() {
      return De.ConnectionMessage;
    } });
    var Ee = Jgr();
    Object.defineProperty(e, "VoiceProfile", { enumerable: !0, get: function() {
      return Ee.VoiceProfile;
    } });
    var te = Zgr();
    Object.defineProperty(e, "VoiceProfileEnrollmentResult", { enumerable: !0, get: function() {
      return te.VoiceProfileEnrollmentResult;
    } }), Object.defineProperty(e, "VoiceProfileEnrollmentCancellationDetails", { enumerable: !0, get: function() {
      return te.VoiceProfileEnrollmentCancellationDetails;
    } });
    var ue = Qgr();
    Object.defineProperty(e, "VoiceProfileResult", { enumerable: !0, get: function() {
      return ue.VoiceProfileResult;
    } }), Object.defineProperty(e, "VoiceProfileCancellationDetails", { enumerable: !0, get: function() {
      return ue.VoiceProfileCancellationDetails;
    } });
    var ye = e1r();
    Object.defineProperty(e, "VoiceProfileAuthorizationPhraseResult", { enumerable: !0, get: function() {
      return ye.VoiceProfileAuthorizationPhraseResult;
    } });
    var Le = t1r();
    Object.defineProperty(e, "VoiceProfileClient", { enumerable: !0, get: function() {
      return Le.VoiceProfileClient;
    } });
    var Me = r1r();
    Object.defineProperty(e, "SpeakerRecognizer", { enumerable: !0, get: function() {
      return Me.SpeakerRecognizer;
    } });
    var Ae = n1r();
    Object.defineProperty(e, "SpeakerIdentificationModel", { enumerable: !0, get: function() {
      return Ae.SpeakerIdentificationModel;
    } });
    var ie = i1r();
    Object.defineProperty(e, "SpeakerVerificationModel", { enumerable: !0, get: function() {
      return ie.SpeakerVerificationModel;
    } });
    var K = o1r();
    Object.defineProperty(e, "AutoDetectSourceLanguageConfig", { enumerable: !0, get: function() {
      return K.AutoDetectSourceLanguageConfig;
    } });
    var Z = a1r();
    Object.defineProperty(e, "AutoDetectSourceLanguageResult", { enumerable: !0, get: function() {
      return Z.AutoDetectSourceLanguageResult;
    } });
    var Ce = u1r();
    Object.defineProperty(e, "SourceLanguageConfig", { enumerable: !0, get: function() {
      return Ce.SourceLanguageConfig;
    } });
    var be = s1r();
    Object.defineProperty(e, "SpeakerRecognitionResult", { enumerable: !0, get: function() {
      return be.SpeakerRecognitionResult;
    } }), Object.defineProperty(e, "SpeakerRecognitionResultType", { enumerable: !0, get: function() {
      return be.SpeakerRecognitionResultType;
    } }), Object.defineProperty(e, "SpeakerRecognitionCancellationDetails", { enumerable: !0, get: function() {
      return be.SpeakerRecognitionCancellationDetails;
    } });
    var Ge = f4e();
    Object.defineProperty(e, "Conversation", { enumerable: !0, get: function() {
      return Ge.Conversation;
    } }), Object.defineProperty(e, "ConversationExpirationEventArgs", { enumerable: !0, get: function() {
      return Ge.ConversationExpirationEventArgs;
    } }), Object.defineProperty(e, "ConversationParticipantsChangedEventArgs", { enumerable: !0, get: function() {
      return Ge.ConversationParticipantsChangedEventArgs;
    } }), Object.defineProperty(e, "ConversationTranslationCanceledEventArgs", { enumerable: !0, get: function() {
      return Ge.ConversationTranslationCanceledEventArgs;
    } }), Object.defineProperty(e, "ConversationTranslationEventArgs", { enumerable: !0, get: function() {
      return Ge.ConversationTranslationEventArgs;
    } }), Object.defineProperty(e, "ConversationTranslationResult", { enumerable: !0, get: function() {
      return Ge.ConversationTranslationResult;
    } }), Object.defineProperty(e, "ConversationTranslator", { enumerable: !0, get: function() {
      return Ge.ConversationTranslator;
    } }), Object.defineProperty(e, "ConversationTranscriber", { enumerable: !0, get: function() {
      return Ge.ConversationTranscriber;
    } }), Object.defineProperty(e, "Participant", { enumerable: !0, get: function() {
      return Ge.Participant;
    } }), Object.defineProperty(e, "ParticipantChangedReason", { enumerable: !0, get: function() {
      return Ge.ParticipantChangedReason;
    } }), Object.defineProperty(e, "User", { enumerable: !0, get: function() {
      return Ge.User;
    } });
    var st = o4e();
    Object.defineProperty(e, "SpeechSynthesisOutputFormat", { enumerable: !0, get: function() {
      return st.SpeechSynthesisOutputFormat;
    } });
    var wt = T1r();
    Object.defineProperty(e, "SpeechSynthesizer", { enumerable: !0, get: function() {
      return wt.SpeechSynthesizer;
    } });
    var Bt = y1r();
    Object.defineProperty(e, "SpeechSynthesisResult", { enumerable: !0, get: function() {
      return Bt.SpeechSynthesisResult;
    } });
    var jt = _1r();
    Object.defineProperty(e, "SpeechSynthesisEventArgs", { enumerable: !0, get: function() {
      return jt.SpeechSynthesisEventArgs;
    } });
    var Xt = A1r();
    Object.defineProperty(e, "SpeechSynthesisWordBoundaryEventArgs", { enumerable: !0, get: function() {
      return Xt.SpeechSynthesisWordBoundaryEventArgs;
    } });
    var Qt = S1r();
    Object.defineProperty(e, "SpeechSynthesisBookmarkEventArgs", { enumerable: !0, get: function() {
      return Qt.SpeechSynthesisBookmarkEventArgs;
    } });
    var Zr = b1r();
    Object.defineProperty(e, "SpeechSynthesisVisemeEventArgs", { enumerable: !0, get: function() {
      return Zr.SpeechSynthesisVisemeEventArgs;
    } });
    var Jn = C1r();
    Object.defineProperty(e, "SpeakerAudioDestination", { enumerable: !0, get: function() {
      return Jn.SpeakerAudioDestination;
    } });
    var Ur = I1r();
    Object.defineProperty(e, "ConversationTranscriptionCanceledEventArgs", { enumerable: !0, get: function() {
      return Ur.ConversationTranscriptionCanceledEventArgs;
    } });
    var fn = O1r();
    Object.defineProperty(e, "PronunciationAssessmentGradingSystem", { enumerable: !0, get: function() {
      return fn.PronunciationAssessmentGradingSystem;
    } });
    var gn = R1r();
    Object.defineProperty(e, "PronunciationAssessmentGranularity", { enumerable: !0, get: function() {
      return gn.PronunciationAssessmentGranularity;
    } });
    var cr = w1r();
    Object.defineProperty(e, "PronunciationAssessmentConfig", { enumerable: !0, get: function() {
      return cr.PronunciationAssessmentConfig;
    } });
    var Ri = P1r();
    Object.defineProperty(e, "PronunciationAssessmentResult", { enumerable: !0, get: function() {
      return Ri.PronunciationAssessmentResult;
    } });
  }(PN)), PN;
}
var doe;
function D1r() {
  if (doe) return dE;
  doe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var u = function(s, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, f) {
        l.__proto__ = f;
      } || function(l, f) {
        for (var d in f) f.hasOwnProperty(d) && (l[d] = f[d]);
      }, u(s, c);
    };
    return function(s, c) {
      u(s, c);
      function l() {
        this.constructor = s;
      }
      s.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }();
  Object.defineProperty(dE, "__esModule", { value: !0 }), dE.IntentConnectionFactory = void 0;
  var t = Yu(), r = Wt(), n = tv(), i = gr(), o = vc(), a = (
    /** @class */
    function(u) {
      e(s, u);
      function s() {
        var c = u !== null && u.apply(this, arguments) || this;
        return c.create = function(l, f, d) {
          var p = l.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Endpoint);
          if (!p) {
            var v = l.parameters.getProperty(r.PropertyId.SpeechServiceConnection_IntentRegion), h = v && v.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", E = l.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Host, "wss://" + v + ".sr.speech" + h);
            p = E + "/speech/recognition/interactive/cognitiveservices/v1";
          }
          var m = {
            format: "simple",
            language: l.parameters.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage)
          };
          c.setCommonUrlParams(l, m, p);
          var g = {};
          f.token !== void 0 && f.token !== "" && (g[f.headerName] = f.token), g[o.HeaderNames.ConnectionId] = d, l.parameters.setProperty(r.PropertyId.SpeechServiceConnection_Url, p);
          var y = l.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new t.WebsocketConnection(p, m, g, new i.WebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(l), y, d);
        }, c;
      }
      return s.prototype.getSpeechRegionFromIntentRegion = function(c) {
        switch (c) {
          case "West US":
          case "US West":
          case "westus":
            return "uswest";
          case "West US 2":
          case "US West 2":
          case "westus2":
            return "uswest2";
          case "South Central US":
          case "US South Central":
          case "southcentralus":
            return "ussouthcentral";
          case "West Central US":
          case "US West Central":
          case "westcentralus":
            return "uswestcentral";
          case "East US":
          case "US East":
          case "eastus":
            return "useast";
          case "East US 2":
          case "US East 2":
          case "eastus2":
            return "useast2";
          case "West Europe":
          case "Europe West":
          case "westeurope":
            return "europewest";
          case "North Europe":
          case "Europe North":
          case "northeurope":
            return "europenorth";
          case "Brazil South":
          case "South Brazil":
          case "southbrazil":
            return "brazilsouth";
          case "Australia East":
          case "East Australia":
          case "eastaustralia":
            return "australiaeast";
          case "Southeast Asia":
          case "Asia Southeast":
          case "southeastasia":
            return "asiasoutheast";
          case "East Asia":
          case "Asia East":
          case "eastasia":
            return "asiaeast";
          default:
            return c;
        }
      }, s;
    }(n.ConnectionFactoryBase)
  );
  return dE.IntentConnectionFactory = a, dE;
}
var WN = {}, poe;
function FH() {
  return poe || (poe = 1, function(e) {
    var t = fe && fe.__extends || /* @__PURE__ */ function() {
      var l = function(f, d) {
        return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, v) {
          p.__proto__ = v;
        } || function(p, v) {
          for (var h in v) v.hasOwnProperty(h) && (p[h] = v[h]);
        }, l(f, d);
      };
      return function(f, d) {
        l(f, d);
        function p() {
          this.constructor = f;
        }
        f.prototype = d === null ? Object.create(d) : (p.prototype = d.prototype, new p());
      };
    }();
    Object.defineProperty(e, "__esModule", { value: !0 }), e.RecognitionEndedEvent = e.RecognitionCompletionStatus = e.RecognitionStartedEvent = e.ConnectingToServiceEvent = e.ListeningStartedEvent = e.RecognitionTriggeredEvent = e.SpeechRecognitionEvent = void 0;
    var r = Ar(), n = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v, h) {
          h === void 0 && (h = r.EventType.Info);
          var E = l.call(this, d, h) || this;
          return E.privRequestId = p, E.privSessionId = v, E;
        }
        return Object.defineProperty(f.prototype, "requestId", {
          get: function() {
            return this.privRequestId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "sessionId", {
          get: function() {
            return this.privSessionId;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(r.PlatformEvent)
    );
    e.SpeechRecognitionEvent = n;
    var i = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v, h) {
          var E = l.call(this, "RecognitionTriggeredEvent", d, p) || this;
          return E.privAudioSourceId = v, E.privAudioNodeId = h, E;
        }
        return Object.defineProperty(f.prototype, "audioSourceId", {
          get: function() {
            return this.privAudioSourceId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "audioNodeId", {
          get: function() {
            return this.privAudioNodeId;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(n)
    );
    e.RecognitionTriggeredEvent = i;
    var o = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v, h) {
          var E = l.call(this, "ListeningStartedEvent", d, p) || this;
          return E.privAudioSourceId = v, E.privAudioNodeId = h, E;
        }
        return Object.defineProperty(f.prototype, "audioSourceId", {
          get: function() {
            return this.privAudioSourceId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "audioNodeId", {
          get: function() {
            return this.privAudioNodeId;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(n)
    );
    e.ListeningStartedEvent = o;
    var a = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v) {
          var h = l.call(this, "ConnectingToServiceEvent", d, v) || this;
          return h.privAuthFetchEventid = p, h;
        }
        return Object.defineProperty(f.prototype, "authFetchEventid", {
          get: function() {
            return this.privAuthFetchEventid;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(n)
    );
    e.ConnectingToServiceEvent = a;
    var u = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v, h, E) {
          var m = l.call(this, "RecognitionStartedEvent", d, E) || this;
          return m.privAudioSourceId = p, m.privAudioNodeId = v, m.privAuthFetchEventId = h, m;
        }
        return Object.defineProperty(f.prototype, "audioSourceId", {
          get: function() {
            return this.privAudioSourceId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "audioNodeId", {
          get: function() {
            return this.privAudioNodeId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "authFetchEventId", {
          get: function() {
            return this.privAuthFetchEventId;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(n)
    );
    e.RecognitionStartedEvent = u;
    var s;
    (function(l) {
      l[l.Success = 0] = "Success", l[l.AudioSourceError = 1] = "AudioSourceError", l[l.AudioSourceTimeout = 2] = "AudioSourceTimeout", l[l.AuthTokenFetchError = 3] = "AuthTokenFetchError", l[l.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", l[l.UnAuthorized = 5] = "UnAuthorized", l[l.ConnectTimeout = 6] = "ConnectTimeout", l[l.ConnectError = 7] = "ConnectError", l[l.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", l[l.UnknownError = 9] = "UnknownError";
    })(s = e.RecognitionCompletionStatus || (e.RecognitionCompletionStatus = {}));
    var c = (
      /** @class */
      function(l) {
        t(f, l);
        function f(d, p, v, h, E, m, g, y) {
          var _ = l.call(this, "RecognitionEndedEvent", d, E, g === s.Success ? r.EventType.Info : r.EventType.Error) || this;
          return _.privAudioSourceId = p, _.privAudioNodeId = v, _.privAuthFetchEventId = h, _.privStatus = g, _.privError = y, _.privServiceTag = m, _;
        }
        return Object.defineProperty(f.prototype, "audioSourceId", {
          get: function() {
            return this.privAudioSourceId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "audioNodeId", {
          get: function() {
            return this.privAudioNodeId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "authFetchEventId", {
          get: function() {
            return this.privAuthFetchEventId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "serviceTag", {
          get: function() {
            return this.privServiceTag;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "status", {
          get: function() {
            return this.privStatus;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(f.prototype, "error", {
          get: function() {
            return this.privError;
          },
          enumerable: !1,
          configurable: !0
        }), f;
      }(n)
    );
    e.RecognitionEndedEvent = c;
  }(WN)), WN;
}
var Rm = {}, wm = {}, hoe;
function e2() {
  if (hoe) return wm;
  hoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, s) {
        u.__proto__ = s;
      } || function(u, s) {
        for (var c in s) s.hasOwnProperty(c) && (u[c] = s[c]);
      }, i(o, a);
    };
    return function(o, a) {
      i(o, a);
      function u() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
    };
  }();
  Object.defineProperty(wm, "__esModule", { value: !0 }), wm.SpeechConnectionMessage = void 0;
  var t = Ar(), r = vc(), n = (
    /** @class */
    function(i) {
      e(o, i);
      function o(a, u, s, c, l, f, d, p) {
        var v = this;
        if (!u)
          throw new t.ArgumentNullError("path");
        if (!s)
          throw new t.ArgumentNullError("requestId");
        var h = {};
        if (h[r.HeaderNames.Path] = u, h[r.HeaderNames.RequestId] = s, h[r.HeaderNames.RequestTimestamp] = (/* @__PURE__ */ new Date()).toISOString(), c && (h[r.HeaderNames.ContentType] = c), f && (h[r.HeaderNames.RequestStreamId] = f), d)
          for (var E in d)
            E && (h[E] = d[E]);
        return p ? v = i.call(this, a, l, h, p) || this : v = i.call(this, a, l, h) || this, v.privPath = u, v.privRequestId = s, v.privContentType = c, v.privStreamId = f, v.privAdditionalHeaders = d, v;
      }
      return Object.defineProperty(o.prototype, "path", {
        get: function() {
          return this.privPath;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "requestId", {
        get: function() {
          return this.privRequestId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "contentType", {
        get: function() {
          return this.privContentType;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "streamId", {
        get: function() {
          return this.privStreamId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "additionalHeaders", {
        get: function() {
          return this.privAdditionalHeaders;
        },
        enumerable: !1,
        configurable: !0
      }), o.fromConnectionMessage = function(a) {
        var u = null, s = null, c = null, l = null, f = {};
        if (a.headers)
          for (var d in a.headers)
            d && (d.toLowerCase() === r.HeaderNames.Path.toLowerCase() ? u = a.headers[d] : d.toLowerCase() === r.HeaderNames.RequestId.toLowerCase() ? s = a.headers[d] : d.toLowerCase() === r.HeaderNames.RequestTimestamp.toLowerCase() ? a.headers[d] : d.toLowerCase() === r.HeaderNames.ContentType.toLowerCase() ? c = a.headers[d] : d.toLowerCase() === r.HeaderNames.RequestStreamId.toLowerCase() ? l = a.headers[d] : f[d] = a.headers[d]);
        return new o(a.messageType, u, s, c, a.body, l, f, a.id);
      }, o;
    }(t.ConnectionMessage)
  );
  return wm.SpeechConnectionMessage = n, wm;
}
var voe;
function x1r() {
  if (voe) return Rm;
  voe = 1;
  var e = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, t = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Rm, "__esModule", { value: !0 }), Rm.ServiceRecognizerBase = void 0;
  var r = Yu(), n = Ar(), i = Wt(), o = gr(), a = e2(), u = (
    /** @class */
    function() {
      function s(c, l, f, d, p) {
        var v = this;
        if (this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.recognizeOverride = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendSpeechContext = function(h) {
          var E = v.speechContext.toJSON();
          if (E)
            return h.send(new a.SpeechConnectionMessage(n.MessageType.Text, "speech.context", v.privRequestSession.requestId, "application/json", E));
        }, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSpeechServiceConfig = function(h, E, m) {
          if (s.telemetryDataEnabled !== !0) {
            var g = JSON.parse(m), y = {
              context: {
                system: g.context.system
              }
            };
            m = JSON.stringify(y);
          }
          if (v.privRecognizerConfig.parameters.getProperty("TranscriptionService_SingleChannel", "false").toLowerCase() === "true") {
            var _ = JSON.parse(m);
            _.context.DisableReferenceChannel = "True", _.context.MicSpec = "1_0_0", m = JSON.stringify(_);
          }
          if (m)
            return h.send(new a.SpeechConnectionMessage(n.MessageType.Text, "speech.config", E.requestId, "application/json", m));
        }, !c)
          throw new n.ArgumentNullError("authentication");
        if (!l)
          throw new n.ArgumentNullError("connectionFactory");
        if (!f)
          throw new n.ArgumentNullError("audioSource");
        if (!d)
          throw new n.ArgumentNullError("recognizerConfig");
        this.privMustReportEndOfStream = !1, this.privAuthentication = c, this.privConnectionFactory = l, this.privAudioSource = f, this.privRecognizerConfig = d, this.privIsDisposed = !1, this.privRecognizer = p, this.privRequestSession = new o.RequestSession(this.privAudioSource.id()), this.privConnectionEvents = new n.EventSource(), this.privServiceEvents = new n.EventSource(), this.privDynamicGrammar = new o.DynamicGrammarBuilder(), this.privSpeechContext = new o.SpeechContext(this.privDynamicGrammar), this.privAgentConfig = new o.AgentConfig(), typeof Blob < "u" && typeof Worker < "u" && (this.privSetTimeout = n.Timeout.setTimeout), this.connectionEvents.attach(function(h) {
          return e(v, void 0, void 0, function() {
            var E;
            return t(this, function(m) {
              switch (m.label) {
                case 0:
                  return h.name !== "ConnectionClosedEvent" ? [3, 2] : (E = h, E.statusCode === 1003 || E.statusCode === 1007 || E.statusCode === 1002 || E.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount ? [4, this.cancelRecognitionLocal(i.CancellationReason.Error, E.statusCode === 1007 ? i.CancellationErrorCode.BadRequestParameters : i.CancellationErrorCode.ConnectionFailure, E.reason + " websocket error code: " + E.statusCode)] : [3, 2]);
                case 1:
                  m.sent(), m.label = 2;
                case 2:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      }
      return Object.defineProperty(s.prototype, "audioSource", {
        get: function() {
          return this.privAudioSource;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "speechContext", {
        get: function() {
          return this.privSpeechContext;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "dynamicGrammar", {
        get: function() {
          return this.privDynamicGrammar;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "agentConfig", {
        get: function() {
          return this.privAgentConfig;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "conversationTranslatorToken", {
        set: function(c) {
          this.privRecognizerConfig.parameters.setProperty(i.PropertyId.ConversationTranslator_Token, c);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "authentication", {
        set: function(c) {
          this.privAuthentication = this.authentication;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.isDisposed = function() {
        return this.privIsDisposed;
      }, s.prototype.dispose = function(c) {
        return e(this, void 0, void 0, function() {
          var l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                if (this.privIsDisposed = !0, !this.privConnectionConfigurationPromise) return [3, 5];
                f.label = 1;
              case 1:
                return f.trys.push([1, 4, , 5]), [4, this.privConnectionConfigurationPromise];
              case 2:
                return l = f.sent(), [4, l.dispose(c)];
              case 3:
                return f.sent(), [3, 5];
              case 4:
                return f.sent(), [
                  2
                  /*return*/
                ];
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(s.prototype, "connectionEvents", {
        get: function() {
          return this.privConnectionEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "serviceEvents", {
        get: function() {
          return this.privServiceEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "recognitionMode", {
        get: function() {
          return this.privRecognizerConfig.recognitionMode;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.recognize = function(c, l, f) {
        return e(this, void 0, void 0, function() {
          var d, p, v, h, E, m, g, y, _, S = this;
          return t(this, function(A) {
            switch (A.label) {
              case 0:
                if (this.recognizeOverride !== void 0)
                  return [2, this.recognizeOverride(c, l, f)];
                this.privConnectionConfigurationPromise = null, this.privRecognizerConfig.recognitionMode = c, this.privSuccessCallback = l, this.privErrorCallback = f, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events), d = this.connectImpl(), A.label = 1;
              case 1:
                return A.trys.push([1, 6, , 8]), [4, this.audioSource.attach(this.privRequestSession.audioNodeId)];
              case 2:
                return v = A.sent(), [4, this.audioSource.format];
              case 3:
                return h = A.sent(), [4, this.audioSource.deviceInfo];
              case 4:
                return E = A.sent(), this.privIsLiveAudio = E.type && E.type === o.type.Microphones, p = new r.ReplayableAudioNode(v, h.avgBytesPerSec), [4, this.privRequestSession.onAudioSourceAttachCompleted(p, !1)];
              case 5:
                return A.sent(), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: E }, [3, 8];
              case 6:
                return m = A.sent(), [4, this.privRequestSession.onStopRecognizing()];
              case 7:
                throw A.sent(), m;
              case 8:
                return A.trys.push([8, 10, , 12]), [4, d];
              case 9:
                return A.sent(), [3, 12];
              case 10:
                return g = A.sent(), [4, this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.ConnectionFailure, g)];
              case 11:
                return A.sent(), [
                  2
                  /*return*/
                ];
              case 12:
                return y = new i.SessionEventArgs(this.privRequestSession.sessionId), this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, y), this.receiveMessage(), _ = this.sendAudio(p), _.catch(function(O) {
                  return e(S, void 0, void 0, function() {
                    return t(this, function(P) {
                      switch (P.label) {
                        case 0:
                          return [4, this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.RuntimeError, O)];
                        case 1:
                          return P.sent(), [
                            2
                            /*return*/
                          ];
                      }
                    });
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.stopRecognizing = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                if (!this.privRequestSession.isRecognizing) return [3, 8];
                c.label = 1;
              case 1:
                return c.trys.push([1, , 6, 8]), [4, this.audioSource.turnOff()];
              case 2:
                return c.sent(), [4, this.sendFinalAudio()];
              case 3:
                return c.sent(), [4, this.privRequestSession.onStopRecognizing()];
              case 4:
                return c.sent(), [4, this.privRequestSession.turnCompletionPromise];
              case 5:
                return c.sent(), [3, 8];
              case 6:
                return [4, this.privRequestSession.dispose()];
              case 7:
                return c.sent(), [
                  7
                  /*endfinally*/
                ];
              case 8:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.connect = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, this.connectImpl()];
              case 1:
                return c.sent(), [2, Promise.resolve()];
            }
          });
        });
      }, s.prototype.connectAsync = function(c, l) {
        this.connectImpl().then(function(f) {
          try {
            c && c();
          } catch (d) {
            l && l(d);
          }
        }, function(f) {
          try {
            l && l(f);
          } catch {
          }
        });
      }, s.prototype.disconnect = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.NoError, "Disconnecting")];
              case 1:
                return c.sent(), this.disconnectOverride === void 0 ? [3, 3] : [4, this.disconnectOverride()];
              case 2:
                c.sent(), c.label = 3;
              case 3:
                return c.trys.push([3, 6, , 7]), [4, this.privConnectionPromise];
              case 4:
                return [4, c.sent().dispose()];
              case 5:
                return c.sent(), [3, 7];
              case 6:
                return c.sent(), [3, 7];
              case 7:
                return this.privConnectionPromise = null, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.sendMessage = function(c) {
      }, s.prototype.sendNetworkMessage = function(c, l) {
        return e(this, void 0, void 0, function() {
          var f, d, p;
          return t(this, function(v) {
            switch (v.label) {
              case 0:
                return f = typeof l == "string" ? n.MessageType.Text : n.MessageType.Binary, d = typeof l == "string" ? "application/json" : "", [4, this.fetchConnection()];
              case 1:
                return p = v.sent(), [2, p.send(new a.SpeechConnectionMessage(f, c, this.privRequestSession.requestId, d, l))];
            }
          });
        });
      }, Object.defineProperty(s.prototype, "activityTemplate", {
        get: function() {
          return this.privActivityTemplate;
        },
        set: function(c) {
          this.privActivityTemplate = c;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.sendTelemetryData = function() {
        return e(this, void 0, void 0, function() {
          var c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                if (c = this.privRequestSession.getTelemetry(), s.telemetryDataEnabled !== !0 || this.privIsDisposed || c === null)
                  return [
                    2
                    /*return*/
                  ];
                if (s.telemetryData)
                  try {
                    s.telemetryData(c);
                  } catch {
                  }
                return [4, this.fetchConnection()];
              case 1:
                return l = f.sent(), [4, l.send(new a.SpeechConnectionMessage(n.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", c))];
              case 2:
                return f.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.cancelRecognitionLocal = function(c, l, f) {
        return e(this, void 0, void 0, function() {
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                return this.privRequestSession.isRecognizing ? [4, this.privRequestSession.onStopRecognizing()] : [3, 2];
              case 1:
                d.sent(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, c, l, f), d.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.receiveMessage = function() {
        return e(this, void 0, void 0, function() {
          var c, l, f, d, p, v, h, E, m, g;
          return t(this, function(y) {
            switch (y.label) {
              case 0:
                return y.trys.push([0, 18, , 19]), this.privIsDisposed ? [
                  2
                  /*return*/
                ] : [4, this.fetchConnection()];
              case 1:
                return c = y.sent(), [4, c.read()];
              case 2:
                if (l = y.sent(), this.receiveMessageOverride !== void 0)
                  return [2, this.receiveMessageOverride()];
                if (!l)
                  return this.privRequestSession.isRecognizing ? [2, this.receiveMessage()] : [
                    2
                    /*return*/
                  ];
                if (this.privServiceHasSentMessage = !0, f = a.SpeechConnectionMessage.fromConnectionMessage(l), f.requestId.toLowerCase() !== this.privRequestSession.requestId.toLowerCase()) return [3, 17];
                switch (d = f.path.toLowerCase(), d) {
                  case "turn.start":
                    return [3, 3];
                  case "speech.startdetected":
                    return [3, 4];
                  case "speech.enddetected":
                    return [3, 5];
                  case "turn.end":
                    return [3, 6];
                }
                return [3, 15];
              case 3:
                return this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse(), [3, 17];
              case 4:
                return p = o.SpeechDetected.fromJSON(f.textBody), v = new i.RecognitionEventArgs(p.Offset, this.privRequestSession.sessionId), this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, v), [3, 17];
              case 5:
                return h = void 0, f.textBody.length > 0 ? h = f.textBody : h = "{ Offset: 0 }", E = o.SpeechDetected.fromJSON(h), this.privRecognizerConfig.isContinuousRecognition && this.privRequestSession.onServiceRecognized(E.Offset + this.privRequestSession.currentTurnAudioOffset), m = new i.RecognitionEventArgs(E.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, m), [3, 17];
              case 6:
                return [4, this.sendTelemetryData()];
              case 7:
                return y.sent(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream ? (this.privMustReportEndOfStream = !1, [4, this.cancelRecognitionLocal(i.CancellationReason.EndOfStream, i.CancellationErrorCode.NoError, void 0)]) : [3, 9];
              case 8:
                y.sent(), y.label = 9;
              case 9:
                return g = new i.SessionEventArgs(this.privRequestSession.sessionId), [4, this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition)];
              case 10:
                return y.sent(), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing ? (this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, g), [
                  2
                  /*return*/
                ]) : [3, 11];
              case 11:
                return [4, this.fetchConnection()];
              case 12:
                return c = y.sent(), [4, this.sendPrePayloadJSON(c)];
              case 13:
                y.sent(), y.label = 14;
              case 14:
                return [3, 17];
              case 15:
                return [4, this.processTypeSpecificMessages(f)];
              case 16:
                y.sent() || this.privServiceEvents && this.serviceEvents.onEvent(new n.ServiceEvent(f.path.toLowerCase(), f.textBody)), y.label = 17;
              case 17:
                return [2, this.receiveMessage()];
              case 18:
                return y.sent(), [2, null];
              case 19:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.sendPrePayloadJSON = function(c) {
        return e(this, void 0, void 0, function() {
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return this.sendPrePayloadJSONOverride !== void 0 ? [2, this.sendPrePayloadJSONOverride(c)] : [4, this.sendSpeechContext(c)];
              case 1:
                return l.sent(), [4, this.sendWaveHeader(c)];
              case 2:
                return l.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.sendWaveHeader = function(c) {
        return e(this, void 0, void 0, function() {
          var l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return [4, this.audioSource.format];
              case 1:
                return l = f.sent(), [2, c.send(new a.SpeechConnectionMessage(n.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", l.header))];
            }
          });
        });
      }, s.prototype.connectImpl = function() {
        var c = this;
        return this.privConnectionPromise ? this.privConnectionPromise.then(function(l) {
          return l.state() === n.ConnectionState.Disconnected ? (c.privConnectionId = null, c.privConnectionPromise = null, c.privServiceHasSentMessage = !1, c.connectImpl()) : c.privConnectionPromise;
        }, function(l) {
          return c.privConnectionId = null, c.privConnectionPromise = null, c.privServiceHasSentMessage = !1, c.connectImpl();
        }) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(function() {
        }), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
      }, s.prototype.fetchConnection = function() {
        return e(this, void 0, void 0, function() {
          var c = this;
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return this.privConnectionConfigurationPromise ? [2, this.privConnectionConfigurationPromise.then(function(f) {
                  return f.state() === n.ConnectionState.Disconnected ? (c.privConnectionId = null, c.privConnectionConfigurationPromise = null, c.privServiceHasSentMessage = !1, c.fetchConnection()) : c.privConnectionConfigurationPromise;
                }, function(f) {
                  return c.privConnectionId = null, c.privConnectionConfigurationPromise = null, c.privServiceHasSentMessage = !1, c.fetchConnection();
                })] : (this.privConnectionConfigurationPromise = this.configureConnection(), [4, this.privConnectionConfigurationPromise]);
              case 1:
                return [2, l.sent()];
            }
          });
        });
      }, s.prototype.sendAudio = function(c) {
        return e(this, void 0, void 0, function() {
          var l, f, d, p, v, h, E = this;
          return t(this, function(m) {
            switch (m.label) {
              case 0:
                return [4, this.audioSource.format];
              case 1:
                return l = m.sent(), f = Date.now(), d = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), p = l.avgBytesPerSec / 1e3 * parseInt(d, 10), v = this.privRequestSession.recogNumber, h = function() {
                  return e(E, void 0, void 0, function() {
                    var g, y, _, S, A = this;
                    return t(this, function(O) {
                      switch (O.label) {
                        case 0:
                          return !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === v ? [4, this.fetchConnection()] : [3, 5];
                        case 1:
                          return g = O.sent(), [4, c.read()];
                        case 2:
                          return y = O.sent(), this.privRequestSession.isSpeechEnded ? [
                            2
                            /*return*/
                          ] : (_ = void 0, S = void 0, !y || y.isEnd ? (_ = null, S = 0) : (_ = y.buffer, this.privRequestSession.onAudioSent(_.byteLength), p >= this.privRequestSession.bytesSent ? S = 0 : S = Math.max(0, f - Date.now())), S === 0 ? [3, 4] : [4, this.delay(S)]);
                        case 3:
                          O.sent(), O.label = 4;
                        case 4:
                          if (_ !== null && (f = Date.now() + _.byteLength * 1e3 / (l.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === v)
                            if (g.send(new a.SpeechConnectionMessage(n.MessageType.Binary, "audio", this.privRequestSession.requestId, null, _)).catch(function() {
                              A.privRequestSession.onServiceTurnEndResponse(A.privRecognizerConfig.isContinuousRecognition).catch(function() {
                              });
                            }), y != null && y.isEnd)
                              this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
                            else
                              return [2, h()];
                          O.label = 5;
                        case 5:
                          return [
                            2
                            /*return*/
                          ];
                      }
                    });
                  });
                }, [2, h()];
            }
          });
        });
      }, s.prototype.retryableConnect = function() {
        return e(this, void 0, void 0, function() {
          var c, l, f, d, p, v, h, E, m = this;
          return t(this, function(g) {
            switch (g.label) {
              case 0:
                c = !1, this.privAuthFetchEventId = n.createNoDashGuid(), l = this.privRequestSession.sessionId, this.privConnectionId = l !== void 0 ? l : n.createNoDashGuid(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId), f = 0, d = "", g.label = 1;
              case 1:
                return this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount ? (p = c ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId), [4, p]) : [3, 8];
              case 2:
                return v = g.sent(), [4, this.privRequestSession.onAuthCompleted(!1)];
              case 3:
                return g.sent(), h = this.privConnectionFactory.create(this.privRecognizerConfig, v, this.privConnectionId), this.privRequestSession.listenForServiceTelemetry(h.events), h.events.attach(function(y) {
                  m.connectionEvents.onEvent(y);
                }), [4, h.open()];
              case 4:
                return E = g.sent(), E.statusCode !== 200 ? [3, 6] : [4, this.privRequestSession.onConnectionEstablishCompleted(E.statusCode)];
              case 5:
                return g.sent(), [2, Promise.resolve(h)];
              case 6:
                E.statusCode === 1006 && (c = !0), g.label = 7;
              case 7:
                return f = E.statusCode, d = E.reason, this.privRequestSession.onRetryConnection(), [3, 1];
              case 8:
                return [4, this.privRequestSession.onConnectionEstablishCompleted(f, d)];
              case 9:
                return g.sent(), [2, Promise.reject("Unable to contact server. StatusCode: " + f + ", " + this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + d)];
            }
          });
        });
      }, s.prototype.delay = function(c) {
        var l = this;
        return new Promise(function(f, d) {
          l.privSetTimeout(f, c);
        });
      }, s.prototype.writeBufferToConsole = function(c) {
        var l = "Buffer Size: ";
        if (c === null)
          l += "null";
        else {
          var f = new Uint8Array(c);
          l += c.byteLength + `\r
`;
          for (var d = 0; d < c.byteLength; d++)
            l += f[d].toString(16).padStart(2, "0") + " ";
        }
        console.info(l);
      }, s.prototype.sendFinalAudio = function() {
        return e(this, void 0, void 0, function() {
          var c;
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, this.fetchConnection()];
              case 1:
                return c = l.sent(), [4, c.send(new a.SpeechConnectionMessage(n.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null))];
              case 2:
                return l.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.configureConnection = function() {
        return e(this, void 0, void 0, function() {
          var c;
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, this.connectImpl()];
              case 1:
                return c = l.sent(), this.configConnectionOverride !== void 0 ? [2, this.configConnectionOverride(c)] : [4, this.sendSpeechServiceConfig(c, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())];
              case 2:
                return l.sent(), [4, this.sendPrePayloadJSON(c)];
              case 3:
                return l.sent(), [2, c];
            }
          });
        });
      }, s.telemetryDataEnabled = !0, s;
    }()
  );
  return Rm.ServiceRecognizerBase = u, Rm;
}
var KN = {}, Eoe;
function N1r() {
  return Eoe || (Eoe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.type = e.connectivity = e.Device = e.OS = e.System = e.Context = e.SpeechServiceConfig = e.RecognizerConfig = e.SpeechResultFormat = e.RecognitionMode = void 0;
    var t = Wt(), r;
    (function(c) {
      c[c.Interactive = 0] = "Interactive", c[c.Conversation = 1] = "Conversation", c[c.Dictation = 2] = "Dictation";
    })(r = e.RecognitionMode || (e.RecognitionMode = {})), function(c) {
      c[c.Simple = 0] = "Simple", c[c.Detailed = 1] = "Detailed";
    }(e.SpeechResultFormat || (e.SpeechResultFormat = {}));
    var n = (
      /** @class */
      function() {
        function c(l, f) {
          this.privRecognitionMode = r.Interactive, this.privSpeechServiceConfig = l || new i(new o(null)), this.privParameters = f, this.privMaxRetryCount = parseInt(f.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        }
        return Object.defineProperty(c.prototype, "parameters", {
          get: function() {
            return this.privParameters;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "recognitionMode", {
          get: function() {
            return this.privRecognitionMode;
          },
          set: function(l) {
            this.privRecognitionMode = l, this.privRecognitionActivityTimeout = l === r.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = r[l];
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "SpeechServiceConfig", {
          get: function() {
            return this.privSpeechServiceConfig;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "recognitionActivityTimeout", {
          get: function() {
            return this.privRecognitionActivityTimeout;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "isContinuousRecognition", {
          get: function() {
            return this.privRecognitionMode !== r.Interactive;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "autoDetectSourceLanguages", {
          get: function() {
            return this.parameters.getProperty(t.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "maxRetryCount", {
          get: function() {
            return this.privMaxRetryCount;
          },
          enumerable: !1,
          configurable: !0
        }), c;
      }()
    );
    e.RecognizerConfig = n;
    var i = (
      /** @class */
      function() {
        function c(l) {
          var f = this;
          this.serialize = function() {
            return JSON.stringify(f, function(d, p) {
              if (p && typeof p == "object") {
                var v = {};
                for (var h in p)
                  Object.hasOwnProperty.call(p, h) && (v[h && h.charAt(0).toLowerCase() + h.substring(1)] = p[h]);
                return v;
              }
              return p;
            });
          }, this.context = l;
        }
        return Object.defineProperty(c.prototype, "Context", {
          get: function() {
            return this.context;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(c.prototype, "Recognition", {
          get: function() {
            return this.recognition;
          },
          set: function(l) {
            this.recognition = l.toLowerCase();
          },
          enumerable: !1,
          configurable: !0
        }), c;
      }()
    );
    e.SpeechServiceConfig = i;
    var o = (
      /** @class */
      /* @__PURE__ */ function() {
        function c(l) {
          this.system = new a(), this.os = l;
        }
        return c;
      }()
    );
    e.Context = o;
    var a = (
      /** @class */
      /* @__PURE__ */ function() {
        function c() {
          var l = "1.17.0";
          this.name = "SpeechSDK", this.version = l, this.build = "JavaScript", this.lang = "JavaScript";
        }
        return c;
      }()
    );
    e.System = a;
    var u = (
      /** @class */
      /* @__PURE__ */ function() {
        function c(l, f, d) {
          this.platform = l, this.name = f, this.version = d;
        }
        return c;
      }()
    );
    e.OS = u;
    var s = (
      /** @class */
      /* @__PURE__ */ function() {
        function c(l, f, d) {
          this.manufacturer = l, this.model = f, this.version = d;
        }
        return c;
      }()
    );
    e.Device = s, function(c) {
      c.Bluetooth = "Bluetooth", c.Wired = "Wired", c.WiFi = "WiFi", c.Cellular = "Cellular", c.InBuilt = "InBuilt", c.Unknown = "Unknown";
    }(e.connectivity || (e.connectivity = {})), function(c) {
      c.Phone = "Phone", c.Speaker = "Speaker", c.Car = "Car", c.Headset = "Headset", c.Thermostat = "Thermostat", c.Microphones = "Microphones", c.Deskphone = "Deskphone", c.RemoteControl = "RemoteControl", c.Unknown = "Unknown", c.File = "File", c.Stream = "Stream";
    }(e.type || (e.type = {}));
  }(KN)), KN;
}
var XN = {}, moe;
function L1r() {
  return moe || (moe = 1, Object.defineProperty(XN, "__esModule", { value: !0 })), XN;
}
var Pm = {}, goe;
function B1r() {
  if (goe) return Pm;
  goe = 1, Object.defineProperty(Pm, "__esModule", { value: !0 }), Pm.WebsocketMessageFormatter = void 0;
  var e = Ar(), t = `\r
`, r = (
    /** @class */
    /* @__PURE__ */ function() {
      function n() {
        var i = this;
        this.toConnectionMessage = function(o) {
          var a = new e.Deferred();
          try {
            if (o.messageType === e.MessageType.Text) {
              var u = o.textContent, s = {}, c = null;
              if (u) {
                var l = u.split(`\r
\r
`);
                l && l.length > 0 && (s = i.parseHeaders(l[0]), l.length > 1 && (c = l[1]));
              }
              a.resolve(new e.ConnectionMessage(o.messageType, c, s, o.id));
            } else if (o.messageType === e.MessageType.Binary) {
              var f = o.binaryContent, s = {}, c = null;
              if (!f || f.byteLength < 2)
                throw new Error("Invalid binary message format. Header length missing.");
              var d = new DataView(f), p = d.getInt16(0);
              if (f.byteLength < p + 2)
                throw new Error("Invalid binary message format. Header content missing.");
              for (var v = "", h = 0; h < p; h++)
                v += String.fromCharCode(d.getInt8(h + 2));
              s = i.parseHeaders(v), f.byteLength > p + 2 && (c = f.slice(2 + p)), a.resolve(new e.ConnectionMessage(o.messageType, c, s, o.id));
            }
          } catch (E) {
            a.reject("Error formatting the message. Error: " + E);
          }
          return a.promise;
        }, this.fromConnectionMessage = function(o) {
          var a = new e.Deferred();
          try {
            if (o.messageType === e.MessageType.Text) {
              var u = "" + i.makeHeaders(o) + t + (o.textBody ? o.textBody : "");
              a.resolve(new e.RawWebsocketMessage(e.MessageType.Text, u, o.id));
            } else if (o.messageType === e.MessageType.Binary) {
              var s = i.makeHeaders(o), c = o.binaryBody, l = i.stringToArrayBuffer(s), f = new Int8Array(l), d = f.byteLength, p = new Int8Array(2 + d + (c ? c.byteLength : 0));
              if (p[0] = d >> 8 & 255, p[1] = d & 255, p.set(f, 2), c) {
                var v = new Int8Array(c);
                p.set(v, 2 + d);
              }
              var u = p.buffer;
              a.resolve(new e.RawWebsocketMessage(e.MessageType.Binary, u, o.id));
            }
          } catch (h) {
            a.reject("Error formatting the message. " + h);
          }
          return a.promise;
        }, this.makeHeaders = function(o) {
          var a = "";
          if (o.headers)
            for (var u in o.headers)
              u && (a += u + ": " + o.headers[u] + t);
          return a;
        }, this.parseHeaders = function(o) {
          var a = {};
          if (o) {
            var u = o.match(/[^\r\n]+/g);
            if (a)
              for (var s = 0, c = u; s < c.length; s++) {
                var l = c[s];
                if (l) {
                  var f = l.indexOf(":"), d = f > 0 ? l.substr(0, f).trim().toLowerCase() : l, p = f > 0 && l.length > f + 1 ? l.substr(f + 1).trim() : "";
                  a[d] = p;
                }
              }
          }
          return a;
        }, this.stringToArrayBuffer = function(o) {
          for (var a = new ArrayBuffer(o.length), u = new DataView(a), s = 0; s < o.length; s++)
            u.setUint8(s, o.charCodeAt(s));
          return a;
        };
      }
      return n;
    }()
  );
  return Pm.WebsocketMessageFormatter = r, Pm;
}
var Dm = {}, Toe;
function k1r() {
  if (Toe) return Dm;
  Toe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var c = function(l, f) {
      return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, p) {
        d.__proto__ = p;
      } || function(d, p) {
        for (var v in p) p.hasOwnProperty(v) && (d[v] = p[v]);
      }, c(l, f);
    };
    return function(l, f) {
      c(l, f);
      function d() {
        this.constructor = l;
      }
      l.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
    };
  }();
  Object.defineProperty(Dm, "__esModule", { value: !0 }), Dm.SpeechConnectionFactory = void 0;
  var t = Yu(), r = gr(), n = Wt(), i = tv(), o = gr(), a = vc(), u = ev(), s = (
    /** @class */
    function(c) {
      e(l, c);
      function l() {
        var f = c !== null && c.apply(this, arguments) || this;
        return f.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1", f.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1", f.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1", f.create = function(d, p, v) {
          var h = d.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Endpoint, void 0), E = d.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Region, void 0), m = E && E.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", g = d.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Host, "wss://" + E + ".stt.speech" + m), y = {}, _ = d.parameters.getProperty(n.PropertyId.SpeechServiceConnection_EndpointId, void 0), S = d.parameters.getProperty(n.PropertyId.SpeechServiceConnection_RecoLanguage, void 0);
          if (_ ? (!h || h.search(u.QueryParameterNames.CustomSpeechDeploymentId) === -1) && (y[u.QueryParameterNames.CustomSpeechDeploymentId] = _) : S && (!h || h.search(u.QueryParameterNames.Language) === -1) && (y[u.QueryParameterNames.Language] = S), (!h || h.search(u.QueryParameterNames.Format) === -1) && (y[u.QueryParameterNames.Format] = d.parameters.getProperty(r.OutputFormatPropertyName, n.OutputFormat[n.OutputFormat.Simple]).toLowerCase()), d.autoDetectSourceLanguages !== void 0 && (y[u.QueryParameterNames.EnableLanguageId] = "true"), f.setCommonUrlParams(d, y, h), !h)
            switch (d.recognitionMode) {
              case o.RecognitionMode.Conversation:
                d.parameters.getProperty(r.ForceDictationPropertyName, "false") === "true" ? h = g + f.dictationRelativeUri : h = g + f.conversationRelativeUri;
                break;
              case o.RecognitionMode.Dictation:
                h = g + f.dictationRelativeUri;
                break;
              default:
                h = g + f.interactiveRelativeUri;
                break;
            }
          var A = {};
          p.token !== void 0 && p.token !== "" && (A[p.headerName] = p.token), A[a.HeaderNames.ConnectionId] = v, d.parameters.setProperty(n.PropertyId.SpeechServiceConnection_Url, h);
          var O = d.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new t.WebsocketConnection(h, y, A, new o.WebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(d), O, v);
        }, f;
      }
      return l;
    }(i.ConnectionFactoryBase)
  );
  return Dm.SpeechConnectionFactory = s, Dm;
}
var xm = {}, yoe;
function M1r() {
  if (yoe) return xm;
  yoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }();
  Object.defineProperty(xm, "__esModule", { value: !0 }), xm.TranscriberConnectionFactory = void 0;
  var t = Yu(), r = Wt(), n = tv(), i = gr(), o = vc(), a = ev(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c() {
        var l = s !== null && s.apply(this, arguments) || this;
        return l.multiaudioRelativeUri = "/speech/recognition/multiaudio", l.create = function(f, d, p) {
          var v = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Endpoint, void 0), h = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Region, "centralus"), E = h && h.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", m = "wss://transcribe." + h + ".cts.speech" + E + l.multiaudioRelativeUri, g = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Host, m), y = {}, _ = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_EndpointId, void 0), S = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage, void 0);
          _ ? (!v || v.search(a.QueryParameterNames.CustomSpeechDeploymentId) === -1) && (y[a.QueryParameterNames.CustomSpeechDeploymentId] = _) : S && (!v || v.search(a.QueryParameterNames.Language) === -1) && (y[a.QueryParameterNames.Language] = S), l.setCommonUrlParams(f, y, v), v || (v = g);
          var A = {};
          d.token !== void 0 && d.token !== "" && (A[d.headerName] = d.token), A[o.HeaderNames.ConnectionId] = p, f.parameters.setProperty(r.PropertyId.SpeechServiceConnection_Url, v);
          var O = f.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new t.WebsocketConnection(v, y, A, new i.WebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(f), O, p);
        }, l;
      }
      return c;
    }(n.ConnectionFactoryBase)
  );
  return xm.TranscriberConnectionFactory = u, xm;
}
var Nm = {}, _oe;
function F1r() {
  if (_oe) return Nm;
  _oe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }();
  Object.defineProperty(Nm, "__esModule", { value: !0 }), Nm.TranslationConnectionFactory = void 0;
  var t = Yu(), r = Wt(), n = tv(), i = gr(), o = vc(), a = ev(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c() {
        var l = s !== null && s.apply(this, arguments) || this;
        return l.create = function(f, d, p) {
          var v = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Endpoint, void 0);
          if (!v) {
            var h = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Region, void 0), E = h && h.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", m = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Host, "wss://" + h + ".s2s.speech" + E);
            v = m + "/speech/translation/cognitiveservices/v1";
          }
          var g = {
            from: f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage),
            to: f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_TranslationToLanguages)
          };
          l.setCommonUrlParams(f, g, v), l.setUrlParameter(r.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, a.QueryParameterNames.StableTranslation, f, g, v);
          var y = "voice", _ = "features";
          f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && (g[y] = f.parameters.getProperty(r.PropertyId.SpeechServiceConnection_TranslationVoice), g[_] = "texttospeech");
          var S = {};
          d.token !== void 0 && d.token !== "" && (S[d.headerName] = d.token), S[o.HeaderNames.ConnectionId] = p, f.parameters.setProperty(r.PropertyId.SpeechServiceConnection_Url, v);
          var A = f.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new t.WebsocketConnection(v, g, S, new i.WebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(f), A, p);
        }, l;
      }
      return c;
    }(n.ConnectionFactoryBase)
  );
  return Nm.TranslationConnectionFactory = u, Nm;
}
var Lm = {}, Aoe;
function H1r() {
  if (Aoe) return Lm;
  Aoe = 1, Object.defineProperty(Lm, "__esModule", { value: !0 }), Lm.SpeechSynthesisConnectionFactory = void 0;
  var e = Yu(), t = Wt(), r = gr(), n = vc(), i = ev(), o = (
    /** @class */
    /* @__PURE__ */ function() {
      function a() {
        var u = this;
        this.synthesisUri = "/cognitiveservices/websocket/v1", this.create = function(s, c, l) {
          var f = s.parameters.getProperty(t.PropertyId.SpeechServiceConnection_Endpoint, void 0), d = s.parameters.getProperty(t.PropertyId.SpeechServiceConnection_Region, void 0), p = d && d.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", v = s.parameters.getProperty(t.PropertyId.SpeechServiceConnection_EndpointId, void 0), h = v === void 0 ? "tts" : "voice", E = s.parameters.getProperty(t.PropertyId.SpeechServiceConnection_Host, "wss://" + d + "." + h + ".speech" + p), m = {};
          f || (f = E + u.synthesisUri);
          var g = {};
          c.token !== void 0 && c.token !== "" && (g[c.headerName] = c.token), g[n.HeaderNames.ConnectionId] = l, v !== void 0 && (g[i.QueryParameterNames.CustomVoiceDeploymentId] = v), s.parameters.setProperty(t.PropertyId.SpeechServiceConnection_Url, f);
          var y = s.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
          return new e.WebsocketConnection(f, m, g, new r.WebsocketMessageFormatter(), e.ProxyInfo.fromParameters(s.parameters), y, l);
        };
      }
      return a;
    }()
  );
  return Lm.SpeechSynthesisConnectionFactory = o, Lm;
}
var Bm = {}, Soe;
function $1r() {
  if (Soe) return Bm;
  Soe = 1, Object.defineProperty(Bm, "__esModule", { value: !0 }), Bm.EnumTranslation = void 0;
  var e = Wt(), t = gr(), r = (
    /** @class */
    function() {
      function n() {
      }
      return n.implTranslateRecognitionResult = function(i) {
        var o = e.ResultReason.Canceled;
        switch (i) {
          case t.RecognitionStatus.Success:
            o = e.ResultReason.RecognizedSpeech;
            break;
          case t.RecognitionStatus.NoMatch:
          case t.RecognitionStatus.InitialSilenceTimeout:
          case t.RecognitionStatus.BabbleTimeout:
          case t.RecognitionStatus.EndOfDictation:
            o = e.ResultReason.NoMatch;
            break;
          case t.RecognitionStatus.Error:
          default:
            o = e.ResultReason.Canceled;
            break;
        }
        return o;
      }, n.implTranslateCancelResult = function(i) {
        var o = e.CancellationReason.EndOfStream;
        switch (i) {
          case t.RecognitionStatus.Success:
          case t.RecognitionStatus.EndOfDictation:
          case t.RecognitionStatus.NoMatch:
            o = e.CancellationReason.EndOfStream;
            break;
          case t.RecognitionStatus.InitialSilenceTimeout:
          case t.RecognitionStatus.BabbleTimeout:
          case t.RecognitionStatus.Error:
          default:
            o = e.CancellationReason.Error;
            break;
        }
        return o;
      }, n.implTranslateCancelErrorCode = function(i) {
        var o = e.CancellationErrorCode.NoError;
        switch (i) {
          case t.RecognitionStatus.Error:
            o = e.CancellationErrorCode.ServiceError;
            break;
          case t.RecognitionStatus.TooManyRequests:
            o = e.CancellationErrorCode.TooManyRequests;
            break;
          default:
            o = e.CancellationErrorCode.NoError;
            break;
        }
        return o;
      }, n;
    }()
  );
  return Bm.EnumTranslation = r, Bm;
}
var JN = {}, boe;
function U1r() {
  return boe || (boe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.RecognitionStatus = e.SynthesisStatus = void 0, function(t) {
      t[t.Success = 0] = "Success", t[t.SynthesisEnd = 1] = "SynthesisEnd", t[t.Error = 2] = "Error";
    }(e.SynthesisStatus || (e.SynthesisStatus = {})), function(t) {
      t[t.Success = 0] = "Success", t[t.NoMatch = 1] = "NoMatch", t[t.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", t[t.BabbleTimeout = 3] = "BabbleTimeout", t[t.Error = 4] = "Error", t[t.EndOfDictation = 5] = "EndOfDictation", t[t.TooManyRequests = 6] = "TooManyRequests";
    }(e.RecognitionStatus || (e.RecognitionStatus = {}));
  }(JN)), JN;
}
var km = {}, Coe;
function V1r() {
  if (Coe) return km;
  Coe = 1, Object.defineProperty(km, "__esModule", { value: !0 }), km.TranslationSynthesisEnd = void 0;
  var e = gr(), t = (
    /** @class */
    function() {
      function r(n) {
        this.privSynthesisEnd = JSON.parse(n), this.privSynthesisEnd.SynthesisStatus = e.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "SynthesisStatus", {
        get: function() {
          return this.privSynthesisEnd.SynthesisStatus;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "FailureReason", {
        get: function() {
          return this.privSynthesisEnd.FailureReason;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return km.TranslationSynthesisEnd = t, km;
}
var Mm = {}, Ioe;
function j1r() {
  if (Ioe) return Mm;
  Ioe = 1, Object.defineProperty(Mm, "__esModule", { value: !0 }), Mm.TranslationHypothesis = void 0;
  var e = NH(), t = (
    /** @class */
    function() {
      function r(n) {
        this.privTranslationHypothesis = JSON.parse(n), this.privTranslationHypothesis.Translation.TranslationStatus = e.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "Duration", {
        get: function() {
          return this.privTranslationHypothesis.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Offset", {
        get: function() {
          return this.privTranslationHypothesis.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Text", {
        get: function() {
          return this.privTranslationHypothesis.Text;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Translation", {
        get: function() {
          return this.privTranslationHypothesis.Translation;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return Mm.TranslationHypothesis = t, Mm;
}
var Fm = {}, Ooe;
function z1r() {
  if (Ooe) return Fm;
  Ooe = 1, Object.defineProperty(Fm, "__esModule", { value: !0 }), Fm.TranslationPhrase = void 0;
  var e = gr(), t = NH(), r = (
    /** @class */
    function() {
      function n(i) {
        this.privTranslationPhrase = JSON.parse(i), this.privTranslationPhrase.RecognitionStatus = e.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus], this.privTranslationPhrase.Translation !== void 0 && (this.privTranslationPhrase.Translation.TranslationStatus = t.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus]);
      }
      return n.fromJSON = function(i) {
        return new n(i);
      }, Object.defineProperty(n.prototype, "RecognitionStatus", {
        get: function() {
          return this.privTranslationPhrase.RecognitionStatus;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "Offset", {
        get: function() {
          return this.privTranslationPhrase.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "Duration", {
        get: function() {
          return this.privTranslationPhrase.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "Text", {
        get: function() {
          return this.privTranslationPhrase.Text;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(n.prototype, "Translation", {
        get: function() {
          return this.privTranslationPhrase.Translation;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return Fm.TranslationPhrase = r, Fm;
}
var Hm = {}, Roe;
function q1r() {
  if (Roe) return Hm;
  Roe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var u = function(s, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, f) {
        l.__proto__ = f;
      } || function(l, f) {
        for (var d in f) f.hasOwnProperty(d) && (l[d] = f[d]);
      }, u(s, c);
    };
    return function(s, c) {
      u(s, c);
      function l() {
        this.constructor = s;
      }
      s.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }(), t = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, r = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Hm, "__esModule", { value: !0 }), Hm.TranslationServiceRecognizer = void 0;
  var n = Ar(), i = Wt(), o = gr(), a = (
    /** @class */
    function(u) {
      e(s, u);
      function s(c, l, f, d, p) {
        var v = u.call(this, c, l, f, d, p) || this;
        return v.privTranslationRecognizer = p, v.connectionEvents.attach(function(h) {
          return t(v, void 0, void 0, function() {
            return r(this, function(E) {
              switch (E.label) {
                case 0:
                  return h.name !== "ConnectionEstablishedEvent" ? [3, 1] : (this.privTranslationRecognizer.onConnection(), [3, 3]);
                case 1:
                  return h.name !== "ConnectionClosedEvent" ? [3, 3] : [4, this.privTranslationRecognizer.onDisconnection()];
                case 2:
                  E.sent(), E.label = 3;
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }), v;
      }
      return s.prototype.processTypeSpecificMessages = function(c) {
        return t(this, void 0, void 0, function() {
          var l, f, d, p, v, h, E, m, g, y, _, S, A, O;
          return r(this, function(P) {
            switch (P.label) {
              case 0:
                switch (l = new i.PropertyCollection(), f = !1, c.messageType === n.MessageType.Text && l.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, c.textBody), d = c.path.toLowerCase(), d) {
                  case "translation.hypothesis":
                    return [3, 1];
                  case "translation.phrase":
                    return [3, 2];
                  case "translation.synthesis":
                    return [3, 7];
                  case "translation.synthesis.end":
                    return [3, 8];
                }
                return [3, 9];
              case 1:
                if (p = this.fireEventForResult(o.TranslationHypothesis.fromJSON(c.textBody), l), this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + p.offset), this.privTranslationRecognizer.recognizing)
                  try {
                    this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, p);
                  } catch {
                  }
                return f = !0, [3, 10];
              case 2:
                if (v = o.TranslationPhrase.fromJSON(c.textBody), this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + v.Offset + v.Duration), v.RecognitionStatus !== o.RecognitionStatus.Success) return [3, 3];
                if (h = this.fireEventForResult(v, l), this.privTranslationRecognizer.recognized)
                  try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, h);
                  } catch {
                  }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(h.result);
                  } catch (U) {
                    this.privErrorCallback && this.privErrorCallback(U);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                return [3, 10];
              case 3:
                return E = o.EnumTranslation.implTranslateRecognitionResult(v.RecognitionStatus), m = new i.TranslationRecognitionResult(void 0, this.privRequestSession.requestId, E, v.Text, v.Duration, this.privRequestSession.currentTurnAudioOffset + v.Offset, void 0, c.textBody, l), E !== i.ResultReason.Canceled ? [3, 5] : (g = o.EnumTranslation.implTranslateCancelResult(v.RecognitionStatus), [4, this.cancelRecognitionLocal(g, o.EnumTranslation.implTranslateCancelErrorCode(v.RecognitionStatus), void 0)]);
              case 4:
                return P.sent(), [3, 6];
              case 5:
                if (!(this.privRequestSession.isSpeechEnded && E === i.ResultReason.NoMatch && v.RecognitionStatus !== o.RecognitionStatus.InitialSilenceTimeout) && (y = new i.TranslationRecognitionEventArgs(m, m.offset, this.privRequestSession.sessionId), this.privTranslationRecognizer.recognized))
                  try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, y);
                  } catch {
                  }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(m);
                  } catch (U) {
                    this.privErrorCallback && this.privErrorCallback(U);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                P.label = 6;
              case 6:
                return f = !0, [3, 10];
              case 7:
                return this.sendSynthesisAudio(c.binaryBody, this.privRequestSession.sessionId), f = !0, [3, 10];
              case 8:
                switch (_ = o.TranslationSynthesisEnd.fromJSON(c.textBody), _.SynthesisStatus) {
                  case o.SynthesisStatus.Error:
                    if (this.privTranslationRecognizer.synthesizing) {
                      S = new i.TranslationSynthesisResult(i.ResultReason.Canceled, void 0), A = new i.TranslationSynthesisEventArgs(S, this.privRequestSession.sessionId);
                      try {
                        this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, A);
                      } catch {
                      }
                    }
                    if (this.privTranslationRecognizer.canceled) {
                      O = new i.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, i.CancellationReason.Error, _.FailureReason, i.CancellationErrorCode.ServiceError, null);
                      try {
                        this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, O);
                      } catch {
                      }
                    }
                    break;
                  case o.SynthesisStatus.Success:
                    this.sendSynthesisAudio(void 0, this.privRequestSession.sessionId);
                    break;
                }
                return f = !0, [3, 10];
              case 9:
                return [3, 10];
              case 10:
                return [2, f];
            }
          });
        });
      }, s.prototype.cancelRecognition = function(c, l, f, d, p) {
        var v = new i.PropertyCollection();
        if (v.setProperty(o.CancellationErrorCodePropertyName, i.CancellationErrorCode[d]), this.privTranslationRecognizer.canceled) {
          var h = new i.TranslationRecognitionCanceledEventArgs(c, f, p, d, void 0);
          try {
            this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, h);
          } catch {
          }
        }
        if (this.privSuccessCallback) {
          var E = new i.TranslationRecognitionResult(
            void 0,
            // Translations
            l,
            i.ResultReason.Canceled,
            void 0,
            // Text
            void 0,
            // Druation
            void 0,
            // Offset
            p,
            void 0,
            // Json
            v
          );
          try {
            this.privSuccessCallback(E), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }, s.prototype.fireEventForResult = function(c, l) {
        var f;
        if (c.Translation.Translations !== void 0) {
          f = new i.Translations();
          for (var d = 0, p = c.Translation.Translations; d < p.length; d++) {
            var v = p[d];
            f.set(v.Language, v.Text);
          }
        }
        var h;
        c instanceof o.TranslationPhrase ? c.Translation.TranslationStatus === n.TranslationStatus.Success ? h = i.ResultReason.TranslatedSpeech : h = i.ResultReason.RecognizedSpeech : h = i.ResultReason.TranslatingSpeech;
        var E = c.Offset + this.privRequestSession.currentTurnAudioOffset, m = new i.TranslationRecognitionResult(f, this.privRequestSession.requestId, h, c.Text, c.Duration, E, c.Translation.FailureReason, JSON.stringify(c), l), g = new i.TranslationRecognitionEventArgs(m, E, this.privRequestSession.sessionId);
        return g;
      }, s.prototype.sendSynthesisAudio = function(c, l) {
        var f = c === void 0 ? i.ResultReason.SynthesizingAudioCompleted : i.ResultReason.SynthesizingAudio, d = new i.TranslationSynthesisResult(f, c), p = new i.TranslationSynthesisEventArgs(d, l);
        if (this.privTranslationRecognizer.synthesizing)
          try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, p);
          } catch {
          }
      }, s;
    }(o.ServiceRecognizerBase)
  );
  return Hm.TranslationServiceRecognizer = a, Hm;
}
var $m = {}, woe;
function Y1r() {
  if (woe) return $m;
  woe = 1, Object.defineProperty($m, "__esModule", { value: !0 }), $m.SpeechDetected = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privSpeechStartDetected = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "Offset", {
        get: function() {
          return this.privSpeechStartDetected.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return $m.SpeechDetected = e, $m;
}
var Um = {}, Poe;
function G1r() {
  if (Poe) return Um;
  Poe = 1, Object.defineProperty(Um, "__esModule", { value: !0 }), Um.SpeechHypothesis = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privSpeechHypothesis = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "Text", {
        get: function() {
          return this.privSpeechHypothesis.Text;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Offset", {
        get: function() {
          return this.privSpeechHypothesis.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Duration", {
        get: function() {
          return this.privSpeechHypothesis.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Language", {
        get: function() {
          return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "LanguageDetectionConfidence", {
        get: function() {
          return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "SpeakerId", {
        get: function() {
          return this.privSpeechHypothesis.SpeakerId;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Um.SpeechHypothesis = e, Um;
}
var Vm = {}, Doe;
function W1r() {
  if (Doe) return Vm;
  Doe = 1, Object.defineProperty(Vm, "__esModule", { value: !0 }), Vm.SpeechKeyword = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privSpeechKeyword = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "Status", {
        get: function() {
          return this.privSpeechKeyword.Status;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Text", {
        get: function() {
          return this.privSpeechKeyword.Text;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Offset", {
        get: function() {
          return this.privSpeechKeyword.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "Duration", {
        get: function() {
          return this.privSpeechKeyword.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Vm.SpeechKeyword = e, Vm;
}
var jm = {}, xoe;
function K1r() {
  if (xoe) return jm;
  xoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var a = function(u, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
        c.__proto__ = l;
      } || function(c, l) {
        for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
      }, a(u, s);
    };
    return function(u, s) {
      a(u, s);
      function c() {
        this.constructor = u;
      }
      u.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
    };
  }(), t = fe && fe.__awaiter || function(a, u, s, c) {
    function l(f) {
      return f instanceof s ? f : new s(function(d) {
        d(f);
      });
    }
    return new (s || (s = Promise))(function(f, d) {
      function p(E) {
        try {
          h(c.next(E));
        } catch (m) {
          d(m);
        }
      }
      function v(E) {
        try {
          h(c.throw(E));
        } catch (m) {
          d(m);
        }
      }
      function h(E) {
        E.done ? f(E.value) : l(E.value).then(p, v);
      }
      h((c = c.apply(a, u || [])).next());
    });
  }, r = fe && fe.__generator || function(a, u) {
    var s = { label: 0, sent: function() {
      if (f[0] & 1) throw f[1];
      return f[1];
    }, trys: [], ops: [] }, c, l, f, d;
    return d = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
      return this;
    }), d;
    function p(h) {
      return function(E) {
        return v([h, E]);
      };
    }
    function v(h) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; s; ) try {
        if (c = 1, l && (f = h[0] & 2 ? l.return : h[0] ? l.throw || ((f = l.return) && f.call(l), 0) : l.next) && !(f = f.call(l, h[1])).done) return f;
        switch (l = 0, f && (h = [h[0] & 2, f.value]), h[0]) {
          case 0:
          case 1:
            f = h;
            break;
          case 4:
            return s.label++, { value: h[1], done: !1 };
          case 5:
            s.label++, l = h[1], h = [0];
            continue;
          case 7:
            h = s.ops.pop(), s.trys.pop();
            continue;
          default:
            if (f = s.trys, !(f = f.length > 0 && f[f.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              s = 0;
              continue;
            }
            if (h[0] === 3 && (!f || h[1] > f[0] && h[1] < f[3])) {
              s.label = h[1];
              break;
            }
            if (h[0] === 6 && s.label < f[1]) {
              s.label = f[1], f = h;
              break;
            }
            if (f && s.label < f[2]) {
              s.label = f[2], s.ops.push(h);
              break;
            }
            f[2] && s.ops.pop(), s.trys.pop();
            continue;
        }
        h = u.call(a, s);
      } catch (E) {
        h = [6, E], l = 0;
      } finally {
        c = f = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(jm, "__esModule", { value: !0 }), jm.SpeechServiceRecognizer = void 0;
  var n = Wt(), i = gr(), o = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c, l, f, d) {
        var p = a.call(this, s, c, l, f, d) || this;
        if (p.privSpeechRecognizer = d, f.autoDetectSourceLanguages !== void 0) {
          var v = f.autoDetectSourceLanguages.split(",");
          p.privSpeechContext.setSection("languageId", {
            languages: v,
            onSuccess: { action: "Recognize" },
            onUnknown: { action: "None" }
          }), p.privSpeechContext.setSection("phraseOutput", {
            interimResults: {
              resultType: "Auto"
            },
            phraseResults: {
              resultType: "Always"
            }
          });
        }
        return p;
      }
      return u.prototype.processTypeSpecificMessages = function(s) {
        return t(this, void 0, void 0, function() {
          var c, l, f, d, p, v, h, E, m, g, y, _;
          return r(this, function(S) {
            switch (S.label) {
              case 0:
                switch (l = new n.PropertyCollection(), l.setProperty(n.PropertyId.SpeechServiceResponse_JsonResult, s.textBody), f = !1, d = s.path.toLowerCase(), d) {
                  case "speech.hypothesis":
                    return [3, 1];
                  case "speech.fragment":
                    return [3, 1];
                  case "speech.phrase":
                    return [3, 2];
                }
                return [3, 6];
              case 1:
                if (p = i.SpeechHypothesis.fromJSON(s.textBody), v = p.Offset + this.privRequestSession.currentTurnAudioOffset, c = new n.SpeechRecognitionResult(
                  this.privRequestSession.requestId,
                  n.ResultReason.RecognizingSpeech,
                  p.Text,
                  p.Duration,
                  v,
                  p.Language,
                  p.LanguageDetectionConfidence,
                  void 0,
                  // Speaker Id
                  void 0,
                  s.textBody,
                  l
                ), this.privRequestSession.onHypothesis(v), h = new n.SpeechRecognitionEventArgs(c, p.Duration, this.privRequestSession.sessionId), this.privSpeechRecognizer.recognizing)
                  try {
                    this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, h);
                  } catch {
                  }
                return f = !0, [3, 7];
              case 2:
                return E = i.SimpleSpeechPhrase.fromJSON(s.textBody), m = i.EnumTranslation.implTranslateRecognitionResult(E.RecognitionStatus), this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + E.Offset + E.Duration), n.ResultReason.Canceled !== m ? [3, 4] : (g = i.EnumTranslation.implTranslateCancelResult(E.RecognitionStatus), [4, this.cancelRecognitionLocal(g, i.EnumTranslation.implTranslateCancelErrorCode(E.RecognitionStatus), void 0)]);
              case 3:
                return S.sent(), [3, 5];
              case 4:
                if (!(this.privRequestSession.isSpeechEnded && m === n.ResultReason.NoMatch && E.RecognitionStatus !== i.RecognitionStatus.InitialSilenceTimeout) && (this.privRecognizerConfig.parameters.getProperty(i.OutputFormatPropertyName) === n.OutputFormat[n.OutputFormat.Simple] ? c = new n.SpeechRecognitionResult(
                  this.privRequestSession.requestId,
                  m,
                  E.DisplayText,
                  E.Duration,
                  E.Offset + this.privRequestSession.currentTurnAudioOffset,
                  E.Language,
                  E.LanguageDetectionConfidence,
                  void 0,
                  // Speaker Id
                  void 0,
                  s.textBody,
                  l
                ) : (y = i.DetailedSpeechPhrase.fromJSON(s.textBody), c = new n.SpeechRecognitionResult(
                  this.privRequestSession.requestId,
                  m,
                  y.RecognitionStatus === i.RecognitionStatus.Success ? y.NBest[0].Display : void 0,
                  y.Duration,
                  y.Offset + this.privRequestSession.currentTurnAudioOffset,
                  y.Language,
                  y.LanguageDetectionConfidence,
                  void 0,
                  // Speaker Id
                  void 0,
                  s.textBody,
                  l
                )), _ = new n.SpeechRecognitionEventArgs(c, c.offset, this.privRequestSession.sessionId), this.privSpeechRecognizer.recognized))
                  try {
                    this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, _);
                  } catch {
                  }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(c);
                  } catch (A) {
                    this.privErrorCallback && this.privErrorCallback(A);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                S.label = 5;
              case 5:
                return f = !0, [3, 7];
              case 6:
                return [3, 7];
              case 7:
                return [2, f];
            }
          });
        });
      }, u.prototype.cancelRecognition = function(s, c, l, f, d) {
        var p = new n.PropertyCollection();
        if (p.setProperty(i.CancellationErrorCodePropertyName, n.CancellationErrorCode[f]), this.privSpeechRecognizer.canceled) {
          var v = new n.SpeechRecognitionCanceledEventArgs(l, d, f, void 0, s);
          try {
            this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, v);
          } catch {
          }
        }
        if (this.privSuccessCallback) {
          var h = new n.SpeechRecognitionResult(
            c,
            n.ResultReason.Canceled,
            void 0,
            // Text
            void 0,
            // Duration
            void 0,
            // Offset
            void 0,
            // Language
            void 0,
            // Language Detection Confidence
            void 0,
            // Speaker Id
            d,
            void 0,
            // Json
            p
          );
          try {
            this.privSuccessCallback(h), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }, u;
    }(i.ServiceRecognizerBase)
  );
  return jm.SpeechServiceRecognizer = o, jm;
}
var zm = {}, Noe;
function X1r() {
  if (Noe) return zm;
  Noe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }(), t = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, r = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(zm, "__esModule", { value: !0 }), zm.TranscriptionServiceRecognizer = void 0;
  var n = Ar(), i = Wt(), o = gr(), a = e2(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f, d, p, v) {
        var h = s.call(this, l, f, d, p, v) || this;
        return h.sendSpeechEvent = function(E, m) {
          var g = JSON.stringify(m);
          if (g)
            return E.send(new a.SpeechConnectionMessage(n.MessageType.Text, "speech.event", h.privRequestSession.requestId, "application/json", g));
        }, h.privTranscriberRecognizer = v, h.sendPrePayloadJSONOverride = h.sendTranscriptionStartJSON, h;
      }
      return c.prototype.sendSpeechEventAsync = function(l, f) {
        return t(this, void 0, void 0, function() {
          var d;
          return r(this, function(p) {
            switch (p.label) {
              case 0:
                return this.privRequestSession.isRecognizing ? [4, this.fetchConnection()] : [3, 3];
              case 1:
                return d = p.sent(), [4, this.sendSpeechEvent(d, this.createSpeechEventPayload(l, f))];
              case 2:
                p.sent(), p.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.processTypeSpecificMessages = function(l) {
        return t(this, void 0, void 0, function() {
          var f, d, p, v, h, E, m, g, y, _, S, A;
          return r(this, function(O) {
            switch (O.label) {
              case 0:
                switch (d = new i.PropertyCollection(), d.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, l.textBody), p = !1, v = l.path.toLowerCase(), v) {
                  case "speech.hypothesis":
                    return [3, 1];
                  case "speech.fragment":
                    return [3, 1];
                  case "speech.phrase":
                    return [3, 2];
                }
                return [3, 6];
              case 1:
                if (h = o.SpeechHypothesis.fromJSON(l.textBody), E = h.Offset + this.privRequestSession.currentTurnAudioOffset, f = new i.SpeechRecognitionResult(this.privRequestSession.requestId, i.ResultReason.RecognizingSpeech, h.Text, h.Duration, E, h.Language, h.LanguageDetectionConfidence, h.SpeakerId, void 0, l.textBody, d), this.privRequestSession.onHypothesis(E), m = new i.SpeechRecognitionEventArgs(f, h.Duration, this.privRequestSession.sessionId), this.privTranscriberRecognizer.recognizing)
                  try {
                    this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, m);
                  } catch {
                  }
                return p = !0, [3, 7];
              case 2:
                return g = o.SimpleSpeechPhrase.fromJSON(l.textBody), y = o.EnumTranslation.implTranslateRecognitionResult(g.RecognitionStatus), this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + g.Offset + g.Duration), i.ResultReason.Canceled !== y ? [3, 4] : (_ = o.EnumTranslation.implTranslateCancelResult(g.RecognitionStatus), [4, this.cancelRecognitionLocal(_, o.EnumTranslation.implTranslateCancelErrorCode(g.RecognitionStatus), void 0)]);
              case 3:
                return O.sent(), [3, 5];
              case 4:
                if (!(this.privRequestSession.isSpeechEnded && y === i.ResultReason.NoMatch && g.RecognitionStatus !== o.RecognitionStatus.InitialSilenceTimeout) && (this.privRecognizerConfig.parameters.getProperty(o.OutputFormatPropertyName) === i.OutputFormat[i.OutputFormat.Simple] ? f = new i.SpeechRecognitionResult(this.privRequestSession.requestId, y, g.DisplayText, g.Duration, g.Offset + this.privRequestSession.currentTurnAudioOffset, g.Language, g.LanguageDetectionConfidence, g.SpeakerId, void 0, l.textBody, d) : (S = o.DetailedSpeechPhrase.fromJSON(l.textBody), f = new i.SpeechRecognitionResult(this.privRequestSession.requestId, y, S.RecognitionStatus === o.RecognitionStatus.Success ? S.NBest[0].Display : void 0, S.Duration, S.Offset + this.privRequestSession.currentTurnAudioOffset, S.Language, S.LanguageDetectionConfidence, void 0, void 0, l.textBody, d)), A = new i.SpeechRecognitionEventArgs(f, f.offset, this.privRequestSession.sessionId), this.privTranscriberRecognizer.recognized))
                  try {
                    this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, A);
                  } catch {
                  }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(f);
                  } catch (P) {
                    this.privErrorCallback && this.privErrorCallback(P);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                O.label = 5;
              case 5:
                return p = !0, [3, 7];
              case 6:
                return [3, 7];
              case 7:
                return [2, p];
            }
          });
        });
      }, c.prototype.cancelRecognition = function(l, f, d, p, v) {
        var h = new i.PropertyCollection();
        if (h.setProperty(o.CancellationErrorCodePropertyName, i.CancellationErrorCode[p]), this.privTranscriberRecognizer.canceled) {
          var E = new i.ConversationTranscriptionCanceledEventArgs(d, v, p, void 0, l);
          try {
            this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, E);
          } catch {
          }
        }
        if (this.privSuccessCallback) {
          var m = new i.SpeechRecognitionResult(
            f,
            i.ResultReason.Canceled,
            void 0,
            // Text
            void 0,
            // Duration
            void 0,
            // Offset
            void 0,
            // Language
            void 0,
            // Language Detection Confidence
            void 0,
            // Speaker Id
            v,
            void 0,
            // Json
            h
          );
          try {
            this.privSuccessCallback(m), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }, c.prototype.sendTranscriptionStartJSON = function(l) {
        return t(this, void 0, void 0, function() {
          var f, d;
          return r(this, function(p) {
            switch (p.label) {
              case 0:
                return [4, this.sendSpeechContext(l)];
              case 1:
                return p.sent(), f = this.privTranscriberRecognizer.getConversationInfo(), d = this.createSpeechEventPayload(f, "start"), [4, this.sendSpeechEvent(l, d)];
              case 2:
                return p.sent(), [4, this.sendWaveHeader(l)];
              case 3:
                return p.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.createSpeechEventPayload = function(l, f) {
        var d = "meeting", p = { id: d, name: f, meeting: l.conversationProperties }, v = "id", h = "attendees", E = "record";
        return p[d][v] = l.id, p[d][h] = l.participants, p[d][E] = l.conversationProperties.audiorecording === "on" ? "true" : "false", p;
      }, c;
    }(o.ServiceRecognizerBase)
  );
  return zm.TranscriptionServiceRecognizer = u, zm;
}
var qm = {}, Loe;
function J1r() {
  if (Loe) return qm;
  Loe = 1, Object.defineProperty(qm, "__esModule", { value: !0 }), qm.DetailedSpeechPhrase = void 0;
  var e = gr(), t = (
    /** @class */
    function() {
      function r(n) {
        this.privDetailedSpeechPhrase = JSON.parse(n), this.privDetailedSpeechPhrase.RecognitionStatus = e.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "RecognitionStatus", {
        get: function() {
          return this.privDetailedSpeechPhrase.RecognitionStatus;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "NBest", {
        get: function() {
          return this.privDetailedSpeechPhrase.NBest;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Duration", {
        get: function() {
          return this.privDetailedSpeechPhrase.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Offset", {
        get: function() {
          return this.privDetailedSpeechPhrase.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Language", {
        get: function() {
          return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "LanguageDetectionConfidence", {
        get: function() {
          return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return qm.DetailedSpeechPhrase = t, qm;
}
var Ym = {}, Boe;
function Z1r() {
  if (Boe) return Ym;
  Boe = 1, Object.defineProperty(Ym, "__esModule", { value: !0 }), Ym.SimpleSpeechPhrase = void 0;
  var e = gr(), t = (
    /** @class */
    function() {
      function r(n) {
        this.privSimpleSpeechPhrase = JSON.parse(n), this.privSimpleSpeechPhrase.RecognitionStatus = e.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "RecognitionStatus", {
        get: function() {
          return this.privSimpleSpeechPhrase.RecognitionStatus;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "DisplayText", {
        get: function() {
          return this.privSimpleSpeechPhrase.DisplayText;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Offset", {
        get: function() {
          return this.privSimpleSpeechPhrase.Offset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Duration", {
        get: function() {
          return this.privSimpleSpeechPhrase.Duration;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Language", {
        get: function() {
          return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "LanguageDetectionConfidence", {
        get: function() {
          return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "SpeakerId", {
        get: function() {
          return this.privSimpleSpeechPhrase.SpeakerId;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return Ym.SimpleSpeechPhrase = t, Ym;
}
var Gm = {}, koe;
function Q1r() {
  if (koe) return Gm;
  koe = 1, Object.defineProperty(Gm, "__esModule", { value: !0 }), Gm.AddedLmIntent = void 0;
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t(r, n) {
        this.modelImpl = r, this.intentName = n;
      }
      return t;
    }()
  );
  return Gm.AddedLmIntent = e, Gm;
}
var Wm = {}, Moe;
function eTr() {
  if (Moe) return Wm;
  Moe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var u = function(s, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, f) {
        l.__proto__ = f;
      } || function(l, f) {
        for (var d in f) f.hasOwnProperty(d) && (l[d] = f[d]);
      }, u(s, c);
    };
    return function(s, c) {
      u(s, c);
      function l() {
        this.constructor = s;
      }
      s.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }(), t = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, r = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Wm, "__esModule", { value: !0 }), Wm.IntentServiceRecognizer = void 0;
  var n = Ar(), i = Wt(), o = gr(), a = (
    /** @class */
    function(u) {
      e(s, u);
      function s(c, l, f, d, p) {
        var v = u.call(this, c, l, f, d, p) || this;
        return v.privIntentRecognizer = p, v.privIntentDataSent = !1, v;
      }
      return s.prototype.setIntents = function(c, l) {
        this.privAddedLmIntents = c, this.privUmbrellaIntent = l, this.privIntentDataSent = !0;
      }, s.prototype.processTypeSpecificMessages = function(c) {
        return t(this, void 0, void 0, function() {
          var l, f, d, p, v, h, E, m, g, y, _, S, A = this;
          return r(this, function(O) {
            switch (d = !1, p = new i.PropertyCollection(), c.messageType === n.MessageType.Text && p.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, c.textBody), c.path.toLowerCase()) {
              case "speech.hypothesis":
                if (v = o.SpeechHypothesis.fromJSON(c.textBody), l = new i.IntentRecognitionResult(void 0, this.privRequestSession.requestId, i.ResultReason.RecognizingIntent, v.Text, v.Duration, v.Offset + this.privRequestSession.currentTurnAudioOffset, v.Language, v.LanguageDetectionConfidence, void 0, c.textBody, p), this.privRequestSession.onHypothesis(l.offset), f = new i.IntentRecognitionEventArgs(l, v.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privIntentRecognizer.recognizing)
                  try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, f);
                  } catch {
                  }
                d = !0;
                break;
              case "speech.phrase":
                h = o.SimpleSpeechPhrase.fromJSON(c.textBody), l = new i.IntentRecognitionResult(void 0, this.privRequestSession.requestId, o.EnumTranslation.implTranslateRecognitionResult(h.RecognitionStatus), h.DisplayText, h.Duration, h.Offset + this.privRequestSession.currentTurnAudioOffset, h.Language, h.LanguageDetectionConfidence, void 0, c.textBody, p), f = new i.IntentRecognitionEventArgs(l, l.offset, this.privRequestSession.sessionId), E = function() {
                  if (A.privIntentRecognizer.recognized)
                    try {
                      A.privIntentRecognizer.recognized(A.privIntentRecognizer, f);
                    } catch {
                    }
                  if (A.privSuccessCallback) {
                    try {
                      A.privSuccessCallback(l);
                    } catch (P) {
                      A.privErrorCallback && A.privErrorCallback(P);
                    }
                    A.privSuccessCallback = void 0, A.privErrorCallback = void 0;
                  }
                }, this.privIntentDataSent === !1 || i.ResultReason.NoMatch === f.result.reason ? (this.privRequestSession.onPhraseRecognized(f.offset + f.result.duration), E()) : this.privPendingIntentArgs = f, d = !0;
                break;
              case "response":
                if (f = this.privPendingIntentArgs, this.privPendingIntentArgs = void 0, f === void 0) {
                  if (c.textBody === "")
                    return [
                      2
                      /*return*/
                    ];
                  f = new i.IntentRecognitionEventArgs(new i.IntentRecognitionResult(), 0, this.privRequestSession.sessionId);
                }
                if (m = o.IntentResponse.fromJSON(c.textBody), g = this.privAddedLmIntents[m.topScoringIntent.intent], this.privUmbrellaIntent !== void 0 && (g = this.privUmbrellaIntent), m !== null && g !== void 0 && (y = g.intentName === void 0 ? m.topScoringIntent.intent : g.intentName, _ = f.result.reason, y !== void 0 && (_ = i.ResultReason.RecognizedIntent), S = f.result.properties !== void 0 ? f.result.properties : new i.PropertyCollection(), S.setProperty(i.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, c.textBody), f = new i.IntentRecognitionEventArgs(new i.IntentRecognitionResult(y, f.result.resultId, _, f.result.text, f.result.duration, f.result.offset, void 0, void 0, f.result.errorDetails, f.result.json, S), f.offset, f.sessionId)), this.privRequestSession.onPhraseRecognized(f.offset + f.result.duration), this.privIntentRecognizer.recognized)
                  try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, f);
                  } catch {
                  }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(f.result);
                  } catch (P) {
                    this.privErrorCallback && this.privErrorCallback(P);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
                d = !0;
                break;
            }
            return [2, d];
          });
        });
      }, s.prototype.cancelRecognition = function(c, l, f, d, p) {
        var v = new i.PropertyCollection();
        if (v.setProperty(o.CancellationErrorCodePropertyName, i.CancellationErrorCode[d]), this.privIntentRecognizer.canceled) {
          var h = new i.IntentRecognitionCanceledEventArgs(f, p, d, void 0, void 0, c);
          try {
            this.privIntentRecognizer.canceled(this.privIntentRecognizer, h);
          } catch {
          }
        }
        if (this.privSuccessCallback) {
          var E = new i.IntentRecognitionResult(
            void 0,
            // Intent Id
            l,
            i.ResultReason.Canceled,
            void 0,
            // Text
            void 0,
            // Duration
            void 0,
            // Offset
            void 0,
            // Language
            void 0,
            // LanguageDetectionConfidence
            p,
            void 0,
            // Json
            v
          );
          try {
            this.privSuccessCallback(E), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }, s;
    }(o.ServiceRecognizerBase)
  );
  return Wm.IntentServiceRecognizer = a, Wm;
}
var Km = {}, Foe;
function tTr() {
  if (Foe) return Km;
  Foe = 1, Object.defineProperty(Km, "__esModule", { value: !0 }), Km.IntentResponse = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privIntentResponse = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "query", {
        get: function() {
          return this.privIntentResponse.query;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "topScoringIntent", {
        get: function() {
          return this.privIntentResponse.topScoringIntent;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "entities", {
        get: function() {
          return this.privIntentResponse.entities;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Km.IntentResponse = e, Km;
}
var Xm = {}, Jm = {}, Hoe;
function rTr() {
  if (Hoe) return Jm;
  Hoe = 1, Object.defineProperty(Jm, "__esModule", { value: !0 }), Jm.ServiceTelemetryListener = void 0;
  var e = Ar(), t = FH(), r = (
    /** @class */
    function() {
      function n(i, o, a) {
        var u = this;
        this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.onEvent = function(s) {
          u.privIsDisposed || (s instanceof t.RecognitionTriggeredEvent && s.requestId === u.privRequestId && (u.privListeningTriggerMetric = {
            End: s.eventTime,
            Name: "ListeningTrigger",
            Start: s.eventTime
          }), s instanceof e.AudioStreamNodeAttachingEvent && s.audioSourceId === u.privAudioSourceId && s.audioNodeId === u.privAudioNodeId && (u.privMicStartTime = s.eventTime), s instanceof e.AudioStreamNodeAttachedEvent && s.audioSourceId === u.privAudioSourceId && s.audioNodeId === u.privAudioNodeId && (u.privMicStartTime = s.eventTime), s instanceof e.AudioSourceErrorEvent && s.audioSourceId === u.privAudioSourceId && (u.privMicMetric || (u.privMicMetric = {
            End: s.eventTime,
            Error: s.error,
            Name: "Microphone",
            Start: u.privMicStartTime
          })), s instanceof e.AudioStreamNodeErrorEvent && s.audioSourceId === u.privAudioSourceId && s.audioNodeId === u.privAudioNodeId && (u.privMicMetric || (u.privMicMetric = {
            End: s.eventTime,
            Error: s.error,
            Name: "Microphone",
            Start: u.privMicStartTime
          })), s instanceof e.AudioStreamNodeDetachedEvent && s.audioSourceId === u.privAudioSourceId && s.audioNodeId === u.privAudioNodeId && (u.privMicMetric || (u.privMicMetric = {
            End: s.eventTime,
            Name: "Microphone",
            Start: u.privMicStartTime
          })), s instanceof t.ConnectingToServiceEvent && s.requestId === u.privRequestId && (u.privConnectionId = s.sessionId), s instanceof e.ConnectionStartEvent && s.connectionId === u.privConnectionId && (u.privConnectionStartTime = s.eventTime), s instanceof e.ConnectionEstablishedEvent && s.connectionId === u.privConnectionId && (u.privConnectionEstablishMetric || (u.privConnectionEstablishMetric = {
            End: s.eventTime,
            Id: u.privConnectionId,
            Name: "Connection",
            Start: u.privConnectionStartTime
          })), s instanceof e.ConnectionEstablishErrorEvent && s.connectionId === u.privConnectionId && (u.privConnectionEstablishMetric || (u.privConnectionEstablishMetric = {
            End: s.eventTime,
            Error: u.getConnectionError(s.statusCode),
            Id: u.privConnectionId,
            Name: "Connection",
            Start: u.privConnectionStartTime
          })), s instanceof e.ConnectionMessageReceivedEvent && s.connectionId === u.privConnectionId && s.message && s.message.headers && s.message.headers.path && (u.privReceivedMessages[s.message.headers.path] || (u.privReceivedMessages[s.message.headers.path] = new Array()), u.privReceivedMessages[s.message.headers.path].push(s.networkReceivedTime)));
        }, this.getTelemetry = function() {
          var s = new Array();
          u.privListeningTriggerMetric && s.push(u.privListeningTriggerMetric), u.privMicMetric && s.push(u.privMicMetric), u.privConnectionEstablishMetric && s.push(u.privConnectionEstablishMetric), u.privPhraseLatencies.length > 0 && s.push({
            PhraseLatencyMs: u.privPhraseLatencies
          }), u.privHypothesisLatencies.length > 0 && s.push({
            FirstHypothesisLatencyMs: u.privHypothesisLatencies
          });
          var c = {
            Metrics: s,
            ReceivedMessages: u.privReceivedMessages
          }, l = JSON.stringify(c);
          return u.privReceivedMessages = {}, u.privListeningTriggerMetric = null, u.privMicMetric = null, u.privConnectionEstablishMetric = null, u.privPhraseLatencies = [], u.privHypothesisLatencies = [], l;
        }, this.dispose = function() {
          u.privIsDisposed = !0;
        }, this.getConnectionError = function(s) {
          switch (s) {
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
              return "BadRequest";
            case 401:
              return "Unauthorized";
            case 403:
              return "Forbidden";
            case 503:
            case 1001:
              return "ServerUnavailable";
            case 500:
            case 1011:
              return "ServerError";
            case 408:
            case 504:
              return "Timeout";
            default:
              return "statuscode:" + s.toString();
          }
        }, this.privRequestId = i, this.privAudioSourceId = o, this.privAudioNodeId = a, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
      }
      return n.prototype.phraseReceived = function(i) {
        i > 0 && this.privPhraseLatencies.push(Date.now() - i);
      }, n.prototype.hypothesisReceived = function(i) {
        i > 0 && this.privHypothesisLatencies.push(Date.now() - i);
      }, Object.defineProperty(n.prototype, "hasTelemetry", {
        // Determines if there are any telemetry events to send to the service.
        get: function() {
          return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
        },
        enumerable: !1,
        configurable: !0
      }), n;
    }()
  );
  return Jm.ServiceTelemetryListener = r, Jm;
}
var $oe;
function nTr() {
  if ($oe) return Xm;
  $oe = 1;
  var e = fe && fe.__awaiter || function(a, u, s, c) {
    function l(f) {
      return f instanceof s ? f : new s(function(d) {
        d(f);
      });
    }
    return new (s || (s = Promise))(function(f, d) {
      function p(E) {
        try {
          h(c.next(E));
        } catch (m) {
          d(m);
        }
      }
      function v(E) {
        try {
          h(c.throw(E));
        } catch (m) {
          d(m);
        }
      }
      function h(E) {
        E.done ? f(E.value) : l(E.value).then(p, v);
      }
      h((c = c.apply(a, u || [])).next());
    });
  }, t = fe && fe.__generator || function(a, u) {
    var s = { label: 0, sent: function() {
      if (f[0] & 1) throw f[1];
      return f[1];
    }, trys: [], ops: [] }, c, l, f, d;
    return d = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
      return this;
    }), d;
    function p(h) {
      return function(E) {
        return v([h, E]);
      };
    }
    function v(h) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; s; ) try {
        if (c = 1, l && (f = h[0] & 2 ? l.return : h[0] ? l.throw || ((f = l.return) && f.call(l), 0) : l.next) && !(f = f.call(l, h[1])).done) return f;
        switch (l = 0, f && (h = [h[0] & 2, f.value]), h[0]) {
          case 0:
          case 1:
            f = h;
            break;
          case 4:
            return s.label++, { value: h[1], done: !1 };
          case 5:
            s.label++, l = h[1], h = [0];
            continue;
          case 7:
            h = s.ops.pop(), s.trys.pop();
            continue;
          default:
            if (f = s.trys, !(f = f.length > 0 && f[f.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              s = 0;
              continue;
            }
            if (h[0] === 3 && (!f || h[1] > f[0] && h[1] < f[3])) {
              s.label = h[1];
              break;
            }
            if (h[0] === 6 && s.label < f[1]) {
              s.label = f[1], f = h;
              break;
            }
            if (f && s.label < f[2]) {
              s.label = f[2], s.ops.push(h);
              break;
            }
            f[2] && s.ops.pop(), s.trys.pop();
            continue;
        }
        h = u.call(a, s);
      } catch (E) {
        h = [6, E], l = 0;
      } finally {
        c = f = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Xm, "__esModule", { value: !0 }), Xm.RequestSession = void 0;
  var r = Ar(), n = FH(), i = rTr(), o = (
    /** @class */
    function() {
      function a(u) {
        var s = this;
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.onPreConnectionStart = function(c, l) {
          s.privAuthFetchEventId = c, s.privSessionId = l, s.onEvent(new n.ConnectingToServiceEvent(s.privRequestId, s.privAuthFetchEventId, s.privSessionId));
        }, this.onServiceTurnStartResponse = function() {
          s.privTurnDeferral && s.privInTurn && (s.privTurnDeferral.reject("Another turn started before current completed."), s.privTurnDeferral.promise.then().catch(function() {
          })), s.privInTurn = !0, s.privTurnDeferral = new r.Deferred();
        }, this.getTelemetry = function() {
          return s.privServiceTelemetryListener.hasTelemetry ? s.privServiceTelemetryListener.getTelemetry() : null;
        }, this.onEvent = function(c) {
          s.privServiceTelemetryListener && s.privServiceTelemetryListener.onEvent(c), r.Events.instance.onEvent(c);
        }, this.privAudioSourceId = u, this.privRequestId = r.createNoDashGuid(), this.privAudioNodeId = r.createNoDashGuid(), this.privTurnDeferral = new r.Deferred(), this.privTurnDeferral.resolve();
      }
      return Object.defineProperty(a.prototype, "sessionId", {
        get: function() {
          return this.privSessionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "requestId", {
        get: function() {
          return this.privRequestId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "audioNodeId", {
        get: function() {
          return this.privAudioNodeId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "turnCompletionPromise", {
        get: function() {
          return this.privTurnDeferral.promise;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "isSpeechEnded", {
        get: function() {
          return this.privIsSpeechEnded;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "isRecognizing", {
        get: function() {
          return this.privIsRecognizing;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "currentTurnAudioOffset", {
        get: function() {
          return this.privTurnStartAudioOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "recogNumber", {
        get: function() {
          return this.privRecogNumber;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "numConnectionAttempts", {
        get: function() {
          return this.privConnectionAttempts;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "bytesSent", {
        // The number of bytes sent for the current connection.
        // Counter is reset to 0 each time a connection is established.
        get: function() {
          return this.privBytesSent;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.listenForServiceTelemetry = function(u) {
        this.privServiceTelemetryListener && this.privDetachables.push(u.attachListener(this.privServiceTelemetryListener));
      }, a.prototype.startNewRecognition = function() {
        this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRequestId = r.createNoDashGuid(), this.privRecogNumber++, this.privServiceTelemetryListener = new i.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new n.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
      }, a.prototype.onAudioSourceAttachCompleted = function(u, s, c) {
        return e(this, void 0, void 0, function() {
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return this.privAudioNode = u, this.privIsAudioNodeDetached = !1, s ? [4, this.onComplete()] : [3, 2];
              case 1:
                return l.sent(), [3, 3];
              case 2:
                this.onEvent(new n.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId)), l.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onAuthCompleted = function(u, s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return u ? [4, this.onComplete()] : [3, 2];
              case 1:
                c.sent(), c.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onConnectionEstablishCompleted = function(u, s) {
        return e(this, void 0, void 0, function() {
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return u !== 200 ? [3, 1] : (this.onEvent(new n.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0, [
                  2
                  /*return*/
                ]);
              case 1:
                return u !== 403 ? [3, 3] : [4, this.onComplete()];
              case 2:
                c.sent(), c.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onServiceTurnEndResponse = function(u) {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return this.privTurnDeferral.resolve(), !u || this.isSpeechEnded ? [4, this.onComplete()] : [3, 2];
              case 1:
                return s.sent(), this.privInTurn = !1, [3, 3];
              case 2:
                this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privRequestId = r.createNoDashGuid(), this.privAudioNode.replay(), s.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onHypothesis = function(u) {
        this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(u)));
      }, a.prototype.onPhraseRecognized = function(u) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(u)), this.onServiceRecognized(u);
      }, a.prototype.onServiceRecognized = function(u) {
        this.privLastRecoOffset = u, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(u), this.privConnectionAttempts = 0;
      }, a.prototype.onAudioSent = function(u) {
        this.privBytesSent += u;
      }, a.prototype.onRetryConnection = function() {
        this.privConnectionAttempts++;
      }, a.prototype.dispose = function(u) {
        return e(this, void 0, void 0, function() {
          var s, c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                if (this.privIsDisposed) return [3, 5];
                this.privIsDisposed = !0, s = 0, c = this.privDetachables, f.label = 1;
              case 1:
                return s < c.length ? (l = c[s], [4, l.detach()]) : [3, 4];
              case 2:
                f.sent(), f.label = 3;
              case 3:
                return s++, [3, 1];
              case 4:
                this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1, f.label = 5;
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onStopRecognizing = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(u) {
            switch (u.label) {
              case 0:
                return [4, this.onComplete()];
              case 1:
                return u.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.onSpeechEnded = function() {
        this.privIsSpeechEnded = !0;
      }, a.prototype.onComplete = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(u) {
            switch (u.label) {
              case 0:
                return this.privIsRecognizing ? (this.privIsRecognizing = !1, [4, this.detachAudioNode()]) : [3, 2];
              case 1:
                u.sent(), u.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a.prototype.detachAudioNode = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(u) {
            switch (u.label) {
              case 0:
                return this.privIsAudioNodeDetached ? [3, 2] : (this.privIsAudioNodeDetached = !0, this.privAudioNode ? [4, this.privAudioNode.detach()] : [3, 2]);
              case 1:
                u.sent(), u.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a;
    }()
  );
  return Xm.RequestSession = o, Xm;
}
var Zm = {}, Uoe;
function iTr() {
  if (Uoe) return Zm;
  Uoe = 1, Object.defineProperty(Zm, "__esModule", { value: !0 }), Zm.SpeechContext = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privContext = {}, this.privDynamicGrammar = r;
      }
      return t.prototype.setSection = function(r, n) {
        this.privContext[r] = n;
      }, t.prototype.setPronunciationAssessmentParams = function(r) {
        this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = {
          enrichment: {
            pronunciationAssessment: {}
          }
        }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(r), this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
          detailed: {
            options: []
          },
          format: {}
        }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
      }, t.prototype.toJSON = function() {
        var r = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", r);
        var n = JSON.stringify(this.privContext);
        return n;
      }, t;
    }()
  );
  return Zm.SpeechContext = e, Zm;
}
var Qm = {}, Voe;
function oTr() {
  if (Voe) return Qm;
  Voe = 1, Object.defineProperty(Qm, "__esModule", { value: !0 }), Qm.DynamicGrammarBuilder = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.prototype.addPhrase = function(r) {
        this.privPhrases || (this.privPhrases = []), r instanceof Array ? this.privPhrases = this.privPhrases.concat(r) : this.privPhrases.push(r);
      }, t.prototype.clearPhrases = function() {
        this.privPhrases = void 0;
      }, t.prototype.addReferenceGrammar = function(r) {
        this.privGrammars || (this.privGrammars = []), r instanceof Array ? this.privGrammars = this.privGrammars.concat(r) : this.privGrammars.push(r);
      }, t.prototype.clearGrammars = function() {
        this.privGrammars = void 0;
      }, t.prototype.generateGrammarObject = function() {
        if (!(this.privGrammars === void 0 && this.privPhrases === void 0)) {
          var r = {};
          if (r.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
            var n = [];
            this.privPhrases.forEach(function(i, o, a) {
              n.push({
                Text: i
              });
            }), r.Groups = [{ Type: "Generic", Items: n }];
          }
          return r;
        }
      }, t;
    }()
  );
  return Qm.DynamicGrammarBuilder = e, Qm;
}
var ZN = {}, joe;
function aTr() {
  return joe || (joe = 1, Object.defineProperty(ZN, "__esModule", { value: !0 })), ZN;
}
var eg = {}, tg = {}, rg = {}, QN = {}, zoe;
function d4e() {
  return zoe || (zoe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MessageDataStreamType = e.ActivityPayloadResponse = void 0;
    var t = (
      /** @class */
      function() {
        function r(n) {
          this.privActivityResponse = JSON.parse(n);
        }
        return r.fromJSON = function(n) {
          return new r(n);
        }, Object.defineProperty(r.prototype, "conversationId", {
          get: function() {
            return this.privActivityResponse.conversationId;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(r.prototype, "messageDataStreamType", {
          get: function() {
            return this.privActivityResponse.messageDataStreamType;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(r.prototype, "messagePayload", {
          get: function() {
            return this.privActivityResponse.messagePayload;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(r.prototype, "version", {
          get: function() {
            return this.privActivityResponse.version;
          },
          enumerable: !1,
          configurable: !0
        }), r;
      }()
    );
    e.ActivityPayloadResponse = t, function(r) {
      r[r.None = 0] = "None", r[r.TextToSpeechAudio = 1] = "TextToSpeechAudio";
    }(e.MessageDataStreamType || (e.MessageDataStreamType = {}));
  }(QN)), QN;
}
var qoe;
function uTr() {
  if (qoe) return rg;
  qoe = 1, Object.defineProperty(rg, "__esModule", { value: !0 }), rg.DialogServiceTurnState = void 0;
  var e = Q3(), t = Qh(), r = d4e(), n = (
    /** @class */
    function() {
      function i(o, a) {
        this.privRequestId = a, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = o, this.resetTurnEndTimeout();
      }
      return Object.defineProperty(i.prototype, "audioStream", {
        get: function() {
          return this.resetTurnEndTimeout(), this.privAudioStream;
        },
        enumerable: !1,
        configurable: !0
      }), i.prototype.processActivityPayload = function(o, a) {
        return o.messageDataStreamType === r.MessageDataStreamType.TextToSpeechAudio && (this.privAudioStream = t.AudioOutputStream.createPullStream(), this.privAudioStream.format = a !== void 0 ? a : e.AudioOutputFormatImpl.getDefaultOutputFormat()), this.privAudioStream;
      }, i.prototype.endAudioStream = function() {
        this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
      }, i.prototype.complete = function() {
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
      }, i.prototype.resetTurnEndTimeout = function() {
        var o = this;
        this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(function() {
          o.privTurnManager.CompleteTurn(o.privRequestId);
        }, 2e3);
      }, i;
    }()
  );
  return rg.DialogServiceTurnState = n, rg;
}
var Yoe;
function sTr() {
  if (Yoe) return tg;
  Yoe = 1, Object.defineProperty(tg, "__esModule", { value: !0 }), tg.DialogServiceTurnStateManager = void 0;
  var e = hc(), t = uTr(), r = (
    /** @class */
    function() {
      function n() {
        this.privTurnMap = /* @__PURE__ */ new Map();
      }
      return n.prototype.StartTurn = function(i) {
        if (this.privTurnMap.has(i))
          throw new e.InvalidOperationError("Service error: There is already a turn with id:" + i);
        var o = new t.DialogServiceTurnState(this, i);
        return this.privTurnMap.set(i, o), this.privTurnMap.get(i);
      }, n.prototype.GetTurn = function(i) {
        return this.privTurnMap.get(i);
      }, n.prototype.CompleteTurn = function(i) {
        if (!this.privTurnMap.has(i))
          throw new e.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + i);
        var o = this.privTurnMap.get(i);
        return o.complete(), this.privTurnMap.delete(i), o;
      }, n;
    }()
  );
  return tg.DialogServiceTurnStateManager = r, tg;
}
var Goe;
function cTr() {
  if (Goe) return eg;
  Goe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var p = function(v, h) {
      return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, m) {
        E.__proto__ = m;
      } || function(E, m) {
        for (var g in m) m.hasOwnProperty(g) && (E[g] = m[g]);
      }, p(v, h);
    };
    return function(v, h) {
      p(v, h);
      function E() {
        this.constructor = v;
      }
      v.prototype = h === null ? Object.create(h) : (E.prototype = h.prototype, new E());
    };
  }(), t = fe && fe.__awaiter || function(p, v, h, E) {
    function m(g) {
      return g instanceof h ? g : new h(function(y) {
        y(g);
      });
    }
    return new (h || (h = Promise))(function(g, y) {
      function _(O) {
        try {
          A(E.next(O));
        } catch (P) {
          y(P);
        }
      }
      function S(O) {
        try {
          A(E.throw(O));
        } catch (P) {
          y(P);
        }
      }
      function A(O) {
        O.done ? g(O.value) : m(O.value).then(_, S);
      }
      A((E = E.apply(p, v || [])).next());
    });
  }, r = fe && fe.__generator || function(p, v) {
    var h = { label: 0, sent: function() {
      if (g[0] & 1) throw g[1];
      return g[1];
    }, trys: [], ops: [] }, E, m, g, y;
    return y = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
      return this;
    }), y;
    function _(A) {
      return function(O) {
        return S([A, O]);
      };
    }
    function S(A) {
      if (E) throw new TypeError("Generator is already executing.");
      for (; h; ) try {
        if (E = 1, m && (g = A[0] & 2 ? m.return : A[0] ? m.throw || ((g = m.return) && g.call(m), 0) : m.next) && !(g = g.call(m, A[1])).done) return g;
        switch (m = 0, g && (A = [A[0] & 2, g.value]), A[0]) {
          case 0:
          case 1:
            g = A;
            break;
          case 4:
            return h.label++, { value: A[1], done: !1 };
          case 5:
            h.label++, m = A[1], A = [0];
            continue;
          case 7:
            A = h.ops.pop(), h.trys.pop();
            continue;
          default:
            if (g = h.trys, !(g = g.length > 0 && g[g.length - 1]) && (A[0] === 6 || A[0] === 2)) {
              h = 0;
              continue;
            }
            if (A[0] === 3 && (!g || A[1] > g[0] && A[1] < g[3])) {
              h.label = A[1];
              break;
            }
            if (A[0] === 6 && h.label < g[1]) {
              h.label = g[1], g = A;
              break;
            }
            if (g && h.label < g[2]) {
              h.label = g[2], h.ops.push(A);
              break;
            }
            g[2] && h.ops.pop(), h.trys.pop();
            continue;
        }
        A = v.call(p, h);
      } catch (O) {
        A = [6, O], m = 0;
      } finally {
        E = g = 0;
      }
      if (A[0] & 5) throw A[1];
      return { value: A[0] ? A[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(eg, "__esModule", { value: !0 }), eg.DialogServiceAdapter = void 0;
  var n = Yu(), i = ZAe(), o = Ar(), a = Q3(), u = Wt(), s = sTr(), c = gr(), l = d4e(), f = e2(), d = (
    /** @class */
    function(p) {
      e(v, p);
      function v(h, E, m, g, y) {
        var _ = p.call(this, h, E, m, g, y) || this;
        return _.sendAgentConfig = function(S) {
          if (_.agentConfig && !_.agentConfigSent) {
            if (_.privRecognizerConfig.parameters.getProperty(u.PropertyId.Conversation_DialogType) === u.DialogServiceConfig.DialogTypes.CustomCommands) {
              var A = _.agentConfig.get();
              A.botInfo.commandsCulture = _.privRecognizerConfig.parameters.getProperty(u.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us"), _.agentConfig.set(A);
            }
            _.onEvent(new i.SendingAgentContextMessageEvent(_.agentConfig));
            var O = _.agentConfig.toJsonString();
            return _.agentConfigSent = !0, S.send(new f.SpeechConnectionMessage(o.MessageType.Text, "agent.config", _.privRequestSession.requestId, "application/json", O));
          }
        }, _.sendAgentContext = function(S) {
          var A = o.createGuid(), O = _.privDialogServiceConnector.properties.getProperty(u.PropertyId.Conversation_Speech_Activity_Template), P = {
            channelData: "",
            context: {
              interactionId: A
            },
            messagePayload: typeof O === void 0 ? void 0 : O,
            version: 0.5
          }, U = JSON.stringify(P);
          return S.send(new f.SpeechConnectionMessage(o.MessageType.Text, "speech.agent.context", _.privRequestSession.requestId, "application/json", U));
        }, _.handleResponseMessage = function(S) {
          var A = JSON.parse(S.textBody);
          switch (A.messageType.toLowerCase()) {
            case "message":
              var O = S.requestId.toUpperCase(), P = l.ActivityPayloadResponse.fromJSON(S.textBody), U = _.privTurnStateManager.GetTurn(O);
              if (P.conversationId) {
                var z = _.agentConfig.get();
                z.botInfo.conversationId = P.conversationId, _.agentConfig.set(z);
              }
              var k = U.processActivityPayload(P, a.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(_.privDialogServiceConnector.properties.getProperty(u.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0))), H = new u.ActivityReceivedEventArgs(P.messagePayload, k);
              if (_.privDialogServiceConnector.activityReceived)
                try {
                  _.privDialogServiceConnector.activityReceived(_.privDialogServiceConnector, H);
                } catch {
                }
              break;
            case "messagestatus":
              if (_.privDialogServiceConnector.turnStatusReceived)
                try {
                  _.privDialogServiceConnector.turnStatusReceived(_.privDialogServiceConnector, new u.TurnStatusReceivedEventArgs(S.textBody));
                } catch {
                }
              break;
            default:
              o.Events.instance.onEvent(new o.BackgroundEvent("Unexpected response of type " + A.messageType + ". Ignoring."));
              break;
          }
        }, _.privEvents = new o.EventSource(), _.privDialogServiceConnector = y, _.receiveMessageOverride = _.receiveDialogMessageOverride, _.privTurnStateManager = new s.DialogServiceTurnStateManager(), _.recognizeOverride = _.listenOnce, _.postConnectImplOverride = _.dialogConnectImpl, _.configConnectionOverride = _.configConnection, _.disconnectOverride = _.privDisconnect, _.privDialogAudioSource = m, _.agentConfigSent = !1, _.privLastResult = null, _.connectionEvents.attach(function(S) {
          return t(_, void 0, void 0, function() {
            return r(this, function(A) {
              return S.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0), [
                2
                /*return*/
              ];
            });
          });
        }), _;
      }
      return v.prototype.sendMessage = function(h) {
        return t(this, void 0, void 0, function() {
          var E, m, g, y, _;
          return r(this, function(S) {
            switch (S.label) {
              case 0:
                return E = o.createGuid(), m = o.createNoDashGuid(), g = {
                  context: {
                    interactionId: E
                  },
                  messagePayload: JSON.parse(h),
                  version: 0.5
                }, y = JSON.stringify(g), [4, this.fetchConnection()];
              case 1:
                return _ = S.sent(), [4, _.send(new f.SpeechConnectionMessage(o.MessageType.Text, "agent", m, "application/json", y))];
              case 2:
                return S.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, v.prototype.privDisconnect = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(h) {
            switch (h.label) {
              case 0:
                return [4, this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, u.CancellationReason.Error, u.CancellationErrorCode.NoError, "Disconnecting")];
              case 1:
                return h.sent(), this.terminateMessageLoop = !0, this.agentConfigSent = !1, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, v.prototype.processTypeSpecificMessages = function(h) {
        return t(this, void 0, void 0, function() {
          var E, m, g, y, _, S, A, O, P, U, z, k;
          return r(this, function(H) {
            switch (E = new u.PropertyCollection(), h.messageType === o.MessageType.Text && E.setProperty(u.PropertyId.SpeechServiceResponse_JsonResult, h.textBody), h.path.toLowerCase()) {
              case "speech.phrase":
                if (y = c.SimpleSpeechPhrase.fromJSON(h.textBody), this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + y.Offset + y.Duration), y.RecognitionStatus !== c.RecognitionStatus.TooManyRequests && y.RecognitionStatus !== c.RecognitionStatus.Error && (_ = this.fireEventForResult(y, E), this.privLastResult = _.result, this.privDialogServiceConnector.recognized))
                  try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, _);
                  } catch {
                  }
                g = !0;
                break;
              case "speech.hypothesis":
                if (S = c.SpeechHypothesis.fromJSON(h.textBody), A = S.Offset + this.privRequestSession.currentTurnAudioOffset, m = new u.SpeechRecognitionResult(this.privRequestSession.requestId, u.ResultReason.RecognizingSpeech, S.Text, S.Duration, A, S.Language, S.LanguageDetectionConfidence, void 0, void 0, h.textBody, E), this.privRequestSession.onHypothesis(A), O = new u.SpeechRecognitionEventArgs(m, S.Duration, this.privRequestSession.sessionId), this.privDialogServiceConnector.recognizing)
                  try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, O);
                  } catch {
                  }
                g = !0;
                break;
              case "speech.keyword":
                if (P = c.SpeechKeyword.fromJSON(h.textBody), m = new u.SpeechRecognitionResult(this.privRequestSession.requestId, P.Status === "Accepted" ? u.ResultReason.RecognizedKeyword : u.ResultReason.NoMatch, P.Text, P.Duration, P.Offset, void 0, void 0, void 0, void 0, h.textBody, E), P.Status !== "Accepted" && (this.privLastResult = m), U = new u.SpeechRecognitionEventArgs(m, m.duration, m.resultId), this.privDialogServiceConnector.recognized)
                  try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, U);
                  } catch {
                  }
                g = !0;
                break;
              case "audio":
                {
                  z = h.requestId.toUpperCase(), k = this.privTurnStateManager.GetTurn(z);
                  try {
                    h.binaryBody ? k.audioStream.write(h.binaryBody) : k.endAudioStream();
                  } catch {
                  }
                }
                g = !0;
                break;
              case "response":
                this.handleResponseMessage(h), g = !0;
                break;
            }
            return [2, g];
          });
        });
      }, v.prototype.cancelRecognition = function(h, E, m, g, y) {
        return t(this, void 0, void 0, function() {
          var _, S, A;
          return r(this, function(O) {
            switch (O.label) {
              case 0:
                return this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing ? [4, this.privRequestSession.onStopRecognizing()] : [3, 2];
              case 1:
                O.sent(), O.label = 2;
              case 2:
                if (this.privDialogServiceConnector.canceled) {
                  _ = new u.PropertyCollection(), _.setProperty(c.CancellationErrorCodePropertyName, u.CancellationErrorCode[g]), S = new u.SpeechRecognitionCanceledEventArgs(m, y, g, void 0, h);
                  try {
                    this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, S);
                  } catch {
                  }
                  if (this.privSuccessCallback) {
                    A = new u.SpeechRecognitionResult(
                      void 0,
                      // ResultId
                      u.ResultReason.Canceled,
                      void 0,
                      // Text
                      void 0,
                      // Duration
                      void 0,
                      // Offset
                      void 0,
                      // Language
                      void 0,
                      // Language Detection Confidence
                      void 0,
                      // Speaker Id
                      y,
                      void 0,
                      // Json
                      _
                    );
                    try {
                      this.privSuccessCallback(A), this.privSuccessCallback = void 0;
                    } catch {
                    }
                  }
                }
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, v.prototype.listenOnce = function(h, E, m) {
        return t(this, void 0, void 0, function() {
          var g, y, _, S, A, O, P, U, z, k = this;
          return r(this, function(H) {
            switch (H.label) {
              case 0:
                return this.privRecognizerConfig.recognitionMode = h, this.privSuccessCallback = E, this.privErrorCallback = m, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty(u.PropertyId.Speech_SessionId, this.privRequestSession.sessionId), g = this.connectImpl(), y = this.sendPreAudioMessages(), [4, this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId)];
              case 1:
                return _ = H.sent(), [4, this.privDialogAudioSource.format];
              case 2:
                return S = H.sent(), [4, this.privDialogAudioSource.deviceInfo];
              case 3:
                return A = H.sent(), O = new n.ReplayableAudioNode(_, S.avgBytesPerSec), [4, this.privRequestSession.onAudioSourceAttachCompleted(O, !1)];
              case 4:
                H.sent(), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: A }, H.label = 5;
              case 5:
                return H.trys.push([5, 8, , 10]), [4, g];
              case 6:
                return H.sent(), [4, y];
              case 7:
                return H.sent(), [3, 10];
              case 8:
                return P = H.sent(), [4, this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, u.CancellationReason.Error, u.CancellationErrorCode.ConnectionFailure, P)];
              case 9:
                return H.sent(), [2, Promise.resolve()];
              case 10:
                return U = new u.SessionEventArgs(this.privRequestSession.sessionId), this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, U), z = this.sendAudio(O), z.then(function() {
                }, function(B) {
                  return t(k, void 0, void 0, function() {
                    return r(this, function(x) {
                      switch (x.label) {
                        case 0:
                          return [4, this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, u.CancellationReason.Error, u.CancellationErrorCode.RuntimeError, B)];
                        case 1:
                          return x.sent(), [
                            2
                            /*return*/
                          ];
                      }
                    });
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, v.prototype.dialogConnectImpl = function(h) {
        return this.privConnectionLoop = this.startMessageLoop(), h;
      }, v.prototype.receiveDialogMessageOverride = function() {
        var h = this, E = new o.Deferred(), m = function() {
          return t(h, void 0, void 0, function() {
            var g, y, _, S, A, O, P, D, U, z, k, H, B, x, D, w, $;
            return r(this, function(X) {
              switch (X.label) {
                case 0:
                  return X.trys.push([0, 12, , 13]), g = this.isDisposed(), y = !this.isDisposed() && this.terminateMessageLoop, g || y ? (E.resolve(void 0), [
                    2
                    /*return*/
                  ]) : [4, this.fetchConnection()];
                case 1:
                  return _ = X.sent(), [4, _.read()];
                case 2:
                  if (S = X.sent(), !S)
                    return [2, m()];
                  switch (A = f.SpeechConnectionMessage.fromConnectionMessage(S), O = A.path.toLowerCase(), O) {
                    case "turn.start":
                      return [3, 3];
                    case "speech.startdetected":
                      return [3, 4];
                    case "speech.enddetected":
                      return [3, 5];
                    case "turn.end":
                      return [3, 6];
                  }
                  return [3, 10];
                case 3:
                  return P = A.requestId.toUpperCase(), D = this.privRequestSession.requestId.toUpperCase(), P !== D ? this.privTurnStateManager.StartTurn(P) : this.privRequestSession.onServiceTurnStartResponse(), [3, 11];
                case 4:
                  return U = c.SpeechDetected.fromJSON(A.textBody), z = new u.RecognitionEventArgs(U.Offset, this.privRequestSession.sessionId), this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, z), [3, 11];
                case 5:
                  return k = void 0, A.textBody.length > 0 ? k = A.textBody : k = "{ Offset: 0 }", H = c.SpeechDetected.fromJSON(k), this.privRequestSession.onServiceRecognized(H.Offset + this.privRequestSession.currentTurnAudioOffset), B = new u.RecognitionEventArgs(H.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, B), [3, 11];
                case 6:
                  return x = A.requestId.toUpperCase(), D = this.privRequestSession.requestId.toUpperCase(), x === D ? [3, 7] : (this.privTurnStateManager.CompleteTurn(x), [3, 9]);
                case 7:
                  return w = new u.SessionEventArgs(this.privRequestSession.sessionId), [4, this.privRequestSession.onServiceTurnEndResponse(!1)];
                case 8:
                  if (X.sent(), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, w), this.privSuccessCallback && this.privLastResult) {
                    try {
                      this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                    } catch (V) {
                      this.privErrorCallback && this.privErrorCallback(V);
                    }
                    this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                  }
                  X.label = 9;
                case 9:
                  return [3, 11];
                case 10:
                  this.processTypeSpecificMessages(A) || this.serviceEvents && this.serviceEvents.onEvent(new o.ServiceEvent(A.path.toLowerCase(), A.textBody)), X.label = 11;
                case 11:
                  return $ = m(), [2, $];
                case 12:
                  return X.sent(), this.terminateMessageLoop = !0, E.resolve(), [3, 13];
                case 13:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        };
        return m().catch(function(g) {
          o.Events.instance.onEvent(new o.BackgroundEvent(g));
        }), E.promise;
      }, v.prototype.startMessageLoop = function() {
        return t(this, void 0, void 0, function() {
          var h;
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                this.terminateMessageLoop = !1, E.label = 1;
              case 1:
                return E.trys.push([1, 3, , 5]), [4, this.receiveDialogMessageOverride()];
              case 2:
                return E.sent(), [3, 5];
              case 3:
                return h = E.sent(), [4, this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, u.CancellationReason.Error, u.CancellationErrorCode.RuntimeError, h)];
              case 4:
                return E.sent(), [3, 5];
              case 5:
                return [2, Promise.resolve()];
            }
          });
        });
      }, v.prototype.configConnection = function(h) {
        return t(this, void 0, void 0, function() {
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, [2, Promise.reject("Connection to service terminated.")]) : [4, this.sendSpeechServiceConfig(h, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize())];
              case 1:
                return E.sent(), [4, this.sendAgentConfig(h)];
              case 2:
                return E.sent(), [2, h];
            }
          });
        });
      }, v.prototype.sendPreAudioMessages = function() {
        return t(this, void 0, void 0, function() {
          var h;
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return [4, this.fetchConnection()];
              case 1:
                return h = E.sent(), this.addKeywordContextData(), [4, this.sendSpeechContext(h)];
              case 2:
                return E.sent(), [4, this.sendAgentContext(h)];
              case 3:
                return E.sent(), [4, this.sendWaveHeader(h)];
              case 4:
                return E.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, v.prototype.fireEventForResult = function(h, E) {
        var m = c.EnumTranslation.implTranslateRecognitionResult(h.RecognitionStatus), g = h.Offset + this.privRequestSession.currentTurnAudioOffset, y = new u.SpeechRecognitionResult(this.privRequestSession.requestId, m, h.DisplayText, h.Duration, g, h.Language, h.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(h), E), _ = new u.SpeechRecognitionEventArgs(y, g, this.privRequestSession.sessionId);
        return _;
      }, v.prototype.onEvent = function(h) {
        this.privEvents.onEvent(h), o.Events.instance.onEvent(h);
      }, v.prototype.addKeywordContextData = function() {
        var h = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (h !== void 0) {
          for (var E = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), m = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), g = h.split(";"), y = E === void 0 ? [] : E.split(";"), _ = m === void 0 ? [] : m.split(";"), S = [], A = 0; A < g.length; A++) {
            var O = {};
            O.text = g[A], A < y.length && (O.offset = Number(y[A])), A < _.length && (O.duration = Number(_[A])), S.push(O);
          }
          this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [{
            clientDetectedKeywords: S,
            onReject: { action: "EndOfTurn" },
            type: "startTrigger"
          }]);
        }
      }, v;
    }(c.ServiceRecognizerBase)
  );
  return eg.DialogServiceAdapter = d, eg;
}
var ng = {}, Woe;
function lTr() {
  if (Woe) return ng;
  Woe = 1, Object.defineProperty(ng, "__esModule", { value: !0 }), ng.AgentConfig = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return t.prototype.toJsonString = function() {
        return JSON.stringify(this.iPrivConfig);
      }, t.prototype.get = function() {
        return this.iPrivConfig;
      }, t.prototype.set = function(r) {
        this.iPrivConfig = r;
      }, t;
    }()
  );
  return ng.AgentConfig = e, ng;
}
var e5 = {}, ig = {}, og = {}, ag = {}, Koe;
function HH() {
  if (Koe) return ag;
  Koe = 1, Object.defineProperty(ag, "__esModule", { value: !0 }), ag.RestConfigBase = void 0;
  var e = (
    /** @class */
    function() {
      function t() {
      }
      return Object.defineProperty(t, "requestOptions", {
        get: function() {
          return t.privDefaultRequestOptions;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t, "configParams", {
        get: function() {
          return t.privDefaultParams;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t, "restErrors", {
        get: function() {
          return t.privRestErrors;
        },
        enumerable: !1,
        configurable: !0
      }), t.privDefaultRequestOptions = {
        headers: {
          Accept: "application/json"
        },
        ignoreCache: !1,
        timeout: 1e4
      }, t.privRestErrors = {
        authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
        authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
        invalidArgs: "Required input not found: {arg}.",
        invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
        invalidParticipantRequest: "The requested participant was not found.",
        permissionDeniedConnect: "Required credentials not found.",
        permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
        permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
        permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
        permissionDeniedStart: "Invalid operation: there is already an active conversation."
      }, t.privDefaultParams = {
        apiVersion: "api-version",
        authorization: "Authorization",
        clientAppId: "X-ClientAppId",
        contentTypeKey: "Content-Type",
        correlationId: "X-CorrelationId",
        languageCode: "language",
        nickname: "nickname",
        profanity: "profanity",
        requestId: "X-RequestId",
        roomId: "roomid",
        sessionToken: "token",
        subscriptionKey: "Ocp-Apim-Subscription-Key",
        subscriptionRegion: "Ocp-Apim-Subscription-Region",
        token: "X-CapitoToken"
      }, t;
    }()
  );
  return ag.RestConfigBase = e, ag;
}
var Xoe;
function $H() {
  if (Xoe) return og;
  Xoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(og, "__esModule", { value: !0 }), og.ConversationConnectionConfig = void 0;
  var t = HH(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return Object.defineProperty(i, "host", {
        get: function() {
          return i.privHost;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "apiVersion", {
        get: function() {
          return i.privApiVersion;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "clientAppId", {
        get: function() {
          return i.privClientAppId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "defaultLanguageCode", {
        get: function() {
          return i.privDefaultLanguageCode;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "restPath", {
        get: function() {
          return i.privRestPath;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "webSocketPath", {
        get: function() {
          return i.privWebSocketPath;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "speechHost", {
        get: function() {
          return i.privSpeechHost;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "speechPath", {
        get: function() {
          return i.privSpeechPath;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i, "transcriptionEventKeys", {
        get: function() {
          return i.privTranscriptionEventKeys;
        },
        enumerable: !1,
        configurable: !0
      }), i.privHost = "dev.microsofttranslator.com", i.privRestPath = "/capito/room", i.privApiVersion = "2.0", i.privDefaultLanguageCode = "en-US", i.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15", i.privWebSocketPath = "/capito/translate", i.privSpeechHost = "{region}.s2s.speech.microsoft.com", i.privSpeechPath = "/speech/translation/cognitiveservices/v1", i.privTranscriptionEventKeys = ["iCalUid", "callId", "organizer", "FLAC", "MTUri", "DifferenciateGuestSpeakers", "audiorecording", "Threadid", "OrganizerMri", "OrganizerTenantId", "UserToken"], i;
    }(t.RestConfigBase)
  );
  return og.ConversationConnectionConfig = r, og;
}
var Lc = {}, Joe;
function p4e() {
  if (Joe) return Lc;
  Joe = 1;
  var e = fe && fe.__createBinding || (Object.create ? function(d, p, v, h) {
    h === void 0 && (h = v), Object.defineProperty(d, h, { enumerable: !0, get: function() {
      return p[v];
    } });
  } : function(d, p, v, h) {
    h === void 0 && (h = v), d[h] = p[v];
  }), t = fe && fe.__setModuleDefault || (Object.create ? function(d, p) {
    Object.defineProperty(d, "default", { enumerable: !0, value: p });
  } : function(d, p) {
    d.default = p;
  }), r = fe && fe.__importStar || function(d) {
    if (d && d.__esModule) return d;
    var p = {};
    if (d != null) for (var v in d) v !== "default" && Object.hasOwnProperty.call(d, v) && e(p, d, v);
    return t(p, d), p;
  };
  Object.defineProperty(Lc, "__esModule", { value: !0 }), Lc.PromiseToEmptyCallback = Lc.request = Lc.extractHeaderValue = void 0;
  var n = HH(), i = r(ki);
  function o(d) {
    return d === void 0 && (d = {}), Object.keys(d).map(function(p) {
      return encodeURIComponent(p) + "=" + encodeURIComponent(d[p]);
    }).join("&");
  }
  function a(d, p) {
    p === void 0 && (p = {});
    var v = o(p);
    return v ? d + (d.indexOf("?") === -1 ? "?" : "&") + v : d;
  }
  function u(d) {
    return {
      data: d.responseText,
      headers: d.getAllResponseHeaders(),
      json: function() {
        return JSON.parse(d.responseText);
      },
      ok: d.status >= 200 && d.status < 300,
      status: d.status,
      statusText: d.statusText
    };
  }
  function s(d, p) {
    return p === void 0 && (p = null), {
      data: p || d.statusText,
      headers: d.getAllResponseHeaders(),
      json: function() {
        return JSON.parse(p || '"' + d.statusText + '"');
      },
      ok: !1,
      status: d.status,
      statusText: d.statusText
    };
  }
  function c(d, p) {
    var v = "";
    try {
      var h = p.trim().split(/[\r\n]+/), E = {};
      h.forEach(function(m) {
        var g = m.split(": "), y = g.shift().toLowerCase(), _ = g.join(": ");
        E[y] = _;
      }), v = E[d.toLowerCase()];
    } catch {
    }
    return v;
  }
  Lc.extractHeaderValue = c;
  function l(d, p, v, h, E, m) {
    v === void 0 && (v = {}), h === void 0 && (h = null), E === void 0 && (E = {});
    var g = n.RestConfigBase.requestOptions, y = E.ignoreCache || g.ignoreCache, _ = E.headers || g.headers, S = E.timeout || g.timeout, A;
    typeof window > "u" ? A = new i.XMLHttpRequest() : A = new XMLHttpRequest(), A.open(d, a(p, v), !0), _ && Object.keys(_).forEach(function(O) {
      return A.setRequestHeader(O, _[O]);
    }), y && A.setRequestHeader("Cache-Control", "no-cache"), A.timeout = S, A.onload = function(O) {
      m(u(A));
    }, A.onerror = function(O) {
      m(s(A, "Failed to make request."));
    }, A.ontimeout = function(O) {
      m(s(A, "Request took longer than expected."));
    }, d === "post" && h ? (A.setRequestHeader("Content-Type", "application/json"), A.send(JSON.stringify(h))) : A.send();
  }
  Lc.request = l;
  function f(d, p, v) {
    d ? d.then(function(h) {
      try {
        p && p();
      } catch (E) {
        v && v("'Unhandled error on promise callback: " + E + "'");
      }
    }, function(h) {
      try {
        v && v(h);
      } catch {
      }
    }) : v && v("Null promise");
  }
  return Lc.PromiseToEmptyCallback = f, Lc;
}
var Zoe;
function fTr() {
  if (Zoe) return ig;
  Zoe = 1, Object.defineProperty(ig, "__esModule", { value: !0 }), ig.ConversationManager = void 0;
  var e = tn(), t = Wt(), r = $H(), n = p4e(), i = (
    /** @class */
    function() {
      function o() {
        this.privRequestParams = r.ConversationConnectionConfig.configParams, this.privErrors = r.ConversationConnectionConfig.restErrors, this.privHost = r.ConversationConnectionConfig.host, this.privApiVersion = r.ConversationConnectionConfig.apiVersion, this.privRestPath = r.ConversationConnectionConfig.restPath;
      }
      return o.prototype.createOrJoin = function(a, u, s, c) {
        var l = this;
        try {
          e.Contracts.throwIfNullOrUndefined(a, "args");
          var f = a.getProperty(t.PropertyId.SpeechServiceConnection_RecoLanguage, r.ConversationConnectionConfig.defaultLanguageCode), d = a.getProperty(t.PropertyId.ConversationTranslator_Name), p = a.getProperty(t.PropertyId.ConversationTranslator_Host, this.privHost), v = a.getProperty(t.PropertyId.ConversationTranslator_CorrelationId), h = a.getProperty(t.PropertyId.SpeechServiceConnection_Key), E = a.getProperty(t.PropertyId.SpeechServiceConnection_Region), m = a.getProperty(t.PropertyId.SpeechServiceAuthorization_Token);
          e.Contracts.throwIfNullOrWhitespace(f, "languageCode"), e.Contracts.throwIfNullOrWhitespace(d, "nickname"), e.Contracts.throwIfNullOrWhitespace(p, "endpointHost");
          var g = {};
          g[this.privRequestParams.apiVersion] = this.privApiVersion, g[this.privRequestParams.languageCode] = f, g[this.privRequestParams.nickname] = d;
          var y = {};
          v && (y[this.privRequestParams.correlationId] = v), y[this.privRequestParams.clientAppId] = r.ConversationConnectionConfig.clientAppId, u !== void 0 ? g[this.privRequestParams.roomId] = u : (e.Contracts.throwIfNullOrUndefined(E, this.privErrors.authInvalidSubscriptionRegion), y[this.privRequestParams.subscriptionRegion] = E, h ? y[this.privRequestParams.subscriptionKey] = h : m ? y[this.privRequestParams.authorization] = "Bearer " + m : e.Contracts.throwIfNullOrUndefined(h, this.privErrors.authInvalidSubscriptionKey));
          var _ = {};
          _.headers = y;
          var S = "https://" + p + this.privRestPath;
          n.request("post", S, g, null, _, function(O) {
            var P = n.extractHeaderValue(l.privRequestParams.requestId, O.headers);
            if (!O.ok) {
              if (c) {
                var U = l.privErrors.invalidCreateJoinConversationResponse.replace("{status}", O.status.toString()), z = void 0;
                try {
                  z = JSON.parse(O.data), U += " [" + z.error.code + ": " + z.error.message + "]";
                } catch {
                  U += " [" + O.data + "]";
                }
                P && (U += " " + P), c(U);
              }
              return;
            }
            var k = JSON.parse(O.data);
            if (k && (k.requestId = P), s) {
              try {
                s(k);
              } catch (H) {
                c && c(H);
              }
              s = void 0;
            }
          });
        } catch (O) {
          if (c)
            if (O instanceof Error) {
              var A = O;
              c(A.name + ": " + A.message);
            } else
              c(O);
        }
      }, o.prototype.leave = function(a, u) {
        var s = this;
        return new Promise(function(c, l) {
          try {
            e.Contracts.throwIfNullOrUndefined(a, s.privErrors.invalidArgs.replace("{arg}", "config")), e.Contracts.throwIfNullOrWhitespace(u, s.privErrors.invalidArgs.replace("{arg}", "token"));
            var f = a.getProperty(t.PropertyId.ConversationTranslator_Host, s.privHost), d = a.getProperty(t.PropertyId.ConversationTranslator_CorrelationId), p = {};
            p[s.privRequestParams.apiVersion] = s.privApiVersion, p[s.privRequestParams.sessionToken] = u;
            var v = {};
            d && (v[s.privRequestParams.correlationId] = d);
            var h = {};
            h.headers = v;
            var E = "https://" + f + s.privRestPath;
            n.request("delete", E, p, null, h, function(g) {
              g.ok, c();
            });
          } catch (g) {
            if (g instanceof Error) {
              var m = g;
              l(m.name + ": " + m.message);
            } else
              l(g);
          }
        });
      }, o;
    }()
  );
  return ig.ConversationManager = i, ig;
}
var q0 = {}, ug = {}, sg = {}, cg = {}, Qoe;
function h4e() {
  if (Qoe) return cg;
  Qoe = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var n = function(i, o) {
      return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, u) {
        a.__proto__ = u;
      } || function(a, u) {
        for (var s in u) u.hasOwnProperty(s) && (a[s] = u[s]);
      }, n(i, o);
    };
    return function(i, o) {
      n(i, o);
      function a() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    };
  }();
  Object.defineProperty(cg, "__esModule", { value: !0 }), cg.ConversationConnectionMessage = void 0;
  var t = Ar(), r = (
    /** @class */
    function(n) {
      e(i, n);
      function i(o, a, u, s) {
        var c = n.call(this, o, a, u, s) || this, l = JSON.parse(c.textBody);
        return l.type !== void 0 && (c.privConversationMessageType = l.type), c;
      }
      return Object.defineProperty(i.prototype, "conversationMessageType", {
        get: function() {
          return this.privConversationMessageType;
        },
        enumerable: !1,
        configurable: !0
      }), i;
    }(t.ConnectionMessage)
  );
  return cg.ConversationConnectionMessage = r, cg;
}
var eae;
function dTr() {
  if (eae) return sg;
  eae = 1, Object.defineProperty(sg, "__esModule", { value: !0 }), sg.ConversationWebsocketMessageFormatter = void 0;
  var e = Ar(), t = h4e(), r = (
    /** @class */
    /* @__PURE__ */ function() {
      function n() {
        this.toConnectionMessage = function(i) {
          var o = new e.Deferred();
          try {
            if (i.messageType === e.MessageType.Text) {
              var a = new t.ConversationConnectionMessage(i.messageType, i.textContent, {}, i.id);
              o.resolve(a);
            } else i.messageType === e.MessageType.Binary && o.resolve(new t.ConversationConnectionMessage(i.messageType, i.binaryContent, void 0, i.id));
          } catch (u) {
            o.reject("Error formatting the message. Error: " + u);
          }
          return o.promise;
        }, this.fromConnectionMessage = function(i) {
          var o = new e.Deferred();
          try {
            if (i.messageType === e.MessageType.Text) {
              var a = "" + (i.textBody ? i.textBody : "");
              o.resolve(new e.RawWebsocketMessage(e.MessageType.Text, a, i.id));
            }
          } catch (u) {
            o.reject("Error formatting the message. " + u);
          }
          return o.promise;
        };
      }
      return n;
    }()
  );
  return sg.ConversationWebsocketMessageFormatter = r, sg;
}
var tae;
function pTr() {
  if (tae) return ug;
  tae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var c = function(l, f) {
      return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, p) {
        d.__proto__ = p;
      } || function(d, p) {
        for (var v in p) p.hasOwnProperty(v) && (d[v] = p[v]);
      }, c(l, f);
    };
    return function(l, f) {
      c(l, f);
      function d() {
        this.constructor = l;
      }
      l.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
    };
  }();
  Object.defineProperty(ug, "__esModule", { value: !0 }), ug.ConversationConnectionFactory = void 0;
  var t = Yu(), r = Ar(), n = tn(), i = Wt(), o = tv(), a = $H(), u = dTr(), s = (
    /** @class */
    function(c) {
      e(l, c);
      function l() {
        return c !== null && c.apply(this, arguments) || this;
      }
      return l.prototype.create = function(f, d, p) {
        var v = f.parameters.getProperty(i.PropertyId.ConversationTranslator_Host, a.ConversationConnectionConfig.host), h = f.parameters.getProperty(i.PropertyId.ConversationTranslator_CorrelationId, r.createGuid()), E = "wss://" + v + a.ConversationConnectionConfig.webSocketPath, m = f.parameters.getProperty(i.PropertyId.ConversationTranslator_Token, void 0);
        n.Contracts.throwIfNullOrUndefined(m, "token");
        var g = {};
        g[a.ConversationConnectionConfig.configParams.apiVersion] = a.ConversationConnectionConfig.apiVersion, g[a.ConversationConnectionConfig.configParams.token] = m, g[a.ConversationConnectionConfig.configParams.correlationId] = h;
        var y = f.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new t.WebsocketConnection(E, g, {}, new u.ConversationWebsocketMessageFormatter(), t.ProxyInfo.fromRecognizerConfig(f), y, p);
      }, l;
    }(o.ConnectionFactoryBase)
  );
  return ug.ConversationConnectionFactory = s, ug;
}
var lg = {}, fg = {}, rae;
function hTr() {
  if (rae) return fg;
  rae = 1;
  var e = fe && fe.__awaiter || function(i, o, a, u) {
    function s(c) {
      return c instanceof a ? c : new a(function(l) {
        l(c);
      });
    }
    return new (a || (a = Promise))(function(c, l) {
      function f(v) {
        try {
          p(u.next(v));
        } catch (h) {
          l(h);
        }
      }
      function d(v) {
        try {
          p(u.throw(v));
        } catch (h) {
          l(h);
        }
      }
      function p(v) {
        v.done ? c(v.value) : s(v.value).then(f, d);
      }
      p((u = u.apply(i, o || [])).next());
    });
  }, t = fe && fe.__generator || function(i, o) {
    var a = { label: 0, sent: function() {
      if (c[0] & 1) throw c[1];
      return c[1];
    }, trys: [], ops: [] }, u, s, c, l;
    return l = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
      return this;
    }), l;
    function f(p) {
      return function(v) {
        return d([p, v]);
      };
    }
    function d(p) {
      if (u) throw new TypeError("Generator is already executing.");
      for (; a; ) try {
        if (u = 1, s && (c = p[0] & 2 ? s.return : p[0] ? s.throw || ((c = s.return) && c.call(s), 0) : s.next) && !(c = c.call(s, p[1])).done) return c;
        switch (s = 0, c && (p = [p[0] & 2, c.value]), p[0]) {
          case 0:
          case 1:
            c = p;
            break;
          case 4:
            return a.label++, { value: p[1], done: !1 };
          case 5:
            a.label++, s = p[1], p = [0];
            continue;
          case 7:
            p = a.ops.pop(), a.trys.pop();
            continue;
          default:
            if (c = a.trys, !(c = c.length > 0 && c[c.length - 1]) && (p[0] === 6 || p[0] === 2)) {
              a = 0;
              continue;
            }
            if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
              a.label = p[1];
              break;
            }
            if (p[0] === 6 && a.label < c[1]) {
              a.label = c[1], c = p;
              break;
            }
            if (c && a.label < c[2]) {
              a.label = c[2], a.ops.push(p);
              break;
            }
            c[2] && a.ops.pop(), a.trys.pop();
            continue;
        }
        p = o.call(i, a);
      } catch (v) {
        p = [6, v], s = 0;
      } finally {
        u = c = 0;
      }
      if (p[0] & 5) throw p[1];
      return { value: p[0] ? p[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(fg, "__esModule", { value: !0 }), fg.ConversationRequestSession = void 0;
  var r = Ar(), n = (
    /** @class */
    function() {
      function i(o) {
        var a = this;
        this.privIsDisposed = !1, this.privDetachables = new Array(), this.onPreConnectionStart = function(u, s) {
          a.privSessionId = s;
        }, this.onAuthCompleted = function(u, s) {
          u && a.onComplete();
        }, this.onConnectionEstablishCompleted = function(u, s) {
          u !== 200 && u === 403 && a.onComplete();
        }, this.onServiceTurnEndResponse = function(u) {
          u ? a.privRequestId = r.createNoDashGuid() : a.onComplete();
        }, this.onComplete = function() {
        }, this.privSessionId = o, this.privRequestId = r.createNoDashGuid(), this.privRequestCompletionDeferral = new r.Deferred();
      }
      return Object.defineProperty(i.prototype, "sessionId", {
        get: function() {
          return this.privSessionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "requestId", {
        get: function() {
          return this.privRequestId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(i.prototype, "completionPromise", {
        get: function() {
          return this.privRequestCompletionDeferral.promise;
        },
        enumerable: !1,
        configurable: !0
      }), i.prototype.dispose = function(o) {
        return e(this, void 0, void 0, function() {
          var a, u, s;
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                if (this.privIsDisposed) return [3, 4];
                this.privIsDisposed = !0, a = 0, u = this.privDetachables, c.label = 1;
              case 1:
                return a < u.length ? (s = u[a], [4, s.detach()]) : [3, 4];
              case 2:
                c.sent(), c.label = 3;
              case 3:
                return a++, [3, 1];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, i;
    }()
  );
  return fg.ConversationRequestSession = n, fg;
}
var fa = {}, nae;
function v4e() {
  if (nae) return fa;
  nae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }();
  Object.defineProperty(fa, "__esModule", { value: !0 }), fa.ConversationReceivedTranslationEventArgs = fa.ParticipantsListEventArgs = fa.ParticipantAttributeEventArgs = fa.ParticipantEventArgs = fa.LockRoomEventArgs = fa.MuteAllEventArgs = void 0;
  var t = Wt(), r = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = s.call(this, f) || this;
        return d.privIsMuted = l, d;
      }
      return Object.defineProperty(c.prototype, "isMuted", {
        get: function() {
          return this.privIsMuted;
        },
        enumerable: !1,
        configurable: !0
      }), c;
    }(t.SessionEventArgs)
  );
  fa.MuteAllEventArgs = r;
  var n = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = s.call(this, f) || this;
        return d.privIsLocked = l, d;
      }
      return Object.defineProperty(c.prototype, "isMuted", {
        get: function() {
          return this.privIsLocked;
        },
        enumerable: !1,
        configurable: !0
      }), c;
    }(t.SessionEventArgs)
  );
  fa.LockRoomEventArgs = n;
  var i = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = s.call(this, f) || this;
        return d.privParticipant = l, d;
      }
      return Object.defineProperty(c.prototype, "participant", {
        get: function() {
          return this.privParticipant;
        },
        enumerable: !1,
        configurable: !0
      }), c;
    }(t.SessionEventArgs)
  );
  fa.ParticipantEventArgs = i;
  var o = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f, d, p) {
        var v = s.call(this, p) || this;
        return v.privKey = f, v.privValue = d, v.privParticipantId = l, v;
      }
      return Object.defineProperty(c.prototype, "value", {
        get: function() {
          return this.privValue;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "key", {
        get: function() {
          return this.privKey;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "id", {
        get: function() {
          return this.privParticipantId;
        },
        enumerable: !1,
        configurable: !0
      }), c;
    }(t.SessionEventArgs)
  );
  fa.ParticipantAttributeEventArgs = o;
  var a = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f, d, p, v, h, E, m, g) {
        var y = s.call(this, g) || this;
        return y.privRoomId = l, y.privSessionToken = f, y.privTranslateTo = d, y.privProfanityFilter = p, y.privRoomProfanityFilter = v, y.privIsRoomLocked = h, y.privIsRoomLocked = E, y.privParticipants = m, y;
      }
      return Object.defineProperty(c.prototype, "sessionToken", {
        get: function() {
          return this.privSessionToken;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "conversationId", {
        get: function() {
          return this.privRoomId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "translateTo", {
        get: function() {
          return this.privTranslateTo;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "profanityFilter", {
        get: function() {
          return this.privProfanityFilter;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "roomProfanityFilter", {
        get: function() {
          return this.privRoomProfanityFilter;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "isRoomLocked", {
        get: function() {
          return this.privIsRoomLocked;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "isMuteAll", {
        get: function() {
          return this.privIsMuteAll;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "participants", {
        get: function() {
          return this.privParticipants;
        },
        enumerable: !1,
        configurable: !0
      }), c;
    }(t.SessionEventArgs)
  );
  fa.ParticipantsListEventArgs = a;
  var u = (
    /** @class */
    function() {
      function s(c, l, f) {
        this.privPayload = l, this.privCommand = c, this.privSessionId = f;
      }
      return Object.defineProperty(s.prototype, "payload", {
        get: function() {
          return this.privPayload;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "command", {
        get: function() {
          return this.privCommand;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "sessionId", {
        get: function() {
          return this.privSessionId;
        },
        enumerable: !1,
        configurable: !0
      }), s;
    }()
  );
  return fa.ConversationReceivedTranslationEventArgs = u, fa;
}
var Bc = {}, iae;
function E4e() {
  if (iae) return Bc;
  iae = 1, Object.defineProperty(Bc, "__esModule", { value: !0 }), Bc.ConversationTranslatorCommandTypes = Bc.ConversationTranslatorMessageTypes = Bc.InternalParticipants = void 0;
  var e = (
    /** @class */
    function() {
      function t(r, n) {
        r === void 0 && (r = []), this.participants = r, this.meId = n;
      }
      return t.prototype.addOrUpdateParticipant = function(r) {
        if (r !== void 0) {
          var n = this.getParticipantIndex(r.id);
          return n > -1 ? this.participants.splice(n, 1, r) : this.participants.push(r), this.getParticipant(r.id);
        }
      }, t.prototype.getParticipantIndex = function(r) {
        return this.participants.findIndex(function(n) {
          return n.id === r;
        });
      }, t.prototype.getParticipant = function(r) {
        return this.participants.find(function(n) {
          return n.id === r;
        });
      }, t.prototype.deleteParticipant = function(r) {
        this.participants = this.participants.filter(function(n) {
          return n.id !== r;
        });
      }, Object.defineProperty(t.prototype, "host", {
        /***
         * Helper to return the conversation host.
         */
        get: function() {
          return this.participants.find(function(r) {
            return r.isHost === !0;
          });
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "me", {
        /**
         * Helper to return the current user.
         */
        get: function() {
          return this.getParticipant(this.meId);
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return Bc.InternalParticipants = e, Bc.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
  }, Bc.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
  }, Bc;
}
var t5 = {}, dg = {}, oae;
function vTr() {
  if (oae) return dg;
  oae = 1, Object.defineProperty(dg, "__esModule", { value: !0 }), dg.CommandResponsePayload = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privCommandResponse = JSON.parse(r);
      }
      return t.fromJSON = function(r) {
        return new t(r);
      }, Object.defineProperty(t.prototype, "type", {
        get: function() {
          return this.privCommandResponse.type;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "command", {
        get: function() {
          return this.privCommandResponse.command;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "id", {
        get: function() {
          return this.privCommandResponse.id;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "nickname", {
        get: function() {
          return this.privCommandResponse.nickname;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "participantId", {
        get: function() {
          return this.privCommandResponse.participantId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "roomid", {
        get: function() {
          return this.privCommandResponse.roomid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "value", {
        get: function() {
          return this.privCommandResponse.value;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }()
  );
  return dg.CommandResponsePayload = e, dg;
}
var Y0 = {}, aae;
function ETr() {
  if (aae) return Y0;
  aae = 1, Object.defineProperty(Y0, "__esModule", { value: !0 }), Y0.ParticipantPayloadResponse = Y0.ParticipantsListPayloadResponse = void 0;
  var e = (
    /** @class */
    function() {
      function r(n) {
        this.privParticipantsPayloadResponse = JSON.parse(n);
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "roomid", {
        get: function() {
          return this.privParticipantsPayloadResponse.roomid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "id", {
        get: function() {
          return this.privParticipantsPayloadResponse.id;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "command", {
        get: function() {
          return this.privParticipantsPayloadResponse.command;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "participants", {
        get: function() {
          return this.privParticipantsPayloadResponse.participants;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "token", {
        get: function() {
          return this.privParticipantsPayloadResponse.token;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "translateTo", {
        get: function() {
          return this.privParticipantsPayloadResponse.translateTo;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "profanityFilter", {
        get: function() {
          return this.privParticipantsPayloadResponse.profanityFilter;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "roomProfanityFilter", {
        get: function() {
          return this.privParticipantsPayloadResponse.roomProfanityFilter;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "roomLocked", {
        get: function() {
          return this.privParticipantsPayloadResponse.roomLocked;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "muteAll", {
        get: function() {
          return this.privParticipantsPayloadResponse.muteAll;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "type", {
        get: function() {
          return this.privParticipantsPayloadResponse.type;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  Y0.ParticipantsListPayloadResponse = e;
  var t = (
    /** @class */
    function() {
      function r(n) {
        this.privParticipantPayloadResponse = JSON.parse(n);
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "nickname", {
        get: function() {
          return this.privParticipantPayloadResponse.nickname;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "locale", {
        get: function() {
          return this.privParticipantPayloadResponse.locale;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "usetts", {
        get: function() {
          return this.privParticipantPayloadResponse.usetts;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "ismuted", {
        get: function() {
          return this.privParticipantPayloadResponse.ismuted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "ishost", {
        get: function() {
          return this.privParticipantPayloadResponse.ishost;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "participantId", {
        get: function() {
          return this.privParticipantPayloadResponse.participantId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "avatar", {
        get: function() {
          return this.privParticipantPayloadResponse.avatar;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return Y0.ParticipantPayloadResponse = t, Y0;
}
var G0 = {}, uae;
function mTr() {
  if (uae) return G0;
  uae = 1, Object.defineProperty(G0, "__esModule", { value: !0 }), G0.TextResponsePayload = G0.SpeechResponsePayload = void 0;
  var e = (
    /** @class */
    function() {
      function r(n) {
        this.privSpeechResponse = JSON.parse(n);
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "recognition", {
        get: function() {
          return this.privSpeechResponse.recognition;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "translations", {
        get: function() {
          return this.privSpeechResponse.translations;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "id", {
        get: function() {
          return this.privSpeechResponse.id;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "language", {
        get: function() {
          return this.privSpeechResponse.language;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "nickname", {
        get: function() {
          return this.privSpeechResponse.nickname;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "participantId", {
        get: function() {
          return this.privSpeechResponse.participantId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "roomid", {
        get: function() {
          return this.privSpeechResponse.roomid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "timestamp", {
        get: function() {
          return this.privSpeechResponse.timestamp;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "type", {
        get: function() {
          return this.privSpeechResponse.type;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "isFinal", {
        get: function() {
          return this.privSpeechResponse.type === "final";
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  G0.SpeechResponsePayload = e;
  var t = (
    /** @class */
    function() {
      function r(n) {
        this.privTextResponse = JSON.parse(n);
      }
      return r.fromJSON = function(n) {
        return new r(n);
      }, Object.defineProperty(r.prototype, "originalText", {
        get: function() {
          return this.privTextResponse.originalText;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "translations", {
        get: function() {
          return this.privTextResponse.translations;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "id", {
        get: function() {
          return this.privTextResponse.id;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "language", {
        get: function() {
          return this.privTextResponse.language;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "nickname", {
        get: function() {
          return this.privTextResponse.nickname;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "participantId", {
        get: function() {
          return this.privTextResponse.participantId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "roomid", {
        get: function() {
          return this.privTextResponse.roomid;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "timestamp", {
        get: function() {
          return this.privTextResponse.timestamp;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "type", {
        get: function() {
          return this.privTextResponse.type;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return G0.TextResponsePayload = t, G0;
}
var sae;
function gTr() {
  return sae || (sae = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t = vTr();
    Object.defineProperty(e, "CommandResponsePayload", { enumerable: !0, get: function() {
      return t.CommandResponsePayload;
    } });
    var r = ETr();
    Object.defineProperty(e, "ParticipantsListPayloadResponse", { enumerable: !0, get: function() {
      return r.ParticipantsListPayloadResponse;
    } }), Object.defineProperty(e, "ParticipantPayloadResponse", { enumerable: !0, get: function() {
      return r.ParticipantPayloadResponse;
    } });
    var n = mTr();
    Object.defineProperty(e, "SpeechResponsePayload", { enumerable: !0, get: function() {
      return n.SpeechResponsePayload;
    } }), Object.defineProperty(e, "TextResponsePayload", { enumerable: !0, get: function() {
      return n.TextResponsePayload;
    } });
  }(t5)), t5;
}
var cae;
function TTr() {
  if (cae) return lg;
  cae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var d = function(p, v) {
      return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, E) {
        h.__proto__ = E;
      } || function(h, E) {
        for (var m in E) E.hasOwnProperty(m) && (h[m] = E[m]);
      }, d(p, v);
    };
    return function(p, v) {
      d(p, v);
      function h() {
        this.constructor = p;
      }
      p.prototype = v === null ? Object.create(v) : (h.prototype = v.prototype, new h());
    };
  }(), t = fe && fe.__awaiter || function(d, p, v, h) {
    function E(m) {
      return m instanceof v ? m : new v(function(g) {
        g(m);
      });
    }
    return new (v || (v = Promise))(function(m, g) {
      function y(A) {
        try {
          S(h.next(A));
        } catch (O) {
          g(O);
        }
      }
      function _(A) {
        try {
          S(h.throw(A));
        } catch (O) {
          g(O);
        }
      }
      function S(A) {
        A.done ? m(A.value) : E(A.value).then(y, _);
      }
      S((h = h.apply(d, p || [])).next());
    });
  }, r = fe && fe.__generator || function(d, p) {
    var v = { label: 0, sent: function() {
      if (m[0] & 1) throw m[1];
      return m[1];
    }, trys: [], ops: [] }, h, E, m, g;
    return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function y(S) {
      return function(A) {
        return _([S, A]);
      };
    }
    function _(S) {
      if (h) throw new TypeError("Generator is already executing.");
      for (; v; ) try {
        if (h = 1, E && (m = S[0] & 2 ? E.return : S[0] ? E.throw || ((m = E.return) && m.call(E), 0) : E.next) && !(m = m.call(E, S[1])).done) return m;
        switch (E = 0, m && (S = [S[0] & 2, m.value]), S[0]) {
          case 0:
          case 1:
            m = S;
            break;
          case 4:
            return v.label++, { value: S[1], done: !1 };
          case 5:
            v.label++, E = S[1], S = [0];
            continue;
          case 7:
            S = v.ops.pop(), v.trys.pop();
            continue;
          default:
            if (m = v.trys, !(m = m.length > 0 && m[m.length - 1]) && (S[0] === 6 || S[0] === 2)) {
              v = 0;
              continue;
            }
            if (S[0] === 3 && (!m || S[1] > m[0] && S[1] < m[3])) {
              v.label = S[1];
              break;
            }
            if (S[0] === 6 && v.label < m[1]) {
              v.label = m[1], m = S;
              break;
            }
            if (m && v.label < m[2]) {
              v.label = m[2], v.ops.push(S);
              break;
            }
            m[2] && v.ops.pop(), v.trys.pop();
            continue;
        }
        S = p.call(d, v);
      } catch (A) {
        S = [6, A], E = 0;
      } finally {
        h = m = 0;
      }
      if (S[0] & 5) throw S[1];
      return { value: S[0] ? S[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(lg, "__esModule", { value: !0 }), lg.ConversationServiceAdapter = void 0;
  var n = Ar(), i = Wt(), o = gr(), a = h4e(), u = hTr(), s = v4e(), c = E4e(), l = gTr(), f = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h, E, m, g) {
        var y = d.call(this, v, h, E, m, g) || this;
        return y.privLastPartialUtteranceId = "", y.noOp = function() {
        }, y.privConversationServiceConnector = g, y.privConversationAuthentication = v, y.receiveMessageOverride = y.receiveConversationMessageOverride, y.recognizeOverride = y.noOp, y.postConnectImplOverride = y.conversationConnectImpl, y.configConnectionOverride = y.configConnection, y.disconnectOverride = y.privDisconnect, y.privConversationRequestSession = new u.ConversationRequestSession(n.createNoDashGuid()), y.privConversationConnectionFactory = h, y.privConversationIsDisposed = !1, y;
      }
      return p.prototype.isDisposed = function() {
        return d.prototype.isDisposed.call(this) || this.privConversationIsDisposed;
      }, p.prototype.dispose = function(v) {
        return t(this, void 0, void 0, function() {
          var h;
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return this.privConversationIsDisposed = !0, this.privConnectionConfigPromise ? [4, this.privConnectionConfigPromise] : [3, 3];
              case 1:
                return h = E.sent(), [4, h.dispose(v)];
              case 2:
                E.sent(), E.label = 3;
              case 3:
                return [4, d.prototype.dispose.call(this, v)];
              case 4:
                return E.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, p.prototype.sendMessage = function(v) {
        return t(this, void 0, void 0, function() {
          var h;
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return [4, this.fetchConnection()];
              case 1:
                return h = E.sent(), [2, h.send(new a.ConversationConnectionMessage(n.MessageType.Text, v))];
            }
          });
        });
      }, p.prototype.sendMessageAsync = function(v) {
        return t(this, void 0, void 0, function() {
          var h;
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return new n.Deferred(), [4, this.fetchConnection()];
              case 1:
                return h = E.sent(), [4, h.send(new a.ConversationConnectionMessage(n.MessageType.Text, v))];
              case 2:
                return E.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, p.prototype.privDisconnect = function() {
        if (!this.terminateMessageLoop)
          return this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, i.CancellationReason.Error, i.CancellationErrorCode.NoError, "Disconnecting"), this.terminateMessageLoop = !0, Promise.resolve();
      }, p.prototype.processTypeSpecificMessages = function(v, h, E) {
        return t(this, void 0, void 0, function() {
          return r(this, function(m) {
            return [2, !0];
          });
        });
      }, p.prototype.cancelRecognition = function(v, h, E, m, g) {
        this.terminateMessageLoop = !0;
        var y = new i.ConversationTranslationCanceledEventArgs(E, g, m, void 0, v);
        try {
          this.privConversationServiceConnector.canceled && this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, y);
        } catch {
        }
      }, p.prototype.conversationConnectImpl = function(v) {
        return t(this, void 0, void 0, function() {
          return r(this, function(h) {
            return this.privConnectionLoop = this.startMessageLoop(), [2, v];
          });
        });
      }, p.prototype.receiveConversationMessageOverride = function() {
        return t(this, void 0, void 0, function() {
          var v, h, E, m, g, y, _, S, A, O, P, U, z, k, H, B;
          return r(this, function(x) {
            switch (x.label) {
              case 0:
                if (this.isDisposed() || this.terminateMessageLoop)
                  return [2, Promise.resolve()];
                v = new n.Deferred(), x.label = 1;
              case 1:
                return x.trys.push([1, 4, , 5]), [4, this.fetchConnection()];
              case 2:
                return h = x.sent(), [4, h.read()];
              case 3:
                if (E = x.sent(), this.isDisposed() || this.terminateMessageLoop)
                  return v.resolve(), [2, Promise.resolve()];
                if (!E)
                  return [2, this.receiveConversationMessageOverride()];
                m = this.privConversationRequestSession.sessionId, g = !1;
                try {
                  switch (E.conversationMessageType.toLowerCase()) {
                    case "info":
                    case "participant_command":
                    case "command":
                      switch (y = l.CommandResponsePayload.fromJSON(E.textBody), y.command.toLowerCase()) {
                        case "participantlist":
                          _ = l.ParticipantsListPayloadResponse.fromJSON(E.textBody), S = _.participants.map(function(D) {
                            var w = {
                              avatar: D.avatar,
                              displayName: D.nickname,
                              id: D.participantId,
                              isHost: D.ishost,
                              isMuted: D.ismuted,
                              isUsingTts: D.usetts,
                              preferredLanguage: D.locale
                            };
                            return w;
                          }), this.privConversationServiceConnector.participantsListReceived && this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new s.ParticipantsListEventArgs(_.roomid, _.token, _.translateTo, _.profanityFilter, _.roomProfanityFilter, _.roomLocked, _.muteAll, S, m));
                          break;
                        case "settranslatetolanguages":
                          this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new s.ParticipantAttributeEventArgs(y.participantId, c.ConversationTranslatorCommandTypes.setTranslateToLanguages, y.value, m));
                          break;
                        case "setprofanityfiltering":
                          this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new s.ParticipantAttributeEventArgs(y.participantId, c.ConversationTranslatorCommandTypes.setProfanityFiltering, y.value, m));
                          break;
                        case "setmute":
                          this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new s.ParticipantAttributeEventArgs(y.participantId, c.ConversationTranslatorCommandTypes.setMute, y.value, m));
                          break;
                        case "setmuteall":
                          this.privConversationServiceConnector.muteAllCommandReceived && this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new s.MuteAllEventArgs(y.value, m));
                          break;
                        case "roomexpirationwarning":
                          this.privConversationServiceConnector.conversationExpiration && this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new i.ConversationExpirationEventArgs(y.value, this.privConversationRequestSession.sessionId));
                          break;
                        case "setusetts":
                          this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new s.ParticipantAttributeEventArgs(y.participantId, c.ConversationTranslatorCommandTypes.setUseTTS, y.value, m));
                          break;
                        case "setlockstate":
                          this.privConversationServiceConnector.lockRoomCommandReceived && this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new s.LockRoomEventArgs(y.value, m));
                          break;
                        case "changenickname":
                          this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new s.ParticipantAttributeEventArgs(y.participantId, c.ConversationTranslatorCommandTypes.changeNickname, y.nickname, m));
                          break;
                        case "joinsession":
                          A = l.ParticipantPayloadResponse.fromJSON(E.textBody), O = {
                            avatar: A.avatar,
                            displayName: A.nickname,
                            id: A.participantId,
                            isHost: A.ishost,
                            isMuted: A.ismuted,
                            isUsingTts: A.usetts,
                            preferredLanguage: A.locale
                          }, this.privConversationServiceConnector.participantJoinCommandReceived && this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new s.ParticipantEventArgs(O, m));
                          break;
                        case "leavesession":
                          P = {
                            id: y.participantId
                          }, this.privConversationServiceConnector.participantLeaveCommandReceived && this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new s.ParticipantEventArgs(P, m));
                          break;
                        case "disconnectsession":
                          U = {
                            id: y.participantId
                          };
                          break;
                        default:
                          break;
                      }
                      break;
                    case "partial":
                    case "final":
                      z = l.SpeechResponsePayload.fromJSON(E.textBody), k = new i.ConversationTranslationResult(z.participantId, this.getTranslations(z.translations), z.language, void 0, void 0, z.recognition, void 0, void 0, E.textBody, void 0), z.isFinal ? ((k.text !== void 0 && k.text.length > 0 || z.id === this.privLastPartialUtteranceId) && (g = !0), g && this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new s.ConversationReceivedTranslationEventArgs(c.ConversationTranslatorMessageTypes.final, k, m))) : k.text !== void 0 && (this.privLastPartialUtteranceId = z.id, this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new s.ConversationReceivedTranslationEventArgs(c.ConversationTranslatorMessageTypes.partial, k, m)));
                      break;
                    case "translated_message":
                      H = l.TextResponsePayload.fromJSON(E.textBody), B = new i.ConversationTranslationResult(H.participantId, this.getTranslations(H.translations), H.language, void 0, void 0, H.originalText, void 0, void 0, void 0, E.textBody, void 0), this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new s.ConversationReceivedTranslationEventArgs(c.ConversationTranslatorMessageTypes.instantMessage, B, m));
                      break;
                    default:
                      break;
                  }
                } catch {
                }
                return [2, this.receiveConversationMessageOverride()];
              case 4:
                return x.sent(), this.terminateMessageLoop = !0, [3, 5];
              case 5:
                return [2, v.promise];
            }
          });
        });
      }, p.prototype.startMessageLoop = function() {
        return t(this, void 0, void 0, function() {
          var v, h, E;
          return r(this, function(m) {
            switch (m.label) {
              case 0:
                if (this.isDisposed())
                  return [2, Promise.resolve()];
                this.terminateMessageLoop = !1, v = this.receiveConversationMessageOverride(), m.label = 1;
              case 1:
                return m.trys.push([1, 3, , 4]), [4, v];
              case 2:
                return h = m.sent(), [2, h];
              case 3:
                return E = m.sent(), this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", i.CancellationReason.Error, i.CancellationErrorCode.RuntimeError, E), [2, null];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, p.prototype.configConnection = function() {
        var v = this;
        return this.isDisposed() ? Promise.resolve(void 0) : this.privConnectionConfigPromise ? this.privConnectionConfigPromise.then(function(h) {
          return h.state() === n.ConnectionState.Disconnected ? (v.privConnectionId = null, v.privConnectionConfigPromise = null, v.configConnection()) : v.privConnectionConfigPromise;
        }, function(h) {
          return v.privConnectionId = null, v.privConnectionConfigPromise = null, v.configConnection();
        }) : this.terminateMessageLoop ? Promise.resolve(void 0) : (this.privConnectionConfigPromise = this.connectImpl().then(function(h) {
          return h;
        }), this.privConnectionConfigPromise);
      }, p.prototype.getTranslations = function(v) {
        var h;
        if (v !== void 0) {
          h = new i.Translations();
          for (var E = 0, m = v; E < m.length; E++) {
            var g = m[E];
            h.set(g.lang, g.translation);
          }
        }
        return h;
      }, p;
    }(o.ServiceRecognizerBase)
  );
  return lg.ConversationServiceAdapter = f, lg;
}
var lae;
function yTr() {
  if (lae) return q0;
  lae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var d = function(p, v) {
      return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, E) {
        h.__proto__ = E;
      } || function(h, E) {
        for (var m in E) E.hasOwnProperty(m) && (h[m] = E[m]);
      }, d(p, v);
    };
    return function(p, v) {
      d(p, v);
      function h() {
        this.constructor = p;
      }
      p.prototype = v === null ? Object.create(v) : (h.prototype = v.prototype, new h());
    };
  }(), t = fe && fe.__awaiter || function(d, p, v, h) {
    function E(m) {
      return m instanceof v ? m : new v(function(g) {
        g(m);
      });
    }
    return new (v || (v = Promise))(function(m, g) {
      function y(A) {
        try {
          S(h.next(A));
        } catch (O) {
          g(O);
        }
      }
      function _(A) {
        try {
          S(h.throw(A));
        } catch (O) {
          g(O);
        }
      }
      function S(A) {
        A.done ? m(A.value) : E(A.value).then(y, _);
      }
      S((h = h.apply(d, p || [])).next());
    });
  }, r = fe && fe.__generator || function(d, p) {
    var v = { label: 0, sent: function() {
      if (m[0] & 1) throw m[1];
      return m[1];
    }, trys: [], ops: [] }, h, E, m, g;
    return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function y(S) {
      return function(A) {
        return _([S, A]);
      };
    }
    function _(S) {
      if (h) throw new TypeError("Generator is already executing.");
      for (; v; ) try {
        if (h = 1, E && (m = S[0] & 2 ? E.return : S[0] ? E.throw || ((m = E.return) && m.call(E), 0) : E.next) && !(m = m.call(E, S[1])).done) return m;
        switch (E = 0, m && (S = [S[0] & 2, m.value]), S[0]) {
          case 0:
          case 1:
            m = S;
            break;
          case 4:
            return v.label++, { value: S[1], done: !1 };
          case 5:
            v.label++, E = S[1], S = [0];
            continue;
          case 7:
            S = v.ops.pop(), v.trys.pop();
            continue;
          default:
            if (m = v.trys, !(m = m.length > 0 && m[m.length - 1]) && (S[0] === 6 || S[0] === 2)) {
              v = 0;
              continue;
            }
            if (S[0] === 3 && (!m || S[1] > m[0] && S[1] < m[3])) {
              v.label = S[1];
              break;
            }
            if (S[0] === 6 && v.label < m[1]) {
              v.label = m[1], m = S;
              break;
            }
            if (m && v.label < m[2]) {
              v.label = m[2], v.ops.push(S);
              break;
            }
            m[2] && v.ops.pop(), v.trys.pop();
            continue;
        }
        S = p.call(d, v);
      } catch (A) {
        S = [6, A], E = 0;
      } finally {
        h = m = 0;
      }
      if (S[0] & 5) throw S[1];
      return { value: S[0] ? S[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(q0, "__esModule", { value: !0 }), q0.ConversationTranslatorRecognizer = q0.ConversationRecognizerFactory = void 0;
  var n = gr(), i = Ar(), o = tn(), a = Wt(), u = pTr(), s = TTr(), c = p4e(), l = (
    /** @class */
    function() {
      function d() {
      }
      return d.fromConfig = function(p, v) {
        return new f(p, v);
      }, d;
    }()
  );
  q0.ConversationRecognizerFactory = l;
  var f = (
    /** @class */
    function(d) {
      e(p, d);
      function p(v, h) {
        var E = this, m = v;
        return o.Contracts.throwIfNull(m, "speechConfig"), E = d.call(this, h, m.properties, new u.ConversationConnectionFactory()) || this, E.privIsDisposed = !1, E.privProperties = m.properties.clone(), E.privConnection = a.Connection.fromRecognizer(E), E;
      }
      return Object.defineProperty(p.prototype, "connected", {
        set: function(v) {
          this.privConnection.connected = v;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "disconnected", {
        set: function(v) {
          this.privConnection.disconnected = v;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "speechRecognitionLanguage", {
        /**
         * Return the speech language used by the recognizer
         */
        get: function() {
          return this.privSpeechRecognitionLanguage;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(p.prototype, "properties", {
        /**
         * Return the properties for the recognizer
         */
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), p.prototype.isDisposed = function() {
        return this.privIsDisposed;
      }, p.prototype.connect = function(v, h, E) {
        try {
          o.Contracts.throwIfDisposed(this.privIsDisposed), o.Contracts.throwIfNullOrWhitespace(v, "token"), this.privReco.conversationTranslatorToken = v, this.privReco.connectAsync(h, E);
        } catch (g) {
          if (E)
            if (g instanceof Error) {
              var m = g;
              E(m.name + ": " + m.message);
            } else
              E(g);
        }
      }, p.prototype.disconnect = function(v, h) {
        try {
          o.Contracts.throwIfDisposed(this.privIsDisposed), this.privReco.disconnect().then(function() {
            v && v();
          }, function(m) {
            h && h(m);
          });
        } catch (m) {
          if (h)
            if (m instanceof Error) {
              var E = m;
              h(E.name + ": " + E.message);
            } else
              h(m);
          this.dispose(!0).catch(function(g) {
            i.Events.instance.onEvent(new i.BackgroundEvent(g));
          });
        }
      }, p.prototype.sendRequest = function(v, h, E) {
        try {
          o.Contracts.throwIfDisposed(this.privIsDisposed), this.sendMessage(v, h, E);
        } catch (g) {
          if (E)
            if (g instanceof Error) {
              var m = g;
              E(m.name + ": " + m.message);
            } else
              E(g);
          this.dispose(!0).catch(function(y) {
            i.Events.instance.onEvent(new i.BackgroundEvent(y));
          });
        }
      }, p.prototype.close = function() {
        var v, h;
        return t(this, void 0, void 0, function() {
          return r(this, function(E) {
            switch (E.label) {
              case 0:
                return o.Contracts.throwIfDisposed(this.privIsDisposed), (v = this.privConnection) === null || v === void 0 || v.closeConnection(), (h = this.privConnection) === null || h === void 0 || h.close(), this.privConnection = void 0, [4, this.dispose(!0)];
              case 1:
                return E.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, p.prototype.dispose = function(v) {
        return t(this, void 0, void 0, function() {
          return r(this, function(h) {
            switch (h.label) {
              case 0:
                return this.privIsDisposed ? [
                  2
                  /*return*/
                ] : v ? (this.privIsDisposed = !0, this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close(), this.privConnection = void 0), [4, d.prototype.dispose.call(this, v)]) : [3, 2];
              case 1:
                h.sent(), h.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, p.prototype.createRecognizerConfig = function(v) {
        return new n.RecognizerConfig(v, this.privProperties);
      }, p.prototype.createServiceRecognizer = function(v, h, E, m) {
        var g = E;
        return new s.ConversationServiceAdapter(v, h, g, m, this);
      }, p.prototype.sendMessage = function(v, h, E) {
        var m = this.privReco;
        c.PromiseToEmptyCallback(m.sendMessageAsync(v), h, E);
      }, p;
    }(a.Recognizer)
  );
  return q0.ConversationTranslatorRecognizer = f, q0;
}
var pg = {}, fae;
function _Tr() {
  if (fae) return pg;
  fae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var s = function(c, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var p in d) d.hasOwnProperty(p) && (f[p] = d[p]);
      }, s(c, l);
    };
    return function(c, l) {
      s(c, l);
      function f() {
        this.constructor = c;
      }
      c.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  }(), t = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, r = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(pg, "__esModule", { value: !0 }), pg.TranscriberRecognizer = void 0;
  var n = Ar(), i = tn(), o = Wt(), a = gr(), u = (
    /** @class */
    function(s) {
      e(c, s);
      function c(l, f) {
        var d = this, p = l;
        return i.Contracts.throwIfNull(p, "speechTranslationConfig"), i.Contracts.throwIfNullOrWhitespace(p.speechRecognitionLanguage, o.PropertyId[o.PropertyId.SpeechServiceConnection_RecoLanguage]), d = s.call(this, f, p.properties, new a.TranscriberConnectionFactory()) || this, d.privDisposedRecognizer = !1, d;
      }
      return c.prototype.getConversationInfo = function() {
        return i.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation"), this.privConversation.conversationInfo;
      }, Object.defineProperty(c.prototype, "authorizationToken", {
        get: function() {
          return this.properties.getProperty(o.PropertyId.SpeechServiceAuthorization_Token);
        },
        set: function(l) {
          i.Contracts.throwIfNullOrWhitespace(l, "token"), this.properties.setProperty(o.PropertyId.SpeechServiceAuthorization_Token, l);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "conversation", {
        set: function(l) {
          i.Contracts.throwIfNullOrUndefined(l, "Conversation"), this.privConversation = l;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "speechRecognitionLanguage", {
        get: function() {
          return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(o.PropertyId.SpeechServiceConnection_RecoLanguage);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(c.prototype, "properties", {
        get: function() {
          return this.privProperties;
        },
        enumerable: !1,
        configurable: !0
      }), c.prototype.startContinuousRecognitionAsync = function(l, f) {
        n.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(a.RecognitionMode.Conversation), l, f);
      }, c.prototype.stopContinuousRecognitionAsync = function(l, f) {
        n.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), l, f);
      }, c.prototype.close = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(l) {
            switch (l.label) {
              case 0:
                return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), [4, this.dispose(!0)];
              case 1:
                return l.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.pushConversationEvent = function(l, f) {
        return t(this, void 0, void 0, function() {
          var d;
          return r(this, function(p) {
            switch (p.label) {
              case 0:
                return d = this.privReco, i.Contracts.throwIfNullOrUndefined(d, "serviceRecognizer"), [4, d.sendSpeechEventAsync(l, f)];
              case 1:
                return p.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.connectCallbacks = function(l) {
        this.canceled = function(f, d) {
          l.canceled && l.canceled(l, d);
        }, this.recognizing = function(f, d) {
          l.transcribing && l.transcribing(l, d);
        }, this.recognized = function(f, d) {
          l.transcribed && l.transcribed(l, d);
        }, this.sessionStarted = function(f, d) {
          l.sessionStarted && l.sessionStarted(l, d);
        }, this.sessionStopped = function(f, d) {
          l.sessionStopped && l.sessionStopped(l, d);
        };
      }, c.prototype.disconnectCallbacks = function() {
        this.canceled = void 0, this.recognizing = void 0, this.recognized = void 0, this.sessionStarted = void 0, this.sessionStopped = void 0;
      }, c.prototype.dispose = function(l) {
        return t(this, void 0, void 0, function() {
          return r(this, function(f) {
            switch (f.label) {
              case 0:
                return this.privDisposedRecognizer ? [
                  2
                  /*return*/
                ] : l ? (this.privDisposedRecognizer = !0, [4, this.implRecognizerStop()]) : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return [4, s.prototype.dispose.call(this, l)];
              case 3:
                return f.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, c.prototype.createRecognizerConfig = function(l) {
        return new a.RecognizerConfig(l, this.properties);
      }, c.prototype.createServiceRecognizer = function(l, f, d, p) {
        var v = d;
        return new a.TranscriptionServiceRecognizer(l, f, v, p, this);
      }, c;
    }(o.Recognizer)
  );
  return pg.TranscriberRecognizer = u, pg;
}
var dae;
function ATr() {
  return dae || (dae = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t = fTr();
    Object.defineProperty(e, "ConversationManager", { enumerable: !0, get: function() {
      return t.ConversationManager;
    } });
    var r = $H();
    Object.defineProperty(e, "ConversationConnectionConfig", { enumerable: !0, get: function() {
      return r.ConversationConnectionConfig;
    } });
    var n = yTr();
    Object.defineProperty(e, "ConversationRecognizerFactory", { enumerable: !0, get: function() {
      return n.ConversationRecognizerFactory;
    } });
    var i = _Tr();
    Object.defineProperty(e, "TranscriberRecognizer", { enumerable: !0, get: function() {
      return i.TranscriberRecognizer;
    } });
    var o = v4e();
    Object.defineProperty(e, "ConversationReceivedTranslationEventArgs", { enumerable: !0, get: function() {
      return o.ConversationReceivedTranslationEventArgs;
    } }), Object.defineProperty(e, "LockRoomEventArgs", { enumerable: !0, get: function() {
      return o.LockRoomEventArgs;
    } }), Object.defineProperty(e, "MuteAllEventArgs", { enumerable: !0, get: function() {
      return o.MuteAllEventArgs;
    } }), Object.defineProperty(e, "ParticipantAttributeEventArgs", { enumerable: !0, get: function() {
      return o.ParticipantAttributeEventArgs;
    } }), Object.defineProperty(e, "ParticipantEventArgs", { enumerable: !0, get: function() {
      return o.ParticipantEventArgs;
    } }), Object.defineProperty(e, "ParticipantsListEventArgs", { enumerable: !0, get: function() {
      return o.ParticipantsListEventArgs;
    } });
    var a = E4e();
    Object.defineProperty(e, "ConversationTranslatorCommandTypes", { enumerable: !0, get: function() {
      return a.ConversationTranslatorCommandTypes;
    } }), Object.defineProperty(e, "ConversationTranslatorMessageTypes", { enumerable: !0, get: function() {
      return a.ConversationTranslatorMessageTypes;
    } }), Object.defineProperty(e, "InternalParticipants", { enumerable: !0, get: function() {
      return a.InternalParticipants;
    } });
  }(e5)), e5;
}
var r5 = {}, pae;
function STr() {
  return pae || (pae = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SynthesisAudioMetadata = e.MetadataType = void 0, function(r) {
      r.WordBoundary = "WordBoundary", r.Bookmark = "Bookmark", r.Viseme = "Viseme";
    }(e.MetadataType || (e.MetadataType = {}));
    var t = (
      /** @class */
      function() {
        function r(n) {
          this.privSynthesisAudioMetadata = JSON.parse(n);
        }
        return r.fromJSON = function(n) {
          return new r(n);
        }, Object.defineProperty(r.prototype, "Metadata", {
          get: function() {
            return this.privSynthesisAudioMetadata.Metadata;
          },
          enumerable: !1,
          configurable: !0
        }), r;
      }()
    );
    e.SynthesisAudioMetadata = t;
  }(r5)), r5;
}
var hg = {}, vg = {}, hae;
function m4e() {
  if (hae) return vg;
  hae = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(vg, "__esModule", { value: !0 }), vg.SynthesisAdapterBase = void 0;
  var r = Ar(), n = Wt(), i = gr(), o = e2(), a = (
    /** @class */
    function() {
      function u(s, c, l, f, d) {
        var p = this;
        if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSynthesisContext = function(v) {
          var h = p.synthesisContext.toJSON();
          if (h)
            return v.send(new o.SpeechConnectionMessage(r.MessageType.Text, "synthesis.context", p.privSynthesisTurn.requestId, "application/json", h));
        }, this.sendSpeechServiceConfig = function(v, h) {
          if (h)
            return v.send(new o.SpeechConnectionMessage(r.MessageType.Text, "speech.config", p.privSynthesisTurn.requestId, "application/json", h));
        }, this.sendSsmlMessage = function(v, h, E) {
          return v.send(new o.SpeechConnectionMessage(r.MessageType.Text, "ssml", E, "application/ssml+xml", h));
        }, !s)
          throw new r.ArgumentNullError("authentication");
        if (!c)
          throw new r.ArgumentNullError("connectionFactory");
        if (!l)
          throw new r.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = s, this.privConnectionFactory = c, this.privSynthesizerConfig = l, this.privIsDisposed = !1, this.privSpeechSynthesizer = f, this.privSessionAudioDestination = d, this.privSynthesisTurn = new i.SynthesisTurn(), this.privConnectionEvents = new r.EventSource(), this.privServiceEvents = new r.EventSource(), this.privSynthesisContext = new i.SynthesisContext(this.privSpeechSynthesizer), this.privAgentConfig = new i.AgentConfig(), this.connectionEvents.attach(function(v) {
          if (v.name === "ConnectionClosedEvent") {
            var h = v;
            h.statusCode !== 1e3 && p.cancelSynthesisLocal(n.CancellationReason.Error, h.statusCode === 1007 ? n.CancellationErrorCode.BadRequestParameters : n.CancellationErrorCode.ConnectionFailure, h.reason + " websocket error code: " + h.statusCode);
          }
        });
      }
      return Object.defineProperty(u.prototype, "synthesisContext", {
        get: function() {
          return this.privSynthesisContext;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "agentConfig", {
        get: function() {
          return this.privAgentConfig;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "connectionEvents", {
        get: function() {
          return this.privConnectionEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "serviceEvents", {
        get: function() {
          return this.privServiceEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "activityTemplate", {
        get: function() {
          return this.privActivityTemplate;
        },
        set: function(s) {
          this.privActivityTemplate = s;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "audioOutputFormat", {
        set: function(s) {
          this.privAudioOutputFormat = s, this.privSynthesisTurn.audioOutputFormat = s, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = s), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = s);
        },
        enumerable: !1,
        configurable: !0
      }), u.addHeader = function(s, c) {
        if (!c.hasHeader)
          return s;
        c.updateHeader(s.byteLength);
        var l = new Uint8Array(s.byteLength + c.header.byteLength);
        return l.set(new Uint8Array(c.header), 0), l.set(new Uint8Array(s), c.header.byteLength), l.buffer;
      }, u.prototype.isDisposed = function() {
        return this.privIsDisposed;
      }, u.prototype.dispose = function(s) {
        return e(this, void 0, void 0, function() {
          var c;
          return t(this, function(l) {
            switch (l.label) {
              case 0:
                return this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise ? [4, this.privConnectionConfigurationPromise] : [3, 3];
              case 1:
                return c = l.sent(), [4, c.dispose(s)];
              case 2:
                l.sent(), l.label = 3;
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.connect = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return [4, this.connectImpl()];
              case 1:
                return s.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.sendNetworkMessage = function(s, c) {
        return e(this, void 0, void 0, function() {
          var l, f, d;
          return t(this, function(p) {
            switch (p.label) {
              case 0:
                return l = typeof c == "string" ? r.MessageType.Text : r.MessageType.Binary, f = typeof c == "string" ? "application/json" : "", [4, this.fetchConnection()];
              case 1:
                return d = p.sent(), [2, d.send(new o.SpeechConnectionMessage(l, s, this.privSynthesisTurn.requestId, f, c))];
            }
          });
        });
      }, u.prototype.Speak = function(s, c, l, f, d, p) {
        return e(this, void 0, void 0, function() {
          var v, h, E, m;
          return t(this, function(g) {
            switch (g.label) {
              case 0:
                if (c ? v = s : v = this.privSpeechSynthesizer.buildSsml(s), this.speakOverride !== void 0)
                  return [2, this.speakOverride(v, l, f, d)];
                this.privSuccessCallback = f, this.privErrorCallback = d, this.privSynthesisTurn.startNewSynthesis(l, s, c, p), g.label = 1;
              case 1:
                return g.trys.push([1, 6, , 7]), [4, this.connectImpl()];
              case 2:
                return g.sent(), [4, this.fetchConnection()];
              case 3:
                return h = g.sent(), [4, this.sendSynthesisContext(h)];
              case 4:
                return g.sent(), [4, this.sendSsmlMessage(h, v, l)];
              case 5:
                return g.sent(), E = new n.SpeechSynthesisEventArgs(new n.SpeechSynthesisResult(l, n.ResultReason.SynthesizingAudioStarted)), this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, E), this.receiveMessage(), [3, 7];
              case 6:
                return m = g.sent(), this.cancelSynthesisLocal(n.CancellationReason.Error, n.CancellationErrorCode.ConnectionFailure, m), [2, Promise.reject(m)];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.cancelSynthesis = function(s, c, l, f) {
        var d = new n.PropertyCollection();
        d.setProperty(i.CancellationErrorCodePropertyName, n.CancellationErrorCode[l]);
        var p = new n.SpeechSynthesisResult(s, n.ResultReason.Canceled, void 0, f, d);
        if (this.privSpeechSynthesizer.SynthesisCanceled) {
          var v = new n.SpeechSynthesisEventArgs(p);
          try {
            this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, v);
          } catch {
          }
        }
        if (this.privSuccessCallback)
          try {
            this.privSuccessCallback(p);
          } catch {
          }
      }, u.prototype.cancelSynthesisLocal = function(s, c, l) {
        this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, s, c, l));
      }, u.prototype.processTypeSpecificMessages = function(s, c, l) {
        return !0;
      }, u.prototype.receiveMessage = function() {
        return e(this, void 0, void 0, function() {
          var s, c, l, f, d, p, v, h, E, m, g, y, _, S, A, O;
          return t(this, function(P) {
            switch (P.label) {
              case 0:
                return P.trys.push([0, 14, , 15]), [4, this.fetchConnection()];
              case 1:
                return s = P.sent(), [4, s.read()];
              case 2:
                if (c = P.sent(), this.receiveMessageOverride !== void 0)
                  return [2, this.receiveMessageOverride()];
                if (this.privIsDisposed)
                  return [
                    2
                    /*return*/
                  ];
                if (!c)
                  return this.privSynthesisTurn.isSynthesizing ? [2, this.receiveMessage()] : [
                    2
                    /*return*/
                  ];
                if (this.privServiceHasSentMessage = !0, l = o.SpeechConnectionMessage.fromConnectionMessage(c), l.requestId.toLowerCase() !== this.privSynthesisTurn.requestId.toLowerCase()) return [3, 13];
                switch (f = l.path.toLowerCase(), f) {
                  case "turn.start":
                    return [3, 3];
                  case "response":
                    return [3, 4];
                  case "audio":
                    return [3, 5];
                  case "audio.metadata":
                    return [3, 6];
                  case "turn.end":
                    return [3, 7];
                }
                return [3, 12];
              case 3:
                return this.privSynthesisTurn.onServiceTurnStartResponse(), [3, 13];
              case 4:
                return this.privSynthesisTurn.onServiceResponseMessage(l.textBody), [3, 13];
              case 5:
                if (this.privSynthesisTurn.streamId.toLowerCase() === l.streamId.toLowerCase() && l.binaryBody) {
                  if (this.privSynthesisTurn.onAudioChunkReceived(l.binaryBody), this.privSpeechSynthesizer.synthesizing)
                    try {
                      d = u.addHeader(l.binaryBody, this.privSynthesisTurn.audioOutputFormat), p = new n.SpeechSynthesisEventArgs(new n.SpeechSynthesisResult(this.privSynthesisTurn.requestId, n.ResultReason.SynthesizingAudio, d)), this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, p);
                    } catch {
                    }
                  this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(l.binaryBody);
                }
                return [3, 13];
              case 6:
                for (v = i.SynthesisAudioMetadata.fromJSON(l.textBody).Metadata, h = 0, E = v; h < E.length; h++)
                  switch (m = E[h], m.Type) {
                    case i.MetadataType.WordBoundary:
                      if (this.privSynthesisTurn.onWordBoundaryEvent(m.Data.text.Text), g = new n.SpeechSynthesisWordBoundaryEventArgs(m.Data.Offset, m.Data.text.Text, m.Data.text.Length, this.privSynthesisTurn.currentTextOffset), this.privSpeechSynthesizer.wordBoundary)
                        try {
                          this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, g);
                        } catch {
                        }
                      break;
                    case i.MetadataType.Bookmark:
                      if (y = new n.SpeechSynthesisBookmarkEventArgs(m.Data.Offset, m.Data.Bookmark), this.privSpeechSynthesizer.bookmarkReached)
                        try {
                          this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, y);
                        } catch {
                        }
                      break;
                    case i.MetadataType.Viseme:
                      if (this.privSynthesisTurn.onVisemeMetadataReceived(m), m.Data.IsLastAnimation && (_ = new n.SpeechSynthesisVisemeEventArgs(m.Data.Offset, m.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation()), this.privSpeechSynthesizer.visemeReceived))
                        try {
                          this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, _);
                        } catch {
                        }
                      break;
                  }
                return [3, 13];
              case 7:
                this.privSynthesisTurn.onServiceTurnEndResponse(), S = void 0, P.label = 8;
              case 8:
                return P.trys.push([8, 10, , 11]), [4, this.privSynthesisTurn.getAllReceivedAudioWithHeader()];
              case 9:
                return A = P.sent(), S = new n.SpeechSynthesisResult(this.privSynthesisTurn.requestId, n.ResultReason.SynthesizingAudioCompleted, A), this.privSuccessCallback && this.privSuccessCallback(S), [3, 11];
              case 10:
                return O = P.sent(), this.privErrorCallback && this.privErrorCallback(O), [3, 11];
              case 11:
                if (this.privSpeechSynthesizer.synthesisCompleted)
                  try {
                    this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new n.SpeechSynthesisEventArgs(S));
                  } catch {
                  }
                return [3, 13];
              case 12:
                this.processTypeSpecificMessages(l) || this.privServiceEvents && this.serviceEvents.onEvent(new r.ServiceEvent(l.path.toLowerCase(), l.textBody)), P.label = 13;
              case 13:
                return [2, this.receiveMessage()];
              case 14:
                return P.sent(), [3, 15];
              case 15:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.connectImpl = function(s) {
        var c = this;
        if (s === void 0 && (s = !1), this.privConnectionPromise)
          return this.privConnectionPromise.then(function(f) {
            return f.state() === r.ConnectionState.Disconnected ? (c.privConnectionId = null, c.privConnectionPromise = null, c.privServiceHasSentMessage = !1, c.connectImpl()) : c.privConnectionPromise;
          }, function(f) {
            return c.privConnectionId = null, c.privConnectionPromise = null, c.privServiceHasSentMessage = !1, c.connectImpl();
          });
        this.privAuthFetchEventId = r.createNoDashGuid(), this.privConnectionId = r.createNoDashGuid(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        var l = s ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        return this.privConnectionPromise = l.then(function(f) {
          return e(c, void 0, void 0, function() {
            var d, p, v = this;
            return t(this, function(h) {
              switch (h.label) {
                case 0:
                  return [4, this.privSynthesisTurn.onAuthCompleted(!1)];
                case 1:
                  return h.sent(), d = this.privConnectionFactory.create(this.privSynthesizerConfig, f, this.privConnectionId), d.events.attach(function(E) {
                    v.connectionEvents.onEvent(E);
                  }), [4, d.open()];
                case 2:
                  return p = h.sent(), p.statusCode !== 200 ? [3, 4] : [4, this.privSynthesisTurn.onConnectionEstablishCompleted(p.statusCode)];
                case 3:
                  return h.sent(), [2, Promise.resolve(d)];
                case 4:
                  return p.statusCode === 403 && !s ? [2, this.connectImpl(!0)] : [3, 5];
                case 5:
                  return [4, this.privSynthesisTurn.onConnectionEstablishCompleted(p.statusCode, p.reason)];
                case 6:
                  return h.sent(), [2, Promise.reject("Unable to contact server. StatusCode: " + p.statusCode + ", " + this.privSynthesizerConfig.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Endpoint) + " Reason: " + p.reason)];
              }
            });
          });
        }, function(f) {
          return e(c, void 0, void 0, function() {
            return t(this, function(d) {
              switch (d.label) {
                case 0:
                  return [4, this.privSynthesisTurn.onAuthCompleted(!0, f)];
                case 1:
                  throw d.sent(), new Error(f);
              }
            });
          });
        }), this.privConnectionPromise.catch(function() {
        }), this.privConnectionPromise;
      }, u.prototype.fetchConnection = function() {
        return e(this, void 0, void 0, function() {
          var s = this;
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return this.privConnectionConfigurationPromise ? [2, this.privConnectionConfigurationPromise.then(function(l) {
                  return l.state() === r.ConnectionState.Disconnected ? (s.privConnectionId = null, s.privConnectionConfigurationPromise = null, s.privServiceHasSentMessage = !1, s.fetchConnection()) : s.privConnectionConfigurationPromise;
                }, function(l) {
                  return s.privConnectionId = null, s.privConnectionConfigurationPromise = null, s.privServiceHasSentMessage = !1, s.fetchConnection();
                })] : (this.privConnectionConfigurationPromise = this.configureConnection(), [4, this.privConnectionConfigurationPromise]);
              case 1:
                return [2, c.sent()];
            }
          });
        });
      }, u.prototype.configureConnection = function() {
        return e(this, void 0, void 0, function() {
          var s;
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, this.connectImpl()];
              case 1:
                return s = c.sent(), this.configConnectionOverride !== void 0 ? [2, this.configConnectionOverride(s)] : [4, this.sendSpeechServiceConfig(s, this.privSynthesizerConfig.SpeechServiceConfig.serialize())];
              case 2:
                return c.sent(), [2, s];
            }
          });
        });
      }, u.telemetryDataEnabled = !0, u;
    }()
  );
  return vg.SynthesisAdapterBase = a, vg;
}
var rs = {}, vae;
function bTr() {
  if (vae) return rs;
  vae = 1;
  var e = fe && fe.__extends || /* @__PURE__ */ function() {
    var a = function(u, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
        c.__proto__ = l;
      } || function(c, l) {
        for (var f in l) l.hasOwnProperty(f) && (c[f] = l[f]);
      }, a(u, s);
    };
    return function(u, s) {
      a(u, s);
      function c() {
        this.constructor = u;
      }
      u.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
    };
  }();
  Object.defineProperty(rs, "__esModule", { value: !0 }), rs.SynthesisStartedEvent = rs.ConnectingToSynthesisServiceEvent = rs.SynthesisTriggeredEvent = rs.SpeechSynthesisEvent = void 0;
  var t = Ar(), r = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c, l) {
        l === void 0 && (l = t.EventType.Info);
        var f = a.call(this, s, l) || this;
        return f.privRequestId = c, f;
      }
      return Object.defineProperty(u.prototype, "requestId", {
        get: function() {
          return this.privRequestId;
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(t.PlatformEvent)
  );
  rs.SpeechSynthesisEvent = r;
  var n = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c, l) {
        var f = a.call(this, "SynthesisTriggeredEvent", s) || this;
        return f.privSessionAudioDestinationId = c, f.privTurnAudioDestinationId = l, f;
      }
      return Object.defineProperty(u.prototype, "audioSessionDestinationId", {
        get: function() {
          return this.privSessionAudioDestinationId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "audioTurnDestinationId", {
        get: function() {
          return this.privTurnAudioDestinationId;
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(r)
  );
  rs.SynthesisTriggeredEvent = n;
  var i = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c) {
        var l = a.call(this, "ConnectingToSynthesisServiceEvent", s) || this;
        return l.privAuthFetchEventId = c, l;
      }
      return Object.defineProperty(u.prototype, "authFetchEventId", {
        get: function() {
          return this.privAuthFetchEventId;
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(r)
  );
  rs.ConnectingToSynthesisServiceEvent = i;
  var o = (
    /** @class */
    function(a) {
      e(u, a);
      function u(s, c) {
        var l = a.call(this, "SynthesisStartedEvent", s) || this;
        return l.privAuthFetchEventId = c, l;
      }
      return Object.defineProperty(u.prototype, "authFetchEventId", {
        get: function() {
          return this.privAuthFetchEventId;
        },
        enumerable: !1,
        configurable: !0
      }), u;
    }(r)
  );
  return rs.SynthesisStartedEvent = o, rs;
}
var Eae;
function CTr() {
  if (Eae) return hg;
  Eae = 1;
  var e = fe && fe.__awaiter || function(u, s, c, l) {
    function f(d) {
      return d instanceof c ? d : new c(function(p) {
        p(d);
      });
    }
    return new (c || (c = Promise))(function(d, p) {
      function v(m) {
        try {
          E(l.next(m));
        } catch (g) {
          p(g);
        }
      }
      function h(m) {
        try {
          E(l.throw(m));
        } catch (g) {
          p(g);
        }
      }
      function E(m) {
        m.done ? d(m.value) : f(m.value).then(v, h);
      }
      E((l = l.apply(u, s || [])).next());
    });
  }, t = fe && fe.__generator || function(u, s) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, f, d, p;
    return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function v(E) {
      return function(m) {
        return h([E, m]);
      };
    }
    function h(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
        switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, f = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = s.call(u, c);
      } catch (m) {
        E = [6, m], f = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(hg, "__esModule", { value: !0 }), hg.SynthesisTurn = void 0;
  var r = Ar(), n = Qh(), i = m4e(), o = bTr(), a = (
    /** @class */
    function() {
      function u() {
        var s = this;
        this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.onPreConnectionStart = function(c, l) {
          s.privAuthFetchEventId = c, s.onEvent(new o.ConnectingToSynthesisServiceEvent(s.privRequestId, s.privAuthFetchEventId));
        }, this.onAuthCompleted = function(c, l) {
          c && s.onComplete();
        }, this.onConnectionEstablishCompleted = function(c, l) {
          if (c === 200) {
            s.onEvent(new o.SynthesisStartedEvent(s.requestId, s.privAuthFetchEventId)), s.privBytesReceived = 0;
            return;
          } else c === 403 && s.onComplete();
        }, this.onServiceResponseMessage = function(c) {
          var l = JSON.parse(c);
          s.streamId = l.audio.streamId;
        }, this.onServiceTurnEndResponse = function() {
          s.privInTurn = !1, s.privTurnDeferral.resolve(), s.onComplete();
        }, this.onServiceTurnStartResponse = function() {
          s.privTurnDeferral && s.privInTurn && (s.privTurnDeferral.reject("Another turn started before current completed."), s.privTurnDeferral.promise.then().catch(function() {
          })), s.privInTurn = !0, s.privTurnDeferral = new r.Deferred();
        }, this.dispose = function(c) {
          s.privIsDisposed || (s.privIsDisposed = !0);
        }, this.onEvent = function(c) {
          r.Events.instance.onEvent(c);
        }, this.onComplete = function() {
          s.privIsSynthesizing && (s.privIsSynthesizing = !1, s.privIsSynthesisEnded = !0, s.privAudioOutputStream.close(), s.privInTurn = !1, s.privTurnAudioDestination !== void 0 && (s.privTurnAudioDestination.close(), s.privTurnAudioDestination = void 0));
        }, this.privRequestId = r.createNoDashGuid(), this.privTurnDeferral = new r.Deferred(), this.privTurnDeferral.resolve();
      }
      return Object.defineProperty(u.prototype, "requestId", {
        get: function() {
          return this.privRequestId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "streamId", {
        get: function() {
          return this.privStreamId;
        },
        set: function(s) {
          this.privStreamId = s;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "audioOutputFormat", {
        get: function() {
          return this.privAudioOutputFormat;
        },
        set: function(s) {
          this.privAudioOutputFormat = s;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "turnCompletionPromise", {
        get: function() {
          return this.privTurnDeferral.promise;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "isSynthesisEnded", {
        get: function() {
          return this.privIsSynthesisEnded;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "isSynthesizing", {
        get: function() {
          return this.privIsSynthesizing;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "currentTextOffset", {
        get: function() {
          return this.privTextOffset;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(u.prototype, "bytesReceived", {
        // The number of bytes received for current turn
        get: function() {
          return this.privBytesReceived;
        },
        enumerable: !1,
        configurable: !0
      }), u.prototype.getAllReceivedAudio = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return this.privReceivedAudio ? [2, Promise.resolve(this.privReceivedAudio)] : this.privIsSynthesisEnded ? [4, this.readAllAudioFromStream()] : [2, null];
              case 1:
                return s.sent(), [2, Promise.resolve(this.privReceivedAudio)];
            }
          });
        });
      }, u.prototype.getAllReceivedAudioWithHeader = function() {
        return e(this, void 0, void 0, function() {
          var s;
          return t(this, function(c) {
            switch (c.label) {
              case 0:
                return this.privReceivedAudioWithHeader ? [2, this.privReceivedAudioWithHeader] : this.privIsSynthesisEnded ? this.audioOutputFormat.hasHeader ? [4, this.getAllReceivedAudio()] : [3, 2] : [2, null];
              case 1:
                return s = c.sent(), this.privReceivedAudioWithHeader = i.SynthesisAdapterBase.addHeader(s, this.audioOutputFormat), [2, this.privReceivedAudioWithHeader];
              case 2:
                return [2, this.getAllReceivedAudio()];
            }
          });
        });
      }, u.prototype.startNewSynthesis = function(s, c, l, f) {
        this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = s, this.privRawText = c, this.privIsSSML = l, this.privAudioOutputStream = new n.PullAudioOutputStreamImpl(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privPartialVisemeAnimation = "", f !== void 0 && (this.privTurnAudioDestination = f, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new o.SynthesisTriggeredEvent(this.requestId, void 0, f === void 0 ? void 0 : f.id()));
      }, u.prototype.onAudioChunkReceived = function(s) {
        this.isSynthesizing && (this.privAudioOutputStream.write(s), this.privBytesReceived += s.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(s));
      }, u.prototype.onWordBoundaryEvent = function(s) {
        this.updateTextOffset(s);
      }, u.prototype.onVisemeMetadataReceived = function(s) {
        s.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += s.Data.AnimationChunk);
      }, u.prototype.onStopSynthesizing = function() {
        this.onComplete();
      }, u.prototype.getAndClearVisemeAnimation = function() {
        var s = this.privPartialVisemeAnimation;
        return this.privPartialVisemeAnimation = "", s;
      }, u.prototype.updateTextOffset = function(s) {
        this.privTextOffset >= 0 && (this.privTextOffset = this.privRawText.indexOf(s, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + s.length), this.privIsSSML && this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1) && this.updateTextOffset(s));
      }, u.prototype.readAllAudioFromStream = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                if (!this.privIsSynthesisEnded) return [3, 4];
                this.privReceivedAudio = new ArrayBuffer(this.bytesReceived), s.label = 1;
              case 1:
                return s.trys.push([1, 3, , 4]), [4, this.privAudioOutputStream.read(this.privReceivedAudio)];
              case 2:
                return s.sent(), [3, 4];
              case 3:
                return s.sent(), this.privReceivedAudio = new ArrayBuffer(0), [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u;
    }()
  );
  return hg.SynthesisTurn = a, hg;
}
var n5 = {}, mae;
function ITr() {
  return mae || (mae = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SynthesizerConfig = e.SynthesisServiceType = void 0;
    var t = gr(), r;
    (function(i) {
      i[i.Standard = 0] = "Standard", i[i.Custom = 1] = "Custom";
    })(r = e.SynthesisServiceType || (e.SynthesisServiceType = {}));
    var n = (
      /** @class */
      function() {
        function i(o, a) {
          this.privSynthesisServiceType = r.Standard, this.privSpeechServiceConfig = o || new t.SpeechServiceConfig(new t.Context(null)), this.privParameters = a;
        }
        return Object.defineProperty(i.prototype, "parameters", {
          get: function() {
            return this.privParameters;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(i.prototype, "synthesisServiceType", {
          get: function() {
            return this.privSynthesisServiceType;
          },
          set: function(o) {
            this.privSynthesisServiceType = o;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(i.prototype, "SpeechServiceConfig", {
          get: function() {
            return this.privSpeechServiceConfig;
          },
          enumerable: !1,
          configurable: !0
        }), i;
      }()
    );
    e.SynthesizerConfig = n;
  }(n5)), n5;
}
var Eg = {}, gae;
function OTr() {
  if (gae) return Eg;
  gae = 1, Object.defineProperty(Eg, "__esModule", { value: !0 }), Eg.SynthesisContext = void 0;
  var e = (
    /** @class */
    function() {
      function t(r) {
        this.privContext = {}, this.privSpeechSynthesizer = r;
      }
      return t.prototype.setSection = function(r, n) {
        this.privContext[r] = n;
      }, Object.defineProperty(t.prototype, "audioOutputFormat", {
        /**
         * Sets the audio output format for synthesis context generation.
         * @param format {AudioOutputFormatImpl} the output format
         */
        set: function(r) {
          this.privAudioOutputFormat = r;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.toJSON = function() {
        var r = this.buildSynthesisContext();
        return this.setSection("synthesis", r), JSON.stringify(this.privContext);
      }, t.prototype.buildSynthesisContext = function() {
        return {
          audio: {
            metadataOptions: {
              bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
              sentenceBoundaryEnabled: !1,
              visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
              wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary
            },
            outputFormat: this.privAudioOutputFormat.requestAudioFormatString
          },
          language: {
            autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
          }
        };
      }, t;
    }()
  );
  return Eg.SynthesisContext = e, Eg;
}
var mg = {}, Tae;
function RTr() {
  if (Tae) return mg;
  Tae = 1, Object.defineProperty(mg, "__esModule", { value: !0 }), mg.SpeakerRecognitionConfig = void 0;
  var e = gr(), t = (
    /** @class */
    function() {
      function r(n, i) {
        this.privContext = n || new e.Context(null), this.privParameters = i;
      }
      return Object.defineProperty(r.prototype, "parameters", {
        get: function() {
          return this.privParameters;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Context", {
        get: function() {
          return this.privContext;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return mg.SpeakerRecognitionConfig = t, mg;
}
var gg = {}, yae;
function wTr() {
  if (yae) return gg;
  yae = 1;
  var e = fe && fe.__awaiter || function(o, a, u, s) {
    function c(l) {
      return l instanceof u ? l : new u(function(f) {
        f(l);
      });
    }
    return new (u || (u = Promise))(function(l, f) {
      function d(h) {
        try {
          v(s.next(h));
        } catch (E) {
          f(E);
        }
      }
      function p(h) {
        try {
          v(s.throw(h));
        } catch (E) {
          f(E);
        }
      }
      function v(h) {
        h.done ? l(h.value) : c(h.value).then(d, p);
      }
      v((s = s.apply(o, a || [])).next());
    });
  }, t = fe && fe.__generator || function(o, a) {
    var u = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, s, c, l, f;
    return f = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
      return this;
    }), f;
    function d(v) {
      return function(h) {
        return p([v, h]);
      };
    }
    function p(v) {
      if (s) throw new TypeError("Generator is already executing.");
      for (; u; ) try {
        if (s = 1, c && (l = v[0] & 2 ? c.return : v[0] ? c.throw || ((l = c.return) && l.call(c), 0) : c.next) && !(l = l.call(c, v[1])).done) return l;
        switch (c = 0, l && (v = [v[0] & 2, l.value]), v[0]) {
          case 0:
          case 1:
            l = v;
            break;
          case 4:
            return u.label++, { value: v[1], done: !1 };
          case 5:
            u.label++, c = v[1], v = [0];
            continue;
          case 7:
            v = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (l = u.trys, !(l = l.length > 0 && l[l.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              u = 0;
              continue;
            }
            if (v[0] === 3 && (!l || v[1] > l[0] && v[1] < l[3])) {
              u.label = v[1];
              break;
            }
            if (v[0] === 6 && u.label < l[1]) {
              u.label = l[1], l = v;
              break;
            }
            if (l && u.label < l[2]) {
              u.label = l[2], u.ops.push(v);
              break;
            }
            l[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        v = a.call(o, u);
      } catch (h) {
        v = [6, h], c = 0;
      } finally {
        s = l = 0;
      }
      if (v[0] & 5) throw v[1];
      return { value: v[0] ? v[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(gg, "__esModule", { value: !0 }), gg.SpeakerIdMessageAdapter = void 0;
  var r = Yu(), n = Wt(), i = (
    /** @class */
    function() {
      function o(a) {
        var u = a.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Endpoint, void 0);
        if (!u) {
          var s = a.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Region, "westus"), c = s && s.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", l = a.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Host, "https://" + s + ".api.cognitive" + c + "/speaker/{mode}/v2.0/{dependency}");
          u = l + "/profiles";
        }
        this.privUri = u;
        var f = r.RestConfigBase.requestOptions;
        f.headers[r.RestConfigBase.configParams.subscriptionKey] = a.parameters.getProperty(n.PropertyId.SpeechServiceConnection_Key, void 0), this.privRestAdapter = new r.RestMessageAdapter(f);
      }
      return o.prototype.createProfile = function(a, u) {
        var s = this.getOperationUri(a);
        return this.privRestAdapter.setHeaders(r.RestConfigBase.configParams.contentTypeKey, "application/json"), this.privRestAdapter.request(r.RestRequestType.Post, s, {}, { locale: u });
      }, o.prototype.createEnrollment = function(a, u) {
        var s = this;
        this.privRestAdapter.setHeaders(r.RestConfigBase.configParams.contentTypeKey, "multipart/form-data");
        var c = this.getOperationUri(a.profileType) + "/" + a.profileId + "/enrollments";
        return u.blob.then(function(l) {
          return s.privRestAdapter.request(r.RestRequestType.File, c, { ignoreMinLength: "true" }, null, l);
        });
      }, o.prototype.verifySpeaker = function(a, u) {
        return e(this, void 0, void 0, function() {
          var s, c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                this.privRestAdapter.setHeaders(r.RestConfigBase.configParams.contentTypeKey, "multipart/form-data"), s = this.getOperationUri(a.voiceProfile.profileType) + "/" + a.voiceProfile.profileId + "/verify", f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, u.blob];
              case 2:
                return c = f.sent(), [2, this.privRestAdapter.request(r.RestRequestType.File, s, { ignoreMinLength: "true" }, null, c)];
              case 3:
                return l = f.sent(), [2, Promise.resolve({ data: l })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, o.prototype.identifySpeaker = function(a, u) {
        return e(this, void 0, void 0, function() {
          var s, c, l;
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                this.privRestAdapter.setHeaders(r.RestConfigBase.configParams.contentTypeKey, "multipart/form-data"), s = this.getOperationUri(n.VoiceProfileType.TextIndependentIdentification) + "/identifySingleSpeaker", f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, u.blob];
              case 2:
                return c = f.sent(), [2, this.privRestAdapter.request(r.RestRequestType.File, s, { profileIds: a.voiceProfileIds, ignoreMinLength: "true" }, null, c)];
              case 3:
                return l = f.sent(), [2, Promise.resolve({ data: l })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, o.prototype.getProfileStatus = function(a) {
        var u = this.getOperationUri(a.profileType) + "/" + a.profileId;
        return this.privRestAdapter.request(r.RestRequestType.Get, u, {});
      }, o.prototype.getProfiles = function(a) {
        var u = this.getOperationUri(a);
        return this.privRestAdapter.request(r.RestRequestType.Get, u, {});
      }, o.prototype.getAuthorizationPhrases = function(a) {
        var u = ("" + this.getOperationUri(n.VoiceProfileType.TextDependentVerification)).replace("profiles", "phrases") + "/" + a;
        return this.privRestAdapter.request(r.RestRequestType.Get, u, {});
      }, o.prototype.deleteProfile = function(a) {
        var u = this.getOperationUri(a.profileType) + "/" + a.profileId;
        return this.privRestAdapter.request(r.RestRequestType.Delete, u, {});
      }, o.prototype.resetProfile = function(a) {
        var u = this.getOperationUri(a.profileType) + "/" + a.profileId + "/reset";
        return this.privRestAdapter.request(r.RestRequestType.Post, u, {});
      }, o.prototype.getOperationUri = function(a) {
        var u = a === n.VoiceProfileType.TextIndependentIdentification ? "identification" : "verification", s = a === n.VoiceProfileType.TextDependentVerification ? "text-dependent" : "text-independent";
        return this.privUri.replace("{mode}", u).replace("{dependency}", s);
      }, o;
    }()
  );
  return gg.SpeakerIdMessageAdapter = i, gg;
}
var _ae;
function gr() {
  return _ae || (_ae = 1, function(e) {
    var t = fe && fe.__createBinding || (Object.create ? function(n, i, o, a) {
      a === void 0 && (a = o), Object.defineProperty(n, a, { enumerable: !0, get: function() {
        return i[o];
      } });
    } : function(n, i, o, a) {
      a === void 0 && (a = o), n[a] = i[o];
    }), r = fe && fe.__exportStar || function(n, i) {
      for (var o in n) o !== "default" && !i.hasOwnProperty(o) && t(i, n, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.AutoDetectSourceLanguagesOpenRangeOptionName = e.ForceDictationPropertyName = e.ServicePropertiesPropertyName = e.CancellationErrorCodePropertyName = e.OutputFormatPropertyName = void 0, r(Qmr(), e), r(egr(), e), r(LH(), e), r(tgr(), e), r(rgr(), e), r(D1r(), e), r(FH(), e), r(x1r(), e), r(N1r(), e), r(L1r(), e), r(B1r(), e), r(k1r(), e), r(M1r(), e), r(F1r(), e), r(H1r(), e), r($1r(), e), r(U1r(), e), r(V1r(), e), r(j1r(), e), r(z1r(), e), r(q1r(), e), r(Y1r(), e), r(G1r(), e), r(W1r(), e), r(K1r(), e), r(X1r(), e), r(J1r(), e), r(Z1r(), e), r(Q1r(), e), r(eTr(), e), r(tTr(), e), r(nTr(), e), r(iTr(), e), r(oTr(), e), r(aTr(), e), r(cTr(), e), r(lTr(), e), r(ATr(), e), r(STr(), e), r(CTr(), e), r(m4e(), e), r(ITr(), e), r(OTr(), e), r(RTr(), e), r(wTr(), e), e.OutputFormatPropertyName = "OutputFormat", e.CancellationErrorCodePropertyName = "CancellationErrorCode", e.ServicePropertiesPropertyName = "ServiceProperties", e.ForceDictationPropertyName = "ForceDictation", e.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";
  }(ON)), ON;
}
var Aae;
function PTr() {
  return Aae || (Aae = 1, function(e) {
    var t = fe && fe.__awaiter || function(u, s, c, l) {
      function f(d) {
        return d instanceof c ? d : new c(function(p) {
          p(d);
        });
      }
      return new (c || (c = Promise))(function(d, p) {
        function v(m) {
          try {
            E(l.next(m));
          } catch (g) {
            p(g);
          }
        }
        function h(m) {
          try {
            E(l.throw(m));
          } catch (g) {
            p(g);
          }
        }
        function E(m) {
          m.done ? d(m.value) : f(m.value).then(v, h);
        }
        E((l = l.apply(u, s || [])).next());
      });
    }, r = fe && fe.__generator || function(u, s) {
      var c = { label: 0, sent: function() {
        if (d[0] & 1) throw d[1];
        return d[1];
      }, trys: [], ops: [] }, l, f, d, p;
      return p = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
        return this;
      }), p;
      function v(E) {
        return function(m) {
          return h([E, m]);
        };
      }
      function h(E) {
        if (l) throw new TypeError("Generator is already executing.");
        for (; c; ) try {
          if (l = 1, f && (d = E[0] & 2 ? f.return : E[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, E[1])).done) return d;
          switch (f = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
            case 0:
            case 1:
              d = E;
              break;
            case 4:
              return c.label++, { value: E[1], done: !1 };
            case 5:
              c.label++, f = E[1], E = [0];
              continue;
            case 7:
              E = c.ops.pop(), c.trys.pop();
              continue;
            default:
              if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
                c = 0;
                continue;
              }
              if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
                c.label = E[1];
                break;
              }
              if (E[0] === 6 && c.label < d[1]) {
                c.label = d[1], d = E;
                break;
              }
              if (d && c.label < d[2]) {
                c.label = d[2], c.ops.push(E);
                break;
              }
              d[2] && c.ops.pop(), c.trys.pop();
              continue;
          }
          E = s.call(u, c);
        } catch (m) {
          E = [6, m], f = 0;
        } finally {
          l = d = 0;
        }
        if (E[0] & 5) throw E[1];
        return { value: E[0] ? E[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MicAudioSource = e.AudioWorkletSourceURLPropertyName = void 0;
    var n = gr(), i = Ar(), o = Td();
    e.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
    var a = (
      /** @class */
      function() {
        function u(s, c, l, f) {
          var d = this;
          this.privRecorder = s, this.deviceId = c, this.privStreams = {}, this.turnOn = function() {
            if (d.privInitializeDeferral)
              return d.privInitializeDeferral.promise;
            d.privInitializeDeferral = new i.Deferred();
            try {
              d.createAudioContext();
            } catch (g) {
              if (g instanceof Error) {
                var p = g;
                d.privInitializeDeferral.reject(p.name + ": " + p.message);
              } else
                d.privInitializeDeferral.reject(g);
              return d.privInitializeDeferral.promise;
            }
            var v = window.navigator, h = v.getUserMedia || v.webkitGetUserMedia || v.mozGetUserMedia || v.msGetUserMedia;
            if (v.mediaDevices && (h = function(g, y, _) {
              v.mediaDevices.getUserMedia(g).then(y).catch(_);
            }), h) {
              var m = function() {
                d.onEvent(new i.AudioSourceInitializingEvent(d.privId)), d.privMediaStream && d.privMediaStream.active ? (d.onEvent(new i.AudioSourceReadyEvent(d.privId)), d.privInitializeDeferral.resolve()) : h({ audio: d.deviceId ? { deviceId: d.deviceId } : !0, video: !1 }, function(g) {
                  d.privMediaStream = g, d.onEvent(new i.AudioSourceReadyEvent(d.privId)), d.privInitializeDeferral.resolve();
                }, function(g) {
                  var y = "Error occurred during microphone initialization: " + g;
                  d.privInitializeDeferral.reject(y), d.onEvent(new i.AudioSourceErrorEvent(d.privId, y));
                });
              };
              d.privContext.state === "suspended" ? d.privContext.resume().then(m).catch(function(g) {
                d.privInitializeDeferral.reject("Failed to initialize audio context: " + g);
              }) : m();
            } else {
              var E = "Browser does not support getUserMedia.";
              d.privInitializeDeferral.reject(E), d.onEvent(new i.AudioSourceErrorEvent(E, ""));
            }
            return d.privInitializeDeferral.promise;
          }, this.id = function() {
            return d.privId;
          }, this.attach = function(p) {
            return d.onEvent(new i.AudioStreamNodeAttachingEvent(d.privId, p)), d.listen(p).then(function(v) {
              return d.onEvent(new i.AudioStreamNodeAttachedEvent(d.privId, p)), {
                detach: function() {
                  return t(d, void 0, void 0, function() {
                    return r(this, function(h) {
                      return v.readEnded(), delete this.privStreams[p], this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, p)), [2, this.turnOff()];
                    });
                  });
                },
                id: function() {
                  return p;
                },
                read: function() {
                  return v.read();
                }
              };
            });
          }, this.detach = function(p) {
            p && d.privStreams[p] && (d.privStreams[p].close(), delete d.privStreams[p], d.onEvent(new i.AudioStreamNodeDetachedEvent(d.privId, p)));
          }, this.listen = function(p) {
            return t(d, void 0, void 0, function() {
              var v, h;
              return r(this, function(E) {
                switch (E.label) {
                  case 0:
                    return [4, this.turnOn()];
                  case 1:
                    E.sent(), v = new i.ChunkedArrayBufferStream(this.privOutputChunkSize, p), this.privStreams[p] = v;
                    try {
                      this.privRecorder.record(this.privContext, this.privMediaStream, v);
                    } catch (m) {
                      throw this.onEvent(new i.AudioStreamNodeErrorEvent(this.privId, p, m)), m;
                    }
                    return h = v, [2, h];
                }
              });
            });
          }, this.onEvent = function(p) {
            d.privEvents.onEvent(p), i.Events.instance.onEvent(p);
          }, this.createAudioContext = function() {
            d.privContext || (d.privContext = o.AudioStreamFormatImpl.getAudioContext(u.AUDIOFORMAT.samplesPerSec));
          }, this.privOutputChunkSize = u.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = l || i.createNoDashGuid(), this.privEvents = new i.EventSource(), this.privMediaStream = f || null;
        }
        return Object.defineProperty(u.prototype, "format", {
          get: function() {
            return Promise.resolve(u.AUDIOFORMAT);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "blob", {
          get: function() {
            return Promise.reject("Not implemented for Mic input");
          },
          enumerable: !1,
          configurable: !0
        }), u.prototype.turnOff = function() {
          return t(this, void 0, void 0, function() {
            var s, c;
            return r(this, function(l) {
              switch (l.label) {
                case 0:
                  for (s in this.privStreams)
                    s && (c = this.privStreams[s], c && c.close());
                  return this.onEvent(new i.AudioSourceOffEvent(this.privId)), this.privInitializeDeferral ? [4, this.privInitializeDeferral] : [3, 2];
                case 1:
                  l.sent(), this.privInitializeDeferral = null, l.label = 2;
                case 2:
                  return [4, this.destroyAudioContext()];
                case 3:
                  return l.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, Object.defineProperty(u.prototype, "events", {
          get: function() {
            return this.privEvents;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(u.prototype, "deviceInfo", {
          get: function() {
            return this.getMicrophoneLabel().then(function(s) {
              return {
                bitspersample: u.AUDIOFORMAT.bitsPerSample,
                channelcount: u.AUDIOFORMAT.channels,
                connectivity: n.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: s,
                samplerate: u.AUDIOFORMAT.samplesPerSec,
                type: n.type.Microphones
              };
            });
          },
          enumerable: !1,
          configurable: !0
        }), u.prototype.setProperty = function(s, c) {
          if (s === e.AudioWorkletSourceURLPropertyName)
            this.privRecorder.setWorkletUrl(c);
          else
            throw new Error("Property '" + s + "' is not supported on Microphone.");
        }, u.prototype.getMicrophoneLabel = function() {
          var s = this, c = "microphone";
          if (this.privMicrophoneLabel !== void 0)
            return Promise.resolve(this.privMicrophoneLabel);
          if (this.privMediaStream === void 0 || !this.privMediaStream.active)
            return Promise.resolve(c);
          this.privMicrophoneLabel = c;
          var l = this.privMediaStream.getTracks()[0].getSettings().deviceId;
          if (l === void 0)
            return Promise.resolve(this.privMicrophoneLabel);
          var f = new i.Deferred();
          return navigator.mediaDevices.enumerateDevices().then(function(d) {
            for (var p = 0, v = d; p < v.length; p++) {
              var h = v[p];
              if (h.deviceId === l) {
                s.privMicrophoneLabel = h.label;
                break;
              }
            }
            f.resolve(s.privMicrophoneLabel);
          }, function() {
            return f.resolve(s.privMicrophoneLabel);
          }), f.promise;
        }, u.prototype.destroyAudioContext = function() {
          return t(this, void 0, void 0, function() {
            var s;
            return r(this, function(c) {
              switch (c.label) {
                case 0:
                  return this.privContext ? (this.privRecorder.releaseMediaResources(this.privContext), s = !1, "close" in this.privContext && (s = !0), s ? [4, this.privContext.close()] : [3, 2]) : [
                    2
                    /*return*/
                  ];
                case 1:
                  return c.sent(), this.privContext = null, [3, 4];
                case 2:
                  return this.privContext !== null && this.privContext.state === "running" ? [4, this.privContext.suspend()] : [3, 4];
                case 3:
                  c.sent(), c.label = 4;
                case 4:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, u.AUDIOFORMAT = o.AudioStreamFormat.getDefaultInputFormat(), u;
      }()
    );
    e.MicAudioSource = a;
  }(IN)), IN;
}
var Tg = {}, Sae;
function DTr() {
  if (Sae) return Tg;
  Sae = 1;
  var e = fe && fe.__awaiter || function(a, u, s, c) {
    function l(f) {
      return f instanceof s ? f : new s(function(d) {
        d(f);
      });
    }
    return new (s || (s = Promise))(function(f, d) {
      function p(E) {
        try {
          h(c.next(E));
        } catch (m) {
          d(m);
        }
      }
      function v(E) {
        try {
          h(c.throw(E));
        } catch (m) {
          d(m);
        }
      }
      function h(E) {
        E.done ? f(E.value) : l(E.value).then(p, v);
      }
      h((c = c.apply(a, u || [])).next());
    });
  }, t = fe && fe.__generator || function(a, u) {
    var s = { label: 0, sent: function() {
      if (f[0] & 1) throw f[1];
      return f[1];
    }, trys: [], ops: [] }, c, l, f, d;
    return d = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
      return this;
    }), d;
    function p(h) {
      return function(E) {
        return v([h, E]);
      };
    }
    function v(h) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; s; ) try {
        if (c = 1, l && (f = h[0] & 2 ? l.return : h[0] ? l.throw || ((f = l.return) && f.call(l), 0) : l.next) && !(f = f.call(l, h[1])).done) return f;
        switch (l = 0, f && (h = [h[0] & 2, f.value]), h[0]) {
          case 0:
          case 1:
            f = h;
            break;
          case 4:
            return s.label++, { value: h[1], done: !1 };
          case 5:
            s.label++, l = h[1], h = [0];
            continue;
          case 7:
            h = s.ops.pop(), s.trys.pop();
            continue;
          default:
            if (f = s.trys, !(f = f.length > 0 && f[f.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              s = 0;
              continue;
            }
            if (h[0] === 3 && (!f || h[1] > f[0] && h[1] < f[3])) {
              s.label = h[1];
              break;
            }
            if (h[0] === 6 && s.label < f[1]) {
              s.label = f[1], f = h;
              break;
            }
            if (f && s.label < f[2]) {
              s.label = f[2], s.ops.push(h);
              break;
            }
            f[2] && s.ops.pop(), s.trys.pop();
            continue;
        }
        h = u.call(a, s);
      } catch (E) {
        h = [6, E], l = 0;
      } finally {
        c = f = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Tg, "__esModule", { value: !0 }), Tg.FileAudioSource = void 0;
  var r = gr(), n = Ar(), i = Td(), o = (
    /** @class */
    function() {
      function a(u, s, c) {
        var l = this;
        this.privStreams = {}, this.privHeaderEnd = 44, this.turnOn = function() {
          if (l.privFilename.lastIndexOf(".wav") !== l.privFilename.length - 4) {
            var f = l.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            return l.onEvent(new n.AudioSourceErrorEvent(f, "")), Promise.reject(f);
          }
          l.onEvent(new n.AudioSourceInitializingEvent(l.privId)), l.onEvent(new n.AudioSourceReadyEvent(l.privId));
        }, this.id = function() {
          return l.privId;
        }, this.attach = function(f) {
          return e(l, void 0, void 0, function() {
            var d, p = this;
            return t(this, function(v) {
              switch (v.label) {
                case 0:
                  return this.onEvent(new n.AudioStreamNodeAttachingEvent(this.privId, f)), [4, this.upload(f)];
                case 1:
                  return d = v.sent(), this.onEvent(new n.AudioStreamNodeAttachedEvent(this.privId, f)), [2, Promise.resolve({
                    detach: function() {
                      return e(p, void 0, void 0, function() {
                        return t(this, function(h) {
                          switch (h.label) {
                            case 0:
                              return d.readEnded(), delete this.privStreams[f], this.onEvent(new n.AudioStreamNodeDetachedEvent(this.privId, f)), [4, this.turnOff()];
                            case 1:
                              return h.sent(), [
                                2
                                /*return*/
                              ];
                          }
                        });
                      });
                    },
                    id: function() {
                      return f;
                    },
                    read: function() {
                      return d.read();
                    }
                  })];
              }
            });
          });
        }, this.detach = function(f) {
          f && l.privStreams[f] && (l.privStreams[f].close(), delete l.privStreams[f], l.onEvent(new n.AudioStreamNodeDetachedEvent(l.privId, f)));
        }, this.turnOff = function() {
          for (var f in l.privStreams)
            if (f) {
              var d = l.privStreams[f];
              d && !d.isClosed && d.close();
            }
          return l.onEvent(new n.AudioSourceOffEvent(l.privId)), Promise.resolve();
        }, this.onEvent = function(f) {
          l.privEvents.onEvent(f), n.Events.instance.onEvent(f);
        }, this.privId = c || n.createNoDashGuid(), this.privEvents = new n.EventSource(), this.privSource = u, typeof window < "u" && typeof Blob < "u" && this.privSource instanceof Blob ? this.privFilename = u.name : this.privFilename = s || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
      }
      return Object.defineProperty(a.prototype, "format", {
        get: function() {
          return this.privAudioFormatPromise;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "blob", {
        get: function() {
          return Promise.resolve(this.privSource);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "events", {
        get: function() {
          return this.privEvents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(a.prototype, "deviceInfo", {
        get: function() {
          return this.privAudioFormatPromise.then(function(u) {
            return Promise.resolve({
              bitspersample: u.bitsPerSample,
              channelcount: u.channels,
              connectivity: r.connectivity.Unknown,
              manufacturer: "Speech SDK",
              model: "File",
              samplerate: u.samplesPerSec,
              type: r.type.File
            });
          });
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.readHeader = function() {
        var u = this, s = 512, c = this.privSource.slice(0, s), l = new n.Deferred(), f = function(v) {
          var h = new DataView(v), E = function(A) {
            return String.fromCharCode(h.getUint8(A), h.getUint8(A + 1), h.getUint8(A + 2), h.getUint8(A + 3));
          };
          if (E(0) !== "RIFF") {
            l.reject("Invalid WAV header in file, RIFF was not found");
            return;
          }
          if (E(8) !== "WAVE" || E(12) !== "fmt ") {
            l.reject("Invalid WAV header in file, WAVEfmt was not found");
            return;
          }
          for (var m = h.getInt32(16, !0), g = h.getUint16(22, !0), y = h.getUint32(24, !0), _ = h.getUint16(34, !0), S = 36 + Math.max(m - 16, 0); E(S) !== "data"; S += 2)
            if (S > s - 8) {
              l.reject("Invalid WAV header in file, data block was not found");
              return;
            }
          u.privHeaderEnd = S + 8, l.resolve(i.AudioStreamFormat.getWaveFormatPCM(y, _, g));
        };
        if (typeof window < "u" && typeof Blob < "u" && c instanceof Blob) {
          var d = new FileReader();
          d.onload = function(v) {
            var h = v.target.result;
            f(h);
          }, d.readAsArrayBuffer(c);
        } else {
          var p = c;
          f(p.buffer.slice(p.byteOffset, p.byteOffset + p.byteLength));
        }
        return l.promise;
      }, a.prototype.upload = function(u) {
        return e(this, void 0, void 0, function() {
          var s, c, l, f, d, p, v, h, E = this;
          return t(this, function(m) {
            switch (m.label) {
              case 0:
                s = function(g) {
                  var y = "Error occurred while processing '" + E.privFilename + "'. " + g;
                  throw E.onEvent(new n.AudioStreamNodeErrorEvent(E.privId, u, y)), new Error(y);
                }, m.label = 1;
              case 1:
                return m.trys.push([1, 4, , 5]), [4, this.turnOn()];
              case 2:
                return m.sent(), [4, this.privAudioFormatPromise];
              case 3:
                return c = m.sent(), l = new n.ChunkedArrayBufferStream(c.avgBytesPerSec / 10, u), this.privStreams[u] = l, f = this.privSource.slice(this.privHeaderEnd), d = function(g) {
                  l.isClosed || (l.writeStreamChunk({
                    buffer: g,
                    isEnd: !1,
                    timeReceived: Date.now()
                  }), l.close());
                }, typeof window < "u" && typeof Blob < "u" && f instanceof Blob ? (p = new FileReader(), p.onerror = function(g) {
                  s(g.toString());
                }, p.onload = function(g) {
                  var y = g.target.result;
                  d(y);
                }, p.readAsArrayBuffer(f)) : (v = f, d(v.buffer.slice(v.byteOffset, v.byteOffset + v.byteLength))), [2, l];
              case 4:
                return h = m.sent(), s(h), [3, 5];
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a;
    }()
  );
  return Tg.FileAudioSource = o, Tg;
}
var yg = {}, bae;
function xTr() {
  if (bae) return yg;
  bae = 1, Object.defineProperty(yg, "__esModule", { value: !0 }), yg.PcmRecorder = void 0;
  var e = Ar(), t = (
    /** @class */
    function() {
      function r() {
        var n = this;
        this.record = function(i, o, a) {
          var u = 16e3, s = function() {
            var f = 0;
            try {
              return i.createScriptProcessor(f, 1, 1);
            } catch {
              f = 2048;
              for (var d = i.sampleRate; f < 16384 && d >= 2 * u; )
                f <<= 1, d >>= 1;
              return i.createScriptProcessor(f, 1, 1);
            }
          }(), c = new e.RiffPcmEncoder(i.sampleRate, u);
          s.onaudioprocess = function(f) {
            var d = f.inputBuffer.getChannelData(0);
            if (a && !a.isClosed) {
              var p = c.encode(d);
              p && a.writeStreamChunk({
                buffer: p,
                isEnd: !1,
                timeReceived: Date.now()
              });
            }
          };
          var l = i.createMediaStreamSource(o);
          n.privSpeechProcessorScript && i.audioWorklet ? i.audioWorklet.addModule(n.privSpeechProcessorScript).then(function() {
            var f = new AudioWorkletNode(i, "speech-processor");
            f.port.onmessage = function(d) {
              var p = d.data;
              if (a && !a.isClosed) {
                var v = c.encode(p);
                v && a.writeStreamChunk({
                  buffer: v,
                  isEnd: !1,
                  timeReceived: Date.now()
                });
              }
            }, l.connect(f), f.connect(i.destination), n.privMediaResources = {
              scriptProcessorNode: f,
              source: l,
              stream: o
            };
          }).catch(function() {
            l.connect(s), s.connect(i.destination), n.privMediaResources = {
              scriptProcessorNode: s,
              source: l,
              stream: o
            };
          }) : (l.connect(s), s.connect(i.destination), n.privMediaResources = {
            scriptProcessorNode: s,
            source: l,
            stream: o
          });
        }, this.releaseMediaResources = function(i) {
          n.privMediaResources && (n.privMediaResources.scriptProcessorNode && (n.privMediaResources.scriptProcessorNode.disconnect(i.destination), n.privMediaResources.scriptProcessorNode = null), n.privMediaResources.source && (n.privMediaResources.source.disconnect(), n.privMediaResources.stream.getTracks().forEach(function(o) {
            return o.stop();
          }), n.privMediaResources.source = null));
        };
      }
      return r.prototype.setWorkletUrl = function(n) {
        this.privSpeechProcessorScript = n;
      }, r;
    }()
  );
  return yg.PcmRecorder = t, yg;
}
var _g = {}, Ag = {}, Sg = {}, Cae;
function NTr() {
  if (Cae) return Sg;
  Cae = 1;
  var e = fe && fe.__assign || function() {
    return e = Object.assign || function(m) {
      for (var g, y = 1, _ = arguments.length; y < _; y++) {
        g = arguments[y];
        for (var S in g) Object.prototype.hasOwnProperty.call(g, S) && (m[S] = g[S]);
      }
      return m;
    }, e.apply(this, arguments);
  }, t = fe && fe.__createBinding || (Object.create ? function(m, g, y, _) {
    _ === void 0 && (_ = y), Object.defineProperty(m, _, { enumerable: !0, get: function() {
      return g[y];
    } });
  } : function(m, g, y, _) {
    _ === void 0 && (_ = y), m[_] = g[y];
  }), r = fe && fe.__setModuleDefault || (Object.create ? function(m, g) {
    Object.defineProperty(m, "default", { enumerable: !0, value: g });
  } : function(m, g) {
    m.default = g;
  }), n = fe && fe.__importStar || function(m) {
    if (m && m.__esModule) return m;
    var g = {};
    if (m != null) for (var y in m) y !== "default" && Object.hasOwnProperty.call(m, y) && t(g, m, y);
    return r(g, m), g;
  }, i = fe && fe.__awaiter || function(m, g, y, _) {
    function S(A) {
      return A instanceof y ? A : new y(function(O) {
        O(A);
      });
    }
    return new (y || (y = Promise))(function(A, O) {
      function P(k) {
        try {
          z(_.next(k));
        } catch (H) {
          O(H);
        }
      }
      function U(k) {
        try {
          z(_.throw(k));
        } catch (H) {
          O(H);
        }
      }
      function z(k) {
        k.done ? A(k.value) : S(k.value).then(P, U);
      }
      z((_ = _.apply(m, g || [])).next());
    });
  }, o = fe && fe.__generator || function(m, g) {
    var y = { label: 0, sent: function() {
      if (A[0] & 1) throw A[1];
      return A[1];
    }, trys: [], ops: [] }, _, S, A, O;
    return O = { next: P(0), throw: P(1), return: P(2) }, typeof Symbol == "function" && (O[Symbol.iterator] = function() {
      return this;
    }), O;
    function P(z) {
      return function(k) {
        return U([z, k]);
      };
    }
    function U(z) {
      if (_) throw new TypeError("Generator is already executing.");
      for (; y; ) try {
        if (_ = 1, S && (A = z[0] & 2 ? S.return : z[0] ? S.throw || ((A = S.return) && A.call(S), 0) : S.next) && !(A = A.call(S, z[1])).done) return A;
        switch (S = 0, A && (z = [z[0] & 2, A.value]), z[0]) {
          case 0:
          case 1:
            A = z;
            break;
          case 4:
            return y.label++, { value: z[1], done: !1 };
          case 5:
            y.label++, S = z[1], z = [0];
            continue;
          case 7:
            z = y.ops.pop(), y.trys.pop();
            continue;
          default:
            if (A = y.trys, !(A = A.length > 0 && A[A.length - 1]) && (z[0] === 6 || z[0] === 2)) {
              y = 0;
              continue;
            }
            if (z[0] === 3 && (!A || z[1] > A[0] && z[1] < A[3])) {
              y.label = z[1];
              break;
            }
            if (z[0] === 6 && y.label < A[1]) {
              y.label = A[1], A = z;
              break;
            }
            if (A && y.label < A[2]) {
              y.label = A[2], y.ops.push(z);
              break;
            }
            A[2] && y.ops.pop(), y.trys.pop();
            continue;
        }
        z = g.call(m, y);
      } catch (k) {
        z = [6, k], S = 0;
      } finally {
        _ = A = 0;
      }
      if (z[0] & 5) throw z[1];
      return { value: z[0] ? z[1] : void 0, done: !0 };
    }
  }, a = fe && fe.__importDefault || function(m) {
    return m && m.__esModule ? m : { default: m };
  };
  Object.defineProperty(Sg, "__esModule", { value: !0 }), Sg.CertCheckAgent = void 0;
  var u = n(ki), s = n(dAe), c = n(ki), l = Ar(), f = a(ki), d = a(ki), p = a(ki), v = n(ki), h = r4e(), E = (
    /** @class */
    function() {
      function m(g) {
        g && (this.privProxyInfo = g), m.privDiskCache || (m.privDiskCache = new d.default("microsoft-cognitiveservices-speech-sdk-cache", { supportBuffer: !0, location: typeof process < "u" && process.env.SPEECH_OCSP_CACHE_ROOT ? process.env.SPEECH_OCSP_CACHE_ROOT : void 0 }));
      }
      return m.forceReinitDiskCache = function() {
        m.privDiskCache = void 0, m.privMemCache = {};
      }, m.prototype.GetAgent = function(g) {
        var y = new f.default.Agent(this.CreateConnection);
        if (this.privProxyInfo !== void 0 && this.privProxyInfo.HostName !== void 0 && this.privProxyInfo.Port > 0) {
          var _ = "privProxyInfo";
          y[_] = this.privProxyInfo;
        }
        return y;
      }, m.GetProxyAgent = function(g) {
        var y = {
          host: g.HostName,
          port: g.Port
        };
        g.UserName ? y.headers = {
          "Proxy-Authentication": "Basic " + new Buffer(g.UserName + ":" + (g.Password === void 0) ? "" : g.Password).toString("base64")
        } : y.headers = {}, y.headers.requestOCSP = "true";
        var _ = new p.default(y);
        return _;
      }, m.OCSPCheck = function(g, y) {
        return i(this, void 0, void 0, function() {
          var _, S, A, O, P, U = this;
          return o(this, function(z) {
            switch (z.label) {
              case 0:
                return A = !1, [4, g];
              case 1:
                return O = z.sent(), O.cork(), P = O, [2, new Promise(function(k, H) {
                  O.on("OCSPResponse", function(B) {
                    B && (U.onEvent(new l.OCSPStapleReceivedEvent()), S = B);
                  }), O.on("error", function(B) {
                    A || (A = !0, O.destroy(), H(B));
                  }), P.on("secure", function() {
                    return i(U, void 0, void 0, function() {
                      var B, x, D, w, $;
                      return o(this, function(X) {
                        switch (X.label) {
                          case 0:
                            B = P.getPeerCertificate(!0), X.label = 1;
                          case 1:
                            return X.trys.push([1, 6, , 7]), [4, this.GetIssuer(B)];
                          case 2:
                            return x = X.sent(), _ = c.request.generate(B.raw, x.raw), D = _.id.toString("hex"), S ? [3, 4] : [4, m.GetResponseFromCache(D, _, y)];
                          case 3:
                            w = X.sent(), S = w, X.label = 4;
                          case 4:
                            return [4, this.VerifyOCSPResponse(S, _, y)];
                          case 5:
                            return X.sent(), O.uncork(), A = !0, k(O), [3, 7];
                          case 6:
                            return $ = X.sent(), O.destroy(), A = !0, H($), [3, 7];
                          case 7:
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  });
                })];
            }
          });
        });
      }, m.GetIssuer = function(g) {
        return g.issuerCertificate ? Promise.resolve(g.issuerCertificate) : new Promise(function(y, _) {
          var S = new c.Agent({});
          S.fetchIssuer(g, null, function(A, O) {
            if (A) {
              _(A);
              return;
            }
            y(O);
          });
        });
      }, m.GetResponseFromCache = function(g, y, _) {
        return i(this, void 0, void 0, function() {
          var S, A, O, P, U, z, k, H = this;
          return o(this, function(B) {
            switch (B.label) {
              case 0:
                if (S = m.privMemCache[g], S && this.onEvent(new l.OCSPMemoryCacheHitEvent(g)), S) return [3, 4];
                B.label = 1;
              case 1:
                return B.trys.push([1, 3, , 4]), [4, m.privDiskCache.get(g)];
              case 2:
                return A = B.sent(), A.isCached && (m.onEvent(new l.OCSPDiskCacheHitEvent(g)), m.StoreMemoryCacheEntry(g, A.value), S = A.value), [3, 4];
              case 3:
                return B.sent(), S = null, [3, 4];
              case 4:
                if (!S)
                  return [2, S];
                try {
                  if (O = c.utils.parseResponse(S), P = O.value.tbsResponseData, P.responses.length < 1)
                    return this.onEvent(new l.OCSPCacheFetchErrorEvent(g, "Not enough data in cached response")), [
                      2
                      /*return*/
                    ];
                  U = P.responses[0].thisUpdate, z = P.responses[0].nextUpdate, z < Date.now() + this.testTimeOffset - 6e4 ? (this.onEvent(new l.OCSPCacheEntryExpiredEvent(g, z)), S = null) : (k = Math.min(24 * 60 * 60 * 1e3, (z - U) / 2), z - (Date.now() + this.testTimeOffset) < k ? (this.onEvent(new l.OCSPCacheEntryNeedsRefreshEvent(g, U, z)), this.UpdateCache(y, _).catch(function(x) {
                    H.onEvent(new h.OCSPCacheUpdateErrorEvent(g, x.toString()));
                  })) : this.onEvent(new l.OCSPCacheHitEvent(g, U, z)));
                } catch (x) {
                  this.onEvent(new l.OCSPCacheFetchErrorEvent(g, x)), S = null;
                }
                return S || this.onEvent(new l.OCSPCacheMissEvent(g)), [2, S];
            }
          });
        });
      }, m.VerifyOCSPResponse = function(g, y, _) {
        return i(this, void 0, void 0, function() {
          var S, A = this;
          return o(this, function(O) {
            switch (O.label) {
              case 0:
                return S = g, y.certID.toString("hex"), S ? [3, 2] : [4, m.GetOCSPResponse(y, _)];
              case 1:
                S = O.sent(), O.label = 2;
              case 2:
                return [2, new Promise(function(P, U) {
                  c.verify({ request: y, response: S }, function(z, k) {
                    z ? (m.onEvent(new l.OCSPVerificationFailedEvent(y.id.toString("hex"), z)), g ? A.VerifyOCSPResponse(null, y, _).then(function() {
                      P();
                    }, function(H) {
                      U(H);
                    }) : U(z)) : (g || m.StoreCacheEntry(y.id.toString("hex"), S), P());
                  });
                })];
            }
          });
        });
      }, m.UpdateCache = function(g, y) {
        return i(this, void 0, void 0, function() {
          var _, S;
          return o(this, function(A) {
            switch (A.label) {
              case 0:
                return _ = g.id.toString("hex"), this.onEvent(new l.OCSPCacheUpdateNeededEvent(_)), [4, this.GetOCSPResponse(g, y)];
              case 1:
                return S = A.sent(), this.StoreCacheEntry(_, S), this.onEvent(new l.OCSPCacheUpdatehCompleteEvent(g.id.toString("hex"))), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, m.StoreCacheEntry = function(g, y) {
        this.StoreMemoryCacheEntry(g, y), this.StoreDiskCacheEntry(g, y);
      }, m.StoreMemoryCacheEntry = function(g, y) {
        this.privMemCache[g] = y, this.onEvent(new l.OCSPMemoryCacheStoreEvent(g));
      }, m.StoreDiskCacheEntry = function(g, y) {
        var _ = this;
        this.privDiskCache.set(g, y).then(function() {
          _.onEvent(new l.OCSPDiskCacheStoreEvent(g));
        });
      }, m.GetOCSPResponse = function(g, y) {
        var _ = this, S = "1.3.6.1.5.5.7.48.1", A = {};
        if (y) {
          var O = m.GetProxyAgent(y);
          A.agent = O;
        }
        return new Promise(function(P, U) {
          c.utils.getAuthorityInfo(g.cert, S, function(z, k) {
            if (z) {
              U(z);
              return;
            }
            var H = s.default(k);
            H.path = H.pathname, A = e(e({}, A), H), c.utils.getResponse(A, g.data, function(B, x) {
              if (B) {
                U(B);
                return;
              }
              _.onEvent(new l.OCSPResponseRetrievedEvent(g.certID.toString("hex"))), P(x);
            });
          });
        });
      }, m.prototype.CreateConnection = function(g, y) {
        var _ = typeof process < "u" && process.env.NODE_TLS_REJECT_UNAUTHORIZED !== "0" && process.env.SPEECH_CONDUCT_OCSP_CHECK !== "0" && y.secureEndpoint, S;
        if (y = e(e({}, y), {
          requestOCSP: !m.forceDisableOCSPStapling,
          servername: y.host
        }), this.privProxyInfo) {
          var A = m.GetProxyAgent(this.privProxyInfo), O = A;
          S = new Promise(function(P, U) {
            O.callback(g, y, function(z, k) {
              z ? U(z) : P(k);
            });
          });
        } else
          y.secureEndpoint ? S = Promise.resolve(u.connect(y)) : S = Promise.resolve(v.connect(y));
        return _ ? m.OCSPCheck(S, this.privProxyInfo) : S;
      }, m.testTimeOffset = 0, m.forceDisableOCSPStapling = !1, m.privMemCache = {}, m.onEvent = function(g) {
        l.Events.instance.onEvent(g);
      }, m;
    }()
  );
  return Sg.CertCheckAgent = E, Sg;
}
var Iae;
function g4e() {
  if (Iae) return Ag;
  Iae = 1;
  var e = fe && fe.__awaiter || function(s, c, l, f) {
    function d(p) {
      return p instanceof l ? p : new l(function(v) {
        v(p);
      });
    }
    return new (l || (l = Promise))(function(p, v) {
      function h(g) {
        try {
          m(f.next(g));
        } catch (y) {
          v(y);
        }
      }
      function E(g) {
        try {
          m(f.throw(g));
        } catch (y) {
          v(y);
        }
      }
      function m(g) {
        g.done ? p(g.value) : d(g.value).then(h, E);
      }
      m((f = f.apply(s, c || [])).next());
    });
  }, t = fe && fe.__generator || function(s, c) {
    var l = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, d, p, v;
    return v = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function h(m) {
      return function(g) {
        return E([m, g]);
      };
    }
    function E(m) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l; ) try {
        if (f = 1, d && (p = m[0] & 2 ? d.return : m[0] ? d.throw || ((p = d.return) && p.call(d), 0) : d.next) && !(p = p.call(d, m[1])).done) return p;
        switch (d = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return l.label++, { value: m[1], done: !1 };
          case 5:
            l.label++, d = m[1], m = [0];
            continue;
          case 7:
            m = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (p = l.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              l = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              l.label = m[1];
              break;
            }
            if (m[0] === 6 && l.label < p[1]) {
              l.label = p[1], p = m;
              break;
            }
            if (p && l.label < p[2]) {
              l.label = p[2], l.ops.push(m);
              break;
            }
            p[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        m = c.call(s, l);
      } catch (g) {
        m = [6, g], d = 0;
      } finally {
        f = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  }, r = fe && fe.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Ag, "__esModule", { value: !0 }), Ag.WebsocketMessageAdapter = void 0;
  var n = vc(), i = Ar(), o = r(ki), a = NTr(), u = (
    /** @class */
    function() {
      function s(c, l, f, d, p, v) {
        var h = this;
        if (this.open = function() {
          if (h.privConnectionState === i.ConnectionState.Disconnected)
            return Promise.reject("Cannot open a connection that is in " + h.privConnectionState + " state");
          if (h.privConnectionEstablishDeferral)
            return h.privConnectionEstablishDeferral.promise;
          h.privConnectionEstablishDeferral = new i.Deferred(), h.privCertificateValidatedDeferral = new i.Deferred(), h.privConnectionState = i.ConnectionState.Connecting;
          try {
            if (typeof WebSocket < "u" && !s.forceNpmWebSocket)
              h.privCertificateValidatedDeferral.resolve(), h.privWebsocketClient = new WebSocket(h.privUri);
            else {
              var E = { headers: h.privHeaders, perMessageDeflate: h.privEnableCompression };
              h.privCertificateValidatedDeferral.resolve();
              var m = new a.CertCheckAgent(h.proxyInfo);
              E.agent = m.GetAgent(), h.privWebsocketClient = new o.default(h.privUri, E);
            }
            h.privWebsocketClient.binaryType = "arraybuffer", h.privReceivingMessageQueue = new i.Queue(), h.privDisconnectDeferral = new i.Deferred(), h.privSendMessageQueue = new i.Queue(), h.processSendQueue().catch(function(g) {
              i.Events.instance.onEvent(new i.BackgroundEvent(g));
            });
          } catch (g) {
            return h.privConnectionEstablishDeferral.resolve(new i.ConnectionOpenResponse(500, g)), h.privConnectionEstablishDeferral.promise;
          }
          return h.onEvent(new i.ConnectionStartEvent(h.privConnectionId, h.privUri)), h.privWebsocketClient.onopen = function(g) {
            h.privCertificateValidatedDeferral.promise.then(function() {
              h.privConnectionState = i.ConnectionState.Connected, h.onEvent(new i.ConnectionEstablishedEvent(h.privConnectionId)), h.privConnectionEstablishDeferral.resolve(new i.ConnectionOpenResponse(200, ""));
            }, function(y) {
              h.privConnectionEstablishDeferral.reject(y);
            });
          }, h.privWebsocketClient.onerror = function(g) {
            h.onEvent(new i.ConnectionErrorEvent(h.privConnectionId, g.message, g.type)), h.privLastErrorReceived = g.message;
          }, h.privWebsocketClient.onclose = function(g) {
            h.privConnectionState === i.ConnectionState.Connecting ? (h.privConnectionState = i.ConnectionState.Disconnected, h.privConnectionEstablishDeferral.resolve(new i.ConnectionOpenResponse(g.code, g.reason + " " + h.privLastErrorReceived))) : (h.privConnectionState = i.ConnectionState.Disconnected, h.privWebsocketClient = null, h.onEvent(new i.ConnectionClosedEvent(h.privConnectionId, g.code, g.reason))), h.onClose(g.code, g.reason).catch(function(y) {
              i.Events.instance.onEvent(new i.BackgroundEvent(y));
            });
          }, h.privWebsocketClient.onmessage = function(g) {
            var y = (/* @__PURE__ */ new Date()).toISOString();
            if (h.privConnectionState === i.ConnectionState.Connected) {
              var _ = new i.Deferred();
              if (h.privReceivingMessageQueue.enqueueFromPromise(_.promise), g.data instanceof ArrayBuffer) {
                var S = new i.RawWebsocketMessage(i.MessageType.Binary, g.data);
                h.privMessageFormatter.toConnectionMessage(S).then(function(A) {
                  h.onEvent(new i.ConnectionMessageReceivedEvent(h.privConnectionId, y, A)), _.resolve(A);
                }, function(A) {
                  _.reject("Invalid binary message format. Error: " + A);
                });
              } else {
                var S = new i.RawWebsocketMessage(i.MessageType.Text, g.data);
                h.privMessageFormatter.toConnectionMessage(S).then(function(O) {
                  h.onEvent(new i.ConnectionMessageReceivedEvent(h.privConnectionId, y, O)), _.resolve(O);
                }, function(O) {
                  _.reject("Invalid text message format. Error: " + O);
                });
              }
            }
          }, h.privConnectionEstablishDeferral.promise;
        }, this.send = function(E) {
          if (h.privConnectionState !== i.ConnectionState.Connected)
            return Promise.reject("Cannot send on connection that is in " + i.ConnectionState[h.privConnectionState] + " state");
          var m = new i.Deferred(), g = new i.Deferred();
          return h.privSendMessageQueue.enqueueFromPromise(g.promise), h.privMessageFormatter.fromConnectionMessage(E).then(function(y) {
            g.resolve({
              Message: E,
              RawWebsocketMessage: y,
              sendStatusDeferral: m
            });
          }, function(y) {
            g.reject("Error formatting the message. " + y);
          }), m.promise;
        }, this.read = function() {
          return h.privConnectionState !== i.ConnectionState.Connected ? Promise.reject("Cannot read on connection that is in " + h.privConnectionState + " state") : h.privReceivingMessageQueue.dequeue();
        }, this.close = function(E) {
          if (h.privWebsocketClient)
            h.privConnectionState !== i.ConnectionState.Disconnected && h.privWebsocketClient.close(1e3, E || "Normal closure by client");
          else
            return Promise.resolve();
          return h.privDisconnectDeferral.promise;
        }, this.sendRawMessage = function(E) {
          try {
            if (!E)
              return Promise.resolve();
            if (h.onEvent(new i.ConnectionMessageSentEvent(h.privConnectionId, (/* @__PURE__ */ new Date()).toISOString(), E.Message)), h.isWebsocketOpen)
              h.privWebsocketClient.send(E.RawWebsocketMessage.payload);
            else
              return Promise.reject("websocket send error: Websocket not ready " + h.privConnectionId + " " + E.Message.id + " " + new Error().stack);
            return Promise.resolve();
          } catch (m) {
            return Promise.reject("websocket send error: " + m);
          }
        }, this.onEvent = function(E) {
          h.privConnectionEvents.onEvent(E), i.Events.instance.onEvent(E);
        }, !c)
          throw new i.ArgumentNullError("uri");
        if (!f)
          throw new i.ArgumentNullError("messageFormatter");
        this.proxyInfo = d, this.privConnectionEvents = new i.EventSource(), this.privConnectionId = l, this.privMessageFormatter = f, this.privConnectionState = i.ConnectionState.None, this.privUri = c, this.privHeaders = p, this.privEnableCompression = v, this.privHeaders[n.HeaderNames.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
      }
      return Object.defineProperty(s.prototype, "state", {
        get: function() {
          return this.privConnectionState;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "events", {
        get: function() {
          return this.privConnectionEvents;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.onClose = function(c, l) {
        return e(this, void 0, void 0, function() {
          var f;
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                return f = "Connection closed. " + c + ": " + l, this.privConnectionState = i.ConnectionState.Disconnected, this.privDisconnectDeferral.resolve(), [4, this.privReceivingMessageQueue.drainAndDispose(function(p) {
                }, f)];
              case 1:
                return d.sent(), [4, this.privSendMessageQueue.drainAndDispose(function(p) {
                  p.sendStatusDeferral.reject(f);
                }, f)];
              case 2:
                return d.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s.prototype.processSendQueue = function() {
        return e(this, void 0, void 0, function() {
          var c, l, f;
          return t(this, function(d) {
            switch (d.label) {
              case 0:
                return c = this.privSendMessageQueue.dequeue(), [4, c];
              case 1:
                if (l = d.sent(), !l)
                  return [
                    2
                    /*return*/
                  ];
                d.label = 2;
              case 2:
                return d.trys.push([2, 4, , 5]), [4, this.sendRawMessage(l)];
              case 3:
                return d.sent(), l.sendStatusDeferral.resolve(), [3, 5];
              case 4:
                return f = d.sent(), l.sendStatusDeferral.reject(f), [3, 5];
              case 5:
                return [3, 0];
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(s.prototype, "isWebsocketOpen", {
        get: function() {
          return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
        },
        enumerable: !1,
        configurable: !0
      }), s.forceNpmWebSocket = !1, s;
    }()
  );
  return Ag.WebsocketMessageAdapter = u, Ag;
}
var Oae;
function LTr() {
  if (Oae) return _g;
  Oae = 1;
  var e = fe && fe.__awaiter || function(o, a, u, s) {
    function c(l) {
      return l instanceof u ? l : new u(function(f) {
        f(l);
      });
    }
    return new (u || (u = Promise))(function(l, f) {
      function d(h) {
        try {
          v(s.next(h));
        } catch (E) {
          f(E);
        }
      }
      function p(h) {
        try {
          v(s.throw(h));
        } catch (E) {
          f(E);
        }
      }
      function v(h) {
        h.done ? l(h.value) : c(h.value).then(d, p);
      }
      v((s = s.apply(o, a || [])).next());
    });
  }, t = fe && fe.__generator || function(o, a) {
    var u = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, s, c, l, f;
    return f = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
      return this;
    }), f;
    function d(v) {
      return function(h) {
        return p([v, h]);
      };
    }
    function p(v) {
      if (s) throw new TypeError("Generator is already executing.");
      for (; u; ) try {
        if (s = 1, c && (l = v[0] & 2 ? c.return : v[0] ? c.throw || ((l = c.return) && l.call(c), 0) : c.next) && !(l = l.call(c, v[1])).done) return l;
        switch (c = 0, l && (v = [v[0] & 2, l.value]), v[0]) {
          case 0:
          case 1:
            l = v;
            break;
          case 4:
            return u.label++, { value: v[1], done: !1 };
          case 5:
            u.label++, c = v[1], v = [0];
            continue;
          case 7:
            v = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (l = u.trys, !(l = l.length > 0 && l[l.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              u = 0;
              continue;
            }
            if (v[0] === 3 && (!l || v[1] > l[0] && v[1] < l[3])) {
              u.label = v[1];
              break;
            }
            if (v[0] === 6 && u.label < l[1]) {
              u.label = l[1], l = v;
              break;
            }
            if (l && u.label < l[2]) {
              u.label = l[2], u.ops.push(v);
              break;
            }
            l[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        v = a.call(o, u);
      } catch (h) {
        v = [6, h], c = 0;
      } finally {
        s = l = 0;
      }
      if (v[0] & 5) throw v[1];
      return { value: v[0] ? v[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(_g, "__esModule", { value: !0 }), _g.WebsocketConnection = void 0;
  var r = Ar(), n = g4e(), i = (
    /** @class */
    function() {
      function o(a, u, s, c, l, f, d) {
        var p = this;
        if (f === void 0 && (f = !1), this.privIsDisposed = !1, this.isDisposed = function() {
          return p.privIsDisposed;
        }, this.state = function() {
          return p.privConnectionMessageAdapter.state;
        }, this.open = function() {
          return p.privConnectionMessageAdapter.open();
        }, this.send = function(y) {
          return p.privConnectionMessageAdapter.send(y);
        }, this.read = function() {
          return p.privConnectionMessageAdapter.read();
        }, !a)
          throw new r.ArgumentNullError("uri");
        if (!c)
          throw new r.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = c;
        var v = "", h = 0;
        if (u) {
          for (var E in u)
            if (E) {
              v += h === 0 && a.indexOf("?") === -1 ? "?" : "&";
              var m = encodeURIComponent(u[E]);
              v += E + "=" + m, h++;
            }
        }
        if (s) {
          for (var g in s)
            if (g) {
              v += h === 0 && a.indexOf("?") === -1 ? "?" : "&";
              var m = encodeURIComponent(s[g]);
              v += g + "=" + m, h++;
            }
        }
        this.privUri = a + v, this.privId = d || r.createNoDashGuid(), this.privConnectionMessageAdapter = new n.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, l, s, f);
      }
      return o.prototype.dispose = function() {
        return e(this, void 0, void 0, function() {
          return t(this, function(a) {
            switch (a.label) {
              case 0:
                return this.privIsDisposed = !0, this.privConnectionMessageAdapter ? [4, this.privConnectionMessageAdapter.close()] : [3, 2];
              case 1:
                a.sent(), a.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Object.defineProperty(o.prototype, "id", {
        get: function() {
          return this.privId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "events", {
        get: function() {
          return this.privConnectionMessageAdapter.events;
        },
        enumerable: !1,
        configurable: !0
      }), o;
    }()
  );
  return _g.WebsocketConnection = i, _g;
}
var bg = {}, Rae;
function BTr() {
  if (Rae) return bg;
  Rae = 1, Object.defineProperty(bg, "__esModule", { value: !0 }), bg.ReplayableAudioNode = void 0;
  var e = (
    /** @class */
    function() {
      function r(n, i) {
        var o = this;
        this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.id = function() {
          return o.privAudioNode.id();
        }, this.privAudioNode = n, this.privBytesPerSecond = i;
      }
      return r.prototype.read = function() {
        var n = this;
        if (this.privReplay && this.privBuffers.length !== 0) {
          var i = this.privReplayOffset - this.privBufferStartOffset, o = Math.round(i * this.privBytesPerSecond * 1e-7);
          o % 2 !== 0 && o++;
          for (var a = 0; a < this.privBuffers.length && o >= this.privBuffers[a].chunk.buffer.byteLength; )
            o -= this.privBuffers[a++].chunk.buffer.byteLength;
          if (a < this.privBuffers.length) {
            var u = this.privBuffers[a].chunk.buffer.slice(o);
            return this.privReplayOffset += u.byteLength / this.privBytesPerSecond * 1e7, a === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({
              buffer: u,
              isEnd: !1,
              timeReceived: this.privBuffers[a].chunk.timeReceived
            });
          }
        }
        return this.privAudioNode.read().then(function(s) {
          return s && s.buffer && (n.privBuffers.push(new t(s, n.privBufferSerial++, n.privBufferedBytes)), n.privBufferedBytes += s.buffer.byteLength), s;
        });
      }, r.prototype.detach = function() {
        return this.privBuffers = void 0, this.privAudioNode.detach();
      }, r.prototype.replay = function() {
        this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
      }, r.prototype.shrinkBuffers = function(n) {
        if (!(this.privBuffers === void 0 || this.privBuffers.length === 0)) {
          this.privLastShrinkOffset = n;
          for (var i = n - this.privBufferStartOffset, o = Math.round(i * this.privBytesPerSecond * 1e-7), a = 0; a < this.privBuffers.length && o >= this.privBuffers[a].chunk.buffer.byteLength; )
            o -= this.privBuffers[a++].chunk.buffer.byteLength;
          this.privBufferStartOffset = Math.round(n - o / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(a);
        }
      }, r.prototype.findTimeAtOffset = function(n) {
        if (n < this.privBufferStartOffset || this.privBuffers === void 0)
          return 0;
        for (var i = 0, o = this.privBuffers; i < o.length; i++) {
          var a = o[i], u = a.byteOffset / this.privBytesPerSecond * 1e7, s = u + a.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
          if (n >= u && n <= s)
            return a.chunk.timeReceived;
        }
        return 0;
      }, r;
    }()
  );
  bg.ReplayableAudioNode = e;
  var t = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(n, i, o) {
        this.chunk = n, this.serial = i, this.byteOffset = o;
      }
      return r;
    }()
  );
  return bg;
}
var Cg = {}, wae;
function kTr() {
  if (wae) return Cg;
  wae = 1, Object.defineProperty(Cg, "__esModule", { value: !0 }), Cg.ProxyInfo = void 0;
  var e = Wt(), t = (
    /** @class */
    function() {
      function r(n, i, o, a) {
        this.privProxyHostName = n, this.privProxyPort = i, this.privProxyUserName = o, this.privProxyPassword = a;
      }
      return r.fromParameters = function(n) {
        return new r(n.getProperty(e.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(n.getProperty(e.PropertyId.SpeechServiceConnection_ProxyPort), 10), n.getProperty(e.PropertyId.SpeechServiceConnection_ProxyUserName), n.getProperty(e.PropertyId.SpeechServiceConnection_ProxyPassword));
      }, r.fromRecognizerConfig = function(n) {
        return this.fromParameters(n.parameters);
      }, Object.defineProperty(r.prototype, "HostName", {
        get: function() {
          return this.privProxyHostName;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Port", {
        get: function() {
          return this.privProxyPort;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "UserName", {
        get: function() {
          return this.privProxyUserName;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "Password", {
        get: function() {
          return this.privProxyPassword;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }()
  );
  return Cg.ProxyInfo = t, Cg;
}
var i5 = {}, Pae;
function MTr() {
  return Pae || (Pae = 1, function(e) {
    var t = fe && fe.__createBinding || (Object.create ? function(s, c, l, f) {
      f === void 0 && (f = l), Object.defineProperty(s, f, { enumerable: !0, get: function() {
        return c[l];
      } });
    } : function(s, c, l, f) {
      f === void 0 && (f = l), s[f] = c[l];
    }), r = fe && fe.__setModuleDefault || (Object.create ? function(s, c) {
      Object.defineProperty(s, "default", { enumerable: !0, value: c });
    } : function(s, c) {
      s.default = c;
    }), n = fe && fe.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var c = {};
      if (s != null) for (var l in s) l !== "default" && Object.hasOwnProperty.call(s, l) && t(c, s, l);
      return r(c, s), c;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.RestMessageAdapter = e.RestRequestType = void 0;
    var i = Ar(), o = n(ki), a;
    (function(s) {
      s.Get = "get", s.Post = "post", s.Delete = "delete", s.File = "file";
    })(a = e.RestRequestType || (e.RestRequestType = {}));
    var u = (
      /** @class */
      function() {
        function s(c, l) {
          if (!c)
            throw new i.ArgumentNullError("configParams");
          this.privHeaders = c.headers, this.privTimeout = c.timeout, this.privIgnoreCache = c.ignoreCache;
        }
        return s.prototype.setHeaders = function(c, l) {
          this.privHeaders[c] = l;
        }, s.prototype.request = function(c, l, f, d, p) {
          var v = this;
          f === void 0 && (f = {}), d === void 0 && (d = null), p === void 0 && (p = null);
          var h = new i.Deferred(), E;
          typeof XMLHttpRequest > "u" ? E = new o.XMLHttpRequest() : E = new XMLHttpRequest();
          var m = c === a.File ? "post" : c;
          return E.open(m, this.withQuery(l, f), !0), this.privHeaders && Object.keys(this.privHeaders).forEach(function(g) {
            return E.setRequestHeader(g, v.privHeaders[g]);
          }), this.privIgnoreCache && E.setRequestHeader("Cache-Control", "no-cache"), E.timeout = this.privTimeout, E.onload = function() {
            h.resolve(v.parseXHRResult(E));
          }, E.onerror = function() {
            h.resolve(v.errorResponse(E, "Failed to make request."));
          }, E.ontimeout = function() {
            h.resolve(v.errorResponse(E, "Request took longer than expected."));
          }, c === a.File && p ? (E.setRequestHeader("Content-Type", "multipart/form-data"), E.send(p)) : c === a.Post && d ? (E.setRequestHeader("Content-Type", "application/json"), E.send(JSON.stringify(d))) : E.send(), h.promise;
        }, s.prototype.parseXHRResult = function(c) {
          return {
            data: c.responseText,
            headers: c.getAllResponseHeaders(),
            json: function() {
              return JSON.parse(c.responseText);
            },
            ok: c.status >= 200 && c.status < 300,
            status: c.status,
            statusText: c.statusText
          };
        }, s.prototype.errorResponse = function(c, l) {
          return l === void 0 && (l = null), {
            data: l || c.statusText,
            headers: c.getAllResponseHeaders(),
            json: function() {
              return JSON.parse(l || '"' + c.statusText + '"');
            },
            ok: !1,
            status: c.status,
            statusText: c.statusText
          };
        }, s.prototype.withQuery = function(c, l) {
          l === void 0 && (l = {});
          var f = this.queryParams(l);
          return f ? c + (c.indexOf("?") === -1 ? "?" : "&") + f : c;
        }, s.prototype.queryParams = function(c) {
          return c === void 0 && (c = {}), Object.keys(c).map(function(l) {
            return encodeURIComponent(l) + "=" + encodeURIComponent(c[l]);
          }).join("&");
        }, s;
      }()
    );
    e.RestMessageAdapter = u;
  }(i5)), i5;
}
var Dae;
function Yu() {
  return Dae || (Dae = 1, function(e) {
    var t = fe && fe.__createBinding || (Object.create ? function(n, i, o, a) {
      a === void 0 && (a = o), Object.defineProperty(n, a, { enumerable: !0, get: function() {
        return i[o];
      } });
    } : function(n, i, o, a) {
      a === void 0 && (a = o), n[a] = i[o];
    }), r = fe && fe.__exportStar || function(n, i) {
      for (var o in n) o !== "default" && !i.hasOwnProperty(o) && t(i, n, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(Jmr(), e), r(Zmr(), e), r(PTr(), e), r(DTr(), e), r(xTr(), e), r(LTr(), e), r(g4e(), e), r(BTr(), e), r(kTr(), e), r(MTr(), e), r(HH(), e);
  }(cN)), cN;
}
var xae;
function FTr() {
  return xae || (xae = 1, function(e) {
    var t = fe && fe.__createBinding || (Object.create ? function(o, a, u, s) {
      s === void 0 && (s = u), Object.defineProperty(o, s, { enumerable: !0, get: function() {
        return a[u];
      } });
    } : function(o, a, u, s) {
      s === void 0 && (s = u), o[s] = a[u];
    }), r = fe && fe.__exportStar || function(o, a) {
      for (var u in o) u !== "default" && !a.hasOwnProperty(u) && t(a, o, u);
    };
    Object.defineProperty(e, "__esModule", { value: !0 });
    var n = Yu(), i = Ar();
    i.Events.instance.attachListener(new n.ConsoleLoggingListener()), r(Wt(), e);
  }(sN)), sN;
}
var Nae;
function T4e() {
  if (Nae) return Kv;
  Nae = 1, Object.defineProperty(Kv, "__esModule", {
    value: !0
  }), Kv.default = void 0;
  var e = FTr(), t = {
    AudioConfig: e.AudioConfig,
    OutputFormat: e.OutputFormat,
    ResultReason: e.ResultReason,
    SpeechConfig: e.SpeechConfig,
    SpeechRecognizer: e.SpeechRecognizer
  };
  return Kv.default = t, Kv;
}
var Lae;
function HTr() {
  if (Lae) return qA;
  Lae = 1;
  var e = Zh;
  Object.defineProperty(qA, "__esModule", {
    value: !0
  }), qA.default = a;
  var t = e(Pmr()), r = e(T4e()), n = r.default.ResultReason, i = n.RecognizingSpeech, o = n.RecognizedSpeech;
  function a(u) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = s.maxAlternatives, l = c === void 0 ? 1 / 0 : c, f = s.textNormalization, d = f === void 0 ? "display" : f;
    if (u.reason === i || u.reason === o && !u.json.NBest) {
      var p = [{
        confidence: 0.5,
        transcript: u.text
      }];
      return u.reason === o && (p.isFinal = !0), p;
    } else if (u.reason === o) {
      var v = (0, t.default)((u.json.NBest || []).slice(0, l).map(function(h) {
        var E = h.Confidence, m = h.Display, g = h.ITN, y = h.Lexical, _ = h.MaskedITN;
        return {
          confidence: E,
          transcript: d === "itn" ? g : d === "lexical" ? y : d === "maskeditn" ? _ : m
        };
      }), {
        isFinal: !0
      });
      return v;
    }
    return [];
  }
  return qA;
}
var GA = {};
const $Tr = /* @__PURE__ */ lh(sBe);
var Bae;
function UTr() {
  if (Bae) return GA;
  Bae = 1;
  var e = Zh;
  Object.defineProperty(GA, "__esModule", {
    value: !0
  }), GA.default = r;
  var t = e($Tr);
  function r() {
    var n, i = [], o = function(s) {
      if (n) {
        var c = n, l = c.resolve;
        n = null, l(s);
      } else
        i.push(s);
    }, a = function() {
      return i.length ? Promise.resolve(i.shift()) : (n || (n = (0, t.default)())).promise;
    };
    return {
      push: o,
      shift: a
    };
  }
  return GA;
}
var WA = {}, o5 = { exports: {} }, a5 = { exports: {} }, kae;
function VTr() {
  return kae || (kae = 1, function(e) {
    function t(r, n) {
      if (r == null) return {};
      var i = {}, o = Object.keys(r), a, u;
      for (u = 0; u < o.length; u++)
        a = o[u], !(n.indexOf(a) >= 0) && (i[a] = r[a]);
      return i;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(a5)), a5.exports;
}
var Mae;
function jTr() {
  return Mae || (Mae = 1, function(e) {
    var t = VTr();
    function r(n, i) {
      if (n == null) return {};
      var o = t(n, i), a, u;
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(n);
        for (u = 0; u < s.length; u++)
          a = s[u], !(i.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(n, a) && (o[a] = n[a]);
      }
      return o;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(o5)), o5.exports;
}
var KA = {}, Fae;
function zTr() {
  if (Fae) return KA;
  Fae = 1, Object.defineProperty(KA, "__esModule", {
    value: !0
  }), KA.default = e;
  function e(t) {
    return typeof t == "function" ? t() : t;
  }
  return KA;
}
var Hae;
function qTr() {
  if (Hae) return WA;
  Hae = 1;
  var e = Zh;
  Object.defineProperty(WA, "__esModule", {
    value: !0
  }), WA.default = l;
  var t = e(jAe()), r = e(jy()), n = e(YAe()), i = e(jTr()), o = e(zTr()), a = ["authorizationToken", "credentials", "looseEvent", "looseEvents", "region", "subscriptionKey"];
  function u(f, d) {
    var p = Object.keys(f);
    if (Object.getOwnPropertySymbols) {
      var v = Object.getOwnPropertySymbols(f);
      d && (v = v.filter(function(h) {
        return Object.getOwnPropertyDescriptor(f, h).enumerable;
      })), p.push.apply(p, v);
    }
    return p;
  }
  function s(f) {
    for (var d = 1; d < arguments.length; d++) {
      var p = arguments[d] != null ? arguments[d] : {};
      d % 2 ? u(Object(p), !0).forEach(function(v) {
        (0, r.default)(f, v, p[v]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(p)) : u(Object(p)).forEach(function(v) {
        Object.defineProperty(f, v, Object.getOwnPropertyDescriptor(p, v));
      });
    }
    return f;
  }
  var c = !0;
  function l() {
    var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = f.authorizationToken, p = f.credentials, v = f.looseEvent, h = f.looseEvents, E = f.region, m = E === void 0 ? "westus" : E, g = f.subscriptionKey, y = (0, i.default)(f, a);
    if (typeof v < "u" && (console.warn('web-speech-cognitive-services: The option "looseEvent" should be named as "looseEvents".'), h = v), !p) {
      if (!d && !g)
        throw new Error("web-speech-cognitive-services: Credentials must be specified.");
      console.warn("web-speech-cognitive-services: We are deprecating authorizationToken, region, and subscriptionKey. Please use credentials instead. The deprecated option will be removed on or after 2020-11-14."), p = /* @__PURE__ */ function() {
        var _ = (0, n.default)(/* @__PURE__ */ t.default.mark(function S() {
          return t.default.wrap(function(O) {
            for (; ; )
              switch (O.prev = O.next) {
                case 0:
                  if (!d) {
                    O.next = 8;
                    break;
                  }
                  return O.next = 3, (0, o.default)(d);
                case 3:
                  O.t1 = O.sent, O.t2 = m, O.t0 = {
                    authorizationToken: O.t1,
                    region: O.t2
                  }, O.next = 13;
                  break;
                case 8:
                  return O.t3 = m, O.next = 11, (0, o.default)(g);
                case 11:
                  O.t4 = O.sent, O.t0 = {
                    region: O.t3,
                    subscriptionKey: O.t4
                  };
                case 13:
                  return O.abrupt("return", O.t0);
                case 14:
                case "end":
                  return O.stop();
              }
          }, S);
        }));
        return function() {
          return _.apply(this, arguments);
        };
      }();
    }
    return s(s({}, y), {}, {
      fetchCredentials: function() {
        var _ = (0, n.default)(/* @__PURE__ */ t.default.mark(function A() {
          var O, P, U, z, k, H, B, x;
          return t.default.wrap(function(w) {
            for (; ; )
              switch (w.prev = w.next) {
                case 0:
                  return w.next = 2, (0, o.default)(p);
                case 2:
                  if (O = w.sent, P = O.authorizationToken, U = O.customVoiceHostname, z = O.region, k = O.speechRecognitionHostname, H = O.speechSynthesisHostname, B = O.subscriptionKey, !(!P && !B || P && B)) {
                    w.next = 13;
                    break;
                  }
                  throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
                case 13:
                  if (!(!z && !(k && H))) {
                    w.next = 17;
                    break;
                  }
                  throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
                case 17:
                  if (!(z && (U || k || H))) {
                    w.next = 21;
                    break;
                  }
                  throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
                case 21:
                  if (!P) {
                    w.next = 26;
                    break;
                  }
                  if (typeof P == "string") {
                    w.next = 24;
                    break;
                  }
                  throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
                case 24:
                  w.next = 28;
                  break;
                case 26:
                  if (typeof B == "string") {
                    w.next = 28;
                    break;
                  }
                  throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
                case 28:
                  return c && B && (console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead."), c = !1), x = P ? {
                    authorizationToken: P
                  } : {
                    subscriptionKey: B
                  }, z ? x.region = z : (x.customVoiceHostname = U, x.speechRecognitionHostname = k, x.speechSynthesisHostname = H), w.abrupt("return", x);
                case 32:
                case "end":
                  return w.stop();
              }
          }, A);
        }));
        function S() {
          return _.apply(this, arguments);
        }
        return S;
      }(),
      looseEvents: h
    });
  }
  return WA;
}
var Ig = {}, $ae;
function YTr() {
  if ($ae) return Ig;
  $ae = 1;
  var e = Zh;
  Object.defineProperty(Ig, "__esModule", {
    value: !0
  }), Ig.default = void 0;
  var t = e(PH()), r = e(wH()), n = /* @__PURE__ */ function() {
    function i() {
      (0, t.default)(this, i), this._phrases = [];
    }
    return (0, r.default)(i, [{
      key: "addFromString",
      value: function() {
        throw new Error("JSGF is not supported");
      }
    }, {
      key: "phrases",
      get: function() {
        return this._phrases;
      },
      set: function(a) {
        if (Array.isArray(a))
          this._phrases = a;
        else if (typeof a == "string")
          this._phrases = [a];
        else
          throw new Error("The provided value is not an array or of type 'string'");
      }
    }]), i;
  }();
  return Ig.default = n, Ig;
}
var za = Zh;
Object.defineProperty(Vy, "__esModule", {
  value: !0
});
Vy.createSpeechRecognitionPonyfillFromRecognizer = C4e;
Vy.default = void 0;
var Ws = za(jAe()), Uae = za(qAe()), GTr = za(jy()), sb = za(YAe()), y4e = za(wH()), _4e = za(PH()), A4e = za(GAe()), WTr = za(KAe()), Vae = za(Z3()), ui = wmr(), jae = za(HTr()), KTr = za(UTr()), XTr = za(qTr()), u5 = za(YTr()), qy = za(T4e());
function zae(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zae(Object(r), !0).forEach(function(n) {
      (0, GTr.default)(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zae(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function S4e(e) {
  var t = JTr();
  return function() {
    var n = (0, Vae.default)(e), i;
    if (t) {
      var o = (0, Vae.default)(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return (0, WTr.default)(this, i);
  };
}
function JTr() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var ZTr = qy.default.AudioConfig, QTr = qy.default.OutputFormat, eyr = qy.default.ResultReason, XA = qy.default.SpeechConfig, b4e = qy.default.SpeechRecognizer;
function qae(e) {
  var t = e.duration, r = e.errorDetails, n = e.json, i = e.offset, o = e.properties, a = e.reason, u = e.resultId, s = e.text;
  return {
    duration: t,
    errorDetails: r,
    json: JSON.parse(n),
    offset: i,
    properties: o,
    reason: a,
    resultId: u,
    text: s
  };
}
function tyr(e) {
  var t = new Int16Array(e);
  return [].reduce.call(t, function(r, n) {
    return r + Math.abs(n);
  }, 0) / t.length;
}
function s5(e) {
  return function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return new Promise(function(i, o) {
      return e.apply(void 0, r.concat([i, o]));
    });
  };
}
var xi = /* @__PURE__ */ function(e) {
  (0, A4e.default)(r, e);
  var t = S4e(r);
  function r(n) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.data, u = o.emma, s = o.interpretation, c = o.resultIndex, l = o.results;
    return (0, _4e.default)(this, r), i = t.call(this, n), i.data = a, i.emma = u, i.interpretation = s, i.resultIndex = c, i.results = l, i;
  }
  return (0, y4e.default)(r);
}(ui.Event);
function ryr(e) {
  var t = e.attach, r = e.attach.bind(e), n, i;
  return e.attach = /* @__PURE__ */ (0, sb.default)(/* @__PURE__ */ Ws.default.mark(function o() {
    var a;
    return Ws.default.wrap(function(s) {
      for (; ; )
        switch (s.prev = s.next) {
          case 0:
            return s.next = 2, r();
          case 2:
            return a = s.sent, s.abrupt("return", cb(cb({}, a), {}, {
              read: function() {
                var c = (0, sb.default)(/* @__PURE__ */ Ws.default.mark(function f() {
                  var d;
                  return Ws.default.wrap(function(v) {
                    for (; ; )
                      switch (v.prev = v.next) {
                        case 0:
                          return v.next = 2, a.read();
                        case 2:
                          if (d = v.sent, !n && tyr(d.buffer) > 150 && (e.events.onEvent({
                            name: "FirstAudibleChunk"
                          }), n = !0), !i) {
                            v.next = 6;
                            break;
                          }
                          return v.abrupt("return", {
                            buffer: new ArrayBuffer(0),
                            isEnd: !0,
                            timeReceived: Date.now()
                          });
                        case 6:
                          return v.abrupt("return", d);
                        case 7:
                        case "end":
                          return v.stop();
                      }
                  }, f);
                }));
                function l() {
                  return c.apply(this, arguments);
                }
                return l;
              }()
            }));
          case 4:
          case "end":
            return s.stop();
        }
    }, o);
  })), {
    audioConfig: e,
    pause: function() {
      i = !0;
    },
    unprepare: function() {
      e.attach = t;
    }
  };
}
function C4e(e) {
  var t = e.createRecognizer, r = e.enableTelemetry, n = e.looseEvents, i = e.referenceGrammars, o = e.textNormalization;
  b4e.enableTelemetry(r !== !1);
  var a = /* @__PURE__ */ function(u) {
    (0, A4e.default)(c, u);
    var s = S4e(c);
    function c() {
      var l;
      return (0, _4e.default)(this, c), l = s.call(this), l._continuous = !1, l._interimResults = !1, l._lang = typeof window < "u" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US", l._grammars = new u5.default(), l._maxAlternatives = 1, l;
    }
    return (0, y4e.default)(c, [{
      key: "emitCognitiveServices",
      value: function(f, d) {
        this.dispatchEvent(new xi("cognitiveservices", {
          data: cb(cb({}, d), {}, {
            type: f
          })
        }));
      }
    }, {
      key: "continuous",
      get: function() {
        return this._continuous;
      },
      set: function(f) {
        this._continuous = f;
      }
    }, {
      key: "grammars",
      get: function() {
        return this._grammars;
      },
      set: function(f) {
        if (f instanceof u5.default)
          this._grammars = f;
        else
          throw new Error("The provided value is not of type 'SpeechGrammarList'");
      }
    }, {
      key: "interimResults",
      get: function() {
        return this._interimResults;
      },
      set: function(f) {
        this._interimResults = f;
      }
    }, {
      key: "maxAlternatives",
      get: function() {
        return this._maxAlternatives;
      },
      set: function(f) {
        this._maxAlternatives = f;
      }
    }, {
      key: "lang",
      get: function() {
        return this._lang;
      },
      set: function(f) {
        this._lang = f;
      }
    }, {
      key: "onaudioend",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "audioend");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "audioend", f);
      }
    }, {
      key: "onaudiostart",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "audiostart");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "audiostart", f);
      }
    }, {
      key: "oncognitiveservices",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "cognitiveservices");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "cognitiveservices", f);
      }
    }, {
      key: "onend",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "end");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "end", f);
      }
    }, {
      key: "onerror",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "error");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "error", f);
      }
    }, {
      key: "onresult",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "result");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "result", f);
      }
    }, {
      key: "onsoundend",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "soundend");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "soundend", f);
      }
    }, {
      key: "onsoundstart",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "soundstart");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "soundstart", f);
      }
    }, {
      key: "onspeechend",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "speechend");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "speechend", f);
      }
    }, {
      key: "onspeechstart",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "speechstart");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "speechstart", f);
      }
    }, {
      key: "onstart",
      get: function() {
        return (0, ui.getEventAttributeValue)(this, "start");
      },
      set: function(f) {
        (0, ui.setEventAttributeValue)(this, "start", f);
      }
    }, {
      key: "start",
      value: function() {
        var f = this;
        this._startOnce().catch(function(d) {
          f.dispatchEvent(new ErrorEvent("error", {
            error: d,
            message: d && (d.stack || d.message)
          }));
        });
      }
    }, {
      key: "_startOnce",
      value: function() {
        var l = (0, sb.default)(/* @__PURE__ */ Ws.default.mark(function d() {
          var p = this, v, h, E, m, g, y, _, S, A, O, P, U, z, k, H, B, x, D;
          return Ws.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return $.next = 2, t(this.lang);
                case 2:
                  return v = $.sent, h = ryr(v.audioConfig), E = h.pause, m = h.unprepare, $.prev = 4, g = (0, KTr.default)(), A = v.audioConfig.events.attach(function(X) {
                    var V = X.name;
                    V === "AudioSourceReadyEvent" ? g.push({
                      audioSourceReady: {}
                    }) : V === "AudioSourceOffEvent" ? g.push({
                      audioSourceOff: {}
                    }) : V === "FirstAudibleChunk" && g.push({
                      firstAudibleChunk: {}
                    });
                  }), O = A.detach, v.canceled = function(X, V) {
                    var F = V.errorDetails, le = V.offset, ae = V.reason, ne = V.sessionId;
                    g.push({
                      canceled: {
                        errorDetails: F,
                        offset: le,
                        reason: ae,
                        sessionId: ne
                      }
                    });
                  }, v.recognized = function(X, V) {
                    var F = V.offset, le = V.result, ae = V.sessionId;
                    g.push({
                      recognized: {
                        offset: F,
                        result: qae(le),
                        sessionId: ae
                      }
                    });
                  }, v.recognizing = function(X, V) {
                    var F = V.offset, le = V.result, ae = V.sessionId;
                    g.push({
                      recognizing: {
                        offset: F,
                        result: qae(le),
                        sessionId: ae
                      }
                    });
                  }, v.sessionStarted = function(X, V) {
                    var F = V.sessionId;
                    g.push({
                      sessionStarted: {
                        sessionId: F
                      }
                    });
                  }, v.sessionStopped = function(X, V) {
                    var F = V.sessionId;
                    g.push({
                      sessionStopped: {
                        sessionId: F
                      }
                    });
                  }, v.speechStartDetected = function(X, V) {
                    var F = V.offset, le = V.sessionId;
                    g.push({
                      speechStartDetected: {
                        offset: F,
                        sessionId: le
                      }
                    });
                  }, v.speechEndDetected = function(X, V) {
                    var F = V.sessionId;
                    g.push({
                      speechEndDetected: {
                        sessionId: F
                      }
                    });
                  }, P = this.grammars.phrases, U = v.privReco.dynamicGrammar, i && i.length && U.addReferenceGrammar(i), P && P.length && U.addPhrase(P), $.next = 20, s5(v.startContinuousRecognitionAsync.bind(v))();
                case 20:
                  v.stopContinuousRecognitionAsync ? (this.abort = function() {
                    return g.push({
                      abort: {}
                    });
                  }, this.stop = function() {
                    return g.push({
                      stop: {}
                    });
                  }) : this.abort = this.stop = void 0, H = [], B = /* @__PURE__ */ Ws.default.mark(function X(V) {
                    var F, le, ae, ne, ve, Ie, Oe, xe, ze, qe, Je, Be;
                    return Ws.default.wrap(function(Ne) {
                      for (; ; )
                        switch (Ne.prev = Ne.next) {
                          case 0:
                            return Ne.next = 2, g.shift();
                          case 2:
                            if (F = Ne.sent, le = F.abort, ae = F.audioSourceOff, ne = F.audioSourceReady, ve = F.canceled, Ie = F.firstAudibleChunk, Oe = F.recognized, xe = F.recognizing, ze = F.stop, Object.keys(F).forEach(function(je) {
                              return p.emitCognitiveServices(je, F[je]);
                            }), qe = ve && ve.errorDetails, !/Permission[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]denied/.test(qe || "")) {
                              Ne.next = 9;
                              break;
                            }
                            return k = {
                              error: "not-allowed",
                              type: "error"
                            }, Ne.abrupt("return", "break");
                          case 9:
                            if (V || p.dispatchEvent(new xi("start")), !qe) {
                              Ne.next = 15;
                              break;
                            }
                            return /1006/.test(qe) ? (z || (p.dispatchEvent(new xi("audiostart")), p.dispatchEvent(new xi("audioend"))), k = {
                              error: "network",
                              type: "error"
                            }) : k = {
                              error: "unknown",
                              type: "error"
                            }, Ne.abrupt("return", "break");
                          case 15:
                            if (!(le || ze)) {
                              Ne.next = 22;
                              break;
                            }
                            if (le ? (k = {
                              error: "aborted",
                              type: "error"
                            }, S = "abort") : (E(), S = "stop"), !(le && v.stopContinuousRecognitionAsync)) {
                              Ne.next = 20;
                              break;
                            }
                            return Ne.next = 20, s5(v.stopContinuousRecognitionAsync.bind(v))();
                          case 20:
                            Ne.next = 61;
                            break;
                          case 22:
                            if (!ne) {
                              Ne.next = 27;
                              break;
                            }
                            p.dispatchEvent(new xi("audiostart")), z = !0, Ne.next = 61;
                            break;
                          case 27:
                            if (!Ie) {
                              Ne.next = 32;
                              break;
                            }
                            p.dispatchEvent(new xi("soundstart")), y = !0, Ne.next = 61;
                            break;
                          case 32:
                            if (!ae) {
                              Ne.next = 40;
                              break;
                            }
                            return _ && p.dispatchEvent(new xi("speechend")), y && p.dispatchEvent(new xi("soundend")), z && p.dispatchEvent(new xi("audioend")), z = y = _ = !1, Ne.abrupt("return", "break");
                          case 40:
                            if (S === "abort") {
                              Ne.next = 61;
                              break;
                            }
                            if (!(Oe && Oe.result && Oe.result.reason === eyr.NoMatch)) {
                              Ne.next = 45;
                              break;
                            }
                            k = {
                              error: "no-speech",
                              type: "error"
                            }, Ne.next = 61;
                            break;
                          case 45:
                            if (!(Oe || xe)) {
                              Ne.next = 61;
                              break;
                            }
                            if (z || (p.dispatchEvent(new xi("audiostart")), z = !0), y || (p.dispatchEvent(new xi("soundstart")), y = !0), _ || (p.dispatchEvent(new xi("speechstart")), _ = !0), !Oe) {
                              Ne.next = 60;
                              break;
                            }
                            if (Je = (0, jae.default)(Oe.result, {
                              maxAlternatives: p.maxAlternatives,
                              textNormalization: o
                            }), Be = !!Je[0].transcript, Be && (H = [].concat((0, Uae.default)(H), [Je]), p.continuous && p.dispatchEvent(new xi("result", {
                              results: H
                            }))), p.continuous && Be ? k = null : k = {
                              results: H,
                              type: "result"
                            }, !(!p.continuous && v.stopContinuousRecognitionAsync)) {
                              Ne.next = 57;
                              break;
                            }
                            return Ne.next = 57, s5(v.stopContinuousRecognitionAsync.bind(v))();
                          case 57:
                            n && k && Be && (p.dispatchEvent(new xi(k.type, k)), k = null), Ne.next = 61;
                            break;
                          case 60:
                            xe && p.interimResults && p.dispatchEvent(new xi("result", {
                              results: [].concat((0, Uae.default)(H), [(0, jae.default)(xe.result, {
                                maxAlternatives: p.maxAlternatives,
                                textNormalization: o
                              })])
                            }));
                          case 61:
                          case "end":
                            return Ne.stop();
                        }
                    }, X);
                  }), x = 0;
                case 24:
                  if (!(!S || z)) {
                    $.next = 32;
                    break;
                  }
                  return $.delegateYield(B(x), "t0", 26);
                case 26:
                  if (D = $.t0, D !== "break") {
                    $.next = 29;
                    break;
                  }
                  return $.abrupt("break", 32);
                case 29:
                  x++, $.next = 24;
                  break;
                case 32:
                  _ && this.dispatchEvent(new xi("speechend")), y && this.dispatchEvent(new xi("soundend")), z && this.dispatchEvent(new xi("audioend")), k && (k.type === "result" && !k.results.length && (k = {
                    error: "no-speech",
                    type: "error"
                  }), k.type === "error" ? this.dispatchEvent(new ErrorEvent("error", k)) : this.dispatchEvent(new xi(k.type, k))), this.dispatchEvent(new xi("end")), O(), $.next = 44;
                  break;
                case 40:
                  throw $.prev = 40, $.t1 = $.catch(4), console.error($.t1), $.t1;
                case 44:
                  return $.prev = 44, m(), v.dispose(), $.finish(44);
                case 48:
                case "end":
                  return $.stop();
              }
          }, d, this, [[4, 40, 44, 48]]);
        }));
        function f() {
          return l.apply(this, arguments);
        }
        return f;
      }()
    }]), c;
  }(ui.EventTarget);
  return {
    SpeechGrammarList: u5.default,
    SpeechRecognition: a,
    SpeechRecognitionEvent: xi
  };
}
var nyr = function(t) {
  var r = (0, XTr.default)(t), n = r.audioConfig, i = n === void 0 ? ZTr.fromDefaultMicrophoneInput() : n, o = r.enableTelemetry, a = o === void 0 ? !0 : o, u = r.fetchCredentials, s = r.looseEvents, c = r.referenceGrammars, l = r.speechRecognitionEndpointId, f = r.textNormalization, d = f === void 0 ? "display" : f;
  if (!i && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia))
    return console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services."), {};
  var p = /* @__PURE__ */ function() {
    var v = (0, sb.default)(/* @__PURE__ */ Ws.default.mark(function h(E) {
      var m, g, y, _, S, A, O;
      return Ws.default.wrap(function(U) {
        for (; ; )
          switch (U.prev = U.next) {
            case 0:
              return U.next = 2, u();
            case 2:
              return m = U.sent, g = m.authorizationToken, y = m.region, _ = m.speechRecognitionHostname, S = m.subscriptionKey, _ ? (O = {
                hostname: _,
                port: 443,
                protocol: "wss:"
              }, g ? (A = XA.fromHost(O), A.authorizationToken = g) : A = XA.fromHost(O, S)) : A = g ? XA.fromAuthorizationToken(g, y) : XA.fromSubscription(S, y), l && (A.endpointId = l), A.outputFormat = QTr.Detailed, A.speechRecognitionLanguage = E || "en-US", U.abrupt("return", new b4e(A, i));
            case 12:
            case "end":
              return U.stop();
          }
      }, h);
    }));
    return function(E) {
      return v.apply(this, arguments);
    };
  }();
  return C4e({
    audioConfig: i,
    createRecognizer: p,
    enableTelemetry: a,
    looseEvents: s,
    referenceGrammars: c,
    textNormalization: d
  });
};
Vy.default = nyr;
(function(e) {
  var t = J3;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "createSpeechRecognitionPonyfillFromRecognizer", {
    enumerable: !0,
    get: function() {
      return r.createSpeechRecognitionPonyfillFromRecognizer;
    }
  }), e.default = void 0;
  var r = i(Vy);
  function n(a) {
    if (typeof WeakMap != "function") return null;
    var u = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
    return (n = function(l) {
      return l ? s : u;
    })(a);
  }
  function i(a, u) {
    if (a && a.__esModule)
      return a;
    if (a === null || t(a) !== "object" && typeof a != "function")
      return { default: a };
    var s = n(u);
    if (s && s.has(a))
      return s.get(a);
    var c = {}, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(a, f)) {
        var d = l ? Object.getOwnPropertyDescriptor(a, f) : null;
        d && (d.get || d.set) ? Object.defineProperty(c, f, d) : c[f] = a[f];
      }
    return c.default = a, s && s.set(a, c), c;
  }
  var o = r.default;
  e.default = o;
})($Ae);
var Yae = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c1 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var JA = 0; JA < Yae.length; JA++)
  c1[Yae.charCodeAt(JA)] = JA;
var iyr = function(e) {
  var t = e.length * 0.75, r = e.length, n, i = 0, o, a, u, s;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var c = new ArrayBuffer(t), l = new Uint8Array(c);
  for (n = 0; n < r; n += 4)
    o = c1[e.charCodeAt(n)], a = c1[e.charCodeAt(n + 1)], u = c1[e.charCodeAt(n + 2)], s = c1[e.charCodeAt(n + 3)], l[i++] = o << 2 | a >> 4, l[i++] = (a & 15) << 4 | u >> 2, l[i++] = (u & 3) << 6 | s & 63;
  return c;
}, a8 = { exports: {} }, oyr = function() {
  var e = {};
  return e.promise = new Promise(function(t, r) {
    e.resolve = t, e.reject = r;
  }), e;
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(oyr);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s, c) {
    if (!(s instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  function o(s, c) {
    for (var l = 0; l < c.length; l++) {
      var f = c[l];
      f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(s, f.key, f);
    }
  }
  function a(s, c, l) {
    return c && o(s.prototype, c), s;
  }
  var u = /* @__PURE__ */ function() {
    function s() {
      var c = this, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      i(this, s), this.defers = [], this.upcomingDeferred = null, this.eventListener = this.eventListener.bind(this), this.options = l, this.one = this.one.bind(this), this.upcoming = this.upcoming.bind(this), this[Symbol.iterator] = function() {
        return {
          next: function() {
            return {
              done: !1,
              value: c.upcoming()
            };
          }
        };
      };
    }
    return a(s, [{
      key: "eventListener",
      value: function(l) {
        var f = this.defers.shift(), d = this.options.array ? [].slice.call(arguments) : l;
        f && f.resolve(d), this.upcomingDeferred && (this.upcomingDeferred.resolve(d), this.upcomingDeferred = null);
      }
    }, {
      key: "one",
      value: function() {
        var l = (0, r.default)();
        return this.defers.push(l), l.promise;
      }
    }, {
      key: "upcoming",
      value: function() {
        return this.upcomingDeferred || (this.upcomingDeferred = (0, r.default)()), this.upcomingDeferred.promise;
      }
    }]), s;
  }();
  t.default = u, e.exports = t.default, e.exports.default = t.default;
})(a8, a8.exports);
var ayr = a8.exports;
const Gae = /* @__PURE__ */ Mt(ayr);
var Wae = A_e, uyr = pc, I4e = function(e, t, r) {
  return r.get && Wae(r.get, t, { getter: !0 }), r.set && Wae(r.set, t, { setter: !0 }), uyr.f(e, t, r);
}, syr = Ed, cyr = I4e, lyr = ja, fyr = qu, Kae = lyr("species"), dyr = function(e) {
  var t = syr(e);
  fyr && t && !t[Kae] && cyr(t, Kae, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, pyr = Z7, hyr = TypeError, vyr = function(e, t) {
  if (pyr(t, e)) return e;
  throw new hyr("Incorrect invocation");
}, Eyr = Jh, myr = function(e, t, r) {
  for (var n in t) Eyr(e, n, t[n], r);
  return e;
}, gyr = function(e, t) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, t);
  } catch {
  }
}, Tyr = My, W4 = sl, Yy = qu, yyr = dyr, O4e = Ly, _yr = ll, Ayr = vyr, R4e = aa, Syr = $3, byr = cl, K4 = By, Cyr = Jh, UH = myr, w4e = I4e, vp = gyr, Iyr = ja, P4e = j3, Oyr = Iyr("observable"), VH = "Observable", D4e = "Subscription", x4e = "SubscriptionObserver", jH = P4e.getterFor, zH = P4e.set, Ryr = jH(VH), N4e = jH(D4e), X4 = jH(x4e), L4e = function(e) {
  this.observer = _yr(e), this.cleanup = void 0, this.subscriptionObserver = void 0;
};
L4e.prototype = {
  type: D4e,
  clean: function() {
    var e = this.cleanup;
    if (e) {
      this.cleanup = void 0;
      try {
        e();
      } catch (t) {
        vp(t);
      }
    }
  },
  close: function() {
    if (!Yy) {
      var e = this.facade, t = this.subscriptionObserver;
      e.closed = !0, t && (t.closed = !0);
    }
    this.observer = void 0;
  },
  isClosed: function() {
    return this.observer === void 0;
  }
};
var qH = function(e, t) {
  var r = zH(this, new L4e(e)), n;
  Yy || (this.closed = !1);
  try {
    (n = K4(e, "start")) && W4(n, e, this);
  } catch (u) {
    vp(u);
  }
  if (!r.isClosed()) {
    var i = r.subscriptionObserver = new YH(r);
    try {
      var o = t(i), a = o;
      Syr(o) || (r.cleanup = R4e(o.unsubscribe) ? function() {
        a.unsubscribe();
      } : O4e(o));
    } catch (u) {
      i.error(u);
      return;
    }
    r.isClosed() && r.clean();
  }
};
qH.prototype = UH({}, {
  unsubscribe: function() {
    var t = N4e(this);
    t.isClosed() || (t.close(), t.clean());
  }
});
Yy && w4e(qH.prototype, "closed", {
  configurable: !0,
  get: function() {
    return N4e(this).isClosed();
  }
});
var YH = function(e) {
  zH(this, {
    type: x4e,
    subscriptionState: e
  }), Yy || (this.closed = !1);
};
YH.prototype = UH({}, {
  next: function(t) {
    var r = X4(this).subscriptionState;
    if (!r.isClosed()) {
      var n = r.observer;
      try {
        var i = K4(n, "next");
        i && W4(i, n, t);
      } catch (o) {
        vp(o);
      }
    }
  },
  error: function(t) {
    var r = X4(this).subscriptionState;
    if (!r.isClosed()) {
      var n = r.observer;
      r.close();
      try {
        var i = K4(n, "error");
        i ? W4(i, n, t) : vp(t);
      } catch (o) {
        vp(o);
      }
      r.clean();
    }
  },
  complete: function() {
    var t = X4(this).subscriptionState;
    if (!t.isClosed()) {
      var r = t.observer;
      t.close();
      try {
        var n = K4(r, "complete");
        n && W4(n, r);
      } catch (i) {
        vp(i);
      }
      t.clean();
    }
  }
});
Yy && w4e(YH.prototype, "closed", {
  configurable: !0,
  get: function() {
    return X4(this).subscriptionState.isClosed();
  }
});
var B4e = function(t) {
  Ayr(this, GH), zH(this, {
    type: VH,
    subscriber: O4e(t)
  });
}, GH = B4e.prototype;
UH(GH, {
  subscribe: function(t) {
    var r = arguments.length;
    return new qH(R4e(t) ? {
      next: t,
      error: r > 1 ? arguments[1] : void 0,
      complete: r > 2 ? arguments[2] : void 0
    } : byr(t) ? t : {}, Ryr(this).subscriber);
  }
});
Cyr(GH, Oyr, function() {
  return this;
});
Tyr({ global: !0, constructor: !0, forced: !0 }, {
  Observable: B4e
});
yyr(VH);
var wyr = ja, Pyr = wyr("toStringTag"), k4e = {};
k4e[Pyr] = "z";
var WH = String(k4e) === "[object z]", Dyr = WH, xyr = aa, J4 = J7, Nyr = ja, Lyr = Nyr("toStringTag"), Byr = Object, kyr = J4(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Myr = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, t2 = Dyr ? J4 : function(e) {
  var t, r, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = Myr(t = Byr(e), Lyr)) == "string" ? r : kyr ? J4(t) : (n = J4(t)) === "Object" && xyr(t.callee) ? "Arguments" : n;
}, Fyr = Va, Hyr = zu, M4e = aa, $yr = t2, Uyr = Ed, Vyr = T_e, F4e = function() {
}, H4e = Uyr("Reflect", "construct"), KH = /^\s*(?:class|function)\b/, jyr = Fyr(KH.exec), zyr = !KH.test(F4e), Og = function(t) {
  if (!M4e(t)) return !1;
  try {
    return H4e(F4e, [], t), !0;
  } catch {
    return !1;
  }
}, $4e = function(t) {
  if (!M4e(t)) return !1;
  switch ($yr(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return zyr || !!jyr(KH, Vyr(t));
  } catch {
    return !0;
  }
};
$4e.sham = !0;
var U4e = !H4e || Hyr(function() {
  var e;
  return Og(Og.call) || !Og(Object) || !Og(function() {
    e = !0;
  }) || e;
}) ? $4e : Og, Gy = {}, qyr = t2, Xae = By, Yyr = $3, Gyr = Gy, Wyr = ja, Kyr = Wyr("iterator"), V4e = function(e) {
  if (!Yyr(e)) return Xae(e, Kyr) || Xae(e, "@@iterator") || Gyr[qyr(e)];
}, Xyr = sl, Jyr = Ly, Zyr = ll, Qyr = Q7, e_r = V4e, t_r = TypeError, j4e = function(e, t) {
  var r = arguments.length < 2 ? e_r(e) : t;
  if (Jyr(r)) return Zyr(Xyr(r, e));
  throw new t_r(Qyr(e) + " is not iterable");
}, r_r = J7, n_r = Va, i_r = function(e) {
  if (r_r(e) === "Function") return n_r(e);
}, Jae = i_r, o_r = Ly, a_r = W7, u_r = Jae(Jae.bind), s_r = function(e, t) {
  return o_r(e), t === void 0 ? e : a_r ? u_r(e, t) : function() {
    return e.apply(t, arguments);
  };
}, c_r = ja, l_r = Gy, f_r = c_r("iterator"), d_r = Array.prototype, p_r = function(e) {
  return e !== void 0 && (l_r.Array === e || d_r[f_r] === e);
}, h_r = sl, Zae = ll, v_r = By, E_r = function(e, t, r) {
  var n, i;
  Zae(e);
  try {
    if (n = v_r(e, "return"), !n) {
      if (t === "throw") throw r;
      return r;
    }
    n = h_r(n, e);
  } catch (o) {
    i = !0, n = o;
  }
  if (t === "throw") throw r;
  if (i) throw n;
  return Zae(n), r;
}, m_r = s_r, g_r = sl, T_r = ll, y_r = Q7, __r = p_r, A_r = b_e, Qae = Z7, S_r = j4e, b_r = V4e, eue = E_r, C_r = TypeError, Z4 = function(e, t) {
  this.stopped = e, this.result = t;
}, tue = Z4.prototype, I_r = function(e, t, r) {
  var n = r && r.that, i = !!(r && r.AS_ENTRIES), o = !!(r && r.IS_RECORD), a = !!(r && r.IS_ITERATOR), u = !!(r && r.INTERRUPTED), s = m_r(t, n), c, l, f, d, p, v, h, E = function(g) {
    return c && eue(c, "normal", g), new Z4(!0, g);
  }, m = function(g) {
    return i ? (T_r(g), u ? s(g[0], g[1], E) : s(g[0], g[1])) : u ? s(g, E) : s(g);
  };
  if (o)
    c = e.iterator;
  else if (a)
    c = e;
  else {
    if (l = b_r(e), !l) throw new C_r(y_r(e) + " is not iterable");
    if (__r(l)) {
      for (f = 0, d = A_r(e); d > f; f++)
        if (p = m(e[f]), p && Qae(tue, p)) return p;
      return new Z4(!1);
    }
    c = S_r(e, l);
  }
  for (v = o ? e.next : c.next; !(h = g_r(v, c)).done; ) {
    try {
      p = m(h.value);
    } catch (g) {
      eue(c, "throw", g);
    }
    if (typeof p == "object" && p && Qae(tue, p)) return p;
  }
  return new Z4(!1);
}, O_r = My, R_r = Ed, w_r = sl, rue = ll, P_r = U4e, D_r = j4e, x_r = By, N_r = I_r, L_r = ja, B_r = L_r("observable");
O_r({ target: "Observable", stat: !0, forced: !0 }, {
  from: function(t) {
    var r = P_r(this) ? this : R_r("Observable"), n = x_r(rue(t), B_r);
    if (n) {
      var i = rue(w_r(n, t));
      return i.constructor === r ? i : new r(function(a) {
        return i.subscribe(a);
      });
    }
    var o = D_r(t);
    return new r(function(a) {
      N_r(o, function(u, s) {
        if (a.next(u), a.closed) return s();
      }, { IS_ITERATOR: !0, INTERRUPTED: !0 }), a.complete();
    });
  }
});
var k_r = My, z4e = Ed, M_r = U4e, F_r = z4e("Array");
k_r({ target: "Observable", stat: !0, forced: !0 }, {
  of: function() {
    for (var t = M_r(this) ? this : z4e("Observable"), r = arguments.length, n = F_r(r), i = 0; i < r; ) n[i] = arguments[i++];
    return new t(function(o) {
      for (var a = 0; a < r; a++)
        if (o.next(n[a]), o.closed) return;
      o.complete();
    });
  }
});
var q4e = {}, H_r = ja;
q4e.f = H_r;
var nue = lH, $_r = dc, U_r = q4e, V_r = pc.f, j_r = function(e) {
  var t = nue.Symbol || (nue.Symbol = {});
  $_r(t, e) || V_r(t, e, {
    value: U_r.f(e)
  });
}, z_r = j_r;
z_r("observable");
var q_r = WH, Y_r = t2, G_r = q_r ? {}.toString : function() {
  return "[object " + Y_r(this) + "]";
}, W_r = WH, K_r = Jh, X_r = G_r;
W_r || K_r(Object.prototype, "toString", X_r, { unsafe: !0 });
var J_r = t2, Z_r = String, Y4e = function(e) {
  if (J_r(e) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return Z_r(e);
}, XH = Va, Q_r = uH, eAr = Y4e, tAr = U3, rAr = XH("".charAt), iue = XH("".charCodeAt), nAr = XH("".slice), oue = function(e) {
  return function(t, r) {
    var n = eAr(tAr(t)), i = Q_r(r), o = n.length, a, u;
    return i < 0 || i >= o ? e ? "" : void 0 : (a = iue(n, i), a < 55296 || a > 56319 || i + 1 === o || (u = iue(n, i + 1)) < 56320 || u > 57343 ? e ? rAr(n, i) : a : e ? nAr(n, i, i + 2) : (a - 55296 << 10) + (u - 56320) + 65536);
  };
}, iAr = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: oue(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: oue(!0)
}, G4e = {}, oAr = qu, aAr = v_e, uAr = pc, sAr = ll, cAr = Xh, lAr = O_e;
G4e.f = oAr && !aAr ? Object.defineProperties : function(t, r) {
  sAr(t);
  for (var n = cAr(r), i = lAr(r), o = i.length, a = 0, u; o > a; ) uAr.f(t, u = i[a++], n[u]);
  return t;
};
var fAr = Ed, dAr = fAr("document", "documentElement"), pAr = ll, hAr = G4e, aue = sH, vAr = oH, EAr = dAr, mAr = rH, gAr = iH, uue = ">", sue = "<", u8 = "prototype", s8 = "script", W4e = gAr("IE_PROTO"), c5 = function() {
}, K4e = function(e) {
  return sue + s8 + uue + e + sue + "/" + s8 + uue;
}, cue = function(e) {
  e.write(K4e("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, TAr = function() {
  var e = mAr("iframe"), t = "java" + s8 + ":", r;
  return e.style.display = "none", EAr.appendChild(e), e.src = String(t), r = e.contentWindow.document, r.open(), r.write(K4e("document.F=Object")), r.close(), r.F;
}, ZA, Q4 = function() {
  try {
    ZA = new ActiveXObject("htmlfile");
  } catch {
  }
  Q4 = typeof document < "u" ? document.domain && ZA ? cue(ZA) : TAr() : cue(ZA);
  for (var e = aue.length; e--; ) delete Q4[u8][aue[e]];
  return Q4();
};
vAr[W4e] = !0;
var X4e = Object.create || function(t, r) {
  var n;
  return t !== null ? (c5[u8] = pAr(t), n = new c5(), c5[u8] = null, n[W4e] = t) : n = Q4(), r === void 0 ? n : hAr.f(n, r);
}, yAr = zu, _Ar = aa, AAr = cl, lue = cH, SAr = Jh, bAr = ja, c8 = bAr("iterator"), J4e = !1, Ff, l5, f5;
[].keys && (f5 = [].keys(), "next" in f5 ? (l5 = lue(lue(f5)), l5 !== Object.prototype && (Ff = l5)) : J4e = !0);
var CAr = !AAr(Ff) || yAr(function() {
  var e = {};
  return Ff[c8].call(e) !== e;
});
CAr && (Ff = {});
_Ar(Ff[c8]) || SAr(Ff, c8, function() {
  return this;
});
var Z4e = {
  IteratorPrototype: Ff,
  BUGGY_SAFARI_ITERATORS: J4e
}, IAr = pc.f, OAr = dc, RAr = ja, fue = RAr("toStringTag"), JH = function(e, t, r) {
  e && !r && (e = e.prototype), e && !OAr(e, fue) && IAr(e, fue, { configurable: !0, value: t });
}, wAr = Z4e.IteratorPrototype, PAr = X4e, DAr = X7, xAr = JH, NAr = Gy, LAr = function() {
  return this;
}, BAr = function(e, t, r, n) {
  var i = t + " Iterator";
  return e.prototype = PAr(wAr, { next: DAr(+!n, r) }), xAr(e, i, !1), NAr[i] = LAr, e;
}, kAr = Va, MAr = Ly, FAr = function(e, t, r) {
  try {
    return kAr(MAr(Object.getOwnPropertyDescriptor(e, t)[r]));
  } catch {
  }
}, HAr = cl, $Ar = function(e) {
  return HAr(e) || e === null;
}, UAr = $Ar, VAr = String, jAr = TypeError, zAr = function(e) {
  if (UAr(e)) return e;
  throw new jAr("Can't set " + VAr(e) + " as a prototype");
}, qAr = FAr, YAr = cl, GAr = U3, WAr = zAr, KAr = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, t = {}, r;
  try {
    r = qAr(Object.prototype, "__proto__", "set"), r(t, []), e = t instanceof Array;
  } catch {
  }
  return function(i, o) {
    return GAr(i), WAr(o), YAr(i) && (e ? r(i, o) : i.__proto__ = o), i;
  };
}() : void 0), XAr = My, JAr = sl, Q4e = g_e, ZAr = aa, QAr = BAr, due = cH, pue = KAr, e4r = JH, t4r = V3, d5 = Jh, r4r = ja, n4r = Gy, eSe = Z4e, i4r = Q4e.PROPER, o4r = Q4e.CONFIGURABLE, hue = eSe.IteratorPrototype, QA = eSe.BUGGY_SAFARI_ITERATORS, Rg = r4r("iterator"), vue = "keys", wg = "values", Eue = "entries", a4r = function() {
  return this;
}, tSe = function(e, t, r, n, i, o, a) {
  QAr(r, t, n);
  var u = function(m) {
    if (m === i && d) return d;
    if (!QA && m && m in l) return l[m];
    switch (m) {
      case vue:
        return function() {
          return new r(this, m);
        };
      case wg:
        return function() {
          return new r(this, m);
        };
      case Eue:
        return function() {
          return new r(this, m);
        };
    }
    return function() {
      return new r(this);
    };
  }, s = t + " Iterator", c = !1, l = e.prototype, f = l[Rg] || l["@@iterator"] || i && l[i], d = !QA && f || u(i), p = t === "Array" && l.entries || f, v, h, E;
  if (p && (v = due(p.call(new e())), v !== Object.prototype && v.next && (due(v) !== hue && (pue ? pue(v, hue) : ZAr(v[Rg]) || d5(v, Rg, a4r)), e4r(v, s, !0))), i4r && i === wg && f && f.name !== wg && (o4r ? t4r(l, "name", wg) : (c = !0, d = function() {
    return JAr(f, this);
  })), i)
    if (h = {
      values: u(wg),
      keys: o ? d : u(vue),
      entries: u(Eue)
    }, a) for (E in h)
      (QA || c || !(E in l)) && d5(l, E, h[E]);
    else XAr({ target: t, proto: !0, forced: QA || c }, h);
  return l[Rg] !== d && d5(l, Rg, d, { name: i }), n4r[t] = d, h;
}, rSe = function(e, t) {
  return { value: e, done: t };
}, u4r = iAr.charAt, s4r = Y4e, nSe = j3, c4r = tSe, mue = rSe, iSe = "String Iterator", l4r = nSe.set, f4r = nSe.getterFor(iSe);
c4r(String, "String", function(e) {
  l4r(this, {
    type: iSe,
    string: s4r(e),
    index: 0
  });
}, function() {
  var t = f4r(this), r = t.string, n = t.index, i;
  return n >= r.length ? mue(void 0, !0) : (i = u4r(r, n), t.index += i.length, mue(i, !1));
});
var d4r = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, p4r = rH, p5 = p4r("span").classList, gue = p5 && p5.constructor && p5.constructor.prototype, h4r = gue === Object.prototype ? void 0 : gue, v4r = ja, E4r = X4e, m4r = pc.f, l8 = v4r("unscopables"), f8 = Array.prototype;
f8[l8] === void 0 && m4r(f8, l8, {
  configurable: !0,
  value: E4r(null)
});
var g4r = function(e) {
  f8[l8][e] = !0;
}, T4r = Xh, ZH = g4r, Tue = Gy, oSe = j3, y4r = pc.f, _4r = tSe, e4 = rSe, A4r = qu, aSe = "Array Iterator", S4r = oSe.set, b4r = oSe.getterFor(aSe), C4r = _4r(Array, "Array", function(e, t) {
  S4r(this, {
    type: aSe,
    target: T4r(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = b4r(this), t = e.target, r = e.index++;
  if (!t || r >= t.length)
    return e.target = void 0, e4(void 0, !0);
  switch (e.kind) {
    case "keys":
      return e4(r, !1);
    case "values":
      return e4(t[r], !1);
  }
  return e4([r, t[r]], !1);
}, "values"), yue = Tue.Arguments = Tue.Array;
ZH("keys");
ZH("values");
ZH("entries");
if (A4r && yue.name !== "values") try {
  y4r(yue, "name", { value: "values" });
} catch {
}
var _ue = ju, uSe = d4r, I4r = h4r, l1 = C4r, Aue = V3, O4r = JH, R4r = ja, h5 = R4r("iterator"), v5 = l1.values, sSe = function(e, t) {
  if (e) {
    if (e[h5] !== v5) try {
      Aue(e, h5, v5);
    } catch {
      e[h5] = v5;
    }
    if (O4r(e, t, !0), uSe[t]) {
      for (var r in l1)
        if (e[r] !== l1[r]) try {
          Aue(e, r, l1[r]);
        } catch {
          e[r] = l1[r];
        }
    }
  }
};
for (var E5 in uSe)
  sSe(_ue[E5] && _ue[E5].prototype, E5);
sSe(I4r, "DOMTokenList");
var w4r = lH, P4r = w4r.Observable, D4r = P4r;
const t4 = /* @__PURE__ */ Mt(D4r);
function x4r() {
  let e = [], t = { cancelAll: () => {
    e.forEach(({ cancel: r }) => r());
  }, push: (r) => {
    let n = F1(), i = F1(), o = { promise: i.promise }, a, u = o.cancel = () => {
      r = () => ({ result: Promise.reject(new Error("cancelled before start")) }), a && a(), n.reject(new Error("cancelled in the midway"));
    }, s = async () => {
      let { abort: f, result: d } = r();
      a = f;
      try {
        i.resolve(await Promise.race([d, n.promise]));
      } catch (p) {
        i.reject(p);
      }
      e = e.filter((p) => p !== o);
    }, c = e[e.length - 1], l = c && c.promise || Promise.resolve();
    return e.push(o), l.then(s, s), { cancel: u, result: i.promise };
  } };
  return Object.defineProperty(t, "length", { get: () => e.length }), t;
}
function QH(e, t, ...r) {
  if (!e) throw new TypeError(cSe(t, r));
}
function cSe(e, t) {
  let r = 0;
  return e.replace(/%[os]/gu, () => lSe(t[r++]));
}
function lSe(e) {
  return typeof e != "object" || e === null ? String(e) : Object.prototype.toString.call(e);
}
var N4r;
function L4r(e) {
  try {
    let t = e instanceof Error ? e : new Error(lSe(e));
    if (typeof dispatchEvent == "function" && typeof ErrorEvent == "function") dispatchEvent(new ErrorEvent("error", { error: t, message: t.message }));
    else if (typeof process < "u" && typeof process.emit == "function") {
      process.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  } catch {
  }
}
var Es = typeof window < "u" ? window : typeof self < "u" ? self : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : void 0, B4r, fl = class {
  constructor(t, r) {
    this.code = t, this.message = r;
  }
  warn(...t) {
    var r;
    try {
      let n = ((r = new Error().stack) !== null && r !== void 0 ? r : "").replace(/^(?:.+?\n){2}/gu, `
`);
      console.warn(this.message, ...t, n);
    } catch {
    }
  }
}, k4r = new fl("W01", "Unable to initialize event under dispatching."), M4r = new fl("W02", "Assigning any falsy value to 'cancelBubble' property has no effect."), F4r = new fl("W03", "Assigning any truthy value to 'returnValue' property has no effect."), H4r = new fl("W04", "Unable to preventDefault on non-cancelable events."), $4r = new fl("W05", "Unable to preventDefault inside passive event listener invocation."), U4r = new fl("W06", "An event listener wasn't added because it has been added already: %o, %o"), m5 = new fl("W07", "The %o option value was abandoned because the event listener wasn't added as duplicated."), Sue = new fl("W08", "The 'callback' argument must be a function or an object that has 'handleEvent' method: %o"), V4r = new fl("W09", "Event attribute handler must be a function: %o"), gs = class {
  static get NONE() {
    return bue;
  }
  static get CAPTURING_PHASE() {
    return Cue;
  }
  static get AT_TARGET() {
    return Iue;
  }
  static get BUBBLING_PHASE() {
    return Oue;
  }
  constructor(e, t) {
    Object.defineProperty(this, "isTrusted", { value: !1, enumerable: !0 });
    let r = t ?? {};
    d8.set(this, { type: String(e), bubbles: !!r.bubbles, cancelable: !!r.cancelable, composed: !!r.composed, target: null, currentTarget: null, stopPropagationFlag: !1, stopImmediatePropagationFlag: !1, canceledFlag: !1, inPassiveListenerFlag: !1, dispatchFlag: !1, timeStamp: Date.now() });
  }
  get type() {
    return zi(this).type;
  }
  get target() {
    return zi(this).target;
  }
  get srcElement() {
    return zi(this).target;
  }
  get currentTarget() {
    return zi(this).currentTarget;
  }
  composedPath() {
    let e = zi(this).currentTarget;
    return e ? [e] : [];
  }
  get NONE() {
    return bue;
  }
  get CAPTURING_PHASE() {
    return Cue;
  }
  get AT_TARGET() {
    return Iue;
  }
  get BUBBLING_PHASE() {
    return Oue;
  }
  get eventPhase() {
    return zi(this).dispatchFlag ? 2 : 0;
  }
  stopPropagation() {
    zi(this).stopPropagationFlag = !0;
  }
  get cancelBubble() {
    return zi(this).stopPropagationFlag;
  }
  set cancelBubble(e) {
    e ? zi(this).stopPropagationFlag = !0 : M4r.warn();
  }
  stopImmediatePropagation() {
    let e = zi(this);
    e.stopPropagationFlag = e.stopImmediatePropagationFlag = !0;
  }
  get bubbles() {
    return zi(this).bubbles;
  }
  get cancelable() {
    return zi(this).cancelable;
  }
  get returnValue() {
    return !zi(this).canceledFlag;
  }
  set returnValue(e) {
    e ? F4r.warn() : Rue(zi(this));
  }
  preventDefault() {
    Rue(zi(this));
  }
  get defaultPrevented() {
    return zi(this).canceledFlag;
  }
  get composed() {
    return zi(this).composed;
  }
  get isTrusted() {
    return !1;
  }
  get timeStamp() {
    return zi(this).timeStamp;
  }
  initEvent(e, t = !1, r = !1) {
    let n = zi(this);
    if (n.dispatchFlag) {
      k4r.warn();
      return;
    }
    d8.set(this, { ...n, type: String(e), bubbles: !!t, cancelable: !!r, target: null, currentTarget: null, stopPropagationFlag: !1, stopImmediatePropagationFlag: !1, canceledFlag: !1 });
  }
}, bue = 0, Cue = 1, Iue = 2, Oue = 3, d8 = /* @__PURE__ */ new WeakMap();
function zi(e, t = "this") {
  let r = d8.get(e);
  return QH(r != null, "'%s' must be an object that Event constructor created, but got another one: %o", t, e), r;
}
function Rue(e) {
  if (e.inPassiveListenerFlag) {
    $4r.warn();
    return;
  }
  if (!e.cancelable) {
    H4r.warn();
    return;
  }
  e.canceledFlag = !0;
}
Object.defineProperty(gs, "NONE", { enumerable: !0 });
Object.defineProperty(gs, "CAPTURING_PHASE", { enumerable: !0 });
Object.defineProperty(gs, "AT_TARGET", { enumerable: !0 });
Object.defineProperty(gs, "BUBBLING_PHASE", { enumerable: !0 });
var g5 = Object.getOwnPropertyNames(gs.prototype);
for (let e = 0; e < g5.length; ++e) g5[e] !== "constructor" && Object.defineProperty(gs.prototype, g5[e], { enumerable: !0 });
typeof Es < "u" && typeof Es.Event < "u" && Object.setPrototypeOf(gs.prototype, Es.Event.prototype);
function j4r(e) {
  return Es.DOMException ? new Es.DOMException(e, "InvalidStateError") : (Xd == null && (Xd = class fSe extends Error {
    constructor(r) {
      super(r), Error.captureStackTrace && Error.captureStackTrace(this, fSe);
    }
    get code() {
      return 11;
    }
    get name() {
      return "InvalidStateError";
    }
  }, Object.defineProperties(Xd.prototype, { code: { enumerable: !0 }, name: { enumerable: !0 } }), Pue(Xd), Pue(Xd.prototype)), new Xd(e));
}
var Xd, wue = { INDEX_SIZE_ERR: 1, DOMSTRING_SIZE_ERR: 2, HIERARCHY_REQUEST_ERR: 3, WRONG_DOCUMENT_ERR: 4, INVALID_CHARACTER_ERR: 5, NO_DATA_ALLOWED_ERR: 6, NO_MODIFICATION_ALLOWED_ERR: 7, NOT_FOUND_ERR: 8, NOT_SUPPORTED_ERR: 9, INUSE_ATTRIBUTE_ERR: 10, INVALID_STATE_ERR: 11, SYNTAX_ERR: 12, INVALID_MODIFICATION_ERR: 13, NAMESPACE_ERR: 14, INVALID_ACCESS_ERR: 15, VALIDATION_ERR: 16, TYPE_MISMATCH_ERR: 17, SECURITY_ERR: 18, NETWORK_ERR: 19, ABORT_ERR: 20, URL_MISMATCH_ERR: 21, QUOTA_EXCEEDED_ERR: 22, TIMEOUT_ERR: 23, INVALID_NODE_TYPE_ERR: 24, DATA_CLONE_ERR: 25 };
function Pue(e) {
  let t = Object.keys(wue);
  for (let r = 0; r < t.length; ++r) {
    let n = t[r], i = wue[n];
    Object.defineProperty(e, n, { get() {
      return i;
    }, configurable: !0, enumerable: !0 });
  }
}
var r2 = class extends gs {
  static wrap(e) {
    return new (pSe(e))(e);
  }
  constructor(e) {
    super(e.type, { bubbles: e.bubbles, cancelable: e.cancelable, composed: e.composed }), e.cancelBubble && super.stopPropagation(), e.defaultPrevented && super.preventDefault(), dSe.set(this, { original: e });
    let t = Object.keys(e);
    for (let r = 0; r < t.length; ++r) {
      let n = t[r];
      n in this || Object.defineProperty(this, n, hSe(e, n));
    }
  }
  stopPropagation() {
    super.stopPropagation();
    let { original: e } = Hl(this);
    "stopPropagation" in e && e.stopPropagation();
  }
  get cancelBubble() {
    return super.cancelBubble;
  }
  set cancelBubble(e) {
    super.cancelBubble = e;
    let { original: t } = Hl(this);
    "cancelBubble" in t && (t.cancelBubble = e);
  }
  stopImmediatePropagation() {
    super.stopImmediatePropagation();
    let { original: e } = Hl(this);
    "stopImmediatePropagation" in e && e.stopImmediatePropagation();
  }
  get returnValue() {
    return super.returnValue;
  }
  set returnValue(e) {
    super.returnValue = e;
    let { original: t } = Hl(this);
    "returnValue" in t && (t.returnValue = e);
  }
  preventDefault() {
    super.preventDefault();
    let { original: e } = Hl(this);
    "preventDefault" in e && e.preventDefault();
  }
  get timeStamp() {
    let { original: e } = Hl(this);
    return "timeStamp" in e ? e.timeStamp : super.timeStamp;
  }
}, dSe = /* @__PURE__ */ new WeakMap();
function Hl(e) {
  let t = dSe.get(e);
  return QH(t != null, "'this' is expected an Event object, but got", e), t;
}
var lb = /* @__PURE__ */ new WeakMap();
lb.set(Object.prototype, r2);
typeof Es < "u" && typeof Es.Event < "u" && lb.set(Es.Event.prototype, r2);
function pSe(e) {
  let t = Object.getPrototypeOf(e);
  if (t == null) return r2;
  let r = lb.get(t);
  return r == null && (r = z4r(pSe(t), t), lb.set(t, r)), r;
}
function z4r(e, t) {
  class r extends e {
  }
  let n = Object.keys(t);
  for (let i = 0; i < n.length; ++i) Object.defineProperty(r.prototype, n[i], hSe(t, n[i]));
  return r;
}
function hSe(e, t) {
  let r = Object.getOwnPropertyDescriptor(e, t);
  return { get() {
    let n = Hl(this).original, i = n[t];
    return typeof i == "function" ? i.bind(n) : i;
  }, set(n) {
    let i = Hl(this).original;
    i[t] = n;
  }, configurable: r.configurable, enumerable: r.enumerable };
}
function q4r(e, t, r, n, i, o) {
  return { callback: e, flags: (t ? 1 : 0) | (r ? 2 : 0) | (n ? 4 : 0), signal: i, signalListener: o };
}
function Y4r(e) {
  e.flags |= 8;
}
function vSe(e) {
  return (e.flags & 1) === 1;
}
function ESe(e) {
  return (e.flags & 2) === 2;
}
function mSe(e) {
  return (e.flags & 4) === 4;
}
function G4r(e) {
  return (e.flags & 8) === 8;
}
function W4r({ callback: e }, t, r) {
  try {
    typeof e == "function" ? e.call(t, r) : typeof e.handleEvent == "function" && e.handleEvent(r);
  } catch (n) {
    L4r(n);
  }
}
function gSe({ listeners: e }, t, r) {
  for (let n = 0; n < e.length; ++n) if (e[n].callback === t && vSe(e[n]) === r) return n;
  return -1;
}
function TSe(e, t, r, n, i, o) {
  let a;
  o && (a = e$.bind(null, e, t, r), o.addEventListener("abort", a));
  let u = q4r(t, r, n, i, o, a);
  return e.cow ? (e.cow = !1, e.listeners = [...e.listeners, u]) : e.listeners.push(u), u;
}
function e$(e, t, r) {
  let n = gSe(e, t, r);
  return n !== -1 ? ySe(e, n) : !1;
}
function ySe(e, t, r = !1) {
  let n = e.listeners[t];
  return Y4r(n), n.signal && n.signal.removeEventListener("abort", n.signalListener), e.cow && !r ? (e.cow = !1, e.listeners = e.listeners.filter((i, o) => o !== t), !1) : (e.listeners.splice(t, 1), !0);
}
function K4r() {
  return /* @__PURE__ */ Object.create(null);
}
function _Se(e, t) {
  var r;
  return (r = e[t]) !== null && r !== void 0 ? r : e[t] = { attrCallback: void 0, attrListener: void 0, cow: !1, listeners: [] };
}
var n2 = class {
  constructor() {
    ASe.set(this, K4r());
  }
  addEventListener(e, t, r) {
    let n = Rp(this), { callback: i, capture: o, once: a, passive: u, signal: s, type: c } = X4r(e, t, r);
    if (i == null || s != null && s.aborted) return;
    let l = _Se(n, c), f = gSe(l, i, o);
    if (f !== -1) {
      Z4r(l.listeners[f], u, a, s);
      return;
    }
    TSe(l, i, o, u, a, s);
  }
  removeEventListener(e, t, r) {
    let n = Rp(this), { callback: i, capture: o, type: a } = J4r(e, t, r), u = n[a];
    i != null && u && e$(u, i, o);
  }
  dispatchEvent(e) {
    let t = Rp(this)[String(e.type)];
    if (t == null) return !0;
    let r = e instanceof gs ? e : r2.wrap(e), n = zi(r, "event");
    if (n.dispatchFlag) throw j4r("This event has been in dispatching.");
    if (n.dispatchFlag = !0, n.target = n.currentTarget = this, !n.stopPropagationFlag) {
      let { cow: i, listeners: o } = t;
      t.cow = !0;
      for (let a = 0; a < o.length; ++a) {
        let u = o[a];
        if (!G4r(u) && (mSe(u) && ySe(t, a, !i) && (a -= 1), n.inPassiveListenerFlag = ESe(u), W4r(u, this, r), n.inPassiveListenerFlag = !1, n.stopImmediatePropagationFlag)) break;
      }
      i || (t.cow = !1);
    }
    return n.target = null, n.currentTarget = null, n.stopImmediatePropagationFlag = !1, n.stopPropagationFlag = !1, n.dispatchFlag = !1, !n.canceledFlag;
  }
}, ASe = /* @__PURE__ */ new WeakMap();
function Rp(e, t = "this") {
  let r = ASe.get(e);
  return QH(r != null, "'%s' must be an object that EventTarget constructor created, but got another one: %o", t, e), r;
}
function X4r(e, t, r) {
  var n;
  return SSe(t), typeof r == "object" && r !== null ? { type: String(e), callback: t ?? void 0, capture: !!r.capture, passive: !!r.passive, once: !!r.once, signal: (n = r.signal) !== null && n !== void 0 ? n : void 0 } : { type: String(e), callback: t ?? void 0, capture: !!r, passive: !1, once: !1, signal: void 0 };
}
function J4r(e, t, r) {
  return SSe(t), typeof r == "object" && r !== null ? { type: String(e), callback: t ?? void 0, capture: !!r.capture } : { type: String(e), callback: t ?? void 0, capture: !!r };
}
function SSe(e) {
  if (!(typeof e == "function" || typeof e == "object" && e !== null && typeof e.handleEvent == "function")) {
    if (e == null || typeof e == "object") {
      Sue.warn(e);
      return;
    }
    throw new TypeError(cSe(Sue.message, [e]));
  }
}
function Z4r(e, t, r, n) {
  U4r.warn(vSe(e) ? "capture" : "bubble", e.callback), ESe(e) !== t && m5.warn("passive"), mSe(e) !== r && m5.warn("once"), e.signal !== n && m5.warn("signal");
}
var T5 = Object.getOwnPropertyNames(n2.prototype);
for (let e = 0; e < T5.length; ++e) T5[e] !== "constructor" && Object.defineProperty(n2.prototype, T5[e], { enumerable: !0 });
typeof Es < "u" && typeof Es.EventTarget < "u" && Object.setPrototypeOf(n2.prototype, Es.EventTarget.prototype);
function f1(e, t) {
  var r, n;
  return (n = (r = Rp(e, "target")[t]) === null || r === void 0 ? void 0 : r.attrCallback) !== null && n !== void 0 ? n : null;
}
function d1(e, t, r) {
  r != null && typeof r != "function" && V4r.warn(r), typeof r == "function" || typeof r == "object" && r !== null ? Q4r(e, t, r) : eSr(e, t);
}
function Q4r(e, t, r) {
  let n = _Se(Rp(e, "target"), String(t));
  n.attrCallback = r, n.attrListener == null && (n.attrListener = TSe(n, tSr(n), !1, !1, !1, void 0));
}
function eSr(e, t) {
  let r = Rp(e, "target")[String(t)];
  r && r.attrListener && (e$(r, r.attrListener.callback, !1), r.attrCallback = r.attrListener = void 0);
}
function tSr(e) {
  return function(t) {
    let r = e.attrCallback;
    typeof r == "function" && r.call(this, t);
  };
}
var bSe = n2;
function rSr(e) {
  let t = e.numberOfChannels;
  for (let r = 0; r < t; r++) {
    let n = e.getChannelData(r);
    [].fill.call(n, 0);
  }
}
function nSr(e, t) {
  let r = e.numberOfChannels;
  for (let n = 0; n < r; n++) {
    let i = t[+n];
    if (e.copyToChannel) e.copyToChannel(i, n);
    else {
      let { length: o } = i, a = e.getChannelData(n);
      for (let u = 0; u < o; u++) a[+u] = i[+u];
    }
  }
}
function iSr(e, { channels: t, samplesPerSec: r }, n) {
  let i = new Array(3).fill().map(() => e.createBuffer(t, n, r)), o = [], a, u = [], s = () => {
    typeof a != "number" && (a = e.currentTime);
    let c = e.createBufferSource(), l = u.shift();
    if (typeof l == "function") l();
    else if (l) {
      let f = i.shift();
      if (!f) {
        u.unshift(l);
        return;
      }
      rSr(f), nSr(f, l), c.buffer = f, c.connect(e.destination), c.start(a), o.push(c), a += f.duration, c.addEventListener("ended", () => {
        o = o.filter((d) => d !== c), i.push(f), s();
      });
    }
  };
  return { cancelAll: () => {
    u.splice(0), o.forEach((c) => c.stop());
  }, flush: () => new Promise((c) => u.push(c)), push: (c) => {
    if (!c) throw new Error("multiChannelArray must not be falsy.");
    u.push(c), s();
  } };
}
var oSr = 44100, Due = 4096;
function aSr(e) {
  return e.reduce((t, r) => t + r, 0) / e.length;
}
function y5(e, t) {
  let r = new Float32Array(e.length);
  for (let n = 0; n < e.length; n++) r[+n] = e[+n] / t;
  return r;
}
function uSr({ bitsPerSample: e }, t) {
  switch (e) {
    case 8:
      return y5(new Int8Array(t), 128);
    case 16:
      return y5(new Int16Array(t), 32768);
    case 32:
      return y5(new Int32Array(t), 2147483648);
    default:
      throw new Error("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
  }
}
function sSr(e) {
  return new Promise((t, r) => {
    e.onabort = () => r(new Error("aborted"));
  });
}
function cSr(e, { channels: t }) {
  let r = new Array(t), n = e.length / t;
  for (let i = 0; i < t; i++) {
    let o = new Float32Array(n);
    r[+i] = o;
    for (let a = 0; a < n; a++) o[+a] = e[a * t + i];
  }
  return r;
}
function lSr(e, t) {
  if (t === 1) return e;
  let r = new Array(t).fill(e[0]), n = new Float32Array(e.length * t);
  for (let i = 0; i < e.length; i++) {
    let o = e[+i], a = i * t;
    for (let u = 0; u < t; u++) r.shift(), r.push(o), n[a + u] = aSr(r);
  }
  return n;
}
async function fSr(e, t, { signal: r = {} } = {}) {
  if (e) if (t) if (t.format) {
    if (typeof t.read != "function") throw new Error("botframework-directlinespeech-sdk: stream is missing read().");
  } else throw new Error("botframework-directlinespeech-sdk: stream is missing format.");
  else throw new Error("botframework-directlinespeech-sdk: stream must be specified.");
  else throw new Error("botframework-directlinespeech-sdk: audioContext must be specified.");
  let n = [];
  try {
    let { format: i } = t, o = sSr(r), a = new Uint8Array(Due), u = () => Promise.race([o.catch(() => {
    }), t.read(a.buffer).then((d) => d === a.byteLength ? a : d ? a.slice(0, d) : void 0)]);
    if (r.aborted) throw new Error("aborted");
    let { samplesPerSec: s } = i;
    i.requestAudioFormatString === "audio-24khz-48kbitrate-mono-mp3" && (s = 16e3);
    let c = s, l = 1;
    for (; c < oSr && c < 96e3; ) l++, c = s * l;
    let f = iSr(e, { ...i, samplesPerSec: c }, Due / (i.bitsPerSample / 8) * l);
    for (let d = await u(), p = 0; d && p < 1e3 && !r.aborted && !r.aborted; d = await u(), p++) {
      let v = uSr(i, d.buffer), h = cSr(v, i).map((E) => lSr(E, l));
      f.push(h);
    }
    if (o.catch(() => f.cancelAll()), r.aborted) throw new Error("aborted");
    await Promise.race([o, f.flush()]);
  } finally {
    n.forEach((i) => i.stop());
  }
}
var dSr = "SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
function pSr(e, t, r) {
  return e.addEventListener(t, r), () => e.removeEventListener(t, r);
}
function hSr(e, t) {
  return new Promise((r, n) => {
    let i = e.decodeAudioData(t, r, n);
    i && typeof i.then == "function" && r(i);
  });
}
function vSr(e, t, r) {
  return new Promise((n, i) => {
    let o = new Gae(), a = new Gae(), u = pSr(e, "statechange", ({ target: { state: s } }) => s === "closed" && o.eventListener());
    try {
      r.buffer = t, r.onended = a.eventListener, r.connect(e.destination), r.start(0), Promise.race([o.upcoming(), a.upcoming()]).then(n);
    } catch (s) {
      i(s);
    } finally {
      u();
    }
  });
}
async function ESr(e) {
  let t = e.createBufferSource(), r = await hSr(e, iyr(dSr));
  await vSr(e, r, t);
}
var mSr = class extends bSe {
  constructor(e) {
    if (super(), e && !(e.format && typeof e.read == "function")) throw new Error("botframework-directlinespeech-sdk: If the first argument is specified, it must be a Cognitive Services audio stream.");
    this.audioStream = e;
  }
  get onboundary() {
    return f1(this, "boundary");
  }
  set onboundary(e) {
    d1(this, "boundary", e);
  }
  get onend() {
    return f1(this, "end");
  }
  set onend(e) {
    d1(this, "end", e);
  }
  get onerror() {
    return f1(this, "error");
  }
  set onerror(e) {
    d1(this, "error", e);
  }
  get onstart() {
    return f1(this, "start");
  }
  set onstart(e) {
    d1(this, "start", e);
  }
}, CSe = mSr;
function gSr({ audioContext: e, enableTelemetry: t, ponyfill: r = { AudioContext: window.AudioContext || window.webkitAudioContext }, recognizer: n, textNormalization: i }) {
  return r.AudioContext ? () => {
    let { SpeechGrammarList: o, SpeechRecognition: a } = $Ae.createSpeechRecognitionPonyfillFromRecognizer({ createRecognizer: () => n, enableTelemetry: t, looseEvents: !0, textNormalization: i });
    e || (e = new r.AudioContext());
    let { cancelAll: u, push: s } = x4r();
    class c extends bSe {
      cancel() {
        u();
      }
      getVoices() {
        return [];
      }
      speak(f) {
        let { result: d } = s(() => {
          let p = new mmr(), { signal: v } = p;
          return { abort: p.abort.bind(p), result: (async () => {
            f.dispatchEvent(new gs("start"));
            try {
              f.audioStream ? await fSr(e, f.audioStream, { signal: v }) : await ESr(e);
            } catch (h) {
              if (h.message !== "aborted") return f.dispatchEvent(new ErrorEvent(h));
            }
            f.dispatchEvent(new gs("end"));
          })() };
        });
        d.catch((p) => {
          if (!/^cancelled/iu.test(p.message)) throw p;
        });
      }
      get onvoiceschanged() {
        return f1(this, "voiceschanged");
      }
      set onvoiceschanged(f) {
        d1(this, "voiceschanged", f);
      }
    }
    return { SpeechGrammarList: o, SpeechRecognition: a, speechSynthesis: new c(), SpeechSynthesisUtterance: CSe };
  } : (console.warn("botframework-directlinespeech-sdk: This browser does not support Web Audio API. Speech support is disabled."), () => ({}));
}
function xue(e) {
  let t = [], r;
  return new Observable((n) => (r || (r = e.subscribe({ complete() {
    t.forEach((i) => i.complete());
  }, error(i) {
    t.forEach((o) => o.error(i));
  }, next(i) {
    t.forEach((o) => o.next(i));
  } })), t.push(n), () => {
    t = t.filter((i) => i !== n), t.length || (r.unsubscribe(), r = null);
  }));
}
function TSr() {
  return Mu().toString(36).substr(2);
}
var ySr = class {
  constructor({ dialogServiceConnector: t }) {
    let r;
    this.dialogServiceConnector = t, this.activity$ = xue(new t4((n) => {
      this._activityObserver = n, r.next(0), r.next(1), t.connect(() => {
        r.next(2);
      }, (i) => {
        r.next(4), console.warn("botframework-directlinespeech-sdk: Failed to connect", { error: i });
      });
    })), this.connectionStatus$ = xue(new t4((n) => {
      r = n;
    })), t.activityReceived = (n, { activity: i, audioStream: o }) => {
      try {
        this._activityObserver && this._activityObserver.next({ ...i, channelData: { ...i.channelData, speechSynthesisUtterance: new CSe(o) }, from: { ...i.from, role: "bot" }, replyToId: void 0, timestamp: (/* @__PURE__ */ new Date()).toISOString() });
      } catch (a) {
        console.error(a);
      }
    };
  }
  end() {
    try {
      this.dialogServiceConnector.close();
    } catch (t) {
      if (!~t.message.indexOf("already disposed")) throw t;
    }
  }
  postActivity(t) {
    var r;
    t = { ...t, from: { role: "user" } };
    try {
      let n = TSr();
      return (r = t.channelData) != null && r.speech || this.dialogServiceConnector.sendActivityAsync(JSON.stringify(t)), this._activityObserver && this._activityObserver.next({ ...t, id: n, timestamp: (/* @__PURE__ */ new Date()).toISOString() }), t4.of(n);
    } catch (n) {
      return new t4((i) => i.error(n));
    }
  }
};
function _5(e, t, r) {
  return (...n) => {
    n = t ? t(...n) : n;
    let i = e(...n);
    return r ? r(i) : i;
  };
}
function _Sr(e) {
  let t;
  return e.listenOnceAsync = _5(e.listenOnceAsync.bind(e), (r, n, ...i) => (t = F1(), [_5(r, null, (o) => (t.resolve(o), o)), _5(n, null, (o) => (t.reject(o), o)), ...i])), e.startContinuousRecognitionAsync = (r, n) => {
    e.listenOnceAsync(() => {
    }, (i) => {
      r = null, n && n(i);
    }), setTimeout(() => {
      n = null, r && r();
    }, 0);
  }, e;
}
async function ASr(e, t) {
  let r = await fetch(e, { ...t, headers: { ...t.headers, accept: "application/json" } });
  if (!r.ok) throw new Error(`Failed to fetch JSON from server due to ${r.status}`);
  return r.json();
}
async function SSr(e) {
  let { token: t } = await ASr("https://directline.botframework.com/v3/directline/tokens/refresh", { headers: { authorization: `Bearer ${e}` }, method: "POST" });
  return t;
}
function Nue(e) {
  return typeof e == "function" ? e() : e;
}
var bSr = 9e5, CSr = 12e4;
async function ISr({ audioConfig: e, audioContext: t, audioInputDeviceId: r, enableInternalHTTPSupport: n, enableTelemetry: i, fetchCredentials: o, speechRecognitionEndpointId: a, speechRecognitionLanguage: u = typeof window < "u" && typeof window.navigator < "u" && window.navigator.language || "en-US", speechSynthesisDeploymentId: s, speechSynthesisOutputFormat: c, textNormalization: l, userID: f, username: d }) {
  if (!o) throw new Error('"fetchCredentials" must be specified.');
  let { authorizationToken: p, directLineToken: v, directLineSpeechHostname: h, region: E, subscriptionKey: m } = await Nue(o);
  if (!p && !m || p && m || p && typeof p != "string" || m && typeof m != "string" || n && !v) throw new Error('"fetchCredentials" must return either "authorizationToken" or "subscriptionKey" as a non-empty string only. If enableInternalHTTPSupport is set to true, then it should also return a non-empty "directLineToken"');
  if (typeof i < "u" && console.warn("botframework-directlinespeech: Telemetry options are not yet supported. Please refer to Cognitive Services documentation for details."), h && E || !h && !E) throw new Error('"fetchCredentials" must return either "directLineSpeechHostname" or "region" and it must not be an empty string.');
  if (h) {
    if (typeof h != "string") throw new Error('"fetchCredentials" must return "directLineSpeechHostname" as a string.');
    if (n) throw new Error('"fetchCredentials" must not return "directLineSpeechHostname" if "enableInternalHTTPSupport" is set.');
  } else if (typeof E != "string") throw new Error('"fetchCredentials" must return "region" as a string.');
  e && r ? console.warn('botframework-directlinespeech-sdk: Only "audioConfig" or "audioInputDeviceId" can be specified, but not both; ignoring "audioInputDeviceId".') : e || (r ? e = sT.fromMicrophoneInput(r) : e = sT.fromDefaultMicrophoneInput()), a && console.warn('botframework-directlinespeech: Custom Speech is currently not supported; ignoring "speechRecognitionEndpointId".'), s && console.warn('botframework-directlinespeech: Custom Voice is currently not supported; ignoring "speechSynthesisDeploymentId".'), c && console.warn('botframework-directlinespeech: Synthesis output format is currently not supported; ignoring "speechSynthesisOutputFormat".'), l && console.warn('botframework-directlinespeech: Text normalization is currently not supported; ignoring "textNormalization".'), (f || d) && console.warn('botframework-directlinespeech: Custom "userId" and "username" are currently not supported and are ignored.');
  let g;
  h ? p ? (g = NA.fromHost(new URL(`wss://${h}`)), g.setProperty(Lt.SpeechServiceAuthorization_Token, p)) : g = NA.fromHost(new URL(`wss://${h}`), m) : (p ? g = NA.fromAuthorizationToken(p, E) : g = NA.fromSubscription(m, E), n && (g.setProperty(Lt.SpeechServiceConnection_Endpoint, `wss://${encodeURI(E)}.convai.speech.microsoft.com/directline/api/v1`), g.setProperty(Lt.Conversation_Agent_Connection_Id, v))), g.setProperty(Lt.SpeechServiceConnection_RecoLanguage, u), f && g.setProperty(Lt.Conversation_From_Id, f);
  let y = _Sr(new Thr(g, e));
  if (p) {
    let A = setInterval(async () => {
      y.privIsDisposed && clearInterval(A);
      let { authorizationToken: O, directLineSpeechHostname: P, region: U } = await Nue(o);
      if (!O) return console.warn('botframework-directlinespeech-sdk: Renew token failed because "fetchCredentials" call returned no authorization token.');
      if (h) {
        if (h !== P) return console.warn('botframework-directlinespeech-sdk: "directLineSpeechHostname" change is not supported for renewed token. Authorization token is not renewed.');
      } else if (E !== U) return console.warn("botframework-directlinespeech-sdk: Region change is not supported for renewed token. Authorization token is not renewed.");
      y.authorizationToken = O;
    }, CSr);
  }
  if (n) {
    let A = setInterval(async () => {
      y.privIsDisposed && clearInterval(A);
      let O = await SSr(v);
      if (!O) return console.warn("botframework-directlinespeech-sdk: Renew token failed because call to refresh token Direct Line API did not return a new token.");
      g.setProperty(Lt.Conversation_Agent_Connection_Id, O), y.properties.setProperty(Lt.Conversation_Agent_Connection_Id, O), y.connect();
    }, bSr);
  }
  let _ = new ySr({ dialogServiceConnector: y }), S = gSr({ audioContext: t, enableTelemetry: i, recognizer: y, textNormalization: l });
  return { directLine: _, webSpeechPonyfillFactory: S };
}
var OSr = "tsup", RSr = "esmodules";
if (typeof HTMLDocument < "u" && typeof document < "u" && document instanceof HTMLDocument) {
  let e = "4.18.0", t = document.createElement("meta");
  t.setAttribute("name", "botframework-directlinespeech:version"), t.setAttribute("content", e), document.head.appendChild(t);
  let r = document.createElement("meta");
  r.setAttribute("name", "botframework-directlinespeech"), r.setAttribute("content", `version=${e}; build_tool=${OSr}; format=${RSr}`), document.head.appendChild(r);
}
/*! For license information please see botframework-directlinespeech-sdk.mjs.LEGAL.txt */
var Oo = ot((e, t) => {
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Wy = ot((e, t) => {
  function r(n) {
    "@babel/helpers - typeof";
    return t.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
      return typeof i;
    } : function(i) {
      return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), E0 = ot((e, t) => {
  function r(n, i, o) {
    return i in n ? Object.defineProperty(n, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : n[i] = o, n;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), wSr = ot((e, t) => {
  var r = Wy().default;
  function n() {
    t.exports = n = function() {
      return i;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
    var i = {}, o = Object.prototype, a = o.hasOwnProperty, u = typeof Symbol == "function" ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
    function f(x, D, w) {
      return Object.defineProperty(x, D, { value: w, enumerable: !0, configurable: !0, writable: !0 }), x[D];
    }
    try {
      f({}, "");
    } catch {
      f = function(x, D, w) {
        return x[D] = w;
      };
    }
    function d(x, D, w, $) {
      var X = D && D.prototype instanceof h ? D : h, V = Object.create(X.prototype), F = new k($ || []);
      return V._invoke = /* @__PURE__ */ function(le, ae, ne) {
        var ve = "suspendedStart";
        return function(Ie, Oe) {
          if (ve === "executing") throw new Error("Generator is already running");
          if (ve === "completed") {
            if (Ie === "throw") throw Oe;
            return B();
          }
          for (ne.method = Ie, ne.arg = Oe; ; ) {
            var xe = ne.delegate;
            if (xe) {
              var ze = P(xe, ne);
              if (ze) {
                if (ze === v) continue;
                return ze;
              }
            }
            if (ne.method === "next") ne.sent = ne._sent = ne.arg;
            else if (ne.method === "throw") {
              if (ve === "suspendedStart") throw ve = "completed", ne.arg;
              ne.dispatchException(ne.arg);
            } else ne.method === "return" && ne.abrupt("return", ne.arg);
            ve = "executing";
            var qe = p(le, ae, ne);
            if (qe.type === "normal") {
              if (ve = ne.done ? "completed" : "suspendedYield", qe.arg === v) continue;
              return { value: qe.arg, done: ne.done };
            }
            qe.type === "throw" && (ve = "completed", ne.method = "throw", ne.arg = qe.arg);
          }
        };
      }(x, w, F), V;
    }
    function p(x, D, w) {
      try {
        return { type: "normal", arg: x.call(D, w) };
      } catch ($) {
        return { type: "throw", arg: $ };
      }
    }
    i.wrap = d;
    var v = {};
    function h() {
    }
    function E() {
    }
    function m() {
    }
    var g = {};
    f(g, s, function() {
      return this;
    });
    var y = Object.getPrototypeOf, _ = y && y(y(H([])));
    _ && _ !== o && a.call(_, s) && (g = _);
    var S = m.prototype = h.prototype = Object.create(g);
    function A(x) {
      ["next", "throw", "return"].forEach(function(D) {
        f(x, D, function(w) {
          return this._invoke(D, w);
        });
      });
    }
    function O(x, D) {
      function w(X, V, F, le) {
        var ae = p(x[X], x, V);
        if (ae.type !== "throw") {
          var ne = ae.arg, ve = ne.value;
          return ve && r(ve) == "object" && a.call(ve, "__await") ? D.resolve(ve.__await).then(function(Ie) {
            w("next", Ie, F, le);
          }, function(Ie) {
            w("throw", Ie, F, le);
          }) : D.resolve(ve).then(function(Ie) {
            ne.value = Ie, F(ne);
          }, function(Ie) {
            return w("throw", Ie, F, le);
          });
        }
        le(ae.arg);
      }
      var $;
      this._invoke = function(X, V) {
        function F() {
          return new D(function(le, ae) {
            w(X, V, le, ae);
          });
        }
        return $ = $ ? $.then(F, F) : F();
      };
    }
    function P(x, D) {
      var w = x.iterator[D.method];
      if (w === void 0) {
        if (D.delegate = null, D.method === "throw") {
          if (x.iterator.return && (D.method = "return", D.arg = void 0, P(x, D), D.method === "throw")) return v;
          D.method = "throw", D.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return v;
      }
      var $ = p(w, x.iterator, D.arg);
      if ($.type === "throw") return D.method = "throw", D.arg = $.arg, D.delegate = null, v;
      var X = $.arg;
      return X ? X.done ? (D[x.resultName] = X.value, D.next = x.nextLoc, D.method !== "return" && (D.method = "next", D.arg = void 0), D.delegate = null, v) : X : (D.method = "throw", D.arg = new TypeError("iterator result is not an object"), D.delegate = null, v);
    }
    function U(x) {
      var D = { tryLoc: x[0] };
      1 in x && (D.catchLoc = x[1]), 2 in x && (D.finallyLoc = x[2], D.afterLoc = x[3]), this.tryEntries.push(D);
    }
    function z(x) {
      var D = x.completion || {};
      D.type = "normal", delete D.arg, x.completion = D;
    }
    function k(x) {
      this.tryEntries = [{ tryLoc: "root" }], x.forEach(U, this), this.reset(!0);
    }
    function H(x) {
      if (x) {
        var D = x[s];
        if (D) return D.call(x);
        if (typeof x.next == "function") return x;
        if (!isNaN(x.length)) {
          var w = -1, $ = function X() {
            for (; ++w < x.length; ) if (a.call(x, w)) return X.value = x[w], X.done = !1, X;
            return X.value = void 0, X.done = !0, X;
          };
          return $.next = $;
        }
      }
      return { next: B };
    }
    function B() {
      return { value: void 0, done: !0 };
    }
    return E.prototype = m, f(S, "constructor", m), f(m, "constructor", E), E.displayName = f(m, l, "GeneratorFunction"), i.isGeneratorFunction = function(x) {
      var D = typeof x == "function" && x.constructor;
      return !!D && (D === E || (D.displayName || D.name) === "GeneratorFunction");
    }, i.mark = function(x) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(x, m) : (x.__proto__ = m, f(x, l, "GeneratorFunction")), x.prototype = Object.create(S), x;
    }, i.awrap = function(x) {
      return { __await: x };
    }, A(O.prototype), f(O.prototype, c, function() {
      return this;
    }), i.AsyncIterator = O, i.async = function(x, D, w, $, X) {
      X === void 0 && (X = Promise);
      var V = new O(d(x, D, w, $), X);
      return i.isGeneratorFunction(D) ? V : V.next().then(function(F) {
        return F.done ? F.value : V.next();
      });
    }, A(S), f(S, l, "Generator"), f(S, s, function() {
      return this;
    }), f(S, "toString", function() {
      return "[object Generator]";
    }), i.keys = function(x) {
      var D = [];
      for (var w in x) D.push(w);
      return D.reverse(), function $() {
        for (; D.length; ) {
          var X = D.pop();
          if (X in x) return $.value = X, $.done = !1, $;
        }
        return $.done = !0, $;
      };
    }, i.values = H, k.prototype = { constructor: k, reset: function(x) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(z), !x) for (var D in this) D.charAt(0) === "t" && a.call(this, D) && !isNaN(+D.slice(1)) && (this[D] = void 0);
    }, stop: function() {
      this.done = !0;
      var x = this.tryEntries[0].completion;
      if (x.type === "throw") throw x.arg;
      return this.rval;
    }, dispatchException: function(x) {
      if (this.done) throw x;
      var D = this;
      function w(ae, ne) {
        return V.type = "throw", V.arg = x, D.next = ae, ne && (D.method = "next", D.arg = void 0), !!ne;
      }
      for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
        var X = this.tryEntries[$], V = X.completion;
        if (X.tryLoc === "root") return w("end");
        if (X.tryLoc <= this.prev) {
          var F = a.call(X, "catchLoc"), le = a.call(X, "finallyLoc");
          if (F && le) {
            if (this.prev < X.catchLoc) return w(X.catchLoc, !0);
            if (this.prev < X.finallyLoc) return w(X.finallyLoc);
          } else if (F) {
            if (this.prev < X.catchLoc) return w(X.catchLoc, !0);
          } else {
            if (!le) throw new Error("try statement without catch or finally");
            if (this.prev < X.finallyLoc) return w(X.finallyLoc);
          }
        }
      }
    }, abrupt: function(x, D) {
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var $ = this.tryEntries[w];
        if ($.tryLoc <= this.prev && a.call($, "finallyLoc") && this.prev < $.finallyLoc) {
          var X = $;
          break;
        }
      }
      X && (x === "break" || x === "continue") && X.tryLoc <= D && D <= X.finallyLoc && (X = null);
      var V = X ? X.completion : {};
      return V.type = x, V.arg = D, X ? (this.method = "next", this.next = X.finallyLoc, v) : this.complete(V);
    }, complete: function(x, D) {
      if (x.type === "throw") throw x.arg;
      return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && D && (this.next = D), v;
    }, finish: function(x) {
      for (var D = this.tryEntries.length - 1; D >= 0; --D) {
        var w = this.tryEntries[D];
        if (w.finallyLoc === x) return this.complete(w.completion, w.afterLoc), z(w), v;
      }
    }, catch: function(x) {
      for (var D = this.tryEntries.length - 1; D >= 0; --D) {
        var w = this.tryEntries[D];
        if (w.tryLoc === x) {
          var $ = w.completion;
          if ($.type === "throw") {
            var X = $.arg;
            z(w);
          }
          return X;
        }
      }
      throw new Error("illegal catch attempt");
    }, delegateYield: function(x, D, w) {
      return this.delegate = { iterator: H(x), resultName: D, nextLoc: w }, this.method === "next" && (this.arg = void 0), v;
    } }, i;
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Ec = ot((e, t) => {
  var r = wSr()();
  t.exports = r;
  try {
    regeneratorRuntime = r;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
  }
}), ISe = ot((e, t) => {
  function r(n, i) {
    (i == null || i > n.length) && (i = n.length);
    for (var o = 0, a = new Array(i); o < i; o++) a[o] = n[o];
    return a;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), PSr = ot((e, t) => {
  var r = ISe();
  function n(i) {
    if (Array.isArray(i)) return r(i);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), DSr = ot((e, t) => {
  function r(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), xSr = ot((e, t) => {
  var r = ISe();
  function n(i, o) {
    if (i) {
      if (typeof i == "string") return r(i, o);
      var a = Object.prototype.toString.call(i).slice(8, -1);
      if (a === "Object" && i.constructor && (a = i.constructor.name), a === "Map" || a === "Set") return Array.from(i);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return r(i, o);
    }
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), NSr = ot((e, t) => {
  function r() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), OSe = ot((e, t) => {
  var r = PSr(), n = DSr(), i = xSr(), o = NSr();
  function a(u) {
    return r(u) || n(u) || i(u) || o();
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
}), mc = ot((e, t) => {
  function r(i, o, a, u, s, c, l) {
    try {
      var f = i[c](l), d = f.value;
    } catch (p) {
      a(p);
      return;
    }
    f.done ? o(d) : Promise.resolve(d).then(u, s);
  }
  function n(i) {
    return function() {
      var o = this, a = arguments;
      return new Promise(function(u, s) {
        var c = i.apply(o, a);
        function l(d) {
          r(c, u, s, l, f, "next", d);
        }
        function f(d) {
          r(c, u, s, l, f, "throw", d);
        }
        l(void 0);
      });
    };
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), dl = ot((e, t) => {
  function r(i, o) {
    for (var a = 0; a < o.length; a++) {
      var u = o[a];
      u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(i, u.key, u);
    }
  }
  function n(i, o, a) {
    return o && r(i.prototype, o), a && r(i, a), Object.defineProperty(i, "prototype", { writable: !1 }), i;
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), pl = ot((e, t) => {
  function r(n, i) {
    if (!(n instanceof i)) throw new TypeError("Cannot call a class as a function");
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), t$ = ot((e, t) => {
  function r(n, i) {
    return t.exports = r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, a) {
      return o.__proto__ = a, o;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n, i);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Ky = ot((e, t) => {
  var r = t$();
  function n(i, o) {
    if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function");
    i.prototype = Object.create(o && o.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), Object.defineProperty(i, "prototype", { writable: !1 }), o && r(i, o);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), RSe = ot((e, t) => {
  function r(n) {
    if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Xy = ot((e, t) => {
  var r = Wy().default, n = RSe();
  function i(o, a) {
    if (a && (r(a) === "object" || typeof a == "function")) return a;
    if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return n(o);
  }
  t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
}), yd = ot((e, t) => {
  function r(n) {
    return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
      return i.__proto__ || Object.getPrototypeOf(i);
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), wSe = ot((e, t) => {
  var r = yd();
  function n(i, o) {
    for (; !Object.prototype.hasOwnProperty.call(i, o) && (i = r(i), i !== null); ) ;
    return i;
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), LSr = ot((e, t) => {
  var r = wSe(), n = E0();
  function i(a, u, s, c) {
    return typeof Reflect < "u" && Reflect.set ? i = Reflect.set : i = function(l, f, d, p) {
      var v = r(l, f), h;
      if (v) {
        if (h = Object.getOwnPropertyDescriptor(v, f), h.set) return h.set.call(p, d), !0;
        if (!h.writable) return !1;
      }
      if (h = Object.getOwnPropertyDescriptor(p, f), h) {
        if (!h.writable) return !1;
        h.value = d, Object.defineProperty(p, f, h);
      } else n(p, f, d);
      return !0;
    }, i(a, u, s, c);
  }
  function o(a, u, s, c, l) {
    var f = i(a, u, s, c || a);
    if (!f && l) throw new Error("failed to set property");
    return s;
  }
  t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
}), BSr = ot((e, t) => {
  var r = wSe();
  function n() {
    return typeof Reflect < "u" && Reflect.get ? (t.exports = n = Reflect.get.bind(), t.exports.__esModule = !0, t.exports.default = t.exports) : (t.exports = n = function(i, o, a) {
      var u = r(i, o);
      if (u) {
        var s = Object.getOwnPropertyDescriptor(u, o);
        return s.get ? s.get.call(arguments.length < 3 ? i : a) : s.value;
      }
    }, t.exports.__esModule = !0, t.exports.default = t.exports), n.apply(this, arguments);
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), kSr = ot((e, t) => {
  function r(n) {
    return Function.toString.call(n).indexOf("[native code]") !== -1;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), MSr = ot((e, t) => {
  function r() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), FSr = ot((e, t) => {
  var r = t$(), n = MSr();
  function i(o, a, u) {
    return n() ? (t.exports = i = Reflect.construct.bind(), t.exports.__esModule = !0, t.exports.default = t.exports) : (t.exports = i = function(s, c, l) {
      var f = [null];
      f.push.apply(f, c);
      var d = Function.bind.apply(s, f), p = new d();
      return l && r(p, l.prototype), p;
    }, t.exports.__esModule = !0, t.exports.default = t.exports), i.apply(null, arguments);
  }
  t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
}), HSr = ot((e, t) => {
  var r = yd(), n = t$(), i = kSr(), o = FSr();
  function a(u) {
    var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return t.exports = a = function(c) {
      if (c === null || !i(c)) return c;
      if (typeof c != "function") throw new TypeError("Super expression must either be null or a function");
      if (typeof s < "u") {
        if (s.has(c)) return s.get(c);
        s.set(c, l);
      }
      function l() {
        return o(c, arguments, r(this).constructor);
      }
      return l.prototype = Object.create(c.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), n(l, c);
    }, t.exports.__esModule = !0, t.exports.default = t.exports, a(u);
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
}), i2 = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = OSe(), r = LSr(), n = BSr(), i = RSe(), o = Ky(), a = Xy(), u = yd(), s = HSr(), c = E0(), l = pl(), f = dl(), d = Wy();
  function p(Pe) {
    return Pe && typeof Pe == "object" && "default" in Pe ? Pe : { default: Pe };
  }
  var v = p(t), h = p(r), E = p(n), m = p(i), g = p(o), y = p(a), _ = p(u), S = p(s), A = p(c), O = p(l), P = p(f), U = p(d);
  function z(Pe) {
    var Fe = k();
    return function() {
      var Ye = _.default(Pe), Xe;
      if (Fe) {
        var dt = _.default(this).constructor;
        Xe = Reflect.construct(Ye, arguments, dt);
      } else Xe = Ye.apply(this, arguments);
      return y.default(this, Xe);
    };
  }
  function k() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function H(Pe, Fe) {
    var Ye = Object.keys(Pe);
    if (Object.getOwnPropertySymbols) {
      var Xe = Object.getOwnPropertySymbols(Pe);
      Fe && (Xe = Xe.filter(function(dt) {
        return Object.getOwnPropertyDescriptor(Pe, dt).enumerable;
      })), Ye.push.apply(Ye, Xe);
    }
    return Ye;
  }
  function B(Pe) {
    for (var Fe = 1; Fe < arguments.length; Fe++) {
      var Ye = arguments[Fe] != null ? arguments[Fe] : {};
      Fe % 2 ? H(Object(Ye), !0).forEach(function(Xe) {
        A.default(Pe, Xe, Ye[Xe]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Pe, Object.getOwnPropertyDescriptors(Ye)) : H(Object(Ye)).forEach(function(Xe) {
        Object.defineProperty(Pe, Xe, Object.getOwnPropertyDescriptor(Ye, Xe));
      });
    }
    return Pe;
  }
  function x(Pe, Fe) {
    if (!Pe) {
      for (var Ye = arguments.length, Xe = new Array(Ye > 2 ? Ye - 2 : 0), dt = 2; dt < Ye; dt++) Xe[dt - 2] = arguments[dt];
      throw new TypeError(D(Fe, Xe));
    }
  }
  function D(Pe, Fe) {
    var Ye = 0;
    return Pe.replace(/%[os]/g, function() {
      return w(Fe[Ye++]);
    });
  }
  function w(Pe) {
    return U.default(Pe) !== "object" || Pe === null ? String(Pe) : Object.prototype.toString.call(Pe);
  }
  var $;
  function X(Pe) {
    x(typeof Pe == "function" || Pe === void 0, "The error handler must be a function or undefined, but got %o.", Pe), $ = Pe;
  }
  function V(Pe) {
    try {
      var Fe = Pe instanceof Error ? Pe : new Error(w(Pe));
      if ($) {
        $(Fe);
        return;
      }
      if (typeof dispatchEvent == "function" && typeof ErrorEvent == "function") dispatchEvent(new ErrorEvent("error", { error: Fe, message: Fe.message }));
      else if (typeof process < "u" && typeof process.emit == "function") {
        process.emit("uncaughtException", Fe);
        return;
      }
      console.error(Fe);
    } catch {
    }
  }
  var F = typeof window < "u" ? window : typeof self < "u" ? self : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : void 0, le;
  function ae(Pe) {
    x(typeof Pe == "function" || Pe === void 0, "The warning handler must be a function or undefined, but got %o.", Pe), le = Pe;
  }
  var ne = function() {
    function Pe(Fe, Ye) {
      O.default(this, Pe), this.code = Fe, this.message = Ye;
    }
    return P.default(Pe, [{ key: "warn", value: function() {
      var Fe;
      try {
        for (var Ye, Xe = arguments.length, dt = new Array(Xe), Nt = 0; Nt < Xe; Nt++) dt[Nt] = arguments[Nt];
        if (le) {
          le(B(B({}, this), {}, { args: dt }));
          return;
        }
        var er = ((Fe = new Error().stack) !== null && Fe !== void 0 ? Fe : "").replace(/^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?\n){2}/g, `
`);
        (Ye = console).warn.apply(Ye, [this.message].concat(dt, [er]));
      } catch {
      }
    } }]), Pe;
  }(), ve = new ne("W01", "Unable to initialize event under dispatching."), Ie = new ne("W02", "Assigning any falsy value to 'cancelBubble' property has no effect."), Oe = new ne("W03", "Assigning any truthy value to 'returnValue' property has no effect."), xe = new ne("W04", "Unable to preventDefault on non-cancelable events."), ze = new ne("W05", "Unable to preventDefault inside passive event listener invocation."), qe = new ne("W06", "An event listener wasn't added because it has been added already: %o, %o"), Je = new ne("W07", "The %o option value was abandoned because the event listener wasn't added as duplicated."), Be = new ne("W08", "The 'callback' argument must be a function or an object that has 'handleEvent' method: %o"), We = new ne("W09", "Event attribute handler must be a function: %o"), Ne = function() {
    P.default(Pe, null, [{ key: "NONE", get: function() {
      return je;
    } }, { key: "CAPTURING_PHASE", get: function() {
      return et;
    } }, { key: "AT_TARGET", get: function() {
      return St;
    } }, { key: "BUBBLING_PHASE", get: function() {
      return Ot;
    } }]);
    function Pe(Fe, Ye) {
      O.default(this, Pe), Object.defineProperty(this, "isTrusted", { value: !1, enumerable: !0 });
      var Xe = Ye ?? {};
      we.set(this, { type: String(Fe), bubbles: !!Xe.bubbles, cancelable: !!Xe.cancelable, composed: !!Xe.composed, target: null, currentTarget: null, stopPropagationFlag: !1, stopImmediatePropagationFlag: !1, canceledFlag: !1, inPassiveListenerFlag: !1, dispatchFlag: !1, timeStamp: Date.now() });
    }
    return P.default(Pe, [{ key: "composedPath", value: function() {
      var Fe = De(this).currentTarget;
      return Fe ? [Fe] : [];
    } }, { key: "stopPropagation", value: function() {
      De(this).stopPropagationFlag = !0;
    } }, { key: "stopImmediatePropagation", value: function() {
      var Fe = De(this);
      Fe.stopPropagationFlag = Fe.stopImmediatePropagationFlag = !0;
    } }, { key: "preventDefault", value: function() {
      Ee(De(this));
    } }, { key: "initEvent", value: function(Fe) {
      var Ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Xe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, dt = De(this);
      if (dt.dispatchFlag) {
        ve.warn();
        return;
      }
      we.set(this, B(B({}, dt), {}, { type: String(Fe), bubbles: !!Ye, cancelable: !!Xe, target: null, currentTarget: null, stopPropagationFlag: !1, stopImmediatePropagationFlag: !1, canceledFlag: !1 }));
    } }, { key: "type", get: function() {
      return De(this).type;
    } }, { key: "target", get: function() {
      return De(this).target;
    } }, { key: "srcElement", get: function() {
      return De(this).target;
    } }, { key: "currentTarget", get: function() {
      return De(this).currentTarget;
    } }, { key: "NONE", get: function() {
      return je;
    } }, { key: "CAPTURING_PHASE", get: function() {
      return et;
    } }, { key: "AT_TARGET", get: function() {
      return St;
    } }, { key: "BUBBLING_PHASE", get: function() {
      return Ot;
    } }, { key: "eventPhase", get: function() {
      return De(this).dispatchFlag ? 2 : 0;
    } }, { key: "cancelBubble", get: function() {
      return De(this).stopPropagationFlag;
    }, set: function(Fe) {
      Fe ? De(this).stopPropagationFlag = !0 : Ie.warn();
    } }, { key: "bubbles", get: function() {
      return De(this).bubbles;
    } }, { key: "cancelable", get: function() {
      return De(this).cancelable;
    } }, { key: "returnValue", get: function() {
      return !De(this).canceledFlag;
    }, set: function(Fe) {
      Fe ? Oe.warn() : Ee(De(this));
    } }, { key: "defaultPrevented", get: function() {
      return De(this).canceledFlag;
    } }, { key: "composed", get: function() {
      return De(this).composed;
    } }, { key: "isTrusted", get: function() {
      return !1;
    } }, { key: "timeStamp", get: function() {
      return De(this).timeStamp;
    } }]), Pe;
  }(), je = 0, et = 1, St = 2, Ot = 3, we = /* @__PURE__ */ new WeakMap();
  function De(Pe) {
    var Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "this", Ye = we.get(Pe);
    return x(Ye != null, "'%s' must be an object that Event constructor created, but got another one: %o", Fe, Pe), Ye;
  }
  function Ee(Pe) {
    if (Pe.inPassiveListenerFlag) {
      ze.warn();
      return;
    }
    if (!Pe.cancelable) {
      xe.warn();
      return;
    }
    Pe.canceledFlag = !0;
  }
  Object.defineProperty(Ne, "NONE", { enumerable: !0 }), Object.defineProperty(Ne, "CAPTURING_PHASE", { enumerable: !0 }), Object.defineProperty(Ne, "AT_TARGET", { enumerable: !0 }), Object.defineProperty(Ne, "BUBBLING_PHASE", { enumerable: !0 });
  var te = Object.getOwnPropertyNames(Ne.prototype);
  for (ue = 0; ue < te.length; ++ue) te[ue] !== "constructor" && Object.defineProperty(Ne.prototype, te[ue], { enumerable: !0 });
  var ue;
  typeof F < "u" && typeof F.Event < "u" && Object.setPrototypeOf(Ne.prototype, F.Event.prototype);
  function ye(Pe) {
    return F.DOMException ? new F.DOMException(Pe, "InvalidStateError") : (Le == null && (Le = function(Fe) {
      g.default(Xe, Fe);
      var Ye = z(Xe);
      function Xe(dt) {
        var Nt;
        return O.default(this, Xe), Nt = Ye.call(this, dt), Error.captureStackTrace && Error.captureStackTrace(m.default(Nt), Xe), Nt;
      }
      return P.default(Xe, [{ key: "code", get: function() {
        return 11;
      } }, { key: "name", get: function() {
        return "InvalidStateError";
      } }]), Xe;
    }(S.default(Error)), Object.defineProperties(Le.prototype, { code: { enumerable: !0 }, name: { enumerable: !0 } }), Ae(Le), Ae(Le.prototype)), new Le(Pe));
  }
  var Le, Me = { INDEX_SIZE_ERR: 1, DOMSTRING_SIZE_ERR: 2, HIERARCHY_REQUEST_ERR: 3, WRONG_DOCUMENT_ERR: 4, INVALID_CHARACTER_ERR: 5, NO_DATA_ALLOWED_ERR: 6, NO_MODIFICATION_ALLOWED_ERR: 7, NOT_FOUND_ERR: 8, NOT_SUPPORTED_ERR: 9, INUSE_ATTRIBUTE_ERR: 10, INVALID_STATE_ERR: 11, SYNTAX_ERR: 12, INVALID_MODIFICATION_ERR: 13, NAMESPACE_ERR: 14, INVALID_ACCESS_ERR: 15, VALIDATION_ERR: 16, TYPE_MISMATCH_ERR: 17, SECURITY_ERR: 18, NETWORK_ERR: 19, ABORT_ERR: 20, URL_MISMATCH_ERR: 21, QUOTA_EXCEEDED_ERR: 22, TIMEOUT_ERR: 23, INVALID_NODE_TYPE_ERR: 24, DATA_CLONE_ERR: 25 };
  function Ae(Pe) {
    for (var Fe = Object.keys(Me), Ye = function(dt) {
      var Nt = Fe[dt], er = Me[Nt];
      Object.defineProperty(Pe, Nt, { get: function() {
        return er;
      }, configurable: !0, enumerable: !0 });
    }, Xe = 0; Xe < Fe.length; ++Xe) Ye(Xe);
  }
  var ie = function(Pe) {
    g.default(Ye, Pe);
    var Fe = z(Ye);
    P.default(Ye, null, [{ key: "wrap", value: function(Xe) {
      return new (be(Xe))(Xe);
    } }]);
    function Ye(Xe) {
      var dt, Nt, er;
      O.default(this, Ye), er = Fe.call(this, Xe.type, { bubbles: Xe.bubbles, cancelable: Xe.cancelable, composed: Xe.composed }), Xe.cancelBubble && E.default((dt = m.default(er), _.default(Ye.prototype)), "stopPropagation", dt).call(dt), Xe.defaultPrevented && E.default((Nt = m.default(er), _.default(Ye.prototype)), "preventDefault", Nt).call(Nt), K.set(m.default(er), { original: Xe });
      for (var Sr = Object.keys(Xe), Fr = 0; Fr < Sr.length; ++Fr) {
        var ro = Sr[Fr];
        ro in m.default(er) || Object.defineProperty(m.default(er), ro, st(Xe, ro));
      }
      return er;
    }
    return P.default(Ye, [{ key: "stopPropagation", value: function() {
      E.default(_.default(Ye.prototype), "stopPropagation", this).call(this);
      var Xe = Z(this), dt = Xe.original;
      "stopPropagation" in dt && dt.stopPropagation();
    } }, { key: "stopImmediatePropagation", value: function() {
      E.default(_.default(Ye.prototype), "stopImmediatePropagation", this).call(this);
      var Xe = Z(this), dt = Xe.original;
      "stopImmediatePropagation" in dt && dt.stopImmediatePropagation();
    } }, { key: "preventDefault", value: function() {
      E.default(_.default(Ye.prototype), "preventDefault", this).call(this);
      var Xe = Z(this), dt = Xe.original;
      "preventDefault" in dt && dt.preventDefault();
    } }, { key: "cancelBubble", get: function() {
      return E.default(_.default(Ye.prototype), "cancelBubble", this);
    }, set: function(Xe) {
      h.default(_.default(Ye.prototype), "cancelBubble", Xe, this, !0);
      var dt = Z(this), Nt = dt.original;
      "cancelBubble" in Nt && (Nt.cancelBubble = Xe);
    } }, { key: "returnValue", get: function() {
      return E.default(_.default(Ye.prototype), "returnValue", this);
    }, set: function(Xe) {
      h.default(_.default(Ye.prototype), "returnValue", Xe, this, !0);
      var dt = Z(this), Nt = dt.original;
      "returnValue" in Nt && (Nt.returnValue = Xe);
    } }, { key: "timeStamp", get: function() {
      var Xe = Z(this), dt = Xe.original;
      return "timeStamp" in dt ? dt.timeStamp : E.default(_.default(Ye.prototype), "timeStamp", this);
    } }]), Ye;
  }(Ne), K = /* @__PURE__ */ new WeakMap();
  function Z(Pe) {
    var Fe = K.get(Pe);
    return x(Fe != null, "'this' is expected an Event object, but got", Pe), Fe;
  }
  var Ce = /* @__PURE__ */ new WeakMap();
  Ce.set(Object.prototype, ie), typeof F < "u" && typeof F.Event < "u" && Ce.set(F.Event.prototype, ie);
  function be(Pe) {
    var Fe = Object.getPrototypeOf(Pe);
    if (Fe == null) return ie;
    var Ye = Ce.get(Fe);
    return Ye == null && (Ye = Ge(be(Fe), Fe), Ce.set(Fe, Ye)), Ye;
  }
  function Ge(Pe, Fe) {
    for (var Ye = function(Nt) {
      g.default(Sr, Nt);
      var er = z(Sr);
      function Sr() {
        return O.default(this, Sr), er.apply(this, arguments);
      }
      return Sr;
    }(Pe), Xe = Object.keys(Fe), dt = 0; dt < Xe.length; ++dt) Object.defineProperty(Ye.prototype, Xe[dt], st(Fe, Xe[dt]));
    return Ye;
  }
  function st(Pe, Fe) {
    var Ye = Object.getOwnPropertyDescriptor(Pe, Fe);
    return { get: function() {
      var Xe = Z(this).original, dt = Xe[Fe];
      return typeof dt == "function" ? dt.bind(Xe) : dt;
    }, set: function(Xe) {
      var dt = Z(this).original;
      dt[Fe] = Xe;
    }, configurable: Ye.configurable, enumerable: Ye.enumerable };
  }
  function wt(Pe, Fe, Ye, Xe, dt, Nt) {
    return { callback: Pe, flags: (Fe ? 1 : 0) | (Ye ? 2 : 0) | (Xe ? 4 : 0), signal: dt, signalListener: Nt };
  }
  function Bt(Pe) {
    Pe.flags |= 8;
  }
  function jt(Pe) {
    return (Pe.flags & 1) === 1;
  }
  function Xt(Pe) {
    return (Pe.flags & 2) === 2;
  }
  function Qt(Pe) {
    return (Pe.flags & 4) === 4;
  }
  function Zr(Pe) {
    return (Pe.flags & 8) === 8;
  }
  function Jn(Pe, Fe, Ye) {
    var Xe = Pe.callback;
    try {
      typeof Xe == "function" ? Xe.call(Fe, Ye) : typeof Xe.handleEvent == "function" && Xe.handleEvent(Ye);
    } catch (dt) {
      V(dt);
    }
  }
  function Ur(Pe, Fe, Ye) {
    for (var Xe = Pe.listeners, dt = 0; dt < Xe.length; ++dt) if (Xe[dt].callback === Fe && jt(Xe[dt]) === Ye) return dt;
    return -1;
  }
  function fn(Pe, Fe, Ye, Xe, dt, Nt) {
    var er;
    Nt && (er = gn.bind(null, Pe, Fe, Ye), Nt.addEventListener("abort", er));
    var Sr = wt(Fe, Ye, Xe, dt, Nt, er);
    return Pe.cow ? (Pe.cow = !1, Pe.listeners = [].concat(v.default(Pe.listeners), [Sr])) : Pe.listeners.push(Sr), Sr;
  }
  function gn(Pe, Fe, Ye) {
    var Xe = Ur(Pe, Fe, Ye);
    return Xe !== -1 ? cr(Pe, Xe) : !1;
  }
  function cr(Pe, Fe) {
    var Ye = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Xe = Pe.listeners[Fe];
    return Bt(Xe), Xe.signal && Xe.signal.removeEventListener("abort", Xe.signalListener), Pe.cow && !Ye ? (Pe.cow = !1, Pe.listeners = Pe.listeners.filter(function(dt, Nt) {
      return Nt !== Fe;
    }), !1) : (Pe.listeners.splice(Fe, 1), !0);
  }
  function Ri() {
    return /* @__PURE__ */ Object.create(null);
  }
  function ai(Pe, Fe) {
    var Ye;
    return (Ye = Pe[Fe]) !== null && Ye !== void 0 ? Ye : Pe[Fe] = { attrCallback: void 0, attrListener: void 0, cow: !1, listeners: [] };
  }
  var vo = function() {
    function Pe() {
      O.default(this, Pe), to.set(this, Ri());
    }
    return P.default(Pe, [{ key: "addEventListener", value: function(Fe, Ye, Xe) {
      var dt = Ui(this), Nt = Gu(Fe, Ye, Xe), er = Nt.callback, Sr = Nt.capture, Fr = Nt.once, ro = Nt.passive, Eo = Nt.signal, Ti = Nt.type;
      if (!(er == null || Eo != null && Eo.aborted)) {
        var Ya = ai(dt, Ti), ws = Ur(Ya, er, Sr);
        if (ws !== -1) {
          Ku(Ya.listeners[ws], ro, Fr, Eo);
          return;
        }
        fn(Ya, er, Sr, ro, Fr, Eo);
      }
    } }, { key: "removeEventListener", value: function(Fe, Ye, Xe) {
      var dt = Ui(this), Nt = Rs(Fe, Ye, Xe), er = Nt.callback, Sr = Nt.capture, Fr = Nt.type, ro = dt[Fr];
      er != null && ro && gn(ro, er, Sr);
    } }, { key: "dispatchEvent", value: function(Fe) {
      var Ye = Ui(this)[String(Fe.type)];
      if (Ye == null) return !0;
      var Xe = Fe instanceof Ne ? Fe : ie.wrap(Fe), dt = De(Xe, "event");
      if (dt.dispatchFlag) throw ye("This event has been in dispatching.");
      if (dt.dispatchFlag = !0, dt.target = dt.currentTarget = this, !dt.stopPropagationFlag) {
        var Nt = Ye.cow, er = Ye.listeners;
        Ye.cow = !0;
        for (var Sr = 0; Sr < er.length; ++Sr) {
          var Fr = er[Sr];
          if (!Zr(Fr) && (Qt(Fr) && cr(Ye, Sr, !Nt) && (Sr -= 1), dt.inPassiveListenerFlag = Xt(Fr), Jn(Fr, this, Xe), dt.inPassiveListenerFlag = !1, dt.stopImmediatePropagationFlag)) break;
        }
        Nt || (Ye.cow = !1);
      }
      return dt.target = null, dt.currentTarget = null, dt.stopImmediatePropagationFlag = !1, dt.stopPropagationFlag = !1, dt.dispatchFlag = !1, !dt.canceledFlag;
    } }]), Pe;
  }(), to = /* @__PURE__ */ new WeakMap();
  function Ui(Pe) {
    var Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "this", Ye = to.get(Pe);
    return x(Ye != null, "'%s' must be an object that EventTarget constructor created, but got another one: %o", Fe, Pe), Ye;
  }
  function Gu(Pe, Fe, Ye) {
    var Xe;
    return Wu(Fe), U.default(Ye) === "object" && Ye !== null ? { type: String(Pe), callback: Fe ?? void 0, capture: !!Ye.capture, passive: !!Ye.passive, once: !!Ye.once, signal: (Xe = Ye.signal) !== null && Xe !== void 0 ? Xe : void 0 } : { type: String(Pe), callback: Fe ?? void 0, capture: !!Ye, passive: !1, once: !1, signal: void 0 };
  }
  function Rs(Pe, Fe, Ye) {
    return Wu(Fe), U.default(Ye) === "object" && Ye !== null ? { type: String(Pe), callback: Fe ?? void 0, capture: !!Ye.capture } : { type: String(Pe), callback: Fe ?? void 0, capture: !!Ye };
  }
  function Wu(Pe) {
    if (!(typeof Pe == "function" || U.default(Pe) === "object" && Pe !== null && typeof Pe.handleEvent == "function")) {
      if (Pe == null || U.default(Pe) === "object") {
        Be.warn(Pe);
        return;
      }
      throw new TypeError(D(Be.message, [Pe]));
    }
  }
  function Ku(Pe, Fe, Ye, Xe) {
    qe.warn(jt(Pe) ? "capture" : "bubble", Pe.callback), Xt(Pe) !== Fe && Je.warn("passive"), Qt(Pe) !== Ye && Je.warn("once"), Pe.signal !== Xe && Je.warn("signal");
  }
  var Ca = Object.getOwnPropertyNames(vo.prototype);
  for (Dn = 0; Dn < Ca.length; ++Dn) Ca[Dn] !== "constructor" && Object.defineProperty(vo.prototype, Ca[Dn], { enumerable: !0 });
  var Dn;
  typeof F < "u" && typeof F.EventTarget < "u" && Object.setPrototypeOf(vo.prototype, F.EventTarget.prototype);
  function Xu(Pe, Fe) {
    var Ye, Xe, dt = Ui(Pe, "target");
    return (Xe = (Ye = dt[Fe]) === null || Ye === void 0 ? void 0 : Ye.attrCallback) !== null && Xe !== void 0 ? Xe : null;
  }
  function Ze(Pe, Fe, Ye) {
    Ye != null && typeof Ye != "function" && We.warn(Ye), typeof Ye == "function" || U.default(Ye) === "object" && Ye !== null ? kt(Pe, Fe, Ye) : qt(Pe, Fe);
  }
  function kt(Pe, Fe, Ye) {
    var Xe = ai(Ui(Pe, "target"), String(Fe));
    Xe.attrCallback = Ye, Xe.attrListener == null && (Xe.attrListener = fn(Xe, sr(Xe), !1, !1, !1, void 0));
  }
  function qt(Pe, Fe) {
    var Ye = Ui(Pe, "target"), Xe = Ye[String(Fe)];
    Xe && Xe.attrListener && (gn(Xe, Xe.attrListener.callback, !1), Xe.attrCallback = Xe.attrListener = void 0);
  }
  function sr(Pe) {
    return function(Fe) {
      var Ye = Pe.attrCallback;
      typeof Ye == "function" && Ye.call(this, Fe);
    };
  }
  function Mr() {
    for (var Pe = function(Ye) {
      g.default(dt, Ye);
      var Xe = z(dt);
      function dt() {
        return O.default(this, dt), Xe.apply(this, arguments);
      }
      return dt;
    }(vo), Fe = 0; Fe < arguments.length; ++Fe) ht(Pe.prototype, Fe < 0 || arguments.length <= Fe ? void 0 : arguments[Fe]);
    return Pe;
  }
  function ht(Pe, Fe, Ye) {
    Object.defineProperty(Pe, "on".concat(Fe), { get: function() {
      return Xu(this, Fe);
    }, set: function(Xe) {
      Ze(this, Fe, Xe);
    }, configurable: !0, enumerable: !0 });
  }
  e.Event = Ne, e.EventTarget = vo, e.default = vo, e.defineCustomEventTarget = Mr, e.defineEventAttribute = ht, e.getEventAttributeValue = Xu, e.setErrorHandler = X, e.setEventAttributeValue = Ze, e.setWarningHandler = ae;
}), $Sr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
  var r = t(E0());
  function n(a, u) {
    var s = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(a);
      u && (c = c.filter(function(l) {
        return Object.getOwnPropertyDescriptor(a, l).enumerable;
      })), s.push.apply(s, c);
    }
    return s;
  }
  function i(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u] != null ? arguments[u] : {};
      u % 2 ? n(Object(s), !0).forEach(function(c) {
        (0, r.default)(a, c, s[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(s)) : n(Object(s)).forEach(function(c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(s, c));
      });
    }
    return a;
  }
  function o(a, u) {
    var s = i(i(i({}, [].reduce.call(a, function(c, l, f) {
      return c[f] = l, c;
    }, {})), u), {}, (0, r.default)({ length: a.length }, Symbol.iterator, function() {
      return [].slice.call(s)[Symbol.iterator]();
    }));
    return s;
  }
}), fT, jn, _d = Qe(() => {
  fT = () => P1e(), jn = () => fT().replace(new RegExp("-", "g"), "").toUpperCase();
}), hn, el, Jy = Qe(() => {
  _d(), function(e) {
    e[e.Debug = 0] = "Debug", e[e.Info = 1] = "Info", e[e.Warning = 2] = "Warning", e[e.Error = 3] = "Error";
  }(hn || (hn = {})), el = class {
    constructor(e, t) {
      this.privName = e, this.privEventId = jn(), this.privEventTime = (/* @__PURE__ */ new Date()).toISOString(), this.privEventType = t, this.privMetadata = {};
    }
    get name() {
      return this.privName;
    }
    get eventId() {
      return this.privEventId;
    }
    get eventTime() {
      return this.privEventTime;
    }
    get eventType() {
      return this.privEventType;
    }
    get metadata() {
      return this.privMetadata;
    }
  };
}), Jd, ih, Hf, o2, oh, Pg, $f, Uf, hs, Zy, USr = Qe(() => {
  Jy(), Jd = class extends el {
    constructor(e, t, r = hn.Info) {
      super(e, r), this.privAudioSourceId = t;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
  }, ih = class extends Jd {
    constructor(e) {
      super("AudioSourceInitializingEvent", e);
    }
  }, Hf = class extends Jd {
    constructor(e) {
      super("AudioSourceReadyEvent", e);
    }
  }, o2 = class extends Jd {
    constructor(e) {
      super("AudioSourceOffEvent", e);
    }
  }, oh = class extends Jd {
    constructor(e, t) {
      super("AudioSourceErrorEvent", e, hn.Error), this.privError = t;
    }
    get error() {
      return this.privError;
    }
  }, Pg = class extends Jd {
    constructor(e, t, r) {
      super(e, t), this.privAudioNodeId = r;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
  }, $f = class extends Pg {
    constructor(e, t) {
      super("AudioStreamNodeAttachingEvent", e, t);
    }
  }, Uf = class extends Pg {
    constructor(e, t) {
      super("AudioStreamNodeAttachedEvent", e, t);
    }
  }, hs = class extends Pg {
    constructor(e, t) {
      super("AudioStreamNodeDetachedEvent", e, t);
    }
  }, Zy = class extends Pg {
    constructor(e, t, r) {
      super("AudioStreamNodeErrorEvent", e, t), this.privError = r;
    }
    get error() {
      return this.privError;
    }
  };
}), a2, Dl, r$, n$, PSe, DSe, xSe, fb, NSe, VSr = Qe(() => {
  Jy(), a2 = class extends el {
    constructor(e, t, r = hn.Info) {
      super(e, r), this.privJsonResult = t;
    }
    get jsonString() {
      return this.privJsonResult;
    }
  }, Dl = class extends el {
    constructor(e, t, r = hn.Info) {
      super(e, r), this.privConnectionId = t;
    }
    get connectionId() {
      return this.privConnectionId;
    }
  }, r$ = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionStartEvent", e), this.privUri = t, this.privHeaders = r;
    }
    get uri() {
      return this.privUri;
    }
    get headers() {
      return this.privHeaders;
    }
  }, n$ = class extends Dl {
    constructor(e, t) {
      super("ConnectionEstablishedEvent", e);
    }
  }, PSe = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionClosedEvent", e, hn.Debug), this.privReason = r, this.privStatusCode = t;
    }
    get reason() {
      return this.privReason;
    }
    get statusCode() {
      return this.privStatusCode;
    }
  }, DSe = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionErrorEvent", e, hn.Debug), this.privMessage = t, this.privType = r;
    }
    get message() {
      return this.privMessage;
    }
    get type() {
      return this.privType;
    }
  }, xSe = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionEstablishErrorEvent", e, hn.Error), this.privStatusCode = t, this.privReason = r;
    }
    get reason() {
      return this.privReason;
    }
    get statusCode() {
      return this.privStatusCode;
    }
  }, fb = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionMessageReceivedEvent", e), this.privNetworkReceivedTime = t, this.privMessage = r;
    }
    get networkReceivedTime() {
      return this.privNetworkReceivedTime;
    }
    get message() {
      return this.privMessage;
    }
  }, NSe = class extends Dl {
    constructor(e, t, r) {
      super("ConnectionMessageSentEvent", e), this.privNetworkSentTime = t, this.privMessage = r;
    }
    get networkSentTime() {
      return this.privNetworkSentTime;
    }
    get message() {
      return this.privMessage;
    }
  };
}), Ji, ta, u2, gc = Qe(() => {
  Ji = class extends Error {
    constructor(e) {
      super(e), this.name = "ArgumentNull", this.message = e;
    }
  }, ta = class extends Error {
    constructor(e) {
      super(e), this.name = "InvalidOperation", this.message = e;
    }
  }, u2 = class extends Error {
    constructor(e, t) {
      super(t), this.name = e + "ObjectDisposed", this.message = t;
    }
  };
}), br, dT, LSe = Qe(() => {
  gc(), _d(), function(e) {
    e[e.Text = 0] = "Text", e[e.Binary = 1] = "Binary";
  }(br || (br = {})), dT = class {
    constructor(e, t, r, n) {
      if (this.privBody = null, e === br.Text && t && typeof t != "string") throw new ta("Payload must be a string");
      if (e === br.Binary && t && !(t instanceof ArrayBuffer)) throw new ta("Payload must be ArrayBuffer");
      switch (this.privMessageType = e, this.privBody = t, this.privHeaders = r || {}, this.privId = n || jn(), this.messageType) {
        case br.Binary:
          this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
          break;
        case br.Text:
          this.privSize = this.textBody.length;
      }
    }
    get messageType() {
      return this.privMessageType;
    }
    get headers() {
      return this.privHeaders;
    }
    get body() {
      return this.privBody;
    }
    get textBody() {
      if (this.privMessageType === br.Binary) throw new ta("Not supported for binary message");
      return this.privBody;
    }
    get binaryBody() {
      if (this.privMessageType === br.Text) throw new ta("Not supported for text message");
      return this.privBody;
    }
    get id() {
      return this.privId;
    }
  };
}), eS, jSr = Qe(() => {
  eS = class {
    constructor(e, t) {
      this.privStatusCode = e, this.privReason = t;
    }
    get statusCode() {
      return this.privStatusCode;
    }
    get reason() {
      return this.privReason;
    }
  };
}), Lue, BSe, kSe = Qe(() => {
  Jy(), Lue = class extends el {
    constructor(e, t = hn.Info) {
      super(e, t);
    }
  }, BSe = class extends Lue {
    constructor(e) {
      super("SendingAgentContextMessageEvent"), this.privAgentConfig = e;
    }
    get agentConfig() {
      return this.privAgentConfig;
    }
  };
}), su, MSe = Qe(() => {
  gc(), _d(), su = class {
    constructor(e) {
      this.privEventListeners = {}, this.privIsDisposed = !1, this.onEvent = (t) => {
        if (this.isDisposed()) throw new u2("EventSource");
        if (this.metadata) for (let r in this.metadata) r && t.metadata && (t.metadata[r] || (t.metadata[r] = this.metadata[r]));
        for (let r in this.privEventListeners) r && this.privEventListeners[r] && this.privEventListeners[r](t);
      }, this.attach = (t) => {
        let r = jn();
        return this.privEventListeners[r] = t, { detach: () => (delete this.privEventListeners[r], Promise.resolve()) };
      }, this.attachListener = (t) => this.attach(t.onEvent), this.isDisposed = () => this.privIsDisposed, this.dispose = () => {
        this.privEventListeners = null, this.privIsDisposed = !0;
      }, this.privMetadata = e;
    }
    get metadata() {
      return this.privMetadata;
    }
  };
}), ci, zSr = Qe(() => {
  gc(), MSe(), ci = class FSe {
    static get instance() {
      return FSe.privInstance;
    }
  }, ci.privInstance = new su(), ci.setEventSource = (e) => {
    if (!e) throw new Ji("eventSource");
    ci.privInstance = e;
  };
}), qSr = Qe(() => {
}), qi, YSr = Qe(() => {
  (function(e) {
    e[e.None = 0] = "None", e[e.Connected = 1] = "Connected", e[e.Connecting = 2] = "Connecting", e[e.Disconnected = 3] = "Disconnected";
  })(qi || (qi = {}));
}), GSr = Qe(() => {
}), WSr = Qe(() => {
}), KSr = Qe(() => {
}), XSr = Qe(() => {
}), JSr = Qe(() => {
}), ZSr = Qe(() => {
}), QSr = Qe(() => {
}), tS, HSe = Qe(() => {
  gc(), tS = class af {
    constructor(t) {
      if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.get = (r) => (this.throwIfDisposed(), this.privList[r]), this.first = () => this.get(0), this.last = () => this.get(this.length() - 1), this.add = (r) => {
        this.throwIfDisposed(), this.insertAt(this.privList.length, r);
      }, this.insertAt = (r, n) => {
        this.throwIfDisposed(), r === 0 ? this.privList.unshift(n) : r === this.privList.length ? this.privList.push(n) : this.privList.splice(r, 0, n), this.triggerSubscriptions(this.privAddSubscriptions);
      }, this.removeFirst = () => (this.throwIfDisposed(), this.removeAt(0)), this.removeLast = () => (this.throwIfDisposed(), this.removeAt(this.length() - 1)), this.removeAt = (r) => (this.throwIfDisposed(), this.remove(r, 1)[0]), this.remove = (r, n) => {
        this.throwIfDisposed();
        let i = this.privList.splice(r, n);
        return this.triggerSubscriptions(this.privRemoveSubscriptions), i;
      }, this.clear = () => {
        this.throwIfDisposed(), this.remove(0, this.length());
      }, this.length = () => (this.throwIfDisposed(), this.privList.length), this.onAdded = (r) => {
        this.throwIfDisposed();
        let n = this.privSubscriptionIdCounter++;
        return this.privAddSubscriptions[n] = r, { detach: () => (delete this.privAddSubscriptions[n], Promise.resolve()) };
      }, this.onRemoved = (r) => {
        this.throwIfDisposed();
        let n = this.privSubscriptionIdCounter++;
        return this.privRemoveSubscriptions[n] = r, { detach: () => (delete this.privRemoveSubscriptions[n], Promise.resolve()) };
      }, this.onDisposed = (r) => {
        this.throwIfDisposed();
        let n = this.privSubscriptionIdCounter++;
        return this.privDisposedSubscriptions[n] = r, { detach: () => (delete this.privDisposedSubscriptions[n], Promise.resolve()) };
      }, this.join = (r) => (this.throwIfDisposed(), this.privList.join(r)), this.toArray = () => {
        let r = Array();
        return this.privList.forEach((n) => {
          r.push(n);
        }), r;
      }, this.any = (r) => (this.throwIfDisposed(), r ? this.where(r).length() > 0 : this.length() > 0), this.all = (r) => (this.throwIfDisposed(), this.where(r).length() === this.length()), this.forEach = (r) => {
        this.throwIfDisposed();
        for (let n = 0; n < this.length(); n++) r(this.privList[n], n);
      }, this.select = (r) => {
        this.throwIfDisposed();
        let n = [];
        for (let i = 0; i < this.privList.length; i++) n.push(r(this.privList[i], i));
        return new af(n);
      }, this.where = (r) => {
        this.throwIfDisposed();
        let n = new af();
        for (let i = 0; i < this.privList.length; i++) r(this.privList[i], i) && n.add(this.privList[i]);
        return n;
      }, this.orderBy = (r) => {
        this.throwIfDisposed();
        let n = this.toArray().sort(r);
        return new af(n);
      }, this.orderByDesc = (r) => (this.throwIfDisposed(), this.orderBy((n, i) => r(i, n))), this.clone = () => (this.throwIfDisposed(), new af(this.toArray())), this.concat = (r) => (this.throwIfDisposed(), new af(this.privList.concat(r.toArray()))), this.concatArray = (r) => (this.throwIfDisposed(), new af(this.privList.concat(r))), this.isDisposed = () => this.privList == null, this.dispose = (r) => {
        this.isDisposed() || (this.privDisposeReason = r, this.privList = null, this.privAddSubscriptions = null, this.privRemoveSubscriptions = null, this.triggerSubscriptions(this.privDisposedSubscriptions));
      }, this.throwIfDisposed = () => {
        if (this.isDisposed()) throw new u2("List", this.privDisposeReason);
      }, this.triggerSubscriptions = (r) => {
        if (r) for (let n in r) n && r[n]();
      }, this.privList = [], t) for (let r of t) this.privList.push(r);
    }
  };
});
function wr(e, t, r) {
  e.then((n) => {
    try {
      t && t(n);
    } catch (i) {
      if (r) try {
        if (i instanceof Error) {
          let o = i;
          r(o.name + ": " + o.message);
        } else r(i);
      } catch {
      }
    }
  }, (n) => {
    if (r) try {
      if (n instanceof Error) {
        let i = n;
        r(i.name + ": " + i.message);
      } else r(n);
    } catch {
    }
  });
}
var Bue, Kn, i$ = Qe(() => {
  (function(e) {
    e[e.None = 0] = "None", e[e.Resolved = 1] = "Resolved", e[e.Rejected = 2] = "Rejected";
  })(Bue || (Bue = {})), Kn = class {
    constructor() {
      this.resolve = (e) => (this.privResolve(e), this), this.reject = (e) => (this.privReject(e), this), this.privPromise = new Promise((e, t) => {
        this.privResolve = e, this.privReject = t;
      });
    }
    get promise() {
      return this.privPromise;
    }
  };
}), A5, Dg, ah, $Se = Qe(() => {
  gc(), HSe(), i$(), A5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, function(e) {
    e[e.Dequeue = 0] = "Dequeue", e[e.Peek = 1] = "Peek";
  }(Dg || (Dg = {})), ah = class {
    constructor(e) {
      this.privPromiseStore = new tS(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.enqueue = (t) => {
        this.throwIfDispose(), this.enqueueFromPromise(new Promise((r, n) => {
          r(t);
        }));
      }, this.enqueueFromPromise = (t) => {
        this.throwIfDispose(), t.then((r) => {
          this.privList.add(r);
        }, (r) => {
        });
      }, this.dequeue = () => {
        this.throwIfDispose();
        let t = new Kn();
        return this.privSubscribers && (this.privSubscribers.add({ deferral: t, type: Dg.Dequeue }), this.drain()), t.promise;
      }, this.peek = () => {
        this.throwIfDispose();
        let t = new Kn();
        return this.privSubscribers && (this.privSubscribers.add({ deferral: t, type: Dg.Peek }), this.drain()), t.promise;
      }, this.length = () => (this.throwIfDispose(), this.privList.length()), this.isDisposed = () => this.privSubscribers == null, this.drain = () => {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
          this.privIsDrainInProgress = !0;
          let t = this.privSubscribers, r = this.privList;
          if (t && r) {
            for (; r.length() > 0 && t.length() > 0 && !this.privIsDisposing; ) {
              let n = t.removeFirst();
              if (n.type === Dg.Peek) n.deferral.resolve(r.first());
              else {
                let i = r.removeFirst();
                n.deferral.resolve(i);
              }
            }
            this.privSubscribers === t && (this.privSubscribers = t), this.privList === r && (this.privList = r);
          }
          this.privIsDrainInProgress = !1;
        }
      }, this.throwIfDispose = () => {
        if (this.isDisposed()) throw this.privDisposeReason ? new ta(this.privDisposeReason) : new u2("Queue");
        if (this.privIsDisposing) throw new ta("Queue disposing");
      }, this.privList = e || new tS(), this.privDetachables = [], this.privSubscribers = new tS(), this.privDetachables.push(this.privList.onAdded(this.drain));
    }
    drainAndDispose(e, t) {
      return A5(this, void 0, void 0, function* () {
        if (!this.isDisposed() && !this.privIsDisposing) {
          this.privDisposeReason = t, this.privIsDisposing = !0;
          let r = this.privSubscribers;
          if (r) {
            for (; r.length() > 0; ) r.removeFirst().deferral.resolve(void 0);
            this.privSubscribers === r && (this.privSubscribers = r);
          }
          for (let n of this.privDetachables) yield n.detach();
          if (this.privPromiseStore.length() > 0 && e) {
            let n = [];
            return this.privPromiseStore.toArray().forEach((i) => {
              n.push(i);
            }), Promise.all(n).finally(() => {
              this.privSubscribers = null, this.privList.forEach((i, o) => {
                e(i);
              }), this.privList = null;
            }).then();
          } else this.privSubscribers = null, this.privList = null;
        }
      });
    }
    dispose(e) {
      return A5(this, void 0, void 0, function* () {
        yield this.drainAndDispose(null, e);
      });
    }
  };
}), uh, ebr = Qe(() => {
  LSe(), gc(), _d(), uh = class {
    constructor(e, t, r) {
      if (this.privPayload = null, !t) throw new Ji("payload");
      if (e === br.Binary && t.__proto__.constructor.name !== "ArrayBuffer") throw new ta("Payload must be ArrayBuffer");
      if (e === br.Text && typeof t != "string") throw new ta("Payload must be a string");
      this.privMessageType = e, this.privPayload = t, this.privId = r || jn();
    }
    get messageType() {
      return this.privMessageType;
    }
    get payload() {
      return this.privPayload;
    }
    get textContent() {
      if (this.privMessageType === br.Binary) throw new ta("Not supported for binary message");
      return this.privPayload;
    }
    get binaryContent() {
      if (this.privMessageType === br.Text) throw new ta("Not supported for text message");
      return this.privPayload;
    }
    get id() {
      return this.privId;
    }
  };
}), USe, tbr = Qe(() => {
  USe = class {
    constructor(e, t) {
      this.encode = (r) => {
        let n = this.downSampleAudioFrame(r, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!n) return null;
        let i = n.length * 2, o = new ArrayBuffer(i), a = new DataView(o);
        return this.floatTo16BitPCM(a, 0, n), o;
      }, this.setString = (r, n, i) => {
        for (let o = 0; o < i.length; o++) r.setUint8(n + o, i.charCodeAt(o));
      }, this.floatTo16BitPCM = (r, n, i) => {
        for (let o = 0; o < i.length; o++, n += 2) {
          let a = Math.max(-1, Math.min(1, i[o]));
          r.setInt16(n, a < 0 ? a * 32768 : a * 32767, !0);
        }
      }, this.downSampleAudioFrame = (r, n, i) => {
        if (i === n || i > n) return r;
        let o = n / i, a = Math.round(r.length / o), u = new Float32Array(a), s = 0, c = 0;
        for (; c < a; ) {
          let l = Math.round((c + 1) * o), f = 0, d = 0;
          for (; s < l && s < r.length; ) f += r[s++], d++;
          u[c++] = f / d;
        }
        return u;
      }, this.privActualSampleRate = e, this.privDesiredSampleRate = t;
    }
  };
}), kue, o$, rbr = Qe(() => {
  gc(), _d(), $Se(), kue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, o$ = class {
    constructor(e) {
      this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.read = () => {
        if (this.privIsReadEnded) throw new ta("Stream read has already finished");
        return this.privReaderQueue.dequeue().then((t) => kue(this, void 0, void 0, function* () {
          return (t === void 0 || t.isEnd) && (yield this.privReaderQueue.dispose("End of stream reached")), t;
        }));
      }, this.readEnded = () => {
        this.privIsReadEnded || (this.privIsReadEnded = !0, this.privReaderQueue = new ah());
      }, this.throwIfClosed = () => {
        if (this.privIsWriteEnded) throw new ta("Stream closed");
      }, this.privId = e || jn(), this.privReaderQueue = new ah();
    }
    get isClosed() {
      return this.privIsWriteEnded;
    }
    get isReadEnded() {
      return this.privIsReadEnded;
    }
    get id() {
      return this.privId;
    }
    close() {
      this.privIsWriteEnded || (this.writeStreamChunk({ buffer: null, isEnd: !0, timeReceived: Date.now() }), this.privIsWriteEnded = !0);
    }
    writeStreamChunk(e) {
      if (this.throwIfClosed(), !this.privReaderQueue.isDisposed()) try {
        this.privReaderQueue.enqueue(e);
      } catch {
      }
    }
  };
}), pT, a$ = Qe(() => {
  (function(e) {
    e[e.Success = 0] = "Success", e[e.Error = 1] = "Error";
  })(pT || (pT = {}));
}), Qy, nbr = Qe(() => {
  vr(), Qy = class extends o$ {
    constructor(e, t) {
      super(t), this.privTargetChunkSize = e, this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(e) {
      if (e.isEnd || this.privNextBufferReadyBytes === 0 && e.buffer.byteLength === this.privTargetChunkSize) {
        super.writeStreamChunk(e);
        return;
      }
      let t = 0;
      for (; t < e.buffer.byteLength; ) {
        this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = e.timeReceived);
        let r = Math.min(e.buffer.byteLength - t, this.privTargetChunkSize - this.privNextBufferReadyBytes), n = new Uint8Array(this.privNextBufferToWrite), i = new Uint8Array(e.buffer.slice(t, r + t));
        n.set(i, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += r, t += r, this.privNextBufferReadyBytes === this.privTargetChunkSize && (super.writeStreamChunk({ buffer: this.privNextBufferToWrite, isEnd: !1, timeReceived: this.privNextBufferStartTime }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
      }
    }
    close() {
      this.privNextBufferReadyBytes !== 0 && !this.isClosed && super.writeStreamChunk({ buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes), isEnd: !1, timeReceived: this.privNextBufferStartTime }), super.close();
    }
  };
}), ibr = Qe(() => {
}), Ni, obr = Qe(() => {
  Ni = class {
  }, Ni.workerTimers = null, Ni.clearTimeout = (e) => Ni.timers().clearTimeout(e), Ni.setTimeout = (e, t) => Ni.timers().setTimeout(e, t), Ni.load = (e) => {
    let t = /* @__PURE__ */ new Map([[0, () => {
    }]]), r = /* @__PURE__ */ new Map(), n = new Worker(e);
    return n.addEventListener("message", ({ data: i }) => {
      if (Ni.isCallNotification(i)) {
        let { params: { timerId: o } } = i, a = t.get(o);
        if (typeof a == "number") {
          let u = r.get(a);
          if (u === void 0 || u !== o) throw new Error("The timer is in an undefined state.");
        } else if (typeof a < "u") a(), t.delete(o);
        else throw new Error("The timer is in an undefined state.");
      } else if (Ni.isClearResponse(i)) {
        let { id: o } = i, a = r.get(o);
        if (a === void 0) throw new Error("The timer is in an undefined state.");
        r.delete(o), t.delete(a);
      } else {
        let { error: { message: o } } = i;
        throw new Error(o);
      }
    }), { clearTimeout: (i) => {
      let o = Math.random();
      r.set(o, i), t.set(i, o), n.postMessage({ id: o, method: "clear", params: { timerId: i } });
    }, setTimeout: (i, o) => {
      let a = Math.random();
      return t.set(a, i), n.postMessage({ id: null, method: "set", params: { delay: o, now: performance.now(), timerId: a } }), a;
    } };
  }, Ni.loadWorkerTimers = () => {
    let e = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
    return () => {
      if (Ni.workerTimers !== null) return Ni.workerTimers;
      let t = new Blob([e], { type: "application/javascript; charset=utf-8" }), r = URL.createObjectURL(t);
      return Ni.workerTimers = Ni.load(r), Ni.workerTimers.setTimeout(() => URL.revokeObjectURL(r), 0), Ni.workerTimers;
    };
  }, Ni.timers = Ni.loadWorkerTimers(), Ni.isCallNotification = (e) => e.method !== void 0 && e.method === "call", Ni.isClearResponse = (e) => e.error === null && typeof e.id == "number";
}), Ko, VSe, jSe, zSe, qSe, YSe, GSe, WSe, KSe, XSe, JSe, ZSe, QSe, p8, ebe, tbe, rbe = Qe(() => {
  Jy(), Ko = class extends el {
    constructor(e, t, r) {
      super(e, t), this.privSignature = r;
    }
  }, VSe = class extends Ko {
    constructor(e) {
      super("OCSPMemoryCacheHitEvent", hn.Debug, e);
    }
  }, jSe = class extends Ko {
    constructor(e) {
      super("OCSPCacheMissEvent", hn.Debug, e);
    }
  }, zSe = class extends Ko {
    constructor(e) {
      super("OCSPDiskCacheHitEvent", hn.Debug, e);
    }
  }, qSe = class extends Ko {
    constructor(e) {
      super("OCSPCacheUpdateNeededEvent", hn.Debug, e);
    }
  }, YSe = class extends Ko {
    constructor(e) {
      super("OCSPMemoryCacheStoreEvent", hn.Debug, e);
    }
  }, GSe = class extends Ko {
    constructor(e) {
      super("OCSPDiskCacheStoreEvent", hn.Debug, e);
    }
  }, WSe = class extends Ko {
    constructor(e) {
      super("OCSPCacheUpdatehCompleteEvent", hn.Debug, e);
    }
  }, KSe = class extends Ko {
    constructor() {
      super("OCSPStapleReceivedEvent", hn.Debug, "");
    }
  }, XSe = class extends Ko {
    constructor(e, t) {
      super("OCSPCacheEntryExpiredEvent", hn.Debug, e), this.privExpireTime = t;
    }
  }, JSe = class extends Ko {
    constructor(e, t, r) {
      super("OCSPCacheEntryNeedsRefreshEvent", hn.Debug, e), this.privExpireTime = r, this.privStartTime = t;
    }
  }, ZSe = class extends Ko {
    constructor(e, t, r) {
      super("OCSPCacheHitEvent", hn.Debug, e), this.privExpireTime = r, this.privExpireTimeString = new Date(r).toLocaleDateString(), this.privStartTime = t, this.privStartTimeString = new Date(t).toLocaleTimeString();
    }
  }, QSe = class extends Ko {
    constructor(e, t) {
      super("OCSPVerificationFailedEvent", hn.Debug, e), this.privError = t;
    }
  }, p8 = class extends Ko {
    constructor(e, t) {
      super("OCSPCacheFetchErrorEvent", hn.Debug, e), this.privError = t;
    }
  }, ebe = class extends Ko {
    constructor(e) {
      super("OCSPResponseRetrievedEvent", hn.Debug, e);
    }
  }, tbe = class extends Ko {
    constructor(e, t) {
      super("OCSPCacheUpdateErrorEvent", hn.Debug, e), this.privError = t;
    }
  };
}), ec, abr = Qe(() => {
  vr(), ec = class extends el {
    constructor(e) {
      super("BackgroundEvent", hn.Error), this.privError = e;
    }
    get error() {
      return this.privError;
    }
  };
}), vr = Qe(() => {
  USr(), VSr(), LSe(), jSr(), kSe(), gc(), zSr(), MSe(), _d(), qSr(), YSr(), GSr(), WSr(), KSr(), XSr(), JSr(), ZSr(), QSr(), HSe(), Jy(), i$(), $Se(), ebr(), tbr(), rbr(), a$(), nbr(), ibr(), obr(), rbe(), abr();
}), nbe, ubr = Qe(() => {
  vr(), nbe = class {
    constructor(e = hn.Warning) {
      this.onEvent = (t) => {
        if (t.eventType >= this.privLogLevelFilter) {
          let r = this.toString(t);
          switch (t.eventType) {
            case hn.Debug:
              console.debug(r);
              break;
            case hn.Info:
              console.info(r);
              break;
            case hn.Warning:
              console.warn(r);
              break;
            case hn.Error:
              console.error(r);
              break;
            default:
              console.log(r);
              break;
          }
        }
      }, this.toString = (t) => {
        let r = [`${t.EventTime}`, `${t.Name}`];
        for (let n in t) if (n && t.hasOwnProperty(n) && n !== "eventTime" && n !== "eventType" && n !== "eventId" && n !== "name" && n !== "constructor") {
          let i = t[n], o = "<NULL>";
          i != null && (typeof i == "number" || typeof i == "string" ? o = i.toString() : o = JSON.stringify(i)), r.push(`${n}: ${o}`);
        }
        return r.join(" | ");
      }, this.privLogLevelFilter = e;
    }
  };
}), sbr = Qe(() => {
}), wn, Tc = Qe(() => {
  wn = class {
  }, wn.AuthKey = "Ocp-Apim-Subscription-Key", wn.ConnectionId = "X-ConnectionId", wn.ContentType = "Content-Type", wn.CustomCommandsAppId = "X-CommandsAppId", wn.Path = "Path", wn.RequestId = "X-RequestId", wn.RequestStreamId = "X-StreamId", wn.RequestTimestamp = "X-Timestamp";
}), db, u$ = Qe(() => {
  db = class {
    constructor(e, t) {
      this.privHeaderName = e, this.privToken = t;
    }
    get headerName() {
      return this.privHeaderName;
    }
    get token() {
      return this.privToken;
    }
  };
}), s$, cbr = Qe(() => {
  vr(), Tc(), u$(), s$ = class {
    constructor(e) {
      if (this.fetch = (t) => Promise.resolve(this.privAuthInfo), this.fetchOnExpiry = (t) => Promise.resolve(this.privAuthInfo), !e) throw new Ji("subscriptionKey");
      this.privAuthInfo = new db(wn.AuthKey, e);
    }
  };
}), S5, c$, lbr = Qe(() => {
  vr(), u$(), S5 = "Authorization", c$ = class {
    constructor(e, t) {
      if (this.fetch = (r) => this.privFetchCallback(r).then((n) => new db(S5, n)), this.fetchOnExpiry = (r) => this.privFetchOnExpiryCallback(r).then((n) => new db(S5, n)), !e) throw new Ji("fetchCallback");
      if (!t) throw new Ji("fetchOnExpiryCallback");
      this.privFetchCallback = e, this.privFetchOnExpiryCallback = t;
    }
  };
}), fbr = Qe(() => {
}), dbr = Qe(() => {
}), nt, rn = Qe(() => {
  nt = class p1 {
    static throwIfNullOrUndefined(t, r) {
      if (t == null) throw new Error("throwIfNullOrUndefined:" + r);
    }
    static throwIfNull(t, r) {
      if (t === null) throw new Error("throwIfNull:" + r);
    }
    static throwIfNullOrWhitespace(t, r) {
      if (p1.throwIfNullOrUndefined(t, r), ("" + t).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + r);
    }
    static throwIfDisposed(t) {
      if (t) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(t, r) {
      if (p1.throwIfNullOrUndefined(t, r), t.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + r);
      for (let n of t) p1.throwIfNullOrWhitespace(n, r);
    }
    static throwIfFileDoesNotExist(t, r) {
      p1.throwIfNullOrWhitespace(t, r);
    }
    static throwIfNotUndefined(t, r) {
      if (t !== void 0) throw new Error("throwIfNotUndefined:" + r);
    }
  };
}), pbr = ot(() => {
}), l$, ibe = Qe(() => {
  Qa(pbr()), rn(), l$ = class {
    constructor(e) {
      this.id = () => this.privId, nt.throwIfNullOrUndefined(void 0, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = (void 0)(e, "w");
    }
    set format(e) {
      nt.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = e;
      let t = 0;
      this.privAudioFormat.hasHeader && (t = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = (void 0)("", { fd: this.privFd, start: t, autoClose: !1 }));
    }
    write(e) {
      nt.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(e.slice(0)));
    }
    close() {
      this.privFd !== void 0 && (this.privWriteStream.on("finish", () => {
        this.privAudioFormat.hasHeader && (this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten), (void 0)(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0)), (void 0)(this.privFd), this.privFd = void 0;
      }), this.privWriteStream.end());
    }
  };
}), Rr, Vf, Kl, m0 = Qe(() => {
  (function(e) {
    e[e.PCM = 1] = "PCM", e[e.MuLaw = 2] = "MuLaw", e[e.Siren = 3] = "Siren", e[e.MP3 = 4] = "MP3", e[e.SILKSkype = 5] = "SILKSkype", e[e.OGG_OPUS = 6] = "OGG_OPUS", e[e.WEBM_OPUS = 7] = "WEBM_OPUS", e[e.ALaw = 8] = "ALaw";
  })(Rr || (Rr = {})), Vf = class {
    static getDefaultInputFormat() {
      return Kl.getDefaultInputFormat();
    }
    static getWaveFormatPCM(e, t, r) {
      return new Kl(e, t, r);
    }
  }, Kl = class obe extends Vf {
    constructor(t = 16e3, r = 16, n = 1, i = Rr.PCM) {
      switch (super(), this.setString = (a, u, s) => {
        for (let c = 0; c < s.length; c++) a.setUint8(u + c, s.charCodeAt(c));
      }, i) {
        case Rr.PCM:
          this.formatTag = 1;
          break;
        case Rr.ALaw:
          this.formatTag = 6;
          break;
        case Rr.MuLaw:
          this.formatTag = 7;
          break;
      }
      this.bitsPerSample = r, this.samplesPerSec = t, this.channels = n, this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8), this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8), this.privHeader = new ArrayBuffer(44);
      let o = new DataView(this.privHeader);
      this.setString(o, 0, "RIFF"), o.setUint32(4, 0, !0), this.setString(o, 8, "WAVEfmt "), o.setUint32(16, 16, !0), o.setUint16(20, this.formatTag, !0), o.setUint16(22, this.channels, !0), o.setUint32(24, this.samplesPerSec, !0), o.setUint32(28, this.avgBytesPerSec, !0), o.setUint16(32, this.channels * (this.bitsPerSample / 8), !0), o.setUint16(34, this.bitsPerSample, !0), this.setString(o, 36, "data"), o.setUint32(40, 0, !0);
    }
    static getDefaultInputFormat() {
      return new obe();
    }
    static getAudioContext(t) {
      let r = window.AudioContext || window.webkitAudioContext || !1;
      if (r) return t !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new r({ sampleRate: t }) : new r();
      throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    close() {
    }
    get header() {
      return this.privHeader;
    }
  };
}), r4, wp, rS, Mue, nS, h8, abe = Qe(() => {
  hr(), vr(), _d(), Kt(), m0(), r4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, wp = class {
    constructor() {
    }
    static createPushStream(e) {
      return rS.create(e);
    }
    static createPullStream(e, t) {
      return nS.create(e, t);
    }
  }, rS = class extends wp {
    static create(e) {
      return new Mue(e);
    }
  }, Mue = class extends rS {
    constructor(e) {
      super(), this.onEvent = (t) => {
        this.privEvents.onEvent(t), ci.instance.onEvent(t);
      }, e === void 0 ? this.privFormat = Kl.getDefaultInputFormat() : this.privFormat = e, this.privEvents = new su(), this.privId = jn(), this.privStream = new Qy(this.privFormat.avgBytesPerSec / 10);
    }
    get format() {
      return Promise.resolve(this.privFormat);
    }
    write(e) {
      this.privStream.writeStreamChunk({ buffer: e, isEnd: !1, timeReceived: Date.now() });
    }
    close() {
      this.privStream.close();
    }
    id() {
      return this.privId;
    }
    get blob() {
      return this.attach("id").then((e) => {
        let t = [], r = Buffer.from(""), n = () => e.read().then((i) => !i || i.isEnd ? typeof XMLHttpRequest < "u" && typeof Blob < "u" ? Promise.resolve(new Blob(t)) : Promise.resolve(Buffer.from(r)) : (typeof Blob < "u" ? t.push(i.buffer) : r = Buffer.concat([r, this.toBuffer(i.buffer)]), n()));
        return n();
      });
    }
    turnOn() {
      this.onEvent(new ih(this.privId)), this.onEvent(new Hf(this.privId));
    }
    attach(e) {
      return r4(this, void 0, void 0, function* () {
        this.onEvent(new $f(this.privId, e)), yield this.turnOn();
        let t = this.privStream;
        return this.onEvent(new Uf(this.privId, e)), { detach: () => r4(this, void 0, void 0, function* () {
          return t.readEnded(), this.onEvent(new hs(this.privId, e)), this.turnOff();
        }), id: () => e, read: () => t.read() };
      });
    }
    detach(e) {
      this.onEvent(new hs(this.privId, e));
    }
    turnOff() {
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return Promise.resolve({ bitspersample: this.privFormat.bitsPerSample, channelcount: this.privFormat.channels, connectivity: r0.Unknown, manufacturer: "Speech SDK", model: "PushStream", samplerate: this.privFormat.samplesPerSec, type: tl.Stream });
    }
    toBuffer(e) {
      let t = Buffer.alloc(e.byteLength), r = new Uint8Array(e);
      for (let n = 0; n < t.length; ++n) t[n] = r[n];
      return t;
    }
  }, nS = class extends wp {
    constructor() {
      super();
    }
    static create(e, t) {
      return new h8(e, t);
    }
  }, h8 = class extends nS {
    constructor(e, t) {
      super(), this.onEvent = (r) => {
        this.privEvents.onEvent(r), ci.instance.onEvent(r);
      }, t === void 0 ? this.privFormat = Vf.getDefaultInputFormat() : this.privFormat = t, this.privEvents = new su(), this.privId = jn(), this.privCallback = e, this.privIsClosed = !1, this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    get format() {
      return Promise.resolve(this.privFormat);
    }
    close() {
      this.privIsClosed = !0, this.privCallback.close();
    }
    id() {
      return this.privId;
    }
    get blob() {
      return Promise.reject("Not implemented");
    }
    turnOn() {
      this.onEvent(new ih(this.privId)), this.onEvent(new Hf(this.privId));
    }
    attach(e) {
      return r4(this, void 0, void 0, function* () {
        return this.onEvent(new $f(this.privId, e)), yield this.turnOn(), this.onEvent(new Uf(this.privId, e)), { detach: () => (this.privCallback.close(), this.onEvent(new hs(this.privId, e)), this.turnOff()), id: () => e, read: () => {
          let t = 0, r;
          for (; t < this.privBufferSize; ) {
            let n = new ArrayBuffer(this.privBufferSize - t), i = this.privCallback.read(n);
            if (r === void 0 ? r = n : new Int8Array(r).set(new Int8Array(n), t), i === 0) break;
            t += i;
          }
          return Promise.resolve({ buffer: r.slice(0, t), isEnd: this.privIsClosed || t === 0, timeReceived: Date.now() });
        } };
      });
    }
    detach(e) {
      this.onEvent(new hs(this.privId, e));
    }
    turnOff() {
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return Promise.resolve({ bitspersample: this.privFormat.bitsPerSample, channelcount: this.privFormat.channels, connectivity: r0.Unknown, manufacturer: "Speech SDK", model: "PullStream", samplerate: this.privFormat.samplesPerSec, type: tl.Stream });
    }
  };
}), Wr, ube = Qe(() => {
  (function(e) {
    e[e.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", e[e.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", e[e.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", e[e.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", e[e.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", e[e.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", e[e.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", e[e.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", e[e.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", e[e.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", e[e.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", e[e.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", e[e.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", e[e.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", e[e.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", e[e.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", e[e.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", e[e.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", e[e.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", e[e.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", e[e.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", e[e.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", e[e.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", e[e.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", e[e.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", e[e.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", e[e.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", e[e.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", e[e.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw";
  })(Wr || (Wr = {}));
}), sh, s2 = Qe(() => {
  ube(), m0(), sh = class un extends Kl {
    constructor(t, r, n, i, o, a, u, s, c) {
      super(n, a, r, t), this.formatTag = t, this.avgBytesPerSec = i, this.blockAlign = o, this.priAudioFormatString = u, this.priRequestAudioFormatString = s, this.priHasHeader = c;
    }
    static fromSpeechSynthesisOutputFormat(t) {
      return t === void 0 ? un.getDefaultOutputFormat() : un.fromSpeechSynthesisOutputFormatString(un.SpeechSynthesisOutputFormatToString[t]);
    }
    static fromSpeechSynthesisOutputFormatString(t) {
      switch (t) {
        case "raw-8khz-8bit-mono-mulaw":
          return new un(Rr.MuLaw, 1, 8e3, 8e3, 1, 8, t, t, !1);
        case "riff-16khz-16kbps-mono-siren":
          return new un(Rr.Siren, 1, 16e3, 2e3, 40, 0, t, "audio-16khz-16kbps-mono-siren", !0);
        case "audio-16khz-16kbps-mono-siren":
          return new un(Rr.Siren, 1, 16e3, 2e3, 40, 0, t, t, !1);
        case "audio-16khz-32kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 16e3, 4096, 2, 16, t, t, !1);
        case "audio-16khz-128kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 16e3, 16384, 2, 16, t, t, !1);
        case "audio-16khz-64kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 16e3, 8192, 2, 16, t, t, !1);
        case "audio-24khz-48kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 24e3, 6144, 2, 16, t, t, !1);
        case "audio-24khz-96kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 24e3, 12288, 2, 16, t, t, !1);
        case "audio-24khz-160kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 24e3, 20480, 2, 16, t, t, !1);
        case "raw-16khz-16bit-mono-truesilk":
          return new un(Rr.SILKSkype, 1, 16e3, 32e3, 2, 16, t, t, !1);
        case "riff-8khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 8e3, 16e3, 2, 16, t, "raw-8khz-16bit-mono-pcm", !0);
        case "riff-24khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 24e3, 48e3, 2, 16, t, "raw-24khz-16bit-mono-pcm", !0);
        case "riff-8khz-8bit-mono-mulaw":
          return new un(Rr.MuLaw, 1, 8e3, 8e3, 1, 8, t, "raw-8khz-8bit-mono-mulaw", !0);
        case "raw-16khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 16e3, 32e3, 2, 16, t, "raw-16khz-16bit-mono-pcm", !1);
        case "raw-24khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 24e3, 48e3, 2, 16, t, "raw-24khz-16bit-mono-pcm", !1);
        case "raw-8khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 8e3, 16e3, 2, 16, t, "raw-8khz-16bit-mono-pcm", !1);
        case "ogg-16khz-16bit-mono-opus":
          return new un(Rr.OGG_OPUS, 1, 16e3, 8192, 2, 16, t, t, !1);
        case "ogg-24khz-16bit-mono-opus":
          return new un(Rr.OGG_OPUS, 1, 24e3, 8192, 2, 16, t, t, !1);
        case "raw-48khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 48e3, 96e3, 2, 16, t, "raw-48khz-16bit-mono-pcm", !1);
        case "riff-48khz-16bit-mono-pcm":
          return new un(Rr.PCM, 1, 48e3, 96e3, 2, 16, t, "raw-48khz-16bit-mono-pcm", !0);
        case "audio-48khz-96kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 48e3, 12288, 2, 16, t, t, !1);
        case "audio-48khz-192kbitrate-mono-mp3":
          return new un(Rr.MP3, 1, 48e3, 24576, 2, 16, t, t, !1);
        case "ogg-48khz-16bit-mono-opus":
          return new un(Rr.OGG_OPUS, 1, 48e3, 12e3, 2, 16, t, t, !1);
        case "webm-16khz-16bit-mono-opus":
          return new un(Rr.WEBM_OPUS, 1, 16e3, 8e3, 2, 16, t, t, !1);
        case "webm-24khz-16bit-mono-opus":
          return new un(Rr.WEBM_OPUS, 1, 24e3, 8e3, 2, 16, t, t, !1);
        case "raw-24khz-16bit-mono-truesilk":
          return new un(Rr.SILKSkype, 1, 24e3, 48e3, 2, 16, t, t, !1);
        case "raw-8khz-8bit-mono-alaw":
          return new un(Rr.ALaw, 1, 8e3, 8e3, 1, 8, t, t, !1);
        case "riff-8khz-8bit-mono-alaw":
          return new un(Rr.ALaw, 1, 8e3, 8e3, 1, 8, t, "raw-8khz-8bit-mono-alaw", !0);
        case "riff-16khz-16bit-mono-pcm":
        default:
          return new un(Rr.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
      }
    }
    static getDefaultOutputFormat() {
      return un.fromSpeechSynthesisOutputFormatString(typeof window < "u" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    get hasHeader() {
      return this.priHasHeader;
    }
    get header() {
      if (this.hasHeader) return this.privHeader;
    }
    updateHeader(t) {
      this.priHasHeader && new DataView(this.privHeader).setUint32(40, t, !0);
    }
    get requestAudioFormatString() {
      return this.priRequestAudioFormatString;
    }
  }, sh.SpeechSynthesisOutputFormatToString = { [Wr.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw", [Wr.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren", [Wr.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren", [Wr.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3", [Wr.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3", [Wr.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3", [Wr.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3", [Wr.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3", [Wr.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3", [Wr.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk", [Wr.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm", [Wr.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm", [Wr.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm", [Wr.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw", [Wr.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm", [Wr.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm", [Wr.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm", [Wr.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus", [Wr.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus", [Wr.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm", [Wr.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm", [Wr.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3", [Wr.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3", [Wr.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus", [Wr.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus", [Wr.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus", [Wr.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk", [Wr.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw", [Wr.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw" };
}), Fue, P1, Pp, pb, hb, vb, rv = Qe(() => {
  vr(), rn(), s2(), Fue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, P1 = class {
    constructor() {
    }
    static createPullStream() {
      return Pp.create();
    }
  }, Pp = class extends P1 {
    static create() {
      return new pb();
    }
  }, pb = class extends Pp {
    constructor() {
      super(), this.privId = jn(), this.privStream = new o$();
    }
    set format(e) {
      e == null && (this.privFormat = sh.getDefaultOutputFormat()), this.privFormat = e;
    }
    get format() {
      return this.privFormat;
    }
    get isClosed() {
      return this.privStream.isClosed;
    }
    id() {
      return this.privId;
    }
    read(e) {
      return Fue(this, void 0, void 0, function* () {
        let t = new Int8Array(e), r = 0;
        if (this.privLastChunkView !== void 0) {
          if (this.privLastChunkView.length > e.byteLength) return t.set(this.privLastChunkView.slice(0, e.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(e.byteLength), Promise.resolve(e.byteLength);
          t.set(this.privLastChunkView), r = this.privLastChunkView.length, this.privLastChunkView = void 0;
        }
        for (; r < e.byteLength && !this.privStream.isReadEnded; ) {
          let n = yield this.privStream.read();
          if (n !== void 0 && !n.isEnd) {
            let i;
            n.buffer.byteLength > e.byteLength - r ? (i = n.buffer.slice(0, e.byteLength - r), this.privLastChunkView = new Int8Array(n.buffer.slice(e.byteLength - r))) : i = n.buffer, t.set(new Int8Array(i), r), r += i.byteLength;
          } else yield this.privStream.readEnded();
        }
        return r;
      });
    }
    write(e) {
      nt.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({ buffer: e, isEnd: !1, timeReceived: Date.now() });
    }
    close() {
      this.privStream.close();
    }
  }, hb = class extends P1 {
    constructor() {
      super();
    }
    static create(e) {
      return new vb(e);
    }
  }, vb = class extends hb {
    constructor(e) {
      super(), this.privId = jn(), this.privCallback = e;
    }
    set format(e) {
    }
    write(e) {
      this.privCallback.write && this.privCallback.write(e);
    }
    close() {
      this.privCallback.close && this.privCallback.close();
    }
    id() {
      return this.privId;
    }
  };
}), Xl, W0, K0, hbr = Qe(() => {
  hu(), rn(), Kt(), ibe(), abe(), rv(), Xl = class sbe {
    static fromDefaultMicrophoneInput() {
      let t = new L1();
      return new W0(new N1(t));
    }
    static fromMicrophoneInput(t) {
      let r = new L1();
      return new W0(new N1(r, t));
    }
    static fromWavFileInput(t, r = "unnamedBuffer.wav") {
      return new W0(new A3e(t, r));
    }
    static fromStreamInput(t) {
      if (t instanceof f$) return new W0(new h8(t));
      if (t instanceof wp) return new W0(t);
      if (typeof MediaStream < "u" && t instanceof MediaStream) {
        let r = new L1();
        return new W0(new N1(r, null, null, t));
      }
      throw new Error("Not Supported Type");
    }
    static fromDefaultSpeakerOutput() {
      return new K0(new Cb());
    }
    static fromSpeakerOutput(t) {
      if (t === void 0) return sbe.fromDefaultSpeakerOutput();
      if (t instanceof Cb) return new K0(t);
      throw new Error("Not Supported Type");
    }
    static fromAudioFileOutput(t) {
      return new K0(new l$(t));
    }
    static fromStreamOutput(t) {
      if (t instanceof c2) return new K0(new vb(t));
      if (t instanceof hb) return new K0(t);
      if (t instanceof Pp) return new K0(t);
      throw new Error("Not Supported Type");
    }
  }, W0 = class extends Xl {
    constructor(e) {
      super(), this.privSource = e;
    }
    get format() {
      return this.privSource.format;
    }
    close(e, t) {
      this.privSource.turnOff().then(() => {
        e && e();
      }, (r) => {
        t && t(r);
      });
    }
    id() {
      return this.privSource.id();
    }
    get blob() {
      return this.privSource.blob;
    }
    turnOn() {
      return this.privSource.turnOn();
    }
    attach(e) {
      return this.privSource.attach(e);
    }
    detach(e) {
      return this.privSource.detach(e);
    }
    turnOff() {
      return this.privSource.turnOff();
    }
    get events() {
      return this.privSource.events;
    }
    setProperty(e, t) {
      if (nt.throwIfNull(t, "value"), this.privSource.setProperty !== void 0) this.privSource.setProperty(e, t);
      else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(e, t) {
      if (this.privSource.getProperty !== void 0) return this.privSource.getProperty(e, t);
      throw new Error("This AudioConfig instance does not support getting properties.");
    }
    get deviceInfo() {
      return this.privSource.deviceInfo;
    }
  }, K0 = class extends Xl {
    constructor(e) {
      super(), this.privDestination = e;
    }
    set format(e) {
      this.privDestination.format = e;
    }
    write(e) {
      this.privDestination.write(e);
    }
    close() {
      this.privDestination.close();
    }
    id() {
      return this.privDestination.id();
    }
    setProperty(e, t) {
      throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(e, t) {
      throw new Error("This AudioConfig instance does not support getting properties.");
    }
  };
}), oi, vbr = Qe(() => {
  (function(e) {
    e[e.Error = 0] = "Error", e[e.EndOfStream = 1] = "EndOfStream";
  })(oi || (oi = {}));
}), f$, Ebr = Qe(() => {
  f$ = class {
  };
}), c2, mbr = Qe(() => {
  c2 = class {
  };
}), cbe, gbr = Qe(() => {
  rn(), cbe = class {
    constructor() {
      this.privDisposed = !1;
    }
    static fromFile(e) {
      throw nt.throwIfFileDoesNotExist(e, "fileName"), new Error("Not yet implemented.");
    }
    static fromStream(e) {
      throw nt.throwIfNull(e, "file"), new Error("Not yet implemented.");
    }
    close() {
      this.privDisposed || (this.privDisposed = !0);
    }
  };
}), $o, Tbr = Qe(() => {
  $o = class {
    constructor(e) {
      this.privSessionId = e;
    }
    get sessionId() {
      return this.privSessionId;
    }
  };
}), Ts, ybr = Qe(() => {
  Kt(), Ts = class extends $o {
    constructor(e, t) {
      super(t), this.privOffset = e;
    }
    get offset() {
      return this.privOffset;
    }
  };
}), vi, _br = Qe(() => {
  (function(e) {
    e[e.Simple = 0] = "Simple", e[e.Detailed = 1] = "Detailed";
  })(vi || (vi = {}));
}), yf, Abr = Qe(() => {
  Kt(), yf = class extends Ts {
    constructor(e, t, r) {
      super(t, r), this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  };
}), l2, Sbr = Qe(() => {
  l2 = class {
    constructor(e, t, r, n, i, o, a, u, s, c) {
      this.privResultId = e, this.privReason = t, this.privText = r, this.privDuration = n, this.privOffset = i, this.privLanguage = o, this.privLanguageDetectionConfidence = a, this.privErrorDetails = u, this.privJson = s, this.privProperties = c;
    }
    get resultId() {
      return this.privResultId;
    }
    get reason() {
      return this.privReason;
    }
    get text() {
      return this.privText;
    }
    get duration() {
      return this.privDuration;
    }
    get offset() {
      return this.privOffset;
    }
    get language() {
      return this.privLanguage;
    }
    get languageDetectionConfidence() {
      return this.privLanguageDetectionConfidence;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    get json() {
      return this.privJson;
    }
    get properties() {
      return this.privProperties;
    }
  };
}), ra, bbr = Qe(() => {
  Kt(), ra = class extends l2 {
    constructor(e, t, r, n, i, o, a, u, s, c, l) {
      super(e, t, r, n, i, o, a, s, c, l), this.privSpeakerId = u;
    }
    get speakerId() {
      return this.privSpeakerId;
    }
  };
}), lf, Cbr = Qe(() => {
  Kt(), lf = class extends ra {
    constructor(e, t, r, n, i, o, a, u, s, c, l) {
      super(t, r, n, i, o, a, u, void 0, s, c, l), this.privIntentId = e;
    }
    get intentId() {
      return this.privIntentId;
    }
  };
}), v8, n4, Ibr = Qe(() => {
  rn(), v8 = class {
    constructor() {
    }
    static fromEndpoint(e) {
      nt.throwIfNull(e, "uri"), nt.throwIfNullOrWhitespace(e.hostname, "uri");
      let t = new n4(), r = e.host.indexOf(".");
      if (r === -1) throw new Error("Could not determine region from endpoint");
      t.region = e.host.substr(0, r);
      let n = e.pathname.lastIndexOf("/") + 1;
      if (n === -1) throw new Error("Could not determine appId from endpoint");
      if (t.appId = e.pathname.substr(n), t.subscriptionKey = e.searchParams.get("subscription-key"), t.subscriptionKey === void 0) throw new Error("Could not determine subscription key from endpoint");
      return t;
    }
    static fromAppId(e) {
      nt.throwIfNullOrWhitespace(e, "appId");
      let t = new n4();
      return t.appId = e, t;
    }
    static fromSubscription(e, t, r) {
      nt.throwIfNullOrWhitespace(e, "subscriptionKey"), nt.throwIfNullOrWhitespace(t, "appId"), nt.throwIfNullOrWhitespace(r, "region");
      let n = new n4();
      return n.appId = t, n.region = r, n.subscriptionKey = e, n;
    }
  }, n4 = class extends v8 {
  };
}), tc, lbe, Obr = Qe(() => {
  Kt(), tc = class extends Ts {
    constructor(e, t, r) {
      super(t, r), this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  }, lbe = class extends tc {
  };
}), f2, d$ = Qe(() => {
  Kt(), f2 = class extends Ts {
    constructor(e, t, r, n, i) {
      super(n, i), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = r;
    }
    get reason() {
      return this.privReason;
    }
    get errorCode() {
      return this.privErrorCode;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
}), d2, Rbr = Qe(() => {
  d$(), d2 = class extends f2 {
  };
}), Eb, wbr = Qe(() => {
  Kt(), Eb = class extends Ts {
    constructor(e, t, r) {
      super(t, r), this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  };
}), mb, Pbr = Qe(() => {
  Kt(), mb = class extends $o {
    constructor(e, t) {
      super(t), this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  };
}), Dp, fbe = Qe(() => {
  Kt(), Dp = class extends ra {
    constructor(e, t, r, n, i, o, a, u, s) {
      super(t, r, n, i, o, void 0, void 0, void 0, a, u, s), this.privTranslations = e;
    }
    get translations() {
      return this.privTranslations;
    }
  };
}), gb, Dbr = Qe(() => {
  gb = class {
    constructor(e, t) {
      this.privReason = e, this.privAudio = t;
    }
    get audio() {
      return this.privAudio;
    }
    get reason() {
      return this.privReason;
    }
  };
}), or, xbr = Qe(() => {
  (function(e) {
    e[e.NoMatch = 0] = "NoMatch", e[e.Canceled = 1] = "Canceled", e[e.RecognizingSpeech = 2] = "RecognizingSpeech", e[e.RecognizedSpeech = 3] = "RecognizedSpeech", e[e.RecognizedKeyword = 4] = "RecognizedKeyword", e[e.RecognizingIntent = 5] = "RecognizingIntent", e[e.RecognizedIntent = 6] = "RecognizedIntent", e[e.TranslatingSpeech = 7] = "TranslatingSpeech", e[e.TranslatedSpeech = 8] = "TranslatedSpeech", e[e.SynthesizingAudio = 9] = "SynthesizingAudio", e[e.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", e[e.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", e[e.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", e[e.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", e[e.RecognizedSpeakers = 14] = "RecognizedSpeakers", e[e.RecognizedSpeaker = 15] = "RecognizedSpeaker", e[e.ResetVoiceProfile = 16] = "ResetVoiceProfile", e[e.DeletedVoiceProfile = 17] = "DeletedVoiceProfile";
  })(or || (or = {}));
}), Tb, ff, Nbr = Qe(() => {
  hr(), rn(), Kt(), Tb = class {
    constructor() {
    }
    static fromSubscription(e, t) {
      nt.throwIfNullOrWhitespace(e, "subscriptionKey"), nt.throwIfNullOrWhitespace(t, "region");
      let r = new ff();
      return r.setProperty(ke.SpeechServiceConnection_Region, t), r.setProperty(ke.SpeechServiceConnection_IntentRegion, t), r.setProperty(ke.SpeechServiceConnection_Key, e), r;
    }
    static fromEndpoint(e, t) {
      nt.throwIfNull(e, "endpoint");
      let r = new ff();
      return r.setProperty(ke.SpeechServiceConnection_Endpoint, e.href), t !== void 0 && r.setProperty(ke.SpeechServiceConnection_Key, t), r;
    }
    static fromHost(e, t) {
      nt.throwIfNull(e, "hostName");
      let r = new ff();
      return r.setProperty(ke.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && r.setProperty(ke.SpeechServiceConnection_Key, t), r;
    }
    static fromAuthorizationToken(e, t) {
      nt.throwIfNull(e, "authorizationToken"), nt.throwIfNullOrWhitespace(t, "region");
      let r = new ff();
      return r.setProperty(ke.SpeechServiceConnection_Region, t), r.setProperty(ke.SpeechServiceConnection_IntentRegion, t), r.authorizationToken = e, r;
    }
    close() {
    }
  }, ff = class dbe extends Tb {
    constructor() {
      super(), this.privProperties = new zn(), this.speechRecognitionLanguage = "en-US", this.outputFormat = vi.Simple;
    }
    get properties() {
      return this.privProperties;
    }
    get endPoint() {
      return new URL(this.privProperties.getProperty(ke.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_Key);
    }
    get region() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
      return this.privProperties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(t) {
      this.privProperties.setProperty(ke.SpeechServiceAuthorization_Token, t);
    }
    get speechRecognitionLanguage() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_RecoLanguage, t);
    }
    get autoDetectSourceLanguages() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages, t);
    }
    get outputFormat() {
      return vi[this.privProperties.getProperty(nc, void 0)];
    }
    set outputFormat(t) {
      this.privProperties.setProperty(nc, vi[t]);
    }
    get endpointId() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_EndpointId);
    }
    set endpointId(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_EndpointId, t);
    }
    setProperty(t, r) {
      nt.throwIfNull(r, "value"), this.privProperties.setProperty(t, r);
    }
    getProperty(t, r) {
      return this.privProperties.getProperty(t, r);
    }
    setProxy(t, r, n, i) {
      this.setProperty(ke[ke.SpeechServiceConnection_ProxyHostName], t), this.setProperty(ke[ke.SpeechServiceConnection_ProxyPort], r), this.setProperty(ke[ke.SpeechServiceConnection_ProxyUserName], n), this.setProperty(ke[ke.SpeechServiceConnection_ProxyPassword], i);
    }
    setServiceProperty(t, r, n) {
      let i = JSON.parse(this.privProperties.getProperty(ch, "{}"));
      i[t] = r, this.privProperties.setProperty(ch, JSON.stringify(i));
    }
    setProfanity(t) {
      this.privProperties.setProperty(ke.SpeechServiceResponse_ProfanityOption, jf[t]);
    }
    enableAudioLogging() {
      this.privProperties.setProperty(ke.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
      this.privProperties.setProperty(ke.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
      this.privProperties.setProperty(m2, "true");
    }
    clone() {
      let t = new dbe();
      return t.privProperties = this.privProperties.clone(), t;
    }
    get speechSynthesisLanguage() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_SynthLanguage, t);
    }
    get speechSynthesisVoiceName() {
      return this.privProperties.getProperty(ke.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_SynthVoice, t);
    }
    get speechSynthesisOutputFormat() {
      return Wr[this.privProperties.getProperty(ke.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(t) {
      this.privProperties.setProperty(ke.SpeechServiceConnection_SynthOutputFormat, Wr[t]);
    }
  };
}), yb, ap, Lbr = Qe(() => {
  hr(), rn(), Kt(), yb = class extends Tb {
    constructor() {
      super();
    }
    static fromSubscription(e, t) {
      nt.throwIfNullOrWhitespace(e, "subscriptionKey"), nt.throwIfNullOrWhitespace(t, "region");
      let r = new ap();
      return r.properties.setProperty(ke.SpeechServiceConnection_Key, e), r.properties.setProperty(ke.SpeechServiceConnection_Region, t), r;
    }
    static fromAuthorizationToken(e, t) {
      nt.throwIfNullOrWhitespace(e, "authorizationToken"), nt.throwIfNullOrWhitespace(t, "region");
      let r = new ap();
      return r.properties.setProperty(ke.SpeechServiceAuthorization_Token, e), r.properties.setProperty(ke.SpeechServiceConnection_Region, t), r;
    }
    static fromHost(e, t) {
      nt.throwIfNull(e, "hostName");
      let r = new ap();
      return r.setProperty(ke.SpeechServiceConnection_Host, e.protocol + "//" + e.hostname + (e.port === "" ? "" : ":" + e.port)), t !== void 0 && r.setProperty(ke.SpeechServiceConnection_Key, t), r;
    }
    static fromEndpoint(e, t) {
      nt.throwIfNull(e, "endpoint"), nt.throwIfNull(t, "subscriptionKey");
      let r = new ap();
      return r.properties.setProperty(ke.SpeechServiceConnection_Endpoint, e.href), r.properties.setProperty(ke.SpeechServiceConnection_Key, t), r;
    }
  }, ap = class extends yb {
    constructor() {
      super(), this.privSpeechProperties = new zn(), this.outputFormat = vi.Simple;
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    set speechRecognitionLanguage(e) {
      nt.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_RecoLanguage, e);
    }
    get speechRecognitionLanguage() {
      return this.privSpeechProperties.getProperty(ke[ke.SpeechServiceConnection_RecoLanguage]);
    }
    get subscriptionKey() {
      return this.privSpeechProperties.getProperty(ke[ke.SpeechServiceConnection_Key]);
    }
    get outputFormat() {
      return vi[this.privSpeechProperties.getProperty(nc, void 0)];
    }
    set outputFormat(e) {
      this.privSpeechProperties.setProperty(nc, vi[e]);
    }
    get endpointId() {
      return this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_EndpointId);
    }
    set endpointId(e) {
      this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_EndpointId, e);
    }
    addTargetLanguage(e) {
      nt.throwIfNullOrWhitespace(e, "value");
      let t = this.targetLanguages;
      t.push(e), this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_TranslationToLanguages, t.join(","));
    }
    get targetLanguages() {
      return this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_TranslationToLanguages).split(",") : [];
    }
    get voiceName() {
      return this.getProperty(ke[ke.SpeechServiceConnection_TranslationVoice]);
    }
    set voiceName(e) {
      nt.throwIfNullOrWhitespace(e, "value"), this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_TranslationVoice, e);
    }
    get region() {
      return this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_Region);
    }
    setProxy(e, t, r, n) {
      this.setProperty(ke[ke.SpeechServiceConnection_ProxyHostName], e), this.setProperty(ke[ke.SpeechServiceConnection_ProxyPort], t), this.setProperty(ke[ke.SpeechServiceConnection_ProxyUserName], r), this.setProperty(ke[ke.SpeechServiceConnection_ProxyPassword], n);
    }
    getProperty(e, t) {
      return this.privSpeechProperties.getProperty(e, t);
    }
    setProperty(e, t) {
      this.privSpeechProperties.setProperty(e, t);
    }
    get properties() {
      return this.privSpeechProperties;
    }
    close() {
    }
    setServiceProperty(e, t, r) {
      let n = JSON.parse(this.privSpeechProperties.getProperty(ch, "{}"));
      n[e] = t, this.privSpeechProperties.setProperty(ch, JSON.stringify(n));
    }
    setProfanity(e) {
      this.privSpeechProperties.setProperty(ke.SpeechServiceResponse_ProfanityOption, jf[e]);
    }
    enableAudioLogging() {
      this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
      this.privSpeechProperties.setProperty(ke.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
      this.privSpeechProperties.setProperty(m2, "true");
    }
    get speechSynthesisLanguage() {
      return this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(e) {
      this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_SynthLanguage, e);
    }
    get speechSynthesisVoiceName() {
      return this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(e) {
      this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_SynthVoice, e);
    }
    get speechSynthesisOutputFormat() {
      return Wr[this.privSpeechProperties.getProperty(ke.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(e) {
      this.privSpeechProperties.setProperty(ke.SpeechServiceConnection_SynthOutputFormat, Wr[e]);
    }
  };
}), zn, pbe = Qe(() => {
  Kt(), zn = class hbe {
    constructor() {
      this.privKeys = [], this.privValues = [];
    }
    getProperty(t, r) {
      let n;
      typeof t == "string" ? n = t : n = ke[t];
      for (let i = 0; i < this.privKeys.length; i++) if (this.privKeys[i] === n) return this.privValues[i];
      return r;
    }
    setProperty(t, r) {
      let n;
      typeof t == "string" ? n = t : n = ke[t];
      for (let i = 0; i < this.privKeys.length; i++) if (this.privKeys[i] === n) {
        this.privValues[i] = r;
        return;
      }
      this.privKeys.push(n), this.privValues.push(r);
    }
    clone() {
      let t = new hbe();
      for (let r = 0; r < this.privKeys.length; r++) t.privKeys.push(this.privKeys[r]), t.privValues.push(this.privValues[r]);
      return t;
    }
    mergeTo(t) {
      this.privKeys.forEach((r) => {
        if (t.getProperty(r, void 0) === void 0) {
          let n = this.getProperty(r);
          t.setProperty(r, n);
        }
      });
    }
  };
}), ke, p$ = Qe(() => {
  (function(e) {
    e[e.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", e[e.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", e[e.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", e[e.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", e[e.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", e[e.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", e[e.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", e[e.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", e[e.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", e[e.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", e[e.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", e[e.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", e[e.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", e[e.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", e[e.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", e[e.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", e[e.Speech_SessionId = 16] = "Speech_SessionId", e[e.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", e[e.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", e[e.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", e[e.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", e[e.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", e[e.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", e[e.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", e[e.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", e[e.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", e[e.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", e[e.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", e[e.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", e[e.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", e[e.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", e[e.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", e[e.SpeechServiceConnection_EnableAudioLogging = 32] = "SpeechServiceConnection_EnableAudioLogging", e[e.SpeechServiceResponse_ProfanityOption = 33] = "SpeechServiceResponse_ProfanityOption", e[e.SpeechServiceResponse_PostProcessingOption = 34] = "SpeechServiceResponse_PostProcessingOption", e[e.SpeechServiceResponse_RequestWordLevelTimestamps = 35] = "SpeechServiceResponse_RequestWordLevelTimestamps", e[e.SpeechServiceResponse_StablePartialResultThreshold = 36] = "SpeechServiceResponse_StablePartialResultThreshold", e[e.SpeechServiceResponse_OutputFormatOption = 37] = "SpeechServiceResponse_OutputFormatOption", e[e.SpeechServiceResponse_TranslationRequestStablePartialResult = 38] = "SpeechServiceResponse_TranslationRequestStablePartialResult", e[e.Conversation_ApplicationId = 39] = "Conversation_ApplicationId", e[e.Conversation_DialogType = 40] = "Conversation_DialogType", e[e.Conversation_Initial_Silence_Timeout = 41] = "Conversation_Initial_Silence_Timeout", e[e.Conversation_From_Id = 42] = "Conversation_From_Id", e[e.Conversation_Conversation_Id = 43] = "Conversation_Conversation_Id", e[e.Conversation_Custom_Voice_Deployment_Ids = 44] = "Conversation_Custom_Voice_Deployment_Ids", e[e.Conversation_Speech_Activity_Template = 45] = "Conversation_Speech_Activity_Template", e[e.Conversation_Request_Bot_Status_Messages = 46] = "Conversation_Request_Bot_Status_Messages", e[e.Conversation_Agent_Connection_Id = 47] = "Conversation_Agent_Connection_Id", e[e.SpeechServiceConnection_Host = 48] = "SpeechServiceConnection_Host", e[e.ConversationTranslator_Host = 49] = "ConversationTranslator_Host", e[e.ConversationTranslator_Name = 50] = "ConversationTranslator_Name", e[e.ConversationTranslator_CorrelationId = 51] = "ConversationTranslator_CorrelationId", e[e.ConversationTranslator_Token = 52] = "ConversationTranslator_Token", e[e.PronunciationAssessment_ReferenceText = 53] = "PronunciationAssessment_ReferenceText", e[e.PronunciationAssessment_GradingSystem = 54] = "PronunciationAssessment_GradingSystem", e[e.PronunciationAssessment_Granularity = 55] = "PronunciationAssessment_Granularity", e[e.PronunciationAssessment_EnableMiscue = 56] = "PronunciationAssessment_EnableMiscue", e[e.PronunciationAssessment_Json = 57] = "PronunciationAssessment_Json", e[e.PronunciationAssessment_Params = 58] = "PronunciationAssessment_Params";
  })(ke || (ke = {}));
}), Zd, g0, Bbr = Qe(() => {
  hr(), vr(), rn(), Kt(), Zd = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, g0 = class vbe {
    constructor(t, r, n) {
      this.audioConfig = t !== void 0 ? t : Xl.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = r.clone(), this.privConnectionFactory = n, this.implCommonRecognizerSetup();
    }
    close(t, r) {
      nt.throwIfDisposed(this.privDisposed), wr(this.dispose(!0), t, r);
    }
    get internalData() {
      return this.privReco;
    }
    dispose(t) {
      return Zd(this, void 0, void 0, function* () {
        this.privDisposed || (this.privDisposed = !0, t && this.privReco && (yield this.privReco.audioSource.turnOff(), yield this.privReco.dispose()));
      });
    }
    static get telemetryEnabled() {
      return ys.telemetryDataEnabled;
    }
    static enableTelemetry(t) {
      ys.telemetryDataEnabled = t;
    }
    implCommonRecognizerSetup() {
      let t = typeof window < "u" ? "Browser" : "Node", r = "unknown", n = "unknown";
      typeof navigator < "u" && (t = t + "/" + navigator.platform, r = navigator.userAgent, n = navigator.appVersion);
      let i = this.createRecognizerConfig(new ET(new t0(new e_(t, r, n))));
      this.privReco = this.createServiceRecognizer(vbe.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, i);
    }
    recognizeOnceAsyncImpl(t) {
      return Zd(this, void 0, void 0, function* () {
        nt.throwIfDisposed(this.privDisposed);
        let r = new Kn();
        yield this.implRecognizerStop(), yield this.privReco.recognize(t, r.resolve, r.reject);
        let n = yield r.promise;
        return yield this.implRecognizerStop(), n;
      });
    }
    startContinuousRecognitionAsyncImpl(t) {
      return Zd(this, void 0, void 0, function* () {
        nt.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop(), yield this.privReco.recognize(t, void 0, void 0);
      });
    }
    stopContinuousRecognitionAsyncImpl() {
      return Zd(this, void 0, void 0, function* () {
        nt.throwIfDisposed(this.privDisposed), yield this.implRecognizerStop();
      });
    }
    implRecognizerStop() {
      return Zd(this, void 0, void 0, function* () {
        this.privReco && (yield this.privReco.stopRecognizing());
      });
    }
    static getAuthFromProperties(t) {
      let r = t.getProperty(ke.SpeechServiceConnection_Key, void 0);
      return r && r !== "" ? new s$(r) : new c$((n) => {
        let i = t.getProperty(ke.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(i);
      }, (n) => {
        let i = t.getProperty(ke.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(i);
      });
    }
  };
}), Hue, Ebe, kbr = Qe(() => {
  hr(), vr(), rn(), Kt(), Hue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Ebe = class mbe extends g0 {
    constructor(t, r) {
      let n = t;
      nt.throwIfNull(n, "speechConfig"), nt.throwIfNullOrWhitespace(n.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage), ke[ke.SpeechServiceConnection_RecoLanguage]), super(r, n.properties, new lCe()), this.privDisposedRecognizer = !1;
    }
    static FromConfig(t, r, n) {
      let i = t;
      return r.properties.mergeTo(i.properties), new mbe(t, n);
    }
    get endpointId() {
      return nt.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(t) {
      nt.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, t);
    }
    get speechRecognitionLanguage() {
      return nt.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    get outputFormat() {
      return nt.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(nc, vi[vi.Simple]) === vi[vi.Simple] ? vi.Simple : vi.Detailed;
    }
    get properties() {
      return this.privProperties;
    }
    recognizeOnceAsync(t, r) {
      wr(this.recognizeOnceAsyncImpl(Qo.Interactive), t, r);
    }
    startContinuousRecognitionAsync(t, r) {
      wr(this.startContinuousRecognitionAsyncImpl(Qo.Conversation), t, r);
    }
    stopContinuousRecognitionAsync(t, r) {
      wr(this.stopContinuousRecognitionAsyncImpl(), t, r);
    }
    startKeywordRecognitionAsync(t, r, n) {
      nt.throwIfNull(t, "model"), n && n("Not yet implemented.");
    }
    stopKeywordRecognitionAsync(t, r) {
      t && t();
    }
    close(t, r) {
      nt.throwIfDisposed(this.privDisposedRecognizer), wr(this.dispose(!0), t, r);
    }
    dispose(t) {
      let r = Object.create(null, { dispose: { get: () => super.dispose } });
      return Hue(this, void 0, void 0, function* () {
        this.privDisposedRecognizer || (t && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield r.dispose.call(this, t));
      });
    }
    createRecognizerConfig(t) {
      return new Sd(t, this.properties);
    }
    createServiceRecognizer(t, r, n, i) {
      let o = n;
      return new bCe(t, r, o, i, this);
    }
  };
}), $ue, gbe, Mbr = Qe(() => {
  hr(), vr(), rn(), Kt(), $ue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, gbe = class extends g0 {
    constructor(e, t) {
      nt.throwIfNullOrUndefined(e, "speechConfig");
      let r = e;
      nt.throwIfNullOrUndefined(r, "speechConfig"), super(t, r.properties, new uCe()), this.privAddedIntents = [], this.privAddedLmIntents = {}, this.privDisposedIntentRecognizer = !1, this.privProperties = r.properties, nt.throwIfNullOrWhitespace(this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage), ke[ke.SpeechServiceConnection_RecoLanguage]);
    }
    get speechRecognitionLanguage() {
      return nt.throwIfDisposed(this.privDisposedIntentRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get properties() {
      return this.privProperties;
    }
    recognizeOnceAsync(e, t) {
      if (nt.throwIfDisposed(this.privDisposedIntentRecognizer), Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
        let r = this.buildSpeechContext();
        this.privReco.speechContext.setSection("intent", r.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(r.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
      }
      wr(this.recognizeOnceAsyncImpl(Qo.Interactive), e, t);
    }
    startContinuousRecognitionAsync(e, t) {
      if (Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
        let r = this.buildSpeechContext();
        this.privReco.speechContext.setSection("intent", r.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(r.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
      }
      wr(this.startContinuousRecognitionAsyncImpl(Qo.Conversation), e, t);
    }
    stopContinuousRecognitionAsync(e, t) {
      wr(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    startKeywordRecognitionAsync(e, t, r) {
      nt.throwIfNull(e, "model"), r && r("Not yet implemented.");
    }
    stopKeywordRecognitionAsync(e, t) {
      e && e();
    }
    addIntent(e, t) {
      nt.throwIfDisposed(this.privDisposedIntentRecognizer), nt.throwIfNullOrWhitespace(t, "intentId"), nt.throwIfNullOrWhitespace(e, "simplePhrase"), this.privAddedIntents.push([t, e]);
    }
    addIntentWithLanguageModel(e, t, r) {
      nt.throwIfDisposed(this.privDisposedIntentRecognizer), nt.throwIfNullOrWhitespace(e, "intentId"), nt.throwIfNull(t, "model");
      let n = t;
      nt.throwIfNullOrWhitespace(n.appId, "model.appId"), this.privAddedLmIntents[e] = new C8(n, r);
    }
    addAllIntents(e, t) {
      nt.throwIfNull(e, "model");
      let r = e;
      nt.throwIfNullOrWhitespace(r.appId, "model.appId"), this.privUmbrellaIntent = new C8(r, t);
    }
    close(e, t) {
      nt.throwIfDisposed(this.privDisposedIntentRecognizer), wr(this.dispose(!0), e, t);
    }
    createRecognizerConfig(e) {
      return new Sd(e, this.properties);
    }
    createServiceRecognizer(e, t, r, n) {
      let i = r;
      return new RCe(e, t, i, n, this);
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return $ue(this, void 0, void 0, function* () {
        this.privDisposedIntentRecognizer || e && (this.privDisposedIntentRecognizer = !0, yield t.dispose.call(this, e));
      });
    }
    buildSpeechContext() {
      let e, t, r, n = [];
      this.privUmbrellaIntent !== void 0 && (e = this.privUmbrellaIntent.modelImpl.appId, t = this.privUmbrellaIntent.modelImpl.region, r = this.privUmbrellaIntent.modelImpl.subscriptionKey);
      for (let i of Object.keys(this.privAddedLmIntents)) {
        let o = this.privAddedLmIntents[i];
        if (e === void 0) e = o.modelImpl.appId;
        else if (e !== o.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
        if (t === void 0) t = o.modelImpl.region;
        else if (t !== o.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
        if (r === void 0) r = o.modelImpl.subscriptionKey;
        else if (r !== o.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
        let a = "luis/" + e + "-PRODUCTION#" + i;
        n.push(a);
      }
      return { Intent: { id: e, key: r === void 0 ? this.privProperties.getProperty(ke[ke.SpeechServiceConnection_Key]) : r, provider: "LUIS" }, ReferenceGrammars: this.privUmbrellaIntent === void 0 ? n : ["luis/" + e + "-PRODUCTION"] };
    }
  };
}), Ks, Fbr = Qe(() => {
  (function(e) {
    e[e.TextIndependentIdentification = 0] = "TextIndependentIdentification", e[e.TextDependentVerification = 1] = "TextDependentVerification", e[e.TextIndependentVerification = 2] = "TextIndependentVerification";
  })(Ks || (Ks = {}));
}), b5, h$, Hbr = Qe(() => {
  hr(), vr(), rn(), Kt(), b5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, h$ = class extends g0 {
    constructor(e, t) {
      let r = e;
      nt.throwIfNull(r, "speechConfig"), super(t, r.properties, new dCe()), this.privDisposedTranslationRecognizer = !1, this.privProperties = r.properties.clone(), this.properties.getProperty(ke.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && nt.throwIfNullOrWhitespace(this.properties.getProperty(ke.SpeechServiceConnection_TranslationVoice), ke[ke.SpeechServiceConnection_TranslationVoice]), nt.throwIfNullOrWhitespace(this.properties.getProperty(ke.SpeechServiceConnection_TranslationToLanguages), ke[ke.SpeechServiceConnection_TranslationToLanguages]), nt.throwIfNullOrWhitespace(this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage), ke[ke.SpeechServiceConnection_RecoLanguage]);
    }
    get speechRecognitionLanguage() {
      return nt.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    get targetLanguages() {
      return nt.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    get voiceName() {
      return nt.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_TranslationVoice, void 0);
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get properties() {
      return this.privProperties;
    }
    recognizeOnceAsync(e, t) {
      nt.throwIfDisposed(this.privDisposedTranslationRecognizer), wr(this.recognizeOnceAsyncImpl(Qo.Conversation), e, t);
    }
    startContinuousRecognitionAsync(e, t) {
      wr(this.startContinuousRecognitionAsyncImpl(Qo.Conversation), e, t);
    }
    stopContinuousRecognitionAsync(e, t) {
      wr(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    close(e, t) {
      nt.throwIfDisposed(this.privDisposedTranslationRecognizer), wr(this.dispose(!0), e, t);
    }
    onConnection() {
    }
    onDisconnection() {
      return b5(this, void 0, void 0, function* () {
      });
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return b5(this, void 0, void 0, function* () {
        this.privDisposedTranslationRecognizer || (this.privDisposedTranslationRecognizer = !0, e && (yield this.implRecognizerStop(), yield t.dispose.call(this, e)));
      });
    }
    createRecognizerConfig(e) {
      return new Sd(e, this.properties);
    }
    createServiceRecognizer(e, t, r, n) {
      let i = r;
      return new TCe(e, t, i, n, this);
    }
  };
}), p2, $br = Qe(() => {
  Kt(), p2 = class {
    constructor() {
      this.privMap = new zn();
    }
    get(e, t) {
      return this.privMap.getProperty(e, t);
    }
    set(e, t) {
      this.privMap.setProperty(e, t);
    }
  };
}), _f, Ubr = Qe(() => {
  (function(e) {
    e[e.NotRecognized = 0] = "NotRecognized", e[e.InitialSilenceTimeout = 1] = "InitialSilenceTimeout", e[e.InitialBabbleTimeout = 2] = "InitialBabbleTimeout";
  })(_f || (_f = {}));
}), Tbe, Vbr = Qe(() => {
  hr(), Kt(), Tbe = class ybe {
    constructor(t) {
      this.privReason = t;
    }
    static fromResult(t) {
      let r = Cd.fromJSON(t.json), n = _f.NotRecognized;
      switch (r.RecognitionStatus) {
        case Ln.BabbleTimeout:
          n = _f.InitialBabbleTimeout;
          break;
        case Ln.InitialSilenceTimeout:
          n = _f.InitialSilenceTimeout;
          break;
        default:
          n = _f.NotRecognized;
          break;
      }
      return new ybe(n);
    }
    get reason() {
      return this.privReason;
    }
  };
}), _b, jbr = Qe(() => {
  _b = class {
    constructor(e, t, r, n, i) {
      this.privCancelReason = t, this.privErrorDetails = r, this.privResult = i, this.privSessionId = e, this.privErrorCode = n;
    }
    get result() {
      return this.privResult;
    }
    get sessionId() {
      return this.privSessionId;
    }
    get reason() {
      return this.privCancelReason;
    }
    get errorCode() {
      return this.privErrorCode;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
}), v$, zbr = Qe(() => {
  Kt(), v$ = class extends yf {
    constructor(e, t, r, n, i, o) {
      super(n, i, o), this.privReason = e, this.privErrorDetails = t, this.privErrorCode = r;
    }
    get reason() {
      return this.privReason;
    }
    get errorCode() {
      return this.privErrorCode;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
}), nv, _be = Qe(() => {
  nv = class {
    constructor(e, t, r) {
      this.privReason = e, this.privErrorDetails = t, this.privErrorCode = r;
    }
    get reason() {
      return this.privReason;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    get ErrorCode() {
      return this.privErrorCode;
    }
  };
}), Abe, qbr = Qe(() => {
  hr(), _be(), Kt(), Abe = class Sbe extends nv {
    constructor(t, r, n) {
      super(t, r, n);
    }
    static fromResult(t) {
      let r = oi.Error, n = dr.NoError;
      if (t instanceof l2 && t.json) {
        let i = Cd.fromJSON(t.json);
        r = au.implTranslateCancelResult(i.RecognitionStatus);
      }
      return t.properties && (n = dr[t.properties.getProperty(Fa, dr[dr.NoError])]), new Sbe(r, t.errorDetails, n);
    }
  };
}), dr, Ybr = Qe(() => {
  (function(e) {
    e[e.NoError = 0] = "NoError", e[e.AuthenticationFailure = 1] = "AuthenticationFailure", e[e.BadRequestParameters = 2] = "BadRequestParameters", e[e.TooManyRequests = 3] = "TooManyRequests", e[e.ConnectionFailure = 4] = "ConnectionFailure", e[e.ServiceTimeout = 5] = "ServiceTimeout", e[e.ServiceError = 6] = "ServiceError", e[e.RuntimeError = 7] = "RuntimeError";
  })(dr || (dr = {}));
}), Ab, Gbr = Qe(() => {
  Kt(), Ab = class extends $o {
  };
}), E$, Wbr = Qe(() => {
  Kt(), E$ = class extends $o {
    constructor(e, t, r) {
      super(r), this.privJsonResult = e, this.privEventName = t;
    }
    get jsonString() {
      return this.privJsonResult;
    }
    get eventName() {
      return this.privEventName;
    }
  };
}), bbe, E8, Cbe = Qe(() => {
  Tc(), vr(), pbe(), p$(), bbe = class {
  }, E8 = class {
    constructor(e) {
      this.privConnectionMessage = e, this.privProperties = new zn(), this.privConnectionMessage.headers[wn.ConnectionId] && this.privProperties.setProperty(ke.Speech_SessionId, this.privConnectionMessage.headers[wn.ConnectionId]), Object.keys(this.privConnectionMessage.headers).forEach((t, r, n) => {
        this.privProperties.setProperty(t, this.privConnectionMessage.headers[t]);
      });
    }
    get path() {
      return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((e) => e.toLowerCase() === "path".toLowerCase())];
    }
    get isTextMessage() {
      return this.privConnectionMessage.messageType === br.Text;
    }
    get isBinaryMessage() {
      return this.privConnectionMessage.messageType === br.Binary;
    }
    get TextMessage() {
      return this.privConnectionMessage.textBody;
    }
    get binaryMessage() {
      return this.privConnectionMessage.binaryBody;
    }
    get properties() {
      return this.privProperties;
    }
    toString() {
      return "";
    }
  };
}), m$, Kbr = Qe(() => {
  hr(), vr(), Cbe(), rn(), Kt(), m$ = class m8 {
    static fromRecognizer(t) {
      let r = t.internalData, n = new m8();
      return n.privInternalData = r, n.setupEvents(), n;
    }
    static fromSynthesizer(t) {
      let r = t.internalData, n = new m8();
      return n.privInternalData = r, n.setupEvents(), n;
    }
    openConnection(t, r) {
      wr(this.privInternalData.connect(), t, r);
    }
    closeConnection(t, r) {
      if (this.privInternalData instanceof zf) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
      wr(this.privInternalData.disconnect(), t, r);
    }
    setMessageProperty(t, r, n) {
      if (nt.throwIfNullOrWhitespace(r, "propertyName"), this.privInternalData instanceof ys) {
        if (t.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
        this.privInternalData.speechContext.setSection(r, n);
      } else if (this.privInternalData instanceof zf) {
        if (t.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
        this.privInternalData.synthesisContext.setSection(r, n);
      }
    }
    sendMessageAsync(t, r, n, i) {
      wr(this.privInternalData.sendNetworkMessage(t, r), n, i);
    }
    close() {
    }
    setupEvents() {
      this.privEventListener = this.privInternalData.connectionEvents.attach((t) => {
        t.name === "ConnectionEstablishedEvent" ? this.connected && this.connected(new Ab(t.connectionId)) : t.name === "ConnectionClosedEvent" ? this.disconnected && this.disconnected(new Ab(t.connectionId)) : t.name === "ConnectionMessageSentEvent" ? this.messageSent && this.messageSent(new Sb(new E8(t.message))) : t.name === "ConnectionMessageReceivedEvent" && this.messageReceived && this.messageReceived(new Sb(new E8(t.message)));
      }), this.privServiceEventListener = this.privInternalData.serviceEvents.attach((t) => {
        this.receivedServiceMessage && this.receivedServiceMessage(new E$(t.jsonString, t.name));
      });
    }
  };
}), Ibe, Xbr = Qe(() => {
  Ibe = class Obe {
    constructor(t) {
      this.privGrammerBuilder = t.dynamicGrammar;
    }
    static fromRecognizer(t) {
      let r = t.internalData;
      return new Obe(r);
    }
    addPhrase(t) {
      this.privGrammerBuilder.addPhrase(t);
    }
    addPhrases(t) {
      this.privGrammerBuilder.addPhrase(t);
    }
    clear() {
      this.privGrammerBuilder.clearPhrases();
    }
  };
}), i4, ma, $c, g$ = Qe(() => {
  rn(), Kt(), ma = class {
    constructor() {
    }
    set applicationId(e) {
    }
  }, ma.DialogTypes = (i4 = class {
  }, i4.BotFramework = "bot_framework", i4.CustomCommands = "custom_commands", i4), $c = class extends ma {
    constructor() {
      super(), this.privSpeechConfig = new ff();
    }
    get properties() {
      return this.privSpeechConfig.properties;
    }
    get speechRecognitionLanguage() {
      return this.privSpeechConfig.speechRecognitionLanguage;
    }
    set speechRecognitionLanguage(e) {
      nt.throwIfNullOrWhitespace(e, "value"), this.privSpeechConfig.speechRecognitionLanguage = e;
    }
    get outputFormat() {
      return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(e) {
      this.privSpeechConfig.outputFormat = e;
    }
    setProperty(e, t) {
      this.privSpeechConfig.setProperty(e, t);
    }
    getProperty(e, t) {
      return this.privSpeechConfig.getProperty(e);
    }
    setProxy(e, t, r, n) {
      this.setProperty(ke.SpeechServiceConnection_ProxyHostName, e), this.setProperty(ke.SpeechServiceConnection_ProxyPort, `${t}`), r && this.setProperty(ke.SpeechServiceConnection_ProxyUserName, r), n && this.setProperty(ke.SpeechServiceConnection_ProxyPassword, n);
    }
    setServiceProperty(e, t, r) {
      this.privSpeechConfig.setServiceProperty(e, t, r);
    }
    close() {
    }
  };
}), Rbe, Jbr = Qe(() => {
  rn(), g$(), Kt(), Rbe = class extends $c {
    constructor() {
      super();
    }
    static fromSubscription(e, t, r) {
      nt.throwIfNullOrWhitespace(e, "subscription"), nt.throwIfNullOrWhitespace(t, "region");
      let n = new $c();
      return n.setProperty(ke.Conversation_DialogType, ma.DialogTypes.BotFramework), n.setProperty(ke.SpeechServiceConnection_Key, e), n.setProperty(ke.SpeechServiceConnection_Region, t), r && n.setProperty(ke.Conversation_ApplicationId, r), n;
    }
    static fromAuthorizationToken(e, t, r) {
      nt.throwIfNullOrWhitespace(e, "authorizationToken"), nt.throwIfNullOrWhitespace(t, "region");
      let n = new $c();
      return n.setProperty(ke.Conversation_DialogType, ma.DialogTypes.BotFramework), n.setProperty(ke.SpeechServiceAuthorization_Token, e), n.setProperty(ke.SpeechServiceConnection_Region, t), r && n.setProperty(ke.Conversation_ApplicationId, r), n;
    }
    static fromHost(e, t, r) {
      nt.throwIfNullOrUndefined(e, "host");
      let n = e instanceof URL ? e : new URL(`wss://${e}.convai.speech.azure.us`);
      nt.throwIfNullOrUndefined(n, "resolvedHost");
      let i = new $c();
      return i.setProperty(ke.Conversation_DialogType, ma.DialogTypes.BotFramework), i.setProperty(ke.SpeechServiceConnection_Host, n.toString()), t !== void 0 && i.setProperty(ke.SpeechServiceConnection_Key, t), i;
    }
    static fromEndpoint(e, t) {
      nt.throwIfNull(e, "endpoint");
      let r = new $c();
      return r.setProperty(ke.Conversation_DialogType, ma.DialogTypes.BotFramework), r.setProperty(ke.SpeechServiceConnection_Endpoint, e.toString()), t !== void 0 && r.setProperty(ke.SpeechServiceConnection_Key, t), r;
    }
  };
}), wbe, Zbr = Qe(() => {
  rn(), g$(), Kt(), wbe = class extends $c {
    constructor() {
      super();
    }
    static fromSubscription(e, t, r) {
      nt.throwIfNullOrWhitespace(e, "applicationId"), nt.throwIfNullOrWhitespace(t, "subscription"), nt.throwIfNullOrWhitespace(r, "region");
      let n = new $c();
      return n.setProperty(ke.Conversation_DialogType, ma.DialogTypes.CustomCommands), n.setProperty(ke.Conversation_ApplicationId, e), n.setProperty(ke.SpeechServiceConnection_Key, t), n.setProperty(ke.SpeechServiceConnection_Region, r), n;
    }
    static fromAuthorizationToken(e, t, r) {
      nt.throwIfNullOrWhitespace(e, "applicationId"), nt.throwIfNullOrWhitespace(t, "authorizationToken"), nt.throwIfNullOrWhitespace(r, "region");
      let n = new $c();
      return n.setProperty(ke.Conversation_DialogType, ma.DialogTypes.CustomCommands), n.setProperty(ke.Conversation_ApplicationId, e), n.setProperty(ke.SpeechServiceAuthorization_Token, t), n.setProperty(ke.SpeechServiceConnection_Region, r), n;
    }
    set applicationId(e) {
      nt.throwIfNullOrWhitespace(e, "value"), this.setProperty(ke.Conversation_ApplicationId, e);
    }
    get applicationId() {
      return this.getProperty(ke.Conversation_ApplicationId);
    }
  };
}), jr, iv = Qe(() => {
  jr = class {
  }, jr.BotId = "botid", jr.CustomSpeechDeploymentId = "cid", jr.CustomVoiceDeploymentId = "deploymentId", jr.EnableAudioLogging = "storeAudio", jr.EnableLanguageId = "lidEnabled", jr.EnableWordLevelTimestamps = "wordLevelTimestamps", jr.EndSilenceTimeoutMs = "endSilenceTimeoutMs", jr.Format = "format", jr.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs", jr.Language = "language", jr.Profanity = "profanity", jr.RequestBotStatusMessages = "enableBotMessageStatus", jr.StableIntermediateThreshold = "stableIntermediateThreshold", jr.StableTranslation = "stableTranslation", jr.TestHooks = "testhooks";
}), Ad, ov = Qe(() => {
  hr(), Kt(), iv(), Ad = class {
    setCommonUrlParams(e, t, r) {
      this.setUrlParameter(ke.SpeechServiceConnection_EnableAudioLogging, jr.EnableAudioLogging, e, t, r), this.setUrlParameter(ke.SpeechServiceResponse_RequestWordLevelTimestamps, jr.EnableWordLevelTimestamps, e, t, r), this.setUrlParameter(ke.SpeechServiceResponse_ProfanityOption, jr.Profanity, e, t, r), this.setUrlParameter(ke.SpeechServiceConnection_InitialSilenceTimeoutMs, jr.InitialSilenceTimeoutMs, e, t, r), this.setUrlParameter(ke.SpeechServiceConnection_EndSilenceTimeoutMs, jr.EndSilenceTimeoutMs, e, t, r), this.setUrlParameter(ke.SpeechServiceResponse_StablePartialResultThreshold, jr.StableIntermediateThreshold, e, t, r);
      let n = JSON.parse(e.parameters.getProperty(ch, "{}"));
      Object.keys(n).forEach((i, o, a) => {
        t[i] = n[i];
      });
    }
    setUrlParameter(e, t, r, n, i) {
      let o = r.parameters.getProperty(e, void 0);
      o && (!i || i.search(t) === -1) && (n[t] = o.toLocaleLowerCase());
    }
  };
}), o4, g8, Qbr = Qe(() => {
  hu(), hr(), Kt(), ov(), hr(), Tc(), iv(), g8 = class T8 extends Ad {
    constructor() {
      super(...arguments), this.create = (t, r, n) => {
        let i = t.parameters.getProperty(ke.Conversation_ApplicationId, ""), o = t.parameters.getProperty(ke.Conversation_DialogType), a = t.parameters.getProperty(ke.SpeechServiceConnection_Region), u = t.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage, "en-US"), s = t.parameters.getProperty(ke.Conversation_Request_Bot_Status_Messages, "true"), c = {};
        c[wn.ConnectionId] = n, c[jr.Format] = t.parameters.getProperty(nc, vi[vi.Simple]).toLowerCase(), c[jr.Language] = u, c[jr.RequestBotStatusMessages] = s, i && (c[jr.BotId] = i, o === ma.DialogTypes.CustomCommands && (c[wn.CustomCommandsAppId] = i));
        let l = o === ma.DialogTypes.CustomCommands ? "commands/" : "", f = o === ma.DialogTypes.CustomCommands ? "v1" : o === ma.DialogTypes.BotFramework ? "v3" : "v0", d = {};
        r.token != null && r.token !== "" && (d[r.headerName] = r.token);
        let p = t.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, "");
        if (!p) {
          let h = a && a.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", E = t.parameters.getProperty(ke.SpeechServiceConnection_Host, `wss://${a}.${T8.Constants.BaseUrl}${h}`);
          p = `${E.endsWith("/") ? E : E + "/"}${l}${T8.Constants.ApiKey}/${f}`;
        }
        this.setCommonUrlParams(t, c, p);
        let v = t.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(p, c, d, new bd(), y0.fromRecognizerConfig(t), v, n);
      };
    }
  }, g8.Constants = (o4 = class {
  }, o4.ApiKey = "api", o4.BaseUrl = "convai.speech", o4);
}), C5, Pbe, eCr = Qe(() => {
  Qbr(), hr(), vr(), rn(), Kt(), p$(), C5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Pbe = class extends g0 {
    constructor(e, t) {
      let r = e;
      nt.throwIfNull(e, "dialogConfig"), super(t, r.properties, new g8()), this.isTurnComplete = !0, this.privIsDisposed = !1, this.privProperties = r.properties.clone();
      let n = this.buildAgentConfig();
      this.privReco.agentConfig.set(n);
    }
    connect(e, t) {
      wr(this.privReco.connect(), e, t);
    }
    disconnect(e, t) {
      wr(this.privReco.disconnect(), e, t);
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get properties() {
      return this.privProperties;
    }
    get speechActivityTemplate() {
      return this.properties.getProperty(ke.Conversation_Speech_Activity_Template);
    }
    set speechActivityTemplate(e) {
      this.properties.setProperty(ke.Conversation_Speech_Activity_Template, e);
    }
    listenOnceAsync(e, t) {
      if (this.isTurnComplete) {
        nt.throwIfDisposed(this.privIsDisposed);
        let r = C5(this, void 0, void 0, function* () {
          yield this.privReco.connect(), yield this.implRecognizerStop(), this.isTurnComplete = !1;
          let n = new Kn();
          yield this.privReco.recognize(Qo.Conversation, n.resolve, n.reject);
          let i = yield n.promise;
          return yield this.implRecognizerStop(), i;
        });
        r.catch(() => {
          this.dispose(!0).catch(() => {
          });
        }), wr(r.finally(() => {
          this.isTurnComplete = !0;
        }), e, t);
      }
    }
    sendActivityAsync(e, t, r) {
      wr(this.privReco.sendMessage(e), t, r);
    }
    close(e, t) {
      nt.throwIfDisposed(this.privIsDisposed), wr(this.dispose(!0), e, t);
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return C5(this, void 0, void 0, function* () {
        this.privIsDisposed || e && (this.privIsDisposed = !0, yield this.implRecognizerStop(), yield t.dispose.call(this, e));
      });
    }
    createRecognizerConfig(e) {
      return new Sd(e, this.privProperties);
    }
    createServiceRecognizer(e, t, r, n) {
      let i = r;
      return new $Ce(e, t, i, n, this);
    }
    buildAgentConfig() {
      return { botInfo: { commType: this.properties.getProperty("Conversation_Communication_Type", "Default"), commandsCulture: void 0, connectionId: this.properties.getProperty(ke.Conversation_Agent_Connection_Id), conversationId: this.properties.getProperty(ke.Conversation_Conversation_Id, void 0), fromId: this.properties.getProperty(ke.Conversation_From_Id, void 0), ttsAudioFormat: this.properties.getProperty(ke.SpeechServiceConnection_SynthOutputFormat, void 0) }, version: 0.2 };
    }
  };
}), T$, tCr = Qe(() => {
  T$ = class {
    constructor(e, t) {
      this.privActivity = e, this.privAudioStream = t;
    }
    get activity() {
      return this.privActivity;
    }
    get audioStream() {
      return this.privAudioStream;
    }
  };
}), Dbe, rCr = Qe(() => {
  Dbe = class xbe {
    constructor(t) {
      this.privMessageStatusResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new xbe(t);
    }
    get interactionId() {
      return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
      return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
      switch (this.privMessageStatusResponse.statusCode) {
        case "Success":
          return 200;
        case "Failed":
          return 400;
        case "TimedOut":
          return 429;
        default:
          return this.privMessageStatusResponse.statusCode;
      }
    }
  };
}), y$, nCr = Qe(() => {
  rCr(), y$ = class {
    constructor(e) {
      this.privTurnStatus = Dbe.fromJSON(e);
    }
    get interactionId() {
      return this.privTurnStatus.interactionId;
    }
    get conversationId() {
      return this.privTurnStatus.conversationId;
    }
    get statusCode() {
      return this.privTurnStatus.statusCode;
    }
  };
}), y8, iCr = Qe(() => {
  (function(e) {
    e[e.UriQueryParameter = 0] = "UriQueryParameter";
  })(y8 || (y8 = {}));
}), jf, oCr = Qe(() => {
  (function(e) {
    e[e.Masked = 0] = "Masked", e[e.Removed = 1] = "Removed", e[e.Raw = 2] = "Raw";
  })(jf || (jf = {}));
}), I5, Nbe, aCr = Qe(() => {
  gc(), i$(), Kt(), m0(), I5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Nbe = class {
    constructor(e) {
      this.audioContext = null, this.gainNode = null, this.autoUpdateBufferTimer = 0, e === void 0 && (e = Vf.getDefaultInputFormat()), this.init(e);
    }
    playAudioSample(e, t, r) {
      wr(I5(this, void 0, void 0, function* () {
        this.ensureInitializedContext();
        let n = this.formatAudioData(e), i = new Float32Array(this.samples.length + n.length);
        i.set(this.samples, 0), i.set(n, this.samples.length), this.samples = i;
      }), t, r);
    }
    stopAudio(e, t) {
      this.audioContext !== null && (this.samples = new Float32Array(), clearInterval(this.autoUpdateBufferTimer), this.audioContext.close().then(() => {
        e && e();
      }, (r) => {
        t && t(r);
      }), this.audioContext = null);
    }
    init(e) {
      this.audioFormat = e, this.samples = new Float32Array();
    }
    ensureInitializedContext() {
      if (this.audioContext === null) {
        this.createAudioContext();
        let e = 200;
        this.autoUpdateBufferTimer = setInterval(() => {
          this.updateAudioBuffer();
        }, e);
      }
    }
    createAudioContext() {
      this.audioContext = Kl.getAudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = 1, this.gainNode.connect(this.audioContext.destination), this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(e) {
      switch (this.audioFormat.bitsPerSample) {
        case 8:
          return this.formatArrayBuffer(new Int8Array(e), 128);
        case 16:
          return this.formatArrayBuffer(new Int16Array(e), 32768);
        case 32:
          return this.formatArrayBuffer(new Int32Array(e), 2147483648);
        default:
          throw new ta("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
      }
    }
    formatArrayBuffer(e, t) {
      let r = new Float32Array(e.length);
      for (let n = 0; n < e.length; n++) r[n] = e[n] / t;
      return r;
    }
    updateAudioBuffer() {
      if (this.samples.length === 0) return;
      let e = this.audioFormat.channels, t = this.audioContext.createBufferSource(), r = this.samples.length / e, n = this.audioContext.createBuffer(e, r, this.audioFormat.samplesPerSec);
      for (let i = 0; i < e; i++) {
        let o = i, a = n.getChannelData(i);
        for (let u = 0; u < this.samples.length; u++, o += e) a[u] = this.samples[o];
      }
      this.startTime < this.audioContext.currentTime && (this.startTime = this.audioContext.currentTime), t.buffer = n, t.connect(this.gainNode), t.start(this.startTime), this.startTime += n.duration, this.samples = new Float32Array();
    }
    playAudio(e) {
      return I5(this, void 0, void 0, function* () {
        this.audioContext === null && this.createAudioContext();
        let t = this.audioContext.createBufferSource(), r = this.audioContext.destination;
        yield this.audioContext.decodeAudioData(e, (n) => {
          t.buffer = n, t.connect(r), t.start(0);
        });
      });
    }
  };
}), Sb, uCr = Qe(() => {
  Sb = class {
    constructor(e) {
      this.privConnectionMessage = e;
    }
    get message() {
      return this.privConnectionMessage;
    }
    toString() {
      return "Message: " + this.privConnectionMessage.toString();
    }
  };
}), _$, sCr = Qe(() => {
  _$ = class {
    constructor(e, t) {
      this.privId = e, this.privProfileType = t;
    }
    get profileId() {
      return this.privId;
    }
    get profileType() {
      return this.privProfileType;
    }
  };
}), Ep, Lbe, cCr = Qe(() => {
  hr(), Kt(), Ep = class _8 {
    constructor(t, r, n) {
      this.privReason = t, this.privProperties = new zn(), this.privReason !== or.Canceled ? r && (this.privDetails = JSON.parse(r), this.privDetails.enrollmentStatus.toLowerCase() === "enrolling" && (this.privReason = or.EnrollingVoiceProfile)) : (this.privErrorDetails = n, this.privProperties.setProperty(Fa, dr[dr.ServiceError]));
    }
    static FromIdentificationProfileList(t) {
      let r = [];
      for (let n of t.profiles) {
        let i = n.enrollmentStatus.toLowerCase() === "enrolling" ? or.EnrollingVoiceProfile : n.enrollmentStatus.toLowerCase() === "enrolled" ? or.EnrolledVoiceProfile : or.Canceled, o = new _8(i, null, null);
        o.privDetails = this.getIdentificationDetails(n), r.push(o);
      }
      return r;
    }
    static FromVerificationProfileList(t) {
      let r = [];
      for (let n of t.profiles) {
        let i = n.enrollmentStatus.toLowerCase() === "enrolling" ? or.EnrollingVoiceProfile : n.enrollmentStatus.toLowerCase() === "enrolled" ? or.EnrolledVoiceProfile : or.Canceled, o = new _8(i, null, null);
        o.privDetails = this.getVerificationDetails(n), r.push(o);
      }
      return r;
    }
    get reason() {
      return this.privReason;
    }
    get enrollmentsCount() {
      return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
      return this.privDetails.enrollmentsLength;
    }
    get properties() {
      return this.privProperties;
    }
    get enrollmentResultDetails() {
      return this.privDetails;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    static getIdentificationDetails(t) {
      return { audioSpeechLength: t.speechTime ? parseFloat(t.speechTime) : 0, enrollmentStatus: t.enrollmentStatus, enrollmentsLength: t.enrollmentSpeechTime ? parseFloat(t.enrollmentSpeechTime) : 0, profileId: t.profileId || t.identificationProfileId, remainingEnrollmentSpeechLength: t.remainingEnrollmentSpeechTime ? parseFloat(t.remainingEnrollmentSpeechTime) : 0 };
    }
    static getVerificationDetails(t) {
      return { enrollmentStatus: t.enrollmentStatus, enrollmentsCount: t.enrollmentsCount, profileId: t.profileId || t.verificationProfileId, remainingEnrollmentSpeechLength: t.remainingEnrollmentSpeechLength ? parseFloat(t.remainingEnrollmentSpeechLength) : 0, remainingEnrollmentsCount: t.remainingEnrollments || t.remainingEnrollmentsCount };
    }
  }, Lbe = class Bbe extends nv {
    constructor(t, r, n) {
      super(t, r, n);
    }
    static fromResult(t) {
      let r = oi.Error, n = dr.NoError;
      return t.properties && (n = dr[t.properties.getProperty(Fa, dr[dr.NoError])]), new Bbe(r, t.errorDetails, n);
    }
  };
}), h2, kbe, lCr = Qe(() => {
  hr(), rn(), Kt(), h2 = class {
    constructor(e, t) {
      this.privReason = e, this.privProperties = new zn(), e === or.Canceled && (nt.throwIfNullOrUndefined(t, "statusText"), this.privErrorDetails = t, this.privProperties.setProperty(Fa, dr[dr.ServiceError]));
    }
    get reason() {
      return this.privReason;
    }
    get properties() {
      return this.privProperties;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
  }, kbe = class Mbe extends nv {
    constructor(t, r, n) {
      super(t, r, n);
    }
    static fromResult(t) {
      let r = oi.Error, n = dr.NoError;
      return t.properties && (n = dr[t.properties.getProperty(Fa, dr[dr.NoError])]), new Mbe(r, t.errorDetails, n);
    }
  };
}), A$, fCr = Qe(() => {
  rn(), Kt(), A$ = class extends h2 {
    constructor(e, t, r) {
      super(e, t), this.privPhrases = [], nt.throwIfNullOrUndefined(r, "phrases array");
      for (let n of r) this.privPhrases.push(n.passPhrase);
    }
    get phrases() {
      return this.privPhrases;
    }
  };
}), xl, Fbe, dCr = Qe(() => {
  hr(), vr(), rn(), Kt(), xl = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Fbe = class {
    constructor(e) {
      let t = e;
      nt.throwIfNull(t, "speechConfig"), this.privProperties = t.properties.clone(), this.implClientSetup();
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get properties() {
      return this.privProperties;
    }
    createProfileAsync(e, t, r, n) {
      wr(xl(this, void 0, void 0, function* () {
        let i = (yield this.privAdapter.createProfile(e, t)).json();
        return new _$(i.profileId, e);
      }), r, n);
    }
    retrieveEnrollmentResultAsync(e, t, r) {
      wr(xl(this, void 0, void 0, function* () {
        let n = yield this.privAdapter.getProfileStatus(e);
        return new Ep(n.ok ? or.EnrolledVoiceProfile : or.Canceled, n.data, n.statusText);
      }), t, r);
    }
    getAllProfilesAsync(e, t, r) {
      wr(xl(this, void 0, void 0, function* () {
        let n = yield this.privAdapter.getProfiles(e);
        return e === Ks.TextIndependentIdentification ? Ep.FromIdentificationProfileList(n.json()) : Ep.FromVerificationProfileList(n.json());
      }), t, r);
    }
    getAuthorizationPhrasesAsync(e, t, r) {
      wr(xl(this, void 0, void 0, function* () {
        let n = yield this.privAdapter.getAuthorizationPhrases(e);
        return new A$(n.ok ? or.EnrollingVoiceProfile : or.Canceled, n.statusText, n.json());
      }), t, r);
    }
    enrollProfileAsync(e, t, r, n) {
      let i = t;
      nt.throwIfNullOrUndefined(i, "audioConfig"), wr(xl(this, void 0, void 0, function* () {
        let o = yield this.privAdapter.createEnrollment(e, i);
        return new Ep(o.ok ? or.EnrolledVoiceProfile : or.Canceled, o.data, o.statusText);
      }), r, n);
    }
    deleteProfileAsync(e, t, r) {
      wr(xl(this, void 0, void 0, function* () {
        let n = yield this.privAdapter.deleteProfile(e);
        return this.getResult(n, or.DeletedVoiceProfile);
      }), t, r);
    }
    resetProfileAsync(e, t, r) {
      wr(xl(this, void 0, void 0, function* () {
        let n = yield this.privAdapter.resetProfile(e);
        return this.getResult(n, or.ResetVoiceProfile);
      }), t, r);
    }
    close() {
    }
    implClientSetup() {
      let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", r = "unknown";
      typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, r = navigator.appVersion);
      let n = new H$(new t0(new e_(e, t, r)), this.privProperties);
      this.privAdapter = new $$(n);
    }
    getResult(e, t, r) {
      return new h2(e.ok ? t : or.Canceled, e.statusText);
    }
  };
}), Uue, Hbe, pCr = Qe(() => {
  hr(), vr(), rn(), Kt(), Uue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Hbe = class {
    constructor(e, t) {
      let r = e;
      nt.throwIfNull(r, "speechConfig"), this.privAudioConfigImpl = t, nt.throwIfNull(this.privAudioConfigImpl, "audioConfig"), this.privProperties = r.properties.clone(), this.implSRSetup();
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get properties() {
      return this.privProperties;
    }
    recognizeOnceAsync(e, t, r) {
      if (e instanceof S$) {
        let n = this.privAdapter.identifySpeaker(e, this.privAudioConfigImpl);
        wr(this.getResult(n, xp.Identify, void 0), t, r);
      } else if (e instanceof b$) {
        let n = this.privAdapter.verifySpeaker(e, this.privAudioConfigImpl);
        wr(this.getResult(n, xp.Verify, e.voiceProfile.profileId), t, r);
      } else throw new Error("SpeakerRecognizer.recognizeOnce: Unexpected model type");
    }
    close() {
    }
    implSRSetup() {
      let e = typeof window < "u" ? "Browser" : "Node", t = "unknown", r = "unknown";
      typeof navigator < "u" && (e = e + "/" + navigator.platform, t = navigator.userAgent, r = navigator.appVersion);
      let n = new H$(new t0(new e_(e, t, r)), this.privProperties);
      this.privAdapter = new $$(n);
    }
    getResult(e, t, r) {
      return Uue(this, void 0, void 0, function* () {
        let n = yield e;
        return new C$(t, n.data, r, n.ok ? or.RecognizedSpeaker : or.Canceled);
      });
    }
  };
}), S$, hCr = Qe(() => {
  rn(), Kt(), S$ = class $be {
    constructor(t) {
      if (this.privVoiceProfiles = [], nt.throwIfNullOrUndefined(t, "VoiceProfiles"), t.length === 0) throw new Error("Empty Voice Profiles array");
      t.forEach((r) => {
        if (r.profileType !== Ks.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + r.profileId);
        this.privVoiceProfiles.push(r);
      });
    }
    static fromProfiles(t) {
      return new $be(t);
    }
    get voiceProfileIds() {
      return this.privVoiceProfiles.map((t) => t.profileId).join(",");
    }
  };
}), b$, vCr = Qe(() => {
  rn(), Kt(), b$ = class Ube {
    constructor(t) {
      if (nt.throwIfNullOrUndefined(t, "VoiceProfile"), t.profileType === Ks.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
      this.privVoiceProfile = t;
    }
    static fromProfile(t) {
      return new Ube(t);
    }
    get voiceProfile() {
      return this.privVoiceProfile;
    }
  };
}), Vbe, ECr = Qe(() => {
  hr(), rn(), Kt(), Vbe = class iS {
    constructor() {
      this.privProperties = new zn();
    }
    static fromOpenRange() {
      let t = new iS();
      return t.properties.setProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages, U$), t;
    }
    static fromLanguages(t) {
      nt.throwIfArrayEmptyOrWhitespace(t, "languages");
      let r = new iS();
      return r.properties.setProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages, t.join()), r;
    }
    static fromSourceLanguageConfigs(t) {
      if (t.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
      let r = new iS(), n = [];
      return t.forEach((i) => {
        if (n.push(i.language), i.endpointId !== void 0 && i.endpointId !== "") {
          let o = i.language + ke.SpeechServiceConnection_EndpointId.toString();
          r.properties.setProperty(o, i.endpointId);
        }
      }), r.properties.setProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages, n.join()), r;
    }
    get properties() {
      return this.privProperties;
    }
  };
}), jbe, mCr = Qe(() => {
  rn(), jbe = class zbe {
    constructor(t, r) {
      nt.throwIfNullOrUndefined(t, "language"), nt.throwIfNullOrUndefined(r, "languageDetectionConfidence"), this.privLanguage = t, this.privLanguageDetectionConfidence = r;
    }
    static fromResult(t) {
      return new zbe(t.language, t.languageDetectionConfidence);
    }
    get language() {
      return this.privLanguage;
    }
    get languageDetectionConfidence() {
      return this.privLanguageDetectionConfidence;
    }
  };
}), qbe, gCr = Qe(() => {
  rn(), qbe = class Ybe {
    constructor(t, r) {
      nt.throwIfNullOrUndefined(t, "language"), this.privLanguage = t, this.privEndpointId = r;
    }
    static fromLanguage(t, r) {
      return new Ybe(t, r);
    }
    get language() {
      return this.privLanguage;
    }
    get endpointId() {
      return this.privEndpointId;
    }
  };
}), xp, C$, Gbe, TCr = Qe(() => {
  hr(), rn(), Kt(), function(e) {
    e[e.Verify = 0] = "Verify", e[e.Identify = 1] = "Identify";
  }(xp || (xp = {})), C$ = class {
    constructor(e, t, r, n = or.RecognizedSpeaker) {
      if (this.privProperties = new zn(), this.privReason = n, this.privReason !== or.Canceled) if (e === xp.Identify) {
        let i = JSON.parse(t);
        nt.throwIfNullOrUndefined(i, "JSON"), this.privProfileId = i.identifiedProfile.profileId, this.privScore = i.identifiedProfile.score;
      } else {
        let i = JSON.parse(t);
        nt.throwIfNullOrUndefined(i, "JSON"), this.privScore = i.score, i.recognitionResult.toLowerCase() !== "accept" && (this.privReason = or.NoMatch), r !== void 0 && r !== "" && (this.privProfileId = r);
      }
      else {
        let i = JSON.parse(t);
        nt.throwIfNullOrUndefined(i, "JSON"), this.privErrorDetails = i.statusText, this.privProperties.setProperty(Fa, dr[dr.ServiceError]);
      }
      this.privProperties.setProperty(ke.SpeechServiceResponse_JsonResult, t);
    }
    get properties() {
      return this.privProperties;
    }
    get reason() {
      return this.privReason;
    }
    get profileId() {
      return this.privProfileId;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    get score() {
      return this.privScore;
    }
  }, Gbe = class Wbe extends nv {
    constructor(t, r, n) {
      super(t, r, n);
    }
    static fromResult(t) {
      let r = oi.Error, n = dr.NoError;
      return t.properties && (n = dr[t.properties.getProperty(Fa, dr[dr.NoError])]), new Wbe(r, t.errorDetails, n);
    }
  };
}), X0, A8, oS, Kbe = Qe(() => {
  hr(), vr(), rn(), Kt(), X0 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, A8 = class {
    constructor() {
    }
    static createConversationAsync(e, t, r, n) {
      if (nt.throwIfNullOrUndefined(e, sn.restErrors.invalidArgs.replace("{arg}", "config")), nt.throwIfNullOrUndefined(e.region, sn.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), !e.subscriptionKey && !e.getProperty(ke[ke.SpeechServiceAuthorization_Token]) && nt.throwIfNullOrUndefined(e.subscriptionKey, sn.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key")), typeof t == "string") {
        let i = new oS(e, t);
        return wr(X0(this, void 0, void 0, function* () {
        }), r, n), i;
      } else {
        let i = new oS(e), o = t, a = r;
        return i.createConversationAsync(() => {
          o && o();
        }, (u) => {
          a && a(u);
        }), i;
      }
    }
  }, oS = class extends A8 {
    constructor(e, t) {
      if (super(), this.privIsDisposed = !1, this.privIsConnected = !1, this.privErrors = sn.restErrors, this.privConversationId = "", this.onConnected = (n) => {
        this.privIsConnected = !0;
        try {
          this.privConversationTranslator.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, n);
        } catch {
        }
      }, this.onDisconnected = (n) => X0(this, void 0, void 0, function* () {
        yield this.close(!1);
        try {
          this.privConversationTranslator.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, n);
        } catch {
        }
      }), this.onCanceled = (n, i) => X0(this, void 0, void 0, function* () {
        yield this.close(!1);
        try {
          this.privConversationTranslator.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, i);
        } catch {
        }
      }), this.onParticipantUpdateCommandReceived = (n, i) => {
        var o, a;
        try {
          let u = this.privParticipants.getParticipant(i.id);
          if (u !== void 0) {
            switch (i.key) {
              case Zo.changeNickname:
                u.displayName = i.value;
                break;
              case Zo.setUseTTS:
                u.useTts = i.value;
                break;
              case Zo.setProfanityFiltering:
                u.profanity = i.value;
                break;
              case Zo.setMute:
                u.isMuted = i.value;
                break;
              case Zo.setTranslateToLanguages:
                u.translateToLanguages = i.value;
                break;
            }
            this.privParticipants.addOrUpdateParticipant(u), !((o = this.privConversationTranslator) === null || o === void 0) && o.participantsChanged && ((a = this.privConversationTranslator) === null || a === void 0 || a.participantsChanged(this.privConversationTranslator, new df($l.Updated, [this.toParticipant(u)], i.sessionId)));
          }
        } catch {
        }
      }, this.onLockRoomCommandReceived = (n, i) => {
      }, this.onMuteAllCommandReceived = (n, i) => {
        var o, a;
        try {
          this.privParticipants.participants.forEach((u) => u.isMuted = u.isHost ? !1 : i.isMuted), !((o = this.privConversationTranslator) === null || o === void 0) && o.participantsChanged && ((a = this.privConversationTranslator) === null || a === void 0 || a.participantsChanged(this.privConversationTranslator, new df($l.Updated, this.toParticipants(!1), i.sessionId)));
        } catch {
        }
      }, this.onParticipantJoinCommandReceived = (n, i) => {
        var o, a;
        try {
          let u = this.privParticipants.addOrUpdateParticipant(i.participant);
          u !== void 0 && !((o = this.privConversationTranslator) === null || o === void 0) && o.participantsChanged && ((a = this.privConversationTranslator) === null || a === void 0 || a.participantsChanged(this.privConversationTranslator, new df($l.JoinedConversation, [this.toParticipant(u)], i.sessionId)));
        } catch {
        }
      }, this.onParticipantLeaveCommandReceived = (n, i) => {
        var o, a;
        try {
          let u = this.privParticipants.getParticipant(i.participant.id);
          u !== void 0 && (this.privParticipants.deleteParticipant(i.participant.id), !((o = this.privConversationTranslator) === null || o === void 0) && o.participantsChanged && ((a = this.privConversationTranslator) === null || a === void 0 || a.participantsChanged(this.privConversationTranslator, new df($l.LeftConversation, [this.toParticipant(u)], i.sessionId))));
        } catch {
        }
      }, this.onTranslationReceived = (n, i) => {
        var o, a, u, s, c, l;
        try {
          switch (i.command) {
            case Ja.final:
              !((o = this.privConversationTranslator) === null || o === void 0) && o.transcribed && ((a = this.privConversationTranslator) === null || a === void 0 || a.transcribed(this.privConversationTranslator, new D1(i.payload, void 0, i.sessionId)));
              break;
            case Ja.partial:
              !((u = this.privConversationTranslator) === null || u === void 0) && u.transcribing && ((s = this.privConversationTranslator) === null || s === void 0 || s.transcribing(this.privConversationTranslator, new D1(i.payload, void 0, i.sessionId)));
              break;
            case Ja.instantMessage:
              !((c = this.privConversationTranslator) === null || c === void 0) && c.textMessageReceived && ((l = this.privConversationTranslator) === null || l === void 0 || l.textMessageReceived(this.privConversationTranslator, new D1(i.payload, void 0, i.sessionId)));
              break;
          }
        } catch {
        }
      }, this.onParticipantsListReceived = (n, i) => {
        var o, a, u;
        try {
          if (i.sessionToken !== void 0 && i.sessionToken !== null && (this.privRoom.token = i.sessionToken), this.privParticipants.participants = [...i.participants], this.privParticipants.me !== void 0 && (this.privIsReady = !0), !((o = this.privConversationTranslator) === null || o === void 0) && o.participantsChanged && ((a = this.privConversationTranslator) === null || a === void 0 || a.participantsChanged(this.privConversationTranslator, new df($l.JoinedConversation, this.toParticipants(!0), i.sessionId))), this.me.isHost) {
            let s = (u = this.privConversationTranslator) === null || u === void 0 ? void 0 : u.properties.getProperty(ke.ConversationTranslator_Name);
            s !== void 0 && s.length > 0 && s !== this.me.displayName && this.changeNicknameAsync(s);
          }
        } catch {
        }
      }, this.onConversationExpiration = (n, i) => {
        var o, a;
        try {
          !((o = this.privConversationTranslator) === null || o === void 0) && o.conversationExpiration && ((a = this.privConversationTranslator) === null || a === void 0 || a.conversationExpiration(this.privConversationTranslator, i));
        } catch {
        }
      }, this.privProperties = new zn(), this.privManager = new jCe(), e.getProperty(ke[ke.SpeechServiceConnection_RecoLanguage]) || e.setProperty(ke[ke.SpeechServiceConnection_RecoLanguage], sn.defaultLanguageCode), this.privLanguage = e.getProperty(ke[ke.SpeechServiceConnection_RecoLanguage]), t) this.privConversationId = t;
      else {
        e.targetLanguages.length === 0 && e.addTargetLanguage(this.privLanguage), e.getProperty(ke[ke.SpeechServiceResponse_ProfanityOption]) || e.setProfanity(jf.Masked);
        let n = e.getProperty(ke[ke.ConversationTranslator_Name]);
        (n == null || n.length <= 1 || n.length > 50) && (n = "Host"), e.setProperty(ke[ke.ConversationTranslator_Name], n);
      }
      this.privConfig = e;
      let r = e;
      nt.throwIfNull(r, "speechConfig"), this.privProperties = r.properties.clone(), this.privIsConnected = !1, this.privParticipants = new JCe(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    set conversationTranslator(e) {
      this.privConversationTranslator = e;
    }
    get room() {
      return this.privRoom;
    }
    get connection() {
      return this.privConversationRecognizer;
    }
    get authorizationToken() {
      return this.privToken;
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "authorizationToken"), this.privToken = e;
    }
    get config() {
      return this.privConfig;
    }
    get conversationId() {
      return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    get properties() {
      return this.privProperties;
    }
    get speechRecognitionLanguage() {
      return this.privLanguage;
    }
    get isMutedByHost() {
      var e, t;
      return !((e = this.privParticipants.me) === null || e === void 0) && e.isHost ? !1 : (t = this.privParticipants.me) === null || t === void 0 ? void 0 : t.isMuted;
    }
    get isConnected() {
      return this.privIsConnected && this.privIsReady;
    }
    get participants() {
      return this.toParticipants(!0);
    }
    get me() {
      return this.toParticipant(this.privParticipants.me);
    }
    get host() {
      return this.toParticipant(this.privParticipants.host);
    }
    createConversationAsync(e, t) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), this.privManager.createOrJoin(this.privProperties, void 0, (r) => {
          r || this.handleError(new Error(this.privErrors.permissionDeniedConnect), t), this.privRoom = r, this.handleCallback(e, t);
        }, (r) => {
          this.handleError(r, t);
        });
      } catch (r) {
        this.handleError(r, t);
      }
    }
    startConversationAsync(e, t) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), t), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer = l3e.fromConfig(this.privConfig), this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, () => {
          this.handleCallback(e, t);
        }, (r) => {
          this.handleError(r, t);
        });
      } catch (r) {
        this.handleError(r, t);
      }
    }
    addParticipantAsync(e, t, r) {
      nt.throwIfNullOrUndefined(e, "Participant"), wr(this.addParticipantImplAsync(e), t, r);
    }
    joinConversationAsync(e, t, r, n, i) {
      try {
        nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), nt.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), nt.throwIfNullOrWhitespace(r, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, e, (o) => {
          nt.throwIfNullOrUndefined(o, this.privErrors.permissionDeniedConnect), this.privRoom = o, this.privConfig.authorizationToken = o.cognitiveSpeechAuthToken, n && n(o.cognitiveSpeechAuthToken);
        }, (o) => {
          this.handleError(o, i);
        });
      } catch (o) {
        this.handleError(o, i);
      }
    }
    deleteConversationAsync(e, t) {
      wr(this.deleteConversationImplAsync(), e, t);
    }
    deleteConversationImplAsync() {
      return X0(this, void 0, void 0, function* () {
        nt.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), nt.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), yield this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
      });
    }
    endConversationAsync(e, t) {
      wr(this.endConversationImplAsync(), e, t);
    }
    endConversationImplAsync() {
      return this.close(!0);
    }
    lockConversationAsync(e, t) {
      var r;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), t), (r = this.privConversationRecognizer) === null || r === void 0 || r.sendRequest(this.getLockCommand(!0), () => {
          this.handleCallback(e, t);
        }, (n) => {
          this.handleError(n, t);
        });
      } catch (n) {
        this.handleError(n, t);
      }
    }
    muteAllParticipantsAsync(e, t) {
      var r;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), t), (r = this.privConversationRecognizer) === null || r === void 0 || r.sendRequest(this.getMuteAllCommand(!0), () => {
          this.handleCallback(e, t);
        }, (n) => {
          this.handleError(n, t);
        });
      } catch (n) {
        this.handleError(n, t);
      }
    }
    muteParticipantAsync(e, t, r) {
      var n;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), r), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), r), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), r), (n = this.privConversationRecognizer) === null || n === void 0 || n.sendRequest(this.getMuteCommand(e, !0), () => {
          this.handleCallback(t, r);
        }, (i) => {
          this.handleError(i, r);
        });
      } catch (i) {
        this.handleError(i, r);
      }
    }
    removeParticipantAsync(e, t, r) {
      var n;
      try {
        if (nt.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && e.hasOwnProperty("id")) wr(this.removeParticipantImplAsync(e), t, r);
        else {
          nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), r);
          let i = "";
          typeof e == "string" ? i = e : e.hasOwnProperty("id") ? i = e.id : e.hasOwnProperty("userId") && (i = e.userId), nt.throwIfNullOrWhitespace(i, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((o) => o.id === i) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), r), (n = this.privConversationRecognizer) === null || n === void 0 || n.sendRequest(this.getEjectCommand(i), () => {
            this.handleCallback(t, r);
          }, (o) => {
            this.handleError(o, r);
          });
        }
      } catch (i) {
        this.handleError(i, r);
      }
    }
    unlockConversationAsync(e, t) {
      var r;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), t), (r = this.privConversationRecognizer) === null || r === void 0 || r.sendRequest(this.getLockCommand(!1), () => {
          this.handleCallback(e, t);
        }, (n) => {
          this.handleError(n, t);
        });
      } catch (n) {
        this.handleError(n, t);
      }
    }
    unmuteAllParticipantsAsync(e, t) {
      var r;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), t), (r = this.privConversationRecognizer) === null || r === void 0 || r.sendRequest(this.getMuteAllCommand(!1), () => {
          this.handleCallback(e, t);
        }, (n) => {
          this.handleError(n, t);
        });
      } catch (n) {
        this.handleError(n, t);
      }
    }
    unmuteParticipantAsync(e, t, r) {
      var n;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "userId")), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), r), !this.me.isHost && this.me.id !== e && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), r), this.privParticipants.getParticipantIndex(e) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), r), (n = this.privConversationRecognizer) === null || n === void 0 || n.sendRequest(this.getMuteCommand(e, !1), () => {
          this.handleCallback(t, r);
        }, (i) => {
          this.handleError(i, r);
        });
      } catch (i) {
        this.handleError(i, r);
      }
    }
    sendTextMessageAsync(e, t, r) {
      var n;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "message")), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), r), e.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), r), (n = this.privConversationRecognizer) === null || n === void 0 || n.sendRequest(this.getMessageCommand(e), () => {
          this.handleCallback(t, r);
        }, (i) => {
          this.handleError(i, r);
        });
      } catch (i) {
        this.handleError(i, r);
      }
    }
    changeNicknameAsync(e, t, r) {
      var n;
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfDisposed(this.privConversationRecognizer.isDisposed()), nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", "nickname")), nt.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), r), (n = this.privConversationRecognizer) === null || n === void 0 || n.sendRequest(this.getChangeNicknameCommand(e), () => {
          this.handleCallback(t, r);
        }, (i) => {
          this.handleError(i, r);
        });
      } catch (i) {
        this.handleError(i, r);
      }
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose(e) {
      var t;
      this.isDisposed || (this.privIsDisposed = !0, (t = this.config) === null || t === void 0 || t.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privConversationRecognizer = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    get transcriberRecognizer() {
      return this.privTranscriberRecognizer;
    }
    connectTranscriberRecognizer(e) {
      return X0(this, void 0, void 0, function* () {
        this.privTranscriberRecognizer && (yield this.privTranscriberRecognizer.close()), this.privTranscriberRecognizer = e, this.privTranscriberRecognizer.conversation = this;
      });
    }
    get conversationInfo() {
      let e = this.conversationId, t = this.participants.map((n) => ({ id: n.id, preferredLanguage: n.preferredLanguage, voice: n.voice })), r = {};
      for (let n of sn.transcriptionEventKeys) {
        let i = this.properties.getProperty(n, "");
        i !== "" && (r[n] = i);
      }
      return { id: e, participants: t, conversationProperties: r };
    }
    addParticipantImplAsync(e) {
      if (this.privParticipants.addOrUpdateParticipant(e) !== void 0 && this.privTranscriberRecognizer) {
        let t = this.conversationInfo;
        return t.participants = [e], this.privTranscriberRecognizer.pushConversationEvent(t, "join");
      }
    }
    removeParticipantImplAsync(e) {
      this.privParticipants.deleteParticipant(e.id);
      let t = this.conversationInfo;
      return t.participants = [e], this.privTranscriberRecognizer.pushConversationEvent(t, "leave");
    }
    close(e) {
      var t, r;
      return X0(this, void 0, void 0, function* () {
        try {
          this.privIsConnected = !1, yield this.privConversationRecognizer.close(), yield (t = this.privTranscriberRecognizer) === null || t === void 0 ? void 0 : t.close(), this.privConversationRecognizer = void 0, (r = this.privConversationTranslator) === null || r === void 0 || r.dispose();
        } catch {
        }
        e && this.dispose();
      });
    }
    get canSend() {
      var e;
      return this.privIsConnected && !(!((e = this.privParticipants.me) === null || e === void 0) && e.isMuted);
    }
    get canSendAsHost() {
      var e;
      return this.privIsConnected && ((e = this.privParticipants.me) === null || e === void 0 ? void 0 : e.isHost);
    }
    handleCallback(e, t) {
      if (e) {
        try {
          e();
        } catch (r) {
          t && t(r);
        }
        e = void 0;
      }
    }
    handleError(e, t) {
      if (t) if (e instanceof Error) {
        let r = e;
        t(r.name + ": " + r.message);
      } else t(e);
    }
    toParticipants(e) {
      let t = this.privParticipants.participants.map((r) => this.toParticipant(r));
      return e ? t : t.filter((r) => r.isHost === !1);
    }
    toParticipant(e) {
      return new O$(e.id, e.avatar, e.displayName, e.isHost, e.isMuted, e.isUsingTts, e.preferredLanguage, e.voice);
    }
    getMuteAllCommand(e) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({ command: Zo.setMuteAll, participantId: this.privRoom.participantId, roomid: this.privRoom.roomId, type: Ja.participantCommand, value: e });
    }
    getMuteCommand(e, t) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({ command: Zo.setMute, participantId: e, roomid: this.privRoom.roomId, type: Ja.participantCommand, value: t });
    }
    getLockCommand(e) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({ command: Zo.setLockState, participantId: this.privRoom.participantId, roomid: this.privRoom.roomId, type: Ja.participantCommand, value: e });
    }
    getEjectCommand(e) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(e, "participantId"), JSON.stringify({ command: Zo.ejectParticipant, participantId: e, roomid: this.privRoom.roomId, type: Ja.participantCommand });
    }
    getChangeNicknameCommand(e) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(e, "nickname"), nt.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({ command: Zo.changeNickname, nickname: e, participantId: this.privRoom.participantId, roomid: this.privRoom.roomId, type: Ja.participantCommand, value: e });
    }
    getMessageCommand(e) {
      return nt.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), nt.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), nt.throwIfNullOrWhitespace(e, "message"), JSON.stringify({ participantId: this.privRoom.participantId, roomId: this.privRoom.roomId, text: e, type: Ja.instantMessage });
    }
  };
}), Xbe, yCr = Qe(() => {
  Xbe = class {
    constructor(e) {
      this.privAudioConfig = e;
    }
    handleCallback(e, t) {
      if (e) {
        try {
          e();
        } catch (r) {
          t && t(r);
        }
        e = void 0;
      }
    }
    handleError(e, t) {
      if (t) if (e instanceof Error) {
        let r = e;
        t(r.name + ": " + r.message);
      } else t(e);
    }
  };
}), I$, _Cr = Qe(() => {
  Kt(), I$ = class extends $o {
    constructor(e, t) {
      super(t), this.privExpirationTime = e;
    }
    get expirationTime() {
      return this.privExpirationTime;
    }
  };
}), df, ACr = Qe(() => {
  Kt(), df = class extends $o {
    constructor(e, t, r) {
      super(r), this.privReason = e, this.privParticipant = t;
    }
    get reason() {
      return this.privReason;
    }
    get participants() {
      return this.privParticipant;
    }
  };
}), v2, SCr = Qe(() => {
  d$(), v2 = class extends f2 {
  };
}), D1, bCr = Qe(() => {
  Kt(), D1 = class extends Ts {
    constructor(e, t, r) {
      super(t, r), this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  };
}), bb, CCr = Qe(() => {
  fbe(), bb = class extends Dp {
    constructor(e, t, r, n, i, o, a, u, s, c, l) {
      super(t, n, i, o, a, u, s, c, l), this.privId = e, this.privOrigLang = r;
    }
    get participantId() {
      return this.privId;
    }
    get originalLang() {
      return this.privOrigLang;
    }
  };
}), ns, Cu, Vue, Jbe, ICr = Qe(() => {
  hr(), vr(), rn(), Kt(), Kbe(), tCe(), ns = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, function(e) {
    e[e.Inactive = 0] = "Inactive", e[e.Connecting = 1] = "Connecting", e[e.Connected = 2] = "Connected";
  }(Cu || (Cu = {})), Vue = class extends h$ {
    constructor(e, t, r) {
      super(e, t), this.privSpeechState = Cu.Inactive, r && (this.privTranslator = r, this.sessionStarted = () => {
        this.privSpeechState = Cu.Connected;
      }, this.sessionStopped = () => {
        this.privSpeechState = Cu.Inactive;
      }, this.recognized = (n, i) => ns(this, void 0, void 0, function* () {
        var o;
        !((o = i.result) === null || o === void 0) && o.errorDetails && (yield this.cancelSpeech(), this.fireCancelEvent(i.result.errorDetails));
      }), this.canceled = (n, i) => ns(this, void 0, void 0, function* () {
        if (this.privSpeechState !== Cu.Inactive) try {
          yield this.cancelSpeech();
        } catch {
          this.privSpeechState = Cu.Inactive;
        }
      }));
    }
    get state() {
      return this.privSpeechState;
    }
    set state(e) {
      this.privSpeechState = e;
    }
    onConnection() {
      this.privSpeechState = Cu.Connected;
    }
    onDisconnection() {
      return ns(this, void 0, void 0, function* () {
        this.privSpeechState = Cu.Inactive, yield this.cancelSpeech();
      });
    }
    fireCancelEvent(e) {
      var t, r, n;
      try {
        if (this.privTranslator.canceled) {
          let i = new v2((t = e == null ? void 0 : e.reason) !== null && t !== void 0 ? t : oi.Error, (r = e == null ? void 0 : e.errorDetails) !== null && r !== void 0 ? r : e, (n = e == null ? void 0 : e.errorCode) !== null && n !== void 0 ? n : dr.RuntimeError, void 0, e == null ? void 0 : e.sessionId);
          this.privTranslator.canceled(this.privTranslator, i);
        }
      } catch {
      }
    }
    cancelSpeech() {
      var e;
      return ns(this, void 0, void 0, function* () {
        try {
          this.stopContinuousRecognitionAsync(), yield (e = this.privReco) === null || e === void 0 ? void 0 : e.disconnect(), this.privSpeechState = Cu.Inactive;
        } catch {
        }
      });
    }
  }, Jbe = class extends Xbe {
    constructor(e) {
      super(e), this.privIsDisposed = !1, this.privIsSpeaking = !1, this.privErrors = sn.restErrors, this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345", this.privPlaceholderRegion = "westus", this.privProperties = new zn();
    }
    get properties() {
      return this.privProperties;
    }
    get speechRecognitionLanguage() {
      return this.privSpeechRecognitionLanguage;
    }
    get participants() {
      var e;
      return (e = this.privConversation) === null || e === void 0 ? void 0 : e.participants;
    }
    joinConversationAsync(e, t, r, n, i) {
      try {
        if (typeof e == "string") {
          nt.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), nt.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privConversation && this.handleError(new Error(this.privErrors.permissionDeniedStart), i);
          let o = r;
          (o == null || o === "") && (o = sn.defaultLanguageCode), this.privSpeechTranslationConfig = yb.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion), this.privSpeechTranslationConfig.setProfanity(jf.Masked), this.privSpeechTranslationConfig.addTargetLanguage(o), this.privSpeechTranslationConfig.setProperty(ke[ke.SpeechServiceConnection_RecoLanguage], o), this.privSpeechTranslationConfig.setProperty(ke[ke.ConversationTranslator_Name], t);
          let a = this.privProperties.getProperty(ke.ConversationTranslator_Host);
          a && this.privSpeechTranslationConfig.setProperty(ke[ke.ConversationTranslator_Host], a);
          let u = this.privProperties.getProperty(ke.SpeechServiceConnection_Host);
          u && this.privSpeechTranslationConfig.setProperty(ke[ke.SpeechServiceConnection_Host], u), this.privConversation = new oS(this.privSpeechTranslationConfig), this.privConversation.conversationTranslator = this, this.privConversation.joinConversationAsync(e, t, o, (s) => {
            s || this.handleError(new Error(this.privErrors.permissionDeniedConnect), i), this.privSpeechTranslationConfig.authorizationToken = s, this.privConversation.startConversationAsync(() => {
              this.handleCallback(n, i);
            }, (c) => {
              this.handleError(c, i);
            });
          }, (s) => {
            this.handleError(s, i);
          });
        } else typeof e == "object" ? (nt.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), nt.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privProperties.setProperty(ke.ConversationTranslator_Name, t), this.privConversation = e, this.privConversation.conversationTranslator = this, nt.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect), nt.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privSpeechTranslationConfig = e.config, this.handleCallback(r, n)) : this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), n);
      } catch (o) {
        this.handleError(o, typeof r == "string" ? i : n);
      }
    }
    leaveConversationAsync(e, t) {
      wr(ns(this, void 0, void 0, function* () {
        yield this.cancelSpeech(), yield this.privConversation.endConversationImplAsync(), yield this.privConversation.deleteConversationImplAsync(), this.dispose();
      }), e, t);
    }
    sendTextMessageAsync(e, t, r) {
      var n;
      try {
        nt.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), nt.throwIfNullOrWhitespace(e, this.privErrors.invalidArgs.replace("{arg}", e)), (n = this.privConversation) === null || n === void 0 || n.sendTextMessageAsync(e, t, r);
      } catch (i) {
        this.handleError(i, r);
      }
    }
    startTranscribingAsync(e, t) {
      wr(ns(this, void 0, void 0, function* () {
        try {
          nt.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), nt.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privCTRecognizer === void 0 && (yield this.connectTranslatorRecognizer()), nt.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend), this.canSpeak || this.handleError(new Error(this.privErrors.permissionDeniedSend), t), yield this.startContinuousRecognition(), this.privIsSpeaking = !0;
        } catch (r) {
          throw this.privIsSpeaking = !1, yield this.cancelSpeech(), r;
        }
      }), e, t);
    }
    stopTranscribingAsync(e, t) {
      wr(ns(this, void 0, void 0, function* () {
        try {
          if (!this.privIsSpeaking) {
            yield this.cancelSpeech();
            return;
          }
          this.privIsSpeaking = !1, yield new Promise((r, n) => {
            var i;
            (i = this.privCTRecognizer) === null || i === void 0 || i.stopContinuousRecognitionAsync(r, n);
          });
        } catch {
          yield this.cancelSpeech();
        }
      }), e, t);
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose(e, t, r) {
      wr(ns(this, void 0, void 0, function* () {
        var n, i;
        this.isDisposed && !this.privIsSpeaking || (yield this.cancelSpeech(), this.privIsDisposed = !0, (n = this.privSpeechTranslationConfig) === null || n === void 0 || n.close(), this.privSpeechRecognitionLanguage = void 0, this.privProperties = void 0, this.privAudioConfig = void 0, this.privSpeechTranslationConfig = void 0, (i = this.privConversation) === null || i === void 0 || i.dispose(), this.privConversation = void 0);
      }), t, r);
    }
    cancelSpeech() {
      var e;
      return ns(this, void 0, void 0, function* () {
        try {
          this.privIsSpeaking = !1, yield (e = this.privCTRecognizer) === null || e === void 0 ? void 0 : e.onDisconnection(), this.privCTRecognizer = void 0;
        } catch {
        }
      });
    }
    connectTranslatorRecognizer() {
      return ns(this, void 0, void 0, function* () {
        try {
          this.privAudioConfig === void 0 && (this.privAudioConfig = Xl.fromDefaultMicrophoneInput()), this.privSpeechTranslationConfig.getProperty(ke[ke.SpeechServiceConnection_Key]) === this.privPlaceholderKey && this.privSpeechTranslationConfig.setProperty(ke[ke.SpeechServiceConnection_Key], "");
          let e = encodeURIComponent(this.privConversation.room.token), t = this.privSpeechTranslationConfig.getProperty(ke[ke.SpeechServiceConnection_Host], sn.speechHost);
          t = t.replace("{region}", this.privConversation.room.cognitiveSpeechRegion);
          let r = `wss://${t}${sn.speechPath}?${sn.configParams.token}=${e}`;
          this.privSpeechTranslationConfig.setProperty(ke[ke.SpeechServiceConnection_Endpoint], r), this.privCTRecognizer = new Vue(this.privSpeechTranslationConfig, this.privAudioConfig, this);
        } catch (e) {
          throw yield this.cancelSpeech(), e;
        }
      });
    }
    startContinuousRecognition() {
      return new Promise((e, t) => {
        this.privCTRecognizer.startContinuousRecognitionAsync(e, t);
      });
    }
    get canSpeak() {
      return !(!this.privConversation.isConnected || !this.privCTRecognizer || this.privIsSpeaking || this.privCTRecognizer.state === Cu.Connected || this.privCTRecognizer.state === Cu.Connecting || this.privConversation.isMutedByHost);
    }
  };
}), O5, Zbe, OCr = Qe(() => {
  hr(), vr(), rn(), Kt(), O5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, Zbe = class {
    constructor(e) {
      this.privAudioConfig = e, this.privProperties = new zn(), this.privRecognizer = void 0, this.privDisposedRecognizer = !1;
    }
    joinConversationAsync(e, t, r) {
      let n = e;
      nt.throwIfNullOrUndefined(n, "Conversation"), this.privRecognizer = new f3e(e.config, this.privAudioConfig), nt.throwIfNullOrUndefined(this.privRecognizer, "Recognizer"), this.privRecognizer.connectCallbacks(this), wr(n.connectTranscriberRecognizer(this.privRecognizer), t, r);
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    get speechRecognitionLanguage() {
      return nt.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
      return this.privProperties;
    }
    startTranscribingAsync(e, t) {
      this.privRecognizer.startContinuousRecognitionAsync(e, t);
    }
    stopTranscribingAsync(e, t) {
      this.privRecognizer.stopContinuousRecognitionAsync(e, t);
    }
    leaveConversationAsync(e, t) {
      this.privRecognizer.disconnectCallbacks(), wr(O5(this, void 0, void 0, function* () {
      }), e, t);
    }
    close(e, t) {
      nt.throwIfDisposed(this.privDisposedRecognizer), wr(this.dispose(!0), e, t);
    }
    dispose(e) {
      return O5(this, void 0, void 0, function* () {
        this.privDisposedRecognizer || e && (this.privDisposedRecognizer = !0);
      });
    }
  };
}), Qbe, O$, RCr = Qe(() => {
  Kt(), Qbe = class {
    constructor(e) {
      this.privUserId = e;
    }
    get userId() {
      return this.privUserId;
    }
  }, O$ = class eCe {
    constructor(t, r, n, i, o, a, u, s) {
      this.privId = t, this.privAvatar = r, this.privDisplayName = n, this.privIsHost = i, this.privIsMuted = o, this.privIsUsingTts = a, this.privPreferredLanguage = u, this.privVoice = s, this.privProperties = new zn();
    }
    static From(t, r, n) {
      return new eCe(t, "", t, !1, !1, !1, r, n);
    }
    get avatar() {
      return this.privAvatar;
    }
    get displayName() {
      return this.privDisplayName;
    }
    get id() {
      return this.privId;
    }
    get preferredLanguage() {
      return this.privPreferredLanguage;
    }
    get isHost() {
      return this.privIsHost;
    }
    get isMuted() {
      return this.privIsMuted;
    }
    get isUsingTts() {
      return this.privIsUsingTts;
    }
    get voice() {
      return this.privVoice;
    }
    get properties() {
      return this.privProperties;
    }
  };
}), $l, wCr = Qe(() => {
  (function(e) {
    e[e.JoinedConversation = 0] = "JoinedConversation", e[e.LeftConversation = 1] = "LeftConversation", e[e.Updated = 2] = "Updated";
  })($l || ($l = {}));
}), tCe = Qe(() => {
  Kbe(), yCr(), _Cr(), ACr(), SCr(), bCr(), CCr(), ICr(), OCr(), RCr(), wCr();
}), R5, rCe, jue, PCr = Qe(() => {
  hr(), vr(), ibe(), s2(), rv(), rn(), Kt(), R5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, rCe = class S8 {
    constructor(t, r) {
      let n = t;
      nt.throwIfNull(n, "speechConfig"), r !== null && (r === void 0 ? this.audioConfig = typeof window > "u" ? void 0 : Xl.fromDefaultSpeakerOutput() : this.audioConfig = r), this.privProperties = n.properties.clone(), this.privDisposed = !1, this.privSynthesizing = !1, this.privConnectionFactory = new pCe(), this.synthesisRequestQueue = new ah(), this.implCommonSynthesizeSetup();
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(t) {
      nt.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, t);
    }
    get properties() {
      return this.privProperties;
    }
    get autoDetectSourceLanguage() {
      return this.properties.getProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages) === U$;
    }
    static FromConfig(t, r, n) {
      let i = t;
      return r.properties.mergeTo(i.properties), new S8(t, n);
    }
    buildSsml(t) {
      let r = { "ar-EG": "Microsoft Server Speech Text to Speech Voice (ar-EG, Hoda)", "ar-SA": "Microsoft Server Speech Text to Speech Voice (ar-SA, Naayf)", "bg-BG": "Microsoft Server Speech Text to Speech Voice (bg-BG, Ivan)", "ca-ES": "Microsoft Server Speech Text to Speech Voice (ca-ES, HerenaRUS)", "cs-CZ": "Microsoft Server Speech Text to Speech Voice (cs-CZ, Jakub)", "da-DK": "Microsoft Server Speech Text to Speech Voice (da-DK, HelleRUS)", "de-AT": "Microsoft Server Speech Text to Speech Voice (de-AT, Michael)", "de-CH": "Microsoft Server Speech Text to Speech Voice (de-CH, Karsten)", "de-DE": "Microsoft Server Speech Text to Speech Voice (de-DE, HeddaRUS)", "el-GR": "Microsoft Server Speech Text to Speech Voice (el-GR, Stefanos)", "en-AU": "Microsoft Server Speech Text to Speech Voice (en-AU, HayleyRUS)", "en-CA": "Microsoft Server Speech Text to Speech Voice (en-CA, HeatherRUS)", "en-GB": "Microsoft Server Speech Text to Speech Voice (en-GB, HazelRUS)", "en-IE": "Microsoft Server Speech Text to Speech Voice (en-IE, Sean)", "en-IN": "Microsoft Server Speech Text to Speech Voice (en-IN, PriyaRUS)", "en-US": "Microsoft Server Speech Text to Speech Voice (en-US, AriaRUS)", "es-ES": "Microsoft Server Speech Text to Speech Voice (es-ES, HelenaRUS)", "es-MX": "Microsoft Server Speech Text to Speech Voice (es-MX, HildaRUS)", "fi-FI": "Microsoft Server Speech Text to Speech Voice (fi-FI, HeidiRUS)", "fr-CA": "Microsoft Server Speech Text to Speech Voice (fr-CA, HarmonieRUS)", "fr-CH": "Microsoft Server Speech Text to Speech Voice (fr-CH, Guillaume)", "fr-FR": "Microsoft Server Speech Text to Speech Voice (fr-FR, HortenseRUS)", "he-IL": "Microsoft Server Speech Text to Speech Voice (he-IL, Asaf)", "hi-IN": "Microsoft Server Speech Text to Speech Voice (hi-IN, Kalpana)", "hr-HR": "Microsoft Server Speech Text to Speech Voice (hr-HR, Matej)", "hu-HU": "Microsoft Server Speech Text to Speech Voice (hu-HU, Szabolcs)", "id-ID": "Microsoft Server Speech Text to Speech Voice (id-ID, Andika)", "it-IT": "Microsoft Server Speech Text to Speech Voice (it-IT, LuciaRUS)", "ja-JP": "Microsoft Server Speech Text to Speech Voice (ja-JP, HarukaRUS)", "ko-KR": "Microsoft Server Speech Text to Speech Voice (ko-KR, HeamiRUS)", "ms-MY": "Microsoft Server Speech Text to Speech Voice (ms-MY, Rizwan)", "nb-NO": "Microsoft Server Speech Text to Speech Voice (nb-NO, HuldaRUS)", "nl-NL": "Microsoft Server Speech Text to Speech Voice (nl-NL, HannaRUS)", "pl-PL": "Microsoft Server Speech Text to Speech Voice (pl-PL, PaulinaRUS)", "pt-BR": "Microsoft Server Speech Text to Speech Voice (pt-BR, HeloisaRUS)", "pt-PT": "Microsoft Server Speech Text to Speech Voice (pt-PT, HeliaRUS)", "ro-RO": "Microsoft Server Speech Text to Speech Voice (ro-RO, Andrei)", "ru-RU": "Microsoft Server Speech Text to Speech Voice (ru-RU, EkaterinaRUS)", "sk-SK": "Microsoft Server Speech Text to Speech Voice (sk-SK, Filip)", "sl-SI": "Microsoft Server Speech Text to Speech Voice (sl-SI, Lado)", "sv-SE": "Microsoft Server Speech Text to Speech Voice (sv-SE, HedvigRUS)", "ta-IN": "Microsoft Server Speech Text to Speech Voice (ta-IN, Valluvar)", "te-IN": "Microsoft Server Speech Text to Speech Voice (te-IN, Chitra)", "th-TH": "Microsoft Server Speech Text to Speech Voice (th-TH, Pattara)", "tr-TR": "Microsoft Server Speech Text to Speech Voice (tr-TR, SedaRUS)", "vi-VN": "Microsoft Server Speech Text to Speech Voice (vi-VN, An)", "zh-CN": "Microsoft Server Speech Text to Speech Voice (zh-CN, HuihuiRUS)", "zh-HK": "Microsoft Server Speech Text to Speech Voice (zh-HK, TracyRUS)", "zh-TW": "Microsoft Server Speech Text to Speech Voice (zh-TW, HanHanRUS)" }, n = this.properties.getProperty(ke.SpeechServiceConnection_SynthLanguage, "en-US"), i = this.properties.getProperty(ke.SpeechServiceConnection_SynthVoice, ""), o = S8.XMLEncode(t);
      return this.autoDetectSourceLanguage ? n = "en-US" : i = i || r[n], i && (o = `<voice name='${i}'>${o}</voice>`), o = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${n}'>${o}</speak>`, o;
    }
    speakTextAsync(t, r, n, i) {
      this.speakImpl(t, !1, r, n, i);
    }
    speakSsmlAsync(t, r, n, i) {
      this.speakImpl(t, !0, r, n, i);
    }
    close(t, r) {
      nt.throwIfDisposed(this.privDisposed), wr(this.dispose(!0), t, r);
    }
    get internalData() {
      return this.privAdapter;
    }
    dispose(t) {
      return R5(this, void 0, void 0, function* () {
        this.privDisposed || (t && this.privAdapter && (yield this.privAdapter.dispose()), this.privDisposed = !0);
      });
    }
    createSynthesizerConfig(t) {
      return new y3e(t, this.privProperties);
    }
    createSynthesisAdapter(t, r, n, i) {
      return new zf(t, r, i, this, this.audioConfig);
    }
    implCommonSynthesizeSetup() {
      let t = typeof window < "u" ? "Browser" : "Node", r = "unknown", n = "unknown";
      typeof navigator < "u" && (t = t + "/" + navigator.platform, r = navigator.userAgent, n = navigator.appVersion);
      let i = this.createSynthesizerConfig(new ET(new t0(new e_(t, r, n)))), o = this.privProperties.getProperty(ke.SpeechServiceConnection_Key, void 0), a = o && o !== "" ? new s$(o) : new c$((u) => {
        let s = this.privProperties.getProperty(ke.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(s);
      }, (u) => {
        let s = this.privProperties.getProperty(ke.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(s);
      });
      this.privAdapter = this.createSynthesisAdapter(a, this.privConnectionFactory, this.audioConfig, i), this.privAdapter.audioOutputFormat = sh.fromSpeechSynthesisOutputFormat(Wr[this.properties.getProperty(ke.SpeechServiceConnection_SynthOutputFormat, void 0)]);
    }
    speakImpl(t, r, n, i, o) {
      try {
        nt.throwIfDisposed(this.privDisposed);
        let a = jn(), u;
        o instanceof c2 ? u = new vb(o) : o instanceof Pp ? u = o : o !== void 0 ? u = new l$(o) : u = void 0, this.synthesisRequestQueue.enqueue(new jue(a, t, r, (s) => {
          if (this.privSynthesizing = !1, n) try {
            n(s);
          } catch (c) {
            i && i(c);
          }
          n = void 0, this.adapterSpeak().catch(() => {
          });
        }, (s) => {
          i && i(s);
        }, u)), this.adapterSpeak().catch(() => {
        });
      } catch (a) {
        if (i) if (a instanceof Error) {
          let u = a;
          i(u.name + ": " + u.message);
        } else i(a);
        this.dispose(!0).catch(() => {
        });
      }
    }
    adapterSpeak() {
      return R5(this, void 0, void 0, function* () {
        if (!this.privDisposed && !this.privSynthesizing) {
          this.privSynthesizing = !0;
          let t = yield this.synthesisRequestQueue.dequeue();
          return this.privAdapter.Speak(t.text, t.isSSML, t.requestId, t.cb, t.err, t.dataStream);
        }
      });
    }
    static XMLEncode(t) {
      return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
  }, jue = class {
    constructor(e, t, r, n, i, o) {
      this.requestId = e, this.text = t, this.isSSML = r, this.cb = n, this.err = i, this.dataStream = o;
    }
  };
}), mp, DCr = Qe(() => {
  mp = class {
    constructor(e, t, r, n, i) {
      this.privResultId = e, this.privReason = t, this.privAudioData = r, this.privErrorDetails = n, this.privProperties = i;
    }
    get resultId() {
      return this.privResultId;
    }
    get reason() {
      return this.privReason;
    }
    get audioData() {
      return this.privAudioData;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    get properties() {
      return this.privProperties;
    }
  };
}), gp, xCr = Qe(() => {
  gp = class {
    constructor(e) {
      this.privResult = e;
    }
    get result() {
      return this.privResult;
    }
  };
}), R$, NCr = Qe(() => {
  R$ = class {
    constructor(e, t, r, n) {
      this.privAudioOffset = e, this.privText = t, this.privWordLength = r, this.privTextOffset = n;
    }
    get audioOffset() {
      return this.privAudioOffset;
    }
    get text() {
      return this.privText;
    }
    get wordLength() {
      return this.privWordLength;
    }
    get textOffset() {
      return this.privTextOffset;
    }
  };
}), w$, LCr = Qe(() => {
  w$ = class {
    constructor(e, t) {
      this.privAudioOffset = e, this.privText = t;
    }
    get audioOffset() {
      return this.privAudioOffset;
    }
    get text() {
      return this.privText;
    }
  };
}), P$, BCr = Qe(() => {
  P$ = class {
    constructor(e, t, r) {
      this.privAudioOffset = e, this.privVisemeId = t, this.privAnimation = r;
    }
    get audioOffset() {
      return this.privAudioOffset;
    }
    get visemeId() {
      return this.privVisemeId;
    }
    get animation() {
      return this.privAnimation;
    }
  };
}), a4, zue, w5, Cb, kCr = Qe(() => {
  hr(), vr(), rv(), m0(), a4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, zue = 60 * 30, w5 = { [Rr.PCM]: "audio/wav", [Rr.MuLaw]: "audio/x-wav", [Rr.MP3]: "audio/mpeg", [Rr.OGG_OPUS]: "audio/ogg", [Rr.WEBM_OPUS]: "audio/webm; codecs=opus", [Rr.ALaw]: "audio/x-wav" }, Cb = class {
    constructor(e) {
      this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = e || jn(), this.privIsPaused = !1, this.privIsClosed = !1;
    }
    id() {
      return this.privId;
    }
    write(e, t, r) {
      this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(e), this.updateSourceBuffer().then(() => {
        t && t();
      }, (n) => {
        r && r(n);
      })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength);
    }
    close(e, t) {
      if (this.privIsClosed = !0, this.privSourceBuffer !== void 0) this.handleSourceBufferUpdateEnd().then(() => {
        e && e();
      }, (r) => {
        t && t(r);
      });
      else if (this.privAudioOutputStream !== void 0) if ((this.privFormat.formatTag === Rr.PCM || this.privFormat.formatTag === Rr.MuLaw || this.privFormat.formatTag === Rr.ALaw) && this.privFormat.hasHeader === !1) console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
      else {
        let r = new ArrayBuffer(this.privBytesReceived);
        this.privAudioOutputStream.read(r).then((n) => {
          r = zf.addHeader(r, this.privFormat);
          let i = new Blob([r], { type: w5[this.privFormat.formatTag] });
          this.privAudio.src = window.URL.createObjectURL(i), this.notifyPlayback().then(() => {
            e && e();
          }, (o) => {
            t && t(o);
          });
        }, (n) => {
          t && t(n);
        });
      }
      else this.onAudioEnd && this.onAudioEnd(this);
    }
    set format(e) {
      if (typeof AudioContext < "u" || typeof window.webkitAudioContext < "u") {
        this.privFormat = e;
        let t = w5[this.privFormat.formatTag];
        t === void 0 ? console.warn(`Unknown mimeType for format ${Rr[this.privFormat.formatTag]}; playback is not supported.`) : typeof MediaSource < "u" && MediaSource.isTypeSupported(t) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = (r) => {
          this.privMediaSourceOpened = !0, this.privMediaSource.duration = zue, this.privSourceBuffer = this.privMediaSource.addSourceBuffer(t), this.privSourceBuffer.onupdate = (n) => {
            this.updateSourceBuffer().catch((i) => {
              ci.instance.onEvent(new ec(i));
            });
          }, this.privSourceBuffer.onupdateend = (n) => {
            this.handleSourceBufferUpdateEnd().catch((i) => {
              ci.instance.onEvent(new ec(i));
            });
          }, this.privSourceBuffer.onupdatestart = (n) => {
            this.privAppendingToBuffer = !1;
          };
        }, this.updateSourceBuffer().catch((r) => {
          ci.instance.onEvent(new ec(r));
        })) : (console.warn(`Format ${Rr[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`), this.privAudioOutputStream = new pb(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
      }
    }
    get isClosed() {
      return this.privIsClosed;
    }
    get currentTime() {
      return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
    }
    pause() {
      !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
    }
    resume(e, t) {
      this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(() => {
        e && e();
      }, (r) => {
        t && t(r);
      }), this.privIsPaused = !1);
    }
    get internalAudio() {
      return this.privAudio;
    }
    updateSourceBuffer() {
      return a4(this, void 0, void 0, function* () {
        if (this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
          this.privAppendingToBuffer = !0;
          let e = this.privAudioBuffer.shift();
          try {
            this.privSourceBuffer.appendBuffer(e);
          } catch {
            this.privAudioBuffer.unshift(e), console.log("buffer filled, pausing addition of binaries until space is made");
            return;
          }
          yield this.notifyPlayback();
        } else this.canEndStream() && (yield this.handleSourceBufferUpdateEnd());
      });
    }
    handleSourceBufferUpdateEnd() {
      return a4(this, void 0, void 0, function* () {
        this.canEndStream() && this.sourceBufferAvailable() && (this.privMediaSource.endOfStream(), yield this.notifyPlayback());
      });
    }
    notifyPlayback() {
      return a4(this, void 0, void 0, function* () {
        !this.privPlaybackStarted && this.privAudio !== void 0 && (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = () => {
          this.onAudioEnd && this.onAudioEnd(this);
        }, this.privIsPaused || (yield this.privAudio.play()));
      });
    }
    canEndStream() {
      return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
      return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
    }
  };
}), D$, MCr = Qe(() => {
  d$(), D$ = class extends f2 {
  };
}), hT, FCr = Qe(() => {
  (function(e) {
    e[e.FivePoint = 1] = "FivePoint", e[e.HundredMark = 2] = "HundredMark";
  })(hT || (hT = {}));
}), vT, HCr = Qe(() => {
  (function(e) {
    e[e.Phoneme = 1] = "Phoneme", e[e.Word = 2] = "Word", e[e.FullText = 3] = "FullText";
  })(vT || (vT = {}));
}), nCe, $Cr = Qe(() => {
  rn(), Kt(), nCe = class iCe {
    constructor(t, r = hT.FivePoint, n = vT.Phoneme, i = !1) {
      nt.throwIfNullOrUndefined(t, "referenceText"), this.privProperties = new zn(), this.privProperties.setProperty(ke.PronunciationAssessment_ReferenceText, t), this.privProperties.setProperty(ke.PronunciationAssessment_GradingSystem, hT[r]), this.privProperties.setProperty(ke.PronunciationAssessment_Granularity, vT[n]), this.privProperties.setProperty(ke.PronunciationAssessment_EnableMiscue, String(i));
    }
    static fromJSON(t) {
      nt.throwIfNullOrUndefined(t, "json");
      let r = new iCe("");
      return r.privProperties = new zn(), r.properties.setProperty(ke.PronunciationAssessment_Json, t), r;
    }
    toJSON() {
      return this.updateJson(), this.privProperties.getProperty(ke.PronunciationAssessment_Params);
    }
    applyTo(t) {
      this.updateJson(), t.internalData.speechContext.setPronunciationAssessmentParams(this.properties.getProperty(ke.PronunciationAssessment_Params));
    }
    get referenceText() {
      return this.properties.getProperty(ke.PronunciationAssessment_ReferenceText);
    }
    set referenceText(t) {
      nt.throwIfNullOrWhitespace(t, "referenceText"), this.properties.setProperty(ke.PronunciationAssessment_ReferenceText, t);
    }
    get properties() {
      return this.privProperties;
    }
    updateJson() {
      let t = this.privProperties.getProperty(ke.PronunciationAssessment_Json, "{}"), r = JSON.parse(t), n = this.privProperties.getProperty(ke.PronunciationAssessment_ReferenceText);
      n && (r.referenceText = n);
      let i = this.privProperties.getProperty(ke.PronunciationAssessment_GradingSystem);
      i && (r.gradingSystem = i);
      let o = this.privProperties.getProperty(ke.PronunciationAssessment_Granularity);
      o && (r.granularity = o), r.dimension = "Comprehensive";
      let a = this.privProperties.getProperty(ke.PronunciationAssessment_EnableMiscue);
      a === "true" ? r.enableMiscue = !0 : a === "false" && (r.enableMiscue = !1), this.privProperties.setProperty(ke.PronunciationAssessment_Params, JSON.stringify(r));
    }
  };
}), oCe, UCr = Qe(() => {
  rn(), Kt(), oCe = class aCe {
    constructor(t) {
      let r = JSON.parse(t);
      nt.throwIfNullOrUndefined(r.NBest[0], "NBest"), this.privPronJson = r.NBest[0];
    }
    static fromResult(t) {
      nt.throwIfNullOrUndefined(t, "result");
      let r = t.properties.getProperty(ke.SpeechServiceResponse_JsonResult);
      return nt.throwIfNullOrUndefined(r, "json"), new aCe(r);
    }
    get detailResult() {
      return this.privPronJson;
    }
    get accuracyScore() {
      return this.detailResult.PronunciationAssessment.AccuracyScore;
    }
    get pronunciationScore() {
      return this.detailResult.PronunciationAssessment.PronScore;
    }
    get completenessScore() {
      return this.detailResult.PronunciationAssessment.CompletenessScore;
    }
    get fluencyScore() {
      return this.detailResult.PronunciationAssessment.FluencyScore;
    }
  };
}), Kt = Qe(() => {
  hbr(), m0(), abe(), rv(), vbr(), Ebr(), mbr(), gbr(), Tbr(), ybr(), _br(), Abr(), Sbr(), bbr(), Cbr(), Ibr(), Obr(), Rbr(), wbr(), Pbr(), fbe(), Dbr(), xbr(), Nbr(), Lbr(), pbe(), p$(), Bbr(), kbr(), Mbr(), Fbr(), Hbr(), $br(), Ubr(), Vbr(), jbr(), zbr(), _be(), qbr(), Ybr(), Gbr(), Wbr(), Kbr(), Xbr(), g$(), Jbr(), Zbr(), eCr(), tCr(), nCr(), iCr(), oCr(), aCr(), uCr(), Cbe(), sCr(), cCr(), lCr(), fCr(), dCr(), pCr(), hCr(), vCr(), ECr(), mCr(), gCr(), TCr(), tCe(), ube(), PCr(), DCr(), xCr(), NCr(), LCr(), BCr(), kCr(), MCr(), FCr(), HCr(), $Cr(), UCr();
}), uCe, VCr = Qe(() => {
  hu(), Kt(), ov(), hr(), Tc(), uCe = class extends Ad {
    constructor() {
      super(...arguments), this.create = (e, t, r) => {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint);
        if (!n) {
          let u = e.parameters.getProperty(ke.SpeechServiceConnection_IntentRegion), s = u && u.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
          n = e.parameters.getProperty(ke.SpeechServiceConnection_Host, "wss://" + u + ".sr.speech" + s) + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        let i = { format: "simple", language: e.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage) };
        this.setCommonUrlParams(e, i, n);
        let o = {};
        t.token !== void 0 && t.token !== "" && (o[t.headerName] = t.token), o[wn.ConnectionId] = r, e.parameters.setProperty(ke.SpeechServiceConnection_Url, n);
        let a = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(n, i, o, new bd(), y0.fromRecognizerConfig(e), a, r);
      };
    }
    getSpeechRegionFromIntentRegion(e) {
      switch (e) {
        case "West US":
        case "US West":
        case "westus":
          return "uswest";
        case "West US 2":
        case "US West 2":
        case "westus2":
          return "uswest2";
        case "South Central US":
        case "US South Central":
        case "southcentralus":
          return "ussouthcentral";
        case "West Central US":
        case "US West Central":
        case "westcentralus":
          return "uswestcentral";
        case "East US":
        case "US East":
        case "eastus":
          return "useast";
        case "East US 2":
        case "US East 2":
        case "eastus2":
          return "useast2";
        case "West Europe":
        case "Europe West":
        case "westeurope":
          return "europewest";
        case "North Europe":
        case "Europe North":
        case "northeurope":
          return "europenorth";
        case "Brazil South":
        case "South Brazil":
        case "southbrazil":
          return "brazilsouth";
        case "Australia East":
        case "East Australia":
        case "eastaustralia":
          return "australiaeast";
        case "Southeast Asia":
        case "Asia Southeast":
        case "southeastasia":
          return "asiasoutheast";
        case "East Asia":
        case "Asia East":
        case "eastasia":
          return "asiaeast";
        default:
          return e;
      }
    }
  };
}), xg, x$, sCe, N$, cCe, que, L$ = Qe(() => {
  vr(), xg = class extends el {
    constructor(e, t, r, n = hn.Info) {
      super(e, n), this.privRequestId = t, this.privSessionId = r;
    }
    get requestId() {
      return this.privRequestId;
    }
    get sessionId() {
      return this.privSessionId;
    }
  }, x$ = class extends xg {
    constructor(e, t, r, n) {
      super("RecognitionTriggeredEvent", e, t), this.privAudioSourceId = r, this.privAudioNodeId = n;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
  }, sCe = class extends xg {
    constructor(e, t, r, n) {
      super("ListeningStartedEvent", e, t), this.privAudioSourceId = r, this.privAudioNodeId = n;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
  }, N$ = class extends xg {
    constructor(e, t, r) {
      super("ConnectingToServiceEvent", e, r), this.privAuthFetchEventid = t;
    }
    get authFetchEventid() {
      return this.privAuthFetchEventid;
    }
  }, cCe = class extends xg {
    constructor(e, t, r, n, i) {
      super("RecognitionStartedEvent", e, i), this.privAudioSourceId = t, this.privAudioNodeId = r, this.privAuthFetchEventId = n;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
    get authFetchEventId() {
      return this.privAuthFetchEventId;
    }
  }, function(e) {
    e[e.Success = 0] = "Success", e[e.AudioSourceError = 1] = "AudioSourceError", e[e.AudioSourceTimeout = 2] = "AudioSourceTimeout", e[e.AuthTokenFetchError = 3] = "AuthTokenFetchError", e[e.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", e[e.UnAuthorized = 5] = "UnAuthorized", e[e.ConnectTimeout = 6] = "ConnectTimeout", e[e.ConnectError = 7] = "ConnectError", e[e.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", e[e.UnknownError = 9] = "UnknownError";
  }(que || (que = {}));
}), Bi, E2 = Qe(() => {
  vr(), Tc(), Bi = class extends dT {
    constructor(e, t, r, n, i, o, a, u) {
      if (!t) throw new Ji("path");
      if (!r) throw new Ji("requestId");
      let s = {};
      if (s[wn.Path] = t, s[wn.RequestId] = r, s[wn.RequestTimestamp] = (/* @__PURE__ */ new Date()).toISOString(), n && (s[wn.ContentType] = n), o && (s[wn.RequestStreamId] = o), a) for (let c in a) c && (s[c] = a[c]);
      u ? super(e, i, s, u) : super(e, i, s), this.privPath = t, this.privRequestId = r, this.privContentType = n, this.privStreamId = o, this.privAdditionalHeaders = a;
    }
    get path() {
      return this.privPath;
    }
    get requestId() {
      return this.privRequestId;
    }
    get contentType() {
      return this.privContentType;
    }
    get streamId() {
      return this.privStreamId;
    }
    get additionalHeaders() {
      return this.privAdditionalHeaders;
    }
  }, Bi.fromConnectionMessage = (e) => {
    let t = null, r = null, n = null, i = null, o = {};
    if (e.headers) for (let a in e.headers) a && (a.toLowerCase() === wn.Path.toLowerCase() ? t = e.headers[a] : a.toLowerCase() === wn.RequestId.toLowerCase() ? r = e.headers[a] : a.toLowerCase() === wn.RequestTimestamp.toLowerCase() ? e.headers[a] : a.toLowerCase() === wn.ContentType.toLowerCase() ? n = e.headers[a] : a.toLowerCase() === wn.RequestStreamId.toLowerCase() ? i = e.headers[a] : o[a] = e.headers[a]);
    return new Bi(e.messageType, t, r, n, e.body, i, o, e.id);
  };
}), ji, ys, jCr = Qe(() => {
  hu(), vr(), Kt(), hr(), E2(), ji = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, ys = class h1 {
    constructor(t, r, n, i, o) {
      if (this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.recognizeOverride = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendSpeechContext = (a) => {
        let u = this.speechContext.toJSON();
        if (u) return a.send(new Bi(br.Text, "speech.context", this.privRequestSession.requestId, "application/json", u));
      }, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSpeechServiceConfig = (a, u, s) => {
        if (h1.telemetryDataEnabled !== !0) {
          let c = { context: { system: JSON.parse(s).context.system } };
          s = JSON.stringify(c);
        }
        if (this.privRecognizerConfig.parameters.getProperty("TranscriptionService_SingleChannel", "false").toLowerCase() === "true") {
          let c = JSON.parse(s);
          c.context.DisableReferenceChannel = "True", c.context.MicSpec = "1_0_0", s = JSON.stringify(c);
        }
        if (s) return a.send(new Bi(br.Text, "speech.config", u.requestId, "application/json", s));
      }, !t) throw new Ji("authentication");
      if (!r) throw new Ji("connectionFactory");
      if (!n) throw new Ji("audioSource");
      if (!i) throw new Ji("recognizerConfig");
      this.privMustReportEndOfStream = !1, this.privAuthentication = t, this.privConnectionFactory = r, this.privAudioSource = n, this.privRecognizerConfig = i, this.privIsDisposed = !1, this.privRecognizer = o, this.privRequestSession = new xCe(this.privAudioSource.id()), this.privConnectionEvents = new su(), this.privServiceEvents = new su(), this.privDynamicGrammar = new LCe(), this.privSpeechContext = new NCe(this.privDynamicGrammar), this.privAgentConfig = new k$(), typeof Blob < "u" && typeof Worker < "u" && (this.privSetTimeout = Ni.setTimeout), this.connectionEvents.attach((a) => ji(this, void 0, void 0, function* () {
        if (a.name === "ConnectionClosedEvent") {
          let u = a;
          (u.statusCode === 1003 || u.statusCode === 1007 || u.statusCode === 1002 || u.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) && (yield this.cancelRecognitionLocal(oi.Error, u.statusCode === 1007 ? dr.BadRequestParameters : dr.ConnectionFailure, u.reason + " websocket error code: " + u.statusCode));
        }
      }));
    }
    get audioSource() {
      return this.privAudioSource;
    }
    get speechContext() {
      return this.privSpeechContext;
    }
    get dynamicGrammar() {
      return this.privDynamicGrammar;
    }
    get agentConfig() {
      return this.privAgentConfig;
    }
    set conversationTranslatorToken(t) {
      this.privRecognizerConfig.parameters.setProperty(ke.ConversationTranslator_Token, t);
    }
    set authentication(t) {
      this.privAuthentication = this.authentication;
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose(t) {
      return ji(this, void 0, void 0, function* () {
        if (this.privIsDisposed = !0, this.privConnectionConfigurationPromise) try {
          yield (yield this.privConnectionConfigurationPromise).dispose(t);
        } catch {
          return;
        }
      });
    }
    get connectionEvents() {
      return this.privConnectionEvents;
    }
    get serviceEvents() {
      return this.privServiceEvents;
    }
    get recognitionMode() {
      return this.privRecognizerConfig.recognitionMode;
    }
    recognize(t, r, n) {
      return ji(this, void 0, void 0, function* () {
        if (this.recognizeOverride !== void 0) return this.recognizeOverride(t, r, n);
        this.privConnectionConfigurationPromise = null, this.privRecognizerConfig.recognitionMode = t, this.privSuccessCallback = r, this.privErrorCallback = n, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
        let i = this.connectImpl(), o;
        try {
          let u = yield this.audioSource.attach(this.privRequestSession.audioNodeId), s = yield this.audioSource.format, c = yield this.audioSource.deviceInfo;
          this.privIsLiveAudio = c.type && c.type === tl.Microphones, o = new V$(u, s.avgBytesPerSec), yield this.privRequestSession.onAudioSourceAttachCompleted(o, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: c };
        } catch (u) {
          throw yield this.privRequestSession.onStopRecognizing(), u;
        }
        try {
          yield i;
        } catch (u) {
          yield this.cancelRecognitionLocal(oi.Error, dr.ConnectionFailure, u);
          return;
        }
        let a = new $o(this.privRequestSession.sessionId);
        this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, a), this.receiveMessage(), this.sendAudio(o).catch((u) => ji(this, void 0, void 0, function* () {
          yield this.cancelRecognitionLocal(oi.Error, dr.RuntimeError, u);
        }));
      });
    }
    stopRecognizing() {
      return ji(this, void 0, void 0, function* () {
        if (this.privRequestSession.isRecognizing) try {
          yield this.audioSource.turnOff(), yield this.sendFinalAudio(), yield this.privRequestSession.onStopRecognizing(), yield this.privRequestSession.turnCompletionPromise;
        } finally {
          yield this.privRequestSession.dispose();
        }
      });
    }
    connect() {
      return ji(this, void 0, void 0, function* () {
        return yield this.connectImpl(), Promise.resolve();
      });
    }
    connectAsync(t, r) {
      this.connectImpl().then((n) => {
        try {
          t && t();
        } catch (i) {
          r && r(i);
        }
      }, (n) => {
        try {
          r && r(n);
        } catch {
        }
      });
    }
    disconnect() {
      return ji(this, void 0, void 0, function* () {
        yield this.cancelRecognitionLocal(oi.Error, dr.NoError, "Disconnecting"), this.disconnectOverride !== void 0 && (yield this.disconnectOverride());
        try {
          yield (yield this.privConnectionPromise).dispose();
        } catch {
        }
        this.privConnectionPromise = null;
      });
    }
    sendMessage(t) {
    }
    sendNetworkMessage(t, r) {
      return ji(this, void 0, void 0, function* () {
        let n = typeof r == "string" ? br.Text : br.Binary, i = typeof r == "string" ? "application/json" : "";
        return (yield this.fetchConnection()).send(new Bi(n, t, this.privRequestSession.requestId, i, r));
      });
    }
    set activityTemplate(t) {
      this.privActivityTemplate = t;
    }
    get activityTemplate() {
      return this.privActivityTemplate;
    }
    sendTelemetryData() {
      return ji(this, void 0, void 0, function* () {
        let t = this.privRequestSession.getTelemetry();
        if (!(h1.telemetryDataEnabled !== !0 || this.privIsDisposed || t === null)) {
          if (h1.telemetryData) try {
            h1.telemetryData(t);
          } catch {
          }
          yield (yield this.fetchConnection()).send(new Bi(br.Text, "telemetry", this.privRequestSession.requestId, "application/json", t));
        }
      });
    }
    cancelRecognitionLocal(t, r, n) {
      return ji(this, void 0, void 0, function* () {
        this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, t, r, n));
      });
    }
    receiveMessage() {
      return ji(this, void 0, void 0, function* () {
        try {
          if (this.privIsDisposed) return;
          let t = yield this.fetchConnection(), r = yield t.read();
          if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
          if (!r) return this.privRequestSession.isRecognizing ? this.receiveMessage() : void 0;
          this.privServiceHasSentMessage = !0;
          let n = Bi.fromConnectionMessage(r);
          if (n.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch (n.path.toLowerCase()) {
            case "turn.start":
              this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse();
              break;
            case "speech.startdetected":
              let i = gT.fromJSON(n.textBody), o = new Ts(i.Offset, this.privRequestSession.sessionId);
              this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, o);
              break;
            case "speech.enddetected":
              let a;
              n.textBody.length > 0 ? a = n.textBody : a = "{ Offset: 0 }";
              let u = gT.fromJSON(a);
              this.privRecognizerConfig.isContinuousRecognition && this.privRequestSession.onServiceRecognized(u.Offset + this.privRequestSession.currentTurnAudioOffset);
              let s = new Ts(u.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
              this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, s);
              break;
            case "turn.end":
              yield this.sendTelemetryData(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream && (this.privMustReportEndOfStream = !1, yield this.cancelRecognitionLocal(oi.EndOfStream, dr.NoError, void 0));
              let c = new $o(this.privRequestSession.sessionId);
              if (yield this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, c);
                return;
              } else t = yield this.fetchConnection(), yield this.sendPrePayloadJSON(t);
              break;
            default:
              (yield this.processTypeSpecificMessages(n)) || this.privServiceEvents && this.serviceEvents.onEvent(new a2(n.path.toLowerCase(), n.textBody));
          }
          return this.receiveMessage();
        } catch {
          return null;
        }
      });
    }
    sendPrePayloadJSON(t) {
      return ji(this, void 0, void 0, function* () {
        if (this.sendPrePayloadJSONOverride !== void 0) return this.sendPrePayloadJSONOverride(t);
        yield this.sendSpeechContext(t), yield this.sendWaveHeader(t);
      });
    }
    sendWaveHeader(t) {
      return ji(this, void 0, void 0, function* () {
        let r = yield this.audioSource.format;
        return t.send(new Bi(br.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", r.header));
      });
    }
    connectImpl() {
      return this.privConnectionPromise ? this.privConnectionPromise.then((t) => t.state() === qi.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, (t) => (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl())) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(() => {
      }), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
    }
    fetchConnection() {
      return ji(this, void 0, void 0, function* () {
        return this.privConnectionConfigurationPromise ? this.privConnectionConfigurationPromise.then((t) => t.state() === qi.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, (t) => (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
      });
    }
    sendAudio(t) {
      return ji(this, void 0, void 0, function* () {
        let r = yield this.audioSource.format, n = Date.now(), i = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), o = r.avgBytesPerSec / 1e3 * parseInt(i, 10), a = this.privRequestSession.recogNumber, u = () => ji(this, void 0, void 0, function* () {
          if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a) {
            let s = yield this.fetchConnection(), c = yield t.read();
            if (this.privRequestSession.isSpeechEnded) return;
            let l, f;
            if (!c || c.isEnd ? (l = null, f = 0) : (l = c.buffer, this.privRequestSession.onAudioSent(l.byteLength), o >= this.privRequestSession.bytesSent ? f = 0 : f = Math.max(0, n - Date.now())), f !== 0 && (yield this.delay(f)), l !== null && (n = Date.now() + l.byteLength * 1e3 / (r.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === a) if (s.send(new Bi(br.Binary, "audio", this.privRequestSession.requestId, null, l)).catch(() => {
              this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(() => {
              });
            }), c == null ? void 0 : c.isEnd) this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
            else return u();
          }
        });
        return u();
      });
    }
    retryableConnect() {
      return ji(this, void 0, void 0, function* () {
        let t = !1;
        this.privAuthFetchEventId = jn();
        let r = this.privRequestSession.sessionId;
        this.privConnectionId = r !== void 0 ? r : jn(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        let n = 0, i = "";
        for (; this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount; ) {
          let o = yield t ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
          yield this.privRequestSession.onAuthCompleted(!1);
          let a = this.privConnectionFactory.create(this.privRecognizerConfig, o, this.privConnectionId);
          this.privRequestSession.listenForServiceTelemetry(a.events), a.events.attach((s) => {
            this.connectionEvents.onEvent(s);
          });
          let u = yield a.open();
          if (u.statusCode === 200) return yield this.privRequestSession.onConnectionEstablishCompleted(u.statusCode), Promise.resolve(a);
          u.statusCode === 1006 && (t = !0), n = u.statusCode, i = u.reason, this.privRequestSession.onRetryConnection();
        }
        return yield this.privRequestSession.onConnectionEstablishCompleted(n, i), Promise.reject(`Unable to contact server. StatusCode: ${n}, ${this.privRecognizerConfig.parameters.getProperty(ke.SpeechServiceConnection_Endpoint)} Reason: ${i}`);
      });
    }
    delay(t) {
      return new Promise((r, n) => {
        this.privSetTimeout(r, t);
      });
    }
    writeBufferToConsole(t) {
      let r = "Buffer Size: ";
      if (t === null) r += "null";
      else {
        let n = new Uint8Array(t);
        r += t.byteLength + `\r
`;
        for (let i = 0; i < t.byteLength; i++) r += n[i].toString(16).padStart(2, "0") + " ";
      }
      console.info(r);
    }
    sendFinalAudio() {
      return ji(this, void 0, void 0, function* () {
        yield (yield this.fetchConnection()).send(new Bi(br.Binary, "audio", this.privRequestSession.requestId, null, null));
      });
    }
    configureConnection() {
      return ji(this, void 0, void 0, function* () {
        let t = yield this.connectImpl();
        return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(t) : (yield this.sendSpeechServiceConfig(t, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendPrePayloadJSON(t), t);
      });
    }
  }, ys.telemetryDataEnabled = !0;
}), Qo, Yue, Sd, ET, t0, Gue, e_, r0, tl, zCr = Qe(() => {
  Kt(), function(e) {
    e[e.Interactive = 0] = "Interactive", e[e.Conversation = 1] = "Conversation", e[e.Dictation = 2] = "Dictation";
  }(Qo || (Qo = {})), function(e) {
    e[e.Simple = 0] = "Simple", e[e.Detailed = 1] = "Detailed";
  }(Yue || (Yue = {})), Sd = class {
    constructor(e, t) {
      this.privRecognitionMode = Qo.Interactive, this.privSpeechServiceConfig = e || new ET(new t0(null)), this.privParameters = t, this.privMaxRetryCount = parseInt(t.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
    }
    get parameters() {
      return this.privParameters;
    }
    get recognitionMode() {
      return this.privRecognitionMode;
    }
    set recognitionMode(e) {
      this.privRecognitionMode = e, this.privRecognitionActivityTimeout = e === Qo.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = Qo[e];
    }
    get SpeechServiceConfig() {
      return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
      return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
      return this.privRecognitionMode !== Qo.Interactive;
    }
    get autoDetectSourceLanguages() {
      return this.parameters.getProperty(ke.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
    }
    get maxRetryCount() {
      return this.privMaxRetryCount;
    }
  }, ET = class {
    constructor(e) {
      this.serialize = () => JSON.stringify(this, (t, r) => {
        if (r && typeof r == "object") {
          let n = {};
          for (let i in r) Object.hasOwnProperty.call(r, i) && (n[i && i.charAt(0).toLowerCase() + i.substring(1)] = r[i]);
          return n;
        }
        return r;
      }), this.context = e;
    }
    get Context() {
      return this.context;
    }
    get Recognition() {
      return this.recognition;
    }
    set Recognition(e) {
      this.recognition = e.toLowerCase();
    }
  }, t0 = class {
    constructor(e) {
      this.system = new Gue(), this.os = e;
    }
  }, Gue = class {
    constructor() {
      let e = "1.17.0";
      this.name = "SpeechSDK", this.version = e, this.build = "JavaScript", this.lang = "JavaScript";
    }
  }, e_ = class {
    constructor(e, t, r) {
      this.platform = e, this.name = t, this.version = r;
    }
  }, function(e) {
    e.Bluetooth = "Bluetooth", e.Wired = "Wired", e.WiFi = "WiFi", e.Cellular = "Cellular", e.InBuilt = "InBuilt", e.Unknown = "Unknown";
  }(r0 || (r0 = {})), function(e) {
    e.Phone = "Phone", e.Speaker = "Speaker", e.Car = "Car", e.Headset = "Headset", e.Thermostat = "Thermostat", e.Microphones = "Microphones", e.Deskphone = "Deskphone", e.RemoteControl = "RemoteControl", e.Unknown = "Unknown", e.File = "File", e.Stream = "Stream";
  }(tl || (tl = {}));
}), qCr = Qe(() => {
}), P5, bd, YCr = Qe(() => {
  vr(), P5 = `\r
`, bd = class {
    constructor() {
      this.toConnectionMessage = (e) => {
        let t = new Kn();
        try {
          if (e.messageType === br.Text) {
            let r = e.textContent, n = {}, i = null;
            if (r) {
              let o = r.split(`\r
\r
`);
              o && o.length > 0 && (n = this.parseHeaders(o[0]), o.length > 1 && (i = o[1]));
            }
            t.resolve(new dT(e.messageType, i, n, e.id));
          } else if (e.messageType === br.Binary) {
            let r = e.binaryContent, n = {}, i = null;
            if (!r || r.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
            let o = new DataView(r), a = o.getInt16(0);
            if (r.byteLength < a + 2) throw new Error("Invalid binary message format. Header content missing.");
            let u = "";
            for (let s = 0; s < a; s++) u += String.fromCharCode(o.getInt8(s + 2));
            n = this.parseHeaders(u), r.byteLength > a + 2 && (i = r.slice(2 + a)), t.resolve(new dT(e.messageType, i, n, e.id));
          }
        } catch (r) {
          t.reject(`Error formatting the message. Error: ${r}`);
        }
        return t.promise;
      }, this.fromConnectionMessage = (e) => {
        let t = new Kn();
        try {
          if (e.messageType === br.Text) {
            let r = `${this.makeHeaders(e)}${P5}${e.textBody ? e.textBody : ""}`;
            t.resolve(new uh(br.Text, r, e.id));
          } else if (e.messageType === br.Binary) {
            let r = this.makeHeaders(e), n = e.binaryBody, i = this.stringToArrayBuffer(r), o = new Int8Array(i), a = o.byteLength, u = new Int8Array(2 + a + (n ? n.byteLength : 0));
            if (u[0] = a >> 8 & 255, u[1] = a & 255, u.set(o, 2), n) {
              let c = new Int8Array(n);
              u.set(c, 2 + a);
            }
            let s = u.buffer;
            t.resolve(new uh(br.Binary, s, e.id));
          }
        } catch (r) {
          t.reject(`Error formatting the message. ${r}`);
        }
        return t.promise;
      }, this.makeHeaders = (e) => {
        let t = "";
        if (e.headers) for (let r in e.headers) r && (t += `${r}: ${e.headers[r]}${P5}`);
        return t;
      }, this.parseHeaders = (e) => {
        let t = {};
        if (e) {
          let r = e.match(/[^\r\n]+/g);
          if (t) {
            for (let n of r) if (n) {
              let i = n.indexOf(":"), o = i > 0 ? n.substr(0, i).trim().toLowerCase() : n, a = i > 0 && n.length > i + 1 ? n.substr(i + 1).trim() : "";
              t[o] = a;
            }
          }
        }
        return t;
      }, this.stringToArrayBuffer = (e) => {
        let t = new ArrayBuffer(e.length), r = new DataView(t);
        for (let n = 0; n < e.length; n++) r.setUint8(n, e.charCodeAt(n));
        return t;
      };
    }
  };
}), lCe, GCr = Qe(() => {
  hu(), hr(), Kt(), ov(), hr(), Tc(), iv(), lCe = class extends Ad {
    constructor() {
      super(...arguments), this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1", this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1", this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1", this.create = (e, t, r) => {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, void 0), i = e.parameters.getProperty(ke.SpeechServiceConnection_Region, void 0), o = i && i.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", a = e.parameters.getProperty(ke.SpeechServiceConnection_Host, "wss://" + i + ".stt.speech" + o), u = {}, s = e.parameters.getProperty(ke.SpeechServiceConnection_EndpointId, void 0), c = e.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage, void 0);
        if (s ? (!n || n.search(jr.CustomSpeechDeploymentId) === -1) && (u[jr.CustomSpeechDeploymentId] = s) : c && (!n || n.search(jr.Language) === -1) && (u[jr.Language] = c), (!n || n.search(jr.Format) === -1) && (u[jr.Format] = e.parameters.getProperty(nc, vi[vi.Simple]).toLowerCase()), e.autoDetectSourceLanguages !== void 0 && (u[jr.EnableLanguageId] = "true"), this.setCommonUrlParams(e, u, n), !n) switch (e.recognitionMode) {
          case Qo.Conversation:
            e.parameters.getProperty(m2, "false") === "true" ? n = a + this.dictationRelativeUri : n = a + this.conversationRelativeUri;
            break;
          case Qo.Dictation:
            n = a + this.dictationRelativeUri;
            break;
          default:
            n = a + this.interactiveRelativeUri;
            break;
        }
        let l = {};
        t.token !== void 0 && t.token !== "" && (l[t.headerName] = t.token), l[wn.ConnectionId] = r, e.parameters.setProperty(ke.SpeechServiceConnection_Url, n);
        let f = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(n, u, l, new bd(), y0.fromRecognizerConfig(e), f, r);
      };
    }
  };
}), fCe, WCr = Qe(() => {
  hu(), Kt(), ov(), hr(), Tc(), iv(), fCe = class extends Ad {
    constructor() {
      super(...arguments), this.multiaudioRelativeUri = "/speech/recognition/multiaudio", this.create = (e, t, r) => {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, void 0), i = e.parameters.getProperty(ke.SpeechServiceConnection_Region, "centralus"), o = i && i.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", a = "wss://transcribe." + i + ".cts.speech" + o + this.multiaudioRelativeUri, u = e.parameters.getProperty(ke.SpeechServiceConnection_Host, a), s = {}, c = e.parameters.getProperty(ke.SpeechServiceConnection_EndpointId, void 0), l = e.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage, void 0);
        c ? (!n || n.search(jr.CustomSpeechDeploymentId) === -1) && (s[jr.CustomSpeechDeploymentId] = c) : l && (!n || n.search(jr.Language) === -1) && (s[jr.Language] = l), this.setCommonUrlParams(e, s, n), n || (n = u);
        let f = {};
        t.token !== void 0 && t.token !== "" && (f[t.headerName] = t.token), f[wn.ConnectionId] = r, e.parameters.setProperty(ke.SpeechServiceConnection_Url, n);
        let d = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(n, s, f, new bd(), y0.fromRecognizerConfig(e), d, r);
      };
    }
  };
}), dCe, KCr = Qe(() => {
  hu(), Kt(), ov(), hr(), Tc(), iv(), dCe = class extends Ad {
    constructor() {
      super(...arguments), this.create = (e, t, r) => {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, void 0);
        if (!n) {
          let c = e.parameters.getProperty(ke.SpeechServiceConnection_Region, void 0), l = c && c.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
          n = e.parameters.getProperty(ke.SpeechServiceConnection_Host, "wss://" + c + ".s2s.speech" + l) + "/speech/translation/cognitiveservices/v1";
        }
        let i = { from: e.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage), to: e.parameters.getProperty(ke.SpeechServiceConnection_TranslationToLanguages) };
        this.setCommonUrlParams(e, i, n), this.setUrlParameter(ke.SpeechServiceResponse_TranslationRequestStablePartialResult, jr.StableTranslation, e, i, n);
        let o = "voice", a = "features";
        e.parameters.getProperty(ke.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && (i[o] = e.parameters.getProperty(ke.SpeechServiceConnection_TranslationVoice), i[a] = "texttospeech");
        let u = {};
        t.token !== void 0 && t.token !== "" && (u[t.headerName] = t.token), u[wn.ConnectionId] = r, e.parameters.setProperty(ke.SpeechServiceConnection_Url, n);
        let s = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(n, i, u, new bd(), y0.fromRecognizerConfig(e), s, r);
      };
    }
  };
}), pCe, XCr = Qe(() => {
  hu(), Kt(), hr(), Tc(), iv(), pCe = class {
    constructor() {
      this.synthesisUri = "/cognitiveservices/websocket/v1", this.create = (e, t, r) => {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, void 0), i = e.parameters.getProperty(ke.SpeechServiceConnection_Region, void 0), o = i && i.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com", a = e.parameters.getProperty(ke.SpeechServiceConnection_EndpointId, void 0), u = a === void 0 ? "tts" : "voice", s = e.parameters.getProperty(ke.SpeechServiceConnection_Host, "wss://" + i + "." + u + ".speech" + o), c = {};
        n || (n = s + this.synthesisUri);
        let l = {};
        t.token !== void 0 && t.token !== "" && (l[t.headerName] = t.token), l[wn.ConnectionId] = r, a !== void 0 && (l[jr.CustomVoiceDeploymentId] = a), e.parameters.setProperty(ke.SpeechServiceConnection_Url, n);
        let f = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new T0(n, c, l, new bd(), y0.fromParameters(e.parameters), f, r);
      };
    }
  };
}), au, JCr = Qe(() => {
  Kt(), hr(), au = class {
    static implTranslateRecognitionResult(e) {
      let t = or.Canceled;
      switch (e) {
        case Ln.Success:
          t = or.RecognizedSpeech;
          break;
        case Ln.NoMatch:
        case Ln.InitialSilenceTimeout:
        case Ln.BabbleTimeout:
        case Ln.EndOfDictation:
          t = or.NoMatch;
          break;
        case Ln.Error:
        default:
          t = or.Canceled;
          break;
      }
      return t;
    }
    static implTranslateCancelResult(e) {
      let t = oi.EndOfStream;
      switch (e) {
        case Ln.Success:
        case Ln.EndOfDictation:
        case Ln.NoMatch:
          t = oi.EndOfStream;
          break;
        case Ln.InitialSilenceTimeout:
        case Ln.BabbleTimeout:
        case Ln.Error:
        default:
          t = oi.Error;
          break;
      }
      return t;
    }
    static implTranslateCancelErrorCode(e) {
      let t = dr.NoError;
      switch (e) {
        case Ln.Error:
          t = dr.ServiceError;
          break;
        case Ln.TooManyRequests:
          t = dr.TooManyRequests;
          break;
        default:
          t = dr.NoError;
          break;
      }
      return t;
    }
  };
}), mT, Ln, ZCr = Qe(() => {
  (function(e) {
    e[e.Success = 0] = "Success", e[e.SynthesisEnd = 1] = "SynthesisEnd", e[e.Error = 2] = "Error";
  })(mT || (mT = {})), function(e) {
    e[e.Success = 0] = "Success", e[e.NoMatch = 1] = "NoMatch", e[e.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", e[e.BabbleTimeout = 3] = "BabbleTimeout", e[e.Error = 4] = "Error", e[e.EndOfDictation = 5] = "EndOfDictation", e[e.TooManyRequests = 6] = "TooManyRequests";
  }(Ln || (Ln = {}));
}), hCe, QCr = Qe(() => {
  hr(), hCe = class vCe {
    constructor(t) {
      this.privSynthesisEnd = JSON.parse(t), this.privSynthesisEnd.SynthesisStatus = mT[this.privSynthesisEnd.SynthesisStatus];
    }
    static fromJSON(t) {
      return new vCe(t);
    }
    get SynthesisStatus() {
      return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
      return this.privSynthesisEnd.FailureReason;
    }
  };
}), ECe, e3r = Qe(() => {
  a$(), ECe = class mCe {
    constructor(t) {
      this.privTranslationHypothesis = JSON.parse(t), this.privTranslationHypothesis.Translation.TranslationStatus = pT[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(t) {
      return new mCe(t);
    }
    get Duration() {
      return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
      return this.privTranslationHypothesis.Offset;
    }
    get Text() {
      return this.privTranslationHypothesis.Text;
    }
    get Translation() {
      return this.privTranslationHypothesis.Translation;
    }
  };
}), b8, t3r = Qe(() => {
  hr(), a$(), b8 = class gCe {
    constructor(t) {
      this.privTranslationPhrase = JSON.parse(t), this.privTranslationPhrase.RecognitionStatus = Ln[this.privTranslationPhrase.RecognitionStatus], this.privTranslationPhrase.Translation !== void 0 && (this.privTranslationPhrase.Translation.TranslationStatus = pT[this.privTranslationPhrase.Translation.TranslationStatus]);
    }
    static fromJSON(t) {
      return new gCe(t);
    }
    get RecognitionStatus() {
      return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
      return this.privTranslationPhrase.Offset;
    }
    get Duration() {
      return this.privTranslationPhrase.Duration;
    }
    get Text() {
      return this.privTranslationPhrase.Text;
    }
    get Translation() {
      return this.privTranslationPhrase.Translation;
    }
  };
}), D5, TCe, r3r = Qe(() => {
  vr(), Kt(), hr(), D5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, TCe = class extends ys {
    constructor(e, t, r, n, i) {
      super(e, t, r, n, i), this.privTranslationRecognizer = i, this.connectionEvents.attach((o) => D5(this, void 0, void 0, function* () {
        o.name === "ConnectionEstablishedEvent" ? this.privTranslationRecognizer.onConnection() : o.name === "ConnectionClosedEvent" && (yield this.privTranslationRecognizer.onDisconnection());
      }));
    }
    processTypeSpecificMessages(e) {
      return D5(this, void 0, void 0, function* () {
        let t = new zn(), r = !1;
        switch (e.messageType === br.Text && t.setProperty(ke.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()) {
          case "translation.hypothesis":
            let n = this.fireEventForResult(ECe.fromJSON(e.textBody), t);
            if (this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + n.offset), this.privTranslationRecognizer.recognizing) try {
              this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, n);
            } catch {
            }
            r = !0;
            break;
          case "translation.phrase":
            let i = b8.fromJSON(e.textBody);
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + i.Offset + i.Duration), i.RecognitionStatus === Ln.Success) {
              let a = this.fireEventForResult(i, t);
              if (this.privTranslationRecognizer.recognized) try {
                this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, a);
              } catch {
              }
              if (this.privSuccessCallback) {
                try {
                  this.privSuccessCallback(a.result);
                } catch (u) {
                  this.privErrorCallback && this.privErrorCallback(u);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
              }
              break;
            } else {
              let a = au.implTranslateRecognitionResult(i.RecognitionStatus), u = new Dp(void 0, this.privRequestSession.requestId, a, i.Text, i.Duration, this.privRequestSession.currentTurnAudioOffset + i.Offset, void 0, e.textBody, t);
              if (a === or.Canceled) {
                let s = au.implTranslateCancelResult(i.RecognitionStatus);
                yield this.cancelRecognitionLocal(s, au.implTranslateCancelErrorCode(i.RecognitionStatus), void 0);
              } else {
                if (!(this.privRequestSession.isSpeechEnded && a === or.NoMatch && i.RecognitionStatus !== Ln.InitialSilenceTimeout)) {
                  let s = new Eb(u, u.offset, this.privRequestSession.sessionId);
                  if (this.privTranslationRecognizer.recognized) try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, s);
                  } catch {
                  }
                }
                if (this.privSuccessCallback) {
                  try {
                    this.privSuccessCallback(u);
                  } catch (s) {
                    this.privErrorCallback && this.privErrorCallback(s);
                  }
                  this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                }
              }
            }
            r = !0;
            break;
          case "translation.synthesis":
            this.sendSynthesisAudio(e.binaryBody, this.privRequestSession.sessionId), r = !0;
            break;
          case "translation.synthesis.end":
            let o = hCe.fromJSON(e.textBody);
            switch (o.SynthesisStatus) {
              case mT.Error:
                if (this.privTranslationRecognizer.synthesizing) {
                  let a = new gb(or.Canceled, void 0), u = new mb(a, this.privRequestSession.sessionId);
                  try {
                    this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, u);
                  } catch {
                  }
                }
                if (this.privTranslationRecognizer.canceled) {
                  let a = new _b(this.privRequestSession.sessionId, oi.Error, o.FailureReason, dr.ServiceError, null);
                  try {
                    this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, a);
                  } catch {
                  }
                }
                break;
              case mT.Success:
                this.sendSynthesisAudio(void 0, this.privRequestSession.sessionId);
                break;
            }
            r = !0;
            break;
        }
        return r;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      let o = new zn();
      if (o.setProperty(Fa, dr[n]), this.privTranslationRecognizer.canceled) {
        let a = new _b(e, r, i, n, void 0);
        try {
          this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, a);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        let a = new Dp(void 0, t, or.Canceled, void 0, void 0, void 0, i, void 0, o);
        try {
          this.privSuccessCallback(a), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
    fireEventForResult(e, t) {
      let r;
      if (e.Translation.Translations !== void 0) {
        r = new p2();
        for (let a of e.Translation.Translations) r.set(a.Language, a.Text);
      }
      let n;
      e instanceof b8 ? e.Translation.TranslationStatus === pT.Success ? n = or.TranslatedSpeech : n = or.RecognizedSpeech : n = or.TranslatingSpeech;
      let i = e.Offset + this.privRequestSession.currentTurnAudioOffset, o = new Dp(r, this.privRequestSession.requestId, n, e.Text, e.Duration, i, e.Translation.FailureReason, JSON.stringify(e), t);
      return new Eb(o, i, this.privRequestSession.sessionId);
    }
    sendSynthesisAudio(e, t) {
      let r = e === void 0 ? or.SynthesizingAudioCompleted : or.SynthesizingAudio, n = new gb(r, e), i = new mb(n, t);
      if (this.privTranslationRecognizer.synthesizing) try {
        this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, i);
      } catch {
      }
    }
  };
}), gT, n3r = Qe(() => {
  gT = class yCe {
    constructor(t) {
      this.privSpeechStartDetected = JSON.parse(t);
    }
    static fromJSON(t) {
      return new yCe(t);
    }
    get Offset() {
      return this.privSpeechStartDetected.Offset;
    }
  };
}), t_, i3r = Qe(() => {
  t_ = class _Ce {
    constructor(t) {
      this.privSpeechHypothesis = JSON.parse(t);
    }
    static fromJSON(t) {
      return new _Ce(t);
    }
    get Text() {
      return this.privSpeechHypothesis.Text;
    }
    get Offset() {
      return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
      return this.privSpeechHypothesis.Duration;
    }
    get Language() {
      return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
      return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
      return this.privSpeechHypothesis.SpeakerId;
    }
  };
}), ACe, o3r = Qe(() => {
  ACe = class SCe {
    constructor(t) {
      this.privSpeechKeyword = JSON.parse(t);
    }
    static fromJSON(t) {
      return new SCe(t);
    }
    get Status() {
      return this.privSpeechKeyword.Status;
    }
    get Text() {
      return this.privSpeechKeyword.Text;
    }
    get Offset() {
      return this.privSpeechKeyword.Offset;
    }
    get Duration() {
      return this.privSpeechKeyword.Duration;
    }
  };
}), Wue, bCe, a3r = Qe(() => {
  Kt(), hr(), Wue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, bCe = class extends ys {
    constructor(e, t, r, n, i) {
      if (super(e, t, r, n, i), this.privSpeechRecognizer = i, n.autoDetectSourceLanguages !== void 0) {
        let o = n.autoDetectSourceLanguages.split(",");
        this.privSpeechContext.setSection("languageId", { languages: o, onSuccess: { action: "Recognize" }, onUnknown: { action: "None" } }), this.privSpeechContext.setSection("phraseOutput", { interimResults: { resultType: "Auto" }, phraseResults: { resultType: "Always" } });
      }
    }
    processTypeSpecificMessages(e) {
      return Wue(this, void 0, void 0, function* () {
        let t, r = new zn();
        r.setProperty(ke.SpeechServiceResponse_JsonResult, e.textBody);
        let n = !1;
        switch (e.path.toLowerCase()) {
          case "speech.hypothesis":
          case "speech.fragment":
            let i = t_.fromJSON(e.textBody), o = i.Offset + this.privRequestSession.currentTurnAudioOffset;
            t = new ra(this.privRequestSession.requestId, or.RecognizingSpeech, i.Text, i.Duration, o, i.Language, i.LanguageDetectionConfidence, void 0, void 0, e.textBody, r), this.privRequestSession.onHypothesis(o);
            let a = new tc(t, i.Duration, this.privRequestSession.sessionId);
            if (this.privSpeechRecognizer.recognizing) try {
              this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, a);
            } catch {
            }
            n = !0;
            break;
          case "speech.phrase":
            let u = Cd.fromJSON(e.textBody), s = au.implTranslateRecognitionResult(u.RecognitionStatus);
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + u.Offset + u.Duration), or.Canceled === s) {
              let c = au.implTranslateCancelResult(u.RecognitionStatus);
              yield this.cancelRecognitionLocal(c, au.implTranslateCancelErrorCode(u.RecognitionStatus), void 0);
            } else {
              if (!(this.privRequestSession.isSpeechEnded && s === or.NoMatch && u.RecognitionStatus !== Ln.InitialSilenceTimeout)) {
                if (this.privRecognizerConfig.parameters.getProperty(nc) === vi[vi.Simple]) t = new ra(this.privRequestSession.requestId, s, u.DisplayText, u.Duration, u.Offset + this.privRequestSession.currentTurnAudioOffset, u.Language, u.LanguageDetectionConfidence, void 0, void 0, e.textBody, r);
                else {
                  let l = B$.fromJSON(e.textBody);
                  t = new ra(this.privRequestSession.requestId, s, l.RecognitionStatus === Ln.Success ? l.NBest[0].Display : void 0, l.Duration, l.Offset + this.privRequestSession.currentTurnAudioOffset, l.Language, l.LanguageDetectionConfidence, void 0, void 0, e.textBody, r);
                }
                let c = new tc(t, t.offset, this.privRequestSession.sessionId);
                if (this.privSpeechRecognizer.recognized) try {
                  this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, c);
                } catch {
                }
              }
              if (this.privSuccessCallback) {
                try {
                  this.privSuccessCallback(t);
                } catch (c) {
                  this.privErrorCallback && this.privErrorCallback(c);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
              }
            }
            n = !0;
            break;
        }
        return n;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      let o = new zn();
      if (o.setProperty(Fa, dr[n]), this.privSpeechRecognizer.canceled) {
        let a = new d2(r, i, n, void 0, e);
        try {
          this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, a);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        let a = new ra(t, or.Canceled, void 0, void 0, void 0, void 0, void 0, void 0, i, void 0, o);
        try {
          this.privSuccessCallback(a), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
  };
}), u4, CCe, u3r = Qe(() => {
  vr(), Kt(), hr(), E2(), u4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, CCe = class extends ys {
    constructor(e, t, r, n, i) {
      super(e, t, r, n, i), this.sendSpeechEvent = (o, a) => {
        let u = JSON.stringify(a);
        if (u) return o.send(new Bi(br.Text, "speech.event", this.privRequestSession.requestId, "application/json", u));
      }, this.privTranscriberRecognizer = i, this.sendPrePayloadJSONOverride = this.sendTranscriptionStartJSON;
    }
    sendSpeechEventAsync(e, t) {
      return u4(this, void 0, void 0, function* () {
        if (this.privRequestSession.isRecognizing) {
          let r = yield this.fetchConnection();
          yield this.sendSpeechEvent(r, this.createSpeechEventPayload(e, t));
        }
      });
    }
    processTypeSpecificMessages(e) {
      return u4(this, void 0, void 0, function* () {
        let t, r = new zn();
        r.setProperty(ke.SpeechServiceResponse_JsonResult, e.textBody);
        let n = !1;
        switch (e.path.toLowerCase()) {
          case "speech.hypothesis":
          case "speech.fragment":
            let i = t_.fromJSON(e.textBody), o = i.Offset + this.privRequestSession.currentTurnAudioOffset;
            t = new ra(this.privRequestSession.requestId, or.RecognizingSpeech, i.Text, i.Duration, o, i.Language, i.LanguageDetectionConfidence, i.SpeakerId, void 0, e.textBody, r), this.privRequestSession.onHypothesis(o);
            let a = new tc(t, i.Duration, this.privRequestSession.sessionId);
            if (this.privTranscriberRecognizer.recognizing) try {
              this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, a);
            } catch {
            }
            n = !0;
            break;
          case "speech.phrase":
            let u = Cd.fromJSON(e.textBody), s = au.implTranslateRecognitionResult(u.RecognitionStatus);
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + u.Offset + u.Duration), or.Canceled === s) {
              let c = au.implTranslateCancelResult(u.RecognitionStatus);
              yield this.cancelRecognitionLocal(c, au.implTranslateCancelErrorCode(u.RecognitionStatus), void 0);
            } else {
              if (!(this.privRequestSession.isSpeechEnded && s === or.NoMatch && u.RecognitionStatus !== Ln.InitialSilenceTimeout)) {
                if (this.privRecognizerConfig.parameters.getProperty(nc) === vi[vi.Simple]) t = new ra(this.privRequestSession.requestId, s, u.DisplayText, u.Duration, u.Offset + this.privRequestSession.currentTurnAudioOffset, u.Language, u.LanguageDetectionConfidence, u.SpeakerId, void 0, e.textBody, r);
                else {
                  let l = B$.fromJSON(e.textBody);
                  t = new ra(this.privRequestSession.requestId, s, l.RecognitionStatus === Ln.Success ? l.NBest[0].Display : void 0, l.Duration, l.Offset + this.privRequestSession.currentTurnAudioOffset, l.Language, l.LanguageDetectionConfidence, void 0, void 0, e.textBody, r);
                }
                let c = new tc(t, t.offset, this.privRequestSession.sessionId);
                if (this.privTranscriberRecognizer.recognized) try {
                  this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, c);
                } catch {
                }
              }
              if (this.privSuccessCallback) {
                try {
                  this.privSuccessCallback(t);
                } catch (c) {
                  this.privErrorCallback && this.privErrorCallback(c);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
              }
            }
            n = !0;
            break;
        }
        return n;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      let o = new zn();
      if (o.setProperty(Fa, dr[n]), this.privTranscriberRecognizer.canceled) {
        let a = new D$(r, i, n, void 0, e);
        try {
          this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, a);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        let a = new ra(t, or.Canceled, void 0, void 0, void 0, void 0, void 0, void 0, i, void 0, o);
        try {
          this.privSuccessCallback(a), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
    sendTranscriptionStartJSON(e) {
      return u4(this, void 0, void 0, function* () {
        yield this.sendSpeechContext(e);
        let t = this.privTranscriberRecognizer.getConversationInfo(), r = this.createSpeechEventPayload(t, "start");
        yield this.sendSpeechEvent(e, r), yield this.sendWaveHeader(e);
      });
    }
    createSpeechEventPayload(e, t) {
      let r = "meeting", n = { id: r, name: t, meeting: e.conversationProperties }, i = "id", o = "attendees", a = "record";
      return n[r][i] = e.id, n[r][o] = e.participants, n[r][a] = e.conversationProperties.audiorecording === "on" ? "true" : "false", n;
    }
  };
}), B$, s3r = Qe(() => {
  hr(), B$ = class ICe {
    constructor(t) {
      this.privDetailedSpeechPhrase = JSON.parse(t), this.privDetailedSpeechPhrase.RecognitionStatus = Ln[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(t) {
      return new ICe(t);
    }
    get RecognitionStatus() {
      return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
      return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
      return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
      return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
      return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
      return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
  };
}), Cd, c3r = Qe(() => {
  hr(), Cd = class OCe {
    constructor(t) {
      this.privSimpleSpeechPhrase = JSON.parse(t), this.privSimpleSpeechPhrase.RecognitionStatus = Ln[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(t) {
      return new OCe(t);
    }
    get RecognitionStatus() {
      return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
      return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
      return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
      return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
      return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
      return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
      return this.privSimpleSpeechPhrase.SpeakerId;
    }
  };
}), C8, l3r = Qe(() => {
  C8 = class {
    constructor(e, t) {
      this.modelImpl = e, this.intentName = t;
    }
  };
}), Kue, RCe, f3r = Qe(() => {
  vr(), Kt(), hr(), Kue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, RCe = class extends ys {
    constructor(e, t, r, n, i) {
      super(e, t, r, n, i), this.privIntentRecognizer = i, this.privIntentDataSent = !1;
    }
    setIntents(e, t) {
      this.privAddedLmIntents = e, this.privUmbrellaIntent = t, this.privIntentDataSent = !0;
    }
    processTypeSpecificMessages(e) {
      return Kue(this, void 0, void 0, function* () {
        let t, r, n = !1, i = new zn();
        switch (e.messageType === br.Text && i.setProperty(ke.SpeechServiceResponse_JsonResult, e.textBody), e.path.toLowerCase()) {
          case "speech.hypothesis":
            let o = t_.fromJSON(e.textBody);
            if (t = new lf(void 0, this.privRequestSession.requestId, or.RecognizingIntent, o.Text, o.Duration, o.Offset + this.privRequestSession.currentTurnAudioOffset, o.Language, o.LanguageDetectionConfidence, void 0, e.textBody, i), this.privRequestSession.onHypothesis(t.offset), r = new yf(t, o.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privIntentRecognizer.recognizing) try {
              this.privIntentRecognizer.recognizing(this.privIntentRecognizer, r);
            } catch {
            }
            n = !0;
            break;
          case "speech.phrase":
            let a = Cd.fromJSON(e.textBody);
            t = new lf(void 0, this.privRequestSession.requestId, au.implTranslateRecognitionResult(a.RecognitionStatus), a.DisplayText, a.Duration, a.Offset + this.privRequestSession.currentTurnAudioOffset, a.Language, a.LanguageDetectionConfidence, void 0, e.textBody, i), r = new yf(t, t.offset, this.privRequestSession.sessionId);
            let u = () => {
              if (this.privIntentRecognizer.recognized) try {
                this.privIntentRecognizer.recognized(this.privIntentRecognizer, r);
              } catch {
              }
              if (this.privSuccessCallback) {
                try {
                  this.privSuccessCallback(t);
                } catch (l) {
                  this.privErrorCallback && this.privErrorCallback(l);
                }
                this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
              }
            };
            this.privIntentDataSent === !1 || or.NoMatch === r.result.reason ? (this.privRequestSession.onPhraseRecognized(r.offset + r.result.duration), u()) : this.privPendingIntentArgs = r, n = !0;
            break;
          case "response":
            if (r = this.privPendingIntentArgs, this.privPendingIntentArgs = void 0, r === void 0) {
              if (e.textBody === "") return;
              r = new yf(new lf(), 0, this.privRequestSession.sessionId);
            }
            let s = wCe.fromJSON(e.textBody), c = this.privAddedLmIntents[s.topScoringIntent.intent];
            if (this.privUmbrellaIntent !== void 0 && (c = this.privUmbrellaIntent), s !== null && c !== void 0) {
              let l = c.intentName === void 0 ? s.topScoringIntent.intent : c.intentName, f = r.result.reason;
              l !== void 0 && (f = or.RecognizedIntent);
              let d = r.result.properties !== void 0 ? r.result.properties : new zn();
              d.setProperty(ke.LanguageUnderstandingServiceResponse_JsonResult, e.textBody), r = new yf(new lf(l, r.result.resultId, f, r.result.text, r.result.duration, r.result.offset, void 0, void 0, r.result.errorDetails, r.result.json, d), r.offset, r.sessionId);
            }
            if (this.privRequestSession.onPhraseRecognized(r.offset + r.result.duration), this.privIntentRecognizer.recognized) try {
              this.privIntentRecognizer.recognized(this.privIntentRecognizer, r);
            } catch {
            }
            if (this.privSuccessCallback) {
              try {
                this.privSuccessCallback(r.result);
              } catch (l) {
                this.privErrorCallback && this.privErrorCallback(l);
              }
              this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
            n = !0;
            break;
        }
        return n;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      let o = new zn();
      if (o.setProperty(Fa, dr[n]), this.privIntentRecognizer.canceled) {
        let a = new v$(r, i, n, void 0, void 0, e);
        try {
          this.privIntentRecognizer.canceled(this.privIntentRecognizer, a);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        let a = new lf(void 0, t, or.Canceled, void 0, void 0, void 0, void 0, void 0, i, void 0, o);
        try {
          this.privSuccessCallback(a), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
  };
}), wCe, d3r = Qe(() => {
  wCe = class PCe {
    constructor(t) {
      this.privIntentResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new PCe(t);
    }
    get query() {
      return this.privIntentResponse.query;
    }
    get topScoringIntent() {
      return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
      return this.privIntentResponse.entities;
    }
  };
}), DCe, p3r = Qe(() => {
  vr(), L$(), DCe = class {
    constructor(e, t, r) {
      this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.onEvent = (n) => {
        this.privIsDisposed || (n instanceof x$ && n.requestId === this.privRequestId && (this.privListeningTriggerMetric = { End: n.eventTime, Name: "ListeningTrigger", Start: n.eventTime }), n instanceof $f && n.audioSourceId === this.privAudioSourceId && n.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = n.eventTime), n instanceof Uf && n.audioSourceId === this.privAudioSourceId && n.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = n.eventTime), n instanceof oh && n.audioSourceId === this.privAudioSourceId && (this.privMicMetric || (this.privMicMetric = { End: n.eventTime, Error: n.error, Name: "Microphone", Start: this.privMicStartTime })), n instanceof Zy && n.audioSourceId === this.privAudioSourceId && n.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = { End: n.eventTime, Error: n.error, Name: "Microphone", Start: this.privMicStartTime })), n instanceof hs && n.audioSourceId === this.privAudioSourceId && n.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = { End: n.eventTime, Name: "Microphone", Start: this.privMicStartTime })), n instanceof N$ && n.requestId === this.privRequestId && (this.privConnectionId = n.sessionId), n instanceof r$ && n.connectionId === this.privConnectionId && (this.privConnectionStartTime = n.eventTime), n instanceof n$ && n.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = { End: n.eventTime, Id: this.privConnectionId, Name: "Connection", Start: this.privConnectionStartTime })), n instanceof xSe && n.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = { End: n.eventTime, Error: this.getConnectionError(n.statusCode), Id: this.privConnectionId, Name: "Connection", Start: this.privConnectionStartTime })), n instanceof fb && n.connectionId === this.privConnectionId && n.message && n.message.headers && n.message.headers.path && (this.privReceivedMessages[n.message.headers.path] || (this.privReceivedMessages[n.message.headers.path] = new Array()), this.privReceivedMessages[n.message.headers.path].push(n.networkReceivedTime)));
      }, this.getTelemetry = () => {
        let n = new Array();
        this.privListeningTriggerMetric && n.push(this.privListeningTriggerMetric), this.privMicMetric && n.push(this.privMicMetric), this.privConnectionEstablishMetric && n.push(this.privConnectionEstablishMetric), this.privPhraseLatencies.length > 0 && n.push({ PhraseLatencyMs: this.privPhraseLatencies }), this.privHypothesisLatencies.length > 0 && n.push({ FirstHypothesisLatencyMs: this.privHypothesisLatencies });
        let i = { Metrics: n, ReceivedMessages: this.privReceivedMessages }, o = JSON.stringify(i);
        return this.privReceivedMessages = {}, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privPhraseLatencies = [], this.privHypothesisLatencies = [], o;
      }, this.dispose = () => {
        this.privIsDisposed = !0;
      }, this.getConnectionError = (n) => {
        switch (n) {
          case 400:
          case 1002:
          case 1003:
          case 1005:
          case 1007:
          case 1008:
          case 1009:
            return "BadRequest";
          case 401:
            return "Unauthorized";
          case 403:
            return "Forbidden";
          case 503:
          case 1001:
            return "ServerUnavailable";
          case 500:
          case 1011:
            return "ServerError";
          case 408:
          case 504:
            return "Timeout";
          default:
            return "statuscode:" + n.toString();
        }
      }, this.privRequestId = e, this.privAudioSourceId = t, this.privAudioNodeId = r, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
    }
    phraseReceived(e) {
      e > 0 && this.privPhraseLatencies.push(Date.now() - e);
    }
    hypothesisReceived(e) {
      e > 0 && this.privHypothesisLatencies.push(Date.now() - e);
    }
    get hasTelemetry() {
      return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
  };
}), kc, xCe, h3r = Qe(() => {
  vr(), L$(), p3r(), kc = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, xCe = class {
    constructor(e) {
      this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.onPreConnectionStart = (t, r) => {
        this.privAuthFetchEventId = t, this.privSessionId = r, this.onEvent(new N$(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
      }, this.onServiceTurnStartResponse = () => {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
        })), this.privInTurn = !0, this.privTurnDeferral = new Kn();
      }, this.getTelemetry = () => this.privServiceTelemetryListener.hasTelemetry ? this.privServiceTelemetryListener.getTelemetry() : null, this.onEvent = (t) => {
        this.privServiceTelemetryListener && this.privServiceTelemetryListener.onEvent(t), ci.instance.onEvent(t);
      }, this.privAudioSourceId = e, this.privRequestId = jn(), this.privAudioNodeId = jn(), this.privTurnDeferral = new Kn(), this.privTurnDeferral.resolve();
    }
    get sessionId() {
      return this.privSessionId;
    }
    get requestId() {
      return this.privRequestId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
      return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
      return this.privIsSpeechEnded;
    }
    get isRecognizing() {
      return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
      return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
      return this.privRecogNumber;
    }
    get numConnectionAttempts() {
      return this.privConnectionAttempts;
    }
    get bytesSent() {
      return this.privBytesSent;
    }
    listenForServiceTelemetry(e) {
      this.privServiceTelemetryListener && this.privDetachables.push(e.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
      this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRequestId = jn(), this.privRecogNumber++, this.privServiceTelemetryListener = new DCe(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new x$(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onAudioSourceAttachCompleted(e, t, r) {
      return kc(this, void 0, void 0, function* () {
        this.privAudioNode = e, this.privIsAudioNodeDetached = !1, t ? yield this.onComplete() : this.onEvent(new sCe(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
      });
    }
    onAuthCompleted(e, t) {
      return kc(this, void 0, void 0, function* () {
        e && (yield this.onComplete());
      });
    }
    onConnectionEstablishCompleted(e, t) {
      return kc(this, void 0, void 0, function* () {
        if (e === 200) {
          this.onEvent(new cCe(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0;
          return;
        } else e === 403 && (yield this.onComplete());
      });
    }
    onServiceTurnEndResponse(e) {
      return kc(this, void 0, void 0, function* () {
        this.privTurnDeferral.resolve(), !e || this.isSpeechEnded ? (yield this.onComplete(), this.privInTurn = !1) : (this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privRequestId = jn(), this.privAudioNode.replay());
      });
    }
    onHypothesis(e) {
      this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(e)));
    }
    onPhraseRecognized(e) {
      this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(e)), this.onServiceRecognized(e);
    }
    onServiceRecognized(e) {
      this.privLastRecoOffset = e, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(e), this.privConnectionAttempts = 0;
    }
    onAudioSent(e) {
      this.privBytesSent += e;
    }
    onRetryConnection() {
      this.privConnectionAttempts++;
    }
    dispose(e) {
      return kc(this, void 0, void 0, function* () {
        if (!this.privIsDisposed) {
          this.privIsDisposed = !0;
          for (let t of this.privDetachables) yield t.detach();
          this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1;
        }
      });
    }
    onStopRecognizing() {
      return kc(this, void 0, void 0, function* () {
        yield this.onComplete();
      });
    }
    onSpeechEnded() {
      this.privIsSpeechEnded = !0;
    }
    onComplete() {
      return kc(this, void 0, void 0, function* () {
        this.privIsRecognizing && (this.privIsRecognizing = !1, yield this.detachAudioNode());
      });
    }
    detachAudioNode() {
      return kc(this, void 0, void 0, function* () {
        this.privIsAudioNodeDetached || (this.privIsAudioNodeDetached = !0, this.privAudioNode && (yield this.privAudioNode.detach()));
      });
    }
  };
}), NCe, v3r = Qe(() => {
  NCe = class {
    constructor(e) {
      this.privContext = {}, this.privDynamicGrammar = e;
    }
    setSection(e, t) {
      this.privContext[e] = t;
    }
    setPronunciationAssessmentParams(e) {
      this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = { enrichment: { pronunciationAssessment: {} } }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(e), this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = { detailed: { options: [] }, format: {} }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    toJSON() {
      let e = this.privDynamicGrammar.generateGrammarObject();
      return this.setSection("dgi", e), JSON.stringify(this.privContext);
    }
  };
}), LCe, E3r = Qe(() => {
  LCe = class {
    addPhrase(e) {
      this.privPhrases || (this.privPhrases = []), e instanceof Array ? this.privPhrases = this.privPhrases.concat(e) : this.privPhrases.push(e);
    }
    clearPhrases() {
      this.privPhrases = void 0;
    }
    addReferenceGrammar(e) {
      this.privGrammars || (this.privGrammars = []), e instanceof Array ? this.privGrammars = this.privGrammars.concat(e) : this.privGrammars.push(e);
    }
    clearGrammars() {
      this.privGrammars = void 0;
    }
    generateGrammarObject() {
      if (this.privGrammars === void 0 && this.privPhrases === void 0) return;
      let e = {};
      if (e.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
        let t = [];
        this.privPhrases.forEach((r, n, i) => {
          t.push({ Text: r });
        }), e.Groups = [{ Type: "Generic", Items: t }];
      }
      return e;
    }
  };
}), m3r = Qe(() => {
}), BCe, I8, kCe = Qe(() => {
  BCe = class MCe {
    constructor(t) {
      this.privActivityResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new MCe(t);
    }
    get conversationId() {
      return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
      return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
      return this.privActivityResponse.messagePayload;
    }
    get version() {
      return this.privActivityResponse.version;
    }
  }, function(e) {
    e[e.None = 0] = "None", e[e.TextToSpeechAudio = 1] = "TextToSpeechAudio";
  }(I8 || (I8 = {}));
}), FCe, g3r = Qe(() => {
  s2(), rv(), kCe(), FCe = class {
    constructor(e, t) {
      this.privRequestId = t, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = e, this.resetTurnEndTimeout();
    }
    get audioStream() {
      return this.resetTurnEndTimeout(), this.privAudioStream;
    }
    processActivityPayload(e, t) {
      return e.messageDataStreamType === I8.TextToSpeechAudio && (this.privAudioStream = P1.createPullStream(), this.privAudioStream.format = t !== void 0 ? t : sh.getDefaultOutputFormat()), this.privAudioStream;
    }
    endAudioStream() {
      this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
    }
    complete() {
      this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
    }
    resetTurnEndTimeout() {
      this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(() => {
        this.privTurnManager.CompleteTurn(this.privRequestId);
      }, 2e3);
    }
  };
}), HCe, T3r = Qe(() => {
  gc(), g3r(), HCe = class {
    constructor() {
      this.privTurnMap = /* @__PURE__ */ new Map();
    }
    StartTurn(e) {
      if (this.privTurnMap.has(e)) throw new ta("Service error: There is already a turn with id:" + e);
      let t = new FCe(this, e);
      return this.privTurnMap.set(e, t), this.privTurnMap.get(e);
    }
    GetTurn(e) {
      return this.privTurnMap.get(e);
    }
    CompleteTurn(e) {
      if (!this.privTurnMap.has(e)) throw new ta("Service error: Received turn end for an unknown turn id:" + e);
      let t = this.privTurnMap.get(e);
      return t.complete(), this.privTurnMap.delete(e), t;
    }
  };
}), Iu, $Ce, y3r = Qe(() => {
  hu(), kSe(), vr(), s2(), Kt(), T3r(), hr(), kCe(), E2(), Iu = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, $Ce = class extends ys {
    constructor(e, t, r, n, i) {
      super(e, t, r, n, i), this.sendAgentConfig = (o) => {
        if (this.agentConfig && !this.agentConfigSent) {
          if (this.privRecognizerConfig.parameters.getProperty(ke.Conversation_DialogType) === ma.DialogTypes.CustomCommands) {
            let u = this.agentConfig.get();
            u.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty(ke.SpeechServiceConnection_RecoLanguage, "en-us"), this.agentConfig.set(u);
          }
          this.onEvent(new BSe(this.agentConfig));
          let a = this.agentConfig.toJsonString();
          return this.agentConfigSent = !0, o.send(new Bi(br.Text, "agent.config", this.privRequestSession.requestId, "application/json", a));
        }
      }, this.sendAgentContext = (o) => {
        let a = fT(), u = this.privDialogServiceConnector.properties.getProperty(ke.Conversation_Speech_Activity_Template), s = JSON.stringify({ channelData: "", context: { interactionId: a }, messagePayload: typeof u === void 0 ? void 0 : u, version: 0.5 });
        return o.send(new Bi(br.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", s));
      }, this.handleResponseMessage = (o) => {
        let a = JSON.parse(o.textBody);
        switch (a.messageType.toLowerCase()) {
          case "message":
            let u = o.requestId.toUpperCase(), s = BCe.fromJSON(o.textBody), c = this.privTurnStateManager.GetTurn(u);
            if (s.conversationId) {
              let d = this.agentConfig.get();
              d.botInfo.conversationId = s.conversationId, this.agentConfig.set(d);
            }
            let l = c.processActivityPayload(s, sh.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty(ke.SpeechServiceConnection_SynthOutputFormat, void 0))), f = new T$(s.messagePayload, l);
            if (this.privDialogServiceConnector.activityReceived) try {
              this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, f);
            } catch {
            }
            break;
          case "messagestatus":
            if (this.privDialogServiceConnector.turnStatusReceived) try {
              this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new y$(o.textBody));
            } catch {
            }
            break;
          default:
            ci.instance.onEvent(new ec(`Unexpected response of type ${a.messageType}. Ignoring.`));
            break;
        }
      }, this.privEvents = new su(), this.privDialogServiceConnector = i, this.receiveMessageOverride = this.receiveDialogMessageOverride, this.privTurnStateManager = new HCe(), this.recognizeOverride = this.listenOnce, this.postConnectImplOverride = this.dialogConnectImpl, this.configConnectionOverride = this.configConnection, this.disconnectOverride = this.privDisconnect, this.privDialogAudioSource = r, this.agentConfigSent = !1, this.privLastResult = null, this.connectionEvents.attach((o) => Iu(this, void 0, void 0, function* () {
        o.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0);
      }));
    }
    sendMessage(e) {
      return Iu(this, void 0, void 0, function* () {
        let t = fT(), r = jn(), n = { context: { interactionId: t }, messagePayload: JSON.parse(e), version: 0.5 }, i = JSON.stringify(n);
        yield (yield this.fetchConnection()).send(new Bi(br.Text, "agent", r, "application/json", i));
      });
    }
    privDisconnect() {
      return Iu(this, void 0, void 0, function* () {
        yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, oi.Error, dr.NoError, "Disconnecting"), this.terminateMessageLoop = !0, this.agentConfigSent = !1;
      });
    }
    processTypeSpecificMessages(e) {
      return Iu(this, void 0, void 0, function* () {
        let t = new zn();
        e.messageType === br.Text && t.setProperty(ke.SpeechServiceResponse_JsonResult, e.textBody);
        let r, n;
        switch (e.path.toLowerCase()) {
          case "speech.phrase":
            let i = Cd.fromJSON(e.textBody);
            if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + i.Offset + i.Duration), i.RecognitionStatus !== Ln.TooManyRequests && i.RecognitionStatus !== Ln.Error) {
              let l = this.fireEventForResult(i, t);
              if (this.privLastResult = l.result, this.privDialogServiceConnector.recognized) try {
                this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, l);
              } catch {
              }
            }
            n = !0;
            break;
          case "speech.hypothesis":
            let o = t_.fromJSON(e.textBody), a = o.Offset + this.privRequestSession.currentTurnAudioOffset;
            r = new ra(this.privRequestSession.requestId, or.RecognizingSpeech, o.Text, o.Duration, a, o.Language, o.LanguageDetectionConfidence, void 0, void 0, e.textBody, t), this.privRequestSession.onHypothesis(a);
            let u = new tc(r, o.Duration, this.privRequestSession.sessionId);
            if (this.privDialogServiceConnector.recognizing) try {
              this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, u);
            } catch {
            }
            n = !0;
            break;
          case "speech.keyword":
            let s = ACe.fromJSON(e.textBody);
            r = new ra(this.privRequestSession.requestId, s.Status === "Accepted" ? or.RecognizedKeyword : or.NoMatch, s.Text, s.Duration, s.Offset, void 0, void 0, void 0, void 0, e.textBody, t), s.Status !== "Accepted" && (this.privLastResult = r);
            let c = new tc(r, r.duration, r.resultId);
            if (this.privDialogServiceConnector.recognized) try {
              this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, c);
            } catch {
            }
            n = !0;
            break;
          case "audio":
            {
              let l = e.requestId.toUpperCase(), f = this.privTurnStateManager.GetTurn(l);
              try {
                e.binaryBody ? f.audioStream.write(e.binaryBody) : f.endAudioStream();
              } catch {
              }
            }
            n = !0;
            break;
          case "response":
            this.handleResponseMessage(e), n = !0;
            break;
        }
        return n;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      return Iu(this, void 0, void 0, function* () {
        if (this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing && (yield this.privRequestSession.onStopRecognizing()), this.privDialogServiceConnector.canceled) {
          let o = new zn();
          o.setProperty(Fa, dr[n]);
          let a = new d2(r, i, n, void 0, e);
          try {
            this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, a);
          } catch {
          }
          if (this.privSuccessCallback) {
            let u = new ra(void 0, or.Canceled, void 0, void 0, void 0, void 0, void 0, void 0, i, void 0, o);
            try {
              this.privSuccessCallback(u), this.privSuccessCallback = void 0;
            } catch {
            }
          }
        }
      });
    }
    listenOnce(e, t, r) {
      return Iu(this, void 0, void 0, function* () {
        this.privRecognizerConfig.recognitionMode = e, this.privSuccessCallback = t, this.privErrorCallback = r, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty(ke.Speech_SessionId, this.privRequestSession.sessionId);
        let n = this.connectImpl(), i = this.sendPreAudioMessages(), o = yield this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId), a = yield this.privDialogAudioSource.format, u = yield this.privDialogAudioSource.deviceInfo, s = new V$(o, a.avgBytesPerSec);
        yield this.privRequestSession.onAudioSourceAttachCompleted(s, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: u };
        try {
          yield n, yield i;
        } catch (l) {
          return yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, oi.Error, dr.ConnectionFailure, l), Promise.resolve();
        }
        let c = new $o(this.privRequestSession.sessionId);
        this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, c), this.sendAudio(s).then(() => {
        }, (l) => Iu(this, void 0, void 0, function* () {
          yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, oi.Error, dr.RuntimeError, l);
        }));
      });
    }
    dialogConnectImpl(e) {
      return this.privConnectionLoop = this.startMessageLoop(), e;
    }
    receiveDialogMessageOverride() {
      let e = new Kn(), t = () => Iu(this, void 0, void 0, function* () {
        try {
          let r = this.isDisposed(), n = !this.isDisposed() && this.terminateMessageLoop;
          if (r || n) {
            e.resolve(void 0);
            return;
          }
          let i = yield (yield this.fetchConnection()).read();
          if (!i) return t();
          let o = Bi.fromConnectionMessage(i);
          switch (o.path.toLowerCase()) {
            case "turn.start":
              {
                let f = o.requestId.toUpperCase(), d = this.privRequestSession.requestId.toUpperCase();
                f !== d ? this.privTurnStateManager.StartTurn(f) : this.privRequestSession.onServiceTurnStartResponse();
              }
              break;
            case "speech.startdetected":
              let a = gT.fromJSON(o.textBody), u = new Ts(a.Offset, this.privRequestSession.sessionId);
              this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, u);
              break;
            case "speech.enddetected":
              let s;
              o.textBody.length > 0 ? s = o.textBody : s = "{ Offset: 0 }";
              let c = gT.fromJSON(s);
              this.privRequestSession.onServiceRecognized(c.Offset + this.privRequestSession.currentTurnAudioOffset);
              let l = new Ts(c.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
              this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, l);
              break;
            case "turn.end":
              {
                let f = o.requestId.toUpperCase(), d = this.privRequestSession.requestId.toUpperCase();
                if (f !== d) this.privTurnStateManager.CompleteTurn(f);
                else {
                  let p = new $o(this.privRequestSession.sessionId);
                  if (yield this.privRequestSession.onServiceTurnEndResponse(!1), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, p), this.privSuccessCallback && this.privLastResult) {
                    try {
                      this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                    } catch (v) {
                      this.privErrorCallback && this.privErrorCallback(v);
                    }
                    this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                  }
                }
              }
              break;
            default:
              this.processTypeSpecificMessages(o) || this.serviceEvents && this.serviceEvents.onEvent(new a2(o.path.toLowerCase(), o.textBody));
          }
          return t();
        } catch {
          this.terminateMessageLoop = !0, e.resolve();
        }
      });
      return t().catch((r) => {
        ci.instance.onEvent(new ec(r));
      }), e.promise;
    }
    startMessageLoop() {
      return Iu(this, void 0, void 0, function* () {
        this.terminateMessageLoop = !1;
        try {
          yield this.receiveDialogMessageOverride();
        } catch (e) {
          yield this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, oi.Error, dr.RuntimeError, e);
        }
        return Promise.resolve();
      });
    }
    configConnection(e) {
      return Iu(this, void 0, void 0, function* () {
        return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, Promise.reject("Connection to service terminated.")) : (yield this.sendSpeechServiceConfig(e, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), yield this.sendAgentConfig(e), e);
      });
    }
    sendPreAudioMessages() {
      return Iu(this, void 0, void 0, function* () {
        let e = yield this.fetchConnection();
        this.addKeywordContextData(), yield this.sendSpeechContext(e), yield this.sendAgentContext(e), yield this.sendWaveHeader(e);
      });
    }
    fireEventForResult(e, t) {
      let r = au.implTranslateRecognitionResult(e.RecognitionStatus), n = e.Offset + this.privRequestSession.currentTurnAudioOffset, i = new ra(this.privRequestSession.requestId, r, e.DisplayText, e.Duration, n, e.Language, e.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(e), t);
      return new tc(i, n, this.privRequestSession.sessionId);
    }
    onEvent(e) {
      this.privEvents.onEvent(e), ci.instance.onEvent(e);
    }
    addKeywordContextData() {
      let e = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
      if (e === void 0) return;
      let t = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), r = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), n = e.split(";"), i = t === void 0 ? [] : t.split(";"), o = r === void 0 ? [] : r.split(";"), a = [];
      for (let u = 0; u < n.length; u++) {
        let s = {};
        s.text = n[u], u < i.length && (s.offset = Number(i[u])), u < o.length && (s.duration = Number(o[u])), a.push(s);
      }
      this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [{ clientDetectedKeywords: a, onReject: { action: "EndOfTurn" }, type: "startTrigger" }]);
    }
  };
}), k$, _3r = Qe(() => {
  k$ = class {
    toJsonString() {
      return JSON.stringify(this.iPrivConfig);
    }
    get() {
      return this.iPrivConfig;
    }
    set(e) {
      this.iPrivConfig = e;
    }
  };
}), Du, M$ = Qe(() => {
  Du = class aS {
    static get requestOptions() {
      return aS.privDefaultRequestOptions;
    }
    static get configParams() {
      return aS.privDefaultParams;
    }
    static get restErrors() {
      return aS.privRestErrors;
    }
  }, Du.privDefaultRequestOptions = { headers: { Accept: "application/json" }, ignoreCache: !1, timeout: 1e4 }, Du.privRestErrors = { authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.", authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.", invalidArgs: "Required input not found: {arg}.", invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.", invalidParticipantRequest: "The requested participant was not found.", permissionDeniedConnect: "Required credentials not found.", permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.", permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.", permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.", permissionDeniedStart: "Invalid operation: there is already an active conversation." }, Du.privDefaultParams = { apiVersion: "api-version", authorization: "Authorization", clientAppId: "X-ClientAppId", contentTypeKey: "Content-Type", correlationId: "X-CorrelationId", languageCode: "language", nickname: "nickname", profanity: "profanity", requestId: "X-RequestId", roomId: "roomid", sessionToken: "token", subscriptionKey: "Ocp-Apim-Subscription-Key", subscriptionRegion: "Ocp-Apim-Subscription-Region", token: "X-CapitoToken" };
}), sn, F$ = Qe(() => {
  M$(), sn = class Vs extends Du {
    static get host() {
      return Vs.privHost;
    }
    static get apiVersion() {
      return Vs.privApiVersion;
    }
    static get clientAppId() {
      return Vs.privClientAppId;
    }
    static get defaultLanguageCode() {
      return Vs.privDefaultLanguageCode;
    }
    static get restPath() {
      return Vs.privRestPath;
    }
    static get webSocketPath() {
      return Vs.privWebSocketPath;
    }
    static get speechHost() {
      return Vs.privSpeechHost;
    }
    static get speechPath() {
      return Vs.privSpeechPath;
    }
    static get transcriptionEventKeys() {
      return Vs.privTranscriptionEventKeys;
    }
  }, sn.privHost = "dev.microsofttranslator.com", sn.privRestPath = "/capito/room", sn.privApiVersion = "2.0", sn.privDefaultLanguageCode = "en-US", sn.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15", sn.privWebSocketPath = "/capito/translate", sn.privSpeechHost = "{region}.s2s.speech.microsoft.com", sn.privSpeechPath = "/speech/translation/cognitiveservices/v1", sn.privTranscriptionEventKeys = ["iCalUid", "callId", "organizer", "FLAC", "MTUri", "DifferenciateGuestSpeakers", "audiorecording", "Threadid", "OrganizerMri", "OrganizerTenantId", "UserToken"];
}), UCe = ot(() => {
});
function A3r(e = {}) {
  return Object.keys(e).map((t) => encodeURIComponent(t) + "=" + encodeURIComponent(e[t])).join("&");
}
function S3r(e, t = {}) {
  let r = A3r(t);
  return r ? e + (e.indexOf("?") === -1 ? "?" : "&") + r : e;
}
function b3r(e) {
  return { data: e.responseText, headers: e.getAllResponseHeaders(), json: () => JSON.parse(e.responseText), ok: e.status >= 200 && e.status < 300, status: e.status, statusText: e.statusText };
}
function Xue(e, t = null) {
  return { data: t || e.statusText, headers: e.getAllResponseHeaders(), json: () => JSON.parse(t || '"' + e.statusText + '"'), ok: !1, status: e.status, statusText: e.statusText };
}
function C3r(e, t) {
  let r = "";
  try {
    let n = t.trim().split(/[\r\n]+/), i = {};
    n.forEach((o) => {
      let a = o.split(": "), u = a.shift().toLowerCase(), s = a.join(": ");
      i[u] = s;
    }), r = i[e.toLowerCase()];
  } catch {
  }
  return r;
}
function Jue(e, t, r = {}, n = null, i = {}, o) {
  let a = Du.requestOptions, u = i.ignoreCache || a.ignoreCache, s = i.headers || a.headers, c = i.timeout || a.timeout, l;
  typeof window > "u" ? l = new (void 0)() : l = new XMLHttpRequest(), l.open(e, S3r(t, r), !0), s && Object.keys(s).forEach((f) => l.setRequestHeader(f, s[f])), u && l.setRequestHeader("Cache-Control", "no-cache"), l.timeout = c, l.onload = (f) => {
    o(b3r(l));
  }, l.onerror = (f) => {
    o(Xue(l, "Failed to make request."));
  }, l.ontimeout = (f) => {
    o(Xue(l, "Request took longer than expected."));
  }, e === "post" && n ? (l.setRequestHeader("Content-Type", "application/json"), l.send(JSON.stringify(n))) : l.send();
}
function I3r(e, t, r) {
  e ? e.then((n) => {
    try {
      t && t();
    } catch (i) {
      r && r(`'Unhandled error on promise callback: ${i}'`);
    }
  }, (n) => {
    try {
      r && r(n);
    } catch {
    }
  }) : r && r("Null promise");
}
var VCe = Qe(() => {
  M$(), Qa(UCe());
}), jCe, O3r = Qe(() => {
  rn(), Kt(), F$(), VCe(), jCe = class {
    constructor() {
      this.privRequestParams = sn.configParams, this.privErrors = sn.restErrors, this.privHost = sn.host, this.privApiVersion = sn.apiVersion, this.privRestPath = sn.restPath;
    }
    createOrJoin(e, t, r, n) {
      try {
        nt.throwIfNullOrUndefined(e, "args");
        let i = e.getProperty(ke.SpeechServiceConnection_RecoLanguage, sn.defaultLanguageCode), o = e.getProperty(ke.ConversationTranslator_Name), a = e.getProperty(ke.ConversationTranslator_Host, this.privHost), u = e.getProperty(ke.ConversationTranslator_CorrelationId), s = e.getProperty(ke.SpeechServiceConnection_Key), c = e.getProperty(ke.SpeechServiceConnection_Region), l = e.getProperty(ke.SpeechServiceAuthorization_Token);
        nt.throwIfNullOrWhitespace(i, "languageCode"), nt.throwIfNullOrWhitespace(o, "nickname"), nt.throwIfNullOrWhitespace(a, "endpointHost");
        let f = {};
        f[this.privRequestParams.apiVersion] = this.privApiVersion, f[this.privRequestParams.languageCode] = i, f[this.privRequestParams.nickname] = o;
        let d = {};
        u && (d[this.privRequestParams.correlationId] = u), d[this.privRequestParams.clientAppId] = sn.clientAppId, t !== void 0 ? f[this.privRequestParams.roomId] = t : (nt.throwIfNullOrUndefined(c, this.privErrors.authInvalidSubscriptionRegion), d[this.privRequestParams.subscriptionRegion] = c, s ? d[this.privRequestParams.subscriptionKey] = s : l ? d[this.privRequestParams.authorization] = `Bearer ${l}` : nt.throwIfNullOrUndefined(s, this.privErrors.authInvalidSubscriptionKey));
        let p = {};
        p.headers = d;
        let v = `https://${a}${this.privRestPath}`;
        Jue("post", v, f, null, p, (h) => {
          let E = C3r(this.privRequestParams.requestId, h.headers);
          if (!h.ok) {
            if (n) {
              let g = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", h.status.toString()), y;
              try {
                y = JSON.parse(h.data), g += ` [${y.error.code}: ${y.error.message}]`;
              } catch {
                g += ` [${h.data}]`;
              }
              E && (g += ` ${E}`), n(g);
            }
            return;
          }
          let m = JSON.parse(h.data);
          if (m && (m.requestId = E), r) {
            try {
              r(m);
            } catch (g) {
              n && n(g);
            }
            r = void 0;
          }
        });
      } catch (i) {
        if (n) if (i instanceof Error) {
          let o = i;
          n(o.name + ": " + o.message);
        } else n(i);
      }
    }
    leave(e, t) {
      return new Promise((r, n) => {
        try {
          nt.throwIfNullOrUndefined(e, this.privErrors.invalidArgs.replace("{arg}", "config")), nt.throwIfNullOrWhitespace(t, this.privErrors.invalidArgs.replace("{arg}", "token"));
          let i = e.getProperty(ke.ConversationTranslator_Host, this.privHost), o = e.getProperty(ke.ConversationTranslator_CorrelationId), a = {};
          a[this.privRequestParams.apiVersion] = this.privApiVersion, a[this.privRequestParams.sessionToken] = t;
          let u = {};
          o && (u[this.privRequestParams.correlationId] = o);
          let s = {};
          s.headers = u;
          let c = `https://${i}${this.privRestPath}`;
          Jue("delete", c, a, null, s, (l) => {
            l.ok, r();
          });
        } catch (i) {
          if (i instanceof Error) {
            let o = i;
            n(o.name + ": " + o.message);
          } else n(i);
        }
      });
    }
  };
}), TT, zCe = Qe(() => {
  vr(), TT = class extends dT {
    constructor(e, t, r, n) {
      super(e, t, r, n);
      let i = JSON.parse(this.textBody);
      i.type !== void 0 && (this.privConversationMessageType = i.type);
    }
    get conversationMessageType() {
      return this.privConversationMessageType;
    }
  };
}), qCe, R3r = Qe(() => {
  vr(), zCe(), qCe = class {
    constructor() {
      this.toConnectionMessage = (e) => {
        let t = new Kn();
        try {
          if (e.messageType === br.Text) {
            let r = new TT(e.messageType, e.textContent, {}, e.id);
            t.resolve(r);
          } else e.messageType === br.Binary && t.resolve(new TT(e.messageType, e.binaryContent, void 0, e.id));
        } catch (r) {
          t.reject(`Error formatting the message. Error: ${r}`);
        }
        return t.promise;
      }, this.fromConnectionMessage = (e) => {
        let t = new Kn();
        try {
          if (e.messageType === br.Text) {
            let r = `${e.textBody ? e.textBody : ""}`;
            t.resolve(new uh(br.Text, r, e.id));
          }
        } catch (r) {
          t.reject(`Error formatting the message. ${r}`);
        }
        return t.promise;
      };
    }
  };
}), YCe, w3r = Qe(() => {
  hu(), vr(), rn(), Kt(), ov(), F$(), R3r(), YCe = class extends Ad {
    create(e, t, r) {
      let n = e.parameters.getProperty(ke.ConversationTranslator_Host, sn.host), i = e.parameters.getProperty(ke.ConversationTranslator_CorrelationId, fT()), o = `wss://${n}${sn.webSocketPath}`, a = e.parameters.getProperty(ke.ConversationTranslator_Token, void 0);
      nt.throwIfNullOrUndefined(a, "token");
      let u = {};
      u[sn.configParams.apiVersion] = sn.apiVersion, u[sn.configParams.token] = a, u[sn.configParams.correlationId] = i;
      let s = e.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new T0(o, u, {}, new qCe(), y0.fromRecognizerConfig(e), s, r);
    }
  };
}), Zue, GCe, P3r = Qe(() => {
  vr(), Zue = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, GCe = class {
    constructor(e) {
      this.privIsDisposed = !1, this.privDetachables = new Array(), this.onPreConnectionStart = (t, r) => {
        this.privSessionId = r;
      }, this.onAuthCompleted = (t, r) => {
        t && this.onComplete();
      }, this.onConnectionEstablishCompleted = (t, r) => {
        t !== 200 && t === 403 && this.onComplete();
      }, this.onServiceTurnEndResponse = (t) => {
        t ? this.privRequestId = jn() : this.onComplete();
      }, this.onComplete = () => {
      }, this.privSessionId = e, this.privRequestId = jn(), this.privRequestCompletionDeferral = new Kn();
    }
    get sessionId() {
      return this.privSessionId;
    }
    get requestId() {
      return this.privRequestId;
    }
    get completionPromise() {
      return this.privRequestCompletionDeferral.promise;
    }
    dispose(e) {
      return Zue(this, void 0, void 0, function* () {
        if (!this.privIsDisposed) {
          this.privIsDisposed = !0;
          for (let t of this.privDetachables) yield t.detach();
        }
      });
    }
  };
}), WCe, KCe, O8, up, XCe, uS, D3r = Qe(() => {
  Kt(), WCe = class extends $o {
    constructor(e, t) {
      super(t), this.privIsMuted = e;
    }
    get isMuted() {
      return this.privIsMuted;
    }
  }, KCe = class extends $o {
    constructor(e, t) {
      super(t), this.privIsLocked = e;
    }
    get isMuted() {
      return this.privIsLocked;
    }
  }, O8 = class extends $o {
    constructor(e, t) {
      super(t), this.privParticipant = e;
    }
    get participant() {
      return this.privParticipant;
    }
  }, up = class extends $o {
    constructor(e, t, r, n) {
      super(n), this.privKey = t, this.privValue = r, this.privParticipantId = e;
    }
    get value() {
      return this.privValue;
    }
    get key() {
      return this.privKey;
    }
    get id() {
      return this.privParticipantId;
    }
  }, XCe = class extends $o {
    constructor(e, t, r, n, i, o, a, u, s) {
      super(s), this.privRoomId = e, this.privSessionToken = t, this.privTranslateTo = r, this.privProfanityFilter = n, this.privRoomProfanityFilter = i, this.privIsRoomLocked = o, this.privIsRoomLocked = a, this.privParticipants = u;
    }
    get sessionToken() {
      return this.privSessionToken;
    }
    get conversationId() {
      return this.privRoomId;
    }
    get translateTo() {
      return this.privTranslateTo;
    }
    get profanityFilter() {
      return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
      return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
      return this.privIsRoomLocked;
    }
    get isMuteAll() {
      return this.privIsMuteAll;
    }
    get participants() {
      return this.privParticipants;
    }
  }, uS = class {
    constructor(e, t, r) {
      this.privPayload = t, this.privCommand = e, this.privSessionId = r;
    }
    get payload() {
      return this.privPayload;
    }
    get command() {
      return this.privCommand;
    }
    get sessionId() {
      return this.privSessionId;
    }
  };
}), JCe, Ja, Zo, ZCe = Qe(() => {
  JCe = class {
    constructor(e = [], t) {
      this.participants = e, this.meId = t;
    }
    addOrUpdateParticipant(e) {
      if (e === void 0) return;
      let t = this.getParticipantIndex(e.id);
      return t > -1 ? this.participants.splice(t, 1, e) : this.participants.push(e), this.getParticipant(e.id);
    }
    getParticipantIndex(e) {
      return this.participants.findIndex((t) => t.id === e);
    }
    getParticipant(e) {
      return this.participants.find((t) => t.id === e);
    }
    deleteParticipant(e) {
      this.participants = this.participants.filter((t) => t.id !== e);
    }
    get host() {
      return this.participants.find((e) => e.isHost === !0);
    }
    get me() {
      return this.getParticipant(this.meId);
    }
  }, Ja = { command: "command", final: "final", info: "info", instantMessage: "instant_message", partial: "partial", participantCommand: "participant_command", translatedMessage: "translated_message" }, Zo = { changeNickname: "ChangeNickname", disconnectSession: "DisconnectSession", ejectParticipant: "EjectParticipant", instant_message: "instant_message", joinSession: "JoinSession", leaveSession: "LeaveSession", participantList: "ParticipantList", roomExpirationWarning: "RoomExpirationWarning", setLockState: "SetLockState", setMute: "SetMute", setMuteAll: "SetMuteAll", setProfanityFiltering: "SetProfanityFiltering", setTranslateToLanguages: "SetTranslateToLanguages", setUseTTS: "SetUseTTS" };
}), QCe, x3r = Qe(() => {
  QCe = class e3e {
    constructor(t) {
      this.privCommandResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new e3e(t);
    }
    get type() {
      return this.privCommandResponse.type;
    }
    get command() {
      return this.privCommandResponse.command;
    }
    get id() {
      return this.privCommandResponse.id;
    }
    get nickname() {
      return this.privCommandResponse.nickname;
    }
    get participantId() {
      return this.privCommandResponse.participantId;
    }
    get roomid() {
      return this.privCommandResponse.roomid;
    }
    get value() {
      return this.privCommandResponse.value;
    }
  };
}), t3e, r3e, N3r = Qe(() => {
  t3e = class n3e {
    constructor(t) {
      this.privParticipantsPayloadResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new n3e(t);
    }
    get roomid() {
      return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
      return this.privParticipantsPayloadResponse.id;
    }
    get command() {
      return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
      return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
      return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
      return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
      return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
      return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
      return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
      return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
      return this.privParticipantsPayloadResponse.type;
    }
  }, r3e = class i3e {
    constructor(t) {
      this.privParticipantPayloadResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new i3e(t);
    }
    get nickname() {
      return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
      return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
      return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
      return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
      return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
      return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
      return this.privParticipantPayloadResponse.avatar;
    }
  };
}), o3e, a3e, L3r = Qe(() => {
  o3e = class u3e {
    constructor(t) {
      this.privSpeechResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new u3e(t);
    }
    get recognition() {
      return this.privSpeechResponse.recognition;
    }
    get translations() {
      return this.privSpeechResponse.translations;
    }
    get id() {
      return this.privSpeechResponse.id;
    }
    get language() {
      return this.privSpeechResponse.language;
    }
    get nickname() {
      return this.privSpeechResponse.nickname;
    }
    get participantId() {
      return this.privSpeechResponse.participantId;
    }
    get roomid() {
      return this.privSpeechResponse.roomid;
    }
    get timestamp() {
      return this.privSpeechResponse.timestamp;
    }
    get type() {
      return this.privSpeechResponse.type;
    }
    get isFinal() {
      return this.privSpeechResponse.type === "final";
    }
  }, a3e = class s3e {
    constructor(t) {
      this.privTextResponse = JSON.parse(t);
    }
    static fromJSON(t) {
      return new s3e(t);
    }
    get originalText() {
      return this.privTextResponse.originalText;
    }
    get translations() {
      return this.privTextResponse.translations;
    }
    get id() {
      return this.privTextResponse.id;
    }
    get language() {
      return this.privTextResponse.language;
    }
    get nickname() {
      return this.privTextResponse.nickname;
    }
    get participantId() {
      return this.privTextResponse.participantId;
    }
    get roomid() {
      return this.privTextResponse.roomid;
    }
    get timestamp() {
      return this.privTextResponse.timestamp;
    }
    get type() {
      return this.privTextResponse.type;
    }
  };
}), B3r = Qe(() => {
  x3r(), N3r(), L3r();
}), Nl, c3e, k3r = Qe(() => {
  vr(), Kt(), hr(), zCe(), P3r(), D3r(), ZCe(), B3r(), Nl = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, c3e = class extends ys {
    constructor(e, t, r, n, i) {
      super(e, t, r, n, i), this.privLastPartialUtteranceId = "", this.noOp = () => {
      }, this.privConversationServiceConnector = i, this.privConversationAuthentication = e, this.receiveMessageOverride = this.receiveConversationMessageOverride, this.recognizeOverride = this.noOp, this.postConnectImplOverride = this.conversationConnectImpl, this.configConnectionOverride = this.configConnection, this.disconnectOverride = this.privDisconnect, this.privConversationRequestSession = new GCe(jn()), this.privConversationConnectionFactory = t, this.privConversationIsDisposed = !1;
    }
    isDisposed() {
      return super.isDisposed() || this.privConversationIsDisposed;
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return Nl(this, void 0, void 0, function* () {
        this.privConversationIsDisposed = !0, this.privConnectionConfigPromise && (yield (yield this.privConnectionConfigPromise).dispose(e)), yield t.dispose.call(this, e);
      });
    }
    sendMessage(e) {
      return Nl(this, void 0, void 0, function* () {
        return (yield this.fetchConnection()).send(new TT(br.Text, e));
      });
    }
    sendMessageAsync(e) {
      return Nl(this, void 0, void 0, function* () {
        new Kn(), yield (yield this.fetchConnection()).send(new TT(br.Text, e));
      });
    }
    privDisconnect() {
      if (!this.terminateMessageLoop) return this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, oi.Error, dr.NoError, "Disconnecting"), this.terminateMessageLoop = !0, Promise.resolve();
    }
    processTypeSpecificMessages(e, t, r) {
      return Nl(this, void 0, void 0, function* () {
        return !0;
      });
    }
    cancelRecognition(e, t, r, n, i) {
      this.terminateMessageLoop = !0;
      let o = new v2(r, i, n, void 0, e);
      try {
        this.privConversationServiceConnector.canceled && this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, o);
      } catch {
      }
    }
    conversationConnectImpl(e) {
      return Nl(this, void 0, void 0, function* () {
        return this.privConnectionLoop = this.startMessageLoop(), e;
      });
    }
    receiveConversationMessageOverride() {
      return Nl(this, void 0, void 0, function* () {
        if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
        let e = new Kn();
        try {
          let t = yield (yield this.fetchConnection()).read();
          if (this.isDisposed() || this.terminateMessageLoop) return e.resolve(), Promise.resolve();
          if (!t) return this.receiveConversationMessageOverride();
          let r = this.privConversationRequestSession.sessionId, n = !1;
          try {
            switch (t.conversationMessageType.toLowerCase()) {
              case "info":
              case "participant_command":
              case "command":
                let i = QCe.fromJSON(t.textBody);
                switch (i.command.toLowerCase()) {
                  case "participantlist":
                    let c = t3e.fromJSON(t.textBody), l = c.participants.map((h) => ({ avatar: h.avatar, displayName: h.nickname, id: h.participantId, isHost: h.ishost, isMuted: h.ismuted, isUsingTts: h.usetts, preferredLanguage: h.locale }));
                    this.privConversationServiceConnector.participantsListReceived && this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new XCe(c.roomid, c.token, c.translateTo, c.profanityFilter, c.roomProfanityFilter, c.roomLocked, c.muteAll, l, r));
                    break;
                  case "settranslatetolanguages":
                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new up(i.participantId, Zo.setTranslateToLanguages, i.value, r));
                    break;
                  case "setprofanityfiltering":
                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new up(i.participantId, Zo.setProfanityFiltering, i.value, r));
                    break;
                  case "setmute":
                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new up(i.participantId, Zo.setMute, i.value, r));
                    break;
                  case "setmuteall":
                    this.privConversationServiceConnector.muteAllCommandReceived && this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new WCe(i.value, r));
                    break;
                  case "roomexpirationwarning":
                    this.privConversationServiceConnector.conversationExpiration && this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new I$(i.value, this.privConversationRequestSession.sessionId));
                    break;
                  case "setusetts":
                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new up(i.participantId, Zo.setUseTTS, i.value, r));
                    break;
                  case "setlockstate":
                    this.privConversationServiceConnector.lockRoomCommandReceived && this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new KCe(i.value, r));
                    break;
                  case "changenickname":
                    this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new up(i.participantId, Zo.changeNickname, i.nickname, r));
                    break;
                  case "joinsession":
                    let f = r3e.fromJSON(t.textBody), d = { avatar: f.avatar, displayName: f.nickname, id: f.participantId, isHost: f.ishost, isMuted: f.ismuted, isUsingTts: f.usetts, preferredLanguage: f.locale };
                    this.privConversationServiceConnector.participantJoinCommandReceived && this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new O8(d, r));
                    break;
                  case "leavesession":
                    let p = { id: i.participantId };
                    this.privConversationServiceConnector.participantLeaveCommandReceived && this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new O8(p, r));
                    break;
                  case "disconnectsession":
                    let v = { id: i.participantId };
                    break;
                  default:
                    break;
                }
                break;
              case "partial":
              case "final":
                let o = o3e.fromJSON(t.textBody), a = new bb(o.participantId, this.getTranslations(o.translations), o.language, void 0, void 0, o.recognition, void 0, void 0, t.textBody, void 0);
                o.isFinal ? ((a.text !== void 0 && a.text.length > 0 || o.id === this.privLastPartialUtteranceId) && (n = !0), n && this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new uS(Ja.final, a, r))) : a.text !== void 0 && (this.privLastPartialUtteranceId = o.id, this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new uS(Ja.partial, a, r)));
                break;
              case "translated_message":
                let u = a3e.fromJSON(t.textBody), s = new bb(u.participantId, this.getTranslations(u.translations), u.language, void 0, void 0, u.originalText, void 0, void 0, void 0, t.textBody, void 0);
                this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new uS(Ja.instantMessage, s, r));
                break;
              default:
                break;
            }
          } catch {
          }
          return this.receiveConversationMessageOverride();
        } catch {
          this.terminateMessageLoop = !0;
        }
        return e.promise;
      });
    }
    startMessageLoop() {
      return Nl(this, void 0, void 0, function* () {
        if (this.isDisposed()) return Promise.resolve();
        this.terminateMessageLoop = !1;
        let e = this.receiveConversationMessageOverride();
        try {
          return yield e;
        } catch (t) {
          return this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", oi.Error, dr.RuntimeError, t), null;
        }
      });
    }
    configConnection() {
      return this.isDisposed() ? Promise.resolve(void 0) : this.privConnectionConfigPromise ? this.privConnectionConfigPromise.then((e) => e.state() === qi.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigPromise = null, this.configConnection()) : this.privConnectionConfigPromise, (e) => (this.privConnectionId = null, this.privConnectionConfigPromise = null, this.configConnection())) : this.terminateMessageLoop ? Promise.resolve(void 0) : (this.privConnectionConfigPromise = this.connectImpl().then((e) => e), this.privConnectionConfigPromise);
    }
    getTranslations(e) {
      let t;
      if (e !== void 0) {
        t = new p2();
        for (let r of e) t.set(r.lang, r.translation);
      }
      return t;
    }
  };
}), x5, l3e, Que, M3r = Qe(() => {
  hr(), vr(), rn(), Kt(), w3r(), k3r(), VCe(), x5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, l3e = class {
    static fromConfig(e, t) {
      return new Que(e, t);
    }
  }, Que = class extends g0 {
    constructor(e, t) {
      let r = e;
      nt.throwIfNull(r, "speechConfig"), super(t, r.properties, new YCe()), this.privIsDisposed = !1, this.privProperties = r.properties.clone(), this.privConnection = m$.fromRecognizer(this);
    }
    set connected(e) {
      this.privConnection.connected = e;
    }
    set disconnected(e) {
      this.privConnection.disconnected = e;
    }
    get speechRecognitionLanguage() {
      return this.privSpeechRecognitionLanguage;
    }
    get properties() {
      return this.privProperties;
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    connect(e, t, r) {
      try {
        nt.throwIfDisposed(this.privIsDisposed), nt.throwIfNullOrWhitespace(e, "token"), this.privReco.conversationTranslatorToken = e, this.privReco.connectAsync(t, r);
      } catch (n) {
        if (r) if (n instanceof Error) {
          let i = n;
          r(i.name + ": " + i.message);
        } else r(n);
      }
    }
    disconnect(e, t) {
      try {
        nt.throwIfDisposed(this.privIsDisposed), this.privReco.disconnect().then(() => {
          e && e();
        }, (r) => {
          t && t(r);
        });
      } catch (r) {
        if (t) if (r instanceof Error) {
          let n = r;
          t(n.name + ": " + n.message);
        } else t(r);
        this.dispose(!0).catch((n) => {
          ci.instance.onEvent(new ec(n));
        });
      }
    }
    sendRequest(e, t, r) {
      try {
        nt.throwIfDisposed(this.privIsDisposed), this.sendMessage(e, t, r);
      } catch (n) {
        if (r) if (n instanceof Error) {
          let i = n;
          r(i.name + ": " + i.message);
        } else r(n);
        this.dispose(!0).catch((i) => {
          ci.instance.onEvent(new ec(i));
        });
      }
    }
    close() {
      var e, t;
      return x5(this, void 0, void 0, function* () {
        nt.throwIfDisposed(this.privIsDisposed), (e = this.privConnection) === null || e === void 0 || e.closeConnection(), (t = this.privConnection) === null || t === void 0 || t.close(), this.privConnection = void 0, yield this.dispose(!0);
      });
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return x5(this, void 0, void 0, function* () {
        this.privIsDisposed || e && (this.privIsDisposed = !0, this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close(), this.privConnection = void 0), yield t.dispose.call(this, e));
      });
    }
    createRecognizerConfig(e) {
      return new Sd(e, this.privProperties);
    }
    createServiceRecognizer(e, t, r, n) {
      let i = r;
      return new c3e(e, t, i, n, this);
    }
    sendMessage(e, t, r) {
      let n = this.privReco;
      I3r(n.sendMessageAsync(e), t, r);
    }
  };
}), s4, f3e, F3r = Qe(() => {
  vr(), rn(), Kt(), hr(), s4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, f3e = class extends g0 {
    constructor(e, t) {
      let r = e;
      nt.throwIfNull(r, "speechTranslationConfig"), nt.throwIfNullOrWhitespace(r.speechRecognitionLanguage, ke[ke.SpeechServiceConnection_RecoLanguage]), super(t, r.properties, new fCe()), this.privDisposedRecognizer = !1;
    }
    getConversationInfo() {
      return nt.throwIfNullOrUndefined(this.privConversation, "Conversation"), this.privConversation.conversationInfo;
    }
    get authorizationToken() {
      return this.properties.getProperty(ke.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(e) {
      nt.throwIfNullOrWhitespace(e, "token"), this.properties.setProperty(ke.SpeechServiceAuthorization_Token, e);
    }
    set conversation(e) {
      nt.throwIfNullOrUndefined(e, "Conversation"), this.privConversation = e;
    }
    get speechRecognitionLanguage() {
      return nt.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(ke.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
      return this.privProperties;
    }
    startContinuousRecognitionAsync(e, t) {
      wr(this.startContinuousRecognitionAsyncImpl(Qo.Conversation), e, t);
    }
    stopContinuousRecognitionAsync(e, t) {
      wr(this.stopContinuousRecognitionAsyncImpl(), e, t);
    }
    close() {
      return s4(this, void 0, void 0, function* () {
        nt.throwIfDisposed(this.privDisposedRecognizer), yield this.dispose(!0);
      });
    }
    pushConversationEvent(e, t) {
      return s4(this, void 0, void 0, function* () {
        let r = this.privReco;
        nt.throwIfNullOrUndefined(r, "serviceRecognizer"), yield r.sendSpeechEventAsync(e, t);
      });
    }
    connectCallbacks(e) {
      this.canceled = (t, r) => {
        e.canceled && e.canceled(e, r);
      }, this.recognizing = (t, r) => {
        e.transcribing && e.transcribing(e, r);
      }, this.recognized = (t, r) => {
        e.transcribed && e.transcribed(e, r);
      }, this.sessionStarted = (t, r) => {
        e.sessionStarted && e.sessionStarted(e, r);
      }, this.sessionStopped = (t, r) => {
        e.sessionStopped && e.sessionStopped(e, r);
      };
    }
    disconnectCallbacks() {
      this.canceled = void 0, this.recognizing = void 0, this.recognized = void 0, this.sessionStarted = void 0, this.sessionStopped = void 0;
    }
    dispose(e) {
      let t = Object.create(null, { dispose: { get: () => super.dispose } });
      return s4(this, void 0, void 0, function* () {
        this.privDisposedRecognizer || (e && (this.privDisposedRecognizer = !0, yield this.implRecognizerStop()), yield t.dispose.call(this, e));
      });
    }
    createRecognizerConfig(e) {
      return new Sd(e, this.properties);
    }
    createServiceRecognizer(e, t, r, n) {
      let i = r;
      return new CCe(e, t, i, n, this);
    }
  };
}), H3r = Qe(() => {
  O3r(), F$(), M3r(), F3r(), ZCe();
}), x1, d3e, $3r = Qe(() => {
  (function(e) {
    e.WordBoundary = "WordBoundary", e.Bookmark = "Bookmark", e.Viseme = "Viseme";
  })(x1 || (x1 = {})), d3e = class p3e {
    constructor(t) {
      this.privSynthesisAudioMetadata = JSON.parse(t);
    }
    static fromJSON(t) {
      return new p3e(t);
    }
    get Metadata() {
      return this.privSynthesisAudioMetadata.Metadata;
    }
  };
}), Hs, zf, h3e = Qe(() => {
  vr(), Kt(), hr(), E2(), Hs = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, zf = class v3e {
    constructor(t, r, n, i, o) {
      if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.sendSynthesisContext = (a) => {
        let u = this.synthesisContext.toJSON();
        if (u) return a.send(new Bi(br.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", u));
      }, this.sendSpeechServiceConfig = (a, u) => {
        if (u) return a.send(new Bi(br.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", u));
      }, this.sendSsmlMessage = (a, u, s) => a.send(new Bi(br.Text, "ssml", s, "application/ssml+xml", u)), !t) throw new Ji("authentication");
      if (!r) throw new Ji("connectionFactory");
      if (!n) throw new Ji("synthesizerConfig");
      this.privAuthentication = t, this.privConnectionFactory = r, this.privSynthesizerConfig = n, this.privIsDisposed = !1, this.privSpeechSynthesizer = i, this.privSessionAudioDestination = o, this.privSynthesisTurn = new T3e(), this.privConnectionEvents = new su(), this.privServiceEvents = new su(), this.privSynthesisContext = new _3e(this.privSpeechSynthesizer), this.privAgentConfig = new k$(), this.connectionEvents.attach((a) => {
        if (a.name === "ConnectionClosedEvent") {
          let u = a;
          u.statusCode !== 1e3 && this.cancelSynthesisLocal(oi.Error, u.statusCode === 1007 ? dr.BadRequestParameters : dr.ConnectionFailure, u.reason + " websocket error code: " + u.statusCode);
        }
      });
    }
    get synthesisContext() {
      return this.privSynthesisContext;
    }
    get agentConfig() {
      return this.privAgentConfig;
    }
    get connectionEvents() {
      return this.privConnectionEvents;
    }
    get serviceEvents() {
      return this.privServiceEvents;
    }
    set activityTemplate(t) {
      this.privActivityTemplate = t;
    }
    get activityTemplate() {
      return this.privActivityTemplate;
    }
    set audioOutputFormat(t) {
      this.privAudioOutputFormat = t, this.privSynthesisTurn.audioOutputFormat = t, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = t), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = t);
    }
    static addHeader(t, r) {
      if (!r.hasHeader) return t;
      r.updateHeader(t.byteLength);
      let n = new Uint8Array(t.byteLength + r.header.byteLength);
      return n.set(new Uint8Array(r.header), 0), n.set(new Uint8Array(t), r.header.byteLength), n.buffer;
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose(t) {
      return Hs(this, void 0, void 0, function* () {
        this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise && (yield (yield this.privConnectionConfigurationPromise).dispose(t));
      });
    }
    connect() {
      return Hs(this, void 0, void 0, function* () {
        yield this.connectImpl();
      });
    }
    sendNetworkMessage(t, r) {
      return Hs(this, void 0, void 0, function* () {
        let n = typeof r == "string" ? br.Text : br.Binary, i = typeof r == "string" ? "application/json" : "";
        return (yield this.fetchConnection()).send(new Bi(n, t, this.privSynthesisTurn.requestId, i, r));
      });
    }
    Speak(t, r, n, i, o, a) {
      return Hs(this, void 0, void 0, function* () {
        let u;
        if (r ? u = t : u = this.privSpeechSynthesizer.buildSsml(t), this.speakOverride !== void 0) return this.speakOverride(u, n, i, o);
        this.privSuccessCallback = i, this.privErrorCallback = o, this.privSynthesisTurn.startNewSynthesis(n, t, r, a);
        try {
          yield this.connectImpl();
          let s = yield this.fetchConnection();
          yield this.sendSynthesisContext(s), yield this.sendSsmlMessage(s, u, n);
          let c = new gp(new mp(n, or.SynthesizingAudioStarted));
          this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, c);
          let l = this.receiveMessage();
        } catch (s) {
          return this.cancelSynthesisLocal(oi.Error, dr.ConnectionFailure, s), Promise.reject(s);
        }
      });
    }
    cancelSynthesis(t, r, n, i) {
      let o = new zn();
      o.setProperty(Fa, dr[n]);
      let a = new mp(t, or.Canceled, void 0, i, o);
      if (this.privSpeechSynthesizer.SynthesisCanceled) {
        let u = new gp(a);
        try {
          this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, u);
        } catch {
        }
      }
      if (this.privSuccessCallback) try {
        this.privSuccessCallback(a);
      } catch {
      }
    }
    cancelSynthesisLocal(t, r, n) {
      this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, t, r, n));
    }
    processTypeSpecificMessages(t, r, n) {
      return !0;
    }
    receiveMessage() {
      return Hs(this, void 0, void 0, function* () {
        try {
          let t = yield (yield this.fetchConnection()).read();
          if (this.receiveMessageOverride !== void 0) return this.receiveMessageOverride();
          if (this.privIsDisposed) return;
          if (!t) return this.privSynthesisTurn.isSynthesizing ? this.receiveMessage() : void 0;
          this.privServiceHasSentMessage = !0;
          let r = Bi.fromConnectionMessage(t);
          if (r.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch (r.path.toLowerCase()) {
            case "turn.start":
              this.privSynthesisTurn.onServiceTurnStartResponse();
              break;
            case "response":
              this.privSynthesisTurn.onServiceResponseMessage(r.textBody);
              break;
            case "audio":
              if (this.privSynthesisTurn.streamId.toLowerCase() === r.streamId.toLowerCase() && r.binaryBody) {
                if (this.privSynthesisTurn.onAudioChunkReceived(r.binaryBody), this.privSpeechSynthesizer.synthesizing) try {
                  let o = v3e.addHeader(r.binaryBody, this.privSynthesisTurn.audioOutputFormat), a = new gp(new mp(this.privSynthesisTurn.requestId, or.SynthesizingAudio, o));
                  this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, a);
                } catch {
                }
                this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(r.binaryBody);
              }
              break;
            case "audio.metadata":
              let n = d3e.fromJSON(r.textBody).Metadata;
              for (let o of n) switch (o.Type) {
                case x1.WordBoundary:
                  this.privSynthesisTurn.onWordBoundaryEvent(o.Data.text.Text);
                  let a = new R$(o.Data.Offset, o.Data.text.Text, o.Data.text.Length, this.privSynthesisTurn.currentTextOffset);
                  if (this.privSpeechSynthesizer.wordBoundary) try {
                    this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, a);
                  } catch {
                  }
                  break;
                case x1.Bookmark:
                  let u = new w$(o.Data.Offset, o.Data.Bookmark);
                  if (this.privSpeechSynthesizer.bookmarkReached) try {
                    this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, u);
                  } catch {
                  }
                  break;
                case x1.Viseme:
                  if (this.privSynthesisTurn.onVisemeMetadataReceived(o), o.Data.IsLastAnimation) {
                    let s = new P$(o.Data.Offset, o.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                    if (this.privSpeechSynthesizer.visemeReceived) try {
                      this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, s);
                    } catch {
                    }
                  }
                  break;
              }
              break;
            case "turn.end":
              this.privSynthesisTurn.onServiceTurnEndResponse();
              let i;
              try {
                let o = yield this.privSynthesisTurn.getAllReceivedAudioWithHeader();
                i = new mp(this.privSynthesisTurn.requestId, or.SynthesizingAudioCompleted, o), this.privSuccessCallback && this.privSuccessCallback(i);
              } catch (o) {
                this.privErrorCallback && this.privErrorCallback(o);
              }
              if (this.privSpeechSynthesizer.synthesisCompleted) try {
                this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new gp(i));
              } catch {
              }
              break;
            default:
              this.processTypeSpecificMessages(r) || this.privServiceEvents && this.serviceEvents.onEvent(new a2(r.path.toLowerCase(), r.textBody));
          }
          return this.receiveMessage();
        } catch {
        }
      });
    }
    connectImpl(t = !1) {
      if (this.privConnectionPromise) return this.privConnectionPromise.then((n) => n.state() === qi.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, (n) => (this.privConnectionId = null, this.privConnectionPromise = null, this.privServiceHasSentMessage = !1, this.connectImpl()));
      this.privAuthFetchEventId = jn(), this.privConnectionId = jn(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
      let r = t ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
      return this.privConnectionPromise = r.then((n) => Hs(this, void 0, void 0, function* () {
        yield this.privSynthesisTurn.onAuthCompleted(!1);
        let i = this.privConnectionFactory.create(this.privSynthesizerConfig, n, this.privConnectionId);
        i.events.attach((a) => {
          this.connectionEvents.onEvent(a);
        });
        let o = yield i.open();
        return o.statusCode === 200 ? (yield this.privSynthesisTurn.onConnectionEstablishCompleted(o.statusCode), Promise.resolve(i)) : o.statusCode === 403 && !t ? this.connectImpl(!0) : (yield this.privSynthesisTurn.onConnectionEstablishCompleted(o.statusCode, o.reason), Promise.reject(`Unable to contact server. StatusCode: ${o.statusCode}, ${this.privSynthesizerConfig.parameters.getProperty(ke.SpeechServiceConnection_Endpoint)} Reason: ${o.reason}`));
      }), (n) => Hs(this, void 0, void 0, function* () {
        throw yield this.privSynthesisTurn.onAuthCompleted(!0, n), new Error(n);
      })), this.privConnectionPromise.catch(() => {
      }), this.privConnectionPromise;
    }
    fetchConnection() {
      return Hs(this, void 0, void 0, function* () {
        return this.privConnectionConfigurationPromise ? this.privConnectionConfigurationPromise.then((t) => t.state() === qi.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, (t) => (this.privConnectionId = null, this.privConnectionConfigurationPromise = null, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), yield this.privConnectionConfigurationPromise);
      });
    }
    configureConnection() {
      return Hs(this, void 0, void 0, function* () {
        let t = yield this.connectImpl();
        return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(t) : (yield this.sendSpeechServiceConfig(t, this.privSynthesizerConfig.SpeechServiceConfig.serialize()), t);
      });
    }
  }, zf.telemetryDataEnabled = !0;
}), c4, E3e, m3e, g3e, U3r = Qe(() => {
  vr(), c4 = class extends el {
    constructor(e, t, r = hn.Info) {
      super(e, r), this.privRequestId = t;
    }
    get requestId() {
      return this.privRequestId;
    }
  }, E3e = class extends c4 {
    constructor(e, t, r) {
      super("SynthesisTriggeredEvent", e), this.privSessionAudioDestinationId = t, this.privTurnAudioDestinationId = r;
    }
    get audioSessionDestinationId() {
      return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
      return this.privTurnAudioDestinationId;
    }
  }, m3e = class extends c4 {
    constructor(e, t) {
      super("ConnectingToSynthesisServiceEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
      return this.privAuthFetchEventId;
    }
  }, g3e = class extends c4 {
    constructor(e, t) {
      super("SynthesisStartedEvent", e), this.privAuthFetchEventId = t;
    }
    get authFetchEventId() {
      return this.privAuthFetchEventId;
    }
  };
}), l4, T3e, V3r = Qe(() => {
  vr(), rv(), h3e(), U3r(), l4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, T3e = class {
    constructor() {
      this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.onPreConnectionStart = (e, t) => {
        this.privAuthFetchEventId = e, this.onEvent(new m3e(this.privRequestId, this.privAuthFetchEventId));
      }, this.onAuthCompleted = (e, t) => {
        e && this.onComplete();
      }, this.onConnectionEstablishCompleted = (e, t) => {
        if (e === 200) {
          this.onEvent(new g3e(this.requestId, this.privAuthFetchEventId)), this.privBytesReceived = 0;
          return;
        } else e === 403 && this.onComplete();
      }, this.onServiceResponseMessage = (e) => {
        let t = JSON.parse(e);
        this.streamId = t.audio.streamId;
      }, this.onServiceTurnEndResponse = () => {
        this.privInTurn = !1, this.privTurnDeferral.resolve(), this.onComplete();
      }, this.onServiceTurnStartResponse = () => {
        this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
        })), this.privInTurn = !0, this.privTurnDeferral = new Kn();
      }, this.dispose = (e) => {
        this.privIsDisposed || (this.privIsDisposed = !0);
      }, this.onEvent = (e) => {
        ci.instance.onEvent(e);
      }, this.onComplete = () => {
        this.privIsSynthesizing && (this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !0, this.privAudioOutputStream.close(), this.privInTurn = !1, this.privTurnAudioDestination !== void 0 && (this.privTurnAudioDestination.close(), this.privTurnAudioDestination = void 0));
      }, this.privRequestId = jn(), this.privTurnDeferral = new Kn(), this.privTurnDeferral.resolve();
    }
    get requestId() {
      return this.privRequestId;
    }
    get streamId() {
      return this.privStreamId;
    }
    set streamId(e) {
      this.privStreamId = e;
    }
    get audioOutputFormat() {
      return this.privAudioOutputFormat;
    }
    set audioOutputFormat(e) {
      this.privAudioOutputFormat = e;
    }
    get turnCompletionPromise() {
      return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
      return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
      return this.privIsSynthesizing;
    }
    get currentTextOffset() {
      return this.privTextOffset;
    }
    get bytesReceived() {
      return this.privBytesReceived;
    }
    getAllReceivedAudio() {
      return l4(this, void 0, void 0, function* () {
        return this.privReceivedAudio ? Promise.resolve(this.privReceivedAudio) : this.privIsSynthesisEnded ? (yield this.readAllAudioFromStream(), Promise.resolve(this.privReceivedAudio)) : null;
      });
    }
    getAllReceivedAudioWithHeader() {
      return l4(this, void 0, void 0, function* () {
        if (this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
        if (!this.privIsSynthesisEnded) return null;
        if (this.audioOutputFormat.hasHeader) {
          let e = yield this.getAllReceivedAudio();
          return this.privReceivedAudioWithHeader = zf.addHeader(e, this.audioOutputFormat), this.privReceivedAudioWithHeader;
        } else return this.getAllReceivedAudio();
      });
    }
    startNewSynthesis(e, t, r, n) {
      this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = e, this.privRawText = t, this.privIsSSML = r, this.privAudioOutputStream = new pb(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privPartialVisemeAnimation = "", n !== void 0 && (this.privTurnAudioDestination = n, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new E3e(this.requestId, void 0, n === void 0 ? void 0 : n.id()));
    }
    onAudioChunkReceived(e) {
      this.isSynthesizing && (this.privAudioOutputStream.write(e), this.privBytesReceived += e.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(e));
    }
    onWordBoundaryEvent(e) {
      this.updateTextOffset(e);
    }
    onVisemeMetadataReceived(e) {
      e.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += e.Data.AnimationChunk);
    }
    onStopSynthesizing() {
      this.onComplete();
    }
    getAndClearVisemeAnimation() {
      let e = this.privPartialVisemeAnimation;
      return this.privPartialVisemeAnimation = "", e;
    }
    updateTextOffset(e) {
      this.privTextOffset >= 0 && (this.privTextOffset = this.privRawText.indexOf(e, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + e.length), this.privIsSSML && this.privRawText.indexOf("<", this.privTextOffset + 1) > this.privRawText.indexOf(">", this.privTextOffset + 1) && this.updateTextOffset(e));
    }
    readAllAudioFromStream() {
      return l4(this, void 0, void 0, function* () {
        if (this.privIsSynthesisEnded) {
          this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
          try {
            yield this.privAudioOutputStream.read(this.privReceivedAudio);
          } catch {
            this.privReceivedAudio = new ArrayBuffer(0);
          }
        }
      });
    }
  };
}), N5, y3e, j3r = Qe(() => {
  hr(), function(e) {
    e[e.Standard = 0] = "Standard", e[e.Custom = 1] = "Custom";
  }(N5 || (N5 = {})), y3e = class {
    constructor(e, t) {
      this.privSynthesisServiceType = N5.Standard, this.privSpeechServiceConfig = e || new ET(new t0(null)), this.privParameters = t;
    }
    get parameters() {
      return this.privParameters;
    }
    get synthesisServiceType() {
      return this.privSynthesisServiceType;
    }
    set synthesisServiceType(e) {
      this.privSynthesisServiceType = e;
    }
    get SpeechServiceConfig() {
      return this.privSpeechServiceConfig;
    }
  };
}), _3e, z3r = Qe(() => {
  _3e = class {
    constructor(e) {
      this.privContext = {}, this.privSpeechSynthesizer = e;
    }
    setSection(e, t) {
      this.privContext[e] = t;
    }
    set audioOutputFormat(e) {
      this.privAudioOutputFormat = e;
    }
    toJSON() {
      let e = this.buildSynthesisContext();
      return this.setSection("synthesis", e), JSON.stringify(this.privContext);
    }
    buildSynthesisContext() {
      return { audio: { metadataOptions: { bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached, sentenceBoundaryEnabled: !1, visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived, wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary }, outputFormat: this.privAudioOutputFormat.requestAudioFormatString }, language: { autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage } };
    }
  };
}), H$, q3r = Qe(() => {
  hr(), H$ = class {
    constructor(e, t) {
      this.privContext = e || new t0(null), this.privParameters = t;
    }
    get parameters() {
      return this.privParameters;
    }
    get Context() {
      return this.privContext;
    }
  };
}), L5, $$, Y3r = Qe(() => {
  hu(), Kt(), L5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, $$ = class {
    constructor(e) {
      let t = e.parameters.getProperty(ke.SpeechServiceConnection_Endpoint, void 0);
      if (!t) {
        let n = e.parameters.getProperty(ke.SpeechServiceConnection_Region, "westus"), i = n && n.toLowerCase().startsWith("china") ? ".azure.cn" : ".microsoft.com";
        t = e.parameters.getProperty(ke.SpeechServiceConnection_Host, "https://" + n + ".api.cognitive" + i + "/speaker/{mode}/v2.0/{dependency}") + "/profiles";
      }
      this.privUri = t;
      let r = Du.requestOptions;
      r.headers[Du.configParams.subscriptionKey] = e.parameters.getProperty(ke.SpeechServiceConnection_Key, void 0), this.privRestAdapter = new I3e(r);
    }
    createProfile(e, t) {
      let r = this.getOperationUri(e);
      return this.privRestAdapter.setHeaders(Du.configParams.contentTypeKey, "application/json"), this.privRestAdapter.request(wa.Post, r, {}, { locale: t });
    }
    createEnrollment(e, t) {
      this.privRestAdapter.setHeaders(Du.configParams.contentTypeKey, "multipart/form-data");
      let r = this.getOperationUri(e.profileType) + "/" + e.profileId + "/enrollments";
      return t.blob.then((n) => this.privRestAdapter.request(wa.File, r, { ignoreMinLength: "true" }, null, n));
    }
    verifySpeaker(e, t) {
      return L5(this, void 0, void 0, function* () {
        this.privRestAdapter.setHeaders(Du.configParams.contentTypeKey, "multipart/form-data");
        let r = this.getOperationUri(e.voiceProfile.profileType) + "/" + e.voiceProfile.profileId + "/verify";
        try {
          let n = yield t.blob;
          return this.privRestAdapter.request(wa.File, r, { ignoreMinLength: "true" }, null, n);
        } catch (n) {
          return Promise.resolve({ data: n });
        }
      });
    }
    identifySpeaker(e, t) {
      return L5(this, void 0, void 0, function* () {
        this.privRestAdapter.setHeaders(Du.configParams.contentTypeKey, "multipart/form-data");
        let r = this.getOperationUri(Ks.TextIndependentIdentification) + "/identifySingleSpeaker";
        try {
          let n = yield t.blob;
          return this.privRestAdapter.request(wa.File, r, { profileIds: e.voiceProfileIds, ignoreMinLength: "true" }, null, n);
        } catch (n) {
          return Promise.resolve({ data: n });
        }
      });
    }
    getProfileStatus(e) {
      let t = `${this.getOperationUri(e.profileType)}/${e.profileId}`;
      return this.privRestAdapter.request(wa.Get, t, {});
    }
    getProfiles(e) {
      let t = this.getOperationUri(e);
      return this.privRestAdapter.request(wa.Get, t, {});
    }
    getAuthorizationPhrases(e) {
      let t = `${this.getOperationUri(Ks.TextDependentVerification)}`.replace("profiles", "phrases") + "/" + e;
      return this.privRestAdapter.request(wa.Get, t, {});
    }
    deleteProfile(e) {
      let t = this.getOperationUri(e.profileType) + "/" + e.profileId;
      return this.privRestAdapter.request(wa.Delete, t, {});
    }
    resetProfile(e) {
      let t = this.getOperationUri(e.profileType) + "/" + e.profileId + "/reset";
      return this.privRestAdapter.request(wa.Post, t, {});
    }
    getOperationUri(e) {
      let t = e === Ks.TextIndependentIdentification ? "identification" : "verification", r = e === Ks.TextDependentVerification ? "text-dependent" : "text-independent";
      return this.privUri.replace("{mode}", t).replace("{dependency}", r);
    }
  };
}), nc, Fa, ch, m2, U$, hr = Qe(() => {
  cbr(), lbr(), u$(), fbr(), dbr(), VCr(), L$(), jCr(), zCr(), qCr(), YCr(), GCr(), WCr(), KCr(), XCr(), JCr(), ZCr(), QCr(), e3r(), t3r(), r3r(), n3r(), i3r(), o3r(), a3r(), u3r(), s3r(), c3r(), l3r(), f3r(), d3r(), h3r(), v3r(), E3r(), m3r(), y3r(), _3r(), H3r(), $3r(), V3r(), h3e(), j3r(), z3r(), q3r(), Y3r(), nc = "OutputFormat", Fa = "CancellationErrorCode", ch = "ServiceProperties", m2 = "ForceDictation", U$ = "OpenRange";
}), Ng, ese, N1, G3r = Qe(() => {
  hr(), vr(), m0(), Ng = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, ese = "MICROPHONE-WorkletSourceUrl", N1 = class uf {
    constructor(t, r, n, i) {
      this.privRecorder = t, this.deviceId = r, this.privStreams = {}, this.turnOn = () => {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new Kn();
        try {
          this.createAudioContext();
        } catch (u) {
          if (u instanceof Error) {
            let s = u;
            this.privInitializeDeferral.reject(s.name + ": " + s.message);
          } else this.privInitializeDeferral.reject(u);
          return this.privInitializeDeferral.promise;
        }
        let o = window.navigator, a = o.getUserMedia || o.webkitGetUserMedia || o.mozGetUserMedia || o.msGetUserMedia;
        if (o.mediaDevices && (a = (u, s, c) => {
          o.mediaDevices.getUserMedia(u).then(s).catch(c);
        }), a) {
          let u = () => {
            this.onEvent(new ih(this.privId)), this.privMediaStream && this.privMediaStream.active ? (this.onEvent(new Hf(this.privId)), this.privInitializeDeferral.resolve()) : a({ audio: this.deviceId ? { deviceId: this.deviceId } : !0, video: !1 }, (s) => {
              this.privMediaStream = s, this.onEvent(new Hf(this.privId)), this.privInitializeDeferral.resolve();
            }, (s) => {
              let c = `Error occurred during microphone initialization: ${s}`;
              this.privInitializeDeferral.reject(c), this.onEvent(new oh(this.privId, c));
            });
          };
          this.privContext.state === "suspended" ? this.privContext.resume().then(u).catch((s) => {
            this.privInitializeDeferral.reject(`Failed to initialize audio context: ${s}`);
          }) : u();
        } else {
          let u = "Browser does not support getUserMedia.";
          this.privInitializeDeferral.reject(u), this.onEvent(new oh(u, ""));
        }
        return this.privInitializeDeferral.promise;
      }, this.id = () => this.privId, this.attach = (o) => (this.onEvent(new $f(this.privId, o)), this.listen(o).then((a) => (this.onEvent(new Uf(this.privId, o)), { detach: () => Ng(this, void 0, void 0, function* () {
        return a.readEnded(), delete this.privStreams[o], this.onEvent(new hs(this.privId, o)), this.turnOff();
      }), id: () => o, read: () => a.read() }))), this.detach = (o) => {
        o && this.privStreams[o] && (this.privStreams[o].close(), delete this.privStreams[o], this.onEvent(new hs(this.privId, o)));
      }, this.listen = (o) => Ng(this, void 0, void 0, function* () {
        yield this.turnOn();
        let a = new Qy(this.privOutputChunkSize, o);
        this.privStreams[o] = a;
        try {
          this.privRecorder.record(this.privContext, this.privMediaStream, a);
        } catch (u) {
          throw this.onEvent(new Zy(this.privId, o, u)), u;
        }
        return a;
      }), this.onEvent = (o) => {
        this.privEvents.onEvent(o), ci.instance.onEvent(o);
      }, this.createAudioContext = () => {
        this.privContext || (this.privContext = Kl.getAudioContext(uf.AUDIOFORMAT.samplesPerSec));
      }, this.privOutputChunkSize = uf.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = n || jn(), this.privEvents = new su(), this.privMediaStream = i || null;
    }
    get format() {
      return Promise.resolve(uf.AUDIOFORMAT);
    }
    get blob() {
      return Promise.reject("Not implemented for Mic input");
    }
    turnOff() {
      return Ng(this, void 0, void 0, function* () {
        for (let t in this.privStreams) if (t) {
          let r = this.privStreams[t];
          r && r.close();
        }
        this.onEvent(new o2(this.privId)), this.privInitializeDeferral && (yield this.privInitializeDeferral, this.privInitializeDeferral = null), yield this.destroyAudioContext();
      });
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return this.getMicrophoneLabel().then((t) => ({ bitspersample: uf.AUDIOFORMAT.bitsPerSample, channelcount: uf.AUDIOFORMAT.channels, connectivity: r0.Unknown, manufacturer: "Speech SDK", model: t, samplerate: uf.AUDIOFORMAT.samplesPerSec, type: tl.Microphones }));
    }
    setProperty(t, r) {
      if (t === ese) this.privRecorder.setWorkletUrl(r);
      else throw new Error("Property '" + t + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
      let t = "microphone";
      if (this.privMicrophoneLabel !== void 0) return Promise.resolve(this.privMicrophoneLabel);
      if (this.privMediaStream === void 0 || !this.privMediaStream.active) return Promise.resolve(t);
      this.privMicrophoneLabel = t;
      let r = this.privMediaStream.getTracks()[0].getSettings().deviceId;
      if (r === void 0) return Promise.resolve(this.privMicrophoneLabel);
      let n = new Kn();
      return navigator.mediaDevices.enumerateDevices().then((i) => {
        for (let o of i) if (o.deviceId === r) {
          this.privMicrophoneLabel = o.label;
          break;
        }
        n.resolve(this.privMicrophoneLabel);
      }, () => n.resolve(this.privMicrophoneLabel)), n.promise;
    }
    destroyAudioContext() {
      return Ng(this, void 0, void 0, function* () {
        if (!this.privContext) return;
        this.privRecorder.releaseMediaResources(this.privContext);
        let t = !1;
        "close" in this.privContext && (t = !0), t ? (yield this.privContext.close(), this.privContext = null) : this.privContext !== null && this.privContext.state === "running" && (yield this.privContext.suspend());
      });
    }
  }, N1.AUDIOFORMAT = Vf.getDefaultInputFormat();
}), f4, A3e, W3r = Qe(() => {
  hr(), vr(), m0(), f4 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, A3e = class {
    constructor(e, t, r) {
      this.privStreams = {}, this.privHeaderEnd = 44, this.turnOn = () => {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
          let n = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
          return this.onEvent(new oh(n, "")), Promise.reject(n);
        }
        this.onEvent(new ih(this.privId)), this.onEvent(new Hf(this.privId));
      }, this.id = () => this.privId, this.attach = (n) => f4(this, void 0, void 0, function* () {
        this.onEvent(new $f(this.privId, n));
        let i = yield this.upload(n);
        return this.onEvent(new Uf(this.privId, n)), Promise.resolve({ detach: () => f4(this, void 0, void 0, function* () {
          i.readEnded(), delete this.privStreams[n], this.onEvent(new hs(this.privId, n)), yield this.turnOff();
        }), id: () => n, read: () => i.read() });
      }), this.detach = (n) => {
        n && this.privStreams[n] && (this.privStreams[n].close(), delete this.privStreams[n], this.onEvent(new hs(this.privId, n)));
      }, this.turnOff = () => {
        for (let n in this.privStreams) if (n) {
          let i = this.privStreams[n];
          i && !i.isClosed && i.close();
        }
        return this.onEvent(new o2(this.privId)), Promise.resolve();
      }, this.onEvent = (n) => {
        this.privEvents.onEvent(n), ci.instance.onEvent(n);
      }, this.privId = r || jn(), this.privEvents = new su(), this.privSource = e, typeof window < "u" && typeof Blob < "u" && this.privSource instanceof Blob ? this.privFilename = e.name : this.privFilename = t || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
      return this.privAudioFormatPromise;
    }
    get blob() {
      return Promise.resolve(this.privSource);
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return this.privAudioFormatPromise.then((e) => Promise.resolve({ bitspersample: e.bitsPerSample, channelcount: e.channels, connectivity: r0.Unknown, manufacturer: "Speech SDK", model: "File", samplerate: e.samplesPerSec, type: tl.File }));
    }
    readHeader() {
      let e = this.privSource.slice(0, 512), t = new Kn(), r = (n) => {
        let i = new DataView(n), o = (f) => String.fromCharCode(i.getUint8(f), i.getUint8(f + 1), i.getUint8(f + 2), i.getUint8(f + 3));
        if (o(0) !== "RIFF") {
          t.reject("Invalid WAV header in file, RIFF was not found");
          return;
        }
        if (o(8) !== "WAVE" || o(12) !== "fmt ") {
          t.reject("Invalid WAV header in file, WAVEfmt was not found");
          return;
        }
        let a = i.getInt32(16, !0), u = i.getUint16(22, !0), s = i.getUint32(24, !0), c = i.getUint16(34, !0), l = 36 + Math.max(a - 16, 0);
        for (; o(l) !== "data"; l += 2) if (l > 504) {
          t.reject("Invalid WAV header in file, data block was not found");
          return;
        }
        this.privHeaderEnd = l + 8, t.resolve(Vf.getWaveFormatPCM(s, c, u));
      };
      if (typeof window < "u" && typeof Blob < "u" && e instanceof Blob) {
        let n = new FileReader();
        n.onload = (i) => {
          let o = i.target.result;
          r(o);
        }, n.readAsArrayBuffer(e);
      } else {
        let n = e;
        r(n.buffer.slice(n.byteOffset, n.byteOffset + n.byteLength));
      }
      return t.promise;
    }
    upload(e) {
      return f4(this, void 0, void 0, function* () {
        let t = (r) => {
          let n = `Error occurred while processing '${this.privFilename}'. ${r}`;
          throw this.onEvent(new Zy(this.privId, e, n)), new Error(n);
        };
        try {
          yield this.turnOn();
          let r = yield this.privAudioFormatPromise, n = new Qy(r.avgBytesPerSec / 10, e);
          this.privStreams[e] = n;
          let i = this.privSource.slice(this.privHeaderEnd), o = (a) => {
            n.isClosed || (n.writeStreamChunk({ buffer: a, isEnd: !1, timeReceived: Date.now() }), n.close());
          };
          if (typeof window < "u" && typeof Blob < "u" && i instanceof Blob) {
            let a = new FileReader();
            a.onerror = (u) => {
              t(u.toString());
            }, a.onload = (u) => {
              let s = u.target.result;
              o(s);
            }, a.readAsArrayBuffer(i);
          } else {
            let a = i;
            o(a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength));
          }
          return n;
        } catch (r) {
          t(r);
        }
      });
    }
  };
}), L1, K3r = Qe(() => {
  vr(), L1 = class {
    constructor() {
      this.record = (e, t, r) => {
        let n = (() => {
          let a = 0;
          try {
            return e.createScriptProcessor(a, 1, 1);
          } catch {
            a = 2048;
            let u = e.sampleRate;
            for (; a < 16384 && u >= 32e3; ) a <<= 1, u >>= 1;
            return e.createScriptProcessor(a, 1, 1);
          }
        })(), i = new USe(e.sampleRate, 16e3);
        n.onaudioprocess = (a) => {
          let u = a.inputBuffer.getChannelData(0);
          if (r && !r.isClosed) {
            let s = i.encode(u);
            s && r.writeStreamChunk({ buffer: s, isEnd: !1, timeReceived: Date.now() });
          }
        };
        let o = e.createMediaStreamSource(t);
        this.privSpeechProcessorScript && e.audioWorklet ? e.audioWorklet.addModule(this.privSpeechProcessorScript).then(() => {
          let a = new AudioWorkletNode(e, "speech-processor");
          a.port.onmessage = (u) => {
            let s = u.data;
            if (r && !r.isClosed) {
              let c = i.encode(s);
              c && r.writeStreamChunk({ buffer: c, isEnd: !1, timeReceived: Date.now() });
            }
          }, o.connect(a), a.connect(e.destination), this.privMediaResources = { scriptProcessorNode: a, source: o, stream: t };
        }).catch(() => {
          o.connect(n), n.connect(e.destination), this.privMediaResources = { scriptProcessorNode: n, source: o, stream: t };
        }) : (o.connect(n), n.connect(e.destination), this.privMediaResources = { scriptProcessorNode: n, source: o, stream: t });
      }, this.releaseMediaResources = (e) => {
        this.privMediaResources && (this.privMediaResources.scriptProcessorNode && (this.privMediaResources.scriptProcessorNode.disconnect(e.destination), this.privMediaResources.scriptProcessorNode = null), this.privMediaResources.source && (this.privMediaResources.source.disconnect(), this.privMediaResources.stream.getTracks().forEach((t) => t.stop()), this.privMediaResources.source = null));
      };
    }
    setWorkletUrl(e) {
      this.privSpeechProcessorScript = e;
    }
  };
}), X3r = ot(() => {
}), J3r = ot(() => {
}), Z3r = ot((e, t) => {
  t.exports = function(r, n) {
    if (n = n.split(":")[0], r = +r, !r) return !1;
    switch (n) {
      case "http":
      case "ws":
        return r !== 80;
      case "https":
      case "wss":
        return r !== 443;
      case "ftp":
        return r !== 21;
      case "gopher":
        return r !== 70;
      case "file":
        return !1;
    }
    return r !== 0;
  };
}), Q3r = ot((e) => {
  var t = Object.prototype.hasOwnProperty, r;
  function n(u) {
    try {
      return decodeURIComponent(u.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function i(u) {
    try {
      return encodeURIComponent(u);
    } catch {
      return null;
    }
  }
  function o(u) {
    for (var s = /([^=?#&]+)=?([^&]*)/g, c = {}, l; l = s.exec(u); ) {
      var f = n(l[1]), d = n(l[2]);
      f === null || d === null || f in c || (c[f] = d);
    }
    return c;
  }
  function a(u, s) {
    s = s || "";
    var c = [], l, f;
    typeof s != "string" && (s = "?");
    for (f in u) if (t.call(u, f)) {
      if (l = u[f], !l && (l === null || l === r || isNaN(l)) && (l = ""), f = i(f), l = i(l), f === null || l === null) continue;
      c.push(f + "=" + l);
    }
    return c.length ? s + c.join("&") : "";
  }
  e.stringify = a, e.parse = o;
}), e2r = ot((e, t) => {
  var r = Z3r(), n = Q3r(), i = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, o = /[\n\r\t]/g, a = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, u = /:\d+$/, s = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, c = /^[a-zA-Z]:/;
  function l(_) {
    return (_ || "").toString().replace(i, "");
  }
  var f = [["#", "hash"], ["?", "query"], function(_, S) {
    return v(S.protocol) ? _.replace(/\\/g, "/") : _;
  }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d*)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]], d = { hash: 1, query: 1 };
  function p(_) {
    var S;
    typeof window < "u" ? S = window : typeof global < "u" ? S = global : typeof self < "u" ? S = self : S = {};
    var A = S.location || {};
    _ = _ || A;
    var O = {}, P = typeof _, U;
    if (_.protocol === "blob:") O = new m(unescape(_.pathname), {});
    else if (P === "string") {
      O = new m(_, {});
      for (U in d) delete O[U];
    } else if (P === "object") {
      for (U in _) U in d || (O[U] = _[U]);
      O.slashes === void 0 && (O.slashes = a.test(_.href));
    }
    return O;
  }
  function v(_) {
    return _ === "file:" || _ === "ftp:" || _ === "http:" || _ === "https:" || _ === "ws:" || _ === "wss:";
  }
  function h(_, S) {
    _ = l(_), _ = _.replace(o, ""), S = S || {};
    var A = s.exec(_), O = A[1] ? A[1].toLowerCase() : "", P = !!A[2], U = !!A[3], z = 0, k;
    return P ? U ? (k = A[2] + A[3] + A[4], z = A[2].length + A[3].length) : (k = A[2] + A[4], z = A[2].length) : U ? (k = A[3] + A[4], z = A[3].length) : k = A[4], O === "file:" ? z >= 2 && (k = k.slice(2)) : v(O) ? k = A[4] : O ? P && (k = k.slice(2)) : z >= 2 && v(S.protocol) && (k = A[4]), { protocol: O, slashes: P || v(O), slashesCount: z, rest: k };
  }
  function E(_, S) {
    if (_ === "") return S;
    for (var A = (S || "/").split("/").slice(0, -1).concat(_.split("/")), O = A.length, P = A[O - 1], U = !1, z = 0; O--; ) A[O] === "." ? A.splice(O, 1) : A[O] === ".." ? (A.splice(O, 1), z++) : z && (O === 0 && (U = !0), A.splice(O, 1), z--);
    return U && A.unshift(""), (P === "." || P === "..") && A.push(""), A.join("/");
  }
  function m(_, S, A) {
    if (_ = l(_), _ = _.replace(o, ""), !(this instanceof m)) return new m(_, S, A);
    var O, P, U, z, k, H, B = f.slice(), x = typeof S, D = this, w = 0;
    for (x !== "object" && x !== "string" && (A = S, S = null), A && typeof A != "function" && (A = n.parse), S = p(S), P = h(_ || "", S), O = !P.protocol && !P.slashes, D.slashes = P.slashes || O && S.slashes, D.protocol = P.protocol || S.protocol || "", _ = P.rest, (P.protocol === "file:" && (P.slashesCount !== 2 || c.test(_)) || !P.slashes && (P.protocol || P.slashesCount < 2 || !v(D.protocol))) && (B[3] = [/(.*)/, "pathname"]); w < B.length; w++) {
      if (z = B[w], typeof z == "function") {
        _ = z(_, D);
        continue;
      }
      U = z[0], H = z[1], U !== U ? D[H] = _ : typeof U == "string" ? (k = U === "@" ? _.lastIndexOf(U) : _.indexOf(U), ~k && (typeof z[2] == "number" ? (D[H] = _.slice(0, k), _ = _.slice(k + z[2])) : (D[H] = _.slice(k), _ = _.slice(0, k)))) : (k = U.exec(_)) && (D[H] = k[1], _ = _.slice(0, k.index)), D[H] = D[H] || O && z[3] && S[H] || "", z[4] && (D[H] = D[H].toLowerCase());
    }
    A && (D.query = A(D.query)), O && S.slashes && D.pathname.charAt(0) !== "/" && (D.pathname !== "" || S.pathname !== "") && (D.pathname = E(D.pathname, S.pathname)), D.pathname.charAt(0) !== "/" && v(D.protocol) && (D.pathname = "/" + D.pathname), r(D.port, D.protocol) || (D.host = D.hostname, D.port = ""), D.username = D.password = "", D.auth && (k = D.auth.indexOf(":"), ~k ? (D.username = D.auth.slice(0, k), D.username = encodeURIComponent(decodeURIComponent(D.username)), D.password = D.auth.slice(k + 1), D.password = encodeURIComponent(decodeURIComponent(D.password))) : D.username = encodeURIComponent(decodeURIComponent(D.auth)), D.auth = D.password ? D.username + ":" + D.password : D.username), D.origin = D.protocol !== "file:" && v(D.protocol) && D.host ? D.protocol + "//" + D.host : "null", D.href = D.toString();
  }
  function g(_, S, A) {
    var O = this;
    switch (_) {
      case "query":
        typeof S == "string" && S.length && (S = (A || n.parse)(S)), O[_] = S;
        break;
      case "port":
        O[_] = S, r(S, O.protocol) ? S && (O.host = O.hostname + ":" + S) : (O.host = O.hostname, O[_] = "");
        break;
      case "hostname":
        O[_] = S, O.port && (S += ":" + O.port), O.host = S;
        break;
      case "host":
        O[_] = S, u.test(S) ? (S = S.split(":"), O.port = S.pop(), O.hostname = S.join(":")) : (O.hostname = S, O.port = "");
        break;
      case "protocol":
        O.protocol = S.toLowerCase(), O.slashes = !A;
        break;
      case "pathname":
      case "hash":
        if (S) {
          var P = _ === "pathname" ? "/" : "#";
          O[_] = S.charAt(0) !== P ? P + S : S;
        } else O[_] = S;
        break;
      case "username":
      case "password":
        O[_] = encodeURIComponent(S);
        break;
      case "auth":
        var U = S.indexOf(":");
        ~U ? (O.username = S.slice(0, U), O.username = encodeURIComponent(decodeURIComponent(O.username)), O.password = S.slice(U + 1), O.password = encodeURIComponent(decodeURIComponent(O.password))) : O.username = encodeURIComponent(decodeURIComponent(S));
    }
    for (var z = 0; z < f.length; z++) {
      var k = f[z];
      k[4] && (O[k[1]] = O[k[1]].toLowerCase());
    }
    return O.auth = O.password ? O.username + ":" + O.password : O.username, O.origin = O.protocol !== "file:" && v(O.protocol) && O.host ? O.protocol + "//" + O.host : "null", O.href = O.toString(), O;
  }
  function y(_) {
    (!_ || typeof _ != "function") && (_ = n.stringify);
    var S, A = this, O = A.host, P = A.protocol;
    P && P.charAt(P.length - 1) !== ":" && (P += ":");
    var U = P + (A.protocol && A.slashes || v(A.protocol) ? "//" : "");
    return A.username ? (U += A.username, A.password && (U += ":" + A.password), U += "@") : A.password ? (U += ":" + A.password, U += "@") : A.protocol !== "file:" && v(A.protocol) && !O && A.pathname !== "/" && (U += "@"), (O[O.length - 1] === ":" || u.test(A.hostname) && !A.port) && (O += ":"), U += O + A.pathname, S = typeof A.query == "object" ? _(A.query) : A.query, S && (U += S.charAt(0) !== "?" ? "?" + S : S), A.hash && (U += A.hash), U;
  }
  m.prototype = { set: g, toString: y }, m.extractProtocol = h, m.location = p, m.trimLeft = l, m.qs = n, t.exports = m;
}), t2r = ot(() => {
}), r2r = ot(() => {
}), n2r = ot(() => {
}), i2r = ot(() => {
}), o2r = ot(() => {
}), tse, rse, nse, ise, Qd, sp, a2r = Qe(() => {
  Qa(J3r()), tse = Qa(e2r()), Qa(t2r()), vr(), rse = Qa(r2r()), nse = Qa(n2r()), ise = Qa(i2r()), Qa(o2r()), rbe(), Qd = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, sp = class Bo {
    constructor(t) {
      t && (this.privProxyInfo = t), Bo.privDiskCache || (Bo.privDiskCache = new nse.default("microsoft-cognitiveservices-speech-sdk-cache", { supportBuffer: !0, location: void 0 }));
    }
    static forceReinitDiskCache() {
      Bo.privDiskCache = void 0, Bo.privMemCache = {};
    }
    GetAgent(t) {
      let r = new rse.default.Agent(this.CreateConnection);
      if (this.privProxyInfo !== void 0 && this.privProxyInfo.HostName !== void 0 && this.privProxyInfo.Port > 0) {
        let n = "privProxyInfo";
        r[n] = this.privProxyInfo;
      }
      return r;
    }
    static GetProxyAgent(t) {
      let r = { host: t.HostName, port: t.Port };
      return t.UserName ? r.headers = { "Proxy-Authentication": "Basic " + new Buffer(t.UserName + ":" + (t.Password === void 0) ? "" : t.Password).toString("base64") } : r.headers = {}, r.headers.requestOCSP = "true", new ise.default(r);
    }
    static OCSPCheck(t, r) {
      return Qd(this, void 0, void 0, function* () {
        let n, i, o = !1, a = yield t;
        a.cork();
        let u = a;
        return new Promise((s, c) => {
          a.on("OCSPResponse", (l) => {
            l && (this.onEvent(new KSe()), i = l);
          }), a.on("error", (l) => {
            o || (o = !0, a.destroy(), c(l));
          }), u.on("secure", () => Qd(this, void 0, void 0, function* () {
            let l = u.getPeerCertificate(!0);
            try {
              let f = yield this.GetIssuer(l);
              n = (void 0).generate(l.raw, f.raw);
              let d = n.id.toString("hex");
              i || (i = yield Bo.GetResponseFromCache(d, n, r)), yield this.VerifyOCSPResponse(i, n, r), a.uncork(), o = !0, s(a);
            } catch (f) {
              a.destroy(), o = !0, c(f);
            }
          }));
        });
      });
    }
    static GetIssuer(t) {
      return t.issuerCertificate ? Promise.resolve(t.issuerCertificate) : new Promise((r, n) => {
        new (void 0)({}).fetchIssuer(t, null, (i, o) => {
          if (i) {
            n(i);
            return;
          }
          r(o);
        });
      });
    }
    static GetResponseFromCache(t, r, n) {
      return Qd(this, void 0, void 0, function* () {
        let i = Bo.privMemCache[t];
        if (i && this.onEvent(new VSe(t)), !i) try {
          let o = yield Bo.privDiskCache.get(t);
          o.isCached && (Bo.onEvent(new zSe(t)), Bo.StoreMemoryCacheEntry(t, o.value), i = o.value);
        } catch {
          i = null;
        }
        if (!i) return i;
        try {
          let o = (void 0).parseResponse(i).value.tbsResponseData;
          if (o.responses.length < 1) {
            this.onEvent(new p8(t, "Not enough data in cached response"));
            return;
          }
          let a = o.responses[0].thisUpdate, u = o.responses[0].nextUpdate;
          if (u < Date.now() + this.testTimeOffset - 6e4) this.onEvent(new XSe(t, u)), i = null;
          else {
            let s = Math.min(864e5, (u - a) / 2);
            u - (Date.now() + this.testTimeOffset) < s ? (this.onEvent(new JSe(t, a, u)), this.UpdateCache(r, n).catch((c) => {
              this.onEvent(new tbe(t, c.toString()));
            })) : this.onEvent(new ZSe(t, a, u));
          }
        } catch (o) {
          this.onEvent(new p8(t, o)), i = null;
        }
        return i || this.onEvent(new jSe(t)), i;
      });
    }
    static VerifyOCSPResponse(t, r, n) {
      return Qd(this, void 0, void 0, function* () {
        let i = t;
        return r.certID.toString("hex"), i || (i = yield Bo.GetOCSPResponse(r, n)), new Promise((o, a) => {
          (void 0)({ request: r, response: i }, (u, s) => {
            u ? (Bo.onEvent(new QSe(r.id.toString("hex"), u)), t ? this.VerifyOCSPResponse(null, r, n).then(() => {
              o();
            }, (c) => {
              a(c);
            }) : a(u)) : (t || Bo.StoreCacheEntry(r.id.toString("hex"), i), o());
          });
        });
      });
    }
    static UpdateCache(t, r) {
      return Qd(this, void 0, void 0, function* () {
        let n = t.id.toString("hex");
        this.onEvent(new qSe(n));
        let i = yield this.GetOCSPResponse(t, r);
        this.StoreCacheEntry(n, i), this.onEvent(new WSe(t.id.toString("hex")));
      });
    }
    static StoreCacheEntry(t, r) {
      this.StoreMemoryCacheEntry(t, r), this.StoreDiskCacheEntry(t, r);
    }
    static StoreMemoryCacheEntry(t, r) {
      this.privMemCache[t] = r, this.onEvent(new YSe(t));
    }
    static StoreDiskCacheEntry(t, r) {
      this.privDiskCache.set(t, r).then(() => {
        this.onEvent(new GSe(t));
      });
    }
    static GetOCSPResponse(t, r) {
      let n = "1.3.6.1.5.5.7.48.1", i = {};
      if (r) {
        let o = Bo.GetProxyAgent(r);
        i.agent = o;
      }
      return new Promise((o, a) => {
        (void 0).getAuthorityInfo(t.cert, n, (u, s) => {
          if (u) {
            a(u);
            return;
          }
          let c = tse.default(s);
          c.path = c.pathname, i = Object.assign(Object.assign({}, i), c), (void 0).getResponse(i, t.data, (l, f) => {
            if (l) {
              a(l);
              return;
            }
            this.onEvent(new ebe(t.certID.toString("hex"))), o(f);
          });
        });
      });
    }
    CreateConnection(t, r) {
      let n = typeof process < "u" && !0 && !0 && r.secureEndpoint, i;
      if (r = Object.assign(Object.assign({}, r), { requestOCSP: !Bo.forceDisableOCSPStapling, servername: r.host }), this.privProxyInfo) {
        let o = Bo.GetProxyAgent(this.privProxyInfo);
        i = new Promise((a, u) => {
          o.callback(t, r, (s, c) => {
            s ? u(s) : a(c);
          });
        });
      } else r.secureEndpoint, i = Promise.resolve((void 0)(r));
      return n ? Bo.OCSPCheck(i, this.privProxyInfo) : i;
    }
  }, sp.testTimeOffset = 0, sp.forceDisableOCSPStapling = !1, sp.privMemCache = {}, sp.onEvent = (e) => {
    ci.instance.onEvent(e);
  };
}), ose, B5, R8, S3e = Qe(() => {
  Tc(), vr(), ose = Qa(X3r()), a2r(), B5 = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, R8 = class b3e {
    constructor(t, r, n, i, o, a) {
      if (this.open = () => {
        if (this.privConnectionState === qi.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new Kn(), this.privCertificateValidatedDeferral = new Kn(), this.privConnectionState = qi.Connecting;
        try {
          if (typeof WebSocket < "u" && !b3e.forceNpmWebSocket) this.privCertificateValidatedDeferral.resolve(), this.privWebsocketClient = new WebSocket(this.privUri);
          else {
            let u = { headers: this.privHeaders, perMessageDeflate: this.privEnableCompression };
            this.privCertificateValidatedDeferral.resolve();
            let s = new sp(this.proxyInfo);
            u.agent = s.GetAgent(), this.privWebsocketClient = new ose.default(this.privUri, u);
          }
          this.privWebsocketClient.binaryType = "arraybuffer", this.privReceivingMessageQueue = new ah(), this.privDisconnectDeferral = new Kn(), this.privSendMessageQueue = new ah(), this.processSendQueue().catch((u) => {
            ci.instance.onEvent(new ec(u));
          });
        } catch (u) {
          return this.privConnectionEstablishDeferral.resolve(new eS(500, u)), this.privConnectionEstablishDeferral.promise;
        }
        return this.onEvent(new r$(this.privConnectionId, this.privUri)), this.privWebsocketClient.onopen = (u) => {
          this.privCertificateValidatedDeferral.promise.then(() => {
            this.privConnectionState = qi.Connected, this.onEvent(new n$(this.privConnectionId)), this.privConnectionEstablishDeferral.resolve(new eS(200, ""));
          }, (s) => {
            this.privConnectionEstablishDeferral.reject(s);
          });
        }, this.privWebsocketClient.onerror = (u) => {
          this.onEvent(new DSe(this.privConnectionId, u.message, u.type)), this.privLastErrorReceived = u.message;
        }, this.privWebsocketClient.onclose = (u) => {
          this.privConnectionState === qi.Connecting ? (this.privConnectionState = qi.Disconnected, this.privConnectionEstablishDeferral.resolve(new eS(u.code, u.reason + " " + this.privLastErrorReceived))) : (this.privConnectionState = qi.Disconnected, this.privWebsocketClient = null, this.onEvent(new PSe(this.privConnectionId, u.code, u.reason))), this.onClose(u.code, u.reason).catch((s) => {
            ci.instance.onEvent(new ec(s));
          });
        }, this.privWebsocketClient.onmessage = (u) => {
          let s = (/* @__PURE__ */ new Date()).toISOString();
          if (this.privConnectionState === qi.Connected) {
            let c = new Kn();
            if (this.privReceivingMessageQueue.enqueueFromPromise(c.promise), u.data instanceof ArrayBuffer) {
              let l = new uh(br.Binary, u.data);
              this.privMessageFormatter.toConnectionMessage(l).then((f) => {
                this.onEvent(new fb(this.privConnectionId, s, f)), c.resolve(f);
              }, (f) => {
                c.reject(`Invalid binary message format. Error: ${f}`);
              });
            } else {
              let l = new uh(br.Text, u.data);
              this.privMessageFormatter.toConnectionMessage(l).then((f) => {
                this.onEvent(new fb(this.privConnectionId, s, f)), c.resolve(f);
              }, (f) => {
                c.reject(`Invalid text message format. Error: ${f}`);
              });
            }
          }
        }, this.privConnectionEstablishDeferral.promise;
      }, this.send = (u) => {
        if (this.privConnectionState !== qi.Connected) return Promise.reject(`Cannot send on connection that is in ${qi[this.privConnectionState]} state`);
        let s = new Kn(), c = new Kn();
        return this.privSendMessageQueue.enqueueFromPromise(c.promise), this.privMessageFormatter.fromConnectionMessage(u).then((l) => {
          c.resolve({ Message: u, RawWebsocketMessage: l, sendStatusDeferral: s });
        }, (l) => {
          c.reject(`Error formatting the message. ${l}`);
        }), s.promise;
      }, this.read = () => this.privConnectionState !== qi.Connected ? Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`) : this.privReceivingMessageQueue.dequeue(), this.close = (u) => {
        if (this.privWebsocketClient) this.privConnectionState !== qi.Disconnected && this.privWebsocketClient.close(1e3, u || "Normal closure by client");
        else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
      }, this.sendRawMessage = (u) => {
        try {
          if (!u) return Promise.resolve();
          if (this.onEvent(new NSe(this.privConnectionId, (/* @__PURE__ */ new Date()).toISOString(), u.Message)), this.isWebsocketOpen) this.privWebsocketClient.send(u.RawWebsocketMessage.payload);
          else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + u.Message.id + " " + new Error().stack);
          return Promise.resolve();
        } catch (s) {
          return Promise.reject(`websocket send error: ${s}`);
        }
      }, this.onEvent = (u) => {
        this.privConnectionEvents.onEvent(u), ci.instance.onEvent(u);
      }, !t) throw new Ji("uri");
      if (!n) throw new Ji("messageFormatter");
      this.proxyInfo = i, this.privConnectionEvents = new su(), this.privConnectionId = r, this.privMessageFormatter = n, this.privConnectionState = qi.None, this.privUri = t, this.privHeaders = o, this.privEnableCompression = a, this.privHeaders[wn.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
    }
    get state() {
      return this.privConnectionState;
    }
    get events() {
      return this.privConnectionEvents;
    }
    onClose(t, r) {
      return B5(this, void 0, void 0, function* () {
        let n = `Connection closed. ${t}: ${r}`;
        this.privConnectionState = qi.Disconnected, this.privDisconnectDeferral.resolve(), yield this.privReceivingMessageQueue.drainAndDispose((i) => {
        }, n), yield this.privSendMessageQueue.drainAndDispose((i) => {
          i.sendStatusDeferral.reject(n);
        }, n);
      });
    }
    processSendQueue() {
      return B5(this, void 0, void 0, function* () {
        for (; ; ) {
          let t = yield this.privSendMessageQueue.dequeue();
          if (!t) return;
          try {
            yield this.sendRawMessage(t), t.sendStatusDeferral.resolve();
          } catch (r) {
            t.sendStatusDeferral.reject(r);
          }
        }
      });
    }
    get isWebsocketOpen() {
      return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
  }, R8.forceNpmWebSocket = !1;
}), ase, T0, u2r = Qe(() => {
  vr(), S3e(), ase = function(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(a) {
        a(o);
      });
    }
    return new (r || (r = Promise))(function(o, a) {
      function u(l) {
        try {
          c(n.next(l));
        } catch (f) {
          a(f);
        }
      }
      function s(l) {
        try {
          c(n.throw(l));
        } catch (f) {
          a(f);
        }
      }
      function c(l) {
        l.done ? o(l.value) : i(l.value).then(u, s);
      }
      c((n = n.apply(e, t || [])).next());
    });
  }, T0 = class {
    constructor(e, t, r, n, i, o = !1, a) {
      if (this.privIsDisposed = !1, this.isDisposed = () => this.privIsDisposed, this.state = () => this.privConnectionMessageAdapter.state, this.open = () => this.privConnectionMessageAdapter.open(), this.send = (c) => this.privConnectionMessageAdapter.send(c), this.read = () => this.privConnectionMessageAdapter.read(), !e) throw new Ji("uri");
      if (!n) throw new Ji("messageFormatter");
      this.privMessageFormatter = n;
      let u = "", s = 0;
      if (t) {
        for (let c in t) if (c) {
          u += s === 0 && e.indexOf("?") === -1 ? "?" : "&";
          let l = encodeURIComponent(t[c]);
          u += `${c}=${l}`, s++;
        }
      }
      if (r) {
        for (let c in r) if (c) {
          u += s === 0 && e.indexOf("?") === -1 ? "?" : "&";
          let l = encodeURIComponent(r[c]);
          u += `${c}=${l}`, s++;
        }
      }
      this.privUri = e + u, this.privId = a || jn(), this.privConnectionMessageAdapter = new R8(this.privUri, this.id, this.privMessageFormatter, i, r, o);
    }
    dispose() {
      return ase(this, void 0, void 0, function* () {
        this.privIsDisposed = !0, this.privConnectionMessageAdapter && (yield this.privConnectionMessageAdapter.close());
      });
    }
    get id() {
      return this.privId;
    }
    get events() {
      return this.privConnectionMessageAdapter.events;
    }
  };
}), V$, use, s2r = Qe(() => {
  V$ = class {
    constructor(e, t) {
      this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.id = () => this.privAudioNode.id(), this.privAudioNode = e, this.privBytesPerSecond = t;
    }
    read() {
      if (this.privReplay && this.privBuffers.length !== 0) {
        let e = this.privReplayOffset - this.privBufferStartOffset, t = Math.round(e * this.privBytesPerSecond * 1e-7);
        t % 2 !== 0 && t++;
        let r = 0;
        for (; r < this.privBuffers.length && t >= this.privBuffers[r].chunk.buffer.byteLength; ) t -= this.privBuffers[r++].chunk.buffer.byteLength;
        if (r < this.privBuffers.length) {
          let n = this.privBuffers[r].chunk.buffer.slice(t);
          return this.privReplayOffset += n.byteLength / this.privBytesPerSecond * 1e7, r === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({ buffer: n, isEnd: !1, timeReceived: this.privBuffers[r].chunk.timeReceived });
        }
      }
      return this.privAudioNode.read().then((e) => (e && e.buffer && (this.privBuffers.push(new use(e, this.privBufferSerial++, this.privBufferedBytes)), this.privBufferedBytes += e.buffer.byteLength), e));
    }
    detach() {
      return this.privBuffers = void 0, this.privAudioNode.detach();
    }
    replay() {
      this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
    }
    shrinkBuffers(e) {
      if (this.privBuffers === void 0 || this.privBuffers.length === 0) return;
      this.privLastShrinkOffset = e;
      let t = e - this.privBufferStartOffset, r = Math.round(t * this.privBytesPerSecond * 1e-7), n = 0;
      for (; n < this.privBuffers.length && r >= this.privBuffers[n].chunk.buffer.byteLength; ) r -= this.privBuffers[n++].chunk.buffer.byteLength;
      this.privBufferStartOffset = Math.round(e - r / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(n);
    }
    findTimeAtOffset(e) {
      if (e < this.privBufferStartOffset || this.privBuffers === void 0) return 0;
      for (let t of this.privBuffers) {
        let r = t.byteOffset / this.privBytesPerSecond * 1e7, n = r + t.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
        if (e >= r && e <= n) return t.chunk.timeReceived;
      }
      return 0;
    }
  }, use = class {
    constructor(e, t, r) {
      this.chunk = e, this.serial = t, this.byteOffset = r;
    }
  };
}), y0, c2r = Qe(() => {
  Kt(), y0 = class C3e {
    constructor(t, r, n, i) {
      this.privProxyHostName = t, this.privProxyPort = r, this.privProxyUserName = n, this.privProxyPassword = i;
    }
    static fromParameters(t) {
      return new C3e(t.getProperty(ke.SpeechServiceConnection_ProxyHostName), parseInt(t.getProperty(ke.SpeechServiceConnection_ProxyPort), 10), t.getProperty(ke.SpeechServiceConnection_ProxyUserName), t.getProperty(ke.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(t) {
      return this.fromParameters(t.parameters);
    }
    get HostName() {
      return this.privProxyHostName;
    }
    get Port() {
      return this.privProxyPort;
    }
    get UserName() {
      return this.privProxyUserName;
    }
    get Password() {
      return this.privProxyPassword;
    }
  };
}), wa, I3e, l2r = Qe(() => {
  vr(), Qa(UCe()), function(e) {
    e.Get = "get", e.Post = "post", e.Delete = "delete", e.File = "file";
  }(wa || (wa = {})), I3e = class {
    constructor(e, t) {
      if (!e) throw new Ji("configParams");
      this.privHeaders = e.headers, this.privTimeout = e.timeout, this.privIgnoreCache = e.ignoreCache;
    }
    setHeaders(e, t) {
      this.privHeaders[e] = t;
    }
    request(e, t, r = {}, n = null, i = null) {
      let o = new Kn(), a;
      typeof XMLHttpRequest > "u" ? a = new (void 0)() : a = new XMLHttpRequest();
      let u = e === wa.File ? "post" : e;
      return a.open(u, this.withQuery(t, r), !0), this.privHeaders && Object.keys(this.privHeaders).forEach((s) => a.setRequestHeader(s, this.privHeaders[s])), this.privIgnoreCache && a.setRequestHeader("Cache-Control", "no-cache"), a.timeout = this.privTimeout, a.onload = () => {
        o.resolve(this.parseXHRResult(a));
      }, a.onerror = () => {
        o.resolve(this.errorResponse(a, "Failed to make request."));
      }, a.ontimeout = () => {
        o.resolve(this.errorResponse(a, "Request took longer than expected."));
      }, e === wa.File && i ? (a.setRequestHeader("Content-Type", "multipart/form-data"), a.send(i)) : e === wa.Post && n ? (a.setRequestHeader("Content-Type", "application/json"), a.send(JSON.stringify(n))) : a.send(), o.promise;
    }
    parseXHRResult(e) {
      return { data: e.responseText, headers: e.getAllResponseHeaders(), json: () => JSON.parse(e.responseText), ok: e.status >= 200 && e.status < 300, status: e.status, statusText: e.statusText };
    }
    errorResponse(e, t = null) {
      return { data: t || e.statusText, headers: e.getAllResponseHeaders(), json: () => JSON.parse(t || '"' + e.statusText + '"'), ok: !1, status: e.status, statusText: e.statusText };
    }
    withQuery(e, t = {}) {
      let r = this.queryParams(t);
      return r ? e + (e.indexOf("?") === -1 ? "?" : "&") + r : e;
    }
    queryParams(e = {}) {
      return Object.keys(e).map((t) => encodeURIComponent(t) + "=" + encodeURIComponent(e[t])).join("&");
    }
  };
}), hu = Qe(() => {
  ubr(), sbr(), G3r(), W3r(), K3r(), u2r(), S3e(), s2r(), c2r(), l2r(), M$();
}), O3e = {};
a7(O3e, { ActivityReceivedEventArgs: () => T$, AudioConfig: () => Xl, AudioInputStream: () => wp, AudioOutputStream: () => P1, AudioStreamFormat: () => Vf, AutoDetectSourceLanguageConfig: () => Vbe, AutoDetectSourceLanguageResult: () => jbe, BaseAudioPlayer: () => Nbe, BotFrameworkConfig: () => Rbe, CancellationDetails: () => Abe, CancellationDetailsBase: () => nv, CancellationErrorCode: () => dr, CancellationReason: () => oi, Connection: () => m$, ConnectionEventArgs: () => Ab, ConnectionMessage: () => bbe, ConnectionMessageEventArgs: () => Sb, Conversation: () => A8, ConversationExpirationEventArgs: () => I$, ConversationParticipantsChangedEventArgs: () => df, ConversationTranscriber: () => Zbe, ConversationTranscriptionCanceledEventArgs: () => D$, ConversationTranscriptionEventArgs: () => lbe, ConversationTranslationCanceledEventArgs: () => v2, ConversationTranslationEventArgs: () => D1, ConversationTranslationResult: () => bb, ConversationTranslator: () => Jbe, CustomCommandsConfig: () => wbe, DialogServiceConfig: () => ma, DialogServiceConnector: () => Pbe, IntentRecognitionCanceledEventArgs: () => v$, IntentRecognitionEventArgs: () => yf, IntentRecognitionResult: () => lf, IntentRecognizer: () => gbe, KeywordRecognitionModel: () => cbe, LanguageUnderstandingModel: () => v8, NoMatchDetails: () => Tbe, NoMatchReason: () => _f, OutputFormat: () => vi, Participant: () => O$, ParticipantChangedReason: () => $l, PhraseListGrammar: () => Ibe, ProfanityOption: () => jf, PronunciationAssessmentConfig: () => nCe, PronunciationAssessmentGradingSystem: () => hT, PronunciationAssessmentGranularity: () => vT, PronunciationAssessmentResult: () => oCe, PropertyCollection: () => zn, PropertyId: () => ke, PullAudioInputStream: () => nS, PullAudioInputStreamCallback: () => f$, PullAudioOutputStream: () => Pp, PushAudioInputStream: () => rS, PushAudioOutputStream: () => hb, PushAudioOutputStreamCallback: () => c2, RecognitionEventArgs: () => Ts, RecognitionResult: () => l2, Recognizer: () => g0, ResultReason: () => or, ServiceEventArgs: () => E$, ServicePropertyChannel: () => y8, SessionEventArgs: () => $o, SourceLanguageConfig: () => qbe, SpeakerAudioDestination: () => Cb, SpeakerIdentificationModel: () => S$, SpeakerRecognitionCancellationDetails: () => Gbe, SpeakerRecognitionResult: () => C$, SpeakerRecognitionResultType: () => xp, SpeakerRecognizer: () => Hbe, SpeakerVerificationModel: () => b$, SpeechConfig: () => Tb, SpeechConfigImpl: () => ff, SpeechRecognitionCanceledEventArgs: () => d2, SpeechRecognitionEventArgs: () => tc, SpeechRecognitionResult: () => ra, SpeechRecognizer: () => Ebe, SpeechSynthesisBookmarkEventArgs: () => w$, SpeechSynthesisEventArgs: () => gp, SpeechSynthesisOutputFormat: () => Wr, SpeechSynthesisResult: () => mp, SpeechSynthesisVisemeEventArgs: () => P$, SpeechSynthesisWordBoundaryEventArgs: () => R$, SpeechSynthesizer: () => rCe, SpeechTranslationConfig: () => yb, SpeechTranslationConfigImpl: () => ap, TranslationRecognitionCanceledEventArgs: () => _b, TranslationRecognitionEventArgs: () => Eb, TranslationRecognitionResult: () => Dp, TranslationRecognizer: () => h$, TranslationSynthesisEventArgs: () => mb, TranslationSynthesisResult: () => gb, Translations: () => p2, TurnStatusReceivedEventArgs: () => y$, User: () => Qbe, VoiceProfile: () => _$, VoiceProfileAuthorizationPhraseResult: () => A$, VoiceProfileCancellationDetails: () => kbe, VoiceProfileClient: () => Fbe, VoiceProfileEnrollmentCancellationDetails: () => Lbe, VoiceProfileEnrollmentResult: () => Ep, VoiceProfileResult: () => h2, VoiceProfileType: () => Ks });
var j$ = Qe(() => {
  hu(), vr(), Kt(), ci.instance.attachListener(new nbe());
}), R3e = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var t = (j$(), u7(O3e)), r = { AudioConfig: t.AudioConfig, OutputFormat: t.OutputFormat, ResultReason: t.ResultReason, SpeechConfig: t.SpeechConfig, SpeechRecognizer: t.SpeechRecognizer };
  e.default = r;
}), f2r = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = u;
  var r = t($Sr()), n = t(R3e()), i = n.default.ResultReason, o = i.RecognizingSpeech, a = i.RecognizedSpeech;
  function u(s) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = c.maxAlternatives, f = l === void 0 ? 1 / 0 : l, d = c.textNormalization, p = d === void 0 ? "display" : d;
    if (s.reason === o || s.reason === a && !s.json.NBest) {
      var v = [{ confidence: 0.5, transcript: s.text }];
      return s.reason === a && (v.isFinal = !0), v;
    } else if (s.reason === a) {
      var h = (0, r.default)((s.json.NBest || []).slice(0, f).map(function(E) {
        var m = E.Confidence, g = E.Display, y = E.ITN, _ = E.Lexical, S = E.MaskedITN;
        return { confidence: m, transcript: p === "itn" ? y : p === "lexical" ? _ : p === "maskeditn" ? S : g };
      }), { isFinal: !0 });
      return h;
    }
    return [];
  }
}), d2r = ot((e, t) => {
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Ro = ot((e, t) => {
  var r = function(n) {
    return n && n.Math == Math && n;
  };
  t.exports = r(typeof globalThis == "object" && globalThis) || r(typeof window == "object" && window) || r(typeof self == "object" && self) || r(typeof global == "object" && global) || /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")();
}), vu = ot((e, t) => {
  t.exports = function(r) {
    try {
      return !!r();
    } catch {
      return !0;
    }
  };
}), g2 = ot((e, t) => {
  var r = vu();
  t.exports = !r(function() {
    var n = (function() {
    }).bind();
    return typeof n != "function" || n.hasOwnProperty("prototype");
  });
}), w3e = ot((e, t) => {
  var r = g2(), n = Function.prototype, i = n.apply, o = n.call;
  t.exports = typeof Reflect == "object" && Reflect.apply || (r ? o.bind(i) : function() {
    return o.apply(i, arguments);
  });
}), ua = ot((e, t) => {
  var r = g2(), n = Function.prototype, i = n.bind, o = n.call, a = r && i.bind(o, o);
  t.exports = r ? function(u) {
    return u && a(u);
  } : function(u) {
    return u && function() {
      return o.apply(u, arguments);
    };
  };
}), P3e = ot((e, t) => {
  var r = typeof document == "object" && document.all, n = typeof r > "u" && r !== void 0;
  t.exports = { all: r, IS_HTMLDDA: n };
}), eo = ot((e, t) => {
  var r = P3e(), n = r.all;
  t.exports = r.IS_HTMLDDA ? function(i) {
    return typeof i == "function" || i === n;
  } : function(i) {
    return typeof i == "function";
  };
}), hl = ot((e, t) => {
  var r = vu();
  t.exports = !r(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] != 7;
  });
}), Eu = ot((e, t) => {
  var r = g2(), n = Function.prototype.call;
  t.exports = r ? n.bind(n) : function() {
    return n.apply(n, arguments);
  };
}), p2r = ot((e) => {
  var t = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, n = r && !t.call({ 1: 2 }, 1);
  e.f = n ? function(i) {
    var o = r(this, i);
    return !!o && o.enumerable;
  } : t;
}), r_ = ot((e, t) => {
  t.exports = function(r, n) {
    return { enumerable: !(r & 1), configurable: !(r & 2), writable: !(r & 4), value: n };
  };
}), z$ = ot((e, t) => {
  var r = ua(), n = r({}.toString), i = r("".slice);
  t.exports = function(o) {
    return i(n(o), 8, -1);
  };
}), h2r = ot((e, t) => {
  var r = ua(), n = vu(), i = z$(), o = Object, a = r("".split);
  t.exports = n(function() {
    return !o("z").propertyIsEnumerable(0);
  }) ? function(u) {
    return i(u) == "String" ? a(u, "") : o(u);
  } : o;
}), T2 = ot((e, t) => {
  t.exports = function(r) {
    return r == null;
  };
}), q$ = ot((e, t) => {
  var r = T2(), n = TypeError;
  t.exports = function(i) {
    if (r(i)) throw n("Can't call method on " + i);
    return i;
  };
}), n_ = ot((e, t) => {
  var r = h2r(), n = q$();
  t.exports = function(i) {
    return r(n(i));
  };
}), vl = ot((e, t) => {
  var r = eo(), n = P3e(), i = n.all;
  t.exports = n.IS_HTMLDDA ? function(o) {
    return typeof o == "object" ? o !== null : r(o) || o === i;
  } : function(o) {
    return typeof o == "object" ? o !== null : r(o);
  };
}), Y$ = ot((e, t) => {
  t.exports = {};
}), yc = ot((e, t) => {
  var r = Y$(), n = Ro(), i = eo(), o = function(a) {
    return i(a) ? a : void 0;
  };
  t.exports = function(a, u) {
    return arguments.length < 2 ? o(r[a]) || o(n[a]) : r[a] && r[a][u] || n[a] && n[a][u];
  };
}), y2 = ot((e, t) => {
  var r = ua();
  t.exports = r({}.isPrototypeOf);
}), _2 = ot((e, t) => {
  var r = yc();
  t.exports = r("navigator", "userAgent") || "";
}), D3e = ot((e, t) => {
  var r = Ro(), n = _2(), i = r.process, o = r.Deno, a = i && i.versions || o && o.version, u = a && a.v8, s, c;
  u && (s = u.split("."), c = s[0] > 0 && s[0] < 4 ? 1 : +(s[0] + s[1])), !c && n && (s = n.match(/Edge\/(\d+)/), (!s || s[1] >= 74) && (s = n.match(/Chrome\/(\d+)/), s && (c = +s[1]))), t.exports = c;
}), x3e = ot((e, t) => {
  var r = D3e(), n = vu();
  t.exports = !!Object.getOwnPropertySymbols && !n(function() {
    var i = Symbol();
    return !String(i) || !(Object(i) instanceof Symbol) || !Symbol.sham && r && r < 41;
  });
}), N3e = ot((e, t) => {
  var r = x3e();
  t.exports = r && !Symbol.sham && typeof Symbol.iterator == "symbol";
}), L3e = ot((e, t) => {
  var r = yc(), n = eo(), i = y2(), o = N3e(), a = Object;
  t.exports = o ? function(u) {
    return typeof u == "symbol";
  } : function(u) {
    var s = r("Symbol");
    return n(s) && i(s.prototype, a(u));
  };
}), A2 = ot((e, t) => {
  var r = String;
  t.exports = function(n) {
    try {
      return r(n);
    } catch {
      return "Object";
    }
  };
}), El = ot((e, t) => {
  var r = eo(), n = A2(), i = TypeError;
  t.exports = function(o) {
    if (r(o)) return o;
    throw i(n(o) + " is not a function");
  };
}), G$ = ot((e, t) => {
  var r = El(), n = T2();
  t.exports = function(i, o) {
    var a = i[o];
    return n(a) ? void 0 : r(a);
  };
}), v2r = ot((e, t) => {
  var r = Eu(), n = eo(), i = vl(), o = TypeError;
  t.exports = function(a, u) {
    var s, c;
    if (u === "string" && n(s = a.toString) && !i(c = r(s, a)) || n(s = a.valueOf) && !i(c = r(s, a)) || u !== "string" && n(s = a.toString) && !i(c = r(s, a))) return c;
    throw o("Can't convert object to primitive value");
  };
}), ml = ot((e, t) => {
  t.exports = !0;
}), E2r = ot((e, t) => {
  var r = Ro(), n = Object.defineProperty;
  t.exports = function(i, o) {
    try {
      n(r, i, { value: o, configurable: !0, writable: !0 });
    } catch {
      r[i] = o;
    }
    return o;
  };
}), W$ = ot((e, t) => {
  var r = Ro(), n = E2r(), i = "__core-js_shared__", o = r[i] || n(i, {});
  t.exports = o;
}), B3e = ot((e, t) => {
  var r = ml(), n = W$();
  (t.exports = function(i, o) {
    return n[i] || (n[i] = o !== void 0 ? o : {});
  })("versions", []).push({ version: "3.25.3", mode: r ? "pure" : "global", copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.25.3/LICENSE", source: "https://github.com/zloirock/core-js" });
}), k3e = ot((e, t) => {
  var r = q$(), n = Object;
  t.exports = function(i) {
    return n(r(i));
  };
}), _c = ot((e, t) => {
  var r = ua(), n = k3e(), i = r({}.hasOwnProperty);
  t.exports = Object.hasOwn || function(o, a) {
    return i(n(o), a);
  };
}), M3e = ot((e, t) => {
  var r = ua(), n = 0, i = Math.random(), o = r(1 .toString);
  t.exports = function(a) {
    return "Symbol(" + (a === void 0 ? "" : a) + ")_" + o(++n + i, 36);
  };
}), qa = ot((e, t) => {
  var r = Ro(), n = B3e(), i = _c(), o = M3e(), a = x3e(), u = N3e(), s = n("wks"), c = r.Symbol, l = c && c.for, f = u ? c : c && c.withoutSetter || o;
  t.exports = function(d) {
    if (!i(s, d) || !(a || typeof s[d] == "string")) {
      var p = "Symbol." + d;
      a && i(c, d) ? s[d] = c[d] : u && l ? s[d] = l(p) : s[d] = f(p);
    }
    return s[d];
  };
}), m2r = ot((e, t) => {
  var r = Eu(), n = vl(), i = L3e(), o = G$(), a = v2r(), u = qa(), s = TypeError, c = u("toPrimitive");
  t.exports = function(l, f) {
    if (!n(l) || i(l)) return l;
    var d = o(l, c), p;
    if (d) {
      if (f === void 0 && (f = "default"), p = r(d, l, f), !n(p) || i(p)) return p;
      throw s("Can't convert object to primitive value");
    }
    return f === void 0 && (f = "number"), a(l, f);
  };
}), F3e = ot((e, t) => {
  var r = m2r(), n = L3e();
  t.exports = function(i) {
    var o = r(i, "string");
    return n(o) ? o : o + "";
  };
}), K$ = ot((e, t) => {
  var r = Ro(), n = vl(), i = r.document, o = n(i) && n(i.createElement);
  t.exports = function(a) {
    return o ? i.createElement(a) : {};
  };
}), H3e = ot((e, t) => {
  var r = hl(), n = vu(), i = K$();
  t.exports = !r && !n(function() {
    return Object.defineProperty(i("div"), "a", { get: function() {
      return 7;
    } }).a != 7;
  });
}), X$ = ot((e) => {
  var t = hl(), r = Eu(), n = p2r(), i = r_(), o = n_(), a = F3e(), u = _c(), s = H3e(), c = Object.getOwnPropertyDescriptor;
  e.f = t ? c : function(l, f) {
    if (l = o(l), f = a(f), s) try {
      return c(l, f);
    } catch {
    }
    if (u(l, f)) return i(!r(n.f, l, f), l[f]);
  };
}), $3e = ot((e, t) => {
  var r = vu(), n = eo(), i = /#|\.prototype\./, o = function(l, f) {
    var d = u[a(l)];
    return d == c ? !0 : d == s ? !1 : n(f) ? r(f) : !!f;
  }, a = o.normalize = function(l) {
    return String(l).replace(i, ".").toLowerCase();
  }, u = o.data = {}, s = o.NATIVE = "N", c = o.POLYFILL = "P";
  t.exports = o;
}), S2 = ot((e, t) => {
  var r = ua(), n = El(), i = g2(), o = r(r.bind);
  t.exports = function(a, u) {
    return n(a), u === void 0 ? a : i ? o(a, u) : function() {
      return a.apply(u, arguments);
    };
  };
}), U3e = ot((e, t) => {
  var r = hl(), n = vu();
  t.exports = r && n(function() {
    return Object.defineProperty(function() {
    }, "prototype", { value: 42, writable: !1 }).prototype != 42;
  });
}), Ac = ot((e, t) => {
  var r = vl(), n = String, i = TypeError;
  t.exports = function(o) {
    if (r(o)) return o;
    throw i(n(o) + " is not an object");
  };
}), av = ot((e) => {
  var t = hl(), r = H3e(), n = U3e(), i = Ac(), o = F3e(), a = TypeError, u = Object.defineProperty, s = Object.getOwnPropertyDescriptor, c = "enumerable", l = "configurable", f = "writable";
  e.f = t ? n ? function(d, p, v) {
    if (i(d), p = o(p), i(v), typeof d == "function" && p === "prototype" && "value" in v && f in v && !v[f]) {
      var h = s(d, p);
      h && h[f] && (d[p] = v.value, v = { configurable: l in v ? v[l] : h[l], enumerable: c in v ? v[c] : h[c], writable: !1 });
    }
    return u(d, p, v);
  } : u : function(d, p, v) {
    if (i(d), p = o(p), i(v), r) try {
      return u(d, p, v);
    } catch {
    }
    if ("get" in v || "set" in v) throw a("Accessors not supported");
    return "value" in v && (d[p] = v.value), d;
  };
}), _0 = ot((e, t) => {
  var r = hl(), n = av(), i = r_();
  t.exports = r ? function(o, a, u) {
    return n.f(o, a, i(1, u));
  } : function(o, a, u) {
    return o[a] = u, o;
  };
}), Os = ot((e, t) => {
  var r = Ro(), n = w3e(), i = ua(), o = eo(), a = X$().f, u = $3e(), s = Y$(), c = S2(), l = _0(), f = _c(), d = function(p) {
    var v = function(h, E, m) {
      if (this instanceof v) {
        switch (arguments.length) {
          case 0:
            return new p();
          case 1:
            return new p(h);
          case 2:
            return new p(h, E);
        }
        return new p(h, E, m);
      }
      return n(p, this, arguments);
    };
    return v.prototype = p.prototype, v;
  };
  t.exports = function(p, v) {
    var h = p.target, E = p.global, m = p.stat, g = p.proto, y = E ? r : m ? r[h] : (r[h] || {}).prototype, _ = E ? s : s[h] || l(s, h, {})[h], S = _.prototype, A, O, P, U, z, k, H, B, x;
    for (U in v) A = u(E ? U : h + (m ? "." : "#") + U, p.forced), O = !A && y && f(y, U), k = _[U], O && (p.dontCallGetSet ? (x = a(y, U), H = x && x.value) : H = y[U]), z = O && H ? H : v[U], !(O && typeof k == typeof z) && (p.bind && O ? B = c(z, r) : p.wrap && O ? B = d(z) : g && o(z) ? B = i(z) : B = z, (p.sham || z && z.sham || k && k.sham) && l(B, "sham", !0), l(_, U, B), g && (P = h + "Prototype", f(s, P) || l(s, P, {}), l(s[P], U, z), p.real && S && !S[U] && l(S, U, z)));
  };
}), J$ = ot((e, t) => {
  var r = B3e(), n = M3e(), i = r("keys");
  t.exports = function(o) {
    return i[o] || (i[o] = n(o));
  };
}), g2r = ot((e, t) => {
  var r = vu();
  t.exports = !r(function() {
    function n() {
    }
    return n.prototype.constructor = null, Object.getPrototypeOf(new n()) !== n.prototype;
  });
}), Z$ = ot((e, t) => {
  var r = _c(), n = eo(), i = k3e(), o = J$(), a = g2r(), u = o("IE_PROTO"), s = Object, c = s.prototype;
  t.exports = a ? s.getPrototypeOf : function(l) {
    var f = i(l);
    if (r(f, u)) return f[u];
    var d = f.constructor;
    return n(d) && f instanceof d ? d.prototype : f instanceof s ? c : null;
  };
}), T2r = ot((e, t) => {
  var r = eo(), n = String, i = TypeError;
  t.exports = function(o) {
    if (typeof o == "object" || r(o)) return o;
    throw i("Can't set " + n(o) + " as a prototype");
  };
}), Q$ = ot((e, t) => {
  var r = ua(), n = Ac(), i = T2r();
  t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var o = !1, a = {}, u;
    try {
      u = r(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), u(a, []), o = a instanceof Array;
    } catch {
    }
    return function(s, c) {
      return n(s), i(c), o ? u(s, c) : s.__proto__ = c, s;
    };
  }() : void 0);
}), y2r = ot((e, t) => {
  var r = Math.ceil, n = Math.floor;
  t.exports = Math.trunc || function(i) {
    var o = +i;
    return (o > 0 ? n : r)(o);
  };
}), eU = ot((e, t) => {
  var r = y2r();
  t.exports = function(n) {
    var i = +n;
    return i !== i || i === 0 ? 0 : r(i);
  };
}), _2r = ot((e, t) => {
  var r = eU(), n = Math.max, i = Math.min;
  t.exports = function(o, a) {
    var u = r(o);
    return u < 0 ? n(u + a, 0) : i(u, a);
  };
}), A2r = ot((e, t) => {
  var r = eU(), n = Math.min;
  t.exports = function(i) {
    return i > 0 ? n(r(i), 9007199254740991) : 0;
  };
}), V3e = ot((e, t) => {
  var r = A2r();
  t.exports = function(n) {
    return r(n.length);
  };
}), S2r = ot((e, t) => {
  var r = n_(), n = _2r(), i = V3e(), o = function(a) {
    return function(u, s, c) {
      var l = r(u), f = i(l), d = n(c, f), p;
      if (a && s != s) {
        for (; f > d; ) if (p = l[d++], p != p) return !0;
      } else for (; f > d; d++) if ((a || d in l) && l[d] === s) return a || d || 0;
      return !a && -1;
    };
  };
  t.exports = { includes: o(!0), indexOf: o(!1) };
}), tU = ot((e, t) => {
  t.exports = {};
}), j3e = ot((e, t) => {
  var r = ua(), n = _c(), i = n_(), o = S2r().indexOf, a = tU(), u = r([].push);
  t.exports = function(s, c) {
    var l = i(s), f = 0, d = [], p;
    for (p in l) !n(a, p) && n(l, p) && u(d, p);
    for (; c.length > f; ) n(l, p = c[f++]) && (~o(d, p) || u(d, p));
    return d;
  };
}), rU = ot((e, t) => {
  t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
}), b2r = ot((e) => {
  var t = j3e(), r = rU(), n = r.concat("length", "prototype");
  e.f = Object.getOwnPropertyNames || function(i) {
    return t(i, n);
  };
}), C2r = ot((e) => {
  e.f = Object.getOwnPropertySymbols;
}), I2r = ot((e, t) => {
  var r = yc(), n = ua(), i = b2r(), o = C2r(), a = Ac(), u = n([].concat);
  t.exports = r("Reflect", "ownKeys") || function(s) {
    var c = i.f(a(s)), l = o.f;
    return l ? u(c, l(s)) : c;
  };
}), O2r = ot((e, t) => {
  var r = _c(), n = I2r(), i = X$(), o = av();
  t.exports = function(a, u, s) {
    for (var c = n(u), l = o.f, f = i.f, d = 0; d < c.length; d++) {
      var p = c[d];
      !r(a, p) && !(s && r(s, p)) && l(a, p, f(u, p));
    }
  };
}), R2r = ot((e, t) => {
  var r = j3e(), n = rU();
  t.exports = Object.keys || function(i) {
    return r(i, n);
  };
}), w2r = ot((e) => {
  var t = hl(), r = U3e(), n = av(), i = Ac(), o = n_(), a = R2r();
  e.f = t && !r ? Object.defineProperties : function(u, s) {
    i(u);
    for (var c = o(s), l = a(s), f = l.length, d = 0, p; f > d; ) n.f(u, p = l[d++], c[p]);
    return u;
  };
}), z3e = ot((e, t) => {
  var r = yc();
  t.exports = r("document", "documentElement");
}), nU = ot((e, t) => {
  var r = Ac(), n = w2r(), i = rU(), o = tU(), a = z3e(), u = K$(), s = J$(), c = ">", l = "<", f = "prototype", d = "script", p = s("IE_PROTO"), v = function() {
  }, h = function(_) {
    return l + d + c + _ + l + "/" + d + c;
  }, E = function(_) {
    _.write(h("")), _.close();
    var S = _.parentWindow.Object;
    return _ = null, S;
  }, m = function() {
    var _ = u("iframe"), S = "java" + d + ":", A;
    return _.style.display = "none", a.appendChild(_), _.src = String(S), A = _.contentWindow.document, A.open(), A.write(h("document.F=Object")), A.close(), A.F;
  }, g, y = function() {
    try {
      g = new ActiveXObject("htmlfile");
    } catch {
    }
    y = typeof document < "u" ? document.domain && g ? E(g) : m() : E(g);
    for (var _ = i.length; _--; ) delete y[f][i[_]];
    return y();
  };
  o[p] = !0, t.exports = Object.create || function(_, S) {
    var A;
    return _ !== null ? (v[f] = r(_), A = new v(), v[f] = null, A[p] = _) : A = y(), S === void 0 ? A : n.f(A, S);
  };
}), P2r = ot((e, t) => {
  var r = ua(), n = Error, i = r("".replace), o = function(s) {
    return String(n(s).stack);
  }("zxcasd"), a = /\n\s*at [^:]*:[^\n]*/, u = a.test(o);
  t.exports = function(s, c) {
    if (u && typeof s == "string" && !n.prepareStackTrace) for (; c--; ) s = i(s, a, "");
    return s;
  };
}), D2r = ot((e, t) => {
  var r = vl(), n = _0();
  t.exports = function(i, o) {
    r(o) && "cause" in o && n(i, "cause", o.cause);
  };
}), uv = ot((e, t) => {
  t.exports = {};
}), x2r = ot((e, t) => {
  var r = qa(), n = uv(), i = r("iterator"), o = Array.prototype;
  t.exports = function(a) {
    return a !== void 0 && (n.Array === a || o[i] === a);
  };
}), iU = ot((e, t) => {
  var r = qa(), n = r("toStringTag"), i = {};
  i[n] = "z", t.exports = String(i) === "[object z]";
}), i_ = ot((e, t) => {
  var r = iU(), n = eo(), i = z$(), o = qa(), a = o("toStringTag"), u = Object, s = i(/* @__PURE__ */ function() {
    return arguments;
  }()) == "Arguments", c = function(l, f) {
    try {
      return l[f];
    } catch {
    }
  };
  t.exports = r ? i : function(l) {
    var f, d, p;
    return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (d = c(f = u(l), a)) == "string" ? d : s ? i(f) : (p = i(f)) == "Object" && n(f.callee) ? "Arguments" : p;
  };
}), q3e = ot((e, t) => {
  var r = i_(), n = G$(), i = T2(), o = uv(), a = qa(), u = a("iterator");
  t.exports = function(s) {
    if (!i(s)) return n(s, u) || n(s, "@@iterator") || o[r(s)];
  };
}), N2r = ot((e, t) => {
  var r = Eu(), n = El(), i = Ac(), o = A2(), a = q3e(), u = TypeError;
  t.exports = function(s, c) {
    var l = arguments.length < 2 ? a(s) : c;
    if (n(l)) return i(r(l, s));
    throw u(o(s) + " is not iterable");
  };
}), L2r = ot((e, t) => {
  var r = Eu(), n = Ac(), i = G$();
  t.exports = function(o, a, u) {
    var s, c;
    n(o);
    try {
      if (s = i(o, "return"), !s) {
        if (a === "throw") throw u;
        return u;
      }
      s = r(s, o);
    } catch (l) {
      c = !0, s = l;
    }
    if (a === "throw") throw u;
    if (c) throw s;
    return n(s), u;
  };
}), o_ = ot((e, t) => {
  var r = S2(), n = Eu(), i = Ac(), o = A2(), a = x2r(), u = V3e(), s = y2(), c = N2r(), l = q3e(), f = L2r(), d = TypeError, p = function(h, E) {
    this.stopped = h, this.result = E;
  }, v = p.prototype;
  t.exports = function(h, E, m) {
    var g = m && m.that, y = !!(m && m.AS_ENTRIES), _ = !!(m && m.IS_RECORD), S = !!(m && m.IS_ITERATOR), A = !!(m && m.INTERRUPTED), O = r(E, g), P, U, z, k, H, B, x, D = function($) {
      return P && f(P, "normal", $), new p(!0, $);
    }, w = function($) {
      return y ? (i($), A ? O($[0], $[1], D) : O($[0], $[1])) : A ? O($, D) : O($);
    };
    if (_) P = h.iterator;
    else if (S) P = h;
    else {
      if (U = l(h), !U) throw d(o(h) + " is not iterable");
      if (a(U)) {
        for (z = 0, k = u(h); k > z; z++) if (H = w(h[z]), H && s(v, H)) return H;
        return new p(!1);
      }
      P = c(h, U);
    }
    for (B = _ ? h.next : P.next; !(x = n(B, P)).done; ) {
      try {
        H = w(x.value);
      } catch ($) {
        f(P, "throw", $);
      }
      if (typeof H == "object" && H && s(v, H)) return H;
    }
    return new p(!1);
  };
}), oU = ot((e, t) => {
  var r = i_(), n = String;
  t.exports = function(i) {
    if (r(i) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return n(i);
  };
}), B2r = ot((e, t) => {
  var r = oU();
  t.exports = function(n, i) {
    return n === void 0 ? arguments.length < 2 ? "" : i : r(n);
  };
}), k2r = ot((e, t) => {
  var r = vu(), n = r_();
  t.exports = !r(function() {
    var i = Error("a");
    return "stack" in i ? (Object.defineProperty(i, "stack", n(1, 7)), i.stack !== 7) : !0;
  });
}), M2r = ot(() => {
  var e = Os(), t = y2(), r = Z$(), n = Q$(), i = O2r(), o = nU(), a = _0(), u = r_(), s = P2r(), c = D2r(), l = o_(), f = B2r(), d = qa(), p = k2r(), v = d("toStringTag"), h = Error, E = [].push, m = function(y, _) {
    var S = arguments.length > 2 ? arguments[2] : void 0, A = t(g, this), O;
    n ? O = n(h(), A ? r(this) : g) : (O = A ? this : o(g), a(O, v, "Error")), _ !== void 0 && a(O, "message", f(_)), p && a(O, "stack", s(O.stack, 1)), c(O, S);
    var P = [];
    return l(y, E, { that: P }), a(O, "errors", P), O;
  };
  n ? n(m, h) : i(m, h, { name: !0 });
  var g = m.prototype = o(h.prototype, { constructor: u(1, m), message: u(1, ""), name: u(1, "AggregateError") });
  e({ global: !0, constructor: !0, arity: 2 }, { AggregateError: m });
}), F2r = ot(() => {
  M2r();
}), H2r = ot((e, t) => {
  t.exports = function() {
  };
}), $2r = ot((e, t) => {
  var r = Ro(), n = eo(), i = r.WeakMap;
  t.exports = n(i) && /native code/.test(String(i));
}), aU = ot((e, t) => {
  var r = $2r(), n = Ro(), i = ua(), o = vl(), a = _0(), u = _c(), s = W$(), c = J$(), l = tU(), f = "Object already initialized", d = n.TypeError, p = n.WeakMap, v, h, E, m = function(P) {
    return E(P) ? h(P) : v(P, {});
  }, g = function(P) {
    return function(U) {
      var z;
      if (!o(U) || (z = h(U)).type !== P) throw d("Incompatible receiver, " + P + " required");
      return z;
    };
  };
  r || s.state ? (y = s.state || (s.state = new p()), _ = i(y.get), S = i(y.has), A = i(y.set), v = function(P, U) {
    if (S(y, P)) throw d(f);
    return U.facade = P, A(y, P, U), U;
  }, h = function(P) {
    return _(y, P) || {};
  }, E = function(P) {
    return S(y, P);
  }) : (O = c("state"), l[O] = !0, v = function(P, U) {
    if (u(P, O)) throw d(f);
    return U.facade = P, a(P, O, U), U;
  }, h = function(P) {
    return u(P, O) ? P[O] : {};
  }, E = function(P) {
    return u(P, O);
  });
  var y, _, S, A, O;
  t.exports = { set: v, get: h, has: E, enforce: m, getterFor: g };
}), U2r = ot((e, t) => {
  var r = hl(), n = _c(), i = Function.prototype, o = r && Object.getOwnPropertyDescriptor, a = n(i, "name"), u = a && (function() {
  }).name === "something", s = a && (!r || r && o(i, "name").configurable);
  t.exports = { EXISTS: a, PROPER: u, CONFIGURABLE: s };
}), a_ = ot((e, t) => {
  var r = _0();
  t.exports = function(n, i, o, a) {
    return a && a.enumerable ? n[i] = o : r(n, i, o), n;
  };
}), Y3e = ot((e, t) => {
  var r = vu(), n = eo(), i = vl(), o = nU(), a = Z$(), u = a_(), s = qa(), c = ml(), l = s("iterator"), f = !1, d, p, v;
  [].keys && (v = [].keys(), "next" in v ? (p = a(a(v)), p !== Object.prototype && (d = p)) : f = !0);
  var h = !i(d) || r(function() {
    var E = {};
    return d[l].call(E) !== E;
  });
  h ? d = {} : c && (d = o(d)), n(d[l]) || u(d, l, function() {
    return this;
  }), t.exports = { IteratorPrototype: d, BUGGY_SAFARI_ITERATORS: f };
}), V2r = ot((e, t) => {
  var r = iU(), n = i_();
  t.exports = r ? {}.toString : function() {
    return "[object " + n(this) + "]";
  };
}), uU = ot((e, t) => {
  var r = iU(), n = av().f, i = _0(), o = _c(), a = V2r(), u = qa(), s = u("toStringTag");
  t.exports = function(c, l, f, d) {
    if (c) {
      var p = f ? c : c.prototype;
      o(p, s) || n(p, s, { configurable: !0, value: l }), d && !r && i(p, "toString", a);
    }
  };
}), j2r = ot((e, t) => {
  var r = Y3e().IteratorPrototype, n = nU(), i = r_(), o = uU(), a = uv(), u = function() {
    return this;
  };
  t.exports = function(s, c, l, f) {
    var d = c + " Iterator";
    return s.prototype = n(r, { next: i(+!f, l) }), o(s, d, !1, !0), a[d] = u, s;
  };
}), G3e = ot((e, t) => {
  var r = Os(), n = Eu(), i = ml(), o = U2r(), a = eo(), u = j2r(), s = Z$(), c = Q$(), l = uU(), f = _0(), d = a_(), p = qa(), v = uv(), h = Y3e(), E = o.PROPER, m = o.CONFIGURABLE, g = h.IteratorPrototype, y = h.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), S = "keys", A = "values", O = "entries", P = function() {
    return this;
  };
  t.exports = function(U, z, k, H, B, x, D) {
    u(k, z, H);
    var w = function(Oe) {
      if (Oe === B && le) return le;
      if (!y && Oe in V) return V[Oe];
      switch (Oe) {
        case S:
          return function() {
            return new k(this, Oe);
          };
        case A:
          return function() {
            return new k(this, Oe);
          };
        case O:
          return function() {
            return new k(this, Oe);
          };
      }
      return function() {
        return new k(this);
      };
    }, $ = z + " Iterator", X = !1, V = U.prototype, F = V[_] || V["@@iterator"] || B && V[B], le = !y && F || w(B), ae = z == "Array" && V.entries || F, ne, ve, Ie;
    if (ae && (ne = s(ae.call(new U())), ne !== Object.prototype && ne.next && (!i && s(ne) !== g && (c ? c(ne, g) : a(ne[_]) || d(ne, _, P)), l(ne, $, !0, !0), i && (v[$] = P))), E && B == A && F && F.name !== A && (!i && m ? f(V, "name", A) : (X = !0, le = function() {
      return n(F, this);
    })), B) if (ve = { values: w(A), keys: x ? le : w(S), entries: w(O) }, D) for (Ie in ve) (y || X || !(Ie in V)) && d(V, Ie, ve[Ie]);
    else r({ target: z, proto: !0, forced: y || X }, ve);
    return (!i || D) && V[_] !== le && d(V, _, le, { name: B }), v[z] = le, ve;
  };
}), W3e = ot((e, t) => {
  t.exports = function(r, n) {
    return { value: r, done: n };
  };
}), K3e = ot((e, t) => {
  var r = n_(), n = H2r(), i = uv(), o = aU(), a = av().f, u = G3e(), s = W3e(), c = ml(), l = hl(), f = "Array Iterator", d = o.set, p = o.getterFor(f);
  t.exports = u(Array, "Array", function(h, E) {
    d(this, { type: f, target: r(h), index: 0, kind: E });
  }, function() {
    var h = p(this), E = h.target, m = h.kind, g = h.index++;
    return !E || g >= E.length ? (h.target = void 0, s(void 0, !0)) : m == "keys" ? s(g, !1) : m == "values" ? s(E[g], !1) : s([g, E[g]], !1);
  }, "values");
  var v = i.Arguments = i.Array;
  if (n("keys"), n("values"), n("entries"), !c && l && v.name !== "values") try {
    a(v, "name", { value: "values" });
  } catch {
  }
}), z2r = ot(() => {
}), b2 = ot((e, t) => {
  var r = z$(), n = Ro();
  t.exports = r(n.process) == "process";
}), q2r = ot((e, t) => {
  var r = yc(), n = av(), i = qa(), o = hl(), a = i("species");
  t.exports = function(u) {
    var s = r(u), c = n.f;
    o && s && !s[a] && c(s, a, { configurable: !0, get: function() {
      return this;
    } });
  };
}), Y2r = ot((e, t) => {
  var r = y2(), n = TypeError;
  t.exports = function(i, o) {
    if (r(o, i)) return i;
    throw n("Incorrect invocation");
  };
}), X3e = ot((e, t) => {
  var r = ua(), n = eo(), i = W$(), o = r(Function.toString);
  n(i.inspectSource) || (i.inspectSource = function(a) {
    return o(a);
  }), t.exports = i.inspectSource;
}), G2r = ot((e, t) => {
  var r = ua(), n = vu(), i = eo(), o = i_(), a = yc(), u = X3e(), s = function() {
  }, c = [], l = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = r(f.exec), p = !f.exec(s), v = function(E) {
    if (!i(E)) return !1;
    try {
      return l(s, c, E), !0;
    } catch {
      return !1;
    }
  }, h = function(E) {
    if (!i(E)) return !1;
    switch (o(E)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return p || !!d(f, u(E));
    } catch {
      return !0;
    }
  };
  h.sham = !0, t.exports = !l || n(function() {
    var E;
    return v(v.call) || !v(Object) || !v(function() {
      E = !0;
    }) || E;
  }) ? h : v;
}), W2r = ot((e, t) => {
  var r = G2r(), n = A2(), i = TypeError;
  t.exports = function(o) {
    if (r(o)) return o;
    throw i(n(o) + " is not a constructor");
  };
}), J3e = ot((e, t) => {
  var r = Ac(), n = W2r(), i = T2(), o = qa(), a = o("species");
  t.exports = function(u, s) {
    var c = r(u).constructor, l;
    return c === void 0 || i(l = r(c)[a]) ? s : n(l);
  };
}), K2r = ot((e, t) => {
  var r = ua();
  t.exports = r([].slice);
}), X2r = ot((e, t) => {
  var r = TypeError;
  t.exports = function(n, i) {
    if (n < i) throw r("Not enough arguments");
    return n;
  };
}), Z3e = ot((e, t) => {
  var r = _2();
  t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(r);
}), Q3e = ot((e, t) => {
  var r = Ro(), n = w3e(), i = S2(), o = eo(), a = _c(), u = vu(), s = z3e(), c = K2r(), l = K$(), f = X2r(), d = Z3e(), p = b2(), v = r.setImmediate, h = r.clearImmediate, E = r.process, m = r.Dispatch, g = r.Function, y = r.MessageChannel, _ = r.String, S = 0, A = {}, O = "onreadystatechange", P, U, z, k;
  try {
    P = r.location;
  } catch {
  }
  var H = function(w) {
    if (a(A, w)) {
      var $ = A[w];
      delete A[w], $();
    }
  }, B = function(w) {
    return function() {
      H(w);
    };
  }, x = function(w) {
    H(w.data);
  }, D = function(w) {
    r.postMessage(_(w), P.protocol + "//" + P.host);
  };
  (!v || !h) && (v = function(w) {
    f(arguments.length, 1);
    var $ = o(w) ? w : g(w), X = c(arguments, 1);
    return A[++S] = function() {
      n($, void 0, X);
    }, U(S), S;
  }, h = function(w) {
    delete A[w];
  }, p ? U = function(w) {
    E.nextTick(B(w));
  } : m && m.now ? U = function(w) {
    m.now(B(w));
  } : y && !d ? (z = new y(), k = z.port2, z.port1.onmessage = x, U = i(k.postMessage, k)) : r.addEventListener && o(r.postMessage) && !r.importScripts && P && P.protocol !== "file:" && !u(D) ? (U = D, r.addEventListener("message", x, !1)) : O in l("script") ? U = function(w) {
    s.appendChild(l("script"))[O] = function() {
      s.removeChild(this), H(w);
    };
  } : U = function(w) {
    setTimeout(B(w), 0);
  }), t.exports = { set: v, clear: h };
}), J2r = ot((e, t) => {
  var r = _2(), n = Ro();
  t.exports = /ipad|iphone|ipod/i.test(r) && n.Pebble !== void 0;
}), Z2r = ot((e, t) => {
  var r = _2();
  t.exports = /web0s(?!.*chrome)/i.test(r);
}), Q2r = ot((e, t) => {
  var r = Ro(), n = S2(), i = X$().f, o = Q3e().set, a = Z3e(), u = J2r(), s = Z2r(), c = b2(), l = r.MutationObserver || r.WebKitMutationObserver, f = r.document, d = r.process, p = r.Promise, v = i(r, "queueMicrotask"), h = v && v.value, E, m, g, y, _, S, A, O;
  h || (E = function() {
    var P, U;
    for (c && (P = d.domain) && P.exit(); m; ) {
      U = m.fn, m = m.next;
      try {
        U();
      } catch (z) {
        throw m ? y() : g = void 0, z;
      }
    }
    g = void 0, P && P.enter();
  }, !a && !c && !s && l && f ? (_ = !0, S = f.createTextNode(""), new l(E).observe(S, { characterData: !0 }), y = function() {
    S.data = _ = !_;
  }) : !u && p && p.resolve ? (A = p.resolve(void 0), A.constructor = p, O = n(A.then, A), y = function() {
    O(E);
  }) : c ? y = function() {
    d.nextTick(E);
  } : (o = n(o, r), y = function() {
    o(E);
  })), t.exports = h || function(P) {
    var U = { fn: P, next: void 0 };
    g && (g.next = U), m || (m = U, y()), g = U;
  };
}), eIr = ot((e, t) => {
  var r = Ro();
  t.exports = function(n, i) {
    var o = r.console;
    o && o.error && (arguments.length == 1 ? o.error(n) : o.error(n, i));
  };
}), u_ = ot((e, t) => {
  t.exports = function(r) {
    try {
      return { error: !1, value: r() };
    } catch (n) {
      return { error: !0, value: n };
    }
  };
}), tIr = ot((e, t) => {
  var r = function() {
    this.head = null, this.tail = null;
  };
  r.prototype = { add: function(n) {
    var i = { item: n, next: null };
    this.head ? this.tail.next = i : this.head = i, this.tail = i;
  }, get: function() {
    var n = this.head;
    if (n) return this.head = n.next, this.tail === n && (this.tail = null), n.item;
  } }, t.exports = r;
}), sv = ot((e, t) => {
  var r = Ro();
  t.exports = r.Promise;
}), e2e = ot((e, t) => {
  t.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
}), rIr = ot((e, t) => {
  var r = e2e(), n = b2();
  t.exports = !r && !n && typeof window == "object" && typeof document == "object";
}), s_ = ot((e, t) => {
  var r = Ro(), n = sv(), i = eo(), o = $3e(), a = X3e(), u = qa(), s = rIr(), c = e2e(), l = ml(), f = D3e(), d = n && n.prototype, p = u("species"), v = !1, h = i(r.PromiseRejectionEvent), E = o("Promise", function() {
    var m = a(n), g = m !== String(n);
    if (!g && f === 66 || l && !(d.catch && d.finally)) return !0;
    if (!f || f < 51 || !/native code/.test(m)) {
      var y = new n(function(A) {
        A(1);
      }), _ = function(A) {
        A(function() {
        }, function() {
        });
      }, S = y.constructor = {};
      if (S[p] = _, v = y.then(function() {
      }) instanceof _, !v) return !0;
    }
    return !g && (s || c) && !h;
  });
  t.exports = { CONSTRUCTOR: E, REJECTION_EVENT: h, SUBCLASSING: v };
}), Id = ot((e, t) => {
  var r = El(), n = TypeError, i = function(o) {
    var a, u;
    this.promise = new o(function(s, c) {
      if (a !== void 0 || u !== void 0) throw n("Bad Promise constructor");
      a = s, u = c;
    }), this.resolve = r(a), this.reject = r(u);
  };
  t.exports.f = function(o) {
    return new i(o);
  };
}), nIr = ot(() => {
  var e = Os(), t = ml(), r = b2(), n = Ro(), i = Eu(), o = a_(), a = Q$(), u = uU(), s = q2r(), c = El(), l = eo(), f = vl(), d = Y2r(), p = J3e(), v = Q3e().set, h = Q2r(), E = eIr(), m = u_(), g = tIr(), y = aU(), _ = sv(), S = s_(), A = Id(), O = "Promise", P = S.CONSTRUCTOR, U = S.REJECTION_EVENT, z = S.SUBCLASSING, k = y.getterFor(O), H = y.set, B = _ && _.prototype, x = _, D = B, w = n.TypeError, $ = n.document, X = n.process, V = A.f, F = V, le = !!($ && $.createEvent && n.dispatchEvent), ae = "unhandledrejection", ne = "rejectionhandled", ve = 0, Ie = 1, Oe = 2, xe = 1, ze = 2, qe, Je, Be, We, Ne = function(ye) {
    var Le;
    return f(ye) && l(Le = ye.then) ? Le : !1;
  }, je = function(ye, Le) {
    var Me = Le.value, Ae = Le.state == Ie, ie = Ae ? ye.ok : ye.fail, K = ye.resolve, Z = ye.reject, Ce = ye.domain, be, Ge, st;
    try {
      ie ? (Ae || (Le.rejection === ze && De(Le), Le.rejection = xe), ie === !0 ? be = Me : (Ce && Ce.enter(), be = ie(Me), Ce && (Ce.exit(), st = !0)), be === ye.promise ? Z(w("Promise-chain cycle")) : (Ge = Ne(be)) ? i(Ge, be, K, Z) : K(be)) : Z(Me);
    } catch (wt) {
      Ce && !st && Ce.exit(), Z(wt);
    }
  }, et = function(ye, Le) {
    ye.notified || (ye.notified = !0, h(function() {
      for (var Me = ye.reactions, Ae; Ae = Me.get(); ) je(Ae, ye);
      ye.notified = !1, Le && !ye.rejection && Ot(ye);
    }));
  }, St = function(ye, Le, Me) {
    var Ae, ie;
    le ? (Ae = $.createEvent("Event"), Ae.promise = Le, Ae.reason = Me, Ae.initEvent(ye, !1, !0), n.dispatchEvent(Ae)) : Ae = { promise: Le, reason: Me }, !U && (ie = n["on" + ye]) ? ie(Ae) : ye === ae && E("Unhandled promise rejection", Me);
  }, Ot = function(ye) {
    i(v, n, function() {
      var Le = ye.facade, Me = ye.value, Ae = we(ye), ie;
      if (Ae && (ie = m(function() {
        r ? X.emit("unhandledRejection", Me, Le) : St(ae, Le, Me);
      }), ye.rejection = r || we(ye) ? ze : xe, ie.error)) throw ie.value;
    });
  }, we = function(ye) {
    return ye.rejection !== xe && !ye.parent;
  }, De = function(ye) {
    i(v, n, function() {
      var Le = ye.facade;
      r ? X.emit("rejectionHandled", Le) : St(ne, Le, ye.value);
    });
  }, Ee = function(ye, Le, Me) {
    return function(Ae) {
      ye(Le, Ae, Me);
    };
  }, te = function(ye, Le, Me) {
    ye.done || (ye.done = !0, Me && (ye = Me), ye.value = Le, ye.state = Oe, et(ye, !0));
  }, ue = function(ye, Le, Me) {
    if (!ye.done) {
      ye.done = !0, Me && (ye = Me);
      try {
        if (ye.facade === Le) throw w("Promise can't be resolved itself");
        var Ae = Ne(Le);
        Ae ? h(function() {
          var ie = { done: !1 };
          try {
            i(Ae, Le, Ee(ue, ie, ye), Ee(te, ie, ye));
          } catch (K) {
            te(ie, K, ye);
          }
        }) : (ye.value = Le, ye.state = Ie, et(ye, !1));
      } catch (ie) {
        te({ done: !1 }, ie, ye);
      }
    }
  };
  if (P && (x = function(ye) {
    d(this, D), c(ye), i(qe, this);
    var Le = k(this);
    try {
      ye(Ee(ue, Le), Ee(te, Le));
    } catch (Me) {
      te(Le, Me);
    }
  }, D = x.prototype, qe = function(ye) {
    H(this, { type: O, done: !1, notified: !1, parent: !1, reactions: new g(), rejection: !1, state: ve, value: void 0 });
  }, qe.prototype = o(D, "then", function(ye, Le) {
    var Me = k(this), Ae = V(p(this, x));
    return Me.parent = !0, Ae.ok = l(ye) ? ye : !0, Ae.fail = l(Le) && Le, Ae.domain = r ? X.domain : void 0, Me.state == ve ? Me.reactions.add(Ae) : h(function() {
      je(Ae, Me);
    }), Ae.promise;
  }), Je = function() {
    var ye = new qe(), Le = k(ye);
    this.promise = ye, this.resolve = Ee(ue, Le), this.reject = Ee(te, Le);
  }, A.f = V = function(ye) {
    return ye === x || ye === Be ? new Je(ye) : F(ye);
  }, !t && l(_) && B !== Object.prototype)) {
    We = B.then, z || o(B, "then", function(ye, Le) {
      var Me = this;
      return new x(function(Ae, ie) {
        i(We, Me, Ae, ie);
      }).then(ye, Le);
    }, { unsafe: !0 });
    try {
      delete B.constructor;
    } catch {
    }
    a && a(B, D);
  }
  e({ global: !0, constructor: !0, wrap: !0, forced: P }, { Promise: x }), u(x, O, !1, !0), s(O);
}), iIr = ot((e, t) => {
  var r = qa(), n = r("iterator"), i = !1;
  try {
    o = 0, a = { next: function() {
      return { done: !!o++ };
    }, return: function() {
      i = !0;
    } }, a[n] = function() {
      return this;
    }, Array.from(a, function() {
      throw 2;
    });
  } catch {
  }
  var o, a;
  t.exports = function(u, s) {
    if (!s && !i) return !1;
    var c = !1;
    try {
      var l = {};
      l[n] = function() {
        return { next: function() {
          return { done: c = !0 };
        } };
      }, u(l);
    } catch {
    }
    return c;
  };
}), t2e = ot((e, t) => {
  var r = sv(), n = iIr(), i = s_().CONSTRUCTOR;
  t.exports = i || !n(function(o) {
    r.all(o).then(void 0, function() {
    });
  });
}), oIr = ot(() => {
  var e = Os(), t = Eu(), r = El(), n = Id(), i = u_(), o = o_(), a = t2e();
  e({ target: "Promise", stat: !0, forced: a }, { all: function(u) {
    var s = this, c = n.f(s), l = c.resolve, f = c.reject, d = i(function() {
      var p = r(s.resolve), v = [], h = 0, E = 1;
      o(u, function(m) {
        var g = h++, y = !1;
        E++, t(p, s, m).then(function(_) {
          y || (y = !0, v[g] = _, --E || l(v));
        }, f);
      }), --E || l(v);
    });
    return d.error && f(d.value), c.promise;
  } });
}), aIr = ot(() => {
  var e = Os(), t = ml(), r = s_().CONSTRUCTOR, n = sv(), i = yc(), o = eo(), a = a_(), u = n && n.prototype;
  e({ target: "Promise", proto: !0, forced: r, real: !0 }, { catch: function(c) {
    return this.then(void 0, c);
  } }), !t && o(n) && (s = i("Promise").prototype.catch, u.catch !== s && a(u, "catch", s, { unsafe: !0 }));
  var s;
}), uIr = ot(() => {
  var e = Os(), t = Eu(), r = El(), n = Id(), i = u_(), o = o_(), a = t2e();
  e({ target: "Promise", stat: !0, forced: a }, { race: function(u) {
    var s = this, c = n.f(s), l = c.reject, f = i(function() {
      var d = r(s.resolve);
      o(u, function(p) {
        t(d, s, p).then(c.resolve, l);
      });
    });
    return f.error && l(f.value), c.promise;
  } });
}), sIr = ot(() => {
  var e = Os(), t = Eu(), r = Id(), n = s_().CONSTRUCTOR;
  e({ target: "Promise", stat: !0, forced: n }, { reject: function(i) {
    var o = r.f(this);
    return t(o.reject, void 0, i), o.promise;
  } });
}), r2e = ot((e, t) => {
  var r = Ac(), n = vl(), i = Id();
  t.exports = function(o, a) {
    if (r(o), n(a) && a.constructor === o) return a;
    var u = i.f(o), s = u.resolve;
    return s(a), u.promise;
  };
}), cIr = ot(() => {
  var e = Os(), t = yc(), r = ml(), n = sv(), i = s_().CONSTRUCTOR, o = r2e(), a = t("Promise"), u = r && !i;
  e({ target: "Promise", stat: !0, forced: r || i }, { resolve: function(s) {
    return o(u && this === a ? n : this, s);
  } });
}), lIr = ot(() => {
  nIr(), oIr(), aIr(), uIr(), sIr(), cIr();
}), fIr = ot(() => {
  var e = Os(), t = Eu(), r = El(), n = Id(), i = u_(), o = o_();
  e({ target: "Promise", stat: !0 }, { allSettled: function(a) {
    var u = this, s = n.f(u), c = s.resolve, l = s.reject, f = i(function() {
      var d = r(u.resolve), p = [], v = 0, h = 1;
      o(a, function(E) {
        var m = v++, g = !1;
        h++, t(d, u, E).then(function(y) {
          g || (g = !0, p[m] = { status: "fulfilled", value: y }, --h || c(p));
        }, function(y) {
          g || (g = !0, p[m] = { status: "rejected", reason: y }, --h || c(p));
        });
      }), --h || c(p);
    });
    return f.error && l(f.value), s.promise;
  } });
}), dIr = ot(() => {
  var e = Os(), t = Eu(), r = El(), n = yc(), i = Id(), o = u_(), a = o_(), u = "No one promise resolved";
  e({ target: "Promise", stat: !0 }, { any: function(s) {
    var c = this, l = n("AggregateError"), f = i.f(c), d = f.resolve, p = f.reject, v = o(function() {
      var h = r(c.resolve), E = [], m = 0, g = 1, y = !1;
      a(s, function(_) {
        var S = m++, A = !1;
        g++, t(h, c, _).then(function(O) {
          A || y || (y = !0, d(O));
        }, function(O) {
          A || y || (A = !0, E[S] = O, --g || p(new l(E, u)));
        });
      }), --g || p(new l(E, u));
    });
    return v.error && p(v.value), f.promise;
  } });
}), pIr = ot(() => {
  var e = Os(), t = ml(), r = sv(), n = vu(), i = yc(), o = eo(), a = J3e(), u = r2e(), s = a_(), c = r && r.prototype, l = !!r && n(function() {
    c.finally.call({ then: function() {
    } }, function() {
    });
  });
  e({ target: "Promise", proto: !0, real: !0, forced: l }, { finally: function(d) {
    var p = a(this, i("Promise")), v = o(d);
    return this.then(v ? function(h) {
      return u(p, d()).then(function() {
        return h;
      });
    } : d, v ? function(h) {
      return u(p, d()).then(function() {
        throw h;
      });
    } : d);
  } }), !t && o(r) && (f = i("Promise").prototype.finally, c.finally !== f && s(c, "finally", f, { unsafe: !0 }));
  var f;
}), hIr = ot((e, t) => {
  var r = ua(), n = eU(), i = oU(), o = q$(), a = r("".charAt), u = r("".charCodeAt), s = r("".slice), c = function(l) {
    return function(f, d) {
      var p = i(o(f)), v = n(d), h = p.length, E, m;
      return v < 0 || v >= h ? l ? "" : void 0 : (E = u(p, v), E < 55296 || E > 56319 || v + 1 === h || (m = u(p, v + 1)) < 56320 || m > 57343 ? l ? a(p, v) : E : l ? s(p, v, v + 2) : (E - 55296 << 10) + (m - 56320) + 65536);
    };
  };
  t.exports = { codeAt: c(!1), charAt: c(!0) };
}), vIr = ot(() => {
  var e = hIr().charAt, t = oU(), r = aU(), n = G3e(), i = W3e(), o = "String Iterator", a = r.set, u = r.getterFor(o);
  n(String, "String", function(s) {
    a(this, { type: o, string: t(s), index: 0 });
  }, function() {
    var s = u(this), c = s.string, l = s.index, f;
    return l >= c.length ? i(void 0, !0) : (f = e(c, l), s.index += f.length, i(f, !1));
  });
}), EIr = ot((e, t) => {
  F2r(), K3e(), z2r(), lIr(), fIr(), dIr(), pIr(), vIr();
  var r = Y$();
  t.exports = r.Promise;
}), mIr = ot((e, t) => {
  t.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
}), gIr = ot(() => {
  K3e();
  var e = mIr(), t = Ro(), r = i_(), n = _0(), i = uv(), o = qa(), a = o("toStringTag");
  for (c in e) u = t[c], s = u && u.prototype, s && r(s) !== a && n(s, a, c), i[c] = i.Array;
  var u, s, c;
}), TIr = ot((e, t) => {
  var r = EIr();
  gIr(), t.exports = r;
}), n2e = ot((e, t) => {
  t.exports = TIr();
}), i2e = ot((e, t) => {
  var r = d2r().default, n = r(n2e());
  function i() {
    var o = {};
    return o.promise = new n.default(function(a, u) {
      o.resolve = a, o.reject = u;
    }), o;
  }
  t.exports = i;
}), yIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n;
  var r = t(i2e());
  function n() {
    var i, o = [], a = function(s) {
      if (i) {
        var c = i, l = c.resolve;
        i = null, l(s);
      } else o.push(s);
    }, u = function() {
      return o.length ? Promise.resolve(o.shift()) : (i || (i = (0, r.default)())).promise;
    };
    return { push: a, shift: u };
  }
}), _Ir = ot((e, t) => {
  function r(n, i) {
    if (n == null) return {};
    var o = {}, a = Object.keys(n), u, s;
    for (s = 0; s < a.length; s++) u = a[s], !(i.indexOf(u) >= 0) && (o[u] = n[u]);
    return o;
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
}), AIr = ot((e, t) => {
  var r = _Ir();
  function n(i, o) {
    if (i == null) return {};
    var a = r(i, o), u, s;
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(i);
      for (s = 0; s < c.length; s++) u = c[s], !(o.indexOf(u) >= 0) && Object.prototype.propertyIsEnumerable.call(i, u) && (a[u] = i[u]);
    }
    return a;
  }
  t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
}), SIr = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
  function t(r) {
    return typeof r == "function" ? r() : r;
  }
}), o2e = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = f;
  var r = t(Ec()), n = t(E0()), i = t(mc()), o = t(AIr()), a = t(SIr()), u = ["authorizationToken", "credentials", "looseEvent", "looseEvents", "region", "subscriptionKey"];
  function s(d, p) {
    var v = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var h = Object.getOwnPropertySymbols(d);
      p && (h = h.filter(function(E) {
        return Object.getOwnPropertyDescriptor(d, E).enumerable;
      })), v.push.apply(v, h);
    }
    return v;
  }
  function c(d) {
    for (var p = 1; p < arguments.length; p++) {
      var v = arguments[p] != null ? arguments[p] : {};
      p % 2 ? s(Object(v), !0).forEach(function(h) {
        (0, n.default)(d, h, v[h]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(v)) : s(Object(v)).forEach(function(h) {
        Object.defineProperty(d, h, Object.getOwnPropertyDescriptor(v, h));
      });
    }
    return d;
  }
  var l = !0;
  function f() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = d.authorizationToken, v = d.credentials, h = d.looseEvent, E = d.looseEvents, m = d.region, g = m === void 0 ? "westus" : m, y = d.subscriptionKey, _ = (0, o.default)(d, u);
    if (typeof h < "u" && (console.warn('web-speech-cognitive-services: The option "looseEvent" should be named as "looseEvents".'), E = h), !v) {
      if (!p && !y) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
      console.warn("web-speech-cognitive-services: We are deprecating authorizationToken, region, and subscriptionKey. Please use credentials instead. The deprecated option will be removed on or after 2020-11-14."), v = function() {
        var S = (0, i.default)(r.default.mark(function A() {
          return r.default.wrap(function(O) {
            for (; ; ) switch (O.prev = O.next) {
              case 0:
                if (!p) {
                  O.next = 8;
                  break;
                }
                return O.next = 3, (0, a.default)(p);
              case 3:
                O.t1 = O.sent, O.t2 = g, O.t0 = { authorizationToken: O.t1, region: O.t2 }, O.next = 13;
                break;
              case 8:
                return O.t3 = g, O.next = 11, (0, a.default)(y);
              case 11:
                O.t4 = O.sent, O.t0 = { region: O.t3, subscriptionKey: O.t4 };
              case 13:
                return O.abrupt("return", O.t0);
              case 14:
              case "end":
                return O.stop();
            }
          }, A);
        }));
        return function() {
          return S.apply(this, arguments);
        };
      }();
    }
    return c(c({}, _), {}, { fetchCredentials: function() {
      var S = (0, i.default)(r.default.mark(function O() {
        var P, U, z, k, H, B, x, D;
        return r.default.wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              return w.next = 2, (0, a.default)(v);
            case 2:
              if (P = w.sent, U = P.authorizationToken, z = P.customVoiceHostname, k = P.region, H = P.speechRecognitionHostname, B = P.speechSynthesisHostname, x = P.subscriptionKey, !(!U && !x || U && x)) {
                w.next = 13;
                break;
              }
              throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
            case 13:
              if (!(!k && !(H && B))) {
                w.next = 17;
                break;
              }
              throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
            case 17:
              if (!(k && (z || H || B))) {
                w.next = 21;
                break;
              }
              throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
            case 21:
              if (!U) {
                w.next = 26;
                break;
              }
              if (typeof U == "string") {
                w.next = 24;
                break;
              }
              throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
            case 24:
              w.next = 28;
              break;
            case 26:
              if (typeof x == "string") {
                w.next = 28;
                break;
              }
              throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
            case 28:
              return l && x && (console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead."), l = !1), D = U ? { authorizationToken: U } : { subscriptionKey: x }, k ? D.region = k : (D.customVoiceHostname = z, D.speechRecognitionHostname = H, D.speechSynthesisHostname = B), w.abrupt("return", D);
            case 32:
            case "end":
              return w.stop();
          }
        }, O);
      }));
      function A() {
        return S.apply(this, arguments);
      }
      return A;
    }(), looseEvents: E });
  }
}), bIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(pl()), n = t(dl()), i = function() {
    function o() {
      (0, r.default)(this, o), this._phrases = [];
    }
    return (0, n.default)(o, [{ key: "addFromString", value: function() {
      throw new Error("JSGF is not supported");
    } }, { key: "phrases", get: function() {
      return this._phrases;
    }, set: function(a) {
      if (Array.isArray(a)) this._phrases = a;
      else if (typeof a == "string") this._phrases = [a];
      else throw new Error("The provided value is not an array or of type 'string'");
    } }]), o;
  }();
  e.default = i;
}), CIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSpeechRecognitionPonyfillFromRecognizer = D, e.default = void 0;
  var r = t(Ec()), n = t(OSe()), i = t(E0()), o = t(mc()), a = t(dl()), u = t(pl()), s = t(Ky()), c = t(Xy()), l = t(yd()), f = i2(), d = t(f2r()), p = t(yIr()), v = t(o2e()), h = t(bIr()), E = t(R3e());
  function m($, X) {
    var V = Object.keys($);
    if (Object.getOwnPropertySymbols) {
      var F = Object.getOwnPropertySymbols($);
      X && (F = F.filter(function(le) {
        return Object.getOwnPropertyDescriptor($, le).enumerable;
      })), V.push.apply(V, F);
    }
    return V;
  }
  function g($) {
    for (var X = 1; X < arguments.length; X++) {
      var V = arguments[X] != null ? arguments[X] : {};
      X % 2 ? m(Object(V), !0).forEach(function(F) {
        (0, i.default)($, F, V[F]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties($, Object.getOwnPropertyDescriptors(V)) : m(Object(V)).forEach(function(F) {
        Object.defineProperty($, F, Object.getOwnPropertyDescriptor(V, F));
      });
    }
    return $;
  }
  function y($) {
    var X = _();
    return function() {
      var V = (0, l.default)($), F;
      if (X) {
        var le = (0, l.default)(this).constructor;
        F = Reflect.construct(V, arguments, le);
      } else F = V.apply(this, arguments);
      return (0, c.default)(this, F);
    };
  }
  function _() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var S = E.default.AudioConfig, A = E.default.OutputFormat, O = E.default.ResultReason, P = E.default.SpeechConfig, U = E.default.SpeechRecognizer;
  function z($) {
    var X = $.duration, V = $.errorDetails, F = $.json, le = $.offset, ae = $.properties, ne = $.reason, ve = $.resultId, Ie = $.text;
    return { duration: X, errorDetails: V, json: JSON.parse(F), offset: le, properties: ae, reason: ne, resultId: ve, text: Ie };
  }
  function k($) {
    var X = new Int16Array($);
    return [].reduce.call(X, function(V, F) {
      return V + Math.abs(F);
    }, 0) / X.length;
  }
  function H($) {
    return function() {
      for (var X = arguments.length, V = new Array(X), F = 0; F < X; F++) V[F] = arguments[F];
      return new Promise(function(le, ae) {
        return $.apply(void 0, V.concat([le, ae]));
      });
    };
  }
  var B = function($) {
    (0, s.default)(V, $);
    var X = y(V);
    function V(F) {
      var le, ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = ae.data, ve = ae.emma, Ie = ae.interpretation, Oe = ae.resultIndex, xe = ae.results;
      return (0, u.default)(this, V), le = X.call(this, F), le.data = ne, le.emma = ve, le.interpretation = Ie, le.resultIndex = Oe, le.results = xe, le;
    }
    return (0, a.default)(V);
  }(f.Event);
  function x($) {
    var X = $.attach, V = $.attach.bind($), F, le;
    return $.attach = (0, o.default)(r.default.mark(function ae() {
      var ne;
      return r.default.wrap(function(ve) {
        for (; ; ) switch (ve.prev = ve.next) {
          case 0:
            return ve.next = 2, V();
          case 2:
            return ne = ve.sent, ve.abrupt("return", g(g({}, ne), {}, { read: function() {
              var Ie = (0, o.default)(r.default.mark(function xe() {
                var ze;
                return r.default.wrap(function(qe) {
                  for (; ; ) switch (qe.prev = qe.next) {
                    case 0:
                      return qe.next = 2, ne.read();
                    case 2:
                      if (ze = qe.sent, !F && k(ze.buffer) > 150 && ($.events.onEvent({ name: "FirstAudibleChunk" }), F = !0), !le) {
                        qe.next = 6;
                        break;
                      }
                      return qe.abrupt("return", { buffer: new ArrayBuffer(0), isEnd: !0, timeReceived: Date.now() });
                    case 6:
                      return qe.abrupt("return", ze);
                    case 7:
                    case "end":
                      return qe.stop();
                  }
                }, xe);
              }));
              function Oe() {
                return Ie.apply(this, arguments);
              }
              return Oe;
            }() }));
          case 4:
          case "end":
            return ve.stop();
        }
      }, ae);
    })), { audioConfig: $, pause: function() {
      le = !0;
    }, unprepare: function() {
      $.attach = X;
    } };
  }
  function D($) {
    var X = $.createRecognizer, V = $.enableTelemetry, F = $.looseEvents, le = $.referenceGrammars, ae = $.textNormalization;
    U.enableTelemetry(V !== !1);
    var ne = function(ve) {
      (0, s.default)(Oe, ve);
      var Ie = y(Oe);
      function Oe() {
        var xe;
        return (0, u.default)(this, Oe), xe = Ie.call(this), xe._continuous = !1, xe._interimResults = !1, xe._lang = typeof window < "u" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US", xe._grammars = new h.default(), xe._maxAlternatives = 1, xe;
      }
      return (0, a.default)(Oe, [{ key: "emitCognitiveServices", value: function(xe, ze) {
        this.dispatchEvent(new B("cognitiveservices", { data: g(g({}, ze), {}, { type: xe }) }));
      } }, { key: "continuous", get: function() {
        return this._continuous;
      }, set: function(xe) {
        this._continuous = xe;
      } }, { key: "grammars", get: function() {
        return this._grammars;
      }, set: function(xe) {
        if (xe instanceof h.default) this._grammars = xe;
        else throw new Error("The provided value is not of type 'SpeechGrammarList'");
      } }, { key: "interimResults", get: function() {
        return this._interimResults;
      }, set: function(xe) {
        this._interimResults = xe;
      } }, { key: "maxAlternatives", get: function() {
        return this._maxAlternatives;
      }, set: function(xe) {
        this._maxAlternatives = xe;
      } }, { key: "lang", get: function() {
        return this._lang;
      }, set: function(xe) {
        this._lang = xe;
      } }, { key: "onaudioend", get: function() {
        return (0, f.getEventAttributeValue)(this, "audioend");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "audioend", xe);
      } }, { key: "onaudiostart", get: function() {
        return (0, f.getEventAttributeValue)(this, "audiostart");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "audiostart", xe);
      } }, { key: "oncognitiveservices", get: function() {
        return (0, f.getEventAttributeValue)(this, "cognitiveservices");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "cognitiveservices", xe);
      } }, { key: "onend", get: function() {
        return (0, f.getEventAttributeValue)(this, "end");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "end", xe);
      } }, { key: "onerror", get: function() {
        return (0, f.getEventAttributeValue)(this, "error");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "error", xe);
      } }, { key: "onresult", get: function() {
        return (0, f.getEventAttributeValue)(this, "result");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "result", xe);
      } }, { key: "onsoundend", get: function() {
        return (0, f.getEventAttributeValue)(this, "soundend");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "soundend", xe);
      } }, { key: "onsoundstart", get: function() {
        return (0, f.getEventAttributeValue)(this, "soundstart");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "soundstart", xe);
      } }, { key: "onspeechend", get: function() {
        return (0, f.getEventAttributeValue)(this, "speechend");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "speechend", xe);
      } }, { key: "onspeechstart", get: function() {
        return (0, f.getEventAttributeValue)(this, "speechstart");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "speechstart", xe);
      } }, { key: "onstart", get: function() {
        return (0, f.getEventAttributeValue)(this, "start");
      }, set: function(xe) {
        (0, f.setEventAttributeValue)(this, "start", xe);
      } }, { key: "start", value: function() {
        var xe = this;
        this._startOnce().catch(function(ze) {
          xe.dispatchEvent(new ErrorEvent("error", { error: ze, message: ze && (ze.stack || ze.message) }));
        });
      } }, { key: "_startOnce", value: function() {
        var xe = (0, o.default)(r.default.mark(function qe() {
          var Je = this, Be, We, Ne, je, et, St, Ot, we, De, Ee, te, ue, ye, Le, Me, Ae, ie, K;
          return r.default.wrap(function(Z) {
            for (; ; ) switch (Z.prev = Z.next) {
              case 0:
                return Z.next = 2, X(this.lang);
              case 2:
                return Be = Z.sent, We = x(Be.audioConfig), Ne = We.pause, je = We.unprepare, Z.prev = 4, et = (0, p.default)(), De = Be.audioConfig.events.attach(function(Ce) {
                  var be = Ce.name;
                  be === "AudioSourceReadyEvent" ? et.push({ audioSourceReady: {} }) : be === "AudioSourceOffEvent" ? et.push({ audioSourceOff: {} }) : be === "FirstAudibleChunk" && et.push({ firstAudibleChunk: {} });
                }), Ee = De.detach, Be.canceled = function(Ce, be) {
                  var Ge = be.errorDetails, st = be.offset, wt = be.reason, Bt = be.sessionId;
                  et.push({ canceled: { errorDetails: Ge, offset: st, reason: wt, sessionId: Bt } });
                }, Be.recognized = function(Ce, be) {
                  var Ge = be.offset, st = be.result, wt = be.sessionId;
                  et.push({ recognized: { offset: Ge, result: z(st), sessionId: wt } });
                }, Be.recognizing = function(Ce, be) {
                  var Ge = be.offset, st = be.result, wt = be.sessionId;
                  et.push({ recognizing: { offset: Ge, result: z(st), sessionId: wt } });
                }, Be.sessionStarted = function(Ce, be) {
                  var Ge = be.sessionId;
                  et.push({ sessionStarted: { sessionId: Ge } });
                }, Be.sessionStopped = function(Ce, be) {
                  var Ge = be.sessionId;
                  et.push({ sessionStopped: { sessionId: Ge } });
                }, Be.speechStartDetected = function(Ce, be) {
                  var Ge = be.offset, st = be.sessionId;
                  et.push({ speechStartDetected: { offset: Ge, sessionId: st } });
                }, Be.speechEndDetected = function(Ce, be) {
                  var Ge = be.sessionId;
                  et.push({ speechEndDetected: { sessionId: Ge } });
                }, te = this.grammars.phrases, ue = Be.privReco.dynamicGrammar, le && le.length && ue.addReferenceGrammar(le), te && te.length && ue.addPhrase(te), Z.next = 20, H(Be.startContinuousRecognitionAsync.bind(Be))();
              case 20:
                Be.stopContinuousRecognitionAsync ? (this.abort = function() {
                  return et.push({ abort: {} });
                }, this.stop = function() {
                  return et.push({ stop: {} });
                }) : this.abort = this.stop = void 0, Me = [], Ae = r.default.mark(function Ce(be) {
                  var Ge, st, wt, Bt, jt, Xt, Qt, Zr, Jn, Ur, fn, gn;
                  return r.default.wrap(function(cr) {
                    for (; ; ) switch (cr.prev = cr.next) {
                      case 0:
                        return cr.next = 2, et.shift();
                      case 2:
                        if (Ge = cr.sent, st = Ge.abort, wt = Ge.audioSourceOff, Bt = Ge.audioSourceReady, jt = Ge.canceled, Xt = Ge.firstAudibleChunk, Qt = Ge.recognized, Zr = Ge.recognizing, Jn = Ge.stop, Object.keys(Ge).forEach(function(Ri) {
                          return Je.emitCognitiveServices(Ri, Ge[Ri]);
                        }), Ur = jt && jt.errorDetails, !/Permission[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]denied/.test(Ur || "")) {
                          cr.next = 9;
                          break;
                        }
                        return Le = { error: "not-allowed", type: "error" }, cr.abrupt("return", "break");
                      case 9:
                        if (be || Je.dispatchEvent(new B("start")), !Ur) {
                          cr.next = 15;
                          break;
                        }
                        return /1006/.test(Ur) ? (ye || (Je.dispatchEvent(new B("audiostart")), Je.dispatchEvent(new B("audioend"))), Le = { error: "network", type: "error" }) : Le = { error: "unknown", type: "error" }, cr.abrupt("return", "break");
                      case 15:
                        if (!(st || Jn)) {
                          cr.next = 22;
                          break;
                        }
                        if (st ? (Le = { error: "aborted", type: "error" }, we = "abort") : (Ne(), we = "stop"), !(st && Be.stopContinuousRecognitionAsync)) {
                          cr.next = 20;
                          break;
                        }
                        return cr.next = 20, H(Be.stopContinuousRecognitionAsync.bind(Be))();
                      case 20:
                        cr.next = 61;
                        break;
                      case 22:
                        if (!Bt) {
                          cr.next = 27;
                          break;
                        }
                        Je.dispatchEvent(new B("audiostart")), ye = !0, cr.next = 61;
                        break;
                      case 27:
                        if (!Xt) {
                          cr.next = 32;
                          break;
                        }
                        Je.dispatchEvent(new B("soundstart")), St = !0, cr.next = 61;
                        break;
                      case 32:
                        if (!wt) {
                          cr.next = 40;
                          break;
                        }
                        return Ot && Je.dispatchEvent(new B("speechend")), St && Je.dispatchEvent(new B("soundend")), ye && Je.dispatchEvent(new B("audioend")), ye = St = Ot = !1, cr.abrupt("return", "break");
                      case 40:
                        if (we === "abort") {
                          cr.next = 61;
                          break;
                        }
                        if (!(Qt && Qt.result && Qt.result.reason === O.NoMatch)) {
                          cr.next = 45;
                          break;
                        }
                        Le = { error: "no-speech", type: "error" }, cr.next = 61;
                        break;
                      case 45:
                        if (!(Qt || Zr)) {
                          cr.next = 61;
                          break;
                        }
                        if (ye || (Je.dispatchEvent(new B("audiostart")), ye = !0), St || (Je.dispatchEvent(new B("soundstart")), St = !0), Ot || (Je.dispatchEvent(new B("speechstart")), Ot = !0), !Qt) {
                          cr.next = 60;
                          break;
                        }
                        if (fn = (0, d.default)(Qt.result, { maxAlternatives: Je.maxAlternatives, textNormalization: ae }), gn = !!fn[0].transcript, gn && (Me = [].concat((0, n.default)(Me), [fn]), Je.continuous && Je.dispatchEvent(new B("result", { results: Me }))), Je.continuous && gn ? Le = null : Le = { results: Me, type: "result" }, !(!Je.continuous && Be.stopContinuousRecognitionAsync)) {
                          cr.next = 57;
                          break;
                        }
                        return cr.next = 57, H(Be.stopContinuousRecognitionAsync.bind(Be))();
                      case 57:
                        F && Le && gn && (Je.dispatchEvent(new B(Le.type, Le)), Le = null), cr.next = 61;
                        break;
                      case 60:
                        Zr && Je.interimResults && Je.dispatchEvent(new B("result", { results: [].concat((0, n.default)(Me), [(0, d.default)(Zr.result, { maxAlternatives: Je.maxAlternatives, textNormalization: ae })]) }));
                      case 61:
                      case "end":
                        return cr.stop();
                    }
                  }, Ce);
                }), ie = 0;
              case 24:
                if (!(!we || ye)) {
                  Z.next = 32;
                  break;
                }
                return Z.delegateYield(Ae(ie), "t0", 26);
              case 26:
                if (K = Z.t0, K !== "break") {
                  Z.next = 29;
                  break;
                }
                return Z.abrupt("break", 32);
              case 29:
                ie++, Z.next = 24;
                break;
              case 32:
                Ot && this.dispatchEvent(new B("speechend")), St && this.dispatchEvent(new B("soundend")), ye && this.dispatchEvent(new B("audioend")), Le && (Le.type === "result" && !Le.results.length && (Le = { error: "no-speech", type: "error" }), Le.type === "error" ? this.dispatchEvent(new ErrorEvent("error", Le)) : this.dispatchEvent(new B(Le.type, Le))), this.dispatchEvent(new B("end")), Ee(), Z.next = 44;
                break;
              case 40:
                throw Z.prev = 40, Z.t1 = Z.catch(4), console.error(Z.t1), Z.t1;
              case 44:
                return Z.prev = 44, je(), Be.dispose(), Z.finish(44);
              case 48:
              case "end":
                return Z.stop();
            }
          }, qe, this, [[4, 40, 44, 48]]);
        }));
        function ze() {
          return xe.apply(this, arguments);
        }
        return ze;
      }() }]), Oe;
    }(f.EventTarget);
    return { SpeechGrammarList: h.default, SpeechRecognition: ne, SpeechRecognitionEvent: B };
  }
  var w = function($) {
    var X = (0, v.default)($), V = X.audioConfig, F = V === void 0 ? S.fromDefaultMicrophoneInput() : V, le = X.enableTelemetry, ae = le === void 0 ? !0 : le, ne = X.fetchCredentials, ve = X.looseEvents, Ie = X.referenceGrammars, Oe = X.speechRecognitionEndpointId, xe = X.textNormalization, ze = xe === void 0 ? "display" : xe;
    if (!F && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) return console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services."), {};
    var qe = function() {
      var Je = (0, o.default)(r.default.mark(function Be(We) {
        var Ne, je, et, St, Ot, we, De;
        return r.default.wrap(function(Ee) {
          for (; ; ) switch (Ee.prev = Ee.next) {
            case 0:
              return Ee.next = 2, ne();
            case 2:
              return Ne = Ee.sent, je = Ne.authorizationToken, et = Ne.region, St = Ne.speechRecognitionHostname, Ot = Ne.subscriptionKey, St ? (De = { hostname: St, port: 443, protocol: "wss:" }, je ? (we = P.fromHost(De), we.authorizationToken = je) : we = P.fromHost(De, Ot)) : we = je ? P.fromAuthorizationToken(je, et) : P.fromSubscription(Ot, et), Oe && (we.endpointId = Oe), we.outputFormat = A.Detailed, we.speechRecognitionLanguage = We || "en-US", Ee.abrupt("return", new U(we, F));
            case 12:
            case "end":
              return Ee.stop();
          }
        }, Be);
      }));
      return function(Be) {
        return Je.apply(this, arguments);
      };
    }();
    return D({ audioConfig: F, createRecognizer: qe, enableTelemetry: ae, looseEvents: ve, referenceGrammars: Ie, textNormalization: ze });
  };
  e.default = w;
}), IIr = ot((e) => {
  var t = Wy();
  Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "createSpeechRecognitionPonyfillFromRecognizer", { enumerable: !0, get: function() {
    return r.createSpeechRecognitionPonyfillFromRecognizer;
  } }), e.default = void 0;
  var r = i(CIr());
  function n(a) {
    if (typeof WeakMap != "function") return null;
    var u = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
    return (n = function(c) {
      return c ? s : u;
    })(a);
  }
  function i(a, u) {
    if (a && a.__esModule) return a;
    if (a === null || t(a) !== "object" && typeof a != "function") return { default: a };
    var s = n(u);
    if (s && s.has(a)) return s.get(a);
    var c = {}, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if (f !== "default" && Object.prototype.hasOwnProperty.call(a, f)) {
      var d = l ? Object.getOwnPropertyDescriptor(a, f) : null;
      d && (d.get || d.set) ? Object.defineProperty(c, f, d) : c[f] = a[f];
    }
    return c.default = a, s && s.set(a, c), c;
  }
  var o = r.default;
  e.default = o;
}), OIr = ot((e, t) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
  function r(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    try {
      var o = n.call(i);
      return typeof o.then == "function" ? new Promise(function(a) {
        o.then(a, function() {
          return a();
        });
      }) : o;
    } catch {
    }
  }
  t.exports = e.default, t.exports.default = e.default;
}), a2e = {};
a7(a2e, { default: () => PIr });
function RIr(e, t) {
  return !!(e === t || w8(e) && w8(t));
}
function wIr(e, t) {
  if (e.length !== t.length) return !1;
  for (var r = 0; r < e.length; r++) if (!RIr(e[r], t[r])) return !1;
  return !0;
}
function PIr(e, t) {
  t === void 0 && (t = wIr);
  var r = null;
  function n() {
    for (var i = [], o = 0; o < arguments.length; o++) i[o] = arguments[o];
    if (r && r.lastThis === this && t(i, r.lastArgs)) return r.lastResult;
    var a = e.apply(this, i);
    return r = { lastResult: a, lastArgs: i, lastThis: this }, a;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
var w8, DIr = Qe(() => {
  w8 = Number.isNaN || function(e) {
    return typeof e == "number" && e !== e;
  };
}), xIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(Ec()), n = t(mc()), i = t(pl()), o = t(dl()), a = function() {
    function u(s) {
      (0, i.default)(this, u), this.audioContext = s;
    }
    return (0, o.default)(u, [{ key: "pause", value: function() {
      this.audioContext && this.audioContext.suspend(), this.playingUtterance && this.playingUtterance.dispatchEvent(new CustomEvent("pause"));
    } }, { key: "resume", value: function() {
      this.audioContext && this.audioContext.resume(), this.playingUtterance && this.playingUtterance.dispatchEvent(new CustomEvent("resume"));
    } }, { key: "start", value: function() {
      var s = (0, n.default)(r.default.mark(function l(f) {
        var d;
        return r.default.wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              if (!(d = f.shift())) {
                p.next = 7;
                break;
              }
              return this.playingUtterance = d, p.next = 4, d.play(this.audioContext);
            case 4:
              this.playingUtterance = null, p.next = 0;
              break;
            case 7:
            case "end":
              return p.stop();
          }
        }, l, this);
      }));
      function c(l) {
        return s.apply(this, arguments);
      }
      return c;
    }() }, { key: "stop", value: function() {
      this.playingUtterance && this.playingUtterance.stop(), this.audioContext.state === "suspended" && this.audioContext.resume();
    } }]), u;
  }();
  e.default = a;
}), NIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(Ec()), n = t(mc()), i = t(pl()), o = t(dl()), a = t((DIr(), u7(a2e))), u = t(xIr()), s = function() {
    function c(l) {
      var f = l.audioContext, d = l.ponyfill;
      (0, i.default)(this, c), this.consumer = null, this.paused = !1, this.queue = [], this.getAudioContext = (0, a.default)(function() {
        return f || new d.AudioContext();
      });
    }
    return (0, o.default)(c, [{ key: "pause", value: function() {
      this.paused = !0, this.consumer && this.consumer.pause();
    } }, { key: "push", value: function(l) {
      this.queue.push(l), this.startConsumer();
    } }, { key: "resume", value: function() {
      this.paused = !1, this.consumer ? this.consumer.resume() : this.startConsumer();
    } }, { key: "speaking", get: function() {
      return !!this.consumer;
    } }, { key: "startConsumer", value: function() {
      var l = (0, n.default)(r.default.mark(function d() {
        return r.default.wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              if (!(!this.paused && this.queue.length && !this.consumer)) {
                p.next = 7;
                break;
              }
              return this.consumer = new u.default(this.getAudioContext()), p.next = 4, this.consumer.start(this.queue);
            case 4:
              this.consumer = null, p.next = 0;
              break;
            case 7:
            case "end":
              return p.stop();
          }
        }, d, this);
      }));
      function f() {
        return l.apply(this, arguments);
      }
      return f;
    }() }, { key: "stop", value: function() {
      this.queue.splice(0), this.consumer && this.consumer.stop();
    } }]), c;
  }();
  e.default = s;
}), u2e = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(pl()), n = t(dl()), i = function() {
    function o(a) {
      var u = a.gender, s = a.lang, c = a.voiceURI;
      (0, r.default)(this, o), this._default = !1, this._gender = u, this._lang = s, this._localService = !1, this._name = c, this._voiceURI = c;
    }
    return (0, n.default)(o, [{ key: "default", get: function() {
      return this._default;
    } }, { key: "gender", get: function() {
      return this._gender;
    } }, { key: "lang", get: function() {
      return this._lang;
    } }, { key: "localService", get: function() {
      return this._localService;
    } }, { key: "name", get: function() {
      return this._name;
    } }, { key: "voiceURI", get: function() {
      return this._voiceURI;
    } }]), o;
  }();
  e.default = i;
}), LIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = u;
  var r = t(Ec()), n = t(mc()), i = t(u2e());
  function o(c) {
    return a.apply(this, arguments);
  }
  function a() {
    return a = (0, n.default)(r.default.mark(function c(l) {
      var f, d, p, v, h, E;
      return r.default.wrap(function(m) {
        for (; ; ) switch (m.prev = m.next) {
          case 0:
            return f = l.customVoiceHostname, d = l.deploymentId, p = l.region, v = l.subscriptionKey, h = f || "".concat(p, ".customvoice.api.speech.microsoft.com"), m.next = 4, fetch("https://".concat(encodeURI(h), "/api/texttospeech/v2.0/endpoints/").concat(encodeURIComponent(d)), { headers: { accept: "application/json", "ocp-apim-subscription-key": v } });
          case 4:
            if (E = m.sent, E.ok) {
              m.next = 7;
              break;
            }
            throw new Error("Failed to fetch custom voices");
          case 7:
            return m.abrupt("return", E.json());
          case 8:
          case "end":
            return m.stop();
        }
      }, c);
    })), a.apply(this, arguments);
  }
  function u(c) {
    return s.apply(this, arguments);
  }
  function s() {
    return s = (0, n.default)(r.default.mark(function c(l) {
      var f, d, p, v, h, E;
      return r.default.wrap(function(m) {
        for (; ; ) switch (m.prev = m.next) {
          case 0:
            return f = l.customVoiceHostname, d = l.deploymentId, p = l.region, v = l.subscriptionKey, m.next = 3, o({ customVoiceHostname: f, deploymentId: d, region: p, subscriptionKey: v });
          case 3:
            return h = m.sent, E = h.models, m.abrupt("return", E.map(function(g) {
              var y = g.properties.Gender, _ = g.locale, S = g.name;
              return new i.default({ gender: y, lang: _, voiceURI: S });
            }).sort(function(g, y) {
              var _ = g.name, S = y.name;
              return _ > S ? 1 : _ < S ? -1 : 0;
            }));
          case 6:
          case "end":
            return m.stop();
        }
      }, c);
    })), s.apply(this, arguments);
  }
}), BIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = s;
  var r = t(Ec()), n = t(E0()), i = t(mc()), o = t(u2e());
  function a(l, f) {
    var d = Object.keys(l);
    if (Object.getOwnPropertySymbols) {
      var p = Object.getOwnPropertySymbols(l);
      f && (p = p.filter(function(v) {
        return Object.getOwnPropertyDescriptor(l, v).enumerable;
      })), d.push.apply(d, p);
    }
    return d;
  }
  function u(l) {
    for (var f = 1; f < arguments.length; f++) {
      var d = arguments[f] != null ? arguments[f] : {};
      f % 2 ? a(Object(d), !0).forEach(function(p) {
        (0, n.default)(l, p, d[p]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(d)) : a(Object(d)).forEach(function(p) {
        Object.defineProperty(l, p, Object.getOwnPropertyDescriptor(d, p));
      });
    }
    return l;
  }
  function s(l) {
    return c.apply(this, arguments);
  }
  function c() {
    return c = (0, i.default)(r.default.mark(function l(f) {
      var d, p, v, h, E, m, g;
      return r.default.wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            return d = f.authorizationToken, p = f.region, v = f.speechSynthesisHostname, h = f.subscriptionKey, E = v || "".concat(encodeURI(p), ".tts.speech.microsoft.com"), y.next = 4, fetch("https://".concat(E, "/cognitiveservices/voices/list"), { headers: u({ "content-type": "application/json" }, d ? { authorization: "Bearer ".concat(d) } : { "Ocp-Apim-Subscription-Key": h }) });
          case 4:
            if (m = y.sent, m.ok) {
              y.next = 7;
              break;
            }
            throw new Error("Failed to fetch voices");
          case 7:
            return y.next = 9, m.json();
          case 9:
            return g = y.sent, y.abrupt("return", g.map(function(_) {
              var S = _.Gender, A = _.Locale, O = _.Name;
              return new o.default({ gender: S, lang: A, voiceURI: O });
            }).sort(function(_, S) {
              var A = _.name, O = S.name;
              return A > O ? 1 : A < O ? -1 : 0;
            }));
          case 11:
          case "end":
            return y.stop();
        }
      }, l);
    })), c.apply(this, arguments);
  }
}), s2e = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(dl()), n = t(pl()), i = t(Ky()), o = t(Xy()), a = t(yd()), u = i2();
  function s(f) {
    var d = c();
    return function() {
      var p = (0, a.default)(f), v;
      if (d) {
        var h = (0, a.default)(this).constructor;
        v = Reflect.construct(p, arguments, h);
      } else v = p.apply(this, arguments);
      return (0, o.default)(this, v);
    };
  }
  function c() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var l = function(f) {
    (0, i.default)(p, f);
    var d = s(p);
    function p(v) {
      return (0, n.default)(this, p), d.call(this, v);
    }
    return (0, r.default)(p);
  }(u.Event);
  e.default = l;
}), kIr = ot((e, t) => {
  t.exports = function() {
    var r = {};
    return r.promise = new Promise(function(n, i) {
      r.resolve = n, r.reject = i;
    }), r;
  };
}), MIr = ot((e, t) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = n(kIr());
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s, c) {
    if (!(s instanceof c)) throw new TypeError("Cannot call a class as a function");
  }
  function o(s, c) {
    for (var l = 0; l < c.length; l++) {
      var f = c[l];
      f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(s, f.key, f);
    }
  }
  function a(s, c, l) {
    return c && o(s.prototype, c), s;
  }
  var u = function() {
    function s() {
      var c = this, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      i(this, s), this.defers = [], this.upcomingDeferred = null, this.eventListener = this.eventListener.bind(this), this.options = l, this.one = this.one.bind(this), this.upcoming = this.upcoming.bind(this), this[Symbol.iterator] = function() {
        return { next: function() {
          return { done: !1, value: c.upcoming() };
        } };
      };
    }
    return a(s, [{ key: "eventListener", value: function(c) {
      var l = this.defers.shift(), f = this.options.array ? [].slice.call(arguments) : c;
      l && l.resolve(f), this.upcomingDeferred && (this.upcomingDeferred.resolve(f), this.upcomingDeferred = null);
    } }, { key: "one", value: function() {
      var c = (0, r.default)();
      return this.defers.push(c), c.promise;
    } }, { key: "upcoming", value: function() {
      return this.upcomingDeferred || (this.upcomingDeferred = (0, r.default)()), this.upcomingDeferred.promise;
    } }]), s;
  }();
  e.default = u, t.exports = e.default, t.exports.default = e.default;
}), c2e = {};
a7(c2e, { decode: () => f2e, encode: () => l2e });
var J0, ep, Lg, l2e, f2e, FIr = Qe(() => {
  for (J0 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ep = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Lg = 0; Lg < J0.length; Lg++) ep[J0.charCodeAt(Lg)] = Lg;
  l2e = function(e) {
    var t = new Uint8Array(e), r, n = t.length, i = "";
    for (r = 0; r < n; r += 3) i += J0[t[r] >> 2], i += J0[(t[r] & 3) << 4 | t[r + 1] >> 4], i += J0[(t[r + 1] & 15) << 2 | t[r + 2] >> 6], i += J0[t[r + 2] & 63];
    return n % 3 === 2 ? i = i.substring(0, i.length - 1) + "=" : n % 3 === 1 && (i = i.substring(0, i.length - 2) + "=="), i;
  }, f2e = function(e) {
    var t = e.length * 0.75, r = e.length, n, i = 0, o, a, u, s;
    e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
    var c = new ArrayBuffer(t), l = new Uint8Array(c);
    for (n = 0; n < r; n += 4) o = ep[e.charCodeAt(n)], a = ep[e.charCodeAt(n + 1)], u = ep[e.charCodeAt(n + 2)], s = ep[e.charCodeAt(n + 3)], l[i++] = o << 2 | a >> 4, l[i++] = (a & 15) << 4 | u >> 2, l[i++] = (u & 3) << 6 | s & 63;
    return c;
  };
}), HIr = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
  function t(n) {
    var i = Math.round((n - 1) * 100);
    return i >= 0 && (i = "+" + i), i + "%";
  }
  function r(n) {
    var i = n.lang, o = n.pitch, a = o === void 0 ? 1 : o, u = n.rate, s = u === void 0 ? 1 : u, c = n.text, l = n.voice, f = n.volume;
    return '<speak version="1.0" xml:lang="'.concat(i, `">
  <voice xml:lang="`).concat(i, '" name="').concat(l, `">
    <prosody pitch="`).concat(t(a), '" rate="').concat(t(s), '" volume="').concat(t(f), `">
      `).concat(c, `
    </prosody>
  </voice>
</speak>`);
  }
}), $Ir = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n;
  var t = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<speak([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\/?>)/, r = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*<\?xml[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
  function n(i) {
    return t.test(i) || r.test(i);
  }
}), UIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = v;
  var r = t(Ec()), n = t(E0()), i = t(mc()), o = (FIr(), u7(c2e)), a = t(HIr()), u = t($Ir());
  function s(E, m) {
    var g = Object.keys(E);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(E);
      m && (y = y.filter(function(_) {
        return Object.getOwnPropertyDescriptor(E, _).enumerable;
      })), g.push.apply(g, y);
    }
    return g;
  }
  function c(E) {
    for (var m = 1; m < arguments.length; m++) {
      var g = arguments[m] != null ? arguments[m] : {};
      m % 2 ? s(Object(g), !0).forEach(function(y) {
        (0, n.default)(E, y, g[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(g)) : s(Object(g)).forEach(function(y) {
        Object.defineProperty(E, y, Object.getOwnPropertyDescriptor(g, y));
      });
    }
    return E;
  }
  var l = "en-US", f = "riff-16khz-16bit-mono-pcm", d = "Microsoft Server Speech Text to Speech Voice (en-US, AriaNeural)", p = "SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
  function v(E) {
    return h.apply(this, arguments);
  }
  function h() {
    return h = (0, i.default)(r.default.mark(function E(m) {
      var g, y, _, S, A, O, P, U, z, k, H, B, x, D, w, $, X, V, F, le, ae, ne;
      return r.default.wrap(function(ve) {
        for (; ; ) switch (ve.prev = ve.next) {
          case 0:
            if (g = m.deploymentId, y = m.fetchCredentials, _ = m.lang, S = _ === void 0 ? l : _, A = m.outputFormat, O = A === void 0 ? f : A, P = m.pitch, U = m.rate, z = m.text, k = m.voice, H = k === void 0 ? d : k, B = m.volume, z) {
              ve.next = 3;
              break;
            }
            return ve.abrupt("return", (0, o.decode)(p));
          case 3:
            return ve.next = 5, y();
          case 5:
            if (x = ve.sent, D = x.authorizationToken, w = x.region, $ = x.speechSynthesisHostname, X = x.subscriptionKey, !(D && X || !D && !X)) {
              ve.next = 14;
              break;
            }
            throw new Error('Only "authorizationToken" or "subscriptionKey" should be set.');
          case 14:
            if (!(w && $ || !w && !$)) {
              ve.next = 16;
              break;
            }
            throw new Error('Only "region" or "speechSynthesisHostnamename" should be set.');
          case 16:
            return V = (0, u.default)(z) ? z : (0, a.default)({ lang: S, pitch: P, rate: U, text: z, voice: H, volume: B }), F = $ || (g ? "".concat(encodeURI(w), ".voice.speech.microsoft.com") : "".concat(encodeURI(w), ".tts.speech.microsoft.com")), le = g ? "?deploymentId=".concat(encodeURI(g)) : "", ae = "https://".concat(F, "/cognitiveservices/v1").concat(le), ve.next = 22, fetch(ae, { headers: c({ "Content-Type": "application/ssml+xml", "X-Microsoft-OutputFormat": O }, D ? { Authorization: "Bearer ".concat(D) } : { "Ocp-Apim-Subscription-Key": X }), method: "POST", body: V });
          case 22:
            if (ne = ve.sent, ne.ok) {
              ve.next = 25;
              break;
            }
            throw new Error("web-speech-cognitive-services: Failed to syntheis speech, server returned ".concat(ne.status));
          case 25:
            return ve.abrupt("return", ne.arrayBuffer());
          case 26:
          case "end":
            return ve.stop();
        }
      }, E);
    })), h.apply(this, arguments);
  }
}), VIr = ot((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
  function t(r, n, i) {
    return r.addEventListener(n, i), function() {
      return r.removeEventListener(n, i);
    };
  }
}), jIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(Ec()), n = t(mc()), i = t(pl()), o = t(dl()), a = t(Ky()), u = t(Xy()), s = t(yd()), c = i2(), l = t(MIr()), f = t(UIr()), d = t(s2e()), p = t(VIr());
  function v(_) {
    var S = h();
    return function() {
      var A = (0, s.default)(_), O;
      if (S) {
        var P = (0, s.default)(this).constructor;
        O = Reflect.construct(A, arguments, P);
      } else O = A.apply(this, arguments);
      return (0, u.default)(this, O);
    };
  }
  function h() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function E(_, S) {
    return new Promise(function(A, O) {
      var P = _.decodeAudioData(S, A, O);
      P && typeof P.then == "function" && A(P);
    });
  }
  function m(_, S, A) {
    return new Promise(function(O, P) {
      var U = new l.default(), z = new l.default(), k = (0, p.default)(_, "statechange", function(H) {
        var B = H.target.state;
        return B === "closed" && U.eventListener();
      });
      try {
        A.buffer = S, A.onended = z.eventListener, A.connect(_.destination), A.start(0), Promise.race([U.upcoming(), z.upcoming()]).then(O);
      } catch (H) {
        P(H);
      } finally {
        k();
      }
    });
  }
  var g = function(_) {
    (0, a.default)(A, _);
    var S = v(A);
    function A(O) {
      var P;
      return (0, i.default)(this, A), P = S.call(this), P._lang = null, P._pitch = 1, P._rate = 1, P._voice = null, P._volume = 1, P.text = O, P.onboundary = null, P.onend = null, P.onerror = null, P.onmark = null, P.onpause = null, P.onresume = null, P.onstart = null, P;
    }
    return (0, o.default)(A, [{ key: "lang", get: function() {
      return this._lang;
    }, set: function(O) {
      this._lang = O;
    } }, { key: "onboundary", get: function() {
      return (0, c.getEventAttributeValue)(this, "boundary");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "boundary", O);
    } }, { key: "onend", get: function() {
      return (0, c.getEventAttributeValue)(this, "end");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "end", O);
    } }, { key: "onerror", get: function() {
      return (0, c.getEventAttributeValue)(this, "error");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "error", O);
    } }, { key: "onmark", get: function() {
      return (0, c.getEventAttributeValue)(this, "mark");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "mark", O);
    } }, { key: "onpause", get: function() {
      return (0, c.getEventAttributeValue)(this, "pause");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "pause", O);
    } }, { key: "onresume", get: function() {
      return (0, c.getEventAttributeValue)(this, "resume");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "resume", O);
    } }, { key: "onstart", get: function() {
      return (0, c.getEventAttributeValue)(this, "start");
    }, set: function(O) {
      (0, c.setEventAttributeValue)(this, "start", O);
    } }, { key: "pitch", get: function() {
      return this._pitch;
    }, set: function(O) {
      this._pitch = O;
    } }, { key: "rate", get: function() {
      return this._rate;
    }, set: function(O) {
      this._rate = O;
    } }, { key: "voice", get: function() {
      return this._voice;
    }, set: function(O) {
      this._voice = O;
    } }, { key: "volume", get: function() {
      return this._volume;
    }, set: function(O) {
      this._volume = O;
    } }, { key: "preload", value: function(O) {
      var P = O.deploymentId, U = O.fetchCredentials, z = O.outputFormat;
      this.arrayBufferPromise = (0, f.default)({ fetchCredentials: U, deploymentId: P, lang: this.lang || window.navigator.language, outputFormat: z, pitch: this.pitch, rate: this.rate, text: this.text, voice: this.voice && this.voice.voiceURI, volume: this.volume }), this.arrayBufferPromise.catch();
    } }, { key: "play", value: function() {
      var O = (0, n.default)(r.default.mark(function U(z) {
        var k, H;
        return r.default.wrap(function(B) {
          for (; ; ) switch (B.prev = B.next) {
            case 0:
              return B.prev = 0, this.dispatchEvent(new d.default("start")), k = z.createBufferSource(), B.t0 = E, B.t1 = z, B.next = 7, this.arrayBufferPromise;
            case 7:
              return B.t2 = B.sent, B.next = 10, (0, B.t0)(B.t1, B.t2);
            case 10:
              return H = B.sent, this._playingSource = k, B.next = 14, m(z, H, k);
            case 14:
              this._playingSource = null, this.dispatchEvent(new d.default("end")), B.next = 21;
              break;
            case 18:
              B.prev = 18, B.t3 = B.catch(0), this.dispatchEvent(new ErrorEvent("error", { error: "synthesis-failed", message: B.t3.stack }));
            case 21:
            case "end":
              return B.stop();
          }
        }, U, this, [[0, 18]]);
      }));
      function P(U) {
        return O.apply(this, arguments);
      }
      return P;
    }() }, { key: "stop", value: function() {
      this._playingSource && this._playingSource.stop();
    } }]), A;
  }(c.EventTarget), y = g;
  e.default = y;
}), zIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(Ec()), n = t(mc()), i = t(pl()), o = t(dl()), a = t(Ky()), u = t(Xy()), s = t(yd()), c = i2(), l = t(i2e()), f = t(OIr()), d = t(NIr()), p = t(LIr()), v = t(BIr()), h = t(o2e()), E = t(s2e()), m = t(jIr());
  function g(O) {
    var P = y();
    return function() {
      var U = (0, s.default)(O), z;
      if (P) {
        var k = (0, s.default)(this).constructor;
        z = Reflect.construct(U, arguments, k);
      } else z = U.apply(this, arguments);
      return (0, u.default)(this, z);
    };
  }
  function y() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = "audio-24khz-160kbitrate-mono-mp3", S = [], A = function(O) {
    var P = (0, h.default)(O), U = P.audioContext, z = P.fetchCredentials, k = P.ponyfill, H = k === void 0 ? { AudioContext: window.AudioContext || window.webkitAudioContext } : k, B = P.speechSynthesisDeploymentId, x = P.speechSynthesisOutputFormat, D = x === void 0 ? _ : x;
    if (!U && !H.AudioContext) return console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services."), {};
    var w = function($) {
      (0, a.default)(V, $);
      var X = g(V);
      function V() {
        var F;
        return (0, i.default)(this, V), F = X.call(this), F.queue = new d.default({ audioContext: U, ponyfill: H }), F.updateVoices(), F;
      }
      return (0, o.default)(V, [{ key: "cancel", value: function() {
        this.queue.stop();
      } }, { key: "getVoices", value: function() {
        return S;
      } }, { key: "onvoiceschanged", get: function() {
        return (0, c.getEventAttributeValue)(this, "voiceschanged");
      }, set: function(F) {
        (0, c.setEventAttributeValue)(this, "voiceschanged", F);
      } }, { key: "pause", value: function() {
        this.queue.pause();
      } }, { key: "resume", value: function() {
        this.queue.resume();
      } }, { key: "speak", value: function(F) {
        if (!(F instanceof m.default)) throw new Error("invalid utterance");
        var le = (0, l.default)(), ae = le.reject, ne = le.resolve, ve = le.promise, Ie = function(Oe) {
          var xe = Oe.error, ze = Oe.message, qe = new Error(xe);
          qe.stack = ze, ae(qe);
        };
        return F.addEventListener("end", ne), F.addEventListener("error", Ie), F.preload({ deploymentId: B, fetchCredentials: z, outputFormat: D }), this.queue.push(F), ve.finally(function() {
          F.removeEventListener("end", ne), F.removeEventListener("error", Ie);
        });
      } }, { key: "speaking", get: function() {
        return this.queue.speaking;
      } }, { key: "updateVoices", value: function() {
        var F = (0, n.default)(r.default.mark(function ae() {
          var ne = this, ve, Ie, Oe, xe, ze;
          return r.default.wrap(function(qe) {
            for (; ; ) switch (qe.prev = qe.next) {
              case 0:
                return qe.next = 2, z();
              case 2:
                if (ve = qe.sent, Ie = ve.customVoiceHostname, Oe = ve.region, xe = ve.speechSynthesisHostname, ze = ve.subscriptionKey, !B) {
                  qe.next = 14;
                  break;
                }
                if (!ze) {
                  qe.next = 12;
                  break;
                }
                return console.warn("web-speech-cognitive-services: Listing of custom voice models are only available when using subscription key."), qe.next = 12, (0, f.default)((0, n.default)(r.default.mark(function Je() {
                  var Be;
                  return r.default.wrap(function(We) {
                    for (; ; ) switch (We.prev = We.next) {
                      case 0:
                        return We.next = 2, (0, p.default)({ customVoiceHostname: Ie, deploymentId: B, region: Oe, speechSynthesisHostname: xe, subscriptionKey: ze });
                      case 2:
                        Be = We.sent, ne.getVoices = function() {
                          return Be;
                        };
                      case 4:
                      case "end":
                        return We.stop();
                    }
                  }, Je);
                })));
              case 12:
                qe.next = 16;
                break;
              case 14:
                return qe.next = 16, (0, f.default)((0, n.default)(r.default.mark(function Je() {
                  var Be;
                  return r.default.wrap(function(We) {
                    for (; ; ) switch (We.prev = We.next) {
                      case 0:
                        return We.t0 = v.default, We.next = 3, z();
                      case 3:
                        return We.t1 = We.sent, We.next = 6, (0, We.t0)(We.t1);
                      case 6:
                        Be = We.sent, ne.getVoices = function() {
                          return Be;
                        };
                      case 8:
                      case "end":
                        return We.stop();
                    }
                  }, Je);
                })));
              case 16:
                this.dispatchEvent(new E.default("voiceschanged"));
              case 17:
              case "end":
                return qe.stop();
            }
          }, ae, this);
        }));
        function le() {
          return F.apply(this, arguments);
        }
        return le;
      }() }]), V;
    }(c.EventTarget);
    return { speechSynthesis: new w(), SpeechSynthesisEvent: E.default, SpeechSynthesisUtterance: m.default };
  };
  e.default = A;
}), qIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var r = t(zIr()), n = r.default;
  e.default = n;
}), YIr = ot((e) => {
  var t = Oo();
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
  var r = t(Ec()), n = t(mc()), i = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
  function o(u) {
    return a.apply(this, arguments);
  }
  function a() {
    return a = (0, n.default)(r.default.mark(function u(s) {
      var c, l, f;
      return r.default.wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return c = s.region, l = s.subscriptionKey, d.next = 3, fetch(i.replace(/\{region\}/, c), { headers: { "Ocp-Apim-Subscription-Key": l }, method: "POST" });
          case 3:
            if (f = d.sent, f.ok) {
              d.next = 6;
              break;
            }
            throw new Error("Failed to fetch authorization token, server returned ".concat(f.status));
          case 6:
            return d.abrupt("return", f.text());
          case 7:
          case "end":
            return d.stop();
        }
      }, u);
    })), a.apply(this, arguments);
  }
}), GIr = ot((e) => {
  var t = Oo(), r = Wy();
  Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "createSpeechRecognitionPonyfill", { enumerable: !0, get: function() {
    return i.default;
  } }), Object.defineProperty(e, "createSpeechRecognitionPonyfillFromRecognizer", { enumerable: !0, get: function() {
    return i.createSpeechRecognitionPonyfillFromRecognizer;
  } }), Object.defineProperty(e, "createSpeechSynthesisPonyfill", { enumerable: !0, get: function() {
    return o.default;
  } }), e.default = f, Object.defineProperty(e, "fetchAuthorizationToken", { enumerable: !0, get: function() {
    return a.default;
  } });
  var n = t(E0()), i = s(IIr()), o = t(qIr()), a = t(YIr());
  function u(p) {
    if (typeof WeakMap != "function") return null;
    var v = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
    return (u = function(E) {
      return E ? h : v;
    })(p);
  }
  function s(p, v) {
    if (p && p.__esModule) return p;
    if (p === null || r(p) !== "object" && typeof p != "function") return { default: p };
    var h = u(v);
    if (h && h.has(p)) return h.get(p);
    var E = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var g in p) if (g !== "default" && Object.prototype.hasOwnProperty.call(p, g)) {
      var y = m ? Object.getOwnPropertyDescriptor(p, g) : null;
      y && (y.get || y.set) ? Object.defineProperty(E, g, y) : E[g] = p[g];
    }
    return E.default = p, h && h.set(p, E), E;
  }
  function c(p, v) {
    var h = Object.keys(p);
    if (Object.getOwnPropertySymbols) {
      var E = Object.getOwnPropertySymbols(p);
      v && (E = E.filter(function(m) {
        return Object.getOwnPropertyDescriptor(p, m).enumerable;
      })), h.push.apply(h, E);
    }
    return h;
  }
  function l(p) {
    for (var v = 1; v < arguments.length; v++) {
      var h = arguments[v] != null ? arguments[v] : {};
      v % 2 ? c(Object(h), !0).forEach(function(E) {
        (0, n.default)(p, E, h[E]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(p, Object.getOwnPropertyDescriptors(h)) : c(Object(h)).forEach(function(E) {
        Object.defineProperty(p, E, Object.getOwnPropertyDescriptor(h, E));
      });
    }
    return p;
  }
  function f() {
    for (var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = arguments.length, h = new Array(v > 1 ? v - 1 : 0), E = 1; E < v; E++) h[E - 1] = arguments[E];
    var m = l(l({}, i.default.apply(void 0, [p].concat(h))), o.default.apply(void 0, [p].concat(h)));
    return l(l({}, m), {}, { then: function(g) {
      console.warn("web-speech-cognitive-services: This function no longer need to be called in an asynchronous fashion. Please update your code. We will remove this Promise.then function on or after 2020-08-10."), g(m);
    } });
  }
  var d = document.createElement("meta");
  d.setAttribute("name", "web-speech-cognitive-services"), d.setAttribute("content", "version=".concat("7.1.3")), document.head.appendChild(d);
}), WIr = ei(void 0), d2e = WIr, KIr = ({ adaptiveCardsHostConfig: e, adaptiveCardsPackage: t, children: r }) => {
  let n = tt(() => t || Kor, [t]), i = tt(() => ({ adaptiveCardsPackage: n, hostConfigFromProps: e }), [e, n]);
  return G.createElement(d2e.Provider, { value: i }, r);
}, XIr = KIr;
function p2e() {
  let e = En(d2e);
  if (!e) throw new Error("This hook can only be used on component that is decendants of <ComposerWithAdaptiveCards>");
  return e;
}
function gl() {
  let { adaptiveCardsPackage: e } = p2e();
  return [e];
}
function A0() {
  let [e] = du.useStyleOptions();
  return [e];
}
var { useDirection: JIr } = du;
function h2e(e, t, r) {
  if (e instanceof r.Container && (e.rtl = t), e.getItemAt && e.getItemCount) {
    let n = e.getItemCount();
    for (let i = 0; i < n; i++) {
      let o = e.getItemAt(i);
      h2e(o, t, r);
    }
  }
}
function v2e() {
  let [e] = gl(), [t] = JIr(), [{ adaptiveCardsParserMaxVersion: r }] = A0(), { AdaptiveCard: n, SerializationContext: i, Version: o } = e, a = tt(() => {
    let u = o.parse(r, new i());
    if (u && !u.isValid) {
      console.warn('botframework-webchat: "adaptiveCardsParserMaxVersion" specified is not a valid version.');
      return;
    }
    return u;
  }, [r, i, o]);
  return mt((u, { ignoreErrors: s = !1 } = {}) => {
    if (!u) return;
    let c = new n(), l = [], f = new i(a);
    c.parse(u, f);
    let { eventCount: d } = f;
    for (let p = 0; p < d; p++) l.push(f.getEventAt(p));
    if (!s && l.length) throw console.error("botframework-webchat: Failed to parse Adaptive Card", { errors: l }), new Error("botframework-webchat: Failed to parse Adaptive Card");
    return h2e(c, t === "rtl", e), c;
  }, [n, e, t, a, i]);
}
function ZIr(e) {
  let t = tt(() => Mu().toString(36).substr(2, 5), []);
  return e = e ? `${e}--` : "", `${e}${t}`;
}
var { useLocalizer: QIr } = du;
function E2e(e, t) {
  if (t(e), e.getItemAt && e.getItemCount) for (let r = e.getItemCount(), n = 0; n < r; n++) E2e(e.getItemAt(n), t);
  if (e.getActionAt && e.getActionCount) for (let r = e.getActionCount(), n = 0; n < r; n++) t(e.getActionAt(n));
}
var m2e = ({ input: { choices: e, defaultValue: t, label: r } }) => {
  let n = ZIr("webchat__id"), i = e.find(({ value: o }) => t === o || !t && !o);
  return G.createElement("div", null, G.createElement("select", { "aria-label": r, "aria-labelledby": !r && i ? n : void 0, defaultValue: t, tabIndex: -1 }, e.map((o) => G.createElement("option", { id: !r && o === i ? n : void 0, key: o.value, value: o.value }, o.title))));
};
m2e.propTypes = { input: Q.shape({ choices: Q.arrayOf(Q.shape({ title: Q.string, value: Q.any })), defaultValue: Q.any, label: Q.string, value: Q.any }).isRequired };
var g2e = ({ content: e }) => {
  let t = QIr(), r = v2e(), [{ ChoiceSetInput: n, DateInput: i, NumberInput: o, OpenUrlAction: a, ShowCardAction: u, SubmitAction: s, TextInput: c, TimeInput: l, ToggleInput: f }] = gl(), d = tt(() => r(e, { ignoreErrors: !0 }), [e, r]), p = tt(() => {
    let h = [];
    return E2e(d, (E) => {
      (E instanceof n || E instanceof i || E instanceof o || E instanceof a || E instanceof u || E instanceof s || E instanceof c || E instanceof l || E instanceof f) && h.push(E);
    }), h;
  }, [d, n, i, o, a, u, s, c, l, f]), v = t("ATTACHMENT_CARD", d.speak || "", "", "");
  return G.createElement("article", null, G.createElement("div", null, v), p.map((h, E) => h instanceof n ? G.createElement(m2e, { input: h, key: E }) : h instanceof i ? G.createElement("label", { key: E }, h.title, G.createElement("input", { placeholder: h.placeholder, tabIndex: -1, type: "date" })) : h instanceof o ? G.createElement("label", { key: E }, h.title, G.createElement("input", { placeholder: h.placeholder, tabIndex: -1, type: "number" })) : h instanceof a || h instanceof u || h instanceof s ? G.createElement("div", { key: E }, G.createElement("button", { tabIndex: -1, type: "button" }, h.title)) : h instanceof c ? G.createElement("label", { key: E }, h.title, G.createElement("input", { placeholder: h.placeholder, tabIndex: -1, type: "text" })) : h instanceof l ? G.createElement("label", { key: E }, h.title, G.createElement("input", { placeholder: h.placeholder, tabIndex: -1, type: "time" })) : h instanceof f ? G.createElement("label", { key: E }, h.title, G.createElement("input", { defaultChecked: h.value === h.valueOn, tabIndex: -1, type: "checkbox" })) : !1));
};
g2e.propTypes = { content: Q.any.isRequired };
var eOr = g2e, { useLocalizer: tOr } = du, T2e = ({ content: e = {} }) => {
  let t = tOr(), { buttons: r, facts: n, image: i, images: o, items: a, subtitle: u, tax: s, text: c, title: l, total: f, vat: d } = e, p = t("RECEIPT_CARD_TAX"), v = t("RECEIPT_CARD_TOTAL"), h = t("RECEIPT_CARD_VAT"), E = t("ATTACHMENT_CARD", l || "", u || "", c || "");
  return G.createElement("article", null, G.createElement("div", null, E), !!i && !!i.alt && G.createElement("img", { alt: i.alt }), !!o && !!o.length && o.map(({ alt: m }, g) => G.createElement("img", { alt: m, key: g })), !!n && !!n.length && G.createElement("dl", null, n.map(({ key: m, value: g }, y) => G.createElement(G.Fragment, { key: y }, G.createElement("dt", null, m), G.createElement("dd", null, g)))), !!a && !!a.length && G.createElement("ul", null, a.map(({ image: m, price: g, quantity: y, subtitle: _, text: S, title: A }, O) => G.createElement("li", { key: O }, !!m && !!m.alt && G.createElement("img", { alt: m.alt }), !!A && G.createElement("p", null, A), !!_ && G.createElement("p", null, _), !!S && G.createElement("p", null, S), !!y && G.createElement("p", null, y), !!g && G.createElement("p", null, g)))), !!d && G.createElement("p", null, h, " ", d), !!s && G.createElement("p", null, p, " ", s), !!f && G.createElement("p", null, v, " ", f), !!r && !!r.length && G.createElement("div", null, r.map(({ title: m }, g) => G.createElement("button", { key: g, tabIndex: -1, type: "button" }, m))));
};
T2e.propTypes = { content: Q.any.isRequired };
var rOr = T2e, nOr = ["application/vnd.microsoft.card.animation", "application/vnd.microsoft.card.audio", "application/vnd.microsoft.card.hero", "application/vnd.microsoft.card.oauth", "application/vnd.microsoft.card.receipt", "application/vnd.microsoft.card.signin", "application/vnd.microsoft.card.thumbnail", "application/vnd.microsoft.card.video"];
function y2e() {
  return () => (e) => (...t) => {
    let [{ attachment: { content: r, contentType: n } }] = t;
    return r && nOr.includes(n) ? () => G.createElement(rOr, { content: r }) : r && n === "application/vnd.microsoft.card.adaptive" ? () => G.createElement(eOr, { content: r }) : e(...t);
  };
}
var iOr = du.useStyleSet;
function cv() {
  let [e] = iOr();
  return Object.freeze([e]);
}
var oOr = { adaptiveCardsParserMaxVersion: void 0, cardEmphasisBackgroundColor: "#F9F9F9", cardPushButtonBackgroundColor: "#0063B1", cardPushButtonTextColor: "White", richCardWrapTitle: !1 }, aOr = oOr;
function _2e(e) {
  return { ...aOr, ...e };
}
function uOr(e) {
  let { accent: t, bubbleTextColor: r, cardEmphasisBackgroundColor: n, primaryFont: i, subtle: o } = { ...Zb(e), ..._2e(e) };
  return { containerStyles: { default: { foregroundColors: { default: { default: r, subtle: o }, accent: { default: t, subtle: "#0078D4" }, attention: { default: "#D13438", subtle: "#A4262C" }, dark: { default: "#000000", subtle: "#646464" }, good: { default: "#0B6A0B", subtle: "#028A02" }, light: { default: "#FFFFFF", subtle: o }, warning: { default: "#B75C00", subtle: "#986F0B" } } }, emphasis: { backgroundColor: n, foregroundColors: { default: { default: "#000000", subtle: "#484644" } } }, accent: { backgroundColor: "#C7DEF9", foregroundColors: { default: { default: "#333333", subtle: "#484644" } } }, good: { backgroundColor: "#CCFFCC", foregroundColors: { default: { default: "#333333", subtle: "#484644" } } }, attention: { backgroundColor: "#FFC5B2", foregroundColors: { default: { default: "#333333", subtle: "#484644" } } }, warning: { backgroundColor: "#FFE2B2", foregroundColors: { default: { default: "#333333", subtle: "#484644" } } } }, supportsInteractivity: !0, fontFamily: i, imageSizes: { small: 40, medium: 80, large: 160 }, actions: { actionAlignment: "stretch", actionsOrientation: "vertical", buttonSpacing: 8, maxActions: 100, showCard: { actionMode: "inline", inlineTopMargin: 8 }, spacing: "default" }, adaptiveCard: { allowCustomStyle: !1 }, imageSet: { imageSize: "medium", maxImageHeight: 100 }, factSet: { title: { color: "default", size: "default", isSubtle: !1, weight: "bolder", wrap: !0, maxWidth: 150 }, value: { color: "default", size: "default", isSubtle: !1, weight: "default", wrap: !0 }, spacing: 8 }, textBlock: { headingLevel: 2 } };
}
function A2e() {
  let { hostConfigFromProps: e } = p2e(), [t] = A0();
  return [tt(() => e || uOr(t), [e, t])];
}
function P8(e) {
  let t = Ut(e);
  return t.current = e, t;
}
var sOr = () => {
}, yT = sOr;
function S2e(e, t, r, n) {
  return e ? (e.addEventListener(t, r, n), () => e.removeEventListener(t, r, n)) : yT;
}
function sU(e) {
  let t;
  return () => {
    t || (t = !0, [...e].reverse().forEach((r) => r == null ? void 0 : r()));
  };
}
function cOr(e, t) {
  if (typeof e.closest == "function") return e.closest(t);
  let r = e;
  for (; r; ) {
    if ((r.matches || r.msMatchesSelector).call(r, t)) return r;
    r = r.parentElement;
  }
}
function sse(e, t) {
  let { classList: r } = e;
  if (!r.contains(t)) return r.add(t), !0;
}
function cse(e, t) {
  if (e) {
    sse(e, t);
    let r = new MutationObserver(() => sse(e, t));
    return r.observe(e, { attributes: !0, attributeFilter: ["class"] }), () => {
      e.classList.remove(t), r.disconnect();
    };
  }
  return yT;
}
function Ib(e, t) {
  for (let r = e.getActionCount(), n = 0; n < r; n++) {
    let i = e.getActionAt(n);
    if (i.renderedElement === t) return i;
    if (i.getJsonTypeName() === "Action.ShowCard") {
      let { card: o } = i, a = o && Ib(o, t);
      if (a) return a;
    }
  }
  return e.findDOMNodeOwner(t);
}
function lOr(e, t) {
  return !!e && e.hasAttribute(t) && (e.getAttribute(t) || "");
}
function lse(e, t, r) {
  r === !1 ? e == null || e.removeAttribute(t) : e == null || e.setAttribute(t, r);
}
function ls(e, t, r) {
  if (!e) return yT;
  let n = lOr(e, t);
  return n === r ? yT : (lse(e, t, r), () => lse(e, t, n));
}
var fse = Symbol();
function fOr(e) {
  let t = Ut(fse);
  return t.current === fse && (t.current = e()), t;
}
var CT, Af, Vse, dOr = (Vse = class {
  constructor(e) {
    I0(this, CT);
    I0(this, Af);
    bl(this, CT, e);
  }
  apply(e, t, ...r) {
    var n;
    (n = Sl(this, Af)) == null || n.call(this), bl(this, Af, e && t && Sl(this, CT).call(this, e, t, ...r));
  }
  undo() {
    var e;
    (e = Sl(this, Af)) == null || e.call(this), bl(this, Af, void 0);
  }
}, CT = new WeakMap(), Af = new WeakMap(), Vse);
function c_(e, t) {
  let r = P8(t), n = tt(() => new dOr(e), [e]), i = Ut(), o = fOr(() => new MutationObserver(() => {
    var s;
    (s = i.current) == null || s.call(i);
  }));
  nr(() => () => {
    o.current.disconnect();
  }, [o]);
  let a = mt((s, ...c) => {
    r.current && s && (i.current = () => n.apply(r.current, s, ...c))();
    let { current: l } = o;
    l.disconnect(), l.observe(s, { childList: !0, subtree: !0 });
  }, [r, o, n]), u = mt(() => {
    n.undo(), i.current = void 0;
  }, [n, i]);
  return tt(() => Object.freeze([a, u]), [a, u]);
}
function cU(e) {
  let t = Ut();
  return nr(() => {
    t.current = e;
  }), t.current;
}
function pOr(e) {
  let t = cU(e), r = Ut(/* @__PURE__ */ new Set());
  t === e || r.current.clear();
  let n = tt(() => (i, o, a) => {
    let u = [];
    return Array.from(o.querySelectorAll("button.ac-pushButton")).forEach((s) => {
      let c = Ib(i, s);
      s.hasAttribute("aria-expanded") || (r.current.has(c) ? (a && u.push(cse(s, a)), u.push(ls(s, "aria-pressed", "true"))) : u.push(ls(s, "aria-pressed", "false"))), u.push(ls(s, "aria-posinset", !1), ls(s, "aria-setsize", !1), ls(s, "role", !1));
    }), u.push(S2e(o, "click", ({ target: s }) => {
      let c = cOr(s, "button.ac-pushButton");
      if (!c) return;
      let l = Ib(i, c);
      !l || c.getAttribute("aria-disabled") === "true" || c.hasAttribute("aria-expanded") || (a && u.push(cse(c, a)), u.push(ls(c, "aria-pressed", "true")), l && r.current.add(l));
    }, { capture: !0 })), () => sU(u)();
  }, [r]);
  return c_(n, e);
}
function hOr(e) {
  let t = Ut();
  cU(e) !== e && (t.current = void 0);
  let r = tt(() => (n) => {
    var i, o, a;
    return (a = (o = (i = t.current) == null ? void 0 : i.renderedElement) == null ? void 0 : o.focus) == null || a.call(o), () => {
      t.current = Ib(n, document.activeElement);
    };
  }, [t]);
  return c_(r, e);
}
function vOr(e) {
  e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
}
function EOr(e, t) {
  let r = e.nodeName.toLowerCase();
  switch (r) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      t.push(S2e(e, "click", vOr, { capture: !0 }), ls(e, "aria-disabled", "true"), ls(e, "tabindex", "-1")), r === "input" || r === "textarea" ? t.push(ls(e, "readonly", "readonly")) : r === "select" && t.push(...Array.from(e.querySelectorAll("option")).map((n) => ls(n, "disabled", "disabled")));
      break;
  }
}
function mOr(e) {
  if (!e) return yT;
  let t = [], r = () => EOr(e, t);
  r();
  let n = new MutationObserver(r);
  return n.observe(e, { attributeFilter: ["tabindex"] }), t.push(() => n.disconnect()), sU(t);
}
var gOr = () => {
}, TOr = "button:not([aria-expanded]), input, select, textarea";
function yOr(e) {
  let t = tt(() => (r, n, i) => {
    if (!i) return gOr;
    let o = Array.from(n.querySelectorAll(TOr)).map((a) => mOr(a));
    return () => sU(o)();
  }, []);
  return c_(t, e);
}
function _Or(e) {
  return e ? Array.from(e.querySelectorAll("input, option, textarea")).reduce((t, r) => {
    if (r instanceof HTMLInputElement) {
      let { type: n } = r;
      n === "checkbox" || n === "radio" ? r.checked && t.add(r.value) : (t.clear(), t.add(r.value));
    } else r instanceof HTMLOptionElement ? r.selected && t.add(r.value) : (t.clear(), t.add(r.value));
    return t;
  }, /* @__PURE__ */ new Set()) : /* @__PURE__ */ new Set();
}
function AOr(e, t) {
  if (!e) return;
  let r = Array.from(t)[0] || "";
  e.querySelectorAll("input, option, textarea").forEach((n) => {
    if (n instanceof HTMLInputElement) {
      let { type: i } = n;
      i === "checkbox" || i === "radio" ? n.checked = t.has(n.value) : n.value = r;
    } else n instanceof HTMLOptionElement ? n.selected = t.has(n.value) : n.value = r;
  });
}
function SOr(e) {
  let t = cU(e), r = Ut(/* @__PURE__ */ new Map());
  t === e || r.current.clear();
  let n = tt(() => (i) => {
    let { current: o } = r;
    return i.getAllInputs().forEach((a) => {
      o.has(a) && AOr(a.renderedElement, o.get(a));
    }), () => {
      r.current = i.getAllInputs().reduce((a, u) => {
        let s = _Or(u.renderedElement);
        return typeof s < "u" ? a.set(u, s) : a;
      }, /* @__PURE__ */ new Map());
    };
  }, [r]);
  return c_(n, e);
}
function bOr(e) {
  let t = tt(() => (r, n) => ls(n, "role", n.querySelector("button, input, select, textarea") && n.getAttribute("aria-label") || n.getAttribute("aria-labelledby") || n.getAttribute("title") ? "form" : "figure"), []);
  return c_(t, e);
}
function COr(e) {
  return Object.getPrototypeOf(e) === Object.prototype;
}
function IOr(e, { adaptiveCardsHostConfig: t, adaptiveCardsPackage: { GlobalSettings: r, HostConfig: n }, renderMarkdownAsHTML: i, setTabIndexAtCardRoot: o }) {
  e.constructor.onProcessMarkdown = (s, c) => {
    i && (c.outputHtml = i(s), c.didProcess = !0);
  }, t && (e.hostConfig = COr(t) ? new n(t) : t), r.setTabIndexAtCardRoot = o;
  let { validationEvents: a } = e.validateProperties();
  if (a.length) return { errors: a.reduce((s, { message: c }) => [...s, new Error(c)], []) };
  let u;
  try {
    u = e.render();
  } catch (s) {
    return { errors: [s] };
  }
  return u ? { element: u } : { errors: [new Error("Adaptive Card rendered as empty element")] };
}
var { useDisabled: OOr, useLocalizer: ROr, usePerformCardAction: wOr, useRenderMarkdownAsHTML: POr, useScrollToEnd: DOr } = du, xOr = "production", lU = ({ actionPerformedClassName: e, adaptiveCard: t, disabled: r, tapAction: n }) => {
  let [{ adaptiveCardRenderer: i }] = cv(), [{ GlobalSettings: o, HostConfig: a }] = gl(), [u] = A2e(), [s] = OOr(), c = Ut();
  ROr();
  let l = wOr(), f = POr("adaptive cards"), d = DOr(), p = s || r, v = P8(n), h = P8(p), E = mt((w) => {
    let { key: $, type: X } = w, V = w.target, { current: F } = c, le = F.querySelector('.ac-adaptiveCard[tabindex="0"]');
    if (!le) return console.warn("botframework-webchat: No Adaptive Card root container can be found; the card is probably on an unsupported Adaptive Card version.");
    if (X === "keypress") {
      if ($ !== "Enter" && $ !== " ") return;
      w.preventDefault();
    }
    if (V !== le) {
      let ae = YEe(V);
      if (typeof ae == "number" && ae >= 0) return;
    }
    l(v.current), d();
  }, [c, l, d, v]), m = !p && n ? E : void 0, g = mt((w) => {
    if (h.current) return;
    let $ = w.getJsonTypeName(), { iconUrl: X, title: V } = w;
    if ($ === "Action.OpenUrl") {
      let { url: F } = w;
      l({ image: X, title: V, type: "openUrl", value: F });
    } else if ($ === "Action.Submit") {
      let { data: F } = w;
      typeof F < "u" && (typeof F == "string" ? l({ image: X, title: V, type: "imBack", value: F }) : F.__isBotFrameworkCardAction ? l(F.cardAction) : l({ image: X, title: V, type: "postBack", value: F })), d();
    } else console.error("Web Chat: received unknown action from Adaptive Cards"), console.error(w);
  }, [h, l, d]), y = !!n, [_, S] = pOr(t), [A, O] = hOr(t), [P, U] = yOr(t), [z, k] = SOr(t), [H, B] = bOr(t), { element: x, errors: D } = tt(() => (S(), O(), U(), k(), B(), IOr(t, { adaptiveCardsHostConfig: u, adaptiveCardsPackage: { GlobalSettings: o, HostConfig: a }, renderMarkdownAsHTML: f, setTabIndexAtCardRoot: y })), [t, u, o, a, f, y, S, O, U, k, B]);
  return tt(() => {
    t.onExecuteAction = g;
  }, [t, g]), Np(() => {
    let { current: w } = c;
    return w == null || w.appendChild(x), () => {
      w == null || w.removeChild(x);
    };
  }, [c, x]), Np(() => {
    x && (_(x, e), A(x), P(x, p), z(x), H(x));
  }, [e, _, A, P, z, H, p, x]), D != null && D.length && console.warn("botframework-webchat: Failed to render Adaptive Cards.", D), D != null && D.length ? xOr === "development" : G.createElement("div", { className: Gt(i + "", "webchat__adaptive-card-renderer"), onClick: m, onKeyPress: m, ref: c });
};
lU.defaultProps = { actionPerformedClassName: "", disabled: void 0, tapAction: void 0 };
lU.propTypes = { actionPerformedClassName: Q.string, adaptiveCard: Q.any.isRequired, disabled: Q.bool, tapAction: Q.shape({ image: Q.string, title: Q.string, type: Q.string.isRequired, value: Q.string }) };
var lv = lU;
function b2e(e) {
  if (!e.actions) return e;
  let t = e.actions.filter((r) => r.type !== "Action.Submit").map((r) => r.type === "Action.ShowCard" ? { ...r, card: b2e(r.card) } : r);
  return { ...e, nextActions: t };
}
var fU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let n = v2e(), i = tt(() => n(b2e({ version: "1.0", ...typeof t == "object" ? t : {} }), { ignoreErrors: !0 }), [t, n]);
  return !!i && G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: i, disabled: r });
};
fU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
fU.propTypes = { actionPerformedClassName: Q.string, content: Q.any.isRequired, disabled: Q.bool };
var C2e = fU, dU = ({ attachment: { content: e }, disabled: t }) => G.createElement(C2e, { content: e, disabled: t }), NOr = dU;
dU.defaultProps = { disabled: void 0 };
dU.propTypes = { attachment: Q.shape({ content: Q.any.isRequired }).isRequired, disabled: Q.bool };
function k5(e, t) {
  let { type: r } = e, n;
  return r === "imBack" || r === "messageBack" || r === "postBack" || r === "signin" && t ? (n = new yo.SubmitAction(), n.data = { __isBotFrameworkCardAction: !0, cardAction: e }, n.title = e.title) : (n = new yo.OpenUrlAction(), n.title = e.title, n.url = e.type === "call" ? `tel:${e.value}` : e.value), n;
}
var l_ = class {
  constructor(e, t, r = "ltr") {
    Do(this, "card");
    Do(this, "container");
    Do(this, "styleOptions");
    this.card = new e.AdaptiveCard(), this.container = new yo.Container(), this.container.rtl = r === "rtl", this.styleOptions = t, this.card.addItem(this.container);
  }
  addColumnSet(e, t = this.container, r) {
    let n = new yo.ColumnSet();
    return n.selectAction = r && k5(r), t.addItem(n), e.map((i) => {
      let o = new yo.Column();
      return o.width = new yo.SizeAndUnit(i, yo.SizeUnit.Weight), n.addColumn(o), o;
    });
  }
  addItems(e, t = this.container) {
    e.forEach((r) => t.addItem(r));
  }
  addTextBlock(e, t, r = this.container) {
    if (typeof e < "u") {
      let n = new yo.TextBlock();
      for (let i in t) ia(i) || (n[i] = t[i]);
      n.text = e, r.addItem(n);
    }
  }
  addButtons(e, t) {
    e && e.forEach((r) => {
      this.card.addAction(k5(r, t));
    });
  }
  addCommonHeaders(e) {
    let { richCardWrapTitle: t } = this.styleOptions;
    this.addTextBlock(e.title, { color: yo.TextColor.Default, size: yo.TextSize.Medium, style: "heading", weight: yo.TextWeight.Bolder, wrap: t }), this.addTextBlock(e.subtitle, { color: yo.TextColor.Default, isSubtle: !0, wrap: t }), this.addTextBlock(e.text, { color: yo.TextColor.Default, wrap: !0 });
  }
  addCommon(e) {
    this.addCommonHeaders(e), this.addButtons(e.buttons);
  }
  addImage(e, t, r, n) {
    t = t || this.container;
    let i = new yo.Image();
    i.altText = n, i.url = e, i.selectAction = r && k5(r), i.size = yo.Size.Stretch, t.addItem(i);
  }
}, { useDirection: LOr } = du, pU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [n] = gl(), [i] = LOr(), [o] = A0(), a = tt(() => {
    if (t) {
      let u = new l_(n, o, i);
      return u.addCommon(t), u.card;
    }
  }, [n, t, i, o]);
  return G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: a, disabled: r, tapAction: t && t.tap });
};
pU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
pU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ tap: Q.any }).isRequired, disabled: Q.bool };
var C2 = pU, { ImageContent: BOr, VideoContent: kOr } = Ey, hU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let { media: n = [] } = t, [{ animationCardAttachment: i }] = cv();
  return G.createElement("div", { className: i }, G.createElement("ul", { className: "media-list" }, n.map(({ profile: o = "", url: a }, u) => G.createElement("li", { key: u }, /\.gif$/iu.test(a) ? G.createElement(BOr, { alt: o, src: a }) : G.createElement(kOr, { alt: o, src: a })))), G.createElement(C2, { actionPerformedClassName: e, content: t, disabled: r }));
};
hU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
hU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ media: Q.arrayOf(Q.shape({ profile: Q.string, url: Q.string.isRequired })).isRequired }).isRequired, disabled: Q.bool };
var I2e = hU, vU = ({ attachment: { content: e }, disabled: t }) => G.createElement(I2e, { content: e, disabled: t });
vU.defaultProps = { disabled: void 0 };
vU.propTypes = { attachment: Q.shape({ content: Q.shape({ media: Q.arrayOf(Q.shape({ profile: Q.string, url: Q.string.isRequired })).isRequired }).isRequired }).isRequired, disabled: Q.bool };
var MOr = vU, { AudioContent: FOr } = Ey, EU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [{ audioCardAttachment: n }] = cv(), { autostart: i = !1, autoloop: o = !1, image: { url: a = "" } = {}, media: u = [] } = t;
  return G.createElement("div", { className: n }, G.createElement("ul", { className: "media-list" }, u.map(({ url: s }, c) => G.createElement("li", { key: c }, G.createElement(FOr, { autoPlay: i, loop: o, poster: a, src: s })))), G.createElement(C2, { actionPerformedClassName: e, content: t, disabled: r }));
};
EU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
EU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ autostart: Q.bool, autoloop: Q.bool, image: Q.shape({ url: Q.string.isRequired }), media: Q.arrayOf(Q.shape({ url: Q.string.isRequired }).isRequired).isRequired }).isRequired, disabled: Q.bool };
var O2e = EU, mU = ({ attachment: { content: e }, disabled: t }) => G.createElement(O2e, { content: e, disabled: t });
mU.defaultProps = { disabled: void 0 };
mU.propTypes = { attachment: Q.shape({ content: Q.shape({ autostart: Q.bool, autoloop: Q.bool, image: Q.shape({ url: Q.string.isRequired }), media: Q.arrayOf(Q.shape({ url: Q.string.isRequired }).isRequired).isRequired }) }).isRequired, disabled: Q.bool };
var HOr = mU, { useDirection: $Or } = du, gU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [n] = gl(), [i] = A0(), [o] = $Or(), a = tt(() => {
    let u = new l_(n, i, o);
    if (t) return (t.images || []).forEach((s) => u.addImage(s.url, null, s.tap, s.alt)), u.addCommon(t), u.card;
  }, [n, t, o, i]);
  return G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: a, disabled: r, tapAction: t && t.tap });
};
gU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
gU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ images: Q.arrayOf(Q.shape({ alt: Q.string.isRequired, tap: Q.any, url: Q.string.isRequired })), tap: Q.any }).isRequired, disabled: Q.bool };
var R2e = gU, TU = ({ attachment: { content: e } = {}, disabled: t }) => !!e && G.createElement(R2e, { content: e, disabled: t });
TU.defaultProps = { disabled: void 0 };
TU.propTypes = { attachment: Q.shape({ content: Q.shape({ buttons: Q.any, images: Q.arrayOf(Q.shape({ alt: Q.string, tap: Q.any, url: Q.string.isRequired })), subtitle: Q.string, tap: Q.any, text: Q.string, title: Q.string }).isRequired }).isRequired, disabled: Q.bool };
var UOr = TU, { useDirection: VOr } = du, yU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [n] = gl(), [i] = VOr(), [o] = A0(), a = tt(() => {
    if (t) {
      let u = new l_(n, o, i);
      return u.addCommonHeaders(t), u.addButtons(t.buttons, !0), u.card;
    }
  }, [n, t, i, o]);
  return G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: a, disabled: r });
};
yU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
yU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ buttons: Q.array }).isRequired, disabled: Q.bool };
var w2e = yU, _U = ({ attachment: { content: e } = {}, disabled: t }) => G.createElement(w2e, { content: e, disabled: t });
_U.defaultProps = { disabled: void 0 };
_U.propTypes = { attachment: Q.shape({ content: Q.shape({ buttons: Q.array }).isRequired }).isRequired, disabled: Q.bool };
var jOr = _U, { useDirection: zOr, useLocalizer: qOr } = du;
function M5(e) {
  return e === null || typeof e > "u";
}
var AU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [n] = gl(), [i] = zOr(), [o] = A0(), a = qOr(), u = a("RECEIPT_CARD_TAX"), s = a("RECEIPT_CARD_TOTAL"), c = a("RECEIPT_CARD_VAT"), l = tt(() => {
    let f = new l_(n, o, i), { HorizontalAlignment: d, TextSize: p, TextWeight: v } = n, { buttons: h, facts: E, items: m, tax: g, title: y, total: _, vat: S } = t, { richCardWrapTitle: A } = o;
    if (t) {
      if (f.addTextBlock(y, { size: p.Medium, weight: v.Bolder, wrap: A }), E) {
        let [O, P] = f.addColumnSet([75, 25]);
        E.map(({ key: U, value: z }) => {
          f.addTextBlock(U, { size: p.Medium }, O), f.addTextBlock(z, { size: p.Medium, horizontalAlignment: d.Right }, P);
        });
      }
      if (m && m.map(({ image: { alt: O, tap: P, url: U } = {}, price: z, quantity: k, subtitle: H, tap: B, text: x, title: D }) => {
        let w;
        if (U) {
          let [V, ...F] = f.addColumnSet([15, 75, 10]);
          w = F, f.addImage(U, V, P, O);
        } else w = f.addColumnSet([75, 25], void 0, B && B);
        let [$, X] = w;
        f.addTextBlock(k ? `${D} &times; ${k}` : D, { size: p.Medium, weight: v.Bolder, wrap: A }, $), f.addTextBlock(H, { size: p.Medium, wrap: A }, $), f.addTextBlock(z, { horizontalAlignment: d.Right }, X), x && f.addTextBlock(x, { size: p.Medium, wrap: A }, $);
      }), !M5(S)) {
        let O = f.addColumnSet([75, 25]);
        f.addTextBlock(c, { size: p.Medium, weight: v.Bolder }, O[0]), f.addTextBlock(S, { horizontalAlignment: d.Right }, O[1]);
      }
      if (!M5(g)) {
        let O = f.addColumnSet([75, 25]);
        f.addTextBlock(u, { size: p.Medium, weight: v.Bolder }, O[0]), f.addTextBlock(g, { horizontalAlignment: d.Right }, O[1]);
      }
      if (!M5(_)) {
        let O = f.addColumnSet([75, 25]);
        f.addTextBlock(s, { size: p.Medium, weight: v.Bolder }, O[0]), f.addTextBlock(_, { horizontalAlignment: d.Right, size: p.Medium, weight: v.Bolder }, O[1]);
      }
      return f.addButtons(h), f.card;
    }
  }, [n, t, i, o, u, s, c]);
  return G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: l, disabled: r, tapAction: t && t.tap });
};
AU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
AU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ buttons: Q.array, facts: Q.arrayOf(Q.shape({ key: Q.string, value: Q.string })), items: Q.arrayOf(Q.shape({ image: Q.shape({ alt: Q.string.isRequired, tap: Q.any, url: Q.string.isRequired }), price: Q.string.isRequired, quantity: Q.string, subtitle: Q.string, tap: Q.any, text: Q.string, title: Q.string.isRequired })), tap: Q.any, tax: Q.string, title: Q.string, total: Q.string, vat: Q.string }).isRequired, disabled: Q.bool };
var P2e = AU, SU = ({ attachment: { content: e }, disabled: t }) => G.createElement(P2e, { content: e, disabled: t });
SU.defaultProps = { disabled: void 0 };
SU.propTypes = { attachment: Q.shape({ content: Q.shape({ buttons: Q.array, facts: Q.arrayOf(Q.shape({ key: Q.string, value: Q.string })), items: Q.arrayOf(Q.shape({ image: Q.shape({ alt: Q.string.isRequired, tap: Q.any, url: Q.string.isRequired }), price: Q.string.isRequired, quantity: Q.string, subtitle: Q.string, tap: Q.any, text: Q.string, title: Q.string.isRequired })), tap: Q.any, tax: Q.string, title: Q.string, total: Q.string, vat: Q.string }).isRequired }).isRequired, disabled: Q.bool };
var YOr = SU, bU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [{ animationCardAttachment: n }] = cv();
  return G.createElement("div", { className: n }, G.createElement(C2, { actionPerformedClassName: e, content: t, disabled: r }));
};
bU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
bU.propTypes = { actionPerformedClassName: Q.string, content: Q.any.isRequired, disabled: Q.bool };
var D2e = bU, CU = ({ attachment: { content: e }, disabled: t }) => G.createElement(D2e, { content: e, disabled: t });
CU.defaultProps = { disabled: void 0 };
CU.propTypes = { attachment: Q.shape({ content: Q.any.isRequired }).isRequired, disabled: Q.bool };
var GOr = CU, { useDirection: WOr } = du, IU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let [n] = gl(), [i] = WOr(), [o] = A0(), a = tt(() => {
    if (t) {
      let u = new l_(n, o, i), { TextSize: s, TextWeight: c } = n, { buttons: l, images: f, subtitle: d, text: p, title: v } = t, { richCardWrapTitle: h } = o;
      if (f && f.length) {
        let [E, m] = u.addColumnSet([75, 25]), [{ alt: g, tap: y, url: _ }] = f;
        u.addTextBlock(v, { size: s.Medium, weight: c.Bolder, wrap: h }, E), u.addTextBlock(d, { isSubtle: !0, wrap: h }, E), u.addImage(_, m, y, g), u.addTextBlock(p, { wrap: !0 }), u.addButtons(l);
      } else u.addCommon(t);
      return u.card;
    }
  }, [n, i, t, o]);
  return G.createElement(lv, { actionPerformedClassName: e, adaptiveCard: a, disabled: r, tapAction: t && t.tap });
};
IU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
IU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ buttons: Q.array, images: Q.arrayOf(Q.shape({ alt: Q.string.isRequired, tap: Q.any, url: Q.string.isRequired })), subtitle: Q.string, tap: Q.any, text: Q.string, title: Q.string }).isRequired, disabled: Q.bool };
var x2e = IU, OU = ({ attachment: { content: e }, disabled: t }) => G.createElement(x2e, { content: e, disabled: t });
OU.defaultProps = { disabled: void 0 };
OU.propTypes = { attachment: Q.shape({ content: Q.shape({ buttons: Q.array, images: Q.arrayOf(Q.shape({ alt: Q.string.isRequired, tap: Q.any, url: Q.string.isRequired })), subtitle: Q.string, tap: Q.any, text: Q.string, title: Q.string }).isRequired }).isRequired, disabled: Q.bool };
var KOr = OU, { VideoContent: XOr } = Ey, RU = ({ actionPerformedClassName: e, content: t, disabled: r }) => {
  let { autoloop: n, autostart: i, image: { url: o } = { url: void 0 }, media: a } = t, [{ audioCardAttachment: u }] = cv();
  return G.createElement("div", { className: u }, G.createElement("ul", { className: "media-list" }, a.map(({ url: s }, c) => G.createElement("li", { key: c }, G.createElement(XOr, { autoPlay: i, loop: n, poster: o, src: s })))), G.createElement(C2, { actionPerformedClassName: e, content: t, disabled: r }));
};
RU.defaultProps = { actionPerformedClassName: "", disabled: void 0 };
RU.propTypes = { actionPerformedClassName: Q.string, content: Q.shape({ autoloop: Q.bool, autostart: Q.bool, image: Q.shape({ url: Q.string.isRequired }), media: Q.arrayOf(Q.shape({ profile: Q.string, url: Q.string.isRequired })).isRequired }).isRequired, disabled: Q.bool };
var N2e = RU, wU = ({ attachment: { content: e }, disabled: t }) => G.createElement(N2e, { content: e, disabled: t });
wU.defaultProps = { disabled: void 0 };
wU.propTypes = { attachment: Q.shape({ content: Q.shape({ autoloop: Q.bool, autostart: Q.bool, image: Q.shape({ url: Q.string.isRequired }), media: Q.arrayOf(Q.shape({ profile: Q.string.isRequired, url: Q.string })) }) }).isRequired, disabled: Q.bool };
var JOr = wU;
function L2e() {
  return () => (e) => (...t) => {
    let [{ attachment: r }] = t;
    return r.contentType === "application/vnd.microsoft.card.hero" ? G.createElement(UOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.adaptive" ? G.createElement(NOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.animation" ? G.createElement(MOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.audio" ? G.createElement(HOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.oauth" ? G.createElement(jOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.receipt" ? G.createElement(YOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.signin" ? G.createElement(GOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.thumbnail" ? G.createElement(KOr, { attachment: r }) : r.contentType === "application/vnd.microsoft.card.video" ? G.createElement(JOr, { attachment: r }) : e(...t);
  };
}
function ZOr({ cardPushButtonBackgroundColor: e, cardPushButtonTextColor: t, accent: r, paddingRegular: n, primaryFont: i }) {
  return { "&.webchat__adaptive-card-renderer": { "& *": { boxSizing: "border-box" }, "& .ac-input, & .ac-inlineActionButton, & .ac-quickActionButton": { fontFamily: i }, "& .ac-multichoiceInput": { padding: n }, "& .ac-pushButton": { appearance: "none", backgroundColor: "White", borderStyle: "solid", borderWidth: 1, color: r, fontWeight: 600, padding: n }, "& .ac-pushButton.style-destructive": { backgroundColor: "#E50000", color: "white" }, "& .ac-pushButton.style-destructive:hover, & .ac-pushButton.style-destructive:active": { backgroundColor: "#BF0000" }, "& .ac-pushButton.style-positive": { backgroundColor: "#0078D7", color: "white" }, "& .ac-pushButton.style-positive:hover, & .ac-pushButton.style-positive:active": { backgroundColor: "#006ABC" }, "& .ac-pushButton, & input, & select, & textarea": { '&[aria-disabled="true"]': { backgroundColor: "rgba(239, 239, 239, 0.3)", borderColor: "rgba(118, 118, 118, 0.3)", borderStyle: "solid", borderWidth: 1, color: "#545454" } }, '& .ac-pushButton[aria-disabled="true"]': { backgroundColor: "#EEE", color: "#4F4F4F" }, '& .ac-pushButton[aria-pressed="true"]': { backgroundColor: e, borderColor: e, color: t, "@media (forced-colors: active)": { backgroundColor: "Highlight", borderColor: "Highlight", color: "HighlightText", forcedColorAdjust: "none" } }, '& input[aria-disabled="true"]': { padding: "2px 1px" } } };
}
function QOr() {
  return { display: "flex", flexDirection: "column", "& > ul.media-list": { listStyleType: "none", margin: 0, padding: 0 } };
}
function eRr({ paddingRegular: e = void 0 }) {
  return { display: "flex", flexDirection: "column", "& > ul.media-list": { listStyleType: "none", margin: e, padding: 0 } };
}
function B2e(e) {
  let t = { ...Zb(e), ..._2e(e) };
  return { adaptiveCardRenderer: ZOr(t), animationCardAttachment: QOr(), audioCardAttachment: eRr(t) };
}
var Ob = "⟬", tRr = new RegExp(Ob, "g"), Rb = "⟭", rRr = new RegExp(Rb, "g"), nRr = (e) => e.use(zlr, { allowedAttributes: ["aria-label"], leftDelimiter: Ob, rightDelimiter: Rb }), iRr = (e) => e.replace(/\{\s*aria-label()\s*\}/gi, `${Ob}aria-label${Rb}`).replace(/\{\s*aria-label=("[^"]*"|[^\s}]*)\s*\}/gi, (t, r) => `${Ob}aria-label=${r}${Rb}`), oRr = (e) => e.replace(tRr, "{").replace(rRr, "}"), aRr = nRr, uRr = (e) => e.replace(/\n\r|\r\n/g, (t) => t === `
\r` ? `\r
` : `
\r`), d4 = "​";
function* sRr(e) {
  let { length: t } = e;
  for (let r = 0; r < t; r++) yield e.item(r);
}
var cRr = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
function Bg(e, t, r) {
  r ? e.setAttribute(t, typeof r == "function" ? r(e.getAttribute(t)) : r) : r === !1 && e.removeAttribute(t);
}
function lRr(e, t) {
  for (let r of [...sRr(e.querySelectorAll("a"))]) {
    let n = t(r.getAttribute("href"), r.textContent);
    if (!n) continue;
    let { ariaLabel: i, asButton: o, className: a, iconAlt: u, iconClassName: s, rel: c, target: l, title: f, wrapZeroWidthSpace: d } = n;
    if (Bg(r, "aria-label", i), Bg(r, "class", a), Bg(r, "title", f), s) {
      let p = e.createElement("img");
      p.setAttribute("src", cRr), p.setAttribute("alt", ""), p.classList.add(s), u && p.setAttribute("title", u), r.insertAdjacentElement("beforeend", p);
    }
    if (o) {
      let p = e.createElement("button");
      r.hasAttribute("aria-label") && p.setAttribute("aria-label", r.getAttribute("aria-label")), r.hasAttribute("class") && p.setAttribute("class", r.getAttribute("class")), r.hasAttribute("title") && p.setAttribute("title", r.getAttribute("title")), p.setAttribute("type", "button"), p.setAttribute("value", r.getAttribute("href")), p.textContent = r.textContent, p.append(...r.children), r.replaceWith(p), d && (p.insertAdjacentText("beforebegin", d4), p.insertAdjacentText("afterend", d4));
    } else Bg(r, "rel", c), Bg(r, "target", l), d && (r.insertAdjacentText("beforebegin", d4), r.insertAdjacentText("afterend", d4));
  }
  return e;
}
function fRr(e) {
  return e.type === "definition";
}
function* dRr(e) {
  for (let t of Cve(e).children) fRr(t) && (yield t);
}
var dse = Object.freeze({ allowedAttributes: { a: ["aria-label", "class", "href", "name", "rel", "target"], button: ["aria-label", "class", "type", "value"], img: ["alt", "class", "src", "title"], span: ["aria-label"] }, allowedSchemes: ["data", "http", "https", "ftp", "mailto", "sip", "tel"], allowedTags: ["a", "b", "blockquote", "br", "button", "caption", "code", "del", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "ins", "li", "nl", "ol", "p", "pre", "s", "span", "strike", "strong", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], nonBooleanAttributes: [] });
function k2e(e, { markdownRespectCRLF: t, markdownRenderHTML: r }, { externalLinkAlt: n = "" } = Object.freeze({})) {
  let i = Array.from(dRr(e)), o = Object.freeze({ breaks: !1, html: r ?? !0, linkify: !0, typographer: !0, xhtmlOut: !0 });
  t && (e = uRr(e)), e = iRr(e);
  let a = (l, f) => {
    let d = { rel: "noopener noreferrer", target: "_blank", wrapZeroWidthSpace: !0 }, p = [f], v = /* @__PURE__ */ new Set(), h = i.find(({ url: m }) => m === l), E = Hp(() => new URL(l).protocol);
    return h && (p.push(h.title || Hp(() => new URL(h.url).host) || h.url), h.label === f && v.add("webchat__render-markdown__pure-identifier")), dse.allowedSchemes.map((m) => `${m}:`).includes(E) ? (E === "http:" || E === "https:") && (d.iconAlt = n, d.iconClassName = "webchat__render-markdown__external-link-icon", p.push(n)) : (d.asButton = !0, v.add("webchat__render-markdown__citation")), p.length > 1 && (d.ariaLabel = (m) => m || p.join(" ")), d.className = Array.from(v).join(" "), d.title = !1, d;
  }, u = oRr(new xC(o).use(aRr).render(e)), s = Afe(u);
  lRr(s, a);
  let c = Sfe(s);
  return mcr(c, dse);
}
function pRr({ attachmentForScreenReaderMiddleware: e, attachmentMiddleware: t, renderMarkdown: r, styleOptions: n, styleSet: i }) {
  let o = tt(() => [...t, L2e()], [t]), a = tt(() => [...e, y2e()], [e]), u = tt(() => i ? void 0 : B2e(n), [n, i]), s = tt(() => typeof r > "u" ? k2e : r, [r]);
  return { attachmentForScreenReaderMiddleware: a, attachmentMiddleware: o, extraStyleSet: u, renderMarkdown: s };
}
var hRr = rl('"adaptiveCardHostConfig" is deprecated. Please use "adaptiveCardsHostConfig" instead. "adaptiveCardHostConfig" will be removed on or after 2022-01-01.'), vRr = ({ adaptiveCardHostConfig: e, adaptiveCardsHostConfig: t, adaptiveCardsPackage: r, attachmentForScreenReaderMiddleware: n, attachmentMiddleware: i, children: o, renderMarkdown: a, styleOptions: u, styleSet: s }) => {
  e && hRr();
  let c = pRr({ attachmentForScreenReaderMiddleware: Li(n), attachmentMiddleware: Li(i), renderMarkdown: a, styleOptions: u, styleSet: s });
  return G.createElement(XIr, { adaptiveCardsHostConfig: e || t, adaptiveCardsPackage: r }, o(c));
}, M2e = vRr, { Composer: PU } = Ey, DU = (e) => G.createElement(M2e, { ...e }, (t) => G.createElement(PU, { ...e, ...t }, e.children));
DU.defaultProps = { ...PU.defaultProps, adaptiveCardsHostConfig: void 0, adaptiveCardsPackage: void 0, children: void 0 };
DU.propTypes = { ...PU.propTypes, adaptiveCardsHostConfig: Q.any, adaptiveCardsPackage: Q.any, children: Q.any };
var ERr = DU, mRr = (e) => G.createElement(M2e, { ...e }, (t) => G.createElement(NF, { ...e, ...t })), F2e = mRr, gRr = Qa(GIr());
vr();
hu();
function TRr(e) {
  return (e.sampleSize >> 3) * e.channelCount * e.sampleRate;
}
j$();
j$();
vr();
m0();
hr();
var yRr = Qa(n2e(), 1);
function _Rr() {
  var e = {};
  return e.promise = new yRr.default(function(t, r) {
    e.resolve = t, e.reject = r;
  }), e;
}
var pse = _Rr, p4 = Symbol("deviceInfoDeferred"), h4 = Symbol("events"), kg = Symbol("formatDeferred"), v4 = Symbol("options"), jse, zse, qse, Yse, Gse, ARr = class extends (Gse = wp, Yse = p4, qse = h4, zse = kg, jse = v4, Gse) {
  constructor(t = {}) {
    super();
    Do(this, Yse);
    Do(this, qse);
    Do(this, zse);
    Do(this, jse);
    let r = { debug: t.debug || !1, id: t.id || P1e().replace(/-/gu, "") };
    this[p4] = pse(), this[h4] = new su(), this[kg] = pse(), this[v4] = r;
  }
  get events() {
    return this[h4];
  }
  get format() {
    return this.debug('Getting "format".'), this[kg].promise;
  }
  id() {
    return this[v4].id;
  }
  onEvent(t) {
    this[h4].onEvent(t), ci.instance.onEvent(t);
  }
  emitInitializing() {
    this.debug('Emitting "AudioSourceInitializingEvent".'), this.onEvent(new ih(this.id()));
  }
  emitReady() {
    this.debug('Emitting "AudioSourceReadyEvent".'), this.onEvent(new Hf(this.id()));
  }
  emitError(t) {
    this.debug('Emitting "AudioSourceErrorEvent".', { error: t }), this.onEvent(new oh(this.id(), t.message));
  }
  emitNodeAttaching(t) {
    this.debug(`Emitting "AudioStreamNodeAttachingEvent" for node "${t}".`), this.onEvent(new $f(this.id(), t));
  }
  emitNodeAttached(t) {
    this.debug(`Emitting "AudioStreamNodeAttachedEvent" for node "${t}".`), this.onEvent(new Uf(this.id(), t));
  }
  emitNodeError(t, r) {
    this.debug(`Emitting "AudioStreamNodeErrorEvent" for node "${t}".`, { error: r }), this.onEvent(new Zy(this.id(), t, r.message));
  }
  emitNodeDetached(t) {
    this.debug('Emitting "AudioStreamNodeDetachedEvent".'), this.onEvent(new hs(this.id(), t));
  }
  emitOff() {
    this.debug('Emitting "AudioSourceOffEvent".'), this.onEvent(new o2(this.id()));
  }
  close() {
    throw this.debug('Callback for "close".'), new Error("Not implemented");
  }
  turnOn() {
    throw this.debug('Callback for "turnOn".'), new Error("Not implemented");
  }
  detach() {
    throw this.debug('Callback for "detach".'), new Error("Not implemented");
  }
  debug(t, ...r) {
    this[v4].debug && console.info(`CustomAudioInputStream: ${t}`, ...r);
  }
  attach(t) {
    return this.debug(`Callback for "attach" with "${t}".`), this.emitNodeAttaching(t), Promise.resolve().then(async () => {
      this.emitInitializing();
      try {
        let { audioStreamNode: r, deviceInfo: n, format: i } = await this.performAttach(t);
        return this[p4].resolve(n), this[kg].resolve(new Kl(i.samplesPerSec, i.bitsPerSample, i.channels)), this.emitReady(), this.emitNodeAttached(t), { detach: async () => {
          this.debug(`Detaching audio node "${t}".`), await r.detach(), this.emitOff(), this.emitNodeDetached(t);
        }, id: () => r.id(), read: () => (this.debug("Reading"), r.read()) };
      } catch (r) {
        throw this.emitNodeError(t, r), r;
      }
    });
  }
  performTurnOff() {
  }
  async turnOff() {
    this.debug('Callback for "turnOff".'), await this.performTurnOff();
  }
  get deviceInfo() {
    return this.debug('Getting "deviceInfo".'), Promise.all([this[p4].promise, this[kg].promise]).then(([{ connectivity: t, manufacturer: r, model: n, type: i }, { bitsPerSample: o, channels: a, samplesPerSec: u }]) => ({ bitspersample: o, channelcount: a, connectivity: typeof t == "string" && !ia(t) ? r0[t] : t || r0.Unknown, manufacturer: r || "", model: n || "", samplerate: u, type: typeof i == "string" && !ia(i) ? tl[i] : i || tl.Unknown }));
  }
}, SRr = ARr, F5 = Symbol("attach"), H5 = Symbol("turnOff"), Wse, Kse, Xse, bRr = class extends (Xse = SRr, Kse = F5, Wse = H5, Xse) {
  constructor({ attach: t, debug: r, turnOff: n }) {
    if (!t || typeof t != "function") throw new Error('"attach" must be a function.');
    if (n && typeof n != "function") throw new Error('"turnOff", if defined, must be a function.');
    super({ debug: r });
    Do(this, Kse);
    Do(this, Wse);
    this[F5] = t, this[H5] = n;
  }
  performAttach(t) {
    return this[F5](t);
  }
  performTurnOff() {
    let { [H5]: t } = this;
    return t && t();
  }
};
function CRr(e) {
  return Xl.fromStreamInput(new bRr(e));
}
function IRr() {
  if (typeof window.AudioContext < "u") return new window.AudioContext();
  if (typeof window.webkitAudioContext < "u") return new window.webkitAudioContext();
  throw new Error("This browser does not support Web Audio API.");
}
function ORr(e) {
  let { navigator: t } = window;
  if (typeof t.mediaDevices < "u") return t.mediaDevices.getUserMedia(e);
  if (typeof t.getUserMedia < "u") return new Promise((r, n) => t.getUserMedia(e, r, n));
  throw new Error("This browser does not support Web Audio API.");
}
var hse = 100, sS = Object.freeze({ channelCount: 1, sampleRate: 16e3, sampleSize: 16 }), RRr = Object.freeze({ bitsPerSample: sS.sampleSize, channels: sS.channelCount, samplesPerSec: sS.sampleRate });
function wRr(e) {
  let { audioConstraints: t, audioContext: r, debug: n, enableTelemetry: i, pcmRecorderWorkletUrl: o } = e, a = e.bufferDurationInMS || hse, u = new L1();
  return o && u.setWorkletUrl(o), CRr({ async attach(s) {
    let c = await ORr({ audio: t, video: !1 }), [l] = c.getAudioTracks();
    if (!l) throw new Error("No audio device is found.");
    let f = new Qy(TRr(sS) * ((a || hse) / 1e3), s);
    return u.record(r, c, f), { audioStreamNode: { detach: () => {
      f.readEnded(), f.close(), u.releaseMediaResources(r), c.getTracks().forEach((d) => c.removeTrack(d));
    }, id: () => s, read: () => f.read() }, deviceInfo: { manufacturer: "Bot Framework Web Chat", model: i ? l.label : "", type: i ? "Microphones" : "Unknown" }, format: RRr };
  }, debug: n });
}
function H2e({ audioContext: e, audioInputDeviceId: t, enableTelemetry: r }) {
  return e || (e = IRr()), { audioConfig: wRr({ audioConstraints: t ? { deviceId: t } : !0, audioContext: e, enableTelemetry: r ? !0 : void 0 }), audioContext: e };
}
function PRr({ audioConfig: e, audioContext: t, audioInputDeviceId: r, credentials: n, enableTelemetry: i, speechRecognitionEndpointId: o, speechSynthesisDeploymentId: a, speechSynthesisOutputFormat: u, textNormalization: s }) {
  return !window.navigator.mediaDevices && !e ? (console.warn("botframework-webchat: Your browser does not support Web Audio or the page is not loaded via HTTPS or localhost. Cognitive Services Speech Services is disabled. However, you may pass a custom AudioConfig to enable speech in this environment."), () => ({})) : (e ? (r && console.warn('botframework-webchat: "audioConfig" and "audioInputDeviceId" cannot be set at the same time; ignoring "audioInputDeviceId".'), t && console.warn('botframework-webchat: "audioConfig" and "audioContext" cannot be set at the same time; ignoring "audioContext" for speech recognition.')) : { audioConfig: e, audioContext: t } = H2e({ audioContext: t, audioInputDeviceId: r, enableTelemetry: i }), ({ referenceGrammarID: c } = {}) => {
    let { SpeechGrammarList: l, SpeechRecognition: f, speechSynthesis: d, SpeechSynthesisUtterance: p } = (0, gRr.default)({ audioConfig: e, audioContext: t, credentials: n, enableTelemetry: i, referenceGrammars: c ? [`luis/${c}-PRODUCTION`] : [], speechRecognitionEndpointId: o, speechSynthesisDeploymentId: a, speechSynthesisOutputFormat: u, textNormalization: s });
    return { resumeAudioContext: () => t && t.state === "suspended" && t.resume(), SpeechGrammarList: l, SpeechRecognition: f, speechSynthesis: d, SpeechSynthesisUtterance: p };
  });
}
var DRr = "en-US";
function xRr({ audioConfig: e, audioContext: t, audioInputDeviceId: r, enableInternalHTTPSupport: n, enableTelemetry: i, fetchCredentials: o, speechRecognitionEndpointId: a, speechRecognitionLanguage: u = ((p) => (p = window == null ? void 0 : window.navigator) == null ? void 0 : p.language)() || DRr, speechSynthesisDeploymentId: s, speechSynthesisOutputFormat: c, textNormalization: l, userID: f, username: d }) {
  return e ? (r && console.warn('botframework-webchat: "audioConfig" and "audioInputDeviceId" cannot be set at the same time; ignoring "audioInputDeviceId".'), t && console.warn('botframework-webchat: "audioConfig" and "audioContext" cannot be set at the same time; ignoring "audioContext" for speech recognition.')) : window.navigator.mediaDevices ? { audioConfig: e, audioContext: t } = H2e({ audioContext: t, audioInputDeviceId: r, enableTelemetry: i }) : console.warn('botframework-webchat: Your browser does not support or allow microphone access or the page is not loaded via HTTPS or localhost. Speech is disabled for Direct Line Speech. However, you may pass a custom "audioConfig" to enable speech in this environment.'), ISr({ audioConfig: e, audioContext: t, audioInputDeviceId: void 0, enableInternalHTTPSupport: n, enableTelemetry: i, fetchCredentials: o, speechRecognitionEndpointId: a, speechRecognitionLanguage: u, speechSynthesisDeploymentId: s, speechSynthesisOutputFormat: c, textNormalization: l, userID: f, username: d });
}
function NRr(e) {
  return { ...wF(e), ...B2e(e) };
}
var LRr = w1e.bind(null, F2e), BRr = { ...Vtr, variant: "full" }, $2e = (e) => (e.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details."), O1e({ ...e, botAgent: `WebChat/${Ay} (Full)` })), kRr = (e) => (e.botAgent && console.warn("Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details."), R1e({ ...e, botAgent: `WebChat/${Ay} (Full)` })), Rf = { ...du, useAdaptiveCardsHostConfig: A2e, useAdaptiveCardsPackage: gl, useStyleOptions: A0, useStyleSet: cv }, MRr = { AdaptiveCardContent: C2e, AnimationCardContent: I2e, AudioCardContent: O2e, Composer: ERr, HeroCardContent: R2e, OAuthCardContent: w2e, ReceiptCardContent: P2e, SignInCardContent: D2e, ThumbnailCardContent: x2e, VideoCardContent: N2e }, pf = { ...Ey, ...MRr };
window.WebChat = { ...window.WebChat, buildInfo: BRr, Components: pf, createAdaptiveCardsAttachmentMiddleware: L2e, createAdaptiveCardsAttachmentForScreenReaderMiddleware: y2e, createCognitiveServicesSpeechServicesPonyfillFactory: PRr, createDirectLine: $2e, createDirectLineAppServiceExtension: kRr, createDirectLineSpeechAdapters: xRr, createStyleSet: NRr, hooks: Rf, ReactWebChat: F2e, renderMarkdown: k2e, renderWebChat: LRr, withEmoji: JC };
I1e("full");
/*! For license information please see chunk-5CGNWJX7.mjs.LEGAL.txt */
const ba = (...e) => e.filter((t) => typeof t == "string" && t.trim()).join(" "), FRr = "tbwch", HRr = 1e3, vse = 3, $Rr = "application/vnd.microsoft.card.adaptive", URr = "Great! Please rate your experience.", VRr = "Sorry, I didn't get that. Please enter a number from 1 to 5.", jRr = "Please rate your experience.", zRr = "application/vnd.microsoft.card.oauth", wo = (e) => `${FRr}__${e}`, U2e = async (e, t = {}) => {
  const r = await fetch(e, {
    ...t,
    headers: {
      ...t.headers,
      accept: "application/json"
    }
  });
  if (!r.ok)
    throw new Error(`Failed to fetch JSON from server due to ${r.status}`);
  return await r.json();
}, qRr = async (e, t) => (await U2e(
  new URL(
    `/powervirtualagents/regionalchannelsettings?api-version=${t}`,
    e
  )
)).channelUrlsById.directline, YRr = async (e) => (await U2e(e)).token, GRr = async (e) => {
  const t = new URL(e), r = t.searchParams.get("api-version") ?? "", [n, i] = await Promise.all([
    qRr(t, r),
    YRr(t)
  ]);
  return { directLineURL: n, token: i };
}, WRr = ({ directLineURL: e, token: t }) => $2e({
  domain: new URL("v3/directline", e).toString(),
  token: t
}), KRr = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.channelData) != null && t.hasRatingButtons);
}, XRr = (e) => {
  var t, r;
  return ((r = (t = e.suggestedActions) == null ? void 0 : t.actions) == null ? void 0 : r.length) > 0;
}, JRr = (e) => {
  var t;
  return !e.channelData.postBack && !((t = e.value) != null && t.rate);
}, ZRr = (e, t) => {
  const r = e.filter(JRr), n = r.length - 1, i = r[n].id;
  return t !== i;
}, QRr = (e) => {
  var r, n, i, o;
  const t = (r = e.attachments) == null ? void 0 : r[0];
  return (t == null ? void 0 : t.contentType) === $Rr && ((o = (i = (n = t == null ? void 0 : t.content) == null ? void 0 : n.body) == null ? void 0 : i[0]) == null ? void 0 : o.text) === URr;
}, V2e = (e) => e.text === VRr, I2 = (e) => {
  var r, n;
  return ((n = (r = e == null ? void 0 : e.attachments) == null ? void 0 : r[0]) == null ? void 0 : n.contentType) === zRr;
}, j2e = /^@TID_@TID_AUTH_KEY_.*/, ewr = /^@TID_@TID_USER_KEY_.*/, twr = (e) => [j2e, ewr].some((t) => t.test(e)), rwr = () => {
  const e = Object.keys(localStorage).filter(twr);
  for (const t of e)
    localStorage.removeItem(t);
}, nwr = (e) => Date.now() < e, iwr = () => {
  const t = Object.keys(localStorage).find((n) => j2e.test(n));
  if (!t) return null;
  const r = JSON.parse(localStorage.getItem(t));
  return nwr(r.expires_at) ? r.access_token : null;
}, owr = (e) => {
  var t, r, n, i;
  return (i = (n = (r = (t = e.attachments) == null ? void 0 : t[0]) == null ? void 0 : r.content) == null ? void 0 : n.tokenPostResource) == null ? void 0 : i.sasUrl;
}, awr = ({ className: e }) => /* @__PURE__ */ Jt(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "44",
    fill: "#0063A4",
    className: "mi-solid mi-stars",
    viewBox: "3 2 17 19",
    children: /* @__PURE__ */ Jt("path", { d: "m13 4.12-1.44.29a.49.49 0 0 0-.39.39l-.29 1.44-.29-1.44a.49.49 0 0 0-.39-.39l-1.44-.29 1.44-.29c.2-.04.35-.19.39-.39L10.88 2l.29 1.44c.04.2.19.35.39.39zM6.9 8.69a.75.75 0 0 1-.59-.59l-.43-2.16-.43 2.16c-.06.3-.29.53-.59.59l-2.16.43 2.16.43c.3.06.53.29.59.59l.43 2.16.43-2.16c.06-.3.29-.53.59-.59l2.16-.43zm7.14 5.45c-.59-.12-1.06-.58-1.18-1.18L12 8.64l-.87 4.32c-.12.59-.58 1.06-1.18 1.18L5.63 15l4.32.86c.59.12 1.06.58 1.18 1.18l.86 4.32.86-4.32c.12-.59.58-1.06 1.18-1.18l4.32-.86-4.32-.86Z" })
  }
), uwr = ({
  onClick: e,
  buttonIcon: t,
  className: r,
  loading: n
}) => {
  const i = wo("bot-assistant-button"), o = n && `${i}--loading`, a = `${i}__icon`;
  return /* @__PURE__ */ Jt(
    "button",
    {
      className: ba(i, o, r),
      type: "button",
      onClick: e,
      disabled: n,
      children: t || /* @__PURE__ */ Jt(awr, { className: a })
    }
  );
}, swr = ({ className: e }) => /* @__PURE__ */ Jt(
  "svg",
  {
    className: ba(wo("close-icon"), e),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Jt(
      "path",
      {
        d: "M18.3002 5.70998C18.2077 5.61728 18.0978 5.54373 17.9768 5.49355C17.8559 5.44337 17.7262 5.41754 17.5952 5.41754C17.4643 5.41754 17.3346 5.44337 17.2136 5.49355C17.0926 5.54373 16.9827 5.61728 16.8902 5.70998L12.0002 10.59L7.11022 5.69998C7.01764 5.6074 6.90773 5.53396 6.78677 5.48385C6.6658 5.43375 6.53615 5.40796 6.40522 5.40796C6.27429 5.40796 6.14464 5.43375 6.02368 5.48385C5.90272 5.53396 5.79281 5.6074 5.70022 5.69998C5.60764 5.79256 5.5342 5.90247 5.4841 6.02344C5.43399 6.1444 5.4082 6.27405 5.4082 6.40498C5.4082 6.53591 5.43399 6.66556 5.4841 6.78652C5.5342 6.90749 5.60764 7.0174 5.70022 7.10998L10.5902 12L5.70022 16.89C5.60764 16.9826 5.5342 17.0925 5.4841 17.2134C5.43399 17.3344 5.4082 17.464 5.4082 17.595C5.4082 17.7259 5.43399 17.8556 5.4841 17.9765C5.5342 18.0975 5.60764 18.2074 5.70022 18.3C5.79281 18.3926 5.90272 18.466 6.02368 18.5161C6.14464 18.5662 6.27429 18.592 6.40522 18.592C6.53615 18.592 6.6658 18.5662 6.78677 18.5161C6.90773 18.466 7.01764 18.3926 7.11022 18.3L12.0002 13.41L16.8902 18.3C16.9828 18.3926 17.0927 18.466 17.2137 18.5161C17.3346 18.5662 17.4643 18.592 17.5952 18.592C17.7262 18.592 17.8558 18.5662 17.9768 18.5161C18.0977 18.466 18.2076 18.3926 18.3002 18.3C18.3928 18.2074 18.4662 18.0975 18.5163 17.9765C18.5665 17.8556 18.5922 17.7259 18.5922 17.595C18.5922 17.464 18.5665 17.3344 18.5163 17.2134C18.4662 17.0925 18.3928 16.9826 18.3002 16.89L13.4102 12L18.3002 7.10998C18.6802 6.72998 18.6802 6.08998 18.3002 5.70998Z",
        fill: "#252A2E"
      }
    )
  }
), cwr = ({ className: e }) => /* @__PURE__ */ va(
  "svg",
  {
    className: ba(wo("logo-icon"), e),
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [
      /* @__PURE__ */ Jt("title", { children: "Trimble Assistant for SketchUp" }),
      /* @__PURE__ */ Jt("rect", { width: "35", height: "35", fill: "url(#pattern0_3_2286)" }),
      /* @__PURE__ */ va("defs", { children: [
        /* @__PURE__ */ Jt(
          "pattern",
          {
            id: "pattern0_3_2286",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ Jt(
              "use",
              {
                xlinkHref: "#image0_3_2286",
                transform: "matrix(0.00841751 0 0 0.00833333 0.037037 0)"
              }
            )
          }
        ),
        /* @__PURE__ */ Jt(
          "image",
          {
            id: "image0_3_2286",
            width: "100",
            height: "100",
            xlinkHref: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  }
), lwr = ({ className: e }) => /* @__PURE__ */ Jt(
  "svg",
  {
    className: ba(wo("refresh-icon"), e),
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ Jt(
      "path",
      {
        d: "M18.36 5.64a8.98 8.98 0 0 0-7.16-2.61c-4.2.36-7.66 3.73-8.13 7.92C2.46 16.39 6.68 21 12 21c3.59 0 6.67-2.1 8.11-5.13.36-.75-.18-1.62-1.01-1.62-.42 0-.82.22-.99.6-1.07 2.3-3.4 3.9-6.11 3.9-3.62 0-6.7-3.02-6.75-6.64S8.24 5.25 12 5.25c1.87 0 3.53.78 4.75 2l-1.92 1.92c-.63.63-.18 1.71.71 1.71H20c.55 0 1-.45 1-1V5.42c0-.89-1.08-1.34-1.71-.71l-.94.94Z",
        fill: "#252A2E"
      }
    )
  }
), wb = ({
  children: e,
  className: t,
  ...r
}) => {
  const n = wo("icon-button");
  return /* @__PURE__ */ Jt("button", { className: ba(n, t), ...r, children: e });
}, fwr = ({ chatNameSlot: e, onRefresh: t, onClose: r }) => /* @__PURE__ */ va("div", { className: "webchat-header", children: [
  e || /* @__PURE__ */ va("div", { className: "webchat-header__logo-container", children: [
    /* @__PURE__ */ Jt(cwr, {}),
    /* @__PURE__ */ va("div", { className: "webchat-header__text-container", children: [
      /* @__PURE__ */ Jt("span", { className: "webchat-header__text-container__name", children: "Trimble Assistant" }),
      /* @__PURE__ */ Jt("span", { className: "webchat-header__text-container__text", children: "for SketchUp" })
    ] })
  ] }),
  /* @__PURE__ */ va("div", { className: "webchat-header__buttons-container", children: [
    /* @__PURE__ */ Jt(wb, { className: "webchat-header__button", onClick: t, children: /* @__PURE__ */ Jt(lwr, {}) }),
    /* @__PURE__ */ Jt(wb, { className: "webchat-header__button", onClick: r, children: /* @__PURE__ */ Jt(swr, {}) })
  ] })
] }), dwr = ({ className: e }) => /* @__PURE__ */ va(
  "svg",
  {
    className: ba(wo("send-icon"), e),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ Jt("rect", { width: "24", height: "24", rx: "4", fill: "#0063A3" }),
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M5.29716 13.1254C5.26637 13.2451 5.25 13.3707 5.25 13.5V16.4056C5.25 17.5003 6.38465 18.2263 7.37859 17.7676L18.3996 12.681C18.9805 12.4128 18.9805 11.5872 18.3996 11.319L7.37859 6.23242C6.38466 5.77368 5.25 6.49967 5.25 7.59436V10.5C5.25 10.6294 5.26637 10.7549 5.29716 10.8747C5.46355 11.5218 6.05093 12 6.75 12C6.05093 12 5.46355 12.4783 5.29716 13.1254ZM6.75 12V7.59436L16.2955 12L6.75 16.4056L6.75 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M13.5 12.375H6.75V11.625H13.5C13.7071 11.625 13.875 11.7929 13.875 12C13.875 12.2071 13.7071 12.375 13.5 12.375Z",
          fill: "white"
        }
      )
    ]
  }
), pwr = ({ className: e, ...t }) => /* @__PURE__ */ Jt(
  "button",
  {
    className: ba(wo("send-button"), e),
    ...t,
    children: /* @__PURE__ */ Jt(dwr, {})
  }
), hwr = ({ className: e }) => {
  const [t] = Rf.useConnectivityStatus(), r = Rf.useSubmitSendBox(), [n] = Rf.useActivities(), i = () => r(), o = n.filter(
    (u) => u.type === "message" && !I2(u)
  ), a = t !== "connected" || o.length === 0;
  return /* @__PURE__ */ va(
    "div",
    {
      className: ba(
        "webchat__send-box__main",
        a && "webchat__send-box__main--disabled",
        e
      ),
      role: "form",
      children: [
        /* @__PURE__ */ Jt(pf.SendTextBox, { className: "webchat__send-box__text-box" }),
        /* @__PURE__ */ Jt(
          pwr,
          {
            className: "webchat__send-box__button",
            onClick: i,
            disabled: a
          }
        )
      ]
    }
  );
}, $5 = "#171C1E", vwr = {
  accent: $5,
  subtle: "#7D808D",
  paddingRegular: 12,
  primaryFont: "Open Sans",
  bubbleBackground: "#F1F1F6",
  bubbleTextColor: $5,
  bubbleBorderRadius: 8,
  bubbleBorderWidth: 0,
  bubbleNubSize: 1,
  bubbleFromUserBackground: "#DCEDF9",
  bubbleFromUserTextColor: $5,
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserBorderWidth: 0,
  bubbleFromUserNubSize: 1
}, Ese = (e) => {
  const {
    chatNameSlot: t,
    styleOptions: r,
    onRefresh: n,
    onChatClose: i,
    className: o,
    ...a
  } = e;
  return /* @__PURE__ */ Jt(
    pf.Composer,
    {
      ...a,
      styleOptions: { ...vwr, ...r },
      children: /* @__PURE__ */ va(
        pf.AccessKeySinkSurface,
        {
          className: ba("webchat__surface", o),
          role: "complementary",
          children: [
            /* @__PURE__ */ Jt(
              fwr,
              {
                chatNameSlot: t,
                onRefresh: n,
                onClose: i
              }
            ),
            /* @__PURE__ */ Jt(pf.BasicToaster, {}),
            /* @__PURE__ */ Jt(pf.BasicTranscript, {}),
            /* @__PURE__ */ Jt(pf.BasicConnectivityStatus, {}),
            /* @__PURE__ */ Jt("hr", { className: "webchat__divider" }),
            /* @__PURE__ */ Jt(hwr, {})
          ]
        }
      )
    }
  );
}, Ewr = ({ open: e, children: t, className: r }) => {
  const n = wo("sidebar");
  return BIe(
    /* @__PURE__ */ Jt(
      "div",
      {
        className: ba(
          n,
          e ? `${n}--open` : `${n}--closed`,
          r
        ),
        children: t
      }
    ),
    document.body
  );
};
var z2e = { exports: {} }, U5 = { exports: {} }, V5, mse;
function mwr() {
  if (mse) return V5;
  mse = 1;
  function e(he, _e) {
    return function() {
      return he.apply(_e, arguments);
    };
  }
  const { toString: t } = Object.prototype, { getPrototypeOf: r } = Object, n = /* @__PURE__ */ ((he) => (_e) => {
    const $e = t.call(_e);
    return he[$e] || (he[$e] = $e.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null)), i = (he) => (he = he.toLowerCase(), (_e) => n(_e) === he), o = (he) => (_e) => typeof _e === he, { isArray: a } = Array, u = o("undefined");
  function s(he) {
    return he !== null && !u(he) && he.constructor !== null && !u(he.constructor) && d(he.constructor.isBuffer) && he.constructor.isBuffer(he);
  }
  const c = i("ArrayBuffer");
  function l(he) {
    let _e;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? _e = ArrayBuffer.isView(he) : _e = he && he.buffer && c(he.buffer), _e;
  }
  const f = o("string"), d = o("function"), p = o("number"), v = (he) => he !== null && typeof he == "object", h = (he) => he === !0 || he === !1, E = (he) => {
    if (n(he) !== "object")
      return !1;
    const _e = r(he);
    return (_e === null || _e === Object.prototype || Object.getPrototypeOf(_e) === null) && !(Symbol.toStringTag in he) && !(Symbol.iterator in he);
  }, m = i("Date"), g = i("File"), y = i("Blob"), _ = i("FileList"), S = (he) => v(he) && d(he.pipe), A = (he) => {
    let _e;
    return he && (typeof FormData == "function" && he instanceof FormData || d(he.append) && ((_e = n(he)) === "formdata" || // detect form-data instance
    _e === "object" && d(he.toString) && he.toString() === "[object FormData]"));
  }, O = i("URLSearchParams"), [P, U, z, k] = ["ReadableStream", "Request", "Response", "Headers"].map(i), H = (he) => he.trim ? he.trim() : he.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function B(he, _e, { allOwnKeys: $e = !1 } = {}) {
    if (he === null || typeof he > "u")
      return;
    let Ue, rt;
    if (typeof he != "object" && (he = [he]), a(he))
      for (Ue = 0, rt = he.length; Ue < rt; Ue++)
        _e.call(null, he[Ue], Ue, he);
    else {
      const Et = $e ? Object.getOwnPropertyNames(he) : Object.keys(he), gt = Et.length;
      let lt;
      for (Ue = 0; Ue < gt; Ue++)
        lt = Et[Ue], _e.call(null, he[lt], lt, he);
    }
  }
  function x(he, _e) {
    _e = _e.toLowerCase();
    const $e = Object.keys(he);
    let Ue = $e.length, rt;
    for (; Ue-- > 0; )
      if (rt = $e[Ue], _e === rt.toLowerCase())
        return rt;
    return null;
  }
  const D = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : fe, w = (he) => !u(he) && he !== D;
  function $() {
    const { caseless: he } = w(this) && this || {}, _e = {}, $e = (Ue, rt) => {
      const Et = he && x(_e, rt) || rt;
      E(_e[Et]) && E(Ue) ? _e[Et] = $(_e[Et], Ue) : E(Ue) ? _e[Et] = $({}, Ue) : a(Ue) ? _e[Et] = Ue.slice() : _e[Et] = Ue;
    };
    for (let Ue = 0, rt = arguments.length; Ue < rt; Ue++)
      arguments[Ue] && B(arguments[Ue], $e);
    return _e;
  }
  const X = (he, _e, $e, { allOwnKeys: Ue } = {}) => (B(_e, (rt, Et) => {
    $e && d(rt) ? he[Et] = e(rt, $e) : he[Et] = rt;
  }, { allOwnKeys: Ue }), he), V = (he) => (he.charCodeAt(0) === 65279 && (he = he.slice(1)), he), F = (he, _e, $e, Ue) => {
    he.prototype = Object.create(_e.prototype, Ue), he.prototype.constructor = he, Object.defineProperty(he, "super", {
      value: _e.prototype
    }), $e && Object.assign(he.prototype, $e);
  }, le = (he, _e, $e, Ue) => {
    let rt, Et, gt;
    const lt = {};
    if (_e = _e || {}, he == null) return _e;
    do {
      for (rt = Object.getOwnPropertyNames(he), Et = rt.length; Et-- > 0; )
        gt = rt[Et], (!Ue || Ue(gt, he, _e)) && !lt[gt] && (_e[gt] = he[gt], lt[gt] = !0);
      he = $e !== !1 && r(he);
    } while (he && (!$e || $e(he, _e)) && he !== Object.prototype);
    return _e;
  }, ae = (he, _e, $e) => {
    he = String(he), ($e === void 0 || $e > he.length) && ($e = he.length), $e -= _e.length;
    const Ue = he.indexOf(_e, $e);
    return Ue !== -1 && Ue === $e;
  }, ne = (he) => {
    if (!he) return null;
    if (a(he)) return he;
    let _e = he.length;
    if (!p(_e)) return null;
    const $e = new Array(_e);
    for (; _e-- > 0; )
      $e[_e] = he[_e];
    return $e;
  }, ve = /* @__PURE__ */ ((he) => (_e) => he && _e instanceof he)(typeof Uint8Array < "u" && r(Uint8Array)), Ie = (he, _e) => {
    const Ue = (he && he[Symbol.iterator]).call(he);
    let rt;
    for (; (rt = Ue.next()) && !rt.done; ) {
      const Et = rt.value;
      _e.call(he, Et[0], Et[1]);
    }
  }, Oe = (he, _e) => {
    let $e;
    const Ue = [];
    for (; ($e = he.exec(_e)) !== null; )
      Ue.push($e);
    return Ue;
  }, xe = i("HTMLFormElement"), ze = (he) => he.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function($e, Ue, rt) {
      return Ue.toUpperCase() + rt;
    }
  ), qe = (({ hasOwnProperty: he }) => (_e, $e) => he.call(_e, $e))(Object.prototype), Je = i("RegExp"), Be = (he, _e) => {
    const $e = Object.getOwnPropertyDescriptors(he), Ue = {};
    B($e, (rt, Et) => {
      let gt;
      (gt = _e(rt, Et, he)) !== !1 && (Ue[Et] = gt || rt);
    }), Object.defineProperties(he, Ue);
  }, We = (he) => {
    Be(he, (_e, $e) => {
      if (d(he) && ["arguments", "caller", "callee"].indexOf($e) !== -1)
        return !1;
      const Ue = he[$e];
      if (d(Ue)) {
        if (_e.enumerable = !1, "writable" in _e) {
          _e.writable = !1;
          return;
        }
        _e.set || (_e.set = () => {
          throw Error("Can not rewrite read-only method '" + $e + "'");
        });
      }
    });
  }, Ne = (he, _e) => {
    const $e = {}, Ue = (rt) => {
      rt.forEach((Et) => {
        $e[Et] = !0;
      });
    };
    return a(he) ? Ue(he) : Ue(String(he).split(_e)), $e;
  }, je = () => {
  }, et = (he, _e) => he != null && Number.isFinite(he = +he) ? he : _e, St = "abcdefghijklmnopqrstuvwxyz", Ot = "0123456789", we = {
    DIGIT: Ot,
    ALPHA: St,
    ALPHA_DIGIT: St + St.toUpperCase() + Ot
  }, De = (he = 16, _e = we.ALPHA_DIGIT) => {
    let $e = "";
    const { length: Ue } = _e;
    for (; he--; )
      $e += _e[Math.random() * Ue | 0];
    return $e;
  };
  function Ee(he) {
    return !!(he && d(he.append) && he[Symbol.toStringTag] === "FormData" && he[Symbol.iterator]);
  }
  const te = (he) => {
    const _e = new Array(10), $e = (Ue, rt) => {
      if (v(Ue)) {
        if (_e.indexOf(Ue) >= 0)
          return;
        if (!("toJSON" in Ue)) {
          _e[rt] = Ue;
          const Et = a(Ue) ? [] : {};
          return B(Ue, (gt, lt) => {
            const L = $e(gt, rt + 1);
            !u(L) && (Et[lt] = L);
          }), _e[rt] = void 0, Et;
        }
      }
      return Ue;
    };
    return $e(he, 0);
  }, ue = i("AsyncFunction"), ye = (he) => he && (v(he) || d(he)) && d(he.then) && d(he.catch), Le = ((he, _e) => he ? setImmediate : _e ? (($e, Ue) => (D.addEventListener("message", ({ source: rt, data: Et }) => {
    rt === D && Et === $e && Ue.length && Ue.shift()();
  }, !1), (rt) => {
    Ue.push(rt), D.postMessage($e, "*");
  }))(`axios@${Math.random()}`, []) : ($e) => setTimeout($e))(
    typeof setImmediate == "function",
    d(D.postMessage)
  ), Me = typeof queueMicrotask < "u" ? queueMicrotask.bind(D) : typeof process < "u" && process.nextTick || Le;
  var Ae = {
    isArray: a,
    isArrayBuffer: c,
    isBuffer: s,
    isFormData: A,
    isArrayBufferView: l,
    isString: f,
    isNumber: p,
    isBoolean: h,
    isObject: v,
    isPlainObject: E,
    isReadableStream: P,
    isRequest: U,
    isResponse: z,
    isHeaders: k,
    isUndefined: u,
    isDate: m,
    isFile: g,
    isBlob: y,
    isRegExp: Je,
    isFunction: d,
    isStream: S,
    isURLSearchParams: O,
    isTypedArray: ve,
    isFileList: _,
    forEach: B,
    merge: $,
    extend: X,
    trim: H,
    stripBOM: V,
    inherits: F,
    toFlatObject: le,
    kindOf: n,
    kindOfTest: i,
    endsWith: ae,
    toArray: ne,
    forEachEntry: Ie,
    matchAll: Oe,
    isHTMLForm: xe,
    hasOwnProperty: qe,
    hasOwnProp: qe,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors: Be,
    freezeMethods: We,
    toObjectSet: Ne,
    toCamelCase: ze,
    noop: je,
    toFiniteNumber: et,
    findKey: x,
    global: D,
    isContextDefined: w,
    ALPHABET: we,
    generateString: De,
    isSpecCompliantForm: Ee,
    toJSONObject: te,
    isAsyncFn: ue,
    isThenable: ye,
    setImmediate: Le,
    asap: Me
  };
  function ie(he, _e, $e, Ue, rt) {
    Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = he, this.name = "AxiosError", _e && (this.code = _e), $e && (this.config = $e), Ue && (this.request = Ue), rt && (this.response = rt, this.status = rt.status ? rt.status : null);
  }
  Ae.inherits(ie, Error, {
    toJSON: function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: Ae.toJSONObject(this.config),
        code: this.code,
        status: this.status
      };
    }
  });
  const K = ie.prototype, Z = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
    // eslint-disable-next-line func-names
  ].forEach((he) => {
    Z[he] = { value: he };
  }), Object.defineProperties(ie, Z), Object.defineProperty(K, "isAxiosError", { value: !0 }), ie.from = (he, _e, $e, Ue, rt, Et) => {
    const gt = Object.create(K);
    return Ae.toFlatObject(he, gt, function(L) {
      return L !== Error.prototype;
    }, (lt) => lt !== "isAxiosError"), ie.call(gt, he.message, _e, $e, Ue, rt), gt.cause = he, gt.name = he.name, Et && Object.assign(gt, Et), gt;
  };
  var Ce = null;
  function be(he) {
    return Ae.isPlainObject(he) || Ae.isArray(he);
  }
  function Ge(he) {
    return Ae.endsWith(he, "[]") ? he.slice(0, -2) : he;
  }
  function st(he, _e, $e) {
    return he ? he.concat(_e).map(function(rt, Et) {
      return rt = Ge(rt), !$e && Et ? "[" + rt + "]" : rt;
    }).join($e ? "." : "") : _e;
  }
  function wt(he) {
    return Ae.isArray(he) && !he.some(be);
  }
  const Bt = Ae.toFlatObject(Ae, {}, null, function(_e) {
    return /^is[A-Z]/.test(_e);
  });
  function jt(he, _e, $e) {
    if (!Ae.isObject(he))
      throw new TypeError("target must be an object");
    _e = _e || new FormData(), $e = Ae.toFlatObject($e, {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    }, !1, function(kr, rr) {
      return !Ae.isUndefined(rr[kr]);
    });
    const Ue = $e.metaTokens, rt = $e.visitor || Yt, Et = $e.dots, gt = $e.indexes, L = ($e.Blob || typeof Blob < "u" && Blob) && Ae.isSpecCompliantForm(_e);
    if (!Ae.isFunction(rt))
      throw new TypeError("visitor must be a function");
    function zt(ur) {
      if (ur === null) return "";
      if (Ae.isDate(ur))
        return ur.toISOString();
      if (!L && Ae.isBlob(ur))
        throw new ie("Blob is not supported. Use a Buffer instead.");
      return Ae.isArrayBuffer(ur) || Ae.isTypedArray(ur) ? L && typeof Blob == "function" ? new Blob([ur]) : Buffer.from(ur) : ur;
    }
    function Yt(ur, kr, rr) {
      let Yn = ur;
      if (ur && !rr && typeof ur == "object") {
        if (Ae.endsWith(kr, "{}"))
          kr = Ue ? kr : kr.slice(0, -2), ur = JSON.stringify(ur);
        else if (Ae.isArray(ur) && wt(ur) || (Ae.isFileList(ur) || Ae.endsWith(kr, "[]")) && (Yn = Ae.toArray(ur)))
          return kr = Ge(kr), Yn.forEach(function(Br, ca) {
            !(Ae.isUndefined(Br) || Br === null) && _e.append(
              // eslint-disable-next-line no-nested-ternary
              gt === !0 ? st([kr], ca, Et) : gt === null ? kr : kr + "[]",
              zt(Br)
            );
          }), !1;
      }
      return be(ur) ? !0 : (_e.append(st(rr, kr, Et), zt(ur)), !1);
    }
    const ir = [], Hr = Object.assign(Bt, {
      defaultVisitor: Yt,
      convertValue: zt,
      isVisitable: be
    });
    function wi(ur, kr) {
      if (!Ae.isUndefined(ur)) {
        if (ir.indexOf(ur) !== -1)
          throw Error("Circular reference detected in " + kr.join("."));
        ir.push(ur), Ae.forEach(ur, function(Yn, Vr) {
          (!(Ae.isUndefined(Yn) || Yn === null) && rt.call(
            _e,
            Yn,
            Ae.isString(Vr) ? Vr.trim() : Vr,
            kr,
            Hr
          )) === !0 && wi(Yn, kr ? kr.concat(Vr) : [Vr]);
        }), ir.pop();
      }
    }
    if (!Ae.isObject(he))
      throw new TypeError("data must be an object");
    return wi(he), _e;
  }
  function Xt(he) {
    const _e = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    };
    return encodeURIComponent(he).replace(/[!'()~]|%20|%00/g, function(Ue) {
      return _e[Ue];
    });
  }
  function Qt(he, _e) {
    this._pairs = [], he && jt(he, this, _e);
  }
  const Zr = Qt.prototype;
  Zr.append = function(_e, $e) {
    this._pairs.push([_e, $e]);
  }, Zr.toString = function(_e) {
    const $e = _e ? function(Ue) {
      return _e.call(this, Ue, Xt);
    } : Xt;
    return this._pairs.map(function(rt) {
      return $e(rt[0]) + "=" + $e(rt[1]);
    }, "").join("&");
  };
  function Jn(he) {
    return encodeURIComponent(he).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  function Ur(he, _e, $e) {
    if (!_e)
      return he;
    const Ue = $e && $e.encode || Jn;
    Ae.isFunction($e) && ($e = {
      serialize: $e
    });
    const rt = $e && $e.serialize;
    let Et;
    if (rt ? Et = rt(_e, $e) : Et = Ae.isURLSearchParams(_e) ? _e.toString() : new Qt(_e, $e).toString(Ue), Et) {
      const gt = he.indexOf("#");
      gt !== -1 && (he = he.slice(0, gt)), he += (he.indexOf("?") === -1 ? "?" : "&") + Et;
    }
    return he;
  }
  class fn {
    constructor() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(_e, $e, Ue) {
      return this.handlers.push({
        fulfilled: _e,
        rejected: $e,
        synchronous: Ue ? Ue.synchronous : !1,
        runWhen: Ue ? Ue.runWhen : null
      }), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
    eject(_e) {
      this.handlers[_e] && (this.handlers[_e] = null);
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      this.handlers && (this.handlers = []);
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(_e) {
      Ae.forEach(this.handlers, function(Ue) {
        Ue !== null && _e(Ue);
      });
    }
  }
  var gn = fn, cr = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  }, Ri = typeof URLSearchParams < "u" ? URLSearchParams : Qt, ai = typeof FormData < "u" ? FormData : null, vo = typeof Blob < "u" ? Blob : null, to = {
    isBrowser: !0,
    classes: {
      URLSearchParams: Ri,
      FormData: ai,
      Blob: vo
    },
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };
  const Ui = typeof window < "u" && typeof document < "u", Gu = typeof navigator == "object" && navigator || void 0, Rs = Ui && (!Gu || ["ReactNative", "NativeScript", "NS"].indexOf(Gu.product) < 0), Wu = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Ku = Ui && window.location.href || "http://localhost";
  var Ca = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    hasBrowserEnv: Ui,
    hasStandardBrowserWebWorkerEnv: Wu,
    hasStandardBrowserEnv: Rs,
    navigator: Gu,
    origin: Ku
  }), Dn = {
    ...Ca,
    ...to
  };
  function Xu(he, _e) {
    return jt(he, new Dn.classes.URLSearchParams(), Object.assign({
      visitor: function($e, Ue, rt, Et) {
        return Dn.isNode && Ae.isBuffer($e) ? (this.append(Ue, $e.toString("base64")), !1) : Et.defaultVisitor.apply(this, arguments);
      }
    }, _e));
  }
  function Ze(he) {
    return Ae.matchAll(/\w+|\[(\w*)]/g, he).map((_e) => _e[0] === "[]" ? "" : _e[1] || _e[0]);
  }
  function kt(he) {
    const _e = {}, $e = Object.keys(he);
    let Ue;
    const rt = $e.length;
    let Et;
    for (Ue = 0; Ue < rt; Ue++)
      Et = $e[Ue], _e[Et] = he[Et];
    return _e;
  }
  function qt(he) {
    function _e($e, Ue, rt, Et) {
      let gt = $e[Et++];
      if (gt === "__proto__") return !0;
      const lt = Number.isFinite(+gt), L = Et >= $e.length;
      return gt = !gt && Ae.isArray(rt) ? rt.length : gt, L ? (Ae.hasOwnProp(rt, gt) ? rt[gt] = [rt[gt], Ue] : rt[gt] = Ue, !lt) : ((!rt[gt] || !Ae.isObject(rt[gt])) && (rt[gt] = []), _e($e, Ue, rt[gt], Et) && Ae.isArray(rt[gt]) && (rt[gt] = kt(rt[gt])), !lt);
    }
    if (Ae.isFormData(he) && Ae.isFunction(he.entries)) {
      const $e = {};
      return Ae.forEachEntry(he, (Ue, rt) => {
        _e(Ze(Ue), rt, $e, 0);
      }), $e;
    }
    return null;
  }
  function sr(he, _e, $e) {
    if (Ae.isString(he))
      try {
        return (_e || JSON.parse)(he), Ae.trim(he);
      } catch (Ue) {
        if (Ue.name !== "SyntaxError")
          throw Ue;
      }
    return (0, JSON.stringify)(he);
  }
  const Mr = {
    transitional: cr,
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [function(_e, $e) {
      const Ue = $e.getContentType() || "", rt = Ue.indexOf("application/json") > -1, Et = Ae.isObject(_e);
      if (Et && Ae.isHTMLForm(_e) && (_e = new FormData(_e)), Ae.isFormData(_e))
        return rt ? JSON.stringify(qt(_e)) : _e;
      if (Ae.isArrayBuffer(_e) || Ae.isBuffer(_e) || Ae.isStream(_e) || Ae.isFile(_e) || Ae.isBlob(_e) || Ae.isReadableStream(_e))
        return _e;
      if (Ae.isArrayBufferView(_e))
        return _e.buffer;
      if (Ae.isURLSearchParams(_e))
        return $e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), _e.toString();
      let lt;
      if (Et) {
        if (Ue.indexOf("application/x-www-form-urlencoded") > -1)
          return Xu(_e, this.formSerializer).toString();
        if ((lt = Ae.isFileList(_e)) || Ue.indexOf("multipart/form-data") > -1) {
          const L = this.env && this.env.FormData;
          return jt(
            lt ? { "files[]": _e } : _e,
            L && new L(),
            this.formSerializer
          );
        }
      }
      return Et || rt ? ($e.setContentType("application/json", !1), sr(_e)) : _e;
    }],
    transformResponse: [function(_e) {
      const $e = this.transitional || Mr.transitional, Ue = $e && $e.forcedJSONParsing, rt = this.responseType === "json";
      if (Ae.isResponse(_e) || Ae.isReadableStream(_e))
        return _e;
      if (_e && Ae.isString(_e) && (Ue && !this.responseType || rt)) {
        const gt = !($e && $e.silentJSONParsing) && rt;
        try {
          return JSON.parse(_e);
        } catch (lt) {
          if (gt)
            throw lt.name === "SyntaxError" ? ie.from(lt, ie.ERR_BAD_RESPONSE, this, null, this.response) : lt;
        }
      }
      return _e;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: Dn.classes.FormData,
      Blob: Dn.classes.Blob
    },
    validateStatus: function(_e) {
      return _e >= 200 && _e < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": void 0
      }
    }
  };
  Ae.forEach(["delete", "get", "head", "post", "put", "patch"], (he) => {
    Mr.headers[he] = {};
  });
  var ht = Mr;
  const Pe = Ae.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  var Fe = (he) => {
    const _e = {};
    let $e, Ue, rt;
    return he && he.split(`
`).forEach(function(gt) {
      rt = gt.indexOf(":"), $e = gt.substring(0, rt).trim().toLowerCase(), Ue = gt.substring(rt + 1).trim(), !(!$e || _e[$e] && Pe[$e]) && ($e === "set-cookie" ? _e[$e] ? _e[$e].push(Ue) : _e[$e] = [Ue] : _e[$e] = _e[$e] ? _e[$e] + ", " + Ue : Ue);
    }), _e;
  };
  const Ye = Symbol("internals");
  function Xe(he) {
    return he && String(he).trim().toLowerCase();
  }
  function dt(he) {
    return he === !1 || he == null ? he : Ae.isArray(he) ? he.map(dt) : String(he);
  }
  function Nt(he) {
    const _e = /* @__PURE__ */ Object.create(null), $e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let Ue;
    for (; Ue = $e.exec(he); )
      _e[Ue[1]] = Ue[2];
    return _e;
  }
  const er = (he) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(he.trim());
  function Sr(he, _e, $e, Ue, rt) {
    if (Ae.isFunction(Ue))
      return Ue.call(this, _e, $e);
    if (rt && (_e = $e), !!Ae.isString(_e)) {
      if (Ae.isString(Ue))
        return _e.indexOf(Ue) !== -1;
      if (Ae.isRegExp(Ue))
        return Ue.test(_e);
    }
  }
  function Fr(he) {
    return he.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (_e, $e, Ue) => $e.toUpperCase() + Ue);
  }
  function ro(he, _e) {
    const $e = Ae.toCamelCase(" " + _e);
    ["get", "set", "has"].forEach((Ue) => {
      Object.defineProperty(he, Ue + $e, {
        value: function(rt, Et, gt) {
          return this[Ue].call(this, _e, rt, Et, gt);
        },
        configurable: !0
      });
    });
  }
  class Eo {
    constructor(_e) {
      _e && this.set(_e);
    }
    set(_e, $e, Ue) {
      const rt = this;
      function Et(lt, L, zt) {
        const Yt = Xe(L);
        if (!Yt)
          throw new Error("header name must be a non-empty string");
        const ir = Ae.findKey(rt, Yt);
        (!ir || rt[ir] === void 0 || zt === !0 || zt === void 0 && rt[ir] !== !1) && (rt[ir || L] = dt(lt));
      }
      const gt = (lt, L) => Ae.forEach(lt, (zt, Yt) => Et(zt, Yt, L));
      if (Ae.isPlainObject(_e) || _e instanceof this.constructor)
        gt(_e, $e);
      else if (Ae.isString(_e) && (_e = _e.trim()) && !er(_e))
        gt(Fe(_e), $e);
      else if (Ae.isHeaders(_e))
        for (const [lt, L] of _e.entries())
          Et(L, lt, Ue);
      else
        _e != null && Et($e, _e, Ue);
      return this;
    }
    get(_e, $e) {
      if (_e = Xe(_e), _e) {
        const Ue = Ae.findKey(this, _e);
        if (Ue) {
          const rt = this[Ue];
          if (!$e)
            return rt;
          if ($e === !0)
            return Nt(rt);
          if (Ae.isFunction($e))
            return $e.call(this, rt, Ue);
          if (Ae.isRegExp($e))
            return $e.exec(rt);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(_e, $e) {
      if (_e = Xe(_e), _e) {
        const Ue = Ae.findKey(this, _e);
        return !!(Ue && this[Ue] !== void 0 && (!$e || Sr(this, this[Ue], Ue, $e)));
      }
      return !1;
    }
    delete(_e, $e) {
      const Ue = this;
      let rt = !1;
      function Et(gt) {
        if (gt = Xe(gt), gt) {
          const lt = Ae.findKey(Ue, gt);
          lt && (!$e || Sr(Ue, Ue[lt], lt, $e)) && (delete Ue[lt], rt = !0);
        }
      }
      return Ae.isArray(_e) ? _e.forEach(Et) : Et(_e), rt;
    }
    clear(_e) {
      const $e = Object.keys(this);
      let Ue = $e.length, rt = !1;
      for (; Ue--; ) {
        const Et = $e[Ue];
        (!_e || Sr(this, this[Et], Et, _e, !0)) && (delete this[Et], rt = !0);
      }
      return rt;
    }
    normalize(_e) {
      const $e = this, Ue = {};
      return Ae.forEach(this, (rt, Et) => {
        const gt = Ae.findKey(Ue, Et);
        if (gt) {
          $e[gt] = dt(rt), delete $e[Et];
          return;
        }
        const lt = _e ? Fr(Et) : String(Et).trim();
        lt !== Et && delete $e[Et], $e[lt] = dt(rt), Ue[lt] = !0;
      }), this;
    }
    concat(..._e) {
      return this.constructor.concat(this, ..._e);
    }
    toJSON(_e) {
      const $e = /* @__PURE__ */ Object.create(null);
      return Ae.forEach(this, (Ue, rt) => {
        Ue != null && Ue !== !1 && ($e[rt] = _e && Ae.isArray(Ue) ? Ue.join(", ") : Ue);
      }), $e;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([_e, $e]) => _e + ": " + $e).join(`
`);
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(_e) {
      return _e instanceof this ? _e : new this(_e);
    }
    static concat(_e, ...$e) {
      const Ue = new this(_e);
      return $e.forEach((rt) => Ue.set(rt)), Ue;
    }
    static accessor(_e) {
      const Ue = (this[Ye] = this[Ye] = {
        accessors: {}
      }).accessors, rt = this.prototype;
      function Et(gt) {
        const lt = Xe(gt);
        Ue[lt] || (ro(rt, gt), Ue[lt] = !0);
      }
      return Ae.isArray(_e) ? _e.forEach(Et) : Et(_e), this;
    }
  }
  Eo.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), Ae.reduceDescriptors(Eo.prototype, ({ value: he }, _e) => {
    let $e = _e[0].toUpperCase() + _e.slice(1);
    return {
      get: () => he,
      set(Ue) {
        this[$e] = Ue;
      }
    };
  }), Ae.freezeMethods(Eo);
  var Ti = Eo;
  function Ya(he, _e) {
    const $e = this || ht, Ue = _e || $e, rt = Ti.from(Ue.headers);
    let Et = Ue.data;
    return Ae.forEach(he, function(lt) {
      Et = lt.call($e, Et, rt.normalize(), _e ? _e.status : void 0);
    }), rt.normalize(), Et;
  }
  function ws(he) {
    return !!(he && he.__CANCEL__);
  }
  function yl(he, _e, $e) {
    ie.call(this, he ?? "canceled", ie.ERR_CANCELED, _e, $e), this.name = "CanceledError";
  }
  Ae.inherits(yl, ie, {
    __CANCEL__: !0
  });
  function f_(he, _e, $e) {
    const Ue = $e.config.validateStatus;
    !$e.status || !Ue || Ue($e.status) ? he($e) : _e(new ie(
      "Request failed with status code " + $e.status,
      [ie.ERR_BAD_REQUEST, ie.ERR_BAD_RESPONSE][Math.floor($e.status / 100) - 4],
      $e.config,
      $e.request,
      $e
    ));
  }
  function P2(he) {
    const _e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(he);
    return _e && _e[1] || "";
  }
  function D2(he, _e) {
    he = he || 10;
    const $e = new Array(he), Ue = new Array(he);
    let rt = 0, Et = 0, gt;
    return _e = _e !== void 0 ? _e : 1e3, function(L) {
      const zt = Date.now(), Yt = Ue[Et];
      gt || (gt = zt), $e[rt] = L, Ue[rt] = zt;
      let ir = Et, Hr = 0;
      for (; ir !== rt; )
        Hr += $e[ir++], ir = ir % he;
      if (rt = (rt + 1) % he, rt === Et && (Et = (Et + 1) % he), zt - gt < _e)
        return;
      const wi = Yt && zt - Yt;
      return wi ? Math.round(Hr * 1e3 / wi) : void 0;
    };
  }
  function x2(he, _e) {
    let $e = 0, Ue = 1e3 / _e, rt, Et;
    const gt = (zt, Yt = Date.now()) => {
      $e = Yt, rt = null, Et && (clearTimeout(Et), Et = null), he.apply(null, zt);
    };
    return [(...zt) => {
      const Yt = Date.now(), ir = Yt - $e;
      ir >= Ue ? gt(zt, Yt) : (rt = zt, Et || (Et = setTimeout(() => {
        Et = null, gt(rt);
      }, Ue - ir)));
    }, () => rt && gt(rt)];
  }
  const Od = (he, _e, $e = 3) => {
    let Ue = 0;
    const rt = D2(50, 250);
    return x2((Et) => {
      const gt = Et.loaded, lt = Et.lengthComputable ? Et.total : void 0, L = gt - Ue, zt = rt(L), Yt = gt <= lt;
      Ue = gt;
      const ir = {
        loaded: gt,
        total: lt,
        progress: lt ? gt / lt : void 0,
        bytes: L,
        rate: zt || void 0,
        estimated: zt && lt && Yt ? (lt - gt) / zt : void 0,
        event: Et,
        lengthComputable: lt != null,
        [_e ? "download" : "upload"]: !0
      };
      he(ir);
    }, $e);
  }, d_ = (he, _e) => {
    const $e = he != null;
    return [(Ue) => _e[0]({
      lengthComputable: $e,
      total: he,
      loaded: Ue
    }), _e[1]];
  }, mo = (he) => (..._e) => Ae.asap(() => he(..._e));
  var N2 = Dn.hasStandardBrowserEnv ? /* @__PURE__ */ ((he, _e) => ($e) => ($e = new URL($e, Dn.origin), he.protocol === $e.protocol && he.host === $e.host && (_e || he.port === $e.port)))(
    new URL(Dn.origin),
    Dn.navigator && /(msie|trident)/i.test(Dn.navigator.userAgent)
  ) : () => !0, L2 = Dn.hasStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    {
      write(he, _e, $e, Ue, rt, Et) {
        const gt = [he + "=" + encodeURIComponent(_e)];
        Ae.isNumber($e) && gt.push("expires=" + new Date($e).toGMTString()), Ae.isString(Ue) && gt.push("path=" + Ue), Ae.isString(rt) && gt.push("domain=" + rt), Et === !0 && gt.push("secure"), document.cookie = gt.join("; ");
      },
      read(he) {
        const _e = document.cookie.match(new RegExp("(^|;\\s*)(" + he + ")=([^;]*)"));
        return _e ? decodeURIComponent(_e[3]) : null;
      },
      remove(he) {
        this.write(he, "", Date.now() - 864e5);
      }
    }
  ) : (
    // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {
      },
      read() {
        return null;
      },
      remove() {
      }
    }
  );
  function B2(he) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(he);
  }
  function fv(he, _e) {
    return _e ? he.replace(/\/?\/$/, "") + "/" + _e.replace(/^\/+/, "") : he;
  }
  function p_(he, _e) {
    return he && !B2(_e) ? fv(he, _e) : _e;
  }
  const h_ = (he) => he instanceof Ti ? { ...he } : he;
  function Sc(he, _e) {
    _e = _e || {};
    const $e = {};
    function Ue(zt, Yt, ir, Hr) {
      return Ae.isPlainObject(zt) && Ae.isPlainObject(Yt) ? Ae.merge.call({ caseless: Hr }, zt, Yt) : Ae.isPlainObject(Yt) ? Ae.merge({}, Yt) : Ae.isArray(Yt) ? Yt.slice() : Yt;
    }
    function rt(zt, Yt, ir, Hr) {
      if (Ae.isUndefined(Yt)) {
        if (!Ae.isUndefined(zt))
          return Ue(void 0, zt, ir, Hr);
      } else return Ue(zt, Yt, ir, Hr);
    }
    function Et(zt, Yt) {
      if (!Ae.isUndefined(Yt))
        return Ue(void 0, Yt);
    }
    function gt(zt, Yt) {
      if (Ae.isUndefined(Yt)) {
        if (!Ae.isUndefined(zt))
          return Ue(void 0, zt);
      } else return Ue(void 0, Yt);
    }
    function lt(zt, Yt, ir) {
      if (ir in _e)
        return Ue(zt, Yt);
      if (ir in he)
        return Ue(void 0, zt);
    }
    const L = {
      url: Et,
      method: Et,
      data: Et,
      baseURL: gt,
      transformRequest: gt,
      transformResponse: gt,
      paramsSerializer: gt,
      timeout: gt,
      timeoutMessage: gt,
      withCredentials: gt,
      withXSRFToken: gt,
      adapter: gt,
      responseType: gt,
      xsrfCookieName: gt,
      xsrfHeaderName: gt,
      onUploadProgress: gt,
      onDownloadProgress: gt,
      decompress: gt,
      maxContentLength: gt,
      maxBodyLength: gt,
      beforeRedirect: gt,
      transport: gt,
      httpAgent: gt,
      httpsAgent: gt,
      cancelToken: gt,
      socketPath: gt,
      responseEncoding: gt,
      validateStatus: lt,
      headers: (zt, Yt, ir) => rt(h_(zt), h_(Yt), ir, !0)
    };
    return Ae.forEach(Object.keys(Object.assign({}, he, _e)), function(Yt) {
      const ir = L[Yt] || rt, Hr = ir(he[Yt], _e[Yt], Yt);
      Ae.isUndefined(Hr) && ir !== lt || ($e[Yt] = Hr);
    }), $e;
  }
  var Rd = (he) => {
    const _e = Sc({}, he);
    let { data: $e, withXSRFToken: Ue, xsrfHeaderName: rt, xsrfCookieName: Et, headers: gt, auth: lt } = _e;
    _e.headers = gt = Ti.from(gt), _e.url = Ur(p_(_e.baseURL, _e.url), he.params, he.paramsSerializer), lt && gt.set(
      "Authorization",
      "Basic " + btoa((lt.username || "") + ":" + (lt.password ? unescape(encodeURIComponent(lt.password)) : ""))
    );
    let L;
    if (Ae.isFormData($e)) {
      if (Dn.hasStandardBrowserEnv || Dn.hasStandardBrowserWebWorkerEnv)
        gt.setContentType(void 0);
      else if ((L = gt.getContentType()) !== !1) {
        const [zt, ...Yt] = L ? L.split(";").map((ir) => ir.trim()).filter(Boolean) : [];
        gt.setContentType([zt || "multipart/form-data", ...Yt].join("; "));
      }
    }
    if (Dn.hasStandardBrowserEnv && (Ue && Ae.isFunction(Ue) && (Ue = Ue(_e)), Ue || Ue !== !1 && N2(_e.url))) {
      const zt = rt && Et && L2.read(Et);
      zt && gt.set(rt, zt);
    }
    return _e;
  }, sa = typeof XMLHttpRequest < "u" && function(he) {
    return new Promise(function($e, Ue) {
      const rt = Rd(he);
      let Et = rt.data;
      const gt = Ti.from(rt.headers).normalize();
      let { responseType: lt, onUploadProgress: L, onDownloadProgress: zt } = rt, Yt, ir, Hr, wi, ur;
      function kr() {
        wi && wi(), ur && ur(), rt.cancelToken && rt.cancelToken.unsubscribe(Yt), rt.signal && rt.signal.removeEventListener("abort", Yt);
      }
      let rr = new XMLHttpRequest();
      rr.open(rt.method.toUpperCase(), rt.url, !0), rr.timeout = rt.timeout;
      function Yn() {
        if (!rr)
          return;
        const Br = Ti.from(
          "getAllResponseHeaders" in rr && rr.getAllResponseHeaders()
        ), Zn = {
          data: !lt || lt === "text" || lt === "json" ? rr.responseText : rr.response,
          status: rr.status,
          statusText: rr.statusText,
          headers: Br,
          config: he,
          request: rr
        };
        f_(function(Cc) {
          $e(Cc), kr();
        }, function(Cc) {
          Ue(Cc), kr();
        }, Zn), rr = null;
      }
      "onloadend" in rr ? rr.onloadend = Yn : rr.onreadystatechange = function() {
        !rr || rr.readyState !== 4 || rr.status === 0 && !(rr.responseURL && rr.responseURL.indexOf("file:") === 0) || setTimeout(Yn);
      }, rr.onabort = function() {
        rr && (Ue(new ie("Request aborted", ie.ECONNABORTED, he, rr)), rr = null);
      }, rr.onerror = function() {
        Ue(new ie("Network Error", ie.ERR_NETWORK, he, rr)), rr = null;
      }, rr.ontimeout = function() {
        let ca = rt.timeout ? "timeout of " + rt.timeout + "ms exceeded" : "timeout exceeded";
        const Zn = rt.transitional || cr;
        rt.timeoutErrorMessage && (ca = rt.timeoutErrorMessage), Ue(new ie(
          ca,
          Zn.clarifyTimeoutError ? ie.ETIMEDOUT : ie.ECONNABORTED,
          he,
          rr
        )), rr = null;
      }, Et === void 0 && gt.setContentType(null), "setRequestHeader" in rr && Ae.forEach(gt.toJSON(), function(ca, Zn) {
        rr.setRequestHeader(Zn, ca);
      }), Ae.isUndefined(rt.withCredentials) || (rr.withCredentials = !!rt.withCredentials), lt && lt !== "json" && (rr.responseType = rt.responseType), zt && ([Hr, ur] = Od(zt, !0), rr.addEventListener("progress", Hr)), L && rr.upload && ([ir, wi] = Od(L), rr.upload.addEventListener("progress", ir), rr.upload.addEventListener("loadend", wi)), (rt.cancelToken || rt.signal) && (Yt = (Br) => {
        rr && (Ue(!Br || Br.type ? new yl(null, he, rr) : Br), rr.abort(), rr = null);
      }, rt.cancelToken && rt.cancelToken.subscribe(Yt), rt.signal && (rt.signal.aborted ? Yt() : rt.signal.addEventListener("abort", Yt)));
      const Vr = P2(rt.url);
      if (Vr && Dn.protocols.indexOf(Vr) === -1) {
        Ue(new ie("Unsupported protocol " + Vr + ":", ie.ERR_BAD_REQUEST, he));
        return;
      }
      rr.send(Et || null);
    });
  }, k2 = (he, _e) => {
    const { length: $e } = he = he ? he.filter(Boolean) : [];
    if (_e || $e) {
      let Ue = new AbortController(), rt;
      const Et = function(zt) {
        if (!rt) {
          rt = !0, lt();
          const Yt = zt instanceof Error ? zt : this.reason;
          Ue.abort(Yt instanceof ie ? Yt : new yl(Yt instanceof Error ? Yt.message : Yt));
        }
      };
      let gt = _e && setTimeout(() => {
        gt = null, Et(new ie(`timeout ${_e} of ms exceeded`, ie.ETIMEDOUT));
      }, _e);
      const lt = () => {
        he && (gt && clearTimeout(gt), gt = null, he.forEach((zt) => {
          zt.unsubscribe ? zt.unsubscribe(Et) : zt.removeEventListener("abort", Et);
        }), he = null);
      };
      he.forEach((zt) => zt.addEventListener("abort", Et));
      const { signal: L } = Ue;
      return L.unsubscribe = () => Ae.asap(lt), L;
    }
  };
  const pv = function* (he, _e) {
    let $e = he.byteLength;
    if ($e < _e) {
      yield he;
      return;
    }
    let Ue = 0, rt;
    for (; Ue < $e; )
      rt = Ue + _e, yield he.slice(Ue, rt), Ue = rt;
  }, Ga = async function* (he, _e) {
    for await (const $e of v_(he))
      yield* pv($e, _e);
  }, v_ = async function* (he) {
    if (he[Symbol.asyncIterator]) {
      yield* he;
      return;
    }
    const _e = he.getReader();
    try {
      for (; ; ) {
        const { done: $e, value: Ue } = await _e.read();
        if ($e)
          break;
        yield Ue;
      }
    } finally {
      await _e.cancel();
    }
  }, hv = (he, _e, $e, Ue) => {
    const rt = Ga(he, _e);
    let Et = 0, gt, lt = (L) => {
      gt || (gt = !0, Ue && Ue(L));
    };
    return new ReadableStream({
      async pull(L) {
        try {
          const { done: zt, value: Yt } = await rt.next();
          if (zt) {
            lt(), L.close();
            return;
          }
          let ir = Yt.byteLength;
          if ($e) {
            let Hr = Et += ir;
            $e(Hr);
          }
          L.enqueue(new Uint8Array(Yt));
        } catch (zt) {
          throw lt(zt), zt;
        }
      },
      cancel(L) {
        return lt(L), rt.return();
      }
    }, {
      highWaterMark: 2
    });
  }, S0 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", E_ = S0 && typeof ReadableStream == "function", M2 = S0 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((he) => (_e) => he.encode(_e))(new TextEncoder()) : async (he) => new Uint8Array(await new Response(he).arrayBuffer())), bc = (he, ..._e) => {
    try {
      return !!he(..._e);
    } catch {
      return !1;
    }
  }, Yo = E_ && bc(() => {
    let he = !1;
    const _e = new Request(Dn.origin, {
      body: new ReadableStream(),
      method: "POST",
      get duplex() {
        return he = !0, "half";
      }
    }).headers.has("Content-Type");
    return he && !_e;
  }), Er = 64 * 1024, vv = E_ && bc(() => Ae.isReadableStream(new Response("").body)), wd = {
    stream: vv && ((he) => he.body)
  };
  S0 && ((he) => {
    ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_e) => {
      !wd[_e] && (wd[_e] = Ae.isFunction(he[_e]) ? ($e) => $e[_e]() : ($e, Ue) => {
        throw new ie(`Response type '${_e}' is not supported`, ie.ERR_NOT_SUPPORT, Ue);
      });
    });
  })(new Response());
  const F2 = async (he) => {
    if (he == null)
      return 0;
    if (Ae.isBlob(he))
      return he.size;
    if (Ae.isSpecCompliantForm(he))
      return (await new Request(Dn.origin, {
        method: "POST",
        body: he
      }).arrayBuffer()).byteLength;
    if (Ae.isArrayBufferView(he) || Ae.isArrayBuffer(he))
      return he.byteLength;
    if (Ae.isURLSearchParams(he) && (he = he + ""), Ae.isString(he))
      return (await M2(he)).byteLength;
  }, H2 = async (he, _e) => {
    const $e = Ae.toFiniteNumber(he.getContentLength());
    return $e ?? F2(_e);
  };
  var $2 = S0 && (async (he) => {
    let {
      url: _e,
      method: $e,
      data: Ue,
      signal: rt,
      cancelToken: Et,
      timeout: gt,
      onDownloadProgress: lt,
      onUploadProgress: L,
      responseType: zt,
      headers: Yt,
      withCredentials: ir = "same-origin",
      fetchOptions: Hr
    } = Rd(he);
    zt = zt ? (zt + "").toLowerCase() : "text";
    let wi = k2([rt, Et && Et.toAbortSignal()], gt), ur;
    const kr = wi && wi.unsubscribe && (() => {
      wi.unsubscribe();
    });
    let rr;
    try {
      if (L && Yo && $e !== "get" && $e !== "head" && (rr = await H2(Yt, Ue)) !== 0) {
        let Zn = new Request(_e, {
          method: "POST",
          body: Ue,
          duplex: "half"
        }), Ps;
        if (Ae.isFormData(Ue) && (Ps = Zn.headers.get("content-type")) && Yt.setContentType(Ps), Zn.body) {
          const [Cc, Ic] = d_(
            rr,
            Od(mo(L))
          );
          Ue = hv(Zn.body, Er, Cc, Ic);
        }
      }
      Ae.isString(ir) || (ir = ir ? "include" : "omit");
      const Yn = "credentials" in Request.prototype;
      ur = new Request(_e, {
        ...Hr,
        signal: wi,
        method: $e.toUpperCase(),
        headers: Yt.normalize().toJSON(),
        body: Ue,
        duplex: "half",
        credentials: Yn ? ir : void 0
      });
      let Vr = await fetch(ur);
      const Br = vv && (zt === "stream" || zt === "response");
      if (vv && (lt || Br && kr)) {
        const Zn = {};
        ["status", "statusText", "headers"].forEach((dn) => {
          Zn[dn] = Vr[dn];
        });
        const Ps = Ae.toFiniteNumber(Vr.headers.get("content-length")), [Cc, Ic] = lt && d_(
          Ps,
          Od(mo(lt), !0)
        ) || [];
        Vr = new Response(
          hv(Vr.body, Er, Cc, () => {
            Ic && Ic(), kr && kr();
          }),
          Zn
        );
      }
      zt = zt || "text";
      let ca = await wd[Ae.findKey(wd, zt) || "text"](Vr, he);
      return !Br && kr && kr(), await new Promise((Zn, Ps) => {
        f_(Zn, Ps, {
          data: ca,
          headers: Ti.from(Vr.headers),
          status: Vr.status,
          statusText: Vr.statusText,
          config: he,
          request: ur
        });
      });
    } catch (Yn) {
      throw kr && kr(), Yn && Yn.name === "TypeError" && /fetch/i.test(Yn.message) ? Object.assign(
        new ie("Network Error", ie.ERR_NETWORK, he, ur),
        {
          cause: Yn.cause || Yn
        }
      ) : ie.from(Yn, Yn && Yn.code, he, ur);
    }
  });
  const Ev = {
    http: Ce,
    xhr: sa,
    fetch: $2
  };
  Ae.forEach(Ev, (he, _e) => {
    if (he) {
      try {
        Object.defineProperty(he, "name", { value: _e });
      } catch {
      }
      Object.defineProperty(he, "adapterName", { value: _e });
    }
  });
  const yi = (he) => `- ${he}`, U2 = (he) => Ae.isFunction(he) || he === null || he === !1;
  var m_ = {
    getAdapter: (he) => {
      he = Ae.isArray(he) ? he : [he];
      const { length: _e } = he;
      let $e, Ue;
      const rt = {};
      for (let Et = 0; Et < _e; Et++) {
        $e = he[Et];
        let gt;
        if (Ue = $e, !U2($e) && (Ue = Ev[(gt = String($e)).toLowerCase()], Ue === void 0))
          throw new ie(`Unknown adapter '${gt}'`);
        if (Ue)
          break;
        rt[gt || "#" + Et] = Ue;
      }
      if (!Ue) {
        const Et = Object.entries(rt).map(
          ([lt, L]) => `adapter ${lt} ` + (L === !1 ? "is not supported by the environment" : "is not available in the build")
        );
        let gt = _e ? Et.length > 1 ? `since :
` + Et.map(yi).join(`
`) : " " + yi(Et[0]) : "as no adapter specified";
        throw new ie(
          "There is no suitable adapter to dispatch the request " + gt,
          "ERR_NOT_SUPPORT"
        );
      }
      return Ue;
    },
    adapters: Ev
  };
  function mv(he) {
    if (he.cancelToken && he.cancelToken.throwIfRequested(), he.signal && he.signal.aborted)
      throw new yl(null, he);
  }
  function g_(he) {
    return mv(he), he.headers = Ti.from(he.headers), he.data = Ya.call(
      he,
      he.transformRequest
    ), ["post", "put", "patch"].indexOf(he.method) !== -1 && he.headers.setContentType("application/x-www-form-urlencoded", !1), m_.getAdapter(he.adapter || ht.adapter)(he).then(function(Ue) {
      return mv(he), Ue.data = Ya.call(
        he,
        he.transformResponse,
        Ue
      ), Ue.headers = Ti.from(Ue.headers), Ue;
    }, function(Ue) {
      return ws(Ue) || (mv(he), Ue && Ue.response && (Ue.response.data = Ya.call(
        he,
        he.transformResponse,
        Ue.response
      ), Ue.response.headers = Ti.from(Ue.response.headers))), Promise.reject(Ue);
    });
  }
  const T_ = "1.7.8", Pd = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((he, _e) => {
    Pd[he] = function(Ue) {
      return typeof Ue === he || "a" + (_e < 1 ? "n " : " ") + he;
    };
  });
  const y_ = {};
  Pd.transitional = function(_e, $e, Ue) {
    function rt(Et, gt) {
      return "[Axios v" + T_ + "] Transitional option '" + Et + "'" + gt + (Ue ? ". " + Ue : "");
    }
    return (Et, gt, lt) => {
      if (_e === !1)
        throw new ie(
          rt(gt, " has been removed" + ($e ? " in " + $e : "")),
          ie.ERR_DEPRECATED
        );
      return $e && !y_[gt] && (y_[gt] = !0, console.warn(
        rt(
          gt,
          " has been deprecated since v" + $e + " and will be removed in the near future"
        )
      )), _e ? _e(Et, gt, lt) : !0;
    };
  }, Pd.spelling = function(_e) {
    return ($e, Ue) => (console.warn(`${Ue} is likely a misspelling of ${_e}`), !0);
  };
  function V2(he, _e, $e) {
    if (typeof he != "object")
      throw new ie("options must be an object", ie.ERR_BAD_OPTION_VALUE);
    const Ue = Object.keys(he);
    let rt = Ue.length;
    for (; rt-- > 0; ) {
      const Et = Ue[rt], gt = _e[Et];
      if (gt) {
        const lt = he[Et], L = lt === void 0 || gt(lt, Et, he);
        if (L !== !0)
          throw new ie("option " + Et + " must be " + L, ie.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if ($e !== !0)
        throw new ie("Unknown option " + Et, ie.ERR_BAD_OPTION);
    }
  }
  var qr = {
    assertOptions: V2,
    validators: Pd
  };
  const gu = qr.validators;
  class Dd {
    constructor(_e) {
      this.defaults = _e, this.interceptors = {
        request: new gn(),
        response: new gn()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    async request(_e, $e) {
      try {
        return await this._request(_e, $e);
      } catch (Ue) {
        if (Ue instanceof Error) {
          let rt = {};
          Error.captureStackTrace ? Error.captureStackTrace(rt) : rt = new Error();
          const Et = rt.stack ? rt.stack.replace(/^.+\n/, "") : "";
          try {
            Ue.stack ? Et && !String(Ue.stack).endsWith(Et.replace(/^.+\n.+\n/, "")) && (Ue.stack += `
` + Et) : Ue.stack = Et;
          } catch {
          }
        }
        throw Ue;
      }
    }
    _request(_e, $e) {
      typeof _e == "string" ? ($e = $e || {}, $e.url = _e) : $e = _e || {}, $e = Sc(this.defaults, $e);
      const { transitional: Ue, paramsSerializer: rt, headers: Et } = $e;
      Ue !== void 0 && qr.assertOptions(Ue, {
        silentJSONParsing: gu.transitional(gu.boolean),
        forcedJSONParsing: gu.transitional(gu.boolean),
        clarifyTimeoutError: gu.transitional(gu.boolean)
      }, !1), rt != null && (Ae.isFunction(rt) ? $e.paramsSerializer = {
        serialize: rt
      } : qr.assertOptions(rt, {
        encode: gu.function,
        serialize: gu.function
      }, !0)), qr.assertOptions($e, {
        baseUrl: gu.spelling("baseURL"),
        withXsrfToken: gu.spelling("withXSRFToken")
      }, !0), $e.method = ($e.method || this.defaults.method || "get").toLowerCase();
      let gt = Et && Ae.merge(
        Et.common,
        Et[$e.method]
      );
      Et && Ae.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        (ur) => {
          delete Et[ur];
        }
      ), $e.headers = Ti.concat(gt, Et);
      const lt = [];
      let L = !0;
      this.interceptors.request.forEach(function(kr) {
        typeof kr.runWhen == "function" && kr.runWhen($e) === !1 || (L = L && kr.synchronous, lt.unshift(kr.fulfilled, kr.rejected));
      });
      const zt = [];
      this.interceptors.response.forEach(function(kr) {
        zt.push(kr.fulfilled, kr.rejected);
      });
      let Yt, ir = 0, Hr;
      if (!L) {
        const ur = [g_.bind(this), void 0];
        for (ur.unshift.apply(ur, lt), ur.push.apply(ur, zt), Hr = ur.length, Yt = Promise.resolve($e); ir < Hr; )
          Yt = Yt.then(ur[ir++], ur[ir++]);
        return Yt;
      }
      Hr = lt.length;
      let wi = $e;
      for (ir = 0; ir < Hr; ) {
        const ur = lt[ir++], kr = lt[ir++];
        try {
          wi = ur(wi);
        } catch (rr) {
          kr.call(this, rr);
          break;
        }
      }
      try {
        Yt = g_.call(this, wi);
      } catch (ur) {
        return Promise.reject(ur);
      }
      for (ir = 0, Hr = zt.length; ir < Hr; )
        Yt = Yt.then(zt[ir++], zt[ir++]);
      return Yt;
    }
    getUri(_e) {
      _e = Sc(this.defaults, _e);
      const $e = p_(_e.baseURL, _e.url);
      return Ur($e, _e.params, _e.paramsSerializer);
    }
  }
  Ae.forEach(["delete", "get", "head", "options"], function(_e) {
    Dd.prototype[_e] = function($e, Ue) {
      return this.request(Sc(Ue || {}, {
        method: _e,
        url: $e,
        data: (Ue || {}).data
      }));
    };
  }), Ae.forEach(["post", "put", "patch"], function(_e) {
    function $e(Ue) {
      return function(Et, gt, lt) {
        return this.request(Sc(lt || {}, {
          method: _e,
          headers: Ue ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: Et,
          data: gt
        }));
      };
    }
    Dd.prototype[_e] = $e(), Dd.prototype[_e + "Form"] = $e(!0);
  });
  var xd = Dd;
  class gv {
    constructor(_e) {
      if (typeof _e != "function")
        throw new TypeError("executor must be a function.");
      let $e;
      this.promise = new Promise(function(Et) {
        $e = Et;
      });
      const Ue = this;
      this.promise.then((rt) => {
        if (!Ue._listeners) return;
        let Et = Ue._listeners.length;
        for (; Et-- > 0; )
          Ue._listeners[Et](rt);
        Ue._listeners = null;
      }), this.promise.then = (rt) => {
        let Et;
        const gt = new Promise((lt) => {
          Ue.subscribe(lt), Et = lt;
        }).then(rt);
        return gt.cancel = function() {
          Ue.unsubscribe(Et);
        }, gt;
      }, _e(function(Et, gt, lt) {
        Ue.reason || (Ue.reason = new yl(Et, gt, lt), $e(Ue.reason));
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason)
        throw this.reason;
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(_e) {
      if (this.reason) {
        _e(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(_e) : this._listeners = [_e];
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(_e) {
      if (!this._listeners)
        return;
      const $e = this._listeners.indexOf(_e);
      $e !== -1 && this._listeners.splice($e, 1);
    }
    toAbortSignal() {
      const _e = new AbortController(), $e = (Ue) => {
        _e.abort(Ue);
      };
      return this.subscribe($e), _e.signal.unsubscribe = () => this.unsubscribe($e), _e.signal;
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let _e;
      return {
        token: new gv(function(rt) {
          _e = rt;
        }),
        cancel: _e
      };
    }
  }
  var j2 = gv;
  function z2(he) {
    return function($e) {
      return he.apply(null, $e);
    };
  }
  function q2(he) {
    return Ae.isObject(he) && he.isAxiosError === !0;
  }
  const Tv = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(Tv).forEach(([he, _e]) => {
    Tv[_e] = he;
  });
  var Y2 = Tv;
  function Tu(he) {
    const _e = new xd(he), $e = e(xd.prototype.request, _e);
    return Ae.extend($e, xd.prototype, _e, { allOwnKeys: !0 }), Ae.extend($e, _e, null, { allOwnKeys: !0 }), $e.create = function(rt) {
      return Tu(Sc(he, rt));
    }, $e;
  }
  const _i = Tu(ht);
  return _i.Axios = xd, _i.CanceledError = yl, _i.CancelToken = j2, _i.isCancel = ws, _i.VERSION = T_, _i.toFormData = jt, _i.AxiosError = ie, _i.Cancel = _i.CanceledError, _i.all = function(_e) {
    return Promise.all(_e);
  }, _i.spread = z2, _i.isAxiosError = q2, _i.mergeConfig = Sc, _i.AxiosHeaders = Ti, _i.formToJSON = (he) => qt(Ae.isHTMLForm(he) ? new FormData(he) : he), _i.getAdapter = m_.getAdapter, _i.HttpStatusCode = Y2, _i.default = _i, V5 = _i, V5;
}
var gse;
function Tl() {
  return gse || (gse = 1, function(e, t) {
    (function(r, n) {
      e.exports = n({
        axios: mwr().default
      });
    })(fe, function(r) {
      var n = function(s = null, c = {}) {
        this._baseAddress = s, this._defaultSettings = c;
      }, i = function(s, c) {
        return s ? c ? c.includes("://") ? c : (c.startsWith("/"), s + (s.endsWith("/") ? "" : "/") + c) : s : c;
      }, o = function(s) {
        return s && typeof s == "object" && !Array.isArray(s);
      }, a = function(s, ...c) {
        if (!c.length) return s;
        const l = c.shift();
        if (o(s) && o(l))
          for (const f in l)
            o(l[f]) ? (s[f] || Object.assign(s, { [f]: {} }), a(s[f], l[f])) : Object.assign(s, { [f]: l[f] });
        return a(s, ...c);
      }, u = function(s, c) {
        return a(c, s);
      };
      return n.prototype.httpPost = function(s, c = null, l = {}) {
        var f = this;
        return new Promise(function(d, p) {
          var v = i(f._baseAddress, s), h = u(f._defaultSettings, l);
          h.responseType = "text", h.transformRequest = [], h.transformResponse = [], r.axios.post(v, c, h).then((E) => {
            d(E.data);
          }).catch((E) => {
            E.response ? p("Returned: " + E.response.status + " " + E.response.data) : p(E.message);
          });
        });
      }, n.prototype.httpGet = function(s, c = {}) {
        var l = this;
        return new Promise(function(f, d) {
          var p = i(l._baseAddress, s), v = u(l._defaultSettings, c);
          v.responseType = "text", v.transformResponse = [], r.axios.get(p, v).then((h) => {
            f(h.data);
          }).catch((h) => {
            h.response ? d("Returned: " + h.response.status + " " + h.response.data) : d(h.message);
          });
        });
      }, n.prototype.httpPut = function(s, c = null, l = {}) {
        var f = this;
        return new Promise(function(d, p) {
          var v = i(f._baseAddress, s), h = u(f._defaultSettings, l);
          h.responseType = "text", h.transformRequest = [], h.transformResponse = [], r.axios.put(v, c, h).then((E) => {
            d(E.data);
          }).catch((E) => {
            E.response ? p("Returned: " + E.response.status + " " + E.response.data) : p(E.message);
          });
        });
      }, n.prototype.httpPut_FullResponse = function(s, c = null, l = {}) {
        var f = this;
        return new Promise(function(d, p) {
          var v = i(f._baseAddress, s), h = u(f._defaultSettings, l);
          h.responseType = "text", h.transformRequest = [], h.transformResponse = [], r.axios.put(v, c, h).then((E) => {
            d(E);
          }).catch((E) => {
            E.response ? p("Returned: " + E.response.status + " " + E.response.data) : p(E.message);
          });
        });
      }, n.prototype.httpPatch = function(s, c = null, l = {}) {
        var f = this;
        return new Promise(function(d, p) {
          var v = i(f._baseAddress, s), h = u(f._defaultSettings, l);
          h.responseType = "text", h.transformRequest = [], h.transformResponse = [], r.axios.patch(v, c, h).then((E) => {
            d(E.data);
          }).catch((E) => {
            E.response ? p("Returned: " + E.response.status + " " + E.response.data) : p(E.message);
          });
        });
      }, n.prototype.httpDelete = function(s, c = null, l = {}) {
        var f = this;
        return new Promise(function(d, p) {
          var v = i(f._baseAddress, s), h = u(f._defaultSettings, l);
          h.responseType = "text", h.transformRequest = [], h.transformResponse = [], h.data = c, r.axios.delete(v, h).then((E) => {
            d(E.data);
          }).catch((E) => {
            E.response ? p("Returned: " + E.response.status + " " + E.response.data) : p(E.message);
          });
        });
      }, n.prototype.httpPostJSON = function(s, c, l = {}) {
        var f = this;
        return new Promise((d, p) => {
          var v = u(
            l,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              }
            }
          );
          f.httpPost(s, JSON.stringify(c), v).then((h) => {
            d(h ? JSON.parse(h) : void 0);
          }).catch((h) => {
            p(h);
          });
        });
      }, n.prototype.httpGetJSON = function(s, c = {}) {
        var l = this;
        return new Promise((f, d) => {
          var p = u(
            c,
            {
              headers: {
                accept: "application/json"
              }
            }
          );
          l.httpGet(s, p).then((v) => {
            f(v ? JSON.parse(v) : void 0);
          }).catch((v) => {
            d(v);
          });
        });
      }, n.prototype.httpPutJSON = function(s, c, l = {}) {
        var f = this;
        return new Promise((d, p) => {
          var v = u(
            l,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              }
            }
          );
          f.httpPut(s, JSON.stringify(c), v).then((h) => {
            d(h ? JSON.parse(h) : void 0);
          }).catch((h) => {
            p(h);
          });
        });
      }, n.prototype.httpPatchJSON = function(s, c, l = {}) {
        var f = this;
        return new Promise((d, p) => {
          var v = u(
            l,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              }
            }
          );
          f.httpPatch(s, JSON.stringify(c), v).then((h) => {
            d(h ? JSON.parse(h) : void 0);
          }).catch((h) => {
            p(h);
          });
        });
      }, n.prototype.httpDeleteJSON = function(s, c = null, l = {}) {
        var f = this;
        return new Promise((d, p) => {
          var v = u(
            l,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              }
            }
          );
          f.httpDelete(s, c, v).then((h) => {
            d(h ? JSON.parse(h) : void 0);
          }).catch((h) => {
            p(h);
          });
        });
      }, n;
    });
  }(U5)), U5.exports;
}
var q2e = { exports: {} }, j5 = {}, Mg = {}, E4 = {}, Tse;
function Y2e() {
  if (Tse) return E4;
  Tse = 1, Object.defineProperty(E4, "__esModule", {
    value: !0
  }), E4.default = r;
  let e;
  const t = new Uint8Array(16);
  function r() {
    if (!e && (e = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !e))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return e(t);
  }
  return E4;
}
var tp = {}, Fg = {}, Hg = {}, yse;
function gwr() {
  if (yse) return Hg;
  yse = 1, Object.defineProperty(Hg, "__esModule", {
    value: !0
  }), Hg.default = void 0;
  var e = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return Hg.default = e, Hg;
}
var _se;
function O2() {
  if (_se) return Fg;
  _se = 1, Object.defineProperty(Fg, "__esModule", {
    value: !0
  }), Fg.default = void 0;
  var e = t(gwr());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function r(i) {
    return typeof i == "string" && e.default.test(i);
  }
  var n = r;
  return Fg.default = n, Fg;
}
var Ase;
function R2() {
  if (Ase) return tp;
  Ase = 1, Object.defineProperty(tp, "__esModule", {
    value: !0
  }), tp.default = void 0, tp.unsafeStringify = n;
  var e = t(O2());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  const r = [];
  for (let a = 0; a < 256; ++a)
    r.push((a + 256).toString(16).slice(1));
  function n(a, u = 0) {
    return r[a[u + 0]] + r[a[u + 1]] + r[a[u + 2]] + r[a[u + 3]] + "-" + r[a[u + 4]] + r[a[u + 5]] + "-" + r[a[u + 6]] + r[a[u + 7]] + "-" + r[a[u + 8]] + r[a[u + 9]] + "-" + r[a[u + 10]] + r[a[u + 11]] + r[a[u + 12]] + r[a[u + 13]] + r[a[u + 14]] + r[a[u + 15]];
  }
  function i(a, u = 0) {
    const s = n(a, u);
    if (!(0, e.default)(s))
      throw TypeError("Stringified UUID is invalid");
    return s;
  }
  var o = i;
  return tp.default = o, tp;
}
var Sse;
function Twr() {
  if (Sse) return Mg;
  Sse = 1, Object.defineProperty(Mg, "__esModule", {
    value: !0
  }), Mg.default = void 0;
  var e = r(Y2e()), t = R2();
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  let n, i, o = 0, a = 0;
  function u(c, l, f) {
    let d = l && f || 0;
    const p = l || new Array(16);
    c = c || {};
    let v = c.node || n, h = c.clockseq !== void 0 ? c.clockseq : i;
    if (v == null || h == null) {
      const S = c.random || (c.rng || e.default)();
      v == null && (v = n = [S[0] | 1, S[1], S[2], S[3], S[4], S[5]]), h == null && (h = i = (S[6] << 8 | S[7]) & 16383);
    }
    let E = c.msecs !== void 0 ? c.msecs : Date.now(), m = c.nsecs !== void 0 ? c.nsecs : a + 1;
    const g = E - o + (m - a) / 1e4;
    if (g < 0 && c.clockseq === void 0 && (h = h + 1 & 16383), (g < 0 || E > o) && c.nsecs === void 0 && (m = 0), m >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    o = E, a = m, i = h, E += 122192928e5;
    const y = ((E & 268435455) * 1e4 + m) % 4294967296;
    p[d++] = y >>> 24 & 255, p[d++] = y >>> 16 & 255, p[d++] = y >>> 8 & 255, p[d++] = y & 255;
    const _ = E / 4294967296 * 1e4 & 268435455;
    p[d++] = _ >>> 8 & 255, p[d++] = _ & 255, p[d++] = _ >>> 24 & 15 | 16, p[d++] = _ >>> 16 & 255, p[d++] = h >>> 8 | 128, p[d++] = h & 255;
    for (let S = 0; S < 6; ++S)
      p[d + S] = v[S];
    return l || (0, t.unsafeStringify)(p);
  }
  var s = u;
  return Mg.default = s, Mg;
}
var $g = {}, Ll = {}, Ug = {}, bse;
function G2e() {
  if (bse) return Ug;
  bse = 1, Object.defineProperty(Ug, "__esModule", {
    value: !0
  }), Ug.default = void 0;
  var e = t(O2());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function r(i) {
    if (!(0, e.default)(i))
      throw TypeError("Invalid UUID");
    let o;
    const a = new Uint8Array(16);
    return a[0] = (o = parseInt(i.slice(0, 8), 16)) >>> 24, a[1] = o >>> 16 & 255, a[2] = o >>> 8 & 255, a[3] = o & 255, a[4] = (o = parseInt(i.slice(9, 13), 16)) >>> 8, a[5] = o & 255, a[6] = (o = parseInt(i.slice(14, 18), 16)) >>> 8, a[7] = o & 255, a[8] = (o = parseInt(i.slice(19, 23), 16)) >>> 8, a[9] = o & 255, a[10] = (o = parseInt(i.slice(24, 36), 16)) / 1099511627776 & 255, a[11] = o / 4294967296 & 255, a[12] = o >>> 24 & 255, a[13] = o >>> 16 & 255, a[14] = o >>> 8 & 255, a[15] = o & 255, a;
  }
  var n = r;
  return Ug.default = n, Ug;
}
var Cse;
function W2e() {
  if (Cse) return Ll;
  Cse = 1, Object.defineProperty(Ll, "__esModule", {
    value: !0
  }), Ll.URL = Ll.DNS = void 0, Ll.default = a;
  var e = R2(), t = r(G2e());
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function n(u) {
    u = unescape(encodeURIComponent(u));
    const s = [];
    for (let c = 0; c < u.length; ++c)
      s.push(u.charCodeAt(c));
    return s;
  }
  const i = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  Ll.DNS = i;
  const o = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  Ll.URL = o;
  function a(u, s, c) {
    function l(f, d, p, v) {
      var h;
      if (typeof f == "string" && (f = n(f)), typeof d == "string" && (d = (0, t.default)(d)), ((h = d) === null || h === void 0 ? void 0 : h.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let E = new Uint8Array(16 + f.length);
      if (E.set(d), E.set(f, d.length), E = c(E), E[6] = E[6] & 15 | s, E[8] = E[8] & 63 | 128, p) {
        v = v || 0;
        for (let m = 0; m < 16; ++m)
          p[v + m] = E[m];
        return p;
      }
      return (0, e.unsafeStringify)(E);
    }
    try {
      l.name = u;
    } catch {
    }
    return l.DNS = i, l.URL = o, l;
  }
  return Ll;
}
var Vg = {}, Ise;
function ywr() {
  if (Ise) return Vg;
  Ise = 1, Object.defineProperty(Vg, "__esModule", {
    value: !0
  }), Vg.default = void 0;
  function e(p) {
    if (typeof p == "string") {
      const v = unescape(encodeURIComponent(p));
      p = new Uint8Array(v.length);
      for (let h = 0; h < v.length; ++h)
        p[h] = v.charCodeAt(h);
    }
    return t(n(i(p), p.length * 8));
  }
  function t(p) {
    const v = [], h = p.length * 32, E = "0123456789abcdef";
    for (let m = 0; m < h; m += 8) {
      const g = p[m >> 5] >>> m % 32 & 255, y = parseInt(E.charAt(g >>> 4 & 15) + E.charAt(g & 15), 16);
      v.push(y);
    }
    return v;
  }
  function r(p) {
    return (p + 64 >>> 9 << 4) + 14 + 1;
  }
  function n(p, v) {
    p[v >> 5] |= 128 << v % 32, p[r(v) - 1] = v;
    let h = 1732584193, E = -271733879, m = -1732584194, g = 271733878;
    for (let y = 0; y < p.length; y += 16) {
      const _ = h, S = E, A = m, O = g;
      h = s(h, E, m, g, p[y], 7, -680876936), g = s(g, h, E, m, p[y + 1], 12, -389564586), m = s(m, g, h, E, p[y + 2], 17, 606105819), E = s(E, m, g, h, p[y + 3], 22, -1044525330), h = s(h, E, m, g, p[y + 4], 7, -176418897), g = s(g, h, E, m, p[y + 5], 12, 1200080426), m = s(m, g, h, E, p[y + 6], 17, -1473231341), E = s(E, m, g, h, p[y + 7], 22, -45705983), h = s(h, E, m, g, p[y + 8], 7, 1770035416), g = s(g, h, E, m, p[y + 9], 12, -1958414417), m = s(m, g, h, E, p[y + 10], 17, -42063), E = s(E, m, g, h, p[y + 11], 22, -1990404162), h = s(h, E, m, g, p[y + 12], 7, 1804603682), g = s(g, h, E, m, p[y + 13], 12, -40341101), m = s(m, g, h, E, p[y + 14], 17, -1502002290), E = s(E, m, g, h, p[y + 15], 22, 1236535329), h = c(h, E, m, g, p[y + 1], 5, -165796510), g = c(g, h, E, m, p[y + 6], 9, -1069501632), m = c(m, g, h, E, p[y + 11], 14, 643717713), E = c(E, m, g, h, p[y], 20, -373897302), h = c(h, E, m, g, p[y + 5], 5, -701558691), g = c(g, h, E, m, p[y + 10], 9, 38016083), m = c(m, g, h, E, p[y + 15], 14, -660478335), E = c(E, m, g, h, p[y + 4], 20, -405537848), h = c(h, E, m, g, p[y + 9], 5, 568446438), g = c(g, h, E, m, p[y + 14], 9, -1019803690), m = c(m, g, h, E, p[y + 3], 14, -187363961), E = c(E, m, g, h, p[y + 8], 20, 1163531501), h = c(h, E, m, g, p[y + 13], 5, -1444681467), g = c(g, h, E, m, p[y + 2], 9, -51403784), m = c(m, g, h, E, p[y + 7], 14, 1735328473), E = c(E, m, g, h, p[y + 12], 20, -1926607734), h = l(h, E, m, g, p[y + 5], 4, -378558), g = l(g, h, E, m, p[y + 8], 11, -2022574463), m = l(m, g, h, E, p[y + 11], 16, 1839030562), E = l(E, m, g, h, p[y + 14], 23, -35309556), h = l(h, E, m, g, p[y + 1], 4, -1530992060), g = l(g, h, E, m, p[y + 4], 11, 1272893353), m = l(m, g, h, E, p[y + 7], 16, -155497632), E = l(E, m, g, h, p[y + 10], 23, -1094730640), h = l(h, E, m, g, p[y + 13], 4, 681279174), g = l(g, h, E, m, p[y], 11, -358537222), m = l(m, g, h, E, p[y + 3], 16, -722521979), E = l(E, m, g, h, p[y + 6], 23, 76029189), h = l(h, E, m, g, p[y + 9], 4, -640364487), g = l(g, h, E, m, p[y + 12], 11, -421815835), m = l(m, g, h, E, p[y + 15], 16, 530742520), E = l(E, m, g, h, p[y + 2], 23, -995338651), h = f(h, E, m, g, p[y], 6, -198630844), g = f(g, h, E, m, p[y + 7], 10, 1126891415), m = f(m, g, h, E, p[y + 14], 15, -1416354905), E = f(E, m, g, h, p[y + 5], 21, -57434055), h = f(h, E, m, g, p[y + 12], 6, 1700485571), g = f(g, h, E, m, p[y + 3], 10, -1894986606), m = f(m, g, h, E, p[y + 10], 15, -1051523), E = f(E, m, g, h, p[y + 1], 21, -2054922799), h = f(h, E, m, g, p[y + 8], 6, 1873313359), g = f(g, h, E, m, p[y + 15], 10, -30611744), m = f(m, g, h, E, p[y + 6], 15, -1560198380), E = f(E, m, g, h, p[y + 13], 21, 1309151649), h = f(h, E, m, g, p[y + 4], 6, -145523070), g = f(g, h, E, m, p[y + 11], 10, -1120210379), m = f(m, g, h, E, p[y + 2], 15, 718787259), E = f(E, m, g, h, p[y + 9], 21, -343485551), h = o(h, _), E = o(E, S), m = o(m, A), g = o(g, O);
    }
    return [h, E, m, g];
  }
  function i(p) {
    if (p.length === 0)
      return [];
    const v = p.length * 8, h = new Uint32Array(r(v));
    for (let E = 0; E < v; E += 8)
      h[E >> 5] |= (p[E / 8] & 255) << E % 32;
    return h;
  }
  function o(p, v) {
    const h = (p & 65535) + (v & 65535);
    return (p >> 16) + (v >> 16) + (h >> 16) << 16 | h & 65535;
  }
  function a(p, v) {
    return p << v | p >>> 32 - v;
  }
  function u(p, v, h, E, m, g) {
    return o(a(o(o(v, p), o(E, g)), m), h);
  }
  function s(p, v, h, E, m, g, y) {
    return u(v & h | ~v & E, p, v, m, g, y);
  }
  function c(p, v, h, E, m, g, y) {
    return u(v & E | h & ~E, p, v, m, g, y);
  }
  function l(p, v, h, E, m, g, y) {
    return u(v ^ h ^ E, p, v, m, g, y);
  }
  function f(p, v, h, E, m, g, y) {
    return u(h ^ (v | ~E), p, v, m, g, y);
  }
  var d = e;
  return Vg.default = d, Vg;
}
var Ose;
function _wr() {
  if (Ose) return $g;
  Ose = 1, Object.defineProperty($g, "__esModule", {
    value: !0
  }), $g.default = void 0;
  var e = r(W2e()), t = r(ywr());
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var i = (0, e.default)("v3", 48, t.default);
  return $g.default = i, $g;
}
var jg = {}, zg = {}, Rse;
function Awr() {
  if (Rse) return zg;
  Rse = 1, Object.defineProperty(zg, "__esModule", {
    value: !0
  }), zg.default = void 0;
  var t = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return zg.default = t, zg;
}
var wse;
function Swr() {
  if (wse) return jg;
  wse = 1, Object.defineProperty(jg, "__esModule", {
    value: !0
  }), jg.default = void 0;
  var e = n(Awr()), t = n(Y2e()), r = R2();
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a, u, s) {
    if (e.default.randomUUID && !u && !a)
      return e.default.randomUUID();
    a = a || {};
    const c = a.random || (a.rng || t.default)();
    if (c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, u) {
      s = s || 0;
      for (let l = 0; l < 16; ++l)
        u[s + l] = c[l];
      return u;
    }
    return (0, r.unsafeStringify)(c);
  }
  var o = i;
  return jg.default = o, jg;
}
var qg = {}, Yg = {}, Pse;
function bwr() {
  if (Pse) return Yg;
  Pse = 1, Object.defineProperty(Yg, "__esModule", {
    value: !0
  }), Yg.default = void 0;
  function e(i, o, a, u) {
    switch (i) {
      case 0:
        return o & a ^ ~o & u;
      case 1:
        return o ^ a ^ u;
      case 2:
        return o & a ^ o & u ^ a & u;
      case 3:
        return o ^ a ^ u;
    }
  }
  function t(i, o) {
    return i << o | i >>> 32 - o;
  }
  function r(i) {
    const o = [1518500249, 1859775393, 2400959708, 3395469782], a = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof i == "string") {
      const l = unescape(encodeURIComponent(i));
      i = [];
      for (let f = 0; f < l.length; ++f)
        i.push(l.charCodeAt(f));
    } else Array.isArray(i) || (i = Array.prototype.slice.call(i));
    i.push(128);
    const u = i.length / 4 + 2, s = Math.ceil(u / 16), c = new Array(s);
    for (let l = 0; l < s; ++l) {
      const f = new Uint32Array(16);
      for (let d = 0; d < 16; ++d)
        f[d] = i[l * 64 + d * 4] << 24 | i[l * 64 + d * 4 + 1] << 16 | i[l * 64 + d * 4 + 2] << 8 | i[l * 64 + d * 4 + 3];
      c[l] = f;
    }
    c[s - 1][14] = (i.length - 1) * 8 / Math.pow(2, 32), c[s - 1][14] = Math.floor(c[s - 1][14]), c[s - 1][15] = (i.length - 1) * 8 & 4294967295;
    for (let l = 0; l < s; ++l) {
      const f = new Uint32Array(80);
      for (let m = 0; m < 16; ++m)
        f[m] = c[l][m];
      for (let m = 16; m < 80; ++m)
        f[m] = t(f[m - 3] ^ f[m - 8] ^ f[m - 14] ^ f[m - 16], 1);
      let d = a[0], p = a[1], v = a[2], h = a[3], E = a[4];
      for (let m = 0; m < 80; ++m) {
        const g = Math.floor(m / 20), y = t(d, 5) + e(g, p, v, h) + E + o[g] + f[m] >>> 0;
        E = h, h = v, v = t(p, 30) >>> 0, p = d, d = y;
      }
      a[0] = a[0] + d >>> 0, a[1] = a[1] + p >>> 0, a[2] = a[2] + v >>> 0, a[3] = a[3] + h >>> 0, a[4] = a[4] + E >>> 0;
    }
    return [a[0] >> 24 & 255, a[0] >> 16 & 255, a[0] >> 8 & 255, a[0] & 255, a[1] >> 24 & 255, a[1] >> 16 & 255, a[1] >> 8 & 255, a[1] & 255, a[2] >> 24 & 255, a[2] >> 16 & 255, a[2] >> 8 & 255, a[2] & 255, a[3] >> 24 & 255, a[3] >> 16 & 255, a[3] >> 8 & 255, a[3] & 255, a[4] >> 24 & 255, a[4] >> 16 & 255, a[4] >> 8 & 255, a[4] & 255];
  }
  var n = r;
  return Yg.default = n, Yg;
}
var Dse;
function Cwr() {
  if (Dse) return qg;
  Dse = 1, Object.defineProperty(qg, "__esModule", {
    value: !0
  }), qg.default = void 0;
  var e = r(W2e()), t = r(bwr());
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var i = (0, e.default)("v5", 80, t.default);
  return qg.default = i, qg;
}
var Gg = {}, xse;
function Iwr() {
  if (xse) return Gg;
  xse = 1, Object.defineProperty(Gg, "__esModule", {
    value: !0
  }), Gg.default = void 0;
  var e = "00000000-0000-0000-0000-000000000000";
  return Gg.default = e, Gg;
}
var Wg = {}, Nse;
function Owr() {
  if (Nse) return Wg;
  Nse = 1, Object.defineProperty(Wg, "__esModule", {
    value: !0
  }), Wg.default = void 0;
  var e = t(O2());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function r(i) {
    if (!(0, e.default)(i))
      throw TypeError("Invalid UUID");
    return parseInt(i.slice(14, 15), 16);
  }
  var n = r;
  return Wg.default = n, Wg;
}
var Lse;
function Rwr() {
  return Lse || (Lse = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "NIL", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(e, "parse", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(e, "stringify", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(e, "v1", {
      enumerable: !0,
      get: function() {
        return t.default;
      }
    }), Object.defineProperty(e, "v3", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(e, "v4", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(e, "v5", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "validate", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(e, "version", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    });
    var t = l(Twr()), r = l(_wr()), n = l(Swr()), i = l(Cwr()), o = l(Iwr()), a = l(Owr()), u = l(O2()), s = l(R2()), c = l(G2e());
    function l(f) {
      return f && f.__esModule ? f : { default: f };
    }
  }(j5)), j5;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(
      {
        HttpClient: Tl(),
        uuid: Rwr()
      }
    );
  })(fe, function(r) {
    class n {
      constructor() {
        Do(this, "baseAddress", "https://www.google-analytics.com");
        Do(this, "measurementId", "G-9DHNE789XG");
        Do(this, "apiKey", "7wd60wEeSnufb8FK6naHOQ");
        Do(this, "cid", r.uuid.v4());
        Do(this, "sdkName", "@trimble-oss/trimble-id");
        Do(this, "sdkVersion", "0.0.3");
        if (n._instance)
          return n._instance;
        n._instance = this;
      }
      sendEvent(o, a) {
        var u = this;
        return new Promise(function(s, c) {
          var l = `/mp/collect?measurement_id=${u.measurementId}&api_secret=${u.apiKey}`, f = u.baseAddress + l, d = {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json"
            }
          }, p = {
            client_id: u.cid,
            events: [
              {
                name: o,
                params: a
              }
            ]
          };
          new r.HttpClient().httpPost(f, JSON.stringify(p), d).then(() => {
            s();
          }).catch((v) => {
            console.log(v), c(v);
          });
        });
      }
      sendMethodEvent(o, a, u, s) {
        let c = {};
        u == null && s == null ? c = { event_type: "METHOD_USAGE", client_name: this.sdkName, client_version: this.sdkVersion, language: "js", application_id: a } : c = { event_type: "METHOD_USAGE", client_name: u, client_version: s, language: "js", application_id: a }, this.sendEvent(o + "_method", c);
      }
      sendInitEvent(o, a, u, s) {
        let c = {};
        u == null && s == null ? c = { event_type: "INIT", client_name: this.sdkName, client_version: this.sdkVersion, language: "js", application_id: a } : c = { event_type: "INIT", client_name: u, client_version: s, language: "js", application_id: a }, this.sendEvent(o + "_init", c);
      }
      sendExceptionEvent(o, a, u, s, c) {
        let l = {};
        s == null && c == null ? l = { event_type: "EXCEPTION", client_name: this.sdkName, client_version: this.sdkVersion, language: "js", application_id: u, exception_message: String(a) } : l = { event_type: "EXCEPTION", client_name: s, client_version: c, language: "js", application_id: u, exception_message: String(a) }, this.sendEvent(o + "_exception", l);
      }
    }
    return n._instance = null, n;
  });
})(q2e);
var mu = q2e.exports, z5 = { exports: {} }, Bse;
function xU() {
  return Bse || (Bse = 1, function() {
    function e(t) {
      var r;
      return t instanceof Buffer ? r = t : r = Buffer.from(t.toString(), "binary"), r.toString("base64");
    }
    z5.exports = e;
  }()), z5.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      HttpClient: Tl(),
      AnalyticsHttpClient: mu,
      btoa: r.btoa || xU()
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for ClientCredentialTokenProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity token endpoint.
       * It can be OpenIdEndpointProvider/FixedEndpointProvider
       * @param {string} consumerKey The consumer key for the calling application
       * @param {string} consumerSecret The consumer secret for the calling application
       */
      constructor(o, a, u) {
        this._endpointProvider = o, this._consumerKey = a, this._consumerSecret = u, this._scopes = [], this._accessToken = null, this._tokenExpiry = /* @__PURE__ */ new Date(0), this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name, a);
      }
      /**
       * @description Fluent extension to add scopes
       * @param {IEnumerable<string>} scopes The scopes to add to the token provider
       */
      WithScopes(o) {
        return this._scopes = this._scopes.concat(o), this;
      }
      /**
       * @description Retrieves an access token for the application
       * @returns {PromiseLike<string>} A promise that resolves to the value of the access token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveToken.name, this._consumerKey);
        var o = this;
        return new Promise(function(a, u) {
          o._tokenExpiry < /* @__PURE__ */ new Date() ? o._refreshToken().then(() => {
            a(o._accessToken);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, s, o._consumerKey), u("Unable to refresh token: " + s);
          }) : a(o._accessToken);
        });
      }
      _refreshToken() {
        var o = this;
        return new Promise(function(a, u) {
          o._endpointProvider.RetrieveTokenEndpoint().then((s) => {
            var c = "Basic " + r.btoa(o._consumerKey + ":" + o._consumerSecret), l = {
              headers: {
                Authorization: c,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }, f = "grant_type=client_credentials&scope=" + encodeURIComponent(o._scopes.join(" "));
            new r.HttpClient().httpPost(s, f, l).then((d) => {
              var p = JSON.parse(d);
              o._accessToken = p.access_token;
              var v = /* @__PURE__ */ new Date();
              o._tokenExpiry = new Date(v.getTime() + p.expires_in * 1e3), a();
            }).catch((d) => {
              o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, d, o._consumerKey), u("Client credential grant method failed: " + d);
            });
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, s, o._consumerKey), u("Unable to retrieve token endpoint: " + s);
          });
        });
      }
    }
    return n;
  });
})(z2e);
var wwr = z2e.exports, K2e = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      HttpClient: Tl(),
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for OpenIdEndpointProvider class
       * @param {string} configurationEndpoint The URL for the Trimble Identity OpenID well known configuration endpoint 
       * Production : https://id.trimble.com/.well-known/openid-configuration
       * @param {string=} tokenRevocationEndpoint The URL for the Trimble Identity token revocation endpoint, if not supplied this is computed relative to the token endpoint
       */
      constructor(o, a = null) {
        this._configurationEndpoint = o, this._authorizationEndpoint = null, this._tokenEndpoint = null, this._userInfoEndpoint = null, this._jwksEndpoint = null, this._tokenRevocationEndpoint = a, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
       * @description Retrieves a URL for the Trimble Identity authorization endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveAuthorizationEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveAuthorizationEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._authorizationEndpoint ? a(o._authorizationEndpoint) : o._loadConfiguration().then(() => {
            a(o._authorizationEndpoint);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveAuthorizationEndpoint.name, s), u(s);
          });
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity authorization endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveTokenEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveTokenEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._tokenEndpoint ? a(o._tokenEndpoint) : o._loadConfiguration().then(() => {
            a(o._tokenEndpoint);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveTokenEndpoint.name, s), u(s);
          });
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity authorization endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveUserInfoEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveUserInfoEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._userInfoEndpoint ? a(o._userInfoEndpoint) : o._loadConfiguration().then(() => {
            a(o._userInfoEndpoint);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveUserInfoEndpoint.name, s), u(s);
          });
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity token revocation endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveTokenRevocationEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveTokenRevocationEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._tokenRevocationEndpoint ? a(o._tokenRevocationEndpoint) : o._loadConfiguration().then(() => {
            a(o._tokenRevocationEndpoint);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveTokenRevocationEndpoint.name, s), u(s);
          });
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity end session endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveEndSessionEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveEndSessionEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._endSessionEndpoint ? a(o._endSessionEndpoint) : o._loadConfiguration().then(() => {
            a(o._endSessionEndpoint);
          }).catch((s) => {
            u(s);
          });
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity authorization endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       * @exception Thrown if the configuration endpoint returns an error
       */
      RetrieveJSONWebKeySetEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveJSONWebKeySetEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          o._jwksEndpoint ? a(o._jwksEndpoint) : o._loadConfiguration().then(() => {
            a(o._jwksEndpoint);
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveJSONWebKeySetEndpoint.name, s), u(s);
          });
        });
      }
      _loadConfiguration() {
        var o = this;
        return new Promise(function(a, u) {
          new r.HttpClient().httpGetJSON(o._configurationEndpoint).then((s) => {
            o._authorizationEndpoint = s.authorization_endpoint, o._tokenEndpoint = s.token_endpoint, o._userInfoEndpoint = s.userinfo_endpoint, o._jwksEndpoint = s.jwks_uri, "revocation_endpoint" in s ? o._tokenRevocationEndpoint = s.revocation_endpoint : o._tokenRevocationEndpoint = o._tokenRevocationEndpoint || new URL(o._configurationEndpoint).origin + "/revoke", "end_session_endpoint" in s ? o._endSessionEndpoint = s.end_session_endpoint : o._endSessionEndpoint = new URL(o._configurationEndpoint).origin + "/i/commonauth", a();
          }).catch((s) => {
            u("Failed to load configuration endpoint: " + s);
          });
        });
      }
    }
    return n;
  });
})(K2e);
var Pwr = K2e.exports, X2e = { exports: {} }, $t = {}, kse;
function w2() {
  if (kse) return $t;
  kse = 1;
  var e = {};
  e.userAgent = !1;
  var t = {}, r = "11.1.0", n = "jsrsasign(all) 11.1.0 (2024-02-01) (c) 2010-2023 Kenji Urushima | kjur.github.io/jsrsasign/license";
  /*! CryptoJS v3.1.2 core-fix.js
   * code.google.com/p/crypto-js
   * (c) 2009-2013 by Jeff Mott. All rights reserved.
   * code.google.com/p/crypto-js/wiki/License
   * THIS IS FIX of 'core.js' to fix Hmac issue.
   * https://code.google.com/p/crypto-js/issues/detail?id=84
   * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
   */
  var i = i || function(T, C) {
    var I = {}, R = I.lib = {}, M = R.Base = /* @__PURE__ */ function() {
      function j() {
      }
      return { extend: function(ee) {
        j.prototype = this;
        var W = new j();
        return ee && W.mixIn(ee), W.hasOwnProperty("init") || (W.init = function() {
          W.$super.init.apply(this, arguments);
        }), W.init.prototype = W, W.$super = this, W;
      }, create: function() {
        var ee = this.extend();
        return ee.init.apply(ee, arguments), ee;
      }, init: function() {
      }, mixIn: function(ee) {
        for (var W in ee)
          ee.hasOwnProperty(W) && (this[W] = ee[W]);
        ee.hasOwnProperty("toString") && (this.toString = ee.toString);
      }, clone: function() {
        return this.init.prototype.extend(this);
      } };
    }(), N = R.WordArray = M.extend({ init: function(j, ee) {
      j = this.words = j || [], ee != C ? this.sigBytes = ee : this.sigBytes = j.length * 4;
    }, toString: function(j) {
      return (j || q).stringify(this);
    }, concat: function(j) {
      var ee = this.words, W = j.words, re = this.sigBytes, ce = j.sigBytes;
      if (this.clamp(), re % 4)
        for (var me = 0; me < ce; me++) {
          var Ve = W[me >>> 2] >>> 24 - me % 4 * 8 & 255;
          ee[re + me >>> 2] |= Ve << 24 - (re + me) % 4 * 8;
        }
      else
        for (var me = 0; me < ce; me += 4)
          ee[re + me >>> 2] = W[me >>> 2];
      return this.sigBytes += ce, this;
    }, clamp: function() {
      var j = this.words, ee = this.sigBytes;
      j[ee >>> 2] &= 4294967295 << 32 - ee % 4 * 8, j.length = T.ceil(ee / 4);
    }, clone: function() {
      var j = M.clone.call(this);
      return j.words = this.words.slice(0), j;
    }, random: function(j) {
      for (var ee = [], W = 0; W < j; W += 4)
        ee.push(T.random() * 4294967296 | 0);
      return new N.init(ee, j);
    } }), Y = I.enc = {}, q = Y.Hex = { stringify: function(j) {
      for (var ee = j.words, W = j.sigBytes, re = [], ce = 0; ce < W; ce++) {
        var me = ee[ce >>> 2] >>> 24 - ce % 4 * 8 & 255;
        re.push((me >>> 4).toString(16)), re.push((me & 15).toString(16));
      }
      return re.join("");
    }, parse: function(j) {
      for (var ee = j.length, W = [], re = 0; re < ee; re += 2)
        W[re >>> 3] |= parseInt(j.substr(re, 2), 16) << 24 - re % 8 * 4;
      return new N.init(W, ee / 2);
    } }, oe = Y.Latin1 = { stringify: function(j) {
      for (var ee = j.words, W = j.sigBytes, re = [], ce = 0; ce < W; ce++) {
        var me = ee[ce >>> 2] >>> 24 - ce % 4 * 8 & 255;
        re.push(String.fromCharCode(me));
      }
      return re.join("");
    }, parse: function(j) {
      for (var ee = j.length, W = [], re = 0; re < ee; re++)
        W[re >>> 2] |= (j.charCodeAt(re) & 255) << 24 - re % 4 * 8;
      return new N.init(W, ee);
    } }, J = Y.Utf8 = { stringify: function(j) {
      try {
        return decodeURIComponent(escape(oe.stringify(j)));
      } catch {
        throw new Error("Malformed UTF-8 data");
      }
    }, parse: function(j) {
      return oe.parse(unescape(encodeURIComponent(j)));
    } }, de = R.BufferedBlockAlgorithm = M.extend({ reset: function() {
      this._data = new N.init(), this._nDataBytes = 0;
    }, _append: function(j) {
      typeof j == "string" && (j = J.parse(j)), this._data.concat(j), this._nDataBytes += j.sigBytes;
    }, _process: function(j) {
      var ee = this._data, W = ee.words, re = ee.sigBytes, ce = this.blockSize, me = ce * 4, Ve = re / me;
      j ? Ve = T.ceil(Ve) : Ve = T.max((Ve | 0) - this._minBufferSize, 0);
      var at = Ve * ce, it = T.min(at * 4, re);
      if (at) {
        for (var ct = 0; ct < at; ct += ce)
          this._doProcessBlock(W, ct);
        var ge = W.splice(0, at);
        ee.sigBytes -= it;
      }
      return new N.init(ge, it);
    }, clone: function() {
      var j = M.clone.call(this);
      return j._data = this._data.clone(), j;
    }, _minBufferSize: 0 });
    R.Hasher = de.extend({ cfg: M.extend(), init: function(j) {
      this.cfg = this.cfg.extend(j), this.reset();
    }, reset: function() {
      de.reset.call(this), this._doReset();
    }, update: function(j) {
      return this._append(j), this._process(), this;
    }, finalize: function(j) {
      j && this._append(j);
      var ee = this._doFinalize();
      return ee;
    }, blockSize: 512 / 32, _createHelper: function(j) {
      return function(ee, W) {
        return new j.init(W).finalize(ee);
      };
    }, _createHmacHelper: function(j) {
      return function(ee, W) {
        return new se.HMAC.init(j, W).finalize(ee);
      };
    } });
    var se = I.algo = {};
    return I;
  }(Math);
  (function(T) {
    var M = i, C = M.lib, I = C.Base, R = C.WordArray, M = M.x64 = {};
    M.Word = I.extend({ init: function(N, Y) {
      this.high = N, this.low = Y;
    } }), M.WordArray = I.extend({ init: function(N, Y) {
      N = this.words = N || [], this.sigBytes = Y != T ? Y : 8 * N.length;
    }, toX32: function() {
      for (var N = this.words, Y = N.length, q = [], oe = 0; oe < Y; oe++) {
        var J = N[oe];
        q.push(J.high), q.push(J.low);
      }
      return R.create(q, this.sigBytes);
    }, clone: function() {
      for (var N = I.clone.call(this), Y = N.words = this.words.slice(0), q = Y.length, oe = 0; oe < q; oe++) Y[oe] = Y[oe].clone();
      return N;
    } });
  })(), i.lib.Cipher || function(T) {
    var ee = i, C = ee.lib, I = C.Base, R = C.WordArray, M = C.BufferedBlockAlgorithm, N = ee.enc.Base64, Y = ee.algo.EvpKDF, q = C.Cipher = M.extend({ cfg: I.extend(), createEncryptor: function(re, ce) {
      return this.create(this._ENC_XFORM_MODE, re, ce);
    }, createDecryptor: function(re, ce) {
      return this.create(this._DEC_XFORM_MODE, re, ce);
    }, init: function(re, ce, me) {
      this.cfg = this.cfg.extend(me), this._xformMode = re, this._key = ce, this.reset();
    }, reset: function() {
      M.reset.call(this), this._doReset();
    }, process: function(re) {
      return this._append(re), this._process();
    }, finalize: function(re) {
      return re && this._append(re), this._doFinalize();
    }, keySize: 4, ivSize: 4, _ENC_XFORM_MODE: 1, _DEC_XFORM_MODE: 2, _createHelper: function(re) {
      return { encrypt: function(ce, me, Ve) {
        return (typeof me == "string" ? W : j).encrypt(re, ce, me, Ve);
      }, decrypt: function(ce, me, Ve) {
        return (typeof me == "string" ? W : j).decrypt(re, ce, me, Ve);
      } };
    } });
    C.StreamCipher = q.extend({ _doFinalize: function() {
      return this._process(!0);
    }, blockSize: 1 });
    var se = ee.mode = {}, oe = function(re, ce, me) {
      var Ve = this._iv;
      Ve ? this._iv = T : Ve = this._prevBlock;
      for (var at = 0; at < me; at++) re[ce + at] ^= Ve[at];
    }, J = (C.BlockCipherMode = I.extend({ createEncryptor: function(re, ce) {
      return this.Encryptor.create(re, ce);
    }, createDecryptor: function(re, ce) {
      return this.Decryptor.create(re, ce);
    }, init: function(re, ce) {
      this._cipher = re, this._iv = ce;
    } })).extend();
    J.Encryptor = J.extend({ processBlock: function(re, ce) {
      var me = this._cipher, Ve = me.blockSize;
      oe.call(this, re, ce, Ve), me.encryptBlock(re, ce), this._prevBlock = re.slice(ce, ce + Ve);
    } }), J.Decryptor = J.extend({ processBlock: function(re, ce) {
      var me = this._cipher, Ve = me.blockSize, at = re.slice(ce, ce + Ve);
      me.decryptBlock(
        re,
        ce
      ), oe.call(this, re, ce, Ve), this._prevBlock = at;
    } }), se = se.CBC = J, J = (ee.pad = {}).Pkcs7 = { pad: function(re, ce) {
      for (var me = 4 * ce, me = me - re.sigBytes % me, Ve = me << 24 | me << 16 | me << 8 | me, at = [], it = 0; it < me; it += 4) at.push(Ve);
      me = R.create(at, me), re.concat(me);
    }, unpad: function(re) {
      re.sigBytes -= re.words[re.sigBytes - 1 >>> 2] & 255;
    } }, C.BlockCipher = q.extend({ cfg: q.cfg.extend({ mode: se, padding: J }), reset: function() {
      q.reset.call(this);
      var ce = this.cfg, re = ce.iv, ce = ce.mode;
      if (this._xformMode == this._ENC_XFORM_MODE) var me = ce.createEncryptor;
      else me = ce.createDecryptor, this._minBufferSize = 1;
      this._mode = me.call(ce, this, re && re.words);
    }, _doProcessBlock: function(re, ce) {
      this._mode.processBlock(re, ce);
    }, _doFinalize: function() {
      var re = this.cfg.padding;
      if (this._xformMode == this._ENC_XFORM_MODE) {
        re.pad(this._data, this.blockSize);
        var ce = this._process(!0);
      } else ce = this._process(!0), re.unpad(ce);
      return ce;
    }, blockSize: 4 });
    var de = C.CipherParams = I.extend({ init: function(re) {
      this.mixIn(re);
    }, toString: function(re) {
      return (re || this.formatter).stringify(this);
    } }), se = (ee.format = {}).OpenSSL = { stringify: function(re) {
      var ce = re.ciphertext;
      return re = re.salt, (re ? R.create([1398893684, 1701076831]).concat(re).concat(ce) : ce).toString(N);
    }, parse: function(re) {
      re = N.parse(re);
      var ce = re.words;
      if (ce[0] == 1398893684 && ce[1] == 1701076831) {
        var me = R.create(ce.slice(2, 4));
        ce.splice(0, 4), re.sigBytes -= 16;
      }
      return de.create({ ciphertext: re, salt: me });
    } }, j = C.SerializableCipher = I.extend({ cfg: I.extend({ format: se }), encrypt: function(re, ce, me, Ve) {
      Ve = this.cfg.extend(Ve);
      var at = re.createEncryptor(me, Ve);
      return ce = at.finalize(ce), at = at.cfg, de.create({
        ciphertext: ce,
        key: me,
        iv: at.iv,
        algorithm: re,
        mode: at.mode,
        padding: at.padding,
        blockSize: re.blockSize,
        formatter: Ve.format
      });
    }, decrypt: function(re, ce, me, Ve) {
      return Ve = this.cfg.extend(Ve), ce = this._parse(ce, Ve.format), re.createDecryptor(me, Ve).finalize(ce.ciphertext);
    }, _parse: function(re, ce) {
      return typeof re == "string" ? ce.parse(re, this) : re;
    } }), ee = (ee.kdf = {}).OpenSSL = { execute: function(re, ce, me, Ve) {
      return Ve || (Ve = R.random(8)), re = Y.create({ keySize: ce + me }).compute(re, Ve), me = R.create(re.words.slice(ce), 4 * me), re.sigBytes = 4 * ce, de.create({ key: re, iv: me, salt: Ve });
    } }, W = C.PasswordBasedCipher = j.extend({ cfg: j.cfg.extend({ kdf: ee }), encrypt: function(re, ce, me, Ve) {
      return Ve = this.cfg.extend(Ve), me = Ve.kdf.execute(me, re.keySize, re.ivSize), Ve.iv = me.iv, re = j.encrypt.call(this, re, ce, me.key, Ve), re.mixIn(me), re;
    }, decrypt: function(re, ce, me, Ve) {
      return Ve = this.cfg.extend(Ve), ce = this._parse(ce, Ve.format), me = Ve.kdf.execute(me, re.keySize, re.ivSize, ce.salt), Ve.iv = me.iv, j.decrypt.call(this, re, ce, me.key, Ve);
    } });
  }(), function() {
    for (var T = i, C = T.lib.BlockCipher, ge = T.algo, I = [], R = [], M = [], N = [], Y = [], q = [], oe = [], J = [], de = [], se = [], j = [], ee = 0; 256 > ee; ee++) j[ee] = 128 > ee ? ee << 1 : ee << 1 ^ 283;
    for (var W = 0, re = 0, ee = 0; 256 > ee; ee++) {
      var ce = re ^ re << 1 ^ re << 2 ^ re << 3 ^ re << 4, ce = ce >>> 8 ^ ce & 255 ^ 99;
      I[W] = ce, R[ce] = W;
      var me = j[W], Ve = j[me], at = j[Ve], it = 257 * j[ce] ^ 16843008 * ce;
      M[W] = it << 24 | it >>> 8, N[W] = it << 16 | it >>> 16, Y[W] = it << 8 | it >>> 24, q[W] = it, it = 16843009 * at ^ 65537 * Ve ^ 257 * me ^ 16843008 * W, oe[ce] = it << 24 | it >>> 8, J[ce] = it << 16 | it >>> 16, de[ce] = it << 8 | it >>> 24, se[ce] = it, W ? (W = me ^ j[j[j[at ^ me]]], re ^= j[j[re]]) : W = re = 1;
    }
    var ct = [
      0,
      1,
      2,
      4,
      8,
      16,
      32,
      64,
      128,
      27,
      54
    ], ge = ge.AES = C.extend({ _doReset: function() {
      for (var Te = this._key, Se = Te.words, Re = Te.sigBytes / 4, Te = 4 * ((this._nRounds = Re + 6) + 1), He = this._keySchedule = [], ut = 0; ut < Te; ut++) if (ut < Re) He[ut] = Se[ut];
      else {
        var vt = He[ut - 1];
        ut % Re ? 6 < Re && ut % Re == 4 && (vt = I[vt >>> 24] << 24 | I[vt >>> 16 & 255] << 16 | I[vt >>> 8 & 255] << 8 | I[vt & 255]) : (vt = vt << 8 | vt >>> 24, vt = I[vt >>> 24] << 24 | I[vt >>> 16 & 255] << 16 | I[vt >>> 8 & 255] << 8 | I[vt & 255], vt ^= ct[ut / Re | 0] << 24), He[ut] = He[ut - Re] ^ vt;
      }
      for (Se = this._invKeySchedule = [], Re = 0; Re < Te; Re++) ut = Te - Re, vt = Re % 4 ? He[ut] : He[ut - 4], Se[Re] = 4 > Re || 4 >= ut ? vt : oe[I[vt >>> 24]] ^ J[I[vt >>> 16 & 255]] ^ de[I[vt >>> 8 & 255]] ^ se[I[vt & 255]];
    }, encryptBlock: function(Se, Re) {
      this._doCryptBlock(Se, Re, this._keySchedule, M, N, Y, q, I);
    }, decryptBlock: function(Se, Re) {
      var Te = Se[Re + 1];
      Se[Re + 1] = Se[Re + 3], Se[Re + 3] = Te, this._doCryptBlock(Se, Re, this._invKeySchedule, oe, J, de, se, R), Te = Se[Re + 1], Se[Re + 1] = Se[Re + 3], Se[Re + 3] = Te;
    }, _doCryptBlock: function(Se, Re, Te, He, ut, vt, Rt, pt) {
      for (var Tt = this._nRounds, go = Se[Re] ^ Te[0], Po = Se[Re + 1] ^ Te[1], To = Se[Re + 2] ^ Te[2], Vi = Se[Re + 3] ^ Te[3], Pt = 4, Dt = 1; Dt < Tt; Dt++) var Wo = He[go >>> 24] ^ ut[Po >>> 16 & 255] ^ vt[To >>> 8 & 255] ^ Rt[Vi & 255] ^ Te[Pt++], li = He[Po >>> 24] ^ ut[To >>> 16 & 255] ^ vt[Vi >>> 8 & 255] ^ Rt[go & 255] ^ Te[Pt++], Gn = He[To >>> 24] ^ ut[Vi >>> 16 & 255] ^ vt[go >>> 8 & 255] ^ Rt[Po & 255] ^ Te[Pt++], Vi = He[Vi >>> 24] ^ ut[go >>> 16 & 255] ^ vt[Po >>> 8 & 255] ^ Rt[To & 255] ^ Te[Pt++], go = Wo, Po = li, To = Gn;
      Wo = (pt[go >>> 24] << 24 | pt[Po >>> 16 & 255] << 16 | pt[To >>> 8 & 255] << 8 | pt[Vi & 255]) ^ Te[Pt++], li = (pt[Po >>> 24] << 24 | pt[To >>> 16 & 255] << 16 | pt[Vi >>> 8 & 255] << 8 | pt[go & 255]) ^ Te[Pt++], Gn = (pt[To >>> 24] << 24 | pt[Vi >>> 16 & 255] << 16 | pt[go >>> 8 & 255] << 8 | pt[Po & 255]) ^ Te[Pt++], Vi = (pt[Vi >>> 24] << 24 | pt[go >>> 16 & 255] << 16 | pt[Po >>> 8 & 255] << 8 | pt[To & 255]) ^ Te[Pt++], Se[Re] = Wo, Se[Re + 1] = li, Se[Re + 2] = Gn, Se[Re + 3] = Vi;
    }, keySize: 8 });
    T.AES = C._createHelper(ge);
  }(), function() {
    function T(j, ee) {
      var W = (this._lBlock >>> j ^ this._rBlock) & ee;
      this._rBlock ^= W, this._lBlock ^= W << j;
    }
    function C(j, ee) {
      var W = (this._rBlock >>> j ^ this._lBlock) & ee;
      this._lBlock ^= W, this._rBlock ^= W << j;
    }
    var I = i, M = I.lib, R = M.WordArray, M = M.BlockCipher, N = I.algo, Y = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4], q = [
      14,
      17,
      11,
      24,
      1,
      5,
      3,
      28,
      15,
      6,
      21,
      10,
      23,
      19,
      12,
      4,
      26,
      8,
      16,
      7,
      27,
      20,
      13,
      2,
      41,
      52,
      31,
      37,
      47,
      55,
      30,
      40,
      51,
      45,
      33,
      48,
      44,
      49,
      39,
      56,
      34,
      53,
      46,
      42,
      50,
      36,
      29,
      32
    ], oe = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], J = [{
      0: 8421888,
      268435456: 32768,
      536870912: 8421378,
      805306368: 2,
      1073741824: 512,
      1342177280: 8421890,
      1610612736: 8389122,
      1879048192: 8388608,
      2147483648: 514,
      2415919104: 8389120,
      2684354560: 33280,
      2952790016: 8421376,
      3221225472: 32770,
      3489660928: 8388610,
      3758096384: 0,
      4026531840: 33282,
      134217728: 0,
      402653184: 8421890,
      671088640: 33282,
      939524096: 32768,
      1207959552: 8421888,
      1476395008: 512,
      1744830464: 8421378,
      2013265920: 2,
      2281701376: 8389120,
      2550136832: 33280,
      2818572288: 8421376,
      3087007744: 8389122,
      3355443200: 8388610,
      3623878656: 32770,
      3892314112: 514,
      4160749568: 8388608,
      1: 32768,
      268435457: 2,
      536870913: 8421888,
      805306369: 8388608,
      1073741825: 8421378,
      1342177281: 33280,
      1610612737: 512,
      1879048193: 8389122,
      2147483649: 8421890,
      2415919105: 8421376,
      2684354561: 8388610,
      2952790017: 33282,
      3221225473: 514,
      3489660929: 8389120,
      3758096385: 32770,
      4026531841: 0,
      134217729: 8421890,
      402653185: 8421376,
      671088641: 8388608,
      939524097: 512,
      1207959553: 32768,
      1476395009: 8388610,
      1744830465: 2,
      2013265921: 33282,
      2281701377: 32770,
      2550136833: 8389122,
      2818572289: 514,
      3087007745: 8421888,
      3355443201: 8389120,
      3623878657: 0,
      3892314113: 33280,
      4160749569: 8421378
    }, {
      0: 1074282512,
      16777216: 16384,
      33554432: 524288,
      50331648: 1074266128,
      67108864: 1073741840,
      83886080: 1074282496,
      100663296: 1073758208,
      117440512: 16,
      134217728: 540672,
      150994944: 1073758224,
      167772160: 1073741824,
      184549376: 540688,
      201326592: 524304,
      218103808: 0,
      234881024: 16400,
      251658240: 1074266112,
      8388608: 1073758208,
      25165824: 540688,
      41943040: 16,
      58720256: 1073758224,
      75497472: 1074282512,
      92274688: 1073741824,
      109051904: 524288,
      125829120: 1074266128,
      142606336: 524304,
      159383552: 0,
      176160768: 16384,
      192937984: 1074266112,
      209715200: 1073741840,
      226492416: 540672,
      243269632: 1074282496,
      260046848: 16400,
      268435456: 0,
      285212672: 1074266128,
      301989888: 1073758224,
      318767104: 1074282496,
      335544320: 1074266112,
      352321536: 16,
      369098752: 540688,
      385875968: 16384,
      402653184: 16400,
      419430400: 524288,
      436207616: 524304,
      452984832: 1073741840,
      469762048: 540672,
      486539264: 1073758208,
      503316480: 1073741824,
      520093696: 1074282512,
      276824064: 540688,
      293601280: 524288,
      310378496: 1074266112,
      327155712: 16384,
      343932928: 1073758208,
      360710144: 1074282512,
      377487360: 16,
      394264576: 1073741824,
      411041792: 1074282496,
      427819008: 1073741840,
      444596224: 1073758224,
      461373440: 524304,
      478150656: 0,
      494927872: 16400,
      511705088: 1074266128,
      528482304: 540672
    }, {
      0: 260,
      1048576: 0,
      2097152: 67109120,
      3145728: 65796,
      4194304: 65540,
      5242880: 67108868,
      6291456: 67174660,
      7340032: 67174400,
      8388608: 67108864,
      9437184: 67174656,
      10485760: 65792,
      11534336: 67174404,
      12582912: 67109124,
      13631488: 65536,
      14680064: 4,
      15728640: 256,
      524288: 67174656,
      1572864: 67174404,
      2621440: 0,
      3670016: 67109120,
      4718592: 67108868,
      5767168: 65536,
      6815744: 65540,
      7864320: 260,
      8912896: 4,
      9961472: 256,
      11010048: 67174400,
      12058624: 65796,
      13107200: 65792,
      14155776: 67109124,
      15204352: 67174660,
      16252928: 67108864,
      16777216: 67174656,
      17825792: 65540,
      18874368: 65536,
      19922944: 67109120,
      20971520: 256,
      22020096: 67174660,
      23068672: 67108868,
      24117248: 0,
      25165824: 67109124,
      26214400: 67108864,
      27262976: 4,
      28311552: 65792,
      29360128: 67174400,
      30408704: 260,
      31457280: 65796,
      32505856: 67174404,
      17301504: 67108864,
      18350080: 260,
      19398656: 67174656,
      20447232: 0,
      21495808: 65540,
      22544384: 67109120,
      23592960: 256,
      24641536: 67174404,
      25690112: 65536,
      26738688: 67174660,
      27787264: 65796,
      28835840: 67108868,
      29884416: 67109124,
      30932992: 67174400,
      31981568: 4,
      33030144: 65792
    }, {
      0: 2151682048,
      65536: 2147487808,
      131072: 4198464,
      196608: 2151677952,
      262144: 0,
      327680: 4198400,
      393216: 2147483712,
      458752: 4194368,
      524288: 2147483648,
      589824: 4194304,
      655360: 64,
      720896: 2147487744,
      786432: 2151678016,
      851968: 4160,
      917504: 4096,
      983040: 2151682112,
      32768: 2147487808,
      98304: 64,
      163840: 2151678016,
      229376: 2147487744,
      294912: 4198400,
      360448: 2151682112,
      425984: 0,
      491520: 2151677952,
      557056: 4096,
      622592: 2151682048,
      688128: 4194304,
      753664: 4160,
      819200: 2147483648,
      884736: 4194368,
      950272: 4198464,
      1015808: 2147483712,
      1048576: 4194368,
      1114112: 4198400,
      1179648: 2147483712,
      1245184: 0,
      1310720: 4160,
      1376256: 2151678016,
      1441792: 2151682048,
      1507328: 2147487808,
      1572864: 2151682112,
      1638400: 2147483648,
      1703936: 2151677952,
      1769472: 4198464,
      1835008: 2147487744,
      1900544: 4194304,
      1966080: 64,
      2031616: 4096,
      1081344: 2151677952,
      1146880: 2151682112,
      1212416: 0,
      1277952: 4198400,
      1343488: 4194368,
      1409024: 2147483648,
      1474560: 2147487808,
      1540096: 64,
      1605632: 2147483712,
      1671168: 4096,
      1736704: 2147487744,
      1802240: 2151678016,
      1867776: 4160,
      1933312: 2151682048,
      1998848: 4194304,
      2064384: 4198464
    }, {
      0: 128,
      4096: 17039360,
      8192: 262144,
      12288: 536870912,
      16384: 537133184,
      20480: 16777344,
      24576: 553648256,
      28672: 262272,
      32768: 16777216,
      36864: 537133056,
      40960: 536871040,
      45056: 553910400,
      49152: 553910272,
      53248: 0,
      57344: 17039488,
      61440: 553648128,
      2048: 17039488,
      6144: 553648256,
      10240: 128,
      14336: 17039360,
      18432: 262144,
      22528: 537133184,
      26624: 553910272,
      30720: 536870912,
      34816: 537133056,
      38912: 0,
      43008: 553910400,
      47104: 16777344,
      51200: 536871040,
      55296: 553648128,
      59392: 16777216,
      63488: 262272,
      65536: 262144,
      69632: 128,
      73728: 536870912,
      77824: 553648256,
      81920: 16777344,
      86016: 553910272,
      90112: 537133184,
      94208: 16777216,
      98304: 553910400,
      102400: 553648128,
      106496: 17039360,
      110592: 537133056,
      114688: 262272,
      118784: 536871040,
      122880: 0,
      126976: 17039488,
      67584: 553648256,
      71680: 16777216,
      75776: 17039360,
      79872: 537133184,
      83968: 536870912,
      88064: 17039488,
      92160: 128,
      96256: 553910272,
      100352: 262272,
      104448: 553910400,
      108544: 0,
      112640: 553648128,
      116736: 16777344,
      120832: 262144,
      124928: 537133056,
      129024: 536871040
    }, {
      0: 268435464,
      256: 8192,
      512: 270532608,
      768: 270540808,
      1024: 268443648,
      1280: 2097152,
      1536: 2097160,
      1792: 268435456,
      2048: 0,
      2304: 268443656,
      2560: 2105344,
      2816: 8,
      3072: 270532616,
      3328: 2105352,
      3584: 8200,
      3840: 270540800,
      128: 270532608,
      384: 270540808,
      640: 8,
      896: 2097152,
      1152: 2105352,
      1408: 268435464,
      1664: 268443648,
      1920: 8200,
      2176: 2097160,
      2432: 8192,
      2688: 268443656,
      2944: 270532616,
      3200: 0,
      3456: 270540800,
      3712: 2105344,
      3968: 268435456,
      4096: 268443648,
      4352: 270532616,
      4608: 270540808,
      4864: 8200,
      5120: 2097152,
      5376: 268435456,
      5632: 268435464,
      5888: 2105344,
      6144: 2105352,
      6400: 0,
      6656: 8,
      6912: 270532608,
      7168: 8192,
      7424: 268443656,
      7680: 270540800,
      7936: 2097160,
      4224: 8,
      4480: 2105344,
      4736: 2097152,
      4992: 268435464,
      5248: 268443648,
      5504: 8200,
      5760: 270540808,
      6016: 270532608,
      6272: 270540800,
      6528: 270532616,
      6784: 8192,
      7040: 2105352,
      7296: 2097160,
      7552: 0,
      7808: 268435456,
      8064: 268443656
    }, {
      0: 1048576,
      16: 33555457,
      32: 1024,
      48: 1049601,
      64: 34604033,
      80: 0,
      96: 1,
      112: 34603009,
      128: 33555456,
      144: 1048577,
      160: 33554433,
      176: 34604032,
      192: 34603008,
      208: 1025,
      224: 1049600,
      240: 33554432,
      8: 34603009,
      24: 0,
      40: 33555457,
      56: 34604032,
      72: 1048576,
      88: 33554433,
      104: 33554432,
      120: 1025,
      136: 1049601,
      152: 33555456,
      168: 34603008,
      184: 1048577,
      200: 1024,
      216: 34604033,
      232: 1,
      248: 1049600,
      256: 33554432,
      272: 1048576,
      288: 33555457,
      304: 34603009,
      320: 1048577,
      336: 33555456,
      352: 34604032,
      368: 1049601,
      384: 1025,
      400: 34604033,
      416: 1049600,
      432: 1,
      448: 0,
      464: 34603008,
      480: 33554433,
      496: 1024,
      264: 1049600,
      280: 33555457,
      296: 34603009,
      312: 1,
      328: 33554432,
      344: 1048576,
      360: 1025,
      376: 34604032,
      392: 33554433,
      408: 34603008,
      424: 0,
      440: 34604033,
      456: 1049601,
      472: 1024,
      488: 33555456,
      504: 1048577
    }, {
      0: 134219808,
      1: 131072,
      2: 134217728,
      3: 32,
      4: 131104,
      5: 134350880,
      6: 134350848,
      7: 2048,
      8: 134348800,
      9: 134219776,
      10: 133120,
      11: 134348832,
      12: 2080,
      13: 0,
      14: 134217760,
      15: 133152,
      2147483648: 2048,
      2147483649: 134350880,
      2147483650: 134219808,
      2147483651: 134217728,
      2147483652: 134348800,
      2147483653: 133120,
      2147483654: 133152,
      2147483655: 32,
      2147483656: 134217760,
      2147483657: 2080,
      2147483658: 131104,
      2147483659: 134350848,
      2147483660: 0,
      2147483661: 134348832,
      2147483662: 134219776,
      2147483663: 131072,
      16: 133152,
      17: 134350848,
      18: 32,
      19: 2048,
      20: 134219776,
      21: 134217760,
      22: 134348832,
      23: 131072,
      24: 0,
      25: 131104,
      26: 134348800,
      27: 134219808,
      28: 134350880,
      29: 133120,
      30: 2080,
      31: 134217728,
      2147483664: 131072,
      2147483665: 2048,
      2147483666: 134348832,
      2147483667: 133152,
      2147483668: 32,
      2147483669: 134348800,
      2147483670: 134217728,
      2147483671: 134219808,
      2147483672: 134350880,
      2147483673: 134217760,
      2147483674: 134219776,
      2147483675: 0,
      2147483676: 133120,
      2147483677: 2080,
      2147483678: 131104,
      2147483679: 134350848
    }], de = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], se = N.DES = M.extend({ _doReset: function() {
      for (var j = this._key.words, ee = [], W = 0; 56 > W; W++) {
        var re = Y[W] - 1;
        ee[W] = j[re >>> 5] >>> 31 - re % 32 & 1;
      }
      for (j = this._subKeys = [], re = 0; 16 > re; re++) {
        for (var ce = j[re] = [], me = oe[re], W = 0; 24 > W; W++) ce[W / 6 | 0] |= ee[(q[W] - 1 + me) % 28] << 31 - W % 6, ce[4 + (W / 6 | 0)] |= ee[28 + (q[W + 24] - 1 + me) % 28] << 31 - W % 6;
        for (ce[0] = ce[0] << 1 | ce[0] >>> 31, W = 1; 7 > W; W++) ce[W] >>>= 4 * (W - 1) + 3;
        ce[7] = ce[7] << 5 | ce[7] >>> 27;
      }
      for (ee = this._invSubKeys = [], W = 0; 16 > W; W++) ee[W] = j[15 - W];
    }, encryptBlock: function(j, ee) {
      this._doCryptBlock(j, ee, this._subKeys);
    }, decryptBlock: function(j, ee) {
      this._doCryptBlock(j, ee, this._invSubKeys);
    }, _doCryptBlock: function(j, ee, W) {
      this._lBlock = j[ee], this._rBlock = j[ee + 1], T.call(this, 4, 252645135), T.call(this, 16, 65535), C.call(this, 2, 858993459), C.call(this, 8, 16711935), T.call(this, 1, 1431655765);
      for (var re = 0; 16 > re; re++) {
        for (var ce = W[re], me = this._lBlock, Ve = this._rBlock, at = 0, it = 0; 8 > it; it++) at |= J[it][((Ve ^ ce[it]) & de[it]) >>> 0];
        this._lBlock = Ve, this._rBlock = me ^ at;
      }
      W = this._lBlock, this._lBlock = this._rBlock, this._rBlock = W, T.call(this, 1, 1431655765), C.call(this, 8, 16711935), C.call(this, 2, 858993459), T.call(this, 16, 65535), T.call(this, 4, 252645135), j[ee] = this._lBlock, j[ee + 1] = this._rBlock;
    }, keySize: 2, ivSize: 2, blockSize: 2 });
    I.DES = M._createHelper(se), N = N.TripleDES = M.extend({ _doReset: function() {
      var j = this._key.words;
      this._des1 = se.createEncryptor(R.create(j.slice(0, 2))), this._des2 = se.createEncryptor(R.create(j.slice(2, 4))), this._des3 = se.createEncryptor(R.create(j.slice(4, 6)));
    }, encryptBlock: function(j, ee) {
      this._des1.encryptBlock(j, ee), this._des2.decryptBlock(j, ee), this._des3.encryptBlock(j, ee);
    }, decryptBlock: function(j, ee) {
      this._des3.decryptBlock(j, ee), this._des2.encryptBlock(j, ee), this._des1.decryptBlock(j, ee);
    }, keySize: 6, ivSize: 2, blockSize: 2 }), I.TripleDES = M._createHelper(N);
  }(), function() {
    var T = i, C = T.lib.WordArray;
    T.enc.Base64 = { stringify: function(I) {
      var R = I.words, M = I.sigBytes, N = this._map;
      I.clamp(), I = [];
      for (var Y = 0; Y < M; Y += 3) for (var q = (R[Y >>> 2] >>> 24 - 8 * (Y % 4) & 255) << 16 | (R[Y + 1 >>> 2] >>> 24 - 8 * ((Y + 1) % 4) & 255) << 8 | R[Y + 2 >>> 2] >>> 24 - 8 * ((Y + 2) % 4) & 255, oe = 0; 4 > oe && Y + 0.75 * oe < M; oe++) I.push(N.charAt(q >>> 6 * (3 - oe) & 63));
      if (R = N.charAt(64)) for (; I.length % 4; ) I.push(R);
      return I.join("");
    }, parse: function(I) {
      var R = I.length, M = this._map, N = M.charAt(64);
      N && (N = I.indexOf(N), N != -1 && (R = N));
      for (var N = [], Y = 0, q = 0; q < R; q++) if (q % 4) {
        var oe = M.indexOf(I.charAt(q - 1)) << 2 * (q % 4), J = M.indexOf(I.charAt(q)) >>> 6 - 2 * (q % 4);
        N[Y >>> 2] |= (oe | J) << 24 - 8 * (Y % 4), Y++;
      }
      return C.create(N, Y);
    }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
  }(), function(T) {
    function C(se, j, ee, W, re, ce, me) {
      return se = se + (j & ee | ~j & W) + re + me, (se << ce | se >>> 32 - ce) + j;
    }
    function I(se, j, ee, W, re, ce, me) {
      return se = se + (j & W | ee & ~W) + re + me, (se << ce | se >>> 32 - ce) + j;
    }
    function R(se, j, ee, W, re, ce, me) {
      return se = se + (j ^ ee ^ W) + re + me, (se << ce | se >>> 32 - ce) + j;
    }
    function M(se, j, ee, W, re, ce, me) {
      return se = se + (ee ^ (j | ~W)) + re + me, (se << ce | se >>> 32 - ce) + j;
    }
    for (var N = i, oe = N.lib, Y = oe.WordArray, q = oe.Hasher, oe = N.algo, J = [], de = 0; 64 > de; de++) J[de] = 4294967296 * T.abs(T.sin(de + 1)) | 0;
    oe = oe.MD5 = q.extend({
      _doReset: function() {
        this._hash = new Y.init([1732584193, 4023233417, 2562383102, 271733878]);
      },
      _doProcessBlock: function(se, j) {
        for (var ee = 0; 16 > ee; ee++) {
          var W = j + ee, re = se[W];
          se[W] = (re << 8 | re >>> 24) & 16711935 | (re << 24 | re >>> 8) & 4278255360;
        }
        var ee = this._hash.words, W = se[j + 0], re = se[j + 1], ce = se[j + 2], me = se[j + 3], Ve = se[j + 4], at = se[j + 5], it = se[j + 6], ct = se[j + 7], ge = se[j + 8], Se = se[j + 9], Re = se[j + 10], Te = se[j + 11], He = se[j + 12], ut = se[j + 13], vt = se[j + 14], Rt = se[j + 15], pt = ee[0], Dt = ee[1], Pt = ee[2], Tt = ee[3], pt = C(pt, Dt, Pt, Tt, W, 7, J[0]), Tt = C(Tt, pt, Dt, Pt, re, 12, J[1]), Pt = C(Pt, Tt, pt, Dt, ce, 17, J[2]), Dt = C(Dt, Pt, Tt, pt, me, 22, J[3]), pt = C(pt, Dt, Pt, Tt, Ve, 7, J[4]), Tt = C(Tt, pt, Dt, Pt, at, 12, J[5]), Pt = C(Pt, Tt, pt, Dt, it, 17, J[6]), Dt = C(Dt, Pt, Tt, pt, ct, 22, J[7]), pt = C(pt, Dt, Pt, Tt, ge, 7, J[8]), Tt = C(Tt, pt, Dt, Pt, Se, 12, J[9]), Pt = C(Pt, Tt, pt, Dt, Re, 17, J[10]), Dt = C(Dt, Pt, Tt, pt, Te, 22, J[11]), pt = C(pt, Dt, Pt, Tt, He, 7, J[12]), Tt = C(Tt, pt, Dt, Pt, ut, 12, J[13]), Pt = C(Pt, Tt, pt, Dt, vt, 17, J[14]), Dt = C(Dt, Pt, Tt, pt, Rt, 22, J[15]), pt = I(pt, Dt, Pt, Tt, re, 5, J[16]), Tt = I(Tt, pt, Dt, Pt, it, 9, J[17]), Pt = I(Pt, Tt, pt, Dt, Te, 14, J[18]), Dt = I(Dt, Pt, Tt, pt, W, 20, J[19]), pt = I(pt, Dt, Pt, Tt, at, 5, J[20]), Tt = I(Tt, pt, Dt, Pt, Re, 9, J[21]), Pt = I(Pt, Tt, pt, Dt, Rt, 14, J[22]), Dt = I(Dt, Pt, Tt, pt, Ve, 20, J[23]), pt = I(pt, Dt, Pt, Tt, Se, 5, J[24]), Tt = I(Tt, pt, Dt, Pt, vt, 9, J[25]), Pt = I(Pt, Tt, pt, Dt, me, 14, J[26]), Dt = I(Dt, Pt, Tt, pt, ge, 20, J[27]), pt = I(pt, Dt, Pt, Tt, ut, 5, J[28]), Tt = I(
          Tt,
          pt,
          Dt,
          Pt,
          ce,
          9,
          J[29]
        ), Pt = I(Pt, Tt, pt, Dt, ct, 14, J[30]), Dt = I(Dt, Pt, Tt, pt, He, 20, J[31]), pt = R(pt, Dt, Pt, Tt, at, 4, J[32]), Tt = R(Tt, pt, Dt, Pt, ge, 11, J[33]), Pt = R(Pt, Tt, pt, Dt, Te, 16, J[34]), Dt = R(Dt, Pt, Tt, pt, vt, 23, J[35]), pt = R(pt, Dt, Pt, Tt, re, 4, J[36]), Tt = R(Tt, pt, Dt, Pt, Ve, 11, J[37]), Pt = R(Pt, Tt, pt, Dt, ct, 16, J[38]), Dt = R(Dt, Pt, Tt, pt, Re, 23, J[39]), pt = R(pt, Dt, Pt, Tt, ut, 4, J[40]), Tt = R(Tt, pt, Dt, Pt, W, 11, J[41]), Pt = R(Pt, Tt, pt, Dt, me, 16, J[42]), Dt = R(Dt, Pt, Tt, pt, it, 23, J[43]), pt = R(pt, Dt, Pt, Tt, Se, 4, J[44]), Tt = R(Tt, pt, Dt, Pt, He, 11, J[45]), Pt = R(Pt, Tt, pt, Dt, Rt, 16, J[46]), Dt = R(Dt, Pt, Tt, pt, ce, 23, J[47]), pt = M(pt, Dt, Pt, Tt, W, 6, J[48]), Tt = M(Tt, pt, Dt, Pt, ct, 10, J[49]), Pt = M(
          Pt,
          Tt,
          pt,
          Dt,
          vt,
          15,
          J[50]
        ), Dt = M(Dt, Pt, Tt, pt, at, 21, J[51]), pt = M(pt, Dt, Pt, Tt, He, 6, J[52]), Tt = M(Tt, pt, Dt, Pt, me, 10, J[53]), Pt = M(Pt, Tt, pt, Dt, Re, 15, J[54]), Dt = M(Dt, Pt, Tt, pt, re, 21, J[55]), pt = M(pt, Dt, Pt, Tt, ge, 6, J[56]), Tt = M(Tt, pt, Dt, Pt, Rt, 10, J[57]), Pt = M(Pt, Tt, pt, Dt, it, 15, J[58]), Dt = M(Dt, Pt, Tt, pt, ut, 21, J[59]), pt = M(pt, Dt, Pt, Tt, Ve, 6, J[60]), Tt = M(Tt, pt, Dt, Pt, Te, 10, J[61]), Pt = M(Pt, Tt, pt, Dt, ce, 15, J[62]), Dt = M(Dt, Pt, Tt, pt, Se, 21, J[63]);
        ee[0] = ee[0] + pt | 0, ee[1] = ee[1] + Dt | 0, ee[2] = ee[2] + Pt | 0, ee[3] = ee[3] + Tt | 0;
      },
      _doFinalize: function() {
        var se = this._data, j = se.words, ee = 8 * this._nDataBytes, W = 8 * se.sigBytes;
        j[W >>> 5] |= 128 << 24 - W % 32;
        var re = T.floor(ee / 4294967296);
        for (j[(W + 64 >>> 9 << 4) + 15] = (re << 8 | re >>> 24) & 16711935 | (re << 24 | re >>> 8) & 4278255360, j[(W + 64 >>> 9 << 4) + 14] = (ee << 8 | ee >>> 24) & 16711935 | (ee << 24 | ee >>> 8) & 4278255360, se.sigBytes = 4 * (j.length + 1), this._process(), se = this._hash, j = se.words, ee = 0; 4 > ee; ee++) W = j[ee], j[ee] = (W << 8 | W >>> 24) & 16711935 | (W << 24 | W >>> 8) & 4278255360;
        return se;
      },
      clone: function() {
        var se = q.clone.call(this);
        return se._hash = this._hash.clone(), se;
      }
    }), N.MD5 = q._createHelper(oe), N.HmacMD5 = q._createHmacHelper(oe);
  }(Math), function() {
    var T = i, M = T.lib, C = M.WordArray, I = M.Hasher, R = [], M = T.algo.SHA1 = I.extend({ _doReset: function() {
      this._hash = new C.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
    }, _doProcessBlock: function(N, Y) {
      for (var q = this._hash.words, oe = q[0], J = q[1], de = q[2], se = q[3], j = q[4], ee = 0; 80 > ee; ee++) {
        if (16 > ee) R[ee] = N[Y + ee] | 0;
        else {
          var W = R[ee - 3] ^ R[ee - 8] ^ R[ee - 14] ^ R[ee - 16];
          R[ee] = W << 1 | W >>> 31;
        }
        W = (oe << 5 | oe >>> 27) + j + R[ee], W = 20 > ee ? W + ((J & de | ~J & se) + 1518500249) : 40 > ee ? W + ((J ^ de ^ se) + 1859775393) : 60 > ee ? W + ((J & de | J & se | de & se) - 1894007588) : W + ((J ^ de ^ se) - 899497514), j = se, se = de, de = J << 30 | J >>> 2, J = oe, oe = W;
      }
      q[0] = q[0] + oe | 0, q[1] = q[1] + J | 0, q[2] = q[2] + de | 0, q[3] = q[3] + se | 0, q[4] = q[4] + j | 0;
    }, _doFinalize: function() {
      var N = this._data, Y = N.words, q = 8 * this._nDataBytes, oe = 8 * N.sigBytes;
      return Y[oe >>> 5] |= 128 << 24 - oe % 32, Y[(oe + 64 >>> 9 << 4) + 14] = Math.floor(q / 4294967296), Y[(oe + 64 >>> 9 << 4) + 15] = q, N.sigBytes = 4 * Y.length, this._process(), this._hash;
    }, clone: function() {
      var N = I.clone.call(this);
      return N._hash = this._hash.clone(), N;
    } });
    T.SHA1 = I._createHelper(M), T.HmacSHA1 = I._createHmacHelper(M);
  }(), function(T) {
    for (var C = i, ee = C.lib, I = ee.WordArray, R = ee.Hasher, ee = C.algo, M = [], N = [], Y = function(re) {
      return 4294967296 * (re - (re | 0)) | 0;
    }, q = 2, oe = 0; 64 > oe; ) {
      var J;
      e: {
        J = q;
        for (var de = T.sqrt(J), se = 2; se <= de; se++) if (!(J % se)) {
          J = !1;
          break e;
        }
        J = !0;
      }
      J && (8 > oe && (M[oe] = Y(T.pow(q, 0.5))), N[oe] = Y(T.pow(q, 1 / 3)), oe++), q++;
    }
    var j = [], ee = ee.SHA256 = R.extend({ _doReset: function() {
      this._hash = new I.init(M.slice(0));
    }, _doProcessBlock: function(W, re) {
      for (var ce = this._hash.words, me = ce[0], Ve = ce[1], at = ce[2], it = ce[3], ct = ce[4], ge = ce[5], Se = ce[6], Re = ce[7], Te = 0; 64 > Te; Te++) {
        if (16 > Te) j[Te] = W[re + Te] | 0;
        else {
          var He = j[Te - 15], ut = j[Te - 2];
          j[Te] = ((He << 25 | He >>> 7) ^ (He << 14 | He >>> 18) ^ He >>> 3) + j[Te - 7] + ((ut << 15 | ut >>> 17) ^ (ut << 13 | ut >>> 19) ^ ut >>> 10) + j[Te - 16];
        }
        He = Re + ((ct << 26 | ct >>> 6) ^ (ct << 21 | ct >>> 11) ^ (ct << 7 | ct >>> 25)) + (ct & ge ^ ~ct & Se) + N[Te] + j[Te], ut = ((me << 30 | me >>> 2) ^ (me << 19 | me >>> 13) ^ (me << 10 | me >>> 22)) + (me & Ve ^ me & at ^ Ve & at), Re = Se, Se = ge, ge = ct, ct = it + He | 0, it = at, at = Ve, Ve = me, me = He + ut | 0;
      }
      ce[0] = ce[0] + me | 0, ce[1] = ce[1] + Ve | 0, ce[2] = ce[2] + at | 0, ce[3] = ce[3] + it | 0, ce[4] = ce[4] + ct | 0, ce[5] = ce[5] + ge | 0, ce[6] = ce[6] + Se | 0, ce[7] = ce[7] + Re | 0;
    }, _doFinalize: function() {
      var W = this._data, re = W.words, ce = 8 * this._nDataBytes, me = 8 * W.sigBytes;
      return re[me >>> 5] |= 128 << 24 - me % 32, re[(me + 64 >>> 9 << 4) + 14] = T.floor(ce / 4294967296), re[(me + 64 >>> 9 << 4) + 15] = ce, W.sigBytes = 4 * re.length, this._process(), this._hash;
    }, clone: function() {
      var W = R.clone.call(this);
      return W._hash = this._hash.clone(), W;
    } });
    C.SHA256 = R._createHelper(ee), C.HmacSHA256 = R._createHmacHelper(ee);
  }(Math), function() {
    var T = i, C = T.lib.WordArray, R = T.algo, I = R.SHA256, R = R.SHA224 = I.extend({ _doReset: function() {
      this._hash = new C.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]);
    }, _doFinalize: function() {
      var M = I._doFinalize.call(this);
      return M.sigBytes -= 4, M;
    } });
    T.SHA224 = I._createHelper(R), T.HmacSHA224 = I._createHmacHelper(R);
  }(), function() {
    function T() {
      return R.create.apply(R, arguments);
    }
    for (var C = i, I = C.lib.Hasher, N = C.x64, R = N.Word, M = N.WordArray, N = C.algo, Y = [
      T(1116352408, 3609767458),
      T(1899447441, 602891725),
      T(3049323471, 3964484399),
      T(3921009573, 2173295548),
      T(961987163, 4081628472),
      T(1508970993, 3053834265),
      T(2453635748, 2937671579),
      T(2870763221, 3664609560),
      T(3624381080, 2734883394),
      T(310598401, 1164996542),
      T(607225278, 1323610764),
      T(1426881987, 3590304994),
      T(1925078388, 4068182383),
      T(2162078206, 991336113),
      T(2614888103, 633803317),
      T(3248222580, 3479774868),
      T(3835390401, 2666613458),
      T(4022224774, 944711139),
      T(264347078, 2341262773),
      T(604807628, 2007800933),
      T(770255983, 1495990901),
      T(1249150122, 1856431235),
      T(1555081692, 3175218132),
      T(1996064986, 2198950837),
      T(2554220882, 3999719339),
      T(2821834349, 766784016),
      T(2952996808, 2566594879),
      T(3210313671, 3203337956),
      T(3336571891, 1034457026),
      T(3584528711, 2466948901),
      T(113926993, 3758326383),
      T(338241895, 168717936),
      T(666307205, 1188179964),
      T(773529912, 1546045734),
      T(1294757372, 1522805485),
      T(
        1396182291,
        2643833823
      ),
      T(1695183700, 2343527390),
      T(1986661051, 1014477480),
      T(2177026350, 1206759142),
      T(2456956037, 344077627),
      T(2730485921, 1290863460),
      T(2820302411, 3158454273),
      T(3259730800, 3505952657),
      T(3345764771, 106217008),
      T(3516065817, 3606008344),
      T(3600352804, 1432725776),
      T(4094571909, 1467031594),
      T(275423344, 851169720),
      T(430227734, 3100823752),
      T(506948616, 1363258195),
      T(659060556, 3750685593),
      T(883997877, 3785050280),
      T(958139571, 3318307427),
      T(1322822218, 3812723403),
      T(1537002063, 2003034995),
      T(1747873779, 3602036899),
      T(1955562222, 1575990012),
      T(2024104815, 1125592928),
      T(2227730452, 2716904306),
      T(2361852424, 442776044),
      T(2428436474, 593698344),
      T(2756734187, 3733110249),
      T(3204031479, 2999351573),
      T(3329325298, 3815920427),
      T(3391569614, 3928383900),
      T(3515267271, 566280711),
      T(3940187606, 3454069534),
      T(4118630271, 4000239992),
      T(116418474, 1914138554),
      T(174292421, 2731055270),
      T(289380356, 3203993006),
      T(460393269, 320620315),
      T(685471733, 587496836),
      T(852142971, 1086792851),
      T(1017036298, 365543100),
      T(1126000580, 2618297676),
      T(
        1288033470,
        3409855158
      ),
      T(1501505948, 4234509866),
      T(1607167915, 987167468),
      T(1816402316, 1246189591)
    ], q = [], oe = 0; 80 > oe; oe++) q[oe] = T();
    N = N.SHA512 = I.extend({ _doReset: function() {
      this._hash = new M.init([new R.init(1779033703, 4089235720), new R.init(3144134277, 2227873595), new R.init(1013904242, 4271175723), new R.init(2773480762, 1595750129), new R.init(1359893119, 2917565137), new R.init(2600822924, 725511199), new R.init(528734635, 4215389547), new R.init(1541459225, 327033209)]);
    }, _doProcessBlock: function(J, de) {
      for (var Ve = this._hash.words, se = Ve[0], j = Ve[1], ee = Ve[2], W = Ve[3], re = Ve[4], ce = Ve[5], me = Ve[6], Ve = Ve[7], at = se.high, it = se.low, ct = j.high, ge = j.low, Se = ee.high, Re = ee.low, Te = W.high, He = W.low, ut = re.high, vt = re.low, Rt = ce.high, pt = ce.low, Tt = me.high, Pt = me.low, Dt = Ve.high, Wo = Ve.low, li = at, Gn = it, Vi = ct, go = ge, Po = Se, To = Re, _v = Te, la = He, Qr = ut, xn = vt, fi = Rt, di = pt, Oa = Tt, Si = Pt, Av = Dt, b0 = Wo, Ju = 0; 80 > Ju; Ju++) {
        var Al = q[Ju];
        if (16 > Ju) var yu = Al.high = J[de + 2 * Ju] | 0, yn = Al.low = J[de + 2 * Ju + 1] | 0;
        else {
          var yu = q[Ju - 15], yn = yu.high, xs = yu.low, yu = (yn >>> 1 | xs << 31) ^ (yn >>> 8 | xs << 24) ^ yn >>> 7, xs = (xs >>> 1 | yn << 31) ^ (xs >>> 8 | yn << 24) ^ (xs >>> 7 | yn << 25), C0 = q[Ju - 2], yn = C0.high, ti = C0.low, C0 = (yn >>> 19 | ti << 13) ^ (yn << 3 | ti >>> 29) ^ yn >>> 6, ti = (ti >>> 19 | yn << 13) ^ (ti << 3 | yn >>> 29) ^ (ti >>> 6 | yn << 26), yn = q[Ju - 7], tI = yn.high, _l = q[Ju - 16], Ns = _l.high, _l = _l.low, yn = xs + yn.low, yu = yu + tI + (yn >>> 0 < xs >>> 0 ? 1 : 0), yn = yn + ti, yu = yu + C0 + (yn >>> 0 < ti >>> 0 ? 1 : 0), yn = yn + _l, yu = yu + Ns + (yn >>> 0 < _l >>> 0 ? 1 : 0);
          Al.high = yu, Al.low = yn;
        }
        var tI = Qr & fi ^ ~Qr & Oa, _l = xn & di ^ ~xn & Si, Al = li & Vi ^ li & Po ^ Vi & Po, CIe = Gn & go ^ Gn & To ^ go & To, xs = (li >>> 28 | Gn << 4) ^ (li << 30 | Gn >>> 2) ^ (li << 25 | Gn >>> 7), C0 = (Gn >>> 28 | li << 4) ^ (Gn << 30 | li >>> 2) ^ (Gn << 25 | li >>> 7), ti = Y[Ju], IIe = ti.high, KU = ti.low, ti = b0 + ((xn >>> 14 | Qr << 18) ^ (xn >>> 18 | Qr << 14) ^ (xn << 23 | Qr >>> 9)), Ns = Av + ((Qr >>> 14 | xn << 18) ^ (Qr >>> 18 | xn << 14) ^ (Qr << 23 | xn >>> 9)) + (ti >>> 0 < b0 >>> 0 ? 1 : 0), ti = ti + _l, Ns = Ns + tI + (ti >>> 0 < _l >>> 0 ? 1 : 0), ti = ti + KU, Ns = Ns + IIe + (ti >>> 0 < KU >>> 0 ? 1 : 0), ti = ti + yn, Ns = Ns + yu + (ti >>> 0 < yn >>> 0 ? 1 : 0), yn = C0 + CIe, Al = xs + Al + (yn >>> 0 < C0 >>> 0 ? 1 : 0), Av = Oa, b0 = Si, Oa = fi, Si = di, fi = Qr, di = xn, xn = la + ti | 0, Qr = _v + Ns + (xn >>> 0 < la >>> 0 ? 1 : 0) | 0, _v = Po, la = To, Po = Vi, To = go, Vi = li, go = Gn, Gn = ti + yn | 0, li = Ns + Al + (Gn >>> 0 < ti >>> 0 ? 1 : 0) | 0;
      }
      it = se.low = it + Gn, se.high = at + li + (it >>> 0 < Gn >>> 0 ? 1 : 0), ge = j.low = ge + go, j.high = ct + Vi + (ge >>> 0 < go >>> 0 ? 1 : 0), Re = ee.low = Re + To, ee.high = Se + Po + (Re >>> 0 < To >>> 0 ? 1 : 0), He = W.low = He + la, W.high = Te + _v + (He >>> 0 < la >>> 0 ? 1 : 0), vt = re.low = vt + xn, re.high = ut + Qr + (vt >>> 0 < xn >>> 0 ? 1 : 0), pt = ce.low = pt + di, ce.high = Rt + fi + (pt >>> 0 < di >>> 0 ? 1 : 0), Pt = me.low = Pt + Si, me.high = Tt + Oa + (Pt >>> 0 < Si >>> 0 ? 1 : 0), Wo = Ve.low = Wo + b0, Ve.high = Dt + Av + (Wo >>> 0 < b0 >>> 0 ? 1 : 0);
    }, _doFinalize: function() {
      var J = this._data, de = J.words, se = 8 * this._nDataBytes, j = 8 * J.sigBytes;
      return de[j >>> 5] |= 128 << 24 - j % 32, de[(j + 128 >>> 10 << 5) + 30] = Math.floor(se / 4294967296), de[(j + 128 >>> 10 << 5) + 31] = se, J.sigBytes = 4 * de.length, this._process(), this._hash.toX32();
    }, clone: function() {
      var J = I.clone.call(this);
      return J._hash = this._hash.clone(), J;
    }, blockSize: 32 }), C.SHA512 = I._createHelper(N), C.HmacSHA512 = I._createHmacHelper(N);
  }(), function() {
    var T = i, M = T.x64, C = M.Word, I = M.WordArray, M = T.algo, R = M.SHA512, M = M.SHA384 = R.extend({ _doReset: function() {
      this._hash = new I.init([new C.init(3418070365, 3238371032), new C.init(1654270250, 914150663), new C.init(2438529370, 812702999), new C.init(355462360, 4144912697), new C.init(1731405415, 4290775857), new C.init(2394180231, 1750603025), new C.init(3675008525, 1694076839), new C.init(1203062813, 3204075428)]);
    }, _doFinalize: function() {
      var N = R._doFinalize.call(this);
      return N.sigBytes -= 16, N;
    } });
    T.SHA384 = R._createHelper(M), T.HmacSHA384 = R._createHmacHelper(M);
  }(), function() {
    var T = i, J = T.lib, C = J.WordArray, I = J.Hasher, J = T.algo, R = C.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]), M = C.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]), N = C.create([
      11,
      14,
      15,
      12,
      5,
      8,
      7,
      9,
      11,
      13,
      14,
      15,
      6,
      7,
      9,
      8,
      7,
      6,
      8,
      13,
      11,
      9,
      7,
      15,
      7,
      12,
      15,
      9,
      11,
      7,
      13,
      12,
      11,
      13,
      6,
      7,
      14,
      9,
      13,
      15,
      14,
      8,
      13,
      6,
      5,
      12,
      7,
      5,
      11,
      12,
      14,
      15,
      14,
      15,
      9,
      8,
      9,
      14,
      5,
      6,
      8,
      6,
      5,
      12,
      9,
      15,
      5,
      11,
      6,
      8,
      13,
      12,
      5,
      12,
      13,
      14,
      11,
      8,
      5,
      6
    ]), Y = C.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]), q = C.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), oe = C.create([
      1352829926,
      1548603684,
      1836072691,
      2053994217,
      0
    ]), J = J.RIPEMD160 = I.extend({ _doReset: function() {
      this._hash = C.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
    }, _doProcessBlock: function(de, se) {
      for (var j = 0; 16 > j; j++) {
        var ee = se + j, W = de[ee];
        de[ee] = (W << 8 | W >>> 24) & 16711935 | (W << 24 | W >>> 8) & 4278255360;
      }
      var ee = this._hash.words, W = q.words, re = oe.words, ce = R.words, me = M.words, Ve = N.words, at = Y.words, it, ct, ge, Se, Re, Te, He, ut, vt, Rt;
      Te = it = ee[0], He = ct = ee[1], ut = ge = ee[2], vt = Se = ee[3], Rt = Re = ee[4];
      for (var pt, j = 0; 80 > j; j += 1) pt = it + de[se + ce[j]] | 0, pt = 16 > j ? pt + ((ct ^ ge ^ Se) + W[0]) : 32 > j ? pt + ((ct & ge | ~ct & Se) + W[1]) : 48 > j ? pt + (((ct | ~ge) ^ Se) + W[2]) : 64 > j ? pt + ((ct & Se | ge & ~Se) + W[3]) : pt + ((ct ^ (ge | ~Se)) + W[4]), pt |= 0, pt = pt << Ve[j] | pt >>> 32 - Ve[j], pt = pt + Re | 0, it = Re, Re = Se, Se = ge << 10 | ge >>> 22, ge = ct, ct = pt, pt = Te + de[se + me[j]] | 0, pt = 16 > j ? pt + ((He ^ (ut | ~vt)) + re[0]) : 32 > j ? pt + ((He & vt | ut & ~vt) + re[1]) : 48 > j ? pt + (((He | ~ut) ^ vt) + re[2]) : 64 > j ? pt + ((He & ut | ~He & vt) + re[3]) : pt + ((He ^ ut ^ vt) + re[4]), pt |= 0, pt = pt << at[j] | pt >>> 32 - at[j], pt = pt + Rt | 0, Te = Rt, Rt = vt, vt = ut << 10 | ut >>> 22, ut = He, He = pt;
      pt = ee[1] + ge + vt | 0, ee[1] = ee[2] + Se + Rt | 0, ee[2] = ee[3] + Re + Te | 0, ee[3] = ee[4] + it + He | 0, ee[4] = ee[0] + ct + ut | 0, ee[0] = pt;
    }, _doFinalize: function() {
      var de = this._data, se = de.words, j = 8 * this._nDataBytes, ee = 8 * de.sigBytes;
      for (se[ee >>> 5] |= 128 << 24 - ee % 32, se[(ee + 64 >>> 9 << 4) + 14] = (j << 8 | j >>> 24) & 16711935 | (j << 24 | j >>> 8) & 4278255360, de.sigBytes = 4 * (se.length + 1), this._process(), de = this._hash, se = de.words, j = 0; 5 > j; j++) ee = se[j], se[j] = (ee << 8 | ee >>> 24) & 16711935 | (ee << 24 | ee >>> 8) & 4278255360;
      return de;
    }, clone: function() {
      var de = I.clone.call(this);
      return de._hash = this._hash.clone(), de;
    } });
    T.RIPEMD160 = I._createHelper(J), T.HmacRIPEMD160 = I._createHmacHelper(J);
  }(), function() {
    var T = i, C = T.enc.Utf8;
    T.algo.HMAC = T.lib.Base.extend({ init: function(I, R) {
      I = this._hasher = new I.init(), typeof R == "string" && (R = C.parse(R));
      var M = I.blockSize, N = 4 * M;
      R.sigBytes > N && (R = I.finalize(R)), R.clamp();
      for (var Y = this._oKey = R.clone(), q = this._iKey = R.clone(), oe = Y.words, J = q.words, de = 0; de < M; de++) oe[de] ^= 1549556828, J[de] ^= 909522486;
      Y.sigBytes = q.sigBytes = N, this.reset();
    }, reset: function() {
      var I = this._hasher;
      I.reset(), I.update(this._iKey);
    }, update: function(I) {
      return this._hasher.update(I), this;
    }, finalize: function(I) {
      var R = this._hasher;
      return I = R.finalize(I), R.reset(), R.finalize(this._oKey.clone().concat(I));
    } });
  }(), function() {
    var T = i, R = T.lib, C = R.Base, I = R.WordArray, R = T.algo, M = R.HMAC, N = R.PBKDF2 = C.extend({ cfg: C.extend({ keySize: 4, hasher: R.SHA1, iterations: 1 }), init: function(Y) {
      this.cfg = this.cfg.extend(Y);
    }, compute: function(Y, q) {
      for (var W = this.cfg, oe = M.create(W.hasher, Y), J = I.create(), de = I.create([1]), se = J.words, j = de.words, ee = W.keySize, W = W.iterations; se.length < ee; ) {
        var re = oe.update(q).finalize(de);
        oe.reset();
        for (var ce = re.words, me = ce.length, Ve = re, at = 1; at < W; at++) {
          Ve = oe.finalize(Ve), oe.reset();
          for (var it = Ve.words, ct = 0; ct < me; ct++) ce[ct] ^= it[ct];
        }
        J.concat(re), j[0]++;
      }
      return J.sigBytes = 4 * ee, J;
    } });
    T.PBKDF2 = function(Y, q, oe) {
      return N.create(oe).compute(Y, q);
    };
  }();
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = "=";
  function u(T) {
    var C, I, R = "";
    for (C = 0; C + 3 <= T.length; C += 3)
      I = parseInt(T.substring(C, C + 3), 16), R += o.charAt(I >> 6) + o.charAt(I & 63);
    for (C + 1 == T.length ? (I = parseInt(T.substring(C, C + 1), 16), R += o.charAt(I << 2)) : C + 2 == T.length && (I = parseInt(T.substring(C, C + 2), 16), R += o.charAt(I >> 2) + o.charAt((I & 3) << 4)); (R.length & 3) > 0; )
      R += a;
    return R;
  }
  function s(T) {
    var C = "", I, R = 0, M, N;
    for (I = 0; I < T.length && T.charAt(I) != a; ++I)
      N = o.indexOf(T.charAt(I)), !(N < 0) && (R == 0 ? (C += S(N >> 2), M = N & 3, R = 1) : R == 1 ? (C += S(M << 2 | N >> 4), M = N & 15, R = 2) : R == 2 ? (C += S(M), C += S(N >> 2), M = N & 3, R = 3) : (C += S(M << 2 | N >> 4), C += S(N & 15), R = 0));
    return R == 1 && (C += S(M << 2)), C;
  }
  function c(T) {
    var C = s(T), I, R = new Array();
    for (I = 0; 2 * I < C.length; ++I)
      R[I] = parseInt(C.substring(2 * I, 2 * I + 2), 16);
    return R;
  }
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
  */
  var l;
  function f(T, C, I) {
    T != null && (typeof T == "number" ? this.fromNumber(T, C, I) : C == null && typeof T != "string" ? this.fromString(T, 256) : this.fromString(T, C));
  }
  function d() {
    return new f(null);
  }
  function p(T, C, I, R, M, N) {
    for (; --N >= 0; ) {
      var Y = C * this[T++] + I[R] + M;
      M = Math.floor(Y / 67108864), I[R++] = Y & 67108863;
    }
    return M;
  }
  function v(T, C, I, R, M, N) {
    for (var Y = C & 32767, q = C >> 15; --N >= 0; ) {
      var oe = this[T] & 32767, J = this[T++] >> 15, de = q * oe + J * Y;
      oe = Y * oe + ((de & 32767) << 15) + I[R] + (M & 1073741823), M = (oe >>> 30) + (de >>> 15) + q * J + (M >>> 30), I[R++] = oe & 1073741823;
    }
    return M;
  }
  function h(T, C, I, R, M, N) {
    for (var Y = C & 16383, q = C >> 14; --N >= 0; ) {
      var oe = this[T] & 16383, J = this[T++] >> 14, de = q * oe + J * Y;
      oe = Y * oe + ((de & 16383) << 14) + I[R] + M, M = (oe >> 28) + (de >> 14) + q * J, I[R++] = oe & 268435455;
    }
    return M;
  }
  e.appName == "Microsoft Internet Explorer" ? (f.prototype.am = v, l = 30) : e.appName != "Netscape" ? (f.prototype.am = p, l = 26) : (f.prototype.am = h, l = 28), f.prototype.DB = l, f.prototype.DM = (1 << l) - 1, f.prototype.DV = 1 << l;
  var E = 52;
  f.prototype.FV = Math.pow(2, E), f.prototype.F1 = E - l, f.prototype.F2 = 2 * l - E;
  var m = "0123456789abcdefghijklmnopqrstuvwxyz", g = new Array(), y, _;
  for (y = 48, _ = 0; _ <= 9; ++_)
    g[y++] = _;
  for (y = 97, _ = 10; _ < 36; ++_)
    g[y++] = _;
  for (y = 65, _ = 10; _ < 36; ++_)
    g[y++] = _;
  function S(T) {
    return m.charAt(T);
  }
  function A(T, C) {
    var I = g[T.charCodeAt(C)];
    return I ?? -1;
  }
  function O(T) {
    for (var C = this.t - 1; C >= 0; --C)
      T[C] = this[C];
    T.t = this.t, T.s = this.s;
  }
  function P(T) {
    this.t = 1, this.s = T < 0 ? -1 : 0, T > 0 ? this[0] = T : T < -1 ? this[0] = T + this.DV : this.t = 0;
  }
  function U(T) {
    var C = d();
    return C.fromInt(T), C;
  }
  function z(T, C) {
    var I;
    if (C == 16)
      I = 4;
    else if (C == 8)
      I = 3;
    else if (C == 256)
      I = 8;
    else if (C == 2)
      I = 1;
    else if (C == 32)
      I = 5;
    else if (C == 4)
      I = 2;
    else {
      this.fromRadix(T, C);
      return;
    }
    this.t = 0, this.s = 0;
    for (var R = T.length, M = !1, N = 0; --R >= 0; ) {
      var Y = I == 8 ? T[R] & 255 : A(T, R);
      if (Y < 0) {
        T.charAt(R) == "-" && (M = !0);
        continue;
      }
      M = !1, N == 0 ? this[this.t++] = Y : N + I > this.DB ? (this[this.t - 1] |= (Y & (1 << this.DB - N) - 1) << N, this[this.t++] = Y >> this.DB - N) : this[this.t - 1] |= Y << N, N += I, N >= this.DB && (N -= this.DB);
    }
    I == 8 && T[0] & 128 && (this.s = -1, N > 0 && (this[this.t - 1] |= (1 << this.DB - N) - 1 << N)), this.clamp(), M && f.ZERO.subTo(this, this);
  }
  function k() {
    for (var T = this.s & this.DM; this.t > 0 && this[this.t - 1] == T; )
      --this.t;
  }
  function H(T) {
    if (this.s < 0)
      return "-" + this.negate().toString(T);
    var C;
    if (T == 16)
      C = 4;
    else if (T == 8)
      C = 3;
    else if (T == 2)
      C = 1;
    else if (T == 32)
      C = 5;
    else if (T == 4)
      C = 2;
    else
      return this.toRadix(T);
    var I = (1 << C) - 1, R, M = !1, N = "", Y = this.t, q = this.DB - Y * this.DB % C;
    if (Y-- > 0)
      for (q < this.DB && (R = this[Y] >> q) > 0 && (M = !0, N = S(R)); Y >= 0; )
        q < C ? (R = (this[Y] & (1 << q) - 1) << C - q, R |= this[--Y] >> (q += this.DB - C)) : (R = this[Y] >> (q -= C) & I, q <= 0 && (q += this.DB, --Y)), R > 0 && (M = !0), M && (N += S(R));
    return M ? N : "0";
  }
  function B() {
    var T = d();
    return f.ZERO.subTo(this, T), T;
  }
  function x() {
    return this.s < 0 ? this.negate() : this;
  }
  function D(T) {
    var C = this.s - T.s;
    if (C != 0)
      return C;
    var I = this.t;
    if (C = I - T.t, C != 0)
      return this.s < 0 ? -C : C;
    for (; --I >= 0; )
      if ((C = this[I] - T[I]) != 0)
        return C;
    return 0;
  }
  function w(T) {
    var C = 1, I;
    return (I = T >>> 16) != 0 && (T = I, C += 16), (I = T >> 8) != 0 && (T = I, C += 8), (I = T >> 4) != 0 && (T = I, C += 4), (I = T >> 2) != 0 && (T = I, C += 2), (I = T >> 1) != 0 && (T = I, C += 1), C;
  }
  function $() {
    return this.t <= 0 ? 0 : this.DB * (this.t - 1) + w(this[this.t - 1] ^ this.s & this.DM);
  }
  function X(T, C) {
    var I;
    for (I = this.t - 1; I >= 0; --I)
      C[I + T] = this[I];
    for (I = T - 1; I >= 0; --I)
      C[I] = 0;
    C.t = this.t + T, C.s = this.s;
  }
  function V(T, C) {
    for (var I = T; I < this.t; ++I)
      C[I - T] = this[I];
    C.t = Math.max(this.t - T, 0), C.s = this.s;
  }
  function F(T, C) {
    var I = T % this.DB, R = this.DB - I, M = (1 << R) - 1, N = Math.floor(T / this.DB), Y = this.s << I & this.DM, q;
    for (q = this.t - 1; q >= 0; --q)
      C[q + N + 1] = this[q] >> R | Y, Y = (this[q] & M) << I;
    for (q = N - 1; q >= 0; --q)
      C[q] = 0;
    C[N] = Y, C.t = this.t + N + 1, C.s = this.s, C.clamp();
  }
  function le(T, C) {
    C.s = this.s;
    var I = Math.floor(T / this.DB);
    if (I >= this.t) {
      C.t = 0;
      return;
    }
    var R = T % this.DB, M = this.DB - R, N = (1 << R) - 1;
    C[0] = this[I] >> R;
    for (var Y = I + 1; Y < this.t; ++Y)
      C[Y - I - 1] |= (this[Y] & N) << M, C[Y - I] = this[Y] >> R;
    R > 0 && (C[this.t - I - 1] |= (this.s & N) << M), C.t = this.t - I, C.clamp();
  }
  function ae(T, C) {
    for (var I = 0, R = 0, M = Math.min(T.t, this.t); I < M; )
      R += this[I] - T[I], C[I++] = R & this.DM, R >>= this.DB;
    if (T.t < this.t) {
      for (R -= T.s; I < this.t; )
        R += this[I], C[I++] = R & this.DM, R >>= this.DB;
      R += this.s;
    } else {
      for (R += this.s; I < T.t; )
        R -= T[I], C[I++] = R & this.DM, R >>= this.DB;
      R -= T.s;
    }
    C.s = R < 0 ? -1 : 0, R < -1 ? C[I++] = this.DV + R : R > 0 && (C[I++] = R), C.t = I, C.clamp();
  }
  function ne(T, C) {
    var I = this.abs(), R = T.abs(), M = I.t;
    for (C.t = M + R.t; --M >= 0; )
      C[M] = 0;
    for (M = 0; M < R.t; ++M)
      C[M + I.t] = I.am(0, R[M], C, M, 0, I.t);
    C.s = 0, C.clamp(), this.s != T.s && f.ZERO.subTo(C, C);
  }
  function ve(T) {
    for (var C = this.abs(), I = T.t = 2 * C.t; --I >= 0; )
      T[I] = 0;
    for (I = 0; I < C.t - 1; ++I) {
      var R = C.am(I, C[I], T, 2 * I, 0, 1);
      (T[I + C.t] += C.am(I + 1, 2 * C[I], T, 2 * I + 1, R, C.t - I - 1)) >= C.DV && (T[I + C.t] -= C.DV, T[I + C.t + 1] = 1);
    }
    T.t > 0 && (T[T.t - 1] += C.am(I, C[I], T, 2 * I, 0, 1)), T.s = 0, T.clamp();
  }
  function Ie(T, C, I) {
    var R = T.abs();
    if (!(R.t <= 0)) {
      var M = this.abs();
      if (M.t < R.t) {
        C != null && C.fromInt(0), I != null && this.copyTo(I);
        return;
      }
      I == null && (I = d());
      var N = d(), Y = this.s, q = T.s, oe = this.DB - w(R[R.t - 1]);
      oe > 0 ? (R.lShiftTo(oe, N), M.lShiftTo(oe, I)) : (R.copyTo(N), M.copyTo(I));
      var J = N.t, de = N[J - 1];
      if (de != 0) {
        var se = de * (1 << this.F1) + (J > 1 ? N[J - 2] >> this.F2 : 0), j = this.FV / se, ee = (1 << this.F1) / se, W = 1 << this.F2, re = I.t, ce = re - J, me = C ?? d();
        for (N.dlShiftTo(ce, me), I.compareTo(me) >= 0 && (I[I.t++] = 1, I.subTo(me, I)), f.ONE.dlShiftTo(J, me), me.subTo(N, N); N.t < J; )
          N[N.t++] = 0;
        for (; --ce >= 0; ) {
          var Ve = I[--re] == de ? this.DM : Math.floor(I[re] * j + (I[re - 1] + W) * ee);
          if ((I[re] += N.am(0, Ve, I, ce, 0, J)) < Ve)
            for (N.dlShiftTo(ce, me), I.subTo(me, I); I[re] < --Ve; )
              I.subTo(me, I);
        }
        C != null && (I.drShiftTo(J, C), Y != q && f.ZERO.subTo(C, C)), I.t = J, I.clamp(), oe > 0 && I.rShiftTo(oe, I), Y < 0 && f.ZERO.subTo(I, I);
      }
    }
  }
  function Oe(T) {
    var C = d();
    return this.abs().divRemTo(T, null, C), this.s < 0 && C.compareTo(f.ZERO) > 0 && T.subTo(C, C), C;
  }
  function xe(T) {
    this.m = T;
  }
  function ze(T) {
    return T.s < 0 || T.compareTo(this.m) >= 0 ? T.mod(this.m) : T;
  }
  function qe(T) {
    return T;
  }
  function Je(T) {
    T.divRemTo(this.m, null, T);
  }
  function Be(T, C, I) {
    T.multiplyTo(C, I), this.reduce(I);
  }
  function We(T, C) {
    T.squareTo(C), this.reduce(C);
  }
  xe.prototype.convert = ze, xe.prototype.revert = qe, xe.prototype.reduce = Je, xe.prototype.mulTo = Be, xe.prototype.sqrTo = We;
  function Ne() {
    if (this.t < 1)
      return 0;
    var T = this[0];
    if (!(T & 1))
      return 0;
    var C = T & 3;
    return C = C * (2 - (T & 15) * C) & 15, C = C * (2 - (T & 255) * C) & 255, C = C * (2 - ((T & 65535) * C & 65535)) & 65535, C = C * (2 - T * C % this.DV) % this.DV, C > 0 ? this.DV - C : -C;
  }
  function je(T) {
    this.m = T, this.mp = T.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << T.DB - 15) - 1, this.mt2 = 2 * T.t;
  }
  function et(T) {
    var C = d();
    return T.abs().dlShiftTo(this.m.t, C), C.divRemTo(this.m, null, C), T.s < 0 && C.compareTo(f.ZERO) > 0 && this.m.subTo(C, C), C;
  }
  function St(T) {
    var C = d();
    return T.copyTo(C), this.reduce(C), C;
  }
  function Ot(T) {
    for (; T.t <= this.mt2; )
      T[T.t++] = 0;
    for (var C = 0; C < this.m.t; ++C) {
      var I = T[C] & 32767, R = I * this.mpl + ((I * this.mph + (T[C] >> 15) * this.mpl & this.um) << 15) & T.DM;
      for (I = C + this.m.t, T[I] += this.m.am(0, R, T, C, 0, this.m.t); T[I] >= T.DV; )
        T[I] -= T.DV, T[++I]++;
    }
    T.clamp(), T.drShiftTo(this.m.t, T), T.compareTo(this.m) >= 0 && T.subTo(this.m, T);
  }
  function we(T, C) {
    T.squareTo(C), this.reduce(C);
  }
  function De(T, C, I) {
    T.multiplyTo(C, I), this.reduce(I);
  }
  je.prototype.convert = et, je.prototype.revert = St, je.prototype.reduce = Ot, je.prototype.mulTo = De, je.prototype.sqrTo = we;
  function Ee() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
  }
  function te(T, C) {
    if (T > 4294967295 || T < 1)
      return f.ONE;
    var I = d(), R = d(), M = C.convert(this), N = w(T) - 1;
    for (M.copyTo(I); --N >= 0; )
      if (C.sqrTo(I, R), (T & 1 << N) > 0)
        C.mulTo(R, M, I);
      else {
        var Y = I;
        I = R, R = Y;
      }
    return C.revert(I);
  }
  function ue(T, C) {
    var I;
    return T < 256 || C.isEven() ? I = new xe(C) : I = new je(C), this.exp(T, I);
  }
  f.prototype.copyTo = O, f.prototype.fromInt = P, f.prototype.fromString = z, f.prototype.clamp = k, f.prototype.dlShiftTo = X, f.prototype.drShiftTo = V, f.prototype.lShiftTo = F, f.prototype.rShiftTo = le, f.prototype.subTo = ae, f.prototype.multiplyTo = ne, f.prototype.squareTo = ve, f.prototype.divRemTo = Ie, f.prototype.invDigit = Ne, f.prototype.isEven = Ee, f.prototype.exp = te, f.prototype.toString = H, f.prototype.negate = B, f.prototype.abs = x, f.prototype.compareTo = D, f.prototype.bitLength = $, f.prototype.mod = Oe, f.prototype.modPowInt = ue, f.ZERO = U(0), f.ONE = U(1);
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  function ye() {
    var T = d();
    return this.copyTo(T), T;
  }
  function Le() {
    if (this.s < 0) {
      if (this.t == 1)
        return this[0] - this.DV;
      if (this.t == 0)
        return -1;
    } else {
      if (this.t == 1)
        return this[0];
      if (this.t == 0)
        return 0;
    }
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
  }
  function Me() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
  }
  function Ae() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
  }
  function ie(T) {
    return Math.floor(Math.LN2 * this.DB / Math.log(T));
  }
  function K() {
    return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this[0] <= 0 ? 0 : 1;
  }
  function Z(T) {
    if (T == null && (T = 10), this.signum() == 0 || T < 2 || T > 36)
      return "0";
    var C = this.chunkSize(T), I = Math.pow(T, C), R = U(I), M = d(), N = d(), Y = "";
    for (this.divRemTo(R, M, N); M.signum() > 0; )
      Y = (I + N.intValue()).toString(T).substr(1) + Y, M.divRemTo(R, M, N);
    return N.intValue().toString(T) + Y;
  }
  function Ce(T, C) {
    this.fromInt(0), C == null && (C = 10);
    for (var I = this.chunkSize(C), R = Math.pow(C, I), M = !1, N = 0, Y = 0, q = 0; q < T.length; ++q) {
      var oe = A(T, q);
      if (oe < 0) {
        T.charAt(q) == "-" && this.signum() == 0 && (M = !0);
        continue;
      }
      Y = C * Y + oe, ++N >= I && (this.dMultiply(R), this.dAddOffset(Y, 0), N = 0, Y = 0);
    }
    N > 0 && (this.dMultiply(Math.pow(C, N)), this.dAddOffset(Y, 0)), M && f.ZERO.subTo(this, this);
  }
  function be(T, C, I) {
    if (typeof C == "number")
      if (T < 2)
        this.fromInt(1);
      else
        for (this.fromNumber(T, I), this.testBit(T - 1) || this.bitwiseTo(f.ONE.shiftLeft(T - 1), Zr, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(C); )
          this.dAddOffset(2, 0), this.bitLength() > T && this.subTo(f.ONE.shiftLeft(T - 1), this);
    else {
      var R = new Array(), M = T & 7;
      R.length = (T >> 3) + 1, C.nextBytes(R), M > 0 ? R[0] &= (1 << M) - 1 : R[0] = 0, this.fromString(R, 256);
    }
  }
  function Ge() {
    var T = this.t, C = new Array();
    C[0] = this.s;
    var I = this.DB - T * this.DB % 8, R, M = 0;
    if (T-- > 0)
      for (I < this.DB && (R = this[T] >> I) != (this.s & this.DM) >> I && (C[M++] = R | this.s << this.DB - I); T >= 0; )
        I < 8 ? (R = (this[T] & (1 << I) - 1) << 8 - I, R |= this[--T] >> (I += this.DB - 8)) : (R = this[T] >> (I -= 8) & 255, I <= 0 && (I += this.DB, --T)), R & 128 && (R |= -256), M == 0 && (this.s & 128) != (R & 128) && ++M, (M > 0 || R != this.s) && (C[M++] = R);
    return C;
  }
  function st(T) {
    return this.compareTo(T) == 0;
  }
  function wt(T) {
    return this.compareTo(T) < 0 ? this : T;
  }
  function Bt(T) {
    return this.compareTo(T) > 0 ? this : T;
  }
  function jt(T, C, I) {
    var R, M, N = Math.min(T.t, this.t);
    for (R = 0; R < N; ++R)
      I[R] = C(this[R], T[R]);
    if (T.t < this.t) {
      for (M = T.s & this.DM, R = N; R < this.t; ++R)
        I[R] = C(this[R], M);
      I.t = this.t;
    } else {
      for (M = this.s & this.DM, R = N; R < T.t; ++R)
        I[R] = C(M, T[R]);
      I.t = T.t;
    }
    I.s = C(this.s, T.s), I.clamp();
  }
  function Xt(T, C) {
    return T & C;
  }
  function Qt(T) {
    var C = d();
    return this.bitwiseTo(T, Xt, C), C;
  }
  function Zr(T, C) {
    return T | C;
  }
  function Jn(T) {
    var C = d();
    return this.bitwiseTo(T, Zr, C), C;
  }
  function Ur(T, C) {
    return T ^ C;
  }
  function fn(T) {
    var C = d();
    return this.bitwiseTo(T, Ur, C), C;
  }
  function gn(T, C) {
    return T & ~C;
  }
  function cr(T) {
    var C = d();
    return this.bitwiseTo(T, gn, C), C;
  }
  function Ri() {
    for (var T = d(), C = 0; C < this.t; ++C)
      T[C] = this.DM & ~this[C];
    return T.t = this.t, T.s = ~this.s, T;
  }
  function ai(T) {
    var C = d();
    return T < 0 ? this.rShiftTo(-T, C) : this.lShiftTo(T, C), C;
  }
  function vo(T) {
    var C = d();
    return T < 0 ? this.lShiftTo(-T, C) : this.rShiftTo(T, C), C;
  }
  function to(T) {
    if (T == 0)
      return -1;
    var C = 0;
    return T & 65535 || (T >>= 16, C += 16), T & 255 || (T >>= 8, C += 8), T & 15 || (T >>= 4, C += 4), T & 3 || (T >>= 2, C += 2), T & 1 || ++C, C;
  }
  function Ui() {
    for (var T = 0; T < this.t; ++T)
      if (this[T] != 0)
        return T * this.DB + to(this[T]);
    return this.s < 0 ? this.t * this.DB : -1;
  }
  function Gu(T) {
    for (var C = 0; T != 0; )
      T &= T - 1, ++C;
    return C;
  }
  function Rs() {
    for (var T = 0, C = this.s & this.DM, I = 0; I < this.t; ++I)
      T += Gu(this[I] ^ C);
    return T;
  }
  function Wu(T) {
    var C = Math.floor(T / this.DB);
    return C >= this.t ? this.s != 0 : (this[C] & 1 << T % this.DB) != 0;
  }
  function Ku(T, C) {
    var I = f.ONE.shiftLeft(T);
    return this.bitwiseTo(I, C, I), I;
  }
  function Ca(T) {
    return this.changeBit(T, Zr);
  }
  function Dn(T) {
    return this.changeBit(T, gn);
  }
  function Xu(T) {
    return this.changeBit(T, Ur);
  }
  function Ze(T, C) {
    for (var I = 0, R = 0, M = Math.min(T.t, this.t); I < M; )
      R += this[I] + T[I], C[I++] = R & this.DM, R >>= this.DB;
    if (T.t < this.t) {
      for (R += T.s; I < this.t; )
        R += this[I], C[I++] = R & this.DM, R >>= this.DB;
      R += this.s;
    } else {
      for (R += this.s; I < T.t; )
        R += T[I], C[I++] = R & this.DM, R >>= this.DB;
      R += T.s;
    }
    C.s = R < 0 ? -1 : 0, R > 0 ? C[I++] = R : R < -1 && (C[I++] = this.DV + R), C.t = I, C.clamp();
  }
  function kt(T) {
    var C = d();
    return this.addTo(T, C), C;
  }
  function qt(T) {
    var C = d();
    return this.subTo(T, C), C;
  }
  function sr(T) {
    var C = d();
    return this.multiplyTo(T, C), C;
  }
  function Mr() {
    var T = d();
    return this.squareTo(T), T;
  }
  function ht(T) {
    var C = d();
    return this.divRemTo(T, C, null), C;
  }
  function Pe(T) {
    var C = d();
    return this.divRemTo(T, null, C), C;
  }
  function Fe(T) {
    var C = d(), I = d();
    return this.divRemTo(T, C, I), new Array(C, I);
  }
  function Ye(T) {
    this[this.t] = this.am(0, T - 1, this, 0, 0, this.t), ++this.t, this.clamp();
  }
  function Xe(T, C) {
    if (T != 0) {
      for (; this.t <= C; )
        this[this.t++] = 0;
      for (this[C] += T; this[C] >= this.DV; )
        this[C] -= this.DV, ++C >= this.t && (this[this.t++] = 0), ++this[C];
    }
  }
  function dt() {
  }
  function Nt(T) {
    return T;
  }
  function er(T, C, I) {
    T.multiplyTo(C, I);
  }
  function Sr(T, C) {
    T.squareTo(C);
  }
  dt.prototype.convert = Nt, dt.prototype.revert = Nt, dt.prototype.mulTo = er, dt.prototype.sqrTo = Sr;
  function Fr(T) {
    return this.exp(T, new dt());
  }
  function ro(T, C, I) {
    var R = Math.min(this.t + T.t, C);
    for (I.s = 0, I.t = R; R > 0; )
      I[--R] = 0;
    var M;
    for (M = I.t - this.t; R < M; ++R)
      I[R + this.t] = this.am(0, T[R], I, R, 0, this.t);
    for (M = Math.min(T.t, C); R < M; ++R)
      this.am(0, T[R], I, R, 0, C - R);
    I.clamp();
  }
  function Eo(T, C, I) {
    --C;
    var R = I.t = this.t + T.t - C;
    for (I.s = 0; --R >= 0; )
      I[R] = 0;
    for (R = Math.max(C - this.t, 0); R < T.t; ++R)
      I[this.t + R - C] = this.am(C - R, T[R], I, 0, 0, this.t + R - C);
    I.clamp(), I.drShiftTo(1, I);
  }
  function Ti(T) {
    this.r2 = d(), this.q3 = d(), f.ONE.dlShiftTo(2 * T.t, this.r2), this.mu = this.r2.divide(T), this.m = T;
  }
  function Ya(T) {
    if (T.s < 0 || T.t > 2 * this.m.t)
      return T.mod(this.m);
    if (T.compareTo(this.m) < 0)
      return T;
    var C = d();
    return T.copyTo(C), this.reduce(C), C;
  }
  function ws(T) {
    return T;
  }
  function yl(T) {
    for (T.drShiftTo(this.m.t - 1, this.r2), T.t > this.m.t + 1 && (T.t = this.m.t + 1, T.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); T.compareTo(this.r2) < 0; )
      T.dAddOffset(1, this.m.t + 1);
    for (T.subTo(this.r2, T); T.compareTo(this.m) >= 0; )
      T.subTo(this.m, T);
  }
  function f_(T, C) {
    T.squareTo(C), this.reduce(C);
  }
  function P2(T, C, I) {
    T.multiplyTo(C, I), this.reduce(I);
  }
  Ti.prototype.convert = Ya, Ti.prototype.revert = ws, Ti.prototype.reduce = yl, Ti.prototype.mulTo = P2, Ti.prototype.sqrTo = f_;
  function D2(T, C) {
    var I = T.bitLength(), R, M = U(1), N;
    if (I <= 0)
      return M;
    I < 18 ? R = 1 : I < 48 ? R = 3 : I < 144 ? R = 4 : I < 768 ? R = 5 : R = 6, I < 8 ? N = new xe(C) : C.isEven() ? N = new Ti(C) : N = new je(C);
    var Y = new Array(), q = 3, oe = R - 1, J = (1 << R) - 1;
    if (Y[1] = N.convert(this), R > 1) {
      var de = d();
      for (N.sqrTo(Y[1], de); q <= J; )
        Y[q] = d(), N.mulTo(de, Y[q - 2], Y[q]), q += 2;
    }
    var se = T.t - 1, j, ee = !0, W = d(), re;
    for (I = w(T[se]) - 1; se >= 0; ) {
      for (I >= oe ? j = T[se] >> I - oe & J : (j = (T[se] & (1 << I + 1) - 1) << oe - I, se > 0 && (j |= T[se - 1] >> this.DB + I - oe)), q = R; !(j & 1); )
        j >>= 1, --q;
      if ((I -= q) < 0 && (I += this.DB, --se), ee)
        Y[j].copyTo(M), ee = !1;
      else {
        for (; q > 1; )
          N.sqrTo(M, W), N.sqrTo(W, M), q -= 2;
        q > 0 ? N.sqrTo(M, W) : (re = M, M = W, W = re), N.mulTo(W, Y[j], M);
      }
      for (; se >= 0 && !(T[se] & 1 << I); )
        N.sqrTo(M, W), re = M, M = W, W = re, --I < 0 && (I = this.DB - 1, --se);
    }
    return N.revert(M);
  }
  function x2(T) {
    var C = this.s < 0 ? this.negate() : this.clone(), I = T.s < 0 ? T.negate() : T.clone();
    if (C.compareTo(I) < 0) {
      var R = C;
      C = I, I = R;
    }
    var M = C.getLowestSetBit(), N = I.getLowestSetBit();
    if (N < 0)
      return C;
    for (M < N && (N = M), N > 0 && (C.rShiftTo(N, C), I.rShiftTo(N, I)); C.signum() > 0; )
      (M = C.getLowestSetBit()) > 0 && C.rShiftTo(M, C), (M = I.getLowestSetBit()) > 0 && I.rShiftTo(M, I), C.compareTo(I) >= 0 ? (C.subTo(I, C), C.rShiftTo(1, C)) : (I.subTo(C, I), I.rShiftTo(1, I));
    return N > 0 && I.lShiftTo(N, I), I;
  }
  function Od(T) {
    if (T <= 0)
      return 0;
    var C = this.DV % T, I = this.s < 0 ? T - 1 : 0;
    if (this.t > 0)
      if (C == 0)
        I = this[0] % T;
      else
        for (var R = this.t - 1; R >= 0; --R)
          I = (C * I + this[R]) % T;
    return I;
  }
  function d_(T) {
    var C = T.isEven();
    if (this.isEven() && C || T.signum() == 0)
      return f.ZERO;
    for (var I = T.clone(), R = this.clone(), M = U(1), N = U(0), Y = U(0), q = U(1); I.signum() != 0; ) {
      for (; I.isEven(); )
        I.rShiftTo(1, I), C ? ((!M.isEven() || !N.isEven()) && (M.addTo(this, M), N.subTo(T, N)), M.rShiftTo(1, M)) : N.isEven() || N.subTo(T, N), N.rShiftTo(1, N);
      for (; R.isEven(); )
        R.rShiftTo(1, R), C ? ((!Y.isEven() || !q.isEven()) && (Y.addTo(this, Y), q.subTo(T, q)), Y.rShiftTo(1, Y)) : q.isEven() || q.subTo(T, q), q.rShiftTo(1, q);
      I.compareTo(R) >= 0 ? (I.subTo(R, I), C && M.subTo(Y, M), N.subTo(q, N)) : (R.subTo(I, R), C && Y.subTo(M, Y), q.subTo(N, q));
    }
    if (R.compareTo(f.ONE) != 0)
      return f.ZERO;
    if (q.compareTo(T) >= 0)
      return q.subtract(T);
    if (q.signum() < 0)
      q.addTo(T, q);
    else
      return q;
    return q.signum() < 0 ? q.add(T) : q;
  }
  var mo = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], N2 = (1 << 26) / mo[mo.length - 1];
  function L2(T) {
    var C, I = this.abs();
    if (I.t == 1 && I[0] <= mo[mo.length - 1]) {
      for (C = 0; C < mo.length; ++C)
        if (I[0] == mo[C])
          return !0;
      return !1;
    }
    if (I.isEven())
      return !1;
    for (C = 1; C < mo.length; ) {
      for (var R = mo[C], M = C + 1; M < mo.length && R < N2; )
        R *= mo[M++];
      for (R = I.modInt(R); C < M; )
        if (R % mo[C++] == 0)
          return !1;
    }
    return I.millerRabin(T);
  }
  function B2(T) {
    var C = this.subtract(f.ONE), I = C.getLowestSetBit();
    if (I <= 0)
      return !1;
    var R = C.shiftRight(I);
    T = T + 1 >> 1, T > mo.length && (T = mo.length);
    for (var M = d(), N = 0; N < T; ++N) {
      M.fromInt(mo[Math.floor(Math.random() * mo.length)]);
      var Y = M.modPow(R, this);
      if (Y.compareTo(f.ONE) != 0 && Y.compareTo(C) != 0) {
        for (var q = 1; q++ < I && Y.compareTo(C) != 0; )
          if (Y = Y.modPowInt(2, this), Y.compareTo(f.ONE) == 0)
            return !1;
        if (Y.compareTo(C) != 0)
          return !1;
      }
    }
    return !0;
  }
  f.prototype.chunkSize = ie, f.prototype.toRadix = Z, f.prototype.fromRadix = Ce, f.prototype.fromNumber = be, f.prototype.bitwiseTo = jt, f.prototype.changeBit = Ku, f.prototype.addTo = Ze, f.prototype.dMultiply = Ye, f.prototype.dAddOffset = Xe, f.prototype.multiplyLowerTo = ro, f.prototype.multiplyUpperTo = Eo, f.prototype.modInt = Od, f.prototype.millerRabin = B2, f.prototype.clone = ye, f.prototype.intValue = Le, f.prototype.byteValue = Me, f.prototype.shortValue = Ae, f.prototype.signum = K, f.prototype.toByteArray = Ge, f.prototype.equals = st, f.prototype.min = wt, f.prototype.max = Bt, f.prototype.and = Qt, f.prototype.or = Jn, f.prototype.xor = fn, f.prototype.andNot = cr, f.prototype.not = Ri, f.prototype.shiftLeft = ai, f.prototype.shiftRight = vo, f.prototype.getLowestSetBit = Ui, f.prototype.bitCount = Rs, f.prototype.testBit = Wu, f.prototype.setBit = Ca, f.prototype.clearBit = Dn, f.prototype.flipBit = Xu, f.prototype.add = kt, f.prototype.subtract = qt, f.prototype.multiply = sr, f.prototype.divide = ht, f.prototype.remainder = Pe, f.prototype.divideAndRemainder = Fe, f.prototype.modPow = D2, f.prototype.modInverse = d_, f.prototype.pow = Fr, f.prototype.gcd = x2, f.prototype.isProbablePrime = L2, f.prototype.square = Mr;
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  function fv() {
    this.i = 0, this.j = 0, this.S = new Array();
  }
  function p_(T) {
    var C, I, R;
    for (C = 0; C < 256; ++C)
      this.S[C] = C;
    for (I = 0, C = 0; C < 256; ++C)
      I = I + this.S[C] + T[C % T.length] & 255, R = this.S[C], this.S[C] = this.S[I], this.S[I] = R;
    this.i = 0, this.j = 0;
  }
  function h_() {
    var T;
    return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, T = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = T, this.S[T + this.S[this.i] & 255];
  }
  fv.prototype.init = p_, fv.prototype.next = h_;
  function Sc() {
    return new fv();
  }
  var Rd = 256;
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  var dv, sa, no;
  function k2(T) {
    sa[no++] ^= T & 255, sa[no++] ^= T >> 8 & 255, sa[no++] ^= T >> 16 & 255, sa[no++] ^= T >> 24 & 255, no >= Rd && (no -= Rd);
  }
  function pv() {
    k2((/* @__PURE__ */ new Date()).getTime());
  }
  if (sa == null) {
    sa = new Array(), no = 0;
    var Ga;
    if (t !== void 0 && (t.crypto !== void 0 || t.msCrypto !== void 0)) {
      var v_ = t.crypto || t.msCrypto;
      if (v_.getRandomValues) {
        var hv = new Uint8Array(32);
        for (v_.getRandomValues(hv), Ga = 0; Ga < 32; ++Ga)
          sa[no++] = hv[Ga];
      } else if (e.appName == "Netscape" && e.appVersion < "5") {
        var S0 = t.crypto.random(32);
        for (Ga = 0; Ga < S0.length; ++Ga)
          sa[no++] = S0.charCodeAt(Ga) & 255;
      }
    }
    for (; no < Rd; )
      Ga = Math.floor(65536 * Math.random()), sa[no++] = Ga >>> 8, sa[no++] = Ga & 255;
    no = 0, pv();
  }
  function E_() {
    if (dv == null) {
      for (pv(), dv = Sc(), dv.init(sa), no = 0; no < sa.length; ++no)
        sa[no] = 0;
      no = 0;
    }
    return dv.next();
  }
  function M2(T) {
    var C;
    for (C = 0; C < T.length; ++C)
      T[C] = E_();
  }
  function bc() {
  }
  bc.prototype.nextBytes = M2;
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  function Yo(T, C) {
    return new f(T, C);
  }
  function Er() {
    this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
  }
  function vv(T, C) {
    if (this.isPublic = !0, this.isPrivate = !1, typeof T != "string")
      this.n = T, this.e = C;
    else if (T != null && C != null && T.length > 0 && C.length > 0)
      this.n = Yo(T, 16), this.e = parseInt(C, 16);
    else
      throw "Invalid RSA public key";
  }
  function wd(T) {
    return T.modPowInt(this.e, this.n);
  }
  Er.prototype.doPublic = wd, Er.prototype.setPublic = vv, Er.prototype.type = "RSA";
  function F2(T, C, I) {
    if (this.isPrivate = !0, typeof T != "string")
      this.n = T, this.e = C, this.d = I;
    else if (T != null && C != null && T.length > 0 && C.length > 0)
      this.n = Yo(T, 16), this.e = parseInt(C, 16), this.d = Yo(I, 16);
    else
      throw "Invalid RSA private key";
  }
  function H2(T, C, I, R, M, N, Y, q) {
    if (this.isPrivate = !0, this.isPublic = !1, T == null)
      throw "RSASetPrivateEx N == null";
    if (C == null)
      throw "RSASetPrivateEx E == null";
    if (T.length == 0)
      throw "RSASetPrivateEx N.length == 0";
    if (C.length == 0)
      throw "RSASetPrivateEx E.length == 0";
    if (T != null && C != null && T.length > 0 && C.length > 0)
      this.n = Yo(T, 16), this.e = parseInt(C, 16), this.d = Yo(I, 16), this.p = Yo(R, 16), this.q = Yo(M, 16), this.dmp1 = Yo(N, 16), this.dmq1 = Yo(Y, 16), this.coeff = Yo(q, 16);
    else
      throw "Invalid RSA private key in RSASetPrivateEx";
  }
  function $2(T, C) {
    var I = new bc(), R = T >> 1;
    this.e = parseInt(C, 16);
    for (var M = new f(C, 16), N = T / 2 - 100, Y = f.ONE.shiftLeft(N); ; ) {
      for (; this.p = new f(T - R, 1, I), !(this.p.subtract(f.ONE).gcd(M).compareTo(f.ONE) == 0 && this.p.isProbablePrime(10)); )
        ;
      for (; this.q = new f(R, 1, I), !(this.q.subtract(f.ONE).gcd(M).compareTo(f.ONE) == 0 && this.q.isProbablePrime(10)); )
        ;
      if (this.p.compareTo(this.q) <= 0) {
        var q = this.p;
        this.p = this.q, this.q = q;
      }
      var oe = this.q.subtract(this.p).abs();
      if (!(oe.bitLength() < N || oe.compareTo(Y) <= 0)) {
        var J = this.p.subtract(f.ONE), de = this.q.subtract(f.ONE), se = J.multiply(de);
        if (se.gcd(M).compareTo(f.ONE) == 0 && (this.n = this.p.multiply(this.q), this.n.bitLength() == T)) {
          this.d = M.modInverse(se), this.dmp1 = this.d.mod(J), this.dmq1 = this.d.mod(de), this.coeff = this.q.modInverse(this.p);
          break;
        }
      }
    }
    this.isPrivate = !0;
  }
  function Ev(T) {
    if (this.p == null || this.q == null)
      return T.modPow(this.d, this.n);
    for (var C = T.mod(this.p).modPow(this.dmp1, this.p), I = T.mod(this.q).modPow(this.dmq1, this.q); C.compareTo(I) < 0; )
      C = C.add(this.p);
    return C.subtract(I).multiply(this.coeff).mod(this.p).multiply(this.q).add(I);
  }
  Er.prototype.doPrivate = Ev, Er.prototype.setPrivate = F2, Er.prototype.setPrivateEx = H2, Er.prototype.generate = $2;
  /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
   */
  function yi(T, C) {
    this.x = C, this.q = T;
  }
  function U2(T) {
    return T == this ? !0 : this.q.equals(T.q) && this.x.equals(T.x);
  }
  function m_() {
    return this.x;
  }
  function mv() {
    return new yi(this.q, this.x.negate().mod(this.q));
  }
  function g_(T) {
    return new yi(this.q, this.x.add(T.toBigInteger()).mod(this.q));
  }
  function T_(T) {
    return new yi(this.q, this.x.subtract(T.toBigInteger()).mod(this.q));
  }
  function Pd(T) {
    return new yi(this.q, this.x.multiply(T.toBigInteger()).mod(this.q));
  }
  function y_() {
    return new yi(this.q, this.x.square().mod(this.q));
  }
  function V2(T) {
    return new yi(this.q, this.x.multiply(T.toBigInteger().modInverse(this.q)).mod(this.q));
  }
  yi.prototype.equals = U2, yi.prototype.toBigInteger = m_, yi.prototype.negate = mv, yi.prototype.add = g_, yi.prototype.subtract = T_, yi.prototype.multiply = Pd, yi.prototype.square = y_, yi.prototype.divide = V2, yi.prototype.sqrt = function() {
    return new yi(this.q, this.x.sqrt().mod(this.q));
  };
  function qr(T, C, I, R) {
    this.curve = T, this.x = C, this.y = I, R == null ? this.z = f.ONE : this.z = R, this.zinv = null;
  }
  function gu() {
    return this.zinv == null && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
  }
  function Dd() {
    return this.zinv == null && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
  }
  function xd(T) {
    if (T == this)
      return !0;
    if (this.isInfinity())
      return T.isInfinity();
    if (T.isInfinity())
      return this.isInfinity();
    var C, I;
    return C = T.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(T.z)).mod(this.curve.q), C.equals(f.ZERO) ? (I = T.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(T.z)).mod(this.curve.q), I.equals(f.ZERO)) : !1;
  }
  function gv() {
    return this.x == null && this.y == null ? !0 : this.z.equals(f.ZERO) && !this.y.toBigInteger().equals(f.ZERO);
  }
  function j2() {
    return new qr(this.curve, this.x, this.y.negate(), this.z);
  }
  function z2(T) {
    if (this.isInfinity())
      return T;
    if (T.isInfinity())
      return this;
    var C = T.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(T.z)).mod(this.curve.q), I = T.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(T.z)).mod(this.curve.q);
    if (f.ZERO.equals(I))
      return f.ZERO.equals(C) ? this.twice() : this.curve.getInfinity();
    var R = new f("3"), M = this.x.toBigInteger(), N = this.y.toBigInteger();
    T.x.toBigInteger(), T.y.toBigInteger();
    var Y = I.square(), q = Y.multiply(I), oe = M.multiply(Y), J = C.square().multiply(this.z), de = J.subtract(oe.shiftLeft(1)).multiply(T.z).subtract(q).multiply(I).mod(this.curve.q), se = oe.multiply(R).multiply(C).subtract(N.multiply(q)).subtract(J.multiply(C)).multiply(T.z).add(C.multiply(q)).mod(this.curve.q), j = q.multiply(this.z).multiply(T.z).mod(this.curve.q);
    return new qr(this.curve, this.curve.fromBigInteger(de), this.curve.fromBigInteger(se), j);
  }
  function q2() {
    if (this.isInfinity())
      return this;
    if (this.y.toBigInteger().signum() == 0)
      return this.curve.getInfinity();
    var T = new f("3"), C = this.x.toBigInteger(), I = this.y.toBigInteger(), R = I.multiply(this.z), M = R.multiply(I).mod(this.curve.q), N = this.curve.a.toBigInteger(), Y = C.square().multiply(T);
    f.ZERO.equals(N) || (Y = Y.add(this.z.square().multiply(N))), Y = Y.mod(this.curve.q);
    var q = Y.square().subtract(C.shiftLeft(3).multiply(M)).shiftLeft(1).multiply(R).mod(this.curve.q), oe = Y.multiply(T).multiply(C).subtract(M.shiftLeft(1)).shiftLeft(2).multiply(M).subtract(Y.square().multiply(Y)).mod(this.curve.q), J = R.square().multiply(R).shiftLeft(3).mod(this.curve.q);
    return new qr(this.curve, this.curve.fromBigInteger(q), this.curve.fromBigInteger(oe), J);
  }
  function Tv(T) {
    if (this.isInfinity())
      return this;
    if (T.signum() == 0)
      return this.curve.getInfinity();
    var C = T, I = C.multiply(new f("3")), R = this.negate(), M = this, N = this.curve.q.subtract(T), Y = N.multiply(new f("3")), q = new qr(this.curve, this.x, this.y), oe = q.negate(), J;
    for (J = I.bitLength() - 2; J > 0; --J) {
      M = M.twice();
      var de = I.testBit(J), se = C.testBit(J);
      de != se && (M = M.add(de ? this : R));
    }
    for (J = Y.bitLength() - 2; J > 0; --J) {
      q = q.twice();
      var j = Y.testBit(J), ee = N.testBit(J);
      j != ee && (q = q.add(j ? q : oe));
    }
    return M;
  }
  function Y2(T, C, I) {
    var R;
    T.bitLength() > I.bitLength() ? R = T.bitLength() - 1 : R = I.bitLength() - 1;
    for (var M = this.curve.getInfinity(), N = this.add(C); R >= 0; )
      M = M.twice(), T.testBit(R) ? I.testBit(R) ? M = M.add(N) : M = M.add(this) : I.testBit(R) && (M = M.add(C)), --R;
    return M;
  }
  qr.prototype.getX = gu, qr.prototype.getY = Dd, qr.prototype.equals = xd, qr.prototype.isInfinity = gv, qr.prototype.negate = j2, qr.prototype.add = z2, qr.prototype.twice = q2, qr.prototype.multiply = Tv, qr.prototype.multiplyTwo = Y2;
  function Tu(T, C, I) {
    this.q = T, this.a = this.fromBigInteger(C), this.b = this.fromBigInteger(I), this.infinity = new qr(this, null, null);
  }
  function _i() {
    return this.q;
  }
  function he() {
    return this.a;
  }
  function _e() {
    return this.b;
  }
  function $e(T) {
    return T == this ? !0 : this.q.equals(T.q) && this.a.equals(T.a) && this.b.equals(T.b);
  }
  function Ue() {
    return this.infinity;
  }
  function rt(T) {
    return new yi(this.q, T);
  }
  function Et(T) {
    switch (parseInt(T.substr(0, 2), 16)) {
      case 0:
        return this.infinity;
      case 2:
      case 3:
        var C = T.substr(0, 2);
        T.substr(2);
        var I = this.fromBigInteger(new f(oe, 16)), R = this.getA(), M = this.getB(), N = I.square().add(R).multiply(I).add(M), Y = N.sqrt();
        return C == "03" && (Y = Y.negate()), new qr(this, I, Y);
      case 4:
      case 6:
      case 7:
        var q = (T.length - 2) / 2, oe = T.substr(2, q), J = T.substr(q + 2, q);
        return new qr(this, this.fromBigInteger(new f(oe, 16)), this.fromBigInteger(new f(J, 16)));
      default:
        return null;
    }
  }
  Tu.prototype.getQ = _i, Tu.prototype.getA = he, Tu.prototype.getB = _e, Tu.prototype.equals = $e, Tu.prototype.getInfinity = Ue, Tu.prototype.fromBigInteger = rt, Tu.prototype.decodePointHex = Et;
  /*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
   */
  yi.prototype.getByteLength = function() {
    return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
  }, qr.prototype.getEncoded = function(T) {
    var C = function(N, Y) {
      var q = N.toByteArrayUnsigned();
      if (Y < q.length)
        q = q.slice(q.length - Y);
      else
        for (; Y > q.length; )
          q.unshift(0);
      return q;
    }, I = this.getX().toBigInteger(), R = this.getY().toBigInteger(), M = C(I, 32);
    return T ? R.isEven() ? M.unshift(2) : M.unshift(3) : (M.unshift(4), M = M.concat(C(R, 32))), M;
  }, qr.decodeFrom = function(T, C) {
    C[0];
    var I = C.length - 1, R = C.slice(1, 1 + I / 2), M = C.slice(1 + I / 2, 1 + I);
    R.unshift(0), M.unshift(0);
    var N = new f(R), Y = new f(M);
    return new qr(T, T.fromBigInteger(N), T.fromBigInteger(Y));
  }, qr.decodeFromHex = function(T, C) {
    C.substr(0, 2);
    var I = C.length - 2, R = C.substr(2, I / 2), M = C.substr(2 + I / 2, I / 2), N = new f(R, 16), Y = new f(M, 16);
    return new qr(T, T.fromBigInteger(N), T.fromBigInteger(Y));
  }, qr.prototype.add2D = function(T) {
    if (this.isInfinity())
      return T;
    if (T.isInfinity())
      return this;
    if (this.x.equals(T.x))
      return this.y.equals(T.y) ? this.twice() : this.curve.getInfinity();
    var C = T.x.subtract(this.x), I = T.y.subtract(this.y), R = I.divide(C), M = R.square().subtract(this.x).subtract(T.x), N = R.multiply(this.x.subtract(M)).subtract(this.y);
    return new qr(this.curve, M, N);
  }, qr.prototype.twice2D = function() {
    if (this.isInfinity())
      return this;
    if (this.y.toBigInteger().signum() == 0)
      return this.curve.getInfinity();
    var T = this.curve.fromBigInteger(f.valueOf(2)), C = this.curve.fromBigInteger(f.valueOf(3)), I = this.x.square().multiply(C).add(this.curve.a).divide(this.y.multiply(T)), R = I.square().subtract(this.x.multiply(T)), M = I.multiply(this.x.subtract(R)).subtract(this.y);
    return new qr(this.curve, R, M);
  }, qr.prototype.multiply2D = function(T) {
    if (this.isInfinity())
      return this;
    if (T.signum() == 0)
      return this.curve.getInfinity();
    var C = T, I = C.multiply(new f("3")), R = this.negate(), M = this, N;
    for (N = I.bitLength() - 2; N > 0; --N) {
      M = M.twice();
      var Y = I.testBit(N), q = C.testBit(N);
      Y != q && (M = M.add2D(Y ? this : R));
    }
    return M;
  }, qr.prototype.isOnCurve = function() {
    var T = this.getX().toBigInteger(), C = this.getY().toBigInteger(), I = this.curve.getA().toBigInteger(), R = this.curve.getB().toBigInteger(), M = this.curve.getQ(), N = C.multiply(C).mod(M), Y = T.multiply(T).multiply(T).add(I.multiply(T)).add(R).mod(M);
    return N.equals(Y);
  }, qr.prototype.toString = function() {
    return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
  }, qr.prototype.validate = function() {
    var T = this.curve.getQ();
    if (this.isInfinity())
      throw new Error("Point is at infinity.");
    var C = this.getX().toBigInteger(), I = this.getY().toBigInteger();
    if (C.compareTo(f.ONE) < 0 || C.compareTo(T.subtract(f.ONE)) > 0)
      throw new Error("x coordinate out of bounds");
    if (I.compareTo(f.ONE) < 0 || I.compareTo(T.subtract(f.ONE)) > 0)
      throw new Error("y coordinate out of bounds");
    if (!this.isOnCurve())
      throw new Error("Point is not on the curve.");
    if (this.multiply(T).isInfinity())
      throw new Error("Point is not a scalar multiple of G.");
    return !0;
  };
  /*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
   */
  var gt = function() {
    var T = "(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)", C = '(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))', I = '(?:"' + C + '*")', R = new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|" + T + "|" + I + ")", "g"), M = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), N = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: `
`, r: "\r", t: "	" };
    function Y(de, se, j) {
      return se ? N[se] : String.fromCharCode(parseInt(j, 16));
    }
    var q = new String(""), oe = "\\", J = Object.hasOwnProperty;
    return function(de, se) {
      var j = de.match(R), ee, W = j[0], re = !1;
      W === "{" ? ee = {} : W === "[" ? ee = [] : (ee = [], re = !0);
      for (var ce, me = [ee], Ve = 1 - re, at = j.length; Ve < at; ++Ve) {
        W = j[Ve];
        var it;
        switch (W.charCodeAt(0)) {
          default:
            it = me[0], it[ce || it.length] = +W, ce = void 0;
            break;
          case 34:
            if (W = W.substring(1, W.length - 1), W.indexOf(oe) !== -1 && (W = W.replace(M, Y)), it = me[0], !ce)
              if (it instanceof Array)
                ce = it.length;
              else {
                ce = W || q;
                break;
              }
            it[ce] = W, ce = void 0;
            break;
          case 91:
            it = me[0], me.unshift(it[ce || it.length] = []), ce = void 0;
            break;
          case 93:
            me.shift();
            break;
          case 102:
            it = me[0], it[ce || it.length] = !1, ce = void 0;
            break;
          case 110:
            it = me[0], it[ce || it.length] = null, ce = void 0;
            break;
          case 116:
            it = me[0], it[ce || it.length] = !0, ce = void 0;
            break;
          case 123:
            it = me[0], me.unshift(it[ce || it.length] = {}), ce = void 0;
            break;
          case 125:
            me.shift();
            break;
        }
      }
      if (re) {
        if (me.length !== 1)
          throw new Error();
        ee = ee[0];
      } else if (me.length)
        throw new Error();
      if (se) {
        var ct = function(ge, Se) {
          var Re = ge[Se];
          if (Re && typeof Re == "object") {
            var Te = null;
            for (var He in Re)
              if (J.call(Re, He) && Re !== ge) {
                var ut = ct(Re, He);
                ut !== void 0 ? Re[He] = ut : (Te || (Te = []), Te.push(He));
              }
            if (Te)
              for (var vt = Te.length; --vt >= 0; )
                delete Re[Te[vt]];
          }
          return se.call(ge, Se, Re);
        };
        ee = ct({ "": ee }, "");
      }
      return ee;
    };
  }();
  (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), L.asn1.ASN1Util = new function() {
    this.integerToByteHex = function(T) {
      var C = T.toString(16);
      return C.length % 2 == 1 && (C = "0" + C), C;
    }, this.bigIntToMinTwosComplementsHex = function(T) {
      return yv(T);
    }, this.getPEMStringFromHex = function(T, C) {
      return Go(T, C);
    }, this.newObject = function(T) {
      var C = L, I = C.asn1, R = I.ASN1Object, M = I.DERBoolean, N = I.DERInteger, Y = I.DERBitString, q = I.DEROctetString, oe = I.DERNull, J = I.DERObjectIdentifier, de = I.DEREnumerated, se = I.DERUTF8String, j = I.DERNumericString, ee = I.DERPrintableString, W = I.DERTeletexString, re = I.DERIA5String, ce = I.DERUTCTime, me = I.DERGeneralizedTime, Ve = I.DERVisibleString, at = I.DERBMPString, it = I.DERSequence, ct = I.DERSet, ge = I.DERTaggedObject, Se = I.ASN1Util.newObject;
      if (T instanceof I.ASN1Object)
        return T;
      var Re = Object.keys(T);
      if (Re.length != 1)
        throw new Error("key of param shall be only one.");
      var Te = Re[0];
      if (":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + Te + ":") == -1)
        throw new Error("undefined key: " + Te);
      if (Te == "bool")
        return new M(T[Te]);
      if (Te == "int")
        return new N(T[Te]);
      if (Te == "bitstr")
        return new Y(T[Te]);
      if (Te == "octstr")
        return new q(T[Te]);
      if (Te == "null")
        return new oe(T[Te]);
      if (Te == "oid")
        return new J(T[Te]);
      if (Te == "enum")
        return new de(T[Te]);
      if (Te == "utf8str")
        return new se(T[Te]);
      if (Te == "numstr")
        return new j(T[Te]);
      if (Te == "prnstr")
        return new ee(T[Te]);
      if (Te == "telstr")
        return new W(T[Te]);
      if (Te == "ia5str")
        return new re(T[Te]);
      if (Te == "utctime")
        return new ce(T[Te]);
      if (Te == "gentime")
        return new me(T[Te]);
      if (Te == "visstr")
        return new Ve(T[Te]);
      if (Te == "bmpstr")
        return new at(T[Te]);
      if (Te == "asn1")
        return new R(T[Te]);
      if (Te == "seq") {
        for (var He = T[Te], ut = [], vt = 0; vt < He.length; vt++) {
          var Rt = Se(He[vt]);
          ut.push(Rt);
        }
        return new it({ array: ut });
      }
      if (Te == "set") {
        for (var He = T[Te], ut = [], vt = 0; vt < He.length; vt++) {
          var Rt = Se(He[vt]);
          ut.push(Rt);
        }
        return new ct({ array: ut });
      }
      if (Te == "tag") {
        var pt = T[Te];
        if (Object.prototype.toString.call(pt) === "[object Array]" && pt.length == 3) {
          var Tt = Se(pt[2]);
          return new ge({ tag: pt[0], explicit: pt[1], obj: Tt });
        } else
          return new ge(pt);
      }
    }, this.jsonToASN1HEX = function(T) {
      var C = this.newObject(T);
      return C.tohex();
    };
  }(), L.asn1.ASN1Util.oidHexToInt = function(T) {
    for (var M = "", C = parseInt(T.substr(0, 2), 16), I = Math.floor(C / 40), R = C % 40, M = I + "." + R, N = "", Y = 2; Y < T.length; Y += 2) {
      var q = parseInt(T.substr(Y, 2), 16), oe = ("00000000" + q.toString(2)).slice(-8);
      if (N = N + oe.substr(1, 7), oe.substr(0, 1) == "0") {
        var J = new f(N, 2);
        M = M + "." + J.toString(10), N = "";
      }
    }
    return M;
  }, L.asn1.ASN1Util.oidIntToHex = function(T) {
    var C = function(q) {
      var oe = q.toString(16);
      return oe.length == 1 && (oe = "0" + oe), oe;
    }, I = function(q) {
      var oe = "", J = new f(q, 10), de = J.toString(2), se = 7 - de.length % 7;
      se == 7 && (se = 0);
      for (var j = "", ee = 0; ee < se; ee++)
        j += "0";
      de = j + de;
      for (var ee = 0; ee < de.length - 1; ee += 7) {
        var W = de.substr(ee, 7);
        ee != de.length - 7 && (W = "1" + W), oe += C(parseInt(W, 2));
      }
      return oe;
    };
    if (!T.match(/^[0-9.]+$/))
      throw "malformed oid string: " + T;
    var R = "", M = T.split("."), N = parseInt(M[0]) * 40 + parseInt(M[1]);
    R += C(N), M.splice(0, 2);
    for (var Y = 0; Y < M.length; Y++)
      R += I(M[Y]);
    return R;
  }, L.asn1.ASN1Object = function(T) {
    var C = "";
    this.params = null, this.getLengthHexFromValue = function() {
      if (typeof this.hV > "u" || this.hV == null)
        throw new Error("this.hV is null or undefined");
      if (this.hV.length % 2 == 1)
        throw new Error("value hex must be even length: n=" + C.length + ",v=" + this.hV);
      var I = this.hV.length / 2, R = I.toString(16);
      if (R.length % 2 == 1 && (R = "0" + R), I < 128)
        return R;
      var M = R.length / 2;
      if (M > 15)
        throw new Error("ASN.1 length too long to represent by 8x: n = " + I.toString(16));
      var N = 128 + M;
      return N.toString(16) + R;
    }, this.tohex = function() {
      return (this.hTLV == null || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.getValueHex = function() {
      return this.tohex(), this.hV;
    }, this.getFreshValueHex = function() {
      return "";
    }, this.setByParam = function(I) {
      this.params = I;
    }, T != null && T.tlv != null && (this.hTLV = T.tlv, this.isModified = !1);
  }, L.asn1.DERAbstractString = function(T) {
    L.asn1.DERAbstractString.superclass.constructor.call(this), this.getString = function() {
      return this.s;
    }, this.setString = function(C) {
      this.hTLV = null, this.isModified = !0, this.s = C, this.hV = Ic(this.s).toLowerCase();
    }, this.setStringHex = function(C) {
      this.hTLV = null, this.isModified = !0, this.s = null, this.hV = C;
    }, this.getFreshValueHex = function() {
      return this.hV;
    }, typeof T < "u" && (typeof T == "string" ? this.setString(T) : typeof T.str < "u" ? this.setString(T.str) : typeof T.hex < "u" && this.setStringHex(T.hex));
  }, It(L.asn1.DERAbstractString, L.asn1.ASN1Object), L.asn1.DERAbstractTime = function(T) {
    L.asn1.DERAbstractTime.superclass.constructor.call(this), this.localDateToUTC = function(C) {
      var I = C.getTime() + C.getTimezoneOffset() * 6e4, R = new Date(I);
      return R;
    }, this.formatDate = function(C, I, R) {
      var M = this.zeroPadding, N = this.localDateToUTC(C), Y = String(N.getFullYear());
      I == "utc" && (Y = Y.substr(2, 2));
      var q = M(String(N.getMonth() + 1), 2), oe = M(String(N.getDate()), 2), J = M(String(N.getHours()), 2), de = M(String(N.getMinutes()), 2), se = M(String(N.getSeconds()), 2), j = Y + q + oe + J + de + se;
      if (R === !0) {
        var ee = N.getMilliseconds();
        if (ee != 0) {
          var W = M(String(ee), 3);
          W = W.replace(/[0]+$/, ""), j = j + "." + W;
        }
      }
      return j + "Z";
    }, this.zeroPadding = function(C, I) {
      return C.length >= I ? C : new Array(I - C.length + 1).join("0") + C;
    }, this.setByParam = function(C) {
      this.hV = null, this.hTLV = null, this.params = C;
    }, this.getString = function() {
    }, this.setString = function(C) {
      this.hTLV = null, this.isModified = !0, this.params == null && (this.params = {}), this.params.str = C;
    }, this.setByDate = function(C) {
      this.hTLV = null, this.isModified = !0, this.params == null && (this.params = {}), this.params.date = C;
    }, this.setByDateValue = function(C, I, R, M, N, Y) {
      var q = new Date(Date.UTC(C, I - 1, R, M, N, Y, 0));
      this.setByDate(q);
    }, this.getFreshValueHex = function() {
      return this.hV;
    };
  }, It(L.asn1.DERAbstractTime, L.asn1.ASN1Object), L.asn1.DERAbstractStructured = function(T) {
    L.asn1.DERAbstractString.superclass.constructor.call(this), this.setByASN1ObjectArray = function(C) {
      this.hTLV = null, this.isModified = !0, this.asn1Array = C;
    }, this.appendASN1Object = function(C) {
      this.hTLV = null, this.isModified = !0, this.asn1Array.push(C);
    }, this.asn1Array = new Array(), typeof T < "u" && typeof T.array < "u" && (this.asn1Array = T.array);
  }, It(L.asn1.DERAbstractStructured, L.asn1.ASN1Object), L.asn1.DERBoolean = function(T) {
    L.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", T == !1 ? this.hTLV = "010100" : this.hTLV = "0101ff";
  }, It(L.asn1.DERBoolean, L.asn1.ASN1Object), L.asn1.DERInteger = function(T) {
    L.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.params = null;
    var C = yv;
    this.setByBigInteger = function(I) {
      this.isModified = !0, this.params = { bigint: I };
    }, this.setByInteger = function(I) {
      this.isModified = !0, this.params = I;
    }, this.setValueHex = function(I) {
      this.isModified = !0, this.params = { hex: I };
    }, this.getFreshValueHex = function() {
      var I = this.params, R = null;
      if (I == null)
        throw new Error("value not set");
      if (typeof I == "object" && I.hex != null)
        return this.hV = I.hex, this.hV;
      if (typeof I == "number")
        R = new f(String(I), 10);
      else if (I.int != null)
        R = new f(String(I.int), 10);
      else if (I.bigint != null)
        R = I.bigint;
      else
        throw new Error("wrong parameter");
      return this.hV = C(R), this.hV;
    }, T != null && (this.params = T);
  }, It(L.asn1.DERInteger, L.asn1.ASN1Object), L.asn1.DERBitString = function(T) {
    if (T !== void 0 && typeof T.obj < "u") {
      var C = L.asn1.ASN1Util.newObject(T.obj);
      T.hex = "00" + C.tohex();
    }
    L.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(I) {
      this.hTLV = null, this.isModified = !0, this.hV = I;
    }, this.setUnusedBitsAndHexValue = function(I, R) {
      if (I < 0 || 7 < I)
        throw "unused bits shall be from 0 to 7: u = " + I;
      var M = "0" + I;
      this.hTLV = null, this.isModified = !0, this.hV = M + R;
    }, this.setByBinaryString = function(I) {
      I = I.replace(/0+$/, "");
      var R = 8 - I.length % 8;
      R == 8 && (R = 0), I += "0000000".substr(0, R);
      for (var M = "", N = 0; N < I.length - 1; N += 8) {
        var Y = I.substr(N, 8), q = parseInt(Y, 2).toString(16);
        q.length == 1 && (q = "0" + q), M += q;
      }
      this.hTLV = null, this.isModified = !0, this.hV = "0" + R + M;
    }, this.setByBooleanArray = function(I) {
      for (var R = "", M = 0; M < I.length; M++)
        I[M] == !0 ? R += "1" : R += "0";
      this.setByBinaryString(R);
    }, this.newFalseArray = function(I) {
      for (var R = new Array(I), M = 0; M < I; M++)
        R[M] = !1;
      return R;
    }, this.getFreshValueHex = function() {
      return this.hV;
    }, typeof T < "u" && (typeof T == "string" && T.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(T) : typeof T.hex < "u" ? this.setHexValueIncludingUnusedBits(T.hex) : typeof T.bin < "u" ? this.setByBinaryString(T.bin) : typeof T.array < "u" && this.setByBooleanArray(T.array));
  }, It(L.asn1.DERBitString, L.asn1.ASN1Object), L.asn1.DEROctetString = function(T) {
    if (T !== void 0 && typeof T.obj < "u") {
      var C = L.asn1.ASN1Util.newObject(T.obj);
      T.hex = C.tohex();
    }
    L.asn1.DEROctetString.superclass.constructor.call(this, T), this.hT = "04";
  }, It(L.asn1.DEROctetString, L.asn1.DERAbstractString), L.asn1.DERNull = function() {
    L.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
  }, It(L.asn1.DERNull, L.asn1.ASN1Object), L.asn1.DERObjectIdentifier = function(T) {
    L.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(C) {
      this.hTLV = null, this.isModified = !0, this.s = null, this.hV = C;
    }, this.setValueOidString = function(C) {
      var I = UU(C);
      if (I == null)
        throw new Error("malformed oid string: " + C);
      this.hTLV = null, this.isModified = !0, this.s = null, this.hV = I;
    }, this.setValueName = function(C) {
      var I = L.asn1.x509.OID.name2oid(C);
      if (I !== "")
        this.setValueOidString(I);
      else
        throw new Error("DERObjectIdentifier oidName undefined: " + C);
    }, this.setValueNameOrOid = function(C) {
      C.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(C) : this.setValueName(C);
    }, this.getFreshValueHex = function() {
      return this.hV;
    }, this.setByParam = function(C) {
      typeof C == "string" ? this.setValueNameOrOid(C) : C.oid !== void 0 ? this.setValueNameOrOid(C.oid) : C.name !== void 0 ? this.setValueNameOrOid(C.name) : C.hex !== void 0 && this.setValueHex(C.hex);
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.DERObjectIdentifier, L.asn1.ASN1Object), L.asn1.DEREnumerated = function(T) {
    L.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(C) {
      this.hTLV = null, this.isModified = !0, this.hV = yv(C);
    }, this.setByInteger = function(C) {
      var I = new f(String(C), 10);
      this.setByBigInteger(I);
    }, this.setValueHex = function(C) {
      this.hV = C;
    }, this.getFreshValueHex = function() {
      return this.hV;
    }, typeof T < "u" && (typeof T.int < "u" ? this.setByInteger(T.int) : typeof T == "number" ? this.setByInteger(T) : typeof T.hex < "u" && this.setValueHex(T.hex));
  }, It(L.asn1.DEREnumerated, L.asn1.ASN1Object), L.asn1.DERUTF8String = function(T) {
    L.asn1.DERUTF8String.superclass.constructor.call(this, T), this.hT = "0c";
  }, It(L.asn1.DERUTF8String, L.asn1.DERAbstractString), L.asn1.DERNumericString = function(T) {
    L.asn1.DERNumericString.superclass.constructor.call(this, T), this.hT = "12";
  }, It(L.asn1.DERNumericString, L.asn1.DERAbstractString), L.asn1.DERPrintableString = function(T) {
    L.asn1.DERPrintableString.superclass.constructor.call(this, T), this.hT = "13";
  }, It(L.asn1.DERPrintableString, L.asn1.DERAbstractString), L.asn1.DERTeletexString = function(T) {
    L.asn1.DERTeletexString.superclass.constructor.call(this, T), this.hT = "14";
  }, It(L.asn1.DERTeletexString, L.asn1.DERAbstractString), L.asn1.DERIA5String = function(T) {
    L.asn1.DERIA5String.superclass.constructor.call(this, T), this.hT = "16";
  }, It(L.asn1.DERIA5String, L.asn1.DERAbstractString), L.asn1.DERVisibleString = function(T) {
    L.asn1.DERIA5String.superclass.constructor.call(this, T), this.hT = "1a";
  }, It(L.asn1.DERVisibleString, L.asn1.DERAbstractString), L.asn1.DERBMPString = function(T) {
    L.asn1.DERBMPString.superclass.constructor.call(this, T), this.hT = "1e";
  }, It(L.asn1.DERBMPString, L.asn1.DERAbstractString), L.asn1.DERUTCTime = function(T) {
    L.asn1.DERUTCTime.superclass.constructor.call(this, T), this.hT = "17", this.params = void 0, this.getFreshValueHex = function() {
      var C = this.params;
      if (this.params == null && (C = { date: /* @__PURE__ */ new Date() }), typeof C == "string")
        if (C.match(/^[0-9]{12}Z$/) || C.match(/^[0-9]{12}\.[0-9]+Z$/))
          this.hV = Hr(C);
        else
          throw new Error("malformed string for UTCTime: " + C);
      else if (C.str != null)
        this.hV = Hr(C.str);
      else if (C.date == null && C.millis == !0) {
        var I = /* @__PURE__ */ new Date();
        this.hV = Hr(this.formatDate(I, "utc", !0));
      } else if (C.date != null && C.date instanceof Date) {
        var R = C.millis === !0;
        this.hV = Hr(this.formatDate(C.date, "utc", R));
      } else
        C instanceof Date && (this.hV = Hr(this.formatDate(C, "utc")));
      if (this.hV == null)
        throw new Error("parameter not specified properly for UTCTime");
      return this.hV;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.DERUTCTime, L.asn1.DERAbstractTime), L.asn1.DERGeneralizedTime = function(T) {
    L.asn1.DERGeneralizedTime.superclass.constructor.call(this, T), this.hT = "18", this.params = T, this.getFreshValueHex = function() {
      var C = this.params;
      if (this.params == null && (C = { date: /* @__PURE__ */ new Date() }), typeof C == "string")
        if (C.match(/^[0-9]{14}Z$/) || C.match(/^[0-9]{14}\.[0-9]+Z$/))
          this.hV = Hr(C);
        else
          throw new Error("malformed string for GeneralizedTime: " + C);
      else if (C.str != null)
        this.hV = Hr(C.str);
      else if (C.date == null && C.millis == !0) {
        var I = /* @__PURE__ */ new Date();
        this.hV = Hr(this.formatDate(I, "gen", !0));
      } else if (C.date != null && C.date instanceof Date) {
        var R = C.millis === !0;
        this.hV = Hr(this.formatDate(C.date, "gen", R));
      } else
        C instanceof Date && (this.hV = Hr(this.formatDate(C, "gen")));
      if (this.hV == null)
        throw new Error("parameter not specified properly for GeneralizedTime");
      return this.hV;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.DERGeneralizedTime, L.asn1.DERAbstractTime), L.asn1.DERSequence = function(T) {
    L.asn1.DERSequence.superclass.constructor.call(this, T), this.hT = "30", this.getFreshValueHex = function() {
      for (var C = "", I = 0; I < this.asn1Array.length; I++) {
        var R = this.asn1Array[I];
        C += R.tohex();
      }
      return this.hV = C, this.hV;
    };
  }, It(L.asn1.DERSequence, L.asn1.DERAbstractStructured), L.asn1.DERSet = function(T) {
    L.asn1.DERSet.superclass.constructor.call(this, T), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function() {
      for (var C = new Array(), I = 0; I < this.asn1Array.length; I++) {
        var R = this.asn1Array[I];
        C.push(R.tohex());
      }
      return this.sortFlag == !0 && C.sort(), this.hV = C.join(""), this.hV;
    }, typeof T < "u" && typeof T.sortflag < "u" && T.sortflag == !1 && (this.sortFlag = !1);
  }, It(L.asn1.DERSet, L.asn1.DERAbstractStructured), L.asn1.DERTaggedObject = function(T) {
    L.asn1.DERTaggedObject.superclass.constructor.call(this);
    var C = L.asn1, I = lt, R = I.getV;
    I.isASN1HEX;
    var M = C.ASN1Util.newObject;
    this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.params = { tag: "a0", explicit: !0 }, this.setASN1Object = function(N, Y, q) {
      this.params = { tag: Y, explicit: N, obj: q };
    }, this.getFreshValueHex = function() {
      var N = this.params;
      if (N.explicit == null && (N.explicit = !0), N.tage != null && (N.tag = N.tage, N.explicit = !0), N.tagi != null && (N.tag = N.tagi, N.explicit = !1), N.str != null)
        this.hV = Ic(N.str);
      else if (N.hex != null)
        this.hV = N.hex;
      else if (N.obj != null) {
        var Y;
        N.obj instanceof C.ASN1Object ? Y = N.obj.tohex() : typeof N.obj == "object" && (Y = M(N.obj).tohex()), N.explicit ? this.hV = Y : this.hV = R(Y, 0);
      } else
        throw new Error("str, hex nor obj not specified");
      return N.tag == null && (N.tag = "a0"), this.hT = N.tag, this.hTLV = null, this.isModified = !0, this.hV;
    }, this.setByParam = function(N) {
      this.params = N;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.DERTaggedObject, L.asn1.ASN1Object);
  var lt = new function() {
  }();
  lt.getLblen = function(T, C) {
    if (T.substr(C + 2, 1) != "8")
      return 1;
    var I = parseInt(T.substr(C + 3, 1));
    return I == 0 ? -1 : 0 < I && I < 10 ? I + 1 : -2;
  }, lt.getL = function(T, C) {
    var I = lt.getLblen(T, C);
    return I < 1 ? "" : T.substr(C + 2, I * 2);
  }, lt.getVblen = function(T, C) {
    var I, R;
    return I = lt.getL(T, C), I == "" ? -1 : (I.substr(0, 1) === "8" ? R = new f(I.substr(2), 16) : R = new f(I, 16), R.intValue());
  }, lt.getVidx = function(T, C) {
    var I = lt.getLblen(T, C);
    return I < 0 ? I : C + (I + 1) * 2;
  }, lt.getV = function(T, C) {
    var I = lt.getVidx(T, C), R = lt.getVblen(T, C);
    return T.substr(I, R * 2);
  }, lt.getTLV = function(T, C) {
    return T.substr(C, 2) + lt.getL(T, C) + lt.getV(T, C);
  }, lt.getTLVblen = function(T, C) {
    return 2 + lt.getLblen(T, C) * 2 + lt.getVblen(T, C) * 2;
  }, lt.getNextSiblingIdx = function(T, C) {
    var I = lt.getVidx(T, C), R = lt.getVblen(T, C);
    return I + R * 2;
  }, lt.getChildIdx = function(T, C) {
    var I = lt, R = [], M, N, Y;
    M = I.getVidx(T, C), N = I.getVblen(T, C) * 2, T.substr(C, 2) == "03" && (M += 2, N -= 2), Y = 0;
    for (var q = M; Y <= N; ) {
      var oe = I.getTLVblen(T, q);
      if (Y += oe, Y <= N && R.push(q), q += oe, Y >= N)
        break;
    }
    return R;
  }, lt.getNthChildIdx = function(T, C, I) {
    var R = lt.getChildIdx(T, C);
    return R[I];
  }, lt.getIdxbyList = function(T, C, I, R) {
    var M = lt, N, Y;
    return I.length == 0 ? R !== void 0 && T.substr(C, 2) !== R ? -1 : C : (N = I.shift(), Y = M.getChildIdx(T, C), N >= Y.length ? -1 : M.getIdxbyList(T, Y[N], I, R));
  }, lt.getIdxbyListEx = function(T, C, I, R) {
    var M = lt, N, Y;
    if (I.length == 0)
      return R !== void 0 && T.substr(C, 2) !== R ? -1 : C;
    N = I.shift(), Y = M.getChildIdx(T, C);
    for (var q = 0, oe = 0; oe < Y.length; oe++) {
      var J = T.substr(Y[oe], 2);
      if (typeof N == "number" && !M.isContextTag(J) && q == N || typeof N == "string" && M.isContextTag(J, N))
        return M.getIdxbyListEx(T, Y[oe], I, R);
      M.isContextTag(J) || q++;
    }
    return -1;
  }, lt.getTLVbyList = function(T, C, I, R) {
    var M = lt, N = M.getIdxbyList(T, C, I, R);
    return N == -1 || N >= T.length ? null : M.getTLV(T, N);
  }, lt.getTLVbyListEx = function(T, C, I, R) {
    var M = lt, N = M.getIdxbyListEx(T, C, I, R);
    return N == -1 ? null : M.getTLV(T, N);
  }, lt.getVbyList = function(T, C, I, R, M) {
    var N = lt, Y, q;
    return Y = N.getIdxbyList(T, C, I, R), Y == -1 || Y >= T.length ? null : (q = N.getV(T, Y), M === !0 && (q = q.substr(2)), q);
  }, lt.getVbyListEx = function(T, C, I, R, M) {
    var N = lt, Y, q;
    return Y = N.getIdxbyListEx(T, C, I, R), Y == -1 ? null : (q = N.getV(T, Y), T.substr(Y, 2) == "03" && M !== !1 && (q = q.substr(2)), q);
  }, lt.getInt = function(T, C, I) {
    I == null && (I = -1);
    try {
      var R = T.substr(C, 2);
      if (R != "02" && R != "03")
        return I;
      var M = lt.getV(T, C);
      return R == "02" ? parseInt(M, 16) : jU(M);
    } catch {
      return I;
    }
  }, lt.getOID = function(T, C, I) {
    I == null && (I = null);
    try {
      if (T.substr(C, 2) != "06")
        return I;
      var R = lt.getV(T, C);
      return I_(R);
    } catch {
      return I;
    }
  }, lt.getOIDName = function(T, C, I) {
    I == null && (I = null);
    try {
      var R = lt.getOID(T, C, I);
      if (R == I)
        return I;
      var M = L.asn1.x509.OID.oid2name(R);
      return M == "" ? R : M;
    } catch {
      return I;
    }
  }, lt.getString = function(T, C, I) {
    I == null && (I = null);
    try {
      var R = lt.getV(T, C);
      return Ia(R);
    } catch {
      return I;
    }
  }, lt.hextooidstr = function(T) {
    var C = function(se, j) {
      return se.length >= j ? se : new Array(j - se.length + 1).join("0") + se;
    }, I = [], R = T.substr(0, 2), M = parseInt(R, 16);
    I[0] = new String(Math.floor(M / 40)), I[1] = new String(M % 40);
    for (var N = T.substr(2), Y = [], q = 0; q < N.length / 2; q++)
      Y.push(parseInt(N.substr(q * 2, 2), 16));
    for (var oe = [], J = "", q = 0; q < Y.length; q++)
      Y[q] & 128 ? J = J + C((Y[q] & 127).toString(2), 7) : (J = J + C((Y[q] & 127).toString(2), 7), oe.push(new String(parseInt(J, 2))), J = "");
    var de = I.join(".");
    return oe.length > 0 && (de = de + "." + oe.join(".")), de;
  }, lt.dump = function(T, C, I, R) {
    var M = lt, N = M.getV, Y = M.dump, q = M.getChildIdx, oe = T;
    T instanceof L.asn1.ASN1Object && (oe = T.tohex());
    var J = function(Se, Re) {
      if (Se.length <= Re * 2)
        return Se;
      var Te = Se.substr(0, Re) + "..(total " + Se.length / 2 + "bytes).." + Se.substr(Se.length - Re, Re);
      return Te;
    };
    C === void 0 && (C = { ommit_long_octet: 32 }), I === void 0 && (I = 0), R === void 0 && (R = "");
    var de = C.ommit_long_octet, ct = oe.substr(I, 2);
    if (ct == "01") {
      var se = N(oe, I);
      return se == "00" ? R + `BOOLEAN FALSE
` : R + `BOOLEAN TRUE
`;
    }
    if (ct == "02") {
      var se = N(oe, I);
      return R + "INTEGER " + J(se, de) + `
`;
    }
    if (ct == "03") {
      var se = N(oe, I);
      if (M.isASN1HEX(se.substr(2))) {
        var j = R + `BITSTRING, encapsulates
`;
        return j = j + Y(se.substr(2), C, 0, R + "  "), j;
      } else
        return R + "BITSTRING " + J(se, de) + `
`;
    }
    if (ct == "04") {
      var se = N(oe, I);
      if (M.isASN1HEX(se)) {
        var j = R + `OCTETSTRING, encapsulates
`;
        return j = j + Y(se, C, 0, R + "  "), j;
      } else
        return R + "OCTETSTRING " + J(se, de) + `
`;
    }
    if (ct == "05")
      return R + `NULL
`;
    if (ct == "06") {
      var ee = N(oe, I), W = L.asn1.ASN1Util.oidHexToInt(ee), re = L.asn1.x509.OID.oid2name(W), ce = W.replace(/\./g, " ");
      return re != "" ? R + "ObjectIdentifier " + re + " (" + ce + `)
` : R + "ObjectIdentifier (" + ce + `)
`;
    }
    if (ct == "0a")
      return R + "ENUMERATED " + parseInt(N(oe, I)) + `
`;
    if (ct == "0c")
      return R + "UTF8String '" + dn(N(oe, I)) + `'
`;
    if (ct == "13")
      return R + "PrintableString '" + dn(N(oe, I)) + `'
`;
    if (ct == "14")
      return R + "TeletexString '" + dn(N(oe, I)) + `'
`;
    if (ct == "16")
      return R + "IA5String '" + dn(N(oe, I)) + `'
`;
    if (ct == "17")
      return R + "UTCTime " + dn(N(oe, I)) + `
`;
    if (ct == "18")
      return R + "GeneralizedTime " + dn(N(oe, I)) + `
`;
    if (ct == "1a")
      return R + "VisualString '" + dn(N(oe, I)) + `'
`;
    if (ct == "1e")
      return R + "BMPString '" + Z2(N(oe, I)) + `'
`;
    if (ct == "30") {
      if (oe.substr(I, 4) == "3000")
        return R + `SEQUENCE {}
`;
      var j = R + `SEQUENCE
`, me = q(oe, I), Ve = C;
      if ((me.length == 2 || me.length == 3) && oe.substr(me[0], 2) == "06" && oe.substr(me[me.length - 1], 2) == "04") {
        var re = M.oidname(N(oe, me[0])), at = JSON.parse(JSON.stringify(C));
        at.x509ExtName = re, Ve = at;
      }
      for (var it = 0; it < me.length; it++)
        j = j + Y(oe, Ve, me[it], R + "  ");
      return j;
    }
    if (ct == "31") {
      for (var j = R + `SET
`, me = q(oe, I), it = 0; it < me.length; it++)
        j = j + Y(oe, C, me[it], R + "  ");
      return j;
    }
    var ct = parseInt(ct, 16);
    if (ct & 128) {
      var ge = ct & 31;
      if (ct & 32) {
        for (var j = R + "[" + ge + `]
`, me = q(oe, I), it = 0; it < me.length; it++)
          j = j + Y(oe, C, me[it], R + "  ");
        return j;
      } else {
        var se = N(oe, I);
        if (lt.isASN1HEX(se)) {
          var j = R + "[" + ge + `]
`;
          return j = j + Y(se, C, 0, R + "  "), j;
        } else
          (se.substr(0, 8) == "68747470" || C.x509ExtName === "subjectAltName" && ge == 2) && (se = dn(se));
        var j = R + "[" + ge + "] " + se + `
`;
        return j;
      }
    }
    return R + "UNKNOWN(" + ct + ") " + N(oe, I) + `
`;
  }, lt.parse = function(T) {
    var C = lt, I = C.parse, R = C.isASN1HEX, M = C.getV, N = C.getTLV, Y = C.getChildIdx, q = L.asn1, oe = q.ASN1Util.oidHexToInt, J = q.x509.OID.oid2name, de = dn, se = Z2, j = cIe, ee = { "0c": "utf8str", 12: "numstr", 13: "prnstr", 14: "telstr", 16: "ia5str", 17: "utctime", 18: "gentime", "1a": "visstr", "1e": "bmpstr", 30: "seq", 31: "set" }, W = function(Te) {
      for (var He = [], ut = Y(Te, 0), vt = 0; vt < ut.length; vt++) {
        var Rt = ut[vt], pt = N(Te, Rt), Tt = I(pt);
        He.push(Tt);
      }
      return He;
    }, re = T.substr(0, 2), ce = {}, me = M(T, 0);
    if (re == "01")
      return T == "0101ff" ? { bool: !0 } : { bool: !1 };
    if (re == "02")
      return { int: { hex: me } };
    if (re == "03")
      try {
        if (me.substr(0, 2) != "00")
          throw "not encap";
        var Ve = me.substr(2);
        if (!R(Ve))
          throw "not encap";
        return { bitstr: { obj: I(Ve) } };
      } catch {
        var at = null;
        return me.length <= 10 && (at = qU(me)), at == null ? { bitstr: { hex: me } } : { bitstr: { bin: at } };
      }
    else if (re == "04")
      try {
        if (!R(me))
          throw "not encap";
        return { octstr: { obj: I(me) } };
      } catch {
        return { octstr: { hex: me } };
      }
    else {
      if (re == "05")
        return { null: "" };
      if (re == "06") {
        var it = oe(me), ct = J(it);
        return ct == "" ? { oid: it } : { oid: ct };
      } else {
        if (re == "0a")
          return me.length > 4 ? { enum: { hex: me } } : { enum: parseInt(me, 16) };
        if (re == "30" || re == "31")
          return ce[ee[re]] = W(T), ce;
        if (re == "14") {
          var ge = j(me);
          return ce[ee[re]] = { str: ge }, ce;
        } else if (re == "1e") {
          var ge = se(me);
          return ce[ee[re]] = { str: ge }, ce;
        } else if (":0c:12:13:16:17:18:1a:".indexOf(re) != -1) {
          var ge = de(me);
          return ce[ee[re]] = { str: ge }, ce;
        } else if (re.match(/^8[0-9]$/)) {
          var ge = de(me);
          return ge == null | ge == "" ? { tag: { tag: re, explicit: !1, hex: me } } : ge.match(/[\x00-\x1F\x7F-\x9F]/) != null || ge.match(/[\u0000-\u001F\u0080–\u009F]/) != null ? { tag: { tag: re, explicit: !1, hex: me } } : { tag: { tag: re, explicit: !1, str: ge } };
        } else if (re.match(/^a[0-9]$/))
          try {
            if (!R(me))
              throw new Error("not encap");
            return { tag: { tag: re, explicit: !0, obj: I(me) } };
          } catch {
            return { tag: { tag: re, explicit: !0, hex: me } };
          }
        else {
          var Se = new L.asn1.ASN1Object();
          Se.hV = me;
          var Re = Se.getLengthHexFromValue();
          return { asn1: { tlv: re + Re + me } };
        }
      }
    }
  }, lt.isContextTag = function(T, C) {
    T = T.toLowerCase();
    var I, R;
    try {
      I = parseInt(T, 16);
    } catch {
      return -1;
    }
    if (C === void 0)
      return (I & 192) == 128;
    try {
      var M = C.match(/^\[[0-9]+\]$/);
      return M == null || (R = parseInt(C.substr(1, C.length - 1), 10), R > 31) ? !1 : (I & 192) == 128 && (I & 31) == R;
    } catch {
      return !1;
    }
  }, lt.isASN1HEX = function(T) {
    var C = lt;
    if (T.length % 2 == 1)
      return !1;
    var I = C.getVblen(T, 0), R = T.substr(0, 2), M = C.getL(T, 0), N = T.length - R.length - M.length;
    return N == I * 2;
  }, lt.checkStrictDER = function(T, C, I, R, M) {
    var N = lt;
    if (I === void 0) {
      if (typeof T != "string")
        throw new Error("not hex string");
      if (T = T.toLowerCase(), !L.lang.String.isHex(T))
        throw new Error("not hex string");
      I = T.length, R = T.length / 2, R < 128 ? M = 1 : M = Math.ceil(R.toString(16)) + 1;
    }
    var Y = N.getL(T, C);
    if (Y.length > M * 2)
      throw new Error("L of TLV too long: idx=" + C);
    var q = N.getVblen(T, C);
    if (q > R)
      throw new Error("value of L too long than hex: idx=" + C);
    var oe = N.getTLV(T, C), J = oe.length - 2 - N.getL(T, C).length;
    if (J !== q * 2)
      throw new Error("V string length and L's value not the same:" + J + "/" + q * 2);
    if (C === 0 && T.length != oe.length)
      throw new Error("total length and TLV length unmatch:" + T.length + "!=" + oe.length);
    var de = T.substr(C, 2);
    if (de === "02") {
      var se = N.getVidx(T, C);
      if (T.substr(se, 2) == "00" && T.charCodeAt(se + 2) < 56)
        throw new Error("not least zeros for DER INTEGER");
    }
    if (parseInt(de, 16) & 32) {
      for (var j = N.getVblen(T, C), ee = 0, W = N.getChildIdx(T, C), re = 0; re < W.length; re++) {
        var ce = N.getTLV(T, W[re]);
        ee += ce.length, N.checkStrictDER(T, W[re], I, R, M);
      }
      if (j * 2 != ee)
        throw new Error("sum of children's TLV length and L unmatch: " + j * 2 + "!=" + ee);
    }
  }, lt.oidname = function(T) {
    var C = L.asn1;
    L.lang.String.isHex(T) && (T = C.ASN1Util.oidHexToInt(T));
    var I = C.x509.OID.oid2name(T);
    return I === "" && (I = T), I;
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), (typeof L.asn1.x509 > "u" || !L.asn1.x509) && (L.asn1.x509 = {}), L.asn1.x509.Certificate = function(T) {
    L.asn1.x509.Certificate.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERBitString, M = I.DERSequence, N = I.x509, Y = N.TBSCertificate, q = N.AlgorithmIdentifier;
    this.params = void 0, this.setByParam = function(oe) {
      this.params = oe;
    }, this.sign = function() {
      var oe = this.params, J = oe.sigalg;
      oe.sigalg.name != null && (J = oe.sigalg.name);
      var de = oe.tbsobj.tohex(), se = new L.crypto.Signature({ alg: J });
      se.init(oe.cakey), se.updateHex(de), oe.sighex = se.sign();
    }, this.getPEM = function() {
      return Go(this.tohex(), "CERTIFICATE");
    }, this.tohex = function() {
      var oe = this.params;
      if ((oe.tbsobj == null || oe.tbsobj == null) && (oe.tbsobj = new Y(oe)), oe.sighex == null && oe.cakey != null && this.sign(), oe.sighex == null)
        throw new Error("sighex or cakey parameter not defined");
      var J = [];
      J.push(oe.tbsobj), J.push(new q({ name: oe.sigalg })), J.push(new R({ hex: "00" + oe.sighex }));
      var de = new M({ array: J });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && (this.params = T);
  }, It(L.asn1.x509.Certificate, L.asn1.ASN1Object), L.asn1.x509.TBSCertificate = function(T) {
    L.asn1.x509.TBSCertificate.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.x509, M = I.DERTaggedObject, N = I.DERInteger, Y = I.DERSequence, q = R.AlgorithmIdentifier, oe = R.Time, J = R.X500Name, de = R.Extensions, se = R.SubjectPublicKeyInfo;
    this.params = null, this.setByParam = function(j) {
      this.params = j;
    }, this.tohex = function() {
      var j = [], ee = this.params;
      if (ee.version != null || ee.version != 1) {
        var W = 2;
        ee.version != null && (W = ee.version - 1);
        var re = new M({ obj: new N({ int: W }) });
        j.push(re);
      }
      j.push(new N(ee.serial)), j.push(new q({ name: ee.sigalg })), j.push(new J(ee.issuer)), j.push(new Y({ array: [new oe(ee.notbefore), new oe(ee.notafter)] })), j.push(new J(ee.subject)), j.push(new se(Yr.getKey(ee.sbjpubkey))), ee.ext !== void 0 && ee.ext.length > 0 && j.push(new M({ tag: "a3", obj: new de(ee.ext) }));
      var ce = new L.asn1.DERSequence({ array: j });
      return ce.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.TBSCertificate, L.asn1.ASN1Object), L.asn1.x509.Extensions = function(T) {
    L.asn1.x509.Extensions.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERSequence, M = I.x509;
    this.aParam = [], this.setByParam = function(N) {
      this.aParam = N;
    }, this.tohex = function() {
      for (var N = [], Y = 0; Y < this.aParam.length; Y++) {
        var q = this.aParam[Y], oe = q.extname, J = null;
        if (q.extn != null)
          J = new M.PrivateExtension(q);
        else if (oe == "subjectKeyIdentifier")
          J = new M.SubjectKeyIdentifier(q);
        else if (oe == "keyUsage")
          J = new M.KeyUsage(q);
        else if (oe == "subjectAltName")
          J = new M.SubjectAltName(q);
        else if (oe == "issuerAltName")
          J = new M.IssuerAltName(q);
        else if (oe == "basicConstraints")
          J = new M.BasicConstraints(q);
        else if (oe == "nameConstraints")
          J = new M.NameConstraints(q);
        else if (oe == "cRLDistributionPoints")
          J = new M.CRLDistributionPoints(q);
        else if (oe == "certificatePolicies")
          J = new M.CertificatePolicies(q);
        else if (oe == "policyMappings")
          J = new M.PolicyMappings(q);
        else if (oe == "policyConstraints")
          J = new M.PolicyConstraints(q);
        else if (oe == "inhibitAnyPolicy")
          J = new M.InhibitAnyPolicy(q);
        else if (oe == "authorityKeyIdentifier")
          J = new M.AuthorityKeyIdentifier(q);
        else if (oe == "extKeyUsage")
          J = new M.ExtKeyUsage(q);
        else if (oe == "authorityInfoAccess")
          J = new M.AuthorityInfoAccess(q);
        else if (oe == "cRLNumber")
          J = new M.CRLNumber(q);
        else if (oe == "cRLReason")
          J = new M.CRLReason(q);
        else if (oe == "ocspNonce")
          J = new M.OCSPNonce(q);
        else if (oe == "ocspNoCheck")
          J = new M.OCSPNoCheck(q);
        else if (oe == "adobeTimeStamp")
          J = new M.AdobeTimeStamp(q);
        else if (oe == "subjectDirectoryAttributes")
          J = new M.SubjectDirectoryAttributes(q);
        else
          throw new Error("extension not supported:" + JSON.stringify(q));
        J != null && N.push(J);
      }
      var de = new R({ array: N });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.x509.Extensions, L.asn1.ASN1Object), L.asn1.x509.Extension = function(T) {
    L.asn1.x509.Extension.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERObjectIdentifier, M = I.DEROctetString;
    I.DERBitString;
    var N = I.DERBoolean, Y = I.DERSequence;
    this.tohex = function() {
      var q = new R({ oid: this.oid }), oe = new M({ hex: this.getExtnValueHex() }), J = new Array();
      J.push(q), this.critical && J.push(new N()), J.push(oe);
      var de = new Y({ array: J });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.critical = !1, T !== void 0 && T.critical !== void 0 && (this.critical = T.critical);
  }, It(L.asn1.x509.Extension, L.asn1.ASN1Object), L.asn1.x509.KeyUsage = function(T) {
    L.asn1.x509.KeyUsage.superclass.constructor.call(this, T);
    var C = Error, I = { digitalSignature: 0, nonRepudiation: 1, keyEncipherment: 2, dataEncipherment: 3, keyAgreement: 4, keyCertSign: 5, cRLSign: 6, encipherOnly: 7, decipherOnly: 8 };
    this.getExtnValueHex = function() {
      var R = this.getBinValue();
      return this.asn1ExtnValue = new L.asn1.DERBitString({ bin: R }), this.asn1ExtnValue.tohex();
    }, this.getBinValue = function() {
      var R = this.params;
      if (typeof R != "object" || typeof R.names != "object" && typeof R.bin != "string")
        throw new C("parameter not yet set");
      if (R.names != null)
        return R_(R.names, I);
      if (R.bin != null)
        return R.bin;
      throw new C("parameter not set properly");
    }, this.oid = "2.5.29.15", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.KeyUsage, L.asn1.x509.Extension), L.asn1.x509.BasicConstraints = function(T) {
    L.asn1.x509.BasicConstraints.superclass.constructor.call(this, T);
    var C = L.asn1, I = C.DERBoolean, R = C.DERInteger, M = C.DERSequence;
    this.getExtnValueHex = function() {
      var N = new Array();
      this.cA && N.push(new I()), this.pathLen > -1 && N.push(new R({ int: this.pathLen }));
      var Y = new M({ array: N });
      return this.asn1ExtnValue = Y, this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.19", this.cA = !1, this.pathLen = -1, T !== void 0 && (T.cA !== void 0 && (this.cA = T.cA), T.pathLen !== void 0 && (this.pathLen = T.pathLen));
  }, It(L.asn1.x509.BasicConstraints, L.asn1.x509.Extension), L.asn1.x509.CRLDistributionPoints = function(T) {
    L.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.x509;
    this.getExtnValueHex = function() {
      return this.asn1ExtnValue.tohex();
    }, this.setByDPArray = function(M) {
      for (var N = [], Y = 0; Y < M.length; Y++)
        if (M[Y] instanceof L.asn1.ASN1Object)
          N.push(M[Y]);
        else {
          var q = new R.DistributionPoint(M[Y]);
          N.push(q);
        }
      this.asn1ExtnValue = new I.DERSequence({ array: N });
    }, this.setByOneURI = function(M) {
      var N = new R.DistributionPoint({ fulluri: M });
      this.setByDPArray([N]);
    }, this.oid = "2.5.29.31", T !== void 0 && (T.array !== void 0 ? this.setByDPArray(T.array) : T.uri !== void 0 && this.setByOneURI(T.uri));
  }, It(L.asn1.x509.CRLDistributionPoints, L.asn1.x509.Extension), L.asn1.x509.DistributionPoint = function(T) {
    L.asn1.x509.DistributionPoint.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.x509.DistributionPointName;
    this.tohex = function() {
      var M = new I.DERSequence();
      if (this.asn1DP != null) {
        var N = new I.DERTaggedObject({ explicit: !0, tag: "a0", obj: this.asn1DP });
        M.appendASN1Object(N);
      }
      return this.hTLV = M.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (T.dpobj !== void 0 ? this.asn1DP = T.dpobj : T.dpname !== void 0 ? this.asn1DP = new R(T.dpname) : T.fulluri !== void 0 && (this.asn1DP = new R({ full: [{ uri: T.fulluri }] })));
  }, It(L.asn1.x509.DistributionPoint, L.asn1.ASN1Object), L.asn1.x509.DistributionPointName = function(T) {
    L.asn1.x509.DistributionPointName.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERTaggedObject;
    if (this.tohex = function() {
      if (this.type != "full")
        throw new Error("currently type shall be 'full': " + this.type);
      return this.asn1Obj = new R({ explicit: !1, tag: this.tag, obj: this.asn1V }), this.hTLV = this.asn1Obj.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0)
      if (I.x509.GeneralNames.prototype.isPrototypeOf(T))
        this.type = "full", this.tag = "a0", this.asn1V = T;
      else if (T.full !== void 0)
        this.type = "full", this.tag = "a0", this.asn1V = new I.x509.GeneralNames(T.full);
      else
        throw new Error("This class supports GeneralNames only as argument");
  }, It(L.asn1.x509.DistributionPointName, L.asn1.ASN1Object), L.asn1.x509.CertificatePolicies = function(T) {
    L.asn1.x509.CertificatePolicies.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.x509, M = I.DERSequence, N = R.PolicyInformation;
    this.params = null, this.getExtnValueHex = function() {
      for (var Y = [], q = 0; q < this.params.array.length; q++)
        Y.push(new N(this.params.array[q]));
      var oe = new M({ array: Y });
      return this.asn1ExtnValue = oe, this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.32", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.CertificatePolicies, L.asn1.x509.Extension), L.asn1.x509.PolicyInformation = function(T) {
    L.asn1.x509.PolicyInformation.superclass.constructor.call(this, T);
    var C = L.asn1, I = C.DERSequence, R = C.DERObjectIdentifier, M = C.x509.PolicyQualifierInfo;
    this.params = null, this.tohex = function() {
      if (this.params.policyoid === void 0 && this.params.array === void 0)
        throw new Error("parameter oid and array missing");
      var N = [new R(this.params.policyoid)];
      if (this.params.array !== void 0) {
        for (var Y = [], q = 0; q < this.params.array.length; q++)
          Y.push(new M(this.params.array[q]));
        Y.length > 0 && N.push(new I({ array: Y }));
      }
      var oe = new I({ array: N });
      return oe.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.PolicyInformation, L.asn1.ASN1Object), L.asn1.x509.PolicyQualifierInfo = function(T) {
    L.asn1.x509.PolicyQualifierInfo.superclass.constructor.call(this, T);
    var C = L.asn1, I = C.DERSequence, R = C.DERIA5String, M = C.DERObjectIdentifier, N = C.x509.UserNotice;
    this.params = null, this.tohex = function() {
      if (this.params.cps !== void 0) {
        var Y = new I({ array: [new M({ oid: "1.3.6.1.5.5.7.2.1" }), new R({ str: this.params.cps })] });
        return Y.tohex();
      }
      if (this.params.unotice != null) {
        var Y = new I({ array: [new M({ oid: "1.3.6.1.5.5.7.2.2" }), new N(this.params.unotice)] });
        return Y.tohex();
      }
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.PolicyQualifierInfo, L.asn1.ASN1Object), L.asn1.x509.UserNotice = function(T) {
    L.asn1.x509.UserNotice.superclass.constructor.call(this, T);
    var C = L.asn1.DERSequence;
    L.asn1.DERInteger;
    var I = L.asn1.x509.DisplayText, R = L.asn1.x509.NoticeReference;
    this.params = null, this.tohex = function() {
      var M = [];
      this.params.noticeref !== void 0 && M.push(new R(this.params.noticeref)), this.params.exptext !== void 0 && M.push(new I(this.params.exptext));
      var N = new C({ array: M });
      return N.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.UserNotice, L.asn1.ASN1Object), L.asn1.x509.NoticeReference = function(T) {
    L.asn1.x509.NoticeReference.superclass.constructor.call(this, T);
    var C = L.asn1.DERSequence, I = L.asn1.DERInteger, R = L.asn1.x509.DisplayText;
    this.params = null, this.tohex = function() {
      var M = [];
      if (this.params.org !== void 0 && M.push(new R(this.params.org)), this.params.noticenum !== void 0) {
        for (var N = [], Y = this.params.noticenum, q = 0; q < Y.length; q++)
          N.push(new I(Y[q]));
        M.push(new C({ array: N }));
      }
      if (M.length == 0)
        throw new Error("parameter is empty");
      var oe = new C({ array: M });
      return oe.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.NoticeReference, L.asn1.ASN1Object), L.asn1.x509.DisplayText = function(T) {
    L.asn1.x509.DisplayText.superclass.constructor.call(this, T), this.hT = "0c", T !== void 0 && (T.type === "ia5" ? this.hT = "16" : T.type === "vis" ? this.hT = "1a" : T.type === "bmp" && (this.hT = "1e"));
  }, It(L.asn1.x509.DisplayText, L.asn1.DERAbstractString), L.asn1.x509.PolicyMappings = function(T) {
    L.asn1.x509.PolicyMappings.superclass.constructor.call(this, T);
    var C = L, I = C.asn1;
    I.x509;
    var R = I.ASN1Util.newObject;
    this.params = null, this.getExtnValueHex = function() {
      for (var M = this.params, N = [], Y = 0; Y < M.array.length; Y++) {
        var q = M.array[Y];
        N.push({ seq: [{ oid: q[0] }, { oid: q[1] }] });
      }
      return this.asn1ExtnValue = R({ seq: N }), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.33", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.PolicyMappings, L.asn1.x509.Extension), L.asn1.x509.PolicyConstraints = function(T) {
    L.asn1.x509.PolicyConstraints.superclass.constructor.call(this, T);
    var C = L, I = C.asn1;
    I.x509;
    var R = I.ASN1Util.newObject;
    this.params = null, this.getExtnValueHex = function() {
      var M = this.params, N = [];
      return M.reqexp != null && N.push({ tag: { tagi: "80", obj: { int: M.reqexp } } }), M.inhibit != null && N.push({ tag: { tagi: "81", obj: { int: M.inhibit } } }), this.asn1ExtnValue = R({ seq: N }), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.36", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.PolicyConstraints, L.asn1.x509.Extension), L.asn1.x509.InhibitAnyPolicy = function(T) {
    L.asn1.x509.InhibitAnyPolicy.superclass.constructor.call(this, T);
    var C = L, I = C.asn1;
    I.x509;
    var R = I.ASN1Util.newObject;
    this.params = null, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = R({ int: this.params.skip }), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.54", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.InhibitAnyPolicy, L.asn1.x509.Extension), L.asn1.x509.NameConstraints = function(T) {
    L.asn1.x509.NameConstraints.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.x509, M = I.ASN1Util.newObject, N = R.GeneralSubtree;
    this.params = null, this.getExtnValueHex = function() {
      var Y = this.params, q = [];
      if (Y.permit != null && Y.permit.length != null) {
        for (var oe = [], J = 0; J < Y.permit.length; J++)
          oe.push(new N(Y.permit[J]));
        q.push({ tag: { tagi: "a0", obj: { seq: oe } } });
      }
      if (Y.exclude != null && Y.exclude.length != null) {
        for (var de = [], J = 0; J < Y.exclude.length; J++)
          de.push(new N(Y.exclude[J]));
        q.push({ tag: { tagi: "a1", obj: { seq: de } } });
      }
      return this.asn1ExtnValue = M({ seq: q }), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.30", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.NameConstraints, L.asn1.x509.Extension), L.asn1.x509.GeneralSubtree = function(T) {
    L.asn1.x509.GeneralSubtree.superclass.constructor.call(this);
    var C = L.asn1, I = C.x509, R = I.GeneralName, M = C.ASN1Util.newObject;
    this.params = null, this.setByParam = function(N) {
      this.params = N;
    }, this.tohex = function() {
      var N = this.params, Y = [new R(N)];
      N.min != null && Y.push({ tag: { tagi: "80", obj: { int: N.min } } }), N.max != null && Y.push({ tag: { tagi: "81", obj: { int: N.max } } });
      var q = M({ seq: Y });
      return q.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.GeneralSubtree, L.asn1.ASN1Object), L.asn1.x509.ExtKeyUsage = function(T) {
    L.asn1.x509.ExtKeyUsage.superclass.constructor.call(this, T);
    var C = L, I = C.asn1;
    this.setPurposeArray = function(R) {
      this.asn1ExtnValue = new I.DERSequence();
      for (var M = 0; M < R.length; M++) {
        var N = new I.DERObjectIdentifier(R[M]);
        this.asn1ExtnValue.appendASN1Object(N);
      }
    }, this.getExtnValueHex = function() {
      return this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.37", T !== void 0 && T.array !== void 0 && this.setPurposeArray(T.array);
  }, It(L.asn1.x509.ExtKeyUsage, L.asn1.x509.Extension), L.asn1.x509.AuthorityKeyIdentifier = function(T) {
    L.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.DERTaggedObject, M = I.x509.GeneralNames;
    C.crypto.Util.isKey, this.asn1KID = null, this.asn1CertIssuer = null, this.asn1CertSN = null, this.getExtnValueHex = function() {
      var N = new Array();
      this.asn1KID && N.push(new R({ explicit: !1, tag: "80", obj: this.asn1KID })), this.asn1CertIssuer && N.push(new R({ explicit: !1, tag: "a1", obj: new M([{ dn: this.asn1CertIssuer }]) })), this.asn1CertSN && N.push(new R({ explicit: !1, tag: "82", obj: this.asn1CertSN }));
      var Y = new I.DERSequence({ array: N });
      return this.asn1ExtnValue = Y, this.asn1ExtnValue.tohex();
    }, this.setKIDByParam = function(N) {
      if (N.str !== void 0 || N.hex !== void 0)
        this.asn1KID = new L.asn1.DEROctetString(N);
      else if (typeof N == "object" && L.crypto.Util.isKey(N) || typeof N == "string" && N.indexOf("BEGIN ") != -1) {
        var Y = N;
        typeof N == "string" && (Y = Yr.getKey(N));
        var q = Yr.getKeyID(Y);
        this.asn1KID = new L.asn1.DEROctetString({ hex: q });
      }
    }, this.setCertIssuerByParam = function(N) {
      N.str !== void 0 || N.ldapstr !== void 0 || N.hex !== void 0 || N.certsubject !== void 0 || N.certissuer !== void 0 ? this.asn1CertIssuer = new L.asn1.x509.X500Name(N) : typeof N == "string" && N.indexOf("BEGIN ") != -1 && N.indexOf("CERTIFICATE") != -1 && (this.asn1CertIssuer = new L.asn1.x509.X500Name({ certissuer: N }));
    }, this.setCertSNByParam = function(N) {
      if (N.str !== void 0 || N.bigint !== void 0 || N.hex !== void 0)
        this.asn1CertSN = new L.asn1.DERInteger(N);
      else if (typeof N == "string" && N.indexOf("BEGIN ") != -1 && N.indexOf("CERTIFICATE")) {
        var Y = new mr();
        Y.readCertPEM(N);
        var q = Y.getSerialNumberHex();
        this.asn1CertSN = new L.asn1.DERInteger({ hex: q });
      }
    }, this.oid = "2.5.29.35", T !== void 0 && (T.kid !== void 0 && this.setKIDByParam(T.kid), T.issuer !== void 0 && this.setCertIssuerByParam(T.issuer), T.sn !== void 0 && this.setCertSNByParam(T.sn), T.issuersn !== void 0 && typeof T.issuersn == "string" && T.issuersn.indexOf("BEGIN ") != -1 && T.issuersn.indexOf("CERTIFICATE") && (this.setCertSNByParam(T.issuersn), this.setCertIssuerByParam(T.issuersn)));
  }, It(L.asn1.x509.AuthorityKeyIdentifier, L.asn1.x509.Extension), L.asn1.x509.SubjectKeyIdentifier = function(T) {
    L.asn1.x509.SubjectKeyIdentifier.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.DEROctetString;
    this.asn1KID = null, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = this.asn1KID, this.asn1ExtnValue.tohex();
    }, this.setKIDByParam = function(M) {
      if (M.str !== void 0 || M.hex !== void 0)
        this.asn1KID = new R(M);
      else if (typeof M == "object" && L.crypto.Util.isKey(M) || typeof M == "string" && M.indexOf("BEGIN") != -1) {
        var N = M;
        typeof M == "string" && (N = Yr.getKey(M));
        var Y = Yr.getKeyID(N);
        this.asn1KID = new L.asn1.DEROctetString({ hex: Y });
      }
    }, this.oid = "2.5.29.14", T !== void 0 && T.kid !== void 0 && this.setKIDByParam(T.kid);
  }, It(L.asn1.x509.SubjectKeyIdentifier, L.asn1.x509.Extension), L.asn1.x509.AuthorityInfoAccess = function(T) {
    L.asn1.x509.AuthorityInfoAccess.superclass.constructor.call(this, T), this.setAccessDescriptionArray = function(C) {
      for (var I = new Array(), R = L, M = R.asn1, N = M.DERSequence, Y = M.DERObjectIdentifier, q = M.x509.GeneralName, oe = 0; oe < C.length; oe++) {
        var J, de = C[oe];
        if (de.ocsp !== void 0)
          J = new N({ array: [new Y({ oid: "1.3.6.1.5.5.7.48.1" }), new q({ uri: de.ocsp })] });
        else if (de.caissuer !== void 0)
          J = new N({ array: [new Y({ oid: "1.3.6.1.5.5.7.48.2" }), new q({ uri: de.caissuer })] });
        else
          throw new Error("unknown AccessMethod parameter: " + JSON.stringify(de));
        I.push(J);
      }
      this.asn1ExtnValue = new N({ array: I });
    }, this.getExtnValueHex = function() {
      return this.asn1ExtnValue.tohex();
    }, this.oid = "1.3.6.1.5.5.7.1.1", T !== void 0 && T.array !== void 0 && this.setAccessDescriptionArray(T.array);
  }, It(L.asn1.x509.AuthorityInfoAccess, L.asn1.x509.Extension), L.asn1.x509.SubjectAltName = function(T) {
    L.asn1.x509.SubjectAltName.superclass.constructor.call(this, T), this.setNameArray = function(C) {
      this.asn1ExtnValue = new L.asn1.x509.GeneralNames(C);
    }, this.getExtnValueHex = function() {
      return this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.17", T !== void 0 && T.array !== void 0 && this.setNameArray(T.array);
  }, It(L.asn1.x509.SubjectAltName, L.asn1.x509.Extension), L.asn1.x509.IssuerAltName = function(T) {
    L.asn1.x509.IssuerAltName.superclass.constructor.call(this, T), this.setNameArray = function(C) {
      this.asn1ExtnValue = new L.asn1.x509.GeneralNames(C);
    }, this.getExtnValueHex = function() {
      return this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.18", T !== void 0 && T.array !== void 0 && this.setNameArray(T.array);
  }, It(L.asn1.x509.IssuerAltName, L.asn1.x509.Extension), L.asn1.x509.SubjectDirectoryAttributes = function(T) {
    L.asn1.x509.SubjectDirectoryAttributes.superclass.constructor.call(this, T);
    var C = L.asn1, I = C.DERSequence, R = C.ASN1Util.newObject, M = C.x509.OID.name2oid;
    this.params = null, this.getExtnValueHex = function() {
      for (var N = [], Y = 0; Y < this.params.array.length; Y++) {
        var q = this.params.array[Y];
        if (q.attr != null && q.array != null) {
          var oe = { seq: [{ oid: q.attr }, { set: q.array }] };
          N.push(R(oe));
          continue;
        }
        var J = { seq: [{ oid: "1.2.3.4" }, { set: [{ utf8str: "DE" }] }] };
        if (q.attr == "dateOfBirth")
          J.seq[0].oid = M(q.attr), J.seq[1].set[0] = { gentime: q.str };
        else if (q.attr == "placeOfBirth")
          J.seq[0].oid = M(q.attr), J.seq[1].set[0] = { utf8str: q.str };
        else if (q.attr == "gender")
          J.seq[0].oid = M(q.attr), J.seq[1].set[0] = { prnstr: q.str };
        else if (q.attr == "countryOfCitizenship")
          J.seq[0].oid = M(q.attr), J.seq[1].set[0] = { prnstr: q.str };
        else if (q.attr == "countryOfResidence")
          J.seq[0].oid = M(q.attr), J.seq[1].set[0] = { prnstr: q.str };
        else
          throw new Error("unsupported attribute: " + q.attr);
        N.push(new R(J));
      }
      var de = new I({ array: N });
      return this.asn1ExtnValue = de, this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.9", T !== void 0 && (this.params = T);
  }, It(L.asn1.x509.SubjectDirectoryAttributes, L.asn1.x509.Extension), L.asn1.x509.PrivateExtension = function(T) {
    L.asn1.x509.PrivateExtension.superclass.constructor.call(this, T);
    var C = L, I = C.lang.String.isHex, R = C.asn1, M = R.x509.OID.name2oid, N = R.ASN1Util.newObject;
    this.params = null, this.setByParam = function(Y) {
      this.oid = M(Y.extname), this.params = Y;
    }, this.getExtnValueHex = function() {
      if (this.params.extname == null || this.params.extn == null)
        throw new Error("extname or extnhex not specified");
      var Y = this.params.extn;
      if (typeof Y == "string" && I(Y))
        return Y;
      if (typeof Y == "object")
        try {
          return N(Y).tohex();
        } catch {
        }
      throw new Error("unsupported extn value");
    }, T != null && this.setByParam(T);
  }, It(L.asn1.x509.PrivateExtension, L.asn1.x509.Extension), L.asn1.x509.CRL = function(T) {
    L.asn1.x509.CRL.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DERBitString, N = I.x509, Y = N.AlgorithmIdentifier, q = N.TBSCertList;
    this.params = void 0, this.setByParam = function(oe) {
      this.params = oe;
    }, this.sign = function() {
      var oe = new q(this.params).tohex(), J = new L.crypto.Signature({ alg: this.params.sigalg });
      J.init(this.params.cakey), J.updateHex(oe);
      var de = J.sign();
      this.params.sighex = de;
    }, this.getPEM = function() {
      return Go(this.tohex(), "X509 CRL");
    }, this.tohex = function() {
      var oe = this.params;
      if (oe.tbsobj == null && (oe.tbsobj = new q(oe)), oe.sighex == null && oe.cakey != null && this.sign(), oe.sighex == null)
        throw new Error("sighex or cakey parameter not defined");
      var J = [];
      J.push(oe.tbsobj), J.push(new Y({ name: oe.sigalg })), J.push(new M({ hex: "00" + oe.sighex }));
      var de = new R({ array: J });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && (this.params = T);
  }, It(L.asn1.x509.CRL, L.asn1.ASN1Object), L.asn1.x509.TBSCertList = function(T) {
    L.asn1.x509.TBSCertList.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERInteger, M = I.DERSequence, N = I.DERTaggedObject;
    I.DERObjectIdentifier;
    var Y = I.x509, q = Y.AlgorithmIdentifier, oe = Y.Time, J = Y.Extensions, de = Y.X500Name;
    this.params = null, this.setByParam = function(se) {
      this.params = se;
    }, this.getRevCertSequence = function() {
      for (var se = [], j = this.params.revcert, ee = 0; ee < j.length; ee++) {
        var W = [new R(j[ee].sn), new oe(j[ee].date)];
        j[ee].ext != null && W.push(new J(j[ee].ext)), se.push(new M({ array: W }));
      }
      return new M({ array: se });
    }, this.tohex = function() {
      var se = [], j = this.params;
      if (j.version != null) {
        var ee = j.version - 1, W = new R({ int: ee });
        se.push(W);
      }
      if (se.push(new q({ name: j.sigalg })), se.push(new de(j.issuer)), se.push(new oe(j.thisupdate)), j.nextupdate != null && se.push(new oe(j.nextupdate)), j.revcert != null && se.push(this.getRevCertSequence()), j.ext != null) {
        var re = new J(j.ext);
        se.push(new N({ tag: "a0", explicit: !0, obj: re }));
      }
      var ce = new M({ array: se });
      return ce.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.TBSCertList, L.asn1.ASN1Object), L.asn1.x509.CRLEntry = function(T) {
    L.asn1.x509.CRLEntry.superclass.constructor.call(this);
    var C = L, I = C.asn1;
    this.setCertSerial = function(R) {
      this.sn = new I.DERInteger(R);
    }, this.setRevocationDate = function(R) {
      this.time = new I.x509.Time(R);
    }, this.tohex = function() {
      var R = new I.DERSequence({ array: [this.sn, this.time] });
      return this.TLV = R.tohex(), this.TLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (T.time !== void 0 && this.setRevocationDate(T.time), T.sn !== void 0 && this.setCertSerial(T.sn));
  }, It(L.asn1.x509.CRLEntry, L.asn1.ASN1Object), L.asn1.x509.CRLNumber = function(T) {
    L.asn1.x509.CRLNumber.superclass.constructor.call(this, T), this.params = void 0, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = new L.asn1.DERInteger(this.params.num), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.20", T != null && (this.params = T);
  }, It(L.asn1.x509.CRLNumber, L.asn1.x509.Extension), L.asn1.x509.CRLReason = function(T) {
    L.asn1.x509.CRLReason.superclass.constructor.call(this, T), this.params = void 0, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = new L.asn1.DEREnumerated(this.params.code), this.asn1ExtnValue.tohex();
    }, this.oid = "2.5.29.21", T != null && (this.params = T);
  }, It(L.asn1.x509.CRLReason, L.asn1.x509.Extension), L.asn1.x509.OCSPNonce = function(T) {
    L.asn1.x509.OCSPNonce.superclass.constructor.call(this, T), this.params = void 0, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = new L.asn1.DEROctetString(this.params), this.asn1ExtnValue.tohex();
    }, this.oid = "1.3.6.1.5.5.7.48.1.2", T != null && (this.params = T);
  }, It(L.asn1.x509.OCSPNonce, L.asn1.x509.Extension), L.asn1.x509.OCSPNoCheck = function(T) {
    L.asn1.x509.OCSPNoCheck.superclass.constructor.call(this, T), this.params = void 0, this.getExtnValueHex = function() {
      return this.asn1ExtnValue = new L.asn1.DERNull(), this.asn1ExtnValue.tohex();
    }, this.oid = "1.3.6.1.5.5.7.48.1.5", T != null && (this.params = T);
  }, It(L.asn1.x509.OCSPNoCheck, L.asn1.x509.Extension), L.asn1.x509.AdobeTimeStamp = function(T) {
    L.asn1.x509.AdobeTimeStamp.superclass.constructor.call(this, T);
    var C = L, I = C.asn1, R = I.DERInteger, M = I.DERBoolean, N = I.DERSequence, Y = I.x509.GeneralName;
    this.params = null, this.getExtnValueHex = function() {
      var q = this.params, oe = [new R(1)];
      return oe.push(new Y({ uri: q.uri })), q.reqauth != null && oe.push(new M(q.reqauth)), this.asn1ExtnValue = new N({ array: oe }), this.asn1ExtnValue.tohex();
    }, this.oid = "1.2.840.113583.1.1.9.1", T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.AdobeTimeStamp, L.asn1.x509.Extension), L.asn1.x509.X500Name = function(T) {
    L.asn1.x509.X500Name.superclass.constructor.call(this), this.asn1Array = [], this.paramArray = [], this.sRule = "utf8";
    var C = L, I = C.asn1, R = I.x509, M = R.RDN;
    this.setByString = function(N, Y) {
      Y !== void 0 && (this.sRule = Y);
      var q = N.split("/");
      q.shift();
      for (var oe = [], J = 0; J < q.length; J++)
        if (q[J].match(/^[^=]+=.+$/))
          oe.push(q[J]);
        else {
          var de = oe.length - 1;
          oe[de] = oe[de] + "/" + q[J];
        }
      for (var J = 0; J < oe.length; J++)
        this.asn1Array.push(new M({ str: oe[J], rule: this.sRule }));
    }, this.setByLdapString = function(N, Y) {
      Y !== void 0 && (this.sRule = Y);
      var q = R.X500Name.ldapToCompat(N);
      this.setByString(q, Y);
    }, this.setByObject = function(N, Y) {
      Y !== void 0 && (this.sRule = Y);
      for (var q in N)
        if (N.hasOwnProperty(q)) {
          var oe = new M({ str: q + "=" + N[q], rule: this.sRule });
          this.asn1Array ? this.asn1Array.push(oe) : this.asn1Array = [oe];
        }
    }, this.setByParam = function(N) {
      if (N.rule !== void 0 && (this.sRule = N.rule), N.array !== void 0)
        this.paramArray = N.array;
      else if (N.str !== void 0)
        this.setByString(N.str);
      else if (N.ldapstr !== void 0)
        this.setByLdapString(N.ldapstr);
      else if (N.hex !== void 0)
        this.hTLV = N.hex;
      else if (N.certissuer !== void 0) {
        var Y = new mr();
        Y.readCertPEM(N.certissuer), this.hTLV = Y.getIssuerHex();
      } else if (N.certsubject !== void 0) {
        var Y = new mr();
        Y.readCertPEM(N.certsubject), this.hTLV = Y.getSubjectHex();
      } else
        typeof N == "object" && N.certsubject === void 0 && N.certissuer === void 0 && this.setByObject(N);
    }, this.tohex = function() {
      if (typeof this.hTLV == "string")
        return this.hTLV;
      if (this.asn1Array.length == 0 && this.paramArray.length > 0)
        for (var N = 0; N < this.paramArray.length; N++) {
          var Y = { array: this.paramArray[N] };
          this.sRule != "utf8" && (Y.rule = this.sRule);
          var q = new M(Y);
          this.asn1Array.push(q);
        }
      var oe = new I.DERSequence({ array: this.asn1Array });
      return this.hTLV = oe.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.X500Name, L.asn1.ASN1Object), L.asn1.x509.X500Name.compatToLDAP = function(T) {
    if (T.substr(0, 1) !== "/")
      throw "malformed input";
    T = T.substr(1);
    var C = T.split("/");
    return C.reverse(), C = C.map(function(I) {
      return I.replace(/,/, "\\,");
    }), C.join(",");
  }, L.asn1.x509.X500Name.onelineToLDAP = function(T) {
    return L.asn1.x509.X500Name.compatToLDAP(T);
  }, L.asn1.x509.X500Name.ldapToCompat = function(T) {
    for (var C = T.split(","), I = !1, R = [], M = 0; C.length > 0; M++) {
      var N = C.shift();
      if (I === !0) {
        var Y = R.pop(), q = (Y + "," + N).replace(/\\,/g, ",");
        R.push(q), I = !1;
      } else
        R.push(N);
      N.substr(-1, 1) === "\\" && (I = !0);
    }
    return R = R.map(function(oe) {
      return oe.replace("/", "\\/");
    }), R.reverse(), "/" + R.join("/");
  }, L.asn1.x509.X500Name.ldapToOneline = function(T) {
    return L.asn1.x509.X500Name.ldapToCompat(T);
  }, L.asn1.x509.RDN = function(T) {
    L.asn1.x509.RDN.superclass.constructor.call(this), this.asn1Array = [], this.paramArray = [], this.sRule = "utf8";
    var C = L.asn1.x509.AttributeTypeAndValue;
    this.setByParam = function(I) {
      I.rule !== void 0 && (this.sRule = I.rule), I.str !== void 0 && this.addByMultiValuedString(I.str), I.array !== void 0 && (this.paramArray = I.array);
    }, this.addByString = function(I) {
      this.asn1Array.push(new L.asn1.x509.AttributeTypeAndValue({ str: I, rule: this.sRule }));
    }, this.addByMultiValuedString = function(I) {
      for (var R = L.asn1.x509.RDN.parseString(I), M = 0; M < R.length; M++)
        this.addByString(R[M]);
    }, this.tohex = function() {
      if (this.asn1Array.length == 0 && this.paramArray.length > 0)
        for (var I = 0; I < this.paramArray.length; I++) {
          var R = this.paramArray[I];
          R.rule !== void 0 && this.sRule != "utf8" && (R.rule = this.sRule);
          var M = new C(R);
          this.asn1Array.push(M);
        }
      var N = new L.asn1.DERSet({ array: this.asn1Array });
      return this.TLV = N.tohex(), this.TLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.RDN, L.asn1.ASN1Object), L.asn1.x509.RDN.parseString = function(T) {
    for (var C = T.split(/\+/), I = !1, R = [], M = 0; C.length > 0; M++) {
      var N = C.shift();
      if (I === !0) {
        var Y = R.pop(), q = (Y + "+" + N).replace(/\\\+/g, "+");
        R.push(q), I = !1;
      } else
        R.push(N);
      N.substr(-1, 1) === "\\" && (I = !0);
    }
    for (var oe = !1, J = [], M = 0; R.length > 0; M++) {
      var N = R.shift();
      if (oe === !0) {
        var de = J.pop();
        if (N.match(/"$/)) {
          var q = (de + "+" + N).replace(/^([^=]+)="(.*)"$/, "$1=$2");
          J.push(q), oe = !1;
        } else
          J.push(de + "+" + N);
      } else
        J.push(N);
      N.match(/^[^=]+="/) && (oe = !0);
    }
    return J;
  }, L.asn1.x509.AttributeTypeAndValue = function(T) {
    L.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this), this.sRule = "utf8", this.sType = null, this.sValue = null, this.dsType = null;
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DERUTF8String, N = I.DERPrintableString, Y = I.DERTeletexString, q = I.DERIA5String, oe = I.DERVisibleString, J = I.DERBMPString, de = C.lang.String.isMail, se = C.lang.String.isPrintable;
    this.setByParam = function(j) {
      if (j.rule !== void 0 && (this.sRule = j.rule), j.ds !== void 0 && (this.dsType = j.ds), j.value === void 0 && j.str !== void 0) {
        var ee = j.str, W = ee.match(/^([^=]+)=(.+)$/);
        if (W)
          this.sType = W[1], this.sValue = W[2];
        else
          throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
      } else
        this.sType = j.type, this.sValue = j.value;
    }, this.setByString = function(j, ee) {
      ee !== void 0 && (this.sRule = ee);
      var W = j.match(/^([^=]+)=(.+)$/);
      if (W)
        this.setByAttrTypeAndValueStr(W[1], W[2]);
      else
        throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
    }, this._getDsType = function() {
      var j = this.sType, ee = this.sValue, W = this.sRule;
      return W === "prn" ? j == "CN" && de(ee) ? "ia5" : se(ee) ? "prn" : "utf8" : W === "utf8" ? j == "CN" && de(ee) ? "ia5" : j == "C" ? "prn" : "utf8" : "utf8";
    }, this.setByAttrTypeAndValueStr = function(j, ee, W) {
      W !== void 0 && (this.sRule = W), this.sType = j, this.sValue = ee;
    }, this.getValueObj = function(j, ee) {
      if (j == "utf8")
        return new M({ str: ee });
      if (j == "prn")
        return new N({ str: ee });
      if (j == "tel")
        return new Y({ str: ee });
      if (j == "ia5")
        return new q({ str: ee });
      if (j == "vis")
        return new oe({ str: ee });
      if (j == "bmp")
        return new J({ str: ee });
      throw new Error("unsupported directory string type: type=" + j + " value=" + ee);
    }, this.tohex = function() {
      this.dsType == null && (this.dsType = this._getDsType());
      var j = L.asn1.x509.OID.atype2obj(this.sType), ee = this.getValueObj(this.dsType, this.sValue), W = new R({ array: [j, ee] });
      return this.TLV = W.tohex(), this.TLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.AttributeTypeAndValue, L.asn1.ASN1Object), L.asn1.x509.SubjectPublicKeyInfo = function(T) {
    L.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERInteger, M = I.DERBitString, N = I.DERObjectIdentifier, Y = I.DERSequence, q = I.ASN1Util.newObject, oe = I.x509, J = oe.AlgorithmIdentifier, de = C.crypto;
    de.ECDSA, de.DSA, this.getASN1Object = function() {
      if (this.asn1AlgId == null || this.asn1SubjPKey == null)
        throw "algId and/or subjPubKey not set";
      var se = new Y({ array: [this.asn1AlgId, this.asn1SubjPKey] });
      return se;
    }, this.tohex = function() {
      var se = this.getASN1Object();
      return this.hTLV = se.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setPubKey = function(se) {
      try {
        if (se instanceof Er) {
          var j = q({ seq: [{ int: { bigint: se.n } }, { int: { int: se.e } }] }), ee = j.tohex();
          this.asn1AlgId = new J({ name: "rsaEncryption" }), this.asn1SubjPKey = new M({ hex: "00" + ee });
        }
      } catch {
      }
      try {
        if (se instanceof L.crypto.ECDSA) {
          var W = new N({ name: se.curveName });
          this.asn1AlgId = new J({ name: "ecPublicKey", asn1params: W }), this.asn1SubjPKey = new M({ hex: "00" + se.pubKeyHex });
        }
      } catch {
      }
      try {
        if (se instanceof L.crypto.DSA) {
          var W = new q({ seq: [{ int: { bigint: se.p } }, { int: { bigint: se.q } }, { int: { bigint: se.g } }] });
          this.asn1AlgId = new J({ name: "dsa", asn1params: W });
          var re = new R({ bigint: se.y });
          this.asn1SubjPKey = new M({ hex: "00" + re.tohex() });
        }
      } catch {
      }
    }, T !== void 0 && this.setPubKey(T);
  }, It(L.asn1.x509.SubjectPublicKeyInfo, L.asn1.ASN1Object), L.asn1.x509.Time = function(T) {
    L.asn1.x509.Time.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERUTCTime, M = I.DERGeneralizedTime;
    this.params = null, this.type = null, this.setTimeParams = function(N) {
      this.timeParams = N;
    }, this.setByParam = function(N) {
      this.params = N;
    }, this.getType = function(N) {
      return N.match(/^[0-9]{12}Z$/) ? "utc" : N.match(/^[0-9]{14}Z$/) ? "gen" : N.match(/^[0-9]{12}\.[0-9]+Z$/) ? "utc" : N.match(/^[0-9]{14}\.[0-9]+Z$/) ? "gen" : null;
    }, this.tohex = function() {
      var N = this.params, Y = null;
      if (typeof N == "string" && (N = { str: N }), N != null && N.str && (N.type == null || N.type == null) && (N.type = this.getType(N.str)), N != null && N.str ? (N.type == "utc" && (Y = new R(N.str)), N.type == "gen" && (Y = new M(N.str))) : this.type == "gen" ? Y = new M() : Y = new R(), Y == null)
        throw new Error("wrong setting for Time");
      return this.TLV = Y.tohex(), this.TLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, L.asn1.x509.Time_bak = function(T) {
    L.asn1.x509.Time_bak.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERUTCTime, M = I.DERGeneralizedTime;
    this.setTimeParams = function(N) {
      this.timeParams = N;
    }, this.tohex = function() {
      var N = null;
      return this.timeParams != null ? this.type == "utc" ? N = new R(this.timeParams) : N = new M(this.timeParams) : this.type == "utc" ? N = new R() : N = new M(), this.TLV = N.tohex(), this.TLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.type = "utc", T !== void 0 && (T.type !== void 0 ? this.type = T.type : T.str !== void 0 && (T.str.match(/^[0-9]{12}Z$/) && (this.type = "utc"), T.str.match(/^[0-9]{14}Z$/) && (this.type = "gen")), this.timeParams = T);
  }, It(L.asn1.x509.Time, L.asn1.ASN1Object), L.asn1.x509.AlgorithmIdentifier = function(T) {
    L.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this), this.nameAlg = null, this.asn1Alg = null, this.asn1Params = null, this.paramEmpty = !1;
    var C = L, I = C.asn1, R = I.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
    if (this.tohex = function() {
      if (this.nameAlg === null && this.asn1Alg === null)
        throw new Error("algorithm not specified");
      if (this.nameAlg !== null) {
        var N = null;
        for (var Y in R)
          Y === this.nameAlg && (N = R[Y]);
        if (N !== null)
          return this.hTLV = N, this.hTLV;
      }
      this.nameAlg !== null && this.asn1Alg === null && (this.asn1Alg = I.x509.OID.name2obj(this.nameAlg));
      var q = [this.asn1Alg];
      this.asn1Params !== null && q.push(this.asn1Params);
      var oe = new I.DERSequence({ array: q });
      return this.hTLV = oe.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && (T.name !== void 0 && (this.nameAlg = T.name), T.asn1params !== void 0 && (this.asn1Params = T.asn1params), T.paramempty !== void 0 && (this.paramEmpty = T.paramempty)), this.asn1Params === null && this.paramEmpty === !1 && this.nameAlg !== null) {
      this.nameAlg.name !== void 0 && (this.nameAlg = this.nameAlg.name);
      var M = this.nameAlg.toLowerCase();
      M.substr(-7, 7) !== "withdsa" && M.substr(-9, 9) !== "withecdsa" && (this.asn1Params = new I.DERNull());
    }
  }, It(L.asn1.x509.AlgorithmIdentifier, L.asn1.ASN1Object), L.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV = { SHAwithRSAandMGF1: "300d06092a864886f70d01010a3000", SHA256withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040201a11a301806092a864886f70d010108300b0609608648016503040201a203020120", SHA384withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040202a11a301806092a864886f70d010108300b0609608648016503040202a203020130", SHA512withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040203a11a301806092a864886f70d010108300b0609608648016503040203a203020140" }, L.asn1.x509.GeneralName = function(T) {
    L.asn1.x509.GeneralName.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.x509, M = R.X500Name, N = R.OtherName, Y = I.DERIA5String;
    I.DERPrintableString;
    var q = I.DEROctetString, oe = I.DERTaggedObject, J = I.ASN1Object, de = Error;
    this.params = null, this.setByParam = function(se) {
      this.params = se;
    }, this.tohex = function() {
      var se = this.params, j, W, ee, W = !1;
      if (se.other !== void 0)
        j = "a0", ee = new N(se.other);
      else if (se.rfc822 !== void 0)
        j = "81", ee = new Y({ str: se.rfc822 });
      else if (se.dns !== void 0)
        j = "82", ee = new Y({ str: se.dns });
      else if (se.dn !== void 0)
        j = "a4", W = !0, typeof se.dn == "string" ? ee = new M({ str: se.dn }) : se.dn instanceof L.asn1.x509.X500Name ? ee = se.dn : ee = new M(se.dn);
      else if (se.ldapdn !== void 0)
        j = "a4", W = !0, ee = new M({ ldapstr: se.ldapdn });
      else if (se.certissuer !== void 0 || se.certsubj !== void 0) {
        j = "a4", W = !0;
        var re, ce, me = null;
        if (se.certsubj !== void 0 ? (re = !1, ce = se.certsubj) : (re = !0, ce = se.certissuer), ce.match(/^[0-9A-Fa-f]+$/), ce.indexOf("-----BEGIN ") != -1 && (me = Ai(ce)), me == null)
          throw new Error("certsubj/certissuer not cert");
        var Ve = new mr();
        Ve.hex = me;
        var at;
        re ? at = Ve.getIssuerHex() : at = Ve.getSubjectHex(), ee = new J(), ee.hTLV = at;
      } else if (se.uri !== void 0)
        j = "86", ee = new Y({ str: se.uri });
      else if (se.ip !== void 0) {
        j = "87";
        var it, ct = se.ip;
        try {
          if (ct.match(/^[0-9a-f]+$/)) {
            var ge = ct.length;
            if (ge == 8 || ge == 16 || ge == 32 || ge == 64)
              it = ct;
            else
              throw "err";
          } else
            it = J2(ct);
        } catch (Re) {
          throw new de("malformed IP address: " + se.ip + ":" + Re.message);
        }
        ee = new q({ hex: it });
      } else
        throw new de("improper params");
      var Se = new oe({ tag: j, explicit: W, obj: ee });
      return Se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.GeneralName, L.asn1.ASN1Object), L.asn1.x509.GeneralNames = function(T) {
    L.asn1.x509.GeneralNames.superclass.constructor.call(this);
    var C = L, I = C.asn1;
    this.setByParamArray = function(R) {
      for (var M = 0; M < R.length; M++) {
        var N = new I.x509.GeneralName(R[M]);
        this.asn1Array.push(N);
      }
    }, this.tohex = function() {
      var R = new I.DERSequence({ array: this.asn1Array });
      return R.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.asn1Array = new Array(), typeof T < "u" && this.setByParamArray(T);
  }, It(L.asn1.x509.GeneralNames, L.asn1.ASN1Object), L.asn1.x509.OtherName = function(T) {
    L.asn1.x509.OtherName.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DERObjectIdentifier, M = I.DERSequence, N = I.ASN1Util.newObject;
    this.params = null, this.setByParam = function(Y) {
      this.params = Y;
    }, this.tohex = function() {
      var Y = this.params;
      if (Y.oid == null || Y.value == null)
        throw new Error("oid or value not specified");
      var q = new R({ oid: Y.oid }), oe = N({ tag: { tag: "a0", explicit: !0, obj: Y.value } }), J = new M({ array: [q, oe] });
      return J.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.x509.OtherName, L.asn1.ASN1Object), L.asn1.x509.OID = new function() {
    var T = L.asn1.DERObjectIdentifier;
    this.name2oidList = { "aes128-CBC": "2.16.840.1.101.3.4.1.2", "aes256-CBC": "2.16.840.1.101.3.4.1.42", sha1: "1.3.14.3.2.26", sha256: "2.16.840.1.101.3.4.2.1", sha384: "2.16.840.1.101.3.4.2.2", sha512: "2.16.840.1.101.3.4.2.3", sha224: "2.16.840.1.101.3.4.2.4", md5: "1.2.840.113549.2.5", md2: "1.3.14.7.2.2.1", ripemd160: "1.3.36.3.2.1", hmacWithSHA1: "1.2.840.113549.2.7", hmacWithSHA224: "1.2.840.113549.2.8", hmacWithSHA256: "1.2.840.113549.2.9", hmacWithSHA384: "1.2.840.113549.2.10", hmacWithSHA512: "1.2.840.113549.2.11", MD2withRSA: "1.2.840.113549.1.1.2", MD4withRSA: "1.2.840.113549.1.1.3", MD5withRSA: "1.2.840.113549.1.1.4", SHA1withRSA: "1.2.840.113549.1.1.5", "pkcs1-MGF": "1.2.840.113549.1.1.8", rsaPSS: "1.2.840.113549.1.1.10", SHA224withRSA: "1.2.840.113549.1.1.14", SHA256withRSA: "1.2.840.113549.1.1.11", SHA384withRSA: "1.2.840.113549.1.1.12", SHA512withRSA: "1.2.840.113549.1.1.13", SHA1withECDSA: "1.2.840.10045.4.1", SHA224withECDSA: "1.2.840.10045.4.3.1", SHA256withECDSA: "1.2.840.10045.4.3.2", SHA384withECDSA: "1.2.840.10045.4.3.3", SHA512withECDSA: "1.2.840.10045.4.3.4", dsa: "1.2.840.10040.4.1", SHA1withDSA: "1.2.840.10040.4.3", SHA224withDSA: "2.16.840.1.101.3.4.3.1", SHA256withDSA: "2.16.840.1.101.3.4.3.2", rsaEncryption: "1.2.840.113549.1.1.1", commonName: "2.5.4.3", countryName: "2.5.4.6", localityName: "2.5.4.7", stateOrProvinceName: "2.5.4.8", streetAddress: "2.5.4.9", organizationName: "2.5.4.10", organizationalUnitName: "2.5.4.11", domainComponent: "0.9.2342.19200300.100.1.25", userId: "0.9.2342.19200300.100.1.1", surname: "2.5.4.4", givenName: "2.5.4.42", title: "2.5.4.12", distinguishedName: "2.5.4.49", emailAddress: "1.2.840.113549.1.9.1", description: "2.5.4.13", businessCategory: "2.5.4.15", postalCode: "2.5.4.17", uniqueIdentifier: "2.5.4.45", organizationIdentifier: "2.5.4.97", jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1", jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2", jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3", subjectDirectoryAttributes: "2.5.29.9", subjectKeyIdentifier: "2.5.29.14", keyUsage: "2.5.29.15", subjectAltName: "2.5.29.17", issuerAltName: "2.5.29.18", basicConstraints: "2.5.29.19", cRLNumber: "2.5.29.20", cRLReason: "2.5.29.21", nameConstraints: "2.5.29.30", cRLDistributionPoints: "2.5.29.31", certificatePolicies: "2.5.29.32", anyPolicy: "2.5.29.32.0", policyMappings: "2.5.29.33", authorityKeyIdentifier: "2.5.29.35", policyConstraints: "2.5.29.36", extKeyUsage: "2.5.29.37", inhibitAnyPolicy: "2.5.29.54", authorityInfoAccess: "1.3.6.1.5.5.7.1.1", ocsp: "1.3.6.1.5.5.7.48.1", ocspBasic: "1.3.6.1.5.5.7.48.1.1", ocspNonce: "1.3.6.1.5.5.7.48.1.2", ocspNoCheck: "1.3.6.1.5.5.7.48.1.5", caIssuers: "1.3.6.1.5.5.7.48.2", anyExtendedKeyUsage: "2.5.29.37.0", serverAuth: "1.3.6.1.5.5.7.3.1", clientAuth: "1.3.6.1.5.5.7.3.2", codeSigning: "1.3.6.1.5.5.7.3.3", emailProtection: "1.3.6.1.5.5.7.3.4", timeStamping: "1.3.6.1.5.5.7.3.8", ocspSigning: "1.3.6.1.5.5.7.3.9", smtpUTF8Mailbox: "1.3.6.1.5.5.7.8.9", dateOfBirth: "1.3.6.1.5.5.7.9.1", placeOfBirth: "1.3.6.1.5.5.7.9.2", gender: "1.3.6.1.5.5.7.9.3", countryOfCitizenship: "1.3.6.1.5.5.7.9.4", countryOfResidence: "1.3.6.1.5.5.7.9.5", ecPublicKey: "1.2.840.10045.2.1", "P-256": "1.2.840.10045.3.1.7", secp256r1: "1.2.840.10045.3.1.7", secp256k1: "1.3.132.0.10", secp384r1: "1.3.132.0.34", secp521r1: "1.3.132.0.35", pkcs5PBES2: "1.2.840.113549.1.5.13", pkcs5PBKDF2: "1.2.840.113549.1.5.12", "des-EDE3-CBC": "1.2.840.113549.3.7", data: "1.2.840.113549.1.7.1", "signed-data": "1.2.840.113549.1.7.2", "enveloped-data": "1.2.840.113549.1.7.3", "digested-data": "1.2.840.113549.1.7.5", "encrypted-data": "1.2.840.113549.1.7.6", "authenticated-data": "1.2.840.113549.1.9.16.1.2", tstinfo: "1.2.840.113549.1.9.16.1.4", signingCertificate: "1.2.840.113549.1.9.16.2.12", timeStampToken: "1.2.840.113549.1.9.16.2.14", signaturePolicyIdentifier: "1.2.840.113549.1.9.16.2.15", etsArchiveTimeStamp: "1.2.840.113549.1.9.16.2.27", signingCertificateV2: "1.2.840.113549.1.9.16.2.47", etsArchiveTimeStampV2: "1.2.840.113549.1.9.16.2.48", extensionRequest: "1.2.840.113549.1.9.14", contentType: "1.2.840.113549.1.9.3", messageDigest: "1.2.840.113549.1.9.4", signingTime: "1.2.840.113549.1.9.5", counterSignature: "1.2.840.113549.1.9.6", archiveTimeStampV3: "0.4.0.1733.2.4", pdfRevocationInfoArchival: "1.2.840.113583.1.1.8", adobeTimeStamp: "1.2.840.113583.1.1.9.1", smimeMailboxLegacy: "2.23.140.1.5.1.1", smimeMailboxMulti: "2.23.140.1.5.1.2", smimeMailboxStrict: "2.23.140.1.5.1.3", smimeOrganizationLegacy: "2.23.140.1.5.2.1", smimeOrganizationMulti: "2.23.140.1.5.2.2", smimeOrganizationStrict: "2.23.140.1.5.2.3", smimeSponsorLegacy: "2.23.140.1.5.3.1", smimeSponsorMulti: "2.23.140.1.5.3.2", smimeSponsorStrict: "2.23.140.1.5.3.3", smimeIndividualLegacy: "2.23.140.1.5.4.1", smimeIndividualMulti: "2.23.140.1.5.4.2", smimeIndividualStrict: "2.23.140.1.5.4.3" }, this.atype2oidList = { CN: "2.5.4.3", L: "2.5.4.7", ST: "2.5.4.8", O: "2.5.4.10", OU: "2.5.4.11", C: "2.5.4.6", STREET: "2.5.4.9", DC: "0.9.2342.19200300.100.1.25", UID: "0.9.2342.19200300.100.1.1", SN: "2.5.4.4", T: "2.5.4.12", GN: "2.5.4.42", DN: "2.5.4.49", E: "1.2.840.113549.1.9.1", description: "2.5.4.13", businessCategory: "2.5.4.15", postalCode: "2.5.4.17", serialNumber: "2.5.4.5", uniqueIdentifier: "2.5.4.45", organizationIdentifier: "2.5.4.97", jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1", jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2", jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3" }, this.objCache = {}, this.name2obj = function(C) {
      if (typeof this.objCache[C] < "u")
        return this.objCache[C];
      if (typeof this.name2oidList[C] > "u")
        throw "Name of ObjectIdentifier not defined: " + C;
      var I = this.name2oidList[C], R = new T({ oid: I });
      return this.objCache[C] = R, R;
    }, this.atype2obj = function(C) {
      if (this.objCache[C] !== void 0)
        return this.objCache[C];
      var I;
      if (C.match(/^\d+\.\d+\.[0-9.]+$/))
        I = C;
      else if (this.atype2oidList[C] !== void 0)
        I = this.atype2oidList[C];
      else if (this.name2oidList[C] !== void 0)
        I = this.name2oidList[C];
      else
        throw new Error("AttributeType name undefined: " + C);
      var R = new T({ oid: I });
      return this.objCache[C] = R, R;
    }, this.registerOIDs = function(C) {
      if (this.checkOIDs(C))
        for (var I in C)
          this.name2oidList[I] = C[I];
    }, this.checkOIDs = function(C) {
      try {
        var I = Object.keys(C);
        return I.length == 0 ? !1 : (I.map(function(R, M, N) {
          var Y = this[R];
          if (!Y.match(/^[0-2]\.[0-9.]+$/))
            throw new Error("value is not OID");
        }, C), !0);
      } catch {
        return !1;
      }
    };
  }(), L.asn1.x509.OID.oid2name = function(T) {
    var C = L.asn1.x509.OID.name2oidList;
    for (var I in C)
      if (C[I] == T)
        return I;
    return "";
  }, L.asn1.x509.OID.oid2atype = function(T) {
    var C = L.asn1.x509.OID.atype2oidList;
    for (var I in C)
      if (C[I] == T)
        return I;
    return T;
  }, L.asn1.x509.OID.name2oid = function(T) {
    if (T.match(/^[0-9.]+$/))
      return T;
    var C = L.asn1.x509.OID.name2oidList;
    return C[T] === void 0 ? "" : C[T];
  }, L.asn1.x509.X509Util = {}, L.asn1.x509.X509Util.newCertPEM = function(T) {
    var C = L.asn1.x509;
    C.TBSCertificate;
    var I = C.Certificate, R = new I(T);
    return R.getPEM();
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), (typeof L.asn1.cms > "u" || !L.asn1.cms) && (L.asn1.cms = {}), L.asn1.cms.Attribute = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.DERSet, Y = R.DERObjectIdentifier;
    this.params = null, this.typeOid = null, this.setByParam = function(q) {
      this.params = q;
    }, this.getValueArray = function() {
      throw new C("not yet implemented abstract");
    }, this.tohex = function() {
      var q = new Y({ oid: this.typeOid }), oe = new N({ array: this.getValueArray() }), J = new M({ array: [q, oe] });
      return J.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    };
  }, It(L.asn1.cms.Attribute, L.asn1.ASN1Object), L.asn1.cms.ContentType = function(T) {
    var C = L, I = C.asn1;
    I.cms.ContentType.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.3", this.getValueArray = function() {
      var R = new I.DERObjectIdentifier(this.params.type);
      return [R];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.ContentType, L.asn1.cms.Attribute), L.asn1.cms.MessageDigest = function(T) {
    var C = L, I = C.asn1, R = I.DEROctetString, M = I.cms;
    M.MessageDigest.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.4", this.getValueArray = function() {
      var N = new R(this.params);
      return [N];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.MessageDigest, L.asn1.cms.Attribute), L.asn1.cms.SigningTime = function(T) {
    var C = L, I = C.asn1;
    I.cms.SigningTime.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.5", this.getValueArray = function() {
      var R = new I.x509.Time(this.params);
      return [R];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SigningTime, L.asn1.cms.Attribute), L.asn1.cms.SigningCertificate = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.cms, Y = N.ESSCertID;
    I.crypto, N.SigningCertificate.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.12", this.getValueArray = function() {
      if (this.params == null || this.params == null || this.params.array == null)
        throw new C("parameter 'array' not specified");
      for (var q = this.params.array, oe = [], J = 0; J < q.length; J++) {
        var de = q[J];
        T.hasis == !1 && typeof de == "string" && (de.indexOf("-----BEGIN") != -1 || lt.isASN1HEX(de)) && (de = { cert: de }), de.hasis != !1 && T.hasis == !1 && (de.hasis = !1), oe.push(new Y(de));
      }
      var se = new M({ array: oe }), j = new M({ array: [se] });
      return [j];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SigningCertificate, L.asn1.cms.Attribute), L.asn1.cms.ESSCertID = function(T) {
    L.asn1.cms.ESSCertID.superclass.constructor.call(this);
    var C = Error, I = L, R = I.asn1, M = R.DEROctetString, N = R.DERSequence, Y = R.cms.IssuerSerial;
    this.params = null, this.getCertHash = function(q, oe) {
      if (q.hash != null)
        return q.hash;
      if (typeof q == "string" && q.indexOf("-----BEGIN") == -1 && !lt.isASN1HEX(q))
        return q;
      var J;
      if (typeof q == "string")
        J = q;
      else if (q.cert != null)
        J = q.cert;
      else
        throw new C("hash nor cert unspecified");
      var de;
      J.indexOf("-----BEGIN") != -1 ? de = Ai(J) : de = J, typeof q == "string" && (q.indexOf("-----BEGIN") != -1 ? de = Ai(q) : lt.isASN1HEX(q) && (de = q));
      var se;
      if (q.alg != null)
        se = q.alg;
      else if (oe != null)
        se = oe;
      else
        throw new C("hash alg unspecified");
      return I.crypto.Util.hashHex(de, se);
    }, this.tohex = function() {
      var q = this.params, oe = this.getCertHash(q, "sha1"), J = [];
      J.push(new M({ hex: oe })), (typeof q == "string" && q.indexOf("-----BEGIN") != -1 || q.cert != null && q.hasis != !1 || q.issuer != null && q.serial != null) && J.push(new Y(q));
      var de = new N({ array: J });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.ESSCertID, L.asn1.ASN1Object), L.asn1.cms.SigningCertificateV2 = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence;
    R.x509;
    var N = R.cms, Y = N.ESSCertIDv2;
    I.crypto, N.SigningCertificateV2.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.47", this.getValueArray = function() {
      if (this.params == null || this.params == null || this.params.array == null)
        throw new C("parameter 'array' not specified");
      for (var q = this.params.array, oe = [], J = 0; J < q.length; J++) {
        var de = q[J];
        (T.alg != null || T.hasis == !1) && typeof de == "string" && (de.indexOf("-----BEGIN") != -1 || lt.isASN1HEX(de)) && (de = { cert: de }), de.alg == null && T.alg != null && (de.alg = T.alg), de.hasis != !1 && T.hasis == !1 && (de.hasis = !1), oe.push(new Y(de));
      }
      var se = new M({ array: oe }), j = new M({ array: [se] });
      return [j];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SigningCertificateV2, L.asn1.cms.Attribute), L.asn1.cms.ESSCertIDv2 = function(T) {
    L.asn1.cms.ESSCertIDv2.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.DEROctetString, M = I.DERSequence, N = I.cms.IssuerSerial, Y = I.x509.AlgorithmIdentifier;
    this.params = null, this.tohex = function() {
      var q = this.params, oe = this.getCertHash(q, "sha256"), J = [];
      q.alg != null && q.alg != "sha256" && J.push(new Y({ name: q.alg })), J.push(new R({ hex: oe })), (typeof q == "string" && q.indexOf("-----BEGIN") != -1 || q.cert != null && q.hasis != !1 || q.issuer != null && q.serial != null) && J.push(new N(q));
      var de = new M({ array: J });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.ESSCertIDv2, L.asn1.cms.ESSCertID), L.asn1.cms.IssuerSerial = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERInteger, N = R.DERSequence, Y = R.cms, q = R.x509, oe = q.GeneralNames, J = mr;
    Y.IssuerSerial.superclass.constructor.call(this), this.setByParam = function(de) {
      this.params = de;
    }, this.tohex = function() {
      var de = this.params, se, j;
      if (typeof de == "string" && de.indexOf("-----BEGIN") != -1 || de.cert != null) {
        var ee;
        de.cert != null ? ee = de.cert : ee = de;
        var W = new J();
        W.readCertPEM(ee), se = W.getIssuer(), j = { hex: W.getSerialNumberHex() };
      } else if (de.issuer != null && de.serial)
        se = de.issuer, j = de.serial;
      else
        throw new C("cert or issuer and serial parameter not specified");
      var re = new oe([{ dn: se }]), ce = new M(j), me = new N({ array: [re, ce] });
      return me.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.IssuerSerial, L.asn1.ASN1Object), L.asn1.cms.SignerIdentifier = function(T) {
    var C = L, I = C.asn1;
    I.DERInteger, I.DERSequence;
    var R = I.cms, M = R.IssuerAndSerialNumber, N = R.SubjectKeyIdentifier, Y = I.x509;
    Y.X500Name, R.SignerIdentifier.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var q = this.params;
      if (q.type == "isssn") {
        var oe = new M(q);
        return oe.tohex();
      } else if (q.type == "skid") {
        var J = new N(q);
        return J.tohex();
      } else
        throw new Error("wrong property for isssn or skid");
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SignerIdentifier, L.asn1.ASN1Object), L.asn1.cms.IssuerAndSerialNumber = function(T) {
    var C = L, I = C.asn1, R = I.DERInteger, M = I.DERSequence, N = I.cms, Y = I.x509, q = Y.X500Name, oe = mr, J = Error;
    N.IssuerAndSerialNumber.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var de = this.params, se, j;
      if (typeof de == "string" && de.indexOf("-----BEGIN") != -1 || de.cert != null) {
        var ee;
        de.cert != null ? ee = de.cert : ee = de;
        var W = new oe();
        W.readCertPEM(ee), se = W.getIssuer(), j = { hex: W.getSerialNumberHex() };
      } else if (de.issuer != null && de.serial)
        se = de.issuer, j = de.serial;
      else
        throw new J("cert or issuer and serial parameter not specified");
      var re = new q(se), ce = new R(j), me = new M({ array: [re, ce] });
      return me.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(de) {
      this.params = de;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.IssuerAndSerialNumber, L.asn1.ASN1Object), L.asn1.cms.SubjectKeyIdentifier = function(T) {
    var C = L, I = C.asn1;
    I.DERInteger, I.DERSequence;
    var R = I.ASN1Util.newObject, M = I.cms;
    M.IssuerAndSerialName, M.SubjectKeyIdentifier;
    var N = I.x509;
    N.X500Name;
    var Y = mr, q = Error;
    M.SubjectKeyIdentifier.superclass.constructor.call(this), this.tohex = function() {
      var oe = this.params;
      if (oe.cert == null && oe.skid == null)
        throw new q("property cert nor skid undefined");
      var J;
      if (oe.cert != null) {
        var de = new Y(oe.cert), se = de.getExtSubjectKeyIdentifier();
        J = se.kid.hex;
      } else
        oe.skid != null && (J = oe.skid);
      var j = R({ tag: { tage: "a0", obj: { octstr: { hex: J } } } });
      return j.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SubjectKeyIdentifier, L.asn1.ASN1Object), L.asn1.cms.AttributeList = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSet, N = R.cms;
    N.AttributeList.superclass.constructor.call(this), this.params = null, this.hTLV = null, this.setByParam = function(Y) {
      this.params = Y;
    }, this.tohex = function() {
      var Y = this.params;
      if (this.hTLV != null)
        return this.hTLV;
      var q = !0;
      Y.sortflag != null && (q = Y.sortflag);
      for (var oe = Y.array, J = [], de = 0; de < oe.length; de++) {
        var se = oe[de], j = se.attr;
        if (j == "contentType")
          J.push(new N.ContentType(se));
        else if (j == "messageDigest")
          J.push(new N.MessageDigest(se));
        else if (j == "signingTime")
          J.push(new N.SigningTime(se));
        else if (j == "signingCertificate")
          J.push(new N.SigningCertificate(se));
        else if (j == "signingCertificateV2")
          J.push(new N.SigningCertificateV2(se));
        else if (j == "signaturePolicyIdentifier")
          J.push(new L.asn1.cades.SignaturePolicyIdentifier(se));
        else if (j == "signatureTimeStamp" || j == "timeStampToken")
          J.push(new L.asn1.cades.SignatureTimeStamp(se));
        else
          throw new C("unknown attr: " + j);
      }
      var ee = new M({ array: J, sortflag: q });
      return this.hTLV = ee.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.AttributeList, L.asn1.ASN1Object), L.asn1.cms.SignerInfo = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERInteger, N = R.DEROctetString, Y = R.DERSequence, q = R.DERTaggedObject, oe = R.cms, J = oe.SignerIdentifier, de = oe.AttributeList;
    oe.ContentType, oe.EncapsulatedContentInfo, oe.MessageDigest, oe.SignedData;
    var se = R.x509, j = se.AlgorithmIdentifier, ee = I.crypto, W = Yr;
    oe.SignerInfo.superclass.constructor.call(this), this.params = null, this.sign = function() {
      var re = this.params, ce = re.sigalg, me = new de(re.sattrs).tohex(), Ve = W.getKey(re.signkey), at = new ee.Signature({ alg: ce });
      at.init(Ve), at.updateHex(me);
      var it = at.sign();
      re.sighex = it;
    }, this.tohex = function() {
      var re = this.params, ce = [];
      if (ce.push(new M({ int: re.version })), ce.push(new J(re.id)), ce.push(new j({ name: re.hashalg })), re.sattrs != null) {
        var me = new de(re.sattrs);
        try {
          ce.push(new q({ tag: "a0", explicit: !1, obj: me }));
        } catch (at) {
          throw new C("si sattr error: " + at);
        }
      }
      if (re.sigalgfield != null ? ce.push(new j({ name: re.sigalgfield })) : ce.push(new j({ name: re.sigalg })), re.sighex == null && re.signkey != null && this.sign(), ce.push(new N({ hex: re.sighex })), re.uattrs != null) {
        var me = new de(re.uattrs);
        try {
          ce.push(new q({ tag: "a1", explicit: !1, obj: me }));
        } catch (it) {
          throw new C("si uattr error: " + it);
        }
      }
      var Ve = new Y({ array: ce });
      return Ve.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SignerInfo, L.asn1.ASN1Object), L.asn1.cms.EncapsulatedContentInfo = function(T) {
    var C = L, I = C.asn1, R = I.DERTaggedObject, M = I.DERSequence, N = I.DERObjectIdentifier, Y = I.DEROctetString, q = I.cms;
    q.EncapsulatedContentInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var oe = this.params, J = [];
      if (J.push(new N(oe.type)), oe.content != null && (oe.content.hex != null || oe.content.str != null) && oe.isDetached != !0) {
        var de = new Y(oe.content), se = new R({ tag: "a0", explicit: !0, obj: de });
        J.push(se);
      }
      var j = new M({ array: J });
      return j.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(oe) {
      this.params = oe;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.EncapsulatedContentInfo, L.asn1.ASN1Object), L.asn1.cms.ContentInfo = function(T) {
    var C = L, I = C.asn1, R = I.DERTaggedObject, M = I.DERSequence, N = I.DERObjectIdentifier, Y = I.x509;
    Y.OID.name2obj, L.asn1.cms.ContentInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var q = this.params, oe = [];
      oe.push(new N(q.type));
      var J = new R({ tag: "a0", explicit: !0, obj: q.obj });
      oe.push(J);
      var de = new M({ array: oe });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(q) {
      this.params = q;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.ContentInfo, L.asn1.ASN1Object), L.asn1.cms.SignedData = function(T) {
    var C = L, I = C.asn1;
    I.ASN1Object;
    var R = I.DERInteger, M = I.DERSet, N = I.DERSequence;
    I.DERTaggedObject;
    var Y = I.cms, q = Y.EncapsulatedContentInfo, oe = Y.SignerInfo, J = Y.ContentInfo, de = Y.CertificateSet, se = Y.RevocationInfoChoices, j = I.x509, ee = j.AlgorithmIdentifier;
    L.asn1.cms.SignedData.superclass.constructor.call(this), this.params = null, this.checkAndFixParam = function() {
      var W = this.params;
      this._setDigestAlgs(W), this._setContentTypeByEContent(W), this._setMessageDigestByEContent(W), this._setSignerInfoVersion(W), this._setSignedDataVersion(W);
    }, this._setDigestAlgs = function(W) {
      for (var re = {}, ce = W.sinfos, me = 0; me < ce.length; me++) {
        var Ve = ce[me];
        re[Ve.hashalg] = 1;
      }
      W.hashalgs = Object.keys(re).sort();
    }, this._setContentTypeByEContent = function(W) {
      for (var re = W.econtent.type, ce = W.sinfos, me = 0; me < ce.length; me++) {
        var Ve = ce[me], at = this._getAttrParamByName(Ve, "contentType");
        at.type = re;
      }
    }, this._setMessageDigestByEContent = function(W) {
      var re = W.econtent;
      W.econtent.type;
      var ce = re.content.hex;
      ce == null && re.type == "data" && re.content.str != null && (ce = Ds(re.content.str));
      for (var me = W.sinfos, Ve = 0; Ve < me.length; Ve++) {
        var at = me[Ve], it = at.hashalg, ct = this._getAttrParamByName(at, "messageDigest"), ge = L.crypto.Util.hashHex(ce, it);
        ct.hex = ge;
      }
    }, this._getAttrParamByName = function(W, re) {
      for (var ce = W.sattrs.array, me = 0; me < ce.length; me++)
        if (ce[me].attr == re)
          return ce[me];
    }, this._setSignerInfoVersion = function(W) {
      for (var re = W.sinfos, ce = 0; ce < re.length; ce++) {
        var me = re[ce], Ve = 1;
        me.id.type == "skid" && (Ve = 3), me.version = Ve;
      }
    }, this._setSignedDataVersion = function(W) {
      var re = this._getSignedDataVersion(W);
      W.version = re;
    }, this._getSignedDataVersion = function(W) {
      if (W.revinfos != null)
        for (var re = W.revinfos, ce = 0; ce < re.length; ce++) {
          var me = re[ce];
          if (me.ocsp != null)
            return 5;
        }
      for (var Ve = W.sinfos, ce = 0; ce < Ve.length; ce++) {
        var at = W.sinfos[ce];
        if (at.version == 3)
          return 3;
      }
      return W.econtent.type != "data" ? 3 : 1;
    }, this.tohex = function() {
      var W = this.params;
      this.getEncodedHexPrepare != null && this.getEncodedHexPrepare(), W.fixed != !0 && this.checkAndFixParam();
      var re = [];
      re.push(new R({ int: W.version }));
      for (var ce = [], me = 0; me < W.hashalgs.length; me++) {
        var Ve = W.hashalgs[me];
        ce.push(new ee({ name: Ve }));
      }
      re.push(new M({ array: ce })), re.push(new q(W.econtent)), W.certs != null && re.push(new de(W.certs)), W.revinfos != null && re.push(new se(W.revinfos));
      for (var at = [], me = 0; me < W.sinfos.length; me++) {
        var it = W.sinfos[me];
        at.push(new oe(it));
      }
      re.push(new M({ array: at }));
      var ct = new N({ array: re });
      return ct.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.getContentInfo = function() {
      var W = new J({ type: "signed-data", obj: this });
      return W;
    }, this.getContentInfoEncodedHex = function() {
      return this.getContentInfo().tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.SignedData, L.asn1.ASN1Object), L.asn1.cms.CertificateSet = function(T) {
    L.asn1.cms.CertificateSet.superclass.constructor.call(this);
    var C = Error, I = L.asn1, R = I.DERTaggedObject, M = I.DERSet, N = I.ASN1Object;
    this.params = null, this.tohex = function() {
      var Y = this.params, q = [], oe;
      if (Y instanceof Array)
        oe = Y;
      else if (Y.array != null)
        oe = Y.array;
      else
        throw new C("cert array not specified");
      for (var J = 0; J < oe.length; J++) {
        var de = oe[J], se = Ai(de), j = new N();
        j.hTLV = se, q.push(j);
      }
      var ee = { array: q };
      Y.sortflag == !1 && (ee.sortflag = !1);
      var W = new M(ee), re = new R({ tag: "a0", explicit: !1, obj: W });
      return re.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.CertificateSet, L.asn1.ASN1Object), L.asn1.cms.RevocationInfoChoices = function(T) {
    L.asn1.cms.RevocationInfoChoices.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var C = this.params;
      if (!C instanceof Array)
        throw new Error("params is not array");
      for (var I = [], R = 0; R < C.length; R++)
        I.push(new L.asn1.cms.RevocationInfoChoice(C[R]));
      var M = L.asn1.ASN1Util.newObject({ tag: { tagi: "a1", obj: { set: I } } });
      return M.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.RevocationInfoChoices, L.asn1.ASN1Object), L.asn1.cms.RevocationInfoChoice = function(T) {
    L.asn1.cms.RevocationInfoChoice.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var C = this.params;
      if (C.crl != null && typeof C.crl == "string") {
        var I = C.crl;
        return C.crl.indexOf("-----BEGIN") != -1 && (I = Ai(C.crl)), I;
      } else if (C.ocsp != null) {
        var R = L.asn1.ASN1Util.newObject({ tag: { tagi: "a1", obj: new L.asn1.cms.OtherRevocationFormat(C) } });
        return R.tohex();
      } else
        throw new Error("property crl or ocsp undefined");
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.RevocationInfoChoice, L.asn1.ASN1Object), L.asn1.cms.OtherRevocationFormat = function(T) {
    L.asn1.cms.OtherRevocationFormat.superclass.constructor.call(this);
    var C = Error, I = L, R = I.asn1, M = R.ASN1Util.newObject, N = I.lang.String.isHex;
    this.params = null, this.tohex = function() {
      var Y = this.params;
      if (Y.ocsp == null)
        throw new C("property ocsp not specified");
      if (!N(Y.ocsp) || !lt.isASN1HEX(Y.ocsp))
        throw new C("ocsp value not ASN.1 hex string");
      var q = M({ seq: [{ oid: "1.3.6.1.5.5.7.16.2" }, { asn1: { tlv: Y.ocsp } }] });
      return q.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cms.OtherRevocationFormat, L.asn1.ASN1Object), L.asn1.cms.CMSUtil = new function() {
  }(), L.asn1.cms.CMSUtil.newSignedData = function(T) {
    return new L.asn1.cms.SignedData(T);
  }, L.asn1.cms.CMSUtil.verifySignedData = function(T) {
    var C = L, I = C.asn1, R = I.cms;
    R.SignerInfo, R.SignedData, R.SigningTime, R.SigningCertificate, R.SigningCertificateV2;
    var M = I.cades;
    M.SignaturePolicyIdentifier;
    var N = C.lang.String.isHex, Y = lt, q = Y.getVbyList, oe = Y.getTLVbyList, J = Y.getIdxbyList, de = Y.getChildIdx, se = Y.getTLV, j = Y.oidname, ee = C.crypto.Util.hashHex;
    T.cms === void 0 && N(T.cms);
    var W = T.cms, re = function(Re, Te) {
      for (var He, ut = 3; ut < 6; ut++)
        if (He = J(Re, 0, [1, 0, ut]), He !== void 0) {
          var vt = Re.substr(He, 2);
          vt === "a0" && (Te.certsIdx = He), vt === "a1" && (Te.revinfosIdx = He), vt === "31" && (Te.signerinfosIdx = He);
        }
    }, ce = function(Re, Te) {
      var He = Te.signerinfosIdx;
      if (He !== void 0) {
        var ut = de(Re, He);
        Te.signerInfoIdxList = ut;
        for (var vt = 0; vt < ut.length; vt++) {
          var Rt = ut[vt], pt = { idx: Rt };
          me(Re, pt), Te.signerInfos.push(pt);
        }
      }
    }, me = function(Re, Te) {
      var He = Te.idx;
      Te.signerid_issuer1 = oe(Re, He, [1, 0], "30"), Te.signerid_serial1 = q(Re, He, [1, 1], "02"), Te.hashalg = j(q(Re, He, [2, 0], "06"));
      var ut = J(Re, He, [3], "a0");
      Te.idxSignedAttrs = ut, Ve(Re, Te, ut);
      var vt = de(Re, He), Rt = vt.length;
      if (Rt < 6)
        throw "malformed SignerInfo";
      Te.sigalg = j(q(Re, He, [Rt - 2, 0], "06")), Te.sigval = q(Re, He, [Rt - 1], "04");
    }, Ve = function(Re, Te, He) {
      var ut = de(Re, He);
      Te.signedAttrIdxList = ut;
      for (var vt = 0; vt < ut.length; vt++) {
        var Rt = ut[vt], pt = q(Re, Rt, [0], "06"), Tt;
        pt === "2a864886f70d010905" ? (Tt = dn(q(Re, Rt, [1, 0])), Te.saSigningTime = Tt) : pt === "2a864886f70d010904" && (Tt = q(Re, Rt, [1, 0], "04"), Te.saMessageDigest = Tt);
      }
    }, at = function(Re, Te) {
      if (q(Re, 0, [0], "06") !== "2a864886f70d010702")
        return Te;
      Te.cmsType = "signedData", Te.econtent = q(Re, 0, [1, 0, 2, 1, 0]), re(Re, Te), Te.signerInfos = [], ce(Re, Te);
    }, it = function(Re, Te) {
      for (var He = Te.parse.signerInfos, ut = He.length, vt = !0, Rt = 0; Rt < ut; Rt++) {
        var pt = He[Rt];
        ge(Re, Te, pt), pt.isValid || (vt = !1);
      }
      Te.isValid = vt;
    }, ct = function(Re, Te, He, ut) {
      var vt = Te.parse.certsIdx, Rt;
      if (Te.certs === void 0) {
        Rt = [], Te.certkeys = [];
        for (var pt = de(Re, vt), Tt = 0; Tt < pt.length; Tt++) {
          var Pt = se(Re, pt[Tt]), Dt = new mr();
          Dt.readCertHex(Pt), Rt[Tt] = Dt, Te.certkeys[Tt] = Dt.getPublicKey();
        }
        Te.certs = Rt;
      } else
        Rt = Te.certs;
      Te.cccc = Rt.length, Te.cccci = pt.length;
      for (var Tt = 0; Tt < Rt.length; Tt++) {
        var Wo = Dt.getIssuerHex(), li = Dt.getSerialNumberHex();
        He.signerid_issuer1 === Wo && He.signerid_serial1 === li && (He.certkey_idx = Tt);
      }
    }, ge = function(Re, Te, He, ut) {
      He.verifyDetail = {};
      var vt = He.verifyDetail, Rt = Te.parse.econtent, pt = He.hashalg, Tt = He.saMessageDigest;
      vt.validMessageDigest = !1, ee(Rt, pt) === Tt && (vt.validMessageDigest = !0), ct(Re, Te, He), vt.validSignatureValue = !1;
      var Pt = He.sigalg, Dt = "31" + se(Re, He.idxSignedAttrs).substr(2);
      He.signedattrshex = Dt;
      var Wo = Te.certs[He.certkey_idx].getPublicKey(), li = new L.crypto.Signature({ alg: Pt });
      li.init(Wo), li.updateHex(Dt);
      var Gn = li.verify(He.sigval);
      vt.validSignatureValue_isValid = Gn, Gn === !0 && (vt.validSignatureValue = !0), He.isValid = !1, vt.validMessageDigest && vt.validSignatureValue && (He.isValid = !0);
    }, Se = { isValid: !1, parse: {} };
    return at(W, Se.parse), it(W, Se), Se;
  }, L.asn1.cms.CMSParser = function() {
    var T = Error, C = mr, I = new C(), R = lt, M = R.getV, N = R.getTLV;
    R.getIdxbyList;
    var Y = R.getTLVbyList, q = R.getTLVbyListEx, oe = R.getVbyList, J = R.getVbyListEx, de = R.getChildIdx;
    this.getCMSSignedData = function(se) {
      var j = Y(se, 0, [1, 0]), ee = this.getSignedData(j);
      return ee;
    }, this.getSignedData = function(se) {
      var j = de(se, 0), ee = {}, W = M(se, j[0]), re = parseInt(W, 16);
      ee.version = re;
      var ce = N(se, j[1]);
      ee.hashalgs = this.getHashAlgArray(ce);
      var me = N(se, j[2]);
      ee.econtent = this.getEContent(me);
      var Ve = q(se, 0, ["[0]"]);
      Ve != null && (ee.certs = this.getCertificateSet(Ve)), q(se, 0, ["[1]"]);
      var at = q(se, 0, [3]);
      return ee.sinfos = this.getSignerInfos(at), ee;
    }, this.getHashAlgArray = function(se) {
      for (var j = de(se, 0), ee = new C(), W = [], re = 0; re < j.length; re++) {
        var ce = N(se, j[re]), me = ee.getAlgorithmIdentifierName(ce);
        W.push(me);
      }
      return W;
    }, this.getEContent = function(se) {
      var j = {}, ee = oe(se, 0, [0]), W = oe(se, 0, [1, 0]);
      return j.type = L.asn1.x509.OID.oid2name(lt.hextooidstr(ee)), j.content = { hex: W }, j;
    }, this.getSignerInfos = function(se) {
      for (var j = [], ee = de(se, 0), W = 0; W < ee.length; W++) {
        var re = N(se, ee[W]), ce = this.getSignerInfo(re);
        j.push(ce);
      }
      return j;
    }, this.getSignerInfo = function(se) {
      var j = {}, ee = de(se, 0), W = R.getInt(se, ee[0], -1);
      W != -1 && (j.version = W);
      var re = N(se, ee[1]), ce = this.getIssuerAndSerialNumber(re);
      j.id = ce;
      var me = N(se, ee[2]), Ve = I.getAlgorithmIdentifierName(me);
      j.hashalg = Ve;
      var at = q(se, 0, ["[0]"]);
      if (at != null) {
        var it = this.getAttributeList(at);
        j.sattrs = it;
      }
      var ct = q(se, 0, [3]), ge = I.getAlgorithmIdentifierName(ct);
      j.sigalg = ge;
      var Se = J(se, 0, [4]);
      j.sighex = Se;
      var Re = q(se, 0, ["[1]"]);
      if (Re != null) {
        var Te = this.getAttributeList(Re);
        j.uattrs = Te;
      }
      return j;
    }, this.getSignerIdentifier = function(se) {
      if (se.substr(0, 2) == "30")
        return this.getIssuerAndSerialNumber(se);
      throw new Error("SKID of signerIdentifier not supported");
    }, this.getIssuerAndSerialNumber = function(se) {
      var j = { type: "isssn" }, ee = de(se, 0), W = N(se, ee[0]);
      j.issuer = I.getX500Name(W);
      var re = M(se, ee[1]);
      return j.serial = { hex: re }, j;
    }, this.getAttributeList = function(se) {
      for (var j = [], ee = de(se, 0), W = 0; W < ee.length; W++) {
        var re = N(se, ee[W]), ce = this.getAttribute(re);
        j.push(ce);
      }
      return { array: j };
    }, this.getAttribute = function(se) {
      var j = {}, ee = de(se, 0), W = R.getOID(se, ee[0]), re = L.asn1.x509.OID.oid2name(W);
      j.attr = re;
      var ce = N(se, ee[1]), me = de(ce, 0);
      if (me.length == 1)
        j.valhex = N(ce, me[0]);
      else {
        for (var Ve = [], at = 0; at < me.length; at++)
          Ve.push(N(ce, me[at]));
        j.valhex = Ve;
      }
      return re == "contentType" ? this.setContentType(j) : re == "messageDigest" ? this.setMessageDigest(j) : re == "signingTime" ? this.setSigningTime(j) : re == "signingCertificate" ? this.setSigningCertificate(j) : re == "signingCertificateV2" ? this.setSigningCertificateV2(j) : re == "signaturePolicyIdentifier" && this.setSignaturePolicyIdentifier(j), j;
    }, this.setContentType = function(se) {
      var j = R.getOIDName(se.valhex, 0, null);
      j != null && (se.type = j, delete se.valhex);
    }, this.setSigningTime = function(se) {
      var j = M(se.valhex, 0), ee = dn(j);
      se.str = ee, delete se.valhex;
    }, this.setMessageDigest = function(se) {
      var j = M(se.valhex, 0);
      se.hex = j, delete se.valhex;
    }, this.setSigningCertificate = function(se) {
      var j = de(se.valhex, 0);
      if (j.length > 0) {
        for (var ee = N(se.valhex, j[0]), W = de(ee, 0), re = [], ce = 0; ce < W.length; ce++) {
          var me = N(ee, W[ce]), Ve = this.getESSCertID(me);
          re.push(Ve);
        }
        se.array = re;
      }
      if (j.length > 1) {
        var at = N(se.valhex, j[1]);
        se.polhex = at;
      }
      delete se.valhex;
    }, this.setSignaturePolicyIdentifier = function(se) {
      var j = de(se.valhex, 0);
      if (j.length > 0) {
        var ee = R.getOID(se.valhex, j[0]);
        se.oid = ee;
      }
      if (j.length > 1) {
        var W = new C(), re = de(se.valhex, j[1]), ce = N(se.valhex, re[0]), me = W.getAlgorithmIdentifierName(ce);
        se.alg = me;
        var Ve = M(se.valhex, re[1]);
        se.hash = Ve;
      }
      delete se.valhex;
    }, this.setSigningCertificateV2 = function(se) {
      var j = de(se.valhex, 0);
      if (j.length > 0) {
        for (var ee = N(se.valhex, j[0]), W = de(ee, 0), re = [], ce = 0; ce < W.length; ce++) {
          var me = N(ee, W[ce]), Ve = this.getESSCertIDv2(me);
          re.push(Ve);
        }
        se.array = re;
      }
      if (j.length > 1) {
        var at = N(se.valhex, j[1]);
        se.polhex = at;
      }
      delete se.valhex;
    }, this.getESSCertID = function(se) {
      var j = {}, ee = de(se, 0);
      if (ee.length > 0) {
        var W = M(se, ee[0]);
        j.hash = W;
      }
      if (ee.length > 1) {
        var re = N(se, ee[1]), ce = this.getIssuerSerial(re);
        ce.serial != null && (j.serial = ce.serial), ce.issuer != null && (j.issuer = ce.issuer);
      }
      return j;
    }, this.getESSCertIDv2 = function(se) {
      var j = {}, ee = de(se, 0);
      if (ee.length < 1 || 3 < ee.length)
        throw new T("wrong number of elements");
      var W = 0;
      if (se.substr(ee[0], 2) == "30") {
        var re = N(se, ee[0]);
        j.alg = I.getAlgorithmIdentifierName(re), W++;
      } else
        j.alg = "sha256";
      var ce = M(se, ee[W]);
      if (j.hash = ce, ee.length > W + 1) {
        var me = N(se, ee[W + 1]), Ve = this.getIssuerSerial(me);
        j.issuer = Ve.issuer, j.serial = Ve.serial;
      }
      return j;
    }, this.getIssuerSerial = function(se) {
      var j = {}, ee = de(se, 0), W = N(se, ee[0]), re = I.getGeneralNames(W), ce = re[0].dn;
      j.issuer = ce;
      var me = M(se, ee[1]);
      return j.serial = { hex: me }, j;
    }, this.getCertificateSet = function(se) {
      for (var j = de(se, 0), ee = [], W = 0; W < j.length; W++) {
        var re = N(se, j[W]);
        if (re.substr(0, 2) == "30") {
          var ce = Go(re, "CERTIFICATE");
          ee.push(ce);
        }
      }
      return { array: ee, sortflag: !1 };
    };
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), (typeof L.asn1.tsp > "u" || !L.asn1.tsp) && (L.asn1.tsp = {}), L.asn1.tsp.TimeStampToken = function(T) {
    var C = L, I = C.asn1, R = I.tsp;
    R.TimeStampToken.superclass.constructor.call(this), this.params = null, this.getEncodedHexPrepare = function() {
      var M = new R.TSTInfo(this.params.econtent.content);
      this.params.econtent.content.hex = M.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.TimeStampToken, L.asn1.cms.SignedData), L.asn1.tsp.TSTInfo = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DERInteger, N = I.DERBoolean, Y = I.DERGeneralizedTime, q = I.DERObjectIdentifier, oe = I.DERTaggedObject, J = I.tsp, de = J.MessageImprint, se = J.Accuracy;
    I.x509.X500Name;
    var j = I.x509.GeneralName;
    if (J.TSTInfo.superclass.constructor.call(this), this.dVersion = new M({ int: 1 }), this.dPolicy = null, this.dMessageImprint = null, this.dSerial = null, this.dGenTime = null, this.dAccuracy = null, this.dOrdering = null, this.dNonce = null, this.dTsa = null, this.tohex = function() {
      var ee = [this.dVersion];
      if (this.dPolicy == null)
        throw new Error("policy shall be specified.");
      if (ee.push(this.dPolicy), this.dMessageImprint == null)
        throw new Error("messageImprint shall be specified.");
      if (ee.push(this.dMessageImprint), this.dSerial == null)
        throw new Error("serialNumber shall be specified.");
      if (ee.push(this.dSerial), this.dGenTime == null)
        throw new Error("genTime shall be specified.");
      ee.push(this.dGenTime), this.dAccuracy != null && ee.push(this.dAccuracy), this.dOrdering != null && ee.push(this.dOrdering), this.dNonce != null && ee.push(this.dNonce), this.dTsa != null && ee.push(this.dTsa);
      var W = new R({ array: ee });
      return this.hTLV = W.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0) {
      if (typeof T.policy == "string") {
        if (!T.policy.match(/^[0-9.]+$/))
          throw "policy shall be oid like 0.1.4.134";
        this.dPolicy = new q({ oid: T.policy });
      }
      T.messageImprint !== void 0 && (this.dMessageImprint = new de(T.messageImprint)), T.serial !== void 0 && (this.dSerial = new M(T.serial)), T.genTime !== void 0 && (this.dGenTime = new Y(T.genTime)), T.accuracy !== void 0 && (this.dAccuracy = new se(T.accuracy)), T.ordering !== void 0 && T.ordering == !0 && (this.dOrdering = new N()), T.nonce !== void 0 && (this.dNonce = new M(T.nonce)), T.tsa !== void 0 && (this.dTsa = new oe({ tag: "a0", explicit: !0, obj: new j({ dn: T.tsa }) }));
    }
  }, It(L.asn1.tsp.TSTInfo, L.asn1.ASN1Object), L.asn1.tsp.Accuracy = function(T) {
    var C = L, I = C.asn1, R = I.ASN1Util.newObject;
    I.tsp.Accuracy.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var M = this.params, N = [];
      return M.seconds != null && typeof M.seconds == "number" && N.push({ int: M.seconds }), M.millis != null && typeof M.millis == "number" && N.push({ tag: { tagi: "80", obj: { int: M.millis } } }), M.micros != null && typeof M.micros == "number" && N.push({ tag: { tagi: "81", obj: { int: M.micros } } }), R({ seq: N }).tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.Accuracy, L.asn1.ASN1Object), L.asn1.tsp.MessageImprint = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DEROctetString, N = I.x509, Y = N.AlgorithmIdentifier;
    I.tsp.MessageImprint.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var q = this.params, oe = new Y({ name: q.alg }), J = new M({ hex: q.hash }), de = new R({ array: [oe, J] });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.tsp.MessageImprint, L.asn1.ASN1Object), L.asn1.tsp.TimeStampReq = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DERInteger, N = I.DERBoolean;
    I.ASN1Object;
    var Y = I.DERObjectIdentifier, q = I.tsp, oe = q.MessageImprint;
    q.TimeStampReq.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var J = this.params, de = [];
      de.push(new M({ int: 1 })), J.messageImprint instanceof L.asn1.ASN1Object ? de.push(J.messageImprint) : de.push(new oe(J.messageImprint)), J.policy != null && de.push(new Y(J.policy)), J.nonce != null && de.push(new M(J.nonce)), J.certreq == !0 && de.push(new N());
      var se = new R({ array: de });
      return se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.TimeStampReq, L.asn1.ASN1Object), L.asn1.tsp.TimeStampResp = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence;
    I.ASN1Object;
    var M = I.tsp, N = M.PKIStatusInfo;
    M.TimeStampResp.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var Y = this.params, q = [];
      if (Y.econtent != null || Y.tst != null)
        if (Y.statusinfo != null ? q.push(new N(Y.statusinfo)) : q.push(new N("granted")), Y.econtent != null)
          q.push(new M.TimeStampToken(Y).getContentInfo());
        else if (Y.tst instanceof I.ASN1Object)
          q.push(Y.tst);
        else
          throw new Error("improper member tst value");
      else if (Y.statusinfo != null)
        q.push(new N(Y.statusinfo));
      else
        throw new Error("parameter for token nor statusinfo not specified");
      var oe = new R({ array: q });
      return oe.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.TimeStampResp, L.asn1.ASN1Object), L.asn1.tsp.PKIStatusInfo = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.tsp, Y = N.PKIStatus, q = N.PKIFreeText, oe = N.PKIFailureInfo;
    N.PKIStatusInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var J = this.params, de = [];
      if (typeof J == "string")
        de.push(new Y(J));
      else {
        if (J.status == null)
          throw new C("property 'status' unspecified");
        de.push(new Y(J.status)), J.statusstr != null && de.push(new q(J.statusstr)), J.failinfo != null && de.push(new oe(J.failinfo));
      }
      var se = new M({ array: de });
      return se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.PKIStatusInfo, L.asn1.ASN1Object), L.asn1.tsp.PKIStatus = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERInteger, N = R.tsp;
    N.PKIStatus.superclass.constructor.call(this);
    var Y = { granted: 0, grantedWithMods: 1, rejection: 2, waiting: 3, revocationWarning: 4, revocationNotification: 5 };
    this.params = null, this.tohex = function() {
      var q = this.params, oe;
      if (typeof q == "string")
        try {
          oe = Y[q];
        } catch {
          throw new C("undefined name: " + q);
        }
      else if (typeof q == "number")
        oe = q;
      else
        throw new C("unsupported params");
      return new M({ int: oe }).tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.PKIStatus, L.asn1.ASN1Object), L.asn1.tsp.PKIFreeText = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.DERUTF8String, Y = R.tsp;
    Y.PKIFreeText.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var q = this.params;
      if (!q instanceof Array)
        throw new C("wrong params: not array");
      for (var oe = [], J = 0; J < q.length; J++)
        oe.push(new N({ str: q[J] }));
      var de = new M({ array: oe });
      return de.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.PKIFreeText, L.asn1.ASN1Object), L.asn1.tsp.PKIFailureInfo = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERBitString, N = R.tsp, Y = N.PKIFailureInfo, q = { badAlg: 0, badRequest: 2, badDataFormat: 5, timeNotAvailable: 14, unacceptedPolicy: 15, unacceptedExtension: 16, addInfoNotAvailable: 17, systemFailure: 25 };
    Y.superclass.constructor.call(this), this.params = null, this.getBinValue = function() {
      var oe = this.params, J = 0;
      if (typeof oe == "number" && 0 <= oe && oe <= 25) {
        J |= 1 << oe;
        for (var de = J.toString(2), se = "", j = de.length - 1; j >= 0; j--)
          se += de[j];
        return se;
      } else {
        if (typeof oe == "string" && q[oe] != null)
          return R_([oe], q);
        if (typeof oe == "object" && oe.length != null)
          return R_(oe, q);
        throw new C("wrong params");
      }
    }, this.tohex = function() {
      this.params;
      var oe = this.getBinValue();
      return new M({ bin: oe }).tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.tsp.PKIFailureInfo, L.asn1.ASN1Object), L.asn1.tsp.AbstractTSAAdapter = function(T) {
    this.getTSTHex = function(C, I) {
      throw "not implemented yet";
    };
  }, L.asn1.tsp.SimpleTSAAdapter = function(T) {
    var C = L, I = C.asn1, R = I.tsp, M = C.crypto.Util.hashHex;
    R.SimpleTSAAdapter.superclass.constructor.call(this), this.params = null, this.serial = 0, this.getTSTHex = function(N, Y) {
      var q = M(N, Y);
      this.params.econtent.content.messageImprint = { alg: Y, hash: q }, this.params.econtent.content.serial = { int: this.serial++ };
      var oe = Math.floor(Math.random() * 1e9);
      this.params.econtent.content.nonce = { int: oe };
      var J = new R.TimeStampToken(this.params);
      return J.getContentInfoEncodedHex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.tsp.SimpleTSAAdapter, L.asn1.tsp.AbstractTSAAdapter), L.asn1.tsp.FixedTSAAdapter = function(T) {
    var C = L, I = C.asn1, R = I.tsp, M = C.crypto.Util.hashHex;
    R.FixedTSAAdapter.superclass.constructor.call(this), this.params = null, this.getTSTHex = function(N, Y) {
      var q = M(N, Y);
      this.params.econtent.content.messageImprint = { alg: Y, hash: q };
      var oe = new R.TimeStampToken(this.params);
      return oe.getContentInfoEncodedHex();
    }, T !== void 0 && (this.params = T);
  }, It(L.asn1.tsp.FixedTSAAdapter, L.asn1.tsp.AbstractTSAAdapter), L.asn1.tsp.TSPUtil = new function() {
  }(), L.asn1.tsp.TSPUtil.newTimeStampToken = function(T) {
    return new L.asn1.tsp.TimeStampToken(T);
  }, L.asn1.tsp.TSPUtil.parseTimeStampReq = function(T) {
    var C = new L.asn1.tsp.TSPParser();
    return C.getTimeStampReq(T);
  }, L.asn1.tsp.TSPUtil.parseMessageImprint = function(T) {
    var C = new L.asn1.tsp.TSPParser();
    return C.getMessageImprint(T);
  }, L.asn1.tsp.TSPParser = function() {
    var T = mr, C = new T(), I = lt, R = I.getV, M = I.getTLV, N = I.getIdxbyList;
    I.getTLVbyListEx;
    var Y = I.getChildIdx, q = ["granted", "grantedWithMods", "rejection", "waiting", "revocationWarning", "revocationNotification"], oe = { 0: "badAlg", 2: "badRequest", 5: "badDataFormat", 14: "timeNotAvailable", 15: "unacceptedPolicy", 16: "unacceptedExtension", 17: "addInfoNotAvailable", 25: "systemFailure" };
    this.getResponse = function(J) {
      var de = Y(J, 0);
      if (de.length == 1)
        return this.getPKIStatusInfo(M(J, de[0]));
      if (de.length > 1) {
        var se = this.getPKIStatusInfo(M(J, de[0])), j = M(J, de[1]), ee = this.getToken(j);
        return ee.statusinfo = se, ee;
      }
    }, this.getToken = function(J) {
      var de = new L.asn1.cms.CMSParser(), se = de.getCMSSignedData(J);
      return this.setTSTInfo(se), se;
    }, this.setTSTInfo = function(J) {
      var de = J.econtent;
      if (de.type == "tstinfo") {
        var se = de.content.hex, j = this.getTSTInfo(se);
        de.content = j;
      }
    }, this.getTSTInfo = function(J) {
      var de = {}, se = Y(J, 0), j = R(J, se[1]);
      de.policy = I_(j);
      var ee = M(J, se[2]);
      de.messageImprint = this.getMessageImprint(ee);
      var W = R(J, se[3]);
      de.serial = { hex: W };
      var re = R(J, se[4]);
      de.genTime = { str: dn(re) };
      var ce = 0;
      if (se.length > 5 && J.substr(se[5], 2) == "30") {
        var me = M(J, se[5]);
        de.accuracy = this.getAccuracy(me), ce++;
      }
      if (se.length > 5 + ce && J.substr(se[5 + ce], 2) == "01") {
        var Ve = R(J, se[5 + ce]);
        Ve == "ff" && (de.ordering = !0), ce++;
      }
      if (se.length > 5 + ce && J.substr(se[5 + ce], 2) == "02") {
        var at = R(J, se[5 + ce]);
        de.nonce = { hex: at }, ce++;
      }
      if (se.length > 5 + ce && J.substr(se[5 + ce], 2) == "a0") {
        var it = M(J, se[5 + ce]);
        it = "30" + it.substr(2), pGeneralNames = C.getGeneralNames(it);
        var ct = pGeneralNames[0].dn;
        de.tsa = ct, ce++;
      }
      if (se.length > 5 + ce && J.substr(se[5 + ce], 2) == "a1") {
        var ge = M(J, se[5 + ce]);
        ge = "30" + ge.substr(2);
        var Se = C.getExtParamArray(ge);
        de.ext = Se, ce++;
      }
      return de;
    }, this.getAccuracy = function(J) {
      for (var de = {}, se = Y(J, 0), j = 0; j < se.length; j++) {
        var ee = J.substr(se[j], 2), W = R(J, se[j]), re = parseInt(W, 16);
        ee == "02" ? de.seconds = re : ee == "80" ? de.millis = re : ee == "81" && (de.micros = re);
      }
      return de;
    }, this.getMessageImprint = function(J) {
      if (J.substr(0, 2) != "30")
        throw new Error("head of messageImprint hex shall be x30");
      var de = {};
      Y(J, 0);
      var se = N(J, 0, [0, 0]), j = R(J, se), ee = I.hextooidstr(j), W = L.asn1.x509.OID.oid2name(ee);
      if (W == "")
        throw new Error("hashAlg name undefined: " + ee);
      var re = W, ce = N(J, 0, [1]);
      return de.alg = re, de.hash = R(J, ce), de;
    }, this.getPKIStatusInfo = function(J) {
      var de = {}, se = Y(J, 0), j = 0;
      try {
        var ee = R(J, se[0]), W = parseInt(ee, 16);
        de.status = q[W];
      } catch {
      }
      if (se.length > 1 && J.substr(se[1], 2) == "30") {
        var re = M(J, se[1]);
        de.statusstr = this.getPKIFreeText(re), j++;
      }
      if (se.length > j && J.substr(se[1 + j], 2) == "03") {
        var ce = M(J, se[1 + j]);
        de.failinfo = this.getPKIFailureInfo(ce);
      }
      return de;
    }, this.getPKIFreeText = function(J) {
      for (var de = [], se = Y(J, 0), j = 0; j < se.length; j++)
        de.push(I.getString(J, se[j]));
      return de;
    }, this.getPKIFailureInfo = function(J) {
      var de = I.getInt(J, 0);
      return oe[de] != null ? oe[de] : de;
    }, this.getTimeStampReq = function(J) {
      var de = {};
      de.certreq = !1;
      var se = Y(J, 0);
      if (se.length < 2)
        throw new Error("TimeStampReq must have at least 2 items");
      var j = M(J, se[1]);
      de.messageImprint = L.asn1.tsp.TSPUtil.parseMessageImprint(j);
      for (var ee = 2; ee < se.length; ee++) {
        var W = se[ee], re = J.substr(W, 2);
        if (re == "06") {
          var ce = R(J, W);
          de.policy = I.hextooidstr(ce);
        }
        re == "02" && (de.nonce = R(J, W)), re == "01" && (de.certreq = !0);
      }
      return de;
    };
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), (typeof L.asn1.cades > "u" || !L.asn1.cades) && (L.asn1.cades = {}), L.asn1.cades.SignaturePolicyIdentifier = function(T) {
    var C = L, I = C.asn1, R = I.cades, M = R.SignaturePolicyId;
    R.SignaturePolicyIdentifier.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.15", this.params = null, this.getValueArray = function() {
      return [new M(this.params)];
    }, this.setByParam = function(N) {
      this.params = N;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.SignaturePolicyIdentifier, L.asn1.cms.Attribute), L.asn1.cades.SignaturePolicyId = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.DERObjectIdentifier, N = I.x509;
    N.AlgorithmIdentifier;
    var Y = I.cades, q = Y.SignaturePolicyId, oe = Y.OtherHashAlgAndValue;
    q.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var J = this.params, de = [];
      de.push(new M(J.oid)), de.push(new oe(J));
      var se = new R({ array: de });
      return se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(J) {
      this.params = J;
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.SignaturePolicyId, L.asn1.ASN1Object), L.asn1.cades.OtherHashAlgAndValue = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.DEROctetString, Y = R.x509, q = Y.AlgorithmIdentifier, oe = R.cades, J = oe.OtherHashAlgAndValue;
    J.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var de = this.params;
      if (de.alg == null)
        throw new C("property 'alg' not specified");
      if (de.hash == null && de.cert == null)
        throw new C("property 'hash' nor 'cert' not specified");
      var se = null;
      if (de.hash != null)
        se = de.hash;
      else if (de.cert != null) {
        if (typeof de.cert != "string")
          throw new C("cert not string");
        var j = de.cert;
        de.cert.indexOf("-----BEGIN") != -1 && (j = Ai(de.cert)), se = L.crypto.Util.hashHex(j, de.alg);
      }
      var ee = [];
      ee.push(new q({ name: de.alg })), ee.push(new N({ hex: se }));
      var W = new M({ array: ee });
      return W.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.OtherHashAlgAndValue, L.asn1.ASN1Object), L.asn1.cades.OtherHashValue = function(T) {
    L.asn1.cades.OtherHashValue.superclass.constructor.call(this);
    var C = Error, I = L;
    I.lang.String.isHex;
    var R = I.asn1, M = R.DEROctetString;
    I.crypto.Util.hashHex, this.params = null, this.tohex = function() {
      var N = this.params;
      if (N.hash == null && N.cert == null)
        throw new C("hash or cert not specified");
      var Y = null;
      if (N.hash != null)
        Y = N.hash;
      else if (N.cert != null) {
        if (typeof N.cert != "string")
          throw new C("cert not string");
        var q = N.cert;
        N.cert.indexOf("-----BEGIN") != -1 && (q = Ai(N.cert)), Y = L.crypto.Util.hashHex(q, "sha1");
      }
      return new M({ hex: Y }).tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.OtherHashValue, L.asn1.ASN1Object), L.asn1.cades.SignatureTimeStamp = function(T) {
    var C = Error, I = L, R = I.lang.String.isHex, M = I.asn1, N = M.ASN1Object;
    M.x509;
    var Y = M.cades;
    Y.SignatureTimeStamp.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.14", this.params = null, this.getValueArray = function() {
      var q = this.params;
      if (q.tst != null)
        if (R(q.tst)) {
          var oe = new N();
          return oe.hTLV = q.tst, [oe];
        } else {
          if (q.tst instanceof N)
            return [q.tst];
          throw new C("params.tst has wrong value");
        }
      else if (q.res != null) {
        var J = q.res;
        if (J instanceof N && (J = J.tohex()), typeof J != "string" || !R(J))
          throw new C("params.res has wrong value");
        lt.getTLVbyList(J, 0, [1]);
        var oe = new N();
        return oe.hTLV = q.tst, [oe];
      }
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.SignatureTimeStamp, L.asn1.cms.Attribute), L.asn1.cades.CompleteCertificateRefs = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.cades, Y = N.OtherCertID, q = I.lang.String.isHex;
    N.CompleteCertificateRefs.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.21", this.params = null, this.getValueArray = function() {
      for (var oe = this.params, J = [], de = 0; de < oe.array.length; de++) {
        var se = oe.array[de];
        if (typeof se == "string")
          if (se.indexOf("-----BEGIN") != -1)
            se = { cert: se };
          else if (q(se))
            se = { hash: se };
          else
            throw new C("unsupported value: " + se);
        oe.alg != null && se.alg == null && (se.alg = oe.alg), oe.hasis != null && se.hasis == null && (se.hasis = oe.hasis);
        var j = new Y(se);
        J.push(j);
      }
      var ee = new M({ array: J });
      return [ee];
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.CompleteCertificateRefs, L.asn1.cms.Attribute), L.asn1.cades.OtherCertID = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.cms, N = M.IssuerSerial, Y = I.cades, q = Y.OtherHashValue, oe = Y.OtherHashAlgAndValue;
    Y.OtherCertID.superclass.constructor.call(this), this.params = T, this.tohex = function() {
      var J = this.params;
      typeof J == "string" && (J.indexOf("-----BEGIN") != -1 ? J = { cert: J } : _isHex(J) && (J = { hash: J }));
      var de = [], se = null;
      if (J.alg != null ? se = new oe(J) : se = new q(J), de.push(se), J.cert != null && J.hasis == !0 || J.issuer != null && J.serial != null) {
        var j = new N(J);
        de.push(j);
      }
      var ee = new R({ array: de });
      return ee.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.OtherCertID, L.asn1.ASN1Object), L.asn1.cades.OtherHash = function(T) {
    var C = L, I = C.asn1;
    I.cms;
    var R = I.cades, M = R.OtherHashAlgAndValue, N = R.OtherHashValue;
    C.crypto.Util.hashHex;
    var Y = C.lang.String.isHex;
    R.OtherHash.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var q = this.params;
      typeof q == "string" && (q.indexOf("-----BEGIN") != -1 ? q = { cert: q } : Y(q) && (q = { hash: q }));
      var oe = null;
      return q.alg != null ? oe = new M(q) : oe = new N(q), oe.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T != null && this.setByParam(T);
  }, It(L.asn1.cades.OtherHash, L.asn1.ASN1Object), L.asn1.cades.CAdESUtil = new function() {
  }(), L.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned = function(T) {
    var C = new L.asn1.cms.CMSParser(), I = C.getCMSSignedData(T);
    return I;
  }, L.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned = function(T, C, I) {
    var R = lt, M = R.getChildIdx, N = R.getTLV, Y = R.getV, q = L, oe = q.asn1, J = oe.ASN1Object, de = oe.cms, se = de.AttributeList, j = de.SignerInfo, ee = {}, W = M(T, C);
    if (W.length != 6)
      throw "not supported items for SignerInfo (!=6)";
    var re = W.shift();
    ee.version = N(T, re);
    var ce = W.shift();
    ee.si = N(T, ce);
    var me = W.shift();
    ee.digalg = N(T, me);
    var Ve = W.shift();
    ee.sattrs = N(T, Ve);
    var at = W.shift();
    ee.sigalg = N(T, at);
    var it = W.shift();
    ee.sig = N(T, it), ee.sigval = Y(T, it);
    var ct = null;
    return ee.obj = new j(), ct = new J(), ct.hTLV = ee.version, ee.obj.dCMSVersion = ct, ct = new J(), ct.hTLV = ee.si, ee.obj.dSignerIdentifier = ct, ct = new J(), ct.hTLV = ee.digalg, ee.obj.dDigestAlgorithm = ct, ct = new J(), ct.hTLV = ee.sattrs, ee.obj.dSignedAttrs = ct, ct = new J(), ct.hTLV = ee.sigalg, ee.obj.dSigAlg = ct, ct = new J(), ct.hTLV = ee.sig, ee.obj.dSig = ct, ee.obj.dUnsignedAttrs = new se(), ee;
  }, (typeof L.asn1.csr > "u" || !L.asn1.csr) && (L.asn1.csr = {}), L.asn1.csr.CertificationRequest = function(T) {
    var C = L, I = C.asn1, R = I.DERBitString, M = I.DERSequence, N = I.csr;
    I.x509;
    var Y = N.CertificationRequestInfo;
    N.CertificationRequest.superclass.constructor.call(this), this.setByParam = function(q) {
      this.params = q;
    }, this.sign = function() {
      var q = new Y(this.params).tohex(), oe = new L.crypto.Signature({ alg: this.params.sigalg });
      oe.init(this.params.sbjprvkey), oe.updateHex(q);
      var J = oe.sign();
      this.params.sighex = J;
    }, this.getPEM = function() {
      return Go(this.tohex(), "CERTIFICATE REQUEST");
    }, this.tohex = function() {
      var q = this.params, oe = new L.asn1.csr.CertificationRequestInfo(this.params), J = new L.asn1.x509.AlgorithmIdentifier({ name: q.sigalg });
      if (q.sighex == null && q.sbjprvkey != null && this.sign(), q.sighex == null)
        throw new Error("sighex or sbjprvkey parameter not defined");
      var de = new R({ hex: "00" + q.sighex }), se = new M({ array: [oe, J, de] });
      return se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.csr.CertificationRequest, L.asn1.ASN1Object), L.asn1.csr.CertificationRequestInfo = function(T) {
    var C = L, I = C.asn1;
    I.DERBitString;
    var R = I.DERSequence, M = I.DERInteger, N = I.DERUTF8String, Y = I.DERTaggedObject, q = I.ASN1Util.newObject, oe = I.csr, J = I.x509, de = J.X500Name, se = J.Extensions, j = J.SubjectPublicKeyInfo;
    oe.AttributeList, oe.CertificationRequestInfo.superclass.constructor.call(this), this.params = null, this.setByParam = function(W) {
      W != null && (this.params = W);
    }, this.tohex = function() {
      var W = this.params, re = [];
      if (re.push(new M({ int: 0 })), re.push(new de(W.subject)), re.push(new j(Yr.getKey(W.sbjpubkey))), W.attrs != null) {
        var ce = ee(W.attrs), me = q({ tag: { tage: "a0", obj: ce } });
        re.push(me);
      } else if (W.extreq != null) {
        var Ve = new se(W.extreq), me = q({ tag: { tage: "a0", obj: { seq: [{ oid: "1.2.840.113549.1.9.14" }, { set: [Ve] }] } } });
        re.push(me);
      } else
        re.push(new Y({ tag: "a0", explicit: !1, obj: new N({ str: "" }) }));
      var at = new R({ array: re });
      return at.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    };
    function ee(W) {
      for (var re = Error, ce = L.asn1.x509.Extensions, me = [], Ve = 0; Ve < W.length; Ve++) {
        var at = W[Ve], it = at.attr;
        if (it == "extensionRequest") {
          var ct = new ce(at.ext), ge = { seq: [{ oid: "1.2.840.113549.1.9.14" }, { set: [ct] }] };
          me.push(ge);
        } else if (it == "unstructuredName") {
          var ge = { seq: [{ oid: "1.2.840.113549.1.9.2" }, { set: at.names }] };
          me.push(ge);
        } else if (it == "challengePassword") {
          var ge = { seq: [{ oid: "1.2.840.113549.1.9.7" }, { set: [{ utf8str: at.password }] }] };
          me.push(ge);
        } else
          throw new re("unknown CSR attribute");
      }
      return { set: me };
    }
    T != null && this.setByParam(T);
  }, It(L.asn1.csr.CertificationRequestInfo, L.asn1.ASN1Object), L.asn1.csr.AttributeList = function(T) {
  }, It(L.asn1.csr.AttributeList, L.asn1.ASN1Object), L.asn1.csr.CSRUtil = new function() {
  }(), L.asn1.csr.CSRUtil.newCSRPEM = function(T) {
    var C = L.asn1.csr, I = new C.CertificationRequest(T), R = I.getPEM();
    return R;
  }, L.asn1.csr.CSRUtil.getParam = function(T, C) {
    var I = lt, R = I.getV, M = I.getIdxbyList, N = I.getTLVbyList, Y = I.getTLVbyListEx, q = I.getVbyListEx, oe = function(Ve) {
      var at = M(Ve, 0, [0, 3, 0, 0], "06");
      return R(Ve, at) != "2a864886f70d01090e" ? null : N(Ve, 0, [0, 3, 0, 1, 0], "30");
    }, J = {};
    if (T.indexOf("-----BEGIN CERTIFICATE REQUEST") == -1)
      throw new Error("argument is not PEM file");
    var de = Ai(T, "CERTIFICATE REQUEST");
    C && (J.tbs = N(de, 0, [0]));
    try {
      var se = Y(de, 0, [0, 1]);
      if (se == "3000")
        J.subject = {};
      else {
        var re = new mr();
        J.subject = re.getX500Name(se);
      }
    } catch {
    }
    var j = Y(de, 0, [0, 2]), ee = Yr.getKey(j, null, "pkcs8pub");
    J.sbjpubkey = Yr.getPEM(ee, "PKCS8PUB");
    var W = oe(de), re = new mr();
    W != null && (J.extreq = re.getExtParamArray(W));
    try {
      var ce = Y(de, 0, [1], "30"), re = new mr();
      J.sigalg = re.getAlgorithmIdentifierName(ce);
    } catch {
    }
    try {
      var me = q(de, 0, [2]);
      J.sighex = me;
    } catch {
    }
    return J;
  }, L.asn1.csr.CSRUtil.verifySignature = function(T) {
    try {
      var C = null;
      if (typeof T == "string" && T.indexOf("-----BEGIN CERTIFICATE REQUEST") != -1 ? C = L.asn1.csr.CSRUtil.getParam(T, !0) : typeof T == "object" && T.sbjpubkey != null && T.sigalg != null && T.sighex != null && T.tbs != null && (C = T), C == null)
        return !1;
      var I = new L.crypto.Signature({ alg: C.sigalg });
      return I.init(C.sbjpubkey), I.updateHex(C.tbs), I.verify(C.sighex);
    } catch (R) {
      return alert(R), !1;
    }
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.asn1 > "u" || !L.asn1) && (L.asn1 = {}), (typeof L.asn1.ocsp > "u" || !L.asn1.ocsp) && (L.asn1.ocsp = {}), L.asn1.ocsp.DEFAULT_HASH = "sha1", L.asn1.ocsp.OCSPResponse = function(T) {
    L.asn1.ocsp.OCSPResponse.superclass.constructor.call(this), L.asn1.DEREnumerated;
    var C = L.asn1.ASN1Util.newObject, I = L.asn1.ocsp.ResponseBytes, R = ["successful", "malformedRequest", "internalError", "tryLater", "_not_used_", "sigRequired", "unauthorized"];
    this.params = null, this._getStatusCode = function() {
      var M = this.params.resstatus;
      return typeof M == "number" ? M : typeof M != "string" ? -1 : R.indexOf(M);
    }, this.setByParam = function(M) {
      this.params = M;
    }, this.tohex = function() {
      var M = this.params, N = this._getStatusCode();
      if (N == -1)
        throw new Error("responseStatus not supported: " + M.resstatus);
      if (N != 0)
        return C({ seq: [{ enum: { int: N } }] }).tohex();
      var Y = new I(M);
      return C({ seq: [{ enum: { int: 0 } }, { tag: { tag: "a0", explicit: !0, obj: Y } }] }).tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.OCSPResponse, L.asn1.ASN1Object), L.asn1.ocsp.ResponseBytes = function(T) {
    L.asn1.ocsp.ResponseBytes.superclass.constructor.call(this);
    var C = L.asn1, I = C.DERSequence, R = C.DERObjectIdentifier, M = C.DEROctetString, N = C.ocsp.BasicOCSPResponse;
    this.params = null, this.setByParam = function(Y) {
      this.params = Y;
    }, this.tohex = function() {
      var Y = this.params;
      if (Y.restype != "ocspBasic")
        throw new Error("not supported responseType: " + Y.restype);
      var q = new N(Y), oe = [];
      oe.push(new R({ name: "ocspBasic" })), oe.push(new M({ hex: q.tohex() }));
      var J = new I({ array: oe });
      return J.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.ResponseBytes, L.asn1.ASN1Object), L.asn1.ocsp.BasicOCSPResponse = function(T) {
    L.asn1.ocsp.BasicOCSPResponse.superclass.constructor.call(this);
    var C = Error, I = L.asn1, R = I.ASN1Object, M = I.DERSequence;
    I.DERGeneralizedTime;
    var N = I.DERTaggedObject, Y = I.DERBitString;
    I.x509.Extensions;
    var q = I.x509.AlgorithmIdentifier, oe = I.ocsp;
    oe.ResponderID, _SingleResponseList = oe.SingleResponseList, _ResponseData = oe.ResponseData, this.params = null, this.setByParam = function(J) {
      this.params = J;
    }, this.sign = function() {
      var J = this.params, de = J.tbsresp.tohex(), se = new L.crypto.Signature({ alg: J.sigalg });
      se.init(J.reskey), se.updateHex(de), J.sighex = se.sign();
    }, this.tohex = function() {
      var J = this.params;
      J.tbsresp == null && (J.tbsresp = new _ResponseData(J)), J.sighex == null && J.reskey != null && this.sign();
      var de = [];
      if (de.push(J.tbsresp), de.push(new q({ name: J.sigalg })), de.push(new Y({ hex: "00" + J.sighex })), J.certs != null && J.certs.length != null) {
        for (var se = [], j = 0; j < J.certs.length; j++) {
          var ee = J.certs[j], W = null;
          if (lt.isASN1HEX(ee))
            W = ee;
          else if (ee.match(/-----BEGIN/))
            W = Ai(ee);
          else
            throw new C("certs[" + j + "] not hex or PEM");
          se.push(new R({ tlv: W }));
        }
        var re = new M({ array: se });
        de.push(new N({ tag: "a0", explicit: !0, obj: re }));
      }
      var ce = new M({ array: de });
      return ce.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.BasicOCSPResponse, L.asn1.ASN1Object), L.asn1.ocsp.ResponseData = function(T) {
    L.asn1.ocsp.ResponseData.superclass.constructor.call(this);
    var C = L.asn1, I = C.DERSequence, R = C.DERGeneralizedTime, M = C.DERTaggedObject, N = C.x509.Extensions, Y = C.ocsp, q = Y.ResponderID;
    _SingleResponseList = Y.SingleResponseList, this.params = null, this.tohex = function() {
      var oe = this.params;
      oe.respid != null, oe.prodat != null, oe.array != null;
      var J = [];
      if (J.push(new q(oe.respid)), J.push(new R(oe.prodat)), J.push(new _SingleResponseList(oe.array)), oe.ext != null) {
        var de = new N(oe.ext);
        J.push(new M({ tag: "a1", explicit: !0, obj: de }));
      }
      var se = new I({ array: J });
      return se.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(oe) {
      this.params = oe;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.ResponseData, L.asn1.ASN1Object), L.asn1.ocsp.ResponderID = function(T) {
    L.asn1.ocsp.ResponderID.superclass.constructor.call(this);
    var C = L, I = C.asn1, R = I.ASN1Util.newObject, M = I.x509.X500Name, N = C.lang.String.isHex, Y = Error;
    this.params = null, this.tohex = function() {
      var q = this.params;
      if (q.key != null) {
        var oe = null;
        if (typeof q.key == "string") {
          if (N(q.key) && (oe = q.key), q.key.match(/-----BEGIN CERTIFICATE/)) {
            var J = new mr(q.key), de = J.getExtSubjectKeyIdentifier();
            de != null && (oe = de.kid.hex);
          }
        } else if (q.key instanceof mr) {
          var de = q.key.getExtSubjectKeyIdentifier();
          de != null && (oe = de.kid.hex);
        }
        if (oe == null)
          throw new Y("wrong key member value");
        var se = R({ tag: { tag: "a2", explicit: !0, obj: { octstr: { hex: oe } } } });
        return se.tohex();
      } else if (q.name != null) {
        var j = null;
        if (typeof q.name == "string" && q.name.match(/-----BEGIN CERTIFICATE/)) {
          var J = new mr(q.name);
          j = J.getSubject();
        } else
          q.name instanceof mr ? j = q.name.getSubject() : typeof q.name == "object" && (q.name.array != null || q.name.str != null) && (j = q.name);
        if (j == null)
          throw new Y("wrong name member value");
        var se = R({ tag: { tag: "a1", explicit: !0, obj: new M(j) } });
        return se.tohex();
      }
      throw new Y("key or name not specified");
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(q) {
      this.params = q;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.ResponderID, L.asn1.ASN1Object), L.asn1.ocsp.SingleResponseList = function(T) {
    L.asn1.ocsp.SingleResponseList.superclass.constructor.call(this);
    var C = L.asn1, I = C.DERSequence, R = C.ocsp.SingleResponse;
    this.params = null, this.tohex = function() {
      var M = this.params;
      if (typeof M != "object" || M.length == null)
        throw new Error("params not specified properly");
      for (var N = [], Y = 0; Y < M.length; Y++)
        N.push(new R(M[Y]));
      var q = new I({ array: N });
      return q.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(M) {
      this.params = M;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.SingleResponseList, L.asn1.ASN1Object), L.asn1.ocsp.SingleResponse = function(T) {
    var C = Error, I = L, R = I.asn1, M = R.DERSequence, N = R.DERGeneralizedTime, Y = R.DERTaggedObject, q = R.ocsp, oe = q.CertID, J = q.CertStatus, de = R.x509, se = de.Extensions;
    q.SingleResponse.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var j = this.params, ee = [];
      if (j.certid == null)
        throw new C("certid unspecified");
      if (j.status == null)
        throw new C("status unspecified");
      if (j.thisupdate == null)
        throw new C("thisupdate unspecified");
      if (ee.push(new oe(j.certid)), ee.push(new J(j.status)), ee.push(new N(j.thisupdate)), j.nextupdate != null) {
        var W = new N(j.nextupdate);
        ee.push(new Y({ tag: "a0", explicit: !0, obj: W }));
      }
      if (j.ext != null) {
        var re = new se(j.ext);
        ee.push(new Y({ tag: "a1", explicit: !0, obj: re }));
      }
      var ce = new M({ array: ee });
      return ce.tohex();
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(j) {
      this.params = j;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.SingleResponse, L.asn1.ASN1Object), L.asn1.ocsp.CertID = function(T) {
    var C = L, I = C.asn1, R = I.DEROctetString, M = I.DERInteger, N = I.DERSequence, Y = I.x509, q = Y.AlgorithmIdentifier, oe = I.ocsp;
    oe.DEFAULT_HASH;
    var J = C.crypto, de = J.Util.hashHex, se = mr, j = lt, ee = j.getVbyList;
    oe.CertID.superclass.constructor.call(this), this.DEFAULT_HASH = "sha1", this.params = null, this.setByValue = function(W, re, ce, me) {
      me == null && (me = this.DEFAULT_HASH), this.params = { alg: me, issname: W, isskey: re, sbjsn: ce };
    }, this.setByCert = function(W, re, ce) {
      ce == null && (ce = this.DEFAULT_HASH), this.params = { alg: ce, issuerCert: W, subjectCert: re };
    }, this.getParamByCerts = function(W, re, ce) {
      ce == null && (ce = this.DEFAULT_HASH);
      var me = new se(W), Ve = new se(re), at = de(me.getSubjectHex(), ce), it = me.getPublicKeyHex(), ct = de(ee(it, 0, [1], "03", !0), ce), ge = Ve.getSerialNumberHex(), Se = { alg: ce, issname: at, isskey: ct, sbjsn: ge };
      return Se;
    }, this.tohex = function() {
      if (typeof this.params != "object")
        throw new Error("params not set");
      var W = this.params, re, ce, me, Ve;
      if (W.alg == null ? Ve = this.DEFAULT_HASH : Ve = W.alg, W.issuerCert != null && W.subjectCert != null) {
        var at = this.getParamByCerts(W.issuerCert, W.subjectCert, Ve);
        re = at.issname, ce = at.isskey, me = at.sbjsn;
      } else if (W.issname != null && W.isskey != null && W.sbjsn != null)
        re = W.issname, ce = W.isskey, me = W.sbjsn;
      else
        throw new Error("required param members not defined");
      var it = new q({ name: Ve }), ct = new R({ hex: re }), ge = new R({ hex: ce }), Se = new M({ hex: me }), Re = new N({ array: [it, ct, ge, Se] });
      return this.hTLV = Re.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.CertID, L.asn1.ASN1Object), L.asn1.ocsp.CertStatus = function(T) {
    L.asn1.ocsp.CertStatus.superclass.constructor.call(this), this.params = null, this.tohex = function() {
      var C = this.params;
      if (C.status == "good")
        return "8000";
      if (C.status == "unknown")
        return "8200";
      if (C.status == "revoked") {
        var I = [{ gentime: { str: C.time } }];
        C.reason != null && I.push({ tag: { tag: "a0", explicit: !0, obj: { enum: { int: C.reason } } } });
        var R = { tag: "a1", explicit: !1, obj: { seq: I } };
        return L.asn1.ASN1Util.newObject({ tag: R }).tohex();
      }
      throw new Error("bad status");
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, this.setByParam = function(C) {
      this.params = C;
    }, T !== void 0 && this.setByParam(T);
  }, It(L.asn1.ocsp.CertStatus, L.asn1.ASN1Object), L.asn1.ocsp.Request = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.ocsp;
    if (M.Request.superclass.constructor.call(this), this.dReqCert = null, this.dExt = null, this.tohex = function() {
      var Y = [];
      if (this.dReqCert === null)
        throw "reqCert not set";
      Y.push(this.dReqCert);
      var q = new R({ array: Y });
      return this.hTLV = q.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, typeof T < "u") {
      var N = new M.CertID(T);
      this.dReqCert = N;
    }
  }, It(L.asn1.ocsp.Request, L.asn1.ASN1Object), L.asn1.ocsp.TBSRequest = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.ocsp;
    M.TBSRequest.superclass.constructor.call(this), this.version = 0, this.dRequestorName = null, this.dRequestList = [], this.dRequestExt = null, this.setRequestListByParam = function(N) {
      for (var Y = [], q = 0; q < N.length; q++) {
        var oe = new M.Request(N[0]);
        Y.push(oe);
      }
      this.dRequestList = Y;
    }, this.tohex = function() {
      var N = [];
      if (this.version !== 0)
        throw "not supported version: " + this.version;
      if (this.dRequestorName !== null)
        throw "requestorName not supported";
      var Y = new R({ array: this.dRequestList });
      if (N.push(Y), this.dRequestExt !== null)
        throw "requestExtensions not supported";
      var q = new R({ array: N });
      return this.hTLV = q.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && T.reqList !== void 0 && this.setRequestListByParam(T.reqList);
  }, It(L.asn1.ocsp.TBSRequest, L.asn1.ASN1Object), L.asn1.ocsp.OCSPRequest = function(T) {
    var C = L, I = C.asn1, R = I.DERSequence, M = I.ocsp;
    if (M.OCSPRequest.superclass.constructor.call(this), this.dTbsRequest = null, this.dOptionalSignature = null, this.tohex = function() {
      var Y = [];
      if (this.dTbsRequest !== null)
        Y.push(this.dTbsRequest);
      else
        throw "tbsRequest not set";
      if (this.dOptionalSignature !== null)
        throw "optionalSignature not supported";
      var q = new R({ array: Y });
      return this.hTLV = q.tohex(), this.hTLV;
    }, this.getEncodedHex = function() {
      return this.tohex();
    }, T !== void 0 && T.reqList !== void 0) {
      var N = new M.TBSRequest(T);
      this.dTbsRequest = N;
    }
  }, It(L.asn1.ocsp.OCSPRequest, L.asn1.ASN1Object), L.asn1.ocsp.OCSPUtil = {}, L.asn1.ocsp.OCSPUtil.getRequestHex = function(T, C, I) {
    var R = L, M = R.asn1, N = M.ocsp;
    I === void 0 && (I = N.DEFAULT_HASH);
    var Y = { alg: I, issuerCert: T, subjectCert: C }, q = new N.OCSPRequest({ reqList: [Y] });
    return q.tohex();
  }, L.asn1.ocsp.OCSPUtil.getOCSPResponseInfo = function(T) {
    var C = lt, I = C.getVbyList, R = C.getVbyListEx, M = C.getIdxbyList;
    C.getIdxbyListEx;
    var N = C.getV, Y = {};
    try {
      var q = R(T, 0, [0], "0a");
      Y.responseStatus = parseInt(q, 16);
    } catch {
    }
    if (Y.responseStatus !== 0)
      return Y;
    try {
      var oe = M(T, 0, [1, 0, 1, 0, 0, 2, 0, 1]);
      T.substr(oe, 2) === "80" ? Y.certStatus = "good" : T.substr(oe, 2) === "a1" ? (Y.certStatus = "revoked", Y.revocationTime = dn(I(T, oe, [0]))) : T.substr(oe, 2) === "82" && (Y.certStatus = "unknown");
    } catch {
    }
    try {
      var J = M(T, 0, [1, 0, 1, 0, 0, 2, 0, 2]);
      Y.thisUpdate = dn(N(T, J));
    } catch {
    }
    try {
      var de = M(T, 0, [1, 0, 1, 0, 0, 2, 0, 3]);
      T.substr(de, 2) === "a0" && (Y.nextUpdate = dn(I(T, de, [0])));
    } catch {
    }
    return Y;
  }, L.asn1.ocsp.OCSPParser = function() {
    var T = Error, C = mr, I = new C(), R = lt, M = R.getV, N = R.getTLV, Y = R.getIdxbyList, q = R.getVbyList, oe = R.getTLVbyList, J = R.getVbyListEx, de = R.getTLVbyListEx, se = R.getChildIdx;
    this.getOCSPRequest = function(j) {
      var ee = se(j, 0);
      if (ee.length != 1 && ee.length != 2)
        throw new T("wrong number elements: " + ee.length);
      var W = this.getTBSRequest(N(j, ee[0]));
      return W;
    }, this.getTBSRequest = function(j) {
      var ee = {}, W = de(j, 0, [0], "30");
      ee.array = this.getRequestList(W);
      var re = de(j, 0, ["[2]", 0], "30");
      return re != null && (ee.ext = I.getExtParamArray(re)), ee;
    }, this.getRequestList = function(j) {
      for (var ee = [], W = se(j, 0), re = 0; re < W.length; re++) {
        var j = N(j, W[re]);
        ee.push(this.getRequest(j));
      }
      return ee;
    }, this.getRequest = function(j) {
      var ee = se(j, 0);
      if (ee.length != 1 && ee.length != 2)
        throw new T("wrong number elements: " + ee.length);
      var W = this.getCertID(N(j, ee[0]));
      if (ee.length == 2) {
        var re = Y(j, 0, [1, 0]);
        W.ext = I.getExtParamArray(N(j, re));
      }
      return W;
    }, this.getCertID = function(j) {
      var ee = se(j, 0);
      if (ee.length != 4)
        throw new T("wrong number elements: " + ee.length);
      var W = new C(), re = {};
      return re.alg = W.getAlgorithmIdentifierName(N(j, ee[0])), re.issname = M(j, ee[1]), re.isskey = M(j, ee[2]), re.sbjsn = M(j, ee[3]), re;
    }, this.getOCSPResponse = function(j) {
      var ee = se(j, 0), W, re = M(j, ee[0]), ce = parseInt(re);
      if (ee.length == 1)
        return { resstatus: ce };
      var me = oe(j, 0, [1, 0]);
      return W = this.getResponseBytes(me), W.resstatus = ce, W;
    }, this.getResponseBytes = function(j) {
      var ee = se(j, 0), W, re = oe(j, 0, [1, 0]);
      W = this.getBasicOCSPResponse(re);
      var ce = M(j, ee[0]);
      return W.restype = L.asn1.x509.OID.oid2name(I_(ce)), W;
    }, this.getBasicOCSPResponse = function(j) {
      var ee = se(j, 0), W;
      W = this.getResponseData(N(j, ee[0]));
      var re = new mr();
      W.alg = re.getAlgorithmIdentifierName(N(j, ee[1]));
      var ce = M(j, ee[2]);
      W.sighex = ce.substr(2);
      var me = J(j, 0, ["[0]"]);
      if (me != null) {
        for (var Ve = se(me, 0), at = [], it = 0; it < Ve.length; it++) {
          var ct = N(me, Ve[it]);
          at.push(ct);
        }
        W.certs = at;
      }
      return W;
    }, this.getResponseData = function(j) {
      var ee = se(j, 0), W = ee.length, re = {}, ce = 0;
      j.substr(ee[0], 2) == "a0" && ce++, re.respid = this.getResponderID(N(j, ee[ce++]));
      var me = M(j, ee[ce++]);
      if (re.prodat = dn(me), re.array = this.getSingleResponseList(N(j, ee[ce++])), j.substr(ee[W - 1], 2) == "a1") {
        var Ve = oe(j, ee[W - 1], [0]), at = new mr();
        re.ext = at.getExtParamArray(Ve);
      }
      return re;
    }, this.getResponderID = function(j) {
      var ee = {};
      if (j.substr(0, 2) == "a2") {
        var W = q(j, 0, [0]);
        ee.key = W;
      }
      if (j.substr(0, 2) == "a1") {
        var re = oe(j, 0, [0]), ce = new mr();
        ee.name = ce.getX500Name(re);
      }
      return ee;
    }, this.getSingleResponseList = function(j) {
      for (var ee = se(j, 0), W = [], re = 0; re < ee.length; re++) {
        var ce = this.getSingleResponse(N(j, ee[re]));
        W.push(ce);
      }
      return W;
    }, this.getSingleResponse = function(j) {
      var ee = se(j, 0), W = {}, re = this.getCertID(N(j, ee[0]));
      W.certid = re;
      var ce = this.getCertStatus(N(j, ee[1]));
      if (W.status = ce, j.substr(ee[2], 2) == "18") {
        var me = M(j, ee[2]);
        W.thisupdate = dn(me);
      }
      for (var Ve = 3; Ve < ee.length; Ve++) {
        if (j.substr(ee[Ve], 2) == "a0") {
          var at = q(j, ee[Ve], [0], "18");
          W.nextupdate = dn(at);
        }
        if (j.substr(ee[Ve], 2) == "a1") {
          var it = new mr(), ct = oe(j, 0, [Ve, 0]);
          W.ext = it.getExtParamArray(ct);
        }
      }
      return W;
    }, this.getCertStatus = function(j) {
      var ee = {};
      if (j == "8000")
        return { status: "good" };
      if (j == "8200")
        return { status: "unknown" };
      if (j.substr(0, 2) == "a1") {
        ee.status = "revoked";
        var W = q(j, 0, [0]), re = dn(W);
        ee.time = re;
      }
      return ee;
    };
  };
  var L;
  (typeof L > "u" || !L) && (L = {}), (typeof L.lang > "u" || !L.lang) && (L.lang = {}), L.lang.String = function() {
  };
  function zt(T) {
    for (var C = new Array(), I = 0; I < T.length; I++)
      C[I] = T.charCodeAt(I);
    return C;
  }
  function Yt(T) {
    for (var C = "", I = 0; I < T.length; I++)
      C = C + String.fromCharCode(T[I]);
    return C;
  }
  function ir(T) {
    for (var C = "", I = 0; I < T.length; I++) {
      var R = T[I].toString(16);
      R.length == 1 && (R = "0" + R), C = C + R;
    }
    return C;
  }
  function Hr(T) {
    return ir(zt(T));
  }
  function wi(T) {
    return u(Hr(T));
  }
  function ur(T) {
    return rr(u(Hr(T)));
  }
  function kr(T) {
    return Yt(c(Yn(T)));
  }
  function rr(T) {
    return T = T.replace(/\=/g, ""), T = T.replace(/\+/g, "-"), T = T.replace(/\//g, "_"), T;
  }
  function Yn(T) {
    return T.length % 4 == 2 ? T = T + "==" : T.length % 4 == 3 && (T = T + "="), T = T.replace(/-/g, "+"), T = T.replace(/_/g, "/"), T;
  }
  function Vr(T) {
    return T.length % 2 == 1 && (T = "0" + T), rr(u(T));
  }
  function Br(T) {
    return s(Yn(T));
  }
  var ca, Zn;
  typeof Buffer == "function" ? (ca = function(T) {
    return rr(Buffer.from(T, "utf8").toString("base64"));
  }, Zn = function(T) {
    return Buffer.from(Yn(T), "base64").toString("utf8");
  }) : (ca = function(T) {
    return Vr(A_(C_(T)));
  }, Zn = function(T) {
    return decodeURIComponent(S_(Br(T)));
  });
  function Ps(T) {
    return u(A_(C_(T)));
  }
  function Cc(T) {
    return decodeURIComponent(S_(s(T)));
  }
  function Ic(T) {
    return A_(C_(T)).toLowerCase();
  }
  function dn(T) {
    try {
      return decodeURIComponent(S_(T));
    } catch {
      return null;
    }
  }
  function cIe(T) {
    return dn(lIe(T));
  }
  function lIe(T) {
    for (var C = T.match(/.{1,2}/g), I = [], R = 0; R < C.length; R++) {
      var M = parseInt(C[R], 16);
      161 <= M && M <= 191 ? (I.push("c2"), I.push(C[R])) : 192 <= M && M <= 255 ? (I.push("c3"), I.push((M - 64).toString(16))) : I.push(C[R]);
    }
    return I.join("");
  }
  function Ia(T) {
    for (var C = "", I = 0; I < T.length - 1; I += 2)
      C += String.fromCharCode(parseInt(T.substr(I, 2), 16));
    return C;
  }
  function Ds(T) {
    for (var C = "", I = 0; I < T.length; I++)
      C += ("0" + T.charCodeAt(I).toString(16)).slice(-2);
    return C;
  }
  function G2(T) {
    return u(T);
  }
  function fIe(T) {
    return __(G2(T), 64);
  }
  function __(T, C) {
    return T = T.replace(new RegExp("(.{" + C + "})", "g"), `$1\r
`), T = T.replace(/\s+$/, ""), T;
  }
  function BU(T) {
    var C = T.replace(/[^0-9A-Za-z\/+=]*/g, ""), I = s(C);
    return I;
  }
  function dIe(T, C) {
    return "-----BEGIN " + C + `-----\r
` + __(T, 64) + `\r
-----END ` + C + `-----\r
`;
  }
  function Go(T, C) {
    return "-----BEGIN " + C + `-----\r
` + __(G2(T), 64) + `\r
-----END ` + C + `-----\r
`;
  }
  function Ai(T, C) {
    if (T.indexOf("-----BEGIN ") == -1)
      throw new Error("can't find PEM header");
    return C !== void 0 ? (T = T.replace(new RegExp("^[^]*-----BEGIN " + C + "-----"), ""), T = T.replace(new RegExp("-----END " + C + "-----[^]*$"), "")) : (T = T.replace(/^[^]*-----BEGIN [^-]+-----/, ""), T = T.replace(/-----END [^-]+-----[^]*$/, "")), BU(T);
  }
  function pIe(T) {
    return T.indexOf("-----BEGIN ") == -1 || T.indexOf("-----END ") == -1 ? null : (T = T.replace(/^[\s\S]*?-----BEGIN [^-]+-----/m, ""), T = T.replace(/-----END [\s\S]+$/m, ""), T = T.replace(/\s+/g, ""), T.match(/^[0-9a-zA-Z+/=]+$/) ? T : null);
  }
  function hIe(T) {
    if (T.length % 2 != 0)
      throw "input is not even length";
    if (T.match(/^[0-9A-Fa-f]+$/) == null)
      throw "input is not hexadecimal";
    for (var C = new ArrayBuffer(T.length / 2), I = new DataView(C), R = 0; R < T.length / 2; R++)
      I.setUint8(R, parseInt(T.substr(R * 2, 2), 16));
    return C;
  }
  function vIe(T) {
    for (var C = "", I = new DataView(T), R = 0; R < T.byteLength; R++)
      C += ("00" + I.getUint8(R).toString(16)).slice(-2);
    return C;
  }
  function W2(T) {
    var C, I, R, M, N, Y, q, oe, J, de;
    if (T = MU(T), de = T.match(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/), de)
      return C = parseInt(de[1]), I = parseInt(de[2]) - 1, R = parseInt(de[3]), M = parseInt(de[4]), N = parseInt(de[5]), Y = parseInt(de[6]), q = 0, oe = de[7], oe !== "" && (J = (oe.substr(1) + "00").substr(0, 3), q = parseInt(J)), Date.UTC(C, I, R, M, N, Y, q);
    throw new Error("unsupported zulu format: " + T);
  }
  function EIe(T) {
    var C = new Date(T), I = ("0000" + C.getUTCFullYear()).slice(-4), R = ("00" + (C.getUTCMonth() + 1)).slice(-2), M = ("00" + C.getUTCDate()).slice(-2), N = ("00" + C.getUTCHours()).slice(-2), Y = ("00" + C.getUTCMinutes()).slice(-2), q = ("00" + C.getUTCSeconds()).slice(-2), oe = ("000" + C.getUTCMilliseconds()).slice(-3);
    return oe = oe.replace(/0+$/, ""), oe = oe != "" ? "." + oe : oe, I + R + M + N + Y + q + oe + "Z";
  }
  function kU(T) {
    return Math.round(W2(T) / 1e3);
  }
  function mIe(T) {
    return new Date(W2(T));
  }
  function gIe(T, C, I) {
    var R, M = T.getUTCFullYear();
    if (C) {
      if (M < 1950 || 2049 < M)
        throw "not proper year for UTCTime: " + M;
      R = ("" + M).slice(-2);
    } else
      R = ("000" + M).slice(-4);
    if (R += ("0" + (T.getUTCMonth() + 1)).slice(-2), R += ("0" + T.getUTCDate()).slice(-2), R += ("0" + T.getUTCHours()).slice(-2), R += ("0" + T.getUTCMinutes()).slice(-2), R += ("0" + T.getUTCSeconds()).slice(-2), I) {
      var N = T.getUTCMilliseconds();
      N !== 0 && (N = ("00" + N).slice(-3), N = N.replace(/0+$/g, ""), R += "." + N);
    }
    return R += "Z", R;
  }
  function MU(T) {
    return T.match(/^[0-9]{12}Z$/) || T.match(/^[0-9]{12}[.][0-9]*Z$/) ? T.match(/^[0-4]/) ? "20" + T : "19" + T : T;
  }
  function A_(T) {
    return T.replace(/%/g, "");
  }
  function S_(T) {
    return T.replace(/(..)/g, "%$1");
  }
  function K2(T) {
    var C = "malformed IPv6 address";
    if (!T.match(/^[0-9A-Fa-f:]+$/))
      throw C;
    T = T.toLowerCase();
    var I = T.split(":").length - 1;
    if (I < 2)
      throw C;
    var R = ":".repeat(7 - I + 2);
    T = T.replace("::", R);
    var M = T.split(":");
    if (M.length != 8)
      throw C;
    for (var N = 0; N < 8; N++)
      M[N] = ("0000" + M[N]).slice(-4);
    return M.join("");
  }
  function X2(T) {
    if (!T.match(/^[0-9A-Fa-f]{32}$/))
      throw new Error("malformed IPv6 address: " + T);
    T = T.toLowerCase();
    var C = T.match(/.{1,4}/g);
    C = C.map(function(M) {
      return M.replace(/^0+/, "");
    }), C = C.map(function(M) {
      return M == "" ? "0" : M;
    }), T = ":" + C.join(":") + ":";
    var I = T.match(/:(0:){2,}/g);
    if (I == null)
      return T.slice(1, -1);
    var R = I.sort().slice(-1)[0];
    return T = T.replace(R.substr(0, R.length - 1), ":"), T.substr(0, 2) != "::" && (T = T.substr(1)), T.substr(-2, 2) != "::" && (T = T.substr(0, T.length - 1)), T;
  }
  function b_(T) {
    var C = new Error("malformed hex value");
    if (!T.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))
      throw C;
    if (T.length == 8) {
      var I;
      try {
        return I = parseInt(T.substr(0, 2), 16) + "." + parseInt(T.substr(2, 2), 16) + "." + parseInt(T.substr(4, 2), 16) + "." + parseInt(T.substr(6, 2), 16), I;
      } catch {
        throw C;
      }
    } else if (T.length == 16)
      try {
        return b_(T.substr(0, 8)) + "/" + FU(T.substr(8));
      } catch {
        throw C;
      }
    else {
      if (T.length == 32)
        return X2(T);
      if (T.length == 64) {
        try {
          return X2(T.substr(0, 32)) + "/" + FU(T.substr(32));
        } catch {
          throw C;
        }
        return;
      } else
        return T;
    }
  }
  function FU(T) {
    var C = new Error("malformed mask"), I;
    try {
      I = new f(T, 16).toString(2);
    } catch {
      throw C;
    }
    if (!I.match(/^1*0*$/))
      throw C;
    return I.replace(/0+$/, "").length;
  }
  function J2(T) {
    var C = new Error("malformed IP address");
    if (T = T.toLowerCase(T), !T.match(/^[0-9a-f.:/]+$/))
      throw C;
    if (T.match(/^[0-9.]+$/)) {
      var I = T.split(".");
      if (I.length !== 4)
        throw C;
      var R = "";
      try {
        for (var M = 0; M < 4; M++) {
          var N = parseInt(I[M]);
          R += ("0" + N.toString(16)).slice(-2);
        }
        return R;
      } catch {
        throw C;
      }
    } else if (T.match(/^[0-9.]+\/[0-9]+$/)) {
      var Y = T.split("/");
      return J2(Y[0]) + HU(parseInt(Y[1]), 32);
    } else {
      if (T.match(/^[0-9a-f:]+$/) && T.indexOf(":") !== -1)
        return K2(T);
      if (T.match(/^[0-9a-f:]+\/[0-9]+$/) && T.indexOf(":") !== -1) {
        var Y = T.split("/");
        return K2(Y[0]) + HU(parseInt(Y[1]), 128);
      } else
        throw C;
    }
  }
  function HU(T, C) {
    if (C == 32 && T == 0)
      return "00000000";
    if (C == 128 && T == 0)
      return "00000000000000000000000000000000";
    var I = Array(T + 1).join("1") + Array(C - T + 1).join("0");
    return new f(I, 2).toString(16);
  }
  function Z2(T) {
    function C(M) {
      var N = parseInt(M.substr(0, 2), 16), Y = parseInt(M.substr(2), 16);
      if (N == 0 & Y < 128)
        return String.fromCharCode(Y);
      if (N < 8) {
        var q = 192 | (N & 7) << 3 | (Y & 192) >> 6, oe = 128 | Y & 63;
        return dn(q.toString(16) + oe.toString(16));
      }
      var q = 224 | (N & 240) >> 4, oe = 128 | (N & 15) << 2 | (Y & 192) >> 6, J = 128 | Y & 63;
      return dn(q.toString(16) + oe.toString(16) + J.toString(16));
    }
    var I = T.match(/.{4}/g), R = I.map(C);
    return R.join("");
  }
  function C_(T) {
    for (var C = encodeURIComponent(T), I = "", R = 0; R < C.length; R++)
      C[R] == "%" ? (I = I + C.substr(R, 3), R = R + 2) : I = I + "%" + Hr(C[R]);
    return I;
  }
  function TIe(T) {
    return T = T.replace(/\r\n/mg, `
`), T;
  }
  function yIe(T) {
    return T = T.replace(/\r\n/mg, `
`), T = T.replace(/\n/mg, `\r
`), T;
  }
  L.lang.String.isInteger = function(T) {
    return T.match(/^[0-9]+$/) ? !0 : !!T.match(/^-[0-9]+$/);
  }, L.lang.String.isHex = function(T) {
    return $U(T);
  };
  function $U(T) {
    return !!(T.length % 2 == 0 && (T.match(/^[0-9a-f]+$/) || T.match(/^[0-9A-F]+$/)));
  }
  L.lang.String.isBase64 = function(T) {
    return T = T.replace(/\s+/g, ""), !!(T.match(/^[0-9A-Za-z+\/]+={0,3}$/) && T.length % 4 == 0);
  }, L.lang.String.isBase64URL = function(T) {
    return T.match(/[+/=]/) ? !1 : (T = Yn(T), L.lang.String.isBase64(T));
  };
  function Q2(T) {
    return !!T.match(/^[0-9A-Za-z-_.]+$/);
  }
  L.lang.String.isIntegerArray = function(T) {
    return T = T.replace(/\s+/g, ""), !!T.match(/^\[[0-9,]+\]$/);
  }, L.lang.String.isPrintable = function(T) {
    return T.match(/^[0-9A-Za-z '()+,-./:=?]*$/) !== null;
  }, L.lang.String.isIA5 = function(T) {
    return T.match(/^[\x20-\x21\x23-\x7f]*$/) !== null;
  }, L.lang.String.isMail = function(T) {
    return T.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/) !== null;
  };
  function eI(T) {
    return T.length % 2 == 1 ? "0" + T : T.substr(0, 1) > "7" ? "00" + T : T;
  }
  function _Ie(T) {
    T = T.replace(/^\s*\[\s*/, ""), T = T.replace(/\s*\]\s*$/, ""), T = T.replace(/\s*/g, "");
    try {
      var C = T.split(/,/).map(function(I, R, M) {
        var N = parseInt(I);
        if (N < 0 || 255 < N)
          throw "integer not in range 0-255";
        var Y = ("00" + N.toString(16)).slice(-2);
        return Y;
      }).join("");
      return C;
    } catch (I) {
      throw "malformed integer array string: " + I;
    }
  }
  var AIe = function(T, C) {
    var I = T.length;
    T.length > C.length && (I = C.length);
    for (var R = 0; R < I; R++)
      if (T.charCodeAt(R) != C.charCodeAt(R))
        return R;
    return T.length != C.length ? I : -1;
  };
  function UU(T) {
    var C = function(q) {
      var oe = q.toString(16);
      return oe.length == 1 && (oe = "0" + oe), oe;
    }, I = function(q) {
      var oe = "", J = parseInt(q, 10), de = J.toString(2), se = 7 - de.length % 7;
      se == 7 && (se = 0);
      for (var j = "", ee = 0; ee < se; ee++)
        j += "0";
      de = j + de;
      for (var ee = 0; ee < de.length - 1; ee += 7) {
        var W = de.substr(ee, 7);
        ee != de.length - 7 && (W = "1" + W), oe += C(parseInt(W, 2));
      }
      return oe;
    };
    try {
      if (!T.match(/^[0-9.]+$/))
        return null;
      var R = "", M = T.split("."), N = parseInt(M[0], 10) * 40 + parseInt(M[1], 10);
      R += C(N), M.splice(0, 2);
      for (var Y = 0; Y < M.length; Y++)
        R += I(M[Y]);
      return R;
    } catch {
      return null;
    }
  }
  function I_(T) {
    if (!$U(T))
      return null;
    try {
      var C = [], I = T.substr(0, 2), R = parseInt(I, 16);
      C[0] = new String(Math.floor(R / 40)), C[1] = new String(R % 40);
      for (var M = T.substr(2), N = [], Y = 0; Y < M.length / 2; Y++)
        N.push(parseInt(M.substr(Y * 2, 2), 16));
      for (var q = [], oe = "", Y = 0; Y < N.length; Y++)
        N[Y] & 128 ? oe = oe + O_((N[Y] & 127).toString(2), 7) : (oe = oe + O_((N[Y] & 127).toString(2), 7), q.push(new String(parseInt(oe, 2))), oe = "");
      var J = C.join(".");
      return q.length > 0 && (J = J + "." + q.join(".")), J;
    } catch {
      return null;
    }
  }
  function VU(T) {
    var C = new f(String(T), 10);
    return yv(C);
  }
  function yv(T) {
    var C = T.toString(16);
    if (C.substr(0, 1) != "-")
      return C.length % 2 == 1 ? C = "0" + C : C.match(/^[0-7]/) || (C = "00" + C), C;
    var I = C.substr(1), R = I.length;
    R % 2 == 1 ? R += 1 : C.match(/^[0-7]/) || (R += 2);
    for (var M = "", N = 0; N < R; N++)
      M += "f";
    var Y = new f(M, 16), q = Y.xor(T).add(f.ONE);
    return C = q.toString(16).replace(/^-/, ""), C;
  }
  var O_ = function(T, C, I) {
    return I == null && (I = "0"), T.length >= C ? T : new Array(C - T.length + 1).join(I) + T;
  };
  function jU(T) {
    if (T.length % 2 != 0 || (T = T.toLowerCase(), T.match(/^[0-9a-f]+$/) == null))
      return -1;
    try {
      var C = T.substr(0, 2);
      if (C == "00")
        return parseInt(T.substr(2), 16);
      var I = parseInt(C, 16);
      if (I > 7)
        return -1;
      var R = T.substr(2), M = parseInt(R, 16).toString(2);
      M == "0" && (M = "00000000"), M = M.slice(0, 0 - I);
      var N = parseInt(M, 2);
      return N == NaN ? -1 : N;
    } catch {
      return -1;
    }
  }
  function zU(T) {
    if (typeof T != "number" || T < 0)
      return null;
    var C = Number(T).toString(2), I = 8 - C.length % 8;
    I == 8 && (I = 0), C = C + O_("", I, "0");
    var R = parseInt(C, 2).toString(16);
    R.length % 2 == 1 && (R = "0" + R);
    var M = "0" + I;
    return M + R;
  }
  function qU(T) {
    if (typeof T != "string" || T.length % 2 != 0 || !T.match(/^[0-9a-f]+$/))
      return null;
    try {
      var C = parseInt(T.substr(0, 2), 16);
      if (C < 0 || 7 < C)
        return null;
      for (var I = T.substr(2), R = "", M = 0; M < I.length; M += 2) {
        var N = I.substr(M, 2), Y = parseInt(N, 16).toString(2);
        Y = ("0000000" + Y).slice(-8), R += Y;
      }
      return R.substr(0, R.length - C);
    } catch {
      return null;
    }
  }
  function SIe(T) {
    if (typeof T != "string" || T.match(/^[01]+$/) == null)
      return null;
    try {
      var C = parseInt(T, 2);
      return zU(C);
    } catch {
      return null;
    }
  }
  function R_(T, C) {
    for (var I = 0, R = 0; R < T.length; R++)
      I |= 1 << C[T[R]];
    for (var M = I.toString(2), N = "", R = M.length - 1; R >= 0; R--)
      N += M[R];
    return N;
  }
  function Fn(T, R, I) {
    if (typeof T == "object") {
      for (var R = String(R).split("."), M = 0; M < R.length && T; M++) {
        var N = R[M];
        N.match(/^[0-9]+$/) && (N = parseInt(N)), T = T[N];
      }
      return T || T === !1 ? T : I;
    }
  }
  function It(T, C) {
    var I = function() {
    };
    I.prototype = C.prototype, T.prototype = new I(), T.prototype.constructor = T, T.superclass = C.prototype, C.prototype.constructor == Object.prototype.constructor && (C.prototype.constructor = C);
  }
  (typeof L > "u" || !L) && (L = {}), (typeof L.crypto > "u" || !L.crypto) && (L.crypto = {}), L.crypto.Util = new function() {
    this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHAwithRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: i.algo.MD5, sha1: i.algo.SHA1, sha224: i.algo.SHA224, sha256: i.algo.SHA256, sha384: i.algo.SHA384, sha512: i.algo.SHA512, ripemd160: i.algo.RIPEMD160 }, this.getDigestInfoHex = function(T, C) {
      if (typeof this.DIGESTINFOHEAD[C] > "u")
        throw "alg not supported in Util.DIGESTINFOHEAD: " + C;
      return this.DIGESTINFOHEAD[C] + T;
    }, this.getPaddedDigestInfoHex = function(T, C, I) {
      var R = this.getDigestInfoHex(T, C), M = I / 4;
      if (R.length + 22 > M)
        throw "key is too short for SigAlg: keylen=" + I + "," + C;
      for (var N = "0001", Y = "00" + R, q = "", oe = M - N.length - Y.length, J = 0; J < oe; J += 2)
        q += "ff";
      var de = N + q + Y;
      return de;
    }, this.hashString = function(T, C) {
      var I = new L.crypto.MessageDigest({ alg: C });
      return I.digestString(T);
    }, this.hashHex = function(T, C) {
      var I = new L.crypto.MessageDigest({ alg: C });
      return I.digestHex(T);
    }, this.sha1 = function(T) {
      return this.hashString(T, "sha1");
    }, this.sha256 = function(T) {
      return this.hashString(T, "sha256");
    }, this.sha256Hex = function(T) {
      return this.hashHex(T, "sha256");
    }, this.sha512 = function(T) {
      return this.hashString(T, "sha512");
    }, this.sha512Hex = function(T) {
      return this.hashHex(T, "sha512");
    }, this.isKey = function(T) {
      return T instanceof Er || T instanceof L.crypto.DSA || T instanceof L.crypto.ECDSA;
    };
  }(), L.crypto.Util.md5 = function(T) {
    var C = new L.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" });
    return C.digestString(T);
  }, L.crypto.Util.ripemd160 = function(T) {
    var C = new L.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" });
    return C.digestString(T);
  }, L.crypto.Util.SECURERANDOMGEN = new bc(), L.crypto.Util.getRandomHexOfNbytes = function(T) {
    var C = new Array(T);
    return L.crypto.Util.SECURERANDOMGEN.nextBytes(C), ir(C);
  }, L.crypto.Util.getRandomBigIntegerOfNbytes = function(T) {
    return new f(L.crypto.Util.getRandomHexOfNbytes(T), 16);
  }, L.crypto.Util.getRandomHexOfNbits = function(T) {
    var C = T % 8, I = (T - C) / 8, R = new Array(I + 1);
    return L.crypto.Util.SECURERANDOMGEN.nextBytes(R), R[0] = (255 << C & 255 ^ 255) & R[0], ir(R);
  }, L.crypto.Util.getRandomBigIntegerOfNbits = function(T) {
    return new f(L.crypto.Util.getRandomHexOfNbits(T), 16);
  }, L.crypto.Util.getRandomBigIntegerZeroToMax = function(T) {
    for (var C = T.bitLength(); ; ) {
      var I = L.crypto.Util.getRandomBigIntegerOfNbits(C);
      if (T.compareTo(I) != -1)
        return I;
    }
  }, L.crypto.Util.getRandomBigIntegerMinToMax = function(T, C) {
    var I = T.compareTo(C);
    if (I == 1)
      throw "biMin is greater than biMax";
    if (I == 0)
      return T;
    var R = C.subtract(T), M = L.crypto.Util.getRandomBigIntegerZeroToMax(R);
    return M.add(T);
  }, L.crypto.MessageDigest = function(T) {
    this.setAlgAndProvider = function(C, I) {
      if (C = L.crypto.MessageDigest.getCanonicalAlgName(C), C !== null && I === void 0 && (I = L.crypto.Util.DEFAULTPROVIDER[C]), ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(C) != -1 && I == "cryptojs") {
        try {
          this.md = L.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[C].create();
        } catch (R) {
          throw "setAlgAndProvider hash alg set fail alg=" + C + "/" + R;
        }
        this.updateString = function(R) {
          this.md.update(R);
        }, this.updateHex = function(R) {
          var M = i.enc.Hex.parse(R);
          this.md.update(M);
        }, this.digest = function() {
          var R = this.md.finalize();
          return R.toString(i.enc.Hex);
        }, this.digestString = function(R) {
          return this.updateString(R), this.digest();
        }, this.digestHex = function(R) {
          return this.updateHex(R), this.digest();
        };
      }
      if (":sha256:".indexOf(C) != -1 && I == "sjcl") {
        try {
          this.md = new sjcl.hash.sha256();
        } catch (R) {
          throw "setAlgAndProvider hash alg set fail alg=" + C + "/" + R;
        }
        this.updateString = function(R) {
          this.md.update(R);
        }, this.updateHex = function(R) {
          var M = sjcl.codec.hex.toBits(R);
          this.md.update(M);
        }, this.digest = function() {
          var R = this.md.finalize();
          return sjcl.codec.hex.fromBits(R);
        }, this.digestString = function(R) {
          return this.updateString(R), this.digest();
        }, this.digestHex = function(R) {
          return this.updateHex(R), this.digest();
        };
      }
    }, this.updateString = function(C) {
      throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    }, this.updateHex = function(C) {
      throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    }, this.digest = function() {
      throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
    }, this.digestString = function(C) {
      throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    }, this.digestHex = function(C) {
      throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    }, T !== void 0 && T.alg !== void 0 && (this.algName = T.alg, T.prov === void 0 && (this.provName = L.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
  }, L.crypto.MessageDigest.getCanonicalAlgName = function(T) {
    return typeof T == "string" && (T = T.toLowerCase(), T = T.replace(/-/, "")), T;
  }, L.crypto.MessageDigest.getHashLength = function(T) {
    var C = L.crypto.MessageDigest, I = C.getCanonicalAlgName(T);
    if (C.HASHLENGTH[I] === void 0)
      throw "not supported algorithm: " + T;
    return C.HASHLENGTH[I];
  }, L.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 }, L.crypto.Mac = function(T) {
    this.setAlgAndProvider = function(C, I) {
      if (C = C.toLowerCase(), C == null && (C = "hmacsha1"), C = C.toLowerCase(), C.substr(0, 4) != "hmac")
        throw "setAlgAndProvider unsupported HMAC alg: " + C;
      I === void 0 && (I = L.crypto.Util.DEFAULTPROVIDER[C]), this.algProv = C + "/" + I;
      var R = C.substr(4);
      if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(R) != -1 && I == "cryptojs") {
        try {
          var M = L.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[R];
          this.mac = i.algo.HMAC.create(M, this.pass);
        } catch (N) {
          throw "setAlgAndProvider hash alg set fail hashAlg=" + R + "/" + N;
        }
        this.updateString = function(N) {
          this.mac.update(N);
        }, this.updateHex = function(N) {
          var Y = i.enc.Hex.parse(N);
          this.mac.update(Y);
        }, this.doFinal = function() {
          var N = this.mac.finalize();
          return N.toString(i.enc.Hex);
        }, this.doFinalString = function(N) {
          return this.updateString(N), this.doFinal();
        }, this.doFinalHex = function(N) {
          return this.updateHex(N), this.doFinal();
        };
      }
    }, this.updateString = function(C) {
      throw "updateString(str) not supported for this alg/prov: " + this.algProv;
    }, this.updateHex = function(C) {
      throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
    }, this.doFinal = function() {
      throw "digest() not supported for this alg/prov: " + this.algProv;
    }, this.doFinalString = function(C) {
      throw "digestString(str) not supported for this alg/prov: " + this.algProv;
    }, this.doFinalHex = function(C) {
      throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
    }, this.setPassword = function(C) {
      if (typeof C == "string") {
        var I = C;
        (C.length % 2 == 1 || !C.match(/^[0-9A-Fa-f]+$/)) && (I = Ds(C)), this.pass = i.enc.Hex.parse(I);
        return;
      }
      if (typeof C != "object")
        throw "KJUR.crypto.Mac unsupported password type: " + C;
      var I = null;
      if (C.hex !== void 0) {
        if (C.hex.length % 2 != 0 || !C.hex.match(/^[0-9A-Fa-f]+$/))
          throw "Mac: wrong hex password: " + C.hex;
        I = C.hex;
      }
      if (C.utf8 !== void 0 && (I = Ic(C.utf8)), C.rstr !== void 0 && (I = Ds(C.rstr)), C.b64 !== void 0 && (I = s(C.b64)), C.b64u !== void 0 && (I = Br(C.b64u)), I == null)
        throw "KJUR.crypto.Mac unsupported password type: " + C;
      this.pass = i.enc.Hex.parse(I);
    }, T !== void 0 && (T.pass !== void 0 && this.setPassword(T.pass), T.alg !== void 0 && (this.algName = T.alg, T.prov === void 0 && (this.provName = L.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
  }, L.crypto.Signature = function(T) {
    var C = null;
    if (this._setAlgNames = function() {
      var I = this.algName.match(/^(.+)with(.+)$/);
      I && (this.mdAlgName = I[1].toLowerCase(), this.pubkeyAlgName = I[2].toLowerCase(), this.pubkeyAlgName == "rsaandmgf1" && this.mdAlgName == "sha" && (this.mdAlgName = "sha1"));
    }, this._zeroPaddingOfSignature = function(I, R) {
      for (var M = "", N = R / 4 - I.length, Y = 0; Y < N; Y++)
        M = M + "0";
      return M + I;
    }, this.setAlgAndProvider = function(I, R) {
      if (this._setAlgNames(), R != "cryptojs/jsrsa")
        throw new Error("provider not supported: " + R);
      if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName) != -1) {
        try {
          this.md = new L.crypto.MessageDigest({ alg: this.mdAlgName });
        } catch (M) {
          throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + M);
        }
        this.init = function(M, N) {
          var Y = null;
          try {
            N === void 0 ? Y = Yr.getKey(M) : Y = Yr.getKey(M, N);
          } catch (q) {
            throw "init failed:" + q;
          }
          if (Y.isPrivate === !0)
            this.prvKey = Y, this.state = "SIGN";
          else if (Y.isPublic === !0)
            this.pubKey = Y, this.state = "VERIFY";
          else
            throw "init failed.:" + Y;
        }, this.updateString = function(M) {
          this.md.updateString(M);
        }, this.updateHex = function(M) {
          this.md.updateHex(M);
        }, this.sign = function() {
          if (this.sHashHex = this.md.digest(), this.prvKey === void 0 && this.ecprvhex !== void 0 && this.eccurvename !== void 0 && L.crypto.ECDSA !== void 0 && (this.prvKey = new L.crypto.ECDSA({ curve: this.eccurvename, prv: this.ecprvhex })), this.prvKey instanceof Er && this.pubkeyAlgName === "rsaandmgf1")
            this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
          else if (this.prvKey instanceof Er && this.pubkeyAlgName === "rsa")
            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
          else if (this.prvKey instanceof L.crypto.ECDSA)
            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
          else if (this.prvKey instanceof L.crypto.DSA)
            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
          else
            throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
          return this.hSign;
        }, this.signString = function(M) {
          return this.updateString(M), this.sign();
        }, this.signHex = function(M) {
          return this.updateHex(M), this.sign();
        }, this.verify = function(M) {
          if (this.sHashHex = this.md.digest(), this.pubKey === void 0 && this.ecpubhex !== void 0 && this.eccurvename !== void 0 && L.crypto.ECDSA !== void 0 && (this.pubKey = new L.crypto.ECDSA({ curve: this.eccurvename, pub: this.ecpubhex })), this.pubKey instanceof Er && this.pubkeyAlgName === "rsaandmgf1")
            return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, M, this.mdAlgName, this.pssSaltLen);
          if (this.pubKey instanceof Er && this.pubkeyAlgName === "rsa")
            return this.pubKey.verifyWithMessageHash(this.sHashHex, M);
          if (L.crypto.ECDSA !== void 0 && this.pubKey instanceof L.crypto.ECDSA)
            return this.pubKey.verifyWithMessageHash(this.sHashHex, M);
          if (L.crypto.DSA !== void 0 && this.pubKey instanceof L.crypto.DSA)
            return this.pubKey.verifyWithMessageHash(this.sHashHex, M);
          throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
        };
      }
    }, this.init = function(I, R) {
      throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
    }, this.updateString = function(I) {
      throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
    }, this.updateHex = function(I) {
      throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
    }, this.sign = function() {
      throw "sign() not supported for this alg:prov=" + this.algProvName;
    }, this.signString = function(I) {
      throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
    }, this.signHex = function(I) {
      throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
    }, this.verify = function(I) {
      throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
    }, this.initParams = T, T !== void 0 && (T.alg !== void 0 && (this.algName = T.alg, T.prov === void 0 ? this.provName = L.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = T.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), T.psssaltlen !== void 0 && (this.pssSaltLen = T.psssaltlen), T.prvkeypem !== void 0)) {
      if (T.prvkeypas !== void 0)
        throw "both prvkeypem and prvkeypas parameters not supported";
      try {
        var C = Yr.getKey(T.prvkeypem);
        this.init(C);
      } catch (I) {
        throw "fatal error to load pem private key: " + I;
      }
    }
  }, L.crypto.Cipher = function(T) {
  }, L.crypto.Cipher.encrypt = function(T, C, I, R) {
    if (Fn(R, "enclag") != null && (I = R.encalg), typeof I == "string" && I.substr(-4) == "-CBC") {
      var M = C, N = T;
      Fn(R, "key") != null && (M = R.key), Fn(R, "enc") != null && (hEnc = R.enc);
      var Y = i.enc.Hex.parse(M), q = i.enc.Hex.parse(N), oe = i.enc.Hex.parse(R.iv), J;
      if (I == "des-EDE3-CBC")
        J = i.TripleDES.encrypt(q, Y, { iv: oe });
      else if (I == "aes128-CBC" || I == "aes256-CBC")
        J = i.AES.encrypt(q, Y, { iv: oe });
      else
        throw new Error("unsupported algorithm: " + I);
      return J + "";
    } else
      throw new Error("Cipher.encrypt: unsupported key or algorithm");
  }, L.crypto.Cipher.decrypt = function(T, C, I, R) {
    if (Fn(R, "enclag") != null && (I = R.encalg), typeof I == "string" && I.substr(-4) == "-CBC") {
      var M = C, N = T;
      Fn(R, "key") != null && (M = R.key), Fn(R, "enc") != null && (N = R.enc);
      var Y = i.enc.Hex.parse(M), q = i.enc.Hex.parse(N), oe = i.enc.Hex.parse(R.iv), J;
      if (I == "des-EDE3-CBC")
        J = i.TripleDES.decrypt({ ciphertext: q }, Y, { iv: oe });
      else if (I == "aes128-CBC" || I == "aes256-CBC")
        J = i.AES.decrypt({ ciphertext: q }, Y, { iv: oe });
      else
        throw new Error("unsupported algorithm: " + I);
      return i.enc.Hex.stringify(J);
    } else
      throw new Error("Cipher.decrypt: unsupported key or algorithm");
  }, L.crypto.OID = new function() {
    this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040022": "secp384r1", "2b81040023": "secp521r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" };
  }(), (typeof L > "u" || !L) && (L = {}), (typeof L.crypto > "u" || !L.crypto) && (L.crypto = {}), L.crypto.ECDSA = function(T) {
    var C = "secp256r1", I = Error, R = f, M = qr, N = L.crypto.ECDSA, Y = L.crypto.ECParameterDB, q = N.getName, oe = lt, J = oe.getVbyListEx, de = oe.isASN1HEX, se = new bc();
    this.type = "EC", this.isPrivate = !1, this.isPublic = !1, this.getBigRandom = function(j) {
      return new R(j.bitLength(), se).mod(j.subtract(R.ONE)).add(R.ONE);
    }, this.setNamedCurve = function(j) {
      this.ecparams = Y.getByName(j), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = j;
    }, this.setPrivateKeyHex = function(j) {
      this.isPrivate = !0, this.prvKeyHex = j;
    }, this.setPublicKeyHex = function(j) {
      this.isPublic = !0, this.pubKeyHex = j;
    }, this.getPublicKeyXYHex = function() {
      var j = this.pubKeyHex;
      if (j.substr(0, 2) !== "04")
        throw "this method supports uncompressed format(04) only";
      var ee = this.ecparams.keycharlen;
      if (j.length !== 2 + ee * 2)
        throw "malformed public key hex length";
      var W = {};
      return W.x = j.substr(2, ee), W.y = j.substr(2 + ee), W;
    }, this.getShortNISTPCurveName = function() {
      var j = this.curveName;
      return j === "secp256r1" || j === "NIST P-256" || j === "P-256" || j === "prime256v1" ? "P-256" : j === "secp384r1" || j === "NIST P-384" || j === "P-384" ? "P-384" : j === "secp521r1" || j === "NIST P-521" || j === "P-521" ? "P-521" : null;
    }, this.generateKeyPairHex = function() {
      var j = this.ecparams.n, ee = this.getBigRandom(j), W = this.ecparams.keycharlen, re = ("0000000000" + ee.toString(16)).slice(-W);
      this.setPrivateKeyHex(re);
      var ce = this.generatePublicKeyHex();
      return { ecprvhex: re, ecpubhex: ce };
    }, this.generatePublicKeyHex = function() {
      var j = new R(this.prvKeyHex, 16), ee = this.ecparams.G.multiply(j), W = ee.getX().toBigInteger(), re = ee.getY().toBigInteger(), ce = this.ecparams.keycharlen, me = ("0000000000" + W.toString(16)).slice(-ce), Ve = ("0000000000" + re.toString(16)).slice(-ce), at = "04" + me + Ve;
      return this.setPublicKeyHex(at), at;
    }, this.signWithMessageHash = function(j) {
      return this.signHex(j, this.prvKeyHex);
    }, this.signHex = function(j, ee) {
      var W = new R(ee, 16), re = this.ecparams.n, ce = new R(j.substring(0, this.ecparams.keycharlen), 16);
      do
        var me = this.getBigRandom(re), Ve = this.ecparams.G, at = Ve.multiply(me), it = at.getX().toBigInteger().mod(re);
      while (it.compareTo(R.ZERO) <= 0);
      var ct = me.modInverse(re).multiply(ce.add(W.multiply(it))).mod(re);
      return N.biRSSigToASN1Sig(it, ct);
    }, this.sign = function(j, ee) {
      var W = ee, re = this.ecparams.n, ce = R.fromByteArrayUnsigned(j);
      do
        var me = this.getBigRandom(re), Ve = this.ecparams.G, at = Ve.multiply(me), it = at.getX().toBigInteger().mod(re);
      while (it.compareTo(f.ZERO) <= 0);
      var ct = me.modInverse(re).multiply(ce.add(W.multiply(it))).mod(re);
      return this.serializeSig(it, ct);
    }, this.verifyWithMessageHash = function(j, ee) {
      return this.verifyHex(j, ee, this.pubKeyHex);
    }, this.verifyHex = function(j, ee, W) {
      try {
        var re, ce, me = N.parseSigHex(ee);
        re = me.r, ce = me.s;
        var Ve = M.decodeFromHex(this.ecparams.curve, W), at = new R(j.substring(0, this.ecparams.keycharlen), 16);
        return this.verifyRaw(at, re, ce, Ve);
      } catch {
        return !1;
      }
    }, this.verify = function(j, ee, W) {
      var re, ce;
      if (Bitcoin.Util.isArray(ee)) {
        var me = this.parseSig(ee);
        re = me.r, ce = me.s;
      } else if (typeof ee == "object" && ee.r && ee.s)
        re = ee.r, ce = ee.s;
      else
        throw "Invalid value for signature";
      var Ve;
      if (W instanceof qr)
        Ve = W;
      else if (Bitcoin.Util.isArray(W))
        Ve = M.decodeFrom(this.ecparams.curve, W);
      else
        throw "Invalid format for pubkey value, must be byte array or ECPointFp";
      var at = R.fromByteArrayUnsigned(j);
      return this.verifyRaw(at, re, ce, Ve);
    }, this.verifyRaw = function(j, ee, W, re) {
      var ce = this.ecparams.n, me = this.ecparams.G;
      if (ee.compareTo(R.ONE) < 0 || ee.compareTo(ce) >= 0 || W.compareTo(R.ONE) < 0 || W.compareTo(ce) >= 0)
        return !1;
      var Ve = W.modInverse(ce), at = j.multiply(Ve).mod(ce), it = ee.multiply(Ve).mod(ce), ct = me.multiply(at).add(re.multiply(it)), ge = ct.getX().toBigInteger().mod(ce);
      return ge.equals(ee);
    }, this.serializeSig = function(j, ee) {
      var W = j.toByteArraySigned(), re = ee.toByteArraySigned(), ce = [];
      return ce.push(2), ce.push(W.length), ce = ce.concat(W), ce.push(2), ce.push(re.length), ce = ce.concat(re), ce.unshift(ce.length), ce.unshift(48), ce;
    }, this.parseSig = function(j) {
      var ee;
      if (j[0] != 48)
        throw new Error("Signature not a valid DERSequence");
      if (ee = 2, j[ee] != 2)
        throw new Error("First element in signature must be a DERInteger");
      var W = j.slice(ee + 2, ee + 2 + j[ee + 1]);
      if (ee += 2 + j[ee + 1], j[ee] != 2)
        throw new Error("Second element in signature must be a DERInteger");
      var re = j.slice(ee + 2, ee + 2 + j[ee + 1]);
      ee += 2 + j[ee + 1];
      var ce = R.fromByteArrayUnsigned(W), me = R.fromByteArrayUnsigned(re);
      return { r: ce, s: me };
    }, this.parseSigCompact = function(j) {
      if (j.length !== 65)
        throw "Signature has the wrong length";
      var ee = j[0] - 27;
      if (ee < 0 || ee > 7)
        throw "Invalid signature type";
      var W = this.ecparams.n, re = R.fromByteArrayUnsigned(j.slice(1, 33)).mod(W), ce = R.fromByteArrayUnsigned(j.slice(33, 65)).mod(W);
      return { r: re, s: ce, i: ee };
    }, this.readPKCS5PrvKeyHex = function(j) {
      if (de(j) === !1)
        throw new Error("not ASN.1 hex string");
      var ee, W, re;
      try {
        ee = J(j, 0, ["[0]", 0], "06"), W = J(j, 0, [1], "04");
        try {
          re = J(j, 0, ["[1]", 0], "03");
        } catch {
        }
      } catch {
        throw new Error("malformed PKCS#1/5 plain ECC private key");
      }
      if (this.curveName = q(ee), this.curveName === void 0)
        throw "unsupported curve name";
      this.setNamedCurve(this.curveName), this.setPublicKeyHex(re), this.setPrivateKeyHex(W), this.isPublic = !1;
    }, this.readPKCS8PrvKeyHex = function(j) {
      if (de(j) === !1)
        throw new I("not ASN.1 hex string");
      var ee, W, re, ce;
      try {
        ee = J(j, 0, [1, 0], "06"), W = J(j, 0, [1, 1], "06"), re = J(j, 0, [2, 0, 1], "04");
        try {
          ce = J(j, 0, [2, 0, "[1]", 0], "03");
        } catch {
        }
      } catch {
        throw new I("malformed PKCS#8 plain ECC private key");
      }
      if (this.curveName = q(W), this.curveName === void 0)
        throw new I("unsupported curve name");
      this.setNamedCurve(this.curveName), this.setPublicKeyHex(ce), this.setPrivateKeyHex(re), this.isPublic = !1;
    }, this.readPKCS8PubKeyHex = function(j) {
      if (de(j) === !1)
        throw new I("not ASN.1 hex string");
      var ee, W, re;
      try {
        ee = J(j, 0, [0, 0], "06"), W = J(j, 0, [0, 1], "06"), re = J(j, 0, [1], "03");
      } catch {
        throw new I("malformed PKCS#8 ECC public key");
      }
      if (this.curveName = q(W), this.curveName === null)
        throw new I("unsupported curve name");
      this.setNamedCurve(this.curveName), this.setPublicKeyHex(re);
    }, this.readCertPubKeyHex = function(j, ee) {
      if (de(j) === !1)
        throw new I("not ASN.1 hex string");
      var W, re;
      try {
        W = J(j, 0, [0, 5, 0, 1], "06"), re = J(j, 0, [0, 5, 1], "03");
      } catch {
        throw new I("malformed X.509 certificate ECC public key");
      }
      if (this.curveName = q(W), this.curveName === null)
        throw new I("unsupported curve name");
      this.setNamedCurve(this.curveName), this.setPublicKeyHex(re);
    }, T !== void 0 && T.curve !== void 0 && (this.curveName = T.curve), this.curveName === void 0 && (this.curveName = C), this.setNamedCurve(this.curveName), T !== void 0 && (T.prv !== void 0 && this.setPrivateKeyHex(T.prv), T.pub !== void 0 && this.setPublicKeyHex(T.pub));
  }, L.crypto.ECDSA.parseSigHex = function(T) {
    var C = L.crypto.ECDSA.parseSigHexInHexRS(T), I = new f(C.r, 16), R = new f(C.s, 16);
    return { r: I, s: R };
  }, L.crypto.ECDSA.parseSigHexInHexRS = function(T) {
    var C = lt, I = C.getChildIdx, R = C.getV;
    if (C.checkStrictDER(T, 0), T.substr(0, 2) != "30")
      throw new Error("signature is not a ASN.1 sequence");
    var M = I(T, 0);
    if (M.length != 2)
      throw new Error("signature shall have two elements");
    var N = M[0], Y = M[1];
    if (T.substr(N, 2) != "02")
      throw new Error("1st item not ASN.1 integer");
    if (T.substr(Y, 2) != "02")
      throw new Error("2nd item not ASN.1 integer");
    var q = R(T, N), oe = R(T, Y);
    return { r: q, s: oe };
  }, L.crypto.ECDSA.asn1SigToConcatSig = function(T) {
    var C = L.crypto.ECDSA.parseSigHexInHexRS(T), I = C.r, R = C.s;
    if (I.length >= 130 && I.length <= 134) {
      if (I.length % 2 != 0)
        throw Error("unknown ECDSA sig r length error");
      if (R.length % 2 != 0)
        throw Error("unknown ECDSA sig s length error");
      I.substr(0, 2) == "00" && (I = I.substr(2)), R.substr(0, 2) == "00" && (R = R.substr(2));
      var M = Math.max(I.length, R.length);
      return I = ("000000" + I).slice(-M), R = ("000000" + R).slice(-M), I + R;
    }
    if (I.substr(0, 2) == "00" && I.length % 32 == 2 && (I = I.substr(2)), R.substr(0, 2) == "00" && R.length % 32 == 2 && (R = R.substr(2)), I.length % 32 == 30 && (I = "00" + I), R.length % 32 == 30 && (R = "00" + R), I.length % 32 != 0)
      throw Error("unknown ECDSA sig r length error");
    if (R.length % 32 != 0)
      throw Error("unknown ECDSA sig s length error");
    return I + R;
  }, L.crypto.ECDSA.concatSigToASN1Sig = function(T) {
    if (T.length % 4 != 0)
      throw Error("unknown ECDSA concatinated r-s sig length error");
    var C = T.substr(0, T.length / 2), I = T.substr(T.length / 2);
    return L.crypto.ECDSA.hexRSSigToASN1Sig(C, I);
  }, L.crypto.ECDSA.hexRSSigToASN1Sig = function(T, C) {
    var I = new f(T, 16), R = new f(C, 16);
    return L.crypto.ECDSA.biRSSigToASN1Sig(I, R);
  }, L.crypto.ECDSA.biRSSigToASN1Sig = function(T, C) {
    var I = L.asn1, R = new I.DERInteger({ bigint: T }), M = new I.DERInteger({ bigint: C }), N = new I.DERSequence({ array: [R, M] });
    return N.tohex();
  }, L.crypto.ECDSA.getName = function(T) {
    return T === "2b8104001f" ? "secp192k1" : T === "2a8648ce3d030107" ? "secp256r1" : T === "2b8104000a" ? "secp256k1" : T === "2b81040021" ? "secp224r1" : T === "2b81040022" ? "secp384r1" : T === "2b81040023" ? "secp521r1" : "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(T) !== -1 ? "secp256r1" : "|secp256k1|".indexOf(T) !== -1 ? "secp256k1" : "|secp224r1|NIST P-224|P-224|".indexOf(T) !== -1 ? "secp224r1" : "|secp384r1|NIST P-384|P-384|".indexOf(T) !== -1 ? "secp384r1" : "|secp521r1|NIST P-521|P-521|".indexOf(T) !== -1 ? "secp521r1" : null;
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.crypto > "u" || !L.crypto) && (L.crypto = {}), L.crypto.ECParameterDB = new function() {
    var T = {}, C = {};
    function I(R) {
      return new f(R, 16);
    }
    this.getByName = function(R) {
      var M = R;
      if (typeof C[M] < "u" && (M = C[R]), typeof T[M] < "u")
        return T[M];
      throw "unregistered EC curve name: " + M;
    }, this.regist = function(R, M, N, Y, q, oe, J, de, se, j, ee, W) {
      T[R] = {};
      var re = I(N), ce = I(Y), me = I(q), Ve = I(oe), at = I(J), it = new Tu(re, ce, me), ct = it.decodePointHex("04" + de + se);
      T[R].name = R, T[R].keylen = M, T[R].keycharlen = Math.ceil(M / 8) * 2, T[R].curve = it, T[R].G = ct, T[R].n = Ve, T[R].h = at, T[R].oid = ee, T[R].info = W;
      for (var ge = 0; ge < j.length; ge++)
        C[j[ge]] = R;
    };
  }(), L.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), L.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), L.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), L.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), L.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), L.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), L.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), L.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]), L.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]), L.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "00C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]), (typeof L > "u" || !L) && (L = {}), (typeof L.crypto > "u" || !L.crypto) && (L.crypto = {}), L.crypto.DSA = function() {
    var T = lt;
    T.getVbyList;
    var C = T.getVbyListEx, I = T.isASN1HEX, R = f;
    this.p = null, this.q = null, this.g = null, this.y = null, this.x = null, this.type = "DSA", this.isPrivate = !1, this.isPublic = !1, this.setPrivate = function(M, N, Y, q, oe) {
      this.isPrivate = !0, this.p = M, this.q = N, this.g = Y, this.y = q, this.x = oe;
    }, this.setPrivateHex = function(M, N, Y, q, oe) {
      var J, de, se, j, ee;
      J = new f(M, 16), de = new f(N, 16), se = new f(Y, 16), typeof q == "string" && q.length > 1 ? j = new f(q, 16) : j = null, ee = new f(oe, 16), this.setPrivate(J, de, se, j, ee);
    }, this.setPublic = function(M, N, Y, q) {
      this.isPublic = !0, this.p = M, this.q = N, this.g = Y, this.y = q, this.x = null;
    }, this.setPublicHex = function(M, N, Y, q) {
      var oe, J, de, se;
      oe = new f(M, 16), J = new f(N, 16), de = new f(Y, 16), se = new f(q, 16), this.setPublic(oe, J, de, se);
    }, this.signWithMessageHash = function(M) {
      var N = this.p, Y = this.q, q = this.g;
      this.y;
      var oe = this.x, J = L.crypto.Util.getRandomBigIntegerMinToMax(f.ONE.add(f.ONE), Y.subtract(f.ONE)), de = M.substr(0, Y.bitLength() / 4), se = new f(de, 16), j = q.modPow(J, N).mod(Y), ee = J.modInverse(Y).multiply(se.add(oe.multiply(j))).mod(Y), W = L.asn1.ASN1Util.jsonToASN1HEX({ seq: [{ int: { bigint: j } }, { int: { bigint: ee } }] });
      return W;
    }, this.verifyWithMessageHash = function(M, N) {
      var Y = this.p, q = this.q, oe = this.g, J = this.y, de = this.parseASN1Signature(N), se = de[0], j = de[1], ee = M.substr(0, q.bitLength() / 4), W = new f(ee, 16);
      if (f.ZERO.compareTo(se) > 0 || se.compareTo(q) > 0 || f.ZERO.compareTo(j) >= 0 || j.compareTo(q) > 0)
        throw "invalid DSA signature";
      var re = j.modInverse(q), ce = W.multiply(re).mod(q), me = se.multiply(re).mod(q), Ve = oe.modPow(ce, Y).multiply(J.modPow(me, Y)).mod(Y).mod(q);
      return Ve.compareTo(se) == 0;
    }, this.parseASN1Signature = function(M) {
      try {
        var N = new R(C(M, 0, [0], "02"), 16), Y = new R(C(M, 0, [1], "02"), 16);
        return [N, Y];
      } catch {
        throw new Error("malformed ASN.1 DSA signature");
      }
    }, this.readPKCS5PrvKeyHex = function(M) {
      var N, Y, q, oe, J;
      if (I(M) === !1)
        throw new Error("not ASN.1 hex string");
      try {
        N = C(M, 0, [1], "02"), Y = C(M, 0, [2], "02"), q = C(M, 0, [3], "02"), oe = C(M, 0, [4], "02"), J = C(M, 0, [5], "02");
      } catch {
        throw new Error("malformed PKCS#1/5 plain DSA private key");
      }
      this.setPrivateHex(N, Y, q, oe, J);
    }, this.readPKCS8PrvKeyHex = function(M) {
      var N, Y, q, oe;
      if (I(M) === !1)
        throw new Error("not ASN.1 hex string");
      try {
        N = C(M, 0, [1, 1, 0], "02"), Y = C(M, 0, [1, 1, 1], "02"), q = C(M, 0, [1, 1, 2], "02"), oe = C(M, 0, [2, 0], "02");
      } catch {
        throw new Error("malformed PKCS#8 plain DSA private key");
      }
      this.setPrivateHex(N, Y, q, null, oe);
    }, this.readPKCS8PubKeyHex = function(M) {
      var N, Y, q, oe;
      if (I(M) === !1)
        throw new Error("not ASN.1 hex string");
      try {
        N = C(M, 0, [0, 1, 0], "02"), Y = C(M, 0, [0, 1, 1], "02"), q = C(M, 0, [0, 1, 2], "02"), oe = C(M, 0, [1, 0], "02");
      } catch {
        throw new Error("malformed PKCS#8 DSA public key");
      }
      this.setPublicHex(N, Y, q, oe);
    }, this.readCertPubKeyHex = function(M, N) {
      var Y, q, oe, J;
      if (I(M) === !1)
        throw new Error("not ASN.1 hex string");
      try {
        Y = C(M, 0, [0, 5, 0, 1, 0], "02"), q = C(M, 0, [0, 5, 0, 1, 1], "02"), oe = C(M, 0, [0, 5, 0, 1, 2], "02"), J = C(M, 0, [0, 5, 1, 0], "02");
      } catch {
        throw new Error("malformed X.509 certificate DSA public key");
      }
      this.setPublicHex(Y, q, oe, J);
    };
  };
  var Yr = /* @__PURE__ */ function() {
    var T = function(W, re, ce) {
      return R(i.AES, W, re, ce);
    }, C = function(W, re, ce) {
      return R(i.TripleDES, W, re, ce);
    }, I = function(W, re, ce) {
      return R(i.DES, W, re, ce);
    }, R = function(W, re, ce, me) {
      var Ve = i.enc.Hex.parse(re), at = i.enc.Hex.parse(ce), it = i.enc.Hex.parse(me), ct = {};
      ct.key = at, ct.iv = it, ct.ciphertext = Ve;
      var ge = W.decrypt(ct, at, { iv: it });
      return i.enc.Hex.stringify(ge);
    }, M = function(W, re, ce) {
      return q(i.AES, W, re, ce);
    }, N = function(W, re, ce) {
      return q(i.TripleDES, W, re, ce);
    }, Y = function(W, re, ce) {
      return q(i.DES, W, re, ce);
    }, q = function(W, re, ce, me) {
      var Ve = i.enc.Hex.parse(re), at = i.enc.Hex.parse(ce), it = i.enc.Hex.parse(me), ct = W.encrypt(Ve, at, { iv: it }), ge = i.enc.Hex.parse(ct.toString()), Se = i.enc.Base64.stringify(ge);
      return Se;
    }, oe = { "AES-256-CBC": { proc: T, eproc: M, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: T, eproc: M, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: T, eproc: M, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: C, eproc: N, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: I, eproc: Y, keylen: 8, ivlen: 8 } }, J = function(W) {
      var re = i.lib.WordArray.random(W), ce = i.enc.Hex.stringify(re);
      return ce;
    }, de = function(W) {
      var re = {}, ce = W.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
      ce && (re.cipher = ce[1], re.ivsalt = ce[2]);
      var me = W.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
      me && (re.type = me[1]);
      var Ve = -1, at = 0;
      W.indexOf(`\r
\r
`) != -1 && (Ve = W.indexOf(`\r
\r
`), at = 2), W.indexOf(`

`) != -1 && (Ve = W.indexOf(`

`), at = 1);
      var it = W.indexOf("-----END");
      if (Ve != -1 && it != -1) {
        var ct = W.substring(Ve + at * 2, it - at);
        ct = ct.replace(/\s+/g, ""), re.data = ct;
      }
      return re;
    }, se = function(W, re, ce) {
      for (var me = ce.substring(0, 16), Ve = i.enc.Hex.parse(me), at = i.enc.Utf8.parse(re), it = oe[W].keylen + oe[W].ivlen, ct = "", ge = null; ; ) {
        var Se = i.algo.MD5.create();
        if (ge != null && Se.update(ge), Se.update(at), Se.update(Ve), ge = Se.finalize(), ct = ct + i.enc.Hex.stringify(ge), ct.length >= it * 2)
          break;
      }
      var Re = {};
      return Re.keyhex = ct.substr(0, oe[W].keylen * 2), Re.ivhex = ct.substr(oe[W].keylen * 2, oe[W].ivlen * 2), Re;
    }, j = function(W, re, ce, me) {
      var Ve = i.enc.Base64.parse(W), at = i.enc.Hex.stringify(Ve), it = oe[re].proc, ct = it(at, ce, me);
      return ct;
    }, ee = function(W, re, ce, me) {
      var Ve = oe[re].eproc, at = Ve(W, ce, me);
      return at;
    };
    return { version: "1.0.0", parsePKCS5PEM: function(W) {
      return de(W);
    }, getKeyAndUnusedIvByPasscodeAndIvsalt: function(W, re, ce) {
      return se(W, re, ce);
    }, decryptKeyB64: function(W, re, ce, me) {
      return j(W, re, ce, me);
    }, getDecryptedKeyHex: function(W, re) {
      var ce = de(W), me = ce.cipher, Ve = ce.ivsalt, at = ce.data, it = se(me, re, Ve), ct = it.keyhex, ge = j(at, me, ct, Ve);
      return ge;
    }, getEncryptedPKCS5PEMFromPrvKeyHex: function(W, re, ce, me, Ve) {
      var Te = "";
      if ((typeof me > "u" || me == null) && (me = "AES-256-CBC"), typeof oe[me] > "u")
        throw new Error("KEYUTIL unsupported algorithm: " + me);
      if (typeof Ve > "u" || Ve == null) {
        var at = oe[me].ivlen, it = J(at);
        Ve = it.toUpperCase();
      }
      var ct = se(me, ce, Ve), ge = ct.keyhex, Se = ee(re, me, ge, Ve), Re = Se.replace(/(.{64})/g, `$1\r
`), Te = "-----BEGIN " + W + ` PRIVATE KEY-----\r
`;
      return Te += `Proc-Type: 4,ENCRYPTED\r
`, Te += "DEK-Info: " + me + "," + Ve + `\r
`, Te += `\r
`, Te += Re, Te += `\r
-----END ` + W + ` PRIVATE KEY-----\r
`, Te;
    }, getEncryptedPKCS8PEM: function(W, re, ce) {
      var me = this.getEncryptedPKCS8Hex(W, re, ce);
      return Go(me, "ENCRYPTED PRIVATE KEY");
    }, getEncryptedPKCS8Hex: function(W, re, ce) {
      var me;
      ce == null || ce == null ? me = {} : me = JSON.parse(JSON.stringify(ce)), me.plain = W, this.initPBES2Param(me), this.encryptPBES2Param(me, re);
      var Ve = this.generatePBES2ASN1Param(me);
      return L.asn1.ASN1Util.newObject(Ve).tohex();
    }, initPBES2Param: function(W) {
      if (Fn(W, "encalg") == null && (W.encalg = "aes256-CBC"), Fn(W, "iter") == null && (W.iter = 2048), Fn(W, "prf") == null && (W.prf = "hmacWithSHA256"), Fn(W, "salt") == null && (W.salt = i.enc.Hex.stringify(i.lib.WordArray.random(8))), Fn(W, "enciv") == null) {
        var re;
        W.encalg == "des-EDE3-CBC" && (re = 8), W.encalg == "aes128-CBC" && (re = 16), W.encalg == "aes256-CBC" && (re = 16), W.enciv = i.enc.Hex.stringify(i.lib.WordArray.random(re));
      }
    }, encryptPBES2Param: function(W, re) {
      var ce = Yr.getDKFromPBES2Param(W, re);
      try {
        var me = L.crypto.Cipher.encrypt(W.plain, ce, W.encalg, { iv: W.enciv });
      } catch {
        throw new Error("encrypt error: " + W.plain + " " + ce + " " + W.encalg + " " + W.enciv);
      }
      W.enc = me;
    }, generatePBES2ASN1Param: function(W) {
      var re = { seq: [{ seq: [{ oid: "pkcs5PBES2" }, { seq: [{ seq: [{ oid: "pkcs5PBKDF2" }, { seq: [{ octstr: { hex: W.salt } }, { int: { hex: VU(W.iter) } }] }] }, { seq: [{ oid: W.encalg }, { octstr: { hex: W.enciv } }] }] }] }, { octstr: { hex: W.enc } }] };
      return W.prf != "hmacWithSHA1" && re.seq[0].seq[1].seq[0].seq[1].seq.push({ seq: [{ oid: W.prf }, { null: "" }] }), re;
    }, parseHexOfEncryptedPKCS8: function(W) {
      var re = lt, ce = re.getChildIdx, me = re.getV, Ve = {}, at = ce(W, 0);
      if (at.length != 2)
        throw new Error("malformed format: SEQUENCE(0).items != 2: " + at.length);
      Ve.ciphertext = me(W, at[1]);
      var it = ce(W, at[0]);
      if (it.length != 2)
        throw new Error("malformed format: SEQUENCE(0.0).items != 2: " + it.length);
      if (me(W, it[0]) != "2a864886f70d01050d")
        throw new Error("this only supports pkcs5PBES2");
      var ct = ce(W, it[1]);
      if (it.length != 2)
        throw new Error("malformed format: SEQUENCE(0.0.1).items != 2: " + ct.length);
      var ge = ce(W, ct[1]);
      if (ge.length != 2)
        throw new Error("malformed format: SEQUENCE(0.0.1.1).items != 2: " + ge.length);
      if (me(W, ge[0]) != "2a864886f70d0307")
        throw "this only supports TripleDES";
      Ve.encryptionSchemeAlg = "TripleDES", Ve.encryptionSchemeIV = me(W, ge[1]);
      var Se = ce(W, ct[0]);
      if (Se.length != 2)
        throw new Error("malformed format: SEQUENCE(0.0.1.0).items != 2: " + Se.length);
      if (me(W, Se[0]) != "2a864886f70d01050c")
        throw new Error("this only supports pkcs5PBKDF2");
      var Re = ce(W, Se[1]);
      if (Re.length < 2)
        throw new Error("malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + Re.length);
      Ve.pbkdf2Salt = me(W, Re[0]);
      var Te = me(W, Re[1]);
      try {
        Ve.pbkdf2Iter = parseInt(Te, 16);
      } catch {
        throw new Error("malformed format pbkdf2Iter: " + Te);
      }
      return Ve;
    }, getPBKDF2KeyHexFromParam: function(W, re) {
      var ce = i.enc.Hex.parse(W.pbkdf2Salt), me = W.pbkdf2Iter, Ve = i.PBKDF2(re, ce, { keySize: 192 / 32, iterations: me }), at = i.enc.Hex.stringify(Ve);
      return at;
    }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function(W, re) {
      var ce = Ai(W, "ENCRYPTED PRIVATE KEY"), me = this.parseHexOfEncryptedPKCS8(ce), Ve = Yr.getPBKDF2KeyHexFromParam(me, re), at = {};
      at.ciphertext = i.enc.Hex.parse(me.ciphertext);
      var it = i.enc.Hex.parse(Ve), ct = i.enc.Hex.parse(me.encryptionSchemeIV), ge = i.TripleDES.decrypt(at, it, { iv: ct }), Se = i.enc.Hex.stringify(ge);
      return Se;
    }, parsePBES2: function(W) {
      var re = lt.parse(W);
      if (Fn(re, "seq.0.seq.0.oid") != "pkcs5PBES2" || Fn(re, "seq.0.seq.1.seq.0.seq.0.oid") != "pkcs5PBKDF2")
        throw new Error("not pkcs5PBES2 and pkcs5PBKDF2 used");
      var ce = Fn(re, "seq.0.seq.1.seq.0.seq.1.seq");
      if (ce == null)
        throw new Error("PBKDF2 parameter not found");
      var me = Fn(ce, "0.octstr.hex"), Ve = Fn(ce, "1.int.hex"), at = Fn(ce, "2.seq.0.oid", "hmacWithSHA1"), it = -1;
      try {
        it = parseInt(Ve, 16);
      } catch {
        throw new Error("iter not proper value");
      }
      var ct = Fn(re, "seq.0.seq.1.seq.1.seq.0.oid"), ge = Fn(re, "seq.0.seq.1.seq.1.seq.1.octstr.hex"), Se = Fn(re, "seq.1.octstr.hex");
      if (ct == null || ge == null || Se == null)
        throw new Error("encalg, enciv or enc is undefined");
      var Re = { salt: me, iter: it, prf: at, encalg: ct, enciv: ge, enc: Se };
      return Re;
    }, getDKFromPBES2Param: function(W, re) {
      var ce = { hmacWithSHA1: i.algo.SHA1, hmacWithSHA224: i.algo.SHA224, hmacWithSHA256: i.algo.SHA256, hmacWithSHA384: i.algo.SHA384, hmacWithSHA512: i.algo.SHA512 }, me = { "des-EDE3-CBC": 192 / 32, "aes128-CBC": 128 / 32, "aes256-CBC": 256 / 32 }, Ve = ce[W.prf];
      if (Ve == null)
        throw new Error("unsupported prf");
      var at = me[W.encalg];
      if (at == null)
        throw new Error("unsupported encalg");
      var it = i.enc.Hex.parse(W.salt), ct = W.iter;
      try {
        var ge = i.PBKDF2(re, it, { keySize: at, iterations: ct, hasher: Ve });
        return i.enc.Hex.stringify(ge);
      } catch (Se) {
        throw new Error("PBKDF2 error: " + Se + " " + JSON.stringify(W) + " " + re);
      }
    }, getPlainHexFromEncryptedPKCS8PEM: function(W, re) {
      if (W.indexOf("BEGIN ENCRYPTED PRIVATE KEY") == -1)
        throw new Error("not Encrypted PKCS#8 PEM string");
      var ce = Ai(W), me;
      try {
        me = Yr.parsePBES2(ce);
      } catch (at) {
        throw new Error("malformed PBES2 format: " + at.message);
      }
      var Ve = Yr.getDKFromPBES2Param(me, re);
      return L.crypto.Cipher.decrypt(me.enc, Ve, me.encalg, { iv: me.enciv });
    }, getKeyFromEncryptedPKCS8PEM: function(W, re) {
      var ce = this.getPlainHexFromEncryptedPKCS8PEM(W, re), me = this.getKeyFromPlainPrivatePKCS8Hex(ce);
      return me;
    }, parsePlainPrivatePKCS8Hex: function(W) {
      var re = lt, ce = re.getChildIdx, me = re.getV, Ve = {};
      if (Ve.algparam = null, W.substr(0, 2) != "30")
        throw new Error("malformed plain PKCS8 private key(code:001)");
      var at = ce(W, 0);
      if (at.length < 3)
        throw new Error("malformed plain PKCS8 private key(code:002)");
      if (W.substr(at[1], 2) != "30")
        throw new Error("malformed PKCS8 private key(code:003)");
      var it = ce(W, at[1]);
      if (it.length != 2)
        throw new Error("malformed PKCS8 private key(code:004)");
      if (W.substr(it[0], 2) != "06")
        throw new Error("malformed PKCS8 private key(code:005)");
      if (Ve.algoid = me(W, it[0]), W.substr(it[1], 2) == "06" && (Ve.algparam = me(W, it[1])), W.substr(at[2], 2) != "04")
        throw new Error("malformed PKCS8 private key(code:006)");
      return Ve.keyidx = re.getVidx(W, at[2]), Ve;
    }, getKeyFromPlainPrivatePKCS8PEM: function(W) {
      var re = Ai(W, "PRIVATE KEY"), ce = this.getKeyFromPlainPrivatePKCS8Hex(re);
      return ce;
    }, getKeyFromPlainPrivatePKCS8Hex: function(W) {
      var re = this.parsePlainPrivatePKCS8Hex(W), ce;
      if (re.algoid == "2a864886f70d010101")
        ce = new Er();
      else if (re.algoid == "2a8648ce380401")
        ce = new L.crypto.DSA();
      else if (re.algoid == "2a8648ce3d0201")
        ce = new L.crypto.ECDSA();
      else
        throw new Error("unsupported private key algorithm");
      return ce.readPKCS8PrvKeyHex(W), ce;
    }, _getKeyFromPublicPKCS8Hex: function(W) {
      var re, ce = lt.getVbyList(W, 0, [0, 0], "06");
      if (ce === "2a864886f70d010101")
        re = new Er();
      else if (ce === "2a8648ce380401")
        re = new L.crypto.DSA();
      else if (ce === "2a8648ce3d0201")
        re = new L.crypto.ECDSA();
      else
        throw new Error("unsupported PKCS#8 public key hex");
      return re.readPKCS8PubKeyHex(W), re;
    }, parsePublicRawRSAKeyHex: function(W) {
      var re = lt, ce = re.getChildIdx, me = re.getV, Ve = {};
      if (W.substr(0, 2) != "30")
        throw new Error("malformed RSA key(code:001)");
      var at = ce(W, 0);
      if (at.length != 2)
        throw new Error("malformed RSA key(code:002)");
      if (W.substr(at[0], 2) != "02")
        throw new Error("malformed RSA key(code:003)");
      if (Ve.n = me(W, at[0]), W.substr(at[1], 2) != "02")
        throw new Error("malformed RSA key(code:004)");
      return Ve.e = me(W, at[1]), Ve;
    }, parsePublicPKCS8Hex: function(W) {
      var re = lt, ce = re.getChildIdx, me = re.getV, Ve = {};
      Ve.algparam = null;
      var at = ce(W, 0);
      if (at.length != 2)
        throw new Error("outer DERSequence shall have 2 elements: " + at.length);
      var it = at[0];
      if (W.substr(it, 2) != "30")
        throw new Error("malformed PKCS8 public key(code:001)");
      var ct = ce(W, it);
      if (ct.length != 2)
        throw new Error("malformed PKCS8 public key(code:002)");
      if (W.substr(ct[0], 2) != "06")
        throw new Error("malformed PKCS8 public key(code:003)");
      if (Ve.algoid = me(W, ct[0]), W.substr(ct[1], 2) == "06" ? Ve.algparam = me(W, ct[1]) : W.substr(ct[1], 2) == "30" && (Ve.algparam = {}, Ve.algparam.p = re.getVbyList(W, ct[1], [0], "02"), Ve.algparam.q = re.getVbyList(W, ct[1], [1], "02"), Ve.algparam.g = re.getVbyList(W, ct[1], [2], "02")), W.substr(at[1], 2) != "03")
        throw new Error("malformed PKCS8 public key(code:004)");
      return Ve.key = me(W, at[1]).substr(2), Ve;
    } };
  }();
  Yr.getKey = function(T, C, I) {
    var R = lt, M = R.getChildIdx;
    R.getV;
    var N = R.getVbyList, Y = L.crypto, q = Y.ECDSA, oe = Y.DSA, J = Er, de = Ai, se = Yr;
    if (typeof J < "u" && T instanceof J || typeof q < "u" && T instanceof q || typeof oe < "u" && T instanceof oe)
      return T;
    if (T.curve !== void 0 && T.xy !== void 0 && T.d === void 0)
      return new q({ pub: T.xy, curve: T.curve });
    if (T.curve !== void 0 && T.d !== void 0)
      return new q({ prv: T.d, curve: T.curve });
    if (T.kty === void 0 && T.n !== void 0 && T.e !== void 0 && T.d === void 0) {
      var j = new J();
      return j.setPublic(T.n, T.e), j;
    }
    if (T.kty === void 0 && T.n !== void 0 && T.e !== void 0 && T.d !== void 0 && T.p !== void 0 && T.q !== void 0 && T.dp !== void 0 && T.dq !== void 0 && T.co !== void 0 && T.qi === void 0) {
      var j = new J();
      return j.setPrivateEx(T.n, T.e, T.d, T.p, T.q, T.dp, T.dq, T.co), j;
    }
    if (T.kty === void 0 && T.n !== void 0 && T.e !== void 0 && T.d !== void 0 && T.p === void 0) {
      var j = new J();
      return j.setPrivate(T.n, T.e, T.d), j;
    }
    if (T.p !== void 0 && T.q !== void 0 && T.g !== void 0 && T.y !== void 0 && T.x === void 0) {
      var j = new oe();
      return j.setPublic(T.p, T.q, T.g, T.y), j;
    }
    if (T.p !== void 0 && T.q !== void 0 && T.g !== void 0 && T.y !== void 0 && T.x !== void 0) {
      var j = new oe();
      return j.setPrivate(T.p, T.q, T.g, T.y, T.x), j;
    }
    if (T.kty === "RSA" && T.n !== void 0 && T.e !== void 0 && T.d === void 0) {
      var j = new J();
      return j.setPublic(Br(T.n), Br(T.e)), j;
    }
    if (T.kty === "RSA" && T.n !== void 0 && T.e !== void 0 && T.d !== void 0 && T.p !== void 0 && T.q !== void 0 && T.dp !== void 0 && T.dq !== void 0 && T.qi !== void 0) {
      var j = new J();
      return j.setPrivateEx(Br(T.n), Br(T.e), Br(T.d), Br(T.p), Br(T.q), Br(T.dp), Br(T.dq), Br(T.qi)), j;
    }
    if (T.kty === "RSA" && T.n !== void 0 && T.e !== void 0 && T.d !== void 0) {
      var j = new J();
      return j.setPrivate(Br(T.n), Br(T.e), Br(T.d)), j;
    }
    if (T.kty === "EC" && T.crv !== void 0 && T.x !== void 0 && T.y !== void 0 && T.d === void 0) {
      var ee = new q({ curve: T.crv }), W = ee.ecparams.keycharlen, re = ("0000000000" + Br(T.x)).slice(-W), ce = ("0000000000" + Br(T.y)).slice(-W), me = "04" + re + ce;
      return ee.setPublicKeyHex(me), ee;
    }
    if (T.kty === "EC" && T.crv !== void 0 && T.x !== void 0 && T.y !== void 0 && T.d !== void 0) {
      var ee = new q({ curve: T.crv }), W = ee.ecparams.keycharlen, re = ("0000000000" + Br(T.x)).slice(-W), ce = ("0000000000" + Br(T.y)).slice(-W), me = "04" + re + ce, Ve = ("0000000000" + Br(T.d)).slice(-W);
      return ee.setPublicKeyHex(me), ee.setPrivateKeyHex(Ve), ee;
    }
    if (I === "pkcs5prv") {
      var at = T, R = lt, it, j;
      if (it = M(at, 0), it.length === 9)
        j = new J(), j.readPKCS5PrvKeyHex(at);
      else if (it.length === 6)
        j = new oe(), j.readPKCS5PrvKeyHex(at);
      else if (it.length > 2 && at.substr(it[1], 2) === "04")
        j = new q(), j.readPKCS5PrvKeyHex(at);
      else
        throw new Error("unsupported PKCS#1/5 hexadecimal key");
      return j;
    }
    if (I === "pkcs8prv") {
      var j = se.getKeyFromPlainPrivatePKCS8Hex(T);
      return j;
    }
    if (I === "pkcs8pub")
      return se._getKeyFromPublicPKCS8Hex(T);
    if (I === "x509pub")
      return mr.getPublicKeyFromCertHex(T);
    if (T.indexOf("-END CERTIFICATE-", 0) != -1 || T.indexOf("-END X509 CERTIFICATE-", 0) != -1 || T.indexOf("-END TRUSTED CERTIFICATE-", 0) != -1)
      return mr.getPublicKeyFromCertPEM(T);
    if (T.indexOf("-END PUBLIC KEY-") != -1) {
      var ct = Ai(T, "PUBLIC KEY");
      return se._getKeyFromPublicPKCS8Hex(ct);
    }
    if (T.indexOf("-END RSA PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") == -1) {
      var ge = de(T, "RSA PRIVATE KEY");
      return se.getKey(ge, null, "pkcs5prv");
    }
    if (T.indexOf("-END DSA PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") == -1) {
      var Se = de(T, "DSA PRIVATE KEY"), Re = N(Se, 0, [1], "02"), Te = N(Se, 0, [2], "02"), He = N(Se, 0, [3], "02"), ut = N(Se, 0, [4], "02"), vt = N(Se, 0, [5], "02"), j = new oe();
      return j.setPrivate(new f(Re, 16), new f(Te, 16), new f(He, 16), new f(ut, 16), new f(vt, 16)), j;
    }
    if (T.indexOf("-END EC PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") == -1) {
      var ge = de(T, "EC PRIVATE KEY");
      return se.getKey(ge, null, "pkcs5prv");
    }
    if (T.indexOf("-END PRIVATE KEY-") != -1)
      return se.getKeyFromPlainPrivatePKCS8PEM(T);
    if (T.indexOf("-END RSA PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") != -1) {
      var Rt = se.getDecryptedKeyHex(T, C), pt = new Er();
      return pt.readPKCS5PrvKeyHex(Rt), pt;
    }
    if (T.indexOf("-END EC PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") != -1) {
      var Se = se.getDecryptedKeyHex(T, C), j = N(Se, 0, [1], "04"), Tt = N(Se, 0, [2, 0], "06"), Pt = N(Se, 0, [3, 0], "03").substr(2), Dt = "";
      if (L.crypto.OID.oidhex2name[Tt] !== void 0)
        Dt = L.crypto.OID.oidhex2name[Tt];
      else
        throw new Error("undefined OID(hex) in KJUR.crypto.OID: " + Tt);
      var ee = new q({ curve: Dt });
      return ee.setPublicKeyHex(Pt), ee.setPrivateKeyHex(j), ee.isPublic = !1, ee;
    }
    if (T.indexOf("-END DSA PRIVATE KEY-") != -1 && T.indexOf("4,ENCRYPTED") != -1) {
      var Se = se.getDecryptedKeyHex(T, C), Re = N(Se, 0, [1], "02"), Te = N(Se, 0, [2], "02"), He = N(Se, 0, [3], "02"), ut = N(Se, 0, [4], "02"), vt = N(Se, 0, [5], "02"), j = new oe();
      return j.setPrivate(new f(Re, 16), new f(Te, 16), new f(He, 16), new f(ut, 16), new f(vt, 16)), j;
    }
    if (T.indexOf("-END ENCRYPTED PRIVATE KEY-") != -1)
      return se.getKeyFromEncryptedPKCS8PEM(T, C);
    throw new Error("not supported argument");
  }, Yr.generateKeypair = function(T, C) {
    if (T == "RSA") {
      var I = C, R = new Er();
      R.generate(I, "10001"), R.isPrivate = !0, R.isPublic = !0;
      var M = new Er(), N = R.n.toString(16), Y = R.e.toString(16);
      M.setPublic(N, Y), M.isPrivate = !1, M.isPublic = !0;
      var q = {};
      return q.prvKeyObj = R, q.pubKeyObj = M, q;
    } else if (T == "EC") {
      var oe = C, J = new L.crypto.ECDSA({ curve: oe }), de = J.generateKeyPairHex(), R = new L.crypto.ECDSA({ curve: oe });
      R.setPublicKeyHex(de.ecpubhex), R.setPrivateKeyHex(de.ecprvhex), R.isPrivate = !0, R.isPublic = !1;
      var M = new L.crypto.ECDSA({ curve: oe });
      M.setPublicKeyHex(de.ecpubhex), M.isPrivate = !1, M.isPublic = !0;
      var q = {};
      return q.prvKeyObj = R, q.pubKeyObj = M, q;
    } else
      throw new Error("unknown algorithm: " + T);
  }, Yr.getPEM = function(T, C, I, R, M, N) {
    var Y = L, q = Y.asn1, oe = q.DERObjectIdentifier, J = q.DERInteger, de = q.ASN1Util.newObject, se = q.x509, j = se.SubjectPublicKeyInfo, ee = Y.crypto, W = ee.DSA, re = ee.ECDSA, ce = Er;
    function me(Tt) {
      var Pt = de({ seq: [{ int: 0 }, { int: { bigint: Tt.n } }, { int: Tt.e }, { int: { bigint: Tt.d } }, { int: { bigint: Tt.p } }, { int: { bigint: Tt.q } }, { int: { bigint: Tt.dmp1 } }, { int: { bigint: Tt.dmq1 } }, { int: { bigint: Tt.coeff } }] });
      return Pt;
    }
    function Ve(Tt) {
      var Pt = de({ seq: [{ int: 1 }, { octstr: { hex: Tt.prvKeyHex } }, { tag: ["a0", !0, { oid: { name: Tt.curveName } }] }, { tag: ["a1", !0, { bitstr: { hex: "00" + Tt.pubKeyHex } }] }] });
      return Pt;
    }
    function at(Tt) {
      var Pt = de({ seq: [{ int: 0 }, { int: { bigint: Tt.p } }, { int: { bigint: Tt.q } }, { int: { bigint: Tt.g } }, { int: { bigint: Tt.y } }, { int: { bigint: Tt.x } }] });
      return Pt;
    }
    if ((ce !== void 0 && T instanceof ce || W !== void 0 && T instanceof W || re !== void 0 && T instanceof re) && T.isPublic == !0 && (C === void 0 || C == "PKCS8PUB")) {
      var it = new j(T), ct = it.tohex();
      return Go(ct, "PUBLIC KEY");
    }
    if (C == "PKCS1PRV" && ce !== void 0 && T instanceof ce && (I === void 0 || I == null) && T.isPrivate == !0) {
      var it = me(T), ct = it.tohex();
      return Go(ct, "RSA PRIVATE KEY");
    }
    if (C == "PKCS1PRV" && re !== void 0 && T instanceof re && (I === void 0 || I == null) && T.isPrivate == !0) {
      var ge = new oe({ name: T.curveName }), Se = ge.tohex(), Re = Ve(T), Te = Re.tohex(), He = "";
      return He += Go(Se, "EC PARAMETERS"), He += Go(Te, "EC PRIVATE KEY"), He;
    }
    if (C == "PKCS1PRV" && W !== void 0 && T instanceof W && (I === void 0 || I == null) && T.isPrivate == !0) {
      var it = at(T), ct = it.tohex();
      return Go(ct, "DSA PRIVATE KEY");
    }
    if (C == "PKCS5PRV" && ce !== void 0 && T instanceof ce && I !== void 0 && I != null && T.isPrivate == !0) {
      var it = me(T), ct = it.tohex();
      return R === void 0 && (R = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", ct, I, R, N);
    }
    if (C == "PKCS5PRV" && re !== void 0 && T instanceof re && I !== void 0 && I != null && T.isPrivate == !0) {
      var it = Ve(T), ct = it.tohex();
      return R === void 0 && (R = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", ct, I, R, N);
    }
    if (C == "PKCS5PRV" && W !== void 0 && T instanceof W && I !== void 0 && I != null && T.isPrivate == !0) {
      var it = at(T), ct = it.tohex();
      return R === void 0 && (R = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", ct, I, R, N);
    }
    var ut = function(Tt, Pt) {
      if (typeof Pt == "string")
        return Yr.getEncryptedPKCS8PEM(Tt, Pt);
      if (typeof Pt == "object" && Fn(Pt, "passcode") != null) {
        var Dt = JSON.parse(JSON.stringify(Pt)), Wo = Dt.passcode;
        return delete Dt.passcode, Yr.getEncryptedPKCS8PEM(Tt, Wo, Dt);
      }
    };
    if (C == "PKCS8PRV" && ce != null && T instanceof ce && T.isPrivate == !0) {
      var vt = me(T), Rt = vt.tohex(), it = de({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: !0 }] }, { octstr: { hex: Rt } }] }), ct = it.tohex();
      return I === void 0 || I == null ? Go(ct, "PRIVATE KEY") : ut(ct, I);
    }
    if (C == "PKCS8PRV" && re !== void 0 && T instanceof re && T.isPrivate == !0) {
      var pt = { seq: [{ int: 1 }, { octstr: { hex: T.prvKeyHex } }] };
      typeof T.pubKeyHex == "string" && pt.seq.push({ tag: ["a1", !0, { bitstr: { hex: "00" + T.pubKeyHex } }] });
      var vt = new de(pt), Rt = vt.tohex(), it = de({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: T.curveName } }] }, { octstr: { hex: Rt } }] }), ct = it.tohex();
      return I === void 0 || I == null ? Go(ct, "PRIVATE KEY") : ut(ct, I);
    }
    if (C == "PKCS8PRV" && W !== void 0 && T instanceof W && T.isPrivate == !0) {
      var vt = new J({ bigint: T.x }), Rt = vt.tohex(), it = de({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: T.p } }, { int: { bigint: T.q } }, { int: { bigint: T.g } }] }] }, { octstr: { hex: Rt } }] }), ct = it.tohex();
      return I === void 0 || I == null ? Go(ct, "PRIVATE KEY") : ut(ct, I);
    }
    throw new Error("unsupported object nor format");
  }, Yr.getKeyFromCSRPEM = function(T) {
    var C = Ai(T, "CERTIFICATE REQUEST"), I = Yr.getKeyFromCSRHex(C);
    return I;
  }, Yr.getKeyFromCSRHex = function(T) {
    var C = Yr.parseCSRHex(T), I = Yr.getKey(C.p8pubkeyhex, null, "pkcs8pub");
    return I;
  }, Yr.parseCSRHex = function(T) {
    var C = lt, I = C.getChildIdx, R = C.getTLV, M = {}, N = T;
    if (N.substr(0, 2) != "30")
      throw new Error("malformed CSR(code:001)");
    var Y = I(N, 0);
    if (Y.length < 1)
      throw new Error("malformed CSR(code:002)");
    if (N.substr(Y[0], 2) != "30")
      throw new Error("malformed CSR(code:003)");
    var q = I(N, Y[0]);
    if (q.length < 3)
      throw new Error("malformed CSR(code:004)");
    return M.p8pubkeyhex = R(N, q[2]), M;
  }, Yr.getKeyID = function(T) {
    var C = Yr, I = lt;
    typeof T == "string" && T.indexOf("BEGIN ") != -1 && (T = C.getKey(T));
    var R = Ai(C.getPEM(T)), M = I.getIdxbyList(R, 0, [1]), N = I.getV(R, M).substring(2);
    return L.crypto.Util.hashHex(N, "sha1");
  }, Yr.getJWK = function(T, C, I, R, M) {
    var N, Y = {}, q, oe = L.crypto.Util.hashHex;
    if (typeof T == "string")
      N = Yr.getKey(T), T.indexOf("CERTIFICATE") != -1 && (q = Ai(T));
    else if (typeof T == "object")
      T instanceof mr ? (N = T.getPublicKey(), q = T.hex) : N = T;
    else
      throw new Error("unsupported keyinfo type");
    if (N instanceof Er && N.isPrivate)
      Y.kty = "RSA", Y.n = Vr(N.n.toString(16)), Y.e = Vr(N.e.toString(16)), Y.d = Vr(N.d.toString(16)), Y.p = Vr(N.p.toString(16)), Y.q = Vr(N.q.toString(16)), Y.dp = Vr(N.dmp1.toString(16)), Y.dq = Vr(N.dmq1.toString(16)), Y.qi = Vr(N.coeff.toString(16));
    else if (N instanceof Er && N.isPublic)
      Y.kty = "RSA", Y.n = Vr(N.n.toString(16)), Y.e = Vr(N.e.toString(16));
    else if (N instanceof L.crypto.ECDSA && N.isPrivate) {
      var J = N.getShortNISTPCurveName();
      if (J !== "P-256" && J !== "P-384" && J !== "P-521")
        throw new Error("unsupported curve name for JWT: " + J);
      var de = N.getPublicKeyXYHex();
      Y.kty = "EC", Y.crv = J, Y.x = Vr(de.x), Y.y = Vr(de.y), Y.d = Vr(N.prvKeyHex);
    } else if (N instanceof L.crypto.ECDSA && N.isPublic) {
      var J = N.getShortNISTPCurveName();
      if (J !== "P-256" && J !== "P-384" && J !== "P-521")
        throw new Error("unsupported curve name for JWT: " + J);
      var de = N.getPublicKeyXYHex();
      Y.kty = "EC", Y.crv = J, Y.x = Vr(de.x), Y.y = Vr(de.y);
    }
    if (Y.kty == null)
      throw new Error("unsupported keyinfo");
    return !N.isPrivate && C != !0 && (Y.kid = L.jws.JWS.getJWKthumbprint(Y)), q != null && I != !0 && (Y.x5c = [u(q)]), q != null && R != !0 && (Y.x5t = rr(u(oe(q, "sha1")))), q != null && M != !0 && (Y["x5t#S256"] = rr(u(oe(q, "sha256")))), Y;
  }, Yr.getJWKFromKey = function(T) {
    return Yr.getJWK(T, !0, !0, !0, !0);
  }, Er.getPosArrayOfChildrenFromHex = function(T) {
    return lt.getChildIdx(T, 0);
  }, Er.getHexValueArrayOfChildrenFromHex = function(T) {
    var C = lt, I = C.getV, j = Er.getPosArrayOfChildrenFromHex(T), R = I(T, j[0]), M = I(T, j[1]), N = I(T, j[2]), Y = I(T, j[3]), q = I(T, j[4]), oe = I(T, j[5]), J = I(T, j[6]), de = I(T, j[7]), se = I(T, j[8]), j = new Array();
    return j.push(R, M, N, Y, q, oe, J, de, se), j;
  }, Er.prototype.readPrivateKeyFromPEMString = function(T) {
    var C = Ai(T), I = Er.getHexValueArrayOfChildrenFromHex(C);
    this.setPrivateEx(I[1], I[2], I[3], I[4], I[5], I[6], I[7], I[8]);
  }, Er.prototype.readPKCS5PrvKeyHex = function(T) {
    var C = Er.getHexValueArrayOfChildrenFromHex(T);
    this.setPrivateEx(C[1], C[2], C[3], C[4], C[5], C[6], C[7], C[8]);
  }, Er.prototype.readPKCS8PrvKeyHex = function(T) {
    var C, I, R, M, N, Y, q, oe, J = lt, de = J.getVbyListEx;
    if (J.isASN1HEX(T) === !1)
      throw new Error("not ASN.1 hex string");
    try {
      C = de(T, 0, [2, 0, 1], "02"), I = de(T, 0, [2, 0, 2], "02"), R = de(T, 0, [2, 0, 3], "02"), M = de(T, 0, [2, 0, 4], "02"), N = de(T, 0, [2, 0, 5], "02"), Y = de(T, 0, [2, 0, 6], "02"), q = de(T, 0, [2, 0, 7], "02"), oe = de(T, 0, [2, 0, 8], "02");
    } catch {
      throw new Error("malformed PKCS#8 plain RSA private key");
    }
    this.setPrivateEx(C, I, R, M, N, Y, q, oe);
  }, Er.prototype.readPKCS5PubKeyHex = function(T) {
    var C = lt, I = C.getV;
    if (C.isASN1HEX(T) === !1)
      throw new Error("keyHex is not ASN.1 hex string");
    var R = C.getChildIdx(T, 0);
    if (R.length !== 2 || T.substr(R[0], 2) !== "02" || T.substr(R[1], 2) !== "02")
      throw new Error("wrong hex for PKCS#5 public key");
    var M = I(T, R[0]), N = I(T, R[1]);
    this.setPublic(M, N);
  }, Er.prototype.readPKCS8PubKeyHex = function(T) {
    var C = lt;
    if (C.isASN1HEX(T) === !1)
      throw new Error("not ASN.1 hex string");
    if (C.getTLVbyListEx(T, 0, [0, 0]) !== "06092a864886f70d010101")
      throw new Error("not PKCS8 RSA public key");
    var I = C.getTLVbyListEx(T, 0, [1, 0]);
    this.readPKCS5PubKeyHex(I);
  }, Er.prototype.readCertPubKeyHex = function(T, C) {
    var I, R;
    I = new mr(), I.readCertHex(T), R = I.getPublicKeyHex(), this.readPKCS8PubKeyHex(R);
  };
  function YU(T, C) {
    for (var I = "", R = C / 4 - T.length, M = 0; M < R; M++)
      I = I + "0";
    return I + T;
  }
  Er.prototype.sign = function(T, C) {
    var I = function(M) {
      return L.crypto.Util.hashString(M, C);
    }, R = I(T);
    return this.signWithMessageHash(R, C);
  }, Er.prototype.signWithMessageHash = function(T, C) {
    var I = L.crypto.Util.getPaddedDigestInfoHex(T, C, this.n.bitLength()), R = Yo(I, 16), M = this.doPrivate(R), N = M.toString(16);
    return YU(N, this.n.bitLength());
  };
  function GU(T, C, I) {
    for (var R = "", M = 0; R.length < C; )
      R += Ia(I(Ds(T + String.fromCharCode.apply(String, [(M & 4278190080) >> 24, (M & 16711680) >> 16, (M & 65280) >> 8, M & 255])))), M += 1;
    return R;
  }
  Er.prototype.signPSS = function(T, C, I) {
    var R = function(N) {
      return L.crypto.Util.hashHex(N, C);
    }, M = R(Ds(T));
    return I === void 0 && (I = -1), this.signWithMessageHashPSS(M, C, I);
  }, Er.prototype.signWithMessageHashPSS = function(T, C, I) {
    var R = Ia(T), M = R.length, N = this.n.bitLength() - 1, Y = Math.ceil(N / 8), q, oe = function(ce) {
      return L.crypto.Util.hashHex(ce, C);
    };
    if (I === -1 || I === void 0)
      I = M;
    else if (I === -2)
      I = Y - M - 2;
    else if (I < -2)
      throw new Error("invalid salt length");
    if (Y < M + I + 2)
      throw new Error("data too long");
    var J = "";
    I > 0 && (J = new Array(I), new bc().nextBytes(J), J = String.fromCharCode.apply(String, J));
    var de = Ia(oe(Ds("\0\0\0\0\0\0\0\0" + R + J))), se = [];
    for (q = 0; q < Y - I - M - 2; q += 1)
      se[q] = 0;
    var j = String.fromCharCode.apply(String, se) + "" + J, ee = GU(de, j.length, oe), W = [];
    for (q = 0; q < j.length; q += 1)
      W[q] = j.charCodeAt(q) ^ ee.charCodeAt(q);
    var re = 65280 >> 8 * Y - N & 255;
    for (W[0] &= ~re, q = 0; q < M; q++)
      W.push(de.charCodeAt(q));
    return W.push(188), YU(this.doPrivate(new f(W)).toString(16), this.n.bitLength());
  };
  function WU(T) {
    for (var C in L.crypto.Util.DIGESTINFOHEAD) {
      var I = L.crypto.Util.DIGESTINFOHEAD[C], R = I.length;
      if (T.substring(0, R) == I) {
        var M = [C, T.substring(R)];
        return M;
      }
    }
    return [];
  }
  Er.prototype.verify = function(T, C) {
    if (C = C.toLowerCase(), C.match(/^[0-9a-f]+$/) == null)
      return !1;
    var I = Yo(C, 16), R = this.n.bitLength();
    if (I.bitLength() > R)
      return !1;
    var M = this.doPublic(I), N = M.toString(16);
    if (N.length + 3 != R / 4)
      return !1;
    var Y = N.replace(/^1f+00/, ""), q = WU(Y);
    if (q.length == 0)
      return !1;
    var oe = q[0], J = q[1], de = function(j) {
      return L.crypto.Util.hashString(j, oe);
    }, se = de(T);
    return J == se;
  }, Er.prototype.verifyWithMessageHash = function(T, C) {
    if (C.length != Math.ceil(this.n.bitLength() / 4))
      return !1;
    var I = Yo(C, 16);
    if (I.bitLength() > this.n.bitLength())
      return 0;
    var R = this.doPublic(I), M = R.toString(16).replace(/^1f+00/, ""), N = WU(M);
    if (N.length == 0)
      return !1;
    N[0];
    var Y = N[1];
    return Y == T;
  }, Er.prototype.verifyPSS = function(T, C, I, R) {
    var M = function(Y) {
      return L.crypto.Util.hashHex(Y, I);
    }, N = M(Ds(T));
    return R === void 0 && (R = -1), this.verifyWithMessageHashPSS(N, C, I, R);
  }, Er.prototype.verifyWithMessageHashPSS = function(T, C, I, R) {
    if (C.length != Math.ceil(this.n.bitLength() / 4))
      return !1;
    var M = new f(C, 16), N = function(Ve) {
      return L.crypto.Util.hashHex(Ve, I);
    }, Y = Ia(T), q = Y.length, oe = this.n.bitLength() - 1, J = Math.ceil(oe / 8), de;
    if (R === -1 || R === void 0)
      R = q;
    else if (R === -2)
      R = J - q - 2;
    else if (R < -2)
      throw new Error("invalid salt length");
    if (J < q + R + 2)
      throw new Error("data too long");
    var se = this.doPublic(M).toByteArray();
    for (de = 0; de < se.length; de += 1)
      se[de] &= 255;
    for (; se.length < J; )
      se.unshift(0);
    if (se[J - 1] !== 188)
      throw new Error("encoded message does not end in 0xbc");
    se = String.fromCharCode.apply(String, se);
    var j = se.substr(0, J - q - 1), ee = se.substr(j.length, q), W = 65280 >> 8 * J - oe & 255;
    if (j.charCodeAt(0) & W)
      throw new Error("bits beyond keysize not zero");
    var re = GU(ee, j.length, N), ce = [];
    for (de = 0; de < j.length; de += 1)
      ce[de] = j.charCodeAt(de) ^ re.charCodeAt(de);
    ce[0] &= ~W;
    var me = J - q - R - 2;
    for (de = 0; de < me; de += 1)
      if (ce[de] !== 0)
        throw new Error("leftmost octets not zero");
    if (ce[me] !== 1)
      throw new Error("0x01 marker not found");
    return ee === Ia(N(Ds("\0\0\0\0\0\0\0\0" + Y + String.fromCharCode.apply(String, ce.slice(-R)))));
  }, Er.SALT_LEN_HLEN = -1, Er.SALT_LEN_MAX = -2, Er.SALT_LEN_RECOVER = -2;
  function mr(T) {
    var C = lt, I = C.getChildIdx, R = C.getV;
    C.dump;
    var M = C.parse, N = C.getTLV, Y = C.getVbyList, q = C.getVbyListEx, oe = C.getTLVbyList, J = C.getTLVbyListEx, de = C.getIdxbyList, se = C.getIdxbyListEx, j = C.getVidx, ee = C.getInt, W = C.oidname, re = C.hextooidstr, ce = Ai, me, Ve = Error;
    try {
      me = L.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
    } catch {
    }
    this.HEX2STAG = { "0c": "utf8", 13: "prn", 16: "ia5", "1a": "vis", "1e": "bmp" }, this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function() {
      if (this.hex === null || this.version !== 0)
        return this.version;
      var ge = oe(this.hex, 0, [0, 0]);
      if (ge.substr(0, 2) == "a0") {
        var Se = oe(ge, 0, [0]), Re = ee(Se, 0);
        if (Re < 0 || 2 < Re)
          throw new Error("malformed version field");
        return this.version = Re + 1, this.version;
      } else
        return this.version = 1, this.foffset = -1, 1;
    }, this.getSerialNumberHex = function() {
      return q(this.hex, 0, [0, 0], "02");
    }, this.getSignatureAlgorithmField = function() {
      var ge = J(this.hex, 0, [0, 1]);
      return this.getAlgorithmIdentifierName(ge);
    }, this.getAlgorithmIdentifierName = function(ge) {
      for (var Se in me)
        if (ge === me[Se])
          return Se;
      return W(q(ge, 0, [0], "06"));
    }, this.getIssuer = function(ge, Se) {
      return this.getX500Name(this.getIssuerHex(), ge, Se);
    }, this.getIssuerHex = function() {
      return oe(this.hex, 0, [0, 3 + this.foffset], "30");
    }, this.getIssuerString = function() {
      var ge = this.getIssuer();
      return ge.str;
    }, this.getSubject = function(ge, Se) {
      return this.getX500Name(this.getSubjectHex(), ge, Se);
    }, this.getSubjectHex = function() {
      return oe(this.hex, 0, [0, 5 + this.foffset], "30");
    }, this.getSubjectString = function() {
      var ge = this.getSubject();
      return ge.str;
    }, this.getNotBefore = function() {
      var ge = Y(this.hex, 0, [0, 4 + this.foffset, 0]);
      return ge = ge.replace(/(..)/g, "%$1"), ge = decodeURIComponent(ge), ge;
    }, this.getNotAfter = function() {
      var ge = Y(this.hex, 0, [0, 4 + this.foffset, 1]);
      return ge = ge.replace(/(..)/g, "%$1"), ge = decodeURIComponent(ge), ge;
    }, this.getPublicKeyHex = function() {
      return this.getSPKI();
    }, this.getSPKI = function() {
      return oe(this.hex, 0, [0, 6 + this.foffset], "30");
    }, this.getSPKIValue = function() {
      var ge = this.getSPKI();
      return ge == null ? null : Y(ge, 0, [1], "03", !0);
    }, this.getPublicKeyIdx = function() {
      return de(this.hex, 0, [0, 6 + this.foffset], "30");
    }, this.getPublicKeyContentIdx = function() {
      var ge = this.getPublicKeyIdx();
      return de(this.hex, ge, [1, 0], "30");
    }, this.getPublicKey = function() {
      return Yr.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
    }, this.getSignatureAlgorithmName = function() {
      var ge = oe(this.hex, 0, [1], "30");
      return this.getAlgorithmIdentifierName(ge);
    }, this.getSignatureValueHex = function() {
      return Y(this.hex, 0, [2], "03", !0);
    }, this.verifySignature = function(ge) {
      var Se = this.getSignatureAlgorithmField(), Re = this.getSignatureValueHex(), Te = oe(this.hex, 0, [0], "30"), He = new L.crypto.Signature({ alg: Se });
      return He.init(ge), He.updateHex(Te), He.verify(Re);
    }, this.parseExt = function(ge) {
      var Se, Re, Te;
      if (ge === void 0) {
        if (Te = this.hex, this.version !== 3)
          return -1;
        Se = de(Te, 0, [0, 7, 0], "30"), Re = I(Te, Se);
      } else {
        Te = Ai(ge);
        var He = de(Te, 0, [0, 3, 0, 0], "06");
        if (R(Te, He) != "2a864886f70d01090e") {
          this.aExtInfo = new Array();
          return;
        }
        Se = de(Te, 0, [0, 3, 0, 1, 0], "30"), Re = I(Te, Se), this.hex = Te;
      }
      this.aExtInfo = new Array();
      for (var ut = 0; ut < Re.length; ut++) {
        var vt = {};
        vt.critical = !1;
        var Rt = I(Te, Re[ut]), pt = 0;
        Rt.length === 3 && (vt.critical = !0, pt = 1), vt.oid = C.hextooidstr(Y(Te, Re[ut], [0], "06"));
        var Tt = de(Te, Re[ut], [1 + pt]);
        vt.vidx = j(Te, Tt), this.aExtInfo.push(vt);
      }
    }, this.getExtInfo = function(ge) {
      var Se = this.aExtInfo, Re = ge;
      if (ge.match(/^[0-9.]+$/) || (Re = L.asn1.x509.OID.name2oid(ge)), Re !== "") {
        for (var Te = 0; Te < Se.length; Te++)
          if (Se[Te].oid === Re)
            return Se[Te];
      }
    }, this.getCriticalExtV = function(ge, Se, Re) {
      if (Se != null)
        return [Se, Re];
      var Te = this.getExtInfo(ge);
      return Te == null ? [null, null] : [N(this.hex, Te.vidx), Te.critical];
    }, this.getExtBasicConstraints = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("basicConstraints");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "basicConstraints" };
      if (Se && (Te.critical = !0), ge === "3000")
        return Te;
      if (ge === "30030101ff")
        return Te.cA = !0, Te;
      if (ge.substr(0, 12) === "30060101ff02") {
        var He = R(ge, 10), ut = parseInt(He, 16);
        return Te.cA = !0, Te.pathLen = ut, Te;
      }
      throw new Error("hExtV parse error: " + ge);
    }, this.getExtNameConstraints = function(ge, Se) {
      var Re = this.getCriticalExtV("nameConstraints", ge, Se);
      if (ge = Re[0], Se = Re[1], ge != null) {
        var Te = { extname: "nameConstraints" };
        Se && (Te.critical = !0);
        for (var He = I(ge, 0), ut = 0; ut < He.length; ut++) {
          for (var vt = [], Rt = I(ge, He[ut]), pt = 0; pt < Rt.length; pt++) {
            var Tt = N(ge, Rt[pt]), Pt = this.getGeneralSubtree(Tt);
            vt.push(Pt);
          }
          var Dt = ge.substr(He[ut], 2);
          Dt == "a0" ? Te.permit = vt : Dt == "a1" && (Te.exclude = vt);
        }
        return Te;
      }
    }, this.getGeneralSubtree = function(ge) {
      var Se = I(ge, 0), Re = Se.length;
      if (Re < 1 || 2 < Re)
        throw new Error("wrong num elements");
      for (var Te = this.getGeneralName(N(ge, Se[0])), He = 1; He < Re; He++) {
        var ut = ge.substr(Se[He], 2), vt = R(ge, Se[He]), Rt = parseInt(vt, 16);
        ut == "80" && (Te.min = Rt), ut == "81" && (Te.max = Rt);
      }
      return Te;
    }, this.getExtKeyUsage = function(ge, Se) {
      var Re = this.getCriticalExtV("keyUsage", ge, Se);
      if (ge = Re[0], Se = Re[1], ge != null) {
        var Te = { extname: "keyUsage" };
        return Se && (Te.critical = !0), Te.names = this.getExtKeyUsageString(ge).split(","), Te;
      }
    }, this.getExtKeyUsageBin = function(ge) {
      if (ge === void 0) {
        var Se = this.getExtInfo("keyUsage");
        if (Se === void 0)
          return "";
        ge = N(this.hex, Se.vidx);
      }
      if (ge.length != 8 && ge.length != 10)
        throw new Error("malformed key usage value: " + ge);
      var Re = "000000000000000" + parseInt(ge.substr(6), 16).toString(2);
      return ge.length == 8 && (Re = Re.slice(-8)), ge.length == 10 && (Re = Re.slice(-16)), Re = Re.replace(/0+$/, ""), Re == "" && (Re = "0"), Re;
    }, this.getExtKeyUsageString = function(ge) {
      for (var Se = this.getExtKeyUsageBin(ge), Re = new Array(), Te = 0; Te < Se.length; Te++)
        Se.substr(Te, 1) == "1" && Re.push(mr.KEYUSAGE_NAME[Te]);
      return Re.join(",");
    }, this.getExtSubjectKeyIdentifier = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("subjectKeyIdentifier");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "subjectKeyIdentifier" };
      Se && (Te.critical = !0);
      var He = R(ge, 0);
      return Te.kid = { hex: He }, Te;
    }, this.getExtAuthorityKeyIdentifier = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("authorityKeyIdentifier");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "authorityKeyIdentifier" };
      Se && (Te.critical = !0);
      for (var He = I(ge, 0), ut = 0; ut < He.length; ut++) {
        var vt = ge.substr(He[ut], 2);
        if (vt === "80" && (Te.kid = { hex: R(ge, He[ut]) }), vt === "a1") {
          var Rt = N(ge, He[ut]), pt = this.getGeneralNames(Rt);
          Te.issuer = pt[0].dn;
        }
        vt === "82" && (Te.sn = { hex: R(ge, He[ut]) });
      }
      return Te;
    }, this.getExtExtKeyUsage = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("extKeyUsage");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "extKeyUsage", array: [] };
      Se && (Te.critical = !0);
      for (var He = I(ge, 0), ut = 0; ut < He.length; ut++)
        Te.array.push(W(R(ge, He[ut])));
      return Te;
    }, this.getExtExtKeyUsageName = function() {
      var ge = this.getExtInfo("extKeyUsage");
      if (ge === void 0)
        return ge;
      var Se = new Array(), Re = N(this.hex, ge.vidx);
      if (Re === "")
        return Se;
      for (var Te = I(Re, 0), He = 0; He < Te.length; He++)
        Se.push(W(R(Re, Te[He])));
      return Se;
    }, this.getExtSubjectAltName = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("subjectAltName");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "subjectAltName", array: [] };
      return Se && (Te.critical = !0), Te.array = this.getGeneralNames(ge), Te;
    }, this.getExtIssuerAltName = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("issuerAltName");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "issuerAltName", array: [] };
      return Se && (Te.critical = !0), Te.array = this.getGeneralNames(ge), Te;
    }, this.getGeneralNames = function(ge) {
      for (var Se = I(ge, 0), Re = [], Te = 0; Te < Se.length; Te++) {
        var He = this.getGeneralName(N(ge, Se[Te]));
        He !== void 0 && Re.push(He);
      }
      return Re;
    }, this.getGeneralName = function(ge) {
      var Se = ge.substr(0, 2), Re = R(ge, 0), Te = Ia(Re);
      if (Se == "81")
        return { rfc822: Te };
      if (Se == "82")
        return { dns: Te };
      if (Se == "86")
        return { uri: Te };
      if (Se == "87")
        return { ip: b_(Re) };
      if (Se == "a4")
        return { dn: this.getX500Name(Re) };
      if (Se == "a0")
        return { other: this.getOtherName(ge) };
    }, this.getExtSubjectAltName2 = function() {
      var ge, Se, Re, Te = this.getExtInfo("subjectAltName");
      if (Te === void 0)
        return Te;
      for (var He = new Array(), ut = N(this.hex, Te.vidx), vt = I(ut, 0), Rt = 0; Rt < vt.length; Rt++)
        Re = ut.substr(vt[Rt], 2), ge = R(ut, vt[Rt]), Re === "81" && (Se = dn(ge), He.push(["MAIL", Se])), Re === "82" && (Se = dn(ge), He.push(["DNS", Se])), Re === "84" && (Se = mr.hex2dn(ge, 0), He.push(["DN", Se])), Re === "86" && (Se = dn(ge), He.push(["URI", Se])), Re === "87" && (Se = b_(ge), He.push(["IP", Se]));
      return He;
    }, this.getExtCRLDistributionPoints = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("cRLDistributionPoints");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "cRLDistributionPoints", array: [] };
      Se && (Te.critical = !0);
      for (var He = I(ge, 0), ut = 0; ut < He.length; ut++) {
        var vt = N(ge, He[ut]);
        Te.array.push(this.getDistributionPoint(vt));
      }
      return Te;
    }, this.getDistributionPoint = function(ge) {
      for (var Se = {}, Re = I(ge, 0), Te = 0; Te < Re.length; Te++) {
        var He = ge.substr(Re[Te], 2), ut = N(ge, Re[Te]);
        He == "a0" && (Se.dpname = this.getDistributionPointName(ut));
      }
      return Se;
    }, this.getDistributionPointName = function(ge) {
      for (var Se = {}, Re = I(ge, 0), Te = 0; Te < Re.length; Te++) {
        var He = ge.substr(Re[Te], 2), ut = N(ge, Re[Te]);
        He == "a0" && (Se.full = this.getGeneralNames(ut));
      }
      return Se;
    }, this.getExtCRLDistributionPointsURI = function() {
      var ge = this.getExtCRLDistributionPoints();
      if (ge == null)
        return ge;
      for (var Se = ge.array, Re = [], Te = 0; Te < Se.length; Te++)
        try {
          Se[Te].dpname.full[0].uri != null && Re.push(Se[Te].dpname.full[0].uri);
        } catch {
        }
      return Re;
    }, this.getExtAIAInfo = function() {
      var ge = this.getExtInfo("authorityInfoAccess");
      if (ge === void 0)
        return ge;
      for (var Se = { ocsp: [], caissuer: [] }, Re = I(this.hex, ge.vidx), Te = 0; Te < Re.length; Te++) {
        var He = Y(this.hex, Re[Te], [0], "06"), ut = Y(this.hex, Re[Te], [1], "86");
        He === "2b06010505073001" && Se.ocsp.push(dn(ut)), He === "2b06010505073002" && Se.caissuer.push(dn(ut));
      }
      return Se;
    }, this.getExtAuthorityInfoAccess = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("authorityInfoAccess");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "authorityInfoAccess", array: [] };
      Se && (Te.critical = !0);
      for (var He = I(ge, 0), ut = 0; ut < He.length; ut++) {
        var vt = q(ge, He[ut], [0], "06"), Rt = Y(ge, He[ut], [1], "86"), pt = dn(Rt);
        if (vt == "2b06010505073001")
          Te.array.push({ ocsp: pt });
        else if (vt == "2b06010505073002")
          Te.array.push({ caissuer: pt });
        else
          throw new Error("unknown method: " + vt);
      }
      return Te;
    }, this.getExtCertificatePolicies = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("certificatePolicies");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "certificatePolicies", array: [] };
      Se && (Te.critical = !0);
      for (var He = I(ge, 0), ut = 0; ut < He.length; ut++) {
        var vt = N(ge, He[ut]), Rt = this.getPolicyInformation(vt);
        Te.array.push(Rt);
      }
      return Te;
    }, this.getPolicyInformation = function(ge) {
      var Se = {}, Re = Y(ge, 0, [0], "06");
      Se.policyoid = W(Re);
      var Te = se(ge, 0, [1], "30");
      if (Te != -1) {
        Se.array = [];
        for (var He = I(ge, Te), ut = 0; ut < He.length; ut++) {
          var vt = N(ge, He[ut]), Rt = this.getPolicyQualifierInfo(vt);
          Se.array.push(Rt);
        }
      }
      return Se;
    }, this.getOtherName = function(ge) {
      var Se = {}, Re = I(ge, 0), Te = Y(ge, Re[0], [], "06"), He = Y(ge, Re[1], []);
      return Se.oid = W(Te), Se.value = M(He), Se;
    }, this.getPolicyQualifierInfo = function(ge) {
      var Se = {}, Re = Y(ge, 0, [0], "06");
      if (Re === "2b06010505070201") {
        var Te = q(ge, 0, [1], "16");
        Se.cps = Ia(Te);
      } else if (Re === "2b06010505070202") {
        var He = oe(ge, 0, [1], "30");
        Se.unotice = this.getUserNotice(He);
      }
      return Se;
    }, this.getUserNotice = function(ge) {
      var Se = null;
      try {
        Se = C.parse(ge);
        var Re = this._asn1ToUnotice(Se);
        return Re;
      } catch {
        return;
      }
    }, this._asn1ToUnotice = function(ge) {
      try {
        for (var Se = {}, Re = Fn(ge, "seq"), Te = 0; Te < Re.length; Te++) {
          var He = this._asn1ToNoticeRef(Re[Te]);
          He != null && (Se.noticeref = He);
          var ut = this.asn1ToDisplayText(Re[Te]);
          ut != null && (Se.exptext = ut);
        }
        return Object.keys(Se).length > 0 ? Se : void 0;
      } catch {
        return;
      }
    }, this._asn1ToNoticeRef = function(ge) {
      try {
        for (var Se = {}, Re = Fn(ge, "seq"), Te = 0; Te < Re.length; Te++) {
          var He = this._asn1ToNoticeNum(Re[Te]);
          He != null && (Se.noticenum = He);
          var ut = this.asn1ToDisplayText(Re[Te]);
          ut != null && (Se.org = ut);
        }
        return Object.keys(Se).length > 0 ? Se : void 0;
      } catch {
        return;
      }
    }, this._asn1ToNoticeNum = function(ge) {
      try {
        for (var Se = Fn(ge, "seq"), Re = [], Te = 0; Te < Se.length; Te++) {
          var He = Se[Te];
          Re.push(parseInt(Fn(He, "int.hex"), 16));
        }
        return Re;
      } catch {
        return;
      }
    }, this.getDisplayText = function(ge) {
      var Se = { "0c": "utf8", 16: "ia5", "1a": "vis", "1e": "bmp" }, Re = {};
      return Re.type = Se[ge.substr(0, 2)], Re.str = Ia(R(ge, 0)), Re;
    }, this.asn1ToDisplayText = function(ge) {
      if (ge.utf8str != null)
        return { type: "utf8", str: ge.utf8str.str };
      if (ge.ia5str != null)
        return { type: "ia5", str: ge.ia5str.str };
      if (ge.visstr != null)
        return { type: "vis", str: ge.visstr.str };
      if (ge.bmpstr != null)
        return { type: "bmp", str: ge.bmpstr.str };
      if (ge.prnstr != null)
        return { type: "prn", str: ge.prnstr.str };
    }, this.getExtPolicyMappings = function(ge, Se) {
      var Re = this.getCriticalExtV("policyMappings", ge, Se);
      if (ge = Re[0], Se = Re[1], ge != null) {
        var Te = { extname: "policyMappings" };
        Se && (Te.critical = !0);
        try {
          for (var He = M(ge), ut = He.seq, vt = [], Rt = 0; Rt < ut.length; Rt++) {
            var pt = ut[Rt].seq;
            vt.push([pt[0].oid, pt[1].oid]);
          }
          Te.array = vt;
        } catch {
          throw new Ve("malformed policyMappings");
        }
        return Te;
      }
    }, this.getExtPolicyConstraints = function(ge, Se) {
      var Re = this.getCriticalExtV("policyConstraints", ge, Se);
      if (ge = Re[0], Se = Re[1], ge != null) {
        var Te = { extname: "policyConstraints" };
        Se && (Te.critical = !0);
        var He = M(ge);
        try {
          for (var ut = He.seq, vt = 0; vt < ut.length; vt++) {
            var Rt = ut[vt].tag;
            Rt.explicit == !1 && (Rt.tag == "80" && (Te.reqexp = parseInt(Rt.hex, 16)), Rt.tag == "81" && (Te.inhibit = parseInt(Rt.hex, 16)));
          }
        } catch {
          return new Ve("malformed policyConstraints value");
        }
        return Te;
      }
    }, this.getExtInhibitAnyPolicy = function(ge, Se) {
      var Re = this.getCriticalExtV("inhibitAnyPolicy", ge, Se);
      if (ge = Re[0], Se = Re[1], ge != null) {
        var Te = { extname: "inhibitAnyPolicy" };
        Se && (Te.critical = !0);
        var He = ee(ge, 0);
        return He == -1 ? new Ve("wrong value") : (Te.skip = He, Te);
      }
    }, this.getExtCRLNumber = function(ge, Se) {
      var Re = { extname: "cRLNumber" };
      if (Se && (Re.critical = !0), ge.substr(0, 2) == "02")
        return Re.num = { hex: R(ge, 0) }, Re;
      throw new Ve("hExtV parse error: " + ge);
    }, this.getExtCRLReason = function(ge, Se) {
      var Re = { extname: "cRLReason" };
      if (Se && (Re.critical = !0), ge.substr(0, 2) == "0a")
        return Re.code = parseInt(R(ge, 0), 16), Re;
      throw new Error("hExtV parse error: " + ge);
    }, this.getExtOcspNonce = function(ge, Se) {
      var Re = { extname: "ocspNonce" };
      Se && (Re.critical = !0);
      var Te = R(ge, 0);
      return Re.hex = Te, Re;
    }, this.getExtOcspNoCheck = function(ge, Se) {
      var Re = { extname: "ocspNoCheck" };
      return Se && (Re.critical = !0), Re;
    }, this.getExtAdobeTimeStamp = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("adobeTimeStamp");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "adobeTimeStamp" };
      Se && (Te.critical = !0);
      var He = I(ge, 0);
      if (He.length > 1) {
        var ut = N(ge, He[1]), vt = this.getGeneralName(ut);
        vt.uri != null && (Te.uri = vt.uri);
      }
      if (He.length > 2) {
        var Rt = N(ge, He[2]);
        Rt == "0101ff" && (Te.reqauth = !0), Rt == "010100" && (Te.reqauth = !1);
      }
      return Te;
    }, this.getExtSubjectDirectoryAttributes = function(ge, Se) {
      if (ge === void 0 && Se === void 0) {
        var Re = this.getExtInfo("subjectDirectoryAttributes");
        if (Re === void 0)
          return;
        ge = N(this.hex, Re.vidx), Se = Re.critical;
      }
      var Te = { extname: "subjectDirectoryAttributes" };
      Se && (Te.critical = !0);
      try {
        for (var He = M(ge), ut = [], vt = 0; vt < He.seq.length; vt++) {
          var Rt = He.seq[vt], pt = Fn(Rt, "seq.0.oid"), Tt = Fn(Rt, "seq.1.set");
          if (pt == null || Tt == null)
            throw "error";
          ut.push({ attr: pt, array: Tt });
        }
        return Te.array = ut, Te;
      } catch {
        throw new Error("malformed subjectDirectoryAttributes extension value");
      }
    };
    var at = function(ge) {
      var Se = {};
      try {
        var Re = ge.seq[0].oid, Te = L.asn1.x509.OID.name2oid(Re);
        Se.type = L.asn1.x509.OID.oid2atype(Te);
        var He = ge.seq[1];
        if (He.utf8str != null)
          Se.ds = "utf8", Se.value = He.utf8str.str;
        else if (He.numstr != null)
          Se.ds = "num", Se.value = He.numstr.str;
        else if (He.telstr != null)
          Se.ds = "tel", Se.value = He.telstr.str;
        else if (He.prnstr != null)
          Se.ds = "prn", Se.value = He.prnstr.str;
        else if (He.ia5str != null)
          Se.ds = "ia5", Se.value = He.ia5str.str;
        else if (He.visstr != null)
          Se.ds = "vis", Se.value = He.visstr.str;
        else if (He.bmpstr != null)
          Se.ds = "bmp", Se.value = He.bmpstr.str;
        else
          throw "error";
        return Se;
      } catch {
        throw new Erorr("improper ASN.1 parsed AttrTypeAndValue");
      }
    }, it = function(ge) {
      try {
        return ge.set.map(function(Se) {
          return at(Se);
        });
      } catch (Se) {
        throw new Error("improper ASN.1 parsed RDN: " + Se);
      }
    }, ct = function(ge) {
      try {
        return ge.seq.map(function(Se) {
          return it(Se);
        });
      } catch (Se) {
        throw new Error("improper ASN.1 parsed X500Name: " + Se);
      }
    };
    this.getX500NameRule = function(ge) {
      for (var Se = null, Re = [], Te = 0; Te < ge.length; Te++)
        for (var He = ge[Te], ut = 0; ut < He.length; ut++)
          Re.push(He[ut]);
      for (var Te = 0; Te < Re.length; Te++) {
        var vt = Re[Te], Rt = vt.ds, pt = vt.value, Tt = vt.type;
        if (Rt != "prn" && Rt != "utf8" && Rt != "ia5")
          return "mixed";
        if (Rt == "ia5") {
          if (Tt != "CN")
            return "mixed";
          if (L.lang.String.isMail(pt))
            continue;
          return "mixed";
        }
        if (Tt == "C") {
          if (Rt == "prn")
            continue;
          return "mixed";
        }
        if (Se == null)
          Se = Rt;
        else if (Se !== Rt)
          return "mixed";
      }
      return Se ?? "prn";
    }, this.getAttrTypeAndValue = function(ge) {
      var Se = M(ge);
      return at(Se);
    }, this.getRDN = function(ge) {
      var Se = M(ge);
      return it(Se);
    }, this.getX500NameArray = function(ge) {
      var Se = M(ge);
      return ct(Se);
    }, this.getX500Name = function(ge, Se, Re) {
      var Te = this.getX500NameArray(ge), He = this.dnarraytostr(Te), ut = { str: He };
      return ut.array = Te, Re == !0 && (ut.hex = ge), Se == !0 && (ut.canon = this.c14nRDNArray(Te)), ut;
    }, this.readCertPEM = function(ge) {
      this.readCertHex(ce(ge));
    }, this.readCertHex = function(ge) {
      this.hex = ge, this.getVersion();
      try {
        de(this.hex, 0, [0, 7], "a3"), this.parseExt();
      } catch {
      }
    }, this.getParam = function(ge) {
      var Se = {};
      return ge == null && (ge = {}), Se.version = this.getVersion(), Se.serial = { hex: this.getSerialNumberHex() }, Se.sigalg = this.getSignatureAlgorithmField(), Se.issuer = this.getIssuer(ge.dncanon, ge.dnhex), Se.notbefore = this.getNotBefore(), Se.notafter = this.getNotAfter(), Se.subject = this.getSubject(ge.dncanon, ge.dnhex), Se.sbjpubkey = Go(this.getPublicKeyHex(), "PUBLIC KEY"), this.aExtInfo != null && this.aExtInfo.length > 0 && (Se.ext = this.getExtParamArray()), Se.sighex = this.getSignatureValueHex(), ge.tbshex == !0 && (Se.tbshex = oe(this.hex, 0, [0])), ge.nodnarray == !0 && (delete Se.issuer.array, delete Se.subject.array), Se;
    }, this.getExtParamArray = function(ge) {
      if (ge == null) {
        var Se = se(this.hex, 0, [0, "[3]"]);
        Se != -1 && (ge = J(this.hex, 0, [0, "[3]", 0], "30"));
      }
      for (var Re = [], Te = I(ge, 0), He = 0; He < Te.length; He++) {
        var ut = N(ge, Te[He]), vt = this.getExtParam(ut);
        vt != null && Re.push(vt);
      }
      return Re;
    }, this.getExtParam = function(ge) {
      var Se = I(ge, 0), Re = Se.length;
      if (Re != 2 && Re != 3)
        throw new Error("wrong number elements in Extension: " + Re + " " + ge);
      var Te = re(Y(ge, 0, [0], "06")), He = !1;
      Re == 3 && oe(ge, 0, [1]) == "0101ff" && (He = !0);
      var ut = oe(ge, 0, [Re - 1, 0]), vt = void 0;
      if (Te == "2.5.29.14" ? vt = this.getExtSubjectKeyIdentifier(ut, He) : Te == "2.5.29.15" ? vt = this.getExtKeyUsage(ut, He) : Te == "2.5.29.17" ? vt = this.getExtSubjectAltName(ut, He) : Te == "2.5.29.18" ? vt = this.getExtIssuerAltName(ut, He) : Te == "2.5.29.19" ? vt = this.getExtBasicConstraints(ut, He) : Te == "2.5.29.30" ? vt = this.getExtNameConstraints(ut, He) : Te == "2.5.29.31" ? vt = this.getExtCRLDistributionPoints(ut, He) : Te == "2.5.29.32" ? vt = this.getExtCertificatePolicies(ut, He) : Te == "2.5.29.33" ? vt = this.getExtPolicyMappings(ut, He) : Te == "2.5.29.35" ? vt = this.getExtAuthorityKeyIdentifier(ut, He) : Te == "2.5.29.36" ? vt = this.getExtPolicyConstraints(ut, He) : Te == "2.5.29.37" ? vt = this.getExtExtKeyUsage(ut, He) : Te == "2.5.29.54" ? vt = this.getExtInhibitAnyPolicy(ut, He) : Te == "1.3.6.1.5.5.7.1.1" ? vt = this.getExtAuthorityInfoAccess(ut, He) : Te == "2.5.29.20" ? vt = this.getExtCRLNumber(ut, He) : Te == "2.5.29.21" ? vt = this.getExtCRLReason(ut, He) : Te == "2.5.29.9" ? vt = this.getExtSubjectDirectoryAttributes(ut, He) : Te == "1.3.6.1.5.5.7.48.1.2" ? vt = this.getExtOcspNonce(ut, He) : Te == "1.3.6.1.5.5.7.48.1.5" ? vt = this.getExtOcspNoCheck(ut, He) : Te == "1.2.840.113583.1.1.9.1" ? vt = this.getExtAdobeTimeStamp(ut, He) : mr.EXT_PARSER[Te] != null && (vt = mr.EXT_PARSER[Te](Te, He, ut)), vt != null)
        return vt;
      var Rt = { extname: Te, extn: ut };
      try {
        Rt.extn = M(ut);
      } catch {
      }
      return He && (Rt.critical = !0), Rt;
    }, this.findExt = function(ge, Se) {
      for (var Re = 0; Re < ge.length; Re++)
        if (ge[Re].extname == Se)
          return ge[Re];
      return null;
    }, this.updateExtCDPFullURI = function(ge, Se) {
      var Re = this.findExt(ge, "cRLDistributionPoints");
      if (Re != null && Re.array != null) {
        for (var Te = Re.array, He = 0; He < Te.length; He++)
          if (Te[He].dpname != null && Te[He].dpname.full != null)
            for (var ut = Te[He].dpname.full, vt = 0; vt < ut.length; vt++) {
              var Rt = ut[He];
              Rt.uri != null && (Rt.uri = Se);
            }
      }
    }, this.updateExtAIAOCSP = function(ge, Se) {
      var Re = this.findExt(ge, "authorityInfoAccess");
      if (Re != null && Re.array != null)
        for (var Te = Re.array, He = 0; He < Te.length; He++)
          Te[He].ocsp != null && (Te[He].ocsp = Se);
    }, this.updateExtAIACAIssuer = function(ge, Se) {
      var Re = this.findExt(ge, "authorityInfoAccess");
      if (Re != null && Re.array != null)
        for (var Te = Re.array, He = 0; He < Te.length; He++)
          Te[He].caissuer != null && (Te[He].caissuer = Se);
    }, this.dnarraytostr = function(ge) {
      function Se(Te) {
        return Te.map(function(He) {
          return Re(He).replace(/\+/, "\\+");
        }).join("+");
      }
      function Re(Te) {
        return Te.type + "=" + Te.value;
      }
      return "/" + ge.map(function(Te) {
        return Se(Te).replace(/\//, "\\/");
      }).join("/");
    }, this.setCanonicalizedDN = function(ge) {
      var Se;
      if (ge.str != null && ge.array == null) {
        var Re = new L.asn1.x509.X500Name({ str: ge.str }), Te = Re.tohex();
        Se = this.getX500NameArray(Te);
      } else
        Se = ge.array;
      ge.canon == null && (ge.canon = this.c14nRDNArray(Se));
    }, this.c14nRDNArray = function(ge) {
      for (var Se = [], Re = 0; Re < ge.length; Re++) {
        for (var Te = ge[Re], He = [], ut = 0; ut < Te.length; ut++) {
          var vt = Te[ut], Rt = vt.value;
          Rt = Rt.replace(/^\s*/, ""), Rt = Rt.replace(/\s*$/, ""), Rt = Rt.replace(/\s+/g, " "), Rt = Rt.toLowerCase(), He.push(vt.type.toLowerCase() + "=" + Rt);
        }
        Se.push(He.join("+"));
      }
      return "/" + Se.join("/");
    }, this.getInfo = function() {
      var ge = function(la) {
        for (var Qr = "", xn = "    ", fi = `
`, di = la.array, Oa = 0; Oa < di.length; Oa++) {
          var Si = di[Oa];
          if (Si.dn != null && (Qr += xn + "dn: " + Si.dn.str + fi), Si.ip != null && (Qr += xn + "ip: " + Si.ip + fi), Si.rfc822 != null && (Qr += xn + "rfc822: " + Si.rfc822 + fi), Si.dns != null && (Qr += xn + "dns: " + Si.dns + fi), Si.uri != null && (Qr += xn + "uri: " + Si.uri + fi), Si.other != null) {
            var Av = Si.other.oid, b0 = JSON.stringify(Si.other.value).replace(/\"/g, "");
            Qr += xn + "other: " + Av + "=" + b0 + fi;
          }
        }
        return Qr = Qr.replace(/\n$/, ""), Qr;
      }, Se = function(la) {
        for (var Qr = "", xn = la.array, fi = 0; fi < xn.length; fi++) {
          var di = xn[fi];
          if (Qr += "    policy oid: " + di.policyoid + `
`, di.array !== void 0)
            for (var Oa = 0; Oa < di.array.length; Oa++) {
              var Si = di.array[Oa];
              Si.cps !== void 0 && (Qr += "    cps: " + Si.cps + `
`);
            }
        }
        return Qr;
      }, Re = function(la) {
        for (var Qr = "", xn = la.array, fi = 0; fi < xn.length; fi++) {
          var di = xn[fi];
          try {
            di.dpname.full[0].uri !== void 0 && (Qr += "    " + di.dpname.full[0].uri + `
`);
          } catch {
          }
          try {
            di.dname.full[0].dn.hex !== void 0 && (Qr += "    " + mr.hex2dn(di.dpname.full[0].dn.hex) + `
`);
          } catch {
          }
        }
        return Qr;
      }, Te = function(la) {
        for (var Qr = "", xn = la.array, fi = 0; fi < xn.length; fi++) {
          var di = xn[fi];
          di.caissuer !== void 0 && (Qr += "    caissuer: " + di.caissuer + `
`), di.ocsp !== void 0 && (Qr += "    ocsp: " + di.ocsp + `
`);
        }
        return Qr;
      }, He, ut, vt;
      if (He = `Basic Fields
`, He += "  serial number: " + this.getSerialNumberHex() + `
`, He += "  signature algorithm: " + this.getSignatureAlgorithmField() + `
`, He += "  issuer: " + this.getIssuerString() + `
`, He += "  notBefore: " + this.getNotBefore() + `
`, He += "  notAfter: " + this.getNotAfter() + `
`, He += "  subject: " + this.getSubjectString() + `
`, He += `  subject public key info: 
`, ut = this.getPublicKey(), He += "    key algorithm: " + ut.type + `
`, ut.type === "RSA" && (He += "    n=" + eI(ut.n.toString(16)).substr(0, 16) + `...
`, He += "    e=" + eI(ut.e.toString(16)) + `
`), vt = this.aExtInfo, vt != null) {
        He += `X509v3 Extensions:
`;
        for (var Rt = 0; Rt < vt.length; Rt++) {
          var pt = vt[Rt], Tt = L.asn1.x509.OID.oid2name(pt.oid);
          Tt === "" && (Tt = pt.oid);
          var Pt = "";
          if (pt.critical === !0 && (Pt = "CRITICAL"), He += "  " + Tt + " " + Pt + `:
`, Tt === "basicConstraints") {
            var Dt = this.getExtBasicConstraints();
            Dt.cA === void 0 ? He += `    {}
` : (He += "    cA=true", Dt.pathLen !== void 0 && (He += ", pathLen=" + Dt.pathLen), He += `
`);
          } else if (Tt == "policyMappings") {
            var Wo = this.getExtPolicyMappings().array, li = Wo.map(function(la) {
              var Qr = la;
              return Qr[0] + ":" + Qr[1];
            }).join(", ");
            He += "    " + li + `
`;
          } else if (Tt == "policyConstraints") {
            var Gn = this.getExtPolicyConstraints();
            He += "    ", Gn.reqexp != null && (He += " reqexp=" + Gn.reqexp), Gn.inhibit != null && (He += " inhibit=" + Gn.inhibit), He += `
`;
          } else if (Tt == "inhibitAnyPolicy") {
            var Gn = this.getExtInhibitAnyPolicy();
            He += "    skip=" + Gn.skip + `
`;
          } else if (Tt == "keyUsage")
            He += "    " + this.getExtKeyUsageString() + `
`;
          else if (Tt == "subjectKeyIdentifier")
            He += "    " + this.getExtSubjectKeyIdentifier().kid.hex + `
`;
          else if (Tt == "authorityKeyIdentifier") {
            var Vi = this.getExtAuthorityKeyIdentifier();
            Vi.kid !== void 0 && (He += "    kid=" + Vi.kid.hex + `
`);
          } else if (Tt == "extKeyUsage") {
            var go = this.getExtExtKeyUsage().array;
            He += "    " + go.join(", ") + `
`;
          } else if (Tt == "subjectAltName") {
            var Po = ge(this.getExtSubjectAltName());
            He += Po + `
`;
          } else if (Tt == "cRLDistributionPoints") {
            var To = this.getExtCRLDistributionPoints();
            He += Re(To);
          } else if (Tt == "authorityInfoAccess") {
            var _v = this.getExtAuthorityInfoAccess();
            He += Te(_v);
          } else
            Tt == "certificatePolicies" && (He += Se(this.getExtCertificatePolicies()));
        }
      }
      return He += "signature algorithm: " + this.getSignatureAlgorithmName() + `
`, He += "signature: " + this.getSignatureValueHex().substr(0, 16) + `...
`, He;
    }, typeof T == "string" && (T.indexOf("-----BEGIN") != -1 ? this.readCertPEM(T) : L.lang.String.isHex(T) && this.readCertHex(T));
  }
  mr.EXT_PARSER = {}, mr.registExtParser = function(T, C) {
    mr.EXT_PARSER[T] = C;
  }, mr.hex2dn = function(T, C) {
    C === void 0 && (C = 0);
    var I = new mr();
    lt.getTLV(T, C);
    var R = I.getX500Name(T);
    return R.str;
  }, mr.hex2rdn = function(T, C) {
    if (C === void 0 && (C = 0), T.substr(C, 2) !== "31")
      throw new Error("malformed RDN");
    for (var I = new Array(), R = lt.getChildIdx(T, C), M = 0; M < R.length; M++)
      I.push(mr.hex2attrTypeValue(T, R[M]));
    return I = I.map(function(N) {
      return N.replace("+", "\\+");
    }), I.join("+");
  }, mr.hex2attrTypeValue = function(T, C) {
    var I = lt, R = I.getV;
    if (C === void 0 && (C = 0), T.substr(C, 2) !== "30")
      throw new Error("malformed attribute type and value");
    var M = I.getChildIdx(T, C);
    M.length !== 2 || T.substr(M[0], 2);
    var N = R(T, M[0]), Y = L.asn1.ASN1Util.oidHexToInt(N), q = L.asn1.x509.OID.oid2atype(Y), oe = R(T, M[1]), J = Ia(oe);
    return q + "=" + J;
  }, mr.getPublicKeyFromCertHex = function(T) {
    var C = new mr();
    return C.readCertHex(T), C.getPublicKey();
  }, mr.getPublicKeyFromCertPEM = function(T) {
    var C = new mr();
    return C.readCertPEM(T), C.getPublicKey();
  }, mr.getPublicKeyInfoPropOfCertPEM = function(T) {
    var C = lt, I = C.getVbyList, R = {}, M, N;
    return R.algparam = null, M = new mr(), M.readCertPEM(T), N = M.getPublicKeyHex(), R.keyhex = I(N, 0, [1], "03").substr(2), R.algoid = I(N, 0, [0, 0], "06"), R.algoid === "2a8648ce3d0201" && (R.algparam = I(N, 0, [0, 1], "06")), R;
  }, mr.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"];
  var bIe = function(T) {
    var C = L, I = C.lang.String.isHex, R = lt, M = R.getV, N = R.getTLV, Y = R.getVbyList, q = R.getTLVbyList, oe = R.getTLVbyListEx, J = R.getIdxbyList, de = R.getIdxbyListEx, se = R.getChildIdx, j = new mr();
    this.hex = null, this.posSigAlg = null, this.posRevCert = null, this.parsed = null, this._setPos = function() {
      var ee = J(this.hex, 0, [0, 0]), W = this.hex.substr(ee, 2);
      if (W == "02")
        this.posSigAlg = 1;
      else if (W == "30")
        this.posSigAlg = 0;
      else
        throw new Error("malformed 1st item of TBSCertList: " + W);
      var re = J(this.hex, 0, [0, this.posSigAlg + 3]), ce = this.hex.substr(re, 2);
      if (ce == "17" || ce == "18") {
        var me, Ve;
        me = J(this.hex, 0, [0, this.posSigAlg + 4]), this.posRevCert = null, me != -1 && (Ve = this.hex.substr(me, 2), Ve == "30" && (this.posRevCert = this.posSigAlg + 4));
      } else if (ce == "30")
        this.posRevCert = this.posSigAlg + 3;
      else if (ce == "a0")
        this.posRevCert = null;
      else
        throw new Error("malformed nextUpdate or revCert tag: " + ce);
    }, this.getVersion = function() {
      return this.posSigAlg == 0 ? null : parseInt(Y(this.hex, 0, [0, 0], "02"), 16) + 1;
    }, this.getSignatureAlgorithmField = function() {
      var ee = q(this.hex, 0, [0, this.posSigAlg], "30");
      return j.getAlgorithmIdentifierName(ee);
    }, this.getIssuer = function() {
      return j.getX500Name(this.getIssuerHex());
    }, this.getIssuerHex = function() {
      return q(this.hex, 0, [0, this.posSigAlg + 1], "30");
    }, this.getThisUpdate = function() {
      var ee = Y(this.hex, 0, [0, this.posSigAlg + 2]);
      return result = Ia(ee);
    }, this.getNextUpdate = function() {
      var ee = J(this.hex, 0, [0, this.posSigAlg + 3]), W = this.hex.substr(ee, 2);
      return W != "17" && W != "18" ? null : Ia(M(this.hex, ee));
    }, this.getRevCertArray = function() {
      if (this.posRevCert == null)
        return null;
      for (var ee = [], W = J(this.hex, 0, [0, this.posRevCert]), re = se(this.hex, W), ce = 0; ce < re.length; ce++) {
        var me = N(this.hex, re[ce]);
        ee.push(this.getRevCert(me));
      }
      return ee;
    }, this.getRevCert = function(ee) {
      var W = {}, re = se(ee, 0);
      return W.sn = { hex: Y(ee, 0, [0], "02") }, W.date = Ia(Y(ee, 0, [1])), re.length == 3 && (W.ext = j.getExtParamArray(q(ee, 0, [2]))), W;
    }, this.findRevCert = function(ee) {
      var W = new mr(ee), re = W.getSerialNumberHex();
      return this.findRevCertBySN(re);
    }, this.findRevCertBySN = function(ee) {
      if (this.parsed == null && this.getParam(), this.parsed.revcert == null)
        return null;
      for (var W = this.parsed.revcert, re = 0; re < W.length; re++)
        if (ee == W[re].sn.hex)
          return W[re];
      return null;
    }, this.getSignatureValueHex = function() {
      return Y(this.hex, 0, [2], "03", !0);
    }, this.verifySignature = function(ee) {
      var W = this.getSignatureAlgorithmField(), re = this.getSignatureValueHex(), ce = q(this.hex, 0, [0], "30"), me = new L.crypto.Signature({ alg: W });
      return me.init(ee), me.updateHex(ce), me.verify(re);
    }, this.getParam = function(ee) {
      var W = {}, re = this.getVersion();
      re != null && (W.version = re), W.sigalg = this.getSignatureAlgorithmField(), W.issuer = this.getIssuer(), W.thisupdate = this.getThisUpdate();
      var ce = this.getNextUpdate();
      ce != null && (W.nextupdate = ce);
      var me = this.getRevCertArray();
      me != null && (W.revcert = me);
      var Ve = de(this.hex, 0, [0, "[0]"]);
      if (Ve != -1) {
        var at = oe(this.hex, 0, [0, "[0]", 0]);
        W.ext = j.getExtParamArray(at);
      }
      return W.sighex = this.getSignatureValueHex(), this.parsed = W, typeof ee == "object" && (ee.tbshex == !0 && (W.tbshex = q(this.hex, 0, [0])), ee.nodnarray == !0 && delete W.issuer.array), W;
    }, typeof T == "string" && (I(T) ? this.hex = T : T.match(/-----BEGIN X509 CRL/) && (this.hex = Ai(T)), this._setPos());
  };
  return (typeof L > "u" || !L) && (L = {}), (typeof L.jws > "u" || !L.jws) && (L.jws = {}), L.jws.JWS = function() {
    var T = L, C = T.jws.JWS, I = C.isSafeJSONString;
    this.parseJWS = function(R, M) {
      if (!(this.parsedJWS !== void 0 && (M || this.parsedJWS.sigvalH !== void 0))) {
        var N = R.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
        if (N == null)
          throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
        var Y = N[1], q = N[2], oe = N[3], J = Y + "." + q;
        if (this.parsedJWS = {}, this.parsedJWS.headB64U = Y, this.parsedJWS.payloadB64U = q, this.parsedJWS.sigvalB64U = oe, this.parsedJWS.si = J, !M) {
          var de = Br(oe), se = Yo(de, 16);
          this.parsedJWS.sigvalH = de, this.parsedJWS.sigvalBI = se;
        }
        var j = Zn(Y), ee = Zn(q);
        if (this.parsedJWS.headS = j, this.parsedJWS.payloadS = ee, !I(j, this.parsedJWS, "headP"))
          throw "malformed JSON string for JWS Head: " + j;
      }
    };
  }, L.jws.JWS.sign = function(T, C, I, R, M) {
    var N = L, Y = N.jws, q = Y.JWS, oe = q.readSafeJSONString, J = q.isSafeJSONString, de = N.crypto;
    de.ECDSA;
    var se = de.Mac, j = de.Signature, ee = JSON, W, re, ce;
    if (typeof C != "string" && typeof C != "object")
      throw "spHeader must be JSON string or object: " + C;
    if (typeof C == "object" && (re = C, W = ee.stringify(re)), typeof C == "string") {
      if (W = C, !J(W))
        throw "JWS Head is not safe JSON string: " + W;
      re = oe(W);
    }
    if (ce = I, typeof I == "object" && (ce = ee.stringify(I)), (T == "" || T == null) && re.alg !== void 0 && (T = re.alg), T != "" && T != null && re.alg === void 0 && (re.alg = T, W = ee.stringify(re)), T !== re.alg)
      throw "alg and sHeader.alg doesn't match: " + T + "!=" + re.alg;
    var me = null;
    if (q.jwsalg2sigalg[T] === void 0)
      throw "unsupported alg name: " + T;
    me = q.jwsalg2sigalg[T];
    var Ve = ca(W), at = ca(ce), it = Ve + "." + at, ct = "";
    if (me.substr(0, 4) == "Hmac") {
      if (R === void 0)
        throw "mac key shall be specified for HS* alg";
      var ge = new se({ alg: me, prov: "cryptojs", pass: R });
      ge.updateString(it), ct = ge.doFinal();
    } else if (me.indexOf("withECDSA") != -1) {
      var Se = new j({ alg: me });
      Se.init(R, M), Se.updateString(it);
      var Re = Se.sign();
      ct = L.crypto.ECDSA.asn1SigToConcatSig(Re);
    } else if (me != "none") {
      var Se = new j({ alg: me });
      Se.init(R, M), Se.updateString(it), ct = Se.sign();
    }
    var Te = Vr(ct);
    return it + "." + Te;
  }, L.jws.JWS.verify = function(T, C, I) {
    var R = L, M = R.jws, N = M.JWS, Y = N.readSafeJSONString, q = R.crypto, oe = q.ECDSA, J = q.Mac, de = q.Signature, se;
    if (typeof Er !== void 0 && (se = Er), !Q2(T))
      return !1;
    var j = T.split(".");
    if (j.length !== 3)
      return !1;
    var ee = j[0], W = j[1], re = ee + "." + W, ce = Br(j[2]), me = Y(Zn(j[0])), Ve = null, at = null;
    if (me.alg === void 0)
      throw "algorithm not specified in header";
    if (Ve = me.alg, at = Ve.substr(0, 2), I != null && Object.prototype.toString.call(I) === "[object Array]" && I.length > 0) {
      var it = ":" + I.join(":") + ":";
      if (it.indexOf(":" + Ve + ":") == -1)
        throw "algorithm '" + Ve + "' not accepted in the list";
    }
    if (Ve != "none" && C === null)
      throw "key shall be specified to verify.";
    if (typeof C == "string" && C.indexOf("-----BEGIN ") != -1 && (C = Yr.getKey(C)), (at == "RS" || at == "PS") && !(C instanceof se))
      throw "key shall be a RSAKey obj for RS* and PS* algs";
    if (at == "ES" && !(C instanceof oe))
      throw "key shall be a ECDSA obj for ES* algs";
    var ct = null;
    if (N.jwsalg2sigalg[me.alg] === void 0)
      throw "unsupported alg name: " + Ve;
    if (ct = N.jwsalg2sigalg[Ve], ct == "none")
      throw "not supported";
    if (ct.substr(0, 4) == "Hmac") {
      var ge = null;
      if (C === void 0)
        throw "hexadecimal key shall be specified for HMAC";
      var Se = new J({ alg: ct, pass: C });
      return Se.updateString(re), ge = Se.doFinal(), ce == ge;
    } else if (ct.indexOf("withECDSA") != -1) {
      var Re = null;
      try {
        Re = oe.concatSigToASN1Sig(ce);
      } catch {
        return !1;
      }
      var Te = new de({ alg: ct });
      return Te.init(C), Te.updateString(re), Te.verify(Re);
    } else {
      var Te = new de({ alg: ct });
      return Te.init(C), Te.updateString(re), Te.verify(ce);
    }
  }, L.jws.JWS.parse = function(T) {
    var C = T.split("."), I = {}, R, M, N;
    if (C.length != 2 && C.length != 3)
      throw "malformed sJWS: wrong number of '.' splitted elements";
    return R = C[0], M = C[1], C.length == 3 && (N = C[2]), I.headerObj = L.jws.JWS.readSafeJSONString(Zn(R)), I.payloadObj = L.jws.JWS.readSafeJSONString(Zn(M)), I.headerPP = JSON.stringify(I.headerObj, null, "  "), I.payloadObj == null ? I.payloadPP = Zn(M) : I.payloadPP = JSON.stringify(I.payloadObj, null, "  "), N !== void 0 && (I.sigHex = Br(N)), I;
  }, L.jws.JWS.verifyJWT = function(T, C, I) {
    var R = L, M = R.jws, N = M.JWS, Y = N.readSafeJSONString, q = N.inArray, oe = N.includedArray;
    if (!Q2(T))
      return !1;
    var J = T.split(".");
    if (J.length != 3)
      return !1;
    var de = J[0], se = J[1];
    Br(J[2]);
    var j = Y(Zn(de)), ee = Y(Zn(se));
    if (j.alg === void 0)
      return !1;
    if (I.alg === void 0)
      throw "acceptField.alg shall be specified";
    if (!q(j.alg, I.alg) || ee.iss !== void 0 && typeof I.iss == "object" && !q(ee.iss, I.iss) || ee.sub !== void 0 && typeof I.sub == "object" && !q(ee.sub, I.sub))
      return !1;
    if (ee.aud !== void 0 && typeof I.aud == "object") {
      if (typeof ee.aud == "string") {
        if (!q(ee.aud, I.aud))
          return !1;
      } else if (typeof ee.aud == "object" && !oe(ee.aud, I.aud))
        return !1;
    }
    var W = M.IntDate.getNow();
    return I.verifyAt !== void 0 && typeof I.verifyAt == "number" && (W = I.verifyAt), (I.gracePeriod === void 0 || typeof I.gracePeriod != "number") && (I.gracePeriod = 0), !(ee.exp !== void 0 && typeof ee.exp == "number" && ee.exp + I.gracePeriod < W || ee.nbf !== void 0 && typeof ee.nbf == "number" && W < ee.nbf - I.gracePeriod || ee.iat !== void 0 && typeof ee.iat == "number" && W < ee.iat - I.gracePeriod || ee.jti !== void 0 && I.jti !== void 0 && ee.jti !== I.jti || !N.verify(T, C, I.alg));
  }, L.jws.JWS.includedArray = function(T, C) {
    var I = L.jws.JWS.inArray;
    if (T === null || typeof T != "object" || typeof T.length != "number")
      return !1;
    for (var R = 0; R < T.length; R++)
      if (!I(T[R], C))
        return !1;
    return !0;
  }, L.jws.JWS.inArray = function(T, C) {
    if (C === null || typeof C != "object" || typeof C.length != "number")
      return !1;
    for (var I = 0; I < C.length; I++)
      if (C[I] == T)
        return !0;
    return !1;
  }, L.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", ES512: "SHA512withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" }, L.jws.JWS.isSafeJSONString = function(T, C, I) {
    var R = null;
    try {
      return R = gt(T), typeof R != "object" || R.constructor === Array ? 0 : (C && (C[I] = R), 1);
    } catch {
      return 0;
    }
  }, L.jws.JWS.readSafeJSONString = function(T) {
    var C = null;
    try {
      return C = gt(T), typeof C != "object" || C.constructor === Array ? null : C;
    } catch {
      return null;
    }
  }, L.jws.JWS.getEncodedSignatureValueFromJWS = function(T) {
    var C = T.match(/^[^.]+\.[^.]+\.([^.]+)$/);
    if (C == null)
      throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
    return C[1];
  }, L.jws.JWS.getJWKthumbprint = function(T) {
    if (T.kty !== "RSA" && T.kty !== "EC" && T.kty !== "oct")
      throw "unsupported algorithm for JWK Thumprint";
    var C = "{";
    if (T.kty === "RSA") {
      if (typeof T.n != "string" || typeof T.e != "string")
        throw "wrong n and e value for RSA key";
      C += '"e":"' + T.e + '",', C += '"kty":"' + T.kty + '",', C += '"n":"' + T.n + '"}';
    } else if (T.kty === "EC") {
      if (typeof T.crv != "string" || typeof T.x != "string" || typeof T.y != "string")
        throw "wrong crv, x and y value for EC key";
      C += '"crv":"' + T.crv + '",', C += '"kty":"' + T.kty + '",', C += '"x":"' + T.x + '",', C += '"y":"' + T.y + '"}';
    } else if (T.kty === "oct") {
      if (typeof T.k != "string")
        throw "wrong k value for oct(symmetric) key";
      C += '"kty":"' + T.kty + '",', C += '"k":"' + T.k + '"}';
    }
    var I = Ds(C), R = L.crypto.Util.hashHex(I, "sha256"), M = Vr(R);
    return M;
  }, L.jws.IntDate = {}, L.jws.IntDate.get = function(T) {
    var C = L.jws.IntDate, I = C.getNow, R = C.getZulu;
    if (T == "now")
      return I();
    if (T == "now + 1hour")
      return I() + 60 * 60;
    if (T == "now + 1day")
      return I() + 60 * 60 * 24;
    if (T == "now + 1month")
      return I() + 60 * 60 * 24 * 30;
    if (T == "now + 1year")
      return I() + 60 * 60 * 24 * 365;
    if (T.match(/Z$/))
      return R(T);
    if (T.match(/^[0-9]+$/))
      return parseInt(T);
    throw "unsupported format: " + T;
  }, L.jws.IntDate.getZulu = function(T) {
    return kU(T);
  }, L.jws.IntDate.getNow = function() {
    var T = ~~(/* @__PURE__ */ new Date() / 1e3);
    return T;
  }, L.jws.IntDate.intDate2UTCString = function(T) {
    var C = new Date(T * 1e3);
    return C.toUTCString();
  }, L.jws.IntDate.intDate2Zulu = function(T) {
    var C = new Date(T * 1e3), I = ("0000" + C.getUTCFullYear()).slice(-4), R = ("00" + (C.getUTCMonth() + 1)).slice(-2), M = ("00" + C.getUTCDate()).slice(-2), N = ("00" + C.getUTCHours()).slice(-2), Y = ("00" + C.getUTCMinutes()).slice(-2), q = ("00" + C.getUTCSeconds()).slice(-2);
    return I + R + M + N + Y + q + "Z";
  }, (typeof L > "u" || !L) && (L = {}), (typeof L.jws > "u" || !L.jws) && (L.jws = {}), L.jws.JWSJS = function() {
    var T = L, C = T.jws, I = C.JWS, R = I.readSafeJSONString;
    this.aHeader = [], this.sPayload = "", this.aSignature = [], this.init = function() {
      this.aHeader = [], this.sPayload = void 0, this.aSignature = [];
    }, this.initWithJWS = function(M) {
      this.init();
      var N = M.split(".");
      if (N.length != 3)
        throw "malformed input JWS";
      this.aHeader.push(N[0]), this.sPayload = N[1], this.aSignature.push(N[2]);
    }, this.addSignature = function(M, N, Y, q) {
      if (this.sPayload === void 0 || this.sPayload === null)
        throw "there's no JSON-JS signature to add.";
      var oe = this.aHeader.length;
      if (this.aHeader.length != this.aSignature.length)
        throw "aHeader.length != aSignature.length";
      try {
        var J = L.jws.JWS.sign(M, N, this.sPayload, Y, q), de = J.split("."), se = de[0], j = de[2];
        this.aHeader.push(de[0]), this.aSignature.push(de[2]);
      } catch (ee) {
        throw this.aHeader.length > oe && this.aHeader.pop(), this.aSignature.length > oe && this.aSignature.pop(), "addSignature failed: " + ee;
      }
    }, this.verifyAll = function(M) {
      if (this.aHeader.length !== M.length || this.aSignature.length !== M.length)
        return !1;
      for (var N = 0; N < M.length; N++) {
        var Y = M[N];
        if (Y.length !== 2)
          return !1;
        var q = this.verifyNth(N, Y[0], Y[1]);
        if (q === !1)
          return !1;
      }
      return !0;
    }, this.verifyNth = function(M, N, Y) {
      if (this.aHeader.length <= M || this.aSignature.length <= M)
        return !1;
      var q = this.aHeader[M], oe = this.aSignature[M], J = q + "." + this.sPayload + "." + oe, de = !1;
      try {
        de = I.verify(J, N, Y);
      } catch {
        return !1;
      }
      return de;
    }, this.readJWSJS = function(M) {
      if (typeof M == "string") {
        var N = R(M);
        if (N == null)
          throw "argument is not safe JSON object string";
        this.aHeader = N.headers, this.sPayload = N.payload, this.aSignature = N.signatures;
      } else
        try {
          if (M.headers.length > 0)
            this.aHeader = M.headers;
          else
            throw "malformed header";
          if (typeof M.payload == "string")
            this.sPayload = M.payload;
          else
            throw "malformed signatures";
          if (M.signatures.length > 0)
            this.aSignature = M.signatures;
          else
            throw "malformed signatures";
        } catch (Y) {
          throw "malformed JWS-JS JSON object: " + Y;
        }
    }, this.getJSON = function() {
      return { headers: this.aHeader, payload: this.sPayload, signatures: this.aSignature };
    }, this.isEmpty = function() {
      return this.aHeader.length == 0 ? 1 : 0;
    };
  }, $t.SecureRandom = bc, $t.rng_seed_time = pv, $t.BigInteger = f, $t.RSAKey = Er, $t.ECDSA = L.crypto.ECDSA, $t.DSA = L.crypto.DSA, $t.Signature = L.crypto.Signature, $t.MessageDigest = L.crypto.MessageDigest, $t.Mac = L.crypto.Mac, $t.KEYUTIL = Yr, $t.ASN1HEX = lt, $t.X509 = mr, $t.X509CRL = bIe, $t.CryptoJS = i, $t.b64tohex = s, $t.b64toBA = c, $t.ECFieldElementFp = yi, $t.ECPointFp = qr, $t.ECCurveFp = Tu, $t.stoBA = zt, $t.BAtos = Yt, $t.BAtohex = ir, $t.stohex = Hr, $t.stob64 = wi, $t.stob64u = ur, $t.b64utos = kr, $t.b64tob64u = rr, $t.b64utob64 = Yn, $t.hex2b64 = u, $t.hextob64u = Vr, $t.b64utohex = Br, $t.utf8tob64u = ca, $t.b64utoutf8 = Zn, $t.utf8tob64 = Ps, $t.b64toutf8 = Cc, $t.utf8tohex = Ic, $t.hextoutf8 = dn, $t.hextorstr = Ia, $t.rstrtohex = Ds, $t.hextob64 = G2, $t.hextob64nl = fIe, $t.b64nltohex = BU, $t.hextopem = Go, $t.pemtohex = Ai, $t.hextoArrayBuffer = hIe, $t.ArrayBuffertohex = vIe, $t.zulutomsec = W2, $t.msectozulu = EIe, $t.zulutosec = kU, $t.zulutodate = mIe, $t.datetozulu = gIe, $t.uricmptohex = A_, $t.hextouricmp = S_, $t.ipv6tohex = K2, $t.hextoipv6 = X2, $t.hextoip = b_, $t.iptohex = J2, $t.ucs2hextoutf8 = Z2, $t.encodeURIComponentAll = C_, $t.newline_toUnix = TIe, $t.newline_toDos = yIe, $t.hextoposhex = eI, $t.intarystrtohex = _Ie, $t.strdiffidx = AIe, $t.oidtohex = UU, $t.hextooid = I_, $t.strpad = O_, $t.bitstrtoint = jU, $t.inttobitstr = zU, $t.bitstrtobinstr = qU, $t.binstrtobitstr = SIe, $t.isBase64URLDot = Q2, $t.namearraytobinstr = R_, $t.extendClass = It, $t.foldnl = __, $t.b64topem = dIe, $t.pemtob64 = pIe, $t.timeogen = MU, $t.aryval = Fn, $t.inttohex = VU, $t.twoscompl = yv, $t.KJUR = L, $t.crypto = L.crypto, $t.asn1 = L.asn1, $t.jws = L.jws, $t.lang = L.lang, $t.VERSION = r, $t.VERSION_FULL = n, $t;
}
var J2e = { exports: {} };
(function(e, t) {
  (function(r, n) {
    {
      var i = w2();
      e.exports = n({
        HttpClient: Tl(),
        AnalyticsHttpClient: mu,
        btoa: r.btoa || xU(),
        KJUR: i.KJUR,
        stob64: i.stob64,
        hextob64u: i.hextob64u,
        b64utoutf8: i.b64utoutf8
      });
    }
  })(fe, function(r) {
    class n {
      /**
       * @description Static method to generate a code verifier
       * @returns {string} A code verifier string
       */
      static GenerateCodeVerifier() {
        var o = r.KJUR.crypto.Util.getRandomHexOfNbits(256);
        return r.hextob64u(o);
      }
      /**
       * @description Public constructor for RefreshableTokenProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity token endpoint.
       * It can be be OpenIdEndpointProvider/FixedEndpointProvider
       * @param {string} consumerKey The consumer key for the calling application
       */
      constructor(o, a) {
        this._endpointProvider = o, this._consumerKey = a, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent("RefreshableTokenProvider", a);
      }
      /**
       * @description Fluent extension for Authorization Code with PKCE
       * @param {string} codeVerifier The PKCE code verifier for the calling application
       */
      WithProofKeyForCodeExchange(o) {
        return this._codeVerifier = o, this;
      }
      /**
       * @description Fluent extension for Authorization Code with client secret
       * @param {string} consumerSecret The consumer secret for the calling application
       */
      WithConsumerSecret(o) {
        return this._consumerSecret = o, this;
      }
      /**
       * @description Fluent extension for Authorization Code with access token
       * @param {string} accessToken The access token for the calling application
       * @param {datetime} tokenExpiry The access token expiry for the calling application
       */
      WithAccessToken(o, a) {
        return this._accessToken = o, this._tokenExpiry = a, this;
      }
      /**
       * @description Fluent extension for Authorization Code with id token
       * @param {string} idToken The ID token for the calling application
       */
      WithIdToken(o) {
        return this._idToken = o, this;
      }
      /**
       * @description Fluent extension for Authorization Code with refresh token
       * @param {string} refreshToken The refresh token for the calling application
       */
      WithRefreshToken(o) {
        return this._refreshToken = o, this;
      }
      /**
       * @description Fluent extension for Authorization Code with persistent storage
       * @param {IPersistentStorage} persistentStorage The persistent storage method for the calling application
       */
      WithPersistentStorage(o) {
        return this._persistentStorage = o, this;
      }
      /**
       * @description Fluent extension to add logout redirect URL
       * @param {string} logoutRedirectUrl 
       */
      WithLogoutRedirect(o) {
        return this._logoutRedirectUrl = o, this;
      }
      /**
       * @description Retrieves an access token for the authenticated user
       * @returns {PromiseLike<string>} A Task that resolves to the value of the access token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveToken.name, this._consumerKey);
        var o = this;
        return new Promise(function(a, u) {
          var s = new Date((/* @__PURE__ */ new Date()).getTime() + 3e5);
          o._accessToken == null || o._isJwt(o._accessToken) && o._jwtExpiry(o._accessToken) < s || !o._isJwt(o._accessToken) && o._tokenExpiry < s ? o._refreshTokenInternal().then(() => {
            a(o._accessToken);
          }).catch((c) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, c, o._consumerKey), u("Unable to refresh token: " + c);
          }) : a(o._accessToken);
        });
      }
      /**
       * @description Retrieves an access token expiry for the authenticated user
       * @returns {PromiseLike<string>} A Task that resolves to the value of the access token expiry on completion
       */
      RetrieveTokenExpiry() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveTokenExpiry.name, this._consumerKey);
        var o = this;
        return new Promise(function(a) {
          a(o._tokenExpiry);
        });
      }
      /**
       * @description Retrieves an ID token for the authenticated user
       * @returns {PromiseLike<string>} A Task that resolves to the value of the ID token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveIdToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveIdToken.name, this._consumerKey);
        var o = this;
        return new Promise(function(a, u) {
          var s = new Date((/* @__PURE__ */ new Date()).getTime() + 3e5);
          o._idToken == null || o._jwtExpiry(o._idToken) < s ? o._refreshTokenInternal().then(() => {
            a(o._idToken);
          }).catch((c) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveIdToken.name, c, o._consumerKey), u("Unable to refresh token: " + c);
          }) : a(o._idToken);
        });
      }
      /**
       * @description Retrieves a refresh token for the authenticated user
       * @returns {PromiseLike<string>} A Task that resolves to the value of the refresh token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveRefreshToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveRefreshToken.name, this._consumerKey);
        var o = this;
        return new Promise(function(a, u) {
          a(o._refreshToken);
        });
      }
      /**
       * @description Retrieves a code verifier for the authenticated user for PKCE grant
       * @returns {PromiseLike<string>} A Task that resolves to the value of the code verifier on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveCodeVerifier() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveCodeVerifier.name, this._consumerKey);
        var o = this;
        return new Promise(function(a, u) {
          a(o._codeVerifier);
        });
      }
      /**
       * @description Revokes a refresh token for the authenticated user
       * @returns {PromiseLike<void>} A Task that revokes refreshtoken
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RevokeRefreshToken() {
        this._analyticshttpclient.sendMethodEvent(this.RevokeRefreshToken.name, this._consumerKey);
        var o = this;
        return new Promise((a, u) => {
          o._endpointProvider.RetrieveTokenRevocationEndpoint().then((s) => {
            var c = "Basic " + r.btoa(o._consumerKey + ":" + o._consumerSecret), l = {
              headers: {
                Authorization: c,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }, f = "token=" + encodeURIComponent(o._refreshToken) + "&token_type_hint=refresh_token&client_id=" + encodeURIComponent(o._consumerKey);
            new r.HttpClient().httpPost(s, f, l).then(function(d) {
              a();
            }).catch((d) => {
              o._analyticshttpclient.sendExceptionEvent(o.RevokeRefreshToken.name, d, o._consumerKey), u("Token revocation failed: " + d);
            });
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RevokeRefreshToken.name, s, o._consumerKey), u("Unable to retrieve token revocation endpoint: " + s);
          });
        });
      }
      _isJwt(o) {
        return o.includes(".");
      }
      _jwtExpiry(o) {
        var a = o.split("."), u = r.KJUR.jws.JWS.readSafeJSONString(r.b64utoutf8(a[1]));
        return new Date(u.exp * 1e3);
      }
      _refreshTokenInternal() {
        var o = this;
        return new Promise(function(a, u) {
          o._endpointProvider.RetrieveTokenEndpoint().then((s) => {
            var c = {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            };
            if (o._consumerSecret) {
              var l = "Basic " + r.btoa(o._consumerKey + ":" + o._consumerSecret);
              c.headers.Authorization = l;
            }
            var f = "grant_type=refresh_token&client_id=" + encodeURIComponent(o._consumerKey) + "&scope=openid&refresh_token=" + encodeURIComponent(o._refreshToken), d = null;
            o._codeVerifier && (f = f + "&code_verifier=" + encodeURIComponent(o._codeVerifier), d = n.GenerateCodeVerifier(), f = f + "&code_challenge_method=S256", f = f + "&code_challenge=" + encodeURIComponent(o._GenerateCodeChallenge(d))), new r.HttpClient().httpPost(s, f, c).then(function(p) {
              var v = JSON.parse(p);
              o._accessToken = v.access_token;
              var h = /* @__PURE__ */ new Date();
              o._tokenExpiry = new Date(h.getTime() + v.expires_in * 1e3), o._idToken = v.id_token, o._refreshToken = v.refresh_token, d && (o._codeVerifier = d), a();
            }).catch((p) => {
              u("Token refresh failed: " + p);
            });
          }).catch((s) => {
            u("Unable to retrieve token endpoint: " + s);
          });
        });
      }
      _GenerateCodeChallenge(o) {
        var a = r.KJUR.crypto.Util.hashString(o, "sha256");
        return r.hextob64u(a);
      }
    }
    return n;
  });
})(J2e);
var NU = J2e.exports;
(function(e, t) {
  (function(r, n) {
    {
      var i = w2();
      e.exports = n({
        RefreshableTokenProvider: NU,
        HttpClient: Tl(),
        AnalyticsHttpClient: mu,
        KJUR: i.KJUR,
        stob64: i.stob64,
        hextob64u: i.hextob64u
      });
    }
  })(fe, function(r) {
    class n extends r.RefreshableTokenProvider {
      /**
       * @description Public constructor for AuthorizationCodeGrantTokenProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity authorization and token endpoints.
       * It can be OpenIdEndpointProvider/FixedEndpointProvider
       * @param {string} consumerKey The consumer key for the calling application
       * @param {string} redirectUrl The URL to which Trimble Identity should redirect after successfully authenticating a user
       */
      constructor(o, a, u) {
        super(o, a, null, null, null, null, null), this._redirectUrl = u, this._codeVerifier = null, this._scopes = ["openid"], this._state = null, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name, a);
      }
      /**
       * @description Fluent extension to add scopes
       * @param {IEnumerable<string>} scopes The scopes to add to the token provider
       */
      WithScopes(o) {
        return this._scopes = this._scopes.concat(o), this;
      }
      /**
       * @description Fluent extension to add logout redirect URL
       * @param {string} logoutRedirectUrl 
       */
      WithLogoutRedirect(o) {
        return this._logoutRedirectUrl = o, this;
      }
      /**
       * @description Fluent extension to add identity provider
       * @param {string} identityProvider 
       */
      WithIdentityProvider(o) {
        return this._identityProvider = o, this;
      }
      /**
       * @description Get a redirect URL for Trimble Identity
       * @param {string} state An optional state parameter that will be passed back to the caller via the redirect URL
       * @returns {PromiseLike<string>} A promise that resolves to the redirect URL
       * @exception Thrown when an authorization endpoint is not provided by the endpoint provider
       */
      GetOAuthRedirect(o) {
        this._analyticshttpclient.sendMethodEvent(this.GetOAuthRedirect.name, this._consumerKey);
        var a = this;
        return new Promise((u, s) => {
          a._endpointProvider.RetrieveAuthorizationEndpoint().then((c) => {
            var l = c + "?response_type=code&scope=" + encodeURIComponent(a._scopes.join(" ")) + "&client_id=" + encodeURIComponent(a._consumerKey) + "&redirect_uri=" + encodeURIComponent(a._redirectUrl);
            a._codeVerifier && (l = l + "&code_challenge_method=S256&code_challenge=" + encodeURIComponent(a._GenerateCodeChallenge(a._codeVerifier))), o && (l = l + "&state=" + encodeURIComponent(o)), a._identityProvider && (l = l + "&identity_provider=" + encodeURIComponent(a._identityProvider)), u(l);
          }).catch((c) => {
            a._analyticshttpclient.sendExceptionEvent(a.GetOAuthRedirect.name, c, a._consumerKey), s("Unable to return OAuth redirect: " + c);
          });
        });
      }
      /**
       * @description Validate the query parameters passed back to the application by Trimble Identity
       * @param {string} query The query string from the URL
       * @returns {PromiseLike<boolean>} A promise that resolves to true if the query string is valid
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      ValidateQuery(o) {
        this._analyticshttpclient.sendMethodEvent(this.ValidateQuery.name, this._consumerKey), o.startsWith("?") && (o = o.substr(1));
        var a = {};
        return o.split("&").forEach((u) => {
          var s = u.split("=");
          a[s[0]] = decodeURIComponent(s[1]);
        }), this._state = a.state, this._validateCode(a.code);
      }
      /**
       * @description Return a redirect URL to log out of all Trimble Identity applications
       * @param {string} state An optional state parameter that will be passed back to the caller via the redirect URL
       * @returns {PromiseLike<string>} A promise that resolves to the value of the redirect URL on completion
       */
      GetOAuthLogoutRedirect(o = null) {
        this._analyticshttpclient.sendMethodEvent(this.GetOAuthLogoutRedirect.name, this._consumerKey);
        var a = this;
        return new Promise((u, s) => {
          a._endpointProvider.RetrieveEndSessionEndpoint().then((c) => {
            c.endsWith("/commonauth") ? u(
              c + "?commonAuthLogout=true&type=samlsso&relyingParty=" + encodeURIComponent(a._consumerKey) + "&commonAuthCallerPath=" + encodeURIComponent(a._logoutRedirectUrl)
            ) : a.RetrieveIdToken().then((l) => {
              var f = c + "?id_token_hint=" + encodeURIComponent(l) + "&post_logout_redirect_uri=" + encodeURIComponent(a._logoutRedirectUrl);
              o && (f = f + "&state=" + encodeURIComponent(o)), u(f);
            }).catch((l) => {
              a._analyticshttpclient.sendExceptionEvent(a.GetOAuthLogoutRedirect.name, l, a._consumerKey), s(l);
            });
          }).catch((c) => {
            a._analyticshttpclient.sendExceptionEvent(a.GetOAuthLogoutRedirect.name, c, a._consumerKey), s(c);
          });
        });
      }
      /**
       * @description Validate the code passed back to the application by Trimble Identity
       * @param {string} code from the URL
       * @returns {PromiseLike<boolean>} A promise that resolves to true if the code is valid
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      ValidateCode(o) {
        return this._analyticshttpclient.sendMethodEvent(this.ValidateCode.name, this._consumerKey), this._validateCode(o);
      }
      _validateCode(o) {
        var a = this;
        return new Promise(function(u, s) {
          a._endpointProvider.RetrieveTokenEndpoint().then((c) => {
            var l = {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            };
            if (a._consumerSecret) {
              var f = "Basic " + r.stob64(a._consumerKey + ":" + a._consumerSecret);
              l.headers.Authorization = f;
            }
            var d = "grant_type=authorization_code&tenantDomain=trimble.com&client_id=" + encodeURIComponent(a._consumerKey) + "&code=" + encodeURIComponent(o) + "&redirect_uri=" + encodeURIComponent(a._redirectUrl), p = null;
            a._codeVerifier && (d = d + "&code_verifier=" + encodeURIComponent(a._codeVerifier), p = r.RefreshableTokenProvider.GenerateCodeVerifier(), d = d + "&code_challenge_method=S256", d = d + "&code_challenge=" + encodeURIComponent(a._GenerateCodeChallenge(p))), new r.HttpClient().httpPost(c, d, l).then((v) => {
              var h = JSON.parse(v), E = /* @__PURE__ */ new Date();
              a.WithAccessToken(h.access_token, new Date(E.getTime() + h.expires_in * 1e3)).WithIdToken(h.id_token).WithRefreshToken(h.refresh_token), p && a.WithProofKeyForCodeExchange(p), u();
            }).catch((v) => {
              a._analyticshttpclient.sendExceptionEvent(a.ValidateCode.name, v, a._consumerKey), s("Unable to validate code: " + v);
            });
          }).catch((c) => {
            a._analyticshttpclient.sendExceptionEvent(a.ValidateCode.name, c, a._consumerKey), s("Unable to validate code: " + c);
          });
        });
      }
    }
    return n;
  });
})(X2e);
var Dwr = X2e.exports, Z2e = { exports: {} };
(function(e, t) {
  (function(r, n) {
    {
      var i = w2();
      e.exports = n({
        AnalyticsHttpClient: mu,
        KJUR: i.KJUR,
        b64utoutf8: i.b64utoutf8,
        KEYUTIL: i.KEYUTIL
      });
    }
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for ValidatedClaimsetProvider class
       * @param {IKeysetProvider} keysetProvider A provider for the keyset used to validate the JWT claimset.
       * It can be OpenIdKeysetProvider/FixedKeysetProvider
       */
      constructor(o) {
        this._keysetProvider = o, this._keyset = null, this._clockSkewInSeconds = 5 * 60, this._tokenValidationRequired = !0, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
      * @description Fluent extension for setting clock skew/grace period while validating the token.
      * @param {number} clockSkewInSeconds is the acceptable time difference between signer and verifier in seconds.
      */
      WithClockSkew(o) {
        return this._clockSkewInSeconds = o, this;
      }
      /**
       * @description Fluent extension for allowing token validation.
       * @param {boolean} token is validated before retrieving claims if tokenValidationRequired is set to true.
       */
      WithTokenValidation(o) {
        return this._tokenValidationRequired = o, this;
      }
      /**
       * @description Retrieves a validated claimset from a given JSON web token
       * @returns {PromiseLike<any>} A Task that resolves to the claimset completion
       * @exception Thrown when the keyset provider does not provide the named key
       * @exception Thrown when the JSON web token is invalid
       */
      RetrieveClaimset(o) {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveClaimset.name);
        var a = this;
        return new Promise((u, s) => {
          var c = o.split("."), l = r.KJUR.jws.JWS.readSafeJSONString(r.b64utoutf8(c[0]));
          a._findMatchingKey(l.kid).then((f) => {
            a._tokenValidationRequired && (a._clockSkewInSeconds < 0 ? s("ClockSkew is less than 0") : a._validateToken(o, f, a._clockSkewInSeconds) || s("Unable to validate token"));
            var d = r.KJUR.jws.JWS.readSafeJSONString(r.b64utoutf8(c[1]));
            u(d);
          }).catch((f) => {
            a._analyticshttpclient.sendExceptionEvent(a.RetrieveClaimset.name, f), s("No key matching token KID in keyset: " + f);
          });
        });
      }
      _retrieveKeyset() {
        var o = this;
        return new Promise((a, u) => {
          o._keyset != null ? a(o._keyset) : o._keysetProvider.RetrieveKeyset().then((s) => {
            o._keyset = s, a(o._keyset);
          }).catch((s) => {
            u("Unable to retrieve JSON web key set: " + s);
          });
        });
      }
      _findMatchingKey(o) {
        var a = this;
        return new Promise((u, s) => {
          a._retrieveKeyset().then((c) => {
            var l = c.find((f) => f.kid == o);
            l !== void 0 ? u(l) : (a._keyset = null, a._retrieveKeyset().then((f) => {
              l = f.find((d) => d.kid == o), l !== void 0 ? u(l) : s("No key matching token KID in keyset");
            }).catch((f) => {
              s("Unable to retrieve JSON web key set: " + f);
            }));
          }).catch((c) => {
            s("Unable to retrieve JSON web key set: " + c);
          });
        });
      }
      _validateToken(o, a, u) {
        var s = r.KEYUTIL.getKey(a);
        return r.KJUR.jws.JWS.verifyJWT(o, s, { alg: ["RS256"], gracePeriod: u });
      }
    }
    return n;
  });
})(Z2e);
var xwr = Z2e.exports, Q2e = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      HttpClient: Tl(),
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for OpenIdKeySetProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity JSON web keyset endpoint.
       * It can be be OpenIdEndpointProvider/FixedEndpointProvider
       */
      constructor(o) {
        this._endpointProvider = o, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
       * @description Retrieves an dictionary of named keys
       * @returns {PromiseLike<any>} A Task that resolves to a dictionary of named keys on completion
       * @exception Thrown when a JSON web keyset endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the JSON web keyset endpoint fails
       */
      RetrieveKeyset() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveKeyset.name);
        var o = this;
        return new Promise((a, u) => {
          o._endpointProvider.RetrieveJSONWebKeySetEndpoint().then((s) => {
            new r.HttpClient().httpGetJSON(s).then((c) => {
              a(c.keys);
            }).catch((c) => {
              o._analyticshttpclient.sendExceptionEvent(o.RetrieveKeyset.name, c), u("Failed to retrieve JSON web key set: " + c);
            });
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveKeyset.name, s), u("Failed to retrieve JSON web key set endpoint: " + s);
          });
        });
      }
    }
    return n;
  });
})(Q2e);
var Nwr = Q2e.exports, eIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      HttpClient: Tl(),
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    var n = function(i, o) {
      this._tokenProvider = i, this._baseAddress = o, this._consumerKey = this.RetrieveConsumerKey(), this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name, this._consumerKey);
    };
    return n.prototype.RetrieveClient = function() {
      this._analyticshttpclient.sendMethodEvent("RetrieveClient", this._consumerKey);
      var i = this;
      return new Promise(function(o, a) {
        i._tokenProvider.RetrieveToken().then((u) => {
          var s = {
            headers: {
              Authorization: "Bearer " + u
            }
          };
          o(new r.HttpClient(i._baseAddress, s));
        }).catch(a);
      });
    }, n.prototype.RetrieveConsumerKey = function() {
      return this._tokenProvider != null ? this._tokenProvider._consumerKey : null;
    }, n;
  });
})(eIe);
var Lwr = eIe.exports, tIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      RefreshableTokenProvider: NU,
      HttpClient: Tl(),
      AnalyticsHttpClient: mu,
      btoa: r.btoa || xU()
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for OnBehalfGrantTokenProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity token endpoints.
       * It can be be OpenIdEndpointProvider/FixedEndpointProvider
       * @param {string} consumerKey The consumer key for the calling application
       * @param {string} consumerSecret The consumer secret for the calling application
       * @param {string} accessToken The access token that this application wishes to act on behalf of when calling another API
       */
      constructor(o, a, u, s) {
        this._endpointProvider = o, this._consumerKey = a, this._consumerSecret = u, this._accessToken = s, this._scopes = [], this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name, a);
      }
      /**
       * @description Fluent extension to add scopes
       * @param {IEnumerable<string>} scopes The scopes to add to the token provider
       */
      WithScopes(o) {
        return this._scopes = this._scopes.concat(o), this;
      }
      /**
       * @description Retrieves an access token for the application
       * @returns {PromiseLike<string>} A Task that resolves to the value of the access token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveToken() {
        return this._analyticshttpclient.sendMethodEvent(this.RetrieveToken.name, this._consumerKey), this._refreshableTokenProvider ? this._refreshableTokenProvider.RetrieveToken() : this._retrieveToken();
      }
      _retrieveToken() {
        var o = this;
        return new Promise(function(a, u) {
          o._endpointProvider.RetrieveTokenEndpoint().then((s) => {
            var c = "Basic " + r.btoa(o._consumerKey + ":" + o._consumerSecret), l = {
              headers: {
                Authorization: c,
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
              }
            }, f = "grant_type=urn:ietf:params:oauth:grant-type:token-exchange&subject_token_type=urn:ietf:params:oauth:token-type:jwt&subject_token=" + encodeURIComponent(o._accessToken) + "&scope=" + encodeURIComponent(o._scopes.join(" "));
            new r.HttpClient().httpPost(s, f, l).then(function(d) {
              var p = JSON.parse(d), v = /* @__PURE__ */ new Date();
              o._refreshableTokenProvider = new r.RefreshableTokenProvider(o._endpointProvider, o._consumerKey, o._consumerSecret, p.access_token, new Date(v.getTime() + p.expires_in * 1e3), null, p.refresh_token), a(p.access_token);
            }).catch((d) => {
              o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, d, o._consumerKey), u("On-behalf grant failed: " + d);
            });
          }).catch((s) => {
            o._analyticshttpclient.sendExceptionEvent(o.RetrieveToken.name, s, o._consumerKey), u("On-behalf grant failed: " + s);
          });
        });
      }
    }
    return n;
  });
})(tIe);
var Bwr = tIe.exports, rIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for FixedEndpointProvider class
       * @param {string=} authorizationEndpoint The URL for the Trimble Identity authorization endpoint
       * @param {string=} tokenEndpoint The URL for the Trimble Identity token endpoint
       * @param {string=} userInfoEndpoint The URL for the Trimble Identity user information endpoint
       * @param {string=} tokenRevocationEndpoint The URL for the Trimble Identity token revocation endpoint, if not supplied this is computed relative to the token endpoint
       * @param {string=} jwksEndpoint The URL for the Trimble Identity JSON web keyset endpoint
       * @remarks All parameters for this constructor are considered obsolete
       * @remarks Use fluent extensions when constructing a new instance in the future
       */
      constructor(o = null, a = null, u = null, s = null, c = null) {
        this._authorizationEndpoint = o, this._tokenEndpoint = a, this._userInfoEndpoint = u, this._tokenRevocationEndpoint = s || a ? new URL(a).origin + "/revoke" : null, this._endSessionEndpoint = null, this._jwksEndpoint = c, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
       * @description Add an authorization endpoint
       * @param {string} authorizationEndpoint The URL for the Trimble Identity authorization endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithAuthorizationEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._authorizationEndpoint = o, a;
      }
      /**
       * @description Add a token endpoint
       * @param {string} tokenEndpoint The URL for the Trimble Identity token endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithTokenEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._tokenEndpoint = o, a;
      }
      /**
       * @description Add a user info endpoint
       * @param {string} userInfoEndpoint The URL for the Trimble Identity user information endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithUserInfoEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._userInfoEndpoint = o, a;
      }
      /**
       * @description Add a token revocation endpoint
       * @param {string} tokenRevocationEndpoint The URL for the Trimble Identity token revocation endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithTokenRevocationEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._tokenRevocationEndpoint = o, a;
      }
      /**
       * @description Add an end session endpoint
       * @param {string} endSessionEndpoint The URL for the Trimble Identity end session endpoint, if not supplied this is computed relative to the token endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithEndSessionEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._endSessionEndpoint = o, a;
      }
      /**
       * @description Add a JWKS endpoint
       * @param {string} jwksEndpoint The URL for the Trimble Identity JSON web keyset endpoint
       * @returns {IEndpointProvider} A new instance of a FixedEndpointProvider
       */
      WithJWKSEndpoint(o) {
        var a = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
        return a._jwksEndpoint = o, a;
      }
      /**
       * @description Retrieves a URL for the Trimble Identity authorization endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveAuthorizationEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveAuthorizationEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._authorizationEndpoint);
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity token endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveTokenEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveTokenEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._tokenEndpoint);
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity user information endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveUserInfoEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveUserInfoEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._userInfoEndpoint);
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity token revocation endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveTokenRevocationEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveTokenRevocationEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._tokenRevocationEndpoint);
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity end session endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveEndSessionEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveEndSessionEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._endSessionEndpoint);
        });
      }
      /**
       * @description Retrieves a URL for the Trimble Identity JSON web keyset endpoint
       * @returns {PromiseLike<string>} A Task that resolves to the value of the URL on completion
       */
      RetrieveJSONWebKeySetEndpoint() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveJSONWebKeySetEndpoint.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._jwksEndpoint);
        });
      }
    }
    return n;
  });
})(rIe);
var kwr = rIe.exports, nIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for FixedKeySetProvider class
       * @param {any} keyset A dictionary of named keys
       */
      constructor(o) {
        this._keyset = o, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
       * @description Retrieves an dictionary of named keys
       * @returns {PromiseLike<any>} A Task that resolves to a dictionary of named keys on completion
       */
      RetrieveKeyset() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveKeyset.name);
        var o = this;
        return new Promise((a, u) => {
          a(o._keyset);
        });
      }
    }
    return n;
  });
})(nIe);
var Mwr = nIe.exports, iIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n({
      AnalyticsHttpClient: mu
    });
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for FixedTokenProvider class
       * @param {string} token The fixed token to return
       */
      constructor(o) {
        this._accessToken = o, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name);
      }
      /**
       * @description Retrieves an access token for the user or application
       * @returns {PromiseLike<string>} A Task that resolves to the value of the access token on completion
       */
      RetrieveToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveToken.name);
        var o = this;
        return new Promise(function(a, u) {
          a(o._accessToken);
        });
      }
    }
    return n;
  });
})(iIe);
var Fwr = iIe.exports, oIe = { exports: {} };
(function(e, t) {
  (function(r, n) {
    {
      var i = w2();
      e.exports = n({
        HttpClient: Tl(),
        AnalyticsHttpClient: mu,
        KJUR: i.KJUR,
        hextob64: i.hextob64
      });
    }
  })(fe, function(r) {
    class n {
      /**
       * @description Public constructor for ImplicitGrantTokenProvider class
       * @param {IEndpointProvider} endpointProvider An endpoint provider that provides the URL for the Trimble Identity authorization and token endpoints.
       * It can be be OpenIdEndpointProvider/FixedEndpointProvider
       * @param {string} consumerKey The consumer key for the calling application
       * @param {string} redirectUrl The URL to which Trimble Identity should redirect after successfully authenticating a user
       */
      constructor(a, u, s) {
        this._endpointProvider = a, this._consumerKey = u, this._redirectUrl = s, this._logoutRedirectUrl = null, this._scopes = ["openid"], this._accessToken = null, this._tokenExpiry = /* @__PURE__ */ new Date(0), this.state = null, this._requireIdToken = !1, this._requireIdTokenValidation = !1, this._idToken = null, this._persistantStorage = null, this._claimsetProvider = null, this._silentAuthenticationSupported = !1, this._silentAuthenticationCallback = null, this._analyticshttpclient = new r.AnalyticsHttpClient(), this._analyticshttpclient.sendInitEvent(this.constructor.name, u);
      }
      /**
       * @description Fluent extension to add scopes
       * @param {IEnumerable<string>} scopes The scopes to add to the token provider
       */
      WithScopes(a) {
        return this._scopes = this._scopes.concat(a), this;
      }
      /**
       * @description Add ID token validation to an ImplicitGrantTokenProvider
       * @param {IPersistantStorage} persistantStorage A store that persists the nonce value during the OAuth redirect workflow
       * @param {IClaimsetProvider} claimsetProvider A claimset provider that returns the JSON web keyset for validating the JWT ID token
       */
      WithIDTokenValidation(a, u) {
        return this._requireIdToken = !0, this._requireIdTokenValidation = !0, this._persistantStorage = a, this._claimsetProvider = u, this;
      }
      /**
       * @description Add silent authentication to an ImplicitGrantTokenProvider
       * @param {string} state The state parameter to pass with silent authentication
       * @param {string} callback The callback URL for silent authentication
       */
      WithSilentAuthentication(a, u) {
        return this._silentAuthenticationSupported = !0, this._silentAuthenticationState = a, this._silentAuthenticationCallback = u, this._activePromise = null, this;
      }
      /**
       * @description Fluent extension to add logout redirect URL
       * @param {string} logoutRedirectUrl 
       */
      WithLogoutRedirect(a) {
        return this._requireIdToken = !0, this._logoutRedirectUrl = a, this;
      }
      /**
       * @description Get a redirect URL for Trimble Identity
       * @param {string} state An optional state parameter that will be passed back to the caller via the redirect URL
       * @returns {PromiseLike<string>} An awaitable Task that resolves to the redirect URL
       * @exception Thrown when an authorization endpoint is not provided by the endpoint provider
       */
      GetOAuthRedirect(a = null) {
        this._analyticshttpclient.sendMethodEvent(this.GetOAuthRedirect.name, this._consumerKey);
        var u = this;
        return new Promise((s, c) => {
          u._endpointProvider.RetrieveAuthorizationEndpoint().then((l) => {
            var f = u._requireIdToken ? "id_token%20token" : "token", d = l + "?response_type=" + f + "&scope=" + encodeURIComponent(u._scopes.join(" ")) + "&client_id=" + encodeURIComponent(u._consumerKey) + "&redirect_uri=" + encodeURIComponent(u._redirectUrl);
            if (u._requireIdToken) {
              var p = i(16);
              d += "&nonce=" + encodeURIComponent(p), u._requireIdTokenValidation && u._persistantStorage.SetItem("nonce", p);
            }
            a && (d = d + "&state=" + encodeURIComponent(a)), s(d);
          }).catch((l) => {
            u._analyticshttpclient.sendExceptionEvent(u.GetOAuthRedirect.name, l, u._consumerKey), c("Unable to retrieve token endpoint: " + l);
          });
        });
      }
      /**
       * @description Validate the hash parameters passed back to the application by Trimble Identity
       * @param {string} hash The hash string from the URL
       * @returns {PromiseLike<string>} An awaitable Task
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      DecodeHash(a) {
        this._analyticshttpclient.sendMethodEvent(this.DecodeHash.name, this._consumerKey);
        var u = this;
        return new Promise((s, c) => {
          a.startsWith("#") && (a = a.substr(1)), a.startsWith("?") && (a = a.substr(1));
          var l = {};
          a.split("&").forEach((f) => {
            var d = f.split("=");
            l[d[0]] = decodeURIComponent(d[1]);
          }), u._validateIdToken(l.access_token, l.id_token).then(() => {
            u._accessToken = l.access_token, u._idToken = l.id_token;
            var f = /* @__PURE__ */ new Date();
            u._tokenExpiry = new Date(f.getTime() + l.expires_in * 1e3), u.state = l.state, s();
          }).catch((f) => {
            u._analyticshttpclient.sendExceptionEvent(u.DecodeHash.name, f, u._consumerKey), c(f);
          });
        });
      }
      /**
       * @description Retrieves an access token for the authenticated user
       * @returns {PromiseLike<string>} A Task that resolves to the value of the access token on completion
       * @exception Thrown when a token endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token endpoint fails
       */
      RetrieveToken() {
        this._analyticshttpclient.sendMethodEvent(this.RetrieveToken.name, this._consumerKey);
        var a = this;
        return new Promise((u, s) => {
          a._tokenExpiry < /* @__PURE__ */ new Date() ? a._silentAuthenticationSupported ? a._activePromise ? a._activePromise.then((c) => {
            u(c);
          }).catch((c) => {
            s(c);
          }) : (a._activePromise = a._singleThreadedPromise(), a._activePromise.then((c) => {
            u(c);
          }).catch((c) => {
            s(c);
          }).finally(() => {
            a._activePromise = null;
          })) : (a._analyticshttpclient.sendExceptionEvent(a.RetrieveToken.name, "Token has expired", a._consumerKey), s("Token has expired")) : u(a._accessToken);
        });
      }
      /**
       * @description Revoke the token for the authenticated user and return a redirect URL to log them out of all Trimble Identity applications
       * @returns {PromiseLike<string>} A Task that resolves to the value of the redirect URL on completion
       * @exception Thrown when a token revocation endpoint is not provided by the endpoint provider
       * @exception Thrown when a call to the token revocation endpoint fails
       * @remarks Obsolete! Access tokens cannot be revoked in Trimble Identity v4
       */
      RevokeToken() {
        this._analyticshttpclient.sendMethodEvent(this.RevokeToken.name, this._consumerKey);
        var a = this;
        return new Promise((u, s) => {
          a._endpointProvider.RetrieveTokenRevocationEndpoint().then((c) => {
            var l = "token=" + encodeURIComponent(a._accessToken) + "&token_type_hint=access_token&client_id=" + encodeURIComponent(a._consumerKey);
            new r.HttpClient().httpPost(c, l, { headers: { "content-type": "application/x-www-form-urlencoded" } }).then(() => {
              var f = a._redirectUrl;
              a._logoutRedirectUrl && (f = a._logoutRedirectUrl);
              var d = new URL(c).origin;
              u(d + "/i/commonauth?commonAuthLogout=true&type=samlsso&relyingParty=" + encodeURIComponent(a._consumerKey) + "&commonAuthCallerPath=" + encodeURIComponent(f));
            });
          });
        });
      }
      /**
       * @description Return a redirect URL to log out of all Trimble Identity applications
       * @param {string} state An optional state parameter that will be passed back to the caller via the redirect URL
       * @returns {PromiseLike<string>} A promise that resolves to the value of the redirect URL on completion
       */
      GetOAuthLogoutRedirect(a = null) {
        this._analyticshttpclient.sendMethodEvent(this.GetOAuthLogoutRedirect.name, this._consumerKey);
        var u = this;
        return new Promise((s, c) => {
          u._endpointProvider.RetrieveEndSessionEndpoint().then((l) => {
            if (l.endsWith("/commonauth"))
              s(
                l + "?commonAuthLogout=true&type=samlsso&relyingParty=" + encodeURIComponent(u._consumerKey) + "&commonAuthCallerPath=" + encodeURIComponent(u._logoutRedirectUrl)
              );
            else if (u._idToken) {
              var f = l + "?id_token_hint=" + encodeURIComponent(u._idToken) + "&post_logout_redirect_uri=" + encodeURIComponent(u._logoutRedirectUrl);
              a && (f = f + "&state=" + encodeURIComponent(a)), s(f);
            } else
              u._analyticshttpclient.sendExceptionEvent(u.GetOAuthLogoutRedirect.name, "An id_token is required to log out of all applications", u._consumerKey), c("An id_token is required to log out of all applications");
          }).catch((l) => {
            u._analyticshttpclient.sendExceptionEvent(u.GetOAuthLogoutRedirect.name, "An id_token is required to log out of all applications", u._consumerKey), c(l);
          });
        });
      }
      _validateIdToken(a, u) {
        var s = this;
        return new Promise((c, l) => {
          s._requireIdTokenValidation ? (u || l("Missing ID token"), s._claimsetProvider.RetrieveClaimset(u).then((f) => {
            if (f.nonce != s._persistantStorage.GetItem("nonce")) {
              s._persistantStorage.RemoveItem("nonce"), l("Stored value does not match nonce claim");
              return;
            }
            if (f.at_hash) {
              var d = r.KJUR.crypto.Util.hashString(a, "sha256"), p = r.hextob64(d.substring(0, 32)).replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "");
              if (f.at_hash != p) {
                s._persistantStorage.RemoveItem("nonce"), l("Calculated hash does not match at_hash claim");
                return;
              }
            }
            s._persistantStorage.RemoveItem("nonce"), c();
          }).catch(() => {
            s._persistantStorage.RemoveItem("nonce"), l("Unable to validate ID token");
          })) : c();
        });
      }
      _singleThreadedPromise() {
        var a = this;
        return new Promise((u, s) => {
          a.GetOAuthRedirect(a._silentAuthenticationState, !0).then((c) => {
            a._silentAuthenticationCallback(c + "&prompt=none").then((l) => {
              l.error ? s(l.error) : a._validateIdToken(l.access_token, l.id_token).then(() => {
                a._accessToken = l.access_token;
                var f = /* @__PURE__ */ new Date();
                a._tokenExpiry = new Date(f.getTime() + l.expires_in * 1e3), a.state = l.state, u(a._accessToken);
              }).catch((f) => {
                s(f);
              });
            }).catch((l) => {
              s("Error from silent authentication callback: " + l);
            });
          }).catch((c) => {
            s("Failed to generate redirect URL: " + c);
          });
        });
      }
    }
    function i(o) {
      for (var a = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~", u = ""; o > 0; ) {
        var s = new Uint8Array(16), c = window.crypto.getRandomValues(s);
        c.forEach(function(l) {
          o != 0 && l < a.length && (u += a[l], o--);
        });
      }
      return u;
    }
    return n;
  });
})(oIe);
var Hwr = oIe.exports, Kg = {
  ClientCredentialTokenProvider: wwr,
  OpenIdEndpointProvider: Pwr,
  AuthorizationCodeGrantTokenProvider: Dwr,
  RefreshableTokenProvider: NU,
  ValidatedClaimsetProvider: xwr,
  OpenIdKeysetProvider: Nwr,
  BearerTokenHttpClientProvider: Lwr,
  OnBehalfGrantTokenProvider: Bwr,
  FixedEndpointProvider: kwr,
  FixedKeysetProvider: Mwr,
  FixedTokenProvider: Fwr,
  ImplicitGrantTokenProvider: Hwr,
  AnalyticsHttpClient: mu
};
function rp(e, t) {
  if (!t)
    return "";
  let r = "; " + e;
  return t === !0 ? r : r + "=" + t;
}
function $wr(e) {
  if (typeof e.expires == "number") {
    const t = Math.min(Date.now() + e.expires * 864e5, 864e13);
    e.expires = new Date(t);
  }
  return rp("Expires", e.expires ? e.expires.toUTCString() : "") + rp("Domain", e.domain) + rp("Path", e.path) + rp("Secure", e.secure) + rp("Partitioned", e.partitioned) + rp("SameSite", e.sameSite);
}
function Uwr(e, t, r) {
  return encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent) + $wr(r);
}
function Vwr(e) {
  let t = {};
  const r = e ? e.split("; ") : [];
  for (let n of r) {
    const i = n.split("=");
    let o = i.slice(1).join("=");
    o[0] === '"' && (o = o.slice(1, -1));
    try {
      const a = decodeURIComponent(i[0]);
      t[a] = o.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    } catch {
    }
  }
  return t;
}
function jwr() {
  return Vwr(document.cookie);
}
function zwr(e) {
  return jwr()[e];
}
function aIe(e, t, r) {
  document.cookie = Uwr(e, t, { path: "/", ...r });
}
function qwr(e, t) {
  aIe(e, "", { ...t, expires: -1 });
}
var Ywr = Object.defineProperty, Gwr = (e, t, r) => t in e ? Ywr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ki = (e, t, r) => (Gwr(e, typeof t != "symbol" ? t + "" : t, r), r);
class Wwr {
  constructor() {
    Ki(this, "generateCache", /* @__PURE__ */ function() {
      const t = {
        token: void 0,
        user: void 0
      };
      return {
        /**
         * Get token store in cache
         * @return {Promise<TIDAuthToken | undefined>} Token store in memory
         */
        async getToken() {
          return t.token;
        },
        /**
         * Get user store in cache
         * @return {Promise<TIDUser | undefined>} User store in memory
         */
        async getUser() {
          return t.user;
        },
        /**
         * Store token in cache
         * @param {TIDAuthToken} token - Token that you want to store in cache
         * @return {Promise<void>} Empty promise
         */
        async storeToken(r) {
          t.token = r;
        },
        /**
         * Store user in cache
         * @param {TIDUser} user - User that you want to store in cache
         * @return {Promise<void>} Empty promise
         */
        async storeUser(r) {
          t.user = r;
        },
        /**
         * The clear the cache from the storage
         * @return {Promise<void>} Empty promise
         */
        clear() {
          return t.token = void 0, t.user = void 0, Promise.resolve(void 0);
        }
      };
    }());
  }
}
class Kwr {
  /**
   * Initialized configuration to store information into local storage
   * @param {LocalStorageCacheOptions} options - Configuration for caching in localstorage
   */
  constructor(t) {
    Ki(this, "localStorage"), Ki(this, "cacheKey"), this.localStorage = window.localStorage, this.cacheKey = t.cacheKey;
  }
  /**
   * Get token store in localstorage
   * @return {Promise<TIDAuthToken | undefined>} - Token store in localstorage
   */
  async getToken() {
    const t = this.getAuthKey(), r = localStorage.getItem(t);
    return r ? JSON.parse(r) : void 0;
  }
  /**
   * Get user store in localstorage
   * @return {Promise<TIDUser | undefined>}  - User store in localstorage
   */
  async getUser() {
    const t = this.getUserKey(), r = localStorage.getItem(t);
    return r ? JSON.parse(r) : void 0;
  }
  /**
   * Store token in localstorage
   * @param {TIDAuthToken} token - Token that you want to store in localstorage
   * @return {Promise<void>} Empty promise
   */
  async storeToken(t) {
    const r = this.getAuthKey(), n = JSON.stringify(t);
    localStorage.setItem(r, n);
  }
  /**
   * Store user in cache
   * @param {TIDUser} user - User that you want to store in localstorage
   * @return {Promise<void>} Empty promise
   */
  async storeUser(t) {
    const r = this.getUserKey(), n = JSON.stringify(t);
    localStorage.setItem(r, n);
  }
  /**
   * Get the full key from the cachekey for the user
   * @return {string} - Full key to get the token from the localstorage
   */
  getUserKey() {
    return this.cacheKey.getUserKey();
  }
  /**
   * Get the full key from the cachekey for the token
   * @return {string} - Full key to get the token from the localstorage
   */
  getAuthKey() {
    return this.cacheKey.getAuthKey();
  }
  /**
   * The clear the cache from the localstorage
   * @return {Promise<void>} Empty promise
   */
  clear() {
    return this.localStorage.removeItem(this.getAuthKey()), this.localStorage.removeItem(this.getUserKey()), Promise.resolve(void 0);
  }
}
const LU = "@TID", Xwr = `${LU}_AUTH_KEY`, Jwr = `${LU}_USER_KEY`;
class Zwr {
  /**
   * Initialized the cache key
   * @param {CacheKeyOptions} cacheKeyOptions - Cache key options to edit the default values
   */
  constructor(t) {
    Ki(this, "clientId"), Ki(this, "prefix", LU), Ki(this, "authSuffix", Xwr), Ki(this, "userSuffix", Jwr), this.clientId = t.client_id;
  }
  /**
   * Get key to store/retrieve user
   * @return {string} Key for the user
   */
  getUserKey() {
    return `${this.prefix}_${this.userSuffix}_${this.clientId}`;
  }
  /**
   * Get key to store/retrieve token
   * @return {string} Key for the token
   */
  getAuthKey() {
    return `${this.prefix}_${this.authSuffix}_${this.clientId}`;
  }
}
class Qwr {
  /**
   * Initialized configuration to store information into session storage
   * @param {SessionStorageCacheOptions} options - Configuration for caching in session storage
   */
  constructor(t) {
    Ki(this, "sessionStorage"), Ki(this, "cacheKey"), this.sessionStorage = window.sessionStorage, this.cacheKey = t.cacheKey;
  }
  /**
   * Get token store in session storage
   * @return {Promise<TIDAuthToken | undefined>} - Token store in session storage
   */
  async getToken() {
    const t = this.getAuthKey(), r = sessionStorage.getItem(t);
    return r ? JSON.parse(r) : void 0;
  }
  /**
   * Get user store in session storage
   * @return {Promise<TIDUser | undefined>}  - User store in session storage
   */
  async getUser() {
    const t = this.getUserKey(), r = sessionStorage.getItem(t);
    return r ? JSON.parse(r) : void 0;
  }
  /**
   * Store token in session storage
   * @param {TIDAuthToken} authToken - Token that you want to store in session storage
   * @return {Promise<void>} Empty promise
   */
  async storeToken(t) {
    const r = this.getAuthKey(), n = JSON.stringify(t);
    sessionStorage.setItem(r, n);
  }
  /**
   * Store user in cache
   * @param {TIDUser} user - User that you want to store in session storage
   * @return {Promise<void>} Empty promise
   */
  async storeUser(t) {
    const r = this.getUserKey(), n = JSON.stringify(t);
    sessionStorage.setItem(r, n);
  }
  /**
   * Get the full key from the cachekey for the user
   * @return {string} - Full key to get the token from the session storage
   */
  getUserKey() {
    return this.cacheKey.getUserKey();
  }
  /**
   * Get the full key from the cachekey for the token
   * @return {string} - Full key to get the token from the session storage
   */
  getAuthKey() {
    return this.cacheKey.getAuthKey();
  }
  /**
   * The clear the cache from the session storage
   * @return {Promise<void>} Empty promise
   */
  clear() {
    return this.sessionStorage.removeItem(this.getAuthKey()), this.sessionStorage.removeItem(this.getUserKey()), Promise.resolve(void 0);
  }
}
class ePr {
  /**
   * Create a cache manager to extract or save the user, and token
   * @param {CacheManagerOptions} options - Configuration for the managing the caching
   */
  constructor(t) {
    Ki(this, "persistentStore"), Ki(this, "cacheStorage"), Ki(this, "cacheKey"), this.persistentStore = t.persistentStore, this.cacheKey = new Zwr({
      client_id: t.clientId
    }), this.persistentStore === "localStorage" ? this.cacheStorage = new Kwr({
      cacheKey: this.cacheKey
    }) : this.persistentStore === "sessionStorage" ? this.cacheStorage = new Qwr({
      cacheKey: this.cacheKey
    }) : this.cacheStorage = new Wwr().generateCache;
  }
  /**
   * Store token in cache
   * @param {TIDAuthToken} token - Token that you want to store in cache
   * @return {Promise<void>} Empty promise
   */
  async setToken(t) {
    await this.cacheStorage.storeToken(t);
  }
  /**
   * Store user in cache
   * @param {TIDUser} user - User that you want to store in cache
   * @return {Promise<void>} Empty promise
   */
  async setUser(t) {
    await this.cacheStorage.storeUser(t);
  }
  /**
   * Get user store in cache
   * @return {Promise<TIDUser | undefined>} Key for the user
   */
  async getUser() {
    return this.cacheStorage.getUser();
  }
  /**
   * Get token store in cache
   * @return {Promise<TIDAuthToken | undefined>} Key for the user
   */
  async getToken() {
    return this.cacheStorage.getToken();
  }
  /**
   * The clear the cache from the storage
   * @return {Promise<void>} Empty promise
   */
  async clear() {
    await this.cacheStorage.clear();
  }
}
const tPr = 5 * 6e4, rPr = ["code", "state"], Mse = (e) => e.split("?")[0], nPr = (e) => e.split("?")[1], uIe = (e) => {
  let t = e;
  if (!e.startsWith("?"))
    try {
      t = new URL(e).search;
    } catch {
    }
  return new URLSearchParams(t);
}, iPr = (e = window.location.href, t) => {
  if (t != null) {
    const n = Mse(t), i = Mse(e ?? "");
    if (n !== i)
      return !1;
  }
  const r = uIe(e);
  for (const n of rPr)
    if (!r.has(n))
      return !1;
  return !0;
}, oPr = (e) => ({
  name: `${e.given_name} ${e.family_name}`,
  given_name: e.given_name,
  family_name: e.family_name,
  picture: e.picture,
  email: e.email,
  email_verified: e.email_verified,
  phone_number_verified: !1
}), aPr = "@TID_COOKIE";
class uPr {
  /**
   * Retrieve a cookie from the browser
   * @param {string} key - Key to retrieve the cookies
   */
  get(t) {
    const r = zwr(t);
    if (r == null)
      throw new Error("Cookie not found");
    return JSON.parse(r);
  }
  /**
   * Store cookies in the browser
   * @param {string} key - Key to save and retrieve the cookies
   * @param {any} value - Information you want to store in cookies
   * @param {CookiesOptions} options - Additional options you want to add to the cookies.
   * @example Save cookies with one day of expiration
   * cookiesStorage.set('key',{data:{...}},{expires:1})
   * @example Save cookies with a custom domain
   * cookiesStorage.set('key',{data:{...}},{domain:'https://example.com/subpath'})
   */
  set(t, r, n) {
    let i = {};
    window.location.protocol === "https:" && (i = {
      secure: !0,
      sameSite: "none"
    }), n != null && n.expires && (i.expires = n.expires), n != null && n.domain && (i.domain = n.domain), aIe(t, JSON.stringify(r), i);
  }
  /**
   * Remove a cookie from the browser
   * @param {string} key - Key to remove the cookies from the browser
   * @param {CookiesOptions} options - Additional options used when the cookie was declared
   * @example Remove cookies without additional information
   * cookiesStorage.remove('key')
   * @example Remove cookies with custom domain
   * cookiesStorage.remove('key',{domain:'https://example.com/subpath'})
   */
  remove(t, r) {
    const n = {};
    r != null && r.domain && (n.domain = r.domain), qwr(t, n);
  }
}
class sPr {
  /**
   * Create a cookies manager to extract or save cookies in the browser
   * @param {CookiesManagerOptions} options - Configuration for the managing the cookies
   */
  constructor(t) {
    Ki(this, "cookieKey"), Ki(this, "cookiesStorage"), this.cookieKey = `${aPr}.${t.clientId}`, this.cookiesStorage = new uPr();
  }
  /**
   * Store cookies in the browser
   * @param {CookieValue} value - information to store
   */
  save(t) {
    this.cookiesStorage.set(this.cookieKey, t, {
      expires: 1
    });
  }
  /**
   * Retrieve cookies in the browser
   * @return {CookieValue | undefined}  - Cookies from the browser
   */
  get() {
    try {
      return this.cookiesStorage.get(this.cookieKey);
    } catch {
      return;
    }
  }
  /**
   * Clear information about the cookies stored in the browser
   */
  clear() {
    this.cookiesStorage.remove(this.cookieKey);
  }
}
class cPr extends Error {
}
class lPr extends Error {
}
class fPr extends Error {
}
const Z0 = "@trimble-oss/trimble-id-react", Q0 = "0.0.4", dPr = {
  configurationEndpoint: "",
  clientId: "",
  redirectUrl: "",
  logoutRedirectUrl: "",
  scopes: []
}, pPr = {
  persistentStore: "in-memory"
};
class hPr {
  /**
   * Create a TID client to handle manage all user authentication functions and information
   * @param {CacheManagerOptions} props - TID client configuration
   */
  constructor(t) {
    Ki(this, "tokenProvider"), Ki(this, "cacheManager"), Ki(this, "cookiesManager"), Ki(this, "clientId"), Ki(this, "redirectUrl"), Ki(this, "analyticshttpclient");
    const { config: r = dPr, persistentOptions: n = pPr } = t;
    if (this.redirectUrl = r.redirectUrl, r.configurationEndpoint == null || r.configurationEndpoint == "")
      throw new Error("Configuration endpoint not defined");
    if (r.clientId == null || r.clientId == "")
      throw new Error("Consumer key is not defined");
    this.cookiesManager = new sPr({
      clientId: r.clientId
    });
    const i = this.cookiesManager.get(), o = new Kg.OpenIdEndpointProvider(r.configurationEndpoint);
    let a = new Kg.AuthorizationCodeGrantTokenProvider(
      o,
      r.clientId,
      r.redirectUrl
    ).WithScopes(r.scopes);
    r.logoutRedirectUrl && (a = a.WithLogoutRedirect(r.logoutRedirectUrl)), (i == null ? void 0 : i.code_verifier) != null && (a = a.WithProofKeyForCodeExchange(i.code_verifier)), this.tokenProvider = a, this.cacheManager = new ePr({
      clientId: r.clientId,
      persistentStore: n.persistentStore
    }), this.clientId = r.clientId, this.analyticshttpclient = new Kg.AnalyticsHttpClient(), this.analyticshttpclient.sendInitEvent("TIDClient", this.clientId, Z0, Q0);
  }
  /**
   * Redirect the user to TID using the browser
   * @param {LoginWithRedirectOptions} options - Custom configuration for the redirection
   * @return {Promise<void>} Empty promise
   * @example No configuration
   * loginWithRedirect()
   * // Automatically redirects the user to TID with all necessary parameters
   * @example Custom redirect
   * loginWithRedirect({onRedirect: (url) => router.navigate(url)})
   * // Redirect calls onRedirect with the log-out url for TID
   * // So it can be handled by the developer
   */
  async loginWithRedirect(t) {
    this.analyticshttpclient.sendMethodEvent(this.loginWithRedirect.name, this.clientId, Z0, Q0);
    const { onRedirect: r } = t || {}, n = Kg.AuthorizationCodeGrantTokenProvider.GenerateCodeVerifier();
    this.cookiesManager.save({ code_verifier: n }), this.tokenProvider = this.tokenProvider.WithProofKeyForCodeExchange(n);
    const i = await this.tokenProvider.GetOAuthRedirect("state");
    r != null ? r(i) : window.location.assign(i);
  }
  /**
   * Authenticated the user using the url callback params
   * @param {string} url - Custom configuration for the redirection
   * @return {Promise<AuthState>} Object contain the state returned from TID
   * @throws {CodeVerifierNotFoundException} Will throw an exception if the session doesn't contain the code verifier
   * @example No configuration
   * handleCallback()
   * // Will automatically take the url from the browser and try to log in the user
   * @example Custom url
   * handleCallback('https://example.com?code=code....')
   * // Will try to log in the user with the url assign by the developer
   */
  async handleCallback(t = window.location.href) {
    const r = this.cookiesManager.get();
    if (r == null || (r == null ? void 0 : r.code_verifier) == null)
      throw new fPr("Code verifier not available");
    const n = nPr(t), i = uIe(t), o = i.get("identity_provider") ?? "", a = i.get("state") ?? "";
    return await this.tokenProvider.ValidateQuery(n), await this.generateToken(o), {
      authState: a
    };
  }
  /**
   * Function to generate and store the access token
   * @param {string} identityProvider - Type of identity provider used
   * @return {Promise<void>} Empty promise
   */
  async generateToken(t) {
    var r, n;
    const i = await this.tokenProvider.RetrieveToken(), o = await this.tokenProvider.RetrieveRefreshToken(), a = await this.tokenProvider.RetrieveIdToken(), u = await this.tokenProvider.RetrieveTokenExpiry(), s = new Date(u).getTime(), c = (n = (r = this.tokenProvider) == null ? void 0 : r._scopes) == null ? void 0 : n.join(" ");
    await this.cacheManager.setToken({
      scope: c,
      state: "",
      session_state: "",
      identity_provider: t,
      token_type: "bearer",
      access_token: i,
      refresh_token: o,
      id_token: a,
      expires_at: s
    });
    const l = a1e(a), f = oPr(l);
    await this.cacheManager.setUser(f), await this.reloadCodeVerifier();
  }
  async reloadCodeVerifier() {
    const t = await this.tokenProvider.RetrieveCodeVerifier();
    this.cookiesManager.save({ code_verifier: t }), this.tokenProvider = this.tokenProvider.WithProofKeyForCodeExchange(t);
  }
  /**
   * Return the user stored in cache
   * @return {Promise<TIDUser | undefined>} User in cache
   */
  async getUser() {
    return this.analyticshttpclient.sendMethodEvent(this.getUser.name, this.clientId, Z0, Q0), await this.cacheManager.getUser();
  }
  /**
   * Gets the access token from cache. If the token already expired,
   * will try to refresh it using the refresh token
   * @return {Promise<string>} Access token
   * @throws {TokenNotFoundException} Will throw an exception if the access token is not in cache
   * @throws {TokenExpiredException} Will throw an exception if the user token expired
   */
  async getAccessTokenSilently() {
    this.analyticshttpclient.sendMethodEvent(this.getAccessTokenSilently.name, this.clientId, Z0, Q0);
    let t = await this.cacheManager.getToken();
    if (t == null)
      throw this.analyticshttpclient.sendExceptionEvent(this.getAccessTokenSilently.name, "No token available", this.clientId, Z0, Q0), new lPr("No token available");
    const r = new Date((/* @__PURE__ */ new Date()).getTime() + tPr);
    if ((t == null ? void 0 : t.expires_at) == null || (t == null ? void 0 : t.expires_at) < r.getTime()) {
      try {
        await this.tokenProvider.RetrieveToken();
      } catch (n) {
        throw this.analyticshttpclient.sendExceptionEvent(this.getAccessTokenSilently.name, n.message, this.clientId, Z0, Q0), new cPr(n.message);
      }
      await this.generateToken((t == null ? void 0 : t.identity_provider) ?? ""), t = await this.cacheManager.getToken();
    }
    return (t == null ? void 0 : t.access_token) || "";
  }
  /**
   * Redirect the user to TID using the browser
   * @param {LogoutOptions} options - Custom configuration for teh redirection
   * @return {Promise<void>} Empty promise
   * @example No configuration
   * logout()
   * // Automatically redirects the user to TID to log out
   * @example Custom redirect
   * logout({onRedirect: (url) => router.navigate(url)})
   * // Redirect calls onRedirect with the log-out url for TID
   * // So it can be handled by the developer
   */
  async logout(t) {
    this.analyticshttpclient.sendMethodEvent(this.logout.name, this.clientId, Z0, Q0);
    const { onRedirect: r, disabledAutoRedirect: n } = t || {};
    this.cacheManager && await this.cacheManager.clear(), this.cookiesManager && this.cookiesManager.clear();
    const i = await this.tokenProvider.GetOAuthLogoutRedirect("state");
    if (r != null)
      return r(i);
    n || window.location.assign(i);
  }
  /**
   * Check if the user still has a valid session
   * @return {Promise<boolean>} True or false depending on if the user is session is valid or not
   */
  async checkSession() {
    try {
      await this.getAccessTokenSilently();
    } catch {
      return !1;
    }
    return !0;
  }
  /**
   * Check if the user has a session valid after a refresh
   * @return {Promise<void>} Empty promise
   */
  async loadUserSession() {
    await this.loadCacheSessionIntoSDK(), await this.checkSession() || await this.cacheManager.clear();
  }
  /**
   * Load the user session from cache into the SDK
   * @return {Promise<void>} Empty promise
   */
  async loadCacheSessionIntoSDK() {
    const t = await this.cacheManager.getToken();
    if (t == null)
      return;
    const r = t.access_token, n = t.refresh_token || "", i = t.id_token, o = t.expires_at;
    this.tokenProvider = this.tokenProvider.WithAccessToken(r, o).WithRefreshToken(n).WithIdToken(i);
  }
  /**
   * Get a http bearer token client to use it for another SDK (Ex: Processing framework)
   * @return {any} - BearerTokenHttpClientProvider
   */
  getBearerTokenHttpClient(t) {
    return new Kg.BearerTokenHttpClientProvider(this.tokenProvider, t);
  }
  /**
   * Get the redirect url to TID
   * @return {string} - Callback redirect url
   */
  getRedirectUrl() {
    return this.redirectUrl;
  }
}
const D8 = ei(null), vPr = () => En(D8) ?? {};
var x8 = { exports: {} }, Xg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fse;
function EPr() {
  if (Fse)
    return Xg;
  Fse = 1;
  var e = G, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(u, s, c) {
    var l, f = {}, d = null, p = null;
    c !== void 0 && (d = "" + c), s.key !== void 0 && (d = "" + s.key), s.ref !== void 0 && (p = s.ref);
    for (l in s)
      n.call(s, l) && !o.hasOwnProperty(l) && (f[l] = s[l]);
    if (u && u.defaultProps)
      for (l in s = u.defaultProps, s)
        f[l] === void 0 && (f[l] = s[l]);
    return { $$typeof: t, type: u, key: d, ref: p, props: f, _owner: i.current };
  }
  return Xg.Fragment = r, Xg.jsx = a, Xg.jsxs = a, Xg;
}
var m4 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hse;
function mPr() {
  return Hse || (Hse = 1, process.env.NODE_ENV !== "production" && function() {
    var e = G, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), u = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = Symbol.iterator, h = "@@iterator";
    function E(Ze) {
      if (Ze === null || typeof Ze != "object")
        return null;
      var kt = v && Ze[v] || Ze[h];
      return typeof kt == "function" ? kt : null;
    }
    var m = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(Ze) {
      {
        for (var kt = arguments.length, qt = new Array(kt > 1 ? kt - 1 : 0), sr = 1; sr < kt; sr++)
          qt[sr - 1] = arguments[sr];
        y("error", Ze, qt);
      }
    }
    function y(Ze, kt, qt) {
      {
        var sr = m.ReactDebugCurrentFrame, Mr = sr.getStackAddendum();
        Mr !== "" && (kt += "%s", qt = qt.concat([Mr]));
        var ht = qt.map(function(Pe) {
          return String(Pe);
        });
        ht.unshift("Warning: " + kt), Function.prototype.apply.call(console[Ze], console, ht);
      }
    }
    var _ = !1, S = !1, A = !1, O = !1, P = !1, U;
    U = Symbol.for("react.module.reference");
    function z(Ze) {
      return !!(typeof Ze == "string" || typeof Ze == "function" || Ze === n || Ze === o || P || Ze === i || Ze === c || Ze === l || O || Ze === p || _ || S || A || typeof Ze == "object" && Ze !== null && (Ze.$$typeof === d || Ze.$$typeof === f || Ze.$$typeof === a || Ze.$$typeof === u || Ze.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ze.$$typeof === U || Ze.getModuleId !== void 0));
    }
    function k(Ze, kt, qt) {
      var sr = Ze.displayName;
      if (sr)
        return sr;
      var Mr = kt.displayName || kt.name || "";
      return Mr !== "" ? qt + "(" + Mr + ")" : qt;
    }
    function H(Ze) {
      return Ze.displayName || "Context";
    }
    function B(Ze) {
      if (Ze == null)
        return null;
      if (typeof Ze.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ze == "function")
        return Ze.displayName || Ze.name || null;
      if (typeof Ze == "string")
        return Ze;
      switch (Ze) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof Ze == "object")
        switch (Ze.$$typeof) {
          case u:
            var kt = Ze;
            return H(kt) + ".Consumer";
          case a:
            var qt = Ze;
            return H(qt._context) + ".Provider";
          case s:
            return k(Ze, Ze.render, "ForwardRef");
          case f:
            var sr = Ze.displayName || null;
            return sr !== null ? sr : B(Ze.type) || "Memo";
          case d: {
            var Mr = Ze, ht = Mr._payload, Pe = Mr._init;
            try {
              return B(Pe(ht));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, D = 0, w, $, X, V, F, le, ae;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function ve() {
      {
        if (D === 0) {
          w = console.log, $ = console.info, X = console.warn, V = console.error, F = console.group, le = console.groupCollapsed, ae = console.groupEnd;
          var Ze = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ze,
            log: Ze,
            warn: Ze,
            error: Ze,
            group: Ze,
            groupCollapsed: Ze,
            groupEnd: Ze
          });
        }
        D++;
      }
    }
    function Ie() {
      {
        if (D--, D === 0) {
          var Ze = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, Ze, {
              value: w
            }),
            info: x({}, Ze, {
              value: $
            }),
            warn: x({}, Ze, {
              value: X
            }),
            error: x({}, Ze, {
              value: V
            }),
            group: x({}, Ze, {
              value: F
            }),
            groupCollapsed: x({}, Ze, {
              value: le
            }),
            groupEnd: x({}, Ze, {
              value: ae
            })
          });
        }
        D < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = m.ReactCurrentDispatcher, xe;
    function ze(Ze, kt, qt) {
      {
        if (xe === void 0)
          try {
            throw Error();
          } catch (Mr) {
            var sr = Mr.stack.trim().match(/\n( *(at )?)/);
            xe = sr && sr[1] || "";
          }
        return `
` + xe + Ze;
      }
    }
    var qe = !1, Je;
    {
      var Be = typeof WeakMap == "function" ? WeakMap : Map;
      Je = new Be();
    }
    function We(Ze, kt) {
      if (!Ze || qe)
        return "";
      {
        var qt = Je.get(Ze);
        if (qt !== void 0)
          return qt;
      }
      var sr;
      qe = !0;
      var Mr = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ht;
      ht = Oe.current, Oe.current = null, ve();
      try {
        if (kt) {
          var Pe = function() {
            throw Error();
          };
          if (Object.defineProperty(Pe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Pe, []);
            } catch (Fr) {
              sr = Fr;
            }
            Reflect.construct(Ze, [], Pe);
          } else {
            try {
              Pe.call();
            } catch (Fr) {
              sr = Fr;
            }
            Ze.call(Pe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Fr) {
            sr = Fr;
          }
          Ze();
        }
      } catch (Fr) {
        if (Fr && sr && typeof Fr.stack == "string") {
          for (var Fe = Fr.stack.split(`
`), Ye = sr.stack.split(`
`), Xe = Fe.length - 1, dt = Ye.length - 1; Xe >= 1 && dt >= 0 && Fe[Xe] !== Ye[dt]; )
            dt--;
          for (; Xe >= 1 && dt >= 0; Xe--, dt--)
            if (Fe[Xe] !== Ye[dt]) {
              if (Xe !== 1 || dt !== 1)
                do
                  if (Xe--, dt--, dt < 0 || Fe[Xe] !== Ye[dt]) {
                    var Nt = `
` + Fe[Xe].replace(" at new ", " at ");
                    return Ze.displayName && Nt.includes("<anonymous>") && (Nt = Nt.replace("<anonymous>", Ze.displayName)), typeof Ze == "function" && Je.set(Ze, Nt), Nt;
                  }
                while (Xe >= 1 && dt >= 0);
              break;
            }
        }
      } finally {
        qe = !1, Oe.current = ht, Ie(), Error.prepareStackTrace = Mr;
      }
      var er = Ze ? Ze.displayName || Ze.name : "", Sr = er ? ze(er) : "";
      return typeof Ze == "function" && Je.set(Ze, Sr), Sr;
    }
    function Ne(Ze, kt, qt) {
      return We(Ze, !1);
    }
    function je(Ze) {
      var kt = Ze.prototype;
      return !!(kt && kt.isReactComponent);
    }
    function et(Ze, kt, qt) {
      if (Ze == null)
        return "";
      if (typeof Ze == "function")
        return We(Ze, je(Ze));
      if (typeof Ze == "string")
        return ze(Ze);
      switch (Ze) {
        case c:
          return ze("Suspense");
        case l:
          return ze("SuspenseList");
      }
      if (typeof Ze == "object")
        switch (Ze.$$typeof) {
          case s:
            return Ne(Ze.render);
          case f:
            return et(Ze.type, kt, qt);
          case d: {
            var sr = Ze, Mr = sr._payload, ht = sr._init;
            try {
              return et(ht(Mr), kt, qt);
            } catch {
            }
          }
        }
      return "";
    }
    var St = Object.prototype.hasOwnProperty, Ot = {}, we = m.ReactDebugCurrentFrame;
    function De(Ze) {
      if (Ze) {
        var kt = Ze._owner, qt = et(Ze.type, Ze._source, kt ? kt.type : null);
        we.setExtraStackFrame(qt);
      } else
        we.setExtraStackFrame(null);
    }
    function Ee(Ze, kt, qt, sr, Mr) {
      {
        var ht = Function.call.bind(St);
        for (var Pe in Ze)
          if (ht(Ze, Pe)) {
            var Fe = void 0;
            try {
              if (typeof Ze[Pe] != "function") {
                var Ye = Error((sr || "React class") + ": " + qt + " type `" + Pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ze[Pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ye.name = "Invariant Violation", Ye;
              }
              Fe = Ze[Pe](kt, Pe, sr, qt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Xe) {
              Fe = Xe;
            }
            Fe && !(Fe instanceof Error) && (De(Mr), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", sr || "React class", qt, Pe, typeof Fe), De(null)), Fe instanceof Error && !(Fe.message in Ot) && (Ot[Fe.message] = !0, De(Mr), g("Failed %s type: %s", qt, Fe.message), De(null));
          }
      }
    }
    var te = Array.isArray;
    function ue(Ze) {
      return te(Ze);
    }
    function ye(Ze) {
      {
        var kt = typeof Symbol == "function" && Symbol.toStringTag, qt = kt && Ze[Symbol.toStringTag] || Ze.constructor.name || "Object";
        return qt;
      }
    }
    function Le(Ze) {
      try {
        return Me(Ze), !1;
      } catch {
        return !0;
      }
    }
    function Me(Ze) {
      return "" + Ze;
    }
    function Ae(Ze) {
      if (Le(Ze))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ye(Ze)), Me(Ze);
    }
    var ie = m.ReactCurrentOwner, K = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Z, Ce, be;
    be = {};
    function Ge(Ze) {
      if (St.call(Ze, "ref")) {
        var kt = Object.getOwnPropertyDescriptor(Ze, "ref").get;
        if (kt && kt.isReactWarning)
          return !1;
      }
      return Ze.ref !== void 0;
    }
    function st(Ze) {
      if (St.call(Ze, "key")) {
        var kt = Object.getOwnPropertyDescriptor(Ze, "key").get;
        if (kt && kt.isReactWarning)
          return !1;
      }
      return Ze.key !== void 0;
    }
    function wt(Ze, kt) {
      if (typeof Ze.ref == "string" && ie.current && kt && ie.current.stateNode !== kt) {
        var qt = B(ie.current.type);
        be[qt] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(ie.current.type), Ze.ref), be[qt] = !0);
      }
    }
    function Bt(Ze, kt) {
      {
        var qt = function() {
          Z || (Z = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", kt));
        };
        qt.isReactWarning = !0, Object.defineProperty(Ze, "key", {
          get: qt,
          configurable: !0
        });
      }
    }
    function jt(Ze, kt) {
      {
        var qt = function() {
          Ce || (Ce = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", kt));
        };
        qt.isReactWarning = !0, Object.defineProperty(Ze, "ref", {
          get: qt,
          configurable: !0
        });
      }
    }
    var Xt = function(Ze, kt, qt, sr, Mr, ht, Pe) {
      var Fe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Ze,
        key: kt,
        ref: qt,
        props: Pe,
        // Record the component responsible for creating this element.
        _owner: ht
      };
      return Fe._store = {}, Object.defineProperty(Fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: sr
      }), Object.defineProperty(Fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Mr
      }), Object.freeze && (Object.freeze(Fe.props), Object.freeze(Fe)), Fe;
    };
    function Qt(Ze, kt, qt, sr, Mr) {
      {
        var ht, Pe = {}, Fe = null, Ye = null;
        qt !== void 0 && (Ae(qt), Fe = "" + qt), st(kt) && (Ae(kt.key), Fe = "" + kt.key), Ge(kt) && (Ye = kt.ref, wt(kt, Mr));
        for (ht in kt)
          St.call(kt, ht) && !K.hasOwnProperty(ht) && (Pe[ht] = kt[ht]);
        if (Ze && Ze.defaultProps) {
          var Xe = Ze.defaultProps;
          for (ht in Xe)
            Pe[ht] === void 0 && (Pe[ht] = Xe[ht]);
        }
        if (Fe || Ye) {
          var dt = typeof Ze == "function" ? Ze.displayName || Ze.name || "Unknown" : Ze;
          Fe && Bt(Pe, dt), Ye && jt(Pe, dt);
        }
        return Xt(Ze, Fe, Ye, Mr, sr, ie.current, Pe);
      }
    }
    var Zr = m.ReactCurrentOwner, Jn = m.ReactDebugCurrentFrame;
    function Ur(Ze) {
      if (Ze) {
        var kt = Ze._owner, qt = et(Ze.type, Ze._source, kt ? kt.type : null);
        Jn.setExtraStackFrame(qt);
      } else
        Jn.setExtraStackFrame(null);
    }
    var fn;
    fn = !1;
    function gn(Ze) {
      return typeof Ze == "object" && Ze !== null && Ze.$$typeof === t;
    }
    function cr() {
      {
        if (Zr.current) {
          var Ze = B(Zr.current.type);
          if (Ze)
            return `

Check the render method of \`` + Ze + "`.";
        }
        return "";
      }
    }
    function Ri(Ze) {
      return "";
    }
    var ai = {};
    function vo(Ze) {
      {
        var kt = cr();
        if (!kt) {
          var qt = typeof Ze == "string" ? Ze : Ze.displayName || Ze.name;
          qt && (kt = `

Check the top-level render call using <` + qt + ">.");
        }
        return kt;
      }
    }
    function to(Ze, kt) {
      {
        if (!Ze._store || Ze._store.validated || Ze.key != null)
          return;
        Ze._store.validated = !0;
        var qt = vo(kt);
        if (ai[qt])
          return;
        ai[qt] = !0;
        var sr = "";
        Ze && Ze._owner && Ze._owner !== Zr.current && (sr = " It was passed a child from " + B(Ze._owner.type) + "."), Ur(Ze), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', qt, sr), Ur(null);
      }
    }
    function Ui(Ze, kt) {
      {
        if (typeof Ze != "object")
          return;
        if (ue(Ze))
          for (var qt = 0; qt < Ze.length; qt++) {
            var sr = Ze[qt];
            gn(sr) && to(sr, kt);
          }
        else if (gn(Ze))
          Ze._store && (Ze._store.validated = !0);
        else if (Ze) {
          var Mr = E(Ze);
          if (typeof Mr == "function" && Mr !== Ze.entries)
            for (var ht = Mr.call(Ze), Pe; !(Pe = ht.next()).done; )
              gn(Pe.value) && to(Pe.value, kt);
        }
      }
    }
    function Gu(Ze) {
      {
        var kt = Ze.type;
        if (kt == null || typeof kt == "string")
          return;
        var qt;
        if (typeof kt == "function")
          qt = kt.propTypes;
        else if (typeof kt == "object" && (kt.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        kt.$$typeof === f))
          qt = kt.propTypes;
        else
          return;
        if (qt) {
          var sr = B(kt);
          Ee(qt, Ze.props, "prop", sr, Ze);
        } else if (kt.PropTypes !== void 0 && !fn) {
          fn = !0;
          var Mr = B(kt);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Mr || "Unknown");
        }
        typeof kt.getDefaultProps == "function" && !kt.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rs(Ze) {
      {
        for (var kt = Object.keys(Ze.props), qt = 0; qt < kt.length; qt++) {
          var sr = kt[qt];
          if (sr !== "children" && sr !== "key") {
            Ur(Ze), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", sr), Ur(null);
            break;
          }
        }
        Ze.ref !== null && (Ur(Ze), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ur(null));
      }
    }
    function Wu(Ze, kt, qt, sr, Mr, ht) {
      {
        var Pe = z(Ze);
        if (!Pe) {
          var Fe = "";
          (Ze === void 0 || typeof Ze == "object" && Ze !== null && Object.keys(Ze).length === 0) && (Fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ye = Ri();
          Ye ? Fe += Ye : Fe += cr();
          var Xe;
          Ze === null ? Xe = "null" : ue(Ze) ? Xe = "array" : Ze !== void 0 && Ze.$$typeof === t ? (Xe = "<" + (B(Ze.type) || "Unknown") + " />", Fe = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof Ze, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, Fe);
        }
        var dt = Qt(Ze, kt, qt, Mr, ht);
        if (dt == null)
          return dt;
        if (Pe) {
          var Nt = kt.children;
          if (Nt !== void 0)
            if (sr)
              if (ue(Nt)) {
                for (var er = 0; er < Nt.length; er++)
                  Ui(Nt[er], Ze);
                Object.freeze && Object.freeze(Nt);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ui(Nt, Ze);
        }
        return Ze === n ? Rs(dt) : Gu(dt), dt;
      }
    }
    function Ku(Ze, kt, qt) {
      return Wu(Ze, kt, qt, !0);
    }
    function Ca(Ze, kt, qt) {
      return Wu(Ze, kt, qt, !1);
    }
    var Dn = Ca, Xu = Ku;
    m4.Fragment = n, m4.jsx = Dn, m4.jsxs = Xu;
  }()), m4;
}
process.env.NODE_ENV === "production" ? x8.exports = EPr() : x8.exports = mPr();
var gPr = x8.exports;
const TPr = (e, t) => {
  switch (t.type) {
    case "INIT":
      return {
        ...e,
        isLoading: !1,
        isAuthenticated: t.user != null,
        user: t.user,
        error: void 0
      };
    case "HANDLE_CALLBACK_COMPLETE":
    case "GET_ACCESS_TOKEN_COMPLETE":
      return {
        ...e,
        isLoading: !1,
        isAuthenticated: t.user != null,
        user: t.user,
        error: void 0
      };
    case "LOGOUT":
      return {
        ...e,
        isAuthenticated: !1,
        user: void 0
      };
    case "ERROR":
      return {
        ...e,
        isLoading: !1,
        error: t.error
      };
  }
}, yPr = {
  isLoading: !0,
  isAuthenticated: !1
}, $se = (e) => {
  if (e == null || Object.keys(e).length <= 0)
    return !0;
  const t = Object.keys(e);
  for (const r of t)
    if (e[r] != null && e[r] !== "")
      return !1;
  return !0;
}, _Pr = (e) => {
  const t = $se(e.config), r = $se(e.persistentOptions);
  return !t || !r;
}, APr = (e) => {
  const {
    children: t,
    configurationEndpoint: r,
    clientId: n,
    redirectUrl: i,
    logoutRedirectUrl: o,
    scopes: a,
    persistentStore: u,
    onRedirectCallback: s,
    checkRedirectUrlMatch: c
  } = e;
  if (En(D8) != null)
    throw new Error("TID Provider already defined");
  const l = {
    config: {
      configurationEndpoint: r ?? "",
      clientId: n ?? "",
      redirectUrl: i ?? "",
      logoutRedirectUrl: o ?? "",
      scopes: a ?? [""]
    },
    persistentOptions: {
      persistentStore: u ?? "in-memory"
    }
  }, [f] = cn(e.tidClient ?? new hPr(l)), [d, p] = Jse(TPr, yPr), v = Ut(!1), h = tt(
    () => c ? f.getRedirectUrl() : void 0,
    [c, f]
  );
  nr(() => {
    v.current || (e.tidClient != null && _Pr({
      config: {
        configurationEndpoint: r,
        clientId: n,
        redirectUrl: i,
        logoutRedirectUrl: o,
        scopes: a
      },
      persistentOptions: {
        persistentStore: u
      }
    }) && console.warn(
      "When TID client is pass as prop, any client configuration property sent directly to the TID Provider component will be ignored"
    ), v.current = !0, (async () => {
      try {
        let S;
        if (iPr(void 0, h)) {
          const { authState: A } = await f.handleCallback();
          S = await f.getUser(), s != null && s(A);
        } else
          await f.loadUserSession(), S = await f.getUser();
        p({ type: "INIT", user: S });
      } catch (S) {
        let A = S;
        typeof S == "string" && (A = new Error(S)), p({ type: "ERROR", error: A });
      }
    })());
  }, [f, s]);
  const E = mt(async () => {
    const S = await f.getAccessTokenSilently(), A = await f.getUser();
    return p({
      type: "GET_ACCESS_TOKEN_COMPLETE",
      user: A
    }), S;
  }, [f]), m = mt(
    async (S) => {
      await f.loginWithRedirect(S);
    },
    [f]
  ), g = mt(
    async (S) => {
      await f.logout(S), (S == null ? void 0 : S.disabledAutoRedirect) != null && S.disabledAutoRedirect && p({
        type: "LOGOUT"
      });
    },
    [f]
  ), y = mt(
    async (S) => {
      const { authState: A } = await f.handleCallback(S), O = await f.getUser();
      return p({
        type: "HANDLE_CALLBACK_COMPLETE",
        user: O
      }), {
        authState: A
      };
    },
    [f]
  ), _ = tt(
    () => ({
      ...d,
      getAccessTokenSilently: E,
      loginWithRedirect: m,
      handleCallback: y,
      logout: g
    }),
    [d, E, m, y, g]
  );
  return /* @__PURE__ */ gPr.jsx(D8.Provider, { value: _, children: t });
}, SPr = vPr, bPr = APr, CPr = (e) => (t) => (r) => {
  const n = /* @__PURE__ */ Jt(t, { ...r });
  return e ? /* @__PURE__ */ Jt(bPr, { ...e, persistentStore: "localStorage", children: n }) : n;
}, IPr = () => (e) => (...t) => {
  var n, i;
  const [r] = t;
  if (QRr(r.activity))
    return !1;
  if (V2e(r.activity)) {
    const o = {
      ...r,
      activity: { ...r.activity, text: jRr }
    };
    return e(o);
  }
  if (I2(r.activity)) {
    const o = (i = (n = r.activity) == null ? void 0 : n.attachments) == null ? void 0 : i[0].content.text, a = {
      ...r,
      activity: { ...r.activity, attachments: void 0, text: o }
    };
    return e(a);
  }
  return r.activity.type === "endOfConversation" ? !1 : e(r);
}, OPr = ({
  children: e,
  slot: t
}) => /* @__PURE__ */ va("div", { className: wo("activity-status-decorator"), children: [
  t,
  e
] }), RPr = ({ className: e }) => /* @__PURE__ */ Jt(
  "svg",
  {
    className: ba(wo("thumbs-up-outline-icon"), e),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Jt(
      "path",
      {
        d: "M14.66 8.15333C14.66 6.92 13.66 5.92 12.4267 5.92H9.96666C10.1067 4.66667 10.0733 2.90667 8.20666 2.15333C7.95333 2.05333 7.7 2 7.45333 2C6.94666 2 6.49333 2.21333 6.16666 2.6C5.55333 3.33333 5.68 4.34 5.73333 4.6C5.79333 4.97333 5.52666 5.30667 4.96 5.94C4.85333 6.06 4.74666 6.17333 4.64666 6.29333C4.35333 6.04 3.97333 5.89333 3.56 5.89333H3.00666C2.08666 5.89333 1.34 6.64 1.34 7.56V12.5667C1.34 13.4867 2.08666 14.2333 3.00666 14.2333H3.56C4.06666 14.2333 4.52666 14.0067 4.83333 13.6467C5.23333 14.02 5.76666 14.2467 6.35333 14.2467H11.06C12.3867 14.2467 12.9267 13.5267 13.3867 12.3067C13.7867 11.3467 14.4467 9.76667 14.5133 9.62C14.58 9.47333 14.7 9.21333 14.66 8.15333ZM4.11333 12.5733C4.11333 12.88 3.86 13.1267 3.56 13.1267H3.00666C2.7 13.1267 2.45333 12.88 2.45333 12.5733V7.56667C2.45333 7.26 2.7 7.01333 3.00666 7.01333H3.56C3.86666 7.01333 4.11333 7.26667 4.11333 7.56667V12.5733ZM13.4933 9.16667C13.4133 9.34 12.3533 11.8867 12.3533 11.8867C11.9333 12.9867 11.6733 13.14 11.0533 13.14H6.34666C5.72666 13.14 5.22666 12.64 5.22666 12.02V7.66667C5.22666 7.66667 5.22 7.36667 5.29333 7.26C5.95333 6.41333 7.02 5.64667 6.83333 4.44C6.71333 3.78 6.92666 2.85333 7.8 3.19333C9.32666 3.81333 8.89333 5.5 8.72666 6.76C8.74666 6.90667 8.94 6.98 9.20666 7.01333C9.32666 7.02667 9.48 7.03333 9.62 7.03333H12.42C13.04 7.03333 13.54 7.53333 13.54 8.15333C13.54 8.15333 13.5733 8.99333 13.4933 9.16667Z",
        fill: "#252A2E"
      }
    )
  }
), wPr = ({ className: e }) => /* @__PURE__ */ Jt(
  "svg",
  {
    className: ba(
      wo("thumbs-down-outline-icon"),
      e
    ),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Jt(
      "path",
      {
        d: "M14.66 8.09999C14.66 9.33332 13.66 10.3333 12.4267 10.3333H9.96666C10.1067 11.5867 10.0733 13.3467 8.20666 14.1C7.95333 14.2 7.7 14.2533 7.45333 14.2533C6.94666 14.2533 6.49333 14.04 6.16666 13.6533C5.55333 12.92 5.68 11.9133 5.73333 11.6533C5.79333 11.28 5.52666 10.9467 4.96 10.3133C4.85333 10.1933 4.74666 10.08 4.64666 9.95999C4.35333 10.2133 3.97333 10.36 3.56 10.36H3.00666C2.08666 10.36 1.34 9.61332 1.34 8.69332V3.68665C1.34 2.76665 2.08666 2.01999 3.00666 2.01999H3.56C4.06666 2.01999 4.52666 2.24665 4.83333 2.60665C5.23333 2.23332 5.76666 2.00665 6.35333 2.00665H11.06C12.3867 2.00665 12.9267 2.72665 13.3867 3.94665C13.7867 4.90665 14.4467 6.48665 14.5133 6.63332C14.58 6.77999 14.7 7.03999 14.66 8.09999ZM4.11333 3.67999C4.11333 3.37332 3.86 3.12665 3.56 3.12665H3.00666C2.7 3.12665 2.45333 3.37332 2.45333 3.67999V8.68665C2.45333 8.99332 2.7 9.23999 3.00666 9.23999H3.56C3.86666 9.23999 4.11333 8.98665 4.11333 8.68665V3.67999ZM13.4933 7.08665C13.4133 6.91332 12.3533 4.36665 12.3533 4.36665C11.9333 3.26665 11.6733 3.11332 11.0533 3.11332H6.34666C5.72666 3.11332 5.22666 3.61332 5.22666 4.23332V8.58665C5.22666 8.58665 5.22 8.88665 5.29333 8.99332C5.95333 9.83999 7.02 10.6067 6.83333 11.8133C6.71333 12.4733 6.92666 13.4 7.8 13.06C9.32666 12.44 8.89333 10.7533 8.72666 9.49332C8.74666 9.34665 8.94 9.27332 9.20666 9.23999C9.32666 9.22665 9.48 9.21999 9.62 9.21999H12.42C13.04 9.21999 13.54 8.71999 13.54 8.09999C13.54 8.09999 13.5733 7.25999 13.4933 7.08665Z",
        fill: "#252A2E"
      }
    )
  }
), PPr = ({ className: e }) => /* @__PURE__ */ va(
  "svg",
  {
    className: ba(wo("thumbs-up-filled-icon"), e),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M2.66666 6.00001H1.99999C1.63333 6.00001 1.33333 6.30001 1.33333 6.66668V12.6667C1.33333 13.0333 1.63333 13.3333 1.99999 13.3333H2.66666C3.03333 13.3333 3.33333 13.0333 3.33333 12.6667V6.66668C3.33333 6.30001 3.03333 6.00001 2.66666 6.00001Z",
          fill: "#0063A3"
        }
      ),
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M13.2933 6.03335C14.0333 6.03335 14.64 6.62668 14.64 7.36668C14.64 7.36668 14.6733 8.36668 14.58 8.58002C14.4867 8.79335 13.2133 11.84 13.2133 11.84C12.7133 13.1533 12.4 13.34 11.66 13.34H6.02C5.28 13.34 4.67333 12.74 4.67333 12V6.78668C4.67333 6.78668 4.66666 6.43335 4.75333 6.30002C5.54666 5.28668 6.82666 4.36668 6.6 2.92002C6.45333 2.12668 6.71333 1.01335 7.75333 1.42668C9.58667 2.17335 9.06667 4.19335 8.86666 5.70668C8.9 5.88668 9.12666 5.97335 9.44666 6.01335L9.6901 6.03335H13.2933Z",
          fill: "#0063A3"
        }
      )
    ]
  }
), DPr = ({ className: e }) => /* @__PURE__ */ va(
  "svg",
  {
    className: ba(wo("thumbs-down-filled-icon"), e),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M2.66666 10.0133H1.99999C1.63333 10.0133 1.33333 9.71333 1.33333 9.34667V3.34667C1.33333 2.98 1.63333 2.68 1.99999 2.68H2.66666C3.03333 2.68 3.33333 2.98 3.33333 3.34667V9.34667C3.33333 9.71333 3.03333 10.0133 2.66666 10.0133Z",
          fill: "#252A2E"
        }
      ),
      /* @__PURE__ */ Jt(
        "path",
        {
          d: "M13.2933 9.98001C14.0333 9.98001 14.64 9.38667 14.64 8.64667C14.64 8.64667 14.6733 7.64667 14.58 7.43334C14.4867 7.22001 13.2133 4.17334 13.2133 4.17334C12.7133 2.86001 12.4 2.67334 11.66 2.67334H6.02C5.28 2.67334 4.67333 3.27334 4.67333 4.01334V9.22667C4.67333 9.22667 4.66666 9.58001 4.75333 9.71334C5.54666 10.7267 6.82666 11.6467 6.6 13.0933C6.45333 13.8867 6.71333 15 7.75333 14.5867C9.58667 13.84 9.06667 11.82 8.86666 10.3067C8.9 10.1267 9.12666 10.04 9.44666 10L9.94 9.98001H13.2933Z",
          fill: "#252A2E"
        }
      )
    ]
  }
), g4 = {
  THUMBS_UP: "5",
  THUMBS_DOWN: "1"
}, xPr = () => {
  const [e, t] = cn(null), r = Rf.useSendPostBack(), n = (s) => {
    r({ rate: s }), t(s);
  }, i = () => n(g4.THUMBS_UP), o = () => n(g4.THUMBS_DOWN), a = wo("rating-buttons"), u = e !== null;
  return /* @__PURE__ */ va("div", { className: a, children: [
    /* @__PURE__ */ Jt(wb, { onClick: i, disabled: u, children: e === g4.THUMBS_UP ? /* @__PURE__ */ Jt(PPr, {}) : /* @__PURE__ */ Jt(RPr, {}) }),
    /* @__PURE__ */ Jt("div", { className: `${a}__divider` }),
    /* @__PURE__ */ Jt(wb, { onClick: o, disabled: u, children: e === g4.THUMBS_DOWN ? /* @__PURE__ */ Jt(DPr, {}) : /* @__PURE__ */ Jt(wPr, {}) })
  ] });
}, sIe = ({
  className: e,
  disabled: t,
  label: r,
  variant: n = "primary",
  ...i
}) => {
  const o = wo("button");
  return /* @__PURE__ */ Jt(
    "button",
    {
      className: ba(
        o,
        `${o}--${n}`,
        e
      ),
      disabled: t,
      ...i,
      children: r
    }
  );
}, NPr = (e) => e.title || e.value || e.label || e.value, LPr = ({ actions: e, activityId: t }) => {
  const [r] = Rf.useActivities(), n = Rf.usePerformCardAction(), i = (a) => () => {
    n(a);
  }, o = ZRr(r, t);
  return /* @__PURE__ */ Jt("div", { className: wo("suggested-actions-container"), children: e.map((a, u) => /* @__PURE__ */ Jt(
    sIe,
    {
      label: NPr(a),
      onClick: i(a),
      disabled: o
    },
    u
  )) });
}, BPr = () => {
  const { loginWithRedirect: e } = SPr();
  return /* @__PURE__ */ Jt(sIe, { label: "Login", onClick: () => e() });
}, kPr = (e) => new Date(e).toLocaleTimeString("en-US", {
  hour: "numeric",
  minute: "2-digit",
  hour12: !0
}), MPr = ({ timestamp: e }) => /* @__PURE__ */ Jt("span", { className: wo("timestamp"), children: kPr(e) }), FPr = (e) => {
  switch (!0) {
    case I2(e):
      return /* @__PURE__ */ Jt(BPr, {});
    case (KRr(e) || V2e(e)):
      return /* @__PURE__ */ Jt(xPr, {});
    case XRr(e):
      return /* @__PURE__ */ Jt(
        LPr,
        {
          activityId: e.id,
          actions: e.suggestedActions.actions
        }
      );
    default:
      return null;
  }
}, HPr = () => (e) => (t) => {
  const { activity: r } = t, n = FPr(r);
  return n ? /* @__PURE__ */ Jt(OPr, { slot: n, children: e(t) }) : e(t);
}, $Pr = () => (e) => (t) => {
  const {
    sendState: r,
    hideTimestamp: n,
    activity: { timestamp: i }
  } = t;
  return r === "sent" && !n && i ? /* @__PURE__ */ Jt(MPr, { timestamp: i }) : e(t);
}, UPr = [
  HPr,
  $Pr
], VPr = (e) => {
  const t = wo("typing-indicator"), r = `${t}__dot`;
  return e.visible ? /* @__PURE__ */ va("div", { className: t, children: [
    /* @__PURE__ */ Jt("div", { className: r }),
    /* @__PURE__ */ Jt("div", { className: r }),
    /* @__PURE__ */ Jt("div", { className: r })
  ] }) : null;
}, jPr = () => () => VPr, zPr = ({ dispatch: e }) => (t) => (r) => {
  if (r.type === "DIRECT_LINE/CONNECT_FULFILLED" && e({
    meta: {
      method: "keyboard"
    },
    payload: {
      activity: {
        channelData: {
          postBack: !0
        },
        // Web Chat will show the Start Conversation System Topic message
        name: "startConversation",
        value: {
          chanType: "React Web Application"
        },
        type: "event"
      }
    },
    type: "DIRECT_LINE/POST_ACTIVITY"
  }), r.type === "DIRECT_LINE/INCOMING_ACTIVITY" && I2(r.payload.activity)) {
    const n = iwr();
    if (n) {
      const i = owr(r.payload.activity);
      fetch(i, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ token: n })
      }).then((o) => {
        o.ok || (rwr(), e(r));
      });
      return;
    }
  }
  return t(r);
}, bDr = ({
  botTokenEndpoint: e,
  sidebarClassName: t,
  chatClassName: r,
  buttonClassName: n,
  buttonIcon: i,
  chatNameSlot: o,
  styleOptions: a,
  tidClientConfig: u,
  enableSSO: s
}) => {
  const c = Ut(), l = Ut(0), f = Ut(), [d, p] = cn(null), [v, h] = cn(!1), [E, m] = cn(!1), g = () => h((O) => !O), y = mt(
    async (O = !1) => {
      m(!0);
      let P;
      f.current && !O ? P = f.current : (P = await GRr(e), f.current = P);
      const U = WRr(P), z = hfe({}, zPr);
      p({ directLine: U, store: z }), m(!1);
    },
    [e]
  ), _ = async () => {
    d || await y(), g();
  }, S = () => y(!0);
  nr(() => {
    if (!d) return;
    const O = d.directLine.connectionStatus$.subscribe(
      (P) => {
        const U = l.current + 1, z = HRr * U, k = (H = !1) => setTimeout(async () => {
          l.current = U, O.unsubscribe(), await y(H);
        }, z);
        switch (P) {
          case 1:
            l.current < vse && (c.current = k());
            break;
          case 2:
            clearTimeout(c.current), l.current = 0;
            break;
          case 3:
          case 4:
            l.current < vse && (c.current = k(!0));
        }
      }
    );
    return () => O.unsubscribe();
  }, [d, y]);
  const A = tt(() => u || s ? CPr(u)(Ese) : Ese, [u, s]);
  return /* @__PURE__ */ va(wIe, { children: [
    /* @__PURE__ */ Jt(Ewr, { open: v, className: t, children: d && /* @__PURE__ */ Jt(
      A,
      {
        className: r,
        styleOptions: a,
        chatNameSlot: o,
        store: d.store,
        directLine: d.directLine,
        onRefresh: S,
        onChatClose: g,
        activityMiddleware: IPr,
        activityStatusMiddleware: UPr,
        typingIndicatorMiddleware: jPr
      }
    ) }),
    !v && /* @__PURE__ */ Jt(
      uwr,
      {
        className: n,
        buttonIcon: i,
        loading: E,
        onClick: _
      }
    )
  ] });
};
export {
  bDr as default
};
